
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref718"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref718"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7B2bR", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $587db01302e19550$export$ffb0004e005737fa, (v) => $587db01302e19550$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $587db01302e19550$export$34b9dba7ce09269b, (v) => $587db01302e19550$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $587db01302e19550$export$25062201e9e25d76, (v) => $587db01302e19550$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $587db01302e19550$export$ffb0004e005737fa;
var $587db01302e19550$export$34b9dba7ce09269b;
var $587db01302e19550$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("acw62"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $587db01302e19550$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $587db01302e19550$export$34b9dba7ce09269b = jsx;
    $587db01302e19550$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jWQW9"));

});
parcelRegister("jWQW9", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.2.0";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("3y30c", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2956e04298bc31b1$export$ae55be85d98224ed, (v) => $2956e04298bc31b1$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $2956e04298bc31b1$export$d39a5bbd09211389, (v) => $2956e04298bc31b1$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $2956e04298bc31b1$export$882461b6382ed46c, (v) => $2956e04298bc31b1$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $2956e04298bc31b1$export$466bfc07425424d5, (v) => $2956e04298bc31b1$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $2956e04298bc31b1$export$cd75ccfd720a3cd4, (v) => $2956e04298bc31b1$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $2956e04298bc31b1$export$fa8d919ba61d84db, (v) => $2956e04298bc31b1$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $2956e04298bc31b1$export$757ceba2d55c277e, (v) => $2956e04298bc31b1$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $2956e04298bc31b1$export$b3890eb0ae9dca99, (v) => $2956e04298bc31b1$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $2956e04298bc31b1$export$502457920280e6be, (v) => $2956e04298bc31b1$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2956e04298bc31b1$export$c78a37762a8d58e1, (v) => $2956e04298bc31b1$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $2956e04298bc31b1$export$dc54d992c10e8a18, (v) => $2956e04298bc31b1$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $2956e04298bc31b1$export$83d89fbfd8236492, (v) => $2956e04298bc31b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2956e04298bc31b1$export$ae55be85d98224ed;
var $2956e04298bc31b1$export$d39a5bbd09211389;
var $2956e04298bc31b1$export$882461b6382ed46c;
var $2956e04298bc31b1$export$466bfc07425424d5;
var $2956e04298bc31b1$export$cd75ccfd720a3cd4;
var $2956e04298bc31b1$export$fa8d919ba61d84db;
var $2956e04298bc31b1$export$757ceba2d55c277e;
var $2956e04298bc31b1$export$b3890eb0ae9dca99;
var $2956e04298bc31b1$export$502457920280e6be;
var $2956e04298bc31b1$export$c78a37762a8d58e1;
var $2956e04298bc31b1$export$dc54d992c10e8a18;
var $2956e04298bc31b1$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("acw62"));
    var Scheduler = (parcelRequire("fO90s"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = false; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {}; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = resolvedInst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.2.0";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $2956e04298bc31b1$export$ae55be85d98224ed = Internals;
    $2956e04298bc31b1$export$d39a5bbd09211389 = createPortal$1;
    $2956e04298bc31b1$export$882461b6382ed46c = createRoot$1;
    $2956e04298bc31b1$export$466bfc07425424d5 = findDOMNode;
    $2956e04298bc31b1$export$cd75ccfd720a3cd4 = flushSync$1;
    $2956e04298bc31b1$export$fa8d919ba61d84db = hydrate;
    $2956e04298bc31b1$export$757ceba2d55c277e = hydrateRoot$1;
    $2956e04298bc31b1$export$b3890eb0ae9dca99 = render;
    $2956e04298bc31b1$export$502457920280e6be = unmountComponentAtNode;
    $2956e04298bc31b1$export$c78a37762a8d58e1 = batchedUpdates$1;
    $2956e04298bc31b1$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $2956e04298bc31b1$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7jGsX"));

});
parcelRegister("7jGsX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $553b3f9a1c62156e$export$c4744153514ff05d, (v) => $553b3f9a1c62156e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7, (v) => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $553b3f9a1c62156e$export$e26fe2ed2fa76875, (v) => $553b3f9a1c62156e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $553b3f9a1c62156e$export$502329bbf4b505b1, (v) => $553b3f9a1c62156e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $553b3f9a1c62156e$export$6e3807111c4874c4, (v) => $553b3f9a1c62156e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $553b3f9a1c62156e$export$c27134553091fb3a, (v) => $553b3f9a1c62156e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $553b3f9a1c62156e$export$33ee1acdc04fd2a2, (v) => $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $553b3f9a1c62156e$export$b00a404bbd5edef2, (v) => $553b3f9a1c62156e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $553b3f9a1c62156e$export$8352ce38b91d0c62, (v) => $553b3f9a1c62156e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $553b3f9a1c62156e$export$d66a1c1c77bd778b, (v) => $553b3f9a1c62156e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $553b3f9a1c62156e$export$d3dfb8e4810cb555, (v) => $553b3f9a1c62156e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $553b3f9a1c62156e$export$839f9183b0465a69, (v) => $553b3f9a1c62156e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $553b3f9a1c62156e$export$72fdf0e06517287b, (v) => $553b3f9a1c62156e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $553b3f9a1c62156e$export$4b844e58a3e414b4, (v) => $553b3f9a1c62156e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $553b3f9a1c62156e$export$816d2913ae6b83b1, (v) => $553b3f9a1c62156e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $553b3f9a1c62156e$export$61bcfe829111a1d0, (v) => $553b3f9a1c62156e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $553b3f9a1c62156e$export$7ee8c9beb337bc3f, (v) => $553b3f9a1c62156e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $553b3f9a1c62156e$export$b5836b71941fa3ed, (v) => $553b3f9a1c62156e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $553b3f9a1c62156e$export$cf845f2c119da08a, (v) => $553b3f9a1c62156e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $553b3f9a1c62156e$export$c4744153514ff05d;
var $553b3f9a1c62156e$export$3e506c1ccc9cc1a7;
var $553b3f9a1c62156e$export$e26fe2ed2fa76875;
var $553b3f9a1c62156e$export$502329bbf4b505b1;
var $553b3f9a1c62156e$export$6e3807111c4874c4;
var $553b3f9a1c62156e$export$c27134553091fb3a;
var $553b3f9a1c62156e$export$33ee1acdc04fd2a2;
var $553b3f9a1c62156e$export$b00a404bbd5edef2;
var $553b3f9a1c62156e$export$8352ce38b91d0c62;
var $553b3f9a1c62156e$export$d66a1c1c77bd778b;
var $553b3f9a1c62156e$export$d3dfb8e4810cb555;
var $553b3f9a1c62156e$export$839f9183b0465a69;
var $553b3f9a1c62156e$export$72fdf0e06517287b;
var $553b3f9a1c62156e$export$4b844e58a3e414b4;
var $553b3f9a1c62156e$export$816d2913ae6b83b1;
var $553b3f9a1c62156e$export$61bcfe829111a1d0;
var $553b3f9a1c62156e$export$7ee8c9beb337bc3f;
var $553b3f9a1c62156e$export$b5836b71941fa3ed;
var $553b3f9a1c62156e$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $553b3f9a1c62156e$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($553b3f9a1c62156e$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = IdlePriority;
    $553b3f9a1c62156e$export$e26fe2ed2fa76875 = ImmediatePriority;
    $553b3f9a1c62156e$export$502329bbf4b505b1 = LowPriority;
    $553b3f9a1c62156e$export$6e3807111c4874c4 = NormalPriority;
    $553b3f9a1c62156e$export$c27134553091fb3a = unstable_Profiling;
    $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $553b3f9a1c62156e$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $553b3f9a1c62156e$export$8352ce38b91d0c62 = unstable_continueExecution;
    $553b3f9a1c62156e$export$d66a1c1c77bd778b = forceFrameRate;
    $553b3f9a1c62156e$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $553b3f9a1c62156e$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $553b3f9a1c62156e$export$72fdf0e06517287b = unstable_next;
    $553b3f9a1c62156e$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $553b3f9a1c62156e$export$816d2913ae6b83b1 = unstable_requestPaint;
    $553b3f9a1c62156e$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $553b3f9a1c62156e$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $553b3f9a1c62156e$export$b5836b71941fa3ed = shouldYieldToHost;
    $553b3f9a1c62156e$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("4kvQX", function(module, exports) {
"use strict";

});

parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("1R2J7", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, "digest");
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $loYLU();
    if (alg === "rmd160" || alg === "ripemd160") return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("loYLU", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $imbnh = parcelRequire("imbnh");
var $abf00c68ae11d39d$require$Transform = $imbnh.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(data)) data = $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRegister("imbnh", function(module, exports) {

exports = module.exports = (parcelRequire("dKWUQ"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("c5jlB"));

exports.Duplex = (parcelRequire("3ov6Z"));

exports.Transform = (parcelRequire("crXmw"));

exports.PassThrough = (parcelRequire("di5wW"));

exports.finished = (parcelRequire("izVph"));

exports.pipeline = (parcelRequire("4HJZ1"));

});
parcelRegister("dKWUQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $a03d45b164266ddc$var$Readable;
/*<replacement>*/ var $a03d45b164266ddc$var$Duplex;
/*</replacement>*/ $a03d45b164266ddc$var$Readable.ReadableState = $a03d45b164266ddc$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $a03d45b164266ddc$require$EE = $7etJZ.EventEmitter;
var $a03d45b164266ddc$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $c6U6o = parcelRequire("c6U6o");

var $6ZWSX = parcelRequire("6ZWSX");
var $a03d45b164266ddc$require$Buffer = $6ZWSX.Buffer;
var $a03d45b164266ddc$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $a03d45b164266ddc$var$_uint8ArrayToBuffer(chunk) {
    return $a03d45b164266ddc$require$Buffer.from(chunk);
}
function $a03d45b164266ddc$var$_isUint8Array(obj) {
    return $a03d45b164266ddc$require$Buffer.isBuffer(obj) || obj instanceof $a03d45b164266ddc$var$OurUint8Array;
}

var $4kvQX = parcelRequire("4kvQX");
var $a03d45b164266ddc$var$debug;
if ($4kvQX && $4kvQX.debuglog) $a03d45b164266ddc$var$debug = $4kvQX.debuglog("stream");
else $a03d45b164266ddc$var$debug = function debug() {};

var $67IS3 = parcelRequire("67IS3");

var $c0Uf7 = parcelRequire("c0Uf7");

var $2wssQ = parcelRequire("2wssQ");
var $a03d45b164266ddc$var$getHighWaterMark = $2wssQ.getHighWaterMark;

var $gid0T = parcelRequire("gid0T");
var $a03d45b164266ddc$require$_require$codes = $gid0T.codes;
var $a03d45b164266ddc$var$ERR_INVALID_ARG_TYPE = $a03d45b164266ddc$require$_require$codes.ERR_INVALID_ARG_TYPE, $a03d45b164266ddc$var$ERR_STREAM_PUSH_AFTER_EOF = $a03d45b164266ddc$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $a03d45b164266ddc$var$ERR_METHOD_NOT_IMPLEMENTED = $a03d45b164266ddc$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $a03d45b164266ddc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $a03d45b164266ddc$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $a03d45b164266ddc$var$StringDecoder;
var $a03d45b164266ddc$var$createReadableStreamAsyncIterator;
var $a03d45b164266ddc$var$from;

(parcelRequire("dlqwk"))($a03d45b164266ddc$var$Readable, $c6U6o);
var $a03d45b164266ddc$var$errorOrDestroy = $c0Uf7.errorOrDestroy;
var $a03d45b164266ddc$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $a03d45b164266ddc$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $a03d45b164266ddc$var$ReadableState(options, stream, isDuplex) {
    $a03d45b164266ddc$var$Duplex = $a03d45b164266ddc$var$Duplex || (parcelRequire("3ov6Z"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $a03d45b164266ddc$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $a03d45b164266ddc$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $67IS3();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$a03d45b164266ddc$var$StringDecoder) $a03d45b164266ddc$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $a03d45b164266ddc$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $a03d45b164266ddc$var$Readable(options) {
    $a03d45b164266ddc$var$Duplex = $a03d45b164266ddc$var$Duplex || (parcelRequire("3ov6Z"));
    if (!(this instanceof $a03d45b164266ddc$var$Readable)) return new $a03d45b164266ddc$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $a03d45b164266ddc$var$Duplex;
    this._readableState = new $a03d45b164266ddc$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $c6U6o.call(this);
}
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$a03d45b164266ddc$var$Readable.prototype.destroy = $c0Uf7.destroy;
$a03d45b164266ddc$var$Readable.prototype._undestroy = $c0Uf7.undestroy;
$a03d45b164266ddc$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$a03d45b164266ddc$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $a03d45b164266ddc$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $a03d45b164266ddc$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$a03d45b164266ddc$var$Readable.prototype.unshift = function(chunk) {
    return $a03d45b164266ddc$var$readableAddChunk(this, chunk, null, true, false);
};
function $a03d45b164266ddc$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $a03d45b164266ddc$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $a03d45b164266ddc$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $a03d45b164266ddc$var$chunkInvalid(state, chunk);
        if (er) $a03d45b164266ddc$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $a03d45b164266ddc$require$Buffer.prototype) chunk = $a03d45b164266ddc$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $a03d45b164266ddc$var$errorOrDestroy(stream, new $a03d45b164266ddc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $a03d45b164266ddc$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $a03d45b164266ddc$var$errorOrDestroy(stream, new $a03d45b164266ddc$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $a03d45b164266ddc$var$addChunk(stream, state, chunk, false);
                    else $a03d45b164266ddc$var$maybeReadMore(stream, state);
                } else $a03d45b164266ddc$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $a03d45b164266ddc$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $a03d45b164266ddc$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $a03d45b164266ddc$var$emitReadable(stream);
    }
    $a03d45b164266ddc$var$maybeReadMore(stream, state);
}
function $a03d45b164266ddc$var$chunkInvalid(state, chunk) {
    var er;
    if (!$a03d45b164266ddc$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $a03d45b164266ddc$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$a03d45b164266ddc$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$a03d45b164266ddc$var$Readable.prototype.setEncoding = function(enc) {
    if (!$a03d45b164266ddc$var$StringDecoder) $a03d45b164266ddc$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $a03d45b164266ddc$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $a03d45b164266ddc$var$MAX_HWM = 0x40000000;
function $a03d45b164266ddc$var$computeNewHighWaterMark(n) {
    if (n >= $a03d45b164266ddc$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $a03d45b164266ddc$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a03d45b164266ddc$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $a03d45b164266ddc$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$a03d45b164266ddc$var$Readable.prototype.read = function(n) {
    $a03d45b164266ddc$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $a03d45b164266ddc$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $a03d45b164266ddc$var$endReadable(this);
        else $a03d45b164266ddc$var$emitReadable(this);
        return null;
    }
    n = $a03d45b164266ddc$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $a03d45b164266ddc$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $a03d45b164266ddc$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $a03d45b164266ddc$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $a03d45b164266ddc$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $a03d45b164266ddc$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $a03d45b164266ddc$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $a03d45b164266ddc$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $a03d45b164266ddc$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $a03d45b164266ddc$var$onEofChunk(stream, state) {
    $a03d45b164266ddc$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $a03d45b164266ddc$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $a03d45b164266ddc$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $a03d45b164266ddc$var$emitReadable(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $a03d45b164266ddc$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$emitReadable_, stream);
    }
}
function $a03d45b164266ddc$var$emitReadable_(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $a03d45b164266ddc$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $a03d45b164266ddc$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$maybeReadMore_, stream, state);
    }
}
function $a03d45b164266ddc$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $a03d45b164266ddc$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$a03d45b164266ddc$var$Readable.prototype._read = function(n) {
    $a03d45b164266ddc$var$errorOrDestroy(this, new $a03d45b164266ddc$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$a03d45b164266ddc$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $a03d45b164266ddc$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $a03d45b164266ddc$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $a03d45b164266ddc$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $a03d45b164266ddc$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $a03d45b164266ddc$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $a03d45b164266ddc$var$debug("ondata");
        var ret = dest.write(chunk);
        $a03d45b164266ddc$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $a03d45b164266ddc$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $a03d45b164266ddc$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $a03d45b164266ddc$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($a03d45b164266ddc$var$EElistenerCount(dest, "error") === 0) $a03d45b164266ddc$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $a03d45b164266ddc$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $a03d45b164266ddc$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $a03d45b164266ddc$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $a03d45b164266ddc$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $a03d45b164266ddc$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $a03d45b164266ddc$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $a03d45b164266ddc$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $a03d45b164266ddc$var$flow(src);
        }
    };
}
$a03d45b164266ddc$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $a03d45b164266ddc$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$a03d45b164266ddc$var$Readable.prototype.on = function(ev, fn) {
    var res = $c6U6o.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $a03d45b164266ddc$var$debug("on readable", state.length, state.reading);
            if (state.length) $a03d45b164266ddc$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($a03d45b164266ddc$var$nReadingNextTick, this);
        }
    }
    return res;
};
$a03d45b164266ddc$var$Readable.prototype.addListener = $a03d45b164266ddc$var$Readable.prototype.on;
$a03d45b164266ddc$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $c6U6o.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($a03d45b164266ddc$var$updateReadableListening, this);
    return res;
};
$a03d45b164266ddc$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $c6U6o.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($a03d45b164266ddc$var$updateReadableListening, this);
    return res;
};
function $a03d45b164266ddc$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $a03d45b164266ddc$var$nReadingNextTick(self1) {
    $a03d45b164266ddc$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$a03d45b164266ddc$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $a03d45b164266ddc$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $a03d45b164266ddc$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $a03d45b164266ddc$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$resume_, stream, state);
    }
}
function $a03d45b164266ddc$var$resume_(stream, state) {
    $a03d45b164266ddc$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $a03d45b164266ddc$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$a03d45b164266ddc$var$Readable.prototype.pause = function() {
    $a03d45b164266ddc$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $a03d45b164266ddc$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $a03d45b164266ddc$var$flow(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$a03d45b164266ddc$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $a03d45b164266ddc$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $a03d45b164266ddc$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $a03d45b164266ddc$var$kProxyEvents.length; n++)stream.on($a03d45b164266ddc$var$kProxyEvents[n], this.emit.bind(this, $a03d45b164266ddc$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $a03d45b164266ddc$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $a03d45b164266ddc$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($a03d45b164266ddc$var$createReadableStreamAsyncIterator === undefined) $a03d45b164266ddc$var$createReadableStreamAsyncIterator = (parcelRequire("8NiiC"));
    return $a03d45b164266ddc$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$a03d45b164266ddc$var$Readable._fromList = $a03d45b164266ddc$var$fromList;
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a03d45b164266ddc$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $a03d45b164266ddc$var$endReadable(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$endReadableNT, state, stream);
    }
}
function $a03d45b164266ddc$var$endReadableNT(state, stream) {
    $a03d45b164266ddc$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $a03d45b164266ddc$var$Readable.from = function(iterable, opts) {
    if ($a03d45b164266ddc$var$from === undefined) $a03d45b164266ddc$var$from = (parcelRequire("2O9bI"));
    return $a03d45b164266ddc$var$from($a03d45b164266ddc$var$Readable, iterable, opts);
};
function $a03d45b164266ddc$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("c6U6o", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("67IS3", function(module, exports) {
"use strict";
function $475633eec3441396$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $475633eec3441396$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $475633eec3441396$var$ownKeys(Object(source), !0).forEach(function(key) {
            $475633eec3441396$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $475633eec3441396$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $475633eec3441396$var$_defineProperty(obj, key, value) {
    key = $475633eec3441396$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $475633eec3441396$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $475633eec3441396$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $475633eec3441396$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $475633eec3441396$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $475633eec3441396$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $475633eec3441396$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $475633eec3441396$var$_toPropertyKey(arg) {
    var key = $475633eec3441396$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $475633eec3441396$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $475633eec3441396$var$Buffer = $6ZWSX.Buffer;

var $4kvQX = parcelRequire("4kvQX");
var $475633eec3441396$var$inspect = $4kvQX.inspect;
var $475633eec3441396$var$custom = $475633eec3441396$var$inspect && $475633eec3441396$var$inspect.custom || "inspect";
function $475633eec3441396$var$copyBuffer(src, target, offset) {
    $475633eec3441396$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $475633eec3441396$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $475633eec3441396$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $475633eec3441396$var$Buffer.alloc(0);
                var ret = $475633eec3441396$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $475633eec3441396$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $475633eec3441396$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $475633eec3441396$var$custom,
            value: function value(_, options) {
                return $475633eec3441396$var$inspect(this, $475633eec3441396$var$_objectSpread($475633eec3441396$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("c0Uf7", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $8bf11cc7ac536710$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($8bf11cc7ac536710$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($8bf11cc7ac536710$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($8bf11cc7ac536710$var$emitCloseNT, _this);
    });
    return this;
}
function $8bf11cc7ac536710$var$emitErrorAndCloseNT(self, err) {
    $8bf11cc7ac536710$var$emitErrorNT(self, err);
    $8bf11cc7ac536710$var$emitCloseNT(self);
}
function $8bf11cc7ac536710$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $8bf11cc7ac536710$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $8bf11cc7ac536710$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $8bf11cc7ac536710$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $8bf11cc7ac536710$var$destroy,
    undestroy: $8bf11cc7ac536710$var$undestroy,
    errorOrDestroy: $8bf11cc7ac536710$var$errorOrDestroy
};

});

parcelRegister("2wssQ", function(module, exports) {
"use strict";

var $1d64a656ab2d4da3$var$ERR_INVALID_OPT_VALUE = (parcelRequire("gid0T")).codes.ERR_INVALID_OPT_VALUE;
function $1d64a656ab2d4da3$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $1d64a656ab2d4da3$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $1d64a656ab2d4da3$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $1d64a656ab2d4da3$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $1d64a656ab2d4da3$var$getHighWaterMark
};

});
parcelRegister("gid0T", function(module, exports) {

$parcel$export(module.exports, "codes", () => $bdc86bf9ff1a2a6a$export$e45cb6485273080e, (v) => $bdc86bf9ff1a2a6a$export$e45cb6485273080e = v);
var $bdc86bf9ff1a2a6a$export$e45cb6485273080e;
"use strict";
function $bdc86bf9ff1a2a6a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $bdc86bf9ff1a2a6a$var$codes = {};
function $bdc86bf9ff1a2a6a$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $bdc86bf9ff1a2a6a$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $bdc86bf9ff1a2a6a$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $bdc86bf9ff1a2a6a$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $bdc86bf9ff1a2a6a$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $bdc86bf9ff1a2a6a$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $bdc86bf9ff1a2a6a$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $bdc86bf9ff1a2a6a$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($bdc86bf9ff1a2a6a$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($bdc86bf9ff1a2a6a$var$oneOf(expected, "type"));
    else {
        var type = $bdc86bf9ff1a2a6a$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($bdc86bf9ff1a2a6a$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$bdc86bf9ff1a2a6a$export$e45cb6485273080e = $bdc86bf9ff1a2a6a$var$codes;

});


parcelRegister("3ov6Z", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $278bbf2162c434f2$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $278bbf2162c434f2$var$Duplex;

var $dKWUQ = parcelRequire("dKWUQ");

var $c5jlB = parcelRequire("c5jlB");

(parcelRequire("dlqwk"))($278bbf2162c434f2$var$Duplex, $dKWUQ);
// Allow the keys array to be GC'ed.
var $278bbf2162c434f2$var$keys = $278bbf2162c434f2$var$objectKeys($c5jlB.prototype);
for(var $278bbf2162c434f2$var$v = 0; $278bbf2162c434f2$var$v < $278bbf2162c434f2$var$keys.length; $278bbf2162c434f2$var$v++){
    var $278bbf2162c434f2$var$method = $278bbf2162c434f2$var$keys[$278bbf2162c434f2$var$v];
    if (!$278bbf2162c434f2$var$Duplex.prototype[$278bbf2162c434f2$var$method]) $278bbf2162c434f2$var$Duplex.prototype[$278bbf2162c434f2$var$method] = $c5jlB.prototype[$278bbf2162c434f2$var$method];
}
function $278bbf2162c434f2$var$Duplex(options) {
    if (!(this instanceof $278bbf2162c434f2$var$Duplex)) return new $278bbf2162c434f2$var$Duplex(options);
    $dKWUQ.call(this, options);
    $c5jlB.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $278bbf2162c434f2$var$onend);
        }
    }
}
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $278bbf2162c434f2$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($278bbf2162c434f2$var$onEndNT, this);
}
function $278bbf2162c434f2$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("c5jlB", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $8cc4f5a98988b56b$var$Writable;
/* <replacement> */ function $8cc4f5a98988b56b$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $8cc4f5a98988b56b$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $8cc4f5a98988b56b$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $8cc4f5a98988b56b$var$Duplex;
/*</replacement>*/ $8cc4f5a98988b56b$var$Writable.WritableState = $8cc4f5a98988b56b$var$WritableState;

/*<replacement>*/ var $8cc4f5a98988b56b$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $c6U6o = parcelRequire("c6U6o");

var $6ZWSX = parcelRequire("6ZWSX");
var $8cc4f5a98988b56b$require$Buffer = $6ZWSX.Buffer;
var $8cc4f5a98988b56b$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $8cc4f5a98988b56b$var$_uint8ArrayToBuffer(chunk) {
    return $8cc4f5a98988b56b$require$Buffer.from(chunk);
}
function $8cc4f5a98988b56b$var$_isUint8Array(obj) {
    return $8cc4f5a98988b56b$require$Buffer.isBuffer(obj) || obj instanceof $8cc4f5a98988b56b$var$OurUint8Array;
}

var $c0Uf7 = parcelRequire("c0Uf7");

var $2wssQ = parcelRequire("2wssQ");
var $8cc4f5a98988b56b$var$getHighWaterMark = $2wssQ.getHighWaterMark;

var $gid0T = parcelRequire("gid0T");
var $8cc4f5a98988b56b$require$_require$codes = $gid0T.codes;
var $8cc4f5a98988b56b$var$ERR_INVALID_ARG_TYPE = $8cc4f5a98988b56b$require$_require$codes.ERR_INVALID_ARG_TYPE, $8cc4f5a98988b56b$var$ERR_METHOD_NOT_IMPLEMENTED = $8cc4f5a98988b56b$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8cc4f5a98988b56b$var$ERR_MULTIPLE_CALLBACK = $8cc4f5a98988b56b$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8cc4f5a98988b56b$var$ERR_STREAM_CANNOT_PIPE = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $8cc4f5a98988b56b$var$ERR_STREAM_DESTROYED = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_DESTROYED, $8cc4f5a98988b56b$var$ERR_STREAM_NULL_VALUES = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_NULL_VALUES, $8cc4f5a98988b56b$var$ERR_STREAM_WRITE_AFTER_END = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $8cc4f5a98988b56b$var$ERR_UNKNOWN_ENCODING = $8cc4f5a98988b56b$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $8cc4f5a98988b56b$var$errorOrDestroy = $c0Uf7.errorOrDestroy;

(parcelRequire("dlqwk"))($8cc4f5a98988b56b$var$Writable, $c6U6o);
function $8cc4f5a98988b56b$var$nop() {}

function $8cc4f5a98988b56b$var$WritableState(options, stream, isDuplex) {
    $8cc4f5a98988b56b$var$Duplex = $8cc4f5a98988b56b$var$Duplex || (parcelRequire("3ov6Z"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $8cc4f5a98988b56b$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $8cc4f5a98988b56b$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $8cc4f5a98988b56b$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $8cc4f5a98988b56b$var$CorkedRequest(this);
}
$8cc4f5a98988b56b$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($8cc4f5a98988b56b$var$WritableState.prototype, "buffer", {
            get: $8cc4f5a98988b56b$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $8cc4f5a98988b56b$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $8cc4f5a98988b56b$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($8cc4f5a98988b56b$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($8cc4f5a98988b56b$var$realHasInstance.call(this, object)) return true;
            if (this !== $8cc4f5a98988b56b$var$Writable) return false;
            return object && object._writableState instanceof $8cc4f5a98988b56b$var$WritableState;
        }
    });
} else $8cc4f5a98988b56b$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $8cc4f5a98988b56b$var$Writable(options) {
    $8cc4f5a98988b56b$var$Duplex = $8cc4f5a98988b56b$var$Duplex || (parcelRequire("3ov6Z"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $8cc4f5a98988b56b$var$Duplex;
    if (!isDuplex && !$8cc4f5a98988b56b$var$realHasInstance.call($8cc4f5a98988b56b$var$Writable, this)) return new $8cc4f5a98988b56b$var$Writable(options);
    this._writableState = new $8cc4f5a98988b56b$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $c6U6o.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$8cc4f5a98988b56b$var$Writable.prototype.pipe = function() {
    $8cc4f5a98988b56b$var$errorOrDestroy(this, new $8cc4f5a98988b56b$var$ERR_STREAM_CANNOT_PIPE());
};
function $8cc4f5a98988b56b$var$writeAfterEnd(stream, cb) {
    var er = new $8cc4f5a98988b56b$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $8cc4f5a98988b56b$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $8cc4f5a98988b56b$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $8cc4f5a98988b56b$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$8cc4f5a98988b56b$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $8cc4f5a98988b56b$var$_isUint8Array(chunk);
    if (isBuf && !$8cc4f5a98988b56b$require$Buffer.isBuffer(chunk)) chunk = $8cc4f5a98988b56b$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $8cc4f5a98988b56b$var$nop;
    if (state.ending) $8cc4f5a98988b56b$var$writeAfterEnd(this, cb);
    else if (isBuf || $8cc4f5a98988b56b$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $8cc4f5a98988b56b$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$8cc4f5a98988b56b$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$8cc4f5a98988b56b$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8cc4f5a98988b56b$var$clearBuffer(this, state);
    }
};
$8cc4f5a98988b56b$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $8cc4f5a98988b56b$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $8cc4f5a98988b56b$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $8cc4f5a98988b56b$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $8cc4f5a98988b56b$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $8cc4f5a98988b56b$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $8cc4f5a98988b56b$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $8cc4f5a98988b56b$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $8cc4f5a98988b56b$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $8cc4f5a98988b56b$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($8cc4f5a98988b56b$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $8cc4f5a98988b56b$var$finishMaybe(stream, state);
    }
}
function $8cc4f5a98988b56b$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $8cc4f5a98988b56b$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $8cc4f5a98988b56b$var$ERR_MULTIPLE_CALLBACK();
    $8cc4f5a98988b56b$var$onwriteStateUpdate(state);
    if (er) $8cc4f5a98988b56b$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $8cc4f5a98988b56b$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8cc4f5a98988b56b$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($8cc4f5a98988b56b$var$afterWrite, stream, state, finished, cb);
        else $8cc4f5a98988b56b$var$afterWrite(stream, state, finished, cb);
    }
}
function $8cc4f5a98988b56b$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $8cc4f5a98988b56b$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $8cc4f5a98988b56b$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $8cc4f5a98988b56b$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $8cc4f5a98988b56b$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $8cc4f5a98988b56b$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $8cc4f5a98988b56b$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $8cc4f5a98988b56b$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$8cc4f5a98988b56b$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $8cc4f5a98988b56b$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$8cc4f5a98988b56b$var$Writable.prototype._writev = null;
$8cc4f5a98988b56b$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $8cc4f5a98988b56b$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $8cc4f5a98988b56b$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $8cc4f5a98988b56b$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $8cc4f5a98988b56b$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $8cc4f5a98988b56b$var$finishMaybe(stream, state);
    });
}
function $8cc4f5a98988b56b$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($8cc4f5a98988b56b$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $8cc4f5a98988b56b$var$finishMaybe(stream, state) {
    var need = $8cc4f5a98988b56b$var$needFinish(state);
    if (need) {
        $8cc4f5a98988b56b$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $8cc4f5a98988b56b$var$endWritable(stream, state, cb) {
    state.ending = true;
    $8cc4f5a98988b56b$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $8cc4f5a98988b56b$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$8cc4f5a98988b56b$var$Writable.prototype.destroy = $c0Uf7.destroy;
$8cc4f5a98988b56b$var$Writable.prototype._undestroy = $c0Uf7.undestroy;
$8cc4f5a98988b56b$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("8NiiC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $667118301431ed3f$var$_Object$setPrototypeO;
function $667118301431ed3f$var$_defineProperty(obj, key, value) {
    key = $667118301431ed3f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $667118301431ed3f$var$_toPropertyKey(arg) {
    var key = $667118301431ed3f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $667118301431ed3f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $izVph = parcelRequire("izVph");
var $667118301431ed3f$var$kLastResolve = Symbol("lastResolve");
var $667118301431ed3f$var$kLastReject = Symbol("lastReject");
var $667118301431ed3f$var$kError = Symbol("error");
var $667118301431ed3f$var$kEnded = Symbol("ended");
var $667118301431ed3f$var$kLastPromise = Symbol("lastPromise");
var $667118301431ed3f$var$kHandlePromise = Symbol("handlePromise");
var $667118301431ed3f$var$kStream = Symbol("stream");
function $667118301431ed3f$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $667118301431ed3f$var$readAndResolve(iter) {
    var resolve = iter[$667118301431ed3f$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$667118301431ed3f$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$667118301431ed3f$var$kLastPromise] = null;
            iter[$667118301431ed3f$var$kLastResolve] = null;
            iter[$667118301431ed3f$var$kLastReject] = null;
            resolve($667118301431ed3f$var$createIterResult(data, false));
        }
    }
}
function $667118301431ed3f$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($667118301431ed3f$var$readAndResolve, iter);
}
function $667118301431ed3f$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$667118301431ed3f$var$kEnded]) {
                resolve($667118301431ed3f$var$createIterResult(undefined, true));
                return;
            }
            iter[$667118301431ed3f$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $667118301431ed3f$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $667118301431ed3f$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($667118301431ed3f$var$_Object$setPrototypeO = {
    get stream () {
        return this[$667118301431ed3f$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$667118301431ed3f$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$667118301431ed3f$var$kEnded]) return Promise.resolve($667118301431ed3f$var$createIterResult(undefined, true));
        if (this[$667118301431ed3f$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$667118301431ed3f$var$kError]) reject(_this[$667118301431ed3f$var$kError]);
                else resolve($667118301431ed3f$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$667118301431ed3f$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($667118301431ed3f$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$667118301431ed3f$var$kStream].read();
            if (data !== null) return Promise.resolve($667118301431ed3f$var$createIterResult(data, false));
            promise = new Promise(this[$667118301431ed3f$var$kHandlePromise]);
        }
        this[$667118301431ed3f$var$kLastPromise] = promise;
        return promise;
    }
}, $667118301431ed3f$var$_defineProperty($667118301431ed3f$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $667118301431ed3f$var$_defineProperty($667118301431ed3f$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$667118301431ed3f$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($667118301431ed3f$var$createIterResult(undefined, true));
        });
    });
}), $667118301431ed3f$var$_Object$setPrototypeO), $667118301431ed3f$var$AsyncIteratorPrototype);
var $667118301431ed3f$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($667118301431ed3f$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kStream, {
        value: stream,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kLastResolve, {
        value: null,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kLastReject, {
        value: null,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kError, {
        value: null,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$667118301431ed3f$var$kStream].read();
            if (data) {
                iterator[$667118301431ed3f$var$kLastPromise] = null;
                iterator[$667118301431ed3f$var$kLastResolve] = null;
                iterator[$667118301431ed3f$var$kLastReject] = null;
                resolve($667118301431ed3f$var$createIterResult(data, false));
            } else {
                iterator[$667118301431ed3f$var$kLastResolve] = resolve;
                iterator[$667118301431ed3f$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$667118301431ed3f$var$kLastPromise] = null;
    $izVph(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$667118301431ed3f$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$667118301431ed3f$var$kLastPromise] = null;
                iterator[$667118301431ed3f$var$kLastResolve] = null;
                iterator[$667118301431ed3f$var$kLastReject] = null;
                reject(err);
            }
            iterator[$667118301431ed3f$var$kError] = err;
            return;
        }
        var resolve = iterator[$667118301431ed3f$var$kLastResolve];
        if (resolve !== null) {
            iterator[$667118301431ed3f$var$kLastPromise] = null;
            iterator[$667118301431ed3f$var$kLastResolve] = null;
            iterator[$667118301431ed3f$var$kLastReject] = null;
            resolve($667118301431ed3f$var$createIterResult(undefined, true));
        }
        iterator[$667118301431ed3f$var$kEnded] = true;
    });
    stream.on("readable", $667118301431ed3f$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $667118301431ed3f$var$createReadableStreamAsyncIterator;

});
parcelRegister("izVph", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $d86806abb7caca08$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("gid0T")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $d86806abb7caca08$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $d86806abb7caca08$var$noop() {}
function $d86806abb7caca08$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $d86806abb7caca08$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $d86806abb7caca08$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $d86806abb7caca08$var$once(callback || $d86806abb7caca08$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $d86806abb7caca08$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $d86806abb7caca08$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($d86806abb7caca08$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $d86806abb7caca08$var$eos;

});


parcelRegister("2O9bI", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("crXmw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $91060dc4548a9b08$var$Transform;

var $gid0T = parcelRequire("gid0T");
var $91060dc4548a9b08$require$_require$codes = $gid0T.codes;
var $91060dc4548a9b08$var$ERR_METHOD_NOT_IMPLEMENTED = $91060dc4548a9b08$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $91060dc4548a9b08$var$ERR_MULTIPLE_CALLBACK = $91060dc4548a9b08$require$_require$codes.ERR_MULTIPLE_CALLBACK, $91060dc4548a9b08$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $91060dc4548a9b08$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $91060dc4548a9b08$var$ERR_TRANSFORM_WITH_LENGTH_0 = $91060dc4548a9b08$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $3ov6Z = parcelRequire("3ov6Z");

(parcelRequire("dlqwk"))($91060dc4548a9b08$var$Transform, $3ov6Z);
function $91060dc4548a9b08$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $91060dc4548a9b08$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $91060dc4548a9b08$var$Transform(options) {
    if (!(this instanceof $91060dc4548a9b08$var$Transform)) return new $91060dc4548a9b08$var$Transform(options);
    $3ov6Z.call(this, options);
    this._transformState = {
        afterTransform: $91060dc4548a9b08$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $91060dc4548a9b08$var$prefinish);
}
function $91060dc4548a9b08$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $91060dc4548a9b08$var$done(_this, er, data);
    });
    else $91060dc4548a9b08$var$done(this, null, null);
}
$91060dc4548a9b08$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $3ov6Z.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$91060dc4548a9b08$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $91060dc4548a9b08$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$91060dc4548a9b08$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$91060dc4548a9b08$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$91060dc4548a9b08$var$Transform.prototype._destroy = function(err, cb) {
    $3ov6Z.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $91060dc4548a9b08$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $91060dc4548a9b08$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $91060dc4548a9b08$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("di5wW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $9ad13f044dc43d7f$var$PassThrough;

var $crXmw = parcelRequire("crXmw");

(parcelRequire("dlqwk"))($9ad13f044dc43d7f$var$PassThrough, $crXmw);
function $9ad13f044dc43d7f$var$PassThrough(options) {
    if (!(this instanceof $9ad13f044dc43d7f$var$PassThrough)) return new $9ad13f044dc43d7f$var$PassThrough(options);
    $crXmw.call(this, options);
}
$9ad13f044dc43d7f$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("4HJZ1", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $36ced8e7be5358d3$var$eos;
function $36ced8e7be5358d3$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $gid0T = parcelRequire("gid0T");
var $36ced8e7be5358d3$require$_require$codes = $gid0T.codes;
var $36ced8e7be5358d3$var$ERR_MISSING_ARGS = $36ced8e7be5358d3$require$_require$codes.ERR_MISSING_ARGS, $36ced8e7be5358d3$var$ERR_STREAM_DESTROYED = $36ced8e7be5358d3$require$_require$codes.ERR_STREAM_DESTROYED;
function $36ced8e7be5358d3$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $36ced8e7be5358d3$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $36ced8e7be5358d3$var$destroyer(stream, reading, writing, callback) {
    callback = $36ced8e7be5358d3$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($36ced8e7be5358d3$var$eos === undefined) $36ced8e7be5358d3$var$eos = (parcelRequire("izVph"));
    $36ced8e7be5358d3$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($36ced8e7be5358d3$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $36ced8e7be5358d3$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $36ced8e7be5358d3$var$call(fn) {
    fn();
}
function $36ced8e7be5358d3$var$pipe(from, to) {
    return from.pipe(to);
}
function $36ced8e7be5358d3$var$popCallback(streams) {
    if (!streams.length) return $36ced8e7be5358d3$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $36ced8e7be5358d3$var$noop;
    return streams.pop();
}
function $36ced8e7be5358d3$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $36ced8e7be5358d3$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $36ced8e7be5358d3$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $36ced8e7be5358d3$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($36ced8e7be5358d3$var$call);
            if (reading) return;
            destroys.forEach($36ced8e7be5358d3$var$call);
            callback(error);
        });
    });
    return streams.reduce($36ced8e7be5358d3$var$pipe);
}
module.exports = $36ced8e7be5358d3$var$pipeline;

});




parcelRegister("a8qBR", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRegister("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("aBufs"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("6XbcT"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("fFuzr"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("k3Gr9"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("6G2fH"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("hzqCm"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("coyuH"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("aBufs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $7b84d2ca8f0d8afd$var$Readable;
/*<replacement>*/ var $7b84d2ca8f0d8afd$var$Duplex;
/*</replacement>*/ $7b84d2ca8f0d8afd$var$Readable.ReadableState = $7b84d2ca8f0d8afd$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $7b84d2ca8f0d8afd$require$EE = $7etJZ.EventEmitter;
var $7b84d2ca8f0d8afd$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $7b84d2ca8f0d8afd$require$Buffer = $6ZWSX.Buffer;
var $7b84d2ca8f0d8afd$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk) {
    return $7b84d2ca8f0d8afd$require$Buffer.from(chunk);
}
function $7b84d2ca8f0d8afd$var$_isUint8Array(obj) {
    return $7b84d2ca8f0d8afd$require$Buffer.isBuffer(obj) || obj instanceof $7b84d2ca8f0d8afd$var$OurUint8Array;
}

var $4kvQX = parcelRequire("4kvQX");
var $7b84d2ca8f0d8afd$var$debug;
if ($4kvQX && $4kvQX.debuglog) $7b84d2ca8f0d8afd$var$debug = $4kvQX.debuglog("stream");
else $7b84d2ca8f0d8afd$var$debug = function debug() {};

var $6aKSQ = parcelRequire("6aKSQ");

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $7b84d2ca8f0d8afd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $7b84d2ca8f0d8afd$require$_require$codes = $967Aq.codes;
var $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE = $7b84d2ca8f0d8afd$require$_require$codes.ERR_INVALID_ARG_TYPE, $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED = $7b84d2ca8f0d8afd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $7b84d2ca8f0d8afd$var$StringDecoder;
var $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator;
var $7b84d2ca8f0d8afd$var$from;

(parcelRequire("dlqwk"))($7b84d2ca8f0d8afd$var$Readable, $jJj7p);
var $7b84d2ca8f0d8afd$var$errorOrDestroy = $fnDgj.errorOrDestroy;
var $7b84d2ca8f0d8afd$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $7b84d2ca8f0d8afd$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $7b84d2ca8f0d8afd$var$ReadableState(options, stream, isDuplex) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $7b84d2ca8f0d8afd$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $7b84d2ca8f0d8afd$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6aKSQ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7b84d2ca8f0d8afd$var$Readable(options) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    if (!(this instanceof $7b84d2ca8f0d8afd$var$Readable)) return new $7b84d2ca8f0d8afd$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $7b84d2ca8f0d8afd$var$Duplex;
    this._readableState = new $7b84d2ca8f0d8afd$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jJj7p.call(this);
}
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$7b84d2ca8f0d8afd$var$Readable.prototype.destroy = $fnDgj.destroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._undestroy = $fnDgj.undestroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7b84d2ca8f0d8afd$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $7b84d2ca8f0d8afd$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$7b84d2ca8f0d8afd$var$Readable.prototype.unshift = function(chunk) {
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, null, true, false);
};
function $7b84d2ca8f0d8afd$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $7b84d2ca8f0d8afd$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $7b84d2ca8f0d8afd$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk);
        if (er) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $7b84d2ca8f0d8afd$require$Buffer.prototype) chunk = $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
                    else $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
                } else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $7b84d2ca8f0d8afd$var$emitReadable(stream);
    }
    $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
}
function $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk) {
    var er;
    if (!$7b84d2ca8f0d8afd$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$7b84d2ca8f0d8afd$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$7b84d2ca8f0d8afd$var$Readable.prototype.setEncoding = function(enc) {
    if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $7b84d2ca8f0d8afd$var$MAX_HWM = 0x40000000;
function $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n) {
    if (n >= $7b84d2ca8f0d8afd$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $7b84d2ca8f0d8afd$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$7b84d2ca8f0d8afd$var$Readable.prototype.read = function(n) {
    $7b84d2ca8f0d8afd$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7b84d2ca8f0d8afd$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
        else $7b84d2ca8f0d8afd$var$emitReadable(this);
        return null;
    }
    n = $7b84d2ca8f0d8afd$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7b84d2ca8f0d8afd$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $7b84d2ca8f0d8afd$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7b84d2ca8f0d8afd$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $7b84d2ca8f0d8afd$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $7b84d2ca8f0d8afd$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7b84d2ca8f0d8afd$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7b84d2ca8f0d8afd$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $7b84d2ca8f0d8afd$var$onEofChunk(stream, state) {
    $7b84d2ca8f0d8afd$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $7b84d2ca8f0d8afd$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $7b84d2ca8f0d8afd$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7b84d2ca8f0d8afd$var$emitReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7b84d2ca8f0d8afd$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$emitReadable_, stream);
    }
}
function $7b84d2ca8f0d8afd$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7b84d2ca8f0d8afd$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$maybeReadMore_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7b84d2ca8f0d8afd$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7b84d2ca8f0d8afd$var$Readable.prototype._read = function(n) {
    $7b84d2ca8f0d8afd$var$errorOrDestroy(this, new $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$7b84d2ca8f0d8afd$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $7b84d2ca8f0d8afd$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7b84d2ca8f0d8afd$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7b84d2ca8f0d8afd$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $7b84d2ca8f0d8afd$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $7b84d2ca8f0d8afd$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $7b84d2ca8f0d8afd$var$debug("ondata");
        var ret = dest.write(chunk);
        $7b84d2ca8f0d8afd$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $7b84d2ca8f0d8afd$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7b84d2ca8f0d8afd$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($7b84d2ca8f0d8afd$var$EElistenerCount(dest, "error") === 0) $7b84d2ca8f0d8afd$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $7b84d2ca8f0d8afd$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $7b84d2ca8f0d8afd$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $7b84d2ca8f0d8afd$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $7b84d2ca8f0d8afd$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $7b84d2ca8f0d8afd$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $7b84d2ca8f0d8afd$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $7b84d2ca8f0d8afd$var$flow(src);
        }
    };
}
$7b84d2ca8f0d8afd$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$7b84d2ca8f0d8afd$var$Readable.prototype.on = function(ev, fn) {
    var res = $jJj7p.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7b84d2ca8f0d8afd$var$debug("on readable", state.length, state.reading);
            if (state.length) $7b84d2ca8f0d8afd$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($7b84d2ca8f0d8afd$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.addListener = $7b84d2ca8f0d8afd$var$Readable.prototype.on;
$7b84d2ca8f0d8afd$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jJj7p.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jJj7p.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
function $7b84d2ca8f0d8afd$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $7b84d2ca8f0d8afd$var$nReadingNextTick(self1) {
    $7b84d2ca8f0d8afd$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7b84d2ca8f0d8afd$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $7b84d2ca8f0d8afd$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $7b84d2ca8f0d8afd$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$resume_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$resume_(stream, state) {
    $7b84d2ca8f0d8afd$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $7b84d2ca8f0d8afd$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7b84d2ca8f0d8afd$var$Readable.prototype.pause = function() {
    $7b84d2ca8f0d8afd$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7b84d2ca8f0d8afd$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $7b84d2ca8f0d8afd$var$flow(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7b84d2ca8f0d8afd$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $7b84d2ca8f0d8afd$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $7b84d2ca8f0d8afd$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $7b84d2ca8f0d8afd$var$kProxyEvents.length; n++)stream.on($7b84d2ca8f0d8afd$var$kProxyEvents[n], this.emit.bind(this, $7b84d2ca8f0d8afd$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $7b84d2ca8f0d8afd$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $7b84d2ca8f0d8afd$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator === undefined) $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator = (parcelRequire("3etzH"));
    return $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$7b84d2ca8f0d8afd$var$Readable._fromList = $7b84d2ca8f0d8afd$var$fromList;
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7b84d2ca8f0d8afd$var$endReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$endReadableNT, state, stream);
    }
}
function $7b84d2ca8f0d8afd$var$endReadableNT(state, stream) {
    $7b84d2ca8f0d8afd$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $7b84d2ca8f0d8afd$var$Readable.from = function(iterable, opts) {
    if ($7b84d2ca8f0d8afd$var$from === undefined) $7b84d2ca8f0d8afd$var$from = (parcelRequire("gN4Jr"));
    return $7b84d2ca8f0d8afd$var$from($7b84d2ca8f0d8afd$var$Readable, iterable, opts);
};
function $7b84d2ca8f0d8afd$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jJj7p", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("6aKSQ", function(module, exports) {
"use strict";
function $47e80b5d1f4ca857$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47e80b5d1f4ca857$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $47e80b5d1f4ca857$var$ownKeys(Object(source), !0).forEach(function(key) {
            $47e80b5d1f4ca857$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $47e80b5d1f4ca857$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47e80b5d1f4ca857$var$_defineProperty(obj, key, value) {
    key = $47e80b5d1f4ca857$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47e80b5d1f4ca857$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $47e80b5d1f4ca857$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $47e80b5d1f4ca857$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $47e80b5d1f4ca857$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $47e80b5d1f4ca857$var$_toPropertyKey(arg) {
    var key = $47e80b5d1f4ca857$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $47e80b5d1f4ca857$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $47e80b5d1f4ca857$var$Buffer = $6ZWSX.Buffer;

var $4kvQX = parcelRequire("4kvQX");
var $47e80b5d1f4ca857$var$inspect = $4kvQX.inspect;
var $47e80b5d1f4ca857$var$custom = $47e80b5d1f4ca857$var$inspect && $47e80b5d1f4ca857$var$inspect.custom || "inspect";
function $47e80b5d1f4ca857$var$copyBuffer(src, target, offset) {
    $47e80b5d1f4ca857$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $47e80b5d1f4ca857$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $47e80b5d1f4ca857$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $47e80b5d1f4ca857$var$Buffer.alloc(0);
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $47e80b5d1f4ca857$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $47e80b5d1f4ca857$var$custom,
            value: function value(_, options) {
                return $47e80b5d1f4ca857$var$inspect(this, $47e80b5d1f4ca857$var$_objectSpread($47e80b5d1f4ca857$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fnDgj", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b32775a19d7a76d1$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
    });
    return this;
}
function $b32775a19d7a76d1$var$emitErrorAndCloseNT(self, err) {
    $b32775a19d7a76d1$var$emitErrorNT(self, err);
    $b32775a19d7a76d1$var$emitCloseNT(self);
}
function $b32775a19d7a76d1$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b32775a19d7a76d1$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b32775a19d7a76d1$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b32775a19d7a76d1$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b32775a19d7a76d1$var$destroy,
    undestroy: $b32775a19d7a76d1$var$undestroy,
    errorOrDestroy: $b32775a19d7a76d1$var$errorOrDestroy
};

});

parcelRegister("5yyyA", function(module, exports) {
"use strict";

var $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("967Aq")).codes.ERR_INVALID_OPT_VALUE;
function $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $40baeeffbb52bbd0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $40baeeffbb52bbd0$var$getHighWaterMark
};

});
parcelRegister("967Aq", function(module, exports) {

$parcel$export(module.exports, "codes", () => $69fa8f23fe6fc7e7$export$e45cb6485273080e, (v) => $69fa8f23fe6fc7e7$export$e45cb6485273080e = v);
var $69fa8f23fe6fc7e7$export$e45cb6485273080e;
"use strict";
function $69fa8f23fe6fc7e7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $69fa8f23fe6fc7e7$var$codes = {};
function $69fa8f23fe6fc7e7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $69fa8f23fe6fc7e7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $69fa8f23fe6fc7e7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $69fa8f23fe6fc7e7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $69fa8f23fe6fc7e7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $69fa8f23fe6fc7e7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $69fa8f23fe6fc7e7$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$69fa8f23fe6fc7e7$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $69fa8f23fe6fc7e7$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($69fa8f23fe6fc7e7$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, "type"));
    else {
        var type = $69fa8f23fe6fc7e7$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$69fa8f23fe6fc7e7$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$69fa8f23fe6fc7e7$export$e45cb6485273080e = $69fa8f23fe6fc7e7$var$codes;

});


parcelRegister("fFuzr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $b682660ac74fe757$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b682660ac74fe757$var$Duplex;

var $aBufs = parcelRequire("aBufs");

var $6XbcT = parcelRequire("6XbcT");

(parcelRequire("dlqwk"))($b682660ac74fe757$var$Duplex, $aBufs);
// Allow the keys array to be GC'ed.
var $b682660ac74fe757$var$keys = $b682660ac74fe757$var$objectKeys($6XbcT.prototype);
for(var $b682660ac74fe757$var$v = 0; $b682660ac74fe757$var$v < $b682660ac74fe757$var$keys.length; $b682660ac74fe757$var$v++){
    var $b682660ac74fe757$var$method = $b682660ac74fe757$var$keys[$b682660ac74fe757$var$v];
    if (!$b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method]) $b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method] = $6XbcT.prototype[$b682660ac74fe757$var$method];
}
function $b682660ac74fe757$var$Duplex(options) {
    if (!(this instanceof $b682660ac74fe757$var$Duplex)) return new $b682660ac74fe757$var$Duplex(options);
    $aBufs.call(this, options);
    $6XbcT.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $b682660ac74fe757$var$onend);
        }
    }
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $b682660ac74fe757$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($b682660ac74fe757$var$onEndNT, this);
}
function $b682660ac74fe757$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("6XbcT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $5100f23d2ab8fadd$var$Writable;
/* <replacement> */ function $5100f23d2ab8fadd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5100f23d2ab8fadd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5100f23d2ab8fadd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5100f23d2ab8fadd$var$Duplex;
/*</replacement>*/ $5100f23d2ab8fadd$var$Writable.WritableState = $5100f23d2ab8fadd$var$WritableState;

/*<replacement>*/ var $5100f23d2ab8fadd$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $5100f23d2ab8fadd$require$Buffer = $6ZWSX.Buffer;
var $5100f23d2ab8fadd$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk) {
    return $5100f23d2ab8fadd$require$Buffer.from(chunk);
}
function $5100f23d2ab8fadd$var$_isUint8Array(obj) {
    return $5100f23d2ab8fadd$require$Buffer.isBuffer(obj) || obj instanceof $5100f23d2ab8fadd$var$OurUint8Array;
}

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $5100f23d2ab8fadd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $5100f23d2ab8fadd$require$_require$codes = $967Aq.codes;
var $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE = $5100f23d2ab8fadd$require$_require$codes.ERR_INVALID_ARG_TYPE, $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED = $5100f23d2ab8fadd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK = $5100f23d2ab8fadd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_DESTROYED, $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_NULL_VALUES, $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING = $5100f23d2ab8fadd$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5100f23d2ab8fadd$var$errorOrDestroy = $fnDgj.errorOrDestroy;

(parcelRequire("dlqwk"))($5100f23d2ab8fadd$var$Writable, $jJj7p);
function $5100f23d2ab8fadd$var$nop() {}

function $5100f23d2ab8fadd$var$WritableState(options, stream, isDuplex) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $5100f23d2ab8fadd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5100f23d2ab8fadd$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5100f23d2ab8fadd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(this);
}
$5100f23d2ab8fadd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5100f23d2ab8fadd$var$WritableState.prototype, "buffer", {
            get: $5100f23d2ab8fadd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5100f23d2ab8fadd$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $5100f23d2ab8fadd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5100f23d2ab8fadd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5100f23d2ab8fadd$var$realHasInstance.call(this, object)) return true;
            if (this !== $5100f23d2ab8fadd$var$Writable) return false;
            return object && object._writableState instanceof $5100f23d2ab8fadd$var$WritableState;
        }
    });
} else $5100f23d2ab8fadd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5100f23d2ab8fadd$var$Writable(options) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5100f23d2ab8fadd$var$Duplex;
    if (!isDuplex && !$5100f23d2ab8fadd$var$realHasInstance.call($5100f23d2ab8fadd$var$Writable, this)) return new $5100f23d2ab8fadd$var$Writable(options);
    this._writableState = new $5100f23d2ab8fadd$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jJj7p.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5100f23d2ab8fadd$var$Writable.prototype.pipe = function() {
    $5100f23d2ab8fadd$var$errorOrDestroy(this, new $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE());
};
function $5100f23d2ab8fadd$var$writeAfterEnd(stream, cb) {
    var er = new $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5100f23d2ab8fadd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$5100f23d2ab8fadd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5100f23d2ab8fadd$var$_isUint8Array(chunk);
    if (isBuf && !$5100f23d2ab8fadd$require$Buffer.isBuffer(chunk)) chunk = $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $5100f23d2ab8fadd$var$nop;
    if (state.ending) $5100f23d2ab8fadd$var$writeAfterEnd(this, cb);
    else if (isBuf || $5100f23d2ab8fadd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5100f23d2ab8fadd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5100f23d2ab8fadd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5100f23d2ab8fadd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(this, state);
    }
};
$5100f23d2ab8fadd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $5100f23d2ab8fadd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5100f23d2ab8fadd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5100f23d2ab8fadd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($5100f23d2ab8fadd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    }
}
function $5100f23d2ab8fadd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5100f23d2ab8fadd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK();
    $5100f23d2ab8fadd$var$onwriteStateUpdate(state);
    if (er) $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5100f23d2ab8fadd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($5100f23d2ab8fadd$var$afterWrite, stream, state, finished, cb);
        else $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb);
    }
}
function $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5100f23d2ab8fadd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5100f23d2ab8fadd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $5100f23d2ab8fadd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5100f23d2ab8fadd$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5100f23d2ab8fadd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$5100f23d2ab8fadd$var$Writable.prototype._writev = null;
$5100f23d2ab8fadd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5100f23d2ab8fadd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5100f23d2ab8fadd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5100f23d2ab8fadd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5100f23d2ab8fadd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    });
}
function $5100f23d2ab8fadd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($5100f23d2ab8fadd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $5100f23d2ab8fadd$var$finishMaybe(stream, state) {
    var need = $5100f23d2ab8fadd$var$needFinish(state);
    if (need) {
        $5100f23d2ab8fadd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5100f23d2ab8fadd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5100f23d2ab8fadd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5100f23d2ab8fadd$var$Writable.prototype.destroy = $fnDgj.destroy;
$5100f23d2ab8fadd$var$Writable.prototype._undestroy = $fnDgj.undestroy;
$5100f23d2ab8fadd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRegister("3etzH", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $25a99ede456543b7$var$_Object$setPrototypeO;
function $25a99ede456543b7$var$_defineProperty(obj, key, value) {
    key = $25a99ede456543b7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25a99ede456543b7$var$_toPropertyKey(arg) {
    var key = $25a99ede456543b7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $25a99ede456543b7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $hzqCm = parcelRequire("hzqCm");
var $25a99ede456543b7$var$kLastResolve = Symbol("lastResolve");
var $25a99ede456543b7$var$kLastReject = Symbol("lastReject");
var $25a99ede456543b7$var$kError = Symbol("error");
var $25a99ede456543b7$var$kEnded = Symbol("ended");
var $25a99ede456543b7$var$kLastPromise = Symbol("lastPromise");
var $25a99ede456543b7$var$kHandlePromise = Symbol("handlePromise");
var $25a99ede456543b7$var$kStream = Symbol("stream");
function $25a99ede456543b7$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $25a99ede456543b7$var$readAndResolve(iter) {
    var resolve = iter[$25a99ede456543b7$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$25a99ede456543b7$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$25a99ede456543b7$var$kLastPromise] = null;
            iter[$25a99ede456543b7$var$kLastResolve] = null;
            iter[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(data, false));
        }
    }
}
function $25a99ede456543b7$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($25a99ede456543b7$var$readAndResolve, iter);
}
function $25a99ede456543b7$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$25a99ede456543b7$var$kEnded]) {
                resolve($25a99ede456543b7$var$createIterResult(undefined, true));
                return;
            }
            iter[$25a99ede456543b7$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $25a99ede456543b7$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($25a99ede456543b7$var$_Object$setPrototypeO = {
    get stream () {
        return this[$25a99ede456543b7$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$25a99ede456543b7$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$25a99ede456543b7$var$kEnded]) return Promise.resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        if (this[$25a99ede456543b7$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$25a99ede456543b7$var$kError]) reject(_this[$25a99ede456543b7$var$kError]);
                else resolve($25a99ede456543b7$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$25a99ede456543b7$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($25a99ede456543b7$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$25a99ede456543b7$var$kStream].read();
            if (data !== null) return Promise.resolve($25a99ede456543b7$var$createIterResult(data, false));
            promise = new Promise(this[$25a99ede456543b7$var$kHandlePromise]);
        }
        this[$25a99ede456543b7$var$kLastPromise] = promise;
        return promise;
    }
}, $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$25a99ede456543b7$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        });
    });
}), $25a99ede456543b7$var$_Object$setPrototypeO), $25a99ede456543b7$var$AsyncIteratorPrototype);
var $25a99ede456543b7$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kStream, {
        value: stream,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastResolve, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastReject, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kError, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$25a99ede456543b7$var$kStream].read();
            if (data) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                resolve($25a99ede456543b7$var$createIterResult(data, false));
            } else {
                iterator[$25a99ede456543b7$var$kLastResolve] = resolve;
                iterator[$25a99ede456543b7$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$25a99ede456543b7$var$kLastPromise] = null;
    $hzqCm(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$25a99ede456543b7$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                reject(err);
            }
            iterator[$25a99ede456543b7$var$kError] = err;
            return;
        }
        var resolve = iterator[$25a99ede456543b7$var$kLastResolve];
        if (resolve !== null) {
            iterator[$25a99ede456543b7$var$kLastPromise] = null;
            iterator[$25a99ede456543b7$var$kLastResolve] = null;
            iterator[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        }
        iterator[$25a99ede456543b7$var$kEnded] = true;
    });
    stream.on("readable", $25a99ede456543b7$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $25a99ede456543b7$var$createReadableStreamAsyncIterator;

});
parcelRegister("hzqCm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("967Aq")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $ccaa5a4968d6bb28$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $ccaa5a4968d6bb28$var$noop() {}
function $ccaa5a4968d6bb28$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $ccaa5a4968d6bb28$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $ccaa5a4968d6bb28$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $ccaa5a4968d6bb28$var$once(callback || $ccaa5a4968d6bb28$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($ccaa5a4968d6bb28$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $ccaa5a4968d6bb28$var$eos;

});


parcelRegister("gN4Jr", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("k3Gr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $e9a50192eb9e2af9$var$Transform;

var $967Aq = parcelRequire("967Aq");
var $e9a50192eb9e2af9$require$_require$codes = $967Aq.codes;
var $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED = $e9a50192eb9e2af9$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK = $e9a50192eb9e2af9$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $fFuzr = parcelRequire("fFuzr");

(parcelRequire("dlqwk"))($e9a50192eb9e2af9$var$Transform, $fFuzr);
function $e9a50192eb9e2af9$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e9a50192eb9e2af9$var$Transform(options) {
    if (!(this instanceof $e9a50192eb9e2af9$var$Transform)) return new $e9a50192eb9e2af9$var$Transform(options);
    $fFuzr.call(this, options);
    this._transformState = {
        afterTransform: $e9a50192eb9e2af9$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $e9a50192eb9e2af9$var$prefinish);
}
function $e9a50192eb9e2af9$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $e9a50192eb9e2af9$var$done(_this, er, data);
    });
    else $e9a50192eb9e2af9$var$done(this, null, null);
}
$e9a50192eb9e2af9$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fFuzr.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e9a50192eb9e2af9$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$e9a50192eb9e2af9$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e9a50192eb9e2af9$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e9a50192eb9e2af9$var$Transform.prototype._destroy = function(err, cb) {
    $fFuzr.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e9a50192eb9e2af9$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6G2fH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $4dc8698e5416b71e$var$PassThrough;

var $k3Gr9 = parcelRequire("k3Gr9");

(parcelRequire("dlqwk"))($4dc8698e5416b71e$var$PassThrough, $k3Gr9);
function $4dc8698e5416b71e$var$PassThrough(options) {
    if (!(this instanceof $4dc8698e5416b71e$var$PassThrough)) return new $4dc8698e5416b71e$var$PassThrough(options);
    $k3Gr9.call(this, options);
}
$4dc8698e5416b71e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("coyuH", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $90627bba44315748$var$eos;
function $90627bba44315748$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $967Aq = parcelRequire("967Aq");
var $90627bba44315748$require$_require$codes = $967Aq.codes;
var $90627bba44315748$var$ERR_MISSING_ARGS = $90627bba44315748$require$_require$codes.ERR_MISSING_ARGS, $90627bba44315748$var$ERR_STREAM_DESTROYED = $90627bba44315748$require$_require$codes.ERR_STREAM_DESTROYED;
function $90627bba44315748$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $90627bba44315748$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $90627bba44315748$var$destroyer(stream, reading, writing, callback) {
    callback = $90627bba44315748$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($90627bba44315748$var$eos === undefined) $90627bba44315748$var$eos = (parcelRequire("hzqCm"));
    $90627bba44315748$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($90627bba44315748$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $90627bba44315748$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $90627bba44315748$var$call(fn) {
    fn();
}
function $90627bba44315748$var$pipe(from, to) {
    return from.pipe(to);
}
function $90627bba44315748$var$popCallback(streams) {
    if (!streams.length) return $90627bba44315748$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $90627bba44315748$var$noop;
    return streams.pop();
}
function $90627bba44315748$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $90627bba44315748$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $90627bba44315748$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $90627bba44315748$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($90627bba44315748$var$call);
            if (reading) return;
            destroys.forEach($90627bba44315748$var$call);
            callback(error);
        });
    });
    return streams.reduce($90627bba44315748$var$pipe);
}
module.exports = $90627bba44315748$var$pipeline;

});




parcelRegister("1iL1D", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $0f2bf322914b61b2$var$Hmac("rmd160", key);
    if (alg === "md5") return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});

parcelRegister("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split(".")[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $5130da986dd86f24$var$defaultEncoding = "utf-8";
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    digest = digest || "sha1";
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});



parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
"use strict";
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("enfpo", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("dB8Kv", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $dB8Kv.create({
            type: "encrypt",
            key: k1
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: "decrypt",
            key: k3
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});

parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("4kvQX"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("62Mby", function(module, exports) {

exports = module.exports = (parcelRequire("ijRUb"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("77F6W"));

exports.Duplex = (parcelRequire("gymWQ"));

exports.Transform = (parcelRequire("8hRuT"));

exports.PassThrough = (parcelRequire("fbZXo"));

exports.finished = (parcelRequire("3mcid"));

exports.pipeline = (parcelRequire("etwQ4"));

});
parcelRegister("ijRUb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $d563d0cdbeba3673$var$Readable;
/*<replacement>*/ var $d563d0cdbeba3673$var$Duplex;
/*</replacement>*/ $d563d0cdbeba3673$var$Readable.ReadableState = $d563d0cdbeba3673$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $d563d0cdbeba3673$require$EE = $7etJZ.EventEmitter;
var $d563d0cdbeba3673$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $7TavY = parcelRequire("7TavY");

var $6ZWSX = parcelRequire("6ZWSX");
var $d563d0cdbeba3673$require$Buffer = $6ZWSX.Buffer;
var $d563d0cdbeba3673$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $d563d0cdbeba3673$var$_uint8ArrayToBuffer(chunk) {
    return $d563d0cdbeba3673$require$Buffer.from(chunk);
}
function $d563d0cdbeba3673$var$_isUint8Array(obj) {
    return $d563d0cdbeba3673$require$Buffer.isBuffer(obj) || obj instanceof $d563d0cdbeba3673$var$OurUint8Array;
}

var $4kvQX = parcelRequire("4kvQX");
var $d563d0cdbeba3673$var$debug;
if ($4kvQX && $4kvQX.debuglog) $d563d0cdbeba3673$var$debug = $4kvQX.debuglog("stream");
else $d563d0cdbeba3673$var$debug = function debug() {};

var $l520z = parcelRequire("l520z");

var $dMA3M = parcelRequire("dMA3M");

var $jjqfv = parcelRequire("jjqfv");
var $d563d0cdbeba3673$var$getHighWaterMark = $jjqfv.getHighWaterMark;

var $juU80 = parcelRequire("juU80");
var $d563d0cdbeba3673$require$_require$codes = $juU80.codes;
var $d563d0cdbeba3673$var$ERR_INVALID_ARG_TYPE = $d563d0cdbeba3673$require$_require$codes.ERR_INVALID_ARG_TYPE, $d563d0cdbeba3673$var$ERR_STREAM_PUSH_AFTER_EOF = $d563d0cdbeba3673$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $d563d0cdbeba3673$var$ERR_METHOD_NOT_IMPLEMENTED = $d563d0cdbeba3673$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $d563d0cdbeba3673$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $d563d0cdbeba3673$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $d563d0cdbeba3673$var$StringDecoder;
var $d563d0cdbeba3673$var$createReadableStreamAsyncIterator;
var $d563d0cdbeba3673$var$from;

(parcelRequire("dlqwk"))($d563d0cdbeba3673$var$Readable, $7TavY);
var $d563d0cdbeba3673$var$errorOrDestroy = $dMA3M.errorOrDestroy;
var $d563d0cdbeba3673$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $d563d0cdbeba3673$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $d563d0cdbeba3673$var$ReadableState(options, stream, isDuplex) {
    $d563d0cdbeba3673$var$Duplex = $d563d0cdbeba3673$var$Duplex || (parcelRequire("gymWQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $d563d0cdbeba3673$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $d563d0cdbeba3673$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $l520z();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$d563d0cdbeba3673$var$StringDecoder) $d563d0cdbeba3673$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $d563d0cdbeba3673$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $d563d0cdbeba3673$var$Readable(options) {
    $d563d0cdbeba3673$var$Duplex = $d563d0cdbeba3673$var$Duplex || (parcelRequire("gymWQ"));
    if (!(this instanceof $d563d0cdbeba3673$var$Readable)) return new $d563d0cdbeba3673$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $d563d0cdbeba3673$var$Duplex;
    this._readableState = new $d563d0cdbeba3673$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $7TavY.call(this);
}
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$d563d0cdbeba3673$var$Readable.prototype.destroy = $dMA3M.destroy;
$d563d0cdbeba3673$var$Readable.prototype._undestroy = $dMA3M.undestroy;
$d563d0cdbeba3673$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$d563d0cdbeba3673$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $d563d0cdbeba3673$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $d563d0cdbeba3673$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$d563d0cdbeba3673$var$Readable.prototype.unshift = function(chunk) {
    return $d563d0cdbeba3673$var$readableAddChunk(this, chunk, null, true, false);
};
function $d563d0cdbeba3673$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $d563d0cdbeba3673$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $d563d0cdbeba3673$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $d563d0cdbeba3673$var$chunkInvalid(state, chunk);
        if (er) $d563d0cdbeba3673$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $d563d0cdbeba3673$require$Buffer.prototype) chunk = $d563d0cdbeba3673$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $d563d0cdbeba3673$var$errorOrDestroy(stream, new $d563d0cdbeba3673$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $d563d0cdbeba3673$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $d563d0cdbeba3673$var$errorOrDestroy(stream, new $d563d0cdbeba3673$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $d563d0cdbeba3673$var$addChunk(stream, state, chunk, false);
                    else $d563d0cdbeba3673$var$maybeReadMore(stream, state);
                } else $d563d0cdbeba3673$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $d563d0cdbeba3673$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $d563d0cdbeba3673$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $d563d0cdbeba3673$var$emitReadable(stream);
    }
    $d563d0cdbeba3673$var$maybeReadMore(stream, state);
}
function $d563d0cdbeba3673$var$chunkInvalid(state, chunk) {
    var er;
    if (!$d563d0cdbeba3673$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $d563d0cdbeba3673$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$d563d0cdbeba3673$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$d563d0cdbeba3673$var$Readable.prototype.setEncoding = function(enc) {
    if (!$d563d0cdbeba3673$var$StringDecoder) $d563d0cdbeba3673$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $d563d0cdbeba3673$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $d563d0cdbeba3673$var$MAX_HWM = 0x40000000;
function $d563d0cdbeba3673$var$computeNewHighWaterMark(n) {
    if (n >= $d563d0cdbeba3673$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $d563d0cdbeba3673$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $d563d0cdbeba3673$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$d563d0cdbeba3673$var$Readable.prototype.read = function(n) {
    $d563d0cdbeba3673$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $d563d0cdbeba3673$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $d563d0cdbeba3673$var$endReadable(this);
        else $d563d0cdbeba3673$var$emitReadable(this);
        return null;
    }
    n = $d563d0cdbeba3673$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $d563d0cdbeba3673$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $d563d0cdbeba3673$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $d563d0cdbeba3673$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $d563d0cdbeba3673$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $d563d0cdbeba3673$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $d563d0cdbeba3673$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $d563d0cdbeba3673$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $d563d0cdbeba3673$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $d563d0cdbeba3673$var$onEofChunk(stream, state) {
    $d563d0cdbeba3673$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $d563d0cdbeba3673$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $d563d0cdbeba3673$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $d563d0cdbeba3673$var$emitReadable(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $d563d0cdbeba3673$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$emitReadable_, stream);
    }
}
function $d563d0cdbeba3673$var$emitReadable_(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $d563d0cdbeba3673$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $d563d0cdbeba3673$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$maybeReadMore_, stream, state);
    }
}
function $d563d0cdbeba3673$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $d563d0cdbeba3673$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$d563d0cdbeba3673$var$Readable.prototype._read = function(n) {
    $d563d0cdbeba3673$var$errorOrDestroy(this, new $d563d0cdbeba3673$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$d563d0cdbeba3673$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $d563d0cdbeba3673$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $d563d0cdbeba3673$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $d563d0cdbeba3673$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $d563d0cdbeba3673$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $d563d0cdbeba3673$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $d563d0cdbeba3673$var$debug("ondata");
        var ret = dest.write(chunk);
        $d563d0cdbeba3673$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $d563d0cdbeba3673$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $d563d0cdbeba3673$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $d563d0cdbeba3673$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($d563d0cdbeba3673$var$EElistenerCount(dest, "error") === 0) $d563d0cdbeba3673$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $d563d0cdbeba3673$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $d563d0cdbeba3673$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $d563d0cdbeba3673$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $d563d0cdbeba3673$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $d563d0cdbeba3673$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $d563d0cdbeba3673$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $d563d0cdbeba3673$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $d563d0cdbeba3673$var$flow(src);
        }
    };
}
$d563d0cdbeba3673$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $d563d0cdbeba3673$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$d563d0cdbeba3673$var$Readable.prototype.on = function(ev, fn) {
    var res = $7TavY.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $d563d0cdbeba3673$var$debug("on readable", state.length, state.reading);
            if (state.length) $d563d0cdbeba3673$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($d563d0cdbeba3673$var$nReadingNextTick, this);
        }
    }
    return res;
};
$d563d0cdbeba3673$var$Readable.prototype.addListener = $d563d0cdbeba3673$var$Readable.prototype.on;
$d563d0cdbeba3673$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $7TavY.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($d563d0cdbeba3673$var$updateReadableListening, this);
    return res;
};
$d563d0cdbeba3673$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $7TavY.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($d563d0cdbeba3673$var$updateReadableListening, this);
    return res;
};
function $d563d0cdbeba3673$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $d563d0cdbeba3673$var$nReadingNextTick(self1) {
    $d563d0cdbeba3673$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$d563d0cdbeba3673$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $d563d0cdbeba3673$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $d563d0cdbeba3673$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $d563d0cdbeba3673$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$resume_, stream, state);
    }
}
function $d563d0cdbeba3673$var$resume_(stream, state) {
    $d563d0cdbeba3673$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $d563d0cdbeba3673$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$d563d0cdbeba3673$var$Readable.prototype.pause = function() {
    $d563d0cdbeba3673$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $d563d0cdbeba3673$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $d563d0cdbeba3673$var$flow(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$d563d0cdbeba3673$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $d563d0cdbeba3673$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $d563d0cdbeba3673$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $d563d0cdbeba3673$var$kProxyEvents.length; n++)stream.on($d563d0cdbeba3673$var$kProxyEvents[n], this.emit.bind(this, $d563d0cdbeba3673$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $d563d0cdbeba3673$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $d563d0cdbeba3673$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($d563d0cdbeba3673$var$createReadableStreamAsyncIterator === undefined) $d563d0cdbeba3673$var$createReadableStreamAsyncIterator = (parcelRequire("c6IHI"));
    return $d563d0cdbeba3673$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$d563d0cdbeba3673$var$Readable._fromList = $d563d0cdbeba3673$var$fromList;
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $d563d0cdbeba3673$var$endReadable(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$endReadableNT, state, stream);
    }
}
function $d563d0cdbeba3673$var$endReadableNT(state, stream) {
    $d563d0cdbeba3673$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $d563d0cdbeba3673$var$Readable.from = function(iterable, opts) {
    if ($d563d0cdbeba3673$var$from === undefined) $d563d0cdbeba3673$var$from = (parcelRequire("gSI6Z"));
    return $d563d0cdbeba3673$var$from($d563d0cdbeba3673$var$Readable, iterable, opts);
};
function $d563d0cdbeba3673$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("7TavY", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("l520z", function(module, exports) {
"use strict";
function $f58b9f61eb9af493$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f58b9f61eb9af493$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f58b9f61eb9af493$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f58b9f61eb9af493$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f58b9f61eb9af493$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f58b9f61eb9af493$var$_defineProperty(obj, key, value) {
    key = $f58b9f61eb9af493$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f58b9f61eb9af493$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f58b9f61eb9af493$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f58b9f61eb9af493$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f58b9f61eb9af493$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f58b9f61eb9af493$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f58b9f61eb9af493$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f58b9f61eb9af493$var$_toPropertyKey(arg) {
    var key = $f58b9f61eb9af493$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f58b9f61eb9af493$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $f58b9f61eb9af493$var$Buffer = $6ZWSX.Buffer;

var $4kvQX = parcelRequire("4kvQX");
var $f58b9f61eb9af493$var$inspect = $4kvQX.inspect;
var $f58b9f61eb9af493$var$custom = $f58b9f61eb9af493$var$inspect && $f58b9f61eb9af493$var$inspect.custom || "inspect";
function $f58b9f61eb9af493$var$copyBuffer(src, target, offset) {
    $f58b9f61eb9af493$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $f58b9f61eb9af493$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $f58b9f61eb9af493$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $f58b9f61eb9af493$var$Buffer.alloc(0);
                var ret = $f58b9f61eb9af493$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $f58b9f61eb9af493$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $f58b9f61eb9af493$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $f58b9f61eb9af493$var$custom,
            value: function value(_, options) {
                return $f58b9f61eb9af493$var$inspect(this, $f58b9f61eb9af493$var$_objectSpread($f58b9f61eb9af493$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("dMA3M", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $a08bbad2eabf9353$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($a08bbad2eabf9353$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($a08bbad2eabf9353$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($a08bbad2eabf9353$var$emitCloseNT, _this);
    });
    return this;
}
function $a08bbad2eabf9353$var$emitErrorAndCloseNT(self, err) {
    $a08bbad2eabf9353$var$emitErrorNT(self, err);
    $a08bbad2eabf9353$var$emitCloseNT(self);
}
function $a08bbad2eabf9353$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $a08bbad2eabf9353$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $a08bbad2eabf9353$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $a08bbad2eabf9353$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $a08bbad2eabf9353$var$destroy,
    undestroy: $a08bbad2eabf9353$var$undestroy,
    errorOrDestroy: $a08bbad2eabf9353$var$errorOrDestroy
};

});

parcelRegister("jjqfv", function(module, exports) {
"use strict";

var $e0f427330e62d0b4$var$ERR_INVALID_OPT_VALUE = (parcelRequire("juU80")).codes.ERR_INVALID_OPT_VALUE;
function $e0f427330e62d0b4$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $e0f427330e62d0b4$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $e0f427330e62d0b4$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $e0f427330e62d0b4$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $e0f427330e62d0b4$var$getHighWaterMark
};

});
parcelRegister("juU80", function(module, exports) {

$parcel$export(module.exports, "codes", () => $e31c5b8dd6d6ccf7$export$e45cb6485273080e, (v) => $e31c5b8dd6d6ccf7$export$e45cb6485273080e = v);
var $e31c5b8dd6d6ccf7$export$e45cb6485273080e;
"use strict";
function $e31c5b8dd6d6ccf7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $e31c5b8dd6d6ccf7$var$codes = {};
function $e31c5b8dd6d6ccf7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $e31c5b8dd6d6ccf7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $e31c5b8dd6d6ccf7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $e31c5b8dd6d6ccf7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $e31c5b8dd6d6ccf7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $e31c5b8dd6d6ccf7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $e31c5b8dd6d6ccf7$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $e31c5b8dd6d6ccf7$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($e31c5b8dd6d6ccf7$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($e31c5b8dd6d6ccf7$var$oneOf(expected, "type"));
    else {
        var type = $e31c5b8dd6d6ccf7$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($e31c5b8dd6d6ccf7$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$e31c5b8dd6d6ccf7$export$e45cb6485273080e = $e31c5b8dd6d6ccf7$var$codes;

});


parcelRegister("gymWQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $c0d19f59fee501bd$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $c0d19f59fee501bd$var$Duplex;

var $ijRUb = parcelRequire("ijRUb");

var $77F6W = parcelRequire("77F6W");

(parcelRequire("dlqwk"))($c0d19f59fee501bd$var$Duplex, $ijRUb);
// Allow the keys array to be GC'ed.
var $c0d19f59fee501bd$var$keys = $c0d19f59fee501bd$var$objectKeys($77F6W.prototype);
for(var $c0d19f59fee501bd$var$v = 0; $c0d19f59fee501bd$var$v < $c0d19f59fee501bd$var$keys.length; $c0d19f59fee501bd$var$v++){
    var $c0d19f59fee501bd$var$method = $c0d19f59fee501bd$var$keys[$c0d19f59fee501bd$var$v];
    if (!$c0d19f59fee501bd$var$Duplex.prototype[$c0d19f59fee501bd$var$method]) $c0d19f59fee501bd$var$Duplex.prototype[$c0d19f59fee501bd$var$method] = $77F6W.prototype[$c0d19f59fee501bd$var$method];
}
function $c0d19f59fee501bd$var$Duplex(options) {
    if (!(this instanceof $c0d19f59fee501bd$var$Duplex)) return new $c0d19f59fee501bd$var$Duplex(options);
    $ijRUb.call(this, options);
    $77F6W.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $c0d19f59fee501bd$var$onend);
        }
    }
}
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $c0d19f59fee501bd$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($c0d19f59fee501bd$var$onEndNT, this);
}
function $c0d19f59fee501bd$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("77F6W", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $52f9139fc7db56d4$var$Writable;
/* <replacement> */ function $52f9139fc7db56d4$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $52f9139fc7db56d4$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $52f9139fc7db56d4$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $52f9139fc7db56d4$var$Duplex;
/*</replacement>*/ $52f9139fc7db56d4$var$Writable.WritableState = $52f9139fc7db56d4$var$WritableState;

/*<replacement>*/ var $52f9139fc7db56d4$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $7TavY = parcelRequire("7TavY");

var $6ZWSX = parcelRequire("6ZWSX");
var $52f9139fc7db56d4$require$Buffer = $6ZWSX.Buffer;
var $52f9139fc7db56d4$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $52f9139fc7db56d4$var$_uint8ArrayToBuffer(chunk) {
    return $52f9139fc7db56d4$require$Buffer.from(chunk);
}
function $52f9139fc7db56d4$var$_isUint8Array(obj) {
    return $52f9139fc7db56d4$require$Buffer.isBuffer(obj) || obj instanceof $52f9139fc7db56d4$var$OurUint8Array;
}

var $dMA3M = parcelRequire("dMA3M");

var $jjqfv = parcelRequire("jjqfv");
var $52f9139fc7db56d4$var$getHighWaterMark = $jjqfv.getHighWaterMark;

var $juU80 = parcelRequire("juU80");
var $52f9139fc7db56d4$require$_require$codes = $juU80.codes;
var $52f9139fc7db56d4$var$ERR_INVALID_ARG_TYPE = $52f9139fc7db56d4$require$_require$codes.ERR_INVALID_ARG_TYPE, $52f9139fc7db56d4$var$ERR_METHOD_NOT_IMPLEMENTED = $52f9139fc7db56d4$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $52f9139fc7db56d4$var$ERR_MULTIPLE_CALLBACK = $52f9139fc7db56d4$require$_require$codes.ERR_MULTIPLE_CALLBACK, $52f9139fc7db56d4$var$ERR_STREAM_CANNOT_PIPE = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $52f9139fc7db56d4$var$ERR_STREAM_DESTROYED = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_DESTROYED, $52f9139fc7db56d4$var$ERR_STREAM_NULL_VALUES = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_NULL_VALUES, $52f9139fc7db56d4$var$ERR_STREAM_WRITE_AFTER_END = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $52f9139fc7db56d4$var$ERR_UNKNOWN_ENCODING = $52f9139fc7db56d4$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $52f9139fc7db56d4$var$errorOrDestroy = $dMA3M.errorOrDestroy;

(parcelRequire("dlqwk"))($52f9139fc7db56d4$var$Writable, $7TavY);
function $52f9139fc7db56d4$var$nop() {}

function $52f9139fc7db56d4$var$WritableState(options, stream, isDuplex) {
    $52f9139fc7db56d4$var$Duplex = $52f9139fc7db56d4$var$Duplex || (parcelRequire("gymWQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $52f9139fc7db56d4$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $52f9139fc7db56d4$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $52f9139fc7db56d4$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $52f9139fc7db56d4$var$CorkedRequest(this);
}
$52f9139fc7db56d4$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($52f9139fc7db56d4$var$WritableState.prototype, "buffer", {
            get: $52f9139fc7db56d4$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $52f9139fc7db56d4$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $52f9139fc7db56d4$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($52f9139fc7db56d4$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($52f9139fc7db56d4$var$realHasInstance.call(this, object)) return true;
            if (this !== $52f9139fc7db56d4$var$Writable) return false;
            return object && object._writableState instanceof $52f9139fc7db56d4$var$WritableState;
        }
    });
} else $52f9139fc7db56d4$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $52f9139fc7db56d4$var$Writable(options) {
    $52f9139fc7db56d4$var$Duplex = $52f9139fc7db56d4$var$Duplex || (parcelRequire("gymWQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $52f9139fc7db56d4$var$Duplex;
    if (!isDuplex && !$52f9139fc7db56d4$var$realHasInstance.call($52f9139fc7db56d4$var$Writable, this)) return new $52f9139fc7db56d4$var$Writable(options);
    this._writableState = new $52f9139fc7db56d4$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $7TavY.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$52f9139fc7db56d4$var$Writable.prototype.pipe = function() {
    $52f9139fc7db56d4$var$errorOrDestroy(this, new $52f9139fc7db56d4$var$ERR_STREAM_CANNOT_PIPE());
};
function $52f9139fc7db56d4$var$writeAfterEnd(stream, cb) {
    var er = new $52f9139fc7db56d4$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $52f9139fc7db56d4$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $52f9139fc7db56d4$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $52f9139fc7db56d4$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$52f9139fc7db56d4$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $52f9139fc7db56d4$var$_isUint8Array(chunk);
    if (isBuf && !$52f9139fc7db56d4$require$Buffer.isBuffer(chunk)) chunk = $52f9139fc7db56d4$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $52f9139fc7db56d4$var$nop;
    if (state.ending) $52f9139fc7db56d4$var$writeAfterEnd(this, cb);
    else if (isBuf || $52f9139fc7db56d4$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $52f9139fc7db56d4$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$52f9139fc7db56d4$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$52f9139fc7db56d4$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $52f9139fc7db56d4$var$clearBuffer(this, state);
    }
};
$52f9139fc7db56d4$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $52f9139fc7db56d4$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $52f9139fc7db56d4$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $52f9139fc7db56d4$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $52f9139fc7db56d4$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $52f9139fc7db56d4$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $52f9139fc7db56d4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $52f9139fc7db56d4$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $52f9139fc7db56d4$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $52f9139fc7db56d4$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($52f9139fc7db56d4$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $52f9139fc7db56d4$var$finishMaybe(stream, state);
    }
}
function $52f9139fc7db56d4$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $52f9139fc7db56d4$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $52f9139fc7db56d4$var$ERR_MULTIPLE_CALLBACK();
    $52f9139fc7db56d4$var$onwriteStateUpdate(state);
    if (er) $52f9139fc7db56d4$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $52f9139fc7db56d4$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $52f9139fc7db56d4$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($52f9139fc7db56d4$var$afterWrite, stream, state, finished, cb);
        else $52f9139fc7db56d4$var$afterWrite(stream, state, finished, cb);
    }
}
function $52f9139fc7db56d4$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $52f9139fc7db56d4$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $52f9139fc7db56d4$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $52f9139fc7db56d4$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $52f9139fc7db56d4$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $52f9139fc7db56d4$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $52f9139fc7db56d4$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $52f9139fc7db56d4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$52f9139fc7db56d4$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $52f9139fc7db56d4$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$52f9139fc7db56d4$var$Writable.prototype._writev = null;
$52f9139fc7db56d4$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $52f9139fc7db56d4$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $52f9139fc7db56d4$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $52f9139fc7db56d4$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $52f9139fc7db56d4$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $52f9139fc7db56d4$var$finishMaybe(stream, state);
    });
}
function $52f9139fc7db56d4$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($52f9139fc7db56d4$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $52f9139fc7db56d4$var$finishMaybe(stream, state) {
    var need = $52f9139fc7db56d4$var$needFinish(state);
    if (need) {
        $52f9139fc7db56d4$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $52f9139fc7db56d4$var$endWritable(stream, state, cb) {
    state.ending = true;
    $52f9139fc7db56d4$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $52f9139fc7db56d4$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$52f9139fc7db56d4$var$Writable.prototype.destroy = $dMA3M.destroy;
$52f9139fc7db56d4$var$Writable.prototype._undestroy = $dMA3M.undestroy;
$52f9139fc7db56d4$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRegister("c6IHI", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $8d08b8e50a33e6d4$var$_Object$setPrototypeO;
function $8d08b8e50a33e6d4$var$_defineProperty(obj, key, value) {
    key = $8d08b8e50a33e6d4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8d08b8e50a33e6d4$var$_toPropertyKey(arg) {
    var key = $8d08b8e50a33e6d4$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8d08b8e50a33e6d4$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $3mcid = parcelRequire("3mcid");
var $8d08b8e50a33e6d4$var$kLastResolve = Symbol("lastResolve");
var $8d08b8e50a33e6d4$var$kLastReject = Symbol("lastReject");
var $8d08b8e50a33e6d4$var$kError = Symbol("error");
var $8d08b8e50a33e6d4$var$kEnded = Symbol("ended");
var $8d08b8e50a33e6d4$var$kLastPromise = Symbol("lastPromise");
var $8d08b8e50a33e6d4$var$kHandlePromise = Symbol("handlePromise");
var $8d08b8e50a33e6d4$var$kStream = Symbol("stream");
function $8d08b8e50a33e6d4$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $8d08b8e50a33e6d4$var$readAndResolve(iter) {
    var resolve = iter[$8d08b8e50a33e6d4$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$8d08b8e50a33e6d4$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$8d08b8e50a33e6d4$var$kLastPromise] = null;
            iter[$8d08b8e50a33e6d4$var$kLastResolve] = null;
            iter[$8d08b8e50a33e6d4$var$kLastReject] = null;
            resolve($8d08b8e50a33e6d4$var$createIterResult(data, false));
        }
    }
}
function $8d08b8e50a33e6d4$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($8d08b8e50a33e6d4$var$readAndResolve, iter);
}
function $8d08b8e50a33e6d4$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$8d08b8e50a33e6d4$var$kEnded]) {
                resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
                return;
            }
            iter[$8d08b8e50a33e6d4$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $8d08b8e50a33e6d4$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $8d08b8e50a33e6d4$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($8d08b8e50a33e6d4$var$_Object$setPrototypeO = {
    get stream () {
        return this[$8d08b8e50a33e6d4$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$8d08b8e50a33e6d4$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$8d08b8e50a33e6d4$var$kEnded]) return Promise.resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
        if (this[$8d08b8e50a33e6d4$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$8d08b8e50a33e6d4$var$kError]) reject(_this[$8d08b8e50a33e6d4$var$kError]);
                else resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$8d08b8e50a33e6d4$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($8d08b8e50a33e6d4$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$8d08b8e50a33e6d4$var$kStream].read();
            if (data !== null) return Promise.resolve($8d08b8e50a33e6d4$var$createIterResult(data, false));
            promise = new Promise(this[$8d08b8e50a33e6d4$var$kHandlePromise]);
        }
        this[$8d08b8e50a33e6d4$var$kLastPromise] = promise;
        return promise;
    }
}, $8d08b8e50a33e6d4$var$_defineProperty($8d08b8e50a33e6d4$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $8d08b8e50a33e6d4$var$_defineProperty($8d08b8e50a33e6d4$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$8d08b8e50a33e6d4$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
        });
    });
}), $8d08b8e50a33e6d4$var$_Object$setPrototypeO), $8d08b8e50a33e6d4$var$AsyncIteratorPrototype);
var $8d08b8e50a33e6d4$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($8d08b8e50a33e6d4$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kStream, {
        value: stream,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kLastResolve, {
        value: null,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kLastReject, {
        value: null,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kError, {
        value: null,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$8d08b8e50a33e6d4$var$kStream].read();
            if (data) {
                iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastResolve] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastReject] = null;
                resolve($8d08b8e50a33e6d4$var$createIterResult(data, false));
            } else {
                iterator[$8d08b8e50a33e6d4$var$kLastResolve] = resolve;
                iterator[$8d08b8e50a33e6d4$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
    $3mcid(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$8d08b8e50a33e6d4$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastResolve] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastReject] = null;
                reject(err);
            }
            iterator[$8d08b8e50a33e6d4$var$kError] = err;
            return;
        }
        var resolve = iterator[$8d08b8e50a33e6d4$var$kLastResolve];
        if (resolve !== null) {
            iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
            iterator[$8d08b8e50a33e6d4$var$kLastResolve] = null;
            iterator[$8d08b8e50a33e6d4$var$kLastReject] = null;
            resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
        }
        iterator[$8d08b8e50a33e6d4$var$kEnded] = true;
    });
    stream.on("readable", $8d08b8e50a33e6d4$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $8d08b8e50a33e6d4$var$createReadableStreamAsyncIterator;

});
parcelRegister("3mcid", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $271cf646c183c13f$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("juU80")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $271cf646c183c13f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $271cf646c183c13f$var$noop() {}
function $271cf646c183c13f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $271cf646c183c13f$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $271cf646c183c13f$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $271cf646c183c13f$var$once(callback || $271cf646c183c13f$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $271cf646c183c13f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $271cf646c183c13f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($271cf646c183c13f$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $271cf646c183c13f$var$eos;

});


parcelRegister("gSI6Z", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("8hRuT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $608968b8987d674a$var$Transform;

var $juU80 = parcelRequire("juU80");
var $608968b8987d674a$require$_require$codes = $juU80.codes;
var $608968b8987d674a$var$ERR_METHOD_NOT_IMPLEMENTED = $608968b8987d674a$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $608968b8987d674a$var$ERR_MULTIPLE_CALLBACK = $608968b8987d674a$require$_require$codes.ERR_MULTIPLE_CALLBACK, $608968b8987d674a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $608968b8987d674a$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $608968b8987d674a$var$ERR_TRANSFORM_WITH_LENGTH_0 = $608968b8987d674a$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $gymWQ = parcelRequire("gymWQ");

(parcelRequire("dlqwk"))($608968b8987d674a$var$Transform, $gymWQ);
function $608968b8987d674a$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $608968b8987d674a$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $608968b8987d674a$var$Transform(options) {
    if (!(this instanceof $608968b8987d674a$var$Transform)) return new $608968b8987d674a$var$Transform(options);
    $gymWQ.call(this, options);
    this._transformState = {
        afterTransform: $608968b8987d674a$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $608968b8987d674a$var$prefinish);
}
function $608968b8987d674a$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $608968b8987d674a$var$done(_this, er, data);
    });
    else $608968b8987d674a$var$done(this, null, null);
}
$608968b8987d674a$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $gymWQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$608968b8987d674a$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $608968b8987d674a$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$608968b8987d674a$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$608968b8987d674a$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$608968b8987d674a$var$Transform.prototype._destroy = function(err, cb) {
    $gymWQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $608968b8987d674a$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $608968b8987d674a$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $608968b8987d674a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("fbZXo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $b0f7f16f37d01e98$var$PassThrough;

var $8hRuT = parcelRequire("8hRuT");

(parcelRequire("dlqwk"))($b0f7f16f37d01e98$var$PassThrough, $8hRuT);
function $b0f7f16f37d01e98$var$PassThrough(options) {
    if (!(this instanceof $b0f7f16f37d01e98$var$PassThrough)) return new $b0f7f16f37d01e98$var$PassThrough(options);
    $8hRuT.call(this, options);
}
$b0f7f16f37d01e98$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("etwQ4", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $a89d3f3581dab9ef$var$eos;
function $a89d3f3581dab9ef$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $juU80 = parcelRequire("juU80");
var $a89d3f3581dab9ef$require$_require$codes = $juU80.codes;
var $a89d3f3581dab9ef$var$ERR_MISSING_ARGS = $a89d3f3581dab9ef$require$_require$codes.ERR_MISSING_ARGS, $a89d3f3581dab9ef$var$ERR_STREAM_DESTROYED = $a89d3f3581dab9ef$require$_require$codes.ERR_STREAM_DESTROYED;
function $a89d3f3581dab9ef$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $a89d3f3581dab9ef$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $a89d3f3581dab9ef$var$destroyer(stream, reading, writing, callback) {
    callback = $a89d3f3581dab9ef$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($a89d3f3581dab9ef$var$eos === undefined) $a89d3f3581dab9ef$var$eos = (parcelRequire("3mcid"));
    $a89d3f3581dab9ef$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($a89d3f3581dab9ef$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $a89d3f3581dab9ef$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $a89d3f3581dab9ef$var$call(fn) {
    fn();
}
function $a89d3f3581dab9ef$var$pipe(from, to) {
    return from.pipe(to);
}
function $a89d3f3581dab9ef$var$popCallback(streams) {
    if (!streams.length) return $a89d3f3581dab9ef$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $a89d3f3581dab9ef$var$noop;
    return streams.pop();
}
function $a89d3f3581dab9ef$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $a89d3f3581dab9ef$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $a89d3f3581dab9ef$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $a89d3f3581dab9ef$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($a89d3f3581dab9ef$var$call);
            if (reading) return;
            destroys.forEach($a89d3f3581dab9ef$var$call);
            callback(error);
        });
    });
    return streams.reduce($a89d3f3581dab9ef$var$pipe);
}
module.exports = $a89d3f3581dab9ef$var$pipeline;

});


parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("gEVtY", function(module, exports) {
"use strict";
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $c20cf89948514165$var$utils.toArray(bytes, "hex") : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, "hex", "le");
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lC4vN", function(module, exports) {
"use strict";
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("cP1GP", function(module, exports) {
"use strict";
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, "short", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, "mont", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, "edwards", conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
"use strict";
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cP1GP.short(options);
    else if (options.type === "edwards") this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), "Invalid curve");
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$b0f2b206068f1378$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$b0f2b206068f1378$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$b0f2b206068f1378$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$b0f2b206068f1378$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRegister("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), "Unknown curve " + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $jX0xT(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $jX0xT(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("kKonu", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $lC4vN.toArray(options.pers, options.persEnc || "hex");
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fe42f8d68750188b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fe42f8d68750188b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("i46nc", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair is public only");
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});


parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {
"use strict";

var $ljw8S = parcelRequire("ljw8S");

var $89TTw = parcelRequire("89TTw");

var $dlqwk = parcelRequire("dlqwk");
const $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $dlqwk(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($89TTw[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($ljw8S[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("ljw8S", function(module, exports) {
"use strict";
const $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $1ae2666fc718ae87$require$Buffer = $5ZrzL.Buffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $h4y6g);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $1ae2666fc718ae87$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $1ae2666fc718ae87$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $1ae2666fc718ae87$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $1ae2666fc718ae87$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $1ae2666fc718ae87$require$Buffer.from(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $1ae2666fc718ae87$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($1ae2666fc718ae87$require$Buffer.from(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1G1m0.tagByName.hasOwnProperty(tag)) res = $1G1m0.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1G1m0.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("5ZrzL", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $45c80a3e8b7e5b65$var$Buffer = $6ZWSX.Buffer;
var $45c80a3e8b7e5b65$var$safer = {};
var $45c80a3e8b7e5b65$var$key;
for($45c80a3e8b7e5b65$var$key in $6ZWSX){
    if (!$6ZWSX.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "SlowBuffer" || $45c80a3e8b7e5b65$var$key === "Buffer") continue;
    $45c80a3e8b7e5b65$var$safer[$45c80a3e8b7e5b65$var$key] = $6ZWSX[$45c80a3e8b7e5b65$var$key];
}
var $45c80a3e8b7e5b65$var$Safer = $45c80a3e8b7e5b65$var$safer.Buffer = {};
for($45c80a3e8b7e5b65$var$key in $45c80a3e8b7e5b65$var$Buffer){
    if (!$45c80a3e8b7e5b65$var$Buffer.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "allocUnsafe" || $45c80a3e8b7e5b65$var$key === "allocUnsafeSlow") continue;
    $45c80a3e8b7e5b65$var$Safer[$45c80a3e8b7e5b65$var$key] = $45c80a3e8b7e5b65$var$Buffer[$45c80a3e8b7e5b65$var$key];
}
$45c80a3e8b7e5b65$var$safer.Buffer.prototype = $45c80a3e8b7e5b65$var$Buffer.prototype;
if (!$45c80a3e8b7e5b65$var$Safer.from || $45c80a3e8b7e5b65$var$Safer.from === Uint8Array.from) $45c80a3e8b7e5b65$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $45c80a3e8b7e5b65$var$Buffer(value, encodingOrOffset, length);
};
if (!$45c80a3e8b7e5b65$var$Safer.alloc) $45c80a3e8b7e5b65$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $45c80a3e8b7e5b65$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$45c80a3e8b7e5b65$var$safer.kStringMaxLength) try {
    $45c80a3e8b7e5b65$var$safer.kStringMaxLength = $hPtJY.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$45c80a3e8b7e5b65$var$safer.constants) {
    $45c80a3e8b7e5b65$var$safer.constants = {
        MAX_LENGTH: $45c80a3e8b7e5b65$var$safer.kMaxLength
    };
    if ($45c80a3e8b7e5b65$var$safer.kStringMaxLength) $45c80a3e8b7e5b65$var$safer.constants.MAX_STRING_LENGTH = $45c80a3e8b7e5b65$var$safer.kStringMaxLength;
}
module.exports = $45c80a3e8b7e5b65$var$safer;

});

parcelRegister("h4y6g", function(module, exports) {
"use strict";

var $k2jVB = parcelRequire("k2jVB");
var $c6dd42f3395d566f$require$Reporter = $k2jVB.Reporter;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$EncoderBuffer = $33sbF.EncoderBuffer;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
const $c6dd42f3395d566f$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $c6dd42f3395d566f$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
const $c6dd42f3395d566f$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c6dd42f3395d566f$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
const $c6dd42f3395d566f$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, "Root node can have only one child");
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    const state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $koC21(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $koC21(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;
"use strict";

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $k2jVB = parcelRequire("k2jVB");
var $2397844df508f52e$require$Reporter = $k2jVB.Reporter;

var $5ZrzL = parcelRequire("5ZrzL");
var $2397844df508f52e$require$Buffer = $5ZrzL.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $2397844df508f52e$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer(item)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $2397844df508f52e$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;
"use strict";
// Helper
function $138ac3909863432c$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$138ac3909863432c$export$f18596ef8d632e49 = $138ac3909863432c$var$reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$138ac3909863432c$export$f17df38a421ab9e3 = $138ac3909863432c$var$reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("bPffB", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = "pem";
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $2j6ve.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("89TTw", function(module, exports) {
"use strict";
const $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $9qVGS = parcelRequire("9qVGS");

var $33sbF = parcelRequire("33sbF");
var $b28be291c8d179e1$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$b28be291c8d179e1$require$DecoderBuffer.isDecoderBuffer(data)) data = new $b28be291c8d179e1$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $h4y6g);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $9qVGS(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $1G1m0.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $1G1m0.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $6ef8062b6cdbe0f4$require$Buffer = $5ZrzL.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = "pem";
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $6ef8062b6cdbe0f4$require$Buffer.from(base64, "base64");
    return $fkoHA.prototype.decode.call(this, input, options);
};

});



parcelRegister("5JhaY", function(module, exports) {
"use strict";
const $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});

parcelRegister("3TcQc", function(module, exports) {
"use strict";
const $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});

parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define("RelativeDistinguishedName", function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define("RDNSequence", function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define("Name", function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($877bcccea3fc6be5$var$Time), this.key("notAfter").use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("issuer").use($877bcccea3fc6be5$var$Name), this.key("validity").use($877bcccea3fc6be5$var$Validity), this.key("subject").use($877bcccea3fc6be5$var$Name), this.key("subjectPublicKeyInfo").use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($877bcccea3fc6be5$var$TBSCertificate), this.key("signatureAlgorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});
parcelRegister("10gXo", function(module, exports) {
"use strict";
const $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});


parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("1zUcV", function(module, exports) {
"use strict";
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});

parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7("sha1").update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("aNeDF", function(module, exports) {

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
module.exports = $7db9d5f82e4113aa$var$parseKeys;
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fC6a8.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fC6a8.EncryptedPrivateKey.decode(data, "der");
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fC6a8.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fC6a8.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fC6a8.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fC6a8.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fC6a8.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
"use strict";

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define("DSAparam", function() {
    this.int();
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});

parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("3ILSx", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], "hex");
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});

parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv, true);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});



parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});


parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});

parcelRegister("3Sg1O", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d22d91c93a13ae5$require$Buffer = $6ZWSX.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, "be", len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7("sha1").update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("7we3r", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;
// Factory for creating new instances
$57966c7e0affc4cb$var$axios.create = function create(instanceConfig) {
    return $57966c7e0affc4cb$var$createInstance($lk5EI($57966c7e0affc4cb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
"use strict";

var $jJbMR = parcelRequire("jJbMR");
// utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM
};

});
parcelRegister("jJbMR", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $bv3QM = parcelRequire("bv3QM");
var $a93486d2307f31c3$var$validators = $bv3QM.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $bv3QM.assertOptions(transitional, {
        silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $dlZEJ,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $dlZEJ(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($gKvUL.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + "=" + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $lJY4v;
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("lJY4v", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");

var $8v8A7 = parcelRequire("8v8A7");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
function $fd3c65eeb28abd71$var$stringifySafely(rawValue, parser, encoder) {
    if ($gKvUL.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $gKvUL.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $fd3c65eeb28abd71$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, "Accept");
            $kiL6T(headers, "Content-Type");
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($gKvUL.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/json");
                return $fd3c65eeb28abd71$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $gKvUL.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $8v8A7(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$fd3c65eeb28abd71$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$gKvUL.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRegister("kiL6T", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("8v8A7", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("at5cb", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($gKvUL.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
"use strict";

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("kjF3e", function(module, exports) {
"use strict";

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});


parcelRegister("8JRzs", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push("path=" + path);
            if ($gKvUL.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7GD7a", function(module, exports) {
"use strict";

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("7L4QX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("lk5EI", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $gKvUL.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $gKvUL.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $gKvUL.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $gKvUL.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $gKvUL.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("bv3QM", function(module, exports) {
"use strict";

var $bgdCC = parcelRequire("bgdCC");
var $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $85f59389941e7907$var$deprecatedWarnings = {};
var $85f59389941e7907$var$currentVerArr = $bgdCC.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $85f59389941e7907$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $85f59389941e7907$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $85f59389941e7907$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $bgdCC.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $85f59389941e7907$var$isOlderVersion,
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("bgdCC", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRegister("4Tkeq", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});

parcelRegister("lAKPy", function(module, exports) {
"use strict";

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dxy9O", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});


parcelRegister("9XjZK", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $73f922543d406108$export$2b8d127b894957b9, (v) => $73f922543d406108$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $73f922543d406108$export$cea3a54a6425200c, (v) => $73f922543d406108$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $73f922543d406108$export$a7c73072b1a182ae, (v) => $73f922543d406108$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $73f922543d406108$export$9f27bc3417b4524d, (v) => $73f922543d406108$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $73f922543d406108$export$db77ccec0bb4ccac, (v) => $73f922543d406108$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $73f922543d406108$export$8392c0c9d3dcbd35, (v) => $73f922543d406108$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $73f922543d406108$export$ffb0004e005737fa, (v) => $73f922543d406108$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $73f922543d406108$export$b624eff549462981, (v) => $73f922543d406108$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $73f922543d406108$export$7897aa7841a5380c, (v) => $73f922543d406108$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $73f922543d406108$export$602eac185826482c, (v) => $73f922543d406108$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $73f922543d406108$export$e2c29f18771995cb, (v) => $73f922543d406108$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $73f922543d406108$export$5f8d39834fd61797, (v) => $73f922543d406108$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $73f922543d406108$export$74bf444e3cd11ea5, (v) => $73f922543d406108$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $73f922543d406108$export$92387174baf9b227, (v) => $73f922543d406108$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $73f922543d406108$export$ec112efeb987d9c6, (v) => $73f922543d406108$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $73f922543d406108$export$b706b080d889d2c9, (v) => $73f922543d406108$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $73f922543d406108$export$5be5a87408f70ddc, (v) => $73f922543d406108$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $73f922543d406108$export$45a5e7f76e0caa8d, (v) => $73f922543d406108$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $73f922543d406108$export$455c2e768291efa6, (v) => $73f922543d406108$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $73f922543d406108$export$9522e17588c12572, (v) => $73f922543d406108$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $73f922543d406108$export$2110ac352bb060b9, (v) => $73f922543d406108$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $73f922543d406108$export$56885ab8b9c456ab, (v) => $73f922543d406108$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $73f922543d406108$export$d927fcb6adf8f9de, (v) => $73f922543d406108$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $73f922543d406108$export$b82d16f27459e05a, (v) => $73f922543d406108$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $73f922543d406108$export$522c17b4f5e123e8, (v) => $73f922543d406108$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $73f922543d406108$export$1aabd8a0274ecfd6, (v) => $73f922543d406108$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $73f922543d406108$export$9b621391a187a31a, (v) => $73f922543d406108$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $73f922543d406108$export$f5bbd400c2f4426f, (v) => $73f922543d406108$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $73f922543d406108$export$2b8d127b894957b9;
var $73f922543d406108$export$cea3a54a6425200c;
var $73f922543d406108$export$a7c73072b1a182ae;
var $73f922543d406108$export$9f27bc3417b4524d;
var $73f922543d406108$export$db77ccec0bb4ccac;
var $73f922543d406108$export$8392c0c9d3dcbd35;
var $73f922543d406108$export$ffb0004e005737fa;
var $73f922543d406108$export$b624eff549462981;
var $73f922543d406108$export$7897aa7841a5380c;
var $73f922543d406108$export$602eac185826482c;
var $73f922543d406108$export$e2c29f18771995cb;
var $73f922543d406108$export$5f8d39834fd61797;
var $73f922543d406108$export$74bf444e3cd11ea5;
var $73f922543d406108$export$92387174baf9b227;
var $73f922543d406108$export$ec112efeb987d9c6;
var $73f922543d406108$export$b706b080d889d2c9;
var $73f922543d406108$export$5be5a87408f70ddc;
var $73f922543d406108$export$45a5e7f76e0caa8d;
var $73f922543d406108$export$455c2e768291efa6;
var $73f922543d406108$export$9522e17588c12572;
var $73f922543d406108$export$2110ac352bb060b9;
var $73f922543d406108$export$56885ab8b9c456ab;
var $73f922543d406108$export$d927fcb6adf8f9de;
var $73f922543d406108$export$b82d16f27459e05a;
var $73f922543d406108$export$522c17b4f5e123e8;
var $73f922543d406108$export$1aabd8a0274ecfd6;
var $73f922543d406108$export$9b621391a187a31a;
var $73f922543d406108$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $73f922543d406108$export$2b8d127b894957b9 = AsyncMode;
    $73f922543d406108$export$cea3a54a6425200c = ConcurrentMode;
    $73f922543d406108$export$a7c73072b1a182ae = ContextConsumer;
    $73f922543d406108$export$9f27bc3417b4524d = ContextProvider;
    $73f922543d406108$export$db77ccec0bb4ccac = Element;
    $73f922543d406108$export$8392c0c9d3dcbd35 = ForwardRef;
    $73f922543d406108$export$ffb0004e005737fa = Fragment;
    $73f922543d406108$export$b624eff549462981 = Lazy;
    $73f922543d406108$export$7897aa7841a5380c = Memo;
    $73f922543d406108$export$602eac185826482c = Portal;
    $73f922543d406108$export$e2c29f18771995cb = Profiler;
    $73f922543d406108$export$5f8d39834fd61797 = StrictMode;
    $73f922543d406108$export$74bf444e3cd11ea5 = Suspense;
    $73f922543d406108$export$92387174baf9b227 = isAsyncMode;
    $73f922543d406108$export$ec112efeb987d9c6 = isConcurrentMode;
    $73f922543d406108$export$b706b080d889d2c9 = isContextConsumer;
    $73f922543d406108$export$5be5a87408f70ddc = isContextProvider;
    $73f922543d406108$export$45a5e7f76e0caa8d = isElement;
    $73f922543d406108$export$455c2e768291efa6 = isForwardRef;
    $73f922543d406108$export$9522e17588c12572 = isFragment;
    $73f922543d406108$export$2110ac352bb060b9 = isLazy;
    $73f922543d406108$export$56885ab8b9c456ab = isMemo;
    $73f922543d406108$export$d927fcb6adf8f9de = isPortal;
    $73f922543d406108$export$b82d16f27459e05a = isProfiler;
    $73f922543d406108$export$522c17b4f5e123e8 = isStrictMode;
    $73f922543d406108$export$1aabd8a0274ecfd6 = isSuspense;
    $73f922543d406108$export$9b621391a187a31a = isValidElementType;
    $73f922543d406108$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("eGxWZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $k8nJx = parcelRequire("k8nJx");

var $8coUR = parcelRequire("8coUR");

var $kZO5c = parcelRequire("kZO5c");

var $fQsEq = parcelRequire("fQsEq");

var $gwROR = parcelRequire("gwROR");
var $ab0f52c9db6f842e$var$printWarning = function() {};
$ab0f52c9db6f842e$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $kZO5c) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else if (typeof console !== "undefined") {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ":" + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $ab0f52c9db6f842e$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$k8nJx.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $ab0f52c9db6f842e$var$printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                else $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if ($fQsEq(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $kZO5c);
                if (checkerResult == null) return null;
                if (checkerResult.data && $fQsEq(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $8coUR({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($fQsEq(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $gwROR;
    ReactPropTypes.resetWarningCache = $gwROR.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("k8nJx", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9XjZK"));

});

parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});

parcelRegister("fQsEq", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("gwROR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c08961ea4c03f601$var$printWarning = function() {};

var $kZO5c = parcelRequire("kZO5c");
var $c08961ea4c03f601$var$loggedTypeFailures = {};

var $fQsEq = parcelRequire("fQsEq");
$c08961ea4c03f601$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $c08961ea4c03f601$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($fQsEq(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                err.name = "Invariant Violation";
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $kZO5c);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $c08961ea4c03f601$var$printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
        if (error instanceof Error && !(error.message in $c08961ea4c03f601$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $c08961ea4c03f601$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            $c08961ea4c03f601$var$printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $c08961ea4c03f601$var$checkPropTypes.resetWarningCache = function() {
    $c08961ea4c03f601$var$loggedTypeFailures = {};
};
module.exports = $c08961ea4c03f601$var$checkPropTypes;

});


parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("hkVY4", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $c9f145267881427c$export$a7c73072b1a182ae, (v) => $c9f145267881427c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $c9f145267881427c$export$9f27bc3417b4524d, (v) => $c9f145267881427c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $c9f145267881427c$export$db77ccec0bb4ccac, (v) => $c9f145267881427c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $c9f145267881427c$export$8392c0c9d3dcbd35, (v) => $c9f145267881427c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $c9f145267881427c$export$ffb0004e005737fa, (v) => $c9f145267881427c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $c9f145267881427c$export$b624eff549462981, (v) => $c9f145267881427c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $c9f145267881427c$export$7897aa7841a5380c, (v) => $c9f145267881427c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $c9f145267881427c$export$602eac185826482c, (v) => $c9f145267881427c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $c9f145267881427c$export$e2c29f18771995cb, (v) => $c9f145267881427c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $c9f145267881427c$export$5f8d39834fd61797, (v) => $c9f145267881427c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $c9f145267881427c$export$74bf444e3cd11ea5, (v) => $c9f145267881427c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $c9f145267881427c$export$998bcd577473dd93, (v) => $c9f145267881427c$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $c9f145267881427c$export$92387174baf9b227, (v) => $c9f145267881427c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $c9f145267881427c$export$ec112efeb987d9c6, (v) => $c9f145267881427c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $c9f145267881427c$export$b706b080d889d2c9, (v) => $c9f145267881427c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $c9f145267881427c$export$5be5a87408f70ddc, (v) => $c9f145267881427c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $c9f145267881427c$export$45a5e7f76e0caa8d, (v) => $c9f145267881427c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $c9f145267881427c$export$455c2e768291efa6, (v) => $c9f145267881427c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $c9f145267881427c$export$9522e17588c12572, (v) => $c9f145267881427c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $c9f145267881427c$export$2110ac352bb060b9, (v) => $c9f145267881427c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $c9f145267881427c$export$56885ab8b9c456ab, (v) => $c9f145267881427c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $c9f145267881427c$export$d927fcb6adf8f9de, (v) => $c9f145267881427c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $c9f145267881427c$export$b82d16f27459e05a, (v) => $c9f145267881427c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $c9f145267881427c$export$522c17b4f5e123e8, (v) => $c9f145267881427c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $c9f145267881427c$export$1aabd8a0274ecfd6, (v) => $c9f145267881427c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $c9f145267881427c$export$3d6c20d97e46b957, (v) => $c9f145267881427c$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $c9f145267881427c$export$9b621391a187a31a, (v) => $c9f145267881427c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $c9f145267881427c$export$f5bbd400c2f4426f, (v) => $c9f145267881427c$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9f145267881427c$export$a7c73072b1a182ae;
var $c9f145267881427c$export$9f27bc3417b4524d;
var $c9f145267881427c$export$db77ccec0bb4ccac;
var $c9f145267881427c$export$8392c0c9d3dcbd35;
var $c9f145267881427c$export$ffb0004e005737fa;
var $c9f145267881427c$export$b624eff549462981;
var $c9f145267881427c$export$7897aa7841a5380c;
var $c9f145267881427c$export$602eac185826482c;
var $c9f145267881427c$export$e2c29f18771995cb;
var $c9f145267881427c$export$5f8d39834fd61797;
var $c9f145267881427c$export$74bf444e3cd11ea5;
var $c9f145267881427c$export$998bcd577473dd93;
var $c9f145267881427c$export$92387174baf9b227;
var $c9f145267881427c$export$ec112efeb987d9c6;
var $c9f145267881427c$export$b706b080d889d2c9;
var $c9f145267881427c$export$5be5a87408f70ddc;
var $c9f145267881427c$export$45a5e7f76e0caa8d;
var $c9f145267881427c$export$455c2e768291efa6;
var $c9f145267881427c$export$9522e17588c12572;
var $c9f145267881427c$export$2110ac352bb060b9;
var $c9f145267881427c$export$56885ab8b9c456ab;
var $c9f145267881427c$export$d927fcb6adf8f9de;
var $c9f145267881427c$export$b82d16f27459e05a;
var $c9f145267881427c$export$522c17b4f5e123e8;
var $c9f145267881427c$export$1aabd8a0274ecfd6;
var $c9f145267881427c$export$3d6c20d97e46b957;
var $c9f145267881427c$export$9b621391a187a31a;
var $c9f145267881427c$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_SERVER_CONTEXT_TYPE:
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    $c9f145267881427c$export$a7c73072b1a182ae = ContextConsumer;
    $c9f145267881427c$export$9f27bc3417b4524d = ContextProvider;
    $c9f145267881427c$export$db77ccec0bb4ccac = Element;
    $c9f145267881427c$export$8392c0c9d3dcbd35 = ForwardRef;
    $c9f145267881427c$export$ffb0004e005737fa = Fragment;
    $c9f145267881427c$export$b624eff549462981 = Lazy;
    $c9f145267881427c$export$7897aa7841a5380c = Memo;
    $c9f145267881427c$export$602eac185826482c = Portal;
    $c9f145267881427c$export$e2c29f18771995cb = Profiler;
    $c9f145267881427c$export$5f8d39834fd61797 = StrictMode;
    $c9f145267881427c$export$74bf444e3cd11ea5 = Suspense;
    $c9f145267881427c$export$998bcd577473dd93 = SuspenseList;
    $c9f145267881427c$export$92387174baf9b227 = isAsyncMode;
    $c9f145267881427c$export$ec112efeb987d9c6 = isConcurrentMode;
    $c9f145267881427c$export$b706b080d889d2c9 = isContextConsumer;
    $c9f145267881427c$export$5be5a87408f70ddc = isContextProvider;
    $c9f145267881427c$export$45a5e7f76e0caa8d = isElement;
    $c9f145267881427c$export$455c2e768291efa6 = isForwardRef;
    $c9f145267881427c$export$9522e17588c12572 = isFragment;
    $c9f145267881427c$export$2110ac352bb060b9 = isLazy;
    $c9f145267881427c$export$56885ab8b9c456ab = isMemo;
    $c9f145267881427c$export$d927fcb6adf8f9de = isPortal;
    $c9f145267881427c$export$b82d16f27459e05a = isProfiler;
    $c9f145267881427c$export$522c17b4f5e123e8 = isStrictMode;
    $c9f145267881427c$export$1aabd8a0274ecfd6 = isSuspense;
    $c9f145267881427c$export$3d6c20d97e46b957 = isSuspenseList;
    $c9f145267881427c$export$9b621391a187a31a = isValidElementType;
    $c9f145267881427c$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("8Hm9c", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $655384e8331727f6$export$2b8d127b894957b9, (v) => $655384e8331727f6$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $655384e8331727f6$export$cea3a54a6425200c, (v) => $655384e8331727f6$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $655384e8331727f6$export$a7c73072b1a182ae, (v) => $655384e8331727f6$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $655384e8331727f6$export$9f27bc3417b4524d, (v) => $655384e8331727f6$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $655384e8331727f6$export$db77ccec0bb4ccac, (v) => $655384e8331727f6$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $655384e8331727f6$export$8392c0c9d3dcbd35, (v) => $655384e8331727f6$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $655384e8331727f6$export$ffb0004e005737fa, (v) => $655384e8331727f6$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $655384e8331727f6$export$b624eff549462981, (v) => $655384e8331727f6$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $655384e8331727f6$export$7897aa7841a5380c, (v) => $655384e8331727f6$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $655384e8331727f6$export$602eac185826482c, (v) => $655384e8331727f6$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $655384e8331727f6$export$e2c29f18771995cb, (v) => $655384e8331727f6$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $655384e8331727f6$export$5f8d39834fd61797, (v) => $655384e8331727f6$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $655384e8331727f6$export$74bf444e3cd11ea5, (v) => $655384e8331727f6$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $655384e8331727f6$export$92387174baf9b227, (v) => $655384e8331727f6$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $655384e8331727f6$export$ec112efeb987d9c6, (v) => $655384e8331727f6$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $655384e8331727f6$export$b706b080d889d2c9, (v) => $655384e8331727f6$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $655384e8331727f6$export$5be5a87408f70ddc, (v) => $655384e8331727f6$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $655384e8331727f6$export$45a5e7f76e0caa8d, (v) => $655384e8331727f6$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $655384e8331727f6$export$455c2e768291efa6, (v) => $655384e8331727f6$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $655384e8331727f6$export$9522e17588c12572, (v) => $655384e8331727f6$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $655384e8331727f6$export$2110ac352bb060b9, (v) => $655384e8331727f6$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $655384e8331727f6$export$56885ab8b9c456ab, (v) => $655384e8331727f6$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $655384e8331727f6$export$d927fcb6adf8f9de, (v) => $655384e8331727f6$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $655384e8331727f6$export$b82d16f27459e05a, (v) => $655384e8331727f6$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $655384e8331727f6$export$522c17b4f5e123e8, (v) => $655384e8331727f6$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $655384e8331727f6$export$1aabd8a0274ecfd6, (v) => $655384e8331727f6$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $655384e8331727f6$export$9b621391a187a31a, (v) => $655384e8331727f6$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $655384e8331727f6$export$f5bbd400c2f4426f, (v) => $655384e8331727f6$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $655384e8331727f6$export$2b8d127b894957b9;
var $655384e8331727f6$export$cea3a54a6425200c;
var $655384e8331727f6$export$a7c73072b1a182ae;
var $655384e8331727f6$export$9f27bc3417b4524d;
var $655384e8331727f6$export$db77ccec0bb4ccac;
var $655384e8331727f6$export$8392c0c9d3dcbd35;
var $655384e8331727f6$export$ffb0004e005737fa;
var $655384e8331727f6$export$b624eff549462981;
var $655384e8331727f6$export$7897aa7841a5380c;
var $655384e8331727f6$export$602eac185826482c;
var $655384e8331727f6$export$e2c29f18771995cb;
var $655384e8331727f6$export$5f8d39834fd61797;
var $655384e8331727f6$export$74bf444e3cd11ea5;
var $655384e8331727f6$export$92387174baf9b227;
var $655384e8331727f6$export$ec112efeb987d9c6;
var $655384e8331727f6$export$b706b080d889d2c9;
var $655384e8331727f6$export$5be5a87408f70ddc;
var $655384e8331727f6$export$45a5e7f76e0caa8d;
var $655384e8331727f6$export$455c2e768291efa6;
var $655384e8331727f6$export$9522e17588c12572;
var $655384e8331727f6$export$2110ac352bb060b9;
var $655384e8331727f6$export$56885ab8b9c456ab;
var $655384e8331727f6$export$d927fcb6adf8f9de;
var $655384e8331727f6$export$b82d16f27459e05a;
var $655384e8331727f6$export$522c17b4f5e123e8;
var $655384e8331727f6$export$1aabd8a0274ecfd6;
var $655384e8331727f6$export$9b621391a187a31a;
var $655384e8331727f6$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $655384e8331727f6$export$2b8d127b894957b9 = AsyncMode;
    $655384e8331727f6$export$cea3a54a6425200c = ConcurrentMode;
    $655384e8331727f6$export$a7c73072b1a182ae = ContextConsumer;
    $655384e8331727f6$export$9f27bc3417b4524d = ContextProvider;
    $655384e8331727f6$export$db77ccec0bb4ccac = Element;
    $655384e8331727f6$export$8392c0c9d3dcbd35 = ForwardRef;
    $655384e8331727f6$export$ffb0004e005737fa = Fragment;
    $655384e8331727f6$export$b624eff549462981 = Lazy;
    $655384e8331727f6$export$7897aa7841a5380c = Memo;
    $655384e8331727f6$export$602eac185826482c = Portal;
    $655384e8331727f6$export$e2c29f18771995cb = Profiler;
    $655384e8331727f6$export$5f8d39834fd61797 = StrictMode;
    $655384e8331727f6$export$74bf444e3cd11ea5 = Suspense;
    $655384e8331727f6$export$92387174baf9b227 = isAsyncMode;
    $655384e8331727f6$export$ec112efeb987d9c6 = isConcurrentMode;
    $655384e8331727f6$export$b706b080d889d2c9 = isContextConsumer;
    $655384e8331727f6$export$5be5a87408f70ddc = isContextProvider;
    $655384e8331727f6$export$45a5e7f76e0caa8d = isElement;
    $655384e8331727f6$export$455c2e768291efa6 = isForwardRef;
    $655384e8331727f6$export$9522e17588c12572 = isFragment;
    $655384e8331727f6$export$2110ac352bb060b9 = isLazy;
    $655384e8331727f6$export$56885ab8b9c456ab = isMemo;
    $655384e8331727f6$export$d927fcb6adf8f9de = isPortal;
    $655384e8331727f6$export$b82d16f27459e05a = isProfiler;
    $655384e8331727f6$export$522c17b4f5e123e8 = isStrictMode;
    $655384e8331727f6$export$1aabd8a0274ecfd6 = isSuspense;
    $655384e8331727f6$export$9b621391a187a31a = isValidElementType;
    $655384e8331727f6$export$f5bbd400c2f4426f = typeOf;
})();

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("7B2bR"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

$11492dca620dcaa5$exports = (parcelRequire("3y30c"));


var $7e96a608cb33bf79$var$i = $11492dca620dcaa5$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$7e96a608cb33bf79$export$882461b6382ed46c = function(c, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $11492dca620dcaa5$exports.createRoot(c, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};
$7e96a608cb33bf79$export$757ceba2d55c277e = function(c, h, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $11492dca620dcaa5$exports.hydrateRoot(c, h, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};



parcelRequire("acw62");
function $9481eb156b453e62$var$e(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $9481eb156b453e62$var$t(t) {
    for(var n = 1; n < arguments.length; n++){
        var r = null != arguments[n] ? arguments[n] : {};
        n % 2 ? $9481eb156b453e62$var$e(Object(r), !0).forEach(function(e) {
            $9481eb156b453e62$var$s(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : $9481eb156b453e62$var$e(Object(r)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
    }
    return t;
}
function $9481eb156b453e62$var$n(e) {
    return $9481eb156b453e62$var$n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, $9481eb156b453e62$var$n(e);
}
function $9481eb156b453e62$var$r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $9481eb156b453e62$var$i(e, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
}
function $9481eb156b453e62$var$o(e, t, n) {
    return t && $9481eb156b453e62$var$i(e.prototype, t), n && $9481eb156b453e62$var$i(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $9481eb156b453e62$var$s(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $9481eb156b453e62$var$a(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(e, "prototype", {
        writable: !1
    }), t && $9481eb156b453e62$var$l(e, t);
}
function $9481eb156b453e62$var$u(e) {
    return $9481eb156b453e62$var$u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
    }, $9481eb156b453e62$var$u(e);
}
function $9481eb156b453e62$var$l(e, t) {
    return $9481eb156b453e62$var$l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
        return e.__proto__ = t, e;
    }, $9481eb156b453e62$var$l(e, t);
}
function $9481eb156b453e62$var$c(e, t) {
    if (null == e) return {};
    var n, r, i = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, o = Object.keys(e);
        for(r = 0; r < o.length; r++)n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for(r = 0; r < o.length; r++)n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
    }
    return i;
}
function $9481eb156b453e62$var$d(e, t) {
    if (t && ("object" == typeof t || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return function(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }(e);
}
function $9481eb156b453e62$var$h(e) {
    var t = function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (e) {
            return !1;
        }
    }();
    return function() {
        var n, r = $9481eb156b453e62$var$u(e);
        if (t) {
            var i = $9481eb156b453e62$var$u(this).constructor;
            n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);
        return $9481eb156b453e62$var$d(this, n);
    };
}
function $9481eb156b453e62$var$f(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == n) return;
        var r, i, o = [], s = !0, a = !1;
        try {
            for(n = n.call(e); !(s = (r = n.next()).done) && (o.push(r.value), !t || o.length !== t); s = !0);
        } catch (e) {
            a = !0, i = e;
        } finally{
            try {
                s || null == n.return || n.return();
            } finally{
                if (a) throw i;
            }
        }
        return o;
    }(e, t) || $9481eb156b453e62$var$_(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $9481eb156b453e62$var$p(e) {
    return function(e) {
        if (Array.isArray(e)) return $9481eb156b453e62$var$g(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || $9481eb156b453e62$var$_(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $9481eb156b453e62$var$_(e, t) {
    if (e) {
        if ("string" == typeof e) return $9481eb156b453e62$var$g(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $9481eb156b453e62$var$g(e, t) : void 0;
    }
}
function $9481eb156b453e62$var$g(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
    return r;
}
function $9481eb156b453e62$var$v(e, t) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!n) {
        if (Array.isArray(e) || (n = $9481eb156b453e62$var$_(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var r = 0, i = function() {};
            return {
                s: i,
                n: function() {
                    return r >= e.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: e[r++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: i
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, s = !0, a = !1;
    return {
        s: function() {
            n = n.call(e);
        },
        n: function() {
            var e = n.next();
            return s = e.done, e;
        },
        e: function(e) {
            a = !0, o = e;
        },
        f: function() {
            try {
                s || null == n.return || n.return();
            } finally{
                if (a) throw o;
            }
        }
    };
}
var $9481eb156b453e62$var$m = {
    DEBUG: !1,
    LIB_VERSION: "1.98.2"
}, $9481eb156b453e62$var$y = Array.isArray, $9481eb156b453e62$var$b = Object.prototype, $9481eb156b453e62$var$k = $9481eb156b453e62$var$b.hasOwnProperty, $9481eb156b453e62$var$w = $9481eb156b453e62$var$b.toString, $9481eb156b453e62$var$S = $9481eb156b453e62$var$y || function(e) {
    return "[object Array]" === $9481eb156b453e62$var$w.call(e);
}, $9481eb156b453e62$var$F = function(e) {
    return "[object Uint8Array]" === $9481eb156b453e62$var$w.call(e);
}, $9481eb156b453e62$var$P = function(e) {
    return "function" == typeof e;
}, $9481eb156b453e62$var$I = function(e) {
    return e === Object(e) && !$9481eb156b453e62$var$S(e);
}, $9481eb156b453e62$var$x = function(e) {
    if ($9481eb156b453e62$var$I(e)) {
        for(var t in e)if ($9481eb156b453e62$var$k.call(e, t)) return !1;
        return !0;
    }
    return !1;
}, $9481eb156b453e62$var$R = function(e) {
    return void 0 === e;
}, $9481eb156b453e62$var$E = function(e) {
    return "[object String]" == $9481eb156b453e62$var$w.call(e);
}, $9481eb156b453e62$var$C = function(e) {
    return null === e;
}, $9481eb156b453e62$var$$ = function(e) {
    return "[object Number]" == $9481eb156b453e62$var$w.call(e);
}, $9481eb156b453e62$var$O = function(e) {
    return "[object Boolean]" === $9481eb156b453e62$var$w.call(e);
}, $9481eb156b453e62$var$M = Array.prototype, $9481eb156b453e62$var$A = $9481eb156b453e62$var$M.forEach, $9481eb156b453e62$var$T = $9481eb156b453e62$var$M.indexOf, $9481eb156b453e62$var$D = "undefined" != typeof window ? window : void 0, $9481eb156b453e62$var$q = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.navigator, $9481eb156b453e62$var$B = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.document, $9481eb156b453e62$var$N = null == $9481eb156b453e62$var$q ? void 0 : $9481eb156b453e62$var$q.userAgent, $9481eb156b453e62$var$L = null != $9481eb156b453e62$var$D ? $9481eb156b453e62$var$D : {}, $9481eb156b453e62$var$j = "[PostHog.js]", $9481eb156b453e62$var$H = {
    _log: function(e) {
        if ($9481eb156b453e62$var$D && ($9481eb156b453e62$var$m.DEBUG || $9481eb156b453e62$var$L.POSTHOG_DEBUG) && !$9481eb156b453e62$var$R($9481eb156b453e62$var$D.console) && $9481eb156b453e62$var$D.console) {
            for(var t = ("__rrweb_original__" in $9481eb156b453e62$var$D.console[e]) ? $9481eb156b453e62$var$D.console[e].__rrweb_original__ : $9481eb156b453e62$var$D.console[e], n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)r[i - 1] = arguments[i];
            t.apply(void 0, [
                $9481eb156b453e62$var$j
            ].concat(r));
        }
    },
    info: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $9481eb156b453e62$var$H._log.apply($9481eb156b453e62$var$H, [
            "log"
        ].concat(t));
    },
    warn: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $9481eb156b453e62$var$H._log.apply($9481eb156b453e62$var$H, [
            "warn"
        ].concat(t));
    },
    error: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $9481eb156b453e62$var$H._log.apply($9481eb156b453e62$var$H, [
            "error"
        ].concat(t));
    },
    critical: function() {
        for(var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
        (e = console).error.apply(e, [
            $9481eb156b453e62$var$j
        ].concat(n));
    },
    uninitializedWarning: function(e) {
        $9481eb156b453e62$var$H.error("You must initialize PostHog before calling ".concat(e));
    }
}, $9481eb156b453e62$var$V = {}, $9481eb156b453e62$var$U = function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
function $9481eb156b453e62$var$W(e, t, n) {
    if ($9481eb156b453e62$var$S(e)) {
        if ($9481eb156b453e62$var$A && e.forEach === $9481eb156b453e62$var$A) e.forEach(t, n);
        else if ("length" in e && e.length === +e.length) {
            for(var r = 0, i = e.length; r < i; r++)if (r in e && t.call(n, e[r], r) === $9481eb156b453e62$var$V) return;
        }
    }
}
function $9481eb156b453e62$var$G(e, t, n) {
    if (!$9481eb156b453e62$var$C(e) && !$9481eb156b453e62$var$R(e)) {
        if ($9481eb156b453e62$var$S(e)) return $9481eb156b453e62$var$W(e, t, n);
        for(var r in e)if ($9481eb156b453e62$var$k.call(e, r) && t.call(n, e[r], r) === $9481eb156b453e62$var$V) return;
    }
}
var $9481eb156b453e62$var$z = function(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $9481eb156b453e62$var$W(n, function(t) {
        for(var n in t)void 0 !== t[n] && (e[n] = t[n]);
    }), e;
};
function $9481eb156b453e62$var$Y(e, t) {
    return -1 !== e.indexOf(t);
}
function $9481eb156b453e62$var$Q(e) {
    for(var t = Object.keys(e), n = t.length, r = new Array(n); n--;)r[n] = [
        t[n],
        e[t[n]]
    ];
    return r;
}
var $9481eb156b453e62$var$J = function() {
    return Date.now = Date.now || function() {
        return +new Date;
    }, Date.now();
}, $9481eb156b453e62$var$X = function(e) {
    try {
        return e();
    } catch (e) {
        return;
    }
}, $9481eb156b453e62$var$K = function(e) {
    return function() {
        try {
            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
            return e.apply(this, n);
        } catch (e) {
            $9481eb156b453e62$var$H.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $9481eb156b453e62$var$H.critical(e);
        }
    };
}, $9481eb156b453e62$var$Z = function(e) {
    var t = {};
    return $9481eb156b453e62$var$G(e, function(e, n) {
        $9481eb156b453e62$var$E(e) && e.length > 0 && (t[n] = e);
    }), t;
};
var $9481eb156b453e62$var$ee = [
    "$performance_raw"
];
function $9481eb156b453e62$var$te(e, t) {
    var n, r, i;
    return n = e, r = function(e, n) {
        return n && $9481eb156b453e62$var$ee.indexOf(n) > -1 ? e : $9481eb156b453e62$var$E(e) && !$9481eb156b453e62$var$C(t) ? e.slice(0, t) : e;
    }, i = new Set, function e(t, n) {
        var o;
        return t !== Object(t) ? r ? r(t, n) : t : i.has(t) ? void 0 : (i.add(t), $9481eb156b453e62$var$S(t) ? (o = [], $9481eb156b453e62$var$W(t, function(t) {
            o.push(e(t));
        })) : (o = {}, $9481eb156b453e62$var$G(t, function(t, n) {
            i.has(t) || (o[n] = e(t, n));
        })), o);
    }(n);
}
function $9481eb156b453e62$var$ne(e) {
    var t, n, r, i, o, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, u = 0, l = "", c = [];
    if (!e) return e;
    e = $9481eb156b453e62$var$re(e);
    do t = (o = e.charCodeAt(a++) << 16 | e.charCodeAt(a++) << 8 | e.charCodeAt(a++)) >> 18 & 63, n = o >> 12 & 63, r = o >> 6 & 63, i = 63 & o, c[u++] = s.charAt(t) + s.charAt(n) + s.charAt(r) + s.charAt(i);
    while (a < e.length);
    switch(l = c.join(""), e.length % 3){
        case 1:
            l = l.slice(0, -2) + "==";
            break;
        case 2:
            l = l.slice(0, -1) + "=";
    }
    return l;
}
var $9481eb156b453e62$var$re = function(e) {
    var t, n, r, i, o = "";
    for(t = n = 0, r = (e = (e + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, i = 0; i < r; i++){
        var s = e.charCodeAt(i), a = null;
        s < 128 ? n++ : a = s > 127 && s < 2048 ? String.fromCharCode(s >> 6 | 192, 63 & s | 128) : String.fromCharCode(s >> 12 | 224, s >> 6 & 63 | 128, 63 & s | 128), $9481eb156b453e62$var$C(a) || (n > t && (o += e.substring(t, n)), o += a, t = n = i + 1);
    }
    return n > t && (o += e.substring(t, e.length)), o;
}, $9481eb156b453e62$var$ie = function() {
    function e(t) {
        return t && (t.preventDefault = e.preventDefault, t.stopPropagation = e.stopPropagation), t;
    }
    return e.preventDefault = function() {
        this.returnValue = !1;
    }, e.stopPropagation = function() {
        this.cancelBubble = !0;
    }, function(t, n, r, i, o) {
        if (t) {
            if (t.addEventListener && !i) t.addEventListener(n, r, !!o);
            else {
                var s = "on" + n, a = t[s];
                t[s] = function(t, n, r) {
                    return function(i) {
                        if (i = i || e(null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.event)) {
                            var o, s = !0;
                            $9481eb156b453e62$var$P(r) && (o = r(i));
                            var a = n.call(t, i);
                            return !1 !== o && !1 !== a || (s = !1), s;
                        }
                    };
                }(t, r, a);
            }
        } else $9481eb156b453e62$var$H.error("No valid element provided to register_event");
    };
}();
function $9481eb156b453e62$var$oe(e, t) {
    var n = function() {
        if (!$9481eb156b453e62$var$B) return t("document not found");
        var n = $9481eb156b453e62$var$B.createElement("script");
        n.type = "text/javascript", n.src = e, n.onload = function(e) {
            return t(void 0, e);
        }, n.onerror = function(e) {
            return t(e);
        };
        var r, i = $9481eb156b453e62$var$B.querySelectorAll("body > script");
        i.length > 0 ? null === (r = i[0].parentNode) || void 0 === r || r.insertBefore(n, i[0]) : $9481eb156b453e62$var$B.body.appendChild(n);
    };
    null != $9481eb156b453e62$var$B && $9481eb156b453e62$var$B.body ? n() : null == $9481eb156b453e62$var$B || $9481eb156b453e62$var$B.addEventListener("DOMContentLoaded", n);
}
function $9481eb156b453e62$var$se(e) {
    return e ? $9481eb156b453e62$var$U(e).split(/\s+/) : [];
}
function $9481eb156b453e62$var$ae(e) {
    var t = "";
    switch($9481eb156b453e62$var$n(e.className)){
        case "string":
            t = e.className;
            break;
        case "object":
            t = ("baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
            break;
        default:
            t = "";
    }
    return $9481eb156b453e62$var$se(t);
}
function $9481eb156b453e62$var$ue(e) {
    var t = "";
    return $9481eb156b453e62$var$pe(e) && !$9481eb156b453e62$var$_e(e) && e.childNodes && e.childNodes.length && $9481eb156b453e62$var$G(e.childNodes, function(e) {
        $9481eb156b453e62$var$de(e) && e.textContent && (t += $9481eb156b453e62$var$U(e.textContent).split(/(\s+)/).filter($9481eb156b453e62$var$ge).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255));
    }), $9481eb156b453e62$var$U(t);
}
function $9481eb156b453e62$var$le(e) {
    return !!e && 1 === e.nodeType;
}
function $9481eb156b453e62$var$ce(e, t) {
    return !!e && !!e.tagName && e.tagName.toLowerCase() === t.toLowerCase();
}
function $9481eb156b453e62$var$de(e) {
    return !!e && 3 === e.nodeType;
}
function $9481eb156b453e62$var$he(e) {
    return !!e && 11 === e.nodeType;
}
var $9481eb156b453e62$var$fe = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $9481eb156b453e62$var$pe(e) {
    for(var t = e; t.parentNode && !$9481eb156b453e62$var$ce(t, "body"); t = t.parentNode){
        var n = $9481eb156b453e62$var$ae(t);
        if ($9481eb156b453e62$var$Y(n, "ph-sensitive") || $9481eb156b453e62$var$Y(n, "ph-no-capture")) return !1;
    }
    if ($9481eb156b453e62$var$Y($9481eb156b453e62$var$ae(e), "ph-include")) return !0;
    var r = e.type || "";
    if ($9481eb156b453e62$var$E(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var i = e.name || e.id || "";
    if ($9481eb156b453e62$var$E(i)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(i.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $9481eb156b453e62$var$_e(e) {
    return !!($9481eb156b453e62$var$ce(e, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(e.type) || $9481eb156b453e62$var$ce(e, "select") || $9481eb156b453e62$var$ce(e, "textarea") || "true" === e.getAttribute("contenteditable"));
}
function $9481eb156b453e62$var$ge(e) {
    if ($9481eb156b453e62$var$C(e) || $9481eb156b453e62$var$R(e)) return !1;
    if ($9481eb156b453e62$var$E(e)) {
        e = $9481eb156b453e62$var$U(e);
        if (/^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/.test((e || "").replace(/[- ]/g, ""))) return !1;
        if (/(^\d{3}-?\d{2}-?\d{4}$)/.test(e)) return !1;
    }
    return !0;
}
function $9481eb156b453e62$var$ve(e) {
    var t = $9481eb156b453e62$var$ue(e);
    return $9481eb156b453e62$var$ge(t = "".concat(t, " ").concat($9481eb156b453e62$var$me(e)).trim()) ? t : "";
}
function $9481eb156b453e62$var$me(e) {
    var t = "";
    return e && e.childNodes && e.childNodes.length && $9481eb156b453e62$var$G(e.childNodes, function(e) {
        var n;
        if (e && "span" === (null === (n = e.tagName) || void 0 === n ? void 0 : n.toLowerCase())) try {
            var r = $9481eb156b453e62$var$ue(e);
            t = "".concat(t, " ").concat(r).trim(), e.childNodes && e.childNodes.length && (t = "".concat(t, " ").concat($9481eb156b453e62$var$me(e)).trim());
        } catch (e) {
            $9481eb156b453e62$var$H.error(e);
        }
    }), t;
}
function $9481eb156b453e62$var$ye(e) {
    return function(e) {
        var n = e.map(function(e) {
            var n, r, i = "";
            if (e.tag_name && (i += e.tag_name), e.attr_class) {
                e.attr_class.sort();
                var o, s = $9481eb156b453e62$var$v(e.attr_class);
                try {
                    for(s.s(); !(o = s.n()).done;){
                        var a = o.value;
                        i += ".".concat(a.replace(/"/g, ""));
                    }
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
            }
            var u = $9481eb156b453e62$var$t($9481eb156b453e62$var$t($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, e.text ? {
                text: e.text
            } : {}), {}, {
                "nth-child": null !== (n = e.nth_child) && void 0 !== n ? n : 0,
                "nth-of-type": null !== (r = e.nth_of_type) && void 0 !== r ? r : 0
            }, e.href ? {
                href: e.href
            } : {}), e.attr_id ? {
                attr_id: e.attr_id
            } : {}), e.attributes), l = {};
            return $9481eb156b453e62$var$Q(u).sort(function(e, t) {
                var n = $9481eb156b453e62$var$f(e, 1)[0], r = $9481eb156b453e62$var$f(t, 1)[0];
                return n.localeCompare(r);
            }).forEach(function(e) {
                var t = $9481eb156b453e62$var$f(e, 2), n = t[0], r = t[1];
                return l[$9481eb156b453e62$var$be(n.toString())] = $9481eb156b453e62$var$be(r.toString());
            }), i += ":", i += $9481eb156b453e62$var$Q(u).map(function(e) {
                var t = $9481eb156b453e62$var$f(e, 2), n = t[0], r = t[1];
                return "".concat(n, '="').concat(r, '"');
            }).join("");
        });
        return n.join(";");
    }(function(e) {
        return e.map(function(e) {
            var t, n, r = {
                text: null === (t = e.$el_text) || void 0 === t ? void 0 : t.slice(0, 400),
                tag_name: e.tag_name,
                href: null === (n = e.attr__href) || void 0 === n ? void 0 : n.slice(0, 2048),
                attr_class: $9481eb156b453e62$var$ke(e),
                attr_id: e.attr__id,
                nth_child: e.nth_child,
                nth_of_type: e.nth_of_type,
                attributes: {}
            };
            return $9481eb156b453e62$var$Q(e).filter(function(e) {
                return 0 === $9481eb156b453e62$var$f(e, 1)[0].indexOf("attr__");
            }).forEach(function(e) {
                var t = $9481eb156b453e62$var$f(e, 2), n = t[0], i = t[1];
                return r.attributes[n] = i;
            }), r;
        });
    }(e));
}
function $9481eb156b453e62$var$be(e) {
    return e.replace(/"|\\"/g, '\\"');
}
function $9481eb156b453e62$var$ke(e) {
    var t = e.attr__class;
    return t ? $9481eb156b453e62$var$S(t) ? t : $9481eb156b453e62$var$se(t) : void 0;
}
var $9481eb156b453e62$var$we = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.clicks = [], this.enabled = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "isRageClick",
            value: function(e, t, n) {
                if (!this.enabled) return !1;
                var r = this.clicks[this.clicks.length - 1];
                if (r && Math.abs(e - r.x) + Math.abs(t - r.y) < 30 && n - r.timestamp < 1e3) {
                    if (this.clicks.push({
                        x: e,
                        y: t,
                        timestamp: n
                    }), 3 === this.clicks.length) return !0;
                } else this.clicks = [
                    {
                        x: e,
                        y: t,
                        timestamp: n
                    }
                ];
                return !1;
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Se = "$people_distinct_id", $9481eb156b453e62$var$Fe = "__alias", $9481eb156b453e62$var$Pe = "__timers", $9481eb156b453e62$var$Ie = "$autocapture_disabled_server_side", $9481eb156b453e62$var$xe = "$session_recording_enabled_server_side", $9481eb156b453e62$var$Re = "$console_log_recording_enabled_server_side", $9481eb156b453e62$var$Ee = "$session_recording_recorder_version_server_side", $9481eb156b453e62$var$Ce = "$session_recording_network_payload_capture", $9481eb156b453e62$var$$e = "$sesid", $9481eb156b453e62$var$Oe = "$session_is_sampled", $9481eb156b453e62$var$Me = "$enabled_feature_flags", $9481eb156b453e62$var$Ae = "$early_access_features", $9481eb156b453e62$var$Te = "$stored_person_properties", $9481eb156b453e62$var$De = "$stored_group_properties", $9481eb156b453e62$var$qe = "$surveys", $9481eb156b453e62$var$Be = "$flag_call_reported", $9481eb156b453e62$var$Ne = "$user_state", $9481eb156b453e62$var$Le = "$posthog_quota_limited", $9481eb156b453e62$var$je = "$client_session_props", $9481eb156b453e62$var$He = [
    $9481eb156b453e62$var$Se,
    $9481eb156b453e62$var$Fe,
    "__cmpns",
    $9481eb156b453e62$var$Pe,
    $9481eb156b453e62$var$xe,
    $9481eb156b453e62$var$$e,
    $9481eb156b453e62$var$Me,
    $9481eb156b453e62$var$Ne,
    $9481eb156b453e62$var$Le,
    $9481eb156b453e62$var$Ae,
    $9481eb156b453e62$var$De,
    $9481eb156b453e62$var$Te,
    $9481eb156b453e62$var$qe,
    $9481eb156b453e62$var$Be,
    $9481eb156b453e62$var$je
];
function $9481eb156b453e62$var$Ve(e, t) {
    return t.length > e ? t.slice(0, e) + "..." : t;
}
var $9481eb156b453e62$var$Ue = {
    _initializedTokens: [],
    _isDisabledServerSide: null,
    _isAutocaptureEnabled: !1,
    _setIsAutocaptureEnabled: function(e) {
        var t, n = $9481eb156b453e62$var$C(this._isDisabledServerSide) ? !(null === (t = e.persistence) || void 0 === t || !t.props[$9481eb156b453e62$var$Ie]) : this._isDisabledServerSide, r = !!e.config.autocapture;
        this._isAutocaptureEnabled = r && !n;
    },
    _previousElementSibling: function(e) {
        if (e.previousElementSibling) return e.previousElementSibling;
        var t = e;
        do t = t.previousSibling;
        while (t && !$9481eb156b453e62$var$le(t));
        return t;
    },
    _getAugmentPropertiesFromElement: function(e) {
        if (!$9481eb156b453e62$var$pe(e)) return {};
        var t = {};
        return $9481eb156b453e62$var$G(e.attributes, function(e) {
            if (0 === e.name.indexOf("data-ph-capture-attribute")) {
                var n = e.name.replace("data-ph-capture-attribute-", ""), r = e.value;
                n && r && $9481eb156b453e62$var$ge(r) && (t[n] = r);
            }
        }), t;
    },
    _getPropertiesFromElement: function(e, t, n) {
        var r, i = e.tagName.toLowerCase(), o = {
            tag_name: i
        };
        $9481eb156b453e62$var$fe.indexOf(i) > -1 && !n && ("a" === i.toLowerCase() || "button" === i.toLowerCase() ? o.$el_text = $9481eb156b453e62$var$Ve(1024, $9481eb156b453e62$var$ve(e)) : o.$el_text = $9481eb156b453e62$var$Ve(1024, $9481eb156b453e62$var$ue(e)));
        var s = $9481eb156b453e62$var$ae(e);
        s.length > 0 && (o.classes = s.filter(function(e) {
            return "" !== e;
        }));
        var a = null === (r = this.config) || void 0 === r ? void 0 : r.element_attribute_ignorelist;
        $9481eb156b453e62$var$G(e.attributes, function(n) {
            var r;
            if ((!$9481eb156b453e62$var$_e(e) || -1 !== [
                "name",
                "id",
                "class"
            ].indexOf(n.name)) && (null == a || !a.includes(n.name)) && !t && $9481eb156b453e62$var$ge(n.value) && (r = n.name, !$9481eb156b453e62$var$E(r) || "_ngcontent" !== r.substring(0, 10) && "_nghost" !== r.substring(0, 7))) {
                var i = n.value;
                "class" === n.name && (i = $9481eb156b453e62$var$se(i).join(" ")), o["attr__" + n.name] = $9481eb156b453e62$var$Ve(1024, i);
            }
        });
        for(var u = 1, l = 1, c = e; c = this._previousElementSibling(c);)u++, c.tagName === e.tagName && l++;
        return o.nth_child = u, o.nth_of_type = l, o;
    },
    _getDefaultProperties: function(e) {
        return {
            $event_type: e,
            $ce_version: 1
        };
    },
    _extractCustomPropertyValue: function(e) {
        var t = [];
        return $9481eb156b453e62$var$G(null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelectorAll(e.css_selector), function(e) {
            var n;
            [
                "input",
                "select"
            ].indexOf(e.tagName.toLowerCase()) > -1 ? n = e.value : e.textContent && (n = e.textContent), $9481eb156b453e62$var$ge(n) && t.push(n);
        }), t.join(", ");
    },
    _getCustomProperties: function(e) {
        var t = this, n = {};
        return $9481eb156b453e62$var$G(this._customProperties, function(r) {
            $9481eb156b453e62$var$G(r.event_selectors, function(i) {
                $9481eb156b453e62$var$G(null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelectorAll(i), function(i) {
                    $9481eb156b453e62$var$Y(e, i) && $9481eb156b453e62$var$pe(i) && (n[r.name] = t._extractCustomPropertyValue(r));
                });
            });
        }), n;
    },
    _getEventTarget: function(e) {
        var t;
        return $9481eb156b453e62$var$R(e.target) ? e.srcElement || null : null !== (t = e.target) && void 0 !== t && t.shadowRoot ? e.composedPath()[0] || null : e.target || null;
    },
    _captureEvent: function(e, t) {
        var n, r = this, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "$autocapture", o = this._getEventTarget(e);
        ($9481eb156b453e62$var$de(o) && (o = o.parentNode || null), "$autocapture" === i && "click" === e.type && e instanceof MouseEvent) && null !== (n = this.rageclicks) && void 0 !== n && n.isRageClick(e.clientX, e.clientY, (new Date).getTime()) && this._captureEvent(e, t, "$rageclick");
        if (o && function(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
            if (!$9481eb156b453e62$var$D || !e || $9481eb156b453e62$var$ce(e, "html") || !$9481eb156b453e62$var$le(e)) return !1;
            if (null != n && n.url_allowlist) {
                var r = $9481eb156b453e62$var$D.location.href, i = n.url_allowlist;
                if (i && !i.some(function(e) {
                    return r.match(e);
                })) return !1;
            }
            if (null != n && n.dom_event_allowlist) {
                var o = n.dom_event_allowlist;
                if (o && !o.some(function(e) {
                    return t.type === e;
                })) return !1;
            }
            if (null != n && n.element_allowlist) {
                var s = n.element_allowlist;
                if (s && !s.some(function(t) {
                    return e.tagName.toLowerCase() === t;
                })) return !1;
            }
            if (null != n && n.css_selector_allowlist) {
                var a = n.css_selector_allowlist;
                if (a && !a.some(function(t) {
                    return e.matches(t);
                })) return !1;
            }
            for(var u = !1, l = [
                e
            ], c = !0, d = e; d.parentNode && !$9481eb156b453e62$var$ce(d, "body");)if ($9481eb156b453e62$var$he(d.parentNode)) l.push(d.parentNode.host), d = d.parentNode.host;
            else {
                if (!(c = d.parentNode || !1)) break;
                if ($9481eb156b453e62$var$fe.indexOf(c.tagName.toLowerCase()) > -1) u = !0;
                else {
                    var h = $9481eb156b453e62$var$D.getComputedStyle(c);
                    h && "pointer" === h.getPropertyValue("cursor") && (u = !0);
                }
                l.push(c), d = c;
            }
            var f = $9481eb156b453e62$var$D.getComputedStyle(e);
            if (f && "pointer" === f.getPropertyValue("cursor") && "click" === t.type) return !0;
            var p = e.tagName.toLowerCase();
            switch(p){
                case "html":
                    return !1;
                case "form":
                    return "submit" === t.type;
                case "input":
                case "select":
                case "textarea":
                    return "change" === t.type || "click" === t.type;
                default:
                    return u ? "click" === t.type : "click" === t.type && ($9481eb156b453e62$var$fe.indexOf(p) > -1 || "true" === e.getAttribute("contenteditable"));
            }
        }(o, e, this.config)) {
            for(var s, a, u = [
                o
            ], l = o; l.parentNode && !$9481eb156b453e62$var$ce(l, "body");)$9481eb156b453e62$var$he(l.parentNode) ? (u.push(l.parentNode.host), l = l.parentNode.host) : (u.push(l.parentNode), l = l.parentNode);
            var c, d = [], h = {}, f = !1;
            if ($9481eb156b453e62$var$G(u, function(e) {
                var n = $9481eb156b453e62$var$pe(e);
                "a" === e.tagName.toLowerCase() && (c = e.getAttribute("href"), c = n && $9481eb156b453e62$var$ge(c) && c), $9481eb156b453e62$var$Y($9481eb156b453e62$var$ae(e), "ph-no-capture") && (f = !0), d.push(r._getPropertiesFromElement(e, t.config.mask_all_element_attributes, t.config.mask_all_text));
                var i = r._getAugmentPropertiesFromElement(e);
                $9481eb156b453e62$var$z(h, i);
            }), t.config.mask_all_text || ("a" === o.tagName.toLowerCase() || "button" === o.tagName.toLowerCase() ? d[0].$el_text = $9481eb156b453e62$var$ve(o) : d[0].$el_text = $9481eb156b453e62$var$ue(o)), c && (d[0].attr__href = c), f) return !1;
            var p = $9481eb156b453e62$var$z(this._getDefaultProperties(e.type), t.elementsChainAsString ? {
                $elements_chain: $9481eb156b453e62$var$ye(d)
            } : {
                $elements: d
            }, null !== (s = d[0]) && void 0 !== s && s.$el_text ? {
                $el_text: null === (a = d[0]) || void 0 === a ? void 0 : a.$el_text
            } : {}, this._getCustomProperties(u), h);
            return t.capture(i, p), !0;
        }
    },
    _navigate: function(e) {
        $9481eb156b453e62$var$D && ($9481eb156b453e62$var$D.location.href = e);
    },
    _addDomEventHandlers: function(e) {
        var t = this;
        if ($9481eb156b453e62$var$D && $9481eb156b453e62$var$B) {
            var n = function(n) {
                n = n || (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.event), t._captureEvent(n, e);
            };
            $9481eb156b453e62$var$ie($9481eb156b453e62$var$B, "submit", n, !1, !0), $9481eb156b453e62$var$ie($9481eb156b453e62$var$B, "change", n, !1, !0), $9481eb156b453e62$var$ie($9481eb156b453e62$var$B, "click", n, !1, !0);
        }
    },
    _customProperties: [],
    rageclicks: null,
    config: void 0,
    init: function(e) {
        var t;
        $9481eb156b453e62$var$O(e.__autocapture) || (this.config = e.__autocapture), null !== (t = this.config) && void 0 !== t && t.url_allowlist && (this.config.url_allowlist = this.config.url_allowlist.map(function(e) {
            return new RegExp(e);
        })), this.rageclicks = new $9481eb156b453e62$var$we(e.config.rageclick);
    },
    afterDecideResponse: function(e, t) {
        var n = t.config.token;
        this._initializedTokens.indexOf(n) > -1 ? $9481eb156b453e62$var$H.info('autocapture already initialized for token "' + n + '"') : (t.persistence && t.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ie, !!e.autocapture_opt_out)), this._isDisabledServerSide = !!e.autocapture_opt_out, this._setIsAutocaptureEnabled(t), this._initializedTokens.push(n), e && e.config && e.config.enable_collect_everything && this._isAutocaptureEnabled ? (e.custom_properties && (this._customProperties = e.custom_properties), this._addDomEventHandlers(t)) : t.__autocapture = !1);
    },
    enabledForProject: function(e, t, n) {
        if (!e) return !0;
        t = $9481eb156b453e62$var$R(t) ? 10 : t, n = $9481eb156b453e62$var$R(n) ? 10 : n;
        for(var r = 0, i = 0; i < e.length; i++)r += e.charCodeAt(i);
        return r % t < n;
    },
    isBrowserSupported: function() {
        return $9481eb156b453e62$var$P(null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelectorAll);
    }
};
!function(e) {
    for(var t in e)$9481eb156b453e62$var$P(e[t]) && (e[t] = e[t].bind(e));
}($9481eb156b453e62$var$Ue), function(e) {
    for(var t in e)$9481eb156b453e62$var$P(e[t]) && (e[t] = $9481eb156b453e62$var$K(e[t]));
}($9481eb156b453e62$var$Ue);
var $9481eb156b453e62$var$We = "$active_feature_flags", $9481eb156b453e62$var$Ge = "$override_feature_flags", $9481eb156b453e62$var$ze = "$feature_flag_payloads", $9481eb156b453e62$var$Ye = function(e) {
    var t, n = {}, r = $9481eb156b453e62$var$v($9481eb156b453e62$var$Q(e || {}));
    try {
        for(r.s(); !(t = r.n()).done;){
            var i = $9481eb156b453e62$var$f(t.value, 2), o = i[0], s = i[1];
            s && (n[o] = s);
        }
    } catch (e) {
        r.e(e);
    } finally{
        r.f();
    }
    return n;
}, $9481eb156b453e62$var$Qe = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t, this._override_warning = !1, this.featureFlagEventHandlers = [], this.reloadFeatureFlagsQueued = !1, this.reloadFeatureFlagsInAction = !1;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "getFlags",
            value: function() {
                return Object.keys(this.getFlagVariants());
            }
        },
        {
            key: "getFlagVariants",
            value: function() {
                var e = this.instance.get_property($9481eb156b453e62$var$Me), t = this.instance.get_property($9481eb156b453e62$var$Ge);
                if (!t) return e || {};
                for(var n = $9481eb156b453e62$var$z({}, e), r = Object.keys(t), i = 0; i < r.length; i++)!1 === t[r[i]] ? delete n[r[i]] : n[r[i]] = t[r[i]];
                return this._override_warning || ($9481eb156b453e62$var$H.warn(" Overriding feature flags!", {
                    enabledFlags: e,
                    overriddenFlags: t,
                    finalFlags: n
                }), this._override_warning = !0), n;
            }
        },
        {
            key: "getFlagPayloads",
            value: function() {
                return this.instance.get_property($9481eb156b453e62$var$ze) || {};
            }
        },
        {
            key: "reloadFeatureFlags",
            value: function() {
                this.reloadFeatureFlagsQueued || (this.reloadFeatureFlagsQueued = !0, this._startReloadTimer());
            }
        },
        {
            key: "setAnonymousDistinctId",
            value: function(e) {
                this.$anon_distinct_id = e;
            }
        },
        {
            key: "setReloadingPaused",
            value: function(e) {
                this.reloadFeatureFlagsInAction = e;
            }
        },
        {
            key: "resetRequestQueue",
            value: function() {
                this.reloadFeatureFlagsQueued = !1;
            }
        },
        {
            key: "_startReloadTimer",
            value: function() {
                var e = this;
                this.reloadFeatureFlagsQueued && !this.reloadFeatureFlagsInAction && setTimeout(function() {
                    !e.reloadFeatureFlagsInAction && e.reloadFeatureFlagsQueued && (e.reloadFeatureFlagsQueued = !1, e._reloadFeatureFlagsRequest());
                }, 5);
            }
        },
        {
            key: "_reloadFeatureFlagsRequest",
            value: function() {
                var e = this;
                if (!this.instance.config.advanced_disable_feature_flags) {
                    this.setReloadingPaused(!0);
                    var t = this.instance.config.token, n = this.instance.get_property($9481eb156b453e62$var$Te), r = this.instance.get_property($9481eb156b453e62$var$De), i = $9481eb156b453e62$var$ne(JSON.stringify({
                        token: t,
                        distinct_id: this.instance.get_distinct_id(),
                        groups: this.instance.getGroups(),
                        $anon_distinct_id: this.$anon_distinct_id,
                        person_properties: n,
                        group_properties: r,
                        disable_flags: this.instance.config.advanced_disable_feature_flags || void 0
                    }));
                    this.instance._send_request(this.instance.config.api_host + "/decide/?v=3", {
                        data: i
                    }, {
                        method: "POST"
                    }, this.instance._prepare_callback(function(t) {
                        e.$anon_distinct_id = void 0, e.receivedFeatureFlags(t), e.setReloadingPaused(!1), e._startReloadTimer();
                    }));
                }
            }
        },
        {
            key: "getFeatureFlag",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) {
                    var n, r = this.getFlagVariants()[e], i = "".concat(r), o = this.instance.get_property($9481eb156b453e62$var$Be) || {};
                    if (t.send_event || !("send_event" in t)) {
                        if (!(e in o) || !o[e].includes(i)) $9481eb156b453e62$var$S(o[e]) ? o[e].push(i) : o[e] = [
                            i
                        ], null === (n = this.instance.persistence) || void 0 === n || n.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Be, o)), this.instance.capture("$feature_flag_called", {
                            $feature_flag: e,
                            $feature_flag_response: r
                        });
                    }
                    return r;
                }
                $9481eb156b453e62$var$H.warn('getFeatureFlag for key "' + e + "\" failed. Feature flags didn't load in time.");
            }
        },
        {
            key: "getFeatureFlagPayload",
            value: function(e) {
                return this.getFlagPayloads()[e];
            }
        },
        {
            key: "isFeatureEnabled",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(e, t);
                $9481eb156b453e62$var$H.warn('isFeatureEnabled for key "' + e + "\" failed. Feature flags didn't load in time.");
            }
        },
        {
            key: "addFeatureFlagsHandler",
            value: function(e) {
                this.featureFlagEventHandlers.push(e);
            }
        },
        {
            key: "removeFeatureFlagsHandler",
            value: function(e) {
                this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter(function(t) {
                    return t !== e;
                });
            }
        },
        {
            key: "receivedFeatureFlags",
            value: function(e) {
                if (this.instance.persistence) {
                    this.instance.decideEndpointWasHit = !0;
                    var n = this.getFlagVariants(), r = this.getFlagPayloads();
                    !function(e, n) {
                        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, o = e.featureFlags, a = e.featureFlagPayloads;
                        if (o) {
                            if ($9481eb156b453e62$var$S(o)) {
                                var u, l = {};
                                if (o) for(var c = 0; c < o.length; c++)l[o[c]] = !0;
                                n && n.register(($9481eb156b453e62$var$s(u = {}, $9481eb156b453e62$var$We, o), $9481eb156b453e62$var$s(u, $9481eb156b453e62$var$Me, l), u));
                            } else {
                                var d, h = o, f = a;
                                e.errorsWhileComputingFlags && (h = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), h), f = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, i), f)), n && n.register(($9481eb156b453e62$var$s(d = {}, $9481eb156b453e62$var$We, Object.keys($9481eb156b453e62$var$Ye(h))), $9481eb156b453e62$var$s(d, $9481eb156b453e62$var$Me, h || {}), $9481eb156b453e62$var$s(d, $9481eb156b453e62$var$ze, f || {}), d));
                            }
                        }
                    }(e, this.instance.persistence, n, r), this._fireFeatureFlagsCallbacks();
                }
            }
        },
        {
            key: "override",
            value: function(e) {
                if (!this.instance.__loaded || !this.instance.persistence) return $9481eb156b453e62$var$H.uninitializedWarning("posthog.feature_flags.override");
                if (this._override_warning = !1, !1 === e) this.instance.persistence.unregister($9481eb156b453e62$var$Ge);
                else if ($9481eb156b453e62$var$S(e)) {
                    for(var t = {}, n = 0; n < e.length; n++)t[e[n]] = !0;
                    this.instance.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ge, t));
                } else this.instance.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ge, e));
            }
        },
        {
            key: "onFeatureFlags",
            value: function(e) {
                var t = this;
                if (this.addFeatureFlagsHandler(e), this.instance.decideEndpointWasHit) {
                    var n = this._prepareFeatureFlagsForCallbacks(), r = n.flags, i = n.flagVariants;
                    e(r, i);
                }
                return function() {
                    return t.removeFeatureFlagsHandler(e);
                };
            }
        },
        {
            key: "updateEarlyAccessFeatureEnrollment",
            value: function(e, n) {
                var r, i, o = $9481eb156b453e62$var$s({}, "$feature_enrollment/".concat(e), n);
                this.instance.capture("$feature_enrollment_update", {
                    $feature_flag: e,
                    $feature_enrollment: n,
                    $set: o
                }), this.setPersonPropertiesForFlags(o, !1);
                var a = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, this.getFlagVariants()), {}, $9481eb156b453e62$var$s({}, e, n));
                null === (r = this.instance.persistence) || void 0 === r || r.register(($9481eb156b453e62$var$s(i = {}, $9481eb156b453e62$var$We, Object.keys($9481eb156b453e62$var$Ye(a))), $9481eb156b453e62$var$s(i, $9481eb156b453e62$var$Me, a), i)), this._fireFeatureFlagsCallbacks();
            }
        },
        {
            key: "getEarlyAccessFeatures",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = this.instance.get_property($9481eb156b453e62$var$Ae);
                if (r && !n) return e(r);
                this.instance._send_request("".concat(this.instance.config.api_host, "/api/early_access_features/?token=").concat(this.instance.config.token), {}, {
                    method: "GET"
                }, function(n) {
                    var r, i = n.earlyAccessFeatures;
                    return null === (r = t.instance.persistence) || void 0 === r || r.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ae, i)), e(i);
                });
            }
        },
        {
            key: "_prepareFeatureFlagsForCallbacks",
            value: function() {
                var e = this.getFlags(), t = this.getFlagVariants();
                return {
                    flags: e.filter(function(e) {
                        return t[e];
                    }),
                    flagVariants: Object.keys(t).filter(function(e) {
                        return t[e];
                    }).reduce(function(e, n) {
                        return e[n] = t[n], e;
                    }, {})
                };
            }
        },
        {
            key: "_fireFeatureFlagsCallbacks",
            value: function() {
                var e = this._prepareFeatureFlagsForCallbacks(), t = e.flags, n = e.flagVariants;
                this.featureFlagEventHandlers.forEach(function(e) {
                    return e(t, n);
                });
            }
        },
        {
            key: "setPersonPropertiesForFlags",
            value: function(e) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = this.instance.get_property($9481eb156b453e62$var$Te) || {};
                this.instance.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Te, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), e))), n && this.instance.reloadFeatureFlags();
            }
        },
        {
            key: "resetPersonPropertiesForFlags",
            value: function() {
                this.instance.unregister($9481eb156b453e62$var$Te);
            }
        },
        {
            key: "setGroupPropertiesForFlags",
            value: function(e) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = this.instance.get_property($9481eb156b453e62$var$De) || {};
                0 !== Object.keys(r).length && Object.keys(r).forEach(function(n) {
                    r[n] = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r[n]), e[n]), delete e[n];
                }), this.instance.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$De, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), e))), n && this.instance.reloadFeatureFlags();
            }
        },
        {
            key: "resetGroupPropertiesForFlags",
            value: function(e) {
                if (e) {
                    var n = this.instance.get_property($9481eb156b453e62$var$De) || {};
                    this.instance.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$De, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, n), {}, $9481eb156b453e62$var$s({}, e, {}))));
                } else this.instance.unregister($9481eb156b453e62$var$De);
            }
        }
    ]), e;
}();
Math.trunc || (Math.trunc = function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
    return $9481eb156b453e62$var$$(e) && isFinite(e) && Math.floor(e) === e;
});
var $9481eb156b453e62$var$Je = "0123456789abcdef", $9481eb156b453e62$var$Xe = function() {
    function e(t) {
        if ($9481eb156b453e62$var$r(this, e), this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "toString",
            value: function() {
                for(var e = "", t = 0; t < this.bytes.length; t++)e = e + $9481eb156b453e62$var$Je.charAt(this.bytes[t] >>> 4) + $9481eb156b453e62$var$Je.charAt(15 & this.bytes[t]), 3 !== t && 5 !== t && 7 !== t && 9 !== t || (e += "-");
                if (36 !== e.length) throw new Error("Invalid UUIDv7 was generated");
                return e;
            }
        },
        {
            key: "clone",
            value: function() {
                return new e(this.bytes.slice(0));
            }
        },
        {
            key: "equals",
            value: function(e) {
                return 0 === this.compareTo(e);
            }
        },
        {
            key: "compareTo",
            value: function(e) {
                for(var t = 0; t < 16; t++){
                    var n = this.bytes[t] - e.bytes[t];
                    if (0 !== n) return Math.sign(n);
                }
                return 0;
            }
        }
    ], [
        {
            key: "fromFieldsV7",
            value: function(t, n, r, i) {
                if (!Number.isInteger(t) || !Number.isInteger(n) || !Number.isInteger(r) || !Number.isInteger(i) || t < 0 || n < 0 || r < 0 || i < 0 || t > 0xffffffffffff || n > 4095 || r > 1073741823 || i > 4294967295) throw new RangeError("invalid field value");
                var o = new Uint8Array(16);
                return o[0] = t / Math.pow(2, 40), o[1] = t / Math.pow(2, 32), o[2] = t / Math.pow(2, 24), o[3] = t / Math.pow(2, 16), o[4] = t / Math.pow(2, 8), o[5] = t, o[6] = 112 | n >>> 8, o[7] = n, o[8] = 128 | r >>> 24, o[9] = r >>> 16, o[10] = r >>> 8, o[11] = r, o[12] = i >>> 24, o[13] = i >>> 16, o[14] = i >>> 8, o[15] = i, new e(o);
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Ke = function() {
    function e() {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "timestamp", 0), $9481eb156b453e62$var$s(this, "counter", 0), $9481eb156b453e62$var$s(this, "random", new $9481eb156b453e62$var$tt);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "generate",
            value: function() {
                var e = this.generateOrAbort();
                if ($9481eb156b453e62$var$R(e)) {
                    this.timestamp = 0;
                    var t = this.generateOrAbort();
                    if ($9481eb156b453e62$var$R(t)) throw new Error("Could not generate UUID after timestamp reset");
                    return t;
                }
                return e;
            }
        },
        {
            key: "generateOrAbort",
            value: function() {
                var e = Date.now();
                if (e > this.timestamp) this.timestamp = e, this.resetCounter();
                else {
                    if (!(e + 1e4 > this.timestamp)) return;
                    this.counter++, this.counter > 4398046511103 && (this.timestamp++, this.resetCounter());
                }
                return $9481eb156b453e62$var$Xe.fromFieldsV7(this.timestamp, Math.trunc(this.counter / Math.pow(2, 30)), this.counter & Math.pow(2, 30) - 1, this.random.nextUint32());
            }
        },
        {
            key: "resetCounter",
            value: function() {
                this.counter = 1024 * this.random.nextUint32() + (1023 & this.random.nextUint32());
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Ze = function(e) {
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var t = 0; t < e.length; t++)e[t] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return e;
};
$9481eb156b453e62$var$D && !$9481eb156b453e62$var$R($9481eb156b453e62$var$D.crypto) && crypto.getRandomValues && ($9481eb156b453e62$var$Ze = function(e) {
    return crypto.getRandomValues(e);
});
var $9481eb156b453e62$var$et, $9481eb156b453e62$var$tt = function() {
    function e() {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "buffer", new Uint32Array(8)), $9481eb156b453e62$var$s(this, "cursor", 1 / 0);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "nextUint32",
            value: function() {
                return this.cursor >= this.buffer.length && ($9481eb156b453e62$var$Ze(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$nt = function() {
    return $9481eb156b453e62$var$rt().toString();
}, $9481eb156b453e62$var$rt = function() {
    return ($9481eb156b453e62$var$et || ($9481eb156b453e62$var$et = new $9481eb156b453e62$var$Ke)).generate();
}, $9481eb156b453e62$var$it = "Thu, 01 Jan 1970 00:00:00 GMT", $9481eb156b453e62$var$ot = "";
var $9481eb156b453e62$var$st = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i, $9481eb156b453e62$var$at = function(e) {
    var t = e.match($9481eb156b453e62$var$st);
    return t ? t[0] : "";
};
function $9481eb156b453e62$var$ut(e, t) {
    if (t) {
        var n = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $9481eb156b453e62$var$B;
            if ($9481eb156b453e62$var$ot) return $9481eb156b453e62$var$ot;
            if (!t) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(e)) return "";
            for(var n = e.split("."), r = Math.min(n.length, 8), i = "dmn_chk_" + $9481eb156b453e62$var$nt(), o = new RegExp("(^|;)\\s*" + i + "=1"); !$9481eb156b453e62$var$ot && r--;){
                var s = n.slice(r).join("."), a = i + "=1;domain=." + s;
                t.cookie = a, o.test(t.cookie) && (t.cookie = a + ";expires=" + $9481eb156b453e62$var$it, $9481eb156b453e62$var$ot = s);
            }
            return $9481eb156b453e62$var$ot;
        }(e);
        if (!n) {
            var r = $9481eb156b453e62$var$at(e);
            r !== n && $9481eb156b453e62$var$H.info("Warning: cookie subdomain discovery mismatch", r, n), n = r;
        }
        return n ? "; domain=." + n : "";
    }
    return "";
}
var $9481eb156b453e62$var$lt = {
    is_supported: function() {
        return !!$9481eb156b453e62$var$B;
    },
    error: function(e) {
        $9481eb156b453e62$var$H.error("cookieStore error: " + e);
    },
    get: function(e) {
        if ($9481eb156b453e62$var$B) {
            try {
                for(var t = e + "=", n = $9481eb156b453e62$var$B.cookie.split(";").filter(function(e) {
                    return e.length;
                }), r = 0; r < n.length; r++){
                    for(var i = n[r]; " " == i.charAt(0);)i = i.substring(1, i.length);
                    if (0 === i.indexOf(t)) return decodeURIComponent(i.substring(t.length, i.length));
                }
            } catch (e) {}
            return null;
        }
    },
    parse: function(e) {
        var t;
        try {
            t = JSON.parse($9481eb156b453e62$var$lt.get(e)) || {};
        } catch (e) {}
        return t;
    },
    set: function(e, t, n, r, i) {
        if ($9481eb156b453e62$var$B) try {
            var o = "", s = "", a = $9481eb156b453e62$var$ut($9481eb156b453e62$var$B.location.hostname, r);
            if (n) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * n * 3600000), o = "; expires=" + u.toUTCString();
            }
            i && (s = "; secure");
            var l = e + "=" + encodeURIComponent(JSON.stringify(t)) + o + "; SameSite=Lax; path=/" + a + s;
            return l.length > 3686.4 && $9481eb156b453e62$var$H.warn("cookieStore warning: large cookie, len=" + l.length), $9481eb156b453e62$var$B.cookie = l, l;
        } catch (e) {
            return;
        }
    },
    remove: function(e, t) {
        try {
            $9481eb156b453e62$var$lt.set(e, "", -1, t);
        } catch (e) {
            return;
        }
    }
}, $9481eb156b453e62$var$ct = null, $9481eb156b453e62$var$dt = {
    is_supported: function() {
        if (!$9481eb156b453e62$var$C($9481eb156b453e62$var$ct)) return $9481eb156b453e62$var$ct;
        var e = !0;
        if ($9481eb156b453e62$var$R($9481eb156b453e62$var$D)) e = !1;
        else try {
            var t = "__mplssupport__";
            $9481eb156b453e62$var$dt.set(t, "xyz"), '"xyz"' !== $9481eb156b453e62$var$dt.get(t) && (e = !1), $9481eb156b453e62$var$dt.remove(t);
        } catch (t) {
            e = !1;
        }
        return e || $9481eb156b453e62$var$H.error("localStorage unsupported; falling back to cookie store"), $9481eb156b453e62$var$ct = e, e;
    },
    error: function(e) {
        $9481eb156b453e62$var$H.error("localStorage error: " + e);
    },
    get: function(e) {
        try {
            return null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.localStorage.getItem(e);
        } catch (e) {
            $9481eb156b453e62$var$dt.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($9481eb156b453e62$var$dt.get(e)) || {};
        } catch (e) {}
        return null;
    },
    set: function(e, t) {
        try {
            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.localStorage.setItem(e, JSON.stringify(t));
        } catch (e) {
            $9481eb156b453e62$var$dt.error(e);
        }
    },
    remove: function(e) {
        try {
            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.localStorage.removeItem(e);
        } catch (e) {
            $9481eb156b453e62$var$dt.error(e);
        }
    }
}, $9481eb156b453e62$var$ht = [
    "distinct_id",
    $9481eb156b453e62$var$$e,
    $9481eb156b453e62$var$Oe
], $9481eb156b453e62$var$ft = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, $9481eb156b453e62$var$dt), {}, {
    parse: function(e) {
        try {
            var t = {};
            try {
                t = $9481eb156b453e62$var$lt.parse(e) || {};
            } catch (e) {}
            var n = $9481eb156b453e62$var$z(t, JSON.parse($9481eb156b453e62$var$dt.get(e) || "{}"));
            return $9481eb156b453e62$var$dt.set(e, n), n;
        } catch (e) {}
        return null;
    },
    set: function(e, t, n, r, i) {
        try {
            $9481eb156b453e62$var$dt.set(e, t);
            var o = {};
            $9481eb156b453e62$var$ht.forEach(function(e) {
                t[e] && (o[e] = t[e]);
            }), Object.keys(o).length && $9481eb156b453e62$var$lt.set(e, o, n, r, i);
        } catch (e) {
            $9481eb156b453e62$var$dt.error(e);
        }
    },
    remove: function(e, t) {
        try {
            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.localStorage.removeItem(e), $9481eb156b453e62$var$lt.remove(e, t);
        } catch (e) {
            $9481eb156b453e62$var$dt.error(e);
        }
    }
}), $9481eb156b453e62$var$pt = {}, $9481eb156b453e62$var$_t = {
    is_supported: function() {
        return !0;
    },
    error: function(e) {
        $9481eb156b453e62$var$H.error("memoryStorage error: " + e);
    },
    get: function(e) {
        return $9481eb156b453e62$var$pt[e] || null;
    },
    parse: function(e) {
        return $9481eb156b453e62$var$pt[e] || null;
    },
    set: function(e, t) {
        $9481eb156b453e62$var$pt[e] = t;
    },
    remove: function(e) {
        delete $9481eb156b453e62$var$pt[e];
    }
}, $9481eb156b453e62$var$gt = null, $9481eb156b453e62$var$vt = {
    is_supported: function() {
        if (!$9481eb156b453e62$var$C($9481eb156b453e62$var$gt)) return $9481eb156b453e62$var$gt;
        if ($9481eb156b453e62$var$gt = !0, $9481eb156b453e62$var$R($9481eb156b453e62$var$D)) $9481eb156b453e62$var$gt = !1;
        else try {
            var e = "__support__";
            $9481eb156b453e62$var$vt.set(e, "xyz"), '"xyz"' !== $9481eb156b453e62$var$vt.get(e) && ($9481eb156b453e62$var$gt = !1), $9481eb156b453e62$var$vt.remove(e);
        } catch (e) {
            $9481eb156b453e62$var$gt = !1;
        }
        return $9481eb156b453e62$var$gt;
    },
    error: function(e) {
        $9481eb156b453e62$var$H.error("sessionStorage error: ", e);
    },
    get: function(e) {
        try {
            return null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.sessionStorage.getItem(e);
        } catch (e) {
            $9481eb156b453e62$var$vt.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($9481eb156b453e62$var$vt.get(e)) || null;
        } catch (e) {}
        return null;
    },
    set: function(e, t) {
        try {
            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.sessionStorage.setItem(e, JSON.stringify(t));
        } catch (e) {
            $9481eb156b453e62$var$vt.error(e);
        }
    },
    remove: function(e) {
        try {
            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.sessionStorage.removeItem(e);
        } catch (e) {
            $9481eb156b453e62$var$vt.error(e);
        }
    }
}, $9481eb156b453e62$var$mt = [
    "localhost",
    "127.0.0.1"
], $9481eb156b453e62$var$yt = function(e) {
    var t = null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.createElement("a");
    return $9481eb156b453e62$var$R(t) ? null : (t.href = e, t);
}, $9481eb156b453e62$var$bt = function(e, t) {
    return !!function(e) {
        try {
            new RegExp(e);
        } catch (e) {
            return !1;
        }
        return !0;
    }(t) && new RegExp(t).test(e);
}, $9481eb156b453e62$var$kt = function(e, t) {
    for(var n, r = ((e.split("#")[0] || "").split("?")[1] || "").split("&"), i = 0; i < r.length; i++){
        var o = r[i].split("=");
        if (o[0] === t) {
            n = o;
            break;
        }
    }
    if (!$9481eb156b453e62$var$S(n) || n.length < 2) return "";
    var s = n[1];
    try {
        s = decodeURIComponent(s);
    } catch (e) {
        $9481eb156b453e62$var$H.error("Skipping decoding for malformed query param: " + s);
    }
    return s.replace(/\+/g, " ");
}, $9481eb156b453e62$var$wt = function(e, t) {
    var n = e.match(new RegExp(t + "=([^&]*)"));
    return n ? n[1] : null;
};
var $9481eb156b453e62$var$St = {
    campaignParams: function(e) {
        var t = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_content",
            "utm_term",
            "gclid",
            "gad_source",
            "gbraid",
            "wbraid",
            "fbclid",
            "msclkid"
        ].concat(e || []), n = {};
        return $9481eb156b453e62$var$G(t, function(e) {
            var t = $9481eb156b453e62$var$B ? $9481eb156b453e62$var$kt($9481eb156b453e62$var$B.URL, e) : "";
            t.length && (n[e] = t);
        }), n;
    },
    searchEngine: function() {
        var e = null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.referrer;
        return e ? 0 === e.search("https?://(.*)google.([^/?]*)") ? "google" : 0 === e.search("https?://(.*)bing.com") ? "bing" : 0 === e.search("https?://(.*)yahoo.com") ? "yahoo" : 0 === e.search("https?://(.*)duckduckgo.com") ? "duckduckgo" : null : null;
    },
    searchInfo: function() {
        var e = $9481eb156b453e62$var$St.searchEngine(), t = "yahoo" != e ? "q" : "p", n = {};
        if (!$9481eb156b453e62$var$C(e)) {
            n.$search_engine = e;
            var r = $9481eb156b453e62$var$B ? $9481eb156b453e62$var$kt($9481eb156b453e62$var$B.referrer, t) : "";
            r.length && (n.ph_keyword = r);
        }
        return n;
    },
    browser: function(e, t, n) {
        return t = t || "", n || $9481eb156b453e62$var$Y(e, " OPR/") ? $9481eb156b453e62$var$Y(e, "Mini") ? "Opera Mini" : "Opera" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : $9481eb156b453e62$var$Y(e, "IEMobile") || $9481eb156b453e62$var$Y(e, "WPDesktop") ? "Internet Explorer Mobile" : $9481eb156b453e62$var$Y(e, "SamsungBrowser/") ? "Samsung Internet" : $9481eb156b453e62$var$Y(e, "Edge") || $9481eb156b453e62$var$Y(e, "Edg/") ? "Microsoft Edge" : $9481eb156b453e62$var$Y(e, "FBIOS") ? "Facebook Mobile" : $9481eb156b453e62$var$Y(e, "Chrome") ? "Chrome" : $9481eb156b453e62$var$Y(e, "CriOS") ? "Chrome iOS" : $9481eb156b453e62$var$Y(e, "UCWEB") || $9481eb156b453e62$var$Y(e, "UCBrowser") ? "UC Browser" : $9481eb156b453e62$var$Y(e, "FxiOS") ? "Firefox iOS" : $9481eb156b453e62$var$Y(t, "Apple") || function(e) {
            return $9481eb156b453e62$var$Y(e, "Safari") && !$9481eb156b453e62$var$Y(e, "Chrome") && !$9481eb156b453e62$var$Y(e, "Android");
        }(e) ? $9481eb156b453e62$var$Y(e, "Mobile") ? "Mobile Safari" : "Safari" : $9481eb156b453e62$var$Y(e, "Android") ? "Android Mobile" : $9481eb156b453e62$var$Y(e, "Konqueror") || $9481eb156b453e62$var$Y(e, "konqueror") ? "Konqueror" : $9481eb156b453e62$var$Y(e, "Firefox") ? "Firefox" : $9481eb156b453e62$var$Y(e, "MSIE") || $9481eb156b453e62$var$Y(e, "Trident/") ? "Internet Explorer" : $9481eb156b453e62$var$Y(e, "Gecko") ? "Mozilla" : "";
    },
    browserVersion: function(e, t, n) {
        var r = {
            "Internet Explorer Mobile": [
                /rv:(\d+(\.\d+)?)/
            ],
            "Microsoft Edge": [
                /Edge?\/(\d+(\.\d+)?)/
            ],
            Chrome: [
                /Chrome\/(\d+(\.\d+)?)/
            ],
            "Chrome iOS": [
                /CriOS\/(\d+(\.\d+)?)/
            ],
            "UC Browser": [
                /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/
            ],
            Safari: [
                /Version\/(\d+(\.\d+)?)/
            ],
            "Mobile Safari": [
                /Version\/(\d+(\.\d+)?)/
            ],
            Opera: [
                /(Opera|OPR)\/(\d+(\.\d+)?)/
            ],
            Firefox: [
                /Firefox\/(\d+(\.\d+)?)/
            ],
            "Firefox iOS": [
                /FxiOS\/(\d+(\.\d+)?)/
            ],
            Konqueror: [
                /Konqueror[:/]?(\d+(\.\d+)?)/i
            ],
            BlackBerry: [
                /BlackBerry (\d+(\.\d+)?)/,
                /Version\/(\d+(\.\d+)?)/
            ],
            "Android Mobile": [
                /android\s(\d+(\.\d+)?)/
            ],
            "Samsung Internet": [
                /SamsungBrowser\/(\d+(\.\d+)?)/
            ],
            "Internet Explorer": [
                /(rv:|MSIE )(\d+(\.\d+)?)/
            ],
            Mozilla: [
                /rv:(\d+(\.\d+)?)/
            ]
        }[$9481eb156b453e62$var$St.browser(e, t, n)];
        if ($9481eb156b453e62$var$R(r)) return null;
        for(var i = 0; i < r.length; i++){
            var o = r[i], s = e.match(o);
            if (s) return parseFloat(s[s.length - 2]);
        }
        return null;
    },
    browserLanguage: function() {
        return navigator.language || navigator.userLanguage;
    },
    os: function(e) {
        if (/Windows/i.test(e)) {
            if (/Phone/.test(e) || /WPDesktop/.test(e)) return {
                os_name: "Windows Phone",
                os_version: ""
            };
            var t = /Windows NT ([0-9.]+)/i.exec(e);
            return t && t[1] ? {
                os_name: "Windows",
                os_version: t[1]
            } : {
                os_name: "Windows",
                os_version: ""
            };
        }
        if (/(iPhone|iPad|iPod)/.test(e)) {
            var n = /OS (\d+)_(\d+)_?(\d+)?/i.exec(e);
            return n && n[1] ? {
                os_name: "iOS",
                os_version: [
                    n[1],
                    n[2],
                    n[3] || "0"
                ].join(".")
            } : {
                os_name: "iOS",
                os_version: ""
            };
        }
        if (/Android/.test(e)) {
            var r = /Android (\d+)\.(\d+)\.?(\d+)?/i.exec(e);
            return r && r[1] ? {
                os_name: "Android",
                os_version: [
                    r[1],
                    r[2],
                    r[3] || "0"
                ].join(".")
            } : {
                os_name: "Android",
                os_version: ""
            };
        }
        if (/(BlackBerry|PlayBook|BB10)/i.test(e)) return {
            os_name: "BlackBerry",
            os_version: ""
        };
        if (/Mac/i.test(e)) {
            var i = /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i.exec(e);
            return i && i[1] ? {
                os_name: "Mac OS X",
                os_version: [
                    i[1],
                    i[2],
                    i[3] || "0"
                ].join(".")
            } : {
                os_name: "Mac OS X",
                os_version: ""
            };
        }
        return /Linux/.test(e) ? {
            os_name: "Linux",
            os_version: ""
        } : /CrOS/.test(e) ? {
            os_name: "Chrome OS",
            os_version: ""
        } : {
            os_name: "",
            os_version: ""
        };
    },
    device: function(e) {
        return /Windows Phone/i.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : /iPad/.test(e) ? "iPad" : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Android/.test(e) && !/Mobile/.test(e) ? "Android Tablet" : /Android/.test(e) ? "Android" : "";
    },
    deviceType: function(e) {
        var t = this.device(e);
        return "iPad" === t || "Android Tablet" === t ? "Tablet" : t ? "Mobile" : "Desktop";
    },
    referrer: function() {
        return (null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.referrer) || "$direct";
    },
    referringDomain: function() {
        var e;
        return null != $9481eb156b453e62$var$B && $9481eb156b453e62$var$B.referrer && (null === (e = $9481eb156b453e62$var$yt($9481eb156b453e62$var$B.referrer)) || void 0 === e ? void 0 : e.host) || "$direct";
    },
    properties: function() {
        if (!$9481eb156b453e62$var$N) return {};
        var e = $9481eb156b453e62$var$St.os($9481eb156b453e62$var$N), t = e.os_name, n = e.os_version;
        return $9481eb156b453e62$var$z($9481eb156b453e62$var$Z({
            $os: t,
            $os_version: n,
            $browser: $9481eb156b453e62$var$St.browser($9481eb156b453e62$var$N, navigator.vendor, $9481eb156b453e62$var$L.opera),
            $device: $9481eb156b453e62$var$St.device($9481eb156b453e62$var$N),
            $device_type: $9481eb156b453e62$var$St.deviceType($9481eb156b453e62$var$N)
        }), {
            $current_url: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.href,
            $host: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.host,
            $pathname: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.pathname,
            $raw_user_agent: $9481eb156b453e62$var$N.length > 1e3 ? $9481eb156b453e62$var$N.substring(0, 997) + "..." : $9481eb156b453e62$var$N,
            $browser_version: $9481eb156b453e62$var$St.browserVersion($9481eb156b453e62$var$N, navigator.vendor, $9481eb156b453e62$var$L.opera),
            $browser_language: $9481eb156b453e62$var$St.browserLanguage(),
            $screen_height: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.screen.height,
            $screen_width: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.screen.width,
            $viewport_height: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.innerHeight,
            $viewport_width: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.innerWidth,
            $lib: "web",
            $lib_version: $9481eb156b453e62$var$m.LIB_VERSION,
            $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
            $time: $9481eb156b453e62$var$J() / 1e3
        });
    },
    people_properties: function() {
        if (!$9481eb156b453e62$var$N) return {};
        var e = $9481eb156b453e62$var$St.os($9481eb156b453e62$var$N), t = e.os_name, n = e.os_version;
        return $9481eb156b453e62$var$z($9481eb156b453e62$var$Z({
            $os: t,
            $os_version: n,
            $browser: $9481eb156b453e62$var$St.browser($9481eb156b453e62$var$N, navigator.vendor, $9481eb156b453e62$var$L.opera)
        }), {
            $browser_version: $9481eb156b453e62$var$St.browserVersion($9481eb156b453e62$var$N, navigator.vendor, $9481eb156b453e62$var$L.opera)
        });
    }
}, $9481eb156b453e62$var$Ft = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
], $9481eb156b453e62$var$Pt = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e);
        var n = "";
        t.token && (n = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), this.props = {}, this.campaign_params_saved = !1, this.custom_campaign_params = t.custom_campaign_params || [], t.persistence_name ? this.name = "ph_" + t.persistence_name : this.name = "ph_" + n + "_posthog", -1 === $9481eb156b453e62$var$Ft.indexOf(t.persistence.toLowerCase()) && ($9481eb156b453e62$var$H.critical("Unknown persistence type " + t.persistence + "; falling back to localStorage+cookie"), t.persistence = "localStorage+cookie");
        var i = t.persistence.toLowerCase();
        "localstorage" === i && $9481eb156b453e62$var$dt.is_supported() ? this.storage = $9481eb156b453e62$var$dt : "localstorage+cookie" === i && $9481eb156b453e62$var$ft.is_supported() ? this.storage = $9481eb156b453e62$var$ft : "sessionstorage" === i && $9481eb156b453e62$var$vt.is_supported() ? this.storage = $9481eb156b453e62$var$vt : "memory" === i ? this.storage = $9481eb156b453e62$var$_t : "cookie" === i ? this.storage = $9481eb156b453e62$var$lt : $9481eb156b453e62$var$ft.is_supported() ? this.storage = $9481eb156b453e62$var$ft : this.storage = $9481eb156b453e62$var$lt, this.load(), this.update_config(t), this.save();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "properties",
            value: function() {
                var e = {};
                return $9481eb156b453e62$var$G(this.props, function(t, n) {
                    if (n === $9481eb156b453e62$var$Me && $9481eb156b453e62$var$I(t)) for(var r = Object.keys(t), i = 0; i < r.length; i++)e["$feature/".concat(r[i])] = t[r[i]];
                    else s = n, a = !1, ($9481eb156b453e62$var$C(o = $9481eb156b453e62$var$He) ? a : $9481eb156b453e62$var$T && o.indexOf === $9481eb156b453e62$var$T ? -1 != o.indexOf(s) : ($9481eb156b453e62$var$G(o, function(e) {
                        if (a || (a = e === s)) return $9481eb156b453e62$var$V;
                    }), a)) || (e[n] = t);
                    var o, s, a;
                }), e;
            }
        },
        {
            key: "load",
            value: function() {
                if (!this.disabled) {
                    var e = this.storage.parse(this.name);
                    e && (this.props = $9481eb156b453e62$var$z({}, e));
                }
            }
        },
        {
            key: "save",
            value: function() {
                this.disabled || this.storage.set(this.name, this.props, this.expire_days, this.cross_subdomain, this.secure);
            }
        },
        {
            key: "remove",
            value: function() {
                this.storage.remove(this.name, !1), this.storage.remove(this.name, !0);
            }
        },
        {
            key: "clear",
            value: function() {
                this.remove(), this.props = {};
            }
        },
        {
            key: "register_once",
            value: function(e, t, n) {
                var r = this;
                if ($9481eb156b453e62$var$I(e)) {
                    $9481eb156b453e62$var$R(t) && (t = "None"), this.expire_days = $9481eb156b453e62$var$R(n) ? this.default_expiry : n;
                    var i = !1;
                    if ($9481eb156b453e62$var$G(e, function(e, n) {
                        r.props.hasOwnProperty(n) && r.props[n] !== t || (r.props[n] = e, i = !0);
                    }), i) return this.save(), !0;
                }
                return !1;
            }
        },
        {
            key: "register",
            value: function(e, t) {
                var n = this;
                if ($9481eb156b453e62$var$I(e)) {
                    this.expire_days = $9481eb156b453e62$var$R(t) ? this.default_expiry : t;
                    var r = !1;
                    if ($9481eb156b453e62$var$G(e, function(t, i) {
                        e.hasOwnProperty(i) && n.props[i] !== t && (n.props[i] = t, r = !0);
                    }), r) return this.save(), !0;
                }
                return !1;
            }
        },
        {
            key: "unregister",
            value: function(e) {
                e in this.props && (delete this.props[e], this.save());
            }
        },
        {
            key: "update_campaign_params",
            value: function() {
                this.campaign_params_saved || (this.register($9481eb156b453e62$var$St.campaignParams(this.custom_campaign_params)), this.campaign_params_saved = !0);
            }
        },
        {
            key: "update_search_keyword",
            value: function() {
                this.register($9481eb156b453e62$var$St.searchInfo());
            }
        },
        {
            key: "update_referrer_info",
            value: function() {
                this.register({
                    $referrer: this.props.$referrer || $9481eb156b453e62$var$St.referrer(),
                    $referring_domain: this.props.$referring_domain || $9481eb156b453e62$var$St.referringDomain()
                });
            }
        },
        {
            key: "get_referrer_info",
            value: function() {
                return $9481eb156b453e62$var$Z({
                    $referrer: this.props.$referrer,
                    $referring_domain: this.props.$referring_domain
                });
            }
        },
        {
            key: "safe_merge",
            value: function(e) {
                return $9481eb156b453e62$var$G(this.props, function(t, n) {
                    n in e || (e[n] = t);
                }), e;
            }
        },
        {
            key: "update_config",
            value: function(e) {
                this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie);
            }
        },
        {
            key: "set_disabled",
            value: function(e) {
                this.disabled = e, this.disabled ? this.remove() : this.save();
            }
        },
        {
            key: "set_cross_subdomain",
            value: function(e) {
                e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
            }
        },
        {
            key: "get_cross_subdomain",
            value: function() {
                return !!this.cross_subdomain;
            }
        },
        {
            key: "set_secure",
            value: function(e) {
                e !== this.secure && (this.secure = e, this.remove(), this.save());
            }
        },
        {
            key: "set_event_timer",
            value: function(e, t) {
                var n = this.props[$9481eb156b453e62$var$Pe] || {};
                n[e] = t, this.props[$9481eb156b453e62$var$Pe] = n, this.save();
            }
        },
        {
            key: "remove_event_timer",
            value: function(e) {
                var t = (this.props[$9481eb156b453e62$var$Pe] || {})[e];
                return $9481eb156b453e62$var$R(t) || (delete this.props[$9481eb156b453e62$var$Pe][e], this.save()), t;
            }
        },
        {
            key: "get_user_state",
            value: function() {
                return this.props[$9481eb156b453e62$var$Ne] || "anonymous";
            }
        },
        {
            key: "set_user_state",
            value: function(e) {
                this.props[$9481eb156b453e62$var$Ne] = e, this.save();
            }
        },
        {
            key: "get_quota_limits",
            value: function() {
                return this.props[$9481eb156b453e62$var$Le] || {};
            }
        },
        {
            key: "set_quota_limits",
            value: function(e) {
                this.props[$9481eb156b453e62$var$Le] = e, this.save();
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$It = 2, $9481eb156b453e62$var$xt = 4, $9481eb156b453e62$var$Rt = 3, $9481eb156b453e62$var$Et = 6, $9481eb156b453e62$var$Ct = 0, $9481eb156b453e62$var$$t = "rrweb/console@1";
var $9481eb156b453e62$var$Ot = $9481eb156b453e62$var$o(function e(t) {
    var n, i, o = this, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "bucketSize", 100), $9481eb156b453e62$var$s(this, "refillRate", 10), $9481eb156b453e62$var$s(this, "mutationBuckets", {}), $9481eb156b453e62$var$s(this, "loggedTracker", {}), $9481eb156b453e62$var$s(this, "refillBuckets", function() {
        Object.keys(o.mutationBuckets).forEach(function(e) {
            o.mutationBuckets[e] = o.mutationBuckets[e] + o.refillRate, o.mutationBuckets[e] >= o.bucketSize && delete o.mutationBuckets[e];
        });
    }), $9481eb156b453e62$var$s(this, "getNodeOrRelevantParent", function(e) {
        var t = o.rrweb.mirror.getNode(e);
        if ("svg" !== (null == t ? void 0 : t.nodeName) && t instanceof Element) {
            var n = t.closest("svg");
            if (n) return [
                o.rrweb.mirror.getId(n),
                n
            ];
        }
        return [
            e,
            t
        ];
    }), $9481eb156b453e62$var$s(this, "numberOfChanges", function(e) {
        var t, n, r, i, o, s, a, u;
        return (null !== (t = null === (n = e.removes) || void 0 === n ? void 0 : n.length) && void 0 !== t ? t : 0) + (null !== (r = null === (i = e.attributes) || void 0 === i ? void 0 : i.length) && void 0 !== r ? r : 0) + (null !== (o = null === (s = e.texts) || void 0 === s ? void 0 : s.length) && void 0 !== o ? o : 0) + (null !== (a = null === (u = e.adds) || void 0 === u ? void 0 : u.length) && void 0 !== a ? a : 0);
    }), $9481eb156b453e62$var$s(this, "throttleMutations", function(e) {
        if (e.type !== $9481eb156b453e62$var$Rt || e.data.source !== $9481eb156b453e62$var$Ct) return e;
        var t = e.data, n = o.numberOfChanges(t);
        t.attributes && (t.attributes = t.attributes.filter(function(e) {
            var t, n, r, i = $9481eb156b453e62$var$f(o.getNodeOrRelevantParent(e.id), 2), s = i[0], a = i[1];
            if (0 === o.mutationBuckets[s]) return !1;
            (o.mutationBuckets[s] = null !== (t = o.mutationBuckets[s]) && void 0 !== t ? t : o.bucketSize, o.mutationBuckets[s] = Math.max(o.mutationBuckets[s] - 1, 0), 0 === o.mutationBuckets[s]) && (o.loggedTracker[s] || (o.loggedTracker[s] = !0, null === (n = (r = o.options).onBlockedNode) || void 0 === n || n.call(r, s, a)));
            return e;
        }));
        var r = o.numberOfChanges(t);
        return 0 !== r || n === r ? e : void 0;
    }), this.rrweb = t, this.options = a, this.refillRate = null !== (n = this.options.refillRate) && void 0 !== n ? n : this.refillRate, this.bucketSize = null !== (i = this.options.bucketSize) && void 0 !== i ? i : this.bucketSize, setInterval(function() {
        o.refillBuckets();
    }, 1e3);
}), $9481eb156b453e62$var$Mt = function(e) {
    return e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e;
}($9481eb156b453e62$var$Mt || {}), $9481eb156b453e62$var$At = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: function(e) {
        return e;
    },
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6
}, $9481eb156b453e62$var$Tt = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], $9481eb156b453e62$var$Dt = [
    "/s/",
    "/e/",
    "/i/vo/e/"
];
function $9481eb156b453e62$var$qt(e, t, n, r) {
    var i = null == t ? void 0 : t["content-length"];
    return i && parseInt(i) > n ? "".concat(r, " body too large to record") : e;
}
var $9481eb156b453e62$var$Bt, $9481eb156b453e62$var$Nt = function(e, n) {
    var r, i, o, s = e.session_recording, a = !1 !== s.recordHeaders && n.recordHeaders, u = !1 !== s.recordBody && n.recordBody, l = !1 !== s.recordPerformance && n.recordPerformance, c = (r = s, o = Math.min(1e6, null !== (i = r.payloadSizeLimitBytes) && void 0 !== i ? i : 1e6), function(e) {
        return null != e && e.requestBody && (e.requestBody = $9481eb156b453e62$var$qt(e.requestBody, e.requestHeaders, o, "Request")), null != e && e.responseBody && (e.responseBody = $9481eb156b453e62$var$qt(e.responseBody, e.responseHeaders, o, "Response")), e;
    }), d = function(e) {
        var t, n;
        return c(function(e) {
            var t = $9481eb156b453e62$var$yt(e.name);
            if (!(t && t.pathname && $9481eb156b453e62$var$Dt.includes(t.pathname))) return e;
        }((t = e, Object.keys(null !== (n = t.requestHeaders) && void 0 !== n ? n : {}).forEach(function(e) {
            var n;
            $9481eb156b453e62$var$Tt.includes(e.toLowerCase()) && (null === (n = t.requestHeaders) || void 0 === n || delete n[e]);
        }), t)));
    }, h = $9481eb156b453e62$var$P(e.session_recording.maskNetworkRequestFn);
    return h && $9481eb156b453e62$var$P(e.session_recording.maskCapturedNetworkRequestFn) && $9481eb156b453e62$var$H.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), h && (e.session_recording.maskCapturedNetworkRequestFn = function(n) {
        var r = e.session_recording.maskNetworkRequestFn({
            url: n.name
        });
        return $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, n), {}, {
            name: null == r ? void 0 : r.url
        });
    }), s.maskRequestFn = $9481eb156b453e62$var$P(e.session_recording.maskCapturedNetworkRequestFn) ? function(t) {
        var n, r, i, o = d(t);
        return o && null !== (n = null === (r = (i = e.session_recording).maskCapturedNetworkRequestFn) || void 0 === r ? void 0 : r.call(i, o)) && void 0 !== n ? n : void 0;
    } : void 0, s.maskRequestFn || (s.maskRequestFn = d), $9481eb156b453e62$var$t($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, $9481eb156b453e62$var$At), s), {}, {
        recordHeaders: a,
        recordBody: u,
        recordPerformance: l,
        recordInitialRequests: l
    });
}, $9481eb156b453e62$var$Lt = "/s/", $9481eb156b453e62$var$jt = 3e5;
!function(e) {
    e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet";
}($9481eb156b453e62$var$Bt || ($9481eb156b453e62$var$Bt = {}));
var $9481eb156b453e62$var$Ht = [
    $9481eb156b453e62$var$Bt.MouseMove,
    $9481eb156b453e62$var$Bt.MouseInteraction,
    $9481eb156b453e62$var$Bt.Scroll,
    $9481eb156b453e62$var$Bt.ViewportResize,
    $9481eb156b453e62$var$Bt.Input,
    $9481eb156b453e62$var$Bt.TouchMove,
    $9481eb156b453e62$var$Bt.MediaInteraction,
    $9481eb156b453e62$var$Bt.Drag
], $9481eb156b453e62$var$Vt = function() {
    function e(t) {
        var n = this;
        if ($9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "isIdle", !1), $9481eb156b453e62$var$s(this, "_linkedFlagSeen", !1), $9481eb156b453e62$var$s(this, "_lastActivityTimestamp", Date.now()), $9481eb156b453e62$var$s(this, "windowId", null), $9481eb156b453e62$var$s(this, "sessionId", null), $9481eb156b453e62$var$s(this, "_linkedFlag", null), $9481eb156b453e62$var$s(this, "_sampleRate", null), $9481eb156b453e62$var$s(this, "_minimumDuration", null), $9481eb156b453e62$var$s(this, "_forceAllowLocalhostNetworkCapture", !1), this.instance = t, this._captureStarted = !1, this._endpoint = $9481eb156b453e62$var$Lt, this.stopRrweb = void 0, this.receivedDecide = !1, null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.addEventListener("beforeunload", function() {
            n._flushBuffer();
        }), !this.instance.sessionManager) throw $9481eb156b453e62$var$H.error("Session recording started without valid sessionManager"), new Error("Session recording started without valid sessionManager. This is a bug.");
        this.buffer = this.clearBuffer();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "started",
            get: function() {
                return this._captureStarted;
            }
        },
        {
            key: "sessionManager",
            get: function() {
                if (!this.instance.sessionManager) throw $9481eb156b453e62$var$H.error("Session recording started without valid sessionManager"), new Error("Session recording started without valid sessionManager. This is a bug.");
                return this.instance.sessionManager;
            }
        },
        {
            key: "isSampled",
            get: function() {
                return $9481eb156b453e62$var$$(this._sampleRate) ? this.instance.get_property($9481eb156b453e62$var$Oe) : null;
            }
        },
        {
            key: "sessionDuration",
            get: function() {
                var e, t, n = null === (e = this.buffer) || void 0 === e ? void 0 : e.data[(null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) - 1], r = this.sessionManager.checkAndGetSessionAndWindowId(!0).sessionStartTimestamp;
                return n ? n.timestamp - r : null;
            }
        },
        {
            key: "isRecordingEnabled",
            get: function() {
                var e = !!this.instance.get_property($9481eb156b453e62$var$xe), t = !this.instance.config.disable_session_recording;
                return $9481eb156b453e62$var$D && e && t;
            }
        },
        {
            key: "isConsoleLogCaptureEnabled",
            get: function() {
                var e = !!this.instance.get_property($9481eb156b453e62$var$Re), t = this.instance.config.enable_recording_console_log;
                return null != t ? t : e;
            }
        },
        {
            key: "recordingVersion",
            get: function() {
                var e, t = this.instance.get_property($9481eb156b453e62$var$Ee);
                return (null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.recorderVersion) || t || "v1";
            }
        },
        {
            key: "networkPayloadCapture",
            get: function() {
                var e, t, n = this.instance.get_property($9481eb156b453e62$var$Ce), r = {
                    recordHeaders: null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.recordHeaders,
                    recordBody: null === (t = this.instance.config.session_recording) || void 0 === t ? void 0 : t.recordBody
                }, i = (null == r ? void 0 : r.recordHeaders) || (null == n ? void 0 : n.recordHeaders), o = (null == r ? void 0 : r.recordBody) || (null == n ? void 0 : n.recordBody), s = this.instance.config.capture_performance || (null == n ? void 0 : n.capturePerformance);
                return i || o || s ? {
                    recordHeaders: i,
                    recordBody: o,
                    recordPerformance: s
                } : void 0;
            }
        },
        {
            key: "status",
            get: function() {
                return this.receivedDecide ? this.isRecordingEnabled ? $9481eb156b453e62$var$E(this._linkedFlag) && !this._linkedFlagSeen ? "buffering" : $9481eb156b453e62$var$O(this.isSampled) ? this.isSampled ? "sampled" : "disabled" : "active" : "disabled" : "buffering";
            }
        },
        {
            key: "startRecordingIfEnabled",
            value: function() {
                this.isRecordingEnabled ? this.startCaptureAndTrySendingQueuedSnapshots() : (this.stopRecording(), this.clearBuffer());
            }
        },
        {
            key: "stopRecording",
            value: function() {
                this._captureStarted && this.stopRrweb && (this.stopRrweb(), this.stopRrweb = void 0, this._captureStarted = !1);
            }
        },
        {
            key: "makeSamplingDecision",
            value: function(e) {
                var t, n = this.sessionId !== e;
                if ($9481eb156b453e62$var$$(this._sampleRate)) {
                    var r, i = this.isSampled;
                    if (n || !$9481eb156b453e62$var$O(i)) r = Math.random() < this._sampleRate;
                    else r = i;
                    r || $9481eb156b453e62$var$H.warn("[SessionSampling] Sample rate (".concat(this._sampleRate, ") has determined that this sessionId (").concat(e, ") will not be sent to the server.")), null === (t = this.instance.persistence) || void 0 === t || t.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Oe, r));
                } else {
                    var o;
                    null === (o = this.instance.persistence) || void 0 === o || o.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Oe, null));
                }
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var n, r, i, o, a, u, l, c, d = this;
                this.instance.persistence && this.instance.persistence.register(($9481eb156b453e62$var$s(c = {}, $9481eb156b453e62$var$xe, !!e.sessionRecording), $9481eb156b453e62$var$s(c, $9481eb156b453e62$var$Re, null === (a = e.sessionRecording) || void 0 === a ? void 0 : a.consoleLogRecordingEnabled), $9481eb156b453e62$var$s(c, $9481eb156b453e62$var$Ee, null === (u = e.sessionRecording) || void 0 === u ? void 0 : u.recorderVersion), $9481eb156b453e62$var$s(c, $9481eb156b453e62$var$Ce, $9481eb156b453e62$var$t({
                    capturePerformance: e.capturePerformance
                }, null === (l = e.sessionRecording) || void 0 === l ? void 0 : l.networkPayloadCapture)), c));
                var h = null === (n = e.sessionRecording) || void 0 === n ? void 0 : n.sampleRate;
                this._sampleRate = $9481eb156b453e62$var$R(h) || $9481eb156b453e62$var$C(h) ? null : parseFloat(h);
                var f, p = null === (r = e.sessionRecording) || void 0 === r ? void 0 : r.minimumDurationMilliseconds;
                (this._minimumDuration = $9481eb156b453e62$var$R(p) ? null : p, this._linkedFlag = (null === (i = e.sessionRecording) || void 0 === i ? void 0 : i.linkedFlag) || null, null !== (o = e.sessionRecording) && void 0 !== o && o.endpoint) && (this._endpoint = null === (f = e.sessionRecording) || void 0 === f ? void 0 : f.endpoint);
                if ($9481eb156b453e62$var$$(this._sampleRate) && this.sessionManager.onSessionId(function(e) {
                    d.makeSamplingDecision(e);
                }), $9481eb156b453e62$var$E(this._linkedFlag)) {
                    var _ = this._linkedFlag;
                    this.instance.onFeatureFlags(function(e) {
                        d._linkedFlagSeen = e.includes(_);
                    });
                }
                this.receivedDecide = !0, this.startRecordingIfEnabled();
            }
        },
        {
            key: "log",
            value: function(e) {
                var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "log";
                null === (t = this.instance.sessionRecording) || void 0 === t || t.onRRwebEmit({
                    type: 6,
                    data: {
                        plugin: "rrweb/console@1",
                        payload: {
                            level: n,
                            trace: [],
                            payload: [
                                JSON.stringify(e)
                            ]
                        }
                    },
                    timestamp: $9481eb156b453e62$var$J()
                });
            }
        },
        {
            key: "startCaptureAndTrySendingQueuedSnapshots",
            value: function() {
                this._startCapture();
            }
        },
        {
            key: "_startCapture",
            value: function() {
                var e = this;
                if (!$9481eb156b453e62$var$R(Object.assign) && !this._captureStarted && !this.instance.config.disable_session_recording) {
                    this._captureStarted = !0, this.sessionManager.checkAndGetSessionAndWindowId();
                    var t = "v2" === this.recordingVersion ? "recorder-v2.js" : "recorder.js";
                    this.instance.__loaded_recorder_version !== this.recordingVersion ? $9481eb156b453e62$var$oe(this.instance.config.api_host + "/static/".concat(t, "?v=").concat($9481eb156b453e62$var$m.LIB_VERSION), function(n) {
                        if (n) return $9481eb156b453e62$var$H.error("Could not load ".concat(t), n);
                        e._onScriptLoaded();
                    }) : this._onScriptLoaded();
                }
            }
        },
        {
            key: "_isInteractiveEvent",
            value: function(e) {
                var t;
                return e.type === $9481eb156b453e62$var$Rt && -1 !== $9481eb156b453e62$var$Ht.indexOf(null === (t = e.data) || void 0 === t ? void 0 : t.source);
            }
        },
        {
            key: "_updateWindowAndSessionIds",
            value: function(e) {
                var t = this._isInteractiveEvent(e);
                t || this.isIdle || e.timestamp - this._lastActivityTimestamp > $9481eb156b453e62$var$jt && (this.isIdle = !0, this._tryAddCustomEvent("sessionIdle", {
                    reason: "user inactivity",
                    timeSinceLastActive: e.timestamp - this._lastActivityTimestamp,
                    threshold: $9481eb156b453e62$var$jt
                }));
                var n = !1;
                if (t && (this._lastActivityTimestamp = e.timestamp, this.isIdle && (this.isIdle = !1, this._tryAddCustomEvent("sessionNoLongerIdle", {
                    reason: "user activity",
                    type: e.type
                }), n = !0)), !this.isIdle) {
                    var r = this.sessionManager.checkAndGetSessionAndWindowId(!t, e.timestamp), i = r.windowId, o = r.sessionId, s = this.sessionId !== o, a = this.windowId !== i;
                    this.windowId = i, this.sessionId = o, (n || -1 === [
                        $9481eb156b453e62$var$It,
                        $9481eb156b453e62$var$xt
                    ].indexOf(e.type) && (a || s)) && this._tryTakeFullSnapshot();
                }
            }
        },
        {
            key: "_tryRRwebMethod",
            value: function(e) {
                if (!this._captureStarted) return !1;
                try {
                    return e(), !0;
                } catch (e) {
                    return $9481eb156b453e62$var$H.error("[Session-Recording] using rrweb when not started.", e), !1;
                }
            }
        },
        {
            key: "_tryAddCustomEvent",
            value: function(e, t) {
                var n = this;
                return this._tryRRwebMethod(function() {
                    var r;
                    return null === (r = n.rrwebRecord) || void 0 === r ? void 0 : r.addCustomEvent(e, t);
                });
            }
        },
        {
            key: "_tryTakeFullSnapshot",
            value: function() {
                var e = this;
                return this._tryRRwebMethod(function() {
                    var t;
                    return null === (t = e.rrwebRecord) || void 0 === t ? void 0 : t.takeFullSnapshot();
                });
            }
        },
        {
            key: "_onScriptLoaded",
            value: function() {
                var e, n = this, r = {
                    blockClass: "ph-no-capture",
                    blockSelector: void 0,
                    ignoreClass: "ph-ignore-input",
                    maskTextClass: "ph-mask",
                    maskTextSelector: void 0,
                    maskTextFn: void 0,
                    maskAllInputs: !0,
                    maskInputOptions: {},
                    maskInputFn: void 0,
                    slimDOMOptions: {},
                    collectFonts: !1,
                    inlineStylesheet: !0,
                    recordCrossOriginIframes: !1
                };
                this.rrwebRecord = $9481eb156b453e62$var$D.rrweb ? $9481eb156b453e62$var$D.rrweb.record : $9481eb156b453e62$var$D.rrwebRecord;
                for(var i = this.instance.config.session_recording, o = 0, s = Object.entries(i || {}); o < s.length; o++){
                    var a = $9481eb156b453e62$var$f(s[o], 2), u = a[0], l = a[1];
                    u in r && (r[u] = l);
                }
                if (this.rrwebRecord) {
                    this.mutationRateLimiter = null !== (e = this.mutationRateLimiter) && void 0 !== e ? e : new $9481eb156b453e62$var$Ot(this.rrwebRecord, {
                        onBlockedNode: function(e, t) {
                            var r = "Too many mutations on node '".concat(e, "'. Rate limiting. This could be due to SVG animations or something similar");
                            $9481eb156b453e62$var$H.info(r, {
                                node: t
                            }), n.log("[PostHog Recorder] " + r, "warn");
                        }
                    });
                    var c = this._gatherRRWebPlugins();
                    this.stopRrweb = this.rrwebRecord($9481eb156b453e62$var$t({
                        emit: function(e) {
                            n.onRRwebEmit(e);
                        },
                        plugins: c
                    }, r)), this.instance._addCaptureHook(function(e) {
                        try {
                            if ("$pageview" === e) {
                                var t = $9481eb156b453e62$var$D ? n._maskUrl($9481eb156b453e62$var$D.location.href) : "";
                                if (!t) return;
                                n._tryAddCustomEvent("$pageview", {
                                    href: t
                                });
                            }
                        } catch (e) {
                            $9481eb156b453e62$var$H.error("Could not add $pageview to rrweb session", e);
                        }
                    }), this._lastActivityTimestamp = Date.now(), this.isIdle = !1, this._tryAddCustomEvent("$session_options", {
                        sessionRecordingOptions: r,
                        activePlugins: c.map(function(e) {
                            return null == e ? void 0 : e.name;
                        })
                    });
                } else $9481eb156b453e62$var$H.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
            }
        },
        {
            key: "_gatherRRWebPlugins",
            value: function() {
                var e = [];
                ($9481eb156b453e62$var$L.rrwebConsoleRecord && this.isConsoleLogCaptureEnabled && e.push($9481eb156b453e62$var$L.rrwebConsoleRecord.getRecordConsolePlugin()), this.networkPayloadCapture && $9481eb156b453e62$var$P($9481eb156b453e62$var$L.getRecordNetworkPlugin)) && (!$9481eb156b453e62$var$mt.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? e.push($9481eb156b453e62$var$L.getRecordNetworkPlugin($9481eb156b453e62$var$Nt(this.instance.config, this.networkPayloadCapture))) : $9481eb156b453e62$var$H.info("[SessionReplay-NetworkCapture] not started because we are on localhost."));
                return e;
            }
        },
        {
            key: "onRRwebEmit",
            value: function(e) {
                if (e && $9481eb156b453e62$var$I(e)) {
                    if (e.type === $9481eb156b453e62$var$Mt.Meta) {
                        var t = this._maskUrl(e.data.href);
                        if (!t) return;
                        e.data.href = t;
                    }
                    var n = this.mutationRateLimiter ? this.mutationRateLimiter.throttleMutations(e) : e;
                    if (n) {
                        var r = function(e) {
                            var t = e;
                            if (t && $9481eb156b453e62$var$I(t) && t.type === $9481eb156b453e62$var$Et && $9481eb156b453e62$var$I(t.data) && t.data.plugin === $9481eb156b453e62$var$$t) {
                                t.data.payload.payload.length > 10 && (t.data.payload.payload = t.data.payload.payload.slice(0, 10), t.data.payload.payload.push("...[truncated]"));
                                for(var n = [], r = 0; r < t.data.payload.payload.length; r++)t.data.payload.payload[r] && t.data.payload.payload[r].length > 2e3 ? n.push(t.data.payload.payload[r].slice(0, 2e3) + "...[truncated]") : n.push(t.data.payload.payload[r]);
                                return t.data.payload.payload = n, e;
                            }
                            return e;
                        }(n), i = JSON.stringify(r).length;
                        if (this._updateWindowAndSessionIds(r), !this.isIdle) {
                            var o = {
                                $snapshot_bytes: i,
                                $snapshot_data: r,
                                $session_id: this.sessionId,
                                $window_id: this.windowId
                            };
                            "disabled" !== this.status ? this._captureSnapshotBuffered(o) : this.clearBuffer();
                        }
                    }
                }
            }
        },
        {
            key: "_maskUrl",
            value: function(e) {
                var t = this.instance.config.session_recording;
                if (t.maskNetworkRequestFn) {
                    var n, r = {
                        url: e
                    };
                    return null === (n = r = t.maskNetworkRequestFn(r)) || void 0 === n ? void 0 : n.url;
                }
                return e;
            }
        },
        {
            key: "clearBuffer",
            value: function() {
                return this.buffer = void 0, {
                    size: 0,
                    data: [],
                    sessionId: this.sessionId,
                    windowId: this.windowId
                };
            }
        },
        {
            key: "_flushBuffer",
            value: function() {
                var e = this;
                this.flushBufferTimer && (clearTimeout(this.flushBufferTimer), this.flushBufferTimer = void 0);
                var t = this._minimumDuration, n = this.sessionDuration, r = $9481eb156b453e62$var$$(n) && n >= 0, i = $9481eb156b453e62$var$$(t) && r && n < t;
                return "buffering" === this.status || i ? (this.flushBufferTimer = setTimeout(function() {
                    e._flushBuffer();
                }, 2e3), this.buffer || this.clearBuffer()) : this.buffer && 0 !== this.buffer.data.length ? (this._captureSnapshot({
                    $snapshot_bytes: this.buffer.size,
                    $snapshot_data: this.buffer.data,
                    $session_id: this.buffer.sessionId,
                    $window_id: this.buffer.windowId
                }), this.clearBuffer()) : this.buffer || this.clearBuffer();
            }
        },
        {
            key: "_captureSnapshotBuffered",
            value: function(e) {
                var t, n = this, r = 2 + ((null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) || 0);
                (!this.buffer || this.buffer.size + e.$snapshot_bytes + r > 943718.4 || this.buffer.sessionId && this.buffer.sessionId !== this.sessionId) && (this.buffer = this._flushBuffer()), $9481eb156b453e62$var$C(this.buffer.sessionId) && !$9481eb156b453e62$var$C(this.sessionId) && (this.buffer.sessionId = this.sessionId, this.buffer.windowId = this.windowId), this.buffer.size += e.$snapshot_bytes, this.buffer.data.push(e.$snapshot_data), this.flushBufferTimer || (this.flushBufferTimer = setTimeout(function() {
                    n._flushBuffer();
                }, 2e3));
            }
        },
        {
            key: "_captureSnapshot",
            value: function(e) {
                this.instance.capture("$snapshot", e, {
                    transport: "XHR",
                    method: "POST",
                    endpoint: this._endpoint,
                    _noTruncate: !0,
                    _batchKey: "recordings",
                    _metrics: {
                        rrweb_full_snapshot: e.$snapshot_data.type === $9481eb156b453e62$var$It
                    }
                });
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Ut = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t, this.instance.decideEndpointWasHit = this.instance._hasBootstrappedFeatureFlags();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "call",
            value: function() {
                var e = this, t = $9481eb156b453e62$var$ne(JSON.stringify({
                    token: this.instance.config.token,
                    distinct_id: this.instance.get_distinct_id(),
                    groups: this.instance.getGroups(),
                    person_properties: this.instance.get_property($9481eb156b453e62$var$Te),
                    group_properties: this.instance.get_property($9481eb156b453e62$var$De),
                    disable_flags: this.instance.config.advanced_disable_feature_flags || this.instance.config.advanced_disable_feature_flags_on_first_load || void 0
                }));
                this.instance._send_request("".concat(this.instance.config.api_host, "/decide/?v=3"), {
                    data: t,
                    verbose: !0
                }, {
                    method: "POST"
                }, function(t) {
                    return e.parseDecideResponse(t);
                });
            }
        },
        {
            key: "parseDecideResponse",
            value: function(e) {
                var t, n = this;
                if (this.instance.featureFlags.setReloadingPaused(!1), this.instance.featureFlags._startReloadTimer(), 0 !== (null == e ? void 0 : e.status)) {
                    if (!$9481eb156b453e62$var$B || !$9481eb156b453e62$var$B.body) return $9481eb156b453e62$var$H.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(function() {
                        n.parseDecideResponse(e);
                    }, 500);
                    this.instance.toolbar.afterDecideResponse(e), null === (t = this.instance.sessionRecording) || void 0 === t || t.afterDecideResponse(e), $9481eb156b453e62$var$Ue.afterDecideResponse(e, this.instance), this.instance._afterDecideResponse(e), this.instance.config.advanced_disable_feature_flags_on_first_load || this.instance.config.advanced_disable_feature_flags || this.instance.featureFlags.receivedFeatureFlags(e);
                    var r = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.extendPostHogWithSurveys;
                    e.surveys && !r && $9481eb156b453e62$var$oe(this.instance.config.api_host + "/static/surveys.js", function(e) {
                        if (e) return $9481eb156b453e62$var$H.error("Could not load surveys script", e);
                        $9481eb156b453e62$var$D.extendPostHogWithSurveys(n.instance);
                    });
                    var i = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.extendPostHogWithExceptionAutoCapture;
                    if (e.autocaptureExceptions && e.autocaptureExceptions && $9481eb156b453e62$var$R(i) && $9481eb156b453e62$var$oe(this.instance.config.api_host + "/static/exception-autocapture.js", function(t) {
                        if (t) return $9481eb156b453e62$var$H.error("Could not load exception autocapture script", t);
                        $9481eb156b453e62$var$D.extendPostHogWithExceptionAutocapture(n.instance, e);
                    }), e.siteApps) {
                        if (this.instance.config.opt_in_site_apps) {
                            var o, s = this.instance.config.api_host, a = $9481eb156b453e62$var$v(e.siteApps);
                            try {
                                var u = function() {
                                    var e = o.value, t = e.id, r = e.url, i = [
                                        s,
                                        "/" === s[s.length - 1] && "/" === r[0] ? r.substring(1) : r
                                    ].join("");
                                    $9481eb156b453e62$var$L["__$$ph_site_app_".concat(t)] = n.instance, $9481eb156b453e62$var$oe(i, function(e) {
                                        e && $9481eb156b453e62$var$H.error("Error while initializing PostHog app with config id ".concat(t), e);
                                    });
                                };
                                for(a.s(); !(o = a.n()).done;)u();
                            } catch (e) {
                                a.e(e);
                            } finally{
                                a.f();
                            }
                        } else e.siteApps.length > 0 && $9481eb156b453e62$var$H.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
                    }
                } else $9481eb156b453e62$var$H.error("Failed to fetch feature flags from PostHog.");
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Wt = [
    "https://app.posthog.com",
    "https://eu.posthog.com"
], $9481eb156b453e62$var$Gt = [
    "source"
], $9481eb156b453e62$var$zt = null != $9481eb156b453e62$var$D && $9481eb156b453e62$var$D.location ? $9481eb156b453e62$var$wt($9481eb156b453e62$var$D.location.hash, "__posthog") || $9481eb156b453e62$var$wt(location.hash, "state") : null, $9481eb156b453e62$var$Yt = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "afterDecideResponse",
            value: function(e) {
                var n = e.toolbarParams || e.editorParams || (e.toolbarVersion ? {
                    toolbarVersion: e.toolbarVersion
                } : {});
                e.isAuthenticated && n.toolbarVersion && 0 === n.toolbarVersion.indexOf("toolbar") && this.loadToolbar($9481eb156b453e62$var$t({}, n));
            }
        },
        {
            key: "maybeLoadToolbar",
            value: function() {
                var e, t, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                if (!$9481eb156b453e62$var$D || !$9481eb156b453e62$var$B) return !1;
                n = null !== (e = n) && void 0 !== e ? e : $9481eb156b453e62$var$D.location, i = null !== (t = i) && void 0 !== t ? t : $9481eb156b453e62$var$D.history;
                try {
                    if (!r) {
                        try {
                            $9481eb156b453e62$var$D.localStorage.setItem("test", "test"), $9481eb156b453e62$var$D.localStorage.removeItem("test");
                        } catch (e) {
                            return !1;
                        }
                        r = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.localStorage;
                    }
                    var o, s = $9481eb156b453e62$var$zt || $9481eb156b453e62$var$wt(n.hash, "__posthog") || $9481eb156b453e62$var$wt(n.hash, "state"), a = s ? $9481eb156b453e62$var$X(function() {
                        return JSON.parse(atob(decodeURIComponent(s)));
                    }) || $9481eb156b453e62$var$X(function() {
                        return JSON.parse(decodeURIComponent(s));
                    }) : null;
                    return a && "ph_authorize" === a.action ? ((o = a).source = "url", o && Object.keys(o).length > 0 && (a.desiredHash ? n.hash = a.desiredHash : i ? i.replaceState("", $9481eb156b453e62$var$B.title, n.pathname + n.search) : n.hash = "")) : ((o = JSON.parse(r.getItem("_postHogToolbarParams") || "{}")).source = "localstorage", delete o.userIntent), !(!o.token || this.instance.config.token !== o.token) && (this.loadToolbar(o), !0);
                } catch (e) {
                    return !1;
                }
            }
        },
        {
            key: "loadToolbar",
            value: function(e) {
                var n = this;
                if (!$9481eb156b453e62$var$D || $9481eb156b453e62$var$L._postHogToolbarLoaded) return !1;
                $9481eb156b453e62$var$L._postHogToolbarLoaded = !0;
                var r = this.instance.config.api_host, i = 3e5, o = Math.floor(Date.now() / i) * i, s = "".concat(r).concat(r.endsWith("/") ? "" : "/", "static/toolbar.js?t=").concat(o), a = !$9481eb156b453e62$var$Wt.includes(this.instance.config.api_host) && this.instance.config.advanced_disable_toolbar_metrics, u = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({
                    token: this.instance.config.token
                }, e), {}, {
                    apiURL: r
                }, a ? {
                    instrument: !1
                } : {});
                u.source;
                var l = $9481eb156b453e62$var$c(u, $9481eb156b453e62$var$Gt);
                return $9481eb156b453e62$var$D.localStorage.setItem("_postHogToolbarParams", JSON.stringify(l)), $9481eb156b453e62$var$oe(s, function(e) {
                    e ? $9481eb156b453e62$var$H.error("Failed to load toolbar", e) : ($9481eb156b453e62$var$L.ph_load_toolbar || $9481eb156b453e62$var$L.ph_load_editor)(u, n.instance);
                }), $9481eb156b453e62$var$ie($9481eb156b453e62$var$D, "turbolinks:load", function() {
                    $9481eb156b453e62$var$L._postHogToolbarLoaded = !1, n.loadToolbar(u);
                }), !0;
            }
        },
        {
            key: "_loadEditor",
            value: function(e) {
                return this.loadToolbar(e);
            }
        },
        {
            key: "maybeLoadEditor",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                return this.maybeLoadToolbar(e, t, n);
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Qt = "__ph_opt_in_out_";
function $9481eb156b453e62$var$Jt(e, t) {
    $9481eb156b453e62$var$on(!0, e, t);
}
function $9481eb156b453e62$var$Xt(e, t) {
    $9481eb156b453e62$var$on(!1, e, t);
}
function $9481eb156b453e62$var$Kt(e, t) {
    return "1" === $9481eb156b453e62$var$rn(e, t);
}
function $9481eb156b453e62$var$Zt(e, t) {
    return !!function(e) {
        if (e && e.respectDnt) {
            var t = e && e.window || $9481eb156b453e62$var$D, n = null == t ? void 0 : t.navigator, r = !1;
            return $9481eb156b453e62$var$G([
                null == n ? void 0 : n.doNotTrack,
                n.msDoNotTrack,
                t.doNotTrack
            ], function(e) {
                $9481eb156b453e62$var$Y([
                    !0,
                    1,
                    "1",
                    "yes"
                ], e) && (r = !0);
            }), r;
        }
        return !1;
    }(t) || "0" === $9481eb156b453e62$var$rn(e, t);
}
function $9481eb156b453e62$var$en(e, t) {
    $9481eb156b453e62$var$tn(t = t || {}).remove($9481eb156b453e62$var$nn(e, t), !!t.crossSubdomainCookie);
}
function $9481eb156b453e62$var$tn(e) {
    return "localStorage" === (e = e || {}).persistenceType ? $9481eb156b453e62$var$dt : "localStorage+cookie" === e.persistenceType ? $9481eb156b453e62$var$ft : $9481eb156b453e62$var$lt;
}
function $9481eb156b453e62$var$nn(e, t) {
    return ((t = t || {}).persistencePrefix || $9481eb156b453e62$var$Qt) + e;
}
function $9481eb156b453e62$var$rn(e, t) {
    return $9481eb156b453e62$var$tn(t).get($9481eb156b453e62$var$nn(e, t));
}
function $9481eb156b453e62$var$on(e, t, n) {
    $9481eb156b453e62$var$E(t) && t.length ? ($9481eb156b453e62$var$tn(n = n || {}).set($9481eb156b453e62$var$nn(t, n), e ? 1 : 0, $9481eb156b453e62$var$$(n.cookieExpiration) ? n.cookieExpiration : null, n.crossSubdomainCookie, n.secureCookie), n.capture && e && n.capture(n.captureEventName || "$opt_in", n.captureProperties || {}, {
        send_instantly: !0
    })) : $9481eb156b453e62$var$H.error("gdpr." + (e ? "optIn" : "optOut") + " called with an invalid token");
}
var $9481eb156b453e62$var$sn = function() {
    function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 3e3;
        $9481eb156b453e62$var$r(this, e), this.isPolling = !0, this._event_queue = [], this._empty_queue_count = 0, this._poller = void 0, this._pollInterval = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "setPollInterval",
            value: function(e) {
                this._pollInterval = e, this.isPolling && this.poll();
            }
        },
        {
            key: "poll",
            value: function() {}
        },
        {
            key: "unload",
            value: function() {}
        },
        {
            key: "getTime",
            value: function() {
                return (new Date).getTime();
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$an = function(e) {
    $9481eb156b453e62$var$a(i, $9481eb156b453e62$var$sn);
    var n = $9481eb156b453e62$var$h(i);
    function i(e) {
        var t, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3e3;
        return $9481eb156b453e62$var$r(this, i), (t = n.call(this, o)).handlePollRequest = e, t;
    }
    return $9481eb156b453e62$var$o(i, [
        {
            key: "enqueue",
            value: function(e, t, n) {
                this._event_queue.push({
                    url: e,
                    data: t,
                    options: n
                }), this.isPolling || (this.isPolling = !0, this.poll());
            }
        },
        {
            key: "poll",
            value: function() {
                var e = this;
                clearTimeout(this._poller), this._poller = setTimeout(function() {
                    if (e._event_queue.length > 0) {
                        var t = e.formatQueue(), n = function(n) {
                            var r = t[n], i = r.url, o = r.data, s = r.options;
                            $9481eb156b453e62$var$G(o, function(t, n) {
                                o[n].offset = Math.abs(o[n].timestamp - e.getTime()), delete o[n].timestamp;
                            }), e.handlePollRequest(i, o, s);
                        };
                        for(var r in t)n(r);
                        e._event_queue.length = 0, e._empty_queue_count = 0;
                    } else e._empty_queue_count++;
                    e._empty_queue_count > 4 && (e.isPolling = !1, e._empty_queue_count = 0), e.isPolling && e.poll();
                }, this._pollInterval);
            }
        },
        {
            key: "unload",
            value: function() {
                var e = this;
                clearTimeout(this._poller);
                var n = this._event_queue.length > 0 ? this.formatQueue() : {};
                this._event_queue.length = 0;
                var r = Object.values(n);
                [].concat($9481eb156b453e62$var$p(r.filter(function(e) {
                    return 0 === e.url.indexOf("/e");
                })), $9481eb156b453e62$var$p(r.filter(function(e) {
                    return 0 !== e.url.indexOf("/e");
                }))).map(function(n) {
                    var r = n.url, i = n.data, o = n.options;
                    e.handlePollRequest(r, i, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, o), {}, {
                        transport: "sendBeacon"
                    }));
                });
            }
        },
        {
            key: "formatQueue",
            value: function() {
                var e = {};
                return $9481eb156b453e62$var$G(this._event_queue, function(t) {
                    var n = t.url, r = t.data, i = t.options, o = (i ? i._batchKey : null) || n;
                    $9481eb156b453e62$var$R(e[o]) && (e[o] = {
                        data: [],
                        url: n,
                        options: i
                    }), i && e[o].options && e[o].options._metrics && !e[o].options._metrics.rrweb_full_snapshot && (e[o].options._metrics.rrweb_full_snapshot = i._metrics.rrweb_full_snapshot), e[o].data.push(r);
                }), e;
            }
        }
    ]), i;
}(), $9481eb156b453e62$var$un = Uint8Array, $9481eb156b453e62$var$ln = Uint16Array, $9481eb156b453e62$var$cn = Uint32Array, $9481eb156b453e62$var$dn = new $9481eb156b453e62$var$un([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $9481eb156b453e62$var$hn = new $9481eb156b453e62$var$un([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $9481eb156b453e62$var$fn = new $9481eb156b453e62$var$un([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $9481eb156b453e62$var$pn = function(e, t) {
    for(var n = new $9481eb156b453e62$var$ln(31), r = 0; r < 31; ++r)n[r] = t += 1 << e[r - 1];
    var i = new $9481eb156b453e62$var$cn(n[30]);
    for(r = 1; r < 30; ++r)for(var o = n[r]; o < n[r + 1]; ++o)i[o] = o - n[r] << 5 | r;
    return [
        n,
        i
    ];
}, $9481eb156b453e62$var$_n = $9481eb156b453e62$var$pn($9481eb156b453e62$var$dn, 2), $9481eb156b453e62$var$gn = $9481eb156b453e62$var$_n[0], $9481eb156b453e62$var$vn = $9481eb156b453e62$var$_n[1];
$9481eb156b453e62$var$gn[28] = 258, $9481eb156b453e62$var$vn[258] = 28;
for(var $9481eb156b453e62$var$mn = $9481eb156b453e62$var$pn($9481eb156b453e62$var$hn, 0)[1], $9481eb156b453e62$var$yn = new $9481eb156b453e62$var$ln(32768), $9481eb156b453e62$var$bn = 0; $9481eb156b453e62$var$bn < 32768; ++$9481eb156b453e62$var$bn){
    var $9481eb156b453e62$var$kn = (43690 & $9481eb156b453e62$var$bn) >>> 1 | (21845 & $9481eb156b453e62$var$bn) << 1;
    $9481eb156b453e62$var$kn = (61680 & ($9481eb156b453e62$var$kn = (52428 & $9481eb156b453e62$var$kn) >>> 2 | (13107 & $9481eb156b453e62$var$kn) << 2)) >>> 4 | (3855 & $9481eb156b453e62$var$kn) << 4, $9481eb156b453e62$var$yn[$9481eb156b453e62$var$bn] = ((65280 & $9481eb156b453e62$var$kn) >>> 8 | (255 & $9481eb156b453e62$var$kn) << 8) >>> 1;
}
var $9481eb156b453e62$var$wn = function(e, t, n) {
    for(var r = e.length, i = 0, o = new $9481eb156b453e62$var$ln(t); i < r; ++i)++o[e[i] - 1];
    var s, a = new $9481eb156b453e62$var$ln(t);
    for(i = 0; i < t; ++i)a[i] = a[i - 1] + o[i - 1] << 1;
    if (n) {
        s = new $9481eb156b453e62$var$ln(1 << t);
        var u = 15 - t;
        for(i = 0; i < r; ++i)if (e[i]) for(var l = i << 4 | e[i], c = t - e[i], d = a[e[i] - 1]++ << c, h = d | (1 << c) - 1; d <= h; ++d)s[$9481eb156b453e62$var$yn[d] >>> u] = l;
    } else for(s = new $9481eb156b453e62$var$ln(r), i = 0; i < r; ++i)s[i] = $9481eb156b453e62$var$yn[a[e[i] - 1]++] >>> 15 - e[i];
    return s;
}, $9481eb156b453e62$var$Sn = new $9481eb156b453e62$var$un(288);
for($9481eb156b453e62$var$bn = 0; $9481eb156b453e62$var$bn < 144; ++$9481eb156b453e62$var$bn)$9481eb156b453e62$var$Sn[$9481eb156b453e62$var$bn] = 8;
for($9481eb156b453e62$var$bn = 144; $9481eb156b453e62$var$bn < 256; ++$9481eb156b453e62$var$bn)$9481eb156b453e62$var$Sn[$9481eb156b453e62$var$bn] = 9;
for($9481eb156b453e62$var$bn = 256; $9481eb156b453e62$var$bn < 280; ++$9481eb156b453e62$var$bn)$9481eb156b453e62$var$Sn[$9481eb156b453e62$var$bn] = 7;
for($9481eb156b453e62$var$bn = 280; $9481eb156b453e62$var$bn < 288; ++$9481eb156b453e62$var$bn)$9481eb156b453e62$var$Sn[$9481eb156b453e62$var$bn] = 8;
var $9481eb156b453e62$var$Fn = new $9481eb156b453e62$var$un(32);
for($9481eb156b453e62$var$bn = 0; $9481eb156b453e62$var$bn < 32; ++$9481eb156b453e62$var$bn)$9481eb156b453e62$var$Fn[$9481eb156b453e62$var$bn] = 5;
var $9481eb156b453e62$export$6a00d17b5aff0af, $9481eb156b453e62$var$In = $9481eb156b453e62$var$wn($9481eb156b453e62$var$Sn, 9, 0), $9481eb156b453e62$var$xn = $9481eb156b453e62$var$wn($9481eb156b453e62$var$Fn, 5, 0), $9481eb156b453e62$var$Rn = function(e) {
    return (e / 8 >> 0) + (7 & e && 1);
}, $9481eb156b453e62$var$En = function(e, t, n) {
    (null == t || t < 0) && (t = 0), (null == n || n > e.length) && (n = e.length);
    var r = new (e instanceof $9481eb156b453e62$var$ln ? $9481eb156b453e62$var$ln : e instanceof $9481eb156b453e62$var$cn ? $9481eb156b453e62$var$cn : $9481eb156b453e62$var$un)(n - t);
    return r.set(e.subarray(t, n)), r;
}, $9481eb156b453e62$var$Cn = function(e, t, n) {
    n <<= 7 & t;
    var r = t / 8 >> 0;
    e[r] |= n, e[r + 1] |= n >>> 8;
}, $9481eb156b453e62$var$$n = function(e, t, n) {
    n <<= 7 & t;
    var r = t / 8 >> 0;
    e[r] |= n, e[r + 1] |= n >>> 8, e[r + 2] |= n >>> 16;
}, $9481eb156b453e62$var$On = function(e, t) {
    for(var n = [], r = 0; r < e.length; ++r)e[r] && n.push({
        s: r,
        f: e[r]
    });
    var i = n.length, o = n.slice();
    if (!i) return [
        new $9481eb156b453e62$var$un(0),
        0
    ];
    if (1 == i) {
        var s = new $9481eb156b453e62$var$un(n[0].s + 1);
        return s[n[0].s] = 1, [
            s,
            1
        ];
    }
    n.sort(function(e, t) {
        return e.f - t.f;
    }), n.push({
        s: -1,
        f: 25001
    });
    var a = n[0], u = n[1], l = 0, c = 1, d = 2;
    for(n[0] = {
        s: -1,
        f: a.f + u.f,
        l: a,
        r: u
    }; c != i - 1;)a = n[n[l].f < n[d].f ? l++ : d++], u = n[l != c && n[l].f < n[d].f ? l++ : d++], n[c++] = {
        s: -1,
        f: a.f + u.f,
        l: a,
        r: u
    };
    var h = o[0].s;
    for(r = 1; r < i; ++r)o[r].s > h && (h = o[r].s);
    var f = new $9481eb156b453e62$var$ln(h + 1), p = $9481eb156b453e62$var$Mn(n[c - 1], f, 0);
    if (p > t) {
        r = 0;
        var _ = 0, g = p - t, v = 1 << g;
        for(o.sort(function(e, t) {
            return f[t.s] - f[e.s] || e.f - t.f;
        }); r < i; ++r){
            var m = o[r].s;
            if (!(f[m] > t)) break;
            _ += v - (1 << p - f[m]), f[m] = t;
        }
        for(_ >>>= g; _ > 0;){
            var y = o[r].s;
            f[y] < t ? _ -= 1 << t - f[y]++ - 1 : ++r;
        }
        for(; r >= 0 && _; --r){
            var b = o[r].s;
            f[b] == t && (--f[b], ++_);
        }
        p = t;
    }
    return [
        new $9481eb156b453e62$var$un(f),
        p
    ];
}, $9481eb156b453e62$var$Mn = function e(t, n, r) {
    return -1 == t.s ? Math.max(e(t.l, n, r + 1), e(t.r, n, r + 1)) : n[t.s] = r;
}, $9481eb156b453e62$var$An = function(e) {
    for(var t = e.length; t && !e[--t];);
    for(var n = new $9481eb156b453e62$var$ln(++t), r = 0, i = e[0], o = 1, s = function(e) {
        n[r++] = e;
    }, a = 1; a <= t; ++a)if (e[a] == i && a != t) ++o;
    else {
        if (!i && o > 2) {
            for(; o > 138; o -= 138)s(32754);
            o > 2 && (s(o > 10 ? o - 11 << 5 | 28690 : o - 3 << 5 | 12305), o = 0);
        } else if (o > 3) {
            for(s(i), --o; o > 6; o -= 6)s(8304);
            o > 2 && (s(o - 3 << 5 | 8208), o = 0);
        }
        for(; o--;)s(i);
        o = 1, i = e[a];
    }
    return [
        n.subarray(0, r),
        t
    ];
}, $9481eb156b453e62$var$Tn = function(e, t) {
    for(var n = 0, r = 0; r < t.length; ++r)n += e[r] * t[r];
    return n;
}, $9481eb156b453e62$var$Dn = function(e, t, n) {
    var r = n.length, i = $9481eb156b453e62$var$Rn(t + 2);
    e[i] = 255 & r, e[i + 1] = r >>> 8, e[i + 2] = 255 ^ e[i], e[i + 3] = 255 ^ e[i + 1];
    for(var o = 0; o < r; ++o)e[i + o + 4] = n[o];
    return 8 * (i + 4 + r);
}, $9481eb156b453e62$var$qn = function(e, t, n, r, i, o, s, a, u, l, c) {
    $9481eb156b453e62$var$Cn(t, c++, n), ++i[256];
    for(var d = $9481eb156b453e62$var$On(i, 15), h = d[0], f = d[1], p = $9481eb156b453e62$var$On(o, 15), _ = p[0], g = p[1], v = $9481eb156b453e62$var$An(h), m = v[0], y = v[1], b = $9481eb156b453e62$var$An(_), k = b[0], w = b[1], S = new $9481eb156b453e62$var$ln(19), F = 0; F < m.length; ++F)S[31 & m[F]]++;
    for(F = 0; F < k.length; ++F)S[31 & k[F]]++;
    for(var P = $9481eb156b453e62$var$On(S, 7), I = P[0], x = P[1], R = 19; R > 4 && !I[$9481eb156b453e62$var$fn[R - 1]]; --R);
    var E, C, $, O, M = l + 5 << 3, A = $9481eb156b453e62$var$Tn(i, $9481eb156b453e62$var$Sn) + $9481eb156b453e62$var$Tn(o, $9481eb156b453e62$var$Fn) + s, T = $9481eb156b453e62$var$Tn(i, h) + $9481eb156b453e62$var$Tn(o, _) + s + 14 + 3 * R + $9481eb156b453e62$var$Tn(S, I) + (2 * S[16] + 3 * S[17] + 7 * S[18]);
    if (M <= A && M <= T) return $9481eb156b453e62$var$Dn(t, c, e.subarray(u, u + l));
    if ($9481eb156b453e62$var$Cn(t, c, 1 + (T < A)), c += 2, T < A) {
        E = $9481eb156b453e62$var$wn(h, f, 0), C = h, $ = $9481eb156b453e62$var$wn(_, g, 0), O = _;
        var D = $9481eb156b453e62$var$wn(I, x, 0);
        $9481eb156b453e62$var$Cn(t, c, y - 257), $9481eb156b453e62$var$Cn(t, c + 5, w - 1), $9481eb156b453e62$var$Cn(t, c + 10, R - 4), c += 14;
        for(F = 0; F < R; ++F)$9481eb156b453e62$var$Cn(t, c + 3 * F, I[$9481eb156b453e62$var$fn[F]]);
        c += 3 * R;
        for(var q = [
            m,
            k
        ], B = 0; B < 2; ++B){
            var N = q[B];
            for(F = 0; F < N.length; ++F){
                var L = 31 & N[F];
                $9481eb156b453e62$var$Cn(t, c, D[L]), c += I[L], L > 15 && ($9481eb156b453e62$var$Cn(t, c, N[F] >>> 5 & 127), c += N[F] >>> 12);
            }
        }
    } else E = $9481eb156b453e62$var$In, C = $9481eb156b453e62$var$Sn, $ = $9481eb156b453e62$var$xn, O = $9481eb156b453e62$var$Fn;
    for(F = 0; F < a; ++F)if (r[F] > 255) {
        L = r[F] >>> 18 & 31;
        $9481eb156b453e62$var$$n(t, c, E[L + 257]), c += C[L + 257], L > 7 && ($9481eb156b453e62$var$Cn(t, c, r[F] >>> 23 & 31), c += $9481eb156b453e62$var$dn[L]);
        var j = 31 & r[F];
        $9481eb156b453e62$var$$n(t, c, $[j]), c += O[j], j > 3 && ($9481eb156b453e62$var$$n(t, c, r[F] >>> 5 & 8191), c += $9481eb156b453e62$var$hn[j]);
    } else $9481eb156b453e62$var$$n(t, c, E[r[F]]), c += C[r[F]];
    return $9481eb156b453e62$var$$n(t, c, E[256]), c + C[256];
}, $9481eb156b453e62$var$Bn = new $9481eb156b453e62$var$cn([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $9481eb156b453e62$var$Nn = new $9481eb156b453e62$var$un(0), $9481eb156b453e62$var$Ln = function() {
    for(var e = new $9481eb156b453e62$var$cn(256), t = 0; t < 256; ++t){
        for(var n = t, r = 9; --r;)n = (1 & n && 3988292384) ^ n >>> 1;
        e[t] = n;
    }
    return e;
}(), $9481eb156b453e62$var$jn = function() {
    var e = 4294967295;
    return {
        p: function(t) {
            for(var n = e, r = 0; r < t.length; ++r)n = $9481eb156b453e62$var$Ln[255 & n ^ t[r]] ^ n >>> 8;
            e = n;
        },
        d: function() {
            return 4294967295 ^ e;
        }
    };
}, $9481eb156b453e62$var$Hn = function(e, t, n, r, i) {
    return function(e, t, n, r, i, o) {
        var s = e.length, a = new $9481eb156b453e62$var$un(r + s + 5 * (1 + Math.floor(s / 7e3)) + i), u = a.subarray(r, a.length - i), l = 0;
        if (!t || s < 8) for(var c = 0; c <= s; c += 65535){
            var d = c + 65535;
            d < s ? l = $9481eb156b453e62$var$Dn(u, l, e.subarray(c, d)) : (u[c] = o, l = $9481eb156b453e62$var$Dn(u, l, e.subarray(c, s)));
        }
        else {
            for(var h = $9481eb156b453e62$var$Bn[t - 1], f = h >>> 13, p = 8191 & h, _ = (1 << n) - 1, g = new $9481eb156b453e62$var$ln(32768), v = new $9481eb156b453e62$var$ln(_ + 1), m = Math.ceil(n / 3), y = 2 * m, b = function(t) {
                return (e[t] ^ e[t + 1] << m ^ e[t + 2] << y) & _;
            }, k = new $9481eb156b453e62$var$cn(25e3), w = new $9481eb156b453e62$var$ln(288), S = new $9481eb156b453e62$var$ln(32), F = 0, P = 0, I = (c = 0, 0), x = 0, R = 0; c < s; ++c){
                var E = b(c), C = 32767 & c, $ = v[E];
                if (g[C] = $, v[E] = C, x <= c) {
                    var O = s - c;
                    if ((F > 7e3 || I > 24576) && O > 423) {
                        l = $9481eb156b453e62$var$qn(e, u, 0, k, w, S, P, I, R, c - R, l), I = F = P = 0, R = c;
                        for(var M = 0; M < 286; ++M)w[M] = 0;
                        for(M = 0; M < 30; ++M)S[M] = 0;
                    }
                    var A = 2, T = 0, D = p, q = C - $ & 32767;
                    if (O > 2 && E == b(c - q)) for(var B = Math.min(f, O) - 1, N = Math.min(32767, c), L = Math.min(258, O); q <= N && --D && C != $;){
                        if (e[c + A] == e[c + A - q]) {
                            for(var j = 0; j < L && e[c + j] == e[c + j - q]; ++j);
                            if (j > A) {
                                if (A = j, T = q, j > B) break;
                                var H = Math.min(q, j - 2), V = 0;
                                for(M = 0; M < H; ++M){
                                    var U = c - q + M + 32768 & 32767, W = U - g[U] + 32768 & 32767;
                                    W > V && (V = W, $ = U);
                                }
                            }
                        }
                        q += (C = $) - ($ = g[C]) + 32768 & 32767;
                    }
                    if (T) {
                        k[I++] = 268435456 | $9481eb156b453e62$var$vn[A] << 18 | $9481eb156b453e62$var$mn[T];
                        var G = 31 & $9481eb156b453e62$var$vn[A], z = 31 & $9481eb156b453e62$var$mn[T];
                        P += $9481eb156b453e62$var$dn[G] + $9481eb156b453e62$var$hn[z], ++w[257 + G], ++S[z], x = c + A, ++F;
                    } else k[I++] = e[c], ++w[e[c]];
                }
            }
            l = $9481eb156b453e62$var$qn(e, u, o, k, w, S, P, I, R, c - R, l), o || (l = $9481eb156b453e62$var$Dn(u, l, $9481eb156b453e62$var$Nn));
        }
        return $9481eb156b453e62$var$En(a, 0, r + $9481eb156b453e62$var$Rn(l) + i);
    }(e, null == t.level ? 6 : t.level, null == t.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + t.mem, n, r, !i);
}, $9481eb156b453e62$var$Vn = function(e, t, n) {
    for(; n; ++t)e[t] = n, n >>>= 8;
}, $9481eb156b453e62$var$Un = function(e, t) {
    var n = t.filename;
    if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = t.level < 2 ? 4 : 9 == t.level ? 2 : 0, e[9] = 3, 0 != t.mtime && $9481eb156b453e62$var$Vn(e, 4, Math.floor(new Date(t.mtime || Date.now()) / 1e3)), n) {
        e[3] = 8;
        for(var r = 0; r <= n.length; ++r)e[r + 10] = n.charCodeAt(r);
    }
}, $9481eb156b453e62$var$Wn = function(e) {
    return 10 + (e.filename && e.filename.length + 1 || 0);
};
function $9481eb156b453e62$var$Gn(e, t) {
    void 0 === t && (t = {});
    var n = $9481eb156b453e62$var$jn(), r = e.length;
    n.p(e);
    var i = $9481eb156b453e62$var$Hn(e, t, $9481eb156b453e62$var$Wn(t), 8), o = i.length;
    return $9481eb156b453e62$var$Un(i, t), $9481eb156b453e62$var$Vn(i, o - 8, n.d()), $9481eb156b453e62$var$Vn(i, o - 4, r), i;
}
function $9481eb156b453e62$var$zn(e, t) {
    var n = e.length;
    if (!t && "undefined" != typeof TextEncoder) return (new TextEncoder).encode(e);
    for(var r = new $9481eb156b453e62$var$un(e.length + (e.length >>> 1)), i = 0, o = function(e) {
        r[i++] = e;
    }, s = 0; s < n; ++s){
        if (i + 5 > r.length) {
            var a = new $9481eb156b453e62$var$un(i + 8 + (n - s << 1));
            a.set(r), r = a;
        }
        var u = e.charCodeAt(s);
        u < 128 || t ? o(u) : u < 2048 ? (o(192 | u >>> 6), o(128 | 63 & u)) : u > 55295 && u < 57344 ? (o(240 | (u = 65536 + (1047552 & u) | 1023 & e.charCodeAt(++s)) >>> 18), o(128 | u >>> 12 & 63), o(128 | u >>> 6 & 63), o(128 | 63 & u)) : (o(224 | u >>> 12), o(128 | u >>> 6 & 63), o(128 | 63 & u));
    }
    return $9481eb156b453e62$var$En(r, 0, i);
}
!function(e) {
    e.GZipJS = "gzip-js", e.Base64 = "base64";
}($9481eb156b453e62$export$6a00d17b5aff0af || ($9481eb156b453e62$export$6a00d17b5aff0af = {}));
var $9481eb156b453e62$var$Yn = function(e, t, n) {
    var r = t || {};
    r.ip = n.ip ? 1 : 0, r._ = (new Date).getTime().toString(), r.ver = $9481eb156b453e62$var$m.LIB_VERSION;
    var i = e.split("?");
    if (i.length > 1) {
        var o, s = $9481eb156b453e62$var$v(i[1].split("&"));
        try {
            for(s.s(); !(o = s.n()).done;){
                var a = o.value.split("=")[0];
                $9481eb156b453e62$var$R(r[a]) || delete r[a];
            }
        } catch (e) {
            s.e(e);
        } finally{
            s.f();
        }
    }
    var u = e.indexOf("?") > -1 ? "&" : "?";
    return e + u + function(e) {
        var t, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "&", i = [];
        return $9481eb156b453e62$var$G(e, function(e, r) {
            $9481eb156b453e62$var$R(e) || $9481eb156b453e62$var$R(r) || "undefined" === r || (t = encodeURIComponent(e.toString()), n = encodeURIComponent(r), i[i.length] = n + "=" + t);
        }), i.join(r);
    }(r);
}, $9481eb156b453e62$var$Qn = function e(t, n) {
    if (n.blob && t.buffer) return new Blob([
        $9481eb156b453e62$var$F(t) ? t : t.buffer
    ], {
        type: "text/plain"
    });
    if (n.sendBeacon || n.blob) {
        var r = e(t, {
            method: "POST"
        });
        return new Blob([
            r
        ], {
            type: "application/x-www-form-urlencoded"
        });
    }
    var i;
    return "POST" !== n.method ? null : (i = $9481eb156b453e62$var$S(t) || $9481eb156b453e62$var$F(t) ? "data=" + encodeURIComponent(t) : "data=" + encodeURIComponent(t.data), "compression" in t && t.compression && (i += "&compression=" + t.compression), i);
}, $9481eb156b453e62$var$Jn = function(e) {
    var t = e.url, n = e.data, r = e.headers, i = e.options, o = e.callback, s = e.retriesPerformedSoFar, a = e.retryQueue, u = e.onXHRError, l = e.timeout, c = void 0 === l ? 6e4 : l, d = e.onResponse;
    $9481eb156b453e62$var$$(s) && s > 0 && (t = $9481eb156b453e62$var$Yn(t, {
        retry_count: s
    }, {}));
    var h = new XMLHttpRequest;
    h.open(i.method || "GET", t, !0);
    var f = $9481eb156b453e62$var$Qn(n, i);
    $9481eb156b453e62$var$G(r, function(e, t) {
        h.setRequestHeader(t, e);
    }), "POST" !== i.method || i.blob || h.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), h.timeout = c, h.withCredentials = !0, h.onreadystatechange = function() {
        if (4 === h.readyState) {
            if (null == d || d(h), 200 === h.status) {
                if (o) {
                    var e;
                    try {
                        e = JSON.parse(h.responseText);
                    } catch (e) {
                        return void $9481eb156b453e62$var$H.error(e);
                    }
                    o(e);
                }
            } else $9481eb156b453e62$var$P(u) && u(h), (h.status < 400 || h.status > 500) && a.enqueue({
                url: t,
                data: n,
                options: i,
                headers: r,
                retriesPerformedSoFar: (s || 0) + 1,
                callback: o
            }), null == o || o({
                status: 0
            });
        }
    }, h.send(f);
}, $9481eb156b453e62$var$Xn = 18e5;
var $9481eb156b453e62$var$Kn = function(e) {
    $9481eb156b453e62$var$a(i, $9481eb156b453e62$var$sn);
    var n = $9481eb156b453e62$var$h(i);
    function i(e, t) {
        var o;
        return $9481eb156b453e62$var$r(this, i), (o = n.call(this)).isPolling = !1, o.queue = [], o.areWeOnline = !0, o.onXHRError = e, o.rateLimiter = t, !$9481eb156b453e62$var$R($9481eb156b453e62$var$D) && "onLine" in $9481eb156b453e62$var$D.navigator && (o.areWeOnline = $9481eb156b453e62$var$D.navigator.onLine, $9481eb156b453e62$var$D.addEventListener("online", function() {
            o._handleWeAreNowOnline();
        }), $9481eb156b453e62$var$D.addEventListener("offline", function() {
            o.areWeOnline = !1;
        })), o;
    }
    return $9481eb156b453e62$var$o(i, [
        {
            key: "enqueue",
            value: function(e) {
                var t = e.retriesPerformedSoFar || 0;
                if (!(t >= 10)) {
                    var n = function(e) {
                        var t = 3e3 * Math.pow(2, e), n = t / 2, r = Math.min($9481eb156b453e62$var$Xn, t), i = (Math.random() - .5) * (r - n);
                        return Math.ceil(r + i);
                    }(t), r = new Date(Date.now() + n);
                    this.queue.push({
                        retryAt: r,
                        requestData: e
                    });
                    var i = "Enqueued failed request for retry in ".concat(n);
                    navigator.onLine || (i += " (Browser is offline)"), $9481eb156b453e62$var$H.warn(i), this.isPolling || (this.isPolling = !0, this.poll());
                }
            }
        },
        {
            key: "poll",
            value: function() {
                var e = this;
                this._poller && clearTimeout(this._poller), this._poller = setTimeout(function() {
                    e.areWeOnline && e.queue.length > 0 && e.flush(), e.poll();
                }, this._pollInterval);
            }
        },
        {
            key: "flush",
            value: function() {
                var e = new Date(Date.now()), t = this.queue.filter(function(t) {
                    return t.retryAt < e;
                });
                if (t.length > 0) {
                    this.queue = this.queue.filter(function(t) {
                        return t.retryAt >= e;
                    });
                    var n, r = $9481eb156b453e62$var$v(t);
                    try {
                        for(r.s(); !(n = r.n()).done;){
                            var i = n.value.requestData;
                            this._executeXhrRequest(i);
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                }
            }
        },
        {
            key: "unload",
            value: function() {
                this._poller && (clearTimeout(this._poller), this._poller = void 0);
                var e, n = $9481eb156b453e62$var$v(this.queue);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var r = e.value.requestData, i = r.url, o = r.data, s = r.options;
                        if (this.rateLimiter.isRateLimited(s._batchKey)) $9481eb156b453e62$var$H.warn("[RetryQueue] is quota limited. Dropping request.");
                        else try {
                            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.navigator.sendBeacon(i, $9481eb156b453e62$var$Qn(o, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, s), {}, {
                                sendBeacon: !0
                            })));
                        } catch (e) {
                            $9481eb156b453e62$var$H.error(e);
                        }
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                this.queue = [];
            }
        },
        {
            key: "_executeXhrRequest",
            value: function(e) {
                var t = e.url, n = e.data, r = e.options, i = e.headers, o = e.callback, s = e.retriesPerformedSoFar;
                this.rateLimiter.isRateLimited(r._batchKey) || $9481eb156b453e62$var$Jn({
                    url: t,
                    data: n || {},
                    options: r || {},
                    headers: i || {},
                    retriesPerformedSoFar: s || 0,
                    callback: o,
                    retryQueue: this,
                    onXHRError: this.onXHRError,
                    onResponse: this.rateLimiter.checkForLimiting
                });
            }
        },
        {
            key: "_handleWeAreNowOnline",
            value: function() {
                this.areWeOnline = !0, this.flush();
            }
        }
    ]), i;
}(), $9481eb156b453e62$var$Zn = 1800, $9481eb156b453e62$var$er = 60, $9481eb156b453e62$var$tr = 864e5, $9481eb156b453e62$var$nr = function() {
    function e(t, n, i, o) {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "_sessionIdChangedHandlers", []), this.config = t, this.persistence = n, this._windowId = void 0, this._sessionId = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this._sessionIdGenerator = i || $9481eb156b453e62$var$nt, this._windowIdGenerator = o || $9481eb156b453e62$var$nt;
        var a = t.persistence_name || t.token, u = t.session_idle_timeout_seconds || $9481eb156b453e62$var$Zn;
        if ($9481eb156b453e62$var$$(u) ? u > $9481eb156b453e62$var$Zn ? $9481eb156b453e62$var$H.warn("session_idle_timeout_seconds cannot be  greater than 30 minutes. Using 30 minutes instead.") : u < $9481eb156b453e62$var$er && $9481eb156b453e62$var$H.warn("session_idle_timeout_seconds cannot be less than 60 seconds. Using 60 seconds instead.") : ($9481eb156b453e62$var$H.warn("session_idle_timeout_seconds must be a number. Defaulting to 30 minutes."), u = $9481eb156b453e62$var$Zn), this._sessionTimeoutMs = 1e3 * Math.min(Math.max(u, $9481eb156b453e62$var$er), $9481eb156b453e62$var$Zn), this._window_id_storage_key = "ph_" + a + "_window_id", this._primary_window_exists_storage_key = "ph_" + a + "_primary_window_exists", this._canUseSessionStorage()) {
            var l = $9481eb156b453e62$var$vt.parse(this._window_id_storage_key), c = $9481eb156b453e62$var$vt.parse(this._primary_window_exists_storage_key);
            l && !c ? this._windowId = l : $9481eb156b453e62$var$vt.remove(this._window_id_storage_key), $9481eb156b453e62$var$vt.set(this._primary_window_exists_storage_key, !0);
        }
        this._listenToReloadWindow();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "onSessionId",
            value: function(e) {
                var t = this;
                return $9481eb156b453e62$var$R(this._sessionIdChangedHandlers) && (this._sessionIdChangedHandlers = []), this._sessionIdChangedHandlers.push(e), this._sessionId && e(this._sessionId, this._windowId), function() {
                    t._sessionIdChangedHandlers = t._sessionIdChangedHandlers.filter(function(t) {
                        return t !== e;
                    });
                };
            }
        },
        {
            key: "_canUseSessionStorage",
            value: function() {
                return "memory" !== this.config.persistence && !this.persistence.disabled && $9481eb156b453e62$var$vt.is_supported();
            }
        },
        {
            key: "_setWindowId",
            value: function(e) {
                e !== this._windowId && (this._windowId = e, this._canUseSessionStorage() && $9481eb156b453e62$var$vt.set(this._window_id_storage_key, e));
            }
        },
        {
            key: "_getWindowId",
            value: function() {
                return this._windowId ? this._windowId : this._canUseSessionStorage() ? $9481eb156b453e62$var$vt.parse(this._window_id_storage_key) : null;
            }
        },
        {
            key: "_setSessionId",
            value: function(e, t, n) {
                e === this._sessionId && t === this._sessionActivityTimestamp && n === this._sessionStartTimestamp || (this._sessionStartTimestamp = n, this._sessionActivityTimestamp = t, this._sessionId = e, this.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$$e, [
                    t,
                    e,
                    n
                ])));
            }
        },
        {
            key: "_getSessionId",
            value: function() {
                if (this._sessionId && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
                    this._sessionActivityTimestamp,
                    this._sessionId,
                    this._sessionStartTimestamp
                ];
                var e = this.persistence.props[$9481eb156b453e62$var$$e];
                return $9481eb156b453e62$var$S(e) && 2 === e.length && e.push(e[0]), e || [
                    0,
                    null,
                    0
                ];
            }
        },
        {
            key: "resetSessionId",
            value: function() {
                this._setSessionId(null, null, null);
            }
        },
        {
            key: "_listenToReloadWindow",
            value: function() {
                var e = this;
                null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.addEventListener("beforeunload", function() {
                    e._canUseSessionStorage() && $9481eb156b453e62$var$vt.remove(e._primary_window_exists_storage_key);
                });
            }
        },
        {
            key: "checkAndGetSessionAndWindowId",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null) || (new Date).getTime(), n = $9481eb156b453e62$var$f(this._getSessionId(), 3), r = n[0], i = n[1], o = n[2], s = this._getWindowId(), a = o && o > 0 && Math.abs(t - o) > $9481eb156b453e62$var$tr, u = !1, l = !i, c = !e && Math.abs(t - r) > this._sessionTimeoutMs;
                l || c || a ? (i = this._sessionIdGenerator(), s = this._windowIdGenerator(), o = t, u = !0) : s || (s = this._windowIdGenerator(), u = !0);
                var d = 0 === r || !e || a ? t : r, h = 0 === o ? (new Date).getTime() : o;
                return this._setWindowId(s), this._setSessionId(i, d, h), u && this._sessionIdChangedHandlers.forEach(function(e) {
                    return e(i, s);
                }), {
                    sessionId: i,
                    windowId: s,
                    sessionStartTimestamp: h
                };
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$rr = $9481eb156b453e62$var$o(function e(t, n, i, o) {
    $9481eb156b453e62$var$r(this, e), this.name = "posthog-js", this.setupOnce = function(e) {
        e(function(e) {
            var r, s, a, u, l;
            if ("error" !== e.level || !t.__loaded) return e;
            e.tags || (e.tags = {});
            var c = t.config.ui_host || t.config.api_host;
            e.tags["PostHog Person URL"] = c + "/person/" + t.get_distinct_id(), t.sessionRecordingStarted() && (e.tags["PostHog Recording URL"] = t.get_session_replay_url({
                withTimestamp: !0
            }));
            var d = (null === (r = e.exception) || void 0 === r ? void 0 : r.values) || [], h = {
                $exception_message: null === (s = d[0]) || void 0 === s ? void 0 : s.value,
                $exception_type: null === (a = d[0]) || void 0 === a ? void 0 : a.type,
                $exception_personURL: c + "/person/" + t.get_distinct_id(),
                $sentry_event_id: e.event_id,
                $sentry_exception: e.exception,
                $sentry_exception_message: null === (u = d[0]) || void 0 === u ? void 0 : u.value,
                $sentry_exception_type: null === (l = d[0]) || void 0 === l ? void 0 : l.type,
                $sentry_tags: e.tags
            };
            return n && i && (h.$sentry_url = (o || "https://sentry.io/organizations/") + n + "/issues/?project=" + i + "&query=" + e.event_id), t.capture("$exception", h), e;
        });
    };
}), $9481eb156b453e62$var$ir = function(e) {
    Promise && Promise.resolve || $9481eb156b453e62$var$H.warn("This browser does not have Promise support, and can not use the segment integration");
    var t = function(t, n) {
        t.event.userId || t.event.anonymousId === e.get_distinct_id() || e.reset(), t.event.userId && t.event.userId !== e.get_distinct_id() && (e.register({
            distinct_id: t.event.userId
        }), e.reloadFeatureFlags());
        var r = e._calculate_event_properties(n, t.event.properties);
        return t.event.properties = Object.assign({}, r, t.event.properties), t;
    };
    return {
        name: "PostHog JS",
        type: "enrichment",
        version: "1.0.0",
        isLoaded: function() {
            return !0;
        },
        load: function() {
            return Promise.resolve();
        },
        track: function(e) {
            return t(e, e.event.event);
        },
        page: function(e) {
            return t(e, "$pageview");
        },
        identify: function(e) {
            return t(e, "$identify");
        },
        screen: function(e) {
            return t(e, "$screen");
        }
    };
}, $9481eb156b453e62$var$or = function() {
    function e() {
        var t = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "_hasSeenPageView", !1), $9481eb156b453e62$var$s(this, "_updateScrollData", function() {
            var e, n, r, i;
            t._pageViewData || (t._pageViewData = t._createPageViewData());
            var o = t._pageViewData, s = t._scrollY(), a = t._scrollHeight(), u = t._contentY(), l = t._contentHeight();
            o.lastScrollY = s, o.maxScrollY = Math.max(s, null !== (e = o.maxScrollY) && void 0 !== e ? e : 0), o.maxScrollHeight = Math.max(a, null !== (n = o.maxScrollHeight) && void 0 !== n ? n : 0), o.lastContentY = u, o.maxContentY = Math.max(u, null !== (r = o.maxContentY) && void 0 !== r ? r : 0), o.maxContentHeight = Math.max(l, null !== (i = o.maxContentHeight) && void 0 !== i ? i : 0);
        });
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "_createPageViewData",
            value: function() {
                var e;
                return {
                    pathname: null !== (e = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.pathname) && void 0 !== e ? e : ""
                };
            }
        },
        {
            key: "doPageView",
            value: function() {
                var e, n;
                return this._hasSeenPageView ? (n = this._pageViewData, this._pageViewData = this._createPageViewData()) : (this._hasSeenPageView = !0, n = void 0, this._pageViewData || (this._pageViewData = this._createPageViewData())), setTimeout(this._updateScrollData, 0), $9481eb156b453e62$var$t({
                    $prev_pageview_pathname: null === (e = n) || void 0 === e ? void 0 : e.pathname
                }, this._calculatePrevPageScrollProperties(n));
            }
        },
        {
            key: "doPageLeave",
            value: function() {
                var e = this._pageViewData;
                return $9481eb156b453e62$var$t({
                    $prev_pageview_pathname: null == e ? void 0 : e.pathname
                }, this._calculatePrevPageScrollProperties(e));
            }
        },
        {
            key: "_calculatePrevPageScrollProperties",
            value: function(e) {
                if (!e || null == e.maxScrollHeight || null == e.lastScrollY || null == e.maxScrollY || null == e.maxContentHeight || null == e.lastContentY || null == e.maxContentY) return {};
                var t = e.maxScrollHeight, n = e.lastScrollY, r = e.maxScrollY, i = e.maxContentHeight, o = e.lastContentY, s = e.maxContentY;
                return t = Math.ceil(t), n = Math.ceil(n), r = Math.ceil(r), i = Math.ceil(i), o = Math.ceil(o), s = Math.ceil(s), {
                    $prev_pageview_last_scroll: n,
                    $prev_pageview_last_scroll_percentage: t <= 1 ? 1 : $9481eb156b453e62$var$sr(n / t, 0, 1),
                    $prev_pageview_max_scroll: r,
                    $prev_pageview_max_scroll_percentage: t <= 1 ? 1 : $9481eb156b453e62$var$sr(r / t, 0, 1),
                    $prev_pageview_last_content: o,
                    $prev_pageview_last_content_percentage: i <= 1 ? 1 : $9481eb156b453e62$var$sr(o / i, 0, 1),
                    $prev_pageview_max_content: s,
                    $prev_pageview_max_content_percentage: i <= 1 ? 1 : $9481eb156b453e62$var$sr(s / i, 0, 1)
                };
            }
        },
        {
            key: "startMeasuringScrollPosition",
            value: function() {
                null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.addEventListener("scroll", this._updateScrollData), null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.addEventListener("scrollend", this._updateScrollData), null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.addEventListener("resize", this._updateScrollData);
            }
        },
        {
            key: "stopMeasuringScrollPosition",
            value: function() {
                null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.removeEventListener("scroll", this._updateScrollData), null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.removeEventListener("scrollend", this._updateScrollData), null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.removeEventListener("resize", this._updateScrollData);
            }
        },
        {
            key: "_scrollHeight",
            value: function() {
                return $9481eb156b453e62$var$D ? Math.max(0, $9481eb156b453e62$var$D.document.documentElement.scrollHeight - $9481eb156b453e62$var$D.document.documentElement.clientHeight) : 0;
            }
        },
        {
            key: "_scrollY",
            value: function() {
                return $9481eb156b453e62$var$D && ($9481eb156b453e62$var$D.scrollY || $9481eb156b453e62$var$D.pageYOffset || $9481eb156b453e62$var$D.document.documentElement.scrollTop) || 0;
            }
        },
        {
            key: "_contentHeight",
            value: function() {
                return (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.document.documentElement.scrollHeight) || 0;
            }
        },
        {
            key: "_contentY",
            value: function() {
                var e = (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.document.documentElement.clientHeight) || 0;
                return this._scrollY() + e;
            }
        }
    ]), e;
}();
function $9481eb156b453e62$var$sr(e, t, n) {
    return Math.max(t, Math.min(e, n));
}
var $9481eb156b453e62$var$ar, $9481eb156b453e62$var$ur, $9481eb156b453e62$var$lr, $9481eb156b453e62$var$cr = {
    icontains: function(e) {
        return !!$9481eb156b453e62$var$D && $9481eb156b453e62$var$D.location.href.toLowerCase().indexOf(e.toLowerCase()) > -1;
    },
    regex: function(e) {
        return !!$9481eb156b453e62$var$D && $9481eb156b453e62$var$bt($9481eb156b453e62$var$D.location.href, e);
    },
    exact: function(e) {
        return (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.href) === e;
    }
}, $9481eb156b453e62$var$dr = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "getSurveys",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = this.instance.get_property($9481eb156b453e62$var$qe);
                if (r && !n) return e(r);
                this.instance._send_request("".concat(this.instance.config.api_host, "/api/surveys/?token=").concat(this.instance.config.token), {}, {
                    method: "GET"
                }, function(n) {
                    var r, i = n.surveys || [];
                    return null === (r = t.instance.persistence) || void 0 === r || r.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$qe, i)), e(i);
                });
            }
        },
        {
            key: "getActiveMatchingSurveys",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.getSurveys(function(n) {
                    var r = n.filter(function(e) {
                        return !(!e.start_date || e.end_date);
                    }).filter(function(e) {
                        var t, n, r, i;
                        if (!e.conditions) return !0;
                        var o = null === (t = e.conditions) || void 0 === t || !t.url || $9481eb156b453e62$var$cr[null !== (n = null === (r = e.conditions) || void 0 === r ? void 0 : r.urlMatchType) && void 0 !== n ? n : "icontains"](e.conditions.url), s = null === (i = e.conditions) || void 0 === i || !i.selector || (null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelector(e.conditions.selector));
                        return o && s;
                    }).filter(function(e) {
                        if (!e.linked_flag_key && !e.targeting_flag_key) return !0;
                        var n = !e.linked_flag_key || t.instance.featureFlags.isFeatureEnabled(e.linked_flag_key), r = !e.targeting_flag_key || t.instance.featureFlags.isFeatureEnabled(e.targeting_flag_key);
                        return n && r;
                    });
                    return e(r);
                }, n);
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$hr = 6e4, $9481eb156b453e62$var$fr = function() {
    function e() {
        var t = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "limits", {}), $9481eb156b453e62$var$s(this, "checkForLimiting", function(e) {
            try {
                var n = e.responseText;
                if (!n || !n.length) return;
                (JSON.parse(n).quota_limited || []).forEach(function(e) {
                    $9481eb156b453e62$var$H.info("[RateLimiter] ".concat(e || "events", " is quota limited.")), t.limits[e] = (new Date).getTime() + $9481eb156b453e62$var$hr;
                });
            } catch (e) {
                return void $9481eb156b453e62$var$H.error(e);
            }
        });
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "isRateLimited",
            value: function(e) {
                var t = this.limits[e || "events"] || !1;
                return !1 !== t && (new Date).getTime() < t;
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$pr = function() {
    return $9481eb156b453e62$var$t({
        initialPathName: (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.pathname) || "",
        referringDomain: $9481eb156b453e62$var$St.referringDomain()
    }, $9481eb156b453e62$var$St.campaignParams());
}, $9481eb156b453e62$var$_r = function() {
    function e(t, n, i) {
        var o = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "_onSessionIdCallback", function(e) {
            var t = o._getStoredProps();
            if (!t || t.sessionId !== e) {
                var n = {
                    sessionId: e,
                    props: o._sessionSourceParamGenerator()
                };
                o._persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$je, n));
            }
        }), this._sessionIdManager = t, this._persistence = n, this._sessionSourceParamGenerator = i || $9481eb156b453e62$var$pr, this._sessionIdManager.onSessionId(this._onSessionIdCallback);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "_getStoredProps",
            value: function() {
                return this._persistence.props[$9481eb156b453e62$var$je];
            }
        },
        {
            key: "getSessionProps",
            value: function() {
                var e, t = null === (e = this._getStoredProps()) || void 0 === e ? void 0 : e.props;
                return t ? {
                    $client_session_initial_referring_host: t.referringDomain,
                    $client_session_initial_pathname: t.initialPathName,
                    $client_session_initial_utm_source: t.utm_source,
                    $client_session_initial_utm_campaign: t.utm_campaign,
                    $client_session_initial_utm_medium: t.utm_medium,
                    $client_session_initial_utm_content: t.utm_content,
                    $client_session_initial_utm_term: t.utm_term
                } : {};
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$gr = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "applebot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "bot.htm",
    "bot.php",
    "crawler",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "gptbot",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "linkedinbot",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "semrushbot",
    "sitebulb",
    "slurp",
    "turnitin",
    "twitterbot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google"
], $9481eb156b453e62$var$vr = function(e, t) {
    if (!e) return !1;
    var n = e.toLowerCase();
    return $9481eb156b453e62$var$gr.concat(t || []).some(function(e) {
        var t = e.toLowerCase();
        return n.includes ? n.includes(t) : -1 !== n.indexOf(t);
    });
};
!function(e) {
    e[e.INIT_MODULE = 0] = "INIT_MODULE", e[e.INIT_SNIPPET = 1] = "INIT_SNIPPET";
}($9481eb156b453e62$var$ar || ($9481eb156b453e62$var$ar = {}));
var $9481eb156b453e62$var$mr = function() {}, $9481eb156b453e62$var$yr = {}, $9481eb156b453e62$var$br = "posthog", $9481eb156b453e62$var$kr = (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.XMLHttpRequest) && "withCredentials" in new XMLHttpRequest, $9481eb156b453e62$var$wr = !$9481eb156b453e62$var$kr && -1 === (null == $9481eb156b453e62$var$N ? void 0 : $9481eb156b453e62$var$N.indexOf("MSIE")) && -1 === (null == $9481eb156b453e62$var$N ? void 0 : $9481eb156b453e62$var$N.indexOf("Mozilla")), $9481eb156b453e62$var$Sr = function() {
    var e, t, n;
    return {
        api_host: "https://app.posthog.com",
        api_method: "POST",
        api_transport: "XHR",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: (t = null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.location, n = null == t ? void 0 : t.hostname, !!$9481eb156b453e62$var$E(n) && "herokuapp.com" !== n.split(".").slice(-2).join(".")),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_name: "",
        loaded: $9481eb156b453e62$var$mr,
        store_google: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: !0,
        capture_pageleave: !0,
        debug: !1,
        verbose: !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_cookie: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $9481eb156b453e62$var$D || null === (e = $9481eb156b453e62$var$D.location) || void 0 === e ? void 0 : e.protocol),
        ip: !0,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_blacklist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        xhr_headers: {},
        inapp_protocol: "//",
        inapp_link_new_window: !1,
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_disable_toolbar_metrics: !1,
        on_xhr_error: function(e) {
            var t = "Bad HTTP status: " + e.status + " " + e.statusText;
            $9481eb156b453e62$var$H.error(t);
        },
        get_device_id: function(e) {
            return e;
        },
        _onCapture: $9481eb156b453e62$var$mr,
        capture_performance: void 0,
        name: "posthog",
        callback_fn: "posthog._jsc",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800
    };
}, $9481eb156b453e62$var$Fr = function(e, t, n, r) {
    var i, o = n !== $9481eb156b453e62$var$br && $9481eb156b453e62$var$lr ? n ? $9481eb156b453e62$var$lr[n] : void 0 : $9481eb156b453e62$var$lr, s = {
        initComplete: !1,
        syncCode: !1
    }, a = function(e) {
        return function(t) {
            s[e] || (s[e] = !0, s.initComplete && s.syncCode && (null == r || r(t)));
        };
    };
    if (o && $9481eb156b453e62$var$ur === $9481eb156b453e62$var$ar.INIT_MODULE) i = o;
    else {
        if (o && !$9481eb156b453e62$var$S(o)) return void $9481eb156b453e62$var$H.error("You have already initialized " + n);
        i = new $9481eb156b453e62$export$a9d6b9cbf49b8241;
    }
    if (i._init(e, t, n, a("initComplete")), i.toolbar.maybeLoadToolbar(), i.sessionRecording = new $9481eb156b453e62$var$Vt(i), i.sessionRecording.startRecordingIfEnabled(), i.config.__preview_measure_pageview_stats && i.pageViewManager.startMeasuringScrollPosition(), i.__autocapture = i.config.autocapture, $9481eb156b453e62$var$Ue._setIsAutocaptureEnabled(i), $9481eb156b453e62$var$Ue._isAutocaptureEnabled) {
        i.__autocapture = i.config.autocapture;
        $9481eb156b453e62$var$Ue.enabledForProject(i.config.token, 100, 100) ? $9481eb156b453e62$var$Ue.isBrowserSupported() ? $9481eb156b453e62$var$Ue.init(i) : (i.__autocapture = !1, $9481eb156b453e62$var$H.info("Disabling Automatic Event Collection because this browser is not supported")) : (i.__autocapture = !1, $9481eb156b453e62$var$H.info("Not in active bucket: disabling Automatic Event Collection."));
    }
    return $9481eb156b453e62$var$m.DEBUG = $9481eb156b453e62$var$m.DEBUG || i.config.debug, !$9481eb156b453e62$var$R(o) && $9481eb156b453e62$var$S(o) && (i._execute_array.call(i.people, o.people), i._execute_array(o)), a("syncCode")(i), i;
}, $9481eb156b453e62$var$Pr = function() {
    function e() {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "__forceAllowLocalhost", !1);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "_forceAllowLocalhost",
            get: function() {
                return this.__forceAllowLocalhost;
            },
            set: function(e) {
                $9481eb156b453e62$var$H.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = e;
            }
        }
    ]), e;
}(), $9481eb156b453e62$export$a9d6b9cbf49b8241 = function() {
    function e() {
        var t = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "webPerformance", new $9481eb156b453e62$var$Pr), this.config = $9481eb156b453e62$var$Sr(), this.compression = {}, this.decideEndpointWasHit = !1, this.SentryIntegration = $9481eb156b453e62$var$rr, this.segmentIntegration = function() {
            return $9481eb156b453e62$var$ir(t);
        }, this.__captureHooks = [], this.__request_queue = [], this.__loaded = !1, this.__loaded_recorder_version = void 0, this.__autocapture = void 0, this._jsc = function() {}, this.analyticsDefaultEndpoint = "/e/", this.elementsChainAsString = !1, this.featureFlags = new $9481eb156b453e62$var$Qe(this), this.toolbar = new $9481eb156b453e62$var$Yt(this), this.pageViewManager = new $9481eb156b453e62$var$or, this.surveys = new $9481eb156b453e62$var$dr(this), this.rateLimiter = new $9481eb156b453e62$var$fr, this.people = {
            set: function(e, n, r) {
                var i = $9481eb156b453e62$var$E(e) ? $9481eb156b453e62$var$s({}, e, n) : e;
                t.setPersonProperties(i), null == r || r({});
            },
            set_once: function(e, n, r) {
                var i = $9481eb156b453e62$var$E(e) ? $9481eb156b453e62$var$s({}, e, n) : e;
                t.setPersonProperties(void 0, i), null == r || r({});
            }
        };
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "init",
            value: function(e, t, n) {
                if ($9481eb156b453e62$var$R(n)) $9481eb156b453e62$var$H.critical("You must name your new library: init(token, config, name)");
                else {
                    if (n !== $9481eb156b453e62$var$br) {
                        var r = $9481eb156b453e62$var$Fr(e, t, n, function(e) {
                            $9481eb156b453e62$var$lr[n] = e, e._loaded();
                        });
                        return $9481eb156b453e62$var$lr[n] = r, r;
                    }
                    $9481eb156b453e62$var$H.critical("You must initialize the main posthog object right after you include the PostHog js snippet");
                }
            }
        },
        {
            key: "_init",
            value: function(e) {
                var n, r, i, o = this, s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 ? arguments[2] : void 0, u = arguments.length > 3 ? arguments[3] : void 0;
                this.__loaded = !0, this.config = {}, this._triggered_notifs = [];
                var l, c = {
                    segmentRegister: !1,
                    syncCode: !1
                }, d = function(e) {
                    return function() {
                        c[e] || (c[e] = !0, c.segmentRegister && c.syncCode && (null == u || u(o)));
                    };
                };
                (this.set_config($9481eb156b453e62$var$z({}, $9481eb156b453e62$var$Sr(), s, {
                    name: a,
                    token: e,
                    callback_fn: (a === $9481eb156b453e62$var$br ? a : $9481eb156b453e62$var$br + "." + a) + "._jsc"
                })), this._jsc = function() {}, null != $9481eb156b453e62$var$D && null !== (n = $9481eb156b453e62$var$D.rrweb) && void 0 !== n && n.record || null != $9481eb156b453e62$var$D && $9481eb156b453e62$var$D.rrwebRecord) && (this.__loaded_recorder_version = null == $9481eb156b453e62$var$D || null === (l = $9481eb156b453e62$var$D.rrweb) || void 0 === l ? void 0 : l.version);
                if (this.persistence = new $9481eb156b453e62$var$Pt(this.config), this._requestQueue = new $9481eb156b453e62$var$an(this._handle_queued_event.bind(this)), this._retryQueue = new $9481eb156b453e62$var$Kn(this.config.on_xhr_error, this.rateLimiter), this.__captureHooks = [], this.__request_queue = [], this.sessionManager = new $9481eb156b453e62$var$nr(this.config, this.persistence), this.sessionPropsManager = new $9481eb156b453e62$var$_r(this.sessionManager, this.persistence), this.sessionPersistence = "sessionStorage" === this.config.persistence ? this.persistence : new $9481eb156b453e62$var$Pt($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, this.config), {}, {
                    persistence: "sessionStorage"
                })), this._gdpr_init(), s.segment ? (this.config.get_device_id = function() {
                    return s.segment.user().anonymousId();
                }, s.segment.user().id() && (this.register({
                    distinct_id: s.segment.user().id()
                }), this.persistence.set_user_state("identified")), s.segment.register(this.segmentIntegration()).then(d("segmentRegister"))) : d("segmentRegister")(), void 0 !== (null === (r = s.bootstrap) || void 0 === r ? void 0 : r.distinctID)) {
                    var h, f, p = this.config.get_device_id($9481eb156b453e62$var$nt()), _ = null !== (h = s.bootstrap) && void 0 !== h && h.isIdentifiedID ? p : s.bootstrap.distinctID;
                    this.persistence.set_user_state(null !== (f = s.bootstrap) && void 0 !== f && f.isIdentifiedID ? "identified" : "anonymous"), this.register({
                        distinct_id: s.bootstrap.distinctID,
                        $device_id: _
                    });
                }
                if (this._hasBootstrappedFeatureFlags()) {
                    var g, v, m = Object.keys((null === (g = s.bootstrap) || void 0 === g ? void 0 : g.featureFlags) || {}).filter(function(e) {
                        var t, n;
                        return !(null === (t = s.bootstrap) || void 0 === t || null === (n = t.featureFlags) || void 0 === n || !n[e]);
                    }).reduce(function(e, t) {
                        var n, r;
                        return e[t] = (null === (n = s.bootstrap) || void 0 === n || null === (r = n.featureFlags) || void 0 === r ? void 0 : r[t]) || !1, e;
                    }, {}), y = Object.keys((null === (v = s.bootstrap) || void 0 === v ? void 0 : v.featureFlagPayloads) || {}).filter(function(e) {
                        return m[e];
                    }).reduce(function(e, t) {
                        var n, r, i, o;
                        null !== (n = s.bootstrap) && void 0 !== n && null !== (r = n.featureFlagPayloads) && void 0 !== r && r[t] && (e[t] = null === (i = s.bootstrap) || void 0 === i || null === (o = i.featureFlagPayloads) || void 0 === o ? void 0 : o[t]);
                        return e;
                    }, {});
                    this.featureFlags.receivedFeatureFlags({
                        featureFlags: m,
                        featureFlagPayloads: y
                    });
                }
                if (!this.get_distinct_id()) {
                    var b = this.config.get_device_id($9481eb156b453e62$var$nt());
                    this.register_once({
                        distinct_id: b,
                        $device_id: b
                    }, ""), this.persistence.set_user_state("anonymous");
                }
                null == $9481eb156b453e62$var$D || null === (i = $9481eb156b453e62$var$D.addEventListener) || void 0 === i || i.call($9481eb156b453e62$var$D, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this)), d("syncCode")();
            }
        },
        {
            key: "_afterDecideResponse",
            value: function(e) {
                var t;
                if (this.compression = {}, e.supportedCompression && !this.config.disable_compression) {
                    var n, r = {}, i = $9481eb156b453e62$var$v(e.supportedCompression);
                    try {
                        for(i.s(); !(n = i.n()).done;)r[n.value] = !0;
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    this.compression = r;
                }
                null !== (t = e.analytics) && void 0 !== t && t.endpoint && (this.analyticsDefaultEndpoint = e.analytics.endpoint), e.elementsChainAsString && (this.elementsChainAsString = e.elementsChainAsString);
            }
        },
        {
            key: "_loaded",
            value: function() {
                var e = this.config.advanced_disable_decide;
                e || this.featureFlags.setReloadingPaused(!0);
                try {
                    this.config.loaded(this);
                } catch (e) {
                    $9481eb156b453e62$var$H.critical("`loaded` function failed", e);
                }
                this._start_queue_if_opted_in(), this.config.capture_pageview && $9481eb156b453e62$var$B && this.capture("$pageview", {
                    title: $9481eb156b453e62$var$B.title
                }, {
                    send_instantly: !0
                }), e || (new $9481eb156b453e62$var$Ut(this).call(), this.featureFlags.resetRequestQueue());
            }
        },
        {
            key: "_start_queue_if_opted_in",
            value: function() {
                var e;
                this.has_opted_out_capturing() || this.config.request_batching && (null === (e = this._requestQueue) || void 0 === e || e.poll());
            }
        },
        {
            key: "_dom_loaded",
            value: function() {
                var e = this;
                this.has_opted_out_capturing() || $9481eb156b453e62$var$W(this.__request_queue, function(t) {
                    e._send_request.apply(e, $9481eb156b453e62$var$p(t));
                }), this.__request_queue = [], this._start_queue_if_opted_in();
            }
        },
        {
            key: "_prepare_callback",
            value: function(e, t) {
                if ($9481eb156b453e62$var$R(e)) return null;
                if ($9481eb156b453e62$var$kr) return function(n) {
                    e(n, t);
                };
                var n = this._jsc, r = "" + Math.floor(1e8 * Math.random()), i = this.config.callback_fn + "[" + r + "]";
                return n[r] = function(i) {
                    delete n[r], e(i, t);
                }, i;
            }
        },
        {
            key: "_handle_unload",
            value: function() {
                var e, t;
                this.config.request_batching ? (this.config.capture_pageview && this.config.capture_pageleave && this.capture("$pageleave"), null === (e = this._requestQueue) || void 0 === e || e.unload(), null === (t = this._retryQueue) || void 0 === t || t.unload()) : this.config.capture_pageview && this.config.capture_pageleave && this.capture("$pageleave", null, {
                    transport: "sendBeacon"
                });
            }
        },
        {
            key: "_handle_queued_event",
            value: function(e, t, n) {
                var r = JSON.stringify(t);
                this.__compress_and_send_json_request(e, r, n || $9481eb156b453e62$var$yr, $9481eb156b453e62$var$mr);
            }
        },
        {
            key: "__compress_and_send_json_request",
            value: function(e, n, r, i) {
                var o = function(e, n, r) {
                    return e === $9481eb156b453e62$export$6a00d17b5aff0af.GZipJS ? [
                        $9481eb156b453e62$var$Gn($9481eb156b453e62$var$zn(n), {
                            mtime: 0
                        }),
                        $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), {}, {
                            blob: !0,
                            urlQueryArgs: {
                                compression: $9481eb156b453e62$export$6a00d17b5aff0af.GZipJS
                            }
                        })
                    ] : [
                        {
                            data: $9481eb156b453e62$var$ne(n)
                        },
                        r
                    ];
                }(this.compression[$9481eb156b453e62$export$6a00d17b5aff0af.GZipJS] ? $9481eb156b453e62$export$6a00d17b5aff0af.GZipJS : $9481eb156b453e62$export$6a00d17b5aff0af.Base64, n, r), s = $9481eb156b453e62$var$f(o, 2), a = s[0], u = s[1];
                this._send_request(e, a, u, i);
            }
        },
        {
            key: "_send_request",
            value: function(e, n, r, i) {
                if (this.__loaded && this._retryQueue && !this.rateLimiter.isRateLimited(r._batchKey)) {
                    if ($9481eb156b453e62$var$wr) this.__request_queue.push([
                        e,
                        n,
                        r,
                        i
                    ]);
                    else {
                        var o = {
                            method: this.config.api_method,
                            transport: this.config.api_transport,
                            verbose: this.config.verbose
                        };
                        r = $9481eb156b453e62$var$z(o, r || {}), $9481eb156b453e62$var$kr || (r.method = "GET");
                        var s = $9481eb156b453e62$var$D && "sendBeacon" in $9481eb156b453e62$var$D.navigator && "sendBeacon" === r.transport;
                        if (e = $9481eb156b453e62$var$Yn(e, r.urlQueryArgs || {}, {
                            ip: this.config.ip
                        }), s) try {
                            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.navigator.sendBeacon(e, $9481eb156b453e62$var$Qn(n, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), {}, {
                                sendBeacon: !0
                            })));
                        } catch (e) {}
                        else if ($9481eb156b453e62$var$kr || !$9481eb156b453e62$var$B) try {
                            $9481eb156b453e62$var$Jn({
                                url: e,
                                data: n,
                                headers: this.config.xhr_headers,
                                options: r,
                                callback: i,
                                retriesPerformedSoFar: 0,
                                retryQueue: this._retryQueue,
                                onXHRError: this.config.on_xhr_error,
                                onResponse: this.rateLimiter.checkForLimiting
                            });
                        } catch (e) {
                            $9481eb156b453e62$var$H.error(e);
                        }
                        else {
                            var a, u = $9481eb156b453e62$var$B.createElement("script");
                            u.type = "text/javascript", u.async = !0, u.defer = !0, u.src = e;
                            var l = $9481eb156b453e62$var$B.getElementsByTagName("script")[0];
                            null === (a = l.parentNode) || void 0 === a || a.insertBefore(u, l);
                        }
                    }
                }
            }
        },
        {
            key: "_execute_array",
            value: function(e) {
                var t, n = this, r = [], i = [], o = [];
                $9481eb156b453e62$var$W(e, function(e) {
                    e && (t = e[0], $9481eb156b453e62$var$S(t) ? o.push(e) : $9481eb156b453e62$var$P(e) ? e.call(n) : $9481eb156b453e62$var$S(e) && "alias" === t ? r.push(e) : $9481eb156b453e62$var$S(e) && -1 !== t.indexOf("capture") && $9481eb156b453e62$var$P(n[t]) ? o.push(e) : i.push(e));
                });
                var s = function(e, t) {
                    $9481eb156b453e62$var$W(e, function(e) {
                        if ($9481eb156b453e62$var$S(e[0])) {
                            var n = t;
                            $9481eb156b453e62$var$G(e, function(e) {
                                n = n[e[0]].apply(n, e.slice(1));
                            });
                        } else this[e[0]].apply(this, e.slice(1));
                    }, t);
                };
                s(r, this), s(i, this), s(o, this);
            }
        },
        {
            key: "_hasBootstrappedFeatureFlags",
            value: function() {
                var e, t;
                return (null === (e = this.config.bootstrap) || void 0 === e ? void 0 : e.featureFlags) && Object.keys(null === (t = this.config.bootstrap) || void 0 === t ? void 0 : t.featureFlags).length > 0 || !1;
            }
        },
        {
            key: "push",
            value: function(e) {
                this._execute_array([
                    e
                ]);
            }
        },
        {
            key: "capture",
            value: function(e, n) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $9481eb156b453e62$var$yr;
                if (!this.__loaded || !this.sessionPersistence || !this._requestQueue) return $9481eb156b453e62$var$H.uninitializedWarning("posthog.capture");
                if (!function(e) {
                    var t = !1;
                    try {
                        var n = e.config.token, r = e.config.respect_dnt, i = e.config.opt_out_capturing_persistence_type, o = e.config.opt_out_capturing_cookie_prefix || void 0, s = e.config.window;
                        n && (t = $9481eb156b453e62$var$Zt(n, {
                            respectDnt: r,
                            persistenceType: i,
                            persistencePrefix: o,
                            window: s
                        }));
                    } catch (e) {
                        $9481eb156b453e62$var$H.error("Unexpected error when checking capturing opt-out status: " + e);
                    }
                    return t;
                }(this)) {
                    var i = (r = r || $9481eb156b453e62$var$yr).transport;
                    if (i && (r.transport = i), !$9481eb156b453e62$var$R(e) && $9481eb156b453e62$var$E(e)) {
                        if (!$9481eb156b453e62$var$N || this.config.opt_out_useragent_filter || !$9481eb156b453e62$var$vr($9481eb156b453e62$var$N, this.config.custom_blocked_useragents)) {
                            this.sessionPersistence.update_search_keyword(), this.config.store_google && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info();
                            var o = {
                                uuid: $9481eb156b453e62$var$nt(),
                                event: e,
                                properties: this._calculate_event_properties(e, n || {})
                            };
                            "$identify" === e && (o.$set = r.$set, o.$set_once = r.$set_once), (o = $9481eb156b453e62$var$te(o, r._noTruncate ? null : this.config.properties_string_max_length)).timestamp = r.timestamp || new Date;
                            var s = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, o.properties.$set), o.$set);
                            $9481eb156b453e62$var$x(s) || this.setPersonPropertiesForFlags(s), $9481eb156b453e62$var$H.info("send", o);
                            var a = JSON.stringify(o), u = this.config.api_host + (r.endpoint || this.analyticsDefaultEndpoint), l = r !== $9481eb156b453e62$var$yr;
                            return !this.config.request_batching || l && !r._batchKey || r.send_instantly ? this.__compress_and_send_json_request(u, a, r) : this._requestQueue.enqueue(u, o, r), this._invokeCaptureHooks(e, o), o;
                        }
                    } else $9481eb156b453e62$var$H.error("No event name provided to posthog.capture");
                }
            }
        },
        {
            key: "_addCaptureHook",
            value: function(e) {
                this.__captureHooks.push(e);
            }
        },
        {
            key: "_invokeCaptureHooks",
            value: function(e, t) {
                this.config._onCapture(e, t), $9481eb156b453e62$var$G(this.__captureHooks, function(t) {
                    return t(e);
                });
            }
        },
        {
            key: "_calculate_event_properties",
            value: function(e, n) {
                if (!this.persistence || !this.sessionPersistence) return n;
                var r = this.persistence.remove_event_timer(e), i = $9481eb156b453e62$var$t({}, n);
                if (i.token = this.config.token, "$snapshot" === e) {
                    var o = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, this.persistence.properties()), this.sessionPersistence.properties());
                    return i.distinct_id = o.distinct_id, i;
                }
                var s = $9481eb156b453e62$var$St.properties();
                if (this.sessionManager) {
                    var a = this.sessionManager.checkAndGetSessionAndWindowId(), u = a.sessionId, l = a.windowId;
                    i.$session_id = u, i.$window_id = l;
                }
                if (this.sessionPropsManager && this.config.__preview_send_client_session_params && ("$pageview" === e || "$pageleave" === e || "$autocapture" === e)) {
                    var c = this.sessionPropsManager.getSessionProps();
                    i = $9481eb156b453e62$var$z(i, c);
                }
                if (this.config.__preview_measure_pageview_stats) {
                    var d = {};
                    "$pageview" === e ? d = this.pageViewManager.doPageView() : "$pageleave" === e && (d = this.pageViewManager.doPageLeave()), i = $9481eb156b453e62$var$z(i, d);
                }
                if ("$pageview" === e && $9481eb156b453e62$var$B && (i.title = $9481eb156b453e62$var$B.title), "$performance_event" === e) {
                    var h = this.persistence.properties();
                    return i.distinct_id = h.distinct_id, i.$current_url = s.$current_url, i;
                }
                if (!$9481eb156b453e62$var$R(r)) {
                    var f = (new Date).getTime() - r;
                    i.$duration = parseFloat((f / 1e3).toFixed(3));
                }
                $9481eb156b453e62$var$N && this.config.opt_out_useragent_filter && (i.$browser_type = $9481eb156b453e62$var$vr($9481eb156b453e62$var$N, this.config.custom_blocked_useragents) ? "bot" : "browser"), i = $9481eb156b453e62$var$z({}, $9481eb156b453e62$var$St.properties(), this.persistence.properties(), this.sessionPersistence.properties(), i);
                var p = this.config.property_blacklist;
                $9481eb156b453e62$var$S(p) ? $9481eb156b453e62$var$G(p, function(e) {
                    delete i[e];
                }) : $9481eb156b453e62$var$H.error("Invalid value for property_blacklist config: " + p);
                var _ = this.config.sanitize_properties;
                return _ && (i = _(i, e)), i;
            }
        },
        {
            key: "register",
            value: function(e, t) {
                var n;
                null === (n = this.persistence) || void 0 === n || n.register(e, t);
            }
        },
        {
            key: "register_once",
            value: function(e, t, n) {
                var r;
                null === (r = this.persistence) || void 0 === r || r.register_once(e, t, n);
            }
        },
        {
            key: "register_for_session",
            value: function(e) {
                var t;
                null === (t = this.sessionPersistence) || void 0 === t || t.register(e);
            }
        },
        {
            key: "unregister",
            value: function(e) {
                var t;
                null === (t = this.persistence) || void 0 === t || t.unregister(e);
            }
        },
        {
            key: "unregister_for_session",
            value: function(e) {
                var t;
                null === (t = this.sessionPersistence) || void 0 === t || t.unregister(e);
            }
        },
        {
            key: "_register_single",
            value: function(e, t) {
                this.register($9481eb156b453e62$var$s({}, e, t));
            }
        },
        {
            key: "getFeatureFlag",
            value: function(e, t) {
                return this.featureFlags.getFeatureFlag(e, t);
            }
        },
        {
            key: "getFeatureFlagPayload",
            value: function(e) {
                var t = this.featureFlags.getFeatureFlagPayload(e);
                try {
                    return JSON.parse(t);
                } catch (e) {
                    return t;
                }
            }
        },
        {
            key: "isFeatureEnabled",
            value: function(e, t) {
                return this.featureFlags.isFeatureEnabled(e, t);
            }
        },
        {
            key: "reloadFeatureFlags",
            value: function() {
                this.featureFlags.reloadFeatureFlags();
            }
        },
        {
            key: "updateEarlyAccessFeatureEnrollment",
            value: function(e, t) {
                this.featureFlags.updateEarlyAccessFeatureEnrollment(e, t);
            }
        },
        {
            key: "getEarlyAccessFeatures",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.featureFlags.getEarlyAccessFeatures(e, t);
            }
        },
        {
            key: "onFeatureFlags",
            value: function(e) {
                return this.featureFlags.onFeatureFlags(e);
            }
        },
        {
            key: "onSessionId",
            value: function(e) {
                var t, n;
                return null !== (t = null === (n = this.sessionManager) || void 0 === n ? void 0 : n.onSessionId(e)) && void 0 !== t ? t : function() {};
            }
        },
        {
            key: "getSurveys",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.surveys.getSurveys(e, t);
            }
        },
        {
            key: "getActiveMatchingSurveys",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.surveys.getActiveMatchingSurveys(e, t);
            }
        },
        {
            key: "identify",
            value: function(e, t, n) {
                if (!this.__loaded || !this.persistence) return $9481eb156b453e62$var$H.uninitializedWarning("posthog.identify");
                if (e) {
                    if ([
                        "distinct_id",
                        "distinctid"
                    ].includes(e.toLowerCase())) $9481eb156b453e62$var$H.critical('The string "'.concat(e, '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'));
                    else {
                        var r = this.get_distinct_id();
                        if (this.register({
                            $user_id: e
                        }), !this.get_property("$device_id")) {
                            var i = r;
                            this.register_once({
                                $had_persisted_distinct_id: !0,
                                $device_id: i
                            }, "");
                        }
                        e !== r && e !== this.get_property($9481eb156b453e62$var$Fe) && (this.unregister($9481eb156b453e62$var$Fe), this.register({
                            distinct_id: e
                        }));
                        var o = "anonymous" === this.persistence.get_user_state();
                        e !== r && o ? (this.persistence.set_user_state("identified"), this.setPersonPropertiesForFlags(t || {}, !1), this.capture("$identify", {
                            distinct_id: e,
                            $anon_distinct_id: r
                        }, {
                            $set: t || {},
                            $set_once: n || {}
                        }), this.featureFlags.setAnonymousDistinctId(r)) : (t || n) && this.setPersonProperties(t, n), e !== r && (this.reloadFeatureFlags(), this.unregister($9481eb156b453e62$var$Be));
                    }
                } else $9481eb156b453e62$var$H.error("Unique user id has not been set in posthog.identify");
            }
        },
        {
            key: "setPersonProperties",
            value: function(e, t) {
                (e || t) && (this.setPersonPropertiesForFlags(e || {}), this.capture("$set", {
                    $set: e || {},
                    $set_once: t || {}
                }));
            }
        },
        {
            key: "group",
            value: function(e, n, r) {
                if (e && n) {
                    var i = this.getGroups();
                    i[e] !== n && this.resetGroupPropertiesForFlags(e), this.register({
                        $groups: $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, i), {}, $9481eb156b453e62$var$s({}, e, n))
                    }), r && (this.capture("$groupidentify", {
                        $group_type: e,
                        $group_key: n,
                        $group_set: r
                    }), this.setGroupPropertiesForFlags($9481eb156b453e62$var$s({}, e, r))), i[e] === n || r || this.reloadFeatureFlags();
                } else $9481eb156b453e62$var$H.error("posthog.group requires a group type and group key");
            }
        },
        {
            key: "resetGroups",
            value: function() {
                this.register({
                    $groups: {}
                }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
            }
        },
        {
            key: "setPersonPropertiesForFlags",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.featureFlags.setPersonPropertiesForFlags(e, t);
            }
        },
        {
            key: "resetPersonPropertiesForFlags",
            value: function() {
                this.featureFlags.resetPersonPropertiesForFlags();
            }
        },
        {
            key: "setGroupPropertiesForFlags",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.featureFlags.setGroupPropertiesForFlags(e, t);
            }
        },
        {
            key: "resetGroupPropertiesForFlags",
            value: function(e) {
                this.featureFlags.resetGroupPropertiesForFlags(e);
            }
        },
        {
            key: "reset",
            value: function(e) {
                var t, n, r, i;
                if (!this.__loaded) return $9481eb156b453e62$var$H.uninitializedWarning("posthog.reset");
                var o = this.get_property("$device_id");
                null === (t = this.persistence) || void 0 === t || t.clear(), null === (n = this.sessionPersistence) || void 0 === n || n.clear(), null === (r = this.persistence) || void 0 === r || r.set_user_state("anonymous"), null === (i = this.sessionManager) || void 0 === i || i.resetSessionId();
                var s = this.config.get_device_id($9481eb156b453e62$var$nt());
                this.register_once({
                    distinct_id: s,
                    $device_id: e ? s : o
                }, "");
            }
        },
        {
            key: "get_distinct_id",
            value: function() {
                return this.get_property("distinct_id");
            }
        },
        {
            key: "getGroups",
            value: function() {
                return this.get_property("$groups") || {};
            }
        },
        {
            key: "get_session_id",
            value: function() {
                var e, t;
                return null !== (e = null === (t = this.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== e ? e : "";
            }
        },
        {
            key: "get_session_replay_url",
            value: function(e) {
                if (!this.sessionManager) return "";
                var t = this.config.ui_host || this.config.api_host, n = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = n.sessionId, i = n.sessionStartTimestamp, o = t + "/replay/" + r;
                if (null != e && e.withTimestamp && i) {
                    var s, a = null !== (s = e.timestampLookBack) && void 0 !== s ? s : 10;
                    if (!i) return o;
                    var u = Math.max(Math.floor(((new Date).getTime() - i) / 1e3) - a, 0);
                    o += "?t=".concat(u);
                }
                return o;
            }
        },
        {
            key: "alias",
            value: function(e, t) {
                return e === this.get_property($9481eb156b453e62$var$Se) ? ($9481eb156b453e62$var$H.critical("Attempting to create alias for existing People user - aborting."), -2) : ($9481eb156b453e62$var$R(t) && (t = this.get_distinct_id()), e !== t ? (this._register_single($9481eb156b453e62$var$Fe, e), this.capture("$create_alias", {
                    alias: e,
                    distinct_id: t
                })) : ($9481eb156b453e62$var$H.warn("alias matches current distinct_id - skipping api call."), this.identify(e), -1));
            }
        },
        {
            key: "set_config",
            value: function(e) {
                var n, r, i = $9481eb156b453e62$var$t({}, this.config);
                $9481eb156b453e62$var$I(e) && ($9481eb156b453e62$var$z(this.config, e), this.config.persistence_name || (this.config.persistence_name = this.config.cookie_name), this.config.disable_persistence || (this.config.disable_persistence = this.config.disable_cookie), this.config.api_host = this.config.api_host.replace(/\/$/, ""), "https://us.posthog.com" === this.config.api_host && (this.config.api_host = "https://app.posthog.com"), null === (n = this.persistence) || void 0 === n || n.update_config(this.config), null === (r = this.sessionPersistence) || void 0 === r || r.update_config(this.config), $9481eb156b453e62$var$dt.is_supported() && "true" === $9481eb156b453e62$var$dt.get("ph_debug") && (this.config.debug = !0), this.config.debug && ($9481eb156b453e62$var$m.DEBUG = !0), this.sessionRecording && !$9481eb156b453e62$var$R(e.disable_session_recording) && i.disable_session_recording !== e.disable_session_recording && (e.disable_session_recording ? this.sessionRecording.stopRecording() : this.sessionRecording.startRecordingIfEnabled()));
            }
        },
        {
            key: "startSessionRecording",
            value: function() {
                this.set_config({
                    disable_session_recording: !1
                });
            }
        },
        {
            key: "stopSessionRecording",
            value: function() {
                this.set_config({
                    disable_session_recording: !0
                });
            }
        },
        {
            key: "sessionRecordingStarted",
            value: function() {
                var e;
                return !(null === (e = this.sessionRecording) || void 0 === e || !e.started);
            }
        },
        {
            key: "loadToolbar",
            value: function(e) {
                return this.toolbar.loadToolbar(e);
            }
        },
        {
            key: "get_property",
            value: function(e) {
                var t;
                return null === (t = this.persistence) || void 0 === t ? void 0 : t.props[e];
            }
        },
        {
            key: "getSessionProperty",
            value: function(e) {
                var t;
                return null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.props[e];
            }
        },
        {
            key: "toString",
            value: function() {
                var e, t = null !== (e = this.config.name) && void 0 !== e ? e : $9481eb156b453e62$var$br;
                return t !== $9481eb156b453e62$var$br && (t = $9481eb156b453e62$var$br + "." + t), t;
            }
        },
        {
            key: "_gdpr_init",
            value: function() {
                "localStorage" === this.config.opt_out_capturing_persistence_type && $9481eb156b453e62$var$dt.is_supported() && (!this.has_opted_in_capturing() && this.has_opted_in_capturing({
                    persistence_type: "cookie"
                }) && this.opt_in_capturing({
                    enable_persistence: !1
                }), !this.has_opted_out_capturing() && this.has_opted_out_capturing({
                    persistence_type: "cookie"
                }) && this.opt_out_capturing({
                    clear_persistence: !1
                }), this.clear_opt_in_out_capturing({
                    persistence_type: "cookie",
                    enable_persistence: !1
                })), this.has_opted_out_capturing() ? this._gdpr_update_persistence({
                    clear_persistence: !0
                }) : this.has_opted_in_capturing() || !this.config.opt_out_capturing_by_default && !$9481eb156b453e62$var$lt.get("ph_optout") || ($9481eb156b453e62$var$lt.remove("ph_optout"), this.opt_out_capturing({
                    clear_persistence: this.config.opt_out_persistence_by_default
                }));
            }
        },
        {
            key: "_gdpr_update_persistence",
            value: function(e) {
                var t, n, r, i, o;
                if (e && e.clear_persistence) r = !0;
                else {
                    if (!e || !e.enable_persistence) return;
                    r = !1;
                }
                this.config.disable_persistence || (null === (t = this.persistence) || void 0 === t ? void 0 : t.disabled) === r || null === (i = this.persistence) || void 0 === i || i.set_disabled(r);
                this.config.disable_persistence || (null === (n = this.sessionPersistence) || void 0 === n ? void 0 : n.disabled) === r || null === (o = this.sessionPersistence) || void 0 === o || o.set_disabled(r);
            }
        },
        {
            key: "_gdpr_call_func",
            value: function(e, t) {
                return t = $9481eb156b453e62$var$z({
                    capture: this.capture.bind(this),
                    persistence_type: this.config.opt_out_capturing_persistence_type,
                    cookie_prefix: this.config.opt_out_capturing_cookie_prefix,
                    cookie_expiration: this.config.cookie_expiration,
                    cross_subdomain_cookie: this.config.cross_subdomain_cookie,
                    secure_cookie: this.config.secure_cookie
                }, t || {}), $9481eb156b453e62$var$dt.is_supported() || "localStorage" !== t.persistence_type || (t.persistence_type = "cookie"), e(this.config.token, {
                    capture: t.capture,
                    captureEventName: t.capture_event_name,
                    captureProperties: t.capture_properties,
                    persistenceType: t.persistence_type,
                    persistencePrefix: t.cookie_prefix,
                    cookieExpiration: t.cookie_expiration,
                    crossSubdomainCookie: t.cross_subdomain_cookie,
                    secureCookie: t.secure_cookie
                });
            }
        },
        {
            key: "opt_in_capturing",
            value: function(e) {
                e = $9481eb156b453e62$var$z({
                    enable_persistence: !0
                }, e || {}), this._gdpr_call_func($9481eb156b453e62$var$Jt, e), this._gdpr_update_persistence(e);
            }
        },
        {
            key: "opt_out_capturing",
            value: function(e) {
                var t = $9481eb156b453e62$var$z({
                    clear_persistence: !0
                }, e || {});
                this._gdpr_call_func($9481eb156b453e62$var$Xt, t), this._gdpr_update_persistence(t);
            }
        },
        {
            key: "has_opted_in_capturing",
            value: function(e) {
                return this._gdpr_call_func($9481eb156b453e62$var$Kt, e);
            }
        },
        {
            key: "has_opted_out_capturing",
            value: function(e) {
                return this._gdpr_call_func($9481eb156b453e62$var$Zt, e);
            }
        },
        {
            key: "clear_opt_in_out_capturing",
            value: function(e) {
                var t = $9481eb156b453e62$var$z({
                    enable_persistence: !0
                }, null != e ? e : {});
                this._gdpr_call_func($9481eb156b453e62$var$en, t), this._gdpr_update_persistence(t);
            }
        },
        {
            key: "debug",
            value: function(e) {
                !1 === e ? (null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
                    debug: !1
                })) : (null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
                    debug: !0
                }));
            }
        }
    ]), e;
}();
!function(e, t) {
    for(var n = 0; n < t.length; n++)e.prototype[t[n]] = $9481eb156b453e62$var$K(e.prototype[t[n]]);
}($9481eb156b453e62$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $9481eb156b453e62$export$22779822dd24228f, $9481eb156b453e62$export$9c2ac61661d417f8, $9481eb156b453e62$var$Er = {}, $9481eb156b453e62$var$Cr = function() {
    $9481eb156b453e62$var$lr.init = function(e, t, n) {
        if (n) return $9481eb156b453e62$var$lr[n] || ($9481eb156b453e62$var$lr[n] = $9481eb156b453e62$var$Er[n] = $9481eb156b453e62$var$Fr(e || "", t || {}, n, function(e) {
            $9481eb156b453e62$var$lr[n] = $9481eb156b453e62$var$Er[n] = e, e._loaded();
        })), $9481eb156b453e62$var$lr[n];
        var r = $9481eb156b453e62$var$lr;
        return $9481eb156b453e62$var$Er[$9481eb156b453e62$var$br] ? r = $9481eb156b453e62$var$Er[$9481eb156b453e62$var$br] : e && (r = $9481eb156b453e62$var$Fr(e, t || {}, $9481eb156b453e62$var$br, function(e) {
            $9481eb156b453e62$var$Er[$9481eb156b453e62$var$br] = e, e._loaded();
        }), $9481eb156b453e62$var$Er[$9481eb156b453e62$var$br] = r), $9481eb156b453e62$var$lr = r, $9481eb156b453e62$var$ur === $9481eb156b453e62$var$ar.INIT_SNIPPET && ($9481eb156b453e62$var$L[$9481eb156b453e62$var$br] = $9481eb156b453e62$var$lr), $9481eb156b453e62$var$G($9481eb156b453e62$var$Er, function(e, t) {
            t !== $9481eb156b453e62$var$br && ($9481eb156b453e62$var$lr[t] = e);
        }), r;
    };
}, $9481eb156b453e62$var$$r = function() {
    function e() {
        e.done || (e.done = !0, $9481eb156b453e62$var$wr = !1, $9481eb156b453e62$var$G($9481eb156b453e62$var$Er, function(e) {
            e._dom_loaded();
        }));
    }
    null != $9481eb156b453e62$var$B && $9481eb156b453e62$var$B.addEventListener && ("complete" === $9481eb156b453e62$var$B.readyState ? e() : $9481eb156b453e62$var$B.addEventListener("DOMContentLoaded", e, !1)), $9481eb156b453e62$var$D && $9481eb156b453e62$var$ie($9481eb156b453e62$var$D, "load", e, !0);
};
!function(e) {
    e.Popover = "popover", e.API = "api", e.Widget = "widget";
}($9481eb156b453e62$export$22779822dd24228f || ($9481eb156b453e62$export$22779822dd24228f = {})), function(e) {
    e.Open = "open", e.MultipleChoice = "multiple_choice", e.SingleChoice = "single_choice", e.Rating = "rating", e.Link = "link";
}($9481eb156b453e62$export$9c2ac61661d417f8 || ($9481eb156b453e62$export$9c2ac61661d417f8 = {}));
var $9481eb156b453e62$export$2e2bcd8739ae039 = ($9481eb156b453e62$var$ur = $9481eb156b453e62$var$ar.INIT_MODULE, $9481eb156b453e62$var$lr = new $9481eb156b453e62$export$a9d6b9cbf49b8241, $9481eb156b453e62$var$Cr(), $9481eb156b453e62$var$lr.init(), $9481eb156b453e62$var$$r(), $9481eb156b453e62$var$lr);



parcelRequire("acw62");
var $a3478a115f13707d$exports = {};
"use client";
"use strict";
var $a3478a115f13707d$var$Y = Object.create;
var $a3478a115f13707d$var$E = Object.defineProperty;
var $a3478a115f13707d$var$q = Object.getOwnPropertyDescriptor;
var $a3478a115f13707d$var$G = Object.getOwnPropertyNames;
var $a3478a115f13707d$var$K = Object.getPrototypeOf, $a3478a115f13707d$var$Z = Object.prototype.hasOwnProperty;
var $a3478a115f13707d$var$ee = (e, t)=>{
    for(var o in t)$a3478a115f13707d$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $a3478a115f13707d$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $a3478a115f13707d$var$G(t))!$a3478a115f13707d$var$Z.call(e, r) && r !== o && $a3478a115f13707d$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $a3478a115f13707d$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $a3478a115f13707d$var$W = (e, t, o)=>(o = e != null ? $a3478a115f13707d$var$Y($a3478a115f13707d$var$K(e)) : {}, $a3478a115f13707d$var$j(t || !e || !e.__esModule ? $a3478a115f13707d$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $a3478a115f13707d$var$te = (e)=>$a3478a115f13707d$var$j($a3478a115f13707d$var$E({}, "__esModule", {
        value: !0
    }), e);
var $a3478a115f13707d$var$Ve = {};
$a3478a115f13707d$var$ee($a3478a115f13707d$var$Ve, {
    CheckmarkIcon: ()=>$a3478a115f13707d$var$F,
    ErrorIcon: ()=>$a3478a115f13707d$var$w,
    LoaderIcon: ()=>$a3478a115f13707d$var$M,
    ToastBar: ()=>$a3478a115f13707d$var$$,
    ToastIcon: ()=>$a3478a115f13707d$var$U,
    Toaster: ()=>$a3478a115f13707d$var$J,
    default: ()=>$a3478a115f13707d$var$_e,
    resolveValue: ()=>$a3478a115f13707d$var$u,
    toast: ()=>$a3478a115f13707d$var$n,
    useToaster: ()=>$a3478a115f13707d$var$V,
    useToasterStore: ()=>$a3478a115f13707d$var$_
});
$a3478a115f13707d$exports = $a3478a115f13707d$var$te($a3478a115f13707d$var$Ve);
var $a3478a115f13707d$var$oe = (e)=>typeof e == "function", $a3478a115f13707d$var$u = (e, t)=>$a3478a115f13707d$var$oe(e) ? e(t) : e;
var $a3478a115f13707d$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $a3478a115f13707d$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $a3478a115f13707d$var$re = 20;
var $a3478a115f13707d$var$v = new Map, $a3478a115f13707d$var$se = 1e3, $a3478a115f13707d$var$X = (e)=>{
    if ($a3478a115f13707d$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $a3478a115f13707d$var$v.delete(e), $a3478a115f13707d$var$l({
            type: 4,
            toastId: e
        });
    }, $a3478a115f13707d$var$se);
    $a3478a115f13707d$var$v.set(e, t);
}, $a3478a115f13707d$var$ae = (e)=>{
    let t = $a3478a115f13707d$var$v.get(e);
    t && clearTimeout(t);
}, $a3478a115f13707d$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $a3478a115f13707d$var$re)
            };
        case 1:
            return t.toast.id && $a3478a115f13707d$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $a3478a115f13707d$var$H(e, {
                type: 1,
                toast: o
            }) : $a3478a115f13707d$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $a3478a115f13707d$var$X(s) : e.toasts.forEach((a)=>{
                $a3478a115f13707d$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $a3478a115f13707d$var$I = [], $a3478a115f13707d$var$D = {
    toasts: [],
    pausedAt: void 0
}, $a3478a115f13707d$var$l = (e)=>{
    $a3478a115f13707d$var$D = $a3478a115f13707d$var$H($a3478a115f13707d$var$D, e), $a3478a115f13707d$var$I.forEach((t)=>{
        t($a3478a115f13707d$var$D);
    });
}, $a3478a115f13707d$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $a3478a115f13707d$var$_ = (e = {})=>{
    let [t, o] = (0, (parcelRequire("acw62")).useState)($a3478a115f13707d$var$D);
    (0, (parcelRequire("acw62")).useEffect)(()=>($a3478a115f13707d$var$I.push(o), ()=>{
            let r = $a3478a115f13707d$var$I.indexOf(o);
            r > -1 && $a3478a115f13707d$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $a3478a115f13707d$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $a3478a115f13707d$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $a3478a115f13707d$var$Q()
    }), $a3478a115f13707d$var$S = (e)=>(t, o)=>{
        let s = $a3478a115f13707d$var$ce(t, e, o);
        return $a3478a115f13707d$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $a3478a115f13707d$var$n = (e, t)=>$a3478a115f13707d$var$S("blank")(e, t);
$a3478a115f13707d$var$n.error = $a3478a115f13707d$var$S("error");
$a3478a115f13707d$var$n.success = $a3478a115f13707d$var$S("success");
$a3478a115f13707d$var$n.loading = $a3478a115f13707d$var$S("loading");
$a3478a115f13707d$var$n.custom = $a3478a115f13707d$var$S("custom");
$a3478a115f13707d$var$n.dismiss = (e)=>{
    $a3478a115f13707d$var$l({
        type: 3,
        toastId: e
    });
};
$a3478a115f13707d$var$n.remove = (e)=>$a3478a115f13707d$var$l({
        type: 4,
        toastId: e
    });
$a3478a115f13707d$var$n.promise = (e, t, o)=>{
    let s = $a3478a115f13707d$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($a3478a115f13707d$var$n.success($a3478a115f13707d$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $a3478a115f13707d$var$n.error($a3478a115f13707d$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $a3478a115f13707d$var$pe = (e, t)=>{
    $a3478a115f13707d$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $a3478a115f13707d$var$de = ()=>{
    $a3478a115f13707d$var$l({
        type: 5,
        time: Date.now()
    });
}, $a3478a115f13707d$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $a3478a115f13707d$var$_(e);
    (0, (parcelRequire("acw62")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $a3478a115f13707d$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$a3478a115f13707d$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("acw62")).useCallback)(()=>{
        o && $a3478a115f13707d$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("acw62")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $a3478a115f13707d$var$pe,
            startPause: $a3478a115f13707d$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $a3478a115f13707d$var$T = $a3478a115f13707d$var$W((parcelRequire("acw62")));
let $59bacf62d0c4a6b9$var$e = {
    data: ""
}, $59bacf62d0c4a6b9$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $59bacf62d0c4a6b9$var$e, $59bacf62d0c4a6b9$export$54aba348a7896325 = (e)=>{
    let r = $59bacf62d0c4a6b9$var$t(e), l = r.data;
    return r.data = "", l;
}, $59bacf62d0c4a6b9$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $59bacf62d0c4a6b9$var$a = /\/\*[^]*?\*\/|  +/g, $59bacf62d0c4a6b9$var$n = /\n+/g, $59bacf62d0c4a6b9$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $59bacf62d0c4a6b9$var$o(c, n) : n + "{" + $59bacf62d0c4a6b9$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $59bacf62d0c4a6b9$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $59bacf62d0c4a6b9$var$o.p ? $59bacf62d0c4a6b9$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $59bacf62d0c4a6b9$var$c = {}, $59bacf62d0c4a6b9$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $59bacf62d0c4a6b9$var$s(e[r]);
        return t;
    }
    return e;
}, $59bacf62d0c4a6b9$var$i = (e, t, r, i, p)=>{
    let u = $59bacf62d0c4a6b9$var$s(e), d = $59bacf62d0c4a6b9$var$c[u] || ($59bacf62d0c4a6b9$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$59bacf62d0c4a6b9$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $59bacf62d0c4a6b9$var$l.exec(e.replace($59bacf62d0c4a6b9$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($59bacf62d0c4a6b9$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($59bacf62d0c4a6b9$var$n, " ").trim();
            return o[0];
        })(e);
        $59bacf62d0c4a6b9$var$c[d] = $59bacf62d0c4a6b9$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $59bacf62d0c4a6b9$var$c.g ? $59bacf62d0c4a6b9$var$c.g : null;
    return r && ($59bacf62d0c4a6b9$var$c.g = $59bacf62d0c4a6b9$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($59bacf62d0c4a6b9$var$c[d], t, i, f), d;
}, $59bacf62d0c4a6b9$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $59bacf62d0c4a6b9$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $59bacf62d0c4a6b9$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $59bacf62d0c4a6b9$var$i(l.unshift ? l.raw ? $59bacf62d0c4a6b9$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $59bacf62d0c4a6b9$var$t(r.target), r.g, r.o, r.k);
}
let $59bacf62d0c4a6b9$var$d, $59bacf62d0c4a6b9$var$f, $59bacf62d0c4a6b9$var$g, $59bacf62d0c4a6b9$export$442f1a04865e4790 = $59bacf62d0c4a6b9$export$dbf350e5966cf602.bind({
    g: 1
}), $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e = $59bacf62d0c4a6b9$export$dbf350e5966cf602.bind({
    k: 1
});
function $59bacf62d0c4a6b9$export$de27182ff8187d6c(e, t, r, l) {
    $59bacf62d0c4a6b9$var$o.p = t, $59bacf62d0c4a6b9$var$d = e, $59bacf62d0c4a6b9$var$f = r, $59bacf62d0c4a6b9$var$g = l;
}
function $59bacf62d0c4a6b9$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $59bacf62d0c4a6b9$var$f && $59bacf62d0c4a6b9$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $59bacf62d0c4a6b9$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $59bacf62d0c4a6b9$var$g && i[0] && $59bacf62d0c4a6b9$var$g(c), $59bacf62d0c4a6b9$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}



var $a3478a115f13707d$var$y = $a3478a115f13707d$var$W((parcelRequire("acw62")));


var $a3478a115f13707d$var$me = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $a3478a115f13707d$var$ue = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $a3478a115f13707d$var$le = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $a3478a115f13707d$var$w = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$a3478a115f13707d$var$me} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$a3478a115f13707d$var$ue} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$a3478a115f13707d$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $a3478a115f13707d$var$Te = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $a3478a115f13707d$var$M = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$a3478a115f13707d$var$Te} 1s linear infinite;
`;

var $a3478a115f13707d$var$fe = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $a3478a115f13707d$var$ye = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $a3478a115f13707d$var$F = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$a3478a115f13707d$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$a3478a115f13707d$var$ye} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $a3478a115f13707d$var$ge = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: absolute;
`, $a3478a115f13707d$var$he = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $a3478a115f13707d$var$xe = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $a3478a115f13707d$var$be = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$a3478a115f13707d$var$xe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $a3478a115f13707d$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$be, null, t) : t : o === "blank" ? null : $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$he, null, $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$M, {
        ...s
    }), o !== "loading" && $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$ge, null, o === "error" ? $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$w, {
        ...s
    }) : $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$F, {
        ...s
    })));
};
var $a3478a115f13707d$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $a3478a115f13707d$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $a3478a115f13707d$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $a3478a115f13707d$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $a3478a115f13707d$var$Ee = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $a3478a115f13707d$var$Re = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $a3478a115f13707d$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $a3478a115f13707d$var$R() ? [
        $a3478a115f13707d$var$Pe,
        $a3478a115f13707d$var$Oe
    ] : [
        $a3478a115f13707d$var$Se(s),
        $a3478a115f13707d$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $a3478a115f13707d$var$$ = $a3478a115f13707d$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $a3478a115f13707d$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$U, {
        toast: e
    }), c = $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$Re, {
        ...e.ariaProps
    }, $a3478a115f13707d$var$u(e.message, e));
    return $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$T.Fragment, null, a, c));
});


var $a3478a115f13707d$var$f = $a3478a115f13707d$var$W((parcelRequire("acw62")));
(0, $59bacf62d0c4a6b9$export$de27182ff8187d6c)($a3478a115f13707d$var$f.createElement);
var $a3478a115f13707d$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $a3478a115f13707d$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $a3478a115f13707d$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $a3478a115f13707d$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $a3478a115f13707d$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $a3478a115f13707d$var$ke = $59bacf62d0c4a6b9$export$dbf350e5966cf602`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $a3478a115f13707d$var$L = 16, $a3478a115f13707d$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $a3478a115f13707d$var$V(o);
    return $a3478a115f13707d$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $a3478a115f13707d$var$L,
            left: $a3478a115f13707d$var$L,
            right: $a3478a115f13707d$var$L,
            bottom: $a3478a115f13707d$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $a3478a115f13707d$var$De(g, z);
        return $a3478a115f13707d$var$f.createElement($a3478a115f13707d$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $a3478a115f13707d$var$ke : "",
            style: O
        }, p.type === "custom" ? $a3478a115f13707d$var$u(p.message, p) : r ? r(p) : $a3478a115f13707d$var$f.createElement($a3478a115f13707d$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $a3478a115f13707d$var$_e = $a3478a115f13707d$var$n;


const $4330379de499a7df$var$variantColor = {
    success: "#6EE038",
    error: "#FF2600"
};
const $4330379de499a7df$export$b7fdbd5ce3936fbe = ({ text: text, variant: variant, duration: duration = 5500, className: className = "" })=>{
    const toastProps = {
        duration: duration
    };
    const animClasses = "";
    const toastElement = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${animClasses} tw-flex tw-cursor-not-allowed tw-p-2 tw-px-3 tw-text-black tw-bg-[${$4330379de499a7df$var$variantColor[variant]}] tw-rounded tw-mb-6 ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: `wi my-auto tw-mr-3 ${variant == "success" ? "wi-sm wi-check" : "wi-xs wi-close"}`
            }),
            text
        ]
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a3478a115f13707d$exports))).custom(toastElement, toastProps);
};
const $4330379de499a7df$export$c654193b8661f133 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3478a115f13707d$exports.Toaster), {
        position: "top-center"
    });
};




/**
 * React Router DOM v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.9.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}

/**
 * React Router v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$3add0d5dce533e2e.displayName = "DataRouter";
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$145dfa71566a64dc.displayName = "DataRouterState";
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$var$AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$26749e8557646306.displayName = "Navigation";
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$c7914228fb69b0f5.displayName = "Location";
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$7939e29d663dd3ed$export$9072aa6dd1f93057.displayName = "Route";
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$var$RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(activeRef.current, $7939e29d663dd3ed$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $7939e29d663dd3ed$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + parentPathname + '" (under <Route path="' + parentPath + '">) but the ') + 'parent route path has no trailing "*". This means if you navigate ' + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ('Please change the parent <Route path="' + parentPath + '"> to <Route ') + ('path="' + (parentPath === "/" ? "*" : parentPath + "/*") + '">.'));
    }
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + parentPathnameBase + '" ') + ('but pathname "' + parsedLocationArg.pathname + '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(parentRoute || matches != null, 'No routes matched location "' + location.pathname + location.search + location.hash + '" ');
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined, 'Matched leaf route at location "' + location.pathname + location.search + location.hash + '" ' + "does not have an element or Component. This means it will render an <Outlet /> with a " + 'null value by default resulting in an "empty" page.');
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ $acw62.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ $acw62.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName));
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, hookName + ' can only be used on routes that contain a unique "id"');
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "useActionData must be used inside a RouteContext");
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(activeRef.current, $7939e29d663dd3ed$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) {
        $7939e29d663dd3ed$var$alreadyWarned[key] = true;
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, message);
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(!$acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(locationContext != null, '<Router basename="' + basename + '"> is not able to match the URL ' + ('"' + pathname + search + hash + '" because it does not start with the ') + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ $acw62.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) {
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, '"' + encType + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + $040dbb9c344a508d$var$defaultEncType + '"'));
        return null;
    }
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367)
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367)
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$040dbb9c344a508d$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref4, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, '<Link to="' + to + '"> contains an invalid URL which will probably break ' + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
$040dbb9c344a508d$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref5, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
$040dbb9c344a508d$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
$040dbb9c344a508d$export$a7fed597f4b8afd8.displayName = "Form";
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref6, $040dbb9c344a508d$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
$040dbb9c344a508d$var$FormImpl.displayName = "FormImpl";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
$040dbb9c344a508d$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $040dbb9c344a508d$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $040dbb9c344a508d$var$getDataRouterConsoleError(hookName));
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params\n\nIf you're unsure how to load polyfills, we recommend you check out https://polyfill.io/v3/ which provides some recommendations about how to load polyfills only for users that need them, instead of for every user.");
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No routeId available for useFetcher()");
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    FetcherForm.displayName = "fetcher.Form";
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "useFetcher must be used inside a RouteContext");
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, 'useFetcher can only be used on routes that contain a unique "id"');
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No routeId available for fetcher.Form()");
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No router available for fetcher.load()");
            !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No routeId available for fetcher.load()");
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $7939e29d663dd3ed$export$2af03a1de5c0910)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $cc3eb4e70d9f2fd9$export$2812a1fb15aca49c = "http://localhost".replace(/\/+$/, "");
class $cc3eb4e70d9f2fd9$export$fa89be98fe0936f2 {
    constructor(configuration = {}){
        this.configuration = configuration;
    }
    set config(configuration) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : $cc3eb4e70d9f2fd9$export$2812a1fb15aca49c;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || $cc3eb4e70d9f2fd9$export$ac4103b836844853;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === "function" ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === "function" ? accessToken : async ()=>accessToken;
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
const $cc3eb4e70d9f2fd9$export$ac4f8128ea29c5 = new $cc3eb4e70d9f2fd9$export$fa89be98fe0936f2();
class $cc3eb4e70d9f2fd9$export$70edad7ad5bb3f5d {
    static #_ = this.jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
    constructor(configuration = $cc3eb4e70d9f2fd9$export$ac4f8128ea29c5){
        this.configuration = configuration;
        this.fetchApi = async (url, init)=>{
            let fetchParams = {
                url: url,
                init: init
            };
            for (const middleware of this.middleware)if (middleware.pre) fetchParams = await middleware.pre({
                fetch: this.fetchApi,
                ...fetchParams
            }) || fetchParams;
            let response = undefined;
            try {
                response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
            } catch (e) {
                for (const middleware of this.middleware)if (middleware.onError) response = await middleware.onError({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    error: e,
                    response: response ? response.clone() : undefined
                }) || response;
                if (response === undefined) {
                    if (e instanceof Error) throw new $cc3eb4e70d9f2fd9$export$26e841bcf1aeb894(e, "The request failed and the interceptors did not return an alternative response");
                    else throw e;
                }
            }
            for (const middleware of this.middleware)if (middleware.post) response = await middleware.post({
                fetch: this.fetchApi,
                url: fetchParams.url,
                init: fetchParams.init,
                response: response.clone()
            }) || response;
            return response;
        };
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre: pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post: post
            }));
        return this.withMiddleware(...middlewares);
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */ isJsonMime(mime) {
        if (!mime) return false;
        return $cc3eb4e70d9f2fd9$export$70edad7ad5bb3f5d.jsonRegex.test(mime);
    }
    async request(context, initOverrides) {
        const { url: url, init: init } = await this.createFetchParams(context, initOverrides);
        const response = await this.fetchApi(url, init);
        if (response && response.status >= 200 && response.status < 300) return response;
        throw new $cc3eb4e70d9f2fd9$export$286baf652d0b1206(response, "Response returned an error code");
    }
    async createFetchParams(context, initOverrides) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
        // this is done to avoid urls ending with a "?" character which buggy webservers
        // do not handle correctly sometimes.
        url += "?" + this.configuration.queryParamsStringify(context.query);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        Object.keys(headers).forEach((key)=>headers[key] === undefined ? delete headers[key] : {});
        const initOverrideFn = typeof initOverrides === "function" ? initOverrides : async ()=>initOverrides;
        const initParams = {
            method: context.method,
            headers: headers,
            body: context.body,
            credentials: this.configuration.credentials
        };
        const overriddenInit = {
            ...initParams,
            ...await initOverrideFn({
                init: initParams,
                context: context
            })
        };
        const init = {
            ...overriddenInit,
            body: $cc3eb4e70d9f2fd9$var$isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || $cc3eb4e70d9f2fd9$var$isBlob(overriddenInit.body) ? overriddenInit.body : JSON.stringify(overriddenInit.body)
        };
        return {
            url: url,
            init: init
        };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
function $cc3eb4e70d9f2fd9$var$isBlob(value) {
    return typeof Blob !== "undefined" && value instanceof Blob;
}
function $cc3eb4e70d9f2fd9$var$isFormData(value) {
    return typeof FormData !== "undefined" && value instanceof FormData;
}
class $cc3eb4e70d9f2fd9$export$286baf652d0b1206 extends Error {
    constructor(response, msg){
        super(msg);
        this.response = response;
        this.name = "ResponseError";
    }
}
class $cc3eb4e70d9f2fd9$export$26e841bcf1aeb894 extends Error {
    constructor(cause, msg){
        super(msg);
        this.cause = cause;
        this.name = "FetchError";
    }
}
class $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70 extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
const $cc3eb4e70d9f2fd9$export$83cb526776fb323d = {
    csv: ",",
    ssv: " ",
    tsv: "	",
    pipes: "|"
};
function $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function $cc3eb4e70d9f2fd9$export$ac4103b836844853(params, prefix = "") {
    return Object.keys(params).map((key)=>$cc3eb4e70d9f2fd9$var$querystringSingleKey(key, params[key], prefix)).filter((part)=>part.length > 0).join("&");
}
function $cc3eb4e70d9f2fd9$var$querystringSingleKey(key, value, keyPrefix = "") {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return $cc3eb4e70d9f2fd9$var$querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    if (value instanceof Object) return $cc3eb4e70d9f2fd9$export$ac4103b836844853(value, fullKey);
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function $cc3eb4e70d9f2fd9$export$825e789796ab7275(data, fn) {
    return Object.keys(data).reduce((acc, key)=>({
            ...acc,
            [key]: fn(data[key])
        }), {});
}
function $cc3eb4e70d9f2fd9$export$59072c3750441c02(consumes) {
    for (const consume of consumes){
        if ("multipart/form-data" === consume.contentType) return true;
    }
    return false;
}
class $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4 {
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
    async value() {
        return this.transformer(await this.raw.json());
    }
}
class $cc3eb4e70d9f2fd9$export$20446dc680588cc3 {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return undefined;
    }
}
class $cc3eb4e70d9f2fd9$export$9d707f60a06b41f8 {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.blob();
    }
}
class $cc3eb4e70d9f2fd9$export$bf40ae8c274ef99b {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.text();
    }
}


/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $4aeeef1fdabdd66a$export$cc4714cd9f9c3814 = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
function $4aeeef1fdabdd66a$export$7a297d20d6883fc0(value) {
    let isInstance = true;
    return isInstance;
}
function $4aeeef1fdabdd66a$export$c974f409b401a196(json) {
    return $4aeeef1fdabdd66a$export$c0e06766df2e9b9a(json, false);
}
function $4aeeef1fdabdd66a$export$c0e06766df2e9b9a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "representative": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "representative") ? undefined : json["representative"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "bankAccountName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_account_name") ? undefined : json["bank_account_name"],
        "bankAccountNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_account_number") ? undefined : json["bank_account_number"],
        "bankSortCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_sort_code") ? undefined : json["bank_sort_code"],
        "bankName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_name") ? undefined : json["bank_name"],
        "bankAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_address") ? undefined : json["bank_address"],
        "bankPostcode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_postcode") ? undefined : json["bank_postcode"],
        "bankIban": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_iban") ? undefined : json["bank_iban"],
        "bankRoutingCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_routing_code") ? undefined : json["bank_routing_code"],
        "bankAccountHoldingBranch": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_account_holding_branch") ? undefined : json["bank_account_holding_branch"],
        "bankBicSwiftCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_bic_swift_code") ? undefined : json["bank_bic_swift_code"],
        "bankPaymentMethod": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_payment_method") ? undefined : json["bank_payment_method"]
    };
}
function $4aeeef1fdabdd66a$export$74977fc31957ceee(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_account_name": value.bankAccountName,
        "bank_account_number": value.bankAccountNumber,
        "bank_sort_code": value.bankSortCode,
        "bank_name": value.bankName,
        "bank_address": value.bankAddress,
        "bank_postcode": value.bankPostcode,
        "bank_iban": value.bankIban,
        "bank_routing_code": value.bankRoutingCode,
        "bank_account_holding_branch": value.bankAccountHoldingBranch,
        "bank_bic_swift_code": value.bankBicSwiftCode,
        "bank_payment_method": value.bankPaymentMethod
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $df1cc6f459a202ca$export$272859eee3d91646 = {
    Manager: "Manager",
    Accountant: "Accountant",
    Lawyer: "Lawyer",
    Representative: "Representative",
    Company: "Company"
};
function $df1cc6f459a202ca$export$e9e7e62cde8334d2(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $df1cc6f459a202ca$export$76e5643a4d30737f(json) {
    return $df1cc6f459a202ca$export$9dab346d51456291(json, false);
}
function $df1cc6f459a202ca$export$9dab346d51456291(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": json["name"],
        "role": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "email": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"]
    };
}
function $df1cc6f459a202ca$export$5710a887553d1b09(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name,
        "role": value.role,
        "email": value.email,
        "phone_number": value.phoneNumber
    };
}


function $db1972d7448b3ff8$export$7c52a6c7c5c7d0(value) {
    let isInstance = true;
    return isInstance;
}
function $db1972d7448b3ff8$export$8a33e3ce64853ecc(json) {
    return $db1972d7448b3ff8$export$8a81df7e0f85324d(json, false);
}
function $db1972d7448b3ff8$export$8a81df7e0f85324d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"],
        "witnessFirstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "representative": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "representative") ? undefined : (0, $df1cc6f459a202ca$export$76e5643a4d30737f)(json["representative"]),
        "representativeBankDetails": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "representative_bank_details") ? undefined : (0, $4aeeef1fdabdd66a$export$c974f409b401a196)(json["representative_bank_details"])
    };
}
function $db1972d7448b3ff8$export$a23c9ba4a9c33181(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "representative": (0, $df1cc6f459a202ca$export$5710a887553d1b09)(value.representative),
        "representative_bank_details": (0, $4aeeef1fdabdd66a$export$74977fc31957ceee)(value.representativeBankDetails)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $dc6608696afab66f$export$9ef6494467177d21(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "allNames" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $dc6608696afab66f$export$e4f27606a6d6c163(json) {
    return $dc6608696afab66f$export$18b8add634fdcef9(json, false);
}
function $dc6608696afab66f$export$18b8add634fdcef9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "allNames": json["allNames"],
        "stageName": json["stageName"]
    };
}
function $dc6608696afab66f$export$eea3d6a45d09ebc4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "allNames": value.allNames,
        "stageName": value.stageName
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $730e2a0e920732f8$export$e7268e223c4b7522(value) {
    let isInstance = true;
    isInstance = isInstance && "bankAccountNumber" in value;
    isInstance = isInstance && "bankSortCode" in value;
    isInstance = isInstance && "bankName" in value;
    isInstance = isInstance && "bankAddress" in value;
    isInstance = isInstance && "bankIban" in value;
    return isInstance;
}
function $730e2a0e920732f8$export$c6f5b638dc8b8079(json) {
    return $730e2a0e920732f8$export$65067d499f3e3ff4(json, false);
}
function $730e2a0e920732f8$export$65067d499f3e3ff4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "password": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "bankAccountName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_account_name") ? undefined : json["bank_account_name"],
        "bankAccountNumber": json["bank_account_number"],
        "bankSortCode": json["bank_sort_code"],
        "bankName": json["bank_name"],
        "bankAddress": json["bank_address"],
        "bankPostcode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_postcode") ? undefined : json["bank_postcode"],
        "bankIban": json["bank_iban"],
        "bankRoutingCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_routing_code") ? undefined : json["bank_routing_code"],
        "bankAccountHoldingBranch": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_account_holding_branch") ? undefined : json["bank_account_holding_branch"],
        "bankBicSwiftCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_bic_swift_code") ? undefined : json["bank_bic_swift_code"],
        "intermediaryBankName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "intermediary_bank_name") ? undefined : json["intermediary_bank_name"],
        "intermediaryBankAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "intermediary_bank_address") ? undefined : json["intermediary_bank_address"],
        "intermediaryBankBicSwiftCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "intermediary_bank_bic_swift_code") ? undefined : json["intermediary_bank_bic_swift_code"],
        "intermediaryBankCountry": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "intermediary_bank_country") ? undefined : json["intermediary_bank_country"]
    };
}
function $730e2a0e920732f8$export$d5ce4e46fbd36d46(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password,
        "bank_account_name": value.bankAccountName,
        "bank_account_number": value.bankAccountNumber,
        "bank_sort_code": value.bankSortCode,
        "bank_name": value.bankName,
        "bank_address": value.bankAddress,
        "bank_postcode": value.bankPostcode,
        "bank_iban": value.bankIban,
        "bank_routing_code": value.bankRoutingCode,
        "bank_account_holding_branch": value.bankAccountHoldingBranch,
        "bank_bic_swift_code": value.bankBicSwiftCode,
        "intermediary_bank_name": value.intermediaryBankName,
        "intermediary_bank_address": value.intermediaryBankAddress,
        "intermediary_bank_bic_swift_code": value.intermediaryBankBicSwiftCode,
        "intermediary_bank_country": value.intermediaryBankCountry
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $74f3aef07a9ab9ca$export$e5ec3c87ab2c3909 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $74f3aef07a9ab9ca$export$f56c6f32600d3408 = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
function $74f3aef07a9ab9ca$export$3879157971467e48(value) {
    let isInstance = true;
    return isInstance;
}
function $74f3aef07a9ab9ca$export$54f4e92d07988b2b(json) {
    return $74f3aef07a9ab9ca$export$9ed4bba3c2a12946(json, false);
}
function $74f3aef07a9ab9ca$export$9ed4bba3c2a12946(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "file": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "file") ? undefined : json["file"],
        "filename": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "filename") ? undefined : json["filename"],
        "status": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "documentExpiryDate": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "document_expiry_date") ? undefined : json["document_expiry_date"],
        "documentType": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "document_type") ? undefined : json["document_type"],
        "fileUrl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "file_url") ? undefined : json["file_url"]
    };
}
function $74f3aef07a9ab9ca$export$b7f71b51346e0e19(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "file": value.file,
        "filename": value.filename,
        "status": value.status,
        "document_expiry_date": value.documentExpiryDate,
        "document_type": value.documentType
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $cbf2593677db3000$export$8fd88fcefd9b207f = {
    PerformerProducer: "Performer/Producer"
};
function $cbf2593677db3000$export$82f115c046b1400b(value) {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    return isInstance;
}
function $cbf2593677db3000$export$2a302f093ff9aad4(json) {
    return $cbf2593677db3000$export$718ba37257e96b0(json, false);
}
function $cbf2593677db3000$export$718ba37257e96b0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "role": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "representative": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "representative") ? undefined : (0, $df1cc6f459a202ca$export$76e5643a4d30737f)(json["representative"]),
        "masterRights": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "performerOrProducer": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "firstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "email": json["email"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "masterId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "masterName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterFullname": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "masterEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "pplPerformerName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "aliases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"]
    };
}
function $cbf2593677db3000$export$9922fca795d20c2b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "role": value.role,
        "representative": (0, $df1cc6f459a202ca$export$5710a887553d1b09)(value.representative),
        "master_rights": value.masterRights,
        "performer_or_producer": value.performerOrProducer,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "email": value.email,
        "phone_number": value.phoneNumber,
        "master_id": value.masterId,
        "master_name": value.masterName,
        "master_fullname": value.masterFullname,
        "master_email": value.masterEmail,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "aliases": value.aliases
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $7db1c79fee8c8ab4$export$9176c92985e69802 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $7db1c79fee8c8ab4$export$976466c1610f6f19 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
function $7db1c79fee8c8ab4$export$354fcd6ec9dc2355(value) {
    let isInstance = true;
    return isInstance;
}
function $7db1c79fee8c8ab4$export$1601295b33eeef78(json) {
    return $7db1c79fee8c8ab4$export$9c645b64a3437939(json, false);
}
function $7db1c79fee8c8ab4$export$9c645b64a3437939(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "oldPassword": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "old_password") ? undefined : json["old_password"],
        "password": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"],
        "title": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "fullName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"],
        "firstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "department": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "departmentChoices": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "department_choices") ? undefined : json["department_choices"],
        "userPhoto": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "dateOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "aliases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "nationality": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "taxationCountry": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "westburyId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"]
    };
}
function $7db1c79fee8c8ab4$export$f60ddb500bd22238(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "old_password": value.oldPassword,
        "password": value.password,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "department": value.department,
        "user_photo": value.userPhoto,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "aliases": value.aliases,
        "nationality": value.nationality,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $61c055886c74342c$export$28b9d07f58452a32 = {
    ClientToSign: "client_to_sign",
    WitnessToSign: "witness_to_sign",
    AdminToApprove: "admin_to_approve",
    Approved: "approved"
};
function $61c055886c74342c$export$750496f6709c0771(value) {
    let isInstance = true;
    isInstance = isInstance && "societyFormId" in value;
    isInstance = isInstance && "societyFormName" in value;
    return isInstance;
}
function $61c055886c74342c$export$7fa8d9ea09641068(json) {
    return $61c055886c74342c$export$7b55d98a6fa563c(json, false);
}
function $61c055886c74342c$export$7b55d98a6fa563c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "societyFormId": json["society_form_id"],
        "societyFormName": json["society_form_name"],
        "status": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "dateCompleted": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsDocumentId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsSessionId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"]
    };
}
function $61c055886c74342c$export$1f4009bc54aefa3f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_form_id": value.societyFormId,
        "society_form_name": value.societyFormName,
        "status": value.status,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_session_id": value.pandadocsSessionId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $0103de8d3bd09504$export$e6afaa361fadb0c8 = {
    Pending: "pending",
    Approved: "approved",
    Active: "active",
    Rejected: "rejected",
    Inactive: "inactive"
};
const $0103de8d3bd09504$export$739b189f651fd128 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $0103de8d3bd09504$export$3fa4a3945f132dd6 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
const $0103de8d3bd09504$export$b26b5ed05ded7ba2 = {
    PerformerProducer: "Performer/Producer"
};
function $0103de8d3bd09504$export$7a2c11552836701(value) {
    let isInstance = true;
    return isInstance;
}
function $0103de8d3bd09504$export$1e7456cf69e13b13(json) {
    return $0103de8d3bd09504$export$d5c3184a11e23822(json, false);
}
function $0103de8d3bd09504$export$d5c3184a11e23822(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "aliases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "userPhoto": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "verifiedStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "verified_status") ? undefined : json["verified_status"],
        "signedStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "signed_status") ? undefined : json["signed_status"],
        "accountStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "account_status") ? undefined : json["account_status"],
        "title": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "firstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "nonClient": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "non_client") ? undefined : json["non_client"],
        "dateOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "nationality": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "department": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "taxationCountry": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "witnessFirstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "role": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "registeredWithPpl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "registered_with_ppl") ? undefined : json["registered_with_ppl"],
        "pplAccountName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_account_name") ? undefined : json["ppl_account_name"],
        "pplPerformerName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "notes": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "clientEmailHashed": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "client_email_hashed") ? undefined : json["client_email_hashed"],
        "westburyId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"],
        "discogsIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "discogs_ids") ? undefined : json["discogs_ids"],
        "musicbrainzIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "musicbrainz_ids") ? undefined : json["musicbrainz_ids"],
        "deezerIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "deezer_ids") ? undefined : json["deezer_ids"],
        "spotifyIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "spotify_ids") ? undefined : json["spotify_ids"],
        "performerOrProducer": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "masterRights": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "masterFullname": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "masterEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "masterName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "completedOnboardingSteps": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "completed_onboarding_steps") ? undefined : json["completed_onboarding_steps"]
    };
}
function $0103de8d3bd09504$export$29794e5965fd3174(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aliases": value.aliases,
        "user_photo": value.userPhoto,
        "account_status": value.accountStatus,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "non_client": value.nonClient,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "nationality": value.nationality,
        "department": value.department,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "role": value.role,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_account_name": value.pplAccountName,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "notes": value.notes,
        "client_email_hashed": value.clientEmailHashed,
        "discogs_ids": value.discogsIds,
        "musicbrainz_ids": value.musicbrainzIds,
        "deezer_ids": value.deezerIds,
        "spotify_ids": value.spotifyIds,
        "performer_or_producer": value.performerOrProducer,
        "master_rights": value.masterRights,
        "master_fullname": value.masterFullname,
        "master_email": value.masterEmail,
        "master_name": value.masterName,
        "master_id": value.masterId
    };
}


function $c20a722713b51704$export$dfc1b041ad39eb2(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "userSettings" in value;
    return isInstance;
}
function $c20a722713b51704$export$2965aa33e1f71909(json) {
    return $c20a722713b51704$export$6d58806ed1473f0c(json, false);
}
function $c20a722713b51704$export$6d58806ed1473f0c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "username": json["username"],
        "email": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "firstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "lastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "isActive": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "is_active") ? undefined : json["is_active"],
        "isStaff": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "is_staff") ? undefined : json["is_staff"],
        "isSuperuser": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "is_superuser") ? undefined : json["is_superuser"],
        "dateJoined": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_joined") ? undefined : new Date(json["date_joined"]),
        "userSettings": (0, $0103de8d3bd09504$export$1e7456cf69e13b13)(json["user_settings"])
    };
}
function $c20a722713b51704$export$3e0ad55966ab95f2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username,
        "email": value.email,
        "first_name": value.firstName,
        "last_name": value.lastName,
        "is_active": value.isActive,
        "is_staff": value.isStaff,
        "is_superuser": value.isSuperuser,
        "date_joined": value.dateJoined === undefined ? undefined : value.dateJoined.toISOString(),
        "user_settings": (0, $0103de8d3bd09504$export$29794e5965fd3174)(value.userSettings)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $8c77b84ae55316aa$export$2a938d5a81a4a42e(value) {
    let isInstance = true;
    return isInstance;
}
function $8c77b84ae55316aa$export$48c528d3391c2ee1(json) {
    return $8c77b84ae55316aa$export$876e5df5341c4f1f(json, false);
}
function $8c77b84ae55316aa$export$876e5df5341c4f1f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sessionId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "session_id") ? undefined : json["session_id"]
    };
}
function $8c77b84ae55316aa$export$fe1c3e8c7156433b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "session_id": value.sessionId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $2266668baa14d5e1$export$d7d3282b475f6dc6(value) {
    let isInstance = true;
    isInstance = isInstance && "aggregatePayment" in value;
    isInstance = isInstance && "date" in value;
    return isInstance;
}
function $2266668baa14d5e1$export$58ccaf3d39e682e6(json) {
    return $2266668baa14d5e1$export$15d10f3a8191fd3b(json, false);
}
function $2266668baa14d5e1$export$15d10f3a8191fd3b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aggregatePayment": json["aggregate_payment"],
        "date": json["date"]
    };
}
function $2266668baa14d5e1$export$2713f6b0b8f941bf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aggregate_payment": value.aggregatePayment,
        "date": value.date
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $8894c22abf19eb3e$export$1b12277500a4213e(value) {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;
    return isInstance;
}
function $8894c22abf19eb3e$export$991a282fb95e914b(json) {
    return $8894c22abf19eb3e$export$7631059fceafc372(json, false);
}
function $8894c22abf19eb3e$export$7631059fceafc372(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "signedUrl": json["signed_url"]
    };
}
function $8894c22abf19eb3e$export$e990b4df55b96eae(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "signed_url": value.signedUrl
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $08e14b96c1892b2f$export$34529e760ec9648a(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    return isInstance;
}
function $08e14b96c1892b2f$export$10c6c0ff67d28f5f(json) {
    return $08e14b96c1892b2f$export$5dd2b97fb96aecdd(json, false);
}
function $08e14b96c1892b2f$export$5dd2b97fb96aecdd(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["object_key"]
    };
}
function $08e14b96c1892b2f$export$6d2e9ac51213991c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "object_key": value.objectKey
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $b8ef44df9e3d43b0$export$fa9d0a1376a9ae62(value) {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;
    return isInstance;
}
function $b8ef44df9e3d43b0$export$c7b1fcf5381c94c3(json) {
    return $b8ef44df9e3d43b0$export$b9b42db810d43371(json, false);
}
function $b8ef44df9e3d43b0$export$b9b42db810d43371(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "signedUrl": json["signed_url"]
    };
}
function $b8ef44df9e3d43b0$export$17b43f446906a5ba(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "signed_url": value.signedUrl
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $f8f829a71fac9bcc$export$f1cfc44d85c80d6c(value) {
    let isInstance = true;
    isInstance = isInstance && "url" in value;
    return isInstance;
}
function $f8f829a71fac9bcc$export$dc8f04ce44c3c80c(json) {
    return $f8f829a71fac9bcc$export$b32c8f86b53b754d(json, false);
}
function $f8f829a71fac9bcc$export$b32c8f86b53b754d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": json["url"]
    };
}
function $f8f829a71fac9bcc$export$6a86535ea0505be0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "url": value.url
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $de87e482ba2e92fe$export$5dae5dda92941b26(value) {
    let isInstance = true;
    isInstance = isInstance && "fiscalYearsUnique" in value;
    return isInstance;
}
function $de87e482ba2e92fe$export$8b12be228efb1adf(json) {
    return $de87e482ba2e92fe$export$d641767c1f6d63e3(json, false);
}
function $de87e482ba2e92fe$export$d641767c1f6d63e3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "fiscalYearsUnique": json["fiscal_years_unique"]
    };
}
function $de87e482ba2e92fe$export$e15e7d171f3009bb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "fiscal_years_unique": value.fiscalYearsUnique
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $efbc7481c8d2c39c$export$b5d7bf15840e1e0f(value) {
    let isInstance = true;
    isInstance = isInstance && "documentTypes" in value;
    return isInstance;
}
function $efbc7481c8d2c39c$export$8738fab109abb74d(json) {
    return $efbc7481c8d2c39c$export$5c904fd4f42d9fe6(json, false);
}
function $efbc7481c8d2c39c$export$5c904fd4f42d9fe6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentTypes": json["document_types"]
    };
}
function $efbc7481c8d2c39c$export$b1951e116b9b781a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_types": value.documentTypes
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $b83cc17986a42e6e$export$e819a83265030c9c(value) {
    let isInstance = true;
    isInstance = isInstance && "passportFile" in value;
    isInstance = isInstance && "registeredWithPpl" in value;
    isInstance = isInstance && "streetAddress" in value;
    isInstance = isInstance && "postcode" in value;
    isInstance = isInstance && "county" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "witnessFirstName" in value;
    isInstance = isInstance && "witnessLastName" in value;
    isInstance = isInstance && "witnessEmail" in value;
    return isInstance;
}
function $b83cc17986a42e6e$export$1372d202ad798e18(json) {
    return $b83cc17986a42e6e$export$bc95f783d961e35a(json, false);
}
function $b83cc17986a42e6e$export$bc95f783d961e35a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "passportFile": json["passport_file"],
        "proofOfAddressFile": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "proof_of_address_file") ? undefined : json["proof_of_address_file"],
        "registeredWithPpl": json["registered_with_ppl"],
        "pplPerformerName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "streetAddress": json["street_address"],
        "postcode": json["postcode"],
        "county": json["county"],
        "country": json["country"],
        "witnessFirstName": json["witness_first_name"],
        "witnessLastName": json["witness_last_name"],
        "witnessEmail": json["witness_email"]
    };
}
function $b83cc17986a42e6e$export$585369f1e8f570be(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "passport_file": value.passportFile,
        "proof_of_address_file": value.proofOfAddressFile,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "street_address": value.streetAddress,
        "postcode": value.postcode,
        "county": value.county,
        "country": value.country,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e1410736f4a7598f$export$8f94fab6f213cecf(value) {
    let isInstance = true;
    isInstance = isInstance && "identifier" in value;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $e1410736f4a7598f$export$56f601b553b56a14(json) {
    return $e1410736f4a7598f$export$a78bc3657beb726a(json, false);
}
function $e1410736f4a7598f$export$a78bc3657beb726a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "identifier": json["identifier"],
        "password": json["password"]
    };
}
function $e1410736f4a7598f$export$303b9f6375543435(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "identifier": value.identifier,
        "password": value.password
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $2621dc1dfc6b4959$export$966c6b48709962b0 = {
    ClientToSign: "client_to_sign",
    WithClient: "with_client",
    AdminToSign: "admin_to_sign",
    AwaitingUpload: "awaiting_upload",
    Approved: "approved"
};
function $2621dc1dfc6b4959$export$37fc7c1f7de59ede(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "societyForm" in value;
    return isInstance;
}
function $2621dc1dfc6b4959$export$fda0802f448f87cd(json) {
    return $2621dc1dfc6b4959$export$467b1d29eaf285ce(json, false);
}
function $2621dc1dfc6b4959$export$467b1d29eaf285ce(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "complete": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "complete") ? undefined : json["complete"],
        "dateCompleted": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsSessionId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"],
        "pandadocsDocumentId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsDocumentS3Key": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pandadocs_document_s3_key") ? undefined : json["pandadocs_document_s3_key"],
        "status": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "user": json["user"],
        "societyForm": json["society_form"]
    };
}
function $2621dc1dfc6b4959$export$38e6d1d831d066f2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "complete": value.complete,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_session_id": value.pandadocsSessionId,
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_document_s3_key": value.pandadocsDocumentS3Key,
        "status": value.status,
        "user": value.user,
        "society_form": value.societyForm
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $d55250e4ec146a07$export$2b391cbfad052244(value) {
    let isInstance = true;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $d55250e4ec146a07$export$cc5cf1ab6820dc7(json) {
    return $d55250e4ec146a07$export$384d078584bd1dc5(json, false);
}
function $d55250e4ec146a07$export$384d078584bd1dc5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "readableName": json["readable_name"],
        "country": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "forms": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "forms") ? undefined : json["forms"]
    };
}
function $d55250e4ec146a07$export$f74e681c122ff42e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "readable_name": value.readableName,
        "country": value.country
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $a6c2c57f3ec02d76$export$712e9d999f4633f8(value) {
    let isInstance = true;
    isInstance = isInstance && "onboardingProgress" in value;
    return isInstance;
}
function $a6c2c57f3ec02d76$export$549ee7ec67643d0(json) {
    return $a6c2c57f3ec02d76$export$87508bba39114cdc(json, false);
}
function $a6c2c57f3ec02d76$export$87508bba39114cdc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "onboardingProgress": json["onboarding_progress"]
    };
}
function $a6c2c57f3ec02d76$export$4dc156adcc122a44(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "onboarding_progress": value.onboardingProgress
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $ff1aa3b5d438f12c$export$851c652f47cfe86(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "order" in value;
    return isInstance;
}
function $ff1aa3b5d438f12c$export$453236c830f87979(json) {
    return $ff1aa3b5d438f12c$export$65242b85d5de4eac(json, false);
}
function $ff1aa3b5d438f12c$export$65242b85d5de4eac(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "order": json["order"],
        "information": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "information") ? undefined : json["information"],
        "stepCompleted": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "step_completed") ? undefined : json["step_completed"]
    };
}
function $ff1aa3b5d438f12c$export$6c97f1e4626b54ea(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "order": value.order,
        "information": value.information,
        "step_completed": value.stepCompleted
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $b7638c7b0afddcbf$export$8e8babafda2d958a(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "order" in value;
    return isInstance;
}
function $b7638c7b0afddcbf$export$9a0347ad5bde5e2a(json) {
    return $b7638c7b0afddcbf$export$ff056f4e81644515(json, false);
}
function $b7638c7b0afddcbf$export$ff056f4e81644515(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "order": json["order"],
        "information": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "information") ? undefined : json["information"],
        "stepCompleted": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "step_completed") ? undefined : json["step_completed"]
    };
}
function $b7638c7b0afddcbf$export$8bdf5cc42c4cfee9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "order": value.order,
        "information": value.information,
        "step_completed": value.stepCompleted
    };
}


function $2af9f60a7332cb2c$export$4d73f7aa40dafe87(value) {
    let isInstance = true;
    isInstance = isInstance && "nextStepInformation" in value;
    isInstance = isInstance && "onboardingSteps" in value;
    return isInstance;
}
function $2af9f60a7332cb2c$export$addf7c24f7592504(json) {
    return $2af9f60a7332cb2c$export$9eb3576fd502a6b6(json, false);
}
function $2af9f60a7332cb2c$export$9eb3576fd502a6b6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "nextStepInformation": json["next_step_information"],
        "onboardingSteps": json["onboarding_steps"].map((0, $b7638c7b0afddcbf$export$9a0347ad5bde5e2a))
    };
}
function $2af9f60a7332cb2c$export$1446cb19e77b3b7b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "next_step_information": value.nextStepInformation,
        "onboarding_steps": value.onboardingSteps.map((0, $b7638c7b0afddcbf$export$8bdf5cc42c4cfee9))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $ee8fb9810e0ec00b$export$a09d57aff525c47d(value) {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $ee8fb9810e0ec00b$export$862cf7f4fa6a9624(json) {
    return $ee8fb9810e0ec00b$export$afd6b03f52e963b(json, false);
}
function $ee8fb9810e0ec00b$export$afd6b03f52e963b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "s3Url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "s3_url") ? undefined : json["s3_url"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "s3Key": json["s3_key"],
        "ready": json["ready"],
        "user": json["user"],
        "task": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "task") ? undefined : json["task"]
    };
}
function $ee8fb9810e0ec00b$export$7d0e05573e8ac3d8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "s3_key": value.s3Key,
        "ready": value.ready,
        "user": value.user,
        "task": value.task
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $878c8e823ee915e0$export$a6b417901e3e399b(value) {
    let isInstance = true;
    isInstance = isInstance && "documentId" in value;
    isInstance = isInstance && "documentPandadocUuid" in value;
    isInstance = isInstance && "documentName" in value;
    isInstance = isInstance && "sessionId" in value;
    isInstance = isInstance && "pandadocDocumentId" in value;
    return isInstance;
}
function $878c8e823ee915e0$export$3284951041cc42ee(json) {
    return $878c8e823ee915e0$export$244987b5de33cf8e(json, false);
}
function $878c8e823ee915e0$export$244987b5de33cf8e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentId": json["document_id"],
        "documentPandadocUuid": json["document_pandadoc_uuid"],
        "documentName": json["document_name"],
        "sessionId": json["session_id"],
        "pandadocDocumentId": json["pandadoc_document_id"]
    };
}
function $878c8e823ee915e0$export$c783a4eceaa4d2ee(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_id": value.documentId,
        "document_pandadoc_uuid": value.documentPandadocUuid,
        "document_name": value.documentName,
        "session_id": value.sessionId,
        "pandadoc_document_id": value.pandadocDocumentId
    };
}


function $9df401a83948158b$export$6d07ae274edc1eeb(value) {
    let isInstance = true;
    return isInstance;
}
function $9df401a83948158b$export$4950862b30fc1953(json) {
    return $9df401a83948158b$export$b096a718799a3fab(json, false);
}
function $9df401a83948158b$export$b096a718799a3fab(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documents": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "documents") ? undefined : json["documents"].map((0, $878c8e823ee915e0$export$3284951041cc42ee)),
        "email": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "userId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_id") ? undefined : json["user_id"],
        "societyFormSubroleId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "society_form_subrole_id") ? undefined : json["society_form_subrole_id"],
        "adminSocietyFormTaskId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "admin_society_form_task_id") ? undefined : json["admin_society_form_task_id"]
    };
}
function $9df401a83948158b$export$8652488ad92b6771(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "documents": value.documents === undefined ? undefined : value.documents.map((0, $878c8e823ee915e0$export$c783a4eceaa4d2ee)),
        "email": value.email,
        "user_id": value.userId,
        "society_form_subrole_id": value.societyFormSubroleId,
        "admin_society_form_task_id": value.adminSocietyFormTaskId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $1d87f336a8964c72$export$8dececa65671bade(value) {
    let isInstance = true;
    isInstance = isInstance && "pandadocsData" in value;
    return isInstance;
}
function $1d87f336a8964c72$export$3e714e27ace81dea(json) {
    return $1d87f336a8964c72$export$a6c733fe79e50515(json, false);
}
function $1d87f336a8964c72$export$a6c733fe79e50515(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "pandadocsData": json["pandadocs_data"]
    };
}
function $1d87f336a8964c72$export$5948fce865b68a3a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "pandadocs_data": value.pandadocsData
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $c26629801de68163$export$6faee095f907ed38 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $c26629801de68163$export$2d943482c8106434(value) {
    let isInstance = true;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amountPaidToClient" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "percentagePayable" in value;
    isInstance = isInstance && "dateCreated" in value;
    return isInstance;
}
function $c26629801de68163$export$ede75277ced03c5d(json) {
    return $c26629801de68163$export$b882712ed6ae0d44(json, false);
}
function $c26629801de68163$export$b882712ed6ae0d44(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "paymentDate": new Date(json["payment_date"]),
        "amountPaidToClient": json["amount_paid_to_client"],
        "totalAmountReceived": json["total_amount_received"],
        "status": json["status"],
        "percentagePayable": json["percentage_payable"],
        "fromSociety": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "from_society") ? undefined : json["from_society"],
        "dateCreated": new Date(json["date_created"])
    };
}
function $c26629801de68163$export$14ea7dd57087ac5f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "payment_date": value.paymentDate.toISOString(),
        "amount_paid_to_client": value.amountPaidToClient,
        "total_amount_received": value.totalAmountReceived,
        "status": value.status,
        "percentage_payable": value.percentagePayable,
        "date_created": value.dateCreated.toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $5c14bc5ef067994d$export$92cc256ea35a934b(value) {
    let isInstance = true;
    isInstance = isInstance && "file" in value;
    isInstance = isInstance && "society" in value;
    return isInstance;
}
function $5c14bc5ef067994d$export$78d23a4a7ca69183(json) {
    return $5c14bc5ef067994d$export$441fd7bca1ea85b9(json, false);
}
function $5c14bc5ef067994d$export$441fd7bca1ea85b9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "file": json["file"],
        "society": json["society"]
    };
}
function $5c14bc5ef067994d$export$85c3d9c455b4213a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "file": value.file,
        "society": value.society
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $1679a16c8817a30c$export$9c540be0071d4785(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
function $1679a16c8817a30c$export$973aefbf5296d294(json) {
    return $1679a16c8817a30c$export$5898f237fe5def0c(json, false);
}
function $1679a16c8817a30c$export$5898f237fe5def0c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"]
    };
}
function $1679a16c8817a30c$export$6a4d7222a2308ed8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $3c5b6c0152ce9443$export$6142206dc5ee21d4(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    isInstance = isInstance && "isCover" in value;
    isInstance = isInstance && "isPreferred" in value;
    return isInstance;
}
function $3c5b6c0152ce9443$export$1911aad9801dc9a4(json) {
    return $3c5b6c0152ce9443$export$1b56450a7f8c372f(json, false);
}
function $3c5b6c0152ce9443$export$1b56450a7f8c372f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["objectKey"],
        "isCover": json["isCover"],
        "isPreferred": json["isPreferred"]
    };
}
function $3c5b6c0152ce9443$export$8e7ba2d048a6c566(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "objectKey": value.objectKey,
        "isCover": value.isCover,
        "isPreferred": value.isPreferred
    };
}


function $211a7610b1c9c735$export$bedcb94db2108c60(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sourceReleaseId" in value;
    isInstance = isInstance && "releaseTitle" in value;
    return isInstance;
}
function $211a7610b1c9c735$export$34d46539b73b3b6b(json) {
    return $211a7610b1c9c735$export$b2c207ec186bfa3f(json, false);
}
function $211a7610b1c9c735$export$b2c207ec186bfa3f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "sourceReleaseId": json["sourceReleaseId"],
        "dateReleased": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : json["dateReleased"],
        "releaseTitle": json["releaseTitle"],
        "releaseArtists": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "releaseArtists") ? undefined : json["releaseArtists"],
        "mediaType": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : json["mediaType"],
        "format": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"],
        "catNumbers": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : json["catNumbers"],
        "releaseLabels": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : json["releaseLabels"],
        "ean": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ean") ? undefined : json["ean"],
        "upc": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "upc") ? undefined : json["upc"],
        "evidenceImages": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "evidenceImages") ? undefined : json["evidenceImages"] === null ? null : json["evidenceImages"].map((0, $3c5b6c0152ce9443$export$1911aad9801dc9a4))
    };
}
function $211a7610b1c9c735$export$5fcfb3f7a7855be(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "sourceReleaseId": value.sourceReleaseId,
        "dateReleased": value.dateReleased,
        "releaseTitle": value.releaseTitle,
        "releaseArtists": value.releaseArtists,
        "mediaType": value.mediaType,
        "format": value.format,
        "catNumbers": value.catNumbers,
        "releaseLabels": value.releaseLabels,
        "ean": value.ean,
        "upc": value.upc,
        "evidenceImages": value.evidenceImages === undefined ? undefined : value.evidenceImages === null ? null : value.evidenceImages.map((0, $3c5b6c0152ce9443$export$8e7ba2d048a6c566))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $36e9693200c5ce6a$export$c1bd3a61bdde03a6(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sourceReleaseId" in value;
    isInstance = isInstance && "evidenceImages" in value;
    return isInstance;
}
function $36e9693200c5ce6a$export$fb2e8cdf81242647(json) {
    return $36e9693200c5ce6a$export$600eca293bbf7818(json, false);
}
function $36e9693200c5ce6a$export$600eca293bbf7818(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "sourceReleaseId": json["sourceReleaseId"],
        "evidenceImages": json["evidenceImages"].map((0, $3c5b6c0152ce9443$export$1911aad9801dc9a4))
    };
}
function $36e9693200c5ce6a$export$cd59ab9a4ca345c9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "sourceReleaseId": value.sourceReleaseId,
        "evidenceImages": value.evidenceImages.map((0, $3c5b6c0152ce9443$export$8e7ba2d048a6c566))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $cd36504e875a46b2$export$5df361f9a7e46bf2(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "recordingTitle" in value;
    isInstance = isInstance && "live" in value;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
function $cd36504e875a46b2$export$a1bea63454d8d4ef(json) {
    return $cd36504e875a46b2$export$9448be4442ef20df(json, false);
}
function $cd36504e875a46b2$export$9448be4442ef20df(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "recordingTitle": json["recordingTitle"],
        "duration": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "duration") ? undefined : json["duration"],
        "bandArtistName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bandArtistName") ? undefined : json["bandArtistName"],
        "mainArtists": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "mainArtists") ? undefined : json["mainArtists"],
        "isrcs": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "isrcs") ? undefined : json["isrcs"],
        "live": json["live"],
        "countryOfRecording": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "countryOfRecording") ? undefined : json["countryOfRecording"],
        "source": json["source"]
    };
}
function $cd36504e875a46b2$export$91dfdcb8daf96447(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "recordingTitle": value.recordingTitle,
        "duration": value.duration,
        "bandArtistName": value.bandArtistName,
        "mainArtists": value.mainArtists,
        "isrcs": value.isrcs,
        "live": value.live,
        "countryOfRecording": value.countryOfRecording,
        "source": value.source
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $7bf0e1d9a3c85872$export$145dad09b9d090a7(value) {
    let isInstance = true;
    return isInstance;
}
function $7bf0e1d9a3c85872$export$87a5d3c0b5b446fa(json) {
    return $7bf0e1d9a3c85872$export$454b785feb38dee9(json, false);
}
function $7bf0e1d9a3c85872$export$454b785feb38dee9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "featuredStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"]
    };
}
function $7bf0e1d9a3c85872$export$90f185072ae6727a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "featuredStatus": value.featuredStatus
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e977ed69f16a2d08$export$615d49806d2f4658(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $e977ed69f16a2d08$export$1d0f206a51e5319b(json) {
    return $e977ed69f16a2d08$export$4aa488a2a722dc68(json, false);
}
function $e977ed69f16a2d08$export$4aa488a2a722dc68(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"]
    };
}
function $e977ed69f16a2d08$export$3f3125a18e66022f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $374d0977eb14dc69$export$b2dc914a227951c = {
    SubmittedToSociety: "SUBMITTED_TO_SOCIETY",
    EvidenceNeeded: "EVIDENCE_NEEDED",
    RegisteredWithSociety: "REGISTERED_WITH_SOCIETY",
    ToBeRegistered: "TO_BE_REGISTERED",
    Other: "OTHER"
};
function $374d0977eb14dc69$export$b5e1de6b34752e48(value) {
    let isInstance = true;
    isInstance = isInstance && "contribution" in value;
    isInstance = isInstance && "westburyContribution" in value;
    return isInstance;
}
function $374d0977eb14dc69$export$8ac2c111ddc0c214(json) {
    return $374d0977eb14dc69$export$4185708b39650b8e(json, false);
}
function $374d0977eb14dc69$export$4185708b39650b8e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "claimStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "claimStatus") ? undefined : json["claimStatus"],
        "claimSubstatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "claimSubstatus") ? undefined : json["claimSubstatus"],
        "claimCaseNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "claimCaseNumber") ? undefined : json["claimCaseNumber"],
        "westburyStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "westburyStatus") ? undefined : json["westburyStatus"],
        "contribution": json["contribution"],
        "westburyContribution": json["westburyContribution"]
    };
}
function $374d0977eb14dc69$export$a159991ef9577e8b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "claimStatus": value.claimStatus,
        "claimSubstatus": value.claimSubstatus,
        "claimCaseNumber": value.claimCaseNumber,
        "westburyStatus": value.westburyStatus,
        "contribution": value.contribution,
        "westburyContribution": value.westburyContribution
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $0b6994a93b054682$export$17170f7064f93b56(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    isInstance = isInstance && "isCover" in value;
    isInstance = isInstance && "isPreferred" in value;
    return isInstance;
}
function $0b6994a93b054682$export$199bc9cc26ea424b(json) {
    return $0b6994a93b054682$export$eb306bf8a3970269(json, false);
}
function $0b6994a93b054682$export$eb306bf8a3970269(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["objectKey"],
        "isCover": json["isCover"],
        "isPreferred": json["isPreferred"]
    };
}
function $0b6994a93b054682$export$d155b6d518bc7cf4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "objectKey": value.objectKey,
        "isCover": value.isCover,
        "isPreferred": value.isPreferred
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $4e1575172afce1ed$export$50320fec2254c4ec(value) {
    let isInstance = true;
    isInstance = isInstance && "contribution" in value;
    return isInstance;
}
function $4e1575172afce1ed$export$6727272db99bd9fb(json) {
    return $4e1575172afce1ed$export$9b53e32460c50cff(json, false);
}
function $4e1575172afce1ed$export$9b53e32460c50cff(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "contribution": json["contribution"],
        "isRecordingContribution": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "isRecordingContribution") ? undefined : json["isRecordingContribution"]
    };
}
function $4e1575172afce1ed$export$adfe0bd7c15fd471(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "contribution": value.contribution,
        "isRecordingContribution": value.isRecordingContribution
    };
}


function $b8f2bbcd4cacce64$export$c441177252ae81f(value) {
    let isInstance = true;
    isInstance = isInstance && "parentRecording" in value;
    isInstance = isInstance && "westburyContributions" in value;
    isInstance = isInstance && "persona" in value;
    isInstance = isInstance && "performance" in value;
    return isInstance;
}
function $b8f2bbcd4cacce64$export$6b7b0d019ed2729b(json) {
    return $b8f2bbcd4cacce64$export$73edd13b0a8f31a(json, false);
}
function $b8f2bbcd4cacce64$export$73edd13b0a8f31a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "parentRecording": (0, $cd36504e875a46b2$export$a1bea63454d8d4ef)(json["parentRecording"]),
        "westburyContributions": json["westburyContributions"].map((0, $4e1575172afce1ed$export$6727272db99bd9fb)),
        "pplContributions": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pplContributions") ? undefined : json["pplContributions"] === null ? null : json["pplContributions"].map((0, $374d0977eb14dc69$export$8ac2c111ddc0c214)),
        "persona": (0, $e977ed69f16a2d08$export$1d0f206a51e5319b)(json["persona"]),
        "person": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "person") ? undefined : json["person"],
        "performance": (0, $7bf0e1d9a3c85872$export$87a5d3c0b5b446fa)(json["performance"]),
        "earliestParentRelease": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "earliestParentRelease") ? undefined : (0, $211a7610b1c9c735$export$34d46539b73b3b6b)(json["earliestParentRelease"]),
        "evidenceReleases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "evidenceReleases") ? undefined : json["evidenceReleases"] === null ? null : json["evidenceReleases"].map((0, $36e9693200c5ce6a$export$fb2e8cdf81242647)),
        "thumbnailEvidenceImage": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "thumbnailEvidenceImage") ? undefined : (0, $0b6994a93b054682$export$199bc9cc26ea424b)(json["thumbnailEvidenceImage"])
    };
}
function $b8f2bbcd4cacce64$export$ce4667857929d9d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "parentRecording": (0, $cd36504e875a46b2$export$91dfdcb8daf96447)(value.parentRecording),
        "westburyContributions": value.westburyContributions.map((0, $4e1575172afce1ed$export$adfe0bd7c15fd471)),
        "pplContributions": value.pplContributions === undefined ? undefined : value.pplContributions === null ? null : value.pplContributions.map((0, $374d0977eb14dc69$export$a159991ef9577e8b)),
        "persona": (0, $e977ed69f16a2d08$export$3f3125a18e66022f)(value.persona),
        "performance": (0, $7bf0e1d9a3c85872$export$90f185072ae6727a)(value.performance),
        "earliestParentRelease": (0, $211a7610b1c9c735$export$5fcfb3f7a7855be)(value.earliestParentRelease),
        "evidenceReleases": value.evidenceReleases === undefined ? undefined : value.evidenceReleases === null ? null : value.evidenceReleases.map((0, $36e9693200c5ce6a$export$cd59ab9a4ca345c9)),
        "thumbnailEvidenceImage": (0, $0b6994a93b054682$export$d155b6d518bc7cf4)(value.thumbnailEvidenceImage)
    };
}


function $a8b275b6da33cfa6$export$62aa05d26c318fb2(value) {
    let isInstance = true;
    isInstance = isInstance && "recordings" in value;
    isInstance = isInstance && "sortArray" in value;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
function $a8b275b6da33cfa6$export$c7fe272dbd4732e2(json) {
    return $a8b275b6da33cfa6$export$13ff6572c29f002d(json, false);
}
function $a8b275b6da33cfa6$export$13ff6572c29f002d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordings": json["recordings"].map((0, $b8f2bbcd4cacce64$export$6b7b0d019ed2729b)),
        "sortArray": json["sort_array"],
        "count": json["count"]
    };
}
function $a8b275b6da33cfa6$export$62ddbb802bafd084(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordings": value.recordings.map((0, $b8f2bbcd4cacce64$export$ce4667857929d9d7)),
        "sort_array": value.sortArray,
        "count": value.count
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $5b70e4b48b84fc3d$export$b3d047d2e54775d0(value) {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $5b70e4b48b84fc3d$export$9064002f671ddae3(json) {
    return $5b70e4b48b84fc3d$export$aaee631da266a742(json, false);
}
function $5b70e4b48b84fc3d$export$aaee631da266a742(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "s3Url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "s3_url") ? undefined : json["s3_url"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "s3Key": json["s3_key"],
        "ready": json["ready"],
        "user": json["user"],
        "task": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "task") ? undefined : json["task"]
    };
}
function $5b70e4b48b84fc3d$export$eef7c6e6fd70b6cf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "s3_key": value.s3Key,
        "ready": value.ready,
        "user": value.user,
        "task": value.task
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $1e99d55f76cfd225$export$49ea64c85c445d82 = {
    ParentRecordingMainArtists: "parentRecording.mainArtists",
    ParentRecordingRecordingTitle: "parentRecording.recordingTitle",
    EarliestParentReleaseReleaseTitle: "earliestParentRelease.releaseTitle",
    EarliestParentReleaseDateReleased: "earliestParentRelease.dateReleased",
    EarliestParentReleaseMediaType: "earliestParentRelease.mediaType",
    EarliestParentReleaseFormat: "earliestParentRelease.format",
    PersonaStageName: "persona.stageName"
};
const $1e99d55f76cfd225$export$cef15f35c6196202 = {
    Asc: "asc",
    Desc: "desc"
};
function $1e99d55f76cfd225$export$25b2993cbc528732(value) {
    let isInstance = true;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "sortField" in value;
    isInstance = isInstance && "sortOrder" in value;
    return isInstance;
}
function $1e99d55f76cfd225$export$595199061a8de88d(json) {
    return $1e99d55f76cfd225$export$308cd19a24025365(json, false);
}
function $1e99d55f76cfd225$export$308cd19a24025365(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "size": json["size"],
        "sortField": json["sort_field"],
        "sortOrder": json["sort_order"],
        "searchAfter": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "search_after") ? undefined : json["search_after"]
    };
}
function $1e99d55f76cfd225$export$f75ce5365b9c0f3d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "size": value.size,
        "sort_field": value.sortField,
        "sort_order": value.sortOrder,
        "search_after": value.searchAfter
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 








function $a84dd22ffa1b8721$export$248e33fcbf658e43(value) {
    let isInstance = true;
    isInstance = isInstance && "parentRecording" in value;
    isInstance = isInstance && "westburyContributions" in value;
    isInstance = isInstance && "persona" in value;
    isInstance = isInstance && "performance" in value;
    return isInstance;
}
function $a84dd22ffa1b8721$export$ada4d9eb25dcb112(json) {
    return $a84dd22ffa1b8721$export$f7b5d398ee1d534f(json, false);
}
function $a84dd22ffa1b8721$export$f7b5d398ee1d534f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "parentRecording": (0, $cd36504e875a46b2$export$a1bea63454d8d4ef)(json["parentRecording"]),
        "westburyContributions": json["westburyContributions"].map((0, $4e1575172afce1ed$export$6727272db99bd9fb)),
        "pplContributions": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pplContributions") ? undefined : json["pplContributions"] === null ? null : json["pplContributions"].map((0, $374d0977eb14dc69$export$8ac2c111ddc0c214)),
        "persona": (0, $e977ed69f16a2d08$export$1d0f206a51e5319b)(json["persona"]),
        "person": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "person") ? undefined : json["person"],
        "performance": (0, $7bf0e1d9a3c85872$export$87a5d3c0b5b446fa)(json["performance"]),
        "earliestParentRelease": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "earliestParentRelease") ? undefined : (0, $211a7610b1c9c735$export$34d46539b73b3b6b)(json["earliestParentRelease"]),
        "evidenceReleases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "evidenceReleases") ? undefined : json["evidenceReleases"] === null ? null : json["evidenceReleases"].map((0, $36e9693200c5ce6a$export$fb2e8cdf81242647)),
        "thumbnailEvidenceImage": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "thumbnailEvidenceImage") ? undefined : (0, $0b6994a93b054682$export$199bc9cc26ea424b)(json["thumbnailEvidenceImage"])
    };
}
function $a84dd22ffa1b8721$export$1c1d7226b8761de1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "parentRecording": (0, $cd36504e875a46b2$export$91dfdcb8daf96447)(value.parentRecording),
        "westburyContributions": value.westburyContributions.map((0, $4e1575172afce1ed$export$adfe0bd7c15fd471)),
        "pplContributions": value.pplContributions === undefined ? undefined : value.pplContributions === null ? null : value.pplContributions.map((0, $374d0977eb14dc69$export$a159991ef9577e8b)),
        "persona": (0, $e977ed69f16a2d08$export$3f3125a18e66022f)(value.persona),
        "performance": (0, $7bf0e1d9a3c85872$export$90f185072ae6727a)(value.performance),
        "earliestParentRelease": (0, $211a7610b1c9c735$export$5fcfb3f7a7855be)(value.earliestParentRelease),
        "evidenceReleases": value.evidenceReleases === undefined ? undefined : value.evidenceReleases === null ? null : value.evidenceReleases.map((0, $36e9693200c5ce6a$export$cd59ab9a4ca345c9)),
        "thumbnailEvidenceImage": (0, $0b6994a93b054682$export$d155b6d518bc7cf4)(value.thumbnailEvidenceImage)
    };
}











/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $e05d2d122bcb721a$export$ac035f67eb615957 = {
    Manager: "Manager",
    Accountant: "Accountant",
    Lawyer: "Lawyer",
    Representative: "Representative",
    Company: "Company"
};
function $e05d2d122bcb721a$export$af3ec760d5c309b2(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $e05d2d122bcb721a$export$8e0354464941eec8(json) {
    return $e05d2d122bcb721a$export$1a4b3155ae06660d(json, false);
}
function $e05d2d122bcb721a$export$1a4b3155ae06660d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": json["name"],
        "role": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "email": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"]
    };
}
function $e05d2d122bcb721a$export$4b283602380be6d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name,
        "role": value.role,
        "email": value.email,
        "phone_number": value.phoneNumber
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $0d9420c38717583a$export$3b5798f51f9c7c57(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $0d9420c38717583a$export$1cee1562e0d40484(json) {
    return $0d9420c38717583a$export$73ba85c8a65d5a09(json, false);
}
function $0d9420c38717583a$export$73ba85c8a65d5a09(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"],
        "access": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "access") ? undefined : json["access"]
    };
}
function $0d9420c38717583a$export$2744b1fd1031a21(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


function $9d9e30e8290afd15$export$c48671821948626(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "groups" in value;
    return isInstance;
}
function $9d9e30e8290afd15$export$c63fd8bf0afb13bd(json) {
    return $9d9e30e8290afd15$export$519a1b84938ba377(json, false);
}
function $9d9e30e8290afd15$export$519a1b84938ba377(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": (0, $0d9420c38717583a$export$1cee1562e0d40484)(json["token"]),
        "userId": json["user_id"],
        "email": json["email"],
        "groups": json["groups"]
    };
}
function $9d9e30e8290afd15$export$4df6be20382d0609(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": (0, $0d9420c38717583a$export$2744b1fd1031a21)(value.token),
        "user_id": value.userId,
        "email": value.email,
        "groups": value.groups
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $04c1ef758204bfa0$export$cf0ecddd0fe5c1c3(value) {
    let isInstance = true;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "passwordConfirm" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "hash" in value;
    return isInstance;
}
function $04c1ef758204bfa0$export$8c6139077c2f8511(json) {
    return $04c1ef758204bfa0$export$8b9dce09bf39bd4(json, false);
}
function $04c1ef758204bfa0$export$8b9dce09bf39bd4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": json["password"],
        "passwordConfirm": json["password_confirm"],
        "email": json["email"],
        "hash": json["hash"]
    };
}
function $04c1ef758204bfa0$export$eca3401b04c34cf9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password,
        "password_confirm": value.passwordConfirm,
        "email": value.email,
        "hash": value.hash
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $88ed4b3cd76df043$export$12b161aef0b5ecb5(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "groups" in value;
    return isInstance;
}
function $88ed4b3cd76df043$export$f36f5aa70c133e5(json) {
    return $88ed4b3cd76df043$export$afea3a8d814adcbc(json, false);
}
function $88ed4b3cd76df043$export$afea3a8d814adcbc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": (0, $0d9420c38717583a$export$1cee1562e0d40484)(json["token"]),
        "userId": json["user_id"],
        "email": json["email"],
        "groups": json["groups"]
    };
}
function $88ed4b3cd76df043$export$9771d49f32ac0d74(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": (0, $0d9420c38717583a$export$2744b1fd1031a21)(value.token),
        "user_id": value.userId,
        "email": value.email,
        "groups": value.groups
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $6bd19fa7247378e0$export$bd0a353ae3e38847(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $6bd19fa7247378e0$export$edd4637996f4c27e(json) {
    return $6bd19fa7247378e0$export$60a455454cb5f9df(json, false);
}
function $6bd19fa7247378e0$export$60a455454cb5f9df(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "fieldsList": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "fields_list") ? undefined : json["fields_list"],
        "prepopulatedData": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "prepopulated_data") ? undefined : json["prepopulated_data"]
    };
}
function $6bd19fa7247378e0$export$465cc44318f90c19(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "fields_list": value.fieldsList
    };
}


const $35cacab6a3e1ec67$export$e9c99534c92dd775 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $35cacab6a3e1ec67$export$2f92200ee75a8aa1 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
function $35cacab6a3e1ec67$export$34e336db3101ecaa(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "societyForms" in value;
    return isInstance;
}
function $35cacab6a3e1ec67$export$4ce4e8492a820cd5(json) {
    return $35cacab6a3e1ec67$export$95c1b09bff6b823e(json, false);
}
function $35cacab6a3e1ec67$export$95c1b09bff6b823e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "country": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "website": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "website") ? undefined : json["website"],
        "portal": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "portal") ? undefined : json["portal"],
        "phone": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "address": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "address") ? undefined : json["address"],
        "additionalTerritories": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "additional_territories") ? undefined : json["additional_territories"],
        "societyForms": json["society_forms"].map((0, $6bd19fa7247378e0$export$edd4637996f4c27e)),
        "formEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_email") ? undefined : json["form_email"],
        "formPostalAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_postal_address") ? undefined : json["form_postal_address"],
        "formPortal": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_portal") ? undefined : json["form_portal"],
        "formReminderFrequency": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_reminder_frequency") ? undefined : json["form_reminder_frequency"],
        "formStopReminderFrequency": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_stop_reminder_frequency") ? undefined : json["form_stop_reminder_frequency"],
        "formReminderSendTo": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_reminder_send_to") ? undefined : json["form_reminder_send_to"]
    };
}
function $35cacab6a3e1ec67$export$8f504a6ae2db7503(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "country": value.country,
        "website": value.website,
        "portal": value.portal,
        "phone": value.phone,
        "address": value.address,
        "additional_territories": value.additionalTerritories,
        "society_forms": value.societyForms.map((0, $6bd19fa7247378e0$export$465cc44318f90c19)),
        "form_email": value.formEmail,
        "form_postal_address": value.formPostalAddress,
        "form_portal": value.formPortal,
        "form_reminder_frequency": value.formReminderFrequency,
        "form_stop_reminder_frequency": value.formStopReminderFrequency,
        "form_reminder_send_to": value.formReminderSendTo
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f8c051d75a3a84b4$export$ec3e8484dcd018a9(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $f8c051d75a3a84b4$export$46847c4110a69b3c(json) {
    return $f8c051d75a3a84b4$export$b46ebf2f562f8f7c(json, false);
}
function $f8c051d75a3a84b4$export$b46ebf2f562f8f7c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "fieldsList": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "fields_list") ? undefined : json["fields_list"],
        "prepopulatedData": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "prepopulated_data") ? undefined : json["prepopulated_data"]
    };
}
function $f8c051d75a3a84b4$export$7163e8e46126598f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "fields_list": value.fieldsList
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $f3788f246dd38714$export$21e680d35b1135f6 = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
const $f3788f246dd38714$export$878104e7c717f4d3 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $f3788f246dd38714$export$33a1dc0a429d7dc1(value) {
    let isInstance = true;
    isInstance = isInstance && "clientName" in value;
    isInstance = isInstance && "commission" in value;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "remittanceMethod" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "totalPayable" in value;
    return isInstance;
}
function $f3788f246dd38714$export$faa43dfc7cc59cc0(json) {
    return $f3788f246dd38714$export$881b612e3fa51a91(json, false);
}
function $f3788f246dd38714$export$881b612e3fa51a91(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "clientName": json["client_name"],
        "commission": json["commission"],
        "paymentDate": json["payment_date"],
        "remittanceMethod": json["remittance_method"],
        "status": json["status"],
        "totalAmountReceived": json["total_amount_received"],
        "totalPayable": json["total_payable"]
    };
}
function $f3788f246dd38714$export$3560166a675d0203(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "client_name": value.clientName,
        "commission": value.commission,
        "payment_date": value.paymentDate,
        "remittance_method": value.remittanceMethod,
        "status": value.status,
        "total_amount_received": value.totalAmountReceived,
        "total_payable": value.totalPayable
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $ecdd174ec0f293ad$export$70717bdda59910f1 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $ecdd174ec0f293ad$export$e22f73c146466db0(value) {
    let isInstance = true;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amountPaidToClient" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "comission" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "dateCreated" in value;
    return isInstance;
}
function $ecdd174ec0f293ad$export$eaae7f36aa679238(json) {
    return $ecdd174ec0f293ad$export$328a43810608839(json, false);
}
function $ecdd174ec0f293ad$export$328a43810608839(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "paymentDate": new Date(json["payment_date"]),
        "amountPaidToClient": json["amount_paid_to_client"],
        "totalAmountReceived": json["total_amount_received"],
        "comission": json["comission"],
        "status": json["status"],
        "fromSociety": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "from_society") ? undefined : json["from_society"],
        "dateCreated": new Date(json["date_created"])
    };
}
function $ecdd174ec0f293ad$export$89244da8fad78f14(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "payment_date": value.paymentDate.toISOString(),
        "amount_paid_to_client": value.amountPaidToClient,
        "total_amount_received": value.totalAmountReceived,
        "comission": value.comission,
        "status": value.status,
        "date_created": value.dateCreated.toISOString()
    };
}


function $f2a79bc4061f640b$export$51032390887d36f9(value) {
    let isInstance = true;
    isInstance = isInstance && "metadata" in value;
    isInstance = isInstance && "payments" in value;
    return isInstance;
}
function $f2a79bc4061f640b$export$b7af3949b8b2f080(json) {
    return $f2a79bc4061f640b$export$80fd014de69f5f16(json, false);
}
function $f2a79bc4061f640b$export$80fd014de69f5f16(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "metadata": (0, $f3788f246dd38714$export$faa43dfc7cc59cc0)(json["metadata"]),
        "payments": json["payments"].map((0, $ecdd174ec0f293ad$export$eaae7f36aa679238))
    };
}
function $f2a79bc4061f640b$export$7dc0365fc5810aa1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "metadata": (0, $f3788f246dd38714$export$3560166a675d0203)(value.metadata),
        "payments": value.payments.map((0, $ecdd174ec0f293ad$export$89244da8fad78f14))
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $6baf408b46f72218$export$eade3e1f30f49357(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $6baf408b46f72218$export$b5cfec7638e86e16(json) {
    return $6baf408b46f72218$export$f24a65443b816594(json, false);
}
function $6baf408b46f72218$export$f24a65443b816594(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"]
    };
}
function $6baf408b46f72218$export$68354c35e74dadb8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $64e4ffcde8e740f1$export$517c6e0854a1425d(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $64e4ffcde8e740f1$export$a57843fa58a86c18(json) {
    return $64e4ffcde8e740f1$export$6d85bd90d9e45bc5(json, false);
}
function $64e4ffcde8e740f1$export$6d85bd90d9e45bc5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "username": json["username"],
        "password": json["password"]
    };
}
function $64e4ffcde8e740f1$export$dc065df2aa624562(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username,
        "password": value.password
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $6e6d7e23ca2ce77b$export$64edab5d36dd34cc(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $6e6d7e23ca2ce77b$export$874d3e01e6e7fdc8(json) {
    return $6e6d7e23ca2ce77b$export$fcd7ac86b1eab9d0(json, false);
}
function $6e6d7e23ca2ce77b$export$fcd7ac86b1eab9d0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"],
        "access": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "access") ? undefined : json["access"]
    };
}
function $6e6d7e23ca2ce77b$export$f77999a70380c6a3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $6a3c8ed1f4b02c8e$export$64ceed618d1d7c77(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    return isInstance;
}
function $6a3c8ed1f4b02c8e$export$dd924f4825888164(json) {
    return $6a3c8ed1f4b02c8e$export$c965e2ef0d36bdfa(json, false);
}
function $6a3c8ed1f4b02c8e$export$c965e2ef0d36bdfa(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": json["token"]
    };
}
function $6a3c8ed1f4b02c8e$export$62af2150040a6d3b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": value.token
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $3c58df248542b8a9$export$107108728cbff5c2 = {
    Pending: "pending",
    Approved: "approved",
    Active: "active",
    Rejected: "rejected",
    Inactive: "inactive"
};
const $3c58df248542b8a9$export$4aa87062bd17ed50 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $3c58df248542b8a9$export$fbf415167d268784 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
const $3c58df248542b8a9$export$1b6d3c296eec3f65 = {
    PerformerProducer: "Performer/Producer"
};
function $3c58df248542b8a9$export$f7bcf28a00f810b2(value) {
    let isInstance = true;
    return isInstance;
}
function $3c58df248542b8a9$export$2b0c2ace819fea88(json) {
    return $3c58df248542b8a9$export$f7385e99209fe25f(json, false);
}
function $3c58df248542b8a9$export$f7385e99209fe25f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "aliases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "userPhoto": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "verifiedStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "verified_status") ? undefined : json["verified_status"],
        "signedStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "signed_status") ? undefined : json["signed_status"],
        "accountStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "account_status") ? undefined : json["account_status"],
        "title": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "firstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "nonClient": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "non_client") ? undefined : json["non_client"],
        "dateOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "nationality": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "department": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "taxationCountry": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "witnessFirstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "role": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "registeredWithPpl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "registered_with_ppl") ? undefined : json["registered_with_ppl"],
        "pplAccountName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_account_name") ? undefined : json["ppl_account_name"],
        "pplPerformerName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "notes": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "clientEmailHashed": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "client_email_hashed") ? undefined : json["client_email_hashed"],
        "westburyId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"],
        "discogsIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "discogs_ids") ? undefined : json["discogs_ids"],
        "musicbrainzIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "musicbrainz_ids") ? undefined : json["musicbrainz_ids"],
        "deezerIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "deezer_ids") ? undefined : json["deezer_ids"],
        "spotifyIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "spotify_ids") ? undefined : json["spotify_ids"],
        "performerOrProducer": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "masterRights": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "masterFullname": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "masterEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "masterName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "completedOnboardingSteps": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "completed_onboarding_steps") ? undefined : json["completed_onboarding_steps"]
    };
}
function $3c58df248542b8a9$export$3e1a5b1b9db0a946(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aliases": value.aliases,
        "user_photo": value.userPhoto,
        "account_status": value.accountStatus,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "non_client": value.nonClient,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "nationality": value.nationality,
        "department": value.department,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "role": value.role,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_account_name": value.pplAccountName,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "notes": value.notes,
        "client_email_hashed": value.clientEmailHashed,
        "discogs_ids": value.discogsIds,
        "musicbrainz_ids": value.musicbrainzIds,
        "deezer_ids": value.deezerIds,
        "spotify_ids": value.spotifyIds,
        "performer_or_producer": value.performerOrProducer,
        "master_rights": value.masterRights,
        "master_fullname": value.masterFullname,
        "master_email": value.masterEmail,
        "master_name": value.masterName,
        "master_id": value.masterId
    };
}




class $d1b79341fc7471d8$export$3dfdf93d61a8d1c9 extends $cc3eb4e70d9f2fd9$export$70edad7ad5bb3f5d {
    /**
     * 
     */ async adminApproveMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.formId === null || requestParameters.formId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("formId", "Required parameter requestParameters.formId was null or undefined when calling adminApproveMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/tasks/forms/{form_id}/actions/admin-approve/`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2621dc1dfc6b4959$export$38e6d1d831d066f2)(requestParameters.membershipForms)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2621dc1dfc6b4959$export$fda0802f448f87cd)(jsonValue));
    }
    /**
     * 
     */ async adminApproveMembershipForms(requestParameters, initOverrides) {
        const response = await this.adminApproveMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async clientSignClientSocietyFormTaskRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling clientSignClientSocietyFormTask.");
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling clientSignClientSocietyFormTask.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks/{task_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $61c055886c74342c$export$1f4009bc54aefa3f)(requestParameters.clientSocietyFormTask)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $61c055886c74342c$export$7fa8d9ea09641068)(jsonValue));
    }
    /**
     * 
     */ async clientSignClientSocietyFormTask(requestParameters, initOverrides) {
        const response = await this.clientSignClientSocietyFormTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $db1972d7448b3ff8$export$a23c9ba4a9c33181)(requestParameters.additionalContactDetails)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $db1972d7448b3ff8$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async createAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.createAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createClientBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $730e2a0e920732f8$export$d5ce4e46fbd36d46)(requestParameters.clientBankDetails)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $730e2a0e920732f8$export$c6f5b638dc8b8079)(jsonValue));
    }
    /**
     * 
     */ async createClientBankDetails(requestParameters, initOverrides) {
        const response = await this.createClientBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createClientIdentityDocumentSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $cc3eb4e70d9f2fd9$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.dateCreated !== undefined) formParams.append("date_created", requestParameters.dateCreated);
        if (requestParameters.file !== undefined) formParams.append("file", requestParameters.file);
        if (requestParameters.filename !== undefined) formParams.append("filename", requestParameters.filename);
        if (requestParameters.status !== undefined) formParams.append("status", requestParameters.status);
        if (requestParameters.documentExpiryDate !== undefined) formParams.append("document_expiry_date", requestParameters.documentExpiryDate);
        if (requestParameters.documentType !== undefined) formParams.append("document_type", requestParameters.documentType);
        if (requestParameters.fileUrl !== undefined) formParams.append("file_url", requestParameters.fileUrl);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $74f3aef07a9ab9ca$export$54f4e92d07988b2b)(jsonValue));
    }
    /**
     * 
     */ async createClientIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.createClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create user and user settings based on expression of interest information. Create EOI review and discography ID submission admin tasks.
     */ async createClientInterestRegistrationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/interest-registrations/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $cbf2593677db3000$export$9922fca795d20c2b)(requestParameters.clientInterestRegistration)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $cbf2593677db3000$export$2a302f093ff9aad4)(jsonValue));
    }
    /**
     * Create user and user settings based on expression of interest information. Create EOI review and discography ID submission admin tasks.
     */ async createClientInterestRegistration(requestParameters = {}, initOverrides) {
        const response = await this.createClientInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createClientPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7db1c79fee8c8ab4$export$f60ddb500bd22238)(requestParameters.clientPersonalInformation)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7db1c79fee8c8ab4$export$1601295b33eeef78)(jsonValue));
    }
    /**
     * 
     */ async createClientPersonalInformation(requestParameters, initOverrides) {
        const response = await this.createClientPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientSessionCreatePandadocsSessionIdRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling createClientSessionCreatePandadocsSessionId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/{task_id}/session_id/`.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $8c77b84ae55316aa$export$fe1c3e8c7156433b)(requestParameters.createPandadocsSessionId)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $8c77b84ae55316aa$export$48c528d3391c2ee1)(jsonValue));
    }
    /**
     * 
     */ async createClientSessionCreatePandadocsSessionId(requestParameters, initOverrides) {
        const response = await this.createClientSessionCreatePandadocsSessionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createGeneratePPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createGeneratePPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response);
    }
    /**
     * 
     */ async createGeneratePPLReviewExport(requestParameters, initOverrides) {
        const response = await this.createGeneratePPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createGeneratePrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createGeneratePrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response);
    }
    /**
     * 
     */ async createGeneratePrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.createGeneratePrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createIdentityVerficationSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.passportFile === null || requestParameters.passportFile === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("passportFile", "Required parameter requestParameters.passportFile was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.registeredWithPpl === null || requestParameters.registeredWithPpl === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("registeredWithPpl", "Required parameter requestParameters.registeredWithPpl was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.streetAddress === null || requestParameters.streetAddress === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("streetAddress", "Required parameter requestParameters.streetAddress was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.postcode === null || requestParameters.postcode === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("postcode", "Required parameter requestParameters.postcode was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.county === null || requestParameters.county === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("county", "Required parameter requestParameters.county was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.country === null || requestParameters.country === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("country", "Required parameter requestParameters.country was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessFirstName === null || requestParameters.witnessFirstName === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("witnessFirstName", "Required parameter requestParameters.witnessFirstName was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessLastName === null || requestParameters.witnessLastName === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("witnessLastName", "Required parameter requestParameters.witnessLastName was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessEmail === null || requestParameters.witnessEmail === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("witnessEmail", "Required parameter requestParameters.witnessEmail was null or undefined when calling createIdentityVerficationSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $cc3eb4e70d9f2fd9$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.passportFile !== undefined) formParams.append("passport_file", requestParameters.passportFile);
        if (requestParameters.proofOfAddressFile !== undefined) formParams.append("proof_of_address_file", requestParameters.proofOfAddressFile);
        if (requestParameters.registeredWithPpl !== undefined) formParams.append("registered_with_ppl", requestParameters.registeredWithPpl);
        if (requestParameters.pplPerformerName !== undefined) formParams.append("ppl_performer_name", requestParameters.pplPerformerName);
        if (requestParameters.pplPerformerId !== undefined) formParams.append("ppl_performer_id", requestParameters.pplPerformerId);
        if (requestParameters.streetAddress !== undefined) formParams.append("street_address", requestParameters.streetAddress);
        if (requestParameters.postcode !== undefined) formParams.append("postcode", requestParameters.postcode);
        if (requestParameters.county !== undefined) formParams.append("county", requestParameters.county);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.witnessFirstName !== undefined) formParams.append("witness_first_name", requestParameters.witnessFirstName);
        if (requestParameters.witnessLastName !== undefined) formParams.append("witness_last_name", requestParameters.witnessLastName);
        if (requestParameters.witnessEmail !== undefined) formParams.append("witness_email", requestParameters.witnessEmail);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-verification-submissions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $b83cc17986a42e6e$export$1372d202ad798e18)(jsonValue));
    }
    /**
     * 
     */ async createIdentityVerficationSubmission(requestParameters, initOverrides) {
        const response = await this.createIdentityVerficationSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createPandadocDocumentIdsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/document_id/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $9df401a83948158b$export$8652488ad92b6771)(requestParameters.pandadocDocumentIds)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $9df401a83948158b$export$4950862b30fc1953)(jsonValue));
    }
    /**
     * 
     */ async createPandadocDocumentIds(requestParameters = {}, initOverrides) {
        const response = await this.createPandadocDocumentIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createPreregisteredSocietyPostIdRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createPreregisteredSocietyPostId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/preregistered-societies/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $5c14bc5ef067994d$export$85c3d9c455b4213a)(requestParameters.preregisteredSocietyPost)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $1679a16c8817a30c$export$973aefbf5296d294)(jsonValue));
    }
    /**
     * 
     */ async createPreregisteredSocietyPostId(requestParameters, initOverrides) {
        const response = await this.createPreregisteredSocietyPostIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $e05d2d122bcb721a$export$4b283602380be6d7)(requestParameters.representative)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e05d2d122bcb721a$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async createRepresentative(requestParameters, initOverrides) {
        const response = await this.createRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createSigninAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signin/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $e1410736f4a7598f$export$303b9f6375543435)(requestParameters.loginWithEmailorUsernameAuthToken)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $9d9e30e8290afd15$export$c63fd8bf0afb13bd)(jsonValue));
    }
    /**
     * 
     */ async createSigninAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.createSigninAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createSignupAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signup/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $04c1ef758204bfa0$export$eca3401b04c34cf9)(requestParameters.signup)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $88ed4b3cd76df043$export$f36f5aa70c133e5)(jsonValue));
    }
    /**
     * 
     */ async createSignupAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.createSignupAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a token and blacklists it. Must be used with the `rest_framework_simplejwt.token_blacklist` app installed.
     */ async createTokenBlacklistRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/blacklist/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $6baf408b46f72218$export$68354c35e74dadb8)(requestParameters.tokenBlacklist)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6baf408b46f72218$export$b5cfec7638e86e16)(jsonValue));
    }
    /**
     * Takes a token and blacklists it. Must be used with the `rest_framework_simplejwt.token_blacklist` app installed.
     */ async createTokenBlacklist(requestParameters = {}, initOverrides) {
        const response = await this.createTokenBlacklistRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */ async createTokenObtainPairRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $64e4ffcde8e740f1$export$dc065df2aa624562)(requestParameters.tokenObtainPair)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $64e4ffcde8e740f1$export$a57843fa58a86c18)(jsonValue));
    }
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */ async createTokenObtainPair(requestParameters = {}, initOverrides) {
        const response = await this.createTokenObtainPairRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */ async createTokenRefreshRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/refresh/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $6e6d7e23ca2ce77b$export$f77999a70380c6a3)(requestParameters.tokenRefresh)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6e6d7e23ca2ce77b$export$874d3e01e6e7fdc8)(jsonValue));
    }
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */ async createTokenRefresh(requestParameters = {}, initOverrides) {
        const response = await this.createTokenRefreshRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     */ async createTokenVerifyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/verify/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $6a3c8ed1f4b02c8e$export$62af2150040a6d3b)(requestParameters.tokenVerify)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6a3c8ed1f4b02c8e$export$dd924f4825888164)(jsonValue));
    }
    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     */ async createTokenVerify(requestParameters = {}, initOverrides) {
        const response = await this.createTokenVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async evidenceImageSignedUrlEvidenceImageSignedUrlRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling evidenceImageSignedUrlEvidenceImageSignedUrl.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/evidence-image-signed-url/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $08e14b96c1892b2f$export$6d2e9ac51213991c)(requestParameters.evidenceImageSignedUrlRequest)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $8894c22abf19eb3e$export$991a282fb95e914b)(jsonValue));
    }
    /**
     * 
     */ async evidenceImageSignedUrlEvidenceImageSignedUrl(requestParameters, initOverrides) {
        const response = await this.evidenceImageSignedUrlEvidenceImageSignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listClientSocietyFormTasksRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listClientSocietyFormTasks.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $61c055886c74342c$export$7fa8d9ea09641068)));
    }
    /**
     * 
     */ async listClientSocietyFormTasks(requestParameters, initOverrides) {
        const response = await this.listClientSocietyFormTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listDailyPaymentsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listDailyPayments.");
        const queryParameters = {};
        if (requestParameters.financialYear !== undefined) queryParameters["financial_year"] = requestParameters.financialYear;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/payments/daily/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $2266668baa14d5e1$export$58ccaf3d39e682e6)));
    }
    /**
     * 
     */ async listDailyPayments(requestParameters, initOverrides) {
        const response = await this.listDailyPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/forms/{user_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $2621dc1dfc6b4959$export$fda0802f448f87cd)));
    }
    /**
     * 
     */ async listMembershipForms(requestParameters, initOverrides) {
        const response = await this.listMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listMembershipStatusesRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listMembershipStatuses.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/memberships/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $d55250e4ec146a07$export$cc5cf1ab6820dc7)));
    }
    /**
     * 
     */ async listMembershipStatuses(requestParameters, initOverrides) {
        const response = await this.listMembershipStatusesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listPaymentsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listPayments.");
        const queryParameters = {};
        if (requestParameters.financialYear !== undefined) queryParameters["financial_year"] = requestParameters.financialYear;
        if (requestParameters.format !== undefined) queryParameters["format"] = requestParameters.format;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/payments/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $c26629801de68163$export$ede75277ced03c5d)));
    }
    /**
     * 
     */ async listPayments(requestParameters, initOverrides) {
        const response = await this.listPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietiesRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocieties.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/societies/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $35cacab6a3e1ec67$export$4ce4e8492a820cd5)));
    }
    /**
     * 
     */ async listSocieties(requestParameters, initOverrides) {
        const response = await this.listSocietiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocietyForms.");
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling listSocietyForms.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/societies/{society_id}/forms/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $f8c051d75a3a84b4$export$46847c4110a69b3c)));
    }
    /**
     * 
     */ async listSocietyForms(requestParameters, initOverrides) {
        const response = await this.listSocietyFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async partialUpdateUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling partialUpdateUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $3c58df248542b8a9$export$3e1a5b1b9db0a946)(requestParameters.userSettings)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3c58df248542b8a9$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async partialUpdateUserSettings(requestParameters, initOverrides) {
        const response = await this.partialUpdateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $db1972d7448b3ff8$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.retrieveAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveArtistDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveArtistDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/artist-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $dc6608696afab66f$export$e4f27606a6d6c163)(jsonValue));
    }
    /**
     * 
     */ async retrieveArtistDetails(requestParameters, initOverrides) {
        const response = await this.retrieveArtistDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveByEmailHashClientInterestRegistrationRaw(requestParameters, initOverrides) {
        if (requestParameters.emailHash === null || requestParameters.emailHash === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("emailHash", "Required parameter requestParameters.emailHash was null or undefined when calling retrieveByEmailHashClientInterestRegistration.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{email_hash}/interest-registration/`.replace(`{${"email_hash"}}`, encodeURIComponent(String(requestParameters.emailHash))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $cbf2593677db3000$export$2a302f093ff9aad4)(jsonValue));
    }
    /**
     * 
     */ async retrieveByEmailHashClientInterestRegistration(requestParameters, initOverrides) {
        const response = await this.retrieveByEmailHashClientInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveByUsernameUserRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("username", "Required parameter requestParameters.username was null or undefined when calling retrieveByUsernameUser.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{username}/`.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters.username))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c20a722713b51704$export$2965aa33e1f71909)(jsonValue));
    }
    /**
     * 
     */ async retrieveByUsernameUser(requestParameters, initOverrides) {
        const response = await this.retrieveByUsernameUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveClientBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveClientBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $730e2a0e920732f8$export$c6f5b638dc8b8079)(jsonValue));
    }
    /**
     * 
     */ async retrieveClientBankDetails(requestParameters, initOverrides) {
        const response = await this.retrieveClientBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveClientPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveClientPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7db1c79fee8c8ab4$export$1601295b33eeef78)(jsonValue));
    }
    /**
     * 
     */ async retrieveClientPersonalInformation(requestParameters, initOverrides) {
        const response = await this.retrieveClientPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveExternalEvidenceImageSignedUrlRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/evidence-images/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $b8ef44df9e3d43b0$export$c7b1fcf5381c94c3)(jsonValue));
    }
    /**
     * 
     */ async retrieveExternalEvidenceImageSignedUrl(initOverrides) {
        const response = await this.retrieveExternalEvidenceImageSignedUrlRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveFinancialYearsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveFinancialYears.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/financial-years/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $de87e482ba2e92fe$export$8b12be228efb1adf)(jsonValue));
    }
    /**
     * 
     */ async retrieveFinancialYears(requestParameters, initOverrides) {
        const response = await this.retrieveFinancialYearsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveIdentityDocumentTypesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/identity-document-types/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $efbc7481c8d2c39c$export$8738fab109abb74d)(jsonValue));
    }
    /**
     * 
     */ async retrieveIdentityDocumentTypes(initOverrides) {
        const response = await this.retrieveIdentityDocumentTypesRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestClientIdentityDocumentSubmission.");
        if (requestParameters.documentType === null || requestParameters.documentType === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("documentType", "Required parameter requestParameters.documentType was null or undefined when calling retrieveLatestClientIdentityDocumentSubmission.");
        const queryParameters = {};
        if (requestParameters.documentType !== undefined) queryParameters["document_type"] = requestParameters.documentType;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $74f3aef07a9ab9ca$export$54f4e92d07988b2b)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestClientIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.retrieveLatestClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestPPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestPPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $ee8fb9810e0ec00b$export$862cf7f4fa6a9624)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestPPLReviewExport(requestParameters, initOverrides) {
        const response = await this.retrieveLatestPPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestPrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestPrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5b70e4b48b84fc3d$export$9064002f671ddae3)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestPrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.retrieveLatestPrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveOnboardingProgressRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveOnboardingProgress.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/onboarding-progress/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a6c2c57f3ec02d76$export$549ee7ec67643d0)(jsonValue));
    }
    /**
     * 
     */ async retrieveOnboardingProgress(requestParameters, initOverrides) {
        const response = await this.retrieveOnboardingProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveOnboardingStepsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveOnboardingSteps.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/onboarding-steps/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2af9f60a7332cb2c$export$addf7c24f7592504)(jsonValue));
    }
    /**
     * 
     */ async retrieveOnboardingSteps(requestParameters, initOverrides) {
        const response = await this.retrieveOnboardingStepsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePPLReviewExport.");
        if (requestParameters.exportId === null || requestParameters.exportId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("exportId", "Required parameter requestParameters.exportId was null or undefined when calling retrievePPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/{export_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"export_id"}}`, encodeURIComponent(String(requestParameters.exportId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $ee8fb9810e0ec00b$export$862cf7f4fa6a9624)(jsonValue));
    }
    /**
     * 
     */ async retrievePPLReviewExport(requestParameters, initOverrides) {
        const response = await this.retrievePPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePandadocEgressRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePandadocEgress.");
        if (requestParameters.societyFormId === null || requestParameters.societyFormId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("societyFormId", "Required parameter requestParameters.societyFormId was null or undefined when calling retrievePandadocEgress.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/pandadocs/{user_id}/egress/{society_form_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"society_form_id"}}`, encodeURIComponent(String(requestParameters.societyFormId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $1d87f336a8964c72$export$3e714e27ace81dea)(jsonValue));
    }
    /**
     * 
     */ async retrievePandadocEgress(requestParameters, initOverrides) {
        const response = await this.retrievePandadocEgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePrimaryDiscographyExport.");
        if (requestParameters.exportId === null || requestParameters.exportId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("exportId", "Required parameter requestParameters.exportId was null or undefined when calling retrievePrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/{export_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"export_id"}}`, encodeURIComponent(String(requestParameters.exportId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5b70e4b48b84fc3d$export$9064002f671ddae3)(jsonValue));
    }
    /**
     * 
     */ async retrievePrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.retrievePrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveRecordingRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveRecording.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling retrieveRecording.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a84dd22ffa1b8721$export$ada4d9eb25dcb112)(jsonValue));
    }
    /**
     * 
     */ async retrieveRecording(requestParameters, initOverrides) {
        const response = await this.retrieveRecordingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e05d2d122bcb721a$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async retrieveRepresentative(requestParameters, initOverrides) {
        const response = await this.retrieveRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveStatementsJsonRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveStatementsJson.");
        const queryParameters = {};
        if (requestParameters.paymentDay !== undefined) queryParameters["payment_day"] = requestParameters.paymentDay;
        if (requestParameters.paymentDays) queryParameters["payment_days"] = requestParameters.paymentDays;
        if (requestParameters.format !== undefined) queryParameters["format"] = requestParameters.format;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/statements/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f2a79bc4061f640b$export$b7af3949b8b2f080)(jsonValue));
    }
    /**
     * 
     */ async retrieveStatementsJson(requestParameters, initOverrides) {
        const response = await this.retrieveStatementsJsonRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveUserRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveUser.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c20a722713b51704$export$2965aa33e1f71909)(jsonValue));
    }
    /**
     * 
     */ async retrieveUser(requestParameters, initOverrides) {
        const response = await this.retrieveUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3c58df248542b8a9$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async retrieveUserSettings(requestParameters, initOverrides) {
        const response = await this.retrieveUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async searchPrimaryDiscographyRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling searchPrimaryDiscography.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $1e99d55f76cfd225$export$f75ce5365b9c0f3d)(requestParameters.primaryDiscographyRequest)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a8b275b6da33cfa6$export$c7fe272dbd4732e2)(jsonValue));
    }
    /**
     * 
     */ async searchPrimaryDiscography(requestParameters, initOverrides) {
        const response = await this.searchPrimaryDiscographyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async signUrlExternalEvidenceImageSignedUrlRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/evidence-images/sign-url/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $f8f829a71fac9bcc$export$6a86535ea0505be0)(requestParameters.externalEvidenceImageSignedUrlRequest)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $b8ef44df9e3d43b0$export$c7b1fcf5381c94c3)(jsonValue));
    }
    /**
     * 
     */ async signUrlExternalEvidenceImageSignedUrl(requestParameters = {}, initOverrides) {
        const response = await this.signUrlExternalEvidenceImageSignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $db1972d7448b3ff8$export$a23c9ba4a9c33181)(requestParameters.additionalContactDetails)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $db1972d7448b3ff8$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async updateAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.updateAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateClientBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateClientBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $730e2a0e920732f8$export$d5ce4e46fbd36d46)(requestParameters.clientBankDetails)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $730e2a0e920732f8$export$c6f5b638dc8b8079)(jsonValue));
    }
    /**
     * 
     */ async updateClientBankDetails(requestParameters, initOverrides) {
        const response = await this.updateClientBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateClientIdentityDocumentSubmission.");
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("documentId", "Required parameter requestParameters.documentId was null or undefined when calling updateClientIdentityDocumentSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $cc3eb4e70d9f2fd9$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.dateCreated !== undefined) formParams.append("date_created", requestParameters.dateCreated);
        if (requestParameters.file !== undefined) formParams.append("file", requestParameters.file);
        if (requestParameters.filename !== undefined) formParams.append("filename", requestParameters.filename);
        if (requestParameters.status !== undefined) formParams.append("status", requestParameters.status);
        if (requestParameters.documentExpiryDate !== undefined) formParams.append("document_expiry_date", requestParameters.documentExpiryDate);
        if (requestParameters.documentType !== undefined) formParams.append("document_type", requestParameters.documentType);
        if (requestParameters.fileUrl !== undefined) formParams.append("file_url", requestParameters.fileUrl);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/{document_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $74f3aef07a9ab9ca$export$54f4e92d07988b2b)(jsonValue));
    }
    /**
     * 
     */ async updateClientIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.updateClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateClientPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateClientPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7db1c79fee8c8ab4$export$f60ddb500bd22238)(requestParameters.clientPersonalInformation)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7db1c79fee8c8ab4$export$1601295b33eeef78)(jsonValue));
    }
    /**
     * 
     */ async updateClientPersonalInformation(requestParameters, initOverrides) {
        const response = await this.updateClientPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateClientSocietyFormTaskRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateClientSocietyFormTask.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $61c055886c74342c$export$1f4009bc54aefa3f)(requestParameters.clientSocietyFormTask)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $61c055886c74342c$export$7fa8d9ea09641068)(jsonValue));
    }
    /**
     * 
     */ async updateClientSocietyFormTask(requestParameters, initOverrides) {
        const response = await this.updateClientSocietyFormTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updatePandadocEgressRaw(requestParameters, initOverrides) {
        if (requestParameters.societyFormId === null || requestParameters.societyFormId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("societyFormId", "Required parameter requestParameters.societyFormId was null or undefined when calling updatePandadocEgress.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/str:user_id>/ingress/{society_form_id}/`.replace(`{${"society_form_id"}}`, encodeURIComponent(String(requestParameters.societyFormId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $1d87f336a8964c72$export$3e714e27ace81dea)(jsonValue));
    }
    /**
     * 
     */ async updatePandadocEgress(requestParameters, initOverrides) {
        const response = await this.updatePandadocEgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updatePhotoClientPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updatePhotoClientPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $cc3eb4e70d9f2fd9$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.user !== undefined) formParams.append("user", requestParameters.user);
        if (requestParameters.url !== undefined) formParams.append("url", requestParameters.url);
        if (requestParameters.oldPassword !== undefined) formParams.append("old_password", requestParameters.oldPassword);
        if (requestParameters.password !== undefined) formParams.append("password", requestParameters.password);
        if (requestParameters.title !== undefined) formParams.append("title", requestParameters.title);
        if (requestParameters.gender !== undefined) formParams.append("gender", requestParameters.gender);
        if (requestParameters.cityOfBirth !== undefined) formParams.append("city_of_birth", requestParameters.cityOfBirth);
        if (requestParameters.countryOfBirth !== undefined) formParams.append("country_of_birth", requestParameters.countryOfBirth);
        if (requestParameters.fullName !== undefined) formParams.append("full_name", requestParameters.fullName);
        if (requestParameters.firstName !== undefined) formParams.append("first_name", requestParameters.firstName);
        if (requestParameters.middleName !== undefined) formParams.append("middle_name", requestParameters.middleName);
        if (requestParameters.lastName !== undefined) formParams.append("last_name", requestParameters.lastName);
        if (requestParameters.department !== undefined) formParams.append("department", requestParameters.department);
        if (requestParameters.departmentChoices) formParams.append("department_choices", requestParameters.departmentChoices.join($cc3eb4e70d9f2fd9$export$83cb526776fb323d["csv"]));
        if (requestParameters.userPhoto !== undefined) formParams.append("user_photo", requestParameters.userPhoto);
        if (requestParameters.userPhotoUrl !== undefined) formParams.append("user_photo_url", requestParameters.userPhotoUrl);
        if (requestParameters.dateOfBirth !== undefined) formParams.append("date_of_birth", requestParameters.dateOfBirth);
        if (requestParameters.aliases) formParams.append("aliases", requestParameters.aliases.join($cc3eb4e70d9f2fd9$export$83cb526776fb323d["csv"]));
        if (requestParameters.nationality !== undefined) formParams.append("nationality", requestParameters.nationality);
        if (requestParameters.taxationCountry !== undefined) formParams.append("taxation_country", requestParameters.taxationCountry);
        if (requestParameters.vatNumber !== undefined) formParams.append("vat_number", requestParameters.vatNumber);
        if (requestParameters.taxIdType !== undefined) formParams.append("tax_id_type", requestParameters.taxIdType);
        if (requestParameters.taxIdNumber !== undefined) formParams.append("tax_id_number", requestParameters.taxIdNumber);
        if (requestParameters.emailAddress !== undefined) formParams.append("email_address", requestParameters.emailAddress);
        if (requestParameters.streetAddress !== undefined) formParams.append("street_address", requestParameters.streetAddress);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.phoneNumber !== undefined) formParams.append("phone_number", requestParameters.phoneNumber);
        if (requestParameters.county !== undefined) formParams.append("county", requestParameters.county);
        if (requestParameters.postcode !== undefined) formParams.append("postcode", requestParameters.postcode);
        if (requestParameters.westburyId !== undefined) formParams.append("westbury_id", requestParameters.westburyId);
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/photo/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7db1c79fee8c8ab4$export$1601295b33eeef78)(jsonValue));
    }
    /**
     * 
     */ async updatePhotoClientPersonalInformation(requestParameters, initOverrides) {
        const response = await this.updatePhotoClientPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $e05d2d122bcb721a$export$4b283602380be6d7)(requestParameters.representative)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e05d2d122bcb721a$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async updateRepresentative(requestParameters, initOverrides) {
        const response = await this.updateRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateSignupAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signup/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $04c1ef758204bfa0$export$eca3401b04c34cf9)(requestParameters.signup)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $88ed4b3cd76df043$export$f36f5aa70c133e5)(jsonValue));
    }
    /**
     * 
     */ async updateSignupAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.updateSignupAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $3c58df248542b8a9$export$3e1a5b1b9db0a946)(requestParameters.userSettings)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3c58df248542b8a9$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async updateUserSettings(requestParameters, initOverrides) {
        const response = await this.updateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
const $d1b79341fc7471d8$export$79cb1672b4031ee5 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $d1b79341fc7471d8$export$2f2ed6402679bad7 = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
const $d1b79341fc7471d8$export$f5a6539bc3d0a3b7 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $d1b79341fc7471d8$export$17ce8e90acb3d85b = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
const $d1b79341fc7471d8$export$11735bb024c65bbe = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $d1b79341fc7471d8$export$32d595ebf654a805 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};







/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $f599d8a7dfeab1bb$export$2812a1fb15aca49c = "http://localhost".replace(/\/+$/, "");
class $f599d8a7dfeab1bb$export$fa89be98fe0936f2 {
    constructor(configuration = {}){
        this.configuration = configuration;
    }
    set config(configuration) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : $f599d8a7dfeab1bb$export$2812a1fb15aca49c;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || $f599d8a7dfeab1bb$export$ac4103b836844853;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === "function" ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === "function" ? accessToken : async ()=>accessToken;
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
const $f599d8a7dfeab1bb$export$ac4f8128ea29c5 = new $f599d8a7dfeab1bb$export$fa89be98fe0936f2();
class $f599d8a7dfeab1bb$export$70edad7ad5bb3f5d {
    static #_ = this.jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
    constructor(configuration = $f599d8a7dfeab1bb$export$ac4f8128ea29c5){
        this.configuration = configuration;
        this.fetchApi = async (url, init)=>{
            let fetchParams = {
                url: url,
                init: init
            };
            for (const middleware of this.middleware)if (middleware.pre) fetchParams = await middleware.pre({
                fetch: this.fetchApi,
                ...fetchParams
            }) || fetchParams;
            let response = undefined;
            try {
                response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
            } catch (e) {
                for (const middleware of this.middleware)if (middleware.onError) response = await middleware.onError({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    error: e,
                    response: response ? response.clone() : undefined
                }) || response;
                if (response === undefined) {
                    if (e instanceof Error) throw new $f599d8a7dfeab1bb$export$26e841bcf1aeb894(e, "The request failed and the interceptors did not return an alternative response");
                    else throw e;
                }
            }
            for (const middleware of this.middleware)if (middleware.post) response = await middleware.post({
                fetch: this.fetchApi,
                url: fetchParams.url,
                init: fetchParams.init,
                response: response.clone()
            }) || response;
            return response;
        };
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre: pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post: post
            }));
        return this.withMiddleware(...middlewares);
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */ isJsonMime(mime) {
        if (!mime) return false;
        return $f599d8a7dfeab1bb$export$70edad7ad5bb3f5d.jsonRegex.test(mime);
    }
    async request(context, initOverrides) {
        const { url: url, init: init } = await this.createFetchParams(context, initOverrides);
        const response = await this.fetchApi(url, init);
        if (response && response.status >= 200 && response.status < 300) return response;
        throw new $f599d8a7dfeab1bb$export$286baf652d0b1206(response, "Response returned an error code");
    }
    async createFetchParams(context, initOverrides) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
        // this is done to avoid urls ending with a "?" character which buggy webservers
        // do not handle correctly sometimes.
        url += "?" + this.configuration.queryParamsStringify(context.query);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        Object.keys(headers).forEach((key)=>headers[key] === undefined ? delete headers[key] : {});
        const initOverrideFn = typeof initOverrides === "function" ? initOverrides : async ()=>initOverrides;
        const initParams = {
            method: context.method,
            headers: headers,
            body: context.body,
            credentials: this.configuration.credentials
        };
        const overriddenInit = {
            ...initParams,
            ...await initOverrideFn({
                init: initParams,
                context: context
            })
        };
        const init = {
            ...overriddenInit,
            body: $f599d8a7dfeab1bb$var$isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || $f599d8a7dfeab1bb$var$isBlob(overriddenInit.body) ? overriddenInit.body : JSON.stringify(overriddenInit.body)
        };
        return {
            url: url,
            init: init
        };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
function $f599d8a7dfeab1bb$var$isBlob(value) {
    return typeof Blob !== "undefined" && value instanceof Blob;
}
function $f599d8a7dfeab1bb$var$isFormData(value) {
    return typeof FormData !== "undefined" && value instanceof FormData;
}
class $f599d8a7dfeab1bb$export$286baf652d0b1206 extends Error {
    constructor(response, msg){
        super(msg);
        this.response = response;
        this.name = "ResponseError";
    }
}
class $f599d8a7dfeab1bb$export$26e841bcf1aeb894 extends Error {
    constructor(cause, msg){
        super(msg);
        this.cause = cause;
        this.name = "FetchError";
    }
}
class $f599d8a7dfeab1bb$export$a27bea7cdb975d70 extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
const $f599d8a7dfeab1bb$export$83cb526776fb323d = {
    csv: ",",
    ssv: " ",
    tsv: "	",
    pipes: "|"
};
function $f599d8a7dfeab1bb$export$f7e9f41ea797a17(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function $f599d8a7dfeab1bb$export$ac4103b836844853(params, prefix = "") {
    return Object.keys(params).map((key)=>$f599d8a7dfeab1bb$var$querystringSingleKey(key, params[key], prefix)).filter((part)=>part.length > 0).join("&");
}
function $f599d8a7dfeab1bb$var$querystringSingleKey(key, value, keyPrefix = "") {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return $f599d8a7dfeab1bb$var$querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    if (value instanceof Object) return $f599d8a7dfeab1bb$export$ac4103b836844853(value, fullKey);
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function $f599d8a7dfeab1bb$export$825e789796ab7275(data, fn) {
    return Object.keys(data).reduce((acc, key)=>({
            ...acc,
            [key]: fn(data[key])
        }), {});
}
function $f599d8a7dfeab1bb$export$59072c3750441c02(consumes) {
    for (const consume of consumes){
        if ("multipart/form-data" === consume.contentType) return true;
    }
    return false;
}
class $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4 {
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
    async value() {
        return this.transformer(await this.raw.json());
    }
}
class $f599d8a7dfeab1bb$export$20446dc680588cc3 {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return undefined;
    }
}
class $f599d8a7dfeab1bb$export$9d707f60a06b41f8 {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.blob();
    }
}
class $f599d8a7dfeab1bb$export$bf40ae8c274ef99b {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.text();
    }
}


/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $1d7f437782b3550e$export$cc4714cd9f9c3814 = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
function $1d7f437782b3550e$export$7a297d20d6883fc0(value) {
    let isInstance = true;
    return isInstance;
}
function $1d7f437782b3550e$export$c974f409b401a196(json) {
    return $1d7f437782b3550e$export$c0e06766df2e9b9a(json, false);
}
function $1d7f437782b3550e$export$c0e06766df2e9b9a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "representative": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative") ? undefined : json["representative"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "bankAccountName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_name") ? undefined : json["bank_account_name"],
        "bankAccountNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_number") ? undefined : json["bank_account_number"],
        "bankSortCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_sort_code") ? undefined : json["bank_sort_code"],
        "bankName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_name") ? undefined : json["bank_name"],
        "bankAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_address") ? undefined : json["bank_address"],
        "bankPostcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_postcode") ? undefined : json["bank_postcode"],
        "bankIban": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_iban") ? undefined : json["bank_iban"],
        "bankRoutingCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_routing_code") ? undefined : json["bank_routing_code"],
        "bankAccountHoldingBranch": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_holding_branch") ? undefined : json["bank_account_holding_branch"],
        "bankBicSwiftCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_bic_swift_code") ? undefined : json["bank_bic_swift_code"],
        "bankPaymentMethod": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_payment_method") ? undefined : json["bank_payment_method"]
    };
}
function $1d7f437782b3550e$export$74977fc31957ceee(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_account_name": value.bankAccountName,
        "bank_account_number": value.bankAccountNumber,
        "bank_sort_code": value.bankSortCode,
        "bank_name": value.bankName,
        "bank_address": value.bankAddress,
        "bank_postcode": value.bankPostcode,
        "bank_iban": value.bankIban,
        "bank_routing_code": value.bankRoutingCode,
        "bank_account_holding_branch": value.bankAccountHoldingBranch,
        "bank_bic_swift_code": value.bankBicSwiftCode,
        "bank_payment_method": value.bankPaymentMethod
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $2feea64a3d22a4da$export$de50ce670db8b875 = {
    Manager: "Manager",
    Accountant: "Accountant",
    Lawyer: "Lawyer",
    Representative: "Representative",
    Company: "Company"
};
function $2feea64a3d22a4da$export$94eae51c64f96f45(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $2feea64a3d22a4da$export$4e8df7ad58101063(json) {
    return $2feea64a3d22a4da$export$e3de5954bcc5e040(json, false);
}
function $2feea64a3d22a4da$export$e3de5954bcc5e040(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": json["name"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"]
    };
}
function $2feea64a3d22a4da$export$ae53e75522b65f95(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name,
        "role": value.role,
        "email": value.email,
        "phone_number": value.phoneNumber
    };
}


function $5e3ca10c0ee31eb4$export$7c52a6c7c5c7d0(value) {
    let isInstance = true;
    return isInstance;
}
function $5e3ca10c0ee31eb4$export$8a33e3ce64853ecc(json) {
    return $5e3ca10c0ee31eb4$export$8a81df7e0f85324d(json, false);
}
function $5e3ca10c0ee31eb4$export$8a81df7e0f85324d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"],
        "witnessFirstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "representative": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative") ? undefined : (0, $2feea64a3d22a4da$export$4e8df7ad58101063)(json["representative"]),
        "representativeBankDetails": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative_bank_details") ? undefined : (0, $1d7f437782b3550e$export$c974f409b401a196)(json["representative_bank_details"])
    };
}
function $5e3ca10c0ee31eb4$export$a23c9ba4a9c33181(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "representative": (0, $2feea64a3d22a4da$export$ae53e75522b65f95)(value.representative),
        "representative_bank_details": (0, $1d7f437782b3550e$export$74977fc31957ceee)(value.representativeBankDetails)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $aad9d7442fa2f9eb$export$45149a8a25b36b97(value) {
    let isInstance = true;
    isInstance = isInstance && "dateOfBirth" in value;
    isInstance = isInstance && "documentNumber" in value;
    isInstance = isInstance && "documentExpiryDate" in value;
    return isInstance;
}
function $aad9d7442fa2f9eb$export$ce79036fae66befd(json) {
    return $aad9d7442fa2f9eb$export$e2d4864971e3b70c(json, false);
}
function $aad9d7442fa2f9eb$export$e2d4864971e3b70c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "dateOfBirth": json["date_of_birth"],
        "documentNumber": json["document_number"],
        "documentExpiryDate": json["document_expiry_date"]
    };
}
function $aad9d7442fa2f9eb$export$e08a00926af7c160(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "date_of_birth": value.dateOfBirth,
        "document_number": value.documentNumber,
        "document_expiry_date": value.documentExpiryDate
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $c3418b6825975f57$export$c6bf8ecc4f23e4a = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
function $c3418b6825975f57$export$97629d901bbf4d8a(value) {
    let isInstance = true;
    isInstance = isInstance && "bankAccountNumber" in value;
    isInstance = isInstance && "bankSortCode" in value;
    isInstance = isInstance && "bankName" in value;
    isInstance = isInstance && "bankAddress" in value;
    isInstance = isInstance && "bankIban" in value;
    return isInstance;
}
function $c3418b6825975f57$export$cab2c6e7757d8c1d(json) {
    return $c3418b6825975f57$export$231aca40dd6ed0a1(json, false);
}
function $c3418b6825975f57$export$231aca40dd6ed0a1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "bankAccountName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_name") ? undefined : json["bank_account_name"],
        "bankAccountNumber": json["bank_account_number"],
        "bankSortCode": json["bank_sort_code"],
        "bankName": json["bank_name"],
        "bankAddress": json["bank_address"],
        "bankPostcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_postcode") ? undefined : json["bank_postcode"],
        "bankIban": json["bank_iban"],
        "bankRoutingCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_routing_code") ? undefined : json["bank_routing_code"],
        "bankAccountHoldingBranch": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_holding_branch") ? undefined : json["bank_account_holding_branch"],
        "bankBicSwiftCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_bic_swift_code") ? undefined : json["bank_bic_swift_code"],
        "bankPaymentMethod": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_payment_method") ? undefined : json["bank_payment_method"],
        "intermediaryBankName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "intermediary_bank_name") ? undefined : json["intermediary_bank_name"],
        "intermediaryBankAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "intermediary_bank_address") ? undefined : json["intermediary_bank_address"],
        "intermediaryBankBicSwiftCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "intermediary_bank_bic_swift_code") ? undefined : json["intermediary_bank_bic_swift_code"],
        "intermediaryBankCountry": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "intermediary_bank_country") ? undefined : json["intermediary_bank_country"]
    };
}
function $c3418b6825975f57$export$ff8d63926b23924f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_account_name": value.bankAccountName,
        "bank_account_number": value.bankAccountNumber,
        "bank_sort_code": value.bankSortCode,
        "bank_name": value.bankName,
        "bank_address": value.bankAddress,
        "bank_postcode": value.bankPostcode,
        "bank_iban": value.bankIban,
        "bank_routing_code": value.bankRoutingCode,
        "bank_account_holding_branch": value.bankAccountHoldingBranch,
        "bank_bic_swift_code": value.bankBicSwiftCode,
        "bank_payment_method": value.bankPaymentMethod,
        "intermediary_bank_name": value.intermediaryBankName,
        "intermediary_bank_address": value.intermediaryBankAddress,
        "intermediary_bank_bic_swift_code": value.intermediaryBankBicSwiftCode,
        "intermediary_bank_country": value.intermediaryBankCountry
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $12ebf204d4f43bf9$export$5fcf779e7e65e628(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "order" in value;
    return isInstance;
}
function $12ebf204d4f43bf9$export$cc6b4e10642aad34(json) {
    return $12ebf204d4f43bf9$export$be574d484e2d713b(json, false);
}
function $12ebf204d4f43bf9$export$be574d484e2d713b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "order": json["order"],
        "information": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "information") ? undefined : json["information"],
        "stepCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "step_completed") ? undefined : json["step_completed"]
    };
}
function $12ebf204d4f43bf9$export$119a1d330671ed41(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "order": value.order,
        "information": value.information,
        "step_completed": value.stepCompleted
    };
}


function $d115afa3f35b4902$export$b27eb7f8fb86ce20(value) {
    let isInstance = true;
    isInstance = isInstance && "nonClient" in value;
    isInstance = isInstance && "completedOnboardingSteps" in value;
    return isInstance;
}
function $d115afa3f35b4902$export$9d932c871ca38b84(json) {
    return $d115afa3f35b4902$export$a345a168d698e363(json, false);
}
function $d115afa3f35b4902$export$a345a168d698e363(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "userId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_id") ? undefined : json["user_id"],
        "fullName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"],
        "nonClient": json["non_client"],
        "completedOnboardingSteps": json["completed_onboarding_steps"].map((0, $12ebf204d4f43bf9$export$cc6b4e10642aad34))
    };
}
function $d115afa3f35b4902$export$f0407875854c2a28(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "non_client": value.nonClient,
        "completed_onboarding_steps": value.completedOnboardingSteps.map((0, $12ebf204d4f43bf9$export$119a1d330671ed41))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $bd83d5bbd5694632$export$848862a9276a3f81 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $bd83d5bbd5694632$export$84e842e0cdfad731 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
function $bd83d5bbd5694632$export$8616bb961f2117cb(value) {
    let isInstance = true;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $bd83d5bbd5694632$export$9907fd9d36227c03(json) {
    return $bd83d5bbd5694632$export$ce8c227511f6865(json, false);
}
function $bd83d5bbd5694632$export$ce8c227511f6865(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "readableName": json["readable_name"],
        "logo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo") ? undefined : json["logo"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "website": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "website") ? undefined : json["website"],
        "portal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "portal") ? undefined : json["portal"],
        "phone": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "address": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "address") ? undefined : json["address"],
        "additionalTerritories": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "additional_territories") ? undefined : json["additional_territories"],
        "formEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_email") ? undefined : json["form_email"],
        "formPostalAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_postal_address") ? undefined : json["form_postal_address"],
        "formPortal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_portal") ? undefined : json["form_portal"],
        "formReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_frequency") ? undefined : json["form_reminder_frequency"],
        "formStopReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_stop_reminder_frequency") ? undefined : json["form_stop_reminder_frequency"],
        "formReminderSendTo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_send_to") ? undefined : json["form_reminder_send_to"],
        "taxForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_forms") ? undefined : json["tax_forms"],
        "roleForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role_forms") ? undefined : json["role_forms"],
        "contactInformation": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "contact_information") ? undefined : json["contact_information"]
    };
}
function $bd83d5bbd5694632$export$af61e1b0695ebf79(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "readable_name": value.readableName,
        "logo": value.logo,
        "country": value.country,
        "website": value.website,
        "portal": value.portal,
        "phone": value.phone,
        "address": value.address,
        "additional_territories": value.additionalTerritories,
        "form_email": value.formEmail,
        "form_postal_address": value.formPostalAddress,
        "form_portal": value.formPortal,
        "form_reminder_frequency": value.formReminderFrequency,
        "form_stop_reminder_frequency": value.formStopReminderFrequency,
        "form_reminder_send_to": value.formReminderSendTo,
        "tax_forms": value.taxForms,
        "role_forms": value.roleForms,
        "contact_information": value.contactInformation
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $dae85878c5dda937$export$ce4d75ddf8b4da4 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $dae85878c5dda937$export$378c0835b3bf76ec = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
function $dae85878c5dda937$export$888b681dcf7df22f(value) {
    let isInstance = true;
    return isInstance;
}
function $dae85878c5dda937$export$9d955c411567a352(json) {
    return $dae85878c5dda937$export$4275d1a91757aa12(json, false);
}
function $dae85878c5dda937$export$4275d1a91757aa12(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "file": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "file") ? undefined : json["file"],
        "filename": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "filename") ? undefined : json["filename"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "documentExpiryDate": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_expiry_date") ? undefined : json["document_expiry_date"],
        "documentSignedDate": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_signed_date") ? undefined : json["document_signed_date"],
        "documentType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_type") ? undefined : json["document_type"],
        "fileUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "file_url") ? undefined : json["file_url"]
    };
}
function $dae85878c5dda937$export$c337e99f3cd5040d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "file": value.file,
        "filename": value.filename,
        "status": value.status,
        "document_expiry_date": value.documentExpiryDate,
        "document_signed_date": value.documentSignedDate,
        "document_type": value.documentType
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $2fea223443d8a350$export$599a4ea92cc05b48 = {
    PerformerProducer: "Performer/Producer"
};
const $2fea223443d8a350$export$8a4330f68c23ad0d = {
    Pending: "pending",
    Approved: "approved",
    Active: "active",
    Rejected: "rejected",
    Inactive: "inactive"
};
function $2fea223443d8a350$export$dc4096b34d38787e(value) {
    let isInstance = true;
    return isInstance;
}
function $2fea223443d8a350$export$c8c63a6b256b2f84(json) {
    return $2fea223443d8a350$export$3b83e2aad9580527(json, false);
}
function $2fea223443d8a350$export$3b83e2aad9580527(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "representative": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative") ? undefined : (0, $2feea64a3d22a4da$export$4e8df7ad58101063)(json["representative"]),
        "performerOrProducer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "fullName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "masterId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "masterName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "masterRights": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "masterFullname": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "pplPerformerId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "pplPerformerName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "discogsIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "discogs_ids") ? undefined : json["discogs_ids"],
        "deezerIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "deezer_ids") ? undefined : json["deezer_ids"],
        "spotifyIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "spotify_ids") ? undefined : json["spotify_ids"],
        "musicbrainzIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "musicbrainz_ids") ? undefined : json["musicbrainz_ids"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "accountStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "account_status") ? undefined : json["account_status"],
        "accountCreationUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "account_creation_url") ? undefined : json["account_creation_url"]
    };
}
function $2fea223443d8a350$export$887cdb805eaac4d8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "role": value.role,
        "representative": (0, $2feea64a3d22a4da$export$ae53e75522b65f95)(value.representative),
        "performer_or_producer": value.performerOrProducer,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "email": value.email,
        "phone_number": value.phoneNumber,
        "master_id": value.masterId,
        "master_name": value.masterName,
        "master_email": value.masterEmail,
        "master_rights": value.masterRights,
        "master_fullname": value.masterFullname,
        "ppl_performer_id": value.pplPerformerId,
        "ppl_performer_name": value.pplPerformerName,
        "discogs_ids": value.discogsIds,
        "deezer_ids": value.deezerIds,
        "spotify_ids": value.spotifyIds,
        "musicbrainz_ids": value.musicbrainzIds,
        "notes": value.notes,
        "account_status": value.accountStatus
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $7dac4f16d65ed476$export$e06cceec66347c3f = {
    PerformerProducer: "Performer/Producer"
};
const $7dac4f16d65ed476$export$9b9eb7b0b3ecdf59 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $7dac4f16d65ed476$export$9ab350eeddd69ade = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
function $7dac4f16d65ed476$export$4efbce1e5d2c322e(value) {
    let isInstance = true;
    return isInstance;
}
function $7dac4f16d65ed476$export$345ccf656783517a(json) {
    return $7dac4f16d65ed476$export$3e3f043aada796de(json, false);
}
function $7dac4f16d65ed476$export$3e3f043aada796de(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "oldPassword": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "old_password") ? undefined : json["old_password"],
        "password": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "title": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "fullName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "department": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "departmentChoices": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "department_choices") ? undefined : json["department_choices"],
        "userPhoto": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "dateOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "aliases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "nationality": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "taxationCountry": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "westburyId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"]
    };
}
function $7dac4f16d65ed476$export$7c5d2ff8a10c7191(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "old_password": value.oldPassword,
        "password": value.password,
        "role": value.role,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "department": value.department,
        "user_photo": value.userPhoto,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "aliases": value.aliases,
        "nationality": value.nationality,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $27e4b52526fc9e58$export$525b85f97717f513(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $27e4b52526fc9e58$export$1c504095e8fb3130(json) {
    return $27e4b52526fc9e58$export$4ed5f5a372aa5ac0(json, false);
}
function $27e4b52526fc9e58$export$4ed5f5a372aa5ac0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "fieldsList": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "fields_list") ? undefined : json["fields_list"],
        "prepopulatedData": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "prepopulated_data") ? undefined : json["prepopulated_data"]
    };
}
function $27e4b52526fc9e58$export$6f4fbe925053dc34(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "fields_list": value.fieldsList
    };
}


const $3fcbd4bdbdf09193$export$2e487ae93f0349b8 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $3fcbd4bdbdf09193$export$f9cb9519865efb66 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
function $3fcbd4bdbdf09193$export$e5d84f772ffea9af(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "societyForms" in value;
    return isInstance;
}
function $3fcbd4bdbdf09193$export$5ed54dd8f8ca2d09(json) {
    return $3fcbd4bdbdf09193$export$c0fea0c0a76337c0(json, false);
}
function $3fcbd4bdbdf09193$export$c0fea0c0a76337c0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "logoUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo_url") ? undefined : json["logo_url"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "website": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "website") ? undefined : json["website"],
        "portal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "portal") ? undefined : json["portal"],
        "phone": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "address": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "address") ? undefined : json["address"],
        "additionalTerritories": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "additional_territories") ? undefined : json["additional_territories"],
        "formEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_email") ? undefined : json["form_email"],
        "formPostalAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_postal_address") ? undefined : json["form_postal_address"],
        "formPortal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_portal") ? undefined : json["form_portal"],
        "formReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_frequency") ? undefined : json["form_reminder_frequency"],
        "formStopReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_stop_reminder_frequency") ? undefined : json["form_stop_reminder_frequency"],
        "formReminderSendTo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_send_to") ? undefined : json["form_reminder_send_to"],
        "societyForms": json["society_forms"].map((0, $27e4b52526fc9e58$export$1c504095e8fb3130)),
        "taxForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_forms") ? undefined : json["tax_forms"],
        "roleForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role_forms") ? undefined : json["role_forms"],
        "contactInformation": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "contact_information") ? undefined : json["contact_information"]
    };
}
function $3fcbd4bdbdf09193$export$67b0d72c43f7ce6e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "country": value.country,
        "website": value.website,
        "portal": value.portal,
        "phone": value.phone,
        "address": value.address,
        "additional_territories": value.additionalTerritories,
        "form_email": value.formEmail,
        "form_postal_address": value.formPostalAddress,
        "form_portal": value.formPortal,
        "form_reminder_frequency": value.formReminderFrequency,
        "form_stop_reminder_frequency": value.formStopReminderFrequency,
        "form_reminder_send_to": value.formReminderSendTo,
        "society_forms": value.societyForms.map((0, $27e4b52526fc9e58$export$6f4fbe925053dc34))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $44b716c881c245f1$export$a17802aa6399d204(value) {
    let isInstance = true;
    isInstance = isInstance && "societyForm" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $44b716c881c245f1$export$13aafc733b654c27(json) {
    return $44b716c881c245f1$export$febbe46111b1493e(json, false);
}
function $44b716c881c245f1$export$febbe46111b1493e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "societyForm": json["society_form"],
        "user": json["user"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"]
    };
}
function $44b716c881c245f1$export$6a124b4675e263e8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_form": value.societyForm,
        "user": value.user
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $6780b795e8c2bd3c$export$efe5dfce1f559cbd(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    return isInstance;
}
function $6780b795e8c2bd3c$export$d3c2a41c4d76550a(json) {
    return $6780b795e8c2bd3c$export$9cca1d008da97b56(json, false);
}
function $6780b795e8c2bd3c$export$9cca1d008da97b56(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "username": json["username"],
        "fullName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"]
    };
}
function $6780b795e8c2bd3c$export$3de13346a7f1e52d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username
    };
}


function $f3b0fe9c62b42bbf$export$832497172c4fd451(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "tasks" in value;
    return isInstance;
}
function $f3b0fe9c62b42bbf$export$6d55337ed52765c1(json) {
    return $f3b0fe9c62b42bbf$export$331ac58c44c0177e(json, false);
}
function $f3b0fe9c62b42bbf$export$331ac58c44c0177e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "user": (0, $6780b795e8c2bd3c$export$d3c2a41c4d76550a)(json["user"]),
        "tasks": json["tasks"].map((0, $44b716c881c245f1$export$13aafc733b654c27))
    };
}
function $f3b0fe9c62b42bbf$export$fd6cfe6c501aa8c3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "user": (0, $6780b795e8c2bd3c$export$3de13346a7f1e52d)(value.user),
        "tasks": value.tasks.map((0, $44b716c881c245f1$export$6a124b4675e263e8))
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $898e32c31d9fa843$export$ff7beaaf5b39d2a4 = {
    VerifyPassportAndSendForms: "verify_passport_and_send_forms",
    ExpressionOfInterestReview: "expression_of_interest_review",
    SubmitDiscographyId: "submit_discography_id",
    ApproveWestburyForms: "approve_westbury_forms",
    SignSocietyForm: "sign_society_form",
    ApproveMembershipForms: "approve_membership_forms",
    DownloadPrimaryDiscographyExport: "download_primary_discography_export",
    DownloadPplReviewExport: "download_ppl_review_export"
};
function $898e32c31d9fa843$export$ff02414af2ae2606(value) {
    let isInstance = true;
    return isInstance;
}
function $898e32c31d9fa843$export$3cb371dfaf6bbd4c(json) {
    return $898e32c31d9fa843$export$596df412c64e1b9d(json, false);
}
function $898e32c31d9fa843$export$596df412c64e1b9d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"])
    };
}
function $898e32c31d9fa843$export$c915ff49004ec8d1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "status": value.status
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $691d4f93542f634e$export$a2a5797c3f07b2a8(value) {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $691d4f93542f634e$export$fa54b184222b5f18(json) {
    return $691d4f93542f634e$export$63a7b3b33ecdc4a2(json, false);
}
function $691d4f93542f634e$export$63a7b3b33ecdc4a2(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "s3Url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "s3_url") ? undefined : json["s3_url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "s3Key": json["s3_key"],
        "ready": json["ready"],
        "user": json["user"],
        "task": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "task") ? undefined : json["task"]
    };
}
function $691d4f93542f634e$export$77dd57e79750b82(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "s3_key": value.s3Key,
        "ready": value.ready,
        "user": value.user,
        "task": value.task
    };
}


function $f620ba671e370d28$export$c8d98aba9ae2c224(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "clientAdminTasks" in value;
    isInstance = isInstance && "primaryDiscographyExports" in value;
    isInstance = isInstance && "pplReviewExports" in value;
    return isInstance;
}
function $f620ba671e370d28$export$4639f4523496d0a7(json) {
    return $f620ba671e370d28$export$779a55ec4030e6a3(json, false);
}
function $f620ba671e370d28$export$779a55ec4030e6a3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "username": json["username"],
        "fullName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"],
        "clientAdminTasks": json["client_admin_tasks"].map((0, $898e32c31d9fa843$export$3cb371dfaf6bbd4c)),
        "primaryDiscographyExports": json["primary_discography_exports"].map((0, $691d4f93542f634e$export$fa54b184222b5f18)),
        "pplReviewExports": json["ppl_review_exports"].map((0, $691d4f93542f634e$export$fa54b184222b5f18))
    };
}
function $f620ba671e370d28$export$5b76c785707ee47a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username,
        "client_admin_tasks": value.clientAdminTasks.map((0, $898e32c31d9fa843$export$c915ff49004ec8d1)),
        "primary_discography_exports": value.primaryDiscographyExports.map((0, $691d4f93542f634e$export$77dd57e79750b82)),
        "ppl_review_exports": value.pplReviewExports.map((0, $691d4f93542f634e$export$77dd57e79750b82))
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $d8e38307ea8d81f1$export$d66d8ea433128066 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $d8e38307ea8d81f1$export$c2ee5e53d7c49ba2 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
function $d8e38307ea8d81f1$export$72a3c7fbf7933136(value) {
    let isInstance = true;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $d8e38307ea8d81f1$export$c2ece841a794430e(json) {
    return $d8e38307ea8d81f1$export$23864b2aed5159d1(json, false);
}
function $d8e38307ea8d81f1$export$23864b2aed5159d1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "readableName": json["readable_name"],
        "logo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo") ? undefined : json["logo"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "website": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "website") ? undefined : json["website"],
        "portal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "portal") ? undefined : json["portal"],
        "phone": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "address": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "address") ? undefined : json["address"],
        "additionalTerritories": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "additional_territories") ? undefined : json["additional_territories"],
        "formEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_email") ? undefined : json["form_email"],
        "formPostalAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_postal_address") ? undefined : json["form_postal_address"],
        "formPortal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_portal") ? undefined : json["form_portal"],
        "formReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_frequency") ? undefined : json["form_reminder_frequency"],
        "formStopReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_stop_reminder_frequency") ? undefined : json["form_stop_reminder_frequency"],
        "formReminderSendTo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_send_to") ? undefined : json["form_reminder_send_to"],
        "taxForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_forms") ? undefined : json["tax_forms"],
        "roleForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role_forms") ? undefined : json["role_forms"],
        "contactInformation": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "contact_information") ? undefined : json["contact_information"]
    };
}
function $d8e38307ea8d81f1$export$ba7973148a2484ee(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "readable_name": value.readableName,
        "logo": value.logo,
        "country": value.country,
        "website": value.website,
        "portal": value.portal,
        "phone": value.phone,
        "address": value.address,
        "additional_territories": value.additionalTerritories,
        "form_email": value.formEmail,
        "form_postal_address": value.formPostalAddress,
        "form_portal": value.formPortal,
        "form_reminder_frequency": value.formReminderFrequency,
        "form_stop_reminder_frequency": value.formStopReminderFrequency,
        "form_reminder_send_to": value.formReminderSendTo,
        "tax_forms": value.taxForms,
        "role_forms": value.roleForms,
        "contact_information": value.contactInformation
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $a9fc1541310e50b9$export$52cce691c2b73aac(value) {
    let isInstance = true;
    return isInstance;
}
function $a9fc1541310e50b9$export$7cb07a03442ce417(json) {
    return $a9fc1541310e50b9$export$dcdfbafadf5fc20b(json, false);
}
function $a9fc1541310e50b9$export$dcdfbafadf5fc20b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "registeredArtistName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "registered_artist_name") ? undefined : json["registered_artist_name"],
        "accountId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "account_id") ? undefined : json["account_id"],
        "username": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "username") ? undefined : json["username"],
        "password": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"]
    };
}
function $a9fc1541310e50b9$export$17b7e1e566d9de7b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "registered_artist_name": value.registeredArtistName,
        "account_id": value.accountId,
        "username": value.username,
        "password": value.password
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $200e49f2387423dc$export$af9922444e5ea4df(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "manualStageName" in value;
    return isInstance;
}
function $200e49f2387423dc$export$de3312126358ad1b(json) {
    return $200e49f2387423dc$export$12ff67a9a9ee4bbb(json, false);
}
function $200e49f2387423dc$export$12ff67a9a9ee4bbb(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "stageName": json["stageName"],
        "manualStageName": json["manualStageName"],
        "type": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "type") ? undefined : json["type"],
        "sourceIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_ids") ? undefined : json["source_ids"],
        "createdBySystem": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "created_by_system") ? undefined : json["created_by_system"]
    };
}
function $200e49f2387423dc$export$b2d253b70c9bb204(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "stageName": value.stageName,
        "manualStageName": value.manualStageName,
        "created_by_system": value.createdBySystem
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $7cdb0d939b53e081$export$7205bd91d21b4979(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "originalName" in value;
    isInstance = isInstance && "valid" in value;
    isInstance = isInstance && "rejected" in value;
    isInstance = isInstance && "approved" in value;
    return isInstance;
}
function $7cdb0d939b53e081$export$d9e25686001f2742(json) {
    return $7cdb0d939b53e081$export$38ef969bb2c308de(json, false);
}
function $7cdb0d939b53e081$export$38ef969bb2c308de(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "originalName": json["original_name"],
        "valid": json["valid"],
        "rejected": json["rejected"],
        "approved": json["approved"]
    };
}
function $7cdb0d939b53e081$export$37ffb56edfd492cf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "original_name": value.originalName,
        "valid": value.valid,
        "rejected": value.rejected,
        "approved": value.approved
    };
}


function $61fc73cc4838f4b6$export$db7c7857bac25e08(value) {
    let isInstance = true;
    return isInstance;
}
function $61fc73cc4838f4b6$export$bad647ae283e1232(json) {
    return $61fc73cc4838f4b6$export$43efb3b11b381d99(json, false);
}
function $61fc73cc4838f4b6$export$43efb3b11b381d99(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "spotify": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "spotify") ? undefined : json["spotify"].map((0, $7cdb0d939b53e081$export$d9e25686001f2742)),
        "discogs": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "discogs") ? undefined : json["discogs"].map((0, $7cdb0d939b53e081$export$d9e25686001f2742)),
        "musicbrainz": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "musicbrainz") ? undefined : json["musicbrainz"].map((0, $7cdb0d939b53e081$export$d9e25686001f2742)),
        "deezer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "deezer") ? undefined : json["deezer"].map((0, $7cdb0d939b53e081$export$d9e25686001f2742))
    };
}
function $61fc73cc4838f4b6$export$c32a04e7e7f6ff5e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "spotify": value.spotify === undefined ? undefined : value.spotify.map((0, $7cdb0d939b53e081$export$37ffb56edfd492cf)),
        "discogs": value.discogs === undefined ? undefined : value.discogs.map((0, $7cdb0d939b53e081$export$37ffb56edfd492cf)),
        "musicbrainz": value.musicbrainz === undefined ? undefined : value.musicbrainz.map((0, $7cdb0d939b53e081$export$37ffb56edfd492cf)),
        "deezer": value.deezer === undefined ? undefined : value.deezer.map((0, $7cdb0d939b53e081$export$37ffb56edfd492cf))
    };
}


function $8e361260624ef50d$export$d0721c4dd349c332(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "sourceIds" in value;
    return isInstance;
}
function $8e361260624ef50d$export$a5ecc37db9229dd(json) {
    return $8e361260624ef50d$export$bfbade2437273767(json, false);
}
function $8e361260624ef50d$export$bfbade2437273767(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"],
        "manualStageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "manualStageName") ? undefined : json["manualStageName"],
        "sourceIds": (0, $61fc73cc4838f4b6$export$bad647ae283e1232)(json["source_ids"])
    };
}
function $8e361260624ef50d$export$bafacef4a71b87cf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "manualStageName": value.manualStageName,
        "source_ids": (0, $61fc73cc4838f4b6$export$c32a04e7e7f6ff5e)(value.sourceIds)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

function $858970a27fda4408$export$7efe97ea99a6c615(value) {
    let isInstance = true;
    return isInstance;
}
function $858970a27fda4408$export$325568ae6d37a9e6(json) {
    return $858970a27fda4408$export$91909ad5edab4e05(json, false);
}
function $858970a27fda4408$export$91909ad5edab4e05(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "stageName") ? undefined : json["stageName"],
        "manualStageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "manualStageName") ? undefined : json["manualStageName"],
        "sourceIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_ids") ? undefined : (0, $61fc73cc4838f4b6$export$bad647ae283e1232)(json["source_ids"])
    };
}
function $858970a27fda4408$export$963c340a545e1cd9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "manualStageName": value.manualStageName,
        "source_ids": (0, $61fc73cc4838f4b6$export$c32a04e7e7f6ff5e)(value.sourceIds)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $17df32d0173c8ccd$export$94517982e4fca259(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "manualStageName" in value;
    return isInstance;
}
function $17df32d0173c8ccd$export$8415477e7eaee55b(json) {
    return $17df32d0173c8ccd$export$d2ec52bef3684ed4(json, false);
}
function $17df32d0173c8ccd$export$d2ec52bef3684ed4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "stageName": json["stageName"],
        "manualStageName": json["manualStageName"],
        "type": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "type") ? undefined : json["type"],
        "sourceIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_ids") ? undefined : json["source_ids"],
        "isPermanentMember": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_permanent_member") ? undefined : json["is_permanent_member"],
        "isMainPerformer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_main_performer") ? undefined : json["is_main_performer"],
        "linkedAliasId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "linked_alias_id") ? undefined : json["linked_alias_id"],
        "linkedAliases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "linked_aliases") ? undefined : json["linked_aliases"],
        "createdBySystem": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "created_by_system") ? undefined : json["created_by_system"]
    };
}
function $17df32d0173c8ccd$export$c3077934757f0d4d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "stageName": value.stageName,
        "manualStageName": value.manualStageName
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

function $a7d0c0ae82c3bf9c$export$da680c4ac19a142(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "sourceIds" in value;
    return isInstance;
}
function $a7d0c0ae82c3bf9c$export$3f6f49e7b696bac7(json) {
    return $a7d0c0ae82c3bf9c$export$7593260e111df18d(json, false);
}
function $a7d0c0ae82c3bf9c$export$7593260e111df18d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"],
        "manualStageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "manualStageName") ? undefined : json["manualStageName"],
        "sourceIds": (0, $61fc73cc4838f4b6$export$bad647ae283e1232)(json["source_ids"]),
        "isPermanentMember": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_permanent_member") ? undefined : json["is_permanent_member"],
        "isMainPerformer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_main_performer") ? undefined : json["is_main_performer"],
        "linkedAliasId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "linked_alias_id") ? undefined : json["linked_alias_id"]
    };
}
function $a7d0c0ae82c3bf9c$export$ec34e221180ae073(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "manualStageName": value.manualStageName,
        "source_ids": (0, $61fc73cc4838f4b6$export$c32a04e7e7f6ff5e)(value.sourceIds),
        "is_permanent_member": value.isPermanentMember,
        "is_main_performer": value.isMainPerformer,
        "linked_alias_id": value.linkedAliasId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

function $c84cccdbe293806e$export$ac76fb12af3800ec(value) {
    let isInstance = true;
    return isInstance;
}
function $c84cccdbe293806e$export$5cd5eabb05ff8362(json) {
    return $c84cccdbe293806e$export$e4bfefafc3215ba1(json, false);
}
function $c84cccdbe293806e$export$e4bfefafc3215ba1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "stageName") ? undefined : json["stageName"],
        "manualStageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "manualStageName") ? undefined : json["manualStageName"],
        "sourceIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_ids") ? undefined : (0, $61fc73cc4838f4b6$export$bad647ae283e1232)(json["source_ids"]),
        "isPermanentMember": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_permanent_member") ? undefined : json["is_permanent_member"],
        "isMainPerformer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_main_performer") ? undefined : json["is_main_performer"],
        "linkedAliasId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "linked_alias_id") ? undefined : json["linked_alias_id"]
    };
}
function $c84cccdbe293806e$export$6f95b4e96077f462(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "manualStageName": value.manualStageName,
        "source_ids": (0, $61fc73cc4838f4b6$export$c32a04e7e7f6ff5e)(value.sourceIds),
        "is_permanent_member": value.isPermanentMember,
        "is_main_performer": value.isMainPerformer,
        "linked_alias_id": value.linkedAliasId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $2d99ff3b3060a0c1$export$9ef6494467177d21(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "allNames" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $2d99ff3b3060a0c1$export$e4f27606a6d6c163(json) {
    return $2d99ff3b3060a0c1$export$18b8add634fdcef9(json, false);
}
function $2d99ff3b3060a0c1$export$18b8add634fdcef9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "allNames": json["allNames"],
        "stageName": json["stageName"]
    };
}
function $2d99ff3b3060a0c1$export$eea3d6a45d09ebc4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "allNames": value.allNames,
        "stageName": value.stageName
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $7d0d21cc7dd025f2$export$19fb4ec487137b7f = {
    Queued: "QUEUED",
    NotStarted: "NOT_STARTED",
    Managed: "MANAGED",
    Starting: "STARTING",
    Started: "STARTED",
    Success: "SUCCESS",
    Failure: "FAILURE",
    Canceling: "CANCELING",
    Canceled: "CANCELED"
};
const $7d0d21cc7dd025f2$export$1d2b0362b520f55d = {
    Launching: "LAUNCHING",
    Starting: "STARTING",
    Running: "RUNNING",
    Succeeded: "SUCCEEDED",
    Failed: "FAILED",
    Cancelling: "CANCELLING",
    Cancelled: "CANCELLED"
};
function $7d0d21cc7dd025f2$export$8ccc5db400050d0(value) {
    let isInstance = true;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
function $7d0d21cc7dd025f2$export$254fa118bbd0804(json) {
    return $7d0d21cc7dd025f2$export$cd155ba490d93b40(json, false);
}
function $7d0d21cc7dd025f2$export$cd155ba490d93b40(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "runId": json["run_id"],
        "status": json["status"],
        "phase": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phase") ? undefined : json["phase"],
        "source": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source") ? undefined : json["source"],
        "sourceId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_id") ? undefined : json["source_id"],
        "isStalled": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_stalled") ? undefined : json["is_stalled"],
        "errorDetail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "error_detail") ? undefined : json["error_detail"],
        "requestedAt": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "requested_at") ? undefined : json["requested_at"] === null ? null : new Date(json["requested_at"]),
        "lastProgressAt": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_progress_at") ? undefined : json["last_progress_at"] === null ? null : new Date(json["last_progress_at"])
    };
}
function $7d0d21cc7dd025f2$export$903b1c8353b38ea7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "run_id": value.runId,
        "status": value.status,
        "phase": value.phase,
        "source": value.source,
        "source_id": value.sourceId,
        "is_stalled": value.isStalled,
        "error_detail": value.errorDetail,
        "requested_at": value.requestedAt === undefined ? undefined : value.requestedAt === null ? null : value.requestedAt.toISOString(),
        "last_progress_at": value.lastProgressAt === undefined ? undefined : value.lastProgressAt === null ? null : value.lastProgressAt.toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $2014e54837d099b2$export$d3c58661658cafa3(value) {
    let isInstance = true;
    isInstance = isInstance && "valid" in value;
    return isInstance;
}
function $2014e54837d099b2$export$49d2792eb8b6404d(json) {
    return $2014e54837d099b2$export$40ee61ec00dc6c74(json, false);
}
function $2014e54837d099b2$export$40ee61ec00dc6c74(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "valid": json["valid"],
        "rejected": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "rejected") ? undefined : json["rejected"],
        "approved": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "approved") ? undefined : json["approved"]
    };
}
function $2014e54837d099b2$export$1d6a3c915367a0a7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "valid": value.valid,
        "rejected": value.rejected,
        "approved": value.approved
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $a674df4c16092127$export$497a39e06bd33d11(value) {
    let isInstance = true;
    return isInstance;
}
function $a674df4c16092127$export$fb097d39fc6e1ac2(json) {
    return $a674df4c16092127$export$984c63475e45e3b5(json, false);
}
function $a674df4c16092127$export$984c63475e45e3b5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "collectedIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "collected_ids") ? undefined : json["collected_ids"]
    };
}
function $a674df4c16092127$export$da5fc93c4f710318(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {};
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $d11314fef71eb4d7$export$30fd950816532c7c(value) {
    let isInstance = true;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "values" in value;
    return isInstance;
}
function $d11314fef71eb4d7$export$e684c7630af2398f(json) {
    return $d11314fef71eb4d7$export$f94abba94ca3791b(json, false);
}
function $d11314fef71eb4d7$export$f94abba94ca3791b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "field": json["field"],
        "values": json["values"]
    };
}
function $d11314fef71eb4d7$export$3d595721aca8e248(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "field": value.field,
        "values": value.values
    };
}


function $d59d5e180f39bf3f$export$d615bc8b0e7a9854(value) {
    let isInstance = true;
    isInstance = isInstance && "availableFilters" in value;
    return isInstance;
}
function $d59d5e180f39bf3f$export$11bc36c050626697(json) {
    return $d59d5e180f39bf3f$export$f4648fe99576739d(json, false);
}
function $d59d5e180f39bf3f$export$f4648fe99576739d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "availableFilters": json["available_filters"].map((0, $d11314fef71eb4d7$export$e684c7630af2398f))
    };
}
function $d59d5e180f39bf3f$export$887fccc9f9ab13b4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "available_filters": value.availableFilters.map((0, $d11314fef71eb4d7$export$3d595721aca8e248))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $6c1e06c170fc4cb6$export$7e403d2ce072fae6(value) {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "westburyId" in value;
    isInstance = isInstance && "recordingId" in value;
    return isInstance;
}
function $6c1e06c170fc4cb6$export$6984372f859e410d(json) {
    return $6c1e06c170fc4cb6$export$972210b4863616d6(json, false);
}
function $6c1e06c170fc4cb6$export$972210b4863616d6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "success": json["success"],
        "userId": json["user_id"],
        "westburyId": json["westbury_id"],
        "recordingId": json["recording_id"],
        "errors": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"]
    };
}
function $6c1e06c170fc4cb6$export$5d30da6fdfb9e699(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "success": value.success,
        "user_id": value.userId,
        "westbury_id": value.westburyId,
        "recording_id": value.recordingId,
        "errors": value.errors
    };
}


function $e9cd8703b84308cb$export$fe8252030534019d(value) {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "results" in value;
    return isInstance;
}
function $e9cd8703b84308cb$export$e010dc4ca12a6d36(json) {
    return $e9cd8703b84308cb$export$83340da2b37b1190(json, false);
}
function $e9cd8703b84308cb$export$83340da2b37b1190(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "success": json["success"],
        "results": json["results"].map((0, $6c1e06c170fc4cb6$export$6984372f859e410d))
    };
}
function $e9cd8703b84308cb$export$f7c03de912af9a53(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "success": value.success,
        "results": value.results.map((0, $6c1e06c170fc4cb6$export$5d30da6fdfb9e699))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $0ce2545bf54e3dc4$export$5c10a1602692e07c(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $0ce2545bf54e3dc4$export$c843d8d07dbff309(json) {
    return $0ce2545bf54e3dc4$export$b645daf9cfd861ce(json, false);
}
function $0ce2545bf54e3dc4$export$b645daf9cfd861ce(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "stageName": json["stageName"],
        "_exists": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "exists") ? undefined : json["exists"]
    };
}
function $0ce2545bf54e3dc4$export$dcc9892d4d958f2e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "stageName": value.stageName,
        "exists": value._exists
    };
}


const $f17425da76593f10$export$8c60703649096ae1 = {
    Persona: "persona",
    Group: "group"
};
const $f17425da76593f10$export$a7bb8f12fdd4ad6f = {
    Add: "add",
    Replace: "replace",
    Delete: "delete"
};
const $f17425da76593f10$export$23592af683f8ce89 = {
    Fa: "fa",
    Ofa: "ofa",
    Nfa: "nfa"
};
function $f17425da76593f10$export$1304dbf5ed7afa58(value) {
    let isInstance = true;
    isInstance = isInstance && "artistId" in value;
    isInstance = isInstance && "op" in value;
    return isInstance;
}
function $f17425da76593f10$export$1e740897afb0d8eb(json) {
    return $f17425da76593f10$export$17fb4833ae596453(json, false);
}
function $f17425da76593f10$export$17fb4833ae596453(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "artistId": json["artist_id"],
        "stageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "stageName") ? undefined : json["stageName"],
        "members": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "members") ? undefined : json["members"].map((0, $0ce2545bf54e3dc4$export$c843d8d07dbff309)),
        "type": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "type") ? undefined : json["type"],
        "op": json["op"],
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"]
    };
}
function $f17425da76593f10$export$e2080f1c1748b842(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "artist_id": value.artistId,
        "stageName": value.stageName,
        "members": value.members === undefined ? undefined : value.members.map((0, $0ce2545bf54e3dc4$export$dcc9892d4d958f2e)),
        "type": value.type,
        "op": value.op,
        "featuredStatus": value.featuredStatus
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $dd235a2af97ba5e3$export$83bea5608d67cdeb = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer"
};
const $dd235a2af97ba5e3$export$c018aafac8a2eb4e = {
    Fa: "fa",
    Ofa: "ofa"
};
const $dd235a2af97ba5e3$export$58a42cb5e5d1a39 = {
    Add: "add",
    Replace: "replace"
};
function $dd235a2af97ba5e3$export$644ab5e1d9213692(value) {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $dd235a2af97ba5e3$export$15805eb489d875a4(json) {
    return $dd235a2af97ba5e3$export$90765139385be712(json, false);
}
function $dd235a2af97ba5e3$export$90765139385be712(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sourceId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_id") ? undefined : json["source_id"],
        "source": json["source"],
        "stageName": json["stageName"],
        "members": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "members") ? undefined : json["members"].map((0, $0ce2545bf54e3dc4$export$c843d8d07dbff309)),
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"],
        "op": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "op") ? undefined : json["op"]
    };
}
function $dd235a2af97ba5e3$export$9f533e8e4a2521df(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "source_id": value.sourceId,
        "source": value.source,
        "stageName": value.stageName,
        "members": value.members === undefined ? undefined : value.members.map((0, $0ce2545bf54e3dc4$export$dcc9892d4d958f2e)),
        "featuredStatus": value.featuredStatus,
        "op": value.op
    };
}


function $1bdea64bf1a03c5b$export$425712c1094b2451(value) {
    let isInstance = true;
    return isInstance;
}
function $1bdea64bf1a03c5b$export$235cc6b8c566dad1(json) {
    return $1bdea64bf1a03c5b$export$3c4043c3266edc8b(json, false);
}
function $1bdea64bf1a03c5b$export$3c4043c3266edc8b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "artistChange": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "artist_change") ? undefined : json["artist_change"].map((0, $f17425da76593f10$export$1e740897afb0d8eb)),
        "artistLink": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "artist_link") ? undefined : json["artist_link"].map((0, $dd235a2af97ba5e3$export$15805eb489d875a4))
    };
}
function $1bdea64bf1a03c5b$export$2877977973aeac90(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "artist_change": value.artistChange === undefined ? undefined : value.artistChange.map((0, $f17425da76593f10$export$e2080f1c1748b842)),
        "artist_link": value.artistLink === undefined ? undefined : value.artistLink.map((0, $dd235a2af97ba5e3$export$9f533e8e4a2521df))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $e3ea2edd51a6472b$export$d11ea903e1808876 = {
    Add: "add",
    Edit: "edit",
    Replace: "replace",
    Delete: "delete"
};
function $e3ea2edd51a6472b$export$59f4c6b5af1b0319(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $e3ea2edd51a6472b$export$50ddca925902d461(json) {
    return $e3ea2edd51a6472b$export$7e4cf299b5d146c8(json, false);
}
function $e3ea2edd51a6472b$export$7e4cf299b5d146c8(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "role": json["role"],
        "personaId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "persona_id") ? undefined : json["persona_id"],
        "dataCategory": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "data_category") ? undefined : json["data_category"],
        "sourceUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_url") ? undefined : json["source_url"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"]
    };
}
function $e3ea2edd51a6472b$export$7ec913c7784c503f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "role": value.role,
        "persona_id": value.personaId,
        "data_category": value.dataCategory,
        "source_url": value.sourceUrl,
        "notes": value.notes
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $e8c9a4c6ad9779f6$export$9318178e9ceab7dd = {
    Edit: "edit",
    Add: "add",
    Delete: "delete"
};
function $e8c9a4c6ad9779f6$export$c55a6c71994810d6(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $e8c9a4c6ad9779f6$export$28b4fc8110e21c13(json) {
    return $e8c9a4c6ad9779f6$export$196e0ed4bde00efd(json, false);
}
function $e8c9a4c6ad9779f6$export$196e0ed4bde00efd(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "field": json["field"],
        "value": json["value"]
    };
}
function $e8c9a4c6ad9779f6$export$1d6b448e8d9825ec(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "field": value.field,
        "value": value.value
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $87d23770374c5066$export$d774a81f5a2a4dab(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    return isInstance;
}
function $87d23770374c5066$export$6a104e5e9eafb100(json) {
    return $87d23770374c5066$export$f8191f1071312186(json, false);
}
function $87d23770374c5066$export$f8191f1071312186(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingId": json["recording_id"],
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"],
        "edgeId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "edge_id") ? undefined : json["edge_id"]
    };
}
function $87d23770374c5066$export$9fc725776433fabd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recording_id": value.recordingId,
        "document_id": value.documentId,
        "edge_id": value.edgeId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $3738396d617bda39$export$c1c98572f05ca98d = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer",
    Ppl: "ppl",
    Other: "other"
};
function $3738396d617bda39$export$1f163f9b72aeac25(value) {
    let isInstance = true;
    return isInstance;
}
function $3738396d617bda39$export$c64b252b916613a1(json) {
    return $3738396d617bda39$export$37e8a9d545354da5(json, false);
}
function $3738396d617bda39$export$37e8a9d545354da5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "release_id") ? undefined : json["release_id"],
        "source": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source") ? undefined : json["source"],
        "sourceId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_id") ? undefined : json["source_id"],
        "releaseTitle": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "release_title") ? undefined : json["release_title"],
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_released") ? undefined : json["date_released"],
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "release_labels") ? undefined : json["release_labels"],
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "cat_numbers") ? undefined : json["cat_numbers"],
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "media_type") ? undefined : json["media_type"],
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"]
    };
}
function $3738396d617bda39$export$3609080ee29c452(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "release_id": value.releaseId,
        "source": value.source,
        "source_id": value.sourceId,
        "release_title": value.releaseTitle,
        "date_released": value.dateReleased,
        "release_labels": value.releaseLabels,
        "cat_numbers": value.catNumbers,
        "media_type": value.mediaType,
        "format": value.format
    };
}


function $f9caafee5bcf95b2$export$7c1e527a08fcd8fb(value) {
    let isInstance = true;
    isInstance = isInstance && "recordings" in value;
    return isInstance;
}
function $f9caafee5bcf95b2$export$6ab658db91bd9409(json) {
    return $f9caafee5bcf95b2$export$d6249a66bd1ef008(json, false);
}
function $f9caafee5bcf95b2$export$d6249a66bd1ef008(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordings": json["recordings"].map((0, $87d23770374c5066$export$6a104e5e9eafb100)),
        "correct": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "correct") ? undefined : json["correct"].map((0, $e8c9a4c6ad9779f6$export$28b4fc8110e21c13)),
        "contributions": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "contributions") ? undefined : json["contributions"].map((0, $e3ea2edd51a6472b$export$50ddca925902d461)),
        "changeArtists": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "change_artists") ? undefined : (0, $1bdea64bf1a03c5b$export$235cc6b8c566dad1)(json["change_artists"]),
        "releaseLink": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "release_link") ? undefined : (0, $3738396d617bda39$export$c64b252b916613a1)(json["release_link"])
    };
}
function $f9caafee5bcf95b2$export$3ccef56b78b53caa(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordings": value.recordings.map((0, $87d23770374c5066$export$9fc725776433fabd)),
        "correct": value.correct === undefined ? undefined : value.correct.map((0, $e8c9a4c6ad9779f6$export$1d6b448e8d9825ec)),
        "contributions": value.contributions === undefined ? undefined : value.contributions.map((0, $e3ea2edd51a6472b$export$7ec913c7784c503f)),
        "change_artists": (0, $1bdea64bf1a03c5b$export$2877977973aeac90)(value.changeArtists),
        "release_link": (0, $3738396d617bda39$export$3609080ee29c452)(value.releaseLink)
    };
}


function $edf8bbf08faf3a1c$export$93aa182af0398350(value) {
    let isInstance = true;
    isInstance = isInstance && "bulkEdit" in value;
    return isInstance;
}
function $edf8bbf08faf3a1c$export$97fce2f899625a27(json) {
    return $edf8bbf08faf3a1c$export$1a3d4b8290895cf4(json, false);
}
function $edf8bbf08faf3a1c$export$1a3d4b8290895cf4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "bulkEdit": (0, $f9caafee5bcf95b2$export$6ab658db91bd9409)(json["bulk_edit"]),
        "eventTime": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "event_time") ? undefined : json["event_time"],
        "userId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_id") ? undefined : json["user_id"],
        "westburyId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"]
    };
}
function $edf8bbf08faf3a1c$export$7d65401c95d547d6(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bulk_edit": (0, $f9caafee5bcf95b2$export$3ccef56b78b53caa)(value.bulkEdit),
        "event_time": value.eventTime,
        "user_id": value.userId,
        "westbury_id": value.westburyId
    };
}










/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $2069fc904d1c868b$export$7b2349dd0895bd0f(value) {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "message" in value;
    return isInstance;
}
function $2069fc904d1c868b$export$1f932224b02ab790(json) {
    return $2069fc904d1c868b$export$3ba7d4002f29af04(json, false);
}
function $2069fc904d1c868b$export$3ba7d4002f29af04(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "op") ? undefined : json["op"],
        "code": json["code"],
        "message": json["message"]
    };
}
function $2069fc904d1c868b$export$7237bbbfdb296d9f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "code": value.code,
        "message": value.message
    };
}


const $32fd5bfb7b2b52ac$export$4bdb101372bcbaef = {
    Succeeded: "succeeded",
    Failed: "failed"
};
function $32fd5bfb7b2b52ac$export$cc929709e6c48f3f(value) {
    let isInstance = true;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
function $32fd5bfb7b2b52ac$export$33d9f360f213a2a5(json) {
    return $32fd5bfb7b2b52ac$export$7434613bb5bf21a0(json, false);
}
function $32fd5bfb7b2b52ac$export$7434613bb5bf21a0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "action": json["action"],
        "status": json["status"],
        "error": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "error") ? undefined : (0, $2069fc904d1c868b$export$1f932224b02ab790)(json["error"])
    };
}
function $32fd5bfb7b2b52ac$export$901d13523db25f1a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "action": value.action,
        "status": value.status,
        "error": (0, $2069fc904d1c868b$export$7237bbbfdb296d9f)(value.error)
    };
}


const $5213afeeb3d6213a$export$d855b53d32f857b6 = {
    Succeeded: "succeeded",
    Partial: "partial",
    Failed: "failed"
};
function $5213afeeb3d6213a$export$36446007832fb1cd(value) {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "results" in value;
    return isInstance;
}
function $5213afeeb3d6213a$export$12239a6bda795ffc(json) {
    return $5213afeeb3d6213a$export$5086dd4371d9a14f(json, false);
}
function $5213afeeb3d6213a$export$5086dd4371d9a14f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "status": json["status"],
        "results": json["results"].map((0, $32fd5bfb7b2b52ac$export$33d9f360f213a2a5))
    };
}
function $5213afeeb3d6213a$export$353e97672b13fa6a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "status": value.status,
        "results": value.results.map((0, $32fd5bfb7b2b52ac$export$901d13523db25f1a))
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $52cb4e753ea2e79a$export$9e42fc58eda8364e = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer",
    Ppl: "ppl"
};
function $52cb4e753ea2e79a$export$17ac2acff76447b7(value) {
    let isInstance = true;
    isInstance = isInstance && "sourceId" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "recordingIds" in value;
    return isInstance;
}
function $52cb4e753ea2e79a$export$6bfff8528329ac30(json) {
    return $52cb4e753ea2e79a$export$cec990412c0172cc(json, false);
}
function $52cb4e753ea2e79a$export$cec990412c0172cc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sourceId": json["source_id"],
        "source": json["source"],
        "recordingIds": json["recording_ids"]
    };
}
function $52cb4e753ea2e79a$export$17caed5444512236(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "source_id": value.sourceId,
        "source": value.source,
        "recording_ids": value.recordingIds
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $6db1a3aebda263a6$export$f9846d3e360e48d1(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    return isInstance;
}
function $6db1a3aebda263a6$export$ca8ade34da234739(json) {
    return $6db1a3aebda263a6$export$b4a5f36d3623e10(json, false);
}
function $6db1a3aebda263a6$export$b4a5f36d3623e10(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingId": json["recording_id"],
        "edgeId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "edge_id") ? undefined : json["edge_id"]
    };
}
function $6db1a3aebda263a6$export$77c15c0928b150dd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recording_id": value.recordingId,
        "edge_id": value.edgeId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f4f7ba52c2c02d55$export$27281236f54e7d85(value) {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "releaseTitle" in value;
    return isInstance;
}
function $f4f7ba52c2c02d55$export$d31931daed72dc64(json) {
    return $f4f7ba52c2c02d55$export$757e24e85191ebe6(json, false);
}
function $f4f7ba52c2c02d55$export$757e24e85191ebe6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseId": json["release_id"],
        "releaseTitle": json["releaseTitle"],
        "edgeId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "edge_id") ? undefined : json["edge_id"],
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : json["dateReleased"],
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : json["releaseLabels"],
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : json["catNumbers"],
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : json["mediaType"],
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"]
    };
}
function $f4f7ba52c2c02d55$export$f55578efae5f4799(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "release_id": value.releaseId,
        "releaseTitle": value.releaseTitle,
        "edge_id": value.edgeId,
        "dateReleased": value.dateReleased,
        "releaseLabels": value.releaseLabels,
        "catNumbers": value.catNumbers,
        "mediaType": value.mediaType,
        "format": value.format
    };
}


function $6c384c2cb513cd70$export$e0e440b41e25f39(value) {
    let isInstance = true;
    isInstance = isInstance && "payload" in value;
    isInstance = isInstance && "recordings" in value;
    return isInstance;
}
function $6c384c2cb513cd70$export$6a84cd4a872abfc5(json) {
    return $6c384c2cb513cd70$export$6ec2d7890078b03f(json, false);
}
function $6c384c2cb513cd70$export$6ec2d7890078b03f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "payload": (0, $f4f7ba52c2c02d55$export$d31931daed72dc64)(json["payload"]),
        "recordings": json["recordings"].map((0, $6db1a3aebda263a6$export$ca8ade34da234739))
    };
}
function $6c384c2cb513cd70$export$82c0f2102ccdfe23(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "payload": (0, $f4f7ba52c2c02d55$export$f55578efae5f4799)(value.payload),
        "recordings": value.recordings.map((0, $6db1a3aebda263a6$export$77c15c0928b150dd))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $a04c835e01d8d3bc$export$4dc81c4391b9c0e1(value) {
    let isInstance = true;
    return isInstance;
}
function $a04c835e01d8d3bc$export$f84a279feeaa00bd(json) {
    return $a04c835e01d8d3bc$export$98c8f2050c371bfc(json, false);
}
function $a04c835e01d8d3bc$export$98c8f2050c371bfc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_ids") ? undefined : json["document_ids"],
        "recordingIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "recording_ids") ? undefined : json["recording_ids"]
    };
}
function $a04c835e01d8d3bc$export$5693fd5a32218080(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_ids": value.documentIds,
        "recording_ids": value.recordingIds
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $495b364fdf49527b$export$8887609119abb24e(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "hasManualChanges" in value;
    return isInstance;
}
function $495b364fdf49527b$export$28759d02fd947e48(json) {
    return $495b364fdf49527b$export$b5ce896ccdc2a5d7(json, false);
}
function $495b364fdf49527b$export$b5ce896ccdc2a5d7(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"],
        "recordingId": json["recording_id"],
        "hasManualChanges": json["hasManualChanges"]
    };
}
function $495b364fdf49527b$export$d136bb51e38423f0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_id": value.documentId,
        "recording_id": value.recordingId,
        "hasManualChanges": value.hasManualChanges
    };
}


function $bbb15486918e6a4b$export$4468ac8b87705b09(value) {
    let isInstance = true;
    isInstance = isInstance && "recordings" in value;
    return isInstance;
}
function $bbb15486918e6a4b$export$eb33a474a4a19660(json) {
    return $bbb15486918e6a4b$export$fc44b68ebe20a80a(json, false);
}
function $bbb15486918e6a4b$export$fc44b68ebe20a80a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordings": json["recordings"].map((0, $495b364fdf49527b$export$28759d02fd947e48))
    };
}
function $bbb15486918e6a4b$export$3021c08b3a37f0e7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordings": value.recordings.map((0, $495b364fdf49527b$export$d136bb51e38423f0))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $19c922af6379aa7e$export$97e70b6f4fdd40d8 = {
    Persona: "persona",
    Group: "group"
};
const $19c922af6379aa7e$export$5b356edc00d5e9f9 = {
    Add: "add",
    Delete: "delete"
};
const $19c922af6379aa7e$export$11aacb388fbad6d6 = {
    Fa: "fa",
    Ofa: "ofa",
    Nfa: "nfa"
};
function $19c922af6379aa7e$export$d2538e7462e79576(value) {
    let isInstance = true;
    isInstance = isInstance && "artistId" in value;
    isInstance = isInstance && "op" in value;
    return isInstance;
}
function $19c922af6379aa7e$export$6037f4360c1556b8(json) {
    return $19c922af6379aa7e$export$f7f0f4008d84b4c0(json, false);
}
function $19c922af6379aa7e$export$f7f0f4008d84b4c0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "artistId": json["artist_id"],
        "stageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "stageName") ? undefined : json["stageName"],
        "members": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "members") ? undefined : json["members"].map((0, $0ce2545bf54e3dc4$export$c843d8d07dbff309)),
        "type": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "type") ? undefined : json["type"],
        "op": json["op"],
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"]
    };
}
function $19c922af6379aa7e$export$887cf28ba24452a0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "artist_id": value.artistId,
        "stageName": value.stageName,
        "members": value.members === undefined ? undefined : value.members.map((0, $0ce2545bf54e3dc4$export$dcc9892d4d958f2e)),
        "type": value.type,
        "op": value.op,
        "featuredStatus": value.featuredStatus
    };
}


function $f644235c455de382$export$87688611e7e7d815(value) {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;
    return isInstance;
}
function $f644235c455de382$export$20c0dff3a58b0d20(json) {
    return $f644235c455de382$export$88bf367a9f59b43c(json, false);
}
function $f644235c455de382$export$88bf367a9f59b43c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "edits": json["edits"].map((0, $19c922af6379aa7e$export$6037f4360c1556b8)),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $f644235c455de382$export$62a3f99c3f3cd78f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "edits": value.edits.map((0, $19c922af6379aa7e$export$887cf28ba24452a0)),
        "document_id": value.documentId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $4ba4f806015061e3$export$28b9d07f58452a32 = {
    ClientToSign: "client_to_sign",
    WitnessToSign: "witness_to_sign",
    AdminToApprove: "admin_to_approve",
    Approved: "approved"
};
function $4ba4f806015061e3$export$750496f6709c0771(value) {
    let isInstance = true;
    isInstance = isInstance && "societyFormId" in value;
    isInstance = isInstance && "societyFormName" in value;
    return isInstance;
}
function $4ba4f806015061e3$export$7fa8d9ea09641068(json) {
    return $4ba4f806015061e3$export$7b55d98a6fa563c(json, false);
}
function $4ba4f806015061e3$export$7b55d98a6fa563c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "societyFormId": json["society_form_id"],
        "societyFormName": json["society_form_name"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "dateCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsDocumentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsSessionId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"]
    };
}
function $4ba4f806015061e3$export$1f4009bc54aefa3f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_form_id": value.societyFormId,
        "society_form_name": value.societyFormName,
        "status": value.status,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_session_id": value.pandadocsSessionId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $6dc28d3f3ac0dd34$export$e6afaa361fadb0c8 = {
    Pending: "pending",
    Approved: "approved",
    Active: "active",
    Rejected: "rejected",
    Inactive: "inactive"
};
const $6dc28d3f3ac0dd34$export$739b189f651fd128 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $6dc28d3f3ac0dd34$export$3fa4a3945f132dd6 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
const $6dc28d3f3ac0dd34$export$b26b5ed05ded7ba2 = {
    PerformerProducer: "Performer/Producer"
};
function $6dc28d3f3ac0dd34$export$7a2c11552836701(value) {
    let isInstance = true;
    return isInstance;
}
function $6dc28d3f3ac0dd34$export$1e7456cf69e13b13(json) {
    return $6dc28d3f3ac0dd34$export$d5c3184a11e23822(json, false);
}
function $6dc28d3f3ac0dd34$export$d5c3184a11e23822(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "aliases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "userPhoto": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "verifiedStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "verified_status") ? undefined : json["verified_status"],
        "signedStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "signed_status") ? undefined : json["signed_status"],
        "accountStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "account_status") ? undefined : json["account_status"],
        "title": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "nonClient": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "non_client") ? undefined : json["non_client"],
        "dateOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "nationality": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "department": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "taxationCountry": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "witnessFirstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "registeredWithPpl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "registered_with_ppl") ? undefined : json["registered_with_ppl"],
        "pplAccountName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_account_name") ? undefined : json["ppl_account_name"],
        "pplPerformerName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "clientEmailHashed": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "client_email_hashed") ? undefined : json["client_email_hashed"],
        "westburyId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"],
        "discogsIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "discogs_ids") ? undefined : json["discogs_ids"],
        "musicbrainzIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "musicbrainz_ids") ? undefined : json["musicbrainz_ids"],
        "deezerIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "deezer_ids") ? undefined : json["deezer_ids"],
        "spotifyIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "spotify_ids") ? undefined : json["spotify_ids"],
        "performerOrProducer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "masterRights": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "masterFullname": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "masterEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "masterName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "completedOnboardingSteps": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "completed_onboarding_steps") ? undefined : json["completed_onboarding_steps"]
    };
}
function $6dc28d3f3ac0dd34$export$29794e5965fd3174(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aliases": value.aliases,
        "user_photo": value.userPhoto,
        "account_status": value.accountStatus,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "non_client": value.nonClient,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "nationality": value.nationality,
        "department": value.department,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "role": value.role,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_account_name": value.pplAccountName,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "notes": value.notes,
        "client_email_hashed": value.clientEmailHashed,
        "discogs_ids": value.discogsIds,
        "musicbrainz_ids": value.musicbrainzIds,
        "deezer_ids": value.deezerIds,
        "spotify_ids": value.spotifyIds,
        "performer_or_producer": value.performerOrProducer,
        "master_rights": value.masterRights,
        "master_fullname": value.masterFullname,
        "master_email": value.masterEmail,
        "master_name": value.masterName,
        "master_id": value.masterId
    };
}


function $4c7d46b022e853c3$export$dfc1b041ad39eb2(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "userSettings" in value;
    return isInstance;
}
function $4c7d46b022e853c3$export$2965aa33e1f71909(json) {
    return $4c7d46b022e853c3$export$6d58806ed1473f0c(json, false);
}
function $4c7d46b022e853c3$export$6d58806ed1473f0c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "username": json["username"],
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "isActive": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_active") ? undefined : json["is_active"],
        "isStaff": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_staff") ? undefined : json["is_staff"],
        "isSuperuser": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_superuser") ? undefined : json["is_superuser"],
        "dateJoined": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_joined") ? undefined : new Date(json["date_joined"]),
        "userSettings": (0, $6dc28d3f3ac0dd34$export$1e7456cf69e13b13)(json["user_settings"])
    };
}
function $4c7d46b022e853c3$export$3e0ad55966ab95f2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username,
        "email": value.email,
        "first_name": value.firstName,
        "last_name": value.lastName,
        "is_active": value.isActive,
        "is_staff": value.isStaff,
        "is_superuser": value.isSuperuser,
        "date_joined": value.dateJoined === undefined ? undefined : value.dateJoined.toISOString(),
        "user_settings": (0, $6dc28d3f3ac0dd34$export$29794e5965fd3174)(value.userSettings)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $efcc97191860bc0f$export$8117966722cb1af4(value) {
    let isInstance = true;
    return isInstance;
}
function $efcc97191860bc0f$export$2c4b7a78fa17d58c(json) {
    return $efcc97191860bc0f$export$3e6f510d9f087732(json, false);
}
function $efcc97191860bc0f$export$3e6f510d9f087732(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "companySettings": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "company_settings") ? undefined : json["company_settings"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "bankAccountName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_name") ? undefined : json["bank_account_name"],
        "bankAccountNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_number") ? undefined : json["bank_account_number"],
        "bankSortCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_sort_code") ? undefined : json["bank_sort_code"],
        "bankName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_name") ? undefined : json["bank_name"],
        "bankAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_address") ? undefined : json["bank_address"],
        "bankPostcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_postcode") ? undefined : json["bank_postcode"],
        "bankIban": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_iban") ? undefined : json["bank_iban"],
        "bankRoutingCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_routing_code") ? undefined : json["bank_routing_code"],
        "bankAccountHoldingBranch": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_holding_branch") ? undefined : json["bank_account_holding_branch"],
        "bankBicSwiftCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_bic_swift_code") ? undefined : json["bank_bic_swift_code"]
    };
}
function $efcc97191860bc0f$export$8b2c9c261e20bd82(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_account_name": value.bankAccountName,
        "bank_account_number": value.bankAccountNumber,
        "bank_sort_code": value.bankSortCode,
        "bank_name": value.bankName,
        "bank_address": value.bankAddress,
        "bank_postcode": value.bankPostcode,
        "bank_iban": value.bankIban,
        "bank_routing_code": value.bankRoutingCode,
        "bank_account_holding_branch": value.bankAccountHoldingBranch,
        "bank_bic_swift_code": value.bankBicSwiftCode
    };
}


function $95fd235e640117ca$export$ee0ed55aa24021b0(value) {
    let isInstance = true;
    return isInstance;
}
function $95fd235e640117ca$export$d314b1c0073cad92(json) {
    return $95fd235e640117ca$export$317d8047b96f327e(json, false);
}
function $95fd235e640117ca$export$317d8047b96f327e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "logoImageUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo_image_url") ? undefined : json["logo_image_url"],
        "bankDetails": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_details") ? undefined : (0, $efcc97191860bc0f$export$2c4b7a78fa17d58c)(json["bank_details"]),
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "name") ? undefined : json["name"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "emailAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress1": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address_1") ? undefined : json["street_address_1"],
        "streetAddress2": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address_2") ? undefined : json["street_address_2"],
        "county": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "marketingUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "marketing_url") ? undefined : json["marketing_url"]
    };
}
function $95fd235e640117ca$export$39a06be5b130d148(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_details": (0, $efcc97191860bc0f$export$8b2c9c261e20bd82)(value.bankDetails),
        "name": value.name,
        "first_name": value.firstName,
        "last_name": value.lastName,
        "phone_number": value.phoneNumber,
        "email_address": value.emailAddress,
        "street_address_1": value.streetAddress1,
        "street_address_2": value.streetAddress2,
        "county": value.county,
        "postcode": value.postcode,
        "country": value.country,
        "marketing_url": value.marketingUrl
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $027fc6fe27703f6a$export$a6fc8a17f4d02aa4(value) {
    let isInstance = true;
    return isInstance;
}
function $027fc6fe27703f6a$export$a42a5e5dd8a78937(json) {
    return $027fc6fe27703f6a$export$f26a1bc61ff692c8(json, false);
}
function $027fc6fe27703f6a$export$f26a1bc61ff692c8(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "form": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form") ? undefined : json["form"]
    };
}
function $027fc6fe27703f6a$export$ec7aea5503b3d659(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "form": value.form
    };
}


const $3ce93da8cb25ff1e$export$2d1bc06ecaa9f94f = {
    PerformerProducer: "Performer/Producer"
};
function $3ce93da8cb25ff1e$export$948a932809db3b3d(value) {
    let isInstance = true;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $3ce93da8cb25ff1e$export$733199e1c2ff01bf(json) {
    return $3ce93da8cb25ff1e$export$cf3438780879a428(json, false);
}
function $3ce93da8cb25ff1e$export$cf3438780879a428(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "role": json["role"],
        "forms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "forms") ? undefined : json["forms"].map((0, $027fc6fe27703f6a$export$a42a5e5dd8a78937))
    };
}
function $3ce93da8cb25ff1e$export$da1981000df273eb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "role": value.role,
        "forms": value.forms === undefined ? undefined : value.forms.map((0, $027fc6fe27703f6a$export$ec7aea5503b3d659))
    };
}


function $d3307ed07f4a305a$export$a814cbad36d2740a(value) {
    let isInstance = true;
    isInstance = isInstance && "companyInformation" in value;
    isInstance = isInstance && "roleForms" in value;
    return isInstance;
}
function $d3307ed07f4a305a$export$f608b396a48b017d(json) {
    return $d3307ed07f4a305a$export$1be76b7e332e70ea(json, false);
}
function $d3307ed07f4a305a$export$1be76b7e332e70ea(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "companyInformation": (0, $95fd235e640117ca$export$d314b1c0073cad92)(json["company_information"]),
        "roleForms": json["role_forms"].map((0, $3ce93da8cb25ff1e$export$733199e1c2ff01bf)),
        "societyForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society_forms") ? undefined : json["society_forms"].map((0, $27e4b52526fc9e58$export$1c504095e8fb3130))
    };
}
function $d3307ed07f4a305a$export$8fe7696865cf5926(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "company_information": (0, $95fd235e640117ca$export$39a06be5b130d148)(value.companyInformation),
        "role_forms": value.roleForms.map((0, $3ce93da8cb25ff1e$export$da1981000df273eb)),
        "society_forms": value.societyForms === undefined ? undefined : value.societyForms.map((0, $27e4b52526fc9e58$export$6f4fbe925053dc34))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $acabe406dbdcaf5a$export$a57988bf603f230f = {
    PerformerProducer: "Performer/Producer"
};
function $acabe406dbdcaf5a$export$9857938bc8374bfc(value) {
    let isInstance = true;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $acabe406dbdcaf5a$export$7f857026a8161ae1(json) {
    return $acabe406dbdcaf5a$export$49d302df4fd0ff12(json, false);
}
function $acabe406dbdcaf5a$export$49d302df4fd0ff12(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "role": json["role"],
        "forms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "forms") ? undefined : json["forms"].map((0, $027fc6fe27703f6a$export$a42a5e5dd8a78937))
    };
}
function $acabe406dbdcaf5a$export$1a47cbea4491e9de(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "role": value.role,
        "forms": value.forms === undefined ? undefined : value.forms.map((0, $027fc6fe27703f6a$export$ec7aea5503b3d659))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

function $5f4c773999e6de59$export$abbbb6a4d65f6936(value) {
    let isInstance = true;
    return isInstance;
}
function $5f4c773999e6de59$export$e960ee84a5e4df2c(json) {
    return $5f4c773999e6de59$export$94cd320b6de38fa5(json, false);
}
function $5f4c773999e6de59$export$94cd320b6de38fa5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "logoImageUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo_image_url") ? undefined : json["logo_image_url"],
        "bankDetails": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_details") ? undefined : (0, $efcc97191860bc0f$export$2c4b7a78fa17d58c)(json["bank_details"]),
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "name") ? undefined : json["name"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "emailAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress1": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address_1") ? undefined : json["street_address_1"],
        "streetAddress2": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address_2") ? undefined : json["street_address_2"],
        "county": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "marketingUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "marketing_url") ? undefined : json["marketing_url"]
    };
}
function $5f4c773999e6de59$export$a29fffe331f63309(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_details": (0, $efcc97191860bc0f$export$8b2c9c261e20bd82)(value.bankDetails),
        "name": value.name,
        "first_name": value.firstName,
        "last_name": value.lastName,
        "phone_number": value.phoneNumber,
        "email_address": value.emailAddress,
        "street_address_1": value.streetAddress1,
        "street_address_2": value.streetAddress2,
        "county": value.county,
        "postcode": value.postcode,
        "country": value.country,
        "marketing_url": value.marketingUrl
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $aaeb51be8a431108$export$7088866da12bcdff(value) {
    let isInstance = true;
    isInstance = isInstance && "logoImage" in value;
    return isInstance;
}
function $aaeb51be8a431108$export$6b09e9c7aa680163(json) {
    return $aaeb51be8a431108$export$38ecc7e7a9d56854(json, false);
}
function $aaeb51be8a431108$export$38ecc7e7a9d56854(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "logoImage": json["logo_image"],
        "logoImageUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo_image_url") ? undefined : json["logo_image_url"]
    };
}
function $aaeb51be8a431108$export$52cf701915138c4e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "logo_image": value.logoImage
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $a278c39a053a7c32$export$a3f34ce0ff245260(value) {
    let isInstance = true;
    isInstance = isInstance && "confidenceCategory" in value;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
function $a278c39a053a7c32$export$52b16453816ce773(json) {
    return $a278c39a053a7c32$export$982d2371815f38de(json, false);
}
function $a278c39a053a7c32$export$982d2371815f38de(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "confidenceCategory": json["confidence_category"],
        "count": json["count"]
    };
}
function $a278c39a053a7c32$export$709ed89dc6b13cb8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "confidence_category": value.confidenceCategory,
        "count": value.count
    };
}


function $223588ce99f2272d$export$b50dc328a2679bc1(value) {
    let isInstance = true;
    isInstance = isInstance && "confidenceCategories" in value;
    isInstance = isInstance && "total" in value;
    return isInstance;
}
function $223588ce99f2272d$export$fb38f9a20243237a(json) {
    return $223588ce99f2272d$export$4e6fb039fde32c7e(json, false);
}
function $223588ce99f2272d$export$4e6fb039fde32c7e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "confidenceCategories": json["confidence_categories"].map((0, $a278c39a053a7c32$export$52b16453816ce773)),
        "total": json["total"]
    };
}
function $223588ce99f2272d$export$e342e9f27a516f2d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "confidence_categories": value.confidenceCategories.map((0, $a278c39a053a7c32$export$709ed89dc6b13cb8)),
        "total": value.total
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $caca808012d35faa$export$48b02fb117e86414(value) {
    let isInstance = true;
    isInstance = isInstance && "dupRecordingId" in value;
    isInstance = isInstance && "dupDocumentId" in value;
    return isInstance;
}
function $caca808012d35faa$export$da5cfe2978f8219f(json) {
    return $caca808012d35faa$export$f5eee7d015ac0e04(json, false);
}
function $caca808012d35faa$export$f5eee7d015ac0e04(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "dupRecordingId": json["dup_recording_id"],
        "dupDocumentId": json["dup_document_id"]
    };
}
function $caca808012d35faa$export$95178e8f07582e6f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "dup_recording_id": value.dupRecordingId,
        "dup_document_id": value.dupDocumentId
    };
}


const $949d5cc99c8eb25f$export$347ed0836a582eaa = {
    Edit: "edit",
    Add: "add",
    Delete: "delete"
};
function $949d5cc99c8eb25f$export$511a57243e520c9c(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $949d5cc99c8eb25f$export$f84f5313c223e230(json) {
    return $949d5cc99c8eb25f$export$728ea0a05946d5db(json, false);
}
function $949d5cc99c8eb25f$export$728ea0a05946d5db(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "field": json["field"],
        "value": json["value"],
        "dupIsrcs": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dup_isrcs") ? undefined : json["dup_isrcs"].map((0, $caca808012d35faa$export$da5cfe2978f8219f))
    };
}
function $949d5cc99c8eb25f$export$8059dbe7afbd28f8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "field": value.field,
        "value": value.value,
        "dup_isrcs": value.dupIsrcs === undefined ? undefined : value.dupIsrcs.map((0, $caca808012d35faa$export$95178e8f07582e6f))
    };
}


function $9a7c0b9330cf3844$export$25d86144fd48ecd3(value) {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;
    return isInstance;
}
function $9a7c0b9330cf3844$export$3c1a839704ed61aa(json) {
    return $9a7c0b9330cf3844$export$4a22ff502f6bec2b(json, false);
}
function $9a7c0b9330cf3844$export$4a22ff502f6bec2b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "edits": json["edits"].map((0, $949d5cc99c8eb25f$export$f84f5313c223e230)),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $9a7c0b9330cf3844$export$b390a0a11149d8cb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "edits": value.edits.map((0, $949d5cc99c8eb25f$export$8059dbe7afbd28f8)),
        "document_id": value.documentId
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $5b09199803447a34$export$7a0ecdf3b8c100df = {
    Edit: "edit",
    Add: "add",
    Delete: "delete"
};
function $5b09199803447a34$export$3eba2dcbf645c5e5(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $5b09199803447a34$export$6781d03d8f9082ed(json) {
    return $5b09199803447a34$export$89765d3dbed62981(json, false);
}
function $5b09199803447a34$export$89765d3dbed62981(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "field": json["field"],
        "value": json["value"]
    };
}
function $5b09199803447a34$export$230e847029233e76(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "field": value.field,
        "value": value.value
    };
}


function $3ddeef983b1a1494$export$8fd429c3f0b1ad91(value) {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "edits" in value;
    return isInstance;
}
function $3ddeef983b1a1494$export$880c8cc42bd49a01(json) {
    return $3ddeef983b1a1494$export$9b5a776d7ea20c32(json, false);
}
function $3ddeef983b1a1494$export$9b5a776d7ea20c32(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseId": json["release_id"],
        "edits": json["edits"].map((0, $5b09199803447a34$export$6781d03d8f9082ed)),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $3ddeef983b1a1494$export$e84c7db334e0aed6(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "release_id": value.releaseId,
        "edits": value.edits.map((0, $5b09199803447a34$export$230e847029233e76)),
        "document_id": value.documentId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $b36d2387fff73506$export$eae724b6593e31cc = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer"
};
const $b36d2387fff73506$export$6b46a49d4996d67c = {
    Fa: "fa",
    Ofa: "ofa"
};
const $b36d2387fff73506$export$bf856448a04f07d1 = {
    Add: "add"
};
function $b36d2387fff73506$export$cb44f6c795c2971e(value) {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $b36d2387fff73506$export$8b4401b0ce412df7(json) {
    return $b36d2387fff73506$export$4b2ae74b98fe1784(json, false);
}
function $b36d2387fff73506$export$4b2ae74b98fe1784(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sourceId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_id") ? undefined : json["source_id"],
        "source": json["source"],
        "stageName": json["stageName"],
        "members": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "members") ? undefined : json["members"].map((0, $0ce2545bf54e3dc4$export$c843d8d07dbff309)),
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"],
        "op": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "op") ? undefined : json["op"]
    };
}
function $b36d2387fff73506$export$da7cbce1ff0d9e75(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "source_id": value.sourceId,
        "source": value.source,
        "stageName": value.stageName,
        "members": value.members === undefined ? undefined : value.members.map((0, $0ce2545bf54e3dc4$export$dcc9892d4d958f2e)),
        "featuredStatus": value.featuredStatus,
        "op": value.op
    };
}


function $cd27d3530fb73cb9$export$62e23692048d97f0(value) {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;
    return isInstance;
}
function $cd27d3530fb73cb9$export$15c337baa1074aab(json) {
    return $cd27d3530fb73cb9$export$41a41a96d51a5d2f(json, false);
}
function $cd27d3530fb73cb9$export$41a41a96d51a5d2f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "edits": json["edits"].map((0, $b36d2387fff73506$export$8b4401b0ce412df7)),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $cd27d3530fb73cb9$export$f23cb9f0cf84d44c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "edits": value.edits.map((0, $b36d2387fff73506$export$da7cbce1ff0d9e75)),
        "document_id": value.documentId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $43968d5c1777387c$export$2a938d5a81a4a42e(value) {
    let isInstance = true;
    return isInstance;
}
function $43968d5c1777387c$export$48c528d3391c2ee1(json) {
    return $43968d5c1777387c$export$876e5df5341c4f1f(json, false);
}
function $43968d5c1777387c$export$876e5df5341c4f1f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sessionId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "session_id") ? undefined : json["session_id"]
    };
}
function $43968d5c1777387c$export$fe1c3e8c7156433b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "session_id": value.sessionId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $f3269fd5dab4fed8$export$94d5afa8d02dd2a6 = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer",
    Ppl: "ppl",
    Other: "other"
};
function $f3269fd5dab4fed8$export$1a20725d6434b5ae(value) {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
function $f3269fd5dab4fed8$export$24d72b3bc8b018ce(json) {
    return $f3269fd5dab4fed8$export$a3193fbd30652865(json, false);
}
function $f3269fd5dab4fed8$export$a3193fbd30652865(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sourceId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_id") ? undefined : json["source_id"],
        "source": json["source"],
        "sourceUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_url") ? undefined : json["source_url"],
        "releaseTitle": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseTitle") ? undefined : json["releaseTitle"],
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : json["dateReleased"],
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : json["releaseLabels"],
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : json["catNumbers"],
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : json["mediaType"],
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"],
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $f3269fd5dab4fed8$export$9113875b6aadc556(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "source_id": value.sourceId,
        "source": value.source,
        "source_url": value.sourceUrl,
        "releaseTitle": value.releaseTitle,
        "dateReleased": value.dateReleased,
        "releaseLabels": value.releaseLabels,
        "catNumbers": value.catNumbers,
        "mediaType": value.mediaType,
        "format": value.format,
        "document_id": value.documentId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $3879e3127a8babba$export$d7d3282b475f6dc6(value) {
    let isInstance = true;
    isInstance = isInstance && "aggregatePayment" in value;
    isInstance = isInstance && "date" in value;
    return isInstance;
}
function $3879e3127a8babba$export$58ccaf3d39e682e6(json) {
    return $3879e3127a8babba$export$15d10f3a8191fd3b(json, false);
}
function $3879e3127a8babba$export$15d10f3a8191fd3b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aggregatePayment": json["aggregate_payment"],
        "date": json["date"]
    };
}
function $3879e3127a8babba$export$2713f6b0b8f941bf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aggregate_payment": value.aggregatePayment,
        "date": value.date
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $366dcd6ae4c96880$export$5934483ebc4ece52(value) {
    let isInstance = true;
    isInstance = isInstance && "charField" in value;
    isInstance = isInstance && "emailField" in value;
    isInstance = isInstance && "jsonField" in value;
    isInstance = isInstance && "urlField" in value;
    isInstance = isInstance && "dictField" in value;
    isInstance = isInstance && "listField" in value;
    isInstance = isInstance && "integerField" in value;
    isInstance = isInstance && "floatField" in value;
    isInstance = isInstance && "decimalField" in value;
    isInstance = isInstance && "booleanField" in value;
    isInstance = isInstance && "dateField" in value;
    isInstance = isInstance && "datetimeField" in value;
    isInstance = isInstance && "timeField" in value;
    isInstance = isInstance && "uuidField" in value;
    return isInstance;
}
function $366dcd6ae4c96880$export$488b6f97322bf07(json) {
    return $366dcd6ae4c96880$export$66bb467cda9502ee(json, false);
}
function $366dcd6ae4c96880$export$66bb467cda9502ee(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "charField": json["char_field"],
        "emailField": json["email_field"],
        "jsonField": json["json_field"],
        "urlField": json["url_field"],
        "dictField": json["dict_field"],
        "listField": json["list_field"],
        "integerField": json["integer_field"],
        "floatField": json["float_field"],
        "decimalField": json["decimal_field"],
        "booleanField": json["boolean_field"],
        "dateField": new Date(json["date_field"]),
        "datetimeField": new Date(json["datetime_field"]),
        "timeField": json["time_field"],
        "uuidField": json["uuid_field"],
        "methodField": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "method_field") ? undefined : json["method_field"]
    };
}
function $366dcd6ae4c96880$export$4aa55304b0cb3762(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "char_field": value.charField,
        "email_field": value.emailField,
        "json_field": value.jsonField,
        "url_field": value.urlField,
        "dict_field": value.dictField,
        "list_field": value.listField,
        "integer_field": value.integerField,
        "float_field": value.floatField,
        "decimal_field": value.decimalField,
        "boolean_field": value.booleanField,
        "date_field": value.dateField.toISOString().substr(0, 10),
        "datetime_field": value.datetimeField.toISOString(),
        "time_field": value.timeField,
        "uuid_field": value.uuidField
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $dfb553316c3946d8$export$a80a0b0ac45e6e5d = {
    InProgress: "IN_PROGRESS",
    Failed: "FAILED",
    Succeeded: "SUCCEEDED",
    Unknown: "UNKNOWN"
};
function $dfb553316c3946d8$export$383c688ed0368fa7(value) {
    let isInstance = true;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
function $dfb553316c3946d8$export$92d8e90282029ac4(json) {
    return $dfb553316c3946d8$export$f992985728514f85(json, false);
}
function $dfb553316c3946d8$export$f992985728514f85(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "runId": json["run_id"],
        "status": json["status"]
    };
}
function $dfb553316c3946d8$export$a08c2fabdcd75d8b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "run_id": value.runId,
        "status": value.status
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $cb6201797ee67434$export$8911b5a36017ea73(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "resourceUrl" in value;
    return isInstance;
}
function $cb6201797ee67434$export$472b4cac7240527e(json) {
    return $cb6201797ee67434$export$7df3b31b29a66db(json, false);
}
function $cb6201797ee67434$export$7df3b31b29a66db(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "type": json["type"],
        "resourceUrl": json["resource_url"]
    };
}
function $cb6201797ee67434$export$6936e8cdd0709df0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "type": value.type,
        "resource_url": value.resourceUrl
    };
}


function $df0aa53153605dcb$export$8eca8763a0d3a13e(value) {
    let isInstance = true;
    return isInstance;
}
function $df0aa53153605dcb$export$7ffb5db8dd7d4adb(json) {
    return $df0aa53153605dcb$export$691a071f7a6369a3(json, false);
}
function $df0aa53153605dcb$export$691a071f7a6369a3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "name": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "name") ? undefined : json["name"],
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "images": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "images") ? undefined : json["images"].map((0, $cb6201797ee67434$export$472b4cac7240527e))
    };
}
function $df0aa53153605dcb$export$8aaf267605ec0d28(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name,
        "id": value.id,
        "images": value.images === undefined ? undefined : value.images.map((0, $cb6201797ee67434$export$6936e8cdd0709df0))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $897b89fe755c0559$export$c891614ca760b679(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $897b89fe755c0559$export$971154f117cfc95e(json) {
    return $897b89fe755c0559$export$78a6649a16173904(json, false);
}
function $897b89fe755c0559$export$78a6649a16173904(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "name": json["name"]
    };
}
function $897b89fe755c0559$export$ee25300e23c983c2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "name": value.name
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $0ffc9fbc68ac2eec$export$8ec27db8e916e25(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
function $0ffc9fbc68ac2eec$export$a166e2cc63be2cb9(json) {
    return $0ffc9fbc68ac2eec$export$19065ec0a79398a8(json, false);
}
function $0ffc9fbc68ac2eec$export$19065ec0a79398a8(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "source": json["source"]
    };
}
function $0ffc9fbc68ac2eec$export$3ee142636fb476e9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "source": value.source
    };
}


function $cd4a78309f9407e0$export$5bd83f0a85ea333c(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $cd4a78309f9407e0$export$77fb44a5fb994a26(json) {
    return $cd4a78309f9407e0$export$b2c84a53b5ca2194(json, false);
}
function $cd4a78309f9407e0$export$b2c84a53b5ca2194(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "source": json["source"],
        "name": json["name"],
        "realName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "realName") ? undefined : json["realName"],
        "nameVariations": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "nameVariations") ? undefined : json["nameVariations"],
        "aliases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"].map((0, $897b89fe755c0559$export$971154f117cfc95e)),
        "externalIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "external_ids") ? undefined : json["external_ids"].map((0, $0ffc9fbc68ac2eec$export$a166e2cc63be2cb9))
    };
}
function $cd4a78309f9407e0$export$249569fbecb72889(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "source": value.source,
        "name": value.name,
        "realName": value.realName,
        "nameVariations": value.nameVariations,
        "aliases": value.aliases === undefined ? undefined : value.aliases.map((0, $897b89fe755c0559$export$ee25300e23c983c2)),
        "external_ids": value.externalIds === undefined ? undefined : value.externalIds.map((0, $0ffc9fbc68ac2eec$export$3ee142636fb476e9))
    };
}


function $d52b7e4a81f98461$export$88ffe29dc5faba(value) {
    let isInstance = true;
    isInstance = isInstance && "artists" in value;
    isInstance = isInstance && "sortArray" in value;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
function $d52b7e4a81f98461$export$26b7684970b2390(json) {
    return $d52b7e4a81f98461$export$d3ed9636907361ff(json, false);
}
function $d52b7e4a81f98461$export$d3ed9636907361ff(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "artists": json["artists"].map((0, $cd4a78309f9407e0$export$77fb44a5fb994a26)),
        "sortArray": json["sort_array"],
        "count": json["count"]
    };
}
function $d52b7e4a81f98461$export$ad5f46c365ae965c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "artists": value.artists.map((0, $cd4a78309f9407e0$export$249569fbecb72889)),
        "sort_array": value.sortArray,
        "count": value.count
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $2c7c8d4649c80a20$export$1b12277500a4213e(value) {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;
    return isInstance;
}
function $2c7c8d4649c80a20$export$991a282fb95e914b(json) {
    return $2c7c8d4649c80a20$export$7631059fceafc372(json, false);
}
function $2c7c8d4649c80a20$export$7631059fceafc372(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "signedUrl": json["signed_url"]
    };
}
function $2c7c8d4649c80a20$export$e990b4df55b96eae(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "signed_url": value.signedUrl
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $2e327edbea3e67c8$export$34529e760ec9648a(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    return isInstance;
}
function $2e327edbea3e67c8$export$10c6c0ff67d28f5f(json) {
    return $2e327edbea3e67c8$export$5dd2b97fb96aecdd(json, false);
}
function $2e327edbea3e67c8$export$5dd2b97fb96aecdd(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["object_key"]
    };
}
function $2e327edbea3e67c8$export$6d2e9ac51213991c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "object_key": value.objectKey
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $c2dc3b3871d73742$export$fa9d0a1376a9ae62(value) {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;
    return isInstance;
}
function $c2dc3b3871d73742$export$c7b1fcf5381c94c3(json) {
    return $c2dc3b3871d73742$export$b9b42db810d43371(json, false);
}
function $c2dc3b3871d73742$export$b9b42db810d43371(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "signedUrl": json["signed_url"]
    };
}
function $c2dc3b3871d73742$export$17b43f446906a5ba(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "signed_url": value.signedUrl
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $bbcd59aa11698e87$export$f1cfc44d85c80d6c(value) {
    let isInstance = true;
    isInstance = isInstance && "url" in value;
    return isInstance;
}
function $bbcd59aa11698e87$export$dc8f04ce44c3c80c(json) {
    return $bbcd59aa11698e87$export$b32c8f86b53b754d(json, false);
}
function $bbcd59aa11698e87$export$b32c8f86b53b754d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": json["url"]
    };
}
function $bbcd59aa11698e87$export$6a86535ea0505be0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "url": value.url
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $a4a0ecc41012d219$export$5dae5dda92941b26(value) {
    let isInstance = true;
    isInstance = isInstance && "fiscalYearsUnique" in value;
    return isInstance;
}
function $a4a0ecc41012d219$export$8b12be228efb1adf(json) {
    return $a4a0ecc41012d219$export$d641767c1f6d63e3(json, false);
}
function $a4a0ecc41012d219$export$d641767c1f6d63e3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "fiscalYearsUnique": json["fiscal_years_unique"]
    };
}
function $a4a0ecc41012d219$export$e15e7d171f3009bb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "fiscal_years_unique": value.fiscalYearsUnique
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $b0fcadbdb9a46931$export$b5d7bf15840e1e0f(value) {
    let isInstance = true;
    isInstance = isInstance && "documentTypes" in value;
    return isInstance;
}
function $b0fcadbdb9a46931$export$8738fab109abb74d(json) {
    return $b0fcadbdb9a46931$export$5c904fd4f42d9fe6(json, false);
}
function $b0fcadbdb9a46931$export$5c904fd4f42d9fe6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentTypes": json["document_types"]
    };
}
function $b0fcadbdb9a46931$export$b1951e116b9b781a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_types": value.documentTypes
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f7bbd894883813bb$export$e819a83265030c9c(value) {
    let isInstance = true;
    isInstance = isInstance && "passportFile" in value;
    isInstance = isInstance && "registeredWithPpl" in value;
    isInstance = isInstance && "streetAddress" in value;
    isInstance = isInstance && "postcode" in value;
    isInstance = isInstance && "county" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "witnessFirstName" in value;
    isInstance = isInstance && "witnessLastName" in value;
    isInstance = isInstance && "witnessEmail" in value;
    return isInstance;
}
function $f7bbd894883813bb$export$1372d202ad798e18(json) {
    return $f7bbd894883813bb$export$bc95f783d961e35a(json, false);
}
function $f7bbd894883813bb$export$bc95f783d961e35a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "passportFile": json["passport_file"],
        "proofOfAddressFile": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "proof_of_address_file") ? undefined : json["proof_of_address_file"],
        "registeredWithPpl": json["registered_with_ppl"],
        "pplPerformerName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "streetAddress": json["street_address"],
        "postcode": json["postcode"],
        "county": json["county"],
        "country": json["country"],
        "witnessFirstName": json["witness_first_name"],
        "witnessLastName": json["witness_last_name"],
        "witnessEmail": json["witness_email"]
    };
}
function $f7bbd894883813bb$export$585369f1e8f570be(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "passport_file": value.passportFile,
        "proof_of_address_file": value.proofOfAddressFile,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "street_address": value.streetAddress,
        "postcode": value.postcode,
        "county": value.county,
        "country": value.country,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $de30fb04e66f39f2$export$780d2ae16fa36fe5(value) {
    let isInstance = true;
    isInstance = isInstance && "aliasId" in value;
    return isInstance;
}
function $de30fb04e66f39f2$export$3691f6c635b7c1cd(json) {
    return $de30fb04e66f39f2$export$3d26d22e1fce7f0(json, false);
}
function $de30fb04e66f39f2$export$3d26d22e1fce7f0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aliasId": json["alias_id"],
        "isPermanentMember": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_permanent_member") ? undefined : json["is_permanent_member"],
        "isMainPerformer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_main_performer") ? undefined : json["is_main_performer"]
    };
}
function $de30fb04e66f39f2$export$9a5f9fbbbbb178eb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "alias_id": value.aliasId,
        "is_permanent_member": value.isPermanentMember,
        "is_main_performer": value.isMainPerformer
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f94e6c2ba0d8c130$export$5fc5b211c491638a(value) {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "releaseTitle" in value;
    return isInstance;
}
function $f94e6c2ba0d8c130$export$838fe688e1095847(json) {
    return $f94e6c2ba0d8c130$export$333093c597016174(json, false);
}
function $f94e6c2ba0d8c130$export$333093c597016174(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseId": json["release_id"],
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : json["dateReleased"],
        "edgeId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "edge_id") ? undefined : json["edge_id"],
        "releaseTitle": json["releaseTitle"],
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : json["releaseLabels"],
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : json["catNumbers"],
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : json["mediaType"],
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"],
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $f94e6c2ba0d8c130$export$9c3b2b75140e5fc0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "release_id": value.releaseId,
        "dateReleased": value.dateReleased,
        "edge_id": value.edgeId,
        "releaseTitle": value.releaseTitle,
        "releaseLabels": value.releaseLabels,
        "catNumbers": value.catNumbers,
        "mediaType": value.mediaType,
        "format": value.format,
        "document_id": value.documentId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $3f2370c7cd227afa$export$1216de48694dc432(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "societyName" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "s3Url" in value;
    isInstance = isInstance && "dateCreated" in value;
    isInstance = isInstance && "dateSentToSociety" in value;
    isInstance = isInstance && "country" in value;
    return isInstance;
}
function $3f2370c7cd227afa$export$adddd0d13b7274f3(json) {
    return $3f2370c7cd227afa$export$ec68919ed10eacf0(json, false);
}
function $3f2370c7cd227afa$export$ec68919ed10eacf0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "societyName": json["society_name"],
        "status": json["status"],
        "s3Url": json["s3_url"],
        "dateCreated": new Date(json["date_created"]),
        "dateSentToSociety": json["date_sent_to_society"] === null ? null : new Date(json["date_sent_to_society"]),
        "country": json["country"]
    };
}
function $3f2370c7cd227afa$export$9938ca74b36e28b4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "society_name": value.societyName,
        "status": value.status,
        "s3_url": value.s3Url,
        "date_created": value.dateCreated.toISOString(),
        "date_sent_to_society": value.dateSentToSociety === null ? null : value.dateSentToSociety.toISOString(),
        "country": value.country
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $5b04b154f586a04e$export$8f94fab6f213cecf(value) {
    let isInstance = true;
    isInstance = isInstance && "identifier" in value;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $5b04b154f586a04e$export$56f601b553b56a14(json) {
    return $5b04b154f586a04e$export$a78bc3657beb726a(json, false);
}
function $5b04b154f586a04e$export$a78bc3657beb726a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "identifier": json["identifier"],
        "password": json["password"]
    };
}
function $5b04b154f586a04e$export$303b9f6375543435(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "identifier": value.identifier,
        "password": value.password
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e33bd6fedf5053d7$export$f4fcfff92e12cb0f(value) {
    let isInstance = true;
    isInstance = isInstance && "searchTerm" in value;
    return isInstance;
}
function $e33bd6fedf5053d7$export$7b3961dc03eb55fb(json) {
    return $e33bd6fedf5053d7$export$7ca14f4f27ac03b1(json, false);
}
function $e33bd6fedf5053d7$export$7ca14f4f27ac03b1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "searchTerm": json["search_term"]
    };
}
function $e33bd6fedf5053d7$export$c4dad680b879e9ed(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "search_term": value.searchTerm
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

function $467075b1ca154d75$export$f64f93bf0190311e(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $467075b1ca154d75$export$9995d8cbc0324d6f(json) {
    return $467075b1ca154d75$export$1e8fc63d7d31930c(json, false);
}
function $467075b1ca154d75$export$1e8fc63d7d31930c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "stageName": json["stageName"],
        "members": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "members") ? undefined : json["members"].map((0, $0ce2545bf54e3dc4$export$c843d8d07dbff309))
    };
}
function $467075b1ca154d75$export$11c98810bc13a8a8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "stageName": value.stageName,
        "members": value.members === undefined ? undefined : value.members.map((0, $0ce2545bf54e3dc4$export$dcc9892d4d958f2e))
    };
}


function $10bc28dfcf1d9fc4$export$a992f3b3e889cdf2(value) {
    let isInstance = true;
    isInstance = isInstance && "artists" in value;
    return isInstance;
}
function $10bc28dfcf1d9fc4$export$3c1c1d2c523ad211(json) {
    return $10bc28dfcf1d9fc4$export$aa3d98126b01542a(json, false);
}
function $10bc28dfcf1d9fc4$export$aa3d98126b01542a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "artists": json["artists"].map((0, $467075b1ca154d75$export$9995d8cbc0324d6f))
    };
}
function $10bc28dfcf1d9fc4$export$3bb18dff8bc9acaf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "artists": value.artists.map((0, $467075b1ca154d75$export$11c98810bc13a8a8))
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $44984562fe7ddccf$export$401a75b2b12cccbd(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "personaId" in value;
    return isInstance;
}
function $44984562fe7ddccf$export$61617777feb5a161(json) {
    return $44984562fe7ddccf$export$3b663db324f1ce97(json, false);
}
function $44984562fe7ddccf$export$3b663db324f1ce97(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"],
        "personaId": json["persona_id"]
    };
}
function $44984562fe7ddccf$export$19d958436d609482(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "persona_id": value.personaId
    };
}


function $231c486235fd2ccd$export$bcda1d87d22db5a1(value) {
    let isInstance = true;
    isInstance = isInstance && "personas" in value;
    return isInstance;
}
function $231c486235fd2ccd$export$16f2739d82c24713(json) {
    return $231c486235fd2ccd$export$30c46048728417b5(json, false);
}
function $231c486235fd2ccd$export$30c46048728417b5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "personas": json["personas"].map((0, $44984562fe7ddccf$export$61617777feb5a161))
    };
}
function $231c486235fd2ccd$export$30b61a1f79d7c56f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "personas": value.personas.map((0, $44984562fe7ddccf$export$19d958436d609482))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $921302db4fcbf179$export$946d82b35799eda9 = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer",
    Ppl: "ppl"
};
function $921302db4fcbf179$export$fcfcc4574f5e82a0(value) {
    let isInstance = true;
    isInstance = isInstance && "sourceId" in value;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
function $921302db4fcbf179$export$7e5d52e125ad28b6(json) {
    return $921302db4fcbf179$export$90586b1d09365d94(json, false);
}
function $921302db4fcbf179$export$90586b1d09365d94(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sourceId": json["source_id"],
        "source": json["source"]
    };
}
function $921302db4fcbf179$export$2d4ed814e872f477(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "source_id": value.sourceId,
        "source": value.source
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $70751ac3b08537bb$export$126b7839cdc7c5c5(value) {
    let isInstance = true;
    isInstance = isInstance && "linked" in value;
    isInstance = isInstance && "payload" in value;
    return isInstance;
}
function $70751ac3b08537bb$export$5c590a88b5aac251(json) {
    return $70751ac3b08537bb$export$7e53b53b21898fca(json, false);
}
function $70751ac3b08537bb$export$7e53b53b21898fca(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "linked": json["linked"],
        "payload": (0, $f4f7ba52c2c02d55$export$d31931daed72dc64)(json["payload"])
    };
}
function $70751ac3b08537bb$export$74605a34ce2cf130(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "linked": value.linked,
        "payload": (0, $f4f7ba52c2c02d55$export$f55578efae5f4799)(value.payload)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $0355975438722485$export$604a0559d19cd8e9(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "_exists" in value;
    return isInstance;
}
function $0355975438722485$export$f56f6558598d80e4(json) {
    return $0355975438722485$export$6d00ef40daed2043(json, false);
}
function $0355975438722485$export$6d00ef40daed2043(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "stageName": json["stageName"],
        "_exists": json["exists"],
        "internalId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "internalId") ? undefined : json["internalId"]
    };
}
function $0355975438722485$export$e9777bf2b3ac1acd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "stageName": value.stageName,
        "exists": value._exists,
        "internalId": value.internalId
    };
}


function $fac70cf221c7f05a$export$fe2c3b980db6dc90(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "isGroup" in value;
    isInstance = isInstance && "_exists" in value;
    isInstance = isInstance && "members" in value;
    return isInstance;
}
function $fac70cf221c7f05a$export$ae8904bed07853df(json) {
    return $fac70cf221c7f05a$export$2c48de7deb593520(json, false);
}
function $fac70cf221c7f05a$export$2c48de7deb593520(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"],
        "isGroup": json["isGroup"],
        "_exists": json["exists"],
        "internalId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "internalId") ? undefined : json["internalId"],
        "members": json["members"].map((0, $0355975438722485$export$f56f6558598d80e4))
    };
}
function $fac70cf221c7f05a$export$c71b9a251e1c8400(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "isGroup": value.isGroup,
        "exists": value._exists,
        "internalId": value.internalId,
        "members": value.members.map((0, $0355975438722485$export$e9777bf2b3ac1acd))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $ac464ed50cc3b124$export$fd3a7799230e15bd = {
    Add: "add",
    Delete: "delete",
    Edit: "edit"
};
function $ac464ed50cc3b124$export$8283b767585cd9bd(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $ac464ed50cc3b124$export$a830409f42cbff7(json) {
    return $ac464ed50cc3b124$export$3d5a5e7fc6bc0d37(json, false);
}
function $ac464ed50cc3b124$export$3d5a5e7fc6bc0d37(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "role": json["role"],
        "personaId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "persona_id") ? undefined : json["persona_id"],
        "dataCategory": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "data_category") ? undefined : json["data_category"],
        "sourceUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_url") ? undefined : json["source_url"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"]
    };
}
function $ac464ed50cc3b124$export$97d54cb091dd79b3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "role": value.role,
        "persona_id": value.personaId,
        "data_category": value.dataCategory,
        "source_url": value.sourceUrl,
        "notes": value.notes
    };
}


function $c8f41806c5650da9$export$e5d7d4829a329f99(value) {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;
    return isInstance;
}
function $c8f41806c5650da9$export$8e58f8a3185d4bb5(json) {
    return $c8f41806c5650da9$export$c9afdb4b4424de70(json, false);
}
function $c8f41806c5650da9$export$c9afdb4b4424de70(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "edits": json["edits"].map((0, $ac464ed50cc3b124$export$a830409f42cbff7)),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $c8f41806c5650da9$export$254a769af7d9fef6(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "edits": value.edits.map((0, $ac464ed50cc3b124$export$97d54cb091dd79b3)),
        "document_id": value.documentId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $33ff94992968ec35$export$966c6b48709962b0 = {
    ClientToSign: "client_to_sign",
    WithClient: "with_client",
    AdminToSign: "admin_to_sign",
    AwaitingUpload: "awaiting_upload",
    Approved: "approved"
};
function $33ff94992968ec35$export$37fc7c1f7de59ede(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "societyForm" in value;
    return isInstance;
}
function $33ff94992968ec35$export$fda0802f448f87cd(json) {
    return $33ff94992968ec35$export$467b1d29eaf285ce(json, false);
}
function $33ff94992968ec35$export$467b1d29eaf285ce(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "complete": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "complete") ? undefined : json["complete"],
        "dateCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsSessionId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"],
        "pandadocsDocumentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsDocumentS3Key": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_s3_key") ? undefined : json["pandadocs_document_s3_key"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "user": json["user"],
        "societyForm": json["society_form"]
    };
}
function $33ff94992968ec35$export$38e6d1d831d066f2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "complete": value.complete,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_session_id": value.pandadocsSessionId,
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_document_s3_key": value.pandadocsDocumentS3Key,
        "status": value.status,
        "user": value.user,
        "society_form": value.societyForm
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $b6719923319239b8$export$2b391cbfad052244(value) {
    let isInstance = true;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $b6719923319239b8$export$cc5cf1ab6820dc7(json) {
    return $b6719923319239b8$export$384d078584bd1dc5(json, false);
}
function $b6719923319239b8$export$384d078584bd1dc5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "readableName": json["readable_name"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "forms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "forms") ? undefined : json["forms"]
    };
}
function $b6719923319239b8$export$f74e681c122ff42e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "readable_name": value.readableName,
        "country": value.country
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $4586e55d33e70041$export$712e9d999f4633f8(value) {
    let isInstance = true;
    isInstance = isInstance && "onboardingProgress" in value;
    return isInstance;
}
function $4586e55d33e70041$export$549ee7ec67643d0(json) {
    return $4586e55d33e70041$export$87508bba39114cdc(json, false);
}
function $4586e55d33e70041$export$87508bba39114cdc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "onboardingProgress": json["onboarding_progress"]
    };
}
function $4586e55d33e70041$export$4dc156adcc122a44(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "onboarding_progress": value.onboardingProgress
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $2be015927948e876$export$851c652f47cfe86(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "order" in value;
    return isInstance;
}
function $2be015927948e876$export$453236c830f87979(json) {
    return $2be015927948e876$export$65242b85d5de4eac(json, false);
}
function $2be015927948e876$export$65242b85d5de4eac(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "order": json["order"],
        "information": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "information") ? undefined : json["information"],
        "stepCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "step_completed") ? undefined : json["step_completed"]
    };
}
function $2be015927948e876$export$6c97f1e4626b54ea(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "order": value.order,
        "information": value.information,
        "step_completed": value.stepCompleted
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $431eb5e7bf5a2364$export$4d73f7aa40dafe87(value) {
    let isInstance = true;
    isInstance = isInstance && "nextStepInformation" in value;
    isInstance = isInstance && "onboardingSteps" in value;
    return isInstance;
}
function $431eb5e7bf5a2364$export$addf7c24f7592504(json) {
    return $431eb5e7bf5a2364$export$9eb3576fd502a6b6(json, false);
}
function $431eb5e7bf5a2364$export$9eb3576fd502a6b6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "nextStepInformation": json["next_step_information"],
        "onboardingSteps": json["onboarding_steps"].map((0, $12ebf204d4f43bf9$export$cc6b4e10642aad34))
    };
}
function $431eb5e7bf5a2364$export$1446cb19e77b3b7b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "next_step_information": value.nextStepInformation,
        "onboarding_steps": value.onboardingSteps.map((0, $12ebf204d4f43bf9$export$119a1d330671ed41))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $22c30025326256b6$export$a09d57aff525c47d(value) {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $22c30025326256b6$export$862cf7f4fa6a9624(json) {
    return $22c30025326256b6$export$afd6b03f52e963b(json, false);
}
function $22c30025326256b6$export$afd6b03f52e963b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "s3Url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "s3_url") ? undefined : json["s3_url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "s3Key": json["s3_key"],
        "ready": json["ready"],
        "user": json["user"],
        "task": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "task") ? undefined : json["task"]
    };
}
function $22c30025326256b6$export$7d0e05573e8ac3d8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "s3_key": value.s3Key,
        "ready": value.ready,
        "user": value.user,
        "task": value.task
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e8fd9dfae47c930b$export$a6b417901e3e399b(value) {
    let isInstance = true;
    isInstance = isInstance && "documentId" in value;
    isInstance = isInstance && "documentPandadocUuid" in value;
    isInstance = isInstance && "documentName" in value;
    isInstance = isInstance && "sessionId" in value;
    isInstance = isInstance && "pandadocDocumentId" in value;
    return isInstance;
}
function $e8fd9dfae47c930b$export$3284951041cc42ee(json) {
    return $e8fd9dfae47c930b$export$244987b5de33cf8e(json, false);
}
function $e8fd9dfae47c930b$export$244987b5de33cf8e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentId": json["document_id"],
        "documentPandadocUuid": json["document_pandadoc_uuid"],
        "documentName": json["document_name"],
        "sessionId": json["session_id"],
        "pandadocDocumentId": json["pandadoc_document_id"]
    };
}
function $e8fd9dfae47c930b$export$c783a4eceaa4d2ee(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_id": value.documentId,
        "document_pandadoc_uuid": value.documentPandadocUuid,
        "document_name": value.documentName,
        "session_id": value.sessionId,
        "pandadoc_document_id": value.pandadocDocumentId
    };
}


function $6d120dccd14bda55$export$6d07ae274edc1eeb(value) {
    let isInstance = true;
    return isInstance;
}
function $6d120dccd14bda55$export$4950862b30fc1953(json) {
    return $6d120dccd14bda55$export$b096a718799a3fab(json, false);
}
function $6d120dccd14bda55$export$b096a718799a3fab(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documents": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "documents") ? undefined : json["documents"].map((0, $e8fd9dfae47c930b$export$3284951041cc42ee)),
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "userId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_id") ? undefined : json["user_id"],
        "societyFormSubroleId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society_form_subrole_id") ? undefined : json["society_form_subrole_id"],
        "adminSocietyFormTaskId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "admin_society_form_task_id") ? undefined : json["admin_society_form_task_id"]
    };
}
function $6d120dccd14bda55$export$8652488ad92b6771(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "documents": value.documents === undefined ? undefined : value.documents.map((0, $e8fd9dfae47c930b$export$c783a4eceaa4d2ee)),
        "email": value.email,
        "user_id": value.userId,
        "society_form_subrole_id": value.societyFormSubroleId,
        "admin_society_form_task_id": value.adminSocietyFormTaskId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $3a3591882bee0359$export$8dececa65671bade(value) {
    let isInstance = true;
    isInstance = isInstance && "pandadocsData" in value;
    return isInstance;
}
function $3a3591882bee0359$export$3e714e27ace81dea(json) {
    return $3a3591882bee0359$export$a6c733fe79e50515(json, false);
}
function $3a3591882bee0359$export$a6c733fe79e50515(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "pandadocsData": json["pandadocs_data"]
    };
}
function $3a3591882bee0359$export$5948fce865b68a3a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "pandadocs_data": value.pandadocsData
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $651eb0c6133c2d05$export$6faee095f907ed38 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $651eb0c6133c2d05$export$2d943482c8106434(value) {
    let isInstance = true;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amountPaidToClient" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "percentagePayable" in value;
    isInstance = isInstance && "dateCreated" in value;
    return isInstance;
}
function $651eb0c6133c2d05$export$ede75277ced03c5d(json) {
    return $651eb0c6133c2d05$export$b882712ed6ae0d44(json, false);
}
function $651eb0c6133c2d05$export$b882712ed6ae0d44(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "paymentDate": new Date(json["payment_date"]),
        "amountPaidToClient": json["amount_paid_to_client"],
        "totalAmountReceived": json["total_amount_received"],
        "status": json["status"],
        "percentagePayable": json["percentage_payable"],
        "fromSociety": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "from_society") ? undefined : json["from_society"],
        "dateCreated": new Date(json["date_created"])
    };
}
function $651eb0c6133c2d05$export$14ea7dd57087ac5f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "payment_date": value.paymentDate.toISOString(),
        "amount_paid_to_client": value.amountPaidToClient,
        "total_amount_received": value.totalAmountReceived,
        "status": value.status,
        "percentage_payable": value.percentagePayable,
        "date_created": value.dateCreated.toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $b0c6dc27ae4bb73b$export$1fba77a42e01b8fe(value) {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;
    return isInstance;
}
function $b0c6dc27ae4bb73b$export$11be686f93e21c72(json) {
    return $b0c6dc27ae4bb73b$export$f7b16d36fd6f114f(json, false);
}
function $b0c6dc27ae4bb73b$export$f7b16d36fd6f114f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "userId": json["user_id"]
    };
}
function $b0c6dc27ae4bb73b$export$a690efef17070dbb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "user_id": value.userId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $057bd700f894f3a9$export$21bfd8db6a54fb2f = {
    Queued: "QUEUED",
    NotStarted: "NOT_STARTED",
    Managed: "MANAGED",
    Starting: "STARTING",
    Started: "STARTED",
    Success: "SUCCESS",
    Failure: "FAILURE",
    Canceling: "CANCELING",
    Canceled: "CANCELED"
};
const $057bd700f894f3a9$export$333f0b7e3a40f451 = {
    Requested: "REQUESTED",
    Launching: "LAUNCHING",
    Starting: "STARTING",
    Running: "RUNNING",
    WaitingForSensor: "WAITING_FOR_SENSOR",
    Succeeded: "SUCCEEDED",
    Failed: "FAILED",
    Cancelling: "CANCELLING",
    Cancelled: "CANCELLED"
};
function $057bd700f894f3a9$export$5b828f60b305e82b(value) {
    let isInstance = true;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
function $057bd700f894f3a9$export$eb5e6a8ad753c49(json) {
    return $057bd700f894f3a9$export$f959131cf33d361e(json, false);
}
function $057bd700f894f3a9$export$f959131cf33d361e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "runId": json["run_id"],
        "status": json["status"],
        "phase": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phase") ? undefined : json["phase"],
        "currentStep": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "current_step") ? undefined : json["current_step"],
        "totalSteps": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "total_steps") ? undefined : json["total_steps"],
        "currentStepLabel": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "current_step_label") ? undefined : json["current_step_label"],
        "isStalled": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_stalled") ? undefined : json["is_stalled"],
        "lastProgressAt": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_progress_at") ? undefined : json["last_progress_at"] === null ? null : new Date(json["last_progress_at"]),
        "requestedAt": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "requested_at") ? undefined : json["requested_at"] === null ? null : new Date(json["requested_at"])
    };
}
function $057bd700f894f3a9$export$78ac8042f09d1c0f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "run_id": value.runId,
        "status": value.status,
        "phase": value.phase,
        "current_step": value.currentStep,
        "total_steps": value.totalSteps,
        "current_step_label": value.currentStepLabel,
        "is_stalled": value.isStalled,
        "last_progress_at": value.lastProgressAt === undefined ? undefined : value.lastProgressAt === null ? null : value.lastProgressAt.toISOString(),
        "requested_at": value.requestedAt === undefined ? undefined : value.requestedAt === null ? null : value.requestedAt.toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $8e162968d95ab4d2$export$92cc256ea35a934b(value) {
    let isInstance = true;
    isInstance = isInstance && "file" in value;
    isInstance = isInstance && "society" in value;
    return isInstance;
}
function $8e162968d95ab4d2$export$78d23a4a7ca69183(json) {
    return $8e162968d95ab4d2$export$441fd7bca1ea85b9(json, false);
}
function $8e162968d95ab4d2$export$441fd7bca1ea85b9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "file": json["file"],
        "society": json["society"]
    };
}
function $8e162968d95ab4d2$export$85c3d9c455b4213a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "file": value.file,
        "society": value.society
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e33d707f3168632a$export$9c540be0071d4785(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
function $e33d707f3168632a$export$973aefbf5296d294(json) {
    return $e33d707f3168632a$export$5898f237fe5def0c(json, false);
}
function $e33d707f3168632a$export$5898f237fe5def0c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"]
    };
}
function $e33d707f3168632a$export$6a4d7222a2308ed8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $be0baa886e1734d4$export$6142206dc5ee21d4(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    isInstance = isInstance && "isCover" in value;
    isInstance = isInstance && "isPreferred" in value;
    return isInstance;
}
function $be0baa886e1734d4$export$1911aad9801dc9a4(json) {
    return $be0baa886e1734d4$export$1b56450a7f8c372f(json, false);
}
function $be0baa886e1734d4$export$1b56450a7f8c372f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["objectKey"],
        "isCover": json["isCover"],
        "isPreferred": json["isPreferred"]
    };
}
function $be0baa886e1734d4$export$8e7ba2d048a6c566(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "objectKey": value.objectKey,
        "isCover": value.isCover,
        "isPreferred": value.isPreferred
    };
}


function $3b4a70cf4a3f687e$export$bedcb94db2108c60(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sourceReleaseId" in value;
    isInstance = isInstance && "releaseTitle" in value;
    return isInstance;
}
function $3b4a70cf4a3f687e$export$34d46539b73b3b6b(json) {
    return $3b4a70cf4a3f687e$export$b2c207ec186bfa3f(json, false);
}
function $3b4a70cf4a3f687e$export$b2c207ec186bfa3f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "sourceReleaseId": json["sourceReleaseId"],
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : json["dateReleased"],
        "releaseTitle": json["releaseTitle"],
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : json["mediaType"],
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"],
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : json["catNumbers"],
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : json["releaseLabels"],
        "ean": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ean") ? undefined : json["ean"],
        "upc": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "upc") ? undefined : json["upc"],
        "evidenceImages": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "evidenceImages") ? undefined : json["evidenceImages"] === null ? null : json["evidenceImages"].map((0, $be0baa886e1734d4$export$1911aad9801dc9a4)),
        "releaseVersion": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseVersion") ? undefined : json["releaseVersion"],
        "releaseCountry": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseCountry") ? undefined : json["releaseCountry"]
    };
}
function $3b4a70cf4a3f687e$export$5fcfb3f7a7855be(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "sourceReleaseId": value.sourceReleaseId,
        "dateReleased": value.dateReleased,
        "releaseTitle": value.releaseTitle,
        "mediaType": value.mediaType,
        "format": value.format,
        "catNumbers": value.catNumbers,
        "releaseLabels": value.releaseLabels,
        "ean": value.ean,
        "upc": value.upc,
        "evidenceImages": value.evidenceImages === undefined ? undefined : value.evidenceImages === null ? null : value.evidenceImages.map((0, $be0baa886e1734d4$export$8e7ba2d048a6c566)),
        "releaseVersion": value.releaseVersion,
        "releaseCountry": value.releaseCountry
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $cfb6c0605c8487da$export$c1bd3a61bdde03a6(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sourceReleaseId" in value;
    isInstance = isInstance && "evidenceImages" in value;
    return isInstance;
}
function $cfb6c0605c8487da$export$fb2e8cdf81242647(json) {
    return $cfb6c0605c8487da$export$600eca293bbf7818(json, false);
}
function $cfb6c0605c8487da$export$600eca293bbf7818(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "sourceReleaseId": json["sourceReleaseId"],
        "evidenceImages": json["evidenceImages"].map((0, $be0baa886e1734d4$export$1911aad9801dc9a4))
    };
}
function $cfb6c0605c8487da$export$cd59ab9a4ca345c9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "sourceReleaseId": value.sourceReleaseId,
        "evidenceImages": value.evidenceImages.map((0, $be0baa886e1734d4$export$8e7ba2d048a6c566))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $3731a4f638198ea5$export$5df361f9a7e46bf2(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "recordingTitle" in value;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
function $3731a4f638198ea5$export$a1bea63454d8d4ef(json) {
    return $3731a4f638198ea5$export$9448be4442ef20df(json, false);
}
function $3731a4f638198ea5$export$9448be4442ef20df(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "recordingTitle": json["recordingTitle"],
        "duration": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "duration") ? undefined : json["duration"],
        "bandArtistName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bandArtistName") ? undefined : json["bandArtistName"],
        "mainArtists": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mainArtists") ? undefined : json["mainArtists"],
        "isrcs": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "isrcs") ? undefined : json["isrcs"],
        "live": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "live") ? undefined : json["live"],
        "countryOfRecording": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "countryOfRecording") ? undefined : json["countryOfRecording"],
        "yearRecorded": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "yearRecorded") ? undefined : json["yearRecorded"],
        "recordingVersion": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "recordingVersion") ? undefined : json["recordingVersion"],
        "source": json["source"],
        "pNames": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pNames") ? undefined : json["pNames"],
        "pDates": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pDates") ? undefined : json["pDates"]
    };
}
function $3731a4f638198ea5$export$91dfdcb8daf96447(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "recordingTitle": value.recordingTitle,
        "duration": value.duration,
        "bandArtistName": value.bandArtistName,
        "mainArtists": value.mainArtists,
        "isrcs": value.isrcs,
        "live": value.live,
        "countryOfRecording": value.countryOfRecording,
        "yearRecorded": value.yearRecorded,
        "recordingVersion": value.recordingVersion,
        "source": value.source,
        "pNames": value.pNames,
        "pDates": value.pDates
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $08c727e17cc2205a$export$145dad09b9d090a7(value) {
    let isInstance = true;
    return isInstance;
}
function $08c727e17cc2205a$export$87a5d3c0b5b446fa(json) {
    return $08c727e17cc2205a$export$454b785feb38dee9(json, false);
}
function $08c727e17cc2205a$export$454b785feb38dee9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"]
    };
}
function $08c727e17cc2205a$export$90f185072ae6727a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "featuredStatus": value.featuredStatus
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $610e8f7d9c5365bf$export$615d49806d2f4658(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $610e8f7d9c5365bf$export$1d0f206a51e5319b(json) {
    return $610e8f7d9c5365bf$export$4aa488a2a722dc68(json, false);
}
function $610e8f7d9c5365bf$export$4aa488a2a722dc68(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"]
    };
}
function $610e8f7d9c5365bf$export$3f3125a18e66022f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $645c5fc25d13a6f2$export$b2dc914a227951c = {
    SubmittedToSociety: "SUBMITTED_TO_SOCIETY",
    EvidenceNeeded: "EVIDENCE_NEEDED",
    RegisteredWithSociety: "REGISTERED_WITH_SOCIETY",
    ToBeRegistered: "TO_BE_REGISTERED",
    Other: "OTHER"
};
function $645c5fc25d13a6f2$export$b5e1de6b34752e48(value) {
    let isInstance = true;
    isInstance = isInstance && "contribution" in value;
    isInstance = isInstance && "westburyContribution" in value;
    return isInstance;
}
function $645c5fc25d13a6f2$export$8ac2c111ddc0c214(json) {
    return $645c5fc25d13a6f2$export$4185708b39650b8e(json, false);
}
function $645c5fc25d13a6f2$export$4185708b39650b8e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "claimStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "claimStatus") ? undefined : json["claimStatus"],
        "claimSubstatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "claimSubstatus") ? undefined : json["claimSubstatus"],
        "claimCaseNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "claimCaseNumber") ? undefined : json["claimCaseNumber"],
        "westburyStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "westburyStatus") ? undefined : json["westburyStatus"],
        "contribution": json["contribution"],
        "westburyContribution": json["westburyContribution"]
    };
}
function $645c5fc25d13a6f2$export$a159991ef9577e8b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "claimStatus": value.claimStatus,
        "claimSubstatus": value.claimSubstatus,
        "claimCaseNumber": value.claimCaseNumber,
        "westburyStatus": value.westburyStatus,
        "contribution": value.contribution,
        "westburyContribution": value.westburyContribution
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $ad148090174fabc0$export$17170f7064f93b56(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    isInstance = isInstance && "isCover" in value;
    isInstance = isInstance && "isPreferred" in value;
    return isInstance;
}
function $ad148090174fabc0$export$199bc9cc26ea424b(json) {
    return $ad148090174fabc0$export$eb306bf8a3970269(json, false);
}
function $ad148090174fabc0$export$eb306bf8a3970269(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["objectKey"],
        "isCover": json["isCover"],
        "isPreferred": json["isPreferred"]
    };
}
function $ad148090174fabc0$export$d155b6d518bc7cf4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "objectKey": value.objectKey,
        "isCover": value.isCover,
        "isPreferred": value.isPreferred
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $b898f1703102c0f8$export$50320fec2254c4ec(value) {
    let isInstance = true;
    isInstance = isInstance && "contribution" in value;
    isInstance = isInstance && "confidencePattern" in value;
    isInstance = isInstance && "confidenceCategory" in value;
    return isInstance;
}
function $b898f1703102c0f8$export$6727272db99bd9fb(json) {
    return $b898f1703102c0f8$export$9b53e32460c50cff(json, false);
}
function $b898f1703102c0f8$export$9b53e32460c50cff(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "contribution": json["contribution"],
        "confidencePattern": json["confidencePattern"],
        "confidenceCategory": json["confidenceCategory"]
    };
}
function $b898f1703102c0f8$export$adfe0bd7c15fd471(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "contribution": value.contribution,
        "confidencePattern": value.confidencePattern,
        "confidenceCategory": value.confidenceCategory
    };
}


function $f0dc78284e5b686d$export$c441177252ae81f(value) {
    let isInstance = true;
    isInstance = isInstance && "parentRecording" in value;
    isInstance = isInstance && "westburyContributions" in value;
    isInstance = isInstance && "persona" in value;
    isInstance = isInstance && "performance" in value;
    return isInstance;
}
function $f0dc78284e5b686d$export$6b7b0d019ed2729b(json) {
    return $f0dc78284e5b686d$export$73edd13b0a8f31a(json, false);
}
function $f0dc78284e5b686d$export$73edd13b0a8f31a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "parentRecording": (0, $3731a4f638198ea5$export$a1bea63454d8d4ef)(json["parentRecording"]),
        "westburyContributions": json["westburyContributions"].map((0, $b898f1703102c0f8$export$6727272db99bd9fb)),
        "pplContributions": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pplContributions") ? undefined : json["pplContributions"] === null ? null : json["pplContributions"].map((0, $645c5fc25d13a6f2$export$8ac2c111ddc0c214)),
        "persona": (0, $610e8f7d9c5365bf$export$1d0f206a51e5319b)(json["persona"]),
        "person": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "person") ? undefined : json["person"],
        "performance": (0, $08c727e17cc2205a$export$87a5d3c0b5b446fa)(json["performance"]),
        "earliestParentRelease": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "earliestParentRelease") ? undefined : (0, $3b4a70cf4a3f687e$export$34d46539b73b3b6b)(json["earliestParentRelease"]),
        "evidenceReleases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "evidenceReleases") ? undefined : json["evidenceReleases"] === null ? null : json["evidenceReleases"].map((0, $cfb6c0605c8487da$export$fb2e8cdf81242647)),
        "thumbnailEvidenceImage": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "thumbnailEvidenceImage") ? undefined : (0, $ad148090174fabc0$export$199bc9cc26ea424b)(json["thumbnailEvidenceImage"]),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "documentId") ? undefined : json["documentId"]
    };
}
function $f0dc78284e5b686d$export$ce4667857929d9d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "parentRecording": (0, $3731a4f638198ea5$export$91dfdcb8daf96447)(value.parentRecording),
        "westburyContributions": value.westburyContributions.map((0, $b898f1703102c0f8$export$adfe0bd7c15fd471)),
        "pplContributions": value.pplContributions === undefined ? undefined : value.pplContributions === null ? null : value.pplContributions.map((0, $645c5fc25d13a6f2$export$a159991ef9577e8b)),
        "persona": (0, $610e8f7d9c5365bf$export$3f3125a18e66022f)(value.persona),
        "performance": (0, $08c727e17cc2205a$export$90f185072ae6727a)(value.performance),
        "earliestParentRelease": (0, $3b4a70cf4a3f687e$export$5fcfb3f7a7855be)(value.earliestParentRelease),
        "evidenceReleases": value.evidenceReleases === undefined ? undefined : value.evidenceReleases === null ? null : value.evidenceReleases.map((0, $cfb6c0605c8487da$export$cd59ab9a4ca345c9)),
        "thumbnailEvidenceImage": (0, $ad148090174fabc0$export$d155b6d518bc7cf4)(value.thumbnailEvidenceImage),
        "documentId": value.documentId
    };
}


function $73fba44bd928db81$export$62aa05d26c318fb2(value) {
    let isInstance = true;
    isInstance = isInstance && "recordings" in value;
    isInstance = isInstance && "sortArray" in value;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
function $73fba44bd928db81$export$c7fe272dbd4732e2(json) {
    return $73fba44bd928db81$export$13ff6572c29f002d(json, false);
}
function $73fba44bd928db81$export$13ff6572c29f002d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordings": json["recordings"].map((0, $f0dc78284e5b686d$export$6b7b0d019ed2729b)),
        "sortArray": json["sort_array"],
        "count": json["count"]
    };
}
function $73fba44bd928db81$export$62ddbb802bafd084(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordings": value.recordings.map((0, $f0dc78284e5b686d$export$ce4667857929d9d7)),
        "sort_array": value.sortArray,
        "count": value.count
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f360d66880f037a4$export$b3d047d2e54775d0(value) {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $f360d66880f037a4$export$9064002f671ddae3(json) {
    return $f360d66880f037a4$export$aaee631da266a742(json, false);
}
function $f360d66880f037a4$export$aaee631da266a742(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "s3Url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "s3_url") ? undefined : json["s3_url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "s3Key": json["s3_key"],
        "ready": json["ready"],
        "user": json["user"],
        "task": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "task") ? undefined : json["task"]
    };
}
function $f360d66880f037a4$export$eef7c6e6fd70b6cf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "s3_key": value.s3Key,
        "ready": value.ready,
        "user": value.user,
        "task": value.task
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $bfc28da51393fe01$export$76677806829ead24(value) {
    let isInstance = true;
    isInstance = isInstance && "field" in value;
    return isInstance;
}
function $bfc28da51393fe01$export$6747b653e3ac5ccf(json) {
    return $bfc28da51393fe01$export$cdb8eea09b90c044(json, false);
}
function $bfc28da51393fe01$export$cdb8eea09b90c044(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "field": json["field"],
        "value": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "value") ? undefined : json["value"],
        "caseSensitive": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "case_sensitive") ? undefined : json["case_sensitive"]
    };
}
function $bfc28da51393fe01$export$5cc8b448d1bc09d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "field": value.field,
        "value": value.value,
        "case_sensitive": value.caseSensitive
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $e51c30727b502c9c$export$5317b5e7e7c21477 = {
    EvidenceAvailable: "evidence_available",
    ParentRecordingBandArtistNameRaw: "parentRecording.bandArtistName.raw",
    ParentRecordingRecordingTitleRaw: "parentRecording.recordingTitle.raw",
    ParentRecordingDuration: "parentRecording.duration",
    ParentRecordingIsrcs: "parentRecording.isrcs",
    ParentRecordingLive: "parentRecording.live",
    ParentRecordingYearRecorded: "parentRecording.yearRecorded",
    ParentRecordingRecordingVersion: "parentRecording.recordingVersion",
    EarliestParentReleaseReleaseTitleRaw: "earliestParentRelease.releaseTitle.raw",
    EarliestParentReleaseDateReleased: "earliestParentRelease.dateReleased",
    EarliestParentReleaseMediaType: "earliestParentRelease.mediaType",
    EarliestParentReleaseFormat: "earliestParentRelease.format",
    EarliestParentReleaseReleaseLabels: "earliestParentRelease.releaseLabels",
    EarliestParentReleaseCatNumbers: "earliestParentRelease.catNumbers",
    PersonaStageName: "persona.stageName",
    PerformanceFeaturedStatus: "performance.featuredStatus",
    WestburyContributionsWestburyContribution: "westburyContributions.westburyContribution",
    WestburyContributionsContribution: "westburyContributions.contribution"
};
const $e51c30727b502c9c$export$452827c44d4c15fe = {
    Asc: "asc",
    Desc: "desc"
};
function $e51c30727b502c9c$export$9416d36c4a70a208(value) {
    let isInstance = true;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "order" in value;
    return isInstance;
}
function $e51c30727b502c9c$export$90ab6da4d19db1f3(json) {
    return $e51c30727b502c9c$export$b841ccc5d7fd5e9a(json, false);
}
function $e51c30727b502c9c$export$b841ccc5d7fd5e9a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "field": json["field"],
        "order": json["order"]
    };
}
function $e51c30727b502c9c$export$f0a11548a3a59a10(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "field": value.field,
        "order": value.order
    };
}


const $594f7d6be671f0be$export$49ea64c85c445d82 = {
    EvidenceAvailable: "evidence_available",
    ParentRecordingBandArtistNameRaw: "parentRecording.bandArtistName.raw",
    ParentRecordingRecordingTitleRaw: "parentRecording.recordingTitle.raw",
    ParentRecordingDuration: "parentRecording.duration",
    ParentRecordingIsrcs: "parentRecording.isrcs",
    ParentRecordingLive: "parentRecording.live",
    ParentRecordingYearRecorded: "parentRecording.yearRecorded",
    ParentRecordingRecordingVersion: "parentRecording.recordingVersion",
    EarliestParentReleaseReleaseTitleRaw: "earliestParentRelease.releaseTitle.raw",
    EarliestParentReleaseDateReleased: "earliestParentRelease.dateReleased",
    EarliestParentReleaseMediaType: "earliestParentRelease.mediaType",
    EarliestParentReleaseFormat: "earliestParentRelease.format",
    EarliestParentReleaseReleaseLabels: "earliestParentRelease.releaseLabels",
    EarliestParentReleaseCatNumbers: "earliestParentRelease.catNumbers",
    PersonaStageName: "persona.stageName",
    PerformanceFeaturedStatus: "performance.featuredStatus",
    WestburyContributionsWestburyContribution: "westburyContributions.westburyContribution",
    WestburyContributionsContribution: "westburyContributions.contribution"
};
const $594f7d6be671f0be$export$cef15f35c6196202 = {
    Asc: "asc",
    Desc: "desc"
};
function $594f7d6be671f0be$export$25b2993cbc528732(value) {
    let isInstance = true;
    isInstance = isInstance && "size" in value;
    return isInstance;
}
function $594f7d6be671f0be$export$595199061a8de88d(json) {
    return $594f7d6be671f0be$export$308cd19a24025365(json, false);
}
function $594f7d6be671f0be$export$308cd19a24025365(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "size": json["size"],
        "fromOffset": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "from_offset") ? undefined : json["from_offset"],
        "sortField": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sort_field") ? undefined : json["sort_field"],
        "sortOrder": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sort_order") ? undefined : json["sort_order"],
        "sortFields": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sort_fields") ? undefined : json["sort_fields"].map((0, $e51c30727b502c9c$export$90ab6da4d19db1f3)),
        "filters": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "filters") ? undefined : json["filters"],
        "fieldFilters": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "field_filters") ? undefined : json["field_filters"].map((0, $bfc28da51393fe01$export$6747b653e3ac5ccf)),
        "searchTerm": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "search_term") ? undefined : json["search_term"],
        "searchAfter": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "search_after") ? undefined : json["search_after"],
        "confidenceCategory": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "confidence_category") ? undefined : json["confidence_category"],
        "confidencePattern": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "confidence_pattern") ? undefined : json["confidence_pattern"]
    };
}
function $594f7d6be671f0be$export$f75ce5365b9c0f3d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "size": value.size,
        "from_offset": value.fromOffset,
        "sort_field": value.sortField,
        "sort_order": value.sortOrder,
        "sort_fields": value.sortFields === undefined ? undefined : value.sortFields.map((0, $e51c30727b502c9c$export$f0a11548a3a59a10)),
        "filters": value.filters,
        "field_filters": value.fieldFilters === undefined ? undefined : value.fieldFilters.map((0, $bfc28da51393fe01$export$5cc8b448d1bc09d7)),
        "search_term": value.searchTerm,
        "search_after": value.searchAfter,
        "confidence_category": value.confidenceCategory,
        "confidence_pattern": value.confidencePattern
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 








function $3c900270811aff1c$export$248e33fcbf658e43(value) {
    let isInstance = true;
    isInstance = isInstance && "parentRecording" in value;
    isInstance = isInstance && "westburyContributions" in value;
    isInstance = isInstance && "persona" in value;
    isInstance = isInstance && "performance" in value;
    return isInstance;
}
function $3c900270811aff1c$export$ada4d9eb25dcb112(json) {
    return $3c900270811aff1c$export$f7b5d398ee1d534f(json, false);
}
function $3c900270811aff1c$export$f7b5d398ee1d534f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "parentRecording": (0, $3731a4f638198ea5$export$a1bea63454d8d4ef)(json["parentRecording"]),
        "westburyContributions": json["westburyContributions"].map((0, $b898f1703102c0f8$export$6727272db99bd9fb)),
        "pplContributions": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pplContributions") ? undefined : json["pplContributions"] === null ? null : json["pplContributions"].map((0, $645c5fc25d13a6f2$export$8ac2c111ddc0c214)),
        "persona": (0, $610e8f7d9c5365bf$export$1d0f206a51e5319b)(json["persona"]),
        "person": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "person") ? undefined : json["person"],
        "performance": (0, $08c727e17cc2205a$export$87a5d3c0b5b446fa)(json["performance"]),
        "earliestParentRelease": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "earliestParentRelease") ? undefined : (0, $3b4a70cf4a3f687e$export$34d46539b73b3b6b)(json["earliestParentRelease"]),
        "evidenceReleases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "evidenceReleases") ? undefined : json["evidenceReleases"] === null ? null : json["evidenceReleases"].map((0, $cfb6c0605c8487da$export$fb2e8cdf81242647)),
        "thumbnailEvidenceImage": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "thumbnailEvidenceImage") ? undefined : (0, $ad148090174fabc0$export$199bc9cc26ea424b)(json["thumbnailEvidenceImage"]),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "documentId") ? undefined : json["documentId"]
    };
}
function $3c900270811aff1c$export$1c1d7226b8761de1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "parentRecording": (0, $3731a4f638198ea5$export$91dfdcb8daf96447)(value.parentRecording),
        "westburyContributions": value.westburyContributions.map((0, $b898f1703102c0f8$export$adfe0bd7c15fd471)),
        "pplContributions": value.pplContributions === undefined ? undefined : value.pplContributions === null ? null : value.pplContributions.map((0, $645c5fc25d13a6f2$export$a159991ef9577e8b)),
        "persona": (0, $610e8f7d9c5365bf$export$3f3125a18e66022f)(value.persona),
        "performance": (0, $08c727e17cc2205a$export$90f185072ae6727a)(value.performance),
        "earliestParentRelease": (0, $3b4a70cf4a3f687e$export$5fcfb3f7a7855be)(value.earliestParentRelease),
        "evidenceReleases": value.evidenceReleases === undefined ? undefined : value.evidenceReleases === null ? null : value.evidenceReleases.map((0, $cfb6c0605c8487da$export$cd59ab9a4ca345c9)),
        "thumbnailEvidenceImage": (0, $ad148090174fabc0$export$d155b6d518bc7cf4)(value.thumbnailEvidenceImage),
        "documentId": value.documentId
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $a9a60b7d909e927c$export$55e75ce4a796fee3(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "artistId" in value;
    return isInstance;
}
function $a9a60b7d909e927c$export$8d0a2b6fabdfee42(json) {
    return $a9a60b7d909e927c$export$ea78cd278c466d2b(json, false);
}
function $a9a60b7d909e927c$export$ea78cd278c466d2b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "artistId": json["artist_id"],
        "stageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "stageName") ? undefined : json["stageName"],
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"]
    };
}
function $a9a60b7d909e927c$export$d098bec58afd82be(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "artist_id": value.artistId,
        "stageName": value.stageName,
        "featuredStatus": value.featuredStatus
    };
}


function $a63bedf6d1c02e4e$export$8223921823679b96(value) {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    return isInstance;
}
function $a63bedf6d1c02e4e$export$7cc99ae7be222bc8(json) {
    return $a63bedf6d1c02e4e$export$c7cfb966565e5d87(json, false);
}
function $a63bedf6d1c02e4e$export$c7cfb966565e5d87(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "items": json["items"].map((0, $a9a60b7d909e927c$export$8d0a2b6fabdfee42))
    };
}
function $a63bedf6d1c02e4e$export$24ddac3996f19bc3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "items": value.items.map((0, $a9a60b7d909e927c$export$d098bec58afd82be))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $0cdcec0b017126e0$export$32bf8920d43c3bc8(value) {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $0cdcec0b017126e0$export$111868253a411e1(json) {
    return $0cdcec0b017126e0$export$9e47bae0478b2b73(json, false);
}
function $0cdcec0b017126e0$export$9e47bae0478b2b73(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "value": json["value"]
    };
}
function $0cdcec0b017126e0$export$68d9866a9b47a832(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "value": value.value
    };
}


function $c5ee68de501c2d97$export$e16de852a18b394c(value) {
    let isInstance = true;
    return isInstance;
}
function $c5ee68de501c2d97$export$9e9486699847bfff(json) {
    return $c5ee68de501c2d97$export$671d5918a925665e(json, false);
}
function $c5ee68de501c2d97$export$671d5918a925665e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "dataCategory": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "data_category") ? undefined : (0, $0cdcec0b017126e0$export$111868253a411e1)(json["data_category"]),
        "sourceUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_url") ? undefined : (0, $0cdcec0b017126e0$export$111868253a411e1)(json["source_url"]),
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : (0, $0cdcec0b017126e0$export$111868253a411e1)(json["notes"])
    };
}
function $c5ee68de501c2d97$export$dd3fdc343acf2799(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data_category": (0, $0cdcec0b017126e0$export$68d9866a9b47a832)(value.dataCategory),
        "source_url": (0, $0cdcec0b017126e0$export$68d9866a9b47a832)(value.sourceUrl),
        "notes": (0, $0cdcec0b017126e0$export$68d9866a9b47a832)(value.notes)
    };
}


function $59e54e87124284e5$export$ce3fac5d3cc8a923(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $59e54e87124284e5$export$a850390f0bf6fa69(json) {
    return $59e54e87124284e5$export$4e35299ac8187c87(json, false);
}
function $59e54e87124284e5$export$4e35299ac8187c87(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "role": json["role"],
        "dataCategory": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "data_category") ? undefined : json["data_category"],
        "sourceUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_url") ? undefined : json["source_url"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "changes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "changes") ? undefined : (0, $c5ee68de501c2d97$export$9e9486699847bfff)(json["changes"])
    };
}
function $59e54e87124284e5$export$d268ceda818e66aa(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "role": value.role,
        "data_category": value.dataCategory,
        "source_url": value.sourceUrl,
        "notes": value.notes,
        "changes": (0, $c5ee68de501c2d97$export$dd3fdc343acf2799)(value.changes)
    };
}


function $1ef5cf03e6e37cb5$export$b2a47124ef89a1c8(value) {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    return isInstance;
}
function $1ef5cf03e6e37cb5$export$b7d3dad4ccdc8a64(json) {
    return $1ef5cf03e6e37cb5$export$87f4f61fd8f19114(json, false);
}
function $1ef5cf03e6e37cb5$export$87f4f61fd8f19114(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "items": json["items"].map((0, $59e54e87124284e5$export$a850390f0bf6fa69))
    };
}
function $1ef5cf03e6e37cb5$export$e23a965cfb0054d3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "items": value.items.map((0, $59e54e87124284e5$export$d268ceda818e66aa))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f88dd2d339a8f3cd$export$956fe0c819ee16a1(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $f88dd2d339a8f3cd$export$f65edfe35d34c284(json) {
    return $f88dd2d339a8f3cd$export$68954a7778d3a539(json, false);
}
function $f88dd2d339a8f3cd$export$68954a7778d3a539(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "value": json["value"],
        "note": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "note") ? undefined : json["note"]
    };
}
function $f88dd2d339a8f3cd$export$b22cdd812f0ccbad(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "value": value.value,
        "note": value.note
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $29e79cbad6aa27e4$export$a05df4fdcc65835b(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $29e79cbad6aa27e4$export$72c9e89a31761f28(json) {
    return $29e79cbad6aa27e4$export$f4d776354561ab1c(json, false);
}
function $29e79cbad6aa27e4$export$f4d776354561ab1c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "value": json["value"]
    };
}
function $29e79cbad6aa27e4$export$dc8d333628d998ec(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "value": value.value
    };
}


function $0d5f7ce9c4e73629$export$5e796d729a4edaf2(value) {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    return isInstance;
}
function $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d(json) {
    return $0d5f7ce9c4e73629$export$8566fcd17b352dc1(json, false);
}
function $0d5f7ce9c4e73629$export$8566fcd17b352dc1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "items": json["items"].map((0, $29e79cbad6aa27e4$export$72c9e89a31761f28))
    };
}
function $0d5f7ce9c4e73629$export$97793a45ed012b8f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "items": value.items.map((0, $29e79cbad6aa27e4$export$dc8d333628d998ec))
    };
}


function $9387c5c729593c47$export$81cccd092181a099(value) {
    let isInstance = true;
    return isInstance;
}
function $9387c5c729593c47$export$43e9bb2e1e2c0dcf(json) {
    return $9387c5c729593c47$export$4afe77f1bc9be580(json, false);
}
function $9387c5c729593c47$export$4afe77f1bc9be580(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingTitle": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "recordingTitle") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["recordingTitle"]),
        "duration": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "duration") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["duration"]),
        "live": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "live") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["live"]),
        "countryOfRecording": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "countryOfRecording") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["countryOfRecording"]),
        "bandArtistName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bandArtistName") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["bandArtistName"]),
        "recordingVersion": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "recordingVersion") ? undefined : (0, $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d)(json["recordingVersion"]),
        "isrcs": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "isrcs") ? undefined : (0, $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d)(json["isrcs"]),
        "artists": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "artists") ? undefined : (0, $a63bedf6d1c02e4e$export$7cc99ae7be222bc8)(json["artists"]),
        "contributions": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "contributions") ? undefined : (0, $1ef5cf03e6e37cb5$export$b7d3dad4ccdc8a64)(json["contributions"])
    };
}
function $9387c5c729593c47$export$89f72ed0ea08f5f9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordingTitle": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.recordingTitle),
        "duration": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.duration),
        "live": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.live),
        "countryOfRecording": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.countryOfRecording),
        "bandArtistName": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.bandArtistName),
        "recordingVersion": (0, $0d5f7ce9c4e73629$export$97793a45ed012b8f)(value.recordingVersion),
        "isrcs": (0, $0d5f7ce9c4e73629$export$97793a45ed012b8f)(value.isrcs),
        "artists": (0, $a63bedf6d1c02e4e$export$24ddac3996f19bc3)(value.artists),
        "contributions": (0, $1ef5cf03e6e37cb5$export$e23a965cfb0054d3)(value.contributions)
    };
}


function $6f54614e625a1e21$export$4bce3285f777433f(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "fields" in value;
    return isInstance;
}
function $6f54614e625a1e21$export$fe5b5320f70cac03(json) {
    return $6f54614e625a1e21$export$c16e988493e07927(json, false);
}
function $6f54614e625a1e21$export$c16e988493e07927(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingId": json["recording_id"],
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"],
        "fields": (0, $9387c5c729593c47$export$43e9bb2e1e2c0dcf)(json["fields"])
    };
}
function $6f54614e625a1e21$export$4b2a821ebebae3af(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recording_id": value.recordingId,
        "document_id": value.documentId,
        "fields": (0, $9387c5c729593c47$export$89f72ed0ea08f5f9)(value.fields)
    };
}


















/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 


function $55c25854bc3771e3$export$189ad02a46fabd98(value) {
    let isInstance = true;
    return isInstance;
}
function $55c25854bc3771e3$export$7f05bd4b294c857a(json) {
    return $55c25854bc3771e3$export$ac572ff037a60050(json, false);
}
function $55c25854bc3771e3$export$ac572ff037a60050(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseTitle": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseTitle") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["releaseTitle"]),
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["dateReleased"]),
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["format"]),
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["mediaType"]),
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : (0, $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d)(json["releaseLabels"]),
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : (0, $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d)(json["catNumbers"])
    };
}
function $55c25854bc3771e3$export$1614876d3ae281ce(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "releaseTitle": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.releaseTitle),
        "dateReleased": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.dateReleased),
        "format": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.format),
        "mediaType": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.mediaType),
        "releaseLabels": (0, $0d5f7ce9c4e73629$export$97793a45ed012b8f)(value.releaseLabels),
        "catNumbers": (0, $0d5f7ce9c4e73629$export$97793a45ed012b8f)(value.catNumbers)
    };
}


function $65f4a611b3c4875f$export$6987d5e985497fe8(value) {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "fields" in value;
    return isInstance;
}
function $65f4a611b3c4875f$export$4cb227311f1acab6(json) {
    return $65f4a611b3c4875f$export$f42562b546050e0b(json, false);
}
function $65f4a611b3c4875f$export$f42562b546050e0b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseId": json["release_id"],
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"],
        "fields": (0, $55c25854bc3771e3$export$7f05bd4b294c857a)(json["fields"])
    };
}
function $65f4a611b3c4875f$export$d2523e97d879279b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "release_id": value.releaseId,
        "document_id": value.documentId,
        "fields": (0, $55c25854bc3771e3$export$1614876d3ae281ce)(value.fields)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $fb6864c8a884a76f$export$ac035f67eb615957 = {
    Manager: "Manager",
    Accountant: "Accountant",
    Lawyer: "Lawyer",
    Representative: "Representative",
    Company: "Company"
};
function $fb6864c8a884a76f$export$af3ec760d5c309b2(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $fb6864c8a884a76f$export$8e0354464941eec8(json) {
    return $fb6864c8a884a76f$export$1a4b3155ae06660d(json, false);
}
function $fb6864c8a884a76f$export$1a4b3155ae06660d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": json["name"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"]
    };
}
function $fb6864c8a884a76f$export$4b283602380be6d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name,
        "role": value.role,
        "email": value.email,
        "phone_number": value.phoneNumber
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $fbe666a5f63b7744$export$1e580019c91d2879(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $fbe666a5f63b7744$export$5de9333a3592861b(json) {
    return $fbe666a5f63b7744$export$fa2d0ed67a1e10ed(json, false);
}
function $fbe666a5f63b7744$export$fa2d0ed67a1e10ed(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "name": json["name"]
    };
}
function $fbe666a5f63b7744$export$ba6fd24a04f74d04(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $127d41a480bfebb5$export$b3a0f63189a6d853(value) {
    let isInstance = true;
    isInstance = isInstance && "societyIds" in value;
    return isInstance;
}
function $127d41a480bfebb5$export$e531c1c6f9ecf6a(json) {
    return $127d41a480bfebb5$export$5446bb4ea6624c36(json, false);
}
function $127d41a480bfebb5$export$5446bb4ea6624c36(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "societyIds": json["society_ids"]
    };
}
function $127d41a480bfebb5$export$d5d6d6d331f97390(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_ids": value.societyIds
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $d8377f2314aa254f$export$5c49de2a82e57f01(value) {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "westburyId" in value;
    isInstance = isInstance && "recordingId" in value;
    return isInstance;
}
function $d8377f2314aa254f$export$7ea13f7ccecd0306(json) {
    return $d8377f2314aa254f$export$fac87e48787a655e(json, false);
}
function $d8377f2314aa254f$export$fac87e48787a655e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "success": json["success"],
        "userId": json["user_id"],
        "westburyId": json["westbury_id"],
        "recordingId": json["recording_id"],
        "errors": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"]
    };
}
function $d8377f2314aa254f$export$446b110a7a1819f9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "success": value.success,
        "user_id": value.userId,
        "westbury_id": value.westburyId,
        "recording_id": value.recordingId,
        "errors": value.errors
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $72f4e69f2b514d47$export$6dcf90148336e5b4 = {
    ClientToSign: "client_to_sign",
    WithClient: "with_client",
    AdminToSign: "admin_to_sign",
    AwaitingUpload: "awaiting_upload",
    Approved: "approved"
};
function $72f4e69f2b514d47$export$bff4bced64cce6ab(value) {
    let isInstance = true;
    isInstance = isInstance && "societyFormSubRoleId" in value;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "societyForm" in value;
    return isInstance;
}
function $72f4e69f2b514d47$export$77dcf6f4e2270d7c(json) {
    return $72f4e69f2b514d47$export$a7f743a938f3b994(json, false);
}
function $72f4e69f2b514d47$export$a7f743a938f3b994(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "societyFormSubRoleId": json["society_form_sub_role_id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "complete": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "complete") ? undefined : json["complete"],
        "dateCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsSessionId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"],
        "pandadocsDocumentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsDocumentS3Key": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_s3_key") ? undefined : json["pandadocs_document_s3_key"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "user": json["user"],
        "societyForm": json["society_form"]
    };
}
function $72f4e69f2b514d47$export$92836d79ac6d6184(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_form_sub_role_id": value.societyFormSubRoleId,
        "complete": value.complete,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_session_id": value.pandadocsSessionId,
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_document_s3_key": value.pandadocsDocumentS3Key,
        "status": value.status,
        "user": value.user,
        "society_form": value.societyForm
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $869b74c0caa98889$export$3b5798f51f9c7c57(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $869b74c0caa98889$export$1cee1562e0d40484(json) {
    return $869b74c0caa98889$export$73ba85c8a65d5a09(json, false);
}
function $869b74c0caa98889$export$73ba85c8a65d5a09(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"],
        "access": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "access") ? undefined : json["access"]
    };
}
function $869b74c0caa98889$export$2744b1fd1031a21(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


function $981738fd9f9cc5a3$export$c48671821948626(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "groups" in value;
    return isInstance;
}
function $981738fd9f9cc5a3$export$c63fd8bf0afb13bd(json) {
    return $981738fd9f9cc5a3$export$519a1b84938ba377(json, false);
}
function $981738fd9f9cc5a3$export$519a1b84938ba377(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": (0, $869b74c0caa98889$export$1cee1562e0d40484)(json["token"]),
        "userId": json["user_id"],
        "email": json["email"],
        "groups": json["groups"]
    };
}
function $981738fd9f9cc5a3$export$4df6be20382d0609(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": (0, $869b74c0caa98889$export$2744b1fd1031a21)(value.token),
        "user_id": value.userId,
        "email": value.email,
        "groups": value.groups
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $7f55453984ef7fbf$export$cf0ecddd0fe5c1c3(value) {
    let isInstance = true;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "passwordConfirm" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "hash" in value;
    return isInstance;
}
function $7f55453984ef7fbf$export$8c6139077c2f8511(json) {
    return $7f55453984ef7fbf$export$8b9dce09bf39bd4(json, false);
}
function $7f55453984ef7fbf$export$8b9dce09bf39bd4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": json["password"],
        "passwordConfirm": json["password_confirm"],
        "email": json["email"],
        "hash": json["hash"]
    };
}
function $7f55453984ef7fbf$export$eca3401b04c34cf9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password,
        "password_confirm": value.passwordConfirm,
        "email": value.email,
        "hash": value.hash
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $25f117375b97ece2$export$12b161aef0b5ecb5(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "groups" in value;
    return isInstance;
}
function $25f117375b97ece2$export$f36f5aa70c133e5(json) {
    return $25f117375b97ece2$export$afea3a8d814adcbc(json, false);
}
function $25f117375b97ece2$export$afea3a8d814adcbc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": (0, $869b74c0caa98889$export$1cee1562e0d40484)(json["token"]),
        "userId": json["user_id"],
        "email": json["email"],
        "groups": json["groups"]
    };
}
function $25f117375b97ece2$export$9771d49f32ac0d74(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": (0, $869b74c0caa98889$export$2744b1fd1031a21)(value.token),
        "user_id": value.userId,
        "email": value.email,
        "groups": value.groups
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $aff6aee9f926ab64$export$e9c99534c92dd775 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $aff6aee9f926ab64$export$2f92200ee75a8aa1 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
function $aff6aee9f926ab64$export$34e336db3101ecaa(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "societyForms" in value;
    return isInstance;
}
function $aff6aee9f926ab64$export$4ce4e8492a820cd5(json) {
    return $aff6aee9f926ab64$export$95c1b09bff6b823e(json, false);
}
function $aff6aee9f926ab64$export$95c1b09bff6b823e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "website": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "website") ? undefined : json["website"],
        "portal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "portal") ? undefined : json["portal"],
        "phone": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "address": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "address") ? undefined : json["address"],
        "additionalTerritories": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "additional_territories") ? undefined : json["additional_territories"],
        "societyForms": json["society_forms"].map((0, $27e4b52526fc9e58$export$1c504095e8fb3130)),
        "formEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_email") ? undefined : json["form_email"],
        "formPostalAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_postal_address") ? undefined : json["form_postal_address"],
        "formPortal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_portal") ? undefined : json["form_portal"],
        "formReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_frequency") ? undefined : json["form_reminder_frequency"],
        "formStopReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_stop_reminder_frequency") ? undefined : json["form_stop_reminder_frequency"],
        "formReminderSendTo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_send_to") ? undefined : json["form_reminder_send_to"]
    };
}
function $aff6aee9f926ab64$export$8f504a6ae2db7503(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "country": value.country,
        "website": value.website,
        "portal": value.portal,
        "phone": value.phone,
        "address": value.address,
        "additional_territories": value.additionalTerritories,
        "society_forms": value.societyForms.map((0, $27e4b52526fc9e58$export$6f4fbe925053dc34)),
        "form_email": value.formEmail,
        "form_postal_address": value.formPostalAddress,
        "form_portal": value.formPortal,
        "form_reminder_frequency": value.formReminderFrequency,
        "form_stop_reminder_frequency": value.formStopReminderFrequency,
        "form_reminder_send_to": value.formReminderSendTo
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $ec1fec872195ff2d$export$4648418e7dd54936 = {
    General: "General",
    Account: "Account",
    Membership: "Membership",
    Discography: "Discography",
    Distributions: "Distributions",
    Legal: "Legal",
    Estate: "Estate"
};
function $ec1fec872195ff2d$export$5322af60ad7c7f5c(value) {
    let isInstance = true;
    return isInstance;
}
function $ec1fec872195ff2d$export$63ba8169be3c7618(json) {
    return $ec1fec872195ff2d$export$58bf5bf944688192(json, false);
}
function $ec1fec872195ff2d$export$58bf5bf944688192(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "society": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society") ? undefined : json["society"],
        "name": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "name") ? undefined : json["name"],
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phone": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"]
    };
}
function $ec1fec872195ff2d$export$95c71efc51569347(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society": value.society,
        "name": value.name,
        "email": value.email,
        "phone": value.phone,
        "role": value.role
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $562ad623013da697$export$ec3e8484dcd018a9(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $562ad623013da697$export$46847c4110a69b3c(json) {
    return $562ad623013da697$export$b46ebf2f562f8f7c(json, false);
}
function $562ad623013da697$export$b46ebf2f562f8f7c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "fieldsList": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "fields_list") ? undefined : json["fields_list"],
        "prepopulatedData": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "prepopulated_data") ? undefined : json["prepopulated_data"]
    };
}
function $562ad623013da697$export$7163e8e46126598f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "fields_list": value.fieldsList
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $efe484b832d95e72$export$bebbe8f42e79a1f0 = {
    Digital: "Digital",
    Physical: "Physical"
};
const $efe484b832d95e72$export$2ff726ead5d5b9cc = {
    Email: "Email",
    Post: "Post",
    Portal: "Portal"
};
const $efe484b832d95e72$export$b2ac61b2aa882589 = {
    Admin: "Admin",
    Client: "Client",
    Both: "Both"
};
function $efe484b832d95e72$export$52a1d25d6d0aab23(value) {
    let isInstance = true;
    isInstance = isInstance && "signature" in value;
    isInstance = isInstance && "sendVia" in value;
    isInstance = isInstance && "signedBy" in value;
    return isInstance;
}
function $efe484b832d95e72$export$d56dbf7ef410e69d(json) {
    return $efe484b832d95e72$export$f7755f1feaeb76c1(json, false);
}
function $efe484b832d95e72$export$f7755f1feaeb76c1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "form": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form") ? undefined : json["form"],
        "signature": json["signature"],
        "sendVia": json["send_via"],
        "signedBy": json["signed_by"]
    };
}
function $efe484b832d95e72$export$e8abf7927ee3b8d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "form": value.form,
        "signature": value.signature,
        "send_via": value.sendVia,
        "signed_by": value.signedBy
    };
}


const $50e4c7544de1252c$export$17dd5a46c1eb75e2 = {
    PerformerProducer: "Performer/Producer"
};
function $50e4c7544de1252c$export$b273201667dd37f7(value) {
    let isInstance = true;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $50e4c7544de1252c$export$f1fe62ab070fcdf2(json) {
    return $50e4c7544de1252c$export$b245200d3755bb1d(json, false);
}
function $50e4c7544de1252c$export$b245200d3755bb1d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "society": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society") ? undefined : json["society"],
        "role": json["role"],
        "forms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "forms") ? undefined : json["forms"].map((0, $efe484b832d95e72$export$d56dbf7ef410e69d))
    };
}
function $50e4c7544de1252c$export$56f10f9a830e34dc(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society": value.society,
        "role": value.role,
        "forms": value.forms === undefined ? undefined : value.forms.map((0, $efe484b832d95e72$export$e8abf7927ee3b8d7))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e5a7345d54d6d03d$export$b45fe60f9567fb79(value) {
    let isInstance = true;
    isInstance = isInstance && "accountId" in value;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "registeredArtistName" in value;
    return isInstance;
}
function $e5a7345d54d6d03d$export$bb3697041e7b91b9(json) {
    return $e5a7345d54d6d03d$export$c6522a0c7db32059(json, false);
}
function $e5a7345d54d6d03d$export$c6522a0c7db32059(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "accountId": json["account_id"],
        "username": json["username"],
        "password": json["password"],
        "registeredArtistName": json["registered_artist_name"]
    };
}
function $e5a7345d54d6d03d$export$2c1b8ecf10e555ad(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "account_id": value.accountId,
        "username": value.username,
        "password": value.password,
        "registered_artist_name": value.registeredArtistName
    };
}


function $35776a150092e6a3$export$5d056ca78f56fef1(value) {
    let isInstance = true;
    isInstance = isInstance && "societyName" in value;
    isInstance = isInstance && "societyId" in value;
    isInstance = isInstance && "societyPortal" in value;
    return isInstance;
}
function $35776a150092e6a3$export$5f5240b422f10d0e(json) {
    return $35776a150092e6a3$export$2aed0cbe5ea2318(json, false);
}
function $35776a150092e6a3$export$2aed0cbe5ea2318(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "societyName": json["society_name"],
        "societyId": json["society_id"],
        "societyPortal": json["society_portal"],
        "data": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $e5a7345d54d6d03d$export$bb3697041e7b91b9)(json["data"])
    };
}
function $35776a150092e6a3$export$6fe32b6048559226(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_name": value.societyName,
        "society_id": value.societyId,
        "society_portal": value.societyPortal,
        "data": (0, $e5a7345d54d6d03d$export$2c1b8ecf10e555ad)(value.data)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $e8d4d8c5da6c3189$export$fa3e1c051331f9f2 = {
    ClientToSign: "client_to_sign",
    AdminToSign: "admin_to_sign",
    Complete: "complete",
    Approved: "approved"
};
function $e8d4d8c5da6c3189$export$d90bf2779fe7a73a(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "society" in value;
    return isInstance;
}
function $e8d4d8c5da6c3189$export$2056379903cf98a2(json) {
    return $e8d4d8c5da6c3189$export$55ba140af2252a5d(json, false);
}
function $e8d4d8c5da6c3189$export$55ba140af2252a5d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "complete": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "complete") ? undefined : json["complete"],
        "dateCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "user": json["user"],
        "society": json["society"]
    };
}
function $e8d4d8c5da6c3189$export$17447fa1ae630ace(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "complete": value.complete,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "status": value.status,
        "user": value.user,
        "society": value.society
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $214bb8fddc542766$export$39b4642885f571d0(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "originalName" in value;
    isInstance = isInstance && "valid" in value;
    return isInstance;
}
function $214bb8fddc542766$export$5754b3e47aa5480(json) {
    return $214bb8fddc542766$export$9c5e38235ff78a24(json, false);
}
function $214bb8fddc542766$export$9c5e38235ff78a24(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "originalName": json["original_name"],
        "valid": json["valid"],
        "rejected": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "rejected") ? undefined : json["rejected"],
        "approved": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "approved") ? undefined : json["approved"],
        "createdBySystem": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "created_by_system") ? undefined : json["created_by_system"]
    };
}
function $214bb8fddc542766$export$757696cdcc528ad2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "original_name": value.originalName,
        "valid": value.valid,
        "rejected": value.rejected,
        "approved": value.approved,
        "created_by_system": value.createdBySystem
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $31624599b33d4e98$export$21e680d35b1135f6 = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
const $31624599b33d4e98$export$878104e7c717f4d3 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $31624599b33d4e98$export$33a1dc0a429d7dc1(value) {
    let isInstance = true;
    isInstance = isInstance && "clientName" in value;
    isInstance = isInstance && "commission" in value;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "remittanceMethod" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "totalPayable" in value;
    return isInstance;
}
function $31624599b33d4e98$export$faa43dfc7cc59cc0(json) {
    return $31624599b33d4e98$export$881b612e3fa51a91(json, false);
}
function $31624599b33d4e98$export$881b612e3fa51a91(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "clientName": json["client_name"],
        "commission": json["commission"],
        "paymentDate": json["payment_date"],
        "remittanceMethod": json["remittance_method"],
        "status": json["status"],
        "totalAmountReceived": json["total_amount_received"],
        "totalPayable": json["total_payable"]
    };
}
function $31624599b33d4e98$export$3560166a675d0203(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "client_name": value.clientName,
        "commission": value.commission,
        "payment_date": value.paymentDate,
        "remittance_method": value.remittanceMethod,
        "status": value.status,
        "total_amount_received": value.totalAmountReceived,
        "total_payable": value.totalPayable
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $3eb2e3e0b69a0322$export$70717bdda59910f1 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $3eb2e3e0b69a0322$export$e22f73c146466db0(value) {
    let isInstance = true;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amountPaidToClient" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "comission" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "dateCreated" in value;
    return isInstance;
}
function $3eb2e3e0b69a0322$export$eaae7f36aa679238(json) {
    return $3eb2e3e0b69a0322$export$328a43810608839(json, false);
}
function $3eb2e3e0b69a0322$export$328a43810608839(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "paymentDate": new Date(json["payment_date"]),
        "amountPaidToClient": json["amount_paid_to_client"],
        "totalAmountReceived": json["total_amount_received"],
        "comission": json["comission"],
        "status": json["status"],
        "fromSociety": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "from_society") ? undefined : json["from_society"],
        "dateCreated": new Date(json["date_created"])
    };
}
function $3eb2e3e0b69a0322$export$89244da8fad78f14(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "payment_date": value.paymentDate.toISOString(),
        "amount_paid_to_client": value.amountPaidToClient,
        "total_amount_received": value.totalAmountReceived,
        "comission": value.comission,
        "status": value.status,
        "date_created": value.dateCreated.toISOString()
    };
}


function $168756c1563daff7$export$51032390887d36f9(value) {
    let isInstance = true;
    isInstance = isInstance && "metadata" in value;
    isInstance = isInstance && "payments" in value;
    return isInstance;
}
function $168756c1563daff7$export$b7af3949b8b2f080(json) {
    return $168756c1563daff7$export$80fd014de69f5f16(json, false);
}
function $168756c1563daff7$export$80fd014de69f5f16(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "metadata": (0, $31624599b33d4e98$export$faa43dfc7cc59cc0)(json["metadata"]),
        "payments": json["payments"].map((0, $3eb2e3e0b69a0322$export$eaae7f36aa679238))
    };
}
function $168756c1563daff7$export$7dc0365fc5810aa1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "metadata": (0, $31624599b33d4e98$export$3560166a675d0203)(value.metadata),
        "payments": value.payments.map((0, $3eb2e3e0b69a0322$export$89244da8fad78f14))
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $98a0cfd0de059254$export$7863502ca02bbd4a = {
    Nationality: "Nationality",
    CountryOfResidence: "Country of Residence",
    IndividualEntity: "Individual/Entity"
};
const $98a0cfd0de059254$export$7ee335bbab600dbd = {
    Digital: "Digital",
    Physical: "Physical"
};
const $98a0cfd0de059254$export$f7659d1e74e3e = {
    Email: "Email",
    Post: "Post",
    Portal: "Portal"
};
const $98a0cfd0de059254$export$9d64d4ed81e41585 = {
    Admin: "Admin",
    Client: "Client",
    Both: "Both"
};
function $98a0cfd0de059254$export$1ebd7e0a4a9be921(value) {
    let isInstance = true;
    return isInstance;
}
function $98a0cfd0de059254$export$9f84e25690d8699e(json) {
    return $98a0cfd0de059254$export$842afaa286f1da15(json, false);
}
function $98a0cfd0de059254$export$842afaa286f1da15(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "society": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society") ? undefined : json["society"],
        "determinedBy": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "determined_by") ? undefined : json["determined_by"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "form": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form") ? undefined : json["form"],
        "signature": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "signature") ? undefined : json["signature"],
        "sendVia": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "send_via") ? undefined : json["send_via"],
        "signedBy": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "signed_by") ? undefined : json["signed_by"]
    };
}
function $98a0cfd0de059254$export$233fd552ad9ab6f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society": value.society,
        "determined_by": value.determinedBy,
        "country": value.country,
        "form": value.form,
        "signature": value.signature,
        "send_via": value.sendVia,
        "signed_by": value.signedBy
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $0357ead1ed5cb684$export$5e11be6023d3fb10 = {
    WestburyIncome: "westbury_income",
    ClientIncome: "client_income"
};
function $0357ead1ed5cb684$export$e0ceb335a5ba7a2a(value) {
    let isInstance = true;
    isInstance = isInstance && "percentage" in value;
    isInstance = isInstance && "expirationDate" in value;
    return isInstance;
}
function $0357ead1ed5cb684$export$7760765d57b73a3c(json) {
    return $0357ead1ed5cb684$export$e0601f40fc4990b5(json, false);
}
function $0357ead1ed5cb684$export$e0601f40fc4990b5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "termsOfAgreement": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "terms_of_agreement") ? undefined : json["terms_of_agreement"],
        "percentage": json["percentage"],
        "takenFrom": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "taken_from") ? undefined : json["taken_from"],
        "expirationDate": new Date(json["expiration_date"])
    };
}
function $0357ead1ed5cb684$export$37aa6c3747842171(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "terms_of_agreement": value.termsOfAgreement,
        "percentage": value.percentage,
        "taken_from": value.takenFrom,
        "expiration_date": value.expirationDate.toISOString().substr(0, 10)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $69d9e78182e9a994$export$d2f5d6ae44181790(value) {
    let isInstance = true;
    isInstance = isInstance && "threshold" in value;
    isInstance = isInstance && "commissionRate" in value;
    return isInstance;
}
function $69d9e78182e9a994$export$146bd92570d970b2(json) {
    return $69d9e78182e9a994$export$ccf15ad90decd1c0(json, false);
}
function $69d9e78182e9a994$export$ccf15ad90decd1c0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "threshold": json["threshold"],
        "commissionRate": json["commission_rate"],
        "termsOfAgreement": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "terms_of_agreement") ? undefined : json["terms_of_agreement"]
    };
}
function $69d9e78182e9a994$export$3df3e4ef02c2d02e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "threshold": value.threshold,
        "commission_rate": value.commissionRate,
        "terms_of_agreement": value.termsOfAgreement
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $d518892628822f2a$export$dc72b2cd65abc23c(value) {
    let isInstance = true;
    isInstance = isInstance && "commissionRate" in value;
    return isInstance;
}
function $d518892628822f2a$export$11b5b659144213b8(json) {
    return $d518892628822f2a$export$462f70391cc28325(json, false);
}
function $d518892628822f2a$export$462f70391cc28325(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "commissionRate": json["commission_rate"],
        "termsOfAgreement": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "terms_of_agreement") ? undefined : json["terms_of_agreement"],
        "society": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society") ? undefined : json["society"]
    };
}
function $d518892628822f2a$export$7b494f55f323d779(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "commission_rate": value.commissionRate,
        "terms_of_agreement": value.termsOfAgreement,
        "society": value.society
    };
}


const $41529a4feb258a75$export$4d5f5bd86d543335 = {
    NetIncome: "net_income",
    GrossIncome: "gross_income"
};
const $41529a4feb258a75$export$202f41735a76d71c = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
function $41529a4feb258a75$export$9c4d99551766cbee(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $41529a4feb258a75$export$aad686261db31a8a(json) {
    return $41529a4feb258a75$export$3e50c160b905d5e1(json, false);
}
function $41529a4feb258a75$export$3e50c160b905d5e1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "slidingScales": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sliding_scales") ? undefined : json["sliding_scales"].map((0, $69d9e78182e9a994$export$146bd92570d970b2)),
        "representativeFee": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative_fee") ? undefined : (0, $0357ead1ed5cb684$export$7760765d57b73a3c)(json["representative_fee"]),
        "societyCommissionRates": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society_commission_rates") ? undefined : json["society_commission_rates"].map((0, $d518892628822f2a$export$11b5b659144213b8)),
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "standardAgreement": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "standard_agreement") ? undefined : json["standard_agreement"],
        "commissionRate": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "commission_rate") ? undefined : json["commission_rate"],
        "minimumPayment": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "minimum_payment") ? undefined : json["minimum_payment"],
        "universalSocietyCommissionRate": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "universal_society_commission_rate") ? undefined : json["universal_society_commission_rate"],
        "performerOrProducer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "masterRights": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "universalMandate": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "universal_mandate") ? undefined : json["universal_mandate"],
        "slidingScaleRequired": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sliding_scale_required") ? undefined : json["sliding_scale_required"],
        "slidingScaleBasedOn": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sliding_scale_based_on") ? undefined : json["sliding_scale_based_on"],
        "bankPaymentMethod": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_payment_method") ? undefined : json["bank_payment_method"],
        "representativeFeeRequired": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative_fee_required") ? undefined : json["representative_fee_required"],
        "clientRequiresAdvance": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "client_requires_advance") ? undefined : json["client_requires_advance"],
        "advanceAmount": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "advance_amount") ? undefined : json["advance_amount"],
        "user": json["user"],
        "mandatedSocieties": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mandated_societies") ? undefined : json["mandated_societies"]
    };
}
function $41529a4feb258a75$export$65df8c0be059cbe4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "sliding_scales": value.slidingScales === undefined ? undefined : value.slidingScales.map((0, $69d9e78182e9a994$export$3df3e4ef02c2d02e)),
        "representative_fee": (0, $0357ead1ed5cb684$export$37aa6c3747842171)(value.representativeFee),
        "society_commission_rates": value.societyCommissionRates === undefined ? undefined : value.societyCommissionRates.map((0, $d518892628822f2a$export$7b494f55f323d779)),
        "standard_agreement": value.standardAgreement,
        "commission_rate": value.commissionRate,
        "minimum_payment": value.minimumPayment,
        "universal_society_commission_rate": value.universalSocietyCommissionRate,
        "performer_or_producer": value.performerOrProducer,
        "master_rights": value.masterRights,
        "universal_mandate": value.universalMandate,
        "sliding_scale_required": value.slidingScaleRequired,
        "sliding_scale_based_on": value.slidingScaleBasedOn,
        "bank_payment_method": value.bankPaymentMethod,
        "representative_fee_required": value.representativeFeeRequired,
        "client_requires_advance": value.clientRequiresAdvance,
        "advance_amount": value.advanceAmount,
        "user": value.user,
        "mandated_societies": value.mandatedSocieties
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $d476a6f9711ba447$export$27f9141651d6e072(value) {
    let isInstance = true;
    isInstance = isInstance && "documentName" in value;
    isInstance = isInstance && "documentId" in value;
    return isInstance;
}
function $d476a6f9711ba447$export$fa6db7898acc8c89(json) {
    return $d476a6f9711ba447$export$8187a977117d8087(json, false);
}
function $d476a6f9711ba447$export$8187a977117d8087(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentName": json["document_name"],
        "documentId": json["document_id"]
    };
}
function $d476a6f9711ba447$export$a548d1ba2cc44552(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_name": value.documentName,
        "document_id": value.documentId
    };
}


function $4043810f8d026b69$export$7eda4f746e674958(value) {
    let isInstance = true;
    return isInstance;
}
function $4043810f8d026b69$export$a2a4439062823c60(json) {
    return $4043810f8d026b69$export$ab040386e4dbcdae(json, false);
}
function $4043810f8d026b69$export$ab040386e4dbcdae(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "done": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "done") ? undefined : json["done"],
        "pandadocDocumentIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadoc_document_ids") ? undefined : json["pandadoc_document_ids"].map((0, $d476a6f9711ba447$export$fa6db7898acc8c89))
    };
}
function $4043810f8d026b69$export$5d0069a94b99dc48(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "done": value.done,
        "pandadoc_document_ids": value.pandadocDocumentIds === undefined ? undefined : value.pandadocDocumentIds.map((0, $d476a6f9711ba447$export$a548d1ba2cc44552))
    };
}






/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $eb13e3b5d4558e89$export$eade3e1f30f49357(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $eb13e3b5d4558e89$export$b5cfec7638e86e16(json) {
    return $eb13e3b5d4558e89$export$f24a65443b816594(json, false);
}
function $eb13e3b5d4558e89$export$f24a65443b816594(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"]
    };
}
function $eb13e3b5d4558e89$export$68354c35e74dadb8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $7b35bec082706873$export$517c6e0854a1425d(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $7b35bec082706873$export$a57843fa58a86c18(json) {
    return $7b35bec082706873$export$6d85bd90d9e45bc5(json, false);
}
function $7b35bec082706873$export$6d85bd90d9e45bc5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "username": json["username"],
        "password": json["password"]
    };
}
function $7b35bec082706873$export$dc065df2aa624562(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username,
        "password": value.password
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $3650756ad18dc91b$export$64edab5d36dd34cc(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $3650756ad18dc91b$export$874d3e01e6e7fdc8(json) {
    return $3650756ad18dc91b$export$fcd7ac86b1eab9d0(json, false);
}
function $3650756ad18dc91b$export$fcd7ac86b1eab9d0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"],
        "access": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "access") ? undefined : json["access"]
    };
}
function $3650756ad18dc91b$export$f77999a70380c6a3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $db11163f6e91414a$export$64ceed618d1d7c77(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    return isInstance;
}
function $db11163f6e91414a$export$dd924f4825888164(json) {
    return $db11163f6e91414a$export$c965e2ef0d36bdfa(json, false);
}
function $db11163f6e91414a$export$c965e2ef0d36bdfa(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": json["token"]
    };
}
function $db11163f6e91414a$export$62af2150040a6d3b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": value.token
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $d064efbbb98dc469$export$7af55014e965e7e1(value) {
    let isInstance = true;
    isInstance = isInstance && "aliasId" in value;
    return isInstance;
}
function $d064efbbb98dc469$export$a3833eba408058ee(json) {
    return $d064efbbb98dc469$export$83e7accb517e658e(json, false);
}
function $d064efbbb98dc469$export$83e7accb517e658e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aliasId": json["alias_id"]
    };
}
function $d064efbbb98dc469$export$7965ee62db2629e0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "alias_id": value.aliasId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $c6c420569328d714$export$3478de25acfd2213(value) {
    let isInstance = true;
    isInstance = isInstance && "dateSentToSociety" in value;
    return isInstance;
}
function $c6c420569328d714$export$8bbfe98d5513cd56(json) {
    return $c6c420569328d714$export$473bdeb040edbcc5(json, false);
}
function $c6c420569328d714$export$473bdeb040edbcc5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "dateSentToSociety": new Date(json["date_sent_to_society"])
    };
}
function $c6c420569328d714$export$d0a38c5e29567915(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "date_sent_to_society": value.dateSentToSociety.toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $fb099ad6aecf7035$export$5ca1ab75a8050bc3 = {
    ClientToSign: "client_to_sign",
    WithClient: "with_client",
    AdminToSign: "admin_to_sign",
    AwaitingUpload: "awaiting_upload",
    Approved: "approved"
};
function $fb099ad6aecf7035$export$3cc3b5fbb5c514e3(value) {
    let isInstance = true;
    isInstance = isInstance && "societyFormSubRoleId" in value;
    isInstance = isInstance && "file" in value;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "societyForm" in value;
    return isInstance;
}
function $fb099ad6aecf7035$export$a42a6ebf0e680196(json) {
    return $fb099ad6aecf7035$export$8fc0979a8db5498(json, false);
}
function $fb099ad6aecf7035$export$8fc0979a8db5498(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "societyFormSubRoleId": json["society_form_sub_role_id"],
        "file": json["file"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "complete": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "complete") ? undefined : json["complete"],
        "dateCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsSessionId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"],
        "pandadocsDocumentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsDocumentS3Key": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_s3_key") ? undefined : json["pandadocs_document_s3_key"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "user": json["user"],
        "societyForm": json["society_form"]
    };
}
function $fb099ad6aecf7035$export$5488e5b63938ff7b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_form_sub_role_id": value.societyFormSubRoleId,
        "file": value.file,
        "complete": value.complete,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_session_id": value.pandadocsSessionId,
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_document_s3_key": value.pandadocsDocumentS3Key,
        "status": value.status,
        "user": value.user,
        "society_form": value.societyForm
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $c25f64d49488d97d$export$107108728cbff5c2 = {
    Pending: "pending",
    Approved: "approved",
    Active: "active",
    Rejected: "rejected",
    Inactive: "inactive"
};
const $c25f64d49488d97d$export$4aa87062bd17ed50 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $c25f64d49488d97d$export$fbf415167d268784 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
const $c25f64d49488d97d$export$1b6d3c296eec3f65 = {
    PerformerProducer: "Performer/Producer"
};
function $c25f64d49488d97d$export$f7bcf28a00f810b2(value) {
    let isInstance = true;
    return isInstance;
}
function $c25f64d49488d97d$export$2b0c2ace819fea88(json) {
    return $c25f64d49488d97d$export$f7385e99209fe25f(json, false);
}
function $c25f64d49488d97d$export$f7385e99209fe25f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "aliases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "userPhoto": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "verifiedStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "verified_status") ? undefined : json["verified_status"],
        "signedStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "signed_status") ? undefined : json["signed_status"],
        "accountStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "account_status") ? undefined : json["account_status"],
        "title": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "nonClient": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "non_client") ? undefined : json["non_client"],
        "dateOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "nationality": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "department": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "taxationCountry": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "witnessFirstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "registeredWithPpl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "registered_with_ppl") ? undefined : json["registered_with_ppl"],
        "pplAccountName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_account_name") ? undefined : json["ppl_account_name"],
        "pplPerformerName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "clientEmailHashed": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "client_email_hashed") ? undefined : json["client_email_hashed"],
        "westburyId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"],
        "discogsIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "discogs_ids") ? undefined : json["discogs_ids"],
        "musicbrainzIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "musicbrainz_ids") ? undefined : json["musicbrainz_ids"],
        "deezerIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "deezer_ids") ? undefined : json["deezer_ids"],
        "spotifyIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "spotify_ids") ? undefined : json["spotify_ids"],
        "performerOrProducer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "masterRights": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "masterFullname": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "masterEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "masterName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "completedOnboardingSteps": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "completed_onboarding_steps") ? undefined : json["completed_onboarding_steps"]
    };
}
function $c25f64d49488d97d$export$3e1a5b1b9db0a946(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aliases": value.aliases,
        "user_photo": value.userPhoto,
        "account_status": value.accountStatus,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "non_client": value.nonClient,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "nationality": value.nationality,
        "department": value.department,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "role": value.role,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_account_name": value.pplAccountName,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "notes": value.notes,
        "client_email_hashed": value.clientEmailHashed,
        "discogs_ids": value.discogsIds,
        "musicbrainz_ids": value.musicbrainzIds,
        "deezer_ids": value.deezerIds,
        "spotify_ids": value.spotifyIds,
        "performer_or_producer": value.performerOrProducer,
        "master_rights": value.masterRights,
        "master_fullname": value.masterFullname,
        "master_email": value.masterEmail,
        "master_name": value.masterName,
        "master_id": value.masterId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $f564258d4f2af8a7$export$d8acc5ded6e8747d(value) {
    let isInstance = true;
    isInstance = isInstance && "isrc" in value;
    return isInstance;
}
function $f564258d4f2af8a7$export$c454e3e4db3361e(json) {
    return $f564258d4f2af8a7$export$a47be74b5aebe6cc(json, false);
}
function $f564258d4f2af8a7$export$a47be74b5aebe6cc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "isrc": json["isrc"]
    };
}
function $f564258d4f2af8a7$export$799cb3b787059bbf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "isrc": value.isrc
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $0f5db3c3bfb2278b$export$4fa2f7b6eaed025e(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "documentId" in value;
    return isInstance;
}
function $0f5db3c3bfb2278b$export$9009c705843e3717(json) {
    return $0f5db3c3bfb2278b$export$b9cf990aaa62f491(json, false);
}
function $0f5db3c3bfb2278b$export$b9cf990aaa62f491(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingId": json["recordingId"],
        "recordingTitle": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "recordingTitle") ? undefined : json["recordingTitle"],
        "artistName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "artistName") ? undefined : json["artistName"],
        "documentId": json["documentId"]
    };
}
function $0f5db3c3bfb2278b$export$60a1a0525448f9cc(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordingId": value.recordingId,
        "recordingTitle": value.recordingTitle,
        "artistName": value.artistName,
        "documentId": value.documentId
    };
}


function $838b69d64b5f7b42$export$70884a8f57f87af9(value) {
    let isInstance = true;
    isInstance = isInstance && "isDuplicate" in value;
    isInstance = isInstance && "isrc" in value;
    isInstance = isInstance && "matches" in value;
    return isInstance;
}
function $838b69d64b5f7b42$export$a501d6a07889adaa(json) {
    return $838b69d64b5f7b42$export$d1265ad7ca4a262(json, false);
}
function $838b69d64b5f7b42$export$d1265ad7ca4a262(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "isDuplicate": json["isDuplicate"],
        "isrc": json["isrc"],
        "matches": json["matches"].map((0, $0f5db3c3bfb2278b$export$9009c705843e3717))
    };
}
function $838b69d64b5f7b42$export$9828b01a7cf10b4a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "isDuplicate": value.isDuplicate,
        "isrc": value.isrc,
        "matches": value.matches.map((0, $0f5db3c3bfb2278b$export$60a1a0525448f9cc))
    };
}





class $cdef5ca7170fc2e8$export$3dfdf93d61a8d1c9 extends $f599d8a7dfeab1bb$export$70edad7ad5bb3f5d {
    /**
     * 
     */ async adminApproveMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.formId === null || requestParameters.formId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("formId", "Required parameter requestParameters.formId was null or undefined when calling adminApproveMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/tasks/forms/{form_id}/actions/admin-approve/`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $33ff94992968ec35$export$38e6d1d831d066f2)(requestParameters.membershipForms)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $33ff94992968ec35$export$fda0802f448f87cd)(jsonValue));
    }
    /**
     * 
     */ async adminApproveMembershipForms(requestParameters, initOverrides) {
        const response = await this.adminApproveMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async adminCompleteSocietyPortalTasksRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling adminCompleteSocietyPortalTasks.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/tasks/portal/{task_id}/actions/admin-complete/`.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $e8d4d8c5da6c3189$export$17447fa1ae630ace)(requestParameters.societyPortalTasks)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e8d4d8c5da6c3189$export$2056379903cf98a2)(jsonValue));
    }
    /**
     * 
     */ async adminCompleteSocietyPortalTasks(requestParameters, initOverrides) {
        const response = await this.adminCompleteSocietyPortalTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async adminSignSignMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.formId === null || requestParameters.formId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("formId", "Required parameter requestParameters.formId was null or undefined when calling adminSignSignMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/tasks/forms/{form_id}/actions/admin-sign/`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $72f4e69f2b514d47$export$92836d79ac6d6184)(requestParameters.signMembershipForms)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $72f4e69f2b514d47$export$77dcf6f4e2270d7c)(jsonValue));
    }
    /**
     * 
     */ async adminSignSignMembershipForms(requestParameters, initOverrides) {
        const response = await this.adminSignSignMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async adminUploadUploadMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.formId === null || requestParameters.formId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("formId", "Required parameter requestParameters.formId was null or undefined when calling adminUploadUploadMembershipForms.");
        if (requestParameters.societyFormSubRoleId === null || requestParameters.societyFormSubRoleId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyFormSubRoleId", "Required parameter requestParameters.societyFormSubRoleId was null or undefined when calling adminUploadUploadMembershipForms.");
        if (requestParameters.file === null || requestParameters.file === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("file", "Required parameter requestParameters.file was null or undefined when calling adminUploadUploadMembershipForms.");
        if (requestParameters.user === null || requestParameters.user === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("user", "Required parameter requestParameters.user was null or undefined when calling adminUploadUploadMembershipForms.");
        if (requestParameters.societyForm === null || requestParameters.societyForm === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyForm", "Required parameter requestParameters.societyForm was null or undefined when calling adminUploadUploadMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.societyFormSubRoleId !== undefined) formParams.append("society_form_sub_role_id", requestParameters.societyFormSubRoleId);
        if (requestParameters.file !== undefined) formParams.append("file", requestParameters.file);
        if (requestParameters.dateCreated !== undefined) formParams.append("date_created", requestParameters.dateCreated);
        if (requestParameters.dateUpdated !== undefined) formParams.append("date_updated", requestParameters.dateUpdated);
        if (requestParameters.complete !== undefined) formParams.append("complete", requestParameters.complete);
        if (requestParameters.dateCompleted !== undefined) formParams.append("date_completed", requestParameters.dateCompleted);
        if (requestParameters.pandadocsSessionId !== undefined) formParams.append("pandadocs_session_id", requestParameters.pandadocsSessionId);
        if (requestParameters.pandadocsDocumentId !== undefined) formParams.append("pandadocs_document_id", requestParameters.pandadocsDocumentId);
        if (requestParameters.pandadocsDocumentS3Key !== undefined) formParams.append("pandadocs_document_s3_key", requestParameters.pandadocsDocumentS3Key);
        if (requestParameters.status !== undefined) formParams.append("status", requestParameters.status);
        if (requestParameters.user !== undefined) formParams.append("user", requestParameters.user);
        if (requestParameters.societyForm !== undefined) formParams.append("society_form", requestParameters.societyForm);
        const response = await this.request({
            path: `/portal/tasks/forms/{form_id}/actions/admin-upload/`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fb099ad6aecf7035$export$a42a6ebf0e680196)(jsonValue));
    }
    /**
     * 
     */ async adminUploadUploadMembershipForms(requestParameters, initOverrides) {
        const response = await this.adminUploadUploadMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async approveAdminApproveIdentityDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling approveAdminApproveIdentityDocument.");
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentId", "Required parameter requestParameters.documentId was null or undefined when calling approveAdminApproveIdentityDocument.");
        if (requestParameters.dateOfBirth === null || requestParameters.dateOfBirth === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("dateOfBirth", "Required parameter requestParameters.dateOfBirth was null or undefined when calling approveAdminApproveIdentityDocument.");
        if (requestParameters.documentNumber === null || requestParameters.documentNumber === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentNumber", "Required parameter requestParameters.documentNumber was null or undefined when calling approveAdminApproveIdentityDocument.");
        if (requestParameters.documentExpiryDate === null || requestParameters.documentExpiryDate === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentExpiryDate", "Required parameter requestParameters.documentExpiryDate was null or undefined when calling approveAdminApproveIdentityDocument.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.dateOfBirth !== undefined) formParams.append("date_of_birth", requestParameters.dateOfBirth);
        if (requestParameters.documentNumber !== undefined) formParams.append("document_number", requestParameters.documentNumber);
        if (requestParameters.documentExpiryDate !== undefined) formParams.append("document_expiry_date", requestParameters.documentExpiryDate);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/{document_id}/approve/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $aad9d7442fa2f9eb$export$ce79036fae66befd)(jsonValue));
    }
    /**
     * 
     */ async approveAdminApproveIdentityDocument(requestParameters, initOverrides) {
        const response = await this.approveAdminApproveIdentityDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Start an artist-ID collection, guaranteeing at most one active run per artist.  The atomic select_for_update check-and-set is the single-run guarantee: concurrent triggers (double-click, click-then-refresh, two tabs) serialise on the artist\'s row; the first claims it and the rest are rejected with 409 — so an impatient second click can never terminate the collection that is already running. The slow Dagster submit happens off-thread in a Celery task, so this returns immediately and `run_id` arrives shortly via status polling.
     */ async autoCollectIdsArtistIdCollectionRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling autoCollectIdsArtistIdCollectionRunStatus.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling autoCollectIdsArtistIdCollectionRunStatus.");
        if (requestParameters.source === null || requestParameters.source === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("source", "Required parameter requestParameters.source was null or undefined when calling autoCollectIdsArtistIdCollectionRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/auto-collect-ids/{user_id}/{source_id}/{source}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))).replace(`{${"source"}}`, encodeURIComponent(String(requestParameters.source))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7d0d21cc7dd025f2$export$254fa118bbd0804)(jsonValue));
    }
    /**
     * Start an artist-ID collection, guaranteeing at most one active run per artist.  The atomic select_for_update check-and-set is the single-run guarantee: concurrent triggers (double-click, click-then-refresh, two tabs) serialise on the artist\'s row; the first claims it and the rest are rejected with 409 — so an impatient second click can never terminate the collection that is already running. The slow Dagster submit happens off-thread in a Celery task, so this returns immediately and `run_id` arrives shortly via status polling.
     */ async autoCollectIdsArtistIdCollectionRunStatus(requestParameters, initOverrides) {
        const response = await this.autoCollectIdsArtistIdCollectionRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async availableFiltersAvailableFiltersResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling availableFiltersAvailableFiltersResponse.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/available-filters/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d59d5e180f39bf3f$export$11bc36c050626697)(jsonValue));
    }
    /**
     * 
     */ async availableFiltersAvailableFiltersResponse(requestParameters, initOverrides) {
        const response = await this.availableFiltersAvailableFiltersResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Change associated artists on many recordings in one call (contract 4.1.3 + 3.1).
     */ async batchChangeArtistsBatchServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling batchChangeArtistsBatchServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recordings/artists/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e9cd8703b84308cb$export$e010dc4ca12a6d36)(jsonValue));
    }
    /**
     * Change associated artists on many recordings in one call (contract 4.1.3 + 3.1).
     */ async batchChangeArtistsBatchServiceResponse(requestParameters, initOverrides) {
        const response = await this.batchChangeArtistsBatchServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Correct data on many recordings in one call (contract 4.1.1 + 3.1).
     */ async batchCorrectRecordingBatchServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling batchCorrectRecordingBatchServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recordings/correct/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e9cd8703b84308cb$export$e010dc4ca12a6d36)(jsonValue));
    }
    /**
     * Correct data on many recordings in one call (contract 4.1.1 + 3.1).
     */ async batchCorrectRecordingBatchServiceResponse(requestParameters, initOverrides) {
        const response = await this.batchCorrectRecordingBatchServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Manage contributions on many recordings in one call (contract 4.2.1 + 3.1).
     */ async batchManageContributionsBatchServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling batchManageContributionsBatchServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recordings/contributions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e9cd8703b84308cb$export$e010dc4ca12a6d36)(jsonValue));
    }
    /**
     * Manage contributions on many recordings in one call (contract 4.2.1 + 3.1).
     */ async batchManageContributionsBatchServiceResponse(requestParameters, initOverrides) {
        const response = await this.batchManageContributionsBatchServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Apply a set of operations to a set of recordings (contract §3).  Structural validation is all-or-nothing — a malformed payload rejects the whole request with 400. An action that validates but *fails to apply* is not an HTTP error: it comes back as a failed row in the 200 response, so the caller can see which of the other actions landed (contract §5).
     */ async bulkEditBulkEditResultResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling bulkEditBulkEditResultResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recordings/bulk-edit/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $edf8bbf08faf3a1c$export$7d65401c95d547d6)(requestParameters.bulkEditRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5213afeeb3d6213a$export$12239a6bda795ffc)(jsonValue));
    }
    /**
     * Apply a set of operations to a set of recordings (contract §3).  Structural validation is all-or-nothing — a malformed payload rejects the whole request with 400. An action that validates but *fails to apply* is not an HTTP error: it comes back as a failed row in the 200 response, so the caller can see which of the other actions landed (contract §5).
     */ async bulkEditBulkEditResultResponse(requestParameters, initOverrides) {
        const response = await this.bulkEditBulkEditResultResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Look a release up for a whole selection (contract 4.3.1, bulk form).  Same `(source, source_id)` key as `lookup`, so it still resolves one release — what it adds is a `(recording_id, edge_id)` pair per requested recording, because bulk editing carries `edge_id` **per recording** and a selection can mix linked and unlinked ones.  Returns 200 with the release and every requested recording\'s edge, or 404 when the release isn\'t in the system.
     */ async bulkLookupBulkLookupReleaseResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling bulkLookupBulkLookupReleaseResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/releases/lookup/bulk/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $52cb4e753ea2e79a$export$17caed5444512236)(requestParameters.bulkLookupReleaseRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6c384c2cb513cd70$export$6a84cd4a872abfc5)(jsonValue));
    }
    /**
     * Look a release up for a whole selection (contract 4.3.1, bulk form).  Same `(source, source_id)` key as `lookup`, so it still resolves one release — what it adds is a `(recording_id, edge_id)` pair per requested recording, because bulk editing carries `edge_id` **per recording** and a selection can mix linked and unlinked ones.  Returns 200 with the release and every requested recording\'s edge, or 404 when the release isn\'t in the system.
     */ async bulkLookupBulkLookupReleaseResponse(requestParameters, initOverrides) {
        const response = await this.bulkLookupBulkLookupReleaseResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return a per-recording boolean indicating whether the recording has any tracked manual edits (contract 4.5.1).
     */ async bulkManualChangesBulkManualChangesResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling bulkManualChangesBulkManualChangesResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/manual-changes/bulk/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $a04c835e01d8d3bc$export$5693fd5a32218080)(requestParameters.bulkManualChangesRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $bbb15486918e6a4b$export$eb33a474a4a19660)(jsonValue));
    }
    /**
     * Return a per-recording boolean indicating whether the recording has any tracked manual edits (contract 4.5.1).
     */ async bulkManualChangesBulkManualChangesResponse(requestParameters, initOverrides) {
        const response = await this.bulkManualChangesBulkManualChangesResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Cancel the artist\'s in-flight ID collection.  Only ever reached from an explicit user action. The Dagster terminate happens off-thread; the row moves to CANCELLING immediately so the UI reflects the request without waiting, and the cancel task marks it CANCELLED once Dagster confirms.
     */ async cancelAutoCollectIdsArtistIdCollectionRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling cancelAutoCollectIdsArtistIdCollectionRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/{user_id}/cancel-auto-collect-ids`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7d0d21cc7dd025f2$export$254fa118bbd0804)(jsonValue));
    }
    /**
     * Cancel the artist\'s in-flight ID collection.  Only ever reached from an explicit user action. The Dagster terminate happens off-thread; the row moves to CANCELLING immediately so the UI reflects the request without waiting, and the cancel task marks it CANCELLED once Dagster confirms.
     */ async cancelAutoCollectIdsArtistIdCollectionRunStatus(requestParameters, initOverrides) {
        const response = await this.cancelAutoCollectIdsArtistIdCollectionRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async cancelPrimaryDiscographyRunPipelineRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling cancelPrimaryDiscographyRunPipelineRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/{user_id}/cancel-primary-discography-run`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $057bd700f894f3a9$export$eb5e6a8ad753c49)(jsonValue));
    }
    /**
     * 
     */ async cancelPrimaryDiscographyRunPipelineRunStatus(requestParameters, initOverrides) {
        const response = await this.cancelPrimaryDiscographyRunPipelineRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Add/remove main artists on a recording (contract 4.1.3).
     */ async changeArtistsServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling changeArtistsServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling changeArtistsServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $f644235c455de382$export$62a3f99c3f3cd78f)(requestParameters.changeAssociatedArtistsRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Add/remove main artists on a recording (contract 4.1.3).
     */ async changeArtistsServiceResponse(requestParameters, initOverrides) {
        const response = await this.changeArtistsServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Check if a SourceId exists and return all matching entities with their relationship information (alias_id or group_id).  Query parameters: - source_id: The source identifier to search for - source: The source type (discogs, musicbrainz, spotify, deezer)
     */ async checkSourceIdSourceIdWithRelationshipRaw(requestParameters, initOverrides) {
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling checkSourceIdSourceIdWithRelationship.");
        if (requestParameters.source === null || requestParameters.source === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("source", "Required parameter requestParameters.source was null or undefined when calling checkSourceIdSourceIdWithRelationship.");
        const queryParameters = {};
        if (requestParameters.sourceId !== undefined) queryParameters["source_id"] = requestParameters.sourceId;
        if (requestParameters.source !== undefined) queryParameters["source"] = requestParameters.source;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/check-source-id/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        if (this.isJsonMime(response.headers.get("content-type"))) return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response);
        else return new $f599d8a7dfeab1bb$export$bf40ae8c274ef99b(response);
    }
    /**
     * Check if a SourceId exists and return all matching entities with their relationship information (alias_id or group_id).  Query parameters: - source_id: The source identifier to search for - source: The source type (discogs, musicbrainz, spotify, deezer)
     */ async checkSourceIdSourceIdWithRelationship(requestParameters, initOverrides) {
        const response = await this.checkSourceIdSourceIdWithRelationshipRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async clientSignClientSocietyFormTaskRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling clientSignClientSocietyFormTask.");
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling clientSignClientSocietyFormTask.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks/{task_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $4ba4f806015061e3$export$1f4009bc54aefa3f)(requestParameters.clientSocietyFormTask)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4ba4f806015061e3$export$7fa8d9ea09641068)(jsonValue));
    }
    /**
     * 
     */ async clientSignClientSocietyFormTask(requestParameters, initOverrides) {
        const response = await this.clientSignClientSocietyFormTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async confidenceStatsConfidenceStatsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling confidenceStatsConfidenceStats.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/confidence-stats/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $223588ce99f2272d$export$fb38f9a20243237a)(jsonValue));
    }
    /**
     * 
     */ async confidenceStatsConfidenceStats(requestParameters, initOverrides) {
        const response = await this.confidenceStatsConfidenceStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Admin endpoint to consolidate duplicate ArtistBand entries. Duplicates are identified by matching discogs or musicbrainz source_ids.  Default mode: Dry run (returns what would be changed) Add ?run=true query parameter to actually perform consolidation.
     */ async consolidateDuplicateBandsPipelineRunRequestRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/admin/consolidate-duplicate-bands/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $b0c6dc27ae4bb73b$export$11be686f93e21c72)(jsonValue));
    }
    /**
     * Admin endpoint to consolidate duplicate ArtistBand entries. Duplicates are identified by matching discogs or musicbrainz source_ids.  Default mode: Dry run (returns what would be changed) Add ?run=true query parameter to actually perform consolidation.
     */ async consolidateDuplicateBandsPipelineRunRequest(requestParameters = {}, initOverrides) {
        const response = await this.consolidateDuplicateBandsPipelineRunRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Correct recording data — title, duration, ISRCs, live flag, version, etc. (contract 4.1.1).
     */ async correctRecordingServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling correctRecordingServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling correctRecordingServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/correct/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $9a7c0b9330cf3844$export$b390a0a11149d8cb)(requestParameters.correctRecordingRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Correct recording data — title, duration, ISRCs, live flag, version, etc. (contract 4.1.1).
     */ async correctRecordingServiceResponse(requestParameters, initOverrides) {
        const response = await this.correctRecordingServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Apply corrections to the linked release (contract 4.3.3).
     */ async correctServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling correctServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling correctServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/releases/correct/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $3ddeef983b1a1494$export$e84c7db334e0aed6)(requestParameters.correctReleaseRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Apply corrections to the linked release (contract 4.3.3).
     */ async correctServiceResponse(requestParameters, initOverrides) {
        const response = await this.correctServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $5e3ca10c0ee31eb4$export$a23c9ba4a9c33181)(requestParameters.additionalContactDetails)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5e3ca10c0ee31eb4$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async createAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.createAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdminBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAdminBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c3418b6825975f57$export$ff8d63926b23924f)(requestParameters.adminBankDetails)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c3418b6825975f57$export$cab2c6e7757d8c1d)(jsonValue));
    }
    /**
     * 
     */ async createAdminBankDetails(requestParameters, initOverrides) {
        const response = await this.createAdminBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdminCreateSocietyRaw(requestParameters, initOverrides) {
        if (requestParameters.readableName === null || requestParameters.readableName === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("readableName", "Required parameter requestParameters.readableName was null or undefined when calling createAdminCreateSociety.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "application/x-www-form-urlencoded"
            },
            {
                contentType: "multipart/form-data"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.readableName !== undefined) formParams.append("readable_name", requestParameters.readableName);
        if (requestParameters.logo !== undefined) formParams.append("logo", requestParameters.logo);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.website !== undefined) formParams.append("website", requestParameters.website);
        if (requestParameters.portal !== undefined) formParams.append("portal", requestParameters.portal);
        if (requestParameters.phone !== undefined) formParams.append("phone", requestParameters.phone);
        if (requestParameters.address !== undefined) formParams.append("address", requestParameters.address);
        if (requestParameters.additionalTerritories) formParams.append("additional_territories", requestParameters.additionalTerritories.join($f599d8a7dfeab1bb$export$83cb526776fb323d["csv"]));
        if (requestParameters.formEmail !== undefined) formParams.append("form_email", requestParameters.formEmail);
        if (requestParameters.formPostalAddress !== undefined) formParams.append("form_postal_address", requestParameters.formPostalAddress);
        if (requestParameters.formPortal !== undefined) formParams.append("form_portal", requestParameters.formPortal);
        if (requestParameters.formReminderFrequency !== undefined) formParams.append("form_reminder_frequency", requestParameters.formReminderFrequency);
        if (requestParameters.formStopReminderFrequency !== undefined) formParams.append("form_stop_reminder_frequency", requestParameters.formStopReminderFrequency);
        if (requestParameters.formReminderSendTo !== undefined) formParams.append("form_reminder_send_to", requestParameters.formReminderSendTo);
        if (requestParameters.taxForms !== undefined) formParams.append("tax_forms", requestParameters.taxForms);
        if (requestParameters.roleForms !== undefined) formParams.append("role_forms", requestParameters.roleForms);
        if (requestParameters.contactInformation !== undefined) formParams.append("contact_information", requestParameters.contactInformation);
        const response = await this.request({
            path: `/portal/societies/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $bd83d5bbd5694632$export$9907fd9d36227c03)(jsonValue));
    }
    /**
     * 
     */ async createAdminCreateSociety(requestParameters, initOverrides) {
        const response = await this.createAdminCreateSocietyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAdminIdentityDocumentSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.dateCreated !== undefined) formParams.append("date_created", requestParameters.dateCreated);
        if (requestParameters.file !== undefined) formParams.append("file", requestParameters.file);
        if (requestParameters.filename !== undefined) formParams.append("filename", requestParameters.filename);
        if (requestParameters.status !== undefined) formParams.append("status", requestParameters.status);
        if (requestParameters.documentExpiryDate !== undefined) formParams.append("document_expiry_date", requestParameters.documentExpiryDate);
        if (requestParameters.documentSignedDate !== undefined) formParams.append("document_signed_date", requestParameters.documentSignedDate);
        if (requestParameters.documentType !== undefined) formParams.append("document_type", requestParameters.documentType);
        if (requestParameters.fileUrl !== undefined) formParams.append("file_url", requestParameters.fileUrl);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $dae85878c5dda937$export$9d955c411567a352)(jsonValue));
    }
    /**
     * 
     */ async createAdminIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.createAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create user and user settings based on expression of interest information. Create EOI review and discography ID submission admin tasks.
     */ async createAdminInterestRegistrationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/interest-registrations/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2fea223443d8a350$export$887cdb805eaac4d8)(requestParameters.adminInterestRegistration)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2fea223443d8a350$export$c8c63a6b256b2f84)(jsonValue));
    }
    /**
     * Create user and user settings based on expression of interest information. Create EOI review and discography ID submission admin tasks.
     */ async createAdminInterestRegistration(requestParameters = {}, initOverrides) {
        const response = await this.createAdminInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdminPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAdminPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7dac4f16d65ed476$export$7c5d2ff8a10c7191)(requestParameters.adminPersonalInformation)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7dac4f16d65ed476$export$345ccf656783517a)(jsonValue));
    }
    /**
     * 
     */ async createAdminPersonalInformation(requestParameters, initOverrides) {
        const response = await this.createAdminPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAliasArtistAliasRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAliasArtistAlias.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_alias/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $8e361260624ef50d$export$bafacef4a71b87cf)(requestParameters.artistAliasCreate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $200e49f2387423dc$export$de3312126358ad1b)(jsonValue));
    }
    /**
     * 
     */ async createAliasArtistAlias(requestParameters, initOverrides) {
        const response = await this.createAliasArtistAliasRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new release and link it to the recording. Provide source_id/source and release fields; when source is \'other\', source_url and fields.
     */ async createAndLinkServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAndLinkServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling createAndLinkServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/releases/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $f3269fd5dab4fed8$export$9113875b6aadc556)(requestParameters.createReleaseAndLinkRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Create a new release and link it to the recording. Provide source_id/source and release fields; when source is \'other\', source_url and fields.
     */ async createAndLinkServiceResponse(requestParameters, initOverrides) {
        const response = await this.createAndLinkServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new artist and link to recording (contract 4.4.2).
     */ async createArtistAndLinkServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createArtistAndLinkServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling createArtistAndLinkServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/create/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $cd27d3530fb73cb9$export$f23cb9f0cf84d44c)(requestParameters.createArtistAndLinkRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Create a new artist and link to recording (contract 4.4.2).
     */ async createArtistAndLinkServiceResponse(requestParameters, initOverrides) {
        const response = await this.createArtistAndLinkServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createBandArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createBandArtistBand.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $a7d0c0ae82c3bf9c$export$ec34e221180ae073)(requestParameters.artistBandCreate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * 
     */ async createBandArtistBand(requestParameters, initOverrides) {
        const response = await this.createBandArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientSessionCreatePandadocsSessionIdRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling createClientSessionCreatePandadocsSessionId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/{task_id}/session_id/`.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $43968d5c1777387c$export$fe1c3e8c7156433b)(requestParameters.createPandadocsSessionId)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $43968d5c1777387c$export$48c528d3391c2ee1)(jsonValue));
    }
    /**
     * 
     */ async createClientSessionCreatePandadocsSessionId(requestParameters, initOverrides) {
        const response = await this.createClientSessionCreatePandadocsSessionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientTasksTermsOfAgreementConfirmationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createClientTasksTermsOfAgreementConfirmation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/terms-of-agreement/confirm`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $4043810f8d026b69$export$5d0069a94b99dc48)(requestParameters.termsOfAgreementConfirmation)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4043810f8d026b69$export$a2a4439062823c60)(jsonValue));
    }
    /**
     * 
     */ async createClientTasksTermsOfAgreementConfirmation(requestParameters, initOverrides) {
        const response = await this.createClientTasksTermsOfAgreementConfirmationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createCompanyFormRoleRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/company/forms/roles/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $acabe406dbdcaf5a$export$1a47cbea4491e9de)(requestParameters.companyFormRole)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $acabe406dbdcaf5a$export$7f857026a8161ae1)(jsonValue));
    }
    /**
     * 
     */ async createCompanyFormRole(requestParameters = {}, initOverrides) {
        const response = await this.createCompanyFormRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createGeneratePPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createGeneratePPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response);
    }
    /**
     * 
     */ async createGeneratePPLReviewExport(requestParameters, initOverrides) {
        const response = await this.createGeneratePPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createGeneratePrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createGeneratePrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response);
    }
    /**
     * 
     */ async createGeneratePrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.createGeneratePrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createIdentityVerficationSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.passportFile === null || requestParameters.passportFile === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("passportFile", "Required parameter requestParameters.passportFile was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.registeredWithPpl === null || requestParameters.registeredWithPpl === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("registeredWithPpl", "Required parameter requestParameters.registeredWithPpl was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.streetAddress === null || requestParameters.streetAddress === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("streetAddress", "Required parameter requestParameters.streetAddress was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.postcode === null || requestParameters.postcode === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("postcode", "Required parameter requestParameters.postcode was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.county === null || requestParameters.county === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("county", "Required parameter requestParameters.county was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.country === null || requestParameters.country === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("country", "Required parameter requestParameters.country was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessFirstName === null || requestParameters.witnessFirstName === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("witnessFirstName", "Required parameter requestParameters.witnessFirstName was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessLastName === null || requestParameters.witnessLastName === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("witnessLastName", "Required parameter requestParameters.witnessLastName was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessEmail === null || requestParameters.witnessEmail === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("witnessEmail", "Required parameter requestParameters.witnessEmail was null or undefined when calling createIdentityVerficationSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.passportFile !== undefined) formParams.append("passport_file", requestParameters.passportFile);
        if (requestParameters.proofOfAddressFile !== undefined) formParams.append("proof_of_address_file", requestParameters.proofOfAddressFile);
        if (requestParameters.registeredWithPpl !== undefined) formParams.append("registered_with_ppl", requestParameters.registeredWithPpl);
        if (requestParameters.pplPerformerName !== undefined) formParams.append("ppl_performer_name", requestParameters.pplPerformerName);
        if (requestParameters.pplPerformerId !== undefined) formParams.append("ppl_performer_id", requestParameters.pplPerformerId);
        if (requestParameters.streetAddress !== undefined) formParams.append("street_address", requestParameters.streetAddress);
        if (requestParameters.postcode !== undefined) formParams.append("postcode", requestParameters.postcode);
        if (requestParameters.county !== undefined) formParams.append("county", requestParameters.county);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.witnessFirstName !== undefined) formParams.append("witness_first_name", requestParameters.witnessFirstName);
        if (requestParameters.witnessLastName !== undefined) formParams.append("witness_last_name", requestParameters.witnessLastName);
        if (requestParameters.witnessEmail !== undefined) formParams.append("witness_email", requestParameters.witnessEmail);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-verification-submissions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f7bbd894883813bb$export$1372d202ad798e18)(jsonValue));
    }
    /**
     * 
     */ async createIdentityVerficationSubmission(requestParameters, initOverrides) {
        const response = await this.createIdentityVerficationSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createPandadocDocumentIdsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/document_id/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $6d120dccd14bda55$export$8652488ad92b6771)(requestParameters.pandadocDocumentIds)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6d120dccd14bda55$export$4950862b30fc1953)(jsonValue));
    }
    /**
     * 
     */ async createPandadocDocumentIds(requestParameters = {}, initOverrides) {
        const response = await this.createPandadocDocumentIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Start a primary discography run, guaranteeing at most one active run per artist.  The atomic select_for_update check-and-set on `phase` is the single-run guarantee: two concurrent triggers (double-click, click-then-refresh, two tabs) serialise on the row; the first claims it (LAUNCHING) and the rest are rejected with 409 — so only ONE Dagster run is ever launched. The slow submit happens off-thread in a Celery task, so this returns immediately and `run_id` arrives shortly via status polling.
     */ async createPipelineRunStatusRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/pipeline-runs/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $057bd700f894f3a9$export$eb5e6a8ad753c49)(jsonValue));
    }
    /**
     * Start a primary discography run, guaranteeing at most one active run per artist.  The atomic select_for_update check-and-set on `phase` is the single-run guarantee: two concurrent triggers (double-click, click-then-refresh, two tabs) serialise on the row; the first claims it (LAUNCHING) and the rest are rejected with 409 — so only ONE Dagster run is ever launched. The slow submit happens off-thread in a Celery task, so this returns immediately and `run_id` arrives shortly via status polling.
     */ async createPipelineRunStatus(requestParameters = {}, initOverrides) {
        const response = await this.createPipelineRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createPreregisteredSocietyPostIdRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createPreregisteredSocietyPostId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/preregistered-societies/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $8e162968d95ab4d2$export$85c3d9c455b4213a)(requestParameters.preregisteredSocietyPost)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e33d707f3168632a$export$973aefbf5296d294)(jsonValue));
    }
    /**
     * 
     */ async createPreregisteredSocietyPostId(requestParameters, initOverrides) {
        const response = await this.createPreregisteredSocietyPostIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $fb6864c8a884a76f$export$4b283602380be6d7)(requestParameters.representative)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fb6864c8a884a76f$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async createRepresentative(requestParameters, initOverrides) {
        const response = await this.createRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createSigninAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signin/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $5b04b154f586a04e$export$303b9f6375543435)(requestParameters.loginWithEmailorUsernameAuthToken)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $981738fd9f9cc5a3$export$c63fd8bf0afb13bd)(jsonValue));
    }
    /**
     * 
     */ async createSigninAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.createSigninAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createSignupAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signup/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7f55453984ef7fbf$export$eca3401b04c34cf9)(requestParameters.signup)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $25f117375b97ece2$export$f36f5aa70c133e5)(jsonValue));
    }
    /**
     * 
     */ async createSignupAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.createSignupAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createTermsOfAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createTermsOfAgreement.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/terms-of-agreement`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $41529a4feb258a75$export$65df8c0be059cbe4)(requestParameters.termsOfAgreement)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $41529a4feb258a75$export$aad686261db31a8a)(jsonValue));
    }
    /**
     * 
     */ async createTermsOfAgreement(requestParameters, initOverrides) {
        const response = await this.createTermsOfAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a token and blacklists it. Must be used with the `rest_framework_simplejwt.token_blacklist` app installed.
     */ async createTokenBlacklistRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/blacklist/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $eb13e3b5d4558e89$export$68354c35e74dadb8)(requestParameters.tokenBlacklist)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $eb13e3b5d4558e89$export$b5cfec7638e86e16)(jsonValue));
    }
    /**
     * Takes a token and blacklists it. Must be used with the `rest_framework_simplejwt.token_blacklist` app installed.
     */ async createTokenBlacklist(requestParameters = {}, initOverrides) {
        const response = await this.createTokenBlacklistRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */ async createTokenObtainPairRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7b35bec082706873$export$dc065df2aa624562)(requestParameters.tokenObtainPair)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7b35bec082706873$export$a57843fa58a86c18)(jsonValue));
    }
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */ async createTokenObtainPair(requestParameters = {}, initOverrides) {
        const response = await this.createTokenObtainPairRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */ async createTokenRefreshRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/refresh/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $3650756ad18dc91b$export$f77999a70380c6a3)(requestParameters.tokenRefresh)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3650756ad18dc91b$export$874d3e01e6e7fdc8)(jsonValue));
    }
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */ async createTokenRefresh(requestParameters = {}, initOverrides) {
        const response = await this.createTokenRefreshRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     */ async createTokenVerifyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/verify/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $db11163f6e91414a$export$62af2150040a6d3b)(requestParameters.tokenVerify)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $db11163f6e91414a$export$dd924f4825888164)(jsonValue));
    }
    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     */ async createTokenVerify(requestParameters = {}, initOverrides) {
        const response = await this.createTokenVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async declineAdminDeclineIdentityDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling declineAdminDeclineIdentityDocument.");
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentId", "Required parameter requestParameters.documentId was null or undefined when calling declineAdminDeclineIdentityDocument.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/{document_id}/decline/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response);
    }
    /**
     * 
     */ async declineAdminDeclineIdentityDocument(requestParameters, initOverrides) {
        const response = await this.declineAdminDeclineIdentityDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Decline EOI for user with user_id Deletes user from DB
     */ async declineAdminInterestRegistrationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling declineAdminInterestRegistration.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/interest-registration/decline`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2fea223443d8a350$export$887cdb805eaac4d8)(requestParameters.adminInterestRegistration)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2fea223443d8a350$export$c8c63a6b256b2f84)(jsonValue));
    }
    /**
     * Decline EOI for user with user_id Deletes user from DB
     */ async declineAdminInterestRegistration(requestParameters, initOverrides) {
        const response = await this.declineAdminInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async destroyAdminTaskClientRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling destroyAdminTaskClient.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/{task_id}/`.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "DELETE",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$20446dc680588cc3(response);
    }
    /**
     * 
     */ async destroyAdminTaskClient(requestParameters, initOverrides) {
        await this.destroyAdminTaskClientRaw(requestParameters, initOverrides);
    }
    /**
     * 
     */ async evidenceImageSignedUrlEvidenceImageSignedUrlRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling evidenceImageSignedUrlEvidenceImageSignedUrl.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/evidence-image-signed-url/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2e327edbea3e67c8$export$6d2e9ac51213991c)(requestParameters.evidenceImageSignedUrlRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2c7c8d4649c80a20$export$991a282fb95e914b)(jsonValue));
    }
    /**
     * 
     */ async evidenceImageSignedUrlEvidenceImageSignedUrl(requestParameters, initOverrides) {
        const response = await this.evidenceImageSignedUrlEvidenceImageSignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async finalJobRunStatusPipelineRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.jobRunId === null || requestParameters.jobRunId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("jobRunId", "Required parameter requestParameters.jobRunId was null or undefined when calling finalJobRunStatusPipelineRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/final-job-run-status/{job_run_id}`.replace(`{${"job_run_id"}}`, encodeURIComponent(String(requestParameters.jobRunId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $057bd700f894f3a9$export$eb5e6a8ad753c49)(jsonValue));
    }
    /**
     * 
     */ async finalJobRunStatusPipelineRunStatus(requestParameters, initOverrides) {
        const response = await this.finalJobRunStatusPipelineRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Find an existing band by Discogs or MusicBrainz source id.  Query parameters: - source_id: The source identifier (discogs or musicbrainz id) to look up.  Looks up bands that have this source_id either: - directly on the band\'s source_ids, or - on any alias linked to the band (artist_aliases.source_ids). Returns the first matching band\'s details, or null if none. Used to validate before adding a new band and avoid duplicates.
     */ async findBandBySourceIdArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling findBandBySourceIdArtistBand.");
        const queryParameters = {};
        if (requestParameters.sourceId !== undefined) queryParameters["source_id"] = requestParameters.sourceId;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/find-band-by-source-id/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * Find an existing band by Discogs or MusicBrainz source id.  Query parameters: - source_id: The source identifier (discogs or musicbrainz id) to look up.  Looks up bands that have this source_id either: - directly on the band\'s source_ids, or - on any alias linked to the band (artist_aliases.source_ids). Returns the first matching band\'s details, or null if none. Used to validate before adding a new band and avoid duplicates.
     */ async findBandBySourceIdArtistBand(requestParameters, initOverrides) {
        const response = await this.findBandBySourceIdArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve secondary discography data
     */ async generateSecondaryDiscographyRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling generateSecondaryDiscography.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/secondary-discography/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $127d41a480bfebb5$export$d5d6d6d331f97390)(requestParameters.secondaryDiscography)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $127d41a480bfebb5$export$e531c1c6f9ecf6a)(jsonValue));
    }
    /**
     * Retrieve secondary discography data
     */ async generateSecondaryDiscography(requestParameters, initOverrides) {
        const response = await this.generateSecondaryDiscographyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Link an existing Alias to an existing Band. This adds the alias to the band\'s artist_aliases ManyToMany relationship.
     */ async linkAliasToBandArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling linkAliasToBandArtistBand.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling linkAliasToBandArtistBand.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}/link-alias`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $de30fb04e66f39f2$export$9a5f9fbbbbb178eb)(requestParameters.linkAliasToBand)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * Link an existing Alias to an existing Band. This adds the alias to the band\'s artist_aliases ManyToMany relationship.
     */ async linkAliasToBandArtistBand(requestParameters, initOverrides) {
        const response = await this.linkAliasToBandArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Link the looked-up release as the earliest release for this recording (contract 4.1.2).
     */ async linkEarliestServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling linkEarliestServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling linkEarliestServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/releases/link/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $f94e6c2ba0d8c130$export$9c3b2b75140e5fc0)(requestParameters.linkReleaseRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Link the looked-up release as the earliest release for this recording (contract 4.1.2).
     */ async linkEarliestServiceResponse(requestParameters, initOverrides) {
        const response = await this.linkEarliestServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listAdminIdentityDocumentSubmissionsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listAdminIdentityDocumentSubmissions.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $dae85878c5dda937$export$9d955c411567a352)));
    }
    /**
     * 
     */ async listAdminIdentityDocumentSubmissions(requestParameters, initOverrides) {
        const response = await this.listAdminIdentityDocumentSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listAdminSocietiesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/societies/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $3fcbd4bdbdf09193$export$5ed54dd8f8ca2d09)));
    }
    /**
     * 
     */ async listAdminSocieties(initOverrides) {
        const response = await this.listAdminSocietiesRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listAdminSocietyFormTasksRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/forms/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $f3b0fe9c62b42bbf$export$6d55337ed52765c1)));
    }
    /**
     * 
     */ async listAdminSocietyFormTasks(initOverrides) {
        const response = await this.listAdminSocietyFormTasksRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listAdminTaskClientsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $f620ba671e370d28$export$4639f4523496d0a7)));
    }
    /**
     * 
     */ async listAdminTaskClients(initOverrides) {
        const response = await this.listAdminTaskClientsRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listClientSocietyFormTasksRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listClientSocietyFormTasks.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $4ba4f806015061e3$export$7fa8d9ea09641068)));
    }
    /**
     * 
     */ async listClientSocietyFormTasks(requestParameters, initOverrides) {
        const response = await this.listClientSocietyFormTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listCompanyFormRolesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/company/forms/roles/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $acabe406dbdcaf5a$export$7f857026a8161ae1)));
    }
    /**
     * 
     */ async listCompanyFormRoles(initOverrides) {
        const response = await this.listCompanyFormRolesRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listDailyPaymentsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listDailyPayments.");
        const queryParameters = {};
        if (requestParameters.financialYear !== undefined) queryParameters["financial_year"] = requestParameters.financialYear;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/payments/daily/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $3879e3127a8babba$export$58ccaf3d39e682e6)));
    }
    /**
     * 
     */ async listDailyPayments(requestParameters, initOverrides) {
        const response = await this.listDailyPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listDebugsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/debug/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $366dcd6ae4c96880$export$488b6f97322bf07)));
    }
    /**
     * 
     */ async listDebugs(initOverrides) {
        const response = await this.listDebugsRaw(initOverrides);
        return await response.value();
    }
    /**
     * List all secondary discography runs for user
     */ async listListSecondaryDiscographiesRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listListSecondaryDiscographies.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/secondary-discography/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $3f2370c7cd227afa$export$adddd0d13b7274f3)));
    }
    /**
     * List all secondary discography runs for user
     */ async listListSecondaryDiscographies(requestParameters, initOverrides) {
        const response = await this.listListSecondaryDiscographiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/forms/{user_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $33ff94992968ec35$export$fda0802f448f87cd)));
    }
    /**
     * 
     */ async listMembershipForms(requestParameters, initOverrides) {
        const response = await this.listMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listMembershipStatusesRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listMembershipStatuses.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/memberships/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $b6719923319239b8$export$cc5cf1ab6820dc7)));
    }
    /**
     * 
     */ async listMembershipStatuses(requestParameters, initOverrides) {
        const response = await this.listMembershipStatusesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listPaymentsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listPayments.");
        const queryParameters = {};
        if (requestParameters.financialYear !== undefined) queryParameters["financial_year"] = requestParameters.financialYear;
        if (requestParameters.format !== undefined) queryParameters["format"] = requestParameters.format;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/payments/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $651eb0c6133c2d05$export$ede75277ced03c5d)));
    }
    /**
     * 
     */ async listPayments(requestParameters, initOverrides) {
        const response = await this.listPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietiesRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocieties.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/societies/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $aff6aee9f926ab64$export$4ce4e8492a820cd5)));
    }
    /**
     * 
     */ async listSocieties(requestParameters, initOverrides) {
        const response = await this.listSocietiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyContactInformationsRaw(requestParameters, initOverrides) {
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling listSocietyContactInformations.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/society/contact/{society_id}/`.replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $ec1fec872195ff2d$export$63ba8169be3c7618)));
    }
    /**
     * 
     */ async listSocietyContactInformations(requestParameters, initOverrides) {
        const response = await this.listSocietyContactInformationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyFormRolesRaw(requestParameters, initOverrides) {
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling listSocietyFormRoles.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/society/form/{society_id}/roles/`.replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $50e4c7544de1252c$export$f1fe62ab070fcdf2)));
    }
    /**
     * 
     */ async listSocietyFormRoles(requestParameters, initOverrides) {
        const response = await this.listSocietyFormRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocietyForms.");
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling listSocietyForms.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/societies/{society_id}/forms/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $562ad623013da697$export$46847c4110a69b3c)));
    }
    /**
     * 
     */ async listSocietyForms(requestParameters, initOverrides) {
        const response = await this.listSocietyFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyLoginsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocietyLogins.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/society-logins/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $35776a150092e6a3$export$5f5240b422f10d0e)));
    }
    /**
     * 
     */ async listSocietyLogins(requestParameters, initOverrides) {
        const response = await this.listSocietyLoginsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyPortalTasksRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocietyPortalTasks.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/portal/{user_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $e8d4d8c5da6c3189$export$2056379903cf98a2)));
    }
    /**
     * 
     */ async listSocietyPortalTasks(requestParameters, initOverrides) {
        const response = await this.listSocietyPortalTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listTaxFormRolesRaw(requestParameters, initOverrides) {
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling listTaxFormRoles.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/society/tax/form/{society_id}/roles/`.replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $98a0cfd0de059254$export$9f84e25690d8699e)));
    }
    /**
     * 
     */ async listTaxFormRoles(requestParameters, initOverrides) {
        const response = await this.listTaxFormRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listUsersRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $d115afa3f35b4902$export$9d932c871ca38b84)));
    }
    /**
     * 
     */ async listUsers(initOverrides) {
        const response = await this.listUsersRaw(initOverrides);
        return await response.value();
    }
    /**
     * Search for artists by name (contract 4.4.1).
     */ async lookupArtistsLookupArtistsResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling lookupArtistsLookupArtistsResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling lookupArtistsLookupArtistsResponse.");
        if (requestParameters.searchTerm === null || requestParameters.searchTerm === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("searchTerm", "Required parameter requestParameters.searchTerm was null or undefined when calling lookupArtistsLookupArtistsResponse.");
        const queryParameters = {};
        if (requestParameters.searchTerm !== undefined) queryParameters["search_term"] = requestParameters.searchTerm;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/lookup/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $10bc28dfcf1d9fc4$export$3c1c1d2c523ad211)(jsonValue));
    }
    /**
     * Search for artists by name (contract 4.4.1).
     */ async lookupArtistsLookupArtistsResponse(requestParameters, initOverrides) {
        const response = await this.lookupArtistsLookupArtistsResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Lookup client aliases (personas) for a westbury client (contract 4.2.2). Returns ArtistAlias records linked to the client user.
     */ async lookupClientAliasesLookupClientAliasesResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling lookupClientAliasesLookupClientAliasesResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling lookupClientAliasesLookupClientAliasesResponse.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/client-aliases/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $231c486235fd2ccd$export$16f2739d82c24713)(jsonValue));
    }
    /**
     * Lookup client aliases (personas) for a westbury client (contract 4.2.2). Returns ArtistAlias records linked to the client user.
     */ async lookupClientAliasesLookupClientAliasesResponse(requestParameters, initOverrides) {
        const response = await this.lookupClientAliasesLookupClientAliasesResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Lookup a release by source_id and source. Returns 200 with release payload and linked status if in system, 404 otherwise.
     */ async lookupLookupReleaseResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling lookupLookupReleaseResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling lookupLookupReleaseResponse.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling lookupLookupReleaseResponse.");
        if (requestParameters.source === null || requestParameters.source === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("source", "Required parameter requestParameters.source was null or undefined when calling lookupLookupReleaseResponse.");
        const queryParameters = {};
        if (requestParameters.sourceId !== undefined) queryParameters["source_id"] = requestParameters.sourceId;
        if (requestParameters.source !== undefined) queryParameters["source"] = requestParameters.source;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/releases/lookup/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $70751ac3b08537bb$export$5c590a88b5aac251)(jsonValue));
    }
    /**
     * Lookup a release by source_id and source. Returns 200 with release payload and linked status if in system, 404 otherwise.
     */ async lookupLookupReleaseResponse(requestParameters, initOverrides) {
        const response = await this.lookupLookupReleaseResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Lookup an artist from an external source (Discogs or MusicBrainz) by source ID. Returns stage name, and if the artist is a group, also returns members.
     */ async lookupSourceArtistLookupSourceArtistResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling lookupSourceArtistLookupSourceArtistResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling lookupSourceArtistLookupSourceArtistResponse.");
        if (requestParameters.source === null || requestParameters.source === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("source", "Required parameter requestParameters.source was null or undefined when calling lookupSourceArtistLookupSourceArtistResponse.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling lookupSourceArtistLookupSourceArtistResponse.");
        const queryParameters = {};
        if (requestParameters.source !== undefined) queryParameters["source"] = requestParameters.source;
        if (requestParameters.sourceId !== undefined) queryParameters["source_id"] = requestParameters.sourceId;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/lookup-source/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fac70cf221c7f05a$export$ae8904bed07853df)(jsonValue));
    }
    /**
     * Lookup an artist from an external source (Discogs or MusicBrainz) by source ID. Returns stage name, and if the artist is a group, also returns members.
     */ async lookupSourceArtistLookupSourceArtistResponse(requestParameters, initOverrides) {
        const response = await this.lookupSourceArtistLookupSourceArtistResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Add/delete/edit contributions on a recording (contract 4.2.1).
     */ async manageContributionsServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling manageContributionsServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling manageContributionsServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/contributions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c8f41806c5650da9$export$254a769af7d9fef6)(requestParameters.manageContributionsRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Add/delete/edit contributions on a recording (contract 4.2.1).
     */ async manageContributionsServiceResponse(requestParameters, initOverrides) {
        const response = await this.manageContributionsServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async partialUpdateAdminPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling partialUpdateAdminPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7dac4f16d65ed476$export$7c5d2ff8a10c7191)(requestParameters.adminPersonalInformation)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7dac4f16d65ed476$export$345ccf656783517a)(jsonValue));
    }
    /**
     * 
     */ async partialUpdateAdminPersonalInformation(requestParameters, initOverrides) {
        const response = await this.partialUpdateAdminPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async partialUpdateUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling partialUpdateUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c25f64d49488d97d$export$3e1a5b1b9db0a946)(requestParameters.userSettings)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c25f64d49488d97d$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async partialUpdateUserSettings(requestParameters, initOverrides) {
        const response = await this.partialUpdateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return per-field manual changes for a single recording (contract 4.5.2).
     */ async recordingManualChangesRecordingManualChangesResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling recordingManualChangesRecordingManualChangesResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling recordingManualChangesRecordingManualChangesResponse.");
        const queryParameters = {};
        if (requestParameters.documentId !== undefined) queryParameters["document_id"] = requestParameters.documentId;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/manual-changes/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6f54614e625a1e21$export$fe5b5320f70cac03)(jsonValue));
    }
    /**
     * Return per-field manual changes for a single recording (contract 4.5.2).
     */ async recordingManualChangesRecordingManualChangesResponse(requestParameters, initOverrides) {
        const response = await this.recordingManualChangesRecordingManualChangesResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return per-field manual changes for a single release (contract 4.5.3).  The release is associated with a recording, and overrides are keyed by ``person_rec_id`` (which uses the recording_id). The caller passes the recording_id via query param so we can locate the overrides without an OpenSearch lookup.
     */ async releaseManualChangesReleaseManualChangesResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling releaseManualChangesReleaseManualChangesResponse.");
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("releaseId", "Required parameter requestParameters.releaseId was null or undefined when calling releaseManualChangesReleaseManualChangesResponse.");
        if (requestParameters.recordingId === null || requestParameters.recordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("recordingId", "Required parameter requestParameters.recordingId was null or undefined when calling releaseManualChangesReleaseManualChangesResponse.");
        const queryParameters = {};
        if (requestParameters.recordingId !== undefined) queryParameters["recording_id"] = requestParameters.recordingId;
        if (requestParameters.documentId !== undefined) queryParameters["document_id"] = requestParameters.documentId;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/release/{release_id}/manual-changes/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $65f4a611b3c4875f$export$4cb227311f1acab6)(jsonValue));
    }
    /**
     * Return per-field manual changes for a single release (contract 4.5.3).  The release is associated with a recording, and overrides are keyed by ``person_rec_id`` (which uses the recording_id). The caller passes the recording_id via query param so we can locate the overrides without an OpenSearch lookup.
     */ async releaseManualChangesReleaseManualChangesResponse(requestParameters, initOverrides) {
        const response = await this.releaseManualChangesReleaseManualChangesResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Remove an alias. If deleting this alias would make any bands orphaned (i.e., the band would have no more aliases), those bands will be automatically deleted by a signal handler to prevent users from having bands without aliases.
     */ async removeAliasRemoveRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling removeAliasRemove.");
        if (requestParameters.aliasId === null || requestParameters.aliasId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("aliasId", "Required parameter requestParameters.aliasId was null or undefined when calling removeAliasRemove.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_alias/{user_id}/{alias_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"alias_id"}}`, encodeURIComponent(String(requestParameters.aliasId))),
            method: "DELETE",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$20446dc680588cc3(response);
    }
    /**
     * Remove an alias. If deleting this alias would make any bands orphaned (i.e., the band would have no more aliases), those bands will be automatically deleted by a signal handler to prevent users from having bands without aliases.
     */ async removeAliasRemove(requestParameters, initOverrides) {
        await this.removeAliasRemoveRaw(requestParameters, initOverrides);
    }
    /**
     * Remove a band. The band must be linked to at least one of the user\'s aliases. This will delete the band entirely, which will also remove all relationships.
     */ async removeBandRemoveRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling removeBandRemove.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling removeBandRemove.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))),
            method: "DELETE",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$20446dc680588cc3(response);
    }
    /**
     * Remove a band. The band must be linked to at least one of the user\'s aliases. This will delete the band entirely, which will also remove all relationships.
     */ async removeBandRemove(requestParameters, initOverrides) {
        await this.removeBandRemoveRaw(requestParameters, initOverrides);
    }
    /**
     * Force-cancel the current (often stuck) run and relaunch it fresh.  Exposed to admins as a recovery action; the UI surfaces it when a run is stalled. Safe against concurrent triggers via the same row lock + generation token as create().
     */ async restartPrimaryDiscographyRunPipelineRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling restartPrimaryDiscographyRunPipelineRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/{user_id}/restart-primary-discography-run`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $057bd700f894f3a9$export$eb5e6a8ad753c49)(jsonValue));
    }
    /**
     * Force-cancel the current (often stuck) run and relaunch it fresh.  Exposed to admins as a recovery action; the UI surfaces it when a run is stalled. Safe against concurrent triggers via the same row lock + generation token as create().
     */ async restartPrimaryDiscographyRunPipelineRunStatus(requestParameters, initOverrides) {
        const response = await this.restartPrimaryDiscographyRunPipelineRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5e3ca10c0ee31eb4$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.retrieveAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdminBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAdminBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c3418b6825975f57$export$cab2c6e7757d8c1d)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdminBankDetails(requestParameters, initOverrides) {
        const response = await this.retrieveAdminBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdminInterestRegistrationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAdminInterestRegistration.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/interest-registration/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2fea223443d8a350$export$c8c63a6b256b2f84)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdminInterestRegistration(requestParameters, initOverrides) {
        const response = await this.retrieveAdminInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdminPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAdminPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7dac4f16d65ed476$export$345ccf656783517a)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdminPersonalInformation(requestParameters, initOverrides) {
        const response = await this.retrieveAdminPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdminSocietyRaw(requestParameters, initOverrides) {
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling retrieveAdminSociety.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/societies/{society_id}/`.replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3fcbd4bdbdf09193$export$5ed54dd8f8ca2d09)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdminSociety(requestParameters, initOverrides) {
        const response = await this.retrieveAdminSocietyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveArtistDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveArtistDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/artist-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2d99ff3b3060a0c1$export$e4f27606a6d6c163)(jsonValue));
    }
    /**
     * 
     */ async retrieveArtistDetails(requestParameters, initOverrides) {
        const response = await this.retrieveArtistDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Report the artist\'s latest ID-collection run.  Reads the database only — the phase is kept fresh by the Celery Beat poller (portal.tasks.artist_id_collection), so a poll can never be blocked on, or made to lie by, a slow or failing Dagster GraphQL call. When no collection has ever been run this returns an idle payload rather than a 404, so the client can distinguish \"never started\" from \"the request failed\".
     */ async retrieveAutoCollectIdsJobRunStatusArtistIdCollectionRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAutoCollectIdsJobRunStatusArtistIdCollectionRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/auto-collect-ids/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7d0d21cc7dd025f2$export$254fa118bbd0804)(jsonValue));
    }
    /**
     * Report the artist\'s latest ID-collection run.  Reads the database only — the phase is kept fresh by the Celery Beat poller (portal.tasks.artist_id_collection), so a poll can never be blocked on, or made to lie by, a slow or failing Dagster GraphQL call. When no collection has ever been run this returns an idle payload rather than a 404, so the client can distinguish \"never started\" from \"the request failed\".
     */ async retrieveAutoCollectIdsJobRunStatusArtistIdCollectionRunStatus(requestParameters, initOverrides) {
        const response = await this.retrieveAutoCollectIdsJobRunStatusArtistIdCollectionRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve a band by its ID with all related information including linked aliases, source IDs, and relationship flags.  The band does not need to be linked to the user\'s alias to be retrieved. This allows users to retrieve information about bands they found via search_unlinked_bands before linking them.
     */ async retrieveBandArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveBandArtistBand.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling retrieveBandArtistBand.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * Retrieve a band by its ID with all related information including linked aliases, source IDs, and relationship flags.  The band does not need to be linked to the user\'s alias to be retrieved. This allows users to retrieve information about bands they found via search_unlinked_bands before linking them.
     */ async retrieveBandArtistBand(requestParameters, initOverrides) {
        const response = await this.retrieveBandArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveByEmailHashAdminInterestRegistrationRaw(requestParameters, initOverrides) {
        if (requestParameters.emailHash === null || requestParameters.emailHash === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("emailHash", "Required parameter requestParameters.emailHash was null or undefined when calling retrieveByEmailHashAdminInterestRegistration.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{email_hash}/interest-registration/`.replace(`{${"email_hash"}}`, encodeURIComponent(String(requestParameters.emailHash))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2fea223443d8a350$export$c8c63a6b256b2f84)(jsonValue));
    }
    /**
     * 
     */ async retrieveByEmailHashAdminInterestRegistration(requestParameters, initOverrides) {
        const response = await this.retrieveByEmailHashAdminInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveByUsernameUserRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("username", "Required parameter requestParameters.username was null or undefined when calling retrieveByUsernameUser.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{username}/`.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters.username))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4c7d46b022e853c3$export$2965aa33e1f71909)(jsonValue));
    }
    /**
     * 
     */ async retrieveByUsernameUser(requestParameters, initOverrides) {
        const response = await this.retrieveByUsernameUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveCollectedIdsAutoCollectedIdsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveCollectedIdsAutoCollectedIds.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/retrieve-collected-ids/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a674df4c16092127$export$fb097d39fc6e1ac2)(jsonValue));
    }
    /**
     * 
     */ async retrieveCollectedIdsAutoCollectedIds(requestParameters, initOverrides) {
        const response = await this.retrieveCollectedIdsAutoCollectedIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveCompanyRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/company/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d3307ed07f4a305a$export$f608b396a48b017d)(jsonValue));
    }
    /**
     * 
     */ async retrieveCompany(initOverrides) {
        const response = await this.retrieveCompanyRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveCompanyInformationRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/company_information/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5f4c773999e6de59$export$e960ee84a5e4df2c)(jsonValue));
    }
    /**
     * 
     */ async retrieveCompanyInformation(initOverrides) {
        const response = await this.retrieveCompanyInformationRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveDeleteDeclinedArtistRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveDeleteDeclinedArtistRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/delete-declined-artist/{user_id}/pipeline-runs/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $dfb553316c3946d8$export$92d8e90282029ac4)(jsonValue));
    }
    /**
     * 
     */ async retrieveDeleteDeclinedArtistRunStatus(requestParameters, initOverrides) {
        const response = await this.retrieveDeleteDeclinedArtistRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveExternalEvidenceImageSignedUrlRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/evidence-images/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c2dc3b3871d73742$export$c7b1fcf5381c94c3)(jsonValue));
    }
    /**
     * 
     */ async retrieveExternalEvidenceImageSignedUrl(initOverrides) {
        const response = await this.retrieveExternalEvidenceImageSignedUrlRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveFinancialYearsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveFinancialYears.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/financial-years/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a4a0ecc41012d219$export$8b12be228efb1adf)(jsonValue));
    }
    /**
     * 
     */ async retrieveFinancialYears(requestParameters, initOverrides) {
        const response = await this.retrieveFinancialYearsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveIdentityDocumentTypesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/identity-document-types/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $b0fcadbdb9a46931$export$8738fab109abb74d)(jsonValue));
    }
    /**
     * 
     */ async retrieveIdentityDocumentTypes(initOverrides) {
        const response = await this.retrieveIdentityDocumentTypesRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestAdminIdentityDocumentSubmission.");
        if (requestParameters.documentType === null || requestParameters.documentType === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentType", "Required parameter requestParameters.documentType was null or undefined when calling retrieveLatestAdminIdentityDocumentSubmission.");
        const queryParameters = {};
        if (requestParameters.documentType !== undefined) queryParameters["document_type"] = requestParameters.documentType;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $dae85878c5dda937$export$9d955c411567a352)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestAdminIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.retrieveLatestAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestPPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestPPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $22c30025326256b6$export$862cf7f4fa6a9624)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestPPLReviewExport(requestParameters, initOverrides) {
        const response = await this.retrieveLatestPPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestPrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestPrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f360d66880f037a4$export$9064002f671ddae3)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestPrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.retrieveLatestPrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveOnboardingProgressRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveOnboardingProgress.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/onboarding-progress/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4586e55d33e70041$export$549ee7ec67643d0)(jsonValue));
    }
    /**
     * 
     */ async retrieveOnboardingProgress(requestParameters, initOverrides) {
        const response = await this.retrieveOnboardingProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveOnboardingStepsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveOnboardingSteps.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/onboarding-steps/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $431eb5e7bf5a2364$export$addf7c24f7592504)(jsonValue));
    }
    /**
     * 
     */ async retrieveOnboardingSteps(requestParameters, initOverrides) {
        const response = await this.retrieveOnboardingStepsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePPLReviewExport.");
        if (requestParameters.exportId === null || requestParameters.exportId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("exportId", "Required parameter requestParameters.exportId was null or undefined when calling retrievePPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/{export_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"export_id"}}`, encodeURIComponent(String(requestParameters.exportId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $22c30025326256b6$export$862cf7f4fa6a9624)(jsonValue));
    }
    /**
     * 
     */ async retrievePPLReviewExport(requestParameters, initOverrides) {
        const response = await this.retrievePPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePandadocEgressRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePandadocEgress.");
        if (requestParameters.societyFormId === null || requestParameters.societyFormId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyFormId", "Required parameter requestParameters.societyFormId was null or undefined when calling retrievePandadocEgress.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/pandadocs/{user_id}/egress/{society_form_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"society_form_id"}}`, encodeURIComponent(String(requestParameters.societyFormId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3a3591882bee0359$export$3e714e27ace81dea)(jsonValue));
    }
    /**
     * 
     */ async retrievePandadocEgress(requestParameters, initOverrides) {
        const response = await this.retrievePandadocEgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePipelineRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePipelineRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/{user_id}/pipeline-runs/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $057bd700f894f3a9$export$eb5e6a8ad753c49)(jsonValue));
    }
    /**
     * 
     */ async retrievePipelineRunStatus(requestParameters, initOverrides) {
        const response = await this.retrievePipelineRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePrimaryDiscographyExport.");
        if (requestParameters.exportId === null || requestParameters.exportId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("exportId", "Required parameter requestParameters.exportId was null or undefined when calling retrievePrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/{export_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"export_id"}}`, encodeURIComponent(String(requestParameters.exportId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f360d66880f037a4$export$9064002f671ddae3)(jsonValue));
    }
    /**
     * 
     */ async retrievePrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.retrievePrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveRecordingRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveRecording.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling retrieveRecording.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3c900270811aff1c$export$ada4d9eb25dcb112)(jsonValue));
    }
    /**
     * 
     */ async retrieveRecording(requestParameters, initOverrides) {
        const response = await this.retrieveRecordingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fb6864c8a884a76f$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async retrieveRepresentative(requestParameters, initOverrides) {
        const response = await this.retrieveRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveStatementsJsonRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveStatementsJson.");
        const queryParameters = {};
        if (requestParameters.paymentDay !== undefined) queryParameters["payment_day"] = requestParameters.paymentDay;
        if (requestParameters.paymentDays) queryParameters["payment_days"] = requestParameters.paymentDays;
        if (requestParameters.format !== undefined) queryParameters["format"] = requestParameters.format;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/statements/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $168756c1563daff7$export$b7af3949b8b2f080)(jsonValue));
    }
    /**
     * 
     */ async retrieveStatementsJson(requestParameters, initOverrides) {
        const response = await this.retrieveStatementsJsonRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveTermsOfAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveTermsOfAgreement.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/terms-of-agreement`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $41529a4feb258a75$export$aad686261db31a8a)(jsonValue));
    }
    /**
     * 
     */ async retrieveTermsOfAgreement(requestParameters, initOverrides) {
        const response = await this.retrieveTermsOfAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveUserRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveUser.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4c7d46b022e853c3$export$2965aa33e1f71909)(jsonValue));
    }
    /**
     * 
     */ async retrieveUser(requestParameters, initOverrides) {
        const response = await this.retrieveUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c25f64d49488d97d$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async retrieveUserSettings(requestParameters, initOverrides) {
        const response = await this.retrieveUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async searchArtistDiscogsArtistRaw(requestParameters, initOverrides) {
        if (requestParameters.discogsId === null || requestParameters.discogsId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("discogsId", "Required parameter requestParameters.discogsId was null or undefined when calling searchArtistDiscogsArtist.");
        const queryParameters = {};
        if (requestParameters.discogsId !== undefined) queryParameters["discogs_id"] = requestParameters.discogsId;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/discogs/search-artist/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $df0aa53153605dcb$export$7ffb5db8dd7d4adb)(jsonValue));
    }
    /**
     * 
     */ async searchArtistDiscogsArtist(requestParameters, initOverrides) {
        const response = await this.searchArtistDiscogsArtistRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async searchDiscogsSearchRaw(requestParameters, initOverrides) {
        if (requestParameters.searchTerm === null || requestParameters.searchTerm === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("searchTerm", "Required parameter requestParameters.searchTerm was null or undefined when calling searchDiscogsSearch.");
        const queryParameters = {};
        if (requestParameters.searchTerm !== undefined) queryParameters["search_term"] = requestParameters.searchTerm;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/discogs/search/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d52b7e4a81f98461$export$26b7684970b2390)(jsonValue));
    }
    /**
     * 
     */ async searchDiscogsSearch(requestParameters, initOverrides) {
        const response = await this.searchDiscogsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async searchForSourceSearchForSourceRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling searchForSourceSearchForSource.");
        if (requestParameters.source === null || requestParameters.source === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("source", "Required parameter requestParameters.source was null or undefined when calling searchForSourceSearchForSource.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling searchForSourceSearchForSource.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/search-source/{user_id}/{source}/{source_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"source"}}`, encodeURIComponent(String(requestParameters.source))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fbe666a5f63b7744$export$5de9333a3592861b)(jsonValue));
    }
    /**
     * 
     */ async searchForSourceSearchForSource(requestParameters, initOverrides) {
        const response = await this.searchForSourceSearchForSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async searchPrimaryDiscographyRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling searchPrimaryDiscography.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $594f7d6be671f0be$export$f75ce5365b9c0f3d)(requestParameters.primaryDiscographyRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $73fba44bd928db81$export$c7fe272dbd4732e2)(jsonValue));
    }
    /**
     * 
     */ async searchPrimaryDiscography(requestParameters, initOverrides) {
        const response = await this.searchPrimaryDiscographyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Search for bands that are not yet linked to the given alias. Returns bands with their band_id, name (stage_name), and discogs/musicbrainz source_id.  Query parameters: - q: Optional search query to filter bands by name (stage_name)
     */ async searchUnlinkedBandsUnlinkedBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling searchUnlinkedBandsUnlinkedBand.");
        if (requestParameters.aliasId === null || requestParameters.aliasId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("aliasId", "Required parameter requestParameters.aliasId was null or undefined when calling searchUnlinkedBandsUnlinkedBand.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_alias/{user_id}/{alias_id}/search-unlinked-bands`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"alias_id"}}`, encodeURIComponent(String(requestParameters.aliasId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        if (this.isJsonMime(response.headers.get("content-type"))) return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response);
        else return new $f599d8a7dfeab1bb$export$bf40ae8c274ef99b(response);
    }
    /**
     * Search for bands that are not yet linked to the given alias. Returns bands with their band_id, name (stage_name), and discogs/musicbrainz source_id.  Query parameters: - q: Optional search query to filter bands by name (stage_name)
     */ async searchUnlinkedBandsUnlinkedBand(requestParameters, initOverrides) {
        const response = await this.searchUnlinkedBandsUnlinkedBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async signUrlExternalEvidenceImageSignedUrlRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/evidence-images/sign-url/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $bbcd59aa11698e87$export$6a86535ea0505be0)(requestParameters.externalEvidenceImageSignedUrlRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c2dc3b3871d73742$export$c7b1fcf5381c94c3)(jsonValue));
    }
    /**
     * 
     */ async signUrlExternalEvidenceImageSignedUrl(requestParameters = {}, initOverrides) {
        const response = await this.signUrlExternalEvidenceImageSignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Unlink an alias from a band. This removes the alias from the band\'s artist_aliases ManyToMany relationship and also removes it from permanent_members and main_performers if present.  Handles orphaned links where the alias may have been deleted but the link still exists. In such cases, we query the through model directly and match by alias_id.
     */ async unlinkAliasFromBandArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling unlinkAliasFromBandArtistBand.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling unlinkAliasFromBandArtistBand.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}/unlink-alias`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $d064efbbb98dc469$export$7965ee62db2629e0)(requestParameters.unlinkAliasFromBand)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * Unlink an alias from a band. This removes the alias from the band\'s artist_aliases ManyToMany relationship and also removes it from permanent_members and main_performers if present.  Handles orphaned links where the alias may have been deleted but the link still exists. In such cases, we query the through model directly and match by alias_id.
     */ async unlinkAliasFromBandArtistBand(requestParameters, initOverrides) {
        const response = await this.unlinkAliasFromBandArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $5e3ca10c0ee31eb4$export$a23c9ba4a9c33181)(requestParameters.additionalContactDetails)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5e3ca10c0ee31eb4$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async updateAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.updateAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdminBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c3418b6825975f57$export$ff8d63926b23924f)(requestParameters.adminBankDetails)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c3418b6825975f57$export$cab2c6e7757d8c1d)(jsonValue));
    }
    /**
     * 
     */ async updateAdminBankDetails(requestParameters, initOverrides) {
        const response = await this.updateAdminBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdminIdentityDocumentSubmission.");
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentId", "Required parameter requestParameters.documentId was null or undefined when calling updateAdminIdentityDocumentSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.dateCreated !== undefined) formParams.append("date_created", requestParameters.dateCreated);
        if (requestParameters.file !== undefined) formParams.append("file", requestParameters.file);
        if (requestParameters.filename !== undefined) formParams.append("filename", requestParameters.filename);
        if (requestParameters.status !== undefined) formParams.append("status", requestParameters.status);
        if (requestParameters.documentExpiryDate !== undefined) formParams.append("document_expiry_date", requestParameters.documentExpiryDate);
        if (requestParameters.documentSignedDate !== undefined) formParams.append("document_signed_date", requestParameters.documentSignedDate);
        if (requestParameters.documentType !== undefined) formParams.append("document_type", requestParameters.documentType);
        if (requestParameters.fileUrl !== undefined) formParams.append("file_url", requestParameters.fileUrl);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/{document_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $dae85878c5dda937$export$9d955c411567a352)(jsonValue));
    }
    /**
     * 
     */ async updateAdminIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.updateAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminInterestRegistrationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdminInterestRegistration.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/interest-registration/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2fea223443d8a350$export$887cdb805eaac4d8)(requestParameters.adminInterestRegistration)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2fea223443d8a350$export$c8c63a6b256b2f84)(jsonValue));
    }
    /**
     * 
     */ async updateAdminInterestRegistration(requestParameters, initOverrides) {
        const response = await this.updateAdminInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdminPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7dac4f16d65ed476$export$7c5d2ff8a10c7191)(requestParameters.adminPersonalInformation)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7dac4f16d65ed476$export$345ccf656783517a)(jsonValue));
    }
    /**
     * 
     */ async updateAdminPersonalInformation(requestParameters, initOverrides) {
        const response = await this.updateAdminPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminUpdateSocietyRaw(requestParameters, initOverrides) {
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling updateAdminUpdateSociety.");
        if (requestParameters.readableName === null || requestParameters.readableName === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("readableName", "Required parameter requestParameters.readableName was null or undefined when calling updateAdminUpdateSociety.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "application/x-www-form-urlencoded"
            },
            {
                contentType: "multipart/form-data"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.readableName !== undefined) formParams.append("readable_name", requestParameters.readableName);
        if (requestParameters.logo !== undefined) formParams.append("logo", requestParameters.logo);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.website !== undefined) formParams.append("website", requestParameters.website);
        if (requestParameters.portal !== undefined) formParams.append("portal", requestParameters.portal);
        if (requestParameters.phone !== undefined) formParams.append("phone", requestParameters.phone);
        if (requestParameters.address !== undefined) formParams.append("address", requestParameters.address);
        if (requestParameters.additionalTerritories) formParams.append("additional_territories", requestParameters.additionalTerritories.join($f599d8a7dfeab1bb$export$83cb526776fb323d["csv"]));
        if (requestParameters.formEmail !== undefined) formParams.append("form_email", requestParameters.formEmail);
        if (requestParameters.formPostalAddress !== undefined) formParams.append("form_postal_address", requestParameters.formPostalAddress);
        if (requestParameters.formPortal !== undefined) formParams.append("form_portal", requestParameters.formPortal);
        if (requestParameters.formReminderFrequency !== undefined) formParams.append("form_reminder_frequency", requestParameters.formReminderFrequency);
        if (requestParameters.formStopReminderFrequency !== undefined) formParams.append("form_stop_reminder_frequency", requestParameters.formStopReminderFrequency);
        if (requestParameters.formReminderSendTo !== undefined) formParams.append("form_reminder_send_to", requestParameters.formReminderSendTo);
        if (requestParameters.taxForms !== undefined) formParams.append("tax_forms", requestParameters.taxForms);
        if (requestParameters.roleForms !== undefined) formParams.append("role_forms", requestParameters.roleForms);
        if (requestParameters.contactInformation !== undefined) formParams.append("contact_information", requestParameters.contactInformation);
        const response = await this.request({
            path: `/portal/societies/{society_id}/`.replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8e38307ea8d81f1$export$c2ece841a794430e)(jsonValue));
    }
    /**
     * 
     */ async updateAdminUpdateSociety(requestParameters, initOverrides) {
        const response = await this.updateAdminUpdateSocietyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminUpdateSocietyCredentialsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdminUpdateSocietyCredentials.");
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling updateAdminUpdateSocietyCredentials.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/societies/{society_id}/login/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $a9fc1541310e50b9$export$17b7e1e566d9de7b)(requestParameters.adminUpdateSocietyCredentials)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a9fc1541310e50b9$export$7cb07a03442ce417)(jsonValue));
    }
    /**
     * 
     */ async updateAdminUpdateSocietyCredentials(requestParameters, initOverrides) {
        const response = await this.updateAdminUpdateSocietyCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAliasArtistAliasRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAliasArtistAlias.");
        if (requestParameters.aliasId === null || requestParameters.aliasId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("aliasId", "Required parameter requestParameters.aliasId was null or undefined when calling updateAliasArtistAlias.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_alias/{user_id}/{alias_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"alias_id"}}`, encodeURIComponent(String(requestParameters.aliasId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $858970a27fda4408$export$963c340a545e1cd9)(requestParameters.artistAliasUpdate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $200e49f2387423dc$export$de3312126358ad1b)(jsonValue));
    }
    /**
     * 
     */ async updateAliasArtistAlias(requestParameters, initOverrides) {
        const response = await this.updateAliasArtistAliasRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAliasSourceIdSourceIdRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAliasSourceIdSourceId.");
        if (requestParameters.aliasId === null || requestParameters.aliasId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("aliasId", "Required parameter requestParameters.aliasId was null or undefined when calling updateAliasSourceIdSourceId.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling updateAliasSourceIdSourceId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_alias/{user_id}/{alias_id}/source_id/{source_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"alias_id"}}`, encodeURIComponent(String(requestParameters.aliasId))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2014e54837d099b2$export$1d6a3c915367a0a7)(requestParameters.artistSourceIdUpdate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $214bb8fddc542766$export$5754b3e47aa5480)(jsonValue));
    }
    /**
     * 
     */ async updateAliasSourceIdSourceId(requestParameters, initOverrides) {
        const response = await this.updateAliasSourceIdSourceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateBandArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateBandArtistBand.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling updateBandArtistBand.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c84cccdbe293806e$export$6f95b4e96077f462)(requestParameters.artistBandUpdate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * 
     */ async updateBandArtistBand(requestParameters, initOverrides) {
        const response = await this.updateBandArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateBandSourceIdSourceIdRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateBandSourceIdSourceId.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling updateBandSourceIdSourceId.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling updateBandSourceIdSourceId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}/source_id/{source_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2014e54837d099b2$export$1d6a3c915367a0a7)(requestParameters.artistSourceIdUpdate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $214bb8fddc542766$export$5754b3e47aa5480)(jsonValue));
    }
    /**
     * 
     */ async updateBandSourceIdSourceId(requestParameters, initOverrides) {
        const response = await this.updateBandSourceIdSourceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateClientSocietyFormTaskRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateClientSocietyFormTask.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $4ba4f806015061e3$export$1f4009bc54aefa3f)(requestParameters.clientSocietyFormTask)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4ba4f806015061e3$export$7fa8d9ea09641068)(jsonValue));
    }
    /**
     * 
     */ async updateClientSocietyFormTask(requestParameters, initOverrides) {
        const response = await this.updateClientSocietyFormTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateCompanyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/company/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $d3307ed07f4a305a$export$8fe7696865cf5926)(requestParameters.company)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d3307ed07f4a305a$export$f608b396a48b017d)(jsonValue));
    }
    /**
     * 
     */ async updateCompany(requestParameters = {}, initOverrides) {
        const response = await this.updateCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateCompanyFormRoleRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/company/forms/roles/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $acabe406dbdcaf5a$export$1a47cbea4491e9de)(requestParameters.companyFormRole)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $acabe406dbdcaf5a$export$7f857026a8161ae1)(jsonValue));
    }
    /**
     * 
     */ async updateCompanyFormRole(requestParameters = {}, initOverrides) {
        const response = await this.updateCompanyFormRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateCompanyInformationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/company_information/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $5f4c773999e6de59$export$a29fffe331f63309)(requestParameters.companyInformation)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5f4c773999e6de59$export$e960ee84a5e4df2c)(jsonValue));
    }
    /**
     * 
     */ async updateCompanyInformation(requestParameters = {}, initOverrides) {
        const response = await this.updateCompanyInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateLogoImageCompanyInformationLogoImageRaw(requestParameters, initOverrides) {
        if (requestParameters.logoImage === null || requestParameters.logoImage === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("logoImage", "Required parameter requestParameters.logoImage was null or undefined when calling updateLogoImageCompanyInformationLogoImage.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.logoImage !== undefined) formParams.append("logo_image", requestParameters.logoImage);
        if (requestParameters.logoImageUrl !== undefined) formParams.append("logo_image_url", requestParameters.logoImageUrl);
        const response = await this.request({
            path: `/portal/company_information/logo_image/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $aaeb51be8a431108$export$6b09e9c7aa680163)(jsonValue));
    }
    /**
     * 
     */ async updateLogoImageCompanyInformationLogoImage(requestParameters, initOverrides) {
        const response = await this.updateLogoImageCompanyInformationLogoImageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updatePandadocEgressRaw(requestParameters, initOverrides) {
        if (requestParameters.societyFormId === null || requestParameters.societyFormId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyFormId", "Required parameter requestParameters.societyFormId was null or undefined when calling updatePandadocEgress.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/str:user_id>/ingress/{society_form_id}/`.replace(`{${"society_form_id"}}`, encodeURIComponent(String(requestParameters.societyFormId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3a3591882bee0359$export$3e714e27ace81dea)(jsonValue));
    }
    /**
     * 
     */ async updatePandadocEgress(requestParameters, initOverrides) {
        const response = await this.updatePandadocEgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updatePhotoAdminPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updatePhotoAdminPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.user !== undefined) formParams.append("user", requestParameters.user);
        if (requestParameters.url !== undefined) formParams.append("url", requestParameters.url);
        if (requestParameters.oldPassword !== undefined) formParams.append("old_password", requestParameters.oldPassword);
        if (requestParameters.password !== undefined) formParams.append("password", requestParameters.password);
        if (requestParameters.role !== undefined) formParams.append("role", requestParameters.role);
        if (requestParameters.title !== undefined) formParams.append("title", requestParameters.title);
        if (requestParameters.gender !== undefined) formParams.append("gender", requestParameters.gender);
        if (requestParameters.cityOfBirth !== undefined) formParams.append("city_of_birth", requestParameters.cityOfBirth);
        if (requestParameters.countryOfBirth !== undefined) formParams.append("country_of_birth", requestParameters.countryOfBirth);
        if (requestParameters.fullName !== undefined) formParams.append("full_name", requestParameters.fullName);
        if (requestParameters.firstName !== undefined) formParams.append("first_name", requestParameters.firstName);
        if (requestParameters.middleName !== undefined) formParams.append("middle_name", requestParameters.middleName);
        if (requestParameters.lastName !== undefined) formParams.append("last_name", requestParameters.lastName);
        if (requestParameters.department !== undefined) formParams.append("department", requestParameters.department);
        if (requestParameters.departmentChoices) formParams.append("department_choices", requestParameters.departmentChoices.join($f599d8a7dfeab1bb$export$83cb526776fb323d["csv"]));
        if (requestParameters.userPhoto !== undefined) formParams.append("user_photo", requestParameters.userPhoto);
        if (requestParameters.userPhotoUrl !== undefined) formParams.append("user_photo_url", requestParameters.userPhotoUrl);
        if (requestParameters.dateOfBirth !== undefined) formParams.append("date_of_birth", requestParameters.dateOfBirth);
        if (requestParameters.aliases) formParams.append("aliases", requestParameters.aliases.join($f599d8a7dfeab1bb$export$83cb526776fb323d["csv"]));
        if (requestParameters.nationality !== undefined) formParams.append("nationality", requestParameters.nationality);
        if (requestParameters.taxationCountry !== undefined) formParams.append("taxation_country", requestParameters.taxationCountry);
        if (requestParameters.vatNumber !== undefined) formParams.append("vat_number", requestParameters.vatNumber);
        if (requestParameters.taxIdType !== undefined) formParams.append("tax_id_type", requestParameters.taxIdType);
        if (requestParameters.taxIdNumber !== undefined) formParams.append("tax_id_number", requestParameters.taxIdNumber);
        if (requestParameters.emailAddress !== undefined) formParams.append("email_address", requestParameters.emailAddress);
        if (requestParameters.streetAddress !== undefined) formParams.append("street_address", requestParameters.streetAddress);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.phoneNumber !== undefined) formParams.append("phone_number", requestParameters.phoneNumber);
        if (requestParameters.county !== undefined) formParams.append("county", requestParameters.county);
        if (requestParameters.postcode !== undefined) formParams.append("postcode", requestParameters.postcode);
        if (requestParameters.westburyId !== undefined) formParams.append("westbury_id", requestParameters.westburyId);
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/photo/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7dac4f16d65ed476$export$345ccf656783517a)(jsonValue));
    }
    /**
     * 
     */ async updatePhotoAdminPersonalInformation(requestParameters, initOverrides) {
        const response = await this.updatePhotoAdminPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $fb6864c8a884a76f$export$4b283602380be6d7)(requestParameters.representative)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fb6864c8a884a76f$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async updateRepresentative(requestParameters, initOverrides) {
        const response = await this.updateRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateSignupAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signup/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7f55453984ef7fbf$export$eca3401b04c34cf9)(requestParameters.signup)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $25f117375b97ece2$export$f36f5aa70c133e5)(jsonValue));
    }
    /**
     * 
     */ async updateSignupAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.updateSignupAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateTermsOfAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateTermsOfAgreement.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/terms-of-agreement`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $41529a4feb258a75$export$65df8c0be059cbe4)(requestParameters.termsOfAgreement)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $41529a4feb258a75$export$aad686261db31a8a)(jsonValue));
    }
    /**
     * 
     */ async updateTermsOfAgreement(requestParameters, initOverrides) {
        const response = await this.updateTermsOfAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update secondary discography run date_sent_to_society
     */ async updateUpdateSecondaryDiscographyRaw(requestParameters, initOverrides) {
        if (requestParameters.exportId === null || requestParameters.exportId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("exportId", "Required parameter requestParameters.exportId was null or undefined when calling updateUpdateSecondaryDiscography.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/secondary-discography/exports/{export_id}/`.replace(`{${"export_id"}}`, encodeURIComponent(String(requestParameters.exportId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c6c420569328d714$export$d0a38c5e29567915)(requestParameters.updateSecondaryDiscography)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c6c420569328d714$export$8bbfe98d5513cd56)(jsonValue));
    }
    /**
     * Update secondary discography run date_sent_to_society
     */ async updateUpdateSecondaryDiscography(requestParameters, initOverrides) {
        const response = await this.updateUpdateSecondaryDiscographyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c25f64d49488d97d$export$3e1a5b1b9db0a946)(requestParameters.userSettings)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c25f64d49488d97d$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async updateUserSettings(requestParameters, initOverrides) {
        const response = await this.updateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Check if an ISRC already exists on another recording in the client\'s discography. Queries OpenSearch directly to return both the recording ID and the document _id.
     */ async validateIsrcValidateIsrcResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling validateIsrcValidateIsrcResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling validateIsrcValidateIsrcResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/validate-isrc/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $f564258d4f2af8a7$export$799cb3b787059bbf)(requestParameters.validateIsrcRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $838b69d64b5f7b42$export$a501d6a07889adaa)(jsonValue));
    }
    /**
     * Check if an ISRC already exists on another recording in the client\'s discography. Queries OpenSearch directly to return both the recording ID and the document _id.
     */ async validateIsrcValidateIsrcResponse(requestParameters, initOverrides) {
        const response = await this.validateIsrcValidateIsrcResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
const $cdef5ca7170fc2e8$export$263f2605af3f0c16 = {
    ClientToSign: "client_to_sign",
    WithClient: "with_client",
    AdminToSign: "admin_to_sign",
    AwaitingUpload: "awaiting_upload",
    Approved: "approved"
};
const $cdef5ca7170fc2e8$export$b55f108801bf5ab0 = {
    Discogs: "discogs",
    Musicbrainz: "musicbrainz",
    Spotify: "spotify",
    Deezer: "deezer"
};
const $cdef5ca7170fc2e8$export$eaaf76520b8d23b3 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $cdef5ca7170fc2e8$export$bae637b0fd5e2dea = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $cdef5ca7170fc2e8$export$5a6c30e5bfed4bb3 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $cdef5ca7170fc2e8$export$562f67bb7d0bda8f = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
const $cdef5ca7170fc2e8$export$73e80048d9b56855 = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer",
    Ppl: "ppl"
};
const $cdef5ca7170fc2e8$export$f9fe1534b58e5b47 = {
    Discogs: "discogs",
    Musicbrainz: "musicbrainz"
};
const $cdef5ca7170fc2e8$export$f3cefc662c9c3e76 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $cdef5ca7170fc2e8$export$cdcbbd330fed22ba = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
const $cdef5ca7170fc2e8$export$ba55551ba77207a9 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $cdef5ca7170fc2e8$export$fbfa1727eed9158e = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $cdef5ca7170fc2e8$export$5fc837e01e685c0d = {
    PerformerProducer: "Performer/Producer"
};
const $cdef5ca7170fc2e8$export$7a9708d676b5b328 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $cdef5ca7170fc2e8$export$1574a53df3fc8a8f = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};







const $1978162fe9dc014b$export$3b164a006a884f7 = "https://web.dev.westburymusic.com";
const $1978162fe9dc014b$var$AuthRoutes = {
    tokenObtain: `${$1978162fe9dc014b$export$3b164a006a884f7}/portal/api/token/`,
    tokenRefresh: `${$1978162fe9dc014b$export$3b164a006a884f7}/portal/api/token/refresh/`,
    tokenVerify: `${$1978162fe9dc014b$export$3b164a006a884f7}/portal/api/token/verify/`,
    signIn: `${$1978162fe9dc014b$export$3b164a006a884f7}/portal/signin/`,
    signUp: `${$1978162fe9dc014b$export$3b164a006a884f7}/portal/signup/`
};
async function $1978162fe9dc014b$export$c54666775b9f7f1a(credentials) {
    const response = await fetch($1978162fe9dc014b$var$AuthRoutes.tokenObtain, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            username: credentials.identifier,
            password: credentials.password
        })
    });
    return await response.json();
}
async function $1978162fe9dc014b$export$c4918b461d83debb(refreshToken) {
    const response = await fetch($1978162fe9dc014b$var$AuthRoutes.tokenRefresh, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            refresh: refreshToken
        })
    });
    return await response.json();
}
const $1978162fe9dc014b$var$saveLocationToSessionStorage = ()=>{
    sessionStorage.setItem("prev", location.href);
};
const $1978162fe9dc014b$export$56e55eecc9e3b311 = ()=>{
    return sessionStorage.getItem("prev");
};
const $1978162fe9dc014b$var$clearLocationFromSessionStorage = ()=>{
    sessionStorage.removeItem("prev");
};
function $1978162fe9dc014b$export$fe0bd509971bc7b3(token) {
    sessionStorage.setItem("token", JSON.stringify(token));
}
function $1978162fe9dc014b$export$843994e1ed9d1163() {
    sessionStorage.removeItem("token");
}
function $1978162fe9dc014b$export$76e3c576b65ee323() {
    const token = sessionStorage.getItem("token");
    if (token === null) return null; // token is not set, raise exception?
    return JSON.parse(token);
}
function $1978162fe9dc014b$export$9d1cdfdf434fc246(clientLoginResponse) {
    $1978162fe9dc014b$export$fe0bd509971bc7b3(clientLoginResponse.token);
    const prev = $1978162fe9dc014b$export$56e55eecc9e3b311();
    if (prev) {
        $1978162fe9dc014b$var$clearLocationFromSessionStorage();
        location.href = prev;
    }
}
function $1978162fe9dc014b$export$88aa089937905007(adminLoginResponse) {
    $1978162fe9dc014b$export$fe0bd509971bc7b3(adminLoginResponse.token);
    const prev = $1978162fe9dc014b$export$56e55eecc9e3b311();
    if (prev) {
        $1978162fe9dc014b$var$clearLocationFromSessionStorage();
        location.href = prev;
    }
}
function $1978162fe9dc014b$export$a6f1ecf08e412113() {
    const token = $1978162fe9dc014b$export$76e3c576b65ee323();
    if (token === null) return {};
    return {
        Authorization: `Bearer ${token.access}`
    };
}
class $1978162fe9dc014b$export$c6a5536d8f7c4cfe {
    // https://github.com/OpenAPITools/openapi-generator/issues/2594#issuecomment-808808097
    // Note: this is the only documentation I could find on implementing
    // middleware via this openapi client (typescript-fetch)
    async pre(context) {
        // do we need to sanitize the url??
        if (![
            $1978162fe9dc014b$var$AuthRoutes.signIn,
            $1978162fe9dc014b$var$AuthRoutes.signUp
        ].includes(context.url)) context.init.headers = {
            ...$1978162fe9dc014b$export$a6f1ecf08e412113(),
            ...context.init.headers
        };
        return Promise.resolve({
            url: context.url,
            init: context.init
        });
    }
    async post(context) {
        if (context.response.status === 401) return context.response.json().then(async ({ code: code })=>{
            $1978162fe9dc014b$var$saveLocationToSessionStorage();
            $1978162fe9dc014b$export$843994e1ed9d1163();
            location.pathname = "/signin";
            // [TODO]: when adding remember me functionality, use refresh token if available
            // method moved into 'refreshAccessToken' function
            // await refreshAccessToken();
            if (code !== "token_not_valid") return Promise.resolve(context.response);
            context.init.headers = {
                ...context.init.headers,
                ...$1978162fe9dc014b$export$a6f1ecf08e412113()
            };
            return fetch(context.url, context.init);
        }).catch(()=>Promise.resolve(context.response));
        return Promise.resolve(context.response);
    }
}
const $1978162fe9dc014b$var$refreshAccessToken = async ()=>{
    const token = $1978162fe9dc014b$export$76e3c576b65ee323();
    if (token === null) throw new Error();
    await $1978162fe9dc014b$export$c4918b461d83debb(token.refresh).then((response)=>{
        $1978162fe9dc014b$export$fe0bd509971bc7b3({
            ...token,
            access: response.access
        });
    });
};


var $630dda8d81b1b9e8$exports = {};

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $630dda8d81b1b9e8$require$Buffer = $6ZWSX.Buffer;

var $4kvQX = parcelRequire("4kvQX");
var $3bfdb7183e8721d6$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $hPtJY.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return "";
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
$3bfdb7183e8721d6$exports = $3bfdb7183e8721d6$var$posix;


var $8e2551e033e95cb5$export$edf525f30916fbb8;
var $8e2551e033e95cb5$export$640106f6dc7d2706;
var $8e2551e033e95cb5$export$3ea386628068cf62;
var $8e2551e033e95cb5$export$749d472264fad440;
var $8e2551e033e95cb5$export$8b931a48d9488767;
var $8e2551e033e95cb5$export$9123f37609399513;
var $8e2551e033e95cb5$export$9b60beb643db4d69;
var $8e2551e033e95cb5$export$bf9fb029d174d554;
var $8e2551e033e95cb5$export$23d3fad09dc44362;
var $8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5;
var $8e2551e033e95cb5$export$3bf7c33313eba0fe;
var $8e2551e033e95cb5$export$7925d89f138dad5b;
var $8e2551e033e95cb5$export$722a64dea1b767dc;
var $8e2551e033e95cb5$export$9e6c06a7d47f9af7;
var $8e2551e033e95cb5$export$6b76988456c0292f;
var $8e2551e033e95cb5$export$266d3b9babd1fc45;
var $8e2551e033e95cb5$export$c1d46b5ea6262c0b;
$8e2551e033e95cb5$export$edf525f30916fbb8 = function() {
    return "LE";
};
$8e2551e033e95cb5$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$8e2551e033e95cb5$export$3ea386628068cf62 = function() {
    return [];
};
$8e2551e033e95cb5$export$749d472264fad440 = function() {
    return 0;
};
$8e2551e033e95cb5$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9b60beb643db4d69 = function() {
    return [];
};
$8e2551e033e95cb5$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$8e2551e033e95cb5$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5 = $8e2551e033e95cb5$export$3bf7c33313eba0fe = function() {
    return {};
};
$8e2551e033e95cb5$export$7925d89f138dad5b = function() {
    return "javascript";
};
$8e2551e033e95cb5$export$722a64dea1b767dc = function() {
    return "browser";
};
$8e2551e033e95cb5$export$9e6c06a7d47f9af7 = $8e2551e033e95cb5$export$6b76988456c0292f = function() {
    return "/tmp";
};
$8e2551e033e95cb5$export$266d3b9babd1fc45 = "\n";
$8e2551e033e95cb5$export$c1d46b5ea6262c0b = function() {
    return "/";
};


var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
"use strict";

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));
var $aaef572789dc684d$exports = {};
"use strict";

$aaef572789dc684d$exports = (parcelRequire("6swAi"));


var $44edd02a6be448cd$var$algoKeys = Object.keys($aaef572789dc684d$exports);
var $44edd02a6be448cd$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;
var $f85287bc79724838$exports = {};

var $26nOC = parcelRequire("26nOC");
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
"use strict";

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));



var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    "des-ede3-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    "des-ede3": $675eb908dbde2e68$export$947646e34766044f,
    "des-ede-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    "des-ede": $675eb908dbde2e68$export$947646e34766044f,
    "des-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$cc8859615686b300),
    "des-ecb": $675eb908dbde2e68$export$cc8859615686b300
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes["des-cbc"];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes["des-ede3-cbc"];
$f85287bc79724838$exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};



var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");
var $0649907c0434f982$exports = {};

$parcel$export($0649907c0434f982$exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export($0649907c0434f982$exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export($0649907c0434f982$exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export($0649907c0434f982$exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export($0649907c0434f982$exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export($0649907c0434f982$exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export($0649907c0434f982$exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export($0649907c0434f982$exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($0649907c0434f982$exports).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;


$44edd02a6be448cd$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$export$26e5786e8ac8e530;
$44edd02a6be448cd$export$bdd223f16383713e = $a97f913e2ff95e3b$export$bdd223f16383713e;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$export$20533d26f07f1ee0;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
$44edd02a6be448cd$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$12ada9414fbc594c;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$36b6d6ef312eab39;
$44edd02a6be448cd$export$58a258485f1e49f6 = $a97f913e2ff95e3b$export$58a258485f1e49f6;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;
var $7f34ba2fa9025258$exports = {};

var $hkN9y = parcelRequire("hkN9y");
$7f34ba2fa9025258$exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);
var $bac5f004a90de4c6$exports = {};

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
$bac5f004a90de4c6$exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $7f34ba2fa9025258$var$millerRabin = new $bac5f004a90de4c6$exports();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}


var $f0f71b0d846b32d7$exports = {};
$f0f71b0d846b32d7$exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');


var $8911d62d5514749e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $8911d62d5514749e$var$millerRabin = new $bac5f004a90de4c6$exports();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);


var $hkN9y = parcelRequire("hkN9y");
$8911d62d5514749e$exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$7f34ba2fa9025258$exports.simpleSieve || !$7f34ba2fa9025258$exports.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].prime, "hex");
    var gen = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].gen, "hex");
    return new $8911d62d5514749e$exports(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $8911d62d5514749e$exports($7f34ba2fa9025258$exports(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $8911d62d5514749e$exports(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;


$44edd02a6be448cd$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$971862a2fcb1bb40;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
$44edd02a6be448cd$export$fdc27893e98845cc = $4387b1fafb8a1868$export$fdc27893e98845cc;
$44edd02a6be448cd$export$6671fb9a1323bed = $4387b1fafb8a1868$export$6671fb9a1323bed;
$44edd02a6be448cd$export$d74daf141a551db = $4387b1fafb8a1868$export$d74daf141a551db;
var $3550302076d9e62e$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $62Mby = parcelRequire("62Mby");

var $dlqwk = parcelRequire("dlqwk");
var $4d6db7c28d99f640$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");
var $7fcf61ce5a538063$exports = {};
$7fcf61ce5a538063$exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');


var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $7fcf61ce5a538063$exports[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
$4d6db7c28d99f640$exports = $4d6db7c28d99f640$var$sign;
$4d6db7c28d99f640$exports.getKey = $4d6db7c28d99f640$var$getKey;
$4d6db7c28d99f640$exports.makeKey = $4d6db7c28d99f640$var$makeKey;


var $b885ed4272d45f84$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $7fcf61ce5a538063$exports[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
$b885ed4272d45f84$exports = $b885ed4272d45f84$var$verify;



var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, "hex");
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $62Mby.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $62Mby.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $4d6db7c28d99f640$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $62Mby.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $62Mby.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $b885ed4272d45f84$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
$3550302076d9e62e$exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};


$44edd02a6be448cd$export$45df7cae684751af = $3550302076d9e62e$exports.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $3550302076d9e62e$exports.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $3550302076d9e62e$exports.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $3550302076d9e62e$exports.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};


$44edd02a6be448cd$export$512823e338ddb1b7 = $b7e0a6843ffae451$export$512823e338ddb1b7;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
$44edd02a6be448cd$export$b9d55ff329113abd = $b7e0a6843ffae451$export$b9d55ff329113abd;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}


$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
$44edd02a6be448cd$export$2f7171e78e524d5e = $8c5943302864e9a5$export$2f7171e78e524d5e;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};


var $d4bdae746c4edf7a$exports = {};
$d4bdae746c4edf7a$exports = JSON.parse('{"name":"dotenv","version":"16.3.1","description":"Loads environment variables from .env file","main":"lib/main.js","types":"lib/main.d.ts","exports":{".":{"types":"./lib/main.d.ts","require":"./lib/main.js","default":"./lib/main.js"},"./config":"./config.js","./config.js":"./config.js","./lib/env-options":"./lib/env-options.js","./lib/env-options.js":"./lib/env-options.js","./lib/cli-options":"./lib/cli-options.js","./lib/cli-options.js":"./lib/cli-options.js","./package.json":"./package.json"},"scripts":{"dts-check":"tsc --project tests/types/tsconfig.json","lint":"standard","lint-readme":"standard-markdown","pretest":"npm run lint && npm run dts-check","test":"tap tests/*.js --100 -Rspec","prerelease":"npm test","release":"standard-version"},"repository":{"type":"git","url":"git://github.com/motdotla/dotenv.git"},"funding":"https://github.com/motdotla/dotenv?sponsor=1","keywords":["dotenv","env",".env","environment","variables","config","settings"],"readmeFilename":"README.md","license":"BSD-2-Clause","devDependencies":{"@definitelytyped/dtslint":"^0.0.133","@types/node":"^18.11.3","decache":"^4.6.1","sinon":"^14.0.1","standard":"^17.0.0","standard-markdown":"^7.1.0","standard-version":"^9.5.0","tap":"^16.3.0","tar":"^6.1.11","typescript":"^4.8.4"},"engines":{"node":">=12"},"browser":{"fs":false}}');


const $630dda8d81b1b9e8$var$version = $d4bdae746c4edf7a$exports.version;
const $630dda8d81b1b9e8$var$LINE = /(?:^|^)\s*(?:export\s+)?([\w.-]+)(?:\s*=\s*?|:\s+?)(\s*'(?:\\'|[^'])*'|\s*"(?:\\"|[^"])*"|\s*`(?:\\`|[^`])*`|[^#\r\n]+)?\s*(?:#.*)?(?:$|$)/mg;
// Parse src into an Object
function $630dda8d81b1b9e8$var$parse(src) {
    const obj = {};
    // Convert buffer to string
    let lines = src.toString();
    // Convert line breaks to same format
    lines = lines.replace(/\r\n?/mg, "\n");
    let match;
    while((match = $630dda8d81b1b9e8$var$LINE.exec(lines)) != null){
        const key = match[1];
        // Default undefined or null to empty string
        let value = match[2] || "";
        // Remove whitespace
        value = value.trim();
        // Check if double quoted
        const maybeQuote = value[0];
        // Remove surrounding quotes
        value = value.replace(/^(['"`])([\s\S]*)\1$/mg, "$2");
        // Expand newlines if double quoted
        if (maybeQuote === '"') {
            value = value.replace(/\\n/g, "\n");
            value = value.replace(/\\r/g, "\r");
        }
        // Add to object
        obj[key] = value;
    }
    return obj;
}
function $630dda8d81b1b9e8$var$_parseVault(options) {
    const vaultPath = $630dda8d81b1b9e8$var$_vaultPath(options);
    // Parse .env.vault
    const result = $630dda8d81b1b9e8$var$DotenvModule.configDotenv({
        path: vaultPath
    });
    if (!result.parsed) throw new Error(`MISSING_DATA: Cannot parse ${vaultPath} for an unknown reason`);
    // handle scenario for comma separated keys - for use with key rotation
    // example: DOTENV_KEY="dotenv://:key_1234@dotenv.org/vault/.env.vault?environment=prod,dotenv://:key_7890@dotenv.org/vault/.env.vault?environment=prod"
    const keys = $630dda8d81b1b9e8$var$_dotenvKey(options).split(",");
    const length = keys.length;
    let decrypted;
    for(let i = 0; i < length; i++)try {
        // Get full key
        const key = keys[i].trim();
        // Get instructions for decrypt
        const attrs = $630dda8d81b1b9e8$var$_instructions(result, key);
        // Decrypt
        decrypted = $630dda8d81b1b9e8$var$DotenvModule.decrypt(attrs.ciphertext, attrs.key);
        break;
    } catch (error) {
        // last key
        if (i + 1 >= length) throw error;
    // try next key
    }
    // Parse decrypted .env string
    return $630dda8d81b1b9e8$var$DotenvModule.parse(decrypted);
}
function $630dda8d81b1b9e8$var$_log(message) {
    console.log(`[dotenv@${$630dda8d81b1b9e8$var$version}][INFO] ${message}`);
}
function $630dda8d81b1b9e8$var$_warn(message) {
    console.log(`[dotenv@${$630dda8d81b1b9e8$var$version}][WARN] ${message}`);
}
function $630dda8d81b1b9e8$var$_debug(message) {
    console.log(`[dotenv@${$630dda8d81b1b9e8$var$version}][DEBUG] ${message}`);
}
function $630dda8d81b1b9e8$var$_dotenvKey(options) {
    // prioritize developer directly setting options.DOTENV_KEY
    if (options && options.DOTENV_KEY && options.DOTENV_KEY.length > 0) return options.DOTENV_KEY;
    // fallback to empty string
    return "";
}
function $630dda8d81b1b9e8$var$_instructions(result, dotenvKey) {
    // Parse DOTENV_KEY. Format is a URI
    let uri;
    try {
        uri = new URL(dotenvKey);
    } catch (error) {
        if (error.code === "ERR_INVALID_URL") throw new Error("INVALID_DOTENV_KEY: Wrong format. Must be in valid uri format like dotenv://:key_1234@dotenv.org/vault/.env.vault?environment=development");
        throw error;
    }
    // Get decrypt key
    const key = uri.password;
    if (!key) throw new Error("INVALID_DOTENV_KEY: Missing key part");
    // Get environment
    const environment = uri.searchParams.get("environment");
    if (!environment) throw new Error("INVALID_DOTENV_KEY: Missing environment part");
    // Get ciphertext payload
    const environmentKey = `DOTENV_VAULT_${environment.toUpperCase()}`;
    const ciphertext = result.parsed[environmentKey] // DOTENV_VAULT_PRODUCTION
    ;
    if (!ciphertext) throw new Error(`NOT_FOUND_DOTENV_ENVIRONMENT: Cannot locate environment ${environmentKey} in your .env.vault file.`);
    return {
        ciphertext: ciphertext,
        key: key
    };
}
function $630dda8d81b1b9e8$var$_vaultPath(options) {
    let dotenvPath = $3bfdb7183e8721d6$exports.resolve($hPtJY.cwd(), ".env");
    if (options && options.path && options.path.length > 0) dotenvPath = options.path;
    // Locate .env.vault
    return dotenvPath.endsWith(".vault") ? dotenvPath : `${dotenvPath}.vault`;
}
function $630dda8d81b1b9e8$var$_resolveHome(envPath) {
    return envPath[0] === "~" ? $3bfdb7183e8721d6$exports.join($8e2551e033e95cb5$export$c1d46b5ea6262c0b(), envPath.slice(1)) : envPath;
}
function $630dda8d81b1b9e8$var$_configVault(options) {
    $630dda8d81b1b9e8$var$_log("Loading env from encrypted .env.vault");
    const parsed = $630dda8d81b1b9e8$var$DotenvModule._parseVault(options);
    let processEnv = {};
    if (options && options.processEnv != null) processEnv = options.processEnv;
    $630dda8d81b1b9e8$var$DotenvModule.populate(processEnv, parsed, options);
    return {
        parsed: parsed
    };
}
function $630dda8d81b1b9e8$var$configDotenv(options) {
    let dotenvPath = $3bfdb7183e8721d6$exports.resolve($hPtJY.cwd(), ".env");
    let encoding = "utf8";
    const debug = Boolean(options && options.debug);
    if (options) {
        if (options.path != null) dotenvPath = $630dda8d81b1b9e8$var$_resolveHome(options.path);
        if (options.encoding != null) encoding = options.encoding;
    }
    try {
        // Specifying an encoding returns a string instead of a buffer
        const parsed = $630dda8d81b1b9e8$var$DotenvModule.parse($4kvQX.readFileSync(dotenvPath, {
            encoding: encoding
        }));
        let processEnv = {};
        if (options && options.processEnv != null) processEnv = options.processEnv;
        $630dda8d81b1b9e8$var$DotenvModule.populate(processEnv, parsed, options);
        return {
            parsed: parsed
        };
    } catch (e) {
        if (debug) $630dda8d81b1b9e8$var$_debug(`Failed to load ${dotenvPath} ${e.message}`);
        return {
            error: e
        };
    }
}
// Populates process.env from .env file
function $630dda8d81b1b9e8$var$config(options) {
    const vaultPath = $630dda8d81b1b9e8$var$_vaultPath(options);
    // fallback to original dotenv if DOTENV_KEY is not set
    if ($630dda8d81b1b9e8$var$_dotenvKey(options).length === 0) return $630dda8d81b1b9e8$var$DotenvModule.configDotenv(options);
    // dotenvKey exists but .env.vault file does not exist
    if (!$4kvQX.existsSync(vaultPath)) {
        $630dda8d81b1b9e8$var$_warn(`You set DOTENV_KEY but you are missing a .env.vault file at ${vaultPath}. Did you forget to build it?`);
        return $630dda8d81b1b9e8$var$DotenvModule.configDotenv(options);
    }
    return $630dda8d81b1b9e8$var$DotenvModule._configVault(options);
}
function $630dda8d81b1b9e8$var$decrypt(encrypted, keyStr) {
    const key = $630dda8d81b1b9e8$require$Buffer.from(keyStr.slice(-64), "hex");
    let ciphertext = $630dda8d81b1b9e8$require$Buffer.from(encrypted, "base64");
    const nonce = ciphertext.slice(0, 12);
    const authTag = ciphertext.slice(-16);
    ciphertext = ciphertext.slice(12, -16);
    try {
        const aesgcm = $44edd02a6be448cd$export$36b6d6ef312eab39("aes-256-gcm", key, nonce);
        aesgcm.setAuthTag(authTag);
        return `${aesgcm.update(ciphertext)}${aesgcm.final()}`;
    } catch (error) {
        const isRange = error instanceof RangeError;
        const invalidKeyLength = error.message === "Invalid key length";
        const decryptionFailed = error.message === "Unsupported state or unable to authenticate data";
        if (isRange || invalidKeyLength) {
            const msg = "INVALID_DOTENV_KEY: It must be 64 characters long (or more)";
            throw new Error(msg);
        } else if (decryptionFailed) {
            const msg = "DECRYPTION_FAILED: Please check your DOTENV_KEY";
            throw new Error(msg);
        } else {
            console.error("Error: ", error.code);
            console.error("Error: ", error.message);
            throw error;
        }
    }
}
// Populate process.env with parsed values
function $630dda8d81b1b9e8$var$populate(processEnv, parsed, options = {}) {
    const debug = Boolean(options && options.debug);
    const override = Boolean(options && options.override);
    if (typeof parsed !== "object") throw new Error("OBJECT_REQUIRED: Please check the processEnv argument being passed to populate");
    // Set process.env
    for (const key of Object.keys(parsed))if (Object.prototype.hasOwnProperty.call(processEnv, key)) {
        if (override === true) processEnv[key] = parsed[key];
        if (debug) {
            if (override === true) $630dda8d81b1b9e8$var$_debug(`"${key}" is already defined and WAS overwritten`);
            else $630dda8d81b1b9e8$var$_debug(`"${key}" is already defined and was NOT overwritten`);
        }
    } else processEnv[key] = parsed[key];
}
const $630dda8d81b1b9e8$var$DotenvModule = {
    configDotenv: $630dda8d81b1b9e8$var$configDotenv,
    _configVault: $630dda8d81b1b9e8$var$_configVault,
    _parseVault: $630dda8d81b1b9e8$var$_parseVault,
    config: $630dda8d81b1b9e8$var$config,
    decrypt: $630dda8d81b1b9e8$var$decrypt,
    parse: $630dda8d81b1b9e8$var$parse,
    populate: $630dda8d81b1b9e8$var$populate
};
$630dda8d81b1b9e8$exports.configDotenv = $630dda8d81b1b9e8$var$DotenvModule.configDotenv;
$630dda8d81b1b9e8$exports._configVault = $630dda8d81b1b9e8$var$DotenvModule._configVault;
$630dda8d81b1b9e8$exports._parseVault = $630dda8d81b1b9e8$var$DotenvModule._parseVault;
$630dda8d81b1b9e8$exports.config = $630dda8d81b1b9e8$var$DotenvModule.config;
$630dda8d81b1b9e8$exports.decrypt = $630dda8d81b1b9e8$var$DotenvModule.decrypt;
$630dda8d81b1b9e8$exports.parse = $630dda8d81b1b9e8$var$DotenvModule.parse;
$630dda8d81b1b9e8$exports.populate = $630dda8d81b1b9e8$var$DotenvModule.populate;
$630dda8d81b1b9e8$exports = $630dda8d81b1b9e8$var$DotenvModule;


(0, (/*@__PURE__*/$parcel$interopDefault($630dda8d81b1b9e8$exports))).config();
const $0e7b664d034fa0c2$var$clientConfiguration = new (0, $cc3eb4e70d9f2fd9$export$fa89be98fe0936f2)({
    basePath: "https://web.dev.westburymusic.com",
    middleware: [
        new (0, $1978162fe9dc014b$export$c6a5536d8f7c4cfe)()
    ]
});
const $0e7b664d034fa0c2$var$adminConfiguration = new (0, $f599d8a7dfeab1bb$export$fa89be98fe0936f2)({
    basePath: "https://web.dev.westburymusic.com",
    middleware: [
        new (0, $1978162fe9dc014b$export$c6a5536d8f7c4cfe)()
    ]
});
const $0e7b664d034fa0c2$export$9c6af153448fb003 = new (0, $d1b79341fc7471d8$export$3dfdf93d61a8d1c9)($0e7b664d034fa0c2$var$clientConfiguration);
const $0e7b664d034fa0c2$export$4ae6a664f3841a6 = new (0, $cdef5ca7170fc2e8$export$3dfdf93d61a8d1c9)($0e7b664d034fa0c2$var$adminConfiguration);


const $3b5fd5559e42de25$var$ApiContext = /*#__PURE__*/ (0, $acw62.createContext)({
    clientApi: $0e7b664d034fa0c2$export$9c6af153448fb003,
    adminApi: $0e7b664d034fa0c2$export$4ae6a664f3841a6
});
const $3b5fd5559e42de25$export$f4e57f6132f56752 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3b5fd5559e42de25$var$ApiContext.Provider, {
        value: {
            clientApi: $0e7b664d034fa0c2$export$9c6af153448fb003,
            adminApi: $0e7b664d034fa0c2$export$4ae6a664f3841a6
        },
        children: children
    });
};
const $3b5fd5559e42de25$export$eb2799109db70ffd = ()=>{
    const { clientApi: clientApi, adminApi: adminApi } = (0, $acw62.useContext)($3b5fd5559e42de25$var$ApiContext);
    return {
        clientApi: clientApi,
        adminApi: adminApi
    };
};





function $1eeac253570f845a$var$e(e) {
    this.message = e;
}
$1eeac253570f845a$var$e.prototype = new Error, $1eeac253570f845a$var$e.prototype.name = "InvalidCharacterError";
var $1eeac253570f845a$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $1eeac253570f845a$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $1eeac253570f845a$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($1eeac253570f845a$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $1eeac253570f845a$var$r(t);
    }
}
function $1eeac253570f845a$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $1eeac253570f845a$var$o(e, r) {
    if ("string" != typeof e) throw new $1eeac253570f845a$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($1eeac253570f845a$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $1eeac253570f845a$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$1eeac253570f845a$export$b9721ef022f71a68.prototype = new Error, $1eeac253570f845a$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $1eeac253570f845a$export$2e2bcd8739ae039 = $1eeac253570f845a$var$o;



var $acw62 = parcelRequire("acw62");
const $bb19b832faf6099b$var$departmentDashboardMap = {
    Membership: "/dashboard",
    Discography: "/discography-dashboard",
    Distribution: "/distribution-dashboard"
};
const $bb19b832faf6099b$var$UserContext = /*#__PURE__*/ (0, $acw62.createContext)({
    userId: undefined,
    setUserId: ()=>{},
    firstName: undefined,
    setFirstName: ()=>{},
    lastName: undefined,
    setLastName: ()=>{},
    initials: "",
    imageUrl: undefined,
    setImageUrl: ()=>{},
    department: undefined,
    setDepartment: ()=>{},
    profileProgress: 1,
    setProfileProgress: ()=>{},
    defaultDashboardPath: $bb19b832faf6099b$var$departmentDashboardMap.Membership,
    verifiedStatus: false,
    signedStatus: false,
    pplAccountName: undefined,
    fetchData: ()=>{}
});
const $bb19b832faf6099b$export$88f24fd8fcfab6ca = ({ children: children, api: api })=>{
    const [userId, setUserId] = (0, $acw62.useState)();
    const [firstName, setFirstName] = (0, $acw62.useState)();
    const [lastName, setLastName] = (0, $acw62.useState)();
    const [imageUrl, setImageUrl] = (0, $acw62.useState)();
    const [department, setDepartment] = (0, $acw62.useState)();
    const [profileProgress, setProfileProgress] = (0, $acw62.useState)(0);
    const [verifiedStatus, setVerifiedStatus] = (0, $acw62.useState)(false);
    const [signedStatus, setSignedStatus] = (0, $acw62.useState)(false);
    const [pplAccountName, setPplAccountName] = (0, $acw62.useState)();
    const initials = (0, $acw62.useMemo)(()=>{
        const firstInitial = firstName?.at(0) ?? "";
        const lastInitial = lastName?.at(0) ?? "";
        return firstInitial.concat(lastInitial);
    }, [
        firstName,
        lastName
    ]);
    const defaultDashboardPath = (0, $acw62.useMemo)(()=>{
        return $bb19b832faf6099b$var$departmentDashboardMap[department ?? "Membership"];
    }, [
        department
    ]);
    const getSessionUserId = ()=>{
        const tokenRaw = sessionStorage.getItem("token");
        if (tokenRaw === null) {
            setUserId(undefined);
            return;
        }
        const token = JSON.parse(tokenRaw);
        const decodedToken = (0, $1eeac253570f845a$export$2e2bcd8739ae039)(token.access);
        setUserId(decodedToken.user_id);
    };
    (0, $acw62.useEffect)(()=>{
        getSessionUserId();
    }, []);
    const fetchData = ()=>{
        if (userId === undefined) return;
        api.retrieveUserSettings({
            userId: userId
        }).then((userSettings)=>{
            setFirstName(userSettings.firstName);
            setLastName(userSettings.lastName);
            setImageUrl(userSettings.userPhotoUrl);
            setDepartment(userSettings.department);
            setVerifiedStatus(userSettings.verifiedStatus ?? false);
            setSignedStatus(userSettings.signedStatus ?? false);
            setPplAccountName(userSettings.pplAccountName);
        }).catch(()=>{});
        api.retrieveOnboardingSteps({
            userId: userId
        }).then((response)=>{
            const stepNum = response.onboardingSteps.toSorted((a, b)=>b.order - a.order).find((step)=>step.stepCompleted)?.order ?? 1;
            setProfileProgress(stepNum);
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bb19b832faf6099b$var$UserContext.Provider, {
        value: {
            userId: userId,
            setUserId: setUserId,
            firstName: firstName,
            setFirstName: setFirstName,
            lastName: lastName,
            setLastName: setLastName,
            initials: initials,
            imageUrl: imageUrl,
            setImageUrl: setImageUrl,
            department: department,
            setDepartment: setDepartment,
            profileProgress: profileProgress,
            setProfileProgress: setProfileProgress,
            defaultDashboardPath: defaultDashboardPath,
            verifiedStatus: verifiedStatus,
            signedStatus: signedStatus,
            pplAccountName: pplAccountName,
            fetchData: fetchData
        },
        children: children
    });
};
const $bb19b832faf6099b$export$a5c2098c02d2840a = ()=>{
    const { userId: userId, setUserId: setUserId } = (0, $acw62.useContext)($bb19b832faf6099b$var$UserContext);
    if (!setUserId) throw new Error("useUserId must be used within a UserProvider");
    return {
        userId: userId,
        setUserId: setUserId
    };
};
const $bb19b832faf6099b$export$23bbbc4533528f03 = ()=>{
    const { firstName: firstName, setFirstName: setFirstName, lastName: lastName, setLastName: setLastName, initials: initials, imageUrl: imageUrl, setImageUrl: setImageUrl, department: department, setDepartment: setDepartment, profileProgress: profileProgress, setProfileProgress: setProfileProgress, defaultDashboardPath: defaultDashboardPath, signedStatus: signedStatus, verifiedStatus: verifiedStatus, pplAccountName: pplAccountName, fetchData: fetchData } = (0, $acw62.useContext)($bb19b832faf6099b$var$UserContext);
    if (!setImageUrl) throw new Error("useUser must be used within a UserProvider");
    return {
        firstName: firstName,
        setFirstName: setFirstName,
        lastName: lastName,
        setLastName: setLastName,
        initials: initials,
        imageUrl: imageUrl,
        setImageUrl: setImageUrl,
        department: department,
        setDepartment: setDepartment,
        profileProgress: profileProgress,
        setProfileProgress: setProfileProgress,
        defaultDashboardPath: defaultDashboardPath,
        verifiedStatus: verifiedStatus,
        signedStatus: signedStatus,
        pplAccountName: pplAccountName,
        fetchData: fetchData
    };
};




parcelRequire("acw62");

parcelRequire("acw62");
// TODO: add hrefs to all icons and links
function $5d63082c9ce575dd$var$Footer() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
        className: "tw-flex tw-h-[269px] tw-justify-start tw-space-x-10 tw-bg-surfaceBlack90 tw-p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-start tw-p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-white tw-text-md tw-mb-4",
                        children: "Westbury Music Consultants Ltd. 2022"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-space-x-3 tw-mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-facebook"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-twitter"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-linkedin"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-list-none tw-mt-3 tw-font-light tw-space-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Contact Us"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Privacy Policy"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Cookie Policy"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Terms & Conditions"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Modern Slavery Act"
                        })
                    })
                ]
            })
        ]
    });
}
var $5d63082c9ce575dd$export$2e2bcd8739ae039 = $5d63082c9ce575dd$var$Footer;


function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


function $d877c7393834f3de$var$LoginPageLayout({ children: children, bgImage: bgImage }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-h-screen", "tw-flex", "tw-flex-col"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex", "tw-grow", "tw-items-center", "tw-flex-col", "tw-py-[60px]", "tw-justify-center", {
                    "westbury-bg-login": bgImage === "signIn"
                }, {
                    "tw-bg-surfacePurple": bgImage === undefined
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                    className: "tw-flex tw-justify-center tw-items-center  tw-w-screen tw-pl-6",
                    style: {
                        maxWidth: "1580px"
                    },
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-bg-surfaceBlack90",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d63082c9ce575dd$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $d877c7393834f3de$export$2e2bcd8739ae039 = $d877c7393834f3de$var$LoginPageLayout;



parcelRequire("acw62");

const $9f9ec61e990410df$export$e5ec966c03d6b304 = ({ disabled: disabled = false, children: children, extraClasses: extraClasses = "tw-w-full", title: title })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-surfaceBlack90", "tw-p-6", "tw-mt-6", "tw-text-white", "tw-rounded-2xl", "tw-max-w-full", extraClasses, "IS_W_CONTAINER", disabled && "tw-relative"),
        style: {
            pointerEvents: disabled ? "none" : "auto"
        },
        children: disabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-blur-xl"),
                    children: children
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-rounded-full  tw-absolute  tw-top-1/2  tw-left-1/2  tw-transform  tw--translate-x-1/2  tw--translate-y-1/2 tw-w-[140px] tw-h-[140px]  tw-bg-white tw-opacity-20"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "tw-text-md tw-text-white  tw-top-1/2  tw-absolute tw-left-1/2  tw-transform  tw--translate-x-1/2  tw--translate-y-1/2 tw-text-center",
                    children: [
                        "Feature ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Coming ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Soon"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "tw-text-xl tw-text-white  tw-top-[21px] tw-font-semibold tw-absolute tw-left-[28px]  tw-text-center",
                    children: title
                })
            ]
        }) : children
    });
};
var $9f9ec61e990410df$export$2e2bcd8739ae039 = $9f9ec61e990410df$export$e5ec966c03d6b304;




var $99b5763031ccc1a7$exports = {};
$99b5763031ccc1a7$exports = new URL("Logo.2040407e.png", import.meta.url).toString();




var $acw62 = parcelRequire("acw62");
var $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($9ee9c7b494d01fc9$export$7debb50ef11d5e0b || ($9ee9c7b494d01fc9$export$7debb50ef11d5e0b = {}));
var $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 || ($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 = {}));
const $9ee9c7b494d01fc9$export$5716da67bfaa244d = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $9ee9c7b494d01fc9$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined;
        case "string":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan : $9ee9c7b494d01fc9$export$5716da67bfaa244d.number;
        case "boolean":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean;
        case "function":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.function;
        case "bigint":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.array;
            if (data === null) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.date;
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.object;
        default:
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.unknown;
    }
};
const $9ee9c7b494d01fc9$export$5ba560653e4a1035 = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $9ee9c7b494d01fc9$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $9ee9c7b494d01fc9$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$9ee9c7b494d01fc9$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues);
    return error;
};
const $9ee9c7b494d01fc9$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $9ee9c7b494d01fc9$var$overrideErrorMap = $9ee9c7b494d01fc9$export$341b0b6e0a6f5099;
function $9ee9c7b494d01fc9$export$1097a8289cfd22d7(map) {
    $9ee9c7b494d01fc9$var$overrideErrorMap = map;
}
function $9ee9c7b494d01fc9$export$32f27c719778d4c4() {
    return $9ee9c7b494d01fc9$var$overrideErrorMap;
}
const $9ee9c7b494d01fc9$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $9ee9c7b494d01fc9$export$1526d2e05f74572 = [];
function $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $9ee9c7b494d01fc9$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
            $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $9ee9c7b494d01fc9$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $9ee9c7b494d01fc9$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $9ee9c7b494d01fc9$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $9ee9c7b494d01fc9$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $9ee9c7b494d01fc9$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $9ee9c7b494d01fc9$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $9ee9c7b494d01fc9$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($9ee9c7b494d01fc9$var$errorUtil || ($9ee9c7b494d01fc9$var$errorUtil = {}));
class $9ee9c7b494d01fc9$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $9ee9c7b494d01fc9$var$handleResult = (ctx, result)=>{
    if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $9ee9c7b494d01fc9$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $9ee9c7b494d01fc9$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $9ee9c7b494d01fc9$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $9ee9c7b494d01fc9$export$66b0c798a395271f({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $9ee9c7b494d01fc9$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $9ee9c7b494d01fc9$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $9ee9c7b494d01fc9$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $9ee9c7b494d01fc9$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $9ee9c7b494d01fc9$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $9ee9c7b494d01fc9$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $9ee9c7b494d01fc9$var$emojiRegex;
const $9ee9c7b494d01fc9$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $9ee9c7b494d01fc9$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $9ee9c7b494d01fc9$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $9ee9c7b494d01fc9$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $9ee9c7b494d01fc9$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $9ee9c7b494d01fc9$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $9ee9c7b494d01fc9$export$1230eb29b8d3b502 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$9ee9c7b494d01fc9$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$9ee9c7b494d01fc9$var$emojiRegex) $9ee9c7b494d01fc9$var$emojiRegex = new RegExp($9ee9c7b494d01fc9$var$_emojiRegex, "u");
                if (!$9ee9c7b494d01fc9$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$9ee9c7b494d01fc9$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$9ee9c7b494d01fc9$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$9ee9c7b494d01fc9$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$9ee9c7b494d01fc9$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $9ee9c7b494d01fc9$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$9ee9c7b494d01fc9$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $9ee9c7b494d01fc9$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $9ee9c7b494d01fc9$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $9ee9c7b494d01fc9$export$5b070a55c0c43e09 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($9ee9c7b494d01fc9$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$67d741fd70ff98f4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$723d146f80596191 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$723d146f80596191.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$723d146f80596191({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e974be33bdc55521 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$9ee9c7b494d01fc9$export$e974be33bdc55521.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDate,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bcc3b40f6b638044 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$bcc3b40f6b638044.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$bcc3b40f6b638044({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSymbol,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$4e780e961c30340d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$4e780e961c30340d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$4e780e961c30340d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUndefined,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a96281f914484f2d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$a96281f914484f2d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$a96281f914484f2d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNull,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodAny,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$ef3b1bb1630977ae extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$ef3b1bb1630977ae({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnknown,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
            expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
    }
}
$9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNever,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7d39f5df85f21031 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$7d39f5df85f21031.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$7d39f5df85f21031({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodVoid,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7acfc3e64785411 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big : $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$7acfc3e64785411.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodArray,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$deepPartialify(schema) {
    if (schema instanceof $9ee9c7b494d01fc9$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(fieldSchema));
        }
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $9ee9c7b494d01fc9$export$7acfc3e64785411) return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        ...schema._def,
        type: $9ee9c7b494d01fc9$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8) return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$aaac0b8b429cef5) return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3) return $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$9ee9c7b494d01fc9$var$deepPartialify(item)));
    else return schema;
}
class $9ee9c7b494d01fc9$export$736315c5b55efbad extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $9ee9c7b494d01fc9$var$errorUtil.errToObj;
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $9ee9c7b494d01fc9$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $9ee9c7b494d01fc9$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $9ee9c7b494d01fc9$var$createZodEnum($9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$9ee9c7b494d01fc9$export$736315c5b55efbad.create = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a8b236cb5070a311 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(result.ctx.common.issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$9ee9c7b494d01fc9$export$a8b236cb5070a311.create = (types, params)=>{
    return new $9ee9c7b494d01fc9$export$a8b236cb5070a311({
        options: types,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnion,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $9ee9c7b494d01fc9$var$getDiscriminator = (type)=>{
    if (type instanceof $9ee9c7b494d01fc9$export$378d0cfce37406e6) return $9ee9c7b494d01fc9$var$getDiscriminator(type.schema);
    else if (type instanceof $9ee9c7b494d01fc9$export$a60af00cc0ce2582) return $9ee9c7b494d01fc9$var$getDiscriminator(type.innerType());
    else if (type instanceof $9ee9c7b494d01fc9$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $9ee9c7b494d01fc9$export$bb19b37874861e7e) return $9ee9c7b494d01fc9$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $9ee9c7b494d01fc9$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $9ee9c7b494d01fc9$export$5ef2424805ac76a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $9ee9c7b494d01fc9$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $9ee9c7b494d01fc9$export$5ef2424805ac76a3({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
function $9ee9c7b494d01fc9$var$mergeValues(a, b) {
    const aType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(a);
    const bType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
        const bKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $9ee9c7b494d01fc9$export$c02deaf0bb5203d4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($9ee9c7b494d01fc9$export$afa861e3c5730743(parsedLeft) || $9ee9c7b494d01fc9$export$afa861e3c5730743(parsedRight)) return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            const merged = $9ee9c7b494d01fc9$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            }
            if ($9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedLeft) || $9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $9ee9c7b494d01fc9$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodIntersection,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a2acc09968cb4b7f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $9ee9c7b494d01fc9$export$19342e026b58ebb7) return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(third)
        });
        return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(second)
        });
    }
}
class $9ee9c7b494d01fc9$export$163b6a2b712d9542 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.map) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$9ee9c7b494d01fc9$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodMap,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$977057706f816712 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.set) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$977057706f816712.create = (valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSet,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$d4602ba55673f53c extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.function) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $9ee9c7b494d01fc9$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            args: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(items).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            args: args ? args : $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create([]).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create()),
            returns: returns || $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create(),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodFunction,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
class $9ee9c7b494d01fc9$export$378d0cfce37406e6 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$9ee9c7b494d01fc9$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $9ee9c7b494d01fc9$export$378d0cfce37406e6({
        getter: getter,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLazy,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7e44096782a165d3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$9ee9c7b494d01fc9$export$7e44096782a165d3.create = (value, params)=>{
    return new $9ee9c7b494d01fc9$export$7e44096782a165d3({
        value: value,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLiteral,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$createZodEnum(values, params) {
    return new $9ee9c7b494d01fc9$export$d325d1f0e1c20179({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
}
class $9ee9c7b494d01fc9$export$d325d1f0e1c20179 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$9ee9c7b494d01fc9$export$d325d1f0e1c20179.create = $9ee9c7b494d01fc9$var$createZodEnum;
class $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string && ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNativeEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$3f196b0127d6e50a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$9ee9c7b494d01fc9$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$3f196b0127d6e50a({
        type: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPromise,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a60af00cc0ce2582 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aa56fec1e9d629b8 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodOptional,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aaac0b8b429cef5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNullable,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bb19b37874861e7e extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$bb19b37874861e7e.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$75a44ec6249ac76b extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$26ccfa0145e8511f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$9ee9c7b494d01fc9$export$26ccfa0145e8511f.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$26ccfa0145e8511f({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNaN,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $9ee9c7b494d01fc9$export$66b0c798a395271f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $9ee9c7b494d01fc9$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodReadonly,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create();
};
const $9ee9c7b494d01fc9$export$1ee8ee30835eab8b = {
    object: $9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate
};
var $9ee9c7b494d01fc9$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($9ee9c7b494d01fc9$export$558106ce543bd011 || ($9ee9c7b494d01fc9$export$558106ce543bd011 = {}));
const $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$9ee9c7b494d01fc9$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $9ee9c7b494d01fc9$export$22b082955e083ec3 = $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create;
const $9ee9c7b494d01fc9$export$98e628dec113755e = $9ee9c7b494d01fc9$export$5b070a55c0c43e09.create;
const $9ee9c7b494d01fc9$export$9e06de0973666692 = $9ee9c7b494d01fc9$export$26ccfa0145e8511f.create;
const $9ee9c7b494d01fc9$export$a0f65b52274bcc00 = $9ee9c7b494d01fc9$export$67d741fd70ff98f4.create;
const $9ee9c7b494d01fc9$export$4a21f16c33752377 = $9ee9c7b494d01fc9$export$723d146f80596191.create;
const $9ee9c7b494d01fc9$export$324d90190a8b822a = $9ee9c7b494d01fc9$export$e974be33bdc55521.create;
const $9ee9c7b494d01fc9$export$8f701197936bc2a6 = $9ee9c7b494d01fc9$export$bcc3b40f6b638044.create;
const $9ee9c7b494d01fc9$export$1db45310990710a5 = $9ee9c7b494d01fc9$export$4e780e961c30340d.create;
const $9ee9c7b494d01fc9$export$7b1b591b262c240 = $9ee9c7b494d01fc9$export$a96281f914484f2d.create;
const $9ee9c7b494d01fc9$export$4154a199d7d90455 = $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create;
const $9ee9c7b494d01fc9$export$19282c40b967aec6 = $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create;
const $9ee9c7b494d01fc9$export$b3e22bcfd64c1022 = $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create;
const $9ee9c7b494d01fc9$export$490e536ee7389aeb = $9ee9c7b494d01fc9$export$7d39f5df85f21031.create;
const $9ee9c7b494d01fc9$export$2f23118c22fb2630 = $9ee9c7b494d01fc9$export$7acfc3e64785411.create;
const $9ee9c7b494d01fc9$export$be5493f9613cbbe = $9ee9c7b494d01fc9$export$736315c5b55efbad.create;
const $9ee9c7b494d01fc9$export$8fb0df5f40d0b477 = $9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate;
const $9ee9c7b494d01fc9$export$971dd5b0dfd021b6 = $9ee9c7b494d01fc9$export$a8b236cb5070a311.create;
const $9ee9c7b494d01fc9$export$4b888e40c4ee26dd = $9ee9c7b494d01fc9$export$5ef2424805ac76a3.create;
const $9ee9c7b494d01fc9$export$bc86dfbf7795668c = $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create;
const $9ee9c7b494d01fc9$export$65e3907585753458 = $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create;
const $9ee9c7b494d01fc9$export$e5185e241753e543 = $9ee9c7b494d01fc9$export$a2acc09968cb4b7f.create;
const $9ee9c7b494d01fc9$export$871de8747c9eaa88 = $9ee9c7b494d01fc9$export$163b6a2b712d9542.create;
const $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be = $9ee9c7b494d01fc9$export$977057706f816712.create;
const $9ee9c7b494d01fc9$export$44e51c8aac7c2deb = $9ee9c7b494d01fc9$export$d4602ba55673f53c.create;
const $9ee9c7b494d01fc9$export$488013bae63b21da = $9ee9c7b494d01fc9$export$378d0cfce37406e6.create;
const $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0 = $9ee9c7b494d01fc9$export$7e44096782a165d3.create;
const $9ee9c7b494d01fc9$export$78a99c8d44d72635 = $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create;
const $9ee9c7b494d01fc9$export$6fe7eca19ebe5199 = $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create;
const $9ee9c7b494d01fc9$export$c957ef27a0ebfd4 = $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create;
const $9ee9c7b494d01fc9$export$dc573d8a6576cdb3 = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.create;
const $9ee9c7b494d01fc9$export$516e28dec6a4b6d4 = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create;
const $9ee9c7b494d01fc9$export$133fc36489ac9add = $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create;
const $9ee9c7b494d01fc9$export$fc37fe19dfda43ee = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess;
const $9ee9c7b494d01fc9$export$43f28b24e1eb8181 = $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create;
const $9ee9c7b494d01fc9$export$3b3d07727c5b702c = ()=>$9ee9c7b494d01fc9$export$22b082955e083ec3().optional();
const $9ee9c7b494d01fc9$export$eb150471a61fced6 = ()=>$9ee9c7b494d01fc9$export$98e628dec113755e().optional();
const $9ee9c7b494d01fc9$export$269251733cdcbbf1 = ()=>$9ee9c7b494d01fc9$export$4a21f16c33752377().optional();
const $9ee9c7b494d01fc9$export$8c14e57e778d3873 = {
    string: (arg)=>$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$9ee9c7b494d01fc9$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$9ee9c7b494d01fc9$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $9ee9c7b494d01fc9$export$96c94437c95d7862 = $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
var $9ee9c7b494d01fc9$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $9ee9c7b494d01fc9$export$341b0b6e0a6f5099,
    setErrorMap: $9ee9c7b494d01fc9$export$1097a8289cfd22d7,
    getErrorMap: $9ee9c7b494d01fc9$export$32f27c719778d4c4,
    makeIssue: $9ee9c7b494d01fc9$export$244a85fde9c419ed,
    EMPTY_PATH: $9ee9c7b494d01fc9$export$1526d2e05f74572,
    addIssueToContext: $9ee9c7b494d01fc9$export$db7caee60e5d514d,
    ParseStatus: $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f,
    INVALID: $9ee9c7b494d01fc9$export$9a105a556e65c2c0,
    DIRTY: $9ee9c7b494d01fc9$export$325a211da9693fcf,
    OK: $9ee9c7b494d01fc9$export$c6813a8d51f77eaf,
    isAborted: $9ee9c7b494d01fc9$export$afa861e3c5730743,
    isDirty: $9ee9c7b494d01fc9$export$910b6cdd390341b3,
    isValid: $9ee9c7b494d01fc9$export$1ea939691cdc45b8,
    isAsync: $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e,
    get util () {
        return $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $9ee9c7b494d01fc9$export$5716da67bfaa244d,
    getParsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a,
    ZodType: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodString: $9ee9c7b494d01fc9$export$1230eb29b8d3b502,
    ZodNumber: $9ee9c7b494d01fc9$export$5b070a55c0c43e09,
    ZodBigInt: $9ee9c7b494d01fc9$export$67d741fd70ff98f4,
    ZodBoolean: $9ee9c7b494d01fc9$export$723d146f80596191,
    ZodDate: $9ee9c7b494d01fc9$export$e974be33bdc55521,
    ZodSymbol: $9ee9c7b494d01fc9$export$bcc3b40f6b638044,
    ZodUndefined: $9ee9c7b494d01fc9$export$4e780e961c30340d,
    ZodNull: $9ee9c7b494d01fc9$export$a96281f914484f2d,
    ZodAny: $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb,
    ZodUnknown: $9ee9c7b494d01fc9$export$ef3b1bb1630977ae,
    ZodNever: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5,
    ZodVoid: $9ee9c7b494d01fc9$export$7d39f5df85f21031,
    ZodArray: $9ee9c7b494d01fc9$export$7acfc3e64785411,
    ZodObject: $9ee9c7b494d01fc9$export$736315c5b55efbad,
    ZodUnion: $9ee9c7b494d01fc9$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $9ee9c7b494d01fc9$export$5ef2424805ac76a3,
    ZodIntersection: $9ee9c7b494d01fc9$export$c02deaf0bb5203d4,
    ZodTuple: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3,
    ZodRecord: $9ee9c7b494d01fc9$export$a2acc09968cb4b7f,
    ZodMap: $9ee9c7b494d01fc9$export$163b6a2b712d9542,
    ZodSet: $9ee9c7b494d01fc9$export$977057706f816712,
    ZodFunction: $9ee9c7b494d01fc9$export$d4602ba55673f53c,
    ZodLazy: $9ee9c7b494d01fc9$export$378d0cfce37406e6,
    ZodLiteral: $9ee9c7b494d01fc9$export$7e44096782a165d3,
    ZodEnum: $9ee9c7b494d01fc9$export$d325d1f0e1c20179,
    ZodNativeEnum: $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56,
    ZodPromise: $9ee9c7b494d01fc9$export$3f196b0127d6e50a,
    ZodEffects: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodTransformer: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodOptional: $9ee9c7b494d01fc9$export$aa56fec1e9d629b8,
    ZodNullable: $9ee9c7b494d01fc9$export$aaac0b8b429cef5,
    ZodDefault: $9ee9c7b494d01fc9$export$bb19b37874861e7e,
    ZodCatch: $9ee9c7b494d01fc9$export$75a44ec6249ac76b,
    ZodNaN: $9ee9c7b494d01fc9$export$26ccfa0145e8511f,
    BRAND: $9ee9c7b494d01fc9$export$cf2deea74cde46b4,
    ZodBranded: $9ee9c7b494d01fc9$export$66b0c798a395271f,
    ZodPipeline: $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da,
    ZodReadonly: $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a,
    custom: $9ee9c7b494d01fc9$export$4c00f665f0d4b443,
    Schema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodSchema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    late: $9ee9c7b494d01fc9$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $9ee9c7b494d01fc9$export$558106ce543bd011;
    },
    coerce: $9ee9c7b494d01fc9$export$8c14e57e778d3873,
    any: $9ee9c7b494d01fc9$export$4154a199d7d90455,
    array: $9ee9c7b494d01fc9$export$2f23118c22fb2630,
    bigint: $9ee9c7b494d01fc9$export$a0f65b52274bcc00,
    boolean: $9ee9c7b494d01fc9$export$4a21f16c33752377,
    date: $9ee9c7b494d01fc9$export$324d90190a8b822a,
    discriminatedUnion: $9ee9c7b494d01fc9$export$4b888e40c4ee26dd,
    effect: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    "enum": $9ee9c7b494d01fc9$export$78a99c8d44d72635,
    "function": $9ee9c7b494d01fc9$export$44e51c8aac7c2deb,
    "instanceof": $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5,
    intersection: $9ee9c7b494d01fc9$export$bc86dfbf7795668c,
    lazy: $9ee9c7b494d01fc9$export$488013bae63b21da,
    literal: $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0,
    map: $9ee9c7b494d01fc9$export$871de8747c9eaa88,
    nan: $9ee9c7b494d01fc9$export$9e06de0973666692,
    nativeEnum: $9ee9c7b494d01fc9$export$6fe7eca19ebe5199,
    never: $9ee9c7b494d01fc9$export$b3e22bcfd64c1022,
    "null": $9ee9c7b494d01fc9$export$7b1b591b262c240,
    nullable: $9ee9c7b494d01fc9$export$133fc36489ac9add,
    number: $9ee9c7b494d01fc9$export$98e628dec113755e,
    object: $9ee9c7b494d01fc9$export$be5493f9613cbbe,
    oboolean: $9ee9c7b494d01fc9$export$269251733cdcbbf1,
    onumber: $9ee9c7b494d01fc9$export$eb150471a61fced6,
    optional: $9ee9c7b494d01fc9$export$516e28dec6a4b6d4,
    ostring: $9ee9c7b494d01fc9$export$3b3d07727c5b702c,
    pipeline: $9ee9c7b494d01fc9$export$43f28b24e1eb8181,
    preprocess: $9ee9c7b494d01fc9$export$fc37fe19dfda43ee,
    promise: $9ee9c7b494d01fc9$export$c957ef27a0ebfd4,
    record: $9ee9c7b494d01fc9$export$e5185e241753e543,
    set: $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be,
    strictObject: $9ee9c7b494d01fc9$export$8fb0df5f40d0b477,
    string: $9ee9c7b494d01fc9$export$22b082955e083ec3,
    symbol: $9ee9c7b494d01fc9$export$8f701197936bc2a6,
    transformer: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    tuple: $9ee9c7b494d01fc9$export$65e3907585753458,
    "undefined": $9ee9c7b494d01fc9$export$1db45310990710a5,
    union: $9ee9c7b494d01fc9$export$971dd5b0dfd021b6,
    unknown: $9ee9c7b494d01fc9$export$19282c40b967aec6,
    "void": $9ee9c7b494d01fc9$export$490e536ee7389aeb,
    NEVER: $9ee9c7b494d01fc9$export$96c94437c95d7862,
    ZodIssueCode: $9ee9c7b494d01fc9$export$5ba560653e4a1035,
    quotelessJson: $9ee9c7b494d01fc9$export$913eddeaf297cfea,
    ZodError: $9ee9c7b494d01fc9$export$f98dac4b251ab333
});



var $acw62 = parcelRequire("acw62");
const $afdf3823589d7a4b$export$41ef470ffb49a27c = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $afdf3823589d7a4b$export$4d957a5e1be13b03 = ()=>{
    const context = (0, $acw62.useContext)($afdf3823589d7a4b$export$41ef470ffb49a27c);
    if (!context) throw new Error("useFormContext must be used within a FormProvider");
    return context;
};


const $1cd7e4c79aed6df3$export$f0462607dd4d52eb = ({ schema: schema, editByDefault: editByDefault = false, onSuccess: onSuccess, onSuccessMessage: onSuccessMessage, handleSubmit: handleSubmit, children: children, formData: formData, submitOnEnter: submitOnEnter = true })=>{
    const [isEditing, setIsEditing] = (0, $acw62.useState)(editByDefault);
    const [isFormSubmitted, setFormSubmitted] = (0, $acw62.useState)(false);
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [successMessage, setSuccessMessage] = (0, $acw62.useState)(onSuccessMessage);
    const form = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        // add enter event listener
        const handleKeyDown = (e)=>{
            if (e.key === "Enter") {
                e.preventDefault();
                if (submitOnEnter) handleFormSubmit(formData);
            }
        };
        if (form.current) {
            form.current.addEventListener("keydown", handleKeyDown);
            return ()=>{
                form.current?.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [
        form,
        formData
    ]);
    (0, $acw62.useEffect)(()=>{
        setSuccessMessage(onSuccessMessage);
        if (successMessage !== undefined && onSuccess === undefined) throw new Error("Success Message provided but no onSuccess callback");
    }, [
        onSuccessMessage,
        onSuccess
    ]);
    // Make sure all zod schema keys are present in the formData object
    (0, $acw62.useEffect)(()=>{
        if (schema !== undefined) {
            if (formData === undefined) {
                console.error("Form data is undefined while schema is defined, this will cause form validation to always fail");
                return;
            }
            if (schema.shape === undefined) return;
            const schemaKeys = Object.keys(schema.shape);
            const formDataKeys = Object.keys(formData);
            // make sure all schemaKeys are present in formData, throw an error if not
            // if a schema key doesn't exist in formData, the form validation will always fail
            for(let i = 0; i < schemaKeys.length; i++)if (!formDataKeys.includes(schemaKeys[i])) {
                console.error(`Form formData is missing key "${schemaKeys[i]}" while form schema contains it, this will cause form validation to always fail`);
                return;
            }
        }
    }, [
        formData
    ]);
    const validateForm = ()=>{
        // expose the form validation to be run from the parent component
        // this is useful if the form is combined with other providers, e.g. the Wizard
        if (schema !== undefined) try {
            schema.parse(formData);
            // no errors, set errors to empty object
            setErrors({});
            return {};
        } catch (error) {
            // errors, set errors and return them
            if (error instanceof (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).ZodError) {
                const parsedErrors = {};
                error.errors.forEach((err)=>{
                    parsedErrors[err.path.join(".")] = err.message;
                });
                setErrors(parsedErrors);
                return parsedErrors;
            }
        }
    };
    const handleFormSubmit = (formData)=>{
        try {
            let parsedData = formData;
            if (schema) parsedData = schema.parse(formData);
            // no errors, submit form
            let response = handleSubmit(true, parsedData, {});
            // We need to receive a promise in order to handle server errors
            // Even though we aren't currently using the promise, it's a great way to handle errors in the future if we need to
            // And a clean way to chain code after the form is submitted
            if (response) response.then((res)=>{
                setFormSubmitted(true);
                // If we don't have a success message and a success callback, we can change the form back to preview mode
                if (typeof onSuccess === "function") onSuccess();
                if (successMessage === undefined || successMessage === null) setIsEditing(false);
                setErrors({});
            }).catch((errors)=>{
                // handle server errors
                // server errors need to be parsed and set as errors
                if (errors) setErrors(errors);
                return;
            });
            else {
                if (successMessage === undefined || successMessage === null) setIsEditing(false);
                setFormSubmitted(true);
            }
        // if we don't have a success message, we can change the form back to preview mode
        // where the default toast message will be shown
        } catch (error) {
            // errors, set errors
            if (error instanceof (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).ZodError) {
                const parsedErrors = {};
                error.errors.forEach((err)=>{
                    parsedErrors[err.path.join(".")] = err.message;
                });
                setErrors(parsedErrors);
                return parsedErrors;
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $afdf3823589d7a4b$export$41ef470ffb49a27c).Provider, {
        value: {
            isEditing: isEditing,
            editByDefault: editByDefault,
            onSuccess: onSuccess,
            setIsEditing: setIsEditing,
            isFormSubmitted: isFormSubmitted,
            successMessage: successMessage,
            setFormSubmitted: setFormSubmitted,
            errors: errors,
            setErrors: setErrors,
            handleFormSubmit: handleFormSubmit,
            formData: formData,
            validateForm: validateForm
        },
        children: [
            isFormSubmitted && Object.keys(errors).length === 0 && successMessage === undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-p-2 tw-text-black tw-bg-westburyGreen tw-rounded tw-mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: `wi wi-sm wi-check tw-mr-2`
                    }),
                    "Details Saved"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                ref: form,
                children: children
            }),
            isFormSubmitted && Object.keys(errors).length === 0 && successMessage != undefined && successMessage
        ]
    });
};





var $acw62 = parcelRequire("acw62");

const $8b83b817f32778a9$export$ad5d4e91f331cc01 = ({ isOpen: isOpen, onClose: onClose, title: title, modalClasses: modalClasses, children: children, hasCloseButton: hasCloseButton = true, disableBackdropClick: disableBackdropClick = false })=>{
    (0, $acw62.useEffect)(()=>{
        if (isOpen) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-z-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-absolute tw-inset-0 tw-opacity-50 tw-animate-fadeIn",
                style: {
                    background: "rgba(255, 255, 255, 0.30)",
                    backdropFilter: "blur(3px)"
                },
                onClick: ()=>{
                    if (!disableBackdropClick) onClose();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(modalClasses, "tw-relative tw-p-6 tw-bg-surfaceBlack90 tw-rounded-2xl tw-transform tw-animate-scaleIn"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "tw-flex tw-justify-between tw-items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white tw-text-xl",
                                children: title
                            }),
                            hasCloseButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-xl tw-cursor-pointer tw-text-white",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-sm wi-close"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                        className: "tw-mt-4 tw-text-white",
                        children: children
                    })
                ]
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");


const $b5db6f0d0cf9e167$export$6337720cf3ea4fc8 = ({ type: type = "text", layout: layout = "vertical", name: name, value: value, label: label, labelSecondary: labelSecondary = "", disabled: disabled = false, isFieldEditing: isFieldEditing = false, hideOnView: hideOnView = false, optionalLabel: optionalLabel = false, icon: icon, placeholder: placeholder, onBlur: onBlur, onChange: onChange })=>{
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors, handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const input = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // input should capture enter key press and submit form
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const onIconClick = ()=>{};
    const handleFocus = ()=>setFocused(true);
    const handleBlur = ()=>setFocused(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (isEditing || isFieldEditing || !hideOnView) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-mb-4", {
                "tw-flex-row tw-w-full tw-justify-between tw-items-center": layout === "horizontal"
            }, {
                "tw-flex-col tw-mb-8 tw-flex tw-justify-between": layout === "vertical"
            }),
            children: [
                label != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    htmlFor: name,
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-space-x-1 tw-justify-between tw-leading-4 tw-text-white tw-mb-2 tw-capitalize", {
                        "tw-w-1/4": layout === "horizontal"
                    }, {
                        "tw-text-[14px]": !isEditing && !isFieldEditing
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                                "tw-text-westburyRed": isEditing && errors[name]
                            }),
                            children: [
                                label,
                                labelSecondary != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tw-ml-1 tw-text-xs tw-leading-4",
                                    children: labelSecondary
                                })
                            ]
                        }),
                        optionalLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-text-xs tw-leading-4 tw-text-gray-400",
                            children: "Optional"
                        })
                    ]
                }),
                (isEditing || isFieldEditing) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-relative", {
                        "tw-w-3/4": layout === "horizontal"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            ref: input,
                            type: type,
                            name: name,
                            id: name,
                            onFocus: handleFocus,
                            placeholder: placeholder || label,
                            value: value,
                            disabled: disabled,
                            onChange: (event)=>onChange(event),
                            onBlur: ()=>{
                                handleBlur();
                                if (isFormSubmitted) {
                                    if (onBlur) onBlur();
                                }
                            },
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-h-12", "tw-w-full", "tw-placeholder-textSeal", "tw-appearance-none", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-border-2", {
                                "tw-border-formInputBackground": !errors[name]
                            }, "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none", {
                                "tw-border-westburyRed": isEditing && errors[name]
                            }, {
                                "tw-font-extraLight": disabled
                            }, {
                                "tw-cursor-not-allowed": disabled
                            }),
                            style: {
                                colorScheme: `${type === "date" ? "dark" : ""}`
                            }
                        }),
                        icon && onIconClick && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            onClick: onIconClick,
                            className: "tw-absolute tw-right-0 tw-top-0 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center",
                            children: icon
                        }),
                        (isEditing || isFieldEditing) && !focused && errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "tw-absolute tw-right-0 tw-top-1 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: `wi wi-20px wi-alert tw-text-westburyRed`
                            })
                        }),
                        disabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "tw-absolute tw-right-0 tw-top-1 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: `wi wi-20px wi-ban`
                            })
                        })
                    ]
                }),
                !isEditing && !isFieldEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `tw-text-textDove tw-text-[14px]`,
                    children: value && value != "" ? value : "-"
                }),
                isEditing && !isFieldEditing && errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-text-westburyRed tw-text-xs",
                    children: errors[name]
                }),
                " "
            ]
        })
    });
};



/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 
parcelRequire("acw62");
const $4a5c6258410346c7$var$WButton = ({ label: label, icon: icon = "", variant: variant, disabled: disabled = false, onClick: onClick, extraClasses: extraClasses = "" })=>{
    const baseClasses = "tw-flex tw-inline-flex tw-items-center tw-font-size-[14px] tw-justify-center tw-items-center tw-whitespace-nowrap";
    const variantClasses = {
        primary: "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-surfaceLime tw-text-surfaceBlack90 tw-h-[32px]",
        "primary-lg": "tw-py-1 tw-px-6 tw-rounded-3xl tw-bg-surfaceLime tw-text-surfaceBlack90 tw-h-[48px]",
        secondary: "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-transparent tw-text-textWhite tw-border-[2px] tw-border-textWhite tw-h-[32px]",
        "secondary-lg": "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-transparent tw-text-textWhite tw-border-[2px] tw-border-textWhite tw-h-[48px]",
        warning: "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-surfaceLime tw-text-surfaceBlack90 tw-h-[32px]",
        dark: "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-surfaceBlack90 tw-text-textWhite tw-h-[32px]",
        "outline-light": "tw-underline tw-bg-transparent tw-text-textWhite tw-h-[32px]",
        link: "tw-underline tw-underline-offset-2 tw-bg-transparent tw-text-textLime tw-h-[32px]",
        "link-secondary": "tw-underline tw-underline-offset-2 tw-bg-transparent tw-text-textWhite tw-h-[32px]",
        disabled: "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-transparent tw-text-textGraphite tw-border-[2px] tw-border-textGraphite tw-h-[32px]"
    };
    const combinedClasses = `${baseClasses} ${disabled === true ? variantClasses["disabled"] : variantClasses[variant]} ${extraClasses} ${disabled ? "tw-cursor-not-allowed" : "tw-cursor-pointer"}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: combinedClasses,
        onClick: ()=>{
            if (disabled === true) return;
            if (typeof onClick != "undefined") onClick();
        },
        style: {
            lineHeight: "16px"
        },
        children: [
            icon != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: `wi wi-sm wi-${icon} ${icon == "Back" ? "tw-mr-1" : "tw-mr-2"}`
            }),
            label
        ]
    });
};
var $4a5c6258410346c7$export$2e2bcd8739ae039 = $4a5c6258410346c7$var$WButton;





var $acw62 = parcelRequire("acw62");


const $d20d2fe2192b2a86$export$9b6170fdf3e360b0 = ({ name: name, value: value, label: label, hideOnView: hideOnView = false, icon: icon, onBlur: onBlur, onChange: onChange, disabled: disabled = false })=>{
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const [type, setType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("password");
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleFocus = ()=>setFocused(true);
    const handleBlur = ()=>setFocused(false);
    const onIconClick = ()=>{
        if (type === "password") setType("text");
        if (type === "text") setType("password");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (isEditing || !hideOnView) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mb-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    htmlFor: name,
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-space-x-1 tw-justify-start tw-block tw-leading-4 tw-text-white tw-mb-2 tw-capitalize", {
                        "tw-text-[14px]": !isEditing
                    }),
                    children: label
                }),
                isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: type,
                            name: name,
                            id: name,
                            placeholder: label,
                            value: value,
                            onChange: (event)=>onChange(event),
                            onFocus: handleFocus,
                            onBlur: ()=>{
                                handleBlur();
                            },
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-12", "tw-placeholder-textSeal", "tw-appearance-none", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-border-2", {
                                "tw-border-formInputBackground": !errors[name]
                            }, "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none", {
                                "tw-border-westburyRed": isEditing && errors[name]
                            }, {
                                "tw-font-extraLight": disabled
                            }, {
                                "tw-cursor-not-allowed": disabled
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            onClick: onIconClick,
                            className: "tw-absolute tw-top-1 tw-right-0 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-cursor-pointer",
                            children: [
                                type === "password" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    tabIndex: 0,
                                    className: "wi wi-20px wi-shut-eye"
                                }),
                                type === "text" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    tabIndex: 0,
                                    className: "wi wi-20px wi-eye"
                                })
                            ]
                        })
                    ]
                }),
                !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: `tw-text-textDove`,
                    children: "\u25CF \u25CF \u25CF \u25CF \u25CF \u25CF"
                }),
                errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-text-westburyRed tw-text-xs",
                    children: errors[name]
                }),
                " "
            ]
        })
    });
};




parcelRequire("acw62");


const $31555d64cac64856$var$defaultTitle = "Oops... Something Went Wrong";
const $31555d64cac64856$var$defaultDescription = "An error occurred";
const $31555d64cac64856$export$5f71c1e53eaf1d93 = ({ title: title = $31555d64cac64856$var$defaultTitle, description: description = $31555d64cac64856$var$defaultDescription, cta: cta })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        extraClasses: `tw-flex tw-flex-col tw-items-center tw-w-[400px] ${cta === undefined ? "tw-pb-24" : "tw-pb-4"}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: "wi tw-h-20 tw-w-20 wi-alert-warning",
                style: {
                    background: "#FF2600"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-white tw-text-2xl tw-text-center tw-mt-2 tw-font-medium",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-md tw-text-center tw-mt-2 tw-font-light",
                children: description
            }),
            cta != undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-mt-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "primary-lg",
                    label: cta.ctaText,
                    onClick: cta.onClick
                })
            })
        ]
    });
};
var $31555d64cac64856$export$2e2bcd8739ae039 = $31555d64cac64856$export$5f71c1e53eaf1d93;


function $56dc2e9e4d88bc0c$var$AdminLogin() {
    let history = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { setUserId: setUserId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const [formData, setFormData] = (0, $acw62.useState)({
        identifier: "",
        password: ""
    });
    const [submitError, setSubmitError] = (0, $acw62.useState)(false);
    const inputChange = (e)=>{
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const handleSubmit = async (e)=>{
        let response;
        try {
            response = await api.createSigninAuthToken({
                loginWithEmailorUsernameAuthToken: formData
            });
            (0, $1978162fe9dc014b$export$88aa089937905007)(response);
            setUserId(response.userId);
        } catch (error) {
            setSubmitError(true);
            return Promise.reject(error);
        }
        try {
            const userSettings = await api.retrieveUserSettings({
                userId: response.userId
            });
            const defaultDashboard = {
                Membership: "/dashboard",
                Discography: "/discography-dashboard",
                Distribution: "/distribution-dashboard"
            }[userSettings.department ?? "Membership"];
            history(defaultDashboard);
        } catch  {
            history("/dashboard");
        }
    };
    const schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        identifier: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email(),
        password: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().refine((value)=>value !== "", "Password cannot be empty")
    });
    const inputClass = "tw-h-[48px] tw-bg-surfaceBlack80 tw-p-3 tw-textSeal tw-mt-4 tw-placeholder-textSeal sm:tw-w-50";
    (0, $acw62.useEffect)(()=>{
        const prev = (0, $1978162fe9dc014b$export$56e55eecc9e3b311)();
        if (prev) (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
            text: "Your session expired. Please login again and you will be redirected to your previous page.",
            variant: "success",
            duration: 10000
        });
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d877c7393834f3de$export$2e2bcd8739ae039), {
        bgImage: "signIn",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
            extraClasses: "tw-w-[600px] sm:tw-w-50 ",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                    title: "",
                    isOpen: submitError,
                    onClose: ()=>{
                        setSubmitError(false);
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31555d64cac64856$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-justify-center tw-items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($99b5763031ccc1a7$exports))),
                            alt: "Westbury Music Consultants",
                            className: "tw-w-[158px] tw-h-[56px] tw-mt-6"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-mt-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "tw-font-sans tw-mb-4 tw-font-semibold tw-text-2xl tw-uppercase",
                                    children: "Welcome Back!"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-mt-4 tw-mb-6 tw-font-light",
                                    children: "Please enter your details to sign in"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-w-[536px]",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                                editByDefault: true,
                                handleSubmit: handleSubmit,
                                schema: schema,
                                onSuccess: ()=>{},
                                onSuccessMessage: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                                formData: formData,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        name: "identifier",
                                        label: "Email",
                                        value: formData.identifier,
                                        onChange: inputChange
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                                        name: "password",
                                        label: "Password",
                                        value: formData.password,
                                        onChange: inputChange
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-flex tw-justify-center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($56dc2e9e4d88bc0c$var$FormFooter, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function $56dc2e9e4d88bc0c$var$FormFooter() {
    const { handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            label: "Sign In",
            variant: "primary-lg",
            onClick: ()=>handleFormSubmit(formData),
            extraClasses: "tw-mt-4 tw-w-[200px]"
        })
    });
}
var $56dc2e9e4d88bc0c$export$2e2bcd8739ae039 = $56dc2e9e4d88bc0c$var$AdminLogin;



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $94a0b690fd9978ec$var$extendStatics = function(d, b) {
    $94a0b690fd9978ec$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $94a0b690fd9978ec$var$extendStatics(d, b);
};
function $94a0b690fd9978ec$var$__extends(d, b) {
    $94a0b690fd9978ec$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $94a0b690fd9978ec$var$__assign = function() {
    $94a0b690fd9978ec$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $94a0b690fd9978ec$var$__assign.apply(this, arguments);
};
function $94a0b690fd9978ec$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
}
var $94a0b690fd9978ec$var$VIEWBOX_WIDTH = 100;
var $94a0b690fd9978ec$var$VIEWBOX_HEIGHT = 100;
var $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF = 50;
var $94a0b690fd9978ec$var$VIEWBOX_CENTER_X = 50;
var $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y = 50;
function $94a0b690fd9978ec$var$Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return (0, $acw62.createElement)("path", {
        className: className,
        style: Object.assign({}, style, $94a0b690fd9978ec$var$getDashStyle({
            pathRadius: pathRadius,
            dashRatio: dashRatio,
            counterClockwise: counterClockwise
        })),
        d: $94a0b690fd9978ec$var$getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise
        }),
        strokeWidth: strokeWidth,
        fillOpacity: 0
    });
}
function $94a0b690fd9978ec$var$getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + $94a0b690fd9978ec$var$VIEWBOX_CENTER_X + "," + $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function $94a0b690fd9978ec$var$getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px"
    };
}
var $94a0b690fd9978ec$export$14082143029b37c8 = function(_super) {
    $94a0b690fd9978ec$var$__extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function() {
        if (!this.props.background) return 0;
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function() {
        return $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function() {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function() {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return (0, $acw62.createElement)("svg", {
            className: classes.root + " " + className,
            style: styles.root,
            viewBox: "0 0 " + $94a0b690fd9978ec$var$VIEWBOX_WIDTH + " " + $94a0b690fd9978ec$var$VIEWBOX_HEIGHT,
            "data-test-id": "CircularProgressbar"
        }, this.props.background ? (0, $acw62.createElement)("circle", {
            className: classes.background,
            style: styles.background,
            cx: $94a0b690fd9978ec$var$VIEWBOX_CENTER_X,
            cy: $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y,
            r: $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF
        }) : null, (0, $acw62.createElement)($94a0b690fd9978ec$var$Path, {
            className: classes.trail,
            counterClockwise: counterClockwise,
            dashRatio: circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.trail
        }), (0, $acw62.createElement)($94a0b690fd9978ec$var$Path, {
            className: classes.path,
            counterClockwise: counterClockwise,
            dashRatio: pathRatio * circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.path
        }), text ? (0, $acw62.createElement)("text", {
            className: classes.text,
            style: styles.text,
            x: $94a0b690fd9978ec$var$VIEWBOX_CENTER_X,
            y: $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y
        }, text) : null);
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: "CircularProgressbar",
            trail: "CircularProgressbar-trail",
            path: "CircularProgressbar-path",
            text: "CircularProgressbar-text",
            background: "CircularProgressbar-background"
        },
        counterClockwise: false,
        className: "",
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {}
        },
        text: ""
    };
    return CircularProgressbar;
}((0, $acw62.Component));
function $94a0b690fd9978ec$export$5ab97151efedb8c6(props) {
    var children = props.children, circularProgressbarProps = $94a0b690fd9978ec$var$__rest(props, [
        "children"
    ]);
    return (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren"
    }, (0, $acw62.createElement)("div", {
        style: {
            position: "relative",
            width: "100%",
            height: "100%"
        }
    }, (0, $acw62.createElement)($94a0b690fd9978ec$export$14082143029b37c8, $94a0b690fd9978ec$var$__assign({}, circularProgressbarProps)), props.children ? (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren__children",
        style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            marginTop: "-100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }
    }, props.children) : null));
}
function $94a0b690fd9978ec$export$5115a192ad9bf57f(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : "center center";
    return {
        root: {},
        path: $94a0b690fd9978ec$var$removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s"
        }),
        trail: $94a0b690fd9978ec$var$removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin
        }),
        text: $94a0b690fd9978ec$var$removeUndefinedValues({
            fill: textColor,
            fontSize: textSize
        }),
        background: $94a0b690fd9978ec$var$removeUndefinedValues({
            fill: backgroundColor
        })
    };
}
function $94a0b690fd9978ec$var$removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function(key) {
        if (obj[key] == null) delete obj[key];
    });
    return obj;
}


const $5a6180f04a3e64cf$var$progressValues = [
    1,
    2,
    3,
    5,
    10
];
const $5a6180f04a3e64cf$var$progressPercentage = {
    1: 34,
    2: 50,
    3: 67,
    5: 84,
    10: 100
};
const $5a6180f04a3e64cf$export$553fd01770b02e7e = ({ value: value, text: text })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-mt-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "0",
                height: "0",
                viewBox: "0 0 0 0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "gradient",
                        x1: "0%",
                        y1: "0%",
                        x2: "0%",
                        y2: "100%",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#FF7121"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#FF1529"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    maxWidth: "185px",
                    margin: "0 auto"
                },
                className: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94a0b690fd9978ec$export$5ab97151efedb8c6), {
                    value: value,
                    styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                        strokeLinecap: "butt",
                        textSize: "16px",
                        pathColor: "#00B3FF",
                        trailColor: "#c4c4c4",
                        textColor: "#191c1f"
                    }),
                    strokeWidth: 10,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-text-center tw-text-[13px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "",
                                children: [
                                    value,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "",
                                children: text
                            })
                        ]
                    })
                })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
const $7950a72521dfb882$var$ClientContext = /*#__PURE__*/ (0, $acw62.createContext)({
    clientId: undefined,
    setClientId: ()=>{},
    clientEmail: "",
    setClientEmail: ()=>{}
});
const $7950a72521dfb882$export$5d91bb6ce8e0f47 = ({ children: children, initialClientId: initialClientId, initialClientEmail: initialClientEmail })=>{
    const [clientId, setClientId] = (0, $acw62.useState)(()=>localStorage.getItem("clientId") || initialClientId);
    const [clientEmail, setClientEmail] = (0, $acw62.useState)(()=>localStorage.getItem("clientEmail") || initialClientEmail);
    (0, $acw62.useEffect)(()=>{
        if (!clientId) {
            localStorage.removeItem("clientId");
            return;
        }
        localStorage.setItem("clientId", clientId);
    }, [
        clientId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!clientEmail) {
            localStorage.removeItem("clientEmail");
            return;
        }
        localStorage.setItem("clientEmail", clientEmail);
    }, [
        clientEmail
    ]);
    const contextValue = {
        clientId: clientId,
        setClientId: setClientId,
        clientEmail: clientEmail,
        setClientEmail: setClientEmail
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7950a72521dfb882$var$ClientContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $7950a72521dfb882$export$d669bac2eff79277 = ()=>{
    const { clientId: clientId, setClientId: setClientId, clientEmail: clientEmail, setClientEmail: setClientEmail } = (0, $acw62.useContext)($7950a72521dfb882$var$ClientContext);
    if (!setClientId) throw new Error("useClientId must be used within a ClientProvider");
    return {
        clientId: clientId,
        setClientId: setClientId,
        clientEmail: clientEmail,
        setClientEmail: setClientEmail
    };
};




var $acw62 = parcelRequire("acw62");
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ function $97ecbd121be4860b$export$cf2f7c5792f80b46() {}
const $97ecbd121be4860b$export$4c3d22f3d993c33f = function() {
    let id = 0;
    return function() {
        return id++;
    };
}();
function $97ecbd121be4860b$export$342063e11d6c3cad(value) {
    return value === null || typeof value === "undefined";
}
function $97ecbd121be4860b$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
function $97ecbd121be4860b$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
const $97ecbd121be4860b$export$39b482c5e57630a8 = (value)=>(typeof value === "number" || value instanceof Number) && isFinite(+value);
function $97ecbd121be4860b$export$ef35774e6d314e91(value, defaultValue) {
    return $97ecbd121be4860b$export$39b482c5e57630a8(value) ? value : defaultValue;
}
function $97ecbd121be4860b$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $97ecbd121be4860b$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : value / dimension;
const $97ecbd121be4860b$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function $97ecbd121be4860b$export$e7094788287c5e9b(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $97ecbd121be4860b$export$3722cfe417b6ed86(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($97ecbd121be4860b$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($97ecbd121be4860b$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
function $97ecbd121be4860b$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
function $97ecbd121be4860b$export$738ab4df8bf92ae9(source) {
    if ($97ecbd121be4860b$export$8b22cf2602fb60ce(source)) return source.map($97ecbd121be4860b$export$738ab4df8bf92ae9);
    if ($97ecbd121be4860b$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $97ecbd121be4860b$export$738ab4df8bf92ae9(source[keys[k]]);
        return target;
    }
    return source;
}
function $97ecbd121be4860b$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
function $97ecbd121be4860b$export$d377dcb2b61d6c4e(key, target, source, options) {
    if (!$97ecbd121be4860b$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($97ecbd121be4860b$export$23f2a1d2818174ef(tval) && $97ecbd121be4860b$export$23f2a1d2818174ef(sval)) $97ecbd121be4860b$export$e7c866399fa523f5(tval, sval, options);
    else target[key] = $97ecbd121be4860b$export$738ab4df8bf92ae9(sval);
}
function $97ecbd121be4860b$export$e7c866399fa523f5(target, source, options) {
    const sources = $97ecbd121be4860b$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$97ecbd121be4860b$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $97ecbd121be4860b$export$d377dcb2b61d6c4e;
    for(let i = 0; i < ilen; ++i){
        source = sources[i];
        if (!$97ecbd121be4860b$export$23f2a1d2818174ef(source)) continue;
        const keys = Object.keys(source);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, source, options);
    }
    return target;
}
function $97ecbd121be4860b$export$2219238a014317b0(target, source) {
    return $97ecbd121be4860b$export$e7c866399fa523f5(target, source, {
        merger: $97ecbd121be4860b$export$667d3bf0c5f83305
    });
}
function $97ecbd121be4860b$export$667d3bf0c5f83305(key, target, source) {
    if (!$97ecbd121be4860b$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($97ecbd121be4860b$export$23f2a1d2818174ef(tval) && $97ecbd121be4860b$export$23f2a1d2818174ef(sval)) $97ecbd121be4860b$export$2219238a014317b0(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $97ecbd121be4860b$export$738ab4df8bf92ae9(sval);
}
function $97ecbd121be4860b$export$317a3d46287192d8(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
const $97ecbd121be4860b$var$keyResolvers = {
    "": (v)=>v,
    x: (o)=>o.x,
    y: (o)=>o.y
};
function $97ecbd121be4860b$export$2d1720544b23b823(obj, key) {
    const resolver = $97ecbd121be4860b$var$keyResolvers[key] || ($97ecbd121be4860b$var$keyResolvers[key] = $97ecbd121be4860b$var$_getKeyResolver(key));
    return resolver(obj);
}
function $97ecbd121be4860b$var$_getKeyResolver(key) {
    const keys = $97ecbd121be4860b$export$1ee57be6f6687d2c(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $97ecbd121be4860b$export$1ee57be6f6687d2c(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function $97ecbd121be4860b$export$71cec2538cb2c617(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $97ecbd121be4860b$export$35e795649ee09318 = (value)=>typeof value !== "undefined";
const $97ecbd121be4860b$export$c3950d9923825c02 = (value)=>typeof value === "function";
const $97ecbd121be4860b$export$995eb9fca571757 = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
function $97ecbd121be4860b$export$3b513254972cfc9c(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const $97ecbd121be4860b$export$56c0d5a1e737357d = Math.PI;
const $97ecbd121be4860b$export$971d5caa766a69d7 = 2 * $97ecbd121be4860b$export$56c0d5a1e737357d;
const $97ecbd121be4860b$export$8c78c7c36408ea29 = $97ecbd121be4860b$export$971d5caa766a69d7 + $97ecbd121be4860b$export$56c0d5a1e737357d;
const $97ecbd121be4860b$export$d29e374196577086 = Number.POSITIVE_INFINITY;
const $97ecbd121be4860b$export$2ec5befb9e6c97d4 = $97ecbd121be4860b$export$56c0d5a1e737357d / 180;
const $97ecbd121be4860b$export$7f8ddf7c7c20b3cd = $97ecbd121be4860b$export$56c0d5a1e737357d / 2;
const $97ecbd121be4860b$export$53c86fa97d611818 = $97ecbd121be4860b$export$56c0d5a1e737357d / 4;
const $97ecbd121be4860b$export$39c1cc7c062529d4 = $97ecbd121be4860b$export$56c0d5a1e737357d * 2 / 3;
const $97ecbd121be4860b$export$df995fae86a55f06 = Math.log10;
const $97ecbd121be4860b$export$2408f22a0fab9ae5 = Math.sign;
function $97ecbd121be4860b$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $97ecbd121be4860b$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($97ecbd121be4860b$export$df995fae86a55f06(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
function $97ecbd121be4860b$export$ebd11618f299a286(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $97ecbd121be4860b$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $97ecbd121be4860b$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
function $97ecbd121be4860b$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
function $97ecbd121be4860b$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $97ecbd121be4860b$export$625550452a3fa3ec(degrees) {
    return degrees * ($97ecbd121be4860b$export$56c0d5a1e737357d / 180);
}
function $97ecbd121be4860b$export$d66501df72047452(radians) {
    return radians * (180 / $97ecbd121be4860b$export$56c0d5a1e737357d);
}
function $97ecbd121be4860b$export$91477dc880baac21(x) {
    if (!$97ecbd121be4860b$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
function $97ecbd121be4860b$export$34aec0b863436764(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $97ecbd121be4860b$export$56c0d5a1e737357d) angle += $97ecbd121be4860b$export$971d5caa766a69d7;
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $97ecbd121be4860b$export$53a70dd1ebbae346(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function $97ecbd121be4860b$export$7a0bdf7d4a91ea88(a, b) {
    return (a - b + $97ecbd121be4860b$export$8c78c7c36408ea29) % $97ecbd121be4860b$export$971d5caa766a69d7 - $97ecbd121be4860b$export$56c0d5a1e737357d;
}
function $97ecbd121be4860b$export$3d12bd131bb975d1(a) {
    return (a % $97ecbd121be4860b$export$971d5caa766a69d7 + $97ecbd121be4860b$export$971d5caa766a69d7) % $97ecbd121be4860b$export$971d5caa766a69d7;
}
function $97ecbd121be4860b$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $97ecbd121be4860b$export$3d12bd131bb975d1(angle);
    const s = $97ecbd121be4860b$export$3d12bd131bb975d1(start);
    const e = $97ecbd121be4860b$export$3d12bd131bb975d1(end);
    const angleToStart = $97ecbd121be4860b$export$3d12bd131bb975d1(s - a);
    const angleToEnd = $97ecbd121be4860b$export$3d12bd131bb975d1(e - a);
    const startToAngle = $97ecbd121be4860b$export$3d12bd131bb975d1(a - s);
    const endToAngle = $97ecbd121be4860b$export$3d12bd131bb975d1(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function $97ecbd121be4860b$export$a9c23c6ac3fc3eca(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $97ecbd121be4860b$export$9bb611d729802a56(value) {
    return $97ecbd121be4860b$export$a9c23c6ac3fc3eca(value, -32768, 32767);
}
function $97ecbd121be4860b$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $97ecbd121be4860b$export$c03999cb2f36933f(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
const $97ecbd121be4860b$export$dc98b0b04f4c7758 = (table, key, value, last)=>$97ecbd121be4860b$export$c03999cb2f36933f(table, value, last ? (index)=>table[index][key] <= value : (index)=>table[index][key] < value);
const $97ecbd121be4860b$export$8743009a87fcb00f = (table, key, value)=>$97ecbd121be4860b$export$c03999cb2f36933f(table, value, (index)=>table[index][key] >= value);
function $97ecbd121be4860b$export$faec65b429be379(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $97ecbd121be4860b$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $97ecbd121be4860b$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $97ecbd121be4860b$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $97ecbd121be4860b$export$71cec2538cb2c617(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $97ecbd121be4860b$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $97ecbd121be4860b$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
function $97ecbd121be4860b$export$71511d61b312f219(items) {
    const set = new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set.add(items[i]);
    if (set.size === ilen) return items;
    return Array.from(set);
}
function $97ecbd121be4860b$export$a17c37559e1db147(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
const $97ecbd121be4860b$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
function $97ecbd121be4860b$export$efca4cbe5dd06740(fn, thisArg, updateFn) {
    const updateArgs = updateFn || ((args)=>Array.prototype.slice.call(args));
    let ticking = false;
    let args = [];
    return function(...rest) {
        args = updateArgs(rest);
        if (!ticking) {
            ticking = true;
            $97ecbd121be4860b$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, args);
            });
        }
    };
}
function $97ecbd121be4860b$export$f787f51d84a910ad(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
const $97ecbd121be4860b$export$db202ddc8be9136 = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
const $97ecbd121be4860b$export$25ce5a424b770e84 = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
const $97ecbd121be4860b$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
function $97ecbd121be4860b$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $97ecbd121be4860b$export$a9c23c6ac3fc3eca(Math.min($97ecbd121be4860b$export$dc98b0b04f4c7758(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : $97ecbd121be4860b$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $97ecbd121be4860b$export$a9c23c6ac3fc3eca(Math.max($97ecbd121be4860b$export$dc98b0b04f4c7758(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $97ecbd121be4860b$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
function $97ecbd121be4860b$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $97ecbd121be4860b$var$atEdge = (t)=>t === 0 || t === 1;
const $97ecbd121be4860b$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $97ecbd121be4860b$export$971d5caa766a69d7 / p));
const $97ecbd121be4860b$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $97ecbd121be4860b$export$971d5caa766a69d7 / p) + 1;
const $97ecbd121be4860b$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $97ecbd121be4860b$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $97ecbd121be4860b$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($97ecbd121be4860b$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$97ecbd121be4860b$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$97ecbd121be4860b$var$atEdge(t) ? t : $97ecbd121be4860b$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$97ecbd121be4860b$var$atEdge(t) ? t : $97ecbd121be4860b$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $97ecbd121be4860b$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $97ecbd121be4860b$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $97ecbd121be4860b$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $97ecbd121be4860b$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $97ecbd121be4860b$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $97ecbd121be4860b$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */ function $97ecbd121be4860b$var$round(v) {
    return v + 0.5 | 0;
}
const $97ecbd121be4860b$var$lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function $97ecbd121be4860b$var$p2b(v) {
    return $97ecbd121be4860b$var$lim($97ecbd121be4860b$var$round(v * 2.55), 0, 255);
}
function $97ecbd121be4860b$var$n2b(v) {
    return $97ecbd121be4860b$var$lim($97ecbd121be4860b$var$round(v * 255), 0, 255);
}
function $97ecbd121be4860b$var$b2n(v) {
    return $97ecbd121be4860b$var$lim($97ecbd121be4860b$var$round(v / 2.55) / 100, 0, 1);
}
function $97ecbd121be4860b$var$n2p(v) {
    return $97ecbd121be4860b$var$lim($97ecbd121be4860b$var$round(v * 100), 0, 100);
}
const $97ecbd121be4860b$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $97ecbd121be4860b$var$hex = [
    ..."0123456789ABCDEF"
];
const $97ecbd121be4860b$var$h1 = (b)=>$97ecbd121be4860b$var$hex[b & 0xF];
const $97ecbd121be4860b$var$h2 = (b)=>$97ecbd121be4860b$var$hex[(b & 0xF0) >> 4] + $97ecbd121be4860b$var$hex[b & 0xF];
const $97ecbd121be4860b$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $97ecbd121be4860b$var$isShort = (v)=>$97ecbd121be4860b$var$eq(v.r) && $97ecbd121be4860b$var$eq(v.g) && $97ecbd121be4860b$var$eq(v.b) && $97ecbd121be4860b$var$eq(v.a);
function $97ecbd121be4860b$var$hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $97ecbd121be4860b$var$map$1[str[1]] * 17,
            g: 255 & $97ecbd121be4860b$var$map$1[str[2]] * 17,
            b: 255 & $97ecbd121be4860b$var$map$1[str[3]] * 17,
            a: len === 5 ? $97ecbd121be4860b$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $97ecbd121be4860b$var$map$1[str[1]] << 4 | $97ecbd121be4860b$var$map$1[str[2]],
            g: $97ecbd121be4860b$var$map$1[str[3]] << 4 | $97ecbd121be4860b$var$map$1[str[4]],
            b: $97ecbd121be4860b$var$map$1[str[5]] << 4 | $97ecbd121be4860b$var$map$1[str[6]],
            a: len === 9 ? $97ecbd121be4860b$var$map$1[str[7]] << 4 | $97ecbd121be4860b$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $97ecbd121be4860b$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $97ecbd121be4860b$var$hexString(v) {
    var f = $97ecbd121be4860b$var$isShort(v) ? $97ecbd121be4860b$var$h1 : $97ecbd121be4860b$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $97ecbd121be4860b$var$alpha(v.a, f) : undefined;
}
const $97ecbd121be4860b$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $97ecbd121be4860b$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $97ecbd121be4860b$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $97ecbd121be4860b$var$hwb2rgbn(h, w, b) {
    const rgb = $97ecbd121be4860b$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $97ecbd121be4860b$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $97ecbd121be4860b$var$rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $97ecbd121be4860b$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $97ecbd121be4860b$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($97ecbd121be4860b$var$n2b);
}
function $97ecbd121be4860b$var$hsl2rgb(h, s, l) {
    return $97ecbd121be4860b$var$calln($97ecbd121be4860b$var$hsl2rgbn, h, s, l);
}
function $97ecbd121be4860b$var$hwb2rgb(h, w, b) {
    return $97ecbd121be4860b$var$calln($97ecbd121be4860b$var$hwb2rgbn, h, w, b);
}
function $97ecbd121be4860b$var$hsv2rgb(h, s, v) {
    return $97ecbd121be4860b$var$calln($97ecbd121be4860b$var$hsv2rgbn, h, s, v);
}
function $97ecbd121be4860b$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $97ecbd121be4860b$var$hueParse(str) {
    const m = $97ecbd121be4860b$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $97ecbd121be4860b$var$p2b(+m[5]) : $97ecbd121be4860b$var$n2b(+m[5]);
    const h = $97ecbd121be4860b$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $97ecbd121be4860b$var$hwb2rgb(h, p1, p2);
    else if (m[1] === "hsv") v = $97ecbd121be4860b$var$hsv2rgb(h, p1, p2);
    else v = $97ecbd121be4860b$var$hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $97ecbd121be4860b$var$rotate(v, deg) {
    var h = $97ecbd121be4860b$var$rgb2hsl(v);
    h[0] = $97ecbd121be4860b$var$hue(h[0] + deg);
    h = $97ecbd121be4860b$var$hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $97ecbd121be4860b$var$hslString(v) {
    if (!v) return;
    const a = $97ecbd121be4860b$var$rgb2hsl(v);
    const h = a[0];
    const s = $97ecbd121be4860b$var$n2p(a[1]);
    const l = $97ecbd121be4860b$var$n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$97ecbd121be4860b$var$b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $97ecbd121be4860b$var$map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $97ecbd121be4860b$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $97ecbd121be4860b$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($97ecbd121be4860b$var$names$1);
    const tkeys = Object.keys($97ecbd121be4860b$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $97ecbd121be4860b$var$map[k]);
        }
        k = parseInt($97ecbd121be4860b$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $97ecbd121be4860b$var$names;
function $97ecbd121be4860b$var$nameParse(str) {
    if (!$97ecbd121be4860b$var$names) {
        $97ecbd121be4860b$var$names = $97ecbd121be4860b$var$unpack();
        $97ecbd121be4860b$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $97ecbd121be4860b$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $97ecbd121be4860b$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $97ecbd121be4860b$var$rgbParse(str) {
    const m = $97ecbd121be4860b$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $97ecbd121be4860b$var$p2b(v) : $97ecbd121be4860b$var$lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $97ecbd121be4860b$var$p2b(r) : $97ecbd121be4860b$var$lim(r, 0, 255));
    g = 255 & (m[4] ? $97ecbd121be4860b$var$p2b(g) : $97ecbd121be4860b$var$lim(g, 0, 255));
    b = 255 & (m[6] ? $97ecbd121be4860b$var$p2b(b) : $97ecbd121be4860b$var$lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $97ecbd121be4860b$var$rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$97ecbd121be4860b$var$b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $97ecbd121be4860b$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $97ecbd121be4860b$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $97ecbd121be4860b$var$interpolate(rgb1, rgb2, t) {
    const r = $97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb1.r));
    const g = $97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb1.g));
    const b = $97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb1.b));
    return {
        r: $97ecbd121be4860b$var$n2b($97ecbd121be4860b$var$to(r + t * ($97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb2.r)) - r))),
        g: $97ecbd121be4860b$var$n2b($97ecbd121be4860b$var$to(g + t * ($97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb2.g)) - g))),
        b: $97ecbd121be4860b$var$n2b($97ecbd121be4860b$var$to(b + t * ($97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $97ecbd121be4860b$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $97ecbd121be4860b$var$rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $97ecbd121be4860b$var$hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $97ecbd121be4860b$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $97ecbd121be4860b$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $97ecbd121be4860b$var$n2b(input[3]);
        }
    } else {
        v = $97ecbd121be4860b$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $97ecbd121be4860b$var$n2b(v.a);
    }
    return v;
}
function $97ecbd121be4860b$var$functionParse(str) {
    if (str.charAt(0) === "r") return $97ecbd121be4860b$var$rgbParse(str);
    return $97ecbd121be4860b$var$hueParse(str);
}
class $97ecbd121be4860b$var$Color {
    constructor(input){
        if (input instanceof $97ecbd121be4860b$var$Color) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $97ecbd121be4860b$var$fromObject(input);
        else if (type === "string") v = $97ecbd121be4860b$var$hexParse(input) || $97ecbd121be4860b$var$nameParse(input) || $97ecbd121be4860b$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $97ecbd121be4860b$var$clone(this._rgb);
        if (v) v.a = $97ecbd121be4860b$var$b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $97ecbd121be4860b$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $97ecbd121be4860b$var$rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $97ecbd121be4860b$var$hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $97ecbd121be4860b$var$hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $97ecbd121be4860b$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $97ecbd121be4860b$var$Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $97ecbd121be4860b$var$n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $97ecbd121be4860b$var$round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $97ecbd121be4860b$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $97ecbd121be4860b$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $97ecbd121be4860b$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $97ecbd121be4860b$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $97ecbd121be4860b$var$rotate(this._rgb, deg);
        return this;
    }
}
function $97ecbd121be4860b$var$index_esm(input) {
    return new $97ecbd121be4860b$var$Color(input);
}
function $97ecbd121be4860b$export$2ed0fc6709e59212(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $97ecbd121be4860b$export$db3b6bfb95261072(value) {
    return $97ecbd121be4860b$export$2ed0fc6709e59212(value) ? value : $97ecbd121be4860b$var$index_esm(value);
}
function $97ecbd121be4860b$export$f96d196f7728bb5(value) {
    return $97ecbd121be4860b$export$2ed0fc6709e59212(value) ? value : $97ecbd121be4860b$var$index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const $97ecbd121be4860b$export$3a6d5c9ae78a2c08 = Object.create(null);
const $97ecbd121be4860b$export$a93c5207d687da10 = Object.create(null);
function $97ecbd121be4860b$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $97ecbd121be4860b$var$set(root, scope, values) {
    if (typeof scope === "string") return $97ecbd121be4860b$export$e7c866399fa523f5($97ecbd121be4860b$var$getScope$1(root, scope), values);
    return $97ecbd121be4860b$export$e7c866399fa523f5($97ecbd121be4860b$var$getScope$1(root, ""), scope);
}
class $97ecbd121be4860b$var$Defaults {
    constructor(_descriptors){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$97ecbd121be4860b$export$f96d196f7728bb5(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$97ecbd121be4860b$export$f96d196f7728bb5(options.borderColor);
        this.hoverColor = (ctx, options)=>$97ecbd121be4860b$export$f96d196f7728bb5(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
    }
    set(scope, values) {
        return $97ecbd121be4860b$var$set(this, scope, values);
    }
    get(scope) {
        return $97ecbd121be4860b$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $97ecbd121be4860b$var$set($97ecbd121be4860b$export$a93c5207d687da10, scope, values);
    }
    override(scope, values) {
        return $97ecbd121be4860b$var$set($97ecbd121be4860b$export$3a6d5c9ae78a2c08, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $97ecbd121be4860b$var$getScope$1(this, scope);
        const targetScopeObject = $97ecbd121be4860b$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($97ecbd121be4860b$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $97ecbd121be4860b$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
}
var $97ecbd121be4860b$export$4368d992c4eafac0 = new $97ecbd121be4860b$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
});
function $97ecbd121be4860b$export$9d0e2d13d04f7070(font) {
    if (!font || $97ecbd121be4860b$export$342063e11d6c3cad(font.size) || $97ecbd121be4860b$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function $97ecbd121be4860b$export$2329c99376c9d0a4(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $97ecbd121be4860b$export$9f4f30ee63539e24(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== undefined && thing !== null && $97ecbd121be4860b$export$8b22cf2602fb60ce(thing) !== true) longest = $97ecbd121be4860b$export$2329c99376c9d0a4(ctx, data, gc, longest, thing);
        else if ($97ecbd121be4860b$export$8b22cf2602fb60ce(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== undefined && nestedThing !== null && !$97ecbd121be4860b$export$8b22cf2602fb60ce(nestedThing)) longest = $97ecbd121be4860b$export$2329c99376c9d0a4(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $97ecbd121be4860b$export$b4171a6734a65d42(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $97ecbd121be4860b$export$ee7c8ad385a60b7b(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $97ecbd121be4860b$export$1fbe638ecf81657e(ctx, options, x, y) {
    $97ecbd121be4860b$export$158acd800e1ef08b(ctx, options, x, y, null);
}
function $97ecbd121be4860b$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $97ecbd121be4860b$export$2ec5befb9e6c97d4;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $97ecbd121be4860b$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $97ecbd121be4860b$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $97ecbd121be4860b$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $97ecbd121be4860b$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $97ecbd121be4860b$export$53c86fa97d611818) * size;
            yOffset = Math.sin(rad + $97ecbd121be4860b$export$53c86fa97d611818) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - $97ecbd121be4860b$export$56c0d5a1e737357d, rad - $97ecbd121be4860b$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - $97ecbd121be4860b$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + $97ecbd121be4860b$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + $97ecbd121be4860b$export$7f8ddf7c7c20b3cd, rad + $97ecbd121be4860b$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $97ecbd121be4860b$export$53c86fa97d611818;
        case "rectRot":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $97ecbd121be4860b$export$53c86fa97d611818;
        case "cross":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "star":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += $97ecbd121be4860b$export$53c86fa97d611818;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $97ecbd121be4860b$export$3d8c2f653ac9d0b9(point, area, margin) {
    margin = margin || 0.5;
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $97ecbd121be4860b$export$61196ced6d74a310(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $97ecbd121be4860b$export$a07804094c3ecf2d(ctx) {
    ctx.restore();
}
function $97ecbd121be4860b$export$6554612db691658e(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $97ecbd121be4860b$export$493d36ec626b6698(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $97ecbd121be4860b$export$3a1a48c8f6ef640e(ctx, text, x, y, font, opts = {}) {
    const lines = $97ecbd121be4860b$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $97ecbd121be4860b$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$97ecbd121be4860b$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $97ecbd121be4860b$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $97ecbd121be4860b$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$97ecbd121be4860b$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $97ecbd121be4860b$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $97ecbd121be4860b$export$d66dc83d8cfc8dd(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$97ecbd121be4860b$export$7f8ddf7c7c20b3cd, $97ecbd121be4860b$export$56c0d5a1e737357d, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $97ecbd121be4860b$export$56c0d5a1e737357d, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$97ecbd121be4860b$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $97ecbd121be4860b$var$LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const $97ecbd121be4860b$var$FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function $97ecbd121be4860b$export$fef3dfd9bad05307(value, size) {
    const matches = ("" + value).match($97ecbd121be4860b$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $97ecbd121be4860b$var$numberOrZero = (v)=>+v || 0;
function $97ecbd121be4860b$export$ab83b03e4111b1d0(value, props) {
    const ret = {};
    const objProps = $97ecbd121be4860b$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $97ecbd121be4860b$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$97ecbd121be4860b$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $97ecbd121be4860b$var$numberOrZero(read(prop));
    return ret;
}
function $97ecbd121be4860b$export$92108d983e8ee699(value) {
    return $97ecbd121be4860b$export$ab83b03e4111b1d0(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
function $97ecbd121be4860b$export$9fa96a7d116ea3ce(value) {
    return $97ecbd121be4860b$export$ab83b03e4111b1d0(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
function $97ecbd121be4860b$export$3466f893ebf79586(value) {
    const obj = $97ecbd121be4860b$export$92108d983e8ee699(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
function $97ecbd121be4860b$export$c4ce752e73470fba(options, fallback) {
    options = options || {};
    fallback = fallback || $97ecbd121be4860b$export$4368d992c4eafac0.font;
    let size = $97ecbd121be4860b$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $97ecbd121be4860b$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($97ecbd121be4860b$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = "";
    }
    const font = {
        family: $97ecbd121be4860b$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $97ecbd121be4860b$export$fef3dfd9bad05307($97ecbd121be4860b$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $97ecbd121be4860b$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $97ecbd121be4860b$export$9d0e2d13d04f7070(font);
    return font;
}
function $97ecbd121be4860b$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $97ecbd121be4860b$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
function $97ecbd121be4860b$export$96f57966bedc81b4(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $97ecbd121be4860b$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $97ecbd121be4860b$export$dda1d9f60106f0e9(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
function $97ecbd121be4860b$export$7910e0436ed8d1de(scopes, prefixes = [
    ""
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$97ecbd121be4860b$export$35e795649ee09318(fallback)) fallback = $97ecbd121be4860b$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$97ecbd121be4860b$export$7910e0436ed8d1de([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $97ecbd121be4860b$var$_cached(target, prop, ()=>$97ecbd121be4860b$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $97ecbd121be4860b$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $97ecbd121be4860b$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value;
            delete target._keys;
            return true;
        }
    });
}
function $97ecbd121be4860b$export$a9c996f45e5784d0(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $97ecbd121be4860b$export$555508cbc6add439(proxy, descriptorDefaults),
        setContext: (ctx)=>$97ecbd121be4860b$export$a9c996f45e5784d0(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$97ecbd121be4860b$export$a9c996f45e5784d0(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $97ecbd121be4860b$var$_cached(target, prop, ()=>$97ecbd121be4860b$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $97ecbd121be4860b$export$555508cbc6add439(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $97ecbd121be4860b$export$c3950d9923825c02(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $97ecbd121be4860b$export$c3950d9923825c02(_indexable) ? _indexable : ()=>_indexable
    };
}
const $97ecbd121be4860b$var$readKey = (prefix, name)=>prefix ? prefix + $97ecbd121be4860b$export$71cec2538cb2c617(name) : name;
const $97ecbd121be4860b$var$needsSubResolver = (prop, value)=>$97ecbd121be4860b$export$23f2a1d2818174ef(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $97ecbd121be4860b$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    target[prop] = value;
    return value;
}
function $97ecbd121be4860b$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop];
    if ($97ecbd121be4860b$export$c3950d9923825c02(value) && descriptors.isScriptable(prop)) value = $97ecbd121be4860b$var$_resolveScriptable(prop, value, target, receiver);
    if ($97ecbd121be4860b$export$8b22cf2602fb60ce(value) && value.length) value = $97ecbd121be4860b$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($97ecbd121be4860b$var$needsSubResolver(prop, value)) value = $97ecbd121be4860b$export$a9c996f45e5784d0(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $97ecbd121be4860b$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($97ecbd121be4860b$var$needsSubResolver(prop, value)) value = $97ecbd121be4860b$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $97ecbd121be4860b$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if ($97ecbd121be4860b$export$35e795649ee09318(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($97ecbd121be4860b$export$23f2a1d2818174ef(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $97ecbd121be4860b$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($97ecbd121be4860b$export$a9c996f45e5784d0(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $97ecbd121be4860b$var$resolveFallback(fallback, prop, value) {
    return $97ecbd121be4860b$export$c3950d9923825c02(fallback) ? fallback(prop, value) : fallback;
}
const $97ecbd121be4860b$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $97ecbd121be4860b$export$2d1720544b23b823(parent, key) : undefined;
function $97ecbd121be4860b$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $97ecbd121be4860b$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $97ecbd121be4860b$var$resolveFallback(scope._fallback, key, value);
            if ($97ecbd121be4860b$export$35e795649ee09318(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $97ecbd121be4860b$export$35e795649ee09318(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $97ecbd121be4860b$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $97ecbd121be4860b$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $97ecbd121be4860b$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if ($97ecbd121be4860b$export$35e795649ee09318(fallback) && fallback !== prop) {
        key = $97ecbd121be4860b$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $97ecbd121be4860b$export$7910e0436ed8d1de(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$97ecbd121be4860b$var$subGetTarget(resolver, prop, value));
}
function $97ecbd121be4860b$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $97ecbd121be4860b$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $97ecbd121be4860b$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($97ecbd121be4860b$export$8b22cf2602fb60ce(target) && $97ecbd121be4860b$export$23f2a1d2818174ef(value)) return value;
    return target;
}
function $97ecbd121be4860b$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $97ecbd121be4860b$var$_resolve($97ecbd121be4860b$var$readKey(prefix, prop), scopes);
        if ($97ecbd121be4860b$export$35e795649ee09318(value)) return $97ecbd121be4860b$var$needsSubResolver(prop, value) ? $97ecbd121be4860b$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $97ecbd121be4860b$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($97ecbd121be4860b$export$35e795649ee09318(value)) return value;
    }
}
function $97ecbd121be4860b$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $97ecbd121be4860b$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $97ecbd121be4860b$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
function $97ecbd121be4860b$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = "r" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($97ecbd121be4860b$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $97ecbd121be4860b$var$EPSILON = Number.EPSILON || 1e-14;
const $97ecbd121be4860b$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $97ecbd121be4860b$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $97ecbd121be4860b$export$1a8f5705751d8277(firstPoint, middlePoint, afterPoint, t) {
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $97ecbd121be4860b$export$53a70dd1ebbae346(current, previous);
    const d12 = $97ecbd121be4860b$export$53a70dd1ebbae346(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01;
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
function $97ecbd121be4860b$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $97ecbd121be4860b$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $97ecbd121be4860b$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($97ecbd121be4860b$export$23ebac1979863676(deltaK[i], 0, $97ecbd121be4860b$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $97ecbd121be4860b$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $97ecbd121be4860b$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $97ecbd121be4860b$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $97ecbd121be4860b$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
function $97ecbd121be4860b$export$e171bab687b50e0(points, indexAxis = "x") {
    const valueAxis = $97ecbd121be4860b$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    let i, pointBefore, pointCurrent;
    let pointAfter = $97ecbd121be4860b$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $97ecbd121be4860b$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $97ecbd121be4860b$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $97ecbd121be4860b$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $97ecbd121be4860b$var$monotoneAdjust(points, deltaK, mK);
    $97ecbd121be4860b$var$monotoneCompute(points, mK, indexAxis);
}
function $97ecbd121be4860b$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $97ecbd121be4860b$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $97ecbd121be4860b$export$3d8c2f653ac9d0b9(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $97ecbd121be4860b$export$3d8c2f653ac9d0b9(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $97ecbd121be4860b$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $97ecbd121be4860b$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $97ecbd121be4860b$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $97ecbd121be4860b$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
function $97ecbd121be4860b$export$1a82df3d29112e01(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $97ecbd121be4860b$export$e171bab687b50e0(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $97ecbd121be4860b$export$1a8f5705751d8277(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $97ecbd121be4860b$var$capBezierPoints(points, area);
}
function $97ecbd121be4860b$export$2e2af4578d910ddf() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function $97ecbd121be4860b$export$ce26c07117d59d6a(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
function $97ecbd121be4860b$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $97ecbd121be4860b$var$getComputedStyle = (element)=>window.getComputedStyle(element, null);
function $97ecbd121be4860b$export$527e9aa3390079e9(el, property) {
    return $97ecbd121be4860b$var$getComputedStyle(el).getPropertyValue(property);
}
const $97ecbd121be4860b$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $97ecbd121be4860b$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $97ecbd121be4860b$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $97ecbd121be4860b$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
function $97ecbd121be4860b$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($97ecbd121be4860b$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
function $97ecbd121be4860b$export$78acf4525d8a74c4(evt, chart) {
    if ("native" in evt) return evt;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $97ecbd121be4860b$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $97ecbd121be4860b$var$getPositionedStyle(style, "padding");
    const borders = $97ecbd121be4860b$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $97ecbd121be4860b$var$getCanvasPosition(evt, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $97ecbd121be4860b$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $97ecbd121be4860b$export$ce26c07117d59d6a(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect();
            const containerStyle = $97ecbd121be4860b$var$getComputedStyle(container);
            const containerBorder = $97ecbd121be4860b$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $97ecbd121be4860b$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $97ecbd121be4860b$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $97ecbd121be4860b$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $97ecbd121be4860b$export$d29e374196577086,
        maxHeight: maxHeight || $97ecbd121be4860b$export$d29e374196577086
    };
}
const $97ecbd121be4860b$var$round1 = (v)=>Math.round(v * 10) / 10;
function $97ecbd121be4860b$export$3c2fa207a37baaea(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $97ecbd121be4860b$var$getComputedStyle(canvas);
    const margins = $97ecbd121be4860b$var$getPositionedStyle(style, "margin");
    const maxWidth = $97ecbd121be4860b$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $97ecbd121be4860b$export$d29e374196577086;
    const maxHeight = $97ecbd121be4860b$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $97ecbd121be4860b$export$d29e374196577086;
    const containerSize = $97ecbd121be4860b$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $97ecbd121be4860b$var$getPositionedStyle(style, "border", "width");
        const paddings = $97ecbd121be4860b$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
    width = $97ecbd121be4860b$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $97ecbd121be4860b$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) height = $97ecbd121be4860b$var$round1(width / 2);
    return {
        width: width,
        height: height
    };
}
function $97ecbd121be4860b$export$c9170ad7d4cd7e57(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = deviceHeight / pixelRatio;
    chart.width = deviceWidth / pixelRatio;
    const canvas = chart.canvas;
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
const $97ecbd121be4860b$export$a8550f7dbe79f93a = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch (e) {}
    return passiveSupported;
}();
function $97ecbd121be4860b$export$6559d589eb85fbb6(element, property) {
    const value = $97ecbd121be4860b$export$527e9aa3390079e9(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
function $97ecbd121be4860b$export$d24c54395ce0c509(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
function $97ecbd121be4860b$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
function $97ecbd121be4860b$export$8a5498727ef6be21(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $97ecbd121be4860b$export$d24c54395ce0c509(p1, cp1, t);
    const b = $97ecbd121be4860b$export$d24c54395ce0c509(cp1, cp2, t);
    const c = $97ecbd121be4860b$export$d24c54395ce0c509(cp2, p2, t);
    const d = $97ecbd121be4860b$export$d24c54395ce0c509(a, b, t);
    const e = $97ecbd121be4860b$export$d24c54395ce0c509(b, c, t);
    return $97ecbd121be4860b$export$d24c54395ce0c509(d, e, t);
}
const $97ecbd121be4860b$var$intlCache = new Map();
function $97ecbd121be4860b$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $97ecbd121be4860b$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $97ecbd121be4860b$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $97ecbd121be4860b$export$ae1af26003f05816(num, locale, options) {
    return $97ecbd121be4860b$var$getNumberFormat(locale, options).format(num);
}
const $97ecbd121be4860b$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $97ecbd121be4860b$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $97ecbd121be4860b$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $97ecbd121be4860b$var$getRightToLeftAdapter(rectX, width) : $97ecbd121be4860b$var$getLeftToRightAdapter();
}
function $97ecbd121be4860b$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $97ecbd121be4860b$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $97ecbd121be4860b$var$propertyFn(property) {
    if (property === "angle") return {
        between: $97ecbd121be4860b$export$ffb5f4729a158638,
        compare: $97ecbd121be4860b$export$7a0bdf7d4a91ea88,
        normalize: $97ecbd121be4860b$export$3d12bd131bb975d1
    };
    return {
        between: $97ecbd121be4860b$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $97ecbd121be4860b$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $97ecbd121be4860b$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $97ecbd121be4860b$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $97ecbd121be4860b$export$28f7fcd39efa255(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $97ecbd121be4860b$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $97ecbd121be4860b$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($97ecbd121be4860b$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($97ecbd121be4860b$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $97ecbd121be4860b$export$7a38258bbe170828(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $97ecbd121be4860b$export$28f7fcd39efa255(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $97ecbd121be4860b$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $97ecbd121be4860b$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $97ecbd121be4860b$export$306ddfe3a8403e2(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $97ecbd121be4860b$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $97ecbd121be4860b$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $97ecbd121be4860b$var$splitByStyles(line, $97ecbd121be4860b$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $97ecbd121be4860b$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $97ecbd121be4860b$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $97ecbd121be4860b$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $97ecbd121be4860b$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $97ecbd121be4860b$var$readStyle(segmentOptions.setContext($97ecbd121be4860b$export$dda1d9f60106f0e9(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($97ecbd121be4860b$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $97ecbd121be4860b$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $97ecbd121be4860b$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}


class $1af551c56cb88ebf$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $97ecbd121be4860b$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $1af551c56cb88ebf$export$a424a0aa8f687495 = new $1af551c56cb88ebf$var$Animator();
const $1af551c56cb88ebf$var$transparent = "transparent";
const $1af551c56cb88ebf$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $97ecbd121be4860b$export$db3b6bfb95261072)(from || $1af551c56cb88ebf$var$transparent);
        const c1 = c0.valid && (0, $97ecbd121be4860b$export$db3b6bfb95261072)(to || $1af551c56cb88ebf$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $1af551c56cb88ebf$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $97ecbd121be4860b$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $97ecbd121be4860b$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $1af551c56cb88ebf$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $97ecbd121be4860b$export$f1e1789686576879)[cfg.easing] || (0, $97ecbd121be4860b$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $97ecbd121be4860b$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $97ecbd121be4860b$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
const $1af551c56cb88ebf$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $1af551c56cb88ebf$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
(0, $97ecbd121be4860b$export$4368d992c4eafac0).set("animation", {
    delay: undefined,
    duration: 1000,
    easing: "easeOutQuart",
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
});
const $1af551c56cb88ebf$var$animationOptions = Object.keys((0, $97ecbd121be4860b$export$4368d992c4eafac0).animation);
(0, $97ecbd121be4860b$export$4368d992c4eafac0).describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
});
(0, $97ecbd121be4860b$export$4368d992c4eafac0).set("animations", {
    colors: {
        type: "color",
        properties: $1af551c56cb88ebf$var$colors
    },
    numbers: {
        type: "number",
        properties: $1af551c56cb88ebf$var$numbers
    }
});
(0, $97ecbd121be4860b$export$4368d992c4eafac0).describe("animations", {
    _fallback: "animation"
});
(0, $97ecbd121be4860b$export$4368d992c4eafac0).set("transitions", {
    active: {
        animation: {
            duration: 400
        }
    },
    resize: {
        animation: {
            duration: 0
        }
    },
    show: {
        animations: {
            colors: {
                from: "transparent"
            },
            visible: {
                type: "boolean",
                duration: 0
            }
        }
    },
    hide: {
        animations: {
            colors: {
                to: "transparent"
            },
            visible: {
                type: "boolean",
                easing: "linear",
                fn: (v)=>v | 0
            }
        }
    }
});
class $1af551c56cb88ebf$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $97ecbd121be4860b$export$23f2a1d2818174ef)(config)) return;
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $97ecbd121be4860b$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of $1af551c56cb88ebf$var$animationOptions)resolved[option] = cfg[option];
            ((0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $1af551c56cb88ebf$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $1af551c56cb88ebf$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $1af551c56cb88ebf$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $1af551c56cb88ebf$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $1af551c56cb88ebf$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $1af551c56cb88ebf$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $1af551c56cb88ebf$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $1af551c56cb88ebf$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $1af551c56cb88ebf$var$scaleClip(xScale, allowedOverflow);
    const y = $1af551c56cb88ebf$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $1af551c56cb88ebf$var$toClip(value) {
    let t, r, b, l;
    if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $1af551c56cb88ebf$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $1af551c56cb88ebf$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $97ecbd121be4860b$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $97ecbd121be4860b$export$2408f22a0fab9ae5)(value) === (0, $97ecbd121be4860b$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    return value;
}
function $1af551c56cb88ebf$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $1af551c56cb88ebf$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $1af551c56cb88ebf$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $1af551c56cb88ebf$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $1af551c56cb88ebf$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $1af551c56cb88ebf$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $1af551c56cb88ebf$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $1af551c56cb88ebf$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $1af551c56cb88ebf$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $1af551c56cb88ebf$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $1af551c56cb88ebf$var$getLastIndexInStack(stack, vScale, false, meta.type);
    }
}
function $1af551c56cb88ebf$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $1af551c56cb88ebf$var$createDatasetContext(parent, index) {
    return (0, $97ecbd121be4860b$export$dda1d9f60106f0e9)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $1af551c56cb88ebf$var$createDataContext(parent, index, element) {
    return (0, $97ecbd121be4860b$export$dda1d9f60106f0e9)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $1af551c56cb88ebf$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
    }
}
const $1af551c56cb88ebf$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $1af551c56cb88ebf$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $1af551c56cb88ebf$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $1af551c56cb88ebf$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $1af551c56cb88ebf$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $1af551c56cb88ebf$var$isStacked(meta.vScale, meta);
        this.addElements();
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $1af551c56cb88ebf$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(dataset.xAxisID, $1af551c56cb88ebf$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(dataset.yAxisID, $1af551c56cb88ebf$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(dataset.rAxisID, $1af551c56cb88ebf$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $97ecbd121be4860b$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $1af551c56cb88ebf$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(data)) this._data = $1af551c56cb88ebf$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $97ecbd121be4860b$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $1af551c56cb88ebf$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $97ecbd121be4860b$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $1af551c56cb88ebf$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $1af551c56cb88ebf$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $1af551c56cb88ebf$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $1af551c56cb88ebf$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $97ecbd121be4860b$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $97ecbd121be4860b$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $1af551c56cb88ebf$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]
        };
        return $1af551c56cb88ebf$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $1af551c56cb88ebf$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $1af551c56cb88ebf$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $1af551c56cb88ebf$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $97ecbd121be4860b$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $97ecbd121be4860b$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $1af551c56cb88ebf$var$toClip((0, $97ecbd121be4860b$export$90a7f3efeed30595)(this.options.clip, $1af551c56cb88ebf$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $1af551c56cb88ebf$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $1af551c56cb88ebf$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $97ecbd121be4860b$export$35e795649ee09318)(index);
        if (cached) return $1af551c56cb88ebf$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $97ecbd121be4860b$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($1af551c56cb88ebf$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $1af551c56cb88ebf$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $1af551c56cb88ebf$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($1af551c56cb88ebf$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$1af551c56cb88ebf$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $1af551c56cb88ebf$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
$1af551c56cb88ebf$export$75572ec5c55b4048.defaults = {};
$1af551c56cb88ebf$export$75572ec5c55b4048.prototype.datasetElementType = null;
$1af551c56cb88ebf$export$75572ec5c55b4048.prototype.dataElementType = null;
function $1af551c56cb88ebf$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $97ecbd121be4860b$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $1af551c56cb88ebf$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $1af551c56cb88ebf$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $97ecbd121be4860b$export$35e795649ee09318)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $1af551c56cb88ebf$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $97ecbd121be4860b$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $1af551c56cb88ebf$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $1af551c56cb88ebf$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $1af551c56cb88ebf$var$parseValue(entry, item, vScale, i) {
    if ((0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(entry)) $1af551c56cb88ebf$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $1af551c56cb88ebf$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($1af551c56cb88ebf$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $1af551c56cb88ebf$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $1af551c56cb88ebf$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $97ecbd121be4860b$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $1af551c56cb88ebf$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $1af551c56cb88ebf$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $1af551c56cb88ebf$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$1af551c56cb88ebf$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$1af551c56cb88ebf$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $1af551c56cb88ebf$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $1af551c56cb88ebf$var$swap(edge, a, b);
        edge = $1af551c56cb88ebf$var$startEnd(edge, b, a);
    } else edge = $1af551c56cb88ebf$var$startEnd(edge, a, b);
    return edge;
}
function $1af551c56cb88ebf$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $1af551c56cb88ebf$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $1af551c56cb88ebf$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $1af551c56cb88ebf$export$e97d5dc64e999004 extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $1af551c56cb88ebf$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $1af551c56cb88ebf$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $97ecbd121be4860b$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($1af551c56cb88ebf$var$parseValue((0, $97ecbd121be4860b$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $1af551c56cb88ebf$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $97ecbd121be4860b$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $1af551c56cb88ebf$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $1af551c56cb88ebf$var$setBorderSkipped(properties, options, stack, index);
            $1af551c56cb88ebf$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $97ecbd121be4860b$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $1af551c56cb88ebf$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $1af551c56cb88ebf$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $97ecbd121be4860b$export$2408f22a0fab9ae5)(value) !== (0, $97ecbd121be4860b$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $97ecbd121be4860b$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $1af551c56cb88ebf$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $97ecbd121be4860b$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $1af551c56cb88ebf$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $1af551c56cb88ebf$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
$1af551c56cb88ebf$export$e97d5dc64e999004.id = "bar";
$1af551c56cb88ebf$export$e97d5dc64e999004.defaults = {
    datasetElementType: false,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "base",
                "width",
                "height"
            ]
        }
    }
};
$1af551c56cb88ebf$export$e97d5dc64e999004.overrides = {
    scales: {
        _index_: {
            type: "category",
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: "linear",
            beginAtZero: true
        }
    }
};
class $1af551c56cb88ebf$export$19b5c4773f17abe extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: meta.label,
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $97ecbd121be4860b$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
$1af551c56cb88ebf$export$19b5c4773f17abe.id = "bubble";
$1af551c56cb88ebf$export$19b5c4773f17abe.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius"
            ]
        }
    }
};
$1af551c56cb88ebf$export$19b5c4773f17abe.overrides = {
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                }
            }
        }
    }
};
function $1af551c56cb88ebf$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $97ecbd121be4860b$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $97ecbd121be4860b$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $97ecbd121be4860b$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $97ecbd121be4860b$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $97ecbd121be4860b$export$56c0d5a1e737357d) + (0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $1af551c56cb88ebf$export$e04603e7d8b77172 extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = "value" } = this._parsing;
                getter = (i)=>+(0, $97ecbd121be4860b$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $97ecbd121be4860b$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $97ecbd121be4860b$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $97ecbd121be4860b$export$971d5caa766a69d7);
        let max = -(0, $97ecbd121be4860b$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i)) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $97ecbd121be4860b$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $1af551c56cb88ebf$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $97ecbd121be4860b$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $97ecbd121be4860b$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $97ecbd121be4860b$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $97ecbd121be4860b$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $97ecbd121be4860b$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
$1af551c56cb88ebf$export$e04603e7d8b77172.id = "doughnut";
$1af551c56cb88ebf$export$e04603e7d8b77172.defaults = {
    datasetElementType: false,
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing"
            ]
        }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
};
$1af551c56cb88ebf$export$e04603e7d8b77172.descriptors = {
    _scriptable: (name)=>name !== "spacing",
    _indexable: (name)=>name !== "spacing"
};
$1af551c56cb88ebf$export$e04603e7d8b77172.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (tooltipItem) {
                    let dataLabel = tooltipItem.label;
                    const value = ": " + tooltipItem.formattedValue;
                    if ((0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    }
};
class $1af551c56cb88ebf$export$3c9b5d28c11cbfd0 extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $97ecbd121be4860b$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $97ecbd121be4860b$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $97ecbd121be4860b$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $97ecbd121be4860b$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
$1af551c56cb88ebf$export$3c9b5d28c11cbfd0.id = "line";
$1af551c56cb88ebf$export$3c9b5d28c11cbfd0.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
};
$1af551c56cb88ebf$export$3c9b5d28c11cbfd0.overrides = {
    scales: {
        _index_: {
            type: "category"
        },
        _value_: {
            type: "linear"
        }
    }
};
class $1af551c56cb88ebf$export$2a270b3a0d973c85 extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $97ecbd121be4860b$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $97ecbd121be4860b$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $97ecbd121be4860b$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $97ecbd121be4860b$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
$1af551c56cb88ebf$export$2a270b3a0d973c85.id = "polarArea";
$1af551c56cb88ebf$export$2a270b3a0d973c85.defaults = {
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius"
            ]
        }
    },
    indexAxis: "r",
    startAngle: 0
};
$1af551c56cb88ebf$export$2a270b3a0d973c85.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (context) {
                    return context.chart.data.labels[context.dataIndex] + ": " + context.formattedValue;
                }
            }
        }
    },
    scales: {
        r: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
};
class $1af551c56cb88ebf$export$b21a3f1286706191 extends $1af551c56cb88ebf$export$e04603e7d8b77172 {
}
$1af551c56cb88ebf$export$b21a3f1286706191.id = "pie";
$1af551c56cb88ebf$export$b21a3f1286706191.defaults = {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: "100%"
};
class $1af551c56cb88ebf$export$48dbc6ac651bf8be extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $97ecbd121be4860b$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
$1af551c56cb88ebf$export$48dbc6ac651bf8be.id = "radar";
$1af551c56cb88ebf$export$48dbc6ac651bf8be.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    indexAxis: "r",
    showLine: true,
    elements: {
        line: {
            fill: "start"
        }
    }
};
$1af551c56cb88ebf$export$48dbc6ac651bf8be.overrides = {
    aspectRatio: 1,
    scales: {
        r: {
            type: "radialLinear"
        }
    }
};
class $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(){
        this.x = undefined;
        this.y = undefined;
        this.active = false;
        this.options = undefined;
        this.$animations = undefined;
    }
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $97ecbd121be4860b$export$d141bba7fdc215a3)(this.x) && (0, $97ecbd121be4860b$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
$1af551c56cb88ebf$export$db77ccec0bb4ccac.defaults = {};
$1af551c56cb88ebf$export$db77ccec0bb4ccac.defaultRoutes = undefined;
const $1af551c56cb88ebf$var$formatters = {
    values (value) {
        return (0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $1af551c56cb88ebf$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = (0, $97ecbd121be4860b$export$df995fae86a55f06)(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return (0, $97ecbd121be4860b$export$ae1af26003f05816)(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = tickValue / Math.pow(10, Math.floor((0, $97ecbd121be4860b$export$df995fae86a55f06)(tickValue)));
        if (remain === 1 || remain === 2 || remain === 5) return $1af551c56cb88ebf$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $1af551c56cb88ebf$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $1af551c56cb88ebf$export$27c7467594ef87bd = {
    formatters: $1af551c56cb88ebf$var$formatters
};
(0, $97ecbd121be4860b$export$4368d992c4eafac0).set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    grace: 0,
    grid: {
        display: true,
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickLength: 8,
        tickWidth: (_ctx, options)=>options.lineWidth,
        tickColor: (_ctx, options)=>options.color,
        offset: false,
        borderDash: [],
        borderDashOffset: 0.0,
        borderWidth: 1
    },
    title: {
        display: false,
        text: "",
        padding: {
            top: 4,
            bottom: 4
        }
    },
    ticks: {
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        textStrokeWidth: 0,
        textStrokeColor: "",
        padding: 3,
        display: true,
        autoSkip: true,
        autoSkipPadding: 3,
        labelOffset: 0,
        callback: $1af551c56cb88ebf$export$27c7467594ef87bd.formatters.values,
        minor: {},
        major: {},
        align: "center",
        crossAlign: "near",
        showLabelBackdrop: false,
        backdropColor: "rgba(255, 255, 255, 0.75)",
        backdropPadding: 2
    }
});
(0, $97ecbd121be4860b$export$4368d992c4eafac0).route("scale.ticks", "color", "", "color");
(0, $97ecbd121be4860b$export$4368d992c4eafac0).route("scale.grid", "color", "", "borderColor");
(0, $97ecbd121be4860b$export$4368d992c4eafac0).route("scale.grid", "borderColor", "", "borderColor");
(0, $97ecbd121be4860b$export$4368d992c4eafac0).route("scale.title", "color", "", "color");
(0, $97ecbd121be4860b$export$4368d992c4eafac0).describe("scale", {
    _fallback: false,
    _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash"
});
(0, $97ecbd121be4860b$export$4368d992c4eafac0).describe("scales", {
    _fallback: "scale"
});
(0, $97ecbd121be4860b$export$4368d992c4eafac0).describe("scale.ticks", {
    _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
    _indexable: (name)=>name !== "backdropPadding"
});
function $1af551c56cb88ebf$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const ticksLimit = tickOpts.maxTicksLimit || $1af551c56cb88ebf$var$determineMaxTicks(scale);
    const majorIndices = tickOpts.major.enabled ? $1af551c56cb88ebf$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $1af551c56cb88ebf$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $1af551c56cb88ebf$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $1af551c56cb88ebf$var$skip(ticks, newTicks, spacing, (0, $97ecbd121be4860b$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$1af551c56cb88ebf$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $1af551c56cb88ebf$var$skip(ticks, newTicks, spacing, last, (0, $97ecbd121be4860b$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $1af551c56cb88ebf$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $1af551c56cb88ebf$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $1af551c56cb88ebf$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $1af551c56cb88ebf$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $97ecbd121be4860b$export$ebd11618f299a286)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $1af551c56cb88ebf$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $1af551c56cb88ebf$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $1af551c56cb88ebf$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $97ecbd121be4860b$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $1af551c56cb88ebf$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $1af551c56cb88ebf$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $1af551c56cb88ebf$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
function $1af551c56cb88ebf$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $1af551c56cb88ebf$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $1af551c56cb88ebf$var$garbageCollect(caches, length) {
    (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $1af551c56cb88ebf$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $1af551c56cb88ebf$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(options.font, fallback);
    const padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(options.padding);
    const lines = (0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $1af551c56cb88ebf$var$createScaleContext(parent, scale) {
    return (0, $97ecbd121be4860b$export$dda1d9f60106f0e9)(parent, {
        scale: scale,
        type: "scale"
    });
}
function $1af551c56cb88ebf$var$createTickContext(parent, index, tick) {
    return (0, $97ecbd121be4860b$export$dda1d9f60106f0e9)(parent, {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $1af551c56cb88ebf$var$titleAlign(align, position, reverse) {
    let ret = (0, $97ecbd121be4860b$export$db202ddc8be9136)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $1af551c56cb88ebf$var$reverseAlign(ret);
    return ret;
}
function $1af551c56cb88ebf$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, left, right);
        if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $1af551c56cb88ebf$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $1af551c56cb88ebf$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, bottom, top);
        rotation = position === "left" ? -(0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd) : (0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $1af551c56cb88ebf$export$d60cfc58d3c358b6 extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $97ecbd121be4860b$export$ef35774e6d314e91)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $97ecbd121be4860b$export$ef35774e6d314e91)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $97ecbd121be4860b$export$ef35774e6d314e91)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $97ecbd121be4860b$export$ef35774e6d314e91)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $97ecbd121be4860b$export$ef35774e6d314e91)(_userMin, _suggestedMin),
            max: (0, $97ecbd121be4860b$export$ef35774e6d314e91)(_userMax, _suggestedMax),
            minDefined: (0, $97ecbd121be4860b$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $97ecbd121be4860b$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $97ecbd121be4860b$export$ef35774e6d314e91)(min, (0, $97ecbd121be4860b$export$ef35774e6d314e91)(max, min)),
            max: (0, $97ecbd121be4860b$export$ef35774e6d314e91)(max, (0, $97ecbd121be4860b$export$ef35774e6d314e91)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $97ecbd121be4860b$export$96f57966bedc81b4)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $1af551c56cb88ebf$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $1af551c56cb88ebf$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $97ecbd121be4860b$export$e7094788287c5e9b)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = this.ticks.length;
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $1af551c56cb88ebf$var$getTickMarkLength(options.grid) - tickOpts.padding - $1af551c56cb88ebf$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $97ecbd121be4860b$export$d66501df72047452)(Math.min(Math.asin((0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $1af551c56cb88ebf$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $1af551c56cb88ebf$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $1af551c56cb88ebf$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $97ecbd121be4860b$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $97ecbd121be4860b$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $1af551c56cb88ebf$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $97ecbd121be4860b$export$342063e11d6c3cad)(label) && !(0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(label)) {
                width = (0, $97ecbd121be4860b$export$2329c99376c9d0a4)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $97ecbd121be4860b$export$342063e11d6c3cad)(nestedLabel) && !(0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $97ecbd121be4860b$export$2329c99376c9d0a4)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $1af551c56cb88ebf$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $97ecbd121be4860b$export$9bb611d729802a56)(this._alignToPixels ? (0, $97ecbd121be4860b$export$b4171a6734a65d42)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $1af551c56cb88ebf$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $1af551c56cb88ebf$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $97ecbd121be4860b$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $1af551c56cb88ebf$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $97ecbd121be4860b$export$b4171a6734a65d42)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const optsAtIndex = grid.setContext(this.getContext(i));
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndex.borderDash || [];
            const borderDashOffset = optsAtIndex.borderDashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $1af551c56cb88ebf$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $97ecbd121be4860b$export$b4171a6734a65d42)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $1af551c56cb88ebf$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $97ecbd121be4860b$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = y + textOffset - labelPadding.top;
                let left = x - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                rotation: rotation,
                label: label,
                font: font,
                color: color,
                strokeColor: strokeColor,
                strokeWidth: strokeWidth,
                textOffset: textOffset,
                textAlign: tickTextAlign,
                textBaseline: textBaseline,
                translation: [
                    x,
                    y
                ],
                backdrop: backdrop
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $97ecbd121be4860b$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { grid: grid } } = this;
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $97ecbd121be4860b$export$b4171a6734a65d42)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $97ecbd121be4860b$export$b4171a6734a65d42)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $97ecbd121be4860b$export$b4171a6734a65d42)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $97ecbd121be4860b$export$b4171a6734a65d42)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.borderWidth;
        ctx.strokeStyle = borderOpts.borderColor;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $97ecbd121be4860b$export$61196ced6d74a310)(ctx, area);
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        let i, ilen;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            const tickFont = item.font;
            const label = item.label;
            if (item.backdrop) {
                ctx.fillStyle = item.backdrop.color;
                ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
            }
            let y = item.textOffset;
            (0, $97ecbd121be4860b$export$3a1a48c8f6ef640e)(ctx, label, 0, y, tickFont, item);
        }
        if (area) (0, $97ecbd121be4860b$export$a07804094c3ecf2d)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(title.font);
        const padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, $97ecbd121be4860b$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $1af551c56cb88ebf$var$titleArgs(this, offset, position, align);
        (0, $97ecbd121be4860b$export$3a1a48c8f6ef640e)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $1af551c56cb88ebf$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        if (!this._isVisible() || this.draw !== $1af551c56cb88ebf$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: gz + 1,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $97ecbd121be4860b$export$c4ce752e73470fba)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $1af551c56cb88ebf$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($1af551c56cb88ebf$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $1af551c56cb88ebf$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $97ecbd121be4860b$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $97ecbd121be4860b$export$4368d992c4eafac0)[scope]) {
            delete (0, $97ecbd121be4860b$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $97ecbd121be4860b$export$3a6d5c9ae78a2c08)[id];
        }
    }
}
function $1af551c56cb88ebf$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $97ecbd121be4860b$export$e7c866399fa523f5)(Object.create(null), [
        parentScope ? (0, $97ecbd121be4860b$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $97ecbd121be4860b$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $97ecbd121be4860b$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $1af551c56cb88ebf$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $97ecbd121be4860b$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $1af551c56cb88ebf$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $97ecbd121be4860b$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $1af551c56cb88ebf$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $1af551c56cb88ebf$var$Registry {
    constructor(){
        this.controllers = new $1af551c56cb88ebf$var$TypedRegistry($1af551c56cb88ebf$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $1af551c56cb88ebf$var$TypedRegistry($1af551c56cb88ebf$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $1af551c56cb88ebf$var$TypedRegistry(Object, "plugins");
        this.scales = new $1af551c56cb88ebf$var$TypedRegistry($1af551c56cb88ebf$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $97ecbd121be4860b$export$71cec2538cb2c617)(method);
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $1af551c56cb88ebf$export$4bb7493d241fd8a5 = new $1af551c56cb88ebf$var$Registry();
class $1af551c56cb88ebf$export$b2f2bae6713db87 extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $97ecbd121be4860b$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $97ecbd121be4860b$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = $1af551c56cb88ebf$export$4bb7493d241fd8a5.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $97ecbd121be4860b$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $97ecbd121be4860b$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
$1af551c56cb88ebf$export$b2f2bae6713db87.id = "scatter";
$1af551c56cb88ebf$export$b2f2bae6713db87.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    showLine: false,
    fill: false
};
$1af551c56cb88ebf$export$b2f2bae6713db87.overrides = {
    interaction: {
        mode: "point"
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (item) {
                    return "(" + item.label + ", " + item.formattedValue + ")";
                }
            }
        }
    },
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
};
var $1af551c56cb88ebf$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $1af551c56cb88ebf$export$e97d5dc64e999004,
    BubbleController: $1af551c56cb88ebf$export$19b5c4773f17abe,
    DoughnutController: $1af551c56cb88ebf$export$e04603e7d8b77172,
    LineController: $1af551c56cb88ebf$export$3c9b5d28c11cbfd0,
    PolarAreaController: $1af551c56cb88ebf$export$2a270b3a0d973c85,
    PieController: $1af551c56cb88ebf$export$b21a3f1286706191,
    RadarController: $1af551c56cb88ebf$export$48dbc6ac651bf8be,
    ScatterController: $1af551c56cb88ebf$export$b2f2bae6713db87
});
function $1af551c56cb88ebf$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class $1af551c56cb88ebf$var$DateAdapter {
    constructor(options){
        this.options = options || {};
    }
    init(chartOptions) {}
    formats() {
        return $1af551c56cb88ebf$var$abstract();
    }
    parse(value, format) {
        return $1af551c56cb88ebf$var$abstract();
    }
    format(timestamp, format) {
        return $1af551c56cb88ebf$var$abstract();
    }
    add(timestamp, amount, unit) {
        return $1af551c56cb88ebf$var$abstract();
    }
    diff(a, b, unit) {
        return $1af551c56cb88ebf$var$abstract();
    }
    startOf(timestamp, unit, weekday) {
        return $1af551c56cb88ebf$var$abstract();
    }
    endOf(timestamp, unit) {
        return $1af551c56cb88ebf$var$abstract();
    }
}
$1af551c56cb88ebf$var$DateAdapter.override = function(members) {
    Object.assign($1af551c56cb88ebf$var$DateAdapter.prototype, members);
};
var $1af551c56cb88ebf$export$f32766ea09ec8bc4 = {
    _date: $1af551c56cb88ebf$var$DateAdapter
};
function $1af551c56cb88ebf$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $97ecbd121be4860b$export$8743009a87fcb00f) : (0, $97ecbd121be4860b$export$dc98b0b04f4c7758);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $1af551c56cb88ebf$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $1af551c56cb88ebf$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $1af551c56cb88ebf$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $1af551c56cb88ebf$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $97ecbd121be4860b$export$3d8c2f653ac9d0b9)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $1af551c56cb88ebf$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $1af551c56cb88ebf$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle } = (0, $97ecbd121be4860b$export$34aec0b863436764)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $97ecbd121be4860b$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $1af551c56cb88ebf$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $1af551c56cb88ebf$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $1af551c56cb88ebf$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $1af551c56cb88ebf$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $1af551c56cb88ebf$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $1af551c56cb88ebf$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $1af551c56cb88ebf$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $1af551c56cb88ebf$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $1af551c56cb88ebf$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $1af551c56cb88ebf$export$a13296960cae0384 = {
    evaluateInteractionItems: $1af551c56cb88ebf$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $97ecbd121be4860b$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $1af551c56cb88ebf$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $1af551c56cb88ebf$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $97ecbd121be4860b$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $1af551c56cb88ebf$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $1af551c56cb88ebf$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $97ecbd121be4860b$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $1af551c56cb88ebf$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $97ecbd121be4860b$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $1af551c56cb88ebf$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $97ecbd121be4860b$export$78acf4525d8a74c4)(e, chart);
            return $1af551c56cb88ebf$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $97ecbd121be4860b$export$78acf4525d8a74c4)(e, chart);
            return $1af551c56cb88ebf$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $1af551c56cb88ebf$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $1af551c56cb88ebf$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $1af551c56cb88ebf$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$1af551c56cb88ebf$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $1af551c56cb88ebf$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $1af551c56cb88ebf$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $1af551c56cb88ebf$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$1af551c56cb88ebf$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $1af551c56cb88ebf$var$setLayoutDims(layouts, params) {
    const stacks = $1af551c56cb88ebf$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $1af551c56cb88ebf$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $1af551c56cb88ebf$var$wrapBoxes(boxes);
    const fullSize = $1af551c56cb88ebf$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $1af551c56cb88ebf$var$sortByWeight($1af551c56cb88ebf$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $1af551c56cb88ebf$var$sortByWeight($1af551c56cb88ebf$var$filterByPosition(layoutBoxes, "right"));
    const top = $1af551c56cb88ebf$var$sortByWeight($1af551c56cb88ebf$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $1af551c56cb88ebf$var$sortByWeight($1af551c56cb88ebf$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $1af551c56cb88ebf$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $1af551c56cb88ebf$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $1af551c56cb88ebf$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $1af551c56cb88ebf$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $1af551c56cb88ebf$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $1af551c56cb88ebf$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $97ecbd121be4860b$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $1af551c56cb88ebf$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $1af551c56cb88ebf$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $1af551c56cb88ebf$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $1af551c56cb88ebf$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $1af551c56cb88ebf$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $1af551c56cb88ebf$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $1af551c56cb88ebf$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $1af551c56cb88ebf$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $1af551c56cb88ebf$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $1af551c56cb88ebf$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $1af551c56cb88ebf$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $97ecbd121be4860b$export$35e795649ee09318)(stack.start)) y = stack.start;
            if (box.fullSize) $1af551c56cb88ebf$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $1af551c56cb88ebf$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $97ecbd121be4860b$export$35e795649ee09318)(stack.start)) x = stack.start;
            if (box.fullSize) $1af551c56cb88ebf$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $1af551c56cb88ebf$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
(0, $97ecbd121be4860b$export$4368d992c4eafac0).set("layout", {
    autoPadding: true,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
});
var $1af551c56cb88ebf$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $1af551c56cb88ebf$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $1af551c56cb88ebf$var$updateMaxPadding(maxPadding, (0, $97ecbd121be4860b$export$3466f893ebf79586)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $1af551c56cb88ebf$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $1af551c56cb88ebf$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $1af551c56cb88ebf$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($1af551c56cb88ebf$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $1af551c56cb88ebf$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $1af551c56cb88ebf$var$handleMaxPadding(chartArea);
        $1af551c56cb88ebf$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $1af551c56cb88ebf$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $1af551c56cb88ebf$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $1af551c56cb88ebf$export$a40a96b24b46cf35 extends $1af551c56cb88ebf$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $1af551c56cb88ebf$var$EXPANDO_KEY = "$chartjs";
const $1af551c56cb88ebf$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $1af551c56cb88ebf$var$isNullOrEmpty = (value)=>value === null || value === "";
function $1af551c56cb88ebf$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$1af551c56cb88ebf$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($1af551c56cb88ebf$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $97ecbd121be4860b$export$6559d589eb85fbb6)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($1af551c56cb88ebf$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $97ecbd121be4860b$export$6559d589eb85fbb6)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $1af551c56cb88ebf$var$eventListenerOptions = (0, $97ecbd121be4860b$export$a8550f7dbe79f93a) ? {
    passive: true
} : false;
function $1af551c56cb88ebf$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $1af551c56cb88ebf$var$eventListenerOptions);
}
function $1af551c56cb88ebf$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $1af551c56cb88ebf$var$eventListenerOptions);
}
function $1af551c56cb88ebf$var$fromNativeEvent(event, chart) {
    const type = $1af551c56cb88ebf$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $97ecbd121be4860b$export$78acf4525d8a74c4)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $1af551c56cb88ebf$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $1af551c56cb88ebf$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $1af551c56cb88ebf$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$1af551c56cb88ebf$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $1af551c56cb88ebf$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $1af551c56cb88ebf$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$1af551c56cb88ebf$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $1af551c56cb88ebf$var$drpListeningCharts = new Map();
let $1af551c56cb88ebf$var$oldDevicePixelRatio = 0;
function $1af551c56cb88ebf$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $1af551c56cb88ebf$var$oldDevicePixelRatio) return;
    $1af551c56cb88ebf$var$oldDevicePixelRatio = dpr;
    $1af551c56cb88ebf$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $1af551c56cb88ebf$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$1af551c56cb88ebf$var$drpListeningCharts.size) window.addEventListener("resize", $1af551c56cb88ebf$var$onWindowResize);
    $1af551c56cb88ebf$var$drpListeningCharts.set(chart, resize);
}
function $1af551c56cb88ebf$var$unlistenDevicePixelRatioChanges(chart) {
    $1af551c56cb88ebf$var$drpListeningCharts.delete(chart);
    if (!$1af551c56cb88ebf$var$drpListeningCharts.size) window.removeEventListener("resize", $1af551c56cb88ebf$var$onWindowResize);
}
function $1af551c56cb88ebf$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $97ecbd121be4860b$export$ce26c07117d59d6a)(canvas);
    if (!container) return;
    const resize = (0, $97ecbd121be4860b$export$efca4cbe5dd06740)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $1af551c56cb88ebf$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $1af551c56cb88ebf$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $1af551c56cb88ebf$var$unlistenDevicePixelRatioChanges(chart);
}
function $1af551c56cb88ebf$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $97ecbd121be4860b$export$efca4cbe5dd06740)((event)=>{
        if (chart.ctx !== null) listener($1af551c56cb88ebf$var$fromNativeEvent(event, chart));
    }, chart, (args)=>{
        const event = args[0];
        return [
            event,
            event.offsetX,
            event.offsetY
        ];
    });
    $1af551c56cb88ebf$var$addListener(canvas, type, proxy);
    return proxy;
}
class $1af551c56cb88ebf$export$f02da7f882cf6b2e extends $1af551c56cb88ebf$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $1af551c56cb88ebf$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$1af551c56cb88ebf$var$EXPANDO_KEY]) return false;
        const initial = canvas[$1af551c56cb88ebf$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $97ecbd121be4860b$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$1af551c56cb88ebf$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $1af551c56cb88ebf$var$createAttachObserver,
            detach: $1af551c56cb88ebf$var$createDetachObserver,
            resize: $1af551c56cb88ebf$var$createResizeObserver
        };
        const handler = handlers[type] || $1af551c56cb88ebf$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $1af551c56cb88ebf$var$releaseObserver,
            detach: $1af551c56cb88ebf$var$releaseObserver,
            resize: $1af551c56cb88ebf$var$releaseObserver
        };
        const handler = handlers[type] || $1af551c56cb88ebf$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $97ecbd121be4860b$export$3c2fa207a37baaea)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $97ecbd121be4860b$export$ce26c07117d59d6a)(canvas);
        return !!(container && container.isConnected);
    }
}
function $1af551c56cb88ebf$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $97ecbd121be4860b$export$2e2af4578d910ddf)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $1af551c56cb88ebf$export$a40a96b24b46cf35;
    return $1af551c56cb88ebf$export$f02da7f882cf6b2e;
}
class $1af551c56cb88ebf$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $97ecbd121be4860b$export$e7094788287c5e9b)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $97ecbd121be4860b$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $1af551c56cb88ebf$var$allPlugins(config);
        return options === false && !all ? [] : $1af551c56cb88ebf$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function $1af551c56cb88ebf$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($1af551c56cb88ebf$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($1af551c56cb88ebf$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $1af551c56cb88ebf$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $1af551c56cb88ebf$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $1af551c56cb88ebf$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $1af551c56cb88ebf$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $1af551c56cb88ebf$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $1af551c56cb88ebf$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $97ecbd121be4860b$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $1af551c56cb88ebf$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $1af551c56cb88ebf$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $1af551c56cb88ebf$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $1af551c56cb88ebf$var$determineAxis(id, scaleOptions) {
    if (id === "x" || id === "y") return id;
    return scaleOptions.axis || $1af551c56cb88ebf$var$axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function $1af551c56cb88ebf$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $97ecbd121be4860b$export$3a6d5c9ae78a2c08)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $1af551c56cb88ebf$var$getIndexAxis(config.type, options);
    const firstIDs = Object.create(null);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $97ecbd121be4860b$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $1af551c56cb88ebf$var$determineAxis(id, scaleConf);
        const defaultId = $1af551c56cb88ebf$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        firstIDs[axis] = firstIDs[axis] || id;
        scales[id] = (0, $97ecbd121be4860b$export$2219238a014317b0)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $1af551c56cb88ebf$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $97ecbd121be4860b$export$3a6d5c9ae78a2c08)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $1af551c56cb88ebf$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || firstIDs[axis] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $97ecbd121be4860b$export$2219238a014317b0)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $97ecbd121be4860b$export$2219238a014317b0)(scale, [
            (0, $97ecbd121be4860b$export$4368d992c4eafac0).scales[scale.type],
            (0, $97ecbd121be4860b$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $1af551c56cb88ebf$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $1af551c56cb88ebf$var$mergeScaleConfig(config, options);
}
function $1af551c56cb88ebf$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $1af551c56cb88ebf$var$initConfig(config) {
    config = config || {};
    config.data = $1af551c56cb88ebf$var$initData(config.data);
    $1af551c56cb88ebf$var$initOptions(config);
    return config;
}
const $1af551c56cb88ebf$var$keyCache = new Map();
const $1af551c56cb88ebf$var$keysCached = new Set();
function $1af551c56cb88ebf$var$cachedKeys(cacheKey, generate) {
    let keys = $1af551c56cb88ebf$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $1af551c56cb88ebf$var$keyCache.set(cacheKey, keys);
        $1af551c56cb88ebf$var$keysCached.add(keys);
    }
    return keys;
}
const $1af551c56cb88ebf$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $97ecbd121be4860b$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $1af551c56cb88ebf$var$Config {
    constructor(config){
        this._config = $1af551c56cb88ebf$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $1af551c56cb88ebf$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $1af551c56cb88ebf$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $1af551c56cb88ebf$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $1af551c56cb88ebf$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $1af551c56cb88ebf$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $1af551c56cb88ebf$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$1af551c56cb88ebf$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$1af551c56cb88ebf$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$1af551c56cb88ebf$var$addIfFound(scopes, (0, $97ecbd121be4860b$export$3a6d5c9ae78a2c08)[type] || {}, key));
            keys.forEach((key)=>$1af551c56cb88ebf$var$addIfFound(scopes, (0, $97ecbd121be4860b$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$1af551c56cb88ebf$var$addIfFound(scopes, (0, $97ecbd121be4860b$export$a93c5207d687da10), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($1af551c56cb88ebf$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $97ecbd121be4860b$export$3a6d5c9ae78a2c08)[type] || {},
            (0, $97ecbd121be4860b$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $97ecbd121be4860b$export$4368d992c4eafac0),
            (0, $97ecbd121be4860b$export$a93c5207d687da10)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $1af551c56cb88ebf$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($1af551c56cb88ebf$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $97ecbd121be4860b$export$c3950d9923825c02)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $97ecbd121be4860b$export$a9c996f45e5784d0)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $1af551c56cb88ebf$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $97ecbd121be4860b$export$23f2a1d2818174ef)(context) ? (0, $97ecbd121be4860b$export$a9c996f45e5784d0)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $1af551c56cb88ebf$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $97ecbd121be4860b$export$7910e0436ed8d1de)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $1af551c56cb88ebf$var$hasFunction = (value)=>(0, $97ecbd121be4860b$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).reduce((acc, key)=>acc || (0, $97ecbd121be4860b$export$c3950d9923825c02)(value[key]), false);
function $1af551c56cb88ebf$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $97ecbd121be4860b$export$555508cbc6add439)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $97ecbd121be4860b$export$c3950d9923825c02)(value) || $1af551c56cb88ebf$var$hasFunction(value)) || indexable && (0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $1af551c56cb88ebf$var$version = "3.9.1";
const $1af551c56cb88ebf$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $1af551c56cb88ebf$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $1af551c56cb88ebf$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $1af551c56cb88ebf$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $1af551c56cb88ebf$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $97ecbd121be4860b$export$e7094788287c5e9b)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $1af551c56cb88ebf$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $97ecbd121be4860b$export$e7094788287c5e9b)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $1af551c56cb88ebf$var$getCanvas(item) {
    if ((0, $97ecbd121be4860b$export$2e2af4578d910ddf)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $1af551c56cb88ebf$var$instances = {};
const $1af551c56cb88ebf$var$getChart = (key)=>{
    const canvas = $1af551c56cb88ebf$var$getCanvas(key);
    return Object.values($1af551c56cb88ebf$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $1af551c56cb88ebf$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $1af551c56cb88ebf$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
class $1af551c56cb88ebf$export$acaa6426d77a227e {
    constructor(item, userConfig){
        const config = this.config = new $1af551c56cb88ebf$var$Config(userConfig);
        const initialCanvas = $1af551c56cb88ebf$var$getCanvas(item);
        const existingChart = $1af551c56cb88ebf$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $1af551c56cb88ebf$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $97ecbd121be4860b$export$4c3d22f3d993c33f)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $1af551c56cb88ebf$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $97ecbd121be4860b$export$f787f51d84a910ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $1af551c56cb88ebf$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $1af551c56cb88ebf$export$a424a0aa8f687495.listen(this, "complete", $1af551c56cb88ebf$var$onAnimationsComplete);
        $1af551c56cb88ebf$export$a424a0aa8f687495.listen(this, "progress", $1af551c56cb88ebf$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $97ecbd121be4860b$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, $97ecbd121be4860b$export$c9170ad7d4cd7e57)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, $97ecbd121be4860b$export$ee7c8ad385a60b7b)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $1af551c56cb88ebf$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$1af551c56cb88ebf$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $97ecbd121be4860b$export$c9170ad7d4cd7e57)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, $97ecbd121be4860b$export$e7094788287c5e9b)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $1af551c56cb88ebf$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $1af551c56cb88ebf$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $1af551c56cb88ebf$var$positionIsHorizontal(scaleOptions.position, axis) !== $1af551c56cb88ebf$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $1af551c56cb88ebf$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(scales, (scale)=>{
            $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $1af551c56cb88ebf$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($1af551c56cb88ebf$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $1af551c56cb88ebf$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $1af551c56cb88ebf$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $97ecbd121be4860b$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass.prototype, {
                    dataElementType: $1af551c56cb88ebf$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $1af551c56cb88ebf$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($1af551c56cb88ebf$var$compare2Level("z", "_idx"));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(this.scales, (scale)=>{
            $1af551c56cb88ebf$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $97ecbd121be4860b$export$995eb9fca571757)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === "_removeElements" ? -count : count;
            $1af551c56cb88ebf$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $97ecbd121be4860b$export$995eb9fca571757)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $97ecbd121be4860b$export$c3950d9923825c02)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($1af551c56cb88ebf$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$1af551c56cb88ebf$export$a424a0aa8f687495.running(this)) $1af551c56cb88ebf$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $1af551c56cb88ebf$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = this.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $97ecbd121be4860b$export$61196ced6d74a310)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $97ecbd121be4860b$export$a07804094c3ecf2d)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, $97ecbd121be4860b$export$3d8c2f653ac9d0b9)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $1af551c56cb88ebf$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $97ecbd121be4860b$export$dda1d9f60106f0e9)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $97ecbd121be4860b$export$35e795649ee09318)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $1af551c56cb88ebf$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $97ecbd121be4860b$export$ee7c8ad385a60b7b)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        this.notifyPlugins("destroy");
        delete $1af551c56cb88ebf$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $97ecbd121be4860b$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $97ecbd121be4860b$export$3b513254972cfc9c)(e);
        const lastEvent = $1af551c56cb88ebf$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $97ecbd121be4860b$export$e7094788287c5e9b)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $97ecbd121be4860b$export$e7094788287c5e9b)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $97ecbd121be4860b$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
const $1af551c56cb88ebf$var$invalidatePlugins = ()=>(0, $97ecbd121be4860b$export$3722cfe417b6ed86)($1af551c56cb88ebf$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
const $1af551c56cb88ebf$var$enumerable = true;
Object.defineProperties($1af551c56cb88ebf$export$acaa6426d77a227e, {
    defaults: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: (0, $97ecbd121be4860b$export$4368d992c4eafac0)
    },
    instances: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: $1af551c56cb88ebf$var$instances
    },
    overrides: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: (0, $97ecbd121be4860b$export$3a6d5c9ae78a2c08)
    },
    registry: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: $1af551c56cb88ebf$export$4bb7493d241fd8a5
    },
    version: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: $1af551c56cb88ebf$var$version
    },
    getChart: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: $1af551c56cb88ebf$var$getChart
    },
    register: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: (...items)=>{
            $1af551c56cb88ebf$export$4bb7493d241fd8a5.add(...items);
            $1af551c56cb88ebf$var$invalidatePlugins();
        }
    },
    unregister: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: (...items)=>{
            $1af551c56cb88ebf$export$4bb7493d241fd8a5.remove(...items);
            $1af551c56cb88ebf$var$invalidatePlugins();
        }
    }
});
function $1af551c56cb88ebf$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd), startAngle - (0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $1af551c56cb88ebf$var$toRadiusCorners(value) {
    return (0, $97ecbd121be4860b$export$ab83b03e4111b1d0)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
function $1af551c56cb88ebf$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $1af551c56cb88ebf$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(o.innerEnd, 0, innerLimit)
    };
}
function $1af551c56cb88ebf$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
function $1af551c56cb88ebf$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $97ecbd121be4860b$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $1af551c56cb88ebf$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
        if (outerEnd > 0) {
            const pCenter = $1af551c56cb88ebf$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd));
        }
        const p4 = $1af551c56cb88ebf$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        if (innerEnd > 0) {
            const pCenter = $1af551c56cb88ebf$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
        if (innerStart > 0) {
            const pCenter = $1af551c56cb88ebf$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd));
        }
        const p8 = $1af551c56cb88ebf$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        if (outerStart > 0) {
            const pCenter = $1af551c56cb88ebf$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $1af551c56cb88ebf$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $1af551c56cb88ebf$var$pathArc(ctx, element, offset, spacing, startAngle + (0, $97ecbd121be4860b$export$971d5caa766a69d7), circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) {
            endAngle = startAngle + circumference % (0, $97ecbd121be4860b$export$971d5caa766a69d7);
            if (circumference % (0, $97ecbd121be4860b$export$971d5caa766a69d7) === 0) endAngle += (0, $97ecbd121be4860b$export$971d5caa766a69d7);
        }
    }
    $1af551c56cb88ebf$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $1af551c56cb88ebf$var$drawFullCircleBorders(ctx, element, inner) {
    const { x: x, y: y, startAngle: startAngle, pixelMargin: pixelMargin, fullCircles: fullCircles } = element;
    const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
    const innerRadius = element.innerRadius + pixelMargin;
    let i;
    if (inner) $1af551c56cb88ebf$var$clipArc(ctx, element, startAngle + (0, $97ecbd121be4860b$export$971d5caa766a69d7));
    ctx.beginPath();
    ctx.arc(x, y, innerRadius, startAngle + (0, $97ecbd121be4860b$export$971d5caa766a69d7), startAngle, true);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle, startAngle + (0, $97ecbd121be4860b$export$971d5caa766a69d7));
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
}
function $1af551c56cb88ebf$var$drawBorder(ctx, element, offset, spacing, endAngle, circular) {
    const { options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    if (element.fullCircles) $1af551c56cb88ebf$var$drawFullCircleBorders(ctx, element, inner);
    if (inner) $1af551c56cb88ebf$var$clipArc(ctx, element, endAngle);
    $1af551c56cb88ebf$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.stroke();
}
class $1af551c56cb88ebf$export$d48203c759d6a1fc extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $97ecbd121be4860b$export$34aec0b863436764)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const _circumference = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $97ecbd121be4860b$export$971d5caa766a69d7) || (0, $97ecbd121be4860b$export$ffb5f4729a158638)(angle, startAngle, endAngle);
        const withinRadius = (0, $97ecbd121be4860b$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 2;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, $97ecbd121be4860b$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $97ecbd121be4860b$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        let radiusOffset = 0;
        if (offset) {
            radiusOffset = offset / 2;
            const halfAngle = (this.startAngle + this.endAngle) / 2;
            ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
            if (this.circumference >= (0, $97ecbd121be4860b$export$56c0d5a1e737357d)) radiusOffset = offset;
        }
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        const endAngle = $1af551c56cb88ebf$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $1af551c56cb88ebf$var$drawBorder(ctx, this, radiusOffset, spacing, endAngle, circular);
        ctx.restore();
    }
}
$1af551c56cb88ebf$export$d48203c759d6a1fc.id = "arc";
$1af551c56cb88ebf$export$d48203c759d6a1fc.defaults = {
    borderAlign: "center",
    borderColor: "#fff",
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true
};
$1af551c56cb88ebf$export$d48203c759d6a1fc.defaultRoutes = {
    backgroundColor: "backgroundColor"
};
function $1af551c56cb88ebf$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $97ecbd121be4860b$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $1af551c56cb88ebf$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $1af551c56cb88ebf$var$getLineMethod(options) {
    if (options.stepped) return 0, $97ecbd121be4860b$export$6554612db691658e;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $97ecbd121be4860b$export$493d36ec626b6698;
    return $1af551c56cb88ebf$var$lineTo;
}
function $1af551c56cb88ebf$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $1af551c56cb88ebf$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $1af551c56cb88ebf$var$pathVars(points, segment, params);
    const lineMethod = $1af551c56cb88ebf$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $1af551c56cb88ebf$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $1af551c56cb88ebf$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $1af551c56cb88ebf$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $1af551c56cb88ebf$var$fastPathSegment : $1af551c56cb88ebf$var$pathSegment;
}
function $1af551c56cb88ebf$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $97ecbd121be4860b$export$2f6ca3d3b1f80bf5;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $97ecbd121be4860b$export$8a5498727ef6be21;
    return 0, $97ecbd121be4860b$export$d24c54395ce0c509;
}
function $1af551c56cb88ebf$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $1af551c56cb88ebf$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $1af551c56cb88ebf$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $1af551c56cb88ebf$var$_getSegmentMethod(line);
    for (const segment of segments){
        $1af551c56cb88ebf$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $1af551c56cb88ebf$var$usePath2D = typeof Path2D === "function";
function $1af551c56cb88ebf$var$draw(ctx, line, start, count) {
    if ($1af551c56cb88ebf$var$usePath2D && !line.options.segment) $1af551c56cb88ebf$var$strokePathWithCache(ctx, line, start, count);
    else $1af551c56cb88ebf$var$strokePathDirect(ctx, line, start, count);
}
class $1af551c56cb88ebf$export$55e463fa7bcd3469 extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $97ecbd121be4860b$export$1a82df3d29112e01)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $97ecbd121be4860b$export$306ddfe3a8403e2)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $97ecbd121be4860b$export$7a38258bbe170828)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $1af551c56cb88ebf$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $1af551c56cb88ebf$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $1af551c56cb88ebf$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $1af551c56cb88ebf$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
$1af551c56cb88ebf$export$55e463fa7bcd3469.id = "line";
$1af551c56cb88ebf$export$55e463fa7bcd3469.defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
};
$1af551c56cb88ebf$export$55e463fa7bcd3469.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
$1af551c56cb88ebf$export$55e463fa7bcd3469.descriptors = {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash" && name !== "fill"
};
function $1af551c56cb88ebf$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $1af551c56cb88ebf$export$bd159b522b230b7a extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $1af551c56cb88ebf$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $1af551c56cb88ebf$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $97ecbd121be4860b$export$3d8c2f653ac9d0b9)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $97ecbd121be4860b$export$1fbe638ecf81657e)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        return options.radius + options.hitRadius;
    }
}
$1af551c56cb88ebf$export$bd159b522b230b7a.id = "point";
$1af551c56cb88ebf$export$bd159b522b230b7a.defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
};
$1af551c56cb88ebf$export$bd159b522b230b7a.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
function $1af551c56cb88ebf$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $1af551c56cb88ebf$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(value, min, max);
}
function $1af551c56cb88ebf$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $97ecbd121be4860b$export$92108d983e8ee699)(value);
    return {
        t: $1af551c56cb88ebf$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $1af551c56cb88ebf$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $1af551c56cb88ebf$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $1af551c56cb88ebf$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $1af551c56cb88ebf$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $97ecbd121be4860b$export$9fa96a7d116ea3ce)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $97ecbd121be4860b$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $1af551c56cb88ebf$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $1af551c56cb88ebf$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $1af551c56cb88ebf$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $1af551c56cb88ebf$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $1af551c56cb88ebf$var$boundingRects(bar) {
    const bounds = $1af551c56cb88ebf$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $1af551c56cb88ebf$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $1af551c56cb88ebf$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $1af551c56cb88ebf$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $1af551c56cb88ebf$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $97ecbd121be4860b$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $97ecbd121be4860b$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $1af551c56cb88ebf$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $1af551c56cb88ebf$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $1af551c56cb88ebf$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $1af551c56cb88ebf$export$a16ed71bf4b07672 extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $1af551c56cb88ebf$var$boundingRects(this);
        const addRectPath = $1af551c56cb88ebf$var$hasRadius(outer.radius) ? (0, $97ecbd121be4860b$export$d66dc83d8cfc8dd) : $1af551c56cb88ebf$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $1af551c56cb88ebf$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $1af551c56cb88ebf$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $1af551c56cb88ebf$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $1af551c56cb88ebf$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $1af551c56cb88ebf$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $1af551c56cb88ebf$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
$1af551c56cb88ebf$export$a16ed71bf4b07672.id = "bar";
$1af551c56cb88ebf$export$a16ed71bf4b07672.defaults = {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: "auto",
    pointStyle: undefined
};
$1af551c56cb88ebf$export$a16ed71bf4b07672.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
var $1af551c56cb88ebf$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $1af551c56cb88ebf$export$d48203c759d6a1fc,
    LineElement: $1af551c56cb88ebf$export$55e463fa7bcd3469,
    PointElement: $1af551c56cb88ebf$export$bd159b522b230b7a,
    BarElement: $1af551c56cb88ebf$export$a16ed71bf4b07672
});
function $1af551c56cb88ebf$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $1af551c56cb88ebf$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $97ecbd121be4860b$export$342063e11d6c3cad)(minIndex) && !(0, $97ecbd121be4860b$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $1af551c56cb88ebf$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            value: data
        });
    }
}
function $1af551c56cb88ebf$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $1af551c56cb88ebf$var$cleanDecimatedDataset(dataset);
    });
}
function $1af551c56cb88ebf$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)((0, $97ecbd121be4860b$export$dc98b0b04f4c7758)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)((0, $97ecbd121be4860b$export$dc98b0b04f4c7758)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $1af551c56cb88ebf$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $1af551c56cb88ebf$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $97ecbd121be4860b$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $1af551c56cb88ebf$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $1af551c56cb88ebf$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $97ecbd121be4860b$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $1af551c56cb88ebf$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $1af551c56cb88ebf$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $1af551c56cb88ebf$var$cleanDecimatedData(chart);
    }
};
function $1af551c56cb88ebf$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $1af551c56cb88ebf$var$_findSegmentEnd(start, end, points);
        const bounds = $1af551c56cb88ebf$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $97ecbd121be4860b$export$7a38258bbe170828)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $1af551c56cb88ebf$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $97ecbd121be4860b$export$28f7fcd39efa255)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $1af551c56cb88ebf$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $1af551c56cb88ebf$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $1af551c56cb88ebf$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $97ecbd121be4860b$export$3d12bd131bb975d1)(start);
        end = (0, $97ecbd121be4860b$export$3d12bd131bb975d1)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $1af551c56cb88ebf$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $1af551c56cb88ebf$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $1af551c56cb88ebf$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $1af551c56cb88ebf$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $1af551c56cb88ebf$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $1af551c56cb88ebf$var$_pointsFromSegments(boundary, line);
    return points.length ? new $1af551c56cb88ebf$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $1af551c56cb88ebf$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $1af551c56cb88ebf$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $97ecbd121be4860b$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $1af551c56cb88ebf$var$_decodeFill(line, index, count) {
    const fill = $1af551c56cb88ebf$var$parseFillOption(line);
    if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $97ecbd121be4860b$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $1af551c56cb88ebf$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function $1af551c56cb88ebf$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $1af551c56cb88ebf$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $1af551c56cb88ebf$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $97ecbd121be4860b$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $1af551c56cb88ebf$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $1af551c56cb88ebf$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $1af551c56cb88ebf$var$getLinesBelow(scale, index);
    linesBelow.push($1af551c56cb88ebf$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$1af551c56cb88ebf$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $1af551c56cb88ebf$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $1af551c56cb88ebf$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $1af551c56cb88ebf$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $1af551c56cb88ebf$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $1af551c56cb88ebf$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $97ecbd121be4860b$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $1af551c56cb88ebf$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $97ecbd121be4860b$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $1af551c56cb88ebf$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $97ecbd121be4860b$export$39b482c5e57630a8)(fill)) return $1af551c56cb88ebf$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $1af551c56cb88ebf$var$_buildStackLine(source);
    if (fill === "shape") return true;
    const boundary = $1af551c56cb88ebf$var$computeBoundary(source);
    if (boundary instanceof $1af551c56cb88ebf$var$simpleArc) return boundary;
    return $1af551c56cb88ebf$var$_createBoundaryLine(boundary, line);
}
function $1af551c56cb88ebf$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $1af551c56cb88ebf$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $1af551c56cb88ebf$var$computeCircularBoundary(source);
    return $1af551c56cb88ebf$var$computeLinearBoundary(source);
}
function $1af551c56cb88ebf$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $1af551c56cb88ebf$var$_getTargetPixel(fill, scale);
    if ((0, $97ecbd121be4860b$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $1af551c56cb88ebf$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $1af551c56cb88ebf$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $1af551c56cb88ebf$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $1af551c56cb88ebf$var$_drawfill(ctx, source, area) {
    const target = $1af551c56cb88ebf$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $97ecbd121be4860b$export$61196ced6d74a310)(ctx, area);
        $1af551c56cb88ebf$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $97ecbd121be4860b$export$a07804094c3ecf2d)(ctx);
    }
}
function $1af551c56cb88ebf$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $1af551c56cb88ebf$var$clipVertical(ctx, target, area.top);
        $1af551c56cb88ebf$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $1af551c56cb88ebf$var$clipVertical(ctx, target, area.bottom);
    }
    $1af551c56cb88ebf$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $1af551c56cb88ebf$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$1af551c56cb88ebf$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $1af551c56cb88ebf$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $1af551c56cb88ebf$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $1af551c56cb88ebf$var$clipBounds(ctx, scale, notShape && $1af551c56cb88ebf$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $1af551c56cb88ebf$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $1af551c56cb88ebf$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $1af551c56cb88ebf$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $1af551c56cb88ebf$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $1af551c56cb88ebf$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $1af551c56cb88ebf$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $1af551c56cb88ebf$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $1af551c56cb88ebf$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $1af551c56cb88ebf$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($1af551c56cb88ebf$var$_shouldApplyFill(source)) $1af551c56cb88ebf$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$1af551c56cb88ebf$var$_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        $1af551c56cb88ebf$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $1af551c56cb88ebf$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $1af551c56cb88ebf$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $1af551c56cb88ebf$var$Legend extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $97ecbd121be4860b$export$e7094788287c5e9b)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $1af551c56cb88ebf$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $97ecbd121be4860b$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $97ecbd121be4860b$export$61196ced6d74a310)(ctx, this);
            this._draw();
            (0, $97ecbd121be4860b$export$a07804094c3ecf2d)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $97ecbd121be4860b$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $97ecbd121be4860b$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(labelOpts.font);
        const { color: fontColor, padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $1af551c56cb88ebf$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $97ecbd121be4860b$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $97ecbd121be4860b$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $97ecbd121be4860b$export$9fa96a7d116ea3ce)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $97ecbd121be4860b$export$d66dc83d8cfc8dd)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $97ecbd121be4860b$export$3a1a48c8f6ef640e)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $97ecbd121be4860b$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor || fontColor;
            ctx.fillStyle = legendItem.fontColor || fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $97ecbd121be4860b$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else cursor.y += lineHeight;
        });
        (0, $97ecbd121be4860b$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(titleOpts.font);
        const titlePadding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $97ecbd121be4860b$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $97ecbd121be4860b$export$25ce5a424b770e84)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $97ecbd121be4860b$export$db202ddc8be9136)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $97ecbd121be4860b$export$3a1a48c8f6ef640e)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(titleOpts.font);
        const titlePadding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $97ecbd121be4860b$export$21579262ef46735b)(x, this.left, this.right) && (0, $97ecbd121be4860b$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $97ecbd121be4860b$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $97ecbd121be4860b$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$1af551c56cb88ebf$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $1af551c56cb88ebf$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $97ecbd121be4860b$export$e7094788287c5e9b)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $97ecbd121be4860b$export$e7094788287c5e9b)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $97ecbd121be4860b$export$e7094788287c5e9b)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $1af551c56cb88ebf$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $1af551c56cb88ebf$export$ed247974535929c7 = {
    id: "legend",
    _element: $1af551c56cb88ebf$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $1af551c56cb88ebf$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $97ecbd121be4860b$export$3466f893ebf79586)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: 0,
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $1af551c56cb88ebf$var$Title extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(opts.padding);
        const textSize = lineCount * (0, $97ecbd121be4860b$export$c4ce752e73470fba)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, bottom, top);
                rotation = (0, $97ecbd121be4860b$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $97ecbd121be4860b$export$25ce5a424b770e84)(align, top, bottom);
                rotation = (0, $97ecbd121be4860b$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $97ecbd121be4860b$export$3a1a48c8f6ef640e)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $97ecbd121be4860b$export$db202ddc8be9136)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $1af551c56cb88ebf$var$createTitle(chart, titleOpts) {
    const title = new $1af551c56cb88ebf$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $1af551c56cb88ebf$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $1af551c56cb88ebf$export$f99233281efd08a0 = {
    id: "title",
    _element: $1af551c56cb88ebf$var$Title,
    start (chart, _args, options) {
        $1af551c56cb88ebf$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $1af551c56cb88ebf$var$map = new WeakMap();
var $1af551c56cb88ebf$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $1af551c56cb88ebf$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, title, options);
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.addBox(chart, title);
        $1af551c56cb88ebf$var$map.set(chart, title);
    },
    stop (chart) {
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.removeBox(chart, $1af551c56cb88ebf$var$map.get(chart));
        $1af551c56cb88ebf$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $1af551c56cb88ebf$var$map.get(chart);
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $1af551c56cb88ebf$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $97ecbd121be4860b$export$53a70dd1ebbae346)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $1af551c56cb88ebf$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $1af551c56cb88ebf$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $1af551c56cb88ebf$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $1af551c56cb88ebf$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(options.bodyFont);
    const titleFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(options.titleFont);
    const footerFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(body, (bodyItem)=>{
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(bodyItem.before, maxLineWidth);
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(bodyItem.lines, maxLineWidth);
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $1af551c56cb88ebf$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $1af551c56cb88ebf$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $1af551c56cb88ebf$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($1af551c56cb88ebf$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $1af551c56cb88ebf$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $1af551c56cb88ebf$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $1af551c56cb88ebf$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $1af551c56cb88ebf$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $1af551c56cb88ebf$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $1af551c56cb88ebf$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $97ecbd121be4860b$export$9fa96a7d116ea3ce)(cornerRadius);
    let x = $1af551c56cb88ebf$var$alignX(size, xAlign);
    const y = $1af551c56cb88ebf$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(x, 0, chart.width - size.width),
        y: (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(y, 0, chart.height - size.height)
    };
}
function $1af551c56cb88ebf$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $1af551c56cb88ebf$var$getBeforeAfterBodyLines(callback) {
    return $1af551c56cb88ebf$var$pushOrConcat([], $1af551c56cb88ebf$var$splitNewlines(callback));
}
function $1af551c56cb88ebf$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $97ecbd121be4860b$export$dda1d9f60106f0e9)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $1af551c56cb88ebf$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
class $1af551c56cb88ebf$var$Tooltip extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart || config._chart;
        this._chart = this.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $1af551c56cb88ebf$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $1af551c56cb88ebf$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = callbacks.beforeTitle.apply(this, [
            context
        ]);
        const title = callbacks.title.apply(this, [
            context
        ]);
        const afterTitle = callbacks.afterTitle.apply(this, [
            context
        ]);
        let lines = [];
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(beforeTitle));
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(title));
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $1af551c56cb88ebf$var$getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [
            tooltipItems
        ]));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $1af551c56cb88ebf$var$overrideCallbacks(callbacks, context);
            $1af551c56cb88ebf$var$pushOrConcat(bodyItem.before, $1af551c56cb88ebf$var$splitNewlines(scoped.beforeLabel.call(this, context)));
            $1af551c56cb88ebf$var$pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
            $1af551c56cb88ebf$var$pushOrConcat(bodyItem.after, $1af551c56cb88ebf$var$splitNewlines(scoped.afterLabel.call(this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $1af551c56cb88ebf$var$getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [
            tooltipItems
        ]));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = callbacks.beforeFooter.apply(this, [
            tooltipItems
        ]);
        const footer = callbacks.footer.apply(this, [
            tooltipItems
        ]);
        const afterFooter = callbacks.afterFooter.apply(this, [
            tooltipItems
        ]);
        let lines = [];
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(beforeFooter));
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(footer));
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($1af551c56cb88ebf$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(tooltipItems, (context)=>{
            const scoped = $1af551c56cb88ebf$var$overrideCallbacks(options.callbacks, context);
            labelColors.push(scoped.labelColor.call(this, context));
            labelPointStyles.push(scoped.labelPointStyle.call(this, context));
            labelTextColors.push(scoped.labelTextColor.call(this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $1af551c56cb88ebf$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $1af551c56cb88ebf$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $1af551c56cb88ebf$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $1af551c56cb88ebf$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $97ecbd121be4860b$export$9fa96a7d116ea3ce)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $97ecbd121be4860b$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $1af551c56cb88ebf$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColors = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(options.bodyFont);
        const colorX = $1af551c56cb88ebf$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $97ecbd121be4860b$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            (0, $97ecbd121be4860b$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $97ecbd121be4860b$export$23f2a1d2818174ef)(labelColors.borderWidth) ? Math.max(...Object.values(labelColors.borderWidth)) : labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
            const borderRadius = (0, $97ecbd121be4860b$export$9fa96a7d116ea3ce)(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $97ecbd121be4860b$export$d66dc83d8cfc8dd)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                (0, $97ecbd121be4860b$export$d66dc83d8cfc8dd)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $97ecbd121be4860b$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $1af551c56cb88ebf$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $97ecbd121be4860b$export$3722cfe417b6ed86)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $97ecbd121be4860b$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $1af551c56cb88ebf$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $97ecbd121be4860b$export$9fa96a7d116ea3ce)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $1af551c56cb88ebf$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $1af551c56cb88ebf$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $1af551c56cb88ebf$var$determineAlignment(chart, options, positionAndSize);
            const point = $1af551c56cb88ebf$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $97ecbd121be4860b$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $97ecbd121be4860b$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $97ecbd121be4860b$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $97ecbd121be4860b$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $1af551c56cb88ebf$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
$1af551c56cb88ebf$var$Tooltip.positioners = $1af551c56cb88ebf$var$positioners;
var $1af551c56cb88ebf$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $1af551c56cb88ebf$var$Tooltip,
    positioners: $1af551c56cb88ebf$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $1af551c56cb88ebf$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", args) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: {
            beforeTitle: (0, $97ecbd121be4860b$export$cf2f7c5792f80b46),
            title (tooltipItems) {
                if (tooltipItems.length > 0) {
                    const item = tooltipItems[0];
                    const labels = item.chart.data.labels;
                    const labelCount = labels ? labels.length : 0;
                    if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
                    else if (item.label) return item.label;
                    else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
                }
                return "";
            },
            afterTitle: (0, $97ecbd121be4860b$export$cf2f7c5792f80b46),
            beforeBody: (0, $97ecbd121be4860b$export$cf2f7c5792f80b46),
            beforeLabel: (0, $97ecbd121be4860b$export$cf2f7c5792f80b46),
            label (tooltipItem) {
                if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
                let label = tooltipItem.dataset.label || "";
                if (label) label += ": ";
                const value = tooltipItem.formattedValue;
                if (!(0, $97ecbd121be4860b$export$342063e11d6c3cad)(value)) label += value;
                return label;
            },
            labelColor (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    borderColor: options.borderColor,
                    backgroundColor: options.backgroundColor,
                    borderWidth: options.borderWidth,
                    borderDash: options.borderDash,
                    borderDashOffset: options.borderDashOffset,
                    borderRadius: 0
                };
            },
            labelTextColor () {
                return this.options.bodyColor;
            },
            labelPointStyle (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    pointStyle: options.pointStyle,
                    rotation: options.rotation
                };
            },
            afterLabel: (0, $97ecbd121be4860b$export$cf2f7c5792f80b46),
            afterBody: (0, $97ecbd121be4860b$export$cf2f7c5792f80b46),
            beforeFooter: (0, $97ecbd121be4860b$export$cf2f7c5792f80b46),
            footer: (0, $97ecbd121be4860b$export$cf2f7c5792f80b46),
            afterFooter: (0, $97ecbd121be4860b$export$cf2f7c5792f80b46)
        }
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $1af551c56cb88ebf$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Decimation: $1af551c56cb88ebf$export$be17f937e9aa7533,
    Filler: $1af551c56cb88ebf$export$d19ba4d812bed757,
    Legend: $1af551c56cb88ebf$export$ed247974535929c7,
    SubTitle: $1af551c56cb88ebf$export$d5c56664638992a4,
    Title: $1af551c56cb88ebf$export$f99233281efd08a0,
    Tooltip: $1af551c56cb88ebf$export$28c660c63b792dea
});
const $1af551c56cb88ebf$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $1af551c56cb88ebf$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $1af551c56cb88ebf$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $1af551c56cb88ebf$var$validIndex = (index, max)=>index === null ? null : (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(Math.round(index), 0, max);
class $1af551c56cb88ebf$export$29e663ba4d09fe7 extends $1af551c56cb88ebf$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $97ecbd121be4860b$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $1af551c56cb88ebf$var$findOrAddLabel(labels, raw, (0, $97ecbd121be4860b$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $1af551c56cb88ebf$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        const labels = this.getLabels();
        if (value >= 0 && value < labels.length) return labels[value];
        return value;
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
$1af551c56cb88ebf$export$29e663ba4d09fe7.id = "category";
$1af551c56cb88ebf$export$29e663ba4d09fe7.defaults = {
    ticks: {
        callback: $1af551c56cb88ebf$export$29e663ba4d09fe7.prototype.getLabelForValue
    }
};
function $1af551c56cb88ebf$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $97ecbd121be4860b$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $97ecbd121be4860b$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $97ecbd121be4860b$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $97ecbd121be4860b$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $97ecbd121be4860b$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $97ecbd121be4860b$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $97ecbd121be4860b$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $97ecbd121be4860b$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $97ecbd121be4860b$export$91477dc880baac21)(spacing), (0, $97ecbd121be4860b$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $97ecbd121be4860b$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $97ecbd121be4860b$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $1af551c56cb88ebf$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $97ecbd121be4860b$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $1af551c56cb88ebf$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $1af551c56cb88ebf$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $97ecbd121be4860b$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $1af551c56cb88ebf$var$LinearScaleBase extends $1af551c56cb88ebf$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $97ecbd121be4860b$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $97ecbd121be4860b$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $97ecbd121be4860b$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = 1;
            if (max >= Number.MAX_SAFE_INTEGER || min <= Number.MIN_SAFE_INTEGER) offset = Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $1af551c56cb88ebf$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $97ecbd121be4860b$export$a33b77bbdbb8366c)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $97ecbd121be4860b$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $1af551c56cb88ebf$export$e7f4e5e8656f0b93 extends $1af551c56cb88ebf$var$LinearScaleBase {
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $97ecbd121be4860b$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $97ecbd121be4860b$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $97ecbd121be4860b$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
$1af551c56cb88ebf$export$e7f4e5e8656f0b93.id = "linear";
$1af551c56cb88ebf$export$e7f4e5e8656f0b93.defaults = {
    ticks: {
        callback: $1af551c56cb88ebf$export$27c7467594ef87bd.formatters.numeric
    }
};
function $1af551c56cb88ebf$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, Math.floor((0, $97ecbd121be4860b$export$df995fae86a55f06)(tickVal)));
    return remain === 1;
}
function $1af551c56cb88ebf$var$generateTicks(generationOptions, dataRange) {
    const endExp = Math.floor((0, $97ecbd121be4860b$export$df995fae86a55f06)(dataRange.max));
    const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    const ticks = [];
    let tickVal = (0, $97ecbd121be4860b$export$ef35774e6d314e91)(generationOptions.min, Math.pow(10, Math.floor((0, $97ecbd121be4860b$export$df995fae86a55f06)(dataRange.min))));
    let exp = Math.floor((0, $97ecbd121be4860b$export$df995fae86a55f06)(tickVal));
    let significand = Math.floor(tickVal / Math.pow(10, exp));
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
        ticks.push({
            value: tickVal,
            major: $1af551c56cb88ebf$var$isMajor(tickVal)
        });
        ++significand;
        if (significand === 10) {
            significand = 1;
            ++exp;
            precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    }while (exp < endExp || exp === endExp && significand < endSignificand);
    const lastTick = (0, $97ecbd121be4860b$export$ef35774e6d314e91)(generationOptions.max, tickVal);
    ticks.push({
        value: lastTick,
        major: $1af551c56cb88ebf$var$isMajor(tickVal)
    });
    return ticks;
}
class $1af551c56cb88ebf$export$85295eaf7cb3ac3e extends $1af551c56cb88ebf$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $1af551c56cb88ebf$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $97ecbd121be4860b$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $97ecbd121be4860b$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $97ecbd121be4860b$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        const exp = (v, m)=>Math.pow(10, Math.floor((0, $97ecbd121be4860b$export$df995fae86a55f06)(v)) + m);
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(exp(min, -1));
                setMax(exp(max, 1));
            }
        }
        if (min <= 0) setMin(exp(max, -1));
        if (max <= 0) setMax(exp(min, 1));
        if (this._zero && this.min !== this._suggestedMin && min === exp(this.min, 0)) setMin(exp(min, -1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $1af551c56cb88ebf$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, $97ecbd121be4860b$export$a33b77bbdbb8366c)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $97ecbd121be4860b$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $97ecbd121be4860b$export$df995fae86a55f06)(start);
        this._valueRange = (0, $97ecbd121be4860b$export$df995fae86a55f06)(this.max) - (0, $97ecbd121be4860b$export$df995fae86a55f06)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $97ecbd121be4860b$export$df995fae86a55f06)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
$1af551c56cb88ebf$export$85295eaf7cb3ac3e.id = "logarithmic";
$1af551c56cb88ebf$export$85295eaf7cb3ac3e.defaults = {
    ticks: {
        callback: $1af551c56cb88ebf$export$27c7467594ef87bd.formatters.logarithmic,
        major: {
            enabled: true
        }
    }
};
function $1af551c56cb88ebf$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(tickOpts.backdropPadding);
        return (0, $97ecbd121be4860b$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $97ecbd121be4860b$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $1af551c56cb88ebf$var$measureLabelSize(ctx, font, label) {
    label = (0, $97ecbd121be4860b$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $97ecbd121be4860b$export$9f4f30ee63539e24)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $1af551c56cb88ebf$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $1af551c56cb88ebf$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $97ecbd121be4860b$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(opts.font);
        const textSize = $1af551c56cb88ebf$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $97ecbd121be4860b$export$3d12bd131bb975d1)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $97ecbd121be4860b$export$d66501df72047452)(angleRadians));
        const hLimits = $1af551c56cb88ebf$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $1af551c56cb88ebf$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $1af551c56cb88ebf$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $1af551c56cb88ebf$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $1af551c56cb88ebf$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $1af551c56cb88ebf$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const extra = $1af551c56cb88ebf$var$getTickBackdropHeight(opts) / 2;
    const outerDistance = scale.drawingArea;
    const additionalAngle = opts.pointLabels.centerPointLabels ? (0, $97ecbd121be4860b$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
        const angle = Math.round((0, $97ecbd121be4860b$export$d66501df72047452)((0, $97ecbd121be4860b$export$3d12bd131bb975d1)(pointLabelPosition.angle + (0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd))));
        const size = labelSizes[i];
        const y = $1af551c56cb88ebf$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $1af551c56cb88ebf$var$getTextAlignForAngle(angle);
        const left = $1af551c56cb88ebf$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $1af551c56cb88ebf$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $1af551c56cb88ebf$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $1af551c56cb88ebf$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $1af551c56cb88ebf$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        const plFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign, left: left, top: top, right: right, bottom: bottom } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor } = optsAtIndex;
        if (!(0, $97ecbd121be4860b$export$342063e11d6c3cad)(backdropColor)) {
            const borderRadius = (0, $97ecbd121be4860b$export$9fa96a7d116ea3ce)(optsAtIndex.borderRadius);
            const padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            const backdropLeft = left - padding.left;
            const backdropTop = top - padding.top;
            const backdropWidth = right - left + padding.width;
            const backdropHeight = bottom - top + padding.height;
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                (0, $97ecbd121be4860b$export$d66dc83d8cfc8dd)(ctx, {
                    x: backdropLeft,
                    y: backdropTop,
                    w: backdropWidth,
                    h: backdropHeight,
                    radius: borderRadius
                });
                ctx.fill();
            } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
        (0, $97ecbd121be4860b$export$3a1a48c8f6ef640e)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $1af551c56cb88ebf$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $97ecbd121be4860b$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $1af551c56cb88ebf$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(gridLineOpts.borderDash);
    ctx.lineDashOffset = gridLineOpts.borderDashOffset;
    ctx.beginPath();
    $1af551c56cb88ebf$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $1af551c56cb88ebf$var$createPointLabelContext(parent, index, label) {
    return (0, $97ecbd121be4860b$export$dda1d9f60106f0e9)(parent, {
        label: label,
        index: index,
        type: "pointLabel"
    });
}
class $1af551c56cb88ebf$export$cfafc36d95386d38 extends $1af551c56cb88ebf$var$LinearScaleBase {
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)($1af551c56cb88ebf$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $97ecbd121be4860b$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $97ecbd121be4860b$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $1af551c56cb88ebf$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $1af551c56cb88ebf$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $97ecbd121be4860b$export$e7094788287c5e9b)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $1af551c56cb88ebf$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $97ecbd121be4860b$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $97ecbd121be4860b$export$3d12bd131bb975d1)(index * angleMultiplier + (0, $97ecbd121be4860b$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $97ecbd121be4860b$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $97ecbd121be4860b$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $1af551c56cb88ebf$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $1af551c56cb88ebf$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $1af551c56cb88ebf$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const optsAtIndex = grid.setContext(this.getContext(index - 1));
                $1af551c56cb88ebf$var$drawRadiusLine(this, optsAtIndex, offset, labelCount);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $97ecbd121be4860b$export$c4ce752e73470fba)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $97ecbd121be4860b$export$3466f893ebf79586)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $97ecbd121be4860b$export$3a1a48c8f6ef640e)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
$1af551c56cb88ebf$export$cfafc36d95386d38.id = "radialLinear";
$1af551c56cb88ebf$export$cfafc36d95386d38.defaults = {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: $1af551c56cb88ebf$export$27c7467594ef87bd.formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
};
$1af551c56cb88ebf$export$cfafc36d95386d38.defaultRoutes = {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
};
$1af551c56cb88ebf$export$cfafc36d95386d38.descriptors = {
    angleLines: {
        _fallback: "grid"
    }
};
const $1af551c56cb88ebf$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $1af551c56cb88ebf$var$UNITS = Object.keys($1af551c56cb88ebf$var$INTERVALS);
function $1af551c56cb88ebf$var$sorter(a, b) {
    return a - b;
}
function $1af551c56cb88ebf$var$parse(scale, input) {
    if ((0, $97ecbd121be4860b$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $97ecbd121be4860b$export$39b482c5e57630a8)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $97ecbd121be4860b$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $1af551c56cb88ebf$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $1af551c56cb88ebf$var$UNITS.length;
    for(let i = $1af551c56cb88ebf$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $1af551c56cb88ebf$var$INTERVALS[$1af551c56cb88ebf$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $1af551c56cb88ebf$var$UNITS[i];
    }
    return $1af551c56cb88ebf$var$UNITS[ilen - 1];
}
function $1af551c56cb88ebf$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $1af551c56cb88ebf$var$UNITS.length - 1; i >= $1af551c56cb88ebf$var$UNITS.indexOf(minUnit); i--){
        const unit = $1af551c56cb88ebf$var$UNITS[i];
        if ($1af551c56cb88ebf$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $1af551c56cb88ebf$var$UNITS[minUnit ? $1af551c56cb88ebf$var$UNITS.indexOf(minUnit) : 0];
}
function $1af551c56cb88ebf$var$determineMajorUnit(unit) {
    for(let i = $1af551c56cb88ebf$var$UNITS.indexOf(unit) + 1, ilen = $1af551c56cb88ebf$var$UNITS.length; i < ilen; ++i){
        if ($1af551c56cb88ebf$var$INTERVALS[$1af551c56cb88ebf$var$UNITS[i]].common) return $1af551c56cb88ebf$var$UNITS[i];
    }
}
function $1af551c56cb88ebf$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $97ecbd121be4860b$export$c03999cb2f36933f)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $1af551c56cb88ebf$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $1af551c56cb88ebf$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $1af551c56cb88ebf$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $1af551c56cb88ebf$export$a894c72689ff3ec extends $1af551c56cb88ebf$export$d60cfc58d3c358b6 {
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $1af551c56cb88ebf$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $97ecbd121be4860b$export$2219238a014317b0)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $1af551c56cb88ebf$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, $97ecbd121be4860b$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $97ecbd121be4860b$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $97ecbd121be4860b$export$faec65b429be379)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $1af551c56cb88ebf$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $1af551c56cb88ebf$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : $1af551c56cb88ebf$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $1af551c56cb88ebf$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(start, 0, limit);
        end = (0, $97ecbd121be4860b$export$a9c23c6ac3fc3eca)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $1af551c56cb88ebf$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $97ecbd121be4860b$export$90a7f3efeed30595)(timeOpts.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $97ecbd121be4860b$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$1af551c56cb88ebf$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $1af551c56cb88ebf$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        const label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));
        const formatter = options.ticks.callback;
        return formatter ? (0, $97ecbd121be4860b$export$e7094788287c5e9b)(formatter, [
            label,
            index,
            ticks
        ], this) : label;
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $97ecbd121be4860b$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $1af551c56cb88ebf$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($1af551c56cb88ebf$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $97ecbd121be4860b$export$71511d61b312f219)(values.sort($1af551c56cb88ebf$var$sorter));
    }
}
$1af551c56cb88ebf$export$a894c72689ff3ec.id = "time";
$1af551c56cb88ebf$export$a894c72689ff3ec.defaults = {
    bounds: "data",
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: "millisecond",
        displayFormats: {}
    },
    ticks: {
        source: "auto",
        major: {
            enabled: false
        }
    }
};
function $1af551c56cb88ebf$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $97ecbd121be4860b$export$dc98b0b04f4c7758)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $97ecbd121be4860b$export$dc98b0b04f4c7758)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $1af551c56cb88ebf$export$85df64a8eb6dc986 extends $1af551c56cb88ebf$export$a894c72689ff3ec {
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $1af551c56cb88ebf$var$interpolate(table, this.min);
        this._tableRange = $1af551c56cb88ebf$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($1af551c56cb88ebf$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $1af551c56cb88ebf$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
$1af551c56cb88ebf$export$85df64a8eb6dc986.id = "timeseries";
$1af551c56cb88ebf$export$85df64a8eb6dc986.defaults = $1af551c56cb88ebf$export$a894c72689ff3ec.defaults;
var $1af551c56cb88ebf$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $1af551c56cb88ebf$export$29e663ba4d09fe7,
    LinearScale: $1af551c56cb88ebf$export$e7f4e5e8656f0b93,
    LogarithmicScale: $1af551c56cb88ebf$export$85295eaf7cb3ac3e,
    RadialLinearScale: $1af551c56cb88ebf$export$cfafc36d95386d38,
    TimeScale: $1af551c56cb88ebf$export$a894c72689ff3ec,
    TimeSeriesScale: $1af551c56cb88ebf$export$85df64a8eb6dc986
});
const $1af551c56cb88ebf$export$e8959e79e3af550f = [
    $1af551c56cb88ebf$export$a6506504f799c5d5,
    $1af551c56cb88ebf$export$7a5d735b2ab6389d,
    $1af551c56cb88ebf$export$8b3ca321c77fdea6,
    $1af551c56cb88ebf$export$bcac1c16f1530ec2
];


(0, $1af551c56cb88ebf$export$acaa6426d77a227e).register(...(0, $1af551c56cb88ebf$export$e8959e79e3af550f));
var $5b117e7d5e461010$export$2e2bcd8739ae039 = (0, $1af551c56cb88ebf$export$acaa6426d77a227e);


const $662f9e853a36449a$var$randomInt = (min, max)=>Math.floor(Math.random() * (max - min + 1) + min);
let $662f9e853a36449a$var$width;
let $662f9e853a36449a$var$height;
let $662f9e853a36449a$var$gradient;
const $662f9e853a36449a$var$getGradient = (ctx, chartArea)=>{
    const chartWidth = chartArea.right - chartArea.left;
    const chartHeight = chartArea.bottom - chartArea.top;
    if (!$662f9e853a36449a$var$gradient || $662f9e853a36449a$var$width !== chartWidth || $662f9e853a36449a$var$height !== chartHeight) {
        // Create the gradient because this is either the first render
        // or the size of the chart has changed
        $662f9e853a36449a$var$width = chartWidth;
        $662f9e853a36449a$var$height = chartHeight;
        $662f9e853a36449a$var$gradient = ctx.createLinearGradient(0, 0, 0, chartArea.bottom);
        $662f9e853a36449a$var$gradient.addColorStop(0, "#FF1529");
        $662f9e853a36449a$var$gradient.addColorStop(1, "#FF7121");
    }
    return $662f9e853a36449a$var$gradient;
};
const $662f9e853a36449a$var$labels = [
    "AARC",
    "ACTRA",
    "ABRAMUS",
    "ADAMI",
    [
        "AFM",
        "SAG-AFTRA"
    ],
    "AIE",
    "GDA",
    [
        "GRAMEX",
        "Denmark"
    ],
    [
        "GRAMEX",
        "Finland"
    ],
    "GRAMO",
    "GVL",
    "ITSRIGHT",
    "LaIPA",
    "LSG",
    "NORMA",
    "PlayRight",
    "PPL",
    "AARC",
    "ACTRA",
    "ABRAMUS",
    "ADAMI",
    [
        "AFM",
        "SAG-AFTRA"
    ],
    "AIE",
    "GDA",
    [
        "GRAMEX",
        "Denmark"
    ]
];
const $662f9e853a36449a$var$chartConfig = {
    type: "bar",
    data: {
        labels: $662f9e853a36449a$var$labels,
        datasets: [
            {
                label: "Client receiving income",
                data: $662f9e853a36449a$var$labels.map(()=>{
                    return $662f9e853a36449a$var$randomInt(0, 15);
                }),
                backgroundColor: "#B380FF",
                barThickness: 18
            },
            {
                label: "Clients registered",
                data: $662f9e853a36449a$var$labels.map(()=>{
                    return $662f9e853a36449a$var$randomInt(15, 20);
                }),
                backgroundColor: "#535D66",
                barThickness: 18
            },
            {
                label: "No. of clients",
                data: $662f9e853a36449a$var$labels.map(()=>{
                    return $662f9e853a36449a$var$randomInt(20, 50);
                }),
                backgroundColor: "#00B3FF",
                barThickness: 18,
                borderRadius: 3
            }
        ]
    },
    options: {
        plugins: {
            legend: {
                display: true,
                // position: 'right',
                align: "end",
                labels: {
                    color: "#FFFFFF",
                    boxWidth: 9,
                    boxHeight: 9,
                    font: {
                        size: 12,
                        weight: 500
                    }
                }
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: "point"
        },
        scales: {
            x: {
                barPercentage: 0.25,
                categoryPercentage: 1.0,
                barThickness: 18,
                min: 0,
                max: 23,
                stacked: true,
                grid: {
                    display: false,
                    offsetGridLines: false
                },
                ticks: {
                    fontSize: 10,
                    fontWeight: 500,
                    color: "#FFFFFF",
                    autoSkip: false,
                    beginAtZero: true,
                    // barPercentage: 0.1,
                    categoryPercentage: 1.0,
                    stepSize: 1,
                    maxRotation: 45,
                    minRotation: 45,
                    angle: 45
                }
            },
            y: {
                stacked: false,
                suggestedMin: 5,
                ticks: {
                    beginAtZero: false,
                    stepSize: 10,
                    color: "#FFFFFF"
                }
            }
        },
        events: [
            "mousemove",
            "touchmove"
        ]
    }
};
function $662f9e853a36449a$var$ClientsChart() {
    const chartContainer = (0, $acw62.useRef)(null);
    const [chartInstance, setChartInstance] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (chartContainer && chartContainer.current) {
            const newChartInstance = new (0, $5b117e7d5e461010$export$2e2bcd8739ae039)(chartContainer.current, $662f9e853a36449a$var$chartConfig);
            setChartInstance(newChartInstance);
        } else setChartInstance(undefined);
    }, [
        chartContainer
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "chart-container",
        style: {
            minWidth: "300px",
            position: "relative",
            height: "305px"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("canvas", {
            id: "clientsChart",
            ref: chartContainer,
            height: "300",
            width: "1206"
        })
    });
}
var $662f9e853a36449a$export$2e2bcd8739ae039 = $662f9e853a36449a$var$ClientsChart;




var $acw62 = parcelRequire("acw62");









function $8027e0c1918401fd$var$PassportVerification(props) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const checkUserStatus = async ()=>{
        const result = await api.retrieveLatestAdminIdentityDocumentSubmission({
            userId: clientId,
            documentType: "Passport"
        });
        if (result.status === (0, $dae85878c5dda937$export$ce4d75ddf8b4da4).Invalid) props.declineMessage();
        else if (result.status !== (0, $dae85878c5dda937$export$ce4d75ddf8b4da4).PendingDecision) navigate(`/terms-of-agreement/${clientId}`, {
            state: {
                taskId: props.taskId
            }
        });
    };
    (0, $acw62.useEffect)(()=>{
        checkUserStatus();
    }, [
        props.taskId
    ]);
    const passportFileLocationFileExtension = props.passportFileLocation.split("?")[0].split(".").pop();
    const schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        dateOfBirth: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty().max(10).min(10).regex(/^\d{4}-\d{2}-\d{2}$/),
        passportNumber: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty().max(20),
        passportExpiryDate: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty().max(10).min(10).regex(/^\d{4}-\d{2}-\d{2}$/)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "tw-mb-6",
                children: "Passport Verification"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                variant: "link-secondary",
                icon: "chevron-left",
                onClick: ()=>props.setVerifyPassport(false),
                label: "Back"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-w-full tw-bg-surfaceBlack90 tw-p-5 tw-rounded-2 tw-text-white tw-rounded-lg",
                style: {
                    maxWidth: "1050px"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/2 tw-p-4 ",
                        children: passportFileLocationFileExtension == "pdf" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("embed", {
                            src: props.passportFileLocation,
                            type: "application/pdf",
                            className: "passportImg",
                            height: "100%",
                            width: "100%"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: props.passportFileLocation,
                            alt: "passport",
                            className: "passportImg"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/2 tw-p-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                            schema: schema,
                            handleSubmit: props.acceptPassport,
                            formData: {
                                dateOfBirth: props.passportDateOfBirth,
                                passportNumber: props.passportNumber,
                                passportExpiryDate: props.passportExpiryDate
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                    type: "date",
                                    name: "dateOfBirth",
                                    label: "Date of Birth",
                                    value: props.passportDateOfBirth,
                                    onChange: (e)=>{
                                        props.setPassportDateOfBirth(e.target.value);
                                    },
                                    onBlur: ()=>{},
                                    isFieldEditing: true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                    type: "text",
                                    name: "passportNumber",
                                    label: "Passport Number",
                                    value: props.passportNumber,
                                    onChange: (e)=>{
                                        props.setPassportNumber(e.target.value);
                                    },
                                    onBlur: ()=>{},
                                    isFieldEditing: true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                    type: "date",
                                    name: "passportExpiryDate",
                                    label: "Passport Expiry Date",
                                    value: props.passportExpiryDate,
                                    onChange: (e)=>{
                                        props.setPassportExpiryDate(e.target.value);
                                    },
                                    onBlur: ()=>{},
                                    isFieldEditing: true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-justify-start tw-space-x-2 tw-mt-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8027e0c1918401fd$var$FormFooter, {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                            onClick: ()=>{
                                                props.declineMessage();
                                            },
                                            disabled: true,
                                            variant: "secondary",
                                            label: "Decline"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function $8027e0c1918401fd$var$FormFooter() {
    // disable continue if any field is empty
    const { formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const { handleFormSubmit: handleFormSubmit } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
        onClick: ()=>{
            handleFormSubmit(formData);
        },
        disabled: formData.dateOfBirth == "" || formData.passportNumber == "" || formData.passportExpiryDate == "",
        label: "Continue",
        variant: "primary"
    });
}
var $8027e0c1918401fd$export$2e2bcd8739ae039 = $8027e0c1918401fd$var$PassportVerification;






function $fa8b665f3163a5b2$var$DeclineMessage(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "declineMessageContainer",
        style: {
            maxWidth: "600px"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "declineContainer",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "piBack d-flex",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        variant: "outline-light",
                        onClick: ()=>props.setShowDeclineMessage(false),
                        label: "Back"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                    extraClasses: "tw-max-w-[600px]",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "passportDeclineTitle",
                                    children: "Passport declined"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "You will need to contact the client to inform them that their passport is not valid."
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-mt-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/clients",
                                    style: {
                                        textDecoration: "none"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        label: "OK"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $fa8b665f3163a5b2$export$2e2bcd8739ae039 = $fa8b665f3163a5b2$var$DeclineMessage;




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
const $cc827972f01625b6$export$8ba061c9afd04389 = ({ isOpen: isOpen, children: children, cardEvent: cardEvent, title: title })=>{
    (0, $acw62.useEffect)(()=>{
        if (isOpen) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isOpen
    ]);
    // Force re-render of internal components
    if (!isOpen) return null;
    const overlayClass = isOpen ? "tw-opacity-100 tw-visible" : "tw-opacity-0 tw-invisible tw-pointer-events-none";
    const modalClass = isOpen ? "tw-translate-x-0" : "tw-translate-x-full";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `tw-text-white ${overlayClass}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `tw-fixed tw-inset-0 tw-z-30 tw-transition-opacity tw-duration-300`,
                style: {
                    background: "rgba(255, 255, 255, 0.30)",
                    backdropFilter: "blur(3px)"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-fixed tw-inset-0 tw-flex tw-justify-end tw-z-50",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `tw-min-w-[550px] tw-p-8 tw-pb-0 tw-bg-surfaceBlack80 tw-h-full tw-transform ${modalClass} tw-transition-transform tw-duration-400 tw-overflow-y-scroll`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                            className: "tw-flex tw-justify-between tw-items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "tw-text-white tw-text-xl",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "tw-text-[32px] tw-text-white",
                                    onClick: cardEvent,
                                    children: "\xd7"
                                })
                            ]
                        }),
                        children
                    ]
                })
            })
        ]
    });
};
const $cc827972f01625b6$export$3d28cc639c274ad6 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-sticky tw-bottom-0 tw-p-4 tw-left-0 tw-bg-surfaceBlack80 tw-flex tw-space-x-4",
        children: children
    });
};









class $fd566f0076ec21e5$export$e3f69961e0548597 extends Error {
    constructor(message, error, title){
        super(message);
        this.name = "WError";
        this.title = title;
        // If an error object is provided, use its stack
        if (error) this.stack = error.stack;
    }
} // In the future, we can add more error types here, e.g. WNetworkError, WHttpError, etc.
 // Then in the catch block, we can do something like:
 // catch (error) {
 //   if (error instanceof WNetworkError) {
 //     // Handle network error
 //   } else if (error instanceof WHttpError) {
 //     // Handle http error
 //   } else {
 //     // Handle other errors




var $acw62 = parcelRequire("acw62");



const $ace6711bea63eb39$var$WErrorContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $ace6711bea63eb39$export$cb6b548c2da6d814 = ()=>{
    const context = (0, $acw62.useContext)($ace6711bea63eb39$var$WErrorContext);
    if (!context) throw new Error("useWError must be used within a WErrorProvider");
    return context;
};
const $ace6711bea63eb39$export$f536685410d85835 = ({ children: children })=>{
    const [error, setError] = (0, $acw62.useState)(null);
    const [errorModalOpen, setErrorModalOpen] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (error !== null) setErrorModalOpen(true);
    }, [
        error
    ]);
    const throwError = (0, $acw62.useCallback)((error)=>{
        if (error instanceof (0, $fd566f0076ec21e5$export$e3f69961e0548597)) setError(error);
    }, []);
    const handleClose = (0, $acw62.useCallback)(()=>{
        setError(null);
        setErrorModalOpen(false);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ace6711bea63eb39$var$WErrorContext.Provider, {
        value: {
            throwError: throwError
        },
        children: [
            children,
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: errorModalOpen,
                onClose: handleClose,
                title: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31555d64cac64856$export$2e2bcd8739ae039), {
                    title: error.title,
                    description: error.message
                })
            })
        ]
    });
};





const $10f9b7b2624d2fba$export$f79a7be7df1f74d3 = ({ disabled: disabled = false })=>{
    const { isEditing: isEditing, handleFormSubmit: handleFormSubmit, formData: formData, setIsEditing: setIsEditing, isFormSubmitted: isFormSubmitted, setFormSubmitted: setFormSubmitted } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-relative tw-w-full tw-text-black tw-mt-4",
            children: isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-justify-start tw-space-x-4 tw-items-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    label: "Save Changes",
                    variant: "secondary",
                    disabled: disabled,
                    onClick: ()=>{
                        handleFormSubmit(formData);
                    }
                })
            })
        })
    });
};




var $acw62 = parcelRequire("acw62");
const $2bab2d07adce8775$export$e2595d8541f6e8ef = ({ columns: columns, data: data, columnStyle: columnStyle = {}, rowStyle: rowStyle = [], rawData: rawData = [] })=>{
    const [sortConfig, setSortConfig] = (0, $acw62.useState)(null);
    // Function to handle sorting
    const handleSort = (columnKey)=>{
        if (!sortConfig || sortConfig.key !== columnKey || sortConfig.direction === "descending") setSortConfig({
            key: columnKey,
            direction: "ascending"
        });
        else setSortConfig({
            key: columnKey,
            direction: "descending"
        });
    };
    // We memoize the sorted data so that we don't have to sort it on every render
    const sortedData = (0, $acw62.useMemo)(()=>{
        if (!sortConfig) return data;
        // For easily pairing up raw data with JSX data, we create a common map
        const dataMap = rawData.map((rawItem, index)=>({
                rawItem: rawItem,
                jsxItem: data[index]
            }));
        dataMap.sort((a, b)=>{
            const valueA = a.rawItem[sortConfig.key.dataKey];
            const valueB = b.rawItem[sortConfig.key.dataKey];
            // compareValues is a utility function that does valueA - valueB for all data types
            const comparisonResult = $2bab2d07adce8775$var$compareValues(valueA, valueB);
            return sortConfig.direction === "ascending" ? comparisonResult : -comparisonResult;
        });
        return dataMap.map((entry)=>entry.jsxItem);
    }, [
        data,
        rawData,
        sortConfig
    ]);
    const gridTemplateColumns = columns.map((col)=>col.width || "1fr").join(" ");
    const privateRowStyle = {
        borderBottom: "1px solid #AAB2B9"
    };
    const privateColumnStyle = {
        fontWeight: "bold",
        borderBottom: "1px solid #AAB2B9"
    };
    if (Object.keys(columnStyle).length === 0) columnStyle = privateColumnStyle;
    if (rowStyle.length === 0) rowStyle = sortedData.map(()=>privateRowStyle);
    const allColumnsEmpty = columns.every((col)=>col.title === "");
    const paddingClass = allColumnsEmpty || columns.length === 0 ? "" : "tw-p-4";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-bg-surfaceBlack80 IS_W_TABLE tw-w-full",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-bg-surfaceBlack90 tw-p-2 tw-w-full",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-grid tw-gap-2 tw-w-full",
                    style: {
                        gridTemplateColumns: gridTemplateColumns,
                        ...columnStyle
                    },
                    children: columns.map((column, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: `${paddingClass} tw-pl-0 tw-flex tw-items-center`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-capitalize",
                                role: "button",
                                tabIndex: 0,
                                onClick: ()=>{
                                    if (column.sort) handleSort(column);
                                },
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter") handleSort(column);
                                },
                                children: [
                                    column.title,
                                    column.sort ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-px-2 tw-text-textSeal",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "wi wi-sm wi-sort"
                                        })
                                    }) : null
                                ]
                            })
                        }, idx))
                }),
                sortedData.map((row, rowIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-grid tw-gap-2 tw-w-full",
                        style: {
                            gridTemplateColumns: gridTemplateColumns,
                            ...rowStyle[rowIndex]
                        },
                        children: columns.map((column, colIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `tw-p-4 tw-pl-0 tw-flex tw-items-center tw-text-sm tw-leading-4`,
                                children: row[column.dataKey]
                            }, colIndex))
                    }, rowIndex))
            ]
        })
    });
};
var $2bab2d07adce8775$export$2e2bcd8739ae039 = $2bab2d07adce8775$export$e2595d8541f6e8ef;
// Utility function to compare different data types
const $2bab2d07adce8775$var$compareValues = (a, b)=>{
    if (a === null || a === undefined) return -1;
    if (b === null || b === undefined) return 1;
    if (!isNaN(Date.parse(a)) && !isNaN(Date.parse(b))) {
        // Compare as dates
        const dateA = new Date(a);
        const dateB = new Date(b);
        return dateA.getTime() - dateB.getTime();
    } else if (!isNaN(+a) && !isNaN(+b)) // Compare as numbers
    return +a - +b; // +a converts a to a number
    else // Compare as strings
    return a.toString().localeCompare(b.toString());
};





parcelRequire("acw62");
const $aa586959ed1a48eb$var$FullName = ({ editedSettings: editedSettings, handleInputChange: handleInputChange, disabled: disabled = false })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "firstName",
                        label: "First Name",
                        disabled: disabled,
                        value: editedSettings.firstName,
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "middleName",
                        label: "Middle Name",
                        disabled: disabled,
                        value: editedSettings.middleName,
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "lastName",
                        label: "Last Name",
                        disabled: disabled,
                        value: editedSettings.lastName,
                        onChange: handleInputChange
                    })
                ]
            }),
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                    type: "text",
                    name: "fullName",
                    label: "Name",
                    value: editedSettings.firstName + " " + editedSettings.middleName + " " + editedSettings.lastName,
                    onChange: handleInputChange
                })
            })
        ]
    });
};
var $aa586959ed1a48eb$export$2e2bcd8739ae039 = $aa586959ed1a48eb$var$FullName;




function $41b3017e16d4d38e$var$EOIReviewCard({ deleteTaskOnConfirmed: deleteTaskOnConfirmed, eoiReviewID: eoiReviewID, onComplete: onComplete, cardEvent: cardEvent, isOpen: isOpen }) {
    // get the DECLINE_CLIENT_FEATURE_ENABLED variable from env vars
    const DECLINE_CLIENT_FEATURE_ENABLED = true;
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [editNotes, setEditNotes] = (0, $acw62.useState)(false);
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [userStatus, setUserStatus] = (0, $acw62.useState)();
    const [onBoardLink, setOnBoardlink] = (0, $acw62.useState)("");
    const [notes, setNotes] = (0, $acw62.useState)("");
    const [isFormEditable, setIsFormEditable] = (0, $acw62.useState)(false);
    const { clientId: clientId, clientEmail: clientEmail } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [runStatus, setRunStatus] = (0, $acw62.useState)(null);
    const [userNotFound, setUserNotFound] = (0, $acw62.useState)(false);
    const artistSchema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        firstName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        middleName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
        lastName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        email: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email()
    });
    const hideEmail = function(email) {
        return email.replace(/(.{2})(.*)(?=@)/, function(gp1, gp2, gp3) {
            for(let i = 0; i < gp3.length; i++)gp2 += "*";
            return gp2;
        });
    };
    const [formValue, setFormValue] = (0, $acw62.useState)({
        firstName: "",
        middleName: "",
        lastName: "",
        email: clientEmail,
        hiddenEmail: clientEmail && hideEmail(clientEmail)
    });
    (0, $acw62.useEffect)(()=>{
        setUserStatus(null);
        setEditNotes(false);
        fetchData();
    }, [
        clientEmail
    ]);
    (0, $acw62.useEffect)(()=>{
        // reset form states
        setIsFormEditable(false);
    }, [
        isOpen
    ]);
    const inputChange = async (event)=>{
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    const blurHandle = async (event)=>{
        if (event.target.value) setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    const fetchData = ()=>{
        api.retrieveAdminInterestRegistration({
            userId: clientId
        }).then((userSettings)=>{
            setUserStatus(userSettings.accountStatus);
            setOnBoardlink(userSettings.accountCreationUrl);
            setFormValue({
                firstName: userSettings.firstName ?? "",
                middleName: userSettings.middleName ?? "",
                lastName: userSettings.lastName ?? "",
                email: userSettings.email ?? "",
                hiddenEmail: userSettings.email ? hideEmail(userSettings.email) : ""
            });
            setNotes(userSettings.notes ?? "");
        }).catch((error)=>{
            if (error.response && error.response.status == 404) {
                setUserNotFound(true);
                setUserStatus((0, $3c58df248542b8a9$export$107108728cbff5c2).Rejected);
            }
        });
    };
    const declineClient = ()=>{
        api.updateAdminInterestRegistration({
            userId: clientId,
            adminInterestRegistration: {
                accountStatus: (0, $3c58df248542b8a9$export$107108728cbff5c2).Rejected
            }
        }).then(()=>{
            setUserStatus((0, $3c58df248542b8a9$export$107108728cbff5c2).Rejected);
        }).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("There was an error declining the client."));
        });
    };
    const onBoardClient = ()=>{
        if (clientId === undefined) return;
        api.updateAdminInterestRegistration({
            userId: clientId,
            adminInterestRegistration: {
                firstName: formValue.firstName,
                middleName: formValue.middleName,
                lastName: formValue.lastName,
                accountStatus: (0, $3c58df248542b8a9$export$107108728cbff5c2).Approved,
                notes: notes
            }
        }).then((response)=>{
            setUserStatus(response.accountStatus);
            setOnBoardlink(response.accountCreationUrl);
        }).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("There was an error onboarding the client."));
        });
    };
    const confirmDecline = ()=>{
        if (DECLINE_CLIENT_FEATURE_ENABLED) {
            setRunStatus((0, $dfb553316c3946d8$export$a80a0b0ac45e6e5d).InProgress);
            api.declineAdminInterestRegistration({
                userId: clientId
            }).then(()=>{
                getDeleteDeclinedArtistRunStatus();
            }).catch((e)=>{
                console.log(e);
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("There was an error declining the client."));
            });
        } else {
            onComplete();
            cardEvent();
        }
    };
    const getDeleteDeclinedArtistRunStatus = async ()=>{
        if (clientId === undefined) return;
        if (!isOpen) return;
        await api.retrieveDeleteDeclinedArtistRunStatus({
            userId: clientId
        }).then(({ status: status })=>setRunStatus(status)).catch((error)=>{
            if (error.response && error.response.status === 404) {
                fetchData();
                if (userNotFound) // if no user found, likely the user was already deleted
                setRunStatus((0, $dfb553316c3946d8$export$a80a0b0ac45e6e5d).Succeeded);
            }
        });
    };
    (0, $acw62.useEffect)(()=>{
        getDeleteDeclinedArtistRunStatus();
    }, [
        isOpen,
        clientId
    ]);
    const runStatusMap = {
        IN_PROGRESS: "Decline in progress",
        SUCCEEDED: "Decline succeeded",
        FAILED: "Decline failed",
        UNKNOWN: "Decline status unknown"
    };
    const saveArtistDetails = ()=>{
        if (clientId === undefined) return;
        api.updateAdminInterestRegistration({
            userId: clientId,
            adminInterestRegistration: {
                firstName: formValue.firstName,
                middleName: formValue.middleName,
                lastName: formValue.lastName,
                notes: notes
            }
        }).catch((error)=>{
            const defaultErrorMessage = "Couldn't save artist details.";
            error.response.json().then((errorJson)=>{
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)(errorJson.non_field_errors ?? defaultErrorMessage));
            }).catch(()=>{
                new (0, $fd566f0076ec21e5$export$e3f69961e0548597)(defaultErrorMessage);
            });
        });
    };
    const saveNotes = ()=>{
        if (clientId === undefined) return;
        api.updateAdminInterestRegistration({
            userId: clientId,
            adminInterestRegistration: {
                notes: notes
            }
        }).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Couldn't save notes."));
        });
    };
    const [isCopied, setIsCopied] = (0, $acw62.useState)(false);
    const copyTextToClipboard = (text)=>{
        setIsCopied(true);
        setTimeout(()=>{
            setIsCopied(false);
        }, 1500);
        return navigator.clipboard.writeText(text);
    };
    // dummy data
    const records = [
        {
            name: "Victoria Beckham",
            spotify: "47,123",
            recordings: "1430 Recordings"
        },
        {
            name: "Victoria Beckham",
            spotify: "47,123",
            recordings: "1430 Recordings"
        },
        {
            name: "Victoria Beckham",
            spotify: "47,123",
            recordings: "1430 Recordings"
        },
        {
            name: "Victoria Beckham",
            spotify: "47,123",
            recordings: "1430 Recordings"
        },
        {
            name: "Victoria Beckham",
            spotify: "47,123",
            recordings: "1430 Recordings"
        },
        {
            name: "Victoria Beckham",
            spotify: "47,123",
            recordings: "1430 Recordings"
        },
        {
            name: "Victoria Beckham",
            spotify: "47,123",
            recordings: "1430 Recordings"
        },
        {
            name: "Victoria Beckham",
            spotify: "47,123",
            recordings: "1430 Recordings"
        }
    ];
    const columnStyle = {
        fontSize: "14px",
        fontWeight: "500",
        borderBottom: "1px solid #fff"
    };
    const rowStyle = {
        fontSize: "14px",
        fontWeight: "300",
        borderBottom: "1px solid #535D66"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cc827972f01625b6$export$8ba061c9afd04389), {
        title: "",
        isOpen: isOpen,
        cardEvent: cardEvent,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                editByDefault: isFormEditable,
                formData: formValue,
                handleSubmit: saveArtistDetails,
                schema: artistSchema,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tw-text-xl tw-mb-6",
                                    children: "Artist details"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41b3017e16d4d38e$var$FormEditSection, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa586959ed1a48eb$export$2e2bcd8739ae039), {
                            editedSettings: {
                                firstName: formValue.firstName,
                                lastName: formValue.lastName,
                                middleName: formValue.middleName
                            },
                            handleInputChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "email",
                            onChange: ()=>{},
                            onBlur: ()=>{},
                            value: formValue.email,
                            label: "Email",
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10f9b7b2624d2fba$export$f79a7be7df1f74d3), {})
                    ]
                })
            }),
            userStatus === (0, $3c58df248542b8a9$export$107108728cbff5c2).Approved ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                extraClasses: "tw-border-[1px] tw-border-[#6EE038]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "detailsBoxWrap",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-xl tw-mb-2",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Artist Onboarded"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Send this link to the client so they can create their account"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "tw-max-w-[400px]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    className: "tw-text-textLime tw-break-words",
                                    href: onBoardLink,
                                    children: onBoardLink
                                }),
                                isCopied ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "d-block copied-text",
                                    children: "Copied text on clipboard"
                                }) : ""
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-mt-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                icon: "copy",
                                onClick: ()=>{
                                    copyTextToClipboard(onBoardLink);
                                },
                                label: "Copy Link"
                            })
                        })
                    ]
                })
            }) : userStatus === (0, $3c58df248542b8a9$export$107108728cbff5c2).Rejected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                extraClasses: "tw-border-[1px] tw-border-[#FF2600]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "detailsBoxWrap",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "d-flex tw-text-xl tw-mb-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "wi wi-20px wi-alert-warning tw- tw-mr-2",
                                        style: {
                                            background: "#FF2600"
                                        }
                                    }),
                                    "Artist declined"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-max-w-[400px] tw-mb-4 tw-font-light",
                            children: "You will need to contact the client to inform them that their application has not been successful."
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-text-xl tw-mb-6",
                                children: "PPL review"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `/discography-registrations/${eoiReviewID}`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    label: "View review",
                                    variant: "secondary"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                        disabled: true,
                        title: "Associated Artists",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "detailsBoxWrap",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-xl tw-mb-6",
                                    children: "Associated Artists"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-max-h-[350px] tw-overflow-y-scroll",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
                                        columns: [
                                            {
                                                title: "Artist Name",
                                                width: "1fr",
                                                dataKey: "name"
                                            },
                                            {
                                                title: "Spotify",
                                                width: "1fr",
                                                dataKey: "spotify"
                                            },
                                            {
                                                title: "Recordings",
                                                width: "1fr",
                                                dataKey: "recordings"
                                            }
                                        ],
                                        columnStyle: columnStyle,
                                        rowStyle: records.map(()=>rowStyle),
                                        data: records
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "detailsBoxWrap",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-xl tw-mb-6",
                                    children: "Notes"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "d-flex mb-3 scInputFields fonmGroupControl",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                        name: "notes",
                                        rows: 10,
                                        cols: 20,
                                        value: notes,
                                        disabled: editNotes,
                                        onChange: (e)=>setNotes(e.target.value),
                                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-resize-none", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-w-[450px]", "tw-placeholder-textSeal", "tw-text-sm", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "d-flex  justify-content-start",
                                    children: editNotes ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        label: "Edit",
                                        icon: "edit",
                                        onClick: ()=>{
                                            saveNotes();
                                            setEditNotes(false);
                                        }
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        label: "Save",
                                        onClick: ()=>{
                                            setEditNotes(true);
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cc827972f01625b6$export$3d28cc639c274ad6), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                variant: "primary",
                                onClick: onBoardClient,
                                label: "Onboard client"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                label: "Decline client",
                                onClick: ()=>declineClient(),
                                variant: "secondary"
                            })
                        ]
                    })
                ]
            }),
            (userStatus === (0, $3c58df248542b8a9$export$107108728cbff5c2).Approved || userStatus === (0, $3c58df248542b8a9$export$107108728cbff5c2).Rejected) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc827972f01625b6$export$3d28cc639c274ad6), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        userStatus === (0, $3c58df248542b8a9$export$107108728cbff5c2).Approved && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            onClick: deleteTaskOnConfirmed,
                            label: "Complete Onboarding"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                userStatus === (0, $3c58df248542b8a9$export$107108728cbff5c2).Rejected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    onClick: confirmDecline,
                                    label: "Confirm Decline",
                                    disabled: !DECLINE_CLIENT_FEATURE_ENABLED || runStatus !== null
                                }),
                                runStatus !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-my-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "",
                                        children: runStatusMap[runStatus ?? (0, $dfb553316c3946d8$export$a80a0b0ac45e6e5d).Unknown]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $41b3017e16d4d38e$var$FormEditSection() {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const { handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                label: "Edit",
                variant: "secondary",
                icon: "edit",
                onClick: ()=>{
                    setIsEditing(true);
                }
            })
        ]
    });
}
var $41b3017e16d4d38e$export$2e2bcd8739ae039 = $41b3017e16d4d38e$var$EOIReviewCard;


/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 

var $acw62 = parcelRequire("acw62");





/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $db42588f972bc829$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $db42588f972bc829$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $db42588f972bc829$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $db42588f972bc829$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $db42588f972bc829$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $db42588f972bc829$export$3d46f4579dba46e5)(`lucide-${(0, $db42588f972bc829$export$73bda83cddbc7187)((0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $39f04136db3724b2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const $39f04136db3724b2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("loader-circle", $39f04136db3724b2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ad14973a512851d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("search", $9ad14973a512851d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cfb3b3013a649f15$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("x", $cfb3b3013a649f15$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0740549741641712$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "5",
            key: "1hypcn"
        }
    ],
    [
        "path",
        {
            d: "M20 21a8 8 0 0 0-16 0",
            key: "rfgkzh"
        }
    ]
];
const $0740549741641712$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-round", $0740549741641712$export$3efd853dbb351e94);


function $bf10c2f08346e322$export$3f5eb857c8edfe4d() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0740549741641712$export$2e2bcd8739ae039), {
            size: 24
        })
    });
}



/**
 * Creates a continuation function with some arguments already applied.
 *
 * Useful as a shorthand when combined with other control flow functions. Any
 * arguments passed to the returned function are added to the arguments
 * originally passed to apply.
 *
 * @name apply
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {Function} fn - The function you want to eventually apply all
 * arguments to. Invokes with (arguments...).
 * @param {...*} arguments... - Any number of arguments to automatically apply
 * when the continuation is called.
 * @returns {Function} the partially-applied function
 * @example
 *
 * // using apply
 * async.parallel([
 *     async.apply(fs.writeFile, 'testfile1', 'test1'),
 *     async.apply(fs.writeFile, 'testfile2', 'test2')
 * ]);
 *
 *
 * // the same process without using apply
 * async.parallel([
 *     function(callback) {
 *         fs.writeFile('testfile1', 'test1', callback);
 *     },
 *     function(callback) {
 *         fs.writeFile('testfile2', 'test2', callback);
 *     }
 * ]);
 *
 * // It's possible to pass any number of additional arguments when calling the
 * // continuation:
 *
 * node> var fn = async.apply(sys.puts, 'one');
 * node> fn('two', 'three');
 * one
 * two
 * three
 */ 
var $hPtJY = parcelRequire("hPtJY");
function $63690b4f22172e23$export$5635d7ef4b8fee1c(fn, ...args) {
    return (...callArgs)=>fn(...args, ...callArgs);
}
function $63690b4f22172e23$var$initialParams(fn) {
    return function(...args /*, callback*/ ) {
        var callback = args.pop();
        return fn.call(this, args, callback);
    };
}
/* istanbul ignore file */ var $63690b4f22172e23$var$hasQueueMicrotask = typeof queueMicrotask === "function" && queueMicrotask;
var $63690b4f22172e23$var$hasSetImmediate = typeof setImmediate === "function" && setImmediate;
var $63690b4f22172e23$var$hasNextTick = typeof $hPtJY === "object" && typeof $hPtJY.nextTick === "function";
function $63690b4f22172e23$var$fallback(fn) {
    setTimeout(fn, 0);
}
function $63690b4f22172e23$var$wrap(defer) {
    return (fn, ...args)=>defer(()=>fn(...args));
}
var $63690b4f22172e23$var$_defer$1;
if ($63690b4f22172e23$var$hasQueueMicrotask) $63690b4f22172e23$var$_defer$1 = queueMicrotask;
else if ($63690b4f22172e23$var$hasSetImmediate) $63690b4f22172e23$var$_defer$1 = setImmediate;
else if ($63690b4f22172e23$var$hasNextTick) $63690b4f22172e23$var$_defer$1 = $hPtJY.nextTick;
else $63690b4f22172e23$var$_defer$1 = $63690b4f22172e23$var$fallback;
var $63690b4f22172e23$export$c233f08fbfea0913 = $63690b4f22172e23$var$wrap($63690b4f22172e23$var$_defer$1);
/**
 * Take a sync function and make it async, passing its return value to a
 * callback. This is useful for plugging sync functions into a waterfall,
 * series, or other async functions. Any arguments passed to the generated
 * function will be passed to the wrapped function (except for the final
 * callback argument). Errors thrown will be passed to the callback.
 *
 * If the function passed to `asyncify` returns a Promise, that promises's
 * resolved/rejected state will be used to call the callback, rather than simply
 * the synchronous return value.
 *
 * This also means you can asyncify ES2017 `async` functions.
 *
 * @name asyncify
 * @static
 * @memberOf module:Utils
 * @method
 * @alias wrapSync
 * @category Util
 * @param {Function} func - The synchronous function, or Promise-returning
 * function to convert to an {@link AsyncFunction}.
 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
 * invoked with `(args..., callback)`.
 * @example
 *
 * // passing a regular synchronous function
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(JSON.parse),
 *     function (data, next) {
 *         // data is the result of parsing the text.
 *         // If there was a parsing error, it would have been caught.
 *     }
 * ], callback);
 *
 * // passing a function returning a promise
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(function (contents) {
 *         return db.model.create(contents);
 *     }),
 *     function (model, next) {
 *         // `model` is the instantiated model object.
 *         // If there was an error, this function would be skipped.
 *     }
 * ], callback);
 *
 * // es2017 example, though `asyncify` is not needed if your JS environment
 * // supports async functions out of the box
 * var q = async.queue(async.asyncify(async function(file) {
 *     var intermediateStep = await processFile(file);
 *     return await somePromise(intermediateStep)
 * }));
 *
 * q.push(files);
 */ function $63690b4f22172e23$export$b5d55b15b1db3122(func) {
    if ($63690b4f22172e23$var$isAsync(func)) return function(...args /*, callback*/ ) {
        const callback = args.pop();
        const promise = func.apply(this, args);
        return $63690b4f22172e23$var$handlePromise(promise, callback);
    };
    return $63690b4f22172e23$var$initialParams(function(args, callback) {
        var result;
        try {
            result = func.apply(this, args);
        } catch (e) {
            return callback(e);
        }
        // if result is Promise object
        if (result && typeof result.then === "function") return $63690b4f22172e23$var$handlePromise(result, callback);
        else callback(null, result);
    });
}
function $63690b4f22172e23$var$handlePromise(promise, callback) {
    return promise.then((value)=>{
        $63690b4f22172e23$var$invokeCallback(callback, null, value);
    }, (err)=>{
        $63690b4f22172e23$var$invokeCallback(callback, err && (err instanceof Error || err.message) ? err : new Error(err));
    });
}
function $63690b4f22172e23$var$invokeCallback(callback, error, value) {
    try {
        callback(error, value);
    } catch (err) {
        $63690b4f22172e23$export$c233f08fbfea0913((e)=>{
            throw e;
        }, err);
    }
}
function $63690b4f22172e23$var$isAsync(fn) {
    return fn[Symbol.toStringTag] === "AsyncFunction";
}
function $63690b4f22172e23$var$isAsyncGenerator(fn) {
    return fn[Symbol.toStringTag] === "AsyncGenerator";
}
function $63690b4f22172e23$var$isAsyncIterable(obj) {
    return typeof obj[Symbol.asyncIterator] === "function";
}
function $63690b4f22172e23$var$wrapAsync(asyncFn) {
    if (typeof asyncFn !== "function") throw new Error("expected a function");
    return $63690b4f22172e23$var$isAsync(asyncFn) ? $63690b4f22172e23$export$b5d55b15b1db3122(asyncFn) : asyncFn;
}
// conditionally promisify a function.
// only return a promise if a callback is omitted
function $63690b4f22172e23$var$awaitify(asyncFn, arity) {
    if (!arity) arity = asyncFn.length;
    if (!arity) throw new Error("arity is undefined");
    function awaitable(...args) {
        if (typeof args[arity - 1] === "function") return asyncFn.apply(this, args);
        return new Promise((resolve, reject)=>{
            args[arity - 1] = (err, ...cbArgs)=>{
                if (err) return reject(err);
                resolve(cbArgs.length > 1 ? cbArgs : cbArgs[0]);
            };
            asyncFn.apply(this, args);
        });
    }
    return awaitable;
}
function $63690b4f22172e23$var$applyEach$1(eachfn) {
    return function applyEach(fns, ...callArgs) {
        const go = $63690b4f22172e23$var$awaitify(function(callback) {
            var that = this;
            return eachfn(fns, (fn, cb)=>{
                $63690b4f22172e23$var$wrapAsync(fn).apply(that, callArgs.concat(cb));
            }, callback);
        });
        return go;
    };
}
function $63690b4f22172e23$var$_asyncMap(eachfn, arr, iteratee, callback) {
    arr = arr || [];
    var results = [];
    var counter = 0;
    var _iteratee = $63690b4f22172e23$var$wrapAsync(iteratee);
    return eachfn(arr, (value, _, iterCb)=>{
        var index = counter++;
        _iteratee(value, (err, v)=>{
            results[index] = v;
            iterCb(err);
        });
    }, (err)=>{
        callback(err, results);
    });
}
function $63690b4f22172e23$var$isArrayLike(value) {
    return value && typeof value.length === "number" && value.length >= 0 && value.length % 1 === 0;
}
// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
const $63690b4f22172e23$var$breakLoop = {};
function $63690b4f22172e23$var$once(fn) {
    function wrapper(...args) {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    }
    Object.assign(wrapper, fn);
    return wrapper;
}
function $63690b4f22172e23$var$getIterator(coll) {
    return coll[Symbol.iterator] && coll[Symbol.iterator]();
}
function $63690b4f22172e23$var$createArrayIterator(coll) {
    var i = -1;
    var len = coll.length;
    return function next() {
        return ++i < len ? {
            value: coll[i],
            key: i
        } : null;
    };
}
function $63690b4f22172e23$var$createES2015Iterator(iterator) {
    var i = -1;
    return function next() {
        var item = iterator.next();
        if (item.done) return null;
        i++;
        return {
            value: item.value,
            key: i
        };
    };
}
function $63690b4f22172e23$var$createObjectIterator(obj) {
    var okeys = obj ? Object.keys(obj) : [];
    var i = -1;
    var len = okeys.length;
    return function next() {
        var key = okeys[++i];
        if (key === "__proto__") return next();
        return i < len ? {
            value: obj[key],
            key: key
        } : null;
    };
}
function $63690b4f22172e23$var$createIterator(coll) {
    if ($63690b4f22172e23$var$isArrayLike(coll)) return $63690b4f22172e23$var$createArrayIterator(coll);
    var iterator = $63690b4f22172e23$var$getIterator(coll);
    return iterator ? $63690b4f22172e23$var$createES2015Iterator(iterator) : $63690b4f22172e23$var$createObjectIterator(coll);
}
function $63690b4f22172e23$var$onlyOnce(fn) {
    return function(...args) {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    };
}
// for async generators
function $63690b4f22172e23$var$asyncEachOfLimit(generator, limit, iteratee, callback) {
    let done = false;
    let canceled = false;
    let awaiting = false;
    let running = 0;
    let idx = 0;
    function replenish() {
        //console.log('replenish')
        if (running >= limit || awaiting || done) return;
        //console.log('replenish awaiting')
        awaiting = true;
        generator.next().then(({ value: value, done: iterDone })=>{
            //console.log('got value', value)
            if (canceled || done) return;
            awaiting = false;
            if (iterDone) {
                done = true;
                if (running <= 0) //console.log('done nextCb')
                callback(null);
                return;
            }
            running++;
            iteratee(value, idx, iterateeCallback);
            idx++;
            replenish();
        }).catch(handleError);
    }
    function iterateeCallback(err, result) {
        //console.log('iterateeCallback')
        running -= 1;
        if (canceled) return;
        if (err) return handleError(err);
        if (err === false) {
            done = true;
            canceled = true;
            return;
        }
        if (result === $63690b4f22172e23$var$breakLoop || done && running <= 0) {
            done = true;
            //console.log('done iterCb')
            return callback(null);
        }
        replenish();
    }
    function handleError(err) {
        if (canceled) return;
        awaiting = false;
        done = true;
        callback(err);
    }
    replenish();
}
var $63690b4f22172e23$var$eachOfLimit$2 = (limit)=>{
    return (obj, iteratee, callback)=>{
        callback = $63690b4f22172e23$var$once(callback);
        if (limit <= 0) throw new RangeError("concurrency limit cannot be less than 1");
        if (!obj) return callback(null);
        if ($63690b4f22172e23$var$isAsyncGenerator(obj)) return $63690b4f22172e23$var$asyncEachOfLimit(obj, limit, iteratee, callback);
        if ($63690b4f22172e23$var$isAsyncIterable(obj)) return $63690b4f22172e23$var$asyncEachOfLimit(obj[Symbol.asyncIterator](), limit, iteratee, callback);
        var nextElem = $63690b4f22172e23$var$createIterator(obj);
        var done = false;
        var canceled = false;
        var running = 0;
        var looping = false;
        function iterateeCallback(err, value) {
            if (canceled) return;
            running -= 1;
            if (err) {
                done = true;
                callback(err);
            } else if (err === false) {
                done = true;
                canceled = true;
            } else if (value === $63690b4f22172e23$var$breakLoop || done && running <= 0) {
                done = true;
                return callback(null);
            } else if (!looping) replenish();
        }
        function replenish() {
            looping = true;
            while(running < limit && !done){
                var elem = nextElem();
                if (elem === null) {
                    done = true;
                    if (running <= 0) callback(null);
                    return;
                }
                running += 1;
                iteratee(elem.value, elem.key, $63690b4f22172e23$var$onlyOnce(iterateeCallback));
            }
            looping = false;
        }
        replenish();
    };
};
/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name eachOfLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`. The `key` is the item's key, or index in the case of an
 * array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $63690b4f22172e23$var$eachOfLimit(coll, limit, iteratee, callback) {
    return $63690b4f22172e23$var$eachOfLimit$2(limit)(coll, $63690b4f22172e23$var$wrapAsync(iteratee), callback);
}
var $63690b4f22172e23$export$8b05461b96b91438 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$eachOfLimit, 4);
// eachOf implementation optimized for array-likes
function $63690b4f22172e23$var$eachOfArrayLike(coll, iteratee, callback) {
    callback = $63690b4f22172e23$var$once(callback);
    var index = 0, completed = 0, { length: length } = coll, canceled = false;
    if (length === 0) callback(null);
    function iteratorCallback(err, value) {
        if (err === false) canceled = true;
        if (canceled === true) return;
        if (err) callback(err);
        else if (++completed === length || value === $63690b4f22172e23$var$breakLoop) callback(null);
    }
    for(; index < length; index++)iteratee(coll[index], index, $63690b4f22172e23$var$onlyOnce(iteratorCallback));
}
// a generic version of eachOf which can handle array, object, and iterator cases.
function $63690b4f22172e23$var$eachOfGeneric(coll, iteratee, callback) {
    return $63690b4f22172e23$export$8b05461b96b91438(coll, Infinity, iteratee, callback);
}
/**
 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
 * to the iteratee.
 *
 * @name eachOf
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEachOf
 * @category Collection
 * @see [async.each]{@link module:Collections.each}
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each
 * item in `coll`.
 * The `key` is the item's key, or index in the case of an array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * // dev.json is a file containing a valid json object config for dev environment
 * // dev.json is a file containing a valid json object config for test environment
 * // prod.json is a file containing a valid json object config for prod environment
 * // invalid.json is a file with a malformed json object
 *
 * let configs = {}; //global variable
 * let validConfigFileMap = {dev: 'dev.json', test: 'test.json', prod: 'prod.json'};
 * let invalidConfigFileMap = {dev: 'dev.json', test: 'test.json', invalid: 'invalid.json'};
 *
 * // asynchronous function that reads a json file and parses the contents as json object
 * function parseFile(file, key, callback) {
 *     fs.readFile(file, "utf8", function(err, data) {
 *         if (err) return calback(err);
 *         try {
 *             configs[key] = JSON.parse(data);
 *         } catch (e) {
 *             return callback(e);
 *         }
 *         callback();
 *     });
 * }
 *
 * // Using callbacks
 * async.forEachOf(validConfigFileMap, parseFile, function (err) {
 *     if (err) {
 *         console.error(err);
 *     } else {
 *         console.log(configs);
 *         // configs is now a map of JSON data, e.g.
 *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 *     }
 * });
 *
 * //Error handing
 * async.forEachOf(invalidConfigFileMap, parseFile, function (err) {
 *     if (err) {
 *         console.error(err);
 *         // JSON parse error exception
 *     } else {
 *         console.log(configs);
 *     }
 * });
 *
 * // Using Promises
 * async.forEachOf(validConfigFileMap, parseFile)
 * .then( () => {
 *     console.log(configs);
 *     // configs is now a map of JSON data, e.g.
 *     // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 * }).catch( err => {
 *     console.error(err);
 * });
 *
 * //Error handing
 * async.forEachOf(invalidConfigFileMap, parseFile)
 * .then( () => {
 *     console.log(configs);
 * }).catch( err => {
 *     console.error(err);
 *     // JSON parse error exception
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.forEachOf(validConfigFileMap, parseFile);
 *         console.log(configs);
 *         // configs is now a map of JSON data, e.g.
 *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * //Error handing
 * async () => {
 *     try {
 *         let result = await async.forEachOf(invalidConfigFileMap, parseFile);
 *         console.log(configs);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // JSON parse error exception
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$eachOf(coll, iteratee, callback) {
    var eachOfImplementation = $63690b4f22172e23$var$isArrayLike(coll) ? $63690b4f22172e23$var$eachOfArrayLike : $63690b4f22172e23$var$eachOfGeneric;
    return eachOfImplementation(coll, $63690b4f22172e23$var$wrapAsync(iteratee), callback);
}
var $63690b4f22172e23$export$d10d68e43a57bce9 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$eachOf, 3);
/**
 * Produces a new collection of values by mapping each value in `coll` through
 * the `iteratee` function. The `iteratee` is called with an item from `coll`
 * and a callback for when it has finished processing. Each of these callbacks
 * takes 2 arguments: an `error`, and the transformed item from `coll`. If
 * `iteratee` passes an error to its callback, the main `callback` (for the
 * `map` function) is immediately called with the error.
 *
 * Note, that since this function applies the `iteratee` to each item in
 * parallel, there is no guarantee that the `iteratee` functions will complete
 * in order. However, the results array will be in the same order as the
 * original `coll`.
 *
 * If `map` is passed an Object, the results will be an Array.  The results
 * will roughly be in the order of the original Objects' keys (but this can
 * vary across JavaScript engines).
 *
 * @name map
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an Array of the
 * transformed items from the `coll`. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * // file1.txt is a file that is 1000 bytes in size
 * // file2.txt is a file that is 2000 bytes in size
 * // file3.txt is a file that is 3000 bytes in size
 * // file4.txt does not exist
 *
 * const fileList = ['file1.txt','file2.txt','file3.txt'];
 * const withMissingFileList = ['file1.txt','file2.txt','file4.txt'];
 *
 * // asynchronous function that returns the file size in bytes
 * function getFileSizeInBytes(file, callback) {
 *     fs.stat(file, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         callback(null, stat.size);
 *     });
 * }
 *
 * // Using callbacks
 * async.map(fileList, getFileSizeInBytes, function(err, results) {
 *     if (err) {
 *         console.log(err);
 *     } else {
 *         console.log(results);
 *         // results is now an array of the file size in bytes for each file, e.g.
 *         // [ 1000, 2000, 3000]
 *     }
 * });
 *
 * // Error Handling
 * async.map(withMissingFileList, getFileSizeInBytes, function(err, results) {
 *     if (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     } else {
 *         console.log(results);
 *     }
 * });
 *
 * // Using Promises
 * async.map(fileList, getFileSizeInBytes)
 * .then( results => {
 *     console.log(results);
 *     // results is now an array of the file size in bytes for each file, e.g.
 *     // [ 1000, 2000, 3000]
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Error Handling
 * async.map(withMissingFileList, getFileSizeInBytes)
 * .then( results => {
 *     console.log(results);
 * }).catch( err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let results = await async.map(fileList, getFileSizeInBytes);
 *         console.log(results);
 *         // results is now an array of the file size in bytes for each file, e.g.
 *         // [ 1000, 2000, 3000]
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         let results = await async.map(withMissingFileList, getFileSizeInBytes);
 *         console.log(results);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$map(coll, iteratee, callback) {
    return $63690b4f22172e23$var$_asyncMap($63690b4f22172e23$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $63690b4f22172e23$export$871de8747c9eaa88 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$map, 3);
/**
 * Applies the provided arguments to each function in the array, calling
 * `callback` after all functions have completed. If you only provide the first
 * argument, `fns`, then it will return a function which lets you pass in the
 * arguments as if it were a single function call. If more arguments are
 * provided, `callback` is required while `args` is still optional. The results
 * for each of the applied async functions are passed to the final callback
 * as an array.
 *
 * @name applyEach
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} fns - A collection of {@link AsyncFunction}s
 * to all call with the same arguments
 * @param {...*} [args] - any number of separate arguments to pass to the
 * function.
 * @param {Function} [callback] - the final argument should be the callback,
 * called when all functions have completed processing.
 * @returns {AsyncFunction} - Returns a function that takes no args other than
 * an optional callback, that is the result of applying the `args` to each
 * of the functions.
 * @example
 *
 * const appliedFn = async.applyEach([enableSearch, updateSchema], 'bucket')
 *
 * appliedFn((err, results) => {
 *     // results[0] is the results for `enableSearch`
 *     // results[1] is the results for `updateSchema`
 * });
 *
 * // partial application example:
 * async.each(
 *     buckets,
 *     async (bucket) => async.applyEach([enableSearch, updateSchema], bucket)(),
 *     callback
 * );
 */ var $63690b4f22172e23$export$e0fc6250e304edaf = $63690b4f22172e23$var$applyEach$1($63690b4f22172e23$export$871de8747c9eaa88);
/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
 *
 * @name eachOfSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfSeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $63690b4f22172e23$var$eachOfSeries(coll, iteratee, callback) {
    return $63690b4f22172e23$export$8b05461b96b91438(coll, 1, iteratee, callback);
}
var $63690b4f22172e23$export$750e7e5fea3b0654 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$eachOfSeries, 3);
/**
 * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
 *
 * @name mapSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an array of the
 * transformed items from the `coll`. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$var$mapSeries(coll, iteratee, callback) {
    return $63690b4f22172e23$var$_asyncMap($63690b4f22172e23$export$750e7e5fea3b0654, coll, iteratee, callback);
}
var $63690b4f22172e23$export$9a85c32cda85b0dd = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$mapSeries, 3);
/**
 * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
 *
 * @name applyEachSeries
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.applyEach]{@link module:ControlFlow.applyEach}
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} fns - A collection of {@link AsyncFunction}s to all
 * call with the same arguments
 * @param {...*} [args] - any number of separate arguments to pass to the
 * function.
 * @param {Function} [callback] - the final argument should be the callback,
 * called when all functions have completed processing.
 * @returns {AsyncFunction} - A function, that when called, is the result of
 * appling the `args` to the list of functions.  It takes no args, other than
 * a callback.
 */ var $63690b4f22172e23$export$cdb63afc167779e = $63690b4f22172e23$var$applyEach$1($63690b4f22172e23$export$9a85c32cda85b0dd);
const $63690b4f22172e23$var$PROMISE_SYMBOL = Symbol("promiseCallback");
function $63690b4f22172e23$var$promiseCallback() {
    let resolve, reject;
    function callback(err, ...args) {
        if (err) return reject(err);
        resolve(args.length > 1 ? args : args[0]);
    }
    callback[$63690b4f22172e23$var$PROMISE_SYMBOL] = new Promise((res, rej)=>{
        resolve = res, reject = rej;
    });
    return callback;
}
/**
 * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
 * their requirements. Each function can optionally depend on other functions
 * being completed first, and each function is run as soon as its requirements
 * are satisfied.
 *
 * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
 * will stop. Further tasks will not execute (so any other functions depending
 * on it will not run), and the main `callback` is immediately called with the
 * error.
 *
 * {@link AsyncFunction}s also receive an object containing the results of functions which
 * have completed so far as the first argument, if they have dependencies. If a
 * task function has no dependencies, it will only be passed a callback.
 *
 * @name auto
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Object} tasks - An object. Each of its properties is either a
 * function or an array of requirements, with the {@link AsyncFunction} itself the last item
 * in the array. The object's key of a property serves as the name of the task
 * defined by that property, i.e. can be used when specifying requirements for
 * other tasks. The function receives one or two arguments:
 * * a `results` object, containing the results of the previously executed
 *   functions, only passed if the task has any dependencies,
 * * a `callback(err, result)` function, which must be called when finished,
 *   passing an `error` (which can be `null`) and the result of the function's
 *   execution.
 * @param {number} [concurrency=Infinity] - An optional `integer` for
 * determining the maximum number of tasks that can be run in parallel. By
 * default, as many as possible.
 * @param {Function} [callback] - An optional callback which is called when all
 * the tasks have been completed. It receives the `err` argument if any `tasks`
 * pass an error to their callback. Results are always returned; however, if an
 * error occurs, no further `tasks` will be performed, and the results object
 * will only contain partial results. Invoked with (err, results).
 * @returns {Promise} a promise, if a callback is not passed
 * @example
 *
 * //Using Callbacks
 * async.auto({
 *     get_data: function(callback) {
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: ['get_data', 'make_folder', function(results, callback) {
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(results, callback) {
 *         // once the file is written let's email a link to it...
 *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
 *     }]
 * }, function(err, results) {
 *     if (err) {
 *         console.log('err = ', err);
 *     }
 *     console.log('results = ', results);
 *     // results = {
 *     //     get_data: ['data', 'converted to array']
 *     //     make_folder; 'folder',
 *     //     write_file: 'filename'
 *     //     email_link: { file: 'filename', email: 'user@example.com' }
 *     // }
 * });
 *
 * //Using Promises
 * async.auto({
 *     get_data: function(callback) {
 *         console.log('in get_data');
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         console.log('in make_folder');
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: ['get_data', 'make_folder', function(results, callback) {
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(results, callback) {
 *         // once the file is written let's email a link to it...
 *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
 *     }]
 * }).then(results => {
 *     console.log('results = ', results);
 *     // results = {
 *     //     get_data: ['data', 'converted to array']
 *     //     make_folder; 'folder',
 *     //     write_file: 'filename'
 *     //     email_link: { file: 'filename', email: 'user@example.com' }
 *     // }
 * }).catch(err => {
 *     console.log('err = ', err);
 * });
 *
 * //Using async/await
 * async () => {
 *     try {
 *         let results = await async.auto({
 *             get_data: function(callback) {
 *                 // async code to get some data
 *                 callback(null, 'data', 'converted to array');
 *             },
 *             make_folder: function(callback) {
 *                 // async code to create a directory to store a file in
 *                 // this is run at the same time as getting the data
 *                 callback(null, 'folder');
 *             },
 *             write_file: ['get_data', 'make_folder', function(results, callback) {
 *                 // once there is some data and the directory exists,
 *                 // write the data to a file in the directory
 *                 callback(null, 'filename');
 *             }],
 *             email_link: ['write_file', function(results, callback) {
 *                 // once the file is written let's email a link to it...
 *                 callback(null, {'file':results.write_file, 'email':'user@example.com'});
 *             }]
 *         });
 *         console.log('results = ', results);
 *         // results = {
 *         //     get_data: ['data', 'converted to array']
 *         //     make_folder; 'folder',
 *         //     write_file: 'filename'
 *         //     email_link: { file: 'filename', email: 'user@example.com' }
 *         // }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $63690b4f22172e23$export$dfb5619354ba860(tasks, concurrency, callback) {
    if (typeof concurrency !== "number") {
        // concurrency is optional, shift the args.
        callback = concurrency;
        concurrency = null;
    }
    callback = $63690b4f22172e23$var$once(callback || $63690b4f22172e23$var$promiseCallback());
    var numTasks = Object.keys(tasks).length;
    if (!numTasks) return callback(null);
    if (!concurrency) concurrency = numTasks;
    var results = {};
    var runningTasks = 0;
    var canceled = false;
    var hasError = false;
    var listeners = Object.create(null);
    var readyTasks = [];
    // for cycle detection:
    var readyToCheck = []; // tasks that have been identified as reachable
    // without the possibility of returning to an ancestor task
    var uncheckedDependencies = {};
    Object.keys(tasks).forEach((key)=>{
        var task = tasks[key];
        if (!Array.isArray(task)) {
            // no dependencies
            enqueueTask(key, [
                task
            ]);
            readyToCheck.push(key);
            return;
        }
        var dependencies = task.slice(0, task.length - 1);
        var remainingDependencies = dependencies.length;
        if (remainingDependencies === 0) {
            enqueueTask(key, task);
            readyToCheck.push(key);
            return;
        }
        uncheckedDependencies[key] = remainingDependencies;
        dependencies.forEach((dependencyName)=>{
            if (!tasks[dependencyName]) throw new Error("async.auto task `" + key + "` has a non-existent dependency `" + dependencyName + "` in " + dependencies.join(", "));
            addListener(dependencyName, ()=>{
                remainingDependencies--;
                if (remainingDependencies === 0) enqueueTask(key, task);
            });
        });
    });
    checkForDeadlocks();
    processQueue();
    function enqueueTask(key, task) {
        readyTasks.push(()=>runTask(key, task));
    }
    function processQueue() {
        if (canceled) return;
        if (readyTasks.length === 0 && runningTasks === 0) return callback(null, results);
        while(readyTasks.length && runningTasks < concurrency){
            var run = readyTasks.shift();
            run();
        }
    }
    function addListener(taskName, fn) {
        var taskListeners = listeners[taskName];
        if (!taskListeners) taskListeners = listeners[taskName] = [];
        taskListeners.push(fn);
    }
    function taskComplete(taskName) {
        var taskListeners = listeners[taskName] || [];
        taskListeners.forEach((fn)=>fn());
        processQueue();
    }
    function runTask(key, task) {
        if (hasError) return;
        var taskCallback = $63690b4f22172e23$var$onlyOnce((err, ...result)=>{
            runningTasks--;
            if (err === false) {
                canceled = true;
                return;
            }
            if (result.length < 2) [result] = result;
            if (err) {
                var safeResults = {};
                Object.keys(results).forEach((rkey)=>{
                    safeResults[rkey] = results[rkey];
                });
                safeResults[key] = result;
                hasError = true;
                listeners = Object.create(null);
                if (canceled) return;
                callback(err, safeResults);
            } else {
                results[key] = result;
                taskComplete(key);
            }
        });
        runningTasks++;
        var taskFn = $63690b4f22172e23$var$wrapAsync(task[task.length - 1]);
        if (task.length > 1) taskFn(results, taskCallback);
        else taskFn(taskCallback);
    }
    function checkForDeadlocks() {
        // Kahn's algorithm
        // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
        // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
        var currentTask;
        var counter = 0;
        while(readyToCheck.length){
            currentTask = readyToCheck.pop();
            counter++;
            getDependents(currentTask).forEach((dependent)=>{
                if (--uncheckedDependencies[dependent] === 0) readyToCheck.push(dependent);
            });
        }
        if (counter !== numTasks) throw new Error("async.auto cannot execute tasks due to a recursive dependency");
    }
    function getDependents(taskName) {
        var result = [];
        Object.keys(tasks).forEach((key)=>{
            const task = tasks[key];
            if (Array.isArray(task) && task.indexOf(taskName) >= 0) result.push(key);
        });
        return result;
    }
    return callback[$63690b4f22172e23$var$PROMISE_SYMBOL];
}
var $63690b4f22172e23$var$FN_ARGS = /^(?:async\s)?(?:function)?\s*(?:\w+\s*)?\(([^)]+)\)(?:\s*{)/;
var $63690b4f22172e23$var$ARROW_FN_ARGS = /^(?:async\s)?\s*(?:\(\s*)?((?:[^)=\s]\s*)*)(?:\)\s*)?=>/;
var $63690b4f22172e23$var$FN_ARG_SPLIT = /,/;
var $63690b4f22172e23$var$FN_ARG = /(=.+)?(\s*)$/;
function $63690b4f22172e23$var$stripComments(string) {
    let stripped = "";
    let index = 0;
    let endBlockComment = string.indexOf("*/");
    while(index < string.length){
        if (string[index] === "/" && string[index + 1] === "/") {
            // inline comment
            let endIndex = string.indexOf("\n", index);
            index = endIndex === -1 ? string.length : endIndex;
        } else if (endBlockComment !== -1 && string[index] === "/" && string[index + 1] === "*") {
            // block comment
            let endIndex = string.indexOf("*/", index);
            if (endIndex !== -1) {
                index = endIndex + 2;
                endBlockComment = string.indexOf("*/", index);
            } else {
                stripped += string[index];
                index++;
            }
        } else {
            stripped += string[index];
            index++;
        }
    }
    return stripped;
}
function $63690b4f22172e23$var$parseParams(func) {
    const src = $63690b4f22172e23$var$stripComments(func.toString());
    let match = src.match($63690b4f22172e23$var$FN_ARGS);
    if (!match) match = src.match($63690b4f22172e23$var$ARROW_FN_ARGS);
    if (!match) throw new Error("could not parse args in autoInject\nSource:\n" + src);
    let [, args] = match;
    return args.replace(/\s/g, "").split($63690b4f22172e23$var$FN_ARG_SPLIT).map((arg)=>arg.replace($63690b4f22172e23$var$FN_ARG, "").trim());
}
/**
 * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
 * tasks are specified as parameters to the function, after the usual callback
 * parameter, with the parameter names matching the names of the tasks it
 * depends on. This can provide even more readable task graphs which can be
 * easier to maintain.
 *
 * If a final callback is specified, the task results are similarly injected,
 * specified as named parameters after the initial error parameter.
 *
 * The autoInject function is purely syntactic sugar and its semantics are
 * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
 *
 * @name autoInject
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.auto]{@link module:ControlFlow.auto}
 * @category Control Flow
 * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
 * the form 'func([dependencies...], callback). The object's key of a property
 * serves as the name of the task defined by that property, i.e. can be used
 * when specifying requirements for other tasks.
 * * The `callback` parameter is a `callback(err, result)` which must be called
 *   when finished, passing an `error` (which can be `null`) and the result of
 *   the function's execution. The remaining parameters name other tasks on
 *   which the task is dependent, and the results from those tasks are the
 *   arguments of those parameters.
 * @param {Function} [callback] - An optional callback which is called when all
 * the tasks have been completed. It receives the `err` argument if any `tasks`
 * pass an error to their callback, and a `results` object with any completed
 * task results, similar to `auto`.
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * //  The example from `auto` can be rewritten as follows:
 * async.autoInject({
 *     get_data: function(callback) {
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: function(get_data, make_folder, callback) {
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     },
 *     email_link: function(write_file, callback) {
 *         // once the file is written let's email a link to it...
 *         // write_file contains the filename returned by write_file.
 *         callback(null, {'file':write_file, 'email':'user@example.com'});
 *     }
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('email_link = ', results.email_link);
 * });
 *
 * // If you are using a JS minifier that mangles parameter names, `autoInject`
 * // will not work with plain functions, since the parameter names will be
 * // collapsed to a single letter identifier.  To work around this, you can
 * // explicitly specify the names of the parameters your task function needs
 * // in an array, similar to Angular.js dependency injection.
 *
 * // This still has an advantage over plain `auto`, since the results a task
 * // depends on are still spread into arguments.
 * async.autoInject({
 *     //...
 *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(write_file, callback) {
 *         callback(null, {'file':write_file, 'email':'user@example.com'});
 *     }]
 *     //...
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('email_link = ', results.email_link);
 * });
 */ function $63690b4f22172e23$export$868ec1c38c3c8735(tasks, callback) {
    var newTasks = {};
    Object.keys(tasks).forEach((key)=>{
        var taskFn = tasks[key];
        var params;
        var fnIsAsync = $63690b4f22172e23$var$isAsync(taskFn);
        var hasNoDeps = !fnIsAsync && taskFn.length === 1 || fnIsAsync && taskFn.length === 0;
        if (Array.isArray(taskFn)) {
            params = [
                ...taskFn
            ];
            taskFn = params.pop();
            newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
        } else if (hasNoDeps) // no dependencies, use the function as-is
        newTasks[key] = taskFn;
        else {
            params = $63690b4f22172e23$var$parseParams(taskFn);
            if (taskFn.length === 0 && !fnIsAsync && params.length === 0) throw new Error("autoInject task functions require explicit parameters.");
            // remove callback param
            if (!fnIsAsync) params.pop();
            newTasks[key] = params.concat(newTask);
        }
        function newTask(results, taskCb) {
            var newArgs = params.map((name)=>results[name]);
            newArgs.push(taskCb);
            $63690b4f22172e23$var$wrapAsync(taskFn)(...newArgs);
        }
    });
    return $63690b4f22172e23$export$dfb5619354ba860(newTasks, callback);
}
// Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
// used for queues. This implementation assumes that the node provided by the user can be modified
// to adjust the next and last properties. We implement only the minimal functionality
// for queue support.
class $63690b4f22172e23$var$DLL {
    constructor(){
        this.head = this.tail = null;
        this.length = 0;
    }
    removeLink(node) {
        if (node.prev) node.prev.next = node.next;
        else this.head = node.next;
        if (node.next) node.next.prev = node.prev;
        else this.tail = node.prev;
        node.prev = node.next = null;
        this.length -= 1;
        return node;
    }
    empty() {
        while(this.head)this.shift();
        return this;
    }
    insertAfter(node, newNode) {
        newNode.prev = node;
        newNode.next = node.next;
        if (node.next) node.next.prev = newNode;
        else this.tail = newNode;
        node.next = newNode;
        this.length += 1;
    }
    insertBefore(node, newNode) {
        newNode.prev = node.prev;
        newNode.next = node;
        if (node.prev) node.prev.next = newNode;
        else this.head = newNode;
        node.prev = newNode;
        this.length += 1;
    }
    unshift(node) {
        if (this.head) this.insertBefore(this.head, node);
        else $63690b4f22172e23$var$setInitial(this, node);
    }
    push(node) {
        if (this.tail) this.insertAfter(this.tail, node);
        else $63690b4f22172e23$var$setInitial(this, node);
    }
    shift() {
        return this.head && this.removeLink(this.head);
    }
    pop() {
        return this.tail && this.removeLink(this.tail);
    }
    toArray() {
        return [
            ...this
        ];
    }
    *[Symbol.iterator]() {
        var cur = this.head;
        while(cur){
            yield cur.data;
            cur = cur.next;
        }
    }
    remove(testFn) {
        var curr = this.head;
        while(curr){
            var { next: next } = curr;
            if (testFn(curr)) this.removeLink(curr);
            curr = next;
        }
        return this;
    }
}
function $63690b4f22172e23$var$setInitial(dll, node) {
    dll.length = 1;
    dll.head = dll.tail = node;
}
function $63690b4f22172e23$var$queue$1(worker, concurrency, payload) {
    if (concurrency == null) concurrency = 1;
    else if (concurrency === 0) throw new RangeError("Concurrency must not be zero");
    var _worker = $63690b4f22172e23$var$wrapAsync(worker);
    var numRunning = 0;
    var workersList = [];
    const events = {
        error: [],
        drain: [],
        saturated: [],
        unsaturated: [],
        empty: []
    };
    function on(event, handler) {
        events[event].push(handler);
    }
    function once(event, handler) {
        const handleAndRemove = (...args)=>{
            off(event, handleAndRemove);
            handler(...args);
        };
        events[event].push(handleAndRemove);
    }
    function off(event, handler) {
        if (!event) return Object.keys(events).forEach((ev)=>events[ev] = []);
        if (!handler) return events[event] = [];
        events[event] = events[event].filter((ev)=>ev !== handler);
    }
    function trigger(event, ...args) {
        events[event].forEach((handler)=>handler(...args));
    }
    var processingScheduled = false;
    function _insert(data, insertAtFront, rejectOnError, callback) {
        if (callback != null && typeof callback !== "function") throw new Error("task callback must be a function");
        q.started = true;
        var res, rej;
        function promiseCallback(err, ...args) {
            // we don't care about the error, let the global error handler
            // deal with it
            if (err) return rejectOnError ? rej(err) : res();
            if (args.length <= 1) return res(args[0]);
            res(args);
        }
        var item = q._createTaskItem(data, rejectOnError ? promiseCallback : callback || promiseCallback);
        if (insertAtFront) q._tasks.unshift(item);
        else q._tasks.push(item);
        if (!processingScheduled) {
            processingScheduled = true;
            $63690b4f22172e23$export$c233f08fbfea0913(()=>{
                processingScheduled = false;
                q.process();
            });
        }
        if (rejectOnError || !callback) return new Promise((resolve, reject)=>{
            res = resolve;
            rej = reject;
        });
    }
    function _createCB(tasks) {
        return function(err, ...args) {
            numRunning -= 1;
            for(var i = 0, l = tasks.length; i < l; i++){
                var task = tasks[i];
                var index = workersList.indexOf(task);
                if (index === 0) workersList.shift();
                else if (index > 0) workersList.splice(index, 1);
                task.callback(err, ...args);
                if (err != null) trigger("error", err, task.data);
            }
            if (numRunning <= q.concurrency - q.buffer) trigger("unsaturated");
            if (q.idle()) trigger("drain");
            q.process();
        };
    }
    function _maybeDrain(data) {
        if (data.length === 0 && q.idle()) {
            // call drain immediately if there are no tasks
            $63690b4f22172e23$export$c233f08fbfea0913(()=>trigger("drain"));
            return true;
        }
        return false;
    }
    const eventMethod = (name)=>(handler)=>{
            if (!handler) return new Promise((resolve, reject)=>{
                once(name, (err, data)=>{
                    if (err) return reject(err);
                    resolve(data);
                });
            });
            off(name);
            on(name, handler);
        };
    var isProcessing = false;
    var q = {
        _tasks: new $63690b4f22172e23$var$DLL(),
        _createTaskItem (data, callback) {
            return {
                data: data,
                callback: callback
            };
        },
        *[Symbol.iterator] () {
            yield* q._tasks[Symbol.iterator]();
        },
        concurrency: concurrency,
        payload: payload,
        buffer: concurrency / 4,
        started: false,
        paused: false,
        push (data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map((datum)=>_insert(datum, false, false, callback));
            }
            return _insert(data, false, false, callback);
        },
        pushAsync (data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map((datum)=>_insert(datum, false, true, callback));
            }
            return _insert(data, false, true, callback);
        },
        kill () {
            off();
            q._tasks.empty();
        },
        unshift (data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map((datum)=>_insert(datum, true, false, callback));
            }
            return _insert(data, true, false, callback);
        },
        unshiftAsync (data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map((datum)=>_insert(datum, true, true, callback));
            }
            return _insert(data, true, true, callback);
        },
        remove (testFn) {
            q._tasks.remove(testFn);
        },
        process () {
            // Avoid trying to start too many processing operations. This can occur
            // when callbacks resolve synchronously (#1267).
            if (isProcessing) return;
            isProcessing = true;
            while(!q.paused && numRunning < q.concurrency && q._tasks.length){
                var tasks = [], data = [];
                var l = q._tasks.length;
                if (q.payload) l = Math.min(l, q.payload);
                for(var i = 0; i < l; i++){
                    var node = q._tasks.shift();
                    tasks.push(node);
                    workersList.push(node);
                    data.push(node.data);
                }
                numRunning += 1;
                if (q._tasks.length === 0) trigger("empty");
                if (numRunning === q.concurrency) trigger("saturated");
                var cb = $63690b4f22172e23$var$onlyOnce(_createCB(tasks));
                _worker(data, cb);
            }
            isProcessing = false;
        },
        length () {
            return q._tasks.length;
        },
        running () {
            return numRunning;
        },
        workersList () {
            return workersList;
        },
        idle () {
            return q._tasks.length + numRunning === 0;
        },
        pause () {
            q.paused = true;
        },
        resume () {
            if (q.paused === false) return;
            q.paused = false;
            $63690b4f22172e23$export$c233f08fbfea0913(q.process);
        }
    };
    // define these as fixed properties, so people get useful errors when updating
    Object.defineProperties(q, {
        saturated: {
            writable: false,
            value: eventMethod("saturated")
        },
        unsaturated: {
            writable: false,
            value: eventMethod("unsaturated")
        },
        empty: {
            writable: false,
            value: eventMethod("empty")
        },
        drain: {
            writable: false,
            value: eventMethod("drain")
        },
        error: {
            writable: false,
            value: eventMethod("error")
        }
    });
    return q;
}
/**
 * Creates a `cargo` object with the specified payload. Tasks added to the
 * cargo will be processed altogether (up to the `payload` limit). If the
 * `worker` is in progress, the task is queued until it becomes available. Once
 * the `worker` has completed some tasks, each callback of those tasks is
 * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
 * for how `cargo` and `queue` work.
 *
 * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
 * at a time, cargo passes an array of tasks to a single worker, repeating
 * when the worker is finished.
 *
 * @name cargo
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @category Control Flow
 * @param {AsyncFunction} worker - An asynchronous function for processing an array
 * of queued tasks. Invoked with `(tasks, callback)`.
 * @param {number} [payload=Infinity] - An optional `integer` for determining
 * how many tasks should be processed per round; if omitted, the default is
 * unlimited.
 * @returns {module:ControlFlow.QueueObject} A cargo object to manage the tasks. Callbacks can
 * attached as certain properties to listen for specific events during the
 * lifecycle of the cargo and inner queue.
 * @example
 *
 * // create a cargo object with payload 2
 * var cargo = async.cargo(function(tasks, callback) {
 *     for (var i=0; i<tasks.length; i++) {
 *         console.log('hello ' + tasks[i].name);
 *     }
 *     callback();
 * }, 2);
 *
 * // add some items
 * cargo.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * cargo.push({name: 'bar'}, function(err) {
 *     console.log('finished processing bar');
 * });
 * await cargo.push({name: 'baz'});
 * console.log('finished processing baz');
 */ function $63690b4f22172e23$export$f9549d7e5aef7637(worker, payload) {
    return $63690b4f22172e23$var$queue$1(worker, 1, payload);
}
/**
 * Creates a `cargoQueue` object with the specified payload. Tasks added to the
 * cargoQueue will be processed together (up to the `payload` limit) in `concurrency` parallel workers.
 * If the all `workers` are in progress, the task is queued until one becomes available. Once
 * a `worker` has completed some tasks, each callback of those tasks is
 * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
 * for how `cargo` and `queue` work.
 *
 * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
 * at a time, and [`cargo`]{@link module:ControlFlow.cargo} passes an array of tasks to a single worker,
 * the cargoQueue passes an array of tasks to multiple parallel workers.
 *
 * @name cargoQueue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @see [async.cargo]{@link module:ControlFLow.cargo}
 * @category Control Flow
 * @param {AsyncFunction} worker - An asynchronous function for processing an array
 * of queued tasks. Invoked with `(tasks, callback)`.
 * @param {number} [concurrency=1] - An `integer` for determining how many
 * `worker` functions should be run in parallel.  If omitted, the concurrency
 * defaults to `1`.  If the concurrency is `0`, an error is thrown.
 * @param {number} [payload=Infinity] - An optional `integer` for determining
 * how many tasks should be processed per round; if omitted, the default is
 * unlimited.
 * @returns {module:ControlFlow.QueueObject} A cargoQueue object to manage the tasks. Callbacks can
 * attached as certain properties to listen for specific events during the
 * lifecycle of the cargoQueue and inner queue.
 * @example
 *
 * // create a cargoQueue object with payload 2 and concurrency 2
 * var cargoQueue = async.cargoQueue(function(tasks, callback) {
 *     for (var i=0; i<tasks.length; i++) {
 *         console.log('hello ' + tasks[i].name);
 *     }
 *     callback();
 * }, 2, 2);
 *
 * // add some items
 * cargoQueue.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * cargoQueue.push({name: 'bar'}, function(err) {
 *     console.log('finished processing bar');
 * });
 * cargoQueue.push({name: 'baz'}, function(err) {
 *     console.log('finished processing baz');
 * });
 * cargoQueue.push({name: 'boo'}, function(err) {
 *     console.log('finished processing boo');
 * });
 */ function $63690b4f22172e23$export$687de40d137ed486(worker, concurrency, payload) {
    return $63690b4f22172e23$var$queue$1(worker, concurrency, payload);
}
/**
 * Reduces `coll` into a single value using an async `iteratee` to return each
 * successive step. `memo` is the initial state of the reduction. This function
 * only operates in series.
 *
 * For performance reasons, it may make sense to split a call to this function
 * into a parallel map, and then use the normal `Array.prototype.reduce` on the
 * results. This function is for situations where each step in the reduction
 * needs to be async; if you can get the data before reducing it, then it's
 * probably a good idea to do so.
 *
 * @name reduce
 * @static
 * @memberOf module:Collections
 * @method
 * @alias inject
 * @alias foldl
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {*} memo - The initial state of the reduction.
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * array to produce the next step in the reduction.
 * The `iteratee` should complete with the next state of the reduction.
 * If the iteratee completes with an error, the reduction is stopped and the
 * main `callback` is immediately called with the error.
 * Invoked with (memo, item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the reduced value. Invoked with
 * (err, result).
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * // file1.txt is a file that is 1000 bytes in size
 * // file2.txt is a file that is 2000 bytes in size
 * // file3.txt is a file that is 3000 bytes in size
 * // file4.txt does not exist
 *
 * const fileList = ['file1.txt','file2.txt','file3.txt'];
 * const withMissingFileList = ['file1.txt','file2.txt','file3.txt', 'file4.txt'];
 *
 * // asynchronous function that computes the file size in bytes
 * // file size is added to the memoized value, then returned
 * function getFileSizeInBytes(memo, file, callback) {
 *     fs.stat(file, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         callback(null, memo + stat.size);
 *     });
 * }
 *
 * // Using callbacks
 * async.reduce(fileList, 0, getFileSizeInBytes, function(err, result) {
 *     if (err) {
 *         console.log(err);
 *     } else {
 *         console.log(result);
 *         // 6000
 *         // which is the sum of the file sizes of the three files
 *     }
 * });
 *
 * // Error Handling
 * async.reduce(withMissingFileList, 0, getFileSizeInBytes, function(err, result) {
 *     if (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     } else {
 *         console.log(result);
 *     }
 * });
 *
 * // Using Promises
 * async.reduce(fileList, 0, getFileSizeInBytes)
 * .then( result => {
 *     console.log(result);
 *     // 6000
 *     // which is the sum of the file sizes of the three files
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Error Handling
 * async.reduce(withMissingFileList, 0, getFileSizeInBytes)
 * .then( result => {
 *     console.log(result);
 * }).catch( err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.reduce(fileList, 0, getFileSizeInBytes);
 *         console.log(result);
 *         // 6000
 *         // which is the sum of the file sizes of the three files
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         let result = await async.reduce(withMissingFileList, 0, getFileSizeInBytes);
 *         console.log(result);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$reduce(coll, memo, iteratee, callback) {
    callback = $63690b4f22172e23$var$once(callback);
    var _iteratee = $63690b4f22172e23$var$wrapAsync(iteratee);
    return $63690b4f22172e23$export$750e7e5fea3b0654(coll, (x, i, iterCb)=>{
        _iteratee(memo, x, (err, v)=>{
            memo = v;
            iterCb(err);
        });
    }, (err)=>callback(err, memo));
}
var $63690b4f22172e23$export$50ae948ca12cdcbc = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$reduce, 4);
/**
 * Version of the compose function that is more natural to read. Each function
 * consumes the return value of the previous function. It is the equivalent of
 * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
 *
 * Each function is executed with the `this` binding of the composed function.
 *
 * @name seq
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.compose]{@link module:ControlFlow.compose}
 * @category Control Flow
 * @param {...AsyncFunction} functions - the asynchronous functions to compose
 * @returns {Function} a function that composes the `functions` in order
 * @example
 *
 * // Requires lodash (or underscore), express3 and dresende's orm2.
 * // Part of an app, that fetches cats of the logged user.
 * // This example uses `seq` function to avoid overnesting and error
 * // handling clutter.
 * app.get('/cats', function(request, response) {
 *     var User = request.models.User;
 *     async.seq(
 *         User.get.bind(User),  // 'User.get' has signature (id, callback(err, data))
 *         function(user, fn) {
 *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
 *         }
 *     )(req.session.user_id, function (err, cats) {
 *         if (err) {
 *             console.error(err);
 *             response.json({ status: 'error', message: err.message });
 *         } else {
 *             response.json({ status: 'ok', message: 'Cats found', data: cats });
 *         }
 *     });
 * });
 */ function $63690b4f22172e23$export$1041d4276c328e4d(...functions) {
    var _functions = functions.map($63690b4f22172e23$var$wrapAsync);
    return function(...args) {
        var that = this;
        var cb = args[args.length - 1];
        if (typeof cb == "function") args.pop();
        else cb = $63690b4f22172e23$var$promiseCallback();
        $63690b4f22172e23$export$50ae948ca12cdcbc(_functions, args, (newargs, fn, iterCb)=>{
            fn.apply(that, newargs.concat((err, ...nextargs)=>{
                iterCb(err, nextargs);
            }));
        }, (err, results)=>cb(err, ...results));
        return cb[$63690b4f22172e23$var$PROMISE_SYMBOL];
    };
}
/**
 * Creates a function which is a composition of the passed asynchronous
 * functions. Each function consumes the return value of the function that
 * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
 * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
 *
 * If the last argument to the composed function is not a function, a promise
 * is returned when you call it.
 *
 * Each function is executed with the `this` binding of the composed function.
 *
 * @name compose
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {...AsyncFunction} functions - the asynchronous functions to compose
 * @returns {Function} an asynchronous function that is the composed
 * asynchronous `functions`
 * @example
 *
 * function add1(n, callback) {
 *     setTimeout(function () {
 *         callback(null, n + 1);
 *     }, 10);
 * }
 *
 * function mul3(n, callback) {
 *     setTimeout(function () {
 *         callback(null, n * 3);
 *     }, 10);
 * }
 *
 * var add1mul3 = async.compose(mul3, add1);
 * add1mul3(4, function (err, result) {
 *     // result now equals 15
 * });
 */ function $63690b4f22172e23$export$f672e0b6f7222cd7(...args) {
    return $63690b4f22172e23$export$1041d4276c328e4d(...args.reverse());
}
/**
 * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
 *
 * @name mapLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an array of the
 * transformed items from the `coll`. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$var$mapLimit(coll, limit, iteratee, callback) {
    return $63690b4f22172e23$var$_asyncMap($63690b4f22172e23$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $63690b4f22172e23$export$6a28d19bcc59197c = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$mapLimit, 4);
/**
 * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
 *
 * @name concatLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.concat]{@link module:Collections.concat}
 * @category Collection
 * @alias flatMapLimit
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
 * which should use an array as its result. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 * @returns A Promise, if no callback is passed
 */ function $63690b4f22172e23$var$concatLimit(coll, limit, iteratee, callback) {
    var _iteratee = $63690b4f22172e23$var$wrapAsync(iteratee);
    return $63690b4f22172e23$export$6a28d19bcc59197c(coll, limit, (val, iterCb)=>{
        _iteratee(val, (err, ...args)=>{
            if (err) return iterCb(err);
            return iterCb(err, args);
        });
    }, (err, mapResults)=>{
        var result = [];
        for(var i = 0; i < mapResults.length; i++)if (mapResults[i]) result = result.concat(...mapResults[i]);
        return callback(err, result);
    });
}
var $63690b4f22172e23$export$4f1520afe59a31db = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$concatLimit, 4);
/**
 * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
 * the concatenated list. The `iteratee`s are called in parallel, and the
 * results are concatenated as they return. The results array will be returned in
 * the original order of `coll` passed to the `iteratee` function.
 *
 * @name concat
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @alias flatMap
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
 * which should use an array as its result. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 * @returns A Promise, if no callback is passed
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * let directoryList = ['dir1','dir2','dir3'];
 * let withMissingDirectoryList = ['dir1','dir2','dir3', 'dir4'];
 *
 * // Using callbacks
 * async.concat(directoryList, fs.readdir, function(err, results) {
 *    if (err) {
 *        console.log(err);
 *    } else {
 *        console.log(results);
 *        // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
 *    }
 * });
 *
 * // Error Handling
 * async.concat(withMissingDirectoryList, fs.readdir, function(err, results) {
 *    if (err) {
 *        console.log(err);
 *        // [ Error: ENOENT: no such file or directory ]
 *        // since dir4 does not exist
 *    } else {
 *        console.log(results);
 *    }
 * });
 *
 * // Using Promises
 * async.concat(directoryList, fs.readdir)
 * .then(results => {
 *     console.log(results);
 *     // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
 * }).catch(err => {
 *      console.log(err);
 * });
 *
 * // Error Handling
 * async.concat(withMissingDirectoryList, fs.readdir)
 * .then(results => {
 *     console.log(results);
 * }).catch(err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 *     // since dir4 does not exist
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let results = await async.concat(directoryList, fs.readdir);
 *         console.log(results);
 *         // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
 *     } catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         let results = await async.concat(withMissingDirectoryList, fs.readdir);
 *         console.log(results);
 *     } catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *         // since dir4 does not exist
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$concat(coll, iteratee, callback) {
    return $63690b4f22172e23$export$4f1520afe59a31db(coll, Infinity, iteratee, callback);
}
var $63690b4f22172e23$export$ee1b3e54f0441b22 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$concat, 3);
/**
 * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
 *
 * @name concatSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.concat]{@link module:Collections.concat}
 * @category Collection
 * @alias flatMapSeries
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
 * The iteratee should complete with an array an array of results.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 * @returns A Promise, if no callback is passed
 */ function $63690b4f22172e23$var$concatSeries(coll, iteratee, callback) {
    return $63690b4f22172e23$export$4f1520afe59a31db(coll, 1, iteratee, callback);
}
var $63690b4f22172e23$export$b6df61d74da01b63 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$concatSeries, 3);
/**
 * Returns a function that when called, calls-back with the values provided.
 * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
 * [`auto`]{@link module:ControlFlow.auto}.
 *
 * @name constant
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {...*} arguments... - Any number of arguments to automatically invoke
 * callback with.
 * @returns {AsyncFunction} Returns a function that when invoked, automatically
 * invokes the callback with the previous given arguments.
 * @example
 *
 * async.waterfall([
 *     async.constant(42),
 *     function (value, next) {
 *         // value === 42
 *     },
 *     //...
 * ], callback);
 *
 * async.waterfall([
 *     async.constant(filename, "utf8"),
 *     fs.readFile,
 *     function (fileData, next) {
 *         //...
 *     }
 *     //...
 * ], callback);
 *
 * async.auto({
 *     hostname: async.constant("https://server.net/"),
 *     port: findFreePort,
 *     launchServer: ["hostname", "port", function (options, cb) {
 *         startServer(options, cb);
 *     }],
 *     //...
 * }, callback);
 */ function $63690b4f22172e23$export$c983f826f44ff86(...args) {
    return function(...ignoredArgs /*, callback*/ ) {
        var callback = ignoredArgs.pop();
        return callback(null, ...args);
    };
}
function $63690b4f22172e23$var$_createTester(check, getResult) {
    return (eachfn, arr, _iteratee, cb)=>{
        var testPassed = false;
        var testResult;
        const iteratee = $63690b4f22172e23$var$wrapAsync(_iteratee);
        eachfn(arr, (value, _, callback)=>{
            iteratee(value, (err, result)=>{
                if (err || err === false) return callback(err);
                if (check(result) && !testResult) {
                    testPassed = true;
                    testResult = getResult(true, value);
                    return callback(null, $63690b4f22172e23$var$breakLoop);
                }
                callback();
            });
        }, (err)=>{
            if (err) return cb(err);
            cb(null, testPassed ? testResult : getResult(false));
        });
    };
}
/**
 * Returns the first value in `coll` that passes an async truth test. The
 * `iteratee` is applied in parallel, meaning the first iteratee to return
 * `true` will fire the detect `callback` with that result. That means the
 * result might not be the first item in the original `coll` (in terms of order)
 * that passes the test.

 * If order within the original `coll` is important, then look at
 * [`detectSeries`]{@link module:Collections.detectSeries}.
 *
 * @name detect
 * @static
 * @memberOf module:Collections
 * @method
 * @alias find
 * @category Collections
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 *
 * // asynchronous function that checks if a file exists
 * function fileExists(file, callback) {
 *    fs.access(file, fs.constants.F_OK, (err) => {
 *        callback(null, !err);
 *    });
 * }
 *
 * async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists,
 *    function(err, result) {
 *        console.log(result);
 *        // dir1/file1.txt
 *        // result now equals the first file in the list that exists
 *    }
 *);
 *
 * // Using Promises
 * async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists)
 * .then(result => {
 *     console.log(result);
 *     // dir1/file1.txt
 *     // result now equals the first file in the list that exists
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists);
 *         console.log(result);
 *         // dir1/file1.txt
 *         // result now equals the file in the list that exists
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$detect(coll, iteratee, callback) {
    return $63690b4f22172e23$var$_createTester((bool)=>bool, (res, item)=>item)($63690b4f22172e23$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $63690b4f22172e23$export$17b446b869dad473 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$detect, 3);
/**
 * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name detectLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.detect]{@link module:Collections.detect}
 * @alias findLimit
 * @category Collections
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $63690b4f22172e23$var$detectLimit(coll, limit, iteratee, callback) {
    return $63690b4f22172e23$var$_createTester((bool)=>bool, (res, item)=>item)($63690b4f22172e23$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $63690b4f22172e23$export$922bcf02f3a5b284 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$detectLimit, 4);
/**
 * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
 *
 * @name detectSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.detect]{@link module:Collections.detect}
 * @alias findSeries
 * @category Collections
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $63690b4f22172e23$var$detectSeries(coll, iteratee, callback) {
    return $63690b4f22172e23$var$_createTester((bool)=>bool, (res, item)=>item)($63690b4f22172e23$var$eachOfLimit$2(1), coll, iteratee, callback);
}
var $63690b4f22172e23$export$922a9a31d0cff2ee = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$detectSeries, 3);
function $63690b4f22172e23$var$consoleFunc(name) {
    return (fn, ...args)=>$63690b4f22172e23$var$wrapAsync(fn)(...args, (err, ...resultArgs)=>{
            /* istanbul ignore else */ if (typeof console === "object") {
                /* istanbul ignore else */ if (err) /* istanbul ignore else */ {
                    if (console.error) console.error(err);
                } else if (console[name]) resultArgs.forEach((x)=>console[name](x));
            }
        });
}
/**
 * Logs the result of an [`async` function]{@link AsyncFunction} to the
 * `console` using `console.dir` to display the properties of the resulting object.
 * Only works in Node.js or in browsers that support `console.dir` and
 * `console.error` (such as FF and Chrome).
 * If multiple arguments are returned from the async function,
 * `console.dir` is called on each argument in order.
 *
 * @name dir
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} function - The function you want to eventually apply
 * all arguments to.
 * @param {...*} arguments... - Any number of arguments to apply to the function.
 * @example
 *
 * // in a module
 * var hello = function(name, callback) {
 *     setTimeout(function() {
 *         callback(null, {hello: name});
 *     }, 1000);
 * };
 *
 * // in the node repl
 * node> async.dir(hello, 'world');
 * {hello: 'world'}
 */ var $63690b4f22172e23$export$147ec2801e896265 = $63690b4f22172e23$var$consoleFunc("dir");
/**
 * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
 * the order of operations, the arguments `test` and `iteratee` are switched.
 *
 * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
 *
 * @name doWhilst
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {AsyncFunction} iteratee - A function which is called each time `test`
 * passes. Invoked with (callback).
 * @param {AsyncFunction} test - asynchronous truth test to perform after each
 * execution of `iteratee`. Invoked with (...args, callback), where `...args` are the
 * non-error args from the previous callback of `iteratee`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `iteratee` has stopped.
 * `callback` will be passed an error and any arguments passed to the final
 * `iteratee`'s callback. Invoked with (err, [results]);
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$var$doWhilst(iteratee, test, callback) {
    callback = $63690b4f22172e23$var$onlyOnce(callback);
    var _fn = $63690b4f22172e23$var$wrapAsync(iteratee);
    var _test = $63690b4f22172e23$var$wrapAsync(test);
    var results;
    function next(err, ...args) {
        if (err) return callback(err);
        if (err === false) return;
        results = args;
        _test(...args, check);
    }
    function check(err, truth) {
        if (err) return callback(err);
        if (err === false) return;
        if (!truth) return callback(null, ...results);
        _fn(next);
    }
    return check(null, true);
}
var $63690b4f22172e23$export$df0899fd4acbef10 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$doWhilst, 3);
/**
 * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
 * argument ordering differs from `until`.
 *
 * @name doUntil
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
 * @category Control Flow
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` fails. Invoked with (callback).
 * @param {AsyncFunction} test - asynchronous truth test to perform after each
 * execution of `iteratee`. Invoked with (...args, callback), where `...args` are the
 * non-error args from the previous callback of `iteratee`
 * @param {Function} [callback] - A callback which is called after the test
 * function has passed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$export$16f3a0560cc13fb4(iteratee, test, callback) {
    const _test = $63690b4f22172e23$var$wrapAsync(test);
    return $63690b4f22172e23$export$df0899fd4acbef10(iteratee, (...args)=>{
        const cb = args.pop();
        _test(...args, (err, truth)=>cb(err, !truth));
    }, callback);
}
function $63690b4f22172e23$var$_withoutIndex(iteratee) {
    return (value, index, callback)=>iteratee(value, callback);
}
/**
 * Applies the function `iteratee` to each item in `coll`, in parallel.
 * The `iteratee` is called with an item from the list, and a callback for when
 * it has finished. If the `iteratee` passes an error to its `callback`, the
 * main `callback` (for the `each` function) is immediately called with the
 * error.
 *
 * Note, that since this function applies `iteratee` to each item in parallel,
 * there is no guarantee that the iteratee functions will complete in order.
 *
 * @name each
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEach
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to
 * each item in `coll`. Invoked with (item, callback).
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOf`.
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * const fileList = [ 'dir1/file2.txt', 'dir2/file3.txt', 'dir/file5.txt'];
 * const withMissingFileList = ['dir1/file1.txt', 'dir4/file2.txt'];
 *
 * // asynchronous function that deletes a file
 * const deleteFile = function(file, callback) {
 *     fs.unlink(file, callback);
 * };
 *
 * // Using callbacks
 * async.each(fileList, deleteFile, function(err) {
 *     if( err ) {
 *         console.log(err);
 *     } else {
 *         console.log('All files have been deleted successfully');
 *     }
 * });
 *
 * // Error Handling
 * async.each(withMissingFileList, deleteFile, function(err){
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 *     // since dir4/file2.txt does not exist
 *     // dir1/file1.txt could have been deleted
 * });
 *
 * // Using Promises
 * async.each(fileList, deleteFile)
 * .then( () => {
 *     console.log('All files have been deleted successfully');
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Error Handling
 * async.each(fileList, deleteFile)
 * .then( () => {
 *     console.log('All files have been deleted successfully');
 * }).catch( err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 *     // since dir4/file2.txt does not exist
 *     // dir1/file1.txt could have been deleted
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         await async.each(files, deleteFile);
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         await async.each(withMissingFileList, deleteFile);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *         // since dir4/file2.txt does not exist
 *         // dir1/file1.txt could have been deleted
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$eachLimit$2(coll, iteratee, callback) {
    return $63690b4f22172e23$export$d10d68e43a57bce9(coll, $63690b4f22172e23$var$_withoutIndex($63690b4f22172e23$var$wrapAsync(iteratee)), callback);
}
var $63690b4f22172e23$export$79b2f7037acddd43 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$eachLimit$2, 3);
/**
 * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
 *
 * @name eachLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfLimit`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $63690b4f22172e23$var$eachLimit(coll, limit, iteratee, callback) {
    return $63690b4f22172e23$var$eachOfLimit$2(limit)(coll, $63690b4f22172e23$var$_withoutIndex($63690b4f22172e23$var$wrapAsync(iteratee)), callback);
}
var $63690b4f22172e23$export$2a2080ddac50d6b8 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$eachLimit, 4);
/**
 * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
 *
 * Note, that unlike [`each`]{@link module:Collections.each}, this function applies iteratee to each item
 * in series and therefore the iteratee functions will complete in order.

 * @name eachSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachSeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfSeries`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $63690b4f22172e23$var$eachSeries(coll, iteratee, callback) {
    return $63690b4f22172e23$export$2a2080ddac50d6b8(coll, 1, iteratee, callback);
}
var $63690b4f22172e23$export$9bd663f1fadd104c = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$eachSeries, 3);
/**
 * Wrap an async function and ensure it calls its callback on a later tick of
 * the event loop.  If the function already calls its callback on a next tick,
 * no extra deferral is added. This is useful for preventing stack overflows
 * (`RangeError: Maximum call stack size exceeded`) and generally keeping
 * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
 * contained. ES2017 `async` functions are returned as-is -- they are immune
 * to Zalgo's corrupting influences, as they always resolve on a later tick.
 *
 * @name ensureAsync
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - an async function, one that expects a node-style
 * callback as its last argument.
 * @returns {AsyncFunction} Returns a wrapped function with the exact same call
 * signature as the function passed in.
 * @example
 *
 * function sometimesAsync(arg, callback) {
 *     if (cache[arg]) {
 *         return callback(null, cache[arg]); // this would be synchronous!!
 *     } else {
 *         doSomeIO(arg, callback); // this IO would be asynchronous
 *     }
 * }
 *
 * // this has a risk of stack overflows if many results are cached in a row
 * async.mapSeries(args, sometimesAsync, done);
 *
 * // this will defer sometimesAsync's callback if necessary,
 * // preventing stack overflows
 * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
 */ function $63690b4f22172e23$export$85d5b9ccf228381c(fn) {
    if ($63690b4f22172e23$var$isAsync(fn)) return fn;
    return function(...args /*, callback*/ ) {
        var callback = args.pop();
        var sync = true;
        args.push((...innerArgs)=>{
            if (sync) $63690b4f22172e23$export$c233f08fbfea0913(()=>callback(...innerArgs));
            else callback(...innerArgs);
        });
        fn.apply(this, args);
        sync = false;
    };
}
/**
 * Returns `true` if every element in `coll` satisfies an async test. If any
 * iteratee call returns `false`, the main `callback` is immediately called.
 *
 * @name every
 * @static
 * @memberOf module:Collections
 * @method
 * @alias all
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in parallel.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * const fileList = ['dir1/file1.txt','dir2/file3.txt','dir3/file5.txt'];
 * const withMissingFileList = ['file1.txt','file2.txt','file4.txt'];
 *
 * // asynchronous function that checks if a file exists
 * function fileExists(file, callback) {
 *    fs.access(file, fs.constants.F_OK, (err) => {
 *        callback(null, !err);
 *    });
 * }
 *
 * // Using callbacks
 * async.every(fileList, fileExists, function(err, result) {
 *     console.log(result);
 *     // true
 *     // result is true since every file exists
 * });
 *
 * async.every(withMissingFileList, fileExists, function(err, result) {
 *     console.log(result);
 *     // false
 *     // result is false since NOT every file exists
 * });
 *
 * // Using Promises
 * async.every(fileList, fileExists)
 * .then( result => {
 *     console.log(result);
 *     // true
 *     // result is true since every file exists
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * async.every(withMissingFileList, fileExists)
 * .then( result => {
 *     console.log(result);
 *     // false
 *     // result is false since NOT every file exists
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.every(fileList, fileExists);
 *         console.log(result);
 *         // true
 *         // result is true since every file exists
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * async () => {
 *     try {
 *         let result = await async.every(withMissingFileList, fileExists);
 *         console.log(result);
 *         // false
 *         // result is false since NOT every file exists
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$every(coll, iteratee, callback) {
    return $63690b4f22172e23$var$_createTester((bool)=>!bool, (res)=>!res)($63690b4f22172e23$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $63690b4f22172e23$export$84bf76cd7afc7469 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$every, 3);
/**
 * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
 *
 * @name everyLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.every]{@link module:Collections.every}
 * @alias allLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in parallel.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 */ function $63690b4f22172e23$var$everyLimit(coll, limit, iteratee, callback) {
    return $63690b4f22172e23$var$_createTester((bool)=>!bool, (res)=>!res)($63690b4f22172e23$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $63690b4f22172e23$export$5b469f316a3f1415 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$everyLimit, 4);
/**
 * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
 *
 * @name everySeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.every]{@link module:Collections.every}
 * @alias allSeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in series.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 */ function $63690b4f22172e23$var$everySeries(coll, iteratee, callback) {
    return $63690b4f22172e23$var$_createTester((bool)=>!bool, (res)=>!res)($63690b4f22172e23$export$750e7e5fea3b0654, coll, iteratee, callback);
}
var $63690b4f22172e23$export$c4a4adf74205a63d = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$everySeries, 3);
function $63690b4f22172e23$var$filterArray(eachfn, arr, iteratee, callback) {
    var truthValues = new Array(arr.length);
    eachfn(arr, (x, index, iterCb)=>{
        iteratee(x, (err, v)=>{
            truthValues[index] = !!v;
            iterCb(err);
        });
    }, (err)=>{
        if (err) return callback(err);
        var results = [];
        for(var i = 0; i < arr.length; i++)if (truthValues[i]) results.push(arr[i]);
        callback(null, results);
    });
}
function $63690b4f22172e23$var$filterGeneric(eachfn, coll, iteratee, callback) {
    var results = [];
    eachfn(coll, (x, index, iterCb)=>{
        iteratee(x, (err, v)=>{
            if (err) return iterCb(err);
            if (v) results.push({
                index: index,
                value: x
            });
            iterCb(err);
        });
    }, (err)=>{
        if (err) return callback(err);
        callback(null, results.sort((a, b)=>a.index - b.index).map((v)=>v.value));
    });
}
function $63690b4f22172e23$var$_filter(eachfn, coll, iteratee, callback) {
    var filter = $63690b4f22172e23$var$isArrayLike(coll) ? $63690b4f22172e23$var$filterArray : $63690b4f22172e23$var$filterGeneric;
    return filter(eachfn, coll, $63690b4f22172e23$var$wrapAsync(iteratee), callback);
}
/**
 * Returns a new array of all the values in `coll` which pass an async truth
 * test. This operation is performed in parallel, but the results array will be
 * in the same order as the original.
 *
 * @name filter
 * @static
 * @memberOf module:Collections
 * @method
 * @alias select
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback provided
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 *
 * const files = ['dir1/file1.txt','dir2/file3.txt','dir3/file6.txt'];
 *
 * // asynchronous function that checks if a file exists
 * function fileExists(file, callback) {
 *    fs.access(file, fs.constants.F_OK, (err) => {
 *        callback(null, !err);
 *    });
 * }
 *
 * // Using callbacks
 * async.filter(files, fileExists, function(err, results) {
 *    if(err) {
 *        console.log(err);
 *    } else {
 *        console.log(results);
 *        // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
 *        // results is now an array of the existing files
 *    }
 * });
 *
 * // Using Promises
 * async.filter(files, fileExists)
 * .then(results => {
 *     console.log(results);
 *     // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
 *     // results is now an array of the existing files
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let results = await async.filter(files, fileExists);
 *         console.log(results);
 *         // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
 *         // results is now an array of the existing files
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$filter(coll, iteratee, callback) {
    return $63690b4f22172e23$var$_filter($63690b4f22172e23$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $63690b4f22172e23$export$3dea766d36a8935f = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$filter, 3);
/**
 * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name filterLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @alias selectLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback provided
 */ function $63690b4f22172e23$var$filterLimit(coll, limit, iteratee, callback) {
    return $63690b4f22172e23$var$_filter($63690b4f22172e23$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $63690b4f22172e23$export$6a93acd3681313ac = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$filterLimit, 4);
/**
 * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
 *
 * @name filterSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @alias selectSeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results)
 * @returns {Promise} a promise, if no callback provided
 */ function $63690b4f22172e23$var$filterSeries(coll, iteratee, callback) {
    return $63690b4f22172e23$var$_filter($63690b4f22172e23$export$750e7e5fea3b0654, coll, iteratee, callback);
}
var $63690b4f22172e23$export$ddcc38daaa46257c = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$filterSeries, 3);
/**
 * Calls the asynchronous function `fn` with a callback parameter that allows it
 * to call itself again, in series, indefinitely.

 * If an error is passed to the callback then `errback` is called with the
 * error, and execution stops, otherwise it will never be called.
 *
 * @name forever
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} fn - an async function to call repeatedly.
 * Invoked with (next).
 * @param {Function} [errback] - when `fn` passes an error to it's callback,
 * this function will be called, and execution stops. Invoked with (err).
 * @returns {Promise} a promise that rejects if an error occurs and an errback
 * is not passed
 * @example
 *
 * async.forever(
 *     function(next) {
 *         // next is suitable for passing to things that need a callback(err [, whatever]);
 *         // it will result in this function being called again.
 *     },
 *     function(err) {
 *         // if next is called with a value in its first parameter, it will appear
 *         // in here as 'err', and execution will stop.
 *     }
 * );
 */ function $63690b4f22172e23$var$forever(fn, errback) {
    var done = $63690b4f22172e23$var$onlyOnce(errback);
    var task = $63690b4f22172e23$var$wrapAsync($63690b4f22172e23$export$85d5b9ccf228381c(fn));
    function next(err) {
        if (err) return done(err);
        if (err === false) return;
        task(next);
    }
    return next();
}
var $63690b4f22172e23$export$116a0f7f2303acd8 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$forever, 2);
/**
 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
 *
 * @name groupByLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.groupBy]{@link module:Collections.groupBy}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$var$groupByLimit(coll, limit, iteratee, callback) {
    var _iteratee = $63690b4f22172e23$var$wrapAsync(iteratee);
    return $63690b4f22172e23$export$6a28d19bcc59197c(coll, limit, (val, iterCb)=>{
        _iteratee(val, (err, key)=>{
            if (err) return iterCb(err);
            return iterCb(err, {
                key: key,
                val: val
            });
        });
    }, (err, mapResults)=>{
        var result = {};
        // from MDN, handle object having an `hasOwnProperty` prop
        var { hasOwnProperty: hasOwnProperty } = Object.prototype;
        for(var i = 0; i < mapResults.length; i++)if (mapResults[i]) {
            var { key: key } = mapResults[i];
            var { val: val } = mapResults[i];
            if (hasOwnProperty.call(result, key)) result[key].push(val);
            else result[key] = [
                val
            ];
        }
        return callback(err, result);
    });
}
var $63690b4f22172e23$export$335ad4c8e8977a4b = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$groupByLimit, 4);
/**
 * Returns a new object, where each value corresponds to an array of items, from
 * `coll`, that returned the corresponding key. That is, the keys of the object
 * correspond to the values passed to the `iteratee` callback.
 *
 * Note: Since this function applies the `iteratee` to each item in parallel,
 * there is no guarantee that the `iteratee` functions will complete in order.
 * However, the values for each key in the `result` will be in the same order as
 * the original `coll`. For Objects, the values will roughly be in the order of
 * the original Objects' keys (but this can vary across JavaScript engines).
 *
 * @name groupBy
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * const files = ['dir1/file1.txt','dir2','dir4']
 *
 * // asynchronous function that detects file type as none, file, or directory
 * function detectFile(file, callback) {
 *     fs.stat(file, function(err, stat) {
 *         if (err) {
 *             return callback(null, 'none');
 *         }
 *         callback(null, stat.isDirectory() ? 'directory' : 'file');
 *     });
 * }
 *
 * //Using callbacks
 * async.groupBy(files, detectFile, function(err, result) {
 *     if(err) {
 *         console.log(err);
 *     } else {
 *	       console.log(result);
 *         // {
 *         //     file: [ 'dir1/file1.txt' ],
 *         //     none: [ 'dir4' ],
 *         //     directory: [ 'dir2']
 *         // }
 *         // result is object containing the files grouped by type
 *     }
 * });
 *
 * // Using Promises
 * async.groupBy(files, detectFile)
 * .then( result => {
 *     console.log(result);
 *     // {
 *     //     file: [ 'dir1/file1.txt' ],
 *     //     none: [ 'dir4' ],
 *     //     directory: [ 'dir2']
 *     // }
 *     // result is object containing the files grouped by type
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.groupBy(files, detectFile);
 *         console.log(result);
 *         // {
 *         //     file: [ 'dir1/file1.txt' ],
 *         //     none: [ 'dir4' ],
 *         //     directory: [ 'dir2']
 *         // }
 *         // result is object containing the files grouped by type
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $63690b4f22172e23$export$3f063810d7bf01bd(coll, iteratee, callback) {
    return $63690b4f22172e23$export$335ad4c8e8977a4b(coll, Infinity, iteratee, callback);
}
/**
 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
 *
 * @name groupBySeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.groupBy]{@link module:Collections.groupBy}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whose
 * properties are arrays of values which returned the corresponding key.
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$export$d0689f2b629adbdb(coll, iteratee, callback) {
    return $63690b4f22172e23$export$335ad4c8e8977a4b(coll, 1, iteratee, callback);
}
/**
 * Logs the result of an `async` function to the `console`. Only works in
 * Node.js or in browsers that support `console.log` and `console.error` (such
 * as FF and Chrome). If multiple arguments are returned from the async
 * function, `console.log` is called on each argument in order.
 *
 * @name log
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} function - The function you want to eventually apply
 * all arguments to.
 * @param {...*} arguments... - Any number of arguments to apply to the function.
 * @example
 *
 * // in a module
 * var hello = function(name, callback) {
 *     setTimeout(function() {
 *         callback(null, 'hello ' + name);
 *     }, 1000);
 * };
 *
 * // in the node repl
 * node> async.log(hello, 'world');
 * 'hello world'
 */ var $63690b4f22172e23$export$bef1f36f5486a6a3 = $63690b4f22172e23$var$consoleFunc("log");
/**
 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name mapValuesLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.mapValues]{@link module:Collections.mapValues}
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$var$mapValuesLimit(obj, limit, iteratee, callback) {
    callback = $63690b4f22172e23$var$once(callback);
    var newObj = {};
    var _iteratee = $63690b4f22172e23$var$wrapAsync(iteratee);
    return $63690b4f22172e23$var$eachOfLimit$2(limit)(obj, (val, key, next)=>{
        _iteratee(val, key, (err, result)=>{
            if (err) return next(err);
            newObj[key] = result;
            next(err);
        });
    }, (err)=>callback(err, newObj));
}
var $63690b4f22172e23$export$d5d82430c6fa645f = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$mapValuesLimit, 4);
/**
 * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
 *
 * Produces a new Object by mapping each value of `obj` through the `iteratee`
 * function. The `iteratee` is called each `value` and `key` from `obj` and a
 * callback for when it has finished processing. Each of these callbacks takes
 * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
 * passes an error to its callback, the main `callback` (for the `mapValues`
 * function) is immediately called with the error.
 *
 * Note, the order of the keys in the result is not guaranteed.  The keys will
 * be roughly in the order they complete, (but this is very engine-specific)
 *
 * @name mapValues
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * // file1.txt is a file that is 1000 bytes in size
 * // file2.txt is a file that is 2000 bytes in size
 * // file3.txt is a file that is 3000 bytes in size
 * // file4.txt does not exist
 *
 * const fileMap = {
 *     f1: 'file1.txt',
 *     f2: 'file2.txt',
 *     f3: 'file3.txt'
 * };
 *
 * const withMissingFileMap = {
 *     f1: 'file1.txt',
 *     f2: 'file2.txt',
 *     f3: 'file4.txt'
 * };
 *
 * // asynchronous function that returns the file size in bytes
 * function getFileSizeInBytes(file, key, callback) {
 *     fs.stat(file, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         callback(null, stat.size);
 *     });
 * }
 *
 * // Using callbacks
 * async.mapValues(fileMap, getFileSizeInBytes, function(err, result) {
 *     if (err) {
 *         console.log(err);
 *     } else {
 *         console.log(result);
 *         // result is now a map of file size in bytes for each file, e.g.
 *         // {
 *         //     f1: 1000,
 *         //     f2: 2000,
 *         //     f3: 3000
 *         // }
 *     }
 * });
 *
 * // Error handling
 * async.mapValues(withMissingFileMap, getFileSizeInBytes, function(err, result) {
 *     if (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     } else {
 *         console.log(result);
 *     }
 * });
 *
 * // Using Promises
 * async.mapValues(fileMap, getFileSizeInBytes)
 * .then( result => {
 *     console.log(result);
 *     // result is now a map of file size in bytes for each file, e.g.
 *     // {
 *     //     f1: 1000,
 *     //     f2: 2000,
 *     //     f3: 3000
 *     // }
 * }).catch (err => {
 *     console.log(err);
 * });
 *
 * // Error Handling
 * async.mapValues(withMissingFileMap, getFileSizeInBytes)
 * .then( result => {
 *     console.log(result);
 * }).catch (err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.mapValues(fileMap, getFileSizeInBytes);
 *         console.log(result);
 *         // result is now a map of file size in bytes for each file, e.g.
 *         // {
 *         //     f1: 1000,
 *         //     f2: 2000,
 *         //     f3: 3000
 *         // }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         let result = await async.mapValues(withMissingFileMap, getFileSizeInBytes);
 *         console.log(result);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     }
 * }
 *
 */ function $63690b4f22172e23$export$825e789796ab7275(obj, iteratee, callback) {
    return $63690b4f22172e23$export$d5d82430c6fa645f(obj, Infinity, iteratee, callback);
}
/**
 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
 *
 * @name mapValuesSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.mapValues]{@link module:Collections.mapValues}
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$export$8fbd16e43ec40b44(obj, iteratee, callback) {
    return $63690b4f22172e23$export$d5d82430c6fa645f(obj, 1, iteratee, callback);
}
/**
 * Caches the results of an async function. When creating a hash to store
 * function results against, the callback is omitted from the hash and an
 * optional hash function can be used.
 *
 * **Note: if the async function errs, the result will not be cached and
 * subsequent calls will call the wrapped function.**
 *
 * If no hash function is specified, the first argument is used as a hash key,
 * which may work reasonably if it is a string or a data type that converts to a
 * distinct string. Note that objects and arrays will not behave reasonably.
 * Neither will cases where the other arguments are significant. In such cases,
 * specify your own hash function.
 *
 * The cache of results is exposed as the `memo` property of the function
 * returned by `memoize`.
 *
 * @name memoize
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - The async function to proxy and cache results from.
 * @param {Function} hasher - An optional function for generating a custom hash
 * for storing results. It has all the arguments applied to it apart from the
 * callback, and must be synchronous.
 * @returns {AsyncFunction} a memoized version of `fn`
 * @example
 *
 * var slow_fn = function(name, callback) {
 *     // do something
 *     callback(null, result);
 * };
 * var fn = async.memoize(slow_fn);
 *
 * // fn can now be used as if it were slow_fn
 * fn('some name', function() {
 *     // callback
 * });
 */ function $63690b4f22172e23$export$fc10aeed3a532e2a(fn, hasher = (v)=>v) {
    var memo = Object.create(null);
    var queues = Object.create(null);
    var _fn = $63690b4f22172e23$var$wrapAsync(fn);
    var memoized = $63690b4f22172e23$var$initialParams((args, callback)=>{
        var key = hasher(...args);
        if (key in memo) $63690b4f22172e23$export$c233f08fbfea0913(()=>callback(null, ...memo[key]));
        else if (key in queues) queues[key].push(callback);
        else {
            queues[key] = [
                callback
            ];
            _fn(...args, (err, ...resultArgs)=>{
                // #1465 don't memoize if an error occurred
                if (!err) memo[key] = resultArgs;
                var q = queues[key];
                delete queues[key];
                for(var i = 0, l = q.length; i < l; i++)q[i](err, ...resultArgs);
            });
        }
    });
    memoized.memo = memo;
    memoized.unmemoized = fn;
    return memoized;
}
/* istanbul ignore file */ /**
 * Calls `callback` on a later loop around the event loop. In Node.js this just
 * calls `process.nextTick`.  In the browser it will use `setImmediate` if
 * available, otherwise `setTimeout(callback, 0)`, which means other higher
 * priority events may precede the execution of `callback`.
 *
 * This is used internally for browser-compatibility purposes.
 *
 * @name nextTick
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.setImmediate]{@link module:Utils.setImmediate}
 * @category Util
 * @param {Function} callback - The function to call on a later loop around
 * the event loop. Invoked with (args...).
 * @param {...*} args... - any number of additional arguments to pass to the
 * callback on the next tick.
 * @example
 *
 * var call_order = [];
 * async.nextTick(function() {
 *     call_order.push('two');
 *     // call_order now equals ['one','two']
 * });
 * call_order.push('one');
 *
 * async.setImmediate(function (a, b, c) {
 *     // a, b, and c equal 1, 2, and 3
 * }, 1, 2, 3);
 */ var $63690b4f22172e23$var$_defer;
if ($63690b4f22172e23$var$hasNextTick) $63690b4f22172e23$var$_defer = $hPtJY.nextTick;
else if ($63690b4f22172e23$var$hasSetImmediate) $63690b4f22172e23$var$_defer = setImmediate;
else $63690b4f22172e23$var$_defer = $63690b4f22172e23$var$fallback;
var $63690b4f22172e23$export$bdd553fddd433dcb = $63690b4f22172e23$var$wrap($63690b4f22172e23$var$_defer);
var $63690b4f22172e23$var$_parallel = $63690b4f22172e23$var$awaitify((eachfn, tasks, callback)=>{
    var results = $63690b4f22172e23$var$isArrayLike(tasks) ? [] : {};
    eachfn(tasks, (task, key, taskCb)=>{
        $63690b4f22172e23$var$wrapAsync(task)((err, ...result)=>{
            if (result.length < 2) [result] = result;
            results[key] = result;
            taskCb(err);
        });
    }, (err)=>callback(err, results));
}, 3);
/**
 * Run the `tasks` collection of functions in parallel, without waiting until
 * the previous function has completed. If any of the functions pass an error to
 * its callback, the main `callback` is immediately called with the value of the
 * error. Once the `tasks` have completed, the results are passed to the final
 * `callback` as an array.
 *
 * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
 * parallel execution of code.  If your tasks do not use any timers or perform
 * any I/O, they will actually be executed in series.  Any synchronous setup
 * sections for each task will happen one after the other.  JavaScript remains
 * single-threaded.
 *
 * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
 * execution of other tasks when a task fails.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 * results from {@link async.parallel}.
 *
 * @name parallel
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 * @returns {Promise} a promise, if a callback is not passed
 *
 * @example
 *
 * //Using Callbacks
 * async.parallel([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ], function(err, results) {
 *     console.log(results);
 *     // results is equal to ['one','two'] even though
 *     // the second function had a shorter timeout.
 * });
 *
 * // an example using an object instead of an array
 * async.parallel({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * });
 *
 * //Using Promises
 * async.parallel([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ]).then(results => {
 *     console.log(results);
 *     // results is equal to ['one','two'] even though
 *     // the second function had a shorter timeout.
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // an example using an object instead of an array
 * async.parallel({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }).then(results => {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * //Using async/await
 * async () => {
 *     try {
 *         let results = await async.parallel([
 *             function(callback) {
 *                 setTimeout(function() {
 *                     callback(null, 'one');
 *                 }, 200);
 *             },
 *             function(callback) {
 *                 setTimeout(function() {
 *                     callback(null, 'two');
 *                 }, 100);
 *             }
 *         ]);
 *         console.log(results);
 *         // results is equal to ['one','two'] even though
 *         // the second function had a shorter timeout.
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // an example using an object instead of an array
 * async () => {
 *     try {
 *         let results = await async.parallel({
 *             one: function(callback) {
 *                 setTimeout(function() {
 *                     callback(null, 1);
 *                 }, 200);
 *             },
 *            two: function(callback) {
 *                 setTimeout(function() {
 *                     callback(null, 2);
 *                 }, 100);
 *            }
 *         });
 *         console.log(results);
 *         // results is equal to: { one: 1, two: 2 }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $63690b4f22172e23$export$451942af9381149c(tasks, callback) {
    return $63690b4f22172e23$var$_parallel($63690b4f22172e23$export$d10d68e43a57bce9, tasks, callback);
}
/**
 * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name parallelLimit
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.parallel]{@link module:ControlFlow.parallel}
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 * @returns {Promise} a promise, if a callback is not passed
 */ function $63690b4f22172e23$export$362c0a688af131a0(tasks, limit, callback) {
    return $63690b4f22172e23$var$_parallel($63690b4f22172e23$var$eachOfLimit$2(limit), tasks, callback);
}
/**
 * A queue of tasks for the worker function to complete.
 * @typedef {Iterable} QueueObject
 * @memberOf module:ControlFlow
 * @property {Function} length - a function returning the number of items
 * waiting to be processed. Invoke with `queue.length()`.
 * @property {boolean} started - a boolean indicating whether or not any
 * items have been pushed and processed by the queue.
 * @property {Function} running - a function returning the number of items
 * currently being processed. Invoke with `queue.running()`.
 * @property {Function} workersList - a function returning the array of items
 * currently being processed. Invoke with `queue.workersList()`.
 * @property {Function} idle - a function returning false if there are items
 * waiting or being processed, or true if not. Invoke with `queue.idle()`.
 * @property {number} concurrency - an integer for determining how many `worker`
 * functions should be run in parallel. This property can be changed after a
 * `queue` is created to alter the concurrency on-the-fly.
 * @property {number} payload - an integer that specifies how many items are
 * passed to the worker function at a time. only applies if this is a
 * [cargo]{@link module:ControlFlow.cargo} object
 * @property {AsyncFunction} push - add a new task to the `queue`. Calls `callback`
 * once the `worker` has finished processing the task. Instead of a single task,
 * a `tasks` array can be submitted. The respective callback is used for every
 * task in the list. Invoke with `queue.push(task, [callback])`,
 * @property {AsyncFunction} unshift - add a new task to the front of the `queue`.
 * Invoke with `queue.unshift(task, [callback])`.
 * @property {AsyncFunction} pushAsync - the same as `q.push`, except this returns
 * a promise that rejects if an error occurs.
 * @property {AsyncFunction} unshiftAsync - the same as `q.unshift`, except this returns
 * a promise that rejects if an error occurs.
 * @property {Function} remove - remove items from the queue that match a test
 * function.  The test function will be passed an object with a `data` property,
 * and a `priority` property, if this is a
 * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
 * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
 * `function ({data, priority}) {}` and returns a Boolean.
 * @property {Function} saturated - a function that sets a callback that is
 * called when the number of running workers hits the `concurrency` limit, and
 * further tasks will be queued.  If the callback is omitted, `q.saturated()`
 * returns a promise for the next occurrence.
 * @property {Function} unsaturated - a function that sets a callback that is
 * called when the number of running workers is less than the `concurrency` &
 * `buffer` limits, and further tasks will not be queued. If the callback is
 * omitted, `q.unsaturated()` returns a promise for the next occurrence.
 * @property {number} buffer - A minimum threshold buffer in order to say that
 * the `queue` is `unsaturated`.
 * @property {Function} empty - a function that sets a callback that is called
 * when the last item from the `queue` is given to a `worker`. If the callback
 * is omitted, `q.empty()` returns a promise for the next occurrence.
 * @property {Function} drain - a function that sets a callback that is called
 * when the last item from the `queue` has returned from the `worker`. If the
 * callback is omitted, `q.drain()` returns a promise for the next occurrence.
 * @property {Function} error - a function that sets a callback that is called
 * when a task errors. Has the signature `function(error, task)`. If the
 * callback is omitted, `error()` returns a promise that rejects on the next
 * error.
 * @property {boolean} paused - a boolean for determining whether the queue is
 * in a paused state.
 * @property {Function} pause - a function that pauses the processing of tasks
 * until `resume()` is called. Invoke with `queue.pause()`.
 * @property {Function} resume - a function that resumes the processing of
 * queued tasks when the queue is paused. Invoke with `queue.resume()`.
 * @property {Function} kill - a function that removes the `drain` callback and
 * empties remaining tasks from the queue forcing it to go idle. No more tasks
 * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
 *
 * @example
 * const q = async.queue(worker, 2)
 * q.push(item1)
 * q.push(item2)
 * q.push(item3)
 * // queues are iterable, spread into an array to inspect
 * const items = [...q] // [item1, item2, item3]
 * // or use for of
 * for (let item of q) {
 *     console.log(item)
 * }
 *
 * q.drain(() => {
 *     console.log('all done')
 * })
 * // or
 * await q.drain()
 */ /**
 * Creates a `queue` object with the specified `concurrency`. Tasks added to the
 * `queue` are processed in parallel (up to the `concurrency` limit). If all
 * `worker`s are in progress, the task is queued until one becomes available.
 * Once a `worker` completes a `task`, that `task`'s callback is called.
 *
 * @name queue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} worker - An async function for processing a queued task.
 * If you want to handle errors from an individual task, pass a callback to
 * `q.push()`. Invoked with (task, callback).
 * @param {number} [concurrency=1] - An `integer` for determining how many
 * `worker` functions should be run in parallel.  If omitted, the concurrency
 * defaults to `1`.  If the concurrency is `0`, an error is thrown.
 * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can be
 * attached as certain properties to listen for specific events during the
 * lifecycle of the queue.
 * @example
 *
 * // create a queue object with concurrency 2
 * var q = async.queue(function(task, callback) {
 *     console.log('hello ' + task.name);
 *     callback();
 * }, 2);
 *
 * // assign a callback
 * q.drain(function() {
 *     console.log('all items have been processed');
 * });
 * // or await the end
 * await q.drain()
 *
 * // assign an error callback
 * q.error(function(err, task) {
 *     console.error('task experienced an error');
 * });
 *
 * // add some items to the queue
 * q.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * // callback is optional
 * q.push({name: 'bar'});
 *
 * // add some items to the queue (batch-wise)
 * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
 *     console.log('finished processing item');
 * });
 *
 * // add some items to the front of the queue
 * q.unshift({name: 'bar'}, function (err) {
 *     console.log('finished processing bar');
 * });
 */ function $63690b4f22172e23$export$4f7fa46ff53e516f(worker, concurrency) {
    var _worker = $63690b4f22172e23$var$wrapAsync(worker);
    return $63690b4f22172e23$var$queue$1((items, cb)=>{
        _worker(items[0], cb);
    }, concurrency, 1);
}
// Binary min-heap implementation used for priority queue.
// Implementation is stable, i.e. push time is considered for equal priorities
class $63690b4f22172e23$var$Heap {
    constructor(){
        this.heap = [];
        this.pushCount = Number.MIN_SAFE_INTEGER;
    }
    get length() {
        return this.heap.length;
    }
    empty() {
        this.heap = [];
        return this;
    }
    percUp(index) {
        let p;
        while(index > 0 && $63690b4f22172e23$var$smaller(this.heap[index], this.heap[p = $63690b4f22172e23$var$parent(index)])){
            let t = this.heap[index];
            this.heap[index] = this.heap[p];
            this.heap[p] = t;
            index = p;
        }
    }
    percDown(index) {
        let l;
        while((l = $63690b4f22172e23$var$leftChi(index)) < this.heap.length){
            if (l + 1 < this.heap.length && $63690b4f22172e23$var$smaller(this.heap[l + 1], this.heap[l])) l = l + 1;
            if ($63690b4f22172e23$var$smaller(this.heap[index], this.heap[l])) break;
            let t = this.heap[index];
            this.heap[index] = this.heap[l];
            this.heap[l] = t;
            index = l;
        }
    }
    push(node) {
        node.pushCount = ++this.pushCount;
        this.heap.push(node);
        this.percUp(this.heap.length - 1);
    }
    unshift(node) {
        return this.heap.push(node);
    }
    shift() {
        let [top] = this.heap;
        this.heap[0] = this.heap[this.heap.length - 1];
        this.heap.pop();
        this.percDown(0);
        return top;
    }
    toArray() {
        return [
            ...this
        ];
    }
    *[Symbol.iterator]() {
        for(let i = 0; i < this.heap.length; i++)yield this.heap[i].data;
    }
    remove(testFn) {
        let j = 0;
        for(let i = 0; i < this.heap.length; i++)if (!testFn(this.heap[i])) {
            this.heap[j] = this.heap[i];
            j++;
        }
        this.heap.splice(j);
        for(let i = $63690b4f22172e23$var$parent(this.heap.length - 1); i >= 0; i--)this.percDown(i);
        return this;
    }
}
function $63690b4f22172e23$var$leftChi(i) {
    return (i << 1) + 1;
}
function $63690b4f22172e23$var$parent(i) {
    return (i + 1 >> 1) - 1;
}
function $63690b4f22172e23$var$smaller(x, y) {
    if (x.priority !== y.priority) return x.priority < y.priority;
    else return x.pushCount < y.pushCount;
}
/**
 * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
 * completed in ascending priority order.
 *
 * @name priorityQueue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @category Control Flow
 * @param {AsyncFunction} worker - An async function for processing a queued task.
 * If you want to handle errors from an individual task, pass a callback to
 * `q.push()`.
 * Invoked with (task, callback).
 * @param {number} concurrency - An `integer` for determining how many `worker`
 * functions should be run in parallel.  If omitted, the concurrency defaults to
 * `1`.  If the concurrency is `0`, an error is thrown.
 * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are three
 * differences between `queue` and `priorityQueue` objects:
 * * `push(task, priority, [callback])` - `priority` should be a number. If an
 *   array of `tasks` is given, all tasks will be assigned the same priority.
 * * `pushAsync(task, priority, [callback])` - the same as `priorityQueue.push`,
 *   except this returns a promise that rejects if an error occurs.
 * * The `unshift` and `unshiftAsync` methods were removed.
 */ function $63690b4f22172e23$export$25579debde666a98(worker, concurrency) {
    // Start with a normal queue
    var q = $63690b4f22172e23$export$4f7fa46ff53e516f(worker, concurrency);
    var { push: push, pushAsync: pushAsync } = q;
    q._tasks = new $63690b4f22172e23$var$Heap();
    q._createTaskItem = ({ data: data, priority: priority }, callback)=>{
        return {
            data: data,
            priority: priority,
            callback: callback
        };
    };
    function createDataItems(tasks, priority) {
        if (!Array.isArray(tasks)) return {
            data: tasks,
            priority: priority
        };
        return tasks.map((data)=>{
            return {
                data: data,
                priority: priority
            };
        });
    }
    // Override push to accept second parameter representing priority
    q.push = function(data, priority = 0, callback) {
        return push(createDataItems(data, priority), callback);
    };
    q.pushAsync = function(data, priority = 0, callback) {
        return pushAsync(createDataItems(data, priority), callback);
    };
    // Remove unshift functions
    delete q.unshift;
    delete q.unshiftAsync;
    return q;
}
/**
 * Runs the `tasks` array of functions in parallel, without waiting until the
 * previous function has completed. Once any of the `tasks` complete or pass an
 * error to its callback, the main `callback` is immediately called. It's
 * equivalent to `Promise.race()`.
 *
 * @name race
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
 * to run. Each function can complete with an optional `result` value.
 * @param {Function} callback - A callback to run once any of the functions have
 * completed. This function gets an error or result from the first function that
 * completed. Invoked with (err, result).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * async.race([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ],
 * // main callback
 * function(err, result) {
 *     // the result will be equal to 'two' as it finishes earlier
 * });
 */ function $63690b4f22172e23$var$race(tasks, callback) {
    callback = $63690b4f22172e23$var$once(callback);
    if (!Array.isArray(tasks)) return callback(new TypeError("First argument to race must be an array of functions"));
    if (!tasks.length) return callback();
    for(var i = 0, l = tasks.length; i < l; i++)$63690b4f22172e23$var$wrapAsync(tasks[i])(callback);
}
var $63690b4f22172e23$export$236c05de452bec2 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$race, 2);
/**
 * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
 *
 * @name reduceRight
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reduce]{@link module:Collections.reduce}
 * @alias foldr
 * @category Collection
 * @param {Array} array - A collection to iterate over.
 * @param {*} memo - The initial state of the reduction.
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * array to produce the next step in the reduction.
 * The `iteratee` should complete with the next state of the reduction.
 * If the iteratee completes with an error, the reduction is stopped and the
 * main `callback` is immediately called with the error.
 * Invoked with (memo, item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the reduced value. Invoked with
 * (err, result).
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$export$a11cb61c36c4a4cf(array, memo, iteratee, callback) {
    var reversed = [
        ...array
    ].reverse();
    return $63690b4f22172e23$export$50ae948ca12cdcbc(reversed, memo, iteratee, callback);
}
/**
 * Wraps the async function in another function that always completes with a
 * result object, even when it errors.
 *
 * The result object has either the property `error` or `value`.
 *
 * @name reflect
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - The async function you want to wrap
 * @returns {Function} - A function that always passes null to it's callback as
 * the error. The second argument to the callback will be an `object` with
 * either an `error` or a `value` property.
 * @example
 *
 * async.parallel([
 *     async.reflect(function(callback) {
 *         // do some stuff ...
 *         callback(null, 'one');
 *     }),
 *     async.reflect(function(callback) {
 *         // do some more stuff but error ...
 *         callback('bad stuff happened');
 *     }),
 *     async.reflect(function(callback) {
 *         // do some more stuff ...
 *         callback(null, 'two');
 *     })
 * ],
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results[0].value = 'one'
 *     // results[1].error = 'bad stuff happened'
 *     // results[2].value = 'two'
 * });
 */ function $63690b4f22172e23$export$9debe8cffacea23(fn) {
    var _fn = $63690b4f22172e23$var$wrapAsync(fn);
    return $63690b4f22172e23$var$initialParams(function reflectOn(args, reflectCallback) {
        args.push((error, ...cbArgs)=>{
            let retVal = {};
            if (error) retVal.error = error;
            if (cbArgs.length > 0) {
                var value = cbArgs;
                if (cbArgs.length <= 1) [value] = cbArgs;
                retVal.value = value;
            }
            reflectCallback(null, retVal);
        });
        return _fn.apply(this, args);
    });
}
/**
 * A helper function that wraps an array or an object of functions with `reflect`.
 *
 * @name reflectAll
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.reflect]{@link module:Utils.reflect}
 * @category Util
 * @param {Array|Object|Iterable} tasks - The collection of
 * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
 * @returns {Array} Returns an array of async functions, each wrapped in
 * `async.reflect`
 * @example
 *
 * let tasks = [
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         // do some more stuff but error ...
 *         callback(new Error('bad stuff happened'));
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ];
 *
 * async.parallel(async.reflectAll(tasks),
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results[0].value = 'one'
 *     // results[1].error = Error('bad stuff happened')
 *     // results[2].value = 'two'
 * });
 *
 * // an example using an object instead of an array
 * let tasks = {
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         callback('two');
 *     },
 *     three: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'three');
 *         }, 100);
 *     }
 * };
 *
 * async.parallel(async.reflectAll(tasks),
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results.one.value = 'one'
 *     // results.two.error = 'two'
 *     // results.three.value = 'three'
 * });
 */ function $63690b4f22172e23$export$1a54554d0a489acc(tasks) {
    var results;
    if (Array.isArray(tasks)) results = tasks.map($63690b4f22172e23$export$9debe8cffacea23);
    else {
        results = {};
        Object.keys(tasks).forEach((key)=>{
            results[key] = $63690b4f22172e23$export$9debe8cffacea23.call(this, tasks[key]);
        });
    }
    return results;
}
function $63690b4f22172e23$var$reject$2(eachfn, arr, _iteratee, callback) {
    const iteratee = $63690b4f22172e23$var$wrapAsync(_iteratee);
    return $63690b4f22172e23$var$_filter(eachfn, arr, (value, cb)=>{
        iteratee(value, (err, v)=>{
            cb(err, !v);
        });
    }, callback);
}
/**
 * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
 *
 * @name reject
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 *
 * const fileList = ['dir1/file1.txt','dir2/file3.txt','dir3/file6.txt'];
 *
 * // asynchronous function that checks if a file exists
 * function fileExists(file, callback) {
 *    fs.access(file, fs.constants.F_OK, (err) => {
 *        callback(null, !err);
 *    });
 * }
 *
 * // Using callbacks
 * async.reject(fileList, fileExists, function(err, results) {
 *    // [ 'dir3/file6.txt' ]
 *    // results now equals an array of the non-existing files
 * });
 *
 * // Using Promises
 * async.reject(fileList, fileExists)
 * .then( results => {
 *     console.log(results);
 *     // [ 'dir3/file6.txt' ]
 *     // results now equals an array of the non-existing files
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let results = await async.reject(fileList, fileExists);
 *         console.log(results);
 *         // [ 'dir3/file6.txt' ]
 *         // results now equals an array of the non-existing files
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$reject(coll, iteratee, callback) {
    return $63690b4f22172e23$var$reject$2($63690b4f22172e23$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $63690b4f22172e23$export$2800f3ceda99eb84 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$reject, 3);
/**
 * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name rejectLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reject]{@link module:Collections.reject}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$var$rejectLimit(coll, limit, iteratee, callback) {
    return $63690b4f22172e23$var$reject$2($63690b4f22172e23$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $63690b4f22172e23$export$b59d647fa1894da8 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$rejectLimit, 4);
/**
 * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
 *
 * @name rejectSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reject]{@link module:Collections.reject}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 */ function $63690b4f22172e23$var$rejectSeries(coll, iteratee, callback) {
    return $63690b4f22172e23$var$reject$2($63690b4f22172e23$export$750e7e5fea3b0654, coll, iteratee, callback);
}
var $63690b4f22172e23$export$d68373657532124d = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$rejectSeries, 3);
function $63690b4f22172e23$var$constant(value) {
    return function() {
        return value;
    };
}
/**
 * Attempts to get a successful response from `task` no more than `times` times
 * before returning an error. If the task is successful, the `callback` will be
 * passed the result of the successful task. If all attempts fail, the callback
 * will be passed the error and result (if any) of the final attempt.
 *
 * @name retry
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @see [async.retryable]{@link module:ControlFlow.retryable}
 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
 * object with `times` and `interval` or a number.
 * * `times` - The number of attempts to make before giving up.  The default
 *   is `5`.
 * * `interval` - The time to wait between retries, in milliseconds.  The
 *   default is `0`. The interval may also be specified as a function of the
 *   retry count (see example).
 * * `errorFilter` - An optional synchronous function that is invoked on
 *   erroneous result. If it returns `true` the retry attempts will continue;
 *   if the function returns `false` the retry flow is aborted with the current
 *   attempt's error and result being returned to the final callback.
 *   Invoked with (err).
 * * If `opts` is a number, the number specifies the number of times to retry,
 *   with the default interval of `0`.
 * @param {AsyncFunction} task - An async function to retry.
 * Invoked with (callback).
 * @param {Function} [callback] - An optional callback which is called when the
 * task has succeeded, or after the final failed attempt. It receives the `err`
 * and `result` arguments of the last attempt at completing the `task`. Invoked
 * with (err, results).
 * @returns {Promise} a promise if no callback provided
 *
 * @example
 *
 * // The `retry` function can be used as a stand-alone control flow by passing
 * // a callback, as shown below:
 *
 * // try calling apiMethod 3 times
 * async.retry(3, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod 3 times, waiting 200 ms between each retry
 * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod 10 times with exponential backoff
 * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
 * async.retry({
 *   times: 10,
 *   interval: function(retryCount) {
 *     return 50 * Math.pow(2, retryCount);
 *   }
 * }, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod the default 5 times no delay between each retry
 * async.retry(apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod only when error condition satisfies, all other
 * // errors will abort the retry control flow and return to final callback
 * async.retry({
 *   errorFilter: function(err) {
 *     return err.message === 'Temporary error'; // only retry on a specific error
 *   }
 * }, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // to retry individual methods that are not as reliable within other
 * // control flow functions, use the `retryable` wrapper:
 * async.auto({
 *     users: api.getUsers.bind(api),
 *     payments: async.retryable(3, api.getPayments.bind(api))
 * }, function(err, results) {
 *     // do something with the results
 * });
 *
 */ const $63690b4f22172e23$var$DEFAULT_TIMES = 5;
const $63690b4f22172e23$var$DEFAULT_INTERVAL = 0;
function $63690b4f22172e23$export$9369b12211e1fce4(opts, task, callback) {
    var options = {
        times: $63690b4f22172e23$var$DEFAULT_TIMES,
        intervalFunc: $63690b4f22172e23$var$constant($63690b4f22172e23$var$DEFAULT_INTERVAL)
    };
    if (arguments.length < 3 && typeof opts === "function") {
        callback = task || $63690b4f22172e23$var$promiseCallback();
        task = opts;
    } else {
        $63690b4f22172e23$var$parseTimes(options, opts);
        callback = callback || $63690b4f22172e23$var$promiseCallback();
    }
    if (typeof task !== "function") throw new Error("Invalid arguments for async.retry");
    var _task = $63690b4f22172e23$var$wrapAsync(task);
    var attempt = 1;
    function retryAttempt() {
        _task((err, ...args)=>{
            if (err === false) return;
            if (err && attempt++ < options.times && (typeof options.errorFilter != "function" || options.errorFilter(err))) setTimeout(retryAttempt, options.intervalFunc(attempt - 1));
            else callback(err, ...args);
        });
    }
    retryAttempt();
    return callback[$63690b4f22172e23$var$PROMISE_SYMBOL];
}
function $63690b4f22172e23$var$parseTimes(acc, t) {
    if (typeof t === "object") {
        acc.times = +t.times || $63690b4f22172e23$var$DEFAULT_TIMES;
        acc.intervalFunc = typeof t.interval === "function" ? t.interval : $63690b4f22172e23$var$constant(+t.interval || $63690b4f22172e23$var$DEFAULT_INTERVAL);
        acc.errorFilter = t.errorFilter;
    } else if (typeof t === "number" || typeof t === "string") acc.times = +t || $63690b4f22172e23$var$DEFAULT_TIMES;
    else throw new Error("Invalid arguments for async.retry");
}
/**
 * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
 * wraps a task and makes it retryable, rather than immediately calling it
 * with retries.
 *
 * @name retryable
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.retry]{@link module:ControlFlow.retry}
 * @category Control Flow
 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
 * options, exactly the same as from `retry`, except for a `opts.arity` that
 * is the arity of the `task` function, defaulting to `task.length`
 * @param {AsyncFunction} task - the asynchronous function to wrap.
 * This function will be passed any arguments passed to the returned wrapper.
 * Invoked with (...args, callback).
 * @returns {AsyncFunction} The wrapped function, which when invoked, will
 * retry on an error, based on the parameters specified in `opts`.
 * This function will accept the same parameters as `task`.
 * @example
 *
 * async.auto({
 *     dep1: async.retryable(3, getFromFlakyService),
 *     process: ["dep1", async.retryable(3, function (results, cb) {
 *         maybeProcessData(results.dep1, cb);
 *     })]
 * }, callback);
 */ function $63690b4f22172e23$export$9e1b8e833f44ff21(opts, task) {
    if (!task) {
        task = opts;
        opts = null;
    }
    let arity = opts && opts.arity || task.length;
    if ($63690b4f22172e23$var$isAsync(task)) arity += 1;
    var _task = $63690b4f22172e23$var$wrapAsync(task);
    return $63690b4f22172e23$var$initialParams((args, callback)=>{
        if (args.length < arity - 1 || callback == null) {
            args.push(callback);
            callback = $63690b4f22172e23$var$promiseCallback();
        }
        function taskFn(cb) {
            _task(...args, cb);
        }
        if (opts) $63690b4f22172e23$export$9369b12211e1fce4(opts, taskFn, callback);
        else $63690b4f22172e23$export$9369b12211e1fce4(taskFn, callback);
        return callback[$63690b4f22172e23$var$PROMISE_SYMBOL];
    });
}
/**
 * Run the functions in the `tasks` collection in series, each one running once
 * the previous function has completed. If any functions in the series pass an
 * error to its callback, no more functions are run, and `callback` is
 * immediately called with the value of the error. Otherwise, `callback`
 * receives an array of results when `tasks` have completed.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function, and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 *  results from {@link async.series}.
 *
 * **Note** that while many implementations preserve the order of object
 * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
 * explicitly states that
 *
 * > The mechanics and order of enumerating the properties is not specified.
 *
 * So if you rely on the order in which your series of functions are executed,
 * and want this to work on all platforms, consider using an array.
 *
 * @name series
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing
 * [async functions]{@link AsyncFunction} to run in series.
 * Each function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This function gets a results array (or object)
 * containing all the result arguments passed to the `task` callbacks. Invoked
 * with (err, result).
 * @return {Promise} a promise, if no callback is passed
 * @example
 *
 * //Using Callbacks
 * async.series([
 *     function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ], function(err, results) {
 *     console.log(results);
 *     // results is equal to ['one','two']
 * });
 *
 * // an example using objects instead of arrays
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * });
 *
 * //Using Promises
 * async.series([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ]).then(results => {
 *     console.log(results);
 *     // results is equal to ['one','two']
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // an example using an object instead of an array
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }).then(results => {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * //Using async/await
 * async () => {
 *     try {
 *         let results = await async.series([
 *             function(callback) {
 *                 setTimeout(function() {
 *                     // do some async task
 *                     callback(null, 'one');
 *                 }, 200);
 *             },
 *             function(callback) {
 *                 setTimeout(function() {
 *                     // then do another async task
 *                     callback(null, 'two');
 *                 }, 100);
 *             }
 *         ]);
 *         console.log(results);
 *         // results is equal to ['one','two']
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // an example using an object instead of an array
 * async () => {
 *     try {
 *         let results = await async.parallel({
 *             one: function(callback) {
 *                 setTimeout(function() {
 *                     // do some async task
 *                     callback(null, 1);
 *                 }, 200);
 *             },
 *            two: function(callback) {
 *                 setTimeout(function() {
 *                     // then do another async task
 *                     callback(null, 2);
 *                 }, 100);
 *            }
 *         });
 *         console.log(results);
 *         // results is equal to: { one: 1, two: 2 }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $63690b4f22172e23$export$7589597339a0562d(tasks, callback) {
    return $63690b4f22172e23$var$_parallel($63690b4f22172e23$export$750e7e5fea3b0654, tasks, callback);
}
/**
 * Returns `true` if at least one element in the `coll` satisfies an async test.
 * If any iteratee call returns `true`, the main `callback` is immediately
 * called.
 *
 * @name some
 * @static
 * @memberOf module:Collections
 * @method
 * @alias any
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in parallel.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * // asynchronous function that checks if a file exists
 * function fileExists(file, callback) {
 *    fs.access(file, fs.constants.F_OK, (err) => {
 *        callback(null, !err);
 *    });
 * }
 *
 * // Using callbacks
 * async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists,
 *    function(err, result) {
 *        console.log(result);
 *        // true
 *        // result is true since some file in the list exists
 *    }
 *);
 *
 * async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists,
 *    function(err, result) {
 *        console.log(result);
 *        // false
 *        // result is false since none of the files exists
 *    }
 *);
 *
 * // Using Promises
 * async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists)
 * .then( result => {
 *     console.log(result);
 *     // true
 *     // result is true since some file in the list exists
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists)
 * .then( result => {
 *     console.log(result);
 *     // false
 *     // result is false since none of the files exists
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists);
 *         console.log(result);
 *         // true
 *         // result is true since some file in the list exists
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * async () => {
 *     try {
 *         let result = await async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists);
 *         console.log(result);
 *         // false
 *         // result is false since none of the files exists
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$some(coll, iteratee, callback) {
    return $63690b4f22172e23$var$_createTester(Boolean, (res)=>res)($63690b4f22172e23$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $63690b4f22172e23$export$4154a199d7d90455 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$some, 3);
/**
 * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
 *
 * @name someLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.some]{@link module:Collections.some}
 * @alias anyLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in parallel.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 */ function $63690b4f22172e23$var$someLimit(coll, limit, iteratee, callback) {
    return $63690b4f22172e23$var$_createTester(Boolean, (res)=>res)($63690b4f22172e23$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $63690b4f22172e23$export$97c6076dd161c251 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$someLimit, 4);
/**
 * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
 *
 * @name someSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.some]{@link module:Collections.some}
 * @alias anySeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in series.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 */ function $63690b4f22172e23$var$someSeries(coll, iteratee, callback) {
    return $63690b4f22172e23$var$_createTester(Boolean, (res)=>res)($63690b4f22172e23$export$750e7e5fea3b0654, coll, iteratee, callback);
}
var $63690b4f22172e23$export$728f30d6f8df8331 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$someSeries, 3);
/**
 * Sorts a list by the results of running each `coll` value through an async
 * `iteratee`.
 *
 * @name sortBy
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a value to use as the sort criteria as
 * its `result`.
 * Invoked with (item, callback).
 * @param {Function} callback - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is the items
 * from the original `coll` sorted by the values returned by the `iteratee`
 * calls. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback passed
 * @example
 *
 * // bigfile.txt is a file that is 251100 bytes in size
 * // mediumfile.txt is a file that is 11000 bytes in size
 * // smallfile.txt is a file that is 121 bytes in size
 *
 * // asynchronous function that returns the file size in bytes
 * function getFileSizeInBytes(file, callback) {
 *     fs.stat(file, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         callback(null, stat.size);
 *     });
 * }
 *
 * // Using callbacks
 * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], getFileSizeInBytes,
 *     function(err, results) {
 *         if (err) {
 *             console.log(err);
 *         } else {
 *             console.log(results);
 *             // results is now the original array of files sorted by
 *             // file size (ascending by default), e.g.
 *             // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
 *         }
 *     }
 * );
 *
 * // By modifying the callback parameter the
 * // sorting order can be influenced:
 *
 * // ascending order
 * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], function(file, callback) {
 *     getFileSizeInBytes(file, function(getFileSizeErr, fileSize) {
 *         if (getFileSizeErr) return callback(getFileSizeErr);
 *         callback(null, fileSize);
 *     });
 * }, function(err, results) {
 *         if (err) {
 *             console.log(err);
 *         } else {
 *             console.log(results);
 *             // results is now the original array of files sorted by
 *             // file size (ascending by default), e.g.
 *             // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
 *         }
 *     }
 * );
 *
 * // descending order
 * async.sortBy(['bigfile.txt','mediumfile.txt','smallfile.txt'], function(file, callback) {
 *     getFileSizeInBytes(file, function(getFileSizeErr, fileSize) {
 *         if (getFileSizeErr) {
 *             return callback(getFileSizeErr);
 *         }
 *         callback(null, fileSize * -1);
 *     });
 * }, function(err, results) {
 *         if (err) {
 *             console.log(err);
 *         } else {
 *             console.log(results);
 *             // results is now the original array of files sorted by
 *             // file size (ascending by default), e.g.
 *             // [ 'bigfile.txt', 'mediumfile.txt', 'smallfile.txt']
 *         }
 *     }
 * );
 *
 * // Error handling
 * async.sortBy(['mediumfile.txt','smallfile.txt','missingfile.txt'], getFileSizeInBytes,
 *     function(err, results) {
 *         if (err) {
 *             console.log(err);
 *             // [ Error: ENOENT: no such file or directory ]
 *         } else {
 *             console.log(results);
 *         }
 *     }
 * );
 *
 * // Using Promises
 * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], getFileSizeInBytes)
 * .then( results => {
 *     console.log(results);
 *     // results is now the original array of files sorted by
 *     // file size (ascending by default), e.g.
 *     // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Error handling
 * async.sortBy(['mediumfile.txt','smallfile.txt','missingfile.txt'], getFileSizeInBytes)
 * .then( results => {
 *     console.log(results);
 * }).catch( err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 * });
 *
 * // Using async/await
 * (async () => {
 *     try {
 *         let results = await async.sortBy(['bigfile.txt','mediumfile.txt','smallfile.txt'], getFileSizeInBytes);
 *         console.log(results);
 *         // results is now the original array of files sorted by
 *         // file size (ascending by default), e.g.
 *         // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * })();
 *
 * // Error handling
 * async () => {
 *     try {
 *         let results = await async.sortBy(['missingfile.txt','mediumfile.txt','smallfile.txt'], getFileSizeInBytes);
 *         console.log(results);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     }
 * }
 *
 */ function $63690b4f22172e23$var$sortBy(coll, iteratee, callback) {
    var _iteratee = $63690b4f22172e23$var$wrapAsync(iteratee);
    return $63690b4f22172e23$export$871de8747c9eaa88(coll, (x, iterCb)=>{
        _iteratee(x, (err, criteria)=>{
            if (err) return iterCb(err);
            iterCb(err, {
                value: x,
                criteria: criteria
            });
        });
    }, (err, results)=>{
        if (err) return callback(err);
        callback(null, results.sort(comparator).map((v)=>v.value));
    });
    function comparator(left, right) {
        var a = left.criteria, b = right.criteria;
        return a < b ? -1 : a > b ? 1 : 0;
    }
}
var $63690b4f22172e23$export$b035e44d7bb4278f = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$sortBy, 3);
/**
 * Sets a time limit on an asynchronous function. If the function does not call
 * its callback within the specified milliseconds, it will be called with a
 * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
 *
 * @name timeout
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} asyncFn - The async function to limit in time.
 * @param {number} milliseconds - The specified time limit.
 * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
 * to timeout Error for more information..
 * @returns {AsyncFunction} Returns a wrapped function that can be used with any
 * of the control flow functions.
 * Invoke this function with the same parameters as you would `asyncFunc`.
 * @example
 *
 * function myFunction(foo, callback) {
 *     doAsyncTask(foo, function(err, data) {
 *         // handle errors
 *         if (err) return callback(err);
 *
 *         // do some stuff ...
 *
 *         // return processed data
 *         return callback(null, data);
 *     });
 * }
 *
 * var wrapped = async.timeout(myFunction, 1000);
 *
 * // call `wrapped` as you would `myFunction`
 * wrapped({ bar: 'bar' }, function(err, data) {
 *     // if `myFunction` takes < 1000 ms to execute, `err`
 *     // and `data` will have their expected values
 *
 *     // else `err` will be an Error with the code 'ETIMEDOUT'
 * });
 */ function $63690b4f22172e23$export$83e74882c5df8fe1(asyncFn, milliseconds, info) {
    var fn = $63690b4f22172e23$var$wrapAsync(asyncFn);
    return $63690b4f22172e23$var$initialParams((args, callback)=>{
        var timedOut = false;
        var timer;
        function timeoutCallback() {
            var name = asyncFn.name || "anonymous";
            var error = new Error('Callback function "' + name + '" timed out.');
            error.code = "ETIMEDOUT";
            if (info) error.info = info;
            timedOut = true;
            callback(error);
        }
        args.push((...cbArgs)=>{
            if (!timedOut) {
                callback(...cbArgs);
                clearTimeout(timer);
            }
        });
        // setup timer and call original function
        timer = setTimeout(timeoutCallback, milliseconds);
        fn(...args);
    });
}
function $63690b4f22172e23$var$range(size) {
    var result = Array(size);
    while(size--)result[size] = size;
    return result;
}
/**
 * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name timesLimit
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.times]{@link module:ControlFlow.times}
 * @category Control Flow
 * @param {number} count - The number of times to run the function.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see [async.map]{@link module:Collections.map}.
 * @returns {Promise} a promise, if no callback is provided
 */ function $63690b4f22172e23$export$5ebd4c84811c422b(count, limit, iteratee, callback) {
    var _iteratee = $63690b4f22172e23$var$wrapAsync(iteratee);
    return $63690b4f22172e23$export$6a28d19bcc59197c($63690b4f22172e23$var$range(count), limit, _iteratee, callback);
}
/**
 * Calls the `iteratee` function `n` times, and accumulates results in the same
 * manner you would use with [map]{@link module:Collections.map}.
 *
 * @name times
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Control Flow
 * @param {number} n - The number of times to run the function.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see {@link module:Collections.map}.
 * @returns {Promise} a promise, if no callback is provided
 * @example
 *
 * // Pretend this is some complicated async factory
 * var createUser = function(id, callback) {
 *     callback(null, {
 *         id: 'user' + id
 *     });
 * };
 *
 * // generate 5 users
 * async.times(5, function(n, next) {
 *     createUser(n, function(err, user) {
 *         next(err, user);
 *     });
 * }, function(err, users) {
 *     // we should now have 5 users
 * });
 */ function $63690b4f22172e23$export$b5bc26e198ce73d0(n, iteratee, callback) {
    return $63690b4f22172e23$export$5ebd4c84811c422b(n, Infinity, iteratee, callback);
}
/**
 * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
 *
 * @name timesSeries
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.times]{@link module:ControlFlow.times}
 * @category Control Flow
 * @param {number} n - The number of times to run the function.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see {@link module:Collections.map}.
 * @returns {Promise} a promise, if no callback is provided
 */ function $63690b4f22172e23$export$51c3f8bb1fe6838c(n, iteratee, callback) {
    return $63690b4f22172e23$export$5ebd4c84811c422b(n, 1, iteratee, callback);
}
/**
 * A relative of `reduce`.  Takes an Object or Array, and iterates over each
 * element in parallel, each step potentially mutating an `accumulator` value.
 * The type of the accumulator defaults to the type of collection passed in.
 *
 * @name transform
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {*} [accumulator] - The initial state of the transform.  If omitted,
 * it will default to an empty Object or Array, depending on the type of `coll`
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * collection that potentially modifies the accumulator.
 * Invoked with (accumulator, item, key, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the transformed accumulator.
 * Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 * @example
 *
 * // file1.txt is a file that is 1000 bytes in size
 * // file2.txt is a file that is 2000 bytes in size
 * // file3.txt is a file that is 3000 bytes in size
 *
 * // helper function that returns human-readable size format from bytes
 * function formatBytes(bytes, decimals = 2) {
 *   // implementation not included for brevity
 *   return humanReadbleFilesize;
 * }
 *
 * const fileList = ['file1.txt','file2.txt','file3.txt'];
 *
 * // asynchronous function that returns the file size, transformed to human-readable format
 * // e.g. 1024 bytes = 1KB, 1234 bytes = 1.21 KB, 1048576 bytes = 1MB, etc.
 * function transformFileSize(acc, value, key, callback) {
 *     fs.stat(value, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         acc[key] = formatBytes(stat.size);
 *         callback(null);
 *     });
 * }
 *
 * // Using callbacks
 * async.transform(fileList, transformFileSize, function(err, result) {
 *     if(err) {
 *         console.log(err);
 *     } else {
 *         console.log(result);
 *         // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
 *     }
 * });
 *
 * // Using Promises
 * async.transform(fileList, transformFileSize)
 * .then(result => {
 *     console.log(result);
 *     // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * (async () => {
 *     try {
 *         let result = await async.transform(fileList, transformFileSize);
 *         console.log(result);
 *         // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * })();
 *
 * @example
 *
 * // file1.txt is a file that is 1000 bytes in size
 * // file2.txt is a file that is 2000 bytes in size
 * // file3.txt is a file that is 3000 bytes in size
 *
 * // helper function that returns human-readable size format from bytes
 * function formatBytes(bytes, decimals = 2) {
 *   // implementation not included for brevity
 *   return humanReadbleFilesize;
 * }
 *
 * const fileMap = { f1: 'file1.txt', f2: 'file2.txt', f3: 'file3.txt' };
 *
 * // asynchronous function that returns the file size, transformed to human-readable format
 * // e.g. 1024 bytes = 1KB, 1234 bytes = 1.21 KB, 1048576 bytes = 1MB, etc.
 * function transformFileSize(acc, value, key, callback) {
 *     fs.stat(value, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         acc[key] = formatBytes(stat.size);
 *         callback(null);
 *     });
 * }
 *
 * // Using callbacks
 * async.transform(fileMap, transformFileSize, function(err, result) {
 *     if(err) {
 *         console.log(err);
 *     } else {
 *         console.log(result);
 *         // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
 *     }
 * });
 *
 * // Using Promises
 * async.transform(fileMap, transformFileSize)
 * .then(result => {
 *     console.log(result);
 *     // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.transform(fileMap, transformFileSize);
 *         console.log(result);
 *         // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $63690b4f22172e23$export$51186ad6e864892a(coll, accumulator, iteratee, callback) {
    if (arguments.length <= 3 && typeof accumulator === "function") {
        callback = iteratee;
        iteratee = accumulator;
        accumulator = Array.isArray(coll) ? [] : {};
    }
    callback = $63690b4f22172e23$var$once(callback || $63690b4f22172e23$var$promiseCallback());
    var _iteratee = $63690b4f22172e23$var$wrapAsync(iteratee);
    $63690b4f22172e23$export$d10d68e43a57bce9(coll, (v, k, cb)=>{
        _iteratee(accumulator, v, k, cb);
    }, (err)=>callback(err, accumulator));
    return callback[$63690b4f22172e23$var$PROMISE_SYMBOL];
}
/**
 * It runs each task in series but stops whenever any of the functions were
 * successful. If one of the tasks were successful, the `callback` will be
 * passed the result of the successful task. If all tasks fail, the callback
 * will be passed the error and result (if any) of the final attempt.
 *
 * @name tryEach
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing functions to
 * run, each function is passed a `callback(err, result)` it must call on
 * completion with an error `err` (which can be `null`) and an optional `result`
 * value.
 * @param {Function} [callback] - An optional callback which is called when one
 * of the tasks has succeeded, or all have failed. It receives the `err` and
 * `result` arguments of the last attempt at completing the `task`. Invoked with
 * (err, results).
 * @returns {Promise} a promise, if no callback is passed
 * @example
 * async.tryEach([
 *     function getDataFromFirstWebsite(callback) {
 *         // Try getting the data from the first website
 *         callback(err, data);
 *     },
 *     function getDataFromSecondWebsite(callback) {
 *         // First website failed,
 *         // Try getting the data from the backup website
 *         callback(err, data);
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     Now do something with the data.
 * });
 *
 */ function $63690b4f22172e23$var$tryEach(tasks, callback) {
    var error = null;
    var result;
    return $63690b4f22172e23$export$9bd663f1fadd104c(tasks, (task, taskCb)=>{
        $63690b4f22172e23$var$wrapAsync(task)((err, ...args)=>{
            if (err === false) return taskCb(err);
            if (args.length < 2) [result] = args;
            else result = args;
            error = err;
            taskCb(err ? null : {});
        });
    }, ()=>callback(error, result));
}
var $63690b4f22172e23$export$c382910393876e1e = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$tryEach);
/**
 * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
 * unmemoized form. Handy for testing.
 *
 * @name unmemoize
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.memoize]{@link module:Utils.memoize}
 * @category Util
 * @param {AsyncFunction} fn - the memoized function
 * @returns {AsyncFunction} a function that calls the original unmemoized function
 */ function $63690b4f22172e23$export$a8183b28ba2fbf41(fn) {
    return (...args)=>{
        return (fn.unmemoized || fn)(...args);
    };
}
/**
 * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
 * stopped, or an error occurs.
 *
 * @name whilst
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} test - asynchronous truth test to perform before each
 * execution of `iteratee`. Invoked with (callback).
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * var count = 0;
 * async.whilst(
 *     function test(cb) { cb(null, count < 5); },
 *     function iter(callback) {
 *         count++;
 *         setTimeout(function() {
 *             callback(null, count);
 *         }, 1000);
 *     },
 *     function (err, n) {
 *         // 5 seconds have passed, n = 5
 *     }
 * );
 */ function $63690b4f22172e23$var$whilst(test, iteratee, callback) {
    callback = $63690b4f22172e23$var$onlyOnce(callback);
    var _fn = $63690b4f22172e23$var$wrapAsync(iteratee);
    var _test = $63690b4f22172e23$var$wrapAsync(test);
    var results = [];
    function next(err, ...rest) {
        if (err) return callback(err);
        results = rest;
        if (err === false) return;
        _test(check);
    }
    function check(err, truth) {
        if (err) return callback(err);
        if (err === false) return;
        if (!truth) return callback(null, ...results);
        _fn(next);
    }
    return _test(check);
}
var $63690b4f22172e23$export$147085f09cc1931 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$whilst, 3);
/**
 * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
 * stopped, or an error occurs. `callback` will be passed an error and any
 * arguments passed to the final `iteratee`'s callback.
 *
 * The inverse of [whilst]{@link module:ControlFlow.whilst}.
 *
 * @name until
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {AsyncFunction} test - asynchronous truth test to perform before each
 * execution of `iteratee`. Invoked with (callback).
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` fails. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has passed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 * @returns {Promise} a promise, if a callback is not passed
 *
 * @example
 * const results = []
 * let finished = false
 * async.until(function test(cb) {
 *     cb(null, finished)
 * }, function iter(next) {
 *     fetchPage(url, (err, body) => {
 *         if (err) return next(err)
 *         results = results.concat(body.objects)
 *         finished = !!body.next
 *         next(err)
 *     })
 * }, function done (err) {
 *     // all pages have been fetched
 * })
 */ function $63690b4f22172e23$export$a40009bd2c363351(test, iteratee, callback) {
    const _test = $63690b4f22172e23$var$wrapAsync(test);
    return $63690b4f22172e23$export$147085f09cc1931((cb)=>_test((err, truth)=>cb(err, !truth)), iteratee, callback);
}
/**
 * Runs the `tasks` array of functions in series, each passing their results to
 * the next in the array. However, if any of the `tasks` pass an error to their
 * own callback, the next function is not executed, and the main `callback` is
 * immediately called with the error.
 *
 * @name waterfall
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
 * to run.
 * Each function should complete with any number of `result` values.
 * The `result` values will be passed as arguments, in order, to the next task.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This will be passed the results of the last task's
 * callback. Invoked with (err, [results]).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * async.waterfall([
 *     function(callback) {
 *         callback(null, 'one', 'two');
 *     },
 *     function(arg1, arg2, callback) {
 *         // arg1 now equals 'one' and arg2 now equals 'two'
 *         callback(null, 'three');
 *     },
 *     function(arg1, callback) {
 *         // arg1 now equals 'three'
 *         callback(null, 'done');
 *     }
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 *
 * // Or, with named functions:
 * async.waterfall([
 *     myFirstFunction,
 *     mySecondFunction,
 *     myLastFunction,
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 * function myFirstFunction(callback) {
 *     callback(null, 'one', 'two');
 * }
 * function mySecondFunction(arg1, arg2, callback) {
 *     // arg1 now equals 'one' and arg2 now equals 'two'
 *     callback(null, 'three');
 * }
 * function myLastFunction(arg1, callback) {
 *     // arg1 now equals 'three'
 *     callback(null, 'done');
 * }
 */ function $63690b4f22172e23$var$waterfall(tasks, callback) {
    callback = $63690b4f22172e23$var$once(callback);
    if (!Array.isArray(tasks)) return callback(new Error("First argument to waterfall must be an array of functions"));
    if (!tasks.length) return callback();
    var taskIndex = 0;
    function nextTask(args) {
        var task = $63690b4f22172e23$var$wrapAsync(tasks[taskIndex++]);
        task(...args, $63690b4f22172e23$var$onlyOnce(next));
    }
    function next(err, ...args) {
        if (err === false) return;
        if (err || taskIndex === tasks.length) return callback(err, ...args);
        nextTask(args);
    }
    nextTask([]);
}
var $63690b4f22172e23$export$981f466e0ef96280 = $63690b4f22172e23$var$awaitify($63690b4f22172e23$var$waterfall);
/**
 * An "async function" in the context of Async is an asynchronous function with
 * a variable number of parameters, with the final parameter being a callback.
 * (`function (arg1, arg2, ..., callback) {}`)
 * The final callback is of the form `callback(err, results...)`, which must be
 * called once the function is completed.  The callback should be called with a
 * Error as its first argument to signal that an error occurred.
 * Otherwise, if no error occurred, it should be called with `null` as the first
 * argument, and any additional `result` arguments that may apply, to signal
 * successful completion.
 * The callback must be called exactly once, ideally on a later tick of the
 * JavaScript event loop.
 *
 * This type of function is also referred to as a "Node-style async function",
 * or a "continuation passing-style function" (CPS). Most of the methods of this
 * library are themselves CPS/Node-style async functions, or functions that
 * return CPS/Node-style async functions.
 *
 * Wherever we accept a Node-style async function, we also directly accept an
 * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
 * In this case, the `async` function will not be passed a final callback
 * argument, and any thrown error will be used as the `err` argument of the
 * implicit callback, and the return value will be used as the `result` value.
 * (i.e. a `rejected` of the returned Promise becomes the `err` callback
 * argument, and a `resolved` value becomes the `result`.)
 *
 * Note, due to JavaScript limitations, we can only detect native `async`
 * functions and not transpilied implementations.
 * Your environment must have `async`/`await` support for this to work.
 * (e.g. Node > v7.6, or a recent version of a modern browser).
 * If you are using `async` functions through a transpiler (e.g. Babel), you
 * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
 * because the `async function` will be compiled to an ordinary function that
 * returns a promise.
 *
 * @typedef {Function} AsyncFunction
 * @static
 */ var $63690b4f22172e23$export$2e2bcd8739ae039 = {
    apply: $63690b4f22172e23$export$5635d7ef4b8fee1c,
    applyEach: $63690b4f22172e23$export$e0fc6250e304edaf,
    applyEachSeries: $63690b4f22172e23$export$cdb63afc167779e,
    asyncify: $63690b4f22172e23$export$b5d55b15b1db3122,
    auto: $63690b4f22172e23$export$dfb5619354ba860,
    autoInject: $63690b4f22172e23$export$868ec1c38c3c8735,
    cargo: $63690b4f22172e23$export$f9549d7e5aef7637,
    cargoQueue: $63690b4f22172e23$export$687de40d137ed486,
    compose: $63690b4f22172e23$export$f672e0b6f7222cd7,
    concat: $63690b4f22172e23$export$ee1b3e54f0441b22,
    concatLimit: $63690b4f22172e23$export$4f1520afe59a31db,
    concatSeries: $63690b4f22172e23$export$b6df61d74da01b63,
    constant: $63690b4f22172e23$export$c983f826f44ff86,
    detect: $63690b4f22172e23$export$17b446b869dad473,
    detectLimit: $63690b4f22172e23$export$922bcf02f3a5b284,
    detectSeries: $63690b4f22172e23$export$922a9a31d0cff2ee,
    dir: $63690b4f22172e23$export$147ec2801e896265,
    doUntil: $63690b4f22172e23$export$16f3a0560cc13fb4,
    doWhilst: $63690b4f22172e23$export$df0899fd4acbef10,
    each: $63690b4f22172e23$export$79b2f7037acddd43,
    eachLimit: $63690b4f22172e23$export$2a2080ddac50d6b8,
    eachOf: $63690b4f22172e23$export$d10d68e43a57bce9,
    eachOfLimit: $63690b4f22172e23$export$8b05461b96b91438,
    eachOfSeries: $63690b4f22172e23$export$750e7e5fea3b0654,
    eachSeries: $63690b4f22172e23$export$9bd663f1fadd104c,
    ensureAsync: $63690b4f22172e23$export$85d5b9ccf228381c,
    every: $63690b4f22172e23$export$84bf76cd7afc7469,
    everyLimit: $63690b4f22172e23$export$5b469f316a3f1415,
    everySeries: $63690b4f22172e23$export$c4a4adf74205a63d,
    filter: $63690b4f22172e23$export$3dea766d36a8935f,
    filterLimit: $63690b4f22172e23$export$6a93acd3681313ac,
    filterSeries: $63690b4f22172e23$export$ddcc38daaa46257c,
    forever: $63690b4f22172e23$export$116a0f7f2303acd8,
    groupBy: $63690b4f22172e23$export$3f063810d7bf01bd,
    groupByLimit: $63690b4f22172e23$export$335ad4c8e8977a4b,
    groupBySeries: $63690b4f22172e23$export$d0689f2b629adbdb,
    log: $63690b4f22172e23$export$bef1f36f5486a6a3,
    map: $63690b4f22172e23$export$871de8747c9eaa88,
    mapLimit: $63690b4f22172e23$export$6a28d19bcc59197c,
    mapSeries: $63690b4f22172e23$export$9a85c32cda85b0dd,
    mapValues: $63690b4f22172e23$export$825e789796ab7275,
    mapValuesLimit: $63690b4f22172e23$export$d5d82430c6fa645f,
    mapValuesSeries: $63690b4f22172e23$export$8fbd16e43ec40b44,
    memoize: $63690b4f22172e23$export$fc10aeed3a532e2a,
    nextTick: $63690b4f22172e23$export$bdd553fddd433dcb,
    parallel: $63690b4f22172e23$export$451942af9381149c,
    parallelLimit: $63690b4f22172e23$export$362c0a688af131a0,
    priorityQueue: $63690b4f22172e23$export$25579debde666a98,
    queue: $63690b4f22172e23$export$4f7fa46ff53e516f,
    race: $63690b4f22172e23$export$236c05de452bec2,
    reduce: $63690b4f22172e23$export$50ae948ca12cdcbc,
    reduceRight: $63690b4f22172e23$export$a11cb61c36c4a4cf,
    reflect: $63690b4f22172e23$export$9debe8cffacea23,
    reflectAll: $63690b4f22172e23$export$1a54554d0a489acc,
    reject: $63690b4f22172e23$export$2800f3ceda99eb84,
    rejectLimit: $63690b4f22172e23$export$b59d647fa1894da8,
    rejectSeries: $63690b4f22172e23$export$d68373657532124d,
    retry: $63690b4f22172e23$export$9369b12211e1fce4,
    retryable: $63690b4f22172e23$export$9e1b8e833f44ff21,
    seq: $63690b4f22172e23$export$1041d4276c328e4d,
    series: $63690b4f22172e23$export$7589597339a0562d,
    setImmediate: $63690b4f22172e23$export$c233f08fbfea0913,
    some: $63690b4f22172e23$export$4154a199d7d90455,
    someLimit: $63690b4f22172e23$export$97c6076dd161c251,
    someSeries: $63690b4f22172e23$export$728f30d6f8df8331,
    sortBy: $63690b4f22172e23$export$b035e44d7bb4278f,
    timeout: $63690b4f22172e23$export$83e74882c5df8fe1,
    times: $63690b4f22172e23$export$b5bc26e198ce73d0,
    timesLimit: $63690b4f22172e23$export$5ebd4c84811c422b,
    timesSeries: $63690b4f22172e23$export$51c3f8bb1fe6838c,
    transform: $63690b4f22172e23$export$51186ad6e864892a,
    tryEach: $63690b4f22172e23$export$c382910393876e1e,
    unmemoize: $63690b4f22172e23$export$a8183b28ba2fbf41,
    until: $63690b4f22172e23$export$a40009bd2c363351,
    waterfall: $63690b4f22172e23$export$981f466e0ef96280,
    whilst: $63690b4f22172e23$export$147085f09cc1931,
    // aliases
    all: $63690b4f22172e23$export$84bf76cd7afc7469,
    allLimit: $63690b4f22172e23$export$5b469f316a3f1415,
    allSeries: $63690b4f22172e23$export$c4a4adf74205a63d,
    any: $63690b4f22172e23$export$4154a199d7d90455,
    anyLimit: $63690b4f22172e23$export$97c6076dd161c251,
    anySeries: $63690b4f22172e23$export$728f30d6f8df8331,
    find: $63690b4f22172e23$export$17b446b869dad473,
    findLimit: $63690b4f22172e23$export$922bcf02f3a5b284,
    findSeries: $63690b4f22172e23$export$922a9a31d0cff2ee,
    flatMap: $63690b4f22172e23$export$ee1b3e54f0441b22,
    flatMapLimit: $63690b4f22172e23$export$4f1520afe59a31db,
    flatMapSeries: $63690b4f22172e23$export$b6df61d74da01b63,
    forEach: $63690b4f22172e23$export$79b2f7037acddd43,
    forEachSeries: $63690b4f22172e23$export$9bd663f1fadd104c,
    forEachLimit: $63690b4f22172e23$export$2a2080ddac50d6b8,
    forEachOf: $63690b4f22172e23$export$d10d68e43a57bce9,
    forEachOfSeries: $63690b4f22172e23$export$750e7e5fea3b0654,
    forEachOfLimit: $63690b4f22172e23$export$8b05461b96b91438,
    inject: $63690b4f22172e23$export$50ae948ca12cdcbc,
    foldl: $63690b4f22172e23$export$50ae948ca12cdcbc,
    foldr: $63690b4f22172e23$export$a11cb61c36c4a4cf,
    select: $63690b4f22172e23$export$3dea766d36a8935f,
    selectLimit: $63690b4f22172e23$export$6a93acd3681313ac,
    selectSeries: $63690b4f22172e23$export$ddcc38daaa46257c,
    wrapSync: $63690b4f22172e23$export$b5d55b15b1db3122,
    during: $63690b4f22172e23$export$147085f09cc1931,
    doDuring: $63690b4f22172e23$export$df0899fd4acbef10
};



var $acw62 = parcelRequire("acw62");
const $6790db85a3c2ee37$var$RateLimiterContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $6790db85a3c2ee37$export$a3533c31c6fd4e87({ children: children, requestsPerSecond: requestsPerSecond = 5 }) {
    const requestsPerSecondRef = (0, $acw62.useRef)(requestsPerSecond);
    (0, $acw62.useEffect)(()=>{
        requestsPerSecondRef.current = requestsPerSecond;
    }, [
        requestsPerSecond
    ]);
    const apiQueue = (0, $acw62.useMemo)(()=>(0, $63690b4f22172e23$export$4f7fa46ff53e516f)((task, callback)=>{
            task.asyncFn().then(task.resolve).catch(task.reject).finally(()=>{
                setTimeout(callback, 1000 / requestsPerSecondRef.current);
            });
        }, 1), []);
    const wrapApiCall = (0, $acw62.useCallback)((asyncFn)=>new Promise((resolve, reject)=>{
            apiQueue.push({
                asyncFn: asyncFn,
                resolve: resolve,
                reject: reject
            });
        }), [
        apiQueue
    ]);
    const contextValue = (0, $acw62.useMemo)(()=>({
            wrapApiCall: wrapApiCall
        }), [
        wrapApiCall
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6790db85a3c2ee37$var$RateLimiterContext.Provider, {
        value: contextValue,
        children: children
    });
}
function $6790db85a3c2ee37$export$8c7d93a3f5838ae9() {
    const context = (0, $acw62.useContext)($6790db85a3c2ee37$var$RateLimiterContext);
    if (context === null) throw new Error("useRateLimiter must be used within a RateLimiterProvider");
    return context;
}


function $e8b140ba9efae563$export$f0553479e1a1feb3({ discogId: discogId, title: title }) {
    const [loadingImage, setLoadingImage] = (0, $acw62.useState)(false);
    const api = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { wrapApiCall: wrapApiCall } = (0, $6790db85a3c2ee37$export$8c7d93a3f5838ae9)();
    const [imageSrc, setImageSrc] = (0, $acw62.useState)(()=>{
        try {
            const saved_image = localStorage.getItem(`discogs_artist_image_${discogId}`);
            if (typeof saved_image === "string" && saved_image.length > 0) return saved_image;
            return null;
        } catch  {
            return null;
        }
    });
    const placeholderRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        // Do not fetch if we already have an image
        if (typeof imageSrc === "string" && imageSrc.length > 0) return;
        const element = placeholderRef.current;
        if (!element) return;
        const observer = new IntersectionObserver(([entry])=>{
            // Fetch when the element is visible
            if (entry.isIntersecting) {
                // We can unobserve the element now
                observer.unobserve(element);
                setLoadingImage(true);
                wrapApiCall(()=>api.adminApi.searchArtistDiscogsArtist({
                        discogsId: discogId
                    })).then((data)=>{
                    const artist_image = data.images?.[0]?.resourceUrl ?? "none";
                    localStorage.setItem(`discogs_artist_image_${discogId}`, artist_image);
                    setImageSrc(artist_image);
                }).catch((err)=>{
                    if (err.response?.status === 404 || err.response?.status === 500 || err.response?.status === 400) {
                        localStorage.setItem(`discogs_artist_image_${discogId}`, "none");
                        setImageSrc("none");
                        return;
                    }
                    console.error(`Failed to fetch image for discogId ${discogId}:`, err);
                    localStorage.removeItem(`discogs_artist_image_${discogId}`);
                    setImageSrc(null);
                }).finally(()=>{
                    setLoadingImage(false);
                });
            }
        });
        observer.observe(element);
        return ()=>{
            // Cleanup observer on component unmount
            if (element) observer.unobserve(element);
        };
    }, [
        discogId,
        api,
        imageSrc,
        wrapApiCall
    ]);
    if (loadingImage) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
            className: "tw-animate-spin"
        })
    });
    if (imageSrc === "none") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf10c2f08346e322$export$3f5eb857c8edfe4d), {});
    if (imageSrc) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: imageSrc,
        alt: title,
        className: "tw-w-full tw-h-full tw-object-cover"
    });
    // Render a placeholder to be observed
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: placeholderRef,
        className: "tw-w-full tw-h-full",
        role: "img",
        "aria-label": title
    });
}



parcelRequire("acw62");
const $683bf00e40c955d9$export$353f5b6fc5456de1 = ({ onClick: onClick, children: children, styleType: styleType, width: width = "154", disabled: disabled = false, type: type })=>{
    let styleClass;
    switch(styleType){
        case "btn-primary":
            styleClass = `tw-bg-surfaceLime tw-text-black tw-px-5 tw-py-3 tw-rounded-full tw-w-[${width}]`;
            break;
        case "btn-info":
            styleClass = "tw-bg-teal-500 tw-text-white";
            break;
        case "btn-info-outline":
            styleClass = "tw-border tw-border-teal-500 tw-text-teal-500";
            break;
        case "btn-link":
            styleClass = "tw-bg-transparent tw-text-white hover:tw-textLime tw-font-medium active:tw-textLime";
            break;
        default:
            styleClass = "tw-bg-westburyBlue tw-text-white";
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: `${styleClass} tw-rounded ${disabled ? "tw-grayscale" : ""}`,
        onClick: onClick,
        disabled: disabled,
        type: type,
        children: children
    });
};




/**
 * Artist-ID auto-collection state model — the rules for turning the backend's run
 * report into what the admin sees on the Populate IDs button.
 *
 * Why this exists as its own module: the bug this replaces was a *state* bug, not a
 * rendering one. The old hook folded "never started", "cancelled", "failed", "Dagster
 * unreachable" and "mid-relaunch" into a single `'not-loaded'` that also meant *safe to
 * click again* — so a poll landing in a blind window re-enabled the button, the admin
 * clicked, and the backend cancelled the run that was already collecting. That is the
 * stack of CANCELED runs in Dagster.
 *
 * Kept free of React so the rules are testable without a DOM (see
 * `artistIdCollectionModel.test.ts`) — the repo has no React Testing Library, and these
 * are exactly the rules worth pinning down.
 */ /** Backend lifecycle phase — the source of truth. Mirrors `ArtistIdCollectionRunPhase`. */ const $b56fb8f4df8e7ea3$export$c7de5ec717f81599 = [
    "triggering",
    "queued",
    "starting",
    "collecting",
    "cancelling"
];
function $b56fb8f4df8e7ea3$export$18608c84ede3221c(status) {
    return $b56fb8f4df8e7ea3$export$c7de5ec717f81599.includes(status);
}
function $b56fb8f4df8e7ea3$export$507a32851b2a8920(report) {
    if (!report) return "unknown";
    switch(report.phase){
        case "LAUNCHING":
            return "queued";
        case "STARTING":
            return "starting";
        case "RUNNING":
            return "collecting";
        case "SUCCEEDED":
            return "loaded";
        case "FAILED":
            return "failed";
        case "CANCELLING":
            return "cancelling";
        case "CANCELLED":
            return "cancelled";
        case null:
        case undefined:
            break;
        default:
            // A phase this build does not know about. Treat it as "we cannot see the backend"
            // rather than falling through to the legacy `status`, which could map a phase we do
            // not understand onto `loaded` and hand the admin a stale, re-enabled button.
            return "unknown";
    }
    // No phase: either a pre-phase backend, or genuinely no run on record.
    switch(report.status){
        case "QUEUED":
        case "MANAGED":
            return "queued";
        case "STARTING":
            return "starting";
        case "STARTED":
            return "collecting";
        case "SUCCESS":
            return "loaded";
        case "FAILURE":
        case "FAILED":
            return "failed";
        case "CANCELING":
            return "cancelling";
        case "CANCELED":
            return "cancelled";
        case "NOT_STARTED":
            return "idle";
        case null:
        case undefined:
            // Phase is absent too (checked above), so this really is "no run on record".
            return "idle";
        default:
            return "unknown";
    }
}
function $b56fb8f4df8e7ea3$export$469a17b8bcd0b2ca(status) {
    return $b56fb8f4df8e7ea3$export$18608c84ede3221c(status) || status === "unknown";
}
const $b56fb8f4df8e7ea3$export$efe1c8edbaf7e22a = 3000;
const $b56fb8f4df8e7ea3$export$c2ca6edee2a596ed = 30000;
function $b56fb8f4df8e7ea3$export$589bb1c6d6f3af8a(consecutiveFailures) {
    if (consecutiveFailures <= 0) return $b56fb8f4df8e7ea3$export$efe1c8edbaf7e22a;
    return Math.min($b56fb8f4df8e7ea3$export$efe1c8edbaf7e22a * 2 ** consecutiveFailures, $b56fb8f4df8e7ea3$export$c2ca6edee2a596ed);
}
const $b56fb8f4df8e7ea3$export$6b785d2aa550473 = 3;
function $b56fb8f4df8e7ea3$export$eeeaf4d8d237ce2d(status) {
    // `unknown` disables too: if we cannot see the backend we cannot promise there is no run
    // in flight, and a click in that window is exactly what caused the reported bug.
    return $b56fb8f4df8e7ea3$export$18608c84ede3221c(status) || status === "unknown";
}
function $b56fb8f4df8e7ea3$export$6fcdc52d0455e1a1(status) {
    return status === "queued" || status === "starting" || status === "collecting";
}
function $b56fb8f4df8e7ea3$export$5be8bd33ddde0187(requestedAt, now) {
    if (requestedAt === null || requestedAt === undefined) return null;
    const started = typeof requestedAt === "number" ? requestedAt : requestedAt.getTime();
    if (Number.isNaN(started)) return null;
    return Math.max(0, Math.floor((now - started) / 1000));
}
function $b56fb8f4df8e7ea3$export$867b0b35f5a34859(totalSeconds) {
    if (totalSeconds === null) return null;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}
function $b56fb8f4df8e7ea3$export$1477c7d6a515fd96(status, options = {}) {
    const { elapsed: elapsed = null, isStalled: isStalled = false, errorDetail: errorDetail = null } = options;
    const clock = $b56fb8f4df8e7ea3$export$867b0b35f5a34859(elapsed);
    const withClock = (label)=>clock ? `${label}\u{2026} ${clock}` : `${label}\u{2026}`;
    if (isStalled && $b56fb8f4df8e7ea3$export$18608c84ede3221c(status)) return {
        label: "Taking longer than expected",
        detail: withClock("Taking longer than expected"),
        busy: true,
        attention: true
    };
    switch(status){
        case "triggering":
            return {
                label: "Starting",
                detail: "Starting\u2026",
                busy: true,
                attention: false
            };
        case "queued":
            return {
                label: "Queued",
                detail: withClock("Queued"),
                busy: true,
                attention: false
            };
        case "starting":
            return {
                label: "Starting",
                detail: withClock("Starting"),
                busy: true,
                attention: false
            };
        case "collecting":
            return {
                label: "Collecting IDs",
                detail: withClock("Collecting IDs"),
                busy: true,
                attention: false
            };
        case "cancelling":
            return {
                label: "Cancelling",
                detail: withClock("Cancelling"),
                busy: true,
                attention: false
            };
        case "cancelled":
            return {
                label: "Cancelled",
                detail: "Cancelled",
                busy: false,
                attention: false
            };
        case "loaded":
            return {
                label: "IDs collected",
                detail: "IDs collected",
                busy: false,
                attention: false
            };
        case "failed":
            return {
                label: "Failed \u2014 retry",
                detail: errorDetail ? `Failed \u{2014} ${errorDetail}` : "Failed \u2014 retry",
                busy: false,
                attention: true
            };
        case "unknown":
            return {
                label: "Checking status",
                detail: "Checking status\u2026",
                busy: true,
                attention: true
            };
        case "idle":
        default:
            return {
                label: "Not started",
                detail: "Not started",
                busy: false,
                attention: false
            };
    }
}





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
function $fcbcabcdd5e0aacc$export$b313845ce8fd18ca(key, initialValue, options) {
    const getNamespace = ()=>{
        return options?.namespace || window.location.pathname;
    };
    const getValue = ()=>{
        const namespace = getNamespace();
        const storedValue = localStorage.getItem(`${namespace}_${key}`);
        try {
            return storedValue ? JSON.parse(storedValue) : initialValue;
        } catch (error) {
            console.error(`Error retrieving value from localStorage for key "${key}":`, error);
            return initialValue;
        }
    };
    const [state, setState] = (0, $acw62.useState)(()=>{
        return getValue();
    });
    const setValue = (value)=>{
        setState(value);
        const namespace = getNamespace();
        localStorage.setItem(`${namespace}_${key}`, JSON.stringify(value));
    };
    (0, $acw62.useEffect)(()=>{
        if (options?.namespace) {
            const updatedValue = getValue();
            setValue(updatedValue);
        }
    }, [
        options?.namespace
    ]);
    return [
        state,
        setValue
    ];
}



const $fb3e3eaca9d70655$var$DiscographyIdsContex = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $fb3e3eaca9d70655$var$DiscographyIdsProviderImplementation = ({ children: children, clientId: clientId })=>{
    // The run report is server state; the client only mirrors it. The old hook kept the
    // *status* in localStorage, so a bad reading ("nothing is running") outlived the reload
    // that would have corrected it.
    const [status, setStatus] = (0, $acw62.useState)("unknown");
    const [phase, setPhase] = (0, $acw62.useState)(null);
    const [isStalled, setIsStalled] = (0, $acw62.useState)(false);
    const [errorDetail, setErrorDetail] = (0, $acw62.useState)(null);
    const [requestedAt, setRequestedAt] = (0, $acw62.useState)(null);
    const [now, setNow] = (0, $acw62.useState)(()=>Date.now());
    // Source/sourceId stay local: they are the admin's search selection, not run state.
    const [source, setSource] = (0, $fcbcabcdd5e0aacc$export$b313845ce8fd18ca)("source", "", {
        namespace: clientId
    });
    const [sourceId, setSourceId] = (0, $fcbcabcdd5e0aacc$export$b313845ce8fd18ca)("sourceId", "", {
        namespace: clientId
    });
    const [collectedDiscographyIds, setCollectedDiscographyIds] = (0, $acw62.useState)([]);
    const [cancelAutoCollectIdsInProgress, setCancelAutoCollectIdsInProgress] = (0, $acw62.useState)(false);
    // A trigger or cancel request is in flight. Suppresses a second one, and suppresses the
    // poll loop, whose answer during that window describes the run being replaced.
    const mutating = (0, $acw62.useRef)(false);
    // Consecutive failed polls. One hiccup must not change what the admin sees; a sustained
    // outage must — and must also back the poll off rather than hammering a sick backend.
    const consecutiveFailures = (0, $acw62.useRef)(0);
    // Bumped on every artist switch and on every trigger/cancel. A status response whose epoch
    // no longer matches is discarded: without this, a slow poll issued for the previous artist
    // (or before the click) lands afterwards and overwrites the newer state with the older one
    // — reintroducing exactly the "UI says nothing is running" flicker this whole change fixes.
    const epoch = (0, $acw62.useRef)(0);
    // Whether `collectedDiscographyIds` reflects a completed fetch for the current artist. The
    // overwrite confirmation must not be skipped merely because we have not looked yet.
    const collectedIdsLoaded = (0, $acw62.useRef)(false);
    // Consecutive 404s specifically. Distinguishes "this backend has no such endpoint" from
    // "one request went astray"; see refreshRunStatus.
    const consecutiveNotFound = (0, $acw62.useRef)(0);
    // Whether the last status we saw was an active run, so we know when one has just ended.
    const wasActive = (0, $acw62.useRef)(false);
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    // `useLocalStorageState` builds a brand-new `setValue` closure on every render, and
    // `useApi` makes no identity promise either. Every callback below is both used from async
    // code and named in an effect's dependency array, so it has to be *stable*. Listing these
    // directly as deps gave each callback a fresh identity per render → the reset effect
    // re-ran → it set state → re-render → "Maximum update depth exceeded" on mount, plus a
    // status request per iteration. Holding them in a ref keeps the callbacks stable while
    // still reading the current values, which is what a stale closure would otherwise cost.
    const latest = (0, $acw62.useRef)({
        api: api,
        source: source,
        sourceId: sourceId,
        setSource: setSource,
        setSourceId: setSourceId
    });
    latest.current = {
        api: api,
        source: source,
        sourceId: sourceId,
        setSource: setSource,
        setSourceId: setSourceId
    };
    const getCollectedDiscographyIds = (0, $acw62.useCallback)(async (clientId)=>{
        const issuedAt = epoch.current;
        try {
            const data = await latest.current.api.retrieveCollectedIdsAutoCollectedIds({
                userId: clientId
            });
            // Belongs to the artist we were looking at before the switch. Adopting it would show
            // one artist's discography under another's name *and* mark the IDs "loaded", which
            // silently suppresses the overwrite confirmation for the artist now on screen.
            if (issuedAt !== epoch.current) return null;
            const list = data.collectedIds;
            const mapped = list.map((item)=>({
                    ...item,
                    source_ids: {
                        discogs: [],
                        deezer: [],
                        musicbrainz: [],
                        spotify: [],
                        ...item.source_ids
                    }
                }));
            collectedIdsLoaded.current = true;
            setCollectedDiscographyIds(mapped);
            return mapped;
        } catch (err) {
            if (issuedAt !== epoch.current) return null;
            console.error(err);
            return null;
        }
    }, []);
    /**
   * Read the run report and mirror it into state.
   *
   * A rejected request does *not* fall through to "nothing is running". It bumps the
   * failure counter, and only a run of failures moves the UI to `unknown` — which still
   * keeps the button disabled and the poll loop alive.
   */ const refreshRunStatus = (0, $acw62.useCallback)(async (clientId)=>{
        const issuedAt = epoch.current;
        try {
            const data = await latest.current.api.retrieveAutoCollectIdsJobRunStatusArtistIdCollectionRunStatus({
                userId: clientId
            });
            // A response from before the last artist switch / click is stale by definition.
            if (issuedAt !== epoch.current) return;
            consecutiveFailures.current = 0;
            consecutiveNotFound.current = 0;
            setStatus((0, $b56fb8f4df8e7ea3$export$507a32851b2a8920)(data));
            setPhase(data.phase ?? null);
            setIsStalled(Boolean(data.isStalled));
            setErrorDetail(data.errorDetail ?? null);
            // Store the instant, not the Date: the generated client builds a new Date on every
            // response, and two equal Dates still fail `Object.is`, so an unchanged poll answer
            // would re-render the provider and the whole discography subtree every 3s.
            setRequestedAt(data.requestedAt ? data.requestedAt.getTime() : null);
            // Only write when it actually changed. `useLocalStorageState` writes through to
            // localStorage unconditionally, and re-applying this every poll also stamps the last
            // run's source over the search selection the admin is making right now.
            if (data.source && data.source !== latest.current.source) latest.current.setSource(data.source);
            if (data.sourceId && data.sourceId !== latest.current.sourceId) latest.current.setSourceId(data.sourceId);
        } catch (err) {
            if (issuedAt !== epoch.current) return;
            const notFound = err instanceof (0, $f599d8a7dfeab1bb$export$286baf652d0b1206) && err.response.status === 404;
            consecutiveFailures.current += 1;
            consecutiveNotFound.current = notFound ? consecutiveNotFound.current + 1 : 0;
            if (!notFound) console.error(err);
            // A *sustained* 404 means this bundle is talking to a backend that predates the
            // endpoint, and the admin should get a usable button rather than a dead one. A single
            // 404 must not: a rolling deploy or a momentarily mis-routed request produces one too,
            // and `idle` is terminal — it stops the poll loop and re-enables the trigger, which is
            // precisely the "UI says nothing is running" bug, one bad response later.
            if (consecutiveNotFound.current >= (0, $b56fb8f4df8e7ea3$export$6b785d2aa550473)) {
                setStatus("idle");
                setPhase(null);
                return;
            }
            if (consecutiveFailures.current >= (0, $b56fb8f4df8e7ea3$export$6b785d2aa550473)) setStatus("unknown");
        }
    }, []);
    // Read the server's view on mount / artist switch, before any polling decision.
    (0, $acw62.useEffect)(()=>{
        // Every piece of per-artist state, not just the status — leaving `errorDetail` or
        // `collectedDiscographyIds` behind shows one artist's run details under another's name.
        epoch.current += 1;
        consecutiveFailures.current = 0;
        consecutiveNotFound.current = 0;
        collectedIdsLoaded.current = false;
        mutating.current = false;
        wasActive.current = false;
        setStatus("unknown");
        setPhase(null);
        setIsStalled(false);
        setErrorDetail(null);
        setRequestedAt(null);
        setCollectedDiscographyIds([]);
        refreshRunStatus(clientId);
        // Unconditionally, and independently of the run status. Gating this on the status made
        // a status-endpoint outage empty the ID table for an artist with thousands of rows —
        // one broken endpoint taking down the page's entire read path.
        getCollectedDiscographyIds(clientId);
    }, [
        clientId,
        refreshRunStatus,
        getCollectedDiscographyIds
    ]);
    // Re-read the collected IDs when a run finishes. The file is only written at the end, so
    // there is nothing to see until an active run goes terminal.
    (0, $acw62.useEffect)(()=>{
        if ((0, $b56fb8f4df8e7ea3$export$18608c84ede3221c)(status)) {
            wasActive.current = true;
            return;
        }
        if (!wasActive.current) return;
        wasActive.current = false;
        getCollectedDiscographyIds(clientId);
    }, [
        status,
        clientId,
        getCollectedDiscographyIds
    ]);
    // The poll loop. It keeps running while the state is in doubt, and reschedules itself
    // from a ref-based delay so a backend outage backs off instead of hammering.
    (0, $acw62.useEffect)(()=>{
        if (!(0, $b56fb8f4df8e7ea3$export$469a17b8bcd0b2ca)(status)) return;
        let timeout = null;
        let cancelled = false;
        const tick = async ()=>{
            if (cancelled) return;
            // A trigger or cancel is mid-flight. Polling now reads the *previous* run's terminal
            // state — "nothing is running" in the middle of starting something — which drops the
            // poll loop and re-enables the button under the admin's cursor. The mutation runs its
            // own refresh when it lands.
            if (!mutating.current) await refreshRunStatus(clientId);
            if (cancelled) return;
            timeout = setTimeout(tick, (0, $b56fb8f4df8e7ea3$export$589bb1c6d6f3af8a)(consecutiveFailures.current));
        };
        timeout = setTimeout(tick, (0, $b56fb8f4df8e7ea3$export$589bb1c6d6f3af8a)(consecutiveFailures.current));
        return ()=>{
            cancelled = true;
            if (timeout) clearTimeout(timeout);
        };
    }, [
        status,
        clientId,
        refreshRunStatus
    ]);
    // Drives the elapsed clock. Runs only while something is in flight, so an idle page does
    // no work.
    (0, $acw62.useEffect)(()=>{
        if (!(0, $b56fb8f4df8e7ea3$export$18608c84ede3221c)(status)) return;
        setNow(Date.now());
        const interval = setInterval(()=>setNow(Date.now()), 1000);
        return ()=>clearInterval(interval);
    }, [
        status
    ]);
    const autoCollectIds = (0, $acw62.useCallback)(async (clientId, sourceId, source)=>{
        if (mutating.current) return;
        mutating.current = true;
        // Invalidate any poll already in flight: its answer predates this click.
        epoch.current += 1;
        // Disable the button on the click, not when the response lands. The wait for the
        // response is exactly the window in which the admin used to click again.
        setStatus("triggering");
        setPhase(null);
        setIsStalled(false);
        setErrorDetail(null);
        setRequestedAt(Date.now());
        latest.current.setSource(source);
        latest.current.setSourceId(sourceId);
        try {
            await latest.current.api.autoCollectIdsArtistIdCollectionRunStatus({
                userId: clientId,
                sourceId: sourceId,
                source: source
            });
        } catch (err) {
            // 409 means a collection is already running for this artist — the backend refusing
            // to cancel-and-relaunch. Not an error to show; the refresh below adopts the
            // server's state and the admin sees the run that is already going.
            const conflict = err instanceof (0, $f599d8a7dfeab1bb$export$286baf652d0b1206) && err.response.status === 409;
            if (!conflict) {
                console.error(err);
                (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                    text: "Could not start collecting IDs. Please try again.",
                    variant: "error"
                });
            }
        } finally{
            mutating.current = false;
        }
        consecutiveFailures.current = 0;
        consecutiveNotFound.current = 0;
        await refreshRunStatus(clientId);
    }, [
        refreshRunStatus
    ]);
    const cancelAutoCollectIds = (0, $acw62.useCallback)(async ()=>{
        if (mutating.current) return;
        mutating.current = true;
        setCancelAutoCollectIdsInProgress(true);
        epoch.current += 1;
        // Reflect the request immediately, but as "cancelling" — not as "nothing is running",
        // which is what let the admin start a second run on top of a still-terminating one.
        setStatus("cancelling");
        setPhase("CANCELLING");
        try {
            await latest.current.api.cancelAutoCollectIdsArtistIdCollectionRunStatus({
                userId: clientId
            });
        } catch (ex) {
            console.error(ex);
            (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                text: "Could not cancel the collection. Please try again.",
                variant: "error"
            });
        } finally{
            mutating.current = false;
            setCancelAutoCollectIdsInProgress(false);
        }
        consecutiveFailures.current = 0;
        consecutiveNotFound.current = 0;
        await refreshRunStatus(clientId);
    }, [
        clientId,
        refreshRunStatus
    ]);
    const ensureCollectedDiscographyIds = (0, $acw62.useCallback)(async (clientId)=>{
        if (collectedIdsLoaded.current) return {
            known: true,
            ids: collectedDiscographyIds
        };
        const fetched = await getCollectedDiscographyIds(clientId);
        // A failed or superseded fetch is not evidence of "no existing IDs" — say so rather
        // than returning an empty list the caller would read as "nothing to overwrite".
        return fetched ? {
            known: true,
            ids: fetched
        } : {
            known: false
        };
    }, [
        collectedDiscographyIds,
        getCollectedDiscographyIds
    ]);
    const elapsed = (0, $acw62.useMemo)(()=>(0, $b56fb8f4df8e7ea3$export$18608c84ede3221c)(status) ? (0, $b56fb8f4df8e7ea3$export$5be8bd33ddde0187)(requestedAt, now) : null, [
        status,
        requestedAt,
        now
    ]);
    const indicator = (0, $acw62.useMemo)(()=>(0, $b56fb8f4df8e7ea3$export$1477c7d6a515fd96)(status, {
            elapsed: elapsed,
            isStalled: isStalled,
            errorDetail: errorDetail
        }), [
        status,
        elapsed,
        isStalled,
        errorDetail
    ]);
    const value = (0, $acw62.useMemo)(()=>{
        return {
            status: status,
            phase: phase,
            indicator: indicator,
            elapsed: elapsed,
            isStalled: isStalled,
            errorDetail: errorDetail,
            triggerDisabled: (0, $b56fb8f4df8e7ea3$export$eeeaf4d8d237ce2d)(status),
            canCancel: (0, $b56fb8f4df8e7ea3$export$6fcdc52d0455e1a1)(status),
            source: source,
            sourceId: sourceId,
            collectedDiscographyIds: collectedDiscographyIds ?? [],
            autoCollectIds: autoCollectIds,
            cancelAutoCollectIds: cancelAutoCollectIds,
            cancelAutoCollectIdsInProgress: cancelAutoCollectIdsInProgress,
            getCollectedDiscographyIds: getCollectedDiscographyIds,
            ensureCollectedDiscographyIds: ensureCollectedDiscographyIds
        };
    }, [
        status,
        phase,
        indicator,
        elapsed,
        isStalled,
        errorDetail,
        source,
        sourceId,
        collectedDiscographyIds,
        autoCollectIds,
        cancelAutoCollectIds,
        cancelAutoCollectIdsInProgress,
        getCollectedDiscographyIds,
        ensureCollectedDiscographyIds
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fb3e3eaca9d70655$var$DiscographyIdsContex.Provider, {
        value: value,
        children: children
    });
};
const $fb3e3eaca9d70655$export$c71b1e37f2e0ace0 = (props)=>{
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    if (!clientId) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fb3e3eaca9d70655$var$DiscographyIdsProviderImplementation, {
        ...props,
        clientId: clientId
    });
};
const $fb3e3eaca9d70655$export$cfc5730c3495bd2b = ()=>{
    const context = (0, $acw62.useContext)($fb3e3eaca9d70655$var$DiscographyIdsContex);
    if (!context) throw new Error("Cannot use DiscographyIds without provider");
    return context;
};






var $acw62 = parcelRequire("acw62");

function $8961ff11963ff74e$export$76238e056cd0c052({ externalIds: externalIds, title: title }) {
    const discog_id = (0, $acw62.useMemo)(()=>externalIds.find((externalId)=>externalId.source === "discogs")?.id, [
        externalIds
    ]);
    if (discog_id) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e8b140ba9efae563$export$f0553479e1a1feb3), {
        discogId: discog_id,
        title: title
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf10c2f08346e322$export$3f5eb857c8edfe4d), {});
}





function $2b6ac978d2ae7c3b$export$f24c68efd51f8274(artistId) {
    return `https://open.spotify.com/artist/${artistId}`;
}
function $2b6ac978d2ae7c3b$export$fcaf5b7bee37dce9(artistId) {
    return `https://www.discogs.com/artist/${artistId}`;
}
function $2b6ac978d2ae7c3b$export$c1308c3c40c54272(artistId) {
    return `https://www.deezer.com/en/artist/${artistId}`;
}
function $2b6ac978d2ae7c3b$export$576bdca90ecf816e(artistId) {
    return `https://musicbrainz.org/artist/${artistId}`;
}
function $2b6ac978d2ae7c3b$export$2b3e309b6e59ebdf(artistId, source) {
    switch(source){
        case "spotify":
            return $2b6ac978d2ae7c3b$export$f24c68efd51f8274(artistId);
        case "deezer":
            return $2b6ac978d2ae7c3b$export$c1308c3c40c54272(artistId);
        case "discogs":
            return $2b6ac978d2ae7c3b$export$fcaf5b7bee37dce9(artistId);
        case "musicbrainz":
            return $2b6ac978d2ae7c3b$export$576bdca90ecf816e(artistId);
        default:
            return "";
    }
}
const $2b6ac978d2ae7c3b$export$eb54afb9e215f14f = (source_ids)=>{
    return source_ids.some((source_id)=>!source_id.valid);
};




var $acw62 = parcelRequire("acw62");



const $004d21965b9ef321$var$ACTIVE_STATUSES = [
    "preparing",
    "running",
    "canceling"
];
// Map the backend phase (preferred) — or the legacy DagsterRunStatus — to the coarse status.
function $004d21965b9ef321$var$deriveStatus(phase, status) {
    switch(phase){
        case "REQUESTED":
        case "LAUNCHING":
        case "STARTING":
            return "preparing";
        case "RUNNING":
        case "WAITING_FOR_SENSOR":
            return "running";
        case "CANCELLING":
            return "canceling";
        case "CANCELLED":
            return "cancelled";
        case "SUCCEEDED":
            return "finished";
        case "FAILED":
            return "failed";
    }
    switch(status){
        case "QUEUED":
        case "NOT_STARTED":
        case "MANAGED":
        case "STARTING":
            return "preparing";
        case "STARTED":
            return "running";
        case "SUCCESS":
            return "finished";
        case "CANCELING":
            return "canceling";
        case "CANCELED":
            return "cancelled";
        case "FAILURE":
            return "failed";
        default:
            return "not-started";
    }
}
const $004d21965b9ef321$var$PrimaryDiscographyRunContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $004d21965b9ef321$var$PrimaryDiscographyRunProviderImplementation = ({ children: children, clientId: clientId })=>{
    // Guards against firing a second create/restart before the first request settles. The
    // backend is the real guarantee (it rejects a concurrent trigger with 409); this just
    // avoids a wasted round-trip and a flash of stale UI.
    const creatingRun = (0, $acw62.useRef)(false);
    const [status, setStatus] = (0, $fcbcabcdd5e0aacc$export$b313845ce8fd18ca)("primary_discography_run_status", null, {
        namespace: clientId
    });
    const [phase, setPhase] = (0, $acw62.useState)(null);
    const [currentStep, setCurrentStep] = (0, $acw62.useState)(null);
    const [totalSteps, setTotalSteps] = (0, $acw62.useState)(null);
    const [currentStepLabel, setCurrentStepLabel] = (0, $acw62.useState)(null);
    const [isStalled, setIsStalled] = (0, $acw62.useState)(false);
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const getLatestPipelineStatus = (0, $acw62.useCallback)(async (clientId)=>{
        return api.retrievePipelineRunStatus({
            userId: clientId
        }).then((data)=>{
            setPhase(data.phase ?? null);
            setCurrentStep(data.currentStep ?? null);
            setTotalSteps(data.totalSteps ?? null);
            setCurrentStepLabel(data.currentStepLabel ?? null);
            setIsStalled(Boolean(data.isStalled));
            setStatus($004d21965b9ef321$var$deriveStatus(data.phase, data.status));
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (creatingRun.current) return;
        if (!$004d21965b9ef321$var$ACTIVE_STATUSES.includes(status)) getLatestPipelineStatus(clientId).catch((err)=>{
            console.log(err);
            setStatus((state)=>!$004d21965b9ef321$var$ACTIVE_STATUSES.includes(state) ? "not-started" : state);
        });
    }, [
        clientId,
        status
    ]);
    (0, $acw62.useEffect)(()=>{
        if (creatingRun.current) return;
        if (!$004d21965b9ef321$var$ACTIVE_STATUSES.includes(status)) return;
        let finalJobStatusFetchTimeout = null;
        const fetchFinalJobStatus = ()=>{
            getLatestPipelineStatus(clientId).catch((err)=>{
                console.log(err);
                setStatus("not-started");
            });
            finalJobStatusFetchTimeout = setTimeout(()=>{
                fetchFinalJobStatus();
            }, 3000);
        };
        finalJobStatusFetchTimeout = setTimeout(()=>{
            fetchFinalJobStatus();
        }, 3000);
        return ()=>{
            if (finalJobStatusFetchTimeout) clearTimeout(finalJobStatusFetchTimeout);
        };
    }, [
        status,
        clientId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (creatingRun.current) return;
        getLatestPipelineStatus(clientId).catch((err)=>{
            console.log(err);
            setStatus((state)=>!$004d21965b9ef321$var$ACTIVE_STATUSES.includes(state) ? "not-started" : state);
        });
    }, [
        clientId
    ]);
    const startRun = (0, $acw62.useCallback)(async ()=>{
        if (creatingRun.current) return;
        creatingRun.current = true;
        setStatus("preparing");
        setPhase("REQUESTED");
        setIsStalled(false);
        try {
            await api.createPipelineRunStatus({
                pipelineRunRequest: {
                    userId: clientId
                }
            });
        } catch (err) {
            // 409 = a run is already active for this artist (e.g. another tab/admin). That is the
            // backend doing its job; just fall through and poll for the real state.
            console.log(err);
        } finally{
            creatingRun.current = false;
        }
        getLatestPipelineStatus(clientId).catch((err)=>{
            console.log(err);
            setStatus((state)=>!$004d21965b9ef321$var$ACTIVE_STATUSES.includes(state) ? "not-started" : state);
        });
    }, [
        clientId
    ]);
    const restartRun = (0, $acw62.useCallback)(async ()=>{
        if (creatingRun.current) return;
        creatingRun.current = true;
        setStatus("preparing");
        setPhase("LAUNCHING");
        setIsStalled(false);
        try {
            await api.restartPrimaryDiscographyRunPipelineRunStatus({
                userId: clientId
            });
        } catch (err) {
            console.log(err);
        } finally{
            creatingRun.current = false;
        }
        getLatestPipelineStatus(clientId).catch((err)=>{
            console.log(err);
        });
    }, [
        clientId
    ]);
    const cancelRun = (0, $acw62.useCallback)(async ()=>{
        setStatus("canceling");
        setPhase("CANCELLING");
        setIsStalled(false);
        api.cancelPrimaryDiscographyRunPipelineRunStatus({
            userId: clientId
        }).then(()=>getLatestPipelineStatus(clientId).catch((err)=>{
                console.log(err);
                setStatus((state)=>!$004d21965b9ef321$var$ACTIVE_STATUSES.includes(state) ? "not-started" : state);
            })).catch((ex)=>{
            console.log(ex);
        });
    }, [
        clientId
    ]);
    const actionsDisabled = (0, $acw62.useMemo)(()=>{
        switch(status){
            case "not-started":
            case "finished":
            case "cancelled":
            case "failed":
                return false;
            default:
                return true;
        }
    }, [
        status
    ]);
    const value = (0, $acw62.useMemo)(()=>{
        return {
            status: status,
            phase: phase,
            currentStep: currentStep,
            totalSteps: totalSteps,
            currentStepLabel: currentStepLabel,
            isStalled: isStalled,
            actionsDisabled: actionsDisabled,
            startRun: startRun,
            restartRun: restartRun,
            cancelRun: cancelRun
        };
    }, [
        status,
        phase,
        currentStep,
        totalSteps,
        currentStepLabel,
        isStalled,
        actionsDisabled,
        startRun,
        restartRun,
        cancelRun
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($004d21965b9ef321$var$PrimaryDiscographyRunContext.Provider, {
        value: value,
        children: children
    });
};
const $004d21965b9ef321$export$7f62b772a1698e6 = (props)=>{
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    if (!clientId) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($004d21965b9ef321$var$PrimaryDiscographyRunProviderImplementation, {
        ...props,
        clientId: clientId
    });
};
const $004d21965b9ef321$export$8c32be3a47a5b6d6 = ()=>{
    const context = (0, $acw62.useContext)($004d21965b9ef321$var$PrimaryDiscographyRunContext);
    if (!context) throw new Error("Cannot use PrimaryDiscographyRunContext without provider");
    return context;
};


function $8503c7a26359d6fd$var$NoQueryInformation() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center tw-h-64",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                size: 16,
                className: "text-gray-400"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-gray-400 tw-text-sm mb-2",
                children: "Start typing to search for artists, releases, and labels"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-gray-500 tw-text-xs",
                children: "Results will appear as you type"
            })
        ]
    });
}
function $8503c7a26359d6fd$export$4e5af08e77f3f9f3() {
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)("");
    const isLoadingMore = false;
    const { clientId: clientId, setClientEmail: setClientEmail } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const searchResultsRef = (0, $acw62.useRef)(null);
    const [confirmationModalDetails, setConfirmationModalDetails] = (0, $acw62.useState)(null);
    const baseApi = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const api = baseApi.adminApi;
    const { autoCollectIds: autoCollectIds, status: autoCollectStatus, indicator: autoCollectIndicator, triggerDisabled: autoCollectDisabled, source: autoCollectSource, sourceId: autoCollectSourceId, ensureCollectedDiscographyIds: ensureCollectedDiscographyIds } = (0, $fb3e3eaca9d70655$export$cfc5730c3495bd2b)();
    const { actionsDisabled: actionsDisabled } = (0, $004d21965b9ef321$export$8c32be3a47a5b6d6)();
    const [displayedResults, setDisplayedResults] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        // Immediately reset scroll position on new search
        if (searchResultsRef.current) searchResultsRef.current.scrollTop = 0;
        if (searchQuery.trim() === "") {
            setDisplayedResults([]);
            return;
        }
        const debounceTimer = setTimeout(()=>{
            api.searchDiscogsSearch({
                searchTerm: searchQuery
            }).then((data)=>{
                const basicList = data.artists.map((artist)=>({
                        title: artist.name,
                        type: "Artist",
                        ...artist
                    }));
                const collapsedList = basicList.filter((artist)=>{
                    const { externalIds: externalIds } = artist;
                    if (!Array.isArray(externalIds)) return true;
                    if (artist.source === "discogs") return true;
                    // If there is already an alias from discogs we collapse this result
                    if (artist.source === "musicbrainz") {
                        if (basicList.find((originalArtist)=>originalArtist.source === "discogs" && externalIds.some((externalId)=>externalId.id === originalArtist.id && externalId.source === "discogs"))) return false;
                    }
                    return true;
                });
                console.log("collapsedList results", collapsedList);
                setDisplayedResults(collapsedList);
            }).catch((error)=>console.log(error));
        }, 500);
        return ()=>clearTimeout(debounceTimer);
    }, [
        searchQuery,
        api
    ]);
    // A run is genuinely in flight, as opposed to the trigger being disabled merely because
    // we cannot currently see the backend. The two want different treatment below.
    const collectionActive = (0, $b56fb8f4df8e7ea3$export$18608c84ede3221c)(autoCollectStatus);
    /** The search row the current run was started from, if it is on screen. */ const isRunRow = (resultId, resultSource)=>autoCollectDisabled && resultId === autoCollectSourceId && resultSource === autoCollectSource;
    /**
   * Whether this row gets a button at all.
   *
   * While a collection is running, every row *except* the one it was started from loses its
   * button: greyed-out lime still reads as clickable, so a disabled button there just
   * invites the repeat-clicking this whole change exists to stop. The state is not hidden —
   * the run's own row shows its phase and clock, and the panel on the right carries the
   * spinner and the Cancel button.
   *
   * The `unknown` case deliberately does NOT hide anything. There the trigger is disabled
   * because the status endpoint is unreachable, and blanking every button on screen with no
   * on-row explanation is how an ordinary backend hiccup turns into "the page is broken".
   * Those rows keep a plainly disabled button, and the banner says why.
   */ const showsButton = (resultId, resultSource)=>!collectionActive || isRunRow(resultId, resultSource);
    const handlePopulateIdsClick = async (source_id, source)=>{
        if (!clientId) return;
        // Cheap early-out for a click on an already-disabled button. It reads a render-time
        // value, so it cannot catch a second click during the await below — the `mutating` ref
        // inside `autoCollectIds`, and the backend's 409, are what actually make that safe.
        if (autoCollectDisabled) return;
        // Usually already in context — the provider re-reads the collected IDs whenever a run
        // finishes — in which case this resolves without a round-trip. Deciding the confirm
        // modal used to *always* cost a fetch that downloads and unpickles the collection file
        // server-side, which is a large part of why the click felt unresponsive and invited a
        // second one. It still fetches when we genuinely have not looked yet, because skipping
        // the warning is worse than a slow click.
        const existing = await ensureCollectedDiscographyIds(clientId);
        // Warn unless we positively know there is nothing to lose. "We could not find out" has
        // to fall on the cautious side: skipping the prompt destroys hand-curated IDs.
        if (!existing.known || existing.ids.length > 0) {
            setConfirmationModalDetails({
                clientId: clientId,
                source: source,
                sourceId: source_id
            });
            return;
        }
        autoCollectIds(clientId, source_id, source);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6790db85a3c2ee37$export$a3533c31c6fd4e87), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-h-full tw-w-h-full tw-w-[30%] tw-border-r tw-border-gray-700 tw-flex tw-flex-col tw-relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-border-b tw-border-gray-700 tw-p-4 ",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-items-center tw-justify-between tw-mb-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "tw-text-white tw-font-medium tw-text-lg",
                                    children: "Search"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-relative tw-w-full",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            placeholder: "Search...",
                                            value: searchQuery,
                                            onChange: (e)=>setSearchQuery(e.target.value),
                                            className: "tw-w-full tw-bg-gray-700 tw-border-none tw-rounded-md tw-pl-10 tw-pr-10 tw-py-2 tw-text-white tw-outline-none",
                                            // eslint-disable-next-line jsx-a11y/no-autofocus
                                            autoFocus: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "tw-text-gray-400"
                                            })
                                        }),
                                        searchQuery && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "tw-absolute tw-inset-y-0 tw-right-0 tw-pr-3 tw-flex tw-items-center",
                                            onClick: ()=>setSearchQuery(""),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "tw-text-gray-400 tw-hover-text-white"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex-1 tw-overflow-y-auto",
                        ref: searchResultsRef,
                        children: searchQuery ? // Search results when query exists
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                displayedResults.map((result)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-border-b tw-border-gray-700 tw-py-2 tw-px-3 tw-flex tw-items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                href: (0, $2b6ac978d2ae7c3b$export$2b3e309b6e59ebdf)(result.id, result.source),
                                                className: "tw-w-12 tw-h-12 tw-mr-3 tw-flex-shrink-0 tw-bg-gray-700 tw-rounded tw-overflow-hidden",
                                                children: result.source === "discogs" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e8b140ba9efae563$export$f0553479e1a1feb3), {
                                                    discogId: result.id,
                                                    title: result.title
                                                }) : result.source === "musicbrainz" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8961ff11963ff74e$export$76238e056cd0c052), {
                                                    title: result.title,
                                                    externalIds: result.externalIds ?? []
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf10c2f08346e322$export$3f5eb857c8edfe4d), {})
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex-grow tw-min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "tw-text-white tw-font-bold tw-text-sm tw-truncate tw-font-sans",
                                                        children: result.title
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-flex tw-items-center tw-mt-0.5",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "tw-text-gray-300 tw-text-xs",
                                                                children: result.type
                                                            }),
                                                            result.source && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "tw-mx-1 tw-text-gray-500 tw-text-xs",
                                                                        children: "\u2022"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "tw-text-gray-400 tw-text-xs",
                                                                        children: result.source
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            actionsDisabled || !showsButton(result.id, result.source) ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: [
                                                    "tw-scale-75",
                                                    // The run's own row pulses; it is the progress indicator.
                                                    isRunRow(result.id, result.source) && !autoCollectIndicator.attention ? "tw-animate-pulse" : "",
                                                    // Only reachable in the `unknown` case (an active run hides these
                                                    // rows outright). `Button`'s disabled styling is `tw-grayscale`,
                                                    // and greyscaled lime is still a bright, clickable-looking pill —
                                                    // which is why these read as enabled on screen. Dim them properly.
                                                    autoCollectDisabled && !isRunRow(result.id, result.source) ? "tw-opacity-40 tw-cursor-not-allowed" : ""
                                                ].filter(Boolean).join(" "),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $683bf00e40c955d9$export$353f5b6fc5456de1), {
                                                    disabled: autoCollectDisabled,
                                                    styleType: "btn-primary",
                                                    onClick: ()=>handlePopulateIdsClick(result.id, result.source),
                                                    children: isRunRow(result.id, result.source) ? autoCollectIndicator.detail : "Populate IDs"
                                                })
                                            })
                                        ]
                                    }, result.id)),
                                isLoadingMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-flex tw-justify-center tw-items-center tw-py-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                        size: 24,
                                        className: "tw-text-westburyBlue tw-animate-spin"
                                    })
                                })
                            ]
                        }) : // Instructions when no query
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8503c7a26359d6fd$var$NoQueryInformation, {})
                    })
                ]
            }),
            confirmationModalDetails ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                onClose: ()=>setConfirmationModalDetails(null),
                isOpen: Boolean(confirmationModalDetails),
                title: "Re-populate Discography IDs?",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                "Are you sure you want to continue?",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                "This will overwrite the existing populated IDs"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-mt-4 tw-w-full tw-flex tw-justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    label: "Cancel",
                                    variant: "secondary",
                                    onClick: ()=>{
                                        setConfirmationModalDetails(null);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    label: "Continue",
                                    variant: "primary",
                                    onClick: ()=>{
                                        autoCollectIds(confirmationModalDetails.clientId, confirmationModalDetails.sourceId, confirmationModalDetails.source);
                                        setConfirmationModalDetails(null);
                                    }
                                })
                            ]
                        })
                    ]
                })
            }) : null
        ]
    });
}


/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a2dfa57d290a8089$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m4.9 4.9 14.2 14.2",
            key: "1m5liu"
        }
    ]
];
const $a2dfa57d290a8089$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ban", $a2dfa57d290a8089$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f88028b3cc726f6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $4f88028b3cc726f6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-down", $4f88028b3cc726f6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b397e876e35a9277$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const $b397e876e35a9277$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-up", $b397e876e35a9277$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a3266583f46f84dc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
            key: "sobvz5"
        }
    ],
    [
        "path",
        {
            d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
            key: "11i496"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M12 22v-2",
            key: "1osdcq"
        }
    ],
    [
        "path",
        {
            d: "m17 20.66-1-1.73",
            key: "eq3orb"
        }
    ],
    [
        "path",
        {
            d: "M11 10.27 7 3.34",
            key: "16pf9h"
        }
    ],
    [
        "path",
        {
            d: "m20.66 17-1.73-1",
            key: "sg0v6f"
        }
    ],
    [
        "path",
        {
            d: "m3.34 7 1.73 1",
            key: "1ulond"
        }
    ],
    [
        "path",
        {
            d: "M14 12h8",
            key: "4f43i9"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "m20.66 7-1.73 1",
            key: "1ow05n"
        }
    ],
    [
        "path",
        {
            d: "m3.34 17 1.73-1",
            key: "nuk764"
        }
    ],
    [
        "path",
        {
            d: "m17 3.34-1 1.73",
            key: "2wel8s"
        }
    ],
    [
        "path",
        {
            d: "m11 13.73-4 6.93",
            key: "794ttg"
        }
    ]
];
const $a3266583f46f84dc$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("cog", $a3266583f46f84dc$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $766b7a414a24981f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 18V5l12-2v13",
            key: "1jmyc2"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "18",
            r: "3",
            key: "fqmcym"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "16",
            r: "3",
            key: "1hluhg"
        }
    ]
];
const $766b7a414a24981f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("music", $766b7a414a24981f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6c2a827dd5c2d433$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
];
const $6c2a827dd5c2d433$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pencil", $6c2a827dd5c2d433$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a800148d042d893$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $8a800148d042d893$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("refresh-cw", $8a800148d042d893$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1d55a58c47e43a5b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
];
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trash-2", $1d55a58c47e43a5b$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");





/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbde4c3396582d11$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $dbde4c3396582d11$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("plus", $dbde4c3396582d11$export$3efd853dbb351e94);


/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8240f8fcfc513968$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("check", $8240f8fcfc513968$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");




function $4ed092134b4ac0ae$export$e201bc85b2771d70({ artist: artist, source: source, source_id: source_id, onChange: onChange }) {
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { getCollectedDiscographyIds: getCollectedDiscographyIds } = (0, $fb3e3eaca9d70655$export$cfc5730c3495bd2b)();
    const [loadingValidate, setLoadingValidate] = (0, $acw62.useState)(false);
    const [loadingReject, setLoadingReject] = (0, $acw62.useState)(false);
    const { actionsDisabled: actionsDisabled } = (0, $004d21965b9ef321$export$8c32be3a47a5b6d6)();
    const sourceId = (0, $acw62.useMemo)(()=>{
        return artist.source_ids[source].find((s)=>s.id === source_id);
    }, [
        artist,
        source,
        source_id
    ]);
    const validateSourceId = (0, $acw62.useCallback)(()=>{
        if (!clientId || !sourceId || actionsDisabled) return;
        setLoadingValidate(true);
        const sourceIdUpdate = {
            valid: sourceId.valid,
            approved: true,
            rejected: false
        };
        const shared = {
            userId: clientId,
            sourceId: source_id,
            artistSourceIdUpdate: sourceIdUpdate
        };
        (artist.type === "group" ? api.updateBandSourceIdSourceId({
            bandId: artist.id,
            ...shared
        }) : api.updateAliasSourceIdSourceId({
            aliasId: artist.id,
            ...shared
        })).then(()=>{
            getCollectedDiscographyIds(clientId);
            onChange?.({
                valid: sourceId.valid,
                approved: true,
                rejected: false
            });
        }).catch((ex)=>{
            console.log(ex);
        }).finally(()=>{
            setLoadingValidate(false);
        });
    }, [
        api,
        source_id,
        artist.id,
        sourceId,
        actionsDisabled
    ]);
    const rejectSourceId = (0, $acw62.useCallback)(()=>{
        if (!clientId || !sourceId || actionsDisabled) return;
        setLoadingReject(true);
        const shared = {
            userId: clientId,
            sourceId: source_id,
            artistSourceIdUpdate: {
                valid: sourceId.valid,
                approved: false,
                rejected: true
            }
        };
        (artist.type === "group" ? api.updateBandSourceIdSourceId({
            bandId: artist.id,
            ...shared
        }) : api.updateAliasSourceIdSourceId({
            aliasId: artist.id,
            ...shared
        })).then(()=>{
            getCollectedDiscographyIds(clientId);
            onChange?.({
                valid: sourceId.valid,
                approved: false,
                rejected: true
            });
        }).catch((ex)=>{
            console.log(ex);
        }).finally(()=>{
            setLoadingReject(false);
        });
    }, [
        api,
        source_id,
        artist.id,
        sourceId,
        actionsDisabled
    ]);
    const uncertainSourceId = (0, $acw62.useCallback)(()=>{
        if (!clientId || !sourceId || actionsDisabled) return;
        setLoadingReject(true);
        const shared = {
            userId: clientId,
            sourceId: source_id,
            artistSourceIdUpdate: {
                valid: false,
                approved: false,
                rejected: false
            }
        };
        (artist.type === "group" ? api.updateBandSourceIdSourceId({
            bandId: artist.id,
            ...shared
        }) : api.updateAliasSourceIdSourceId({
            aliasId: artist.id,
            ...shared
        })).then(()=>{
            getCollectedDiscographyIds(clientId);
            onChange?.({
                valid: false,
                approved: false,
                rejected: false
            });
        }).catch((ex)=>{
            console.log(ex);
        }).finally(()=>{
            setLoadingReject(false);
        });
    }, [
        api,
        source_id,
        artist.id,
        sourceId,
        actionsDisabled
    ]);
    if (!sourceId) return null;
    const isApproved = sourceId.approved;
    const isRejected = sourceId.rejected;
    const isValid = sourceId.valid && !isRejected && !isApproved;
    const isUnderReview = !isValid && !isRejected && !isApproved;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-group tw-flex tw-items-center tw-justify-center tw-relative tw-w-full",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-w-full",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: (0, $2b6ac978d2ae7c3b$export$2b3e309b6e59ebdf)(sourceId.id, source),
                                className: "tw-text-gray-400 tw-mr-1 tw-underline",
                                children: sourceId.original_name
                            })
                        }),
                        !actionsDisabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-justify-end tw-items-start tw-flex-grow",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-gap-1 tw-items-center tw-justify-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: [
                                            "tw-p-0.5  tw-rounded tw-cursor-pointer",
                                            isApproved || isValid ? "tw-bg-westburyGreen" : "tw-bg-gray-500"
                                        ].join(" "),
                                        title: "Mark as valid",
                                        type: "button",
                                        onClick: validateSourceId,
                                        children: loadingValidate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                            size: 10,
                                            className: "tw-animate-spin"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                            size: 10,
                                            strokeWidth: "4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: uncertainSourceId,
                                        type: "button",
                                        className: [
                                            "tw-p-o tw-m-0 tw-rounded tw-cursor-pointer",
                                            isUnderReview ? "tw-bg-westburyAmber" : "tw-bg-gray-500"
                                        ].join(" "),
                                        title: "Uncertain",
                                        children: loadingReject ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                            size: 10,
                                            className: "tw-animate-spin"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-text-xs tw-flex tw-items-center tw-justify-center tw-p-0 tw-m-0",
                                            style: {
                                                height: "14px",
                                                width: "14px",
                                                lineHeight: "12px",
                                                fontSize: "12px"
                                            },
                                            children: "?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: rejectSourceId,
                                        type: "button",
                                        className: [
                                            "tw-p-0.5 tw-rounded tw-cursor-pointer",
                                            isRejected ? "tw-bg-westburyRed" : "tw-bg-gray-500"
                                        ].join(" "),
                                        title: "Reject",
                                        children: loadingReject ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                            size: 10,
                                            className: "tw-animate-spin"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                            size: 10,
                                            strokeWidth: "4"
                                        })
                                    })
                                ]
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    title: sourceId.id,
                    className: [
                        "tw-text-ellipsis tw-overflow-hidden",
                        isApproved ? "tw-text-westburyGreen" : "",
                        isRejected ? "tw-text-westburyRed" : "",
                        isValid ? "tw-text-westburyBlue" : "",
                        isUnderReview ? "tw-text-westburyAmber" : ""
                    ].join(" "),
                    children: sourceId.id
                })
            ]
        })
    });
}


function $350900d80b13e467$var$Tooltip({ idTooltip: idTooltip }) {
    if (idTooltip) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-fixed tw-bg-gray-900 tw-text-white tw-text-xs tw-py-1 tw-px-2 tw-rounded tw-z-50 tw-shadow-lg",
        style: {
            top: idTooltip.position.top + "px",
            left: idTooltip.position.left + "px",
            transform: "translateX(-50%)"
        },
        children: idTooltip.id
    });
    return null;
}
// Function to format ID to show only last 4 characters
const $350900d80b13e467$var$formatId = (id)=>{
    if (!id) return "";
    return id.length > 4 ? `...${id.slice(-4)}` : id;
};
function $350900d80b13e467$var$ArtistDiscographySourceIdCellImplementation({ artist: artist, source: source, expanded: expanded = true, openIdDetailsModal: openIdDetailsModal, handleAddIdFromCell: handleAddIdFromCell }) {
    const sourceIds = artist.source_ids[source];
    // Function to format ID to show only last 4 characters
    const [idTooltip, setIdTooltip] = (0, $acw62.useState)(null);
    const [displayText, setDisplayText] = (0, $acw62.useState)(sourceIds.length > 0 ? sourceIds.some((id)=>!id.valid && !id.approved && !id.rejected) ? sourceIds.find((id)=>!id.valid && !id.approved && !id.rejected)?.id : sourceIds[0].id : "");
    const [isMeasuring, setIsMeasuring] = (0, $acw62.useState)(true);
    const containerRef = (0, $acw62.useRef)(null);
    // Function to show full ID on hover
    const showFullId = (0, $acw62.useCallback)((id, event)=>{
        const rect = event.currentTarget.getBoundingClientRect();
        setIdTooltip({
            id: id,
            position: {
                top: rect.top - 30,
                left: rect.left + rect.width
            }
        });
    }, []);
    // Function to hide full ID
    const hideFullId = (0, $acw62.useCallback)(()=>{
        setIdTooltip(null);
    }, []);
    (0, $acw62.useEffect)(()=>{
        setIsMeasuring(true);
    }, [
        artist
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (sourceIds.length === 0) {
            setIsMeasuring(false);
            return;
        }
        if (containerRef.current) {
            const element = containerRef.current;
            // We render with the full ID initially. If the container's height is larger
            // than a single line's height, it means the content wrapped.
            const firstSpan = element.querySelector("span");
            if (firstSpan) {
                const singleLineHeight = firstSpan.offsetHeight;
                if (element.offsetHeight > singleLineHeight * 1.75) {
                    setDisplayText($350900d80b13e467$var$formatId(sourceIds[0].id));
                    setIsMeasuring(false);
                    return;
                }
            }
        }
        if (displayText?.length === 0) // This is in case we don't need to collapse the id
        setDisplayText(sourceIds.length > 0 ? sourceIds.some((id)=>!id.valid && !id.approved && !id.rejected) ? sourceIds.find((id)=>!id.valid && !id.approved && !id.rejected)?.id : sourceIds[0].id : "");
        setIsMeasuring(false);
    }, [
        sourceIds,
        isMeasuring
    ]);
    (0, $acw62.useEffect)(()=>{
        console.log("mounted", {
            id: artist.id,
            source: source
        });
        return ()=>{
            console.log("un-mounted", {
                id: artist.id,
                source: source
            });
        };
    }, []);
    if (sourceIds.length > 0) {
        if (expanded) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-flex-col gap-2 tw-max-w-full tw-min-w-full",
            children: sourceIds.map((sourceId)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-flex-wrap tw-items-start tw-text-xs",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed092134b4ac0ae$export$e201bc85b2771d70), {
                        artist: artist,
                        source: source,
                        source_id: sourceId.id
                    })
                }, sourceId.id))
        });
        const someInReview = sourceIds.some((id)=>!id.valid && !id.approved && !id.rejected);
        const firstInReview = sourceIds.find((id)=>!id.valid && !id.approved && !id.rejected);
        const sourceId = someInReview ? firstInReview : sourceIds[0];
        if (!sourceId) return null;
        const isApproved = sourceId.approved;
        const isRejected = sourceId.rejected;
        const isValid = sourceId.valid && !isRejected && !isApproved;
        const isUnderReview = !isValid && !isRejected && !isApproved;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `tw-cursor-pointer`,
            onClick: ()=>openIdDetailsModal(artist.id, source),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-flex-col",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        ref: containerRef,
                        className: "tw-flex tw-flex-wrap tw-items-center tw-text-xs",
                        style: {
                            visibility: isMeasuring ? "hidden" : "visible"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-gray-400 tw-mr-1",
                                children: sourceId?.original_name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "tw-flex tw-flex-wrap tw-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: [
                                            isApproved ? "tw-text-westburyGreen" : "",
                                            isRejected ? "tw-text-westburyRed" : "",
                                            isValid ? "tw-text-westburyBlue" : "",
                                            isUnderReview ? "tw-text-westburyAmber" : ""
                                        ].join(" "),
                                        onMouseEnter: (e)=>sourceId && showFullId(sourceId.id, e),
                                        onMouseLeave: hideFullId,
                                        children: displayText
                                    }),
                                    sourceIds.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: [
                                            "tw-ml-2  tw-text-gray-300 tw-text-xs tw-px-1.5 tw-py-0.5 tw-rounded-full",
                                            someInReview ? "tw-bg-westburyAmber" : "tw-bg-gray-700"
                                        ].join(" "),
                                        children: [
                                            "+",
                                            sourceIds.length - 1
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($350900d80b13e467$var$Tooltip, {
                    idTooltip: idTooltip
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: "tw-inline-flex tw-items-center tw-justify-center tw-text-surfaceLime tw-text-xs tw-border tw-border-gray-700 tw-rounded-md hover:tw-bg-gray-800",
        onClick: ()=>handleAddIdFromCell(artist.id, source),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                size: 10,
                className: "tw-mr-1"
            }),
            "Add ID"
        ]
    });
}
function $350900d80b13e467$var$ArtistDiscographySourceIdCellWrapper(props) {
    console.log("rerendering cell ArtistDiscographySourceIdCellWrapper");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-py-2 tw-px-3 tw-flex tw-justify-start tw-items-start tw-align-top tw-border-r tw-border-gray-700 tw-w-1/5",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($350900d80b13e467$var$ArtistDiscographySourceIdCellImplementation, {
            ...props
        })
    });
}
const $350900d80b13e467$export$4d15f0dfcfc9f8ae = /*#__PURE__*/ (0, $acw62.memo)($350900d80b13e467$var$ArtistDiscographySourceIdCellWrapper, (prevProps, nextProps)=>{
    return Boolean(prevProps.artist.id === nextProps.artist.id && prevProps.source === nextProps.source && prevProps.openIdDetailsModal === nextProps.openIdDetailsModal);
});





var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e52b122f04c04d7d$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const $e52b122f04c04d7d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("info", $e52b122f04c04d7d$export$3efd853dbb351e94);



/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $737c279b45d43939$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
            key: "1m0v6g"
        }
    ],
    [
        "path",
        {
            d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
            key: "ohrbg2"
        }
    ]
];
const $737c279b45d43939$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("square-pen", $737c279b45d43939$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $839eea37a960d2b1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $839eea37a960d2b1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-x", $839eea37a960d2b1$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");




var $f1q41 = parcelRequire("f1q41");


const $e99a1f9c643cbc26$var$getIdUrl = (platform, id)=>{
    if (!id) return "#";
    switch(platform){
        case "discogs":
            return `https://www.discogs.com/artist/${id}`;
        case "deezer":
            return `https://www.deezer.com/artist/${id}`;
        case "spotify":
            return `https://open.spotify.com/artist/${id}`;
        case "musicbrainz":
            return `https://musicbrainz.org/artist/${id}`;
        default:
            return "#";
    }
};
function $e99a1f9c643cbc26$export$7057afef4108ac27({ item: item, items: items, source: source, allowDelete: allowDelete = false, disabled: disabled = false, onChange: onChange, onRemove: onRemove, validateBandSourceId: validateBandSourceId, excludeFromDuplicateCheckBandId: excludeFromDuplicateCheckBandId }) {
    const { collectedDiscographyIds: collectedDiscographyIds } = (0, $fb3e3eaca9d70655$export$cfc5730c3495bd2b)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const abortController = (0, $acw62.useRef)(null);
    const bandSourceIdCheckTimeout = (0, $acw62.useRef)(null);
    const sourceName = `${source.charAt(0).toUpperCase() + source.slice(1)}`;
    const relevantArtist = (0, $acw62.useMemo)(()=>{
        return collectedDiscographyIds.find((a)=>a.source_ids[source].some((s)=>s.id === item.id));
    }, [
        collectedDiscographyIds,
        item
    ]);
    const shouldShowDuplicateAliasSourceIDError = (0, $acw62.useMemo)(()=>{
        const duplicate = collectedDiscographyIds.find((artist)=>{
            if (excludeFromDuplicateCheckBandId && artist.id === excludeFromDuplicateCheckBandId) return false;
            return artist.source_ids[source].some((id, index)=>{
                if (id.id === item.id && `${artist.id}-${source}-${index}` !== item.itemId) {
                    console.log("Duplicate found", id, item);
                    return true;
                }
                return false;
            });
        });
        const foundRemoteDuplicate = Boolean(duplicate);
        if (foundRemoteDuplicate) return true;
        const foundLocalDuplicate = items.filter((id)=>id.source === source).some((id, index)=>{
            if (id.id === item.id && id.itemId !== item.itemId) return true;
            return false;
        });
        return Boolean(foundLocalDuplicate);
    }, [
        collectedDiscographyIds,
        item,
        items,
        excludeFromDuplicateCheckBandId
    ]);
    // Band modal: validate Discogs/MusicBrainz ID is not already used by another group (debounced)
    const isBandSourceToValidate = validateBandSourceId && (source === "discogs" || source === "musicbrainz");
    const bandSourceIdCheckCancelled = (0, $acw62.useRef)(false);
    const itemRef = (0, $acw62.useRef)(item);
    itemRef.current = item;
    (0, $acw62.useEffect)(()=>{
        if (!isBandSourceToValidate) {
            if (bandSourceIdCheckTimeout.current) {
                clearTimeout(bandSourceIdCheckTimeout.current);
                bandSourceIdCheckTimeout.current = null;
            }
            return;
        }
        if (!item.id?.trim()) {
            if (bandSourceIdCheckTimeout.current) {
                clearTimeout(bandSourceIdCheckTimeout.current);
                bandSourceIdCheckTimeout.current = null;
            }
            onChange({
                ...itemRef.current,
                error: undefined,
                validating: false
            });
            return;
        }
        const sourceId = item.id.trim();
        if (bandSourceIdCheckTimeout.current) clearTimeout(bandSourceIdCheckTimeout.current);
        // Disable Save immediately until this ID is validated (don't wait for debounce)
        onChange({
            ...itemRef.current,
            validating: true
        });
        bandSourceIdCheckCancelled.current = false;
        bandSourceIdCheckTimeout.current = setTimeout(()=>{
            bandSourceIdCheckTimeout.current = null;
            api.findBandBySourceIdArtistBand({
                sourceId: sourceId
            }).then((band)=>{
                if (bandSourceIdCheckCancelled.current) return;
                const currentItem = itemRef.current;
                const { currentBandId: currentBandId } = validateBandSourceId;
                const inUseByOther = !currentBandId || band.id !== currentBandId;
                if (inUseByOther) onChange({
                    ...currentItem,
                    error: `This ${sourceName} ID is already used by another group`,
                    validating: false
                });
                else onChange({
                    ...currentItem,
                    error: undefined,
                    validating: false
                });
            }).catch(()=>{
                if (bandSourceIdCheckCancelled.current) return;
                onChange({
                    ...itemRef.current,
                    error: undefined,
                    validating: false
                });
            });
        }, 500);
        return ()=>{
            bandSourceIdCheckCancelled.current = true;
            if (bandSourceIdCheckTimeout.current) {
                clearTimeout(bandSourceIdCheckTimeout.current);
                bandSourceIdCheckTimeout.current = null;
            }
        };
    }, [
        isBandSourceToValidate,
        item.id,
        item.itemId,
        validateBandSourceId?.currentBandId,
        api,
        sourceName
    ]);
    const handleOnEdit = ()=>{
        onChange({
            ...item,
            editing: true,
            // Store the original values
            originalId: item.id,
            originalArtistName: item.artistName
        });
    };
    const handleCancelEditing = ()=>{
        onChange({
            ...item,
            editing: false,
            id: item.originalId ?? item.id,
            artistName: item.originalArtistName ?? item.artistName,
            originalId: undefined,
            originalArtistName: undefined
        });
    };
    const handleOnChange = (newId)=>{
        onChange({
            ...item,
            id: newId
        });
    };
    const handleOnSave = ()=>{
        if (!clientId) return;
        if (abortController.current) abortController.current.abort();
        onChange({
            ...item,
            validating: true,
            validated: false,
            error: null
        });
        abortController.current = new AbortController();
        // Validate the new ID
        api.searchForSourceSearchForSource({
            userId: clientId,
            source: source,
            sourceId: item.id
        }, {
            signal: abortController.current.signal
        }).then((response)=>{
            if (response.name === null) onChange({
                ...item,
                validating: false,
                validated: true,
                valid: false,
                approved: false,
                rejected: false,
                error: `${sourceName} ID does not exist`
            });
            else onChange({
                ...item,
                editing: false,
                artistName: response.name,
                originalId: undefined,
                originalArtistName: undefined,
                validating: false,
                validated: true,
                valid: false,
                approved: true,
                rejected: false,
                error: null
            });
        }).catch(()=>{
            onChange({
                ...item,
                validating: false,
                validated: true,
                valid: false,
                error: `${sourceName} ID does not exist`
            });
        });
    };
    const handleOnIdResolverChange = (props)=>{
        onChange({
            ...item,
            ...props
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-mb-1.5 tw-bg-gray-700 tw-rounded-md tw-p-1.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-justify-between tw-items-center tw-mb-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-text-xs tw-text-gray-300 tw-flex tw-items-center tw-gap-1",
                        children: item.id && !item.originalId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: relevantArtist ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed092134b4ac0ae$export$e201bc85b2771d70), {
                                artist: relevantArtist,
                                source: source,
                                source_id: item.id,
                                onChange: handleOnIdResolverChange
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                className: "tw-underline",
                                href: $e99a1f9c643cbc26$var$getIdUrl(item.source, item.id),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                title: `View on ${item.source.charAt(0).toUpperCase() + item.source.slice(1)}`,
                                children: item.artistName
                            })
                        }) : null
                    }),
                    !disabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-gap-1",
                        children: [
                            item.validating ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-p-1 tw-bg-gray-600 tw-rounded-md tw-flex tw-items-center tw-justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                    size: 14,
                                    className: "tw-text-westburyBlue tw-animate-spin"
                                })
                            }) : item.validated && !item.error && !item.editing && !item.created_by_system ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    onClick: handleOnEdit,
                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "tw-mr-1"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-text-xs",
                                                children: "Edit"
                                            })
                                        ]
                                    })
                                })
                            }) : item.originalId && !item.created_by_system ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: Boolean(item.error || shouldShowDuplicateAliasSourceIDError) ? "disabled" : "primary",
                                        onClick: handleOnSave,
                                        disabled: Boolean(item.error || shouldShowDuplicateAliasSourceIDError),
                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                    size: 14,
                                                    className: "tw-mr-1"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "tw-text-xs",
                                                    children: "Save"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        onClick: handleCancelEditing,
                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                                                    size: 14,
                                                    className: "tw-mr-1"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "tw-text-xs",
                                                    children: "Cancel"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : !item.created_by_system ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                variant: Boolean(!item.id || item.error || shouldShowDuplicateAliasSourceIDError) ? "disabled" : "primary",
                                onClick: handleOnSave,
                                disabled: Boolean(!item.id || item.error || shouldShowDuplicateAliasSourceIDError),
                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                            size: 14,
                                            className: "tw-mr-1"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-text-xs",
                                            children: "Save"
                                        })
                                    ]
                                })
                            }) : null,
                            (allowDelete || item.artistName) && !item.editing && !item.created_by_system && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                disabled: !item.id && items.filter((i)=>i.source === source).length === 1,
                                onClick: ()=>onRemove(item),
                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                    size: 14
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-items-center tw-gap-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-relative tw-flex-grow",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        disabled: disabled,
                        name: `ids.${item.itemId}.id`,
                        value: item.id,
                        onChange: (e)=>handleOnChange(e.target.value),
                        placeholder: !disabled ? `Enter ${(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).capitalize(source)} ID` : "",
                        className: `tw-w-full tw-bg-gray-600 tw-border ${item.error ? "tw-border-westburyRed" : "tw-border-gray-600"} tw-rounded-md tw-px-2 tw-py-1 tw-text-white tw-outline-none tw-text-sm`,
                        readOnly: item.validated && item.valid && !item.editing
                    })
                })
            }),
            item.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-westburyRed tw-text-xs tw-mt-1",
                children: item.error
            }),
            shouldShowDuplicateAliasSourceIDError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "tw-text-westburyRed tw-text-xs tw-mt-1",
                children: [
                    "Duplicate ",
                    sourceName,
                    " ID"
                ]
            })
        ]
    });
}




const $dbf6134e5e96254f$var$AliasModal = ({ show: show, mode: mode = "create", onClose: onClose, formData: formData, activeTab: activeTab, onTabChange: onTabChange, onItemsChange: onItemsChange, onRemoveItem: onRemoveItem, onNameChange: onNameChange, onAddIdField: onAddIdField, onSubmit: onSubmit })=>{
    const { actionsDisabled: actionsDisabled } = (0, $004d21965b9ef321$export$8c32be3a47a5b6d6)();
    if (!show) return null;
    const showDiscogsMultiplIDsWarning = formData.ids.filter((id)=>id.source === "discogs").length > 1;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-70 tw-flex tw-items-center tw-justify-center tw-z-50",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-bg-gray-800 tw-rounded-lg tw-max-h-[90vh] tw-flex tw-flex-col tw-max-w-xl tw-w-full tw-mx-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-justify-between tw-items-center tw-p-3 tw-border-b tw-border-gray-700",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "tw-text-white tw-text-lg tw-font-medium",
                            children: mode === "create" ? "Add Alias" : "Update Alias"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "tw-text-gray-400 hover:tw-text-white",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 20
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: (e)=>{
                        e.preventDefault();
                        onSubmit();
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-overflow-y-auto tw-p-3 tw-flex-grow",
                            children: [
                                formData.errors.general && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-bg-westburyRed/50 tw-border tw-border-westburyRed tw-text-westburyRed tw-p-2 tw-mb-3 tw-rounded-md",
                                    children: formData.errors.general
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-space-y-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "tw-text-white tw-mb-1 tw-flex tw-items-center",
                                                children: [
                                                    "Alias Name",
                                                    formData.aliasName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `tw-ml-2 tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full ${formData.manualStageName ? "tw-bg-westburyAmber/50 tw-text-westburyAmber" : "tw-bg-westburyBlue/50 tw-text-westburyBlue"}`,
                                                        children: formData.manualStageName ? "Manually entered" : `Auto-populated`
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                disabled: actionsDisabled,
                                                type: "text",
                                                name: "aliasName",
                                                value: formData.aliasName,
                                                onChange: (e)=>onNameChange(e.target.value),
                                                className: `tw-w-full tw-bg-gray-700 tw-border ${formData.errors.aliasName ? "tw-border-westburyRed" : "tw-border-gray-600"} tw-rounded-md tw-px-3 tw-py-1.5 tw-text-white tw-outline-none`,
                                                required: true
                                            }),
                                            formData.errors.aliasName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-westburyRed tw-text-xs tw-mt-1",
                                                children: formData.errors.aliasName
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-flex-grow tw-border-t tw-border-gray-700 tw-p-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-justify-between tw-items-center tw-mb-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-block tw-text-white",
                                            children: "Discography IDs"
                                        }),
                                        !actionsDisabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                            onClick: onAddIdField,
                                            variant: "secondary",
                                            label: "+ Add ID"
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-border-b tw-border-gray-700 tw-mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>onTabChange("discogs"),
                                            className: `tw-px-3 tw-py-1.5 tw-text-sm ${activeTab === "discogs" ? "tw-text-westburyBlue tw-border-b-2 tw-border-westburyBlue" : "tw-text-gray-400"}`,
                                            children: "Discogs"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>onTabChange("deezer"),
                                            className: `tw-px-3 tw-py-1.5 tw-text-sm ${activeTab === "deezer" ? "tw-text-westburyBlue tw-border-b-2 tw-border-westburyBlue" : "tw-text-gray-400"}`,
                                            children: "Deezer"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>onTabChange("spotify"),
                                            className: `tw-px-3 tw-py-1.5 tw-text-sm ${activeTab === "spotify" ? "tw-text-westburyBlue tw-border-b-2 tw-border-westburyBlue" : "tw-text-gray-400"}`,
                                            children: "Spotify"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>onTabChange("musicbrainz"),
                                            className: `tw-px-3 tw-py-1.5 tw-text-sm ${activeTab === "musicbrainz" ? "tw-text-westburyBlue tw-border-b-2 tw-border-westburyBlue" : "tw-text-gray-400"}`,
                                            children: "MusicBrainz"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-h-[300px] tw-overflow-y-auto tw-rounded-md",
                                    children: [
                                        showDiscogsMultiplIDsWarning && activeTab === "discogs" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-bg-westburyBlue/50 tw-border tw-border-westburyBlue tw-text-westburyBlue tw-p-2 tw-mb-3 tw-rounded-md tw-inline-flex tw-gap-2 tw-items-center tw-w-full tw-text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Discogs ID already linked"
                                                })
                                            ]
                                        }) : null,
                                        formData.ids.filter((id)=>id.source === activeTab).map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e99a1f9c643cbc26$export$7057afef4108ac27), {
                                                disabled: actionsDisabled,
                                                source: activeTab,
                                                items: formData.ids,
                                                item: item,
                                                allowDelete: formData.ids.filter((id)=>id.source === activeTab).length > 0,
                                                onRemove: onRemoveItem,
                                                onChange: onItemsChange
                                            }, item.itemId))
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-justify-end tw-space-x-3 tw-p-3 tw-border-t tw-border-gray-700",
                    children: !actionsDisabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                onClick: onClose,
                                label: "Cancel",
                                variant: "secondary"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                onClick: onSubmit,
                                variant: "primary",
                                label: mode === "create" ? "Add" : "Save"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        label: "Close",
                        variant: "secondary"
                    })
                })
            ]
        })
    });
};
var $dbf6134e5e96254f$export$2e2bcd8739ae039 = $dbf6134e5e96254f$var$AliasModal;






var $acw62 = parcelRequire("acw62");







const $d318c431587d8dce$var$BandModal = ({ show: show, mode: mode = "create", onClose: onClose, formData: formData, activeTab: activeTab, onTabChange: onTabChange, onItemsChange: onItemsChange, onRemoveItem: onRemoveItem, onNameChange: onNameChange, onPermanentMemberChange: onPermanentMemberChange, onLinkedAliasChange: onLinkedAliasChange, onAddIdField: onAddIdField, onSubmit: onSubmit, onCreateNewAlias: onCreateNewAlias, onBandModeChange: onBandModeChange, onExistingBandChange: onExistingBandChange, onNewBandFromSourceId: onNewBandFromSourceId, onGroupSourceIdChange: onGroupSourceIdChange, onSkipSourceIdLookup: onSkipSourceIdLookup })=>{
    console.log("=== BandModal render ===");
    console.log("Props received:", {
        show: show,
        formData: {
            ...formData,
            ids: formData.ids?.length || 0
        },
        onBandModeChange: !!onBandModeChange,
        onExistingBandChange: !!onExistingBandChange,
        onBandModeChangeType: typeof onBandModeChange,
        onExistingBandChangeType: typeof onExistingBandChange
    });
    const { collectedDiscographyIds: _unsortedCollectedDiscographyIds } = (0, $fb3e3eaca9d70655$export$cfc5730c3495bd2b)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const collectedDiscographyIds = [
        ..._unsortedCollectedDiscographyIds
    ].sort((a, b)=>{
        return a.stageName.localeCompare(b.stageName);
    });
    const availableAliases = (0, $acw62.useMemo)(()=>{
        const aliases = collectedDiscographyIds.filter((a)=>a.type === "persona");
        return aliases.map((alias)=>({
                label: alias.stageName,
                value: alias.id
            }));
    }, [
        collectedDiscographyIds
    ]);
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)("");
    const [isSearchOpen, setIsSearchOpen] = (0, $acw62.useState)(false);
    const [groupSourceIdInput, setGroupSourceIdInput] = (0, $acw62.useState)("");
    const [sourceIdLookupLoading, setSourceIdLookupLoading] = (0, $acw62.useState)(false);
    const [sourceIdLookupError, setSourceIdLookupError] = (0, $acw62.useState)(null);
    const [unlinkedBands, setUnlinkedBands] = (0, $acw62.useState)([]);
    const [isLoadingBands, setIsLoadingBands] = (0, $acw62.useState)(false);
    const searchRef = (0, $acw62.useRef)(null);
    const [dropdownPosition, setDropdownPosition] = (0, $acw62.useState)(null);
    // Fetch all unlinked bands when linked alias is set (create: for source-id lookup comparison; existing: for dropdown)
    (0, $acw62.useEffect)(()=>{
        console.log("formData", formData);
        console.log("clientId", clientId);
        const currentBandMode = formData.bandMode || "new";
        const isCreateWithAlias = mode === "create" && !!formData.linkedAliasId;
        // Fetch when: existing mode with alias, or create mode with alias (for source-id lookup comparison)
        if (currentBandMode !== "existing" && !isCreateWithAlias) {
            setUnlinkedBands([]);
            setSearchQuery(""); // Clear search when mode changes
            return;
        }
        if (!clientId || !formData.linkedAliasId) {
            setUnlinkedBands([]);
            return;
        }
        console.log("fetching unlinked bands");
        // Fetch all unlinked bands for the given alias
        setIsLoadingBands(true);
        api.searchUnlinkedBandsUnlinkedBand({
            userId: clientId,
            aliasId: formData.linkedAliasId
        }).then((response)=>{
            console.log("=== API Response for unlinked bands ===");
            console.log("Raw response:", response);
            console.log("Response type:", typeof response);
            console.log("Is array:", Array.isArray(response));
            // Handle response - it might be an array or a single object with an array property
            const bands = Array.isArray(response) ? response : response.bands || response.results || [];
            console.log("Extracted bands array:", bands);
            console.log("First band structure:", bands[0]);
            if (bands[0]) {
                console.log("First band keys:", Object.keys(bands[0]));
                console.log("First band.bandId:", bands[0].bandId);
                console.log("First band.band_id:", bands[0].band_id);
            }
            setUnlinkedBands(bands);
        }).catch((error)=>{
            console.error("Error fetching unlinked bands:", error);
            setUnlinkedBands([]);
        }).finally(()=>{
            setIsLoadingBands(false);
        });
    }, [
        formData.linkedAliasId,
        formData.bandMode,
        clientId,
        api,
        mode
    ]);
    // Filter bands client-side based on search query
    const filteredBands = (0, $acw62.useMemo)(()=>{
        // Map bands to display format first
        const mappedBands = unlinkedBands.map((band)=>{
            const idsLabel = band.sourceId ? ` (${band.sourceId})` : "";
            // Use band_id if bandId is not available (API might return band_id instead)
            // Also check if the structure is nested (band.band_id)
            const bandIdValue = band.bandId || band.band_id || band.band?.band_id;
            console.log("Mapping band:", {
                band: band,
                bandId: band.bandId,
                band_id: band.band_id,
                nested_band_id: band.band?.band_id,
                bandIdValue: bandIdValue
            });
            if (!bandIdValue) console.error("WARNING: No band ID found for band:", band);
            return {
                label: `${band.name}${idsLabel}`,
                value: bandIdValue,
                band: band
            };
        });
        console.log("unlinkedBands", unlinkedBands);
        // If no search query (after trimming), return all mapped bands
        const trimmedQuery = searchQuery.trim();
        if (!trimmedQuery) return mappedBands;
        // Filter by matching against the full label (as displayed) using indexOf
        const query = trimmedQuery.toLowerCase();
        console.log("mappedBands", mappedBands);
        return mappedBands.filter((band)=>band.label.toLowerCase().indexOf(query) > -1 || band.band.name.toLowerCase().indexOf(query) > -1 || band.band.sourceId && band.band.sourceId.toLowerCase().indexOf(query) > -1);
    }, [
        unlinkedBands,
        searchQuery
    ]);
    // Update search query when a band is selected (to show the selected band's label)
    (0, $acw62.useEffect)(()=>{
        console.log("=== useEffect for search query update ===");
        console.log("formData.selectedExistingBandId:", formData.selectedExistingBandId);
        console.log("formData.stageName:", formData.stageName);
        console.log("formData.ids:", formData.ids);
        console.log("isSearchOpen:", isSearchOpen);
        console.log("filteredBandsCount:", filteredBands.length);
        if (formData.selectedExistingBandId && !isSearchOpen) {
            // Try to find in filteredBands first
            const selected = filteredBands.find((b)=>b.value === formData.selectedExistingBandId);
            console.log("Selected band in filteredBands:", selected);
            if (selected) {
                console.log("Setting searchQuery to selected label:", selected.label);
                setSearchQuery(selected.label);
            } else if (formData.stageName) {
                // Fallback to stageName from formData if not found in filteredBands
                console.log("Setting searchQuery to stageName:", formData.stageName);
                setSearchQuery(formData.stageName);
            } else console.warn("No selected band found and no stageName available");
        }
    }, [
        formData.selectedExistingBandId,
        formData.stageName,
        formData.ids,
        filteredBands,
        isSearchOpen
    ]);
    // Log formData changes
    (0, $acw62.useEffect)(()=>{
        console.log("=== formData changed ===");
        console.log("formData:", {
            selectedExistingBandId: formData.selectedExistingBandId,
            stageName: formData.stageName,
            bandMode: formData.bandMode,
            idsCount: formData.ids?.length || 0,
            ids: formData.ids
        });
    }, [
        formData.selectedExistingBandId,
        formData.stageName,
        formData.bandMode,
        formData.ids
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const target = event.target;
            if (searchRef.current && !searchRef.current.contains(target) && !document.getElementById("existing-band-listbox")?.contains(target)) setIsSearchOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // Update dropdown position when it opens or window scrolls/resizes
    (0, $acw62.useEffect)(()=>{
        const updatePosition = ()=>{
            if (isSearchOpen && searchRef.current) {
                const rect = searchRef.current.getBoundingClientRect();
                // Use getBoundingClientRect() values directly for fixed positioning (viewport-relative)
                setDropdownPosition({
                    top: rect.bottom,
                    left: rect.left,
                    width: rect.width
                });
            } else setDropdownPosition(null);
        };
        updatePosition();
        if (isSearchOpen) {
            window.addEventListener("scroll", updatePosition, true);
            window.addEventListener("resize", updatePosition);
        }
        return ()=>{
            window.removeEventListener("scroll", updatePosition, true);
            window.removeEventListener("resize", updatePosition);
        };
    }, [
        isSearchOpen
    ]);
    // Clear search query when switching modes
    (0, $acw62.useEffect)(()=>{
        const bandMode = formData.bandMode || "new";
        if (bandMode === "new") {
            setSearchQuery("");
            setIsSearchOpen(false);
        }
    }, [
        formData.bandMode
    ]);
    const { actionsDisabled: actionsDisabled } = (0, $004d21965b9ef321$export$8c32be3a47a5b6d6)();
    if (!show) return null;
    const showDiscogsMultiplIDsWarning = formData.ids.filter((id)=>id.source === "discogs").length > 1;
    const bandMode = formData.bandMode || "new";
    const addGroupStep = formData.addGroupStep;
    const selectedBand = filteredBands.find((b)=>b.value === formData.selectedExistingBandId);
    // Determine which inputs should be disabled based on form state
    const hasLinkedAlias = !!formData.linkedAliasId;
    const hasExistingBandSelected = bandMode === "existing" && !!formData.selectedExistingBandId;
    const hasNewGroupType = bandMode === "new";
    const hasAtLeastOneDiscographyId = formData.ids.some((id)=>id.id && id.id.trim() !== "");
    // Disable all inputs until Linked Alias is selected
    const inputsDisabled = !hasLinkedAlias || actionsDisabled;
    // Disable Is Permanent Member and Discography IDs until:
    // - Linked Alias + Existing + Selected Existing Group OR
    // - Linked Alias + New group type selected
    const permanentMemberAndIdsDisabled = !hasLinkedAlias || bandMode === "existing" && !hasExistingBandSelected || actionsDisabled;
    // Disable footer until:
    // - Linked Alias + New + at least one discography ID OR
    // - Linked Alias + Existing + existing band + discography ID
    const hasIdError = formData.ids.some((id)=>id.error);
    const hasIdValidating = formData.ids.some((id)=>id.validating);
    const footerDisabled = !hasLinkedAlias || hasNewGroupType && !hasAtLeastOneDiscographyId || bandMode === "existing" && (!hasExistingBandSelected || !hasAtLeastOneDiscographyId) || hasIdError || hasIdValidating || actionsDisabled;
    console.log("BandModal render state:", {
        bandMode: bandMode,
        selectedExistingBandId: formData.selectedExistingBandId,
        selectedBand: selectedBand,
        filteredBandsCount: filteredBands.length,
        unlinkedBandsCount: unlinkedBands.length,
        searchQuery: searchQuery,
        isSearchOpen: isSearchOpen
    });
    const handleBandSelect = (bandId, event)=>{
        console.log("=== handleBandSelect START ===");
        console.log("bandId:", bandId);
        console.log("event:", event);
        console.log("unlinkedBands:", unlinkedBands);
        console.log("filteredBands:", filteredBands);
        console.log("onExistingBandChange exists:", !!onExistingBandChange);
        // Find the selected band from unlinkedBands to pass its data
        // Check both bandId and band_id since API might return either
        const selectedUnlinkedBand = unlinkedBands.find((b)=>{
            const bId = b.bandId || b.band_id;
            return bId === bandId;
        });
        console.log("selectedUnlinkedBand found:", selectedUnlinkedBand);
        // Also check in filteredBands
        const selectedFilteredBand = filteredBands.find((b)=>b.value === bandId);
        console.log("selectedFilteredBand found:", selectedFilteredBand);
        // Get the actual band ID to use (prefer bandId, fallback to band_id)
        const actualBandId = selectedUnlinkedBand?.bandId || selectedUnlinkedBand?.band_id || bandId;
        console.log("actualBandId to use:", actualBandId);
        if (onExistingBandChange) {
            console.log("Calling onExistingBandChange with:", {
                bandId: actualBandId,
                selectedUnlinkedBand: selectedUnlinkedBand
            });
            try {
                onExistingBandChange(actualBandId, selectedUnlinkedBand);
                console.log("onExistingBandChange called successfully");
            } catch (error) {
                console.error("Error calling onExistingBandChange:", error);
            }
        } else console.error("onExistingBandChange is not defined!");
        console.log("Closing dropdown and updating search");
        setIsSearchOpen(false);
        // The useEffect will update searchQuery to show the selected band's label
        console.log("=== handleBandSelect END ===");
    };
    const handleSourceIdLookup = async ()=>{
        const sourceId = groupSourceIdInput.trim();
        if (!sourceId) {
            setSourceIdLookupError("Please enter a Group Source ID");
            return;
        }
        setSourceIdLookupError(null);
        setSourceIdLookupLoading(true);
        try {
            const band = await api.findBandBySourceIdArtistBand({
                sourceId: sourceId
            });
            if (band && band.id) {
                const bandIdValue = band.id;
                const isInUnlinked = unlinkedBands.some((b)=>(b.bandId || b.band_id) === bandIdValue);
                if (isInUnlinked) {
                    const unlinkedEntry = unlinkedBands.find((b)=>(b.bandId || b.band_id) === bandIdValue);
                    if (onExistingBandChange) onExistingBandChange(bandIdValue, unlinkedEntry ?? {
                        bandId: bandIdValue,
                        name: band.stageName,
                        sourceId: sourceId,
                        source: "discogs"
                    });
                } else if (onNewBandFromSourceId) onNewBandFromSourceId(sourceId, band);
            } else if (onNewBandFromSourceId) onNewBandFromSourceId(sourceId, null);
        } catch (_err) {
            setSourceIdLookupError("No group found for this source ID. You can add a new group below.");
            if (onNewBandFromSourceId) onNewBandFromSourceId(sourceId, null);
        } finally{
            setSourceIdLookupLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-70 tw-flex tw-items-center tw-justify-center tw-z-50",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-bg-gray-800 tw-rounded-lg tw-max-h-[90vh] tw-flex tw-flex-col tw-max-w-xl tw-w-full tw-mx-4 tw-overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-justify-between tw-items-center tw-p-3 tw-border-b tw-border-gray-700 tw-flex-shrink-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "tw-text-white tw-text-lg tw-font-medium",
                            children: mode === "create" ? "Add Group" : "Update Group"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "tw-text-gray-400 hover:tw-text-white",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 20
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: (e)=>{
                        e.preventDefault();
                        onSubmit();
                    },
                    className: "tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-overflow-y-auto tw-p-3 tw-flex-shrink-0",
                            children: [
                                formData.errors.general && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-bg-westburyRed/50 tw-border tw-border-westburyRed tw-text-westburyRed tw-p-2 tw-mb-3 tw-rounded-md",
                                    children: formData.errors.general
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-space-y-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex tw-gap-2 tw-flex-col tw-items-start tw-justify-start",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        htmlFor: "linked_alias_id",
                                                        className: "tw-text-white tw-mb-1 tw-flex tw-items-center tw-gap-3 tw-justify-between tw-w-full",
                                                        children: [
                                                            "Linked alias",
                                                            !actionsDisabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                label: "+ Create New Alias",
                                                                onClick: onCreateNewAlias,
                                                                variant: "primary"
                                                            }) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        disabled: actionsDisabled,
                                                        name: "linked_alias_id",
                                                        placeholder: "Select alias",
                                                        value: formData.linkedAliasId ?? undefined,
                                                        onChange: (e)=>{
                                                            if (e.target.value) {
                                                                onLinkedAliasChange(e.target.value);
                                                                if (onGroupSourceIdChange) onGroupSourceIdChange("");
                                                                setGroupSourceIdInput("");
                                                                setSourceIdLookupError(null);
                                                            }
                                                        },
                                                        className: `tw-w-full tw-bg-gray-700 tw-border ${formData.errors.aliasName ? "tw-border-westburyRed" : "tw-border-gray-600"} tw-rounded-md tw-px-2 tw-py-1.5 tw-text-white tw-outline-none ${actionsDisabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                children: "Select alias"
                                                            }),
                                                            availableAliases.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: option.value,
                                                                    children: option.label
                                                                }, option.value))
                                                        ]
                                                    }),
                                                    formData.errors.missing_alias_link && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "tw-text-westburyRed tw-text-xs tw-mt-1",
                                                        children: formData.errors.missing_alias_link
                                                    })
                                                ]
                                            })
                                        }),
                                        mode === "create" && formData.linkedAliasId && addGroupStep !== "form" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "group_source_id",
                                                    className: "tw-text-white tw-mb-1 tw-block",
                                                    children: "Provide Discogs or MusicBrainz ID"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-gap-2 tw-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            id: "group_source_id",
                                                            type: "text",
                                                            disabled: sourceIdLookupLoading || actionsDisabled,
                                                            placeholder: "Discogs or MusicBrainz ID",
                                                            value: groupSourceIdInput,
                                                            onChange: (e)=>{
                                                                setGroupSourceIdInput(e.target.value);
                                                                setSourceIdLookupError(null);
                                                            },
                                                            onKeyDown: (e)=>{
                                                                if (e.key === "Enter") {
                                                                    e.preventDefault();
                                                                    handleSourceIdLookup();
                                                                }
                                                            },
                                                            className: "tw-flex-1 tw-bg-gray-700 tw-border tw-border-gray-600 tw-rounded-md tw-px-3 tw-py-1.5 tw-text-white tw-outline-none"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                            label: sourceIdLookupLoading ? "Looking up\u2026" : "Look up",
                                                            onClick: handleSourceIdLookup,
                                                            variant: "primary",
                                                            disabled: sourceIdLookupLoading || !groupSourceIdInput.trim() || actionsDisabled
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                            label: "Skip",
                                                            onClick: ()=>onSkipSourceIdLookup?.(),
                                                            variant: "secondary",
                                                            disabled: sourceIdLookupLoading || actionsDisabled
                                                        })
                                                    ]
                                                }),
                                                onSkipSourceIdLookup && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "tw-text-gray-400 tw-text-xs tw-mt-1",
                                                    children: "Don't have an ID? Skip to create a new group."
                                                }),
                                                sourceIdLookupError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "tw-text-westburyAmber tw-text-xs tw-mt-1",
                                                    children: sourceIdLookupError
                                                })
                                            ]
                                        }),
                                        (mode !== "create" || addGroupStep === "form") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            className: "tw-text-white tw-mb-1 tw-flex tw-items-center",
                                                            children: [
                                                                "Group Name",
                                                                formData.stageName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: `tw-ml-2 tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full ${formData.manualStageName ? "tw-bg-westburyAmber/50 tw-text-westburyAmber" : "tw-bg-westburyBlue/50 tw-text-westburyBlue"}`,
                                                                    children: formData.manualStageName ? "Manually entered" : `Auto-populated`
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            disabled: inputsDisabled,
                                                            type: "text",
                                                            name: "stageName",
                                                            value: formData.stageName,
                                                            onChange: (e)=>onNameChange(e.target.value),
                                                            className: `tw-w-full tw-bg-gray-700 tw-border ${formData.errors.aliasName ? "tw-border-westburyRed" : "tw-border-gray-600"} tw-rounded-md tw-px-3 tw-py-1.5 tw-text-white tw-outline-none ${inputsDisabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""}`,
                                                            required: true
                                                        }),
                                                        formData.errors.aliasName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "tw-text-westburyRed tw-text-xs tw-mt-1",
                                                            children: formData.errors.aliasName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-gap-3 tw-flex-col tw-items-start tw-justify-start tw-mt-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "isPermanentMember",
                                                            className: "tw-text-white",
                                                            children: "Is permanent member?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    disabled: permanentMemberAndIdsDisabled,
                                                                    onClick: ()=>{
                                                                        if (!permanentMemberAndIdsDisabled) onPermanentMemberChange(true);
                                                                    },
                                                                    className: `tw-px-4 tw-py-1.5 tw-rounded-l-md ${permanentMemberAndIdsDisabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""} ${formData.isPermanentMember ? "tw-bg-surfaceLime tw-text-black" : `tw-bg-gray-700 ${permanentMemberAndIdsDisabled ? "" : "hover:tw-bg-surfaceLime hover:tw-text-black"}`}`,
                                                                    children: "Yes"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    disabled: permanentMemberAndIdsDisabled,
                                                                    onClick: ()=>{
                                                                        if (!permanentMemberAndIdsDisabled) onPermanentMemberChange(false);
                                                                    },
                                                                    className: `tw-px-4 tw-py-1.5 tw-rounded-r-md ${permanentMemberAndIdsDisabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""} ${!formData.isPermanentMember ? "tw-bg-surfaceLime tw-text-black" : `tw-bg-gray-700 ${permanentMemberAndIdsDisabled ? "" : "hover:tw-bg-surfaceLime hover:tw-text-black"}`}`,
                                                                    children: "No"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        (mode !== "create" || addGroupStep === "form") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-p-3 tw-border-t tw-border-gray-700 tw-overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-justify-between tw-items-center tw-mb-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-block tw-text-white",
                                            children: "Discography IDs"
                                        }),
                                        !permanentMemberAndIdsDisabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                            onClick: onAddIdField,
                                            variant: "secondary",
                                            label: "+ Add ID"
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-border-b tw-border-gray-700 tw-mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            disabled: permanentMemberAndIdsDisabled,
                                            onClick: ()=>{
                                                if (!permanentMemberAndIdsDisabled) onTabChange("discogs");
                                            },
                                            className: `tw-px-3 tw-py-1.5 tw-text-sm ${permanentMemberAndIdsDisabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""} ${activeTab === "discogs" ? "tw-text-westburyBlue tw-border-b-2 tw-border-westburyBlue" : "tw-text-gray-400"}`,
                                            children: "Discogs"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            disabled: permanentMemberAndIdsDisabled,
                                            onClick: ()=>{
                                                if (!permanentMemberAndIdsDisabled) onTabChange("deezer");
                                            },
                                            className: `tw-px-3 tw-py-1.5 tw-text-sm ${permanentMemberAndIdsDisabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""} ${activeTab === "deezer" ? "tw-text-westburyBlue tw-border-b-2 tw-border-westburyBlue" : "tw-text-gray-400"}`,
                                            children: "Deezer"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            disabled: permanentMemberAndIdsDisabled,
                                            onClick: ()=>{
                                                if (!permanentMemberAndIdsDisabled) onTabChange("spotify");
                                            },
                                            className: `tw-px-3 tw-py-1.5 tw-text-sm ${permanentMemberAndIdsDisabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""} ${activeTab === "spotify" ? "tw-text-westburyBlue tw-border-b-2 tw-border-westburyBlue" : "tw-text-gray-400"}`,
                                            children: "Spotify"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            disabled: permanentMemberAndIdsDisabled,
                                            onClick: ()=>{
                                                if (!permanentMemberAndIdsDisabled) onTabChange("musicbrainz");
                                            },
                                            className: `tw-px-3 tw-py-1.5 tw-text-sm ${permanentMemberAndIdsDisabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""} ${activeTab === "musicbrainz" ? "tw-text-westburyBlue tw-border-b-2 tw-border-westburyBlue" : "tw-text-gray-400"}`,
                                            children: "MusicBrainz"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex-1 tw-min-h-0 tw-overflow-y-auto",
                                    children: [
                                        showDiscogsMultiplIDsWarning && activeTab === "discogs" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-bg-westburyBlue/50 tw-border tw-border-westburyBlue tw-text-westburyBlue tw-p-2 tw-mb-3 tw-rounded-md tw-inline-flex tw-gap-2 tw-items-center tw-w-full tw-text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Discogs ID already linked"
                                                })
                                            ]
                                        }) : null,
                                        formData.ids.filter((id)=>id.source === activeTab).map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e99a1f9c643cbc26$export$7057afef4108ac27), {
                                                disabled: permanentMemberAndIdsDisabled,
                                                source: activeTab,
                                                items: formData.ids,
                                                item: item,
                                                allowDelete: formData.ids.filter((id)=>id.source === activeTab).length > 0,
                                                onRemove: onRemoveItem,
                                                onChange: onItemsChange,
                                                validateBandSourceId: mode !== "create" || addGroupStep === "form" ? {
                                                    mode: mode,
                                                    currentBandId: formData.id || formData.selectedExistingBandId || undefined
                                                } : undefined,
                                                excludeFromDuplicateCheckBandId: formData.id || formData.selectedExistingBandId || undefined
                                            }, item.itemId))
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-justify-end tw-space-x-3 tw-p-3 tw-border-t tw-border-gray-700 tw-flex-shrink-0",
                    children: !actionsDisabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    // Reset form and close modal
                                    if (onExistingBandChange) onExistingBandChange("", undefined);
                                    onClose();
                                },
                                label: "Cancel",
                                variant: "secondary"
                            }),
                            (mode !== "create" || addGroupStep === "form") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                onClick: onSubmit,
                                variant: "primary",
                                label: mode === "create" ? bandMode === "existing" ? "Save" : "Add" : "Save",
                                disabled: footerDisabled
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        label: "Close",
                        variant: "secondary"
                    })
                })
            ]
        })
    });
};
var $d318c431587d8dce$export$2e2bcd8739ae039 = $d318c431587d8dce$var$BandModal;


function $2d5567c03117eaee$var$AliasBandManagement({ showAliasModal: showAliasModal, showBandModal: showBandModal, aliasForm: aliasForm, bandForm: bandForm, activeAliasTab: activeAliasTab, activeBandTab: activeBandTab, onClose: onClose, onCreateNewAlias: onCreateNewAlias, onAliasChange: onAliasChange, onBandChange: onBandChange, onAliasTabChange: onAliasTabChange, onBandTabChange: onBandTabChange }) {
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { getCollectedDiscographyIds: getCollectedDiscographyIds, collectedDiscographyIds: collectedDiscographyIds } = (0, $fb3e3eaca9d70655$export$cfc5730c3495bd2b)();
    // Track if we're waiting for collectedDiscographyIds to update with a selected band
    const pendingBandIdRef = (0, $acw62.useRef)(null);
    // When collectedDiscographyIds updates, check if we have a pending band that's now available
    (0, $acw62.useEffect)(()=>{
        console.log("=== useEffect: collectedDiscographyIds updated ===");
        console.log("pendingBandIdRef.current:", pendingBandIdRef.current);
        console.log("collectedDiscographyIds.length:", collectedDiscographyIds.length);
        console.log("collectedDiscographyIds:", collectedDiscographyIds);
        if (pendingBandIdRef.current && collectedDiscographyIds.length > 0) {
            const pendingBandId = pendingBandIdRef.current;
            console.log("Checking if pending band is now available:", pendingBandId);
            const foundBand = collectedDiscographyIds.find((band)=>band.id === pendingBandId && band.type === "group");
            console.log("Found band in search:", foundBand);
            console.log("Found band source_ids:", foundBand?.source_ids);
            if (foundBand) {
                console.log("Pending band found in collectedDiscographyIds, loading full data:", foundBand);
                loadBandDataIntoForm(foundBand);
                pendingBandIdRef.current = null; // Clear the pending flag
                console.log("Cleared pendingBandIdRef");
            } else {
                console.log("Pending band still not found in collectedDiscographyIds");
                console.log("Available band IDs:", collectedDiscographyIds.map((b)=>({
                        id: b.id,
                        type: b.type
                    })));
            }
        } else console.log("No pending band or collectedDiscographyIds is empty");
    }, [
        collectedDiscographyIds
    ]);
    const handleAliasFormChange = (updatedItem)=>{
        onAliasChange((prev)=>{
            const updatedIds = [
                ...prev.ids
            ];
            const index = updatedIds.findIndex((item)=>item.itemId === updatedItem.itemId);
            if (index > -1) updatedIds[index] = {
                ...updatedIds[index],
                ...updatedItem
            };
            if (!prev.aliasName && prev.manualStageName === false) prev.aliasName = updatedItem.artistName ?? prev.aliasName;
            return {
                ...prev,
                ids: updatedIds
            };
        });
    };
    const handleBandFormChange = (updatedItem)=>{
        onBandChange((prev)=>{
            const updatedIds = [
                ...prev.ids
            ];
            const index = updatedIds.findIndex((item)=>item.itemId === updatedItem.itemId);
            if (index > -1) updatedIds[index] = {
                ...updatedIds[index],
                ...updatedItem
            };
            if (!prev.stageName && prev.manualStageName === false) prev.stageName = updatedItem.artistName ?? prev.stageName;
            return {
                ...prev,
                ids: updatedIds
            };
        });
    };
    const addAliasSourceField = ()=>{
        onAliasChange((prev)=>({
                ...prev,
                ids: [
                    {
                        source: activeAliasTab,
                        itemId: `${prev.id ? `${prev.id}-` : ""}${activeAliasTab}-${prev.ids.length}`,
                        id: ``,
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    ...prev.ids
                ]
            }));
    };
    const addBandSourceField = ()=>{
        onBandChange((prev)=>({
                ...prev,
                ids: [
                    {
                        source: activeBandTab,
                        itemId: `${prev.id ? `${prev.id}-` : ""}${activeBandTab}-${prev.ids.length}`,
                        id: ``,
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    ...prev.ids
                ]
            }));
    };
    const validateAliasForm = ()=>{
        const errors = {};
        // Check if at least one ID is provided
        const hasAnyId = aliasForm.ids.some((item)=>item.id);
        if (!hasAnyId) errors.general = "At least one discography ID must be provided";
        // Check if alias name is provided
        if (!aliasForm.aliasName.trim()) errors.aliasName = "Alias name is required";
        onAliasChange((prev)=>({
                ...prev,
                errors: errors
            }));
        return Object.keys(errors).length === 0;
    };
    const validateBandForm = ()=>{
        const errors = {};
        // If linking to existing band, validate linked alias, selected band, and no ID errors
        if (bandForm.bandMode === "existing") {
            if (!bandForm.linkedAliasId) errors.missing_alias_link = "Group needs to have a linked alias";
            if (!bandForm.selectedExistingBandId) errors.selectedExistingBandId = "Please select an existing band";
            if (bandForm.ids.some((id)=>id.error)) errors.general = "Please fix invalid or duplicate Discogs/MusicBrainz IDs";
            onBandChange((prev)=>({
                    ...prev,
                    errors: errors
                }));
            return Object.keys(errors).length === 0;
        }
        // For new bands, validate all fields
        // Check if at least one ID is provided
        const hasAnyId = bandForm.ids.some((item)=>item.id);
        if (!hasAnyId) errors.general = "At least one discography ID must be provided";
        // Check if alias name is provided
        if (!bandForm.stageName.trim()) errors.aliasName = "Group name is required";
        if (!bandForm.linkedAliasId) errors.missing_alias_link = "Group needs to have a linked alias";
        // Discogs/MusicBrainz: block submit if any ID has validation error (e.g. already used by another group)
        if (bandForm.ids.some((id)=>id.error)) errors.general = "Please fix invalid or duplicate Discogs/MusicBrainz IDs";
        onBandChange((prev)=>({
                ...prev,
                errors: errors
            }));
        return Object.keys(errors).length === 0;
    };
    const handleAddAliasSubmit = ()=>{
        if (!clientId) return;
        // Validate form
        if (!validateAliasForm()) return;
        // Add to artist data (mock implementation)
        const newArtistData = [];
        // Group IDs by platform for storage
        const groupedIds = {
            discogs: [],
            deezer: [],
            spotify: [],
            musicbrainz: []
        };
        aliasForm.ids.forEach((item)=>{
            console.log(item, "item");
            if (item.id) groupedIds[item.source].push({
                id: item.id,
                original_name: item.artistName,
                valid: item.valid,
                approved: item.approved ?? false,
                rejected: item.rejected ?? false
            });
        });
        // Create a new artist entry
        const newArtist = {
            id: 1,
            name: aliasForm.aliasName,
            ids: {
                discogs: groupedIds.discogs.length > 0 ? {
                    ids: groupedIds.discogs
                } : null,
                deezer: groupedIds.deezer.length > 0 ? {
                    ids: groupedIds.deezer
                } : null,
                spotify: groupedIds.spotify.length > 0 ? {
                    ids: groupedIds.spotify
                } : null,
                musicbrainz: groupedIds.musicbrainz.length > 0 ? {
                    ids: groupedIds.musicbrainz
                } : null
            }
        };
        newArtistData.push(newArtist);
        if (aliasForm.id) api.updateAliasArtistAlias({
            userId: clientId,
            aliasId: aliasForm.id,
            artistAliasUpdate: {
                stageName: aliasForm.aliasName,
                manualStageName: aliasForm.manualStageName,
                sourceIds: {
                    discogs: groupedIds.discogs.length > 0 ? groupedIds.discogs.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    deezer: groupedIds.deezer.length > 0 ? groupedIds.deezer.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    spotify: groupedIds.spotify.length > 0 ? groupedIds.spotify.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    musicbrainz: groupedIds.musicbrainz.length > 0 ? groupedIds.musicbrainz.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined
                }
            }
        }).then(()=>{
            getCollectedDiscographyIds(clientId);
            // Close modal and reset form
            onClose();
            onAliasChange({
                aliasName: "",
                isGroup: false,
                isPermanentMember: false,
                ids: [
                    {
                        source: "discogs",
                        itemId: "discogs-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "deezer",
                        itemId: "deezer-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "spotify",
                        itemId: "deezer-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "musicbrainz",
                        itemId: "musicbrainz-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ],
                manualStageName: false,
                hasAutoPopulated: false,
                errors: {}
            });
        });
        else api.createAliasArtistAlias({
            userId: clientId,
            artistAliasCreate: {
                stageName: aliasForm.aliasName,
                manualStageName: aliasForm.manualStageName,
                sourceIds: {
                    discogs: groupedIds.discogs.length > 0 ? groupedIds.discogs.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    deezer: groupedIds.deezer.length > 0 ? groupedIds.deezer.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    spotify: groupedIds.spotify.length > 0 ? groupedIds.spotify.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    musicbrainz: groupedIds.musicbrainz.length > 0 ? groupedIds.musicbrainz.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined
                }
            }
        }).then(()=>{
            getCollectedDiscographyIds(clientId);
            // Close modal and reset form
            onClose();
            onAliasChange({
                aliasName: "",
                isGroup: false,
                isPermanentMember: false,
                ids: [
                    {
                        source: "discogs",
                        itemId: "discogs-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "deezer",
                        itemId: "deezer-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "spotify",
                        itemId: "deezer-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "musicbrainz",
                        itemId: "musicbrainz-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ],
                manualStageName: false,
                hasAutoPopulated: false,
                errors: {}
            });
        });
    };
    const handleAddBandSubmit = ()=>{
        if (!clientId) return;
        // If linking to an existing band, first link the alias, then update if needed
        if (bandForm.bandMode === "existing" && bandForm.selectedExistingBandId && bandForm.linkedAliasId) {
            console.log("=== Linking alias to existing band ===");
            console.log("Band ID:", bandForm.selectedExistingBandId);
            console.log("Alias ID:", bandForm.linkedAliasId);
            console.log("Is Permanent Member:", bandForm.isPermanentMember);
            console.log("Is Main Performer:", bandForm.isMainPerformer);
            console.log("Form IDs count:", bandForm.ids.length);
            console.log("Form IDs:", bandForm.ids);
            // Step 1: Link the alias to the band
            api.linkAliasToBandArtistBand({
                userId: clientId,
                bandId: bandForm.selectedExistingBandId,
                linkAliasToBand: {
                    aliasId: bandForm.linkedAliasId,
                    isPermanentMember: bandForm.isPermanentMember,
                    isMainPerformer: bandForm.isMainPerformer
                }
            }).then(()=>{
                console.log("\u2705 Successfully linked alias to band");
                // Step 2: Check if there are any new source IDs to add/update
                // Group IDs by platform
                const groupedIds = {
                    discogs: [],
                    deezer: [],
                    spotify: [],
                    musicbrainz: []
                };
                bandForm.ids.forEach((item)=>{
                    if (item.id && item.id.trim() !== "") groupedIds[item.source].push({
                        id: item.id,
                        original_name: item.artistName,
                        valid: item.valid,
                        approved: item.approved ?? false,
                        rejected: item.rejected ?? false
                    });
                });
                console.log("Grouped source IDs:", {
                    discogs: groupedIds.discogs.length,
                    deezer: groupedIds.deezer.length,
                    spotify: groupedIds.spotify.length,
                    musicbrainz: groupedIds.musicbrainz.length
                });
                console.log("Grouped source IDs details:", groupedIds);
                // Check if there are any source IDs to update
                const hasSourceIds = groupedIds.discogs.length > 0 || groupedIds.deezer.length > 0 || groupedIds.spotify.length > 0 || groupedIds.musicbrainz.length > 0;
                // Step 3: Update the band (name, permanent member, source IDs)
                if (bandForm.selectedExistingBandId) {
                    console.log("\uD83D\uDCDD Updating band with form data");
                    const updatePayload = {
                        stageName: bandForm.stageName,
                        manualStageName: bandForm.manualStageName,
                        isPermanentMember: bandForm.isPermanentMember,
                        isMainPerformer: bandForm.isMainPerformer,
                        sourceIds: {
                            discogs: groupedIds.discogs.length > 0 ? groupedIds.discogs.map((id)=>({
                                    id: id.id,
                                    originalName: id.original_name,
                                    valid: id.valid,
                                    approved: id.approved,
                                    rejected: id.rejected
                                })) : undefined,
                            deezer: groupedIds.deezer.length > 0 ? groupedIds.deezer.map((id)=>({
                                    id: id.id,
                                    originalName: id.original_name,
                                    valid: id.valid,
                                    approved: id.approved,
                                    rejected: id.rejected
                                })) : undefined,
                            spotify: groupedIds.spotify.length > 0 ? groupedIds.spotify.map((id)=>({
                                    id: id.id,
                                    originalName: id.original_name,
                                    valid: id.valid,
                                    approved: id.approved,
                                    rejected: id.rejected
                                })) : undefined,
                            musicbrainz: groupedIds.musicbrainz.length > 0 ? groupedIds.musicbrainz.map((id)=>({
                                    id: id.id,
                                    originalName: id.original_name,
                                    valid: id.valid,
                                    approved: id.approved,
                                    rejected: id.rejected
                                })) : undefined
                        }
                    };
                    console.log("Update payload:", JSON.stringify(updatePayload, null, 2));
                    return api.updateBandArtistBand({
                        userId: clientId,
                        bandId: bandForm.selectedExistingBandId,
                        artistBandUpdate: updatePayload
                    });
                } else return Promise.resolve();
            }).then(()=>{
                console.log("\u2705 Successfully completed linking and updating band");
                getCollectedDiscographyIds(clientId);
                onClose();
                // Reset form
                onBandChange({
                    stageName: "",
                    isPermanentMember: false,
                    isMainPerformer: false,
                    linkedAliasId: null,
                    bandMode: "new",
                    addGroupStep: undefined,
                    groupSourceId: undefined,
                    selectedExistingBandId: undefined,
                    ids: [
                        {
                            source: "discogs",
                            itemId: "discogs-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        },
                        {
                            source: "deezer",
                            itemId: "deezer-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        },
                        {
                            source: "spotify",
                            itemId: "spotify-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        },
                        {
                            source: "musicbrainz",
                            itemId: "musicbrainz-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        }
                    ],
                    manualStageName: false,
                    hasAutoPopulated: false,
                    errors: {}
                });
            }).catch((error)=>{
                console.error("Error linking alias to band or updating band:", error);
                onBandChange((prev)=>({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            general: "Failed to link alias to band or update band. Please try again."
                        }
                    }));
            });
            return;
        }
        // Validate form
        if (!validateBandForm()) {
            console.log("\u274C Band form validation failed");
            return;
        }
        const bandMode = bandForm.bandMode || "new";
        console.log("=== Creating new band ===");
        console.log("Band Mode:", bandMode);
        console.log("Stage Name:", bandForm.stageName);
        console.log("Linked Alias ID:", bandForm.linkedAliasId);
        console.log("Is Permanent Member:", bandForm.isPermanentMember);
        console.log("Is Main Performer:", bandForm.isMainPerformer);
        console.log("Manual Stage Name:", bandForm.manualStageName);
        console.log("Form IDs count:", bandForm.ids.length);
        // Group IDs by platform for storage
        const groupedIds = {
            discogs: [],
            deezer: [],
            spotify: [],
            musicbrainz: []
        };
        bandForm.ids.forEach((item)=>{
            if (item.id) groupedIds[item.source].push({
                id: item.id,
                original_name: item.artistName,
                valid: item.valid,
                approved: item.approved ?? false,
                rejected: item.rejected ?? false
            });
        });
        console.log("Grouped source IDs:", {
            discogs: groupedIds.discogs.length,
            deezer: groupedIds.deezer.length,
            spotify: groupedIds.spotify.length,
            musicbrainz: groupedIds.musicbrainz.length
        });
        console.log("Grouped source IDs details:", groupedIds);
        if (bandForm.id) api.updateBandArtistBand({
            userId: clientId,
            bandId: bandForm.id,
            artistBandUpdate: {
                stageName: bandForm.stageName,
                manualStageName: bandForm.manualStageName,
                isPermanentMember: bandForm.isPermanentMember,
                isMainPerformer: bandForm.isMainPerformer,
                linkedAliasId: bandForm.linkedAliasId ?? null,
                sourceIds: {
                    discogs: groupedIds.discogs.length > 0 ? groupedIds.discogs.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    deezer: groupedIds.deezer.length > 0 ? groupedIds.deezer.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    spotify: groupedIds.spotify.length > 0 ? groupedIds.spotify.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    musicbrainz: groupedIds.musicbrainz.length > 0 ? groupedIds.musicbrainz.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined
                }
            }
        }).then(()=>{
            getCollectedDiscographyIds(clientId);
            // Close modal and reset form
            onClose();
            onBandChange({
                stageName: "",
                isPermanentMember: false,
                isMainPerformer: false,
                linkedAliasId: null,
                bandMode: "new",
                addGroupStep: undefined,
                groupSourceId: undefined,
                selectedExistingBandId: undefined,
                ids: [
                    {
                        source: "discogs",
                        itemId: "discogs-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "deezer",
                        itemId: "deezer-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "spotify",
                        itemId: "deezer-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "musicbrainz",
                        itemId: "musicbrainz-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ],
                manualStageName: false,
                hasAutoPopulated: false,
                errors: {}
            });
        });
        else {
            // Creating a new band
            const createPayload = {
                stageName: bandForm.stageName,
                manualStageName: bandForm.manualStageName,
                isPermanentMember: bandForm.isPermanentMember,
                isMainPerformer: bandForm.isMainPerformer,
                linkedAliasId: bandForm.linkedAliasId ?? null,
                sourceIds: {
                    discogs: groupedIds.discogs.length > 0 ? groupedIds.discogs.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    deezer: groupedIds.deezer.length > 0 ? groupedIds.deezer.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    spotify: groupedIds.spotify.length > 0 ? groupedIds.spotify.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined,
                    musicbrainz: groupedIds.musicbrainz.length > 0 ? groupedIds.musicbrainz.filter((id)=>!!id.id).map((id)=>({
                            id: id.id,
                            originalName: id.original_name,
                            valid: id.valid,
                            approved: id.approved,
                            rejected: id.rejected
                        })) : undefined
                }
            };
            console.log("\uD83D\uDCDD Creating new band with payload:");
            console.log("Payload:", JSON.stringify(createPayload, null, 2));
            console.log("Linked Alias ID in payload:", createPayload.linkedAliasId);
            api.createBandArtistBand({
                userId: clientId,
                artistBandCreate: createPayload
            }).then(()=>{
                console.log("\u2705 Successfully created new band with linked alias");
                getCollectedDiscographyIds(clientId);
                // Close modal and reset form
                onClose();
                onBandChange({
                    stageName: "",
                    isPermanentMember: false,
                    isMainPerformer: false,
                    linkedAliasId: null,
                    bandMode: "new",
                    addGroupStep: undefined,
                    groupSourceId: undefined,
                    selectedExistingBandId: undefined,
                    ids: [
                        {
                            source: "discogs",
                            itemId: "discogs-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        },
                        {
                            source: "deezer",
                            itemId: "deezer-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        },
                        {
                            source: "spotify",
                            itemId: "deezer-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        },
                        {
                            source: "musicbrainz",
                            itemId: "musicbrainz-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        }
                    ],
                    manualStageName: false,
                    hasAutoPopulated: false,
                    errors: {}
                });
            });
        }
    };
    const handleAliasNameChange = (newName)=>{
        onAliasChange((prev)=>{
            if (prev.aliasName !== newName && prev.manualStageName === false) prev.manualStageName = true;
            return {
                ...prev,
                aliasName: newName
            };
        });
    };
    const handleBandNameChange = (newName)=>{
        onBandChange((prev)=>{
            if (prev.stageName !== newName && prev.manualStageName === false) prev.manualStageName = true;
            return {
                ...prev,
                stageName: newName
            };
        });
    };
    const handleBandPermanentChange = (isPermanentMember)=>{
        onBandChange((prev)=>{
            return {
                ...prev,
                isPermanentMember: isPermanentMember
            };
        });
    };
    const handleBandLinkedAliasChange = (linkedAliasId)=>{
        onBandChange((prev)=>{
            return {
                ...prev,
                errors: {
                    ...prev.errors,
                    missing_alias_id: linkedAliasId ? undefined : prev.errors.missing_alias_id
                },
                linkedAliasId: linkedAliasId ?? null
            };
        });
    };
    const handleNewBandFromSourceId = (sourceId, band)=>{
        onBandChange((prev)=>{
            const ids = [
                ...prev.ids || []
            ];
            const discogsIndex = ids.findIndex((id)=>id.source === "discogs");
            const musicbrainzIndex = ids.findIndex((id)=>id.source === "musicbrainz");
            if (discogsIndex >= 0) ids[discogsIndex] = {
                ...ids[discogsIndex],
                id: sourceId
            };
            else if (musicbrainzIndex >= 0) ids[musicbrainzIndex] = {
                ...ids[musicbrainzIndex],
                id: sourceId
            };
            return {
                ...prev,
                bandMode: "new",
                addGroupStep: "form",
                selectedExistingBandId: undefined,
                stageName: band?.stageName ?? prev.stageName ?? "",
                manualStageName: !!band?.stageName,
                ids: ids,
                errors: {
                    ...prev.errors,
                    general: undefined
                }
            };
        });
    };
    const handleSkipSourceIdLookup = ()=>{
        onBandChange((prev)=>({
                ...prev,
                bandMode: "new",
                addGroupStep: "form",
                selectedExistingBandId: undefined,
                errors: {
                    ...prev.errors,
                    general: undefined
                }
            }));
    };
    const handleBandModeChange = (mode)=>{
        onBandChange((prev)=>{
            // If switching from existing to new, reset the form to default state
            if (prev.bandMode === "existing" && mode === "new") return {
                stageName: "",
                isPermanentMember: false,
                isMainPerformer: false,
                linkedAliasId: prev.linkedAliasId,
                bandMode: "new",
                ids: [
                    {
                        source: "discogs",
                        itemId: "discogs-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "deezer",
                        itemId: "deezer-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "spotify",
                        itemId: "spotify-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    },
                    {
                        source: "musicbrainz",
                        itemId: "musicbrainz-0",
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ],
                manualStageName: false,
                hasAutoPopulated: false,
                errors: {},
                selectedExistingBandId: undefined
            };
            return {
                ...prev,
                bandMode: mode,
                // Clear selected band when switching to new mode
                selectedExistingBandId: mode === "new" ? undefined : prev.selectedExistingBandId
            };
        });
    };
    const handleExistingBandChange = (bandId, unlinkedBandData)=>{
        console.log("=== handleExistingBandChange START ===");
        console.log("bandId:", bandId);
        console.log("unlinkedBandData:", unlinkedBandData);
        console.log("clientId:", clientId);
        console.log("collectedDiscographyIds length:", collectedDiscographyIds.length);
        // If bandId is empty, reset the form while preserving linkedAliasId and bandMode
        if (!bandId) {
            console.log("bandId is empty, resetting form while preserving linkedAliasId and bandMode");
            onBandChange((prev)=>{
                const currentBandMode = prev.bandMode || "existing";
                const currentLinkedAliasId = prev.linkedAliasId;
                return {
                    ...prev,
                    selectedExistingBandId: undefined,
                    stageName: "",
                    isPermanentMember: false,
                    isMainPerformer: false,
                    manualStageName: false,
                    hasAutoPopulated: false,
                    errors: {},
                    linkedAliasId: currentLinkedAliasId,
                    bandMode: currentBandMode,
                    ids: [
                        {
                            source: "discogs",
                            itemId: "discogs-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        },
                        {
                            source: "deezer",
                            itemId: "deezer-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        },
                        {
                            source: "spotify",
                            itemId: "spotify-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        },
                        {
                            source: "musicbrainz",
                            itemId: "musicbrainz-0",
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        }
                    ]
                };
            });
            return;
        }
        if (!clientId) {
            console.warn("No clientId, returning early");
            return;
        }
        // First try to find the selected band from collectedDiscographyIds (if it's already linked to current artist)
        const selectedBand = collectedDiscographyIds.find((band)=>band.id === bandId && band.type === "group");
        console.log("selectedBand from collectedDiscographyIds:", selectedBand);
        console.log("selectedBand source_ids:", selectedBand?.source_ids);
        // If found in collectedDiscographyIds, load the full band data with all source IDs
        if (selectedBand) {
            console.log("Found band in collectedDiscographyIds, loading full data");
            const isCreateMode = !bandForm.id;
            loadBandDataIntoForm(selectedBand, {
                bandMode: "existing",
                ...isCreateMode ? {
                    addGroupStep: "form"
                } : {}
            });
            return;
        }
        // If not found in collectedDiscographyIds, use the API to retrieve the full band data
        // This is needed because the band might be linked to a different artist
        console.log("Band not found in collectedDiscographyIds, fetching from API...");
        console.log("Calling api.retrieveBandArtistBand with:", {
            userId: clientId,
            bandId: bandId
        });
        api.retrieveBandArtistBand({
            userId: clientId,
            bandId: bandId
        }).then((bandData)=>{
            console.log("=== API Response: retrieveBandArtistBand ===");
            console.log("bandData:", bandData);
            console.log("bandData.id:", bandData.id);
            console.log("bandData.stageName:", bandData.stageName);
            console.log("bandData.sourceIds:", bandData.sourceIds);
            console.log("bandData.sourceIds type:", typeof bandData.sourceIds);
            console.log("bandData type:", typeof bandData);
            console.log("bandData keys:", Object.keys(bandData));
            // Parse sourceIds - it might be a JSON string or already an object
            let parsedSourceIds = {
                discogs: [],
                deezer: [],
                spotify: [],
                musicbrainz: []
            };
            if (bandData.sourceIds) {
                if (typeof bandData.sourceIds === "string") try {
                    parsedSourceIds = JSON.parse(bandData.sourceIds);
                    console.log("Parsed sourceIds from string:", parsedSourceIds);
                } catch (e) {
                    console.error("Error parsing sourceIds as JSON:", e);
                    console.log("sourceIds string value:", bandData.sourceIds);
                }
                else if (typeof bandData.sourceIds === "object") {
                    parsedSourceIds = bandData.sourceIds;
                    console.log("sourceIds is already an object:", parsedSourceIds);
                }
            }
            // Ensure parsedSourceIds has the expected structure
            if (!parsedSourceIds.discogs) parsedSourceIds.discogs = [];
            if (!parsedSourceIds.deezer) parsedSourceIds.deezer = [];
            if (!parsedSourceIds.spotify) parsedSourceIds.spotify = [];
            if (!parsedSourceIds.musicbrainz) parsedSourceIds.musicbrainz = [];
            // Convert ArtistBand to the format expected by loadBandDataIntoForm
            // ArtistBand has a different structure than DiscographyId, so we need to transform it
            const transformedBand = {
                id: bandData.id,
                stageName: bandData.stageName,
                manualStageName: bandData.manualStageName,
                type: "group",
                source_ids: parsedSourceIds,
                is_permanent_member: bandData.isPermanentMember === "true" || Boolean(bandData.isPermanentMember) === true,
                is_main_performer: bandData.isMainPerformer === "true" || Boolean(bandData.isMainPerformer) === true,
                linked_alias_id: bandData.linkedAliasId,
                created_by_system: bandData.createdBySystem || false
            };
            console.log("Transformed band data:", transformedBand);
            console.log("Transformed band source_ids:", transformedBand.source_ids);
            console.log("Transformed band source_ids structure:", JSON.stringify(transformedBand.source_ids, null, 2));
            const isCreateMode = !bandForm.id;
            loadBandDataIntoForm(transformedBand, {
                bandMode: "existing",
                ...isCreateMode ? {
                    addGroupStep: "form"
                } : {}
            });
        }).catch((error)=>{
            console.error("Error fetching band from API:", error);
            // Fallback to unlinked band data if API call fails
            if (unlinkedBandData) {
                console.log("Using unlinked band data as fallback after API error:", unlinkedBandData);
                const isCreateMode = !bandForm.id;
                loadUnlinkedBandDataIntoForm(bandId, unlinkedBandData, {
                    bandMode: "existing",
                    ...isCreateMode ? {
                        addGroupStep: "form"
                    } : {}
                });
            } else console.error("No unlinkedBandData available and API call failed");
        });
    };
    const loadBandDataIntoForm = (selectedBand, extraState)=>{
        console.log("=== loadBandDataIntoForm START ===");
        console.log("selectedBand:", selectedBand);
        console.log("selectedBand.id:", selectedBand.id);
        console.log("selectedBand.stageName:", selectedBand.stageName);
        console.log("selectedBand.type:", selectedBand.type);
        console.log("selectedBand.source_ids:", selectedBand.source_ids);
        console.log("selectedBand.source_ids type:", typeof selectedBand.source_ids);
        console.log("selectedBand.source_ids is null/undefined:", selectedBand.source_ids == null);
        if (selectedBand.source_ids) {
            console.log("selectedBand.source_ids keys:", Object.keys(selectedBand.source_ids));
            console.log("selectedBand.source_ids structure:", JSON.stringify(selectedBand.source_ids, null, 2));
        }
        // Check if source_ids exists and has the expected structure
        if (!selectedBand.source_ids) {
            console.error("ERROR: selectedBand.source_ids is missing!");
            console.error("selectedBand keys:", Object.keys(selectedBand));
            return;
        }
        // Helper function to deduplicate IDs by id value within each source
        const deduplicateIds = (ids, source)=>{
            const seen = new Set();
            return ids.filter((id)=>{
                const idKey = id.id || "";
                if (idKey && seen.has(idKey)) {
                    console.log(`Removing duplicate ${source} ID:`, idKey);
                    return false;
                }
                if (idKey) seen.add(idKey);
                return true;
            });
        };
        // Convert the band's source IDs to BandId format
        const newIds = [];
        console.log("Initialized newIds array:", newIds);
        // Add Discogs IDs
        const discogsIdsRaw = selectedBand.source_ids.discogs || [];
        const discogsIds = deduplicateIds(discogsIdsRaw, "discogs");
        console.log("=== Processing Discogs IDs ===");
        console.log("discogsIdsRaw (before dedup):", discogsIdsRaw);
        console.log("discogsIds (after dedup):", discogsIds);
        console.log("discogsIds type:", typeof discogsIds);
        console.log("discogsIds is array:", Array.isArray(discogsIds));
        console.log("discogsIds count:", discogsIds.length);
        if (discogsIds.length > 0) discogsIds.forEach((id, index)=>{
            console.log(`Processing discogs ID ${index}:`, id);
            const bandId = {
                source: "discogs",
                itemId: `existing-discogs-${index}`,
                id: id.id,
                artistName: id.original_name,
                validated: true,
                valid: id.valid,
                approved: id.approved,
                rejected: id.rejected,
                created_by_system: id.created_by_system
            };
            console.log(`Created discogs BandId ${index}:`, bandId);
            newIds.push(bandId);
        });
        else {
            // Add empty placeholder if no discogs IDs exist
            console.log("No discogs IDs, adding empty placeholder");
            newIds.push({
                source: "discogs",
                itemId: "existing-discogs-0",
                id: "",
                valid: false,
                approved: true,
                rejected: false,
                created_by_system: false
            });
        }
        console.log("After discogs, newIds count:", newIds.length);
        // Add Deezer IDs
        const deezerIdsRaw = selectedBand.source_ids.deezer || [];
        const deezerIds = deduplicateIds(deezerIdsRaw, "deezer");
        console.log("=== Processing Deezer IDs ===");
        console.log("deezerIdsRaw (before dedup):", deezerIdsRaw);
        console.log("deezerIds (after dedup):", deezerIds);
        console.log("deezerIds type:", typeof deezerIds);
        console.log("deezerIds is array:", Array.isArray(deezerIds));
        console.log("deezerIds count:", deezerIds.length);
        if (deezerIds.length > 0) deezerIds.forEach((id, index)=>{
            console.log(`Processing deezer ID ${index}:`, id);
            const bandId = {
                source: "deezer",
                itemId: `existing-deezer-${index}`,
                id: id.id,
                artistName: id.original_name,
                validated: true,
                valid: id.valid,
                approved: id.approved,
                rejected: id.rejected,
                created_by_system: id.created_by_system
            };
            console.log(`Created deezer BandId ${index}:`, bandId);
            newIds.push(bandId);
        });
        else {
            // Add empty placeholder if no deezer IDs exist
            console.log("No deezer IDs, adding empty placeholder");
            newIds.push({
                source: "deezer",
                itemId: "existing-deezer-0",
                id: "",
                valid: false,
                approved: true,
                rejected: false,
                created_by_system: false
            });
        }
        console.log("After deezer, newIds count:", newIds.length);
        // Add Spotify IDs
        const spotifyIdsRaw = selectedBand.source_ids.spotify || [];
        const spotifyIds = deduplicateIds(spotifyIdsRaw, "spotify");
        console.log("=== Processing Spotify IDs ===");
        console.log("spotifyIdsRaw (before dedup):", spotifyIdsRaw);
        console.log("spotifyIds (after dedup):", spotifyIds);
        console.log("spotifyIds type:", typeof spotifyIds);
        console.log("spotifyIds is array:", Array.isArray(spotifyIds));
        console.log("spotifyIds count:", spotifyIds.length);
        if (spotifyIds.length > 0) spotifyIds.forEach((id, index)=>{
            console.log(`Processing spotify ID ${index}:`, id);
            const bandId = {
                source: "spotify",
                itemId: `existing-spotify-${index}`,
                id: id.id,
                artistName: id.original_name,
                validated: true,
                valid: id.valid,
                approved: id.approved,
                rejected: id.rejected,
                created_by_system: id.created_by_system
            };
            console.log(`Created spotify BandId ${index}:`, bandId);
            newIds.push(bandId);
        });
        else {
            // Add empty placeholder if no spotify IDs exist
            console.log("No spotify IDs, adding empty placeholder");
            newIds.push({
                source: "spotify",
                itemId: "existing-spotify-0",
                id: "",
                valid: false,
                approved: true,
                rejected: false,
                created_by_system: false
            });
        }
        console.log("After spotify, newIds count:", newIds.length);
        // Add MusicBrainz IDs
        const musicbrainzIdsRaw = selectedBand.source_ids.musicbrainz || [];
        const musicbrainzIds = deduplicateIds(musicbrainzIdsRaw, "musicbrainz");
        console.log("=== Processing MusicBrainz IDs ===");
        console.log("musicbrainzIdsRaw (before dedup):", musicbrainzIdsRaw);
        console.log("musicbrainzIds (after dedup):", musicbrainzIds);
        console.log("musicbrainzIds type:", typeof musicbrainzIds);
        console.log("musicbrainzIds is array:", Array.isArray(musicbrainzIds));
        console.log("musicbrainzIds count:", musicbrainzIds.length);
        if (musicbrainzIds.length > 0) musicbrainzIds.forEach((id, index)=>{
            console.log(`Processing musicbrainz ID ${index}:`, id);
            const bandId = {
                source: "musicbrainz",
                itemId: `existing-musicbrainz-${index}`,
                id: id.id,
                artistName: id.original_name,
                validated: true,
                valid: id.valid,
                approved: id.approved,
                rejected: id.rejected,
                created_by_system: id.created_by_system
            };
            console.log(`Created musicbrainz BandId ${index}:`, bandId);
            newIds.push(bandId);
        });
        else {
            // Add empty placeholder if no musicbrainz IDs exist
            console.log("No musicbrainz IDs, adding empty placeholder");
            newIds.push({
                source: "musicbrainz",
                itemId: "existing-musicbrainz-0",
                id: "",
                valid: false,
                approved: true,
                rejected: false,
                created_by_system: false
            });
        }
        console.log("After musicbrainz, newIds count:", newIds.length);
        console.log("Final newIds array:", newIds);
        // Ensure all sources have at least one ID field (this should already be handled above, but keep as safety check)
        const sources = [
            "discogs",
            "deezer",
            "spotify",
            "musicbrainz"
        ];
        sources.forEach((source)=>{
            if (!newIds.some((id)=>id.source === source)) {
                console.log(`No ${source} IDs found, adding empty placeholder`);
                newIds.push({
                    source: source,
                    itemId: `existing-${source}-0`,
                    id: "",
                    valid: false,
                    approved: true,
                    rejected: false,
                    created_by_system: false
                });
            }
        });
        // Legacy check - should not be needed anymore since we handle each source above
        if (newIds.length === 0) {
            console.log("WARNING: No source IDs found, adding empty placeholders");
            newIds.push({
                source: "discogs",
                itemId: "existing-discogs-0",
                id: "",
                valid: false,
                approved: true,
                rejected: false,
                created_by_system: false
            }, {
                source: "deezer",
                itemId: "existing-deezer-0",
                id: "",
                valid: false,
                approved: true,
                rejected: false,
                created_by_system: false
            }, {
                source: "spotify",
                itemId: "existing-spotify-0",
                id: "",
                valid: false,
                approved: true,
                rejected: false,
                created_by_system: false
            }, {
                source: "musicbrainz",
                itemId: "existing-musicbrainz-0",
                id: "",
                valid: false,
                approved: true,
                rejected: false,
                created_by_system: false
            });
        }
        console.log("=== Preparing to update form ===");
        console.log("newIds created:", newIds);
        console.log("newIds length:", newIds.length);
        console.log("newIds structure:", JSON.stringify(newIds, null, 2));
        console.log("Updating form with:", {
            selectedExistingBandId: selectedBand.id,
            stageName: selectedBand.stageName,
            idsCount: newIds.length,
            manualStageName: selectedBand.manualStageName,
            isPermanentMember: selectedBand.is_permanent_member ?? false,
            isMainPerformer: selectedBand.is_main_performer ?? false
        });
        onBandChange((prev)=>{
            console.log("=== onBandChange callback START ===");
            console.log("Previous form state:", prev);
            console.log("Previous form ids:", prev.ids);
            console.log("Previous form ids length:", prev.ids?.length || 0);
            const updated = {
                ...prev,
                selectedExistingBandId: selectedBand.id,
                ids: newIds,
                stageName: selectedBand.stageName,
                manualStageName: selectedBand.manualStageName,
                isPermanentMember: selectedBand.is_permanent_member ?? false,
                isMainPerformer: selectedBand.is_main_performer ?? false,
                // Keep other properties unchanged
                ...typeof extraState === "object" && extraState !== null ? extraState : {}
            };
            console.log("Updated form state:", updated);
            console.log("Updated form ids:", updated.ids);
            console.log("Updated form ids length:", updated.ids?.length || 0);
            console.log("onBandChange type:", typeof onBandChange);
            console.log("=== onBandChange callback END ===");
            return updated;
        });
        console.log("=== loadBandDataIntoForm END ===");
    };
    const loadUnlinkedBandDataIntoForm = (bandId, unlinkedBandData, extraState)=>{
        console.log("loadUnlinkedBandDataIntoForm called with:", {
            bandId: bandId,
            unlinkedBandData: unlinkedBandData
        });
        const newIds = [];
        // If we have sourceId from unlinked band, add it
        if (unlinkedBandData.sourceId && unlinkedBandData.source) {
            const source = unlinkedBandData.source.toLowerCase();
            console.log("Normalized source:", source);
            console.log("Is valid source:", [
                "discogs",
                "deezer",
                "spotify",
                "musicbrainz"
            ].includes(source));
            if ([
                "discogs",
                "deezer",
                "spotify",
                "musicbrainz"
            ].includes(source)) {
                const bandId = {
                    source: source,
                    itemId: `existing-${source}-0`,
                    id: unlinkedBandData.sourceId,
                    validated: true,
                    valid: true,
                    approved: true,
                    rejected: false,
                    created_by_system: false
                };
                console.log("Created BandId from unlinked data:", bandId);
                newIds.push(bandId);
            } else console.warn("Invalid source type:", source);
        } else console.log("No sourceId or source in unlinkedBandData");
        // Add empty placeholders for other sources
        console.log("Adding empty placeholders for other sources");
        const sources = [
            "discogs",
            "deezer",
            "spotify",
            "musicbrainz"
        ];
        sources.forEach((source)=>{
            if (!newIds.some((id)=>id.source === source)) {
                const placeholderId = {
                    source: source,
                    itemId: `existing-${source}-0`,
                    id: "",
                    valid: false,
                    approved: true,
                    rejected: false,
                    created_by_system: false
                };
                console.log(`Adding placeholder for ${source}:`, placeholderId);
                newIds.push(placeholderId);
            } else console.log(`Skipping placeholder for ${source} (already exists)`);
        });
        console.log("=== Final newIds for unlinked band ===");
        console.log("newIds:", newIds);
        console.log("newIds length:", newIds.length);
        console.log("newIds structure:", JSON.stringify(newIds, null, 2));
        console.log("Updating form with unlinked band data:", {
            selectedExistingBandId: bandId,
            stageName: unlinkedBandData.name,
            idsCount: newIds.length
        });
        onBandChange((prev)=>{
            console.log("=== onBandChange callback for unlinked band START ===");
            console.log("Previous form state:", prev);
            console.log("Previous form ids:", prev.ids);
            console.log("Previous form ids length:", prev.ids?.length || 0);
            const updated = {
                ...prev,
                selectedExistingBandId: bandId,
                ids: newIds,
                stageName: unlinkedBandData.name,
                manualStageName: false,
                ...typeof extraState === "object" && extraState !== null ? extraState : {}
            };
            console.log("Updated form state:", updated);
            console.log("Updated form ids:", updated.ids);
            console.log("Updated form ids length:", updated.ids?.length || 0);
            console.log("onBandChange type:", typeof onBandChange);
            console.log("=== onBandChange callback for unlinked band END ===");
            return updated;
        });
        console.log("=== loadUnlinkedBandDataIntoForm END ===");
    };
    const handleAliasRemoveItem = (itemToRemove)=>{
        onAliasChange((prev)=>{
            const lastItemForSource = prev.ids.filter((item)=>item.source === itemToRemove.source).length < 2;
            return {
                ...prev,
                ids: [
                    ...prev.ids.filter((item)=>item.itemId !== itemToRemove.itemId),
                    ...lastItemForSource ? [
                        {
                            source: itemToRemove.source,
                            itemId: `${itemToRemove.source}-${prev.ids.length}`,
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        }
                    ] : []
                ]
            };
        });
    };
    const handleBandRemoveItem = (itemToRemove)=>{
        onBandChange((prev)=>{
            const lastItemForSource = prev.ids.filter((item)=>item.source === itemToRemove.source).length < 2;
            return {
                ...prev,
                ids: [
                    ...prev.ids.filter((item)=>item.itemId !== itemToRemove.itemId),
                    ...lastItemForSource ? [
                        {
                            source: itemToRemove.source,
                            itemId: `${itemToRemove.source}-${prev.ids.length}`,
                            id: "",
                            valid: false,
                            approved: true,
                            rejected: false,
                            created_by_system: false
                        }
                    ] : []
                ]
            };
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbf6134e5e96254f$export$2e2bcd8739ae039), {
                show: showAliasModal,
                onClose: onClose,
                formData: aliasForm,
                mode: aliasForm.id ? "edit" : "create",
                activeTab: activeAliasTab,
                onTabChange: onAliasTabChange,
                onNameChange: handleAliasNameChange,
                onItemsChange: handleAliasFormChange,
                onRemoveItem: handleAliasRemoveItem,
                onAddIdField: addAliasSourceField,
                onSubmit: handleAddAliasSubmit
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d318c431587d8dce$export$2e2bcd8739ae039), {
                show: showBandModal,
                onClose: onClose,
                formData: bandForm,
                mode: bandForm.id ? "edit" : "create",
                activeTab: activeBandTab,
                onTabChange: onBandTabChange,
                onNameChange: handleBandNameChange,
                onItemsChange: handleBandFormChange,
                onRemoveItem: handleBandRemoveItem,
                onAddIdField: addBandSourceField,
                onPermanentMemberChange: handleBandPermanentChange,
                onLinkedAliasChange: handleBandLinkedAliasChange,
                onSubmit: handleAddBandSubmit,
                onCreateNewAlias: onCreateNewAlias,
                onBandModeChange: handleBandModeChange,
                onExistingBandChange: (bandId, unlinkedBandData)=>{
                    console.log("=== onExistingBandChange prop called ===");
                    console.log("bandId:", bandId);
                    console.log("unlinkedBandData:", unlinkedBandData);
                    console.log("handleExistingBandChange function:", handleExistingBandChange);
                    handleExistingBandChange(bandId, unlinkedBandData);
                },
                onNewBandFromSourceId: handleNewBandFromSourceId,
                onSkipSourceIdLookup: handleSkipSourceIdLookup
            })
        ]
    });
}
var $2d5567c03117eaee$export$2e2bcd8739ae039 = $2d5567c03117eaee$var$AliasBandManagement;




/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 




var $acw62 = parcelRequire("acw62");


function $58e5d286cbd6aa3b$var$CachedInfinity() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 16c5 0 7-8 12-8a4 4 0 0 1 0 8c-5 0-7-8-12-8a4 4 0 1 0 0 8"
        })
    });
}
function $58e5d286cbd6aa3b$var$PermanentStatusCheck({ artist: artist }) {
    const { getCollectedDiscographyIds: getCollectedDiscographyIds } = (0, $fb3e3eaca9d70655$export$cfc5730c3495bd2b)();
    const [updating, setUpdating] = (0, $acw62.useState)(false);
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { actionsDisabled: actionsDisabled } = (0, $004d21965b9ef321$export$8c32be3a47a5b6d6)();
    const handleOnTogglePermanentStatus = (0, $acw62.useCallback)(()=>{
        if (!clientId || actionsDisabled || !artist.linked_alias_id) return;
        setUpdating(true);
        api.updateBandArtistBand({
            userId: clientId,
            bandId: artist.id,
            artistBandUpdate: {
                linkedAliasId: artist.linked_alias_id,
                isPermanentMember: !Boolean(artist.is_permanent_member)
            }
        }).finally(()=>{
            getCollectedDiscographyIds(clientId);
            setUpdating(false);
        });
    }, [
        api,
        artist,
        actionsDisabled
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: [
            `tw-inline-flex tw-w-6 tw-items-center tw-pl-2 tw-text-lg tw-rounded tw-select-none tw-h-5 tw-justify-center`,
            artist.is_permanent_member ? "tw-text-westburyGreen" : "tw-text-westburyRed",
            !actionsDisabled ? "tw-cursor-pointer" : ""
        ].join(" "),
        onClick: handleOnTogglePermanentStatus,
        title: artist.is_permanent_member ? "Permanent member" : "Non-permanent member",
        children: updating ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
            size: 12,
            className: "tw-animate-spin tw-text-white"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($58e5d286cbd6aa3b$var$CachedInfinity, {})
    });
}
var $58e5d286cbd6aa3b$export$2e2bcd8739ae039 = $58e5d286cbd6aa3b$var$PermanentStatusCheck;



const $2ec52385fce330c7$var$DEFAULT_ALIAS_FORM_STATE = {
    aliasName: "",
    isGroup: false,
    isPermanentMember: false,
    ids: [
        {
            source: "discogs",
            itemId: "discogs-0",
            id: "",
            valid: false,
            approved: true,
            rejected: false,
            created_by_system: false
        },
        {
            source: "deezer",
            itemId: "deezer-0",
            id: "",
            valid: false,
            approved: true,
            rejected: false,
            created_by_system: false
        },
        {
            source: "spotify",
            itemId: "spotify-0",
            id: "",
            valid: false,
            approved: true,
            rejected: false,
            created_by_system: false
        },
        {
            source: "musicbrainz",
            itemId: "musicbrainz-0",
            id: "",
            valid: false,
            approved: true,
            rejected: false,
            created_by_system: false
        }
    ],
    manualStageName: false,
    hasAutoPopulated: false,
    errors: {}
};
const $2ec52385fce330c7$var$DEFAULT_BAND_FORM_STATE = {
    stageName: "",
    isPermanentMember: false,
    isMainPerformer: false,
    linkedAliasId: null,
    bandMode: "new",
    ids: [
        {
            source: "discogs",
            itemId: "discogs-0",
            id: "",
            valid: false,
            approved: true,
            rejected: false,
            created_by_system: false
        },
        {
            source: "deezer",
            itemId: "deezer-0",
            id: "",
            valid: false,
            approved: true,
            rejected: false,
            created_by_system: false
        },
        {
            source: "spotify",
            itemId: "spotify-0",
            id: "",
            valid: false,
            approved: true,
            rejected: false,
            created_by_system: false
        },
        {
            source: "musicbrainz",
            itemId: "musicbrainz-0",
            id: "",
            valid: false,
            approved: true,
            rejected: false,
            created_by_system: false
        }
    ],
    manualStageName: false,
    hasAutoPopulated: false,
    errors: {}
};
function $2ec52385fce330c7$export$fd8ba84aa3816912({ onUserSettingsUpdated: onUserSettingsUpdated, toggleSearchPanel: toggleSearchPanel, isSearchExpanded: isSearchExpanded }) {
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { collectedDiscographyIds: _collectedDiscographyIds, status: status, indicator: indicator, errorDetail: errorDetail, isStalled: isStalled, canCancel: canCancel, getCollectedDiscographyIds: getCollectedDiscographyIds, cancelAutoCollectIds: cancelAutoCollectIds, cancelAutoCollectIdsInProgress: cancelAutoCollectIdsInProgress } = (0, $fb3e3eaca9d70655$export$cfc5730c3495bd2b)();
    const [tableFilter, setTableFilter] = (0, $acw62.useState)("all");
    const collectedDiscographyIds = (0, $acw62.useMemo)(()=>{
        if (tableFilter === "verified") {
            const verifiedFilter = (id)=>!id.rejected && (id.approved || id.valid);
            return _collectedDiscographyIds.filter((id)=>Object.entries(id.source_ids).some(([, source_id_list])=>{
                    return source_id_list.some(verifiedFilter);
                })).map((artist)=>({
                    ...artist,
                    source_ids: {
                        discogs: [
                            ...artist.source_ids.discogs.filter(verifiedFilter)
                        ],
                        deezer: [
                            ...artist.source_ids.deezer.filter(verifiedFilter)
                        ],
                        musicbrainz: [
                            ...artist.source_ids.musicbrainz.filter(verifiedFilter)
                        ],
                        spotify: [
                            ...artist.source_ids.spotify.filter(verifiedFilter)
                        ]
                    }
                }));
        } else if (tableFilter === "rejected") return _collectedDiscographyIds.filter((id)=>Object.entries(id.source_ids).some(([, source_id_list])=>{
                return source_id_list.some((source_id)=>source_id.rejected === true);
            })).map((artist)=>({
                ...artist,
                source_ids: {
                    discogs: [
                        ...artist.source_ids.discogs.filter((id)=>id.rejected)
                    ],
                    deezer: [
                        ...artist.source_ids.deezer.filter((id)=>id.rejected)
                    ],
                    musicbrainz: [
                        ...artist.source_ids.musicbrainz.filter((id)=>id.rejected)
                    ],
                    spotify: [
                        ...artist.source_ids.spotify.filter((id)=>id.rejected)
                    ]
                }
            }));
        else if (tableFilter === "uncertain") return _collectedDiscographyIds.filter((id)=>Object.entries(id.source_ids).some(([, source_id_list])=>{
                return source_id_list.some((source_id)=>!source_id.valid && !source_id.approved && !source_id.rejected);
            })).map((artist)=>({
                ...artist,
                source_ids: {
                    discogs: [
                        ...artist.source_ids.discogs.filter((id)=>!id.valid && !id.approved && !id.rejected)
                    ],
                    deezer: [
                        ...artist.source_ids.deezer.filter((id)=>!id.valid && !id.approved && !id.rejected)
                    ],
                    musicbrainz: [
                        ...artist.source_ids.musicbrainz.filter((id)=>!id.valid && !id.approved && !id.rejected)
                    ],
                    spotify: [
                        ...artist.source_ids.spotify.filter((id)=>!id.valid && !id.approved && !id.rejected)
                    ]
                }
            }));
        return _collectedDiscographyIds;
    }, [
        _collectedDiscographyIds,
        tableFilter
    ]);
    const [sortedArtistData, setSortedArtistData] = (0, $acw62.useState)(collectedDiscographyIds);
    const [sortDirection, setSortDirection] = (0, $acw62.useState)("asc");
    // Function to sort artist data
    const sortArtistData = (0, $acw62.useCallback)((discogIds)=>{
        const sorted = [
            ...discogIds
        ].sort((a, b)=>{
            if (sortDirection === "asc") return a.stageName.localeCompare(b.stageName);
            else return b.stageName.localeCompare(a.stageName);
        });
        setSortedArtistData(sorted);
    }, [
        sortDirection
    ]);
    // Function to toggle sort direction
    const toggleSortDirection = (0, $acw62.useCallback)(()=>{
        setSortDirection((state)=>state === "asc" ? "desc" : "asc");
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (Array.isArray(collectedDiscographyIds)) {
            console.log("Sorting discog id list");
            sortArtistData(collectedDiscographyIds);
        }
    }, [
        collectedDiscographyIds,
        sortDirection
    ]);
    // Only a genuinely active run takes the card over. `unknown` must NOT: it is the state on
    // every mount before the first poll answers, and blanking the whole discography on each
    // page load to show a spinner is worse than the bug being fixed. It gets the banner below
    // instead, which reports the lost contact without hiding anything.
    // A terminal banner is re-shown on every mount — the server keeps reporting the last run
    // as FAILED forever — so it needs a way out. Dismissal is keyed on the run being reported,
    // so a *new* failure re-arms it rather than inheriting the old dismissal.
    const [dismissedNoticeKey, setDismissedNoticeKey] = (0, $acw62.useState)(null);
    const noticeKey = `${clientId ?? ""}:${status}:${errorDetail ?? ""}`;
    const noticeDismissed = dismissedNoticeKey === noticeKey;
    // ...and not once a run has overrun its budget. `CANCELLING` in particular is driven by
    // its own Celery task, so a dead worker or an unreachable Dagster used to leave the whole
    // discography behind a spinner with no cancel button, no banner and no way out. Showing
    // the data plus an amber banner is strictly better than hiding it behind a stuck spinner.
    const isPopulatingIds = (0, $b56fb8f4df8e7ea3$export$18608c84ede3221c)(status) && !isStalled;
    // Terminal-but-noteworthy outcomes. These have `busy: false`, so without their own
    // rendering path a failed collection would finish completely silently — the admin would
    // see the button re-enable and no explanation, which is how the repeat-clicking starts.
    const runNotice = !noticeDismissed && (status === "failed" || status === "cancelled" || status === "unknown" || isStalled && (0, $b56fb8f4df8e7ea3$export$18608c84ede3221c)(status)) ? indicator : null;
    const idsPopulated = sortedArtistData.length > 0;
    const tableBodyRef = (0, $acw62.useRef)(null);
    const [credentialsFormData, setCredentialsFormData] = (0, $acw62.useState)({
        firstName: "",
        lastName: "",
        email: "",
        pplAccountName: "",
        pplPerformerName: "",
        pplPerformerId: ""
    });
    const [cleanCredentialsFormData, setCleanCredentialsFormData] = (0, $acw62.useState)(credentialsFormData);
    (0, $acw62.useEffect)(()=>{
        if (!clientId) return;
        api.retrieveUserSettings({
            userId: clientId
        }).then((userSettings)=>{
            api.updateUserSettings({
                userId: clientId,
                userSettings: {
                    ...userSettings,
                    firstName: credentialsFormData.firstName,
                    lastName: credentialsFormData.lastName,
                    emailAddress: credentialsFormData.email,
                    pplAccountName: credentialsFormData.pplAccountName,
                    pplPerformerName: credentialsFormData.pplPerformerName
                }
            }).catch((e)=>{
                console.error(e);
            });
        }).catch((e)=>{
            console.error(e);
        });
    }, [
        credentialsFormData
    ]);
    const fetchData = (0, $acw62.useCallback)((clientId)=>{
        api.retrieveUserSettings({
            userId: clientId
        }).then((userSettings)=>{
            setCredentialsFormData({
                firstName: userSettings.firstName ?? "",
                lastName: userSettings.lastName ?? "",
                email: userSettings.emailAddress ?? "",
                pplAccountName: userSettings.pplAccountName ?? "",
                pplPerformerName: userSettings.pplPerformerName ?? "",
                pplPerformerId: userSettings.pplPerformerId ?? ""
            });
        }).catch((e)=>{
            console.error(e);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (clientId) {
            console.log("Refetching user settings for artis discography contents");
            fetchData(clientId);
        }
    }, [
        clientId
    ]);
    // Add new state for artist details modal
    const [showEditArtistModal, setShowEditArtistModal] = (0, $acw62.useState)(false);
    const [showIdDetailsModal, setShowIdDetailsModal] = (0, $acw62.useState)(false);
    const [selectedIdDetails, setSelectedIdDetails] = (0, $acw62.useState)({
        id: "",
        artistName: "",
        platform: "discogs",
        source_ids: []
    });
    const [confirmDeleteModalDetails, setConfirmDeleteModalDetails] = (0, $acw62.useState)(null);
    const handleDeleteArtistDiscographyID = (id)=>{
        if (!clientId) return;
        const aliasOrBand = sortedArtistData.find((aob)=>aob.id === id);
        if (aliasOrBand?.type === "persona") handDeleteArtistAlias(id);
        else if (aliasOrBand?.type === "group") handDeleteArtistBand(id, aliasOrBand);
    };
    const handDeleteArtistAlias = (aliasId)=>{
        if (!clientId) return;
        api.removeAliasRemove({
            userId: clientId,
            aliasId: aliasId
        }).then(()=>{
            getCollectedDiscographyIds(clientId);
        });
    };
    const handDeleteArtistBand = (bandId, band)=>{
        if (!clientId) return;
        // Find the band if not provided
        const bandData = band || sortedArtistData.find((aob)=>aob.id === bandId && aob.type === "group");
        if (!bandData) {
            console.error("Band not found:", bandId);
            return;
        }
        // Check if band has a linked alias
        if (bandData.linked_alias_id) {
            // Unlink the alias from the band instead of deleting the band
            console.log("Unlinking alias from band:", {
                bandId: bandId,
                aliasId: bandData.linked_alias_id
            });
            api.unlinkAliasFromBandArtistBand({
                userId: clientId,
                bandId: bandId,
                unlinkAliasFromBand: {
                    aliasId: bandData.linked_alias_id
                }
            }).then(()=>{
                console.log("\u2705 Successfully unlinked alias from band");
                getCollectedDiscographyIds(clientId);
            }).catch((error)=>{
                console.error("Error unlinking alias from band:", error);
            // Optionally show an error message to the user
            });
        } else console.warn("Band has no linked alias, cannot unlink:", bandId);
    };
    // Add new alias form state
    const [newAliasForm, setNewAliasForm] = (0, $acw62.useState)($2ec52385fce330c7$var$DEFAULT_ALIAS_FORM_STATE);
    const [newBandForm, setNewBandForm] = (0, $acw62.useState)($2ec52385fce330c7$var$DEFAULT_BAND_FORM_STATE);
    // Add state for active tab
    const [activeAliasTab, setActiveAliasTab] = (0, $acw62.useState)("discogs");
    const [activeBandTab, setActiveBandTab] = (0, $acw62.useState)("discogs");
    const [showAddAliasModal, setShowAddAliasModal] = (0, $acw62.useState)(false);
    const [showAddBandModal, setShowAddBandModal] = (0, $acw62.useState)(false);
    const handleOpenEditModal = (id, source)=>{
        const aliasOrBand = sortedArtistData.find((a)=>a.id === id);
        if (aliasOrBand?.type === "persona") handleOpenEditAliasModal(aliasOrBand.id, source);
        else if (aliasOrBand?.type === "group") handleOpenEditBandModal(aliasOrBand.id, source);
    };
    const handleOpenEditAliasModal = (artistId, source)=>{
        const artist = sortedArtistData.find((a)=>a.id === artistId);
        if (!artist) return;
        setActiveAliasTab(source);
        setNewAliasForm({
            id: artist.id,
            aliasName: artist.stageName,
            isGroup: artist.type === "group",
            isPermanentMember: false,
            ids: [
                ...artist.source_ids.discogs.length > 0 ? artist.source_ids.discogs.map((id, index)=>({
                        source: "discogs",
                        itemId: `${artist.id}-discogs-${index}`,
                        id: id.id,
                        artistName: id.original_name,
                        validated: true,
                        valid: id.valid,
                        approved: id.approved,
                        rejected: id.rejected,
                        editing: false,
                        created_by_system: id.created_by_system
                    })) : [
                    {
                        source: "discogs",
                        itemId: `${artist.id}-discogs-0`,
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ],
                ...artist.source_ids.deezer.length > 0 ? artist.source_ids.deezer.map((id, index)=>({
                        source: "deezer",
                        itemId: `${artist.id}-deezer-${index}`,
                        id: id.id,
                        artistName: id.original_name,
                        validated: true,
                        valid: id.valid,
                        approved: id.approved,
                        rejected: id.rejected,
                        editing: false,
                        created_by_system: id.created_by_system
                    })) : [
                    {
                        source: "deezer",
                        itemId: `${artist.id}-deezer-0`,
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ],
                ...artist.source_ids.spotify.length > 0 ? artist.source_ids.spotify.map((id, index)=>({
                        source: "spotify",
                        itemId: `${artist.id}-spotify-${index}`,
                        id: id.id,
                        artistName: id.original_name,
                        validated: true,
                        valid: id.valid,
                        approved: id.approved,
                        rejected: id.rejected,
                        editing: false,
                        created_by_system: id.created_by_system
                    })) : [
                    {
                        source: "spotify",
                        itemId: `${artist.id}-spotify-0`,
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ],
                ...artist.source_ids.musicbrainz.length > 0 ? artist.source_ids.musicbrainz.map((id, index)=>({
                        source: "musicbrainz",
                        itemId: `${artist.id}-musicbrainz-${index}`,
                        id: id.id,
                        artistName: id.original_name,
                        validated: true,
                        valid: id.valid,
                        approved: id.approved,
                        rejected: id.rejected,
                        editing: false,
                        created_by_system: id.created_by_system
                    })) : [
                    {
                        source: "musicbrainz",
                        itemId: `${artist.id}-musicbrainz-0`,
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ]
            ],
            manualStageName: artist.manualStageName,
            hasAutoPopulated: artist.manualStageName ? true : false,
            errors: {}
        });
        setShowAddAliasModal(true);
    };
    const handleOpenEditBandModal = (artistId, source)=>{
        const artist = sortedArtistData.find((a)=>a.id === artistId && a.type === "group");
        if (!artist) return;
        setActiveBandTab(source);
        setNewBandForm({
            id: artist.id,
            stageName: artist.stageName,
            isPermanentMember: artist.is_permanent_member ?? false,
            isMainPerformer: artist.is_main_performer ?? false,
            linkedAliasId: artist.linked_alias_id ?? null,
            ids: [
                ...artist.source_ids.discogs.length > 0 ? artist.source_ids.discogs.map((id, index)=>({
                        source: "discogs",
                        itemId: `${artist.id}-discogs-${index}`,
                        id: id.id,
                        artistName: id.original_name,
                        validated: true,
                        valid: id.valid,
                        approved: id.approved,
                        rejected: id.rejected,
                        editing: false,
                        created_by_system: id.created_by_system
                    })) : [
                    {
                        source: "discogs",
                        itemId: `${artist.id}-discogs-0`,
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ],
                ...artist.source_ids.deezer.length > 0 ? artist.source_ids.deezer.map((id, index)=>({
                        source: "deezer",
                        itemId: `${artist.id}-deezer-${index}`,
                        id: id.id,
                        artistName: id.original_name,
                        validated: true,
                        valid: id.valid,
                        approved: id.approved,
                        rejected: id.rejected,
                        editing: false,
                        created_by_system: id.created_by_system
                    })) : [
                    {
                        source: "deezer",
                        itemId: `${artist.id}-deezer-0`,
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ],
                ...artist.source_ids.spotify.length > 0 ? artist.source_ids.spotify.map((id, index)=>({
                        source: "spotify",
                        itemId: `${artist.id}-spotify-${index}`,
                        id: id.id,
                        artistName: id.original_name,
                        validated: true,
                        valid: id.valid,
                        approved: id.approved,
                        rejected: id.rejected,
                        editing: false,
                        created_by_system: id.created_by_system
                    })) : [
                    {
                        source: "spotify",
                        itemId: `${artist.id}-spotify-0`,
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ],
                ...artist.source_ids.musicbrainz.length > 0 ? artist.source_ids.musicbrainz.map((id, index)=>({
                        source: "musicbrainz",
                        itemId: `${artist.id}-musicbrainz-${index}`,
                        id: id.id,
                        artistName: id.original_name,
                        validated: true,
                        valid: id.valid,
                        approved: id.approved,
                        rejected: id.rejected,
                        editing: false,
                        created_by_system: id.created_by_system
                    })) : [
                    {
                        source: "musicbrainz",
                        itemId: `${artist.id}-musicbrainz-0`,
                        id: "",
                        valid: false,
                        approved: true,
                        rejected: false,
                        created_by_system: false
                    }
                ]
            ],
            manualStageName: artist.manualStageName,
            hasAutoPopulated: artist.manualStageName ? true : false,
            errors: {}
        });
        setShowAddBandModal(true);
    };
    const handleOpenAddAliasModal = ()=>{
        setNewAliasForm($2ec52385fce330c7$var$DEFAULT_ALIAS_FORM_STATE);
        setShowAddAliasModal(true);
    };
    const handleOpenAddBandModal = ()=>{
        setNewBandForm($2ec52385fce330c7$var$DEFAULT_BAND_FORM_STATE);
        setShowAddBandModal(true);
    };
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const { startRun: runDiscography, restartRun: restartDiscography, status: runStatus, phase: runPhase, currentStep: runCurrentStep, totalSteps: runTotalSteps, currentStepLabel: runCurrentStepLabel, isStalled: runIsStalled, actionsDisabled: isFormDisabled, cancelRun: cancelDiscographyRun } = (0, $004d21965b9ef321$export$8c32be3a47a5b6d6)();
    const runStatusMap = {
        preparing: "Preparing",
        "not-started": "",
        canceling: "Canceling",
        cancelled: "Cancelled",
        failed: "Failed",
        finished: "Finished",
        running: "Running"
    };
    // Human label for the active phase shown next to the spinner.
    const activeRunLabel = (()=>{
        switch(runPhase){
            case "REQUESTED":
                return "Queued\u2026";
            case "LAUNCHING":
            case "STARTING":
                return "Starting (cold start can take a few minutes)\u2026";
            case "WAITING_FOR_SENSOR":
                return "Waiting for next step\u2026";
            case "CANCELLING":
                return "Cancelling\u2026";
            case "RUNNING":
                return runCurrentStepLabel && runCurrentStep && runTotalSteps ? `${runCurrentStepLabel} (${runCurrentStep}/${runTotalSteps})` : "Running\u2026";
            default:
                return runStatus === "preparing" ? "Preparing\u2026" : runStatus === "canceling" ? "Cancelling\u2026" : "Running\u2026";
        }
    })();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `tw-h-full ${isSearchExpanded ? "tw-w-[70%]" : "tw-w-full"}  tw-shadow-lg tw-overflow-hidden tw-flex tw-flex-col tw-relative`,
        onClick: (e)=>e.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-h-full tw-overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-rounded-lg tw-p-4 tw-mb-4 tw-flex-shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-justify-between tw-items-center tw-mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "tw-text-white tw-text-lg tw-font-medium",
                                        children: "Artist details"
                                    }),
                                    !isFormDisabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        onClick: ()=>setShowEditArtistModal(true),
                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                    size: 16,
                                                    className: "tw-mr-1.5 tw-text-white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "tw-text-white tw-text-sm",
                                                    children: "Edit"
                                                })
                                            ]
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-flex-wrap tw-gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-pr-4 tw-mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-white tw-text-sm tw-mb-0.5",
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "tw-text-gray-400 tw-text-sm",
                                                children: [
                                                    credentialsFormData.firstName,
                                                    " ",
                                                    credentialsFormData.lastName
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-pr-4 tw-mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-white tw-text-sm tw-mb-0.5",
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-gray-400 tw-text-sm",
                                                children: credentialsFormData.email
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-pr-4 tw-mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-white tw-text-sm tw-mb-0.5",
                                                children: "PPL Contributor Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-gray-400 tw-text-sm",
                                                children: credentialsFormData.pplPerformerName ?? "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-pr-4 tw-mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-white tw-text-sm tw-mb-0.5",
                                                children: "PPL Performer ID"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-gray-400 tw-text-sm",
                                                children: credentialsFormData.pplPerformerId ?? "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-pr-4 tw-mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-white tw-text-sm tw-mb-0.5",
                                                children: "PPL Account Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-gray-400 tw-text-sm",
                                                children: credentialsFormData.pplAccountName ?? "-"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    runNotice ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `tw-rounded-lg tw-px-4 tw-py-3 tw-mb-4 tw-flex tw-items-start tw-justify-between tw-border ${runNotice.attention ? "tw-border-amber-500/50 tw-bg-amber-500/10" : "tw-border-gray-700 tw-bg-gray-800/60"}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `tw-text-sm tw-font-medium ${runNotice.attention ? "tw-text-amber-300" : "tw-text-gray-200"}`,
                                children: runNotice.detail
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                "aria-label": "Dismiss",
                                onClick: ()=>setDismissedNoticeKey(noticeKey),
                                className: "tw-ml-4 tw-flex-shrink-0 tw-text-gray-400 hover:tw-text-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    size: 16
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-rounded-lg tw-p-4 tw-mb-4 tw-flex-grow tw-flex tw-flex-col tw-overflow-hidden",
                        children: isPopulatingIds ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-h-full tw-overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-items-center tw-justify-between tw-mb-3 tw-flex-shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-flex tw-items-center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "tw-text-white tw-text-lg tw-font-medium",
                                                children: "Discography IDs"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-flex tw-space-x-2",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                onClick: toggleSearchPanel,
                                                variant: "secondary",
                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                            size: 14,
                                                            className: "tw-mr-1.5"
                                                        }),
                                                        "Search IDs"
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12 tw-flex-grow",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-relative tw-mb-6",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tw-bg-westburyBlue tw-rounded-full tw-p-5 tw-animate-pulse",
                                                    children: status === "collecting" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $766b7a414a24981f$export$2e2bcd8739ae039), {
                                                        size: 32,
                                                        className: "tw-text-white"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3266583f46f84dc$export$2e2bcd8739ae039), {
                                                        size: 32,
                                                        className: "tw-text-white tw-animate-spin"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tw-absolute tw-inset-0 tw-rounded-full tw-border-4 tw-border-t-transparent tw-border-westburyBlue tw-animate-spin"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: `tw-text-center tw-mb-2 tw-text-lg ${indicator.attention ? "tw-text-amber-400" : "tw-text-gray-100"}`,
                                            children: indicator.detail
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "tw-text-gray-400 tw-text-center tw-text-sm tw-mb-8",
                                            children: "Populating discography IDs - this may take some time..."
                                        }),
                                        clientId && canCancel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-flex tw-w-full tw-items-center tw-justify-center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                onClick: ()=>cancelAutoCollectIds(clientId),
                                                // Without this the button stayed live through the whole DELETE, so a
                                                // second click fired a second cancel at the same run.
                                                disabled: cancelAutoCollectIdsInProgress,
                                                variant: "secondary",
                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: cancelAutoCollectIdsInProgress ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                        className: "tw-animate-spin"
                                                    }) : "Cancel"
                                                })
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-h-full tw-overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-items-center tw-justify-between tw-mb-3 tw-flex-shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-flex tw-items-center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "tw-text-white tw-text-lg tw-font-medium",
                                                children: "Discography IDs"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex tw-space-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                    onClick: toggleSearchPanel,
                                                    variant: "secondary",
                                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                                size: 14,
                                                                className: "tw-mr-1.5"
                                                            }),
                                                            "Search IDs"
                                                        ]
                                                    })
                                                }),
                                                !isFormDisabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                            onClick: handleOpenAddAliasModal,
                                                            label: "+ Add Alias",
                                                            variant: "primary"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                            onClick: handleOpenAddBandModal,
                                                            label: "+ Add Group",
                                                            variant: "primary"
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-pb-3 tw-pl-1 tw-flex tw-gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: tableFilter ?? "",
                                            onChange: (e)=>{
                                                const targetValue = e.target.value;
                                                setTableFilter(targetValue);
                                            },
                                            className: "tw-rounded-full tw-bg-transparent tw-border-white tw-border-solid tw-border-2 tw-text-xs tw-px-2 tw-py-1 tw-pr-7 tw-focus:outline-none tw-hover:bg-[#3c3c3c] tw-cursor-pointer tw-appearance-none tw-relative tw-min-w-[120px]",
                                            style: {
                                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%239CA3AF'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: "right 0.25rem center",
                                                backgroundSize: "1.25em 1.25em"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    className: "tw-text-xs tw-text-black",
                                                    value: "all",
                                                    children: "All IDs"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    className: "tw-text-xs tw-text-black",
                                                    value: "verified",
                                                    children: "Verified IDs"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    className: "tw-text-xs tw-text-black",
                                                    value: "uncertain",
                                                    children: "Uncertain IDs"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    className: "tw-text-xs tw-text-black",
                                                    value: "rejected",
                                                    children: "Rejected"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex tw-items-center tw-text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setExpanded(true),
                                                    className: `tw-px-2 tw-py-0.5 tw-rounded-l-full tw-border-solid tw-border-r-0 tw-border-2 ${expanded ? "tw-border-surfaceLime tw-bg-surfaceLime tw-text-black" : "tw-border-white tw-bg-transparent hover:tw-border-surfaceLime hover:tw-bg-surfaceLime hover:tw-text-black"}`,
                                                    children: "Expanded"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setExpanded(false),
                                                    className: `tw-px-2 tw-py-0.5 tw-rounded-r-full tw-border-solid tw-border-l-0 tw-border-2  ${!expanded ? "tw-bg-surfaceLime tw-border-surfaceLime tw-text-black" : "tw-bg-transparent tw-border-white hover:tw-border-surfaceLime  hover:tw-bg-surfaceLime hover:tw-text-black"}`,
                                                    children: "Collapsed"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-ml-auto tw-flex tw-items-center tw-gap-3 tw-text-sm tw-text-gray-400",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-items-center tw-gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "tw-w-4 tw-h-4 tw-bg-westburyBlue tw-rounded-full"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Validated"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-items-center tw-gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "tw-w-4 tw-h-4 tw-bg-westburyGreen tw-rounded-full"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Approved"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-items-center tw-gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "tw-w-4 tw-h-4 tw-bg-westburyAmber tw-rounded-full"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Review"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-items-center tw-gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "tw-w-4 tw-h-4 tw-bg-westburyRed tw-rounded-full"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Rejected"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                idsPopulated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-w-full tw-overflow-hidden tw-flex-grow tw-flex tw-flex-col",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-rounded-lg tw-border tw-border-gray-700 tw-overflow-hidden tw-flex tw-flex-col tw-h-full",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-sticky tw-top-0 tw-z-10",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tw-w-full tw-text-xs tw-text-left tw-bg-gray-800",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-text-xs tw-text-gray-400 tw-border-b tw-border-gray-700 tw-flex",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "tw-py-2 tw-px-3 tw-font-medium tw-w-1/5 tw-border-r tw-border-gray-700 tw-cursor-pointer tw-flex tw-items-center",
                                                                onClick: toggleSortDirection,
                                                                children: [
                                                                    "Alias/Group",
                                                                    sortDirection === "asc" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                                                        size: 14,
                                                                        className: "tw-ml-1"
                                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                                        size: 14,
                                                                        className: "tw-ml-1"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "tw-py-2 tw-px-3 tw-font-medium tw-w-1/5 tw-border-r tw-border-gray-700",
                                                                children: "Discogs"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "tw-py-2 tw-px-3 tw-font-medium tw-w-1/5 tw-border-r tw-border-gray-700",
                                                                children: "Deezer"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "tw-py-2 tw-px-3 tw-font-medium tw-w-1/5 tw-border-r tw-border-gray-700",
                                                                children: "Spotify"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "tw-py-2 tw-px-3 tw-font-medium tw-w-1/5",
                                                                children: "MusicBrainz"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-overflow-y-auto tw-overflow-x-visible tw-flex-grow tw-bg-gray-800",
                                                style: {
                                                    scrollbarWidth: "none"
                                                },
                                                ref: tableBodyRef,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tw-w-full tw-text-xs tw-text-left",
                                                    children: sortedArtistData.map((artist, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-border-b tw-border-gray-700 tw-bg-gray-900 hover:tw-bg-gray-800 tw-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "tw-py-2 tw-px-3 tw-align-top tw-border-r tw-border-gray-700 tw-w-1/5 tw-flex tw-items-start",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "tw-flex tw-w-full  tw-items-start tw-gap-2 tw-h-full",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "tw-flex tw-w-full tw-justify-between tw-items-center tw-gap-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "tw-flex tw-justify-start",
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                                        href: "#",
                                                                                        onClick: ()=>handleOpenEditModal(artist.id, "discogs"),
                                                                                        className: "tw-text-white hover:tw-underline tw-font-medium tw-inline-flex tw-items-center tw-gap-1",
                                                                                        children: artist.stageName
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    className: "tw-flex tw-items-center tw-gap-2",
                                                                                    children: [
                                                                                        artist.type === "group" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58e5d286cbd6aa3b$export$2e2bcd8739ae039), {
                                                                                            artist: artist
                                                                                        }) : null,
                                                                                        !artist.created_by_system && !isFormDisabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                            type: "button",
                                                                                            onClick: ()=>setConfirmDeleteModalDetails({
                                                                                                    stageName: artist.stageName,
                                                                                                    id: artist.id,
                                                                                                    type: artist.type
                                                                                                }),
                                                                                            className: "tw-group tw-p-0 tw-text-westburyRed tw-rounded-md hover:tw-text-white  tw-flex tw-items-center",
                                                                                            title: "Edit ID",
                                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                                                                size: 18,
                                                                                                className: "tw-text-westburyRed group-hover:tw-text-white tw-cursor-pointer"
                                                                                            })
                                                                                        }) : null
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $350900d80b13e467$export$4d15f0dfcfc9f8ae), {
                                                                    expanded: expanded,
                                                                    artist: artist,
                                                                    source: "discogs",
                                                                    handleAddIdFromCell: handleOpenEditModal,
                                                                    openIdDetailsModal: handleOpenEditModal
                                                                }, `${artist.id}-discogs-cell`),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $350900d80b13e467$export$4d15f0dfcfc9f8ae), {
                                                                    expanded: expanded,
                                                                    artist: artist,
                                                                    source: "deezer",
                                                                    handleAddIdFromCell: handleOpenEditModal,
                                                                    openIdDetailsModal: handleOpenEditModal
                                                                }, `${artist.id}-deezer-cell`),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $350900d80b13e467$export$4d15f0dfcfc9f8ae), {
                                                                    expanded: expanded,
                                                                    artist: artist,
                                                                    source: "spotify",
                                                                    handleAddIdFromCell: handleOpenEditModal,
                                                                    openIdDetailsModal: handleOpenEditModal
                                                                }, `${artist.id}-spotify-cell`),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $350900d80b13e467$export$4d15f0dfcfc9f8ae), {
                                                                    expanded: expanded,
                                                                    artist: artist,
                                                                    source: "musicbrainz",
                                                                    handleAddIdFromCell: handleOpenEditModal,
                                                                    openIdDetailsModal: handleOpenEditModal
                                                                }, `${artist.id}-musicbrainz-cell`)
                                                            ]
                                                        }, artist.id))
                                                })
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-text-center tw-py-8 tw-flex-grow tw-flex tw-flex-col tw-justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "tw-text-gray-400",
                                            children: "No IDs populated yet"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "tw-text-gray-500 tw-text-sm tw-mt-2",
                                            children: "Use the search function to populate IDs"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    !isPopulatingIds && idsPopulated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-justify-end tw-w-full tw-items-center tw-gap-4",
                        children: [
                            runStatus !== null && (runStatus === "cancelled" || runStatus === "failed" || runStatus === "finished") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-my-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "tw-flex tw-items-center tw-gap-2",
                                    children: [
                                        "Last run status:",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: [
                                                "tw-rounded-full tw-w-4 tw-h-4",
                                                runStatus === "finished" ? "tw-bg-westburyGreen" : "",
                                                runStatus === "cancelled" ? "tw-bg-gray-500" : "",
                                                runStatus === "failed" ? "tw-bg-westburyRed" : ""
                                            ].join(" ")
                                        }),
                                        runStatusMap[runStatus] ?? "Unknown"
                                    ]
                                })
                            }) : null,
                            runStatus !== null && runStatus !== "running" && runStatus !== "preparing" && runStatus !== "canceling" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-min-w-[200px] tw-pr-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $683bf00e40c955d9$export$353f5b6fc5456de1), {
                                    styleType: "btn-primary",
                                    onClick: runDiscography,
                                    disabled: isFormDisabled,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-w-full tw-flex tw-gap-2 tw-items-center",
                                        children: runStatus === "not-started" ? "Run Discography" : "Re-Run Discography"
                                    })
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-min-w-[260px] tw-flex tw-flex-col tw-gap-2 tw-items-end tw-justify-end tw-pr-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-gap-2 tw-items-center tw-justify-end",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $683bf00e40c955d9$export$353f5b6fc5456de1), {
                                                styleType: "btn-primary",
                                                onClick: runDiscography,
                                                disabled: isFormDisabled,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-w-full tw-flex tw-gap-2 tw-items-center",
                                                    children: [
                                                        runStatus === "preparing" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3266583f46f84dc$export$2e2bcd8739ae039), {
                                                            size: 18,
                                                            className: "tw-animate-spin"
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                            size: 18,
                                                            className: "tw-animate-spin"
                                                        }),
                                                        activeRunLabel
                                                    ]
                                                })
                                            }),
                                            runStatus === "running" || runStatus === "preparing" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $683bf00e40c955d9$export$353f5b6fc5456de1), {
                                                styleType: "btn-primary",
                                                onClick: cancelDiscographyRun,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-w-full tw-flex tw-gap-2 tw-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2dfa57d290a8089$export$2e2bcd8739ae039), {
                                                            size: 18
                                                        }),
                                                        "Cancel Discography Run"
                                                    ]
                                                })
                                            }) : null,
                                            runIsStalled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $683bf00e40c955d9$export$353f5b6fc5456de1), {
                                                styleType: "btn-primary",
                                                onClick: restartDiscography,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-w-full tw-flex tw-gap-2 tw-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                            size: 18
                                                        }),
                                                        "Restart stuck run"
                                                    ]
                                                })
                                            }) : null
                                        ]
                                    }),
                                    runCurrentStep && runTotalSteps ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-h-1.5 tw-w-full tw-bg-gray-600 tw-rounded-full tw-overflow-hidden",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-h-full tw-bg-westburyGreen tw-transition-all",
                                            style: {
                                                width: `${Math.round(runCurrentStep / runTotalSteps * 100)}%`
                                            }
                                        })
                                    }) : null,
                                    runIsStalled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "tw-text-xs tw-text-westburyRed",
                                        children: "No progress detected \u2014 the run may be stuck. You can restart it."
                                    }) : null
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            showEditArtistModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-70 tw-flex tw-items-center tw-justify-center tw-z-50",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-bg-gray-800 tw-rounded-lg tw-p-6 tw-max-w-md tw-w-full tw-mx-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-between tw-items-center tw-mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "tw-text-white tw-text-lg tw-font-medium",
                                    children: "Edit Artist Details"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>setShowEditArtistModal(false),
                                    className: "tw-text-gray-400 hover:tw-text-white",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 20
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "firstName",
                                            className: "tw-text-white tw-mb-1 tw-flex tw-items-center",
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            name: "firstName",
                                            value: credentialsFormData.firstName,
                                            onChange: (e)=>setCredentialsFormData((state)=>({
                                                        ...state,
                                                        firstName: e.target.value
                                                    })),
                                            className: "tw-w-full tw-bg-gray-700 tw-border-none tw-rounded-md tw-px-3 tw-py-2 tw-text-white tw-outline-none",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "lastName",
                                            className: " tw-text-white tw-mb-1 tw-flex tw-items-center",
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            name: "lastName",
                                            value: credentialsFormData.lastName,
                                            onChange: (e)=>setCredentialsFormData((state)=>({
                                                        ...state,
                                                        lastName: e.target.value
                                                    })),
                                            className: "tw-w-full tw-bg-gray-700 tw-border-none tw-rounded-md tw-px-3 tw-py-2 tw-text-white tw-outline-none",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "email",
                                            className: " tw-text-white tw-mb-1 tw-flex tw-items-center",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "email",
                                            name: "email",
                                            value: credentialsFormData.email,
                                            onChange: (e)=>setCredentialsFormData((state)=>({
                                                        ...state,
                                                        email: e.target.value
                                                    })),
                                            className: "tw-w-full tw-bg-gray-700 tw-border-none tw-rounded-md tw-px-3 tw-py-2 tw-text-white tw-outline-none",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "pplPerformerName",
                                            className: " tw-text-white tw-mb-1 tw-flex tw-items-center",
                                            children: "PPL Contributor Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            name: "pplPerformerName",
                                            value: credentialsFormData.pplPerformerName,
                                            onChange: (e)=>setCredentialsFormData((state)=>({
                                                        ...state,
                                                        pplPerformerName: e.target.value
                                                    })),
                                            className: "tw-w-full tw-bg-gray-700 tw-border-none tw-rounded-md tw-px-3 tw-py-2 tw-text-white tw-outline-none",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "pplPerformerId",
                                            className: " tw-text-white tw-mb-1 tw-flex tw-items-center",
                                            children: "PPL Perfomer ID"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            name: "pplPerformerId",
                                            value: credentialsFormData.pplPerformerId,
                                            onChange: (e)=>setCredentialsFormData((state)=>({
                                                        ...state,
                                                        pplPerformerId: e.target.value
                                                    })),
                                            className: "tw-w-full tw-bg-gray-700 tw-border-none tw-rounded-md tw-px-3 tw-py-2 tw-text-white tw-outline-none",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "pplAccountName",
                                            className: " tw-text-white tw-mb-1 tw-flex tw-items-center",
                                            children: "PPL Account Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            name: "pplAccountName",
                                            value: credentialsFormData.pplAccountName,
                                            onChange: (e)=>setCredentialsFormData((state)=>({
                                                        ...state,
                                                        pplAccountName: e.target.value
                                                    })),
                                            className: "tw-w-full tw-bg-gray-700 tw-border-none tw-rounded-md tw-px-3 tw-py-2 tw-text-white tw-outline-none",
                                            required: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-space-x-3 tw-mt-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        setShowEditArtistModal(false);
                                        // Reset values
                                        setCredentialsFormData(cleanCredentialsFormData);
                                    },
                                    className: "tw-px-4 tw-py-2 tw-rounded-md tw-text-white tw-bg-gray-700 hover:tw-bg-gray-600",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        setShowEditArtistModal(false);
                                        onUserSettingsUpdated();
                                        // Update values to the latest
                                        setCleanCredentialsFormData(credentialsFormData);
                                    },
                                    className: "tw-px-4 tw-py-2 tw-rounded-md tw-text-white tw-bg-westburyBlue hover:tw-bg-westburyBlue/80",
                                    children: "Save Changes"
                                })
                            ]
                        })
                    ]
                })
            }),
            showIdDetailsModal && selectedIdDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-70 tw-flex tw-items-center tw-justify-center tw-z-50",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-bg-gray-800 tw-rounded-lg tw-p-6 tw-max-w-md tw-w-full tw-mx-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-between tw-items-center tw-mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    className: "tw-text-white tw-text-lg tw-font-medium",
                                    children: [
                                        selectedIdDetails.platform.charAt(0).toUpperCase() + selectedIdDetails.platform.slice(1),
                                        " ",
                                        "IDs for ",
                                        selectedIdDetails.artistName
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>setShowIdDetailsModal(false),
                                    className: "tw-text-gray-400 hover:tw-text-white",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 20
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-space-y-3 tw-max-h-96 tw-overflow-y-auto tw-mb-6",
                            children: selectedIdDetails.source_ids.length > 0 ? selectedIdDetails.source_ids.map((idObj, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-bg-gray-700 tw-rounded-md tw-p-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-text-gray-300 tw-text-xs tw-mb-1",
                                            children: idObj.original_name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-flex tw-items-center tw-justify-between",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-flex tw-items-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: (0, $2b6ac978d2ae7c3b$export$2b3e309b6e59ebdf)(idObj.id, selectedIdDetails.platform),
                                                    className: "tw-text-westburyBlue tw-text-sm tw-flex tw-items-center tw-justify-center",
                                                    children: idObj.id
                                                })
                                            })
                                        })
                                    ]
                                }, index)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-text-gray-400 tw-text-center tw-py-4",
                                children: "No IDs available"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-justify-end tw-space-x-3",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setShowIdDetailsModal(false),
                                className: "tw-px-4 tw-py-2 tw-rounded-md tw-text-white tw-bg-gray-700 hover:tw-bg-gray-600",
                                children: "Close"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d5567c03117eaee$export$2e2bcd8739ae039), {
                showAliasModal: showAddAliasModal,
                showBandModal: showAddBandModal,
                onClose: ()=>{
                    setShowAddAliasModal(false);
                    setShowAddBandModal(false);
                },
                onCreateNewAlias: ()=>{
                    setShowAddBandModal(false);
                    handleOpenAddAliasModal();
                },
                activeAliasTab: activeAliasTab,
                activeBandTab: activeBandTab,
                onAliasTabChange: setActiveAliasTab,
                onBandTabChange: setActiveBandTab,
                aliasForm: newAliasForm,
                bandForm: newBandForm,
                onAliasChange: setNewAliasForm,
                onBandChange: setNewBandForm
            }),
            confirmDeleteModalDetails ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                onClose: ()=>setConfirmDeleteModalDetails(null),
                isOpen: Boolean(confirmDeleteModalDetails),
                title: `Remove "${confirmDeleteModalDetails.stageName}" ${confirmDeleteModalDetails.type === "persona" ? "alias" : "band"}?`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: `Are you sure you want to remove "${confirmDeleteModalDetails.stageName}" ${confirmDeleteModalDetails.type === "persona" ? "alias" : "band"}?`
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-mt-4 tw-w-full tw-flex tw-justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    label: "Cancel",
                                    variant: "secondary",
                                    onClick: ()=>{
                                        setConfirmDeleteModalDetails(null);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    label: "Continue",
                                    variant: "primary",
                                    onClick: ()=>{
                                        handleDeleteArtistDiscographyID(confirmDeleteModalDetails.id);
                                        setConfirmDeleteModalDetails(null);
                                    }
                                })
                            ]
                        })
                    ]
                })
            }) : null
        ]
    });
}




function $4d3075243f034f38$var$ArtistDiscographyIDCardImplementation({ isOpen: isOpen, onClose: onClose, onComplete: onComplete, onUserSettingsUpdated: onUserSettingsUpdated }) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [runStatus, setRunStatus] = (0, $acw62.useState)(null);
    const getDiscographyPipelineRunStatus = async ()=>{
        if (clientId === undefined) return;
        if (!isOpen) return;
        await api.retrievePipelineRunStatus({
            userId: clientId
        }).then(({ status: status })=>setRunStatus(status)).catch(()=>setRunStatus(null));
    };
    (0, $acw62.useEffect)(()=>{
        getDiscographyPipelineRunStatus();
    }, [
        isOpen,
        clientId
    ]);
    const handleClose = ()=>{
        if (runStatus === (0, $057bd700f894f3a9$export$21bfd8db6a54fb2f).Success) {
            onComplete && onComplete();
            onClose();
            return;
        }
        onClose();
    };
    const [searchVisible, setSearchVisible] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        title: "",
        isOpen: isOpen,
        onClose: handleClose,
        modalClasses: "tw-w-[90%]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-rounded-xl tw-shadow-2xl tw-w-full tw-h-[90vh] tw-flex tw-overflow-hidden tw-z-20",
            onClick: (e)=>e.stopPropagation(),
            children: [
                searchVisible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8503c7a26359d6fd$export$4e5af08e77f3f9f3), {}) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ec52385fce330c7$export$fd8ba84aa3816912), {
                    toggleSearchPanel: ()=>setSearchVisible((state)=>!state),
                    isSearchExpanded: searchVisible,
                    onUserSettingsUpdated: ()=>onUserSettingsUpdated?.()
                })
            ]
        })
    });
}
function $4d3075243f034f38$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $004d21965b9ef321$export$7f62b772a1698e6), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb3e3eaca9d70655$export$c71b1e37f2e0ace0), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4d3075243f034f38$var$ArtistDiscographyIDCardImplementation, {
                ...props
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");
var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));


var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $0522fa2e4977c358$var$_excluded = [
    "as",
    "disabled"
];
function $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0522fa2e4977c358$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
function $0522fa2e4977c358$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = "a";
        else tagName = "button";
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === "button") return [
        {
            type: type || "button",
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === "a" && $0522fa2e4977c358$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === "a") {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = "#");
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : "button",
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === "a" ? target : undefined,
            "aria-disabled": !disabled ? undefined : disabled,
            rel: tagName === "a" ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $0522fa2e4977c358$var$Button = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(_ref, $0522fa2e4977c358$var$_excluded);
    const [buttonProps, { tagName: Component }] = $0522fa2e4977c358$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$0522fa2e4977c358$var$Button.displayName = "Button";
var $0522fa2e4977c358$export$2e2bcd8739ae039 = $0522fa2e4977c358$var$Button;



var $acw62 = parcelRequire("acw62");

const $626bd95fa485b758$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $626bd95fa485b758$export$ff817e17bad2e091 = "xs";
const $626bd95fa485b758$var$ThemeContext = /*#__PURE__*/ $acw62.createContext({
    prefixes: {},
    breakpoints: $626bd95fa485b758$export$666ad80b5007f835,
    minBreakpoint: $626bd95fa485b758$export$ff817e17bad2e091
});
const { Consumer: $626bd95fa485b758$export$b631efc24e9d5e2f, Provider: $626bd95fa485b758$var$Provider } = $626bd95fa485b758$var$ThemeContext;
function $626bd95fa485b758$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $626bd95fa485b758$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $626bd95fa485b758$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $acw62.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($626bd95fa485b758$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $626bd95fa485b758$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $626bd95fa485b758$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return breakpoints;
}
function $626bd95fa485b758$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return minBreakpoint;
}
function $626bd95fa485b758$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return dir === "rtl";
}
function $626bd95fa485b758$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? "ref" : "innerRef" } = opts;
    const Wrapped = /*#__PURE__*/ $acw62.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $626bd95fa485b758$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $626bd95fa485b758$export$2e2bcd8739ae039 = $626bd95fa485b758$var$ThemeProvider;



const $4ed343d4b409b2f2$var$Button = /*#__PURE__*/ $acw62.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = "primary", size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "btn");
    const [buttonProps, { tagName: tagName }] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, active && "active", variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && "disabled")
    });
});
$4ed343d4b409b2f2$var$Button.displayName = "Button";
var $4ed343d4b409b2f2$export$2e2bcd8739ae039 = $4ed343d4b409b2f2$var$Button;


/* eslint-disable no-return-assign */ var $55986f7b0f69fd17$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);


var $28419dce7921d430$export$63fefd044b2bc624 = false;
var $28419dce7921d430$export$a614c6b395900f69 = false;
try {
    var $28419dce7921d430$var$options = {
        get passive () {
            return $28419dce7921d430$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $28419dce7921d430$export$a614c6b395900f69 = $28419dce7921d430$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $55986f7b0f69fd17$export$2e2bcd8739ae039) {
        window.addEventListener("test", $28419dce7921d430$var$options, $28419dce7921d430$var$options);
        window.removeEventListener("test", $28419dce7921d430$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $28419dce7921d430$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$28419dce7921d430$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$28419dce7921d430$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $28419dce7921d430$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $28419dce7921d430$export$2e2bcd8739ae039 = $28419dce7921d430$var$addEventListener;



/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $fcf05e248574eb57$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $59fd23e4cc6020bf$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $59fd23e4cc6020bf$export$2e2bcd8739ae039 = $59fd23e4cc6020bf$var$removeEventListener;



var $2d215567a00cb0b5$var$size;
function $2d215567a00cb0b5$export$2e2bcd8739ae039(recalc) {
    if (!$2d215567a00cb0b5$var$size && $2d215567a00cb0b5$var$size !== 0 || recalc) {
        if (0, $55986f7b0f69fd17$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement("div");
            scrollDiv.style.position = "absolute";
            scrollDiv.style.top = "-9999px";
            scrollDiv.style.width = "50px";
            scrollDiv.style.height = "50px";
            scrollDiv.style.overflow = "scroll";
            document.body.appendChild(scrollDiv);
            $2d215567a00cb0b5$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $2d215567a00cb0b5$var$size;
}



var $acw62 = parcelRequire("acw62");
function $6ee4f2c1aea3527b$export$2e2bcd8739ae039() {
    return (0, $acw62.useState)(null);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ab80f0daa08f2134$var$useCommittedRef(value) {
    const ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ab80f0daa08f2134$export$2e2bcd8739ae039 = $ab80f0daa08f2134$var$useCommittedRef;


function $9cc831e7fe1726fc$export$2e2bcd8739ae039(fn) {
    const ref = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn);
    return (0, $acw62.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $acw62 = parcelRequire("acw62");
const $9d58c39545e3cedc$var$toFnRef = (ref)=>!ref || typeof ref === "function" ? ref : (value)=>{
        ref.current = value;
    };
function $9d58c39545e3cedc$export$c9058316764c140e(refA, refB) {
    const a = $9d58c39545e3cedc$var$toFnRef(refA);
    const b = $9d58c39545e3cedc$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $9d58c39545e3cedc$var$useMergedRefs(refA, refB) {
    return (0, $acw62.useMemo)(()=>$9d58c39545e3cedc$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $9d58c39545e3cedc$export$2e2bcd8739ae039 = $9d58c39545e3cedc$var$useMergedRefs;



var $acw62 = parcelRequire("acw62");
function $6227e7ea0d71afb1$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $acw62 = parcelRequire("acw62");
function $63805df80cf3ca43$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $6227e7ea0d71afb1$export$2e2bcd8739ae039)(fn);
    (0, $acw62.useEffect)(()=>()=>onUnmount.current(), []);
}



function $da31306d5140b746$export$2e2bcd8739ae039(node) {
    var doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $9d0d2e2a013bac9c$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $da31306d5140b746$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $9f2c378a21ca2430$var$rUpper = /([A-Z])/g;
function $9f2c378a21ca2430$export$2e2bcd8739ae039(string) {
    return string.replace($9f2c378a21ca2430$var$rUpper, "-$1").toLowerCase();
}


var $09bdad49a6503060$var$msPattern = /^ms-/;
function $09bdad49a6503060$export$2e2bcd8739ae039(string) {
    return (0, $9f2c378a21ca2430$export$2e2bcd8739ae039)(string).replace($09bdad49a6503060$var$msPattern, "-ms-");
}


var $c8af0fa0e8553220$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $c8af0fa0e8553220$export$2e2bcd8739ae039(value) {
    return !!(value && $c8af0fa0e8553220$var$supportedTransforms.test(value));
}


function $1d31c226dae4138f$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property)) || (0, $9d0d2e2a013bac9c$export$2e2bcd8739ae039)(node).getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $09bdad49a6503060$export$2e2bcd8739ae039)(key));
        else if ((0, $c8af0fa0e8553220$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $09bdad49a6503060$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $1d31c226dae4138f$export$2e2bcd8739ae039 = $1d31c226dae4138f$var$style;




function $5ce0a80dcc778636$var$listen(node, eventName, handler, options) {
    (0, $28419dce7921d430$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $5ce0a80dcc778636$export$2e2bcd8739ae039 = $5ce0a80dcc778636$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $d690caf237d1909f$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $3966a04026e86a49$var$parseDuration(node) {
    var str = (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $d690caf237d1909f$export$2e2bcd8739ae039)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $3966a04026e86a49$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $3966a04026e86a49$var$parseDuration(element) || 0;
    var removeEmulate = $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}



var $acw62 = parcelRequire("acw62");

function $d26eb8849281a3d4$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $967999a1a8cec832$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $ed7e9ace1ce49d9f$export$2e2bcd8739ae039() {
    const mounted = (0, $acw62.useRef)(true);
    const isMounted = (0, $acw62.useRef)(()=>mounted.current);
    (0, $acw62.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}




var $acw62 = parcelRequire("acw62");
function $97a3f3bdcb91cb9e$export$2e2bcd8739ae039(value) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}




const $1123d3fd1f42218c$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $1123d3fd1f42218c$export$635202801f9383a0 = `rrUi`;
function $1123d3fd1f42218c$export$5cc3b7b83e34ade7(property) {
    return `${$1123d3fd1f42218c$export$fd7bcb7e9bef4e8a}${property}`;
}
function $1123d3fd1f42218c$export$7776c0a7cd2eb3e0(property) {
    return `${$1123d3fd1f42218c$export$635202801f9383a0}${property}`;
}


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $01b2d58e52126803$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $254a0b83be45660e$export$1a88c12b8b979fa0 = (0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("modal-open");
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $254a0b83be45660e$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $01b2d58e52126803$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: "hidden"
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(container, paddingProp) || "0", 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($254a0b83be45660e$export$1a88c12b8b979fa0, "");
        (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($254a0b83be45660e$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $254a0b83be45660e$export$2e2bcd8739ae039 = $254a0b83be45660e$var$ModalManager;





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $0e151397e562aebc$var$Context = /*#__PURE__*/ (0, $acw62.createContext)((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) ? window : undefined);
const $0e151397e562aebc$export$f7d306aeb1cf5fbc = $0e151397e562aebc$var$Context.Provider;
function $0e151397e562aebc$export$2e2bcd8739ae039() {
    return (0, $acw62.useContext)($0e151397e562aebc$var$Context);
}


const $1892253eb6d46162$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $55986f7b0f69fd17$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $fcf05e248574eb57$export$2e2bcd8739ae039)()).body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if (ref && ("nodeType" in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $1892253eb6d46162$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $acw62.useState)(()=>$1892253eb6d46162$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $acw62.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const nextRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}






var $acw62 = parcelRequire("acw62");
const $63565b817d447aae$var$isReactNative = typeof $parcel$global !== "undefined" && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === "ReactNative";
const $63565b817d447aae$var$isDOM = typeof document !== "undefined";
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $63565b817d447aae$export$2e2bcd8739ae039 = $63565b817d447aae$var$isDOM || $63565b817d447aae$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $83a01f83dd44ef33$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $acw62.useRef)(null);
    const hasEnteredRef = (0, $acw62.useRef)(inProp);
    const handleExited = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onExited);
    (0, $acw62.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, children.ref);
    const child = /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $83a01f83dd44ef33$export$2e2bcd8739ae039 = $83a01f83dd44ef33$var$NoopTransition;



function $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $acw62.useRef)(null);
    const isInitialRef = (0, $acw62.useRef)(true);
    const handleTransition = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onTransition);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $86d0e8a9dc3b2e91$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $acw62.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
}
function $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5(Component, runTransition, props) {
    if (Component) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props));
    if (runTransition) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($86d0e8a9dc3b2e91$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83a01f83dd44ef33$export$2e2bcd8739ae039), Object.assign({}, props));
}


/* eslint-disable import/prefer-default-export */ function $a36e95ee292bed8b$export$806fcc22e55e107d(e) {
    return e.code === "Escape" || e.keyCode === 27;
}



const $0173af0e859d9b0f$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $0173af0e859d9b0f$var$manager;
function $0173af0e859d9b0f$var$getManager(window) {
    if (!$0173af0e859d9b0f$var$manager) $0173af0e859d9b0f$var$manager = new (0, $254a0b83be45660e$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $0173af0e859d9b0f$var$manager;
}
function $0173af0e859d9b0f$var$useModalManager(provided) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const modalManager = provided || $0173af0e859d9b0f$var$getManager(window);
    const modal = (0, $acw62.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $0173af0e859d9b0f$var$Modal = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = "dialog", className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(_ref, $0173af0e859d9b0f$var$_excluded);
    const ownerWindow = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const container = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(containerRef);
    const modal = $0173af0e859d9b0f$var$useModalManager(providedManager);
    const isMounted = (0, $ed7e9ace1ce49d9f$export$2e2bcd8739ae039)();
    const prevShow = (0, $97a3f3bdcb91cb9e$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $acw62.useState)(!show);
    const lastFocusRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(document, "keydown", handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(document, "focus", // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $acw62.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $acw62.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $63805df80cf3ca43$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $a36e95ee292bed8b$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $acw62.useRef)();
    const removeKeydownListenerRef = (0, $acw62.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        "aria-modal": role === "dialog" ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, {
            role: "document"
        })
    }));
    dialog = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$0173af0e859d9b0f$var$Modal.displayName = "Modal";
var $0173af0e859d9b0f$export$2e2bcd8739ae039 = Object.assign($0173af0e859d9b0f$var$Modal, {
    Manager: (0, $254a0b83be45660e$export$2e2bcd8739ae039)
});


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}



var $01b4fe2088fac58b$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $01b4fe2088fac58b$export$2e2bcd8739ae039(element, selector) {
    return $01b4fe2088fac58b$var$toArray(element.querySelectorAll(selector));
}


function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



const $f00adc503d5cecaf$var$Selector = {
    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    STICKY_CONTENT: ".sticky-top",
    NAVBAR_TOGGLER: ".navbar-toggler"
};
class $f00adc503d5cecaf$var$BootstrapModalManager extends (0, $254a0b83be45660e$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(container, "modal-open");
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(container, "modal-open");
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $f00adc503d5cecaf$var$sharedManager;
function $f00adc503d5cecaf$export$a03641438014b436(options) {
    if (!$f00adc503d5cecaf$var$sharedManager) $f00adc503d5cecaf$var$sharedManager = new $f00adc503d5cecaf$var$BootstrapModalManager(options);
    return $f00adc503d5cecaf$var$sharedManager;
}
var $f00adc503d5cecaf$export$2e2bcd8739ae039 = $f00adc503d5cecaf$var$BootstrapModalManager;




var $acw62 = parcelRequire("acw62");
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}


var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $k8nJx = parcelRequire("k8nJx");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $8da5bfbbed271cd7$var$throwOnDirectAccess = true;

$8da5bfbbed271cd7$exports = (parcelRequire("eGxWZ"))($k8nJx.isElement, $8da5bfbbed271cd7$var$throwOnDirectAccess);



var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};



var $8a43c04fdfd3c437$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    }).isRequired
]);
var $8a43c04fdfd3c437$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    })
]);



var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        current: typeof Element === "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $8a43c04fdfd3c437$export$3458ee1082941f5e);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;




function $f251260f6a38a977$var$parseDuration(node, property) {
    const str = (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, property) || "";
    const mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f251260f6a38a977$export$2e2bcd8739ae039(element, handler) {
    const duration = $f251260f6a38a977$var$parseDuration(element, "transitionDuration");
    const delay = $f251260f6a38a977$var$parseDuration(element, "transitionDelay");
    const remove = (0, $3966a04026e86a49$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $02f7800ef44133eb$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $acw62 = parcelRequire("acw62");



function $75718871ab216e51$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



// Normalizes Transition callbacks when nodeRef is used.
const $5e18c3cbbc2321dd$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $acw62.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $acw62.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $acw62.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $acw62.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $acw62.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $acw62.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $acw62.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0fef977f04119bf5$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $5e18c3cbbc2321dd$export$2e2bcd8739ae039 = $5e18c3cbbc2321dd$var$TransitionWrapper;



const $588ffbaaa8a325aa$var$fadeStyles = {
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: "show",
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: "show"
};
const $588ffbaaa8a325aa$var$Fade = /*#__PURE__*/ $acw62.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $acw62.useCallback)((node, isAppearing)=>{
        (0, $02f7800ef44133eb$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $acw62.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("fade", className, children.props.className, $588ffbaaa8a325aa$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$588ffbaaa8a325aa$var$Fade.displayName = "Fade";
var $588ffbaaa8a325aa$export$2e2bcd8739ae039 = $588ffbaaa8a325aa$var$Fade;



var $8839e0a7e6f8b9c7$var$rHyphen = /-(.)/g;
function $8839e0a7e6f8b9c7$export$2e2bcd8739ae039(string) {
    return string.replace($8839e0a7e6f8b9c7$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
}



var $acw62 = parcelRequire("acw62");


const $140532fd91d84ddb$var$pascalCase = (str)=>str[0].toUpperCase() + (0, $8839e0a7e6f8b9c7$export$2e2bcd8739ae039)(str).slice(1);
function $140532fd91d84ddb$export$2e2bcd8739ae039(prefix, { displayName: displayName = $140532fd91d84ddb$var$pascalCase(prefix), Component: Component, defaultProps: defaultProps } = {}) {
    const BsComponent = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Tag = Component || "div", ...props }, ref)=>{
        const componentProps = {
            ...defaultProps,
            ...props
        };
        const resolvedPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, prefix);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Tag, {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, resolvedPrefix),
            ...componentProps
        });
    });
    BsComponent.displayName = displayName;
    return BsComponent;
}


var $25947da381dd154d$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("modal-body");



var $acw62 = parcelRequire("acw62");
const $ce35488230cbfb2e$var$ModalContext = /*#__PURE__*/ $acw62.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $ce35488230cbfb2e$export$2e2bcd8739ae039 = $ce35488230cbfb2e$var$ModalContext;




var $acw62 = parcelRequire("acw62");


const $b2d89f22a8b39e63$var$ModalDialog = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "modal");
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === "string" ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$b2d89f22a8b39e63$var$ModalDialog.displayName = "ModalDialog";
var $b2d89f22a8b39e63$export$2e2bcd8739ae039 = $b2d89f22a8b39e63$var$ModalDialog;



var $9bf8146dd7a62ed4$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("modal-footer");




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $52ed202a4f01c477$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "white"
    ])
};
const $52ed202a4f01c477$var$CloseButton = /*#__PURE__*/ $acw62.forwardRef(({ className: className, variant: variant, "aria-label": ariaLabel = "Close", ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn-close", variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$52ed202a4f01c477$var$CloseButton.displayName = "CloseButton";
$52ed202a4f01c477$var$CloseButton.propTypes = $52ed202a4f01c477$var$propTypes;
var $52ed202a4f01c477$export$2e2bcd8739ae039 = $52ed202a4f01c477$var$CloseButton;




const $7ed9ce9ab3e9405e$var$AbstractModalHeader = /*#__PURE__*/ $acw62.forwardRef(({ closeLabel: closeLabel = "Close", closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $acw62.useContext)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039));
    const handleClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52ed202a4f01c477$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $7ed9ce9ab3e9405e$export$2e2bcd8739ae039 = $7ed9ce9ab3e9405e$var$AbstractModalHeader;



const $b25eacf4397cf179$var$ModalHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = "Close", closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "modal-header");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed9ce9ab3e9405e$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$b25eacf4397cf179$var$ModalHeader.displayName = "ModalHeader";
var $b25eacf4397cf179$export$2e2bcd8739ae039 = $b25eacf4397cf179$var$ModalHeader;




var $acw62 = parcelRequire("acw62");


var $31af5e1d0c3b3c37$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $acw62.forwardRef((p, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(p.className, className)
        }));


const $39e2ac330b33f57e$var$DivStyledAsH4 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)("h4");
var $39e2ac330b33f57e$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("modal-title", {
    Component: $39e2ac330b33f57e$var$DivStyledAsH4
});




/* eslint-disable no-use-before-define, react/no-multi-comp */ function $c17184070610a5f4$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $c17184070610a5f4$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
/* eslint-enable no-use-before-define */ const $c17184070610a5f4$var$Modal = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $b2d89f22a8b39e63$export$2e2bcd8739ae039), "aria-labelledby": ariaLabelledby, "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $acw62.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $acw62.useState)(false);
    const waitingForMouseUpRef = (0, $acw62.useRef)(false);
    const ignoreBackdropClickRef = (0, $acw62.useRef)(false);
    const removeStaticModalAnimationRef = (0, $acw62.useRef)(null);
    const [modal, setModalRef] = (0, $6ee4f2c1aea3527b$export$2e2bcd8739ae039)();
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "modal");
    const modalContext = (0, $acw62.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $f00adc503d5cecaf$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $55986f7b0f69fd17$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $2d215567a00cb0b5$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $2d215567a00cb0b5$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $63805df80cf3ca43$export$2e2bcd8739ae039)(()=>{
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $3966a04026e86a49$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === "static") {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === "static") // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $28419dce7921d430$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ""; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
    };
    const renderBackdrop = (0, $acw62.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && "show")
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = "block";
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && "show"),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0173af0e859d9b0f$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $c17184070610a5f4$var$DialogTransition : undefined,
            backdropTransition: animation ? $c17184070610a5f4$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$c17184070610a5f4$var$Modal.displayName = "Modal";
var $c17184070610a5f4$export$2e2bcd8739ae039 = Object.assign($c17184070610a5f4$var$Modal, {
    Body: (0, $25947da381dd154d$export$2e2bcd8739ae039),
    Header: (0, $b25eacf4397cf179$export$2e2bcd8739ae039),
    Title: (0, $39e2ac330b33f57e$export$2e2bcd8739ae039),
    Footer: (0, $9bf8146dd7a62ed4$export$2e2bcd8739ae039),
    Dialog: (0, $b2d89f22a8b39e63$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});


var $33904babfb68cee8$exports = {};
$33904babfb68cee8$exports = new URL("TermsOfAgreement.124b5521.pdf", import.meta.url).toString();



var $b22b3ebcec7a7ec8$var$documentData = {
    name: "Membership Form [GRAMEX (Denmark)]",
    template_uuid: "grSAyFuPNtoP2bhsQbEokZ",
    recipients: [
        {
            email: "admin@westbury.com",
            role: "Westbury Admin"
        }
    ],
    fields: {
        client_sign: {
            value: "",
            title: "Signature",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        sign_date: {
            value: "",
            title: "Date of Signature",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        date_of_birth: {
            value: "15th April 1999",
            title: "Date of Birth",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        nationality: {
            value: "Uk",
            title: "nationality",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        instrument: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        full_name: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        stage_name: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        band_member_of: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        address: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        zip_code: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        country_of_residence: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        tel_no: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        mobile_no: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        email: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        website: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        account_holder: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        bic_code: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        account_no: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        bank_name: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        bank_address: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        },
        bank_zipcode: {
            value: "xxx xxx xxx",
            title: "",
            assigned_to: {
                email: "admin@westbury.com",
                type: "recipient"
            }
        }
    }
};
function $b22b3ebcec7a7ec8$var$MembershipFormModal({ showModal: show, modalClose: modalClose, clientId: clientId }) {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    localStorage.setItem("document_id", "");
    var docId = localStorage.getItem("document_id");
    const [documentID, setDocumentID] = (0, $acw62.useState)(null);
    const apiKey = "462ef621474a2ea833ac60418b8d36176af04996";
    let documentPDFIds = [];
    const sendDocument = async (doc)=>{
        var config = {
            method: "post",
            url: "https://api.pandadoc.com/public/v1/documents",
            headers: {
                Authorization: "API-Key 462ef621474a2ea833ac60418b8d36176af04996",
                "Content-Type": "application/json"
            },
            data: JSON.stringify(doc)
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports)))(config).then(function(response) {
            if (response.data.id) {
                var Senddata = JSON.stringify({
                    message: "Hello! This document was sent from the PandaDoc API.",
                    email: "admin@westbury.com",
                    silent: true
                });
                var config = {
                    method: "post",
                    url: `https://api.pandadoc.com/public/v1/documents/${response.data.id}/send`,
                    headers: {
                        Authorization: "API-Key 462ef621474a2ea833ac60418b8d36176af04996",
                        "Content-Type": "application/json"
                    },
                    data: Senddata
                };
                setTimeout(()=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports)))(config).then(function(response) {
                        if (response.data.id && response.data.status === "document.sent") {
                            var data = JSON.stringify({
                                recipient: "admin@westbury.com",
                                lifetime: 315359990
                            });
                            var config = {
                                async: true,
                                method: "post",
                                url: `https://api.pandadoc.com/public/v1/documents/${response.data.id}/session`,
                                headers: {
                                    Authorization: "API-Key 462ef621474a2ea833ac60418b8d36176af04996",
                                    "Content-Type": "application/json"
                                },
                                data: data
                            };
                            (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports)))(config).then(function(response) {
                                //localStorage.setItem("document_id", response.data.id);
                                var storeID = response.data.id;
                                documentPDFIds.push(storeID);
                                setDocumentID(storeID);
                                console.log(documentID);
                            }).catch(function(error) {
                                console.log(error);
                            });
                            setTimeout(()=>{}, 5000);
                        } else response.data.status;
                    }).catch(function(error) {});
                }, 3000);
            }
        }).catch(function(error) {});
    };
    const fetchData = async ()=>{
        if (clientId === undefined) return;
        try {
            const res = await api.retrievePandadocsEgress({
                userId: clientId,
                societyFormId: "d6b59095-05b5-453f-a996-46cc3f06d0fb"
            });
            if (res) {
                Object.entries(res.pandadocsData).forEach(([key, value])=>{
                    if (key === "title") $b22b3ebcec7a7ec8$var$documentData.fields[key + "_" + value] = {
                        value: value,
                        title: key,
                        assigned_to: {
                            email: "admin@westbury.com",
                            type: "recipient"
                        }
                    };
                    else $b22b3ebcec7a7ec8$var$documentData.fields[key] = {
                        value: value,
                        title: key,
                        assigned_to: {
                            email: "admin@westbury.com",
                            type: "recipient"
                        }
                    };
                });
                var PDdocs = [
                    {
                        name: "Membership Form [ADAMI]",
                        uuid: "VFxqARh3yB48Snj7rkdPMR"
                    }
                ];
                $b22b3ebcec7a7ec8$var$documentData.template_uuid = "VFxqARh3yB48Snj7rkdPMR";
                $b22b3ebcec7a7ec8$var$documentData.name = "Membership Form [ADAMI]";
                sendDocument($b22b3ebcec7a7ec8$var$documentData);
            }
            const societies = await api.listSocieties({
                userId: clientId
            }).then((societies)=>{
                console.log(societies);
                return Promise.all(societies.map((society)=>{
                    return api.listSocietyForms({
                        userId: clientId,
                        societyId: society.id
                    });
                }));
            });
            for await (const forms of societies){
                /**
         * @todo Handle multiple forms for same society?
         */ const form = forms[0];
                console.log(form);
                Object.entries(form.prepopulatedData).forEach(([key, value])=>{
                    if (!Object.hasOwn($b22b3ebcec7a7ec8$var$documentData.fields, key)) return;
                    $b22b3ebcec7a7ec8$var$documentData.fields[key].value = value;
                });
            }
        } catch  {}
        documentID;
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        clientId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c17184070610a5f4$export$2e2bcd8739ae039), {
        show: show,
        onHide: modalClose,
        className: "AgreementModal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                className: "ModalClose",
                onClick: modalClose,
                children: "close"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c17184070610a5f4$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "AgreementModalData",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "agreementHeader d-none",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "d-flex justify-content-end modalTopButtons",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "sign-btn btn",
                                        children: "Sign"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "send-to-btn btn",
                                        children: "Send to Society"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: (0, (/*@__PURE__*/$parcel$interopDefault($33904babfb68cee8$exports))),
                                        className: "btn download-btn",
                                        download: true,
                                        children: "Download"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "modalDocument",
                            children: documentID ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                    src: `https://app.pandadoc.com/s/${documentID}`,
                                    width: "100%",
                                    height: "720px"
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        paddingLeft: "20px"
                                    },
                                    children: "Loading PDF..."
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $b22b3ebcec7a7ec8$export$2e2bcd8739ae039 = $b22b3ebcec7a7ec8$var$MembershipFormModal;






const $c962736a82687da2$export$c71c3a205c92eaf4 = ({ percentage: percentage, label: label })=>{
    return(//  Container for the progress bar
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-relative tw-w-full",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "tw-pb-2 tw-block tw-text-textWhite tw-text-xs",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "tw-block tw-bg-surfaceBlack80 tw-h-[4px] tw-relative",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-absolute tw-h-full tw-bg-westburyBlue",
                    style: {
                        maxWidth: `${percentage}%`,
                        width: `${percentage}%`
                    }
                })
            })
        ]
    }));
};




var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");

const $21d4a02adca8bc4b$var$defaultTitle = "Thank You";
const $21d4a02adca8bc4b$var$defaultDescription = "A member of our team will verify your information and you will receive an email shortly";
const $21d4a02adca8bc4b$export$ee4c491770af59bd = ({ title: title = $21d4a02adca8bc4b$var$defaultTitle, description: description = $21d4a02adca8bc4b$var$defaultDescription, cta: cta })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `tw-flex tw-flex-col tw-items-center tw-w-[400px] ${cta === undefined ? "tw-mb-12" : "tw-mb-4"}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-mt-4 tw-mb-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                    className: "wi wi-verification-check-filled tw-w-20 tw-h-20 tw-text-formOutlineSuccessGreen"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-white tw-text-2xl tw-mt-2 tw-text-center",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-md tw-text-center tw-mt-2 tw-font-light",
                children: description
            }),
            cta != undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-mt-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "primary-lg",
                    label: cta.ctaText,
                    onClick: cta.onClick
                })
            })
        ]
    });
};
var $21d4a02adca8bc4b$export$2e2bcd8739ae039 = $21d4a02adca8bc4b$export$ee4c491770af59bd;




parcelRequire("acw62");

parcelRequire("acw62");
function $5de6ec63797dfad7$var$AgreementModalPage({ pageIndex: pageIndex, selectedPageIndex: selectedPageIndex, children: children, loading: loading }) {
    const getClassName = ()=>{
        if (pageIndex === selectedPageIndex) return loading ? "tw-hidden" : "";
        return "tw-hidden";
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: getClassName(),
        children: children
    });
}
var $5de6ec63797dfad7$export$2e2bcd8739ae039 = $5de6ec63797dfad7$var$AgreementModalPage;



parcelRequire("acw62");
function $ccc269c1cbba2785$var$AgreementModalIFrame({ documentId: documentId, title: title, style: style = {
    width: "70vw",
    height: "75vh"
} }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
        style: style,
        title: title,
        src: `https://app.pandadoc.com/s/${documentId}`
    });
}
var $ccc269c1cbba2785$export$2e2bcd8739ae039 = $ccc269c1cbba2785$var$AgreementModalIFrame;


function $05f18ed57e2d0baa$var$PandadocPage({ index: index, sessionId: sessionId, selectedPageIndex: selectedPageIndex, isLoading: isLoading, iFrameStyle: iFrameStyle }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5de6ec63797dfad7$export$2e2bcd8739ae039), {
        pageIndex: index + 1,
        selectedPageIndex: selectedPageIndex,
        loading: isLoading,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: sessionId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccc269c1cbba2785$export$2e2bcd8739ae039), {
                documentId: sessionId,
                title: `pandadocs_iframe_${index}`,
                style: iFrameStyle ?? undefined
            }) : ""
        })
    }, index);
}
var $05f18ed57e2d0baa$export$2e2bcd8739ae039 = $05f18ed57e2d0baa$var$PandadocPage;


function $7b197397a08acaa0$var$ApproveWestburyForms(props) {
    const [pandadocsDocumentIds, setPandadocsDocumentIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [showSuccessModal, setShowSuccessModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [selectedPageIndex, setSelectedPageIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [formsApproved, setFormsApproved] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const fetchData = async ()=>{
        if (!clientId) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("no client id"));
            return;
        }
        try {
            setIsLoading(true);
            let data = await api.listClientSocietyFormTasks({
                userId: clientId
            });
            data = data.filter((item)=>item.status === "admin_to_approve");
            // set power of attorney as the second document
            data.sort((a, b)=>{
                if (a.societyFormName?.toLowerCase().includes("power")) return 1;
                return -1;
            });
            setPandadocsDocumentIds(data.map((item)=>{
                return {
                    sessionId: item.pandadocsSessionId,
                    documentName: item.societyFormName,
                    documentId: item.id
                };
            }));
        } catch (error) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("error fetching pandadocs document ids"));
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        clientId
    ]);
    const acceptForms = async ()=>{
        setIsLoading(true);
        pandadocsDocumentIds.map(async (item)=>{
            if (!item.sessionId || !clientId || !item.documentId) return;
            try {
                await api.approveAdminApproveIdentityDocument({
                    documentId: item.documentId,
                    userId: clientId,
                    dateOfBirth: "",
                    documentNumber: "",
                    documentExpiryDate: ""
                });
                setIsLoading(false);
                setShowSuccessModal(true);
                setFormsApproved(true);
            } catch  {
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)(`error approving ${item.documentName}`));
                setIsLoading(false);
            }
        });
    };
    const rejectForms = async ()=>{
    // TODO: add reject functionality
    };
    window.addEventListener("message", (event)=>{
        const type = event.data && event.data.type;
        switch(type){
            case "session_view.document.loaded":
                if (isLoading) setIsLoading(false);
        }
    });
    const passportFileLocationFileExtension = props.passportFileLocation.split("?")[0].split(".").pop();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: formsApproved,
                onClose: ()=>props.setApproveWestburyForms(false),
                title: "",
                disableBackdropClick: true,
                hasCloseButton: false,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
                    title: "Forms Approved",
                    description: "You have successfully approved the forms.",
                    cta: {
                        ctaText: "Return to Dashboard",
                        onClick: ()=>{
                            props.setApproveWestburyForms(false);
                            props.fetchTasks();
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "tw-mb-4",
                children: "Verify Signature"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-w-full tw-p-5 tw-mt-2 tw-space-x-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-w-1/2 tw-p-4 tw-bg-surfaceBlack90 tw-rounded-2 tw-text-white tw-rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-mb-2",
                                children: "Passport Image"
                            }),
                            passportFileLocationFileExtension?.toLocaleLowerCase() == "pdf" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("embed", {
                                src: props.passportFileLocation,
                                type: "application/pdf",
                                className: "passportImg",
                                height: "100%",
                                width: "100%"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: props.passportFileLocation,
                                alt: "passport",
                                className: "passportImg"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-w-1/2 tw-p-4 tw-bg-surfaceBlack90 tw-rounded-2 tw-text-white tw-rounded-lg",
                        children: [
                            isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-items-center tw-justify-center",
                                style: {
                                    height: "100%"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-my-auto tw-animate-ping",
                                    children: "\u26AA"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: isLoading ? "invisible" : "tw-flex tw-flex-row tw-mb-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7b197397a08acaa0$export$557f2efec1a816eb, {
                                    pandadocDocumentIds: pandadocsDocumentIds,
                                    setSelectedPageIndex: setSelectedPageIndex,
                                    selectedPageIndex: selectedPageIndex
                                })
                            }),
                            pandadocsDocumentIds.map(({ sessionId: documentId }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05f18ed57e2d0baa$export$2e2bcd8739ae039), {
                                    index: index,
                                    sessionId: documentId,
                                    selectedPageIndex: selectedPageIndex,
                                    isLoading: isLoading,
                                    iFrameStyle: {
                                        width: "37vw",
                                        height: "70vh"
                                    }
                                }, index)),
                            !isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-justify-end tw-space-x-2 tw-mt-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        onClick: acceptForms,
                                        variant: "primary",
                                        label: "Accept"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        onClick: rejectForms,
                                        variant: "secondary",
                                        disabled: true,
                                        label: "Decline"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $7b197397a08acaa0$export$557f2efec1a816eb = ({ pandadocDocumentIds: pandadocDocumentIds, setSelectedPageIndex: setSelectedPageIndex, selectedPageIndex: selectedPageIndex })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-border-b-[1px] tw-border-surfaceGraphite tw-space-x-4 tw-w-full",
        style: {
            paddingBottom: "18px"
        },
        children: pandadocDocumentIds.map((tab, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                role: "button",
                className: `
      tw-pb-4
      ${selectedPageIndex === index + 1 ? "tw-border-b-[4px] tw-border-textLime tw-text-textLime tw-cursor-pointer" : "tw-text-textDove tw-font-light tw-text-4 tw-cursor-pointer"}
    `,
                onClick: ()=>{
                    setSelectedPageIndex(index + 1);
                },
                children: tab.documentName?.includes("Power") ? "Power of Attorney" : "Client Mandate"
            }, index))
    });
};
var $7b197397a08acaa0$export$2e2bcd8739ae039 = $7b197397a08acaa0$var$ApproveWestburyForms;






var $acw62 = parcelRequire("acw62");








const $b1a0522b32fc01dc$export$4b7fabacb7d8881a = ({ selected: selected, onClick: onClick })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `tw-w-2.5 tw-h-2.5 tw-rounded-full tw-mr-1 ${selected ? "tw-bg-surfaceLime" : "tw-bg-textDove"}`,
        onClick: onClick
    });





var $acw62 = parcelRequire("acw62");


function $1fb6a236a0f605d2$var$PassportAndForms({ passportFileLocation: passportFileLocation, onApprove: onApprove, onDecline: onDecline, isLoading: isLoading, pandadocsDocumentIds: pandadocsDocumentIds, setDocumentInViewId: setDocumentInViewId = ()=>{} }) {
    const [selectedPageIndex, setSelectedPageIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const passportFileLocationFileExtension = passportFileLocation.split("?")[0].split(".").pop();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-w-full tw-p-5 tw-mt-2 tw-space-x-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-w-1/2 tw-p-4 tw-bg-surfaceBlack90 tw-rounded-2 tw-text-white tw-rounded-lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-mb-2",
                        children: "Passport Image"
                    }),
                    passportFileLocationFileExtension?.toLocaleLowerCase() == "pdf" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("embed", {
                        src: passportFileLocation,
                        type: "application/pdf",
                        className: "passportImg",
                        height: "100%",
                        width: "100%"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: passportFileLocation,
                        alt: "passport",
                        className: "passportImg"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-w-1/2 tw-p-4 tw-bg-surfaceBlack90 tw-rounded-2 tw-text-white tw-rounded-lg",
                children: [
                    isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-items-center tw-justify-center",
                        style: {
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-my-auto tw-animate-ping",
                            children: "\u26AA"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: isLoading ? "invisible" : "tw-flex tw-flex-row tw-justify-center tw-mb-2",
                        children: pandadocsDocumentIds.map(({ documentId: documentId }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b1a0522b32fc01dc$export$4b7fabacb7d8881a), {
                                selected: selectedPageIndex === index + 1,
                                onClick: ()=>{
                                    setSelectedPageIndex(index + 1);
                                    setDocumentInViewId(documentId);
                                }
                            }, index))
                    }),
                    pandadocsDocumentIds.map(({ sessionId: documentId }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05f18ed57e2d0baa$export$2e2bcd8739ae039), {
                            index: index,
                            sessionId: documentId,
                            selectedPageIndex: selectedPageIndex,
                            isLoading: isLoading,
                            iFrameStyle: {
                                width: "37vw",
                                height: "70vh"
                            }
                        }, index)),
                    !isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-justify-end tw-space-x-2 tw-mt-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                onClick: onApprove,
                                variant: "primary",
                                label: "Accept"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                onClick: onDecline,
                                variant: "secondary",
                                disabled: true,
                                label: "Decline"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $1fb6a236a0f605d2$export$2e2bcd8739ae039 = $1fb6a236a0f605d2$var$PassportAndForms;


function $87b8afb9b402334d$var$ApproveMembershipForms(props) {
    const [pandadocsDocumentIds, setPandadocsDocumentIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [formsApproved, setFormsApproved] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const passportFileLocationFileExtension = props.passportFileLocation.split("?")[0].split(".").pop();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [documentInViewId, setDocumentInViewId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [membershipForms, setMembershipForms] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [clientSocietyFormTasks, setClientSocietyFormTasks] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const fetchData = async ()=>{
        if (!clientId) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("no client id"));
            return;
        }
        try {
            setIsLoading(true);
            let clientFormTasks = await api.listClientSocietyFormTasks({
                userId: clientId
            });
            clientFormTasks = clientFormTasks.filter((item)=>item.status === "admin_to_approve");
            let membershipForms = await api.listMembershipForms({
                userId: clientId
            });
            setClientSocietyFormTasks(clientFormTasks);
            setMembershipForms(membershipForms);
        } catch (error) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("error fetching pandadocs document ids"));
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        clientId
    ]);
    (0, $acw62.useEffect)(()=>{
        setPandadocsDocumentIds(clientSocietyFormTasks.map((item)=>{
            return {
                sessionId: item.pandadocsSessionId,
                documentName: item.societyFormName,
                documentId: item.pandadocsDocumentId
            };
        }));
        setDocumentInViewId(clientSocietyFormTasks[0]?.pandadocsDocumentId);
    }, [
        clientSocietyFormTasks
    ]);
    const acceptForm = async ()=>{
        setIsLoading(true);
        let membershipForm = membershipForms.find((item)=>item.pandadocsDocumentId === documentInViewId);
        try {
            api.adminApproveMembershipForms({
                formId: membershipForm?.id ?? "",
                membershipForms: {
                    user: clientId,
                    societyForm: membershipForm?.societyForm ?? ""
                }
            });
            // remove client task from ClientSocietyFormTasks
            let clientSocietyFormTasksCopy = [
                ...clientSocietyFormTasks
            ];
            clientSocietyFormTasksCopy = clientSocietyFormTasksCopy.filter((item)=>item.pandadocsDocumentId !== documentInViewId);
            if (clientSocietyFormTasksCopy.length === 0) {
                // forms complete - delete task and show modal
                setFormsApproved(true);
                api.destroyAdminTaskClient({
                    taskId: props.taskId
                });
            }
            setClientSocietyFormTasks(clientSocietyFormTasksCopy);
        } catch (error) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("error approving form"));
        }
    };
    const rejectForm = async ()=>{
    // TODO: add reject functionality
    };
    window.addEventListener("message", (event)=>{
        const type = event.data && event.data.type;
        switch(type){
            case "session_view.document.loaded":
                if (isLoading) setIsLoading(false);
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: formsApproved,
                onClose: ()=>props.setApproveMembershipForms(false),
                title: "",
                disableBackdropClick: true,
                hasCloseButton: false,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
                    title: "Forms Approved",
                    description: "You have successfully approved the forms.",
                    cta: {
                        ctaText: "Return to Dashboard",
                        onClick: ()=>{
                            props.setApproveMembershipForms(false);
                            props.fetchTasks();
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "tw-mb-4",
                children: "Verify Signature"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fb6a236a0f605d2$export$2e2bcd8739ae039), {
                passportFileLocation: props.passportFileLocation,
                onApprove: acceptForm,
                onDecline: rejectForm,
                isLoading: isLoading,
                setIsLoading: setIsLoading,
                pandadocsDocumentIds: pandadocsDocumentIds,
                setDocumentInViewId: setDocumentInViewId
            })
        ]
    });
}
var $87b8afb9b402334d$export$2e2bcd8739ae039 = $87b8afb9b402334d$var$ApproveMembershipForms;


var $90f256c567e4c320$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($90f256c567e4c320$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $90f256c567e4c320$exports = g;
});


function $8dfa623bddb7aaec$var$DashboardDetails() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [registerUsers, setRegisterUsers] = (0, $acw62.useState)(75);
    const [verifyPassport, setVerifyPassport] = (0, $acw62.useState)(false);
    const [showDeclineMessage, setShowDeclineMessage] = (0, $acw62.useState)(false);
    const [passportId, setPassportId] = (0, $acw62.useState)("");
    const [passportDateOfBirth, setPassportDateOfBirth] = (0, $acw62.useState)("");
    const [passportNumber, setPassportNumber] = (0, $acw62.useState)("");
    const [passportExpiryDate, setPassportExpiryDate] = (0, $acw62.useState)("");
    const [passportFileLocation, setPassportFileLocation] = (0, $acw62.useState)("");
    const [clientTasks, setClientTasks] = (0, $acw62.useState)([]);
    const [clientList, setClientList] = (0, $acw62.useState)([]);
    const [taskId, setTaskId] = (0, $acw62.useState)("");
    const [continueButtonDisabled, setContinueButtonDisabled] = (0, $acw62.useState)(true);
    const [eoiReviewID, setEoiReviewID] = (0, $acw62.useState)("");
    const [DiscographyID, setDiscographyID] = (0, $acw62.useState)();
    const [showEOIcard, setShowEOIcard] = (0, $acw62.useState)(false);
    const [showDiscographyIDcard, setShowDiscographyIDcard] = (0, $acw62.useState)(false);
    const [membershipForm, setMembershipForm] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const handleMembershipForm = ()=>{
        setMembershipForm(!membershipForm);
    };
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const things_to_do_status = new Map([
        [
            "verify_passport_and_send_forms",
            "Verify passport and send forms"
        ],
        [
            "expression_of_interest_review",
            "Review EOI form"
        ],
        [
            "submit_discography_id",
            "EOI Submitted. Enter discography ID\u2019s"
        ],
        [
            "sign_society_form",
            "Send membership forms"
        ],
        [
            "approve_westbury_forms",
            "Review signed WMC forms"
        ],
        [
            "approve_membership_forms",
            "Review signed society membership forms"
        ],
        [
            "download_primary_discography_export",
            "Download exported discography"
        ],
        [
            "download_ppl_review_export",
            "Download PPL review export"
        ]
    ]);
    const { clientId: clientId, setClientId: setClientId, setClientEmail: setClientEmail } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [approveWestburyForms, setApproveWestburyForms] = (0, $acw62.useState)(false);
    const [approveMembershipForms, setApproveMembershipForms] = (0, $acw62.useState)(false);
    const fetchData = ()=>{
        setIsLoading(true);
        api.listUsers().then((clients)=>{
            console.log("clients", clients);
            setClientList(// set image to empty string pending backend implementation
            clients.map((client)=>{
                return {
                    ...client,
                    image: ""
                };
            }));
            api.listAdminTaskClients().then((adminClientTasks)=>{
                const mergedData = [];
                const clientIds = [];
                adminClientTasks.forEach((clientTask)=>{
                    const mergedTask = $8dfa623bddb7aaec$var$clientTaskToMergedClientTask(clientTask);
                    mergedData.push(mergedTask);
                    clientIds.push(mergedTask.id?.toString());
                });
                setClientTasks(mergedData);
                setIsLoading(false);
            }).catch(()=>{
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong"));
                setIsLoading(false);
            });
        }).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong"));
            setIsLoading(false);
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    const acceptPassport = ()=>{
        if (clientId === undefined) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong"));
            return Promise.reject();
        }
        return api.approveAdminApproveIdentityDocument({
            userId: clientId,
            documentId: passportId,
            dateOfBirth: passportDateOfBirth,
            documentNumber: passportNumber,
            documentExpiryDate: passportExpiryDate
        }).then((response)=>{
            setPassportDateOfBirth("");
            setPassportNumber("");
            setPassportExpiryDate("");
            navigate(`/terms-of-agreement/${clientId}`, {
                state: {
                    taskId: taskId
                }
            });
            return Promise.resolve(response);
        }).catch((error)=>{
            setPassportDateOfBirth("");
            setPassportNumber("");
            setPassportExpiryDate("");
            return Promise.reject();
        });
    };
    const declineMessage = ()=>{
        if (clientId === undefined) return;
        setVerifyPassport(false);
        setPassportDateOfBirth("");
        setPassportNumber("");
        setPassportExpiryDate("");
        setShowDeclineMessage(true);
        api.declineAdminDeclineIdentityDocument({
            userId: clientId,
            documentId: passportId
        }).then(()=>{
            api.destroyAdminTaskClient({
                taskId: taskId
            });
        }).catch(()=>{});
    };
    const deleteTaskOnConfirmed = ()=>{
        api.destroyAdminTaskClient({
            taskId: taskId
        }).then(()=>{
            fetchData();
            setShowEOIcard(false);
        }).catch(()=>{});
    };
    const handleThingsToDoStatusClick = async (clientId, clientUsername, task)=>{
        setClientEmail(clientUsername);
        setClientId(clientId);
        setTaskId(task.id);
        const clientTaskStatus = task.status;
        if (clientTaskStatus == "verify_passport_and_send_forms") {
            api.listAdminIdentityDocumentSubmissions({
                userId: clientId
            }).then((response)=>{
                response.forEach((document1)=>{
                    if (document1.documentType === "Passport") {
                        setPassportId(document1.id);
                        setPassportFileLocation(document1.fileUrl);
                    }
                });
            });
            setVerifyPassport(true);
        } else if (clientTaskStatus == "expression_of_interest_review") {
            showCard();
            setEoiReviewID(clientId);
            setShowEOIcard(true);
        } else if (clientTaskStatus == "submit_discography_id") {
            showCard();
            setDiscographyID(clientId);
            setShowDiscographyIDcard(true);
        } else if (clientTaskStatus == "sign_society_form") navigate(`/society-forms/${clientId}`, {
            state: {
                taskId: task.id
            }
        });
        else if (clientTaskStatus == "approve_westbury_forms") {
            api.listAdminIdentityDocumentSubmissions({
                userId: clientId
            }).then((response)=>{
                response.forEach((document1)=>{
                    if (document1.documentType === "Passport") {
                        setPassportId(document1.id);
                        setPassportFileLocation(document1.fileUrl);
                    }
                });
            });
            setApproveWestburyForms(true);
        } else if (clientTaskStatus == "approve_membership_forms") {
            api.listAdminIdentityDocumentSubmissions({
                userId: clientId
            }).then((response)=>{
                response.forEach((document1)=>{
                    if (document1.documentType === "Passport") {
                        setPassportId(document1.id);
                        setPassportFileLocation(document1.fileUrl);
                    }
                });
            });
            setApproveMembershipForms(true);
        } else if (clientTaskStatus == "download_primary_discography_export") {
            if (!task.primaryDiscographyExport) return;
            api.retrievePrimaryDiscographyExport({
                userId: clientId,
                exportId: task.primaryDiscographyExport
            }).then((primaryDiscographyExport)=>{
                const url = primaryDiscographyExport.s3Url;
                if (!url) return;
                const pathComponents = new URL(url).pathname.split("/");
                const fileName = decodeURIComponent(pathComponents.pop() ?? "export.xlsx");
                return fetch(url).then(async (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($90f256c567e4c320$exports)))(await response.blob(), fileName));
            }).then(()=>{
                return api.destroyAdminTaskClient({
                    taskId: task.id
                });
            }).then(()=>fetchData()).catch(()=>{
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong"));
            });
        } else if (clientTaskStatus == "download_ppl_review_export") {
            if (!task.pplReviewExport) return;
            const pplPerformerName = await api.retrieveUserSettings({
                userId: clientId
            }).then((userSettings)=>userSettings.pplPerformerName).catch(()=>{});
            api.retrievePPLReviewExport({
                userId: clientId,
                exportId: task.pplReviewExport
            }).then((pplReviewExport)=>{
                const url = pplReviewExport.s3Url;
                if (!url) return;
                let fileName = "export.xlsx";
                if (pplPerformerName) fileName = `PPL Review \u{2013} ${pplPerformerName}.xlsx`;
                return fetch(url).then(async (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($90f256c567e4c320$exports)))(await response.blob(), fileName));
            }).then(()=>{
                return api.destroyAdminTaskClient({
                    taskId: task.id
                });
            }).then(()=>fetchData()).catch(()=>{
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong"));
            });
        }
    };
    const handleDiscographyRunComplete = ()=>{
        fetchData();
    };
    const rawData = clientTasks.filter((clientTask)=>{
        if (clientList.some((client)=>Number(client.userId ?? 0) === Number(clientTask.id ?? 0) && client.nonClient === true)) return false;
        return true;
    }).flatMap((clientTask)=>{
        const [onboardingTasks, exportDownloadTasks] = clientTask.clientAdminTasks.reduce((acc, task)=>{
            const i = task.status === (0, $898e32c31d9fa843$export$ff7beaaf5b39d2a4).DownloadPrimaryDiscographyExport || task.status === (0, $898e32c31d9fa843$export$ff7beaaf5b39d2a4).DownloadPplReviewExport ? 1 : 0;
            acc[i].push(task);
            return acc;
        }, [
            [],
            []
        ]);
        return [
            ...onboardingTasks.slice(0, 1),
            ...exportDownloadTasks
        ].map((task)=>{
            return {
                artist: clientTask.fullName ?? clientTask.username,
                action: things_to_do_status.get(task.status ?? ""),
                dateCreated: task.dateCreated,
                progress: 3 / 8 * 100
            };
        });
    });
    const tableData = clientTasks.filter((clientTask)=>{
        if (clientList.some((client)=>Number(client.userId ?? 0) === Number(clientTask.id ?? 0) && client.nonClient === true)) return false;
        return true;
    }).flatMap((clientTask)=>{
        const [onboardingTasks, exportDownloadTasks] = clientTask.clientAdminTasks.reduce((acc, task)=>{
            const i = task.status === (0, $898e32c31d9fa843$export$ff7beaaf5b39d2a4).DownloadPrimaryDiscographyExport || task.status === (0, $898e32c31d9fa843$export$ff7beaaf5b39d2a4).DownloadPplReviewExport ? 1 : 0;
            acc[i].push(task);
            return acc;
        }, [
            [],
            []
        ]);
        return [
            ...onboardingTasks.slice(0, 1),
            ...exportDownloadTasks
        ].map((task)=>{
            return {
                artist: clientTask.fullName ?? clientTask.username,
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "button",
                    tabIndex: 0,
                    onClick: ()=>handleThingsToDoStatusClick(clientTask.id.toString(), clientTask.username.toString(), task),
                    onKeyPress: (e)=>{
                        if (e.key === "Enter") handleThingsToDoStatusClick(clientTask.id.toString(), clientTask.username.toString(), task);
                    },
                    children: things_to_do_status.get(task.status ?? "")
                }),
                dateCreated: task.dateCreated?.toLocaleDateString().toString() || "-",
                progress: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c962736a82687da2$export$c71c3a205c92eaf4), {
                    percentage: 3 / 8 * 100,
                    label: "Registered at 3 out of 8 "
                })
            };
        });
    });
    const showCard = (0, $acw62.useCallback)(()=>{
        document.body.classList.add("hide-scroll");
    }, []);
    const hideCard = (0, $acw62.useCallback)(()=>{
        document.body.classList.remove("hide-scroll");
        setShowEOIcard(false);
        setShowDiscographyIDcard(false);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            membershipForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b22b3ebcec7a7ec8$export$2e2bcd8739ae039), {
                showModal: membershipForm,
                modalClose: handleMembershipForm,
                clientId: clientId?.toString()
            }) : "",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41b3017e16d4d38e$export$2e2bcd8739ae039), {
                deleteTaskOnConfirmed: deleteTaskOnConfirmed,
                onComplete: ()=>{
                    setShowEOIcard(false);
                    fetchData();
                },
                cardEvent: hideCard,
                eoiReviewID: eoiReviewID,
                isOpen: showEOIcard
            }),
            showDiscographyIDcard ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d3075243f034f38$export$2e2bcd8739ae039), {
                onClose: hideCard,
                onComplete: handleDiscographyRunComplete,
                isOpen: showDiscographyIDcard,
                onUserSettingsUpdated: ()=>{
                    fetchData();
                }
            }) : null,
            verifyPassport ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8027e0c1918401fd$export$2e2bcd8739ae039), {
                        setPassportDateOfBirth: setPassportDateOfBirth,
                        setPassportNumber: setPassportNumber,
                        setPassportExpiryDate: setPassportExpiryDate,
                        setVerifyPassport: setVerifyPassport,
                        hideVerification: setVerifyPassport,
                        declineMessage: declineMessage,
                        acceptPassport: acceptPassport,
                        passportFileLocation: passportFileLocation,
                        clientTasks: clientTasks,
                        taskId: taskId,
                        continueButtonDisabled: continueButtonDisabled,
                        passportDateOfBirth: passportDateOfBirth,
                        passportNumber: passportNumber,
                        passportExpiryDate: passportExpiryDate
                    }),
                    " "
                ]
            }) : showDeclineMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa8b665f3163a5b2$export$2e2bcd8739ae039), {
                setShowDeclineMessage: setShowDeclineMessage,
                declineMessage: declineMessage
            }) : approveWestburyForms ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/dashboard",
                        onClick: ()=>setApproveWestburyForms(false),
                        className: "back-button tw-text-white",
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b197397a08acaa0$export$2e2bcd8739ae039), {
                        passportFileLocation: passportFileLocation,
                        taskId: taskId,
                        setApproveWestburyForms: setApproveWestburyForms,
                        fetchTasks: fetchData
                    })
                ]
            }) : approveMembershipForms ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/dashboard",
                        onClick: ()=>setApproveMembershipForms(false),
                        className: "back-button tw-text-white",
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87b8afb9b402334d$export$2e2bcd8739ae039), {
                        passportFileLocation: passportFileLocation,
                        taskId: taskId,
                        setApproveMembershipForms: setApproveMembershipForms,
                        fetchTasks: fetchData
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "tw-text-page-heading tw-text-white tw-mb-4",
                        children: "Membership Dashboard"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-w-full tw-space-x-6 tw-max-w-[1500px]",
                        style: {
                            maxWidth: "1584px",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                                extraClasses: "tw-min-w-[302px] tw-flex tw-flex-col tw-justify-between",
                                disabled: true,
                                title: "Users Registered",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-uppercase tw-text-sm",
                                            children: "Users registered"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a6180f04a3e64cf$export$553fd01770b02e7e), {
                                        value: registerUsers,
                                        text: "of all users registered"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-text-right",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            className: "viewLink",
                                            children: "View"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                                extraClasses: "tw-flex-grow tw-overflow-scroll tw-scrollbar-none",
                                disabled: true,
                                title: "Society Overview",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-uppercase tw-text-sm tw-pb-2",
                                            children: "Society overview"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-overflow-x-scroll tw-overflow-scroll tw-scrollbar-none",
                                        style: {},
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $662f9e853a36449a$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "dsCol mt-4 pt-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: " tw-text-white tw-flex tw-justify-between",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "tw-font-sans tw-text-xl tw-font-semibold",
                                    children: "Tasks"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                                children: [
                                    !isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$e2595d8541f6e8ef), {
                                        columnStyle: {
                                            borderBottom: "none",
                                            padding: "0px"
                                        },
                                        columns: [
                                            {
                                                title: "Artist",
                                                dataKey: "artist",
                                                sort: true
                                            },
                                            {
                                                title: "Action",
                                                dataKey: "action",
                                                sort: true
                                            },
                                            {
                                                title: "Date Added",
                                                dataKey: "dateCreated",
                                                sort: true
                                            }
                                        ],
                                        data: tableData,
                                        rawData: rawData
                                    }),
                                    isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-flex tw-justify-center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "tw-my-auto tw-animate-ping",
                                            children: "\u26AA"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $8dfa623bddb7aaec$export$2e2bcd8739ae039 = $8dfa623bddb7aaec$var$DashboardDetails;
const $8dfa623bddb7aaec$var$clientTaskToMergedClientTask = (clientTask)=>{
    const obj = {
        id: clientTask.id?.toString(),
        fullName: clientTask.fullName,
        username: clientTask.username,
        clientAdminTasks: clientTask.clientAdminTasks.map((task)=>{
            const primaryDiscographyExport = clientTask.primaryDiscographyExports?.find((primaryDiscographyExport)=>primaryDiscographyExport.task === task.id);
            const pplReviewExport = clientTask.pplReviewExports?.find((pplReviewExport)=>pplReviewExport.task === task.id);
            return {
                id: task.id,
                status: task.status,
                primaryDiscographyExport: primaryDiscographyExport?.id,
                pplReviewExport: pplReviewExport?.id,
                dateCreated: task.dateCreated || new Date()
            };
        })
    };
    return obj;
};




var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");




parcelRequire("acw62");
const $7de95e61b2f57784$export$ff017f8de3390e84 = ({ to: to, label: label, icon: icon = "", onClick: onClick = ()=>{}, variant: variant = "primary", additionalPaths: additionalPaths, compact: compact = false })=>{
    const currentPath = location.pathname;
    const isAdditionalPath = additionalPaths != undefined ? additionalPaths.some((path)=>currentPath.includes(path)) : false;
    // regex to test if current path is the same as the link path
    const isCurrentPage = new RegExp(`^${to}$`).test(currentPath);
    const classes = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
        "tw-text-textLime": (isCurrentPage || isAdditionalPath) && variant !== "disabled"
    }, {
        "tw-text-textWhite": !isCurrentPage && !isAdditionalPath && variant !== "disabled"
    }, {
        "tw-text-textDove": variant === "disabled"
    }, {
        "tw-cursor-not-allowed": variant === "disabled"
    }, {
        "tw-cursor-pointer": variant !== "disabled"
    }, "tw-hover:text-textLime");
    const toInner = variant === "disabled" ? "#" : to;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
            to: toInner,
            onClick: ()=>{
                if (variant === "disabled") return;
                onClick();
            },
            title: compact ? label : undefined,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-space-x-2", compact && "tw-justify-center tw-space-x-0"),
                children: [
                    icon != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi", "wi-sm", "wi-" + icon, {
                            "tw-text-textLime": (isCurrentPage || isAdditionalPath) && variant !== "disabled"
                        }, {
                            "tw-text-textWhite": !isCurrentPage && !isAdditionalPath && variant !== "disabled"
                        }, {
                            "tw-text-textDove": variant === "disabled"
                        }, {
                            "tw-cursor-not-allowed": variant === "disabled"
                        }, {
                            "tw-cursor-pointer": variant !== "disabled"
                        })
                    }),
                    !compact && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: classes,
                        children: label
                    })
                ]
            })
        })
    });
};







var $acw62 = parcelRequire("acw62");
// DropdownContent.tsx

parcelRequire("acw62");

const $c7dae8c979502917$export$94dc7897c0ce1424 = ({ content: content })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-surfaceBlack90", "tw-rounded-[16px]", "tw-p-2", "tw-text-white"),
        style: {
            boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.50)"
        },
        children: content
    });
};
var $c7dae8c979502917$export$2e2bcd8739ae039 = $c7dae8c979502917$export$94dc7897c0ce1424;


const $8f48ae8c4ad4b8a8$var$WDropdown = ({ trigger: trigger, content: content })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const dropdownRef = (0, $acw62.useRef)(null);
    const toggleDropdown = ()=>{
        setIsOpen(!isOpen);
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        // important to clean up event listener when component unmounts
        if (isOpen) document.addEventListener("click", handleClickOutside);
        else document.removeEventListener("click", handleClickOutside);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-relative",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "button",
                tabIndex: 0,
                onClick: toggleDropdown,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === "Space") toggleDropdown();
                },
                className: "tw-cursor-pointer",
                children: trigger
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-absolute tw-top-full tw-pt-4 tw-z-50 tw-right-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c7dae8c979502917$export$2e2bcd8739ae039), {
                    content: content
                })
            })
        ]
    });
};
var $8f48ae8c4ad4b8a8$export$2e2bcd8739ae039 = $8f48ae8c4ad4b8a8$var$WDropdown;


var $37e781df277582a4$exports = {};
$37e781df277582a4$exports = new URL("SquarePlaceholder100.55375be1.svg", import.meta.url).toString();


const $5ab845b8dc308a3a$export$8b251419efc915eb = ()=>{
    const user = (0, $bb19b832faf6099b$export$23bbbc4533528f03)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const api = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)().adminApi;
    const handleSignOut = async ()=>{
        try {
            // const refreshToken = getTokenFromSessionStorage()?.refresh;
            // if (!refreshToken) {
            //   return;
            // }
            // await api.createTokenBlacklist({
            //   tokenBlacklist: { refresh: refreshToken },
            // });
            localStorage.removeItem("token");
            sessionStorage.removeItem("token");
            navigate("/");
        } catch (error) {
            console.error("Error during logout", error);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-flex-row tw-justify-end tw-max-w-[1704px] tw-p-6",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f48ae8c4ad4b8a8$export$2e2bcd8739ae039), {
            trigger: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-row tw-items-center tw-text-white tw-justify-start tw-space-x-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Welcome back ",
                            user.firstName
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "tw-rounded-full tw-ml-6 tw-w-[25px]",
                        src: user.imageUrl || (0, (/*@__PURE__*/$parcel$interopDefault($37e781df277582a4$exports))),
                        alt: "profile img"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "wi wi-20px wi-chevron-down"
                    })
                ]
            }),
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-space-y-3 tw-p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-text-sm tw-font-light tw-text-xs",
                        children: "Switch dashboard"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                        label: "Memberships",
                        to: "/dashboard",
                        icon: "users"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                        label: "Discography",
                        variant: "disabled",
                        to: "/discography-dashboard",
                        icon: "speakers"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                        variant: "disabled",
                        label: "Distribution",
                        to: "/distribution-dashboard",
                        icon: "gbp"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        variant: "primary",
                        label: "Sign out",
                        onClick: handleSignOut
                    })
                ]
            })
        })
    });
};
var $5ab845b8dc308a3a$export$2e2bcd8739ae039 = $5ab845b8dc308a3a$export$8b251419efc915eb;



parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
const $edd541b4e0018444$var$NavigationContext = /*#__PURE__*/ (0, $acw62.createContext)({
    selectedDashboardPath: null
});
const $edd541b4e0018444$export$d91daf425539f32f = ({ children: children })=>{
    const [selectedDashboardPath, setSelectedDashboardPath] = (0, $acw62.useState)(()=>window.sessionStorage.getItem("selectedDashboard"));
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    (0, $acw62.useEffect)(()=>{
        if (location.pathname.includes("dashboard")) {
            setSelectedDashboardPath(location.pathname);
            window.sessionStorage.setItem("selectedDashboard", location.pathname);
        }
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($edd541b4e0018444$var$NavigationContext.Provider, {
        value: {
            selectedDashboardPath: selectedDashboardPath
        },
        children: children
    });
};
const $edd541b4e0018444$export$aa84995bf48f6cf0 = ()=>{
    const { selectedDashboardPath: selectedDashboardPath } = (0, $acw62.useContext)($edd541b4e0018444$var$NavigationContext);
    return selectedDashboardPath;
};



/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c31db635520dc385$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $c31db635520dc385$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-left", $c31db635520dc385$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7979593adeba180b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-right", $7979593adeba180b$export$3efd853dbb351e94);



function $c5d8c5b52067dd26$var$Sidebar({ isCollapsed: isCollapsed, onToggle: onToggle }) {
    const selectedDashboardPath = (0, $edd541b4e0018444$export$aa84995bf48f6cf0)();
    const currentPath = location.pathname;
    const isDashboardPage = new RegExp(`^${selectedDashboardPath}$`).test(currentPath);
    const classes = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
        "tw-text-textLime": isDashboardPage
    }, {
        "tw-text-textWhite": !isDashboardPage
    }, "tw-cursor-pointer", "tw-hover:text-textLime", isCollapsed && "tw-sr-only");
    const discographyAdditionalPaths = [
        "registrations",
        "discography"
    ];
    const settingsAdditionalPaths = [
        "society-config"
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-h-full tw-flex tw-flex-col tw-text-white tw-border-r-outlineGraphite",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-p-4", isCollapsed && "tw-px-3 tw-py-4"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-pb-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-justify-between", isCollapsed && "tw-justify-center"),
                            children: [
                                !isCollapsed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($99b5763031ccc1a7$exports))),
                                    alt: "Westbury Music Logo",
                                    width: "151"
                                }),
                                isCollapsed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($99b5763031ccc1a7$exports))),
                                    alt: "Westbury Music",
                                    className: "tw-h-8 tw-w-8 tw-object-contain"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `${selectedDashboardPath}`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-space-x-2", isCollapsed && "tw-justify-center tw-space-x-0"),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi", "wi-sm", "wi-home", {
                                                "tw-text-textLime": isDashboardPage
                                            }, {
                                                "tw-text-textWhite": !isDashboardPage
                                            }, "tw-cursor-pointer")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: classes,
                                            children: "Dashboard"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                label: "Clients",
                                to: "/clients",
                                icon: "users",
                                compact: isCollapsed
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                label: "Discography",
                                to: "/discography",
                                icon: "speakers",
                                additionalPaths: discographyAdditionalPaths,
                                compact: isCollapsed
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                label: "Distribution",
                                to: "/distribution",
                                icon: "gbp",
                                variant: "disabled",
                                compact: isCollapsed
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-border-t tw-border-textGraphite tw-pt-8 tw-space-x-8",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                        label: "Settings",
                                        to: "/settings",
                                        icon: "settings",
                                        additionalPaths: settingsAdditionalPaths,
                                        compact: isCollapsed
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                        label: "Messages",
                                        to: "/messages",
                                        icon: "email",
                                        variant: "disabled",
                                        compact: isCollapsed
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-mt-auto tw-border-t tw-border-textGraphite tw-p-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onToggle,
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-justify-center tw-w-full tw-py-2 tw-rounded tw-text-white tw-bg-transparent hover:tw-bg-white/10 tw-transition-colors", isCollapsed && "tw-justify-center"),
                    title: isCollapsed ? "Expand sidebar" : "Collapse sidebar",
                    "aria-label": isCollapsed ? "Expand sidebar" : "Collapse sidebar",
                    children: isCollapsed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                        className: "tw-h-5 tw-w-5"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                className: "tw-h-5 tw-w-5 tw-mr-1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-sm",
                                children: "Collapse"
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var $c5d8c5b52067dd26$export$2e2bcd8739ae039 = $c5d8c5b52067dd26$var$Sidebar;



parcelRequire("acw62");
// TODO: add hrefs to all icons and links
function $f92545aa51ff06d8$var$Footer() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
        className: "tw-flex tw-h-[269px] tw-justify-start tw-space-x-10 tw-bg-surfaceBlack90 tw-p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-start tw-p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-white tw-text-md tw-mb-4",
                        children: "Westbury Music Consultants"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-space-x-3 tw-mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-facebook"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-twitter"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://www.linkedin.com/company/westbury-music/about/",
                                target: "blank",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-linkedin tw-text-white"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-list-none tw-mt-3 tw-font-light tw-space-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Contact Us"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Privacy Policy"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Cookie Policy"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Terms & Conditions"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Modern Slavery Act"
                        })
                    })
                ]
            })
        ]
    });
}
var $f92545aa51ff06d8$export$2e2bcd8739ae039 = $f92545aa51ff06d8$var$Footer;




var $acw62 = parcelRequire("acw62");





const $359cbc7644cdeaa3$var$SHOW_DEV_TOOLS = false;
function $359cbc7644cdeaa3$export$2b636689b2802601() {
    const [modalOpen, setModalOpen] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(null);
    const [lastResponse, setLastResponse] = (0, $acw62.useState)(null);
    const [parentRecordingIdInput, setParentRecordingIdInput] = (0, $acw62.useState)("");
    const [lookupSourceId, setLookupSourceId] = (0, $acw62.useState)("");
    const [lookupSource, setLookupSource] = (0, $acw62.useState)("discogs");
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const userId = clientId != null ? String(clientId) : "";
    const parentRecordingId = parentRecordingIdInput.trim();
    const sourceId = lookupSourceId.trim();
    const source = lookupSource;
    const showResult = (result, error = false)=>{
        const str = typeof result === "string" ? result : JSON.stringify(result, null, 2);
        setLastResponse(str);
        if (error) (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
            text: "Request failed \u2013 see result below",
            variant: "error"
        });
        else (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
            text: "Request completed \u2013 see result below",
            variant: "success"
        });
    };
    const runReleaseLookup = async ()=>{
        if (!userId.trim()) {
            (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                text: "Select a client first (clientId)",
                variant: "error"
            });
            setLastResponse("Missing userId (clientId).");
            return;
        }
        if (!parentRecordingId.trim()) {
            setLastResponse("Missing parentRecordingId. Use a real recording ID from discography.");
            (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                text: "Set parentRecordingId for full test",
                variant: "error"
            });
            return;
        }
        if (!sourceId) {
            setLastResponse("Missing source ID for lookup (e.g. Discogs release ID).");
            (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                text: "Set source ID for lookup",
                variant: "error"
            });
            return;
        }
        setLoading("lookup");
        try {
            const data = await api.lookupLookupReleaseResponse({
                userId: userId,
                parentRecordingId: parentRecordingId,
                sourceId: sourceId,
                source: source
            });
            showResult(data);
        } catch (e) {
            const err = e;
            const status = err.response?.status ?? err.status;
            let body = e?.body;
            try {
                if (err.response) body = await err.response.json?.();
            } catch  {
            // ignore
            }
            showResult({
                status: status,
                error: String(e),
                body: body
            }, true);
        } finally{
            setLoading(null);
        }
    };
    const runCreateAndLink = async ()=>{
        if (!userId.trim() || !parentRecordingId.trim()) {
            (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                text: "Need client and parentRecordingId",
                variant: "error"
            });
            setLastResponse("Set clientId and parentRecordingId (e.g. from discography).");
            return;
        }
        setLoading("create");
        try {
            const data = await api.createAndLinkServiceResponse({
                userId: userId,
                parentRecordingId: parentRecordingId,
                createReleaseAndLinkRequest: {
                    releaseTitle: "Dev tools test release",
                    sourceId: lookupSourceId,
                    source: lookupSource
                }
            });
            showResult(data);
        } catch (e) {
            const err = e;
            let body = e?.body;
            try {
                if (err.response) body = await err.response.json?.();
            } catch  {
            // ignore
            }
            showResult({
                error: String(e),
                body: body
            }, true);
        } finally{
            setLoading(null);
        }
    };
    const runLinkRelease = async ()=>{
        if (!userId.trim() || !parentRecordingId.trim()) {
            (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                text: "Need client and parentRecordingId",
                variant: "error"
            });
            setLastResponse("Set clientId and parentRecordingId.");
            return;
        }
        setLoading("link");
        try {
            const data = await api.linkEarliestServiceResponse({
                userId: userId,
                parentRecordingId: parentRecordingId,
                linkReleaseRequest: {
                    releaseId: "placeholder-release-id"
                }
            });
            showResult(data);
        } catch (e) {
            const err = e;
            let body = e?.body;
            try {
                if (err.response) body = await err.response.json?.();
            } catch  {
            // ignore
            }
            showResult({
                error: String(e),
                body: body
            }, true);
        } finally{
            setLoading(null);
        }
    };
    const runCorrectRelease = async ()=>{
        if (!userId.trim() || !parentRecordingId.trim()) {
            (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                text: "Need client and parentRecordingId",
                variant: "error"
            });
            setLastResponse("Set clientId and parentRecordingId.");
            return;
        }
        setLoading("correct");
        try {
            const data = await api.correctServiceResponse({
                userId: userId,
                parentRecordingId: parentRecordingId,
                correctReleaseRequest: {
                    releaseId: "placeholder-release-id",
                    edits: []
                }
            });
            showResult(data);
        } catch (e) {
            const err = e;
            let body = e?.body;
            try {
                if (err.response) body = await err.response.json?.();
            } catch  {
            // ignore
            }
            showResult({
                error: String(e),
                body: body
            }, true);
        } finally{
            setLoading(null);
        }
    };
    if (!$359cbc7644cdeaa3$var$SHOW_DEV_TOOLS) return null;
    const busy = loading !== null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setModalOpen(true),
                className: "tw-fixed tw-bottom-6 tw-right-6 tw-z-40 tw-w-12 tw-h-12 tw-rounded-full tw-bg-surfaceLime tw-text-surfaceBlack90 tw-shadow-lg tw-flex tw-items-center tw-justify-center hover:tw-opacity-90 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-surfaceLime focus:tw-ring-offset-2 focus:tw-ring-offset-surfaceBlack80",
                title: "Dev tools",
                "aria-label": "Open dev tools",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                    className: "wi wi-sm wi-settings"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: modalOpen,
                onClose: ()=>setModalOpen(false),
                title: "Backend integration tests",
                modalClasses: "tw-min-w-[320px] tw-max-w-lg",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-space-y-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-sm tw-text-textWhite/80 tw-mb-2",
                            children: "Run release management endpoints. Uses current client as userId when set."
                        }),
                        userId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "tw-text-xs tw-text-textWhite/60",
                            children: [
                                "userId:",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                    className: "tw-bg-surfaceBlack80 tw-px-1 tw-rounded",
                                    children: userId
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-xs tw-text-westburyRed",
                            children: "No client selected \u2013 set clientId for release tests."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "tw-block tw-text-xs tw-text-textWhite/70 tw-mt-1",
                            children: [
                                "parentRecordingId (from discography)",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    value: parentRecordingIdInput,
                                    onChange: (e)=>setParentRecordingIdInput(e.target.value),
                                    placeholder: "e.g. UUID",
                                    className: "tw-w-full tw-mt-1 tw-px-2 tw-py-1.5 tw-rounded tw-bg-surfaceBlack80 tw-text-textWhite tw-text-sm tw-border tw-border-textWhite/20"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-gap-2 tw-items-end",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "tw-flex-1 tw-text-xs tw-text-textWhite/70",
                                    children: [
                                        "Lookup source ID",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: lookupSourceId,
                                            onChange: (e)=>setLookupSourceId(e.target.value),
                                            placeholder: "e.g. 12345 (Discogs)",
                                            className: "tw-w-full tw-mt-1 tw-px-2 tw-py-1.5 tw-rounded tw-bg-surfaceBlack80 tw-text-textWhite tw-text-sm tw-border tw-border-textWhite/20"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "tw-flex-1 tw-text-xs tw-text-textWhite/70",
                                    children: [
                                        "Lookup source",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: lookupSource,
                                            onChange: (e)=>setLookupSource(e.target.value),
                                            className: "tw-w-full tw-mt-1 tw-px-2 tw-py-1.5 tw-rounded tw-bg-surfaceBlack80 tw-text-textWhite tw-text-sm tw-border tw-border-textWhite/20",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "discogs",
                                                    children: "discogs"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "MusicBrainz",
                                                    children: "MusicBrainz"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "spotify",
                                                    children: "spotify"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "deezer",
                                                    children: "deezer"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "ppl",
                                                    children: "ppl"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tw-text-xs tw-text-textWhite/70 tw-font-medium tw-mt-2",
                                    children: "Release management"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: loading === "lookup" ? "Lookup release\u2026" : "Release lookup",
                                    onClick: runReleaseLookup,
                                    disabled: busy
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: loading === "create" ? "Create & link\u2026" : "Create release and link (POST)",
                                    onClick: runCreateAndLink,
                                    disabled: busy
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: loading === "link" ? "Link\u2026" : "Link release (POST)",
                                    onClick: runLinkRelease,
                                    disabled: busy
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: loading === "correct" ? "Correct\u2026" : "Correct release (POST)",
                                    onClick: runCorrectRelease,
                                    disabled: busy
                                })
                            ]
                        }),
                        lastResponse !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-mt-4 tw-pt-3 tw-border-t tw-border-textWhite/20",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-xs tw-text-textWhite/70 tw-mb-1",
                                    children: "Last response:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                    className: "tw-text-xs tw-bg-surfaceBlack80 tw-p-3 tw-rounded tw-overflow-auto tw-max-h-48 tw-text-textWhite",
                                    children: lastResponse
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


function $4d96ba216e256194$var$PageLayout({ children: children }) {
    const [sidebarSmall, setSidebarSmall] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-h-screen tw-flex tw-flex-col tw-bg-surfaceBlack80",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ab845b8dc308a3a$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-grow tw-pb-[60px] tw-bg-surfaceBlack80",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
                        className: `tw-shrink-0 tw-bg-surfaceBlack80 tw-transition-[width] tw-duration-200 tw-ease-out tw-overflow-hidden ${sidebarSmall ? "tw-w-16" : "tw-w-[218px]"}`,
                        style: {
                            borderRight: "1px solid #535D66"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c5d8c5b52067dd26$export$2e2bcd8739ae039), {
                            isCollapsed: sidebarSmall,
                            onToggle: ()=>setSidebarSmall((prev)=>!prev)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                        className: "tw-flex-1 tw-min-w-0 tw-bg-surfaceBlack80 tw-pl-6",
                        children: [
                            " ",
                            children
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-bg-surfaceBlack90",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f92545aa51ff06d8$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $359cbc7644cdeaa3$export$2b636689b2802601), {})
        ]
    });
}
var $4d96ba216e256194$export$2e2bcd8739ae039 = $4d96ba216e256194$var$PageLayout;



function $25b0364cb2516bb0$var$Dashboard() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7950a72521dfb882$export$5d91bb6ce8e0f47), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8dfa623bddb7aaec$export$2e2bcd8739ae039), {})
        })
    });
}
var $25b0364cb2516bb0$export$2e2bcd8739ae039 = $25b0364cb2516bb0$var$Dashboard;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $c0b087292c3026cb$exports = {};
$c0b087292c3026cb$exports = new URL("userProfile.da98fbe4.png", import.meta.url).toString();





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $1c272c8c9427e0c0$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType
};
const $1c272c8c9427e0c0$var$Feedback = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = "div", className: className, type: type = "valid", tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, `${type}-${tooltip ? "tooltip" : "feedback"}`)
    }));
$1c272c8c9427e0c0$var$Feedback.displayName = "Feedback";
$1c272c8c9427e0c0$var$Feedback.propTypes = $1c272c8c9427e0c0$var$propTypes;
var $1c272c8c9427e0c0$export$2e2bcd8739ae039 = $1c272c8c9427e0c0$var$Feedback;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// TODO
const $870809e0939c9f82$var$FormContext = /*#__PURE__*/ $acw62.createContext({});
var $870809e0939c9f82$export$2e2bcd8739ae039 = $870809e0939c9f82$var$FormContext;




const $7164fecb4f365c4a$var$FormCheckInput = /*#__PURE__*/ $acw62.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = "checkbox", isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input", ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check-input");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, isValid && "is-valid", isInvalid && "is-invalid")
    });
});
$7164fecb4f365c4a$var$FormCheckInput.displayName = "FormCheckInput";
var $7164fecb4f365c4a$export$2e2bcd8739ae039 = $7164fecb4f365c4a$var$FormCheckInput;




var $acw62 = parcelRequire("acw62");



const $b0aba1aace6996b7$var$FormCheckLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check-label");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix)
    });
});
$b0aba1aace6996b7$var$FormCheckLabel.displayName = "FormCheckLabel";
var $b0aba1aace6996b7$export$2e2bcd8739ae039 = $b0aba1aace6996b7$var$FormCheckLabel;





var $acw62 = parcelRequire("acw62");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $d3ae4136892dd278$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $acw62.Children.map(children, (child)=>/*#__PURE__*/ $acw62.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $d3ae4136892dd278$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $acw62.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $d3ae4136892dd278$export$500fd6099226ffae(children, type) {
    return $acw62.Children.toArray(children).some((child)=>/*#__PURE__*/ $acw62.isValidElement(child) && child.type === type);
}



const $87df01720ec94e93$var$FormCheck = /*#__PURE__*/ $acw62.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = "", type: type = "checkbox", label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = "input", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check");
    bsSwitchPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsSwitchPrefix, "form-switch");
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    const innerFormContext = (0, $acw62.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $d3ae4136892dd278$export$500fd6099226ffae)(children, (0, $b0aba1aace6996b7$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7164fecb4f365c4a$export$2e2bcd8739ae039), {
        ...props,
        type: type === "switch" ? "checkbox" : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870809e0939c9f82$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === "switch" && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0aba1aace6996b7$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c272c8c9427e0c0$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$87df01720ec94e93$var$FormCheck.displayName = "FormCheck";
var $87df01720ec94e93$export$2e2bcd8739ae039 = Object.assign($87df01720ec94e93$var$FormCheck, {
    Input: (0, $7164fecb4f365c4a$export$2e2bcd8739ae039),
    Label: (0, $b0aba1aace6996b7$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");
var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = true;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;






const $3023ede31d3d1660$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input", ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-control");
    let classes;
    if (plaintext) classes = {
        [`${bsPrefix}-plaintext`]: true
    };
    else classes = {
        [bsPrefix]: true,
        [`${bsPrefix}-${size}`]: size
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(controlId == null || !id, "`controlId` is ignored on `<FormControl>` when `id` is specified.");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, classes, isValid && `is-valid`, isInvalid && `is-invalid`, type === "color" && `${bsPrefix}-color`)
    });
});
$3023ede31d3d1660$var$FormControl.displayName = "FormControl";
var $3023ede31d3d1660$export$2e2bcd8739ae039 = Object.assign($3023ede31d3d1660$var$FormControl, {
    Feedback: $1c272c8c9427e0c0$export$2e2bcd8739ae039
});



var $3d8877fa5535421d$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("form-floating");



var $acw62 = parcelRequire("acw62");


const $5d8599dc34b64b39$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const context = (0, $acw62.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870809e0939c9f82$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$5d8599dc34b64b39$var$FormGroup.displayName = "FormGroup";
var $5d8599dc34b64b39$export$2e2bcd8739ae039 = $5d8599dc34b64b39$var$FormGroup;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


function $6a906738aa440808$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "col");
    const breakpoints = (0, $626bd95fa485b758$export$8970c8db816a5863)();
    const minBreakpoint = (0, $626bd95fa485b758$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === "object" && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $6a906738aa440808$var$Col = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = "div", bsPrefix: bsPrefix, spans: spans }] = $6a906738aa440808$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, !spans.length && bsPrefix)
    });
});
$6a906738aa440808$var$Col.displayName = "Col";
var $6a906738aa440808$export$2e2bcd8739ae039 = $6a906738aa440808$var$Col;





const $5d7439d74bf97ebc$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "label", bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-label");
    let columnClass = "col-form-label";
    if (typeof column === "string") columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, visuallyHidden && "visually-hidden", column && columnClass);
    (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(controlId == null || !htmlFor, "`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.");
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$5d7439d74bf97ebc$var$FormLabel.displayName = "FormLabel";
var $5d7439d74bf97ebc$export$2e2bcd8739ae039 = $5d7439d74bf97ebc$var$FormLabel;




var $acw62 = parcelRequire("acw62");



const $b91a225b00146fdd$var$FormRange = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-range");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$b91a225b00146fdd$var$FormRange.displayName = "FormRange";
var $b91a225b00146fdd$export$2e2bcd8739ae039 = $b91a225b00146fdd$var$FormRange;




var $acw62 = parcelRequire("acw62");



const $7b27958f5a457ab6$var$FormSelect = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-select");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$7b27958f5a457ab6$var$FormSelect.displayName = "FormSelect";
var $7b27958f5a457ab6$export$2e2bcd8739ae039 = $7b27958f5a457ab6$var$FormSelect;




var $acw62 = parcelRequire("acw62");


const $bd2be22fa282ca4a$var$FormText = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = "small", muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-text");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, muted && "text-muted")
    });
});
$bd2be22fa282ca4a$var$FormText.displayName = "FormText";
var $bd2be22fa282ca4a$export$2e2bcd8739ae039 = $bd2be22fa282ca4a$var$FormText;



var $acw62 = parcelRequire("acw62");


const $fbd36a2b679cb998$var$Switch = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87df01720ec94e93$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$fbd36a2b679cb998$var$Switch.displayName = "Switch";
var $fbd36a2b679cb998$export$2e2bcd8739ae039 = Object.assign($fbd36a2b679cb998$var$Switch, {
    Input: (0, $87df01720ec94e93$export$2e2bcd8739ae039).Input,
    Label: (0, $87df01720ec94e93$export$2e2bcd8739ae039).Label
});




var $acw62 = parcelRequire("acw62");



const $26b7d75a1da62deb$var$FloatingLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5d8599dc34b64b39$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$26b7d75a1da62deb$var$FloatingLabel.displayName = "FloatingLabel";
var $26b7d75a1da62deb$export$2e2bcd8739ae039 = $26b7d75a1da62deb$var$FloatingLabel;



const $64675cdb3851f16c$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType
};
const $64675cdb3851f16c$var$Form = /*#__PURE__*/ $acw62.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "form", ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, validated && "was-validated")
    }));
$64675cdb3851f16c$var$Form.displayName = "Form";
$64675cdb3851f16c$var$Form.propTypes = $64675cdb3851f16c$var$propTypes;
var $64675cdb3851f16c$export$2e2bcd8739ae039 = Object.assign($64675cdb3851f16c$var$Form, {
    Group: (0, $5d8599dc34b64b39$export$2e2bcd8739ae039),
    Control: (0, $3023ede31d3d1660$export$2e2bcd8739ae039),
    Floating: (0, $3d8877fa5535421d$export$2e2bcd8739ae039),
    Check: (0, $87df01720ec94e93$export$2e2bcd8739ae039),
    Switch: $fbd36a2b679cb998$export$2e2bcd8739ae039,
    Label: (0, $5d7439d74bf97ebc$export$2e2bcd8739ae039),
    Text: (0, $bd2be22fa282ca4a$export$2e2bcd8739ae039),
    Range: (0, $b91a225b00146fdd$export$2e2bcd8739ae039),
    Select: (0, $7b27958f5a457ab6$export$2e2bcd8739ae039),
    FloatingLabel: $26b7d75a1da62deb$export$2e2bcd8739ae039
});





var $acw62 = parcelRequire("acw62");




// WSelect.tsx


var $acw62 = parcelRequire("acw62");


const $3ff509e8daf1630b$export$a1b2f659c778dbca = ({ name: name, label: label, layout: layout = "vertical", options: options, defaultValue: defaultValue, onBlur: onBlur, onChange: onChange, row: row = false, disabled: disabled = false })=>{
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const [innerOptions, setInnerOptions] = (0, $acw62.useState)([
        {
            value: "",
            label: "Please select"
        }
    ]);
    // Add please select as first option with value of ''
    (0, $acw62.useEffect)(()=>{
        // if it's emptyish, add the empty option
        if (defaultValue === undefined || defaultValue === null || defaultValue === "") setInnerOptions([
            {
                value: "",
                label: ""
            },
            ...options
        ]);
        else setInnerOptions(options);
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-mb-4", {
                "tw-flex-col tw-flex tw-justify-between": layout === "vertical"
            }, {
                "tw-flex-row tw-w-full tw-justify-between tw-items-center": layout === "horizontal"
            }),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    htmlFor: name,
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-block tw-leading-4 tw-text-white tw-mb-2 tw-capitalize", {
                        "tw-text-[14px]": !isEditing
                    }, {
                        "tw-w-1/4": layout === "horizontal"
                    }),
                    children: label
                }),
                isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-relative", {
                        "tw-w-3/4": layout === "horizontal"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                            id: name,
                            name: name,
                            onChange: (event)=>onChange(event),
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-full", "tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", `${row ? "tw-mw-9/10 " : "tw-w-full"}`, "tw-h-12", "tw-placeholder-textSeal", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-pr-3", "tw-appearance-none", "tw-border-2", {
                                "tw-border-formInputBackground": !errors[name]
                            }, "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none", {
                                "tw-border-westburyRed": isEditing && errors[name]
                            }, {
                                "tw-cursor-not-allowed": disabled
                            }),
                            disabled: !isEditing || disabled,
                            onBlur: ()=>{
                                if (isFormSubmitted && typeof onBlur === "function") onBlur();
                            },
                            value: defaultValue,
                            children: innerOptions.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: option.value,
                                    children: option.label
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-absolute tw-right-0 tw-top-1 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-pointer-events-none",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi wi-sm wi-chevron-down"
                            })
                        })
                    ]
                }),
                !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: `tw-text-textDove tw-text-[14px]`,
                    children: [
                        " ",
                        defaultValue ? defaultValue : "-",
                        " "
                    ]
                }),
                errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-text-westburyRed tw-text-xs tw-mt-4",
                    children: errors[name]
                }),
                " "
            ]
        })
    });
};



parcelRequire("acw62");


const $6aa72595174cf6cb$export$d51e1baf57edf249 = ({ successLabel: successLabel = "Save Changes", cancelLabel: cancelLabel = "Cancel", setIsEditingGlobal: setIsEditingGlobal })=>{
    const { isEditing: isEditing, handleFormSubmit: handleFormSubmit, formData: formData, setIsEditing: setIsEditing, isFormSubmitted: isFormSubmitted, setFormSubmitted: setFormSubmitted } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-relative tw-w-full tw-text-black tw-mt-8",
            children: isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-justify-start tw-space-x-4 tw-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        label: successLabel,
                        variant: "primary-lg",
                        onClick: ()=>{
                            handleFormSubmit(formData);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        label: cancelLabel,
                        variant: "outline-light",
                        onClick: ()=>{
                            setFormSubmitted(false);
                            setIsEditing(false);
                            if (setIsEditingGlobal) setIsEditingGlobal(false);
                        }
                    })
                ]
            })
        })
    });
};





var $45fvw = parcelRequire("45fvw");

function $afe9a0da052a3541$var$ArtistPersonalInfo() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [formValue, setFormValue] = (0, $acw62.useState)({
        title: "",
        gender: "",
        firstName: "",
        middleName: "",
        lastName: "",
        role: "",
        aliases: [],
        dateOfBirth: null,
        nationality: "",
        cityOfBirth: "",
        countryOfBirth: "",
        taxationCountry: "",
        vatNumber: "",
        taxIdType: "",
        taxIdNumber: "",
        emailAddress: "",
        phoneNumber: "",
        streetAddress: "",
        county: "",
        country: "",
        postcode: ""
    });
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        clientId
    ]);
    const fetchData = ()=>{
        if (clientId === undefined) return;
        api.retrieveAdminPersonalInformation({
            userId: clientId
        }).then((personalInfo)=>{
            setFormValue({
                title: personalInfo.title,
                gender: personalInfo.gender,
                firstName: personalInfo.firstName,
                middleName: personalInfo.middleName,
                lastName: personalInfo.lastName,
                role: personalInfo.role,
                aliases: personalInfo.aliases,
                dateOfBirth: personalInfo.dateOfBirth,
                nationality: personalInfo.nationality,
                cityOfBirth: personalInfo.cityOfBirth,
                countryOfBirth: personalInfo.countryOfBirth,
                taxationCountry: personalInfo.taxationCountry,
                vatNumber: personalInfo.vatNumber,
                taxIdType: personalInfo.taxIdType,
                taxIdNumber: personalInfo.taxIdNumber,
                emailAddress: personalInfo.emailAddress,
                phoneNumber: personalInfo.phoneNumber,
                streetAddress: personalInfo.streetAddress,
                county: personalInfo.county,
                country: personalInfo.country,
                postcode: personalInfo.postcode
            });
        }).catch(()=>{});
    };
    const inputChange = (event)=>{
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    const aliasesChange = (event)=>{
        setFormValue({
            ...formValue,
            aliases: event.target.value.split(",").filter(Boolean)
        });
    };
    const saveDetails = ()=>{
        if (clientId === undefined) return;
        api.partialUpdateAdminPersonalInformation({
            userId: clientId,
            adminPersonalInformation: formValue
        }).then(()=>{
            console.log("success");
        }).catch(()=>{
            console.log("error");
        });
        return Promise.resolve();
    };
    const resetData = (event)=>{};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            handleSubmit: saveDetails,
            schema: undefined,
            formData: formValue,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-px-4 tw-justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-max-w-[365px] tw-mt-14",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "title",
                                label: "Title",
                                value: formValue.title,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa586959ed1a48eb$export$2e2bcd8739ae039), {
                                editedSettings: {
                                    firstName: formValue.firstName,
                                    lastName: formValue.lastName,
                                    middleName: formValue.middleName
                                },
                                handleInputChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                                defaultValue: formValue.role,
                                name: "role",
                                label: "Role",
                                onChange: inputChange,
                                options: [
                                    {
                                        label: "Performer/Producer",
                                        value: "Performer/Producer"
                                    },
                                    {
                                        label: "Rightsholder",
                                        value: "Rightsholder"
                                    },
                                    {
                                        label: "Representative",
                                        value: "Representative"
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "aliases",
                                label: "Aliases",
                                value: formValue?.aliases?.join(","),
                                onChange: aliasesChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "date",
                                name: "dateOfBirth",
                                label: "Date of Birth",
                                value: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(formValue.dateOfBirth).format("YYYY-MM-DD"),
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "nationality",
                                label: "Nationality",
                                value: formValue.nationality,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "cityOfBirth",
                                label: "City of Birth",
                                value: formValue.cityOfBirth,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "countryOfBirth",
                                label: "Country of Birth",
                                value: formValue.countryOfBirth,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "taxationCountry",
                                label: "Taxation Country",
                                value: formValue.taxationCountry,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "vatNumber",
                                label: "VAT Number",
                                value: formValue.vatNumber,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "taxIdType",
                                label: "Tax ID Type",
                                value: formValue.taxIdType,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "taxIdNumber",
                                label: "Tax ID Number",
                                value: formValue.taxIdNumber,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "emailAddress",
                                label: "Email Address",
                                value: formValue.emailAddress,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "phoneNumber",
                                label: "Phone Number",
                                value: formValue.phoneNumber,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "streetAddress",
                                label: "Street Address",
                                value: formValue.streetAddress,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "county",
                                label: "County",
                                value: formValue.county,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "country",
                                label: "Country",
                                value: formValue.country,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "postcode",
                                label: "Postcode",
                                value: formValue.postcode,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa72595174cf6cb$export$d51e1baf57edf249), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-end tw-mt-7",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($afe9a0da052a3541$var$FormEditSection, {})
                    })
                ]
            })
        })
    });
}
function $afe9a0da052a3541$var$FormEditSection() {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            icon: "edit",
            variant: "secondary",
            label: "Edit",
            onClick: ()=>setIsEditing(true)
        })
    });
}
var $afe9a0da052a3541$export$2e2bcd8739ae039 = $afe9a0da052a3541$var$ArtistPersonalInfo;




var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");








var $a7768a90264df169$exports = {};
$a7768a90264df169$exports = JSON.parse('["United Kingdom","United States of America","Afghanistan","\xc5land Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia (Plurinational State of)","Bonaire, Sint Eustatius and Saba","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon","Canada","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo (the Democratic Republic of the)","Congo","Cook Islands","Costa Rica","Croatia","Cuba","Cura\xe7ao","Cyprus","Czechia","C\xf4te d\'Ivoire","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Falkland Islands   [Malvinas]","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island and McDonald Islands","Holy See","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran (Islamic Republic of)","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea (the Democratic People\'s Republic of)","Korea (the Republic of)","Kuwait","Kyrgyzstan","Lao People\'s Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macao","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia (Federated States of)","Moldova (the Republic of)","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestine, State of","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Republic of North Macedonia","Romania","Russian Federation","Rwanda","R\xe9union","Saint Barth\xe9lemy","Saint Helena, Ascension and Tristan da Cunha","Saint Kitts and Nevis","Saint Lucia","Saint Martin (French part)","Saint Pierre and Miquelon","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten (Dutch part)","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Svalbard and Jan Mayen","Sweden","Switzerland","Syrian Arab Republic","Taiwan (Province of China)","Tajikistan","Tanzania, United Republic of","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","Uruguay","Uzbekistan","Vanuatu","Venezuela (Bolivarian Republic of)","Viet Nam","Virgin Islands (British)","Virgin Islands (U.S.)","Wallis and Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"]');


const $2a27e1541d4c5148$var$Constants = {
    MAX_FILE_SIZE: 5300000,
    MAX_DOCUMENT_SIZE: 26215000,
    // alternatives
    MAX_FILE_SIZE_IN_MB: 5,
    MAX_FILE_SIZE_IN_KB: 5000,
    // image file types
    IMAGE_FILE_TYPES: [
        "image/jpeg",
        "image/png",
        "image/jpg"
    ],
    // document file types
    DOCUMENT_FILE_TYPES: [
        "application/pdf"
    ]
};
var $2a27e1541d4c5148$export$2e2bcd8739ae039 = $2a27e1541d4c5148$var$Constants;


var $08438dc444d97a40$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($a7768a90264df169$exports)));


const $1375e1af3934033d$var$stStatus = {
    pending_decision: "PENDING",
    invalid: "INVALID",
    accepted: "ACCEPTED"
};
function $1375e1af3934033d$var$DocumentsUpdateForm() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [docFiles, setDocFiles] = (0, $acw62.useState)([]);
    const [isUploadIndex, setIsUploadIndex] = (0, $acw62.useState)(-1);
    const [isEditingIndex, setIsEditingIndex] = (0, $acw62.useState)(-1);
    const [fileUpdate, setFileUpdate] = (0, $acw62.useState)({
        file: null,
        filename: "",
        docId: ""
    });
    const [loading, setLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        fetchData();
        setIsEditingIndex(-1);
        setShowDropdownIndex(-1);
    }, [
        clientId
    ]);
    const fetchData = ()=>{
        if (clientId === undefined) return;
        api.listAdminIdentityDocumentSubmissions({
            userId: clientId
        }).then((docs)=>{
            setDocFiles(docs);
        }).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Failed to fetch documents"));
        });
    };
    const uploadFileHandle = (e, docId)=>{
        if (e.target.files === null) {
            setFileUpdate({
                file: null,
                filename: "",
                docId: ""
            });
            return;
        }
        const file = e.target.files[0];
        const schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
            file: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any()
        }).refine((data)=>{
            const res = data.file.size < (0, $2a27e1541d4c5148$export$2e2bcd8739ae039).MAX_DOCUMENT_SIZE && [
                ...(0, $2a27e1541d4c5148$export$2e2bcd8739ae039).DOCUMENT_FILE_TYPES,
                ...(0, $2a27e1541d4c5148$export$2e2bcd8739ae039).IMAGE_FILE_TYPES
            ].includes(data.file.type);
            return res;
        });
        const res = schema.safeParse({
            file: file
        });
        if (!res.success) {
            alert("File size should be less than 50MB and file type should be one of the following: " + [
                ...(0, $2a27e1541d4c5148$export$2e2bcd8739ae039).DOCUMENT_FILE_TYPES,
                ...(0, $2a27e1541d4c5148$export$2e2bcd8739ae039).IMAGE_FILE_TYPES
            ].join(", "));
            return;
        }
        setFileUpdate({
            file: file,
            filename: file.name,
            docId: docId
        });
    };
    const saveFileHandle = async (documentId)=>{
        if (clientId === undefined) return;
        if (fileUpdate?.docId !== documentId) {
            setIsUploadIndex(-1);
            return;
        }
        setLoading(true);
        await api.updateAdminIdentityDocumentSubmission({
            userId: clientId,
            documentId: documentId,
            file: fileUpdate.file,
            filename: fileUpdate.filename
        }).then(()=>{
            return fetchData();
        }).then(()=>{
            setLoading(false);
        }).catch(()=>{
            setLoading(false);
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Failed to upload file"));
        });
        setFileUpdate({
            file: null,
            filename: "",
            docId: ""
        });
        setIsEditingIndex(-1);
        setIsUploadIndex(-1);
    };
    const inputChange = (e, index)=>{
        const keyName = e.currentTarget.name;
        const newDocFiles = [
            ...docFiles
        ];
        newDocFiles[index][keyName] = e.target.value;
        setDocFiles(newDocFiles);
        console.log(docFiles);
    };
    const [showDropdownIndex, setShowDropdownIndex] = (0, $acw62.useState)(-1);
    const toggleDropdown = (e, index)=>{
        if (showDropdownIndex === index) setShowDropdownIndex(-1);
        else setShowDropdownIndex(index);
    };
    const updateDates = ()=>{
        if (clientId === undefined) return;
        if (isEditingIndex >= 0) {
            setLoading(true);
            const doc = docFiles[isEditingIndex];
            api.updateAdminIdentityDocumentSubmission({
                userId: clientId,
                documentId: doc.id,
                documentExpiryDate: doc.documentExpiryDate,
                documentSignedDate: doc.documentSignedDate,
                status: doc.status
            }).then(()=>{
                setLoading(false);
            }).catch(()=>{
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Failed to update dates"));
                setLoading(false);
            });
        }
        setIsEditingIndex(-1);
    };
    const getExtension = (path)=>{
        if (!path) return "";
        const suffix = path.split(".").pop();
        if (suffix === undefined) return "";
        const extension = suffix.split("?").shift();
        if (extension === undefined) return "";
        return "." + extension;
    };
    const inputClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-10", "tw-placeholder-textSeal", "tw-appearance-none", "tw-leading-5", "tw-p-3", "tw-cursor-pointer", "tw-items-center", "tw-align-center", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none");
    const updateDropdown = (e, index, state)=>{
        // Spread operator is used to create a new array
        const newDocFiles = [
            ...docFiles
        ];
        newDocFiles[index].status = state;
        setDocFiles(newDocFiles);
        setShowDropdownIndex(-1);
    };
    let docFilesData = docFiles.map((doc, index)=>{
        return {
            documentType: doc.documentType.replaceAll("_", " "),
            status: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-cursor-pointer", "tw-text-black", "tw-px-2", "tw-py-1", "tw-text-xs", "tw-font-semibold", {
                            "tw-bg-[#6EE038]": doc.status === "accepted"
                        }, {
                            "tw-bg-[#F2C94C]": doc.status === "pending_decision"
                        }, {
                            "tw-bg-[#EB5757]": doc.status === "invalid"
                        }, "tw-rounded"),
                        onClick: (e)=>{
                            if (isEditingIndex === index) toggleDropdown(e, index);
                        },
                        children: $1375e1af3934033d$var$stStatus[doc.status]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `tw-absolute tw-z-50 ${showDropdownIndex === index ? "tw-block" : "tw-hidden"}`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            className: "tw-bg-surfaceBlack90 tw-p-2 tw-rounded tw-mt-2",
                            children: Object.entries($1375e1af3934033d$var$stStatus).map(([state, stateValue], i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-cursor-pointer", "tw-mt-2", "tw-p-2", "tw-text-black", {
                                        "tw-bg-[#6EE038]": stateValue === "Accepted"
                                    }, {
                                        "tw-bg-[#F2C94C]": stateValue === "Pending"
                                    }, {
                                        "tw-bg-[#EB5757]": stateValue === "Invalid"
                                    }, "tw-rounded", {
                                        "tw-hidden": $1375e1af3934033d$var$stStatus[doc.status] === stateValue,
                                        "tw-block": $1375e1af3934033d$var$stStatus[doc.status] !== stateValue
                                    }),
                                    onClick: (e)=>updateDropdown(e, index, state),
                                    children: stateValue
                                }, `${i}`))
                        })
                    })
                ]
            }),
            file: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "file",
                children: isUploadIndex === index ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "fileUpload",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            hidden: true,
                            type: "file",
                            name: `document_${doc.id}`,
                            id: `document_${doc.id}`,
                            onChange: (e)=>uploadFileHandle(e, doc.id)
                        }),
                        fileUpdate.docId === doc.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            style: {
                                lineHeight: "16px"
                            },
                            htmlFor: `document_${doc.id}`,
                            className: inputClasses,
                            children: fileUpdate.filename
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            style: {
                                lineHeight: "16px"
                            },
                            htmlFor: `document_${doc.id}`,
                            className: inputClasses,
                            children: doc.file ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: doc.filename ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: doc.filename
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        doc.documentType,
                                        getExtension(doc.fileUrl)
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: "Upload your File"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-grid tw-grid-cols-5 tw-w-full tw-justify-between tw-gap-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-flex-col tw-col-span-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            className: "tw-underline tw-truncate",
                            href: doc.fileUrl,
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "",
                                children: doc.filename ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: doc.filename
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        doc.documentType,
                                        getExtension(doc.fileUrl)
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            documentExpiryDate: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: isEditingIndex === index ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "date",
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(doc.documentExpiryDate).format("YYYY-MM-DD"),
                    name: "documentExpiryDate",
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-10", "tw-placeholder-textSeal", "tw-appearance-none", "tw-leading-5", "tw-p-3", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none"),
                    onChange: (e)=>inputChange(e, index)
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: doc.documentExpiryDate ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(doc.documentExpiryDate).format("YYYY-MM-DD") : "-"
                })
            }),
            documentSignedDate: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: isEditingIndex === index ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "date",
                        name: "documentSignedDate",
                        value: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(doc.documentSignedDate).format("YYYY-MM-DD"),
                        onChange: (e)=>inputChange(e, index),
                        className: inputClasses
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: doc.documentSignedDate ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(doc.documentSignedDate).format("YYYY-MM-DD") : "-"
                })
            }),
            editAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    isEditingIndex != index && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "wi wi-20px wi-edit tw-mr-4 tw-cursor-pointer",
                        onClick: ()=>{
                            setIsUploadIndex(index);
                            setIsEditingIndex(index);
                        }
                    }),
                    isEditingIndex === index && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        label: loading ? "Saving..." : "Save",
                        variant: "link-secondary",
                        disabled: loading,
                        onClick: ()=>{
                            saveFileHandle(doc.id);
                            updateDates();
                        }
                    })
                ]
            })
        };
    });
    const columnStyle = {
        fontSize: "14px",
        fontWeight: 400,
        borderBottom: "1px solid #535D66"
    };
    const rowStyle = {
        fontSize: "14px",
        fontWeight: 300,
        borderBottom: "1px solid #535D66"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-ml-3",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
            columns: [
                {
                    title: "Document",
                    width: "1fr",
                    dataKey: "documentType"
                },
                {
                    title: "Status",
                    width: "1fr",
                    dataKey: "status"
                },
                {
                    title: "File uploaded",
                    width: "2fr",
                    dataKey: "file"
                },
                {
                    title: "Expiry date",
                    width: "1fr",
                    dataKey: "documentExpiryDate"
                },
                {
                    title: "Date signed",
                    width: "1fr",
                    dataKey: "documentSignedDate"
                },
                {
                    title: "Action",
                    width: "1fr",
                    dataKey: "editAction"
                }
            ],
            data: docFilesData,
            columnStyle: columnStyle,
            rowStyle: docFilesData.map(()=>rowStyle)
        })
    });
}
var $1375e1af3934033d$export$2e2bcd8739ae039 = $1375e1af3934033d$var$DocumentsUpdateForm;




var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");


const $46dfefc8b1c3ed18$export$df60b5efa84629d9 = ({ name: name, label: label, selectedValue: selectedValue, items: items, onChange: onChange })=>{
    // if form is not editable, disable interactions with the radio buttons
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    let selectedItem = items.find((item)=>item.value === selectedValue);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-flex-col tw-mb-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                    className: "tw-text-textWhite tw-text-base tw-leading-4 tw-mb-4",
                    children: label
                }),
                !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `tw-text-textDove `,
                    children: selectedItem?.label ? selectedItem.label : "-"
                }),
                isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-gap-4",
                    children: items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-cursor-pointer tw-capitalize  tw-mr-12", selectedValue === item.value ? "tw-text-surfaceLime" : "tw-text-textDove"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "radio",
                                    name: name,
                                    value: item.value.toString(),
                                    checked: selectedValue === item.value,
                                    onChange: (e)=>onChange(e),
                                    className: "tw-hidden",
                                    disabled: !isEditing
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-9 tw-h-9 tw-mr-2 tw-border-2 tw-rounded-full", selectedValue === item.value ? "tw-border-surfaceLime" : "tw-border-textDove"),
                                    children: selectedValue === item.value && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-5 tw-h-5 tw-m-[6px]  tw-rounded-full", "tw-bg-surfaceLime")
                                    })
                                }),
                                item.label
                            ]
                        }, item.value))
                })
            ]
        })
    });
};











function $ca5b5ac444ab6215$var$ArtistBankDetails() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [show, setShow] = (0, $acw62.useState)(true);
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [formSubmitted, setFormSubmitted] = (0, $acw62.useState)(false);
    const [formError, setFormError] = (0, $acw62.useState)("");
    const [transferMethod, setTransferMethod] = (0, $acw62.useState)("bank_transfer");
    const [formValue, setFormValue] = (0, $acw62.useState)({
        bankAccountName: "",
        bankSortCode: "",
        bankAccountNumber: "",
        bankName: "",
        bankAddress: "",
        bankIban: "",
        bankRoutingCode: "",
        bankAccountHoldingBranch: "",
        bankBicSwiftCode: "",
        intermediaryBankName: "",
        intermediaryBankAddress: "",
        intermediaryBankBicSwiftCode: "",
        intermediaryBankCountry: ""
    });
    const schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        bankAccountName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        bankSortCode: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        bankAccountNumber: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        bankName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        bankAddress: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        bankIban: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        bankRoutingCode: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        bankAccountHoldingBranch: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        bankBicSwiftCode: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        intermediaryBankName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        intermediaryBankAddress: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        intermediaryBankBicSwiftCode: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        intermediaryBankCountry: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty()
    });
    const inputChange = (event)=>{
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        clientId
    ]);
    const fetchData = ()=>{
        if (clientId === undefined) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Client ID is not defined"));
            return;
        }
        api.retrieveAdminBankDetails({
            userId: clientId
        }).then((bankDetails)=>{
            setFormValue({
                bankAccountName: bankDetails.bankAccountName,
                bankSortCode: bankDetails.bankSortCode,
                bankAccountNumber: bankDetails.bankAccountNumber,
                bankName: bankDetails.bankName,
                bankAddress: bankDetails.bankAddress,
                bankIban: bankDetails.bankIban,
                bankRoutingCode: bankDetails.bankRoutingCode,
                bankAccountHoldingBranch: bankDetails.bankAccountHoldingBranch,
                bankBicSwiftCode: bankDetails.bankBicSwiftCode,
                intermediaryBankName: bankDetails.intermediaryBankName,
                intermediaryBankAddress: bankDetails.intermediaryBankAddress,
                intermediaryBankBicSwiftCode: bankDetails.intermediaryBankBicSwiftCode,
                intermediaryBankCountry: bankDetails.intermediaryBankCountry
            });
            setTransferMethod(bankDetails.bankPaymentMethod);
        }).catch(()=>{
            setFormValue({
                bankAccountName: "",
                bankSortCode: "",
                bankAccountNumber: "",
                bankName: "",
                bankAddress: "",
                bankIban: "",
                bankRoutingCode: "",
                bankAccountHoldingBranch: "",
                bankBicSwiftCode: "",
                intermediaryBankName: "",
                intermediaryBankAddress: "",
                intermediaryBankBicSwiftCode: "",
                intermediaryBankCountry: ""
            });
        });
    };
    const saveDetails = ()=>{
        if (clientId === undefined) throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Client ID is not defined"));
        api.updateAdminBankDetails({
            userId: clientId,
            adminBankDetails: {
                ...formValue,
                bankPaymentMethod: transferMethod
            }
        }).then(()=>{
            setFormSubmitted(true);
            setShow(true);
        }).catch(()=>{
            setFormSubmitted(true);
            setFormError("Your request has failed.");
            setShow(true);
        });
    };
    const resetData = ()=>{
        setFormSubmitted(false);
        setFormError("");
        setShow(false);
        setIsEditing(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: formSubmitted,
                onClose: resetData,
                title: "",
                children: formError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-justify-center tw-text-white",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-text-lg",
                            children: "Sorry!"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "",
                            children: [
                                "There is an error while submitting the details! ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                " Please try again and make sure all the fields are filled."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "OK",
                            onClick: resetData
                        }),
                        "Ok"
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
                    title: "Information Updated",
                    description: "Thank you for updating the client's information"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                handleSubmit: saveDetails,
                schema: schema,
                formData: formValue,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-end",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca5b5ac444ab6215$var$FormEditSection, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-max-w-[350px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                                label: "Method of payment",
                                name: "payment_method",
                                selectedValue: transferMethod,
                                items: [
                                    {
                                        value: "bank_transfer",
                                        label: "Bank transfer"
                                    },
                                    {
                                        value: "cheque",
                                        label: "Cheque"
                                    }
                                ],
                                onChange: (event)=>{
                                    setTransferMethod(event.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Bank Account Name",
                                name: "bankAccountName",
                                value: formValue.bankAccountName,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Bank Sort Code",
                                name: "bankSortCode",
                                value: formValue.bankSortCode,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Bank Account Number",
                                name: "bankAccountNumber",
                                value: formValue.bankAccountNumber,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Bank Name",
                                name: "bankName",
                                value: formValue.bankName,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Bank Address",
                                name: "bankAddress",
                                value: formValue.bankAddress,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Bank IBAN",
                                name: "bankIban",
                                value: formValue.bankIban,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Bank Routing Code",
                                name: "bankRoutingCode",
                                value: formValue.bankRoutingCode,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Bank Account Holding Branch",
                                name: "bankAccountHoldingBranch",
                                value: formValue.bankAccountHoldingBranch,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Bank BIC/SWIFT Code",
                                name: "bankBicSwiftCode",
                                value: formValue.bankBicSwiftCode,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Intermediary Bank Name",
                                name: "intermediaryBankName",
                                value: formValue.intermediaryBankName,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Intermediary Bank Address",
                                name: "intermediaryBankAddress",
                                value: formValue.intermediaryBankAddress,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                label: "Intermediary Bank BIC/SWIFT Code",
                                name: "intermediaryBankBicSwiftCode",
                                value: formValue.intermediaryBankBicSwiftCode,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                                label: "Intermediary Bank Country",
                                name: "intermediaryBankCountry",
                                defaultValue: formValue.intermediaryBankCountry,
                                options: (0, $08438dc444d97a40$export$2e2bcd8739ae039).map((country)=>({
                                        label: country,
                                        value: country
                                    })),
                                onBlur: ()=>{},
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa72595174cf6cb$export$d51e1baf57edf249), {})
                        ]
                    })
                ]
            })
        ]
    });
}
var $ca5b5ac444ab6215$export$2e2bcd8739ae039 = $ca5b5ac444ab6215$var$ArtistBankDetails;
function $ca5b5ac444ab6215$var$FormEditSection() {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                icon: "edit",
                variant: "secondary",
                label: "Edit",
                onClick: ()=>setIsEditing(true)
            })
        ]
    });
}
function $ca5b5ac444ab6215$var$OnboardedFormFooter() {
    const { handleFormSubmit: handleFormSubmit, formData: formData, isEditing: isEditing, setIsEditing: setIsEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return(// show primary button with edit icon when not editing, show Save button when editing
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-start tw-mt-4",
        children: [
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    setIsEditing(true);
                },
                variant: "primary-lg",
                label: "Edit",
                icon: "edit"
            }),
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    handleFormSubmit(formData);
                    setIsEditing(false);
                },
                variant: "primary-lg",
                label: "Save"
            })
        ]
    }));
}




var $acw62 = parcelRequire("acw62");






function $7d8534347d87e2bc$var$SocietyLoginDetails() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [societyLogins, setSocietyLogins] = (0, $acw62.useState)([]);
    const [userPasswordAuth, setUserPasswordAuth] = (0, $acw62.useState)(false);
    const [userPassword, setUserPassword] = (0, $acw62.useState)("");
    const [isEditingIndex, setIsEditingIndex] = (0, $acw62.useState)(-1);
    const [showPassIndex, setShowPassIndex] = (0, $acw62.useState)(-1);
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        clientId
    ]);
    const fetchData = ()=>{
        if (clientId === undefined) return;
        api.listSocietyLogins({
            userId: clientId
        }).then((logins)=>{
            setSocietyLogins(logins);
        }).catch(()=>{
            setSocietyLogins([]);
        });
    };
    const handleChange = (index, key, value)=>{
        setSocietyLogins(societyLogins.map((login, i)=>{
            return i === index ? {
                ...login,
                data: {
                    ...login.data,
                    [key]: value
                }
            } : login;
        }));
    };
    const saveDetails = (index)=>{
        if (clientId === undefined) return;
        api.updateAdminUpdateSocietyCredentials({
            userId: clientId,
            societyId: societyLogins[index].societyId,
            adminUpdateSocietyCredentials: {
                ...societyLogins[index].data
            }
        }).then(()=>{
            setIsEditingIndex(-1);
        }).catch(()=>{});
    };
    const authenticatePassword = ()=>{
        setUserPasswordAuth(!userPasswordAuth);
        setShowPassword(true);
    };
    const columns = [
        {
            title: "Society",
            width: "1fr",
            dataKey: "societyName"
        },
        {
            title: "Name",
            width: "1fr",
            dataKey: "registeredArtistName"
        },
        {
            title: "ID",
            width: "1fr",
            dataKey: "accountId"
        },
        {
            title: "Username",
            width: "2fr",
            dataKey: "username"
        },
        {
            title: "Password",
            width: "1.5fr",
            dataKey: "password"
        },
        {
            title: "Portal Link",
            width: "1.5fr",
            dataKey: "societyPortal"
        },
        {
            title: "Action",
            width: "1fr",
            dataKey: "action"
        }
    ];
    const inputClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-10", "tw-placeholder-textSeal", "tw-text-sm", "tw-leading-5", "tw-p-1", "tw-mb-2", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none");
    const rows = societyLogins.map((societyLog, index)=>{
        const undefinedFiller = "-";
        return {
            societyName: societyLog.societyName,
            registeredArtistName: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7d8534347d87e2bc$var$WSimpleInput, {
                name: `registered_artist_name_${index}`,
                type: "text",
                id: `registered_artist_name_${index}`,
                className: inputClasses,
                readOnly: isEditingIndex === index ? false : true,
                onChange: (e)=>handleChange(index, "registeredArtistName", e.target.value),
                value: societyLog.data?.registeredArtistName ?? undefinedFiller
            }),
            accountId: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7d8534347d87e2bc$var$WSimpleInput, {
                name: `artist_id_${index}`,
                type: "text",
                id: `artist_id_${index}`,
                className: inputClasses,
                readOnly: isEditingIndex === index ? false : true,
                onChange: (e)=>handleChange(index, "accountId", e.target.value),
                value: societyLog.data?.accountId ?? undefinedFiller
            }),
            username: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7d8534347d87e2bc$var$WSimpleInput, {
                name: `artist_username_${index}`,
                type: "text",
                id: `artist_username_${index}`,
                className: inputClasses,
                readOnly: isEditingIndex === index ? false : true,
                onChange: (e)=>handleChange(index, "username", e.target.value),
                value: societyLog.data?.username ?? undefinedFiller
            }),
            password: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7d8534347d87e2bc$var$WSimpleInput, {
                        name: `artist_password_${index}`,
                        type: showPassIndex === index && showPassword ? "text" : "password",
                        id: `artist_password_${index}`,
                        className: inputClasses,
                        readOnly: isEditingIndex === index ? false : true,
                        onChange: (e)=>handleChange(index, "password", e.target.value),
                        value: societyLog.data?.password ?? undefinedFiller
                    }),
                    showPassIndex === index && showPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "passShow passHide",
                        "data-socid": societyLog.societyId,
                        onClick: ()=>{
                            setShowPassIndex(-1);
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: `wi wi-sm wi-shut-eye tw-ml-2`
                            })
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "tw-bg-transparent tw-border-none tw-outline-none tw-cursor-pointer tw-text-white tw-text-base tw-font-medium tw-px-4 tw-py-2 tw-rounded-md tw-bg-primary",
                        // className="passShow"
                        "data-socid": societyLog.societyId,
                        onClick: ()=>{
                            setShowPassIndex(index);
                            setUserPasswordAuth(!userPasswordAuth);
                            setUserPassword("");
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: `wi wi-sm wi-eye`
                        })
                    })
                ]
            }),
            societyPortal: societyLog.societyPortal ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                label: societyLog.societyPortal,
                variant: "secondary",
                onClick: ()=>{
                    window.open(societyLog.societyPortal);
                }
            }) : "-",
            action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "d-flex signButtond align-items-center",
                children: isEditingIndex === index ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    label: "Save",
                    variant: "secondary",
                    onClick: ()=>saveDetails(index)
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                    className: `wi wi-edit tw-cursor-pointer`,
                    style: {
                        width: "25px",
                        height: "25px"
                    },
                    onClick: ()=>setIsEditingIndex(index)
                })
            })
        };
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            userPasswordAuth ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: userPasswordAuth,
                onClose: ()=>setUserPasswordAuth(!userPasswordAuth),
                title: "Password Authentication",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `tw-text-center tw-flex tw-justify-center`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "entText ModalFormGroup col-10 mx-auto mt-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `tw-mb-4`,
                                children: "You are trying to view passwords. Please enter your password to allow this:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                htmlFor: Math.random().toString(),
                                children: [
                                    "Password ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-danger",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: Math.random().toString(),
                                type: "password",
                                value: userPassword,
                                onChange: (e)=>setUserPassword(e.target.value),
                                placeholder: "Enter Password",
                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-12", "tw-placeholder-textSeal", "tw-text-sm", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-space-x-4 tw-mt-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        label: "OK",
                                        onClick: authenticatePassword
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        label: "Cancel",
                                        variant: "outline-light",
                                        onClick: ()=>{
                                            setUserPasswordAuth(!userPasswordAuth);
                                            setUserPassword("");
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : "",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$e2595d8541f6e8ef), {
                columns: columns,
                data: rows
            })
        ]
    });
}
var $7d8534347d87e2bc$export$2e2bcd8739ae039 = $7d8534347d87e2bc$var$SocietyLoginDetails;
function $7d8534347d87e2bc$var$WSimpleInput({ name: name, type: type, id: id, className: className, readOnly: readOnly, onChange: onChange, value: value }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            readOnly && type != "password" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "tw-text-textDove",
                children: [
                    value,
                    " "
                ]
            }),
            readOnly && type == "password" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "tw-text-textDove tw-leading-8",
                children: value !== "-" ? "\u25CF".repeat(String(value).length) : "--------"
            }),
            !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: type,
                name: name,
                id: id,
                className: className,
                readOnly: readOnly,
                onChange: onChange,
                value: value
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $ef80980ea56e490c$exports = {};
$ef80980ea56e490c$exports = new URL("ThumbsUp.cfdac9dc.svg", import.meta.url).toString();


var $87f827128963ff43$exports = {};
$87f827128963ff43$exports = new URL("ThumbsDown.5a2a8553.svg", import.meta.url).toString();












function $2530899195e704ad$var$ArtistAdditionalDetails() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [show, setShow] = (0, $acw62.useState)(true);
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const [formValue, setFormValue] = (0, $acw62.useState)({
        name: "",
        role: "",
        email: ""
    });
    const [formSubmitted, setFormSubmitted] = (0, $acw62.useState)(false);
    const [formError, setFormError] = (0, $acw62.useState)("");
    const inputChange = async (event)=>{
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    const blurHandle = async (event)=>{
        if (event.target.value) setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    (0, $acw62.useEffect)(()=>{
        setFormValue({
            name: "",
            role: "",
            email: ""
        });
        fetchData();
    }, [
        clientId
    ]);
    const fetchData = ()=>{
        if (clientId === undefined) return;
        api.retrieveAdditionalContactDetails({
            userId: clientId
        }).then((additionalContactDetails)=>{
            setFormValue({
                name: additionalContactDetails.representative?.name ?? "",
                role: additionalContactDetails.representative?.role ?? "",
                email: additionalContactDetails.representative?.email ?? ""
            });
        }).catch(()=>{});
    };
    const saveDetails = async ()=>{
        if (clientId === undefined) return;
        await api.updateAdditionalContactDetails({
            userId: clientId,
            additionalContactDetails: {
                representative: {
                    name: formValue.name,
                    role: formValue.role,
                    email: formValue.email
                }
            }
        }).then((response)=>{
            setFormSubmitted(true);
            setShow(true);
            setFormError("");
        }).catch((error)=>{
            setFormSubmitted(true);
            setFormError("Your request has failed.");
            setShow(true);
        });
    };
    const resetData = ()=>{
        setFormSubmitted(false);
        setFormError("");
        setShow(false);
        setIsEditing(false);
    };
    const schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        name: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        role: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty(),
        email: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty()
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                schema: schema,
                handleSubmit: saveDetails,
                formData: formValue,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-end",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2530899195e704ad$var$FormEditSection, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-max-w-[350px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "name",
                                label: "Name",
                                onBlur: ()=>{},
                                onChange: inputChange,
                                value: formValue.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                                name: "role",
                                label: "Role",
                                onBlur: ()=>{},
                                onChange: inputChange,
                                defaultValue: formValue.role,
                                options: [
                                    {
                                        value: "MANAGER",
                                        label: "Manager"
                                    },
                                    {
                                        value: "AGENT",
                                        label: "Agent"
                                    },
                                    {
                                        value: "PUBLICIST",
                                        label: "Publicist"
                                    },
                                    {
                                        value: "LAWYER",
                                        label: "Lawyer"
                                    },
                                    {
                                        value: "OTHER",
                                        label: "Other"
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "email",
                                name: "email",
                                label: "Email",
                                onBlur: ()=>{},
                                onChange: inputChange,
                                value: formValue.email
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa72595174cf6cb$export$d51e1baf57edf249), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: formSubmitted,
                title: "",
                onClose: resetData,
                children: formError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "thankyouBlock",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "thImage",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($87f827128963ff43$exports))),
                                alt: "Thumbs Down",
                                width: "180",
                                className: "d-block m-auto"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "mt-4 pt-1 mb-3 text-center",
                            children: "Sorry!"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-center",
                            children: [
                                "There is an error while submitting the details! ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                " Please try again and make sure all the fields are filled."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                            xs: 12,
                            className: "d-flex justify-content-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                variant: "primary",
                                type: "button",
                                className: "x-button px-4 mt-3 ml-auto",
                                onClick: resetData,
                                children: "Ok"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "thankyouBlock",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "thImage",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ef80980ea56e490c$exports))),
                                alt: "Thumbs Up",
                                width: "180",
                                className: "d-block m-auto"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "mt-4 pt-1 mb-3 text-center",
                            children: "Thank you"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-center",
                            children: "Artist's information has been updated!"
                        })
                    ]
                })
            })
        ]
    });
}
function $2530899195e704ad$var$FormEditSection() {
    const { isEditing: isEditing, setIsEditing: setIsEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            label: "Edit",
            variant: "secondary",
            icon: "edit",
            onClick: ()=>setIsEditing(true)
        })
    });
}
var $2530899195e704ad$export$2e2bcd8739ae039 = $2530899195e704ad$var$ArtistAdditionalDetails;



parcelRequire("acw62");

function $23623e1edf3b4c4c$var$ArtistActivityLog() {
    const artistActivityLog = [
        {
            user: "James Blunt",
            time: "19:42",
            activity: "Membership forms sent to client",
            date: "08/01/2022"
        },
        {
            user: "James Blunt",
            time: "17:13",
            activity: "Completed mandate, POA and questionnaire",
            date: "08/01/2022"
        },
        {
            user: "James Blunt",
            time: "08:06",
            activity: "Client verified",
            date: "08/01/2022"
        },
        {
            user: "James Blunt",
            time: "9:42",
            activity: "Client signed up",
            date: "08/01/2022"
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$e2595d8541f6e8ef), {
        columns: [
            {
                title: "Date",
                width: "1fr",
                dataKey: "date"
            },
            {
                title: "Time",
                width: "1fr",
                dataKey: "time"
            },
            {
                title: "User",
                width: "1fr",
                dataKey: "user"
            },
            {
                title: "Activity",
                width: "2fr",
                dataKey: "activity"
            }
        ],
        data: artistActivityLog
    });
}
var $23623e1edf3b4c4c$export$2e2bcd8739ae039 = $23623e1edf3b4c4c$var$ArtistActivityLog;




var $acw62 = parcelRequire("acw62");

function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}


function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039(value) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $93a8d45f3f5c7cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $5fd7da45fede2458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $6673cc5b62dfa592$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY = 86400000;
function $dbfee7256f9ba04c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY) + 1;
}





function $8b6bcc549b1c1b29$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $56d5b29bd1df6af4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $4e98b4d5a2488885$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK = 604800000;
function $e2b4503c694c959a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(date).getTime() - (0, $4e98b4d5a2488885$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK) + 1;
}







var $1f47e002602f8387$var$defaultOptions = {};
function $1f47e002602f8387$export$430a3269e24b912e() {
    return $1f47e002602f8387$var$defaultOptions;
}
function $1f47e002602f8387$export$95365be1b0704abc(newOptions) {
    $1f47e002602f8387$var$defaultOptions = newOptions;
}


function $0dfbcd4e04a34858$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $efe8c2ce4ac4bd36$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $5b38b39a484f4993$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK = 604800000;
function $c4c2445bc457b574$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(date, options).getTime() - (0, $5b38b39a484f4993$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK) + 1;
}



function $88335940ad51fc8f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8dea7dd01f0b97c2$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $8dea7dd01f0b97c2$export$2e2bcd8739ae039 = $8dea7dd01f0b97c2$var$formatters;


var $d91e238bf521c720$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d91e238bf521c720$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $c4c2445bc457b574$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $e2b4503c694c959a$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $dbfee7256f9ba04c$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $d91e238bf521c720$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(minutes, 2);
}
function $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter);
}
function $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d91e238bf521c720$export$2e2bcd8739ae039 = $d91e238bf521c720$var$formatters;


var $4f085685fa15e740$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $4f085685fa15e740$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $4f085685fa15e740$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $4f085685fa15e740$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $4f085685fa15e740$var$timeLongFormatter(timePattern, formatLong));
};
var $4f085685fa15e740$var$longFormatters = {
    p: $4f085685fa15e740$var$timeLongFormatter,
    P: $4f085685fa15e740$var$dateTimeLongFormatter
};
var $4f085685fa15e740$export$2e2bcd8739ae039 = $4f085685fa15e740$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $a5375092e28b891e$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $a5375092e28b891e$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $a5375092e28b891e$export$c6cc36aa33304772(token) {
    return $a5375092e28b891e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$c6b49d6dceb604a1(token) {
    return $a5375092e28b891e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;


function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $b99de2b03d4f39be$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;


var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $117705cf2af2348d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;


function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $9567ced935a3b497$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $9567ced935a3b497$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;


function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $56621c36efca199b$export$2e2bcd8739ae039)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: "en-US",
    formatDistance: (0, $1c4e78b8ee7f66d8$export$2e2bcd8739ae039),
    formatLong: (0, $b99de2b03d4f39be$export$2e2bcd8739ae039),
    formatRelative: (0, $117705cf2af2348d$export$2e2bcd8739ae039),
    localize: (0, $9567ced935a3b497$export$2e2bcd8739ae039),
    match: (0, $219397ebd8b56b11$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;


var $98e3d5324cb7d94c$export$2e2bcd8739ae039 = (0, $0ca880ce53ce49f9$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4e349bc0dbb08c36$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4e349bc0dbb08c36$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4e349bc0dbb08c36$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4e349bc0dbb08c36$var$doubleQuoteRegExp = /''/g;
var $4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4e349bc0dbb08c36$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $98e3d5324cb7d94c$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $93a8d45f3f5c7cb9$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $6673cc5b62dfa592$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4e349bc0dbb08c36$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $4f085685fa15e740$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4e349bc0dbb08c36$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4e349bc0dbb08c36$var$cleanEscapedString(substring);
        var formatter = (0, $d91e238bf521c720$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a5375092e28b891e$export$c6b49d6dceb604a1)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a5375092e28b891e$export$c6cc36aa33304772)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $4e349bc0dbb08c36$var$cleanEscapedString(input) {
    var matched = input.match($4e349bc0dbb08c36$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4e349bc0dbb08c36$var$doubleQuoteRegExp, "'");
}





var $9fcd6fecc96adb6d$exports = {};
$9fcd6fecc96adb6d$exports = new URL("statementLogo.a2414c6d.png", import.meta.url).toString();


function $01863e1aee93ff44$var$ViewStatement({ show: show, modalClose: modalClose, paymentData: paymentDetail, statementData: statementData, statementPdf: statementPdf }) {
    const numToString = (num)=>{
        const parseNumber = num / 100;
        const toLocale = parseNumber.toLocaleString(navigator.language, {
            minimumFractionDigits: 2
        });
        return toLocale;
    };
    const statusMap = {
        cleared: "Cleared",
        to_be_transferred: "Awaiting transfer",
        waiting_cheque_clear: "Awaiting cheque clearance",
        held: "Held"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c17184070610a5f4$export$2e2bcd8739ae039), {
        show: show,
        onHide: modalClose,
        className: "AgreementModal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                className: "ModalClose",
                onClick: modalClose,
                children: "close"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c17184070610a5f4$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "AgreementModalData",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "agreementHeader",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "d-flex justify-content-end modalTopButtons",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: statementPdf,
                                    className: "btn download-btn button-border",
                                    download: `${(0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(paymentDetail.paymentDate), "do-LLLL-yyyy")}.pdf`,
                                    children: "Download"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "modalDocument",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "statementDoc",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "StatementHeader",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9fcd6fecc96adb6d$exports))),
                                            className: "d-block"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "statementFor d-flex justify-content-between",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "clientInfo",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "d-block name",
                                                        children: "Adam Nutter"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("address", {
                                                        children: [
                                                            "90 westfield Lane",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "Kippax",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "Leeds",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "LS25 7HU",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "United Kingdom"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "companyInfo",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "d-block name",
                                                        children: "Westbury Music Consultants Ltd."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("address", {
                                                        children: [
                                                            "21 Broadoaks Way",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "Bromley, Kent ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "BR2 0UA",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "United Kingdom"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "contactNo d-block",
                                                        children: "+44 (0) 208 1337 265"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "email d-block",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                            href: "mailto:royalties@westburymusic.co.uk",
                                                            children: "royalties@westburymusic.co.uk"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "d-block mt-3",
                                                        children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(paymentDetail.paymentDate), "do LLLL, yyyy")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "statementDetailTable",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "stTitle text-uppercase",
                                                children: "Statement"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "statementTable",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                    className: "statement",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                                        colSpan: 1,
                                                                        children: [
                                                                            "Received ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                            "Date"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        colSpan: 2,
                                                                        children: "Collection Society"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                                        colSpan: 1,
                                                                        children: [
                                                                            "Gross ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                            "Received"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        colSpan: 1,
                                                                        children: "Commission"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                                        colSpan: 1,
                                                                        children: [
                                                                            "Amount",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                            "Paid out"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                                        colSpan: 1,
                                                                        children: [
                                                                            "Date ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                            "Paid out"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        colSpan: 1,
                                                                        children: "Status"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                            children: [
                                                                statementData.map((statement, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                colSpan: 1,
                                                                                children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(statement.dateCreated), "dd/MM/yyyy")
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                colSpan: 2,
                                                                                children: statement.fromSociety
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                                colSpan: 1,
                                                                                children: [
                                                                                    "\xa3 ",
                                                                                    numToString(statement.totalAmountReceived)
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                                colSpan: 1,
                                                                                children: [
                                                                                    "\xa3 ",
                                                                                    numToString(statement.comission)
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                                colSpan: 1,
                                                                                children: [
                                                                                    "\xa3 ",
                                                                                    numToString(statement.amountPaidToClient)
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                colSpan: 1,
                                                                                children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(statement.paymentDate), "dd/MM/yyyy")
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                colSpan: 2,
                                                                                children: statusMap[statement.status]
                                                                            })
                                                                        ]
                                                                    }, `${index}`)),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 2,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 2,
                                                                            children: "\xa0"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 2,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 2,
                                                                            children: "\xa0"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                    className: "totalPayRow",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 6,
                                                                            className: "b-0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "Total"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 2,
                                                                            children: paymentDetail.totalAmountReceived
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "paymentDetailsTable",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            colSpan: 2,
                                                            className: "payHeader",
                                                            children: "Payment Details"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "payhead",
                                                                    children: "Client Name"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: paymentDetail.clientName
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "payhead",
                                                                    children: "Remittance Method:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: paymentDetail.remittanceMethod
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "payhead",
                                                                    children: "Payment Date:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(paymentDetail.paymentDate), "do LLLL, yyyy")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "payhead",
                                                                    children: "Total Payable:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: paymentDetail.totalPayable
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $01863e1aee93ff44$export$2e2bcd8739ae039 = $01863e1aee93ff44$var$ViewStatement;







var $acw62 = parcelRequire("acw62");
const $19ab81438640b22c$var$StatementsTable = ({ rows: rows, columns: columns })=>{
    // Generate grid columns dynamically based on the number of columns
    const gridTemplateColumns = `repeat(${columns.length}, 1fr)`;
    // State to track which rows are expanded
    const [expandedRows, setExpandedRows] = (0, $acw62.useState)([]);
    // Function to handle row click (expand/collapse)
    const handleRowClick = (id)=>{
        setExpandedRows((prevState)=>prevState.includes(id) ? prevState.filter((e)=>e !== id) : [
                ...prevState,
                id
            ]);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-bg-surfaceBlack90",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-grid tw-gap-2 tw-w-full tw-pt-2 tw-pb-2",
                style: {
                    gridTemplateColumns: gridTemplateColumns,
                    borderBottom: "1px solid #fff"
                },
                children: columns.map((column, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `tw-pl-0`,
                        children: column.title
                    }, idx))
            }),
            rows.map((row, rowIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-grid tw-gap-2 tw-w-full tw-pt-2 tw-pb-2",
                            style: {
                                gridTemplateColumns: gridTemplateColumns,
                                borderBottom: "1px solid #fff"
                            },
                            children: columns.map((column, colIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-pl-0 tw-flex tw-items-center",
                                    children: [
                                        row[column.dataKey],
                                        colIndex === columns.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-text-white tw-pl-2 tw-cursor-pointer",
                                            onClick: ()=>handleRowClick(row.id),
                                            onKeyDown: (e)=>{
                                                if (e.key === "Enter") handleRowClick(row.id);
                                            },
                                            tabIndex: 0,
                                            role: "button",
                                            children: expandedRows.includes(row.id) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: "-"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: "+"
                                            })
                                        })
                                    ]
                                }, colIndex))
                        }),
                        expandedRows.includes(row.id) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: row.childComponent
                        })
                    ]
                }, rowIndex))
        ]
    });
};
var $19ab81438640b22c$export$2e2bcd8739ae039 = $19ab81438640b22c$var$StatementsTable;




const $4c86c2ba3eebb152$var$customFetch = async (url, init = {})=>{
    init.headers = {
        ...init.headers,
        ...(0, $1978162fe9dc014b$export$a6f1ecf08e412113)()
    };
    const response = await fetch(url, init);
    if (response.status === 401) return response.json().then(async ({ code: code })=>{
        if (code !== "token_not_valid") return response;
        const token = (0, $1978162fe9dc014b$export$76e3c576b65ee323)();
        if (token === null) {
            location.pathname = "/";
            return response;
        }
        await (0, $1978162fe9dc014b$export$c4918b461d83debb)(token.refresh).then((response)=>{
            (0, $1978162fe9dc014b$export$fe0bd509971bc7b3)({
                ...token,
                access: response.access
            });
            init.headers = {
                ...init.headers,
                ...(0, $1978162fe9dc014b$export$a6f1ecf08e412113)()
            };
        });
        return fetch(url, init);
    });
    return response;
};
var $4c86c2ba3eebb152$export$2e2bcd8739ae039 = $4c86c2ba3eebb152$var$customFetch;


const $7da0a64248b8a85c$var$statusMap = {
    cleared: "Cleared",
    to_be_transferred: "Awaiting transfer",
    waiting_cheque_clear: "Awaiting cheque clearance",
    held: "Held"
};
function $7da0a64248b8a85c$var$ArtistStatements() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [statementView, setStatementView] = (0, $acw62.useState)(false);
    const handleShow = ()=>setStatementView(!statementView);
    const [financialYears, setFinancialYears] = (0, $acw62.useState)([]);
    const [clientPayments, setClientPayments] = (0, $acw62.useState)([]);
    const [statementYear, setStatementYear] = (0, $acw62.useState)("");
    const [clientPaymentsByDay, setClientPaymentsByDay] = (0, $acw62.useState)({});
    const [paymentDetail, setPaymentDetail] = (0, $acw62.useState)();
    const [statementData, setStatementData] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [loadingData, setLoadingData] = (0, $acw62.useState)("Loading...");
    const [statementPdf, setStatementPdf] = (0, $acw62.useState)("");
    const [allStatementsPdf, setAllStatementsPdf] = (0, $acw62.useState)("");
    const [selectedPaymentDates, setSelectedPaymentDates] = (0, $acw62.useState)([]);
    const downloadLinkRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        setFinancialYears([]);
        setStatementYear("");
        setClientPayments([]);
        setClientPaymentsByDay({});
        setLoadingData("Loading...");
        fetchData();
    }, [
        clientId
    ]);
    const fetchData = async ()=>{
        if (clientId === undefined) return;
        try {
            const { fiscalYearsUnique: fiscalYearsUnique } = await api.retrieveFinancialYears({
                userId: clientId
            });
            if (!fiscalYearsUnique.length) return;
            setStatementYear(fiscalYearsUnique[0]);
            setFinancialYears(fiscalYearsUnique);
            const dailyPaymentsGroupedByYear = await Promise.all(fiscalYearsUnique.map((financialYear)=>{
                return api.listDailyPayments({
                    userId: clientId,
                    financialYear: financialYear
                });
            }));
            setClientPayments(dailyPaymentsGroupedByYear);
            if (!dailyPaymentsGroupedByYear.length) return;
            const statementsByYear = await Promise.all(dailyPaymentsGroupedByYear.map((paymentsForYear)=>{
                return Promise.all(paymentsForYear.map((dailyPayments)=>{
                    return api.retrieveStatementsJson({
                        userId: clientId,
                        paymentDay: dailyPayments.date
                    });
                }));
            }));
            setClientPaymentsByDay(statementsByYear.reduce((statementsByYear, statements)=>{
                statements.forEach((statement)=>{
                    statementsByYear[statement.metadata.paymentDate] = statement;
                });
                return statementsByYear;
            }, {}));
        } catch  {}
    };
    const viewStatement = async (e, paymentDay)=>{
        e.stopPropagation();
        e.preventDefault();
        const token = (0, $1978162fe9dc014b$export$76e3c576b65ee323)();
        if (token === null) return;
        if (clientId === undefined) return;
        await api.retrieveStatementsJson({
            userId: clientId,
            paymentDay: paymentDay
        }).then((statement)=>{
            setPaymentDetail(statement.metadata);
            setStatementData(statement.payments);
            setStatementView(true);
        }).catch(()=>{
            setPaymentDetail(undefined);
            setStatementData([]);
        });
        const headers = new Headers({
            Authorization: "Bearer " + token.access
        });
        /**
     * Schema generation currently does not support non-JSON responses.
     * As a workaround, requests that expect other media types are
     * performed manually using the Fetch API.
     */ (0, $4c86c2ba3eebb152$export$2e2bcd8739ae039)(`${(0, $1978162fe9dc014b$export$3b164a006a884f7)}/portal/users/${clientId}/statements/?` + new URLSearchParams({
            payment_day: paymentDay,
            format: "pdf"
        }), {
            headers: headers
        }).then((response)=>response.blob()).then((blob)=>{
            const url = window.URL.createObjectURL(blob);
            setStatementPdf(url);
            setStatementView(true);
        }).catch((e)=>{
            setStatementPdf("");
        });
    };
    const handleDownloadSelected = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const token = (0, $1978162fe9dc014b$export$76e3c576b65ee323)();
        if (!selectedPaymentDates.length) return;
        if (clientId === undefined) return;
        if (token === null) return;
        setLoading(true);
        const headers = new Headers({
            Authorization: "Bearer " + token.access
        });
        /**
     * Schema generation currently does not support non-JSON responses.
     * As a workaround, requests that expect other media types are
     * performed manually using the Fetch API.
     */ (0, $4c86c2ba3eebb152$export$2e2bcd8739ae039)(`${(0, $1978162fe9dc014b$export$3b164a006a884f7)}/portal/users/${clientId}/statements/?` + new URLSearchParams({
            payment_days: selectedPaymentDates.join(","),
            format: "zip"
        }), {
            headers: headers
        }).then((response)=>response.blob()).then((blob)=>{
            const url = window.URL.createObjectURL(blob);
            setAllStatementsPdf(url);
            if (downloadLinkRef.current) {
                downloadLinkRef.current.href = url;
                downloadLinkRef.current.setAttribute("download", "statements.zip");
                downloadLinkRef.current.click();
            }
            setLoading(false);
        }).catch(()=>{
            setStatementData([]);
            setLoading(false);
        });
    };
    const paymentsByDayForSelectedYear = (0, $acw62.useMemo)(()=>{
        return Object.fromEntries(Object.entries(clientPaymentsByDay).filter(([date, statement])=>{
            return new Date(date).getFullYear().toString().slice(-2) === statementYear.slice(-2);
        }));
    }, [
        statementYear,
        clientPaymentsByDay
    ]);
    const handleSelectAll = (event)=>{
        if (!event.target.checked) {
            setSelectedPaymentDates([]);
            return;
        }
        setSelectedPaymentDates(Object.keys(paymentsByDayForSelectedYear));
    };
    const allSelected = (0, $acw62.useMemo)(()=>{
        return Object.keys(paymentsByDayForSelectedYear).length === selectedPaymentDates.length;
    }, [
        selectedPaymentDates,
        paymentsByDayForSelectedYear
    ]);
    const handleSelect = (event, selectedDate)=>{
        if (!event.target.checked) {
            setSelectedPaymentDates(selectedPaymentDates.filter((date)=>date !== selectedDate));
            return;
        }
        if (!selectedPaymentDates.includes(selectedDate)) setSelectedPaymentDates([
            ...selectedPaymentDates,
            selectedDate
        ]);
    };
    const numToString = (num)=>{
        const parseNumber = num / 100;
        const toLocale = parseNumber.toLocaleString(navigator.language, {
            minimumFractionDigits: 2
        });
        return toLocale;
    };
    const handleYearSelect = (event)=>{
        setStatementYear(event.target.value);
        setSelectedPaymentDates([]);
    };
    let columns = [
        {
            dataKey: "checkbox",
            title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "checkbox"
            })
        },
        {
            dataKey: "statement_date",
            title: "Statement Date"
        },
        {
            dataKey: "societies",
            title: "Societies"
        },
        {
            dataKey: "amount_received",
            title: "Amount received"
        },
        {
            dataKey: "commission",
            title: "Commission"
        },
        {
            dataKey: "paid_to_client",
            title: "Paid to client"
        },
        {
            dataKey: "status",
            title: "Status"
        },
        {
            dataKey: "view_statement",
            title: ""
        }
    ];
    // Populate the table with data based on the clientPayments
    let rowsData = [];
    financialYears.forEach((year, yearIndex)=>{
        if (statementYear === year && clientPayments.length > 0) {
            const currentPayments = clientPayments[yearIndex];
            currentPayments.forEach((doc)=>{
                const currentYear = new Date(doc.date).getFullYear().toString().slice(-2);
                // Only show payments for the selected year
                if (currentYear === year.slice(-2)) {
                    const res = {}; // TODO: type this
                    const dayPayments = clientPaymentsByDay[doc.date];
                    res.checkbox = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "checkbox",
                        onClick: (e)=>handleSelect(e, doc.date)
                    });
                    res.statement_date = (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(doc.date), "dd/MM/yyyy");
                    res.societies = dayPayments?.payments.length;
                    res.amount_received = dayPayments?.metadata.totalAmountReceived;
                    res.commission = dayPayments?.metadata.commission;
                    res.paid_to_client = dayPayments?.metadata.totalPayable;
                    res.status = $7da0a64248b8a85c$var$statusMap[dayPayments?.metadata.status];
                    res.view_statement = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: " ",
                        "data-statementday": doc,
                        onClick: (e)=>viewStatement(e, doc.date),
                        children: "View\xa0Statement"
                    });
                    // Loop through detailed payments
                    res.payments = dayPayments?.payments.map((paymentDoc)=>({
                            fromSociety: paymentDoc.fromSociety,
                            totalAmountReceived: paymentDoc.totalAmountReceived,
                            commission: paymentDoc.comission,
                            amountPaidToClient: paymentDoc.amountPaidToClient,
                            status: $7da0a64248b8a85c$var$statusMap[paymentDoc.status]
                        })) || [];
                    rowsData.push(res);
                }
            });
        }
    });
    // For each res.payments, we need to return a JSX that shows/hides the detailed payments
    // This child component is heavily dependent on the columns, so we need to generate the child component based on the main columns
    const formattedRows = (0, $acw62.useMemo)(()=>{
        return rowsData.map((row)=>{
            return {
                ...row,
                childComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-pt-2 tw-pb-2",
                    children: row.payments.map((payment, idx)=>{
                        const gridTemplateColumns = `repeat(${columns.length}, 1fr)`;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-grid tw-gap-2 tw-w-full tw-text-white tw-cursor-pointer",
                            style: {
                                gridTemplateColumns: gridTemplateColumns
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "",
                                    children: payment.fromSociety
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "",
                                    children: numToString(payment.totalAmountReceived)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "",
                                    children: numToString(payment.commission)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "",
                                    children: numToString(payment.amountPaidToClient)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "",
                                    children: payment.status
                                })
                            ]
                        }, idx);
                    })
                })
            };
        });
    }, [
        rowsData
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ArtistDocumentList",
        children: [
            statementView && paymentDetail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01863e1aee93ff44$export$2e2bcd8739ae039), {
                show: statementView,
                modalClose: handleShow,
                statementData: statementData,
                paymentData: paymentDetail,
                statementPdf: statementPdf
            }) : "",
            financialYears.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "DocumentsListingTable m-0",
                children: [
                    loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "loaderWrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "Loader",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Downloading..."
                            })
                        })
                    }) : "",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "listingTableWrap",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-align-items-right tw-justify-end",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "fySelection p-0 d-flex",
                                        children: financialYears.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Select, {
                                            className: "mt-0 fieldSmaller roleSelected fieldWithBorder",
                                            id: "financial_year",
                                            name: "financial_year",
                                            onChange: handleYearSelect,
                                            children: financialYears.map((year)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: year,
                                                    children: year
                                                }, year))
                                        }) : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "downloadZipButtons p-relative",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: allStatementsPdf,
                                                className: "btn download-btn secondary",
                                                onClick: handleDownloadSelected,
                                                children: "Download"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: " ",
                                                ref: downloadLinkRef,
                                                className: "hidden-button",
                                                id: "downloadzip",
                                                download: true,
                                                children: "Download"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $19ab81438640b22c$export$2e2bcd8739ae039), {
                                columns: columns,
                                rows: formattedRows
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "dataLoading",
                children: loadingData
            })
        ]
    });
}
var $7da0a64248b8a85c$export$2e2bcd8739ae039 = $7da0a64248b8a85c$var$ArtistStatements;






var $acw62 = parcelRequire("acw62");



const $9b50e3295c79031e$export$dc9ccbbcb120a24b = ({ clientId: clientId })=>{
    const [societies, setSocieties] = (0, $acw62.useState)([]);
    const [collapse, setCollapse] = (0, $acw62.useState)(-1);
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const formTitle = collapse == -1 ? "" : "Forms";
    const resetState = async ()=>{
        setSocieties([]);
        setCollapse(-1);
    };
    const fetchData = async ()=>{
        await resetState();
        api.listMembershipStatuses({
            userId: clientId
        }).then((res)=>setSocieties(res)).catch(()=>{});
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        clientId
    ]);
    if (!clientId) return null;
    if (societies.length == 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        children: "No memberships have been configured so far."
    });
    const columnStyle = {
        fontSize: "14px",
        fontWeight: 400,
        borderBottom: "1px solid #535D66"
    };
    const rowStyle = {
        fontSize: "14px",
        fontWeight: 300,
        borderBottom: "1px solid #535D66"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        extraClasses: "tw-font-base",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-2xl tw-ml-2",
                children: "Membership Forms"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
                columns: [
                    {
                        title: "Society",
                        width: "1fr",
                        dataKey: "readableName"
                    },
                    {
                        title: "Territory",
                        width: "1fr",
                        dataKey: "country"
                    },
                    {
                        title: formTitle,
                        width: "2fr",
                        dataKey: "forms"
                    }
                ],
                data: societies.map((data, index)=>{
                    return {
                        ...data,
                        forms: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9b50e3295c79031e$var$FormRow, {
                            index: index,
                            forms: data.forms,
                            collapse: collapse,
                            setCollapse: setCollapse
                        })
                    };
                }),
                columnStyle: columnStyle,
                rowStyle: societies.map(()=>rowStyle)
            })
        ]
    });
};
const $9b50e3295c79031e$var$FormRow = ({ index: index, forms: forms, collapse: collapse, setCollapse: setCollapse })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-grid tw-grid-cols-5 tw-w-full tw-justify-between tw-gap-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `tw-flex tw-flex-col tw-gap-2 tw-pr-1 tw-col-span-4 ${collapse == index ? "" : "tw-h-[0px] tw-overflow-hidden"}`,
                children: forms.length == 0 ? "" : forms.map(({ link: link, name: name }, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: "tw-font-medium tw-underline-offset-2 tw-underline tw-truncate",
                        href: link,
                        children: name && name.split("/", 4)[3]
                    }, idx))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "tw-flex tw-text-right tw-gap-1 tw-w-max",
                onClick: ()=>setCollapse(collapse == index ? -1 : index),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-font-medium tw-underline-offset-2 tw-underline",
                        children: collapse == index ? "Hide Docs" : "View Docs"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: `wi wi-xs wi-chevron-down ${collapse == index ? "tw-rotate-180" : ""}`
                    })
                ]
            })
        ]
    });
};









var $acw62 = parcelRequire("acw62");

const $166641b1bbc1826d$export$94cd2787c770a548 = ({ tabs: tabs, variant: variant = "default" })=>{
    const [activeTab, setActiveTab] = (0, $acw62.useState)(0);
    const contentRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (contentRef.current) {
            contentRef.current.style.animation = "none"; // reset animation
            setTimeout(()=>{
                contentRef.current.style.animation = "tw-fadeIn 0.3s ease-in-out forwards"; // apply animation
            }, 0);
        }
    }, [
        activeTab
    ]);
    let tabsClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-surfaceBlack90 tw-rounded tw-p-4");
    switch(variant){
        case "default":
            tabsClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-surfaceBlack90 tw-rounded tw-p-4");
            break;
        case "transparent":
            tabsClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-rounded tw-p-4");
            break;
        default:
            tabsClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-surfaceBlack90 tw-rounded tw-p-4");
            break;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: tabsClasses,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-justify-start tw-mb-4 tw-w-full tw-relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-absolute tw-inset-x-0 tw-bottom-0 tw-border-b-2 tw-border-surfaceGraphite"
                    }),
                    tabs.map((tab, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            role: "button",
                            tabIndex: 0,
                            className: `
      tw-pl-4 tw-pr-4 tw-pt-2
      tw-pb-4 
      tw-font-medium
      ${tab.disabled ? "tw-text-textSeal tw-cursor-not-allowed" : activeTab === index ? "tw-border-b-[6px] tw-border-textLime tw-text-textLime tw-cursor-pointer" : "tw-text-textDove tw-font-light tw-text-4 tw-cursor-pointer"}
      
    `,
                            "aria-disabled": tab.disabled ? "true" : "false",
                            onClick: ()=>{
                                if (!tab.disabled) setActiveTab(index);
                            },
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" && !tab.disabled) setActiveTab(index);
                            },
                            children: tab.label
                        }, index))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: tabs[activeTab].content
            })
        ]
    });
};


function $ebca4f14e7c63ea8$var$ArtistProfile(props) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [clientUserSettings, setClientUserSettings] = (0, $acw62.useState)();
    const [showNotesModal, setShowNotesModal] = (0, $acw62.useState)(false);
    const [showNonClientModal, setShowNonClientModal] = (0, $acw62.useState)(false);
    const [notes, setNotes] = (0, $acw62.useState)("");
    const [nonClient, setNonClient] = (0, $acw62.useState)(false);
    const [onboardedClient, setOnboardedClient] = (0, $acw62.useState)(true);
    const handleSaveNotes = async (e)=>{
        await saveNotes();
        setShowNotesModal(false);
    };
    const handleChangeNonClientStatus = async (e)=>{
        await saveNonClient();
        setShowNonClientModal(false);
    };
    const handleEditNonClientStatus = (e)=>{
        setShowNonClientModal(true);
    };
    const handleEditNotes = (e)=>{
        setShowNotesModal(true);
    };
    const fetchData = ()=>{
        if (clientId === undefined) return;
        api.listUsers().then((users)=>{
            api.retrieveUserSettings({
                userId: clientId
            }).then((userSettings)=>{
                setClientUserSettings(userSettings);
                setNotes(userSettings.notes ?? "");
                setNonClient(userSettings.nonClient ?? false);
                const user = users.find((u)=>u.userId === clientId);
                setOnboardedClient(user?.completedOnboardingSteps?.some((v)=>v.internalIdentifier === "3") ?? false);
            }).catch(()=>{});
        }).catch(()=>{});
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        clientId
    ]);
    const saveNotes = async ()=>{
        if (clientId === undefined) return;
        await api.partialUpdateUserSettings({
            userId: clientId,
            userSettings: {
                notes: notes
            }
        }).catch(()=>{});
    };
    const saveNonClient = async ()=>{
        if (clientId === undefined) return;
        await api.partialUpdateUserSettings({
            userId: clientId,
            userSettings: {
                nonClient: !nonClient
            }
        }).then(()=>{
            // After the update change the value
            setNonClient(!nonClient);
            props.onUpdateUserSettings?.();
        }).catch(()=>{});
    };
    const tabsData = [
        {
            label: "Memberships",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b50e3295c79031e$export$dc9ccbbcb120a24b), {
                clientId: clientId
            })
        },
        {
            label: "Documents",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1375e1af3934033d$export$2e2bcd8739ae039), {})
        },
        {
            label: "Logins",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d8534347d87e2bc$export$2e2bcd8739ae039), {})
        },
        {
            label: "Profile",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $afe9a0da052a3541$export$2e2bcd8739ae039), {})
        },
        {
            label: "Statements",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7da0a64248b8a85c$export$2e2bcd8739ae039), {}),
            disabled: true
        },
        {
            label: "Bank Details",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca5b5ac444ab6215$export$2e2bcd8739ae039), {})
        },
        {
            label: "Representatives",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2530899195e704ad$export$2e2bcd8739ae039), {})
        },
        {
            label: "Activity log",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23623e1edf3b4c4c$export$2e2bcd8739ae039), {
                clientId: clientId
            }),
            disabled: true
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-w-3/4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-w-full tw-h-24 tw-justify-between tw-items-start tw-gap-2 tw-inline-flex",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-justify-start tw-items-start tw-gap-2.5 tw-flex",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-justify-start tw-items-start tw-gap-4 tw-flex",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    className: "tw-w-24 tw-h-24 tw-rounded-full",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c0b087292c3026cb$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-h-24 tw-flex-col tw-justify-between tw-items-start tw-gap-3 tw-inline-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-flex-col tw-justify-center tw-items-start tw-gap-1 tw-flex",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-text-textWhite tw-text-lg tw-font-semibold tw-leading-tight",
                                                children: `${clientUserSettings?.firstName ?? ""} ${clientUserSettings?.lastName ?? ""}`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-py-2 tw-rounded-full tw-justify-center tw-items-center tw-gap-1 tw-inline-flex",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-text-textWhite tw-text-sm tw-font-medium tw-leading-none tw-tracking-tight",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039), {
                                                    onSubmit: saveNotes,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-gap-3",
                                                            children: [
                                                                !onboardedClient ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                    disabled: onboardedClient,
                                                                    type: "button",
                                                                    className: "tw-flex tw-items-center tw-gap-2 tw-bg-gray-700 tw-px-3 tw-py-1.5 tw-rounded-md",
                                                                    onClick: (e)=>{
                                                                        if (onboardedClient) return;
                                                                        e.stopPropagation();
                                                                        e.preventDefault();
                                                                        handleEditNonClientStatus(e);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "tw-text-sm tw-text-gray-300",
                                                                            children: nonClient ? "Non-Client" : onboardedClient ? "Client" : "Potential Client"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: `tw-relative tw-inline-flex tw-h-5 tw-w-9 tw-items-center tw-rounded-full tw-transition-colors tw-focus:outline-none ${!nonClient ? onboardedClient ? "tw-bg-gray-500" : "tw-bg-surfaceLime" : "tw-bg-westburyRed"}`,
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: `tw-inline-block tw-h-3.5 tw-w-3.5 tw-transform tw-rounded-full tw-bg-white tw-transition-transform ${!nonClient ? "tw-translate-x-5" : "tw-translate-x-1"}`
                                                                            })
                                                                        })
                                                                    ]
                                                                }) : null,
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                    type: "button",
                                                                    className: "tw-flex tw-items-center tw-gap-2 tw-bg-gray-700 tw-px-3 tw-py-1.5 tw-rounded-md",
                                                                    onClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        e.preventDefault();
                                                                        handleEditNotes(e);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                            className: `wi wi-sm wi-edit tw-mr-2`
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "tw-text-gray-300 tw-text-sm tw-hover:text-white",
                                                                            children: "Notes"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                                                            onClose: ()=>setShowNotesModal(false),
                                                            isOpen: showNotesModal,
                                                            title: `Notes`,
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "tw-flex tw-flex-col",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                                        name: "notes",
                                                                        rows: 20,
                                                                        cols: 100,
                                                                        value: notes,
                                                                        onChange: (e)=>setNotes(e.target.value),
                                                                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-resize-none", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-w-[450px]", "tw-placeholder-textSeal", "tw-text-sm", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "tw-w-[135px] tw-mt-4",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                            label: "Save Changes",
                                                                            variant: "primary",
                                                                            onClick: handleSaveNotes
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                                                            onClose: ()=>setShowNonClientModal(false),
                                                            isOpen: showNonClientModal,
                                                            title: nonClient ? `Change to Potential Client?` : `Change to Non-Client?`,
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "tw-flex tw-flex-col",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        children: `Are you sure you want to change this client's status to ${nonClient ? "Potential Client" : "Non-Client"}?`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "tw-w-[135px] tw-mt-4",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                            label: "Yes, Change Status",
                                                                            variant: "primary",
                                                                            onClick: handleChangeNonClientStatus
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $166641b1bbc1826d$export$94cd2787c770a548), {
                    tabs: tabsData
                })
            ]
        })
    });
}
var $ebca4f14e7c63ea8$export$2e2bcd8739ae039 = $ebca4f14e7c63ea8$var$ArtistProfile;



/* eslint-disable jsx-a11y/no-noninteractive-element-interactions -- TODO: fix this error */ /* eslint-disable jsx-a11y/click-events-have-key-events -- TODO: fix this error */ 

var $acw62 = parcelRequire("acw62");




const $b670b0fa618e72bc$var$DEFAULT_SORT_ORDER = "asc";
const $b670b0fa618e72bc$var$DEFAULT_CLIENT_STATUS = "all";
const $b670b0fa618e72bc$var$getStatusColor = (artist)=>{
    if (artist.completedOnboardingSteps?.some((step)=>step.internalIdentifier === "3")) return "tw-border-westburyGreen tw-shadow-[0_0_12px_-2px_rgba(34,197,94,0.6)]";
    else if (artist.nonClient) return "tw-border-westburyRed tw-shadow-[0_0_12px_-2px_rgba(239,68,68,0.6)]";
    else if (!artist.completedOnboardingSteps?.some((step)=>step.internalIdentifier === "3")) return "tw-border-surfaceLime tw-shadow-[0_0_12px_-2px_rgba(234,179,8,0.6)]";
};
const $b670b0fa618e72bc$export$9065637e0752ea92 = ({ artists: artists })=>{
    const [artistsSearch, setArtistsSearch] = (0, $fcbcabcdd5e0aacc$export$b313845ce8fd18ca)("artist-list_search", "", {
        namespace: "clients-list"
    });
    const searchRegex = new RegExp(artistsSearch, "i");
    const { clientId: clientId, setClientId: setClientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [sortOrder, setSortOrder] = (0, $fcbcabcdd5e0aacc$export$b313845ce8fd18ca)("artist-list_sort-order", $b670b0fa618e72bc$var$DEFAULT_SORT_ORDER, {
        namespace: "clients-list"
    });
    const [selectedStatus, setSelectedStatus] = (0, $fcbcabcdd5e0aacc$export$b313845ce8fd18ca)("artist-list_selected-status", $b670b0fa618e72bc$var$DEFAULT_CLIENT_STATUS, {
        namespace: "clients-list"
    });
    const filteredArtists = (0, $acw62.useMemo)(()=>{
        const result = artists.filter((artist)=>{
            return searchRegex.test(artist.fullName ?? "");
        }).filter((artist)=>{
            if (selectedStatus === "all") return true;
            if (selectedStatus === "client") return artist.completedOnboardingSteps?.some((step)=>step.internalIdentifier === "3");
            if (selectedStatus === "potential" && !artist.nonClient) return !artist.completedOnboardingSteps?.some((step)=>step.internalIdentifier === "3");
            if (selectedStatus === "non-client") return artist.nonClient;
        });
        return result.sort((a, b)=>{
            if (sortOrder === "asc") return a.fullName?.localeCompare(b.fullName ?? "") ?? -1;
            return b.fullName?.localeCompare(a.fullName ?? "") ?? 1;
        });
    }, [
        artists,
        artistsSearch,
        sortOrder,
        selectedStatus
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-mb-6 tw-w-full",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "Search"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-1.5 tw-text-gray-300",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: selectedStatus || "",
                                onChange: (e)=>{
                                    const isClientStatus = (value)=>{
                                        return [
                                            "all",
                                            "client",
                                            "potential",
                                            "non-client"
                                        ].includes(`${value}`);
                                    };
                                    const targetValue = e.target.value;
                                    if (isClientStatus(targetValue)) setSelectedStatus(targetValue);
                                },
                                className: "tw-bg-[#2c2c2c] tw-text-xs tw-rounded-lg tw-px-2 tw-py-1 tw-pr-7 tw-focus:outline-none tw-hover:bg-[#3c3c3c] tw-cursor-pointer tw-appearance-none tw-relative tw-min-w-[120px]",
                                style: {
                                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%239CA3AF'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "right 0.25rem center",
                                    backgroundSize: "1.25em 1.25em"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        className: "tw-text-xs",
                                        value: "all",
                                        children: "All Clients"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        className: "tw-text-xs",
                                        value: "client",
                                        children: "Client"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        className: "tw-text-xs",
                                        value: "potential",
                                        children: "Potential Client"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        className: "tw-text-xs",
                                        value: "non-client",
                                        children: "Non-Client"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>setSortOrder(sortOrder === "asc" ? "desc" : "asc"),
                                className: "tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-1 tw-bg-[#2c2c2c] tw-rounded-lg hover:tw-bg-[#3c3c3c] tw-transition-colors",
                                title: `Sort ${sortOrder === "asc" ? "descending" : "ascending"}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "tw-text-xs tw-font-medium",
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "tw-text-xs tw-font-medium tw-opacity-75",
                                        children: sortOrder === "asc" ? "A-Z" : "Z-A"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-relative tw-mt-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: `wi wi-20px wi-search tw-absolute tw-left-3 tw-top-[14px]`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-12", "tw-placeholder-textSeal", "tw-text-sm", "tw-leading-5", "tw-p-3", "tw-pl-9", "tw-mb-2", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none"),
                        name: Math.random().toString(),
                        placeholder: "Search artists...",
                        value: artistsSearch,
                        autoComplete: "off",
                        onChange: (e)=>setArtistsSearch(e.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "tw-max-h-[650px] tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-textDove tw-scrollbar-track-surfaceBlack90 tw-scrollbar-thumb-rounded-full",
                children: filteredArtists.length > 0 ? filteredArtists.map((artist)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        onClick: ()=>setClientId(artist?.userId),
                        className: `tw-flex tw-items-center tw-py-1.5 tw-px-2 tw-rounded-md tw-cursor-pointer tw-transition-colors
                ${clientId === artist.userId ? "tw-bg-[#3c3c3c]" : "tw-hover:bg-[#3c3c3c]"}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-relative tw-mr-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: `tw-w-7 tw-h-7 tw-rounded-full tw-border-2 ${$b670b0fa618e72bc$var$getStatusColor(artist)}`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        // TODO: Avatar support has not been implemented yet
                                        // src={artist?.image ? artist?.image : SquarePlaceholder100}
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($37e781df277582a4$exports))),
                                        alt: artist?.fullName,
                                        className: "tw-rounded-full tw-w-full tw-h-full tw-object-cover"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-base",
                                children: artist?.fullName
                            })
                        ]
                    }, artist.userId);
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8 tw-text-gray-400",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: `wi wi-20px wi-search tw-absolute tw-left-3 tw-top-[14px] tw-w-12 tw-h-12 tw-mb-3 tw-opacity-20`
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-sm",
                            children: "No clients found"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-xs tw-mt-1 tw-text-gray-500",
                            children: "Try adjusting your search or filter"
                        })
                    ]
                })
            })
        ]
    });
};



const $9d9bb54aa06aaaca$export$512fe4ab09c7f75b = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
        extraClasses: "tw-w-1/4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b670b0fa618e72bc$export$9065637e0752ea92), {
            ...props
        })
    });
};








var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


const $e3f6b519d8ab6432$export$a2b46379940c75c8 = ({ name: name, label: label, optionalLabel: optionalLabel = false, addCaption: addCaption = "Add", values: values, placeholder: placeholder, disabled: disabled = false, onChange: onChange })=>{
    const { isEditing: isEditing, errors: errors, setErrors: setErrors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const valuesComputed = (0, $acw62.useMemo)(()=>{
        if (!values.length) return [
            ""
        ];
        return values;
    }, [
        values
    ]);
    const handleChange = (value, index)=>{
        let newValues = [
            ...values
        ];
        newValues[index] = value;
        onChange(newValues);
    };
    const handleAdd = ()=>{
        onChange([
            ...valuesComputed,
            ""
        ]);
    };
    const handleRemove = (index)=>{
        const newErrors = {
            ...errors
        };
        for(let index = 0; index < values.length; index++)delete newErrors[`${name}.${index}`];
        setErrors(newErrors);
        let newValues = [
            ...values
        ];
        newValues.splice(index, 1);
        onChange(newValues);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            label != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                htmlFor: name,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-space-x-1 tw-justify-between tw-leading-4 tw-text-white tw-mb-2 tw-capitalize", {
                    "tw-text-[14px]": !isEditing
                }),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                            "tw-text-westburyRed": isEditing && errors[name]
                        }),
                        children: label
                    }),
                    optionalLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-xs tw-leading-4 tw-text-gray-400",
                        children: "Optional"
                    })
                ]
            }),
            valuesComputed.map((value, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                        "tw-mb-4": isEditing,
                        "tw-mb-1.5": !isEditing
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-items-center tw-gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-flex-1",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e3f6b519d8ab6432$var$TextInput, {
                                        name: `${name}.${i}`,
                                        value: value,
                                        error: errors[`${name}.${i}`],
                                        placeholder: placeholder,
                                        isEditing: isEditing,
                                        isFirst: i === 0,
                                        disabled: disabled,
                                        onChange: (e)=>handleChange(e.target.value, i)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-text-sm tw-ml-2", {
                                        "tw-hidden": !isEditing || valuesComputed.length === 1
                                    }),
                                    onClick: ()=>handleRemove(i),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "wi wi-20px wi-minus tw-mr-1"
                                    })
                                })
                            ]
                        }),
                        isEditing && errors[`${name}.${i}`] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-text-westburyRed tw-text-xs tw-mt-2",
                            children: errors[`${name}.${i}`]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-justify-end tw-mt-2", {
                                "tw-hidden": // Display only while editing and only under last field
                                !isEditing || i !== valuesComputed.length - 1
                            }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "tw-text-sm tw-ml-2",
                                onClick: handleAdd,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "wi wi-20px wi-plus tw-mr-1"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-underline",
                                            children: addCaption
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }, i))
        ]
    });
};
const $e3f6b519d8ab6432$var$TextInput = ({ name: name, value: value, error: error, placeholder: placeholder, isEditing: isEditing, isFirst: isFirst = false, disabled: disabled, onChange: onChange })=>{
    const [focused, setFocused] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        name: name,
                        id: name,
                        onFocus: ()=>setFocused(true),
                        onBlur: ()=>setFocused(false),
                        placeholder: placeholder,
                        value: value,
                        disabled: disabled,
                        onChange: onChange,
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-h-12", "tw-w-full", "tw-placeholder-textSeal", "tw-appearance-none", "tw-leading-5", "tw-p-3", "tw-border-2", {
                            "tw-border-formInputBackground": error
                        }, "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none", {
                            "tw-border-transparent": !error
                        }, {
                            "tw-border-westburyRed": isEditing && error
                        }, {
                            "tw-font-extraLight": disabled
                        }, {
                            "tw-cursor-not-allowed": disabled
                        })
                    }),
                    isEditing && !focused && error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "tw-absolute tw-right-0 tw-top-1 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "wi wi-20px wi-alert tw-text-westburyRed"
                        })
                    }),
                    disabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "tw-absolute tw-right-0 tw-top-1 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "wi wi-20px wi-ban"
                        })
                    })
                ]
            }),
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-text-textDove tw-text-[14px]",
                children: value != "" ? value : isFirst && "-"
            })
        ]
    });
};






const $1302faaf406b7a36$export$3c6f31a474a5c858 = ({ handleSubmit: handleSubmit, onSuccess: onSuccess, onSuccessMessage: onSuccessMessage, formData: formData, setFormData: setFormData })=>{
    const inputChange = (e)=>{
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        firstName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty({
            message: "First name is required"
        }),
        middleName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
        lastName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty({
            message: "Last name is required"
        }),
        email: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email({
            message: "Please provide a valid email address"
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-flex-col tw-w-[600px] tw-justify-center tw-items-center tw-content-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-mt-4 tw-flex tw-flex-col tw-min-w-[536px]",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                editByDefault: true,
                handleSubmit: handleSubmit,
                schema: schema,
                formData: formData,
                onSuccessMessage: onSuccessMessage,
                onSuccess: onSuccess,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "firstName",
                            label: "First Name",
                            value: formData.firstName,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "middleName",
                            label: "Middle Name",
                            value: formData.middleName,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "lastName",
                            label: "Last Name",
                            value: formData.lastName,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f6b519d8ab6432$export$a2b46379940c75c8), {
                            name: "aliases",
                            label: "Aliases",
                            optionalLabel: true,
                            addCaption: "Add another alias",
                            values: formData.aliases,
                            onChange: (aliases)=>setFormData({
                                    ...formData,
                                    aliases: aliases
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "pplPerformerName",
                            label: "PPL Contributor Name",
                            optionalLabel: true,
                            value: formData.pplPerformerName,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "pplPerformerId",
                            label: "PPL Performer ID",
                            optionalLabel: true,
                            value: formData.pplPerformerId,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "email",
                            name: "email",
                            label: "Email",
                            value: formData.email,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-items-center tw-justify-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1302faaf406b7a36$var$EOIFormFooter, {})
                    })
                ]
            })
        })
    });
};
function $1302faaf406b7a36$var$EOIFormFooter() {
    // large submit button
    const { handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-items-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                label: "Send",
                extraClasses: "tw-w-[200px]",
                variant: "primary-lg",
                onClick: ()=>{
                    handleFormSubmit(formData);
                }
            })
        })
    });
}



const $9f5866cad2a8c59d$var$AddNewUserModal = ({ isOpen: isOpen, onClose: onClose, fetchData: fetchData })=>{
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [successful, setSuccessful] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const emptyState = {
        email: "",
        firstName: "",
        middleName: "",
        lastName: "",
        aliases: [],
        pplPerformerName: "",
        pplPerformerId: ""
    };
    const [formData, setFormData] = (0, $acw62.useState)(emptyState);
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const handleSubmit = async ()=>{
        return api.createAdminInterestRegistration({
            adminInterestRegistration: formData
        }).then((response)=>{
            return Promise.resolve(response);
        }).catch(async (data)=>{
            const errors = await data.response.json();
            // Format server-side validation errors for setting in form context
            const newErrors = {
                ...errors
            };
            if (errors.aliases) {
                Object.entries(errors.aliases).map(([i, messages])=>{
                    newErrors[`aliases.${i}`] = messages[0];
                });
                delete newErrors.aliases;
            }
            onClose();
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Please try again later"));
            return Promise.reject(newErrors);
        });
    };
    const onSuccess = ()=>{
        fetchData();
        setSuccessful(true);
    };
    const closeModal = ()=>{
        onClose();
        setSuccessful(false);
    };
    if (successful) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        title: "",
        isOpen: isOpen,
        onClose: closeModal,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
            title: "New User Added",
            description: "You can now run a discography for this user from your dashboard",
            cta: {
                ctaText: "Go To Dashboard",
                onClick: ()=>{
                    navigate("/dashboard");
                }
            }
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        title: "Add New User",
        isOpen: isOpen,
        onClose: closeModal,
        modalClasses: "tw-max-h-[100vh] tw-overflow-y-scroll",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1302faaf406b7a36$export$3c6f31a474a5c858), {
            handleSubmit: handleSubmit,
            onSuccess: onSuccess,
            formData: formData,
            setFormData: setFormData
        })
    });
};
var $9f5866cad2a8c59d$export$2e2bcd8739ae039 = $9f5866cad2a8c59d$var$AddNewUserModal;



function $18e6c9218ed081af$var$Clients() {
    const [isArtist, setIsArtist] = (0, $acw62.useState)(true);
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { clientId: clientId, setClientId: setClientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [clientsScreenId, setClientsScreenId] = (0, $fcbcabcdd5e0aacc$export$b313845ce8fd18ca)("clients-screen-id", clientId, {
        namespace: "clients-list"
    });
    (0, $acw62.useEffect)(()=>{
        setClientsScreenId(clientId);
    }, [
        clientId
    ]);
    const [clientList, setClientList] = (0, $acw62.useState)([]);
    const [addNewUserModalIsOpen, setAddNewUserModalIsOpen] = (0, $acw62.useState)(false);
    let societies = [];
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = ()=>{
        api.listUsers().then((clients)=>{
            console.log("clients", clients);
            setClientList(// set image to empty string pending backend implementation
            clients.map((client)=>{
                return {
                    ...client,
                    image: ""
                };
            }));
            if (clients.find((c)=>c.userId === clientsScreenId)) setClientId(clientsScreenId);
            else if (clients.length > 0) {
                const firstId = clients[0].userId;
                setClientId(firstId);
            }
        }).catch((error)=>{});
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: " Clients "
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-mt-6 tw-justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                variant: "link-secondary",
                                icon: "chevron-left",
                                onClick: ()=>{
                                    window.history.back();
                                },
                                label: "Back"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                onClick: ()=>{
                                    setAddNewUserModalIsOpen(true);
                                },
                                label: "Add New User"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-space-x-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d9bb54aa06aaaca$export$512fe4ab09c7f75b), {
                                artists: clientList
                            }),
                            isArtist ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebca4f14e7c63ea8$export$2e2bcd8739ae039), {
                                onUpdateUserSettings: fetchData
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f5866cad2a8c59d$export$2e2bcd8739ae039), {
                isOpen: addNewUserModalIsOpen,
                onClose: ()=>{
                    setAddNewUserModalIsOpen(false);
                },
                fetchData: fetchData
            })
        ]
    });
}
var $18e6c9218ed081af$export$2e2bcd8739ae039 = $18e6c9218ed081af$var$Clients;




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

const $4f7fd67b634ac85e$export$d1e8ba5e4089efe = [
    {
        soc: "SPEDIDAM",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "PlayRight",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "GRAMEX Finland",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "ABRAMUS",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "ADAMI",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "VOIS",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "SPEDIDAM",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "NORMA",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "RAAP",
        date: "17/04/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "PlayRight",
        date: "17/04/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "SPEDIDAM",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "PlayRight",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "GRAMEX Finland",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "ABRAMUS",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "ADAMI",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "VOIS",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "SPEDIDAM",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "NORMA",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "RAAP",
        date: "17/04/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "PlayRight",
        date: "17/04/22",
        file: "https://www.westburymusic.com"
    }
];
const $4f7fd67b634ac85e$export$55f33ffac4e7d3c9 = [
    {
        soc: "SoundExchange",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "GRAMEX Denmark",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "GRAMEX Finland",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "ABRAMUS",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "ADAMI",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "VOIS",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "SPEDIDAM",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "NORMA",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "RAAP",
        date: "17/04/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "PlayRight",
        date: "17/04/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "SPEDIDAM",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "PlayRight",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "GRAMEX Finland",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "ABRAMUS",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "ADAMI",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "VOIS",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "SPEDIDAM",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "NORMA",
        date: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "RAAP",
        date: "17/04/22",
        file: "https://www.westburymusic.com"
    },
    {
        soc: "PlayRight",
        date: "17/04/22",
        file: "https://www.westburymusic.com"
    }
];
const $4f7fd67b634ac85e$export$b3cba2aa1af370a2 = [
    {
        date: "19/05/22",
        deadline: "19/06/22",
        date_send: "19/05/22",
        file: "https://www.westburymusic.com"
    },
    {
        date: "19/03/21",
        deadline: "17/06/21",
        date_send: "17/05/21",
        file: "https://www.westburymusic.com"
    },
    {
        date: "19/03/20",
        deadline: "16/06/20",
        date_send: "16/05/20",
        file: "https://www.westburymusic.com"
    }
];






var $acw62 = parcelRequire("acw62");


const $3b326474f29c412d$export$571ff81a11fed4f6 = ({ title: title, children: children, extraClasses: extraClasses = "", isOpen: isOpen = false, hasTitle: hasTitle = true, disabled: disabled = false })=>{
    const [isOpenInner, setIsOpenInner] = (0, $acw62.useState)(isOpen);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
        extraClasses: extraClasses,
        children: [
            hasTitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-full", "tw-text-left", "tw-text-xl", "tw-cursor-pointer", "tw-block", "tw-bg-surfaceBlack90", "tw-flex", "tw-justify-between", "tw-items-center", disabled ? "tw-text-textSeal tw-cursor-not-allowed" : "tw-text-textWhite", "tw-rounded-lg", {
                    "tw-pb-8": isOpenInner
                }),
                onClick: ()=>!disabled && setIsOpenInner(!isOpenInner),
                disabled: disabled,
                children: [
                    title,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: `wi tw-w-[40px] tw-h-[40px] wi-chevron-${isOpenInner ? "up" : "down"}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `tw-overflow-hidden
        tw-transition-all
        tw-duration-300
        tw-ease-in-out
        ${isOpenInner ? "" : "tw-max-h-0"}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-w-full tw-bg-tw-surfaceBlack90 tw-rounded-b-lg",
                    children: children
                })
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");








const $84675b212a988315$export$d46b78752cfe59ac = ({ clientId: clientId })=>{
    const [secondaryDiscographyRuns, setSecondaryDiscographyRuns] = (0, $acw62.useState)([]);
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [tableData, setTableData] = (0, $acw62.useState)([]);
    const fetchData = async ()=>{
        api.listListSecondaryDiscographies({
            userId: clientId
        }).then((res)=>setSecondaryDiscographyRuns(res)).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Failed to fetch secondary discography data"));
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        clientId
    ]);
    const columnStyle = {
        fontSize: "14px",
        fontWeight: 400,
        borderBottom: "1px solid #AAB2B9"
    };
    const rowStyle = {
        fontSize: "14px",
        fontWeight: 300,
        borderBottom: "1px solid #535D66"
    };
    const columns = [
        {
            title: "Society",
            width: "1fr",
            dataKey: "societyName"
        },
        {
            title: "Territory",
            width: "1fr",
            dataKey: "country"
        },
        {
            title: "Status",
            width: "1fr",
            dataKey: "status"
        },
        {
            title: "File",
            width: "1fr",
            dataKey: "url"
        },
        {
            title: "Date Generated",
            width: "1fr",
            dataKey: "dateCreated"
        },
        {
            title: "Date Sent to Society",
            width: "2fr",
            dataKey: "dateSentToSociety"
        }
    ];
    const statusMap = {
        "SecondaryDiscographyStatus.SUCCEEDED": "Succeeded",
        "SecondaryDiscographyStatus.FAILED": "Failed",
        "SecondaryDiscographyStatus.IN_PROGRESS": "Pending"
    };
    (0, $acw62.useEffect)(()=>{
        console.log(secondaryDiscographyRuns);
        const tableData = secondaryDiscographyRuns.map((data, index)=>{
            return {
                societyName: data.societyName,
                country: data.country,
                status: statusMap[data.status],
                url: buildLink(data.s3Url, data.societyName),
                dateCreated: new Date(data.dateCreated).toLocaleDateString(),
                dateSentToSociety: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($84675b212a988315$var$SentToSocietyDate, {
                    date: data.dateSentToSociety ? new Date(data.dateSentToSociety).toLocaleDateString() : null,
                    isEditing: false,
                    handleSubmit: (newDate)=>{
                        const dateObject = new Date(newDate);
                        updateSentToSocietyDate(data.id, dateObject);
                    }
                })
            };
        });
        setTableData(tableData);
    }, [
        secondaryDiscographyRuns
    ]);
    const updateSentToSocietyDate = (exportId, date)=>{
        api.updateUpdateSecondaryDiscography({
            exportId: exportId,
            updateSecondaryDiscography: {
                dateSentToSociety: date
            }
        }).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Error updating date sent to society"));
        });
    };
    if (!clientId) return null;
    const buildLink = (s3Url, society)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
            className: "tw-font-medium tw-underline-offset-2 tw-underline tw-truncate",
            href: s3Url,
            children: s3Url && `${society}.csv`
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
        columns: columns,
        data: tableData,
        columnStyle: columnStyle,
        rowStyle: secondaryDiscographyRuns.map(()=>rowStyle)
    });
};
const $84675b212a988315$var$EditButton = ({ onSave: onSave })=>{
    const { isEditing: isEditing, setIsEditing: setIsEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: !isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            label: "",
            icon: "edit",
            variant: "secondary",
            onClick: ()=>setIsEditing(!isEditing)
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            label: "Save",
            variant: "primary",
            onClick: ()=>{
                setIsEditing(!isEditing);
                onSave();
            }
        })
    });
};
const $84675b212a988315$var$SentToSocietyDate = ({ date: date, isEditing: isEditing, handleSubmit: handleSubmit })=>{
    const [newDate, setNewDate] = (0, $acw62.useState)(date || "");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            handleSubmit: ()=>{},
            schema: undefined,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-row tw-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mr-2 tw-mt-8 tw-min-w-[120px]",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "date",
                            name: "dateSentToSociety",
                            label: "",
                            value: newDate,
                            onChange: (e)=>setNewDate(e.target.value),
                            onBlur: ()=>{},
                            isFieldEditing: isEditing
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($84675b212a988315$var$EditButton, {
                        onSave: ()=>handleSubmit(newDate)
                    })
                ]
            })
        })
    });
};


function $00a88ce8ccd3a8c7$var$ArtistDiscography() {
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const [socRips, setsocRips] = (0, $acw62.useState)(0);
    const [socDioscSub, setsocDioscSub] = (0, $acw62.useState)(0);
    const [socRipsList, setSocRipsList] = (0, $acw62.useState)((0, $4f7fd67b634ac85e$export$d1e8ba5e4089efe));
    const [socDiscSub, setSocDiscSub] = (0, $acw62.useState)((0, $4f7fd67b634ac85e$export$55f33ffac4e7d3c9));
    const saveDetails = (e, index)=>{
        const soc = e.target.getAttribute("dataSocd");
        const file = e.target.getAttribute("dataFile");
        const date = e.target.getAttribute("dataDate");
        const data = {
            soc: soc,
            file: file,
            date: date
        };
        // API call to save the data
        setIsEditing(false);
    };
    const socRipsListData = socRipsList.map((societyLog, index)=>({
            ...societyLog,
            date: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: societyLog.date
            }),
            file: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: societyLog.file,
                    className: "fileLink",
                    target: "_blank",
                    rel: "noreferrer",
                    children: societyLog.file
                })
            })
        }));
    const societyLogData = socDiscSub.map((societyLog, index)=>({
            ...societyLog,
            date: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "dateReceived",
                children: societyLog.date
            }),
            file: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fileLinkCol",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: societyLog.file,
                    className: "fileLink",
                    target: "_blank",
                    rel: "noreferrer",
                    children: societyLog.file
                })
            }),
            fileEditMode: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fileEditMode",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "actionButtons",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        label: "Edit",
                        icon: "edit",
                        onClick: ()=>setIsEditing(index)
                    })
                })
            }),
            fileSendButton: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fileSendButton",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "portLink",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "send-to-btn btn",
                        children: "Send to society"
                    })
                })
            })
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-w-3/4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/discography/${clientId}`,
                    state: {
                        artist_name: clientId
                    },
                    className: "",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-justify-between tw-text-xl tw-items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "",
                                children: "Discography"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi tw-h-[40px] tw-w-[40px] wi-chevron-right"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/discography-registrations/${clientId}`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-justify-between tw-text-xl tw-items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "",
                                children: "Registrations"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi tw-h-[40px] tw-w-[40px] wi-chevron-right"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                title: "Society Rips",
                disabled: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$e2595d8541f6e8ef), {
                    columns: [
                        {
                            title: "Society",
                            width: "1fr",
                            dataKey: "soc"
                        },
                        {
                            title: "Date received",
                            width: "1fr",
                            dataKey: "date"
                        },
                        {
                            title: "File",
                            width: "1fr",
                            dataKey: "file"
                        }
                    ],
                    data: socRipsListData
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                title: "Society Discography Submissions",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84675b212a988315$export$d46b78752cfe59ac), {
                    clientId: clientId
                })
            })
        ]
    });
}
var $00a88ce8ccd3a8c7$export$2e2bcd8739ae039 = $00a88ce8ccd3a8c7$var$ArtistDiscography;





var $acw62 = parcelRequire("acw62");

const $1a1628d10090d156$export$cf7911419577c55d = ({ societiesComponent: societiesComponent, artistsComponent: artistsComponent })=>{
    const [view, setView] = (0, $acw62.useState)("artists");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
        extraClasses: "tw-w-1/4",
        children: [
            view === "societies" && societiesComponent,
            view === "artists" && artistsComponent
        ]
    });
};




var $acw62 = parcelRequire("acw62");


const $d6fc63188fe3db22$export$dd467e6bea57703c = ({ societies: societies, societySelected: societySelected, isEditingSociety: isEditingSociety, societyClickHandler: societyClickHandler })=>{
    const [societiesSearch, setSocietiesSearch] = (0, $acw62.useState)("");
    // Convert the search string to a regex pattern for flexible matching.
    const searchRegex = new RegExp(societiesSearch, "i");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-mb-6",
        children: [
            "Search",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-relative tw-mt-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: `wi wi-20px wi-search tw-absolute tw-left-3 tw-top-[14px]`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-12", "tw-placeholder-textSeal", "tw-text-sm", "tw-leading-5", "tw-p-3", "tw-pl-9", "tw-mb-2", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none"),
                        placeholder: "Search societies...",
                        value: societiesSearch,
                        onChange: (e)=>setSocietiesSearch(e.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "tw-mt-4 tw-max-h-[850px] tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-textDove tw-scrollbar-track-surfaceBlack90 tw-scrollbar-thumb-rounded-full",
                children: societies.filter((society)=>searchRegex.test(society.readableName)).map((society)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        onClick: ()=>societyClickHandler(society),
                        className: `
                        tw-pt-2
                        tw-pb-2
                        tw-flex
                        tw-items-center
                        tw-cursor-pointer
                        tw-border-b
                        tw-border-surfaceGraphite
                        ${societySelected?.id === society.id ? `tw-bg-surfaceGraphite` : ``}
                        `,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "tw-w-10 tw-h-10 tw-rounded-full tw-m-2 tw-mr-4",
                                src: society.logoUrl ? society.logoUrl : (0, (/*@__PURE__*/$parcel$interopDefault($37e781df277582a4$exports))),
                                alt: society.readableName
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-ml-4 tw-text-textWhite",
                                children: society.readableName
                            })
                        ]
                    }, society.id))
            })
        ]
    });
};




function $8d152945f8a08a4a$var$Discography() {
    const [isArtist, setIsArtist] = (0, $acw62.useState)(true);
    const { clientId: clientId, setClientId: setClientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [clientsScreenId, setClientsScreenId] = (0, $fcbcabcdd5e0aacc$export$b313845ce8fd18ca)("clients-screen-id", clientId, {
        namespace: "clients-list"
    });
    (0, $acw62.useEffect)(()=>{
        setClientsScreenId(clientId);
    }, [
        clientId
    ]);
    const [clientList, setClientList] = (0, $acw62.useState)([]);
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = ()=>{
        api.listUsers().then((clients)=>{
            setClientList(()=>// set image to empty string pending backend implementation
                clients.map((client)=>{
                    return {
                        ...client,
                        image: ""
                    };
                }));
            if (clients.find((c)=>c.userId === clientsScreenId)) setClientId(clientsScreenId);
            else if (clients.length > 0) {
                const firstId = clients[0].userId;
                setClientId(firstId);
            }
        }).catch((error)=>{});
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Discography"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-full tw-flex tw-space-x-6 tw-justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a1628d10090d156$export$cf7911419577c55d), {
                        societiesComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fc63188fe3db22$export$dd467e6bea57703c), {
                            societies: [],
                            societySelected: undefined,
                            isEditingSociety: false,
                            societyClickHandler: ()=>{}
                        }),
                        artistsComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b670b0fa618e72bc$export$9065637e0752ea92), {
                            artists: clientList
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a88ce8ccd3a8c7$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
var $8d152945f8a08a4a$export$2e2bcd8739ae039 = $8d152945f8a08a4a$var$Discography;




var $acw62 = parcelRequire("acw62");

function $8b882307f2535c6a$var$Distribution() {
    const [sidebarSmall, setSidebarSmall] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {});
}
var $8b882307f2535c6a$export$2e2bcd8739ae039 = $8b882307f2535c6a$var$Distribution;




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");






const $2fd8517427d10e3a$var$ArtistDetails = ({ userSettings: userSettings, onSave: onSave })=>{
    const [editedSettings, setEditedSettings] = (0, $acw62.useState)({
        emailAddress: userSettings?.emailAddress,
        firstName: userSettings.firstName,
        lastName: userSettings.lastName,
        middleName: userSettings.middleName
    });
    const handleSaveClick = ()=>{
        return onSave(editedSettings);
    };
    function FormEditSection() {
        const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-w-1/10",
            children: !isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                label: "Edit",
                icon: "edit",
                variant: "secondary",
                onClick: ()=>setIsEditing(!isEditing)
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                label: "Save",
                variant: "primary",
                onClick: ()=>{
                    setIsEditing(!isEditing);
                    handleSaveClick();
                }
            })
        });
    }
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        setEditedSettings((prevSettings)=>({
                ...prevSettings,
                [name]: value
            }));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
            extraClasses: "tw-flex tw-flex-col tw-w-[575px]",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                editByDefault: false,
                handleSubmit: handleSaveClick,
                schema: undefined,
                formData: editedSettings,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-justify-between tw-mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-text-2xl",
                                children: "Artist Details"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FormEditSection, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa586959ed1a48eb$export$2e2bcd8739ae039), {
                        editedSettings: editedSettings,
                        handleInputChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "email",
                        name: "emailAddress",
                        label: "Email",
                        value: editedSettings.emailAddress,
                        onChange: handleInputChange
                    })
                ]
            })
        })
    });
};
var $2fd8517427d10e3a$export$2e2bcd8739ae039 = $2fd8517427d10e3a$var$ArtistDetails;


// a React typscript component to confirm that the terms of agreement have been sent to the user. It has a thumbs up icon and a message.
// The title says Sent to client, beneath the icon. The message says The agreement has been sent and you will be notified once signed by client
// It has a button that says Go back to dashboard. When clicked, it takes the user back to the dashboard.

parcelRequire("acw62");


const $02c9992193821d99$var$TermsOfAgreementSent = ({ onGoBackToDashboard: onGoBackToDashboard })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-p-4 tw-pl-0 tw-text-center tw-w-[575px]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "wi wi-verification-check-filled wi-lg",
                        style: {
                            backgroundColor: "#6EE038"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "tw-text-3xl tw-my-4",
                    children: "Sent to client"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    style: {
                        marginBottom: "2rem"
                    },
                    children: "The agreement has been sent and you will be notified once signed by client"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "primary-lg",
                    label: "Return To Dashboard",
                    onClick: onGoBackToDashboard
                })
            ]
        })
    });
};
var $02c9992193821d99$export$2e2bcd8739ae039 = $02c9992193821d99$var$TermsOfAgreementSent;




var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");



const $e6bc70e244de74f5$var$SocietyCommissionRateItem = ({ societyList: societyList, termsOfAgreement: termsOfAgreement, onAdd: onAdd, onDelete: onDelete, onChange: onChange, index: index, length: length })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                name: "society",
                label: "Society",
                onBlur: ()=>{},
                onChange: ()=>onChange,
                defaultValue: societyList.length > 0 ? societyList[0]?.readableName : "",
                options: societyList.map((society)=>({
                        value: society.readableName,
                        label: society.readableName
                    })),
                row: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                value: termsOfAgreement && termsOfAgreement.societyCommissionRates && termsOfAgreement.societyCommissionRates[index] ? termsOfAgreement.societyCommissionRates[index].commissionRate : "",
                name: "commission",
                label: "Commission",
                placeholder: "Enter Commission Rate",
                onChange: (e)=>onChange(e, index),
                row: true
            }),
            index !== 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-justify-end tw-mb-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "link-secondary",
                    onClick: ()=>onDelete(index),
                    icon: "trash",
                    label: "Remove society commission rate"
                })
            }) : null,
            index === length - 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-justify-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "link-secondary",
                    icon: "plus",
                    onClick: onAdd,
                    className: "tw-flex tw-justify-end hover:tw-underline",
                    label: "Add another society commission rate"
                })
            }) : null
        ]
    });
};
var $e6bc70e244de74f5$export$2e2bcd8739ae039 = $e6bc70e244de74f5$var$SocietyCommissionRateItem;




parcelRequire("acw62");

const $afeaaf657962cb35$var$ClientAdvanceDetails = ({ advanceAmount: advanceAmount, onAmountChange: onAmountChange })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
            type: "text",
            name: "advanceAmount",
            label: "Advance amount",
            value: advanceAmount,
            onChange: (e)=>{
                onAmountChange(e.target.value);
            },
            placeholder: "\xa3"
        })
    });
};
var $afeaaf657962cb35$export$2e2bcd8739ae039 = $afeaaf657962cb35$var$ClientAdvanceDetails;



parcelRequire("acw62");


var $45fvw = parcelRequire("45fvw");


const $1683f4ab741a687a$var$RepresentativeFeeDetails = ({ termsOfAgreement: termsOfAgreement, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-flex-col",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-w-1/6",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                name: "percentage",
                                label: "",
                                type: "text",
                                placeholder: "%",
                                value: termsOfAgreement.representativeFee?.percentage,
                                onChange: (e)=>onChange(e)
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-w-5/6",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                                name: "takenFrom",
                                label: "Taken from",
                                layout: "horizontal",
                                options: [
                                    {
                                        value: (0, $0357ead1ed5cb684$export$5e11be6023d3fb10).WestburyIncome,
                                        label: "Westbury Income"
                                    },
                                    {
                                        value: (0, $0357ead1ed5cb684$export$5e11be6023d3fb10).ClientIncome,
                                        label: "Client Income"
                                    }
                                ],
                                defaultValue: termsOfAgreement.representativeFee?.takenFrom,
                                onChange: (e)=>onChange(e)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-w-full",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        layout: "horizontal",
                        label: "Expiration date",
                        type: "date",
                        value: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(termsOfAgreement.representativeFee?.expirationDate).format("YYYY-MM-DD"),
                        name: "expirationDate",
                        placeholder: "DD/MM/YYYY",
                        onChange: (e)=>onChange(e)
                    })
                })
            ]
        })
    });
};
var $1683f4ab741a687a$export$2e2bcd8739ae039 = $1683f4ab741a687a$var$RepresentativeFeeDetails;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
var $94e865609a9dadd9$exports = {};

$parcel$export($94e865609a9dadd9$exports, "container", () => $94e865609a9dadd9$export$34e0f9847d4c02dd, (v) => $94e865609a9dadd9$export$34e0f9847d4c02dd = v);
var $94e865609a9dadd9$export$34e0f9847d4c02dd;
$94e865609a9dadd9$export$34e0f9847d4c02dd = `XwwVBa_container`;


const $95d3bd05f0e5a60a$export$fab3ce5a4cf652db = /*#__PURE__*/ (0, $acw62.forwardRef)(({ name: name, label: label, checked: checked, onChange: onChange, checkboxSize: checkboxSize = "md", extraClasses: extraClasses, extraLabelClasses: extraLabelClasses }, ref)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-cursor-pointer", (0, (/*@__PURE__*/$parcel$interopDefault($94e865609a9dadd9$exports))).container, extraClasses),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "checkbox",
                name: name,
                checked: checked,
                onChange: onChange,
                ref: ref,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-absolute tw-opacity-0 tw-cursor-pointer", {
                    "tw-w-[16px] tw-h-[16px]": checkboxSize === "xs",
                    "tw-w-[20px] tw-h-[20px]": checkboxSize === "sm",
                    "tw-w-[32px] tw-h-[32px]": checkboxSize === "md"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-justify-center tw-items-center tw-flex-shrink-0 tw-border-white tw-cursor-pointer", {
                    "tw-rounded-[1px] tw-border-[1px] tw-w-[16px] tw-h-[16px]": checkboxSize === "xs",
                    "tw-rounded-[2px] tw-border-[2px] tw-w-[20px] tw-h-[20px]": checkboxSize === "sm",
                    "tw-rounded-[4px] tw-border-[3px] tw-w-[32px] tw-h-[32px]": checkboxSize === "md",
                    "tw-bg-surfaceBlack80": checked
                }),
                children: checked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi wi-check -tw-translate-x-[12%]", {
                        "tw-w-[16px] tw-h-[16px]": checkboxSize === "xs"
                    }, {
                        "tw-w-[20px] tw-h-[20px]": checkboxSize === "sm"
                    }, {
                        "tw-w-[32px] tw-h-[32px]": checkboxSize === "md"
                    })
                })
            }),
            label !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-ml-2 tw-text-wrap tw-pr-[32px]", "tw-font-light", "tw-cursor-pointer", {
                    "tw-text-white": checked,
                    "tw-text-textDove": !checked
                }, extraLabelClasses),
                children: label
            })
        ]
    });
});
$95d3bd05f0e5a60a$export$fab3ce5a4cf652db.displayName = "WCheckBox";




const $7248374da9a479ee$export$796f1daee04ec730 = ({ name: name, label: label, options: options, defaultCheckedValues: defaultCheckedValues, onChange: onChange, grid: grid = "", checkboxSize: checkboxSize = "md" })=>{
    const { isEditing: isEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const [checkedValues, setCheckedValues] = (0, $acw62.useState)(defaultCheckedValues);
    (0, $acw62.useEffect)(()=>{
        setCheckedValues(defaultCheckedValues);
    }, [
        defaultCheckedValues
    ]);
    const handleCheckboxChange = (value, isChecked)=>{
        const updatedCheckedValues = isChecked ? [
            ...checkedValues,
            value
        ] : checkedValues.filter((v)=>v !== value);
        // Update the state
        setCheckedValues(updatedCheckedValues);
        // Call onChange with both old and new values
        onChange({
            oldValues: checkedValues,
            newValues: updatedCheckedValues
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-mb-4 tw-cursor-pointer",
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: "tw-block tw-leading-4 tw-text-white tw-mb-8",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                    "tw-flex tw-flex-row tw-space-x-2": grid === ""
                }, {
                    "tw-grid": grid != ""
                }, grid && grid !== "" && grid, {
                    "tw-pointer-events-none": !isEditing
                }),
                children: options.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95d3bd05f0e5a60a$export$fab3ce5a4cf652db), {
                        name: `${name}_${option.value}`,
                        label: option.label,
                        checked: defaultCheckedValues.includes(option.value),
                        onChange: (e)=>handleCheckboxChange(option.value, e.target.checked),
                        checkboxSize: checkboxSize,
                        extraClasses: "tw-mb-2"
                    }, index))
            }),
            errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-text-westburyRed tw-text-xs tw-mt-4",
                children: errors[name]
            })
        ]
    });
};


const $741471dfbda13355$var$CheckboxList = ({ selectAllOnChange: selectAllOnChange, onCheckboxChange: onCheckboxChange, societyList: societyList })=>{
    const [checkedValues, setCheckedValues] = (0, $acw62.useState)([]);
    const [isCheckedAll, setIsCheckedAll] = (0, $acw62.useState)(false);
    const societyCheckBoxList = societyList.map((society)=>{
        return {
            value: society.id,
            label: society.readableName
        };
    });
    (0, $acw62.useEffect)(()=>{
        // list of society ID's if society.isChecked is true
        const checkedSocieties = societyList.filter((society)=>society.isChecked).map((society)=>society.id);
        setCheckedValues(checkedSocieties);
    }, [
        societyList
    ]);
    (0, $acw62.useEffect)(()=>{
        // iterate through societies, if all are checked set isCheckedAll to true
        const checkedSocieties = societyList.filter((society)=>!society.isChecked);
        if (checkedSocieties.length !== 0) setIsCheckedAll(false);
        else setIsCheckedAll(true);
    }, [
        societyList
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7248374da9a479ee$export$796f1daee04ec730), {
                    name: "selectAll",
                    label: "",
                    options: [
                        {
                            value: "select all",
                            label: "Select All"
                        }
                    ],
                    defaultCheckedValues: isCheckedAll ? [
                        "select all"
                    ] : [],
                    onChange: ({ newValues: newValues })=>{
                        selectAllOnChange(!isCheckedAll);
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7248374da9a479ee$export$796f1daee04ec730), {
                    name: "society",
                    label: "",
                    checkboxSize: "xs",
                    options: societyCheckBoxList,
                    defaultCheckedValues: checkedValues,
                    onChange: ({ oldValues: oldValues, newValues: newValues })=>{
                        selectAllOnChange(false);
                        // Find the changed checkbox
                        const diff = oldValues.filter((x)=>!newValues.includes(x));
                        const diff2 = newValues.filter((x)=>!oldValues.includes(x));
                        // check if it was checked or unchecked
                        if (diff.length > 0) onCheckboxChange(diff[0]);
                        else onCheckboxChange(diff2[0]);
                    },
                    grid: "tw-grid-cols-3 tw-gap-2"
                })
            ]
        })
    });
};
var $741471dfbda13355$export$2e2bcd8739ae039 = $741471dfbda13355$var$CheckboxList;






parcelRequire("acw62");


parcelRequire("acw62");



const $5823d9da1c157e4a$var$SlidingScaleItem = ({ item: item, index: index, handleSlidingScaleChange: handleSlidingScaleChange })=>{
    const inputChange = (e)=>{
        handleSlidingScaleChange(index, e);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                    name: "termsOfAgreementSlidingScaleBasedOn",
                    layout: "horizontal",
                    label: "Based On",
                    options: [
                        {
                            value: (0, $41529a4feb258a75$export$4d5f5bd86d543335).NetIncome,
                            label: "Net Income"
                        },
                        {
                            value: (0, $41529a4feb258a75$export$4d5f5bd86d543335).GrossIncome,
                            label: "Gross Income"
                        }
                    ],
                    defaultValue: (0, $41529a4feb258a75$export$4d5f5bd86d543335).NetIncome,
                    onChange: inputChange
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                    layout: "horizontal",
                    type: "text",
                    value: item.threshold,
                    name: "threshold",
                    label: "After",
                    placeholder: "Enter Sum",
                    onChange: inputChange
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                    layout: "horizontal",
                    type: "text",
                    value: item.commission_rate,
                    name: "commissionRate",
                    label: "Commission Rate",
                    placeholder: "Enter Commission Rate",
                    onChange: inputChange
                })
            })
        ]
    });
};
var $5823d9da1c157e4a$export$2e2bcd8739ae039 = $5823d9da1c157e4a$var$SlidingScaleItem;



const $322491343866f028$var$SlidingScaleSection = ({ addSlidingScale: addSlidingScale, deleteSlidingScale: deleteSlidingScale, handleSlidingScaleChange: handleSlidingScaleChange, termsOfAgreement: termsOfAgreement })=>{
    const onInputChange = (e)=>{
        console.log(e.target.value);
    };
    //remap TermsOfAgreementSlidingScaleBasedOnEnum to label, value key value pair
    const slidingScaleBasedOnOptions = Object.keys((0, $41529a4feb258a75$export$4d5f5bd86d543335)).map((option)=>({
            value: option,
            label: (0, $41529a4feb258a75$export$4d5f5bd86d543335)[option]
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-flex-col",
            children: [
                termsOfAgreement.slidingScales?.map((slidingScale, index)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5823d9da1c157e4a$export$2e2bcd8739ae039), {
                                handleSlidingScaleChange: handleSlidingScaleChange,
                                item: slidingScale,
                                index: index
                            }),
                            index !== 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-justify-end tw-mb-6",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "link-secondary",
                                    icon: "trash",
                                    label: "Delete commission scale",
                                    onClick: ()=>{
                                        deleteSlidingScale(index);
                                    }
                                })
                            }) : null,
                            index < termsOfAgreement.slidingScales.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
                            })
                        ]
                    });
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-justify-end tw-mb-6",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        variant: "link-secondary",
                        icon: "plus",
                        onClick: ()=>{
                            addSlidingScale();
                        },
                        label: "Add another sliding scale"
                    })
                })
            ]
        })
    });
};
var $322491343866f028$export$2e2bcd8739ae039 = $322491343866f028$var$SlidingScaleSection;



const $7ddf10c05dedf652$var$TermsOfAgreementForm = ({ termsOfAgreement: termsOfAgreement, setTermsOfAgreement: setTermsOfAgreement, societyList: societyList, setSocietyList: setSocietyList, selectAllSocieties: selectAllSocieties, setSelectAllSocieties: setSelectAllSocieties })=>{
    const [performerProducerCheckedValues, setPerformerProducerCheckedValues] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    (0, $acw62.useEffect)(()=>{
        const checkedValues = [];
        if (termsOfAgreement.performerOrProducer) checkedValues.push("Performer/Producer");
        if (termsOfAgreement.masterRights) checkedValues.push("Rightsholder");
        setPerformerProducerCheckedValues(checkedValues);
    }, [
        termsOfAgreement.performerOrProducer,
        termsOfAgreement.masterRights
    ]);
    const handleRadioButtonChange = (e, set_attribute_to_true_value)=>{
        const { name: name, value: value } = e.target;
        // ... (rest of the code)
        if (name === "bankPaymentMethod") setTermsOfAgreement({
            ...termsOfAgreement,
            bankPaymentMethod: (0, $41529a4feb258a75$export$202f41735a76d71c)[value]
        });
        else {
            const newBool = set_attribute_to_true_value === "Yes" ? true : false;
            setTermsOfAgreement({
                ...termsOfAgreement,
                [name]: newBool
            });
        }
    };
    const addSocietyCommissionRate = ()=>{
        const updatedSocietyCommissionRates = [
            ...termsOfAgreement.societyCommissionRates
        ];
        updatedSocietyCommissionRates.push({
            commissionRate: "",
            society: ""
        });
        setTermsOfAgreement({
            ...termsOfAgreement,
            societyCommissionRates: updatedSocietyCommissionRates
        });
    };
    const deleteSocietyCommissionRate = (index)=>{
        const updatedSocietyCommissionRates = [
            ...termsOfAgreement.societyCommissionRates
        ];
        updatedSocietyCommissionRates.splice(index, 1);
        setTermsOfAgreement({
            ...termsOfAgreement,
            societyCommissionRates: updatedSocietyCommissionRates
        });
    };
    const addSlidingScale = ()=>{
        const updatedSlidingScales = [
            ...termsOfAgreement.slidingScales
        ];
        updatedSlidingScales.push({
            commissionRate: "",
            threshold: ""
        });
        setTermsOfAgreement({
            ...termsOfAgreement,
            slidingScales: updatedSlidingScales
        });
    };
    const deleteSlidingScale = (index)=>{
        const updatedSlidingScales = [
            ...termsOfAgreement.slidingScales
        ];
        updatedSlidingScales.splice(index, 1);
        setTermsOfAgreement({
            ...termsOfAgreement,
            slidingScales: updatedSlidingScales
        });
    };
    const handleSlidingScaleChange = (index, e)=>{
        const { name: name, value: value } = e.target;
        const updatedSlidingScales = [
            ...termsOfAgreement.slidingScales
        ];
        updatedSlidingScales[index] = {
            ...updatedSlidingScales[index],
            [name]: value
        };
        setTermsOfAgreement({
            ...termsOfAgreement,
            slidingScales: updatedSlidingScales
        });
    };
    const handleSelectAllChange = (checked)=>{
        setSelectAllSocieties(checked);
        const updatedSocietyList = societyList.map((society)=>({
                ...society,
                isChecked: checked
            }));
        setSocietyList(updatedSocietyList);
        setTermsOfAgreement({
            ...termsOfAgreement,
            mandatedSocieties: updatedSocietyList.filter((society)=>society.isChecked).map((society)=>society.id)
        });
    };
    const handleIndividualCheckboxChange = (societyId)=>{
        const updatedSocietyList = societyList.map((society)=>society.id === societyId ? {
                ...society,
                isChecked: !society.isChecked
            } : society);
        const isAllChecked = updatedSocietyList.every((society)=>society.isChecked);
        setSelectAllSocieties(isAllChecked);
        setSocietyList(updatedSocietyList);
        setTermsOfAgreement({
            ...termsOfAgreement,
            mandatedSocieties: updatedSocietyList.filter((society)=>society.isChecked).map((society)=>society.id)
        });
    };
    const handleSlidingScaleBasedOnChange = (e)=>{
        setTermsOfAgreement({
            ...termsOfAgreement,
            slidingScaleBasedOn: (0, $41529a4feb258a75$export$4d5f5bd86d543335)[e.target.value]
        });
    };
    const handleCommissionRateChange = (e, index)=>{
        const { name: name, value: value } = e.target;
        const updatedSocietyCommissionRates = [
            ...termsOfAgreement.societyCommissionRates
        ];
        if (name === "takenFrom") {
            const society = societyList.find((society)=>society.readableName === value);
            if (society) updatedSocietyCommissionRates[index] = {
                ...updatedSocietyCommissionRates[index],
                society: society.id
            };
        } else if (name === "commission") updatedSocietyCommissionRates[index] = {
            ...updatedSocietyCommissionRates[index],
            commissionRate: value
        };
        setTermsOfAgreement({
            ...termsOfAgreement,
            societyCommissionRates: updatedSocietyCommissionRates
        });
    };
    const handleRepresentativeFeesChange = (e)=>{
        const { name: name, value: value } = e.target;
        if (name === "takenFrom") setTermsOfAgreement({
            ...termsOfAgreement,
            representativeFee: {
                ...termsOfAgreement.representativeFee,
                takenFrom: (0, $0357ead1ed5cb684$export$5e11be6023d3fb10)[value]
            }
        });
        else name == "expirationDate" ? setTermsOfAgreement({
            ...termsOfAgreement,
            representativeFee: {
                ...termsOfAgreement.representativeFee,
                [name]: new Date(value)
            }
        }) : setTermsOfAgreement({
            ...termsOfAgreement,
            representativeFee: {
                ...termsOfAgreement.representativeFee,
                [name]: value
            }
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        extraClasses: "tw-text-white tw-flex tw-flex-col tw-w-[575px]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                label: "Standard Agreement?",
                name: "standardAgreement",
                selectedValue: termsOfAgreement.standardAgreement ? "Yes" : "No",
                items: [
                    {
                        value: "Yes",
                        label: "Yes"
                    },
                    {
                        value: "No",
                        label: "No"
                    }
                ],
                onChange: (e)=>{
                    handleRadioButtonChange(e, e.target.value);
                }
            }),
            !termsOfAgreement.standardAgreement && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "commission",
                        label: "Commission",
                        placeholder: "Enter Commission",
                        value: termsOfAgreement.commissionRate,
                        onChange: (e)=>setTermsOfAgreement({
                                ...termsOfAgreement,
                                commissionRate: e.target.value
                            })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "minPayment",
                        label: "Min Payment",
                        placeholder: "Enter Min Payment",
                        value: termsOfAgreement.minimumPayment,
                        onChange: (e)=>setTermsOfAgreement({
                                ...termsOfAgreement,
                                minimumPayment: e.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-mt-2 tw-mb-6 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                label: "Universal society commission rate?",
                name: "universalSocietyCommissionRate",
                selectedValue: termsOfAgreement.universalSocietyCommissionRate ? "Yes" : "No",
                items: [
                    {
                        value: "Yes",
                        label: "Yes"
                    },
                    {
                        value: "No",
                        label: "No"
                    }
                ],
                onChange: (e)=>{
                    handleRadioButtonChange(e, e.target.value);
                }
            }),
            !termsOfAgreement.universalSocietyCommissionRate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: termsOfAgreement.societyCommissionRates?.map((element, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6bc70e244de74f5$export$2e2bcd8739ae039), {
                                    societyList: societyList,
                                    termsOfAgreement: termsOfAgreement,
                                    onAdd: addSocietyCommissionRate,
                                    onDelete: ()=>deleteSocietyCommissionRate(index),
                                    onChange: (e)=>handleCommissionRateChange(e, index),
                                    index: index,
                                    length: termsOfAgreement.societyCommissionRates?.length || 0
                                }, index),
                                index < termsOfAgreement.societyCommissionRates.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
                                })
                            ]
                        }))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-mt-2 tw-mb-6 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                label: "Sliding scale required?",
                name: "slidingScaleRequired",
                selectedValue: termsOfAgreement.slidingScaleRequired ? "Yes" : "No",
                items: [
                    {
                        value: "Yes",
                        label: "Yes"
                    },
                    {
                        value: "No",
                        label: "No"
                    }
                ],
                onChange: (e)=>{
                    handleRadioButtonChange(e, e.target.value);
                }
            }),
            termsOfAgreement.slidingScaleRequired && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $322491343866f028$export$2e2bcd8739ae039), {
                    addSlidingScale: addSlidingScale,
                    deleteSlidingScale: deleteSlidingScale,
                    handleSlidingScaleChange: handleSlidingScaleChange,
                    termsOfAgreement: termsOfAgreement
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-mt-2 tw-mb-6 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7248374da9a479ee$export$796f1daee04ec730), {
                name: "performerOrProducer",
                label: "This Client Is A",
                options: [
                    {
                        value: "Performer/Producer",
                        label: "Performer/Producer"
                    },
                    {
                        value: "Rightsholder",
                        label: "Rightsholder"
                    }
                ],
                defaultCheckedValues: performerProducerCheckedValues,
                onChange: ({ newValues: newValues })=>{
                    const isPerformerProducer = newValues.includes("Performer/Producer");
                    const isRightsholder = newValues.includes("Rightsholder");
                    setTermsOfAgreement({
                        ...termsOfAgreement,
                        performerOrProducer: isPerformerProducer,
                        masterRights: isRightsholder
                    });
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-mt-2 tw-mb-6 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                name: "universalMandate",
                label: "Universal mandate?",
                selectedValue: termsOfAgreement.universalMandate ? "Yes" : "No",
                items: [
                    {
                        value: "Yes",
                        label: "Yes"
                    },
                    {
                        value: "No",
                        label: "No"
                    }
                ],
                onChange: (e)=>{
                    if (e.target.value === "Yes") setTermsOfAgreement({
                        ...termsOfAgreement,
                        universalMandate: true
                    });
                    if (e.target.value === "No") setTermsOfAgreement({
                        ...termsOfAgreement,
                        universalMandate: false
                    });
                }
            }),
            !termsOfAgreement.universalMandate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-mt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $741471dfbda13355$export$2e2bcd8739ae039), {
                    selectAllOnChange: handleSelectAllChange,
                    onCheckboxChange: handleIndividualCheckboxChange,
                    societyList: societyList
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-mt-2 tw-mb-6 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                label: "Method of payment",
                name: "bankPaymentMethod",
                selectedValue: termsOfAgreement.bankPaymentMethod === (0, $41529a4feb258a75$export$202f41735a76d71c).BankTransfer ? "BankTransfer" : "Cheque",
                items: [
                    {
                        value: "BankTransfer",
                        label: "Bank Transfer"
                    },
                    {
                        value: "Cheque",
                        label: "Cheque"
                    }
                ],
                onChange: (e)=>{
                    handleRadioButtonChange(e, e.target.value);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-mt-2 tw-mb-6 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                name: "representativeFeeRequired",
                label: "Representative fees?",
                selectedValue: termsOfAgreement.representativeFeeRequired ? "Yes" : "No",
                items: [
                    {
                        value: "Yes",
                        label: "Yes"
                    },
                    {
                        value: "No",
                        label: "No"
                    }
                ],
                onChange: (e)=>{
                    if (e.target.value === "Yes") setTermsOfAgreement({
                        ...termsOfAgreement,
                        representativeFeeRequired: true
                    });
                    if (e.target.value === "No") setTermsOfAgreement({
                        ...termsOfAgreement,
                        representativeFeeRequired: false
                    });
                }
            }),
            termsOfAgreement.representativeFeeRequired && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1683f4ab741a687a$export$2e2bcd8739ae039), {
                    onChange: handleRepresentativeFeesChange,
                    termsOfAgreement: termsOfAgreement
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-mt-2 tw-mb-6 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                name: "clientRequiresAdvance",
                label: "Client Requires an Advance?",
                selectedValue: termsOfAgreement.clientRequiresAdvance ? "Yes" : "No",
                items: [
                    {
                        value: "Yes",
                        label: "Yes"
                    },
                    {
                        value: "No",
                        label: "No"
                    }
                ],
                onChange: (e)=>{
                    if (e.target.value === "Yes") setTermsOfAgreement({
                        ...termsOfAgreement,
                        clientRequiresAdvance: true
                    });
                    if (e.target.value === "No") setTermsOfAgreement({
                        ...termsOfAgreement,
                        clientRequiresAdvance: false
                    });
                }
            }),
            termsOfAgreement.clientRequiresAdvance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $afeaaf657962cb35$export$2e2bcd8739ae039), {
                advanceAmount: termsOfAgreement.advanceAmount,
                onAmountChange: (e)=>setTermsOfAgreement({
                        ...termsOfAgreement,
                        advanceAmount: e
                    })
            })
        ]
    });
};
var $7ddf10c05dedf652$export$2e2bcd8739ae039 = $7ddf10c05dedf652$var$TermsOfAgreementForm;




var $acw62 = parcelRequire("acw62");








function $f7e9c846bb4379f2$var$AgreementModal({ showModal: showModal, modalClose: modalClose, clientId: clientId, clientEmailAddress: clientEmailAddress, children: children, preview: preview, setPandadocDocumentIds: setPandadocDocumentIds, isLoading: isLoading, setIsLoading: setIsLoading }) {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [isSubmitted, setIsSubmitted] = (0, $acw62.useState)(false);
    const { clientId: clientUserId, clientEmail: clientEmail } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [showWaitMessage, setShowWaitMessage] = (0, $acw62.useState)(false);
    const [pandadocsTemplateIds, setPandadocsTemplateIds] = (0, $acw62.useState)([]);
    const [selectedPageIndex, setSelectedPageIndex] = (0, $acw62.useState)(1);
    const [documentsSigned, setDocumentsSigned] = (0, $acw62.useState)(new Set());
    (0, $acw62.useEffect)(()=>{
        clientEmailAddress = clientEmailAddress ? clientEmailAddress : clientEmail;
        clientId = clientId ? clientId : clientUserId;
    });
    (0, $acw62.useEffect)(()=>{
        if (clientId === undefined) return;
        const fetchData = async ()=>{
            // the api.createPandadocDocumentIds call should only be made once the Terms Of Agreement has been submitted (when showModal is true in this case)
            // we could refactor it to rename the showModal flag in the future
            if (!showModal) return;
            // get pandadoc template ids
            setIsLoading(true);
            api.createPandadocDocumentIds({
                pandadocDocumentIds: {
                    userId: clientId || "missing",
                    email: clientEmailAddress || "missing"
                }
            }).then(({ documents: pandadocsTemplateIdsData })=>{
                if (pandadocsTemplateIdsData && pandadocsTemplateIdsData.length == 0) {
                    setIsSubmitted(true);
                    return;
                }
                pandadocsTemplateIdsData?.map((templateId)=>{
                    if (templateId.sessionId !== null) setPandadocsTemplateIds((prev)=>[
                            ...prev,
                            {
                                ...templateId,
                                pandadocsResponse: {
                                    documentId: templateId.sessionId,
                                    documentName: templateId.documentName
                                }
                            }
                        ]);
                    else throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Couldn't load the document. Please try again."));
                    if (templateId.documentId !== null && setPandadocDocumentIds !== undefined) setPandadocDocumentIds((prev)=>[
                            ...prev,
                            {
                                documentId: templateId.pandadocDocumentId,
                                documentName: templateId.documentName
                            }
                        ]);
                });
            }).catch((err)=>{
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong, please try again."));
            });
        };
        fetchData();
    }, [
        showModal
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedPageIndex != pandadocsTemplateIds.length) setSelectedPageIndex(documentsSigned.size + 1);
        if (preview) return;
        if (documentsSigned.size === 0) return;
        if (documentsSigned.size != pandadocsTemplateIds.length) return;
        try {
            api.updateClientSocietyFormTask({
                userId: clientId
            }).then(()=>setIsSubmitted(true));
        } catch (error) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong, please try again."));
        }
    }, [
        documentsSigned
    ]);
    const isButtonDisabled = (pandadocsResponse, index)=>{
        if (pandadocsResponse === undefined) return true;
        if (pandadocsResponse.documentId === undefined) return true;
        if (documentsSigned.size < index) return true;
        return false;
    };
    // pandadocs iframe event message listeners
    // https://developers.pandadoc.com/reference/embed-a-document#embedded-document-javascript-events
    window.addEventListener("message", (event)=>{
        const type = event.data && event.data.type;
        const payload = event.data && event.data.payload;
        switch(type){
            case "session_view.document.loaded":
                if (isLoading) setIsLoading(false);
            case "session_view.document.completed":
                if (payload && payload.uuid) {
                    const payloadUUID = payload.uuid;
                    if (!(payloadUUID in documentsSigned)) setDocumentsSigned((prev)=>new Set([
                            ...Array.from(prev),
                            payloadUUID
                        ]));
                }
        }
    });
    if (isSubmitted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f7e9c846bb4379f2$var$SubmittedModal, {
        isOpen: showModal,
        onClose: modalClose
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: showModal,
        modalClasses: "tw-min-w-[70vw]",
        onClose: ()=>{
            setPandadocsTemplateIds([]);
            modalClose();
        },
        title: "Sign WMC Forms",
        children: [
            isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: " tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-[70vw] tw-h-[75vh]  ",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-center tw-w-[500px]",
                        style: {
                            minHeight: "500px"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-my-auto tw-animate-ping",
                            children: "\u26AA"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        maxHeight: isLoading ? "0px" : ""
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: isLoading ? "tw-hidden" : "tw-mb-4 tw-flex tw-gap-4 tw-space-x-2",
                            children: pandadocsTemplateIds.map(({ documentName: documentName, pandadocsResponse: pandadocsResponse }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    label: documentName,
                                    variant: "link-secondary",
                                    disabled: isButtonDisabled(pandadocsResponse, index),
                                    onClick: ()=>setSelectedPageIndex(index + 1)
                                }, index))
                        }),
                        pandadocsTemplateIds.map(({ pandadocsResponse: pandadocsResponse }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05f18ed57e2d0baa$export$2e2bcd8739ae039), {
                                index: index,
                                sessionId: pandadocsResponse?.documentId,
                                selectedPageIndex: selectedPageIndex,
                                isLoading: isLoading
                            }, index)),
                        !isLoading && documentsSigned.size > 0 && children
                    ]
                })
            })
        ]
    });
}
var $f7e9c846bb4379f2$export$2e2bcd8739ae039 = $f7e9c846bb4379f2$var$AgreementModal;
const $f7e9c846bb4379f2$var$SubmittedModal = ({ isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        title: "",
        disableBackdropClick: true,
        isOpen: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
            title: "Thank you",
            description: "Your WMC forms have been submitted successfully. WMC will be in contact once your witness has signed the Power of Attorney."
        })
    });
};










function $4b698fe643cd3ade$var$TermsOfAgreement() {
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [societyList, setSocietyList] = (0, $acw62.useState)([]);
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [selectAllSocieties, setSelectAllSocieties] = (0, $acw62.useState)(false);
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const [showSuccessModal, setShowSuccessModal] = (0, $acw62.useState)(false);
    const [userSettings, setUserSettings] = (0, $acw62.useState)(undefined);
    const [formSentToClient, setFormSentToClient] = (0, $acw62.useState)(false);
    const [showPage, setShowPage] = (0, $acw62.useState)(true);
    const { userId: userId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [termsOfAgreement, setTermsOfAgreement] = (0, $acw62.useState)({
        user: userId,
        standardAgreement: true,
        commissionRate: "",
        minimumPayment: "",
        universalSocietyCommissionRate: true,
        societyCommissionRates: [
            {
                commissionRate: "",
                society: ""
            }
        ],
        performerOrProducer: true,
        masterRights: false,
        universalMandate: true,
        slidingScaleRequired: false,
        slidingScaleBasedOn: (0, $41529a4feb258a75$export$4d5f5bd86d543335).NetIncome,
        slidingScales: [
            {
                threshold: "",
                commissionRate: ""
            }
        ],
        bankPaymentMethod: (0, $41529a4feb258a75$export$202f41735a76d71c).BankTransfer,
        representativeFeeRequired: false,
        representativeFee: {
            percentage: "",
            takenFrom: undefined,
            expirationDate: new Date()
        },
        clientRequiresAdvance: false,
        advanceAmount: "",
        mandatedSocieties: []
    });
    const data = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const taskId = data.state?.taskId ? data.state.taskId : undefined;
    const [pandadocDocumentIds, setPandadocDocumentIds] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const toggleModal = ()=>{
        setIsModalOpen(!isModalOpen);
    };
    const societiesFetch = async ()=>{
        try {
            let response = await api.listAdminSocieties();
            let societyListWithCheckbox = response.map((society)=>({
                    ...society,
                    isChecked: false
                }));
            setSocietyList(societyListWithCheckbox);
        } catch (err) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Failed to fetch societies"));
        }
    };
    const userFetch = async (userId)=>{
        if (userId === undefined) return;
        try {
            let userSettings = await api.retrieveUserSettings({
                userId: userId
            });
            setUserSettings(userSettings);
        } catch (err) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Error fetching user data"));
        }
    };
    const saveUserSettings = async (updatedSettings)=>{
        let combinedName = generateFullName(updatedSettings.firstName, updatedSettings.middleName, updatedSettings.lastName);
        let updatedUserSettings = {
            ...userSettings,
            ...updatedSettings,
            fullName: combinedName
        };
        if (userId) return api.updateUserSettings({
            userId: userId,
            userSettings: updatedUserSettings
        }).then((response)=>{
            setUserSettings(response);
            return Promise.resolve(response);
        });
        else return Promise.reject();
    };
    const generateFullName = (firstName, middleName, lastName)=>{
        const parts = [
            firstName,
            middleName,
            lastName
        ].filter(Boolean);
        return parts.join(" ");
    };
    const handleSubmit = async ()=>{
        return sendTermsOfAgreement();
    };
    const sendTermsOfAgreement = async ()=>{
        let existingData;
        try {
            existingData = await api.retrieveTermsOfAgreement({
                userId: userId
            });
        } catch (err) {
            existingData = null;
        }
        const termsOfAgreementData = {
            userId: userId,
            termsOfAgreement: {
                user: userId,
                standardAgreement: termsOfAgreement.standardAgreement,
                commissionRate: termsOfAgreement.standardAgreement ? "" : termsOfAgreement.commissionRate,
                minimumPayment: termsOfAgreement.standardAgreement ? "" : termsOfAgreement.minimumPayment,
                universalSocietyCommissionRate: termsOfAgreement.universalSocietyCommissionRate,
                societyCommissionRates: termsOfAgreement.universalSocietyCommissionRate ? [] : termsOfAgreement.societyCommissionRates,
                performerOrProducer: termsOfAgreement.performerOrProducer,
                masterRights: termsOfAgreement.masterRights,
                universalMandate: termsOfAgreement.universalMandate,
                slidingScaleRequired: termsOfAgreement.slidingScaleRequired,
                slidingScaleBasedOn: termsOfAgreement.slidingScaleRequired ? termsOfAgreement.slidingScaleBasedOn?.replace(" ", "_") : undefined,
                slidingScales: termsOfAgreement.slidingScaleRequired ? termsOfAgreement.slidingScales : [],
                bankPaymentMethod: termsOfAgreement.bankPaymentMethod,
                representativeFeeRequired: termsOfAgreement.representativeFeeRequired,
                representativeFee: termsOfAgreement.representativeFeeRequired ? termsOfAgreement.representativeFee : null,
                clientRequiresAdvance: termsOfAgreement.clientRequiresAdvance,
                advanceAmount: termsOfAgreement.clientRequiresAdvance ? termsOfAgreement.advanceAmount : "",
                mandatedSocieties: selectAllSocieties || termsOfAgreement.universalMandate ? societyList.map((society)=>society.id ?? "") : termsOfAgreement.mandatedSocieties
            }
        };
        try {
            if (!existingData) await api.createTermsOfAgreement({
                userId: userId,
                termsOfAgreement: termsOfAgreementData.termsOfAgreement
            });
            else await api.updateTermsOfAgreement({
                userId: userId,
                termsOfAgreement: termsOfAgreementData.termsOfAgreement
            });
            toggleModal();
        } catch (err) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Error creating Terms of Agreement"));
        }
    };
    const handleOnCancel = ()=>{
        setFormSentToClient(false);
        toggleModal();
    };
    const handleSendToClient = async ()=>{
        if (taskId) try {
            await api.destroyAdminTaskClient({
                taskId: taskId
            });
        } catch  {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Failed to delete task"));
        }
        else throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("No task id provided"));
        setIsLoading(true);
        try {
            await api.createClientTasksTermsOfAgreementConfirmation({
                userId: userId,
                termsOfAgreementConfirmation: {
                    pandadocDocumentIds: pandadocDocumentIds
                }
            });
            toggleModal();
        } catch  {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Failed to create terms of agreement confirmation"));
        }
        setIsLoading(false);
        setIsModalOpen(false);
        setShowSuccessModal(true);
    };
    const checkUserStatus = async ()=>{
        const tasks = await api.listClientSocietyFormTasks({
            userId: userId
        });
        const filteredTasks = tasks.filter((task)=>task.status === (0, $4ba4f806015061e3$export$28b9d07f58452a32).ClientToSign);
        setShowPage(filteredTasks.length === 0);
    };
    (0, $acw62.useEffect)(()=>{
        societiesFetch();
        userFetch(userId);
        checkUserStatus();
    }, [
        userId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "tw-text-2xl tw-text-white tw-mb-4",
                children: "Terms Of Agreement"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                variant: "link-secondary",
                icon: "chevron-left",
                onClick: ()=>navigate("/dashboard"),
                label: "Back"
            }),
            !showPage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02c9992193821d99$export$2e2bcd8739ae039), {
                onGoBackToDashboard: ()=>{
                    navigate("/dashboard");
                }
            }),
            showPage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    !formSentToClient && userSettings && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fd8517427d10e3a$export$2e2bcd8739ae039), {
                        userSettings: userSettings,
                        onSave: saveUserSettings
                    }),
                    formSentToClient && !isModalOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02c9992193821d99$export$2e2bcd8739ae039), {
                            onGoBackToDashboard: ()=>{
                                navigate("/dashboard");
                            }
                        })
                    }),
                    !formSentToClient && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                        submitOnEnter: false,
                        editByDefault: true,
                        handleSubmit: handleSubmit,
                        schema: undefined,
                        formData: {},
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ddf10c05dedf652$export$2e2bcd8739ae039), {
                                termsOfAgreement: termsOfAgreement,
                                setTermsOfAgreement: setTermsOfAgreement,
                                societyList: societyList,
                                setSocietyList: setSocietyList,
                                selectAllSocieties: selectAllSocieties,
                                setSelectAllSocieties: setSelectAllSocieties
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa72595174cf6cb$export$d51e1baf57edf249), {
                                successLabel: "Continue"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7e9c846bb4379f2$export$2e2bcd8739ae039), {
                        showModal: isModalOpen,
                        modalClose: handleOnCancel,
                        clientId: userId,
                        clientEmailAddress: userSettings?.emailAddress,
                        preview: true,
                        setPandadocDocumentIds: setPandadocDocumentIds,
                        isLoading: isLoading,
                        setIsLoading: setIsLoading,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-my-4 tw-space-x-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Send to client",
                                    onClick: handleSendToClient
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    onClick: handleOnCancel,
                                    label: "Cancel",
                                    variant: "link-secondary"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: showSuccessModal,
                onClose: ()=>{
                    setShowSuccessModal(false);
                },
                disableBackdropClick: true,
                hasCloseButton: false,
                title: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
                    title: "Sent to client",
                    description: "The WMC forms have been sent to the client and you will be notified once completed",
                    cta: {
                        ctaText: "Return to Dashboard",
                        onClick: ()=>{
                            navigate("/dashboard");
                        }
                    }
                })
            })
        ]
    });
}
var $4b698fe643cd3ade$export$2e2bcd8739ae039 = $4b698fe643cd3ade$var$TermsOfAgreement;




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $008e11cf932a0927$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ],
    [
        "path",
        {
            d: "m19 12-7 7-7-7",
            key: "1idqje"
        }
    ]
];
const $008e11cf932a0927$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-down", $008e11cf932a0927$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f05f6a77fc593bc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m5 12 7-7 7 7",
            key: "hav0vg"
        }
    ],
    [
        "path",
        {
            d: "M12 19V5",
            key: "x0mq9r"
        }
    ]
];
const $4f05f6a77fc593bc$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-up", $4f05f6a77fc593bc$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4551b311634241de$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m11 17-5-5 5-5",
            key: "13zhaf"
        }
    ],
    [
        "path",
        {
            d: "m18 17-5-5 5-5",
            key: "h8a8et"
        }
    ]
];
const $4551b311634241de$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevrons-left", $4551b311634241de$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f09bbb993f3fef38$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 17 5-5-5-5",
            key: "xnjwq"
        }
    ],
    [
        "path",
        {
            d: "m13 17 5-5-5-5",
            key: "17xmmf"
        }
    ]
];
const $f09bbb993f3fef38$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevrons-right", $f09bbb993f3fef38$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f36710bd138be5d0$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $f36710bd138be5d0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-check", $f36710bd138be5d0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b285ef0f6f9bf8bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $b285ef0f6f9bf8bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("eye", $b285ef0f6f9bf8bf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $056e74b7b26d3329$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
            key: "ct8e1f"
        }
    ],
    [
        "path",
        {
            d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
            key: "151rxh"
        }
    ],
    [
        "path",
        {
            d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
            key: "13bj9a"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const $056e74b7b26d3329$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("eye-off", $056e74b7b26d3329$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b0408904748dc3b8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
            key: "sc7q7i"
        }
    ]
];
const $b0408904748dc3b8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("funnel", $b0408904748dc3b8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $604e08b57548a73d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
            key: "1jaruq"
        }
    ]
];
const $604e08b57548a73d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("flag", $604e08b57548a73d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c00fae44777e2393$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
            key: "1u773s"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $c00fae44777e2393$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-question-mark", $c00fae44777e2393$export$3efd853dbb351e94);




// Makes an AG Grid filter popup body (a plain DOM element built by our custom
// IFilterComp implementations) user-resizable via a triangle handle in the
// bottom-right corner. Chosen dimensions are persisted to localStorage so they
// survive across sessions. localStorage is per browser profile, so this is
// naturally "per user". Pass a `storageKey` that includes the column id so each
// filter remembers its own size independently.
//
// Constraints (product requirement):
//   - max width  = 50%  of the table width
//   - max height = 100% of the table height
// Both are recomputed from the live grid element at drag time so they track
// window resizes.
// Fallback only — callers should pass a per-column `storageKey`.
const $da0c7f9a80b54153$var$DEFAULT_STORAGE_KEY = "westbury.masterDiscography.filterBoxSize";
const $da0c7f9a80b54153$var$DEFAULT_WIDTH = 250;
const $da0c7f9a80b54153$var$MIN_WIDTH = 200;
const $da0c7f9a80b54153$var$MIN_HEIGHT = 140;
function $da0c7f9a80b54153$var$readSavedSize(storageKey) {
    try {
        const raw = window.localStorage.getItem(storageKey);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed.width === "number" && typeof parsed.height === "number") return parsed;
    } catch  {
    // Ignore malformed / unavailable storage.
    }
    return null;
}
function $da0c7f9a80b54153$var$writeSavedSize(storageKey, size) {
    try {
        window.localStorage.setItem(storageKey, JSON.stringify(size));
    } catch  {
    // Ignore quota / unavailable storage.
    }
}
// Derive the resize limits from the live grid element. The filter popup is a
// descendant of `.ag-root-wrapper` (no custom popupParent is configured), so we
// can measure the table by walking up from the popup body.
function $da0c7f9a80b54153$var$getMaxBounds(gui) {
    const grid = gui.closest(".ag-root-wrapper");
    const rect = grid?.getBoundingClientRect();
    const tableWidth = rect?.width ?? window.innerWidth;
    const tableHeight = rect?.height ?? window.innerHeight;
    return {
        maxWidth: Math.round(tableWidth * 0.5),
        maxHeight: Math.round(tableHeight)
    };
}
function $da0c7f9a80b54153$var$clamp(value, min, max) {
    // max can dip below min on very small tables; keep min as the floor.
    return Math.max(min, Math.min(value, Math.max(min, max)));
}
function $da0c7f9a80b54153$export$fbb26e831b71f012(gui, options = {}) {
    const { fillElement: fillElement, storageKey: storageKey = $da0c7f9a80b54153$var$DEFAULT_STORAGE_KEY, minWidth: minWidth = $da0c7f9a80b54153$var$MIN_WIDTH, minHeight: minHeight = $da0c7f9a80b54153$var$MIN_HEIGHT, defaultWidth: defaultWidth = $da0c7f9a80b54153$var$DEFAULT_WIDTH } = options;
    gui.style.position = "relative";
    gui.style.boxSizing = "border-box";
    gui.style.overflow = "hidden";
    gui.style.maxWidth = "none";
    gui.style.width = `${defaultWidth}px`;
    // Applying an explicit height turns the fill element into the flexible,
    // scrollable region so the box grows downward from the handle.
    const applyHeight = (height)=>{
        gui.style.height = `${height}px`;
        if (fillElement) {
            fillElement.style.flex = "1 1 auto";
            fillElement.style.minHeight = "0";
            fillElement.style.maxHeight = "none";
            fillElement.style.overflow = "auto";
        }
    };
    const handle = document.createElement("div");
    handle.className = "ag-filter-resize-handle";
    handle.setAttribute("aria-hidden", "true");
    Object.assign(handle.style, {
        position: "absolute",
        right: "0",
        bottom: "0",
        width: "16px",
        height: "16px",
        cursor: "nwse-resize",
        // Bottom-right triangle.
        background: "linear-gradient(135deg, transparent 50%, #6b7280 50%)",
        zIndex: "5",
        touchAction: "none"
    });
    handle.addEventListener("pointerdown", (event)=>{
        // Prevent text selection and keep AG Grid from treating the drag as an
        // outside click that would close the popup.
        event.preventDefault();
        event.stopPropagation();
        const startX = event.clientX;
        const startY = event.clientY;
        const startWidth = gui.offsetWidth;
        const startHeight = gui.offsetHeight;
        const { maxWidth: maxWidth, maxHeight: maxHeight } = $da0c7f9a80b54153$var$getMaxBounds(gui);
        try {
            handle.setPointerCapture(event.pointerId);
        } catch  {
        // setPointerCapture can throw if the pointer is already released.
        }
        const onMove = (moveEvent)=>{
            const width = $da0c7f9a80b54153$var$clamp(startWidth + (moveEvent.clientX - startX), minWidth, maxWidth);
            const height = $da0c7f9a80b54153$var$clamp(startHeight + (moveEvent.clientY - startY), minHeight, maxHeight);
            gui.style.width = `${width}px`;
            applyHeight(height);
        };
        const onUp = ()=>{
            handle.removeEventListener("pointermove", onMove);
            handle.removeEventListener("pointerup", onUp);
            $da0c7f9a80b54153$var$writeSavedSize(storageKey, {
                width: gui.offsetWidth,
                height: gui.offsetHeight
            });
        };
        handle.addEventListener("pointermove", onMove);
        handle.addEventListener("pointerup", onUp);
    });
    gui.appendChild(handle);
    return function applySavedSize() {
        const { maxWidth: maxWidth, maxHeight: maxHeight } = $da0c7f9a80b54153$var$getMaxBounds(gui);
        const saved = $da0c7f9a80b54153$var$readSavedSize(storageKey);
        const width = $da0c7f9a80b54153$var$clamp(saved?.width ?? defaultWidth, minWidth, maxWidth);
        gui.style.width = `${width}px`;
        // Only pin a height once the user has resized before; otherwise keep the
        // natural (compact) height driven by content.
        if (saved?.height) applyHeight($da0c7f9a80b54153$var$clamp(saved.height, minHeight, maxHeight));
    };
}


const $5e7458979ad0d817$var$BLANK_KEY = "__AG_CHECKBOX_FILTER_BLANK__";
// Helper function to deduplicate values case-insensitively, keeping the first occurrence
function $5e7458979ad0d817$var$deduplicateCaseInsensitive(values) {
    const seen = new Set();
    const result = [];
    for (const value of values){
        const lower = value.toLowerCase();
        if (!seen.has(lower)) {
            seen.add(lower);
            result.push(value);
        }
    }
    return result;
}
class $5e7458979ad0d817$export$1e84ed9684f7d7df {
    init(params) {
        this.params = params;
        this.gui = document.createElement("div");
        this.gui.className = "ag-checkbox-filter tw-flex tw-flex-col tw-gap-2 tw-p-2 tw-text-sm";
        this.createSearchInput();
        this.createSelectedContainer();
        this.createResetButton();
        this.createListContainer();
        // The option list can grow well beyond 250px of content, so let the user
        // resize the box (persisted per user, keyed by column so each filter keeps
        // its own size). The list container is the element that grows to fill the
        // box once a height is applied.
        this.applySavedSize = (0, $da0c7f9a80b54153$export$fbb26e831b71f012)(this.gui, {
            fillElement: this.listContainer,
            storageKey: `westbury.masterDiscography.filterBoxSize.${params.column.getColId()}`
        });
        this.updateAvailableValues();
    }
    getGui() {
        return this.gui;
    }
    doesFilterPass(params) {
        // If server-side filtering is enabled, always return true (server handles filtering)
        if (this.params.serverSideFiltering) return true;
        // If no values are selected, show all rows (filter is inactive)
        if (!this.isFilterActive()) return true;
        // Skip filtering for detail rows - they should always show if their parent passes
        if (params.node.data && params.node.data.kind === "detail") return true;
        const value = this.getValue(params);
        // Handle null/undefined values
        if (value === null || value === undefined) return this.selectedValues.has($5e7458979ad0d817$var$BLANK_KEY);
        // Check if value is an array (for fields like contributions that are arrays)
        if (Array.isArray(value)) // For arrays, check if any item in the array matches any selected value
        return value.some((item)=>{
            const normalized = this.normalizeValue(item);
            return normalized !== null && this.selectedValues.has(normalized);
        });
        // Handle comma-separated strings (like "Producer, Writer")
        const normalized = this.normalizeValue(value);
        if (normalized === null) return this.selectedValues.has($5e7458979ad0d817$var$BLANK_KEY);
        // For comma-separated strings, split and check if any part matches
        // This handles fields like contributions that are stored as "Producer, Writer"
        if (normalized.includes(", ")) {
            const parts = normalized.split(", ").map((part)=>part.trim());
            return parts.some((part)=>this.selectedValues.has(part));
        }
        // For single values, check direct match
        return this.selectedValues.has(normalized);
    }
    isFilterActive() {
        // Filter is active only when at least one value is selected
        return this.selectedValues.size > 0;
    }
    getModel() {
        if (!this.isFilterActive()) return null;
        // If reverse mapper is provided, map display values back to API values
        let values = Array.from(this.selectedValues);
        if (this.params.reverseMapper) values = values.map((v)=>this.params.reverseMapper(v));
        return {
            values: values
        };
    }
    setModel(model) {
        if (!model) {
            // Clear selection when model is null (no filter)
            this.selectedValues.clear();
            this.renderOptions();
            return;
        }
        this.selectedValues = new Set(model.values);
        this.renderOptions();
    }
    afterGuiAttached() {
        // Restore the saved size now that the popup is in the DOM and the table
        // can be measured for clamping.
        this.applySavedSize?.();
        this.searchInput?.focus();
    }
    onNewRowsLoaded() {
        this.updateAvailableValues();
    }
    destroy() {
    // no-op
    }
    refresh() {
        this.updateAvailableValues();
        return true;
    }
    // Method to update available values from external source (e.g., API)
    setAvailableValues(values) {
        // Apply value extractor if provided (e.g., extract year from dates)
        let processedValues = values;
        if (this.params.valueExtractor) processedValues = values.map((v)=>this.params.valueExtractor(v));
        // Apply value mapper if provided (e.g., "True" -> "Yes", "False" -> "No")
        if (this.params.valueMapper) processedValues = processedValues.map((v)=>this.params.valueMapper(v));
        // Remove duplicates after processing
        let deduplicatedValues = Array.from(new Set(processedValues));
        // Apply case-insensitive deduplication if enabled
        if (this.params.caseInsensitiveDeduplication) deduplicatedValues = $5e7458979ad0d817$var$deduplicateCaseInsensitive(deduplicatedValues);
        this.values = deduplicatedValues;
        this.values.sort((a, b)=>a.localeCompare(b));
        this.filteredValues = [
            ...this.values
        ];
        // Preserve selected values that still exist
        const current = new Set(this.selectedValues);
        this.selectedValues = new Set(this.values.filter((value)=>current.has(value)));
        this.renderOptions();
    }
    createSearchInput() {
        this.searchInput = document.createElement("input");
        this.searchInput.type = "text";
        this.searchInput.placeholder = "Search";
        this.searchInput.className = "tw-rounded tw-bg-[#1d2023] tw-border tw-border-[#30353b] tw-px-2 tw-py-1";
        this.searchInput.addEventListener("input", ()=>{
            this.applySearch(this.searchInput.value);
        });
        this.gui.appendChild(this.searchInput);
    }
    createSelectedContainer() {
        this.selectedContainer = document.createElement("div");
        this.selectedContainer.className = "tw-flex tw-flex-col tw-gap-1 tw-pb-2 tw-border-b tw-border-[#30353b] tw-max-h-32 tw-overflow-auto";
        this.gui.appendChild(this.selectedContainer);
    }
    createResetButton() {
        const resetContainer = document.createElement("div");
        resetContainer.className = "tw-flex tw-justify-end tw-pb-2";
        this.resetButton = document.createElement("button");
        this.resetButton.type = "button";
        this.resetButton.textContent = "Reset";
        this.resetButton.className = "tw-text-xs tw-text-blue-400 hover:tw-text-blue-300 tw-cursor-pointer tw-bg-transparent tw-border-none tw-p-0 tw-px-1";
        this.resetButton.style.display = "none";
        this.resetButton.addEventListener("click", ()=>{
            this.selectedValues.clear();
            this.params.filterChangedCallback();
            this.renderOptions();
        });
        resetContainer.appendChild(this.resetButton);
        this.gui.appendChild(resetContainer);
    }
    createListContainer() {
        this.listContainer = document.createElement("div");
        this.listContainer.className = "tw-max-h-60 tw-overflow-auto tw-flex tw-flex-col tw-gap-1";
        this.gui.appendChild(this.listContainer);
    }
    updateAvailableValues() {
        // If availableValues are provided via params, use those instead of scanning grid
        if (this.params.availableValues && this.params.availableValues.length > 0) {
            let processedValues = [
                ...this.params.availableValues
            ];
            // Apply value extractor if provided (e.g., extract year from dates)
            if (this.params.valueExtractor) processedValues = processedValues.map((v)=>this.params.valueExtractor(v));
            // Apply value mapper if provided (e.g., "True" -> "Yes", "False" -> "No")
            if (this.params.valueMapper) processedValues = processedValues.map((v)=>this.params.valueMapper(v));
            // Remove duplicates after processing
            let deduplicatedValues = Array.from(new Set(processedValues));
            // Apply case-insensitive deduplication if enabled
            if (this.params.caseInsensitiveDeduplication) deduplicatedValues = $5e7458979ad0d817$var$deduplicateCaseInsensitive(deduplicatedValues);
            this.values = deduplicatedValues;
            this.values.sort((a, b)=>a.localeCompare(b));
            this.filteredValues = [
                ...this.values
            ];
        } else {
            // Fallback to scanning grid (original behavior)
            const valuesMap = new Map(); // Map<lowercase, first occurrence>
            this.params.api.forEachNode((node)=>{
                if (!node.data || node.data.kind === "detail") return;
                const value = this.getValue({
                    node: node
                });
                let normalized = this.normalizeValue(value);
                // Apply value extractor if provided
                if (normalized && this.params.valueExtractor) normalized = this.params.valueExtractor(normalized);
                // Apply value mapper if provided
                if (normalized && this.params.valueMapper) normalized = this.params.valueMapper(normalized);
                const finalValue = normalized ?? $5e7458979ad0d817$var$BLANK_KEY;
                if (this.params.caseInsensitiveDeduplication) {
                    const lower = finalValue.toLowerCase();
                    if (!valuesMap.has(lower)) valuesMap.set(lower, finalValue);
                } else valuesMap.set(finalValue, finalValue);
            });
            this.values = Array.from(valuesMap.values());
            this.values.sort((a, b)=>a.localeCompare(b));
            this.filteredValues = [
                ...this.values
            ];
        }
        // Preserve selected values that still exist in the new values list
        const current = new Set(this.selectedValues);
        this.selectedValues = new Set(this.values.filter((value)=>current.has(value)));
        this.renderOptions();
    }
    renderOptions() {
        // Clear containers
        this.selectedContainer.innerHTML = "";
        this.listContainer.innerHTML = "";
        // Separate filtered values into selected and unselected
        const selected = [];
        const unselected = [];
        this.filteredValues.forEach((value)=>{
            if (this.selectedValues.has(value)) selected.push(value);
            else unselected.push(value);
        });
        // Sort selected values
        selected.sort((a, b)=>a.localeCompare(b));
        // Render selected values at the top with a label if there are any
        if (selected.length > 0) {
            const labelDiv = document.createElement("div");
            labelDiv.className = "tw-text-xs tw-text-neutral-400 tw-font-medium tw-mb-1";
            labelDiv.textContent = "Selected:";
            this.selectedContainer.appendChild(labelDiv);
            selected.forEach((value)=>{
                const label = this.createCheckboxLabel(value, true);
                this.selectedContainer.appendChild(label);
            });
        }
        // Render unselected values below
        unselected.forEach((value)=>{
            const label = this.createCheckboxLabel(value, false);
            this.listContainer.appendChild(label);
        });
        // Show/hide reset button based on whether there are selected values
        if (this.resetButton) this.resetButton.style.display = this.selectedValues.size > 0 ? "block" : "none";
    }
    createCheckboxLabel(value, isSelected) {
        const label = document.createElement("label");
        label.className = "tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-white tw-cursor-pointer tw-min-w-0";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "tw-h-4 tw-w-4";
        checkbox.checked = isSelected;
        checkbox.addEventListener("change", ()=>{
            if (checkbox.checked) this.selectedValues.add(value);
            else this.selectedValues.delete(value);
            this.params.filterChangedCallback();
            this.renderOptions();
        });
        const formatted = value === $5e7458979ad0d817$var$BLANK_KEY ? "Blanks" : value;
        const optionLabel = document.createElement("span");
        optionLabel.textContent = formatted;
        optionLabel.className = "tw-truncate tw-min-w-0 tw-flex-1";
        label.appendChild(checkbox);
        label.appendChild(optionLabel);
        return label;
    }
    applySearch(value) {
        const query = value.toLowerCase();
        this.filteredValues = this.values.filter((option)=>{
            const formatted = option === $5e7458979ad0d817$var$BLANK_KEY ? "Blanks" : option;
            return formatted.toLowerCase().includes(query);
        });
        this.renderOptions();
    }
    getValue(params) {
        const { colDef: colDef } = this.params;
        const valueGetter = colDef.filterValueGetter || colDef.valueGetter;
        if (valueGetter && typeof valueGetter === "function") return valueGetter({
            api: this.params.api,
            column: this.params.column,
            context: this.params.context,
            data: params.node.data,
            node: params.node
        });
        if (colDef.field && params.node.data) return params.node.data[colDef.field];
        return null;
    }
    normalizeValue(value) {
        if (value === null || value === undefined) return null;
        if (Array.isArray(value)) return value.map((item)=>this.normalizeValue(item) ?? "").join(", ");
        return String(value);
    }
    constructor(){
        this.values = [];
        this.filteredValues = [];
        this.selectedValues = new Set();
    }
}


class $36bcfc8b5b2b059b$export$1952167e72fdddd1 {
    init(params) {
        this.params = params;
        this.gui = document.createElement("div");
        this.gui.className = "ag-text-filter tw-flex tw-flex-col tw-gap-2 tw-p-2 tw-text-sm";
        this.gui.style.maxWidth = "250px";
        this.createSearchInput();
        this.createButtons();
        // Initialize with existing filter model if present
        const filterModel = params.api.getFilterModel();
        const colId = params.column.getColId();
        const existingFilter = filterModel[colId];
        if (existingFilter && existingFilter.filter) {
            this.filterValue = String(existingFilter.filter);
            this.appliedFilterValue = this.filterValue;
            this.searchInput.value = this.filterValue;
        }
    }
    getGui() {
        return this.gui;
    }
    doesFilterPass(params) {
        // If server-side filtering is enabled, always return true (server handles filtering)
        if (this.params.serverSideFiltering) return true;
        // If no filter value is applied, show all rows (filter is inactive)
        if (!this.isFilterActive()) return true;
        // Skip filtering for detail rows - they should always show if their parent passes
        if (params.node.data && params.node.data.kind === "detail") return true;
        const value = this.getValue(params);
        // Handle null/undefined values
        if (value === null || value === undefined) return false;
        // Convert to string and perform case-insensitive contains check
        const cellValue = String(value).toLowerCase();
        const filterText = this.appliedFilterValue.toLowerCase().trim();
        return cellValue.includes(filterText);
    }
    isFilterActive() {
        // Filter is active only when there's a non-empty filter value
        return this.appliedFilterValue.trim().length > 0;
    }
    getModel() {
        if (!this.isFilterActive()) return null;
        return {
            filter: this.appliedFilterValue
        };
    }
    setModel(model) {
        if (!model || !model.filter) {
            // Clear filter when model is null or filter is empty
            this.filterValue = "";
            this.appliedFilterValue = "";
            this.searchInput.value = "";
            this.updateButtons();
            return;
        }
        this.filterValue = String(model.filter);
        this.appliedFilterValue = this.filterValue;
        this.searchInput.value = this.filterValue;
        this.updateButtons();
    }
    afterGuiAttached() {
        this.searchInput?.focus();
    }
    onNewRowsLoaded() {
    // No-op for text filter
    }
    destroy() {
    // no-op
    }
    refresh() {
        return true;
    }
    createSearchInput() {
        this.searchInput = document.createElement("input");
        this.searchInput.type = "text";
        this.searchInput.placeholder = "Search...";
        this.searchInput.className = "tw-rounded tw-bg-[#1d2023] tw-border tw-border-[#30353b] tw-px-2 tw-py-1 tw-text-white tw-placeholder-neutral-500 focus:tw-outline-none focus:tw-border-[#4a5056]";
        this.searchInput.addEventListener("input", ()=>{
            this.filterValue = this.searchInput.value;
            this.updateButtons();
        });
        this.searchInput.addEventListener("keydown", (e)=>{
            if (e.key === "Enter") {
                e.preventDefault();
                this.handleApply();
            }
        });
        this.gui.appendChild(this.searchInput);
    }
    createButtons() {
        const buttonContainer = document.createElement("div");
        buttonContainer.className = "tw-flex tw-justify-end tw-gap-2";
        this.applyButton = document.createElement("button");
        this.applyButton.type = "button";
        this.applyButton.textContent = "Apply";
        this.applyButton.className = "tw-text-xs tw-text-white tw-bg-blue-600 hover:tw-bg-blue-700 tw-cursor-pointer tw-border-none tw-rounded tw-px-3 tw-py-1 tw-transition-colors";
        this.applyButton.addEventListener("click", ()=>{
            this.handleApply();
        });
        this.resetButton = document.createElement("button");
        this.resetButton.type = "button";
        this.resetButton.textContent = "Reset";
        this.resetButton.className = "tw-text-xs tw-text-blue-400 hover:tw-text-blue-300 tw-cursor-pointer tw-bg-transparent tw-border-none tw-p-0 tw-px-1";
        this.resetButton.addEventListener("click", ()=>{
            this.handleReset();
        });
        buttonContainer.appendChild(this.applyButton);
        buttonContainer.appendChild(this.resetButton);
        this.gui.appendChild(buttonContainer);
        this.updateButtons();
    }
    handleApply() {
        this.appliedFilterValue = this.filterValue;
        this.params.filterChangedCallback();
        this.updateButtons();
        // Close the popup menu after applying the filter
        this.params.api.hidePopupMenu();
    }
    handleReset() {
        this.filterValue = "";
        this.appliedFilterValue = "";
        this.searchInput.value = "";
        this.params.filterChangedCallback();
        this.updateButtons();
        // Close the popup menu after resetting the filter
        this.params.api.hidePopupMenu();
    }
    updateButtons() {
        // Enable/disable apply button based on whether value has changed
        const hasChanged = this.filterValue !== this.appliedFilterValue;
        this.applyButton.disabled = !hasChanged;
        this.applyButton.style.opacity = hasChanged ? "1" : "0.5";
        this.applyButton.style.cursor = hasChanged ? "pointer" : "not-allowed";
        // Show/hide reset button based on whether filter is active
        this.resetButton.style.display = this.appliedFilterValue.trim().length > 0 ? "block" : "none";
    }
    getValue(params) {
        const { colDef: colDef } = this.params;
        const valueGetter = colDef.filterValueGetter || colDef.valueGetter;
        if (valueGetter && typeof valueGetter === "function") return valueGetter({
            api: this.params.api,
            column: this.params.column,
            context: this.params.context,
            data: params.node.data,
            node: params.node
        });
        if (colDef.field && params.node.data) return params.node.data[colDef.field];
        return null;
    }
    constructor(){
        this.filterValue = "";
        this.appliedFilterValue = "";
    }
}


const $3afce4b0784d8abb$export$bb51c22950e455cd = new Set([
    "expand",
    "evidence",
    "actions"
]);
const $3afce4b0784d8abb$export$a48320748d7a2751 = (value)=>{
    if (value === null || value === undefined) return "";
    if (Array.isArray(value)) return value.map((item)=>{
        if (item && typeof item === "object" && "contribution" in item) return String(item.contribution ?? "");
        return $3afce4b0784d8abb$export$a48320748d7a2751(item);
    }).filter(Boolean).join(", ");
    return String(value);
};
const $3afce4b0784d8abb$export$452a843c2126e4cf = (api, rowNode, column, copyWholeRow)=>{
    if (copyWholeRow) {
        // Whole-row copy: every visible, text-bearing column, tab-separated so it
        // pastes cleanly into a spreadsheet.
        const columns = api.getAllDisplayedColumns().filter((col)=>!$3afce4b0784d8abb$export$bb51c22950e455cd.has(col.getColId()));
        const text = columns.map((col)=>$3afce4b0784d8abb$export$a48320748d7a2751(api.getCellValue({
                rowNode: rowNode,
                colKey: col
            }))).join("	");
        return {
            text: text,
            flashColumns: columns.map((col)=>col.getColId()),
            feedback: "Row copied to clipboard"
        };
    }
    if ($3afce4b0784d8abb$export$bb51c22950e455cd.has(column.getColId())) return null;
    const text = $3afce4b0784d8abb$export$a48320748d7a2751(api.getCellValue({
        rowNode: rowNode,
        colKey: column
    }));
    return {
        text: text,
        flashColumns: [
            column.getColId()
        ],
        feedback: "Cell copied to clipboard"
    };
};
const $3afce4b0784d8abb$export$f980440e1ab4537d = async (text)=>{
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch  {
    // Fall through to the legacy path below.
    }
    try {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.top = "0";
        textarea.style.left = "0";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(textarea);
        return ok;
    } catch  {
        return false;
    }
};






var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

const $bb6d544802d60420$export$a814bb3374afa59b = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-full", "tw-h-11", "tw-p-3", "tw-rounded-lg", "tw-border-2", "tw-border-formInputBackground", "tw-bg-formInputBackground", "tw-text-white", "tw-text-sm", "tw-placeholder-textSeal", "focus:tw-border-white", "focus:tw-outline-none", "disabled:tw-cursor-not-allowed", "disabled:tw-opacity-60");
const $bb6d544802d60420$export$c60fc0121e325863 = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($bb6d544802d60420$export$a814bb3374afa59b, "tw-h-auto", "tw-resize-y");
const $bb6d544802d60420$export$69aed5ace27d1255 = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($bb6d544802d60420$export$a814bb3374afa59b, "wmc-select", "tw-pl-3");
const $bb6d544802d60420$export$f7148014ed42e56b = (hasValue)=>hasValue ? "tw-text-white" : "tw-text-textSeal";
const $bb6d544802d60420$export$5205ba4e60b034b1 = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-full", "tw-min-h-[2.75rem]", "tw-p-3", "tw-rounded-lg", "tw-border-2 tw-border-formInputBackground", "tw-bg-surfaceBlack90", "tw-text-white tw-text-sm");
const $bb6d544802d60420$export$a1e737d995d28b3 = "tw-border-westburyRed focus:tw-border-westburyRed";
const $bb6d544802d60420$export$3288f564f0f980a7 = "tw-opacity-60 tw-cursor-not-allowed";
function $bb6d544802d60420$export$cc3b8b2da9fb3bff(options = {}) {
    const { kind: kind = "input", error: error, locked: locked, hasValue: hasValue, className: className } = options;
    const base = kind === "textarea" ? $bb6d544802d60420$export$c60fc0121e325863 : kind === "select" ? $bb6d544802d60420$export$69aed5ace27d1255 : $bb6d544802d60420$export$a814bb3374afa59b;
    return (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(base, kind === "select" && $bb6d544802d60420$export$f7148014ed42e56b(!!hasValue), error && $bb6d544802d60420$export$a1e737d995d28b3, locked && $bb6d544802d60420$export$3288f564f0f980a7, className);
}
const $bb6d544802d60420$export$245c09d1fdadc2df = "tw-block tw-text-sm tw-font-medium tw-text-white";
const $bb6d544802d60420$export$120f973cb24657d5 = "tw-text-xs tw-leading-4 tw-text-textSeal";
const $bb6d544802d60420$export$7a55dcc9227b4343 = "tw-text-xs tw-text-textSeal";
const $bb6d544802d60420$export$314105a17693dd98 = "tw-text-sm tw-text-textDove";
const $bb6d544802d60420$export$a6bfce277b24cca2 = "tw-text-xs tw-text-westburyRed";
const $bb6d544802d60420$export$604b83ddef844464 = "tw-flex tw-items-center tw-justify-between tw-mb-2";
const $bb6d544802d60420$export$d9bb8578fc3ff40f = "tw-flex tw-justify-end tw-gap-2 tw-pt-2";
const $bb6d544802d60420$export$ae270fdcc1622e9f = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-absolute tw-z-[60] tw-left-0 tw-right-0 tw-top-full tw-mt-1", "tw-max-h-48 tw-overflow-y-auto", "tw-rounded-lg tw-border-2 tw-border-formInputBackground", "tw-bg-surfaceBlack80 tw-py-1 tw-shadow-lg");
const $bb6d544802d60420$export$4f83e5d0e324b6c5 = "tw-w-full tw-text-left tw-px-3 tw-py-1.5 tw-text-sm tw-text-white hover:tw-bg-surfaceBlack90 tw-transition-colors";
const $bb6d544802d60420$export$785837da81429671 = "tw-px-3 tw-py-2 tw-text-textDove tw-text-xs";
const $bb6d544802d60420$export$ed929ff84da6e8f5 = "tw-text-textSeal tw-text-xs tw-ml-2";
const $bb6d544802d60420$export$4d759f1b65b98f06 = ({ options: options, exclude: exclude = [], onSelect: onSelect, placeholder: placeholder, renderOption: renderOption })=>{
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const q = query.trim().toLowerCase();
        return options.filter((o)=>(!q || o.toLowerCase().includes(q)) && !exclude.includes(o));
    }, [
        options,
        exclude,
        query
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: $bb6d544802d60420$export$a814bb3374afa59b,
                value: query,
                onChange: (e)=>{
                    setQuery(e.target.value);
                    setOpen(true);
                },
                onFocus: ()=>setOpen(true),
                onBlur: ()=>setTimeout(()=>setOpen(false), 200),
                placeholder: placeholder ?? "Search or select\u2026"
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $bb6d544802d60420$export$ae270fdcc1622e9f,
                children: filtered.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: $bb6d544802d60420$export$785837da81429671,
                    children: "No matches"
                }) : filtered.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: $bb6d544802d60420$export$4f83e5d0e324b6c5,
                        onMouseDown: (e)=>{
                            e.preventDefault();
                            onSelect(o);
                            setQuery("");
                            setOpen(false);
                        },
                        children: renderOption ? renderOption(o) : o
                    }, o))
            })
        ]
    });
};
const $bb6d544802d60420$export$32cde37ade98aa4f = ({ leftLabel: leftLabel, rightLabel: rightLabel, isLeftSelected: isLeftSelected, onSelectLeft: onSelectLeft, onSelectRight: onSelectRight, disabled: disabled = false })=>{
    const side = (selected, rounding)=>(0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-px-4 tw-py-1.5 tw-text-sm tw-transition-colors", rounding, selected ? "tw-bg-surfaceLime tw-text-black" : "tw-bg-formInputBackground tw-text-white", !selected && !disabled && "hover:tw-bg-surfaceLime hover:tw-text-black", disabled && "tw-opacity-60 tw-cursor-not-allowed");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                disabled: disabled,
                onClick: onSelectLeft,
                className: side(isLeftSelected, "tw-rounded-l-md"),
                children: leftLabel
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                disabled: disabled,
                onClick: onSelectRight,
                className: side(!isLeftSelected, "tw-rounded-r-md"),
                children: rightLabel
            })
        ]
    });
};


const $225524c18db7a507$export$5b52dd5528497bb9 = [
    {
        id: "1",
        label: "Verified (No Effort)",
        color: "#6EE038",
        textColor: "black"
    },
    {
        id: "2",
        label: "Inferred (Low Effort)",
        color: "#F6FF00",
        textColor: "black"
    },
    {
        id: "3",
        label: "Credited (Mid Effort)",
        color: "#FF8A00",
        textColor: "white"
    },
    {
        id: "4",
        label: "Unverified (High Effort)",
        color: "#FF2600",
        textColor: "white"
    },
    {
        id: "5",
        label: "Unknown (Max Effort)",
        color: "#AAB2B9",
        textColor: "black"
    }
];
function $225524c18db7a507$export$371aef6c8e9fcc5c(value) {
    const trimmed = value.trim();
    if (!trimmed) return null; // optional field
    const hasScheme = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(trimmed);
    let parsed;
    try {
        parsed = new URL(hasScheme ? trimmed : `http://${trimmed}`);
    } catch  {
        return "Enter a valid URL (e.g. google.com)";
    }
    if (!parsed.hostname || !parsed.hostname.includes(".")) return "Enter a valid URL (e.g. google.com)";
    return null;
}
const $225524c18db7a507$var$capitalize = (s)=>s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
const $225524c18db7a507$var$EMPTY_VALUE = {
    contributionName: "",
    confidenceCategory: "1",
    evidenceUrl: "",
    notes: "",
    personaId: ""
};
const $225524c18db7a507$export$ad612c67e8fe7176 = ({ isOpen: isOpen, onClose: onClose, mode: mode, initialValue: initialValue, aliases: aliases, aliasesLoading: aliasesLoading = false, onSave: onSave })=>{
    const [form, setForm] = (0, $acw62.useState)($225524c18db7a507$var$EMPTY_VALUE);
    const [evidenceError, setEvidenceError] = (0, $acw62.useState)(null);
    // Seed the form each time the modal opens. Intentionally only depends on
    // `isOpen` so re-renders while open don't clobber in-progress edits.
    const seedRef = (0, $acw62.useRef)(initialValue);
    seedRef.current = initialValue;
    (0, $acw62.useEffect)(()=>{
        if (isOpen) {
            setForm({
                ...$225524c18db7a507$var$EMPTY_VALUE,
                ...seedRef.current
            });
            setEvidenceError(null);
        }
    }, [
        isOpen
    ]);
    const handleSave = ()=>{
        const evidenceUrl = form.evidenceUrl?.trim() ?? "";
        const error = $225524c18db7a507$export$371aef6c8e9fcc5c(evidenceUrl);
        if (error) {
            setEvidenceError(error);
            return;
        }
        setEvidenceError(null);
        onSave({
            contribution: form.contributionName,
            confidenceCategory: form.confidenceCategory,
            confidencePattern: JSON.stringify({
                evidenceUrl: evidenceUrl,
                notes: form.notes?.trim() ?? ""
            }),
            personaId: form.personaId || undefined
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: onClose,
        title: "Contribution",
        modalClasses: "tw-max-w-md tw-w-full tw-mx-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-4 tw-space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-block tw-text-textSeal tw-text-xs tw-font-medium tw-mb-1",
                            children: "Contribution"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-white tw-text-sm",
                            children: form.contributionName ? $225524c18db7a507$var$capitalize(form.contributionName) : "\u2014"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "contribution-modal-alias",
                            className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                            children: "Alias"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            id: "contribution-modal-alias",
                            value: form.personaId,
                            onChange: (e)=>setForm((prev)=>({
                                        ...prev,
                                        personaId: e.target.value
                                    })),
                            disabled: aliasesLoading,
                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                kind: "select",
                                hasValue: !!form.personaId
                            }),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: aliasesLoading ? "Loading aliases\u2026" : "Select alias"
                                }),
                                aliases.map((alias)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: alias.personaId,
                                        children: alias.stageName
                                    }, alias.personaId))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "contribution-modal-confidence",
                            className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                            children: "Data Quality Category"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                            id: "contribution-modal-confidence",
                            value: form.confidenceCategory,
                            onChange: (e)=>setForm((prev)=>({
                                        ...prev,
                                        confidenceCategory: e.target.value
                                    })),
                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                kind: "select",
                                hasValue: !!form.confidenceCategory
                            }),
                            children: $225524c18db7a507$export$5b52dd5528497bb9.map((cat)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: cat.id,
                                    children: cat.label
                                }, cat.id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $bb6d544802d60420$export$604b83ddef844464),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "contribution-modal-evidence",
                                    className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                    children: "Evidence URL"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                    children: "Optional"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "contribution-modal-evidence",
                            type: "url",
                            value: form.evidenceUrl,
                            onChange: (e)=>{
                                setForm((prev)=>({
                                        ...prev,
                                        evidenceUrl: e.target.value
                                    }));
                                if (evidenceError) setEvidenceError(null);
                            },
                            placeholder: "https://...",
                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                error: !!evidenceError
                            })
                        }),
                        evidenceError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                            children: evidenceError
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $bb6d544802d60420$export$604b83ddef844464),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "contribution-modal-notes",
                                    className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                    children: "Notes"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                    children: "Optional"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                            id: "contribution-modal-notes",
                            value: form.notes,
                            onChange: (e)=>setForm((prev)=>({
                                        ...prev,
                                        notes: e.target.value
                                    })),
                            placeholder: "Optional notes",
                            rows: 3,
                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                kind: "textarea"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Save",
                            disabled: mode === "add" && !form.personaId,
                            onClick: handleSave
                        })
                    ]
                })
            ]
        })
    });
};
var $225524c18db7a507$export$2e2bcd8739ae039 = $225524c18db7a507$export$ad612c67e8fe7176;




var $acw62 = parcelRequire("acw62");


var $f1q41 = parcelRequire("f1q41");
/**
 * Single source of truth for the "manually changed" purple indicator shown
 * across the app:
 *  - discography table rows (MasterDiscography `getRowStyle`)
 *  - the recording edit form fields/chips
 *  - the release edit form fields/chips
 *
 * The visual attributes (colour + line width) live as CSS custom properties in
 * `global.css` (`--color-manual-change`, `--manual-change-line-width`). Both
 * the CSS-driven left line (`.manual-change-line::before`) and the JS-driven
 * ag-grid row style below reference those same variables, so changing the
 * look & feel only requires editing the variables in `global.css`.
 */ /** Class that draws the purple left line via a `::before` pseudo-element.
 *  Apply it to a relatively-positioned wrapper around the edited element
 *  (inputs/selects, which can't host `::before`, must be wrapped). */ const $0fd6d64054ffdc01$export$ac9987bd29f3f58f = "manual-change-line";
const $0fd6d64054ffdc01$export$4a73c783bc3de3b9 = "inset var(--manual-change-line-width) 0 0 0 var(--color-manual-change)";
const $0fd6d64054ffdc01$export$45668a2be728d092 = {
    boxShadow: $0fd6d64054ffdc01$export$4a73c783bc3de3b9
};



const $473dabb7bb223c2d$export$84e9997ca939742d = "Manually Changed";
const $473dabb7bb223c2d$export$710d1af9aabb2280 = ({ text: text })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        role: "tooltip",
        className: "tw-absolute tw-bottom-full tw-left-1/2 -tw-translate-x-1/2 tw-mb-1 tw-px-2 tw-py-1 tw-bg-gray-900 tw-text-white tw-text-xs tw-font-medium tw-rounded tw-whitespace-pre-wrap tw-max-w-xs tw-z-50 tw-pointer-events-none tw-shadow-lg tw-border tw-border-gray-700",
        children: text
    });
const $473dabb7bb223c2d$export$e151e13a7e9f85a5 = ({ edited: edited, outerClassName: outerClassName, children: children })=>{
    const [hover, setHover] = (0, $acw62.useState)(false);
    if (!edited) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${(0, $0fd6d64054ffdc01$export$ac9987bd29f3f58f)} ${outerClassName ?? "tw-inline-flex"}`,
        onMouseEnter: ()=>setHover(true),
        onMouseLeave: ()=>setHover(false),
        children: [
            children,
            hover && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($473dabb7bb223c2d$export$710d1af9aabb2280, {
                text: $473dabb7bb223c2d$export$84e9997ca939742d
            })
        ]
    });
};
const $473dabb7bb223c2d$export$92a172cc67aad148 = ({ name: name, edited: edited, onRemove: onRemove, removeTitle: removeTitle })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($473dabb7bb223c2d$export$e151e13a7e9f85a5, {
        edited: edited,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-relative tw-inline-flex tw-items-center tw-gap-1 tw-rounded-xs tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-bg-gray-700 tw-text-white",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: name
                }),
                onRemove && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onRemove,
                    className: "tw-ml-0.5 tw-opacity-60 hover:tw-opacity-100 tw-flex tw-items-center",
                    title: removeTitle,
                    "aria-label": removeTitle ?? `Remove ${name}`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                        size: 12
                    })
                })
            ]
        })
    });
const $473dabb7bb223c2d$export$7260e85975d9726b = ({ value: value, edited: edited, changed: changed = false, suffix: suffix, dimmed: dimmed = false, onRemove: onRemove })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($473dabb7bb223c2d$export$e151e13a7e9f85a5, {
        edited: edited,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `tw-relative tw-inline-flex tw-items-center tw-gap-1 tw-rounded-xs tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-bg-gray-700 tw-text-white ${dimmed ? "tw-opacity-60" : ""}`,
            children: [
                changed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-absolute -tw-top-1 -tw-right-1 tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-surfacePurple tw-border tw-border-gray-900 tw-animate-pulse-slow"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: value
                }),
                suffix,
                onRemove && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onRemove,
                    className: "tw-ml-1 tw-text-gray-400 hover:tw-text-white tw-flex tw-items-center",
                    title: "Remove",
                    "aria-label": `Remove ${value}`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                        size: 12
                    })
                })
            ]
        })
    });
function $473dabb7bb223c2d$export$9802db7709cd18b6(categoryId) {
    const cat = (0, $225524c18db7a507$export$5b52dd5528497bb9).find((c)=>c.id === categoryId) ?? (0, $225524c18db7a507$export$5b52dd5528497bb9)[4];
    return {
        backgroundColor: cat.color,
        color: cat.textColor
    };
}
const $473dabb7bb223c2d$export$1fcd028c38eb96f = ({ role: role, confidenceCategory: confidenceCategory, edited: edited, changed: changed = false, changedTitle: changedTitle, onSelect: onSelect, onRemove: onRemove })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($473dabb7bb223c2d$export$e151e13a7e9f85a5, {
        edited: edited,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `tw-relative tw-inline-flex tw-items-center tw-gap-1 tw-rounded-xs tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-uppercase tw-border-2 tw-border-transparent tw-transition-colors${onSelect ? " tw-cursor-pointer hover:tw-border-white/50" : ""}`,
            style: $473dabb7bb223c2d$export$9802db7709cd18b6(confidenceCategory ?? "1"),
            title: edited ? undefined : changed ? changedTitle : onSelect ? "Click to edit confidence category" : undefined,
            children: [
                changed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-absolute -tw-top-1 -tw-right-1 tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-surfacePurple tw-border tw-border-gray-900 tw-animate-pulse-slow"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    role: onSelect ? "button" : undefined,
                    tabIndex: onSelect ? 0 : undefined,
                    onClick: onSelect ? (e)=>{
                        e.stopPropagation();
                        onSelect();
                    } : undefined,
                    onKeyDown: onSelect ? (e)=>{
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            e.stopPropagation();
                            onSelect();
                        }
                    } : undefined,
                    children: (0, $f1q41.capitalize)(role)
                }),
                onRemove && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: (e)=>{
                        e.stopPropagation();
                        onRemove();
                    },
                    className: "tw-ml-0.5 tw-opacity-60 hover:tw-opacity-100 tw-flex tw-items-center",
                    title: "Remove contribution",
                    "aria-label": `Remove ${role}`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                        size: 12
                    })
                })
            ]
        })
    });


/* eslint-disable jsx-a11y/label-has-associated-control */ 

var $acw62 = parcelRequire("acw62");





/**
 * Turns an error thrown by a save API call into a user-friendly message shown
 * above the Save CTA on the recording/release edit form.
 *
 * The generated API client throws a `ResponseError` (carrying the raw fetch
 * `Response`) for any non-2xx. Backend save failures return HTTP 400 with one
 * of these body shapes:
 *  - service failure:  { success:false, …, errors: string[] }
 *  - DRF validation:   { <field>: ["msg"], … } (sometimes nested under `payload`)
 *  - misc:             { error: "…" }
 * The raw error text often contains DynamoDB / Neptune-Gremlin / OpenSearch
 * detail that we map to plain-language guidance, with a vague fallback for
 * anything we don't recognise.
 */ const $4e44ff72ec5a5d6e$var$CONTEXT_NOUN = {
    recording: "recording",
    release: "release",
    artists: "artist changes",
    contributions: "contributions",
    "release-link": "release"
};
/** Known raw-error substrings → friendly messages. First match wins. */ const $4e44ff72ec5a5d6e$var$KNOWN_ERRORS = [
    {
        test: /duplicate/i,
        message: "This change contains duplicate values (for example a repeated ISRC, label, or catalogue number). Remove the duplicates and try again."
    },
    {
        test: /accessdenied|not authorized/i,
        message: "This change couldn't be saved because of a permissions issue on our side. Please contact support."
    },
    {
        test: /graph (edges|nodes)|gremlin|expecting value/i,
        message: "We couldn't sync this change to the database. Please try again in a moment \u2014 if it keeps failing, contact support."
    },
    {
        test: /opensearch/i,
        message: "We couldn't update the search index for this change. Please try again, or contact support if it persists."
    },
    {
        // Pass the backend's already-friendly message through unchanged.
        test: /duration is already set/i,
        message: "Duration is already set by the system and cannot be changed."
    }
];
function $4e44ff72ec5a5d6e$var$isResponseError(err) {
    return typeof err === "object" && err !== null && err.name === "ResponseError" && "response" in err;
}
/** Collect raw text + field names from a parsed error body. */ function $4e44ff72ec5a5d6e$var$extractFromBody(body) {
    const result = {
        raw: "",
        fields: [],
        isFieldValidation: false
    };
    if (typeof body !== "object" || body === null) {
        if (typeof body === "string") result.raw = body;
        return result;
    }
    const obj = body;
    // Service failure shape: { errors: string[] }
    if (Array.isArray(obj.errors)) {
        result.raw = obj.errors.filter((e)=>typeof e === "string").join(" ");
        return result;
    }
    // Misc shape: { error: "…" }
    if (typeof obj.error === "string") {
        result.raw = obj.error;
        return result;
    }
    // DRF field-error dict, possibly nested under `payload`.
    const dict = typeof obj.payload === "object" && obj.payload !== null ? obj.payload : obj;
    const parts = [];
    for (const [field, value] of Object.entries(dict))if (Array.isArray(value) && value.some((v)=>typeof v === "string")) {
        result.isFieldValidation = true;
        result.fields.push(field);
        parts.push(`${field}: ${value.filter((v)=>typeof v === "string").join(" ")}`);
    }
    result.raw = parts.join(" ");
    return result;
}
async function $4e44ff72ec5a5d6e$export$3ad1f1ce31dd8e4a(err, context) {
    let extracted = {
        raw: "",
        fields: [],
        isFieldValidation: false
    };
    if ($4e44ff72ec5a5d6e$var$isResponseError(err)) try {
        const body = await err.response.clone().json();
        extracted = $4e44ff72ec5a5d6e$var$extractFromBody(body);
    } catch  {
        // Body wasn't JSON / already consumed — fall back to the error message.
        extracted.raw = err.message ?? "";
    }
    else if (err instanceof Error) extracted.raw = err.message;
    const raw = extracted.raw;
    // Field-validation errors (missing required release details).
    if (extracted.isFieldValidation || /may not be null|this field|is required/i.test(raw)) {
        const fieldList = extracted.fields.length ? ` Missing or empty: ${extracted.fields.join(", ")}.` : "";
        return `Some required details are missing or empty. Please complete every field and try again.${fieldList}`;
    }
    for (const { test: test, message: message } of $4e44ff72ec5a5d6e$var$KNOWN_ERRORS){
        if (test.test(raw)) return message;
    }
    // Generic AWS validation that wasn't a duplicate.
    if (/validationexception/i.test(raw)) return "The data for this change wasn\u2019t accepted. Please review your edits and try again, or contact support.";
    return `Something went wrong while saving the ${$4e44ff72ec5a5d6e$var$CONTEXT_NOUN[context]}. Your change may not have been saved \u{2014} please try again, or contact support if the problem continues.`;
}



/**
 * Change/Link Release modal — extracted from RecordingEditForm so it can be
 * reused by the bulk-edit builder.
 *
 * - mode="apply" (recording edit form): performs the create-and-link /
 *   link-earliest API call for a single recording, then hands the updated Row
 *   to `onApplied`.
 * - mode="select" (bulk edit): does the (read-only) lookup so the user can pick
 *   a release, but does NOT link — it just returns the chosen release via
 *   `onApplied`, leaving the actual per-recording linking to the bulk apply.
 *   The second `onApplied` argument carries the linkage itself (see
 *   `ReleaseSelection`); the Row alone only describes how the release should
 *   *display*, which isn't enough to link by.
 */ const $88d049fe01006cd7$var$MIN_RELEASE_YEAR = 1920;
const $88d049fe01006cd7$var$MAX_RELEASE_YEAR_OFFSET = 2; // current year + 2
// Field presentation comes from ./formStyles so this modal looks the same
// whether it was opened from the recording edit form or the bulk-edit builder.
const $88d049fe01006cd7$var$SELECT_BASE_CLASS = (0, $bb6d544802d60420$export$69aed5ace27d1255);
const $88d049fe01006cd7$var$selectTextClass = (0, $bb6d544802d60420$export$f7148014ed42e56b);
function $88d049fe01006cd7$export$44c3be0a49ff5d2e(value) {
    const trimmed = value.trim();
    if (!trimmed) return null; // optional field
    if (!/^\d{4}$/.test(trimmed)) return "Year must be a 4-digit number";
    const year = Number(trimmed);
    const maxYear = new Date().getFullYear() + $88d049fe01006cd7$var$MAX_RELEASE_YEAR_OFFSET;
    if (year < $88d049fe01006cd7$var$MIN_RELEASE_YEAR) return `Year cannot be before ${$88d049fe01006cd7$var$MIN_RELEASE_YEAR}`;
    if (year > maxYear) return `Year cannot be after ${maxYear}`;
    return null;
}
function $88d049fe01006cd7$var$findDuplicate(values) {
    const seen = new Set();
    for (const v of values){
        const key = v.toLowerCase();
        if (seen.has(key)) return v;
        seen.add(key);
    }
    return null;
}
function $88d049fe01006cd7$var$addMultipleValue(setter, value) {
    const trimmed = value.trim();
    if (trimmed) setter((prev)=>prev.some((v)=>v.toLowerCase() === trimmed.toLowerCase()) ? prev : [
            ...prev,
            trimmed
        ]);
}
function $88d049fe01006cd7$var$mapReleaseSourceToLookupEnum(source) {
    switch(source){
        case "Discogs":
            return (0, $cdef5ca7170fc2e8$export$73e80048d9b56855).Discogs;
        case "Deezer":
            return (0, $cdef5ca7170fc2e8$export$73e80048d9b56855).Deezer;
        case "Spotify":
            return (0, $cdef5ca7170fc2e8$export$73e80048d9b56855).Spotify;
        case "MusicBrainz":
            return (0, $cdef5ca7170fc2e8$export$73e80048d9b56855).Mb;
        case "PPL":
            return (0, $cdef5ca7170fc2e8$export$73e80048d9b56855).Ppl;
        default:
            return null;
    }
}
function $88d049fe01006cd7$var$mapReleaseSourceToContractKey(source) {
    switch(source){
        case "Deezer":
            return "deezer";
        case "Spotify":
            return "spotify";
        case "MusicBrainz":
            return "MB";
        case "PPL":
            return "ppl";
        case "Other":
            return "other";
        default:
            return "discogs";
    }
}
function $88d049fe01006cd7$var$mapReleaseSourceToCreateEnum(source) {
    switch(source){
        case "Discogs":
            return (0, $f3269fd5dab4fed8$export$94d5afa8d02dd2a6).Discogs;
        case "Deezer":
            return (0, $f3269fd5dab4fed8$export$94d5afa8d02dd2a6).Deezer;
        case "Spotify":
            return (0, $f3269fd5dab4fed8$export$94d5afa8d02dd2a6).Spotify;
        case "MusicBrainz":
            return (0, $f3269fd5dab4fed8$export$94d5afa8d02dd2a6).Mb;
        case "PPL":
            return (0, $f3269fd5dab4fed8$export$94d5afa8d02dd2a6).Ppl;
        case "Other":
            return (0, $f3269fd5dab4fed8$export$94d5afa8d02dd2a6).Other;
        default:
            return (0, $f3269fd5dab4fed8$export$94d5afa8d02dd2a6).Discogs;
    }
}
const $88d049fe01006cd7$var$MultiValueAddField = ({ label: label, addLabel: addLabel, placeholder: placeholder, values: values, onRemove: onRemove, open: open, setOpen: setOpen, value: value, setValue: setValue, commit: commit, inputId: inputId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        htmlFor: inputId,
                        className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                        children: "Optional"
                    })
                ]
            }),
            values.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-2",
                children: values.map((v, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-inline-flex tw-items-center tw-gap-1 tw-rounded-xs tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-bg-formInputBackground tw-text-white",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: v
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onRemove(index),
                                className: "tw-ml-1 tw-text-textSeal hover:tw-text-white",
                                title: "Remove",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    size: 12
                                })
                            })
                        ]
                    }, index))
            }),
            values.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-textSeal tw-text-xs tw-mb-2",
                children: "None"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-gap-1.5",
                children: open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: inputId,
                            type: "text",
                            placeholder: placeholder,
                            value: value,
                            onChange: (e)=>setValue(e.target.value),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" && value.trim()) {
                                    e.preventDefault();
                                    commit();
                                } else if (e.key === "Escape") {
                                    setValue("");
                                    setOpen(false);
                                }
                            },
                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                className: "tw-flex-1"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: ()=>{
                                        setValue("");
                                        setOpen(false);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Create",
                                    disabled: !value.trim(),
                                    onClick: commit
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-justify-end",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        className: "tw-text-sm tw-flex tw-items-center tw-text-textWhite hover:tw-text-textLime",
                        onClick: ()=>{
                            setValue("");
                            setOpen(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi wi-20px wi-plus tw-mr-1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-underline",
                                children: addLabel
                            })
                        ]
                    })
                })
            })
        ]
    });
const $88d049fe01006cd7$export$334ef0499792785f = ({ isOpen: isOpen, onClose: onClose, mode: mode = "apply", userId: userId, row: row, bulkRecordingIds: bulkRecordingIds, current: current = {}, currentLabels: currentLabels = [], currentCatNumbers: currentCatNumbers = [], availableFormats: availableFormats = [], availableTypes: availableTypes = [], onApplied: onApplied })=>{
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [releaseId, setReleaseId] = (0, $acw62.useState)("");
    const [releaseSource, setReleaseSource] = (0, $acw62.useState)("Discogs");
    const [sourceUrl, setSourceUrl] = (0, $acw62.useState)("");
    const [newReleaseTitle, setNewReleaseTitle] = (0, $acw62.useState)("");
    const [newReleaseYear, setNewReleaseYear] = (0, $acw62.useState)("");
    const [newReleaseLabels, setNewReleaseLabels] = (0, $acw62.useState)([]);
    const [newReleaseCatNumbers, setNewReleaseCatNumbers] = (0, $acw62.useState)([]);
    const [newLabelInputOpen, setNewLabelInputOpen] = (0, $acw62.useState)(false);
    const [newLabelInputValue, setNewLabelInputValue] = (0, $acw62.useState)("");
    const [newCatNoInputOpen, setNewCatNoInputOpen] = (0, $acw62.useState)(false);
    const [newCatNoInputValue, setNewCatNoInputValue] = (0, $acw62.useState)("");
    const [newReleaseFormat, setNewReleaseFormat] = (0, $acw62.useState)("");
    const [newReleaseType, setNewReleaseType] = (0, $acw62.useState)("");
    const [releaseLookupLoading, setReleaseLookupLoading] = (0, $acw62.useState)(false);
    const [releaseLookupError, setReleaseLookupError] = (0, $acw62.useState)(null);
    const [releaseLookupSuccess, setReleaseLookupSuccess] = (0, $acw62.useState)(false);
    const [releaseLookupNotFound, setReleaseLookupNotFound] = (0, $acw62.useState)(false);
    const [releaseLookupNotLinked, setReleaseLookupNotLinked] = (0, $acw62.useState)(false);
    const [releaseNotLinkedConfirmed, setReleaseNotLinkedConfirmed] = (0, $acw62.useState)(false);
    const [lookupReleaseId, setLookupReleaseId] = (0, $acw62.useState)("");
    const [lookupEdgeId, setLookupEdgeId] = (0, $acw62.useState)(null);
    const [lookupDateReleased, setLookupDateReleased] = (0, $acw62.useState)(null);
    const [releaseChangeSubmitError, setReleaseChangeSubmitError] = (0, $acw62.useState)(null);
    const [releaseChangeSubmitLoading, setReleaseChangeSubmitLoading] = (0, $acw62.useState)(false);
    const [releaseSameAsCurrentError, setReleaseSameAsCurrentError] = (0, $acw62.useState)(false);
    const [newReleaseYearError, setNewReleaseYearError] = (0, $acw62.useState)(null);
    /** Bulk lookup only: how many of the selected recordings are already on this
   *  release. Null until a bulk lookup has run. */ const [bulkLinkedCount, setBulkLinkedCount] = (0, $acw62.useState)(null);
    /** True when the lookup should be a *set* question — "is this release already
   *  linked to any of these recordings?" — rather than a single-recording one.
   *  Only bulk 'select' mode can answer that, and only it needs to. */ const bulkLookupIds = mode === "select" && bulkRecordingIds?.length ? bulkRecordingIds : null;
    const commitNewLabel = ()=>{
        const trimmed = newLabelInputValue.trim();
        if (!trimmed) return;
        $88d049fe01006cd7$var$addMultipleValue(setNewReleaseLabels, trimmed);
        setNewLabelInputValue("");
        setNewLabelInputOpen(false);
    };
    const commitNewCatNo = ()=>{
        const trimmed = newCatNoInputValue.trim();
        if (!trimmed) return;
        $88d049fe01006cd7$var$addMultipleValue(setNewReleaseCatNumbers, trimmed);
        setNewCatNoInputValue("");
        setNewCatNoInputOpen(false);
    };
    const handleReleaseLookup = async ()=>{
        if (!userId || !bulkLookupIds && !row?.id || !releaseId.trim()) {
            setReleaseLookupError("User and recording context required. Enter a release ID.");
            return;
        }
        if (releaseSource === "Other") {
            setReleaseLookupError("Use a catalog source (e.g. Discogs) to look up by ID.");
            return;
        }
        const lookupSource = $88d049fe01006cd7$var$mapReleaseSourceToLookupEnum(releaseSource);
        if (!lookupSource) {
            setReleaseLookupError("Invalid source for lookup.");
            return;
        }
        const enteredId = releaseId.trim();
        // "Already linked to this release" is a per-recording fact, so it is only a
        // blocking error for a single recording. Across a selection it is normal —
        // and the bulk lookup reports it as a count below rather than a refusal.
        const isSameRelease = !bulkLookupIds && (row?.sourceReleaseId ?? []).some((srcId)=>srcId === enteredId || srcId.endsWith(`:${enteredId}`));
        if (isSameRelease) {
            setReleaseSameAsCurrentError(true);
            return;
        }
        setReleaseSameAsCurrentError(false);
        setReleaseLookupError(null);
        setReleaseLookupSuccess(false);
        setReleaseLookupNotFound(false);
        setReleaseLookupNotLinked(false);
        setReleaseNotLinkedConfirmed(false);
        setLookupReleaseId("");
        setLookupEdgeId(null);
        setLookupDateReleased(null);
        setBulkLinkedCount(null);
        setReleaseLookupLoading(true);
        try {
            let p;
            if (bulkLookupIds) {
                const response = await api.bulkLookupBulkLookupReleaseResponse({
                    userId: userId,
                    bulkLookupReleaseRequest: {
                        source: lookupSource,
                        sourceId: enteredId,
                        recordingIds: bulkLookupIds
                    }
                });
                p = response.payload;
                // Edges here are per recording, so there is no single `edgeId` to hold
                // — the apply resolves them again for whatever the target set is by
                // then. What this pass is for is telling the user how much of the
                // selection is already on this release before they commit to it.
                const linked = response.recordings.filter((r)=>!!r.edgeId).length;
                setBulkLinkedCount(linked);
                if (linked === 0) setReleaseLookupNotLinked(true);
            } else {
                const response = await api.lookupLookupReleaseResponse({
                    userId: userId,
                    parentRecordingId: row.id,
                    sourceId: enteredId,
                    source: lookupSource
                });
                p = response.payload;
                setLookupEdgeId(p.edgeId ?? null);
                if (!response.linked) setReleaseLookupNotLinked(true);
            }
            setLookupReleaseId(p.releaseId);
            setLookupDateReleased(p.dateReleased ?? null);
            if (p.releaseTitle) setNewReleaseTitle(p.releaseTitle);
            if (p.dateReleased) {
                const year = p.dateReleased.length >= 4 ? p.dateReleased.slice(0, 4) : p.dateReleased;
                setNewReleaseYear(year);
                setNewReleaseYearError($88d049fe01006cd7$export$44c3be0a49ff5d2e(year));
            }
            if (p.releaseLabels?.length) setNewReleaseLabels([
                ...p.releaseLabels
            ]);
            if (p.catNumbers?.length) setNewReleaseCatNumbers([
                ...p.catNumbers
            ]);
            if (p.format) setNewReleaseFormat(p.format);
            if (p.mediaType) setNewReleaseType(p.mediaType);
            setReleaseLookupSuccess(true);
        } catch (err) {
            const status = err?.response?.status ?? err?.status;
            if (status === 404) setReleaseLookupNotFound(true);
            else {
                const message = err instanceof Error ? err.message : "Release lookup failed";
                setReleaseLookupError(message);
            }
        } finally{
            setReleaseLookupLoading(false);
        }
    };
    const resetReleaseModalState = ()=>{
        setReleaseId("");
        setSourceUrl("");
        setReleaseSource("Discogs");
        setNewReleaseTitle("");
        setNewReleaseYear("");
        setNewReleaseLabels([]);
        setNewReleaseCatNumbers([]);
        setNewLabelInputOpen(false);
        setNewLabelInputValue("");
        setNewCatNoInputOpen(false);
        setNewCatNoInputValue("");
        setNewReleaseFormat("");
        setNewReleaseType("");
        setReleaseLookupError(null);
        setReleaseLookupSuccess(false);
        setReleaseLookupNotFound(false);
        setReleaseLookupNotLinked(false);
        setReleaseNotLinkedConfirmed(false);
        setReleaseSameAsCurrentError(false);
        setLookupReleaseId("");
        setLookupEdgeId(null);
        setLookupDateReleased(null);
        setBulkLinkedCount(null);
        setReleaseChangeSubmitError(null);
        setNewReleaseYearError(null);
    };
    const mergeReleaseIntoRow = ()=>{
        const base = row ?? {};
        return {
            ...base,
            release: newReleaseTitle.trim(),
            year: newReleaseYear.trim() || "",
            label: newReleaseLabels.join(", "),
            catNumbers: newReleaseCatNumbers.join(", "),
            labelsArray: newReleaseLabels,
            catNumbersArray: newReleaseCatNumbers,
            format: newReleaseFormat,
            mediaType: newReleaseType,
            earliestParentReleaseId: lookupReleaseId || base.earliestParentReleaseId,
            sourceReleaseId: releaseId.trim() ? [
                releaseId.trim()
            ] : base.sourceReleaseId,
            isModified: true
        };
    };
    /** The chosen release as a linkage (see `ReleaseSelection`). A release the
   *  lookup didn't find — or an 'Other'-source one, which can't be looked up at
   *  all — has no id yet and is created from this metadata on apply. */ const buildReleaseSelection = ()=>({
            releaseId: lookupReleaseId || null,
            source: $88d049fe01006cd7$var$mapReleaseSourceToContractKey(releaseSource),
            sourceId: releaseSource === "Other" ? sourceUrl.trim() : releaseId.trim(),
            releaseTitle: newReleaseTitle.trim(),
            dateReleased: lookupDateReleased || newReleaseYear.trim() || null,
            releaseLabels: newReleaseLabels,
            catNumbers: newReleaseCatNumbers,
            mediaType: newReleaseType,
            format: newReleaseFormat
        });
    const closeAndReset = ()=>{
        resetReleaseModalState();
        onClose();
    };
    const handleSubmit = async ()=>{
        if (newLabelInputOpen || newCatNoInputOpen) {
            setReleaseChangeSubmitError(`You have a ${newLabelInputOpen ? "label" : "catalogue number"} being entered. Please click Create to add it, or Cancel, before saving.`);
            return;
        }
        const dupNewLabel = $88d049fe01006cd7$var$findDuplicate(newReleaseLabels);
        if (dupNewLabel) {
            setReleaseChangeSubmitError(`Duplicate label: "${dupNewLabel}"`);
            return;
        }
        const dupNewCatNum = $88d049fe01006cd7$var$findDuplicate(newReleaseCatNumbers);
        if (dupNewCatNum) {
            setReleaseChangeSubmitError(`Duplicate catalogue number: "${dupNewCatNum}"`);
            return;
        }
        setReleaseChangeSubmitError(null);
        // Bulk "select" mode: don't perform the per-recording link — just return
        // the chosen release so the bulk apply can handle linking.
        if (mode === "select") {
            onApplied(mergeReleaseIntoRow(), buildReleaseSelection());
            resetReleaseModalState();
            return;
        }
        if (!userId || !row?.id) return;
        const isCreateAndLinkFlow = releaseSource === "Other" || releaseLookupNotFound;
        setReleaseChangeSubmitLoading(true);
        try {
            if (isCreateAndLinkFlow) {
                const createRequest = {
                    source: $88d049fe01006cd7$var$mapReleaseSourceToCreateEnum(releaseSource),
                    releaseTitle: newReleaseTitle.trim(),
                    dateReleased: newReleaseYear.trim() || undefined,
                    releaseLabels: newReleaseLabels.length > 0 ? newReleaseLabels : undefined,
                    catNumbers: newReleaseCatNumbers.length > 0 ? newReleaseCatNumbers : undefined,
                    format: newReleaseFormat || undefined,
                    mediaType: newReleaseType || undefined,
                    ...releaseSource === "Other" ? {
                        sourceUrl: sourceUrl.trim()
                    } : {
                        sourceId: releaseId.trim()
                    }
                };
                await api.createAndLinkServiceResponse({
                    userId: userId,
                    parentRecordingId: row.id,
                    createReleaseAndLinkRequest: {
                        ...createRequest,
                        documentId: row.documentId
                    }
                });
            } else {
                if (!lookupReleaseId) {
                    setReleaseChangeSubmitError("Missing release ID from lookup.");
                    return;
                }
                await api.linkEarliestServiceResponse({
                    userId: userId,
                    parentRecordingId: row.id,
                    linkReleaseRequest: {
                        releaseId: lookupReleaseId,
                        edgeId: lookupEdgeId ?? undefined,
                        dateReleased: lookupDateReleased ?? undefined,
                        releaseTitle: newReleaseTitle.trim(),
                        releaseLabels: newReleaseLabels.length > 0 ? newReleaseLabels : undefined,
                        catNumbers: newReleaseCatNumbers.length > 0 ? newReleaseCatNumbers : undefined,
                        mediaType: newReleaseType || undefined,
                        format: newReleaseFormat || undefined,
                        documentId: row.documentId
                    }
                });
            }
            onApplied(mergeReleaseIntoRow());
            resetReleaseModalState();
            onClose();
        } catch (err) {
            setReleaseChangeSubmitError(await (0, $4e44ff72ec5a5d6e$export$3ad1f1ce31dd8e4a)(err, "release-link"));
        } finally{
            setReleaseChangeSubmitLoading(false);
        }
    };
    const isCreateFlow = releaseSource === "Other" || releaseLookupNotFound;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: closeAndReset,
        title: isCreateFlow ? "Create and Link Release" : "Change Linked Release",
        modalClasses: "tw-max-w-lg tw-w-full tw-mx-4 tw-max-h-[90vh]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-4 tw-overflow-y-auto tw-max-h-[calc(90vh-120px)]",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mb-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "release-source-input",
                            className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                            children: "Release Source"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            id: "release-source-input",
                            value: releaseSource,
                            onChange: (e)=>{
                                const newSource = e.target.value;
                                setReleaseSource(newSource);
                                setReleaseId("");
                                setSourceUrl("");
                                setReleaseLookupError(null);
                                setReleaseLookupSuccess(false);
                                setReleaseLookupNotFound(false);
                                setReleaseLookupNotLinked(false);
                                setReleaseNotLinkedConfirmed(false);
                                setReleaseSameAsCurrentError(false);
                                if (newSource === "Other" && !newReleaseTitle.trim()) {
                                    setNewReleaseTitle(current.release || "");
                                    setNewReleaseYear(current.year || "");
                                    setNewReleaseLabels([
                                        ...currentLabels
                                    ]);
                                    setNewReleaseCatNumbers([
                                        ...currentCatNumbers
                                    ]);
                                    setNewReleaseFormat(current.format || "");
                                    setNewReleaseType(current.mediaType || "");
                                }
                            },
                            className: `${$88d049fe01006cd7$var$SELECT_BASE_CLASS} ${$88d049fe01006cd7$var$selectTextClass(!!releaseSource)}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "Discogs",
                                    children: "Discogs"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "Deezer",
                                    children: "Deezer"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "Spotify",
                                    children: "Spotify"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "MusicBrainz",
                                    children: "MusicBrainz"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "PPL",
                                    children: "PPL"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "Other",
                                    children: "Other"
                                })
                            ]
                        })
                    ]
                }),
                [
                    "Discogs",
                    "Deezer",
                    "Spotify",
                    "MusicBrainz",
                    "PPL"
                ].includes(releaseSource) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mb-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "release-id-input",
                            className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                            children: "Release ID"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-gap-2 tw-items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "release-id-input",
                                    type: "text",
                                    value: releaseId,
                                    onChange: (e)=>{
                                        setReleaseId(e.target.value);
                                        setReleaseLookupError(null);
                                        setReleaseLookupSuccess(false);
                                        setReleaseLookupNotFound(false);
                                        setReleaseLookupNotLinked(false);
                                        setReleaseNotLinkedConfirmed(false);
                                        setReleaseSameAsCurrentError(false);
                                    },
                                    className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                        className: "tw-flex-1"
                                    }),
                                    placeholder: "Enter release ID"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: releaseLookupLoading ? "Looking up\u2026" : "Lookup",
                                    disabled: releaseLookupLoading || !releaseId.trim() || !userId || !row?.id,
                                    onClick: handleReleaseLookup
                                })
                            ]
                        }),
                        releaseLookupError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-westburyRed tw-text-xs tw-mt-2",
                            children: releaseLookupError
                        }),
                        releaseLookupNotFound && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-mt-4 tw-space-y-4 tw-pt-4 tw-border-t tw-border-formInputBackground",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-orange-400 tw-text-sm",
                                    children: "Release not found in WMC database, please provide details."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-gap-4 tw-w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex-1 tw-min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "change-release-notfound-title",
                                                    className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                                                    children: "Release Title"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    id: "change-release-notfound-title",
                                                    type: "text",
                                                    value: newReleaseTitle,
                                                    onChange: (e)=>setNewReleaseTitle(e.target.value),
                                                    className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)(),
                                                    placeholder: "Enter release title"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex-1 tw-min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "change-release-notfound-year",
                                                            className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                                            children: "Year of Release"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                            children: "Optional"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    id: "change-release-notfound-year",
                                                    type: "text",
                                                    value: newReleaseYear,
                                                    onChange: (e)=>{
                                                        const v = e.target.value.replace(/\D/g, "").slice(0, 4);
                                                        setNewReleaseYear(v);
                                                        setNewReleaseYearError($88d049fe01006cd7$export$44c3be0a49ff5d2e(v));
                                                    },
                                                    className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                                        error: !!newReleaseYearError
                                                    }),
                                                    placeholder: "YYYY",
                                                    maxLength: 4
                                                }),
                                                newReleaseYearError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                                                    children: newReleaseYearError
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($88d049fe01006cd7$var$MultiValueAddField, {
                                    label: "Label (Multiple)",
                                    addLabel: "Add label",
                                    placeholder: "Enter label",
                                    inputId: "change-release-notfound-labels-input",
                                    values: newReleaseLabels,
                                    onRemove: (index)=>setNewReleaseLabels((prev)=>prev.filter((_, i)=>i !== index)),
                                    open: newLabelInputOpen,
                                    setOpen: setNewLabelInputOpen,
                                    value: newLabelInputValue,
                                    setValue: setNewLabelInputValue,
                                    commit: commitNewLabel
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($88d049fe01006cd7$var$MultiValueAddField, {
                                    label: "Catalogue Number (Multiple)",
                                    addLabel: "Add catalogue number",
                                    placeholder: "Enter catalogue number",
                                    inputId: "change-release-notfound-catno-input",
                                    values: newReleaseCatNumbers,
                                    onRemove: (index)=>setNewReleaseCatNumbers((prev)=>prev.filter((_, i)=>i !== index)),
                                    open: newCatNoInputOpen,
                                    setOpen: setNewCatNoInputOpen,
                                    value: newCatNoInputValue,
                                    setValue: setNewCatNoInputValue,
                                    commit: commitNewCatNo
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-gap-4 tw-w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex-1 tw-min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "change-release-notfound-format",
                                                            className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                                            children: "Format"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                            children: "Optional"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    id: "change-release-notfound-format",
                                                    value: newReleaseFormat,
                                                    onChange: (e)=>setNewReleaseFormat(e.target.value),
                                                    className: `${$88d049fe01006cd7$var$SELECT_BASE_CLASS} ${$88d049fe01006cd7$var$selectTextClass(!!newReleaseFormat)}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "",
                                                            children: "Select Format"
                                                        }),
                                                        availableFormats.map((format)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: format,
                                                                children: format
                                                            }, format))
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex-1 tw-min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "change-release-notfound-type",
                                                            className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                                            children: "Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                            children: "Optional"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    id: "change-release-notfound-type",
                                                    value: newReleaseType,
                                                    onChange: (e)=>setNewReleaseType(e.target.value),
                                                    className: `${$88d049fe01006cd7$var$SELECT_BASE_CLASS} ${$88d049fe01006cd7$var$selectTextClass(!!newReleaseType)}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "",
                                                            children: "Select Type"
                                                        }),
                                                        availableTypes.map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: type,
                                                                children: type
                                                            }, type))
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        releaseLookupSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-mt-4 tw-space-y-4 tw-pt-4 tw-border-t tw-border-formInputBackground",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-gap-4 tw-w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    className: "tw-block tw-text-textSeal tw-text-xs tw-font-medium tw-mb-1",
                                                    children: "Release Title"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: newReleaseTitle,
                                                    readOnly: true,
                                                    className: (0, $bb6d544802d60420$export$5205ba4e60b034b1)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    className: "tw-block tw-text-textSeal tw-text-xs tw-font-medium tw-mb-1",
                                                    children: "Year of Release"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: newReleaseYear,
                                                    readOnly: true,
                                                    className: (0, $bb6d544802d60420$export$5205ba4e60b034b1)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "tw-block tw-text-textSeal tw-text-xs tw-font-medium tw-mb-1",
                                            children: "Label (Multiple)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `${(0, $bb6d544802d60420$export$5205ba4e60b034b1)} tw-flex tw-flex-wrap tw-gap-1.5 tw-items-center`,
                                            children: newReleaseLabels.length > 0 ? newReleaseLabels.map((label, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "tw-inline-flex tw-rounded-xs tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-bg-formInputBackground",
                                                    children: label
                                                }, index)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-text-textSeal",
                                                children: "\u2014"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "tw-block tw-text-textSeal tw-text-xs tw-font-medium tw-mb-1",
                                            children: "Catalogue Number (Multiple)"
                                        }),
                                        newReleaseCatNumbers.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `${(0, $bb6d544802d60420$export$5205ba4e60b034b1)} tw-flex tw-flex-wrap tw-gap-1.5 tw-items-center`,
                                            children: newReleaseCatNumbers.length > 0 ? newReleaseCatNumbers.map((catNo, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "tw-inline-flex tw-rounded-xs tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-bg-formInputBackground",
                                                    children: catNo
                                                }, index)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-text-textSeal",
                                                children: "\u2014"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-gap-4 tw-w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    className: "tw-block tw-text-textSeal tw-text-xs tw-font-medium tw-mb-1",
                                                    children: "Format"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: newReleaseFormat,
                                                    readOnly: true,
                                                    className: (0, $bb6d544802d60420$export$5205ba4e60b034b1)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    className: "tw-block tw-text-textSeal tw-text-xs tw-font-medium tw-mb-1",
                                                    children: "Type"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: newReleaseType,
                                                    readOnly: true,
                                                    className: (0, $bb6d544802d60420$export$5205ba4e60b034b1)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "new-release-source-url",
                                    className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                                    children: "Source"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "new-release-source-url",
                                    type: "text",
                                    value: sourceUrl,
                                    onChange: (e)=>{
                                        setSourceUrl(e.target.value);
                                    },
                                    className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)(),
                                    placeholder: "Provide release source details"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-4 tw-w-full",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex-1 tw-min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "new-release-title",
                                            className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                                            children: "Release Title"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            id: "new-release-title",
                                            type: "text",
                                            value: newReleaseTitle,
                                            onChange: (e)=>setNewReleaseTitle(e.target.value),
                                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)(),
                                            placeholder: "Enter release title"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex-1 tw-min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "new-release-year",
                                                    className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                                    children: "Year of Release"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                    children: "Optional"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            id: "new-release-year",
                                            type: "text",
                                            value: newReleaseYear,
                                            onChange: (e)=>{
                                                const v = e.target.value.replace(/\D/g, "").slice(0, 4);
                                                setNewReleaseYear(v);
                                                setNewReleaseYearError($88d049fe01006cd7$export$44c3be0a49ff5d2e(v));
                                            },
                                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                                error: !!newReleaseYearError
                                            }),
                                            placeholder: "YYYY",
                                            maxLength: 4
                                        }),
                                        newReleaseYearError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                                            children: newReleaseYearError
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($88d049fe01006cd7$var$MultiValueAddField, {
                            label: "Label (Multiple)",
                            addLabel: "Add label",
                            placeholder: "Enter label",
                            inputId: "new-release-labels-input",
                            values: newReleaseLabels,
                            onRemove: (index)=>setNewReleaseLabels((prev)=>prev.filter((_, i)=>i !== index)),
                            open: newLabelInputOpen,
                            setOpen: setNewLabelInputOpen,
                            value: newLabelInputValue,
                            setValue: setNewLabelInputValue,
                            commit: commitNewLabel
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($88d049fe01006cd7$var$MultiValueAddField, {
                            label: "Catalogue Number (Multiple)",
                            addLabel: "Add catalogue number",
                            placeholder: "Enter catalogue number",
                            inputId: "new-release-catno-input",
                            values: newReleaseCatNumbers,
                            onRemove: (index)=>setNewReleaseCatNumbers((prev)=>prev.filter((_, i)=>i !== index)),
                            open: newCatNoInputOpen,
                            setOpen: setNewCatNoInputOpen,
                            value: newCatNoInputValue,
                            setValue: setNewCatNoInputValue,
                            commit: commitNewCatNo
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-4 tw-w-full",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex-1 tw-min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "new-release-format",
                                                    className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                                    children: "Format"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                    children: "Optional"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            id: "new-release-format",
                                            value: newReleaseFormat,
                                            onChange: (e)=>setNewReleaseFormat(e.target.value),
                                            className: `${$88d049fe01006cd7$var$SELECT_BASE_CLASS} ${$88d049fe01006cd7$var$selectTextClass(!!newReleaseFormat)}`,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Select Format"
                                                }),
                                                availableFormats.map((format)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: format,
                                                        children: format
                                                    }, format))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex-1 tw-min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "new-release-type",
                                                    className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                                    children: "Type"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                    children: "Optional"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            id: "new-release-type",
                                            value: newReleaseType,
                                            onChange: (e)=>setNewReleaseType(e.target.value),
                                            className: `${$88d049fe01006cd7$var$SELECT_BASE_CLASS} ${$88d049fe01006cd7$var$selectTextClass(!!newReleaseType)}`,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Select Type"
                                                }),
                                                availableTypes.map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: type,
                                                        children: type
                                                    }, type))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                releaseLookupNotLinked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-rounded-lg tw-border tw-border-orange-500/60 tw-bg-orange-500/10 tw-p-4",
                    role: "alert",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-orange-400 tw-text-sm tw-font-medium tw-mb-2",
                            children: "Confirm Release Linking"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-gray-300 tw-text-sm tw-mb-4",
                            children: bulkLookupIds ? "None of the selected recordings are currently linked to this release." : "This release is already linked to a different recording."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "tw-text-gray-300 tw-text-sm tw-mb-4",
                            children: [
                                "Please double-check that you are linking it to the correct",
                                bulkLookupIds ? " recordings " : " recording ",
                                "and not a different version."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            htmlFor: "change-release-not-linked-confirmed",
                            className: "tw-flex tw-items-center tw-gap-2 tw-cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "change-release-not-linked-confirmed",
                                    type: "checkbox",
                                    checked: releaseNotLinkedConfirmed,
                                    onChange: (e)=>setReleaseNotLinkedConfirmed(e.target.checked),
                                    className: "tw-mt-0.5 tw-rounded tw-border-formInputBackground tw-bg-formInputBackground tw-text-orange-500 focus:tw-ring-orange-500"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tw-text-sm tw-text-white",
                                    children: "I have read and understood this warning"
                                })
                            ]
                        })
                    ]
                }),
                bulkLookupIds && !!bulkLinkedCount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "tw-text-textDove tw-text-xs tw-mt-2 tw-mb-2",
                    children: [
                        bulkLinkedCount,
                        " of ",
                        bulkLookupIds.length,
                        " selected recording",
                        bulkLookupIds.length === 1 ? " is" : "s are",
                        " already linked to this release."
                    ]
                }),
                releaseSameAsCurrentError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "tw-text-westburyRed tw-text-xs tw-mt-2 tw-mb-2",
                    children: "This recording is already linked to this release"
                }),
                releaseChangeSubmitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "tw-text-westburyRed tw-text-xs tw-mt-2 tw-mb-2",
                    children: releaseChangeSubmitError
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `${(0, $bb6d544802d60420$export$d9bb8578fc3ff40f)} tw-mt-4 tw-pt-4 tw-border-t tw-border-formInputBackground`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: closeAndReset
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: releaseChangeSubmitLoading ? "Saving\u2026" : mode === "select" ? "Select release" : isCreateFlow ? "Create and Link Release" : "Change Linked Release",
                            disabled: releaseChangeSubmitLoading || releaseSameAsCurrentError || !!newReleaseYearError || (isCreateFlow ? !newReleaseTitle.trim() || releaseSource === "Other" && !sourceUrl.trim() : !releaseLookupSuccess || !lookupReleaseId || releaseLookupNotLinked && !releaseNotLinkedConfirmed),
                            onClick: handleSubmit
                        })
                    ]
                })
            ]
        })
    });
};
var $88d049fe01006cd7$export$2e2bcd8739ae039 = $88d049fe01006cd7$export$334ef0499792785f;




var $acw62 = parcelRequire("acw62");





const $b44378a47b84f9b0$export$6327d397dd9387a = ({ isOpen: isOpen, onClose: onClose, userId: userId, parentRecordingId: parentRecordingId, onAdd: onAdd })=>{
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [newArtistAlias, setNewArtistAlias] = (0, $acw62.useState)("");
    const [newArtistFeatured, setNewArtistFeatured] = (0, $acw62.useState)("fa");
    const [newArtistSource, setNewArtistSource] = (0, $acw62.useState)("discogs");
    const [newArtistSourceId, setNewArtistSourceId] = (0, $acw62.useState)("");
    const [newArtistIsGroup, setNewArtistIsGroup] = (0, $acw62.useState)(false);
    const [newArtistMembers, setNewArtistMembers] = (0, $acw62.useState)([]);
    const [newArtistExists, setNewArtistExists] = (0, $acw62.useState)(false);
    const [newArtistSourceLookupLoading, setNewArtistSourceLookupLoading] = (0, $acw62.useState)(false);
    const [newArtistSourceLookupError, setNewArtistSourceLookupError] = (0, $acw62.useState)(null);
    const reset = ()=>{
        setNewArtistAlias("");
        setNewArtistFeatured("fa");
        setNewArtistSource("discogs");
        setNewArtistSourceId("");
        setNewArtistIsGroup(false);
        setNewArtistMembers([]);
        setNewArtistExists(false);
        setNewArtistSourceLookupError(null);
    };
    // Auto-populate stage name and members from source ID lookup (Discogs / MB).
    (0, $acw62.useEffect)(()=>{
        if (!isOpen || !newArtistSourceId.trim() || !userId || !parentRecordingId) {
            setNewArtistSourceLookupError(null);
            return;
        }
        setNewArtistSourceLookupLoading(true);
        setNewArtistSourceLookupError(null);
        const timer = setTimeout(async ()=>{
            try {
                const sourceParam = newArtistSource === "MB" ? (0, $cdef5ca7170fc2e8$export$f9fe1534b58e5b47).Musicbrainz : (0, $cdef5ca7170fc2e8$export$f9fe1534b58e5b47).Discogs;
                const data = await api.lookupSourceArtistLookupSourceArtistResponse({
                    userId: userId,
                    parentRecordingId: parentRecordingId,
                    source: sourceParam,
                    sourceId: newArtistSourceId.trim()
                });
                if (data.stageName) {
                    setNewArtistAlias(data.stageName);
                    setNewArtistIsGroup(data.isGroup ?? false);
                    setNewArtistExists(data._exists ?? false);
                    setNewArtistMembers((data.members ?? []).map((m)=>({
                            id: m._exists && m.internalId ? m.internalId : m.id,
                            stageName: m.stageName,
                            exists: m._exists ?? false
                        })));
                    setNewArtistSourceLookupError(null);
                } else setNewArtistSourceLookupError("Artist not found for this ID");
            } catch  {
                setNewArtistSourceLookupError("Lookup failed \u2014 check the Source ID");
            } finally{
                setNewArtistSourceLookupLoading(false);
            }
        }, 500);
        return ()=>clearTimeout(timer);
    }, [
        newArtistSourceId,
        newArtistSource,
        isOpen,
        userId,
        parentRecordingId,
        api
    ]);
    const closeAndReset = ()=>{
        reset();
        onClose();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: closeAndReset,
        title: "Create new artist",
        modalClasses: "tw-max-w-lg tw-w-full tw-mx-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-4 tw-space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-grid tw-grid-cols-2 tw-gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "create-artist-source",
                                    className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                                    children: "Source"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    id: "create-artist-source",
                                    value: newArtistSource,
                                    onChange: (e)=>{
                                        setNewArtistSource(e.target.value);
                                        setNewArtistAlias("");
                                        setNewArtistSourceId("");
                                        setNewArtistSourceLookupError(null);
                                    },
                                    className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                        kind: "select",
                                        hasValue: !!newArtistSource
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "discogs",
                                            children: "Discogs"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "MB",
                                            children: "MusicBrainz"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "create-artist-source-id",
                                    className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                                    children: "Source ID"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "create-artist-source-id",
                                    type: "text",
                                    value: newArtistSourceId,
                                    onChange: (e)=>{
                                        setNewArtistSourceId(e.target.value);
                                        if (!e.target.value.trim()) {
                                            setNewArtistAlias("");
                                            setNewArtistSourceLookupError(null);
                                        }
                                    },
                                    placeholder: newArtistSource === "discogs" ? "e.g. 12345" : "Enter source ID",
                                    className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)()
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "create-artist-alias",
                            className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                            children: "Stage Name"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-relative",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "create-artist-alias",
                                    type: "text",
                                    value: newArtistAlias,
                                    onChange: (e)=>setNewArtistAlias(e.target.value),
                                    placeholder: newArtistSourceLookupLoading ? "Looking up artist..." : "Enter stage name",
                                    className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                        error: !!newArtistSourceLookupError || newArtistExists
                                    })
                                }),
                                newArtistSourceLookupLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-textSeal tw-text-xs",
                                    children: "Loading..."
                                })
                            ]
                        }),
                        newArtistSourceLookupError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                            children: newArtistSourceLookupError
                        }),
                        newArtistExists && !newArtistSourceLookupError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                            children: "Artist already exists in WMC database. Use Artist Search to add them"
                        }),
                        newArtistSource !== "discogs" && newArtistSourceId.trim() && !newArtistAlias && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: `${(0, $bb6d544802d60420$export$7a55dcc9227b4343)} tw-mt-1`,
                            children: "Auto-lookup is only available for Discogs. Enter the stage name manually."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                            children: "Featured Status"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb6d544802d60420$export$32cde37ade98aa4f), {
                            leftLabel: "Featured",
                            rightLabel: "Other Featured",
                            isLeftSelected: newArtistFeatured === "fa",
                            onSelectLeft: ()=>setNewArtistFeatured("fa"),
                            onSelectRight: ()=>setNewArtistFeatured("ofa")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `${(0, $bb6d544802d60420$export$d9bb8578fc3ff40f)} tw-border-t tw-border-formInputBackground`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: closeAndReset
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: newArtistSourceLookupLoading ? "Looking up..." : "Add",
                            disabled: !newArtistSourceId.trim() || !newArtistAlias.trim() || newArtistSourceLookupLoading || newArtistExists,
                            onClick: ()=>{
                                if (newArtistAlias.trim() && newArtistSourceId.trim()) {
                                    onAdd({
                                        name: newArtistAlias.trim(),
                                        isFeatured: newArtistFeatured === "fa",
                                        featuredStatus: newArtistFeatured,
                                        members: newArtistMembers.length > 0 ? newArtistMembers : undefined,
                                        pendingCreate: {
                                            source: newArtistSource,
                                            sourceId: newArtistSourceId.trim()
                                        }
                                    });
                                    reset();
                                }
                            }
                        })
                    ]
                })
            ]
        })
    });
};
var $b44378a47b84f9b0$export$2e2bcd8739ae039 = $b44378a47b84f9b0$export$6327d397dd9387a;




var $acw62 = parcelRequire("acw62");





function $814d90124c52a773$export$3615c6b82d75a516(userId, parentRecordingId) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [query, setQuery] = (0, $acw62.useState)("");
    const [results, setResults] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!userId || !parentRecordingId) return;
        const q = query.trim();
        if (!q) {
            setResults([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        const timer = setTimeout(async ()=>{
            try {
                const result = await api.lookupArtistsLookupArtistsResponse({
                    userId: userId,
                    parentRecordingId: parentRecordingId,
                    searchTerm: q
                });
                setResults((result.artists ?? []).map((a)=>({
                        id: a.id ?? "",
                        stageName: a.stageName ?? "",
                        members: (a.members ?? []).map((m)=>({
                                id: m.id ?? "",
                                stageName: m.stageName ?? ""
                            }))
                    })));
            } catch  {
                setResults([]);
            } finally{
                setLoading(false);
            }
        }, 300);
        return ()=>clearTimeout(timer);
    }, [
        query,
        userId,
        parentRecordingId,
        api
    ]);
    return {
        query: query,
        setQuery: setQuery,
        results: results,
        loading: loading
    };
}
const $814d90124c52a773$export$dd145f4a2a6bebc2 = ({ value: value, onChange: onChange })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb6d544802d60420$export$32cde37ade98aa4f), {
        leftLabel: "Featured",
        rightLabel: "Other Featured",
        isLeftSelected: value === "fa",
        onSelectLeft: ()=>onChange("fa"),
        onSelectRight: ()=>onChange("ofa")
    });
const $814d90124c52a773$export$d95759e348d01a1a = ({ userId: userId, parentRecordingId: parentRecordingId, existing: existing, onSelect: onSelect })=>{
    const { query: query, setQuery: setQuery, results: results, loading: loading } = $814d90124c52a773$export$3615c6b82d75a516(userId, parentRecordingId);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const notAdded = results.filter((a)=>!existing.some((e)=>e.name === a.stageName || e.id === a.id));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                value: query,
                onChange: (e)=>{
                    setQuery(e.target.value);
                    setOpen(true);
                },
                onFocus: ()=>setOpen(true),
                onBlur: ()=>setTimeout(()=>setOpen(false), 200),
                placeholder: "Search or select artist\u2026",
                className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)()
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $bb6d544802d60420$export$ae270fdcc1622e9f),
                children: !query.trim() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $bb6d544802d60420$export$785837da81429671),
                    children: "Start typing to search for artists\u2026"
                }) : loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $bb6d544802d60420$export$785837da81429671),
                    children: "Searching..."
                }) : notAdded.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $bb6d544802d60420$export$785837da81429671),
                    children: results.length === 0 ? "No matching artists" : "All matching artists already added"
                }) : notAdded.map((artist)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        className: (0, $bb6d544802d60420$export$4f83e5d0e324b6c5),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                            onSelect({
                                name: artist.stageName,
                                id: artist.id || undefined,
                                members: artist.members.length > 0 ? artist.members : undefined
                            });
                            setQuery("");
                            setOpen(false);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: artist.stageName
                            }),
                            artist.id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: (0, $bb6d544802d60420$export$ed929ff84da6e8f5),
                                children: artist.id
                            })
                        ]
                    }, artist.id || artist.stageName))
            })
        ]
    });
};
const $814d90124c52a773$export$3cbdf2bb01a18fa5 = ({ pending: pending, onCancel: onCancel, onAdd: onAdd })=>{
    const [featured, setFeatured] = (0, $acw62.useState)("fa");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: pending !== null,
        onClose: ()=>{
            setFeatured("fa");
            onCancel();
        },
        title: "Add artist",
        modalClasses: "tw-max-w-md tw-w-full tw-mx-4",
        children: pending !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-4 tw-space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-block tw-text-textSeal tw-text-xs tw-font-medium tw-mb-1",
                            children: "Artist"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-white tw-text-sm",
                            children: pending.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                            children: "Featured Status"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($814d90124c52a773$export$dd145f4a2a6bebc2, {
                            value: featured,
                            onChange: setFeatured
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: ()=>{
                                setFeatured("fa");
                                onCancel();
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Add",
                            onClick: ()=>{
                                onAdd({
                                    name: pending.name,
                                    id: pending.id,
                                    members: pending.members && pending.members.length > 0 ? pending.members : undefined,
                                    isFeatured: featured === "fa",
                                    featuredStatus: featured
                                });
                                setFeatured("fa");
                            }
                        })
                    ]
                })
            ]
        })
    });
};
const $814d90124c52a773$export$8ccaf6184c7ddac2 = ({ artistName: artistName, onCancel: onCancel, onDemote: onDemote, onRemove: onRemove })=>{
    const [confirm, setConfirm] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: artistName !== null,
        onClose: ()=>{
            setConfirm(null);
            onCancel();
        },
        title: confirm === "demote" ? "Confirm Demote" : confirm === "remove" ? "Confirm Remove" : "Artist Action",
        modalClasses: "tw-max-w-lg tw-w-full tw-mx-4",
        children: artistName !== null && (confirm === "demote" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-4 tw-space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "tw-text-white tw-text-sm",
                    children: [
                        "Are you sure you want to demote ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: artistName
                        }),
                        " to Non-Featured?"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: ()=>setConfirm(null)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Demote",
                            onClick: ()=>{
                                setConfirm(null);
                                onDemote();
                            }
                        })
                    ]
                })
            ]
        }) : confirm === "remove" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-4 tw-space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "tw-text-white tw-text-sm",
                    children: [
                        "Are you sure you want to remove ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: artistName
                        }),
                        " from this recording?"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: ()=>setConfirm(null)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Remove",
                            onClick: ()=>{
                                setConfirm(null);
                                onRemove();
                            }
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-4 tw-space-y-3",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "tw-text-white tw-text-sm",
                    children: [
                        "What would you like to do with ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: artistName
                        }),
                        "?"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-row tw-gap-2 tw-justify-end tw-pt-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Demote to Non-Featured",
                            extraClasses: "tw-flex-1 !tw-whitespace-normal !tw-h-auto tw-min-h-[32px] tw-py-1.5 tw-text-center",
                            onClick: ()=>setConfirm("demote")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Remove from Recording",
                            extraClasses: "tw-flex-1 !tw-whitespace-normal !tw-h-auto tw-min-h-[32px] tw-py-1.5 tw-text-center",
                            onClick: ()=>setConfirm("remove")
                        })
                    ]
                })
            ]
        }))
    });
};
const $814d90124c52a773$export$cdddb7d8a9f5bc06 = ({ name: name, onUndo: onUndo })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-surfaceBlack80 tw-border tw-border-dashed tw-border-textSeal tw-px-3 tw-py-1 tw-text-xs tw-text-textDove",
        children: [
            name,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "tw-text-textSeal tw-italic",
                children: "demoted"
            }),
            onUndo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                "aria-label": `Undo demote ${name}`,
                className: "tw-text-textDove hover:tw-text-white",
                onClick: onUndo,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "tw-w-3 tw-h-3"
                })
            })
        ]
    });



/**
 * Bulk-edit data model — the rows the builder accumulates, and the rules for
 * what makes a set of them coherent.
 *
 * Bulk edit is not mass edit. Mass edit holds a *per-recording* desired value
 * and diffs it against that recording's current state (see `massEditModel.ts`);
 * bulk edit holds **one plan** — a list of field/operation/value rows — that is
 * applied verbatim to every selected recording. So there is nothing to diff
 * here, but there *is* something to check: rows can contradict each other, and
 * the contract's buckets can only hold one coherent instruction each.
 *
 * Kept free of React/JSX so both the modal (`Components/BulkEditModal.tsx`) and
 * the apply layer (`bulkEditBatch.ts`) can import it without a cycle, and so
 * the rules stay unit-testable without a DOM.
 */ const $05e74afd2b6f1b76$export$539790ee53a8f807 = {
    "Recording Title": [
        "Edit"
    ],
    // "Demote" moves matching artists to non-featured (mirrors the edit form's
    // demote-vs-remove); "Delete" removes them outright.
    Artist: [
        "Add",
        "Demote",
        "Delete",
        "Replace"
    ],
    Live: [
        "Edit"
    ],
    // For Artist & Contribution, "Replace" means replace all currently set with
    // the provided values. "Edit" changes the detail (data quality, evidence,
    // alias) of contributions already on the recordings without adding any.
    Contribution: [
        "Add",
        "Edit",
        "Delete",
        "Replace"
    ],
    "Linked Release": [
        "Change link to Release"
    ]
};
const $05e74afd2b6f1b76$export$e6909ad44e61103d = Object.keys($05e74afd2b6f1b76$export$539790ee53a8f807);
function $05e74afd2b6f1b76$export$a7f4fa59930e5088(field, operation) {
    if (field === "Recording Title") return "title";
    if (field === "Live") return "live";
    if (field === "Linked Release") return "release";
    if (field === "Artist") {
        if (operation === "Delete") return "artistDelete";
        if (operation === "Demote") return "artistDemote";
        return "artist";
    }
    // Contribution: Delete → checklist; Add / Edit / Replace → list builder.
    if (operation === "Delete") return "contributionDelete";
    return "contributions";
}
function $05e74afd2b6f1b76$export$b7616c5a26b2b17b(row) {
    if (!row.field || !row.operation || !row.value) return false;
    switch(row.value.kind){
        case "title":
            return row.value.title.trim().length > 0;
        case "live":
            // A live descriptor is required (mirrors the edit form / mass edit).
            return row.value.descriptor.trim().length > 0;
        case "contributions":
            return row.value.entries.length > 0;
        case "contributionDelete":
            return row.value.roles.length > 0;
        case "artist":
            return row.value.entries.length > 0;
        case "artistDelete":
            return row.value.artists.length > 0;
        case "artistDemote":
            return row.value.artists.length > 0;
        case "release":
            return row.value.label.trim().length > 0 && !!row.value.selection;
        default:
            return false;
    }
}
/* -------------------------------------------------------------------------- */ /* Coherence rules                                                             */ /* -------------------------------------------------------------------------- */ /**
 * Per field, the operations that *define what the value becomes*.
 *
 * At most one of these may appear in a plan, because they are competing answers
 * to the same question. "Add these contributions" and "Replace all
 * contributions with these" both write the single `contributions` bucket, which
 * the backend applies in array order — so whichever the user meant, one of them
 * silently wins. The operations deliberately left out (Delete, Demote) only
 * take things away, so one of those can ride alongside a set-defining row
 * without ambiguity: that is the "one, or two if deleting" shape.
 */ const $05e74afd2b6f1b76$var$SET_OPERATIONS = {
    "Recording Title": [
        "Edit"
    ],
    Artist: [
        "Add",
        "Replace"
    ],
    Live: [
        "Edit"
    ],
    Contribution: [
        "Add",
        "Edit",
        "Replace"
    ],
    "Linked Release": [
        "Change link to Release"
    ]
};
/**
 * Per field, the operations that must stand alone.
 *
 * "Replace" does not contribute to the value — it *is* the value: the bucket it
 * sends supersedes whatever the recordings currently hold. Pairing it with a
 * Delete row is therefore meaningless (the deleted entries are gone either way,
 * and if the delete lands after the replace it eats part of the replacement),
 * and pairing it with Add or Edit is a straight contradiction. Add and Edit
 * leave the untouched entries alone, which is why those two *can* take a Delete
 * alongside them.
 */ const $05e74afd2b6f1b76$var$EXCLUSIVE_OPERATIONS = {
    Artist: [
        "Replace"
    ],
    Contribution: [
        "Replace"
    ]
};
/** Wording for fields with a single operation, where "one row per operation"
 *  and "one row per field" are the same rule and the generic phrasing reads
 *  like boilerplate. */ const $05e74afd2b6f1b76$var$SINGLE_ROW_MESSAGE = {
    "Recording Title": "Only one recording title can be applied \u2014 remove the extra title row.",
    Live: "Only one live descriptor can be applied \u2014 remove the extra live row.",
    "Linked Release": "Only one release can be linked per bulk edit \u2014 remove the extra release row."
};
/** Wording for fields where several operations compete to define the value. */ const $05e74afd2b6f1b76$var$COMPETING_OPS_MESSAGE = {
    Contribution: "Contributions can be added, edited or replaced \u2014 but only one of those per bulk edit. Add and Edit can each be combined with a Delete row.",
    Artist: "Artists can be added or replaced \u2014 but only one of those per bulk edit. Add can be combined with a Delete or Demote row."
};
/** Wording for the operations that must stand alone. */ const $05e74afd2b6f1b76$var$EXCLUSIVE_MESSAGE = {
    Contribution: "Replace rewrites the whole contribution set, so it cannot be combined with any other Contribution row.",
    Artist: "Replace rewrites the whole artist list, so it cannot be combined with any other Artist row."
};
function $05e74afd2b6f1b76$export$702810c20be9018a(field, rows, exceptRowId) {
    const claimed = rows.filter((r)=>r.id !== exceptRowId && r.field === field && r.operation).map((r)=>r.operation);
    const exclusiveOps = $05e74afd2b6f1b76$var$EXCLUSIVE_OPERATIONS[field] ?? [];
    // A stand-alone operation is already there: nothing else may join it.
    if (claimed.some((op)=>exclusiveOps.includes(op))) return [];
    const setOps = $05e74afd2b6f1b76$var$SET_OPERATIONS[field];
    const setOpClaimed = claimed.some((op)=>setOps.includes(op));
    return $05e74afd2b6f1b76$export$539790ee53a8f807[field].filter((op)=>!claimed.includes(op) && !(setOpClaimed && setOps.includes(op)) && // …and it may not join anything either.
        !(claimed.length > 0 && exclusiveOps.includes(op)));
}
function $05e74afd2b6f1b76$export$38cf523f1b17bea5(field, rows, exceptRowId) {
    return $05e74afd2b6f1b76$export$702810c20be9018a(field, rows, exceptRowId).length === 0;
}
function $05e74afd2b6f1b76$export$78a1c9a6d68233b6(rows) {
    const ready = rows.filter($05e74afd2b6f1b76$export$b7616c5a26b2b17b);
    const problems = [];
    for (const field of $05e74afd2b6f1b76$export$e6909ad44e61103d){
        const ops = ready.filter((r)=>r.field === field).map((r)=>r.operation);
        if (ops.length < 2) continue;
        // One row per operation. Two "Add contribution" rows are one row's worth of
        // values split in two, and only one of them would reach the bucket.
        const seen = new Set();
        const duplicated = new Set();
        ops.forEach((op)=>seen.has(op) ? duplicated.add(op) : seen.add(op));
        duplicated.forEach((op)=>problems.push($05e74afd2b6f1b76$var$SINGLE_ROW_MESSAGE[field] ?? `Only one \u{201C}${op}\u{201D} row is allowed for ${field} \u{2014} put all of its values in a single row.`));
        // A stand-alone operation rules out everything else, and says so in its own
        // words — reporting it *and* the competing-operations problem below would
        // be two messages about one mistake.
        const exclusive = Array.from(seen).filter((op)=>($05e74afd2b6f1b76$var$EXCLUSIVE_OPERATIONS[field] ?? []).includes(op));
        if (exclusive.length > 0 && seen.size > 1) {
            problems.push($05e74afd2b6f1b76$var$EXCLUSIVE_MESSAGE[field] ?? `\u{201C}${exclusive[0]}\u{201D} rewrites ${field} entirely, so it cannot be combined with another ${field} row.`);
            continue;
        }
        // …and only one of the operations that define what the value becomes.
        const competing = Array.from(seen).filter((op)=>$05e74afd2b6f1b76$var$SET_OPERATIONS[field].includes(op));
        if (competing.length > 1) problems.push($05e74afd2b6f1b76$var$COMPETING_OPS_MESSAGE[field] ?? `${field} can take only one of ${competing.join(", ")} per bulk edit \u{2014} each defines what the value becomes.`);
    }
    // A role both written and deleted in one plan, or the same artist deleted and
    // demoted — the buckets are applied in array order, so one would win silently.
    const lower = (s)=>s.trim().toLowerCase();
    const writtenRoles = new Set(ready.filter((r)=>r.value?.kind === "contributions").flatMap((r)=>r.value.entries.map((e)=>lower(e.contribution))));
    const deletedRoles = ready.filter((r)=>r.value?.kind === "contributionDelete").flatMap((r)=>r.value.roles.map(lower));
    const roleClash = deletedRoles.filter((role)=>writtenRoles.has(role));
    if (roleClash.length > 0) problems.push(`Contribution${roleClash.length === 1 ? "" : "s"} both set and deleted: ${Array.from(new Set(roleClash)).join(", ")}.`);
    const demoted = ready.filter((r)=>r.value?.kind === "artistDemote").flatMap((r)=>r.value.artists.map(lower));
    const deletedArtists = ready.filter((r)=>r.value?.kind === "artistDelete").flatMap((r)=>r.value.artists.map(lower));
    const artistClash = deletedArtists.filter((a)=>demoted.includes(a));
    if (artistClash.length > 0) problems.push(`Artist${artistClash.length === 1 ? "" : "s"} both demoted and deleted: ${Array.from(new Set(artistClash)).join(", ")}.`);
    return problems;
}


/**
 * Bulk-edit apply — turns the builder's rows plus the grid selection into the
 * one `bulk_edit` object the backend accepts (BE↔DS bulk-editing contract
 * v0.5.1) and dispatches it.
 *
 * Everything here is built out of the **generated** admin models, so the wire
 * casing is the generator's problem rather than this file's: `release_link` goes
 * out snake_case while `change_artists` keeps `stageName` / `featuredStatus`,
 * because each bucket follows the single-recording operation it reuses, and the
 * per-model `…ToJSON` mappers already encode that.
 *
 * The shape of the problem is different from mass edit. Mass edit holds a
 * per-recording desired value, diffs it, and fans out across three batch
 * endpoints — so its unit of failure is the *recording*. Bulk edit sends one
 * plan for the whole selection, DS runs one set-based query per action, and the
 * unit of failure is therefore the **action**: a failed `contributions` action
 * means the contributions didn't land, but says nothing about which recordings
 * (contract §5). That is a property of the wire protocol, not a gap here — the
 * result surface reports per action for exactly that reason.
 *
 * Two more consequences worth knowing before reading the code:
 *
 * - **One request, not one per recording.** Rows of the same field merge into a
 *   single bucket. Rows that contradict each other can't be expressed at all,
 *   so `bulkEditConflicts` (in `bulkEditModel.ts`) rejects them before we build.
 * - **`edge_id` is per recording.** A `release_link` needs each recording's
 *   existing recording→release edge, which the plan itself can't carry — hence
 *   the bulk release lookup below.
 */ 

/**
 * Mass-edit batch apply — turns the grid's pending `MassEdits` into the batch
 * request envelopes the backend accepts (BE↔DS service contract §3.1) and
 * dispatches them.
 *
 * The mass-edit surface stores the *final desired value* per field, while the
 * recording-management API is op-based (add/delete/edit). This module does the
 * diff against each row's current value — mirroring the Recording Edit Form's
 * save logic (RecordingEditForm.handleSaveRecordingDetails) so the two surfaces
 * produce identical payloads — and groups the result into the three batch
 * endpoints:
 *
 *   • correct recording data      (contract 4.1.1) — title, duration, live,
 *                                                    version, isrcs
 *   • change associated artists   (contract 4.1.3) — artist add/remove/demote
 *   • manage contributions        (contract 4.2.1) — contribution add/edit/remove
 *
 * Each endpoint takes a *list* of envelopes, one per recording, so a mass edit
 * spanning N recordings is at most three HTTP calls rather than 3N. The
 * response is an aggregate `{success, results[]}` where `results` carries one
 * per-recording outcome, letting us report exactly which recordings failed.
 *
 * Newly created artists are the one exception: `create artist and link`
 * (contract 4.4.2) has no batch form, so those are fanned out per recording
 * before the artists batch, exactly as the edit form does.
 */ 
/**
 * Mass-edit data model — the shapes the grid accumulates while the user edits,
 * and the projections from a grid `Row` into those shapes.
 *
 * Kept free of React/JSX imports (like ../../utils/recordingValidators) so both
 * the modal components and the save layer (massEditBatch.ts) can import it, and
 * so the diff/payload logic stays unit-testable without a DOM.
 */ function $31ef1c70c0117c31$export$d22120ed4d368425(row) {
    if (row.mainArtistsRaw && row.mainArtistsRaw.length > 0) return row.mainArtistsRaw.map((item)=>{
        if (typeof item === "string") return {
            name: item,
            isFeatured: false,
            featuredStatus: "nf"
        };
        const obj = item;
        return {
            name: obj.stageName,
            id: obj.id,
            isFeatured: false,
            featuredStatus: "nf",
            type: obj.type
        };
    });
    if (row.artist) return row.artist.split(",").map((name)=>({
            name: name.trim(),
            isFeatured: false,
            featuredStatus: "nf"
        })).filter((a)=>a.name);
    return [];
}



/**
 * Shared recording-field validators — the single source of truth for the
 * business rules enforced when editing recording-level fields.
 *
 * The Recording Edit Form is the gold standard; these primitives were extracted
 * from it so that the mass-edit and bulk-edit surfaces validate identically and
 * the rules cannot drift per surface. Keep this module pure (no React / JSX
 * imports) so every surface can import it freely.
 *
 * Note: `validateReleaseYear` lives in ./Components/ChangeReleaseModal and
 * `validateEvidenceUrl` in ./Components/ContributionDetailModal — both are
 * already exported/shared from their component homes, so they are intentionally
 * not duplicated here.
 */ // ── Live descriptor ──────────────────────────────────────────────────────────
/** Normalises a `live` value to a trimmed string. The backend field is
 *  migrating from boolean to string, so any non-string (legacy boolean) is
 *  treated as "no live descriptor" rather than crashing on `.trim()`. */ const $e353c670efa3bb12$export$6a8f182e25b88c10 = (v)=>typeof v === "string" ? v.trim() : "";
const $e353c670efa3bb12$export$39cfc13e9691617c = /^[A-Z]{2}[A-Z0-9]{3}\d{2}\d{5}$/;
const $e353c670efa3bb12$export$5c2a80a44f9ccb50 = (value)=>$e353c670efa3bb12$export$39cfc13e9691617c.test(value.toUpperCase().replace(/[-\s]/g, ""));
const $e353c670efa3bb12$export$909be10aa76219bc = "Invalid ISRC format. Expected: 2 letter country code, 3 char registrant code, 2 digit year, 5 digit designation (e.g. GBAAA0912345)";
const $e353c670efa3bb12$export$e6eb299aec6b2f42 = /^\d{2}:\d{2}:\d{2}$/;
const $e353c670efa3bb12$export$c0eaa116058edb10 = "Format: HH:MM:SS (e.g. 00:03:45)";
/** Minutes and seconds are clock parts — 60 of either rolls into the next unit,
 *  so anything above 59 is a typo (03:64:12 should be 04:04:12). Hours are
 *  deliberately unbounded; a long-form recording can exceed 24h. */ const $e353c670efa3bb12$var$isDurationInRange = (trimmed)=>{
    const [, minutes, seconds] = trimmed.split(":").map(Number);
    return minutes <= 59 && seconds <= 59;
};
const $e353c670efa3bb12$export$e28555c1bee34381 = (value)=>{
    const trimmed = value.trim();
    if (!trimmed) return true;
    return $e353c670efa3bb12$export$e6eb299aec6b2f42.test(trimmed) && $e353c670efa3bb12$var$isDurationInRange(trimmed);
};
const $e353c670efa3bb12$export$9c76e80356ef871a = (value)=>{
    const trimmed = value.trim();
    if (!trimmed) return null;
    // Well-formed: the only thing left to check is the minute/second range.
    if ($e353c670efa3bb12$export$e6eb299aec6b2f42.test(trimmed)) {
        if ($e353c670efa3bb12$var$isDurationInRange(trimmed)) return null;
        const [, minutes, seconds] = trimmed.split(":").map(Number);
        const over = minutes > 59 && seconds > 59 ? "Minutes and seconds" : minutes > 59 ? "Minutes" : "Seconds";
        return `${over} must be 00\u{2013}59 \u{2014} 03:64:12 means 4 minutes past the hour, so write it as 04:04:12.`;
    }
    if (/[^\d:]/.test(trimmed)) return "Use digits and colons only \u2014 no letters, spaces or other characters.";
    const parts = trimmed.split(":");
    if (parts.length < 3) return "Needs all three parts \u2014 hours, minutes and seconds, e.g. 00:03:45 for 3 minutes 45 seconds.";
    if (parts.length > 3) return "Too many parts \u2014 use hours, minutes and seconds only, e.g. 00:03:45.";
    if (parts.some((p)=>p.length !== 2)) return "Each part needs exactly two digits \u2014 write 3:45 as 00:03:45.";
    // Three two-digit parts of digits-and-colons always match DURATION_REGEX, so
    // this is unreachable in practice — kept as a safety net for the format hint.
    return $e353c670efa3bb12$export$c0eaa116058edb10;
};
const $e353c670efa3bb12$export$db9dfd335ba362ce = (value)=>value.trim().length > 0;
const $e353c670efa3bb12$export$a58c1d5525adff3f = (currentValue, wasManuallyEdited)=>{
    const isSet = !!(currentValue && currentValue.toString().trim());
    return !isSet || wasManuallyEdited;
};
function $e353c670efa3bb12$export$e3510695f47e62c5(values) {
    const seen = new Set();
    for (const v of values){
        const key = v.toLowerCase();
        if (seen.has(key)) return v;
        seen.add(key);
    }
    return null;
}


/* -------------------------------------------------------------------------- */ /* Payload builders                                                            */ /* -------------------------------------------------------------------------- */ /** Identity used to match an edited artist against the recording's current
 *  artists. Ids are authoritative; names are the fallback for legacy rows whose
 *  `mainArtists` are plain strings. */ const $1ca226bb7c080c09$var$artistKey = (a)=>a.id || a.name;
function $1ca226bb7c080c09$export$40f16c614c47cc0(row, edits, reassignments) {
    const out = [];
    if (edits.title !== undefined) out.push({
        op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Edit,
        field: "recordingTitle",
        value: edits.title
    });
    if (edits.duration !== undefined) out.push({
        op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Edit,
        field: "duration",
        value: edits.duration
    });
    if (edits.live !== undefined) // Only the `live` descriptor string is persisted — the boolean `is_live`
    // flag is derived downstream from its presence (edit-form parity).
    out.push({
        op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Edit,
        field: "live",
        value: (0, $e353c670efa3bb12$export$6a8f182e25b88c10)(edits.live)
    });
    if (edits.version !== undefined) {
        // recordingVersion is list[str]: emit a delete per removed value and an add
        // per new one rather than a whole-list edit.
        const original = row.versionsArray ?? [];
        original.filter((v)=>!edits.version.includes(v)).forEach((v)=>out.push({
                op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Delete,
                field: "recordingVersion",
                value: v
            }));
        edits.version.filter((v)=>!original.includes(v)).forEach((v)=>out.push({
                op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Add,
                field: "recordingVersion",
                value: v
            }));
    }
    if (edits.isrcs !== undefined) {
        const original = row.isrcsArray ?? [];
        edits.isrcs.filter((v)=>!original.includes(v)).forEach((v)=>{
            // An ISRC taken from another recording carries the source recordings so
            // the backend can detach it there in the same operation.
            const dupSources = reassignments?.[v];
            out.push({
                op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Add,
                field: "isrcs",
                value: v,
                dupIsrcs: dupSources && dupSources.length > 0 ? dupSources.map((d)=>({
                        dupRecordingId: d.recordingId,
                        dupDocumentId: d.documentId
                    })) : undefined
            });
        });
        original.filter((v)=>!edits.isrcs.includes(v)).forEach((v)=>out.push({
                op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Delete,
                field: "isrcs",
                value: v
            }));
    }
    return out;
}
function $1ca226bb7c080c09$export$5e8db2537160c2b2(row, edits) {
    if (edits.artist === undefined) return [];
    const original = (0, $31ef1c70c0117c31$export$d22120ed4d368425)(row);
    const originalKeys = original.map($1ca226bb7c080c09$var$artistKey);
    const current = edits.artist.filter((a)=>a.name.trim());
    const currentKeys = current.map($1ca226bb7c080c09$var$artistKey);
    const out = [];
    // Added — new to the recording and already existing in the graph.
    current.filter((a)=>!originalKeys.includes($1ca226bb7c080c09$var$artistKey(a)) && !a.pendingCreate).forEach((a)=>{
        out.push({
            artistId: a.id || a.name,
            op: (0, $19c922af6379aa7e$export$5b356edc00d5e9f9).Add,
            // The contract only accepts fa|ofa on add; 'nf' is the editor's
            // non-featured marker and maps onto "other featured artist".
            featuredStatus: a.featuredStatus === "fa" ? (0, $19c922af6379aa7e$export$11aacb388fbad6d6).Fa : (0, $19c922af6379aa7e$export$11aacb388fbad6d6).Ofa,
            stageName: a.name,
            members: a.members ?? []
        });
    });
    // Demoted — still linked, but downgraded to non-featured. Sent as delete+nfa.
    current.filter((a)=>a.demoted && originalKeys.includes($1ca226bb7c080c09$var$artistKey(a))).forEach((a)=>{
        out.push({
            artistId: a.id || a.name,
            op: (0, $19c922af6379aa7e$export$5b356edc00d5e9f9).Delete,
            featuredStatus: (0, $19c922af6379aa7e$export$11aacb388fbad6d6).Nfa,
            type: a.type
        });
    });
    // Removed — dropped from the recording entirely. `featuredStatus: null`
    // distinguishes a full removal from a demotion.
    original.filter((a)=>!currentKeys.includes($1ca226bb7c080c09$var$artistKey(a))).forEach((a)=>{
        out.push({
            artistId: a.id || a.name,
            op: (0, $19c922af6379aa7e$export$5b356edc00d5e9f9).Delete,
            featuredStatus: null,
            type: a.type
        });
    });
    return out;
}
function $1ca226bb7c080c09$export$c650e1b205df766f(row, edits) {
    if (edits.artist === undefined) return [];
    const originalNames = (0, $31ef1c70c0117c31$export$d22120ed4d368425)(row).map((a)=>a.name);
    return edits.artist.filter((a)=>!!a.pendingCreate && !originalNames.includes(a.name)).map((a)=>({
            op: (0, $b36d2387fff73506$export$bf856448a04f07d1).Add,
            stageName: a.name,
            source: a.pendingCreate.source,
            sourceId: a.pendingCreate.sourceId,
            featuredStatus: a.featuredStatus === "fa" ? (0, $b36d2387fff73506$export$6b46a49d4996d67c).Fa : (0, $b36d2387fff73506$export$6b46a49d4996d67c).Ofa,
            members: a.members && a.members.length > 0 ? a.members.map((m)=>({
                    id: m.id,
                    stageName: m.stageName,
                    _exists: m.exists ?? false
                })) : undefined
        }));
}
function $1ca226bb7c080c09$export$dd07d2c4b69c12db(confidencePattern) {
    if (!confidencePattern?.trim()) return {
        evidenceUrl: "",
        notes: ""
    };
    try {
        const parsed = JSON.parse(confidencePattern);
        if (typeof parsed === "object" && parsed && !Array.isArray(parsed)) {
            const obj = parsed;
            return {
                evidenceUrl: typeof obj.evidenceUrl === "string" ? obj.evidenceUrl : "",
                notes: typeof obj.notes === "string" ? obj.notes : ""
            };
        }
    } catch  {
    // Not a JSON payload (e.g. a plain "manual_update" marker) — no evidence.
    }
    return {
        evidenceUrl: "",
        notes: ""
    };
}
function $1ca226bb7c080c09$export$1c9a431c341e46f5(row, edits) {
    if (edits.contributions === undefined) return [];
    const original = row.contributions ?? [];
    const current = edits.contributions;
    const out = [];
    const toEdit = (c, op)=>{
        const { evidenceUrl: evidenceUrl, notes: notes } = $1ca226bb7c080c09$export$dd07d2c4b69c12db(c.confidencePattern ?? "");
        return {
            op: op,
            role: c.contribution ?? "",
            personaId: c.personaId || undefined,
            dataCategory: c.confidenceCategory ?? "1",
            sourceUrl: evidenceUrl || undefined,
            notes: notes || undefined
        };
    };
    current.filter((c)=>!original.some((oc)=>oc.contribution === c.contribution)).forEach((c)=>out.push(toEdit(c, (0, $ac464ed50cc3b124$export$fd3a7799230e15bd).Add)));
    original.filter((oc)=>!current.some((c)=>c.contribution === oc.contribution)).forEach((oc)=>out.push({
            op: (0, $ac464ed50cc3b124$export$fd3a7799230e15bd).Delete,
            role: oc.contribution ?? ""
        }));
    // Same role, changed category / evidence / persona.
    current.filter((c)=>{
        const orig = original.find((oc)=>oc.contribution === c.contribution);
        return !!orig && (orig.confidenceCategory !== c.confidenceCategory || orig.confidencePattern !== c.confidencePattern || orig.personaId !== c.personaId);
    }).forEach((c)=>out.push(toEdit(c, (0, $ac464ed50cc3b124$export$fd3a7799230e15bd).Edit)));
    return out;
}
function $1ca226bb7c080c09$export$813eb1b51f89cd61(edits, rows, isrcReassignments = {}) {
    const rowById = new Map(rows.map((r)=>[
            r.id,
            r
        ]));
    const batches = {
        correct: [],
        artists: [],
        contributions: [],
        creates: [],
        recordingIds: []
    };
    const touched = new Set();
    Object.entries(edits).forEach(([recordingId, rowEdits])=>{
        const row = rowById.get(recordingId);
        // A pending edit for a row that's no longer on the page can't be diffed
        // safely — skip it rather than send a payload built from stale state.
        if (!row) return;
        const documentId = row.documentId;
        const correctEdits = $1ca226bb7c080c09$export$40f16c614c47cc0(row, rowEdits, isrcReassignments[recordingId]);
        if (correctEdits.length > 0) {
            const payload = {
                edits: correctEdits,
                documentId: documentId
            };
            batches.correct.push({
                recording_id: recordingId,
                document_id: documentId,
                payload: (0, $9a7c0b9330cf3844$export$b390a0a11149d8cb)(payload)
            });
            touched.add(recordingId);
        }
        const createEdits = $1ca226bb7c080c09$export$c650e1b205df766f(row, rowEdits);
        if (createEdits.length > 0) {
            batches.creates.push({
                recordingId: recordingId,
                documentId: documentId,
                edits: createEdits
            });
            touched.add(recordingId);
        }
        const artistEdits = $1ca226bb7c080c09$export$5e8db2537160c2b2(row, rowEdits);
        if (artistEdits.length > 0) {
            const payload = {
                edits: artistEdits,
                documentId: documentId
            };
            batches.artists.push({
                recording_id: recordingId,
                document_id: documentId,
                payload: (0, $f644235c455de382$export$62a3f99c3f3cd78f)(payload)
            });
            touched.add(recordingId);
        }
        const contributionEdits = $1ca226bb7c080c09$export$1c9a431c341e46f5(row, rowEdits);
        if (contributionEdits.length > 0) {
            const payload = {
                edits: contributionEdits,
                documentId: documentId
            };
            batches.contributions.push({
                recording_id: recordingId,
                document_id: documentId,
                payload: (0, $c8f41806c5650da9$export$254a769af7d9fef6)(payload)
            });
            touched.add(recordingId);
        }
    });
    batches.recordingIds = Array.from(touched);
    return batches;
}
function $1ca226bb7c080c09$export$5f6de07de0e6ae14(row, edits) {
    const next = {
        ...row,
        isModified: true,
        hasManualChanges: true
    };
    if (edits.title !== undefined) next.title = edits.title;
    if (edits.duration !== undefined) next.duration = edits.duration;
    if (edits.live !== undefined) {
        const descriptor = (0, $e353c670efa3bb12$export$6a8f182e25b88c10)(edits.live);
        next.live = descriptor;
        // The boolean grid flag is derived from the descriptor's presence.
        next.isLive = !!descriptor;
    }
    if (edits.version !== undefined) {
        next.versionsArray = edits.version;
        next.version = edits.version.join(", ");
    }
    if (edits.isrcs !== undefined) {
        next.isrcsArray = edits.isrcs;
        next.isrcs = edits.isrcs.join(", ");
    }
    if (edits.contributions !== undefined) next.contributions = edits.contributions;
    if (edits.artist !== undefined) {
        // Demoted artists stay linked but are no longer featured, so they leave the
        // grid's artist list along with the ones that were removed outright.
        const kept = edits.artist.filter((a)=>a.name.trim() && !a.demoted);
        next.artist = kept.map((a)=>a.name).join(", ");
        // Artists without a known id are pending-create — the canonical id arrives
        // on the next refetch, so emit the legacy string form for now.
        next.mainArtistsRaw = kept.map((a)=>a.id ? {
                id: a.id,
                stageName: a.name,
                type: a.type ?? "persona"
            } : a.name);
    }
    return next;
}
/* -------------------------------------------------------------------------- */ /* Dispatch                                                                    */ /* -------------------------------------------------------------------------- */ const $1ca226bb7c080c09$var$addError = (errors, recordingId, message)=>{
    const existing = errors[recordingId] ?? [];
    if (!existing.includes(message)) errors[recordingId] = [
        ...existing,
        message
    ];
};
/** Fold one batch response into the running per-recording error map. */ function $1ca226bb7c080c09$var$collectBatchErrors(response, errors, fallback) {
    (response.results ?? []).forEach((result)=>{
        if (result.success) return;
        const messages = result.errors && result.errors.length > 0 ? result.errors : [
            fallback
        ];
        messages.forEach((m)=>$1ca226bb7c080c09$var$addError(errors, result.recordingId, m));
    });
}
async function $1ca226bb7c080c09$export$87145ec5ef7f5cf1(api, userId, edits, rows, isrcReassignments = {}) {
    const batches = $1ca226bb7c080c09$export$813eb1b51f89cd61(edits, rows, isrcReassignments);
    const errors = {};
    let fatalError;
    if (batches.recordingIds.length === 0) return {
        ok: true,
        appliedRecordingIds: [],
        errorsByRecording: {}
    };
    // ── 1. Correct recording data (4.1.1) ──
    if (batches.correct.length > 0) try {
        const response = await api.batchCorrectRecordingBatchServiceResponse({
            userId: userId,
            body: batches.correct
        });
        $1ca226bb7c080c09$var$collectBatchErrors(response, errors, "Recording data could not be saved.");
    } catch (err) {
        const message = await (0, $4e44ff72ec5a5d6e$export$3ad1f1ce31dd8e4a)(err, "recording");
        batches.correct.forEach((e)=>$1ca226bb7c080c09$var$addError(errors, e.recording_id, message));
        fatalError = message;
    }
    // ── 2a. Create + link new artists (4.4.2 — no batch form, one call each) ──
    for (const create of batches.creates)try {
        await api.createArtistAndLinkServiceResponse({
            userId: userId,
            parentRecordingId: create.recordingId,
            createArtistAndLinkRequest: {
                edits: create.edits,
                documentId: create.documentId
            }
        });
    } catch (err) {
        $1ca226bb7c080c09$var$addError(errors, create.recordingId, await (0, $4e44ff72ec5a5d6e$export$3ad1f1ce31dd8e4a)(err, "artists"));
    }
    // ── 2b. Change associated artists (4.1.3) ──
    if (batches.artists.length > 0) try {
        const response = await api.batchChangeArtistsBatchServiceResponse({
            userId: userId,
            body: batches.artists
        });
        $1ca226bb7c080c09$var$collectBatchErrors(response, errors, "Artists could not be saved.");
    } catch (err) {
        const message = await (0, $4e44ff72ec5a5d6e$export$3ad1f1ce31dd8e4a)(err, "artists");
        batches.artists.forEach((e)=>$1ca226bb7c080c09$var$addError(errors, e.recording_id, message));
        fatalError = fatalError ?? message;
    }
    // ── 3. Manage contributions (4.2.1) ──
    if (batches.contributions.length > 0) try {
        const response = await api.batchManageContributionsBatchServiceResponse({
            userId: userId,
            body: batches.contributions
        });
        $1ca226bb7c080c09$var$collectBatchErrors(response, errors, "Contributions could not be saved.");
    } catch (err) {
        const message = await (0, $4e44ff72ec5a5d6e$export$3ad1f1ce31dd8e4a)(err, "contributions");
        batches.contributions.forEach((e)=>$1ca226bb7c080c09$var$addError(errors, e.recording_id, message));
        fatalError = fatalError ?? message;
    }
    const failed = new Set(Object.keys(errors));
    const appliedRecordingIds = batches.recordingIds.filter((id)=>!failed.has(id));
    return {
        ok: failed.size === 0,
        appliedRecordingIds: appliedRecordingIds,
        errorsByRecording: errors,
        fatalError: fatalError
    };
}



/* -------------------------------------------------------------------------- */ /* Row → bucket                                                                */ /* -------------------------------------------------------------------------- */ const $3ff0a68b826d3857$var$valueOfKind = (rows, kind)=>rows.map((r)=>r.value).filter((v)=>v?.kind === kind);
/** The generator types `correct.value` as `object` because the schema leaves it
 *  free-form — every bulk-editable field actually carries a string. One cast
 *  here rather than one at each call site. */ const $3ff0a68b826d3857$var$correctValue = (value)=>value;
/** Recording-level corrections (contract §3.4.1). */ function $3ff0a68b826d3857$var$buildCorrect(rows) {
    const out = [];
    $3ff0a68b826d3857$var$valueOfKind(rows, "title").forEach((v)=>out.push({
            op: "edit",
            field: "recordingTitle",
            value: $3ff0a68b826d3857$var$correctValue(v.title.trim())
        }));
    // Only the `live` descriptor is persisted — the boolean `is_live` is derived
    // downstream from its presence, and the bulk endpoint rejects it outright.
    $3ff0a68b826d3857$var$valueOfKind(rows, "live").forEach((v)=>out.push({
            op: "edit",
            field: "live",
            value: $3ff0a68b826d3857$var$correctValue(v.descriptor.trim())
        }));
    return out;
}
/** Contribution edits (contract §3.4.2). */ function $3ff0a68b826d3857$var$buildContributions(rows, problems) {
    const out = [];
    const toEdit = (c, op)=>{
        const { evidenceUrl: evidenceUrl, notes: notes } = (0, $1ca226bb7c080c09$export$dd07d2c4b69c12db)(c.confidencePattern ?? "");
        return {
            op: op,
            role: c.contribution,
            personaId: c.personaId || undefined,
            dataCategory: c.confidenceCategory || "1",
            sourceUrl: evidenceUrl || undefined,
            notes: notes || undefined
        };
    };
    rows.forEach((row)=>{
        if (row.value?.kind !== "contributions") return;
        // `Replace` supersedes the recording's whole contribution set; `Add` leaves
        // the rest alone; `Edit` changes the detail of a role already there without
        // adding one (contract §6).
        const op = row.operation === "Replace" ? "replace" : row.operation === "Edit" ? "edit" : "add";
        row.value.entries.forEach((entry)=>{
            // The backend requires an alias when a contribution is being created, and
            // the detail modal asks for one — a missing id means the row predates
            // that rule, so name it rather than let the whole request 400. `edit`
            // targets an existing contribution, so it carries no such requirement.
            if (op !== "edit" && !entry.personaId) {
                problems.push(`Contribution \u{201C}${entry.contribution}\u{201D} has no alias selected \u{2014} reopen the row and choose one.`);
                return;
            }
            out.push(toEdit(entry, op));
        });
    });
    $3ff0a68b826d3857$var$valueOfKind(rows, "contributionDelete").forEach((v)=>v.roles.forEach((role)=>out.push({
                op: "delete",
                role: role
            })));
    return out;
}
/** Map the editor's featured status onto the contract's. The editor's `nf`
 *  marker has no add-time equivalent, so it lands on "other featured" — the
 *  same mapping mass edit uses. */ const $3ff0a68b826d3857$var$featuredFor = (entry)=>entry.featuredStatus === "fa" ? "fa" : "ofa";
/** The `change_artists` bucket (contract §3.4.3): existing artists are linked
 *  by id, brand-new ones are created from a source id first. */ function $3ff0a68b826d3857$var$buildChangeArtists(rows, options) {
    const artistChange = [];
    const artistLink = [];
    const idFor = (name)=>options.artistIdByName?.[name] || name;
    rows.forEach((row)=>{
        if (row.value?.kind !== "artist") return;
        const op = row.operation === "Replace" ? "replace" : "add";
        row.value.entries.forEach((entry)=>{
            if (entry.pendingCreate) {
                artistLink.push({
                    source: entry.pendingCreate.source,
                    sourceId: entry.pendingCreate.sourceId,
                    stageName: entry.name,
                    // `_exists` is the generator's rename of the wire's `exists` (it
                    // avoids the reserved word); the mapper writes it back out as
                    // `exists`. Same spelling mass edit uses.
                    members: entry.members?.map((m)=>({
                            id: m.id,
                            stageName: m.stageName,
                            _exists: m.exists ?? false
                        })),
                    featuredStatus: $3ff0a68b826d3857$var$featuredFor(entry),
                    op: op
                });
                return;
            }
            artistChange.push({
                artistId: entry.id || entry.name,
                stageName: entry.name,
                members: entry.members?.map((m)=>({
                        id: m.id,
                        stageName: m.stageName,
                        _exists: m.exists ?? true
                    })),
                type: entry.type,
                op: op,
                featuredStatus: $3ff0a68b826d3857$var$featuredFor(entry)
            });
        });
    });
    // Demote keeps the artist linked but non-featured; delete removes the link
    // outright. Both are `op: delete` — `featuredStatus` is what separates them.
    // Omitting it is how "remove" is expressed: the backend reads an absent key
    // and an explicit null identically (`data.get("featuredStatus")`).
    $3ff0a68b826d3857$var$valueOfKind(rows, "artistDemote").forEach((v)=>v.artists.forEach((name)=>artistChange.push({
                artistId: idFor(name),
                stageName: name,
                op: "delete",
                featuredStatus: "nfa"
            })));
    $3ff0a68b826d3857$var$valueOfKind(rows, "artistDelete").forEach((v)=>v.artists.forEach((name)=>artistChange.push({
                artistId: idFor(name),
                stageName: name,
                op: "delete"
            })));
    return {
        artistChange: artistChange,
        artistLink: artistLink
    };
}
/** The `release_link` bucket (contract §3.4.4). The generated model spells the
 *  fields camelCase and its mapper emits the snake_case the contract requires —
 *  unlike the artist buckets, whose wire form really is camelCase. */ function $3ff0a68b826d3857$var$releaseLinkFrom(selection) {
    const metadata = {
        releaseTitle: selection.releaseTitle,
        dateReleased: selection.dateReleased,
        releaseLabels: selection.releaseLabels,
        catNumbers: selection.catNumbers,
        mediaType: selection.mediaType,
        format: selection.format
    };
    // Linking an existing release carries only its id; creating one carries the
    // source and metadata. Sending both is rejected by the backend.
    if (selection.releaseId) return {
        releaseId: selection.releaseId,
        ...metadata
    };
    return {
        releaseId: null,
        source: selection.source,
        sourceId: selection.sourceId,
        ...metadata
    };
}
function $3ff0a68b826d3857$export$8c3a32d15c540c29(rows, targets, options = {}) {
    const problems = (0, $05e74afd2b6f1b76$export$78a1c9a6d68233b6)(rows);
    const ready = rows.filter((0, $05e74afd2b6f1b76$export$b7616c5a26b2b17b));
    if (targets.length === 0) problems.push("No recordings are selected.");
    if (ready.length === 0) problems.push("No completed edits to apply.");
    if (problems.length > 0) return {
        plan: null,
        problems: problems
    };
    const recordings = targets.map((t)=>({
            recordingId: t.recordingId,
            documentId: t.documentId
        }));
    const correct = $3ff0a68b826d3857$var$buildCorrect(ready);
    const contributions = $3ff0a68b826d3857$var$buildContributions(ready, problems);
    const { artistChange: artistChange, artistLink: artistLink } = $3ff0a68b826d3857$var$buildChangeArtists(ready, options);
    const releaseRow = $3ff0a68b826d3857$var$valueOfKind(ready, "release")[0];
    if (problems.length > 0) return {
        plan: null,
        problems: problems
    };
    const plan = {
        recordings: recordings
    };
    if (correct.length > 0) plan.correct = correct;
    if (contributions.length > 0) plan.contributions = contributions;
    if (artistChange.length > 0 || artistLink.length > 0) // Empty arrays are omitted: the backend rejects an all-empty bucket rather
    // than treating it as a no-op.
    plan.changeArtists = {
        ...artistChange.length > 0 ? {
            artistChange: artistChange
        } : {},
        ...artistLink.length > 0 ? {
            artistLink: artistLink
        } : {}
    };
    if (releaseRow?.selection) plan.releaseLink = $3ff0a68b826d3857$var$releaseLinkFrom(releaseRow.selection);
    const hasAction = !!plan.correct || !!plan.contributions || !!plan.changeArtists || !!plan.releaseLink;
    if (!hasAction) return {
        plan: null,
        problems: [
            "No completed edits to apply."
        ]
    };
    return {
        plan: plan,
        problems: [],
        releaseSelection: releaseRow?.selection
    };
}
const $3ff0a68b826d3857$export$79c34b902d621576 = {
    correct: "Recording details",
    contributions: "Contributions",
    artist_change: "Artists",
    artist_link: "New artists",
    release_link: "Linked release"
};
/* -------------------------------------------------------------------------- */ /* Dispatch                                                                    */ /* -------------------------------------------------------------------------- */ /** The lookup's source vocabulary is the release-link one minus `other` — an
 *  `other` release is identified by a URL, so there is nothing to look up. */ const $3ff0a68b826d3857$var$lookupSourceOf = (source)=>Object.values((0, $52cb4e753ea2e79a$export$9e42fc58eda8364e)).includes(source) ? source : null;
/**
 * Fill in each recording's existing recording→release edge.
 *
 * Needed only when linking a release that already exists: a selection routinely
 * mixes recordings already linked to it with ones that aren't, and DS repoints
 * an existing edge rather than adding a second one only if it's told which edge.
 * A release being *created* has no edges yet, so this is skipped there.
 *
 * A lookup failure is not fatal — the link still goes ahead without edge ids,
 * which is the same position the single-recording path is in when its lookup
 * returns nothing. A 404 (release not in the system) throws, and lands in the
 * same place.
 */ async function $3ff0a68b826d3857$var$withEdgeIds(api, userId, plan, selection) {
    if (!plan.releaseLink?.releaseId) return plan;
    if (!selection?.source || !selection.sourceId) return plan;
    const source = $3ff0a68b826d3857$var$lookupSourceOf(selection.source);
    if (!source) return plan;
    try {
        const lookup = await api.bulkLookupBulkLookupReleaseResponse({
            userId: userId,
            bulkLookupReleaseRequest: {
                source: source,
                sourceId: selection.sourceId,
                recordingIds: plan.recordings.map((r)=>r.recordingId)
            }
        });
        const edgeByRecording = new Map(lookup.recordings.map((r)=>[
                r.recordingId,
                r.edgeId ?? null
            ]));
        return {
            ...plan,
            recordings: plan.recordings.map((r)=>({
                    ...r,
                    edgeId: edgeByRecording.get(r.recordingId) ?? null
                }))
        };
    } catch  {
        // Lookup is an optimisation, not a precondition — proceed without it.
        return plan;
    }
}
async function $3ff0a68b826d3857$export$342902492a3117ca(api, userId, rows, targets, options = {}) {
    const recordingIds = targets.map((t)=>t.recordingId);
    const { plan: plan, problems: problems, releaseSelection: releaseSelection } = $3ff0a68b826d3857$export$8c3a32d15c540c29(rows, targets, options);
    if (!plan) return {
        ok: false,
        status: "failed",
        outcomes: [],
        fatalError: problems.join(" "),
        recordingIds: recordingIds
    };
    try {
        const bulkEdit = await $3ff0a68b826d3857$var$withEdgeIds(api, userId, plan, releaseSelection);
        const response = await api.bulkEditBulkEditResultResponse({
            userId: userId,
            bulkEditRequest: {
                bulkEdit: bulkEdit,
                eventTime: new Date().toISOString()
            }
        });
        const outcomes = (response.results ?? []).map((result)=>({
                action: result.action,
                label: $3ff0a68b826d3857$export$79c34b902d621576[result.action] ?? result.action,
                ok: result.status === "succeeded",
                message: result.status === "succeeded" ? undefined : result.error?.message || "This part of the edit could not be applied."
            }));
        return {
            ok: response.status === "succeeded",
            status: response.status,
            outcomes: outcomes,
            recordingIds: recordingIds
        };
    } catch (err) {
        return {
            ok: false,
            status: "failed",
            outcomes: [],
            fatalError: await (0, $4e44ff72ec5a5d6e$export$3ad1f1ce31dd8e4a)(err, "recording"),
            recordingIds: recordingIds
        };
    }
}




/**
 * Bulk edit modal.
 *
 * A plan builder: the user assembles a list of edit rows, each a
 * field / operation / value combination, then applies them to every selected
 * recording in one call. The value for each row is configured through a
 * secondary modal appropriate to the field & operation (reusing the recording
 * edit form's modals where possible), so the same control edits one recording
 * or a thousand.
 *
 * The row shapes and the rules for what makes a set of them coherent live in
 * `../bulkEditModel`; turning them into the wire payload lives in
 * `../bulkEditBatch`. This file is the surface.
 */ const $b481426d4df6dccf$var$capitalize = (s)=>s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
/** Searchable role dropdown. The same control, from the same module, as the
 *  one the recording edit form and the mass-edit modals use. */ const $b481426d4df6dccf$var$RoleSelect = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb6d544802d60420$export$4d759f1b65b98f06), {
        ...props,
        renderOption: $b481426d4df6dccf$var$capitalize
    });
/** A simple checklist used by the delete operations. */ const $b481426d4df6dccf$var$CheckList = ({ options: options, selected: selected, onToggle: onToggle })=>options.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: (0, $bb6d544802d60420$export$314105a17693dd98),
        children: "Nothing is currently assigned across the selected recordings."
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-flex-col tw-gap-2 tw-max-h-64 tw-overflow-y-auto",
        children: options.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95d3bd05f0e5a60a$export$fab3ce5a4cf652db), {
                checkboxSize: "sm",
                checked: selected.includes(opt),
                onChange: ()=>onToggle(opt),
                label: $b481426d4df6dccf$var$capitalize(opt)
            }, opt))
    });
let $b481426d4df6dccf$var$ROW_SEQ = 0;
const $b481426d4df6dccf$var$newRow = ()=>({
        id: `row-${$b481426d4df6dccf$var$ROW_SEQ++}`,
        field: "",
        operation: "",
        value: null
    });
const $b481426d4df6dccf$export$6d49d09e5768de04 = ({ isOpen: isOpen, onClose: onClose, targets: targets, availableContributions: availableContributions = [], availableArtists: availableArtists = [], availableAliases: availableAliases = [], assignedContributions: assignedContributions = [], assignedArtists: assignedArtists = [], artistIdByName: artistIdByName = {}, userId: userId, releaseContextRow: releaseContextRow = null, availableFormats: availableFormats = [], availableTypes: availableTypes = [], onApplied: onApplied })=>{
    const { adminApi: adminApi } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const selectedCount = targets.length;
    const [rows, setRows] = (0, $acw62.useState)([
        $b481426d4df6dccf$var$newRow()
    ]);
    const [editingRowId, setEditingRowId] = (0, $acw62.useState)(null);
    const [applying, setApplying] = (0, $acw62.useState)(false);
    const [result, setResult] = (0, $acw62.useState)(null);
    // Reset to a single empty row whenever the modal is (re)opened.
    (0, $acw62.useEffect)(()=>{
        if (isOpen) {
            setRows([
                $b481426d4df6dccf$var$newRow()
            ]);
            setEditingRowId(null);
            setApplying(false);
            setResult(null);
        }
    }, [
        isOpen
    ]);
    const contributionOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(availableContributions.filter(Boolean))).sort(), [
        availableContributions
    ]);
    const updateRow = (id, patch)=>setRows((prev)=>prev.map((r)=>r.id === id ? {
                    ...r,
                    ...patch
                } : r));
    const handleFieldChange = (id, field)=>{
        if (!field) {
            updateRow(id, {
                field: "",
                operation: "",
                value: null
            });
            return;
        }
        // Only what the other rows have left free — see `availableOperations`.
        const ops = (0, $05e74afd2b6f1b76$export$702810c20be9018a)(field, rows, id);
        // Pre-select (and later disable) the operation when there is only one.
        const operation = ops.length === 1 ? ops[0] : "";
        updateRow(id, {
            field: field,
            operation: operation,
            value: null
        });
    };
    const handleOperationChange = (id, operation)=>updateRow(id, {
            operation: operation,
            value: null
        });
    const editingRow = rows.find((r)=>r.id === editingRowId) ?? null;
    const rowSummary = (row)=>{
        if (!row.value) return "";
        switch(row.value.kind){
            case "title":
                return row.value.title ? `\u{201C}${row.value.title}\u{201D}` : "";
            case "live":
                return row.value.descriptor ? `Live \xb7 \u{201C}${row.value.descriptor}\u{201D}` : "Mark as live";
            case "contributions":
                return row.value.entries.map((e)=>$b481426d4df6dccf$var$capitalize(e.contribution)).join(", ");
            case "contributionDelete":
                return row.value.roles.map($b481426d4df6dccf$var$capitalize).join(", ");
            case "artist":
                return row.value.entries.map((e)=>e.name).join(", ");
            case "artistDelete":
                return row.value.artists.map($b481426d4df6dccf$var$capitalize).join(", ");
            case "artistDemote":
                return row.value.artists.map($b481426d4df6dccf$var$capitalize).join(", ");
            case "release":
                return row.value.label ? `\u{2192} ${row.value.label}` : "";
            default:
                return "";
        }
    };
    const readyRows = rows.filter((0, $05e74afd2b6f1b76$export$b7616c5a26b2b17b));
    // Contradictions between rows, surfaced before Apply rather than as a 400:
    // the request carries one bucket per field, so two rows that disagree would
    // arrive as two instructions and one would silently lose.
    const conflicts = (0, $acw62.useMemo)(()=>(0, $05e74afd2b6f1b76$export$78a1c9a6d68233b6)(rows), [
        rows
    ]);
    const handleApply = async ()=>{
        if (!userId) return;
        setApplying(true);
        setResult(null);
        try {
            const applied = await (0, $3ff0a68b826d3857$export$342902492a3117ca)(adminApi, userId, rows, targets, {
                artistIdByName: artistIdByName
            });
            setResult(applied);
            // A partial success still changed data, so the grid needs refetching
            // either way — only a fatal error left everything untouched.
            if (!applied.fatalError) onApplied?.(applied);
            if (applied.ok) onClose();
        } finally{
            setApplying(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: isOpen,
                onClose: onClose,
                title: `Bulk edit ${selectedCount} recording${selectedCount === 1 ? "" : "s"}`,
                modalClasses: "tw-w-[980px] tw-max-w-[97vw]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-items-center tw-justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                    children: "Build a set of edits to apply to the selected recordings."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    icon: "plus",
                                    label: "Add row",
                                    onClick: ()=>setRows((prev)=>[
                                                ...prev,
                                                $b481426d4df6dccf$var$newRow()
                                            ])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-overflow-x-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "tw-w-full tw-text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "tw-text-left tw-text-textDove tw-border-b tw-border-formInputBackground",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "tw-py-2 tw-pr-3 tw-font-medium tw-w-[200px]",
                                                    children: "Field"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "tw-py-2 tw-pr-3 tw-font-medium tw-w-[200px]",
                                                    children: "Operation"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "tw-py-2 tw-pr-3 tw-font-medium",
                                                    children: "Values"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "tw-py-2 tw-w-[40px]"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: rows.map((row)=>{
                                            // Every operation is listed, but the ones another row has
                                            // already claimed are greyed out rather than hidden, so the
                                            // "only one of Add / Edit / Replace" rule is visible where it
                                            // applies instead of options silently disappearing.
                                            const ops = row.field ? (0, $05e74afd2b6f1b76$export$539790ee53a8f807)[row.field] : [];
                                            const selectableOps = row.field ? (0, $05e74afd2b6f1b76$export$702810c20be9018a)(row.field, rows, row.id) : [];
                                            const opDisabled = !row.field || selectableOps.length <= 1;
                                            const canEdit = !!row.field && !!row.operation;
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "tw-border-b tw-border-formInputBackground tw-align-top",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tw-py-2 tw-pr-3",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                                                kind: "select",
                                                                hasValue: !!row.field
                                                            }),
                                                            value: row.field,
                                                            onChange: (e)=>handleFieldChange(row.id, e.target.value),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select field\u2026"
                                                                }),
                                                                (0, $05e74afd2b6f1b76$export$e6909ad44e61103d).map((f)=>{
                                                                    const exhausted = (0, $05e74afd2b6f1b76$export$38cf523f1b17bea5)(f, rows, row.id);
                                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: f,
                                                                        disabled: exhausted,
                                                                        children: exhausted ? `${f} (already in this edit)` : f
                                                                    }, f);
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tw-py-2 tw-pr-3",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                                                kind: "select",
                                                                hasValue: !!row.operation
                                                            }),
                                                            value: row.operation,
                                                            disabled: opDisabled,
                                                            onChange: (e)=>handleOperationChange(row.id, e.target.value),
                                                            children: [
                                                                selectableOps.length !== 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select operation\u2026"
                                                                }),
                                                                ops.map((op)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: op,
                                                                        disabled: !selectableOps.includes(op),
                                                                        children: op
                                                                    }, op))
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tw-py-2 tw-pr-3",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-items-center tw-gap-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex-1 tw-min-h-[44px] tw-flex tw-items-center tw-rounded-lg tw-border-2 tw-border-formInputBackground tw-bg-formInputBackground tw-px-3 tw-text-sm", rowSummary(row) ? "tw-text-white" : "tw-text-textSeal"),
                                                                    children: rowSummary(row) || "No value set"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "secondary",
                                                                    icon: "edit",
                                                                    label: "Edit",
                                                                    disabled: !canEdit,
                                                                    onClick: ()=>setEditingRowId(row.id)
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tw-py-2 tw-text-right",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            "aria-label": "Remove row",
                                                            className: "tw-text-textDove hover:tw-text-white tw-p-1",
                                                            onClick: ()=>setRows((prev)=>prev.length === 1 ? [
                                                                        $b481426d4df6dccf$var$newRow()
                                                                    ] : prev.filter((r)=>r.id !== row.id)),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                className: "tw-w-4 tw-h-4"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, row.id);
                                        })
                                    })
                                ]
                            })
                        }),
                        conflicts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-rounded-xl tw-border tw-border-yellow-700/60 tw-bg-yellow-900/20 tw-p-3",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "tw-flex tw-flex-col tw-gap-1",
                                children: conflicts.map((problem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: "tw-text-xs tw-text-yellow-200",
                                        children: problem
                                    }, problem))
                            })
                        }),
                        result && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$BulkEditResult, {
                            result: result
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-3 tw-pt-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: result && !result.ok ? "Close" : "Cancel",
                                    onClick: onClose
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: applying ? "Applying\u2026" : `${result && !result.ok ? "Retry" : "Apply"} ${readyRows.length} edit${readyRows.length === 1 ? "" : "s"} to ${selectedCount} recording${selectedCount === 1 ? "" : "s"}`,
                                    disabled: readyRows.length === 0 || selectedCount === 0 || conflicts.length > 0 || applying || !userId,
                                    onClick: handleApply
                                })
                            ]
                        })
                    ]
                })
            }),
            editingRow && editingRow.field && editingRow.operation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$RowValueEditor, {
                row: editingRow,
                contributionOptions: contributionOptions,
                availableArtists: availableArtists,
                availableAliases: availableAliases,
                assignedContributions: assignedContributions,
                assignedArtists: assignedArtists,
                userId: userId,
                releaseContextRow: releaseContextRow,
                bulkRecordingIds: targets.map((t)=>t.recordingId),
                availableFormats: availableFormats,
                availableTypes: availableTypes,
                onClose: ()=>setEditingRowId(null),
                onSave: (value)=>{
                    updateRow(editingRow.id, {
                        value: value
                    });
                    setEditingRowId(null);
                }
            })
        ]
    });
};
/**
 * What landed and what didn't.
 *
 * Reported per action rather than per recording because that's all the contract
 * can tell us: DS runs one set-based query per action, so a failure covers the
 * whole selection for that action and says nothing about individual recordings
 * (contract §5). Retrying is resubmitting the same plan — the apply is
 * idempotent, so the actions that already succeeded are harmless to replay.
 */ const $b481426d4df6dccf$var$BulkEditResult = ({ result: result })=>{
    if (result.fatalError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-rounded-xl tw-border tw-border-red-700/60 tw-bg-red-900/20 tw-p-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-xs tw-text-red-200",
                children: result.fatalError
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-xs tw-text-red-300 tw-mt-1",
                children: "Nothing was applied."
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-rounded-xl tw-border tw-p-3 tw-flex tw-flex-col tw-gap-2", result.ok ? "tw-border-formInputBackground tw-bg-surfaceBlack80" : "tw-border-red-700/60 tw-bg-red-900/20"),
        children: [
            !result.ok && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-xs tw-text-red-200",
                children: "Some of this edit could not be applied. Fixing the cause and applying again is safe \u2014 the parts that already succeeded will simply be reapplied."
            }),
            result.outcomes.map((outcome)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-items-start tw-gap-2 tw-text-xs",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: outcome.ok ? "tw-text-textLime" : "tw-text-red-300",
                            "aria-hidden": true,
                            children: outcome.ok ? "\u2713" : "\u2715"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-text-white",
                            children: outcome.label
                        }),
                        !outcome.ok && outcome.message && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "tw-text-red-300",
                            children: [
                                "\u2014 ",
                                outcome.message
                            ]
                        })
                    ]
                }, outcome.action))
        ]
    });
};
/* ------------------------------------------------------------------------- */ /* Secondary value editors                                                   */ /* ------------------------------------------------------------------------- */ const $b481426d4df6dccf$var$RowValueEditor = ({ row: row, contributionOptions: contributionOptions, availableArtists: availableArtists, availableAliases: availableAliases, assignedContributions: assignedContributions, assignedArtists: assignedArtists, userId: userId, releaseContextRow: releaseContextRow, bulkRecordingIds: bulkRecordingIds, availableFormats: availableFormats, availableTypes: availableTypes, onClose: onClose, onSave: onSave })=>{
    const kind = (0, $05e74afd2b6f1b76$export$a7f4fa59930e5088)(row.field, row.operation);
    switch(kind){
        case "title":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$TextValueEditor, {
                title: `${row.operation} recording title`,
                description: "This title will be applied to the selected recordings.",
                label: "Recording title",
                placeholder: "Title to apply",
                initial: row.value?.kind === "title" ? row.value.title : "",
                onClose: onClose,
                onSave: (title)=>onSave({
                        kind: "title",
                        title: title
                    })
            });
        case "live":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$TextValueEditor, {
                title: row.value?.kind === "live" && row.value.descriptor.trim().length > 0 ? "Update live version" : "Mark as live",
                description: "The selected recordings will be marked as live. A live descriptor is required, as on the recording edit form. Recordings whose live descriptor was set automatically and never manually changed will be skipped.",
                label: "Live descriptor",
                placeholder: "e.g. Live at Wembley, 1985",
                required: true,
                initial: row.value?.kind === "live" ? row.value.descriptor : "",
                onClose: onClose,
                onSave: (descriptor)=>onSave({
                        kind: "live",
                        descriptor: descriptor.trim()
                    })
            });
        case "release":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88d049fe01006cd7$export$334ef0499792785f), {
                isOpen: true,
                mode: "select",
                userId: userId,
                row: releaseContextRow,
                // The lookup is about the whole selection, not the one recording that
                // happens to supply the display context.
                bulkRecordingIds: bulkRecordingIds,
                availableFormats: availableFormats,
                availableTypes: availableTypes,
                onClose: onClose,
                onApplied: (updatedRow, selection)=>onSave({
                        kind: "release",
                        label: updatedRow.release,
                        selection: // The linkage — an existing release id, or the metadata to create
                        // one from. Without it the row can only be displayed, not applied.
                        selection,
                        release: updatedRow.release,
                        earliestParentReleaseId: updatedRow.earliestParentReleaseId,
                        sourceReleaseId: updatedRow.sourceReleaseId,
                        year: updatedRow.year,
                        format: updatedRow.format,
                        mediaType: updatedRow.mediaType
                    })
            });
        case "artistDemote":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$DeleteListEditor, {
                title: "Demote artists to non-featured",
                description: "Select artists to demote to non-featured. Only artists currently assigned across the selected recordings are shown. As on the edit form, demote keeps the artist linked but non-featured (use Delete to remove them entirely).",
                options: assignedArtists,
                initial: row.value?.kind === "artistDemote" ? row.value.artists : [],
                onClose: onClose,
                onSave: (artists)=>onSave({
                        kind: "artistDemote",
                        artists: artists
                    })
            });
        case "contributionDelete":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$DeleteListEditor, {
                title: "Delete contributions",
                description: "Select contributions to remove. Only contributions currently assigned across the selected recordings are shown.",
                options: assignedContributions,
                initial: row.value?.kind === "contributionDelete" ? row.value.roles : [],
                onClose: onClose,
                onSave: (roles)=>onSave({
                        kind: "contributionDelete",
                        roles: roles
                    })
            });
        case "artistDelete":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$DeleteListEditor, {
                title: "Delete artists",
                description: "Select artists to remove. Only artists currently assigned across the selected recordings are shown. A recording must keep at least one artist, so on apply this removal is skipped for any recording where it would remove the last remaining artist.",
                options: assignedArtists,
                initial: row.value?.kind === "artistDelete" ? row.value.artists : [],
                onClose: onClose,
                onSave: (artists)=>onSave({
                        kind: "artistDelete",
                        artists: artists
                    })
            });
        case "contributions":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$ContributionListEditor, {
                operation: row.operation,
                contributionOptions: contributionOptions,
                assignedContributions: assignedContributions,
                availableAliases: availableAliases,
                initial: row.value?.kind === "contributions" ? row.value.entries : [],
                onClose: onClose,
                onSave: (entries)=>onSave({
                        kind: "contributions",
                        entries: entries
                    })
            });
        case "artist":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$ArtistAddEditor, {
                replaceAll: row.operation === "Replace",
                availableArtists: availableArtists,
                userId: userId,
                parentRecordingId: releaseContextRow?.id,
                initial: row.value?.kind === "artist" ? row.value.entries : [],
                onClose: onClose,
                onSave: (entries)=>onSave({
                        kind: "artist",
                        entries: entries
                    })
            });
        default:
            return null;
    }
};
/** Simple single-input editor used for Recording Title and Live. */ const $b481426d4df6dccf$var$TextValueEditor = ({ title: title, description: description, label: label, placeholder: placeholder, required: required = true, initial: initial, onClose: onClose, onSave: onSave })=>{
    const [value, setValue] = (0, $acw62.useState)(initial);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: true,
        onClose: onClose,
        title: title,
        modalClasses: "tw-w-[520px] tw-max-w-[95vw]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: (0, $bb6d544802d60420$export$314105a17693dd98),
                    children: description
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                            children: label
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            className: (0, $bb6d544802d60420$export$a814bb3374afa59b),
                            value: value,
                            onChange: (e)=>setValue(e.target.value),
                            placeholder: placeholder
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Save",
                            disabled: required && value.trim().length === 0,
                            onClick: ()=>onSave(value)
                        })
                    ]
                })
            ]
        })
    });
};
/** Checklist editor used by the delete operations. */ const $b481426d4df6dccf$var$DeleteListEditor = ({ title: title, description: description, options: options, initial: initial, onClose: onClose, onSave: onSave })=>{
    const [selected, setSelected] = (0, $acw62.useState)(initial);
    // Dedupe (case-insensitive) so the same role/artist assigned across several
    // recordings shows once, avoiding duplicate React keys and repeated rows.
    const uniqueOptions = (0, $acw62.useMemo)(()=>{
        const seen = new Set();
        const out = [];
        for (const o of options){
            const key = o.toLowerCase();
            if (o && !seen.has(key)) {
                seen.add(key);
                out.push(o);
            }
        }
        return out;
    }, [
        options
    ]);
    const toggle = (value)=>setSelected((prev)=>prev.includes(value) ? prev.filter((v)=>v !== value) : [
                ...prev,
                value
            ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: true,
        onClose: onClose,
        title: title,
        modalClasses: "tw-w-[520px] tw-max-w-[95vw]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: (0, $bb6d544802d60420$export$314105a17693dd98),
                    children: description
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$CheckList, {
                    options: uniqueOptions,
                    selected: selected,
                    onToggle: toggle
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Save",
                            disabled: selected.length === 0,
                            onClick: ()=>onSave(selected)
                        })
                    ]
                })
            ]
        })
    });
};
const $b481426d4df6dccf$var$CONTRIBUTION_EDITOR_COPY = {
    Add: {
        title: "Add contributions",
        help: "Add one or more contributions to the selected recordings. Click a contribution to change its data quality or evidence.",
        pickLabel: "Add a contribution",
        pickPlaceholder: "Search or select contribution\u2026"
    },
    Edit: {
        title: "Edit contributions",
        help: "Change the data quality, evidence or alias of contributions the selected recordings already have. Only contributions currently assigned across the selection can be edited \u2014 nothing is added.",
        pickLabel: "Choose a contribution to edit",
        pickPlaceholder: "Search assigned contributions\u2026"
    },
    Replace: {
        title: "Replace all contributions",
        help: "Define the full set of contributions. These will replace every contribution currently set on the selected recordings.",
        pickLabel: "Add a contribution",
        pickPlaceholder: "Search or select contribution\u2026"
    }
};
/**
 * Add / Edit / Replace-all editor: build a list of contributions, each
 * configured via the reused ContributionDetailModal.
 *
 * The three operations share one surface because they build the same list —
 * only the wire `op` and where the roles come from differ. Edit offers the
 * roles actually assigned across the selection (there is nothing else to edit)
 * and never demands an alias, since it targets a contribution that already
 * exists rather than creating one.
 */ const $b481426d4df6dccf$var$ContributionListEditor = ({ operation: operation, contributionOptions: contributionOptions, assignedContributions: assignedContributions, availableAliases: availableAliases, initial: initial, onClose: onClose, onSave: onSave })=>{
    const [entries, setEntries] = (0, $acw62.useState)(initial);
    const [pendingRole, setPendingRole] = (0, $acw62.useState)(null);
    const [editingIndex, setEditingIndex] = (0, $acw62.useState)(null);
    const isEditOp = operation === "Edit";
    const copy = $b481426d4df6dccf$var$CONTRIBUTION_EDITOR_COPY[operation];
    const detailOpen = pendingRole !== null || editingIndex !== null;
    const editingEntry = editingIndex !== null ? entries[editingIndex] : null;
    const editingNotes = (0, $1ca226bb7c080c09$export$dd07d2c4b69c12db)(editingEntry?.confidencePattern);
    // Dedupe case-insensitively: the same role assigned across several recordings
    // arrives once per recording.
    const roleOptions = (0, $acw62.useMemo)(()=>{
        const source = isEditOp ? assignedContributions : contributionOptions;
        return Array.from(new Map(source.filter(Boolean).map((r)=>[
                r.toLowerCase(),
                r
            ])).values()).sort();
    }, [
        isEditOp,
        assignedContributions,
        contributionOptions
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: !detailOpen,
                onClose: onClose,
                title: copy.title,
                modalClasses: "tw-w-[560px] tw-max-w-[95vw]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: (0, $bb6d544802d60420$export$314105a17693dd98),
                            children: copy.help
                        }),
                        entries.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-flex-wrap tw-gap-1.5",
                            children: entries.map((c, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$1fcd028c38eb96f), {
                                    role: c.contribution,
                                    confidenceCategory: c.confidenceCategory,
                                    edited: false,
                                    onSelect: ()=>setEditingIndex(index),
                                    onRemove: ()=>setEntries((prev)=>prev.filter((_, i)=>i !== index))
                                }, c.contribution))
                        }),
                        roleOptions.length === 0 && isEditOp ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: (0, $bb6d544802d60420$export$314105a17693dd98),
                            children: "None of the selected recordings have any contributions to edit."
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                    children: copy.pickLabel
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b481426d4df6dccf$var$RoleSelect, {
                                    options: roleOptions,
                                    exclude: entries.map((e)=>e.contribution),
                                    onSelect: (role)=>setPendingRole(role),
                                    placeholder: copy.pickPlaceholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: onClose
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Save",
                                    disabled: entries.length === 0,
                                    onClick: ()=>onSave(entries)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $225524c18db7a507$export$ad612c67e8fe7176), {
                isOpen: detailOpen,
                // 'add' is what forces an alias to be chosen. An Edit-operation row
                // never creates a contribution, and neither does reopening a chip, so
                // both go in as 'edit'.
                mode: isEditOp || editingIndex !== null ? "edit" : "add",
                initialValue: editingEntry ? {
                    contributionName: editingEntry.contribution,
                    confidenceCategory: editingEntry.confidenceCategory ?? "1",
                    evidenceUrl: editingNotes.evidenceUrl,
                    notes: editingNotes.notes,
                    personaId: editingEntry.personaId ?? ""
                } : {
                    contributionName: pendingRole ?? ""
                },
                aliases: availableAliases,
                onClose: ()=>{
                    setPendingRole(null);
                    setEditingIndex(null);
                },
                onSave: (payload)=>{
                    setEntries((prev)=>editingIndex !== null ? prev.map((e, i)=>i === editingIndex ? payload : e) : [
                            ...prev,
                            payload
                        ]);
                    setPendingRole(null);
                    setEditingIndex(null);
                }
            })
        ]
    });
};
const $b481426d4df6dccf$var$featuredLabel = (status)=>status === "fa" ? "Featured" : status === "ofa" ? "Other Featured" : "Non-Featured";
/** Artist add/replace — builds a list of artists, each added either by
 *  searching existing artists (carrying identity + featured status) or via the
 *  reused "Create new artist" modal. Mirrors the recording edit form so links
 *  carry an id/members and a Featured / Other Featured choice. */ const $b481426d4df6dccf$var$ArtistAddEditor = ({ replaceAll: replaceAll, userId: userId, parentRecordingId: parentRecordingId, initial: initial, onClose: onClose, onSave: onSave })=>{
    const [entries, setEntries] = (0, $acw62.useState)(initial);
    const [addingArtist, setAddingArtist] = (0, $acw62.useState)(false);
    // An existing artist picked from search, awaiting the featured-status choice.
    const [pendingArtist, setPendingArtist] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: !addingArtist && pendingArtist === null,
                onClose: onClose,
                title: replaceAll ? "Replace all artists" : "Add artists",
                modalClasses: "tw-w-[560px] tw-max-w-[95vw]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: (0, $bb6d544802d60420$export$314105a17693dd98),
                            children: replaceAll ? "Define the full set of artists. These will replace every artist currently set on the selected recordings." : "Add one or more artists to the selected recordings."
                        }),
                        entries.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-flex-wrap tw-gap-2",
                            children: entries.map((a, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-surfaceBlack80 tw-border tw-border-formInputBackground tw-px-3 tw-py-1 tw-text-xs tw-text-white",
                                    children: [
                                        a.name,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "tw-text-textSeal",
                                            children: [
                                                "\xb7 ",
                                                $b481426d4df6dccf$var$featuredLabel(a.featuredStatus)
                                            ]
                                        }),
                                        a.pendingCreate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-text-textLime",
                                            children: "\xb7 new"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            "aria-label": `Remove ${a.name}`,
                                            className: "tw-text-textDove hover:tw-text-white",
                                            onClick: ()=>setEntries((prev)=>prev.filter((_, i)=>i !== index)),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                className: "tw-w-3 tw-h-3"
                                            })
                                        })
                                    ]
                                }, `${a.name}-${index}`))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                    children: "Search existing artists"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $814d90124c52a773$export$d95759e348d01a1a), {
                                    userId: userId,
                                    parentRecordingId: parentRecordingId,
                                    existing: entries,
                                    onSelect: (artist)=>setPendingArtist(artist)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-justify-start",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                icon: "plus",
                                label: "Create new artist",
                                onClick: ()=>setAddingArtist(true)
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: onClose
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Save",
                                    disabled: entries.length === 0,
                                    onClick: ()=>onSave(entries)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $814d90124c52a773$export$3cbdf2bb01a18fa5), {
                pending: pendingArtist,
                onCancel: ()=>setPendingArtist(null),
                onAdd: (entry)=>{
                    setEntries((prev)=>prev.some((e)=>e.name === entry.name || e.id === entry.id) ? prev : [
                            ...prev,
                            entry
                        ]);
                    setPendingArtist(null);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b44378a47b84f9b0$export$6327d397dd9387a), {
                isOpen: addingArtist,
                userId: userId,
                parentRecordingId: parentRecordingId,
                onClose: ()=>setAddingArtist(false),
                onAdd: (entry)=>{
                    setEntries((prev)=>[
                            ...prev,
                            entry
                        ]);
                    setAddingArtist(false);
                }
            })
        ]
    });
};
var $b481426d4df6dccf$export$2e2bcd8739ae039 = $b481426d4df6dccf$export$6d49d09e5768de04;




var $acw62 = parcelRequire("acw62");











/* ------------------------------------------------------------------------- */ /* Shared helpers / styling                                                   */ /* ------------------------------------------------------------------------- */ const $7ba18110fd51242f$var$capitalize = (s)=>s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
/* Field presentation comes from ./formStyles, shared with the recording edit
 * form and the bulk-edit builder. Aliased because this module already refers to
 * the input skin by this name throughout. */ const $7ba18110fd51242f$var$inputClasses = (0, $bb6d544802d60420$export$a814bb3374afa59b);
/** Parse an evidence/notes payload out of a contribution's confidencePattern. */ function $7ba18110fd51242f$var$parseEvidenceNotes(confidencePattern) {
    if (!confidencePattern?.trim()) return {
        evidenceUrl: "",
        notes: ""
    };
    try {
        const o = JSON.parse(confidencePattern);
        if (typeof o === "object" && o && !Array.isArray(o)) {
            const obj = o;
            return {
                evidenceUrl: typeof obj.evidenceUrl === "string" ? obj.evidenceUrl : "",
                notes: typeof obj.notes === "string" ? obj.notes : ""
            };
        }
    } catch  {
    // ignore malformed patterns
    }
    return {
        evidenceUrl: "",
        notes: ""
    };
}
function $7ba18110fd51242f$export$580b5289238c00a3(row) {
    return (row.contributions ?? []).map((c)=>({
            contribution: c.contribution,
            confidenceCategory: c.confidenceCategory ?? "1",
            confidencePattern: c.confidencePattern ?? "",
            personaId: c.personaId
        }));
}
/** Searchable role picker. The panel, the options and the input skin all come
 *  from ./formStyles, so this reads the same as the equivalent control in the
 *  recording edit form and the bulk-edit builder; only the capitalisation of
 *  role names is local. */ const $7ba18110fd51242f$var$SearchSelect = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb6d544802d60420$export$4d759f1b65b98f06), {
        ...props,
        renderOption: $7ba18110fd51242f$var$capitalize
    });
const $7ba18110fd51242f$export$b6661608da11c63b = ({ recordingTitle: recordingTitle, initial: initial, onClose: onClose, onSave: onSave })=>{
    const [value, setValue] = (0, $acw62.useState)(initial);
    // Stay quiet until the user has typed — an untouched field shouldn't be
    // scolded just for being open (mirrors the Duration modal).
    const [touched, setTouched] = (0, $acw62.useState)(false);
    const trimmed = value.trim();
    const showError = touched && trimmed.length === 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: true,
        onClose: onClose,
        title: "Edit Recording Title",
        modalClasses: "tw-w-[520px] tw-max-w-[95vw]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: (0, $bb6d544802d60420$export$314105a17693dd98),
                    children: [
                        "Edit the title of \u201C",
                        recordingTitle,
                        "\u201D. Every recording needs a title, so it can be corrected here but not cleared."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                            children: "Recording title"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($7ba18110fd51242f$var$inputClasses, showError && (0, $bb6d544802d60420$export$a1e737d995d28b3)),
                            // Focus via ref rather than autoFocus (jsx-a11y/no-autofocus).
                            ref: (el)=>el?.focus(),
                            value: value,
                            placeholder: "Recording title",
                            onChange: (e)=>{
                                setValue(e.target.value);
                                setTouched(true);
                            },
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" && trimmed.length > 0) {
                                    e.preventDefault();
                                    onSave(trimmed);
                                }
                            }
                        }),
                        showError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: (0, $bb6d544802d60420$export$a6bfce277b24cca2),
                            children: "A recording title is required \u2014 type the corrected title, or cancel to leave it as it was."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Save",
                            disabled: trimmed.length === 0,
                            onClick: ()=>onSave(trimmed)
                        })
                    ]
                })
            ]
        })
    });
};
const $7ba18110fd51242f$export$a67f5c23c74e5e60 = "This duration was set automatically and hasn\u2019t been manually changed, so it can\u2019t be edited here.";
const $7ba18110fd51242f$export$c8763191f5c97710 = ({ recordingTitle: recordingTitle, initial: initial, locked: locked = false, onClose: onClose, onSave: onSave })=>{
    const [value, setValue] = (0, $acw62.useState)(initial);
    // Validate as the user types, but stay quiet until they've typed something —
    // a half-entered "00:0" shouldn't be scolded on the first keystroke.
    const [touched, setTouched] = (0, $acw62.useState)(false);
    const error = (0, $e353c670efa3bb12$export$9c76e80356ef871a)(value);
    const showError = touched && error !== null;
    const trimmed = value.trim();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: true,
        onClose: onClose,
        title: "Edit Duration",
        modalClasses: "tw-w-[520px] tw-max-w-[95vw]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
            children: [
                locked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: (0, $bb6d544802d60420$export$314105a17693dd98),
                    children: [
                        "\u201C",
                        recordingTitle,
                        "\u201D already has a duration that was set automatically and hasn\u2019t been manually changed. As on the recording edit form, an existing duration can only be edited once it has been manually changed before, so it\u2019s locked here."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: (0, $bb6d544802d60420$export$314105a17693dd98),
                    children: [
                        "Set the duration for \u201C",
                        recordingTitle,
                        "\u201D. Use",
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-font-medium tw-text-white",
                            children: "HH:MM:SS"
                        }),
                        " \u2014 two digits for each part. A 3 minute 45 second recording is",
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-font-medium tw-text-white",
                            children: "00:03:45"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                            children: "Duration"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($7ba18110fd51242f$var$inputClasses, showError && (0, $bb6d544802d60420$export$a1e737d995d28b3), locked && (0, $bb6d544802d60420$export$3288f564f0f980a7)),
                            // Focus via ref rather than autoFocus (jsx-a11y/no-autofocus).
                            ref: (el)=>{
                                if (!locked) el?.focus();
                            },
                            value: value,
                            disabled: locked,
                            inputMode: "numeric",
                            placeholder: "00:03:45",
                            onChange: (e)=>{
                                setValue(e.target.value);
                                setTouched(true);
                            },
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" && !error && !locked) {
                                    e.preventDefault();
                                    onSave(trimmed);
                                }
                            }
                        }),
                        showError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: (0, $bb6d544802d60420$export$a6bfce277b24cca2),
                            children: error
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: (0, $bb6d544802d60420$export$7a55dcc9227b4343),
                            children: trimmed ? (0, $e353c670efa3bb12$export$c0eaa116058edb10) : "Leave empty to leave the duration unset."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Save",
                            disabled: locked || error !== null,
                            onClick: ()=>onSave(trimmed)
                        })
                    ]
                })
            ]
        })
    });
};
const $7ba18110fd51242f$export$7e62e461b48ebca8 = "This live version was set automatically and hasn\u2019t been manually changed, so it can\u2019t be edited here.";
const $7ba18110fd51242f$var$MassLiveEditModal = ({ recordingTitle: recordingTitle, initial: initial, locked: locked, onClose: onClose, onSave: onSave })=>{
    const alreadyLive = initial.trim().length > 0;
    const [descriptor, setDescriptor] = (0, $acw62.useState)(initial);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: true,
        onClose: onClose,
        title: alreadyLive ? "Update live version" : "Change to Live",
        modalClasses: "tw-w-[520px] tw-max-w-[95vw]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
            children: [
                locked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: (0, $bb6d544802d60420$export$314105a17693dd98),
                    children: [
                        "\u201C",
                        recordingTitle,
                        "\u201D already has a live descriptor that was set automatically and hasn\u2019t been manually changed. As on the recording edit form, an existing live version can only be edited once it has been manually changed before, so it\u2019s locked here."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: (0, $bb6d544802d60420$export$314105a17693dd98),
                    children: [
                        "Mark \u201C",
                        recordingTitle,
                        "\u201D as a live recording. A live descriptor is required. As on the recording edit form, a recording's live status can be set or updated here but cannot be cleared back to not-live."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                            children: "Live descriptor"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($7ba18110fd51242f$var$inputClasses, "tw-h-auto tw-resize-y", locked && (0, $bb6d544802d60420$export$3288f564f0f980a7)),
                            rows: 3,
                            value: descriptor,
                            disabled: locked,
                            onChange: (e)=>setDescriptor(e.target.value),
                            placeholder: "e.g. Live at Wembley, 1985"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Save",
                            disabled: locked || descriptor.trim().length === 0,
                            onClick: ()=>onSave(descriptor.trim())
                        })
                    ]
                })
            ]
        })
    });
};
/* ------------------------------------------------------------------------- */ /* Version (multi-value list)                                                */ /* ------------------------------------------------------------------------- */ const $7ba18110fd51242f$var$MassVersionEditModal = ({ recordingTitle: recordingTitle, initial: initial, onClose: onClose, onSave: onSave })=>{
    const [versions, setVersions] = (0, $acw62.useState)(initial);
    // Mirrors the recording edit form: versions are strictly edit-only here.
    // Existing versions can be renamed or emptied out, but new versions cannot be
    // added (the edit form shows "None" with no add control when a recording has
    // none). A recording with no versions therefore has nothing to edit.
    const hasVersions = initial.length > 0;
    const updateAt = (index, value)=>setVersions((prev)=>prev.map((v, i)=>i === index ? value : v));
    const trimmed = versions.map((v)=>v.trim());
    const nonEmpty = trimmed.filter((v)=>v.length > 0);
    const duplicate = (0, $e353c670efa3bb12$export$e3510695f47e62c5)(nonEmpty);
    const versionsError = duplicate ? `\u{201C}${duplicate}\u{201D} is listed more than once. Versions must be unique.` : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: true,
        onClose: onClose,
        title: "Edit Version",
        modalClasses: "tw-w-[520px] tw-max-w-[95vw]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: (0, $bb6d544802d60420$export$314105a17693dd98),
                    children: hasVersions ? `Edit the existing versions for \u{201C}${recordingTitle}\u{201D}. As on the recording edit form, versions can be edited but new ones can\u{2019}t be added here.` : `\u{201C}${recordingTitle}\u{201D} has no versions. As on the recording edit form, versions can\u{2019}t be added here.`
                }),
                hasVersions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-gap-2",
                    children: versions.map((v, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            className: $7ba18110fd51242f$var$inputClasses,
                            value: v,
                            onChange: (e)=>updateAt(i, e.target.value),
                            onBlur: (e)=>updateAt(i, e.target.value.trim()),
                            placeholder: "Version"
                        }, i))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "tw-text-sm tw-text-textSeal tw-italic",
                    children: "None"
                }),
                versionsError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: (0, $bb6d544802d60420$export$a6bfce277b24cca2),
                    children: versionsError
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Cancel",
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Save",
                            disabled: !hasVersions || !!versionsError,
                            onClick: ()=>onSave(nonEmpty)
                        })
                    ]
                })
            ]
        })
    });
};
const $7ba18110fd51242f$var$MassIsrcEditModal = ({ recordingTitle: recordingTitle, initial: initial, row: row, userId: userId, parentRecordingId: parentRecordingId, onClose: onClose, onSave: onSave, onReassign: onReassign })=>{
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [isrcs, setIsrcs] = (0, $acw62.useState)(initial);
    const [draft, setDraft] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)(null);
    const [checking, setChecking] = (0, $acw62.useState)(false);
    // ISRCs reassigned from other recordings this session → the recording ids
    // they were taken from. Drives the "· reassigned" tag and, on save, the
    // optimistic update of those source rows in the grid.
    const [reassignSources, setReassignSources] = (0, $acw62.useState)({});
    // The ISRC awaiting reassign confirmation, plus the recordings it's on now.
    const [pendingDup, setPendingDup] = (0, $acw62.useState)(null);
    // Backend uniqueness check — mirrors the edit form's validateIsrcDuplication.
    const checkDuplicate = async (isrc)=>{
        if (!userId || !parentRecordingId) return {
            isDuplicate: false,
            matches: []
        };
        try {
            const resp = await api.validateIsrcValidateIsrcResponse({
                userId: userId,
                parentRecordingId: parentRecordingId,
                validateIsrcRequest: {
                    isrc: isrc
                }
            });
            return {
                isDuplicate: resp.isDuplicate ?? false,
                matches: (resp.matches ?? []).map((m)=>({
                        recordingId: m.recordingId ?? "",
                        documentId: m.documentId ?? "",
                        recordingTitle: m.recordingTitle ?? "",
                        artistName: m.artistName ?? ""
                    }))
            };
        } catch  {
            // On a network/API error, allow the ISRC (don't block on failure).
            return {
                isDuplicate: false,
                matches: []
            };
        }
    };
    const commitIsrc = (isrc, sources)=>{
        setIsrcs((prev)=>[
                ...prev,
                isrc
            ]);
        if (sources && sources.length > 0) setReassignSources((prev)=>({
                ...prev,
                [isrc]: sources
            }));
        setDraft("");
    };
    const handleSave = ()=>{
        onSave(isrcs);
        // Only report reassignments for ISRCs still in the final list (the user may
        // have removed a reassigned chip before saving).
        const active = Object.fromEntries(Object.entries(reassignSources).filter(([isrc])=>isrcs.includes(isrc)));
        if (Object.keys(active).length > 0) onReassign?.(active);
    };
    const addDraft = async ()=>{
        const raw = draft.trim();
        if (!raw) return;
        if (!(0, $e353c670efa3bb12$export$5c2a80a44f9ccb50)(raw)) {
            setError((0, $e353c670efa3bb12$export$909be10aa76219bc));
            return;
        }
        setError(null);
        // Case-insensitive dedupe, mirroring the edit form's addMultipleValue.
        if (isrcs.some((x)=>x.toLowerCase() === raw.toLowerCase())) {
            setDraft("");
            return;
        }
        setChecking(true);
        const { isDuplicate: isDuplicate, matches: matches } = await checkDuplicate(raw);
        setChecking(false);
        if (isDuplicate) {
            setPendingDup({
                isrc: raw,
                matches: matches
            });
            return;
        }
        commitIsrc(raw);
    };
    // Chip indicators, matching the recording edit form: purple line for an ISRC
    // added by a server-side manual change, pulsing dot for one added here.
    const manuallyAdded = new Set(row.manuallyAddedIsrcs ?? []);
    const original = new Set(row.isrcsArray ?? []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: pendingDup === null,
                onClose: onClose,
                title: "Edit ISRCs",
                modalClasses: "tw-w-[520px] tw-max-w-[95vw]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: (0, $bb6d544802d60420$export$314105a17693dd98),
                            children: [
                                "Edit the ISRCs for \u201C",
                                recordingTitle,
                                "\u201D."
                            ]
                        }),
                        isrcs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-flex-wrap tw-gap-1.5",
                            children: isrcs.map((v)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$7260e85975d9726b), {
                                    value: v,
                                    edited: manuallyAdded.has(v),
                                    changed: !original.has(v),
                                    suffix: reassignSources[v] !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "tw-text-textLime",
                                        children: "\xb7 reassigned"
                                    }) : undefined,
                                    onRemove: ()=>{
                                        setIsrcs((prev)=>prev.filter((x)=>x !== v));
                                        // Removing a chip clears any stale format error so the
                                        // Save button isn't blocked by an error for a gone value.
                                        if (error) setError(null);
                                    }
                                }, v))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-items-center tw-gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            className: $7ba18110fd51242f$var$inputClasses,
                                            value: draft,
                                            onChange: (e)=>{
                                                setDraft(e.target.value);
                                                if (error) setError(null);
                                            },
                                            onKeyDown: (e)=>{
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    addDraft();
                                                }
                                            },
                                            placeholder: "Add an ISRC (e.g. GBAAA0912345)\u2026"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                            variant: "secondary",
                                            icon: "plus",
                                            label: checking ? "Checking\u2026" : "Add",
                                            disabled: draft.trim().length === 0 || checking,
                                            onClick: addDraft
                                        })
                                    ]
                                }),
                                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: (0, $bb6d544802d60420$export$a6bfce277b24cca2),
                                    children: error
                                }),
                                draft.trim().length > 0 && !error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-yellow-300 tw-text-xs",
                                    children: "You have an unadded ISRC. Click \u201CAdd\u201D to include it before saving, or clear the field."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: onClose
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Save",
                                    // Block save while an ISRC draft is uncommitted so the typed value
                                    // isn't silently dropped (mirrors the edit form).
                                    disabled: draft.trim().length > 0 || checking,
                                    onClick: handleSave
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: pendingDup !== null,
                onClose: ()=>setPendingDup(null),
                title: "Reassign ISRC",
                modalClasses: "tw-max-w-md tw-w-full tw-mx-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-white tw-text-sm tw-mb-3",
                            children: "This ISRC is currently assigned to:"
                        }),
                        pendingDup && pendingDup.matches.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-mb-4 tw-space-y-1.5 tw-max-h-32 tw-overflow-y-auto",
                            children: pendingDup.matches.map((m, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-bg-surfaceBlack90 tw-rounded tw-px-3 tw-py-2 tw-text-xs",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-text-white tw-font-medium",
                                            children: m.recordingTitle || "Untitled"
                                        }),
                                        m.artistName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-text-textSeal",
                                            children: m.artistName
                                        })
                                    ]
                                }, `${m.recordingTitle}-${i}`))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "tw-text-white tw-text-sm",
                            children: [
                                "Continuing will remove the ISRC from",
                                " ",
                                pendingDup && pendingDup.matches.length === 1 ? "that recording" : "those recordings",
                                " ",
                                "and assign it to",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: recordingTitle || "this recording"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-2 tw-mt-5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: ()=>setPendingDup(null)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Continue",
                                    onClick: ()=>{
                                        if (pendingDup) {
                                            commitIsrc(pendingDup.isrc, pendingDup.matches.filter((m)=>m.recordingId.length > 0));
                                            setPendingDup(null);
                                        }
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* ------------------------------------------------------------------------- */ /* Contributions (seeded list; add / edit / remove)                          */ /* ------------------------------------------------------------------------- */ const $7ba18110fd51242f$var$MassContributionsEditModal = ({ recordingTitle: recordingTitle, initial: initial, row: row, contributionOptions: contributionOptions, availableAliases: availableAliases, onClose: onClose, onSave: onSave })=>{
    const [entries, setEntries] = (0, $acw62.useState)(initial);
    // The role being added (opens ContributionDetailModal in 'add' mode).
    const [pendingRole, setPendingRole] = (0, $acw62.useState)(null);
    // The existing contribution being edited (index into entries).
    const [editingIndex, setEditingIndex] = (0, $acw62.useState)(null);
    // The contribution pending remove confirmation (index into entries).
    const [removeIndex, setRemoveIndex] = (0, $acw62.useState)(null);
    const detailOpen = pendingRole !== null || editingIndex !== null;
    const editingEntry = editingIndex !== null ? entries[editingIndex] : undefined;
    const editingNotes = editingEntry ? $7ba18110fd51242f$var$parseEvidenceNotes(editingEntry.confidencePattern) : {
        evidenceUrl: "",
        notes: ""
    };
    const closeDetail = ()=>{
        setPendingRole(null);
        setEditingIndex(null);
    };
    // Chip indicators, matching the recording edit form:
    //  - purple line  → the role carries a manual change recorded server-side
    //  - pulsing dot  → the role was added or altered in this session
    const manuallyChangedRoles = new Set(row.manuallyChangedContributionRoles ?? []);
    const original = $7ba18110fd51242f$export$580b5289238c00a3(row);
    const localChangeFor = (c)=>{
        const orig = original.find((o)=>o.contribution === c.contribution);
        if (!orig) return {
            changed: true,
            title: "Newly added contribution"
        };
        const changed = orig.confidenceCategory !== c.confidenceCategory || orig.confidencePattern !== c.confidencePattern;
        return {
            changed: changed,
            title: "Edited contribution"
        };
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: !detailOpen && removeIndex === null,
                onClose: onClose,
                title: "Edit Contributions",
                modalClasses: "tw-w-[560px] tw-max-w-[95vw]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: (0, $bb6d544802d60420$export$314105a17693dd98),
                            children: [
                                "Edit the contributions for \u201C",
                                recordingTitle,
                                "\u201D. Click a contribution to change its data quality or evidence."
                            ]
                        }),
                        entries.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-flex-wrap tw-gap-1.5",
                            children: entries.map((cont, originalIndex)=>({
                                    cont: cont,
                                    originalIndex: originalIndex
                                })).sort((a, b)=>parseInt(a.cont.confidenceCategory ?? "1", 10) - parseInt(b.cont.confidenceCategory ?? "1", 10)).map(({ cont: cont, originalIndex: originalIndex })=>{
                                const local = localChangeFor(cont);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$1fcd028c38eb96f), {
                                    role: cont.contribution ?? "",
                                    confidenceCategory: cont.confidenceCategory,
                                    edited: manuallyChangedRoles.has(cont.contribution ?? ""),
                                    changed: local.changed,
                                    changedTitle: local.title,
                                    onSelect: ()=>setEditingIndex(originalIndex),
                                    onRemove: entries.length > 1 ? ()=>setRemoveIndex(originalIndex) : undefined
                                }, cont.contribution);
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                    children: "Add a contribution"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7ba18110fd51242f$var$SearchSelect, {
                                    options: contributionOptions,
                                    exclude: entries.map((e)=>e.contribution),
                                    onSelect: (role)=>setPendingRole(role),
                                    placeholder: "Search or select contribution\u2026"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: onClose
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Save",
                                    disabled: entries.length === 0,
                                    onClick: ()=>onSave(entries)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $225524c18db7a507$export$ad612c67e8fe7176), {
                isOpen: detailOpen,
                mode: editingIndex !== null ? "edit" : "add",
                initialValue: editingIndex !== null && editingEntry ? {
                    contributionName: editingEntry.contribution,
                    confidenceCategory: editingEntry.confidenceCategory ?? "1",
                    evidenceUrl: editingNotes.evidenceUrl,
                    notes: editingNotes.notes,
                    personaId: editingEntry.personaId ?? ""
                } : {
                    contributionName: pendingRole ?? ""
                },
                aliases: availableAliases,
                onClose: closeDetail,
                onSave: (payload)=>{
                    setEntries((prev)=>{
                        if (editingIndex !== null) return prev.map((e, i)=>i === editingIndex ? payload : e);
                        return [
                            ...prev,
                            payload
                        ];
                    });
                    closeDetail();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: removeIndex !== null,
                onClose: ()=>setRemoveIndex(null),
                title: "Remove Contribution",
                modalClasses: "tw-max-w-sm tw-w-full tw-mx-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "tw-text-white tw-text-sm tw-mb-6",
                            children: [
                                "Are you sure you want to remove",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: removeIndex !== null ? $7ba18110fd51242f$var$capitalize(entries[removeIndex]?.contribution ?? "") : ""
                                }),
                                " ",
                                "from \u201C",
                                recordingTitle,
                                "\u201D?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: ()=>setRemoveIndex(null)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Remove",
                                    onClick: ()=>{
                                        if (removeIndex !== null) {
                                            const idx = removeIndex;
                                            setEntries((prev)=>prev.filter((_, i)=>i !== idx));
                                            setRemoveIndex(null);
                                        }
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* ------------------------------------------------------------------------- */ /* Artists (seeded list; add existing / create new / remove)                 */ /* ------------------------------------------------------------------------- */ const $7ba18110fd51242f$var$MassArtistsEditModal = ({ recordingTitle: recordingTitle, initial: initial, row: row, userId: userId, parentRecordingId: parentRecordingId, onClose: onClose, onSave: onSave })=>{
    // Demoted artists stay in `entries` as tombstones — the save layer needs them
    // to emit the `delete` + `nfa` edit — but they are filtered out of the list
    // below, which only ever shows featured / other-featured artists.
    const [entries, setEntries] = (0, $acw62.useState)(initial);
    const [addingArtist, setAddingArtist] = (0, $acw62.useState)(false);
    // An existing artist picked from search, awaiting the featured-status choice.
    const [pendingArtist, setPendingArtist] = (0, $acw62.useState)(null);
    // Identity of the artist whose remove/demote confirmation is open.
    const [actionKey, setActionKey] = (0, $acw62.useState)(null);
    const keyOf = (a)=>a.id || a.name;
    const visible = entries.filter((e)=>!e.demoted);
    const actionArtist = actionKey === null ? null : entries.find((e)=>keyOf(e) === actionKey) ?? null;
    // Chips carry the purple manual-change line when the artist was added by a
    // previous manual change (4.5.2 overlay) or added locally in this session —
    // the same rule the recording edit form applies.
    const originalKeys = new Set((0, $31ef1c70c0117c31$export$d22120ed4d368425)(row).map(keyOf));
    const addedIds = new Set(row.manuallyAddedArtistIds ?? []);
    const addedNames = new Set(row.manuallyAddedArtistNames ?? []);
    const isEdited = (a)=>!originalKeys.has(keyOf(a)) || !!a.id && addedIds.has(a.id) || addedNames.has(a.name);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: !addingArtist && actionKey === null && pendingArtist === null,
                onClose: onClose,
                title: "Edit Artists",
                modalClasses: "tw-w-[560px] tw-max-w-[95vw]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-2 tw-flex tw-flex-col tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: (0, $bb6d544802d60420$export$314105a17693dd98),
                            children: [
                                "Edit the artists for \u201C",
                                recordingTitle,
                                "\u201D. At least one artist is required. As on the recording edit form, removing an existing artist offers demote-to-non-featured or full removal; a demoted artist leaves this list."
                            ]
                        }),
                        visible.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-flex-wrap tw-gap-1.5",
                            children: visible.map((a)=>{
                                // Last-artist guard: a recording must keep ≥1 artist.
                                const removable = visible.length > 1;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$92a172cc67aad148), {
                                    name: a.name,
                                    edited: isEdited(a),
                                    removeTitle: a.pendingCreate ? "Remove artist" : "Demote or remove artist",
                                    onRemove: removable ? ()=>{
                                        if (a.pendingCreate) // Never linked — just drop it locally.
                                        setEntries((prev)=>prev.filter((e)=>keyOf(e) !== keyOf(a)));
                                        else setActionKey(keyOf(a));
                                    } : undefined
                                }, keyOf(a));
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $bb6d544802d60420$export$245c09d1fdadc2df),
                                    children: "Search existing artists"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $814d90124c52a773$export$d95759e348d01a1a), {
                                    userId: userId,
                                    parentRecordingId: parentRecordingId,
                                    existing: entries,
                                    onSelect: (artist)=>setPendingArtist(artist)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-justify-start",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                icon: "plus",
                                label: "Create new artist",
                                onClick: ()=>setAddingArtist(true)
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $bb6d544802d60420$export$d9bb8578fc3ff40f),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: onClose
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Save",
                                    disabled: visible.length === 0,
                                    onClick: ()=>onSave(entries)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $814d90124c52a773$export$8ccaf6184c7ddac2), {
                artistName: actionArtist?.name ?? null,
                onCancel: ()=>setActionKey(null),
                onDemote: ()=>{
                    setEntries((prev)=>prev.map((e)=>keyOf(e) === actionKey ? {
                                ...e,
                                isFeatured: false,
                                featuredStatus: "nf",
                                // Demoted artists drop out of the list (it only shows
                                // featured / other-featured artists) but stay in the value
                                // as tombstones — the flag is the only signal the save
                                // layer has to emit the delete+nfa edit instead of a plain
                                // removal.
                                demoted: true
                            } : e));
                    setActionKey(null);
                },
                onRemove: ()=>{
                    setEntries((prev)=>prev.filter((e)=>keyOf(e) !== actionKey));
                    setActionKey(null);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $814d90124c52a773$export$3cbdf2bb01a18fa5), {
                pending: pendingArtist,
                onCancel: ()=>setPendingArtist(null),
                onAdd: (entry)=>{
                    setEntries((prev)=>{
                        const existing = prev.find((e)=>e.name === entry.name || !!e.id && e.id === entry.id);
                        // Re-adding an artist that was demoted in this session undoes the
                        // demotion rather than being a no-op against the tombstone.
                        if (existing) return existing.demoted ? prev.map((e)=>e === existing ? {
                                ...e,
                                ...entry,
                                demoted: undefined
                            } : e) : prev;
                        return [
                            ...prev,
                            entry
                        ];
                    });
                    setPendingArtist(null);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b44378a47b84f9b0$export$6327d397dd9387a), {
                isOpen: addingArtist,
                userId: userId,
                parentRecordingId: parentRecordingId,
                onClose: ()=>setAddingArtist(false),
                onAdd: (entry)=>{
                    setEntries((prev)=>[
                            ...prev,
                            entry
                        ]);
                    setAddingArtist(false);
                }
            })
        ]
    });
};
const $7ba18110fd51242f$export$d2f5a4651416d26c = ({ field: field, row: row, pending: pending, availableContributions: availableContributions, availableAliases: availableAliases, userId: userId, onClose: onClose, onSave: onSave, onReassignIsrc: onReassignIsrc })=>{
    const title = row.title || "(untitled)";
    switch(field){
        case "live":
            {
                // Write-once gate: an already-set live descriptor is only editable once
                // it has been manually changed before (row.liveEditedManually). A pending
                // in-session edit keeps it editable so the user can revise their change.
                const liveLocked = typeof pending !== "string" && !(0, $e353c670efa3bb12$export$a58c1d5525adff3f)((0, $e353c670efa3bb12$export$6a8f182e25b88c10)(row.live), !!row.liveEditedManually);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7ba18110fd51242f$var$MassLiveEditModal, {
                    recordingTitle: title,
                    initial: typeof pending === "string" ? pending : (0, $e353c670efa3bb12$export$6a8f182e25b88c10)(row.live),
                    locked: liveLocked,
                    onClose: onClose,
                    onSave: (descriptor)=>onSave("live", descriptor)
                });
            }
        case "version":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7ba18110fd51242f$var$MassVersionEditModal, {
                recordingTitle: title,
                initial: Array.isArray(pending) ? pending : row.versionsArray ?? [],
                onClose: onClose,
                onSave: (versions)=>onSave("version", versions)
            });
        case "contributions":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7ba18110fd51242f$var$MassContributionsEditModal, {
                recordingTitle: title,
                initial: Array.isArray(pending) ? pending : $7ba18110fd51242f$export$580b5289238c00a3(row),
                row: row,
                contributionOptions: availableContributions,
                availableAliases: availableAliases,
                onClose: onClose,
                onSave: (entries)=>onSave("contributions", entries)
            });
        case "artist":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7ba18110fd51242f$var$MassArtistsEditModal, {
                recordingTitle: title,
                initial: Array.isArray(pending) ? pending : (0, $31ef1c70c0117c31$export$d22120ed4d368425)(row),
                row: row,
                userId: userId,
                parentRecordingId: row.id,
                onClose: onClose,
                onSave: (entries)=>onSave("artist", entries)
            });
        case "isrcs":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7ba18110fd51242f$var$MassIsrcEditModal, {
                recordingTitle: title,
                initial: Array.isArray(pending) ? pending : row.isrcsArray ?? [],
                row: row,
                userId: userId,
                parentRecordingId: row.id,
                onClose: onClose,
                onSave: (isrcs)=>onSave("isrcs", isrcs),
                onReassign: onReassignIsrc
            });
        default:
            return null;
    }
};
var $7ba18110fd51242f$export$2e2bcd8739ae039 = $7ba18110fd51242f$export$d2f5a4651416d26c;




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5415d98bde6b29f1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const $5415d98bde6b29f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-alert", $5415d98bde6b29f1$export$3efd853dbb351e94);






/**
 * Mass-edit summary / confirmation modal.
 *
 * Before anything is applied, the user reviews every pending change grouped by
 * recording (field: before → after). "Confirm" hands off to the batch apply
 * (see massEditBatch.ts), which sends one request per endpoint — correct
 * recording data, change associated artists, manage contributions — each
 * carrying a list of per-recording envelopes (contract §3.1).
 *
 * Because the batch endpoints report success per recording, a partial failure
 * leaves this modal open: the recordings that saved disappear from the list and
 * the ones that failed stay, annotated with the reason the backend gave.
 */ const $02ae4f076c1d4517$var$capitalize = (s)=>s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
const $02ae4f076c1d4517$var$DASH = "\u2014";
/** Build the human-readable before/after list for one recording. */ function $02ae4f076c1d4517$var$describeRow(row, edits) {
    const changes = [];
    if (edits.title !== undefined) changes.push({
        field: "title",
        label: "Recording Title",
        before: row.title || $02ae4f076c1d4517$var$DASH,
        after: edits.title || $02ae4f076c1d4517$var$DASH
    });
    if (edits.duration !== undefined) changes.push({
        field: "duration",
        label: "Duration",
        before: row.duration || $02ae4f076c1d4517$var$DASH,
        after: edits.duration || $02ae4f076c1d4517$var$DASH
    });
    if (edits.live !== undefined) {
        const beforeDescriptor = (0, $e353c670efa3bb12$export$6a8f182e25b88c10)(row.live);
        changes.push({
            field: "live",
            label: "Live",
            before: row.isLive ? beforeDescriptor ? `Live \xb7 ${beforeDescriptor}` : "Live" : "Not live",
            after: edits.live.trim() ? `Live \xb7 ${edits.live.trim()}` : "Not live"
        });
    }
    if (edits.version !== undefined) changes.push({
        field: "version",
        label: "Version",
        before: (row.versionsArray ?? []).join(", ") || $02ae4f076c1d4517$var$DASH,
        after: edits.version.join(", ") || $02ae4f076c1d4517$var$DASH
    });
    if (edits.isrcs !== undefined) changes.push({
        field: "isrcs",
        label: "ISRCs",
        before: (row.isrcsArray ?? []).join(", ") || $02ae4f076c1d4517$var$DASH,
        after: edits.isrcs.join(", ") || $02ae4f076c1d4517$var$DASH
    });
    if (edits.contributions !== undefined) changes.push({
        field: "contributions",
        label: "Contributions",
        before: (row.contributions ?? []).map((c)=>$02ae4f076c1d4517$var$capitalize(c.contribution)).join(", ") || $02ae4f076c1d4517$var$DASH,
        after: edits.contributions.map((c)=>$02ae4f076c1d4517$var$capitalize(c.contribution)).join(", ") || $02ae4f076c1d4517$var$DASH
    });
    if (edits.artist !== undefined) changes.push({
        field: "artist",
        label: "Artists",
        before: (0, $31ef1c70c0117c31$export$d22120ed4d368425)(row).map((a)=>a.name).join(", ") || (row.artist ?? $02ae4f076c1d4517$var$DASH),
        // Demoted artists are tombstones in the pending value — they still get a
        // delete+nfa edit, but the list only ever shows featured / other-featured
        // artists, so they drop out of the "after" just as they do in the editor.
        after: edits.artist.filter((a)=>!a.demoted).map((a)=>a.name).join(", ") || $02ae4f076c1d4517$var$DASH
    });
    return changes;
}
const $02ae4f076c1d4517$export$2803f1e68ef5d8b6 = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm, edits: edits, rows: rows, onEditChange: onEditChange, onRemoveChange: onRemoveChange, isSaving: isSaving = false, errorsByRecording: errorsByRecording, fatalError: fatalError })=>{
    const { recordings: recordings, fieldChangeCount: fieldChangeCount } = (0, $acw62.useMemo)(()=>{
        const rowById = new Map(rows.map((r)=>[
                r.id,
                r
            ]));
        const result = [];
        let count = 0;
        Object.entries(edits).forEach(([id, rowEdits])=>{
            const row = rowById.get(id);
            if (!row) return;
            const changes = $02ae4f076c1d4517$var$describeRow(row, rowEdits);
            if (changes.length === 0) return;
            count += changes.length;
            result.push({
                id: id,
                title: row.title || "(untitled)",
                changes: changes
            });
        });
        result.sort((a, b)=>a.title.localeCompare(b.title));
        return {
            recordings: result,
            fieldChangeCount: count
        };
    }, [
        edits,
        rows
    ]);
    const failedCount = recordings.filter((r)=>(errorsByRecording?.[r.id]?.length ?? 0) > 0).length;
    const hasFailures = failedCount > 0 || !!fatalError;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: onClose,
        title: "Review mass edit",
        modalClasses: "tw-w-[820px] tw-max-w-[97vw]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "tw-text-sm tw-text-textDove",
                    children: recordings.length === 0 ? "No changes to apply." : hasFailures ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: failedCount
                            }),
                            " recording",
                            failedCount === 1 ? "" : "s",
                            " could not be saved. The changes below are still pending \u2014 fix them and confirm again, or remove them."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "You are about to apply ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: fieldChangeCount
                            }),
                            " field change",
                            fieldChangeCount === 1 ? "" : "s",
                            " across",
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: recordings.length
                            }),
                            " recording",
                            recordings.length === 1 ? "" : "s",
                            "."
                        ]
                    })
                }),
                fatalError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-rounded-xl tw-border tw-border-red-700/60 tw-bg-red-900/20 tw-p-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-text-xs tw-text-red-200",
                        children: fatalError
                    })
                }),
                recordings.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-max-h-[55vh] tw-overflow-y-auto tw-flex tw-flex-col tw-gap-4 tw-pr-1",
                    children: recordings.map((rec)=>{
                        const recErrors = errorsByRecording?.[rec.id] ?? [];
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-rounded-xl tw-border tw-bg-surfaceBlack90 tw-p-4", recErrors.length > 0 ? "tw-border-red-700/70" : "tw-border-gray-700"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: "tw-text-white tw-text-sm tw-font-semibold tw-mb-3",
                                    children: rec.title
                                }),
                                recErrors.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    className: "tw-mb-3 tw-flex tw-flex-col tw-gap-1",
                                    children: recErrors.map((message)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "tw-text-xs tw-text-red-300 tw-flex tw-gap-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                                    className: "tw-w-3.5 tw-h-3.5 tw-shrink-0 tw-mt-px"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: message
                                                })
                                            ]
                                        }, message))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-overflow-x-auto",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        className: "tw-w-full tw-text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: "tw-text-left tw-text-textDove tw-border-b tw-border-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "tw-py-1.5 tw-pr-3 tw-font-medium tw-w-[150px]",
                                                            children: "Field"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "tw-py-1.5 tw-pr-3 tw-font-medium",
                                                            children: "Before"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "tw-py-1.5 tw-pr-3 tw-font-medium",
                                                            children: "After"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "tw-py-1.5 tw-font-medium tw-w-[96px] tw-text-right",
                                                            children: "Actions"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                children: rec.changes.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "tw-border-b tw-border-gray-800 tw-align-top last:tw-border-0",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "tw-py-2 tw-pr-3 tw-text-textDove",
                                                                children: c.label
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "tw-py-2 tw-pr-3 tw-text-textSeal tw-line-through",
                                                                children: c.before
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "tw-py-2 tw-pr-3 tw-text-white",
                                                                children: c.after
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "tw-py-2",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "tw-flex tw-items-center tw-justify-end tw-gap-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            "aria-label": `Edit ${c.label}`,
                                                                            title: "Edit change",
                                                                            disabled: isSaving,
                                                                            className: "tw-p-1 tw-rounded hover:tw-bg-gray-700 tw-text-textDove hover:tw-text-white disabled:tw-opacity-50",
                                                                            onClick: ()=>onEditChange(rec.id, c.field),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                                                className: "tw-w-3.5 tw-h-3.5"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            "aria-label": `Remove ${c.label} change`,
                                                                            title: "Remove change",
                                                                            disabled: isSaving,
                                                                            className: "tw-p-1 tw-rounded hover:tw-bg-gray-700 tw-text-textDove hover:tw-text-white disabled:tw-opacity-50",
                                                                            onClick: ()=>onRemoveChange(rec.id, c.field),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                                className: "tw-w-3.5 tw-h-3.5"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, c.label))
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, rec.id);
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-justify-end tw-gap-3 tw-pt-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Back",
                            disabled: isSaving,
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: isSaving ? "Saving\u2026" : `${hasFailures ? "Retry" : "Confirm"} ${fieldChangeCount} change${fieldChangeCount === 1 ? "" : "s"}`,
                            disabled: recordings.length === 0 || isSaving,
                            onClick: onConfirm
                        })
                    ]
                })
            ]
        })
    });
};
var $02ae4f076c1d4517$export$2e2bcd8739ae039 = $02ae4f076c1d4517$export$2803f1e68ef5d8b6;








/* eslint-disable jsx-a11y/no-autofocus */ /* eslint-disable jsx-a11y/label-has-associated-control */ 

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");













// ArtistEntry / ArtistMember / FeaturedStatus imported from ./ArtistEditorModal.
// ── Manually-edited indicators (sourced from contract § 4.5.2 / 4.5.3) ──
/** Class applied to any element (chip, pill) that carries a manual change.
 *  Adds the purple left line via a ::before pseudo-element so it stays at full
 *  height regardless of border-radius / padding / disabled state. Shared with
 *  the discography row indicator — see manualChangeIndicator.ts / global.css. */ const $7c320e41e081b01e$var$EDITED_LEFT_BORDER_CLASS = (0, $0fd6d64054ffdc01$export$ac9987bd29f3f58f);
// liveToString is imported from ../../../utils/recordingValidators (shared).
// ── Shared form-field styling ──
// Field presentation lives in ./formStyles, which every editing surface reads
// from — this form, the mass-edit quick-edit modals and the bulk-edit builder —
// so a field looks the same whichever one the user came in through.
const $7c320e41e081b01e$var$SELECT_BASE_CLASS = (0, $bb6d544802d60420$export$69aed5ace27d1255);
const $7c320e41e081b01e$var$selectTextClass = (0, $bb6d544802d60420$export$f7148014ed42e56b);
/** A purple pulsating dot marking a value that has been changed locally but
 *  not yet saved. Positioned at the top-right of its relatively-positioned
 *  parent. */ const $7c320e41e081b01e$var$ChangedDot = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "aria-hidden": true,
        title: "Unsaved change",
        className: "tw-absolute -tw-top-1 -tw-right-1 tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-surfacePurple tw-border tw-border-gray-900 tw-animate-pulse-slow tw-z-10 tw-pointer-events-none"
    });
/** Wraps an `<input>` / `<select>` (which can't host ::before) so the purple
 *  line renders on the wrapper instead. Renders the children unchanged when
 *  not edited/changed so untouched fields keep their original layout.
 *  - `edited`  → persisted manual change: purple left line + hover tooltip.
 *  - `changed` → unsaved local change: purple pulsating dot.
 *  Shows an instant-display tooltip on hover (defaults to "Manually Changed",
 *  but callers can pass a longer string e.g. for the live-note display). */ const $7c320e41e081b01e$var$ManualChangeWrap = ({ edited: edited, changed: changed = false, title: title, children: children })=>{
    const [hover, setHover] = (0, $acw62.useState)(false);
    if (!edited && !changed) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: edited ? (0, $0fd6d64054ffdc01$export$ac9987bd29f3f58f) : "tw-relative",
        onMouseEnter: ()=>setHover(true),
        onMouseLeave: ()=>setHover(false),
        children: [
            children,
            changed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c320e41e081b01e$var$ChangedDot, {}),
            edited && hover && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$710d1af9aabb2280), {
                text: title ?? (0, $473dabb7bb223c2d$export$84e9997ca939742d)
            })
        ]
    });
};
/** Two-option segmented switch (lime fill on the selected side). The shared
 *  implementation lives in ./formStyles; aliased here because this form calls it
 *  by its original name in several places. */ const $7c320e41e081b01e$var$WmcSegmentedToggle = (0, $bb6d544802d60420$export$32cde37ade98aa4f);
/** Build a ResponseError-shaped object (what the generated API client throws on
 *  non-2xx) carrying a JSON body, so friendlySaveError parses it like a real one. */ const $7c320e41e081b01e$var$makeKnownErrorResponse = (body)=>({
        name: "ResponseError",
        response: new Response(JSON.stringify(body), {
            status: 400,
            headers: {
                "Content-Type": "application/json"
            }
        })
    });
const $7c320e41e081b01e$var$KNOWN_ERROR_TEST_SCENARIOS = [
    {
        label: "Field validation",
        makeError: ()=>$7c320e41e081b01e$var$makeKnownErrorResponse({
                payload: {
                    isrc: [
                        "This field may not be null."
                    ],
                    duration: [
                        "This field is required."
                    ]
                }
            })
    },
    {
        label: "Duplicate value",
        makeError: ()=>$7c320e41e081b01e$var$makeKnownErrorResponse({
                errors: [
                    "DynamoDB: duplicate ISRC detected"
                ]
            })
    },
    {
        label: "Permission denied",
        makeError: ()=>$7c320e41e081b01e$var$makeKnownErrorResponse({
                errors: [
                    "AccessDenied: not authorized to perform this operation"
                ]
            })
    },
    {
        label: "Graph sync failure",
        makeError: ()=>$7c320e41e081b01e$var$makeKnownErrorResponse({
                errors: [
                    "Gremlin error: expecting value while updating graph edges"
                ]
            })
    },
    {
        label: "Search index failure",
        makeError: ()=>$7c320e41e081b01e$var$makeKnownErrorResponse({
                errors: [
                    "OpenSearch index update failed"
                ]
            })
    },
    {
        label: "Duration already set",
        makeError: ()=>$7c320e41e081b01e$var$makeKnownErrorResponse({
                error: "Duration is already set by the system."
            })
    },
    {
        label: "AWS validation",
        makeError: ()=>$7c320e41e081b01e$var$makeKnownErrorResponse({
                errors: [
                    "ValidationException: invalid attribute value"
                ]
            })
    },
    {
        label: "Generic fallback",
        makeError: ()=>new Error("Unexpected failure in the save pipeline")
    }
];
// MultiValueAddField moved to ./ChangeReleaseModal (shared).
// Confidence category styling lives with the shared chip
// (getContributionPillStyle in ./manualChangeChip).
function $7c320e41e081b01e$var$parseContributionEvidenceNotes(confidencePattern) {
    if (!confidencePattern?.trim()) return {
        evidenceUrl: "",
        notes: ""
    };
    try {
        const o = JSON.parse(confidencePattern);
        if (typeof o === "object" && o && !Array.isArray(o)) {
            const obj = o;
            return {
                evidenceUrl: typeof obj.evidenceUrl === "string" ? obj.evidenceUrl : "",
                notes: typeof obj.notes === "string" ? obj.notes : ""
            };
        }
    } catch  {
    // ignore
    }
    return {
        evidenceUrl: "",
        notes: ""
    };
}
const $7c320e41e081b01e$export$92bd65961bd57ee8 = /*#__PURE__*/ (0, $acw62.forwardRef)(function RecordingEditForm({ row: row, onSave: onSave, onCancel: onCancel, stacked: stacked = false, hideFooter: hideFooter = false, releaseOnly: releaseOnly = false, userId: userId, availableFormats: availableFormats = [], availableTypes: availableTypes = [], availableContributions: availableContributions = [], availableArtists: availableArtists = [] }, ref) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [formData, setFormData] = (0, $acw62.useState)({});
    const [labels, setLabels] = (0, $acw62.useState)([]);
    const [catNumbers, setCatNumbers] = (0, $acw62.useState)([]);
    const [versions, setVersions] = (0, $acw62.useState)([]);
    const [isrcs, setIsrcs] = (0, $acw62.useState)([]);
    const [artists, setArtists] = (0, $acw62.useState)([]);
    const [contributions, setContributions] = (0, $acw62.useState)([]);
    const [showReleaseCorrectionModal, setShowReleaseCorrectionModal] = (0, $acw62.useState)(false);
    const [showChangeReleaseModal, setShowChangeReleaseModal] = (0, $acw62.useState)(false);
    // Release-flow state moved to ./ChangeReleaseModal (shared).
    const [isReleaseEditable, setIsReleaseEditable] = (0, $acw62.useState)(false);
    // The recording section is always editable (no "Edit Recording Details"
    // step); Save/Cancel CTAs appear only once something changes. The linked
    // release section keeps its own explicit edit step (isReleaseEditable).
    const isRecordingEditable = true;
    const [recordingSaveLoading, setRecordingSaveLoading] = (0, $acw62.useState)(false);
    // Friendly error messages shown above the Save CTA when a save API call fails.
    const [recordingSaveError, setRecordingSaveError] = (0, $acw62.useState)(null);
    const [releaseSaveError, setReleaseSaveError] = (0, $acw62.useState)(null);
    // KNOWN_ERROR_TEST demo (sprint-review only — remove after the review): cycles
    // synthetic save failures through friendlySaveError to preview every message.
    const knownErrorTestEnabled = typeof window !== "undefined" && new URLSearchParams(window.location.search).get("KNOWN_ERROR_TEST") === "true";
    const [simulateErrorIndex, setSimulateErrorIndex] = (0, $acw62.useState)(0);
    const [showRevertModal, setShowRevertModal] = (0, $acw62.useState)(false);
    const [revertTarget, setRevertTarget] = (0, $acw62.useState)(null);
    // Release-flow state moved to ./ChangeReleaseModal (shared).
    const [yearError, setYearError] = (0, $acw62.useState)(null);
    const [showLiveToYesModal, setShowLiveToYesModal] = (0, $acw62.useState)(false);
    const [liveToYesNote, setLiveToYesNote] = (0, $acw62.useState)("");
    const [isrcFormatError, setIsrcFormatError] = (0, $acw62.useState)(null);
    // Inline "add item" inputs (ISRC / Label / Catalogue Number). The input is
    // hidden until the user clicks "Add {item}"; while open, the Add button is
    // replaced with Create / Cancel CTAs. Tracked so "Save Changes" can warn
    // when an item is still being entered (not yet created/cancelled).
    const [isrcInputOpen, setIsrcInputOpen] = (0, $acw62.useState)(false);
    const [isrcInputValue, setIsrcInputValue] = (0, $acw62.useState)("");
    const [labelInputOpen, setLabelInputOpen] = (0, $acw62.useState)(false);
    const [labelInputValue, setLabelInputValue] = (0, $acw62.useState)("");
    const [catNoInputOpen, setCatNoInputOpen] = (0, $acw62.useState)(false);
    const [catNoInputValue, setCatNoInputValue] = (0, $acw62.useState)("");
    // When a save is attempted while an inline add-item input is still open,
    // this holds the item name ("ISRC" / "label" / "catalogue number") so the
    // warning modal can tell the user to create or cancel it first.
    const [unsavedItemWarning, setUnsavedItemWarning] = (0, $acw62.useState)(null);
    const [pendingDuplicateIsrc, setPendingDuplicateIsrc] = (0, $acw62.useState)(null);
    const [pendingDuplicateMatches, setPendingDuplicateMatches] = (0, $acw62.useState)([]);
    // Maps ISRC → all matching recordings it's being reassigned from
    const [confirmedDuplicateIsrcs, setConfirmedDuplicateIsrcs] = (0, $acw62.useState)({});
    const [showCreateArtist, setShowCreateArtist] = (0, $acw62.useState)(false);
    // Create-artist state moved to ./ArtistEditorModal (shared).
    const [pendingArtistName, setPendingArtistName] = (0, $acw62.useState)(null);
    const [pendingArtistId, setPendingArtistId] = (0, $acw62.useState)(null);
    const [pendingArtistMembers, setPendingArtistMembers] = (0, $acw62.useState)([]);
    const [pendingArtistFeatured, setPendingArtistFeatured] = (0, $acw62.useState)("fa");
    const [editingVersionIndex, setEditingVersionIndex] = (0, $acw62.useState)(null);
    const [artistSearchQuery, setArtistSearchQuery] = (0, $acw62.useState)("");
    const [artistDropdownOpen, setArtistDropdownOpen] = (0, $acw62.useState)(false);
    const [artistLookupResults, setArtistLookupResults] = (0, $acw62.useState)([]);
    const [artistLookupLoading, setArtistLookupLoading] = (0, $acw62.useState)(false);
    const [artistsError, setArtistsError] = (0, $acw62.useState)(null);
    const [titleError, setTitleError] = (0, $acw62.useState)(null);
    const [versionsError, setVersionsError] = (0, $acw62.useState)(null);
    const [labelsError, setLabelsError] = (0, $acw62.useState)(null);
    const [catNumbersError, setCatNumbersError] = (0, $acw62.useState)(null);
    const [artistActionModalIndex, setArtistActionModalIndex] = (0, $acw62.useState)(null);
    const [artistActionConfirm, setArtistActionConfirm] = (0, $acw62.useState)(null);
    const [demotedArtists, setDemotedArtists] = (0, $acw62.useState)([]);
    const [showRemoveContributionModal, setShowRemoveContributionModal] = (0, $acw62.useState)(null);
    const [addContributionDropdownOpen, setAddContributionDropdownOpen] = (0, $acw62.useState)(false);
    const [contributionSearchQuery, setContributionSearchQuery] = (0, $acw62.useState)("");
    const [contributionCategoryOpenIndex, setContributionCategoryOpenIndex] = (0, $acw62.useState)(null);
    const [categoryDropdownRect, setCategoryDropdownRect] = (0, $acw62.useState)(null);
    const [showContributionModal, setShowContributionModal] = (0, $acw62.useState)(false);
    const [contributionModalContext, setContributionModalContext] = (0, $acw62.useState)(null);
    const [contributionModalForm, setContributionModalForm] = (0, $acw62.useState)({
        contributionName: "",
        confidenceCategory: "1",
        evidenceUrl: "",
        notes: "",
        personaId: ""
    });
    const [clientAliases, setClientAliases] = (0, $acw62.useState)([]);
    const [clientAliasesLoading, setClientAliasesLoading] = (0, $acw62.useState)(false);
    const [releaseSaveLoading, setReleaseSaveLoading] = (0, $acw62.useState)(false);
    // Manual-change overlays (contract § 4.5.2 / 4.5.3). Populated when the
    // modal opens for a row that has manual edits.
    const [editedRecording, setEditedRecording] = (0, $acw62.useState)(null);
    const [editedRelease, setEditedRelease] = (0, $acw62.useState)(null);
    // Bumped after every successful save so the manual-change overlay fetch
    // re-runs without needing to close + reopen the modal.
    const [editsVersion, setEditsVersion] = (0, $acw62.useState)(0);
    const [originalValues, setOriginalValues] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const validCount = artists.filter((a)=>a.name.trim()).length;
        if (validCount > 0 && artistsError) setArtistsError(null);
    }, [
        artists,
        artistsError
    ]);
    // Fetch the manual-changes overlay for the recording + release on modal
    // open (contract 4.5.2 / 4.5.3). Failures are non-fatal — the form just
    // renders without the purple-line / dot indicators.
    (0, $acw62.useEffect)(()=>{
        if (!row?.id || !userId) {
            setEditedRecording(null);
            setEditedRelease(null);
            return;
        }
        let cancelled = false;
        (async ()=>{
            const recordingPromise = api.recordingManualChangesRecordingManualChangesResponse({
                userId: userId,
                parentRecordingId: row.id,
                documentId: row.documentId
            }).catch((err)=>{
                console.warn("recording manual-changes lookup failed", err);
                return null;
            });
            const releasePromise = row.earliestParentReleaseId ? api.releaseManualChangesReleaseManualChangesResponse({
                userId: userId,
                releaseId: row.earliestParentReleaseId,
                recordingId: row.id,
                documentId: row.documentId
            }).catch((err)=>{
                console.warn("release manual-changes lookup failed", err);
                return null;
            }) : Promise.resolve(null);
            const [recordingResp, releaseResp] = await Promise.all([
                recordingPromise,
                releasePromise
            ]);
            if (cancelled) return;
            setEditedRecording(recordingResp ?? null);
            setEditedRelease(releaseResp ?? null);
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        api,
        userId,
        row?.id,
        row?.documentId,
        row?.earliestParentReleaseId,
        editsVersion
    ]);
    // Helper lookups derived from the manual-changes responses ──────────────
    const editedRecordingFields = editedRecording?.fields ?? {};
    const editedReleaseFields = editedRelease?.fields ?? {};
    // True when a top-level scalar field is present (non-undefined) in either
    // response. We can't use `key in obj` because the OpenAPI generator
    // populates every optional property with `undefined` when missing, which
    // makes `'duration' in fields` true even when the BE didn't return it.
    const isFieldEdited = (key)=>{
        return editedRecordingFields[key] != null || editedReleaseFields[key] != null;
    };
    // Collect values flagged with op="add" for a multi-value field on either
    // the recording or release response. We match chips by value (per user
    // direction: "we'll be able to match it on the value").
    const addedValuesFor = (field)=>{
        const out = new Set();
        const fromRec = editedRecordingFields[field];
        const fromRel = editedReleaseFields[field];
        for (const src of [
            fromRec,
            fromRel
        ]){
            const items = src?.items ?? [];
            for (const it of items)if (it.op === "add" && typeof it.value === "string") out.add(it.value);
        }
        return out;
    };
    // Artists added (op === "add") from the recording response. We track both
    // the artist_id and the stageName so the chip render path can match either —
    // some legacy rows in `row.mainArtistsRaw` are bare strings (no id), so an
    // id-only match would miss them.
    const addedArtistIds = ()=>{
        const out = new Set();
        const items = editedRecording?.fields?.artists?.items ?? [];
        for (const it of items)if (it.op === "add" && it.artistId) out.add(it.artistId);
        return out;
    };
    const addedArtistNames = ()=>{
        const out = new Set();
        const items = editedRecording?.fields?.artists?.items ?? [];
        for (const it of items)if (it.op === "add" && it.stageName) out.add(it.stageName);
        return out;
    };
    // Contribution roles that were either added or edited.
    const editedContributionRoles = ()=>{
        const out = new Set();
        const items = editedRecording?.fields?.contributions?.items ?? [];
        for (const it of items)if ((it.op === "add" || it.op === "edit") && it.role) out.add(it.role);
        return out;
    };
    // For an edited/added contribution role, return the notes + evidence URL
    // captured in the manual-changes overlay. ADD ops carry them top-level;
    // EDIT ops carry them under `changes.{notes,source_url}.value`.
    // Returns undefined fields when the overlay didn't supply that sub-field
    // (the caller falls back to the legacy `confidencePattern` JSON).
    const getContributionOverlayForRole = (role)=>{
        const items = editedRecording?.fields?.contributions?.items ?? [];
        const match = items.find((it)=>it.role === role);
        if (!match) return null;
        const out = {};
        if (match.op === "add") {
            if (match.notes != null) out.notes = String(match.notes);
            if (match.sourceUrl != null) out.sourceUrl = String(match.sourceUrl);
        } else if (match.op === "edit" && match.changes) {
            if (match.changes.notes && match.changes.notes.value != null) out.notes = String(match.changes.notes.value);
            if (match.changes.sourceUrl && match.changes.sourceUrl.value != null) out.sourceUrl = String(match.changes.sourceUrl.value);
        }
        return out;
    };
    // Memoise the predicate sets for the render path.
    const addedArtistIdSet = addedArtistIds();
    const addedArtistNameSet = addedArtistNames();
    const editedContributionRoleSet = editedContributionRoles();
    const addedVersionValues = addedValuesFor("recordingVersion");
    const addedIsrcValues = addedValuesFor("isrcs");
    const addedLabelValues = addedValuesFor("releaseLabels");
    const addedCatNumberValues = addedValuesFor("catNumbers");
    // Debounced artist lookup via API (contract 4.4.1)
    (0, $acw62.useEffect)(()=>{
        if (!isRecordingEditable || !userId || !row?.id) return;
        const q = artistSearchQuery.trim();
        // Only call the API when the user has actually typed something — no
        // empty / wildcard searches.
        if (!q) {
            setArtistLookupResults([]);
            setArtistLookupLoading(false);
            return;
        }
        setArtistLookupLoading(true);
        const timer = setTimeout(async ()=>{
            try {
                const result = await api.lookupArtistsLookupArtistsResponse({
                    userId: userId,
                    parentRecordingId: row.id,
                    searchTerm: q
                });
                setArtistLookupResults((result.artists ?? []).map((a)=>({
                        id: a.id ?? "",
                        stageName: a.stageName ?? "",
                        members: (a.members ?? []).map((m)=>({
                                id: m.id ?? "",
                                stageName: m.stageName ?? ""
                            }))
                    })));
            } catch  {
                setArtistLookupResults([]);
            } finally{
                setArtistLookupLoading(false);
            }
        }, 300);
        return ()=>clearTimeout(timer);
    }, [
        artistSearchQuery,
        isRecordingEditable,
        userId,
        row?.id,
        api
    ]);
    // Create-artist lookup effects moved to ./ArtistEditorModal (shared).
    (0, $acw62.useEffect)(()=>{
        if (row) {
            setArtistsError(null);
            const normalizedYear = row.year ? row.year.length <= 4 ? row.year : row.year.slice(0, 4) : "";
            const initialFormData = {
                release: row.release,
                year: normalizedYear,
                format: row.format,
                mediaType: row.mediaType,
                title: row.title,
                duration: row.duration,
                // `live` is a string descriptor (empty string = not live). Replaces the
                // former boolean `isLive`; `is_live` is derived from its presence on save.
                // Normalised so legacy boolean values can't crash the string code paths.
                live: (0, $e353c670efa3bb12$export$6a8f182e25b88c10)(row.live),
                isFeatured: row.isFeatured
            };
            setFormData(initialFormData);
            // Use original arrays from the Row to avoid lossy comma-split round-trips
            const initialLabels = row.labelsArray ?? [];
            const initialCatNumbers = row.catNumbersArray ?? [];
            const initialVersions = row.versionsArray ?? [];
            const initialIsrcs = row.isrcsArray ?? [];
            const initialArtists = row.mainArtistsRaw && row.mainArtistsRaw.length > 0 ? row.mainArtistsRaw.map((item)=>{
                if (typeof item === "string") return {
                    name: item,
                    isFeatured: false,
                    featuredStatus: "nf"
                };
                const obj = item;
                return {
                    name: obj.stageName,
                    id: obj.id,
                    isFeatured: false,
                    featuredStatus: "nf",
                    type: obj.type
                };
            }) : row.artist ? row.artist.split(",").map((name)=>({
                    name: name.trim(),
                    isFeatured: false,
                    featuredStatus: "nf"
                })).filter((a)=>a.name) : [];
            const initialContributions = row.contributions && row.contributions.length > 0 ? row.contributions.map((c)=>({
                    contribution: c.contribution,
                    confidenceCategory: c.confidenceCategory ?? "1",
                    confidencePattern: c.confidencePattern ?? ""
                })) : [];
            setLabels(initialLabels);
            setCatNumbers(initialCatNumbers);
            setVersions(initialVersions);
            setIsrcs(initialIsrcs);
            setArtists(initialArtists);
            setDemotedArtists([]);
            setContributions(initialContributions);
            setShowCreateArtist(false);
            setArtistSearchQuery("");
            setArtistDropdownOpen(false);
            setContributionCategoryOpenIndex(null);
            setCategoryDropdownRect(null);
            setShowContributionModal(false);
            setContributionModalContext(null);
            setContributionSearchQuery("");
            // Reset inline add-item inputs
            setIsrcInputOpen(false);
            setIsrcInputValue("");
            setLabelInputOpen(false);
            setLabelInputValue("");
            setCatNoInputOpen(false);
            setCatNoInputValue("");
            // Store original values for revert functionality
            setOriginalValues({
                formData: initialFormData,
                labels: initialLabels,
                catNumbers: initialCatNumbers,
                versions: initialVersions,
                isrcs: initialIsrcs,
                artists: initialArtists,
                contributions: initialContributions
            });
            // Reset editing state when row changes
            setIsReleaseEditable(false);
            setRecordingSaveError(null);
            setReleaseSaveError(null);
            setYearError(null);
            setLabelsError(null);
            setCatNumbersError(null);
            setVersionsError(null);
        }
    }, [
        row
    ]);
    const saveHandlerRef = (0, $acw62.useRef)(()=>{});
    // Kept in sync each render (see assignment near the save handler ref) so the
    // imperative `isDirty()` reflects the latest recording/release dirty state.
    const isDirtyRef = (0, $acw62.useRef)(false);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            save: ()=>saveHandlerRef.current?.(),
            cancel: onCancel,
            isDirty: ()=>isDirtyRef.current
        }), [
        onCancel
    ]);
    if (!row || !originalValues) return null;
    // Helper function to check if a field has been modified
    const isFieldModified = (field)=>{
        if (!originalValues) return false;
        switch(field){
            case "release":
                return formData.release !== originalValues.formData.release;
            case "year":
                return formData.year !== originalValues.formData.year;
            case "label":
                return JSON.stringify(labels) !== JSON.stringify(originalValues.labels);
            case "catNumbers":
                return JSON.stringify(catNumbers) !== JSON.stringify(originalValues.catNumbers);
            case "format":
                return formData.format !== originalValues.formData.format;
            case "mediaType":
                return formData.mediaType !== originalValues.formData.mediaType;
            case "artist":
                return JSON.stringify(artists) !== JSON.stringify(originalValues.artists) || demotedArtists.length > 0;
            case "isFeatured":
                return false; // Featured is read-only, never considered modified
            case "title":
                return formData.title !== originalValues.formData.title;
            case "version":
                return JSON.stringify(versions) !== JSON.stringify(originalValues.versions);
            case "isrcs":
                return JSON.stringify(isrcs) !== JSON.stringify(originalValues.isrcs);
            case "duration":
                return formData.duration !== originalValues.formData.duration;
            case "live":
                return (0, $e353c670efa3bb12$export$6a8f182e25b88c10)(formData.live) !== (0, $e353c670efa3bb12$export$6a8f182e25b88c10)(originalValues.formData.live);
            case "contributions":
                return JSON.stringify(contributions) !== JSON.stringify(originalValues.contributions);
            default:
                return false;
        }
    };
    // Check if any field in release section has been modified
    const isReleaseSectionModified = ()=>{
        return isFieldModified("release") || isFieldModified("year") || isFieldModified("label") || isFieldModified("catNumbers") || isFieldModified("format") || isFieldModified("mediaType");
    };
    // Check if any field in recording section has been modified
    const isRecordingSectionModified = ()=>{
        return isFieldModified("artist") || isFieldModified("title") || isFieldModified("version") || isFieldModified("isrcs") || isFieldModified("duration") || isFieldModified("live") || isFieldModified("isFeatured") || isFieldModified("contributions");
    };
    // Release lookup/link handlers moved to ./ChangeReleaseModal (shared).
    const handleRevert = (type, field)=>{
        if (type === "section") {
            // Revert entire section
            if (field === "release") {
                setFormData((prev)=>({
                        ...prev,
                        release: originalValues.formData.release,
                        year: originalValues.formData.year,
                        format: originalValues.formData.format,
                        mediaType: originalValues.formData.mediaType
                    }));
                setLabels(originalValues.labels);
                setCatNumbers(originalValues.catNumbers);
            } else if (field === "recording") {
                setFormData((prev)=>({
                        ...prev,
                        title: originalValues.formData.title,
                        duration: originalValues.formData.duration,
                        live: originalValues.formData.live,
                        isFeatured: originalValues.formData.isFeatured
                    }));
                setVersions(originalValues.versions);
                setIsrcs(originalValues.isrcs);
                setArtists(originalValues.artists);
                setContributions(originalValues.contributions);
                setContributionCategoryOpenIndex(null);
                setCategoryDropdownRect(null);
            }
        } else if (type === "field" && field) // Revert specific field
        switch(field){
            case "release":
                handleFieldChange("release", originalValues.formData.release || "");
                break;
            case "year":
                handleFieldChange("year", originalValues.formData.year || "");
                break;
            case "label":
                setLabels(originalValues.labels);
                break;
            case "catNumbers":
                setCatNumbers(originalValues.catNumbers);
                break;
            case "format":
                handleFieldChange("format", originalValues.formData.format || "");
                break;
            case "mediaType":
                handleFieldChange("mediaType", originalValues.formData.mediaType || "");
                break;
            case "artist":
                setArtists(originalValues.artists);
                setDemotedArtists([]);
                break;
            case "title":
                handleFieldChange("title", originalValues.formData.title || "");
                break;
            case "version":
                setVersions(originalValues.versions);
                break;
            case "isrcs":
                setIsrcs(originalValues.isrcs);
                break;
            case "duration":
                handleFieldChange("duration", originalValues.formData.duration || "");
                break;
            case "live":
                handleFieldChange("live", originalValues.formData.live || "");
                break;
            case "isFeatured":
                handleFieldChange("isFeatured", originalValues.formData.isFeatured || false);
                break;
            case "contributions":
                setContributions(originalValues.contributions);
                setContributionCategoryOpenIndex(null);
                setCategoryDropdownRect(null);
                break;
        }
        setShowRevertModal(false);
        setRevertTarget(null);
    };
    const handleReleaseCancel = ()=>{
        handleRevert("section", "release");
        setReleaseSaveError(null);
        setYearError(null);
        setLabelsError(null);
        setCatNumbersError(null);
        setLabelInputOpen(false);
        setLabelInputValue("");
        setCatNoInputOpen(false);
        setCatNoInputValue("");
        onCancel();
    };
    const handleSaveReleaseDetails = async ()=>{
        if (!userId || !row?.id || !row.earliestParentReleaseId) return;
        if (labelInputOpen || catNoInputOpen) {
            setUnsavedItemWarning(labelInputOpen ? "label" : "catalogue number");
            return;
        }
        const dupLabel = (0, $e353c670efa3bb12$export$e3510695f47e62c5)(labels);
        if (dupLabel) {
            setLabelsError(`Duplicate label: "${dupLabel}"`);
            return;
        }
        setLabelsError(null);
        const dupCatNum = (0, $e353c670efa3bb12$export$e3510695f47e62c5)(catNumbers);
        if (dupCatNum) {
            setCatNumbersError(`Duplicate catalogue number: "${dupCatNum}"`);
            return;
        }
        setCatNumbersError(null);
        setReleaseSaveError(null);
        setReleaseSaveLoading(true);
        try {
            const edits = [];
            if (isFieldModified("release")) edits.push({
                op: (0, $5b09199803447a34$export$7a0ecdf3b8c100df).Edit,
                field: "release_title",
                value: formData.release ?? ""
            });
            if (isFieldModified("year")) edits.push({
                op: (0, $5b09199803447a34$export$7a0ecdf3b8c100df).Edit,
                field: "date_released",
                value: formData.year ?? ""
            });
            if (isFieldModified("label")) {
                const origLabels = originalValues?.labels ?? [];
                const addedLabels = labels.filter((v)=>!origLabels.includes(v));
                const removedLabels = origLabels.filter((v)=>!labels.includes(v));
                addedLabels.forEach((v)=>edits.push({
                        op: (0, $5b09199803447a34$export$7a0ecdf3b8c100df).Add,
                        field: "release_labels",
                        value: v
                    }));
                removedLabels.forEach((v)=>edits.push({
                        op: (0, $5b09199803447a34$export$7a0ecdf3b8c100df).Delete,
                        field: "release_labels",
                        value: v
                    }));
            }
            if (isFieldModified("catNumbers")) {
                const origCatNumbers = originalValues?.catNumbers ?? [];
                const addedCatNumbers = catNumbers.filter((v)=>!origCatNumbers.includes(v));
                const removedCatNumbers = origCatNumbers.filter((v)=>!catNumbers.includes(v));
                addedCatNumbers.forEach((v)=>edits.push({
                        op: (0, $5b09199803447a34$export$7a0ecdf3b8c100df).Add,
                        field: "cat_numbers",
                        value: v
                    }));
                removedCatNumbers.forEach((v)=>edits.push({
                        op: (0, $5b09199803447a34$export$7a0ecdf3b8c100df).Delete,
                        field: "cat_numbers",
                        value: v
                    }));
            }
            if (isFieldModified("format")) edits.push({
                op: (0, $5b09199803447a34$export$7a0ecdf3b8c100df).Edit,
                field: "format",
                value: formData.format ?? ""
            });
            if (isFieldModified("mediaType")) edits.push({
                op: (0, $5b09199803447a34$export$7a0ecdf3b8c100df).Edit,
                field: "media_type",
                value: formData.mediaType ?? ""
            });
            if (edits.length > 0) await api.correctServiceResponse({
                userId: userId,
                parentRecordingId: row.id,
                correctReleaseRequest: {
                    releaseId: row.earliestParentReleaseId,
                    edits: edits,
                    documentId: row.documentId
                }
            });
            // Propagate updated values back to the parent/grid
            const updatedRow = {
                ...row,
                ...formData,
                label: labels.join(", "),
                catNumbers: catNumbers.join(", "),
                labelsArray: labels,
                catNumbersArray: catNumbers,
                isModified: true
            };
            onSave(updatedRow);
            setEditsVersion((v)=>v + 1);
            // Only leave edit mode on success — on failure keep the section editable
            // so the user can see the error above the Save CTA and retry.
            setIsReleaseEditable(false);
        } catch (err) {
            setReleaseSaveError(await (0, $4e44ff72ec5a5d6e$export$3ad1f1ce31dd8e4a)(err, "release"));
        } finally{
            setReleaseSaveLoading(false);
        }
    };
    // ── Recording section handlers ──
    const handleRecordingCancel = ()=>{
        handleRevert("section", "recording");
        setRecordingSaveError(null);
        setShowContributionModal(false);
        setContributionModalContext(null);
        setShowRemoveContributionModal(null);
        setArtistActionModalIndex(null);
        setShowCreateArtist(false);
        setPendingArtistName(null);
        setPendingArtistId(null);
        setPendingArtistFeatured("fa");
        setEditingVersionIndex(null);
        setVersionsError(null);
        setArtistDropdownOpen(false);
        setAddContributionDropdownOpen(false);
        setContributionSearchQuery("");
        setArtistSearchQuery("");
        setIsrcFormatError(null);
        setPendingDuplicateIsrc(null);
        setIsrcInputOpen(false);
        setIsrcInputValue("");
    };
    const handleSaveRecordingDetails = async ()=>{
        if (isrcInputOpen) {
            setUnsavedItemWarning("ISRC");
            return;
        }
        if (!formData.title?.trim()) {
            setTitleError("Recording title is required");
            return;
        }
        setTitleError(null);
        const validArtists = artists.filter((a)=>a.name.trim());
        if (validArtists.length === 0) {
            setArtistsError("At least one artist is required");
            return;
        }
        setArtistsError(null);
        const dupVersion = (0, $e353c670efa3bb12$export$e3510695f47e62c5)(versions);
        if (dupVersion) {
            setVersionsError(`Duplicate version: "${dupVersion}"`);
            return;
        }
        setVersionsError(null);
        const durationWasAlreadySet = !!originalValues?.formData?.duration?.toString().trim();
        const durationIsEditable = !durationWasAlreadySet || isFieldEdited("duration");
        if (durationIsEditable && formData.duration && !(0, $e353c670efa3bb12$export$e28555c1bee34381)(formData.duration)) {
            alert("Duration must be in HH:MM:SS format (e.g. 00:03:45)");
            return;
        }
        setRecordingSaveError(null);
        setRecordingSaveLoading(true);
        try {
            // ── 1. Correct recording data (contract 4.1.1) ──
            if (userId && row?.id) {
                const recordingEdits = [];
                if (isFieldModified("title")) recordingEdits.push({
                    op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Edit,
                    field: "recordingTitle",
                    value: formData.title ?? ""
                });
                if (isFieldModified("duration")) recordingEdits.push({
                    op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Edit,
                    field: "duration",
                    value: formData.duration ?? ""
                });
                if (isFieldModified("live")) {
                    const liveValue = (0, $e353c670efa3bb12$export$6a8f182e25b88c10)(formData.live);
                    // Only the `live` descriptor string is persisted now. The former
                    // boolean `is_live` flag is no longer written — it is derived
                    // downstream from the presence of a live descriptor. The descriptor
                    // is a standalone field, never mirrored into recordingVersion.
                    // (OS schema: ParentRecording.live, e.g. "Live in London, 1989").
                    recordingEdits.push({
                        op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Edit,
                        field: "live",
                        value: liveValue
                    });
                }
                if (isFieldModified("version")) {
                    // recordingVersion is list[str] in OS schema.
                    // Send delete for removed versions and add for new ones.
                    const origVersions = originalValues?.versions ?? [];
                    const addedVersions = versions.filter((v)=>!origVersions.includes(v));
                    const removedVersions = origVersions.filter((v)=>!versions.includes(v));
                    removedVersions.forEach((v)=>recordingEdits.push({
                            op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Delete,
                            field: "recordingVersion",
                            value: v
                        }));
                    addedVersions.forEach((v)=>recordingEdits.push({
                            op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Add,
                            field: "recordingVersion",
                            value: v
                        }));
                }
                if (isFieldModified("isrcs")) {
                    const origIsrcs = originalValues?.isrcs ?? [];
                    const added = isrcs.filter((v)=>!origIsrcs.includes(v));
                    const removed = origIsrcs.filter((v)=>!isrcs.includes(v));
                    added.forEach((v)=>{
                        const dupMatches = confirmedDuplicateIsrcs[v];
                        recordingEdits.push({
                            op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Add,
                            field: "isrcs",
                            value: v,
                            dupIsrcs: dupMatches && dupMatches.length > 0 ? dupMatches.map((d)=>({
                                    dupRecordingId: d.recordingId,
                                    dupDocumentId: d.documentId
                                })) : undefined
                        });
                    });
                    removed.forEach((v)=>recordingEdits.push({
                            op: (0, $949d5cc99c8eb25f$export$347ed0836a582eaa).Delete,
                            field: "isrcs",
                            value: v
                        }));
                }
                if (recordingEdits.length > 0) await api.correctRecordingServiceResponse({
                    userId: userId,
                    parentRecordingId: row.id,
                    correctRecordingRequest: {
                        edits: recordingEdits,
                        documentId: row.documentId
                    }
                });
                // ── 2a. Create new artists and link (contract 4.4.2) ──
                // Pending-create artists are linked via /create in a single batched call,
                // so we don't include them in the /artists payload below.
                if (isFieldModified("artist")) {
                    const origNames = (originalValues?.artists ?? []).map((a)=>a.name);
                    const pendingCreates = validArtists.filter((a)=>a.pendingCreate && !origNames.includes(a.name));
                    if (pendingCreates.length > 0) {
                        const createEdits = pendingCreates.map((a)=>({
                                op: (0, $b36d2387fff73506$export$bf856448a04f07d1).Add,
                                stageName: a.name,
                                source: a.pendingCreate.source,
                                sourceId: a.pendingCreate.sourceId,
                                featuredStatus: a.featuredStatus === "fa" ? (0, $b36d2387fff73506$export$6b46a49d4996d67c).Fa : (0, $b36d2387fff73506$export$6b46a49d4996d67c).Ofa,
                                members: a.members && a.members.length > 0 ? a.members.map((m)=>({
                                        id: m.id,
                                        stageName: m.stageName,
                                        _exists: m.exists ?? false
                                    })) : undefined
                            }));
                        await api.createArtistAndLinkServiceResponse({
                            userId: userId,
                            parentRecordingId: row.id,
                            createArtistAndLinkRequest: {
                                edits: createEdits,
                                documentId: row.documentId
                            }
                        });
                    }
                }
                // ── 2b. Change associated artists (contract 4.1.3) ──
                if (isFieldModified("artist")) {
                    const origNames = (originalValues?.artists ?? []).map((a)=>a.name);
                    const currNames = validArtists.map((a)=>a.name);
                    const artistEdits = [];
                    // Added artists — exclude pending-create artists (handled by /create above)
                    validArtists.filter((a)=>!origNames.includes(a.name) && !a.pendingCreate).forEach((a)=>{
                        artistEdits.push({
                            artistId: a.id || a.name,
                            op: (0, $19c922af6379aa7e$export$5b356edc00d5e9f9).Add,
                            featuredStatus: a.featuredStatus ?? (a.isFeatured ? "fa" : "ofa"),
                            stageName: a.name,
                            members: a.members ?? []
                        });
                    });
                    // Removed artists — no longer in the artists array and not demoted
                    const demotedNames = demotedArtists.map((d)=>d.name);
                    (originalValues?.artists ?? []).filter((a)=>!currNames.includes(a.name) && !demotedNames.includes(a.name)).forEach((a)=>{
                        artistEdits.push({
                            artistId: a.id || a.name,
                            op: (0, $19c922af6379aa7e$export$5b356edc00d5e9f9).Delete,
                            // @ts-expect-error -- contract allows null for remove
                            featuredStatus: null,
                            type: a.type
                        });
                    });
                    // Demoted artists — tracked separately, sent with nfa
                    demotedArtists.forEach((a)=>{
                        artistEdits.push({
                            artistId: a.id || a.name,
                            op: (0, $19c922af6379aa7e$export$5b356edc00d5e9f9).Delete,
                            featuredStatus: "nfa",
                            type: a.type
                        });
                    });
                    if (artistEdits.length > 0) await api.changeArtistsServiceResponse({
                        userId: userId,
                        parentRecordingId: row.id,
                        changeAssociatedArtistsRequest: {
                            edits: artistEdits,
                            documentId: row.documentId
                        }
                    });
                }
                // ── 3. Manage contributions (contract 4.2.1) ──
                if (isFieldModified("contributions")) {
                    const origContribs = originalValues?.contributions ?? [];
                    const contribEdits = [];
                    // Added contributions
                    contributions.filter((c)=>!origContribs.some((oc)=>oc.contribution === c.contribution)).forEach((c)=>{
                        const { evidenceUrl: evidenceUrl, notes: notes } = $7c320e41e081b01e$var$parseContributionEvidenceNotes(c.confidencePattern ?? "");
                        contribEdits.push({
                            op: (0, $ac464ed50cc3b124$export$fd3a7799230e15bd).Add,
                            role: c.contribution ?? "",
                            personaId: c.personaId || undefined,
                            dataCategory: c.confidenceCategory ?? "1",
                            sourceUrl: evidenceUrl || undefined,
                            notes: notes || undefined
                        });
                    });
                    // Removed contributions
                    origContribs.filter((oc)=>!contributions.some((c)=>c.contribution === oc.contribution)).forEach((oc)=>{
                        contribEdits.push({
                            op: (0, $ac464ed50cc3b124$export$fd3a7799230e15bd).Delete,
                            role: oc.contribution ?? ""
                        });
                    });
                    // Edited contributions (same role, changed category/pattern/persona)
                    contributions.filter((c)=>{
                        const orig = origContribs.find((oc)=>oc.contribution === c.contribution);
                        return orig && (orig.confidenceCategory !== c.confidenceCategory || orig.confidencePattern !== c.confidencePattern || orig.personaId !== c.personaId);
                    }).forEach((c)=>{
                        const { evidenceUrl: evidenceUrl, notes: notes } = $7c320e41e081b01e$var$parseContributionEvidenceNotes(c.confidencePattern ?? "");
                        contribEdits.push({
                            op: (0, $ac464ed50cc3b124$export$fd3a7799230e15bd).Edit,
                            role: c.contribution ?? "",
                            personaId: c.personaId || undefined,
                            dataCategory: c.confidenceCategory ?? "1",
                            sourceUrl: evidenceUrl || undefined,
                            notes: notes || undefined
                        });
                    });
                    if (contribEdits.length > 0) await api.manageContributionsServiceResponse({
                        userId: userId,
                        parentRecordingId: row.id,
                        manageContributionsRequest: {
                            edits: contribEdits,
                            documentId: row.documentId
                        }
                    });
                }
            }
            // Build optimistic contributions for the table display.
            // - Unchanged contributions keep their original confidencePattern (tooltip).
            // - Edited or newly added contributions get "manual_update" as the pattern.
            // Sort by confidenceCategory descending (5→1) to match server ordering.
            const origContribMap = new Map((originalValues?.contributions ?? []).map((c)=>[
                    c.contribution,
                    c
                ]));
            const optimisticContributions = contributions.map((c)=>{
                const orig = origContribMap.get(c.contribution);
                const isNew = !orig;
                const isEdited = orig && (orig.confidenceCategory !== c.confidenceCategory || orig.personaId !== c.personaId);
                return {
                    ...c,
                    confidencePattern: isNew || isEdited ? "manual_update" : orig?.confidencePattern ?? ""
                };
            }).sort((a, b)=>b.confidenceCategory.localeCompare(a.confidenceCategory));
            // Project the local artist list back into the row's `mainArtistsRaw`
            // shape so reopening the modal (without a page refresh) shows the
            // updated artist set. Artists with a known UUID are emitted as the new
            // `MainArtistItem` form; pending-create artists (where the server hasn't
            // assigned a UUID yet) fall back to the legacy string form — they'll be
            // replaced with the canonical UUID on the next refresh.
            const optimisticMainArtists = validArtists.map((a)=>a.id ? {
                    id: a.id,
                    stageName: a.name,
                    type: a.type ?? "persona"
                } : a.name);
            const updatedRow = {
                ...row,
                ...formData,
                // Keep the boolean grid flag in sync with the live descriptor so the
                // optimistic row renders the Live column correctly before refetch.
                isLive: !!(0, $e353c670efa3bb12$export$6a8f182e25b88c10)(formData.live),
                artist: validArtists.map((a)=>a.name).join(", "),
                contributions: optimisticContributions,
                label: labels.join(", "),
                catNumbers: catNumbers.join(", "),
                version: versions.join(", "),
                isrcs: isrcs.join(", "),
                labelsArray: labels,
                catNumbersArray: catNumbers,
                versionsArray: versions,
                isrcsArray: isrcs,
                mainArtistsRaw: optimisticMainArtists,
                hasManualChanges: true,
                isModified: true
            };
            // Build list of ISRCs reassigned from other recordings so the grid can
            // optimistically strip them from those rows.
            const reassignedIsrcs = Object.entries(confirmedDuplicateIsrcs).map(([isrc, sources])=>({
                    isrc: isrc,
                    fromRecordingIds: sources.map((s)=>s.recordingId)
                }));
            onSave(updatedRow, reassignedIsrcs.length > 0 ? reassignedIsrcs : undefined);
            // Trigger a manual-changes overlay refetch so the just-saved edits show
            // up as purple indicators without requiring the user to close + reopen
            // the modal.
            setEditsVersion((v)=>v + 1);
        } catch (err) {
            setRecordingSaveError(await (0, $4e44ff72ec5a5d6e$export$3ad1f1ce31dd8e4a)(err, "recording"));
        } finally{
            setRecordingSaveLoading(false);
        }
    };
    const handleFieldChange = (field, value)=>{
        setFormData((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    // Helper functions for managing multiple values
    const addMultipleValue = (setter, value)=>{
        const trimmed = value.trim();
        if (trimmed) setter((prev)=>prev.some((v)=>v.toLowerCase() === trimmed.toLowerCase()) ? prev : [
                ...prev,
                trimmed
            ]);
    };
    const removeMultipleValue = (setter, index)=>{
        setter((prev)=>prev.filter((_, i)=>i !== index));
    };
    const updateMultipleValue = (setter, index, value)=>{
        setter((prev)=>prev.map((v, i)=>i === index ? value : v));
    };
    /** Validate ISRC uniqueness via the backend OpenSearch endpoint. */ const validateIsrcDuplication = async (isrc)=>{
        if (!userId || !row?.id) return {
            isDuplicate: false,
            matches: []
        };
        try {
            const resp = await api.validateIsrcValidateIsrcResponse({
                userId: userId,
                parentRecordingId: row.id,
                validateIsrcRequest: {
                    isrc: isrc
                }
            });
            return {
                isDuplicate: resp.isDuplicate ?? false,
                matches: (resp.matches ?? []).map((m)=>({
                        recordingId: m.recordingId ?? "",
                        recordingTitle: m.recordingTitle ?? "",
                        artistName: m.artistName ?? "",
                        documentId: m.documentId ?? ""
                    }))
            };
        } catch  {
            // If the API call fails, allow the ISRC to be added (don't block on network errors)
            return {
                isDuplicate: false,
                matches: []
            };
        }
    };
    /** Fetch client aliases (personas) for the Alias dropdown in the contribution modal. */ const fetchClientAliases = async ()=>{
        if (!userId || !row?.id || clientAliases.length > 0) return;
        setClientAliasesLoading(true);
        try {
            const response = await api.lookupClientAliasesLookupClientAliasesResponse({
                userId: userId,
                parentRecordingId: row.id
            });
            setClientAliases(response.personas.map((p)=>({
                    stageName: p.stageName,
                    personaId: p.personaId
                })));
        } catch  {
        // Silently fail — alias field will just be empty
        } finally{
            setClientAliasesLoading(false);
        }
    };
    const addIsrc = async (raw)=>{
        if (!(0, $e353c670efa3bb12$export$5c2a80a44f9ccb50)(raw)) {
            setIsrcFormatError((0, $e353c670efa3bb12$export$909be10aa76219bc));
            return;
        }
        setIsrcFormatError(null);
        const { isDuplicate: isDuplicate, matches: matches } = await validateIsrcDuplication(raw);
        if (isDuplicate) {
            // Leave the inline input open behind the confirmation modal; it's
            // cleared/closed once the user confirms (see the Continue handler).
            setPendingDuplicateIsrc(raw);
            setPendingDuplicateMatches(matches);
            return;
        }
        addMultipleValue(setIsrcs, raw);
        setIsrcInputValue("");
        setIsrcInputOpen(false);
    };
    /** Commit the inline Label input into the labels list, then close it. */ const commitLabel = ()=>{
        const trimmed = labelInputValue.trim();
        if (!trimmed) return;
        addMultipleValue(setLabels, trimmed);
        setLabelInputValue("");
        setLabelInputOpen(false);
    };
    /** Commit the inline Catalogue Number input into the list, then close it. */ const commitCatNo = ()=>{
        const trimmed = catNoInputValue.trim();
        if (!trimmed) return;
        addMultipleValue(setCatNumbers, trimmed);
        setCatNoInputValue("");
        setCatNoInputOpen(false);
    };
    /** Commit helpers for the Create/Link-release modal's inline inputs. */ // commitNewLabel/commitNewCatNo moved to ./ChangeReleaseModal (shared).
    // isValidDuration is imported from ../../../utils/recordingValidators (shared).
    saveHandlerRef.current = handleSaveRecordingDetails;
    isDirtyRef.current = isRecordingSectionModified() || isReleaseSectionModified();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: stacked ? "tw-flex tw-flex-col tw-gap-0 tw-mt-2 tw-pb-2" : "tw-grid tw-grid-cols-[1fr_auto_1fr] tw-gap-0 tw-mt-2 tw-pb-2 tw-overflow-y-auto tw-max-h-[calc(90vh-100px)]",
                children: [
                    !releaseOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: stacked ? "tw-flex tw-flex-col tw-shrink-0" : "tw-flex tw-flex-col tw-overflow-y-auto",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-px-3 tw-pt-2 tw-pb-2 tw-flex tw-flex-col tw-shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-flex tw-items-center tw-justify-between tw-mb-2 tw-pb-1.5 tw-border-b tw-border-formInputBackground tw-flex-shrink-0",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-text-white tw-font-semibold",
                                                children: "Recording"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-space-y-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-items-center tw-justify-between tw-mb-1.5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "modal-artist-select",
                                                                    className: `tw-text-sm tw-font-medium ${isFieldModified("artist") ? "tw-text-white" : "tw-text-white"}`,
                                                                    children: "Artists"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "tw-flex tw-items-center tw-gap-3",
                                                                    children: isRecordingEditable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                        type: "button",
                                                                        onClick: ()=>{
                                                                            setShowCreateArtist(true);
                                                                        },
                                                                        className: "tw-text-sm tw-flex tw-items-center tw-text-textWhite hover:tw-text-textLime",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                                className: "wi wi-20px wi-plus tw-mr-1"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "tw-underline",
                                                                                children: "Create artist"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        artistsError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "tw-text-westburyRed tw-text-xs tw-mb-1",
                                                            children: artistsError
                                                        }),
                                                        artists.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-1.5",
                                                            children: artists.map((artist, index)=>{
                                                                const origArtist = originalValues?.artists?.find((oa)=>oa.name === artist.name);
                                                                const isArtistAdded = !origArtist;
                                                                // Left-border indicator when this artist is in the
                                                                // manual-changes overlay (contract 4.5.2 artists.items)
                                                                // OR when the user just added them locally. We match
                                                                // on artist_id when available, falling back to
                                                                // stageName so legacy rows (where mainArtistsRaw is a
                                                                // plain string array) still light up correctly.
                                                                const showEditedBorder = isArtistAdded || !!artist.id && addedArtistIdSet.has(artist.id) || addedArtistNameSet.has(artist.name);
                                                                const removable = isRecordingEditable && artists.length > 1;
                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$92a172cc67aad148), {
                                                                    name: artist.name,
                                                                    edited: showEditedBorder,
                                                                    removeTitle: artist.pendingCreate ? "Remove artist" : "Demote or remove artist",
                                                                    onRemove: removable ? ()=>{
                                                                        if (artist.pendingCreate) // Not yet created/linked — just remove locally
                                                                        setArtists((prev)=>prev.filter((_, i)=>i !== index));
                                                                        else {
                                                                            setArtistActionModalIndex(index);
                                                                            setArtistActionConfirm(null);
                                                                        }
                                                                    } : undefined
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-relative",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "modal-artist-select",
                                                                    type: "text",
                                                                    value: artistSearchQuery,
                                                                    onChange: (e)=>{
                                                                        setArtistSearchQuery(e.target.value);
                                                                        setArtistDropdownOpen(true);
                                                                    },
                                                                    onFocus: ()=>{
                                                                        if (isRecordingEditable) setArtistDropdownOpen(true);
                                                                    },
                                                                    onBlur: ()=>{
                                                                        setTimeout(()=>setArtistDropdownOpen(false), 200);
                                                                    },
                                                                    placeholder: "Search or select artist\u2026",
                                                                    readOnly: !isRecordingEditable,
                                                                    disabled: !isRecordingEditable,
                                                                    className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)()
                                                                }),
                                                                artistDropdownOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: (0, $bb6d544802d60420$export$ae270fdcc1622e9f),
                                                                    children: !artistSearchQuery.trim() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: (0, $bb6d544802d60420$export$785837da81429671),
                                                                        children: "Start typing to search for artists\u2026"
                                                                    }) : artistLookupLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: (0, $bb6d544802d60420$export$785837da81429671),
                                                                        children: "Searching..."
                                                                    }) : (()=>{
                                                                        const notAdded = artistLookupResults.filter((a)=>!artists.some((e)=>e.name === a.stageName || e.id === a.id));
                                                                        if (notAdded.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: (0, $bb6d544802d60420$export$785837da81429671),
                                                                            children: artistLookupResults.length === 0 ? "No matching artists" : "All matching artists already added"
                                                                        });
                                                                        return notAdded.map((artist)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                                type: "button",
                                                                                className: (0, $bb6d544802d60420$export$4f83e5d0e324b6c5),
                                                                                onMouseDown: (e)=>{
                                                                                    e.preventDefault();
                                                                                    setPendingArtistName(artist.stageName);
                                                                                    setPendingArtistId(artist.id);
                                                                                    setPendingArtistMembers(artist.members ?? []);
                                                                                    setPendingArtistFeatured("fa");
                                                                                    setArtistSearchQuery("");
                                                                                    setArtistDropdownOpen(false);
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        children: artist.stageName
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: (0, $bb6d544802d60420$export$ed929ff84da6e8f5),
                                                                                        children: artist.id
                                                                                    })
                                                                                ]
                                                                            }, artist.id));
                                                                    })()
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-items-center tw-gap-2 tw-mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                htmlFor: "modal-title",
                                                                className: `tw-block tw-text-sm tw-font-medium ${isFieldModified("title") ? "tw-text-white" : "tw-text-white"}`,
                                                                children: "Recording Title"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c320e41e081b01e$var$ManualChangeWrap, {
                                                            edited: isFieldEdited("recordingTitle"),
                                                            changed: isFieldModified("title"),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                id: "modal-title",
                                                                type: "text",
                                                                value: formData.title || "",
                                                                onChange: (e)=>{
                                                                    handleFieldChange("title", e.target.value);
                                                                    if (titleError && e.target.value.trim()) setTitleError(null);
                                                                },
                                                                readOnly: !isRecordingEditable,
                                                                disabled: !isRecordingEditable,
                                                                className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                                                    error: !!titleError
                                                                })
                                                            })
                                                        }),
                                                        titleError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                                                            children: titleError
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "modal-version-input",
                                                                    className: `tw-block tw-text-sm tw-font-medium ${isFieldModified("version") ? "tw-text-white" : "tw-text-white"}`,
                                                                    children: "Version"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                                    children: "Optional"
                                                                })
                                                            ]
                                                        }),
                                                        versions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-2 tw-min-h-[40px]",
                                                            children: versions.map((version, index)=>{
                                                                const isVersionEdited = originalValues?.versions?.[index] !== undefined && originalValues.versions[index] !== version;
                                                                return editingVersionIndex === index ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "text",
                                                                    ref: (el)=>el?.focus(),
                                                                    value: version,
                                                                    onChange: (e)=>updateMultipleValue(setVersions, index, e.target.value),
                                                                    onBlur: (e)=>{
                                                                        updateMultipleValue(setVersions, index, e.target.value.trim());
                                                                        setEditingVersionIndex(null);
                                                                    },
                                                                    onKeyDown: (e)=>{
                                                                        if (e.key === "Enter" || e.key === "Escape") {
                                                                            updateMultipleValue(setVersions, index, e.currentTarget.value.trim());
                                                                            setEditingVersionIndex(null);
                                                                        }
                                                                    },
                                                                    className: "tw-bg-formInputBackground tw-border tw-border-westburyBlue tw-rounded-xs tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-white tw-outline-none tw-min-w-[60px] tw-max-w-[160px]"
                                                                }, index) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$e151e13a7e9f85a5), {
                                                                    edited: addedVersionValues.has(version),
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        role: isRecordingEditable ? "button" : undefined,
                                                                        tabIndex: isRecordingEditable ? 0 : undefined,
                                                                        className: `tw-relative tw-inline-flex tw-items-center tw-gap-1 tw-rounded-xs tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-bg-formInputBackground tw-text-white tw-border-2 tw-border-transparent ${isRecordingEditable ? "tw-cursor-pointer hover:tw-border-white/50" : "tw-opacity-60"}`,
                                                                        title: addedVersionValues.has(version) ? undefined : isRecordingEditable ? "Click to edit" : undefined,
                                                                        onClick: ()=>{
                                                                            if (isRecordingEditable) setEditingVersionIndex(index);
                                                                        },
                                                                        onKeyDown: (e)=>{
                                                                            if (isRecordingEditable && (e.key === "Enter" || e.key === " ")) {
                                                                                e.preventDefault();
                                                                                setEditingVersionIndex(index);
                                                                            }
                                                                        },
                                                                        children: [
                                                                            isVersionEdited && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "tw-absolute -tw-top-1 -tw-right-1 tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-surfacePurple tw-border tw-border-gray-900 tw-animate-pulse-slow"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                children: version
                                                                            })
                                                                        ]
                                                                    })
                                                                }, index);
                                                            })
                                                        }),
                                                        versions.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "tw-text-textSeal tw-text-xs",
                                                            children: "None"
                                                        }),
                                                        versionsError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                                                            children: versionsError
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-items-center tw-gap-2 tw-mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                htmlFor: "modal-live",
                                                                className: "tw-block tw-text-sm tw-font-medium tw-text-white",
                                                                children: "Live"
                                                            })
                                                        }),
                                                        (()=>{
                                                            const liveValue = (0, $e353c670efa3bb12$export$6a8f182e25b88c10)(formData.live);
                                                            const liveField = editedRecordingFields.live;
                                                            const note = liveField?.note;
                                                            // Only a *persisted* manual change drives the "manually
                                                            // edited" left ribbon. An unsaved switch (e.g. No → Live)
                                                            // is represented solely by the pulsing "changed" dot
                                                            // until the user saves — at which point the overlay
                                                            // refetch flips isFieldEdited('live') on. Mirrors how the
                                                            // Title field separates edited (ribbon) from changed (dot).
                                                            const liveEdited = isFieldEdited("live");
                                                            // The live descriptor is locked once it comes from source
                                                            // data: it may only be set when empty, or re-edited after a
                                                            // manual change — either persisted (`liveEdited`) or made
                                                            // this session but not yet saved (`isFieldModified`). A
                                                            // source-provided value that was never manually changed is
                                                            // read-only. Enforced on the backend too (correct 4.1.1).
                                                            const isLiveEditable = isRecordingEditable && (!liveValue || liveEdited || isFieldModified("live"));
                                                            const tooltip = note ? `${0, $473dabb7bb223c2d$export$84e9997ca939742d} \u{2014} ${note}` : (0, $473dabb7bb223c2d$export$84e9997ca939742d);
                                                            if (!liveValue) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "tw-flex tw-items-center tw-justify-between tw-gap-2 tw-min-h-[40px]",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "tw-text-textSeal tw-text-xs",
                                                                        children: "No"
                                                                    }),
                                                                    isLiveEditable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                        variant: "secondary",
                                                                        label: "Change to Live",
                                                                        onClick: ()=>{
                                                                            setLiveToYesNote("");
                                                                            setShowLiveToYesModal(true);
                                                                        }
                                                                    })
                                                                ]
                                                            });
                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "tw-flex tw-flex-wrap tw-gap-1.5 tw-min-h-[40px]",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$e151e13a7e9f85a5), {
                                                                    edited: liveEdited,
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        role: isLiveEditable ? "button" : undefined,
                                                                        tabIndex: isLiveEditable ? 0 : undefined,
                                                                        title: isLiveEditable ? "Click to update the live version" : tooltip,
                                                                        className: `tw-relative tw-inline-flex tw-items-center tw-gap-1 tw-rounded-xs tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-bg-formInputBackground tw-text-white tw-border-2 tw-border-transparent ${isLiveEditable ? "tw-cursor-pointer hover:tw-border-white/50" : "tw-opacity-60"}`,
                                                                        onClick: ()=>{
                                                                            if (isLiveEditable) {
                                                                                setLiveToYesNote(liveValue);
                                                                                setShowLiveToYesModal(true);
                                                                            }
                                                                        },
                                                                        onKeyDown: (e)=>{
                                                                            if (isLiveEditable && (e.key === "Enter" || e.key === " ")) {
                                                                                e.preventDefault();
                                                                                setLiveToYesNote(liveValue);
                                                                                setShowLiveToYesModal(true);
                                                                            }
                                                                        },
                                                                        children: [
                                                                            isFieldModified("live") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "tw-absolute -tw-top-1 -tw-right-1 tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-surfacePurple tw-border tw-border-gray-900 tw-animate-pulse-slow"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                children: liveValue
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            });
                                                        })()
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-items-center tw-justify-between tw-mb-1.5",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                htmlFor: "modal-contribution-search",
                                                                className: `tw-text-sm tw-font-medium ${isFieldModified("contributions") ? "tw-text-white" : "tw-text-white"}`,
                                                                children: "Contributions"
                                                            })
                                                        }),
                                                        contributions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-1.5",
                                                            children: [
                                                                ...contributions
                                                            ].map((cont, originalIndex)=>({
                                                                    cont: cont,
                                                                    originalIndex: originalIndex
                                                                })).sort((a, b)=>parseInt(a.cont.confidenceCategory ?? "1", 10) - parseInt(b.cont.confidenceCategory ?? "1", 10)).map(({ cont: cont, originalIndex: originalIndex })=>{
                                                                const origContrib = originalValues?.contributions?.find((oc)=>oc.contribution === cont.contribution);
                                                                const isAdded = !origContrib;
                                                                const isEdited = !!origContrib && (origContrib.confidenceCategory !== cont.confidenceCategory || origContrib.confidencePattern !== cont.confidencePattern);
                                                                const openDetail = ()=>{
                                                                    const c = contributions[originalIndex];
                                                                    const parsed = $7c320e41e081b01e$var$parseContributionEvidenceNotes(c.confidencePattern ?? "");
                                                                    const overlay = getContributionOverlayForRole(c.contribution ?? "");
                                                                    setContributionModalForm({
                                                                        contributionName: c.contribution ?? "",
                                                                        confidenceCategory: c.confidenceCategory ?? "1",
                                                                        evidenceUrl: overlay?.sourceUrl ?? parsed.evidenceUrl,
                                                                        notes: overlay?.notes ?? parsed.notes,
                                                                        personaId: c.personaId ?? ""
                                                                    });
                                                                    setContributionModalContext({
                                                                        type: "edit",
                                                                        index: originalIndex
                                                                    });
                                                                    fetchClientAliases();
                                                                    setShowContributionModal(true);
                                                                };
                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$1fcd028c38eb96f), {
                                                                    role: cont.contribution ?? "",
                                                                    confidenceCategory: cont.confidenceCategory,
                                                                    edited: editedContributionRoleSet.has(cont.contribution ?? ""),
                                                                    changed: isAdded || isEdited,
                                                                    changedTitle: isAdded ? "Newly added contribution" : "Edited contribution",
                                                                    onSelect: isRecordingEditable ? openDetail : undefined,
                                                                    onRemove: isRecordingEditable && contributions.length > 1 ? ()=>setShowRemoveContributionModal(originalIndex) : undefined
                                                                }, originalIndex);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-relative",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "modal-contribution-search",
                                                                    type: "text",
                                                                    value: contributionSearchQuery,
                                                                    onChange: (e)=>{
                                                                        setContributionSearchQuery(e.target.value);
                                                                        setAddContributionDropdownOpen(true);
                                                                    },
                                                                    onFocus: ()=>{
                                                                        if (isRecordingEditable) setAddContributionDropdownOpen(true);
                                                                    },
                                                                    onBlur: ()=>{
                                                                        setTimeout(()=>setAddContributionDropdownOpen(false), 200);
                                                                    },
                                                                    placeholder: "Search or select contribution\u2026",
                                                                    readOnly: !isRecordingEditable,
                                                                    disabled: !isRecordingEditable,
                                                                    className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)()
                                                                }),
                                                                addContributionDropdownOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: `${(0, $bb6d544802d60420$export$ae270fdcc1622e9f)} tw-overflow-x-hidden`,
                                                                    children: (()=>{
                                                                        const q = contributionSearchQuery.trim().toLowerCase();
                                                                        const filtered = availableContributions.filter((cont)=>(!q || cont.toLowerCase().includes(q)) && !contributions.some((c)=>c.contribution === cont));
                                                                        if (filtered.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: (0, $bb6d544802d60420$export$785837da81429671),
                                                                            children: "No matching contributions"
                                                                        });
                                                                        return filtered.map((cont)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                className: (0, $bb6d544802d60420$export$4f83e5d0e324b6c5),
                                                                                onMouseDown: (e)=>{
                                                                                    e.preventDefault();
                                                                                    setContributionModalForm({
                                                                                        contributionName: cont,
                                                                                        confidenceCategory: "1",
                                                                                        evidenceUrl: "",
                                                                                        notes: "",
                                                                                        personaId: ""
                                                                                    });
                                                                                    setContributionModalContext({
                                                                                        type: "add",
                                                                                        contributionValue: cont
                                                                                    });
                                                                                    fetchClientAliases();
                                                                                    setShowContributionModal(true);
                                                                                    setAddContributionDropdownOpen(false);
                                                                                    setContributionSearchQuery("");
                                                                                },
                                                                                children: (0, $f1q41.capitalize)(cont)
                                                                            }, cont));
                                                                    })()
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "modal-isrcs-input",
                                                                    className: `tw-block tw-text-sm tw-font-medium ${isFieldModified("isrcs") ? "tw-text-white" : "tw-text-white"}`,
                                                                    children: "ISRCs"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                                    children: "Optional"
                                                                })
                                                            ]
                                                        }),
                                                        isrcs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-2 tw-min-h-[40px]",
                                                            children: isrcs.map((isrc, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$7260e85975d9726b), {
                                                                    value: isrc,
                                                                    edited: addedIsrcValues.has(isrc),
                                                                    changed: !originalValues?.isrcs?.includes(isrc),
                                                                    dimmed: !isRecordingEditable,
                                                                    onRemove: isRecordingEditable ? ()=>{
                                                                        removeMultipleValue(setIsrcs, index);
                                                                        if (isrcFormatError) setIsrcFormatError(null);
                                                                    } : undefined
                                                                }, index))
                                                        }),
                                                        isrcs.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "tw-text-textSeal tw-text-xs tw-mb-2",
                                                            children: "None"
                                                        }),
                                                        isRecordingEditable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-flex-col tw-gap-1.5",
                                                            children: isrcInputOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        id: "modal-isrcs-input",
                                                                        type: "text",
                                                                        autoFocus: true,
                                                                        placeholder: "Enter ISRC",
                                                                        value: isrcInputValue,
                                                                        onChange: (e)=>{
                                                                            setIsrcInputValue(e.target.value);
                                                                            if (isrcFormatError) setIsrcFormatError(null);
                                                                        },
                                                                        onKeyDown: (e)=>{
                                                                            if (e.key === "Enter" && isrcInputValue.trim()) {
                                                                                e.preventDefault();
                                                                                addIsrc(isrcInputValue.trim());
                                                                            } else if (e.key === "Escape") {
                                                                                setIsrcInputValue("");
                                                                                setIsrcInputOpen(false);
                                                                                setIsrcFormatError(null);
                                                                            }
                                                                        },
                                                                        className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                                                            className: "tw-flex-1"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "tw-flex tw-justify-end tw-gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                                variant: "secondary",
                                                                                label: "Cancel",
                                                                                onClick: ()=>{
                                                                                    setIsrcInputValue("");
                                                                                    setIsrcInputOpen(false);
                                                                                    setIsrcFormatError(null);
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                                variant: "primary",
                                                                                label: "Create",
                                                                                disabled: !isrcInputValue.trim(),
                                                                                onClick: ()=>addIsrc(isrcInputValue.trim())
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "tw-flex tw-justify-end",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                    type: "button",
                                                                    className: "tw-text-sm tw-flex tw-items-center tw-text-textWhite hover:tw-text-textLime",
                                                                    onClick: ()=>{
                                                                        setIsrcInputValue("");
                                                                        setIsrcFormatError(null);
                                                                        setIsrcInputOpen(true);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                            className: "wi wi-20px wi-plus tw-mr-1"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "tw-underline",
                                                                            children: "Add ISRC"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        isrcFormatError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                                                            children: isrcFormatError
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-flex-col tw-gap-4 tw-w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex-1 tw-min-w-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "tw-flex tw-items-center tw-gap-2 tw-mb-2",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        htmlFor: "modal-duration",
                                                                        className: `tw-block tw-text-sm tw-font-medium ${isFieldModified("duration") ? "tw-text-white" : originalValues?.formData?.duration && !isFieldEdited("duration") ? "tw-text-textSeal" : "tw-text-white"}`,
                                                                        children: "Duration"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c320e41e081b01e$var$ManualChangeWrap, {
                                                                    edited: isFieldEdited("duration"),
                                                                    changed: isFieldModified("duration"),
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        id: "modal-duration",
                                                                        type: "text",
                                                                        value: formData.duration || "",
                                                                        onChange: (e)=>handleFieldChange("duration", e.target.value),
                                                                        disabled: !isRecordingEditable || !!originalValues?.formData?.duration?.toString().trim() && !isFieldEdited("duration"),
                                                                        className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                                                            error: (!originalValues?.formData?.duration?.toString().trim() || isFieldEdited("duration")) && !!formData.duration && !(0, $e353c670efa3bb12$export$e28555c1bee34381)(formData.duration)
                                                                        }),
                                                                        placeholder: "HH:MM:SS"
                                                                    })
                                                                }),
                                                                (!originalValues?.formData?.duration?.toString().trim() || isFieldEdited("duration")) && formData.duration && !(0, $e353c670efa3bb12$export$e28555c1bee34381)(formData.duration) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-0.5`,
                                                                    children: "Format: HH:MM:SS (e.g. 00:03:45)"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex-1 tw-min-w-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "tw-flex tw-items-center tw-gap-2 tw-mb-2",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        htmlFor: "modal-featured",
                                                                        className: "tw-block tw-text-sm tw-font-medium tw-text-textSeal",
                                                                        children: "Featured"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    id: "modal-featured",
                                                                    value: formData.isFeatured ? "F" : "NF",
                                                                    disabled: true,
                                                                    className: `${$7c320e41e081b01e$var$SELECT_BASE_CLASS} ${$7c320e41e081b01e$var$selectTextClass(true)}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "NF",
                                                                            children: "Non-Featured (NF)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "F",
                                                                            children: "Featured (F)"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-mt-3 tw-pt-4 tw-border-t tw-border-formInputBackground tw-pb-3",
                                                    children: [
                                                        recordingSaveError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "tw-text-westburyRed tw-text-xs tw-mb-3",
                                                            children: recordingSaveError
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-gap-2 tw-items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "secondary",
                                                                    label: "Cancel",
                                                                    onClick: handleRecordingCancel,
                                                                    disabled: !isRecordingSectionModified()
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "primary",
                                                                    label: recordingSaveLoading ? "Saving\u2026" : "Save Changes",
                                                                    onClick: handleSaveRecordingDetails,
                                                                    disabled: !isRecordingSectionModified() || recordingSaveLoading
                                                                }),
                                                                knownErrorTestEnabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "secondary",
                                                                    label: `Simulate error (${$7c320e41e081b01e$var$KNOWN_ERROR_TEST_SCENARIOS[simulateErrorIndex % $7c320e41e081b01e$var$KNOWN_ERROR_TEST_SCENARIOS.length].label})`,
                                                                    onClick: async ()=>{
                                                                        const scenario = $7c320e41e081b01e$var$KNOWN_ERROR_TEST_SCENARIOS[simulateErrorIndex % $7c320e41e081b01e$var$KNOWN_ERROR_TEST_SCENARIOS.length];
                                                                        setRecordingSaveError(await (0, $4e44ff72ec5a5d6e$export$3ad1f1ce31dd8e4a)(scenario.makeError(), "recording"));
                                                                        setSimulateErrorIndex((i)=>i + 1);
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: stacked ? "tw-border-t tw-border-formInputBackground tw-shrink-0" : "tw-border-l tw-border-formInputBackground"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: stacked ? "tw-p-3 tw-flex tw-flex-col tw-shrink-0" : "tw-pr-4 tw-p-3 tw-flex tw-flex-col tw-overflow-y-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-items-center tw-justify-between tw-mb-2 tw-pb-1.5 tw-border-b tw-border-formInputBackground tw-flex-shrink-0",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-text-white tw-font-semibold",
                                    children: "Release"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-space-y-4 tw-flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-flex-col tw-gap-4 tw-w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex-1 tw-min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "tw-flex tw-items-center tw-gap-2 tw-mb-2",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "modal-release-title",
                                                            className: `tw-block tw-text-sm tw-font-medium ${isFieldModified("release") ? "tw-text-white" : "tw-text-white"}`,
                                                            children: "Release Title"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c320e41e081b01e$var$ManualChangeWrap, {
                                                        edited: isFieldEdited("releaseTitle"),
                                                        changed: isFieldModified("release"),
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            id: "modal-release-title",
                                                            type: "text",
                                                            value: formData.release || "",
                                                            onChange: (e)=>handleFieldChange("release", e.target.value),
                                                            readOnly: !isReleaseEditable,
                                                            disabled: !isReleaseEditable,
                                                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)()
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex-1 tw-min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                htmlFor: "modal-year",
                                                                className: `tw-block tw-text-sm tw-font-medium ${isFieldModified("year") ? "tw-text-white" : "tw-text-white"}`,
                                                                children: "Year of Release"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                                children: "Optional"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c320e41e081b01e$var$ManualChangeWrap, {
                                                        edited: isFieldEdited("dateReleased"),
                                                        changed: isFieldModified("year"),
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            id: "modal-year",
                                                            type: "text",
                                                            value: formData.year ?? "",
                                                            onChange: (e)=>{
                                                                const yearValue = e.target.value.replace(/\D/g, "").slice(0, 4);
                                                                setYearError((0, $88d049fe01006cd7$export$44c3be0a49ff5d2e)(yearValue));
                                                                handleFieldChange("year", yearValue);
                                                            },
                                                            readOnly: !isReleaseEditable,
                                                            disabled: !isReleaseEditable,
                                                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                                                error: !!yearError
                                                            }),
                                                            placeholder: "YYYY",
                                                            maxLength: 4
                                                        })
                                                    }),
                                                    yearError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                                                        children: yearError
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        htmlFor: "modal-label-input",
                                                        className: `tw-block tw-text-sm tw-font-medium ${isFieldModified("label") ? "tw-text-white" : "tw-text-white"}`,
                                                        children: "Label (Multiple)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                        children: "Optional"
                                                    })
                                                ]
                                            }),
                                            labels.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-2 tw-min-h-[40px]",
                                                children: labels.map((label, index)=>{
                                                    const isLabelAdded = !originalValues?.labels?.includes(label);
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$e151e13a7e9f85a5), {
                                                        edited: addedLabelValues.has(label),
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: `tw-relative tw-inline-flex tw-items-center tw-gap-1 tw-rounded-xs tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-bg-formInputBackground tw-text-white ${!isReleaseEditable ? "tw-opacity-60" : ""}`,
                                                            children: [
                                                                isLabelAdded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "tw-absolute -tw-top-1 -tw-right-1 tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-surfacePurple tw-border tw-border-gray-900 tw-animate-pulse-slow"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: label
                                                                }),
                                                                isReleaseEditable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>removeMultipleValue(setLabels, index),
                                                                    className: "tw-ml-1 tw-text-textSeal hover:tw-text-white tw-flex tw-items-center",
                                                                    title: "Remove",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                        size: 12
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, index);
                                                })
                                            }),
                                            labels.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-textSeal tw-text-xs tw-mb-2",
                                                children: "None"
                                            }),
                                            isReleaseEditable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-flex tw-flex-col tw-gap-1.5",
                                                children: labelInputOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            id: "modal-label-input",
                                                            type: "text",
                                                            autoFocus: true,
                                                            placeholder: "Enter label",
                                                            value: labelInputValue,
                                                            onChange: (e)=>setLabelInputValue(e.target.value),
                                                            onKeyDown: (e)=>{
                                                                if (e.key === "Enter" && labelInputValue.trim()) {
                                                                    e.preventDefault();
                                                                    commitLabel();
                                                                } else if (e.key === "Escape") {
                                                                    setLabelInputValue("");
                                                                    setLabelInputOpen(false);
                                                                }
                                                            },
                                                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                                                className: "tw-flex-1"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-justify-end tw-gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "secondary",
                                                                    label: "Cancel",
                                                                    onClick: ()=>{
                                                                        setLabelInputValue("");
                                                                        setLabelInputOpen(false);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "primary",
                                                                    label: "Create",
                                                                    disabled: !labelInputValue.trim(),
                                                                    onClick: commitLabel
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tw-flex tw-justify-end",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "tw-text-sm tw-flex tw-items-center tw-text-textWhite hover:tw-text-textLime",
                                                        onClick: ()=>{
                                                            setLabelInputValue("");
                                                            setLabelInputOpen(true);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                className: "wi wi-20px wi-plus tw-mr-1"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "tw-underline",
                                                                children: "Add label"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            labelsError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                                                children: labelsError
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        htmlFor: "modal-catno-input",
                                                        className: `tw-block tw-text-sm tw-font-medium ${isFieldModified("catNumbers") ? "tw-text-white" : "tw-text-white"}`,
                                                        children: "Catalogue Number (Multiple)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                        children: "Optional"
                                                    })
                                                ]
                                            }),
                                            catNumbers.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-2 tw-min-h-[40px]",
                                                children: catNumbers.map((catNo, index)=>{
                                                    const isCatNoAdded = !originalValues?.catNumbers?.includes(catNo);
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473dabb7bb223c2d$export$e151e13a7e9f85a5), {
                                                        edited: addedCatNumberValues.has(catNo),
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: `tw-relative tw-inline-flex tw-items-center tw-gap-1 tw-rounded-xs tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-bg-formInputBackground tw-text-white ${!isReleaseEditable ? "tw-opacity-60" : ""}`,
                                                            children: [
                                                                isCatNoAdded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "tw-absolute -tw-top-1 -tw-right-1 tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-surfacePurple tw-border tw-border-gray-900 tw-animate-pulse-slow"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: catNo
                                                                }),
                                                                isReleaseEditable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>removeMultipleValue(setCatNumbers, index),
                                                                    className: "tw-ml-1 tw-text-textSeal hover:tw-text-white tw-flex tw-items-center",
                                                                    title: "Remove",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                        size: 12
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, index);
                                                })
                                            }),
                                            catNumbers.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-text-textSeal tw-text-xs tw-mb-2",
                                                children: "None"
                                            }),
                                            isReleaseEditable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-flex tw-flex-col tw-gap-1.5",
                                                children: catNoInputOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            id: "modal-catno-input",
                                                            type: "text",
                                                            autoFocus: true,
                                                            placeholder: "Enter catalogue number",
                                                            value: catNoInputValue,
                                                            onChange: (e)=>setCatNoInputValue(e.target.value),
                                                            onKeyDown: (e)=>{
                                                                if (e.key === "Enter" && catNoInputValue.trim()) {
                                                                    e.preventDefault();
                                                                    commitCatNo();
                                                                } else if (e.key === "Escape") {
                                                                    setCatNoInputValue("");
                                                                    setCatNoInputOpen(false);
                                                                }
                                                            },
                                                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                                                className: "tw-flex-1"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-justify-end tw-gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "secondary",
                                                                    label: "Cancel",
                                                                    onClick: ()=>{
                                                                        setCatNoInputValue("");
                                                                        setCatNoInputOpen(false);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "primary",
                                                                    label: "Create",
                                                                    disabled: !catNoInputValue.trim(),
                                                                    onClick: commitCatNo
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tw-flex tw-justify-end",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "tw-text-sm tw-flex tw-items-center tw-text-textWhite hover:tw-text-textLime",
                                                        onClick: ()=>{
                                                            setCatNoInputValue("");
                                                            setCatNoInputOpen(true);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                className: "wi wi-20px wi-plus tw-mr-1"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "tw-underline",
                                                                children: "Add catalogue number"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            catNumbersError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: `${(0, $bb6d544802d60420$export$a6bfce277b24cca2)} tw-mt-1`,
                                                children: catNumbersError
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-flex-col tw-gap-4 tw-w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex-1 tw-min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                htmlFor: "modal-format",
                                                                className: `tw-block tw-text-sm tw-font-medium ${isFieldModified("format") ? "tw-text-white" : "tw-text-white"}`,
                                                                children: "Format"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                                children: "Optional"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c320e41e081b01e$var$ManualChangeWrap, {
                                                        edited: isFieldEdited("format"),
                                                        changed: isFieldModified("format"),
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            id: "modal-format",
                                                            value: formData.format || "",
                                                            onChange: (e)=>handleFieldChange("format", e.target.value),
                                                            disabled: !isReleaseEditable,
                                                            className: `${$7c320e41e081b01e$var$SELECT_BASE_CLASS} ${$7c320e41e081b01e$var$selectTextClass(!!formData.format)}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select Format"
                                                                }),
                                                                availableFormats.map((format)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: format,
                                                                        children: format
                                                                    }, format))
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex-1 tw-min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-flex tw-items-center tw-justify-between tw-mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                htmlFor: "modal-type",
                                                                className: `tw-block tw-text-sm tw-font-medium ${isFieldModified("mediaType") ? "tw-text-white" : "tw-text-white"}`,
                                                                children: "Type"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: (0, $bb6d544802d60420$export$120f973cb24657d5),
                                                                children: "Optional"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c320e41e081b01e$var$ManualChangeWrap, {
                                                        edited: isFieldEdited("mediaType"),
                                                        changed: isFieldModified("mediaType"),
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            id: "modal-type",
                                                            value: formData.mediaType || "",
                                                            onChange: (e)=>handleFieldChange("mediaType", e.target.value),
                                                            disabled: !isReleaseEditable,
                                                            className: `${$7c320e41e081b01e$var$SELECT_BASE_CLASS} ${$7c320e41e081b01e$var$selectTextClass(!!formData.mediaType)}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select Type"
                                                                }),
                                                                availableTypes.map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: type,
                                                                        children: type
                                                                    }, type))
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    releaseSaveError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "tw-text-westburyRed tw-text-xs tw-mt-3",
                                        children: releaseSaveError
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-gap-2 tw-items-center tw-mt-3 tw-pt-4 tw-border-t tw-border-formInputBackground",
                                        children: [
                                            !isReleaseEditable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                        variant: "secondary",
                                                        label: "Edit Release Details",
                                                        onClick: ()=>setShowReleaseCorrectionModal(true)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                        variant: "secondary",
                                                        label: "Change Linked Release",
                                                        onClick: ()=>setShowChangeReleaseModal(true)
                                                    })
                                                ]
                                            }),
                                            isReleaseEditable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                        variant: "secondary",
                                                        label: "Cancel",
                                                        onClick: handleReleaseCancel
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                        variant: "primary",
                                                        label: releaseSaveLoading ? "Saving\u2026" : "Save Release Details",
                                                        onClick: handleSaveReleaseDetails,
                                                        disabled: releaseSaveLoading || !formData.release?.trim() || !!yearError
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: showReleaseCorrectionModal,
                onClose: ()=>setShowReleaseCorrectionModal(false),
                title: "Confirm Release Correction",
                modalClasses: "tw-max-w-md tw-w-full tw-mx-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-white tw-text-sm tw-mb-6",
                            children: "You are about to correct release data that is linked to multiple recordings. Do you wish to proceed?"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: ()=>setShowReleaseCorrectionModal(false)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Proceed",
                                    onClick: ()=>{
                                        setShowReleaseCorrectionModal(false);
                                        setIsReleaseEditable(true);
                                    // In a real implementation, this would trigger the release correction logic
                                    // For now, it's just a mock, so we enable editing
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $225524c18db7a507$export$ad612c67e8fe7176), {
                isOpen: showContributionModal,
                mode: contributionModalContext?.type ?? "add",
                initialValue: contributionModalForm,
                aliases: clientAliases,
                aliasesLoading: clientAliasesLoading,
                onClose: ()=>{
                    setShowContributionModal(false);
                    setContributionModalContext(null);
                },
                onSave: (payload)=>{
                    if (contributionModalContext?.type === "edit") {
                        const idx = contributionModalContext.index;
                        setContributions((prev)=>prev.map((c, i)=>i === idx ? payload : c));
                    } else if (contributionModalContext?.type === "add") setContributions((prev)=>[
                            ...prev,
                            payload
                        ]);
                    setShowContributionModal(false);
                    setContributionModalContext(null);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: unsavedItemWarning !== null,
                onClose: ()=>setUnsavedItemWarning(null),
                title: "Unsaved item",
                modalClasses: "tw-max-w-sm tw-w-full tw-mx-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "tw-text-white tw-text-sm tw-mb-6",
                            children: [
                                "You have a",
                                unsavedItemWarning === "ISRC" ? "n" : "",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: unsavedItemWarning
                                }),
                                " being entered. Please click",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Create"
                                }),
                                " to add it, or ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Cancel"
                                }),
                                ", before saving your changes."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-justify-end tw-gap-2",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                variant: "primary",
                                label: "Got it",
                                onClick: ()=>setUnsavedItemWarning(null)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: showRemoveContributionModal !== null,
                onClose: ()=>setShowRemoveContributionModal(null),
                title: "Remove Contribution",
                modalClasses: "tw-max-w-sm tw-w-full tw-mx-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "tw-text-white tw-text-sm tw-mb-6",
                            children: [
                                "Are you sure you want to remove",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: showRemoveContributionModal !== null ? (0, $f1q41.capitalize)(contributions[showRemoveContributionModal]?.contribution ?? "") : ""
                                }),
                                " ",
                                "from this recording?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: ()=>setShowRemoveContributionModal(null)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Remove",
                                    onClick: ()=>{
                                        if (showRemoveContributionModal !== null) {
                                            const removeIdx = showRemoveContributionModal;
                                            setContributions((prev)=>prev.filter((_, i)=>i !== removeIdx));
                                            if (contributionModalContext?.type === "edit" && contributionModalContext.index === removeIdx) {
                                                setShowContributionModal(false);
                                                setContributionModalContext(null);
                                            } else if (contributionModalContext?.type === "edit" && contributionModalContext.index > removeIdx) setContributionModalContext({
                                                type: "edit",
                                                index: contributionModalContext.index - 1
                                            });
                                            setShowRemoveContributionModal(null);
                                        }
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: artistActionModalIndex !== null,
                onClose: ()=>{
                    setArtistActionModalIndex(null);
                    setArtistActionConfirm(null);
                },
                title: artistActionConfirm === "demote" ? "Confirm Demote" : artistActionConfirm === "remove" ? "Confirm Remove" : "Artist Action",
                modalClasses: "tw-max-w-lg tw-w-full tw-mx-4",
                children: artistActionModalIndex !== null && artists[artistActionModalIndex] && (()=>{
                    const artist = artists[artistActionModalIndex];
                    const idx = artistActionModalIndex;
                    if (artistActionConfirm === "demote") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-mt-4 tw-space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "tw-text-white tw-text-sm",
                                children: [
                                    "Are you sure you want to demote",
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: artist.name
                                    }),
                                    " to Non-Featured?"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-justify-end tw-gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        label: "Cancel",
                                        onClick: ()=>setArtistActionConfirm(null)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        label: "Demote",
                                        onClick: ()=>{
                                            setDemotedArtists((prev)=>[
                                                    ...prev,
                                                    artist
                                                ]);
                                            setArtists((prev)=>prev.filter((_, i)=>i !== idx));
                                            setArtistActionModalIndex(null);
                                            setArtistActionConfirm(null);
                                        }
                                    })
                                ]
                            })
                        ]
                    });
                    if (artistActionConfirm === "remove") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-mt-4 tw-space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "tw-text-white tw-text-sm",
                                children: [
                                    "Are you sure you want to remove",
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: artist.name
                                    }),
                                    " from this recording?"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-justify-end tw-gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        label: "Cancel",
                                        onClick: ()=>setArtistActionConfirm(null)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        label: "Remove",
                                        onClick: ()=>{
                                            setArtists((prev)=>prev.filter((_, i)=>i !== idx));
                                            setArtistActionModalIndex(null);
                                            setArtistActionConfirm(null);
                                        }
                                    })
                                ]
                            })
                        ]
                    });
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-mt-4 tw-space-y-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "tw-text-white tw-text-sm",
                                children: [
                                    "What would you like to do with ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: artist.name
                                    }),
                                    "?"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-flex-row tw-gap-2 tw-justify-end tw-pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        label: "Demote to Non-Featured",
                                        extraClasses: "tw-flex-1 !tw-whitespace-normal !tw-h-auto tw-min-h-[32px] tw-py-1.5 tw-text-center",
                                        onClick: ()=>setArtistActionConfirm("demote")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        label: "Remove from Recording",
                                        extraClasses: "tw-flex-1 !tw-whitespace-normal !tw-h-auto tw-min-h-[32px] tw-py-1.5 tw-text-center",
                                        onClick: ()=>setArtistActionConfirm("remove")
                                    })
                                ]
                            })
                        ]
                    });
                })()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: pendingDuplicateIsrc !== null,
                onClose: ()=>{
                    setPendingDuplicateIsrc(null);
                    setPendingDuplicateMatches([]);
                },
                title: "Reassign ISRC",
                modalClasses: "tw-max-w-md tw-w-full tw-mx-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-white tw-text-sm tw-mb-3",
                            children: "This ISRC is currently assigned to:"
                        }),
                        pendingDuplicateMatches.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-mb-4 tw-space-y-1.5 tw-max-h-32 tw-overflow-y-auto",
                            children: pendingDuplicateMatches.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-bg-surfaceBlack90 tw-rounded tw-px-3 tw-py-2 tw-text-xs",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-text-white tw-font-medium",
                                            children: m.recordingTitle || "Untitled"
                                        }),
                                        m.artistName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-text-textSeal",
                                            children: m.artistName
                                        })
                                    ]
                                }, m.recordingId))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "tw-text-white tw-text-sm",
                            children: [
                                "Continuing will remove the ISRC from",
                                " ",
                                pendingDuplicateMatches.length === 1 ? "that recording" : "those recordings",
                                " ",
                                "and assign it to",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: formData.title || "this recording"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-2 tw-mt-5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: ()=>{
                                        setPendingDuplicateIsrc(null);
                                        setPendingDuplicateMatches([]);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Continue",
                                    onClick: ()=>{
                                        if (pendingDuplicateIsrc) {
                                            addMultipleValue(setIsrcs, pendingDuplicateIsrc);
                                            // Track all recordings this ISRC is being reassigned from
                                            if (pendingDuplicateMatches.length > 0) setConfirmedDuplicateIsrcs((prev)=>({
                                                    ...prev,
                                                    [pendingDuplicateIsrc]: pendingDuplicateMatches.map((m)=>({
                                                            recordingId: m.recordingId,
                                                            documentId: m.documentId
                                                        }))
                                                }));
                                            setIsrcInputValue("");
                                            setIsrcInputOpen(false);
                                            setPendingDuplicateIsrc(null);
                                            setPendingDuplicateMatches([]);
                                        }
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b44378a47b84f9b0$export$6327d397dd9387a), {
                isOpen: showCreateArtist,
                onClose: ()=>setShowCreateArtist(false),
                userId: userId,
                parentRecordingId: row?.id,
                onAdd: (entry)=>{
                    setArtists((prev)=>[
                            ...prev,
                            entry
                        ]);
                    setShowCreateArtist(false);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: pendingArtistName !== null,
                onClose: ()=>{
                    setPendingArtistName(null);
                    setPendingArtistId(null);
                    setPendingArtistFeatured("fa");
                },
                title: "Add artist",
                modalClasses: "tw-max-w-md tw-w-full tw-mx-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-4 tw-space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tw-block tw-text-textSeal tw-text-xs tw-font-medium tw-mb-1",
                                    children: "Artist"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-white tw-text-sm",
                                    children: pendingArtistName ?? ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tw-block tw-text-textSeal tw-text-xs tw-font-medium tw-mb-2",
                                    children: "Featured Status"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c320e41e081b01e$var$WmcSegmentedToggle, {
                                    leftLabel: "Featured",
                                    rightLabel: "Other Featured",
                                    isLeftSelected: pendingArtistFeatured === "fa",
                                    onSelectLeft: ()=>setPendingArtistFeatured("fa"),
                                    onSelectRight: ()=>setPendingArtistFeatured("ofa")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: ()=>{
                                        setPendingArtistName(null);
                                        setPendingArtistId(null);
                                        setPendingArtistMembers([]);
                                        setPendingArtistFeatured("fa");
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Add",
                                    onClick: ()=>{
                                        if (pendingArtistName) {
                                            setArtists((prev)=>[
                                                    ...prev,
                                                    {
                                                        name: pendingArtistName,
                                                        isFeatured: pendingArtistFeatured === "fa",
                                                        featuredStatus: pendingArtistFeatured,
                                                        id: pendingArtistId ?? undefined,
                                                        members: pendingArtistMembers.length > 0 ? pendingArtistMembers : undefined
                                                    }
                                                ]);
                                            setPendingArtistName(null);
                                            setPendingArtistId(null);
                                            setPendingArtistMembers([]);
                                            setPendingArtistFeatured("fa");
                                        }
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88d049fe01006cd7$export$334ef0499792785f), {
                isOpen: showChangeReleaseModal,
                onClose: ()=>setShowChangeReleaseModal(false),
                mode: "apply",
                userId: userId,
                row: row,
                current: {
                    release: formData.release,
                    year: formData.year,
                    format: formData.format,
                    mediaType: formData.mediaType
                },
                currentLabels: labels,
                currentCatNumbers: catNumbers,
                availableFormats: availableFormats,
                availableTypes: availableTypes,
                onApplied: (updatedRow)=>{
                    setFormData((prev)=>({
                            ...prev,
                            release: updatedRow.release,
                            year: updatedRow.year ?? "",
                            format: updatedRow.format ?? "",
                            mediaType: updatedRow.mediaType ?? ""
                        }));
                    setLabels(updatedRow.labelsArray);
                    setCatNumbers(updatedRow.catNumbersArray);
                    onSave(updatedRow);
                    setEditsVersion((v)=>v + 1);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: showLiveToYesModal,
                onClose: ()=>{
                    setShowLiveToYesModal(false);
                    setLiveToYesNote("");
                },
                title: (0, $e353c670efa3bb12$export$6a8f182e25b88c10)(formData.live) ? "Update Live Information" : "Mark Recording as Live",
                modalClasses: "tw-max-w-md tw-w-full tw-mx-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-white tw-text-sm tw-mb-4",
                            children: "Provide Live information for this recording. This is stored on the Live field and can be updated later, but not removed."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            htmlFor: "live-to-yes-note",
                            className: `${(0, $bb6d544802d60420$export$245c09d1fdadc2df)} tw-mb-2`,
                            children: [
                                "Live Information",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $bb6d544802d60420$export$a6bfce277b24cca2),
                                    children: "(required)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                            id: "live-to-yes-note",
                            value: liveToYesNote,
                            onChange: (e)=>setLiveToYesNote(e.target.value),
                            placeholder: "e.g. Live in London, 1989",
                            rows: 3,
                            className: (0, $bb6d544802d60420$export$cc3b8b2da9fb3bff)({
                                kind: "textarea"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-2 tw-mt-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: ()=>{
                                        setShowLiveToYesModal(false);
                                        setLiveToYesNote("");
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Confirm",
                                    disabled: !liveToYesNote.trim(),
                                    onClick: ()=>{
                                        // Set the live descriptor on its own. It lives solely in the
                                        // `live` field — no recordingVersion op is involved.
                                        handleFieldChange("live", liveToYesNote.trim());
                                        setShowLiveToYesModal(false);
                                        setLiveToYesNote("");
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: showRevertModal,
                onClose: ()=>{
                    setShowRevertModal(false);
                    setRevertTarget(null);
                },
                title: "Confirm Revert",
                modalClasses: "tw-max-w-md tw-w-full tw-mx-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-white tw-text-sm tw-mb-6",
                            children: "Do you want to revert to the original value?"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Cancel",
                                    onClick: ()=>{
                                        setShowRevertModal(false);
                                        setRevertTarget(null);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    label: "Revert",
                                    onClick: ()=>{
                                        if (revertTarget) handleRevert(revertTarget.type, revertTarget.field);
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});


/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 

var $acw62 = parcelRequire("acw62");


// Calculate adjusted widths ensuring minimum 10% per section
function $814c1923bdb44d7d$var$calculateAdjustedWidths(data) {
    const MIN_WIDTH = 5;
    const total = data.reduce((sum, item)=>sum + item.value, 0);
    const widths = new Map();
    // Calculate natural percentages
    const naturalPercentages = data.map((item)=>({
            id: item.id,
            percentage: item.value / total * 100,
            value: item.value
        }));
    // Separate items into those below and above minimum
    const belowMin = naturalPercentages.filter((item)=>item.percentage < MIN_WIDTH);
    const aboveMin = naturalPercentages.filter((item)=>item.percentage >= MIN_WIDTH);
    // Calculate space used by minimum widths
    const minWidthSpace = belowMin.length * MIN_WIDTH;
    // Calculate remaining space for proportional distribution
    const remainingSpace = 100 - minWidthSpace;
    // Calculate total value of items above minimum
    const aboveMinTotal = aboveMin.reduce((sum, item)=>sum + item.value, 0);
    // Set minimum widths for items below threshold
    belowMin.forEach((item)=>{
        widths.set(item.id, MIN_WIDTH);
    });
    // Distribute remaining space proportionally among items above minimum
    aboveMin.forEach((item)=>{
        const proportionalWidth = item.value / aboveMinTotal * remainingSpace;
        widths.set(item.id, proportionalWidth);
    });
    return widths;
}
function $814c1923bdb44d7d$export$3695c2f14e8c6908({ data: data, onFilterChange: onFilterChange }) {
    const [activeFilter, setActiveFilter] = (0, $acw62.useState)(null);
    const [hoveredCategory, setHoveredCategory] = (0, $acw62.useState)(null);
    // Filter out items with 0 value
    const filteredData = data.filter((item)=>item.value > 0);
    const total = filteredData.reduce((sum, item)=>sum + item.value, 0);
    const activeCategory = filteredData.find((c)=>c.id === activeFilter);
    const adjustedWidths = $814c1923bdb44d7d$var$calculateAdjustedWidths(filteredData);
    const handleBarClick = (categoryId)=>{
        const newFilter = activeFilter === categoryId ? null : categoryId;
        setActiveFilter(newFilter);
        onFilterChange?.(newFilter);
    };
    const handleReset = ()=>{
        setActiveFilter(null);
        onFilterChange?.(null);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-w-full tw-rounded-lg tw-flex tw-gap-4 tw-items-end",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-h-full tw-flex tw-items-end tw-pb-5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-text-lg tw-font-semibold tw-text-white tw-h-8",
                    children: "Role Data Quality"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex-grow",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-end tw-items-center tw-mb-2",
                        children: !activeFilter ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-text-sm tw-text-gray-400",
                            children: "Click section to filter"
                        }) : activeCategory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-items-center tw-gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-text-sm tw-text-gray-400",
                                    children: [
                                        "Filtering:",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-text-white tw-font-medium",
                                            children: activeCategory.label
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    onClick: handleReset,
                                    variant: "secondary",
                                    label: "Reset Filter"
                                })
                            ]
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-relative",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-relative tw-flex tw-gap-1",
                                children: filteredData.map((category, index)=>{
                                    const adjustedWidth = adjustedWidths.get(category.id) || 0;
                                    const isActive = activeFilter === category.id;
                                    const naturalPercentage = (category.value / total * 100).toFixed(1);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `tw-relative tw-gap-1 tw-flex tw-flex-col tw-items-end tw-justify-end tw-cursor-pointer tw-transition-all tw-duration-200 ${isActive ? "tw-opacity-100" : activeFilter ? "tw-opacity-40" : "tw-opacity-100"}`,
                                        style: {
                                            width: `calc(${adjustedWidth}%)`,
                                            borderRight: "2px solid #858d93"
                                        },
                                        onClick: ()=>handleBarClick(category.id),
                                        onMouseEnter: ()=>setHoveredCategory(category.id),
                                        onMouseLeave: ()=>setHoveredCategory(null),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-w-full tw-flex tw-justify-end tw-pr-1",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tw-w-5 tw-h-5",
                                                    style: {
                                                        color: category.color
                                                    },
                                                    children: category.icon
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-flex tw-justify-end tw-items-center tw-font-semibold tw-text-sm tw-w-full tw-text-right tw-pr-1 tw-h-8",
                                                style: {
                                                    backgroundColor: category.color,
                                                    color: category.text
                                                },
                                                children: category.value.toLocaleString("en-US")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "tw-text-gray-400 tw-text-xs tw-font-medium tw-pr-1",
                                                children: [
                                                    naturalPercentage,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }, category.id);
                                })
                            }),
                            filteredData.map((category, index)=>{
                                const isHovered = hoveredCategory === category.id;
                                if (!isHovered) return null;
                                const adjustedWidth = adjustedWidths.get(category.id) || 0;
                                // Calculate cumulative position
                                let cumulativePosition = 0;
                                for(let i = 0; i < index; i++)cumulativePosition += adjustedWidths.get(filteredData[i].id) || 0;
                                const sectionStart = cumulativePosition;
                                const sectionEnd = cumulativePosition + adjustedWidth;
                                const sectionCenter = (sectionStart + sectionEnd) / 2;
                                // Determine tooltip positioning
                                let tooltipPositionStyle = {
                                    left: `${sectionCenter}%`,
                                    transform: "translateX(-50%)"
                                };
                                let arrowPositionClasses = "tw-left-1/2 tw-transform tw--translate-x-1/2";
                                if (sectionCenter < 33) {
                                    tooltipPositionStyle = {
                                        left: `${sectionStart}%`
                                    };
                                    arrowPositionClasses = "tw-left-4";
                                } else if (sectionCenter > 66) {
                                    tooltipPositionStyle = {
                                        right: `${100 - sectionEnd}%`
                                    };
                                    arrowPositionClasses = "tw-right-4";
                                }
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-absolute tw-h-[36px] tw-bottom-full tw-mb-2 tw-px-3 tw-py-2 tw-bg-[#2a2a2a] tw-text-white tw-text-xs tw-rounded-lg tw-shadow-xl tw-whitespace-nowrap tw-z-50 tw-border tw-border-gray-700 tw-pointer-events-none",
                                    style: {
                                        ...tooltipPositionStyle,
                                        top: "-18px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex tw-items-center tw-gap-1.5 tw-justify-center",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tw-w-5 tw-h-5",
                                                    style: {
                                                        color: category.color
                                                    },
                                                    children: category.icon
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "tw-font-semibold",
                                                    children: category.label
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `tw-absolute tw-top-full ${arrowPositionClasses} tw--mt-px`,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-border-[5px] tw-border-transparent tw-border-t-[#2a2a2a]"
                                            })
                                        })
                                    ]
                                }, `tooltip-${category.id}`);
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $814c1923bdb44d7d$export$bb6137e35f7ba36c() {
    return [
        {
            id: "verified",
            label: "Verified (No Effort)",
            value: 45,
            text: "white",
            color: "#22c55e",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                className: "tw-w-3.5 tw-h-3.5"
            }),
            description: "Contributions that have been verified and require no additional effort"
        },
        {
            id: "inferred",
            label: "Inferred (Low Effort)",
            value: 30,
            text: "white",
            color: "#eab308",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                className: "tw-w-3.5 tw-h-3.5"
            }),
            description: "Contributions that can be inferred with low verification effort"
        },
        {
            id: "credited",
            label: "Credited (Mid Effort)",
            value: 15,
            text: "white",
            color: "#f97316",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $604e08b57548a73d$export$2e2bcd8739ae039), {
                className: "tw-w-3.5 tw-h-3.5"
            }),
            description: "Contributions that are credited and require moderate verification effort"
        },
        {
            id: "unverified",
            label: "Unverified (High Effort)",
            value: 5,
            text: "white",
            color: "#ef4444",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                className: "tw-w-3.5 tw-h-3.5"
            }),
            description: "Contributions that are unverified and require high verification effort"
        },
        {
            id: "unknown",
            label: "Unknown (Max Effort)",
            value: 2,
            text: "white",
            color: "#6b7280",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                className: "tw-w-3.5 tw-h-3.5"
            }),
            description: "Contributions with unknown status requiring maximum verification effort"
        }
    ];
}




parcelRequire("acw62");
/**
 * A translucent loading overlay meant to be placed inside a `tw-relative`
 * container that wraps a data table. It keeps the current rows visible
 * (dimmed) underneath while a backend request is in flight, so the user gets
 * immediate feedback that an operation (page change, search, filter, sort) is
 * being processed instead of the table appearing frozen/unresponsive.
 */ const $618f8aff4a5696a2$var$TableLoadingOverlay = ({ active: active, label: label = "Loading" })=>{
    if (!active) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-busy": "true",
        className: "tw-absolute tw-inset-0 tw-z-40 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-40",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-bg-neutral-800 tw-px-4 tw-py-2 tw-text-sm tw-text-white tw-shadow-lg",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-w-5 tw-h-5 tw-border-2 tw-border-t-transparent tw-border-white tw-rounded-full tw-animate-spin"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        label,
                        "\u2026"
                    ]
                })
            ]
        })
    });
};
var $618f8aff4a5696a2$export$2e2bcd8739ae039 = $618f8aff4a5696a2$var$TableLoadingOverlay;




// packages/ag-grid-community/src/agStack/events/localEventService.ts
var $437b23f6a393c3bf$export$820da7696a401cdc = class {
    constructor(){
        this.allSyncListeners = /* @__PURE__ */ new Map();
        this.allAsyncListeners = /* @__PURE__ */ new Map();
        this.globalSyncListeners = /* @__PURE__ */ new Set();
        this.globalAsyncListeners = /* @__PURE__ */ new Set();
        this.asyncFunctionsQueue = [];
        this.scheduled = false;
        // using an object performs better than a Set for the number of different events we have
        this.firedEvents = {};
    }
    setFrameworkOverrides(frameworkOverrides) {
        this.frameworkOverrides = frameworkOverrides;
    }
    getListeners(eventType, async, autoCreateListenerCollection) {
        const listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
        let listeners = listenerMap.get(eventType);
        if (!listeners && autoCreateListenerCollection) {
            listeners = /* @__PURE__ */ new Set();
            listenerMap.set(eventType, listeners);
        }
        return listeners;
    }
    noRegisteredListenersExist() {
        return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
    }
    addEventListener(eventType, listener, async = false) {
        this.getListeners(eventType, async, true).add(listener);
    }
    removeEventListener(eventType, listener, async = false) {
        const listeners = this.getListeners(eventType, async, false);
        if (!listeners) return;
        listeners.delete(listener);
        if (listeners.size === 0) (async ? this.allAsyncListeners : this.allSyncListeners).delete(eventType);
    }
    addGlobalListener(listener, async = false) {
        this.getGlobalListeners(async).add(listener);
    }
    removeGlobalListener(listener, async = false) {
        this.getGlobalListeners(async).delete(listener);
    }
    dispatchEvent(event) {
        this.dispatchToListeners(event, true);
        this.dispatchToListeners(event, false);
        this.firedEvents[event.type] = true;
    }
    dispatchEventOnce(event) {
        if (!this.firedEvents[event.type]) this.dispatchEvent(event);
    }
    dispatchToListeners(event, async) {
        const eventType = event.type;
        if (async && "event" in event) {
            const browserEvent = event.event;
            if (browserEvent instanceof Event) event.eventPath = browserEvent.composedPath();
        }
        const { frameworkOverrides: frameworkOverrides } = this;
        const runCallback = (func)=>{
            const callback = frameworkOverrides ? ()=>frameworkOverrides.wrapIncoming(func) : func;
            if (async) this.dispatchAsync(callback);
            else callback();
        };
        const originalListeners = this.getListeners(eventType, async, false);
        if ((originalListeners?.size ?? 0) > 0) {
            const listeners = new Set(originalListeners);
            for (const listener of listeners){
                if (!originalListeners?.has(listener)) continue;
                runCallback(()=>listener(event));
            }
        }
        const globalListenersSrc = this.getGlobalListeners(async);
        if (globalListenersSrc.size > 0) {
            const globalListeners = new Set(globalListenersSrc);
            for (const listener of globalListeners)runCallback(()=>listener(eventType, event));
        }
    }
    getGlobalListeners(async) {
        return async ? this.globalAsyncListeners : this.globalSyncListeners;
    }
    // this gets called inside the grid's thread, for each event that it
    // wants to set async. the grid then batches the events into one setTimeout()
    // because setTimeout() is an expensive operation. ideally we would have
    // each event in it's own setTimeout(), but we batch for performance.
    dispatchAsync(func) {
        this.asyncFunctionsQueue.push(func);
        if (!this.scheduled) {
            const flush = ()=>{
                window.setTimeout(this.flushAsyncQueue.bind(this), 0);
            };
            this.frameworkOverrides ? this.frameworkOverrides.wrapIncoming(flush) : flush();
            this.scheduled = true;
        }
    }
    // this happens in the next VM turn only, and empties the queue of events
    flushAsyncQueue() {
        this.scheduled = false;
        const queueCopy = this.asyncFunctionsQueue.slice();
        this.asyncFunctionsQueue = [];
        for (const func of queueCopy)func();
    }
};
// packages/ag-grid-community/src/agStack/utils/generic.ts
function $437b23f6a393c3bf$export$4978424c4f7b5fc0(value) {
    if (value == null || value === "") return null;
    return value;
}
function $437b23f6a393c3bf$export$25d27f17d3af40f7(value) {
    return value != null && value !== "";
}
function $437b23f6a393c3bf$export$672d9e47bc342bac(value) {
    return !$437b23f6a393c3bf$export$25d27f17d3af40f7(value);
}
function $437b23f6a393c3bf$export$2a74c29220d5c88e(value) {
    return value != null && typeof value.toString === "function" ? value.toString() : null;
}
function $437b23f6a393c3bf$export$dbc2068cc90f5875(val1, val2) {
    const val1Json = val1 ? JSON.stringify(val1) : null;
    const val2Json = val2 ? JSON.stringify(val2) : null;
    return val1Json === val2Json;
}
function $437b23f6a393c3bf$export$b0cca9f3c87c8df8(valueA, valueB, accentedCompare = false) {
    const valueAMissing = valueA == null;
    const valueBMissing = valueB == null;
    if (valueA?.toNumber) valueA = valueA.toNumber();
    if (valueB?.toNumber) valueB = valueB.toNumber();
    if (valueAMissing && valueBMissing) return 0;
    if (valueAMissing) return -1;
    if (valueBMissing) return 1;
    function doQuickCompare(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    if (typeof valueA !== "string") return doQuickCompare(valueA, valueB);
    if (!accentedCompare) return doQuickCompare(valueA, valueB);
    try {
        return valueA.localeCompare(valueB);
    } catch (e) {
        return doQuickCompare(valueA, valueB);
    }
}
// packages/ag-grid-community/src/agStack/utils/string.ts
var $437b23f6a393c3bf$var$reUnescapedHtml = /[&<>"']/g;
var $437b23f6a393c3bf$var$HTML_ESCAPES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $437b23f6a393c3bf$export$a16cfb6652fe466f(toEscape) {
    return toEscape?.toString().toString() ?? null;
}
function $437b23f6a393c3bf$export$3df06b741968da82(toEscape) {
    return $437b23f6a393c3bf$export$a16cfb6652fe466f(toEscape)?.replace($437b23f6a393c3bf$var$reUnescapedHtml, (chr)=>$437b23f6a393c3bf$var$HTML_ESCAPES[chr]) ?? null;
}
// packages/ag-grid-community/src/agStack/utils/document.ts
function $437b23f6a393c3bf$export$1911dd00c79744c0(beans) {
    return beans.eRootDiv.getRootNode();
}
function $437b23f6a393c3bf$export$16bc98d422315038(beans) {
    return $437b23f6a393c3bf$export$1911dd00c79744c0(beans).activeElement;
}
function $437b23f6a393c3bf$export$f63d0991874c6f81(beans) {
    const { gos: gos, eRootDiv: eRootDiv } = beans;
    let result = null;
    const optionsGetDocument = gos.get("getDocument");
    if (optionsGetDocument && $437b23f6a393c3bf$export$25d27f17d3af40f7(optionsGetDocument)) result = optionsGetDocument();
    else if (eRootDiv) result = eRootDiv.ownerDocument;
    if (result && $437b23f6a393c3bf$export$25d27f17d3af40f7(result)) return result;
    return document;
}
function $437b23f6a393c3bf$export$8ff9eef09a45371f(beans) {
    const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
    return activeEl === null || activeEl === $437b23f6a393c3bf$export$f63d0991874c6f81(beans).body;
}
function $437b23f6a393c3bf$var$_getWindow(beans) {
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    return eDocument.defaultView || window;
}
function $437b23f6a393c3bf$export$50c54e860701cf22(beans) {
    let rootNode = null;
    let targetEl = null;
    try {
        rootNode = $437b23f6a393c3bf$export$f63d0991874c6f81(beans).fullscreenElement;
    } catch (e) {} finally{
        if (!rootNode) rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const body = rootNode.querySelector("body");
        if (body) targetEl = body;
        else if (rootNode instanceof ShadowRoot) targetEl = rootNode;
        else if (rootNode instanceof Document) targetEl = rootNode?.documentElement;
        else targetEl = rootNode;
    }
    return targetEl;
}
function $437b23f6a393c3bf$var$_getBodyWidth(beans) {
    const body = $437b23f6a393c3bf$export$50c54e860701cf22(beans);
    return body?.clientWidth ?? (window.innerWidth || -1);
}
function $437b23f6a393c3bf$var$_getBodyHeight(beans) {
    const body = $437b23f6a393c3bf$export$50c54e860701cf22(beans);
    return body?.clientHeight ?? (window.innerHeight || -1);
}
// packages/ag-grid-community/src/agStack/utils/aria.ts
function $437b23f6a393c3bf$var$_toggleAriaAttribute(element, attribute, value) {
    if (value == null || typeof value === "string" && value == "") $437b23f6a393c3bf$var$_removeAriaAttribute(element, attribute);
    else $437b23f6a393c3bf$var$_setAriaAttribute(element, attribute, value);
}
function $437b23f6a393c3bf$var$_setAriaAttribute(element, attribute, value) {
    element.setAttribute($437b23f6a393c3bf$var$_ariaAttributeName(attribute), value.toString());
}
function $437b23f6a393c3bf$var$_removeAriaAttribute(element, attribute) {
    element.removeAttribute($437b23f6a393c3bf$var$_ariaAttributeName(attribute));
}
function $437b23f6a393c3bf$var$_ariaAttributeName(attribute) {
    return `aria-${attribute}`;
}
function $437b23f6a393c3bf$export$f8d01fa01787902(element, role) {
    if (role) element.setAttribute("role", role);
    else element.removeAttribute("role");
}
function $437b23f6a393c3bf$var$_getAriaSortState(sortDirection) {
    let sort;
    if (sortDirection === "asc") sort = "ascending";
    else if (sortDirection === "desc") sort = "descending";
    else if (sortDirection === "mixed") sort = "other";
    else sort = "none";
    return sort;
}
function $437b23f6a393c3bf$export$70c3a20563598672(element) {
    return Number.parseInt(element.getAttribute("aria-posinset"), 10);
}
function $437b23f6a393c3bf$var$_getAriaLabel(element) {
    return element.getAttribute("aria-label");
}
function $437b23f6a393c3bf$export$e81cb0dd07f289f6(element, label) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "label", label);
}
function $437b23f6a393c3bf$export$84233c40c4c74001(element, labelledBy) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "labelledby", labelledBy);
}
function $437b23f6a393c3bf$export$3c2bc877474a7797(element, describedby) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "describedby", describedby);
}
function $437b23f6a393c3bf$var$_setAriaLive(element, live) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "live", live);
}
function $437b23f6a393c3bf$var$_setAriaAtomic(element, atomic) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "atomic", atomic);
}
function $437b23f6a393c3bf$var$_setAriaRelevant(element, relevant) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "relevant", relevant);
}
function $437b23f6a393c3bf$export$fd1450327e6900f2(element, invalid) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "invalid", invalid);
}
function $437b23f6a393c3bf$export$9eaf1f20171625e8(element, level) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "level", level);
}
function $437b23f6a393c3bf$export$7ed376f43c6f2bbd(element, disabled) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "disabled", disabled);
}
function $437b23f6a393c3bf$export$ee52c2b3744c455d(element, hidden) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "hidden", hidden);
}
function $437b23f6a393c3bf$export$5db804730c3c8346(element, descendantId) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "activedescendant", descendantId);
}
function $437b23f6a393c3bf$export$3ad3518dddf15485(element, expanded) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "expanded", expanded);
}
function $437b23f6a393c3bf$export$2254dfb132f01330(element) {
    $437b23f6a393c3bf$var$_removeAriaAttribute(element, "expanded");
}
function $437b23f6a393c3bf$export$3d494c2007bbcac1(element, setsize) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "setsize", setsize);
}
function $437b23f6a393c3bf$export$c3d3aede41065a84(element, position) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "posinset", position);
}
function $437b23f6a393c3bf$var$_setAriaMultiSelectable(element, multiSelectable) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "multiselectable", multiSelectable);
}
function $437b23f6a393c3bf$export$1ad8496b26b660f8(element, rowCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowcount", rowCount);
}
function $437b23f6a393c3bf$export$ba731dedf9d88615(element, rowIndex) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowindex", rowIndex);
}
function $437b23f6a393c3bf$var$_setAriaRowSpan(element, spanCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowspan", spanCount);
}
function $437b23f6a393c3bf$export$56744a26086b5898(element, colCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colcount", colCount);
}
function $437b23f6a393c3bf$export$84b73ecd0b234e89(element, colIndex) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colindex", colIndex);
}
function $437b23f6a393c3bf$export$371d80f0281454ce(element, colSpan) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colspan", colSpan);
}
function $437b23f6a393c3bf$export$c8dd030b968c6fd2(element, sort) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "sort", sort);
}
function $437b23f6a393c3bf$export$26c7aa61eda05134(element) {
    $437b23f6a393c3bf$var$_removeAriaAttribute(element, "sort");
}
function $437b23f6a393c3bf$export$c22e3722e8a33469(element, selected) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "selected", selected);
}
function $437b23f6a393c3bf$export$43b4d6c0ec0fa4c7(element, checked) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "checked", checked === void 0 ? "mixed" : checked);
}
function $437b23f6a393c3bf$export$26fd6a3f123d4e67(controllerElement, controlledId) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(controllerElement, "controls", controlledId);
}
function $437b23f6a393c3bf$export$6ff31a4a210c60ad(controllerElement, controlledElement) {
    $437b23f6a393c3bf$export$26fd6a3f123d4e67(controllerElement, controlledElement.id);
    $437b23f6a393c3bf$export$84233c40c4c74001(controlledElement, controllerElement.id);
}
function $437b23f6a393c3bf$var$_setAriaOwns(ownerElement, ownedId) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(ownerElement, "owns", ownedId);
}
function $437b23f6a393c3bf$export$668d180e9cbef6da(element, hasPopup) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "haspopup", hasPopup === false ? null : hasPopup);
}
function $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, state) {
    return state === void 0 ? translate("ariaIndeterminate", "indeterminate") : state === true ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
}
// packages/ag-grid-community/src/agStack/utils/dom.ts
function $437b23f6a393c3bf$export$605571c1b2992cfe(element, elementClass, otherElementClass) {
    const parent = element.parentElement;
    let sibling = parent && parent.firstChild;
    while(sibling){
        if (elementClass) sibling.classList.toggle(elementClass, sibling === element);
        if (otherElementClass) sibling.classList.toggle(otherElementClass, sibling !== element);
        sibling = sibling.nextSibling;
    }
}
var $437b23f6a393c3bf$var$FOCUSABLE_SELECTOR = "[tabindex], input, select, button, textarea, [href]";
var $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function $437b23f6a393c3bf$var$_isFocusableFormField(element) {
    if (!element) return false;
    const isFocusable = element.matches("input, select, button, textarea");
    if (!isFocusable) return false;
    const isNotFocusable = element.matches($437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE);
    if (!isNotFocusable) return false;
    return $437b23f6a393c3bf$export$2badf4aa566524cb(element);
}
function $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, displayed, options = {}) {
    const { skipAriaHidden: skipAriaHidden } = options;
    element.classList.toggle("ag-hidden", !displayed);
    if (!skipAriaHidden) $437b23f6a393c3bf$export$ee52c2b3744c455d(element, !displayed);
}
function $437b23f6a393c3bf$export$a6c2c477cd60daa8(element, visible, options = {}) {
    const { skipAriaHidden: skipAriaHidden } = options;
    element.classList.toggle("ag-invisible", !visible);
    if (!skipAriaHidden) $437b23f6a393c3bf$export$ee52c2b3744c455d(element, !visible);
}
function $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element, disabled) {
    const attributeName = "disabled";
    const addOrRemoveDisabledAttribute = disabled ? (e)=>e.setAttribute(attributeName, "") : (e)=>e.removeAttribute(attributeName);
    addOrRemoveDisabledAttribute(element);
    const inputs = element.querySelectorAll("input") ?? [];
    for (const input of inputs)addOrRemoveDisabledAttribute(input);
}
function $437b23f6a393c3bf$var$_isElementChildOfClass(element, cls, maxNest) {
    let counter = 0;
    while(element){
        if (element.classList.contains(cls)) return true;
        element = element.parentElement;
        if (typeof maxNest == "number") {
            if (++counter > maxNest) break;
        } else if (element === maxNest) break;
    }
    return false;
}
function $437b23f6a393c3bf$var$_getElementSize(el) {
    const { height: height, width: width, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth, borderLeftWidth: borderLeftWidth, paddingTop: paddingTop, paddingRight: paddingRight, paddingBottom: paddingBottom, paddingLeft: paddingLeft, marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, boxSizing: boxSizing } = window.getComputedStyle(el);
    const pf = Number.parseFloat;
    return {
        height: pf(height || "0"),
        width: pf(width || "0"),
        borderTopWidth: pf(borderTopWidth || "0"),
        borderRightWidth: pf(borderRightWidth || "0"),
        borderBottomWidth: pf(borderBottomWidth || "0"),
        borderLeftWidth: pf(borderLeftWidth || "0"),
        paddingTop: pf(paddingTop || "0"),
        paddingRight: pf(paddingRight || "0"),
        paddingBottom: pf(paddingBottom || "0"),
        paddingLeft: pf(paddingLeft || "0"),
        marginTop: pf(marginTop || "0"),
        marginRight: pf(marginRight || "0"),
        marginBottom: pf(marginBottom || "0"),
        marginLeft: pf(marginLeft || "0"),
        boxSizing: boxSizing
    };
}
function $437b23f6a393c3bf$export$c20e968103d9c16e(el) {
    const size = $437b23f6a393c3bf$var$_getElementSize(el);
    if (size.boxSizing === "border-box") return size.height - size.paddingTop - size.paddingBottom - size.borderTopWidth - size.borderBottomWidth;
    return size.height;
}
function $437b23f6a393c3bf$export$cc615e4191ec3e0c(el) {
    const size = $437b23f6a393c3bf$var$_getElementSize(el);
    if (size.boxSizing === "border-box") return size.width - size.paddingLeft - size.paddingRight - size.borderLeftWidth - size.borderRightWidth;
    return size.width;
}
function $437b23f6a393c3bf$export$d23c22492e0f7c0c(el) {
    const { height: height, marginBottom: marginBottom, marginTop: marginTop } = $437b23f6a393c3bf$var$_getElementSize(el);
    return Math.floor(height + marginBottom + marginTop);
}
function $437b23f6a393c3bf$export$642efcb17474eb51(el) {
    const { width: width, marginLeft: marginLeft, marginRight: marginRight } = $437b23f6a393c3bf$var$_getElementSize(el);
    return Math.floor(width + marginLeft + marginRight);
}
function $437b23f6a393c3bf$var$_getElementRectWithOffset(el) {
    const offsetElementRect = el.getBoundingClientRect();
    const { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth } = $437b23f6a393c3bf$var$_getElementSize(el);
    return {
        top: offsetElementRect.top + (borderTopWidth || 0),
        left: offsetElementRect.left + (borderLeftWidth || 0),
        right: offsetElementRect.right + (borderRightWidth || 0),
        bottom: offsetElementRect.bottom + (borderBottomWidth || 0)
    };
}
function $437b23f6a393c3bf$var$_getScrollLeft(element, rtl) {
    let scrollLeft = element.scrollLeft;
    if (rtl) scrollLeft = Math.abs(scrollLeft);
    return scrollLeft;
}
function $437b23f6a393c3bf$var$_setScrollLeft(element, value, rtl) {
    if (rtl) value *= -1;
    element.scrollLeft = value;
}
function $437b23f6a393c3bf$export$69e6e10709eabd91(el) {
    while(el?.firstChild)el.firstChild.remove();
}
function $437b23f6a393c3bf$export$dd4d52e41fb4cef5(node) {
    if (node?.parentNode) node.remove();
}
function $437b23f6a393c3bf$var$_isInDOM(element) {
    return !!element.offsetParent;
}
function $437b23f6a393c3bf$export$2badf4aa566524cb(element) {
    if (element.checkVisibility) return element.checkVisibility({
        checkVisibilityCSS: true
    });
    const isHidden = !$437b23f6a393c3bf$var$_isInDOM(element) || window.getComputedStyle(element).visibility !== "visible";
    return !isHidden;
}
function $437b23f6a393c3bf$export$b1f57d075ca6d5fb(template) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = (template || "").trim();
    return tempDiv.firstChild;
}
function $437b23f6a393c3bf$var$_ensureDomOrder(eContainer, eChild, eChildBefore) {
    if (eChildBefore && eChildBefore.nextSibling === eChild) return;
    if (!eContainer.firstChild) eContainer.appendChild(eChild);
    else if (eChildBefore) {
        if (eChildBefore.nextSibling) eContainer.insertBefore(eChild, eChildBefore.nextSibling);
        else eContainer.appendChild(eChild);
    } else if (eContainer.firstChild && eContainer.firstChild !== eChild) eContainer.insertAdjacentElement("afterbegin", eChild);
}
function $437b23f6a393c3bf$var$_setDomChildOrder(eContainer, orderedChildren) {
    for(let i = 0; i < orderedChildren.length; i++){
        const correctCellAtIndex = orderedChildren[i];
        const actualCellAtIndex = eContainer.children[i];
        if (actualCellAtIndex !== correctCellAtIndex) eContainer.insertBefore(correctCellAtIndex, actualCellAtIndex);
    }
}
function $437b23f6a393c3bf$var$_camelCaseToHyphenated(camelCase) {
    return camelCase.replace(/[A-Z]/g, (s)=>`-${s.toLocaleLowerCase()}`);
}
function $437b23f6a393c3bf$var$_addStylesToElement(eElement, styles) {
    if (!styles) return;
    for (const key of Object.keys(styles)){
        const value = styles[key];
        if (!key?.length || value == null) continue;
        const parsedKey = $437b23f6a393c3bf$var$_camelCaseToHyphenated(key);
        const valueAsString = value.toString();
        const parsedValue = valueAsString.replace(/\s*!important/g, "");
        const priority = parsedValue.length != valueAsString.length ? "important" : void 0;
        eElement.style.setProperty(parsedKey, parsedValue, priority);
    }
}
function $437b23f6a393c3bf$export$8980540b0a37a11d(getElement2) {
    return ()=>{
        const element = getElement2();
        if (!element) return true;
        return $437b23f6a393c3bf$var$_isHorizontalScrollShowing(element) || $437b23f6a393c3bf$var$_isVerticalScrollShowing(element);
    };
}
function $437b23f6a393c3bf$var$_isHorizontalScrollShowing(element) {
    return element.clientWidth < element.scrollWidth;
}
function $437b23f6a393c3bf$var$_isVerticalScrollShowing(element) {
    return element.clientHeight < element.scrollHeight;
}
function $437b23f6a393c3bf$var$_setElementWidth(element, width) {
    if (width === "flex") {
        element.style.removeProperty("width");
        element.style.removeProperty("minWidth");
        element.style.removeProperty("maxWidth");
        element.style.flex = "1 1 auto";
    } else $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width);
}
function $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width) {
    width = $437b23f6a393c3bf$var$_formatSize(width);
    element.style.width = width;
    element.style.maxWidth = width;
    element.style.minWidth = width;
}
function $437b23f6a393c3bf$var$_setFixedHeight(element, height) {
    height = $437b23f6a393c3bf$var$_formatSize(height);
    element.style.height = height;
    element.style.maxHeight = height;
    element.style.minHeight = height;
}
function $437b23f6a393c3bf$var$_formatSize(size) {
    return typeof size === "number" ? `${size}px` : size;
}
function $437b23f6a393c3bf$export$6e6303ef478b0c94(o) {
    return o instanceof Node || o instanceof HTMLElement;
}
function $437b23f6a393c3bf$var$_addOrRemoveAttribute(element, name, value) {
    if (value == null || value === "") element.removeAttribute(name);
    else element.setAttribute(name, value.toString());
}
function $437b23f6a393c3bf$export$9aef8476630687be(beans, element, callback) {
    const win = $437b23f6a393c3bf$var$_getWindow(beans);
    const ResizeObserverImpl = win.ResizeObserver;
    const resizeObserver = ResizeObserverImpl ? new ResizeObserverImpl(callback) : null;
    resizeObserver?.observe(element);
    return ()=>resizeObserver?.disconnect();
}
function $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, callback) {
    const win = $437b23f6a393c3bf$var$_getWindow(beans);
    if (win.requestAnimationFrame) win.requestAnimationFrame(callback);
    else if (win.webkitRequestAnimationFrame) win.webkitRequestAnimationFrame(callback);
    else win.setTimeout(callback, 0);
}
var $437b23f6a393c3bf$var$DataRefAttribute = "data-ref";
var $437b23f6a393c3bf$var$whitespaceNode;
function $437b23f6a393c3bf$var$getWhitespaceNode() {
    $437b23f6a393c3bf$var$whitespaceNode ?? ($437b23f6a393c3bf$var$whitespaceNode = document.createTextNode(" "));
    return $437b23f6a393c3bf$var$whitespaceNode.cloneNode();
}
function $437b23f6a393c3bf$export$378bc9c64290bc8b(params) {
    const { attrs: attrs, children: children, cls: cls, ref: ref, role: role, tag: tag } = params;
    const element = document.createElement(tag);
    if (cls) element.className = cls;
    if (ref) element.setAttribute($437b23f6a393c3bf$var$DataRefAttribute, ref);
    if (role) element.setAttribute("role", role);
    if (attrs) for (const key of Object.keys(attrs))element.setAttribute(key, attrs[key]);
    if (children) {
        if (typeof children === "string") element.textContent = children;
        else {
            let addFirstWhitespace = true;
            for (const child of children)if (child) {
                if (typeof child === "string") {
                    element.appendChild(document.createTextNode(child));
                    addFirstWhitespace = false;
                } else if (typeof child === "function") element.appendChild(child());
                else {
                    if (addFirstWhitespace) {
                        element.appendChild($437b23f6a393c3bf$var$getWhitespaceNode());
                        addFirstWhitespace = false;
                    }
                    element.append($437b23f6a393c3bf$export$378bc9c64290bc8b(child));
                    element.appendChild($437b23f6a393c3bf$var$getWhitespaceNode());
                }
            }
        }
    }
    return element;
}
// packages/ag-grid-community/src/agStack/utils/event.ts
var $437b23f6a393c3bf$var$PASSIVE_EVENTS = [
    "touchstart",
    "touchend",
    "touchmove",
    "touchcancel",
    "scroll"
];
var $437b23f6a393c3bf$var$NON_PASSIVE_EVENTS = [
    "wheel"
];
var $437b23f6a393c3bf$var$supports = {};
var $437b23f6a393c3bf$var$_isEventSupported = /* @__PURE__ */ (()=>{
    const tags = {
        select: "input",
        change: "input",
        submit: "form",
        reset: "form",
        error: "img",
        load: "img",
        abort: "img"
    };
    const eventChecker = (eventName)=>{
        if (typeof $437b23f6a393c3bf$var$supports[eventName] === "boolean") return $437b23f6a393c3bf$var$supports[eventName];
        const el = document.createElement(tags[eventName] || "div");
        eventName = "on" + eventName;
        return $437b23f6a393c3bf$var$supports[eventName] = eventName in el;
    };
    return eventChecker;
})();
function $437b23f6a393c3bf$export$b5446458166e97b4(element, event) {
    if (!event || !element) return false;
    return $437b23f6a393c3bf$var$_getEventPath(event).indexOf(element) >= 0;
}
function $437b23f6a393c3bf$var$_createEventPath(event) {
    const res = [];
    let pointer = event.target;
    while(pointer){
        res.push(pointer);
        pointer = pointer.parentElement;
    }
    return res;
}
function $437b23f6a393c3bf$var$_getEventPath(event) {
    const eventNoType = event;
    if (eventNoType.path) return eventNoType.path;
    if (eventNoType.composedPath) return eventNoType.composedPath();
    return $437b23f6a393c3bf$var$_createEventPath(eventNoType);
}
function $437b23f6a393c3bf$var$_addSafePassiveEventListener(eElement, event, listener) {
    const passive = $437b23f6a393c3bf$var$getPassiveStateForEvent(event);
    let options;
    if (passive != null) options = {
        passive: passive
    };
    eElement.addEventListener(event, listener, options);
}
var $437b23f6a393c3bf$var$getPassiveStateForEvent = (event)=>{
    const isPassive = $437b23f6a393c3bf$var$PASSIVE_EVENTS.includes(event);
    const isNonPassive = $437b23f6a393c3bf$var$NON_PASSIVE_EVENTS.includes(event);
    if (isPassive) return true;
    if (isNonPassive) return false;
};
function $437b23f6a393c3bf$var$_areEventsNear(e1, e2, pixelCount) {
    if (pixelCount === 0) return false;
    const diffX = Math.abs(e1.clientX - e2.clientX);
    const diffY = Math.abs(e1.clientY - e2.clientY);
    return Math.max(diffX, diffY) <= pixelCount;
}
var $437b23f6a393c3bf$var$_getFirstActiveTouch = (touch, touchList)=>{
    const identifier = touch.identifier;
    for(let i = 0, len = touchList.length; i < len; ++i){
        const item = touchList[i];
        if (item.identifier === identifier) return item;
    }
    return null;
};
function $437b23f6a393c3bf$var$_isEventFromThisInstance(beans, event) {
    return beans.gos.isElementInThisInstance(event.target);
}
function $437b23f6a393c3bf$export$3ce6b987cf48b8c2(element, mouseMoveEvent, beans) {
    const eRect = element.getBoundingClientRect();
    const height = eRect.height;
    const browserWidth = $437b23f6a393c3bf$var$_getBodyWidth(beans) - 2;
    const browserHeight = $437b23f6a393c3bf$var$_getBodyHeight(beans) - 2;
    const offsetParent = element.offsetParent;
    if (!offsetParent) return;
    const offsetParentSize = $437b23f6a393c3bf$var$_getElementRectWithOffset(element.offsetParent);
    const { clientY: clientY, clientX: clientX } = mouseMoveEvent;
    let top = clientY - offsetParentSize.top - height / 2;
    let left = clientX - offsetParentSize.left - 10;
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    const win = eDocument.defaultView || window;
    const windowScrollY = win.pageYOffset || eDocument.documentElement.scrollTop;
    const windowScrollX = win.pageXOffset || eDocument.documentElement.scrollLeft;
    if (browserWidth > 0 && left + element.clientWidth > browserWidth + windowScrollX) left = browserWidth + windowScrollX - element.clientWidth;
    if (left < 0) left = 0;
    if (browserHeight > 0 && top + element.clientHeight > browserHeight + windowScrollY) top = browserHeight + windowScrollY - element.clientHeight;
    if (top < 0) top = 0;
    element.style.left = `${left}px`;
    element.style.top = `${top}px`;
}
var $437b23f6a393c3bf$var$addTempEventHandlers = (list, ...handlers)=>{
    for (const handler of handlers){
        const [target, type, eventListener, options] = handler;
        target.addEventListener(type, eventListener, options);
        list.push(handler);
    }
};
var $437b23f6a393c3bf$var$clearTempEventHandlers = (list)=>{
    if (list) {
        for (const [target, type, listener, options] of list)target.removeEventListener(type, listener, options);
        list.length = 0;
    }
};
var $437b23f6a393c3bf$var$preventEventDefault = (event)=>{
    if (event.cancelable) event.preventDefault();
};
// packages/ag-grid-community/src/agStack/utils/locale.ts
function $437b23f6a393c3bf$var$defaultLocaleTextFunc(_key, defaultValue) {
    return defaultValue;
}
function $437b23f6a393c3bf$export$cc0bf4adff5b95e7(localeSvc) {
    return localeSvc?.getLocaleTextFunc() ?? $437b23f6a393c3bf$var$defaultLocaleTextFunc;
}
function $437b23f6a393c3bf$export$4ad3db330991f17d(bean, localeValues, key, variableValues) {
    const defaultValue = localeValues[key];
    return bean.getLocaleTextFunc()(key, typeof defaultValue === "function" ? defaultValue(variableValues) : defaultValue, variableValues);
}
function $437b23f6a393c3bf$export$b2a251dd30f2791(getLocaleText) {
    return (key, defaultValue, variableValues)=>{
        return getLocaleText({
            key: key,
            defaultValue: defaultValue,
            variableValues: variableValues
        });
    };
}
function $437b23f6a393c3bf$export$5a79576e712817ac(localeText) {
    return (key, defaultValue, variableValues)=>{
        let localisedText = localeText?.[key];
        if (localisedText && variableValues?.length) {
            let found = 0;
            while(true){
                if (found >= variableValues.length) break;
                const idx = localisedText.indexOf("${variable}");
                if (idx === -1) break;
                localisedText = localisedText.replace("${variable}", variableValues[found++]);
            }
        }
        return localisedText ?? defaultValue;
    };
}
// packages/ag-grid-community/src/agStack/core/agBeanStub.ts
var $437b23f6a393c3bf$export$347db2b30d253083 = class {
    constructor(){
        // not named context to allow children to use 'context' as a variable name
        this.destroyFunctions = [];
        this.destroyed = false;
        // for vue 3 - prevents Vue from trying to make this (and obviously any sub classes) from being reactive
        // prevents vue from creating proxies for created objects and prevents identity related issues
        this.__v_skip = true;
        this.propertyListenerId = 0;
        // Enable multiple grid properties to be updated together by the user but only trigger shared logic once.
        // Closely related to logic in GridOptionsUtils.ts _processOnChange
        this.lastChangeSetIdLookup = {};
        this.isAlive = ()=>!this.destroyed;
    }
    preWireBeans(beans) {
        this.beans = beans;
        this.stubContext = beans.context;
        this.eventSvc = beans.eventSvc;
        this.gos = beans.gos;
    }
    // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
    // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
    // points to a bean or component that was not properly disposed of.
    // constructor() {
    //     setTimeout(()=> {
    //         if (this.isAlive()) {
    //             let prototype: any = Object.getPrototypeOf(this);
    //             const constructor: any = prototype.constructor;
    //             const constructorString = constructor.toString();
    //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
    //             console.log('is alive ' + beanName);
    //         }
    //     }, 5000);
    // }
    destroy() {
        const { destroyFunctions: destroyFunctions } = this;
        for(let i = 0; i < destroyFunctions.length; i++)destroyFunctions[i]();
        destroyFunctions.length = 0;
        this.destroyed = true;
        this.dispatchLocalEvent({
            type: "destroyed"
        });
    }
    /** Add a local event listener against this BeanStub */ addEventListener(eventType, listener, async) {
        if (!this.localEventService) this.localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.localEventService.addEventListener(eventType, listener, async);
    }
    /** Remove a local event listener from this BeanStub */ removeEventListener(eventType, listener, async) {
        this.localEventService?.removeEventListener(eventType, listener, async);
    }
    dispatchLocalEvent(event) {
        this.localEventService?.dispatchEvent(event);
    }
    addManagedElementListeners(object, handlers) {
        return this._setupListeners(object, handlers);
    }
    addManagedEventListeners(handlers) {
        return this._setupListeners(this.eventSvc, handlers);
    }
    addManagedListeners(object, handlers) {
        return this._setupListeners(object, handlers);
    }
    _setupListeners(object, handlers) {
        const destroyFuncs = [];
        for (const k of Object.keys(handlers)){
            const handler = handlers[k];
            if (handler) destroyFuncs.push(this._setupListener(object, k, handler));
        }
        return destroyFuncs;
    }
    _setupListener(object, event, listener) {
        if (this.destroyed) return ()=>null;
        let destroyFunc;
        if ($437b23f6a393c3bf$var$isAgEventEmitter(object)) {
            object.__addEventListener(event, listener);
            destroyFunc = ()=>{
                object.__removeEventListener(event, listener);
                return null;
            };
        } else {
            const objIsEventService = $437b23f6a393c3bf$var$isEventService(object);
            if (object instanceof HTMLElement) $437b23f6a393c3bf$var$_addSafePassiveEventListener(object, event, listener);
            else if (objIsEventService) object.addListener(event, listener);
            else object.addEventListener(event, listener);
            destroyFunc = objIsEventService ? ()=>{
                object.removeListener(event, listener);
                return null;
            } : ()=>{
                object.removeEventListener(event, listener);
                return null;
            };
        }
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    /**
   * Setup a managed property listener for the given property.
   * However, stores the destroy function in the beanStub so that if this bean
   * is a component the destroy function will be called when the component is destroyed
   * as opposed to being cleaned up only when the properties service is destroyed.
   */ setupPropertyListener(event, listener) {
        const { gos: gos } = this;
        gos.addPropertyEventListener(event, listener);
        const destroyFunc = ()=>{
            gos.removePropertyEventListener(event, listener);
            return null;
        };
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */ addManagedPropertyListener(event, listener) {
        if (this.destroyed) return ()=>null;
        return this.setupPropertyListener(event, listener);
    }
    /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */ addManagedPropertyListeners(events, listener) {
        if (this.destroyed) return;
        const eventsKey = events.join("-") + this.propertyListenerId++;
        const wrappedListener = (event)=>{
            if (event.changeSet) {
                if (event.changeSet && event.changeSet.id === this.lastChangeSetIdLookup[eventsKey]) return;
                this.lastChangeSetIdLookup[eventsKey] = event.changeSet.id;
            }
            const propertiesChangeEvent = {
                type: "propertyChanged",
                changeSet: event.changeSet,
                source: event.source
            };
            listener(propertiesChangeEvent);
        };
        for (const event of events)this.setupPropertyListener(event, wrappedListener);
    }
    getLocaleTextFunc() {
        return $437b23f6a393c3bf$export$cc0bf4adff5b95e7(this.beans.localeSvc);
    }
    addDestroyFunc(func) {
        if (this.isAlive()) this.destroyFunctions.push(func);
        else func();
    }
    /** doesn't throw an error if `bean` is undefined */ createOptionalManagedBean(bean, context) {
        return bean ? this.createManagedBean(bean, context) : void 0;
    }
    createManagedBean(bean, context) {
        const res = this.createBean(bean, context);
        this.addDestroyFunc(this.destroyBean.bind(this, bean, context));
        return res;
    }
    createBean(bean, context, afterPreCreateCallback) {
        return (context || this.stubContext).createBean(bean, afterPreCreateCallback);
    }
    /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */ destroyBean(bean, context) {
        return (context || this.stubContext).destroyBean(bean);
    }
    /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */ destroyBeans(beans, context) {
        return (context || this.stubContext).destroyBeans(beans);
    }
};
function $437b23f6a393c3bf$var$isAgEventEmitter(object) {
    return object.__addEventListener !== void 0;
}
function $437b23f6a393c3bf$var$isEventService(object) {
    return object.eventServiceType === "global";
}
// packages/ag-grid-community/src/context/beanStub.ts
var $437b23f6a393c3bf$export$2032c8ef3788dfbd = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
};
// packages/ag-grid-community/src/agStack/utils/function.ts
var $437b23f6a393c3bf$var$doOnceFlags = {};
function $437b23f6a393c3bf$export$e150fb6ea3b45c0d(func, key) {
    if ($437b23f6a393c3bf$var$doOnceFlags[key]) return;
    func();
    $437b23f6a393c3bf$var$doOnceFlags[key] = true;
}
var $437b23f6a393c3bf$var$batchedCallsSetTimeout = {
    pending: false,
    funcs: []
};
var $437b23f6a393c3bf$var$batchedCallsRaf = {
    pending: false,
    funcs: []
};
function $437b23f6a393c3bf$export$8ea55376d0d59592(func, mode = "setTimeout", beans) {
    const batch = mode === "raf" ? $437b23f6a393c3bf$var$batchedCallsRaf : $437b23f6a393c3bf$var$batchedCallsSetTimeout;
    batch.funcs.push(func);
    if (batch.pending) return;
    batch.pending = true;
    const runBatch = ()=>{
        const funcsCopy = batch.funcs.slice();
        batch.funcs.length = 0;
        batch.pending = false;
        for (const func2 of funcsCopy)func2();
    };
    if (mode === "raf") $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, runBatch);
    else window.setTimeout(runBatch, 0);
}
function $437b23f6a393c3bf$export$cf7e39bfb94de6e(bean, func, delay) {
    let timeout;
    return function(...args) {
        const context = this;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(function() {
            if (bean.isAlive()) func.apply(context, args);
        }, delay);
    };
}
function $437b23f6a393c3bf$var$_throttle(func, wait) {
    let previousCall = 0;
    return function(...args) {
        const context = this;
        const currentCall = Date.now();
        if (currentCall - previousCall < wait) return;
        previousCall = currentCall;
        func.apply(context, args);
    };
}
function $437b23f6a393c3bf$export$b863e7aac7884b8(bean, condition, callback, timeout = 100) {
    const timeStamp = Date.now();
    let interval = null;
    let executed = false;
    const clearWait = ()=>{
        if (interval != null) {
            window.clearInterval(interval);
            interval = null;
        }
    };
    bean.addDestroyFunc(clearWait);
    const internalCallback = ()=>{
        const reachedTimeout = Date.now() - timeStamp > timeout;
        if (condition() || reachedTimeout) {
            callback();
            executed = true;
            clearWait();
        }
    };
    internalCallback();
    if (!executed) interval = window.setInterval(internalCallback, 10);
}
// packages/ag-grid-community/src/utils/mergeDeep.ts
var $437b23f6a393c3bf$var$SKIP_JS_BUILTINS = /* @__PURE__ */ new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function $437b23f6a393c3bf$var$_iterateObject(object, callback) {
    if (object == null) return;
    if (Array.isArray(object)) {
        for(let i = 0; i < object.length; i++)callback(i.toString(), object[i]);
        return;
    }
    for (const key of Object.keys(object).filter((key2)=>!$437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(key2)))callback(key, object[key]);
}
function $437b23f6a393c3bf$export$8ade6bd474fcde42(dest, source, copyUndefined = true, makeCopyOfSimpleObjects = false) {
    if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(source)) return;
    $437b23f6a393c3bf$var$_iterateObject(source, (key, sourceValue)=>{
        let destValue = dest[key];
        if (destValue === sourceValue) return;
        if (makeCopyOfSimpleObjects) {
            const objectIsDueToBeCopied = destValue == null && sourceValue != null;
            if (objectIsDueToBeCopied) {
                const doNotCopyAsSourceIsSimpleObject = typeof sourceValue === "object" && sourceValue.constructor === Object;
                if (doNotCopyAsSourceIsSimpleObject) {
                    destValue = {};
                    dest[key] = destValue;
                }
            }
        }
        if ($437b23f6a393c3bf$var$_isNonNullObject(sourceValue) && $437b23f6a393c3bf$var$_isNonNullObject(destValue) && !Array.isArray(destValue)) $437b23f6a393c3bf$export$8ade6bd474fcde42(destValue, sourceValue, copyUndefined, makeCopyOfSimpleObjects);
        else if (copyUndefined || sourceValue !== void 0) dest[key] = sourceValue;
    });
}
function $437b23f6a393c3bf$var$_isNonNullObject(value) {
    return typeof value === "object" && value !== null;
}
// packages/ag-grid-community/src/globalGridOptions.ts
var $437b23f6a393c3bf$var$_GlobalGridOptions = class _GlobalGridOptions {
    /**
   * @param providedOptions
   * @returns Shallow copy of the provided options with global options merged in.
   */ static applyGlobalGridOptions(providedOptions) {
        if (!_GlobalGridOptions.gridOptions) return {
            ...providedOptions
        };
        let mergedGridOps = {};
        $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedGridOps, _GlobalGridOptions.gridOptions, true, true);
        if (_GlobalGridOptions.mergeStrategy === "deep") $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedGridOps, providedOptions, true, true);
        else mergedGridOps = {
            ...mergedGridOps,
            ...providedOptions
        };
        if (_GlobalGridOptions.gridOptions.context) mergedGridOps.context = _GlobalGridOptions.gridOptions.context;
        if (providedOptions.context) {
            if (_GlobalGridOptions.mergeStrategy === "deep" && mergedGridOps.context) $437b23f6a393c3bf$export$8ade6bd474fcde42(providedOptions.context, mergedGridOps.context, true, true);
            mergedGridOps.context = providedOptions.context;
        }
        return mergedGridOps;
    }
    /**
   * Apply global grid option for a specific option key.
   * If the merge strategy is 'deep' and both global and provided values are objects, they will be merged deeply.
   * Otherwise, the provided value is returned as is.
   * @param optionKey - The key of the grid option to apply.
   * @param providedValue - The value provided to the grid instance.
   * @returns The merged value if applicable, otherwise the provided value.
   */ static applyGlobalGridOption(optionKey, providedValue) {
        if (_GlobalGridOptions.mergeStrategy === "deep") {
            const globalValue = $437b23f6a393c3bf$export$c3524a7ed99826d4(optionKey);
            if (globalValue && typeof globalValue === "object" && typeof providedValue === "object") return _GlobalGridOptions.applyGlobalGridOptions({
                [optionKey]: providedValue
            })[optionKey];
        }
        return providedValue;
    }
};
$437b23f6a393c3bf$var$_GlobalGridOptions.gridOptions = void 0;
$437b23f6a393c3bf$var$_GlobalGridOptions.mergeStrategy = "shallow";
var $437b23f6a393c3bf$var$GlobalGridOptions = $437b23f6a393c3bf$var$_GlobalGridOptions;
function $437b23f6a393c3bf$export$9def8154c643bfd1(gridOptions, mergeStrategy = "shallow") {
    $437b23f6a393c3bf$var$GlobalGridOptions.gridOptions = gridOptions;
    $437b23f6a393c3bf$var$GlobalGridOptions.mergeStrategy = mergeStrategy;
}
function $437b23f6a393c3bf$export$c3524a7ed99826d4(gridOption) {
    return $437b23f6a393c3bf$var$GlobalGridOptions.gridOptions?.[gridOption];
}
// packages/ag-grid-community/src/gridOptionsDefault.ts
var $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS = {
    suppressContextMenu: false,
    preventDefaultOnContextMenu: false,
    allowContextMenuWithControlKey: false,
    suppressMenuHide: true,
    enableBrowserTooltips: false,
    tooltipTrigger: "hover",
    tooltipShowDelay: 2e3,
    tooltipHideDelay: 1e4,
    tooltipMouseTrack: false,
    tooltipShowMode: "standard",
    tooltipInteraction: false,
    copyHeadersToClipboard: false,
    copyGroupHeadersToClipboard: false,
    clipboardDelimiter: "	",
    suppressCopyRowsToClipboard: false,
    suppressCopySingleCellRanges: false,
    suppressLastEmptyLineOnPaste: false,
    suppressClipboardPaste: false,
    suppressClipboardApi: false,
    suppressCutToClipboard: false,
    maintainColumnOrder: false,
    enableStrictPivotColumnOrder: false,
    suppressFieldDotNotation: false,
    allowDragFromColumnsToolPanel: false,
    suppressMovableColumns: false,
    suppressColumnMoveAnimation: false,
    suppressMoveWhenColumnDragging: false,
    suppressDragLeaveHidesColumns: false,
    suppressRowGroupHidesColumns: false,
    suppressAutoSize: false,
    autoSizePadding: 20,
    skipHeaderOnAutoSize: false,
    singleClickEdit: false,
    suppressClickEdit: false,
    readOnlyEdit: false,
    stopEditingWhenCellsLoseFocus: false,
    enterNavigatesVertically: false,
    enterNavigatesVerticallyAfterEdit: false,
    enableCellEditingOnBackspace: false,
    undoRedoCellEditing: false,
    undoRedoCellEditingLimit: 10,
    suppressCsvExport: false,
    suppressExcelExport: false,
    cacheQuickFilter: false,
    includeHiddenColumnsInQuickFilter: false,
    excludeChildrenWhenTreeDataFiltering: false,
    enableAdvancedFilter: false,
    includeHiddenColumnsInAdvancedFilter: false,
    enableCharts: false,
    masterDetail: false,
    keepDetailRows: false,
    keepDetailRowsCount: 10,
    detailRowAutoHeight: false,
    tabIndex: 0,
    rowBuffer: 10,
    valueCache: false,
    valueCacheNeverExpires: false,
    enableCellExpressions: false,
    suppressTouch: false,
    suppressFocusAfterRefresh: false,
    suppressBrowserResizeObserver: false,
    suppressPropertyNamesCheck: false,
    suppressChangeDetection: false,
    debug: false,
    suppressLoadingOverlay: false,
    suppressNoRowsOverlay: false,
    pagination: false,
    paginationPageSize: 100,
    paginationPageSizeSelector: true,
    paginationAutoPageSize: false,
    paginateChildRows: false,
    suppressPaginationPanel: false,
    pivotMode: false,
    pivotPanelShow: "never",
    pivotDefaultExpanded: 0,
    pivotSuppressAutoColumn: false,
    suppressExpandablePivotGroups: false,
    functionsReadOnly: false,
    suppressAggFuncInHeader: false,
    alwaysAggregateAtRootLevel: false,
    aggregateOnlyChangedColumns: false,
    suppressAggFilteredOnly: false,
    removePivotHeaderRowWhenSingleValueColumn: false,
    animateRows: true,
    cellFlashDuration: 500,
    cellFadeDuration: 1e3,
    allowShowChangeAfterFilter: false,
    domLayout: "normal",
    ensureDomOrder: false,
    enableRtl: false,
    suppressColumnVirtualisation: false,
    suppressMaxRenderedRowRestriction: false,
    suppressRowVirtualisation: false,
    rowDragManaged: false,
    rowDragInsertDelay: 500,
    suppressRowDrag: false,
    suppressMoveWhenRowDragging: false,
    rowDragEntireRow: false,
    rowDragMultiRow: false,
    embedFullWidthRows: false,
    groupDisplayType: "singleColumn",
    groupDefaultExpanded: 0,
    groupMaintainOrder: false,
    groupSelectsChildren: false,
    groupSuppressBlankHeader: false,
    groupSelectsFiltered: false,
    showOpenedGroup: false,
    groupRemoveSingleChildren: false,
    groupRemoveLowestSingleChildren: false,
    groupHideOpenParents: false,
    groupAllowUnbalanced: false,
    rowGroupPanelShow: "never",
    suppressMakeColumnVisibleAfterUnGroup: false,
    treeData: false,
    rowGroupPanelSuppressSort: false,
    suppressGroupRowsSticky: false,
    rowModelType: "clientSide",
    asyncTransactionWaitMillis: 50,
    suppressModelUpdateAfterUpdateTransaction: false,
    cacheOverflowSize: 1,
    infiniteInitialRowCount: 1,
    serverSideInitialRowCount: 1,
    cacheBlockSize: 100,
    maxBlocksInCache: -1,
    maxConcurrentDatasourceRequests: 2,
    blockLoadDebounceMillis: 0,
    purgeClosedRowNodes: false,
    serverSideSortAllLevels: false,
    serverSideOnlyRefreshFilteredGroups: false,
    serverSidePivotResultFieldSeparator: "_",
    viewportRowModelPageSize: 5,
    viewportRowModelBufferSize: 5,
    alwaysShowHorizontalScroll: false,
    alwaysShowVerticalScroll: false,
    debounceVerticalScrollbar: false,
    suppressHorizontalScroll: false,
    suppressScrollOnNewData: false,
    suppressScrollWhenPopupsAreOpen: false,
    suppressAnimationFrame: false,
    suppressMiddleClickScrolls: false,
    suppressPreventDefaultOnMouseWheel: false,
    rowMultiSelectWithClick: false,
    suppressRowDeselection: false,
    suppressRowClickSelection: false,
    suppressCellFocus: false,
    suppressHeaderFocus: false,
    suppressMultiRangeSelection: false,
    enableCellTextSelection: false,
    enableRangeSelection: false,
    enableRangeHandle: false,
    enableFillHandle: false,
    fillHandleDirection: "xy",
    suppressClearOnFillReduction: false,
    accentedSort: false,
    unSortIcon: false,
    suppressMultiSort: false,
    alwaysMultiSort: false,
    suppressMaintainUnsortedOrder: false,
    suppressRowHoverHighlight: false,
    suppressRowTransform: false,
    columnHoverHighlight: false,
    deltaSort: false,
    enableGroupEdit: false,
    groupLockGroupColumns: 0,
    serverSideEnableClientSideSort: false,
    suppressServerSideFullWidthLoadingRow: false,
    pivotMaxGeneratedColumns: -1,
    columnMenu: "new",
    reactiveCustomComponents: true,
    suppressSetFilterByDefault: false,
    rowNumbers: false,
    enableFilterHandlers: false
};
// packages/ag-grid-community/src/baseUrl.ts
var $437b23f6a393c3bf$var$BASE_URL = "https://www.ag-grid.com";
// packages/ag-grid-community/src/utils/log.ts
function $437b23f6a393c3bf$var$_logIfDebug(gos, message, ...args) {
    if (gos.get("debug")) console.log("AG Grid: " + message, ...args);
}
function $437b23f6a393c3bf$export$2cf41453020eef66(msg, ...args) {
    $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>console.warn("AG Grid: " + msg, ...args), msg + args?.join(""));
}
function $437b23f6a393c3bf$var$_errorOnce(msg, ...args) {
    $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>console.error("AG Grid: " + msg, ...args), msg + args?.join(""));
}
// packages/ag-grid-community/src/modules/moduleRegistry.ts
var $437b23f6a393c3bf$var$allRegisteredModules = /* @__PURE__ */ new Set();
var $437b23f6a393c3bf$var$globalModulesMap = {};
var $437b23f6a393c3bf$var$gridModulesMap = {};
var $437b23f6a393c3bf$var$currentModuleVersion;
var $437b23f6a393c3bf$var$userHasRegistered = false;
var $437b23f6a393c3bf$var$areGridScopedModules = false;
var $437b23f6a393c3bf$var$isUmd = false;
function $437b23f6a393c3bf$var$isValidModuleVersion(module) {
    const [moduleMajor, moduleMinor] = module.version.split(".") || [];
    const [currentModuleMajor, currentModuleMinor] = $437b23f6a393c3bf$var$currentModuleVersion.split(".") || [];
    return moduleMajor === currentModuleMajor && moduleMinor === currentModuleMinor;
}
function $437b23f6a393c3bf$var$runVersionChecks(module) {
    if (!$437b23f6a393c3bf$var$currentModuleVersion) $437b23f6a393c3bf$var$currentModuleVersion = module.version;
    const errorMsg = (details)=>`You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. ${details} Please update all modules to the same version.`;
    if (!module.version) $437b23f6a393c3bf$var$_errorOnce(errorMsg(`'${module.moduleName}' is incompatible.`));
    else if (!$437b23f6a393c3bf$var$isValidModuleVersion(module)) $437b23f6a393c3bf$var$_errorOnce(errorMsg(`'${module.moduleName}' is version ${module.version} but the other modules are version ${$437b23f6a393c3bf$var$currentModuleVersion}.`));
    const result = module.validate?.();
    if (result && !result.isValid) $437b23f6a393c3bf$var$_errorOnce(`${result.message}`);
}
function $437b23f6a393c3bf$export$d0b008fbcc09e577(module, gridId, isInternalRegistration = false) {
    if (!isInternalRegistration) $437b23f6a393c3bf$var$userHasRegistered = true;
    $437b23f6a393c3bf$var$runVersionChecks(module);
    const rowModels = module.rowModels ?? [
        "all"
    ];
    $437b23f6a393c3bf$var$allRegisteredModules.add(module);
    let moduleStore;
    if (gridId !== void 0) {
        $437b23f6a393c3bf$var$areGridScopedModules = true;
        if ($437b23f6a393c3bf$var$gridModulesMap[gridId] === void 0) $437b23f6a393c3bf$var$gridModulesMap[gridId] = {};
        moduleStore = $437b23f6a393c3bf$var$gridModulesMap[gridId];
    } else moduleStore = $437b23f6a393c3bf$var$globalModulesMap;
    for (const rowModel of rowModels){
        if (moduleStore[rowModel] === void 0) moduleStore[rowModel] = {};
        moduleStore[rowModel][module.moduleName] = module;
    }
    if (module.dependsOn) for (const dependency of module.dependsOn)$437b23f6a393c3bf$export$d0b008fbcc09e577(dependency, gridId, isInternalRegistration);
}
function $437b23f6a393c3bf$var$_unRegisterGridModules(gridId) {
    delete $437b23f6a393c3bf$var$gridModulesMap[gridId];
}
function $437b23f6a393c3bf$var$_isModuleRegistered(moduleName, gridId, rowModel) {
    const isRegisteredForRowModel = (model)=>!!$437b23f6a393c3bf$var$globalModulesMap[model]?.[moduleName] || !!$437b23f6a393c3bf$var$gridModulesMap[gridId]?.[model]?.[moduleName];
    return isRegisteredForRowModel(rowModel) || isRegisteredForRowModel("all");
}
function $437b23f6a393c3bf$var$_areModulesGridScoped() {
    return $437b23f6a393c3bf$var$areGridScopedModules;
}
function $437b23f6a393c3bf$var$_getRegisteredModules(gridId, rowModel) {
    const gridModules = $437b23f6a393c3bf$var$gridModulesMap[gridId] ?? {};
    return [
        ...Object.values($437b23f6a393c3bf$var$globalModulesMap["all"] ?? {}),
        ...Object.values(gridModules["all"] ?? {}),
        ...Object.values($437b23f6a393c3bf$var$globalModulesMap[rowModel] ?? {}),
        ...Object.values(gridModules[rowModel] ?? {})
    ];
}
function $437b23f6a393c3bf$var$_getAllRegisteredModules() {
    return new Set($437b23f6a393c3bf$var$allRegisteredModules);
}
function $437b23f6a393c3bf$export$7c244c452cd4b417(gridId, rowModel) {
    const gridModules = $437b23f6a393c3bf$var$gridModulesMap[gridId] ?? {};
    return [
        ...Object.values(gridModules["all"] ?? {}),
        ...Object.values(gridModules[rowModel] ?? {})
    ];
}
function $437b23f6a393c3bf$var$_hasUserRegistered() {
    return $437b23f6a393c3bf$var$userHasRegistered;
}
function $437b23f6a393c3bf$var$_isUmd() {
    return $437b23f6a393c3bf$var$isUmd;
}
function $437b23f6a393c3bf$export$8bf1e03cfb50cab5() {
    $437b23f6a393c3bf$var$isUmd = true;
}
var $437b23f6a393c3bf$export$dc053975cc7f6c11 = class {
    /**
   * @deprecated v33 Use `registerModules([module])` instead.
   */ static register(module) {
        $437b23f6a393c3bf$export$d0b008fbcc09e577(module, void 0);
    }
    /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */ static registerModules(modules) {
        for (const module of modules)$437b23f6a393c3bf$export$d0b008fbcc09e577(module, void 0);
    }
};
// packages/ag-grid-community/src/version.ts
var $437b23f6a393c3bf$var$VERSION = "34.3.1";
// packages/ag-grid-community/src/validation/logging.ts
var $437b23f6a393c3bf$var$MAX_URL_LENGTH = 2e3;
var $437b23f6a393c3bf$var$MIN_PARAM_LENGTH = 100;
var $437b23f6a393c3bf$var$VERSION_PARAM_NAME = "_version_";
var $437b23f6a393c3bf$var$getConsoleMessage = null;
var $437b23f6a393c3bf$var$baseDocLink = `${$437b23f6a393c3bf$var$BASE_URL}/javascript-data-grid`;
function $437b23f6a393c3bf$var$provideValidationServiceLogger(logger) {
    $437b23f6a393c3bf$var$getConsoleMessage = logger;
}
function $437b23f6a393c3bf$var$setValidationDocLink(docLink) {
    $437b23f6a393c3bf$var$baseDocLink = docLink;
}
function $437b23f6a393c3bf$var$getErrorParts(id, args, defaultMessage) {
    return $437b23f6a393c3bf$var$getConsoleMessage?.(id, args) ?? [
        $437b23f6a393c3bf$var$minifiedLog(id, args, defaultMessage)
    ];
}
function $437b23f6a393c3bf$var$getMsgOrDefault(logger, id, args, isWarning, defaultMessage) {
    logger(`${isWarning ? "warning" : "error"} #${id}`, ...$437b23f6a393c3bf$var$getErrorParts(id, args, defaultMessage));
}
function $437b23f6a393c3bf$var$stringifyObject(inputObj) {
    if (!inputObj) return String(inputObj);
    const object = {};
    for (const prop of Object.keys(inputObj))if (typeof inputObj[prop] !== "object" && typeof inputObj[prop] !== "function") object[prop] = inputObj[prop];
    return JSON.stringify(object);
}
function $437b23f6a393c3bf$var$stringifyValue(value) {
    let output = value;
    if (value instanceof Error) output = value.toString();
    else if (typeof value === "object") output = $437b23f6a393c3bf$var$stringifyObject(value);
    return output;
}
function $437b23f6a393c3bf$var$toStringWithNullUndefined(str) {
    return str === void 0 ? "undefined" : str === null ? "null" : str;
}
function $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params) {
    return `${baseUrl}?${params.toString()}`;
}
function $437b23f6a393c3bf$var$truncateUrl(baseUrl, params, maxLength) {
    const sortedParams = Array.from(params.entries()).sort((a, b)=>b[1].length - a[1].length);
    let url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    for (const [key, value] of sortedParams){
        if (key === $437b23f6a393c3bf$var$VERSION_PARAM_NAME) continue;
        const excessLength = url.length - maxLength;
        if (excessLength <= 0) break;
        const ellipse = "...";
        const truncateAmount = excessLength + ellipse.length;
        const truncatedValue = value.length - truncateAmount > $437b23f6a393c3bf$var$MIN_PARAM_LENGTH ? value.slice(0, value.length - truncateAmount) + ellipse : value.slice(0, $437b23f6a393c3bf$var$MIN_PARAM_LENGTH) + ellipse;
        params.set(key, truncatedValue);
        url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    }
    return url;
}
function $437b23f6a393c3bf$var$getErrorLink(errorNum, args) {
    const params = new URLSearchParams();
    params.append($437b23f6a393c3bf$var$VERSION_PARAM_NAME, $437b23f6a393c3bf$var$VERSION);
    if (args) for (const key of Object.keys(args))params.append(key, $437b23f6a393c3bf$var$stringifyValue(args[key]));
    const baseUrl = `${$437b23f6a393c3bf$var$baseDocLink}/errors/${errorNum}`;
    const url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    return url.length <= $437b23f6a393c3bf$var$MAX_URL_LENGTH ? url : $437b23f6a393c3bf$var$truncateUrl(baseUrl, params, $437b23f6a393c3bf$var$MAX_URL_LENGTH);
}
var $437b23f6a393c3bf$var$minifiedLog = (errorNum, args, defaultMessage)=>{
    const errorLink = $437b23f6a393c3bf$var$getErrorLink(errorNum, args);
    const prefix = `${defaultMessage ? defaultMessage + " \n" : ""}Visit ${errorLink}`;
    if ($437b23f6a393c3bf$var$_isUmd()) return prefix;
    return `${prefix}${defaultMessage ? "" : " \n  Alternatively register the ValidationModule to see the full message in the console."}`;
};
function $437b23f6a393c3bf$export$545083624300f13d(...args) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$export$2cf41453020eef66, args[0], args[1], true);
}
function $437b23f6a393c3bf$export$a20c7248650823a9(...args) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$var$_errorOnce, args[0], args[1], false);
}
function $437b23f6a393c3bf$var$_logPreInitErr(id, args, defaultMessage) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$var$_errorOnce, id, args, false, defaultMessage);
}
function $437b23f6a393c3bf$export$2ff8152c3f8aff5b(id, args, defaultMessage) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$export$2cf41453020eef66, id, args, true, defaultMessage);
}
function $437b23f6a393c3bf$var$getErrMsg(defaultMessage, args) {
    const id = args[0];
    return `error #${id} ` + $437b23f6a393c3bf$var$getErrorParts(id, args[1], defaultMessage).join(" ");
}
function $437b23f6a393c3bf$export$680bb5102fca525e(...args) {
    return $437b23f6a393c3bf$var$getErrMsg(void 0, args);
}
function $437b23f6a393c3bf$export$d73cab7876c2c868(...args) {
    return $437b23f6a393c3bf$var$getErrMsg("\n", args);
}
// packages/ag-grid-community/src/gridOptionsUtils.ts
function $437b23f6a393c3bf$var$isRowModelType(gos, rowModelType) {
    return gos.get("rowModelType") === rowModelType;
}
function $437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel) {
    return $437b23f6a393c3bf$var$isRowModelType(gos, "clientSide");
}
function $437b23f6a393c3bf$export$cf1bac0013650216(gos, rowModel) {
    return $437b23f6a393c3bf$var$isRowModelType(gos, "serverSide");
}
function $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, domLayout) {
    return gos.get("domLayout") === domLayout;
}
function $437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos) {
    return $437b23f6a393c3bf$export$80b6607444b3274f(gos) !== void 0;
}
function $437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(gos) {
    return typeof gos.get("getRowHeight") === "function";
}
function $437b23f6a393c3bf$var$_shouldMaintainColumnOrder(gos, isPivotColumns) {
    if (isPivotColumns) return !gos.get("enableStrictPivotColumnOrder");
    return gos.get("maintainColumnOrder");
}
function $437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, rowNode, allowEstimate = false, defaultRowHeight) {
    const { gos: gos, environment: environment } = beans;
    if (defaultRowHeight == null) defaultRowHeight = environment.getDefaultRowHeight();
    if ($437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(gos)) {
        if (allowEstimate) return {
            height: defaultRowHeight,
            estimated: true
        };
        const params = {
            node: rowNode,
            data: rowNode.data
        };
        const height = gos.getCallback("getRowHeight")(params);
        if ($437b23f6a393c3bf$var$isNumeric(height)) {
            if (height === 0) $437b23f6a393c3bf$export$545083624300f13d(23);
            return {
                height: Math.max(1, height),
                estimated: false
            };
        }
    }
    if (rowNode.detail && gos.get("masterDetail")) return $437b23f6a393c3bf$var$getMasterDetailRowHeight(gos);
    const gridOptionsRowHeight = gos.get("rowHeight");
    const rowHeight = gridOptionsRowHeight && $437b23f6a393c3bf$var$isNumeric(gridOptionsRowHeight) ? gridOptionsRowHeight : defaultRowHeight;
    return {
        height: rowHeight,
        estimated: false
    };
}
function $437b23f6a393c3bf$var$getMasterDetailRowHeight(gos) {
    if (gos.get("detailRowAutoHeight")) return {
        height: 1,
        estimated: false
    };
    const defaultRowHeight = gos.get("detailRowHeight");
    if ($437b23f6a393c3bf$var$isNumeric(defaultRowHeight)) return {
        height: defaultRowHeight,
        estimated: false
    };
    return {
        height: 300,
        estimated: false
    };
}
function $437b23f6a393c3bf$export$8966875adec41e5b(beans) {
    const { environment: environment, gos: gos } = beans;
    const gridOptionsRowHeight = gos.get("rowHeight");
    if (!gridOptionsRowHeight || $437b23f6a393c3bf$export$672d9e47bc342bac(gridOptionsRowHeight)) return environment.getDefaultRowHeight();
    const rowHeight = environment.refreshRowHeightVariable();
    if (rowHeight !== -1) return rowHeight;
    $437b23f6a393c3bf$export$545083624300f13d(24);
    return environment.getDefaultRowHeight();
}
function $437b23f6a393c3bf$var$isNumeric(value) {
    return !isNaN(value) && typeof value === "number" && isFinite(value);
}
function $437b23f6a393c3bf$var$_getDomData(gos, element, key) {
    const domData = element[gos.getDomDataKey()];
    return domData ? domData[key] : void 0;
}
function $437b23f6a393c3bf$var$_setDomData(gos, element, key, value) {
    const domDataKey = gos.getDomDataKey();
    let domData = element[domDataKey];
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(domData)) {
        domData = {};
        element[domDataKey] = domData;
    }
    domData[key] = value;
}
function $437b23f6a393c3bf$export$27adf74cf591fd1e(gos) {
    if (gos.get("ensureDomOrder")) return false;
    return gos.get("animateRows");
}
function $437b23f6a393c3bf$export$d5f33aacea6a0849(gos) {
    return !(gos.get("paginateChildRows") || gos.get("groupHideOpenParents") || $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print"));
}
function $437b23f6a393c3bf$export$96c51c2547b81aed(gos) {
    const autoGroupColumnDef = gos.get("autoGroupColumnDef");
    return !autoGroupColumnDef?.comparator && !gos.get("treeData");
}
function $437b23f6a393c3bf$export$3708afee0330994(gos) {
    const userValue = gos.get("groupAggFiltering");
    if (typeof userValue === "function") return gos.getCallback("groupAggFiltering");
    if (userValue === true) return ()=>true;
    return void 0;
}
function $437b23f6a393c3bf$export$c6fad27ed643a862(gos) {
    return gos.get("grandTotalRow");
}
function $437b23f6a393c3bf$export$713d6cabeaa7f2a5(gos) {
    const userValue = gos.get("groupTotalRow");
    if (typeof userValue === "function") return gos.getCallback("groupTotalRow");
    return ()=>userValue ?? void 0;
}
function $437b23f6a393c3bf$export$7122eb216a66bef2(gos) {
    const isHideOpenParents = !!gos.get("groupHideOpenParents");
    if (isHideOpenParents) return true;
    return gos.get("groupDisplayType") === "multipleColumns";
}
function $437b23f6a393c3bf$export$b911c5b172d227b4(gos, pivotMode) {
    if (pivotMode) return false;
    return gos.get("groupDisplayType") === "groupRows";
}
function $437b23f6a393c3bf$export$410912a9c501b8cc(gos, node, pivotMode) {
    return !!node.group && !node.footer && $437b23f6a393c3bf$export$b911c5b172d227b4(gos, pivotMode);
}
function $437b23f6a393c3bf$export$57c3bb2f89b59a89(gos) {
    const getRowId = gos.getCallback("getRowId");
    if (getRowId === void 0) return getRowId;
    return (params)=>{
        let id = getRowId(params);
        if (typeof id !== "string") {
            $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>$437b23f6a393c3bf$export$545083624300f13d(25, {
                    id: id
                }), "getRowIdString");
            id = String(id);
        }
        return id;
    };
}
function $437b23f6a393c3bf$export$2f5892ff24cc879d(gos, node) {
    const isSkippingGroups = gos.get("groupHideParentOfSingleChild");
    if (isSkippingGroups === true) return true;
    if (isSkippingGroups === "leafGroupsOnly" && node.leafGroup) return true;
    if (gos.get("groupRemoveSingleChildren")) return true;
    if (gos.get("groupRemoveLowestSingleChildren") && node.leafGroup) return true;
    return false;
}
function $437b23f6a393c3bf$export$efae4c751fa7cc4d(gos) {
    const res = gos.get("maxConcurrentDatasourceRequests");
    return res > 0 ? res : void 0;
}
function $437b23f6a393c3bf$export$d80073cdfb810fa8(gos, isGrouped) {
    const preventVisibilityChanges = gos.get("suppressGroupChangesColumnVisibility");
    if (preventVisibilityChanges === true) return false;
    if (isGrouped && preventVisibilityChanges === "suppressHideOnGroup") return false;
    if (!isGrouped && preventVisibilityChanges === "suppressShowOnUngroup") return false;
    const legacySuppressOnGroup = gos.get("suppressRowGroupHidesColumns");
    if (isGrouped && legacySuppressOnGroup === true) return false;
    const legacySuppressOnUngroup = gos.get("suppressMakeColumnVisibleAfterUnGroup");
    if (!isGrouped && legacySuppressOnUngroup === true) return false;
    return true;
}
function $437b23f6a393c3bf$export$6df3a55606bca6ae(selection) {
    return selection?.checkboxes ?? true;
}
function $437b23f6a393c3bf$export$e92e75627785d7a4(selection) {
    return selection?.mode === "multiRow" && (selection.headerCheckbox ?? true);
}
function $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection) {
    if (typeof rowSelection !== "object") return void 0;
    return rowSelection.checkboxLocation ?? "selectionColumn";
}
function $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(selection) {
    return selection?.hideDisabledCheckboxes ?? false;
}
function $437b23f6a393c3bf$export$d3c80fcacb2e2d55(gos) {
    const rowSelection = gos.get("rowSelection");
    return typeof rowSelection !== "string";
}
function $437b23f6a393c3bf$export$63600d24670d494d(gos) {
    return gos.get("cellSelection") !== void 0;
}
function $437b23f6a393c3bf$export$93073c0b97dd7eba(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return gos.get("suppressMultiRangeSelection");
    return typeof selection !== "boolean" ? selection?.suppressMultiRanges ?? false : false;
}
function $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    return useNewAPI ? !!selection : gos.get("enableRangeSelection");
}
function $437b23f6a393c3bf$export$c96ba82819c56957(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return {
        mode: "fill",
        setFillValue: gos.get("fillOperation"),
        direction: gos.get("fillHandleDirection"),
        suppressClearOnFillReduction: gos.get("suppressClearOnFillReduction")
    };
    return typeof selection !== "boolean" && selection.handle?.mode === "fill" ? selection.handle : void 0;
}
function $437b23f6a393c3bf$var$_getEnableClickSelection(gos) {
    const selection = gos.get("rowSelection") ?? "single";
    if (typeof selection === "string") {
        const suppressRowClickSelection = gos.get("suppressRowClickSelection");
        const suppressRowDeselection = gos.get("suppressRowDeselection");
        if (suppressRowClickSelection && suppressRowDeselection) return false;
        else if (suppressRowClickSelection) return "enableDeselection";
        else if (suppressRowDeselection) return "enableSelection";
        else return true;
    }
    return selection.mode === "singleRow" || selection.mode === "multiRow" ? selection.enableClickSelection ?? false : false;
}
function $437b23f6a393c3bf$var$_getEnableSelection(gos) {
    const enableClickSelection = $437b23f6a393c3bf$var$_getEnableClickSelection(gos);
    return enableClickSelection === true || enableClickSelection === "enableSelection";
}
function $437b23f6a393c3bf$var$_getEnableDeselection(gos) {
    const enableClickSelection = $437b23f6a393c3bf$var$_getEnableClickSelection(gos);
    return enableClickSelection === true || enableClickSelection === "enableDeselection";
}
function $437b23f6a393c3bf$export$351959be716b3b33(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") return gos.get("isRowSelectable");
    return selection?.isRowSelectable;
}
function $437b23f6a393c3bf$export$80b6607444b3274f(arg) {
    const selection = "beanName" in arg && arg.beanName === "gos" ? arg.get("rowSelection") : arg.rowSelection;
    if (typeof selection === "string") switch(selection){
        case "multiple":
            return "multiRow";
        case "single":
            return "singleRow";
        default:
            return;
    }
    switch(selection?.mode){
        case "multiRow":
        case "singleRow":
            return selection.mode;
        default:
            return;
    }
}
function $437b23f6a393c3bf$export$7bd8c52ebc4117d6(arg) {
    const mode = $437b23f6a393c3bf$export$80b6607444b3274f(arg);
    return mode === "multiRow";
}
function $437b23f6a393c3bf$var$_getEnableSelectionWithoutKeys(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") return gos.get("rowMultiSelectWithClick");
    return selection?.enableSelectionWithoutKeys ?? false;
}
function $437b23f6a393c3bf$export$673080972d8c733e(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") {
        const groupSelectsChildren = gos.get("groupSelectsChildren");
        const groupSelectsFiltered = gos.get("groupSelectsFiltered");
        if (groupSelectsChildren && groupSelectsFiltered) return "filteredDescendants";
        else if (groupSelectsChildren) return "descendants";
        else return "self";
    }
    return selection?.mode === "multiRow" ? selection.groupSelects : void 0;
}
function $437b23f6a393c3bf$var$_getSelectAll(gos, defaultValue = true) {
    const rowSelection = gos.get("rowSelection");
    if (typeof rowSelection !== "object") return defaultValue ? "all" : void 0;
    return rowSelection.mode === "multiRow" ? rowSelection.selectAll : "all";
}
function $437b23f6a393c3bf$var$_getCtrlASelectsRows(gos) {
    const rowSelection = gos.get("rowSelection");
    if (typeof rowSelection === "string") return false;
    return rowSelection?.mode === "multiRow" ? rowSelection.ctrlASelectsRows ?? false : false;
}
function $437b23f6a393c3bf$export$460e5745f0e6a40d(gos) {
    const groupSelection = $437b23f6a393c3bf$export$673080972d8c733e(gos);
    return groupSelection === "descendants" || groupSelection === "filteredDescendants";
}
function $437b23f6a393c3bf$var$_getMasterSelects(gos) {
    const rowSelection = gos.get("rowSelection");
    return typeof rowSelection === "object" && rowSelection.masterSelects || "self";
}
function $437b23f6a393c3bf$export$b68e6345dc6b83fa(gos) {
    return gos.isModuleRegistered("SetFilter") && !gos.get("suppressSetFilterByDefault");
}
function $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos) {
    return gos.get("columnMenu") === "legacy";
}
function $437b23f6a393c3bf$export$cfe4cf52f3717a7b(gos) {
    return !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
}
function $437b23f6a393c3bf$export$2badf35af69344c1(eventName) {
    if (!eventName || eventName.length < 2) return eventName;
    return "on" + eventName[0].toUpperCase() + eventName.substring(1);
}
function $437b23f6a393c3bf$export$bfe37fc2d3c03134(gridOptions, component, gridOptionsKeys) {
    if (typeof gridOptions !== "object") gridOptions = {};
    const mergedOptions = {
        ...gridOptions
    };
    for (const key of gridOptionsKeys){
        const value = component[key];
        if (typeof value !== "undefined") mergedOptions[key] = value;
    }
    return mergedOptions;
}
function $437b23f6a393c3bf$export$52208033bd24c2b2(changes, api) {
    if (!changes) return;
    const gridChanges = {};
    let hasChanges = false;
    for (const key of Object.keys(changes)){
        gridChanges[key] = changes[key];
        hasChanges = true;
    }
    if (!hasChanges) return;
    const internalUpdateEvent = {
        type: "gridOptionsChanged",
        options: gridChanges
    };
    api.dispatchEvent(internalUpdateEvent);
    const event = {
        type: "componentStateChanged",
        ...gridChanges
    };
    api.dispatchEvent(event);
}
function $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, params) {
    return gos.addCommon(params);
}
function $437b23f6a393c3bf$export$aa5750e97994dd3(providedGridOptions, gridOption) {
    return providedGridOptions[gridOption] ?? providedGridOptions[`gridOptions`]?.[gridOption] ?? $437b23f6a393c3bf$export$c3524a7ed99826d4(gridOption) ?? $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS[gridOption];
}
function $437b23f6a393c3bf$export$f8093014f10b296a({ gos: gos }, event) {
    return event.button === 2 || event.ctrlKey && gos.get("allowContextMenuWithControlKey");
}
// packages/ag-grid-community/src/entities/agColumn.ts
var $437b23f6a393c3bf$var$COL_DEF_DEFAULTS = {
    resizable: true,
    sortable: true
};
var $437b23f6a393c3bf$var$instanceIdSequence = 0;
function $437b23f6a393c3bf$var$getNextColInstanceId() {
    return $437b23f6a393c3bf$var$instanceIdSequence++;
}
function $437b23f6a393c3bf$export$891484e65a02ec71(col) {
    return col instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2;
}
var $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(colDef, userProvidedColDef, colId, primary){
        super();
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.colId = colId;
        this.primary = primary;
        this.isColumn = true;
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = $437b23f6a393c3bf$var$getNextColInstanceId();
        // The measured height of this column's header when autoHeaderHeight is enabled
        this.autoHeaderHeight = null;
        this.moving = false;
        this.resizing = false;
        this.menuVisible = false;
        this.lastLeftPinned = false;
        this.firstRightPinned = false;
        this.filterActive = false;
        this.colEventSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.tooltipEnabled = false;
        this.rowGroupActive = false;
        this.pivotActive = false;
        this.aggregationActive = false;
        this.flex = null;
        this.colIdSanitised = $437b23f6a393c3bf$export$3df06b741968da82(colId);
    }
    destroy() {
        super.destroy();
        this.beans.rowSpanSvc?.deregister(this);
    }
    getInstanceId() {
        return this.instanceId;
    }
    setState() {
        const { colDef: colDef, beans: { sortSvc: sortSvc, pinnedCols: pinnedCols, colFlex: colFlex } } = this;
        sortSvc?.initCol(this);
        const hide = colDef.hide;
        if (hide !== void 0) this.visible = !hide;
        else this.visible = !colDef.initialHide;
        pinnedCols?.initCol(this);
        colFlex?.initCol(this);
    }
    // gets called when user provides an alternative colDef, eg
    setColDef(colDef, userProvidedColDef, source) {
        const colSpanChanged = colDef.spanRows !== this.colDef.spanRows;
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.initMinAndMaxWidths();
        this.initDotNotation();
        this.initTooltip();
        if (colSpanChanged) {
            this.beans.rowSpanSvc?.deregister(this);
            this.initRowSpan();
        }
        this.dispatchColEvent("colDefChanged", source);
    }
    getUserProvidedColDef() {
        return this.userProvidedColDef;
    }
    getParent() {
        return this.parent;
    }
    getOriginalParent() {
        return this.originalParent;
    }
    // this is done after constructor as it uses gridOptionsService
    postConstruct() {
        this.setState();
        this.initMinAndMaxWidths();
        this.resetActualWidth("gridInitializing");
        this.initDotNotation();
        this.initTooltip();
        this.initRowSpan();
        this.addPivotListener();
    }
    initDotNotation() {
        const { gos: gos, colDef: { field: field, tooltipField: tooltipField } } = this;
        const suppressDotNotation = gos.get("suppressFieldDotNotation");
        this.fieldContainsDots = $437b23f6a393c3bf$export$25d27f17d3af40f7(field) && field.includes(".") && !suppressDotNotation;
        this.tooltipFieldContainsDots = $437b23f6a393c3bf$export$25d27f17d3af40f7(tooltipField) && tooltipField.includes(".") && !suppressDotNotation;
    }
    initMinAndMaxWidths() {
        const colDef = this.colDef;
        this.minWidth = colDef.minWidth ?? this.beans.environment.getDefaultColumnMinWidth();
        this.maxWidth = colDef.maxWidth ?? Number.MAX_SAFE_INTEGER;
    }
    initTooltip() {
        this.beans.tooltipSvc?.initCol(this);
    }
    initRowSpan() {
        if (this.colDef.spanRows) this.beans.rowSpanSvc?.register(this);
    }
    addPivotListener() {
        const pivotColDefSvc = this.beans.pivotColDefSvc;
        const pivotValueColumn = this.colDef.pivotValueColumn;
        if (!pivotColDefSvc || !pivotValueColumn) return;
        this.addManagedListeners(pivotValueColumn, {
            colDefChanged: (evt)=>{
                const colDef = pivotColDefSvc.recreateColDef(this.colDef);
                this.setColDef(colDef, colDef, evt.source);
            }
        });
    }
    resetActualWidth(source) {
        const initialWidth = this.calculateColInitialWidth(this.colDef);
        this.setActualWidth(initialWidth, source, true);
    }
    calculateColInitialWidth(colDef) {
        let width;
        const colDefWidth = colDef.width;
        const colDefInitialWidth = colDef.initialWidth;
        if (colDefWidth != null) width = colDefWidth;
        else if (colDefInitialWidth != null) width = colDefInitialWidth;
        else width = 200;
        return Math.max(Math.min(width, this.maxWidth), this.minWidth);
    }
    isEmptyGroup() {
        return false;
    }
    isRowGroupDisplayed(colId) {
        return this.beans.showRowGroupCols?.isRowGroupDisplayed(this, colId) ?? false;
    }
    isPrimary() {
        return this.primary;
    }
    isFilterAllowed() {
        const filterDefined = !!this.colDef.filter;
        return filterDefined;
    }
    isFieldContainsDots() {
        return this.fieldContainsDots;
    }
    isTooltipEnabled() {
        return this.tooltipEnabled;
    }
    isTooltipFieldContainsDots() {
        return this.tooltipFieldContainsDots;
    }
    getHighlighted() {
        return this.highlighted;
    }
    __addEventListener(eventType, listener) {
        this.colEventSvc.addEventListener(eventType, listener);
    }
    __removeEventListener(eventType, listener) {
        this.colEventSvc.removeEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ addEventListener(eventType, userListener) {
        this.frameworkEventListenerService = this.beans.frameworkOverrides.createLocalEventListenerWrapper?.(this.frameworkEventListenerService, this.colEventSvc);
        const listener = this.frameworkEventListenerService?.wrap(eventType, userListener) ?? userListener;
        this.colEventSvc.addEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ removeEventListener(eventType, userListener) {
        const listener = this.frameworkEventListenerService?.unwrap(eventType, userListener) ?? userListener;
        this.colEventSvc.removeEventListener(eventType, listener);
    }
    createColumnFunctionCallbackParams(rowNode) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            column: this,
            colDef: this.colDef
        });
    }
    isSuppressNavigable(rowNode) {
        return this.beans.cellNavigation?.isSuppressNavigable(this, rowNode) ?? false;
    }
    isCellEditable(rowNode) {
        return this.beans.editSvc?.isCellEditable({
            rowNode: rowNode,
            column: this
        }) ?? false;
    }
    isSuppressFillHandle() {
        return !!this.colDef.suppressFillHandle;
    }
    isAutoHeight() {
        return !!this.colDef.autoHeight;
    }
    isAutoHeaderHeight() {
        return !!this.colDef.autoHeaderHeight;
    }
    isRowDrag(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.rowDrag);
    }
    isDndSource(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.dndSource);
    }
    isCellCheckboxSelection(rowNode) {
        return this.beans.selectionSvc?.isCellCheckboxSelection(this, rowNode) ?? false;
    }
    isSuppressPaste(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef?.suppressPaste ?? null);
    }
    isResizable() {
        return !!this.getColDefValue("resizable");
    }
    /** Get value from ColDef or default if it exists. */ getColDefValue(key) {
        return this.colDef[key] ?? $437b23f6a393c3bf$var$COL_DEF_DEFAULTS[key];
    }
    isColumnFunc(rowNode, value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "function") {
            const params = this.createColumnFunctionCallbackParams(rowNode);
            const editableFunc = value;
            return editableFunc(params);
        }
        return false;
    }
    createColumnEvent(type, source) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            column: this,
            columns: [
                this
            ],
            source: source
        });
    }
    isMoving() {
        return this.moving;
    }
    getSort() {
        return this.sort;
    }
    isSortable() {
        return !!this.getColDefValue("sortable");
    }
    /** @deprecated v32 use col.getSort() === 'asc */ isSortAscending() {
        return this.sort === "asc";
    }
    /** @deprecated v32 use col.getSort() === 'desc */ isSortDescending() {
        return this.sort === "desc";
    }
    /** @deprecated v32 use col.getSort() === undefined */ isSortNone() {
        return $437b23f6a393c3bf$export$672d9e47bc342bac(this.sort);
    }
    /** @deprecated v32 use col.getSort() !== undefined */ isSorting() {
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(this.sort);
    }
    getSortIndex() {
        return this.sortIndex;
    }
    isMenuVisible() {
        return this.menuVisible;
    }
    getAggFunc() {
        return this.aggFunc;
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    getRight() {
        return this.left + this.actualWidth;
    }
    setLeft(left, source) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.dispatchColEvent("leftChanged", source);
        }
    }
    isFilterActive() {
        return this.filterActive;
    }
    /** @deprecated v33 Use `api.isColumnHovered(column)` instead. */ isHovered() {
        $437b23f6a393c3bf$export$545083624300f13d(261);
        return !!this.beans.colHover?.isHovered(this);
    }
    setFirstRightPinned(firstRightPinned, source) {
        if (this.firstRightPinned !== firstRightPinned) {
            this.firstRightPinned = firstRightPinned;
            this.dispatchColEvent("firstRightPinnedChanged", source);
        }
    }
    setLastLeftPinned(lastLeftPinned, source) {
        if (this.lastLeftPinned !== lastLeftPinned) {
            this.lastLeftPinned = lastLeftPinned;
            this.dispatchColEvent("lastLeftPinnedChanged", source);
        }
    }
    isFirstRightPinned() {
        return this.firstRightPinned;
    }
    isLastLeftPinned() {
        return this.lastLeftPinned;
    }
    isPinned() {
        return this.pinned === "left" || this.pinned === "right";
    }
    isPinnedLeft() {
        return this.pinned === "left";
    }
    isPinnedRight() {
        return this.pinned === "right";
    }
    getPinned() {
        return this.pinned;
    }
    setVisible(visible, source) {
        const newValue = visible === true;
        if (this.visible !== newValue) {
            this.visible = newValue;
            this.dispatchColEvent("visibleChanged", source);
        }
        this.dispatchStateUpdatedEvent("hide");
    }
    isVisible() {
        return this.visible;
    }
    isSpanHeaderHeight() {
        const colDef = this.getColDef();
        return !colDef.suppressSpanHeaderHeight;
    }
    /**
   * Returns the first parent that is not a padding group.
   */ getFirstRealParent() {
        let parent = this.getOriginalParent();
        while(parent?.isPadding())parent = parent.getOriginalParent();
        return parent;
    }
    getColumnGroupPaddingInfo() {
        let parent = this.getParent();
        if (!parent?.isPadding()) return {
            numberOfParents: 0,
            isSpanningTotal: false
        };
        const numberOfParents = parent.getPaddingLevel() + 1;
        let isSpanningTotal = true;
        while(parent){
            if (!parent.isPadding()) {
                isSpanningTotal = false;
                break;
            }
            parent = parent.getParent();
        }
        return {
            numberOfParents: numberOfParents,
            isSpanningTotal: isSpanningTotal
        };
    }
    getColDef() {
        return this.colDef;
    }
    getDefinition() {
        return this.colDef;
    }
    getColumnGroupShow() {
        return this.colDef.columnGroupShow;
    }
    getColId() {
        return this.colId;
    }
    getId() {
        return this.colId;
    }
    getUniqueId() {
        return this.colId;
    }
    getActualWidth() {
        return this.actualWidth;
    }
    getAutoHeaderHeight() {
        return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */ setAutoHeaderHeight(height) {
        const changed = height !== this.autoHeaderHeight;
        this.autoHeaderHeight = height;
        return changed;
    }
    createBaseColDefParams(rowNode) {
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            colDef: this.colDef,
            column: this
        });
        return params;
    }
    getColSpan(rowNode) {
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.colDef.colSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const colSpan = this.colDef.colSpan(params);
        return Math.max(colSpan, 1);
    }
    getRowSpan(rowNode) {
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.colDef.rowSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const rowSpan = this.colDef.rowSpan(params);
        return Math.max(rowSpan, 1);
    }
    setActualWidth(actualWidth, source, silent = false) {
        actualWidth = Math.max(actualWidth, this.minWidth);
        actualWidth = Math.min(actualWidth, this.maxWidth);
        if (this.actualWidth !== actualWidth) {
            this.actualWidth = actualWidth;
            if (this.flex != null && source !== "flex" && source !== "gridInitializing") this.flex = null;
            if (!silent) this.fireColumnWidthChangedEvent(source);
        }
        this.dispatchStateUpdatedEvent("width");
    }
    fireColumnWidthChangedEvent(source) {
        this.dispatchColEvent("widthChanged", source);
    }
    isGreaterThanMax(width) {
        return width > this.maxWidth;
    }
    getMinWidth() {
        return this.minWidth;
    }
    getMaxWidth() {
        return this.maxWidth;
    }
    getFlex() {
        return this.flex;
    }
    isRowGroupActive() {
        return this.rowGroupActive;
    }
    isPivotActive() {
        return this.pivotActive;
    }
    isAnyFunctionActive() {
        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    }
    isAnyFunctionAllowed() {
        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    }
    isValueActive() {
        return this.aggregationActive;
    }
    isAllowPivot() {
        return this.colDef.enablePivot === true;
    }
    isAllowValue() {
        return this.colDef.enableValue === true;
    }
    isAllowRowGroup() {
        return this.colDef.enableRowGroup === true;
    }
    dispatchColEvent(type, source, additionalEventAttributes) {
        const colEvent = this.createColumnEvent(type, source);
        if (additionalEventAttributes) $437b23f6a393c3bf$export$8ade6bd474fcde42(colEvent, additionalEventAttributes);
        this.colEventSvc.dispatchEvent(colEvent);
    }
    dispatchStateUpdatedEvent(key) {
        this.colEventSvc.dispatchEvent({
            type: "columnStateUpdated",
            key: key
        });
    }
};
// packages/ag-grid-community/src/entities/agProvidedColumnGroup.ts
function $437b23f6a393c3bf$export$bb4bfad2b594b78e(col) {
    return col instanceof $437b23f6a393c3bf$export$7ff27642a6ecc1cf;
}
var $437b23f6a393c3bf$export$7ff27642a6ecc1cf = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(colGroupDef, groupId, padding, level){
        super();
        this.colGroupDef = colGroupDef;
        this.groupId = groupId;
        this.padding = padding;
        this.level = level;
        this.isColumn = false;
        this.expandable = false;
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = $437b23f6a393c3bf$var$getNextColInstanceId();
        this.expandableListenerRemoveCallback = null;
        this.expanded = !!colGroupDef?.openByDefault;
    }
    destroy() {
        if (this.expandableListenerRemoveCallback) this.reset(null, void 0);
        super.destroy();
    }
    reset(colGroupDef, level) {
        this.colGroupDef = colGroupDef;
        this.level = level;
        this.originalParent = null;
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        this.children = void 0;
        this.expandable = void 0;
    }
    getInstanceId() {
        return this.instanceId;
    }
    getOriginalParent() {
        return this.originalParent;
    }
    getLevel() {
        return this.level;
    }
    isVisible() {
        if (this.children) return this.children.some((child)=>child.isVisible());
        return false;
    }
    isPadding() {
        return this.padding;
    }
    setExpanded(expanded) {
        this.expanded = expanded === void 0 ? false : expanded;
        this.dispatchLocalEvent({
            type: "expandedChanged"
        });
    }
    isExpandable() {
        return this.expandable;
    }
    isExpanded() {
        return this.expanded;
    }
    getGroupId() {
        return this.groupId;
    }
    getId() {
        return this.getGroupId();
    }
    setChildren(children) {
        this.children = children;
    }
    getChildren() {
        return this.children;
    }
    getColGroupDef() {
        return this.colGroupDef;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    forEachLeafColumn(callback) {
        if (!this.children) return;
        for (const child of this.children){
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) callback(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.forEachLeafColumn(callback);
        }
    }
    addLeafColumns(leafColumns) {
        if (!this.children) return;
        for (const child of this.children){
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.addLeafColumns(leafColumns);
        }
    }
    getColumnGroupShow() {
        const colGroupDef = this.colGroupDef;
        if (!colGroupDef) return;
        return colGroupDef.columnGroupShow;
    }
    // need to check that this group has at least one col showing when both expanded and contracted.
    // if not, then we don't allow expanding and contracting on this group
    setupExpandable() {
        this.setExpandable();
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        const listener = this.onColumnVisibilityChanged.bind(this);
        for (const col of this.getLeafColumns())col.__addEventListener("visibleChanged", listener);
        this.expandableListenerRemoveCallback = ()=>{
            for (const col of this.getLeafColumns())col.__removeEventListener("visibleChanged", listener);
            this.expandableListenerRemoveCallback = null;
        };
    }
    setExpandable() {
        if (this.isPadding()) return;
        let atLeastOneShowingWhenOpen = false;
        let atLeastOneShowingWhenClosed = false;
        let atLeastOneChangeable = false;
        const children = this.findChildrenRemovingPadding();
        for(let i = 0, j = children.length; i < j; i++){
            const abstractColumn = children[i];
            if (!abstractColumn.isVisible()) continue;
            const headerGroupShow = abstractColumn.getColumnGroupShow();
            if (headerGroupShow === "open") {
                atLeastOneShowingWhenOpen = true;
                atLeastOneChangeable = true;
            } else if (headerGroupShow === "closed") {
                atLeastOneShowingWhenClosed = true;
                atLeastOneChangeable = true;
            } else {
                atLeastOneShowingWhenOpen = true;
                atLeastOneShowingWhenClosed = true;
            }
        }
        const expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
        if (this.expandable !== expandable) {
            this.expandable = expandable;
            this.dispatchLocalEvent({
                type: "expandableChanged"
            });
        }
    }
    findChildrenRemovingPadding() {
        const res = [];
        const process = (items)=>{
            for (const item of items){
                const skipBecausePadding = $437b23f6a393c3bf$export$bb4bfad2b594b78e(item) && item.isPadding();
                if (skipBecausePadding) process(item.children);
                else res.push(item);
            }
        };
        process(this.children);
        return res;
    }
    onColumnVisibilityChanged() {
        this.setExpandable();
    }
};
// packages/ag-grid-community/src/entities/defaultColumnTypes.ts
var $437b23f6a393c3bf$var$DefaultColumnTypes = {
    numericColumn: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    },
    rightAligned: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupUtils.ts
function $437b23f6a393c3bf$var$createMergedColGroupDef(beans, colGroupDef, groupId) {
    const colGroupDefMerged = {};
    const gos = beans.gos;
    Object.assign(colGroupDefMerged, gos.get("defaultColGroupDef"));
    Object.assign(colGroupDefMerged, colGroupDef);
    gos.validateColDef(colGroupDefMerged, groupId);
    return colGroupDefMerged;
}
// packages/ag-grid-community/src/columns/columnKeyCreator.ts
var $437b23f6a393c3bf$export$f67d1427302c96a3 = class {
    constructor(){
        this.existingKeys = {};
    }
    addExistingKeys(keys) {
        for(let i = 0; i < keys.length; i++)this.existingKeys[keys[i]] = true;
    }
    getUniqueKey(colId, colField) {
        colId = $437b23f6a393c3bf$export$2a74c29220d5c88e(colId);
        let count = 0;
        while(true){
            let idToTry = colId ?? colField;
            if (idToTry) {
                if (count !== 0) idToTry += "_" + count;
            } else idToTry = count;
            if (!this.existingKeys[idToTry]) {
                const usedId = String(idToTry);
                if (colId && count > 0) $437b23f6a393c3bf$export$545083624300f13d(273, {
                    providedId: colId,
                    usedId: usedId
                });
                this.existingKeys[usedId] = true;
                return usedId;
            }
            count++;
        }
    }
};
// packages/ag-grid-community/src/agStack/utils/array.ts
var $437b23f6a393c3bf$export$c758d9371030a6ac = Object.freeze([]);
function $437b23f6a393c3bf$export$236389741107357f(arr) {
    if (!arr?.length) return;
    return arr[arr.length - 1];
}
function $437b23f6a393c3bf$export$893967cdb9833fdd(a, b, comparator) {
    if (a === b) return true;
    if (!a || !b) return a == null && b == null;
    const len = a.length;
    if (len !== b.length) return false;
    for(let i = 0; i < len; i++){
        if (a[i] !== b[i] && !comparator?.(a[i], b[i])) return false;
    }
    return true;
}
function $437b23f6a393c3bf$var$_forAll(array, callback) {
    if (!array) return;
    for (const value of array)callback(value);
}
function $437b23f6a393c3bf$export$83a881c8b5120679(array, object) {
    const index = array.indexOf(object);
    if (index >= 0) array.splice(index, 1);
}
function $437b23f6a393c3bf$export$d938638f12233be7(array, elementsToRemove) {
    let i = 0;
    let j = 0;
    for(; i < array.length; i++)if (!elementsToRemove.includes(array[i])) {
        array[j] = array[i];
        j++;
    }
    while(j < array.length)array.pop();
}
function $437b23f6a393c3bf$var$_moveInArray(array, objectsToMove, toIndex) {
    for(let i = 0; i < objectsToMove.length; i++)$437b23f6a393c3bf$export$83a881c8b5120679(array, objectsToMove[i]);
    for(let i = objectsToMove.length - 1; i >= 0; i--)array.splice(toIndex, 0, objectsToMove[i]);
}
function $437b23f6a393c3bf$export$5e3f39c5068e375d(arrays) {
    return [].concat.apply([], arrays);
}
// packages/ag-grid-community/src/columns/columnUtils.ts
var $437b23f6a393c3bf$export$a7016588c430dba6 = "ag-Grid-AutoColumn";
var $437b23f6a393c3bf$export$dd05e5f089eb2421 = "ag-Grid-SelectionColumn";
var $437b23f6a393c3bf$export$f55c01dfb205b029 = "ag-Grid-RowNumbersColumn";
var $437b23f6a393c3bf$export$2c8ac3f8e81f483f = "ag-Grid-HierarchyColumn";
function $437b23f6a393c3bf$export$42da2aea8fab5b(rootColumns) {
    const result = [];
    const recursiveFindColumns = (childColumns)=>{
        for(let i = 0; i < childColumns.length; i++){
            const child = childColumns[i];
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) result.push(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) recursiveFindColumns(child.getChildren());
        }
    };
    recursiveFindColumns(rootColumns);
    return result;
}
function $437b23f6a393c3bf$var$getWidthOfColsInList(columnList) {
    return columnList.reduce((width, col)=>width + col.getActualWidth(), 0);
}
function $437b23f6a393c3bf$export$dbaaa57234b60d8f(beans, oldTree, newTree) {
    const oldObjectsById = {};
    if (!oldTree) return;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, oldTree, (child)=>{
        oldObjectsById[child.getInstanceId()] = child;
    });
    if (newTree) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, newTree, (child)=>{
        oldObjectsById[child.getInstanceId()] = null;
    });
    const colsToDestroy = Object.values(oldObjectsById).filter((item)=>item != null);
    beans.context.destroyBeans(colsToDestroy);
}
function $437b23f6a393c3bf$export$61b34611dc010a97(col) {
    const colId = col.getId();
    return colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
}
function $437b23f6a393c3bf$export$f6074a9792015c5d(col) {
    const id = typeof col === "string" ? col : "getColId" in col ? col.getColId() : col.colId;
    return id?.startsWith($437b23f6a393c3bf$export$dd05e5f089eb2421) ?? false;
}
function $437b23f6a393c3bf$export$3d3e7d751f0445eb(col) {
    const id = typeof col === "string" ? col : "getColId" in col ? col.getColId() : col.colId;
    return id?.startsWith($437b23f6a393c3bf$export$f55c01dfb205b029) ?? false;
}
function $437b23f6a393c3bf$export$ee97d5717f8d44ec(col) {
    return $437b23f6a393c3bf$export$f6074a9792015c5d(col) || $437b23f6a393c3bf$export$3d3e7d751f0445eb(col);
}
function $437b23f6a393c3bf$var$convertColumnTypes(type) {
    let typeKeys = [];
    if (type instanceof Array) typeKeys = type;
    else if (typeof type === "string") typeKeys = type.split(",");
    return typeKeys;
}
function $437b23f6a393c3bf$export$f56e341a1fe35ed4(colsA, colsB) {
    return $437b23f6a393c3bf$export$893967cdb9833fdd(colsA, colsB, (a, b)=>a.getColId() === b.getColId());
}
function $437b23f6a393c3bf$export$c82fd63ff1738bed(cols) {
    cols.map = {};
    for (const col of cols.list)cols.map[col.getId()] = col;
}
function $437b23f6a393c3bf$export$eb2a92b6162267d1(source) {
    return source === "optionsUpdated" ? "gridOptionsChanged" : source;
}
function $437b23f6a393c3bf$export$f5687d41c39fa1b3(column, key) {
    const columnMatches = column === key;
    const colDefMatches = column.getColDef() === key;
    const idMatches = column.getColId() == key;
    return columnMatches || colDefMatches || idMatches;
}
var $437b23f6a393c3bf$var$getValueFactory = (stateItem, defaultState)=>(key1, key2)=>{
        const obj = {
            value1: void 0,
            value2: void 0
        };
        let calculated = false;
        if (stateItem) {
            if (stateItem[key1] !== void 0) {
                obj.value1 = stateItem[key1];
                calculated = true;
            }
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(key2) && stateItem[key2] !== void 0) {
                obj.value2 = stateItem[key2];
                calculated = true;
            }
        }
        if (!calculated && defaultState) {
            if (defaultState[key1] !== void 0) obj.value1 = defaultState[key1];
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(key2) && defaultState[key2] !== void 0) obj.value2 = defaultState[key2];
        }
        return obj;
    };
// packages/ag-grid-community/src/columns/columnFactoryUtils.ts
var $437b23f6a393c3bf$var$depthFirstCallback = (child, parent)=>{
    if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.setupExpandable();
    child.originalParent = parent;
};
function $437b23f6a393c3bf$export$575b8d8234793d75(beans, defs = null, primaryColumns, existingTree, source) {
    const { existingCols: existingCols, existingGroups: existingGroups } = $437b23f6a393c3bf$var$extractExistingTreeData(existingTree);
    const colIdMap = new Map(existingCols.map((col)=>[
            col.getId(),
            col
        ]));
    const colGroupIdMap = new Map(existingGroups.map((group)=>[
            group.getId(),
            group
        ]));
    let maxDepth = 0;
    const recursivelyProcessColDef = (def, level)=>{
        maxDepth = Math.max(maxDepth, level);
        if ($437b23f6a393c3bf$var$isColumnGroupDef(def)) {
            if (!beans.colGroupSvc) return null;
            const groupId = def.groupId;
            const group = colGroupIdMap.get(groupId);
            const colGroupDef = $437b23f6a393c3bf$var$createMergedColGroupDef(beans, def, groupId);
            const newGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDef, groupId, false, level);
            beans.context.createBean(newGroup);
            if (group) newGroup.setExpanded(group.isExpanded());
            newGroup.setChildren(def.children.map((child)=>recursivelyProcessColDef(child, level + 1)));
            return newGroup;
        }
        const colId = def.colId;
        let column = colIdMap.get(colId);
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, def, column?.getColId() ?? colId);
        if (!column) {
            column = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDefMerged, def, colId, primaryColumns);
            beans.context.createBean(column);
        } else {
            column.setColDef(colDefMerged, def, source);
            $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDefMerged, source);
        }
        beans.dataTypeSvc?.addColumnListeners(column);
        return column;
    };
    const root = defs?.map((def)=>recursivelyProcessColDef(def, 0)) ?? [];
    let counter = 0;
    const keyCreator = {
        getUniqueKey: (_colId, _field)=>String(++counter)
    };
    const columnTree = beans.colGroupSvc ? beans.colGroupSvc.balanceColumnTree(root, 0, maxDepth, keyCreator) : root;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, columnTree, $437b23f6a393c3bf$var$depthFirstCallback);
    return {
        columnTree: columnTree,
        treeDepth: maxDepth
    };
}
function $437b23f6a393c3bf$export$e03b26088dedc2ab(beans, defs = null, primaryColumns, existingTree, source) {
    const columnKeyCreator = new $437b23f6a393c3bf$export$f67d1427302c96a3();
    const { existingCols: existingCols, existingGroups: existingGroups, existingColKeys: existingColKeys } = $437b23f6a393c3bf$var$extractExistingTreeData(existingTree);
    columnKeyCreator.addExistingKeys(existingColKeys);
    const unbalancedTree = $437b23f6a393c3bf$var$_recursivelyCreateColumns(beans, defs, 0, primaryColumns, existingCols, columnKeyCreator, existingGroups, source);
    const { colGroupSvc: colGroupSvc } = beans;
    const treeDepth = colGroupSvc?.findMaxDepth(unbalancedTree, 0) ?? 0;
    const columnTree = colGroupSvc ? colGroupSvc.balanceColumnTree(unbalancedTree, 0, treeDepth, columnKeyCreator) : unbalancedTree;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, columnTree, $437b23f6a393c3bf$var$depthFirstCallback);
    return {
        columnTree: columnTree,
        treeDepth: treeDepth
    };
}
function $437b23f6a393c3bf$var$extractExistingTreeData(existingTree) {
    const existingCols = [];
    const existingGroups = [];
    const existingColKeys = [];
    if (existingTree) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, existingTree, (item)=>{
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(item)) {
            const group = item;
            existingGroups.push(group);
        } else {
            const col = item;
            existingColKeys.push(col.getId());
            existingCols.push(col);
        }
    });
    return {
        existingCols: existingCols,
        existingGroups: existingGroups,
        existingColKeys: existingColKeys
    };
}
function $437b23f6a393c3bf$var$_recursivelyCreateColumns(beans, defs, level, primaryColumns, existingColsCopy, columnKeyCreator, existingGroups, source) {
    if (!defs) return [];
    const { colGroupSvc: colGroupSvc } = beans;
    const result = new Array(defs.length);
    for(let i = 0; i < result.length; i++){
        const def = defs[i];
        if (colGroupSvc && $437b23f6a393c3bf$var$isColumnGroupDef(def)) result[i] = colGroupSvc.createProvidedColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, existingGroups, source);
        else result[i] = $437b23f6a393c3bf$var$createColumn(beans, primaryColumns, def, existingColsCopy, columnKeyCreator, source);
    }
    return result;
}
function $437b23f6a393c3bf$var$createColumn(beans, primaryColumns, colDef, existingColsCopy, columnKeyCreator, source) {
    const existingColAndIndex = $437b23f6a393c3bf$var$findExistingColumn(colDef, existingColsCopy);
    if (existingColAndIndex) existingColsCopy?.splice(existingColAndIndex.idx, 1);
    let column = existingColAndIndex?.column;
    if (!column) {
        const colId = columnKeyCreator.getUniqueKey(colDef.colId, colDef.field);
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, colId);
        column = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDefMerged, colDef, colId, primaryColumns);
        beans.context.createBean(column);
    } else {
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, column.getColId());
        column.setColDef(colDefMerged, colDef, source);
        $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDefMerged, source);
    }
    beans.dataTypeSvc?.addColumnListeners(column);
    return column;
}
function $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, hide, sort, sortIndex, pinned, flex, source) {
    const { sortSvc: sortSvc, pinnedCols: pinnedCols, colFlex: colFlex } = beans;
    if (hide !== void 0) column.setVisible(!hide, source);
    if (sortSvc) {
        sortSvc.updateColSort(column, sort, source);
        if (sortIndex !== void 0) sortSvc.setColSortIndex(column, sortIndex);
    }
    if (pinned !== void 0) pinnedCols?.setColPinned(column, pinned);
    if (flex !== void 0) colFlex?.setColFlex(column, flex);
}
function $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDef, source) {
    $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, colDef.hide, colDef.sort, colDef.sortIndex, colDef.pinned, colDef.flex, source);
    const colFlex = column.getFlex();
    if (colFlex != null && colFlex > 0) return;
    if (colDef.width != null) column.setActualWidth(colDef.width, source);
    else {
        const widthBeforeUpdate = column.getActualWidth();
        column.setActualWidth(widthBeforeUpdate, source);
    }
}
function $437b23f6a393c3bf$var$findExistingColumn(newColDef, existingColsCopy) {
    if (!existingColsCopy) return void 0;
    for(let i = 0; i < existingColsCopy.length; i++){
        const def = existingColsCopy[i].getUserProvidedColDef();
        if (!def) continue;
        const newHasId = newColDef.colId != null;
        if (newHasId) {
            if (existingColsCopy[i].getId() === newColDef.colId) return {
                idx: i,
                column: existingColsCopy[i]
            };
            continue;
        }
        const newHasField = newColDef.field != null;
        if (newHasField) {
            if (def.field === newColDef.field) return {
                idx: i,
                column: existingColsCopy[i]
            };
            continue;
        }
        if (def === newColDef) return {
            idx: i,
            column: existingColsCopy[i]
        };
    }
    return void 0;
}
function $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, colId, isAutoCol) {
    const { gos: gos, dataTypeSvc: dataTypeSvc } = beans;
    const res = {};
    const defaultColDef = gos.get("defaultColDef");
    $437b23f6a393c3bf$export$8ade6bd474fcde42(res, defaultColDef, false, true);
    const columnType = $437b23f6a393c3bf$var$updateColDefAndGetColumnType(beans, res, colDef, colId);
    if (columnType) $437b23f6a393c3bf$var$assignColumnTypes(beans, columnType, res);
    const cellDataType = res.cellDataType;
    $437b23f6a393c3bf$export$8ade6bd474fcde42(res, colDef, false, true);
    if (cellDataType !== void 0) res.cellDataType = cellDataType;
    const autoGroupColDef = gos.get("autoGroupColumnDef");
    const isSortingCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
    if (colDef.rowGroup && autoGroupColDef && isSortingCoupled) $437b23f6a393c3bf$export$8ade6bd474fcde42(res, {
        sort: autoGroupColDef.sort,
        initialSort: autoGroupColDef.initialSort
    }, false, true);
    if (dataTypeSvc) {
        dataTypeSvc.postProcess(res);
        dataTypeSvc.validateColDef(res);
    }
    gos.validateColDef(res, colId, isAutoCol);
    return res;
}
function $437b23f6a393c3bf$var$updateColDefAndGetColumnType(beans, colDef, userColDef, colId) {
    const dataTypeDefinitionColumnType = beans.dataTypeSvc?.updateColDefAndGetColumnType(colDef, userColDef, colId);
    const columnTypes = userColDef.type ?? dataTypeDefinitionColumnType ?? colDef.type;
    colDef.type = columnTypes;
    return columnTypes ? $437b23f6a393c3bf$var$convertColumnTypes(columnTypes) : void 0;
}
function $437b23f6a393c3bf$var$assignColumnTypes(beans, typeKeys, colDefMerged) {
    if (!typeKeys.length) return;
    const allColumnTypes = Object.assign({}, $437b23f6a393c3bf$var$DefaultColumnTypes);
    const userTypes = beans.gos.get("columnTypes") || {};
    for (const key of Object.keys(userTypes)){
        const value = userTypes[key];
        if (key in allColumnTypes) $437b23f6a393c3bf$export$545083624300f13d(34, {
            key: key
        });
        else {
            const colType = value;
            if (colType.type) $437b23f6a393c3bf$export$545083624300f13d(35);
            allColumnTypes[key] = value;
        }
    }
    for (const t of typeKeys){
        const typeColDef = allColumnTypes[t.trim()];
        if (typeColDef) $437b23f6a393c3bf$export$8ade6bd474fcde42(colDefMerged, typeColDef, false, true);
        else $437b23f6a393c3bf$export$545083624300f13d(36, {
            t: t
        });
    }
}
function $437b23f6a393c3bf$var$isColumnGroupDef(abstractColDef) {
    return abstractColDef.children !== void 0;
}
function $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(parent, tree, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
        callback(child, parent);
    }
}
// packages/ag-grid-community/src/columnMove/columnMoveUtils.ts
function $437b23f6a393c3bf$var$placeLockedColumns(cols, gos) {
    const left = [];
    const normal = [];
    const right = [];
    cols.forEach((col)=>{
        const position = col.getColDef().lockPosition;
        if (position === "right") right.push(col);
        else if (position === "left" || position === true) left.push(col);
        else normal.push(col);
    });
    const isRtl = gos.get("enableRtl");
    if (isRtl) return [
        ...right,
        ...normal,
        ...left
    ];
    return [
        ...left,
        ...normal,
        ...right
    ];
}
function $437b23f6a393c3bf$var$doesMovePassMarryChildren(allColumnsCopy, gridBalancedTree) {
    let rulePassed = true;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, gridBalancedTree, (child)=>{
        if (!$437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) return;
        const columnGroup = child;
        const colGroupDef = columnGroup.getColGroupDef();
        const marryChildren = colGroupDef?.marryChildren;
        if (!marryChildren) return;
        const newIndexes = [];
        for (const col of columnGroup.getLeafColumns()){
            const newColIndex = allColumnsCopy.indexOf(col);
            newIndexes.push(newColIndex);
        }
        const maxIndex = Math.max.apply(Math, newIndexes);
        const minIndex = Math.min.apply(Math, newIndexes);
        const spread = maxIndex - minIndex;
        const maxSpread = columnGroup.getLeafColumns().length - 1;
        if (spread > maxSpread) rulePassed = false;
    });
    return rulePassed;
}
// packages/ag-grid-community/src/columns/columnEventUtils.ts
function $437b23f6a393c3bf$var$getCommonValue(cols, valueGetter) {
    if (!cols || cols.length == 0) return void 0;
    const firstValue = valueGetter(cols[0]);
    for(let i = 1; i < cols.length; i++){
        if (firstValue !== valueGetter(cols[i])) return void 0;
    }
    return firstValue;
}
function $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(eventSvc, changedColumns, source) {
    if (!changedColumns.length) return;
    const column = changedColumns.length === 1 ? changedColumns[0] : null;
    const pinned = $437b23f6a393c3bf$var$getCommonValue(changedColumns, (col)=>col.getPinned());
    eventSvc.dispatchEvent({
        type: "columnPinned",
        // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
        pinned: pinned != null ? pinned : null,
        columns: changedColumns,
        column: column,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnVisibleEvent(eventSvc, changedColumns, source) {
    if (!changedColumns.length) return;
    const column = changedColumns.length === 1 ? changedColumns[0] : null;
    const visible = $437b23f6a393c3bf$var$getCommonValue(changedColumns, (col)=>col.isVisible());
    eventSvc.dispatchEvent({
        type: "columnVisible",
        visible: visible,
        columns: changedColumns,
        column: column,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnChangedEvent(eventSvc, type, columns, source) {
    eventSvc.dispatchEvent({
        type: type,
        columns: columns,
        column: columns && columns.length == 1 ? columns[0] : null,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnResizedEvent(eventSvc, columns, finished, source, flexColumns = null) {
    if (columns?.length) eventSvc.dispatchEvent({
        type: "columnResized",
        columns: columns,
        column: columns.length === 1 ? columns[0] : null,
        flexColumns: flexColumns,
        finished: finished,
        source: source
    });
}
// packages/ag-grid-community/src/columns/columnStateUtils.ts
function $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, params, source) {
    const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, colAnimation: colAnimation, visibleCols: visibleCols, pivotResultCols: pivotResultCols, environment: environment, valueColsSvc: valueColsSvc, eventSvc: eventSvc, gos: gos } = beans;
    const providedCols = colModel.getColDefCols() ?? [];
    const selectionCols = selectionColSvc?.getColumns();
    if (!providedCols.length && !selectionCols?.length) return false;
    if (params?.state && !params.state.forEach) {
        $437b23f6a393c3bf$export$545083624300f13d(32);
        return false;
    }
    const syncColumnWithStateItem = (column, stateItem, rowGroupIndexes, pivotIndexes, autoCol)=>{
        if (!column) return;
        const getValue = $437b23f6a393c3bf$var$getValueFactory(stateItem, params.defaultState);
        const flex = getValue("flex").value1;
        $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, getValue("hide").value1, getValue("sort").value1, getValue("sortIndex").value1, getValue("pinned").value1, flex, source);
        if (flex == null) {
            const width = getValue("width").value1;
            if (width != null) {
                const minColWidth = column.getColDef().minWidth ?? environment.getDefaultColumnMinWidth();
                if (minColWidth != null && width >= minColWidth) column.setActualWidth(width, source);
            }
        }
        if (autoCol || !column.isPrimary()) return;
        valueColsSvc?.syncColumnWithState(column, source, getValue);
        rowGroupColsSvc?.syncColumnWithState(column, source, getValue, rowGroupIndexes);
        pivotColsSvc?.syncColumnWithState(column, source, getValue, pivotIndexes);
    };
    const applyStates = (states, existingColumns, getById2)=>{
        const dispatchEventsFunc = $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source);
        const columnsWithNoState = existingColumns.slice();
        const rowGroupIndexes = {};
        const pivotIndexes = {};
        const autoColStates = [];
        const selectionColStates = [];
        const unmatchedAndAutoStates2 = [];
        let unmatchedCount2 = 0;
        const previousRowGroupCols = rowGroupColsSvc?.columns.slice() ?? [];
        const previousPivotCols = pivotColsSvc?.columns.slice() ?? [];
        for (const state of states){
            const colId = state.colId;
            const isAutoGroupColumn = colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
            if (isAutoGroupColumn) {
                autoColStates.push(state);
                unmatchedAndAutoStates2.push(state);
                continue;
            }
            if ($437b23f6a393c3bf$export$f6074a9792015c5d(colId)) {
                selectionColStates.push(state);
                unmatchedAndAutoStates2.push(state);
                continue;
            }
            const column = getById2(colId);
            if (!column) {
                unmatchedAndAutoStates2.push(state);
                unmatchedCount2 += 1;
            } else {
                syncColumnWithStateItem(column, state, rowGroupIndexes, pivotIndexes, false);
                $437b23f6a393c3bf$export$83a881c8b5120679(columnsWithNoState, column);
            }
        }
        const applyDefaultsFunc = (col)=>syncColumnWithStateItem(col, null, rowGroupIndexes, pivotIndexes, false);
        columnsWithNoState.forEach(applyDefaultsFunc);
        rowGroupColsSvc?.sortColumns($437b23f6a393c3bf$var$comparatorByIndex.bind(rowGroupColsSvc, rowGroupIndexes, previousRowGroupCols));
        pivotColsSvc?.sortColumns($437b23f6a393c3bf$var$comparatorByIndex.bind(pivotColsSvc, pivotIndexes, previousPivotCols));
        colModel.refreshCols(false, source);
        const syncColStates = (getCol, colStates, columns = [])=>{
            for (const stateItem of colStates){
                const col = getCol(stateItem.colId);
                $437b23f6a393c3bf$export$83a881c8b5120679(columns, col);
                syncColumnWithStateItem(col, stateItem, null, null, true);
            }
            columns.forEach(applyDefaultsFunc);
        };
        syncColStates((colId)=>autoColSvc?.getColumn(colId) ?? null, autoColStates, autoColSvc?.getColumns()?.slice());
        syncColStates((colId)=>selectionColSvc?.getColumn(colId) ?? null, selectionColStates, selectionColSvc?.getColumns()?.slice());
        $437b23f6a393c3bf$var$orderLiveColsLikeState(params, colModel, gos);
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnEverythingChanged",
            source: source
        });
        dispatchEventsFunc();
        return {
            unmatchedAndAutoStates: unmatchedAndAutoStates2,
            unmatchedCount: unmatchedCount2
        };
    };
    colAnimation?.start();
    let { unmatchedAndAutoStates: unmatchedAndAutoStates, unmatchedCount: unmatchedCount } = applyStates(params.state || [], providedCols, (id)=>colModel.getColDefCol(id));
    if (unmatchedAndAutoStates.length > 0 || $437b23f6a393c3bf$export$25d27f17d3af40f7(params.defaultState)) {
        const pivotResultColsList = pivotResultCols?.getPivotResultCols()?.list ?? [];
        unmatchedCount = applyStates(unmatchedAndAutoStates, pivotResultColsList, (id)=>pivotResultCols?.getPivotResultCol(id) ?? null).unmatchedCount;
    }
    colAnimation?.finish();
    return unmatchedCount === 0;
}
function $437b23f6a393c3bf$export$96a6cbc000255060(beans, source) {
    const { colModel: colModel, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, eventSvc: eventSvc, gos: gos } = beans;
    const primaryCols = colModel.getColDefCols();
    if (!primaryCols?.length) return;
    const primaryColumnTree = colModel.getColDefColTree();
    const primaryColumns = $437b23f6a393c3bf$export$42da2aea8fab5b(primaryColumnTree);
    const columnStates = [];
    let letRowGroupIndex = 1e3;
    let letPivotIndex = 1e3;
    const addColState = (col)=>{
        const stateItem = $437b23f6a393c3bf$var$getColumnStateFromColDef(col);
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(stateItem.rowGroupIndex) && stateItem.rowGroup) stateItem.rowGroupIndex = letRowGroupIndex++;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(stateItem.pivotIndex) && stateItem.pivot) stateItem.pivotIndex = letPivotIndex++;
        columnStates.push(stateItem);
    };
    autoColSvc?.getColumns()?.forEach(addColState);
    selectionColSvc?.getColumns()?.forEach(addColState);
    primaryColumns?.forEach(addColState);
    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
        state: columnStates
    }, source);
    const autoCols = autoColSvc?.getColumns() ?? [];
    const selectionCols = selectionColSvc?.getColumns() ?? [];
    const orderedCols = [
        ...selectionCols,
        ...autoCols,
        ...primaryCols
    ];
    const orderedColState = orderedCols.map((col)=>({
            colId: col.colId
        }));
    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
        state: orderedColState,
        applyOrder: true
    }, source);
    eventSvc.dispatchEvent($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        type: "columnsReset",
        source: source
    }));
}
function $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source) {
    const { rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, valueColsSvc: valueColsSvc, colModel: colModel, sortSvc: sortSvc, eventSvc: eventSvc } = beans;
    const startState = {
        rowGroupColumns: rowGroupColsSvc?.columns.slice() ?? [],
        pivotColumns: pivotColsSvc?.columns.slice() ?? [],
        valueColumns: valueColsSvc?.columns.slice() ?? []
    };
    const columnStateBefore = $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
    const columnStateBeforeMap = {};
    for (const col of columnStateBefore)columnStateBeforeMap[col.colId] = col;
    return ()=>{
        const dispatchWhenListsDifferent = (eventType, colsBefore, colsAfter, idMapper)=>{
            const beforeList = colsBefore.map(idMapper);
            const afterList = colsAfter.map(idMapper);
            const unchanged = $437b23f6a393c3bf$export$893967cdb9833fdd(beforeList, afterList);
            if (unchanged) return;
            const changes = new Set(colsBefore);
            for (const id of colsAfter)if (!changes.delete(id)) changes.add(id);
            const changesArr = [
                ...changes
            ];
            eventSvc.dispatchEvent({
                type: eventType,
                columns: changesArr,
                column: changesArr.length === 1 ? changesArr[0] : null,
                source: source
            });
        };
        const getChangedColumns = (changedPredicate)=>{
            const changedColumns2 = [];
            colModel.forAllCols((column)=>{
                const colStateBefore = columnStateBeforeMap[column.getColId()];
                if (colStateBefore && changedPredicate(colStateBefore, column)) changedColumns2.push(column);
            });
            return changedColumns2;
        };
        const columnIdMapper = (c)=>c.getColId();
        dispatchWhenListsDifferent("columnRowGroupChanged", startState.rowGroupColumns, rowGroupColsSvc?.columns ?? [], columnIdMapper);
        dispatchWhenListsDifferent("columnPivotChanged", startState.pivotColumns, pivotColsSvc?.columns ?? [], columnIdMapper);
        const valueChangePredicate = (cs, c)=>{
            const oldActive = cs.aggFunc != null;
            const activeChanged = oldActive != c.isValueActive();
            const aggFuncChanged = oldActive && cs.aggFunc != c.getAggFunc();
            return activeChanged || aggFuncChanged;
        };
        const changedValues = getChangedColumns(valueChangePredicate);
        if (changedValues.length > 0) $437b23f6a393c3bf$var$dispatchColumnChangedEvent(eventSvc, "columnValueChanged", changedValues, source);
        const resizeChangePredicate = (cs, c)=>cs.width != c.getActualWidth();
        $437b23f6a393c3bf$var$dispatchColumnResizedEvent(eventSvc, getChangedColumns(resizeChangePredicate), true, source);
        const pinnedChangePredicate = (cs, c)=>cs.pinned != c.getPinned();
        $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(eventSvc, getChangedColumns(pinnedChangePredicate), source);
        const visibilityChangePredicate = (cs, c)=>cs.hide == c.isVisible();
        $437b23f6a393c3bf$var$dispatchColumnVisibleEvent(eventSvc, getChangedColumns(visibilityChangePredicate), source);
        const sortChangePredicate = (cs, c)=>cs.sort != c.getSort() || cs.sortIndex != c.getSortIndex();
        const changedColumns = getChangedColumns(sortChangePredicate);
        if (changedColumns.length > 0) sortSvc?.dispatchSortChangedEvents(source, changedColumns);
        const colStateAfter = $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
        $437b23f6a393c3bf$var$normaliseColumnMovedEventForColumnState(columnStateBefore, colStateAfter, source, colModel, eventSvc);
    };
}
function $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans) {
    const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = beans;
    const primaryCols = colModel.getColDefCols();
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(primaryCols) || !colModel.isAlive()) return [];
    const rowGroupColumns = rowGroupColsSvc?.columns;
    const pivotColumns = pivotColsSvc?.columns;
    const res = [];
    const createStateItemFromColumn = (column)=>{
        const rowGroupIndex = column.isRowGroupActive() && rowGroupColumns ? rowGroupColumns.indexOf(column) : null;
        const pivotIndex = column.isPivotActive() && pivotColumns ? pivotColumns.indexOf(column) : null;
        const aggFunc = column.isValueActive() ? column.getAggFunc() : null;
        const sort = column.getSort() != null ? column.getSort() : null;
        const sortIndex = column.getSortIndex() != null ? column.getSortIndex() : null;
        res.push({
            colId: column.getColId(),
            width: column.getActualWidth(),
            hide: !column.isVisible(),
            pinned: column.getPinned(),
            sort: sort,
            sortIndex: sortIndex,
            aggFunc: aggFunc,
            rowGroup: column.isRowGroupActive(),
            rowGroupIndex: rowGroupIndex,
            pivot: column.isPivotActive(),
            pivotIndex: pivotIndex,
            flex: column.getFlex() ?? null
        });
    };
    colModel.forAllCols((col)=>createStateItemFromColumn(col));
    const colIdToGridIndexMap = new Map(colModel.getCols().map((col, index)=>[
            col.getColId(),
            index
        ]));
    res.sort((itemA, itemB)=>{
        const posA = colIdToGridIndexMap.has(itemA.colId) ? colIdToGridIndexMap.get(itemA.colId) : -1;
        const posB = colIdToGridIndexMap.has(itemB.colId) ? colIdToGridIndexMap.get(itemB.colId) : -1;
        return posA - posB;
    });
    return res;
}
function $437b23f6a393c3bf$var$getColumnStateFromColDef(column) {
    const getValueOrNull = (a, b)=>a != null ? a : b != null ? b : null;
    const colDef = column.getColDef();
    const sort = getValueOrNull(colDef.sort, colDef.initialSort);
    const sortIndex = getValueOrNull(colDef.sortIndex, colDef.initialSortIndex);
    const hide = getValueOrNull(colDef.hide, colDef.initialHide);
    const pinned = getValueOrNull(colDef.pinned, colDef.initialPinned);
    const width = getValueOrNull(colDef.width, colDef.initialWidth);
    const flex = getValueOrNull(colDef.flex, colDef.initialFlex);
    let rowGroupIndex = getValueOrNull(colDef.rowGroupIndex, colDef.initialRowGroupIndex);
    let rowGroup = getValueOrNull(colDef.rowGroup, colDef.initialRowGroup);
    if (rowGroupIndex == null && !rowGroup) {
        rowGroupIndex = null;
        rowGroup = null;
    }
    let pivotIndex = getValueOrNull(colDef.pivotIndex, colDef.initialPivotIndex);
    let pivot = getValueOrNull(colDef.pivot, colDef.initialPivot);
    if (pivotIndex == null && !pivot) {
        pivotIndex = null;
        pivot = null;
    }
    const aggFunc = getValueOrNull(colDef.aggFunc, colDef.initialAggFunc);
    return {
        colId: column.getColId(),
        sort: sort,
        sortIndex: sortIndex,
        hide: hide,
        pinned: pinned,
        width: width,
        flex: flex,
        rowGroup: rowGroup,
        rowGroupIndex: rowGroupIndex,
        pivot: pivot,
        pivotIndex: pivotIndex,
        aggFunc: aggFunc
    };
}
function $437b23f6a393c3bf$var$orderLiveColsLikeState(params, colModel, gos) {
    if (!params.applyOrder || !params.state) return;
    const colIds = [];
    for (const item of params.state)if (item.colId != null) colIds.push(item.colId);
    $437b23f6a393c3bf$var$sortColsLikeKeys(colModel.cols, colIds, colModel, gos);
}
function $437b23f6a393c3bf$var$sortColsLikeKeys(cols, colIds, colModel, gos) {
    if (cols == null) return;
    let newOrder = [];
    const processedColIds = {};
    for (const colId of colIds){
        if (processedColIds[colId]) continue;
        const col = cols.map[colId];
        if (col) {
            newOrder.push(col);
            processedColIds[colId] = true;
        }
    }
    let autoGroupInsertIndex = 0;
    for (const col of cols.list){
        const colId = col.getColId();
        const alreadyProcessed = processedColIds[colId] != null;
        if (alreadyProcessed) continue;
        const isAutoGroupCol = colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
        if (isAutoGroupCol) newOrder.splice(autoGroupInsertIndex++, 0, col);
        else newOrder.push(col);
    }
    newOrder = $437b23f6a393c3bf$var$placeLockedColumns(newOrder, gos);
    if (!$437b23f6a393c3bf$var$doesMovePassMarryChildren(newOrder, colModel.getColTree())) {
        $437b23f6a393c3bf$export$545083624300f13d(39);
        return;
    }
    cols.list = newOrder;
}
function $437b23f6a393c3bf$var$normaliseColumnMovedEventForColumnState(colStateBefore, colStateAfter, source, colModel, eventSvc) {
    const colStateAfterMapped = {};
    for (const s of colStateAfter)colStateAfterMapped[s.colId] = s;
    const colsIntersectIds = {};
    for (const s of colStateBefore)if (colStateAfterMapped[s.colId]) colsIntersectIds[s.colId] = true;
    const beforeFiltered = colStateBefore.filter((c)=>colsIntersectIds[c.colId]);
    const afterFiltered = colStateAfter.filter((c)=>colsIntersectIds[c.colId]);
    const movedColumns = [];
    afterFiltered.forEach((csAfter, index)=>{
        const csBefore = beforeFiltered?.[index];
        if (csBefore && csBefore.colId !== csAfter.colId) {
            const gridCol = colModel.getCol(csBefore.colId);
            if (gridCol) movedColumns.push(gridCol);
        }
    });
    if (!movedColumns.length) return;
    eventSvc.dispatchEvent({
        type: "columnMoved",
        columns: movedColumns,
        column: movedColumns.length === 1 ? movedColumns[0] : null,
        finished: true,
        source: source
    });
}
var $437b23f6a393c3bf$var$comparatorByIndex = (indexes, oldList, colA, colB)=>{
    const indexA = indexes[colA.getId()];
    const indexB = indexes[colB.getId()];
    const aHasIndex = indexA != null;
    const bHasIndex = indexB != null;
    if (aHasIndex && bHasIndex) return indexA - indexB;
    if (aHasIndex) return -1;
    if (bHasIndex) return 1;
    const oldIndexA = oldList.indexOf(colA);
    const oldIndexB = oldList.indexOf(colB);
    const aHasOldIndex = oldIndexA >= 0;
    const bHasOldIndex = oldIndexB >= 0;
    if (aHasOldIndex && bHasOldIndex) return oldIndexA - oldIndexB;
    if (aHasOldIndex) return -1;
    return 1;
};
// packages/ag-grid-community/src/columns/columnModel.ts
var $437b23f6a393c3bf$var$ColumnModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colModel";
        // if pivotMode is on, however pivot results are NOT shown if no pivot columns are set
        this.pivotMode = false;
        this.ready = false;
        this.changeEventsDispatching = false;
    }
    postConstruct() {
        this.pivotMode = this.gos.get("pivotMode");
        this.addManagedPropertyListeners([
            "groupDisplayType",
            "treeData",
            "treeDataDisplayType",
            "groupHideOpenParents",
            "rowNumbers",
            "hidePaddedHeaderRows"
        ], (event)=>this.refreshAll($437b23f6a393c3bf$export$eb2a92b6162267d1(event.source)));
        this.addManagedPropertyListeners([
            "defaultColDef",
            "defaultColGroupDef",
            "columnTypes",
            "suppressFieldDotNotation"
        ], this.recreateColumnDefs.bind(this));
        this.addManagedPropertyListener("pivotMode", (event)=>this.setPivotMode(this.gos.get("pivotMode"), $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source)));
    }
    // called from SyncService, when grid has finished initialising
    createColsFromColDefs(source) {
        const { beans: beans } = this;
        const { valueCache: valueCache, colAutosize: colAutosize, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, valueColsSvc: valueColsSvc, visibleCols: visibleCols, eventSvc: eventSvc, groupHierarchyColSvc: groupHierarchyColSvc } = beans;
        const dispatchEventsFunc = this.colDefs ? $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source) : void 0;
        valueCache?.expire();
        const oldCols = this.colDefCols?.list;
        const oldTree = this.colDefCols?.tree;
        const newTree = $437b23f6a393c3bf$export$e03b26088dedc2ab(beans, this.colDefs, true, oldTree, source);
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(beans, this.colDefCols?.tree, newTree.columnTree);
        const tree = newTree.columnTree;
        const treeDepth = newTree.treeDepth;
        const list = $437b23f6a393c3bf$export$42da2aea8fab5b(tree);
        const map = {};
        for (const col of list)map[col.getId()] = col;
        this.colDefCols = {
            tree: tree,
            treeDepth: treeDepth,
            list: list,
            map: map
        };
        this.createColumnsForService([
            groupHierarchyColSvc
        ], this.colDefCols, source);
        rowGroupColsSvc?.extractCols(source, oldCols);
        pivotColsSvc?.extractCols(source, oldCols);
        valueColsSvc?.extractCols(source, oldCols);
        this.ready = true;
        this.refreshCols(true, source);
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnEverythingChanged",
            source: source
        });
        if (dispatchEventsFunc) {
            this.changeEventsDispatching = true;
            dispatchEventsFunc();
            this.changeEventsDispatching = false;
        }
        eventSvc.dispatchEvent({
            type: "newColumnsLoaded",
            source: source
        });
        if (source === "gridInitializing") colAutosize?.applyAutosizeStrategy();
    }
    // called from: buildAutoGroupColumns (events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents')
    // createColsFromColDefs (recreateColumnDefs, setColumnsDefs),
    // setPivotMode, applyColumnState,
    // functionColsService.setPrimaryColList, functionColsService.updatePrimaryColList,
    // pivotResultCols.setPivotResultCols
    refreshCols(newColDefs, source) {
        if (!this.colDefCols) return;
        const prevColTree = this.cols?.tree;
        this.saveColOrder();
        const { autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, rowNumbersSvc: rowNumbersSvc, quickFilter: quickFilter, pivotResultCols: pivotResultCols, showRowGroupCols: showRowGroupCols, rowAutoHeight: rowAutoHeight, visibleCols: visibleCols, colViewport: colViewport, eventSvc: eventSvc } = this.beans;
        const cols = this.selectCols(pivotResultCols, this.colDefCols);
        this.createColumnsForService([
            autoColSvc,
            selectionColSvc,
            rowNumbersSvc
        ], cols, source);
        const shouldSortNewColDefs = $437b23f6a393c3bf$var$_shouldMaintainColumnOrder(this.gos, this.showingPivotResult);
        if (!newColDefs || shouldSortNewColDefs) this.restoreColOrder(cols);
        this.positionLockedCols(cols);
        showRowGroupCols?.refresh();
        quickFilter?.refreshCols();
        this.setColSpanActive();
        rowAutoHeight?.setAutoHeightActive(cols);
        visibleCols.clear();
        colViewport.clear();
        const dispatchChangedEvent = !$437b23f6a393c3bf$export$893967cdb9833fdd(prevColTree, this.cols.tree);
        if (dispatchChangedEvent) eventSvc.dispatchEvent({
            type: "gridColumnsChanged"
        });
    }
    createColumnsForService(services, cols, source) {
        for (const service of services){
            if (!service) continue;
            service.createColumns(cols, (updateOrder)=>{
                this.lastOrder = updateOrder(this.lastOrder);
                this.lastPivotOrder = updateOrder(this.lastPivotOrder);
            }, source);
            service.addColumns(cols);
        }
    }
    selectCols(pivotResultColsSvc, colDefCols) {
        const pivotResultCols = pivotResultColsSvc?.getPivotResultCols() ?? null;
        this.showingPivotResult = pivotResultCols != null;
        const { map: map, list: list, tree: tree, treeDepth: treeDepth } = pivotResultCols ?? colDefCols;
        this.cols = {
            list: list.slice(),
            map: {
                ...map
            },
            tree: tree.slice(),
            treeDepth: treeDepth
        };
        if (pivotResultCols) {
            const hasSameColumns = pivotResultCols.list.some((col)=>this.cols?.map[col.getColId()] !== void 0);
            if (!hasSameColumns) this.lastPivotOrder = null;
        }
        return this.cols;
    }
    getColsToShow() {
        if (!this.cols) return [];
        const { valueColsSvc: valueColsSvc, selectionColSvc: selectionColSvc, gos: gos } = this.beans;
        const showAutoGroupAndValuesOnly = this.isPivotMode() && !this.showingPivotResult;
        const showSelectionColumn = selectionColSvc?.isSelectionColumnEnabled();
        const showRowNumbers = gos.get("rowNumbers");
        const valueColumns = valueColsSvc?.columns;
        const res = this.cols.list.filter((col)=>{
            const isAutoGroupCol = $437b23f6a393c3bf$export$61b34611dc010a97(col);
            if (showAutoGroupAndValuesOnly) {
                const isValueCol = valueColumns?.includes(col);
                return isAutoGroupCol || isValueCol || showSelectionColumn && $437b23f6a393c3bf$export$f6074a9792015c5d(col) || showRowNumbers && $437b23f6a393c3bf$export$3d3e7d751f0445eb(col);
            } else return isAutoGroupCol || col.isVisible();
        });
        return res;
    }
    // on events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents'
    refreshAll(source) {
        if (!this.ready) return;
        this.refreshCols(false, source);
        this.beans.visibleCols.refresh(source);
    }
    setColsVisible(keys, visible = false, source) {
        $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
            state: keys.map((key)=>({
                    colId: typeof key === "string" ? key : key.getColId(),
                    hide: !visible
                }))
        }, source);
    }
    /**
   * Restores provided columns order to the previous order in this.lastPivotOrder / this.lastOrder
   * If columns are not in the last order:
   *  - Check column groups, and apply column after the last column in the lowest shared group
   *  - If no sibling is found, apply the column at the end of the cols
   */ restoreColOrder(cols) {
        const lastOrder = this.showingPivotResult ? this.lastPivotOrder : this.lastOrder;
        if (!lastOrder) return;
        const preservedOrder = lastOrder.filter((col)=>cols.map[col.getId()] != null);
        if (preservedOrder.length === 0) return;
        if (preservedOrder.length === cols.list.length) {
            cols.list = preservedOrder;
            return;
        }
        const hasSiblings = (col)=>{
            const ancestor = col.getOriginalParent();
            if (!ancestor) return false;
            const children = ancestor.getChildren();
            if (children.length > 1) return true;
            return hasSiblings(ancestor);
        };
        if (!preservedOrder.some((col)=>hasSiblings(col))) {
            const preservedOrderSet = new Set(preservedOrder);
            for (const col of cols.list)if (!preservedOrderSet.has(col)) preservedOrder.push(col);
            cols.list = preservedOrder;
            return;
        }
        const colPositionMap = /* @__PURE__ */ new Map();
        for(let i = 0; i < preservedOrder.length; i++){
            const col = preservedOrder[i];
            colPositionMap.set(col, i);
        }
        const additionalCols = cols.list.filter((col)=>!colPositionMap.has(col));
        if (additionalCols.length === 0) {
            cols.list = preservedOrder;
            return;
        }
        const getPreviousSibling = (col, group)=>{
            const parent = group ? group.getOriginalParent() : col.getOriginalParent();
            if (!parent) return null;
            let highestIdx = null;
            let highestSibling = null;
            for (const child of parent.getChildren()){
                if (child === group || child === col) continue;
                if (child instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2) {
                    const colIdx = colPositionMap.get(child);
                    if (colIdx == null) continue;
                    if (highestIdx == null || highestIdx < colIdx) {
                        highestIdx = colIdx;
                        highestSibling = child;
                    }
                    continue;
                }
                child.forEachLeafColumn((leafCol)=>{
                    const colIdx = colPositionMap.get(leafCol);
                    if (colIdx == null) return;
                    if (highestIdx == null || highestIdx < colIdx) {
                        highestIdx = colIdx;
                        highestSibling = leafCol;
                    }
                });
            }
            if (highestSibling == null) return getPreviousSibling(col, parent);
            return highestSibling;
        };
        const noSiblingsAvailable = [];
        const previousSiblingPosMap = /* @__PURE__ */ new Map();
        for (const col of additionalCols){
            const prevSiblingIdx = getPreviousSibling(col, null);
            if (prevSiblingIdx == null) {
                noSiblingsAvailable.push(col);
                continue;
            }
            const prev = previousSiblingPosMap.get(prevSiblingIdx);
            if (prev === void 0) previousSiblingPosMap.set(prevSiblingIdx, col);
            else if (Array.isArray(prev)) prev.push(col);
            else previousSiblingPosMap.set(prevSiblingIdx, [
                prev,
                col
            ]);
        }
        const result = new Array(cols.list.length);
        let resultPointer = result.length - 1;
        for(let i = noSiblingsAvailable.length - 1; i >= 0; i--)result[resultPointer--] = noSiblingsAvailable[i];
        for(let i = preservedOrder.length - 1; i >= 0; i--){
            const nextCol = preservedOrder[i];
            const extraCols = previousSiblingPosMap.get(nextCol);
            if (extraCols) {
                if (Array.isArray(extraCols)) for(let x = extraCols.length - 1; x >= 0; x--){
                    const col = extraCols[x];
                    result[resultPointer--] = col;
                }
                else result[resultPointer--] = extraCols;
            }
            result[resultPointer--] = nextCol;
        }
        cols.list = result;
    }
    positionLockedCols(cols) {
        cols.list = $437b23f6a393c3bf$var$placeLockedColumns(cols.list, this.gos);
    }
    saveColOrder() {
        if (this.showingPivotResult) this.lastPivotOrder = this.cols?.list ?? null;
        else this.lastOrder = this.cols?.list ?? null;
    }
    getColumnDefs(sorted) {
        return this.colDefCols && this.beans.colDefFactory?.getColumnDefs(this.colDefCols.list, this.showingPivotResult, this.lastOrder, this.cols?.list ?? [], sorted);
    }
    setColSpanActive() {
        this.colSpanActive = !!this.cols?.list.some((col)=>col.getColDef().colSpan != null);
    }
    isPivotMode() {
        return this.pivotMode;
    }
    setPivotMode(pivotMode, source) {
        if (pivotMode === this.pivotMode) return;
        this.pivotMode = pivotMode;
        if (!this.ready) return;
        this.refreshCols(false, source);
        const { visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnPivotModeChanged"
        });
    }
    // + clientSideRowModel
    isPivotActive() {
        const pivotColumns = this.beans.pivotColsSvc?.columns;
        return this.pivotMode && !!pivotColumns?.length;
    }
    // called when dataTypes change
    recreateColumnDefs(e) {
        if (!this.cols) return;
        this.beans.autoColSvc?.updateColumns(e);
        const source = $437b23f6a393c3bf$export$eb2a92b6162267d1(e.source);
        this.createColsFromColDefs(source);
    }
    setColumnDefs(columnDefs, source) {
        this.colDefs = columnDefs;
        this.createColsFromColDefs(source);
    }
    destroy() {
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.colDefCols?.tree);
        super.destroy();
    }
    getColTree() {
        return this.cols?.tree ?? [];
    }
    // + columnSelectPanel
    getColDefColTree() {
        return this.colDefCols?.tree ?? [];
    }
    // + clientSideRowController -> sorting, building quick filter text
    // + headerRenderer -> sorting (clearing icon)
    getColDefCols() {
        return this.colDefCols?.list ?? null;
    }
    // + moveColumnController
    getCols() {
        return this.cols?.list ?? [];
    }
    forAllCols(callback) {
        const { pivotResultCols: pivotResultCols, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, groupHierarchyColSvc: groupHierarchyColSvc } = this.beans;
        $437b23f6a393c3bf$var$_forAll(this.colDefCols?.list, callback);
        $437b23f6a393c3bf$var$_forAll(autoColSvc?.columns?.list, callback);
        $437b23f6a393c3bf$var$_forAll(selectionColSvc?.columns?.list, callback);
        $437b23f6a393c3bf$var$_forAll(groupHierarchyColSvc?.columns?.list, callback);
        $437b23f6a393c3bf$var$_forAll(pivotResultCols?.getPivotResultCols()?.list, callback);
    }
    getColsForKeys(keys) {
        if (!keys) return [];
        return keys.map((key)=>this.getCol(key)).filter((col)=>col != null);
    }
    getColDefCol(key) {
        if (!this.colDefCols?.list) return null;
        return this.getColFromCollection(key, this.colDefCols);
    }
    getCol(key) {
        if (key == null) return null;
        return this.getColFromCollection(key, this.cols);
    }
    /**
   * Get column exclusively by ID.
   *
   * Note getCol/getColFromCollection have poor performance when col has been removed.
   */ getColById(key) {
        return this.cols?.map[key] ?? null;
    }
    getColFromCollection(key, cols) {
        if (cols == null) return null;
        const { map: map, list: list } = cols;
        if (typeof key == "string" && map[key]) return map[key];
        for(let i = 0; i < list.length; i++){
            if ($437b23f6a393c3bf$export$f5687d41c39fa1b3(list[i], key)) return list[i];
        }
        const { autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, groupHierarchyColSvc: groupHierarchyColSvc } = this.beans;
        return autoColSvc?.getColumn(key) ?? selectionColSvc?.getColumn(key) ?? groupHierarchyColSvc?.getColumn(key) ?? null;
    }
};
// packages/ag-grid-community/src/columns/baseColsService.ts
var $437b23f6a393c3bf$export$3687f0f5678a5df3 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.dispatchColumnChangedEvent = $437b23f6a393c3bf$var$dispatchColumnChangedEvent;
        this.columns = [];
        this.columnIndexMap = {};
        this.updateIndexMap = ()=>{
            this.columnIndexMap = {};
            this.columns.forEach((col, index)=>this.columnIndexMap[col.getId()] = index);
        };
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.aggFuncSvc = beans.aggFuncSvc;
        this.visibleCols = beans.visibleCols;
        this.groupHierarchCols = beans.groupHierarchyColSvc;
    }
    sortColumns(compareFn) {
        const { groupHierarchCols: groupHierarchCols } = this;
        this.columns.sort((a, b)=>groupHierarchCols?.compareVirtualColumns(a, b) ?? compareFn(a, b));
        this.updateIndexMap();
    }
    setColumns(colKeys, source) {
        this.setColList(colKeys, this.columns, this.eventName, true, true, this.columnProcessors.set, source);
    }
    addColumns(colKeys, source) {
        this.updateColList(colKeys, this.columns, true, true, this.columnProcessors.add, this.eventName, source);
    }
    removeColumns(colKeys, source) {
        this.updateColList(colKeys, this.columns, false, true, this.columnProcessors.remove, this.eventName, source);
    }
    getColumnIndex(colId) {
        return this.columnIndexMap[colId];
    }
    setColList(colKeys = [], masterList, eventName, detectOrderChange, autoGroupsNeedBuilding, columnCallback, source) {
        const gridColumns = this.colModel.getCols();
        if (!gridColumns || gridColumns.length === 0) return;
        const changes = /* @__PURE__ */ new Map();
        masterList.forEach((col, idx)=>changes.set(col, idx));
        masterList.length = 0;
        for (const key of colKeys){
            const column = this.colModel.getColDefCol(key);
            if (column) masterList.push(column);
        }
        masterList.forEach((col, idx)=>{
            const oldIndex = changes.get(col);
            if (oldIndex === void 0) {
                changes.set(col, 0);
                return;
            }
            if (detectOrderChange && oldIndex !== idx) return;
            changes.delete(col);
        });
        this.updateIndexMap();
        const primaryCols = this.colModel.getColDefCols();
        for (const column of primaryCols ?? []){
            const added = masterList.indexOf(column) >= 0;
            columnCallback(column, added, source);
        }
        autoGroupsNeedBuilding && this.colModel.refreshCols(false, source);
        this.visibleCols.refresh(source);
        this.dispatchColumnChangedEvent(this.eventSvc, eventName, [
            ...changes.keys()
        ], source);
    }
    updateColList(keys = [], masterList, actionIsAdd, autoGroupsNeedBuilding, columnCallback, eventType, source) {
        if (!keys || keys.length === 0) return;
        let atLeastOne = false;
        const updatedCols = /* @__PURE__ */ new Set();
        for (const key of keys){
            if (!key) continue;
            const columnToAdd = this.colModel.getColDefCol(key);
            if (!columnToAdd) continue;
            updatedCols.add(columnToAdd);
            if (actionIsAdd) {
                if (masterList.indexOf(columnToAdd) >= 0) continue;
                masterList.push(columnToAdd);
            } else {
                const currentIndex = masterList.indexOf(columnToAdd);
                if (currentIndex < 0) continue;
                for(let i = currentIndex + 1; i < masterList.length; i++)updatedCols.add(masterList[i]);
                $437b23f6a393c3bf$export$83a881c8b5120679(masterList, columnToAdd);
            }
            columnCallback(columnToAdd, actionIsAdd, source);
            atLeastOne = true;
        }
        if (!atLeastOne) return;
        this.updateIndexMap();
        if (autoGroupsNeedBuilding) this.colModel.refreshCols(false, source);
        this.visibleCols.refresh(source);
        const eventColumns = Array.from(updatedCols);
        this.eventSvc.dispatchEvent({
            type: eventType,
            columns: eventColumns,
            column: eventColumns.length === 1 ? eventColumns[0] : null,
            source: source
        });
    }
    extractCols(source, oldProvidedCols = []) {
        const previousCols = this.columns;
        const colsWithIndex = [];
        const colsWithValue = [];
        const { setFlagFunc: setFlagFunc, getIndexFunc: getIndexFunc, getInitialIndexFunc: getInitialIndexFunc, getValueFunc: getValueFunc, getInitialValueFunc: getInitialValueFunc } = this.columnExtractors;
        const primaryCols = this.colModel.getColDefCols();
        for (const col of primaryCols ?? []){
            const colIsNew = !oldProvidedCols.includes(col);
            const colDef = col.getColDef();
            const value = getValueFunc(colDef);
            const initialValue = getInitialValueFunc(colDef);
            const index = getIndexFunc(colDef);
            const initialIndex = getInitialIndexFunc(colDef);
            let include;
            const valuePresent = value !== void 0;
            const indexPresent = index !== void 0;
            const initialValuePresent = initialValue !== void 0;
            const initialIndexPresent = initialIndex !== void 0;
            if (valuePresent) include = value;
            else if (indexPresent) {
                if (index === null) include = false;
                else include = index >= 0;
            } else if (colIsNew) {
                if (initialValuePresent) include = initialValue;
                else if (initialIndexPresent) include = initialIndex != null && initialIndex >= 0;
                else include = false;
            } else include = previousCols.indexOf(col) >= 0;
            if (include) {
                const useIndex = colIsNew ? index != null || initialIndex != null : index != null;
                useIndex ? colsWithIndex.push(col) : colsWithValue.push(col);
            }
        }
        const getIndexForCol = (col)=>{
            const colDef = col.getColDef();
            return getIndexFunc(colDef) ?? getInitialIndexFunc(colDef);
        };
        colsWithIndex.sort((colA, colB)=>getIndexForCol(colA) - getIndexForCol(colB));
        const res = [];
        const groupHierarchCols = this.groupHierarchCols;
        const addCol = (col)=>{
            if (groupHierarchCols) groupHierarchCols.expandColumnInto(res, col);
            else res.push(col);
        };
        colsWithIndex.forEach(addCol);
        for (const col of previousCols)if (colsWithValue.indexOf(col) >= 0) addCol(col);
        for (const col of colsWithValue)if (res.indexOf(col) < 0) addCol(col);
        for (const col of previousCols)if (res.indexOf(col) < 0) setFlagFunc(col, false, source);
        for (const col of res)if (previousCols.indexOf(col) < 0) setFlagFunc(col, true, source);
        this.columns = res;
        this.updateIndexMap();
        return this.columns;
    }
    restoreColumnOrder(columnStateAccumulator, incomingColumnState) {
        const colList = this.columns;
        const primaryCols = this.colModel.getColDefCols();
        if (!colList.length || !primaryCols) return columnStateAccumulator;
        const updatedColIdArray = Object.keys(incomingColumnState);
        const updatedColIds = new Set(updatedColIdArray);
        const newColIds = new Set(updatedColIdArray);
        const allColIds = new Set(colList.map((column)=>{
            const colId = column.getColId();
            newColIds.delete(colId);
            return colId;
        }).concat(updatedColIdArray));
        const colIdsInOriginalOrder = [];
        const originalOrderMap = {};
        let orderIndex = 0;
        for(let i = 0; i < primaryCols.length; i++){
            const colId = primaryCols[i].getColId();
            if (allColIds.has(colId)) {
                colIdsInOriginalOrder.push(colId);
                originalOrderMap[colId] = orderIndex++;
            }
        }
        let index = 1e3;
        let hasAddedNewCols = false;
        let lastIndex = 0;
        const enableProp = this.columnOrdering.enableProp;
        const initialEnableProp = this.columnOrdering.initialEnableProp;
        const indexProp = this.columnOrdering.indexProp;
        const initialIndexProp = this.columnOrdering.initialIndexProp;
        const processPrecedingNewCols = (colId)=>{
            const originalOrderIndex = originalOrderMap[colId];
            for(let i = lastIndex; i < originalOrderIndex; i++){
                const newColId = colIdsInOriginalOrder[i];
                if (newColIds.has(newColId)) {
                    incomingColumnState[newColId][indexProp] = index++;
                    newColIds.delete(newColId);
                }
            }
            lastIndex = originalOrderIndex;
        };
        for (const column of colList){
            const colId = column.getColId();
            if (updatedColIds.has(colId)) {
                processPrecedingNewCols(colId);
                incomingColumnState[colId][indexProp] = index++;
            } else {
                const colDef = column.getColDef();
                const missingIndex = colDef[indexProp] === null || colDef[indexProp] === void 0 && colDef[initialIndexProp] == null;
                if (missingIndex) {
                    if (!hasAddedNewCols) {
                        const propEnabled = colDef[enableProp] || colDef[enableProp] === void 0 && colDef[initialEnableProp];
                        if (propEnabled) processPrecedingNewCols(colId);
                        else {
                            for (const newColId of newColIds)incomingColumnState[newColId][indexProp] = index + originalOrderMap[newColId];
                            index += colIdsInOriginalOrder.length;
                            hasAddedNewCols = true;
                        }
                    }
                    if (!columnStateAccumulator[colId]) columnStateAccumulator[colId] = {
                        colId: colId
                    };
                    columnStateAccumulator[colId][indexProp] = index++;
                }
            }
        }
        return columnStateAccumulator;
    }
};
// packages/ag-grid-community/src/columns/groupInstanceIdCreator.ts
var $437b23f6a393c3bf$export$b3b24737a74261fb = class {
    constructor(){
        // this map contains keys to numbers, so we remember what the last call was
        this.existingIds = {};
    }
    getInstanceIdForKey(key) {
        const lastResult = this.existingIds[key];
        let result;
        if (typeof lastResult !== "number") result = 0;
        else result = lastResult + 1;
        this.existingIds[key] = result;
        return result;
    }
};
// packages/ag-grid-community/src/components/emptyBean.ts
var $437b23f6a393c3bf$export$4f8bbae47c6ad8d2 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
};
function $437b23f6a393c3bf$var$setupCompBean(ctrl, ctx, compBean) {
    if (compBean) ctrl.addDestroyFunc(()=>ctx.destroyBean(compBean));
    return compBean ?? ctrl;
}
// packages/ag-grid-community/src/agStack/interfaces/agComponent.ts
var $437b23f6a393c3bf$export$6c811454646ed8be = null;
function $437b23f6a393c3bf$export$e9be47ed2688240e(item) {
    return typeof item?.getGui === "function";
}
// packages/ag-grid-community/src/agStack/core/cssClassManager.ts
var $437b23f6a393c3bf$export$a7053cb7eb605bd2 = class {
    constructor(getGui){
        // to minimise DOM hits, we only apply CSS classes if they have changed. as adding a CSS class that is already
        // there, or removing one that wasn't present, all takes CPU.
        this.cssClassStates = {};
        this.getGui = getGui;
    }
    toggleCss(className, addOrRemove) {
        if (!className) return;
        if (className.indexOf(" ") >= 0) {
            const list = (className || "").split(" ");
            if (list.length > 1) {
                for (const cls of list)this.toggleCss(cls, addOrRemove);
                return;
            }
        }
        const updateNeeded = this.cssClassStates[className] !== addOrRemove;
        if (updateNeeded && className.length) {
            this.getGui()?.classList.toggle(className, addOrRemove);
            this.cssClassStates[className] = addOrRemove;
        }
    }
};
// packages/ag-grid-community/src/agStack/core/agComponentStub.ts
var $437b23f6a393c3bf$var$compIdSequence = 0;
var $437b23f6a393c3bf$export$e6818678a6454cbe = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(templateOrParams, componentSelectors){
        super();
        this.suppressDataRefValidation = false;
        // if false, then CSS class "ag-hidden" is applied, which sets "display: none"
        this.displayed = true;
        // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"
        this.visible = true;
        // unique id for this row component. this is used for getting a reference to the HTML dom.
        // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
        // around as we create a new rowComp instance for the same row node).
        this.compId = $437b23f6a393c3bf$var$compIdSequence++;
        this.cssManager = new $437b23f6a393c3bf$export$a7053cb7eb605bd2(()=>this.eGui);
        this.componentSelectors = new Map((componentSelectors ?? []).map((comp)=>[
                comp.selector,
                comp
            ]));
        if (templateOrParams) this.setTemplate(templateOrParams);
    }
    preConstruct() {
        this.wireTemplate(this.getGui());
        const debugId = "component-" + Object.getPrototypeOf(this)?.constructor?.name;
        for (const css of this.css ?? [])this.beans.environment.addGlobalCSS(css, debugId);
    }
    wireTemplate(element, paramsMap) {
        if (element && this.gos) {
            this.applyElementsToComponent(element);
            this.createChildComponentsFromTags(element, paramsMap);
        }
    }
    getCompId() {
        return this.compId;
    }
    getDataRefAttribute(element) {
        if (element.getAttribute) return element.getAttribute($437b23f6a393c3bf$var$DataRefAttribute);
        return null;
    }
    applyElementsToComponent(element, elementRef, paramsMap, newComponent = null) {
        if (elementRef === void 0) elementRef = this.getDataRefAttribute(element);
        if (elementRef) {
            const current = this[elementRef];
            if (current === $437b23f6a393c3bf$export$6c811454646ed8be) this[elementRef] = newComponent ?? element;
            else {
                const usedAsParamRef = paramsMap?.[elementRef];
                if (!this.suppressDataRefValidation && !usedAsParamRef) throw new Error(`data-ref: ${elementRef} on ${this.constructor.name} with ${current}`);
            }
        }
    }
    // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
    createChildComponentsFromTags(parentNode, paramsMap) {
        const childNodeList = [];
        for (const childNode of parentNode.childNodes ?? [])childNodeList.push(childNode);
        for (const childNode of childNodeList){
            if (!(childNode instanceof HTMLElement)) continue;
            const childComp = this.createComponentFromElement(childNode, (childComp2)=>{
                const childGui = childComp2.getGui();
                if (childGui) for (const attr of childNode.attributes ?? [])childGui.setAttribute(attr.name, attr.value);
            }, paramsMap);
            if (childComp) {
                if (childComp.addItems && childNode.children.length) {
                    this.createChildComponentsFromTags(childNode, paramsMap);
                    const items = Array.prototype.slice.call(childNode.children);
                    childComp.addItems(items);
                }
                this.swapComponentForNode(childComp, parentNode, childNode);
            } else if (childNode.childNodes) this.createChildComponentsFromTags(childNode, paramsMap);
        }
    }
    createComponentFromElement(element, afterPreCreateCallback, paramsMap) {
        const key = element.nodeName;
        const elementRef = this.getDataRefAttribute(element);
        const isAgGridComponent = key.indexOf("AG-") === 0;
        const componentSelector = isAgGridComponent ? this.componentSelectors.get(key) : null;
        let newComponent = null;
        if (componentSelector) {
            const componentParams = paramsMap && elementRef ? paramsMap[elementRef] : void 0;
            newComponent = new componentSelector.component(componentParams);
            newComponent.setParentComponent(this);
            this.createBean(newComponent, null, afterPreCreateCallback);
        } else if (isAgGridComponent) throw new Error(`selector: ${key}`);
        this.applyElementsToComponent(element, elementRef, paramsMap, newComponent);
        return newComponent;
    }
    swapComponentForNode(newComponent, parentNode, childNode) {
        const eComponent = newComponent.getGui();
        parentNode.replaceChild(eComponent, childNode);
        parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
        this.addDestroyFunc(this.destroyBean.bind(this, newComponent));
    }
    activateTabIndex(elements) {
        const tabIndex = this.gos.get("tabIndex");
        if (!elements) elements = [];
        if (!elements.length) elements.push(this.getGui());
        for (const el of elements)el.setAttribute("tabindex", tabIndex.toString());
    }
    setTemplate(templateOrParams, componentSelectors, paramsMap) {
        let eGui;
        if (typeof templateOrParams === "string" || templateOrParams == null) eGui = $437b23f6a393c3bf$export$b1f57d075ca6d5fb(templateOrParams);
        else eGui = $437b23f6a393c3bf$export$378bc9c64290bc8b(templateOrParams);
        this.setTemplateFromElement(eGui, componentSelectors, paramsMap);
    }
    setTemplateFromElement(element, components, paramsMap, suppressDataRefValidation = false) {
        this.eGui = element;
        this.suppressDataRefValidation = suppressDataRefValidation;
        if (components) for(let i = 0; i < components.length; i++){
            const component = components[i];
            this.componentSelectors.set(component.selector, component);
        }
        this.wireTemplate(element, paramsMap);
    }
    getGui() {
        return this.eGui;
    }
    getFocusableElement() {
        return this.eGui;
    }
    getAriaElement() {
        return this.getFocusableElement();
    }
    setParentComponent(component) {
        this.parentComponent = component;
    }
    getParentComponent() {
        return this.parentComponent;
    }
    // this method is for older code, that wants to provide the gui element,
    // it is not intended for this to be in ag-Stack
    setGui(eGui) {
        this.eGui = eGui;
    }
    queryForHtmlElement(cssSelector) {
        return this.eGui.querySelector(cssSelector);
    }
    getContainerAndElement(newChild, container) {
        let parent = container;
        if (newChild == null) return null;
        if (!parent) parent = this.eGui;
        if ($437b23f6a393c3bf$export$6e6303ef478b0c94(newChild)) return {
            element: newChild,
            parent: parent
        };
        return {
            element: newChild.getGui(),
            parent: parent
        };
    }
    prependChild(newChild, container) {
        const { element: element, parent: parent } = this.getContainerAndElement(newChild, container) || {};
        if (!element || !parent) return;
        parent.insertAdjacentElement("afterbegin", element);
    }
    appendChild(newChild, container) {
        const { element: element, parent: parent } = this.getContainerAndElement(newChild, container) || {};
        if (!element || !parent) return;
        parent.appendChild(element);
    }
    isDisplayed() {
        return this.displayed;
    }
    setVisible(visible, options = {}) {
        if (visible !== this.visible) {
            this.visible = visible;
            const { skipAriaHidden: skipAriaHidden } = options;
            $437b23f6a393c3bf$export$a6c2c477cd60daa8(this.eGui, visible, {
                skipAriaHidden: skipAriaHidden
            });
        }
    }
    setDisplayed(displayed, options = {}) {
        if (displayed !== this.displayed) {
            this.displayed = displayed;
            const { skipAriaHidden: skipAriaHidden } = options;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eGui, displayed, {
                skipAriaHidden: skipAriaHidden
            });
            const event = {
                type: "displayChanged",
                visible: this.displayed
            };
            this.dispatchLocalEvent(event);
        }
    }
    destroy() {
        if (this.parentComponent) this.parentComponent = void 0;
        super.destroy();
    }
    addGuiEventListener(event, listener, options) {
        this.eGui.addEventListener(event, listener, options);
        this.addDestroyFunc(()=>this.eGui.removeEventListener(event, listener));
    }
    addCss(className) {
        this.cssManager.toggleCss(className, true);
    }
    removeCss(className) {
        this.cssManager.toggleCss(className, false);
    }
    toggleCss(className, addOrRemove) {
        this.cssManager.toggleCss(className, addOrRemove);
    }
    registerCSS(css) {
        this.css || (this.css = []);
        this.css.push(css);
    }
};
// packages/ag-grid-community/src/widgets/component.ts
var $437b23f6a393c3bf$export$16fa2f45be04daa8 = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
};
// packages/ag-grid-community/src/interfaces/iFilter.ts
function $437b23f6a393c3bf$var$isColumnFilterComp(filter) {
    return typeof filter === "object" && !!filter.component;
}
// packages/ag-grid-community/src/agStack/utils/promise.ts
function $437b23f6a393c3bf$export$2395b9dc826192b2(fn) {
    return typeof fn.then === "function";
}
function $437b23f6a393c3bf$var$_wrapInterval(action, timeout) {
    return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
        resolve(window.setInterval(action, timeout));
    });
}
var $437b23f6a393c3bf$export$30ec7836a4847721 = class _AgPromise {
    constructor(callback){
        this.status = 0 /* IN_PROGRESS */ ;
        this.resolution = null;
        this.waiters = [];
        callback((value)=>this.onDone(value), (params)=>this.onReject(params));
    }
    static all(promises) {
        return promises.length ? new _AgPromise((resolve)=>{
            let remainingToResolve = promises.length;
            const combinedValues = new Array(remainingToResolve);
            promises.forEach((promise, index)=>{
                promise.then((value)=>{
                    combinedValues[index] = value;
                    remainingToResolve--;
                    if (remainingToResolve === 0) resolve(combinedValues);
                });
            });
        }) : _AgPromise.resolve();
    }
    static resolve(value = null) {
        return new _AgPromise((resolve)=>resolve(value));
    }
    then(func) {
        return new _AgPromise((resolve)=>{
            if (this.status === 1 /* RESOLVED */ ) resolve(func(this.resolution));
            else this.waiters.push((value)=>resolve(func(value)));
        });
    }
    onDone(value) {
        this.status = 1 /* RESOLVED */ ;
        this.resolution = value;
        for (const waiter of this.waiters)waiter(value);
    }
    onReject(_) {}
};
// packages/ag-grid-community/src/components/framework/userComponentFactory.ts
function $437b23f6a393c3bf$var$doesImplementIComponent(candidate) {
    if (!candidate) return false;
    return candidate.prototype && "getGui" in candidate.prototype;
}
function $437b23f6a393c3bf$var$_getUserCompKeys(frameworkOverrides, defObject, type, params) {
    const { name: name } = type;
    let compName;
    let jsComp;
    let fwComp;
    let paramsFromSelector;
    let popupFromSelector;
    let popupPositionFromSelector;
    if (defObject) {
        const defObjectAny = defObject;
        const selectorFunc = defObjectAny[name + "Selector"];
        const selectorRes = selectorFunc ? selectorFunc(params) : null;
        const assignComp = (providedJsComp)=>{
            if (typeof providedJsComp === "string") compName = providedJsComp;
            else if (providedJsComp != null && providedJsComp !== true) {
                const isFwkComp = frameworkOverrides.isFrameworkComponent(providedJsComp);
                if (isFwkComp) fwComp = providedJsComp;
                else jsComp = providedJsComp;
            }
        };
        if (selectorRes) {
            assignComp(selectorRes.component);
            paramsFromSelector = selectorRes.params;
            popupFromSelector = selectorRes.popup;
            popupPositionFromSelector = selectorRes.popupPosition;
        } else assignComp(defObjectAny[name]);
    }
    return {
        compName: compName,
        jsComp: jsComp,
        fwComp: fwComp,
        paramsFromSelector: paramsFromSelector,
        popupFromSelector: popupFromSelector,
        popupPositionFromSelector: popupPositionFromSelector
    };
}
var $437b23f6a393c3bf$var$UserComponentFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "userCompFactory";
    }
    wireBeans(beans) {
        this.agCompUtils = beans.agCompUtils;
        this.registry = beans.registry;
        this.frameworkCompWrapper = beans.frameworkCompWrapper;
        this.gridOptions = beans.gridOptions;
    }
    getCompDetailsFromGridOptions(type, defaultName, params, mandatory = false) {
        return this.getCompDetails(this.gridOptions, type, defaultName, params, mandatory);
    }
    getCompDetails(defObject, type, defaultName, params, mandatory = false) {
        const { name: name, cellRenderer: cellRenderer } = type;
        let { compName: compName, jsComp: jsComp, fwComp: fwComp, paramsFromSelector: paramsFromSelector, popupFromSelector: popupFromSelector, popupPositionFromSelector: popupPositionFromSelector } = $437b23f6a393c3bf$var$_getUserCompKeys(this.beans.frameworkOverrides, defObject, type, params);
        let defaultCompParams;
        let defaultCompProcessParams;
        const lookupFromRegistry = (key)=>{
            const item = this.registry.getUserComponent(name, key);
            if (item) {
                jsComp = !item.componentFromFramework ? item.component : void 0;
                fwComp = item.componentFromFramework ? item.component : void 0;
                defaultCompParams = item.params;
                defaultCompProcessParams = item.processParams;
            }
        };
        if (compName != null) lookupFromRegistry(compName);
        if (jsComp == null && fwComp == null && defaultName != null) lookupFromRegistry(defaultName);
        if (jsComp && cellRenderer && !$437b23f6a393c3bf$var$doesImplementIComponent(jsComp)) jsComp = this.agCompUtils?.adaptFunction(type, jsComp);
        if (!jsComp && !fwComp) {
            const { validation: validation } = this.beans;
            if (mandatory && (compName !== defaultName || !defaultName)) {
                if (compName) {
                    if (!validation?.isProvidedUserComp(compName)) $437b23f6a393c3bf$export$a20c7248650823a9(50, {
                        compName: compName
                    });
                } else if (defaultName) {
                    if (!validation) $437b23f6a393c3bf$export$a20c7248650823a9(260, {
                        ...this.gos.getModuleErrorParams(),
                        propName: name,
                        compName: defaultName
                    });
                } else $437b23f6a393c3bf$export$a20c7248650823a9(216, {
                    name: name
                });
            } else if (defaultName && !validation) $437b23f6a393c3bf$export$a20c7248650823a9(146, {
                comp: defaultName
            });
            return;
        }
        const paramsMerged = this.mergeParams(defObject, type, params, paramsFromSelector, defaultCompParams, defaultCompProcessParams);
        const componentFromFramework = jsComp == null;
        const componentClass = jsComp ?? fwComp;
        return {
            componentFromFramework: componentFromFramework,
            componentClass: componentClass,
            params: paramsMerged,
            type: type,
            popupFromSelector: popupFromSelector,
            popupPositionFromSelector: popupPositionFromSelector,
            newAgStackInstance: ()=>this.newAgStackInstance(componentClass, componentFromFramework, paramsMerged, type)
        };
    }
    newAgStackInstance(ComponentClass, componentFromFramework, params, type) {
        const jsComponent = !componentFromFramework;
        let instance;
        if (jsComponent) instance = new ComponentClass();
        else instance = this.frameworkCompWrapper.wrap(ComponentClass, type.mandatoryMethods, type.optionalMethods, type);
        this.createBean(instance);
        const deferredInit = instance.init?.(params);
        if (deferredInit == null) return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(instance);
        return deferredInit.then(()=>instance);
    }
    /**
   * merges params with application provided params
   * used by Floating Filter
   */ mergeParams(defObject, type, paramsFromGrid, paramsFromSelector = null, defaultCompParams, defaultCompProcessParams) {
        const params = {
            ...paramsFromGrid,
            ...defaultCompParams
        };
        const defObjectAny = defObject;
        const userParams = defObjectAny?.[type.name + "Params"];
        if (typeof userParams === "function") {
            const userParamsFromFunc = userParams(paramsFromGrid);
            $437b23f6a393c3bf$export$8ade6bd474fcde42(params, userParamsFromFunc);
        } else if (typeof userParams === "object") $437b23f6a393c3bf$export$8ade6bd474fcde42(params, userParams);
        $437b23f6a393c3bf$export$8ade6bd474fcde42(params, paramsFromSelector);
        return defaultCompProcessParams ? defaultCompProcessParams(params) : params;
    }
};
// packages/ag-grid-community/src/components/framework/userCompUtils.ts
var $437b23f6a393c3bf$var$DateComponent = {
    name: "dateComponent",
    mandatoryMethods: [
        "getDate",
        "setDate"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "setInputPlaceholder",
        "setInputAriaLabel",
        "setDisabled",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$DragAndDropImageComponent = {
    name: "dragAndDropImageComponent",
    mandatoryMethods: [
        "setIcon",
        "setLabel"
    ]
};
var $437b23f6a393c3bf$var$HeaderComponent = {
    name: "headerComponent",
    optionalMethods: [
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$InnerHeaderComponent = {
    name: "innerHeaderComponent"
};
var $437b23f6a393c3bf$var$InnerHeaderGroupComponent = {
    name: "innerHeaderGroupComponent"
};
var $437b23f6a393c3bf$var$HeaderGroupComponent = {
    name: "headerGroupComponent"
};
var $437b23f6a393c3bf$var$InnerCellRendererComponent = {
    name: "innerRenderer",
    cellRenderer: true,
    optionalMethods: [
        "afterGuiAttached"
    ]
};
var $437b23f6a393c3bf$var$CellRendererComponent = {
    name: "cellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$EditorRendererComponent = {
    name: "cellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ]
};
var $437b23f6a393c3bf$var$LoadingCellRendererComponent = {
    name: "loadingCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$CellEditorComponent = {
    name: "cellEditor",
    mandatoryMethods: [
        "getValue"
    ],
    optionalMethods: [
        "isPopup",
        "isCancelBeforeStart",
        "isCancelAfterEnd",
        "getPopupPosition",
        "focusIn",
        "focusOut",
        "afterGuiAttached",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$LoadingOverlayComponent = {
    name: "loadingOverlayComponent",
    optionalMethods: [
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$NoRowsOverlayComponent = {
    name: "noRowsOverlayComponent",
    optionalMethods: [
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$TooltipComponent = {
    name: "tooltipComponent"
};
var $437b23f6a393c3bf$var$FilterComponent = {
    name: "filter",
    mandatoryMethods: [
        "isFilterActive",
        "doesFilterPass",
        "getModel",
        "setModel"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "afterGuiDetached",
        "onNewRowsLoaded",
        "getModelAsString",
        "onFloatingFilterChanged",
        "onAnyFilterChanged",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$FloatingFilterComponent = {
    name: "floatingFilterComponent",
    mandatoryMethods: [
        "onParentModelChanged"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$FullWidth = {
    name: "fullWidthCellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthLoading = {
    name: "loadingCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthGroup = {
    name: "groupRowRenderer",
    optionalMethods: [
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthDetail = {
    name: "detailCellRenderer",
    optionalMethods: [
        "refresh"
    ],
    cellRenderer: true
};
function $437b23f6a393c3bf$var$_getDragAndDropImageCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$DragAndDropImageComponent, "agDragAndDropImage", params, true);
}
function $437b23f6a393c3bf$export$c3f4e745c2fdf1c0(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$InnerCellRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getHeaderCompDetails(userCompFactory, colDef, params) {
    return userCompFactory.getCompDetails(colDef, $437b23f6a393c3bf$var$HeaderComponent, "agColumnHeader", params);
}
function $437b23f6a393c3bf$var$_getInnerHeaderCompDetails(userCompFactory, headerCompParams, params) {
    return userCompFactory.getCompDetails(headerCompParams, $437b23f6a393c3bf$var$InnerHeaderComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getHeaderGroupCompDetails(userCompFactory, params) {
    const colGroupDef = params.columnGroup.getColGroupDef();
    return userCompFactory.getCompDetails(colGroupDef, $437b23f6a393c3bf$var$HeaderGroupComponent, "agColumnGroupHeader", params);
}
function $437b23f6a393c3bf$var$_getInnerHeaderGroupCompDetails(userCompFactory, headerGroupCompParams, params) {
    return userCompFactory.getCompDetails(headerGroupCompParams, $437b23f6a393c3bf$var$InnerHeaderGroupComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getFullWidthCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidth, void 0, params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthLoadingCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthLoading, "agLoadingCellRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthGroupCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthGroup, "agGroupRowRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthDetailCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthDetail, "agDetailCellRenderer", params, true);
}
function $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$CellRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$export$85a10ea90cfc8a53(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$EditorRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$LoadingCellRendererComponent, "agSkeletonCellRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getCellEditorDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$CellEditorComponent, "agCellEditor", params, true);
}
function $437b23f6a393c3bf$export$e6db9a2d59456da0(userCompFactory, def, params, defaultFilter) {
    const filter = def.filter;
    if ($437b23f6a393c3bf$var$isColumnFilterComp(filter)) def = {
        filter: filter.component,
        filterParams: def.filterParams
    };
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$FilterComponent, defaultFilter, params, true);
}
function $437b23f6a393c3bf$var$_getDateCompDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$DateComponent, "agDateInput", params, true);
}
function $437b23f6a393c3bf$var$_getLoadingOverlayCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$LoadingOverlayComponent, "agLoadingOverlay", params, true);
}
function $437b23f6a393c3bf$var$_getNoRowsOverlayCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$NoRowsOverlayComponent, "agNoRowsOverlay", params, true);
}
function $437b23f6a393c3bf$var$_getTooltipCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetails(params.colDef, $437b23f6a393c3bf$var$TooltipComponent, "agTooltipComponent", params, true);
}
function $437b23f6a393c3bf$export$14d0998f093f007e(userCompFactory, def, params, defaultFloatingFilter) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$FloatingFilterComponent, defaultFloatingFilter, params);
}
function $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, def) {
    return $437b23f6a393c3bf$var$_getUserCompKeys(frameworkOverrides, def, $437b23f6a393c3bf$var$FilterComponent);
}
function $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(userCompFactory, defObject, paramsFromGrid) {
    return userCompFactory.mergeParams(defObject, $437b23f6a393c3bf$var$FilterComponent, paramsFromGrid);
}
// packages/ag-grid-community/src/components/framework/unwrapUserComp.ts
function $437b23f6a393c3bf$export$213d4c63c3df47e4(comp) {
    const compAsAny = comp;
    const isProxy = compAsAny?.getFrameworkComponentInstance != null;
    return isProxy ? compAsAny.getFrameworkComponentInstance() : comp;
}
// packages/ag-grid-community/src/context/context.ts
function $437b23f6a393c3bf$var$isComponentMetaFunc(componentMeta) {
    return typeof componentMeta === "object" && !!componentMeta.getComp;
}
// packages/ag-grid-community/src/agStack/constants/keyCode.ts
var $437b23f6a393c3bf$export$e9e0d96f49f57c33 = {
    BACKSPACE: "Backspace",
    TAB: "Tab",
    ENTER: "Enter",
    ESCAPE: "Escape",
    SPACE: " ",
    LEFT: "ArrowLeft",
    UP: "ArrowUp",
    RIGHT: "ArrowRight",
    DOWN: "ArrowDown",
    DELETE: "Delete",
    F2: "F2",
    PAGE_UP: "PageUp",
    PAGE_DOWN: "PageDown",
    PAGE_HOME: "Home",
    PAGE_END: "End",
    // these should be used with `event.code` instead of `event.key`
    // as `event.key` changes when non-latin keyboards are used
    A: "KeyA",
    C: "KeyC",
    D: "KeyD",
    V: "KeyV",
    X: "KeyX",
    Y: "KeyY",
    Z: "KeyZ"
};
// packages/ag-grid-community/src/agStack/popup/agPopupComponent.ts
var $437b23f6a393c3bf$export$acd471c9223f27ae = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
    isPopup() {
        return true;
    }
    setParentComponent(container) {
        container.addCss("ag-has-popup");
        super.setParentComponent(container);
    }
    destroy() {
        const parentComp = this.parentComponent;
        const hasParent = parentComp?.isAlive();
        if (hasParent) parentComp.getGui().classList.remove("ag-has-popup");
        super.destroy();
    }
};
// packages/ag-grid-community/src/agStack/utils/browser.ts
var $437b23f6a393c3bf$var$isSafari;
var $437b23f6a393c3bf$var$isFirefox;
var $437b23f6a393c3bf$var$isMacOs;
var $437b23f6a393c3bf$var$isIOS;
var $437b23f6a393c3bf$var$invisibleScrollbar;
var $437b23f6a393c3bf$var$browserScrollbarWidth;
var $437b23f6a393c3bf$var$maxDivHeight;
function $437b23f6a393c3bf$export$8caf403dacd36a68() {
    if ($437b23f6a393c3bf$var$isSafari === void 0) $437b23f6a393c3bf$var$isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return $437b23f6a393c3bf$var$isSafari;
}
function $437b23f6a393c3bf$export$ca98fb7c82ac5538() {
    if ($437b23f6a393c3bf$var$isFirefox === void 0) $437b23f6a393c3bf$var$isFirefox = /(firefox)/i.test(navigator.userAgent);
    return $437b23f6a393c3bf$var$isFirefox;
}
function $437b23f6a393c3bf$var$_isMacOsUserAgent() {
    if ($437b23f6a393c3bf$var$isMacOs === void 0) $437b23f6a393c3bf$var$isMacOs = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    return $437b23f6a393c3bf$var$isMacOs;
}
function $437b23f6a393c3bf$export$6b6034a68325bd8a() {
    if ($437b23f6a393c3bf$var$isIOS === void 0) $437b23f6a393c3bf$var$isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return $437b23f6a393c3bf$var$isIOS;
}
function $437b23f6a393c3bf$var$_getTabIndex(el) {
    if (!el) return null;
    const numberTabIndex = el.tabIndex;
    const tabIndex = el.getAttribute("tabIndex");
    if (numberTabIndex === -1 && (tabIndex === null || tabIndex === "" && !$437b23f6a393c3bf$export$ca98fb7c82ac5538())) return null;
    return numberTabIndex.toString();
}
function $437b23f6a393c3bf$var$_getMaxDivHeight() {
    if ($437b23f6a393c3bf$var$maxDivHeight !== void 0) return $437b23f6a393c3bf$var$maxDivHeight;
    if (!document.body) return -1;
    let res = 1e6;
    const testUpTo = $437b23f6a393c3bf$export$ca98fb7c82ac5538() ? 6e6 : 1e9;
    const div = document.createElement("div");
    document.body.appendChild(div);
    while(true){
        const test = res * 2;
        div.style.height = test + "px";
        if (test > testUpTo || div.clientHeight !== test) break;
        else res = test;
    }
    div.remove();
    $437b23f6a393c3bf$var$maxDivHeight = res;
    return res;
}
function $437b23f6a393c3bf$var$_getScrollbarWidth() {
    if ($437b23f6a393c3bf$var$browserScrollbarWidth == null) $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility();
    return $437b23f6a393c3bf$var$browserScrollbarWidth;
}
function $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility() {
    const body = document.body;
    const div = document.createElement("div");
    div.style.width = div.style.height = "100px";
    div.style.opacity = "0";
    div.style.overflow = "scroll";
    div.style.msOverflowStyle = "scrollbar";
    div.style.position = "absolute";
    body.appendChild(div);
    let width = div.offsetWidth - div.clientWidth;
    if (width === 0 && div.clientWidth === 0) width = null;
    if (div.parentNode) div.remove();
    if (width != null) {
        $437b23f6a393c3bf$var$browserScrollbarWidth = width;
        $437b23f6a393c3bf$var$invisibleScrollbar = width === 0;
    }
}
function $437b23f6a393c3bf$var$_isInvisibleScrollbar() {
    if ($437b23f6a393c3bf$var$invisibleScrollbar == null) $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility();
    return $437b23f6a393c3bf$var$invisibleScrollbar;
}
// packages/ag-grid-community/src/agStack/utils/date.ts
var $437b23f6a393c3bf$var$DATE_TIME_SEPARATOR = "T";
var $437b23f6a393c3bf$var$DATE_TIME_SEPARATOR_REGEXP = new RegExp(`[${$437b23f6a393c3bf$var$DATE_TIME_SEPARATOR} ]`);
var $437b23f6a393c3bf$var$DATE_TIME_REGEXP = new RegExp(`^\\d{4}-\\d{2}-\\d{2}(${$437b23f6a393c3bf$var$DATE_TIME_SEPARATOR}\\d{2}:\\d{2}:\\d{2}\\D?)?`);
function $437b23f6a393c3bf$var$_padStartWidthZeros(value, totalStringSize) {
    return value.toString().padStart(totalStringSize, "0");
}
function $437b23f6a393c3bf$export$3d7fedfb21962874(date, includeTime = true, separator = $437b23f6a393c3bf$var$DATE_TIME_SEPARATOR) {
    if (!date) return null;
    let serialised = [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
    ].map((part)=>$437b23f6a393c3bf$var$_padStartWidthZeros(part, 2)).join("-");
    if (includeTime) serialised += separator + [
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ].map((part)=>$437b23f6a393c3bf$var$_padStartWidthZeros(part, 2)).join(":");
    return serialised;
}
function $437b23f6a393c3bf$export$bb4eb333cc2b3e25(d, includeTime = true) {
    if (!d) return null;
    if (includeTime) return [
        String(d.getFullYear()),
        String(d.getMonth() + 1),
        $437b23f6a393c3bf$var$_padStartWidthZeros(d.getDate(), 2),
        $437b23f6a393c3bf$var$_padStartWidthZeros(d.getHours(), 2),
        `:${$437b23f6a393c3bf$var$_padStartWidthZeros(d.getMinutes(), 2)}`,
        `:${$437b23f6a393c3bf$var$_padStartWidthZeros(d.getSeconds(), 2)}`
    ];
    return [
        d.getFullYear(),
        d.getMonth() + 1,
        $437b23f6a393c3bf$var$_padStartWidthZeros(d.getDate(), 2)
    ].map(String);
}
var $437b23f6a393c3bf$var$calculateOrdinal = (value)=>{
    if (value > 3 && value < 21) return "th";
    const remainder = value % 10;
    switch(remainder){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
    }
    return "th";
};
var $437b23f6a393c3bf$export$ae5a33daf12ff29 = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $437b23f6a393c3bf$var$DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
function $437b23f6a393c3bf$var$_dateToFormattedString(date, format) {
    if (format == null) return $437b23f6a393c3bf$export$3d7fedfb21962874(date, false);
    const fullYear = $437b23f6a393c3bf$var$_padStartWidthZeros(date.getFullYear(), 4);
    const replace = {
        YYYY: ()=>fullYear.slice(fullYear.length - 4, fullYear.length),
        YY: ()=>fullYear.slice(fullYear.length - 2, fullYear.length),
        Y: ()=>`${date.getFullYear()}`,
        MMMM: ()=>$437b23f6a393c3bf$export$ae5a33daf12ff29[date.getMonth()],
        MMM: ()=>$437b23f6a393c3bf$export$ae5a33daf12ff29[date.getMonth()].slice(0, 3),
        MM: ()=>$437b23f6a393c3bf$var$_padStartWidthZeros(date.getMonth() + 1, 2),
        Mo: ()=>`${date.getMonth() + 1}${$437b23f6a393c3bf$var$calculateOrdinal(date.getMonth() + 1)}`,
        M: ()=>`${date.getMonth() + 1}`,
        Do: ()=>`${date.getDate()}${$437b23f6a393c3bf$var$calculateOrdinal(date.getDate())}`,
        DD: ()=>$437b23f6a393c3bf$var$_padStartWidthZeros(date.getDate(), 2),
        D: ()=>`${date.getDate()}`,
        dddd: ()=>$437b23f6a393c3bf$var$DAYS[date.getDay()],
        ddd: ()=>$437b23f6a393c3bf$var$DAYS[date.getDay()].slice(0, 3),
        dd: ()=>$437b23f6a393c3bf$var$DAYS[date.getDay()].slice(0, 2),
        do: ()=>`${date.getDay()}${$437b23f6a393c3bf$var$calculateOrdinal(date.getDay())}`,
        d: ()=>`${date.getDay()}`
    };
    const regexp = new RegExp(Object.keys(replace).join("|"), "g");
    return format.replace(regexp, (match)=>{
        if (match in replace) return replace[match]();
        return match;
    });
}
function $437b23f6a393c3bf$var$_isValidDate(value, bailIfInvalidTime = false) {
    return !!$437b23f6a393c3bf$export$26ded2d88c01b527(value, bailIfInvalidTime);
}
function $437b23f6a393c3bf$var$_isValidDateTime(value) {
    return $437b23f6a393c3bf$var$_isValidDate(value, true);
}
function $437b23f6a393c3bf$export$26ded2d88c01b527(value, bailIfInvalidTime = false, skipValidation) {
    if (!value) return null;
    if (!skipValidation && !$437b23f6a393c3bf$var$DATE_TIME_REGEXP.test(value)) return null;
    const [dateStr, timeStr] = value.split($437b23f6a393c3bf$var$DATE_TIME_SEPARATOR_REGEXP);
    if (!dateStr) return null;
    const fields = dateStr.split("-").map((f)=>Number.parseInt(f, 10));
    if (fields.filter((f)=>!isNaN(f)).length !== 3) return null;
    const [year, month, day] = fields;
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    if (!timeStr && bailIfInvalidTime) return null;
    if (!timeStr || timeStr === "00:00:00") return date;
    const [hours, minutes, seconds] = timeStr.split(":").map((part)=>Number.parseInt(part, 10));
    if (hours >= 0 && hours < 24) date.setHours(hours);
    else if (bailIfInvalidTime) return null;
    if (minutes >= 0 && minutes < 60) date.setMinutes(minutes);
    else if (bailIfInvalidTime) return null;
    if (seconds >= 0 && seconds < 60) date.setSeconds(seconds);
    else if (bailIfInvalidTime) return null;
    return date;
}
// packages/ag-grid-community/src/agStack/utils/fuzzyMatch.ts
function $437b23f6a393c3bf$export$85cab1b5a4aa292c(params) {
    const { inputValue: inputValue, allSuggestions: allSuggestions, hideIrrelevant: hideIrrelevant, filterByPercentageOfBestMatch: filterByPercentageOfBestMatch } = params;
    let thisSuggestions = (allSuggestions ?? []).map((text, idx)=>({
            value: text,
            relevance: $437b23f6a393c3bf$var$_getLevenshteinSimilarityDistance(inputValue, text),
            idx: idx
        }));
    thisSuggestions.sort((a, b)=>a.relevance - b.relevance);
    if (hideIrrelevant) thisSuggestions = thisSuggestions.filter((suggestion)=>suggestion.relevance < Math.max(suggestion.value.length, inputValue.length));
    if (thisSuggestions.length > 0 && filterByPercentageOfBestMatch && filterByPercentageOfBestMatch > 0) {
        const bestMatch = thisSuggestions[0].relevance;
        const limit = bestMatch * filterByPercentageOfBestMatch;
        thisSuggestions = thisSuggestions.filter((suggestion)=>limit - suggestion.relevance < 0);
    }
    const values = [];
    const indices = [];
    for (const suggestion of thisSuggestions){
        values.push(suggestion.value);
        indices.push(suggestion.idx);
    }
    return {
        values: values,
        indices: indices
    };
}
function $437b23f6a393c3bf$var$_getLevenshteinSimilarityDistance(inputText, suggestion) {
    if (inputText.length < suggestion.length) [inputText, suggestion] = [
        suggestion,
        inputText
    ];
    let previousRow = [];
    let currentRow = [];
    const sourceLength = inputText.length;
    const targetLength = suggestion.length;
    for(let j = 0; j <= targetLength; j++)previousRow[j] = j;
    let secondaryScore = 0;
    for(let i = 1; i <= sourceLength; i++){
        currentRow[0] = i;
        for(let j = 1; j <= targetLength; j++){
            const sourceChar = inputText[i - 1];
            const targetChar = suggestion[j - 1];
            if (sourceChar.toLocaleLowerCase() === targetChar.toLocaleLowerCase()) {
                ++secondaryScore;
                if (sourceChar === targetChar) ++secondaryScore;
                if (i > 1 && j > 1) {
                    if (inputText[i - 2].toLocaleLowerCase() === suggestion[j - 2].toLocaleLowerCase()) {
                        ++secondaryScore;
                        if (inputText[i - 2] === suggestion[j - 2]) ++secondaryScore;
                    }
                }
                if (i < sourceLength / 2 - 10) ++secondaryScore;
                currentRow[j] = previousRow[j - 1];
            } else {
                const insertCost = currentRow[j - 1];
                const deleteCost = previousRow[j];
                const replaceCost = previousRow[j - 1];
                currentRow[j] = 1 + Math.min(insertCost, deleteCost, replaceCost);
            }
        }
        [previousRow, currentRow] = [
            currentRow,
            previousRow
        ];
    }
    return previousRow[targetLength] / (secondaryScore + 1);
}
// packages/ag-grid-community/src/agStack/utils/keyboard.ts
function $437b23f6a393c3bf$export$33ecd6e270298858(event) {
    if (event.altKey || event.ctrlKey || event.metaKey) return false;
    const printableCharacter = event.key?.length === 1;
    return printableCharacter;
}
// packages/ag-grid-community/src/agStack/utils/focus.ts
var $437b23f6a393c3bf$var$keyboardModeActive = false;
var $437b23f6a393c3bf$var$instanceCount = 0;
function $437b23f6a393c3bf$var$addKeyboardModeEvents(doc) {
    if ($437b23f6a393c3bf$var$instanceCount > 0) return;
    doc.addEventListener("keydown", $437b23f6a393c3bf$var$toggleKeyboardMode);
    doc.addEventListener("mousedown", $437b23f6a393c3bf$var$toggleKeyboardMode);
}
function $437b23f6a393c3bf$var$removeKeyboardModeEvents(doc) {
    if ($437b23f6a393c3bf$var$instanceCount > 0) return;
    doc.removeEventListener("keydown", $437b23f6a393c3bf$var$toggleKeyboardMode);
    doc.removeEventListener("mousedown", $437b23f6a393c3bf$var$toggleKeyboardMode);
}
function $437b23f6a393c3bf$var$toggleKeyboardMode(event) {
    const isKeyboardActive = $437b23f6a393c3bf$var$keyboardModeActive;
    const isKeyboardEvent = event.type === "keydown";
    if (isKeyboardEvent) {
        if (event.ctrlKey || event.metaKey || event.altKey) return;
    }
    if (isKeyboardActive === isKeyboardEvent) return;
    $437b23f6a393c3bf$var$keyboardModeActive = isKeyboardEvent;
}
function $437b23f6a393c3bf$var$_registerKeyboardFocusEvents(beans) {
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    $437b23f6a393c3bf$var$addKeyboardModeEvents(eDocument);
    $437b23f6a393c3bf$var$instanceCount++;
    return ()=>{
        $437b23f6a393c3bf$var$instanceCount--;
        $437b23f6a393c3bf$var$removeKeyboardModeEvents(eDocument);
    };
}
function $437b23f6a393c3bf$export$e4c8c227337b7f23() {
    return $437b23f6a393c3bf$var$keyboardModeActive;
}
function $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, exclude, onlyUnmanaged = false) {
    const focusableString = $437b23f6a393c3bf$var$FOCUSABLE_SELECTOR;
    let excludeString = $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE;
    if (exclude) excludeString += ", " + exclude;
    if (onlyUnmanaged) excludeString += ', [tabindex="-1"]';
    const nodes = Array.prototype.slice.apply(rootNode.querySelectorAll(focusableString)).filter((node)=>{
        return $437b23f6a393c3bf$export$2badf4aa566524cb(node);
    });
    const excludeNodes = Array.prototype.slice.apply(rootNode.querySelectorAll(excludeString));
    if (!excludeNodes.length) return nodes;
    const diff = (a, b)=>a.filter((element)=>b.indexOf(element) === -1);
    return diff(nodes, excludeNodes);
}
function $437b23f6a393c3bf$export$8598088d375f416f(rootNode, up = false, onlyUnmanaged = false, excludeTabGuards = false) {
    const focusableElements = $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, excludeTabGuards ? ".ag-tab-guard" : null, onlyUnmanaged);
    const toFocus = up ? $437b23f6a393c3bf$export$236389741107357f(focusableElements) : focusableElements[0];
    if (toFocus) {
        toFocus.focus({
            preventScroll: true
        });
        return true;
    }
    return false;
}
function $437b23f6a393c3bf$export$83fc12531358bd28(beans, rootNode, onlyManaged, backwards) {
    const focusable = $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, onlyManaged ? ':not([tabindex="-1"])' : null);
    const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
    let currentIndex;
    if (onlyManaged) currentIndex = focusable.findIndex((el)=>el.contains(activeEl));
    else currentIndex = focusable.indexOf(activeEl);
    const nextIndex = currentIndex + (backwards ? -1 : 1);
    if (nextIndex < 0 || nextIndex >= focusable.length) return null;
    return focusable[nextIndex];
}
function $437b23f6a393c3bf$export$c4c49c776025d475(node, limit = 5) {
    let counter = 0;
    while(node && $437b23f6a393c3bf$var$_getTabIndex(node) === null && ++counter <= limit)node = node.parentElement;
    if ($437b23f6a393c3bf$var$_getTabIndex(node) === null) return null;
    return node;
}
// packages/ag-grid-community/src/agStack/widgets/agAbstractLabel.css-GENERATED.ts
var $437b23f6a393c3bf$var$agAbstractLabelCSS = /*css*/ `.ag-label{white-space:nowrap}:where(.ag-ltr) .ag-label{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-label-align-right) .ag-label{order:1}:where(.ag-ltr) :where(.ag-label-align-right) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) :where(.ag-label-align-right) .ag-label{margin-right:var(--ag-spacing)}.ag-label-align-right>*{flex:none}.ag-label-align-top{align-items:flex-start;flex-direction:column;>*{align-self:stretch}}.ag-label-ellipsis{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-label-align-top) .ag-label{margin-bottom:calc(var(--ag-spacing)*.5)}`;
// packages/ag-grid-community/src/agStack/widgets/agAbstractLabel.ts
var $437b23f6a393c3bf$export$d72ea6e1c340e03b = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
    constructor(config, template, components){
        super(template, components);
        this.labelSeparator = "";
        this.labelAlignment = "left";
        this.disabled = false;
        this.label = "";
        this.config = config || {};
        this.registerCSS($437b23f6a393c3bf$var$agAbstractLabelCSS);
    }
    postConstruct() {
        this.addCss("ag-labeled");
        this.eLabel.classList.add("ag-label");
        const { labelSeparator: labelSeparator, label: label, labelWidth: labelWidth, labelAlignment: labelAlignment, disabled: disabled } = this.config;
        if (disabled != null) this.setDisabled(disabled);
        if (labelSeparator != null) this.setLabelSeparator(labelSeparator);
        if (label != null) this.setLabel(label);
        if (labelWidth != null) this.setLabelWidth(labelWidth);
        this.setLabelAlignment(labelAlignment || this.labelAlignment);
        this.refreshLabel();
    }
    refreshLabel() {
        const { label: label, eLabel: eLabel } = this;
        $437b23f6a393c3bf$export$69e6e10709eabd91(eLabel);
        if (typeof label === "string") eLabel.innerText = label + this.labelSeparator;
        else if (label) eLabel.appendChild(label);
        if (label === "") {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eLabel, false);
            $437b23f6a393c3bf$export$f8d01fa01787902(eLabel, "presentation");
        } else {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eLabel, true);
            $437b23f6a393c3bf$export$f8d01fa01787902(eLabel, null);
        }
    }
    setLabelSeparator(labelSeparator) {
        if (this.labelSeparator === labelSeparator) return this;
        this.labelSeparator = labelSeparator;
        if (this.label != null) this.refreshLabel();
        return this;
    }
    getLabelId() {
        const eLabel = this.eLabel;
        eLabel.id = eLabel.id || `ag-${this.getCompId()}-label`;
        return eLabel.id;
    }
    getLabel() {
        return this.label;
    }
    setLabel(label) {
        if (this.label === label) return this;
        this.label = label;
        this.refreshLabel();
        return this;
    }
    setLabelAlignment(alignment) {
        const eGui = this.getGui();
        const eGuiClassList = eGui.classList;
        eGuiClassList.toggle("ag-label-align-left", alignment === "left");
        eGuiClassList.toggle("ag-label-align-right", alignment === "right");
        eGuiClassList.toggle("ag-label-align-top", alignment === "top");
        return this;
    }
    setLabelEllipsis(hasEllipsis) {
        this.eLabel.classList.toggle("ag-label-ellipsis", hasEllipsis);
        return this;
    }
    setLabelWidth(width) {
        if (this.label == null) return this;
        $437b23f6a393c3bf$var$_setElementWidth(this.eLabel, width);
        return this;
    }
    setDisabled(disabled) {
        disabled = !!disabled;
        const element = this.getGui();
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element, disabled);
        element.classList.toggle("ag-disabled", disabled);
        this.disabled = disabled;
        return this;
    }
    isDisabled() {
        return !!this.disabled;
    }
};
// packages/ag-grid-community/src/agStack/widgets/agAbstractField.ts
var $437b23f6a393c3bf$var$AgAbstractField = class extends $437b23f6a393c3bf$export$d72ea6e1c340e03b {
    constructor(config, template, components, className){
        super(config, template, components);
        this.className = className;
    }
    postConstruct() {
        super.postConstruct();
        const { width: width, value: value, onValueChange: onValueChange } = this.config;
        if (width != null) this.setWidth(width);
        if (value != null) this.setValue(value);
        if (onValueChange != null) this.onValueChange(onValueChange);
        if (this.className) this.addCss(this.className);
        this.refreshAriaLabelledBy();
    }
    setLabel(label) {
        super.setLabel(label);
        this.refreshAriaLabelledBy();
        return this;
    }
    refreshAriaLabelledBy() {
        const ariaEl = this.getAriaElement();
        const labelId = this.getLabelId();
        const label = this.getLabel();
        if (label == null || label == "" || $437b23f6a393c3bf$var$_getAriaLabel(ariaEl) !== null) $437b23f6a393c3bf$export$84233c40c4c74001(ariaEl, "");
        else $437b23f6a393c3bf$export$84233c40c4c74001(ariaEl, labelId ?? "");
    }
    setAriaLabel(label) {
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.getAriaElement(), label);
        this.refreshAriaLabelledBy();
        return this;
    }
    onValueChange(callbackFn) {
        this.addManagedListeners(this, {
            fieldValueChanged: ()=>callbackFn(this.getValue())
        });
        return this;
    }
    getWidth() {
        return this.getGui().clientWidth;
    }
    setWidth(width) {
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.getGui(), width);
        return this;
    }
    getPreviousValue() {
        return this.previousValue;
    }
    getValue() {
        return this.value;
    }
    setValue(value, silent) {
        if (this.value === value) return this;
        this.previousValue = this.value;
        this.value = value;
        if (!silent) this.dispatchLocalEvent({
            type: "fieldValueChanged"
        });
        return this;
    }
};
// packages/ag-grid-community/src/agStack/widgets/agAbstractInputField.ts
function $437b23f6a393c3bf$var$buildTemplate(displayFieldTag) {
    return {
        tag: "div",
        role: "presentation",
        children: [
            {
                tag: "div",
                ref: "eLabel",
                cls: "ag-input-field-label"
            },
            {
                tag: "div",
                ref: "eWrapper",
                cls: "ag-wrapper ag-input-wrapper",
                role: "presentation",
                children: [
                    {
                        tag: displayFieldTag,
                        ref: "eInput",
                        cls: "ag-input-field-input"
                    }
                ]
            }
        ]
    };
}
var $437b23f6a393c3bf$export$9671f513d4aa42e3 = class extends $437b23f6a393c3bf$var$AgAbstractField {
    constructor(config, className, inputType = "text", displayFieldTag = "input"){
        super(config, config?.template ?? $437b23f6a393c3bf$var$buildTemplate(displayFieldTag), [], className);
        this.inputType = inputType;
        this.displayFieldTag = displayFieldTag;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eInput = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        super.postConstruct();
        this.setInputType(this.inputType);
        const { eLabel: eLabel, eWrapper: eWrapper, eInput: eInput, className: className } = this;
        eLabel.classList.add(`${className}-label`);
        eWrapper.classList.add(`${className}-input-wrapper`);
        eInput.classList.add(`${className}-input`);
        this.addCss("ag-input-field");
        eInput.id = eInput.id || `ag-${this.getCompId()}-input`;
        const { inputName: inputName, inputWidth: inputWidth } = this.config;
        if (inputName != null) this.setInputName(inputName);
        if (inputWidth != null) this.setInputWidth(inputWidth);
        this.addInputListeners();
        this.activateTabIndex([
            eInput
        ]);
    }
    addInputListeners() {
        this.addManagedElementListeners(this.eInput, {
            input: (e)=>this.setValue(e.target.value)
        });
    }
    setInputType(inputType) {
        if (this.displayFieldTag === "input") {
            this.inputType = inputType;
            $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "type", inputType);
        }
    }
    getInputElement() {
        return this.eInput;
    }
    setInputWidth(width) {
        $437b23f6a393c3bf$var$_setElementWidth(this.eWrapper, width);
        return this;
    }
    setInputName(name) {
        this.getInputElement().setAttribute("name", name);
        return this;
    }
    getFocusableElement() {
        return this.eInput;
    }
    setMaxLength(length) {
        const eInput = this.eInput;
        eInput.maxLength = length;
        return this;
    }
    setInputPlaceholder(placeholder) {
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "placeholder", placeholder);
        return this;
    }
    setInputAriaLabel(label) {
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.eInput, label);
        this.refreshAriaLabelledBy();
        return this;
    }
    setDisabled(disabled) {
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(this.eInput, disabled);
        return super.setDisabled(disabled);
    }
    setAutoComplete(value) {
        if (value === true) $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "autocomplete", null);
        else {
            const autoCompleteValue = typeof value === "string" ? value : "off";
            $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "autocomplete", autoCompleteValue);
        }
        return this;
    }
};
// packages/ag-grid-community/src/agStack/widgets/agCheckbox.ts
var $437b23f6a393c3bf$export$b00c508c1ae18d07 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config, className = "ag-checkbox", inputType = "checkbox"){
        super(config, className, inputType);
        this.labelAlignment = "right";
        this.selected = false;
        this.readOnly = false;
        this.passive = false;
    }
    postConstruct() {
        super.postConstruct();
        const { readOnly: readOnly, passive: passive } = this.config;
        if (typeof readOnly === "boolean") this.setReadOnly(readOnly);
        if (typeof passive === "boolean") this.setPassive(passive);
    }
    addInputListeners() {
        this.addManagedElementListeners(this.eInput, {
            click: this.onCheckboxClick.bind(this)
        });
        this.addManagedElementListeners(this.eLabel, {
            click: this.toggle.bind(this)
        });
    }
    getNextValue() {
        return this.selected === void 0 ? true : !this.selected;
    }
    setPassive(passive) {
        this.passive = passive;
    }
    isReadOnly() {
        return this.readOnly;
    }
    setReadOnly(readOnly) {
        this.eWrapper.classList.toggle("ag-disabled", readOnly);
        this.eInput.disabled = readOnly;
        this.readOnly = readOnly;
    }
    setDisabled(disabled) {
        this.eWrapper.classList.toggle("ag-disabled", disabled);
        return super.setDisabled(disabled);
    }
    toggle() {
        if (this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const nextValue = this.getNextValue();
        if (this.passive) this.dispatchChange(nextValue, previousValue);
        else this.setValue(nextValue);
    }
    getValue() {
        return this.isSelected();
    }
    setValue(value, silent) {
        this.refreshSelectedClass(value);
        this.setSelected(value, silent);
        return this;
    }
    setName(name) {
        const input = this.getInputElement();
        input.name = name;
        return this;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected, silent) {
        if (this.isSelected() === selected) return;
        this.previousValue = this.isSelected();
        selected = this.selected = typeof selected === "boolean" ? selected : void 0;
        const eInput = this.eInput;
        eInput.checked = selected;
        eInput.indeterminate = selected === void 0;
        if (!silent) this.dispatchChange(this.selected, this.previousValue);
    }
    dispatchChange(selected, previousValue, event) {
        this.dispatchLocalEvent({
            type: "fieldValueChanged",
            selected: selected,
            previousValue: previousValue,
            event: event
        });
        const input = this.getInputElement();
        this.eventSvc.dispatchEvent({
            type: "checkboxChanged",
            id: input.id,
            name: input.name,
            selected: selected,
            previousValue: previousValue
        });
    }
    onCheckboxClick(e) {
        if (this.passive || this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const selected = this.selected = e.target.checked;
        this.refreshSelectedClass(selected);
        this.dispatchChange(selected, previousValue, e);
    }
    refreshSelectedClass(value) {
        const classList = this.eWrapper.classList;
        classList.toggle("ag-checked", value === true);
        classList.toggle("ag-indeterminate", value == null);
    }
};
var $437b23f6a393c3bf$export$2e2c317d2e31f2ca = {
    selector: "AG-CHECKBOX",
    component: $437b23f6a393c3bf$export$b00c508c1ae18d07
};
// packages/ag-grid-community/src/agStack/widgets/agRadioButton.ts
var $437b23f6a393c3bf$export$5caa9ea96bbb722 = class extends $437b23f6a393c3bf$export$b00c508c1ae18d07 {
    constructor(config){
        super(config, "ag-radio-button", "radio");
    }
    isSelected() {
        return this.eInput.checked;
    }
    toggle() {
        if (this.eInput.disabled) return;
        if (!this.isSelected()) this.setValue(true);
    }
    addInputListeners() {
        super.addInputListeners();
        this.addManagedEventListeners({
            checkboxChanged: this.onChange.bind(this)
        });
    }
    /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */ onChange(event) {
        const eInput = this.eInput;
        if (event.selected && event.name && eInput.name && eInput.name === event.name && event.id && eInput.id !== event.id) this.setValue(false, true);
    }
};
// packages/ag-grid-community/src/agStack/widgets/agToggleButton.css-GENERATED.ts
var $437b23f6a393c3bf$var$agToggleButtonCSS = /*css*/ `.ag-toggle-button{flex:none;min-width:unset;width:unset}.ag-toggle-button-input-wrapper{background-color:var(--ag-toggle-button-off-background-color);border-radius:calc(var(--ag-toggle-button-height)*.5);flex:none;height:var(--ag-toggle-button-height);max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);position:relative;transition:background-color .1s;:where(.ag-toggle-button-input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-toggle-button-height);margin:0;max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);opacity:0}&:before{background-color:var(--ag-toggle-button-switch-background-color);border-radius:100%;content:"";display:block;height:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2);left:var(--ag-toggle-button-switch-inset);pointer-events:none;position:absolute;top:var(--ag-toggle-button-switch-inset);transition:left .1s;width:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2)}&.ag-checked{background-color:var(--ag-toggle-button-on-background-color);&:before{left:calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-switch-inset))}}&:focus-within{box-shadow:var(--ag-focus-shadow)}&.ag-disabled{opacity:.5}}`;
// packages/ag-grid-community/src/agStack/widgets/agToggleButton.ts
var $437b23f6a393c3bf$export$167b21bf245ce0bf = class extends $437b23f6a393c3bf$export$b00c508c1ae18d07 {
    constructor(config){
        super(config, "ag-toggle-button");
        this.registerCSS($437b23f6a393c3bf$var$agToggleButtonCSS);
    }
    setValue(value, silent) {
        super.setValue(value, silent);
        this.toggleCss("ag-selected", this.getValue());
        return this;
    }
};
var $437b23f6a393c3bf$export$b825a5135f318030 = {
    selector: "AG-TOGGLE-BUTTON",
    component: $437b23f6a393c3bf$export$167b21bf245ce0bf
};
// packages/ag-grid-community/src/agStack/widgets/agInputTextField.ts
var $437b23f6a393c3bf$export$8c027679838afd47 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config, className = "ag-text-field", inputType = "text"){
        super(config, className, inputType);
    }
    postConstruct() {
        super.postConstruct();
        if (this.config.allowedCharPattern) this.preventDisallowedCharacters();
    }
    setValue(value, silent) {
        const eInput = this.eInput;
        if (eInput.value !== value) eInput.value = $437b23f6a393c3bf$export$25d27f17d3af40f7(value) ? value : "";
        return super.setValue(value, silent);
    }
    /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */ setStartValue(value) {
        this.setValue(value, true);
    }
    preventDisallowedCharacters() {
        const pattern = new RegExp(`[${this.config.allowedCharPattern}]`);
        const preventCharacters = (event)=>{
            if (!$437b23f6a393c3bf$export$33ecd6e270298858(event)) return;
            if (event.key && !pattern.test(event.key)) event.preventDefault();
        };
        this.addManagedListeners(this.eInput, {
            keydown: preventCharacters,
            paste: (e)=>{
                const text = e.clipboardData?.getData("text");
                if (text?.split("").some((c)=>!pattern.test(c))) e.preventDefault();
            }
        });
    }
};
var $437b23f6a393c3bf$export$31e2985be4ee06ab = {
    selector: "AG-INPUT-TEXT-FIELD",
    component: $437b23f6a393c3bf$export$8c027679838afd47
};
// packages/ag-grid-community/src/agStack/widgets/agInputTextArea.ts
var $437b23f6a393c3bf$export$fd677433260ffbc8 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config){
        super(config, "ag-text-area", null, "textarea");
    }
    setValue(value, silent) {
        const ret = super.setValue(value, silent);
        this.eInput.value = value;
        return ret;
    }
    setCols(cols) {
        this.eInput.cols = cols;
        return this;
    }
    setRows(rows) {
        this.eInput.rows = rows;
        return this;
    }
};
var $437b23f6a393c3bf$var$AgInputTextAreaSelector = {
    selector: "AG-INPUT-TEXT-AREA",
    component: $437b23f6a393c3bf$export$fd677433260ffbc8
};
// packages/ag-grid-community/src/agStack/widgets/agInputNumberField.ts
var $437b23f6a393c3bf$export$c8aa0be99738aee = class extends $437b23f6a393c3bf$export$8c027679838afd47 {
    constructor(config){
        super(config, "ag-number-field", "number");
    }
    postConstruct() {
        super.postConstruct();
        const eInput = this.eInput;
        this.addManagedListeners(eInput, {
            blur: ()=>{
                const floatedValue = Number.parseFloat(eInput.value);
                const value = isNaN(floatedValue) ? "" : this.normalizeValue(floatedValue.toString());
                if (this.value !== value) this.setValue(value);
            },
            wheel: this.onWheel.bind(this)
        });
        eInput.step = "any";
        const { precision: precision, min: min, max: max, step: step } = this.config;
        if (typeof precision === "number") this.setPrecision(precision);
        if (typeof min === "number") this.setMin(min);
        if (typeof max === "number") this.setMax(max);
        if (typeof step === "number") this.setStep(step);
    }
    onWheel(e) {
        if ($437b23f6a393c3bf$export$16bc98d422315038(this.beans) === this.eInput) e.preventDefault();
    }
    normalizeValue(value) {
        if (value === "") return "";
        if (this.precision != null) value = this.adjustPrecision(value);
        return value;
    }
    adjustPrecision(value, isScientificNotation) {
        const precision = this.precision;
        if (precision == null) return value;
        if (isScientificNotation) {
            const floatString = Number.parseFloat(value).toFixed(precision);
            return Number.parseFloat(floatString).toString();
        }
        const parts = String(value).split(".");
        if (parts.length > 1) {
            if (parts[1].length <= precision) return value;
            else if (precision > 0) return `${parts[0]}.${parts[1].slice(0, precision)}`;
        }
        return parts[0];
    }
    setMin(min) {
        if (this.min === min) return this;
        this.min = min;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(max) {
        if (this.max === max) return this;
        this.max = max;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setPrecision(precision) {
        this.precision = precision;
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    setValue(value, silent) {
        return this.setValueOrInputValue((v)=>super.setValue(v, silent), ()=>this, value);
    }
    setStartValue(value) {
        return this.setValueOrInputValue((v)=>super.setValue(v, true), (v)=>{
            this.eInput.value = v;
        }, value);
    }
    setValueOrInputValue(setValueFunc, setInputValueOnlyFunc, value) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) {
            let setInputValueOnly = this.isScientificNotation(value);
            if (setInputValueOnly && this.eInput.validity.valid) return setValueFunc(value);
            if (!setInputValueOnly) {
                value = this.adjustPrecision(value);
                const normalizedValue = this.normalizeValue(value);
                setInputValueOnly = value != normalizedValue;
            }
            if (setInputValueOnly) return setInputValueOnlyFunc(value);
        }
        return setValueFunc(value);
    }
    getValue() {
        const eInput = this.eInput;
        if (!eInput.validity.valid) return void 0;
        const inputValue = eInput.value;
        if (this.isScientificNotation(inputValue)) return this.adjustPrecision(inputValue, true);
        return super.getValue();
    }
    isScientificNotation(value) {
        return typeof value === "string" && value.includes("e");
    }
};
var $437b23f6a393c3bf$export$c18153c9c909b7d7 = {
    selector: "AG-INPUT-NUMBER-FIELD",
    component: $437b23f6a393c3bf$export$c8aa0be99738aee
};
// packages/ag-grid-community/src/agStack/widgets/agInputDateField.ts
var $437b23f6a393c3bf$export$9e01ec8ba43de612 = class extends $437b23f6a393c3bf$export$8c027679838afd47 {
    constructor(config){
        super(config, "ag-date-field", "date");
    }
    postConstruct() {
        super.postConstruct();
        const usingSafari = $437b23f6a393c3bf$export$8caf403dacd36a68();
        this.addManagedListeners(this.eInput, {
            wheel: this.onWheel.bind(this),
            mousedown: ()=>{
                if (this.isDisabled() || usingSafari) return;
                this.eInput.focus();
            }
        });
        this.eInput.step = "any";
    }
    onWheel(e) {
        if ($437b23f6a393c3bf$export$16bc98d422315038(this.beans) === this.eInput) e.preventDefault();
    }
    setMin(minDate) {
        const min = minDate instanceof Date ? $437b23f6a393c3bf$export$3d7fedfb21962874(minDate ?? null, !!this.includeTime) ?? void 0 : minDate;
        if (this.min === min) return this;
        this.min = min;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(maxDate) {
        const max = maxDate instanceof Date ? $437b23f6a393c3bf$export$3d7fedfb21962874(maxDate ?? null, !!this.includeTime) ?? void 0 : maxDate;
        if (this.max === max) return this;
        this.max = max;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    setIncludeTime(includeTime) {
        if (this.includeTime === includeTime) return this;
        this.includeTime = includeTime;
        super.setInputType(includeTime ? "datetime-local" : "date");
        if (includeTime) this.setStep(1);
        return this;
    }
    getDate() {
        if (!this.eInput.validity.valid) return void 0;
        return $437b23f6a393c3bf$export$26ded2d88c01b527(this.getValue()) ?? void 0;
    }
    setDate(date, silent) {
        this.setValue($437b23f6a393c3bf$export$3d7fedfb21962874(date ?? null, this.includeTime), silent);
    }
};
var $437b23f6a393c3bf$var$AgInputDateFieldSelector = {
    selector: "AG-INPUT-DATE-FIELD",
    component: $437b23f6a393c3bf$export$9e01ec8ba43de612
};
// packages/ag-grid-community/src/agStack/widgets/agList.css-GENERATED.ts
var $437b23f6a393c3bf$var$agListCSS = /*css*/ `.ag-list-item{align-items:center;display:flex;height:var(--ag-list-item-height);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;&.ag-active-item{background-color:var(--ag-row-hover-color)}}`;
// packages/ag-grid-community/src/agStack/widgets/agListItem.ts
var $437b23f6a393c3bf$var$ACTIVE_CLASS = "ag-active-item";
var $437b23f6a393c3bf$var$getAgListElement = (cssIdentifier, label)=>({
        tag: "div",
        cls: `ag-list-item ag-${cssIdentifier}-list-item`,
        attrs: {
            role: "option"
        },
        children: [
            {
                tag: "span",
                ref: "eText",
                children: label
            }
        ]
    });
var $437b23f6a393c3bf$var$AgListItem = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
    constructor(cssIdentifier, label, value){
        super($437b23f6a393c3bf$var$getAgListElement(cssIdentifier, label));
        this.label = label;
        this.value = value;
        this.eText = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        this.createTooltip();
        this.addEventListeners();
    }
    setHighlighted(highlighted) {
        const eGui = this.getGui();
        eGui.classList.toggle($437b23f6a393c3bf$var$ACTIVE_CLASS, highlighted);
        $437b23f6a393c3bf$export$c22e3722e8a33469(eGui, highlighted);
        this.dispatchLocalEvent({
            type: "itemHighlighted",
            highlighted: highlighted
        });
    }
    getHeight() {
        return this.getGui().clientHeight;
    }
    setIndex(idx, setSize) {
        const eGui = this.getGui();
        $437b23f6a393c3bf$export$c3d3aede41065a84(eGui, idx);
        $437b23f6a393c3bf$export$3d494c2007bbcac1(eGui, setSize);
    }
    createTooltip() {
        const tooltipCtrl = {
            getTooltipValue: ()=>this.label,
            getGui: ()=>this.getGui(),
            getLocation: ()=>"UNKNOWN",
            // only show tooltips for items where the text cannot be fully displayed
            shouldDisplayTooltip: ()=>$437b23f6a393c3bf$var$_isHorizontalScrollShowing(this.eText)
        };
        const tooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("highlightTooltipFeature", false, tooltipCtrl, this));
        if (tooltipFeature) this.tooltipFeature = tooltipFeature;
    }
    addEventListeners() {
        const parentComponent = this.getParentComponent();
        if (!parentComponent) return;
        this.addGuiEventListener("mouseover", ()=>{
            parentComponent.highlightItem(this);
        });
        this.addGuiEventListener("mousedown", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            parentComponent.setValue(this.value);
        });
    }
};
// packages/ag-grid-community/src/agStack/widgets/agList.ts
var $437b23f6a393c3bf$var$AgList = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
    constructor(cssIdentifier = "default"){
        super({
            tag: "div",
            cls: `ag-list ag-${cssIdentifier}-list`
        });
        this.cssIdentifier = cssIdentifier;
        this.options = [];
        this.listItems = [];
        this.highlightedItem = null;
        this.registerCSS($437b23f6a393c3bf$var$agListCSS);
    }
    postConstruct() {
        const eGui = this.getGui();
        this.addManagedElementListeners(eGui, {
            mouseleave: ()=>this.clearHighlighted()
        });
    }
    handleKeyDown(e) {
        const key = e.key;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                if (!this.highlightedItem) this.setValue(this.getValue());
                else {
                    const pos = this.listItems.indexOf(this.highlightedItem);
                    this.setValueByIndex(pos);
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                e.preventDefault();
                this.navigate(key);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                e.preventDefault();
                this.navigateToPage(key);
                break;
        }
    }
    addOptions(listOptions) {
        for (const listOption of listOptions)this.addOption(listOption);
        return this;
    }
    addOption(listOption) {
        const { value: value, text: text } = listOption;
        const valueToRender = text ?? value;
        this.options.push({
            value: value,
            text: valueToRender
        });
        this.renderOption(value, valueToRender);
        this.updateIndices();
        return this;
    }
    clearOptions() {
        this.options = [];
        this.reset(true);
        for (const item of this.listItems)item.destroy();
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.getGui());
        this.listItems = [];
        this.refreshAriaRole();
    }
    setValue(value, silent) {
        if (this.value === value) {
            this.fireItemSelected();
            return this;
        }
        if (value == null) {
            this.reset(silent);
            return this;
        }
        const idx = this.options.findIndex((option)=>option.value === value);
        if (idx !== -1) {
            const option = this.options[idx];
            this.value = option.value;
            this.displayValue = option.text;
            this.highlightItem(this.listItems[idx]);
            if (!silent) this.fireChangeEvent();
        }
        return this;
    }
    setValueByIndex(idx) {
        return this.setValue(this.options[idx].value);
    }
    getValue() {
        return this.value;
    }
    getDisplayValue() {
        return this.displayValue;
    }
    refreshHighlighted() {
        this.clearHighlighted();
        const idx = this.options.findIndex((option)=>option.value === this.value);
        if (idx !== -1) this.highlightItem(this.listItems[idx]);
    }
    highlightItem(item) {
        const itemEl = item.getGui();
        if (!$437b23f6a393c3bf$export$2badf4aa566524cb(itemEl)) return;
        this.clearHighlighted();
        item.setHighlighted(true);
        this.highlightedItem = item;
        const eGui = this.getGui();
        const { scrollTop: scrollTop, clientHeight: clientHeight } = eGui;
        const { offsetTop: offsetTop, offsetHeight: offsetHeight } = itemEl;
        if (offsetTop + offsetHeight > scrollTop + clientHeight || offsetTop < scrollTop) itemEl.scrollIntoView({
            block: "nearest"
        });
    }
    hideItemTooltip() {
        this.highlightedItem?.tooltipFeature?.attemptToHideTooltip();
    }
    destroy() {
        this.hideItemTooltip();
        super.destroy();
    }
    reset(silent) {
        this.value = null;
        this.displayValue = null;
        this.clearHighlighted();
        if (!silent) this.fireChangeEvent();
    }
    clearHighlighted() {
        this.highlightedItem?.setHighlighted(false);
        this.highlightedItem = null;
    }
    renderOption(value, text) {
        const item = new $437b23f6a393c3bf$var$AgListItem(this.cssIdentifier, text, value);
        item.setParentComponent(this);
        const listItem = this.createManagedBean(item);
        this.listItems.push(listItem);
        this.getGui().appendChild(listItem.getGui());
    }
    navigate(key) {
        const isDown = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        let itemToHighlight;
        const { listItems: listItems, highlightedItem: highlightedItem } = this;
        if (!highlightedItem) itemToHighlight = isDown ? listItems[0] : $437b23f6a393c3bf$export$236389741107357f(listItems);
        else {
            const currentIdx = listItems.indexOf(highlightedItem);
            let nextPos = currentIdx + (isDown ? 1 : -1);
            nextPos = Math.min(Math.max(nextPos, 0), listItems.length - 1);
            itemToHighlight = listItems[nextPos];
        }
        this.highlightItem(itemToHighlight);
    }
    navigateToPage(key) {
        const { listItems: listItems, highlightedItem: highlightedItem } = this;
        if (!highlightedItem || listItems.length === 0) return;
        const currentIdx = listItems.indexOf(highlightedItem);
        const rowCount = this.options.length - 1;
        const itemHeight = listItems[0].getHeight();
        const pageSize = Math.floor(this.getGui().clientHeight / itemHeight);
        let newIndex = -1;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME) newIndex = 0;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END) newIndex = rowCount;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) newIndex = Math.min(currentIdx + pageSize, rowCount);
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) newIndex = Math.max(currentIdx - pageSize, 0);
        if (newIndex === -1) return;
        this.highlightItem(listItems[newIndex]);
    }
    refreshAriaRole() {
        $437b23f6a393c3bf$export$f8d01fa01787902(this.getGui(), this.options.length === 0 ? "presentation" : "listbox");
    }
    updateIndices() {
        this.refreshAriaRole();
        const listItems = this.listItems;
        const len = listItems.length;
        listItems.forEach((item, idx)=>{
            item.setIndex(idx + 1, len);
        });
    }
    fireChangeEvent() {
        this.dispatchLocalEvent({
            type: "fieldValueChanged"
        });
        this.fireItemSelected();
    }
    fireItemSelected() {
        this.dispatchLocalEvent({
            type: "selectedItem"
        });
    }
};
// packages/ag-grid-community/src/agStack/widgets/agPickerField.css-GENERATED.ts
var $437b23f6a393c3bf$var$agPickerFieldCSS = /*css*/ `.ag-picker-field-display{flex:1 1 auto}.ag-picker-field{align-items:center;display:flex}.ag-picker-field-icon{border:0;cursor:pointer;display:flex;margin:0;padding:0}.ag-picker-field-wrapper{background-color:var(--ag-picker-button-background-color);border:var(--ag-picker-button-border);border-radius:5px;min-height:max(var(--ag-list-item-height),calc(var(--ag-spacing)*4));overflow:hidden;&:where(.ag-picker-has-focus),&:where(:focus-within){background-color:var(--ag-picker-button-focus-background-color);border:var(--ag-picker-button-focus-border);box-shadow:var(--ag-focus-shadow);&:where(.invalid){box-shadow:var(--ag-focus-error-shadow)}}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:disabled{opacity:.5}}`;
// packages/ag-grid-community/src/agStack/widgets/agPickerField.ts
var $437b23f6a393c3bf$var$AgPickerFieldElement = {
    tag: "div",
    cls: "ag-picker-field",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-picker-field-wrapper ag-picker-collapsed",
            children: [
                {
                    tag: "div",
                    ref: "eDisplayField",
                    cls: "ag-picker-field-display"
                },
                {
                    tag: "div",
                    ref: "eIcon",
                    cls: "ag-picker-field-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$export$1f14489b6fdeb99b = class extends $437b23f6a393c3bf$var$AgAbstractField {
    constructor(config){
        super(config, config?.template || $437b23f6a393c3bf$var$AgPickerFieldElement, config?.agComponents || [], config?.className);
        this.isPickerDisplayed = false;
        this.skipClick = false;
        this.pickerGap = 4;
        this.hideCurrentPicker = null;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDisplayField = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eIcon = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$agPickerFieldCSS);
        this.ariaRole = config?.ariaRole;
        this.onPickerFocusIn = this.onPickerFocusIn.bind(this);
        this.onPickerFocusOut = this.onPickerFocusOut.bind(this);
        if (!config) return;
        const { pickerGap: pickerGap, maxPickerHeight: maxPickerHeight, variableWidth: variableWidth, minPickerWidth: minPickerWidth, maxPickerWidth: maxPickerWidth } = config;
        if (pickerGap != null) this.pickerGap = pickerGap;
        this.variableWidth = !!variableWidth;
        if (maxPickerHeight != null) this.setPickerMaxHeight(maxPickerHeight);
        if (minPickerWidth != null) this.setPickerMinWidth(minPickerWidth);
        if (maxPickerWidth != null) this.setPickerMaxWidth(maxPickerWidth);
    }
    postConstruct() {
        super.postConstruct();
        this.setupAria();
        const displayId = `ag-${this.getCompId()}-display`;
        this.eDisplayField.setAttribute("id", displayId);
        const ariaEl = this.getAriaElement();
        this.addManagedElementListeners(ariaEl, {
            keydown: this.onKeyDown.bind(this)
        });
        this.addManagedElementListeners(this.eLabel, {
            mousedown: this.onLabelOrWrapperMouseDown.bind(this)
        });
        this.addManagedElementListeners(this.eWrapper, {
            mousedown: this.onLabelOrWrapperMouseDown.bind(this)
        });
        const { pickerIcon: pickerIcon, inputWidth: inputWidth } = this.config;
        if (pickerIcon) {
            const icon = this.beans.iconSvc.createIconNoSpan(pickerIcon);
            if (icon) this.eIcon.appendChild(icon);
        }
        if (inputWidth != null) this.setInputWidth(inputWidth);
    }
    setupAria() {
        const ariaEl = this.getAriaElement();
        ariaEl.setAttribute("tabindex", this.gos.get("tabIndex").toString());
        $437b23f6a393c3bf$export$3ad3518dddf15485(ariaEl, false);
        if (this.ariaRole) $437b23f6a393c3bf$export$f8d01fa01787902(ariaEl, this.ariaRole);
    }
    onLabelOrWrapperMouseDown(e) {
        if (e) {
            const focusableEl = this.getFocusableElement();
            if (focusableEl !== this.eWrapper && e?.target === focusableEl) return;
            e.preventDefault();
            this.getFocusableElement().focus();
        }
        if (this.skipClick) {
            this.skipClick = false;
            return;
        }
        if (this.isDisabled()) return;
        if (this.isPickerDisplayed) this.hidePicker();
        else this.showPicker();
    }
    onKeyDown(e) {
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                e.preventDefault();
                this.onLabelOrWrapperMouseDown();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (this.isPickerDisplayed) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hideCurrentPicker) this.hideCurrentPicker();
                }
                break;
        }
    }
    showPicker() {
        this.isPickerDisplayed = true;
        if (!this.pickerComponent) this.pickerComponent = this.createPickerComponent();
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.addEventListener("focusin", this.onPickerFocusIn);
        pickerGui.addEventListener("focusout", this.onPickerFocusOut);
        this.hideCurrentPicker = this.renderAndPositionPicker();
        this.toggleExpandedStyles(true);
    }
    renderAndPositionPicker() {
        const ePicker = this.pickerComponent.getGui();
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) [this.destroyMouseWheelFunc] = this.addManagedEventListeners({
            bodyScroll: ()=>{
                this.hidePicker();
            }
        });
        const translate = this.getLocaleTextFunc();
        const { config: { pickerAriaLabelKey: pickerAriaLabelKey, pickerAriaLabelValue: pickerAriaLabelValue, modalPicker: modalPicker = true }, maxPickerHeight: maxPickerHeight, minPickerWidth: minPickerWidth, maxPickerWidth: maxPickerWidth, variableWidth: variableWidth, beans: beans, eWrapper: eWrapper } = this;
        const popupParams = {
            modal: modalPicker,
            eChild: ePicker,
            closeOnEsc: true,
            closedCallback: ()=>{
                const shouldRestoreFocus = $437b23f6a393c3bf$export$8ff9eef09a45371f(beans);
                this.beforeHidePicker();
                if (shouldRestoreFocus && this.isAlive()) this.getFocusableElement().focus();
            },
            ariaLabel: translate(pickerAriaLabelKey, pickerAriaLabelValue),
            anchorToElement: eWrapper
        };
        ePicker.style.position = "absolute";
        const popupSvc = beans.popupSvc;
        const addPopupRes = popupSvc.addPopup(popupParams);
        if (variableWidth) {
            if (minPickerWidth) ePicker.style.minWidth = minPickerWidth;
            ePicker.style.width = $437b23f6a393c3bf$var$_formatSize($437b23f6a393c3bf$export$642efcb17474eb51(eWrapper));
            if (maxPickerWidth) ePicker.style.maxWidth = maxPickerWidth;
        } else $437b23f6a393c3bf$var$_setElementWidth(ePicker, maxPickerWidth ?? $437b23f6a393c3bf$export$642efcb17474eb51(eWrapper));
        const maxHeight = maxPickerHeight ?? `${$437b23f6a393c3bf$export$c20e968103d9c16e(popupSvc.getPopupParent())}px`;
        ePicker.style.setProperty("max-height", maxHeight);
        this.alignPickerToComponent();
        return addPopupRes.hideFunc;
    }
    alignPickerToComponent() {
        if (!this.pickerComponent) return;
        const { pickerGap: pickerGap, config: { pickerType: pickerType }, beans: { popupSvc: popupSvc, gos: gos }, eWrapper: eWrapper, pickerComponent: pickerComponent } = this;
        const alignSide = gos.get("enableRtl") ? "right" : "left";
        popupSvc.positionPopupByComponent({
            type: pickerType,
            eventSource: eWrapper,
            ePopup: pickerComponent.getGui(),
            position: "under",
            alignSide: alignSide,
            keepWithinBounds: true,
            nudgeY: pickerGap
        });
    }
    beforeHidePicker() {
        if (this.destroyMouseWheelFunc) {
            this.destroyMouseWheelFunc();
            this.destroyMouseWheelFunc = void 0;
        }
        this.toggleExpandedStyles(false);
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.removeEventListener("focusin", this.onPickerFocusIn);
        pickerGui.removeEventListener("focusout", this.onPickerFocusOut);
        this.isPickerDisplayed = false;
        this.pickerComponent = void 0;
        this.hideCurrentPicker = null;
    }
    toggleExpandedStyles(expanded) {
        if (!this.isAlive()) return;
        const ariaEl = this.getAriaElement();
        $437b23f6a393c3bf$export$3ad3518dddf15485(ariaEl, expanded);
        const classList = this.eWrapper.classList;
        classList.toggle("ag-picker-expanded", expanded);
        classList.toggle("ag-picker-collapsed", !expanded);
    }
    onPickerFocusIn() {
        this.togglePickerHasFocus(true);
    }
    onPickerFocusOut(e) {
        if (!this.pickerComponent?.getGui().contains(e.relatedTarget)) this.togglePickerHasFocus(false);
    }
    togglePickerHasFocus(focused) {
        if (!this.pickerComponent) return;
        this.eWrapper.classList.toggle("ag-picker-has-focus", focused);
    }
    hidePicker() {
        if (this.hideCurrentPicker) {
            this.hideCurrentPicker();
            this.dispatchLocalEvent({
                type: "pickerHidden"
            });
        }
    }
    setInputWidth(width) {
        $437b23f6a393c3bf$var$_setElementWidth(this.eWrapper, width);
        return this;
    }
    getFocusableElement() {
        return this.eWrapper;
    }
    setPickerGap(gap) {
        this.pickerGap = gap;
        return this;
    }
    setPickerMinWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.minPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.maxPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxHeight(height) {
        if (typeof height === "number") height = `${height}px`;
        this.maxPickerHeight = height == null ? void 0 : height;
        return this;
    }
    destroy() {
        this.hidePicker();
        super.destroy();
    }
};
// packages/ag-grid-community/src/agStack/widgets/agSelect.css-GENERATED.ts
var $437b23f6a393c3bf$var$agSelectCSS = /*css*/ `.ag-select{align-items:center;display:flex;&.ag-disabled{opacity:.5}}:where(.ag-select){.ag-picker-field-wrapper{cursor:default}&.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}&:not(.ag-cell-editor,.ag-label-align-top){min-height:var(--ag-list-item-height)}.ag-picker-field-display{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-picker-field-icon{align-items:center;display:flex}}:where(.ag-ltr) :where(.ag-select){.ag-picker-field-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding)/2);padding-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-select){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-cell-horizontal-padding)/2)}}.ag-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);overflow:hidden auto}.ag-select-list-item{cursor:default;-webkit-user-select:none;-moz-user-select:none;user-select:none;:where(span){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}:where(.ag-ltr) .ag-select-list-item{padding-left:calc(var(--ag-cell-horizontal-padding)/2)}:where(.ag-rtl) .ag-select-list-item{padding-right:calc(var(--ag-cell-horizontal-padding)/2)}`;
// packages/ag-grid-community/src/agStack/widgets/agSelect.ts
var $437b23f6a393c3bf$export$6f9c460854d56032 = class extends $437b23f6a393c3bf$export$1f14489b6fdeb99b {
    constructor(config){
        super({
            pickerAriaLabelKey: "ariaLabelSelectField",
            pickerAriaLabelValue: "Select Field",
            pickerType: "ag-list",
            className: "ag-select",
            pickerIcon: "selectOpen",
            ariaRole: "combobox",
            ...config
        });
        this.registerCSS($437b23f6a393c3bf$var$agSelectCSS);
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            shouldDisplayTooltip: $437b23f6a393c3bf$export$8980540b0a37a11d(()=>this.eDisplayField),
            getGui: ()=>this.getGui()
        }));
        super.postConstruct();
        this.createListComponent();
        this.eWrapper.tabIndex = this.gos.get("tabIndex");
        const { options: options, value: value, placeholder: placeholder } = this.config;
        if (options != null) this.addOptions(options);
        if (value != null) this.setValue(value, true);
        if (placeholder && value == null) this.eDisplayField.textContent = placeholder;
        this.addManagedElementListeners(this.eWrapper, {
            focusout: this.onWrapperFocusOut.bind(this)
        });
    }
    onWrapperFocusOut(e) {
        if (!this.eWrapper.contains(e.relatedTarget)) this.hidePicker();
    }
    createListComponent() {
        const listComponent = this.createBean(new $437b23f6a393c3bf$var$AgList("select"));
        this.listComponent = listComponent;
        listComponent.setParentComponent(this);
        const eListAriaEl = listComponent.getAriaElement();
        const listId = `ag-select-list-${listComponent.getCompId()}`;
        eListAriaEl.setAttribute("id", listId);
        $437b23f6a393c3bf$export$6ff31a4a210c60ad(this.getAriaElement(), eListAriaEl);
        listComponent.addManagedElementListeners(listComponent.getGui(), {
            mousedown: (e)=>{
                e?.preventDefault();
            }
        });
        listComponent.addManagedListeners(listComponent, {
            selectedItem: ()=>{
                this.hidePicker();
                this.dispatchLocalEvent({
                    type: "selectedItem"
                });
            },
            fieldValueChanged: ()=>{
                if (!this.listComponent) return;
                this.setValue(this.listComponent.getValue(), false, true);
                this.hidePicker();
            }
        });
    }
    createPickerComponent() {
        return this.listComponent;
    }
    beforeHidePicker() {
        this.listComponent?.hideItemTooltip();
        super.beforeHidePicker();
    }
    onKeyDown(e) {
        const { key: key } = e;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) this.hidePicker();
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                e.preventDefault();
                if (this.isPickerDisplayed) this.listComponent?.handleKeyDown(e);
                else super.onKeyDown(e);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                super.onKeyDown(e);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                if (this.isPickerDisplayed) e.preventDefault();
                else super.onKeyDown(e);
                break;
        }
    }
    showPicker() {
        const listComponent = this.listComponent;
        if (!listComponent) return;
        super.showPicker();
        listComponent.refreshHighlighted();
    }
    addOptions(options) {
        for (const option of options)this.addOption(option);
        return this;
    }
    addOption(option) {
        this.listComponent.addOption(option);
        return this;
    }
    clearOptions() {
        this.listComponent?.clearOptions();
        this.setValue(void 0, true);
        return this;
    }
    setValue(value, silent, fromPicker) {
        const { listComponent: listComponent, config: { placeholder: placeholder }, eDisplayField: eDisplayField, tooltipFeature: tooltipFeature } = this;
        if (this.value === value || !listComponent) return this;
        if (!fromPicker) listComponent.setValue(value, true);
        const newValue = listComponent.getValue();
        if (newValue === this.getValue()) return this;
        let displayValue = listComponent.getDisplayValue();
        if (displayValue == null && placeholder) displayValue = placeholder;
        eDisplayField.textContent = displayValue;
        tooltipFeature?.setTooltipAndRefresh(displayValue ?? null);
        return super.setValue(value, silent);
    }
    destroy() {
        this.listComponent = this.destroyBean(this.listComponent);
        super.destroy();
    }
};
var $437b23f6a393c3bf$export$e32612175ad118ef = {
    selector: "AG-SELECT",
    component: $437b23f6a393c3bf$export$6f9c460854d56032
};
// packages/ag-grid-community/src/agStack/constants/direction.ts
var $437b23f6a393c3bf$export$cacd6541cfeeb6c1 = /* @__PURE__ */ ((Direction2)=>{
    Direction2[Direction2["Vertical"] = 0] = "Vertical";
    Direction2[Direction2["Horizontal"] = 1] = "Horizontal";
    return Direction2;
})($437b23f6a393c3bf$export$cacd6541cfeeb6c1 || {});
// packages/ag-grid-community/src/agStack/theming/shared/shared.css-GENERATED.ts
var $437b23f6a393c3bf$var$sharedCSS = /*css*/ `:where(.ag-root-wrapper,.ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart),:where(.ag-root-wrapper,.ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]){box-sizing:border-box;&:after,&:before{box-sizing:border-box}&:where(div,span,label):focus-visible{box-shadow:inset var(--ag-focus-shadow);outline:none;&:where(.invalid){box-shadow:inset var(--ag-focus-error-shadow)}}&:where(button){color:inherit}}:where(.ag-root-wrapper,ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]) ::-ms-clear{display:none}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-popup-child{top:0;z-index:5;&:where(:not(.ag-tooltip-custom)){box-shadow:var(--ag-popup-shadow)}}.ag-input-wrapper,.ag-picker-field-wrapper{align-items:center;display:flex;flex:1 1 auto;line-height:normal;position:relative}.ag-input-field{align-items:center;display:flex;flex-direction:row}.ag-input-field-input:where(:not([type=checkbox],[type=radio])){flex:1 1 auto;min-width:0;width:100%}.ag-chart,.ag-dnd-ghost,.ag-external,.ag-popup,.ag-root-wrapper{cursor:default;line-height:normal;white-space:normal;-webkit-font-smoothing:antialiased;background-color:var(--ag-background-color);color:var(--ag-text-color);color-scheme:var(--ag-browser-color-scheme);font-family:var(--ag-font-family);font-size:var(--ag-font-size);--ag-indentation-level:0}:where(.ag-icon):before{align-items:center;background-color:currentcolor;color:inherit;content:"";display:flex;font-family:inherit;font-size:var(--ag-icon-size);font-style:normal;font-variant:normal;height:var(--ag-icon-size);justify-content:center;line-height:var(--ag-icon-size);-webkit-mask-size:contain;mask-size:contain;text-transform:none;width:var(--ag-icon-size)}.ag-icon{background-position:50%;background-repeat:no-repeat;background-size:contain;color:var(--ag-icon-color);display:block;height:var(--ag-icon-size);position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-icon-size)}.ag-disabled,[disabled]{.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-resizer{pointer-events:none;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none;z-index:1}:where(.ag-resizer){&.ag-resizer-topLeft{cursor:nwse-resize;height:5px;left:0;top:0;width:5px}&.ag-resizer-top{cursor:ns-resize;height:5px;left:5px;right:5px;top:0}&.ag-resizer-topRight{cursor:nesw-resize;height:5px;right:0;top:0;width:5px}&.ag-resizer-right{bottom:5px;cursor:ew-resize;right:0;top:5px;width:5px}&.ag-resizer-bottomRight{bottom:0;cursor:nwse-resize;height:5px;right:0;width:5px}&.ag-resizer-bottom{bottom:0;cursor:ns-resize;height:5px;left:5px;right:5px}&.ag-resizer-bottomLeft{bottom:0;cursor:nesw-resize;height:5px;left:0;width:5px}&.ag-resizer-left{bottom:5px;cursor:ew-resize;left:0;top:5px;width:5px}}`;
// packages/ag-grid-community/src/agStack/theming/inject.ts
var $437b23f6a393c3bf$var$IS_SSR = typeof window !== "object" || !window?.document?.fonts?.forEach;
var $437b23f6a393c3bf$var$FORCE_LEGACY_THEMES = false;
var $437b23f6a393c3bf$var$_injectGlobalCSS = (css, styleContainer, debugId, layer, priority, nonce)=>{
    if ($437b23f6a393c3bf$var$IS_SSR) return;
    if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return;
    if (layer) css = `@layer ${CSS.escape(layer)} { ${css} }`;
    let injections = $437b23f6a393c3bf$var$injectionState.map.get(styleContainer);
    if (!injections) {
        injections = [];
        $437b23f6a393c3bf$var$injectionState.map.set(styleContainer, injections);
    }
    if (injections.some((i)=>i.css === css)) return;
    const el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.dataset.agGlobalCss = debugId;
    el.textContent = css;
    const newInjection = {
        css: css,
        el: el,
        priority: priority
    };
    let insertAfter;
    for (const injection of injections){
        if (injection.priority > priority) break;
        insertAfter = injection;
    }
    if (insertAfter) {
        insertAfter.el.insertAdjacentElement("afterend", el);
        const index = injections.indexOf(insertAfter);
        injections.splice(index + 1, 0, newInjection);
    } else {
        styleContainer.insertBefore(el, styleContainer.querySelector(":not(title, meta)"));
        injections.push(newInjection);
    }
};
var $437b23f6a393c3bf$var$_injectCoreAndModuleCSS = (styleContainer, layer, nonce, moduleCss)=>{
    $437b23f6a393c3bf$var$_injectGlobalCSS($437b23f6a393c3bf$var$sharedCSS, styleContainer, "shared", layer, 0, nonce);
    moduleCss?.forEach((css, debugId)=>css.forEach((singleCss)=>$437b23f6a393c3bf$var$_injectGlobalCSS(singleCss, styleContainer, debugId, layer, 0, nonce)));
};
var $437b23f6a393c3bf$var$_registerInstanceUsingThemingAPI = (environment)=>{
    $437b23f6a393c3bf$var$injectionState.grids.add(environment);
};
var $437b23f6a393c3bf$var$_unregisterInstanceUsingThemingAPI = (environment)=>{
    $437b23f6a393c3bf$var$injectionState.grids.delete(environment);
    if ($437b23f6a393c3bf$var$injectionState.grids.size === 0) {
        $437b23f6a393c3bf$var$injectionState.map = /* @__PURE__ */ new WeakMap();
        for (const style of document.head.querySelectorAll("style[data-ag-global-css]"))style.remove();
    }
};
var $437b23f6a393c3bf$var$_a;
var $437b23f6a393c3bf$var$injectionState = ($437b23f6a393c3bf$var$_a = typeof window === "object" ? window : {}).agStyleInjectionState ?? ($437b23f6a393c3bf$var$_a.agStyleInjectionState = {
    map: /* @__PURE__ */ new WeakMap(),
    grids: /* @__PURE__ */ new Set()
});
// packages/ag-grid-community/src/agStack/theming/partImpl.ts
var $437b23f6a393c3bf$export$6e6f0e372f4cb988 = (args)=>{
    return new $437b23f6a393c3bf$var$PartImpl(args);
};
var $437b23f6a393c3bf$var$defaultModeName = "$default";
var $437b23f6a393c3bf$var$partCounter = 0;
var $437b23f6a393c3bf$var$PartImpl = class {
    constructor({ feature: feature, params: params, modeParams: modeParams = {}, css: css, cssImports: cssImports }){
        this.feature = feature;
        this.css = css;
        this.cssImports = cssImports;
        this.modeParams = {
            // NOTE: it's important that default is defined first, putting it
            // first in iteration order, because when merging params the default
            // params override any prior modal params, so modal params in this
            // part need to come after default params to prevent them from being
            // immediately overridden.
            [$437b23f6a393c3bf$var$defaultModeName]: {
                ...modeParams[$437b23f6a393c3bf$var$defaultModeName] ?? {},
                ...params ?? {}
            },
            ...modeParams
        };
    }
    use(styleContainer, layer, nonce) {
        let inject = this._inject;
        if (inject == null) {
            let { css: css } = this;
            if (css) {
                const className = `ag-theme-${this.feature ?? "part"}-${++$437b23f6a393c3bf$var$partCounter}`;
                if (typeof css === "function") css = css();
                css = `:where(.${className}) {
${css}
}
`;
                for (const cssImport of this.cssImports ?? [])css = `@import url(${JSON.stringify(cssImport)});
${css}`;
                inject = {
                    css: css,
                    class: className
                };
            } else inject = false;
            this._inject = inject;
        }
        if (inject && styleContainer) $437b23f6a393c3bf$var$_injectGlobalCSS(inject.css, styleContainer, inject.class, layer, 1, nonce);
        return inject ? inject.class : false;
    }
};
// packages/ag-grid-community/src/agStack/theming/themeUtils.ts
var $437b23f6a393c3bf$var$kebabCase = (str)=>str.replace(/[A-Z]/g, (m)=>`-${m}`).toLowerCase();
var $437b23f6a393c3bf$var$paramToVariableName = (paramName)=>`--ag-${$437b23f6a393c3bf$var$kebabCase(paramName)}`;
var $437b23f6a393c3bf$var$paramToVariableExpression = (paramName)=>`var(${$437b23f6a393c3bf$var$paramToVariableName(paramName)})`;
var $437b23f6a393c3bf$var$clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
var $437b23f6a393c3bf$var$memoize = (fn)=>{
    const values = /* @__PURE__ */ new Map();
    return (a)=>{
        const key = a;
        if (!values.has(key)) values.set(key, fn(a));
        return values.get(key);
    };
};
var $437b23f6a393c3bf$var$accentMix = (mix)=>({
        ref: "accentColor",
        mix: mix
    });
var $437b23f6a393c3bf$var$foregroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix
    });
var $437b23f6a393c3bf$var$foregroundBackgroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix,
        onto: "backgroundColor"
    });
var $437b23f6a393c3bf$var$foregroundHeaderBackgroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix,
        onto: "headerBackgroundColor"
    });
var $437b23f6a393c3bf$var$backgroundColor = {
    ref: "backgroundColor"
};
var $437b23f6a393c3bf$var$foregroundColor = {
    ref: "foregroundColor"
};
var $437b23f6a393c3bf$var$accentColor = {
    ref: "accentColor"
};
// packages/ag-grid-community/src/agStack/theming/shared/shared-css.ts
var $437b23f6a393c3bf$var$defaultLightColorSchemeParams = {
    backgroundColor: "#fff",
    foregroundColor: "#181d1f",
    borderColor: $437b23f6a393c3bf$var$foregroundMix(0.15),
    chromeBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.02),
    browserColorScheme: "light"
};
var $437b23f6a393c3bf$var$sharedDefaults = {
    ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
    textColor: $437b23f6a393c3bf$var$foregroundColor,
    accentColor: "#2196f3",
    invalidColor: "#e02525",
    fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Roboto",
        "Oxygen-Sans",
        "Ubuntu",
        "Cantarell",
        "Helvetica Neue",
        "sans-serif"
    ],
    subtleTextColor: {
        ref: "textColor",
        mix: 0.5
    },
    borderWidth: 1,
    borderRadius: 4,
    spacing: 8,
    fontSize: 14,
    focusShadow: {
        spread: 3,
        color: $437b23f6a393c3bf$var$accentMix(0.5)
    },
    focusErrorShadow: {
        spread: 3,
        color: {
            ref: "invalidColor",
            onto: "backgroundColor",
            mix: 0.5
        }
    },
    popupShadow: "0 0 16px #00000026",
    cardShadow: "0 1px 4px 1px #00000018",
    dropdownShadow: {
        ref: "cardShadow"
    },
    listItemHeight: {
        calc: "max(iconSize, dataFontSize) + widgetVerticalSpacing"
    },
    dragAndDropImageBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    dragAndDropImageBorder: true,
    dragAndDropImageNotAllowedBorder: {
        color: {
            ref: "invalidColor",
            onto: "dragAndDropImageBackgroundColor",
            mix: 0.5
        }
    },
    dragAndDropImageShadow: {
        ref: "popupShadow"
    },
    iconSize: 16,
    iconColor: "inherit",
    toggleButtonWidth: 28,
    toggleButtonHeight: 18,
    toggleButtonOnBackgroundColor: $437b23f6a393c3bf$var$accentColor,
    toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
    toggleButtonSwitchBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    toggleButtonSwitchInset: 2,
    tooltipBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    tooltipErrorBackgroundColor: {
        ref: "invalidColor",
        onto: "backgroundColor",
        mix: 0.1
    },
    tooltipTextColor: {
        ref: "textColor"
    },
    tooltipErrorTextColor: {
        ref: "invalidColor"
    },
    tooltipBorder: true,
    tooltipErrorBorder: {
        color: {
            ref: "invalidColor",
            onto: "backgroundColor",
            mix: 0.25
        }
    }
};
// packages/ag-grid-community/src/agStack/theming/themeTypeUtils.ts
var $437b23f6a393c3bf$var$paramTypes = [
    "colorScheme",
    "color",
    "length",
    "scale",
    "borderStyle",
    "border",
    "shadow",
    "image",
    "fontFamily",
    "fontWeight",
    "duration"
];
var $437b23f6a393c3bf$var$getParamType = $437b23f6a393c3bf$var$memoize((param)=>{
    param = param.toLowerCase();
    return $437b23f6a393c3bf$var$paramTypes.find((type)=>param.endsWith(type.toLowerCase())) ?? "length";
});
var $437b23f6a393c3bf$var$literalToCSS = (value)=>{
    if (typeof value === "object" && value?.ref) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    if (typeof value === "string") return value;
    if (typeof value === "number") return String(value);
    return false;
};
var $437b23f6a393c3bf$var$colorValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value && "ref" in value) {
        const colorExpr = $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
        if (value.mix == null) return colorExpr;
        const backgroundExpr = value.onto ? $437b23f6a393c3bf$var$paramToVariableExpression(value.onto) : "transparent";
        return `color-mix(in srgb, ${backgroundExpr}, ${colorExpr} ${$437b23f6a393c3bf$var$clamp(value.mix * 100, 0, 100)}%)`;
    }
    return false;
};
var $437b23f6a393c3bf$var$colorSchemeValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$lengthValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (typeof value === "number") return `${value}px`;
    if (value && "calc" in value) {
        const valueWithSpaces = value.calc.replace(/ ?[*/+] ?/g, " $& ");
        return `calc(${valueWithSpaces.replace(/-?\b[a-z][a-z0-9]*\b(?![-(])/gi, (p)=>p[0] === "-" ? p : " " + $437b23f6a393c3bf$var$paramToVariableExpression(p) + " ")})`;
    }
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$scaleValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$borderValueToCss = (value, param)=>{
    if (typeof value === "string") return value;
    if (value === true) return $437b23f6a393c3bf$var$borderValueToCss({}, param);
    if (value === false) return param === "columnBorder" ? $437b23f6a393c3bf$var$borderValueToCss({
        color: "transparent"
    }, param) : "none";
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return $437b23f6a393c3bf$var$borderStyleValueToCss(value.style ?? "solid") + " " + $437b23f6a393c3bf$var$lengthValueToCss(value.width ?? {
        ref: "borderWidth"
    }) + " " + $437b23f6a393c3bf$var$colorValueToCss(value.color ?? {
        ref: "borderColor"
    });
};
var $437b23f6a393c3bf$var$shadowValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value === false) return "none";
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return [
        $437b23f6a393c3bf$var$lengthValueToCss(value.offsetX ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.offsetY ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.radius ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.spread ?? 0),
        $437b23f6a393c3bf$var$colorValueToCss(value.color ?? {
            ref: "foregroundColor"
        })
    ].join(" ");
};
var $437b23f6a393c3bf$var$borderStyleValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$fontFamilyValueToCss = (value)=>{
    if (typeof value === "string") return value.includes(",") ? value : $437b23f6a393c3bf$var$quoteUnsafeChars(value);
    if (value && "googleFont" in value) return $437b23f6a393c3bf$var$fontFamilyValueToCss(value.googleFont);
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    if (Array.isArray(value)) return value.map((font)=>{
        if (typeof font === "object" && "googleFont" in font) font = font.googleFont;
        return $437b23f6a393c3bf$var$quoteUnsafeChars(font);
    }).join(", ");
    return false;
};
var $437b23f6a393c3bf$var$quoteUnsafeChars = (font)=>// don't quote var() expressions or quote safe identifier names, so that
    // people can specify fonts like sans-serif which are keywords not strings,
    // or var(--my-var)
    /^[\w-]+$|\w\(/.test(font) ? font : JSON.stringify(font);
var $437b23f6a393c3bf$var$fontWeightValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$imageValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value && "url" in value) return `url(${JSON.stringify(value.url)})`;
    if (value && "svg" in value) return $437b23f6a393c3bf$var$imageValueToCss({
        url: `data:image/svg+xml,${encodeURIComponent(value.svg)}`
    });
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$durationValueToCss = (value, param, themeLogger)=>{
    if (typeof value === "string") return value;
    if (typeof value === "number") {
        if (value >= 10) themeLogger.warn(104, {
            value: value,
            param: param
        });
        return `${value}s`;
    }
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$paramValidators = {
    color: $437b23f6a393c3bf$var$colorValueToCss,
    colorScheme: $437b23f6a393c3bf$var$colorSchemeValueToCss,
    length: $437b23f6a393c3bf$var$lengthValueToCss,
    scale: $437b23f6a393c3bf$var$scaleValueToCss,
    border: $437b23f6a393c3bf$var$borderValueToCss,
    borderStyle: $437b23f6a393c3bf$var$borderStyleValueToCss,
    shadow: $437b23f6a393c3bf$var$shadowValueToCss,
    image: $437b23f6a393c3bf$var$imageValueToCss,
    fontFamily: $437b23f6a393c3bf$var$fontFamilyValueToCss,
    fontWeight: $437b23f6a393c3bf$var$fontWeightValueToCss,
    duration: $437b23f6a393c3bf$var$durationValueToCss
};
var $437b23f6a393c3bf$var$paramValueToCss = (param, value, themeLogger)=>{
    const type = $437b23f6a393c3bf$var$getParamType(param);
    return $437b23f6a393c3bf$var$paramValidators[type](value, param, themeLogger);
};
// packages/ag-grid-community/src/agStack/theming/themeImpl.ts
var $437b23f6a393c3bf$export$638c0e26f33cd834 = (theme)=>{
    if (!(theme instanceof $437b23f6a393c3bf$var$ThemeImpl)) throw new Error("theme is not an object created by createTheme");
    return theme;
};
var $437b23f6a393c3bf$var$createSharedTheme = (themeLogger)=>new $437b23f6a393c3bf$var$ThemeImpl(themeLogger);
var $437b23f6a393c3bf$var$ThemeImpl = class _ThemeImpl {
    constructor(themeLogger, parts = []){
        this.themeLogger = themeLogger;
        this.parts = parts;
    }
    withPart(part) {
        if (typeof part === "function") part = part();
        if (!(part instanceof $437b23f6a393c3bf$var$PartImpl)) {
            this.themeLogger.preInitErr(259, "Invalid part", {
                part: part
            });
            return this;
        }
        return new _ThemeImpl(this.themeLogger, [
            ...this.parts,
            part
        ]);
    }
    withoutPart(feature) {
        return this.withPart($437b23f6a393c3bf$export$6e6f0e372f4cb988({
            feature: feature
        }));
    }
    withParams(params, mode = $437b23f6a393c3bf$var$defaultModeName) {
        return this.withPart($437b23f6a393c3bf$export$6e6f0e372f4cb988({
            modeParams: {
                [mode]: params
            }
        }));
    }
    /**
   * Called by a grid instance when it starts using the theme. This installs
   * the theme's parts into document head, or the shadow DOM if the provided
   * container is within a shadow root.
   */ _startUse({ styleContainer: styleContainer, cssLayer: cssLayer, nonce: nonce, loadThemeGoogleFonts: loadThemeGoogleFonts, moduleCss: moduleCss }) {
        if ($437b23f6a393c3bf$var$IS_SSR) return;
        if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return;
        $437b23f6a393c3bf$var$uninstallLegacyCSS();
        $437b23f6a393c3bf$var$_injectCoreAndModuleCSS(styleContainer, cssLayer, nonce, moduleCss);
        const googleFontsUsed = $437b23f6a393c3bf$var$getGoogleFontsUsed(this);
        if (googleFontsUsed.length > 0) {
            for (const googleFont of googleFontsUsed)if (loadThemeGoogleFonts) $437b23f6a393c3bf$var$loadGoogleFont(googleFont, nonce);
        }
        for (const part of this.parts)part.use(styleContainer, cssLayer, nonce);
    }
    /**
   * Return CSS that that applies the params of this theme to elements with
   * the provided class name
   */ _getCssClass() {
        if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return "ag-theme-quartz";
        return this._cssClassCache ?? (this._cssClassCache = $437b23f6a393c3bf$var$deduplicatePartsByFeature(this.parts).map((part)=>part.use(void 0, void 0, void 0)).filter(Boolean).join(" "));
    }
    _getModeParams() {
        let paramsCache = this._paramsCache;
        if (!paramsCache) {
            const mergedModeParams = {
                // NOTE: defining the default mode here is important, it ensures
                // that the default mode is first in iteration order, which puts
                // it first in outputted CSS, allowing other modes to override it
                [$437b23f6a393c3bf$var$defaultModeName]: {
                    ...$437b23f6a393c3bf$var$sharedDefaults
                }
            };
            for (const part of $437b23f6a393c3bf$var$deduplicatePartsByFeature(this.parts))for (const partMode of Object.keys(part.modeParams)){
                const partParams = part.modeParams[partMode];
                if (partParams) {
                    const mergedParams = mergedModeParams[partMode] ?? (mergedModeParams[partMode] = {});
                    const partParamNames = /* @__PURE__ */ new Set();
                    for (const partParamName of Object.keys(partParams)){
                        const partParamValue = partParams[partParamName];
                        if (partParamValue !== void 0) {
                            mergedParams[partParamName] = partParamValue;
                            partParamNames.add(partParamName);
                        }
                    }
                    if (partMode === $437b23f6a393c3bf$var$defaultModeName) for (const mergedMode of Object.keys(mergedModeParams)){
                        const mergedParams2 = mergedModeParams[mergedMode];
                        if (mergedMode !== $437b23f6a393c3bf$var$defaultModeName) for (const partParamName of partParamNames)delete mergedParams2[partParamName];
                    }
                }
            }
            this._paramsCache = paramsCache = mergedModeParams;
        }
        return paramsCache;
    }
    /**
   * Return the CSS chunk that is inserted into the grid DOM, and will
   * therefore be removed automatically when the grid is destroyed or it
   * starts to use a new theme.
   *
   * @param className a unique class name on the grid wrapper used to scope the returned CSS to the grid instance
   */ _getPerInstanceCss(className) {
        const selectorPlaceholder = "##SELECTOR##";
        let innerParamsCss = this._paramsCssCache;
        if (!innerParamsCss) {
            let variablesCss = "";
            let inheritanceCss = "";
            const modeParams = this._getModeParams();
            for (const mode of Object.keys(modeParams)){
                const params = modeParams[mode];
                if (mode !== $437b23f6a393c3bf$var$defaultModeName) {
                    const escapedMode = typeof CSS === "object" ? CSS.escape(mode) : mode;
                    const wrapPrefix = `:where([data-ag-theme-mode="${escapedMode}"]) & {
`;
                    variablesCss += wrapPrefix;
                    inheritanceCss += wrapPrefix;
                }
                for (const key of Object.keys(params).sort()){
                    const value = params[key];
                    const cssValue = $437b23f6a393c3bf$var$paramValueToCss(key, value, this.themeLogger);
                    if (cssValue === false) this.themeLogger.error(107, {
                        key: key,
                        value: value
                    });
                    else {
                        const cssName = $437b23f6a393c3bf$var$paramToVariableName(key);
                        const inheritedName = cssName.replace("--ag-", "--ag-inherited-");
                        variablesCss += `	${cssName}: var(${inheritedName}, ${cssValue});
`;
                        inheritanceCss += `	${inheritedName}: var(${cssName});
`;
                    }
                }
                if (mode !== $437b23f6a393c3bf$var$defaultModeName) {
                    variablesCss += "}\n";
                    inheritanceCss += "}\n";
                }
            }
            let css = `${selectorPlaceholder} {
${variablesCss}}
`;
            css += `:has(> ${selectorPlaceholder}):not(${selectorPlaceholder}) {
${inheritanceCss}}
`;
            this._paramsCssCache = innerParamsCss = css;
        }
        return innerParamsCss.replaceAll(selectorPlaceholder, `:where(.${className})`);
    }
};
var $437b23f6a393c3bf$var$deduplicatePartsByFeature = (parts)=>{
    const lastPartByFeature = /* @__PURE__ */ new Map();
    for (const part of parts)lastPartByFeature.set(part.feature, part);
    const result = [];
    for (const part of parts)if (!part.feature || lastPartByFeature.get(part.feature) === part) result.push(part);
    return result;
};
var $437b23f6a393c3bf$var$getGoogleFontsUsed = (theme)=>{
    const googleFontsUsed = /* @__PURE__ */ new Set();
    const visitParamValue = (paramValue)=>{
        if (Array.isArray(paramValue)) paramValue.forEach(visitParamValue);
        else {
            const googleFont = paramValue?.googleFont;
            if (typeof googleFont === "string") googleFontsUsed.add(googleFont);
        }
    };
    const allModeValues = Object.values(theme._getModeParams());
    const allValues = allModeValues.flatMap((mv)=>Object.values(mv));
    allValues.forEach(visitParamValue);
    return Array.from(googleFontsUsed).sort();
};
var $437b23f6a393c3bf$var$uninstalledLegacyCSS = false;
var $437b23f6a393c3bf$var$uninstallLegacyCSS = ()=>{
    if ($437b23f6a393c3bf$var$uninstalledLegacyCSS) return;
    $437b23f6a393c3bf$var$uninstalledLegacyCSS = true;
    for (const style of Array.from(document.head.querySelectorAll('style[data-ag-scope="legacy"]')))style.remove();
};
var $437b23f6a393c3bf$var$loadGoogleFont = async (font, nonce)=>{
    const css = `@import url('https://${$437b23f6a393c3bf$var$googleFontsDomain}/css2?family=${encodeURIComponent(font)}:wght@100;200;300;400;500;600;700;800;900&display=swap');
`;
    $437b23f6a393c3bf$var$_injectGlobalCSS(css, document.head, `googleFont:${font}`, void 0, 0, nonce);
};
var $437b23f6a393c3bf$var$googleFontsDomain = "fonts.googleapis.com";
// packages/ag-grid-community/src/agStack/core/agContext.ts
var $437b23f6a393c3bf$var$contextId = 1;
var $437b23f6a393c3bf$export$1e4aca051de0f84c = class {
    constructor(params){
        this.beans = {};
        this.createdBeans = [];
        this.destroyed = false;
        this.instanceId = $437b23f6a393c3bf$var$contextId++;
        if (!params?.beanClasses) return;
        this.beanDestroyComparator = params.beanDestroyComparator;
        this.init(params);
    }
    init(params) {
        this.id = params.id;
        this.beans.context = this;
        this.destroyCallback = params.destroyCallback;
        for (const beanName of Object.keys(params.providedBeanInstances))this.beans[beanName] = params.providedBeanInstances[beanName];
        for (const BeanClass of params.beanClasses){
            const instance = new BeanClass();
            if (instance.beanName) this.beans[instance.beanName] = instance;
            else console.error(`Bean ${BeanClass.name} is missing beanName`);
            this.createdBeans.push(instance);
        }
        for (const beanFunc of params.derivedBeans ?? []){
            const { beanName: beanName, bean: bean } = beanFunc(this);
            this.beans[beanName] = bean;
            this.createdBeans.push(bean);
        }
        if (params.beanInitComparator) this.createdBeans.sort(params.beanInitComparator);
        this.initBeans(this.createdBeans);
    }
    getBeanInstances() {
        return Object.values(this.beans);
    }
    createBean(bean, afterPreCreateCallback) {
        this.initBeans([
            bean
        ], afterPreCreateCallback);
        return bean;
    }
    initBeans(beanInstances, afterPreCreateCallback) {
        const beans = this.beans;
        for (const instance of beanInstances){
            instance.preWireBeans?.(beans);
            instance.wireBeans?.(beans);
        }
        for (const instance of beanInstances)instance.preConstruct?.();
        if (afterPreCreateCallback) beanInstances.forEach(afterPreCreateCallback);
        for (const instance of beanInstances)instance.postConstruct?.();
    }
    getBeans() {
        return this.beans;
    }
    getBean(name) {
        return this.beans[name];
    }
    getId() {
        return this.id;
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        const beanInstances = this.getBeanInstances();
        if (this.beanDestroyComparator) beanInstances.sort(this.beanDestroyComparator);
        this.destroyBeans(beanInstances);
        this.beans = {};
        this.createdBeans = [];
        this.destroyCallback?.();
    }
    /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */ destroyBean(bean) {
        bean?.destroy?.();
    }
    /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */ destroyBeans(beans) {
        if (beans) for(let i = 0; i < beans.length; i++)this.destroyBean(beans[i]);
        return [];
    }
    isDestroyed() {
        return this.destroyed;
    }
};
// packages/ag-grid-community/src/agStack/core/baseEnvironment.ts
var $437b23f6a393c3bf$var$paramsId = 0;
var $437b23f6a393c3bf$export$13d30f6a265c57c6 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "environment";
        this.paramsClass = `ag-theme-params-${++$437b23f6a393c3bf$var$paramsId}`;
        this.globalCSS = [];
    }
    wireBeans(beans) {
        this.eRootDiv = beans.eRootDiv;
    }
    postConstruct() {
        const { gos: gos, eRootDiv: eRootDiv } = this;
        gos.setInstanceDomData(eRootDiv);
        this.eStyleContainer = gos.get("themeStyleContainer") ?? (eRootDiv.getRootNode() === document ? document.head : eRootDiv);
        this.cssLayer = gos.get("themeCssLayer");
        this.styleNonce = gos.get("styleNonce");
        this.addManagedPropertyListener("theme", ()=>this.handleThemeChange());
        this.handleThemeChange();
        this.initVariables();
        this.addDestroyFunc(()=>$437b23f6a393c3bf$var$_unregisterInstanceUsingThemingAPI(this));
        this.mutationObserver = new MutationObserver(()=>{
            this.fireStylesChangedEvent("themeChanged");
        });
        this.addDestroyFunc(()=>this.mutationObserver.disconnect());
    }
    applyThemeClasses(el, extraClasses = []) {
        const { theme: theme } = this;
        let themeClass;
        if (theme) themeClass = `${this.paramsClass} ${theme._getCssClass()}`;
        else themeClass = this.applyLegacyThemeClasses();
        for (const className of Array.from(el.classList))if (className.startsWith("ag-theme-")) el.classList.remove(className);
        if (themeClass) {
            const oldClass = el.className;
            el.className = `${oldClass}${oldClass ? " " : ""}${themeClass}${extraClasses?.length ? " " + extraClasses.join(" ") : ""}`;
        }
    }
    applyLegacyThemeClasses() {
        let themeClass = "";
        this.mutationObserver.disconnect();
        let node = this.eRootDiv;
        while(node){
            let isThemeEl = false;
            for (const className of Array.from(node.classList))if (className.startsWith("ag-theme-")) {
                isThemeEl = true;
                themeClass = themeClass ? `${themeClass} ${className}` : className;
            }
            if (isThemeEl) this.mutationObserver.observe(node, {
                attributes: true,
                attributeFilter: [
                    "class"
                ]
            });
            node = node.parentElement;
        }
        return themeClass;
    }
    addGlobalCSS(css, debugId) {
        if (this.theme) $437b23f6a393c3bf$var$_injectGlobalCSS(css, this.eStyleContainer, debugId, this.cssLayer, 0, this.styleNonce);
        else this.globalCSS.push([
            css,
            debugId
        ]);
    }
    handleThemeChange() {
        const { gos: gos, theme: oldTheme } = this;
        const themeProperty = gos.get("theme");
        let newTheme;
        if (themeProperty === "legacy") newTheme = void 0;
        else {
            const themeOrDefault = themeProperty ?? this.getDefaultTheme();
            if (themeOrDefault instanceof $437b23f6a393c3bf$var$ThemeImpl) newTheme = themeOrDefault;
            else this.themeError(themeOrDefault);
        }
        if (newTheme !== oldTheme) this.handleNewTheme(newTheme);
        this.postProcessThemeChange(newTheme, themeProperty);
    }
    handleNewTheme(newTheme) {
        const { gos: gos, eRootDiv: eRootDiv, globalCSS: globalCSS } = this;
        const additionalCss = this.getAdditionalCss();
        if (newTheme) {
            $437b23f6a393c3bf$var$_registerInstanceUsingThemingAPI(this);
            $437b23f6a393c3bf$var$_injectCoreAndModuleCSS(this.eStyleContainer, this.cssLayer, this.styleNonce, additionalCss);
            for (const [css, debugId] of globalCSS)$437b23f6a393c3bf$var$_injectGlobalCSS(css, this.eStyleContainer, debugId, this.cssLayer, 0, this.styleNonce);
            globalCSS.length = 0;
        }
        this.theme = newTheme;
        newTheme?._startUse({
            loadThemeGoogleFonts: gos.get("loadThemeGoogleFonts"),
            styleContainer: this.eStyleContainer,
            cssLayer: this.cssLayer,
            nonce: this.styleNonce,
            moduleCss: additionalCss
        });
        let eParamsStyle = this.eParamsStyle;
        if (!eParamsStyle) {
            eParamsStyle = this.eParamsStyle = $437b23f6a393c3bf$export$378bc9c64290bc8b({
                tag: "style"
            });
            const styleNonce = gos.get("styleNonce");
            if (styleNonce) eParamsStyle.setAttribute("nonce", styleNonce);
            eRootDiv.appendChild(eParamsStyle);
        }
        if (!$437b23f6a393c3bf$var$IS_SSR) eParamsStyle.textContent = newTheme?._getPerInstanceCss(this.paramsClass) || "";
        this.applyThemeClasses(eRootDiv);
        this.fireStylesChangedEvent("themeChanged");
    }
};
// packages/ag-grid-community/src/agStack/core/baseRegistry.ts
var $437b23f6a393c3bf$export$95e025d9098f4893 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "registry";
    }
    registerDynamicBeans(dynamicBeans) {
        if (dynamicBeans) {
            this.dynamicBeans ?? (this.dynamicBeans = {});
            for (const name of Object.keys(dynamicBeans))this.dynamicBeans[name] = dynamicBeans[name];
        }
    }
    createDynamicBean(name, mandatory, ...args) {
        if (!this.dynamicBeans) throw new Error(this.getDynamicError(name, true));
        const BeanClass = this.dynamicBeans[name];
        if (BeanClass == null) {
            if (mandatory) throw new Error(this.getDynamicError(name, false));
            return void 0;
        }
        return new BeanClass(...args);
    }
};
// packages/ag-grid-community/src/agStack/events/baseEventService.ts
var $437b23f6a393c3bf$export$495c88faa5a4d068 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "eventSvc";
        this.eventServiceType = "global";
        this.globalSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
    }
    addListener(eventType, listener, async) {
        this.globalSvc.addEventListener(eventType, listener, async);
    }
    removeListener(eventType, listener, async) {
        this.globalSvc.removeEventListener(eventType, listener, async);
    }
    addGlobalListener(listener, async = false) {
        this.globalSvc.addGlobalListener(listener, async);
    }
    removeGlobalListener(listener, async = false) {
        this.globalSvc.removeGlobalListener(listener, async);
    }
    dispatchEvent(event) {
        this.globalSvc.dispatchEvent(this.gos.addCommon(event));
    }
    dispatchEventOnce(event) {
        this.globalSvc.dispatchEventOnce(this.gos.addCommon(event));
    }
};
// packages/ag-grid-community/src/agStack/tooltip/agTooltipFeature.ts
var $437b23f6a393c3bf$export$e72bd8c9b85d3e72 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(ctrl, beans){
        super();
        this.ctrl = ctrl;
        if (beans) this.beans = beans;
    }
    postConstruct() {
        this.refreshTooltip();
    }
    /**
   *
   * @param tooltip The tooltip value
   * @param allowEmptyString Set it to true to allow the title to be set to `''`. This is necessary
   * when the browser adds a default tooltip the element and the tooltip service will be displayed
   * next to a browser tooltip causing confusion.
   */ setBrowserTooltip(tooltip, allowEmptyString) {
        const name = "title";
        const eGui = this.ctrl.getGui();
        if (!eGui) return;
        if (tooltip != null && (tooltip != "" || allowEmptyString)) eGui.setAttribute(name, tooltip);
        else eGui.removeAttribute(name);
    }
    updateTooltipText() {
        const { getTooltipValue: getTooltipValue } = this.ctrl;
        if (getTooltipValue) this.tooltip = getTooltipValue();
    }
    createTooltipFeatureIfNeeded() {
        if (this.tooltipManager == null) {
            const tooltipManager = this.beans.registry.createDynamicBean("tooltipStateManager", true, this.ctrl, ()=>this.tooltip);
            if (tooltipManager) this.tooltipManager = this.createBean(tooltipManager, this.beans.context);
        }
    }
    attemptToShowTooltip() {
        this.tooltipManager?.prepareToShowTooltip();
    }
    attemptToHideTooltip() {
        this.tooltipManager?.hideTooltip();
    }
    setTooltipAndRefresh(tooltip) {
        this.tooltip = tooltip;
        this.refreshTooltip();
    }
    refreshTooltip(clearWithEmptyString) {
        this.browserTooltips = this.beans.gos.get("enableBrowserTooltips");
        this.updateTooltipText();
        if (this.browserTooltips) {
            this.setBrowserTooltip(this.tooltip);
            this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        } else {
            this.setBrowserTooltip(clearWithEmptyString ? "" : null, clearWithEmptyString);
            this.createTooltipFeatureIfNeeded();
        }
    }
    destroy() {
        this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        super.destroy();
    }
};
// packages/ag-grid-community/src/agStack/tooltip/baseTooltipStateManager.ts
var $437b23f6a393c3bf$var$SHOW_QUICK_TOOLTIP_DIFF = 1e3;
var $437b23f6a393c3bf$var$FADE_OUT_TOOLTIP_TIMEOUT = 1e3;
var $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY = 100;
var $437b23f6a393c3bf$var$lastTooltipHideTime;
var $437b23f6a393c3bf$var$isLocked = false;
var $437b23f6a393c3bf$export$96f12f5ea073bed1 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(tooltipCtrl, getTooltipValue){
        super();
        this.tooltipCtrl = tooltipCtrl;
        this.getTooltipValue = getTooltipValue;
        this.interactionEnabled = false;
        this.isInteractingWithTooltip = false;
        this.state = 0 /* NOTHING */ ;
        // when showing the tooltip, we need to make sure it's the most recent instance we request, as due to
        // async we could request two tooltips before the first instance returns, in which case we should
        // disregard the second instance.
        this.tooltipInstanceCount = 0;
        this.tooltipMouseTrack = false;
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
    }
    postConstruct() {
        if (this.gos.get("tooltipInteraction")) this.interactionEnabled = true;
        this.tooltipTrigger = this.getTooltipTrigger();
        this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
        const el = this.tooltipCtrl.getGui();
        if (this.tooltipTrigger === 0 /* HOVER */ ) this.addManagedListeners(el, {
            mouseenter: this.onMouseEnter.bind(this),
            mouseleave: this.onMouseLeave.bind(this)
        });
        if (this.tooltipTrigger === 1 /* FOCUS */ ) this.addManagedListeners(el, {
            focusin: this.onFocusIn.bind(this),
            focusout: this.onFocusOut.bind(this)
        });
        this.addManagedListeners(el, {
            mousemove: this.onMouseMove.bind(this)
        });
        if (!this.interactionEnabled) this.addManagedListeners(el, {
            mousedown: this.onMouseDown.bind(this),
            keydown: this.onKeyDown.bind(this)
        });
    }
    getGridOptionsTooltipDelay(delayOption) {
        const delay = this.gos.get(delayOption);
        return Math.max(200, delay);
    }
    getTooltipDelay(type) {
        if (type === "show") return this.tooltipCtrl.getTooltipShowDelayOverride?.() ?? this.getGridOptionsTooltipDelay("tooltipShowDelay");
        return this.tooltipCtrl.getTooltipHideDelayOverride?.() ?? this.getGridOptionsTooltipDelay("tooltipHideDelay");
    }
    destroy() {
        this.setToDoNothing();
        super.destroy();
    }
    getTooltipTrigger() {
        const trigger = this.gos.get("tooltipTrigger");
        if (!trigger || trigger === "hover") return 0 /* HOVER */ ;
        return 1 /* FOCUS */ ;
    }
    onMouseEnter(e) {
        if (this.interactionEnabled && this.interactiveTooltipTimeoutId) {
            this.unlockService();
            this.startHideTimeout();
        }
        if ($437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        if ($437b23f6a393c3bf$var$isLocked) this.showTooltipTimeoutId = window.setTimeout(()=>{
            this.prepareToShowTooltip(e);
        }, $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY);
        else this.prepareToShowTooltip(e);
    }
    onMouseMove(e) {
        if (this.lastMouseEvent) this.lastMouseEvent = e;
        if (this.tooltipMouseTrack && this.state === 2 /* SHOWING */  && this.tooltipComp) this.positionTooltip();
    }
    onMouseDown() {
        this.setToDoNothing();
    }
    onMouseLeave() {
        if (this.interactionEnabled) this.lockService();
        else this.setToDoNothing();
    }
    onFocusIn() {
        this.prepareToShowTooltip();
    }
    onFocusOut(e) {
        const relatedTarget = e.relatedTarget;
        const parentCompGui = this.tooltipCtrl.getGui();
        const tooltipGui = this.tooltipComp?.getGui();
        if (this.isInteractingWithTooltip || parentCompGui.contains(relatedTarget) || this.interactionEnabled && tooltipGui?.contains(relatedTarget)) return;
        this.setToDoNothing();
    }
    onKeyDown() {
        if (this.isInteractingWithTooltip) this.isInteractingWithTooltip = false;
        this.setToDoNothing();
    }
    prepareToShowTooltip(mouseEvent) {
        if (this.state != 0 /* NOTHING */  || $437b23f6a393c3bf$var$isLocked) return;
        let delay = 0;
        if (mouseEvent) delay = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show");
        this.lastMouseEvent = mouseEvent || null;
        this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay);
        this.state = 1 /* WAITING_TO_SHOW */ ;
    }
    isLastTooltipHiddenRecently() {
        const now = Date.now();
        const then = $437b23f6a393c3bf$var$lastTooltipHideTime;
        return now - then < $437b23f6a393c3bf$var$SHOW_QUICK_TOOLTIP_DIFF;
    }
    setToDoNothing(fromHideTooltip) {
        if (!fromHideTooltip && this.state === 2 /* SHOWING */ ) this.hideTooltip();
        if (this.onBodyScrollEventCallback) {
            this.onBodyScrollEventCallback();
            this.onBodyScrollEventCallback = void 0;
        }
        this.clearEventHandlers();
        if (this.onDocumentKeyDownCallback) {
            this.onDocumentKeyDownCallback();
            this.onDocumentKeyDownCallback = void 0;
        }
        this.clearTimeouts();
        this.state = 0 /* NOTHING */ ;
        this.lastMouseEvent = null;
    }
    showTooltip() {
        const value = this.getTooltipValue();
        const ctrl = this.tooltipCtrl;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) || ctrl.shouldDisplayTooltip && !ctrl.shouldDisplayTooltip()) {
            this.setToDoNothing();
            return;
        }
        const params = this.gos.addCommon({
            location: ctrl.getLocation?.() ?? "UNKNOWN",
            value: value,
            hideTooltipCallback: ()=>this.hideTooltip(true),
            ...ctrl.getAdditionalParams?.()
        });
        this.state = 2 /* SHOWING */ ;
        this.tooltipInstanceCount++;
        const callback = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
        this.createTooltipComp(params, callback);
    }
    hideTooltip(forceHide) {
        if (!forceHide && this.isInteractingWithTooltip) return;
        if (this.tooltipComp) {
            this.destroyTooltipComp();
            $437b23f6a393c3bf$var$lastTooltipHideTime = Date.now();
        }
        this.eventSvc.dispatchEvent({
            type: "tooltipHide",
            parentGui: this.tooltipCtrl.getGui()
        });
        if (forceHide) this.isInteractingWithTooltip = false;
        this.setToDoNothing(true);
    }
    newTooltipComponentCallback(tooltipInstanceCopy, tooltipComp) {
        const compNoLongerNeeded = this.state !== 2 /* SHOWING */  || this.tooltipInstanceCount !== tooltipInstanceCopy;
        if (compNoLongerNeeded) {
            this.destroyBean(tooltipComp);
            return;
        }
        const eGui = tooltipComp.getGui();
        this.tooltipComp = tooltipComp;
        if (!eGui.classList.contains("ag-tooltip")) eGui.classList.add("ag-tooltip-custom");
        if (this.tooltipTrigger === 0 /* HOVER */ ) eGui.classList.add("ag-tooltip-animate");
        if (this.interactionEnabled) eGui.classList.add("ag-tooltip-interactive");
        const translate = this.getLocaleTextFunc();
        const addPopupRes = this.popupSvc?.addPopup({
            eChild: eGui,
            ariaLabel: translate("ariaLabelTooltip", "Tooltip")
        });
        if (addPopupRes) this.tooltipPopupDestroyFunc = addPopupRes.hideFunc;
        this.positionTooltip();
        if (this.tooltipTrigger === 1 /* FOCUS */ ) {
            const listener = ()=>this.setToDoNothing();
            [this.onBodyScrollEventCallback] = this.addManagedEventListeners({
                bodyScroll: listener
            });
            this.setEventHandlers(listener);
        }
        if (this.interactionEnabled) {
            [this.tooltipMouseEnterListener, this.tooltipMouseLeaveListener] = this.addManagedElementListeners(eGui, {
                mouseenter: this.onTooltipMouseEnter.bind(this),
                mouseleave: this.onTooltipMouseLeave.bind(this)
            });
            [this.onDocumentKeyDownCallback] = this.addManagedElementListeners($437b23f6a393c3bf$export$f63d0991874c6f81(this.beans), {
                keydown: (e)=>{
                    if (!eGui.contains(e?.target)) this.onKeyDown();
                }
            });
            if (this.tooltipTrigger === 1 /* FOCUS */ ) [this.tooltipFocusInListener, this.tooltipFocusOutListener] = this.addManagedElementListeners(eGui, {
                focusin: this.onTooltipFocusIn.bind(this),
                focusout: this.onTooltipFocusOut.bind(this)
            });
        }
        this.eventSvc.dispatchEvent({
            type: "tooltipShow",
            tooltipGui: eGui,
            parentGui: this.tooltipCtrl.getGui()
        });
        this.startHideTimeout();
    }
    onTooltipMouseEnter() {
        this.isInteractingWithTooltip = true;
        this.unlockService();
    }
    onTooltipMouseLeave() {
        if (this.isTooltipFocused()) return;
        this.isInteractingWithTooltip = false;
        this.lockService();
    }
    onTooltipFocusIn() {
        this.isInteractingWithTooltip = true;
    }
    isTooltipFocused() {
        const tooltipGui = this.tooltipComp?.getGui();
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return !!tooltipGui && tooltipGui.contains(activeEl);
    }
    onTooltipFocusOut(e) {
        const parentGui = this.tooltipCtrl.getGui();
        if (this.isTooltipFocused()) return;
        this.isInteractingWithTooltip = false;
        if (parentGui.contains(e.relatedTarget)) this.startHideTimeout();
        else this.hideTooltip();
    }
    positionTooltip() {
        const params = {
            type: "tooltip",
            ePopup: this.tooltipComp.getGui(),
            nudgeY: 18,
            skipObserver: this.tooltipMouseTrack
        };
        if (this.lastMouseEvent) this.popupSvc?.positionPopupUnderMouseEvent({
            ...params,
            mouseEvent: this.lastMouseEvent
        });
        else this.popupSvc?.positionPopupByComponent({
            ...params,
            eventSource: this.tooltipCtrl.getGui(),
            position: "under",
            keepWithinBounds: true,
            nudgeY: 5
        });
    }
    destroyTooltipComp() {
        this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
        const tooltipPopupDestroyFunc = this.tooltipPopupDestroyFunc;
        const tooltipComp = this.tooltipComp;
        const delay = this.tooltipTrigger === 0 /* HOVER */  ? $437b23f6a393c3bf$var$FADE_OUT_TOOLTIP_TIMEOUT : 0;
        window.setTimeout(()=>{
            tooltipPopupDestroyFunc();
            this.destroyBean(tooltipComp);
        }, delay);
        this.clearTooltipListeners();
        this.tooltipPopupDestroyFunc = void 0;
        this.tooltipComp = void 0;
    }
    clearTooltipListeners() {
        for (const listener of [
            this.tooltipMouseEnterListener,
            this.tooltipMouseLeaveListener,
            this.tooltipFocusInListener,
            this.tooltipFocusOutListener
        ])if (listener) listener();
        this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
    }
    lockService() {
        $437b23f6a393c3bf$var$isLocked = true;
        this.interactiveTooltipTimeoutId = window.setTimeout(()=>{
            this.unlockService();
            this.setToDoNothing();
        }, $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY);
    }
    unlockService() {
        $437b23f6a393c3bf$var$isLocked = false;
        this.clearInteractiveTimeout();
    }
    startHideTimeout() {
        this.clearHideTimeout();
        this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
    }
    clearShowTimeout() {
        if (!this.showTooltipTimeoutId) return;
        window.clearTimeout(this.showTooltipTimeoutId);
        this.showTooltipTimeoutId = void 0;
    }
    clearHideTimeout() {
        if (!this.hideTooltipTimeoutId) return;
        window.clearTimeout(this.hideTooltipTimeoutId);
        this.hideTooltipTimeoutId = void 0;
    }
    clearInteractiveTimeout() {
        if (!this.interactiveTooltipTimeoutId) return;
        window.clearTimeout(this.interactiveTooltipTimeoutId);
        this.interactiveTooltipTimeoutId = void 0;
    }
    clearTimeouts() {
        this.clearShowTimeout();
        this.clearHideTimeout();
        this.clearInteractiveTimeout();
    }
};
// packages/ag-grid-community/src/agStack/tooltip/agHighlightTooltipFeature.ts
var $437b23f6a393c3bf$var$AgHighlightTooltipFeature = class extends $437b23f6a393c3bf$export$e72bd8c9b85d3e72 {
    constructor(ctrl, highlightTracker, beans){
        super(ctrl, beans);
        this.highlightTracker = highlightTracker;
        this.onHighlight = this.onHighlight.bind(this);
    }
    postConstruct() {
        super.postConstruct();
        this.wireHighlightListeners();
    }
    wireHighlightListeners() {
        this.addManagedPropertyListener("tooltipTrigger", ({ currentValue: currentValue })=>{
            this.setTooltipMode(currentValue);
        });
        this.setTooltipMode(this.gos.get("tooltipTrigger"));
        this.highlightTracker.addEventListener("itemHighlighted", this.onHighlight);
    }
    onHighlight(event) {
        if (this.tooltipMode !== 1 /* FOCUS */ ) return;
        if (event.highlighted) this.attemptToShowTooltip();
        else this.attemptToHideTooltip();
    }
    setTooltipMode(tooltipTriggerMode = "focus") {
        this.tooltipMode = tooltipTriggerMode === "focus" ? 1 /* FOCUS */  : 0 /* HOVER */ ;
    }
    destroy() {
        this.highlightTracker.removeEventListener("itemHighlighted", this.onHighlight);
        super.destroy();
    }
};
// packages/ag-grid-community/src/agStack/popup/basePopupService.ts
var $437b23f6a393c3bf$var$instanceIdSeq = 0;
var $437b23f6a393c3bf$var$WAIT_FOR_POPUP_CONTENT_RESIZE = 200;
var $437b23f6a393c3bf$export$a5869429525f9944 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "popupSvc";
        this.popupList = [];
    }
    getPopupParent() {
        const ePopupParent = this.gos.get("popupParent");
        if (ePopupParent) return ePopupParent;
        return this.getDefaultPopupParent();
    }
    positionPopupUnderMouseEvent(params) {
        const { ePopup: ePopup, nudgeX: nudgeX, nudgeY: nudgeY, skipObserver: skipObserver } = params;
        this.positionPopup({
            ePopup: ePopup,
            nudgeX: nudgeX,
            nudgeY: nudgeY,
            keepWithinBounds: true,
            skipObserver: skipObserver,
            updatePosition: ()=>this.calculatePointerAlign(params.mouseEvent),
            postProcessCallback: ()=>this.callPostProcessPopup(params, params.type, params.ePopup, null, params.mouseEvent)
        });
    }
    calculatePointerAlign(e) {
        const parentRect = this.getParentRect();
        return {
            x: e.clientX - parentRect.left,
            y: e.clientY - parentRect.top
        };
    }
    positionPopupByComponent(params) {
        const { ePopup: ePopup, nudgeX: nudgeX, nudgeY: nudgeY, keepWithinBounds: keepWithinBounds, eventSource: eventSource, alignSide: alignSide = "left", position: position = "over", type: type } = params;
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        this.setAlignedTo(eventSource, ePopup);
        const updatePosition = ()=>{
            let x = sourceRect.left - parentRect.left;
            if (alignSide === "right") x -= ePopup.offsetWidth - sourceRect.width;
            let y;
            if (position === "over") {
                y = sourceRect.top - parentRect.top;
                this.setAlignedStyles(ePopup, "over");
            } else {
                this.setAlignedStyles(ePopup, "under");
                const alignSide2 = this.shouldRenderUnderOrAbove(ePopup, sourceRect, parentRect, params.nudgeY || 0);
                if (alignSide2 === "under") y = sourceRect.top - parentRect.top + sourceRect.height;
                else y = sourceRect.top - ePopup.offsetHeight - (nudgeY || 0) * 2 - parentRect.top;
            }
            return {
                x: x,
                y: y
            };
        };
        this.positionPopup({
            ePopup: ePopup,
            nudgeX: nudgeX,
            nudgeY: nudgeY,
            keepWithinBounds: keepWithinBounds,
            updatePosition: updatePosition,
            postProcessCallback: ()=>this.callPostProcessPopup(params, type, ePopup, eventSource, null)
        });
    }
    shouldRenderUnderOrAbove(ePopup, targetCompRect, parentRect, nudgeY) {
        const spaceAvailableUnder = parentRect.bottom - targetCompRect.bottom;
        const spaceAvailableAbove = targetCompRect.top - parentRect.top;
        const spaceRequired = ePopup.offsetHeight + nudgeY;
        if (spaceAvailableUnder > spaceRequired) return "under";
        if (spaceAvailableAbove > spaceRequired || spaceAvailableAbove > spaceAvailableUnder) return "above";
        return "under";
    }
    setAlignedStyles(ePopup, positioned) {
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx === -1) return;
        const popup = this.popupList[popupIdx];
        const { alignedToElement: alignedToElement } = popup;
        if (!alignedToElement) return;
        const positions = [
            "right",
            "left",
            "over",
            "above",
            "under"
        ];
        for (const position of positions){
            alignedToElement.classList.remove(`ag-has-popup-positioned-${position}`);
            ePopup.classList.remove(`ag-popup-positioned-${position}`);
        }
        if (!positioned) return;
        alignedToElement.classList.add(`ag-has-popup-positioned-${positioned}`);
        ePopup.classList.add(`ag-popup-positioned-${positioned}`);
    }
    setAlignedTo(eventSource, ePopup) {
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx !== -1) {
            const popup = this.popupList[popupIdx];
            popup.alignedToElement = eventSource;
        }
    }
    positionPopup(params) {
        const { ePopup: ePopup, keepWithinBounds: keepWithinBounds, nudgeX: nudgeX, nudgeY: nudgeY, skipObserver: skipObserver, updatePosition: updatePosition } = params;
        const lastSize = {
            width: 0,
            height: 0
        };
        const updatePopupPosition = (fromResizeObserver = false)=>{
            let { x: x, y: y } = updatePosition();
            if (fromResizeObserver && ePopup.clientWidth === lastSize.width && ePopup.clientHeight === lastSize.height) return;
            lastSize.width = ePopup.clientWidth;
            lastSize.height = ePopup.clientHeight;
            if (nudgeX) x += nudgeX;
            if (nudgeY) y += nudgeY;
            if (keepWithinBounds) {
                x = this.keepXYWithinBounds(ePopup, x, 1 /* Horizontal */ );
                y = this.keepXYWithinBounds(ePopup, y, 0 /* Vertical */ );
            }
            ePopup.style.left = `${x}px`;
            ePopup.style.top = `${y}px`;
            if (params.postProcessCallback) params.postProcessCallback();
        };
        updatePopupPosition();
        if (!skipObserver) {
            const resizeObserverDestroyFunc = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, ePopup, ()=>updatePopupPosition(true));
            setTimeout(()=>resizeObserverDestroyFunc(), $437b23f6a393c3bf$var$WAIT_FOR_POPUP_CONTENT_RESIZE);
        }
    }
    getParentRect() {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        let popupParent = this.getPopupParent();
        if (popupParent === eDocument.body) popupParent = eDocument.documentElement;
        else if (getComputedStyle(popupParent).position === "static") popupParent = popupParent.offsetParent;
        return $437b23f6a393c3bf$var$_getElementRectWithOffset(popupParent);
    }
    keepXYWithinBounds(ePopup, position, direction) {
        const isVertical = direction === 0 /* Vertical */ ;
        const sizeProperty = isVertical ? "clientHeight" : "clientWidth";
        const anchorProperty = isVertical ? "top" : "left";
        const offsetProperty = isVertical ? "height" : "width";
        const scrollPositionProperty = isVertical ? "scrollTop" : "scrollLeft";
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        const docElement = eDocument.documentElement;
        const popupParent = this.getPopupParent();
        const popupRect = ePopup.getBoundingClientRect();
        const parentRect = popupParent.getBoundingClientRect();
        const documentRect = eDocument.documentElement.getBoundingClientRect();
        const isBody = popupParent === eDocument.body;
        const offsetSize = Math.ceil(popupRect[offsetProperty]);
        const getSize2 = isVertical ? $437b23f6a393c3bf$export$d23c22492e0f7c0c : $437b23f6a393c3bf$export$642efcb17474eb51;
        let sizeOfParent = isBody ? getSize2(docElement) + docElement[scrollPositionProperty] : popupParent[sizeProperty];
        if (isBody) sizeOfParent -= Math.abs(documentRect[anchorProperty] - parentRect[anchorProperty]);
        const max = sizeOfParent - offsetSize;
        return Math.min(Math.max(position, 0), Math.max(max, 0));
    }
    addPopup(params) {
        const { eChild: eChild, ariaLabel: ariaLabel, ariaOwns: ariaOwns, alwaysOnTop: alwaysOnTop, positionCallback: positionCallback, anchorToElement: anchorToElement } = params;
        const pos = this.getPopupIndex(eChild);
        if (pos !== -1) {
            const popup = this.popupList[pos];
            return {
                hideFunc: popup.hideFunc
            };
        }
        this.initialisePopupPosition(eChild);
        const wrapperEl = this.createPopupWrapper(eChild, !!alwaysOnTop, ariaLabel, ariaOwns);
        const removeListeners = this.addEventListenersToPopup({
            ...params,
            wrapperEl: wrapperEl
        });
        if (positionCallback) positionCallback();
        this.addPopupToPopupList(eChild, wrapperEl, removeListeners, anchorToElement);
        return {
            hideFunc: removeListeners
        };
    }
    initialisePopupPosition(element) {
        const ePopupParent = this.getPopupParent();
        const ePopupParentRect = ePopupParent.getBoundingClientRect();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(element.style.top)) element.style.top = `${ePopupParentRect.top * -1}px`;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(element.style.left)) element.style.left = `${ePopupParentRect.left * -1}px`;
    }
    createPopupWrapper(element, alwaysOnTop, ariaLabel, ariaOwns) {
        const ePopupParent = this.getPopupParent();
        const { environment: environment, gos: gos } = this.beans;
        const eWrapper = $437b23f6a393c3bf$export$378bc9c64290bc8b({
            tag: "div"
        });
        environment.applyThemeClasses(eWrapper);
        eWrapper.classList.add("ag-popup");
        element.classList.add(gos.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child");
        if (!element.hasAttribute("role")) $437b23f6a393c3bf$export$f8d01fa01787902(element, "dialog");
        if (ariaLabel) $437b23f6a393c3bf$export$e81cb0dd07f289f6(element, ariaLabel);
        else if (ariaOwns) {
            element.id || (element.id = `popup-component-${$437b23f6a393c3bf$var$instanceIdSeq}`);
            $437b23f6a393c3bf$var$_setAriaOwns(ariaOwns, element.id);
        }
        eWrapper.appendChild(element);
        ePopupParent.appendChild(eWrapper);
        if (alwaysOnTop) this.setAlwaysOnTop(element, true);
        else this.bringPopupToFront(element);
        return eWrapper;
    }
    addEventListenersToPopup(params) {
        const beans = this.beans;
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        const { wrapperEl: wrapperEl, eChild: popupEl, closedCallback: closedCallback, afterGuiAttached: afterGuiAttached, closeOnEsc: closeOnEsc, modal: modal, ariaOwns: ariaOwns } = params;
        let popupHidden = false;
        const hidePopupOnKeyboardEvent = (event)=>{
            if (!wrapperEl.contains($437b23f6a393c3bf$export$16bc98d422315038(beans))) return;
            const key = event.key;
            if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE && !this.isStopPropagation(event)) removeListeners({
                keyboardEvent: event
            });
        };
        const hidePopupOnMouseEvent = (event)=>removeListeners({
                mouseEvent: event
            });
        const hidePopupOnTouchEvent = (event)=>removeListeners({
                touchEvent: event
            });
        const removeListeners = (popupParams = {})=>{
            const { mouseEvent: mouseEvent, touchEvent: touchEvent, keyboardEvent: keyboardEvent, forceHide: forceHide } = popupParams;
            if (!forceHide && // we don't hide popup if the event was on the child, or any
            // children of this child
            (this.isEventFromCurrentPopup({
                mouseEvent: mouseEvent,
                touchEvent: touchEvent
            }, popupEl) || // this method should only be called once. the client can have different
            // paths, each one wanting to close, so this method may be called multiple times.
            popupHidden)) return;
            popupHidden = true;
            wrapperEl.remove();
            eDocument.removeEventListener("keydown", hidePopupOnKeyboardEvent);
            eDocument.removeEventListener("mousedown", hidePopupOnMouseEvent);
            eDocument.removeEventListener("touchstart", hidePopupOnTouchEvent);
            eDocument.removeEventListener("contextmenu", hidePopupOnMouseEvent);
            this.eventSvc.removeListener("dragStarted", hidePopupOnMouseEvent);
            if (closedCallback) closedCallback(mouseEvent || touchEvent || keyboardEvent);
            this.removePopupFromPopupList(popupEl, ariaOwns);
        };
        if (afterGuiAttached) afterGuiAttached({
            hidePopup: removeListeners
        });
        window.setTimeout(()=>{
            if (closeOnEsc) eDocument.addEventListener("keydown", hidePopupOnKeyboardEvent);
            if (modal) {
                eDocument.addEventListener("mousedown", hidePopupOnMouseEvent);
                this.eventSvc.addListener("dragStarted", hidePopupOnMouseEvent);
                eDocument.addEventListener("touchstart", hidePopupOnTouchEvent);
                eDocument.addEventListener("contextmenu", hidePopupOnMouseEvent);
            }
        }, 0);
        return removeListeners;
    }
    addPopupToPopupList(element, wrapperEl, removeListeners, anchorToElement) {
        this.popupList.push({
            element: element,
            wrapper: wrapperEl,
            hideFunc: removeListeners,
            instanceId: $437b23f6a393c3bf$var$instanceIdSeq,
            isAnchored: !!anchorToElement
        });
        if (anchorToElement) this.setPopupPositionRelatedToElement(element, anchorToElement);
        $437b23f6a393c3bf$var$instanceIdSeq = $437b23f6a393c3bf$var$instanceIdSeq + 1;
    }
    getPopupIndex(el) {
        return this.popupList.findIndex((p)=>p.element === el);
    }
    setPopupPositionRelatedToElement(popupEl, relativeElement) {
        const popupIndex = this.getPopupIndex(popupEl);
        if (popupIndex === -1) return;
        const popup = this.popupList[popupIndex];
        if (popup.stopAnchoringPromise) popup.stopAnchoringPromise.then((destroyFunc)=>destroyFunc && destroyFunc());
        popup.stopAnchoringPromise = void 0;
        popup.isAnchored = false;
        if (!relativeElement) return;
        const destroyPositionTracker = this.keepPopupPositionedRelativeTo({
            element: relativeElement,
            ePopup: popupEl,
            hidePopup: popup.hideFunc
        });
        popup.stopAnchoringPromise = destroyPositionTracker;
        popup.isAnchored = true;
        return destroyPositionTracker;
    }
    removePopupFromPopupList(element, ariaOwns) {
        this.setAlignedStyles(element, null);
        this.setPopupPositionRelatedToElement(element, null);
        if (ariaOwns) $437b23f6a393c3bf$var$_setAriaOwns(ariaOwns, null);
        this.popupList = this.popupList.filter((p)=>p.element !== element);
    }
    keepPopupPositionedRelativeTo(params) {
        const eParent = this.getPopupParent();
        const parentRect = eParent.getBoundingClientRect();
        const { element: element, ePopup: ePopup } = params;
        const sourceRect = element.getBoundingClientRect();
        const extractFromPixelValue = (pxSize)=>Number.parseInt(pxSize.substring(0, pxSize.length - 1), 10);
        const createPosition = (prop, direction)=>{
            const initialDiff = parentRect[prop] - sourceRect[prop];
            const initial = extractFromPixelValue(ePopup.style[prop]);
            return {
                initialDiff: initialDiff,
                lastDiff: initialDiff,
                initial: initial,
                last: initial,
                direction: direction
            };
        };
        const topPosition = createPosition("top", 0 /* Vertical */ );
        const leftPosition = createPosition("left", 1 /* Horizontal */ );
        const fwOverrides = this.beans.frameworkOverrides;
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            fwOverrides.wrapIncoming(()=>{
                $437b23f6a393c3bf$var$_wrapInterval(()=>{
                    const pRect = eParent.getBoundingClientRect();
                    const sRect = element.getBoundingClientRect();
                    const elementNotInDom = sRect.top == 0 && sRect.left == 0 && sRect.height == 0 && sRect.width == 0;
                    if (elementNotInDom) {
                        params.hidePopup();
                        return;
                    }
                    const calculateNewPosition = (position, prop)=>{
                        const current = extractFromPixelValue(ePopup.style[prop]);
                        if (position.last !== current) {
                            position.initial = current;
                            position.last = current;
                        }
                        const currentDiff = pRect[prop] - sRect[prop];
                        if (currentDiff != position.lastDiff) {
                            const newValue = this.keepXYWithinBounds(ePopup, position.initial + position.initialDiff - currentDiff, position.direction);
                            ePopup.style[prop] = `${newValue}px`;
                            position.last = newValue;
                        }
                        position.lastDiff = currentDiff;
                    };
                    calculateNewPosition(topPosition, "top");
                    calculateNewPosition(leftPosition, "left");
                }, 200).then((intervalId)=>{
                    const result = ()=>{
                        if (intervalId != null) window.clearInterval(intervalId);
                    };
                    resolve(result);
                });
            }, "popupPositioning");
        });
    }
    isEventFromCurrentPopup(params, target) {
        const { mouseEvent: mouseEvent, touchEvent: touchEvent } = params;
        const event = mouseEvent ? mouseEvent : touchEvent;
        if (!event) return false;
        const indexOfThisChild = this.getPopupIndex(target);
        if (indexOfThisChild === -1) return false;
        for(let i = indexOfThisChild; i < this.popupList.length; i++){
            const popup = this.popupList[i];
            if ($437b23f6a393c3bf$export$b5446458166e97b4(popup.element, event)) return true;
        }
        return this.isElementWithinCustomPopup(event.target);
    }
    isElementWithinCustomPopup(el) {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        while(el && el !== eDocument.body){
            if (el.classList.contains("ag-custom-component-popup") || el.parentElement === null) return true;
            el = el.parentElement;
        }
        return false;
    }
    getWrapper(ePopup) {
        while(!ePopup.classList.contains("ag-popup") && ePopup.parentElement)ePopup = ePopup.parentElement;
        return ePopup.classList.contains("ag-popup") ? ePopup : null;
    }
    setAlwaysOnTop(ePopup, alwaysOnTop) {
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper) return;
        eWrapper.classList.toggle("ag-always-on-top", !!alwaysOnTop);
        if (alwaysOnTop) this.bringPopupToFront(eWrapper);
    }
    /** @returns true if moved */ bringPopupToFront(ePopup) {
        const parent = this.getPopupParent();
        const popupList = Array.prototype.slice.call(parent.querySelectorAll(".ag-popup"));
        const popupLen = popupList.length;
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) return;
        const standardPopupList = [];
        const alwaysOnTopList = [];
        for (const popup of popupList){
            if (popup === eWrapper) continue;
            if (popup.classList.contains("ag-always-on-top")) alwaysOnTopList.push(popup);
            else standardPopupList.push(popup);
        }
        const innerElsScrollMap = [];
        const onTopLength = alwaysOnTopList.length;
        const isPopupAlwaysOnTop = eWrapper.classList.contains("ag-always-on-top");
        const shouldBeLast = isPopupAlwaysOnTop || !onTopLength;
        const targetList = shouldBeLast ? [
            ...standardPopupList,
            ...alwaysOnTopList,
            eWrapper
        ] : [
            ...standardPopupList,
            eWrapper,
            ...alwaysOnTopList
        ];
        for(let i = 0; i <= popupLen; i++){
            const currentPopup = targetList[i];
            if (popupList[i] === targetList[i] || currentPopup === eWrapper) continue;
            const innerEls = currentPopup.querySelectorAll("div");
            for (const el of innerEls)if (el.scrollTop !== 0) innerElsScrollMap.push([
                el,
                el.scrollTop
            ]);
            if (i === 0) parent.insertAdjacentElement("afterbegin", currentPopup);
            else targetList[i - 1].insertAdjacentElement("afterend", currentPopup);
        }
        while(innerElsScrollMap.length){
            const currentEl = innerElsScrollMap.pop();
            currentEl[0].scrollTop = currentEl[1];
        }
    }
};
// packages/ag-grid-community/src/agStack/tooltip/agTooltipComponent.ts
var $437b23f6a393c3bf$export$7347ac91f8ec5988 = class extends $437b23f6a393c3bf$export$acd471c9223f27ae {
    constructor(){
        super({
            tag: "div",
            cls: "ag-tooltip"
        });
    }
    // will need to type params
    init(params) {
        const { value: value } = params;
        const eGui = this.getGui();
        eGui.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(value);
        const locationKebabCase = params.location.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
        eGui.classList.add(`ag-${locationKebabCase}-tooltip`);
    }
};
// packages/ag-grid-community/src/agStack/events/pointerCapture.ts
var $437b23f6a393c3bf$var$tryPointerCapture = (eElement, pointerId)=>{
    if (pointerId != null && eElement?.setPointerCapture) try {
        eElement.setPointerCapture(pointerId);
        return eElement.hasPointerCapture(pointerId);
    } catch  {}
    return false;
};
var $437b23f6a393c3bf$var$capturePointer = (eElement, mouseEvent)=>{
    if (typeof PointerEvent === "undefined" || !(mouseEvent instanceof PointerEvent)) return null;
    const pointerId = mouseEvent.pointerId;
    if (!$437b23f6a393c3bf$var$tryPointerCapture(eElement, pointerId)) return null;
    const capture = {
        eElement: eElement,
        pointerId: pointerId,
        onLost (pointerEvent) {
            $437b23f6a393c3bf$var$pointerLostHandler(capture, pointerEvent);
        }
    };
    eElement.addEventListener("lostpointercapture", capture.onLost);
    return capture;
};
var $437b23f6a393c3bf$var$releasePointerCapture = (capture)=>{
    if (!capture) return;
    $437b23f6a393c3bf$var$removeLostHandler(capture);
    const { eElement: eElement, pointerId: pointerId } = capture;
    if (!eElement) return;
    try {
        eElement.releasePointerCapture(pointerId);
    } catch  {}
    capture.eElement = null;
};
var $437b23f6a393c3bf$var$removeLostHandler = (capture)=>{
    const { eElement: eElement, onLost: onLost } = capture;
    if (eElement && onLost) {
        eElement.removeEventListener("lostpointercapture", onLost);
        capture.onLost = null;
    }
};
var $437b23f6a393c3bf$var$pointerLostHandler = (capture, pointerEvent)=>{
    $437b23f6a393c3bf$var$removeLostHandler(capture);
    const { eElement: eElement, pointerId: pointerId } = capture;
    if (eElement && pointerEvent.pointerId === pointerId) $437b23f6a393c3bf$var$tryPointerCapture(eElement, pointerId);
};
// packages/ag-grid-community/src/agStack/core/baseDragService.ts
var $437b23f6a393c3bf$var$activePointerDrags;
var $437b23f6a393c3bf$var$handledDragEvents;
var $437b23f6a393c3bf$var$addHandledDragEvent = (event)=>{
    if (!$437b23f6a393c3bf$var$handledDragEvents) $437b23f6a393c3bf$var$handledDragEvents = /* @__PURE__ */ new WeakSet();
    else if ($437b23f6a393c3bf$var$handledDragEvents.has(event)) return false;
    $437b23f6a393c3bf$var$handledDragEvents.add(event);
    return true;
};
var $437b23f6a393c3bf$export$746301531a60a666 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "dragSvc";
        this.dragging = false;
        this.drag = null;
        this.dragSources = [];
    }
    get startTarget() {
        return this.drag?.start.target ?? null;
    }
    /** True if there is at least one active pointer drag in any BaseDragService instance in the page */ isPointer() {
        return !!$437b23f6a393c3bf$var$activePointerDrags?.has($437b23f6a393c3bf$export$1911dd00c79744c0(this.beans));
    }
    hasPointerCapture() {
        const capture = this.drag?.pointerCapture;
        return !!(capture && this.beans.eRootDiv.hasPointerCapture?.(capture.pointerId));
    }
    destroy() {
        if (this.drag) this.cancelDrag();
        const dragSources = this.dragSources;
        for (const entry of dragSources)$437b23f6a393c3bf$var$destroyDragSourceEntry(entry);
        dragSources.length = 0;
        super.destroy();
    }
    removeDragSource(params) {
        const dragSources = this.dragSources;
        for(let i = 0, len = dragSources.length; i < len; ++i){
            const entry = dragSources[i];
            if (entry.params === params) {
                dragSources.splice(i, 1);
                $437b23f6a393c3bf$var$destroyDragSourceEntry(entry);
                break;
            }
        }
    }
    addDragSource(params) {
        if (!this.isAlive()) return;
        const { eElement: eElement, includeTouch: includeTouch } = params;
        const handlers = [];
        let oldTouchAction;
        if (includeTouch) {
            const style = eElement.style;
            if (style) {
                oldTouchAction = style.touchAction;
                style.touchAction = "none";
            }
        }
        const dragSource = {
            handlers: handlers,
            params: params,
            oldTouchAction: oldTouchAction
        };
        this.dragSources.push(dragSource);
        const pointerDownListener = (event)=>this.onPointerDown(params, event);
        const mouseListener = (event)=>this.onMouseDown(params, event);
        $437b23f6a393c3bf$var$addTempEventHandlers(handlers, [
            eElement,
            "pointerdown",
            pointerDownListener,
            {
                passive: false
            }
        ], [
            eElement,
            "mousedown",
            mouseListener
        ]);
        const suppressTouch = this.gos.get("suppressTouch");
        if (includeTouch && !suppressTouch) {
            const touchListener = (touchEvent)=>this.onTouchStart(params, touchEvent);
            $437b23f6a393c3bf$var$addTempEventHandlers(handlers, [
                eElement,
                "touchstart",
                touchListener,
                {
                    passive: false
                }
            ]);
        }
    }
    cancelDrag(eElement) {
        const drag = this.drag;
        eElement ?? (eElement = drag?.eElement);
        if (eElement) this.eventSvc.dispatchEvent({
            type: "dragCancelled",
            target: eElement
        });
        drag?.params.onDragCancel?.();
        this.destroyDrag();
    }
    shouldPreventMouseEvent(mouseEvent) {
        const type = mouseEvent.type;
        const isMouseMove = type === "mousemove" || type === "pointermove";
        return isMouseMove && mouseEvent.cancelable && $437b23f6a393c3bf$var$_isEventFromThisInstance(this.beans, mouseEvent) && !$437b23f6a393c3bf$var$_isFocusableFormField($437b23f6a393c3bf$var$getEventTargetElement(mouseEvent));
    }
    initDrag(drag, ...handlers) {
        this.drag = drag;
        const beans = this.beans;
        const onScroll = (event)=>this.onScroll(event);
        const keydownEvent = (ev)=>this.onKeyDown(ev);
        const rootEl = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        $437b23f6a393c3bf$var$addTempEventHandlers(drag.handlers, [
            rootEl,
            "contextmenu",
            $437b23f6a393c3bf$var$preventEventDefault
        ], [
            rootEl,
            "keydown",
            keydownEvent
        ], [
            eDocument,
            "scroll",
            onScroll,
            {
                capture: true
            }
        ], [
            eDocument.defaultView || window,
            "scroll",
            onScroll
        ], ...handlers);
    }
    destroyDrag() {
        this.dragging = false;
        const drag = this.drag;
        if (drag) {
            const rootEl = drag.rootEl;
            if ($437b23f6a393c3bf$var$activePointerDrags?.get(rootEl) === drag) $437b23f6a393c3bf$var$activePointerDrags?.delete(rootEl);
            this.drag = null;
            $437b23f6a393c3bf$var$releasePointerCapture(drag.pointerCapture);
            $437b23f6a393c3bf$var$clearTempEventHandlers(drag.handlers);
        }
    }
    // Pointer Events path (preferred when supported)
    onPointerDown(params, pointerEvent) {
        if (this.isPointer()) return;
        const beans = this.beans;
        if ($437b23f6a393c3bf$var$handledDragEvents?.has(pointerEvent)) return;
        const pointerType = pointerEvent.pointerType;
        if (pointerType === "touch") {
            if (beans.gos.get("suppressTouch") || !params.includeTouch) return;
            if (params.stopPropagationForTouch) pointerEvent.stopPropagation();
            if ($437b23f6a393c3bf$var$_isFocusableFormField($437b23f6a393c3bf$var$getEventTargetElement(pointerEvent))) return;
        }
        if (!pointerEvent.isPrimary) return;
        if (pointerType === "mouse" && pointerEvent.button !== 0) return;
        this.destroyDrag();
        const rootEl = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const eElement = params.eElement;
        const pointerId = pointerEvent.pointerId;
        const pointerDrag = new $437b23f6a393c3bf$var$Dragging(rootEl, params, pointerEvent, pointerId);
        $437b23f6a393c3bf$var$activePointerDrags ?? ($437b23f6a393c3bf$var$activePointerDrags = /* @__PURE__ */ new WeakMap());
        $437b23f6a393c3bf$var$activePointerDrags.set(rootEl, pointerDrag);
        const onPointerMove = (ev)=>{
            if (ev.pointerId === pointerId) this.onMouseOrPointerMove(ev);
        };
        const onUp = (ev)=>{
            if (ev.pointerId === pointerId) this.onMouseOrPointerUp(ev);
        };
        const onCancel = (ev)=>{
            if (ev.pointerId === pointerId && $437b23f6a393c3bf$var$addHandledDragEvent(ev)) this.cancelDrag();
        };
        this.initDrag(pointerDrag, [
            rootEl,
            "pointerup",
            onUp
        ], [
            rootEl,
            "pointercancel",
            onCancel
        ], [
            rootEl,
            "pointermove",
            onPointerMove,
            {
                passive: false
            }
        ], [
            rootEl,
            "touchmove",
            $437b23f6a393c3bf$var$preventEventDefault,
            {
                passive: false
            }
        ], [
            eElement,
            "mousemove",
            $437b23f6a393c3bf$var$preventEventDefault,
            {
                passive: false
            }
        ]);
        if (params.dragStartPixels === 0) this.onMouseOrPointerMove(pointerEvent);
        else $437b23f6a393c3bf$var$addHandledDragEvent(pointerEvent);
    }
    // gets called whenever mouse down on any drag source
    onTouchStart(params, touchEvent) {
        const suppressTouch = this.gos.get("suppressTouch");
        if (suppressTouch || !params.includeTouch) return;
        if (!$437b23f6a393c3bf$var$addHandledDragEvent(touchEvent)) return;
        if ($437b23f6a393c3bf$var$_isFocusableFormField($437b23f6a393c3bf$var$getEventTargetElement(touchEvent))) return;
        if (params.stopPropagationForTouch) touchEvent.stopPropagation();
        if (this.isPointer()) {
            $437b23f6a393c3bf$var$preventEventDefault(touchEvent);
            return;
        }
        this.destroyDrag();
        const beans = this.beans;
        const rootEl = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const touchDrag = new $437b23f6a393c3bf$var$Dragging(rootEl, params, touchEvent.touches[0]);
        const touchMoveEvent = (e)=>this.onTouchMove(e);
        const touchEndEvent = (e)=>this.onTouchUp(e);
        const target = touchEvent.target ?? params.eElement;
        this.initDrag(touchDrag, [
            $437b23f6a393c3bf$export$1911dd00c79744c0(beans),
            "touchmove",
            $437b23f6a393c3bf$var$preventEventDefault,
            {
                passive: false
            }
        ], [
            target,
            "touchmove",
            touchMoveEvent,
            {
                passive: true
            }
        ], [
            target,
            "touchend",
            touchEndEvent,
            {
                passive: true
            }
        ], [
            target,
            "touchcancel",
            touchEndEvent,
            {
                passive: true
            }
        ]);
        if (params.dragStartPixels === 0) this.onMove(touchDrag.start);
    }
    // gets called whenever mouse down on any drag source
    onMouseDown(params, mouseEvent) {
        if (mouseEvent.button !== 0) return;
        if ($437b23f6a393c3bf$var$handledDragEvents?.has(mouseEvent)) return;
        if (this.isPointer()) return;
        const beans = this.beans;
        this.destroyDrag();
        const mouseDrag = new $437b23f6a393c3bf$var$Dragging($437b23f6a393c3bf$export$1911dd00c79744c0(beans), params, mouseEvent);
        const mouseMoveEvent = (event)=>this.onMouseOrPointerMove(event);
        const mouseUpEvent = (event)=>this.onMouseOrPointerUp(event);
        const target = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        this.initDrag(mouseDrag, [
            target,
            "mousemove",
            mouseMoveEvent
        ], [
            target,
            "mouseup",
            mouseUpEvent
        ]);
        if (params.dragStartPixels === 0) this.onMouseOrPointerMove(mouseEvent);
        else $437b23f6a393c3bf$var$addHandledDragEvent(mouseEvent);
    }
    onScroll(event) {
        if (!$437b23f6a393c3bf$var$addHandledDragEvent(event)) return;
        const drag = this.drag;
        const lastDrag = drag?.lastDrag;
        if (lastDrag && this.dragging) drag.params?.onDragging(lastDrag);
    }
    /** only gets called after a mouse down - as this is only added after mouseDown and is removed when mouseUp happens */ onMouseOrPointerMove(mouseEvent) {
        if (!$437b23f6a393c3bf$var$addHandledDragEvent(mouseEvent)) return;
        if ($437b23f6a393c3bf$export$8caf403dacd36a68()) $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans).getSelection()?.removeAllRanges();
        if (this.shouldPreventMouseEvent(mouseEvent)) $437b23f6a393c3bf$var$preventEventDefault(mouseEvent);
        this.onMove(mouseEvent);
    }
    onTouchMove(touchEvent) {
        const drag = this.drag;
        if (!drag || !$437b23f6a393c3bf$var$addHandledDragEvent(touchEvent)) return;
        const touch = $437b23f6a393c3bf$var$_getFirstActiveTouch(drag.start, touchEvent.touches);
        if (touch) {
            touchEvent.preventDefault();
            this.onMove(touch);
        }
    }
    onMove(currentEvent) {
        const drag = this.drag;
        if (!drag) return;
        drag.lastDrag = currentEvent;
        const dragSource = drag.params;
        if (!this.dragging) {
            const start = drag.start;
            const dragStartPixels = dragSource.dragStartPixels;
            const requiredPixelDiff = dragStartPixels ?? 4;
            if ($437b23f6a393c3bf$var$_areEventsNear(currentEvent, start, requiredPixelDiff)) return;
            this.dragging = true;
            if (dragSource.capturePointer) drag.pointerCapture = $437b23f6a393c3bf$var$capturePointer(this.beans.eRootDiv, currentEvent);
            this.eventSvc.dispatchEvent({
                type: "dragStarted",
                target: dragSource.eElement
            });
            dragSource.onDragStart(start);
            if (this.drag !== drag) return;
            dragSource.onDragging(start);
            if (this.drag !== drag) return;
        }
        dragSource.onDragging(currentEvent);
    }
    onTouchUp(touchEvent) {
        const drag = this.drag;
        if (drag && $437b23f6a393c3bf$var$addHandledDragEvent(touchEvent)) this.onUp($437b23f6a393c3bf$var$_getFirstActiveTouch(drag.start, touchEvent.changedTouches));
    }
    onMouseOrPointerUp(mouseEvent) {
        if ($437b23f6a393c3bf$var$addHandledDragEvent(mouseEvent)) this.onUp(mouseEvent);
    }
    onUp(eventOrTouch) {
        const drag = this.drag;
        if (!drag) return;
        if (!eventOrTouch) eventOrTouch = drag.lastDrag;
        if (eventOrTouch && this.dragging) {
            this.dragging = false;
            drag.params.onDragStop(eventOrTouch);
            this.eventSvc.dispatchEvent({
                type: "dragStopped",
                target: drag.params.eElement
            });
        }
        this.destroyDrag();
    }
    // shared keydown handler to cancel current drag with ESC
    onKeyDown(event) {
        if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE) this.cancelDrag();
    }
};
var $437b23f6a393c3bf$var$destroyDragSourceEntry = (dragSource)=>{
    $437b23f6a393c3bf$var$clearTempEventHandlers(dragSource.handlers);
    const oldTouchAction = dragSource.oldTouchAction;
    if (oldTouchAction != null) {
        const style = dragSource.params.eElement.style;
        if (style) style.touchAction = oldTouchAction;
    }
};
var $437b23f6a393c3bf$var$Dragging = class {
    constructor(rootEl, params, start, pointerId = null){
        this.rootEl = rootEl;
        this.params = params;
        this.start = start;
        this.pointerId = pointerId;
        this.handlers = [];
        this.lastDrag = null;
        this.pointerCapture = null;
        this.eElement = params.eElement;
    }
};
var $437b23f6a393c3bf$var$getEventTargetElement = (event)=>{
    const target = event.target;
    return target instanceof Element ? target : null;
};
// packages/ag-grid-community/src/agStack/core/baseDragAndDropService.ts
var $437b23f6a393c3bf$export$95d9806a07659825 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "dragAndDrop";
        this.dragSourceAndParamsList = [];
        this.dragItem = null;
        this.dragInitialSourcePointerOffsetX = 0;
        this.dragInitialSourcePointerOffsetY = 0;
        this.lastMouseEvent = null;
        this.lastDraggingEvent = null;
        this.dragSource = null;
        this.dragImageParent = null;
        this.dragImageCompPromise = null;
        this.dragImageComp = null;
        this.dragImageLastIcon = void 0;
        this.dragImageLastLabel = void 0;
        this.dropTargets = [];
        this.lastDropTarget = null;
    }
    addDragSource(dragSource, allowTouch = false) {
        const entry = {
            capturePointer: true,
            dragSource: dragSource,
            eElement: dragSource.eElement,
            dragStartPixels: dragSource.dragStartPixels,
            onDragStart: (mouseEvent)=>this.onDragStart(dragSource, mouseEvent),
            onDragStop: this.onDragStop.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragCancel: this.onDragCancel.bind(this),
            includeTouch: allowTouch
        };
        this.dragSourceAndParamsList.push(entry);
        this.beans.dragSvc.addDragSource(entry);
    }
    setDragImageCompIcon(iconName, shake = false) {
        const component = this.dragImageComp;
        if (component && (shake || this.dragImageLastIcon !== iconName)) {
            this.dragImageLastIcon = iconName;
            component.setIcon(iconName, shake);
        }
    }
    removeDragSource(dragSource) {
        const { dragSourceAndParamsList: dragSourceAndParamsList, beans: beans } = this;
        const sourceAndParams = dragSourceAndParamsList.find((item)=>item.dragSource === dragSource);
        if (sourceAndParams) {
            beans.dragSvc?.removeDragSource(sourceAndParams);
            $437b23f6a393c3bf$export$83a881c8b5120679(dragSourceAndParamsList, sourceAndParams);
        }
    }
    destroy() {
        const { dragSourceAndParamsList: dragSourceAndParamsList, dropTargets: dropTargets, beans: beans } = this;
        const dragSvc = beans.dragSvc;
        for (const sourceAndParams of dragSourceAndParamsList)dragSvc?.removeDragSource(sourceAndParams);
        dragSourceAndParamsList.length = 0;
        dropTargets.length = 0;
        this.clearDragAndDropProperties();
        super.destroy();
    }
    nudge() {
        const lastMouseEvent = this.lastMouseEvent;
        if (lastMouseEvent) this.onDragging(lastMouseEvent, true);
    }
    onDragStart(dragSource, mouseEvent) {
        this.lastMouseEvent = mouseEvent;
        this.dragSource = dragSource;
        this.dragItem = dragSource.getDragItem();
        const rect = dragSource.eElement.getBoundingClientRect();
        this.dragInitialSourcePointerOffsetX = mouseEvent.clientX - rect.left;
        this.dragInitialSourcePointerOffsetY = mouseEvent.clientY - rect.top;
        dragSource.onDragStarted?.();
        this.createAndUpdateDragImageComp(dragSource);
    }
    onDragStop(mouseEvent) {
        const { dragSource: dragSource, lastDropTarget: lastDropTarget } = this;
        dragSource?.onDragStopped?.();
        if (lastDropTarget) {
            const dragEndEvent = this.dropTargetEvent(lastDropTarget, mouseEvent, false);
            lastDropTarget.onDragStop?.(dragEndEvent);
        }
        this.clearDragAndDropProperties();
    }
    onDragCancel() {
        const { dragSource: dragSource, lastDropTarget: lastDropTarget, lastMouseEvent: lastMouseEvent } = this;
        dragSource?.onDragCancelled?.();
        if (lastDropTarget && lastMouseEvent) {
            const dragCancelEvent = this.dropTargetEvent(lastDropTarget, lastMouseEvent, false);
            lastDropTarget.onDragCancel?.(dragCancelEvent);
        }
        this.clearDragAndDropProperties();
    }
    onDragging(mouseEvent, fromNudge = false) {
        this.positionDragImageComp(mouseEvent);
        const dropTarget = this.findCurrentDropTarget(mouseEvent);
        const { lastDropTarget: lastDropTarget, dragSource: dragSource, dragItem: dragItem } = this;
        let needUpdate = false;
        if (dropTarget !== lastDropTarget) {
            needUpdate = true;
            if (lastDropTarget) {
                const dragLeaveEvent = this.dropTargetEvent(lastDropTarget, mouseEvent, fromNudge);
                lastDropTarget.onDragLeave?.(dragLeaveEvent);
            }
            if (lastDropTarget !== null && !dropTarget) this.handleExit(dragSource, dragItem);
            else if (lastDropTarget === null && dropTarget) this.handleEnter(dragSource, dragItem);
            if (dropTarget) {
                const dragEnterEvent = this.dropTargetEvent(dropTarget, mouseEvent, fromNudge);
                dropTarget.onDragEnter?.(dragEnterEvent);
            }
            this.lastDropTarget = dropTarget;
        } else if (dropTarget) {
            const dragMoveEvent = this.dropTargetEvent(dropTarget, mouseEvent, fromNudge);
            dropTarget.onDragging?.(dragMoveEvent);
            if (dragMoveEvent?.changed) needUpdate = true;
        }
        this.lastMouseEvent = mouseEvent;
        if (needUpdate) this.updateDragImageComp();
    }
    clearDragAndDropProperties() {
        this.removeDragImageComp(this.dragImageComp);
        this.dragImageCompPromise = null;
        this.dragImageParent = null;
        this.dragImageLastIcon = void 0;
        this.dragImageLastLabel = void 0;
        this.lastMouseEvent = null;
        this.lastDraggingEvent = null;
        this.lastDropTarget = null;
        this.dragItem = null;
        this.dragInitialSourcePointerOffsetX = 0;
        this.dragInitialSourcePointerOffsetY = 0;
        this.dragSource = null;
    }
    getAllContainersFromDropTarget(dropTarget) {
        const secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
        const containers = [
            [
                dropTarget.getContainer()
            ]
        ];
        return secondaryContainers ? containers.concat(secondaryContainers) : containers;
    }
    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
    isMouseOnDropTarget(mouseEvent, dropTarget) {
        const allContainersFromDropTarget = this.getAllContainersFromDropTarget(dropTarget);
        let mouseOverTarget = false;
        const allContainersIntersect = (mouseEvent2, containers)=>{
            for (const container of containers){
                const { width: width, height: height, left: left, right: right, top: top, bottom: bottom } = container.getBoundingClientRect();
                if (width === 0 || height === 0) return false;
                const horizontalFit = mouseEvent2.clientX >= left && mouseEvent2.clientX < right;
                const verticalFit = mouseEvent2.clientY >= top && mouseEvent2.clientY < bottom;
                if (!horizontalFit || !verticalFit) return false;
            }
            return true;
        };
        for (const currentContainers of allContainersFromDropTarget)if (allContainersIntersect(mouseEvent, currentContainers)) {
            mouseOverTarget = true;
            break;
        }
        const { eElement: eElement, type: type } = this.dragSource;
        if (dropTarget.targetContainsSource && !dropTarget.getContainer().contains(eElement)) return false;
        return mouseOverTarget && dropTarget.isInterestedIn(type, eElement);
    }
    findCurrentDropTarget(mouseEvent) {
        const validDropTargets = this.dropTargets.filter((target)=>this.isMouseOnDropTarget(mouseEvent, target));
        const len = validDropTargets.length;
        if (len === 0) return null;
        if (len === 1) return validDropTargets[0];
        const rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans);
        const elementStack = rootNode.elementsFromPoint(mouseEvent.clientX, mouseEvent.clientY);
        for (const el of elementStack)for (const dropTarget of validDropTargets){
            const containers = this.getAllContainersFromDropTarget(dropTarget).flatMap((a)=>a);
            if (containers.indexOf(el) !== -1) return dropTarget;
        }
        return null;
    }
    addDropTarget(dropTarget) {
        this.dropTargets.push(dropTarget);
    }
    removeDropTarget(dropTarget) {
        this.dropTargets = this.dropTargets.filter((target)=>target.getContainer() !== dropTarget.getContainer());
    }
    hasExternalDropZones() {
        return this.dropTargets.some((zones)=>zones.external);
    }
    findExternalZone(container) {
        return this.dropTargets.find((zone)=>zone.external && zone.getContainer() === container) || null;
    }
    dropTargetEvent(dropTarget, mouseEvent, fromNudge) {
        const { dragSource: dragSource, dragItem: dragItem, lastDraggingEvent: lastDraggingEvent, lastMouseEvent: lastMouseEvent, dragInitialSourcePointerOffsetX: dragInitialSourcePointerOffsetX, dragInitialSourcePointerOffsetY: dragInitialSourcePointerOffsetY } = this;
        const dropZoneTarget = dropTarget.getContainer();
        const rect = dropZoneTarget.getBoundingClientRect();
        const { clientX: clientX, clientY: clientY } = mouseEvent;
        const xDir = clientX - (lastMouseEvent?.clientX || 0);
        const yDir = clientY - (lastMouseEvent?.clientY || 0);
        const draggingEvent = this.createEvent({
            event: mouseEvent,
            x: clientX - rect.left,
            // relative x
            y: clientY - rect.top,
            // relative y
            vDirection: yDir > 0 ? "down" : yDir < 0 ? "up" : null,
            hDirection: xDir < 0 ? "left" : xDir > 0 ? "right" : null,
            initialSourcePointerOffsetX: dragInitialSourcePointerOffsetX,
            initialSourcePointerOffsetY: dragInitialSourcePointerOffsetY,
            dragSource: dragSource,
            fromNudge: fromNudge,
            dragItem: dragItem,
            dropZoneTarget: dropZoneTarget,
            dropTarget: lastDraggingEvent?.dropTarget ?? null,
            // updated by rowDragFeature
            changed: !!lastDraggingEvent?.changed
        });
        this.lastDraggingEvent = draggingEvent;
        return draggingEvent;
    }
    positionDragImageComp(event) {
        const gui = this.dragImageComp?.getGui();
        if (gui) $437b23f6a393c3bf$export$3ce6b987cf48b8c2(gui, event, this.beans);
    }
    removeDragImageComp(comp) {
        if (this.dragImageComp === comp) this.dragImageComp = null;
        if (comp) {
            comp.getGui()?.remove();
            this.destroyBean(comp);
        }
    }
    createAndUpdateDragImageComp(dragSource) {
        const promise = this.createDragImageComp(dragSource) ?? null;
        this.dragImageCompPromise = promise;
        promise?.then((dragImageComp)=>{
            if (promise !== this.dragImageCompPromise || !this.lastMouseEvent || !this.isAlive()) {
                this.destroyBean(dragImageComp);
                return;
            }
            this.dragImageCompPromise = null;
            this.dragImageLastIcon = void 0;
            this.dragImageLastLabel = void 0;
            const oldDragImageComp = this.dragImageComp;
            if (oldDragImageComp !== dragImageComp) {
                this.dragImageComp = dragImageComp;
                this.removeDragImageComp(oldDragImageComp);
            }
            if (dragImageComp) {
                this.appendDragImageComp(dragImageComp);
                this.updateDragImageComp();
            }
        });
    }
    appendDragImageComp(component) {
        const eGui = component.getGui();
        const style = eGui.style;
        style.position = "absolute";
        style.zIndex = "9999";
        if (this.beans.dragSvc?.hasPointerCapture()) style.pointerEvents = "none";
        this.gos.setInstanceDomData(eGui);
        this.beans.environment.applyThemeClasses(eGui);
        style.top = "20px";
        style.left = "20px";
        const targetEl = $437b23f6a393c3bf$export$50c54e860701cf22(this.beans);
        this.dragImageParent = targetEl;
        if (!targetEl) this.warnNoBody();
        else targetEl.appendChild(eGui);
    }
    updateDragImageComp() {
        const { dragImageComp: dragImageComp, dragSource: dragSource, lastDropTarget: lastDropTarget, lastDraggingEvent: lastDraggingEvent, dragImageLastLabel: dragImageLastLabel } = this;
        if (!dragImageComp) return;
        this.setDragImageCompIcon(lastDropTarget?.getIconName?.(lastDraggingEvent) ?? null);
        let label = dragSource?.dragItemName;
        if (typeof label === "function") label = label(lastDraggingEvent);
        label || (label = "");
        if (dragImageLastLabel !== label) {
            this.dragImageLastLabel = label;
            dragImageComp.setLabel(label);
        }
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragAndDropService.ts
var $437b23f6a393c3bf$export$46ba5a92125911d9 = /* @__PURE__ */ ((DragSourceType2)=>{
    DragSourceType2[DragSourceType2["ToolPanel"] = 0] = "ToolPanel";
    DragSourceType2[DragSourceType2["HeaderCell"] = 1] = "HeaderCell";
    DragSourceType2[DragSourceType2["RowDrag"] = 2] = "RowDrag";
    DragSourceType2[DragSourceType2["ChartPanel"] = 3] = "ChartPanel";
    DragSourceType2[DragSourceType2["AdvancedFilterBuilder"] = 4] = "AdvancedFilterBuilder";
    return DragSourceType2;
})($437b23f6a393c3bf$export$46ba5a92125911d9 || {});
var $437b23f6a393c3bf$var$DragAndDropService = class extends $437b23f6a393c3bf$export$95d9806a07659825 {
    createEvent(event) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, event);
    }
    createDragImageComp(dragSource) {
        const { gos: gos, beans: beans } = this;
        const userCompDetails = $437b23f6a393c3bf$var$_getDragAndDropImageCompDetails(beans.userCompFactory, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            dragSource: dragSource
        }));
        return userCompDetails?.newAgStackInstance();
    }
    handleEnter(dragSource, dragItem) {
        dragSource?.onGridEnter?.(dragItem);
    }
    handleExit(dragSource, dragItem) {
        dragSource?.onGridExit?.(dragItem);
    }
    warnNoBody() {
        $437b23f6a393c3bf$export$545083624300f13d(54);
    }
    isDropZoneWithinThisGrid(draggingEvent) {
        return this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody.contains(draggingEvent.dropZoneTarget);
    }
    registerGridDropTarget(elementFn, ctrl) {
        const dropTarget = {
            getContainer: elementFn,
            isInterestedIn: (type)=>type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */ ,
            getIconName: ()=>"notAllowed"
        };
        this.addDropTarget(dropTarget);
        ctrl.addDestroyFunc(()=>this.removeDropTarget(dropTarget));
    }
};
// packages/ag-grid-community/src/entities/agColumnGroup.ts
function $437b23f6a393c3bf$var$createUniqueColumnGroupId(groupId, instanceId) {
    return groupId + "_" + instanceId;
}
function $437b23f6a393c3bf$export$1f44a60fc23f9028(col) {
    return col instanceof $437b23f6a393c3bf$export$273c80940a54c770;
}
var $437b23f6a393c3bf$export$273c80940a54c770 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(providedColumnGroup, groupId, partId, pinned){
        super();
        this.providedColumnGroup = providedColumnGroup;
        this.groupId = groupId;
        this.partId = partId;
        this.pinned = pinned;
        this.isColumn = false;
        // depends on the open/closed state of the group, only displaying columns are stored here
        this.displayedChildren = [];
        // The measured height of this column's header when autoHeaderHeight is enabled
        this.autoHeaderHeight = null;
        this.parent = null;
        this.colIdSanitised = $437b23f6a393c3bf$export$3df06b741968da82(this.getUniqueId());
    }
    // as the user is adding and removing columns, the groups are recalculated.
    // this reset clears out all children, ready for children to be added again
    reset() {
        this.parent = null;
        this.children = null;
        this.displayedChildren = null;
    }
    getParent() {
        return this.parent;
    }
    getUniqueId() {
        return $437b23f6a393c3bf$var$createUniqueColumnGroupId(this.groupId, this.partId);
    }
    isEmptyGroup() {
        return this.displayedChildren.length === 0;
    }
    isMoving() {
        const allLeafColumns = this.getProvidedColumnGroup().getLeafColumns();
        if (!allLeafColumns || allLeafColumns.length === 0) return false;
        return allLeafColumns.every((col)=>col.isMoving());
    }
    checkLeft() {
        for (const child of this.displayedChildren)if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.checkLeft();
        if (this.displayedChildren.length > 0) {
            if (this.gos.get("enableRtl")) {
                const lastChild = $437b23f6a393c3bf$export$236389741107357f(this.displayedChildren);
                const lastChildLeft = lastChild.getLeft();
                this.setLeft(lastChildLeft);
            } else {
                const firstChildLeft = this.displayedChildren[0].getLeft();
                this.setLeft(firstChildLeft);
            }
        } else this.setLeft(null);
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    setLeft(left) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.dispatchLocalEvent({
                type: "leftChanged"
            });
        }
    }
    getPinned() {
        return this.pinned;
    }
    getGroupId() {
        return this.groupId;
    }
    getPartId() {
        return this.partId;
    }
    getActualWidth() {
        let groupActualWidth = 0;
        for (const child of this.displayedChildren ?? [])groupActualWidth += child.getActualWidth();
        return groupActualWidth;
    }
    isResizable() {
        if (!this.displayedChildren) return false;
        let result = false;
        for (const child of this.displayedChildren)if (child.isResizable()) result = true;
        return result;
    }
    getMinWidth() {
        let result = 0;
        for (const groupChild of this.displayedChildren)result += groupChild.getMinWidth();
        return result;
    }
    addChild(child) {
        if (!this.children) this.children = [];
        this.children.push(child);
    }
    getDisplayedChildren() {
        return this.displayedChildren;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    getDisplayedLeafColumns() {
        const result = [];
        this.addDisplayedLeafColumns(result);
        return result;
    }
    getDefinition() {
        return this.providedColumnGroup.getColGroupDef();
    }
    getColGroupDef() {
        return this.providedColumnGroup.getColGroupDef();
    }
    isPadding() {
        return this.providedColumnGroup.isPadding();
    }
    isExpandable() {
        return this.providedColumnGroup.isExpandable();
    }
    isExpanded() {
        return this.providedColumnGroup.isExpanded();
    }
    setExpanded(expanded) {
        this.providedColumnGroup.setExpanded(expanded);
    }
    isAutoHeaderHeight() {
        return !!this.getColGroupDef()?.autoHeaderHeight;
    }
    getAutoHeaderHeight() {
        return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */ setAutoHeaderHeight(height) {
        const changed = height !== this.autoHeaderHeight;
        this.autoHeaderHeight = height;
        return changed;
    }
    addDisplayedLeafColumns(leafColumns) {
        for (const child of this.displayedChildren ?? []){
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.addDisplayedLeafColumns(leafColumns);
        }
    }
    addLeafColumns(leafColumns) {
        for (const child of this.children ?? []){
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.addLeafColumns(leafColumns);
        }
    }
    getChildren() {
        return this.children;
    }
    getColumnGroupShow() {
        return this.providedColumnGroup.getColumnGroupShow();
    }
    getProvidedColumnGroup() {
        return this.providedColumnGroup;
    }
    getPaddingLevel() {
        const parent = this.getParent();
        if (!this.isPadding() || !parent?.isPadding()) return 0;
        return 1 + parent.getPaddingLevel();
    }
    calculateDisplayedColumns() {
        this.displayedChildren = [];
        let parentWithExpansion = this;
        while(parentWithExpansion?.isPadding())parentWithExpansion = parentWithExpansion.getParent();
        const isExpandable = parentWithExpansion ? parentWithExpansion.getProvidedColumnGroup().isExpandable() : false;
        if (!isExpandable) {
            this.displayedChildren = this.children;
            this.dispatchLocalEvent({
                type: "displayedChildrenChanged"
            });
            return;
        }
        for (const child of this.children ?? []){
            const emptyGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(child) && !child.displayedChildren?.length;
            if (emptyGroup) continue;
            const headerGroupShow = child.getColumnGroupShow();
            switch(headerGroupShow){
                case "open":
                    if (parentWithExpansion.getProvidedColumnGroup().isExpanded()) this.displayedChildren.push(child);
                    break;
                case "closed":
                    if (!parentWithExpansion.getProvidedColumnGroup().isExpanded()) this.displayedChildren.push(child);
                    break;
                default:
                    this.displayedChildren.push(child);
                    break;
            }
        }
        this.dispatchLocalEvent({
            type: "displayedChildrenChanged"
        });
    }
};
// packages/ag-grid-community/src/entities/rowNode.ts
var $437b23f6a393c3bf$export$cb038fdaa8338d9f = "row-group-";
var $437b23f6a393c3bf$export$27b0e4a919abc336 = "t-";
var $437b23f6a393c3bf$export$5f755686e611c1ea = "b-";
var $437b23f6a393c3bf$var$OBJECT_ID_SEQUENCE = 0;
var $437b23f6a393c3bf$export$6af91cd58ec2edf9 = class {
    constructor(beans){
        /** `true` if this row is a master row, part of master / detail (ie row can be expanded to show detail) */ this.master = false;
        /** `true` if this row is a detail row, part of master / detail (ie child row of an expanded master row)*/ this.detail = void 0;
        /** The current row index. If the row is filtered out or in a collapsed group, this value is set to `null`. */ this.rowIndex = null;
        /** The key for the group eg Ireland, UK, USA */ this.key = null;
        /**
     * CSRM only - The index of the row in the source rowData array including any updates via transactions.
     * It does not change when sorting, filtering, grouping, pivoting or any other UI related operations.
     * If this is a filler node (a visual row created by AG Grid in tree data or grouping) the value is set to `-1`.
     */ this.sourceRowIndex = -1;
        /**
     * CSRM only - all lowest level nodes beneath this node, no groups. Backing field for allLeafChildren property.
     * - undefined if not yet loaded.
     * - null if there are no no leaf children.
     * - not empty array containing all the leaf children.
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this._leafs = void 0;
        /** Children mapped by the pivot columns or group key */ this.childrenMapped = null;
        /**
     * Parent RowNode for tree data.
     * When set, the parent node in the hierarchy is updated during Client-Side Row Model (CSRM) grouping.
     * Used by the ClientSideChildrenTreeNodeManager, TreeGroupStrategy, RowDragFeature
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this.treeParent = null;
        /**
     * The flags associated to this node. Used only internally within TreeGroupStrategy.
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this.treeNodeFlags = 0;
        /**
     * This is `true` if the row has a rowIndex assigned, otherwise `false`.
     */ this.displayed = false;
        /** The row top position in pixels. */ this.rowTop = null;
        /** The top pixel for this row last time, makes sense if data set was ordered or filtered,
     * it is used so new rows can animate in from their old position. */ this.oldRowTop = null;
        /** `true` by default - can be overridden via gridOptions.isRowSelectable(rowNode) */ this.selectable = true;
        /**
     * Used by sorting service - to give deterministic sort to groups. Previously we
     * just id for this, however id is a string and had slower sorting compared to numbers.
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this.__objectId = $437b23f6a393c3bf$var$OBJECT_ID_SEQUENCE++;
        /** `true` when nodes with the same id are being removed and added as part of the same batch transaction */ this.alreadyRendered = false;
        this.hovered = false;
        this.__selected = false;
        this.beans = beans;
    }
    /** CSRM only - do not use this property internally, this is exposed to the end user only. Use `_leafs` instead. */ get allLeafChildren() {
        const leafs = this._leafs;
        return leafs === void 0 ? this.beans.groupStage?.loadLeafs?.(this) ?? null : leafs;
    }
    set allLeafChildren(value) {
        this._leafs = value;
    }
    /**
   * Replaces the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */ setData(data) {
        this.setDataCommon(data, false);
    }
    // similar to setRowData, however it is expected that the data is the same data item. this
    // is intended to be used with Redux type stores, where the whole data can be changed. we are
    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
    // dataChanged event, refreshes the cells rather than rip them all out (so user can show transitions).
    /**
   * Updates the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */ updateData(data) {
        this.setDataCommon(data, true);
    }
    setDataCommon(data, update) {
        const { valueCache: valueCache, eventSvc: eventSvc } = this.beans;
        const oldData = this.data;
        this.data = data;
        valueCache?.onDataChanged();
        this.updateDataOnDetailNode();
        this.resetQuickFilterAggregateText();
        const event = this.createDataChangedEvent(data, oldData, update);
        this.__localEventService?.dispatchEvent(event);
        if (this.sibling) {
            this.sibling.data = data;
            const event2 = this.sibling.createDataChangedEvent(data, oldData, update);
            this.sibling.__localEventService?.dispatchEvent(event2);
        }
        eventSvc.dispatchEvent({
            type: "rowNodeDataChanged",
            node: this
        });
        const pinnedSibling = this.pinnedSibling;
        if (pinnedSibling) {
            pinnedSibling.data = data;
            pinnedSibling.__localEventService?.dispatchEvent(pinnedSibling.createDataChangedEvent(data, oldData, update));
            eventSvc.dispatchEvent({
                type: "rowNodeDataChanged",
                node: pinnedSibling
            });
        }
    }
    // when we are doing master / detail, the detail node is lazy created, but then kept around.
    // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
    // in sync, otherwise expand/collapse of the detail would still show the old values.
    updateDataOnDetailNode() {
        const detailNode = this.detailNode;
        if (detailNode) detailNode.data = this.data;
    }
    createDataChangedEvent(newData, oldData, update) {
        return {
            type: "dataChanged",
            node: this,
            oldData: oldData,
            newData: newData,
            update: update
        };
    }
    getRowIndexString() {
        if (this.rowIndex == null) {
            $437b23f6a393c3bf$export$a20c7248650823a9(13);
            return null;
        }
        if (this.rowPinned === "top") return $437b23f6a393c3bf$export$27b0e4a919abc336 + this.rowIndex;
        if (this.rowPinned === "bottom") return $437b23f6a393c3bf$export$5f755686e611c1ea + this.rowIndex;
        return this.rowIndex.toString();
    }
    setDataAndId(data, id) {
        const { selectionSvc: selectionSvc } = this.beans;
        const oldNode = selectionSvc?.createDaemonNode?.(this);
        const oldData = this.data;
        this.data = data;
        this.updateDataOnDetailNode();
        this.setId(id);
        if (selectionSvc) {
            selectionSvc.updateRowSelectable(this);
            selectionSvc.syncInRowNode(this, oldNode);
        }
        const event = this.createDataChangedEvent(data, oldData, false);
        this.__localEventService?.dispatchEvent(event);
    }
    setId(id) {
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.beans.gos);
        if (getRowIdFunc) {
            if (this.data) {
                const parentKeys = this.parent?.getRoute() ?? [];
                this.id = getRowIdFunc({
                    data: this.data,
                    parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
                    level: this.level,
                    rowPinned: this.rowPinned
                });
                if (this.id.startsWith($437b23f6a393c3bf$export$cb038fdaa8338d9f)) $437b23f6a393c3bf$export$a20c7248650823a9(14, {
                    groupPrefix: $437b23f6a393c3bf$export$cb038fdaa8338d9f
                });
            } else this.id = void 0;
        } else this.id = id;
    }
    setRowTop(rowTop) {
        this.oldRowTop = this.rowTop;
        if (this.rowTop === rowTop) return;
        this.rowTop = rowTop;
        this.dispatchRowEvent("topChanged");
        const displayed = rowTop !== null;
        if (this.displayed !== displayed) {
            this.displayed = displayed;
            this.dispatchRowEvent("displayedChanged");
        }
    }
    clearRowTopAndRowIndex() {
        this.oldRowTop = null;
        this.setRowTop(null);
        this.setRowIndex(null);
    }
    setHovered(hovered) {
        this.hovered = hovered;
    }
    isHovered() {
        return this.hovered;
    }
    /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */ setRowHeight(rowHeight, estimated = false) {
        this.rowHeight = rowHeight;
        this.rowHeightEstimated = estimated;
        this.dispatchRowEvent("heightChanged");
    }
    setExpanded(expanded, e, forceSync) {
        this.beans.expansionSvc?.setExpanded(this, expanded, e, forceSync);
    }
    /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid refreshes the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   * **Note**: This method defers to EditModule if available and batches the edit when `fullRow` or `batchEdit` is enabled.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */ setDataValue(colKey, newValue, eventSource) {
        const { colModel: colModel, valueSvc: valueSvc, gos: gos, editSvc: editSvc } = this.beans;
        const column = typeof colKey !== "string" ? colKey : colModel.getCol(colKey) ?? colModel.getColDefCol(colKey);
        if (!column) return false;
        const oldValue = valueSvc.getValueForDisplay(column, this, void 0, void 0, "api").value;
        if (gos.get("readOnlyEdit")) {
            const { beans: { eventSvc: eventSvc }, data: data, rowIndex: rowIndex, rowPinned: rowPinned } = this;
            eventSvc.dispatchEvent({
                type: "cellEditRequest",
                event: null,
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                column: column,
                colDef: column.colDef,
                data: data,
                node: this,
                oldValue: oldValue,
                newValue: newValue,
                value: newValue,
                source: eventSource
            });
            return false;
        }
        if (editSvc && !editSvc.committing) {
            const result = editSvc.setDataValue({
                rowNode: this,
                column: column
            }, newValue, eventSource);
            if (result != null) return result;
        }
        const valueChanged = valueSvc.setValue(this, column, newValue, eventSource);
        this.dispatchCellChangedEvent(column, newValue, oldValue);
        if (valueChanged) this.pinnedSibling?.dispatchCellChangedEvent(column, newValue, oldValue);
        return valueChanged;
    }
    updateHasChildren() {
        let newValue = this.group && !this.footer || !!this.childrenAfterGroup?.length;
        const { rowChildrenSvc: rowChildrenSvc } = this.beans;
        if (rowChildrenSvc) newValue = rowChildrenSvc.getHasChildrenValue(this);
        if (newValue !== this.__hasChildren) {
            this.__hasChildren = !!newValue;
            this.dispatchRowEvent("hasChildrenChanged");
        }
    }
    hasChildren() {
        if (this.__hasChildren == null) this.updateHasChildren();
        return this.__hasChildren;
    }
    dispatchCellChangedEvent(column, newValue, oldValue) {
        const cellChangedEvent = {
            type: "cellChanged",
            node: this,
            column: column,
            newValue: newValue,
            oldValue: oldValue
        };
        this.__localEventService?.dispatchEvent(cellChangedEvent);
    }
    /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However, if you edit without using grid editing, you need to clear this string down for the row to be updated with the new values.
   * Otherwise, new values would not work with the `quickFilter`. */ resetQuickFilterAggregateText() {
        this.quickFilterAggregateText = null;
    }
    /** Returns:
   * - `true` if the node can be expanded, i.e it is a group or master row.
   * - `false` if the node cannot be expanded
   */ isExpandable() {
        return this.beans.expansionSvc?.isExpandable(this) ?? false;
    }
    /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */ isSelected() {
        if (this.footer) return this.sibling.isSelected();
        const pinnedSibling = this.rowPinned && this.pinnedSibling;
        if (pinnedSibling) return pinnedSibling.isSelected();
        return this.__selected;
    }
    /** Perform a depth-first search of this node and its children. */ depthFirstSearch(callback) {
        const childrenAfterGroup = this.childrenAfterGroup;
        if (childrenAfterGroup) for(let i = 0, len = childrenAfterGroup.length; i < len; ++i)childrenAfterGroup[i].depthFirstSearch(callback);
        callback(this);
    }
    dispatchRowEvent(type) {
        this.__localEventService?.dispatchEvent({
            type: type,
            node: this
        });
    }
    /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` selects the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that appears in the `selectionChanged` event.
   */ setSelected(newValue, clearSelection = false, source = "api") {
        this.beans.selectionSvc?.setNodesSelected({
            nodes: [
                this
            ],
            newValue: newValue,
            clearSelection: clearSelection,
            source: source
        });
    }
    /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */ isRowPinned() {
        return !!this.rowPinned;
    }
    __addEventListener(eventType, listener) {
        const localEventService = this.__localEventService ?? (this.__localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc());
        localEventService.addEventListener(eventType, listener);
    }
    __removeEventListener(eventType, listener) {
        this.removeLocalListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ addEventListener(eventType, userListener) {
        this.beans.validation?.checkRowEvents(eventType);
        const localEventService = this.__localEventService ?? (this.__localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc());
        this.frameworkEventListenerService = this.beans.frameworkOverrides.createLocalEventListenerWrapper?.(this.frameworkEventListenerService, localEventService);
        const listener = this.frameworkEventListenerService?.wrap(eventType, userListener) ?? userListener;
        localEventService.addEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ removeEventListener(eventType, userListener) {
        const listener = this.frameworkEventListenerService?.unwrap(eventType, userListener) ?? userListener;
        this.removeLocalListener(eventType, listener);
    }
    removeLocalListener(eventType, listener) {
        const localEventService = this.__localEventService;
        if (localEventService) {
            localEventService.removeEventListener(eventType, listener);
            if (localEventService.noRegisteredListenersExist()) this.__localEventService = null;
        }
    }
    /**
   * @deprecated v32.2.0 Check `node.detail` then user provided callback `isFullWidthRow` instead.
   *
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */ isFullWidthCell() {
        $437b23f6a393c3bf$export$545083624300f13d(61);
        if (this.detail) return true;
        const isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
        return isFullWidthCellFunc ? isFullWidthCellFunc({
            rowNode: this
        }) : false;
    }
    /**
   * Returns the route of keys to the row node. Returns undefined if the node has no key.
   */ getRoute() {
        if (this.level === -1) return [];
        if (this.key == null) return void 0;
        const res = [];
        let pointer = this;
        while(pointer?.key != null){
            res.push(pointer.key);
            pointer = pointer.parent;
        }
        return res.reverse();
    }
    setRowIndex(rowIndex) {
        if (this.rowIndex !== rowIndex) {
            this.rowIndex = rowIndex;
            this.dispatchRowEvent("rowIndexChanged");
        }
    }
    setAllChildrenCount(allChildrenCount) {
        if (this.allChildrenCount !== allChildrenCount) {
            this.allChildrenCount = allChildrenCount;
            this.dispatchRowEvent("allChildrenCountChanged");
        }
    }
    setUiLevel(uiLevel) {
        if (this.uiLevel !== uiLevel) {
            this.uiLevel = uiLevel;
            this.dispatchRowEvent("uiLevelChanged");
        }
    }
    getFirstChild() {
        const childStore = this.childStore;
        if (childStore) return childStore.getFirstNode();
        return this.childrenAfterSort?.[0] ?? null;
    }
};
// packages/ag-grid-community/src/entities/rowNodeUtils.ts
function $437b23f6a393c3bf$export$5c5bd6257397e1bc(rowNode, gos, type) {
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        type: type,
        node: rowNode,
        data: rowNode.data,
        rowIndex: rowNode.rowIndex,
        rowPinned: rowNode.rowPinned
    });
}
var $437b23f6a393c3bf$var$IGNORED_SIBLING_PROPERTIES = /* @__PURE__ */ new Set([
    "__autoHeights",
    "__checkAutoHeightsDebounced",
    "__localEventService",
    "__objectId",
    "_leafs",
    "childStore",
    "oldRowTop",
    "sticky",
    "treeNodeFlags",
    "treeParent"
]);
var $437b23f6a393c3bf$export$48fabbbfcde9fe36 = (rowNode, beans)=>{
    const sibling = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
    for (const key of Object.keys(rowNode)){
        if ($437b23f6a393c3bf$var$IGNORED_SIBLING_PROPERTIES.has(key)) continue;
        sibling[key] = rowNode[key];
    }
    sibling.oldRowTop = null;
    return sibling;
};
var $437b23f6a393c3bf$export$d3815c2420e77efc = (childrenAfterGroup)=>{
    while(childrenAfterGroup?.length){
        const node = childrenAfterGroup[0];
        if (node.data) return node;
        childrenAfterGroup = node.childrenAfterGroup;
    }
};
// packages/ag-grid-community/src/filter/columnFilterUtils.ts
var $437b23f6a393c3bf$var$FILTER_HANDLER_MAP = {
    agSetColumnFilter: "agSetColumnFilterHandler",
    agMultiColumnFilter: "agMultiColumnFilterHandler",
    agGroupColumnFilter: "agGroupColumnFilterHandler",
    agNumberColumnFilter: "agNumberColumnFilterHandler",
    agDateColumnFilter: "agDateColumnFilterHandler",
    agTextColumnFilter: "agTextColumnFilterHandler"
};
var $437b23f6a393c3bf$var$FILTER_HANDLERS = new Set(Object.values($437b23f6a393c3bf$var$FILTER_HANDLER_MAP));
function $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, skipCreate) {
    const filterUi = filterWrapper.filterUi;
    if (!filterUi) return null;
    if (filterUi.created) return filterUi.promise;
    if (skipCreate) return null;
    const promise = filterUi.create(filterUi.refreshed);
    const createdFilterUi = filterUi;
    createdFilterUi.created = true;
    createdFilterUi.promise = promise;
    return promise;
}
function $437b23f6a393c3bf$export$1fc9ad198b29415d(getFilterUi, handler, handlerParams, model, state, source, additionalEventAttributes) {
    handler.refresh?.({
        ...handlerParams,
        model: model,
        source: source,
        additionalEventAttributes: additionalEventAttributes
    });
    return getFilterUi().then((filterUi)=>{
        if (filterUi) {
            const { filter: filter, filterParams: filterParams } = filterUi;
            $437b23f6a393c3bf$export$8e370ccb0273c891(filter, filterParams, model, state, source, additionalEventAttributes);
        }
    });
}
function $437b23f6a393c3bf$export$8e370ccb0273c891(filter, filterParams, model, state, source, additionalEventAttributes) {
    filter?.refresh?.({
        ...filterParams,
        model: model,
        state: state,
        source: source,
        additionalEventAttributes: additionalEventAttributes
    });
}
function $437b23f6a393c3bf$var$getAndRefreshFilterUi(getFilterUi, getModel, getState2) {
    const filterUi = getFilterUi();
    if (filterUi?.created) filterUi.promise.then((filter)=>{
        const model = getModel();
        $437b23f6a393c3bf$export$8e370ccb0273c891(filter, filterUi.filterParams, model, getState2() ?? {
            model: model
        }, "ui");
    });
}
function $437b23f6a393c3bf$export$3305e8c6f4c8572a(action, getFilterUi, getModel, getState2, updateState, updateModel, processModelToApply) {
    let state;
    let shouldUpdateModel = false;
    let model;
    switch(action){
        case "apply":
            {
                const oldState = getState2();
                model = oldState?.model ?? null;
                if (processModelToApply) model = processModelToApply(model);
                state = {
                    // keep the other UI state
                    state: oldState?.state,
                    model: model
                };
                shouldUpdateModel = true;
                break;
            }
        case "clear":
            state = {
                // wipe other UI state
                model: null
            };
            break;
        case "reset":
            state = {
                // wipe other UI state
                model: null
            };
            shouldUpdateModel = true;
            model = null;
            break;
        case "cancel":
            state = {
                // wipe other UI state
                model: getModel()
            };
            break;
    }
    updateState(state);
    if (shouldUpdateModel) updateModel(model);
    else $437b23f6a393c3bf$var$getAndRefreshFilterUi(getFilterUi, getModel, getState2);
}
function $437b23f6a393c3bf$export$8981db65da4532f2(model, colId) {
    return model[colId] ?? null;
}
// packages/ag-grid-community/src/utils/element.ts
function $437b23f6a393c3bf$export$a232bb0480ae674a(params) {
    return $437b23f6a393c3bf$export$378bc9c64290bc8b(params);
}
// packages/ag-grid-community/src/filter/filterButtonComp.ts
function $437b23f6a393c3bf$var$getElement(className) {
    return {
        tag: "div",
        cls: className
    };
}
var $437b23f6a393c3bf$export$226c2a54d31bd592 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(config){
        const { className: className = "ag-filter-apply-panel" } = config ?? {};
        super($437b23f6a393c3bf$var$getElement(className));
        this.listeners = [];
        this.validationMessage = null;
        this.className = className;
    }
    updateButtons(buttons, useForm) {
        const oldButtons = this.buttons;
        this.buttons = buttons;
        if (oldButtons === buttons) return;
        const eGui = this.getGui();
        $437b23f6a393c3bf$export$69e6e10709eabd91(eGui);
        let eApplyButton;
        this.destroyListeners();
        const fragment = document.createDocumentFragment();
        const className = this.className;
        const addButton = ({ type: type, label: label })=>{
            const clickListener = (event)=>{
                this.dispatchLocalEvent({
                    type: type,
                    event: event
                });
            };
            if (![
                "apply",
                "clear",
                "reset",
                "cancel"
            ].includes(type)) $437b23f6a393c3bf$export$545083624300f13d(75);
            const isApply = type === "apply";
            const buttonType = isApply && useForm ? "submit" : "button";
            const button = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "button",
                attrs: {
                    type: buttonType
                },
                ref: `${type}FilterButton`,
                cls: `ag-button ag-standard-button ${className}-button${isApply ? " " + className + "-apply-button" : ""}`,
                children: label
            });
            this.activateTabIndex([
                button
            ]);
            if (isApply) eApplyButton = button;
            const keydownListener = (event)=>{
                if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) {
                    event.preventDefault();
                    clickListener(event);
                }
            };
            const listeners = this.listeners;
            button.addEventListener("click", clickListener);
            listeners.push(()=>button.removeEventListener("click", clickListener));
            button.addEventListener("keydown", keydownListener);
            listeners.push(()=>button.removeEventListener("keydown", keydownListener));
            fragment.append(button);
        };
        for (const button of buttons)addButton(button);
        this.eApply = eApplyButton;
        const tooltip = this.validationTooltipFeature;
        if (eApplyButton && !tooltip) this.validationTooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.eApply,
            getLocation: ()=>"advancedFilter",
            getTooltipShowDelayOverride: ()=>1e3
        }));
        else if (!eApplyButton && tooltip) this.validationTooltipFeature = this.destroyBean(tooltip);
        eGui.append(fragment);
    }
    getApplyButton() {
        return this.eApply;
    }
    updateValidity(valid, message = null) {
        const eApplyButton = this.eApply;
        if (!eApplyButton) return;
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(eApplyButton, valid === false);
        this.validationMessage = message ?? null;
        this.validationTooltipFeature?.setTooltipAndRefresh(this.validationMessage);
    }
    destroyListeners() {
        for (const destroyFunc of this.listeners)destroyFunc();
        this.listeners = [];
    }
    destroy() {
        this.destroyListeners();
        super.destroy();
    }
};
var $437b23f6a393c3bf$export$4a8eed8acd632fcc = {
    selector: "AG-FILTER-BUTTON",
    component: $437b23f6a393c3bf$export$226c2a54d31bd592
};
// packages/ag-grid-community/src/filter/filterLocaleText.ts
var $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT = {
    applyFilter: "Apply",
    clearFilter: "Clear",
    resetFilter: "Reset",
    cancelFilter: "Cancel",
    textFilter: "Text Filter",
    numberFilter: "Number Filter",
    dateFilter: "Date Filter",
    setFilter: "Set Filter",
    filterOoo: "Filter...",
    empty: "Choose one",
    equals: "Equals",
    notEqual: "Does not equal",
    lessThan: "Less than",
    greaterThan: "Greater than",
    inRange: "Between",
    inRangeStart: "From",
    inRangeEnd: "To",
    lessThanOrEqual: "Less than or equal to",
    greaterThanOrEqual: "Greater than or equal to",
    contains: "Contains",
    notContains: "Does not contain",
    startsWith: "Begins with",
    endsWith: "Ends with",
    blank: "Blank",
    notBlank: "Not blank",
    before: "Before",
    after: "After",
    andCondition: "AND",
    orCondition: "OR",
    dateFormatOoo: "yyyy-mm-dd",
    filterSummaryInactive: "is (All)",
    filterSummaryContains: "contains",
    filterSummaryNotContains: "does not contain",
    filterSummaryTextEquals: "equals",
    filterSummaryTextNotEqual: "does not equal",
    filterSummaryStartsWith: "begins with",
    filterSummaryEndsWith: "ends with",
    filterSummaryBlank: "is blank",
    filterSummaryNotBlank: "is not blank",
    filterSummaryEquals: "=",
    filterSummaryNotEqual: "!=",
    filterSummaryGreaterThan: ">",
    filterSummaryGreaterThanOrEqual: ">=",
    filterSummaryLessThan: "<",
    filterSummaryLessThanOrEqual: "<=",
    filterSummaryInRange: "between",
    filterSummaryInRangeValues: (variableValues)=>`(${variableValues[0]}, ${variableValues[1]})`,
    filterSummaryTextQuote: (variableValues)=>`"${variableValues[0]}"`
};
function $437b23f6a393c3bf$export$e2a0ae4af921fff8(bean, key, variableValues) {
    return $437b23f6a393c3bf$export$4ad3db330991f17d(bean, $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT, key, variableValues);
}
// packages/ag-grid-community/src/filter/provided/providedFilterUtils.ts
function $437b23f6a393c3bf$var$getDebounceMs(params, debounceDefault) {
    const { debounceMs: debounceMs } = params;
    if ($437b23f6a393c3bf$export$527c1b777ebd9069(params)) {
        if (debounceMs != null) $437b23f6a393c3bf$export$545083624300f13d(71);
        return 0;
    }
    return debounceMs ?? debounceDefault;
}
function $437b23f6a393c3bf$export$527c1b777ebd9069(params) {
    return (params.buttons?.indexOf("apply") ?? -1) >= 0;
}
// packages/ag-grid-community/src/filter/filterWrapperComp.ts
var $437b23f6a393c3bf$export$70acaf0e0e30e7d = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(column, wrapper, eventParent, updateModel, isGlobalButtons, enableGlobalButtonCheck){
        super();
        this.column = column;
        this.wrapper = wrapper;
        this.eventParent = eventParent;
        this.updateModel = updateModel;
        this.isGlobalButtons = isGlobalButtons;
        this.enableGlobalButtonCheck = enableGlobalButtonCheck;
        this.hidePopup = null;
        this.applyActive = false;
    }
    postConstruct() {
        const { comp: comp, params: originalParams } = this.wrapper;
        const params = originalParams;
        const useForm = params.useForm;
        const tag = useForm ? "form" : "div";
        this.setTemplate({
            tag: tag,
            cls: "ag-filter-wrapper"
        });
        if (useForm) this.addManagedElementListeners(this.getGui(), {
            submit: (e)=>{
                e?.preventDefault();
            },
            keydown: this.handleKeyDown.bind(this)
        });
        this.appendChild(comp.getGui());
        this.params = params;
        this.resetButtonsPanel(params);
        this.addManagedListeners(this.eventParent, {
            filterParamsChanged: ({ column: column, params: eventParams })=>{
                if (column === this.column) this.resetButtonsPanel(eventParams, this.params);
            },
            filterStateChanged: ({ column: column, state: state })=>{
                if (column === this.column) this.eButtons?.updateValidity(state.valid !== false);
            },
            filterAction: ({ column: column, action: action, event: keyboardEvent })=>{
                if (column === this.column) this.afterAction(action, keyboardEvent);
            },
            ...this.enableGlobalButtonCheck ? {
                filterGlobalButtons: ({ isGlobal: isGlobal })=>{
                    if (isGlobal !== this.isGlobalButtons) {
                        this.isGlobalButtons = isGlobal;
                        const currentParams = this.params;
                        this.resetButtonsPanel(currentParams, currentParams, true);
                    }
                }
            } : void 0
        });
    }
    afterGuiAttached(params) {
        if (params) this.hidePopup = params.hidePopup;
    }
    resetButtonsPanel(newParams, oldParams, forceUpdate) {
        const { buttons: oldButtons, readOnly: oldReadOnly } = oldParams ?? {};
        const { buttons: newButtons, readOnly: readOnly, useForm: useForm } = newParams;
        if (!forceUpdate && oldReadOnly === readOnly && $437b23f6a393c3bf$export$dbc2068cc90f5875(oldButtons, newButtons)) return;
        const hasButtons = newButtons && newButtons.length > 0 && !newParams.readOnly && !this.isGlobalButtons;
        let eButtonsPanel = this.eButtons;
        if (hasButtons) {
            const buttons = newButtons.map((type)=>{
                const localeKey = `${type}Filter`;
                return {
                    type: type,
                    label: $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, localeKey)
                };
            });
            this.applyActive = $437b23f6a393c3bf$export$527c1b777ebd9069(this.params);
            if (!eButtonsPanel) {
                eButtonsPanel = this.createBean(new $437b23f6a393c3bf$export$226c2a54d31bd592());
                this.appendChild(eButtonsPanel.getGui());
                const column = this.column;
                const getListener = (action)=>({ event: event })=>{
                        this.updateModel(column, action, {
                            fromButtons: true
                        });
                        this.afterAction(action, event);
                    };
                eButtonsPanel?.addManagedListeners(eButtonsPanel, {
                    apply: getListener("apply"),
                    clear: getListener("clear"),
                    reset: getListener("reset"),
                    cancel: getListener("cancel")
                });
                this.eButtons = eButtonsPanel;
            }
            eButtonsPanel.updateButtons(buttons, useForm);
        } else {
            this.applyActive = false;
            if (eButtonsPanel) {
                $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eButtonsPanel.getGui());
                this.eButtons = this.destroyBean(eButtonsPanel);
            }
        }
    }
    close(e) {
        const hidePopup = this.hidePopup;
        if (!hidePopup) return;
        const keyboardEvent = e;
        const key = keyboardEvent?.key;
        let params;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) params = {
            keyboardEvent: keyboardEvent
        };
        hidePopup(params);
        this.hidePopup = null;
    }
    afterAction(action, event) {
        const { params: params, applyActive: applyActive } = this;
        const closeOnApply = params?.closeOnApply;
        switch(action){
            case "apply":
                event?.preventDefault();
                if (closeOnApply && applyActive) this.close(event);
                break;
            case "reset":
                if (closeOnApply && applyActive) this.close();
                break;
            case "cancel":
                if (closeOnApply) this.close(event);
                break;
        }
    }
    handleKeyDown(event) {
        if (!event.defaultPrevented && event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER && this.applyActive) {
            this.updateModel(this.column, "apply", {
                fromButtons: true
            });
            this.afterAction("apply", event);
        }
    }
    destroy() {
        this.hidePopup = null;
        this.eButtons = this.destroyBean(this.eButtons);
    }
};
// packages/ag-grid-community/src/filter/filterComp.ts
var $437b23f6a393c3bf$var$FilterElement = {
    tag: "div",
    cls: "ag-filter"
};
var $437b23f6a393c3bf$export$7db6d402989d8b90 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(column, source, enableGlobalButtonCheck){
        super($437b23f6a393c3bf$var$FilterElement);
        this.column = column;
        this.source = source;
        this.enableGlobalButtonCheck = enableGlobalButtonCheck;
        this.wrapper = null;
    }
    postConstruct() {
        this.beans.colFilter?.activeFilterComps.add(this);
        this.createFilter(true);
        this.addManagedEventListeners({
            filterDestroyed: this.onFilterDestroyed.bind(this)
        });
    }
    hasFilter() {
        return this.wrapper != null;
    }
    getFilter() {
        return this.wrapper?.then((wrapper)=>wrapper.comp) ?? null;
    }
    afterInit() {
        return this.wrapper?.then(()=>{}) ?? $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    afterGuiAttached(params) {
        this.afterGuiAttachedParams = params;
        this.wrapper?.then((wrapper)=>{
            this.comp?.afterGuiAttached(params);
            wrapper?.comp?.afterGuiAttached?.(params);
        });
    }
    afterGuiDetached() {
        this.wrapper?.then((wrapper)=>{
            wrapper?.comp?.afterGuiDetached?.();
        });
    }
    createFilter(init) {
        const { column: column, source: source, beans: { colFilter: colFilter } } = this;
        const filterPromise = colFilter.getFilterUiForDisplay(column) ?? null;
        this.wrapper = filterPromise;
        filterPromise?.then((wrapper)=>{
            if (!wrapper) return;
            const { isHandler: isHandler, comp: comp } = wrapper;
            let filterGui;
            if (isHandler) {
                const enableGlobalButtonCheck = !!this.enableGlobalButtonCheck;
                const displayComp = this.createBean(new $437b23f6a393c3bf$export$70acaf0e0e30e7d(column, wrapper, colFilter, colFilter.updateModel.bind(colFilter), enableGlobalButtonCheck && colFilter.isGlobalButtons, enableGlobalButtonCheck));
                this.comp = displayComp;
                filterGui = displayComp.getGui();
            } else {
                filterGui = comp.getGui();
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(filterGui)) $437b23f6a393c3bf$export$545083624300f13d(69, {
                    guiFromFilter: filterGui
                });
            }
            this.appendChild(filterGui);
            if (init) this.eventSvc.dispatchEvent({
                type: "filterOpened",
                column: column,
                source: source,
                eGui: this.getGui()
            });
            else comp.afterGuiAttached?.(this.afterGuiAttachedParams);
        });
    }
    onFilterDestroyed(event) {
        const { source: source, column: column } = event;
        if ((source === "api" || source === "paramsUpdated") && column.getId() === this.column.getId() && this.beans.colModel.getColDefCol(this.column)) {
            $437b23f6a393c3bf$export$69e6e10709eabd91(this.getGui());
            this.comp = this.destroyBean(this.comp);
            this.createFilter();
        }
    }
    destroy() {
        this.beans.colFilter?.activeFilterComps.delete(this);
        this.eventSvc.dispatchEvent({
            type: "filterClosed",
            column: this.column
        });
        this.wrapper = null;
        this.comp = this.destroyBean(this.comp);
        this.afterGuiAttachedParams = void 0;
        super.destroy();
    }
};
// packages/ag-grid-community/src/filter/filterDataTypeUtils.ts
var $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT = {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
};
var $437b23f6a393c3bf$var$MONTH_KEYS = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
function $437b23f6a393c3bf$var$setFilterNumberComparator(a, b) {
    if (a == null) return -1;
    if (b == null) return 1;
    return Number.parseFloat(a) - Number.parseFloat(b);
}
function $437b23f6a393c3bf$var$isValidDate(value) {
    return value instanceof Date && !isNaN(value.getTime());
}
var $437b23f6a393c3bf$var$filterParamsForEachDataType = {
    number: ()=>void 0,
    boolean: ()=>({
            maxNumConditions: 1,
            debounceMs: 0,
            filterOptions: [
                "empty",
                {
                    displayKey: "true",
                    displayName: "True",
                    predicate: (_filterValues, cellValue)=>cellValue,
                    numberOfInputs: 0
                },
                {
                    displayKey: "false",
                    displayName: "False",
                    predicate: (_filterValues, cellValue)=>cellValue === false,
                    numberOfInputs: 0
                }
            ]
        }),
    date: ()=>({
            isValidDate: $437b23f6a393c3bf$var$isValidDate
        }),
    dateString: ({ dataTypeDefinition: dataTypeDefinition })=>({
            comparator: (filterDate, cellValue)=>{
                const cellAsDate = dataTypeDefinition.dateParser(cellValue);
                if (cellValue == null || cellAsDate < filterDate) return -1;
                if (cellAsDate > filterDate) return 1;
                return 0;
            },
            isValidDate: (value)=>typeof value === "string" && $437b23f6a393c3bf$var$isValidDate(dataTypeDefinition.dateParser(value))
        }),
    dateTime: (args)=>$437b23f6a393c3bf$var$filterParamsForEachDataType.date(args),
    dateTimeString: (args)=>$437b23f6a393c3bf$var$filterParamsForEachDataType.dateString(args),
    object: ()=>void 0,
    text: ()=>void 0
};
var $437b23f6a393c3bf$var$setFilterParamsForEachDataType = {
    number: ()=>({
            comparator: $437b23f6a393c3bf$var$setFilterNumberComparator
        }),
    boolean: ({ t: t })=>({
            valueFormatter: (params)=>$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value) ? t(String(params.value), params.value ? "True" : "False") : t("blanks", "(Blanks)")
        }),
    date: ({ formatValue: formatValue, t: t })=>({
            valueFormatter: (params)=>{
                const valueFormatted = formatValue(params);
                return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : t("blanks", "(Blanks)");
            },
            treeList: true,
            treeListFormatter: (pathKey, level)=>{
                if (pathKey === "NaN") return t("invalidDate", "Invalid Date");
                if (level === 1 && pathKey != null) {
                    const monthKey = $437b23f6a393c3bf$var$MONTH_KEYS[Number(pathKey) - 1];
                    return t(monthKey, $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT[monthKey]);
                }
                return pathKey ?? t("blanks", "(Blanks)");
            },
            treeListPathGetter: (date)=>$437b23f6a393c3bf$export$bb4eb333cc2b3e25(date, false)
        }),
    dateString: ({ formatValue: formatValue, dataTypeDefinition: dataTypeDefinition, t: t })=>({
            valueFormatter: (params)=>{
                const valueFormatted = formatValue(params);
                return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : t("blanks", "(Blanks)");
            },
            treeList: true,
            treeListPathGetter: (value)=>$437b23f6a393c3bf$export$bb4eb333cc2b3e25(dataTypeDefinition.dateParser(value ?? void 0), false),
            treeListFormatter: (pathKey, level)=>{
                if (level === 1 && pathKey != null) {
                    const monthKey = $437b23f6a393c3bf$var$MONTH_KEYS[Number(pathKey) - 1];
                    return t(monthKey, $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT[monthKey]);
                }
                return pathKey ?? t("blanks", "(Blanks)");
            }
        }),
    dateTime: (args)=>{
        const params = $437b23f6a393c3bf$var$setFilterParamsForEachDataType.date(args);
        params.treeListPathGetter = $437b23f6a393c3bf$export$bb4eb333cc2b3e25;
        return params;
    },
    dateTimeString (args) {
        const convertToDate = args.dataTypeDefinition.dateParser;
        const params = $437b23f6a393c3bf$var$setFilterParamsForEachDataType.dateString(args);
        params.treeListPathGetter = (value)=>$437b23f6a393c3bf$export$bb4eb333cc2b3e25(convertToDate(value ?? void 0));
        return params;
    },
    object: ({ formatValue: formatValue, t: t })=>({
            valueFormatter: (params)=>{
                const valueFormatted = formatValue(params);
                return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : t("blanks", "(Blanks)");
            }
        }),
    text: ()=>void 0
};
function $437b23f6a393c3bf$export$4a99b58ce484acc(filter, existingFilterParams, existingFilterValueGetter, dataTypeDefinition, formatValue, beans, translate) {
    let filterParams = existingFilterParams;
    let filterValueGetter = existingFilterValueGetter;
    const usingSetFilter = filter === "agSetColumnFilter";
    if (!filterValueGetter && dataTypeDefinition.baseDataType === "object" && !usingSetFilter) filterValueGetter = ({ column: column, node: node })=>formatValue({
            column: column,
            node: node,
            value: beans.valueSvc.getValue(column, node)
        });
    const filterParamsMap = usingSetFilter ? $437b23f6a393c3bf$var$setFilterParamsForEachDataType : $437b23f6a393c3bf$var$filterParamsForEachDataType;
    const filterParamsGetter = filterParamsMap[dataTypeDefinition.baseDataType];
    const newFilterParams = filterParamsGetter({
        dataTypeDefinition: dataTypeDefinition,
        formatValue: formatValue,
        t: translate
    });
    filterParams = typeof existingFilterParams === "object" ? {
        ...newFilterParams,
        ...existingFilterParams
    } : newFilterParams;
    return {
        filterParams: filterParams,
        filterValueGetter: filterValueGetter
    };
}
var $437b23f6a393c3bf$var$defaultFilters = {
    boolean: "agTextColumnFilter",
    date: "agDateColumnFilter",
    dateString: "agDateColumnFilter",
    dateTime: "agDateColumnFilter",
    dateTimeString: "agDateColumnFilter",
    number: "agNumberColumnFilter",
    object: "agTextColumnFilter",
    text: "agTextColumnFilter"
};
var $437b23f6a393c3bf$var$defaultFloatingFilters = {
    boolean: "agTextColumnFloatingFilter",
    date: "agDateColumnFloatingFilter",
    dateString: "agDateColumnFloatingFilter",
    dateTime: "agDateColumnFloatingFilter",
    dateTimeString: "agDateColumnFloatingFilter",
    number: "agNumberColumnFloatingFilter",
    object: "agTextColumnFloatingFilter",
    text: "agTextColumnFloatingFilter"
};
function $437b23f6a393c3bf$export$4a4e3cf6acc7e93(cellDataType, isFloating = false) {
    const filterSet = isFloating ? $437b23f6a393c3bf$var$defaultFloatingFilters : $437b23f6a393c3bf$var$defaultFilters;
    return filterSet[cellDataType ?? "text"];
}
// packages/ag-grid-community/src/rendering/features/positionableFeature.ts
var $437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE = "ag-resizer-wrapper";
var $437b23f6a393c3bf$var$makeDiv = (dataRefPrefix, classSuffix)=>({
        tag: "div",
        ref: `${dataRefPrefix}Resizer`,
        cls: `ag-resizer ag-resizer-${classSuffix}`
    });
var $437b23f6a393c3bf$var$RESIZE_TEMPLATE = {
    tag: "div",
    cls: $437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE,
    children: [
        $437b23f6a393c3bf$var$makeDiv("eTopLeft", "topLeft"),
        $437b23f6a393c3bf$var$makeDiv("eTop", "top"),
        $437b23f6a393c3bf$var$makeDiv("eTopRight", "topRight"),
        $437b23f6a393c3bf$var$makeDiv("eRight", "right"),
        $437b23f6a393c3bf$var$makeDiv("eBottomRight", "bottomRight"),
        $437b23f6a393c3bf$var$makeDiv("eBottom", "bottom"),
        $437b23f6a393c3bf$var$makeDiv("eBottomLeft", "bottomLeft"),
        $437b23f6a393c3bf$var$makeDiv("eLeft", "left")
    ]
};
var $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element, config){
        super();
        this.element = element;
        this.dragStartPosition = {
            x: 0,
            y: 0
        };
        this.position = {
            x: 0,
            y: 0
        };
        this.lastSize = {
            width: -1,
            height: -1
        };
        this.positioned = false;
        this.resizersAdded = false;
        this.resizeListeners = [];
        this.boundaryEl = null;
        this.isResizing = false;
        this.isMoving = false;
        this.resizable = {};
        this.movable = false;
        this.currentResizer = null;
        this.config = Object.assign({}, {
            popup: false
        }, config);
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
        this.dragSvc = beans.dragSvc;
    }
    center(postProcessCallback) {
        const { clientHeight: clientHeight, clientWidth: clientWidth } = this.offsetParent;
        const x = clientWidth / 2 - this.getWidth() / 2;
        const y = clientHeight / 2 - this.getHeight() / 2;
        this.offsetElement(x, y, postProcessCallback);
    }
    initialisePosition(postProcessCallback) {
        if (this.positioned) return;
        const { centered: centered, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent, minWidth: minWidth, width: width, minHeight: minHeight, height: height, x: x, y: y } = this.config;
        if (!this.offsetParent) this.setOffsetParent();
        let computedMinHeight = 0;
        let computedMinWidth = 0;
        const isElementVisible = $437b23f6a393c3bf$export$2badf4aa566524cb(this.element);
        if (isElementVisible) {
            const boundaryEl = this.findBoundaryElement();
            const offsetParentComputedStyles = window.getComputedStyle(boundaryEl);
            if (offsetParentComputedStyles.minWidth != null) {
                const paddingWidth = boundaryEl.offsetWidth - this.element.offsetWidth;
                computedMinWidth = Number.parseInt(offsetParentComputedStyles.minWidth, 10) - paddingWidth;
            }
            if (offsetParentComputedStyles.minHeight != null) {
                const paddingHeight = boundaryEl.offsetHeight - this.element.offsetHeight;
                computedMinHeight = Number.parseInt(offsetParentComputedStyles.minHeight, 10) - paddingHeight;
            }
        }
        this.minHeight = minHeight || computedMinHeight;
        this.minWidth = minWidth || computedMinWidth;
        if (width) this.setWidth(width);
        if (height) this.setHeight(height);
        if (!width || !height) this.refreshSize();
        if (centered) this.center(postProcessCallback);
        else if (x || y) this.offsetElement(x, y, postProcessCallback);
        else if (isElementVisible && forcePopupParentAsOffsetParent) {
            let boundaryEl = this.boundaryEl;
            let initialisedDuringPositioning = true;
            if (!boundaryEl) {
                boundaryEl = this.findBoundaryElement();
                initialisedDuringPositioning = false;
            }
            if (boundaryEl) {
                const top = Number.parseFloat(boundaryEl.style.top);
                const left = Number.parseFloat(boundaryEl.style.left);
                if (initialisedDuringPositioning) this.offsetElement(isNaN(left) ? 0 : left, isNaN(top) ? 0 : top, postProcessCallback);
                else this.setPosition(left, top);
            }
        }
        this.positioned = !!this.offsetParent;
    }
    isPositioned() {
        return this.positioned;
    }
    getPosition() {
        return this.position;
    }
    setMovable(movable, moveElement) {
        if (!this.config.popup || movable === this.movable) return;
        this.movable = movable;
        const params = this.moveElementDragListener || {
            eElement: moveElement,
            onDragStart: this.onMoveStart.bind(this),
            onDragging: this.onMove.bind(this),
            onDragStop: this.onMoveEnd.bind(this)
        };
        if (movable) {
            this.dragSvc?.addDragSource(params);
            this.moveElementDragListener = params;
        } else {
            this.dragSvc?.removeDragSource(params);
            this.moveElementDragListener = void 0;
        }
    }
    setResizable(resizable) {
        this.clearResizeListeners();
        if (resizable) this.addResizers();
        else this.removeResizers();
        if (typeof resizable === "boolean") {
            if (resizable === false) return;
            resizable = {
                topLeft: resizable,
                top: resizable,
                topRight: resizable,
                right: resizable,
                bottomRight: resizable,
                bottom: resizable,
                bottomLeft: resizable,
                left: resizable
            };
        }
        Object.keys(resizable).forEach((side)=>{
            const resizableStructure = resizable;
            const isSideResizable = !!resizableStructure[side];
            const resizerEl = this.getResizerElement(side);
            const params = {
                dragStartPixels: 0,
                eElement: resizerEl,
                onDragStart: (e)=>this.onResizeStart(e, side),
                onDragging: this.onResize.bind(this),
                onDragStop: (e)=>this.onResizeEnd(e, side)
            };
            if (isSideResizable || !this.isAlive() && !isSideResizable) {
                if (isSideResizable) {
                    this.dragSvc?.addDragSource(params);
                    this.resizeListeners.push(params);
                    resizerEl.style.pointerEvents = "all";
                } else resizerEl.style.pointerEvents = "none";
                this.resizable[side] = isSideResizable;
            }
        });
    }
    removeSizeFromEl() {
        this.element.style.removeProperty("height");
        this.element.style.removeProperty("width");
        this.element.style.removeProperty("flex");
    }
    restoreLastSize() {
        this.element.style.flex = "0 0 auto";
        const { height: height, width: width } = this.lastSize;
        if (width !== -1) this.element.style.width = `${width}px`;
        if (height !== -1) this.element.style.height = `${height}px`;
    }
    getHeight() {
        return this.element.offsetHeight;
    }
    setHeight(height) {
        const { popup: popup } = this.config;
        const eGui = this.element;
        let isPercent = false;
        if (typeof height === "string" && height.includes("%")) {
            $437b23f6a393c3bf$var$_setFixedHeight(eGui, height);
            height = $437b23f6a393c3bf$export$d23c22492e0f7c0c(eGui);
            isPercent = true;
        } else {
            height = Math.max(this.minHeight, height);
            if (this.positioned) {
                const availableHeight = this.getAvailableHeight();
                if (availableHeight && height > availableHeight) height = availableHeight;
            }
        }
        if (this.getHeight() === height) return;
        if (!isPercent) {
            if (popup) $437b23f6a393c3bf$var$_setFixedHeight(eGui, height);
            else {
                eGui.style.height = `${height}px`;
                eGui.style.flex = "0 0 auto";
                this.lastSize.height = typeof height === "number" ? height : Number.parseFloat(height);
            }
        } else {
            eGui.style.maxHeight = "unset";
            eGui.style.minHeight = "unset";
        }
    }
    getAvailableHeight() {
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        if (!this.positioned) this.initialisePosition();
        const { clientHeight: clientHeight } = this.offsetParent;
        if (!clientHeight) return null;
        const elRect = this.element.getBoundingClientRect();
        const offsetParentRect = this.offsetParent.getBoundingClientRect();
        const yPosition = popup ? this.position.y : elRect.top;
        const parentTop = popup ? 0 : offsetParentRect.top;
        let additionalHeight = 0;
        if (forcePopupParentAsOffsetParent) {
            const parentEl = this.element.parentElement;
            if (parentEl) {
                const { bottom: bottom } = parentEl.getBoundingClientRect();
                additionalHeight = bottom - elRect.bottom;
            }
        }
        const availableHeight = clientHeight + parentTop - yPosition - additionalHeight;
        return availableHeight;
    }
    getWidth() {
        return this.element.offsetWidth;
    }
    setWidth(width) {
        const eGui = this.element;
        const { popup: popup } = this.config;
        let isPercent = false;
        if (typeof width === "string" && width.includes("%")) {
            $437b23f6a393c3bf$export$ce98ba7f5cfe7725(eGui, width);
            width = $437b23f6a393c3bf$export$642efcb17474eb51(eGui);
            isPercent = true;
        } else if (this.positioned) {
            width = Math.max(this.minWidth, width);
            const { clientWidth: clientWidth } = this.offsetParent;
            const xPosition = popup ? this.position.x : this.element.getBoundingClientRect().left;
            if (clientWidth && width + xPosition > clientWidth) width = clientWidth - xPosition;
        }
        if (this.getWidth() === width) return;
        if (!isPercent) {
            if (this.config.popup) $437b23f6a393c3bf$export$ce98ba7f5cfe7725(eGui, width);
            else {
                eGui.style.width = `${width}px`;
                eGui.style.flex = " unset";
                this.lastSize.width = typeof width === "number" ? width : Number.parseFloat(width);
            }
        } else {
            eGui.style.maxWidth = "unset";
            eGui.style.minWidth = "unset";
        }
    }
    offsetElement(x = 0, y = 0, postProcessCallback) {
        const { forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        const ePopup = forcePopupParentAsOffsetParent ? this.boundaryEl : this.element;
        if (!ePopup) return;
        this.popupSvc?.positionPopup({
            ePopup: ePopup,
            keepWithinBounds: true,
            skipObserver: this.movable || this.isResizable(),
            updatePosition: ()=>({
                    x: x,
                    y: y
                }),
            postProcessCallback: postProcessCallback
        });
        this.setPosition(Number.parseFloat(ePopup.style.left), Number.parseFloat(ePopup.style.top));
    }
    constrainSizeToAvailableHeight(constrain) {
        if (!this.config.forcePopupParentAsOffsetParent) return;
        const applyMaxHeightToElement = ()=>{
            const availableHeight = this.getAvailableHeight();
            this.element.style.setProperty("max-height", `${availableHeight}px`);
        };
        if (constrain && this.popupSvc) {
            this.resizeObserverSubscriber?.();
            this.resizeObserverSubscriber = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.popupSvc?.getPopupParent(), applyMaxHeightToElement);
        } else {
            this.element.style.removeProperty("max-height");
            if (this.resizeObserverSubscriber) {
                this.resizeObserverSubscriber();
                this.resizeObserverSubscriber = void 0;
            }
        }
    }
    setPosition(x, y) {
        this.position.x = x;
        this.position.y = y;
    }
    updateDragStartPosition(x, y) {
        this.dragStartPosition = {
            x: x,
            y: y
        };
    }
    calculateMouseMovement(params) {
        const { e: e, isLeft: isLeft, isTop: isTop, anywhereWithin: anywhereWithin, topBuffer: topBuffer } = params;
        const xDiff = e.clientX - this.dragStartPosition.x;
        const yDiff = e.clientY - this.dragStartPosition.y;
        const movementX = this.shouldSkipX(e, !!isLeft, !!anywhereWithin, xDiff) ? 0 : xDiff;
        const movementY = this.shouldSkipY(e, !!isTop, topBuffer, yDiff) ? 0 : yDiff;
        return {
            movementX: movementX,
            movementY: movementY
        };
    }
    shouldSkipX(e, isLeft, anywhereWithin, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const xPosition = this.config.popup ? this.position.x : elRect.left;
        let skipX = xPosition <= 0 && parentRect.left >= e.clientX || parentRect.right <= e.clientX && parentRect.right <= boundaryElRect.right;
        if (skipX) return true;
        if (isLeft) skipX = // is positioned to the right of the left side anchor
        diff < 0 && e.clientX > xPosition + parentRect.left || // skip if we are moving to the right and the cursor
        // is positioned to the left of the dialog
        diff > 0 && e.clientX < xPosition + parentRect.left;
        else if (anywhereWithin) skipX = diff < 0 && e.clientX > boundaryElRect.right || diff > 0 && e.clientX < xPosition + parentRect.left;
        else skipX = // we skip if we are moving to the left and the cursor
        // is to the right of the dialog
        diff < 0 && e.clientX > boundaryElRect.right || // or skip if we are moving to the right and the cursor
        // is to the left of the right side anchor
        diff > 0 && e.clientX < boundaryElRect.right;
        return skipX;
    }
    shouldSkipY(e, isTop, topBuffer = 0, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const yPosition = this.config.popup ? this.position.y : elRect.top;
        let skipY = yPosition <= 0 && parentRect.top >= e.clientY || parentRect.bottom <= e.clientY && parentRect.bottom <= boundaryElRect.bottom;
        if (skipY) return true;
        if (isTop) skipY = // below the top anchor + topBuffer
        // note: topBuffer is used when moving the dialog using the title bar
        diff < 0 && e.clientY > yPosition + parentRect.top + topBuffer || // skip if we are moving to the bottom and the cursor is
        // above the top anchor
        diff > 0 && e.clientY < yPosition + parentRect.top;
        else skipY = // is below the bottom anchor
        diff < 0 && e.clientY > boundaryElRect.bottom || // skip if we are moving towards the bottom and the cursor
        // is above the bottom anchor
        diff > 0 && e.clientY < boundaryElRect.bottom;
        return skipY;
    }
    createResizeMap() {
        const getElement2 = (ref)=>({
                element: this.element.querySelector(`[data-ref=${ref}Resizer]`)
            });
        this.resizerMap = {
            topLeft: getElement2("eTopLeft"),
            top: getElement2("eTop"),
            topRight: getElement2("eTopRight"),
            right: getElement2("eRight"),
            bottomRight: getElement2("eBottomRight"),
            bottom: getElement2("eBottom"),
            bottomLeft: getElement2("eBottomLeft"),
            left: getElement2("eLeft")
        };
    }
    addResizers() {
        if (this.resizersAdded) return;
        const eGui = this.element;
        if (!eGui) return;
        eGui.appendChild($437b23f6a393c3bf$export$a232bb0480ae674a($437b23f6a393c3bf$var$RESIZE_TEMPLATE));
        this.createResizeMap();
        this.resizersAdded = true;
    }
    removeResizers() {
        this.resizerMap = void 0;
        const resizerEl = this.element.querySelector(`.${$437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE}`);
        resizerEl?.remove();
        this.resizersAdded = false;
    }
    getResizerElement(side) {
        return this.resizerMap[side].element;
    }
    onResizeStart(e, side) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.currentResizer = {
            isTop: !!side.match(/top/i),
            isRight: !!side.match(/right/i),
            isBottom: !!side.match(/bottom/i),
            isLeft: !!side.match(/left/i)
        };
        this.element.classList.add("ag-resizing");
        this.resizerMap[side].element.classList.add("ag-active");
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        if (!popup && !forcePopupParentAsOffsetParent) this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop);
        this.isResizing = true;
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    getSiblings() {
        const element = this.element;
        const parent = element.parentElement;
        if (!parent) return null;
        return Array.prototype.slice.call(parent.children).filter((el)=>!el.classList.contains("ag-hidden"));
    }
    getMinSizeOfSiblings() {
        const siblings = this.getSiblings() || [];
        let height = 0;
        let width = 0;
        for(let i = 0; i < siblings.length; i++){
            const currentEl = siblings[i];
            const isFlex = !!currentEl.style.flex && currentEl.style.flex !== "0 0 auto";
            if (currentEl === this.element) continue;
            let nextHeight = this.minHeight || 0;
            let nextWidth = this.minWidth || 0;
            if (isFlex) {
                const computedStyle = window.getComputedStyle(currentEl);
                if (computedStyle.minHeight) nextHeight = Number.parseInt(computedStyle.minHeight, 10);
                if (computedStyle.minWidth) nextWidth = Number.parseInt(computedStyle.minWidth, 10);
            } else {
                nextHeight = currentEl.offsetHeight;
                nextWidth = currentEl.offsetWidth;
            }
            height += nextHeight;
            width += nextWidth;
        }
        return {
            height: height,
            width: width
        };
    }
    applySizeToSiblings(vertical) {
        let containerToFlex = null;
        const siblings = this.getSiblings();
        if (!siblings) return;
        for(let i = 0; i < siblings.length; i++){
            const el = siblings[i];
            if (el === containerToFlex) continue;
            if (vertical) el.style.height = `${el.offsetHeight}px`;
            else el.style.width = `${el.offsetWidth}px`;
            el.style.flex = "0 0 auto";
            if (el === this.element) containerToFlex = siblings[i + 1];
        }
        if (containerToFlex) {
            containerToFlex.style.removeProperty("height");
            containerToFlex.style.removeProperty("min-height");
            containerToFlex.style.removeProperty("max-height");
            containerToFlex.style.flex = "1 1 auto";
        }
    }
    isResizable() {
        return Object.values(this.resizable).some((value)=>value);
    }
    onResize(e) {
        if (!this.isResizing || !this.currentResizer) return;
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        const { isTop: isTop, isRight: isRight, isBottom: isBottom, isLeft: isLeft } = this.currentResizer;
        const isHorizontal = isRight || isLeft;
        const isVertical = isBottom || isTop;
        const { movementX: movementX, movementY: movementY } = this.calculateMouseMovement({
            e: e,
            isLeft: isLeft,
            isTop: isTop
        });
        const xPosition = this.position.x;
        const yPosition = this.position.y;
        let offsetLeft = 0;
        let offsetTop = 0;
        if (isHorizontal && movementX) {
            const direction = isLeft ? -1 : 1;
            const oldWidth = this.getWidth();
            const newWidth = oldWidth + movementX * direction;
            let skipWidth = false;
            if (isLeft) {
                offsetLeft = oldWidth - newWidth;
                if (xPosition + offsetLeft <= 0 || newWidth <= this.minWidth) {
                    skipWidth = true;
                    offsetLeft = 0;
                }
            }
            if (!skipWidth) this.setWidth(newWidth);
        }
        if (isVertical && movementY) {
            const direction = isTop ? -1 : 1;
            const oldHeight = this.getHeight();
            const newHeight = oldHeight + movementY * direction;
            let skipHeight = false;
            if (isTop) {
                offsetTop = oldHeight - newHeight;
                if (yPosition + offsetTop <= 0 || newHeight <= this.minHeight) {
                    skipHeight = true;
                    offsetTop = 0;
                }
            } else if (// do not let the size of all siblings be higher than the parent container
            !this.config.popup && !this.config.forcePopupParentAsOffsetParent && oldHeight < newHeight && this.getMinSizeOfSiblings().height + newHeight > this.element.parentElement.offsetHeight) skipHeight = true;
            if (!skipHeight) this.setHeight(newHeight);
        }
        this.updateDragStartPosition(e.clientX, e.clientY);
        if ((popup || forcePopupParentAsOffsetParent) && offsetLeft || offsetTop) this.offsetElement(xPosition + offsetLeft, yPosition + offsetTop);
    }
    onResizeEnd(e, side) {
        this.isResizing = false;
        this.currentResizer = null;
        this.boundaryEl = null;
        this.element.classList.remove("ag-resizing");
        this.resizerMap[side].element.classList.remove("ag-active");
        this.dispatchLocalEvent({
            type: "resize"
        });
    }
    refreshSize() {
        const eGui = this.element;
        if (this.config.popup) {
            if (!this.config.width) this.setWidth(eGui.offsetWidth);
            if (!this.config.height) this.setHeight(eGui.offsetHeight);
        }
    }
    onMoveStart(e) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.isMoving = true;
        this.element.classList.add("ag-moving");
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMove(e) {
        if (!this.isMoving) return;
        const { x: x, y: y } = this.position;
        let topBuffer;
        if (this.config.calculateTopBuffer) topBuffer = this.config.calculateTopBuffer();
        const { movementX: movementX, movementY: movementY } = this.calculateMouseMovement({
            e: e,
            isTop: true,
            anywhereWithin: true,
            topBuffer: topBuffer
        });
        this.offsetElement(x + movementX, y + movementY);
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMoveEnd() {
        this.isMoving = false;
        this.boundaryEl = null;
        this.element.classList.remove("ag-moving");
    }
    setOffsetParent() {
        if (this.config.forcePopupParentAsOffsetParent && this.popupSvc) this.offsetParent = this.popupSvc.getPopupParent();
        else this.offsetParent = this.element.offsetParent;
    }
    findBoundaryElement() {
        let el = this.element;
        while(el){
            if (window.getComputedStyle(el).position !== "static") return el;
            el = el.parentElement;
        }
        return this.element;
    }
    clearResizeListeners() {
        while(this.resizeListeners.length){
            const params = this.resizeListeners.pop();
            this.dragSvc?.removeDragSource(params);
        }
    }
    destroy() {
        super.destroy();
        if (this.moveElementDragListener) this.dragSvc?.removeDragSource(this.moveElementDragListener);
        this.constrainSizeToAvailableHeight(false);
        this.clearResizeListeners();
        this.removeResizers();
    }
};
// packages/ag-grid-community/src/utils/gridEvent.ts
var $437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION = "__ag_Grid_Stop_Propagation";
function $437b23f6a393c3bf$export$456c40e80134d72a(event) {
    event[$437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION] = true;
}
function $437b23f6a393c3bf$export$9a48e23524c6d58(event) {
    return event[$437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION] === true;
}
// packages/ag-grid-community/src/widgets/managedFocusFeature.ts
var $437b23f6a393c3bf$export$e24a3eb8593af8d8 = "ag-focus-managed";
var $437b23f6a393c3bf$export$5510e53ed3962582 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eFocusable, callbacks = {}){
        super();
        this.eFocusable = eFocusable;
        this.callbacks = callbacks;
        this.callbacks = {
            shouldStopEventPropagation: ()=>false,
            onTabKeyDown: (e)=>{
                if (e.defaultPrevented) return;
                const nextRoot = $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, this.eFocusable, false, e.shiftKey);
                if (!nextRoot) return;
                nextRoot.focus();
                e.preventDefault();
            },
            ...callbacks
        };
    }
    postConstruct() {
        const { eFocusable: eFocusable, callbacks: { onFocusIn: onFocusIn, onFocusOut: onFocusOut } } = this;
        eFocusable.classList.add($437b23f6a393c3bf$export$e24a3eb8593af8d8);
        this.addKeyDownListeners(eFocusable);
        if (onFocusIn) this.addManagedElementListeners(eFocusable, {
            focusin: onFocusIn
        });
        if (onFocusOut) this.addManagedElementListeners(eFocusable, {
            focusout: onFocusOut
        });
    }
    addKeyDownListeners(eGui) {
        this.addManagedElementListeners(eGui, {
            keydown: (e)=>{
                if (e.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(e)) return;
                const { callbacks: callbacks } = this;
                if (callbacks.shouldStopEventPropagation(e)) {
                    $437b23f6a393c3bf$export$456c40e80134d72a(e);
                    return;
                }
                if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) callbacks.onTabKeyDown(e);
                else if (callbacks.handleKeyDown) callbacks.handleKeyDown(e);
            }
        });
    }
};
// packages/ag-grid-community/src/filter/provided/providedFilter.ts
var $437b23f6a393c3bf$export$a927a1327c2cc7f0 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(filterNameKey, cssIdentifier){
        super();
        this.filterNameKey = filterNameKey;
        this.cssIdentifier = cssIdentifier;
        this.applyActive = false;
        this.debouncePending = false;
        // subclasses can override this to provide alternative debounce defaults
        this.defaultDebounceMs = 0;
    }
    postConstruct() {
        const element = {
            tag: "div",
            cls: `ag-filter-body-wrapper ag-${this.cssIdentifier}-body-wrapper`,
            children: [
                this.createBodyTemplate()
            ]
        };
        this.setTemplate(element, this.getAgComponents());
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.getFocusableElement(), {
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
        this.positionableFeature = this.createBean(new $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6(this.getPositionableElement(), {
            forcePopupParentAsOffsetParent: true
        }));
    }
    handleKeyDown(_e) {}
    init(legacyParams) {
        const params = legacyParams;
        this.setParams(params);
        this.setModelIntoUi(params.state.model, true).then(()=>this.updateUiVisibility());
    }
    refresh(legacyNewParams) {
        const newParams = legacyNewParams;
        const oldParams = this.params;
        this.params = newParams;
        const source = newParams.source;
        if (source === "colDef") this.updateParams(newParams, oldParams);
        const newState = newParams.state;
        const oldState = this.state;
        this.state = newState;
        if (newState.model !== oldState.model || newState.state !== oldState.state) this.setModelIntoUi(newState.model);
        return true;
    }
    /** Called on init only. Override in subclasses */ setParams(params) {
        this.params = params;
        this.state = params.state;
        this.commonUpdateParams(params);
    }
    /** Called on refresh only. Override in subclasses */ updateParams(newParams, oldParams) {
        this.commonUpdateParams(newParams, oldParams);
    }
    commonUpdateParams(newParams, _oldParams) {
        this.applyActive = $437b23f6a393c3bf$export$527c1b777ebd9069(newParams);
        this.setupApplyDebounced();
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ doesFilterPass(params) {
        $437b23f6a393c3bf$export$545083624300f13d(283);
        const { getHandler: getHandler, model: model, column: column } = this.params;
        return getHandler().doesFilterPass({
            ...params,
            model: model,
            handlerParams: this.beans.colFilter.getHandlerParams(column)
        });
    }
    getFilterTitle() {
        return this.translate(this.filterNameKey);
    }
    /**
   * @deprecated v34 Filters are active when they have a model. Use `api.getColumnFilterModel()` instead.
   */ isFilterActive() {
        $437b23f6a393c3bf$export$545083624300f13d(284);
        return this.params.model != null;
    }
    setupApplyDebounced() {
        const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(this.params, this.defaultDebounceMs);
        const debounceFunc = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.checkApplyDebounce.bind(this), debounceMs);
        this.applyDebounced = ()=>{
            this.debouncePending = true;
            debounceFunc();
        };
    }
    checkApplyDebounce() {
        if (this.debouncePending) {
            this.debouncePending = false;
            this.doApplyModel();
        }
    }
    /**
   * @deprecated v34 Use (`api.getColumnFilterModel()`) instead.
   */ getModel() {
        $437b23f6a393c3bf$export$545083624300f13d(285);
        return this.params.model;
    }
    /**
   * @deprecated v34 Use (`api.setColumnFilterModel()`) instead.
   */ setModel(model) {
        $437b23f6a393c3bf$export$545083624300f13d(286);
        const { beans: beans, params: params } = this;
        return beans.colFilter.setModelForColumnLegacy(params.column, model);
    }
    /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */ applyModel(_source = "api") {
        return this.doApplyModel();
    }
    canApply(_model) {
        return true;
    }
    doApplyModel(additionalEventAttributes) {
        const { params: params, state: state } = this;
        const changed = !this.areModelsEqual(params.model, state.model);
        if (changed) params.onAction("apply", additionalEventAttributes);
        return changed;
    }
    /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */ onNewRowsLoaded() {}
    /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */ onUiChanged(apply, afterFloatingFilter = false) {
        this.updateUiVisibility();
        const model = this.getModelFromUi();
        const state = {
            model: model,
            state: this.getState(),
            valid: this.canApply(model)
        };
        this.state = state;
        const params = this.params;
        params.onStateChange(state);
        params.onUiChange(this.getUiChangeEventParams());
        if (!this.gos.get("enableFilterHandlers")) this.eventSvc.dispatchEvent({
            type: "filterModified",
            column: params.column,
            filterInstance: this
        });
        apply ?? (apply = this.applyActive ? void 0 : "debounce");
        if (apply === "immediately") this.doApplyModel({
            afterFloatingFilter: afterFloatingFilter,
            afterDataChange: false
        });
        else if (apply === "debounce") this.applyDebounced();
    }
    getState() {
        return void 0;
    }
    getUiChangeEventParams() {
        return void 0;
    }
    afterGuiAttached(params) {
        this.lastContainerType = params?.container;
        this.refreshFilterResizer(params?.container);
    }
    refreshFilterResizer(containerType) {
        const { positionableFeature: positionableFeature, gos: gos } = this;
        if (!positionableFeature) return;
        const isResizable = containerType === "floatingFilter" || containerType === "columnFilter";
        if (isResizable) {
            positionableFeature.restoreLastSize();
            positionableFeature.setResizable(gos.get("enableRtl") ? {
                bottom: true,
                bottomLeft: true,
                left: true
            } : {
                bottom: true,
                bottomRight: true,
                right: true
            });
        } else {
            positionableFeature.removeSizeFromEl();
            positionableFeature.setResizable(false);
        }
        positionableFeature.constrainSizeToAvailableHeight(isResizable);
    }
    afterGuiDetached() {
        this.checkApplyDebounce();
        this.positionableFeature?.constrainSizeToAvailableHeight(false);
    }
    destroy() {
        this.positionableFeature = this.destroyBean(this.positionableFeature);
        super.destroy();
    }
    translate(key) {
        return $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, key);
    }
    // override to control positionable feature
    getPositionableElement() {
        return this.getGui();
    }
    areModelsEqual(a, b) {
        if (a === b || a == null && b == null) return true;
        if (a == null || b == null) return false;
        return this.areNonNullModelsEqual(a, b);
    }
};
// packages/ag-grid-community/src/filter/provided/iSimpleFilter.ts
function $437b23f6a393c3bf$export$a3f343af66a0c1bd(model) {
    return !!model.operator;
}
// packages/ag-grid-community/src/filter/floating/floatingFilterMapper.ts
function $437b23f6a393c3bf$export$47072b32bdaf5d61(frameworkOverrides, def, getFromDefault) {
    if (def == null) return null;
    let defaultFloatingFilterType = null;
    const { compName: compName, jsComp: jsComp, fwComp: fwComp } = $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, def);
    if (compName) {
        const floatingFilterTypeMap = {
            agSetColumnFilter: "agSetColumnFloatingFilter",
            agMultiColumnFilter: "agMultiColumnFloatingFilter",
            agGroupColumnFilter: "agGroupColumnFloatingFilter",
            agNumberColumnFilter: "agNumberColumnFloatingFilter",
            agDateColumnFilter: "agDateColumnFloatingFilter",
            agTextColumnFilter: "agTextColumnFloatingFilter"
        };
        defaultFloatingFilterType = floatingFilterTypeMap[compName];
    } else {
        const usingDefaultFilter = jsComp == null && fwComp == null && def.filter === true;
        if (usingDefaultFilter) defaultFloatingFilterType = getFromDefault();
    }
    return defaultFloatingFilterType;
}
// packages/ag-grid-community/src/interfaces/structuredSchemaParams.ts
var $437b23f6a393c3bf$export$e85ca1dd7f3d099e = [
    "aggregation",
    "filter",
    "sort",
    "pivot",
    "columnVisibility",
    "columnSizing",
    "rowGroup"
];
// packages/ag-grid-community/src/styling/layoutFeature.ts
var $437b23f6a393c3bf$var$LayoutCssClasses = {
    AUTO_HEIGHT: "ag-layout-auto-height",
    NORMAL: "ag-layout-normal",
    PRINT: "ag-layout-print"
};
var $437b23f6a393c3bf$var$LayoutFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(view){
        super();
        this.view = view;
    }
    postConstruct() {
        this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this));
        this.updateLayoutClasses();
    }
    updateLayoutClasses() {
        const domLayout = this.gos.get("domLayout");
        const params = {
            autoHeight: domLayout === "autoHeight",
            normal: domLayout === "normal",
            print: domLayout === "print"
        };
        const cssClass = params.autoHeight ? $437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT : params.print ? $437b23f6a393c3bf$var$LayoutCssClasses.PRINT : $437b23f6a393c3bf$var$LayoutCssClasses.NORMAL;
        this.view.updateLayoutClasses(cssClass, params);
    }
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyScrollFeature.ts
var $437b23f6a393c3bf$var$VIEWPORT = "Viewport";
var $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR = "fakeVScrollComp";
var $437b23f6a393c3bf$var$HORIZONTAL_SOURCES = [
    "fakeHScrollComp",
    "centerHeader",
    "topCenter",
    "bottomCenter",
    "stickyTopCenter",
    "stickyBottomCenter"
];
var $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT = 100;
var $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT = 150;
var $437b23f6a393c3bf$var$GridBodyScrollFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eBodyViewport){
        super();
        // listeners for when ensureIndexVisible is waiting for SSRM data to load
        this.clearRetryListenerFncs = [];
        this.lastScrollSource = [
            null,
            null
        ];
        this.scrollLeft = -1;
        this.nextScrollTop = -1;
        this.scrollTop = -1;
        // Used to provide approximate values of scrollTop and offsetHeight
        // without forcing the browser to recalculate styles.
        this.lastOffsetHeight = -1;
        this.lastScrollTop = -1;
        this.lastIsHorizontalScrollShowing = false;
        this.scrollTimer = 0;
        this.isScrollActive = false;
        this.isVerticalPositionInvalidated = true;
        this.isHorizontalPositionInvalidated = true;
        this.eBodyViewport = eBodyViewport;
        this.resetLastHScrollDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.lastScrollSource[1 /* Horizontal */ ] = null, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
        this.resetLastVScrollDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.lastScrollSource[0 /* Vertical */ ] = null, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.animationFrameSvc = beans.animationFrameSvc;
        this.visibleCols = beans.visibleCols;
    }
    destroy() {
        super.destroy();
        this.clearRetryListenerFncs = [];
        window.clearTimeout(this.scrollTimer);
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        const invalidateVerticalScroll = this.invalidateVerticalScroll.bind(this);
        const invalidateHorizontalScroll = this.invalidateHorizontalScroll.bind(this);
        this.addManagedEventListeners({
            displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this),
            bodyHeightChanged: invalidateVerticalScroll,
            // We only invalidate horizontal scrolling when the viewport switches
            // between scrollable and non-scrollable, avoiding unnecessary
            // invalidation on every gridSizeChanged event. If more properties
            // require invalidation, read/write DOM cycles may be needed.
            scrollGapChanged: invalidateHorizontalScroll
        });
        this.addManagedElementListeners(this.eBodyViewport, {
            scroll: invalidateVerticalScroll
        });
        this.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowsCtrl = p.center;
            this.onDisplayedColumnsWidthChanged();
            this.addScrollListener();
        });
    }
    invalidateHorizontalScroll() {
        this.isHorizontalPositionInvalidated = true;
    }
    invalidateVerticalScroll() {
        this.isVerticalPositionInvalidated = true;
    }
    addScrollListener() {
        this.addHorizontalScrollListeners();
        this.addVerticalScrollListeners();
    }
    addHorizontalScrollListeners() {
        this.addManagedElementListeners(this.centerRowsCtrl.eViewport, {
            scroll: this.onHScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT)
        });
        for (const source of $437b23f6a393c3bf$var$HORIZONTAL_SOURCES){
            const scrollPartner = this.ctrlsSvc.get(source);
            this.registerScrollPartner(scrollPartner, this.onHScroll.bind(this, source));
        }
    }
    addVerticalScrollListeners() {
        const fakeVScrollComp = this.ctrlsSvc.get("fakeVScrollComp");
        const isDebounce = this.gos.get("debounceVerticalScrollbar");
        const onVScroll = isDebounce ? $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onVScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT), $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT) : this.onVScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT);
        const onFakeVScroll = isDebounce ? $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onVScroll.bind(this, $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR), $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT) : this.onVScroll.bind(this, $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR);
        this.addManagedElementListeners(this.eBodyViewport, {
            scroll: onVScroll
        });
        this.registerScrollPartner(fakeVScrollComp, onFakeVScroll);
    }
    registerScrollPartner(comp, callback) {
        comp.onScrollCallback(callback);
    }
    onDisplayedColumnsWidthChanged() {
        if (this.enableRtl) this.horizontallyScrollHeaderCenterAndFloatingCenter();
    }
    horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft) {
        const notYetInitialised = this.centerRowsCtrl == null;
        if (notYetInitialised) return;
        if (scrollLeft === void 0) scrollLeft = this.centerRowsCtrl.getCenterViewportScrollLeft();
        this.setScrollLeftForAllContainersExceptCurrent(Math.abs(scrollLeft));
    }
    setScrollLeftForAllContainersExceptCurrent(scrollLeft) {
        for (const container of [
            ...$437b23f6a393c3bf$var$HORIZONTAL_SOURCES,
            $437b23f6a393c3bf$var$VIEWPORT
        ]){
            if (this.lastScrollSource[1 /* Horizontal */ ] === container) continue;
            const viewport = this.getViewportForSource(container);
            $437b23f6a393c3bf$var$_setScrollLeft(viewport, scrollLeft, this.enableRtl);
        }
    }
    getViewportForSource(source) {
        if (source === $437b23f6a393c3bf$var$VIEWPORT) return this.centerRowsCtrl.eViewport;
        return this.ctrlsSvc.get(source).eViewport;
    }
    isControllingScroll(source, direction) {
        if (this.lastScrollSource[direction] == null) {
            if (direction === 0 /* Vertical */ ) this.lastScrollSource[0] = source;
            else this.lastScrollSource[1] = source;
            return true;
        }
        return this.lastScrollSource[direction] === source;
    }
    onHScroll(source) {
        if (!this.isControllingScroll(source, 1 /* Horizontal */ )) return;
        const centerContainerViewport = this.centerRowsCtrl.eViewport;
        const { scrollLeft: scrollLeft } = centerContainerViewport;
        if (this.shouldBlockScrollUpdate(1 /* Horizontal */ , scrollLeft, true)) return;
        const newScrollLeft = $437b23f6a393c3bf$var$_getScrollLeft(this.getViewportForSource(source), this.enableRtl);
        this.doHorizontalScroll(newScrollLeft);
        this.resetLastHScrollDebounced();
    }
    onVScroll(source) {
        if (!this.isControllingScroll(source, 0 /* Vertical */ )) return;
        let scrollTop;
        if (source === $437b23f6a393c3bf$var$VIEWPORT) scrollTop = this.eBodyViewport.scrollTop;
        else scrollTop = this.ctrlsSvc.get("fakeVScrollComp").getScrollPosition();
        if (this.shouldBlockScrollUpdate(0 /* Vertical */ , scrollTop, true)) return;
        const { animationFrameSvc: animationFrameSvc } = this;
        animationFrameSvc?.setScrollTop(scrollTop);
        this.nextScrollTop = scrollTop;
        if (source === $437b23f6a393c3bf$var$VIEWPORT) this.ctrlsSvc.get("fakeVScrollComp").setScrollPosition(scrollTop);
        else this.eBodyViewport.scrollTop = scrollTop;
        if (animationFrameSvc?.active) animationFrameSvc.schedule();
        else this.scrollGridIfNeeded(true);
        this.resetLastVScrollDebounced();
    }
    doHorizontalScroll(scrollLeft) {
        const fakeScrollLeft = this.ctrlsSvc.get("fakeHScrollComp").getScrollPosition();
        if (this.scrollLeft === scrollLeft && scrollLeft === fakeScrollLeft) return;
        this.scrollLeft = scrollLeft;
        this.fireScrollEvent(1 /* Horizontal */ );
        this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
        this.centerRowsCtrl.onHorizontalViewportChanged(true);
    }
    isScrolling() {
        return this.isScrollActive;
    }
    fireScrollEvent(direction) {
        const bodyScrollEvent = {
            type: "bodyScroll",
            direction: direction === 1 /* Horizontal */  ? "horizontal" : "vertical",
            left: this.scrollLeft,
            top: this.scrollTop
        };
        this.isScrollActive = true;
        this.eventSvc.dispatchEvent(bodyScrollEvent);
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(()=>{
            this.scrollTimer = 0;
            this.isScrollActive = false;
            this.eventSvc.dispatchEvent({
                ...bodyScrollEvent,
                type: "bodyScrollEnd"
            });
        }, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
    }
    shouldBlockScrollUpdate(direction, scrollTo, touchOnly = false) {
        if (touchOnly && !$437b23f6a393c3bf$export$6b6034a68325bd8a()) return false;
        if (direction === 0 /* Vertical */ ) return this.shouldBlockVerticalScroll(scrollTo);
        return this.shouldBlockHorizontalScroll(scrollTo);
    }
    shouldBlockVerticalScroll(scrollTo) {
        const clientHeight = $437b23f6a393c3bf$export$c20e968103d9c16e(this.eBodyViewport);
        const { scrollHeight: scrollHeight } = this.eBodyViewport;
        return !!(scrollTo < 0 || scrollTo + clientHeight > scrollHeight);
    }
    shouldBlockHorizontalScroll(scrollTo) {
        const clientWidth = this.centerRowsCtrl.getCenterWidth();
        const { scrollWidth: scrollWidth } = this.centerRowsCtrl.eViewport;
        if (this.enableRtl) {
            if (scrollTo > 0) return true;
        } else if (scrollTo < 0) return true;
        return Math.abs(scrollTo) + clientWidth > scrollWidth;
    }
    redrawRowsAfterScroll() {
        this.fireScrollEvent(0 /* Vertical */ );
    }
    // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
    // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
    // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
    // back to the left to be kept in sync.
    // adding and removing the grid from the DOM both resets the scroll position and
    // triggers a resize event, so notify listeners if the scroll position has changed
    checkScrollLeft() {
        const scrollLeft = this.scrollLeft;
        let hasHorizontalScrollersOutOfSync = false;
        for (const source of $437b23f6a393c3bf$var$HORIZONTAL_SOURCES){
            const viewport = this.getViewportForSource(source);
            if (viewport.scrollLeft !== scrollLeft) {
                hasHorizontalScrollersOutOfSync = true;
                break;
            }
        }
        if (hasHorizontalScrollersOutOfSync) this.onHScroll($437b23f6a393c3bf$var$VIEWPORT);
    }
    scrollGridIfNeeded(suppressedAnimationFrame = false) {
        const frameNeeded = this.scrollTop != this.nextScrollTop;
        if (frameNeeded) {
            this.scrollTop = this.nextScrollTop;
            if (suppressedAnimationFrame) this.invalidateVerticalScroll();
            this.redrawRowsAfterScroll();
        }
        return frameNeeded;
    }
    // called by scrollHorizontally method and alignedGridsService
    setHorizontalScrollPosition(hScrollPosition, fromAlignedGridsService = false) {
        const minScrollLeft = 0;
        const maxScrollLeft = this.centerRowsCtrl.eViewport.scrollWidth - this.centerRowsCtrl.getCenterWidth();
        if (!fromAlignedGridsService && this.shouldBlockScrollUpdate(1 /* Horizontal */ , hScrollPosition)) {
            if (this.enableRtl) hScrollPosition = hScrollPosition > 0 ? 0 : maxScrollLeft;
            else hScrollPosition = Math.min(Math.max(hScrollPosition, minScrollLeft), maxScrollLeft);
        }
        $437b23f6a393c3bf$var$_setScrollLeft(this.centerRowsCtrl.eViewport, Math.abs(hScrollPosition), this.enableRtl);
        this.doHorizontalScroll(hScrollPosition);
    }
    setVerticalScrollPosition(vScrollPosition) {
        this.invalidateVerticalScroll();
        this.eBodyViewport.scrollTop = vScrollPosition;
    }
    getVScrollPosition() {
        if (!this.isVerticalPositionInvalidated) {
            const { lastOffsetHeight: lastOffsetHeight, lastScrollTop: lastScrollTop } = this;
            return {
                top: lastScrollTop,
                bottom: lastScrollTop + lastOffsetHeight
            };
        }
        this.isVerticalPositionInvalidated = false;
        const { scrollTop: scrollTop, offsetHeight: offsetHeight } = this.eBodyViewport;
        this.lastScrollTop = scrollTop;
        this.lastOffsetHeight = offsetHeight;
        return {
            top: scrollTop,
            bottom: scrollTop + offsetHeight
        };
    }
    /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */ getApproximateVScollPosition() {
        if (this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0) return {
            top: this.scrollTop,
            bottom: this.scrollTop + this.lastOffsetHeight
        };
        return this.getVScrollPosition();
    }
    getHScrollPosition() {
        return this.centerRowsCtrl.getHScrollPosition();
    }
    isHorizontalScrollShowing() {
        if (this.isHorizontalPositionInvalidated) {
            this.lastIsHorizontalScrollShowing = this.centerRowsCtrl.isHorizontalScrollShowing();
            this.isHorizontalPositionInvalidated = false;
        }
        return this.lastIsHorizontalScrollShowing;
    }
    // called by the headerRootComp and moveColumnController
    scrollHorizontally(pixels) {
        const oldScrollPosition = this.centerRowsCtrl.eViewport.scrollLeft;
        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
        return this.centerRowsCtrl.eViewport.scrollLeft - oldScrollPosition;
    }
    // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
    scrollToTop() {
        this.eBodyViewport.scrollTop = 0;
    }
    // Valid values for position are bottom, middle and top
    ensureNodeVisible(comparator, position = null) {
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.getRowCount();
        let indexToSelect = -1;
        for(let i = 0; i < rowCount; i++){
            const node = rowModel.getRow(i);
            if (typeof comparator === "function") {
                const predicate = comparator;
                if (node && predicate(node)) {
                    indexToSelect = i;
                    break;
                }
            } else if (comparator === node || comparator === node.data) {
                indexToSelect = i;
                break;
            }
        }
        if (indexToSelect >= 0) this.ensureIndexVisible(indexToSelect, position);
    }
    // Valid values for position are bottom, middle and top
    // position should be {'top','middle','bottom', or undefined/null}.
    // if undefined/null, then the grid will to the minimal amount of scrolling,
    // eg if grid needs to scroll up, it scrolls until row is on top,
    //    if grid needs to scroll down, it scrolls until row is on bottom,
    //    if row is already in view, grid does not scroll
    ensureIndexVisible(index, position, retry = 0) {
        if ($437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print")) return;
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.getRowCount();
        if (typeof index !== "number" || index < 0 || index >= rowCount) {
            $437b23f6a393c3bf$export$545083624300f13d(88, {
                index: index
            });
            return;
        }
        this.clearRetryListeners();
        const { frameworkOverrides: frameworkOverrides, pageBounds: pageBounds, rowContainerHeight: heightScaler, rowRenderer: rowRenderer } = this.beans;
        frameworkOverrides.wrapIncoming(()=>{
            const gridBodyCtrl = this.ctrlsSvc.getGridBodyCtrl();
            const rowNode = rowModel.getRow(index);
            let rowGotShiftedDuringOperation;
            let stickyHeightsChanged;
            let attempt = 0;
            this.invalidateVerticalScroll();
            do {
                const { stickyTopHeight: stickyTopHeight, stickyBottomHeight: stickyBottomHeight } = gridBodyCtrl;
                const startingRowTop = rowNode.rowTop;
                const startingRowHeight = rowNode.rowHeight;
                const paginationOffset = pageBounds.getPixelOffset();
                const rowTopPixel = rowNode.rowTop - paginationOffset;
                const rowBottomPixel = rowTopPixel + rowNode.rowHeight;
                const scrollPosition = this.getVScrollPosition();
                const heightOffset = heightScaler.divStretchOffset;
                const vScrollTop = scrollPosition.top + heightOffset;
                const vScrollBottom = scrollPosition.bottom + heightOffset;
                const viewportHeight = vScrollBottom - vScrollTop;
                const pxTop = heightScaler.getScrollPositionForPixel(rowTopPixel);
                const pxBottom = heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);
                const pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
                const rowAboveViewport = vScrollTop + stickyTopHeight > rowTopPixel;
                const rowBelowViewport = vScrollBottom - stickyBottomHeight < rowBottomPixel;
                let newScrollPosition = null;
                if (position === "top") newScrollPosition = pxTop - stickyTopHeight;
                else if (position === "bottom") newScrollPosition = pxBottom + stickyBottomHeight;
                else if (position === "middle") newScrollPosition = pxMiddle;
                else if (rowAboveViewport) newScrollPosition = pxTop - stickyTopHeight;
                else if (rowBelowViewport) {
                    if (pxBottom - pxTop > viewportHeight) newScrollPosition = pxTop - stickyTopHeight;
                    else newScrollPosition = pxBottom + stickyBottomHeight;
                }
                if (newScrollPosition !== null) {
                    this.setVerticalScrollPosition(newScrollPosition);
                    rowRenderer.redraw({
                        afterScroll: true
                    });
                }
                rowGotShiftedDuringOperation = startingRowTop !== rowNode.rowTop || startingRowHeight !== rowNode.rowHeight;
                stickyHeightsChanged = stickyTopHeight !== gridBodyCtrl.stickyTopHeight || stickyBottomHeight !== gridBodyCtrl.stickyBottomHeight;
                attempt++;
            }while ((rowGotShiftedDuringOperation || stickyHeightsChanged) && attempt < 10);
            this.animationFrameSvc?.flushAllFrames();
            if (retry < 10 && (rowNode?.stub || !this.beans.rowAutoHeight?.areRowsMeasured())) {
                const scrollTop = this.getVScrollPosition().top;
                this.clearRetryListenerFncs = this.addManagedEventListeners({
                    bodyScroll: ()=>{
                        const newScrollTop = this.getVScrollPosition().top;
                        if (scrollTop === newScrollTop) return;
                        this.clearRetryListeners();
                    },
                    modelUpdated: ()=>{
                        this.clearRetryListeners();
                        if (index >= rowModel.getRowCount()) return;
                        this.ensureIndexVisible(index, position, retry + 1);
                    }
                });
            }
        });
    }
    clearRetryListeners() {
        for (const callback of this.clearRetryListenerFncs)callback();
        this.clearRetryListenerFncs = [];
    }
    ensureColumnVisible(key, position = "auto") {
        const { colModel: colModel, frameworkOverrides: frameworkOverrides } = this.beans;
        const column = colModel.getCol(key);
        if (!column) return;
        if (column.isPinned()) return;
        if (!this.visibleCols.isColDisplayed(column)) return;
        const newHorizontalScroll = this.getPositionedHorizontalScroll(column, position);
        frameworkOverrides.wrapIncoming(()=>{
            if (newHorizontalScroll !== null) this.centerRowsCtrl.setCenterViewportScrollLeft(newHorizontalScroll);
            this.centerRowsCtrl.onHorizontalViewportChanged();
            this.animationFrameSvc?.flushAllFrames();
        });
    }
    getPositionedHorizontalScroll(column, position) {
        const { columnBeforeStart: columnBeforeStart, columnAfterEnd: columnAfterEnd } = this.isColumnOutsideViewport(column);
        const viewportTooSmallForColumn = this.centerRowsCtrl.getCenterWidth() < column.getActualWidth();
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const isRtl = this.enableRtl;
        let alignColToStart = (isRtl ? columnBeforeStart : columnAfterEnd) || viewportTooSmallForColumn;
        let alignColToEnd = isRtl ? columnAfterEnd : columnBeforeStart;
        if (position !== "auto") {
            alignColToStart = position === "start";
            alignColToEnd = position === "end";
        }
        const isMiddle = position === "middle";
        if (alignColToStart || alignColToEnd || isMiddle) {
            const { colLeft: colLeft, colMiddle: colMiddle, colRight: colRight } = this.getColumnBounds(column);
            if (isMiddle) return colMiddle - viewportWidth / 2;
            if (alignColToStart) return isRtl ? colRight : colLeft;
            return isRtl ? colLeft - viewportWidth : colRight - viewportWidth;
        }
        return null;
    }
    isColumnOutsideViewport(column) {
        const { start: viewportStart, end: viewportEnd } = this.getViewportBounds();
        const { colLeft: colLeft, colRight: colRight } = this.getColumnBounds(column);
        const isRtl = this.enableRtl;
        const columnBeforeStart = isRtl ? viewportStart > colRight : viewportEnd < colRight;
        const columnAfterEnd = isRtl ? viewportEnd < colLeft : viewportStart > colLeft;
        return {
            columnBeforeStart: columnBeforeStart,
            columnAfterEnd: columnAfterEnd
        };
    }
    getColumnBounds(column) {
        const isRtl = this.enableRtl;
        const bodyWidth = this.visibleCols.bodyWidth;
        const colWidth = column.getActualWidth();
        const colLeft = column.getLeft();
        const multiplier = isRtl ? -1 : 1;
        const colLeftPixel = isRtl ? bodyWidth - colLeft : colLeft;
        const colRightPixel = colLeftPixel + colWidth * multiplier;
        const colMidPixel = colLeftPixel + colWidth / 2 * multiplier;
        return {
            colLeft: colLeftPixel,
            colMiddle: colMidPixel,
            colRight: colRightPixel
        };
    }
    getViewportBounds() {
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const scrollPosition = this.centerRowsCtrl.getCenterViewportScrollLeft();
        const viewportStartPixel = scrollPosition;
        const viewportEndPixel = viewportWidth + scrollPosition;
        return {
            start: viewportStartPixel,
            end: viewportEndPixel,
            width: viewportWidth
        };
    }
};
// packages/ag-grid-community/src/gridBodyComp/centerWidthFeature.ts
var $437b23f6a393c3bf$var$CenterWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(callback, addSpacer = false){
        super();
        this.callback = callback;
        this.addSpacer = addSpacer;
    }
    postConstruct() {
        const listener = this.setWidth.bind(this);
        this.addManagedPropertyListener("domLayout", listener);
        this.addManagedEventListeners({
            columnContainerWidthChanged: listener,
            displayedColumnsChanged: listener,
            leftPinnedWidthChanged: listener
        });
        if (this.addSpacer) this.addManagedEventListeners({
            rightPinnedWidthChanged: listener,
            scrollVisibilityChanged: listener,
            scrollbarWidthChanged: listener
        });
        this.setWidth();
    }
    setWidth() {
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const { visibleCols: visibleCols, scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        const centerWidth = visibleCols.bodyWidth;
        const leftWidth = visibleCols.getColsLeftWidth();
        const rightWidth = visibleCols.getDisplayedColumnsRightWidth();
        let totalWidth;
        if (printLayout) totalWidth = centerWidth + leftWidth + rightWidth;
        else {
            totalWidth = centerWidth;
            if (this.addSpacer) {
                const relevantWidth = this.gos.get("enableRtl") ? leftWidth : rightWidth;
                if (relevantWidth === 0 && scrollVisibleSvc.verticalScrollShowing) totalWidth += scrollVisibleSvc.getScrollbarWidth();
            }
        }
        this.callback(totalWidth);
    }
};
// packages/ag-grid-community/src/gridBodyComp/viewportSizeFeature.ts
var $437b23f6a393c3bf$var$ViewportSizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(centerContainerCtrl){
        super();
        this.centerContainerCtrl = centerContainerCtrl;
    }
    wireBeans(beans) {
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.listenForResize();
        });
        this.addManagedEventListeners({
            scrollbarWidthChanged: this.onScrollbarWidthChanged.bind(this)
        });
        this.addManagedPropertyListeners([
            "alwaysShowHorizontalScroll",
            "alwaysShowVerticalScroll"
        ], ()=>{
            this.checkViewportAndScrolls();
        });
    }
    listenForResize() {
        const { beans: beans, centerContainerCtrl: centerContainerCtrl, gridBodyCtrl: gridBodyCtrl } = this;
        const listener = ()=>{
            $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>{
                this.onCenterViewportResized();
            });
        };
        centerContainerCtrl.registerViewportResizeListener(listener);
        gridBodyCtrl.registerBodyViewportResizeListener(listener);
    }
    onScrollbarWidthChanged() {
        this.checkViewportAndScrolls();
    }
    onCenterViewportResized() {
        this.scrollVisibleSvc.updateScrollGap();
        if (this.centerContainerCtrl.isViewportInTheDOMTree()) {
            const { pinnedCols: pinnedCols, colFlex: colFlex } = this.beans;
            pinnedCols?.keepPinnedColumnsNarrowerThanViewport();
            this.checkViewportAndScrolls();
            const newWidth = this.centerContainerCtrl.getCenterWidth();
            if (newWidth !== this.centerWidth) {
                this.centerWidth = newWidth;
                colFlex?.refreshFlexedColumns({
                    viewportWidth: this.centerWidth,
                    updateBodyWidths: true,
                    fireResizedEvent: true
                });
            }
        } else this.bodyHeight = 0;
    }
    // gets called every time the viewport size changes. we use this to check visibility of scrollbars
    // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
    checkViewportAndScrolls() {
        this.updateScrollVisibleService();
        this.checkBodyHeight();
        this.onHorizontalViewportChanged();
        this.gridBodyCtrl.scrollFeature.checkScrollLeft();
    }
    getBodyHeight() {
        return this.bodyHeight;
    }
    checkBodyHeight() {
        const eBodyViewport = this.gridBodyCtrl.eBodyViewport;
        const bodyHeight = $437b23f6a393c3bf$export$c20e968103d9c16e(eBodyViewport);
        if (this.bodyHeight !== bodyHeight) {
            this.bodyHeight = bodyHeight;
            this.eventSvc.dispatchEvent({
                type: "bodyHeightChanged"
            });
        }
    }
    updateScrollVisibleService() {
        this.updateScrollVisibleServiceImpl();
        setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
    }
    updateScrollVisibleServiceImpl() {
        if (!this.isAlive()) return;
        const params = {
            horizontalScrollShowing: this.centerContainerCtrl.isHorizontalScrollShowing(),
            verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
        };
        this.scrollVisibleSvc.setScrollsVisible(params);
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged() {
        const scrollWidth = this.centerContainerCtrl.getCenterWidth();
        const scrollPosition = this.centerContainerCtrl.getViewportScrollLeft();
        this.beans.colViewport.setScrollPosition(scrollWidth, scrollPosition);
    }
};
// packages/ag-grid-community/src/rendering/renderUtils.ts
function $437b23f6a393c3bf$export$d7866551eadae1d3(gos, column, node, event) {
    const suppressMouseEventHandling = column.getColDef().cellRendererParams?.suppressMouseEventHandling;
    return $437b23f6a393c3bf$var$suppressMouseEvent(gos, column, node, event, suppressMouseEventHandling);
}
function $437b23f6a393c3bf$var$_suppressFullWidthMouseEvent(gos, cellRendererParams, node, event) {
    const suppressMouseEventHandling = cellRendererParams?.suppressMouseEventHandling;
    return $437b23f6a393c3bf$var$suppressMouseEvent(gos, void 0, node, event, suppressMouseEventHandling);
}
function $437b23f6a393c3bf$var$suppressMouseEvent(gos, column, node, event, suppressMouseEventHandling) {
    if (!suppressMouseEventHandling) return false;
    return suppressMouseEventHandling($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        column: column,
        node: node,
        event: event
    }));
}
function $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, eventTarget, type) {
    let sourceElement = eventTarget;
    while(sourceElement){
        const renderedComp = $437b23f6a393c3bf$var$_getDomData(gos, sourceElement, type);
        if (renderedComp) return renderedComp;
        sourceElement = sourceElement.parentElement;
    }
    return null;
}
var $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL = "cellCtrl";
function $437b23f6a393c3bf$export$b5bf61dcea514250(gos, eventTarget) {
    return $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, eventTarget, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL);
}
var $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL = "renderedRow";
function $437b23f6a393c3bf$export$d06ffa2f01e3cdc7(gos, eventTarget) {
    return $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, eventTarget, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL);
}
// packages/ag-grid-community/src/utils/keyboardEvent.ts
function $437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(gos, keyboardEvent, rowNode, column, editing) {
    const colDefFunc = column ? column.getColDef().suppressKeyboardEvent : void 0;
    if (!colDefFunc) return false;
    const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        event: keyboardEvent,
        editing: editing,
        column: column,
        node: rowNode,
        data: rowNode.data,
        colDef: column.getColDef()
    });
    if (colDefFunc) {
        const colDefFuncResult = colDefFunc(params);
        if (colDefFuncResult) return true;
    }
    return false;
}
// packages/ag-grid-community/src/utils/selection.ts
function $437b23f6a393c3bf$export$57896ee3d2f5a3d(beans) {
    const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    const [isEmptyPinnedTop, isEmptyPinnedBottom] = [
        pinnedRowModel?.isEmpty("top") ?? true,
        pinnedRowModel?.isEmpty("bottom") ?? true
    ];
    const floatingStart = isEmptyPinnedTop ? null : "top";
    let floatingEnd;
    let rowEnd;
    if (isEmptyPinnedBottom) {
        floatingEnd = null;
        rowEnd = rowModel.getRowCount() - 1;
    } else {
        floatingEnd = "bottom";
        rowEnd = pinnedRowModel?.getPinnedBottomRowCount() ?? -1;
    }
    const { visibleCols: visibleCols, rangeSvc: rangeSvc } = beans;
    const allDisplayedColumns = visibleCols.allCols;
    if (!rangeSvc || !allDisplayedColumns?.length) return;
    rangeSvc.setCellRange({
        rowStartIndex: 0,
        rowStartPinned: floatingStart,
        rowEndIndex: rowEnd,
        rowEndPinned: floatingEnd
    });
}
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerEventsFeature.ts
var $437b23f6a393c3bf$var$A_KEYCODE = 65;
var $437b23f6a393c3bf$var$C_KEYCODE = 67;
var $437b23f6a393c3bf$var$V_KEYCODE = 86;
var $437b23f6a393c3bf$var$D_KEYCODE = 68;
var $437b23f6a393c3bf$var$Z_KEYCODE = 90;
var $437b23f6a393c3bf$var$Y_KEYCODE = 89;
function $437b23f6a393c3bf$var$_normaliseQwertyAzerty(keyboardEvent) {
    const { keyCode: keyCode } = keyboardEvent;
    let code;
    switch(keyCode){
        case $437b23f6a393c3bf$var$A_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.A;
            break;
        case $437b23f6a393c3bf$var$C_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.C;
            break;
        case $437b23f6a393c3bf$var$V_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.V;
            break;
        case $437b23f6a393c3bf$var$D_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.D;
            break;
        case $437b23f6a393c3bf$var$Z_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.Z;
            break;
        case $437b23f6a393c3bf$var$Y_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.Y;
            break;
        default:
            code = keyboardEvent.code;
    }
    return code;
}
var $437b23f6a393c3bf$var$RowContainerEventsFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element){
        super();
        this.element = element;
    }
    postConstruct() {
        this.addKeyboardListeners();
        this.addMouseListeners();
        this.beans.touchSvc?.mockRowContextMenu(this);
        this.editSvc = this.beans.editSvc;
    }
    addKeyboardListeners() {
        const eventName = "keydown";
        const listener = this.processKeyboardEvent.bind(this, eventName);
        this.addManagedElementListeners(this.element, {
            [eventName]: listener
        });
    }
    addMouseListeners() {
        const mouseDownEvent = $437b23f6a393c3bf$var$_isEventSupported("touchstart") ? "touchstart" : "mousedown";
        const eventNames = [
            "dblclick",
            "contextmenu",
            "mouseover",
            "mouseout",
            "click",
            mouseDownEvent
        ];
        for (const eventName of eventNames){
            const listener = this.processMouseEvent.bind(this, eventName);
            this.addManagedElementListeners(this.element, {
                [eventName]: listener
            });
        }
    }
    processMouseEvent(eventName, mouseEvent) {
        if (!$437b23f6a393c3bf$var$_isEventFromThisInstance(this.beans, mouseEvent) || $437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(mouseEvent.target);
        if (eventName === "contextmenu") {
            if (cellCtrl?.column) cellCtrl.dispatchCellContextMenuEvent(mouseEvent);
            this.beans.contextMenuSvc?.handleContextMenuMouseEvent(mouseEvent, void 0, rowCtrl, cellCtrl);
        } else {
            if (cellCtrl) cellCtrl.onMouseEvent(eventName, mouseEvent);
            if (rowCtrl) rowCtrl.onMouseEvent(eventName, mouseEvent);
        }
    }
    getControlsForEventTarget(target) {
        const { gos: gos } = this;
        return {
            cellCtrl: $437b23f6a393c3bf$export$b5bf61dcea514250(gos, target),
            rowCtrl: $437b23f6a393c3bf$export$d06ffa2f01e3cdc7(gos, target)
        };
    }
    processKeyboardEvent(eventName, keyboardEvent) {
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(keyboardEvent.target);
        if (keyboardEvent.defaultPrevented) return;
        if (cellCtrl) this.processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent);
        else if (rowCtrl?.isFullWidth()) this.processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent);
    }
    processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent) {
        const editing = this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        }) ?? false;
        const gridProcessingAllowed = !$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, cellCtrl.rowNode, cellCtrl.column, editing);
        if (gridProcessingAllowed) {
            if (eventName === "keydown") {
                const wasScrollKey = !editing && this.beans.navigation?.handlePageScrollingKey(keyboardEvent);
                if (!wasScrollKey) cellCtrl.onKeyDown(keyboardEvent);
                this.doGridOperations(keyboardEvent, editing);
                if ($437b23f6a393c3bf$export$33ecd6e270298858(keyboardEvent)) cellCtrl.processCharacter(keyboardEvent);
            }
        }
        if (eventName === "keydown") this.eventSvc.dispatchEvent(cellCtrl.createEvent(keyboardEvent, "cellKeyDown"));
    }
    processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent) {
        const { rowNode: rowNode } = rowCtrl;
        const { focusSvc: focusSvc, navigation: navigation } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        const column = focusedCell?.column;
        const gridProcessingAllowed = !$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, false);
        if (gridProcessingAllowed) {
            const key = keyboardEvent.key;
            if (eventName === "keydown") switch(key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
                    navigation?.handlePageScrollingKey(keyboardEvent, true);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                    if (!this.gos.get("embedFullWidthRows")) break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                    rowCtrl.onKeyboardNavigate(keyboardEvent);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                    rowCtrl.onTabKeyDown(keyboardEvent);
                    break;
                default:
            }
        }
        if (eventName === "keydown") this.eventSvc.dispatchEvent(rowCtrl.createRowEvent("cellKeyDown", keyboardEvent));
    }
    doGridOperations(keyboardEvent, editing) {
        if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) return;
        if (editing) return;
        if (!$437b23f6a393c3bf$var$_isEventFromThisInstance(this.beans, keyboardEvent)) return;
        const keyCode = $437b23f6a393c3bf$var$_normaliseQwertyAzerty(keyboardEvent);
        const { clipboardSvc: clipboardSvc, undoRedo: undoRedo } = this.beans;
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.A) return this.onCtrlAndA(keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.C) return this.onCtrlAndC(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.D) return this.onCtrlAndD(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.V) return this.onCtrlAndV(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.X) return this.onCtrlAndX(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.Y) return this.onCtrlAndY(undoRedo);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.Z) return this.onCtrlAndZ(undoRedo, keyboardEvent);
    }
    onCtrlAndA(event) {
        const { beans: { rowModel: rowModel, rangeSvc: rangeSvc, selectionSvc: selectionSvc }, gos: gos } = this;
        if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) && !$437b23f6a393c3bf$var$_getCtrlASelectsRows(gos) && rowModel.isRowsToRender()) $437b23f6a393c3bf$export$57896ee3d2f5a3d(this.beans);
        else if (selectionSvc) selectionSvc.selectAllRowNodes({
            source: "keyboardSelectAll",
            selectAll: $437b23f6a393c3bf$var$_getSelectAll(gos)
        });
        event.preventDefault();
    }
    onCtrlAndC(clipboardSvc, event) {
        if (!clipboardSvc || this.gos.get("enableCellTextSelection")) return;
        const { cellCtrl: cellCtrl } = this.getControlsForEventTarget(event.target);
        if (this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        event.preventDefault();
        clipboardSvc.copyToClipboard();
    }
    onCtrlAndX(clipboardSvc, event) {
        if (!clipboardSvc || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard")) return;
        const { cellCtrl: cellCtrl } = this.getControlsForEventTarget(event.target);
        if (this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        event.preventDefault();
        clipboardSvc.cutToClipboard(void 0, "ui");
    }
    onCtrlAndV(clipboardSvc, event) {
        const { cellCtrl: cellCtrl } = this.getControlsForEventTarget(event.target);
        if (this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        if (clipboardSvc && !this.gos.get("suppressClipboardPaste")) clipboardSvc.pasteFromClipboard();
    }
    onCtrlAndD(clipboardSvc, event) {
        if (clipboardSvc && !this.gos.get("suppressClipboardPaste")) clipboardSvc.copyRangeDown();
        event.preventDefault();
    }
    onCtrlAndZ(undoRedo, event) {
        if (!this.gos.get("undoRedoCellEditing") || !undoRedo) return;
        event.preventDefault();
        if (event.shiftKey) undoRedo.redo("ui");
        else undoRedo.undo("ui");
    }
    onCtrlAndY(undoRedo) {
        undoRedo?.redo("ui");
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/setHeightFeature.ts
var $437b23f6a393c3bf$var$SetHeightFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer, eViewport){
        super();
        this.eContainer = eContainer;
        this.eViewport = eViewport;
    }
    postConstruct() {
        this.addManagedEventListeners({
            rowContainerHeightChanged: this.onHeightChanged.bind(this, this.beans.rowContainerHeight)
        });
    }
    onHeightChanged(maxDivHeightScaler) {
        const height = maxDivHeightScaler.uiContainerHeight;
        const heightString = height != null ? `${height}px` : ``;
        this.eContainer.style.height = heightString;
        if (this.eViewport) this.eViewport.style.height = heightString;
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerCtrl.ts
var $437b23f6a393c3bf$var$getTopRowCtrls = (r)=>r.topRowCtrls;
var $437b23f6a393c3bf$var$getStickyTopRowCtrls = (r)=>r.getStickyTopRowCtrls();
var $437b23f6a393c3bf$var$getStickyBottomRowCtrls = (r)=>r.getStickyBottomRowCtrls();
var $437b23f6a393c3bf$var$getBottomRowCtrls = (r)=>r.bottomRowCtrls;
var $437b23f6a393c3bf$var$getCentreRowCtrls = (r)=>r.allRowCtrls;
var $437b23f6a393c3bf$var$getSpannedTopRowCtrls = (r)=>r.getCtrls("top");
var $437b23f6a393c3bf$var$getSpannedCenterRowCtrls = (r)=>r.getCtrls("center");
var $437b23f6a393c3bf$var$getSpannedBottomRowCtrls = (r)=>r.getCtrls("bottom");
var $437b23f6a393c3bf$var$ContainerCssClasses = {
    center: {
        type: "center",
        name: "center-cols",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    left: {
        type: "left",
        name: "pinned-left-cols",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    right: {
        type: "right",
        name: "pinned-right-cols",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    fullWidth: {
        type: "fullWidth",
        name: "full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls
    },
    topCenter: {
        type: "center",
        name: "floating-top",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topLeft: {
        type: "left",
        name: "pinned-left-floating",
        container: "ag-pinned-left-floating-top",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topRight: {
        type: "right",
        name: "pinned-right-floating",
        container: "ag-pinned-right-floating-top",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topFullWidth: {
        type: "fullWidth",
        name: "floating-top-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls
    },
    stickyTopCenter: {
        type: "center",
        name: "sticky-top",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopLeft: {
        type: "left",
        name: "pinned-left-sticky-top",
        container: "ag-pinned-left-sticky-top",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopRight: {
        type: "right",
        name: "pinned-right-sticky-top",
        container: "ag-pinned-right-sticky-top",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopFullWidth: {
        type: "fullWidth",
        name: "sticky-top-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyBottomCenter: {
        type: "center",
        name: "sticky-bottom",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomLeft: {
        type: "left",
        name: "pinned-left-sticky-bottom",
        container: "ag-pinned-left-sticky-bottom",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomRight: {
        type: "right",
        name: "pinned-right-sticky-bottom",
        container: "ag-pinned-right-sticky-bottom",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomFullWidth: {
        type: "fullWidth",
        name: "sticky-bottom-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    bottomCenter: {
        type: "center",
        name: "floating-bottom",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomLeft: {
        type: "left",
        name: "pinned-left-floating-bottom",
        container: "ag-pinned-left-floating-bottom",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomRight: {
        type: "right",
        name: "pinned-right-floating-bottom",
        container: "ag-pinned-right-floating-bottom",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomFullWidth: {
        type: "fullWidth",
        name: "floating-bottom-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls
    }
};
function $437b23f6a393c3bf$export$65619730ec980d6a(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return `ag-${options.name}-viewport`;
}
function $437b23f6a393c3bf$export$35e1b2dddf7fc6e9(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return options.container ?? `ag-${options.name}-container`;
}
function $437b23f6a393c3bf$export$cd6b90bdf6c4fcfd(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return `ag-${options.name}-spanned-cells-container`;
}
function $437b23f6a393c3bf$export$a46aad9f8c79261f(name) {
    return $437b23f6a393c3bf$var$ContainerCssClasses[name];
}
var $437b23f6a393c3bf$var$allTopNoFW = [
    "topCenter",
    "topLeft",
    "topRight"
];
var $437b23f6a393c3bf$var$allBottomNoFW = [
    "bottomCenter",
    "bottomLeft",
    "bottomRight"
];
var $437b23f6a393c3bf$var$allMiddleNoFW = [
    "center",
    "left",
    "right"
];
var $437b23f6a393c3bf$var$allMiddle = [
    "center",
    "left",
    "right",
    "fullWidth"
];
var $437b23f6a393c3bf$var$allCenter = [
    "stickyTopCenter",
    "stickyBottomCenter",
    "center",
    "topCenter",
    "bottomCenter"
];
var $437b23f6a393c3bf$var$allLeft = [
    "left",
    "bottomLeft",
    "topLeft",
    "stickyTopLeft",
    "stickyBottomLeft"
];
var $437b23f6a393c3bf$var$allRight = [
    "right",
    "bottomRight",
    "topRight",
    "stickyTopRight",
    "stickyBottomRight"
];
var $437b23f6a393c3bf$var$allStickyTopNoFW = [
    "stickyTopCenter",
    "stickyTopLeft",
    "stickyTopRight"
];
var $437b23f6a393c3bf$var$allStickyBottomNoFW = [
    "stickyBottomCenter",
    "stickyBottomLeft",
    "stickyBottomRight"
];
var $437b23f6a393c3bf$var$allStickyContainers = [
    ...$437b23f6a393c3bf$var$allStickyTopNoFW,
    "stickyTopFullWidth",
    ...$437b23f6a393c3bf$var$allStickyBottomNoFW,
    "stickyBottomFullWidth"
];
var $437b23f6a393c3bf$var$allNoFW = [
    ...$437b23f6a393c3bf$var$allTopNoFW,
    ...$437b23f6a393c3bf$var$allBottomNoFW,
    ...$437b23f6a393c3bf$var$allMiddleNoFW,
    ...$437b23f6a393c3bf$var$allStickyTopNoFW,
    ...$437b23f6a393c3bf$var$allStickyBottomNoFW
];
var $437b23f6a393c3bf$export$2d4385f6f566fe5e = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(name){
        super();
        this.name = name;
        this.visible = true;
        // Maintaining a constant reference enables optimization in React.
        this.EMPTY_CTRLS = [];
        this.options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        this.forContainers([
            "center"
        ], ()=>{
            this.viewportSizeFeature = this.createManagedBean(new $437b23f6a393c3bf$var$ViewportSizeFeature(this));
            this.addManagedEventListeners({
                stickyTopOffsetChanged: this.onStickyTopOffsetChanged.bind(this)
            });
        });
    }
    onStickyTopOffsetChanged(event) {
        this.comp.setOffsetTop(`${event.offset}px`);
    }
    registerWithCtrlsService() {
        if (this.options.fullWidth) return;
        this.beans.ctrlsSvc.register(this.name, this);
    }
    forContainers(names, callback) {
        if (names.indexOf(this.name) >= 0) callback();
    }
    setComp(view, eContainer, eSpannedContainer, eViewport) {
        this.comp = view;
        this.eContainer = eContainer;
        this.eSpannedContainer = eSpannedContainer;
        this.eViewport = eViewport;
        this.createManagedBean(new $437b23f6a393c3bf$var$RowContainerEventsFeature(this.eViewport ?? this.eContainer));
        this.addPreventScrollWhileDragging();
        this.listenOnDomOrder();
        const { pinnedCols: pinnedCols, rangeSvc: rangeSvc } = this.beans;
        const pinnedWidthChanged = ()=>this.onPinnedWidthChanged();
        this.forContainers($437b23f6a393c3bf$var$allLeft, ()=>{
            this.pinnedWidthFeature = this.createOptionalManagedBean(pinnedCols?.createPinnedWidthFeature(true, this.eContainer, this.eSpannedContainer));
            this.addManagedEventListeners({
                leftPinnedWidthChanged: pinnedWidthChanged
            });
        });
        this.forContainers($437b23f6a393c3bf$var$allRight, ()=>{
            this.pinnedWidthFeature = this.createOptionalManagedBean(pinnedCols?.createPinnedWidthFeature(false, this.eContainer, this.eSpannedContainer));
            this.addManagedEventListeners({
                rightPinnedWidthChanged: pinnedWidthChanged
            });
        });
        this.forContainers($437b23f6a393c3bf$var$allMiddle, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$SetHeightFeature(this.eContainer, this.name === "center" ? eViewport : void 0)));
        if (rangeSvc) this.forContainers($437b23f6a393c3bf$var$allNoFW, ()=>this.createManagedBean(rangeSvc.createDragListenerFeature(this.eContainer)));
        this.forContainers($437b23f6a393c3bf$var$allCenter, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.comp.setContainerWidth(`${width}px`))));
        this.visible = this.isContainerVisible();
        this.addListeners();
        this.registerWithCtrlsService();
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
    addListeners() {
        const { spannedRowRenderer: spannedRowRenderer, gos: gos } = this.beans;
        const onDisplayedColumnsChanged = this.onDisplayedColumnsChanged.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: onDisplayedColumnsChanged,
            displayedColumnsWidthChanged: onDisplayedColumnsChanged,
            displayedRowsChanged: (params)=>this.onDisplayedRowsChanged(params.afterScroll)
        });
        onDisplayedColumnsChanged();
        this.onDisplayedRowsChanged();
        if (spannedRowRenderer && this.options.getSpannedRowCtrls && gos.get("enableCellSpan")) this.addManagedListeners(spannedRowRenderer, {
            spannedRowsUpdated: ()=>{
                const spannedCtrls = this.options.getSpannedRowCtrls(spannedRowRenderer);
                if (!spannedCtrls) return;
                this.comp.setSpannedRowCtrls(spannedCtrls, false);
            }
        });
    }
    listenOnDomOrder() {
        const isStickContainer = $437b23f6a393c3bf$var$allStickyContainers.indexOf(this.name) >= 0;
        if (isStickContainer) {
            this.comp.setDomOrder(true);
            return;
        }
        const listener = ()=>{
            const isEnsureDomOrder = this.gos.get("ensureDomOrder");
            const isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
            this.comp.setDomOrder(isEnsureDomOrder || isPrintLayout);
        };
        this.addManagedPropertyListener("domLayout", listener);
        listener();
    }
    onDisplayedColumnsChanged() {
        this.forContainers([
            "center"
        ], ()=>this.onHorizontalViewportChanged());
    }
    // this methods prevents the grid views from being scrolled while the dragService is being used
    // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
    addPreventScrollWhileDragging() {
        const { dragSvc: dragSvc } = this.beans;
        if (!dragSvc) return;
        const preventScroll = (e)=>{
            if (dragSvc.dragging) {
                if (e.cancelable) e.preventDefault();
            }
        };
        this.eContainer.addEventListener("touchmove", preventScroll, {
            passive: false
        });
        this.addDestroyFunc(()=>this.eContainer.removeEventListener("touchmove", preventScroll));
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged(afterScroll = false) {
        const scrollWidth = this.getCenterWidth();
        const scrollPosition = this.getCenterViewportScrollLeft();
        this.beans.colViewport.setScrollPosition(scrollWidth, scrollPosition, afterScroll);
    }
    hasHorizontalScrollGap() {
        return this.eContainer.clientWidth - this.eViewport.clientWidth < 0;
    }
    hasVerticalScrollGap() {
        return this.eContainer.clientHeight - this.eViewport.clientHeight < 0;
    }
    getCenterWidth() {
        return $437b23f6a393c3bf$export$cc615e4191ec3e0c(this.eViewport);
    }
    getCenterViewportScrollLeft() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    registerViewportResizeListener(listener) {
        const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eViewport, listener);
        this.addDestroyFunc(()=>unsubscribeFromResize());
    }
    isViewportInTheDOMTree() {
        return $437b23f6a393c3bf$var$_isInDOM(this.eViewport);
    }
    getViewportScrollLeft() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    isHorizontalScrollShowing() {
        const isAlwaysShowHorizontalScroll = this.gos.get("alwaysShowHorizontalScroll");
        return isAlwaysShowHorizontalScroll || $437b23f6a393c3bf$var$_isHorizontalScrollShowing(this.eViewport);
    }
    setHorizontalScroll(offset) {
        this.comp.setHorizontalScroll(offset);
    }
    getHScrollPosition() {
        const res = {
            left: this.eViewport.scrollLeft,
            right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
        };
        return res;
    }
    setCenterViewportScrollLeft(value) {
        $437b23f6a393c3bf$var$_setScrollLeft(this.eViewport, value, this.enableRtl);
    }
    isContainerVisible() {
        const pinned = this.options.pinnedType != null;
        return !pinned || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
    }
    onPinnedWidthChanged() {
        const visible = this.isContainerVisible();
        if (this.visible != visible) {
            this.visible = visible;
            this.onDisplayedRowsChanged();
        }
    }
    onDisplayedRowsChanged(afterScroll = false) {
        const rows = this.options.getRowCtrls(this.beans.rowRenderer);
        if (!this.visible || rows.length === 0) {
            this.comp.setRowCtrls({
                rowCtrls: this.EMPTY_CTRLS
            });
            return;
        }
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const embedFullWidthRows = this.gos.get("embedFullWidthRows");
        const embedFW = embedFullWidthRows || printLayout;
        const rowsThisContainer = rows.filter((rowCtrl)=>{
            const fullWidthRow = rowCtrl.isFullWidth();
            const match = this.options.fullWidth ? !embedFW && fullWidthRow : embedFW || !fullWidthRow;
            return match;
        });
        this.comp.setRowCtrls({
            rowCtrls: rowsThisContainer,
            useFlushSync: afterScroll
        });
    }
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyCtrl.ts
var $437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL = "ag-force-vertical-scroll";
var $437b23f6a393c3bf$var$CSS_CLASS_CELL_SELECTABLE = "ag-selectable";
var $437b23f6a393c3bf$var$CSS_CLASS_COLUMN_MOVING = "ag-column-moving";
var $437b23f6a393c3bf$export$8bebc3145b40d221 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.stickyTopHeight = 0;
        this.stickyBottomHeight = 0;
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.colModel = beans.colModel;
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
        this.pinnedRowModel = beans.pinnedRowModel;
        this.filterManager = beans.filterManager;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
    }
    setComp(comp, eGridBody, eBodyViewport, eTop, eBottom, eStickyTop, eStickyBottom) {
        this.comp = comp;
        this.eGridBody = eGridBody;
        this.eBodyViewport = eBodyViewport;
        this.eTop = eTop;
        this.eBottom = eBottom;
        this.eStickyTop = eStickyTop;
        this.eStickyBottom = eStickyBottom;
        this.eCenterColsViewport = eBodyViewport.querySelector(`.${$437b23f6a393c3bf$export$65619730ec980d6a("center")}`);
        this.eFullWidthContainer = eBodyViewport.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("fullWidth")}`);
        this.eStickyTopFullWidthContainer = eStickyTop.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("stickyTopFullWidth")}`);
        this.eStickyBottomFullWidthContainer = eStickyBottom.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("stickyBottomFullWidth")}`);
        this.setCellTextSelection(this.gos.get("enableCellTextSelection"));
        this.addManagedPropertyListener("enableCellTextSelection", (props)=>this.setCellTextSelection(props.currentValue));
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this.comp));
        this.scrollFeature = this.createManagedBean(new $437b23f6a393c3bf$var$GridBodyScrollFeature(eBodyViewport));
        this.beans.rowDragSvc?.setupRowDrag(eBodyViewport, this);
        this.setupRowAnimationCssClass();
        this.addEventListeners();
        this.addFocusListeners([
            eTop,
            eBodyViewport,
            eBottom,
            eStickyTop,
            eStickyBottom
        ]);
        this.setGridRootRole();
        this.onGridColumnsChanged();
        this.addBodyViewportListener();
        this.setFloatingHeights();
        this.disableBrowserDragging();
        this.addStopEditingWhenGridLosesFocus();
        this.updateScrollingClasses();
        this.filterManager?.setupAdvFilterHeaderComp(eTop);
        this.ctrlsSvc.register("gridBodyCtrl", this);
    }
    addEventListeners() {
        const setFloatingHeights = this.setFloatingHeights.bind(this);
        const setGridRootRole = this.setGridRootRole.bind(this);
        const toggleRowResizeStyle = this.toggleRowResizeStyles.bind(this);
        this.addManagedEventListeners({
            gridColumnsChanged: this.onGridColumnsChanged.bind(this),
            scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this),
            scrollGapChanged: this.updateScrollingClasses.bind(this),
            pinnedRowDataChanged: setFloatingHeights,
            pinnedHeightChanged: setFloatingHeights,
            pinnedRowsChanged: setFloatingHeights,
            headerHeightChanged: this.setStickyTopOffsetTop.bind(this),
            columnRowGroupChanged: setGridRootRole,
            columnPivotChanged: setGridRootRole,
            rowResizeStarted: toggleRowResizeStyle,
            rowResizeEnded: toggleRowResizeStyle
        });
        this.addManagedPropertyListener("treeData", setGridRootRole);
    }
    toggleRowResizeStyles(params) {
        const isResizingRow = params.type === "rowResizeStarted";
        this.eBodyViewport.classList.toggle("ag-prevent-animation", isResizingRow);
    }
    onGridColumnsChanged() {
        const columns = this.beans.colModel.getCols();
        this.comp.setColumnCount(columns.length);
    }
    onScrollVisibilityChanged() {
        const { scrollVisibleSvc: scrollVisibleSvc } = this;
        const visible = scrollVisibleSvc.verticalScrollShowing;
        this.setVerticalScrollPaddingVisible(visible);
        this.setStickyWidth(visible);
        this.setStickyBottomOffsetBottom();
        const scrollbarWidth = visible ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const pad = $437b23f6a393c3bf$var$_isInvisibleScrollbar() ? 16 : 0;
        const width = `calc(100% + ${scrollbarWidth + pad}px)`;
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>this.comp.setBodyViewportWidth(width));
        this.updateScrollingClasses();
    }
    setGridRootRole() {
        const { rowGroupColsSvc: rowGroupColsSvc, colModel: colModel } = this;
        let isTreeGrid = this.gos.get("treeData");
        if (!isTreeGrid) {
            const isPivotActive = colModel.isPivotMode();
            const rowGroupColumnLen = !rowGroupColsSvc ? 0 : rowGroupColsSvc.columns.length;
            const columnsNeededForGrouping = isPivotActive ? 2 : 1;
            isTreeGrid = rowGroupColumnLen >= columnsNeededForGrouping;
        }
        this.comp.setGridRootRole(isTreeGrid ? "treegrid" : "grid");
    }
    addFocusListeners(elements) {
        for (const element of elements)this.addManagedElementListeners(element, {
            focusin: (e)=>{
                const { target: target } = e;
                const isFocusedElementNested = $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-root", element);
                element.classList.toggle("ag-has-focus", !isFocusedElementNested);
            },
            focusout: (e)=>{
                const { target: target, relatedTarget: relatedTarget } = e;
                const gridContainRelatedTarget = element.contains(relatedTarget);
                const isNestedRelatedTarget = $437b23f6a393c3bf$var$_isElementChildOfClass(relatedTarget, "ag-root", element);
                const isNestedTarget = $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-root", element);
                if (isNestedTarget) return;
                if (!gridContainRelatedTarget || isNestedRelatedTarget) element.classList.remove("ag-has-focus");
            }
        });
    }
    // used by ColumnAnimationService
    setColumnMovingCss(moving) {
        this.comp.setColumnMovingCss($437b23f6a393c3bf$var$CSS_CLASS_COLUMN_MOVING, moving);
    }
    setCellTextSelection(selectable = false) {
        this.comp.setCellSelectableCss($437b23f6a393c3bf$var$CSS_CLASS_CELL_SELECTABLE, selectable);
    }
    updateScrollingClasses() {
        const { eGridBody: { classList: classList }, scrollVisibleSvc: scrollVisibleSvc } = this;
        classList.toggle("ag-body-vertical-content-no-gap", !scrollVisibleSvc.verticalScrollGap);
        classList.toggle("ag-body-horizontal-content-no-gap", !scrollVisibleSvc.horizontalScrollGap);
    }
    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
    disableBrowserDragging() {
        this.addManagedElementListeners(this.eGridBody, {
            dragstart: (event)=>{
                if (event.target instanceof HTMLImageElement) {
                    event.preventDefault();
                    return false;
                }
            }
        });
    }
    addStopEditingWhenGridLosesFocus() {
        this.beans.editSvc?.addStopEditingWhenGridLosesFocus([
            this.eBodyViewport,
            this.eBottom,
            this.eTop,
            this.eStickyTop,
            this.eStickyBottom
        ]);
    }
    updateRowCount() {
        const headerCount = (this.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0) + (this.filterManager?.getHeaderRowCount() ?? 0);
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.isLastRowIndexKnown() ? rowModel.getRowCount() : -1;
        const total = rowCount === -1 ? -1 : headerCount + rowCount;
        this.comp.setRowCount(total);
    }
    registerBodyViewportResizeListener(listener) {
        this.comp.registerBodyViewportResizeListener(listener);
    }
    setVerticalScrollPaddingVisible(visible) {
        const overflowY = visible ? "scroll" : "hidden";
        this.comp.setPinnedTopBottomOverflowY(overflowY);
    }
    isVerticalScrollShowing() {
        const show = this.gos.get("alwaysShowVerticalScroll");
        const cssClass = show ? $437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL : null;
        const allowVerticalScroll = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        this.comp.setAlwaysVerticalScrollClass(cssClass, show);
        return show || allowVerticalScroll && $437b23f6a393c3bf$var$_isVerticalScrollShowing(this.eBodyViewport);
    }
    setupRowAnimationCssClass() {
        const { rowContainerHeight: rowContainerHeight, environment: environment } = this.beans;
        let initialSizeMeasurementComplete = environment.sizesMeasured;
        const updateAnimationClass = ()=>{
            const animateRows = initialSizeMeasurementComplete && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos) && !rowContainerHeight.stretching;
            const animateRowsCssClass = animateRows ? "ag-row-animation" : "ag-row-no-animation";
            this.comp.setRowAnimationCssOnBodyViewport(animateRowsCssClass, animateRows);
        };
        updateAnimationClass();
        this.addManagedEventListeners({
            heightScaleChanged: updateAnimationClass
        });
        this.addManagedPropertyListener("animateRows", updateAnimationClass);
        this.addManagedEventListeners({
            gridStylesChanged: ()=>{
                if (!initialSizeMeasurementComplete && environment.sizesMeasured) {
                    initialSizeMeasurementComplete = true;
                    updateAnimationClass();
                }
            }
        });
    }
    addBodyViewportListener() {
        const { eBodyViewport: eBodyViewport, eStickyTop: eStickyTop, eStickyBottom: eStickyBottom, eTop: eTop, eBottom: eBottom, beans: { popupSvc: popupSvc, touchSvc: touchSvc } } = this;
        const listener = this.onBodyViewportContextMenu.bind(this);
        this.addManagedElementListeners(eBodyViewport, {
            contextmenu: listener
        });
        touchSvc?.mockBodyContextMenu(this, listener);
        this.addManagedElementListeners(eBodyViewport, {
            wheel: this.onBodyViewportWheel.bind(this, popupSvc)
        });
        const onStickyWheel = this.onStickyWheel.bind(this);
        for (const container of [
            eStickyTop,
            eStickyBottom,
            eTop,
            eBottom
        ])this.addManagedElementListeners(container, {
            wheel: onStickyWheel
        });
        const onHorizontalWheel = this.onHorizontalWheel.bind(this);
        for (const container of [
            "left",
            "right",
            "topLeft",
            "topRight",
            "bottomLeft",
            "bottomRight"
        ])this.addManagedElementListeners(this.ctrlsSvc.get(container).eContainer, {
            wheel: onHorizontalWheel
        });
        this.addFullWidthContainerWheelListener();
    }
    addFullWidthContainerWheelListener() {
        this.addManagedElementListeners(this.eFullWidthContainer, {
            wheel: (e)=>this.onFullWidthContainerWheel(e)
        });
    }
    onFullWidthContainerWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = e;
        const isHorizontalScroll = shiftKey || Math.abs(deltaX) > Math.abs(deltaY);
        if (isHorizontalScroll && $437b23f6a393c3bf$var$_isEventFromThisInstance(this.beans, e)) this.scrollGridBodyToMatchEvent(e);
    }
    onStickyWheel(e) {
        const { deltaY: deltaY } = e;
        const scrolled = this.scrollVertically(deltaY);
        if (scrolled > 0) e.preventDefault();
    }
    onHorizontalWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = e;
        const isHorizontalScroll = shiftKey || Math.abs(deltaX) > Math.abs(deltaY);
        if (!isHorizontalScroll) return;
        this.scrollGridBodyToMatchEvent(e);
    }
    scrollGridBodyToMatchEvent(e) {
        const { deltaX: deltaX, deltaY: deltaY } = e;
        e.preventDefault();
        this.eCenterColsViewport.scrollBy({
            left: deltaX || deltaY
        });
    }
    onBodyViewportContextMenu(mouseEvent, touch, touchEvent) {
        if (!mouseEvent && !touchEvent) return;
        if (this.gos.get("preventDefaultOnContextMenu")) {
            const event = mouseEvent || touchEvent;
            event.preventDefault();
        }
        const { target: target } = mouseEvent || touch;
        if (target === this.eBodyViewport || target === this.ctrlsSvc.get("center").eViewport) this.beans.contextMenuSvc?.showContextMenu({
            mouseEvent: mouseEvent,
            touchEvent: touchEvent,
            value: null,
            anchorToElement: this.eGridBody,
            source: "ui"
        });
    }
    onBodyViewportWheel(popupSvc, e) {
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) return;
        if (popupSvc?.hasAnchoredPopup()) e.preventDefault();
    }
    // called by rowDragFeature
    scrollVertically(pixels) {
        const oldScrollPosition = this.eBodyViewport.scrollTop;
        this.scrollFeature.setVerticalScrollPosition(oldScrollPosition + pixels);
        return this.eBodyViewport.scrollTop - oldScrollPosition;
    }
    setFloatingHeights() {
        const { pinnedRowModel: pinnedRowModel, beans: { environment: environment } } = this;
        const floatingTopHeight = pinnedRowModel?.getPinnedTopTotalHeight();
        const floatingBottomHeight = pinnedRowModel?.getPinnedBottomTotalHeight();
        const pinnedBorderWidth = environment.getPinnedRowBorderWidth();
        const rowBorderWidth = environment.getRowBorderWidth();
        const additionalHeight = pinnedBorderWidth - rowBorderWidth;
        const normalisedFloatingTopHeight = !floatingTopHeight ? 0 : additionalHeight + floatingTopHeight;
        const normalisedFloatingBottomHeight = !floatingBottomHeight ? 0 : additionalHeight + floatingBottomHeight;
        this.comp.setTopHeight(normalisedFloatingTopHeight);
        this.comp.setBottomHeight(normalisedFloatingBottomHeight);
        this.comp.setTopInvisible(normalisedFloatingTopHeight <= 0);
        this.comp.setBottomInvisible(normalisedFloatingBottomHeight <= 0);
        this.setStickyTopOffsetTop();
        this.setStickyBottomOffsetBottom();
    }
    setStickyTopHeight(height = 0) {
        this.comp.setStickyTopHeight(`${height}px`);
        this.stickyTopHeight = height;
    }
    setStickyBottomHeight(height = 0) {
        this.comp.setStickyBottomHeight(`${height}px`);
        this.stickyBottomHeight = height;
    }
    setStickyWidth(vScrollVisible) {
        if (!vScrollVisible) {
            this.comp.setStickyTopWidth("100%");
            this.comp.setStickyBottomWidth("100%");
        } else {
            const scrollbarWidth = this.scrollVisibleSvc.getScrollbarWidth();
            this.comp.setStickyTopWidth(`calc(100% - ${scrollbarWidth}px)`);
            this.comp.setStickyBottomWidth(`calc(100% - ${scrollbarWidth}px)`);
        }
    }
    setStickyTopOffsetTop() {
        const headerCtrl = this.ctrlsSvc.get("gridHeaderCtrl");
        const headerHeight = headerCtrl.headerHeight + (this.filterManager?.getHeaderHeight() ?? 0);
        const pinnedTopHeight = this.pinnedRowModel?.getPinnedTopTotalHeight() ?? 0;
        let height = 0;
        if (headerHeight > 0) height += headerHeight;
        if (pinnedTopHeight > 0) height += pinnedTopHeight;
        if (height > 0) height += 1;
        this.comp.setStickyTopTop(`${height}px`);
    }
    setStickyBottomOffsetBottom() {
        const { pinnedRowModel: pinnedRowModel, scrollVisibleSvc: scrollVisibleSvc, comp: comp } = this;
        const pinnedBottomHeight = pinnedRowModel?.getPinnedBottomTotalHeight() ?? 0;
        const hScrollShowing = scrollVisibleSvc.horizontalScrollShowing;
        const scrollbarWidth = hScrollShowing ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const height = pinnedBottomHeight + scrollbarWidth;
        comp.setStickyBottomBottom(`${height}px`);
    }
};
// packages/ag-grid-community/src/gridBodyComp/mouseEventUtils.ts
function $437b23f6a393c3bf$export$d85fcb0e6e51242(gos, event) {
    return $437b23f6a393c3bf$export$b5bf61dcea514250(gos, event.target)?.getFocusedCellPosition() ?? null;
}
function $437b23f6a393c3bf$export$530c24bdfacb8cd1(beans, event) {
    const gridPanelHasScrolls = $437b23f6a393c3bf$export$aa3ea9d0da61306f(beans.gos, "normal");
    const e = event;
    let x;
    let y;
    if (e.clientX != null || e.clientY != null) {
        x = e.clientX;
        y = e.clientY;
    } else {
        x = e.x;
        y = e.y;
    }
    const { pageFirstPixel: pageFirstPixel } = beans.pageBounds.getCurrentPagePixelRange();
    y += pageFirstPixel;
    if (gridPanelHasScrolls) {
        const scrollFeature = beans.ctrlsSvc.getScrollFeature();
        const vRange = scrollFeature.getVScrollPosition();
        const hRange = scrollFeature.getHScrollPosition();
        x += hRange.left;
        y += vRange.top;
    }
    return {
        x: x,
        y: y
    };
}
// packages/ag-grid-community/src/gridBodyComp/abstractFakeScrollComp.ts
var $437b23f6a393c3bf$var$AbstractFakeScrollComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(template, direction){
        super();
        this.direction = direction;
        this.eViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.hideTimeout = 0;
        this.setTemplate(template);
    }
    postConstruct() {
        this.addManagedEventListeners({
            scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this)
        });
        this.onScrollVisibilityChanged();
        this.toggleCss("ag-apple-scrollbar", $437b23f6a393c3bf$var$_isMacOsUserAgent() || $437b23f6a393c3bf$export$6b6034a68325bd8a());
    }
    destroy() {
        super.destroy();
        window.clearTimeout(this.hideTimeout);
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.invisibleScrollbar = $437b23f6a393c3bf$var$_isInvisibleScrollbar();
        if (this.invisibleScrollbar) {
            this.hideAndShowInvisibleScrollAsNeeded();
            this.addActiveListenerToggles();
        }
    }
    addActiveListenerToggles() {
        const eGui = this.getGui();
        const onActivate = ()=>this.toggleCss("ag-scrollbar-active", true);
        const onDeactivate = ()=>this.toggleCss("ag-scrollbar-active", false);
        this.addManagedListeners(eGui, {
            mouseenter: onActivate,
            mousedown: onActivate,
            touchstart: onActivate,
            mouseleave: onDeactivate,
            touchend: onDeactivate
        });
    }
    onScrollVisibilityChanged() {
        if (this.invisibleScrollbar === void 0) this.initialiseInvisibleScrollbar();
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>this.setScrollVisible());
    }
    hideAndShowInvisibleScrollAsNeeded() {
        this.addManagedEventListeners({
            bodyScroll: (params)=>{
                if (params.direction === this.direction) {
                    if (this.hideTimeout) {
                        window.clearTimeout(this.hideTimeout);
                        this.hideTimeout = 0;
                    }
                    this.toggleCss("ag-scrollbar-scrolling", true);
                }
            },
            bodyScrollEnd: ()=>{
                this.hideTimeout = window.setTimeout(()=>{
                    this.toggleCss("ag-scrollbar-scrolling", false);
                    this.hideTimeout = 0;
                }, 400);
            }
        });
    }
    attemptSettingScrollPosition(value) {
        const viewport = this.eViewport;
        $437b23f6a393c3bf$export$b863e7aac7884b8(this, ()=>$437b23f6a393c3bf$export$2badf4aa566524cb(viewport), ()=>this.setScrollPosition(value), 100);
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
};
// packages/ag-grid-community/src/gridBodyComp/fakeHScrollComp.ts
var $437b23f6a393c3bf$var$FakeHScrollElement = {
    tag: "div",
    cls: "ag-body-horizontal-scroll",
    attrs: {
        "aria-hidden": "true"
    },
    children: [
        {
            tag: "div",
            ref: "eLeftSpacer",
            cls: "ag-horizontal-left-spacer"
        },
        {
            tag: "div",
            ref: "eViewport",
            cls: "ag-body-horizontal-scroll-viewport",
            children: [
                {
                    tag: "div",
                    ref: "eContainer",
                    cls: "ag-body-horizontal-scroll-container"
                }
            ]
        },
        {
            tag: "div",
            ref: "eRightSpacer",
            cls: "ag-horizontal-right-spacer"
        }
    ]
};
var $437b23f6a393c3bf$export$8f252e09ef6be2d3 = class extends $437b23f6a393c3bf$var$AbstractFakeScrollComp {
    constructor(){
        super($437b23f6a393c3bf$var$FakeHScrollElement, "horizontal");
        this.eLeftSpacer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eRightSpacer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.setScrollVisibleDebounce = 0;
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
    }
    postConstruct() {
        super.postConstruct();
        const spacerWidthsListener = this.setFakeHScrollSpacerWidths.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: spacerWidthsListener,
            displayedColumnsWidthChanged: spacerWidthsListener,
            pinnedRowDataChanged: this.refreshCompBottom.bind(this)
        });
        this.addManagedPropertyListener("domLayout", spacerWidthsListener);
        this.beans.ctrlsSvc.register("fakeHScrollComp", this);
        this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.eContainer.style.width = `${width}px`));
        this.addManagedPropertyListeners([
            "suppressHorizontalScroll"
        ], this.onScrollVisibilityChanged.bind(this));
    }
    destroy() {
        window.clearTimeout(this.setScrollVisibleDebounce);
        super.destroy();
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.enableRtl = this.gos.get("enableRtl");
        super.initialiseInvisibleScrollbar();
        if (this.invisibleScrollbar) this.refreshCompBottom();
    }
    refreshCompBottom() {
        if (!this.invisibleScrollbar) return;
        const bottomPinnedHeight = this.beans.pinnedRowModel?.getPinnedBottomTotalHeight() ?? 0;
        this.getGui().style.bottom = `${bottomPinnedHeight}px`;
    }
    onScrollVisibilityChanged() {
        super.onScrollVisibilityChanged();
        this.setFakeHScrollSpacerWidths();
    }
    setFakeHScrollSpacerWidths() {
        const vScrollShowing = this.scrollVisibleSvc.verticalScrollShowing;
        let rightSpacing = this.visibleCols.getDisplayedColumnsRightWidth();
        const scrollOnRight = !this.enableRtl && vScrollShowing;
        const scrollbarWidth = this.scrollVisibleSvc.getScrollbarWidth();
        if (scrollOnRight) rightSpacing += scrollbarWidth;
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eRightSpacer, rightSpacing);
        this.eRightSpacer.classList.toggle("ag-scroller-corner", rightSpacing <= scrollbarWidth);
        let leftSpacing = this.visibleCols.getColsLeftWidth();
        const scrollOnLeft = this.enableRtl && vScrollShowing;
        if (scrollOnLeft) leftSpacing += scrollbarWidth;
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eLeftSpacer, leftSpacing);
        this.eLeftSpacer.classList.toggle("ag-scroller-corner", leftSpacing <= scrollbarWidth);
    }
    setScrollVisible() {
        const hScrollShowing = this.scrollVisibleSvc.horizontalScrollShowing;
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const isSuppressHorizontalScroll = this.gos.get("suppressHorizontalScroll");
        const scrollbarWidth = hScrollShowing ? this.scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        const scrollContainerSize = !isSuppressHorizontalScroll ? adjustedScrollbarWidth : 0;
        const apply = ()=>{
            this.setScrollVisibleDebounce = 0;
            this.toggleCss("ag-scrollbar-invisible", invisibleScrollbar2);
            $437b23f6a393c3bf$var$_setFixedHeight(this.getGui(), scrollContainerSize);
            $437b23f6a393c3bf$var$_setFixedHeight(this.eViewport, scrollContainerSize);
            $437b23f6a393c3bf$var$_setFixedHeight(this.eContainer, scrollContainerSize);
            if (!scrollContainerSize) this.eContainer.style.setProperty("min-height", "1px");
            this.setVisible(hScrollShowing, {
                skipAriaHidden: true
            });
        };
        window.clearTimeout(this.setScrollVisibleDebounce);
        if (!hScrollShowing) apply();
        else this.setScrollVisibleDebounce = window.setTimeout(apply, 100);
    }
    getScrollPosition() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    setScrollPosition(value) {
        if (!$437b23f6a393c3bf$export$2badf4aa566524cb(this.eViewport)) this.attemptSettingScrollPosition(value);
        $437b23f6a393c3bf$var$_setScrollLeft(this.eViewport, value, this.enableRtl);
    }
};
var $437b23f6a393c3bf$var$FakeHScrollSelector = {
    selector: "AG-FAKE-HORIZONTAL-SCROLL",
    component: $437b23f6a393c3bf$export$8f252e09ef6be2d3
};
// packages/ag-grid-community/src/gridBodyComp/fakeVScrollComp.ts
var $437b23f6a393c3bf$var$FakeVScrollElement = {
    tag: "div",
    cls: "ag-body-vertical-scroll",
    attrs: {
        "aria-hidden": "true"
    },
    children: [
        {
            tag: "div",
            ref: "eViewport",
            cls: "ag-body-vertical-scroll-viewport",
            children: [
                {
                    tag: "div",
                    ref: "eContainer",
                    cls: "ag-body-vertical-scroll-container"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$export$f496fc30dbebdfa3 = class extends $437b23f6a393c3bf$var$AbstractFakeScrollComp {
    constructor(){
        super($437b23f6a393c3bf$var$FakeVScrollElement, "vertical");
    }
    postConstruct() {
        super.postConstruct();
        this.createManagedBean(new $437b23f6a393c3bf$var$SetHeightFeature(this.eContainer));
        const { ctrlsSvc: ctrlsSvc } = this.beans;
        ctrlsSvc.register("fakeVScrollComp", this);
        this.addManagedEventListeners({
            rowContainerHeightChanged: this.onRowContainerHeightChanged.bind(this, ctrlsSvc)
        });
    }
    setScrollVisible() {
        const { scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        const vScrollShowing = scrollVisibleSvc.verticalScrollShowing;
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const scrollbarWidth = vScrollShowing ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        this.toggleCss("ag-scrollbar-invisible", invisibleScrollbar2);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.getGui(), adjustedScrollbarWidth);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eViewport, adjustedScrollbarWidth);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eContainer, adjustedScrollbarWidth);
        this.setDisplayed(vScrollShowing, {
            skipAriaHidden: true
        });
    }
    onRowContainerHeightChanged(ctrlsSvc) {
        const gridBodyCtrl = ctrlsSvc.getGridBodyCtrl();
        const gridBodyViewportEl = gridBodyCtrl.eBodyViewport;
        const eViewportScrollTop = this.getScrollPosition();
        const gridBodyViewportScrollTop = gridBodyViewportEl.scrollTop;
        if (eViewportScrollTop != gridBodyViewportScrollTop) this.setScrollPosition(gridBodyViewportScrollTop, true);
    }
    getScrollPosition() {
        return this.eViewport.scrollTop;
    }
    setScrollPosition(value, force) {
        if (!force && !$437b23f6a393c3bf$export$2badf4aa566524cb(this.eViewport)) this.attemptSettingScrollPosition(value);
        this.eViewport.scrollTop = value;
    }
};
var $437b23f6a393c3bf$var$FakeVScrollSelector = {
    selector: "AG-FAKE-VERTICAL-SCROLL",
    component: $437b23f6a393c3bf$export$f496fc30dbebdfa3
};
// packages/ag-grid-community/src/headerRendering/cells/cssClassApplier.ts
var $437b23f6a393c3bf$var$CSS_FIRST_COLUMN = "ag-column-first";
var $437b23f6a393c3bf$var$CSS_LAST_COLUMN = "ag-column-last";
function $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(abstractColDef)) return [];
    return $437b23f6a393c3bf$var$getColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, gos, column, columnGroup);
}
function $437b23f6a393c3bf$export$1784132bab54c462(abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(abstractColDef)) return [];
    return $437b23f6a393c3bf$var$getColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, gos, column, columnGroup);
}
function $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, presentedColsService) {
    comp.toggleCss($437b23f6a393c3bf$var$CSS_FIRST_COLUMN, presentedColsService.isColAtEdge(column, "first"));
    comp.toggleCss($437b23f6a393c3bf$var$CSS_LAST_COLUMN, presentedColsService.isColAtEdge(column, "last"));
}
function $437b23f6a393c3bf$var$getClassParams(abstractColDef, gos, column, columnGroup) {
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        // bad naming, as colDef here can be a group or a column,
        // however most people won't appreciate the difference,
        // so keeping it as colDef to avoid confusion.
        colDef: abstractColDef,
        column: column,
        columnGroup: columnGroup
    });
}
function $437b23f6a393c3bf$var$getColumnClassesFromCollDef(classesOrFunc, abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(classesOrFunc)) return [];
    let classToUse;
    if (typeof classesOrFunc === "function") {
        const params = $437b23f6a393c3bf$var$getClassParams(abstractColDef, gos, column, columnGroup);
        classToUse = classesOrFunc(params);
    } else classToUse = classesOrFunc;
    if (typeof classToUse === "string") return [
        classToUse
    ];
    if (Array.isArray(classToUse)) return [
        ...classToUse
    ];
    return [];
}
// packages/ag-grid-community/src/utils/gridFocus.ts
function $437b23f6a393c3bf$export$8865b8c867776648(beans, comp, eGui) {
    comp.addManagedElementListeners(eGui, {
        keydown: (e)=>{
            if (!e.defaultPrevented && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) {
                const backwards = e.shiftKey;
                if (!$437b23f6a393c3bf$export$83fc12531358bd28(beans, eGui, false, backwards)) {
                    if ($437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards)) e.preventDefault();
                }
            }
        }
    });
}
function $437b23f6a393c3bf$export$b3beea4db79d8bb3(beans, fromBottom) {
    return beans.ctrlsSvc.get("gridCtrl").focusInnerElement(fromBottom);
}
function $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans) {
    return beans.gos.get("suppressHeaderFocus") || !!beans.overlays?.isExclusive();
}
function $437b23f6a393c3bf$var$_isCellFocusSuppressed(beans) {
    return beans.gos.get("suppressCellFocus") || !!beans.overlays?.isExclusive();
}
function $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards, forceOut = false) {
    const gridCtrl = beans.ctrlsSvc.get("gridCtrl");
    if (!forceOut && gridCtrl.focusNextInnerContainer(backwards)) return true;
    if (forceOut || !backwards && !gridCtrl.isDetailGrid()) gridCtrl.forceFocusOutOfContainer(backwards);
    return false;
}
// packages/ag-grid-community/src/headerRendering/headerUtils.ts
function $437b23f6a393c3bf$export$4861f2356b3fc2d7(colModel) {
    if (!colModel.cols) return -1;
    return colModel.cols.treeDepth + 1;
}
function $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans) {
    return beans.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getGroupRowsHeight(beans) {
    const heights = [];
    const headerRowContainerCtrls = beans.ctrlsSvc.getHeaderRowContainerCtrls();
    for (const headerRowContainerCtrl of headerRowContainerCtrls){
        if (!headerRowContainerCtrl) continue;
        const groupRowCount = headerRowContainerCtrl.getGroupRowCount() || 0;
        for(let i = 0; i < groupRowCount; i++){
            const headerRowCtrl = headerRowContainerCtrl.getGroupRowCtrlAtIndex(i);
            const currentHeightAtPos = heights[i];
            if (headerRowCtrl) {
                const newHeight = $437b23f6a393c3bf$var$getColumnGroupHeaderRowHeight(beans, headerRowCtrl);
                if (currentHeightAtPos == null || newHeight > currentHeightAtPos) heights[i] = newHeight;
            }
        }
    }
    return heights;
}
function $437b23f6a393c3bf$var$getColumnGroupHeaderRowHeight(beans, headerRowCtrl) {
    const defaultHeight = beans.colModel.isPivotMode() ? $437b23f6a393c3bf$var$getPivotGroupHeaderHeight(beans) : $437b23f6a393c3bf$var$getGroupHeaderHeight(beans);
    let maxDisplayedHeight = defaultHeight;
    const headerRowCellCtrls = headerRowCtrl.getHeaderCellCtrls();
    for (const headerCellCtrl of headerRowCellCtrls){
        const { column: column } = headerCellCtrl;
        const height = column.getAutoHeaderHeight();
        if (height != null && height > maxDisplayedHeight && column.isAutoHeaderHeight()) maxDisplayedHeight = height;
    }
    return maxDisplayedHeight;
}
function $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans) {
    const defaultHeight = beans.colModel.isPivotMode() ? $437b23f6a393c3bf$var$getPivotHeaderHeight(beans) : $437b23f6a393c3bf$var$getHeaderHeight(beans);
    let maxDisplayedHeight = defaultHeight;
    beans.colModel.forAllCols((col)=>{
        const height = col.getAutoHeaderHeight();
        if (height != null && height > maxDisplayedHeight && col.isAutoHeaderHeight()) maxDisplayedHeight = height;
    });
    return maxDisplayedHeight;
}
function $437b23f6a393c3bf$var$getHeaderHeight(beans) {
    return beans.gos.get("headerHeight") ?? beans.environment.getDefaultHeaderHeight();
}
function $437b23f6a393c3bf$export$b52d5533bf5be44(beans) {
    return beans.gos.get("floatingFiltersHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getGroupHeaderHeight(beans) {
    return beans.gos.get("groupHeaderHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getPivotHeaderHeight(beans) {
    return beans.gos.get("pivotHeaderHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getPivotGroupHeaderHeight(beans) {
    return beans.gos.get("pivotGroupHeaderHeight") ?? $437b23f6a393c3bf$var$getGroupHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$isHeaderPositionEqual(headerPosA, headerPosB) {
    return headerPosA.headerRowIndex === headerPosB.headerRowIndex && headerPosA.column === headerPosB.column;
}
// packages/ag-grid-community/src/headerRendering/gridHeaderCtrl.ts
var $437b23f6a393c3bf$export$20b300eb69ca4d09 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    setComp(comp, eGui, eFocusableElement) {
        this.comp = comp;
        this.eGui = eGui;
        const { beans: beans } = this;
        const { headerNavigation: headerNavigation, touchSvc: touchSvc, ctrlsSvc: ctrlsSvc } = beans;
        if (headerNavigation) this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eFocusableElement, {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addManagedEventListeners({
            columnPivotModeChanged: this.onPivotModeChanged.bind(this, beans),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this, beans)
        });
        this.onPivotModeChanged(beans);
        this.setupHeaderHeight();
        const listener = this.onHeaderContextMenu.bind(this);
        this.addManagedElementListeners(this.eGui, {
            contextmenu: listener
        });
        touchSvc?.mockHeaderContextMenu(this, listener);
        ctrlsSvc.register("gridHeaderCtrl", this);
    }
    setupHeaderHeight() {
        const listener = this.setHeaderHeight.bind(this);
        listener();
        this.addManagedPropertyListeners([
            "headerHeight",
            "pivotHeaderHeight",
            "groupHeaderHeight",
            "pivotGroupHeaderHeight",
            "floatingFiltersHeight"
        ], listener);
        this.addManagedEventListeners({
            headerRowsChanged: listener,
            columnHeaderHeightChanged: listener,
            // add this to the animation frame to avoid a feedback loop
            columnGroupHeaderHeightChanged: ()=>$437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>listener()),
            gridStylesChanged: listener,
            advancedFilterEnabledChanged: listener
        });
    }
    setHeaderHeight() {
        const { beans: beans } = this;
        let totalHeaderHeight = 0;
        const groupHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(beans).reduce((prev, curr)=>prev + curr, 0);
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans);
        if (beans.filterManager?.hasFloatingFilters()) totalHeaderHeight += $437b23f6a393c3bf$export$b52d5533bf5be44(beans);
        totalHeaderHeight += groupHeight;
        totalHeaderHeight += headerHeight;
        if (this.headerHeight === totalHeaderHeight) return;
        this.headerHeight = totalHeaderHeight;
        const px = `${totalHeaderHeight + 1}px`;
        this.comp.setHeightAndMinHeight(px);
        this.eventSvc.dispatchEvent({
            type: "headerHeightChanged"
        });
    }
    onPivotModeChanged(beans) {
        const pivotMode = beans.colModel.isPivotMode();
        this.comp.toggleCss("ag-pivot-on", pivotMode);
        this.comp.toggleCss("ag-pivot-off", !pivotMode);
    }
    onDisplayedColumnsChanged(beans) {
        const columns = beans.visibleCols.allCols;
        const shouldAllowOverflow = columns.some((col)=>col.isSpanHeaderHeight());
        this.comp.toggleCss("ag-header-allow-overflow", shouldAllowOverflow);
    }
    onTabKeyDown(e) {
        const isRtl = this.gos.get("enableRtl");
        const backwards = e.shiftKey;
        const direction = backwards !== isRtl ? "LEFT" : "RIGHT";
        const { beans: beans } = this;
        const { headerNavigation: headerNavigation, focusSvc: focusSvc } = beans;
        if (headerNavigation.navigateHorizontally(direction, true, e) || !backwards && focusSvc.focusOverlay(false) || $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards, true)) e.preventDefault();
    }
    handleKeyDown(e) {
        let direction = null;
        const { headerNavigation: headerNavigation } = this.beans;
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                direction = "LEFT";
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(direction)) direction = "RIGHT";
                if (headerNavigation.navigateHorizontally(direction, false, e)) e.preventDefault();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                direction = "UP";
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(direction)) direction = "DOWN";
                if (headerNavigation.navigateVertically(direction, e)) e.preventDefault();
                break;
            default:
                return;
        }
    }
    onFocusOut(e) {
        const { relatedTarget: relatedTarget } = e;
        const { eGui: eGui, beans: beans } = this;
        if (!relatedTarget && eGui.contains($437b23f6a393c3bf$export$16bc98d422315038(beans))) return;
        if (!eGui.contains(relatedTarget)) beans.focusSvc.focusedHeader = null;
    }
    onHeaderContextMenu(mouseEvent, touch, touchEvent) {
        const { menuSvc: menuSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        if (!mouseEvent && !touchEvent || !menuSvc?.isHeaderContextMenuEnabled()) return;
        const { target: target } = mouseEvent ?? touch;
        if (target === this.eGui || target === ctrlsSvc.getHeaderRowContainerCtrl()?.eViewport) menuSvc.showHeaderContextMenu(void 0, mouseEvent, touchEvent);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/abstractCell/abstractHeaderCellComp.ts
var $437b23f6a393c3bf$var$AbstractHeaderCellComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(template, ctrl){
        super(template);
        this.ctrl = ctrl;
    }
    getCtrl() {
        return this.ctrl;
    }
};
// packages/ag-grid-community/src/headerRendering/cells/column/headerCellComp.ts
var $437b23f6a393c3bf$var$HeaderCellElement = {
    tag: "div",
    cls: "ag-header-cell",
    role: "columnheader",
    children: [
        {
            tag: "div",
            ref: "eResize",
            cls: "ag-header-cell-resize",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eHeaderCompWrapper",
            cls: "ag-header-cell-comp-wrapper",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderCellElement, ctrl);
        this.eResize = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eHeaderCompWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.headerCompVersion = 0;
    }
    postConstruct() {
        const eGui = this.getGui();
        const refreshSelectAllGui = ()=>{
            const selectAllGui = this.ctrl.getSelectAllGui();
            if (selectAllGui) {
                this.eResize.insertAdjacentElement("afterend", selectAllGui);
                this.addDestroyFunc(()=>selectAllGui.remove());
            }
        };
        const compProxy = {
            setWidth: (width)=>eGui.style.width = width,
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            setAriaSort: (sort)=>sort ? $437b23f6a393c3bf$export$c8dd030b968c6fd2(eGui, sort) : $437b23f6a393c3bf$export$26c7aa61eda05134(eGui),
            setUserCompDetails: (compDetails)=>this.setUserCompDetails(compDetails),
            getUserCompInstance: ()=>this.headerComp,
            refreshSelectAllGui: refreshSelectAllGui,
            removeSelectAllGui: ()=>this.ctrl.getSelectAllGui()?.remove()
        };
        this.ctrl.setComp(compProxy, this.getGui(), this.eResize, this.eHeaderCompWrapper, void 0);
        refreshSelectAllGui();
    }
    destroy() {
        this.destroyHeaderComp();
        super.destroy();
    }
    destroyHeaderComp() {
        if (this.headerComp) {
            this.headerCompGui?.remove();
            this.headerComp = this.destroyBean(this.headerComp);
            this.headerCompGui = void 0;
        }
    }
    setUserCompDetails(compDetails) {
        this.headerCompVersion++;
        const versionCopy = this.headerCompVersion;
        compDetails.newAgStackInstance().then((comp)=>this.afterCompCreated(versionCopy, comp));
    }
    afterCompCreated(version, headerComp) {
        if (version != this.headerCompVersion || !this.isAlive()) {
            this.destroyBean(headerComp);
            return;
        }
        this.destroyHeaderComp();
        this.headerComp = headerComp;
        this.headerCompGui = headerComp.getGui();
        this.eHeaderCompWrapper.appendChild(this.headerCompGui);
        this.ctrl.setDragSource(this.getGui());
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupCellComp.ts
var $437b23f6a393c3bf$var$HeaderGroupCellCompElement = {
    tag: "div",
    cls: "ag-header-group-cell",
    role: "columnheader",
    children: [
        {
            tag: "div",
            ref: "eHeaderCompWrapper",
            cls: "ag-header-cell-comp-wrapper",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eResize",
            cls: "ag-header-cell-resize",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderGroupCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderGroupCellCompElement, ctrl);
        this.eResize = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eHeaderCompWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const eGui = this.getGui();
        const setAttribute = (key, value)=>value != void 0 ? eGui.setAttribute(key, value) : eGui.removeAttribute(key);
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            setHeaderWrapperHidden: (hidden)=>{
                if (hidden) this.eHeaderCompWrapper.style.setProperty("display", "none");
                else this.eHeaderCompWrapper.style.removeProperty("display");
            },
            setHeaderWrapperMaxHeight: (value)=>{
                if (value != null) this.eHeaderCompWrapper.style.setProperty("max-height", `${value}px`);
                else this.eHeaderCompWrapper.style.removeProperty("max-height");
                this.eHeaderCompWrapper.classList.toggle("ag-header-cell-comp-wrapper-limited-height", value != null);
            },
            setResizableDisplayed: (displayed)=>$437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eResize, displayed),
            setWidth: (width)=>eGui.style.width = width,
            setAriaExpanded: (expanded)=>setAttribute("aria-expanded", expanded),
            setUserCompDetails: (details)=>this.setUserCompDetails(details),
            getUserCompInstance: ()=>this.headerGroupComp
        };
        this.ctrl.setComp(compProxy, eGui, this.eResize, this.eHeaderCompWrapper, void 0);
    }
    setUserCompDetails(details) {
        details.newAgStackInstance().then((comp)=>this.afterHeaderCompCreated(comp));
    }
    afterHeaderCompCreated(headerGroupComp) {
        const destroyFunc = ()=>this.destroyBean(headerGroupComp);
        if (!this.isAlive()) {
            destroyFunc();
            return;
        }
        const eGui = this.getGui();
        const eHeaderGroupGui = headerGroupComp.getGui();
        this.eHeaderCompWrapper.appendChild(eHeaderGroupGui);
        this.addDestroyFunc(destroyFunc);
        this.headerGroupComp = headerGroupComp;
        this.ctrl.setDragSource(eGui);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/floatingFilter/headerFilterCellComp.ts
var $437b23f6a393c3bf$var$HeaderFilterCellCompElement = {
    tag: "div",
    cls: "ag-header-cell ag-floating-filter",
    role: "gridcell",
    children: [
        {
            tag: "div",
            ref: "eFloatingFilterBody",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eButtonWrapper",
            cls: "ag-floating-filter-button ag-hidden",
            role: "presentation",
            children: [
                {
                    tag: "button",
                    ref: "eButtonShowMainFilter",
                    cls: "ag-button ag-floating-filter-button-button",
                    attrs: {
                        type: "button",
                        tabindex: "-1"
                    }
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderFilterCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderFilterCellCompElement, ctrl);
        this.eFloatingFilterBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eButtonWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eButtonShowMainFilter = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const eGui = this.getGui();
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            addOrRemoveBodyCssClass: (cssClassName, on)=>this.eFloatingFilterBody.classList.toggle(cssClassName, on),
            setButtonWrapperDisplayed: (displayed)=>$437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eButtonWrapper, displayed),
            setCompDetails: (compDetails)=>this.setCompDetails(compDetails),
            getFloatingFilterComp: ()=>this.compPromise,
            setWidth: (width)=>eGui.style.width = width,
            setMenuIcon: (eIcon)=>this.eButtonShowMainFilter.appendChild(eIcon)
        };
        this.ctrl.setComp(compProxy, eGui, this.eButtonShowMainFilter, this.eFloatingFilterBody, void 0);
    }
    setCompDetails(compDetails) {
        if (!compDetails) {
            this.destroyFloatingFilterComp();
            this.compPromise = null;
            return;
        }
        this.compPromise = compDetails.newAgStackInstance();
        this.compPromise.then((comp)=>this.afterCompCreated(comp));
    }
    destroy() {
        this.destroyFloatingFilterComp();
        super.destroy();
    }
    destroyFloatingFilterComp() {
        if (this.floatingFilterComp) {
            this.floatingFilterComp.getGui().remove();
            this.floatingFilterComp = this.destroyBean(this.floatingFilterComp);
        }
    }
    afterCompCreated(comp) {
        if (!comp) return;
        if (!this.isAlive()) {
            this.destroyBean(comp);
            return;
        }
        this.destroyFloatingFilterComp();
        this.floatingFilterComp = comp;
        this.eFloatingFilterBody.appendChild(comp.getGui());
        if (comp.afterGuiAttached) comp.afterGuiAttached();
    }
};
// packages/ag-grid-community/src/headerRendering/row/headerRowComp.ts
var $437b23f6a393c3bf$var$HeaderRowComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(ctrl){
        super({
            tag: "div",
            cls: ctrl.headerRowClass,
            role: "row"
        });
        this.ctrl = ctrl;
        this.headerComps = {};
    }
    postConstruct() {
        const eGui = this.getGui();
        eGui.setAttribute("tabindex", String(this.gos.get("tabIndex")));
        $437b23f6a393c3bf$export$ba731dedf9d88615(this.getGui(), this.ctrl.getAriaRowIndex());
        const compProxy = {
            setHeight: (height)=>this.getGui().style.height = height,
            setTop: (top)=>this.getGui().style.top = top,
            setHeaderCtrls: (ctrls, forceOrder)=>this.setHeaderCtrls(ctrls, forceOrder),
            setWidth: (width)=>this.getGui().style.width = width,
            setRowIndex: (rowIndex)=>$437b23f6a393c3bf$export$ba731dedf9d88615(this.getGui(), rowIndex)
        };
        this.ctrl.setComp(compProxy, void 0);
    }
    destroy() {
        this.setHeaderCtrls([], false);
        super.destroy();
    }
    setHeaderCtrls(ctrls, forceOrder) {
        if (!this.isAlive()) return;
        const oldComps = this.headerComps;
        this.headerComps = {};
        for (const ctrl of ctrls){
            const id = ctrl.instanceId;
            let comp = oldComps[id];
            delete oldComps[id];
            if (comp == null) {
                comp = this.createHeaderComp(ctrl);
                this.getGui().appendChild(comp.getGui());
            }
            this.headerComps[id] = comp;
        }
        Object.values(oldComps).forEach((comp)=>{
            comp.getGui().remove();
            this.destroyBean(comp);
        });
        if (forceOrder) {
            const comps = Object.values(this.headerComps);
            comps.sort((a, b)=>{
                const leftA = a.getCtrl().column.getLeft();
                const leftB = b.getCtrl().column.getLeft();
                return leftA - leftB;
            });
            const elementsInOrder = comps.map((c)=>c.getGui());
            $437b23f6a393c3bf$var$_setDomChildOrder(this.getGui(), elementsInOrder);
        }
    }
    createHeaderComp(headerCtrl) {
        let result;
        switch(this.ctrl.type){
            case "group":
                result = new $437b23f6a393c3bf$var$HeaderGroupCellComp(headerCtrl);
                break;
            case "filter":
                result = new $437b23f6a393c3bf$var$HeaderFilterCellComp(headerCtrl);
                break;
            default:
                result = new $437b23f6a393c3bf$var$HeaderCellComp(headerCtrl);
                break;
        }
        this.createBean(result);
        result.setParentComponent(this);
        return result;
    }
};
// packages/ag-grid-community/src/rendering/features/setLeftFeature.ts
var $437b23f6a393c3bf$var$SetLeftFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columnOrGroup, eCell, beans, colsSpanning){
        super();
        this.columnOrGroup = columnOrGroup;
        this.eCell = eCell;
        this.colsSpanning = colsSpanning;
        this.columnOrGroup = columnOrGroup;
        this.ariaEl = eCell.querySelector("[role=columnheader]") || eCell;
        this.beans = beans;
    }
    setColsSpanning(colsSpanning) {
        this.colsSpanning = colsSpanning;
        this.onLeftChanged();
    }
    getColumnOrGroup() {
        const { beans: beans, colsSpanning: colsSpanning } = this;
        if (beans.gos.get("enableRtl") && colsSpanning) return $437b23f6a393c3bf$export$236389741107357f(colsSpanning);
        return this.columnOrGroup;
    }
    postConstruct() {
        const onLeftChanged = this.onLeftChanged.bind(this);
        this.addManagedListeners(this.columnOrGroup, {
            leftChanged: onLeftChanged
        });
        this.setLeftFirstTime();
        this.addManagedEventListeners({
            displayedColumnsWidthChanged: onLeftChanged
        });
        this.addManagedPropertyListener("domLayout", onLeftChanged);
    }
    setLeftFirstTime() {
        const { gos: gos, colAnimation: colAnimation } = this.beans;
        const suppressMoveAnimation = gos.get("suppressColumnMoveAnimation");
        const oldLeftExists = $437b23f6a393c3bf$export$25d27f17d3af40f7(this.columnOrGroup.getOldLeft());
        const animateColumnMove = colAnimation?.isActive() && oldLeftExists && !suppressMoveAnimation;
        if (animateColumnMove) this.animateInLeft();
        else this.onLeftChanged();
    }
    animateInLeft() {
        const colOrGroup = this.getColumnOrGroup();
        const oldActualLeft = this.modifyLeftForPrintLayout(colOrGroup, colOrGroup.getOldLeft());
        const actualLeft = this.modifyLeftForPrintLayout(colOrGroup, colOrGroup.getLeft());
        this.setLeft(oldActualLeft);
        this.actualLeft = actualLeft;
        this.beans.colAnimation.executeNextVMTurn(()=>{
            if (this.actualLeft === actualLeft) this.setLeft(actualLeft);
        });
    }
    onLeftChanged() {
        const colOrGroup = this.getColumnOrGroup();
        const left = colOrGroup.getLeft();
        this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
        this.setLeft(this.actualLeft);
    }
    modifyLeftForPrintLayout(colOrGroup, leftPosition) {
        const { gos: gos, visibleCols: visibleCols } = this.beans;
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        if (!printLayout) return leftPosition;
        if (colOrGroup.getPinned() === "left") return leftPosition;
        const leftWidth = visibleCols.getColsLeftWidth();
        if (colOrGroup.getPinned() === "right") {
            const bodyWidth = visibleCols.bodyWidth;
            return leftWidth + bodyWidth + leftPosition;
        }
        return leftWidth + leftPosition;
    }
    setLeft(value) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) this.eCell.style.left = `${value}px`;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(this.columnOrGroup)) {
            const children = this.columnOrGroup.getLeafColumns();
            if (!children.length) return;
            if (children.length > 1) $437b23f6a393c3bf$export$371d80f0281454ce(this.ariaEl, children.length);
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/abstractCell/abstractHeaderCellCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence2 = 0;
var $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL = "headerCtrl";
var $437b23f6a393c3bf$var$AbstractHeaderCellCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column, rowCtrl){
        super();
        this.column = column;
        this.rowCtrl = rowCtrl;
        this.resizeToggleTimeout = 0;
        this.resizeMultiplier = 1;
        this.resizeFeature = null;
        this.lastFocusEvent = null;
        this.dragSource = null;
        this.reAttemptToFocus = false;
        this.instanceId = column.getUniqueId() + "-" + $437b23f6a393c3bf$var$instanceIdSequence2++;
    }
    postConstruct() {
        const refreshTabIndex = this.refreshTabIndex.bind(this);
        this.addManagedPropertyListeners([
            "suppressHeaderFocus"
        ], refreshTabIndex);
        this.addManagedEventListeners({
            overlayExclusiveChanged: refreshTabIndex
        });
    }
    setComp(comp, eGui, eResize, eHeaderCompWrapper, compBean) {
        eGui.setAttribute("col-id", this.column.colIdSanitised);
        this.wireComp(comp, eGui, eResize, eHeaderCompWrapper, compBean);
        if (this.reAttemptToFocus) {
            this.reAttemptToFocus = false;
            this.focus(this.lastFocusEvent ?? void 0);
        }
    }
    shouldStopEventPropagation(event) {
        const { headerRowIndex: headerRowIndex, column: column } = this.beans.focusSvc.focusedHeader;
        const colDef = column.getDefinition();
        const colDefFunc = colDef?.suppressHeaderKeyboardEvent;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(colDefFunc)) return false;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            colDef: colDef,
            column: column,
            headerRowIndex: headerRowIndex,
            event: event
        });
        return !!colDefFunc(params);
    }
    getWrapperHasFocus() {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return activeEl === this.eGui;
    }
    setGui(eGui, compBean) {
        this.eGui = eGui;
        this.addDomData(compBean);
        compBean.addManagedListeners(this.beans.eventSvc, {
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this)
        });
        compBean.addManagedElementListeners(this.eGui, {
            focus: this.onGuiFocus.bind(this)
        });
        this.onDisplayedColumnsChanged();
        this.refreshTabIndex();
    }
    refreshHeaderStyles() {
        const colDef = this.column.getDefinition();
        if (!colDef) return;
        const { headerStyle: headerStyle } = colDef;
        let styles;
        if (typeof headerStyle === "function") {
            const cellStyleParams = this.getHeaderClassParams();
            styles = headerStyle(cellStyleParams);
        } else styles = headerStyle;
        if (styles) this.comp.setUserStyles(styles);
    }
    onGuiFocus() {
        this.eventSvc.dispatchEvent({
            type: "headerFocused",
            column: this.column
        });
    }
    setupAutoHeight(params) {
        const { wrapperElement: wrapperElement, checkMeasuringCallback: checkMeasuringCallback, compBean: compBean } = params;
        const { beans: beans } = this;
        const measureHeight = (timesCalled)=>{
            if (!this.isAlive() || !compBean.isAlive()) return;
            const { paddingTop: paddingTop, paddingBottom: paddingBottom, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth } = $437b23f6a393c3bf$var$_getElementSize(this.eGui);
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = wrapperElement.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
                const notYetInDom = !doc?.contains(wrapperElement);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    $437b23f6a393c3bf$export$8ea55376d0d59592(()=>measureHeight(timesCalled + 1), "raf", beans);
                    return;
                }
            }
            this.setColHeaderHeight(this.column, autoHeight);
        };
        let isMeasuring = false;
        let stopResizeObserver;
        const checkMeasuring = ()=>{
            const newValue = this.column.isAutoHeaderHeight();
            if (newValue && !isMeasuring) startMeasuring();
            if (!newValue && isMeasuring) stopMeasuring();
        };
        const startMeasuring = ()=>{
            isMeasuring = true;
            this.comp.toggleCss("ag-header-cell-auto-height", true);
            measureHeight(0);
            stopResizeObserver = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, wrapperElement, ()=>measureHeight(0));
        };
        const stopMeasuring = ()=>{
            isMeasuring = false;
            if (stopResizeObserver) stopResizeObserver();
            this.comp.toggleCss("ag-header-cell-auto-height", false);
            stopResizeObserver = void 0;
        };
        checkMeasuring();
        compBean.addDestroyFunc(()=>stopMeasuring());
        compBean.addManagedListeners(this.column, {
            widthChanged: ()=>isMeasuring && measureHeight(0)
        });
        compBean.addManagedEventListeners({
            sortChanged: ()=>{
                if (isMeasuring) window.setTimeout(()=>measureHeight(0));
            }
        });
        if (checkMeasuringCallback) checkMeasuringCallback(checkMeasuring);
    }
    onDisplayedColumnsChanged() {
        const { comp: comp, column: column, beans: beans, eGui: eGui } = this;
        if (!comp || !column || !eGui) return;
        $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, beans.visibleCols);
        $437b23f6a393c3bf$export$84b73ecd0b234e89(eGui, beans.visibleCols.getAriaColIndex(column));
    }
    addResizeAndMoveKeyboardListeners(compBean) {
        compBean.addManagedListeners(this.eGui, {
            keydown: this.onGuiKeyDown.bind(this),
            keyup: this.onGuiKeyUp.bind(this)
        });
    }
    refreshTabIndex() {
        const suppressHeaderFocus = $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans);
        if (this.eGui) $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eGui, "tabindex", suppressHeaderFocus ? null : "-1");
    }
    onGuiKeyDown(e) {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        const isLeftOrRight = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
        if (this.isResizing) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (// if elements within the header are focused, we don't process the event
        activeEl !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
        !e.shiftKey && !e.altKey) return;
        if (this.isResizing || isLeftOrRight) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (!isLeftOrRight) return;
        const isLeft = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT !== this.gos.get("enableRtl");
        const direction = isLeft ? "left" : "right";
        if (e.altKey) {
            this.isResizing = true;
            this.resizeMultiplier += 1;
            const diff = this.getViewportAdjustedResizeDiff(e);
            this.resizeHeader(diff, e.shiftKey);
            this.resizeFeature?.toggleColumnResizing(true);
        } else this.moveHeader(direction);
    }
    moveHeader(hDirection) {
        this.beans.colMoves?.moveHeader(hDirection, this.eGui, this.column, this.rowCtrl.pinned, this);
    }
    getViewportAdjustedResizeDiff(e) {
        const diff = this.getResizeDiff(e);
        const { pinnedCols: pinnedCols } = this.beans;
        return pinnedCols ? pinnedCols.getHeaderResizeDiff(diff, this.column) : diff;
    }
    getResizeDiff(e) {
        const { gos: gos, column: column } = this;
        let isLeft = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT !== gos.get("enableRtl");
        const pinned = column.getPinned();
        const isRtl = gos.get("enableRtl");
        if (pinned) {
            if (isRtl !== (pinned === "right")) isLeft = !isLeft;
        }
        return (isLeft ? -1 : 1) * this.resizeMultiplier;
    }
    onGuiKeyUp() {
        if (!this.isResizing) return;
        if (this.resizeToggleTimeout) {
            window.clearTimeout(this.resizeToggleTimeout);
            this.resizeToggleTimeout = 0;
        }
        this.isResizing = false;
        this.resizeMultiplier = 1;
        this.resizeToggleTimeout = window.setTimeout(()=>{
            this.resizeFeature?.toggleColumnResizing(false);
        }, 150);
    }
    handleKeyDown(e) {
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (wrapperHasFocus) e.preventDefault();
        }
    }
    addDomData(compBean) {
        const key = $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL;
        const { eGui: eGui, gos: gos } = this;
        $437b23f6a393c3bf$var$_setDomData(gos, eGui, key, this);
        compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(gos, eGui, key, null));
    }
    focus(event) {
        if (!this.isAlive()) return false;
        const { eGui: eGui } = this;
        if (!eGui) this.reAttemptToFocus = true;
        else {
            eGui.focus();
            this.lastFocusEvent = event || null;
        }
        return true;
    }
    focusThis() {
        this.beans.focusSvc.focusedHeader = {
            headerRowIndex: this.rowCtrl.rowIndex,
            column: this.column
        };
    }
    removeDragSource() {
        if (this.dragSource) {
            this.beans.dragAndDrop?.removeDragSource(this.dragSource);
            this.dragSource = null;
        }
    }
    handleContextMenuMouseEvent(mouseEvent, touchEvent, column) {
        const event = mouseEvent ?? touchEvent;
        const { menuSvc: menuSvc, gos: gos } = this.beans;
        if (gos.get("preventDefaultOnContextMenu")) event.preventDefault();
        if (menuSvc?.isHeaderContextMenuEnabled(column)) menuSvc.showHeaderContextMenu(column, mouseEvent, touchEvent);
        this.dispatchColumnMouseEvent("columnHeaderContextMenu", column);
    }
    dispatchColumnMouseEvent(eventType, column) {
        this.eventSvc.dispatchEvent({
            type: eventType,
            column: column
        });
    }
    setColHeaderHeight(col, height) {
        if (!col.setAutoHeaderHeight(height)) return;
        const { eventSvc: eventSvc } = this;
        if (col.isColumn) eventSvc.dispatchEvent({
            type: "columnHeaderHeightChanged",
            column: col,
            columns: [
                col
            ],
            source: "autosizeColumnHeaderHeight"
        });
        else eventSvc.dispatchEvent({
            type: "columnGroupHeaderHeightChanged",
            columnGroup: col,
            source: "autosizeColumnGroupHeaderHeight"
        });
    }
    clearComponent() {
        this.removeDragSource();
        this.resizeFeature = null;
        this.comp = null;
        this.eGui = null;
    }
    destroy() {
        super.destroy();
        this.column = null;
        this.lastFocusEvent = null;
        this.rowCtrl = null;
    }
};
// packages/ag-grid-community/src/headerRendering/cells/column/headerCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.refreshFunctions = {};
        this.userHeaderClasses = /* @__PURE__ */ new Set();
        this.ariaDescriptionProperties = /* @__PURE__ */ new Map();
    }
    wireComp(comp, eGui, eResize, eHeaderCompWrapper, compBeanInput) {
        this.comp = comp;
        const { rowCtrl: rowCtrl, column: column, beans: beans } = this;
        const { colResize: colResize, context: context, colHover: colHover, rangeSvc: rangeSvc } = beans;
        const compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBeanInput);
        this.setGui(eGui, compBean);
        this.updateState();
        this.setupWidth(compBean);
        this.setupMovingCss(compBean);
        this.setupMenuClass(compBean);
        this.setupSortableClass(compBean);
        this.setupWrapTextClass();
        this.refreshSpanHeaderHeight();
        this.setupAutoHeight({
            wrapperElement: eHeaderCompWrapper,
            checkMeasuringCallback: (checkMeasuring)=>this.setRefreshFunction("measuring", checkMeasuring),
            compBean: compBean
        });
        this.addColumnHoverListener(compBean);
        this.setupFilterClass(compBean);
        this.setupStylesFromColDef();
        this.setupClassesFromColDef();
        this.setupTooltip();
        this.addActiveHeaderMouseListeners(compBean);
        this.setupSelectAll(compBean);
        this.setupUserComp();
        this.refreshAria();
        if (colResize) this.resizeFeature = compBean.createManagedBean(colResize.createResizeFeature(rowCtrl.pinned, column, eResize, comp, this));
        else $437b23f6a393c3bf$export$9405f1cbb4e2383f(eResize, false);
        colHover?.createHoverFeature(compBean, [
            column
        ], eGui);
        rangeSvc?.createRangeHighlightFeature(compBean, column, comp);
        compBean.createManagedBean(new $437b23f6a393c3bf$var$SetLeftFeature(column, eGui, beans));
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eGui, {
            shouldStopEventPropagation: (e)=>this.shouldStopEventPropagation(e),
            onTabKeyDown: ()=>null,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addResizeAndMoveKeyboardListeners(compBean);
        compBean.addManagedPropertyListeners([
            "suppressMovableColumns",
            "suppressMenuHide",
            "suppressAggFuncInHeader",
            "enableAdvancedFilter"
        ], ()=>this.refresh());
        compBean.addManagedListeners(column, {
            colDefChanged: ()=>this.refresh()
        });
        compBean.addManagedListeners(column, {
            headerHighlightChanged: this.onHeaderHighlightChanged.bind(this)
        });
        const listener = ()=>this.checkDisplayName();
        compBean.addManagedEventListeners({
            columnValueChanged: listener,
            columnRowGroupChanged: listener,
            columnPivotChanged: listener,
            headerHeightChanged: this.onHeaderHeightChanged.bind(this)
        });
        compBean.addDestroyFunc(()=>{
            this.refreshFunctions = {};
            this.selectAllFeature = null;
            this.dragSourceElement = void 0;
            this.userCompDetails = null;
            this.userHeaderClasses.clear();
            this.ariaDescriptionProperties.clear();
            this.clearComponent();
        });
    }
    resizeHeader(delta, shiftKey) {
        this.beans.colResize?.resizeHeader(this.column, delta, shiftKey);
    }
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.colDef;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            column: column,
            floatingFilter: false
        });
    }
    setupUserComp() {
        const compDetails = this.lookupUserCompDetails();
        if (compDetails) this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setUserCompDetails(compDetails);
    }
    lookupUserCompDetails() {
        const params = this.createParams();
        const colDef = this.column.getColDef();
        return $437b23f6a393c3bf$var$_getHeaderCompDetails(this.beans.userCompFactory, colDef, params);
    }
    createParams() {
        const { menuSvc: menuSvc, sortSvc: sortSvc, colFilter: colFilter, gos: gos } = this.beans;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            column: this.column,
            displayName: this.displayName,
            enableSorting: this.column.isSortable(),
            enableMenu: this.menuEnabled,
            enableFilterButton: this.openFilterEnabled && !!menuSvc?.isHeaderFilterButtonEnabled(this.column),
            enableFilterIcon: !!colFilter && (!this.openFilterEnabled || $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos)),
            showColumnMenu: (buttonElement, onClosedCallback)=>{
                menuSvc?.showColumnMenu({
                    column: this.column,
                    buttonElement: buttonElement,
                    positionBy: "button",
                    onClosedCallback: onClosedCallback
                });
            },
            showColumnMenuAfterMouseClick: (mouseEvent, onClosedCallback)=>{
                menuSvc?.showColumnMenu({
                    column: this.column,
                    mouseEvent: mouseEvent,
                    positionBy: "mouse",
                    onClosedCallback: onClosedCallback
                });
            },
            showFilter: (buttonElement)=>{
                menuSvc?.showFilterMenu({
                    column: this.column,
                    buttonElement: buttonElement,
                    containerType: "columnFilter",
                    positionBy: "button"
                });
            },
            progressSort: (multiSort)=>{
                sortSvc?.progressSort(this.column, !!multiSort, "uiColumnSorted");
            },
            setSort: (sort, multiSort)=>{
                sortSvc?.setSortForColumn(this.column, sort, !!multiSort, "uiColumnSorted");
            },
            eGridHeader: this.eGui,
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupTooltip(value, shouldDisplayTooltip);
            }
        });
        return params;
    }
    setupSelectAll(compBean) {
        const { selectionSvc: selectionSvc } = this.beans;
        if (!selectionSvc) return;
        this.selectAllFeature = compBean.createOptionalManagedBean(selectionSvc.createSelectAllFeature(this.column));
        this.selectAllFeature?.setComp(this);
        compBean.addManagedPropertyListener("rowSelection", ()=>{
            const selectAllFeature = selectionSvc.createSelectAllFeature(this.column);
            if (selectAllFeature && !this.selectAllFeature) {
                this.selectAllFeature = compBean.createManagedBean(selectAllFeature);
                this.selectAllFeature?.setComp(this);
                this.comp.refreshSelectAllGui();
            } else if (this.selectAllFeature && !selectAllFeature) {
                this.comp.removeSelectAllGui();
                this.selectAllFeature = this.destroyBean(this.selectAllFeature);
            }
        });
    }
    getSelectAllGui() {
        return this.selectAllFeature?.getCheckboxGui();
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) this.selectAllFeature?.onSpaceKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) this.onEnterKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN && e.altKey) this.showMenuOnKeyPress(e, false);
    }
    onEnterKeyDown(e) {
        if (e.ctrlKey || e.metaKey) this.showMenuOnKeyPress(e, true);
        else if (this.sortable) this.beans.sortSvc?.progressSort(this.column, e.shiftKey, "uiColumnSorted");
    }
    showMenuOnKeyPress(e, isFilterShortcut) {
        const headerComp = this.comp.getUserCompInstance();
        if (!$437b23f6a393c3bf$var$isHeaderComp(headerComp)) return;
        if (headerComp.onMenuKeyboardShortcut(isFilterShortcut)) e.preventDefault();
    }
    onFocusIn(e) {
        if (!this.eGui.contains(e.relatedTarget)) {
            this.focusThis();
            this.announceAriaDescription();
        }
        if ($437b23f6a393c3bf$export$e4c8c227337b7f23()) this.setActiveHeader(true);
    }
    onFocusOut(e) {
        if (this.eGui.contains(e.relatedTarget)) return;
        this.setActiveHeader(false);
    }
    setupTooltip(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.setupHeaderTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    setupStylesFromColDef() {
        this.setRefreshFunction("headerStyles", this.refreshHeaderStyles.bind(this));
        this.refreshHeaderStyles();
    }
    setupClassesFromColDef() {
        const refreshHeaderClasses = ()=>{
            const colDef = this.column.getColDef();
            const classes = $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(colDef, this.gos, this.column, null);
            const oldClasses = this.userHeaderClasses;
            this.userHeaderClasses = new Set(classes);
            for (const c of classes)if (oldClasses.has(c)) oldClasses.delete(c);
            else this.comp.toggleCss(c, true);
            for (const c of oldClasses)this.comp.toggleCss(c, false);
        };
        this.setRefreshFunction("headerClasses", refreshHeaderClasses);
        refreshHeaderClasses();
    }
    setDragSource(eSource) {
        this.dragSourceElement = eSource;
        this.removeDragSource();
        if (!eSource || !this.draggable) return;
        this.dragSource = this.beans.colMoves?.setDragSourceForHeader(eSource, this.column, this.displayName) ?? null;
    }
    updateState() {
        const { menuSvc: menuSvc } = this.beans;
        this.menuEnabled = !!menuSvc?.isColumnMenuInHeaderEnabled(this.column);
        this.openFilterEnabled = !!menuSvc?.isFilterMenuInHeaderEnabled(this.column);
        this.sortable = this.column.isSortable();
        this.displayName = this.calculateDisplayName();
        this.draggable = this.workOutDraggable();
    }
    setRefreshFunction(name, func) {
        this.refreshFunctions[name] = func;
    }
    refresh() {
        this.updateState();
        this.refreshHeaderComp();
        this.refreshAria();
        for (const f of Object.values(this.refreshFunctions))f();
    }
    refreshHeaderComp() {
        const newCompDetails = this.lookupUserCompDetails();
        if (!newCompDetails) return;
        const compInstance = this.comp.getUserCompInstance();
        const attemptRefresh = compInstance != null && this.userCompDetails.componentClass == newCompDetails.componentClass;
        const headerCompRefreshed = attemptRefresh ? this.attemptHeaderCompRefresh(newCompDetails.params) : false;
        if (headerCompRefreshed) this.setDragSource(this.dragSourceElement);
        else this.setCompDetails(newCompDetails);
    }
    attemptHeaderCompRefresh(params) {
        const headerComp = this.comp.getUserCompInstance();
        if (!headerComp) return false;
        if (!headerComp.refresh) return false;
        const res = headerComp.refresh(params);
        return res;
    }
    calculateDisplayName() {
        return this.beans.colNames.getDisplayNameForColumn(this.column, "header", true);
    }
    checkDisplayName() {
        if (this.displayName !== this.calculateDisplayName()) this.refresh();
    }
    workOutDraggable() {
        const colDef = this.column.getColDef();
        const isSuppressMovableColumns = this.gos.get("suppressMovableColumns");
        const colCanMove = !isSuppressMovableColumns && !colDef.suppressMovable && !colDef.lockPosition;
        return !!colCanMove || !!colDef.enableRowGroup || !!colDef.enablePivot;
    }
    setupWidth(compBean) {
        const listener = ()=>{
            const columnWidth = this.column.getActualWidth();
            this.comp.setWidth(`${columnWidth}px`);
        };
        compBean.addManagedListeners(this.column, {
            widthChanged: listener
        });
        listener();
    }
    setupMovingCss(compBean) {
        const listener = ()=>{
            this.comp.toggleCss("ag-header-cell-moving", this.column.isMoving());
        };
        compBean.addManagedListeners(this.column, {
            movingChanged: listener
        });
        listener();
    }
    setupMenuClass(compBean) {
        const listener = ()=>{
            this.comp?.toggleCss("ag-column-menu-visible", this.column.isMenuVisible());
        };
        compBean.addManagedListeners(this.column, {
            menuVisibleChanged: listener
        });
        listener();
    }
    setupSortableClass(compBean) {
        const updateSortableCssClass = ()=>{
            this.comp.toggleCss("ag-header-cell-sortable", !!this.sortable);
        };
        updateSortableCssClass();
        this.setRefreshFunction("updateSortable", updateSortableCssClass);
        compBean.addManagedEventListeners({
            sortChanged: this.refreshAriaSort.bind(this)
        });
    }
    setupFilterClass(compBean) {
        const listener = ()=>{
            const isFilterActive = this.column.isFilterActive();
            this.comp.toggleCss("ag-header-cell-filtered", isFilterActive);
            this.refreshAria();
        };
        compBean.addManagedListeners(this.column, {
            filterActiveChanged: listener
        });
        listener();
    }
    setupWrapTextClass() {
        const listener = ()=>{
            const wrapText = !!this.column.getColDef().wrapHeaderText;
            this.comp.toggleCss("ag-header-cell-wrap-text", wrapText);
        };
        listener();
        this.setRefreshFunction("wrapText", listener);
    }
    onHeaderHighlightChanged() {
        const highlighted = this.column.getHighlighted();
        const beforeOn = highlighted === 0 /* Before */ ;
        const afterOn = highlighted === 1 /* After */ ;
        this.comp.toggleCss("ag-header-highlight-before", beforeOn);
        this.comp.toggleCss("ag-header-highlight-after", afterOn);
    }
    onDisplayedColumnsChanged() {
        super.onDisplayedColumnsChanged();
        if (!this.isAlive()) return;
        this.onHeaderHeightChanged();
    }
    onHeaderHeightChanged() {
        this.refreshSpanHeaderHeight();
    }
    refreshSpanHeaderHeight() {
        const { eGui: eGui, column: column, comp: comp, beans: beans } = this;
        const groupHeaderHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(this.beans);
        const isZeroGroupHeight = groupHeaderHeight.reduce((total, next)=>total + next, 0) === 0;
        comp.toggleCss("ag-header-parent-hidden", isZeroGroupHeight);
        if (!column.isSpanHeaderHeight()) {
            eGui.style.removeProperty("top");
            eGui.style.removeProperty("height");
            comp.toggleCss("ag-header-span-height", false);
            comp.toggleCss("ag-header-span-total", false);
            return;
        }
        const { numberOfParents: numberOfParents, isSpanningTotal: isSpanningTotal } = this.column.getColumnGroupPaddingInfo();
        comp.toggleCss("ag-header-span-height", numberOfParents > 0);
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans);
        if (numberOfParents === 0) {
            comp.toggleCss("ag-header-span-total", false);
            eGui.style.setProperty("top", `0px`);
            eGui.style.setProperty("height", `${headerHeight}px`);
            return;
        }
        comp.toggleCss("ag-header-span-total", isSpanningTotal);
        const indexToStartSpanning = (this.column.getFirstRealParent()?.getLevel() ?? -1) + 1;
        const rowsToSpan = groupHeaderHeight.length - indexToStartSpanning;
        let extraHeight = 0;
        for(let i = 0; i < rowsToSpan; i++)extraHeight += groupHeaderHeight[groupHeaderHeight.length - 1 - i];
        eGui.style.setProperty("top", `${-extraHeight}px`);
        eGui.style.setProperty("height", `${headerHeight + extraHeight}px`);
    }
    refreshAriaSort() {
        if (this.sortable) {
            const translate = this.getLocaleTextFunc();
            const sort = this.beans.sortSvc?.getDisplaySortForColumn(this.column) || null;
            this.comp.setAriaSort($437b23f6a393c3bf$var$_getAriaSortState(sort));
            this.setAriaDescriptionProperty("sort", translate("ariaSortableColumn", "Press ENTER to sort"));
        } else {
            this.comp.setAriaSort();
            this.setAriaDescriptionProperty("sort", null);
        }
    }
    refreshAriaMenu() {
        if (this.menuEnabled) {
            const translate = this.getLocaleTextFunc();
            this.setAriaDescriptionProperty("menu", translate("ariaMenuColumn", "Press ALT DOWN to open column menu"));
        } else this.setAriaDescriptionProperty("menu", null);
    }
    refreshAriaFilterButton() {
        if (this.openFilterEnabled && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos)) {
            const translate = this.getLocaleTextFunc();
            this.setAriaDescriptionProperty("filterButton", translate("ariaFilterColumn", "Press CTRL ENTER to open filter"));
        } else this.setAriaDescriptionProperty("filterButton", null);
    }
    refreshAriaFiltered() {
        const translate = this.getLocaleTextFunc();
        const isFilterActive = this.column.isFilterActive();
        if (isFilterActive) this.setAriaDescriptionProperty("filter", translate("ariaColumnFiltered", "Column Filtered"));
        else this.setAriaDescriptionProperty("filter", null);
    }
    setAriaDescriptionProperty(property, value) {
        if (value != null) this.ariaDescriptionProperties.set(property, value);
        else this.ariaDescriptionProperties.delete(property);
    }
    announceAriaDescription() {
        if (!this.eGui.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) return;
        const ariaDescription = Array.from(this.ariaDescriptionProperties.keys()).sort((a, b)=>a === "filter" ? -1 : b.charCodeAt(0) - a.charCodeAt(0)).map((key)=>this.ariaDescriptionProperties.get(key)).join(". ");
        this.beans.ariaAnnounce?.announceValue(ariaDescription, "columnHeader");
    }
    refreshAria() {
        this.refreshAriaSort();
        this.refreshAriaMenu();
        this.refreshAriaFilterButton();
        this.refreshAriaFiltered();
    }
    addColumnHoverListener(compBean) {
        this.beans.colHover?.addHeaderColumnHoverListener(compBean, this.comp, this.column);
    }
    addActiveHeaderMouseListeners(compBean) {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>{
            this.setActiveHeader(true);
            this.dispatchColumnMouseEvent("columnHeaderClicked", this.column);
        };
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column);
        compBean.addManagedListeners(this.eGui, {
            mouseenter: listener,
            mouseleave: listener,
            click: clickListener,
            contextmenu: contextMenuListener
        });
    }
    handleMouseOverChange(isMouseOver) {
        this.setActiveHeader(isMouseOver);
        this.eventSvc.dispatchEvent({
            type: isMouseOver ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
            column: this.column
        });
    }
    setActiveHeader(active) {
        this.comp.toggleCss("ag-header-active", active);
    }
    getAnchorElementForMenu(isFilter) {
        const headerComp = this.comp.getUserCompInstance();
        if ($437b23f6a393c3bf$var$isHeaderComp(headerComp)) return headerComp.getAnchorElementForMenu(isFilter);
        return this.eGui;
    }
    destroy() {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$isHeaderComp(headerComp) {
    return typeof headerComp?.getAnchorElementForMenu === "function" && typeof headerComp.onMenuKeyboardShortcut === "function";
}
// packages/ag-grid-community/src/headerRendering/row/headerRowCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence3 = 0;
var $437b23f6a393c3bf$var$HeaderRowCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowIndex, pinned, type){
        super();
        this.rowIndex = rowIndex;
        this.pinned = pinned;
        this.type = type;
        this.instanceId = $437b23f6a393c3bf$var$instanceIdSequence3++;
        this.comp = null;
        this.allCtrls = [];
        let typeClass = "ag-header-row-column";
        if (type === "group") typeClass = "ag-header-row-group";
        else if (type === "filter") typeClass = "ag-header-row-filter";
        this.headerRowClass = `ag-header-row ${typeClass}`;
    }
    setRowIndex(rowIndex) {
        this.rowIndex = rowIndex;
        this.comp?.setRowIndex(this.getAriaRowIndex());
        this.onRowHeightChanged();
    }
    postConstruct() {
        this.isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
    }
    /** Checks that every header cell that is currently visible has been rendered.
   * Can only be false under some circumstances when using React
   */ areCellsRendered() {
        if (!this.comp) return false;
        return this.allCtrls.every((ctrl)=>ctrl.eGui != null);
    }
    /**
   *
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */ setComp(comp, compBean, initCompState = true) {
        this.comp = comp;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, this.beans.context, compBean);
        if (initCompState) {
            this.setRowIndex(this.rowIndex);
            this.onVirtualColumnsChanged();
        }
        this.setWidth();
        this.addEventListeners(compBean);
    }
    getAriaRowIndex() {
        return this.rowIndex + 1;
    }
    addEventListeners(compBean) {
        const onHeightChanged = this.onRowHeightChanged.bind(this);
        const onDisplayedColumnsChanged = this.onDisplayedColumnsChanged.bind(this);
        compBean.addManagedEventListeners({
            columnResized: this.setWidth.bind(this),
            displayedColumnsChanged: onDisplayedColumnsChanged,
            virtualColumnsChanged: (params)=>this.onVirtualColumnsChanged(params.afterScroll),
            columnGroupHeaderHeightChanged: onHeightChanged,
            columnHeaderHeightChanged: onHeightChanged,
            gridStylesChanged: onHeightChanged,
            advancedFilterEnabledChanged: onHeightChanged
        });
        compBean.addManagedPropertyListener("domLayout", onDisplayedColumnsChanged);
        compBean.addManagedPropertyListener("ensureDomOrder", (e)=>this.isEnsureDomOrder = e.currentValue);
        compBean.addManagedPropertyListeners([
            "headerHeight",
            "pivotHeaderHeight",
            "groupHeaderHeight",
            "pivotGroupHeaderHeight",
            "floatingFiltersHeight"
        ], onHeightChanged);
    }
    onDisplayedColumnsChanged() {
        this.isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        this.onVirtualColumnsChanged();
        this.setWidth();
        this.onRowHeightChanged();
    }
    setWidth() {
        if (!this.comp) return;
        const width = this.getWidthForRow();
        this.comp.setWidth(`${width}px`);
    }
    getWidthForRow() {
        const { visibleCols: visibleCols } = this.beans;
        if (this.isPrintLayout) {
            const pinned = this.pinned != null;
            if (pinned) return 0;
            return visibleCols.getContainerWidth("right") + visibleCols.getContainerWidth("left") + visibleCols.getContainerWidth(null);
        }
        return visibleCols.getContainerWidth(this.pinned);
    }
    onRowHeightChanged() {
        if (!this.comp) return;
        const { topOffset: topOffset, rowHeight: rowHeight } = this.getTopAndHeight();
        this.comp.setTop(topOffset + "px");
        this.comp.setHeight(rowHeight + "px");
    }
    getTopAndHeight() {
        let topOffset = 0;
        const groupHeadersHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(this.beans);
        for(let i = 0; i < groupHeadersHeight.length; i++){
            if (i === this.rowIndex && this.type === "group") return {
                topOffset: topOffset,
                rowHeight: groupHeadersHeight[i]
            };
            topOffset += groupHeadersHeight[i];
        }
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(this.beans);
        if (this.type === "column") return {
            topOffset: topOffset,
            rowHeight: headerHeight
        };
        topOffset += headerHeight;
        const filterHeight = $437b23f6a393c3bf$export$b52d5533bf5be44(this.beans);
        return {
            topOffset: topOffset,
            rowHeight: filterHeight
        };
    }
    onVirtualColumnsChanged(afterScroll = false) {
        if (!this.comp) return;
        const ctrlsToDisplay = this.getUpdatedHeaderCtrls();
        const forceOrder = this.isEnsureDomOrder || this.isPrintLayout;
        this.comp.setHeaderCtrls(ctrlsToDisplay, forceOrder, afterScroll);
    }
    /**
   * Recycles the header cell ctrls and creates new ones for the columns in the viewport
   * @returns The updated header cell ctrls
   */ getUpdatedHeaderCtrls() {
        const oldCtrls = this.ctrlsById;
        this.ctrlsById = /* @__PURE__ */ new Map();
        const columns = this.getColumnsInViewport();
        for (const child of columns)this.recycleAndCreateHeaderCtrls(child, this.ctrlsById, oldCtrls);
        const isFocusedAndDisplayed = (ctrl)=>{
            const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
            const isFocused = focusSvc.isHeaderWrapperFocused(ctrl);
            if (!isFocused) return false;
            const isDisplayed = visibleCols.isVisible(ctrl.column);
            return isDisplayed;
        };
        if (oldCtrls) for (const [id, oldCtrl] of oldCtrls){
            const keepCtrl = isFocusedAndDisplayed(oldCtrl);
            if (keepCtrl) this.ctrlsById.set(id, oldCtrl);
            else this.destroyBean(oldCtrl);
        }
        this.allCtrls = Array.from(this.ctrlsById.values());
        return this.allCtrls;
    }
    /** Get the current header cell ctrls */ getHeaderCellCtrls() {
        return this.allCtrls;
    }
    recycleAndCreateHeaderCtrls(headerColumn, currCtrls, oldCtrls) {
        if (headerColumn.isEmptyGroup()) return;
        const idOfChild = headerColumn.getUniqueId();
        let headerCtrl;
        if (oldCtrls) {
            headerCtrl = oldCtrls.get(idOfChild);
            oldCtrls.delete(idOfChild);
        }
        const forOldColumn = headerCtrl && headerCtrl.column != headerColumn;
        if (forOldColumn) {
            this.destroyBean(headerCtrl);
            headerCtrl = void 0;
        }
        if (headerCtrl == null) switch(this.type){
            case "filter":
                headerCtrl = this.createBean(this.beans.registry.createDynamicBean("headerFilterCellCtrl", true, headerColumn, this));
                break;
            case "group":
                headerCtrl = this.createBean(this.beans.registry.createDynamicBean("headerGroupCellCtrl", true, headerColumn, this));
                break;
            default:
                headerCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderCellCtrl(headerColumn, this));
                break;
        }
        currCtrls.set(idOfChild, headerCtrl);
    }
    getColumnsInViewport() {
        if (!this.isPrintLayout) return this.getComponentsToRender();
        if (this.pinned) return [];
        const viewportColumns = [];
        for (const pinned of [
            "left",
            null,
            "right"
        ])viewportColumns.push(...this.getComponentsToRender(pinned));
        return viewportColumns;
    }
    getComponentsToRender(pinned = this.pinned) {
        if (this.type === "group") return this.beans.colViewport.getHeadersToRender(pinned, this.rowIndex);
        return this.beans.colViewport.getColumnHeadersToRender(pinned);
    }
    focusHeader(column, event) {
        const ctrl = this.allCtrls.find((ctrl2)=>ctrl2.column == column);
        if (!ctrl) return false;
        const focused = ctrl.focus(event);
        return focused;
    }
    destroy() {
        this.allCtrls = this.destroyBeans(this.allCtrls);
        this.ctrlsById = void 0;
        this.comp = null;
        super.destroy();
    }
};
// packages/ag-grid-community/src/headerRendering/rowContainer/headerRowContainerCtrl.ts
var $437b23f6a393c3bf$export$1e864ee88f54e7b = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.hidden = false;
        this.includeFloatingFilter = false;
        this.groupsRowCtrls = [];
    }
    setComp(comp, eGui) {
        this.comp = comp;
        this.eViewport = eGui;
        const { pinnedCols: pinnedCols, ctrlsSvc: ctrlsSvc, colModel: colModel, colMoves: colMoves } = this.beans;
        this.setupCenterWidth();
        pinnedCols?.setupHeaderPinnedWidth(this);
        this.setupDragAndDrop(colMoves, this.eViewport);
        const onDisplayedColsChanged = this.refresh.bind(this, true);
        this.addManagedEventListeners({
            displayedColumnsChanged: onDisplayedColsChanged,
            advancedFilterEnabledChanged: onDisplayedColsChanged
        });
        const headerType = `${typeof this.pinned === "string" ? this.pinned : "center"}Header`;
        ctrlsSvc.register(headerType, this);
        if (colModel.ready) this.refresh();
    }
    getAllCtrls() {
        const res = [
            ...this.groupsRowCtrls
        ];
        if (this.columnsRowCtrl) res.push(this.columnsRowCtrl);
        if (this.filtersRowCtrl) res.push(this.filtersRowCtrl);
        return res;
    }
    refresh(keepColumns = false) {
        const { focusSvc: focusSvc, filterManager: filterManager, visibleCols: visibleCols } = this.beans;
        let sequence = 0;
        const focusedHeaderPosition = focusSvc.getFocusHeaderToUseAfterRefresh();
        const refreshColumnGroups = ()=>{
            const groupRowCount = visibleCols.headerGroupRowCount;
            sequence = groupRowCount;
            if (!keepColumns) this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
            const currentGroupCount = this.groupsRowCtrls.length;
            if (currentGroupCount === groupRowCount) return;
            if (currentGroupCount > groupRowCount) {
                for(let i = groupRowCount; i < currentGroupCount; i++)this.destroyBean(this.groupsRowCtrls[i]);
                this.groupsRowCtrls.length = groupRowCount;
                return;
            }
            for(let i = currentGroupCount; i < groupRowCount; i++){
                const ctrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(i, this.pinned, "group"));
                this.groupsRowCtrls.push(ctrl);
            }
        };
        const refreshColumns = ()=>{
            const rowIndex = sequence++;
            if (this.hidden) {
                this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
                return;
            }
            if (this.columnsRowCtrl == null || !keepColumns) {
                this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
                this.columnsRowCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(rowIndex, this.pinned, "column"));
            } else if (this.columnsRowCtrl.rowIndex !== rowIndex) this.columnsRowCtrl.setRowIndex(rowIndex);
        };
        const refreshFilters = ()=>{
            this.includeFloatingFilter = !!filterManager?.hasFloatingFilters() && !this.hidden;
            const destroyPreviousComp = ()=>{
                this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
            };
            if (!this.includeFloatingFilter) {
                destroyPreviousComp();
                return;
            }
            if (!keepColumns) destroyPreviousComp();
            const rowIndex = sequence++;
            if (this.filtersRowCtrl) {
                const rowIndexMismatch = this.filtersRowCtrl.rowIndex !== rowIndex;
                if (rowIndexMismatch) this.filtersRowCtrl.setRowIndex(rowIndex);
            } else this.filtersRowCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(rowIndex, this.pinned, "filter"));
        };
        const oldCtrls = this.getAllCtrls();
        refreshColumnGroups();
        refreshColumns();
        refreshFilters();
        const allCtrls = this.getAllCtrls();
        this.comp.setCtrls(allCtrls);
        this.restoreFocusOnHeader(focusSvc, focusedHeaderPosition);
        if (oldCtrls.length !== allCtrls.length) this.beans.eventSvc.dispatchEvent({
            type: "headerRowsChanged"
        });
    }
    getHeaderCtrlForColumn(column) {
        const findCtrl = (ctrl)=>ctrl?.getHeaderCellCtrls().find((ctrl2)=>ctrl2.column === column);
        if ($437b23f6a393c3bf$export$891484e65a02ec71(column)) return findCtrl(this.columnsRowCtrl);
        if (this.groupsRowCtrls.length === 0) return;
        for(let i = 0; i < this.groupsRowCtrls.length; i++){
            const ctrl = findCtrl(this.groupsRowCtrls[i]);
            if (ctrl) return ctrl;
        }
    }
    getHtmlElementForColumnHeader(column) {
        return this.getHeaderCtrlForColumn(column)?.eGui ?? null;
    }
    getRowType(rowIndex) {
        return this.getAllCtrls()[rowIndex]?.type;
    }
    focusHeader(rowIndex, column, event) {
        const allCtrls = this.getAllCtrls();
        const ctrl = allCtrls[rowIndex];
        if (!ctrl) return false;
        return ctrl.focusHeader(column, event);
    }
    getGroupRowCount() {
        return this.groupsRowCtrls.length;
    }
    getGroupRowCtrlAtIndex(index) {
        return this.groupsRowCtrls[index];
    }
    getRowCount() {
        return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
    }
    setHorizontalScroll(offset) {
        this.comp.setViewportScrollLeft(offset);
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
    destroy() {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
        this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
        this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
        super.destroy();
    }
    setupDragAndDrop(colMoves, dropContainer) {
        const bodyDropTarget = colMoves?.createBodyDropTarget(this.pinned, dropContainer);
        if (bodyDropTarget) this.createManagedBean(bodyDropTarget);
    }
    restoreFocusOnHeader(focusSvc, position) {
        if (!position) return;
        const { column: column } = position;
        if (column.getPinned() != this.pinned) return;
        focusSvc.focusHeaderPosition({
            headerPosition: position,
            scroll: false
        });
    }
    setupCenterWidth() {
        if (this.pinned != null) return;
        this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.comp.setCenterWidth(`${width}px`), true));
    }
};
// packages/ag-grid-community/src/misc/menu/menuService.ts
var $437b23f6a393c3bf$var$MenuService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "menuSvc";
    }
    postConstruct() {
        const { enterpriseMenuFactory: enterpriseMenuFactory, filterMenuFactory: filterMenuFactory } = this.beans;
        this.activeMenuFactory = enterpriseMenuFactory ?? filterMenuFactory;
    }
    showColumnMenu(params) {
        this.showColumnMenuCommon(this.activeMenuFactory, params, "columnMenu");
    }
    showFilterMenu(params) {
        this.showColumnMenuCommon($437b23f6a393c3bf$var$getFilterMenuFactory(this.beans), params, params.containerType, true);
    }
    showHeaderContextMenu(column, mouseEvent, touchEvent) {
        this.activeMenuFactory?.showMenuAfterContextMenuEvent(column, mouseEvent, touchEvent);
    }
    hidePopupMenu() {
        this.beans.contextMenuSvc?.hideActiveMenu();
        this.activeMenuFactory?.hideActiveMenu();
    }
    hideFilterMenu() {
        $437b23f6a393c3bf$var$getFilterMenuFactory(this.beans)?.hideActiveMenu();
    }
    isColumnMenuInHeaderEnabled(column) {
        const { suppressHeaderMenuButton: suppressHeaderMenuButton } = column.getColDef();
        return !suppressHeaderMenuButton && !!this.activeMenuFactory?.isMenuEnabled(column) && ($437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) || !!this.beans.enterpriseMenuFactory);
    }
    isFilterMenuInHeaderEnabled(column) {
        return !column.getColDef().suppressHeaderFilterButton && !!this.beans.filterManager?.isFilterAllowed(column);
    }
    isHeaderContextMenuEnabled(column) {
        const colDef = column && $437b23f6a393c3bf$export$891484e65a02ec71(column) ? column.getColDef() : column?.getColGroupDef();
        return !colDef?.suppressHeaderContextMenu && this.gos.get("columnMenu") === "new";
    }
    isHeaderMenuButtonAlwaysShowEnabled() {
        return this.isSuppressMenuHide();
    }
    isHeaderMenuButtonEnabled() {
        const menuHides = !this.isSuppressMenuHide();
        const onIpadAndMenuHides = $437b23f6a393c3bf$export$6b6034a68325bd8a() && menuHides;
        return !onIpadAndMenuHides;
    }
    isHeaderFilterButtonEnabled(column) {
        return this.isFilterMenuInHeaderEnabled(column) && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) && !this.isFloatingFilterButtonDisplayed(column);
    }
    isFilterMenuItemEnabled(column) {
        return !!this.beans.filterManager?.isFilterAllowed(column) && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) && !this.isFilterMenuInHeaderEnabled(column) && !this.isFloatingFilterButtonDisplayed(column);
    }
    isFloatingFilterButtonEnabled(column) {
        return !column.getColDef().suppressFloatingFilterButton;
    }
    isFloatingFilterButtonDisplayed(column) {
        return !!column.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(column);
    }
    isSuppressMenuHide() {
        const gos = this.gos;
        const suppressMenuHide = gos.get("suppressMenuHide");
        if ($437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos)) return gos.exists("suppressMenuHide") ? suppressMenuHide : false;
        return suppressMenuHide;
    }
    showColumnMenuCommon(menuFactory, params, containerType, filtersOnly) {
        const { positionBy: positionBy, onClosedCallback: onClosedCallback } = params;
        const column = params.column;
        if (positionBy === "button") {
            const { buttonElement: buttonElement } = params;
            menuFactory?.showMenuAfterButtonClick(column, buttonElement, containerType, onClosedCallback, filtersOnly);
        } else if (positionBy === "mouse") {
            const { mouseEvent: mouseEvent } = params;
            menuFactory?.showMenuAfterMouseEvent(column, mouseEvent, containerType, onClosedCallback, filtersOnly);
        } else if (column) {
            const beans = this.beans;
            const ctrlsSvc = beans.ctrlsSvc;
            ctrlsSvc.getScrollFeature().ensureColumnVisible(column, "auto");
            $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>{
                const headerCellCtrl = ctrlsSvc.getHeaderRowContainerCtrl(column.getPinned())?.getHeaderCtrlForColumn(column);
                if (headerCellCtrl) menuFactory?.showMenuAfterButtonClick(column, headerCellCtrl.getAnchorElementForMenu(filtersOnly), containerType, onClosedCallback, filtersOnly);
            });
        }
    }
};
function $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, visible, source) {
    if (column.menuVisible !== visible) {
        column.menuVisible = visible;
        column.dispatchColEvent("menuVisibleChanged", source);
    }
}
function $437b23f6a393c3bf$var$getFilterMenuFactory(beans) {
    const { enterpriseMenuFactory: enterpriseMenuFactory, filterMenuFactory: filterMenuFactory, gos: gos } = beans;
    return enterpriseMenuFactory && $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos) ? enterpriseMenuFactory : filterMenuFactory;
}
// packages/ag-grid-community/src/edit/cellEditors/agAbstractCellEditor.ts
var $437b23f6a393c3bf$export$803b08aecd9af1a9 = class extends $437b23f6a393c3bf$export$acd471c9223f27ae {
    constructor(){
        super(...arguments);
        this.errorMessages = null;
    }
    init(params) {
        this.params = params;
        this.initialiseEditor(params);
        this.eEditor.onValueChange(()=>params.validate());
    }
    destroy() {
        this.errorMessages = null;
    }
};
// packages/ag-grid-community/src/rendering/overlays/overlayComponent.ts
var $437b23f6a393c3bf$var$OverlayComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
    }
};
// packages/ag-grid-community/src/rendering/overlays/loadingOverlayComponent.ts
var $437b23f6a393c3bf$var$LoadingOverlayElement = {
    tag: "span",
    cls: "ag-overlay-loading-center"
};
var $437b23f6a393c3bf$var$LoadingOverlayComponent2 = class extends $437b23f6a393c3bf$var$OverlayComponent {
    init() {
        const customTemplate = $437b23f6a393c3bf$export$4978424c4f7b5fc0(this.gos.get("overlayLoadingTemplate")?.trim());
        this.setTemplate(customTemplate ?? $437b23f6a393c3bf$var$LoadingOverlayElement);
        if (!customTemplate) {
            const localeTextFunc = this.getLocaleTextFunc();
            const loadingText = localeTextFunc("loadingOoo", "Loading...");
            this.getGui().textContent = loadingText;
            this.beans.ariaAnnounce.announceValue(loadingText, "overlay");
        }
    }
};
// packages/ag-grid-community/src/rendering/overlays/noRowsOverlayComponent.ts
var $437b23f6a393c3bf$var$NoRowsOverlayElement = {
    tag: "span",
    cls: "ag-overlay-no-rows-center"
};
var $437b23f6a393c3bf$var$NoRowsOverlayComponent2 = class extends $437b23f6a393c3bf$var$OverlayComponent {
    init() {
        const customTemplate = $437b23f6a393c3bf$export$4978424c4f7b5fc0(this.gos.get("overlayNoRowsTemplate")?.trim());
        this.setTemplate(customTemplate ?? $437b23f6a393c3bf$var$NoRowsOverlayElement);
        if (!customTemplate) {
            const localeTextFunc = this.getLocaleTextFunc();
            const noRowsText = localeTextFunc("noRowsToShow", "No Rows To Show");
            this.getGui().textContent = noRowsText;
            this.beans.ariaAnnounce.announceValue(noRowsText, "overlay");
        }
    }
};
// packages/ag-grid-community/src/utils/icon.ts
function $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1(iconName, beans, column) {
    const iconContents = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, beans, column);
    if (iconContents) {
        const { className: className } = iconContents;
        if (typeof className === "string" && className.includes("ag-icon") || typeof className === "object" && className["ag-icon"]) return iconContents;
    }
    const eResult = $437b23f6a393c3bf$export$a232bb0480ae674a({
        tag: "span"
    });
    eResult.appendChild(iconContents);
    return eResult;
}
function $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, beans, column) {
    let userProvidedIcon = null;
    if (iconName === "smallDown") $437b23f6a393c3bf$export$545083624300f13d(262);
    else if (iconName === "smallLeft") $437b23f6a393c3bf$export$545083624300f13d(263);
    else if (iconName === "smallRight") $437b23f6a393c3bf$export$545083624300f13d(264);
    const icons = column?.getColDef().icons;
    if (icons) userProvidedIcon = icons[iconName];
    if (beans.gos && !userProvidedIcon) {
        const optionsIcons = beans.gos.get("icons");
        if (optionsIcons) userProvidedIcon = optionsIcons[iconName];
    }
    if (userProvidedIcon) {
        let rendererResult;
        if (typeof userProvidedIcon === "function") rendererResult = userProvidedIcon();
        else if (typeof userProvidedIcon === "string") rendererResult = userProvidedIcon;
        else {
            $437b23f6a393c3bf$export$545083624300f13d(38, {
                iconName: iconName
            });
            return void 0;
        }
        if (typeof rendererResult === "string") return $437b23f6a393c3bf$export$b1f57d075ca6d5fb(rendererResult);
        if ($437b23f6a393c3bf$export$6e6303ef478b0c94(rendererResult)) return rendererResult;
        $437b23f6a393c3bf$export$545083624300f13d(133, {
            iconName: iconName
        });
        return void 0;
    } else {
        const iconValue = beans.registry.getIcon(iconName);
        if (!iconValue) beans.validation?.validateIcon(iconName);
        return $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "span",
            cls: `ag-icon ag-icon-${iconValue ?? iconName}`,
            role: "presentation",
            attrs: {
                unselectable: "on"
            }
        });
    }
}
// packages/ag-grid-community/src/dragAndDrop/dragAndDropImageComponent.css-GENERATED.ts
var $437b23f6a393c3bf$var$dragAndDropImageComponentCSS = /*css*/ `.ag-dnd-ghost{align-items:center;background-color:var(--ag-drag-and-drop-image-background-color);border:var(--ag-drag-and-drop-image-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-drag-and-drop-image-shadow);color:var(--ag-text-color);cursor:move;display:flex;font-weight:500;gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding);text-overflow:ellipsis;transform:translateY(calc(var(--ag-spacing)*2));white-space:nowrap}.ag-dnd-ghost-not-allowed{border:var(--ag-drag-and-drop-image-not-allowed-border)}`;
// packages/ag-grid-community/src/dragAndDrop/dragAndDropImageComponent.ts
var $437b23f6a393c3bf$var$DragAndDropElement = {
    tag: "div",
    children: [
        {
            tag: "div",
            ref: "eGhost",
            cls: "ag-dnd-ghost ag-unselectable",
            children: [
                {
                    tag: "span",
                    ref: "eIcon",
                    cls: "ag-dnd-ghost-icon ag-shake-left-to-right"
                },
                {
                    tag: "div",
                    ref: "eLabel",
                    cls: "ag-dnd-ghost-label"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$DragAndDropImageComponent2 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
        this.dragSource = null;
        this.eIcon = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eGhost = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$dragAndDropImageComponentCSS);
    }
    postConstruct() {
        const create = (iconName)=>$437b23f6a393c3bf$export$f4e9fbdaadc5e5c1(iconName, this.beans, null);
        this.dropIconMap = {
            pinned: create("columnMovePin"),
            hide: create("columnMoveHide"),
            move: create("columnMoveMove"),
            left: create("columnMoveLeft"),
            right: create("columnMoveRight"),
            group: create("columnMoveGroup"),
            aggregate: create("columnMoveValue"),
            pivot: create("columnMovePivot"),
            notAllowed: create("dropNotAllowed")
        };
    }
    init(params) {
        this.dragSource = params.dragSource;
        this.setTemplate($437b23f6a393c3bf$var$DragAndDropElement);
        this.beans.environment.applyThemeClasses(this.eGhost);
    }
    destroy() {
        this.dragSource = null;
        super.destroy();
    }
    setIcon(iconName, shake) {
        const { eGhost: eGhost, eIcon: eIcon, dragSource: dragSource, dropIconMap: dropIconMap, gos: gos } = this;
        $437b23f6a393c3bf$export$69e6e10709eabd91(eIcon);
        let eIconChild = null;
        if (!iconName) iconName = dragSource?.getDefaultIconName ? dragSource.getDefaultIconName() : "notAllowed";
        eIconChild = dropIconMap[iconName];
        eGhost.classList.toggle("ag-dnd-ghost-not-allowed", iconName === "notAllowed");
        eIcon.classList.toggle("ag-shake-left-to-right", shake);
        if (eIconChild === dropIconMap["hide"] && gos.get("suppressDragLeaveHidesColumns")) return;
        if (eIconChild) eIcon.appendChild(eIconChild);
    }
    setLabel(label) {
        this.eLabel.textContent = label;
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/checkboxCellRenderer.css-GENERATED.ts
var $437b23f6a393c3bf$var$checkboxCellRendererCSS = /*css*/ `.ag-checkbox-cell{height:100%}`;
// packages/ag-grid-community/src/rendering/cellRenderers/checkboxCellRenderer.ts
var $437b23f6a393c3bf$var$CheckboxCellRendererElement = {
    tag: "div",
    cls: "ag-cell-wrapper ag-checkbox-cell",
    role: "presentation",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxCellRendererElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eCheckbox = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$checkboxCellRendererCSS);
    }
    init(params) {
        this.refresh(params);
        const { eCheckbox: eCheckbox, beans: beans } = this;
        const inputEl = eCheckbox.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        $437b23f6a393c3bf$var$_setAriaLive(inputEl, "polite");
        this.addManagedListeners(inputEl, {
            click: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
                if (eCheckbox.isDisabled()) return;
                const isSelected = eCheckbox.getValue();
                this.onCheckboxChanged(isSelected);
            },
            dblclick: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
            }
        });
        this.addManagedElementListeners(params.eGridCell, {
            keydown: (event)=>{
                if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE && !eCheckbox.isDisabled()) {
                    if (params.eGridCell === $437b23f6a393c3bf$export$16bc98d422315038(beans)) eCheckbox.toggle();
                    const isSelected = eCheckbox.getValue();
                    this.onCheckboxChanged(isSelected);
                    event.preventDefault();
                }
            }
        });
    }
    refresh(params) {
        this.params = params;
        this.updateCheckbox(params);
        return true;
    }
    updateCheckbox(params) {
        let isSelected;
        let displayed = true;
        const { value: value, column: column, node: node } = params;
        if (node.group && column) {
            if (typeof value === "boolean") isSelected = value;
            else {
                const colId = column.getColId();
                if (colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6)) isSelected = value == null || value === "" ? void 0 : value === "true";
                else if (node.aggData && node.aggData[colId] !== void 0) isSelected = value ?? void 0;
                else if (node.sourceRowIndex >= 0) isSelected = value ?? void 0;
                else displayed = false;
            }
        } else isSelected = value ?? void 0;
        const { eCheckbox: eCheckbox } = this;
        if (!displayed) {
            eCheckbox.setDisplayed(false);
            return;
        }
        eCheckbox.setValue(isSelected);
        const disabled = params.disabled ?? !column?.isCellEditable(node);
        eCheckbox.setDisabled(disabled);
        const translate = this.getLocaleTextFunc();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = disabled ? stateName : `${translate("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${stateName})`;
        eCheckbox.setInputAriaLabel(ariaLabel);
    }
    onCheckboxChanged(isSelected) {
        const { params: params } = this;
        const { column: column, node: node, value: value } = params;
        this.beans?.editSvc?.setEditingCells([
            {
                column: column,
                colId: column.getColId(),
                rowIndex: node.rowIndex,
                rowPinned: node.rowPinned,
                state: "changed",
                oldValue: value,
                newValue: value
            }
        ], {
            update: true,
            forceRefreshOfEditCellsOnly: true
        });
        const valueChanged = node.setDataValue(column, isSelected, "renderer");
        this.beans.editSvc?.stopEditing({
            rowNode: node,
            column: column
        }, {
            source: this.beans.editSvc?.isBatchEditing() ? "ui" : "api"
        });
        if (!valueChanged) this.updateCheckbox(params);
    }
};
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRowUtils.ts
var $437b23f6a393c3bf$var$PinnedRows = class {
    constructor(beans, floating){
        this.beans = beans;
        this.floating = floating;
        /** Canonical set of pinned nodes */ this.all = /* @__PURE__ */ new Set();
        /**
     * Set of nodes that should currently be visible given the context of the grid.
     * This is currently used for hiding leaf nodes in pivot mode and filtered nodes.
     */ this.visible = /* @__PURE__ */ new Set();
        /** Ordering of nodes in the pinned area */ this.order = [];
        /** IDs of nodes that need to be pinned once they are available from the row model (SSRM) */ this.queued = /* @__PURE__ */ new Set();
    }
    size() {
        return this.visible.size;
    }
    add(node) {
        const { all: all, visible: visible, order: order } = this;
        if (all.has(node)) return;
        all.add(node);
        visible.add(node);
        order.push(node);
        this.sort();
    }
    delete(item) {
        this.all.delete(item);
        this.visible.delete(item);
        this.queued.delete(item.id);
        $437b23f6a393c3bf$export$83a881c8b5120679(this.order, item);
    }
    has(item) {
        return this.visible.has(item);
    }
    forEach(fn) {
        this.order.forEach(fn);
    }
    getByIndex(i) {
        return this.order[i];
    }
    getById(id) {
        for (const node of this.visible){
            if (node.id == id) return node;
        }
    }
    clear() {
        const { all: all, visible: visible, order: order, queued: queued } = this;
        all.clear();
        queued.clear();
        visible.clear();
        order.length = 0;
    }
    sort() {
        const { sortSvc: sortSvc, rowNodeSorter: rowNodeSorter, gos: gos } = this.beans;
        const sortOptions = sortSvc?.getSortOptions() ?? [];
        const grandTotalNode = $437b23f6a393c3bf$var$_removeGrandTotalRow(this.order);
        this.order.sort((a, b)=>(a.pinnedSibling?.rowIndex ?? 0) - (b.pinnedSibling?.rowIndex ?? 0));
        this.order = rowNodeSorter?.doFullSort(this.order, sortOptions) ?? this.order;
        if (!grandTotalNode) return;
        const grandTotalRow = $437b23f6a393c3bf$export$c6fad27ed643a862(gos);
        if (grandTotalRow === "bottom" || grandTotalRow === "pinnedBottom") this.order.push(grandTotalNode);
        else this.order.unshift(grandTotalNode);
    }
    hide(shouldHide) {
        const { all: all, visible: visible } = this;
        all.forEach((node)=>shouldHide(node) ? visible.delete(node) : visible.add(node));
        this.order = Array.from(visible);
        this.sort();
    }
    queue(id) {
        this.queued.add(id);
    }
    unqueue(id) {
        this.queued.delete(id);
    }
    forEachQueued(fn) {
        this.queued.forEach(fn);
    }
};
function $437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(node) {
    if (node.level === -1) return true;
    const parent = node.parent;
    if (parent?.childrenAfterSort?.some((child)=>child == node)) return $437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(parent);
    return false;
}
function $437b23f6a393c3bf$var$_shouldHidePinnedRows(beans, node) {
    const { gos: gos, rowModel: rowModel, filterManager: filterManager } = beans;
    if ($437b23f6a393c3bf$export$cf1bac0013650216(gos, rowModel)) return !rowModel.getRowNode(node.id);
    if (filterManager?.isAnyFilterPresent()) return !$437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(node);
    if (gos.get("pivotMode")) return !node.group;
    return false;
}
function $437b23f6a393c3bf$var$_isNodeGrandTotal(node) {
    return !!node.footer && node.level === -1;
}
function $437b23f6a393c3bf$var$_isPinnedNodeGrandTotal(node) {
    return !!node.pinnedSibling && $437b23f6a393c3bf$var$_isNodeGrandTotal(node.pinnedSibling);
}
function $437b23f6a393c3bf$var$_removeGrandTotalRow(order) {
    const index = order.findIndex($437b23f6a393c3bf$var$_isPinnedNodeGrandTotal);
    if (index > -1) return order.splice(index, 1)?.[0];
}
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRowModel.ts
var $437b23f6a393c3bf$var$ManualPinnedRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        const { gos: gos, beans: beans } = this;
        this.top = new $437b23f6a393c3bf$var$PinnedRows(beans, "top");
        this.bottom = new $437b23f6a393c3bf$var$PinnedRows(beans, "bottom");
        const shouldHide = (node)=>$437b23f6a393c3bf$var$_shouldHidePinnedRows(beans, node.pinnedSibling);
        const runIsRowPinned = ()=>{
            const isRowPinned = gos.get("isRowPinned");
            if (isRowPinned && gos.get("enableRowPinning")) beans.rowModel.forEachNode((node)=>this.pinRow(node, isRowPinned(node)), true);
            this.refreshRowPositions();
            this.dispatchRowPinnedEvents();
        };
        this.addManagedEventListeners({
            gridStylesChanged: this.onGridStylesChanges.bind(this),
            modelUpdated: ({ keepRenderedRows: keepRenderedRows })=>{
                this.tryToEmptyQueues();
                this.pinGrandTotalRow();
                this.forContainers((container)=>container.hide(shouldHide));
                const positionsChanged = this.refreshRowPositions();
                if (!keepRenderedRows || positionsChanged) this.dispatchRowPinnedEvents();
            },
            columnRowGroupChanged: ()=>{
                this.forContainers($437b23f6a393c3bf$var$removeGroupRows);
                this.refreshRowPositions();
            },
            rowNodeDataChanged: ({ node: node })=>{
                const isRowPinnable = gos.get("isRowPinnable");
                const pinnable = isRowPinnable?.(node) ?? true;
                if (!pinnable) this.pinRow(node, null);
            },
            firstDataRendered: runIsRowPinned
        });
        this.addManagedPropertyListener("pivotMode", ()=>{
            this.forContainers((container)=>container.hide(shouldHide));
            this.dispatchRowPinnedEvents();
        });
        this.addManagedPropertyListener("grandTotalRow", ({ currentValue: currentValue })=>{
            this._grandTotalPinned = currentValue === "pinnedBottom" ? "bottom" : currentValue === "pinnedTop" ? "top" : null;
        });
        this.addManagedPropertyListener("isRowPinned", runIsRowPinned);
    }
    destroy() {
        this.reset(false);
        super.destroy();
    }
    reset(dispatch = true) {
        this.forContainers((container)=>{
            const nodesToUnpin = [];
            container.forEach((n)=>nodesToUnpin.push(n));
            nodesToUnpin.forEach((n)=>this.pinRow(n, null));
            container.clear();
        });
        if (dispatch) this.dispatchRowPinnedEvents();
    }
    pinRow(rowNode, float, column) {
        if (rowNode.footer && rowNode.level > -1) return;
        if (rowNode.footer && rowNode.level === -1) {
            this._grandTotalPinned = float;
            $437b23f6a393c3bf$var$refreshCSRM(this.beans);
            return;
        }
        const currentFloat = rowNode.rowPinned ?? rowNode.pinnedSibling?.rowPinned;
        const switching = currentFloat != null && float != null && float != currentFloat;
        if (switching) {
            const pinned = rowNode.rowPinned ? rowNode : rowNode.pinnedSibling;
            const source = rowNode.rowPinned ? rowNode.pinnedSibling : rowNode;
            this.pinRow(pinned, null, column);
            this.pinRow(source, float, column);
            return;
        }
        const spannedRows = column && $437b23f6a393c3bf$var$getSpannedRows(this.beans, rowNode, column);
        if (spannedRows) {
            spannedRows.forEach((node)=>this.pinRow(node, float));
            return;
        }
        if (float == null) {
            const node = rowNode.rowPinned ? rowNode : rowNode.pinnedSibling;
            const found = this.findPinnedRowNode(node);
            if (!found) return;
            found.delete(node);
            const source = node.pinnedSibling;
            $437b23f6a393c3bf$var$_destroyRowNodeSibling(node);
            this.refreshRowPositions(float);
            this.dispatchRowPinnedEvents(source);
        } else {
            const sibling = $437b23f6a393c3bf$var$_createPinnedSibling(this.beans, rowNode, float);
            const container = this.getContainer(float);
            container.add(sibling);
            if ($437b23f6a393c3bf$var$_shouldHidePinnedRows(this.beans, rowNode)) container.hide((node)=>$437b23f6a393c3bf$var$_shouldHidePinnedRows(this.beans, node.pinnedSibling));
            this.refreshRowPositions(float);
            this.dispatchRowPinnedEvents(rowNode);
        }
    }
    isManual() {
        return true;
    }
    isEmpty(floating) {
        return this.getContainer(floating).size() === 0;
    }
    isRowsToRender(floating) {
        return !this.isEmpty(floating);
    }
    ensureRowHeightsValid() {
        let anyChange = false;
        let rowTop = 0;
        const updateRowHeight = (rowNode)=>{
            if (rowNode.rowHeightEstimated) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                rowNode.setRowTop(rowTop);
                rowNode.setRowHeight(rowHeight.height);
                rowTop += rowHeight.height;
                anyChange = true;
            }
        };
        this.bottom.forEach(updateRowHeight);
        rowTop = 0;
        this.top.forEach(updateRowHeight);
        this.eventSvc.dispatchEvent({
            type: "pinnedHeightChanged"
        });
        return anyChange;
    }
    getPinnedTopTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight(this.top);
    }
    getPinnedBottomTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight(this.bottom);
    }
    getPinnedTopRowCount() {
        return this.top.size();
    }
    getPinnedBottomRowCount() {
        return this.bottom.size();
    }
    getPinnedTopRow(index) {
        return this.top.getByIndex(index);
    }
    getPinnedBottomRow(index) {
        return this.bottom.getByIndex(index);
    }
    getPinnedRowById(id, floating) {
        return this.getContainer(floating).getById(id);
    }
    forEachPinnedRow(floating, callback) {
        this.getContainer(floating).forEach(callback);
    }
    getPinnedState() {
        const buildState = (floating)=>{
            const list = [];
            this.forEachPinnedRow(floating, (node)=>list.push(node.pinnedSibling.id));
            return list;
        };
        return {
            top: buildState("top"),
            bottom: buildState("bottom")
        };
    }
    setPinnedState(state) {
        this.forContainers((pinned, floating)=>{
            for (const id of state[floating]){
                const node = this.beans.rowModel.getRowNode(id);
                if (node) this.pinRow(node, floating);
                else pinned.queue(id);
            }
        });
    }
    getGrandTotalPinned() {
        return this._grandTotalPinned;
    }
    setGrandTotalPinned(value) {
        this._grandTotalPinned = value;
    }
    tryToEmptyQueues() {
        this.forContainers((pinned, container)=>{
            const nodesToPin = /* @__PURE__ */ new Set();
            pinned.forEachQueued((id)=>{
                const node = this.beans.rowModel.getRowNode(id);
                if (node) nodesToPin.add(node);
            });
            for (const node of nodesToPin){
                pinned.unqueue(node.id);
                this.pinRow(node, container);
            }
        });
    }
    pinGrandTotalRow() {
        const { gos: gos, beans: beans, _grandTotalPinned: float } = this;
        const rowModel = beans.rowModel;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return;
        const sibling = rowModel.rootNode?.sibling;
        if (!sibling) return;
        const pinnedSibling = sibling.pinnedSibling;
        const container = pinnedSibling && this.findPinnedRowNode(pinnedSibling);
        if (!float) {
            if (!container) return;
            container.delete(pinnedSibling);
            $437b23f6a393c3bf$var$_destroyRowNodeSibling(pinnedSibling);
        } else {
            if (container && container.floating !== float) {
                container.delete(pinnedSibling);
                $437b23f6a393c3bf$var$_destroyRowNodeSibling(pinnedSibling);
            }
            if (!container || container.floating !== float) {
                const newPinnedSibling = $437b23f6a393c3bf$var$_createPinnedSibling(beans, sibling, float);
                this.getContainer(float).add(newPinnedSibling);
            }
        }
    }
    onGridStylesChanges(e) {
        if (e.rowHeightChanged) this.forContainers((container)=>container.forEach((rowNode)=>rowNode.setRowHeight(rowNode.rowHeight, true)));
    }
    getContainer(floating) {
        return floating === "top" ? this.top : this.bottom;
    }
    findPinnedRowNode(node) {
        if (this.top.has(node)) return this.top;
        if (this.bottom.has(node)) return this.bottom;
    }
    refreshRowPositions(floating) {
        const refreshAll = (pinned)=>$437b23f6a393c3bf$var$refreshRowPositions(this.beans, pinned);
        if (floating) return refreshAll(this.getContainer(floating));
        let changed = false;
        this.forContainers((container)=>{
            const updated = refreshAll(container);
            changed || (changed = updated);
        });
        return changed;
    }
    forContainers(fn) {
        fn(this.top, "top");
        fn(this.bottom, "bottom");
    }
    dispatchRowPinnedEvents(node) {
        this.eventSvc.dispatchEvent({
            type: "pinnedRowsChanged"
        });
        node?.dispatchRowEvent("rowPinned");
    }
};
function $437b23f6a393c3bf$var$refreshRowPositions(beans, container) {
    let rowTop = 0;
    let changed = false;
    container.forEach((node, index)=>{
        changed || (changed = node.rowTop !== rowTop);
        node.setRowTop(rowTop);
        if (node.rowHeightEstimated || node.rowHeight == null) {
            const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, node).height;
            changed || (changed = node.rowHeight !== rowHeight);
            node.setRowHeight(rowHeight);
        }
        node.setRowIndex(index);
        rowTop += node.rowHeight;
    });
    return changed;
}
function $437b23f6a393c3bf$var$_createPinnedSibling(beans, rowNode, floating) {
    if (rowNode.pinnedSibling) return rowNode.pinnedSibling;
    const sibling = $437b23f6a393c3bf$export$48fabbbfcde9fe36(rowNode, beans);
    sibling.setRowTop(null);
    sibling.setRowIndex(null);
    sibling.rowPinned = floating;
    const prefix = floating === "top" ? $437b23f6a393c3bf$export$27b0e4a919abc336 : $437b23f6a393c3bf$export$5f755686e611c1ea;
    sibling.id = `${prefix}${floating}-${rowNode.id}`;
    sibling.pinnedSibling = rowNode;
    rowNode.pinnedSibling = sibling;
    return sibling;
}
function $437b23f6a393c3bf$var$_destroyRowNodeSibling(rowNode) {
    if (!rowNode.pinnedSibling) return;
    rowNode.rowPinned = null;
    rowNode.setRowTop(null);
    rowNode.setRowIndex(null);
    const mainNode = rowNode.pinnedSibling;
    rowNode.pinnedSibling = void 0;
    if (mainNode) {
        mainNode.pinnedSibling = void 0;
        mainNode.rowPinned = null;
    }
}
function $437b23f6a393c3bf$var$removeGroupRows(set) {
    const rowsToRemove = /* @__PURE__ */ new Set();
    set.forEach((node)=>{
        if (node.group) rowsToRemove.add(node);
    });
    rowsToRemove.forEach((node)=>set.delete(node));
}
function $437b23f6a393c3bf$var$getSpannedRows(beans, rowNode, column) {
    const { rowSpanSvc: rowSpanSvc } = beans;
    const isCellSpanning = (column && rowSpanSvc?.isCellSpanning(column, rowNode)) ?? false;
    if (column && isCellSpanning) return rowSpanSvc?.getCellSpan(column, rowNode)?.spannedNodes;
}
function $437b23f6a393c3bf$var$getTotalHeight(container) {
    const size = container.size();
    if (size === 0) return 0;
    const node = container.getByIndex(size - 1);
    if (node === void 0) return 0;
    return node.rowTop + node.rowHeight;
}
function $437b23f6a393c3bf$var$refreshCSRM({ gos: gos, rowModel: rowModel }) {
    if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) rowModel.refreshModel({
        step: "map"
    });
}
// packages/ag-grid-community/src/pinnedRowModel/staticPinnedRowModel.ts
var $437b23f6a393c3bf$var$StaticPinnedRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.nextId = 0;
        this.pinnedTopRows = {
            cache: {},
            order: []
        };
        this.pinnedBottomRows = {
            cache: {},
            order: []
        };
    }
    postConstruct() {
        const gos = this.gos;
        this.setPinnedRowData(gos.get("pinnedTopRowData"), "top");
        this.setPinnedRowData(gos.get("pinnedBottomRowData"), "bottom");
        this.addManagedPropertyListener("pinnedTopRowData", (e)=>this.setPinnedRowData(e.currentValue, "top"));
        this.addManagedPropertyListener("pinnedBottomRowData", (e)=>this.setPinnedRowData(e.currentValue, "bottom"));
        this.addManagedEventListeners({
            gridStylesChanged: this.onGridStylesChanges.bind(this)
        });
    }
    reset() {}
    isEmpty(floating) {
        return this.getCache(floating).order.length === 0;
    }
    isRowsToRender(floating) {
        return !this.isEmpty(floating);
    }
    isManual() {
        return false;
    }
    pinRow(_node, _container) {}
    onGridStylesChanges(e) {
        if (e.rowHeightChanged) {
            const estimateRowHeight = (rowNode)=>{
                rowNode.setRowHeight(rowNode.rowHeight, true);
            };
            $437b23f6a393c3bf$var$forEach(this.pinnedBottomRows, estimateRowHeight);
            $437b23f6a393c3bf$var$forEach(this.pinnedTopRows, estimateRowHeight);
        }
    }
    ensureRowHeightsValid() {
        let anyChange = false;
        let rowTop = 0;
        const updateRowHeight = (rowNode)=>{
            if (rowNode.rowHeightEstimated) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                rowNode.setRowTop(rowTop);
                rowNode.setRowHeight(rowHeight.height);
                rowTop += rowHeight.height;
                anyChange = true;
            }
        };
        $437b23f6a393c3bf$var$forEach(this.pinnedBottomRows, updateRowHeight);
        rowTop = 0;
        $437b23f6a393c3bf$var$forEach(this.pinnedTopRows, updateRowHeight);
        this.eventSvc.dispatchEvent({
            type: "pinnedHeightChanged"
        });
        return anyChange;
    }
    setPinnedRowData(rowData, floating) {
        this.updateNodesFromRowData(rowData, floating);
        this.eventSvc.dispatchEvent({
            type: "pinnedRowDataChanged"
        });
    }
    /**
   * Updates existing RowNode instances and creates new ones if necessary
   *
   * Setting data as `undefined` will clear row nodes
   */ updateNodesFromRowData(allData, floating) {
        const nodes = this.getCache(floating);
        if (allData === void 0) {
            nodes.order.length = 0;
            nodes.cache = {};
            return;
        }
        const getRowId = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const idPrefix = floating === "top" ? $437b23f6a393c3bf$export$27b0e4a919abc336 : $437b23f6a393c3bf$export$5f755686e611c1ea;
        const nodesToRemove = new Set(nodes.order);
        const newOrder = [];
        const dataIds = /* @__PURE__ */ new Set();
        let nextRowTop = 0;
        let i = -1;
        for (const data of allData){
            const id = getRowId?.({
                data: data,
                level: 0,
                rowPinned: floating
            }) ?? idPrefix + this.nextId++;
            if (dataIds.has(id)) {
                $437b23f6a393c3bf$export$545083624300f13d(96, {
                    id: id,
                    data: data
                });
                continue;
            }
            i++;
            dataIds.add(id);
            newOrder.push(id);
            const existingNode = $437b23f6a393c3bf$var$getById(nodes, id);
            if (existingNode !== void 0) {
                if (existingNode.data !== data) existingNode.updateData(data);
                nextRowTop += this.setRowTopAndRowIndex(existingNode, nextRowTop, i);
                nodesToRemove.delete(id);
            } else {
                const rowNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
                rowNode.id = id;
                rowNode.data = data;
                rowNode.rowPinned = floating;
                nextRowTop += this.setRowTopAndRowIndex(rowNode, nextRowTop, i);
                nodes.cache[id] = rowNode;
                nodes.order.push(id);
            }
        }
        for (const id of nodesToRemove){
            $437b23f6a393c3bf$var$getById(nodes, id)?.clearRowTopAndRowIndex();
            delete nodes.cache[id];
        }
        nodes.order = newOrder;
    }
    setRowTopAndRowIndex(rowNode, rowTop, rowIndex) {
        rowNode.setRowTop(rowTop);
        rowNode.setRowHeight($437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode).height);
        rowNode.setRowIndex(rowIndex);
        return rowNode.rowHeight;
    }
    getPinnedTopTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight2(this.pinnedTopRows);
    }
    getPinnedBottomTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight2(this.pinnedBottomRows);
    }
    getPinnedTopRowCount() {
        return $437b23f6a393c3bf$var$getSize(this.pinnedTopRows);
    }
    getPinnedBottomRowCount() {
        return $437b23f6a393c3bf$var$getSize(this.pinnedBottomRows);
    }
    getPinnedTopRow(index) {
        return $437b23f6a393c3bf$var$getByIndex(this.pinnedTopRows, index);
    }
    getPinnedBottomRow(index) {
        return $437b23f6a393c3bf$var$getByIndex(this.pinnedBottomRows, index);
    }
    getPinnedRowById(id, floating) {
        return $437b23f6a393c3bf$var$getById(this.getCache(floating), id);
    }
    forEachPinnedRow(floating, callback) {
        return $437b23f6a393c3bf$var$forEach(this.getCache(floating), callback);
    }
    getCache(floating) {
        return floating === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
    }
    getPinnedState() {
        return {
            top: [],
            bottom: []
        };
    }
    setPinnedState() {}
    getGrandTotalPinned() {
        return;
    }
    setGrandTotalPinned() {}
};
function $437b23f6a393c3bf$var$getTotalHeight2(rowNodes) {
    const size = $437b23f6a393c3bf$var$getSize(rowNodes);
    if (size === 0) return 0;
    const node = $437b23f6a393c3bf$var$getByIndex(rowNodes, size - 1);
    if (node === void 0) return 0;
    return node.rowTop + node.rowHeight;
}
function $437b23f6a393c3bf$var$getById(cache, id) {
    return cache.cache[id];
}
function $437b23f6a393c3bf$var$getByIndex(cache, i) {
    return $437b23f6a393c3bf$var$getById(cache, cache.order[i]);
}
function $437b23f6a393c3bf$var$forEach(cache, callback) {
    cache.order.forEach((id, index)=>{
        const node = $437b23f6a393c3bf$var$getById(cache, id);
        node && callback(node, index);
    });
}
function $437b23f6a393c3bf$var$getSize(cache) {
    return cache.order.length;
}
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowModel.ts
var $437b23f6a393c3bf$export$d44126a5f53c99d9 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pinnedRowModel";
    }
    postConstruct() {
        const { gos: gos } = this;
        const initialiseRowModel = ()=>{
            const enableRowPinning = gos.get("enableRowPinning");
            const grandTotalRow = $437b23f6a393c3bf$export$c6fad27ed643a862(gos);
            const isGrandTotalRowPinned = grandTotalRow === "pinnedBottom" || grandTotalRow === "pinnedTop";
            const useManualPinnedRowModel = !!enableRowPinning || isGrandTotalRowPinned;
            const shouldDestroy = useManualPinnedRowModel ? this.inner instanceof $437b23f6a393c3bf$var$StaticPinnedRowModel : this.inner instanceof $437b23f6a393c3bf$var$ManualPinnedRowModel;
            if (this.inner && shouldDestroy) this.destroyBean(this.inner);
            if (shouldDestroy || !this.inner) this.inner = this.createManagedBean(useManualPinnedRowModel ? new $437b23f6a393c3bf$var$ManualPinnedRowModel() : new $437b23f6a393c3bf$var$StaticPinnedRowModel());
        };
        this.addManagedPropertyListeners([
            "enableRowPinning",
            "grandTotalRow"
        ], initialiseRowModel);
        initialiseRowModel();
    }
    reset() {
        return this.inner.reset();
    }
    isEmpty(container) {
        return this.inner.isEmpty(container);
    }
    isManual() {
        return this.inner.isManual();
    }
    isRowsToRender(container) {
        return this.inner.isRowsToRender(container);
    }
    pinRow(node, container, column) {
        return this.inner.pinRow(node, container, column);
    }
    ensureRowHeightsValid() {
        return this.inner.ensureRowHeightsValid();
    }
    getPinnedRowById(id, container) {
        return this.inner.getPinnedRowById(id, container);
    }
    getPinnedTopTotalHeight() {
        return this.inner.getPinnedTopTotalHeight();
    }
    getPinnedBottomTotalHeight() {
        return this.inner.getPinnedBottomTotalHeight();
    }
    getPinnedTopRowCount() {
        return this.inner.getPinnedTopRowCount();
    }
    getPinnedBottomRowCount() {
        return this.inner.getPinnedBottomRowCount();
    }
    getPinnedTopRow(index) {
        return this.inner.getPinnedTopRow(index);
    }
    getPinnedBottomRow(index) {
        return this.inner.getPinnedBottomRow(index);
    }
    forEachPinnedRow(container, callback) {
        return this.inner.forEachPinnedRow(container, callback);
    }
    getPinnedState() {
        return this.inner.getPinnedState();
    }
    setPinnedState(state) {
        return this.inner.setPinnedState(state);
    }
    setGrandTotalPinned(value) {
        return this.inner.setGrandTotalPinned(value);
    }
    getGrandTotalPinned() {
        return this.inner.getGrandTotalPinned();
    }
};
// packages/ag-grid-community/src/interfaces/serverSideTransaction.ts
var $437b23f6a393c3bf$export$58e95be8934cbc38 = /* @__PURE__ */ ((ServerSideTransactionResultStatus2)=>{
    ServerSideTransactionResultStatus2["Applied"] = "Applied";
    ServerSideTransactionResultStatus2["StoreNotFound"] = "StoreNotFound";
    ServerSideTransactionResultStatus2["StoreLoading"] = "StoreLoading";
    ServerSideTransactionResultStatus2["StoreWaitingToLoad"] = "StoreWaitingToLoad";
    ServerSideTransactionResultStatus2["StoreLoadingFailed"] = "StoreLoadingFailed";
    ServerSideTransactionResultStatus2["StoreWrongType"] = "StoreWrongType";
    ServerSideTransactionResultStatus2["Cancelled"] = "Cancelled";
    ServerSideTransactionResultStatus2["StoreNotStarted"] = "StoreNotStarted";
    return ServerSideTransactionResultStatus2;
})($437b23f6a393c3bf$export$58e95be8934cbc38 || {});
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowUtils.ts
function $437b23f6a393c3bf$var$_isManualPinnedRow(rowNode) {
    return !!(rowNode.rowPinned && rowNode.pinnedSibling);
}
function $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, start, end) {
    const isTop = float === "top";
    if (!start) return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, isTop ? rowModel.getPinnedTopRow(0) : rowModel.getPinnedBottomRow(0), end);
    if (!end) {
        const count = isTop ? rowModel.getPinnedTopRowCount() : rowModel.getPinnedBottomRowCount();
        return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, start, isTop ? rowModel.getPinnedTopRow(count - 1) : rowModel.getPinnedBottomRow(count - 1));
    }
    let started = false;
    let finished = false;
    const range = [];
    rowModel.forEachPinnedRow(float, (node)=>{
        if (node === start && !started) {
            started = true;
            range.push(node);
            return;
        }
        if (started && node === end) {
            finished = true;
            range.push(node);
            return;
        }
        if (started && !finished) range.push(node);
    });
    return range;
}
// packages/ag-grid-community/src/selection/checkboxSelectionComponent.ts
var $437b23f6a393c3bf$var$CheckboxSelectionComponentElement = {
    tag: "div",
    cls: "ag-selection-checkbox",
    role: "presentation",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxSelectionComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxSelectionComponentElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eCheckbox = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        this.eCheckbox.setPassive(true);
    }
    onDataChanged() {
        this.onSelectionChanged();
    }
    onSelectableChanged() {
        this.showOrHideSelect();
    }
    onSelectionChanged() {
        const translate = this.getLocaleTextFunc();
        const { rowNode: rowNode, eCheckbox: eCheckbox } = this;
        const state = rowNode.isSelected();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, state);
        const [ariaKey, ariaLabel] = rowNode.selectable ? [
            "ariaRowToggleSelection",
            "Press Space to toggle row selection"
        ] : [
            "ariaRowSelectionDisabled",
            "Row Selection is disabled for this row"
        ];
        const translatedLabel = translate(ariaKey, ariaLabel);
        eCheckbox.setValue(state, true);
        eCheckbox.setInputAriaLabel(`${translatedLabel} (${stateName})`);
    }
    init(params) {
        this.rowNode = params.rowNode;
        this.column = params.column;
        this.overrides = params.overrides;
        this.onSelectionChanged();
        this.addManagedListeners(this.eCheckbox.getInputElement(), {
            // we don't want double click on this icon to open a group
            dblclick: $437b23f6a393c3bf$export$456c40e80134d72a,
            click: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
                this.beans.selectionSvc?.handleSelectionEvent(event, this.rowNode, "checkboxSelected");
            }
        });
        this.addManagedListeners(this.rowNode, {
            rowSelected: this.onSelectionChanged.bind(this),
            dataChanged: this.onDataChanged.bind(this),
            selectableChanged: this.onSelectableChanged.bind(this)
        });
        this.addManagedPropertyListener("rowSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            const curr = typeof currentValue === "object" ? $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(currentValue) : void 0;
            const prev = typeof previousValue === "object" ? $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(previousValue) : void 0;
            if (curr !== prev) this.onSelectableChanged();
        });
        const isRowSelectableFunc = $437b23f6a393c3bf$export$351959be716b3b33(this.gos);
        const checkboxVisibleIsDynamic = isRowSelectableFunc || typeof this.getIsVisible() === "function";
        if (checkboxVisibleIsDynamic) {
            const showOrHideSelectListener = this.showOrHideSelect.bind(this);
            this.addManagedEventListeners({
                displayedColumnsChanged: showOrHideSelectListener
            });
            this.addManagedListeners(this.rowNode, {
                dataChanged: showOrHideSelectListener,
                cellChanged: showOrHideSelectListener
            });
            this.showOrHideSelect();
        }
        this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
    }
    showOrHideSelect() {
        const { column: column, rowNode: rowNode, overrides: overrides, gos: gos } = this;
        const selectable = rowNode.selectable;
        const isVisible = this.getIsVisible();
        let checkboxes = void 0;
        if (typeof isVisible === "function") {
            const extraParams = overrides?.callbackParams;
            if (!column) checkboxes = isVisible({
                ...extraParams,
                node: rowNode,
                data: rowNode.data
            });
            else {
                const params = column.createColumnFunctionCallbackParams(rowNode);
                checkboxes = isVisible({
                    ...extraParams,
                    ...params
                });
            }
        } else checkboxes = isVisible ?? false;
        const disabled = selectable && !checkboxes || !selectable && checkboxes;
        const visible = selectable || checkboxes;
        const so = gos.get("rowSelection");
        const showDisabledCheckboxes = so && typeof so !== "string" ? !$437b23f6a393c3bf$var$_getHideDisabledCheckboxes(so) : !!column?.getColDef().showDisabledCheckboxes;
        this.setVisible(visible && (disabled ? showDisabledCheckboxes : true));
        this.setDisplayed(visible && (disabled ? showDisabledCheckboxes : true));
        if (visible) this.eCheckbox.setDisabled(disabled);
        if (overrides?.removeHidden) this.setDisplayed(visible);
    }
    getIsVisible() {
        const overrides = this.overrides;
        if (overrides) return overrides.isVisible;
        const so = this.gos.get("rowSelection");
        if (so && typeof so !== "string") return $437b23f6a393c3bf$export$6df3a55606bca6ae(so);
        return this.column?.getColDef()?.checkboxSelection;
    }
};
// packages/ag-grid-community/src/selection/rowRangeSelectionContext.ts
var $437b23f6a393c3bf$var$RowRangeSelectionContext = class {
    constructor(rowModel, pinnedRowModel){
        this.rowModel = rowModel;
        this.pinnedRowModel = pinnedRowModel;
        /** Whether the user is currently selecting all nodes either via the header checkbox or API */ this.selectAll = false;
        this.rootId = null;
        /**
     * Note that the "end" `RowNode` may come before or after the "root" `RowNode` in the
     * actual grid.
     */ this.endId = null;
        this.cachedRange = [];
    }
    reset() {
        this.rootId = null;
        this.endId = null;
        this.cachedRange.length = 0;
    }
    setRoot(node) {
        this.rootId = node.id;
        this.endId = null;
        this.cachedRange.length = 0;
    }
    setEndRange(end) {
        this.endId = end.id;
        this.cachedRange.length = 0;
    }
    getRange() {
        if (this.cachedRange.length === 0) {
            const root = this.getRoot();
            const end = this.getEnd();
            if (root == null || end == null) return this.cachedRange;
            this.cachedRange = this.getNodesInRange(root, end) ?? [];
        }
        return this.cachedRange;
    }
    isInRange(node) {
        if (this.rootId === null) return false;
        return this.getRange().some((nodeInRange)=>nodeInRange.id === node.id);
    }
    getRoot(fallback) {
        if (this.rootId) return this.getRowNode(this.rootId);
        if (fallback) {
            this.setRoot(fallback);
            return fallback;
        }
    }
    getEnd() {
        if (this.endId) return this.getRowNode(this.endId);
    }
    getRowNode(id) {
        let node;
        const { rowModel: rowModel, pinnedRowModel: pinnedRowModel } = this;
        node ?? (node = rowModel.getRowNode(id));
        if (pinnedRowModel?.isManual()) {
            node ?? (node = pinnedRowModel.getPinnedRowById(id, "top"));
            node ?? (node = pinnedRowModel.getPinnedRowById(id, "bottom"));
        }
        return node;
    }
    /**
   * Truncates the range to the given node (assumed to be within the current range).
   * Returns nodes that remain in the current range and those that should be removed
   *
   * @param node - Node at which to truncate the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */ truncate(node) {
        const range = this.getRange();
        if (range.length === 0) return {
            keep: [],
            discard: []
        };
        const discardAfter = range[0].id === this.rootId;
        const idx = range.findIndex((rowNode)=>rowNode.id === node.id);
        if (idx > -1) {
            const above = range.slice(0, idx);
            const below = range.slice(idx + 1);
            this.setEndRange(node);
            return discardAfter ? {
                keep: above,
                discard: below
            } : {
                keep: below,
                discard: above
            };
        } else return {
            keep: range,
            discard: []
        };
    }
    /**
   * Extends the range to the given node. Returns nodes that remain in the current range
   * and those that should be removed.
   *
   * @param node - Node marking the new end of the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */ extend(node, groupSelectsChildren = false) {
        const root = this.getRoot();
        if (root == null) {
            const keep = this.getRange().slice();
            if (groupSelectsChildren) node.depthFirstSearch((node2)=>!node2.group && keep.push(node2));
            keep.push(node);
            this.setRoot(node);
            return {
                keep: keep,
                discard: []
            };
        }
        const newRange = this.getNodesInRange(root, node);
        if (!newRange) {
            this.setRoot(node);
            return {
                keep: [
                    node
                ],
                discard: []
            };
        }
        if (newRange.find((newRangeNode)=>newRangeNode.id === this.endId)) {
            this.setEndRange(node);
            return {
                keep: this.getRange(),
                discard: []
            };
        } else {
            const discard = this.getRange().slice();
            this.setEndRange(node);
            return {
                keep: this.getRange(),
                discard: discard
            };
        }
    }
    getNodesInRange(start, end) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this;
        if (!pinnedRowModel?.isManual()) return rowModel.getNodesInRangeForSelection(start, end);
        if (start.rowPinned === "top" && !end.rowPinned) {
            const pinnedRange = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, void 0);
            return pinnedRange.concat(rowModel.getNodesInRangeForSelection(rowModel.getRow(0), end) ?? []);
        }
        if (start.rowPinned === "bottom" && !end.rowPinned) {
            const pinnedRange = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, start);
            const count = rowModel.getRowCount();
            const lastMain = rowModel.getRow(count - 1);
            return (rowModel.getNodesInRangeForSelection(end, lastMain) ?? []).concat(pinnedRange);
        }
        if (!start.rowPinned && !end.rowPinned) return rowModel.getNodesInRangeForSelection(start, end);
        if (start.rowPinned === "top" && end.rowPinned === "top") return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, end);
        if (start.rowPinned === "bottom" && end.rowPinned === "top") {
            const top = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", end, void 0);
            const bottom = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, start);
            const first = rowModel.getRow(0);
            const last = rowModel.getRow(rowModel.getRowCount() - 1);
            return top.concat(rowModel.getNodesInRangeForSelection(first, last) ?? []).concat(bottom);
        }
        if (!start.rowPinned && end.rowPinned === "top") {
            const pinned = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", end, void 0);
            return pinned.concat(rowModel.getNodesInRangeForSelection(rowModel.getRow(0), start) ?? []);
        }
        if (start.rowPinned === "top" && end.rowPinned === "bottom") {
            const top = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, void 0);
            const bottom = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, end);
            const first = rowModel.getRow(0);
            const last = rowModel.getRow(rowModel.getRowCount() - 1);
            return top.concat(rowModel.getNodesInRangeForSelection(first, last) ?? []).concat(bottom);
        }
        if (start.rowPinned === "bottom" && end.rowPinned === "bottom") return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", start, end);
        if (!start.rowPinned && end.rowPinned === "bottom") {
            const pinned = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, end);
            const last = rowModel.getRow(rowModel.getRowCount());
            return (rowModel.getNodesInRangeForSelection(start, last) ?? []).concat(pinned);
        }
        return null;
    }
};
// packages/ag-grid-community/src/selection/selectAllFeature.ts
var $437b23f6a393c3bf$var$SelectAllFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column){
        super();
        this.column = column;
        this.cbSelectAllVisible = false;
        this.processingEventFromCheckbox = false;
    }
    onSpaceKeyDown(e) {
        const checkbox = this.cbSelectAll;
        if (checkbox.isDisplayed() && !checkbox.getGui().contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) {
            e.preventDefault();
            checkbox.setValue(!checkbox.getValue());
        }
    }
    getCheckboxGui() {
        return this.cbSelectAll.getGui();
    }
    setComp(ctrl) {
        this.headerCellCtrl = ctrl;
        const cbSelectAll = this.createManagedBean(new $437b23f6a393c3bf$export$b00c508c1ae18d07());
        this.cbSelectAll = cbSelectAll;
        cbSelectAll.addCss("ag-header-select-all");
        $437b23f6a393c3bf$export$f8d01fa01787902(cbSelectAll.getGui(), "presentation");
        this.showOrHideSelectAll();
        const updateStateOfCheckbox = this.updateStateOfCheckbox.bind(this);
        this.addManagedEventListeners({
            newColumnsLoaded: ()=>this.showOrHideSelectAll(),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            selectionChanged: updateStateOfCheckbox,
            paginationChanged: updateStateOfCheckbox,
            modelUpdated: updateStateOfCheckbox
        });
        this.addManagedPropertyListener("rowSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            const getSelectAll = (rowSelection)=>typeof rowSelection === "string" || !rowSelection || rowSelection.mode === "singleRow" ? void 0 : rowSelection.selectAll;
            if (getSelectAll(currentValue) !== getSelectAll(previousValue)) this.showOrHideSelectAll();
            this.updateStateOfCheckbox();
        });
        this.addManagedListeners(cbSelectAll, {
            fieldValueChanged: this.onCbSelectAll.bind(this)
        });
        cbSelectAll.getInputElement().setAttribute("tabindex", "-1");
        this.refreshSelectAllLabel();
    }
    onDisplayedColumnsChanged(e) {
        if (!this.isAlive()) return;
        this.showOrHideSelectAll(e.source === "uiColumnMoved");
    }
    showOrHideSelectAll(fromColumnMoved = false) {
        const cbSelectAllVisible = this.isCheckboxSelection();
        this.cbSelectAllVisible = cbSelectAllVisible;
        this.cbSelectAll.setDisplayed(cbSelectAllVisible);
        if (cbSelectAllVisible) {
            this.checkRightRowModelType("selectAllCheckbox");
            this.checkSelectionType("selectAllCheckbox");
            this.updateStateOfCheckbox();
        }
        this.refreshSelectAllLabel(fromColumnMoved);
    }
    updateStateOfCheckbox() {
        if (!this.cbSelectAllVisible || this.processingEventFromCheckbox) return;
        this.processingEventFromCheckbox = true;
        const selectAllMode = this.getSelectAllMode();
        const selectionSvc = this.beans.selectionSvc;
        const cbSelectAll = this.cbSelectAll;
        const allSelected = selectionSvc.getSelectAllState(selectAllMode);
        cbSelectAll.setValue(allSelected);
        const hasNodesToSelect = selectionSvc.hasNodesToSelect(selectAllMode);
        cbSelectAll.setDisabled(!hasNodesToSelect);
        this.refreshSelectAllLabel();
        this.processingEventFromCheckbox = false;
    }
    refreshSelectAllLabel(fromColumnMoved = false) {
        const translate = this.getLocaleTextFunc();
        const { headerCellCtrl: headerCellCtrl, cbSelectAll: cbSelectAll, cbSelectAllVisible: cbSelectAllVisible } = this;
        const checked = cbSelectAll.getValue();
        const ariaStatus = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, checked);
        const ariaLabel = translate("ariaRowSelectAll", "Press Space to toggle all rows selection");
        headerCellCtrl.setAriaDescriptionProperty("selectAll", cbSelectAllVisible ? `${ariaLabel} (${ariaStatus})` : null);
        cbSelectAll.setInputAriaLabel(translate("ariaHeaderSelection", "Column with Header Selection"));
        if (!fromColumnMoved) headerCellCtrl.announceAriaDescription();
    }
    checkSelectionType(feature) {
        const isMultiSelect = $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos);
        if (!isMultiSelect) {
            $437b23f6a393c3bf$export$545083624300f13d(128, {
                feature: feature
            });
            return false;
        }
        return true;
    }
    checkRightRowModelType(feature) {
        const { gos: gos, rowModel: rowModel } = this.beans;
        const rowModelMatches = $437b23f6a393c3bf$export$9f182d9ca737e15(gos) || $437b23f6a393c3bf$export$cf1bac0013650216(gos);
        if (!rowModelMatches) {
            $437b23f6a393c3bf$export$545083624300f13d(129, {
                feature: feature,
                rowModel: rowModel.getType()
            });
            return false;
        }
        return true;
    }
    onCbSelectAll() {
        if (this.processingEventFromCheckbox) return;
        if (!this.cbSelectAllVisible) return;
        const value = this.cbSelectAll.getValue();
        const selectAll2 = this.getSelectAllMode();
        let source = "uiSelectAll";
        if (selectAll2 === "currentPage") source = "uiSelectAllCurrentPage";
        else if (selectAll2 === "filtered") source = "uiSelectAllFiltered";
        const params = {
            source: source,
            selectAll: selectAll2
        };
        const selectionSvc = this.beans.selectionSvc;
        if (value) selectionSvc.selectAllRowNodes(params);
        else selectionSvc.deselectAllRowNodes(params);
    }
    /**
   * Checkbox is enabled when either the `headerCheckbox` option is enabled in the new selection API
   * or `headerCheckboxSelection` is enabled in the legacy API.
   */ isCheckboxSelection() {
        const { column: column, gos: gos, beans: beans } = this;
        const rowSelection = gos.get("rowSelection");
        const newHeaderCheckbox = typeof rowSelection === "object";
        const featureName = newHeaderCheckbox ? "headerCheckbox" : "headerCheckboxSelection";
        return $437b23f6a393c3bf$var$isCheckboxSelection(beans, column) && this.checkRightRowModelType(featureName) && this.checkSelectionType(featureName);
    }
    getSelectAllMode() {
        const selectAll2 = $437b23f6a393c3bf$var$_getSelectAll(this.gos, false);
        if (selectAll2) return selectAll2;
        const { headerCheckboxSelectionCurrentPageOnly: headerCheckboxSelectionCurrentPageOnly, headerCheckboxSelectionFilteredOnly: headerCheckboxSelectionFilteredOnly } = this.column.getColDef();
        if (headerCheckboxSelectionCurrentPageOnly) return "currentPage";
        if (headerCheckboxSelectionFilteredOnly) return "filtered";
        return "all";
    }
    destroy() {
        super.destroy();
        this.cbSelectAll = void 0;
        this.headerCellCtrl = void 0;
    }
};
function $437b23f6a393c3bf$var$isCheckboxSelection({ gos: gos, selectionColSvc: selectionColSvc }, column) {
    const rowSelection = gos.get("rowSelection");
    const colDef = column.getColDef();
    const { headerCheckboxSelection: headerCheckboxSelection } = colDef;
    let result = false;
    const newHeaderCheckbox = typeof rowSelection === "object";
    if (newHeaderCheckbox) {
        const isSelectionCol = $437b23f6a393c3bf$export$f6074a9792015c5d(column);
        const isAutoCol = $437b23f6a393c3bf$export$61b34611dc010a97(column);
        const location = $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection);
        if (location === "autoGroupColumn" && isAutoCol || isSelectionCol && selectionColSvc?.isSelectionColumnEnabled()) result = $437b23f6a393c3bf$export$e92e75627785d7a4(rowSelection);
    } else if (typeof headerCheckboxSelection === "function") result = headerCheckboxSelection($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        column: column,
        colDef: colDef
    }));
    else result = !!headerCheckboxSelection;
    return result;
}
// packages/ag-grid-community/src/selection/baseSelectionService.ts
var $437b23f6a393c3bf$export$3d7b168c0c9c2a78 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        const { gos: gos, beans: beans } = this;
        this.selectionCtx = new $437b23f6a393c3bf$var$RowRangeSelectionContext(beans.rowModel, beans.pinnedRowModel);
        this.addManagedPropertyListeners([
            "isRowSelectable",
            "rowSelection"
        ], ()=>{
            const callback = $437b23f6a393c3bf$export$351959be716b3b33(gos);
            if (callback !== this.isRowSelectable) {
                this.isRowSelectable = callback;
                this.updateSelectable();
            }
        });
        this.isRowSelectable = $437b23f6a393c3bf$export$351959be716b3b33(gos);
        this.addManagedEventListeners({
            cellValueChanged: (e)=>this.updateRowSelectable(e.node),
            rowNodeDataChanged: (e)=>this.updateRowSelectable(e.node)
        });
    }
    destroy() {
        super.destroy();
        this.selectionCtx.reset();
    }
    createCheckboxSelectionComponent() {
        return new $437b23f6a393c3bf$var$CheckboxSelectionComponent();
    }
    createSelectAllFeature(column) {
        if ($437b23f6a393c3bf$var$isCheckboxSelection(this.beans, column)) return new $437b23f6a393c3bf$var$SelectAllFeature(column);
    }
    isMultiSelect() {
        return $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos);
    }
    onRowCtrlSelected(rowCtrl, hasFocusFunc, gui) {
        const selected = !!rowCtrl.rowNode.isSelected();
        rowCtrl.forEachGui(gui, (gui2)=>{
            gui2.rowComp.toggleCss("ag-row-selected", selected);
            const element = gui2.element;
            $437b23f6a393c3bf$export$c22e3722e8a33469(element, selected);
            const hasFocus = element.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans));
            if (hasFocus) hasFocusFunc(gui2);
        });
    }
    announceAriaRowSelection(rowNode) {
        if (this.isRowSelectionBlocked(rowNode)) return;
        const selected = rowNode.isSelected();
        const isEditing2 = this.beans.editSvc?.isEditing({
            rowNode: rowNode
        });
        if (!rowNode.selectable || isEditing2) return;
        const translate = this.getLocaleTextFunc();
        const label = translate(selected ? "ariaRowDeselect" : "ariaRowSelect", `Press SPACE to ${selected ? "deselect" : "select"} this row`);
        this.beans.ariaAnnounce?.announceValue(label, "rowSelection");
    }
    isRowSelectionBlocked(rowNode) {
        return !rowNode.selectable || rowNode.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(rowNode) || !$437b23f6a393c3bf$export$5d5fd838f5df1dd2(this.gos);
    }
    updateRowSelectable(rowNode, suppressSelectionUpdate) {
        const selectable = rowNode.rowPinned && rowNode.pinnedSibling ? // If row node is pinned sibling, copy selectable status over from sibling row node
        rowNode.pinnedSibling.selectable : // otherwise calculate selectable state directly
        this.isRowSelectable?.(rowNode) ?? true;
        this.setRowSelectable(rowNode, selectable, suppressSelectionUpdate);
        return selectable;
    }
    setRowSelectable(rowNode, newVal, suppressSelectionUpdate) {
        if (rowNode.selectable !== newVal) {
            rowNode.selectable = newVal;
            rowNode.dispatchRowEvent("selectableChanged");
            if (suppressSelectionUpdate) return;
            const isGroupSelectsChildren = $437b23f6a393c3bf$export$460e5745f0e6a40d(this.gos);
            if (isGroupSelectsChildren) {
                const selected = this.calculateSelectedFromChildren(rowNode);
                this.setNodesSelected({
                    nodes: [
                        rowNode
                    ],
                    newValue: selected ?? false,
                    source: "selectableChanged"
                });
                return;
            }
            if (rowNode.isSelected() && !rowNode.selectable) this.setNodesSelected({
                nodes: [
                    rowNode
                ],
                newValue: false,
                source: "selectableChanged"
            });
        }
    }
    calculateSelectedFromChildren(rowNode) {
        let atLeastOneSelected = false;
        let atLeastOneDeSelected = false;
        if (!rowNode.childrenAfterGroup?.length) return rowNode.selectable ? rowNode.__selected : null;
        for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
            const child = rowNode.childrenAfterGroup[i];
            let childState = child.isSelected();
            if (!child.selectable) {
                const selectable = this.calculateSelectedFromChildren(child);
                if (selectable === null) continue;
                childState = selectable;
            }
            switch(childState){
                case true:
                    atLeastOneSelected = true;
                    break;
                case false:
                    atLeastOneDeSelected = true;
                    break;
                default:
                    return void 0;
            }
        }
        if (atLeastOneSelected && atLeastOneDeSelected) return void 0;
        if (atLeastOneSelected) return true;
        if (atLeastOneDeSelected) return false;
        if (!rowNode.selectable) return null;
        return rowNode.__selected;
    }
    selectRowNode(rowNode, newValue, e, source = "api") {
        const selectionNotAllowed = !rowNode.selectable && newValue;
        const selectionNotChanged = rowNode.__selected === newValue;
        if (selectionNotAllowed || selectionNotChanged) return false;
        rowNode.__selected = newValue;
        rowNode.dispatchRowEvent("rowSelected");
        const sibling = rowNode.sibling;
        if (sibling && sibling.footer && sibling.__localEventService) sibling.dispatchRowEvent("rowSelected");
        const pinnedSibling = rowNode.pinnedSibling;
        if (pinnedSibling?.rowPinned && pinnedSibling.__localEventService) pinnedSibling.dispatchRowEvent("rowSelected");
        this.eventSvc.dispatchEvent({
            ...$437b23f6a393c3bf$export$5c5bd6257397e1bc(rowNode, this.gos, "rowSelected"),
            event: e || null,
            source: source
        });
        return true;
    }
    isCellCheckboxSelection(column, rowNode) {
        const so = this.gos.get("rowSelection");
        if (so && typeof so !== "string") {
            const checkbox = $437b23f6a393c3bf$export$f6074a9792015c5d(column) && $437b23f6a393c3bf$export$6df3a55606bca6ae(so);
            return column.isColumnFunc(rowNode, checkbox);
        } else return column.isColumnFunc(rowNode, column.colDef.checkboxSelection);
    }
    inferNodeSelections(node, shiftKey, metaKey, source) {
        const { gos: gos, selectionCtx: selectionCtx } = this;
        const currentSelection = node.isSelected();
        const groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
        const enableClickSelection = $437b23f6a393c3bf$var$_getEnableSelection(gos);
        const enableDeselection = $437b23f6a393c3bf$var$_getEnableDeselection(gos);
        const isMultiSelect = this.isMultiSelect();
        const isRowClicked = source === "rowClicked";
        if (isRowClicked && !(enableClickSelection || enableDeselection)) return null;
        if (shiftKey && metaKey && isMultiSelect) {
            const root = selectionCtx.getRoot();
            if (!root) return null;
            else if (!root.isSelected()) {
                const partition = selectionCtx.extend(node, groupSelectsDescendants);
                return {
                    select: [],
                    deselect: partition.keep,
                    reset: false
                };
            } else {
                const partition = selectionCtx.isInRange(node) ? selectionCtx.truncate(node) : selectionCtx.extend(node, groupSelectsDescendants);
                return {
                    deselect: partition.discard,
                    select: partition.keep,
                    reset: false
                };
            }
        } else if (shiftKey && isMultiSelect) {
            const fallback = selectionCtx.selectAll ? this.beans.rowModel.getRow(0) : void 0;
            const root = selectionCtx.getRoot(fallback);
            const partition = selectionCtx.isInRange(node) ? selectionCtx.truncate(node) : selectionCtx.extend(node, groupSelectsDescendants);
            return {
                select: partition.keep,
                deselect: partition.discard,
                reset: selectionCtx.selectAll || !!(root && !root.isSelected())
            };
        } else if (metaKey) {
            if (isRowClicked) {
                const newValue = !currentSelection;
                const selectingWhenDisabled = newValue && !enableClickSelection;
                const deselectingWhenDisabled = !newValue && !enableDeselection;
                if (selectingWhenDisabled || deselectingWhenDisabled) return null;
                selectionCtx.setRoot(node);
                return {
                    node: node,
                    newValue: newValue,
                    clearSelection: false
                };
            }
            selectionCtx.setRoot(node);
            return {
                node: node,
                newValue: !currentSelection,
                clearSelection: !isMultiSelect
            };
        } else {
            selectionCtx.setRoot(node);
            const enableSelectionWithoutKeys = $437b23f6a393c3bf$var$_getEnableSelectionWithoutKeys(gos);
            const groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
            const shouldClear = isRowClicked && (!enableSelectionWithoutKeys || !enableClickSelection);
            if (groupSelectsFiltered && currentSelection === void 0 && $437b23f6a393c3bf$export$9f182d9ca737e15(gos)) return {
                node: node,
                newValue: false,
                checkFilteredNodes: true,
                clearSelection: !isMultiSelect || shouldClear
            };
            if (isRowClicked) {
                const newValue = currentSelection ? !enableSelectionWithoutKeys : enableClickSelection;
                const selectingWhenDisabled = newValue && !enableClickSelection;
                const deselectingWhenDisabled = !newValue && !enableDeselection;
                const wouldStateBeUnchanged = newValue === currentSelection && !shouldClear;
                if (wouldStateBeUnchanged || selectingWhenDisabled || deselectingWhenDisabled) return null;
                return {
                    node: node,
                    newValue: newValue,
                    clearSelection: !isMultiSelect || shouldClear,
                    keepDescendants: node.group && groupSelectsDescendants
                };
            }
            return {
                node: node,
                newValue: !currentSelection,
                clearSelection: !isMultiSelect || shouldClear
            };
        }
    }
};
// packages/ag-grid-community/src/widgets/tabGuardCtrl.ts
var $437b23f6a393c3bf$export$3be5727576441c72 = {
    TAB_GUARD: "ag-tab-guard",
    TAB_GUARD_TOP: "ag-tab-guard-top",
    TAB_GUARD_BOTTOM: "ag-tab-guard-bottom"
};
var $437b23f6a393c3bf$export$3074753638c3772c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.skipTabGuardFocus = false;
        this.forcingFocusOut = false;
        // Used when `isFocusableContainer` enabled
        this.allowFocus = false;
        const { comp: comp, eTopGuard: eTopGuard, eBottomGuard: eBottomGuard, focusTrapActive: focusTrapActive, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, isFocusableContainer: isFocusableContainer, focusInnerElement: focusInnerElement, onFocusIn: onFocusIn, onFocusOut: onFocusOut, shouldStopEventPropagation: shouldStopEventPropagation, onTabKeyDown: onTabKeyDown, handleKeyDown: handleKeyDown, isEmpty: isEmpty, eFocusableElement: eFocusableElement } = params;
        this.comp = comp;
        this.eTopGuard = eTopGuard;
        this.eBottomGuard = eBottomGuard;
        this.providedFocusInnerElement = focusInnerElement;
        this.eFocusableElement = eFocusableElement;
        this.focusTrapActive = !!focusTrapActive;
        this.forceFocusOutWhenTabGuardsAreEmpty = !!forceFocusOutWhenTabGuardsAreEmpty;
        this.isFocusableContainer = !!isFocusableContainer;
        this.providedFocusIn = onFocusIn;
        this.providedFocusOut = onFocusOut;
        this.providedShouldStopEventPropagation = shouldStopEventPropagation;
        this.providedOnTabKeyDown = onTabKeyDown;
        this.providedHandleKeyDown = handleKeyDown;
        this.providedIsEmpty = isEmpty;
    }
    postConstruct() {
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.eFocusableElement, {
            shouldStopEventPropagation: ()=>this.shouldStopEventPropagation(),
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e),
            onFocusIn: (e)=>this.onFocusIn(e),
            onFocusOut: (e)=>this.onFocusOut(e)
        }));
        this.activateTabGuards();
        for (const guard of [
            this.eTopGuard,
            this.eBottomGuard
        ])this.addManagedElementListeners(guard, {
            focus: this.onFocus.bind(this)
        });
    }
    handleKeyDown(e) {
        if (this.providedHandleKeyDown) this.providedHandleKeyDown(e);
    }
    tabGuardsAreActive() {
        return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
    }
    shouldStopEventPropagation() {
        if (this.providedShouldStopEventPropagation) return this.providedShouldStopEventPropagation();
        return false;
    }
    activateTabGuards() {
        if (this.forcingFocusOut) return;
        const tabIndex = this.gos.get("tabIndex");
        this.comp.setTabIndex(tabIndex.toString());
    }
    deactivateTabGuards() {
        this.comp.setTabIndex();
    }
    onFocus(e) {
        if (this.isFocusableContainer && !this.eFocusableElement.contains(e.relatedTarget)) {
            if (!this.allowFocus) {
                this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
                return;
            }
        }
        if (this.skipTabGuardFocus) {
            this.skipTabGuardFocus = false;
            return;
        }
        if (this.forceFocusOutWhenTabGuardsAreEmpty) {
            const isEmpty = this.providedIsEmpty ? this.providedIsEmpty() : $437b23f6a393c3bf$export$7acf44f59625b1f6(this.eFocusableElement, ".ag-tab-guard").length === 0;
            if (isEmpty) {
                this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
                return;
            }
        }
        if (this.isFocusableContainer && this.eFocusableElement.contains(e.relatedTarget)) return;
        const fromBottom = e.target === this.eBottomGuard;
        const hasFocusedInnerElement = this.providedFocusInnerElement ? this.providedFocusInnerElement(fromBottom) : this.focusInnerElement(fromBottom);
        if (!hasFocusedInnerElement && this.forceFocusOutWhenTabGuardsAreEmpty) this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
    }
    findNextElementOutsideAndFocus(up) {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        const focusableEls = $437b23f6a393c3bf$export$7acf44f59625b1f6(eDocument.body, null, true);
        const index = focusableEls.indexOf(up ? this.eTopGuard : this.eBottomGuard);
        if (index === -1) return;
        let start;
        let end;
        if (up) {
            start = 0;
            end = index;
        } else {
            start = index + 1;
            end = focusableEls.length;
        }
        const focusableRange = focusableEls.slice(start, end);
        const targetTabIndex = this.gos.get("tabIndex");
        focusableRange.sort((a, b)=>{
            const indexA = Number.parseInt(a.getAttribute("tabindex") || "0");
            const indexB = Number.parseInt(b.getAttribute("tabindex") || "0");
            if (indexB === targetTabIndex) return 1;
            if (indexA === targetTabIndex) return -1;
            if (indexA === 0) return 1;
            if (indexB === 0) return -1;
            return indexA - indexB;
        });
        focusableRange[up ? focusableRange.length - 1 : 0]?.focus();
    }
    onFocusIn(e) {
        if (this.focusTrapActive || this.forcingFocusOut) return;
        if (this.providedFocusIn) this.providedFocusIn(e);
        if (!this.isFocusableContainer) this.deactivateTabGuards();
    }
    onFocusOut(e) {
        if (this.focusTrapActive) return;
        if (this.providedFocusOut) this.providedFocusOut(e);
        if (!this.eFocusableElement.contains(e.relatedTarget)) this.activateTabGuards();
    }
    onTabKeyDown(e) {
        if (this.providedOnTabKeyDown) {
            this.providedOnTabKeyDown(e);
            return;
        }
        if (this.focusTrapActive) return;
        if (e.defaultPrevented) return;
        const tabGuardsAreActive = this.tabGuardsAreActive();
        if (tabGuardsAreActive) this.deactivateTabGuards();
        const nextRoot = this.getNextFocusableElement(e.shiftKey);
        if (tabGuardsAreActive) setTimeout(()=>this.activateTabGuards(), 0);
        if (!nextRoot) return;
        nextRoot.focus();
        e.preventDefault();
    }
    focusInnerElement(fromBottom = false) {
        const focusable = $437b23f6a393c3bf$export$7acf44f59625b1f6(this.eFocusableElement);
        if (this.tabGuardsAreActive()) {
            focusable.splice(0, 1);
            focusable.splice(focusable.length - 1, 1);
        }
        if (!focusable.length) return false;
        focusable[fromBottom ? focusable.length - 1 : 0].focus({
            preventScroll: true
        });
        return true;
    }
    getNextFocusableElement(backwards) {
        return $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, this.eFocusableElement, false, backwards);
    }
    forceFocusOutOfContainer(up = false) {
        if (this.forcingFocusOut) return;
        const tabGuardToFocus = up ? this.eTopGuard : this.eBottomGuard;
        this.activateTabGuards();
        this.skipTabGuardFocus = true;
        this.forcingFocusOut = true;
        tabGuardToFocus.focus();
        window.setTimeout(()=>{
            this.forcingFocusOut = false;
            this.activateTabGuards();
        });
    }
    isTabGuard(element, bottom) {
        return element === this.eTopGuard && !bottom || element === this.eBottomGuard && (bottom ?? true);
    }
    setAllowFocus(allowFocus) {
        this.allowFocus = allowFocus;
    }
};
// packages/ag-grid-community/src/widgets/tabGuardFeature.ts
var $437b23f6a393c3bf$export$299cbf451479e921 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp){
        super();
        this.comp = comp;
    }
    initialiseTabGuard(params) {
        this.eTopGuard = this.createTabGuard("top");
        this.eBottomGuard = this.createTabGuard("bottom");
        this.eFocusableElement = this.comp.getFocusableElement();
        const { eTopGuard: eTopGuard, eBottomGuard: eBottomGuard, eFocusableElement: eFocusableElement } = this;
        const tabGuards = [
            eTopGuard,
            eBottomGuard
        ];
        const compProxy = {
            setTabIndex: (tabIndex)=>{
                for (const tabGuard of tabGuards)tabIndex != null ? tabGuard.setAttribute("tabindex", tabIndex) : tabGuard.removeAttribute("tabindex");
            }
        };
        this.addTabGuards(eTopGuard, eBottomGuard);
        const { focusTrapActive: focusTrapActive = false, onFocusIn: onFocusIn, onFocusOut: onFocusOut, focusInnerElement: focusInnerElement, handleKeyDown: handleKeyDown, onTabKeyDown: onTabKeyDown, shouldStopEventPropagation: shouldStopEventPropagation, isEmpty: isEmpty, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, isFocusableContainer: isFocusableContainer } = params;
        this.tabGuardCtrl = this.createManagedBean(new $437b23f6a393c3bf$export$3074753638c3772c({
            comp: compProxy,
            focusTrapActive: focusTrapActive,
            eTopGuard: eTopGuard,
            eBottomGuard: eBottomGuard,
            eFocusableElement: eFocusableElement,
            onFocusIn: onFocusIn,
            onFocusOut: onFocusOut,
            focusInnerElement: focusInnerElement,
            handleKeyDown: handleKeyDown,
            onTabKeyDown: onTabKeyDown,
            shouldStopEventPropagation: shouldStopEventPropagation,
            isEmpty: isEmpty,
            forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty,
            isFocusableContainer: isFocusableContainer
        }));
    }
    getTabGuardCtrl() {
        return this.tabGuardCtrl;
    }
    createTabGuard(side) {
        const tabGuard = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans).createElement("div");
        const cls = side === "top" ? $437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD_TOP : $437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD_BOTTOM;
        tabGuard.classList.add($437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD, cls);
        $437b23f6a393c3bf$export$f8d01fa01787902(tabGuard, "presentation");
        return tabGuard;
    }
    addTabGuards(topTabGuard, bottomTabGuard) {
        const eFocusableElement = this.eFocusableElement;
        eFocusableElement.insertAdjacentElement("afterbegin", topTabGuard);
        eFocusableElement.insertAdjacentElement("beforeend", bottomTabGuard);
    }
    removeAllChildrenExceptTabGuards() {
        const tabGuards = [
            this.eTopGuard,
            this.eBottomGuard
        ];
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.comp.getFocusableElement());
        this.addTabGuards(...tabGuards);
    }
    forceFocusOutOfContainer(up = false) {
        this.tabGuardCtrl.forceFocusOutOfContainer(up);
    }
    appendChild(appendChild, newChild, container) {
        if (!$437b23f6a393c3bf$export$6e6303ef478b0c94(newChild)) newChild = newChild.getGui();
        const { eBottomGuard: bottomTabGuard } = this;
        if (bottomTabGuard) bottomTabGuard.insertAdjacentElement("beforebegin", newChild);
        else appendChild(newChild, container);
    }
    destroy() {
        const { eTopGuard: eTopGuard, eBottomGuard: eBottomGuard } = this;
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eTopGuard);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eBottomGuard);
        super.destroy();
    }
};
// packages/ag-grid-community/src/widgets/tabGuardComp.ts
var $437b23f6a393c3bf$export$5a26e3abd1c845b6 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    initialiseTabGuard(params) {
        this.tabGuardFeature = this.createManagedBean(new $437b23f6a393c3bf$export$299cbf451479e921(this));
        this.tabGuardFeature.initialiseTabGuard(params);
    }
    forceFocusOutOfContainer(up = false) {
        this.tabGuardFeature.forceFocusOutOfContainer(up);
    }
    appendChild(newChild, container) {
        this.tabGuardFeature.appendChild(super.appendChild.bind(this), newChild, container);
    }
};
// packages/ag-grid-community/src/widgets/touchListener.ts
var $437b23f6a393c3bf$var$DOUBLE_TAP_MILLISECONDS = 500;
var $437b23f6a393c3bf$var$LONG_PRESS_MILLISECONDS = 550;
var $437b23f6a393c3bf$var$handledTouchEvents;
var $437b23f6a393c3bf$var$addHandledTouchEvent = (event)=>{
    if (!$437b23f6a393c3bf$var$handledTouchEvents) $437b23f6a393c3bf$var$handledTouchEvents = /* @__PURE__ */ new WeakSet();
    else if ($437b23f6a393c3bf$var$handledTouchEvents.has(event)) return false;
    $437b23f6a393c3bf$var$handledTouchEvents.add(event);
    return true;
};
var $437b23f6a393c3bf$export$7b2e93987414b382 = class {
    constructor(eElement, preventClick = false){
        this.eElement = eElement;
        this.preventClick = preventClick;
        this.startListener = null;
        this.handlers = [];
        this.eventSvc = void 0;
        this.touchStart = null;
        this.lastTapTime = null;
        this.longPressTimer = 0;
        this.moved = false;
    }
    addEventListener(eventType, listener) {
        let eventSvc = this.eventSvc;
        if (!eventSvc) {
            if (eventSvc === null) return;
            this.eventSvc = eventSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
            const startListener = this.onTouchStart.bind(this);
            this.startListener = startListener;
            this.eElement.addEventListener("touchstart", startListener, {
                passive: true
            });
        }
        eventSvc.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.eventSvc?.removeEventListener(eventType, listener);
    }
    onTouchStart(touchEvent) {
        if (this.touchStart || !$437b23f6a393c3bf$var$addHandledTouchEvent(touchEvent)) return;
        const touchStart = touchEvent.touches[0];
        this.touchStart = touchStart;
        const handlers = this.handlers;
        if (!handlers.length) {
            const eElement = this.eElement;
            const doc = eElement.ownerDocument;
            const touchMove = this.onTouchMove.bind(this);
            const touchEnd = this.onTouchEnd.bind(this);
            const touchCancel = this.onTouchCancel.bind(this);
            const passiveTrue = {
                passive: true
            };
            const passiveFalse = {
                passive: false
            };
            $437b23f6a393c3bf$var$addTempEventHandlers(handlers, [
                eElement,
                "touchmove",
                touchMove,
                passiveTrue
            ], [
                doc,
                "touchcancel",
                touchCancel,
                passiveTrue
            ], // we set passive=false, as we want to prevent default on this event
            [
                doc,
                "touchend",
                touchEnd,
                passiveFalse
            ], [
                doc,
                "contextmenu",
                $437b23f6a393c3bf$var$preventEventDefault,
                passiveFalse
            ]);
        }
        this.clearLongPress();
        this.longPressTimer = window.setTimeout(()=>{
            this.longPressTimer = 0;
            if (this.touchStart === touchStart && !this.moved) {
                this.moved = true;
                this.eventSvc?.dispatchEvent({
                    type: "longTap",
                    touchStart: touchStart,
                    touchEvent: touchEvent
                });
            }
        }, $437b23f6a393c3bf$var$LONG_PRESS_MILLISECONDS);
    }
    onTouchMove(touchEvent) {
        const { moved: moved, touchStart: touchStart } = this;
        if (!moved && touchStart) {
            const touch = $437b23f6a393c3bf$var$_getFirstActiveTouch(touchStart, touchEvent.touches);
            const eventIsFarAway = touch && !$437b23f6a393c3bf$var$_areEventsNear(touch, touchStart, 4);
            if (eventIsFarAway) {
                this.clearLongPress();
                this.moved = true;
            }
        }
    }
    onTouchEnd(touchEvent) {
        const touchStart = this.touchStart;
        if (!touchStart || !$437b23f6a393c3bf$var$_getFirstActiveTouch(touchStart, touchEvent.changedTouches)) return;
        if (!this.moved) {
            this.eventSvc?.dispatchEvent({
                type: "tap",
                touchStart: touchStart
            });
            this.checkDoubleTap(touchStart);
        }
        if (this.preventClick) $437b23f6a393c3bf$var$preventEventDefault(touchEvent);
        this.cancel();
    }
    onTouchCancel(touchEvent) {
        const touchStart = this.touchStart;
        if (!touchStart || !$437b23f6a393c3bf$var$_getFirstActiveTouch(touchStart, touchEvent.changedTouches)) return;
        this.lastTapTime = null;
        this.cancel();
    }
    checkDoubleTap(touchStart) {
        let now = Date.now();
        const lastTapTime = this.lastTapTime;
        if (lastTapTime) {
            const interval = now - lastTapTime;
            if (interval > $437b23f6a393c3bf$var$DOUBLE_TAP_MILLISECONDS) {
                this.eventSvc?.dispatchEvent({
                    type: "doubleTap",
                    touchStart: touchStart
                });
                now = null;
            }
        }
        this.lastTapTime = now;
    }
    cancel() {
        this.clearLongPress();
        $437b23f6a393c3bf$var$clearTempEventHandlers(this.handlers);
        this.touchStart = null;
    }
    clearLongPress() {
        window.clearTimeout(this.longPressTimer);
        this.longPressTimer = 0;
        this.moved = false;
    }
    destroy() {
        const startListener = this.startListener;
        if (startListener) {
            this.startListener = null;
            this.eElement.removeEventListener("touchstart", startListener);
        }
        this.cancel();
        this.eElement = null;
        this.eventSvc = null;
    }
};
// packages/ag-grid-community/src/interfaces/IRangeService.ts
var $437b23f6a393c3bf$export$162bc75b85f28397 = /* @__PURE__ */ ((CellRangeType2)=>{
    CellRangeType2[CellRangeType2["VALUE"] = 0] = "VALUE";
    CellRangeType2[CellRangeType2["DIMENSION"] = 1] = "DIMENSION";
    return CellRangeType2;
})($437b23f6a393c3bf$export$162bc75b85f28397 || {});
// packages/ag-grid-community/src/autoScrollService.ts
var $437b23f6a393c3bf$export$c66bdc3d55a4f95 = class {
    constructor(params){
        this.tickingInterval = null;
        this.onScrollCallback = null;
        this.scrollContainer = params.scrollContainer;
        this.scrollHorizontally = params.scrollAxis.includes("x");
        this.scrollVertically = params.scrollAxis.includes("y");
        this.scrollByTick = params.scrollByTick != null ? params.scrollByTick : 20;
        if (params.onScrollCallback) this.onScrollCallback = params.onScrollCallback;
        if (this.scrollVertically) {
            this.getVerticalPosition = params.getVerticalPosition;
            this.setVerticalPosition = params.setVerticalPosition;
        }
        if (this.scrollHorizontally) {
            this.getHorizontalPosition = params.getHorizontalPosition;
            this.setHorizontalPosition = params.setHorizontalPosition;
        }
        this.shouldSkipVerticalScroll = params.shouldSkipVerticalScroll || (()=>false);
        this.shouldSkipHorizontalScroll = params.shouldSkipHorizontalScroll || (()=>false);
    }
    /** True while auto-scrolling */ get scrolling() {
        return this.tickingInterval !== null;
    }
    check(mouseEvent, forceSkipVerticalScroll = false) {
        const skipVerticalScroll = forceSkipVerticalScroll || this.shouldSkipVerticalScroll();
        if (skipVerticalScroll && this.shouldSkipHorizontalScroll()) return;
        const rect = this.scrollContainer.getBoundingClientRect();
        const scrollTick = this.scrollByTick;
        this.tickLeft = mouseEvent.clientX < rect.left + scrollTick;
        this.tickRight = mouseEvent.clientX > rect.right - scrollTick;
        this.tickUp = mouseEvent.clientY < rect.top + scrollTick && !skipVerticalScroll;
        this.tickDown = mouseEvent.clientY > rect.bottom - scrollTick && !skipVerticalScroll;
        if (this.tickLeft || this.tickRight || this.tickUp || this.tickDown) this.ensureTickingStarted();
        else this.ensureCleared();
    }
    ensureTickingStarted() {
        if (this.tickingInterval === null) {
            this.tickingInterval = window.setInterval(this.doTick.bind(this), 100);
            this.tickCount = 0;
        }
    }
    doTick() {
        this.tickCount++;
        const tickAmount = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
        if (this.scrollVertically) {
            const vScrollPosition = this.getVerticalPosition();
            if (this.tickUp) this.setVerticalPosition(vScrollPosition - tickAmount);
            if (this.tickDown) this.setVerticalPosition(vScrollPosition + tickAmount);
        }
        if (this.scrollHorizontally) {
            const hScrollPosition = this.getHorizontalPosition();
            if (this.tickLeft) this.setHorizontalPosition(hScrollPosition - tickAmount);
            if (this.tickRight) this.setHorizontalPosition(hScrollPosition + tickAmount);
        }
        if (this.onScrollCallback) this.onScrollCallback();
    }
    ensureCleared() {
        if (this.tickingInterval) {
            window.clearInterval(this.tickingInterval);
            this.tickingInterval = null;
        }
    }
};
// packages/ag-grid-community/src/vanillaFrameworkOverrides.ts
var $437b23f6a393c3bf$export$8174ad74937c6482 = class {
    constructor(frameworkName = "javascript"){
        this.frameworkName = frameworkName;
        this.renderingEngine = "vanilla";
        this.batchFrameworkComps = false;
        this.wrapIncoming = (callback)=>callback();
        this.wrapOutgoing = (callback)=>callback();
        this.baseDocLink = `${$437b23f6a393c3bf$var$BASE_URL}/${this.frameworkName}-data-grid`;
        $437b23f6a393c3bf$var$setValidationDocLink(this.baseDocLink);
    }
    frameworkComponent(_) {
        return null;
    }
    isFrameworkComponent(_) {
        return false;
    }
    getDocLink(path) {
        return this.baseDocLink + (path ? "/" + path : "");
    }
};
// packages/ag-grid-community/src/api/apiUtils.ts
function $437b23f6a393c3bf$var$createGridApi(context) {
    return {
        beanName: "gridApi",
        bean: context.getBean("apiFunctionSvc").api
    };
}
// packages/ag-grid-community/src/context/gridBeanComparator.ts
var $437b23f6a393c3bf$var$orderedCoreBeans = [
    // Validate license first
    "licenseManager",
    // core beans only
    "environment",
    "eventSvc",
    "gos",
    "paginationAutoPageSizeSvc",
    "apiFunctionSvc",
    "gridApi",
    "registry",
    "agCompUtils",
    "userCompFactory",
    "rowContainerHeight",
    "horizontalResizeSvc",
    "localeSvc",
    "pinnedRowModel",
    "dragSvc",
    "colGroupSvc",
    "visibleCols",
    "popupSvc",
    "selectionSvc",
    "colFilter",
    "quickFilter",
    "filterManager",
    "colModel",
    "headerNavigation",
    "pageBounds",
    "pagination",
    "pageBoundsListener",
    "rowSpanSvc",
    "stickyRowSvc",
    "rowRenderer",
    "expressionSvc",
    "alignedGridsSvc",
    "navigation",
    "valueCache",
    "valueSvc",
    "autoWidthCalc",
    "filterMenuFactory",
    "dragAndDrop",
    "focusSvc",
    "cellNavigation",
    "cellStyles",
    "scrollVisibleSvc",
    "sortSvc",
    "colHover",
    "colAnimation",
    "autoColSvc",
    "selectionColSvc",
    "changeDetectionSvc",
    "animationFrameSvc",
    "undoRedo",
    "colDefFactory",
    "rowStyleSvc",
    "rowNodeBlockLoader",
    "rowNodeSorter",
    "ctrlsSvc",
    "pinnedCols",
    "dataTypeSvc",
    "syncSvc",
    "overlays",
    "stateSvc",
    "expansionSvc",
    "apiEventSvc",
    "ariaAnnounce",
    "menuSvc",
    "colMoves",
    "colAutosize",
    "colFlex",
    "colResize",
    "pivotColsSvc",
    "valueColsSvc",
    "rowGroupColsSvc",
    "colNames",
    "colViewport",
    "pivotResultCols",
    "showRowGroupCols",
    "validation"
];
var $437b23f6a393c3bf$var$beanNamePosition = Object.fromEntries($437b23f6a393c3bf$var$orderedCoreBeans.map((beanName, index)=>[
        beanName,
        index
    ]));
function $437b23f6a393c3bf$var$gridBeanInitComparator(bean1, bean2) {
    const index1 = (bean1.beanName ? $437b23f6a393c3bf$var$beanNamePosition[bean1.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
    const index2 = (bean2.beanName ? $437b23f6a393c3bf$var$beanNamePosition[bean2.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
    return index1 - index2;
}
function $437b23f6a393c3bf$var$gridBeanDestroyComparator(bean1, bean2) {
    if (bean1?.beanName === "gridDestroySvc") return -1;
    if (bean2?.beanName === "gridDestroySvc") return 1;
    return 0;
}
// packages/ag-grid-community/src/headerRendering/rowContainer/headerRowContainerComp.ts
var $437b23f6a393c3bf$var$PinnedLeftElement = {
    tag: "div",
    cls: "ag-pinned-left-header",
    role: "rowgroup"
};
var $437b23f6a393c3bf$var$PinnedRightElement = {
    tag: "div",
    cls: "ag-pinned-right-header",
    role: "rowgroup"
};
var $437b23f6a393c3bf$var$CenterElement = {
    tag: "div",
    cls: "ag-header-viewport",
    role: "rowgroup",
    attrs: {
        tabindex: "-1"
    },
    children: [
        {
            tag: "div",
            ref: "eCenterContainer",
            cls: "ag-header-container",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderRowContainerComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(pinned){
        super();
        this.eCenterContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.headerRowComps = {};
        this.rowCompsList = [];
        this.pinned = pinned;
    }
    postConstruct() {
        this.selectAndSetTemplate();
        const compProxy = {
            setDisplayed: (displayed)=>this.setDisplayed(displayed),
            setCtrls: (ctrls)=>this.setCtrls(ctrls),
            // only gets called for center section
            setCenterWidth: (width)=>this.eCenterContainer.style.width = width,
            setViewportScrollLeft: (left)=>this.getGui().scrollLeft = left,
            // only gets called for pinned sections
            setPinnedContainerWidth: (width)=>{
                const eGui = this.getGui();
                eGui.style.width = width;
                eGui.style.maxWidth = width;
                eGui.style.minWidth = width;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$1e864ee88f54e7b(this.pinned));
        ctrl.setComp(compProxy, this.getGui());
    }
    selectAndSetTemplate() {
        const pinnedLeft = this.pinned == "left";
        const pinnedRight = this.pinned == "right";
        const template = pinnedLeft ? $437b23f6a393c3bf$var$PinnedLeftElement : pinnedRight ? $437b23f6a393c3bf$var$PinnedRightElement : $437b23f6a393c3bf$var$CenterElement;
        this.setTemplate(template);
        this.eRowContainer = this.eCenterContainer !== $437b23f6a393c3bf$export$6c811454646ed8be ? this.eCenterContainer : this.getGui();
    }
    destroy() {
        this.setCtrls([]);
        super.destroy();
    }
    destroyRowComp(rowComp) {
        this.destroyBean(rowComp);
        rowComp.getGui().remove();
    }
    setCtrls(ctrls) {
        const oldRowComps = this.headerRowComps;
        this.headerRowComps = {};
        this.rowCompsList = [];
        let prevGui;
        const appendEnsuringDomOrder = (rowComp)=>{
            const eGui = rowComp.getGui();
            const notAlreadyIn = eGui.parentElement != this.eRowContainer;
            if (notAlreadyIn) this.eRowContainer.appendChild(eGui);
            if (prevGui) $437b23f6a393c3bf$var$_ensureDomOrder(this.eRowContainer, eGui, prevGui);
            prevGui = eGui;
        };
        for (const ctrl of ctrls){
            const ctrlId = ctrl.instanceId;
            const existingComp = oldRowComps[ctrlId];
            delete oldRowComps[ctrlId];
            const rowComp = existingComp ? existingComp : this.createBean(new $437b23f6a393c3bf$var$HeaderRowComp(ctrl));
            this.headerRowComps[ctrlId] = rowComp;
            this.rowCompsList.push(rowComp);
            appendEnsuringDomOrder(rowComp);
        }
        for (const c of Object.values(oldRowComps))this.destroyRowComp(c);
    }
};
// packages/ag-grid-community/src/headerRendering/gridHeaderComp.ts
var $437b23f6a393c3bf$var$GridHeaderElement = {
    tag: "div",
    cls: "ag-header",
    role: "presentation"
};
var $437b23f6a393c3bf$var$GridHeaderComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$GridHeaderElement);
    }
    postConstruct() {
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setHeightAndMinHeight: (height)=>{
                this.getGui().style.height = height;
                this.getGui().style.minHeight = height;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$20b300eb69ca4d09());
        ctrl.setComp(compProxy, this.getGui(), this.getFocusableElement());
        const addContainer = (container)=>{
            this.createManagedBean(container);
            this.appendChild(container);
        };
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp("left"));
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp(null));
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp("right"));
    }
};
var $437b23f6a393c3bf$var$GridHeaderSelector = {
    selector: "AG-HEADER-ROOT",
    component: $437b23f6a393c3bf$var$GridHeaderComp
};
// packages/ag-grid-community/src/rendering/cell/cellComp.ts
var $437b23f6a393c3bf$var$CellComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(beans, cellCtrl, printLayout, eRow, editingCell){
        super();
        this.cellCtrl = cellCtrl;
        // every time we go into edit mode, or back again, this gets incremented.
        // it's the components way of dealing with the async nature of framework components,
        // so if a framework component takes a while to be created, we know if the object
        // is still relevant when creating is finished. eg we could click edit / un-edit 20
        // times before the first React edit component comes back - we should discard
        // the first 19.
        this.rendererVersion = 0;
        this.editorVersion = 0;
        this.beans = beans;
        this.gos = beans.gos;
        this.column = cellCtrl.column;
        this.rowNode = cellCtrl.rowNode;
        this.eRow = eRow;
        const cellDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            role: cellCtrl.getCellAriaRole(),
            attrs: {
                "comp-id": `${this.getCompId()}`,
                "col-id": cellCtrl.column.colIdSanitised
            }
        });
        this.eCell = cellDiv;
        let wrapperDiv;
        if (cellCtrl.isCellSpanning()) {
            wrapperDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-spanned-cell-wrapper",
                role: "presentation"
            });
            wrapperDiv.appendChild(cellDiv);
            this.setTemplateFromElement(wrapperDiv);
        } else this.setTemplateFromElement(cellDiv);
        this.cellCssManager = new $437b23f6a393c3bf$export$a7053cb7eb605bd2(()=>cellDiv);
        this.forceWrapper = cellCtrl.isForceWrapper();
        this.refreshWrapper(false);
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.cellCssManager.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(cellDiv, styles),
            getFocusableElement: ()=>cellDiv,
            setIncludeSelection: (include)=>this.includeSelection = include,
            setIncludeRowDrag: (include)=>this.includeRowDrag = include,
            setIncludeDndSource: (include)=>this.includeDndSource = include,
            setRenderDetails: (compDetails, valueToDisplay, force)=>this.setRenderDetails(compDetails, valueToDisplay, force),
            setEditDetails: (compDetails, popup, position)=>this.setEditDetails(compDetails, popup, position),
            getCellEditor: ()=>this.cellEditor || null,
            getCellRenderer: ()=>this.cellRenderer || null,
            getParentOfValue: ()=>this.getParentOfValue(),
            refreshEditStyles: (editing, isPopup)=>this.refreshEditStyles(editing, isPopup)
        };
        cellCtrl.setComp(compProxy, cellDiv, wrapperDiv, this.eCellWrapper, printLayout, editingCell, void 0);
    }
    getParentOfValue() {
        return this.eCellValue ?? this.eCellWrapper ?? this.eCell;
    }
    setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance) {
        const isInlineEditing = this.cellEditor && !this.cellEditorPopupWrapper;
        if (isInlineEditing) return;
        this.firstRender = this.firstRender == null;
        const controlWrapperChanged = this.refreshWrapper(false);
        this.refreshEditStyles(false);
        if (compDetails) {
            const neverRefresh = forceNewCellRendererInstance || controlWrapperChanged;
            const cellRendererRefreshSuccessful = neverRefresh ? false : this.refreshCellRenderer(compDetails);
            if (!cellRendererRefreshSuccessful) {
                this.destroyRenderer();
                this.createCellRendererInstance(compDetails);
            }
        } else {
            this.destroyRenderer();
            this.insertValueWithoutCellRenderer(valueToDisplay);
        }
        this.rowDraggingComp?.refreshVisibility();
    }
    setEditDetails(compDetails, popup, position) {
        if (compDetails) this.createCellEditorInstance(compDetails, popup, position);
        else this.destroyEditor();
    }
    removeControls() {
        const context = this.beans.context;
        this.checkboxSelectionComp = context.destroyBean(this.checkboxSelectionComp);
        this.dndSourceComp = context.destroyBean(this.dndSourceComp);
        this.rowDraggingComp = context.destroyBean(this.rowDraggingComp);
    }
    // returns true if wrapper was changed
    refreshWrapper(editing) {
        const providingControls = this.includeRowDrag || this.includeDndSource || this.includeSelection;
        const usingWrapper = providingControls || this.forceWrapper;
        const putWrapperIn = usingWrapper && this.eCellWrapper == null;
        if (putWrapperIn) {
            this.eCellWrapper = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-cell-wrapper",
                role: "presentation"
            });
            this.eCell.appendChild(this.eCellWrapper);
        }
        const takeWrapperOut = !usingWrapper && this.eCellWrapper != null;
        if (takeWrapperOut) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eCellWrapper);
            this.eCellWrapper = void 0;
        }
        this.cellCssManager.toggleCss("ag-cell-value", !usingWrapper);
        const usingCellValue = !editing && usingWrapper;
        const putCellValueIn = usingCellValue && this.eCellValue == null;
        if (putCellValueIn) {
            const cls = this.cellCtrl.getCellValueClass();
            this.eCellValue = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "span",
                cls: cls,
                role: "presentation"
            });
            this.eCellWrapper.appendChild(this.eCellValue);
        }
        const takeCellValueOut = !usingCellValue && this.eCellValue != null;
        if (takeCellValueOut) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eCellValue);
            this.eCellValue = void 0;
        }
        const templateChanged = putWrapperIn || takeWrapperOut || putCellValueIn || takeCellValueOut;
        if (templateChanged) this.removeControls();
        if (!editing && providingControls) this.addControls();
        return templateChanged;
    }
    addControls() {
        const { cellCtrl: cellCtrl, eCellWrapper: eCellWrapper, eCellValue: eCellValue, includeRowDrag: includeRowDrag, includeDndSource: includeDndSource, includeSelection: includeSelection } = this;
        const insertBefore = (comp)=>{
            if (comp) eCellWrapper.insertBefore(comp.getGui(), eCellValue);
        };
        if (includeRowDrag && this.rowDraggingComp == null) {
            this.rowDraggingComp = cellCtrl.createRowDragComp();
            insertBefore(this.rowDraggingComp);
        }
        if (includeDndSource && this.dndSourceComp == null) {
            this.dndSourceComp = cellCtrl.createDndSource();
            insertBefore(this.dndSourceComp);
        }
        if (includeSelection && this.checkboxSelectionComp == null) {
            this.checkboxSelectionComp = cellCtrl.createSelectionCheckbox();
            insertBefore(this.checkboxSelectionComp);
        }
    }
    createCellEditorInstance(compDetails, popup, position) {
        const versionCopy = this.editorVersion;
        const cellEditorPromise = compDetails.newAgStackInstance();
        const { params: params } = compDetails;
        cellEditorPromise.then((c)=>this.afterCellEditorCreated(versionCopy, c, params, popup, position));
        const cellEditorAsync = $437b23f6a393c3bf$export$672d9e47bc342bac(this.cellEditor);
        if (cellEditorAsync && params.cellStartedEdit) this.cellCtrl.focusCell(true);
    }
    insertValueWithoutCellRenderer(valueToDisplay) {
        const eParent = this.getParentOfValue();
        $437b23f6a393c3bf$export$69e6e10709eabd91(eParent);
        const escapedValue = $437b23f6a393c3bf$export$a16cfb6652fe466f(valueToDisplay);
        if (escapedValue != null) eParent.textContent = escapedValue;
    }
    destroyRenderer() {
        const { context: context } = this.beans;
        this.cellRenderer = context.destroyBean(this.cellRenderer);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.cellRendererGui);
        this.cellRendererGui = null;
        this.rendererVersion++;
    }
    destroyEditor() {
        const { context: context } = this.beans;
        const recoverFocus = this.cellEditorPopupWrapper?.getGui().contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans)) || this.cellCtrl.hasBrowserFocus();
        if (recoverFocus) this.eCell.focus({
            preventScroll: true
        });
        this.hideEditorPopup?.();
        this.hideEditorPopup = void 0;
        this.cellEditor = context.destroyBean(this.cellEditor);
        this.cellEditorPopupWrapper = context.destroyBean(this.cellEditorPopupWrapper);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.cellEditorGui);
        this.cellCtrl.disableEditorTooltipFeature();
        this.cellEditorGui = null;
        this.editorVersion++;
    }
    refreshCellRenderer(compClassAndParams) {
        if (this.cellRenderer?.refresh == null) return false;
        if (this.cellRendererClass !== compClassAndParams.componentClass) return false;
        const result = this.cellRenderer.refresh(compClassAndParams.params);
        return result === true || result === void 0;
    }
    createCellRendererInstance(compDetails) {
        const displayComponentVersionCopy = this.rendererVersion;
        const createCellRendererFunc = (details)=>(_)=>{
                const staleTask = this.rendererVersion !== displayComponentVersionCopy || !this.isAlive();
                if (staleTask) return;
                const componentPromise = details.newAgStackInstance();
                const callback = this.afterCellRendererCreated.bind(this, displayComponentVersionCopy, details.componentClass);
                componentPromise?.then(callback);
            };
        const { animationFrameSvc: animationFrameSvc } = this.beans;
        let createTask;
        if (animationFrameSvc?.active && this.firstRender) createTask = (details, isDeferred = false)=>{
            animationFrameSvc.createTask(createCellRendererFunc(details), this.rowNode.rowIndex, "p2", details.componentFromFramework, isDeferred);
        };
        else createTask = (details)=>createCellRendererFunc(details)();
        if (compDetails.params?.deferRender && !this.cellCtrl.rowNode.group) {
            const { loadingComp: loadingComp, onReady: onReady } = this.cellCtrl.getDeferLoadingCellRenderer();
            if (loadingComp) {
                createTask(loadingComp);
                onReady.then(()=>createTask(compDetails, true));
            }
        } else createTask(compDetails);
    }
    afterCellRendererCreated(cellRendererVersion, cellRendererClass, cellRenderer) {
        const staleTask = !this.isAlive() || cellRendererVersion !== this.rendererVersion;
        if (staleTask) {
            this.beans.context.destroyBean(cellRenderer);
            return;
        }
        this.cellRenderer = cellRenderer;
        this.cellRendererClass = cellRendererClass;
        const cellGui = cellRenderer.getGui();
        this.cellRendererGui = cellGui;
        if (cellGui != null) {
            const eParent = this.getParentOfValue();
            $437b23f6a393c3bf$export$69e6e10709eabd91(eParent);
            eParent.appendChild(cellGui);
        }
    }
    afterCellEditorCreated(requestVersion, cellEditor, params, popup, position) {
        const staleComp = requestVersion !== this.editorVersion;
        const { context: context } = this.beans;
        if (staleComp) {
            context.destroyBean(cellEditor);
            return;
        }
        const editingCancelledByUserComp = cellEditor.isCancelBeforeStart?.();
        if (editingCancelledByUserComp) {
            context.destroyBean(cellEditor);
            this.cellCtrl.stopEditing(true);
            return;
        }
        if (!cellEditor.getGui) {
            $437b23f6a393c3bf$export$545083624300f13d(97, {
                colId: this.column.getId()
            });
            context.destroyBean(cellEditor);
            return;
        }
        this.cellEditor = cellEditor;
        this.cellEditorGui = cellEditor.getGui();
        const cellEditorInPopup = popup || cellEditor.isPopup?.();
        if (cellEditorInPopup) this.addPopupCellEditor(params, position);
        else this.addInCellEditor();
        this.refreshEditStyles(true, cellEditorInPopup);
        cellEditor.afterGuiAttached?.();
        this.cellCtrl.enableEditorTooltipFeature(cellEditor);
        this.cellCtrl.cellEditorAttached();
    }
    refreshEditStyles(editing, isPopup) {
        const { cellCssManager: cellCssManager } = this;
        cellCssManager.toggleCss("ag-cell-inline-editing", editing && !isPopup);
        cellCssManager.toggleCss("ag-cell-popup-editing", editing && !!isPopup);
        cellCssManager.toggleCss("ag-cell-not-inline-editing", !editing || !!isPopup);
    }
    addInCellEditor() {
        const { eCell: eCell } = this;
        if (eCell.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) eCell.focus();
        this.destroyRenderer();
        this.refreshWrapper(true);
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.getParentOfValue());
        if (this.cellEditorGui) {
            const eParent = this.getParentOfValue();
            eParent.appendChild(this.cellEditorGui);
        }
    }
    addPopupCellEditor(params, position) {
        const { gos: gos, context: context, popupSvc: popupSvc, editSvc: editSvc } = this.beans;
        if (gos.get("editType") === "fullRow") $437b23f6a393c3bf$export$545083624300f13d(98);
        const cellEditorPopupWrapper = this.cellEditorPopupWrapper = context.createBean(editSvc.createPopupEditorWrapper(params));
        const { cellEditor: cellEditor, cellEditorGui: cellEditorGui, eCell: eCell, rowNode: rowNode, column: column, cellCtrl: cellCtrl } = this;
        const ePopupGui = cellEditorPopupWrapper.getGui();
        if (cellEditorGui) ePopupGui.appendChild(cellEditorGui);
        const useModelPopup = gos.get("stopEditingWhenCellsLoseFocus");
        const positionToUse = position != null ? position : cellEditor.getPopupPosition?.() ?? "over";
        const isRtl = gos.get("enableRtl");
        const positionParams = {
            ePopup: ePopupGui,
            column: column,
            rowNode: rowNode,
            type: "popupCellEditor",
            eventSource: eCell,
            position: positionToUse,
            alignSide: isRtl ? "right" : "left",
            keepWithinBounds: true
        };
        const positionCallback = popupSvc.positionPopupByComponent.bind(popupSvc, positionParams);
        const addPopupRes = popupSvc.addPopup({
            modal: useModelPopup,
            eChild: ePopupGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                cellCtrl.onPopupEditorClosed();
            },
            anchorToElement: eCell,
            positionCallback: positionCallback,
            ariaOwns: eCell
        });
        if (addPopupRes) this.hideEditorPopup = addPopupRes.hideFunc;
    }
    detach() {
        this.getGui().remove();
    }
    // if the row is also getting destroyed, then we don't need to remove from dom,
    // as the row will also get removed, so no need to take out the cells from the row
    // if the row is going (removing is an expensive operation, so only need to remove
    // the top part)
    //
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroy() {
        this.destroyRenderer();
        this.destroyEditor();
        this.removeControls();
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/row/rowComp.ts
var $437b23f6a393c3bf$var$RowComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(ctrl, beans, containerType){
        super();
        this.cellComps = /* @__PURE__ */ new Map();
        this.beans = beans;
        this.rowCtrl = ctrl;
        const rowDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            role: "row",
            attrs: {
                "comp-id": `${this.getCompId()}`
            }
        });
        this.setInitialStyle(rowDiv, containerType);
        this.setTemplateFromElement(rowDiv);
        const style = rowDiv.style;
        this.domOrder = this.rowCtrl.getDomOrder();
        const compProxy = {
            setDomOrder: (domOrder)=>this.domOrder = domOrder,
            setCellCtrls: (cellCtrls)=>this.setCellCtrls(cellCtrls),
            showFullWidth: (compDetails)=>this.showFullWidth(compDetails),
            getFullWidthCellRenderer: ()=>this.fullWidthCellRenderer,
            getFullWidthCellRendererParams: ()=>this.fullWidthCellRendererParams,
            toggleCss: (name, on)=>this.toggleCss(name, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(rowDiv, styles),
            setTop: (top)=>style.top = top,
            setTransform: (transform)=>style.transform = transform,
            setRowIndex: (rowIndex)=>rowDiv.setAttribute("row-index", rowIndex),
            setRowId: (rowId)=>rowDiv.setAttribute("row-id", rowId),
            setRowBusinessKey: (businessKey)=>rowDiv.setAttribute("row-business-key", businessKey),
            refreshFullWidth: (getUpdatedParams)=>{
                const params = getUpdatedParams();
                this.fullWidthCellRendererParams = params;
                return this.fullWidthCellRenderer?.refresh?.(params) ?? false;
            }
        };
        ctrl.setComp(compProxy, this.getGui(), containerType, void 0);
        this.addDestroyFunc(()=>{
            ctrl.unsetComp(containerType);
        });
    }
    setInitialStyle(container, containerType) {
        const transform = this.rowCtrl.getInitialTransform(containerType);
        if (transform) container.style.setProperty("transform", transform);
        else {
            const top = this.rowCtrl.getInitialRowTop(containerType);
            if (top) container.style.setProperty("top", top);
        }
    }
    showFullWidth(compDetails) {
        const callback = (cellRenderer)=>{
            if (this.isAlive()) {
                const eGui = cellRenderer.getGui();
                this.getGui().appendChild(eGui);
                this.rowCtrl.setupDetailRowAutoHeight(eGui);
                this.setFullWidthRowComp(cellRenderer, compDetails.params);
            } else this.beans.context.destroyBean(cellRenderer);
        };
        const res = compDetails.newAgStackInstance();
        res.then(callback);
    }
    setCellCtrls(cellCtrls) {
        const cellsToRemove = new Map(this.cellComps);
        for (const cellCtrl of cellCtrls){
            const key = cellCtrl.instanceId;
            if (!this.cellComps.has(key)) this.newCellComp(cellCtrl);
            else cellsToRemove.delete(key);
        }
        this.destroyCells(cellsToRemove);
        this.ensureDomOrder(cellCtrls);
    }
    ensureDomOrder(cellCtrls) {
        if (!this.domOrder) return;
        const elementsInOrder = [];
        for (const cellCtrl of cellCtrls){
            const cellComp = this.cellComps.get(cellCtrl.instanceId);
            if (cellComp) elementsInOrder.push(cellComp.getGui());
        }
        $437b23f6a393c3bf$var$_setDomChildOrder(this.getGui(), elementsInOrder);
    }
    newCellComp(cellCtrl) {
        const editing = this.beans.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        }) ?? false;
        const cellComp = new $437b23f6a393c3bf$var$CellComp(this.beans, cellCtrl, this.rowCtrl.printLayout, this.getGui(), editing);
        this.cellComps.set(cellCtrl.instanceId, cellComp);
        this.getGui().appendChild(cellComp.getGui());
    }
    destroy() {
        super.destroy();
        this.destroyCells(this.cellComps);
    }
    setFullWidthRowComp(fullWidthRowComponent, params) {
        this.fullWidthCellRenderer = fullWidthRowComponent;
        this.fullWidthCellRendererParams = params;
        this.addDestroyFunc(()=>{
            this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer);
            this.fullWidthCellRendererParams = void 0;
        });
    }
    destroyCells(cellComps) {
        for (const cellComp of cellComps.values()){
            if (!cellComp) return;
            const instanceId = cellComp.cellCtrl.instanceId;
            if (this.cellComps.get(instanceId) !== cellComp) return;
            cellComp.detach();
            cellComp.destroy();
            this.cellComps.delete(instanceId);
        }
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerComp.ts
function $437b23f6a393c3bf$var$getElementParams(name, options, beans) {
    const isCellSpanning = !!beans.gos.get("enableCellSpan") && !!options.getSpannedRowCtrls;
    const eContainerElement = {
        tag: "div",
        ref: "eContainer",
        cls: $437b23f6a393c3bf$export$35e1b2dddf7fc6e9(name),
        role: "rowgroup"
    };
    if (options.type === "center" || isCellSpanning) {
        const eSpannedContainerElement = {
            tag: "div",
            ref: "eSpannedContainer",
            cls: `ag-spanning-container ${$437b23f6a393c3bf$export$cd6b90bdf6c4fcfd(name)}`,
            role: "presentation"
        };
        eContainerElement.role = "presentation";
        return {
            tag: "div",
            ref: "eViewport",
            cls: `ag-viewport ${$437b23f6a393c3bf$export$65619730ec980d6a(name)}`,
            role: "rowgroup",
            children: [
                eContainerElement,
                isCellSpanning ? eSpannedContainerElement : null
            ]
        };
    }
    return eContainerElement;
}
var $437b23f6a393c3bf$var$RowContainerComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(params){
        super();
        this.eViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSpannedContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.rowCompsNoSpan = {};
        this.rowCompsWithSpan = {};
        this.name = params?.name;
        this.options = $437b23f6a393c3bf$export$a46aad9f8c79261f(this.name);
    }
    postConstruct() {
        this.setTemplate($437b23f6a393c3bf$var$getElementParams(this.name, this.options, this.beans));
        const compProxy = {
            setHorizontalScroll: (offset)=>this.eViewport.scrollLeft = offset,
            setViewportHeight: (height)=>this.eViewport.style.height = height,
            setRowCtrls: ({ rowCtrls: rowCtrls })=>this.setRowCtrls(rowCtrls),
            setSpannedRowCtrls: (rowCtrls)=>this.setRowCtrls(rowCtrls, true),
            setDomOrder: (domOrder)=>{
                this.domOrder = domOrder;
            },
            setContainerWidth: (width)=>{
                this.eContainer.style.width = width;
                if (this.eSpannedContainer) this.eSpannedContainer.style.width = width;
            },
            setOffsetTop: (offset)=>{
                const top = `translateY(${offset})`;
                this.eContainer.style.transform = top;
                if (this.eSpannedContainer) this.eSpannedContainer.style.transform = top;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$2d4385f6f566fe5e(this.name));
        ctrl.setComp(compProxy, this.eContainer, this.eSpannedContainer, this.eViewport);
    }
    destroy() {
        this.setRowCtrls([]);
        this.setRowCtrls([], true);
        super.destroy();
        this.lastPlacedElement = null;
    }
    setRowCtrls(rowCtrls, spanContainer) {
        const { beans: beans, options: options } = this;
        const container = spanContainer ? this.eSpannedContainer : this.eContainer;
        const oldRows = spanContainer ? {
            ...this.rowCompsWithSpan
        } : {
            ...this.rowCompsNoSpan
        };
        const newComps = {};
        if (spanContainer) this.rowCompsWithSpan = newComps;
        else this.rowCompsNoSpan = newComps;
        this.lastPlacedElement = null;
        const orderedRows = [];
        for (const rowCtrl of rowCtrls){
            const instanceId = rowCtrl.instanceId;
            const existingRowComp = oldRows[instanceId];
            let rowComp;
            if (existingRowComp) {
                rowComp = existingRowComp;
                delete oldRows[instanceId];
            } else {
                if (!rowCtrl.rowNode.displayed) continue;
                rowComp = new $437b23f6a393c3bf$var$RowComp(rowCtrl, beans, options.type);
            }
            newComps[instanceId] = rowComp;
            orderedRows.push([
                rowComp,
                !existingRowComp
            ]);
        }
        this.removeOldRows(Object.values(oldRows));
        this.addRowNodes(orderedRows, container);
    }
    addRowNodes(rows, container) {
        const { domOrder: domOrder } = this;
        for (const [rowComp, isNew] of rows){
            const eGui = rowComp.getGui();
            if (!domOrder) {
                if (isNew) container.appendChild(eGui);
            } else this.ensureDomOrder(eGui, container);
        }
    }
    removeOldRows(rowComps) {
        for (const oldRowComp of rowComps){
            oldRowComp.getGui().remove();
            oldRowComp.destroy();
        }
    }
    ensureDomOrder(eRow, container) {
        $437b23f6a393c3bf$var$_ensureDomOrder(container, eRow, this.lastPlacedElement);
        this.lastPlacedElement = eRow;
    }
};
var $437b23f6a393c3bf$var$RowContainerSelector = {
    selector: "AG-ROW-CONTAINER",
    component: $437b23f6a393c3bf$var$RowContainerComp
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyComp.ts
function $437b23f6a393c3bf$var$makeRowContainers(paramsMap, names) {
    return names.map((name)=>{
        const refName = `e${name[0].toUpperCase() + name.substring(1)}RowContainer`;
        paramsMap[refName] = {
            name: name
        };
        return {
            tag: "ag-row-container",
            ref: refName,
            attrs: {
                name: name
            }
        };
    });
}
function $437b23f6a393c3bf$var$getGridBodyTemplate(includeOverlay) {
    const paramsMap = {};
    const elementParams = {
        tag: "div",
        ref: "eGridRoot",
        cls: "ag-root ag-unselectable",
        children: [
            {
                tag: "ag-header-root"
            },
            {
                tag: "div",
                ref: "eTop",
                cls: "ag-floating-top",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "topLeft",
                    "topCenter",
                    "topRight",
                    "topFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eBody",
                cls: "ag-body",
                role: "presentation",
                children: [
                    {
                        tag: "div",
                        ref: "eBodyViewport",
                        cls: "ag-body-viewport",
                        role: "presentation",
                        children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                            "left",
                            "center",
                            "right",
                            "fullWidth"
                        ])
                    },
                    {
                        tag: "ag-fake-vertical-scroll"
                    }
                ]
            },
            {
                tag: "div",
                ref: "eStickyTop",
                cls: "ag-sticky-top",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "stickyTopLeft",
                    "stickyTopCenter",
                    "stickyTopRight",
                    "stickyTopFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eStickyBottom",
                cls: "ag-sticky-bottom",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "stickyBottomLeft",
                    "stickyBottomCenter",
                    "stickyBottomRight",
                    "stickyBottomFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eBottom",
                cls: "ag-floating-bottom",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "bottomLeft",
                    "bottomCenter",
                    "bottomRight",
                    "bottomFullWidth"
                ])
            },
            {
                tag: "ag-fake-horizontal-scroll"
            },
            includeOverlay ? {
                tag: "ag-overlay-wrapper"
            } : null
        ]
    };
    return {
        paramsMap: paramsMap,
        elementParams: elementParams
    };
}
var $437b23f6a393c3bf$var$GridBodyComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        this.eGridRoot = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBodyViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eStickyTop = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eStickyBottom = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eTop = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBottom = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBody = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const { overlays: overlays, rangeSvc: rangeSvc } = this.beans;
        const overlaySelector = overlays?.getOverlayWrapperSelector();
        const { paramsMap: paramsMap, elementParams: elementParams } = $437b23f6a393c3bf$var$getGridBodyTemplate(!!overlaySelector);
        this.setTemplate(elementParams, [
            ...overlaySelector ? [
                overlaySelector
            ] : [],
            $437b23f6a393c3bf$var$FakeHScrollSelector,
            $437b23f6a393c3bf$var$FakeVScrollSelector,
            $437b23f6a393c3bf$var$GridHeaderSelector,
            $437b23f6a393c3bf$var$RowContainerSelector
        ], paramsMap);
        const setHeight = (height, element)=>{
            const heightString = `${height}px`;
            element.style.minHeight = heightString;
            element.style.height = heightString;
        };
        const compProxy = {
            setRowAnimationCssOnBodyViewport: (cssClass, animate)=>this.setRowAnimationCssOnBodyViewport(cssClass, animate),
            setColumnCount: (count)=>$437b23f6a393c3bf$export$56744a26086b5898(this.getGui(), count),
            setRowCount: (count)=>$437b23f6a393c3bf$export$1ad8496b26b660f8(this.getGui(), count),
            setTopHeight: (height)=>setHeight(height, this.eTop),
            setBottomHeight: (height)=>setHeight(height, this.eBottom),
            setTopInvisible: (invisible)=>this.eTop.classList.toggle("ag-invisible", invisible),
            setBottomInvisible: (invisible)=>this.eBottom.classList.toggle("ag-invisible", invisible),
            setStickyTopHeight: (height)=>this.eStickyTop.style.height = height,
            setStickyTopTop: (top)=>this.eStickyTop.style.top = top,
            setStickyTopWidth: (width)=>this.eStickyTop.style.width = width,
            setStickyBottomHeight: (height)=>{
                this.eStickyBottom.style.height = height;
                this.eStickyBottom.classList.toggle("ag-invisible", height === "0px");
            },
            setStickyBottomBottom: (bottom)=>this.eStickyBottom.style.bottom = bottom,
            setStickyBottomWidth: (width)=>this.eStickyBottom.style.width = width,
            setColumnMovingCss: (cssClass, flag)=>this.toggleCss(cssClass, flag),
            updateLayoutClasses: (cssClass, params)=>{
                const classLists = [
                    this.eBodyViewport.classList,
                    this.eBody.classList
                ];
                for (const classList of classLists){
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.NORMAL, params.normal);
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.PRINT, params.print);
                }
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.NORMAL, params.normal);
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.PRINT, params.print);
            },
            setAlwaysVerticalScrollClass: (cssClass, on)=>this.eBodyViewport.classList.toggle($437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL, on),
            registerBodyViewportResizeListener: (listener)=>{
                const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eBodyViewport, listener);
                this.addDestroyFunc(()=>unsubscribeFromResize());
            },
            setPinnedTopBottomOverflowY: (overflow)=>this.eTop.style.overflowY = this.eBottom.style.overflowY = overflow,
            setCellSelectableCss: (cssClass, selectable)=>{
                for (const ct of [
                    this.eTop,
                    this.eBodyViewport,
                    this.eBottom
                ])ct.classList.toggle(cssClass, selectable);
            },
            setBodyViewportWidth: (width)=>this.eBodyViewport.style.width = width,
            setGridRootRole: (role)=>$437b23f6a393c3bf$export$f8d01fa01787902(this.eGridRoot, role)
        };
        this.ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$8bebc3145b40d221());
        this.ctrl.setComp(compProxy, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom, this.eStickyTop, this.eStickyBottom);
        if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos) || $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos)) $437b23f6a393c3bf$var$_setAriaMultiSelectable(this.getGui(), true);
    }
    setRowAnimationCssOnBodyViewport(cssClass, animateRows) {
        const bodyViewportClassList = this.eBodyViewport.classList;
        bodyViewportClassList.toggle("ag-row-animation", animateRows);
        bodyViewportClassList.toggle("ag-row-no-animation", !animateRows);
    }
};
var $437b23f6a393c3bf$var$GridBodySelector = {
    selector: "AG-GRID-BODY",
    component: $437b23f6a393c3bf$var$GridBodyComp
};
// packages/ag-grid-community/src/gridComp/gridCtrl.ts
var $437b23f6a393c3bf$export$f3c741dac0be9745 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.additionalFocusableContainers = /* @__PURE__ */ new Set();
    }
    setComp(view, eGridDiv, eGui) {
        this.view = view;
        this.eGridHostDiv = eGridDiv;
        this.eGui = eGui;
        this.eGui.setAttribute("grid-id", this.beans.context.getId());
        const { dragAndDrop: dragAndDrop, ctrlsSvc: ctrlsSvc } = this.beans;
        dragAndDrop?.registerGridDropTarget(()=>this.eGui, this);
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this.view));
        this.view.setRtlClass(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
        const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eGridHostDiv, this.onGridSizeChanged.bind(this));
        this.addDestroyFunc(()=>unsubscribeFromResize());
        ctrlsSvc.register("gridCtrl", this);
    }
    isDetailGrid() {
        const el = $437b23f6a393c3bf$export$c4c49c776025d475(this.getGui());
        return el?.getAttribute("row-id")?.startsWith("detail") || false;
    }
    getOptionalSelectors() {
        const beans = this.beans;
        return {
            paginationSelector: beans.pagination?.getPaginationSelector(),
            gridHeaderDropZonesSelector: beans.registry?.getSelector("AG-GRID-HEADER-DROP-ZONES"),
            sideBarSelector: beans.sideBar?.getSelector(),
            statusBarSelector: beans.registry?.getSelector("AG-STATUS-BAR"),
            watermarkSelector: beans.licenseManager?.getWatermarkSelector()
        };
    }
    onGridSizeChanged() {
        this.eventSvc.dispatchEvent({
            type: "gridSizeChanged",
            clientWidth: this.eGridHostDiv.clientWidth,
            clientHeight: this.eGridHostDiv.clientHeight
        });
    }
    destroyGridUi() {
        this.view.destroyGridUi();
    }
    getGui() {
        return this.eGui;
    }
    setResizeCursor(direction) {
        const { view: view } = this;
        if (direction === false) view.setCursor(null);
        else {
            const cursor = direction === 1 /* Horizontal */  ? "ew-resize" : "ns-resize";
            view.setCursor(cursor);
        }
    }
    disableUserSelect(on) {
        this.view.setUserSelect(on ? "none" : null);
    }
    focusNextInnerContainer(backwards) {
        const focusableContainers = this.getFocusableContainers();
        const { indexWithFocus: indexWithFocus, nextIndex: nextIndex } = this.getNextFocusableIndex(focusableContainers, backwards);
        if (nextIndex < 0 || nextIndex >= focusableContainers.length) return false;
        if (nextIndex === 0) {
            if (indexWithFocus > 0) {
                const { visibleCols: visibleCols, focusSvc: focusSvc } = this.beans;
                const allColumns = visibleCols.allCols;
                const lastColumn = $437b23f6a393c3bf$export$236389741107357f(allColumns);
                if (focusSvc.focusGridView({
                    column: lastColumn,
                    backwards: true
                })) return true;
            }
            return false;
        }
        return this.focusContainer(focusableContainers[nextIndex], backwards);
    }
    focusInnerElement(fromBottom) {
        const userCallbackFunction = this.gos.getCallback("focusGridInnerElement");
        if (userCallbackFunction?.({
            fromBottom: !!fromBottom
        })) return true;
        const focusableContainers = this.getFocusableContainers();
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const allColumns = visibleCols.allCols;
        if (fromBottom) {
            if (focusableContainers.length > 1) return this.focusContainer($437b23f6a393c3bf$export$236389741107357f(focusableContainers), fromBottom);
            const lastColumn = $437b23f6a393c3bf$export$236389741107357f(allColumns);
            if (focusSvc.focusGridView({
                column: lastColumn,
                backwards: fromBottom
            })) return true;
        }
        if (this.gos.get("headerHeight") === 0 || $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) {
            if (focusSvc.focusGridView({
                column: allColumns[0],
                backwards: fromBottom
            })) return true;
            for(let i = 1; i < focusableContainers.length; i++){
                if ($437b23f6a393c3bf$export$8598088d375f416f(focusableContainers[i].getGui(), fromBottom)) return true;
            }
            return false;
        }
        return focusSvc.focusFirstHeader();
    }
    forceFocusOutOfContainer(up = false) {
        this.view.forceFocusOutOfContainer(up);
    }
    addFocusableContainer(container) {
        this.additionalFocusableContainers.add(container);
    }
    removeFocusableContainer(container) {
        this.additionalFocusableContainers.delete(container);
    }
    allowFocusForNextCoreContainer(up) {
        const coreContainers = this.view.getFocusableContainers();
        const { nextIndex: nextIndex, indexWithFocus: indexWithFocus } = this.getNextFocusableIndex(coreContainers, up);
        if (indexWithFocus === -1 || nextIndex < 0 || nextIndex >= coreContainers.length) return;
        const comp = coreContainers[nextIndex];
        comp.setAllowFocus?.(true);
        setTimeout(()=>{
            comp.setAllowFocus?.(false);
        });
    }
    isFocusable() {
        const beans = this.beans;
        return !$437b23f6a393c3bf$var$_isCellFocusSuppressed(beans) || !$437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans) || !!beans.sideBar?.comp?.isDisplayed();
    }
    getNextFocusableIndex(focusableContainers, backwards) {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        const indexWithFocus = focusableContainers.findIndex((container)=>container.getGui().contains(activeEl));
        const nextIndex = indexWithFocus + (backwards ? -1 : 1);
        return {
            indexWithFocus: indexWithFocus,
            nextIndex: nextIndex
        };
    }
    focusContainer(comp, up) {
        comp.setAllowFocus?.(true);
        const result = $437b23f6a393c3bf$export$8598088d375f416f(comp.getGui(), up, false, true);
        comp.setAllowFocus?.(false);
        return result;
    }
    getFocusableContainers() {
        return [
            ...this.view.getFocusableContainers(),
            ...this.additionalFocusableContainers
        ];
    }
    destroy() {
        this.additionalFocusableContainers.clear();
        super.destroy();
    }
};
// packages/ag-grid-community/src/gridComp/gridComp.ts
var $437b23f6a393c3bf$var$GridComp = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(eGridDiv){
        super();
        this.gridBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.sideBar = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.pagination = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.rootWrapperBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eGridDiv = eGridDiv;
    }
    postConstruct() {
        const compProxy = {
            destroyGridUi: ()=>this.destroyBean(this),
            setRtlClass: (cssClass)=>this.addCss(cssClass),
            forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
            updateLayoutClasses: this.updateLayoutClasses.bind(this),
            getFocusableContainers: this.getFocusableContainers.bind(this),
            setUserSelect: (value)=>{
                this.getGui().style.userSelect = value != null ? value : "";
                this.getGui().style.webkitUserSelect = value != null ? value : "";
            },
            setCursor: (value)=>{
                this.getGui().style.cursor = value != null ? value : "";
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$f3c741dac0be9745());
        const comps = ctrl.getOptionalSelectors();
        const template = this.createTemplate(comps);
        const requiredComps = [
            $437b23f6a393c3bf$var$GridBodySelector,
            ...Object.values(comps).filter((c)=>!!c)
        ];
        this.setTemplate(template, requiredComps);
        ctrl.setComp(compProxy, this.eGridDiv, this.getGui());
        this.insertGridIntoDom();
        this.initialiseTabGuard({
            // we want to override the default behaviour to do nothing for onTabKeyDown
            onTabKeyDown: ()=>void 0,
            focusInnerElement: (fromBottom)=>ctrl.focusInnerElement(fromBottom),
            forceFocusOutWhenTabGuardsAreEmpty: true,
            isEmpty: ()=>!ctrl.isFocusable()
        });
    }
    insertGridIntoDom() {
        const eGui = this.getGui();
        this.eGridDiv.appendChild(eGui);
        this.addDestroyFunc(()=>{
            eGui.remove();
            $437b23f6a393c3bf$var$_logIfDebug(this.gos, "Grid removed from DOM");
        });
    }
    updateLayoutClasses(cssClass, params) {
        const eRootWrapperBodyClassList = this.rootWrapperBody.classList;
        const { AUTO_HEIGHT: AUTO_HEIGHT, NORMAL: NORMAL, PRINT: PRINT } = $437b23f6a393c3bf$var$LayoutCssClasses;
        const { autoHeight: autoHeight, normal: normal, print: print } = params;
        eRootWrapperBodyClassList.toggle(AUTO_HEIGHT, autoHeight);
        eRootWrapperBodyClassList.toggle(NORMAL, normal);
        eRootWrapperBodyClassList.toggle(PRINT, print);
        this.toggleCss(AUTO_HEIGHT, autoHeight);
        this.toggleCss(NORMAL, normal);
        this.toggleCss(PRINT, print);
    }
    createTemplate(params) {
        const dropZones = params.gridHeaderDropZonesSelector ? {
            tag: "ag-grid-header-drop-zones"
        } : null;
        const sideBar = params.sideBarSelector ? {
            tag: "ag-side-bar",
            ref: "sideBar"
        } : null;
        const statusBar = params.statusBarSelector ? {
            tag: "ag-status-bar"
        } : null;
        const watermark = params.watermarkSelector ? {
            tag: "ag-watermark"
        } : null;
        const pagination = params.paginationSelector ? {
            tag: "ag-pagination",
            ref: "pagination"
        } : null;
        return {
            tag: "div",
            cls: "ag-root-wrapper",
            role: "presentation",
            children: [
                dropZones,
                {
                    tag: "div",
                    ref: "rootWrapperBody",
                    cls: "ag-root-wrapper-body",
                    role: "presentation",
                    children: [
                        {
                            tag: "ag-grid-body",
                            ref: "gridBody"
                        },
                        sideBar
                    ]
                },
                statusBar,
                pagination,
                watermark
            ]
        };
    }
    getFocusableElement() {
        return this.rootWrapperBody;
    }
    forceFocusOutOfContainer(up = false) {
        if (!up && this.pagination?.isDisplayed()) {
            this.pagination.forceFocusOutOfContainer(up);
            return;
        }
        super.forceFocusOutOfContainer(up);
    }
    getFocusableContainers() {
        const focusableContainers = [
            this.gridBody
        ];
        for (const comp of [
            this.sideBar,
            this.pagination
        ])if (comp) focusableContainers.push(comp);
        return focusableContainers.filter((el)=>$437b23f6a393c3bf$export$2badf4aa566524cb(el.getGui()));
    }
};
// packages/ag-grid-community/src/api/gridApiFunctions.ts
var $437b23f6a393c3bf$var$mod = (moduleName, input)=>{
    for (const key of Object.keys(input))input[key] = moduleName;
    return input;
};
var $437b23f6a393c3bf$var$gridApiFunctionsMap = {
    dispatchEvent: "CommunityCore",
    // this is always registered
    ...$437b23f6a393c3bf$var$mod("CommunityCore", {
        destroy: 0,
        getGridId: 0,
        getGridOption: 0,
        isDestroyed: 0,
        setGridOption: 0,
        updateGridOptions: 0,
        isModuleRegistered: 0
    }),
    ...$437b23f6a393c3bf$var$mod("GridState", {
        getState: 0,
        setState: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedRowSelection", {
        setNodesSelected: 0,
        selectAll: 0,
        deselectAll: 0,
        selectAllFiltered: 0,
        deselectAllFiltered: 0,
        selectAllOnCurrentPage: 0,
        deselectAllOnCurrentPage: 0,
        getSelectedNodes: 0,
        getSelectedRows: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RowApi", {
        redrawRows: 0,
        setRowNodeExpanded: 0,
        getRowNode: 0,
        addRenderedRowListener: 0,
        getRenderedNodes: 0,
        forEachNode: 0,
        getFirstDisplayedRowIndex: 0,
        getLastDisplayedRowIndex: 0,
        getDisplayedRowAtIndex: 0,
        getDisplayedRowCount: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ScrollApi", {
        getVerticalPixelRange: 0,
        getHorizontalPixelRange: 0,
        ensureColumnVisible: 0,
        ensureIndexVisible: 0,
        ensureNodeVisible: 0
    }),
    ...$437b23f6a393c3bf$var$mod("KeyboardNavigation", {
        getFocusedCell: 0,
        clearFocusedCell: 0,
        setFocusedCell: 0,
        tabToNextCell: 0,
        tabToPreviousCell: 0,
        setFocusedHeader: 0
    }),
    ...$437b23f6a393c3bf$var$mod("EventApi", {
        addEventListener: 0,
        addGlobalListener: 0,
        removeEventListener: 0,
        removeGlobalListener: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ValueCache", {
        expireValueCache: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CellApi", {
        getCellValue: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedMenu", {
        showColumnMenu: 0,
        hidePopupMenu: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Sort", {
        onSortChanged: 0
    }),
    ...$437b23f6a393c3bf$var$mod("PinnedRow", {
        getPinnedTopRowCount: 0,
        getPinnedBottomRowCount: 0,
        getPinnedTopRow: 0,
        getPinnedBottomRow: 0,
        forEachPinnedRow: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Overlay", {
        showLoadingOverlay: 0,
        showNoRowsOverlay: 0,
        hideOverlay: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RenderApi", {
        setGridAriaProperty: 0,
        refreshCells: 0,
        refreshHeader: 0,
        isAnimationFrameQueueEmpty: 0,
        flushAllAnimationFrames: 0,
        getSizesForCurrentTheme: 0,
        getCellRendererInstances: 0
    }),
    ...$437b23f6a393c3bf$var$mod("HighlightChanges", {
        flashCells: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RowDrag", {
        addRowDropZone: 0,
        removeRowDropZone: 0,
        getRowDropZoneParams: 0,
        getRowDropPositionIndicator: 0,
        setRowDropPositionIndicator: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnApi", {
        getColumnDefs: 0,
        getColumnDef: 0,
        getDisplayNameForColumn: 0,
        getColumn: 0,
        getColumns: 0,
        applyColumnState: 0,
        getColumnState: 0,
        resetColumnState: 0,
        isPinning: 0,
        isPinningLeft: 0,
        isPinningRight: 0,
        getDisplayedColAfter: 0,
        getDisplayedColBefore: 0,
        setColumnsVisible: 0,
        setColumnsPinned: 0,
        getAllGridColumns: 0,
        getDisplayedLeftColumns: 0,
        getDisplayedCenterColumns: 0,
        getDisplayedRightColumns: 0,
        getAllDisplayedColumns: 0,
        getAllDisplayedVirtualColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnAutoSize", {
        sizeColumnsToFit: 0,
        autoSizeColumns: 0,
        autoSizeAllColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnGroup", {
        setColumnGroupOpened: 0,
        getColumnGroup: 0,
        getProvidedColumnGroup: 0,
        getDisplayNameForColumnGroup: 0,
        getColumnGroupState: 0,
        setColumnGroupState: 0,
        resetColumnGroupState: 0,
        getLeftDisplayedColumnGroups: 0,
        getCenterDisplayedColumnGroups: 0,
        getRightDisplayedColumnGroups: 0,
        getAllDisplayedColumnGroups: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnMove", {
        moveColumnByIndex: 0,
        moveColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnResize", {
        setColumnWidths: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnHover", {
        isColumnHovered: 0
    }),
    ...$437b23f6a393c3bf$var$mod("EditCore", {
        getCellEditorInstances: 0,
        getEditingCells: 0,
        getEditRowValues: 0,
        stopEditing: 0,
        startEditingCell: 0,
        isEditing: 0,
        validateEdit: 0
    }),
    ...$437b23f6a393c3bf$var$mod("BatchEdit", {
        startBatchEdit: 0,
        cancelBatchEdit: 0,
        commitBatchEdit: 0,
        isBatchEditing: 0
    }),
    ...$437b23f6a393c3bf$var$mod("UndoRedoEdit", {
        undoCellEditing: 0,
        redoCellEditing: 0,
        getCurrentUndoSize: 0,
        getCurrentRedoSize: 0
    }),
    ...$437b23f6a393c3bf$var$mod("FilterCore", {
        isAnyFilterPresent: 0,
        onFilterChanged: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnFilter", {
        isColumnFilterPresent: 0,
        getColumnFilterInstance: 0,
        destroyFilter: 0,
        setFilterModel: 0,
        getFilterModel: 0,
        getColumnFilterModel: 0,
        setColumnFilterModel: 0,
        showColumnFilter: 0,
        hideColumnFilter: 0,
        getColumnFilterHandler: 0,
        doFilterAction: 0
    }),
    ...$437b23f6a393c3bf$var$mod("QuickFilter", {
        isQuickFilterPresent: 0,
        getQuickFilter: 0,
        resetQuickFilter: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Find", {
        findGetActiveMatch: 0,
        findGetTotalMatches: 0,
        findGoTo: 0,
        findNext: 0,
        findPrevious: 0,
        findGetNumMatches: 0,
        findGetParts: 0,
        findClearActive: 0,
        findRefresh: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Pagination", {
        paginationIsLastPageFound: 0,
        paginationGetPageSize: 0,
        paginationGetCurrentPage: 0,
        paginationGetTotalPages: 0,
        paginationGetRowCount: 0,
        paginationGoToNextPage: 0,
        paginationGoToPreviousPage: 0,
        paginationGoToFirstPage: 0,
        paginationGoToLastPage: 0,
        paginationGoToPage: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CsrmSsrmSharedApi", {
        expandAll: 0,
        collapseAll: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SsrmInfiniteSharedApi", {
        setRowCount: 0,
        getCacheBlockState: 0,
        isLastRowIndexKnown: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ClientSideRowModelApi", {
        onGroupExpandedOrCollapsed: 0,
        refreshClientSideRowModel: 0,
        isRowDataEmpty: 0,
        forEachLeafNode: 0,
        forEachNodeAfterFilter: 0,
        forEachNodeAfterFilterAndSort: 0,
        applyTransaction: 0,
        applyTransactionAsync: 0,
        flushAsyncTransactions: 0,
        getBestCostNodeSelection: 0,
        onRowHeightChanged: 0,
        resetRowHeights: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CsvExport", {
        getDataAsCsv: 0,
        exportDataAsCsv: 0
    }),
    ...$437b23f6a393c3bf$var$mod("InfiniteRowModel", {
        refreshInfiniteCache: 0,
        purgeInfiniteCache: 0,
        getInfiniteRowCount: 0
    }),
    ...$437b23f6a393c3bf$var$mod("AdvancedFilter", {
        getAdvancedFilterModel: 0,
        setAdvancedFilterModel: 0,
        showAdvancedFilterBuilder: 0,
        hideAdvancedFilterBuilder: 0
    }),
    ...$437b23f6a393c3bf$var$mod("IntegratedCharts", {
        getChartModels: 0,
        getChartRef: 0,
        getChartImageDataURL: 0,
        downloadChart: 0,
        openChartToolPanel: 0,
        closeChartToolPanel: 0,
        createRangeChart: 0,
        createPivotChart: 0,
        createCrossFilterChart: 0,
        updateChart: 0,
        restoreChart: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Clipboard", {
        copyToClipboard: 0,
        cutToClipboard: 0,
        copySelectedRowsToClipboard: 0,
        copySelectedRangeToClipboard: 0,
        copySelectedRangeDown: 0,
        pasteFromClipboard: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ExcelExport", {
        getDataAsExcel: 0,
        exportDataAsExcel: 0,
        getSheetDataForExcel: 0,
        getMultipleSheetsAsExcel: 0,
        exportMultipleSheetsAsExcel: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedMasterDetail", {
        addDetailGridInfo: 0,
        removeDetailGridInfo: 0,
        getDetailGridInfo: 0,
        forEachDetailGridInfo: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ContextMenu", {
        showContextMenu: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnMenu", {
        showColumnChooser: 0,
        hideColumnChooser: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CellSelection", {
        getCellRanges: 0,
        addCellRange: 0,
        clearRangeSelection: 0,
        clearCellSelection: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedRowGrouping", {
        setRowGroupColumns: 0,
        removeRowGroupColumns: 0,
        addRowGroupColumns: 0,
        getRowGroupColumns: 0,
        moveRowGroupColumn: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedAggregation", {
        addAggFuncs: 0,
        clearAggFuncs: 0,
        setColumnAggFunc: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedPivot", {
        isPivotMode: 0,
        getPivotResultColumn: 0,
        setValueColumns: 0,
        getValueColumns: 0,
        removeValueColumns: 0,
        addValueColumns: 0,
        setPivotColumns: 0,
        removePivotColumns: 0,
        addPivotColumns: 0,
        getPivotColumns: 0,
        setPivotResultColumns: 0,
        getPivotResultColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ServerSideRowModelApi", {
        getServerSideSelectionState: 0,
        setServerSideSelectionState: 0,
        applyServerSideTransaction: 0,
        applyServerSideTransactionAsync: 0,
        applyServerSideRowData: 0,
        retryServerSideLoads: 0,
        flushServerSideAsyncTransactions: 0,
        refreshServerSide: 0,
        getServerSideGroupLevelState: 0,
        onRowHeightChanged: 0,
        resetRowHeights: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SideBar", {
        isSideBarVisible: 0,
        setSideBarVisible: 0,
        setSideBarPosition: 0,
        openToolPanel: 0,
        closeToolPanel: 0,
        getOpenedToolPanel: 0,
        refreshToolPanel: 0,
        isToolPanelShowing: 0,
        getToolPanelInstance: 0,
        getSideBar: 0
    }),
    ...$437b23f6a393c3bf$var$mod("StatusBar", {
        getStatusPanel: 0
    }),
    ...$437b23f6a393c3bf$var$mod("AiToolkit", {
        getStructuredSchema: 0
    })
};
// packages/ag-grid-community/src/api/apiFunctionService.ts
var $437b23f6a393c3bf$var$defaultFns = {
    isDestroyed: ()=>true,
    destroy () {},
    preConstruct () {},
    postConstruct () {},
    preWireBeans () {},
    wireBeans () {}
};
var $437b23f6a393c3bf$var$dispatchEvent = (beans, event)=>beans.eventSvc.dispatchEvent(event);
var $437b23f6a393c3bf$var$GridApiClass = class {
};
Reflect.defineProperty($437b23f6a393c3bf$var$GridApiClass, "name", {
    value: "GridApi"
});
var $437b23f6a393c3bf$var$ApiFunctionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "apiFunctionSvc";
        this.api = new $437b23f6a393c3bf$var$GridApiClass();
        this.fns = {
            ...$437b23f6a393c3bf$var$defaultFns,
            dispatchEvent: // dispatchEvent is used by frameworks, also used by aligned grids to identify a grid api instance
            $437b23f6a393c3bf$var$dispatchEvent
        };
        this.preDestroyLink = "";
        const { api: api } = this;
        for (const key of Object.keys($437b23f6a393c3bf$var$gridApiFunctionsMap))api[key] = this.makeApi(key)[key];
    }
    postConstruct() {
        this.preDestroyLink = this.beans.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed");
    }
    addFunction(functionName, func) {
        const { fns: fns, beans: beans } = this;
        if (fns !== $437b23f6a393c3bf$var$defaultFns) fns[functionName] = beans?.validation?.validateApiFunction(functionName, func) ?? func;
    }
    makeApi(apiName) {
        return {
            [apiName]: (...args)=>{
                const { beans: beans, fns: { [apiName]: fn } } = this;
                return fn ? fn(beans, ...args) : this.apiNotFound(apiName);
            }
        };
    }
    apiNotFound(fnName) {
        const { beans: beans, gos: gos, preDestroyLink: preDestroyLink } = this;
        if (!beans) $437b23f6a393c3bf$export$545083624300f13d(26, {
            fnName: fnName,
            preDestroyLink: preDestroyLink
        });
        else {
            const module = $437b23f6a393c3bf$var$gridApiFunctionsMap[fnName];
            if (gos.assertModuleRegistered(module, `api.${fnName}`)) $437b23f6a393c3bf$export$545083624300f13d(27, {
                fnName: fnName,
                module: module
            });
        }
    }
    destroy() {
        super.destroy();
        this.fns = $437b23f6a393c3bf$var$defaultFns;
        this.beans = null;
    }
};
// packages/ag-grid-community/src/api/coreApi.ts
function $437b23f6a393c3bf$var$getGridId(beans) {
    return beans.context.getId();
}
function $437b23f6a393c3bf$var$destroy(beans) {
    beans.gridDestroySvc.destroy();
}
function $437b23f6a393c3bf$var$isDestroyed(beans) {
    return beans.gridDestroySvc.destroyCalled;
}
function $437b23f6a393c3bf$var$getGridOption(beans, key) {
    return beans.gos.get(key);
}
function $437b23f6a393c3bf$var$setGridOption(beans, key, value) {
    $437b23f6a393c3bf$var$updateGridOptions(beans, {
        [key]: value
    });
}
function $437b23f6a393c3bf$var$updateGridOptions(beans, options) {
    beans.gos.updateGridOptions({
        options: options
    });
}
function $437b23f6a393c3bf$var$isModuleRegistered(beans, moduleName) {
    const withoutSuffix = moduleName.replace(/Module$/, "");
    return beans.gos.isModuleRegistered(withoutSuffix);
}
// packages/ag-grid-community/src/rendering/dndSourceComp.ts
var $437b23f6a393c3bf$var$DndSourceElement = {
    tag: "div",
    cls: "ag-drag-handle ag-row-drag",
    attrs: {
        draggable: "true"
    }
};
var $437b23f6a393c3bf$var$DndSourceComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(rowNode, column, eCell){
        super($437b23f6a393c3bf$var$DndSourceElement);
        this.rowNode = rowNode;
        this.column = column;
        this.eCell = eCell;
    }
    postConstruct() {
        const eGui = this.getGui();
        eGui.appendChild($437b23f6a393c3bf$export$d8feba07bf373edb("rowDrag", this.beans, null));
        this.addGuiEventListener("mousedown", (e)=>{
            e.stopPropagation();
        });
        this.addDragSource();
        this.checkVisibility();
    }
    addDragSource() {
        this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
    }
    onDragStart(dragEvent) {
        const { rowNode: rowNode, column: column, eCell: eCell, gos: gos } = this;
        const providedOnRowDrag = column.getColDef().dndSourceOnRowDrag;
        const dataTransfer = dragEvent.dataTransfer;
        dataTransfer.setDragImage(eCell, 0, 0);
        if (providedOnRowDrag) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                rowNode: rowNode,
                dragEvent: dragEvent
            });
            providedOnRowDrag(params);
        } else try {
            const jsonData = JSON.stringify(rowNode.data);
            dataTransfer.setData("application/json", jsonData);
            dataTransfer.setData("text/plain", jsonData);
        } catch (e) {}
    }
    checkVisibility() {
        const visible = this.column.isDndSource(this.rowNode);
        this.setDisplayed(visible);
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragApi.ts
function $437b23f6a393c3bf$var$addRowDropZone(beans, params) {
    beans.rowDragSvc?.rowDragFeature?.addRowDropZone(params);
}
function $437b23f6a393c3bf$var$removeRowDropZone(beans, params) {
    const activeDropTarget = beans.dragAndDrop?.findExternalZone(params.getContainer());
    if (activeDropTarget) beans.dragAndDrop?.removeDropTarget(activeDropTarget);
}
function $437b23f6a393c3bf$var$getRowDropZoneParams(beans, events) {
    return beans.rowDragSvc?.rowDragFeature?.getRowDropZone(events);
}
function $437b23f6a393c3bf$var$getRowDropPositionIndicator(beans) {
    const rowDropHighlightSvc = beans.rowDropHighlightSvc;
    return rowDropHighlightSvc ? {
        row: rowDropHighlightSvc.row,
        dropIndicatorPosition: rowDropHighlightSvc.position
    } : {
        row: null,
        dropIndicatorPosition: "none"
    };
}
function $437b23f6a393c3bf$var$setRowDropPositionIndicator(beans, params) {
    const rowDropHighlightSvc = beans.rowDropHighlightSvc;
    if (!rowDropHighlightSvc) return;
    const rowNode = params?.row;
    let position = params?.dropIndicatorPosition;
    if (position !== "above" && position !== "below" && position !== "inside") position = "none";
    const rowIndex = rowNode?.rowIndex;
    if (rowIndex === null || rowIndex === void 0 || position === "none") rowDropHighlightSvc.clear();
    else rowDropHighlightSvc.set(rowNode, position);
}
// packages/ag-grid-community/src/dragAndDrop/dragService.ts
var $437b23f6a393c3bf$var$DragService = class extends $437b23f6a393c3bf$export$746301531a60a666 {
    shouldPreventMouseEvent(mouseEvent) {
        const isEnableCellTextSelect = this.gos.get("enableCellTextSelection");
        return isEnableCellTextSelect && super.shouldPreventMouseEvent(mouseEvent);
    }
};
// packages/ag-grid-community/src/dragAndDrop/horizontalResizeService.ts
var $437b23f6a393c3bf$var$HorizontalResizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "horizontalResizeSvc";
    }
    addResizeBar(params) {
        const dragSource = {
            dragStartPixels: params.dragStartPixels || 0,
            eElement: params.eResizeBar,
            onDragStart: this.onDragStart.bind(this, params),
            onDragStop: this.onDragStop.bind(this, params),
            onDragging: this.onDragging.bind(this, params),
            onDragCancel: this.onDragStop.bind(this, params),
            includeTouch: true,
            stopPropagationForTouch: true
        };
        const { dragSvc: dragSvc } = this.beans;
        dragSvc.addDragSource(dragSource);
        const finishedWithResizeFunc = ()=>dragSvc.removeDragSource(dragSource);
        return finishedWithResizeFunc;
    }
    onDragStart(params, mouseEvent) {
        this.dragStartX = mouseEvent.clientX;
        this.setResizeIcons();
        const shiftKey = mouseEvent instanceof MouseEvent && mouseEvent.shiftKey === true;
        params.onResizeStart(shiftKey);
    }
    setResizeIcons() {
        const ctrl = this.beans.ctrlsSvc.get("gridCtrl");
        ctrl.setResizeCursor(1 /* Horizontal */ );
        ctrl.disableUserSelect(true);
    }
    onDragStop(params) {
        params.onResizeEnd(this.resizeAmount);
        this.resetIcons();
    }
    resetIcons() {
        const ctrl = this.beans.ctrlsSvc.get("gridCtrl");
        ctrl.setResizeCursor(false);
        ctrl.disableUserSelect(false);
    }
    onDragging(params, mouseEvent) {
        this.resizeAmount = mouseEvent.clientX - this.dragStartX;
        params.onResizing(this.resizeAmount);
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragComp.ts
var $437b23f6a393c3bf$var$RowDragElement = {
    tag: "div",
    cls: "ag-drag-handle ag-row-drag",
    attrs: {
        "aria-hidden": "true"
    }
};
var $437b23f6a393c3bf$var$RowDragComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(cellValueFn, rowNode, column, customGui, dragStartPixels, alwaysVisible = false){
        super();
        this.cellValueFn = cellValueFn;
        this.rowNode = rowNode;
        this.column = column;
        this.customGui = customGui;
        this.dragStartPixels = dragStartPixels;
        this.alwaysVisible = alwaysVisible;
        this.dragSource = null;
    }
    isCustomGui() {
        return this.customGui != null;
    }
    postConstruct() {
        const { beans: beans, customGui: customGui } = this;
        if (customGui) this.setDragElement(customGui, this.dragStartPixels);
        else {
            this.setTemplate($437b23f6a393c3bf$var$RowDragElement);
            this.getGui().appendChild($437b23f6a393c3bf$export$d8feba07bf373edb("rowDrag", beans, null));
            this.addDragSource();
        }
        if (!this.alwaysVisible) this.initCellDrag();
    }
    initCellDrag() {
        const { beans: beans, gos: gos, rowNode: rowNode } = this;
        const refreshVisibility = this.refreshVisibility.bind(this);
        this.addManagedPropertyListener("suppressRowDrag", refreshVisibility);
        this.addManagedListeners(rowNode, {
            dataChanged: refreshVisibility,
            cellChanged: refreshVisibility
        });
        this.addManagedListeners(beans.eventSvc, // For managed row drag, we do not show the component if sort, filter or grouping is active
        gos.get("rowDragManaged") ? {
            sortChanged: refreshVisibility,
            filterChanged: refreshVisibility,
            columnRowGroupChanged: refreshVisibility,
            newColumnsLoaded: refreshVisibility
        } : {
            newColumnsLoaded: refreshVisibility
        });
    }
    setDragElement(dragElement, dragStartPixels) {
        this.setTemplateFromElement(dragElement, void 0, void 0, true);
        this.addDragSource(dragStartPixels);
    }
    refreshVisibility() {
        if (this.alwaysVisible) return;
        const displayedOptions = {
            skipAriaHidden: true
        };
        if (this.isNeverDisplayed()) {
            this.setDisplayed(false, displayedOptions);
            return;
        }
        const column = this.column;
        let shownSometimes = typeof column?.getColDef().rowDrag === "function";
        let visible = !column || this.isCustomGui() || column.isRowDrag(this.rowNode);
        if (visible && this.rowNode.footer && this.gos.get("rowDragManaged")) {
            visible = false;
            shownSometimes = true;
        }
        this.setDisplayed(shownSometimes || visible, displayedOptions);
        this.setVisible(visible, displayedOptions);
    }
    isNeverDisplayed() {
        const { gos: gos, beans: beans } = this;
        if (gos.get("suppressRowDrag")) return true;
        if (gos.get("rowDragManaged") && !!beans.rowDragSvc.rowDragFeature?.shouldPreventRowMove() && !beans.dragAndDrop?.hasExternalDropZones()) return true;
        return false;
    }
    getSelectedNodes() {
        const rowNode = this.rowNode;
        const isRowDragMultiRow = this.gos.get("rowDragMultiRow");
        if (!isRowDragMultiRow) return [
            rowNode
        ];
        const selection = this.beans.selectionSvc?.getSelectedNodes() ?? [];
        return selection.indexOf(rowNode) !== -1 ? selection : [
            rowNode
        ];
    }
    getDragItem() {
        const { column: column, rowNode: rowNode } = this;
        return {
            rowNode: rowNode,
            rowNodes: this.getSelectedNodes(),
            columns: column ? [
                column
            ] : void 0,
            defaultTextValue: this.cellValueFn()
        };
    }
    getRowDragText(column) {
        if (column) {
            const colDef = column.getColDef();
            if (colDef.rowDragText) return colDef.rowDragText;
        }
        return this.gos.get("rowDragText");
    }
    addDragSource(dragStartPixels = 4) {
        if (this.dragSource) this.removeDragSource();
        if (this.gos.get("rowDragManaged") && this.rowNode.footer) return;
        const eGui = this.getGui();
        if (this.gos.get("enableCellTextSelection")) {
            this.removeMouseDownListener();
            this.mouseDownListener = this.addManagedElementListeners(eGui, {
                mousedown: (e)=>{
                    e?.preventDefault();
                }
            })[0];
        }
        const translate = this.getLocaleTextFunc();
        this.dragSource = {
            type: 2 /* RowDrag */ ,
            eElement: eGui,
            dragItemName: (draggingEvent)=>{
                const dragItem = draggingEvent?.dragItem || this.getDragItem();
                const dragItemCount = (draggingEvent?.dropTarget?.rows.length ?? dragItem.rowNodes?.length) || 1;
                const rowDragText = this.getRowDragText(this.column);
                if (rowDragText) return rowDragText(dragItem, dragItemCount);
                return dragItemCount === 1 ? this.cellValueFn() : `${dragItemCount} ${translate("rowDragRows", "rows")}`;
            },
            getDragItem: ()=>this.getDragItem(),
            dragStartPixels: dragStartPixels,
            dragSourceDomDataKey: this.gos.getDomDataKey()
        };
        this.beans.dragAndDrop.addDragSource(this.dragSource, true);
    }
    destroy() {
        this.removeDragSource();
        this.removeMouseDownListener();
        super.destroy();
    }
    removeDragSource() {
        if (!this.dragSource) return;
        this.beans.dragAndDrop.removeDragSource(this.dragSource);
        this.dragSource = null;
    }
    removeMouseDownListener() {
        if (!this.mouseDownListener) return;
        this.mouseDownListener();
        this.mouseDownListener = void 0;
    }
};
// packages/ag-grid-community/src/clientSideRowModel/changedRowNodes.ts
var $437b23f6a393c3bf$var$ChangedRowNodes = class {
    constructor(){
        this.reordered = false;
        this.removals = /* @__PURE__ */ new Set();
        this.updates = /* @__PURE__ */ new Set();
        this.adds = /* @__PURE__ */ new Set();
    }
};
// packages/ag-grid-community/src/entities/positionUtils.ts
function $437b23f6a393c3bf$export$c0c5a5ba9327269f(cellPosition) {
    const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = cellPosition;
    return `${rowIndex}.${rowPinned == null ? "null" : rowPinned}.${column.getId()}`;
}
function $437b23f6a393c3bf$export$be3973033c2c5267(cellA, cellB) {
    const colsMatch = cellA.column === cellB.column;
    const floatingMatch = cellA.rowPinned === cellB.rowPinned;
    const indexMatch = cellA.rowIndex === cellB.rowIndex;
    return colsMatch && floatingMatch && indexMatch;
}
function $437b23f6a393c3bf$export$6cce97428a227a31(rowA, rowB) {
    switch(rowA.rowPinned){
        case "top":
            if (rowB.rowPinned !== "top") return true;
            break;
        case "bottom":
            if (rowB.rowPinned !== "bottom") return false;
            break;
        default:
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowB.rowPinned)) return rowB.rowPinned !== "top";
            break;
    }
    return rowA.rowIndex < rowB.rowIndex;
}
function $437b23f6a393c3bf$export$de6f9fa10e9f4188(rowA, rowB) {
    if (!rowA && !rowB) return true;
    if (rowA && !rowB || !rowA && rowB) return false;
    return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
}
function $437b23f6a393c3bf$export$124b4386b662b699(beans) {
    let rowIndex = 0;
    let rowPinned;
    const { pinnedRowModel: pinnedRowModel, rowModel: rowModel, pageBounds: pageBounds } = beans;
    if (pinnedRowModel?.getPinnedTopRowCount()) rowPinned = "top";
    else if (rowModel.getRowCount()) {
        rowPinned = null;
        rowIndex = pageBounds.getFirstRow();
    } else if (pinnedRowModel?.getPinnedBottomRowCount()) rowPinned = "bottom";
    return rowPinned === void 0 ? null : {
        rowIndex: rowIndex,
        rowPinned: rowPinned
    };
}
function $437b23f6a393c3bf$export$a1449222017e428(beans) {
    let rowIndex;
    let rowPinned = null;
    const { pinnedRowModel: pinnedRowModel, pageBounds: pageBounds } = beans;
    const pinnedBottomCount = pinnedRowModel?.getPinnedBottomRowCount();
    const pinnedTopCount = pinnedRowModel?.getPinnedTopRowCount();
    if (pinnedBottomCount) {
        rowPinned = "bottom";
        rowIndex = pinnedBottomCount - 1;
    } else if (beans.rowModel.getRowCount()) rowIndex = pageBounds.getLastRow();
    else if (pinnedTopCount) {
        rowPinned = "top";
        rowIndex = pinnedTopCount - 1;
    }
    return rowIndex === void 0 ? null : {
        rowIndex: rowIndex,
        rowPinned: rowPinned
    };
}
function $437b23f6a393c3bf$export$d4675a60917db7b0(beans, gridRow) {
    switch(gridRow.rowPinned){
        case "top":
            return beans.pinnedRowModel?.getPinnedTopRow(gridRow.rowIndex);
        case "bottom":
            return beans.pinnedRowModel?.getPinnedBottomRow(gridRow.rowIndex);
        default:
            return beans.rowModel.getRow(gridRow.rowIndex);
    }
}
function $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, cellPosition) {
    const spannedCellCtrl = beans.spannedRowRenderer?.getCellByPosition(cellPosition);
    if (spannedCellCtrl) return spannedCellCtrl;
    const rowCtrl = beans.rowRenderer.getRowByPosition(cellPosition);
    if (!rowCtrl) return null;
    return rowCtrl.getCellCtrl(cellPosition.column);
}
function $437b23f6a393c3bf$var$_getRowById(beans, rowId, rowPinned) {
    const { rowModel: rm, pinnedRowModel: prm } = beans;
    let node;
    node ?? (node = rm?.getRowNode(rowId));
    if (rowPinned) node ?? (node = prm?.getPinnedRowById(rowId, rowPinned));
    else {
        node ?? (node = prm?.getPinnedRowById(rowId, "top"));
        node ?? (node = prm?.getPinnedRowById(rowId, "bottom"));
    }
    return node;
}
function $437b23f6a393c3bf$export$b36b14fdaf41f4d8(beans, rowPosition, checkSticky = false) {
    const { rowIndex: index, rowPinned: pinned } = rowPosition;
    const { pageBounds: pageBounds, pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    if (index === 0) {
        if (pinned === "top") return null;
        if (pinned === "bottom" && rowModel.isRowsToRender()) return {
            rowIndex: pageBounds.getLastRow(),
            rowPinned: null
        };
        return pinnedRowModel?.isRowsToRender("top") ? {
            rowIndex: pinnedRowModel.getPinnedTopRowCount() - 1,
            rowPinned: "top"
        } : null;
    }
    if (checkSticky) {
        const rowNode = pinned ? void 0 : rowModel.getRow(index);
        return $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode, true) ?? {
            rowIndex: index - 1,
            rowPinned: pinned
        };
    }
    return {
        rowIndex: index - 1,
        rowPinned: pinned
    };
}
function $437b23f6a393c3bf$export$5d5d8b440c4b4c91(beans, rowPosition) {
    const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    const pinnedTopRowCount = pinnedRowModel?.getPinnedTopRowCount() ?? 0;
    const unpinnedRowCount = rowModel.getRowCount();
    const { rowPinned: rowPinned, rowIndex: rowIndex } = rowPosition;
    if (rowPinned === "top") return rowIndex;
    if (rowPinned === "bottom") return pinnedTopRowCount + unpinnedRowCount + rowIndex;
    return pinnedTopRowCount + rowIndex;
}
function $437b23f6a393c3bf$export$3077f3bcabdc5ad1(beans, rowPosition, checkSticky = false) {
    const { rowIndex: index, rowPinned: pinned } = rowPosition;
    const { pageBounds: pageBounds, pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    if ($437b23f6a393c3bf$var$isLastRowInContainer(beans, rowPosition)) {
        if (pinned === "bottom") return null;
        if (pinned === "top" && rowModel.isRowsToRender()) return {
            rowIndex: pageBounds.getFirstRow(),
            rowPinned: null
        };
        return pinnedRowModel?.isRowsToRender("bottom") ? {
            rowIndex: 0,
            rowPinned: "bottom"
        } : null;
    }
    if (checkSticky) {
        const rowNode = pinned ? void 0 : rowModel.getRow(index);
        return $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode) ?? {
            rowIndex: index + 1,
            rowPinned: pinned
        };
    }
    return {
        rowIndex: index + 1,
        rowPinned: pinned
    };
}
function $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode, up = false) {
    const { gos: gos, rowRenderer: rowRenderer } = beans;
    if (!rowNode?.sticky || !$437b23f6a393c3bf$export$d5f33aacea6a0849(gos)) return;
    const stickyTopCtrls = rowRenderer.getStickyTopRowCtrls();
    const stickyBottomCtrls = rowRenderer.getStickyBottomRowCtrls();
    const isStickyTop = !stickyBottomCtrls.some((ctrl)=>ctrl.rowNode.rowIndex === rowNode.rowIndex);
    const stickyRowCtrls = isStickyTop ? stickyTopCtrls : stickyBottomCtrls;
    const increment = (up ? -1 : 1) * (isStickyTop ? -1 : 1);
    let nextCtrl;
    for(let i = 0; i < stickyRowCtrls.length; i++)if (stickyRowCtrls[i].rowNode.rowIndex === rowNode.rowIndex) {
        nextCtrl = stickyRowCtrls[i + increment];
        break;
    }
    return nextCtrl ? {
        rowIndex: nextCtrl.rowNode.rowIndex,
        rowPinned: null
    } : void 0;
}
function $437b23f6a393c3bf$var$isLastRowInContainer(beans, rowPosition) {
    const { rowPinned: rowPinned, rowIndex: rowIndex } = rowPosition;
    const { pinnedRowModel: pinnedRowModel, pageBounds: pageBounds } = beans;
    if (rowPinned === "top") {
        const lastTopIndex = (pinnedRowModel?.getPinnedTopRowCount() ?? 0) - 1;
        return lastTopIndex <= rowIndex;
    }
    if (rowPinned === "bottom") {
        const lastBottomIndex = (pinnedRowModel?.getPinnedBottomRowCount() ?? 0) - 1;
        return lastBottomIndex <= rowIndex;
    }
    const lastBodyIndex = pageBounds.getLastRow();
    return lastBodyIndex <= rowIndex;
}
// packages/ag-grid-community/src/utils/changedPath.ts
var $437b23f6a393c3bf$export$cb4d9114a9732e85 = class {
    constructor(keepingColumns, rootNode){
        // whether changed path is active of not. it is active when a) doing
        // a transaction update or b) doing change detection. if we are doing
        // a CSRM refresh for other reasons (after sort or filter, or user calling
        // setRowData() without delta mode) then we are not active. we are also
        // marked as not active if secondary columns change in pivot (as this impacts
        // aggregations).
        // can be set inactive by:
        // a) ClientSideRowModel, if no transactions or
        // b) PivotService, if secondary columns changed
        this.active = true;
        // for each node in the change path, we also store which columns need
        // to be re-aggregated.
        this.nodeIdsToColumns = {};
        // for quick lookup, all items in the change path are mapped by nodeId
        this.mapToItems = {};
        this.keepingColumns = keepingColumns;
        this.pathRoot = {
            rowNode: rootNode,
            children: null
        };
        this.mapToItems[rootNode.id] = this.pathRoot;
    }
    depthFirstSearchChangedPath(pathItem, callback) {
        const { rowNode: rowNode, children: children } = pathItem;
        if (children) for(let i = 0; i < children.length; ++i)this.depthFirstSearchChangedPath(children[i], callback);
        callback(rowNode);
    }
    depthFirstSearchEverything(rowNode, callback, traverseEverything) {
        const childrenAfterGroup = rowNode.childrenAfterGroup;
        if (childrenAfterGroup) for(let i = 0, len = childrenAfterGroup.length; i < len; ++i){
            const childNode = childrenAfterGroup[i];
            if (childNode.childrenAfterGroup) this.depthFirstSearchEverything(childNode, callback, traverseEverything);
            else if (traverseEverything) callback(childNode);
        }
        callback(rowNode);
    }
    // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
    // will be called for child nodes in addition to parent nodes.
    forEachChangedNodeDepthFirst(callback, traverseLeafNodes = false, includeUnchangedNodes = false) {
        if (this.active && !includeUnchangedNodes) this.depthFirstSearchChangedPath(this.pathRoot, callback);
        else this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
    }
    executeFromRootNode(callback) {
        callback(this.pathRoot.rowNode);
    }
    createPathItems(rowNode) {
        let pointer = rowNode;
        let newEntryCount = 0;
        while(!this.mapToItems[pointer.id]){
            const newEntry = {
                rowNode: pointer,
                children: null
            };
            this.mapToItems[pointer.id] = newEntry;
            newEntryCount++;
            pointer = pointer.parent;
        }
        return newEntryCount;
    }
    populateColumnsMap(rowNode, columns) {
        if (!this.keepingColumns || !columns) return;
        let pointer = rowNode;
        while(pointer){
            if (!this.nodeIdsToColumns[pointer.id]) this.nodeIdsToColumns[pointer.id] = {};
            for (const col of columns)this.nodeIdsToColumns[pointer.id][col.getId()] = true;
            pointer = pointer.parent;
        }
    }
    linkPathItems(rowNode, newEntryCount) {
        let pointer = rowNode;
        for(let i = 0; i < newEntryCount; i++){
            const thisItem = this.mapToItems[pointer.id];
            const parentItem = this.mapToItems[pointer.parent.id];
            if (!parentItem.children) parentItem.children = [];
            parentItem.children.push(thisItem);
            pointer = pointer.parent;
        }
    }
    // called by
    // 1) change detection (provides cols) and
    // 2) groupStage if doing transaction update (doesn't provide cols)
    addParentNode(rowNode, columns) {
        if (!rowNode || rowNode.isRowPinned()) return;
        const newEntryCount = this.createPathItems(rowNode);
        this.linkPathItems(rowNode, newEntryCount);
        this.populateColumnsMap(rowNode, columns);
    }
    canSkip(rowNode) {
        return this.active && !this.mapToItems[rowNode.id];
    }
    getValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return valueColumns;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>colsForThisNode[col.getId()]);
        return result;
    }
    getNotValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return null;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>!colsForThisNode[col.getId()]);
        return result;
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragFeatureNudger.ts
var $437b23f6a393c3bf$var$RowDragFeatureNudger = class {
    constructor(beans, gridBodyCtrl){
        this.beans = beans;
        this.groupThrottled = false;
        this.scrollChanged = false;
        this.scrollChanging = false;
        this.oldVScroll = null;
        this.groupTimer = null;
        this.groupTarget = null;
        this.onGroupThrottle = ()=>{
            this.groupTimer = null;
            this.groupThrottled = true;
            this.beans.dragAndDrop?.nudge();
        };
        const getScrollY = ()=>gridBodyCtrl.scrollFeature.getVScrollPosition().top;
        this.autoScroll = new $437b23f6a393c3bf$export$c66bdc3d55a4f95({
            scrollContainer: gridBodyCtrl.eBodyViewport,
            scrollAxis: "y",
            getVerticalPosition: getScrollY,
            setVerticalPosition: (position)=>gridBodyCtrl.scrollFeature.setVerticalScrollPosition(position),
            onScrollCallback: ()=>{
                const newVScroll = getScrollY();
                if (this.oldVScroll !== newVScroll) {
                    this.oldVScroll = newVScroll;
                    this.scrollChanging = true;
                    return;
                }
                const scrollChanged = this.scrollChanging;
                this.scrollChanged = scrollChanged;
                this.scrollChanging = false;
                if (scrollChanged) {
                    this.beans.dragAndDrop?.nudge();
                    this.scrollChanged = false;
                }
            }
        });
    }
    updateGroup(target, canExpand) {
        if (this.groupTarget && this.groupTarget !== target) this.clearGroup();
        if (target) {
            if (canExpand && this.groupThrottled && !target.expanded && target.childrenAfterSort?.length && target.isExpandable()) target.setExpanded(true, void 0, true);
            if (target.expanded && target.childrenAfterSort?.length) {
                this.groupThrottled = true;
                this.groupTarget = target;
            }
        }
    }
    startGroup(target) {
        this.groupTarget = target;
        if (this.groupTimer === null) this.groupTimer = window.setTimeout(this.onGroupThrottle, this.beans.gos.get("rowDragInsertDelay"));
    }
    clearGroup() {
        this.groupThrottled = false;
        this.groupTarget = null;
        const timer = this.groupTimer;
        if (timer !== null) {
            this.groupTimer = null;
            window.clearTimeout(timer);
        }
    }
    clear() {
        this.clearGroup();
        this.autoScroll.ensureCleared();
        this.oldVScroll = null;
        this.scrollChanged = false;
        this.scrollChanging = false;
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragFeature.ts
var $437b23f6a393c3bf$var$RowDragFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer){
        super();
        this.eContainer = eContainer;
        this.lastDraggingEvent = null;
        this.nudger = null;
    }
    postConstruct() {
        const beans = this.beans;
        beans.ctrlsSvc.whenReady(this, (p)=>{
            this.nudger = new $437b23f6a393c3bf$var$RowDragFeatureNudger(beans, p.gridBodyCtrl);
        });
    }
    destroy() {
        super.destroy();
        this.nudger?.clear();
        this.nudger = null;
        this.lastDraggingEvent = null;
        this.eContainer = null;
    }
    getContainer() {
        return this.eContainer;
    }
    isInterestedIn(type) {
        return type === 2 /* RowDrag */ ;
    }
    getIconName(draggingEvent) {
        if (draggingEvent?.dropTarget?.allowed === false) return "notAllowed";
        if (this.gos.get("rowDragManaged") && this.shouldPreventRowMove()) return "notAllowed";
        return "move";
    }
    shouldPreventRowMove() {
        const { rowGroupColsSvc: rowGroupColsSvc, filterManager: filterManager, sortSvc: sortSvc } = this.beans;
        const rowGroupCols = rowGroupColsSvc?.columns ?? [];
        if (rowGroupCols.length) return true;
        const isFilterPresent = filterManager?.isAnyFilterPresent();
        if (isFilterPresent) return true;
        const isSortActive = sortSvc?.isSortActive();
        if (isSortActive) return true;
        return false;
    }
    getRowNodes(draggingEvent) {
        if (!this.isFromThisGrid(draggingEvent)) return draggingEvent.dragItem.rowNodes || [];
        const currentNode = draggingEvent.dragItem.rowNode;
        if (this.gos.get("rowDragMultiRow")) {
            const selectedNodes = this.beans.selectionSvc?.getSelectedNodes();
            if (selectedNodes && selectedNodes.indexOf(currentNode) >= 0) return selectedNodes.slice().sort($437b23f6a393c3bf$var$compareRowIndex);
        }
        return [
            currentNode
        ];
    }
    onDragEnter(draggingEvent) {
        this.dragging(draggingEvent, true);
    }
    onDragging(draggingEvent) {
        this.dragging(draggingEvent, false);
    }
    dragging(draggingEvent, enter) {
        const { lastDraggingEvent: lastDraggingEvent, beans: beans } = this;
        if (enter) {
            const rowNodes = this.getRowNodes(draggingEvent);
            draggingEvent.dragItem.rowNodes = rowNodes;
            $437b23f6a393c3bf$var$setRowNodesDragging(rowNodes, true);
        }
        this.lastDraggingEvent = draggingEvent;
        const fromNudge = draggingEvent.fromNudge;
        const rowsDrop = this.makeRowsDrop(lastDraggingEvent, draggingEvent, fromNudge, false);
        beans.rowDropHighlightSvc?.fromDrag(draggingEvent);
        if (enter) this.dispatchGridEvent("rowDragEnter", draggingEvent);
        this.dispatchGridEvent("rowDragMove", draggingEvent);
        if (rowsDrop?.rowDragManaged && rowsDrop.moved && rowsDrop.allowed && rowsDrop.sameGrid && !rowsDrop.suppressMoveWhenRowDragging && // Avoid flickering by only dropping while auto-scrolling is not happening
        (!fromNudge && !this.nudger?.autoScroll.scrolling || this.nudger?.scrollChanged)) this.dropRows(rowsDrop);
        this.nudger?.autoScroll.check(draggingEvent.event);
    }
    isFromThisGrid(draggingEvent) {
        return draggingEvent.dragSource.dragSourceDomDataKey === this.gos.getDomDataKey();
    }
    makeRowsDrop(lastDraggingEvent, draggingEvent, moving, dropping) {
        const { beans: beans, gos: gos } = this;
        const rowsDrop = this.newRowsDrop(draggingEvent, dropping);
        const rowModel = beans.rowModel;
        draggingEvent.dropTarget = rowsDrop;
        draggingEvent.changed = false;
        if (!rowsDrop) return null;
        let { sameGrid: sameGrid, rootNode: rootNode, source: source, target: target, rows: rows } = rowsDrop;
        target ?? (target = rowModel.getRow(rowModel.getRowCount() - 1) ?? null);
        const canSetParent = // We don't yet support drag and drop with grouping
        !!this.beans.groupStage?.treeData && // We don't yet support moving tree rows from a different grid in a structured way
        sameGrid;
        let newParent = null;
        if (target?.footer) {
            const found = $437b23f6a393c3bf$var$getPrevOrNext(rowModel, -1, target) ?? $437b23f6a393c3bf$var$getPrevOrNext(rowModel, 1, target);
            newParent = target.sibling ?? rootNode;
            target = found ?? null;
        }
        if (target?.detail) target = target.parent;
        rowsDrop.moved && (rowsDrop.moved = source !== target);
        let yDelta = 0.5;
        if (target) {
            if (sameGrid && rowsDrop.moved && (newParent || !canSetParent)) yDelta = source.rowIndex > target.rowIndex ? -0.5 : 0.5;
            else yDelta = (rowsDrop.y - target.rowTop - target.rowHeight / 2) / target.rowHeight || 0;
        }
        if (!canSetParent && sameGrid && target && rowsDrop.moved && $437b23f6a393c3bf$export$9f182d9ca737e15(gos)) {
            const newTarget = $437b23f6a393c3bf$var$deltaDraggingTarget(rowModel, rowsDrop);
            if (newTarget) {
                yDelta = source.rowIndex > newTarget.rowIndex ? -0.5 : 0.5;
                target = newTarget;
                rowsDrop.moved && (rowsDrop.moved = source !== target);
            }
        }
        const nudger = this.nudger;
        nudger?.updateGroup(target, moving);
        if (canSetParent && !newParent && nudger) {
            if (!target || yDelta >= 0.5 && target.rowIndex === beans.pageBounds.getLastRow()) newParent = rootNode;
            else if (rowsDrop.moved && this.targetShouldBeParent(target, yDelta, rows)) {
                if (nudger.groupThrottled) newParent = target;
                if (!moving && (!newParent || target && !target.expanded && !!target.childrenAfterSort?.length)) nudger.startGroup(target);
            }
            newParent ?? (newParent = target?.parent ?? rootNode);
        }
        let inside = false;
        if (newParent) {
            if (newParent === target && newParent !== rootNode) {
                const firstRow = newParent.expanded ? $437b23f6a393c3bf$var$getPrevOrNext(rowModel, 1, target) : null;
                if (firstRow?.parent === newParent) {
                    target = firstRow;
                    yDelta = -0.5;
                } else inside = true;
            }
            if (target && !inside) {
                let current = target;
                while(current && current !== rootNode && current !== newParent){
                    target = current;
                    current = current.parent;
                }
            }
        }
        rowsDrop.target = target;
        rowsDrop.newParent = newParent;
        rowsDrop.moved && (rowsDrop.moved = source !== target);
        const aboveOrBelow = yDelta < 0 ? "above" : "below";
        rowsDrop.position = rowsDrop.moved ? inside ? "inside" : aboveOrBelow : "none";
        this.validateRowsDrop(rowsDrop, canSetParent, aboveOrBelow, dropping);
        draggingEvent.changed || (draggingEvent.changed = $437b23f6a393c3bf$var$rowsDropChanged(lastDraggingEvent?.dropTarget, rowsDrop));
        return rowsDrop;
    }
    newRowsDrop(draggingEvent, dropping) {
        const { beans: beans, gos: gos } = this;
        const rootNode = beans.rowModel.rootNode;
        const rowDragManaged = $437b23f6a393c3bf$export$9f182d9ca737e15(gos) ? gos.get("rowDragManaged") : false;
        const suppressMoveWhenRowDragging = gos.get("suppressMoveWhenRowDragging");
        const sameGrid = this.isFromThisGrid(draggingEvent);
        let { rowNode: source, rowNodes: rows } = draggingEvent.dragItem;
        rows || (rows = source ? [
            source
        ] : []);
        source || (source = rows[0]);
        if (!source || !rootNode) return null;
        const withinGrid = this.beans.dragAndDrop.isDropZoneWithinThisGrid(draggingEvent);
        let allowed = true;
        if (rowDragManaged && (!rows.length || this.shouldPreventRowMove() || (suppressMoveWhenRowDragging || !sameGrid) && !withinGrid)) allowed = false;
        const y = $437b23f6a393c3bf$export$530c24bdfacb8cd1(beans, draggingEvent).y;
        const overNode = this.getOverNode(y);
        return {
            api: beans.gridApi,
            context: beans.gridOptions.context,
            draggingEvent: draggingEvent,
            rowDragManaged: rowDragManaged,
            suppressMoveWhenRowDragging: suppressMoveWhenRowDragging,
            sameGrid: sameGrid,
            withinGrid: withinGrid,
            rootNode: rootNode,
            moved: source !== overNode,
            y: y,
            overNode: overNode,
            overIndex: overNode?.rowIndex ?? -1,
            position: "none",
            source: source,
            target: overNode ?? null,
            newParent: null,
            rows: rows,
            allowed: allowed,
            highlight: !dropping && rowDragManaged && suppressMoveWhenRowDragging && (withinGrid || !sameGrid)
        };
    }
    validateRowsDrop(rowsDrop, canSetParent, aboveOrBelow, dropping) {
        const { rowDragManaged: rowDragManaged, suppressMoveWhenRowDragging: suppressMoveWhenRowDragging } = rowsDrop;
        if (!canSetParent) rowsDrop.newParent = null;
        if (suppressMoveWhenRowDragging && !rowsDrop.moved) rowsDrop.allowed = false;
        const isRowValidDropPosition = (!rowDragManaged || rowsDrop.allowed) && this.gos.get("isRowValidDropPosition");
        if (isRowValidDropPosition) {
            if (canSetParent && rowsDrop.newParent && $437b23f6a393c3bf$var$rowsHaveSameParent(rowsDrop.rows, rowsDrop.newParent)) rowsDrop.newParent = null;
            const canDropResult = isRowValidDropPosition(rowsDrop);
            if (!canDropResult) rowsDrop.allowed = false;
            else if (typeof canDropResult === "object") {
                if (canDropResult.rows !== void 0) rowsDrop.rows = canDropResult.rows ?? [];
                if (canSetParent && canDropResult.newParent !== void 0) rowsDrop.newParent = canDropResult.newParent;
                if (canDropResult.target !== void 0) rowsDrop.target = canDropResult.target;
                if (canDropResult.position) rowsDrop.position = canDropResult.position;
                if (canDropResult.allowed !== void 0) rowsDrop.allowed = canDropResult.allowed;
                else if (!rowDragManaged) rowsDrop.allowed = true;
                const draggingEvent = rowsDrop.draggingEvent;
                if (canDropResult.changed && draggingEvent) draggingEvent.changed = true;
                if (!dropping && canDropResult.highlight !== void 0) rowsDrop.highlight = canDropResult.highlight;
            }
        }
        if (rowDragManaged) rowsDrop.rows = this.filterRows(rowsDrop);
        if (canSetParent && rowsDrop.newParent && $437b23f6a393c3bf$var$rowsHaveSameParent(rowsDrop.rows, rowsDrop.newParent)) rowsDrop.newParent = null;
        if (suppressMoveWhenRowDragging && (!rowsDrop.rows.length || rowsDrop.position === "none")) rowsDrop.allowed = false;
        if ((!rowsDrop.allowed || !rowsDrop.newParent) && rowsDrop.position === "inside") rowsDrop.position = aboveOrBelow;
    }
    targetShouldBeParent(target, yDelta, rows) {
        const targetRowIndex = target.rowIndex;
        const INSIDE_THRESHOLD = 0.25;
        if (yDelta < -0.5 + INSIDE_THRESHOLD) return false;
        if (yDelta < 0.5 - INSIDE_THRESHOLD) return true;
        let nextRow;
        let nextRowIndex = targetRowIndex + 1;
        const rowModel = this.beans.rowModel;
        do nextRow = rowModel.getRow(nextRowIndex++);
        while (nextRow?.footer);
        const childrenAfterGroup = target.childrenAfterGroup;
        if (nextRow && nextRow.parent === target && childrenAfterGroup?.length) {
            const rowsSet = new Set(rows);
            for (const child of childrenAfterGroup){
                if (child.rowIndex !== null && !rowsSet.has(child)) return true;
            }
        }
        return false;
    }
    addRowDropZone(params) {
        if (!params.getContainer()) {
            $437b23f6a393c3bf$export$545083624300f13d(55);
            return;
        }
        const dragAndDrop = this.beans.dragAndDrop;
        if (dragAndDrop.findExternalZone(params.getContainer())) {
            $437b23f6a393c3bf$export$545083624300f13d(56);
            return;
        }
        const processedParams = params.fromGrid ? params : {
            getContainer: params.getContainer,
            onDragEnter: params.onDragEnter && ((e)=>params.onDragEnter(this.rowDragEvent("rowDragEnter", e))),
            onDragLeave: params.onDragLeave && ((e)=>params.onDragLeave(this.rowDragEvent("rowDragLeave", e))),
            onDragging: params.onDragging && ((e)=>params.onDragging(this.rowDragEvent("rowDragMove", e))),
            onDragStop: params.onDragStop && ((e)=>params.onDragStop(this.rowDragEvent("rowDragEnd", e))),
            onDragCancel: params.onDragCancel && ((e)=>params.onDragCancel(this.rowDragEvent("rowDragCancel", e)))
        };
        const dropTarget = {
            isInterestedIn: (type)=>type === 2 /* RowDrag */ ,
            getIconName: ()=>"move",
            external: true,
            ...processedParams
        };
        dragAndDrop.addDropTarget(dropTarget);
        this.addDestroyFunc(()=>dragAndDrop.removeDropTarget(dropTarget));
    }
    getRowDropZone(events) {
        const result = {
            getContainer: this.getContainer.bind(this),
            onDragEnter: (e)=>{
                this.onDragEnter(e);
                events?.onDragEnter?.(this.rowDragEvent("rowDragEnter", e));
            },
            onDragLeave: (e)=>{
                this.onDragLeave(e);
                events?.onDragLeave?.(this.rowDragEvent("rowDragLeave", e));
            },
            onDragging: (e)=>{
                this.onDragging(e);
                events?.onDragging?.(this.rowDragEvent("rowDragMove", e));
            },
            onDragStop: (e)=>{
                this.onDragStop(e);
                events?.onDragStop?.(this.rowDragEvent("rowDragEnd", e));
            },
            onDragCancel: (e)=>{
                this.onDragCancel(e);
                events?.onDragCancel?.(this.rowDragEvent("rowDragCancel", e));
            },
            fromGrid: true
        };
        return result;
    }
    getOverNode(y) {
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const mouseIsPastLastRow = y > pageBounds.getCurrentPagePixelRange().pageLastPixel;
        const overIndex = mouseIsPastLastRow ? -1 : rowModel.getRowIndexAtPixel(y);
        return overIndex >= 0 ? rowModel.getRow(overIndex) : void 0;
    }
    rowDragEvent(type, draggingEvent) {
        const beans = this.beans;
        const { dragItem: dragItem, dropTarget: rowsDrop, event: event, vDirection: vDirection } = draggingEvent;
        const withRowsDrop = rowsDrop?.rootNode === beans.rowModel.rootNode;
        const y = withRowsDrop ? rowsDrop.y : $437b23f6a393c3bf$export$530c24bdfacb8cd1(beans, draggingEvent).y;
        const overNode = withRowsDrop ? rowsDrop.overNode : this.getOverNode(y);
        const overIndex = withRowsDrop ? rowsDrop.overIndex : overNode?.rowIndex ?? -1;
        return {
            api: beans.gridApi,
            context: beans.gridOptions.context,
            type: type,
            event: event,
            node: dragItem.rowNode,
            nodes: dragItem.rowNodes,
            overIndex: overIndex,
            overNode: overNode,
            y: y,
            vDirection: vDirection,
            rowsDrop: rowsDrop
        };
    }
    dispatchGridEvent(type, draggingEvent) {
        const event = this.rowDragEvent(type, draggingEvent);
        this.eventSvc.dispatchEvent(event);
    }
    onDragLeave(draggingEvent) {
        this.dispatchGridEvent("rowDragLeave", draggingEvent);
        this.stopDragging(draggingEvent);
    }
    onDragStop(draggingEvent) {
        const rowsDrop = this.makeRowsDrop(this.lastDraggingEvent, draggingEvent, false, true);
        this.dispatchGridEvent("rowDragEnd", draggingEvent);
        if (rowsDrop?.allowed && rowsDrop.rowDragManaged && (rowsDrop.suppressMoveWhenRowDragging || !rowsDrop.sameGrid || this.nudger?.autoScroll.scrolling)) this.dropRows(rowsDrop);
        this.stopDragging(draggingEvent);
    }
    onDragCancel(draggingEvent) {
        this.dispatchGridEvent("rowDragCancel", draggingEvent);
        this.stopDragging(draggingEvent);
    }
    stopDragging(draggingEvent) {
        this.nudger?.clear();
        this.beans.rowDropHighlightSvc?.fromDrag(null);
        $437b23f6a393c3bf$var$setRowNodesDragging(draggingEvent.dragItem.rowNodes, false);
    }
    /** Drag and drop. Returns false if at least a row was moved, otherwise true */ dropRows(rowsDrop) {
        return rowsDrop.sameGrid ? this.csrmMoveRows(rowsDrop) : this.csrmAddRows(rowsDrop);
    }
    csrmAddRows({ position: position, target: target, rows: rows }) {
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const clientSideRowModel = this.beans.rowModel;
        const add = rows.filter(({ data: data, rowPinned: rowPinned })=>!clientSideRowModel.getRowNode(getRowIdFunc?.({
                data: data,
                level: 0,
                rowPinned: rowPinned
            }) ?? data.id)).map(({ data: data })=>data);
        if (add.length === 0) return false;
        const addIndex = target ? $437b23f6a393c3bf$var$getLeafSourceRowIndex(target) + (position === "above" ? 0 : 1) : void 0;
        clientSideRowModel.updateRowData({
            add: add,
            addIndex: addIndex
        });
        return true;
    }
    filterRows({ newParent: newParent, rows: rows }) {
        let filtered;
        for(let i = 0, len = rows.length; i < len; ++i){
            let valid = true;
            const row = rows[i];
            if (!row || row.footer || row.rowTop === null && row !== this.beans.rowModel.getRowNode(row.id) || // This row cannot be dragged, not in allLeafChildren and not a filler
            newParent && row.parent !== newParent && $437b23f6a393c3bf$var$wouldFormCycle(row, newParent) || // Cannot move to a parent that would create a cycle
            !$437b23f6a393c3bf$var$getLeafRow(row)) valid = false;
            if (valid) filtered?.push(row);
            else filtered ?? (filtered = rows.slice(0, i));
        }
        return filtered ?? rows;
    }
    csrmMoveRows({ position: position, target: target, rows: rows, newParent: newParent, rootNode: rootNode }) {
        let changed = false;
        const leafs = /* @__PURE__ */ new Set();
        for (const row of rows){
            if (newParent && row.parent !== newParent) {
                row.treeParent = newParent;
                changed = true;
            }
            const leafRow = $437b23f6a393c3bf$var$getLeafRow(row);
            if (leafRow) leafs.add(leafRow);
        }
        if (!changed && leafs.size === 0) return false;
        const focusSvc = this.beans.focusSvc;
        const cellPosition = focusSvc.getFocusedCell();
        const cellCtrl = cellPosition && $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cellPosition);
        if (leafs.size && this.reorderLeafChildren(leafs, ...this.getMoveRowsBounds(leafs, target, position === "above"))) changed = true;
        if (!changed) return false;
        const clientSideRowModel = this.beans.rowModel;
        const changedRowNodes = new $437b23f6a393c3bf$var$ChangedRowNodes();
        changedRowNodes.reordered = true;
        clientSideRowModel.refreshModel({
            step: "group",
            keepRenderedRows: true,
            animate: !this.gos.get("suppressAnimationFrame"),
            changedPath: new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, rootNode),
            changedRowNodes: changedRowNodes
        });
        if (cellCtrl) cellCtrl.focusCell();
        else focusSvc.clearFocusedCell();
        return true;
    }
    /** For reorderLeafChildren, returns min index of the rows to move, the target index and the max index of the rows to move. */ getMoveRowsBounds(leafs, target, above) {
        const totalRows = this.beans.rowModel.rootNode?._leafs?.length ?? 0;
        let targetPositionIdx = target ? $437b23f6a393c3bf$var$getLeafSourceRowIndex(target) : -1;
        if (targetPositionIdx < 0 || targetPositionIdx >= totalRows) targetPositionIdx = totalRows;
        else if (!above) ++targetPositionIdx;
        let firstAffectedLeafIdx = targetPositionIdx;
        let lastAffectedLeafIndex = Math.min(targetPositionIdx, totalRows - 1);
        for (const row of leafs){
            const sourceRowIndex = row.sourceRowIndex;
            if (sourceRowIndex < firstAffectedLeafIdx) firstAffectedLeafIdx = sourceRowIndex;
            if (sourceRowIndex > lastAffectedLeafIndex) lastAffectedLeafIndex = sourceRowIndex;
        }
        return [
            firstAffectedLeafIdx,
            targetPositionIdx,
            lastAffectedLeafIndex
        ];
    }
    /** Reorders the children of the root node, so that the rows to move are in the correct order.
   * @param leafs The valid set of rows to move, as returned by getValidRowsToMove
   * @param firstAffectedLeafIdx The first index of the rows to move
   * @param targetPositionIdx The target index, where the rows will be moved
   * @param lastAffectedLeafIndex The last index of the rows to move
   * @returns True if the order of the rows changed, false otherwise
   */ reorderLeafChildren(leafs, firstAffectedLeafIdx, targetPositionIdx, lastAffectedLeafIndex) {
        let orderChanged = false;
        const allLeafs = this.beans.rowModel.rootNode?._leafs;
        if (!leafs.size || !allLeafs) return false;
        let writeIdxLeft = firstAffectedLeafIdx;
        for(let readIdx = firstAffectedLeafIdx; readIdx < targetPositionIdx; ++readIdx){
            const row = allLeafs[readIdx];
            if (!leafs.has(row)) {
                if (row.sourceRowIndex !== writeIdxLeft) {
                    row.sourceRowIndex = writeIdxLeft;
                    allLeafs[writeIdxLeft] = row;
                    orderChanged = true;
                }
                ++writeIdxLeft;
            }
        }
        let writeIdxRight = lastAffectedLeafIndex;
        for(let readIdx = lastAffectedLeafIndex; readIdx >= targetPositionIdx; --readIdx){
            const row = allLeafs[readIdx];
            if (!leafs.has(row)) {
                if (row.sourceRowIndex !== writeIdxRight) {
                    row.sourceRowIndex = writeIdxRight;
                    allLeafs[writeIdxRight] = row;
                    orderChanged = true;
                }
                --writeIdxRight;
            }
        }
        for (const row of leafs){
            if (row.sourceRowIndex !== writeIdxLeft) {
                row.sourceRowIndex = writeIdxLeft;
                allLeafs[writeIdxLeft] = row;
                orderChanged = true;
            }
            ++writeIdxLeft;
        }
        return orderChanged;
    }
};
var $437b23f6a393c3bf$var$getPrevOrNext = (rowModel, direction, initial)=>{
    if (initial) {
        const rowCount = rowModel.getRowCount();
        let rowIndex = initial.rowIndex + direction;
        while(rowIndex >= 0 && rowIndex < rowCount){
            const row = rowModel.getRow(rowIndex);
            if (!row || !row.footer && !row.detail) return row;
            rowIndex += direction;
        }
    }
    return void 0;
};
var $437b23f6a393c3bf$var$wouldFormCycle = (row, newParent)=>{
    let parent = newParent;
    while(parent){
        if (parent === row) return true;
        parent = parent.parent;
    }
    return false;
};
var $437b23f6a393c3bf$var$rowsHaveSameParent = (rows, newParent)=>{
    for(let i = 0, len = rows.length; i < len; ++i){
        if (rows[i].parent !== newParent) return false;
    }
    return true;
};
var $437b23f6a393c3bf$var$getLeafSourceRowIndex = (row)=>{
    const leaf = $437b23f6a393c3bf$var$getLeafRow(row);
    return leaf !== void 0 ? leaf.sourceRowIndex : -1;
};
var $437b23f6a393c3bf$var$getLeafRow = (row)=>row.data ? row : $437b23f6a393c3bf$export$d3815c2420e77efc(row.childrenAfterGroup);
var $437b23f6a393c3bf$var$rowsDropChanged = (a, b)=>a !== b && (!a || a.sameGrid !== b.sameGrid || a.allowed !== b.allowed || a.position !== b.position || a.target !== b.target || a.source !== b.source || a.newParent !== b.newParent || !$437b23f6a393c3bf$export$893967cdb9833fdd(a.rows, b.rows));
var $437b23f6a393c3bf$var$compareRowIndex = ({ rowIndex: a }, { rowIndex: b })=>a !== null && b !== null ? a - b : 0;
var $437b23f6a393c3bf$var$setRowNodesDragging = (rowNodes, dragging)=>{
    for(let i = 0, len = rowNodes?.length || 0; i < len; ++i){
        const rowNode = rowNodes[i];
        if (rowNode.dragging !== dragging) {
            rowNode.dragging = dragging;
            rowNode.dispatchRowEvent("draggingChanged");
        }
    }
};
var $437b23f6a393c3bf$var$deltaDraggingTarget = (rowModel, rowsDrop)=>{
    let bestTarget = null;
    let current = rowsDrop.target;
    if (current && rowsDrop.rows.indexOf(current) < 0) return null;
    const source = rowsDrop.source;
    if (!current || !source) return null;
    let count = current.rowIndex - source.rowIndex;
    const increment = count < 0 ? -1 : 1;
    count = rowsDrop.suppressMoveWhenRowDragging ? Math.abs(count) : 1;
    const rowsSet = new Set(rowsDrop.rows);
    do {
        const candidate = $437b23f6a393c3bf$var$getPrevOrNext(rowModel, increment, current);
        if (!candidate) break;
        if (!rowsSet.has(candidate)) {
            bestTarget = candidate;
            --count;
        }
        current = candidate;
    }while (count > 0);
    return bestTarget;
};
// packages/ag-grid-community/src/dragAndDrop/rowDragService.ts
var $437b23f6a393c3bf$var$RowDragService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowDragSvc";
    }
    setupRowDrag(element, ctrl) {
        const rowDragFeature = ctrl.createManagedBean(new $437b23f6a393c3bf$var$RowDragFeature(element));
        const dragAndDrop = this.beans.dragAndDrop;
        dragAndDrop.addDropTarget(rowDragFeature);
        ctrl.addDestroyFunc(()=>dragAndDrop.removeDropTarget(rowDragFeature));
        this.rowDragFeature = rowDragFeature;
    }
    createRowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels, alwaysVisible) {
        return new $437b23f6a393c3bf$var$RowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels, alwaysVisible);
    }
    createRowDragCompForRow(rowNode, element) {
        if ($437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos)) return void 0;
        const translate = this.getLocaleTextFunc();
        return this.createRowDragComp(()=>`1 ${translate("rowDragRow", "row")}`, rowNode, void 0, element, void 0, true);
    }
    createRowDragCompForCell(rowNode, column, cellValueFn, element, dragStartPixels, alwaysVisible) {
        const gos = this.gos;
        if (gos.get("rowDragManaged")) {
            if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos) || gos.get("pagination")) return void 0;
        }
        const rowDragComp = this.createRowDragComp(cellValueFn, rowNode, column, element, dragStartPixels, alwaysVisible);
        return rowDragComp;
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDropHighlightService.ts
var $437b23f6a393c3bf$var$RowDropHighlightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowDropHighlightSvc";
        this.uiLevel = 0;
        this.dragging = false;
        this.row = null;
        this.position = "none";
    }
    postConstruct() {
        this.addManagedEventListeners({
            modelUpdated: this.onModelUpdated.bind(this)
        });
    }
    onModelUpdated() {
        const row = this.row;
        const oldDragging = this.dragging;
        if (!row || row?.rowIndex === null || this.position === "none") this.clear();
        else this.set(row, this.position);
        this.dragging = oldDragging;
    }
    destroy() {
        this.clear();
        super.destroy();
    }
    clear() {
        const last = this.row;
        this.dragging = false;
        if (last) {
            this.uiLevel = 0;
            this.position = "none";
            this.row = null;
            last.dispatchRowEvent("rowHighlightChanged");
        }
    }
    set(row, dropIndicatorPosition) {
        const nodeChanged = row !== this.row;
        const uiLevel = row.uiLevel;
        const highlightChanged = dropIndicatorPosition !== this.position;
        const uiLevelChanged = uiLevel !== this.uiLevel;
        this.dragging = false;
        if (nodeChanged || highlightChanged || uiLevelChanged) {
            if (nodeChanged) this.clear();
            this.uiLevel = uiLevel;
            this.position = dropIndicatorPosition;
            this.row = row;
            row.dispatchRowEvent("rowHighlightChanged");
        }
    }
    fromDrag(draggingEvent) {
        const rowsDrop = draggingEvent?.dropTarget;
        if (rowsDrop) {
            const { highlight: highlight, target: target, position: position } = rowsDrop;
            if (highlight && target && position !== "none") {
                this.set(target, position);
                this.dragging = true;
                return;
            }
        }
        if (this.dragging) this.clear();
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragModule.ts
var $437b23f6a393c3bf$export$e88a21946d283d22 = {
    moduleName: "Drag",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DragService
    ]
};
var $437b23f6a393c3bf$export$b9bac28848e60126 = {
    moduleName: "DragAndDrop",
    version: $437b23f6a393c3bf$var$VERSION,
    dynamicBeans: {
        dndSourceComp: $437b23f6a393c3bf$var$DndSourceComp
    },
    icons: {
        // drag handle used to pick up draggable rows
        rowDrag: "grip"
    }
};
var $437b23f6a393c3bf$export$4ad116d131ade5b4 = {
    moduleName: "SharedDragAndDrop",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DragAndDropService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$e88a21946d283d22
    ],
    userComponents: {
        agDragAndDropImage: $437b23f6a393c3bf$var$DragAndDropImageComponent2
    },
    icons: {
        // shown on drag and drop image component icon while dragging column to the side of the grid to pin
        columnMovePin: "pin",
        // shown on drag and drop image component icon while dragging over part of the page that is not a drop zone
        columnMoveHide: "eye-slash",
        // shown on drag and drop image component icon while dragging columns to reorder
        columnMoveMove: "arrows",
        // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
        columnMoveLeft: "left",
        // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
        columnMoveRight: "right",
        // shown on drag and drop image component icon while dragging over Row Groups drop zone
        columnMoveGroup: "group",
        // shown on drag and drop image component icon while dragging over Values drop zone
        columnMoveValue: "aggregation",
        // shown on drag and drop image component icon while dragging over pivot drop zone
        columnMovePivot: "pivot",
        // shown on drag and drop image component icon while dragging over drop zone that doesn't support it, e.g.
        // string column over aggregation drop zone
        dropNotAllowed: "not-allowed",
        // drag handle used to pick up draggable rows
        rowDrag: "grip"
    }
};
var $437b23f6a393c3bf$export$49c914873cdbe391 = {
    moduleName: "RowDrag",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowDropHighlightService,
        $437b23f6a393c3bf$var$RowDragService
    ],
    apiFunctions: {
        addRowDropZone: $437b23f6a393c3bf$var$addRowDropZone,
        removeRowDropZone: $437b23f6a393c3bf$var$removeRowDropZone,
        getRowDropZoneParams: $437b23f6a393c3bf$var$getRowDropZoneParams,
        getRowDropPositionIndicator: $437b23f6a393c3bf$var$getRowDropPositionIndicator,
        setRowDropPositionIndicator: $437b23f6a393c3bf$var$setRowDropPositionIndicator
    },
    dependsOn: [
        $437b23f6a393c3bf$export$4ad116d131ade5b4
    ]
};
var $437b23f6a393c3bf$export$57b5b4ab4a8a663e = {
    moduleName: "HorizontalResize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$HorizontalResizeService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$e88a21946d283d22
    ]
};
// packages/ag-grid-community/src/columnMove/column-moving.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnMovingCSS = /*css*/ `:where(.ag-ltr) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:left .2s}.ag-header-group-cell{transition:left .2s,width .2s}}:where(.ag-rtl) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:right .2s}.ag-header-group-cell{transition:right .2s,width .2s}}`;
// packages/ag-grid-community/src/columnMove/columnAnimationService.ts
var $437b23f6a393c3bf$var$ColumnAnimationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colAnimation";
        this.executeNextFuncs = [];
        this.executeLaterFuncs = [];
        this.active = false;
        // activeNext starts with active but it is reset earlier after the nextFuncs are cleared
        // to prevent calls made to executeNextVMTurn from queuing functions after executeNextFuncs has already been flushed,
        this.activeNext = false;
        this.suppressAnimation = false;
        this.animationThreadCount = 0;
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>this.gridBodyCtrl = p.gridBodyCtrl);
    }
    isActive() {
        return this.active && !this.suppressAnimation;
    }
    setSuppressAnimation(suppress) {
        this.suppressAnimation = suppress;
    }
    start() {
        if (this.active) return;
        const { gos: gos } = this;
        if (gos.get("suppressColumnMoveAnimation")) return;
        if (gos.get("enableRtl")) return;
        this.ensureAnimationCssClassPresent();
        this.active = true;
        this.activeNext = true;
    }
    finish() {
        if (!this.active) return;
        this.flush(()=>this.activeNext = false, ()=>this.active = false);
    }
    executeNextVMTurn(func) {
        if (this.activeNext) this.executeNextFuncs.push(func);
        else func();
    }
    executeLaterVMTurn(func) {
        if (this.active) this.executeLaterFuncs.push(func);
        else func();
    }
    ensureAnimationCssClassPresent() {
        this.animationThreadCount++;
        const animationThreadCountCopy = this.animationThreadCount;
        const { gridBodyCtrl: gridBodyCtrl } = this;
        gridBodyCtrl.setColumnMovingCss(true);
        this.executeLaterFuncs.push(()=>{
            if (this.animationThreadCount === animationThreadCountCopy) gridBodyCtrl.setColumnMovingCss(false);
        });
    }
    flush(callbackNext, callbackLater) {
        const { executeNextFuncs: executeNextFuncs, executeLaterFuncs: executeLaterFuncs } = this;
        if (executeNextFuncs.length === 0 && executeLaterFuncs.length === 0) {
            callbackNext();
            callbackLater();
            return;
        }
        const runFuncs = (queue)=>{
            while(queue.length){
                const func = queue.pop();
                if (func) func();
            }
        };
        this.beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                callbackNext();
                runFuncs(executeNextFuncs);
            }, 0);
            window.setTimeout(()=>{
                callbackLater();
                runFuncs(executeLaterFuncs);
            }, 200);
        });
    }
};
// packages/ag-grid-community/src/columnMove/columnMoveApi.ts
function $437b23f6a393c3bf$var$moveColumnByIndex(beans, fromIndex, toIndex) {
    beans.colMoves?.moveColumnByIndex(fromIndex, toIndex, "api");
}
function $437b23f6a393c3bf$var$moveColumns(beans, columnsToMoveKeys, toIndex) {
    beans.colMoves?.moveColumns(columnsToMoveKeys, toIndex, "api");
}
// packages/ag-grid-community/src/columnMove/columnDrag/bodyDropPivotTarget.ts
var $437b23f6a393c3bf$var$BodyDropPivotTarget = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.columnsToAggregate = [];
        this.columnsToGroup = [];
        this.columnsToPivot = [];
    }
    /** Callback for when drag enters */ onDragEnter(draggingEvent) {
        this.clearColumnsList();
        if (this.gos.get("functionsReadOnly")) return;
        const dragColumns = draggingEvent.dragItem.columns;
        if (!dragColumns) return;
        for (const column of dragColumns){
            if (!column.isPrimary()) continue;
            if (column.isAnyFunctionActive()) continue;
            if (column.isAllowValue()) this.columnsToAggregate.push(column);
            else if (column.isAllowRowGroup()) this.columnsToGroup.push(column);
            else if (column.isAllowPivot()) this.columnsToPivot.push(column);
        }
    }
    getIconName() {
        const totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
        if (totalColumns > 0) return this.pinned ? "pinned" : "move";
        return null;
    }
    /** Callback for when drag leaves */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragLeave(draggingEvent) {
        this.clearColumnsList();
    }
    clearColumnsList() {
        this.columnsToAggregate.length = 0;
        this.columnsToGroup.length = 0;
        this.columnsToPivot.length = 0;
    }
    /** Callback for when dragging */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragging(draggingEvent) {}
    /** Callback for when drag stops */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragStop(draggingEvent) {
        const { valueColsSvc: valueColsSvc, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = this.beans;
        if (this.columnsToAggregate.length > 0) valueColsSvc?.addColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
        if (this.columnsToGroup.length > 0) rowGroupColsSvc?.addColumns(this.columnsToGroup, "toolPanelDragAndDrop");
        if (this.columnsToPivot.length > 0) pivotColsSvc?.addColumns(this.columnsToPivot, "toolPanelDragAndDrop");
    }
    onDragCancel() {
        this.clearColumnsList();
    }
};
// packages/ag-grid-community/src/columnMove/internalColumnMoveUtils.ts
function $437b23f6a393c3bf$var$sortColsLikeCols(colsList, cols) {
    if (!cols || cols.length <= 1) return;
    const notAllColsPresent = cols.filter((c)=>colsList.indexOf(c) < 0).length > 0;
    if (notAllColsPresent) return;
    cols.sort((a, b)=>{
        const indexA = colsList.indexOf(a);
        const indexB = colsList.indexOf(b);
        return indexA - indexB;
    });
}
function $437b23f6a393c3bf$var$getColsToMove(allMovingColumns) {
    const newCols = [
        ...allMovingColumns
    ];
    for (const col of allMovingColumns){
        let movingGroup = null;
        let parent = col.getParent();
        while(parent != null && parent.getDisplayedLeafColumns().length === 1){
            movingGroup = parent;
            parent = parent.getParent();
        }
        if (movingGroup != null) {
            const isMarryChildren = !!movingGroup.getColGroupDef()?.marryChildren;
            const columnsToMove = isMarryChildren ? // when marry children is true, we also have to move hidden
            // columns within the group, so grab them from the `providedColumnGroup`
            movingGroup.getProvidedColumnGroup().getLeafColumns() : movingGroup.getLeafColumns();
            for (const newCol of columnsToMove)if (!newCols.includes(newCol)) newCols.push(newCol);
        }
    }
    return newCols;
}
function $437b23f6a393c3bf$var$getLowestFragMove(validMoves, allMovingColumnsOrdered, colMoves, visibleCols) {
    const displayedCols = visibleCols.allCols;
    let lowestFragMove = null;
    let targetOrder = null;
    for(let i = 0; i < validMoves.length; i++){
        const move = validMoves[i];
        const order = colMoves.getProposedColumnOrder(allMovingColumnsOrdered, move);
        if (!colMoves.doesOrderPassRules(order)) continue;
        const displayedOrder = order.filter((col)=>displayedCols.includes(col));
        if (targetOrder === null) targetOrder = displayedOrder;
        else if (!$437b23f6a393c3bf$export$893967cdb9833fdd(displayedOrder, targetOrder)) break;
        const fragCount = $437b23f6a393c3bf$var$groupFragCount(order);
        if (lowestFragMove === null || fragCount < lowestFragMove.fragCount) lowestFragMove = {
            move: move,
            fragCount: fragCount
        };
    }
    return lowestFragMove;
}
function $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(params) {
    const { isFromHeader: isFromHeader, fromLeft: fromLeft, xPosition: xPosition, fromEnter: fromEnter, fakeEvent: fakeEvent, pinned: pinned, gos: gos, colModel: colModel, colMoves: colMoves, visibleCols: visibleCols } = params;
    let { allMovingColumns: allMovingColumns } = params;
    if (isFromHeader) allMovingColumns = $437b23f6a393c3bf$var$getColsToMove(allMovingColumns);
    const allMovingColumnsOrdered = allMovingColumns.slice();
    $437b23f6a393c3bf$var$sortColsLikeCols(colModel.getCols(), allMovingColumnsOrdered);
    const validMoves = $437b23f6a393c3bf$var$calculateValidMoves({
        movingCols: allMovingColumnsOrdered,
        draggingRight: fromLeft,
        xPosition: xPosition,
        pinned: pinned,
        gos: gos,
        colModel: colModel,
        visibleCols: visibleCols
    });
    const oldIndex = $437b23f6a393c3bf$var$calculateOldIndex(allMovingColumnsOrdered, colModel);
    if (validMoves.length === 0) return;
    const firstValidMove = validMoves[0];
    const constrainDirection = oldIndex !== null && (isFromHeader || !fromEnter);
    if (constrainDirection && !fakeEvent) {
        if (!fromLeft && firstValidMove >= oldIndex) return;
        if (fromLeft && firstValidMove <= oldIndex) return;
    }
    const lowestFragMove = $437b23f6a393c3bf$var$getLowestFragMove(validMoves, allMovingColumnsOrdered, colMoves, visibleCols);
    if (!lowestFragMove) return;
    const toIndex = lowestFragMove.move;
    if (toIndex > colModel.getCols().length - allMovingColumnsOrdered.length) return;
    return {
        columns: allMovingColumnsOrdered,
        toIndex: toIndex
    };
}
function $437b23f6a393c3bf$var$attemptMoveColumns(params) {
    const { columns: columns, toIndex: toIndex } = $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(params) || {};
    const { finished: finished, colMoves: colMoves } = params;
    if (!columns || toIndex == null) return null;
    colMoves.moveColumns(columns, toIndex, "uiColumnMoved", finished);
    return finished ? null : {
        columns: columns,
        toIndex: toIndex
    };
}
function $437b23f6a393c3bf$var$calculateOldIndex(movingCols, colModel) {
    const gridCols = colModel.getCols();
    const indexes = movingCols.map((col)=>gridCols.indexOf(col)).sort((a, b)=>a - b);
    const firstIndex = indexes[0];
    const lastIndex = $437b23f6a393c3bf$export$236389741107357f(indexes);
    const spread = lastIndex - firstIndex;
    const gapsExist = spread !== indexes.length - 1;
    return gapsExist ? null : firstIndex;
}
function $437b23f6a393c3bf$var$groupFragCount(columns) {
    function parents(col) {
        const result = [];
        let parent = col.getOriginalParent();
        while(parent != null){
            result.push(parent);
            parent = parent.getOriginalParent();
        }
        return result;
    }
    let count = 0;
    for(let i = 0; i < columns.length - 1; i++){
        let a = parents(columns[i]);
        let b = parents(columns[i + 1]);
        [a, b] = a.length > b.length ? [
            a,
            b
        ] : [
            b,
            a
        ];
        for (const parent of a)if (b.indexOf(parent) === -1) count++;
    }
    return count;
}
function $437b23f6a393c3bf$var$getDisplayedColumns(visibleCols, type) {
    switch(type){
        case "left":
            return visibleCols.leftCols;
        case "right":
            return visibleCols.rightCols;
        default:
            return visibleCols.centerCols;
    }
}
function $437b23f6a393c3bf$var$calculateValidMoves(params) {
    const { movingCols: movingCols, draggingRight: draggingRight, xPosition: xPosition, pinned: pinned, gos: gos, colModel: colModel, visibleCols: visibleCols } = params;
    const isMoveBlocked = gos.get("suppressMovableColumns") || movingCols.some((col)=>col.getColDef().suppressMovable);
    if (isMoveBlocked) return [];
    const allDisplayedCols = $437b23f6a393c3bf$var$getDisplayedColumns(visibleCols, pinned);
    const allGridCols = colModel.getCols();
    const movingDisplayedCols = allDisplayedCols.filter((col)=>movingCols.includes(col));
    const otherDisplayedCols = allDisplayedCols.filter((col)=>!movingCols.includes(col));
    const otherGridCols = allGridCols.filter((col)=>!movingCols.includes(col));
    let displayIndex = 0;
    let availableWidth = xPosition;
    if (draggingRight) {
        let widthOfMovingDisplayedCols = 0;
        for (const col of movingDisplayedCols)widthOfMovingDisplayedCols += col.getActualWidth();
        availableWidth -= widthOfMovingDisplayedCols;
    }
    if (availableWidth > 0) {
        for(let i = 0; i < otherDisplayedCols.length; i++){
            const col = otherDisplayedCols[i];
            availableWidth -= col.getActualWidth();
            if (availableWidth < 0) break;
            displayIndex++;
        }
        if (draggingRight) displayIndex++;
    }
    let firstValidMove;
    if (displayIndex > 0) {
        const leftColumn = otherDisplayedCols[displayIndex - 1];
        firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
    } else {
        firstValidMove = otherGridCols.indexOf(otherDisplayedCols[0]);
        if (firstValidMove === -1) firstValidMove = 0;
    }
    const validMoves = [
        firstValidMove
    ];
    const numberComparator = (a, b)=>a - b;
    if (draggingRight) {
        let pointer = firstValidMove + 1;
        const lastIndex = allGridCols.length - 1;
        while(pointer <= lastIndex){
            validMoves.push(pointer);
            pointer++;
        }
        validMoves.sort(numberComparator);
    } else {
        let pointer = firstValidMove;
        const lastIndex = allGridCols.length - 1;
        let displacedCol = allGridCols[pointer];
        while(pointer <= lastIndex && allDisplayedCols.indexOf(displacedCol) < 0){
            pointer++;
            validMoves.push(pointer);
            displacedCol = allGridCols[pointer];
        }
        pointer = firstValidMove - 1;
        const firstDisplayIndex = 0;
        while(pointer >= firstDisplayIndex){
            validMoves.push(pointer);
            pointer--;
        }
        validMoves.sort(numberComparator).reverse();
    }
    return validMoves;
}
function $437b23f6a393c3bf$var$normaliseX(params) {
    const { pinned: pinned, fromKeyboard: fromKeyboard, gos: gos, ctrlsSvc: ctrlsSvc, useHeaderRow: useHeaderRow, skipScrollPadding: skipScrollPadding } = params;
    let eViewport = ctrlsSvc.getHeaderRowContainerCtrl(pinned)?.eViewport;
    let { x: x } = params;
    if (!eViewport) return 0;
    if (fromKeyboard) x -= eViewport.getBoundingClientRect().left;
    if (gos.get("enableRtl")) {
        if (useHeaderRow) eViewport = eViewport.querySelector(".ag-header-row");
        x = eViewport.clientWidth - x;
    }
    if (pinned == null && !skipScrollPadding) x += ctrlsSvc.get("center").getCenterViewportScrollLeft();
    return x;
}
function $437b23f6a393c3bf$var$setColumnsMoving(columns, isMoving) {
    for (const column of columns){
        column.moving = isMoving;
        column.dispatchColEvent("movingChanged", "uiColumnMoved");
    }
}
// packages/ag-grid-community/src/columnMove/columnDrag/moveColumnFeature.ts
var $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD = 7;
var $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH = 100;
var $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE = $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH / 2;
var $437b23f6a393c3bf$var$SCROLL_ACCELERATION_RATE = 5;
var $437b23f6a393c3bf$var$SCROLL_TIME_INTERVAL = 100;
var $437b23f6a393c3bf$var$MoveColumnFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.needToMoveLeft = false;
        this.needToMoveRight = false;
        this.lastMovedInfo = null;
        this.isCenterContainer = !$437b23f6a393c3bf$export$25d27f17d3af40f7(pinned);
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    getIconName() {
        const { pinned: pinned, lastDraggingEvent: lastDraggingEvent } = this;
        const { dragItem: dragItem } = lastDraggingEvent || {};
        const columns = dragItem?.columns ?? [];
        for (const col of columns){
            const colPinned = col.getPinned();
            if (col.getColDef().lockPinned) {
                if (colPinned == pinned) return "move";
                continue;
            }
            const initialPinnedState = dragItem?.containerType;
            if (initialPinnedState === pinned || !pinned) return "move";
            if (pinned && (!colPinned || initialPinnedState !== pinned)) return "pinned";
        }
        return "notAllowed";
    }
    onDragEnter(draggingEvent) {
        const dragItem = draggingEvent.dragItem;
        const columns = dragItem.columns;
        const dragCameFromToolPanel = draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
        if (dragCameFromToolPanel) this.setColumnsVisible(columns, true, "uiColumnDragged");
        else {
            const visibleState = dragItem.visibleState;
            const visibleColumns = (columns || []).filter((column)=>visibleState[column.getId()] && !column.isVisible());
            this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
        }
        if (!this.gos.get("suppressMoveWhenColumnDragging")) this.attemptToPinColumns(columns, this.pinned);
        this.onDragging(draggingEvent, true, true);
    }
    onDragging(draggingEvent = this.lastDraggingEvent, fromEnter = false, fakeEvent = false, finished = false) {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        const isSuppressMoveWhenDragging = gos.get("suppressMoveWhenColumnDragging");
        if (finished && !isSuppressMoveWhenDragging) {
            this.finishColumnMoving();
            return;
        }
        this.lastDraggingEvent = draggingEvent;
        if (!draggingEvent || !finished && $437b23f6a393c3bf$export$672d9e47bc342bac(draggingEvent.hDirection)) return;
        const mouseX = $437b23f6a393c3bf$var$normaliseX({
            x: draggingEvent.x,
            pinned: this.pinned,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
        if (!fromEnter) this.checkCenterForScrolling(mouseX);
        if (isSuppressMoveWhenDragging) this.handleColumnDragWhileSuppressingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished);
        else this.handleColumnDragWhileAllowingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished);
    }
    onDragLeave() {
        this.ensureIntervalCleared();
        this.clearHighlighted();
        this.updateDragItemContainerType();
        this.lastMovedInfo = null;
    }
    onDragStop() {
        this.onDragging(this.lastDraggingEvent, false, true, true);
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    onDragCancel() {
        this.clearHighlighted();
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    setColumnsVisible(columns, visible, source) {
        if (!columns?.length) return;
        const allowedCols = columns.filter((c)=>!c.getColDef().lockVisible);
        if (!allowedCols.length) return;
        this.beans.colModel.setColsVisible(allowedCols, visible, source);
    }
    finishColumnMoving() {
        this.clearHighlighted();
        const lastMovedInfo = this.lastMovedInfo;
        if (!lastMovedInfo) return;
        const { columns: columns, toIndex: toIndex } = lastMovedInfo;
        this.beans.colMoves.moveColumns(columns, toIndex, "uiColumnMoved", true);
    }
    updateDragItemContainerType() {
        const { lastDraggingEvent: lastDraggingEvent } = this;
        if (this.gos.get("suppressMoveWhenColumnDragging") || !lastDraggingEvent) return;
        const dragItem = lastDraggingEvent.dragItem;
        if (!dragItem) return;
        dragItem.containerType = this.pinned;
    }
    handleColumnDragWhileSuppressingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished) {
        const allMovingColumns = this.getAllMovingColumns(draggingEvent, true);
        if (finished) {
            const isAttemptingToPin = this.isAttemptingToPin(allMovingColumns);
            if (isAttemptingToPin) this.attemptToPinColumns(allMovingColumns, void 0, true);
            const { fromLeft: fromLeft, xPosition: xPosition } = this.getNormalisedXPositionInfo(allMovingColumns, isAttemptingToPin) || {};
            if (fromLeft == null || xPosition == null) {
                this.finishColumnMoving();
                return;
            }
            this.moveColumnsAfterHighlight({
                allMovingColumns: allMovingColumns,
                xPosition: xPosition,
                fromEnter: fromEnter,
                fakeEvent: fakeEvent,
                fromLeft: fromLeft
            });
        } else {
            if (!this.beans.dragAndDrop.isDropZoneWithinThisGrid(draggingEvent)) return;
            this.highlightHoveredColumn(allMovingColumns, mouseX);
        }
    }
    handleColumnDragWhileAllowingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished) {
        const allMovingColumns = this.getAllMovingColumns(draggingEvent);
        const fromLeft = this.normaliseDirection(draggingEvent.hDirection) === "right";
        const isFromHeader = draggingEvent.dragSource.type === 1 /* HeaderCell */ ;
        const params = this.getMoveColumnParams({
            allMovingColumns: allMovingColumns,
            isFromHeader: isFromHeader,
            xPosition: mouseX,
            fromLeft: fromLeft,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent
        });
        const lastMovedInfo = $437b23f6a393c3bf$var$attemptMoveColumns({
            ...params,
            finished: finished
        });
        if (lastMovedInfo) this.lastMovedInfo = lastMovedInfo;
    }
    getAllMovingColumns(draggingEvent, useSplit = false) {
        const dragItem = draggingEvent.dragSource.getDragItem();
        let columns = null;
        if (useSplit) {
            columns = dragItem.columnsInSplit;
            if (!columns) columns = dragItem.columns;
        } else columns = dragItem.columns;
        const conditionCallback = (col)=>col.getColDef().lockPinned ? col.getPinned() == this.pinned : true;
        if (!columns) return [];
        return columns.filter(conditionCallback);
    }
    getMoveColumnParams(params) {
        const { allMovingColumns: allMovingColumns, isFromHeader: isFromHeader, xPosition: xPosition, fromLeft: fromLeft, fromEnter: fromEnter, fakeEvent: fakeEvent } = params;
        const { gos: gos, colModel: colModel, colMoves: colMoves, visibleCols: visibleCols } = this.beans;
        return {
            allMovingColumns: allMovingColumns,
            isFromHeader: isFromHeader,
            fromLeft: fromLeft,
            xPosition: xPosition,
            pinned: this.pinned,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent,
            gos: gos,
            colModel: colModel,
            colMoves: colMoves,
            visibleCols: visibleCols
        };
    }
    highlightHoveredColumn(movingColumns, mouseX) {
        const { gos: gos, colModel: colModel } = this.beans;
        const isRtl = gos.get("enableRtl");
        const consideredColumns = colModel.getCols().filter((col)=>col.isVisible() && col.getPinned() === this.pinned);
        let start = null;
        let width = null;
        let targetColumn = null;
        for (const col of consideredColumns){
            width = col.getActualWidth();
            start = this.getNormalisedColumnLeft(col, 0, isRtl);
            if (start != null) {
                const end = start + width;
                if (start <= mouseX && end >= mouseX) {
                    targetColumn = col;
                    break;
                }
            }
            start = null;
            width = null;
        }
        if (!targetColumn) {
            for(let i = consideredColumns.length - 1; i >= 0; i--){
                const currentColumn = consideredColumns[i];
                const parent = consideredColumns[i].getParent();
                if (!parent) {
                    targetColumn = currentColumn;
                    break;
                }
                const leafDisplayedCols = parent?.getDisplayedLeafColumns();
                if (leafDisplayedCols.length) {
                    targetColumn = $437b23f6a393c3bf$export$236389741107357f(leafDisplayedCols);
                    break;
                }
            }
            if (!targetColumn) return;
            start = this.getNormalisedColumnLeft(targetColumn, 0, isRtl);
            width = targetColumn.getActualWidth();
        } else if (movingColumns.indexOf(targetColumn) !== -1) targetColumn = null;
        if (this.lastHighlightedColumn?.column !== targetColumn) this.clearHighlighted();
        if (targetColumn == null || start == null || width == null) return;
        let position;
        if (mouseX - start < width / 2 !== isRtl) position = 0 /* Before */ ;
        else position = 1 /* After */ ;
        $437b23f6a393c3bf$var$setColumnHighlighted(targetColumn, position);
        this.lastHighlightedColumn = {
            column: targetColumn,
            position: position
        };
    }
    getNormalisedXPositionInfo(allMovingColumns, isAttemptingToPin) {
        const { gos: gos, visibleCols: visibleCols } = this.beans;
        const isRtl = gos.get("enableRtl");
        const { firstMovingCol: firstMovingCol, column: column, position: position } = this.getColumnMoveAndTargetInfo(allMovingColumns, isAttemptingToPin, isRtl);
        if (!firstMovingCol || !column || position == null) return;
        const visibleColumns = visibleCols.allCols;
        const movingColIndex = visibleColumns.indexOf(firstMovingCol);
        const targetIndex = visibleColumns.indexOf(column);
        const isBefore = position === 0 /* Before */  !== isRtl;
        const fromLeft = movingColIndex < targetIndex || movingColIndex === targetIndex && !isBefore;
        let diff = 0;
        if (isBefore) {
            if (fromLeft) diff -= 1;
        } else if (!fromLeft) diff += 1;
        if (targetIndex + diff === movingColIndex) return;
        const targetColumn = visibleColumns[targetIndex + diff];
        if (!targetColumn) return;
        const xPosition = this.getNormalisedColumnLeft(targetColumn, 20, isRtl);
        return {
            fromLeft: fromLeft,
            xPosition: xPosition
        };
    }
    getColumnMoveAndTargetInfo(allMovingColumns, isAttemptingToPin, isRtl) {
        const lastHighlightedColumn = this.lastHighlightedColumn || {};
        const { firstMovingCol: firstMovingCol, lastMovingCol: lastMovingCol } = $437b23f6a393c3bf$var$findFirstAndLastMovingColumns(allMovingColumns);
        if (!firstMovingCol || !lastMovingCol || lastHighlightedColumn.column || !isAttemptingToPin) return {
            firstMovingCol: firstMovingCol,
            ...lastHighlightedColumn
        };
        const pinned = this.getPinDirection();
        const isLeft = pinned === "left";
        return {
            firstMovingCol: firstMovingCol,
            position: isLeft ? 1 /* After */  : 0 /* Before */ ,
            column: isLeft !== isRtl ? firstMovingCol : lastMovingCol
        };
    }
    normaliseDirection(hDirection) {
        if (this.gos.get("enableRtl")) switch(hDirection){
            case "left":
                return "right";
            case "right":
                return "left";
        }
        return hDirection;
    }
    getNormalisedColumnLeft(col, padding, isRtl) {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        const left = col.getLeft();
        if (left == null) return null;
        const width = col.getActualWidth();
        return $437b23f6a393c3bf$var$normaliseX({
            x: isRtl ? left + width - padding : left + padding,
            pinned: col.getPinned(),
            useHeaderRow: isRtl,
            skipScrollPadding: true,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
    }
    isAttemptingToPin(columns) {
        const isMovingHorizontally = this.needToMoveLeft || this.needToMoveRight;
        const isFailedMoreThanThreshold = this.failedMoveAttempts > $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD;
        return isMovingHorizontally && isFailedMoreThanThreshold || columns.some((col)=>col.getPinned() !== this.pinned);
    }
    moveColumnsAfterHighlight(params) {
        const { allMovingColumns: allMovingColumns, xPosition: xPosition, fromEnter: fromEnter, fakeEvent: fakeEvent, fromLeft: fromLeft } = params;
        const columnMoveParams = this.getMoveColumnParams({
            allMovingColumns: allMovingColumns,
            isFromHeader: true,
            xPosition: xPosition,
            fromLeft: fromLeft,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent
        });
        const { columns: columns, toIndex: toIndex } = $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(columnMoveParams) || {};
        if (columns && toIndex != null) this.lastMovedInfo = {
            columns: columns,
            toIndex: toIndex
        };
        this.finishColumnMoving();
    }
    clearHighlighted() {
        const { lastHighlightedColumn: lastHighlightedColumn } = this;
        if (!lastHighlightedColumn) return;
        $437b23f6a393c3bf$var$setColumnHighlighted(lastHighlightedColumn.column, null);
        this.lastHighlightedColumn = null;
    }
    checkCenterForScrolling(xAdjustedForScroll) {
        if (!this.isCenterContainer) return;
        const centerCtrl = this.beans.ctrlsSvc.get("center");
        const firstVisiblePixel = centerCtrl.getCenterViewportScrollLeft();
        const lastVisiblePixel = firstVisiblePixel + centerCtrl.getCenterWidth();
        let needToMoveRight;
        let needToMoveLeft;
        if (this.gos.get("enableRtl")) {
            needToMoveRight = xAdjustedForScroll < firstVisiblePixel + $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
            needToMoveLeft = xAdjustedForScroll > lastVisiblePixel - $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
        } else {
            needToMoveLeft = xAdjustedForScroll < firstVisiblePixel + $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
            needToMoveRight = xAdjustedForScroll > lastVisiblePixel - $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
        }
        this.needToMoveRight = needToMoveRight;
        this.needToMoveLeft = needToMoveLeft;
        if (needToMoveLeft || needToMoveRight) this.ensureIntervalStarted();
        else this.ensureIntervalCleared();
    }
    ensureIntervalStarted() {
        if (this.movingIntervalId) return;
        this.intervalCount = 0;
        this.failedMoveAttempts = 0;
        this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), $437b23f6a393c3bf$var$SCROLL_TIME_INTERVAL);
        this.beans.dragAndDrop.setDragImageCompIcon(this.needToMoveLeft ? "left" : "right", true);
    }
    ensureIntervalCleared() {
        if (!this.movingIntervalId) return;
        window.clearInterval(this.movingIntervalId);
        this.movingIntervalId = null;
        this.failedMoveAttempts = 0;
        this.beans.dragAndDrop.setDragImageCompIcon(this.getIconName());
    }
    moveInterval() {
        let pixelsToMove;
        this.intervalCount++;
        pixelsToMove = 10 + this.intervalCount * $437b23f6a393c3bf$var$SCROLL_ACCELERATION_RATE;
        if (pixelsToMove > $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH) pixelsToMove = $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH;
        let pixelsMoved = null;
        const scrollFeature = this.gridBodyCon.scrollFeature;
        if (this.needToMoveLeft) pixelsMoved = scrollFeature.scrollHorizontally(-pixelsToMove);
        else if (this.needToMoveRight) pixelsMoved = scrollFeature.scrollHorizontally(pixelsToMove);
        if (pixelsMoved !== 0) {
            this.onDragging(this.lastDraggingEvent);
            this.failedMoveAttempts = 0;
        } else {
            this.failedMoveAttempts++;
            const { pinnedCols: pinnedCols, dragAndDrop: dragAndDrop, gos: gos } = this.beans;
            if (this.failedMoveAttempts <= $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD + 1 || !pinnedCols) return;
            dragAndDrop.setDragImageCompIcon("pinned");
            if (!gos.get("suppressMoveWhenColumnDragging")) {
                const columns = this.lastDraggingEvent?.dragItem.columns;
                this.attemptToPinColumns(columns, void 0, true);
            }
        }
    }
    getPinDirection() {
        if (this.needToMoveLeft || this.pinned === "left") return "left";
        if (this.needToMoveRight || this.pinned === "right") return "right";
    }
    attemptToPinColumns(columns, pinned, fromMoving = false) {
        const allowedCols = (columns || []).filter((c)=>!c.getColDef().lockPinned);
        if (!allowedCols.length) return 0;
        if (fromMoving) pinned = this.getPinDirection();
        const { pinnedCols: pinnedCols, dragAndDrop: dragAndDrop } = this.beans;
        pinnedCols?.setColsPinned(allowedCols, pinned, "uiColumnDragged");
        if (fromMoving) dragAndDrop.nudge();
        return allowedCols.length;
    }
    destroy() {
        super.destroy();
        this.lastDraggingEvent = null;
        this.clearHighlighted();
        this.lastMovedInfo = null;
    }
};
function $437b23f6a393c3bf$var$setColumnHighlighted(column, highlighted) {
    if (column.highlighted === highlighted) return;
    column.highlighted = highlighted;
    column.dispatchColEvent("headerHighlightChanged", "uiColumnMoved");
}
function $437b23f6a393c3bf$var$findFirstAndLastMovingColumns(allMovingColumns) {
    const moveLen = allMovingColumns.length;
    let firstMovingCol;
    let lastMovingCol;
    for(let i = 0; i < moveLen; i++){
        if (!firstMovingCol) {
            const leftCol = allMovingColumns[i];
            if (leftCol.getLeft() != null) firstMovingCol = leftCol;
        }
        if (!lastMovingCol) {
            const rightCol = allMovingColumns[moveLen - 1 - i];
            if (rightCol.getLeft() != null) lastMovingCol = rightCol;
        }
        if (firstMovingCol && lastMovingCol) break;
    }
    return {
        firstMovingCol: firstMovingCol,
        lastMovingCol: lastMovingCol
    };
}
// packages/ag-grid-community/src/columnMove/columnDrag/bodyDropTarget.ts
var $437b23f6a393c3bf$var$BodyDropTarget = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned, eContainer){
        super();
        this.pinned = pinned;
        this.eContainer = eContainer;
    }
    postConstruct() {
        const { ctrlsSvc: ctrlsSvc, dragAndDrop: dragAndDrop } = this.beans;
        const pinned = this.pinned;
        ctrlsSvc.whenReady(this, (p)=>{
            let eSecondaryContainers;
            const eBodyViewport = p.gridBodyCtrl.eBodyViewport;
            switch(pinned){
                case "left":
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.left.eContainer
                        ],
                        [
                            p.bottomLeft.eContainer
                        ],
                        [
                            p.topLeft.eContainer
                        ]
                    ];
                    break;
                case "right":
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.right.eContainer
                        ],
                        [
                            p.bottomRight.eContainer
                        ],
                        [
                            p.topRight.eContainer
                        ]
                    ];
                    break;
                default:
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.center.eViewport
                        ],
                        [
                            p.bottomCenter.eViewport
                        ],
                        [
                            p.topCenter.eViewport
                        ]
                    ];
                    break;
            }
            this.eSecondaryContainers = eSecondaryContainers;
        });
        this.moveColumnFeature = this.createManagedBean(new $437b23f6a393c3bf$var$MoveColumnFeature(pinned));
        this.bodyDropPivotTarget = this.createManagedBean(new $437b23f6a393c3bf$var$BodyDropPivotTarget(pinned));
        dragAndDrop.addDropTarget(this);
        this.addDestroyFunc(()=>dragAndDrop.removeDropTarget(this));
    }
    isInterestedIn(type) {
        return type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */  && this.gos.get("allowDragFromColumnsToolPanel");
    }
    getSecondaryContainers() {
        return this.eSecondaryContainers;
    }
    getContainer() {
        return this.eContainer;
    }
    getIconName() {
        return this.currentDropListener.getIconName();
    }
    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
    // dropped into the grid's body.
    isDropColumnInPivotMode(draggingEvent) {
        return this.beans.colModel.isPivotMode() && draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
    }
    onDragEnter(draggingEvent) {
        this.currentDropListener = this.isDropColumnInPivotMode(draggingEvent) ? this.bodyDropPivotTarget : this.moveColumnFeature;
        this.currentDropListener.onDragEnter(draggingEvent);
    }
    onDragLeave(params) {
        this.currentDropListener.onDragLeave(params);
    }
    onDragging(params) {
        this.currentDropListener.onDragging(params);
    }
    onDragStop(params) {
        this.currentDropListener.onDragStop(params);
    }
    onDragCancel() {
        this.currentDropListener.onDragCancel();
    }
};
// packages/ag-grid-community/src/columnMove/columnMoveService.ts
var $437b23f6a393c3bf$var$ColumnMoveService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colMoves";
    }
    moveColumnByIndex(fromIndex, toIndex, source) {
        const gridColumns = this.beans.colModel.getCols();
        if (!gridColumns) return;
        const column = gridColumns[fromIndex];
        this.moveColumns([
            column
        ], toIndex, source);
    }
    moveColumns(columnsToMoveKeys, toIndex, source, finished = true) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const gridColumns = colModel.getCols();
        if (!gridColumns) return;
        if (toIndex > gridColumns.length - columnsToMoveKeys.length) {
            $437b23f6a393c3bf$export$545083624300f13d(30, {
                toIndex: toIndex
            });
            return;
        }
        colAnimation?.start();
        const movedColumns = colModel.getColsForKeys(columnsToMoveKeys);
        if (this.doesMovePassRules(movedColumns, toIndex)) {
            $437b23f6a393c3bf$var$_moveInArray(colModel.getCols(), movedColumns, toIndex);
            visibleCols.refresh(source);
            eventSvc.dispatchEvent({
                type: "columnMoved",
                columns: movedColumns,
                column: movedColumns.length === 1 ? movedColumns[0] : null,
                toIndex: toIndex,
                finished: finished,
                source: source
            });
        }
        colAnimation?.finish();
    }
    doesMovePassRules(columnsToMove, toIndex) {
        const proposedColumnOrder = this.getProposedColumnOrder(columnsToMove, toIndex);
        return this.doesOrderPassRules(proposedColumnOrder);
    }
    doesOrderPassRules(gridOrder) {
        const { colModel: colModel, gos: gos } = this.beans;
        if (!$437b23f6a393c3bf$var$doesMovePassMarryChildren(gridOrder, colModel.getColTree())) return false;
        const doesMovePassLockedPositions = (proposedColumnOrder)=>{
            const lockPositionToPlacement = (position)=>{
                if (!position) return 0 /* NONE */ ;
                return position === "left" || position === true ? -1 /* LEFT */  : 1 /* RIGHT */ ;
            };
            const isRtl = gos.get("enableRtl");
            let lastPlacement = isRtl ? 1 /* RIGHT */  : -1 /* LEFT */ ;
            let rulePassed = true;
            for (const col of proposedColumnOrder){
                const placement = lockPositionToPlacement(col.getColDef().lockPosition);
                if (isRtl) {
                    if (placement > lastPlacement) rulePassed = false;
                } else if (placement < lastPlacement) rulePassed = false;
                lastPlacement = placement;
            }
            return rulePassed;
        };
        if (!doesMovePassLockedPositions(gridOrder)) return false;
        return true;
    }
    getProposedColumnOrder(columnsToMove, toIndex) {
        const gridColumns = this.beans.colModel.getCols();
        const proposedColumnOrder = gridColumns.slice();
        $437b23f6a393c3bf$var$_moveInArray(proposedColumnOrder, columnsToMove, toIndex);
        return proposedColumnOrder;
    }
    createBodyDropTarget(pinned, dropContainer) {
        return new $437b23f6a393c3bf$var$BodyDropTarget(pinned, dropContainer);
    }
    moveHeader(hDirection, eGui, column, pinned, bean) {
        const { ctrlsSvc: ctrlsSvc, gos: gos, colModel: colModel, visibleCols: visibleCols, focusSvc: focusSvc } = this.beans;
        const rect = eGui.getBoundingClientRect();
        const left = rect.left;
        const isGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(column);
        const width = isGroup ? rect.width : column.getActualWidth();
        const isLeft = hDirection === "left" !== gos.get("enableRtl");
        const xPosition = $437b23f6a393c3bf$var$normaliseX({
            x: isLeft ? left - 20 : left + width + 20,
            pinned: pinned,
            fromKeyboard: true,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
        const headerPosition = focusSvc.focusedHeader;
        $437b23f6a393c3bf$var$attemptMoveColumns({
            allMovingColumns: isGroup ? column.getLeafColumns() : [
                column
            ],
            isFromHeader: true,
            fromLeft: hDirection === "right",
            xPosition: xPosition,
            pinned: pinned,
            fromEnter: false,
            fakeEvent: false,
            gos: gos,
            colModel: colModel,
            colMoves: this,
            visibleCols: visibleCols,
            finished: true
        });
        let targetColumn;
        if (isGroup) {
            const displayedLeafColumns = column.getDisplayedLeafColumns();
            targetColumn = isLeft ? displayedLeafColumns[0] : $437b23f6a393c3bf$export$236389741107357f(displayedLeafColumns);
        } else targetColumn = column;
        ctrlsSvc.getScrollFeature().ensureColumnVisible(targetColumn, "auto");
        if ((!bean.isAlive() || gos.get("ensureDomOrder")) && headerPosition) {
            let restoreFocusColumn;
            if (isGroup) {
                const groupId = column.getGroupId();
                const leafCols = column.getLeafColumns();
                if (!leafCols.length) return;
                const parent = leafCols[0].getParent();
                if (!parent) return;
                restoreFocusColumn = $437b23f6a393c3bf$var$findGroupWidthId(parent, groupId);
            } else restoreFocusColumn = column;
            if (restoreFocusColumn) focusSvc.focusHeaderPosition({
                headerPosition: {
                    ...headerPosition,
                    column: restoreFocusColumn
                }
            });
        }
    }
    setDragSourceForHeader(eSource, column, displayName) {
        const { gos: gos, colModel: colModel, dragAndDrop: dragAndDrop, visibleCols: visibleCols } = this.beans;
        let hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
        const isGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(column);
        const columns = isGroup ? column.getProvidedColumnGroup().getLeafColumns() : [
            column
        ];
        const getDragItem = isGroup ? ()=>$437b23f6a393c3bf$var$createDragItemForGroup(column, visibleCols.allCols) : ()=>$437b23f6a393c3bf$var$createDragItem(column);
        const dragSource = {
            type: 1 /* HeaderCell */ ,
            eElement: eSource,
            getDefaultIconName: ()=>hideColumnOnExit ? "hide" : "notAllowed",
            getDragItem: getDragItem,
            dragItemName: displayName,
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                $437b23f6a393c3bf$var$setColumnsMoving(columns, true);
            },
            onDragStopped: ()=>$437b23f6a393c3bf$var$setColumnsMoving(columns, false),
            onDragCancelled: ()=>$437b23f6a393c3bf$var$setColumnsMoving(columns, false),
            onGridEnter: (dragItem)=>{
                if (hideColumnOnExit) {
                    const { columns: columns2 = [], visibleState: visibleState } = dragItem ?? {};
                    const hasVisibleState = isGroup ? (col)=>!visibleState || visibleState[col.getColId()] : ()=>true;
                    const unlockedColumns = columns2.filter((col)=>!col.getColDef().lockVisible && hasVisibleState(col));
                    colModel.setColsVisible(unlockedColumns, true, "uiColumnMoved");
                }
            },
            onGridExit: (dragItem)=>{
                if (hideColumnOnExit) {
                    const unlockedColumns = dragItem?.columns?.filter((col)=>!col.getColDef().lockVisible) || [];
                    colModel.setColsVisible(unlockedColumns, false, "uiColumnMoved");
                }
            }
        };
        dragAndDrop.addDragSource(dragSource, true);
        return dragSource;
    }
};
function $437b23f6a393c3bf$var$findGroupWidthId(columnGroup, id) {
    while(columnGroup){
        if (columnGroup.getGroupId() === id) return columnGroup;
        columnGroup = columnGroup.getParent();
    }
    return void 0;
}
function $437b23f6a393c3bf$var$createDragItem(column) {
    const visibleState = {};
    visibleState[column.getId()] = column.isVisible();
    return {
        columns: [
            column
        ],
        visibleState: visibleState,
        containerType: column.pinned
    };
}
function $437b23f6a393c3bf$var$createDragItemForGroup(columnGroup, allCols) {
    const allColumnsOriginalOrder = columnGroup.getProvidedColumnGroup().getLeafColumns();
    const visibleState = {};
    for (const column of allColumnsOriginalOrder)visibleState[column.getId()] = column.isVisible();
    const allColumnsCurrentOrder = [];
    for (const column of allCols)if (allColumnsOriginalOrder.indexOf(column) >= 0) {
        allColumnsCurrentOrder.push(column);
        $437b23f6a393c3bf$export$83a881c8b5120679(allColumnsOriginalOrder, column);
    }
    for (const column of allColumnsOriginalOrder)allColumnsCurrentOrder.push(column);
    const columnsInSplit = [];
    const columnGroupColumns = columnGroup.getLeafColumns();
    for (const col of allColumnsCurrentOrder)if (columnGroupColumns.indexOf(col) !== -1) columnsInSplit.push(col);
    return {
        columns: allColumnsCurrentOrder,
        columnsInSplit: columnsInSplit,
        visibleState: visibleState,
        containerType: columnsInSplit[0]?.pinned
    };
}
// packages/ag-grid-community/src/columnMove/columnMoveModule.ts
var $437b23f6a393c3bf$export$1458fbffed29c925 = {
    moduleName: "ColumnMove",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnMoveService,
        $437b23f6a393c3bf$var$ColumnAnimationService
    ],
    apiFunctions: {
        moveColumnByIndex: $437b23f6a393c3bf$var$moveColumnByIndex,
        moveColumns: $437b23f6a393c3bf$var$moveColumns
    },
    dependsOn: [
        $437b23f6a393c3bf$export$4ad116d131ade5b4
    ],
    css: [
        $437b23f6a393c3bf$var$columnMovingCSS
    ]
};
// packages/ag-grid-community/src/rendering/autoWidthCalculator.ts
var $437b23f6a393c3bf$var$AutoWidthCalculator = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "autoWidthCalc";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowContainerCtrl = p.center;
        });
    }
    // this is the trick: we create a dummy container and clone all the cells
    // into the dummy, then check the dummy's width. then destroy the dummy
    // as we don't need it any more.
    // drawback: only the cells visible on the screen are considered
    getPreferredWidthForColumn(column, skipHeader) {
        const eHeaderCell = this.getHeaderCellForColumn(column);
        if (!eHeaderCell) return -1;
        const elements = this.beans.rowRenderer.getAllCellsNotSpanningForColumn(column);
        if (!skipHeader) elements.push(eHeaderCell);
        return this.getPreferredWidthForElements(elements);
    }
    getPreferredWidthForColumnGroup(columnGroup) {
        const eHeaderCell = this.getHeaderCellForColumn(columnGroup);
        if (!eHeaderCell) return -1;
        return this.getPreferredWidthForElements([
            eHeaderCell
        ]);
    }
    getPreferredWidthForElements(elements, extraPadding) {
        const eDummyContainer = document.createElement("form");
        eDummyContainer.style.position = "fixed";
        const eBodyContainer = this.centerRowContainerCtrl.eContainer;
        for (const el of elements)this.cloneItemIntoDummy(el, eDummyContainer);
        eBodyContainer.appendChild(eDummyContainer);
        const dummyContainerWidth = eDummyContainer.offsetWidth;
        eDummyContainer.remove();
        extraPadding = extraPadding ?? this.gos.get("autoSizePadding");
        return dummyContainerWidth + extraPadding;
    }
    getHeaderCellForColumn(column) {
        let element = null;
        for (const container of this.beans.ctrlsSvc.getHeaderRowContainerCtrls()){
            const res = container.getHtmlElementForColumnHeader(column);
            if (res != null) element = res;
        }
        return element;
    }
    cloneItemIntoDummy(eCell, eDummyContainer) {
        const eCellClone = eCell.cloneNode(true);
        eCellClone.style.width = "";
        eCellClone.style.position = "static";
        eCellClone.style.left = "";
        const eCloneParent = document.createElement("div");
        const eCloneParentClassList = eCloneParent.classList;
        const isHeader = [
            "ag-header-cell",
            "ag-header-group-cell"
        ].some((cls)=>eCellClone.classList.contains(cls));
        if (isHeader) {
            eCloneParentClassList.add("ag-header", "ag-header-row");
            eCloneParent.style.position = "static";
        } else eCloneParentClassList.add("ag-row");
        let pointer = eCell.parentElement;
        while(pointer){
            const isRow = [
                "ag-header-row",
                "ag-row"
            ].some((cls)=>pointer.classList.contains(cls));
            if (isRow) {
                for(let i = 0; i < pointer.classList.length; i++){
                    const item = pointer.classList[i];
                    if (item != "ag-row-position-absolute") eCloneParentClassList.add(item);
                }
                break;
            }
            pointer = pointer.parentElement;
        }
        eCloneParent.appendChild(eCellClone);
        eDummyContainer.appendChild(eCloneParent);
    }
};
// packages/ag-grid-community/src/rendering/autoWidthModule.ts
var $437b23f6a393c3bf$var$AutoWidthModule = {
    moduleName: "AutoWidth",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AutoWidthCalculator
    ]
};
// packages/ag-grid-community/src/columnResize/columnResizeApi.ts
function $437b23f6a393c3bf$var$setColumnWidths(beans, columnWidths, finished = true, source = "api") {
    beans.colResize?.setColumnWidths(columnWidths, false, finished, source);
}
// packages/ag-grid-community/src/columnResize/groupResizeFeature.ts
var $437b23f6a393c3bf$var$GroupResizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, eResize, pinned, columnGroup){
        super();
        this.comp = comp;
        this.eResize = eResize;
        this.pinned = pinned;
        this.columnGroup = columnGroup;
    }
    postConstruct() {
        if (!this.columnGroup.isResizable()) {
            this.comp.setResizableDisplayed(false);
            return;
        }
        const { horizontalResizeSvc: horizontalResizeSvc, gos: gos, colAutosize: colAutosize } = this.beans;
        const finishedWithResizeFunc = horizontalResizeSvc.addResizeBar({
            eResizeBar: this.eResize,
            onResizeStart: this.onResizeStart.bind(this),
            onResizing: this.onResizing.bind(this, false),
            onResizeEnd: this.onResizing.bind(this, true)
        });
        this.addDestroyFunc(finishedWithResizeFunc);
        if (!gos.get("suppressAutoSize") && colAutosize) this.addDestroyFunc(colAutosize.addColumnGroupResize(this.eResize, this.columnGroup, ()=>this.resizeLeafColumnsToFit("uiColumnResized")));
    }
    onResizeStart(shiftKey) {
        const { columnsToResize: columnsToResize, resizeStartWidth: resizeStartWidth, resizeRatios: resizeRatios, groupAfterColumns: groupAfterColumns, groupAfterStartWidth: groupAfterStartWidth, groupAfterRatios: groupAfterRatios } = this.getInitialValues(shiftKey);
        this.resizeCols = columnsToResize;
        this.resizeStartWidth = resizeStartWidth;
        this.resizeRatios = resizeRatios;
        this.resizeTakeFromCols = groupAfterColumns;
        this.resizeTakeFromStartWidth = groupAfterStartWidth;
        this.resizeTakeFromRatios = groupAfterRatios;
        this.toggleColumnResizing(true);
    }
    onResizing(finished, resizeAmount, source = "uiColumnResized") {
        const resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
        const width = this.resizeStartWidth + resizeAmountNormalised;
        this.resizeColumnsFromLocalValues(width, source, finished);
    }
    getInitialValues(shiftKey) {
        const getInitialSizeOfColumns = (columns)=>columns.reduce((totalWidth, column)=>totalWidth + column.getActualWidth(), 0);
        const getSizeRatiosOfColumns = (columns, initialSizeOfColumns)=>columns.map((column)=>column.getActualWidth() / initialSizeOfColumns);
        const columnsToResize = this.getColumnsToResize();
        const resizeStartWidth = getInitialSizeOfColumns(columnsToResize);
        const resizeRatios = getSizeRatiosOfColumns(columnsToResize, resizeStartWidth);
        const columnSizeAndRatios = {
            columnsToResize: columnsToResize,
            resizeStartWidth: resizeStartWidth,
            resizeRatios: resizeRatios
        };
        let groupAfter = null;
        if (shiftKey) groupAfter = this.beans.colGroupSvc?.getGroupAtDirection(this.columnGroup, "After") ?? null;
        if (groupAfter) {
            const takeFromLeafCols = groupAfter.getDisplayedLeafColumns();
            const groupAfterColumns = columnSizeAndRatios.groupAfterColumns = takeFromLeafCols.filter((col)=>col.isResizable());
            const groupAfterStartWidth = columnSizeAndRatios.groupAfterStartWidth = getInitialSizeOfColumns(groupAfterColumns);
            columnSizeAndRatios.groupAfterRatios = getSizeRatiosOfColumns(groupAfterColumns, groupAfterStartWidth);
        } else {
            columnSizeAndRatios.groupAfterColumns = void 0;
            columnSizeAndRatios.groupAfterStartWidth = void 0;
            columnSizeAndRatios.groupAfterRatios = void 0;
        }
        return columnSizeAndRatios;
    }
    resizeLeafColumnsToFit(source) {
        const preferredSize = this.beans.autoWidthCalc.getPreferredWidthForColumnGroup(this.columnGroup);
        const initialValues = this.getInitialValues();
        if (preferredSize > initialValues.resizeStartWidth) this.resizeColumns(initialValues, preferredSize, source, true);
    }
    resizeColumnsFromLocalValues(totalWidth, source, finished = true) {
        if (!this.resizeCols || !this.resizeRatios) return;
        const initialValues = {
            columnsToResize: this.resizeCols,
            resizeStartWidth: this.resizeStartWidth,
            resizeRatios: this.resizeRatios,
            groupAfterColumns: this.resizeTakeFromCols,
            groupAfterStartWidth: this.resizeTakeFromStartWidth,
            groupAfterRatios: this.resizeTakeFromRatios
        };
        this.resizeColumns(initialValues, totalWidth, source, finished);
    }
    resizeColumns(initialValues, totalWidth, source, finished = true) {
        const { columnsToResize: columnsToResize, resizeStartWidth: resizeStartWidth, resizeRatios: resizeRatios, groupAfterColumns: groupAfterColumns, groupAfterStartWidth: groupAfterStartWidth, groupAfterRatios: groupAfterRatios } = initialValues;
        const resizeSets = [];
        resizeSets.push({
            columns: columnsToResize,
            ratios: resizeRatios,
            width: totalWidth
        });
        if (groupAfterColumns) {
            const diff = totalWidth - resizeStartWidth;
            resizeSets.push({
                columns: groupAfterColumns,
                ratios: groupAfterRatios,
                width: groupAfterStartWidth - diff
            });
        }
        this.beans.colResize?.resizeColumnSets({
            resizeSets: resizeSets,
            finished: finished,
            source: source
        });
        if (finished) this.toggleColumnResizing(false);
    }
    toggleColumnResizing(resizing) {
        this.comp.toggleCss("ag-column-resizing", resizing);
    }
    getColumnsToResize() {
        const leafCols = this.columnGroup.getDisplayedLeafColumns();
        return leafCols.filter((col)=>col.isResizable());
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
    normaliseDragChange(dragChange) {
        let result = dragChange;
        if (this.gos.get("enableRtl")) {
            if (this.pinned !== "left") result *= -1;
        } else if (this.pinned === "right") result *= -1;
        return result;
    }
    destroy() {
        super.destroy();
        this.resizeCols = void 0;
        this.resizeRatios = void 0;
        this.resizeTakeFromCols = void 0;
        this.resizeTakeFromRatios = void 0;
    }
};
// packages/ag-grid-community/src/columnResize/resizeFeature.ts
var $437b23f6a393c3bf$var$ResizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned, column, eResize, comp, ctrl){
        super();
        this.pinned = pinned;
        this.column = column;
        this.eResize = eResize;
        this.comp = comp;
        this.ctrl = ctrl;
    }
    postConstruct() {
        const destroyResizeFuncs = [];
        let canResize;
        let canAutosize;
        const addResize = ()=>{
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eResize, canResize);
            if (!canResize) return;
            const { horizontalResizeSvc: horizontalResizeSvc, colAutosize: colAutosize } = this.beans;
            const finishedWithResizeFunc = horizontalResizeSvc.addResizeBar({
                eResizeBar: this.eResize,
                onResizeStart: this.onResizeStart.bind(this),
                onResizing: this.onResizing.bind(this, false),
                onResizeEnd: this.onResizing.bind(this, true)
            });
            destroyResizeFuncs.push(finishedWithResizeFunc);
            if (canAutosize && colAutosize) destroyResizeFuncs.push(colAutosize.addColumnAutosizeListeners(this.eResize, this.column));
        };
        const removeResize = ()=>{
            for (const f of destroyResizeFuncs)f();
            destroyResizeFuncs.length = 0;
        };
        const refresh = ()=>{
            const resize = this.column.isResizable();
            const autoSize = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
            const propertyChange = resize !== canResize || autoSize !== canAutosize;
            if (propertyChange) {
                canResize = resize;
                canAutosize = autoSize;
                removeResize();
                addResize();
            }
        };
        refresh();
        this.addDestroyFunc(removeResize);
        this.ctrl.setRefreshFunction("resize", refresh);
    }
    onResizing(finished, resizeAmount) {
        const { column: key, lastResizeAmount: lastResizeAmount, resizeStartWidth: resizeStartWidth, beans: beans } = this;
        const resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
        const newWidth = resizeStartWidth + resizeAmountNormalised;
        const columnWidths = [
            {
                key: key,
                newWidth: newWidth
            }
        ];
        const { pinnedCols: pinnedCols, ctrlsSvc: ctrlsSvc, colResize: colResize } = beans;
        if (this.column.getPinned()) {
            const leftWidth = pinnedCols?.leftWidth ?? 0;
            const rightWidth = pinnedCols?.rightWidth ?? 0;
            const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
            if (leftWidth + rightWidth + (resizeAmountNormalised - lastResizeAmount) > bodyWidth) return;
        }
        this.lastResizeAmount = resizeAmountNormalised;
        colResize?.setColumnWidths(columnWidths, this.resizeWithShiftKey, finished, "uiColumnResized");
        if (finished) this.toggleColumnResizing(false);
    }
    onResizeStart(shiftKey) {
        this.resizeStartWidth = this.column.getActualWidth();
        this.lastResizeAmount = 0;
        this.resizeWithShiftKey = shiftKey;
        this.toggleColumnResizing(true);
    }
    toggleColumnResizing(resizing) {
        this.column.resizing = resizing;
        this.comp.toggleCss("ag-column-resizing", resizing);
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
    normaliseResizeAmount(dragChange) {
        let result = dragChange;
        const notPinningLeft = this.pinned !== "left";
        const pinningRight = this.pinned === "right";
        if (this.gos.get("enableRtl")) {
            if (notPinningLeft) result *= -1;
        } else if (pinningRight) result *= -1;
        return result;
    }
};
// packages/ag-grid-community/src/columnResize/columnResizeService.ts
var $437b23f6a393c3bf$var$ColumnResizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colResize";
    }
    setColumnWidths(columnWidths, shiftKey, finished, source) {
        const sets = [];
        const { colModel: colModel, gos: gos, visibleCols: visibleCols } = this.beans;
        for (const columnWidth of columnWidths){
            const col = colModel.getColDefCol(columnWidth.key) || colModel.getCol(columnWidth.key);
            if (!col) continue;
            sets.push({
                width: columnWidth.newWidth,
                ratios: [
                    1
                ],
                columns: [
                    col
                ]
            });
            const defaultIsShift = gos.get("colResizeDefault") === "shift";
            if (defaultIsShift) shiftKey = !shiftKey;
            if (shiftKey) {
                const otherCol = visibleCols.getColAfter(col);
                if (!otherCol) continue;
                const widthDiff = col.getActualWidth() - columnWidth.newWidth;
                const otherColWidth = otherCol.getActualWidth() + widthDiff;
                sets.push({
                    width: otherColWidth,
                    ratios: [
                        1
                    ],
                    columns: [
                        otherCol
                    ]
                });
            }
        }
        if (sets.length === 0) return;
        this.resizeColumnSets({
            resizeSets: sets,
            finished: finished,
            source: source
        });
    }
    // method takes sets of columns and resizes them. either all sets will be resized, or nothing
    // be resized. this is used for example when user tries to resize a group and holds shift key,
    // then both the current group (grows), and the adjacent group (shrinks), will get resized,
    // so that's two sets for this method.
    resizeColumnSets(params) {
        const { resizeSets: resizeSets, finished: finished, source: source } = params;
        const passMinMaxCheck = !resizeSets || resizeSets.every((columnResizeSet)=>$437b23f6a393c3bf$var$checkMinAndMaxWidthsForSet(columnResizeSet));
        if (!passMinMaxCheck) {
            if (finished) {
                const columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
                $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, columns, finished, source);
            }
            return;
        }
        const changedCols = [];
        const allResizedCols = [];
        for (const set of resizeSets){
            const { width: width, columns: columns, ratios: ratios } = set;
            const newWidths = {};
            const finishedCols = {};
            for (const col of columns)allResizedCols.push(col);
            let finishedColsGrew = true;
            let loopCount = 0;
            while(finishedColsGrew){
                loopCount++;
                if (loopCount > 1e3) {
                    $437b23f6a393c3bf$export$a20c7248650823a9(31);
                    break;
                }
                finishedColsGrew = false;
                const subsetCols = [];
                let subsetRatioTotal = 0;
                let pixelsToDistribute = width;
                columns.forEach((col, index)=>{
                    const thisColFinished = finishedCols[col.getId()];
                    if (thisColFinished) pixelsToDistribute -= newWidths[col.getId()];
                    else {
                        subsetCols.push(col);
                        const ratioThisCol = ratios[index];
                        subsetRatioTotal += ratioThisCol;
                    }
                });
                const ratioScale = 1 / subsetRatioTotal;
                subsetCols.forEach((col, index)=>{
                    const lastCol = index === subsetCols.length - 1;
                    let colNewWidth;
                    if (lastCol) colNewWidth = pixelsToDistribute;
                    else {
                        colNewWidth = Math.round(ratios[index] * width * ratioScale);
                        pixelsToDistribute -= colNewWidth;
                    }
                    const minWidth = col.getMinWidth();
                    const maxWidth = col.getMaxWidth();
                    if (colNewWidth < minWidth) {
                        colNewWidth = minWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    } else if (maxWidth > 0 && colNewWidth > maxWidth) {
                        colNewWidth = maxWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    }
                    newWidths[col.getId()] = colNewWidth;
                });
            }
            for (const col of columns){
                const newWidth = newWidths[col.getId()];
                const actualWidth = col.getActualWidth();
                if (actualWidth !== newWidth) {
                    col.setActualWidth(newWidth, source);
                    changedCols.push(col);
                }
            }
        }
        const atLeastOneColChanged = changedCols.length > 0;
        let flexedCols = [];
        if (atLeastOneColChanged) {
            const { colFlex: colFlex, visibleCols: visibleCols, colViewport: colViewport } = this.beans;
            flexedCols = colFlex?.refreshFlexedColumns({
                resizingCols: allResizedCols,
                skipSetLeft: true
            }) ?? [];
            visibleCols.setLeftValues(source);
            visibleCols.updateBodyWidths();
            colViewport.checkViewportColumns();
        }
        const colsForEvent = allResizedCols.concat(flexedCols);
        if (atLeastOneColChanged || finished) $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, colsForEvent, finished, source, flexedCols);
    }
    resizeHeader(column, delta, shiftKey) {
        if (!column.isResizable()) return;
        const actualWidth = column.getActualWidth();
        const minWidth = column.getMinWidth();
        const maxWidth = column.getMaxWidth();
        const newWidth = Math.min(Math.max(actualWidth + delta, minWidth), maxWidth);
        this.setColumnWidths([
            {
                key: column,
                newWidth: newWidth
            }
        ], shiftKey, true, "uiColumnResized");
    }
    createResizeFeature(pinned, column, eResize, comp, ctrl) {
        return new $437b23f6a393c3bf$var$ResizeFeature(pinned, column, eResize, comp, ctrl);
    }
    createGroupResizeFeature(comp, eResize, pinned, columnGroup) {
        return new $437b23f6a393c3bf$var$GroupResizeFeature(comp, eResize, pinned, columnGroup);
    }
};
function $437b23f6a393c3bf$var$checkMinAndMaxWidthsForSet(columnResizeSet) {
    const { columns: columns, width: width } = columnResizeSet;
    let minWidthAccumulated = 0;
    let maxWidthAccumulated = 0;
    let maxWidthActive = true;
    for (const col of columns){
        const minWidth = col.getMinWidth();
        minWidthAccumulated += minWidth || 0;
        const maxWidth = col.getMaxWidth();
        if (maxWidth > 0) maxWidthAccumulated += maxWidth;
        else maxWidthActive = false;
    }
    const minWidthPasses = width >= minWidthAccumulated;
    const maxWidthPasses = !maxWidthActive || width <= maxWidthAccumulated;
    return minWidthPasses && maxWidthPasses;
}
// packages/ag-grid-community/src/columnResize/columnResizeModule.ts
var $437b23f6a393c3bf$var$ColumnResizeModule = {
    moduleName: "ColumnResize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnResizeService
    ],
    apiFunctions: {
        setColumnWidths: $437b23f6a393c3bf$var$setColumnWidths
    },
    dependsOn: [
        $437b23f6a393c3bf$export$57b5b4ab4a8a663e,
        $437b23f6a393c3bf$var$AutoWidthModule
    ]
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/groupWidthFeature.ts
var $437b23f6a393c3bf$var$GroupWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, columnGroup){
        super();
        // the children can change, we keep destroy functions related to listening to the children here
        this.removeChildListenersFuncs = [];
        this.columnGroup = columnGroup;
        this.comp = comp;
    }
    postConstruct() {
        this.addListenersToChildrenColumns();
        this.addManagedListeners(this.columnGroup, {
            displayedChildrenChanged: this.onDisplayedChildrenChanged.bind(this)
        });
        this.onWidthChanged();
        this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
    }
    addListenersToChildrenColumns() {
        this.removeListenersOnChildrenColumns();
        const widthChangedListener = this.onWidthChanged.bind(this);
        for (const column of this.columnGroup.getLeafColumns()){
            column.__addEventListener("widthChanged", widthChangedListener);
            column.__addEventListener("visibleChanged", widthChangedListener);
            this.removeChildListenersFuncs.push(()=>{
                column.__removeEventListener("widthChanged", widthChangedListener);
                column.__removeEventListener("visibleChanged", widthChangedListener);
            });
        }
    }
    removeListenersOnChildrenColumns() {
        for (const func of this.removeChildListenersFuncs)func();
        this.removeChildListenersFuncs = [];
    }
    onDisplayedChildrenChanged() {
        this.addListenersToChildrenColumns();
        this.onWidthChanged();
    }
    onWidthChanged() {
        const columnWidth = this.columnGroup.getActualWidth();
        this.comp.setWidth(`${columnWidth}px`);
        this.comp.toggleCss("ag-hidden", columnWidth === 0);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderGroupCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.onSuppressColMoveChange = ()=>{
            if (!this.isAlive() || this.isSuppressMoving()) this.removeDragSource();
            else if (!this.dragSource) this.setDragSource(this.eGui);
        };
    }
    wireComp(comp, eGui, eResize, eHeaderCompWrapper, compBean) {
        const { column: column, beans: beans } = this;
        const { context: context, colNames: colNames, colHover: colHover, rangeSvc: rangeSvc, colResize: colResize } = beans;
        this.comp = comp;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBean);
        this.setGui(eGui, compBean);
        this.displayName = colNames.getDisplayNameForColumnGroup(column, "header");
        this.refreshHeaderStyles();
        this.addClasses();
        this.setupMovingCss(compBean);
        this.setupExpandable(compBean);
        this.setupTooltip();
        this.setupAutoHeight({
            wrapperElement: eHeaderCompWrapper,
            compBean: compBean
        });
        this.setupUserComp();
        this.addHeaderMouseListeners(compBean);
        this.addManagedPropertyListener("groupHeaderHeight", this.refreshMaxHeaderHeight.bind(this));
        this.refreshMaxHeaderHeight();
        const pinned = this.rowCtrl.pinned;
        const leafCols = column.getProvidedColumnGroup().getLeafColumns();
        colHover?.createHoverFeature(compBean, leafCols, eGui);
        rangeSvc?.createRangeHighlightFeature(compBean, column, comp);
        compBean.createManagedBean(new $437b23f6a393c3bf$var$SetLeftFeature(column, eGui, beans));
        compBean.createManagedBean(new $437b23f6a393c3bf$var$GroupWidthFeature(comp, column));
        if (colResize) this.resizeFeature = compBean.createManagedBean(colResize.createGroupResizeFeature(comp, eResize, pinned, column));
        else comp.setResizableDisplayed(false);
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: ()=>void 0,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
        this.addHighlightListeners(compBean, leafCols);
        compBean.addManagedPropertyListener("suppressMovableColumns", this.onSuppressColMoveChange);
        this.addResizeAndMoveKeyboardListeners(compBean);
        compBean.addDestroyFunc(()=>this.clearComponent());
    }
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.getDefinition();
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            columnGroup: column,
            floatingFilter: false
        });
    }
    refreshMaxHeaderHeight() {
        const { gos: gos, comp: comp } = this;
        const groupHeaderHeight = gos.get("groupHeaderHeight");
        if (groupHeaderHeight != null) {
            if (groupHeaderHeight === 0) comp.setHeaderWrapperHidden(true);
            else comp.setHeaderWrapperMaxHeight(groupHeaderHeight);
        } else {
            comp.setHeaderWrapperHidden(false);
            comp.setHeaderWrapperMaxHeight(null);
        }
    }
    addHighlightListeners(compBean, columns) {
        if (!this.beans.gos.get("suppressMoveWhenColumnDragging")) return;
        for (const column of columns)compBean.addManagedListeners(column, {
            headerHighlightChanged: this.onLeafColumnHighlightChanged.bind(this, column)
        });
    }
    onLeafColumnHighlightChanged(column) {
        const displayedColumns = this.column.getDisplayedLeafColumns();
        const isFirst = displayedColumns[0] === column;
        const isLast = $437b23f6a393c3bf$export$236389741107357f(displayedColumns) === column;
        if (!isFirst && !isLast) return;
        const highlighted = column.getHighlighted();
        const isColumnMoveAtThisLevel = !!this.rowCtrl.getHeaderCellCtrls().find((ctrl)=>{
            return ctrl.column.isMoving();
        });
        let beforeOn = false;
        let afterOn = false;
        if (isColumnMoveAtThisLevel) {
            const isRtl = this.beans.gos.get("enableRtl");
            const isHighlightAfter = highlighted === 1 /* After */ ;
            const isHighlightBefore = highlighted === 0 /* Before */ ;
            if (isFirst) {
                if (isRtl) afterOn = isHighlightAfter;
                else beforeOn = isHighlightBefore;
            }
            if (isLast) {
                if (isRtl) beforeOn = isHighlightBefore;
                else afterOn = isHighlightAfter;
            }
        }
        this.comp.toggleCss("ag-header-highlight-before", beforeOn);
        this.comp.toggleCss("ag-header-highlight-after", afterOn);
    }
    resizeHeader(delta, shiftKey) {
        const { resizeFeature: resizeFeature } = this;
        if (!resizeFeature) return;
        const initialValues = resizeFeature.getInitialValues(shiftKey);
        resizeFeature.resizeColumns(initialValues, initialValues.resizeStartWidth + delta, "uiColumnResized", true);
    }
    resizeLeafColumnsToFit(source) {
        this.resizeFeature?.resizeLeafColumnsToFit(source);
    }
    setupUserComp() {
        const { colGroupSvc: colGroupSvc, userCompFactory: userCompFactory, gos: gos, enterpriseMenuFactory: enterpriseMenuFactory } = this.beans;
        const columnGroup = this.column;
        const providedColumnGroup = columnGroup.getProvidedColumnGroup();
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            displayName: this.displayName,
            columnGroup: columnGroup,
            setExpanded: (expanded)=>{
                colGroupSvc.setColumnGroupOpened(providedColumnGroup, expanded, "gridInitializing");
            },
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupTooltip(value, shouldDisplayTooltip);
            },
            showColumnMenu: (buttonElement, onClosedCallback)=>enterpriseMenuFactory?.showMenuAfterButtonClick(providedColumnGroup, buttonElement, "columnMenu", onClosedCallback),
            showColumnMenuAfterMouseClick: (mouseEvent, onClosedCallback)=>enterpriseMenuFactory?.showMenuAfterMouseEvent(providedColumnGroup, mouseEvent, "columnMenu", onClosedCallback),
            eGridHeader: this.eGui
        });
        const compDetails = $437b23f6a393c3bf$var$_getHeaderGroupCompDetails(userCompFactory, params);
        if (compDetails) this.comp.setUserCompDetails(compDetails);
    }
    addHeaderMouseListeners(compBean) {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>this.dispatchColumnMouseEvent("columnHeaderClicked", this.column.getProvidedColumnGroup());
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column.getProvidedColumnGroup());
        compBean.addManagedListeners(this.eGui, {
            mouseenter: listener,
            mouseleave: listener,
            click: clickListener,
            contextmenu: contextMenuListener
        });
    }
    handleMouseOverChange(isMouseOver) {
        this.eventSvc.dispatchEvent({
            type: isMouseOver ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
            column: this.column.getProvidedColumnGroup()
        });
    }
    setupTooltip(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.setupHeaderGroupTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    setupExpandable(compBean) {
        const providedColGroup = this.column.getProvidedColumnGroup();
        this.refreshExpanded();
        const listener = this.refreshExpanded.bind(this);
        compBean.addManagedListeners(providedColGroup, {
            expandedChanged: listener,
            expandableChanged: listener
        });
    }
    refreshExpanded() {
        const { column: column } = this;
        this.expandable = column.isExpandable();
        const expanded = column.isExpanded();
        if (this.expandable) this.comp.setAriaExpanded(expanded ? "true" : "false");
        else this.comp.setAriaExpanded(void 0);
        this.refreshHeaderStyles();
    }
    addClasses() {
        const { column: column } = this;
        const colGroupDef = column.getColGroupDef();
        const classes = $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(colGroupDef, this.gos, null, column);
        if (column.isPadding()) {
            classes.push("ag-header-group-cell-no-group");
            const leafCols = column.getLeafColumns();
            if (leafCols.every((col)=>col.isSpanHeaderHeight())) classes.push("ag-header-span-height");
        } else {
            classes.push("ag-header-group-cell-with-group");
            if (colGroupDef?.wrapHeaderText) classes.push("ag-header-cell-wrap-text");
        }
        for (const c of classes)this.comp.toggleCss(c, true);
    }
    setupMovingCss(compBean) {
        const { column: column } = this;
        const providedColumnGroup = column.getProvidedColumnGroup();
        const leafColumns = providedColumnGroup.getLeafColumns();
        const listener = ()=>this.comp.toggleCss("ag-header-cell-moving", column.isMoving());
        for (const col of leafColumns)compBean.addManagedListeners(col, {
            movingChanged: listener
        });
        listener();
    }
    onFocusIn(e) {
        if (!this.eGui.contains(e.relatedTarget)) this.focusThis();
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        if (!this.expandable || !wrapperHasFocus) return;
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) {
            const column = this.column;
            const newExpandedValue = !column.isExpanded();
            this.beans.colGroupSvc.setColumnGroupOpened(column.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        }
    }
    // unlike columns, this will only get called once, as we don't react on props on column groups
    // (we will always destroy and recreate this comp if something changes)
    setDragSource(eHeaderGroup) {
        if (!this.isAlive() || this.isSuppressMoving()) return;
        this.removeDragSource();
        if (!eHeaderGroup) return;
        this.dragSource = this.beans.colMoves?.setDragSourceForHeader(eHeaderGroup, this.column, this.displayName) ?? null;
    }
    isSuppressMoving() {
        return this.gos.get("suppressMovableColumns") || this.column.getLeafColumns().some((column)=>column.getColDef().suppressMovable || column.getColDef().lockPosition);
    }
    destroy() {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        super.destroy();
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupApi.ts
function $437b23f6a393c3bf$var$setColumnGroupOpened(beans, group, newValue) {
    beans.colGroupSvc?.setColumnGroupOpened(group, newValue, "api");
}
function $437b23f6a393c3bf$var$getColumnGroup(beans, name, instanceId) {
    return beans.colGroupSvc?.getColumnGroup(name, instanceId) ?? null;
}
function $437b23f6a393c3bf$var$getProvidedColumnGroup(beans, name) {
    return beans.colGroupSvc?.getProvidedColGroup(name) ?? null;
}
function $437b23f6a393c3bf$var$getDisplayNameForColumnGroup(beans, columnGroup, location) {
    return beans.colNames.getDisplayNameForColumnGroup(columnGroup, location) || "";
}
function $437b23f6a393c3bf$var$getColumnGroupState(beans) {
    return beans.colGroupSvc?.getColumnGroupState() ?? [];
}
function $437b23f6a393c3bf$var$setColumnGroupState(beans, stateItems) {
    beans.colGroupSvc?.setColumnGroupState(stateItems, "api");
}
function $437b23f6a393c3bf$var$resetColumnGroupState(beans) {
    beans.colGroupSvc?.resetColumnGroupState("api");
}
function $437b23f6a393c3bf$var$getLeftDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeLeft;
}
function $437b23f6a393c3bf$var$getCenterDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeCenter;
}
function $437b23f6a393c3bf$var$getRightDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeRight;
}
function $437b23f6a393c3bf$var$getAllDisplayedColumnGroups(beans) {
    return beans.visibleCols.getAllTrees();
}
// packages/ag-grid-community/src/columns/visibleColsService.ts
function $437b23f6a393c3bf$var$_removeAllFromUnorderedArray(array, toRemove) {
    for(let i = 0; i < toRemove.length; i++){
        const index = array.indexOf(toRemove[i]);
        if (index >= 0) {
            array[index] = array[array.length - 1];
            array.pop();
        }
    }
}
var $437b23f6a393c3bf$var$VisibleColsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "visibleCols";
        // for fast lookup, to see if a column or group is still visible
        this.colsAndGroupsMap = {};
        // leave level columns of the displayed trees
        this.leftCols = [];
        this.rightCols = [];
        this.centerCols = [];
        // all three lists above combined
        this.allCols = [];
        this.headerGroupRowCount = 0;
        // used by:
        // + angularGrid -> for setting body width
        // + rowController -> setting main row widths (when inserting and resizing)
        // need to cache this
        this.bodyWidth = 0;
        this.leftWidth = 0;
        this.rightWidth = 0;
        this.isBodyWidthDirty = true;
    }
    refresh(source, skipTreeBuild = false) {
        const { colFlex: colFlex, colModel: colModel, colGroupSvc: colGroupSvc, colViewport: colViewport, selectionColSvc: selectionColSvc } = this.beans;
        if (!skipTreeBuild) this.buildTrees(colModel, colGroupSvc);
        colGroupSvc?.updateOpenClosedVisibility();
        this.leftCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeLeft);
        this.centerCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeCenter);
        this.rightCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeRight);
        selectionColSvc?.refreshVisibility(this.leftCols, this.centerCols, this.rightCols);
        this.joinColsAriaOrder(colModel);
        this.joinCols();
        this.headerGroupRowCount = this.getHeaderRowCount();
        this.setLeftValues(source);
        this.autoHeightCols = this.allCols.filter((col)=>col.isAutoHeight());
        colFlex?.refreshFlexedColumns();
        this.updateBodyWidths();
        this.setFirstRightAndLastLeftPinned(colModel, this.leftCols, this.rightCols, source);
        colViewport.checkViewportColumns(false);
        this.eventSvc.dispatchEvent({
            type: "displayedColumnsChanged",
            source: source
        });
    }
    getHeaderRowCount() {
        if (!this.gos.get("hidePaddedHeaderRows")) return this.beans.colModel.cols.treeDepth;
        let headerGroupRowCount = 0;
        for (const col of this.allCols){
            let parent = col.getParent();
            while(parent){
                if (!parent.isPadding()) {
                    const level = parent.getProvidedColumnGroup().getLevel() + 1;
                    if (level > headerGroupRowCount) headerGroupRowCount = level;
                    break;
                }
                parent = parent.getParent();
            }
        }
        return headerGroupRowCount;
    }
    // after setColumnWidth or updateGroupsAndPresentedCols
    updateBodyWidths() {
        const newBodyWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.centerCols);
        const newLeftWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.leftCols);
        const newRightWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.rightCols);
        this.isBodyWidthDirty = this.bodyWidth !== newBodyWidth;
        const atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
        if (atLeastOneChanged) {
            this.bodyWidth = newBodyWidth;
            this.leftWidth = newLeftWidth;
            this.rightWidth = newRightWidth;
            this.eventSvc.dispatchEvent({
                type: "columnContainerWidthChanged"
            });
            this.eventSvc.dispatchEvent({
                type: "displayedColumnsWidthChanged"
            });
        }
    }
    // sets the left pixel position of each column
    setLeftValues(source) {
        this.setLeftValuesOfCols(source);
        this.setLeftValuesOfGroups();
    }
    setFirstRightAndLastLeftPinned(colModel, leftCols, rightCols, source) {
        let lastLeft;
        let firstRight;
        if (this.gos.get("enableRtl")) {
            lastLeft = leftCols ? leftCols[0] : null;
            firstRight = rightCols ? $437b23f6a393c3bf$export$236389741107357f(rightCols) : null;
        } else {
            lastLeft = leftCols ? $437b23f6a393c3bf$export$236389741107357f(leftCols) : null;
            firstRight = rightCols ? rightCols[0] : null;
        }
        for (const col of colModel.getCols()){
            col.setLastLeftPinned(col === lastLeft, source);
            col.setFirstRightPinned(col === firstRight, source);
        }
    }
    buildTrees(colModel, columnGroupSvc) {
        const cols = colModel.getColsToShow();
        const leftCols = cols.filter((col)=>col.getPinned() == "left");
        const rightCols = cols.filter((col)=>col.getPinned() == "right");
        const centerCols = cols.filter((col)=>col.getPinned() != "left" && col.getPinned() != "right");
        const idCreator = new $437b23f6a393c3bf$export$b3b24737a74261fb();
        const createGroups = (params)=>{
            return columnGroupSvc ? columnGroupSvc.createColumnGroups(params) : params.columns;
        };
        this.treeLeft = createGroups({
            columns: leftCols,
            idCreator: idCreator,
            pinned: "left",
            oldDisplayedGroups: this.treeLeft
        });
        this.treeRight = createGroups({
            columns: rightCols,
            idCreator: idCreator,
            pinned: "right",
            oldDisplayedGroups: this.treeRight
        });
        this.treeCenter = createGroups({
            columns: centerCols,
            idCreator: idCreator,
            pinned: null,
            oldDisplayedGroups: this.treeCenter
        });
        this.updateColsAndGroupsMap();
    }
    clear() {
        this.leftCols = [];
        this.rightCols = [];
        this.centerCols = [];
        this.allCols = [];
        this.ariaOrderColumns = [];
    }
    joinColsAriaOrder(colModel) {
        const allColumns = colModel.getCols();
        const pinnedLeft = [];
        const center = [];
        const pinnedRight = [];
        for (const col of allColumns){
            const pinned = col.getPinned();
            if (!pinned) center.push(col);
            else if (pinned === true || pinned === "left") pinnedLeft.push(col);
            else pinnedRight.push(col);
        }
        this.ariaOrderColumns = pinnedLeft.concat(center).concat(pinnedRight);
    }
    getAriaColIndex(colOrGroup) {
        let col;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(colOrGroup)) col = colOrGroup.getLeafColumns()[0];
        else col = colOrGroup;
        return this.ariaOrderColumns.indexOf(col) + 1;
    }
    setLeftValuesOfGroups() {
        for (const columns of [
            this.treeLeft,
            this.treeRight,
            this.treeCenter
        ]){
            for (const column of columns)if ($437b23f6a393c3bf$export$1f44a60fc23f9028(column)) {
                const columnGroup = column;
                columnGroup.checkLeft();
            }
        }
    }
    setLeftValuesOfCols(source) {
        const { colModel: colModel } = this.beans;
        const primaryCols = colModel.getColDefCols();
        if (!primaryCols) return;
        const allColumns = colModel.getCols().slice(0);
        const doingRtl = this.gos.get("enableRtl");
        for (const columns of [
            this.leftCols,
            this.rightCols,
            this.centerCols
        ]){
            if (doingRtl) {
                let left = $437b23f6a393c3bf$var$getWidthOfColsInList(columns);
                for (const column of columns){
                    left -= column.getActualWidth();
                    column.setLeft(left, source);
                }
            } else {
                let left = 0;
                for (const column of columns){
                    column.setLeft(left, source);
                    left += column.getActualWidth();
                }
            }
            $437b23f6a393c3bf$var$_removeAllFromUnorderedArray(allColumns, columns);
        }
        for (const column of allColumns)column.setLeft(null, source);
    }
    joinCols() {
        if (this.gos.get("enableRtl")) this.allCols = this.rightCols.concat(this.centerCols).concat(this.leftCols);
        else this.allCols = this.leftCols.concat(this.centerCols).concat(this.rightCols);
    }
    getAllTrees() {
        if (this.treeLeft && this.treeRight && this.treeCenter) return this.treeLeft.concat(this.treeCenter).concat(this.treeRight);
        return null;
    }
    // gridPanel -> ensureColumnVisible
    isColDisplayed(column) {
        return this.allCols.indexOf(column) >= 0;
    }
    getLeftColsForRow(rowNode) {
        const { leftCols: leftCols, beans: { colModel: colModel } } = this;
        const colSpanActive = colModel.colSpanActive;
        if (!colSpanActive) return leftCols;
        return this.getColsForRow(rowNode, leftCols);
    }
    getRightColsForRow(rowNode) {
        const { rightCols: rightCols, beans: { colModel: colModel } } = this;
        const colSpanActive = colModel.colSpanActive;
        if (!colSpanActive) return rightCols;
        return this.getColsForRow(rowNode, rightCols);
    }
    getColsForRow(rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
        const result = [];
        let lastConsideredCol = null;
        for(let i = 0; i < displayedColumns.length; i++){
            const col = displayedColumns[i];
            const maxAllowedColSpan = displayedColumns.length - i;
            const colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
            const columnsToCheckFilter = [
                col
            ];
            if (colSpan > 1) {
                const colsToRemove = colSpan - 1;
                for(let j = 1; j <= colsToRemove; j++)columnsToCheckFilter.push(displayedColumns[i + j]);
                i += colsToRemove;
            }
            let filterPasses;
            if (filterCallback) {
                filterPasses = false;
                for (const colForFilter of columnsToCheckFilter)if (filterCallback(colForFilter)) filterPasses = true;
            } else filterPasses = true;
            if (filterPasses) {
                if (result.length === 0 && lastConsideredCol) {
                    const gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;
                    if (gapBeforeColumn) result.push(lastConsideredCol);
                }
                result.push(col);
            }
            lastConsideredCol = col;
        }
        return result;
    }
    getContainerWidth(pinned) {
        switch(pinned){
            case "left":
                return this.leftWidth;
            case "right":
                return this.rightWidth;
            default:
                return this.bodyWidth;
        }
    }
    getColBefore(col) {
        const allDisplayedColumns = this.allCols;
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex > 0) return allDisplayedColumns[oldIndex - 1];
        return null;
    }
    isPinningLeft() {
        return this.leftCols.length > 0;
    }
    isPinningRight() {
        return this.rightCols.length > 0;
    }
    updateColsAndGroupsMap() {
        this.colsAndGroupsMap = {};
        const func = (child)=>{
            this.colsAndGroupsMap[child.getUniqueId()] = child;
        };
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeCenter, false, func);
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeLeft, false, func);
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeRight, false, func);
    }
    isVisible(item) {
        const fromMap = this.colsAndGroupsMap[item.getUniqueId()];
        return fromMap === item;
    }
    getFirstColumn() {
        const isRtl = this.gos.get("enableRtl");
        const queryOrder = [
            "leftCols",
            "centerCols",
            "rightCols"
        ];
        if (isRtl) queryOrder.reverse();
        for(let i = 0; i < queryOrder.length; i++){
            const container = this[queryOrder[i]];
            if (container.length) return isRtl ? $437b23f6a393c3bf$export$236389741107357f(container) : container[0];
        }
        return null;
    }
    // used by:
    // + rowRenderer -> for navigation
    getColAfter(col) {
        const allDisplayedColumns = this.allCols;
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex < allDisplayedColumns.length - 1) return allDisplayedColumns[oldIndex + 1];
        return null;
    }
    // used by:
    // + angularGrid -> setting pinned body width
    // note: this should be cached
    getColsLeftWidth() {
        return $437b23f6a393c3bf$var$getWidthOfColsInList(this.leftCols);
    }
    // note: this should be cached
    getDisplayedColumnsRightWidth() {
        return $437b23f6a393c3bf$var$getWidthOfColsInList(this.rightCols);
    }
    isColAtEdge(col, edge) {
        const allColumns = this.allCols;
        if (!allColumns.length) return false;
        const isFirst = edge === "first";
        let columnToCompare;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(col)) {
            const leafColumns = col.getDisplayedLeafColumns();
            if (!leafColumns.length) return false;
            columnToCompare = isFirst ? leafColumns[0] : $437b23f6a393c3bf$export$236389741107357f(leafColumns);
        } else columnToCompare = col;
        return (isFirst ? allColumns[0] : $437b23f6a393c3bf$export$236389741107357f(allColumns)) === columnToCompare;
    }
};
function $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(tree, useDisplayedChildren, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) {
            const childTree = useDisplayedChildren ? child.getDisplayedChildren() : child.getChildren();
            $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(childTree, useDisplayedChildren, callback);
        }
        callback(child);
    }
}
function $437b23f6a393c3bf$var$pickDisplayedCols(tree) {
    const res = [];
    $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(tree, true, (child)=>{
        if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) res.push(child);
    });
    return res;
}
// packages/ag-grid-community/src/columns/columnGroups/columnGroupService.ts
var $437b23f6a393c3bf$var$ColumnGroupService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colGroupSvc";
    }
    getColumnGroupState() {
        const columnGroupState = [];
        const gridBalancedTree = this.beans.colModel.getColTree();
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, gridBalancedTree, (node)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(node)) columnGroupState.push({
                groupId: node.getGroupId(),
                open: node.isExpanded()
            });
        });
        return columnGroupState;
    }
    resetColumnGroupState(source) {
        const primaryColumnTree = this.beans.colModel.getColDefColTree();
        if (!primaryColumnTree) return;
        const stateItems = [];
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, primaryColumnTree, (child)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) {
                const colGroupDef = child.getColGroupDef();
                const groupState = {
                    groupId: child.getGroupId(),
                    open: !colGroupDef ? void 0 : colGroupDef.openByDefault
                };
                stateItems.push(groupState);
            }
        });
        this.setColumnGroupState(stateItems, source);
    }
    setColumnGroupState(stateItems, source) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const gridBalancedTree = colModel.getColTree();
        if (!gridBalancedTree.length) return;
        colAnimation?.start();
        const impactedGroups = [];
        for (const stateItem of stateItems){
            const groupKey = stateItem.groupId;
            const newValue = stateItem.open;
            const providedColumnGroup = this.getProvidedColGroup(groupKey);
            if (!providedColumnGroup) continue;
            if (providedColumnGroup.isExpanded() === newValue) continue;
            providedColumnGroup.setExpanded(newValue);
            impactedGroups.push(providedColumnGroup);
        }
        visibleCols.refresh(source, true);
        if (impactedGroups.length) eventSvc.dispatchEvent({
            type: "columnGroupOpened",
            columnGroup: impactedGroups.length === 1 ? impactedGroups[0] : void 0,
            columnGroups: impactedGroups
        });
        colAnimation?.finish();
    }
    // called by headerRenderer - when a header is opened or closed
    setColumnGroupOpened(key, newValue, source) {
        let keyAsString;
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(key)) keyAsString = key.getId();
        else keyAsString = key || "";
        this.setColumnGroupState([
            {
                groupId: keyAsString,
                open: newValue
            }
        ], source);
    }
    getProvidedColGroup(key) {
        let res = null;
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, this.beans.colModel.getColTree(), (node)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(node)) {
                if (node.getId() === key) res = node;
            }
        });
        return res;
    }
    getGroupAtDirection(columnGroup, direction) {
        const requiredLevel = columnGroup.getProvidedColumnGroup().getLevel() + columnGroup.getPaddingLevel();
        const colGroupLeafColumns = columnGroup.getDisplayedLeafColumns();
        const col = direction === "After" ? $437b23f6a393c3bf$export$236389741107357f(colGroupLeafColumns) : colGroupLeafColumns[0];
        const getDisplayColMethod = `getCol${direction}`;
        while(true){
            const column = this.beans.visibleCols[getDisplayColMethod](col);
            if (!column) return null;
            const groupPointer = this.getColGroupAtLevel(column, requiredLevel);
            if (groupPointer !== columnGroup) return groupPointer;
        }
    }
    getColGroupAtLevel(column, level) {
        let groupPointer = column.getParent();
        let originalGroupLevel;
        let groupPointerLevel;
        while(true){
            const groupPointerProvidedColumnGroup = groupPointer.getProvidedColumnGroup();
            originalGroupLevel = groupPointerProvidedColumnGroup.getLevel();
            groupPointerLevel = groupPointer.getPaddingLevel();
            if (originalGroupLevel + groupPointerLevel <= level) break;
            groupPointer = groupPointer.getParent();
        }
        return groupPointer;
    }
    updateOpenClosedVisibility() {
        const allColumnGroups = this.beans.visibleCols.getAllTrees();
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.calculateDisplayedColumns();
        });
    }
    // returns the group with matching colId and instanceId. If instanceId is missing,
    // matches only on the colId.
    getColumnGroup(colId, partId) {
        if (!colId) return null;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(colId)) return colId;
        const allColumnGroups = this.beans.visibleCols.getAllTrees();
        const checkPartId = typeof partId === "number";
        let result = null;
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) {
                const columnGroup = child;
                let matched;
                if (checkPartId) matched = colId === columnGroup.getGroupId() && partId === columnGroup.getPartId();
                else matched = colId === columnGroup.getGroupId();
                if (matched) result = columnGroup;
            }
        });
        return result;
    }
    createColumnGroups(params) {
        const { columns: columns, idCreator: idCreator, pinned: pinned, oldDisplayedGroups: oldDisplayedGroups, isStandaloneStructure: isStandaloneStructure } = params;
        const oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
        const topLevelResultCols = [];
        let groupsOrColsAtCurrentLevel = columns;
        while(groupsOrColsAtCurrentLevel.length){
            const currentlyIterating = groupsOrColsAtCurrentLevel;
            groupsOrColsAtCurrentLevel = [];
            let lastGroupedColIdx = 0;
            const createGroupToIndex = (to)=>{
                const from = lastGroupedColIdx;
                lastGroupedColIdx = to;
                const previousNode = currentlyIterating[from];
                const previousNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(previousNode) ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (previousNodeParent == null) {
                    for(let i = from; i < to; i++)topLevelResultCols.push(currentlyIterating[i]);
                    return;
                }
                const newGroup = this.createColumnGroup(previousNodeParent, idCreator, oldColumnsMapped, pinned, isStandaloneStructure);
                for(let i = from; i < to; i++)newGroup.addChild(currentlyIterating[i]);
                groupsOrColsAtCurrentLevel.push(newGroup);
            };
            for(let i = 1; i < currentlyIterating.length; i++){
                const thisNode = currentlyIterating[i];
                const thisNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(thisNode) ? thisNode.getProvidedColumnGroup() : thisNode;
                const thisNodeParent = thisNodeProvided.getOriginalParent();
                const previousNode = currentlyIterating[lastGroupedColIdx];
                const previousNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(previousNode) ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (thisNodeParent !== previousNodeParent) createGroupToIndex(i);
            }
            if (lastGroupedColIdx < currentlyIterating.length) createGroupToIndex(currentlyIterating.length);
        }
        if (!isStandaloneStructure) this.setupParentsIntoCols(topLevelResultCols, null);
        return topLevelResultCols;
    }
    createProvidedColumnGroup(primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, existingGroups, source) {
        const groupId = columnKeyCreator.getUniqueKey(colGroupDef.groupId || null, null);
        const colGroupDefMerged = $437b23f6a393c3bf$var$createMergedColGroupDef(this.beans, colGroupDef, groupId);
        const providedGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDefMerged, groupId, false, level);
        this.createBean(providedGroup);
        const existingGroupAndIndex = this.findExistingGroup(colGroupDef, existingGroups);
        if (existingGroupAndIndex) existingGroups.splice(existingGroupAndIndex.idx, 1);
        const existingGroup = existingGroupAndIndex?.group;
        if (existingGroup) providedGroup.setExpanded(existingGroup.isExpanded());
        const children = $437b23f6a393c3bf$var$_recursivelyCreateColumns(this.beans, colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, existingGroups, source);
        providedGroup.setChildren(children);
        return providedGroup;
    }
    balanceColumnTree(unbalancedTree, currentDepth, columnDepth, columnKeyCreator) {
        const result = [];
        for(let i = 0; i < unbalancedTree.length; i++){
            const child = unbalancedTree[i];
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) {
                const originalGroup = child;
                const newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDepth + 1, columnDepth, columnKeyCreator);
                originalGroup.setChildren(newChildren);
                result.push(originalGroup);
            } else {
                let firstPaddedGroup;
                let currentPaddedGroup;
                for(let j = currentDepth; j < columnDepth; j++){
                    const newColId = columnKeyCreator.getUniqueKey(null, null);
                    const colGroupDefMerged = $437b23f6a393c3bf$var$createMergedColGroupDef(this.beans, null, newColId);
                    const paddedGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDefMerged, newColId, true, j);
                    this.createBean(paddedGroup);
                    if (currentPaddedGroup) currentPaddedGroup.setChildren([
                        paddedGroup
                    ]);
                    currentPaddedGroup = paddedGroup;
                    if (!firstPaddedGroup) firstPaddedGroup = currentPaddedGroup;
                }
                if (firstPaddedGroup && currentPaddedGroup) {
                    result.push(firstPaddedGroup);
                    const hasGroups = unbalancedTree.some((leaf)=>$437b23f6a393c3bf$export$bb4bfad2b594b78e(leaf));
                    if (hasGroups) {
                        currentPaddedGroup.setChildren([
                            child
                        ]);
                        continue;
                    } else {
                        currentPaddedGroup.setChildren(unbalancedTree);
                        break;
                    }
                }
                result.push(child);
            }
        }
        return result;
    }
    findDepth(balancedColumnTree) {
        let depth = 0;
        let pointer = balancedColumnTree;
        while(pointer?.[0] && $437b23f6a393c3bf$export$bb4bfad2b594b78e(pointer[0])){
            depth++;
            pointer = pointer[0].getChildren();
        }
        return depth;
    }
    findMaxDepth(treeChildren, depth) {
        let maxDepthThisLevel = depth;
        for(let i = 0; i < treeChildren.length; i++){
            const abstractColumn = treeChildren[i];
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(abstractColumn)) {
                const originalGroup = abstractColumn;
                const newDepth = this.findMaxDepth(originalGroup.getChildren(), depth + 1);
                if (maxDepthThisLevel < newDepth) maxDepthThisLevel = newDepth;
            }
        }
        return maxDepthThisLevel;
    }
    /**
   * Inserts dummy group columns in the hierarchy above auto-generated columns
   * in order to ensure auto-generated columns are leaf nodes (and therefore are
   * displayed correctly)
   */ balanceTreeForAutoCols(autoCols, depth) {
        const tree = [];
        for (const col of autoCols){
            let nextChild = col;
            for(let i = depth - 1; i >= 0; i--){
                const autoGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(null, `FAKE_PATH_${col.getId()}}_${i}`, true, i);
                this.createBean(autoGroup);
                autoGroup.setChildren([
                    nextChild
                ]);
                nextChild.originalParent = autoGroup;
                nextChild = autoGroup;
            }
            if (depth === 0) col.originalParent = null;
            tree.push(nextChild);
        }
        return tree;
    }
    findExistingGroup(newGroupDef, existingGroups) {
        const newHasId = newGroupDef.groupId != null;
        if (!newHasId) return void 0;
        for(let i = 0; i < existingGroups.length; i++){
            const existingGroup = existingGroups[i];
            const existingDef = existingGroup.getColGroupDef();
            if (!existingDef) continue;
            if (existingGroup.getId() === newGroupDef.groupId) return {
                idx: i,
                group: existingGroup
            };
        }
        return void 0;
    }
    createColumnGroup(providedGroup, groupInstanceIdCreator, oldColumnsMapped, pinned, isStandaloneStructure) {
        const groupId = providedGroup.getGroupId();
        const instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
        const uniqueId = $437b23f6a393c3bf$var$createUniqueColumnGroupId(groupId, instanceId);
        let columnGroup = oldColumnsMapped[uniqueId];
        if (columnGroup && columnGroup.getProvidedColumnGroup() !== providedGroup) columnGroup = null;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(columnGroup)) columnGroup.reset();
        else {
            columnGroup = new $437b23f6a393c3bf$export$273c80940a54c770(providedGroup, groupId, instanceId, pinned);
            if (!isStandaloneStructure) this.createBean(columnGroup);
        }
        return columnGroup;
    }
    // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
    mapOldGroupsById(displayedGroups) {
        const result = {};
        const recursive = (columnsOrGroups)=>{
            for (const columnOrGroup of columnsOrGroups)if ($437b23f6a393c3bf$export$1f44a60fc23f9028(columnOrGroup)) {
                const columnGroup = columnOrGroup;
                result[columnOrGroup.getUniqueId()] = columnGroup;
                recursive(columnGroup.getChildren());
            }
        };
        if (displayedGroups) recursive(displayedGroups);
        return result;
    }
    setupParentsIntoCols(columnsOrGroups, parent) {
        for (const columnsOrGroup of columnsOrGroups ?? []){
            if (columnsOrGroup.parent !== parent) this.beans.colViewport.colsWithinViewportHash = "";
            columnsOrGroup.parent = parent;
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(columnsOrGroup)) {
                const columnGroup = columnsOrGroup;
                this.setupParentsIntoCols(columnGroup.getChildren(), columnGroup);
            }
        }
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupModule.ts
var $437b23f6a393c3bf$export$922da35340a6d14e = {
    moduleName: "ColumnGroup",
    version: $437b23f6a393c3bf$var$VERSION,
    dynamicBeans: {
        headerGroupCellCtrl: $437b23f6a393c3bf$var$HeaderGroupCellCtrl
    },
    beans: [
        $437b23f6a393c3bf$var$ColumnGroupService
    ],
    apiFunctions: {
        getAllDisplayedColumnGroups: $437b23f6a393c3bf$var$getAllDisplayedColumnGroups,
        getCenterDisplayedColumnGroups: $437b23f6a393c3bf$var$getCenterDisplayedColumnGroups,
        getColumnGroup: $437b23f6a393c3bf$var$getColumnGroup,
        getColumnGroupState: $437b23f6a393c3bf$var$getColumnGroupState,
        getDisplayNameForColumnGroup: $437b23f6a393c3bf$var$getDisplayNameForColumnGroup,
        getLeftDisplayedColumnGroups: $437b23f6a393c3bf$var$getLeftDisplayedColumnGroups,
        getProvidedColumnGroup: $437b23f6a393c3bf$var$getProvidedColumnGroup,
        getRightDisplayedColumnGroups: $437b23f6a393c3bf$var$getRightDisplayedColumnGroups,
        resetColumnGroupState: $437b23f6a393c3bf$var$resetColumnGroupState,
        setColumnGroupOpened: $437b23f6a393c3bf$var$setColumnGroupOpened,
        setColumnGroupState: $437b23f6a393c3bf$var$setColumnGroupState
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/skeletonCellRenderer.ts
var $437b23f6a393c3bf$var$SkeletonCellRendererElement = {
    tag: "div",
    cls: "ag-skeleton-container"
};
var $437b23f6a393c3bf$var$SkeletonCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$SkeletonCellRendererElement);
    }
    init(params) {
        const id = `ag-cell-skeleton-renderer-${this.getCompId()}`;
        this.getGui().setAttribute("id", id);
        this.addDestroyFunc(()=>$437b23f6a393c3bf$export$84233c40c4c74001(params.eParentOfValue));
        $437b23f6a393c3bf$export$84233c40c4c74001(params.eParentOfValue, id);
        if (params.deferRender) this.setupLoading(params);
        else params.node.failedLoad ? this.setupFailed() : this.setupLoading(params);
    }
    setupFailed() {
        const localeTextFunc = this.getLocaleTextFunc();
        this.getGui().textContent = localeTextFunc("loadingError", "ERR");
        const ariaFailed = localeTextFunc("ariaSkeletonCellLoadingFailed", "Row failed to load");
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.getGui(), ariaFailed);
    }
    setupLoading(params) {
        const skeletonEffect = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-skeleton-effect"
        });
        const rowIndex = params.node.rowIndex;
        if (rowIndex != null) {
            const width = 75 + 25 * (rowIndex % 2 === 0 ? Math.sin(rowIndex) : Math.cos(rowIndex));
            skeletonEffect.style.width = `${width}%`;
        }
        this.getGui().appendChild(skeletonEffect);
        const localeTextFunc = this.getLocaleTextFunc();
        const ariaLoading = params.deferRender ? localeTextFunc("ariaDeferSkeletonCellLoading", "Cell is loading") : localeTextFunc("ariaSkeletonCellLoading", "Row data is loading");
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.getGui(), ariaLoading);
    }
    refresh(_params) {
        return false;
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/cellRendererModule.ts
var $437b23f6a393c3bf$var$CheckboxCellRendererModule = {
    moduleName: "CheckboxCellRenderer",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCheckboxCellRenderer: $437b23f6a393c3bf$var$CheckboxCellRenderer
    }
};
var $437b23f6a393c3bf$var$SkeletonCellRendererModule = {
    moduleName: "SkeletonCellRenderer",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agSkeletonCellRenderer: $437b23f6a393c3bf$var$SkeletonCellRenderer
    }
};
// packages/ag-grid-community/src/columns/columnApi.ts
function $437b23f6a393c3bf$var$getColumnDef(beans, key) {
    const column = beans.colModel.getColDefCol(key);
    if (column) return column.getColDef();
    return null;
}
function $437b23f6a393c3bf$var$getColumnDefs(beans) {
    return beans.colModel.getColumnDefs(true);
}
function $437b23f6a393c3bf$var$getDisplayNameForColumn(beans, column, location) {
    return beans.colNames.getDisplayNameForColumn(column, location) || "";
}
function $437b23f6a393c3bf$var$getColumn(beans, key) {
    return beans.colModel.getColDefCol(key);
}
function $437b23f6a393c3bf$var$getColumns(beans) {
    return beans.colModel.getColDefCols();
}
function $437b23f6a393c3bf$var$applyColumnState(beans, params) {
    return $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, params, "api");
}
function $437b23f6a393c3bf$var$getColumnState(beans) {
    return $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
}
function $437b23f6a393c3bf$var$resetColumnState(beans) {
    $437b23f6a393c3bf$export$96a6cbc000255060(beans, "api");
}
function $437b23f6a393c3bf$var$isPinning(beans) {
    return beans.visibleCols.isPinningLeft() || beans.visibleCols.isPinningRight();
}
function $437b23f6a393c3bf$var$isPinningLeft(beans) {
    return beans.visibleCols.isPinningLeft();
}
function $437b23f6a393c3bf$var$isPinningRight(beans) {
    return beans.visibleCols.isPinningRight();
}
function $437b23f6a393c3bf$var$getDisplayedColAfter(beans, col) {
    return beans.visibleCols.getColAfter(col);
}
function $437b23f6a393c3bf$var$getDisplayedColBefore(beans, col) {
    return beans.visibleCols.getColBefore(col);
}
function $437b23f6a393c3bf$var$setColumnsVisible(beans, keys, visible) {
    beans.colModel.setColsVisible(keys, visible, "api");
}
function $437b23f6a393c3bf$var$setColumnsPinned(beans, keys, pinned) {
    beans.pinnedCols?.setColsPinned(keys, pinned, "api");
}
function $437b23f6a393c3bf$var$getAllGridColumns(beans) {
    return beans.colModel.getCols();
}
function $437b23f6a393c3bf$var$getDisplayedLeftColumns(beans) {
    return beans.visibleCols.leftCols;
}
function $437b23f6a393c3bf$var$getDisplayedCenterColumns(beans) {
    return beans.visibleCols.centerCols;
}
function $437b23f6a393c3bf$var$getDisplayedRightColumns(beans) {
    return beans.visibleCols.rightCols;
}
function $437b23f6a393c3bf$var$getAllDisplayedColumns(beans) {
    return beans.visibleCols.allCols;
}
function $437b23f6a393c3bf$var$getAllDisplayedVirtualColumns(beans) {
    return beans.colViewport.getViewportColumns();
}
// packages/ag-grid-community/src/columns/columnDefFactory.ts
function $437b23f6a393c3bf$var$_deepCloneDefinition(object, keysToSkip) {
    if (!object) return;
    const obj = object;
    const res = {};
    for (const key of Object.keys(obj)){
        if (keysToSkip && keysToSkip.indexOf(key) >= 0 || $437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(key)) continue;
        const value = obj[key];
        const sourceIsSimpleObject = typeof value === "object" && value !== null && value.constructor === Object;
        if (sourceIsSimpleObject) res[key] = $437b23f6a393c3bf$var$_deepCloneDefinition(value);
        else res[key] = value;
    }
    return res;
}
var $437b23f6a393c3bf$var$ColumnDefFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colDefFactory";
    }
    wireBeans(beans) {
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.pivotColsSvc = beans.pivotColsSvc;
    }
    getColumnDefs(colDefColsList, showingPivotResult, lastOrder, colsList, sorted = false) {
        const cols = colDefColsList.slice();
        if (showingPivotResult) cols.sort((a, b)=>lastOrder.indexOf(a) - lastOrder.indexOf(b));
        else if (lastOrder || sorted) cols.sort((a, b)=>colsList.indexOf(a) - colsList.indexOf(b));
        const rowGroupColumns = this.rowGroupColsSvc?.columns;
        const pivotColumns = this.pivotColsSvc?.columns;
        return this.buildColumnDefs(cols, rowGroupColumns, pivotColumns);
    }
    buildColumnDefs(cols, rowGroupColumns = [], pivotColumns = []) {
        const res = [];
        const colGroupDefs = {};
        for (const col of cols){
            const colDef = this.createDefFromColumn(col, rowGroupColumns, pivotColumns);
            let addToResult = true;
            let childDef = colDef;
            let pointer = col.getOriginalParent();
            let lastPointer = null;
            while(pointer){
                let parentDef = null;
                if (pointer.isPadding()) {
                    pointer = pointer.getOriginalParent();
                    continue;
                }
                const existingParentDef = colGroupDefs[pointer.getGroupId()];
                if (existingParentDef) {
                    existingParentDef.children.push(childDef);
                    addToResult = false;
                    break;
                }
                parentDef = this.createDefFromGroup(pointer);
                if (parentDef) {
                    parentDef.children = [
                        childDef
                    ];
                    colGroupDefs[parentDef.groupId] = parentDef;
                    childDef = parentDef;
                    pointer = pointer.getOriginalParent();
                }
                if (pointer != null && lastPointer === pointer) {
                    addToResult = false;
                    break;
                }
                lastPointer = pointer;
            }
            if (addToResult) res.push(childDef);
        }
        return res;
    }
    createDefFromGroup(group) {
        const defCloned = $437b23f6a393c3bf$var$_deepCloneDefinition(group.getColGroupDef(), [
            "children"
        ]);
        if (defCloned) defCloned.groupId = group.getGroupId();
        return defCloned;
    }
    createDefFromColumn(col, rowGroupColumns, pivotColumns) {
        const colDefCloned = $437b23f6a393c3bf$var$_deepCloneDefinition(col.getColDef());
        colDefCloned.colId = col.getColId();
        colDefCloned.width = col.getActualWidth();
        colDefCloned.rowGroup = col.isRowGroupActive();
        colDefCloned.rowGroupIndex = col.isRowGroupActive() ? rowGroupColumns.indexOf(col) : null;
        colDefCloned.pivot = col.isPivotActive();
        colDefCloned.pivotIndex = col.isPivotActive() ? pivotColumns.indexOf(col) : null;
        colDefCloned.aggFunc = col.isValueActive() ? col.getAggFunc() : null;
        colDefCloned.hide = col.isVisible() ? void 0 : true;
        colDefCloned.pinned = col.isPinned() ? col.getPinned() : null;
        colDefCloned.sort = col.getSort() ? col.getSort() : null;
        colDefCloned.sortIndex = col.getSortIndex() != null ? col.getSortIndex() : null;
        return colDefCloned;
    }
};
// packages/ag-grid-community/src/columns/columnFlexService.ts
var $437b23f6a393c3bf$var$ColumnFlexService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colFlex";
        this.columnsHidden = false;
    }
    refreshFlexedColumns(params = {}) {
        const source = params.source ?? "flex";
        if (params.viewportWidth != null) this.flexViewportWidth = params.viewportWidth;
        const totalSpace = this.flexViewportWidth;
        const { visibleCols: visibleCols, colDelayRenderSvc: colDelayRenderSvc } = this.beans;
        const visibleCenterCols = visibleCols.centerCols;
        let flexAfterDisplayIndex = -1;
        if (params.resizingCols) {
            const allResizingCols = new Set(params.resizingCols);
            for(let i = visibleCenterCols.length - 1; i >= 0; i--)if (allResizingCols.has(visibleCenterCols[i])) {
                flexAfterDisplayIndex = i;
                break;
            }
        }
        let hasFlexItems = false;
        const items = visibleCenterCols.map((col, i)=>{
            const flex = col.getFlex();
            const isFlex = flex != null && flex > 0 && i > flexAfterDisplayIndex;
            hasFlexItems || (hasFlexItems = isFlex);
            return {
                col: col,
                isFlex: isFlex,
                flex: Math.max(0, flex ?? 0),
                initialSize: col.getActualWidth(),
                min: col.getMinWidth(),
                max: col.getMaxWidth(),
                targetSize: 0
            };
        });
        if (hasFlexItems) {
            colDelayRenderSvc?.hideColumns("colFlex");
            this.columnsHidden = true;
        } else if (this.columnsHidden) this.revealColumns(colDelayRenderSvc);
        if (!totalSpace || !hasFlexItems) return [];
        let unfrozenItemCount = items.length;
        let unfrozenFlex = items.reduce((acc, item)=>acc + item.flex, 0);
        let unfrozenSpace = totalSpace;
        const freeze = (item, width)=>{
            item.frozenSize = width;
            item.col.setActualWidth(width, source);
            unfrozenSpace -= width;
            unfrozenFlex -= item.flex;
            unfrozenItemCount -= 1;
        };
        const isFrozen = (item)=>item.frozenSize != null;
        for (const item of items)if (!item.isFlex) freeze(item, item.initialSize);
        while(unfrozenItemCount > 0){
            const spaceToFill = Math.round(unfrozenFlex < 1 ? unfrozenSpace * unfrozenFlex : unfrozenSpace);
            let lastUnfrozenItem;
            let actualLeft = 0;
            let idealRight = 0;
            for (const item of items){
                if (isFrozen(item)) continue;
                lastUnfrozenItem = item;
                idealRight += spaceToFill * (item.flex / unfrozenFlex);
                const idealSize = idealRight - actualLeft;
                const roundedSize = Math.round(idealSize);
                item.targetSize = roundedSize;
                actualLeft += roundedSize;
            }
            if (lastUnfrozenItem) lastUnfrozenItem.targetSize += spaceToFill - actualLeft;
            let totalViolation = 0;
            for (const item of items){
                if (isFrozen(item)) continue;
                const unclampedSize = item.targetSize;
                const clampedSize = Math.min(Math.max(unclampedSize, item.min), item.max);
                totalViolation += clampedSize - unclampedSize;
                item.violationType = clampedSize === unclampedSize ? void 0 : clampedSize < unclampedSize ? "max" : "min";
                item.targetSize = clampedSize;
            }
            const freezeType = totalViolation === 0 ? "all" : totalViolation > 0 ? "min" : "max";
            for (const item of items){
                if (isFrozen(item)) continue;
                if (freezeType === "all" || item.violationType === freezeType) freeze(item, item.targetSize);
            }
        }
        if (!params.skipSetLeft) visibleCols.setLeftValues(source);
        if (params.updateBodyWidths) visibleCols.updateBodyWidths();
        const unconstrainedFlexColumns = items.filter((item)=>item.isFlex && !item.violationType).map((item)=>item.col);
        if (params.fireResizedEvent) {
            const changedColumns = items.filter((item)=>item.initialSize !== item.frozenSize).map((item)=>item.col);
            const flexingColumns = items.filter((item)=>item.flex).map((item)=>item.col);
            $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, changedColumns, true, source, flexingColumns);
        }
        this.revealColumns(colDelayRenderSvc);
        return unconstrainedFlexColumns;
    }
    revealColumns(colDelayRenderSvc) {
        if (this.columnsHidden) {
            colDelayRenderSvc?.revealColumns("colFlex");
            this.columnsHidden = false;
        }
    }
    initCol(column) {
        const { flex: flex, initialFlex: initialFlex } = column.colDef;
        if (flex !== void 0) column.flex = flex;
        else if (initialFlex !== void 0) column.flex = initialFlex;
    }
    // this method should only be used by the colModel to
    // change flex when required by the applyColumnState method.
    setColFlex(column, flex) {
        column.flex = flex ?? null;
        column.dispatchStateUpdatedEvent("flex");
    }
};
// packages/ag-grid-community/src/agStack/utils/value.ts
function $437b23f6a393c3bf$var$_getValueUsingField(data, field, fieldContainsDots) {
    if (!field || !data) return;
    if (!fieldContainsDots) return data[field];
    const fields = field.split(".");
    let currentObject = data;
    for(let i = 0; i < fields.length; i++){
        if (currentObject == null) return void 0;
        currentObject = currentObject[fields[i]];
    }
    return currentObject;
}
// packages/ag-grid-community/src/columns/dataTypeService.ts
var $437b23f6a393c3bf$var$SORTED_CELL_DATA_TYPES_FOR_MATCHING = [
    "dateTimeString",
    "dateString",
    "text",
    "number",
    "boolean",
    "date"
];
var $437b23f6a393c3bf$var$DataTypeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "dataTypeSvc";
        this.dataTypeDefinitions = {};
        this.isPendingInference = false;
        this.isColumnTypeOverrideInDataTypeDefinitions = false;
        // keep track of any column state updates whilst waiting for data types to be inferred
        this.columnStateUpdatesPendingInference = {};
        this.columnStateUpdateListenerDestroyFuncs = [];
        // using an object here to enforce dev to not forget to implement new types as they are added
        this.columnDefinitionPropsPerDataType = {
            number () {
                return {
                    cellEditor: "agNumberCellEditor"
                };
            },
            boolean () {
                return {
                    cellEditor: "agCheckboxCellEditor",
                    cellRenderer: "agCheckboxCellRenderer",
                    getFindText: ()=>null,
                    suppressKeyboardEvent: (params)=>!!params.colDef.editable && params.event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE
                };
            },
            date ({ formatValue: formatValue }) {
                return {
                    cellEditor: "agDateCellEditor",
                    keyCreator: formatValue
                };
            },
            dateString ({ formatValue: formatValue }) {
                return {
                    cellEditor: "agDateStringCellEditor",
                    keyCreator: formatValue
                };
            },
            dateTime (args) {
                return this.date(args);
            },
            dateTimeString (args) {
                return this.dateString(args);
            },
            object ({ formatValue: formatValue, colModel: colModel, colId: colId }) {
                return {
                    cellEditorParams: {
                        useFormatter: true
                    },
                    comparator: (a, b)=>{
                        const column = colModel.getColDefCol(colId);
                        const colDef = column?.getColDef();
                        if (!column || !colDef) return 0;
                        const valA = a == null ? "" : formatValue({
                            column: column,
                            node: null,
                            value: a
                        });
                        const valB = b == null ? "" : formatValue({
                            column: column,
                            node: null,
                            value: b
                        });
                        if (valA === valB) return 0;
                        return valA > valB ? 1 : -1;
                    },
                    keyCreator: formatValue
                };
            },
            text () {
                return {};
            }
        };
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
    }
    postConstruct() {
        this.processDataTypeDefinitions();
        this.addManagedPropertyListener("dataTypeDefinitions", (event)=>{
            this.processDataTypeDefinitions();
            this.colModel.recreateColumnDefs(event);
        });
    }
    processDataTypeDefinitions() {
        const defaultDataTypes = this.getDefaultDataTypes();
        const newDataTypeDefinitions = {};
        const newFormatValueFuncs = {};
        const generateFormatValueFunc = (dataTypeDefinition)=>{
            return (params)=>{
                const { column: column, node: node, value: value } = params;
                let valueFormatter = column.getColDef().valueFormatter;
                if (valueFormatter === dataTypeDefinition.groupSafeValueFormatter) valueFormatter = dataTypeDefinition.valueFormatter;
                return this.beans.valueSvc.formatValue(column, node, value, valueFormatter);
            };
        };
        for (const cellDataType of Object.keys(defaultDataTypes)){
            const defaultDataTypeDef = defaultDataTypes[cellDataType];
            const mergedDataTypeDefinition = {
                ...defaultDataTypeDef,
                groupSafeValueFormatter: $437b23f6a393c3bf$var$createGroupSafeValueFormatter(defaultDataTypeDef, this.gos)
            };
            newDataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;
            newFormatValueFuncs[cellDataType] = generateFormatValueFunc(mergedDataTypeDefinition);
        }
        const userDataTypeDefs = this.gos.get("dataTypeDefinitions") ?? {};
        const newDataTypeMatchers = {};
        for (const cellDataType of Object.keys(userDataTypeDefs)){
            const userDataTypeDef = userDataTypeDefs[cellDataType];
            const mergedDataTypeDefinition = this.processDataTypeDefinition(userDataTypeDef, userDataTypeDefs, [
                cellDataType
            ], defaultDataTypes);
            if (mergedDataTypeDefinition) {
                newDataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;
                if (userDataTypeDef.dataTypeMatcher) newDataTypeMatchers[cellDataType] = userDataTypeDef.dataTypeMatcher;
                newFormatValueFuncs[cellDataType] = generateFormatValueFunc(mergedDataTypeDefinition);
            }
        }
        const { valueParser: defaultValueParser, valueFormatter: defaultValueFormatter } = defaultDataTypes.object;
        const { valueParser: userValueParser, valueFormatter: userValueFormatter } = newDataTypeDefinitions.object;
        this.hasObjectValueParser = userValueParser !== defaultValueParser;
        this.hasObjectValueFormatter = userValueFormatter !== defaultValueFormatter;
        this.formatValueFuncs = newFormatValueFuncs;
        this.dataTypeDefinitions = newDataTypeDefinitions;
        this.dataTypeMatchers = this.sortKeysInMatchers(newDataTypeMatchers, defaultDataTypes);
    }
    /**
   * Sorts the keys in the matchers object.
   * Does not mutate the original object, creates a copy of it with sorted keys instead.
   */ sortKeysInMatchers(matchers, dataTypes) {
        const sortedMatchers = {
            ...matchers
        };
        for (const cellDataType of $437b23f6a393c3bf$var$SORTED_CELL_DATA_TYPES_FOR_MATCHING){
            delete sortedMatchers[cellDataType];
            sortedMatchers[cellDataType] = matchers[cellDataType] ?? dataTypes[cellDataType].dataTypeMatcher;
        }
        return sortedMatchers;
    }
    processDataTypeDefinition(userDataTypeDef, userDataTypeDefs, alreadyProcessedDataTypes, defaultDataTypes) {
        let mergedDataTypeDefinition;
        const extendsCellDataType = userDataTypeDef.extendsDataType;
        if (userDataTypeDef.columnTypes) this.isColumnTypeOverrideInDataTypeDefinitions = true;
        if (userDataTypeDef.extendsDataType === userDataTypeDef.baseDataType) {
            let baseDataTypeDefinition = defaultDataTypes[extendsCellDataType];
            const overriddenBaseDataTypeDefinition = userDataTypeDefs[extendsCellDataType];
            if (baseDataTypeDefinition && overriddenBaseDataTypeDefinition) baseDataTypeDefinition = overriddenBaseDataTypeDefinition;
            if (!$437b23f6a393c3bf$var$validateDataTypeDefinition(userDataTypeDef, baseDataTypeDefinition, extendsCellDataType)) return void 0;
            mergedDataTypeDefinition = $437b23f6a393c3bf$var$mergeDataTypeDefinitions(baseDataTypeDefinition, userDataTypeDef);
        } else {
            if (alreadyProcessedDataTypes.includes(extendsCellDataType)) {
                $437b23f6a393c3bf$export$545083624300f13d(44);
                return void 0;
            }
            const extendedDataTypeDefinition = userDataTypeDefs[extendsCellDataType];
            if (!$437b23f6a393c3bf$var$validateDataTypeDefinition(userDataTypeDef, extendedDataTypeDefinition, extendsCellDataType)) return void 0;
            const mergedExtendedDataTypeDefinition = this.processDataTypeDefinition(extendedDataTypeDefinition, userDataTypeDefs, [
                ...alreadyProcessedDataTypes,
                extendsCellDataType
            ], defaultDataTypes);
            if (!mergedExtendedDataTypeDefinition) return void 0;
            mergedDataTypeDefinition = $437b23f6a393c3bf$var$mergeDataTypeDefinitions(mergedExtendedDataTypeDefinition, userDataTypeDef);
        }
        return {
            ...mergedDataTypeDefinition,
            groupSafeValueFormatter: $437b23f6a393c3bf$var$createGroupSafeValueFormatter(mergedDataTypeDefinition, this.gos)
        };
    }
    updateColDefAndGetColumnType(colDef, userColDef, colId) {
        let { cellDataType: cellDataType } = userColDef;
        const { field: field } = userColDef;
        if (cellDataType === void 0) cellDataType = colDef.cellDataType;
        if (cellDataType == null || cellDataType === true) cellDataType = this.canInferCellDataType(colDef, userColDef) ? this.inferCellDataType(field, colId) : false;
        if (!cellDataType) {
            colDef.cellDataType = false;
            return void 0;
        }
        const dataTypeDefinition = this.dataTypeDefinitions[cellDataType];
        if (!dataTypeDefinition) {
            $437b23f6a393c3bf$export$545083624300f13d(47, {
                cellDataType: cellDataType
            });
            return void 0;
        }
        colDef.cellDataType = cellDataType;
        if (dataTypeDefinition.groupSafeValueFormatter) colDef.valueFormatter = dataTypeDefinition.groupSafeValueFormatter;
        if (dataTypeDefinition.valueParser) colDef.valueParser = dataTypeDefinition.valueParser;
        if (!dataTypeDefinition.suppressDefaultProperties) this.setColDefPropertiesForBaseDataType(colDef, cellDataType, dataTypeDefinition, colId);
        return dataTypeDefinition.columnTypes;
    }
    addColumnListeners(column) {
        if (!this.isPendingInference) return;
        const columnStateUpdates = this.columnStateUpdatesPendingInference[column.getColId()];
        if (!columnStateUpdates) return;
        const columnListener = (event)=>{
            columnStateUpdates.add(event.key);
        };
        column.__addEventListener("columnStateUpdated", columnListener);
        this.columnStateUpdateListenerDestroyFuncs.push(()=>column.__removeEventListener("columnStateUpdated", columnListener));
    }
    canInferCellDataType(colDef, userColDef) {
        const { gos: gos } = this;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos)) return false;
        const propsToCheckForInference = {
            cellRenderer: true,
            valueGetter: true,
            valueParser: true,
            refData: true
        };
        if ($437b23f6a393c3bf$var$doColDefPropsPreventInference(userColDef, propsToCheckForInference)) return false;
        const columnTypes = userColDef.type === null ? colDef.type : userColDef.type;
        if (columnTypes) {
            const columnTypeDefs = gos.get("columnTypes") ?? {};
            const hasPropsPreventingInference = $437b23f6a393c3bf$var$convertColumnTypes(columnTypes).some((columnType)=>{
                const columnTypeDef = columnTypeDefs[columnType.trim()];
                return columnTypeDef && $437b23f6a393c3bf$var$doColDefPropsPreventInference(columnTypeDef, propsToCheckForInference);
            });
            if (hasPropsPreventingInference) return false;
        }
        return !$437b23f6a393c3bf$var$doColDefPropsPreventInference(colDef, propsToCheckForInference);
    }
    inferCellDataType(field, colId) {
        if (!field) return void 0;
        let value;
        const initialData = this.getInitialData();
        if (initialData) {
            const fieldContainsDots = field.includes(".") && !this.gos.get("suppressFieldDotNotation");
            value = $437b23f6a393c3bf$var$_getValueUsingField(initialData, field, fieldContainsDots);
        } else this.initWaitForRowData(colId);
        if (value == null) return void 0;
        const matchedType = Object.keys(this.dataTypeMatchers).find((_cellDataType)=>this.dataTypeMatchers[_cellDataType](value));
        return matchedType ?? "object";
    }
    getInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData?.length) return rowData[0];
        else if (this.initialData) return this.initialData;
        else {
            const rowNodes = this.beans.rowModel.rootNode?._leafs;
            if (rowNodes?.length) return rowNodes[0].data;
        }
        return null;
    }
    initWaitForRowData(colId) {
        this.columnStateUpdatesPendingInference[colId] = /* @__PURE__ */ new Set();
        if (this.isPendingInference) return;
        this.isPendingInference = true;
        const columnTypeOverridesExist = this.isColumnTypeOverrideInDataTypeDefinitions;
        const { colAutosize: colAutosize, eventSvc: eventSvc } = this.beans;
        if (columnTypeOverridesExist && colAutosize) colAutosize.shouldQueueResizeOperations = true;
        const [destroyFunc] = this.addManagedEventListeners({
            rowDataUpdateStarted: (event)=>{
                const { firstRowData: firstRowData } = event;
                if (!firstRowData) return;
                destroyFunc?.();
                this.isPendingInference = false;
                this.processColumnsPendingInference(firstRowData, columnTypeOverridesExist);
                this.columnStateUpdatesPendingInference = {};
                if (columnTypeOverridesExist) colAutosize?.processResizeOperations();
                eventSvc.dispatchEvent({
                    type: "dataTypesInferred"
                });
            }
        });
    }
    processColumnsPendingInference(firstRowData, columnTypeOverridesExist) {
        this.initialData = firstRowData;
        const state = [];
        this.destroyColumnStateUpdateListeners();
        const newRowGroupColumnStateWithoutIndex = {};
        const newPivotColumnStateWithoutIndex = {};
        for (const colId of Object.keys(this.columnStateUpdatesPendingInference)){
            const columnStateUpdates = this.columnStateUpdatesPendingInference[colId];
            const column = this.colModel.getCol(colId);
            if (!column) return;
            const oldColDef = column.getColDef();
            if (!this.resetColDefIntoCol(column, "cellDataTypeInferred")) return;
            const newColDef = column.getColDef();
            if (columnTypeOverridesExist && newColDef.type && newColDef.type !== oldColDef.type) {
                const updatedColumnState = $437b23f6a393c3bf$var$getUpdatedColumnState(column, columnStateUpdates);
                if (updatedColumnState.rowGroup && updatedColumnState.rowGroupIndex == null) newRowGroupColumnStateWithoutIndex[colId] = updatedColumnState;
                if (updatedColumnState.pivot && updatedColumnState.pivotIndex == null) newPivotColumnStateWithoutIndex[colId] = updatedColumnState;
                state.push(updatedColumnState);
            }
        }
        if (columnTypeOverridesExist) state.push(...this.generateColumnStateForRowGroupAndPivotIndexes(newRowGroupColumnStateWithoutIndex, newPivotColumnStateWithoutIndex));
        if (state.length) $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
            state: state
        }, "cellDataTypeInferred");
        this.initialData = null;
    }
    generateColumnStateForRowGroupAndPivotIndexes(updatedRowGroupColumnState, updatedPivotColumnState) {
        const existingColumnStateUpdates = {};
        const { rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = this.beans;
        rowGroupColsSvc?.restoreColumnOrder(existingColumnStateUpdates, updatedRowGroupColumnState);
        pivotColsSvc?.restoreColumnOrder(existingColumnStateUpdates, updatedPivotColumnState);
        return Object.values(existingColumnStateUpdates);
    }
    resetColDefIntoCol(column, source) {
        const userColDef = column.getUserProvidedColDef();
        if (!userColDef) return false;
        const newColDef = $437b23f6a393c3bf$export$310bdd432cb2279e(this.beans, userColDef, column.getColId());
        column.setColDef(newColDef, userColDef, source);
        return true;
    }
    getDateStringTypeDefinition(column) {
        const { dateString: dateString } = this.dataTypeDefinitions;
        if (!column) return dateString;
        return this.getDataTypeDefinition(column) ?? dateString;
    }
    getDateParserFunction(column) {
        return this.getDateStringTypeDefinition(column).dateParser;
    }
    getDateFormatterFunction(column) {
        return this.getDateStringTypeDefinition(column).dateFormatter;
    }
    getDateIncludesTimeFlag(cellDataType) {
        return cellDataType === "dateTime" || cellDataType === "dateTimeString";
    }
    getDataTypeDefinition(column) {
        const colDef = column.getColDef();
        if (!colDef.cellDataType) return void 0;
        return this.dataTypeDefinitions[colDef.cellDataType];
    }
    getBaseDataType(column) {
        return this.getDataTypeDefinition(column)?.baseDataType;
    }
    checkType(column, value) {
        if (value == null) return true;
        const dataTypeMatcher = this.getDataTypeDefinition(column)?.dataTypeMatcher;
        if (!dataTypeMatcher) return true;
        return dataTypeMatcher(value);
    }
    validateColDef(colDef) {
        const warning = (property)=>$437b23f6a393c3bf$export$545083624300f13d(48, {
                property: property
            });
        if (colDef.cellDataType === "object") {
            const { object: object } = this.dataTypeDefinitions;
            if (colDef.valueFormatter === object.groupSafeValueFormatter && !this.hasObjectValueFormatter) warning("Formatter");
            if (colDef.editable && colDef.valueParser === object.valueParser && !this.hasObjectValueParser) warning("Parser");
        }
    }
    postProcess(colDef) {
        const cellDataType = colDef.cellDataType;
        if (!cellDataType || typeof cellDataType !== "string") return;
        const { dataTypeDefinitions: dataTypeDefinitions, beans: beans, formatValueFuncs: formatValueFuncs } = this;
        const dataTypeDefinition = dataTypeDefinitions[cellDataType];
        if (!dataTypeDefinition) return;
        beans.colFilter?.setColDefPropsForDataType(colDef, dataTypeDefinition, formatValueFuncs[cellDataType]);
    }
    // noinspection JSUnusedGlobalSymbols
    getFormatValue(cellDataType) {
        return this.formatValueFuncs[cellDataType];
    }
    isColPendingInference(colId) {
        return this.isPendingInference && !!this.columnStateUpdatesPendingInference[colId];
    }
    setColDefPropertiesForBaseDataType(colDef, cellDataType, dataTypeDefinition, colId) {
        const formatValue = this.formatValueFuncs[cellDataType];
        const partialColDef = this.columnDefinitionPropsPerDataType[dataTypeDefinition.baseDataType]({
            colDef: colDef,
            cellDataType: cellDataType,
            colModel: this.colModel,
            dataTypeDefinition: dataTypeDefinition,
            colId: colId,
            formatValue: formatValue
        });
        Object.assign(colDef, partialColDef);
    }
    getDateObjectTypeDef(baseDataType) {
        const translate = this.getLocaleTextFunc();
        const includeTime = this.getDateIncludesTimeFlag(baseDataType);
        return {
            baseDataType: baseDataType,
            valueParser: (params)=>$437b23f6a393c3bf$export$26ded2d88c01b527(params.newValue && String(params.newValue)),
            valueFormatter: (params)=>{
                if (params.value == null) return "";
                if (!(params.value instanceof Date) || isNaN(params.value.getTime())) return translate("invalidDate", "Invalid Date");
                return $437b23f6a393c3bf$export$3d7fedfb21962874(params.value, includeTime) ?? "";
            },
            dataTypeMatcher: (value)=>value instanceof Date
        };
    }
    getDateStringTypeDef(baseDataType) {
        const includeTime = this.getDateIncludesTimeFlag(baseDataType);
        return {
            baseDataType: baseDataType,
            dateParser: (value)=>$437b23f6a393c3bf$export$26ded2d88c01b527(value) ?? void 0,
            dateFormatter: (value)=>$437b23f6a393c3bf$export$3d7fedfb21962874(value ?? null, includeTime) ?? void 0,
            valueParser: (params)=>$437b23f6a393c3bf$var$_isValidDate(String(params.newValue)) ? params.newValue : null,
            valueFormatter: (params)=>$437b23f6a393c3bf$var$_isValidDate(String(params.value)) ? String(params.value) : "",
            dataTypeMatcher: (value)=>typeof value === "string" && $437b23f6a393c3bf$var$_isValidDate(value)
        };
    }
    getDefaultDataTypes() {
        const translate = this.getLocaleTextFunc();
        return {
            number: {
                baseDataType: "number",
                // can be empty space with legacy copy
                valueParser: (params)=>params.newValue?.trim?.() === "" ? null : Number(params.newValue),
                valueFormatter: (params)=>{
                    if (params.value == null) return "";
                    if (typeof params.value !== "number" || isNaN(params.value)) return translate("invalidNumber", "Invalid Number");
                    return String(params.value);
                },
                dataTypeMatcher: (value)=>typeof value === "number"
            },
            text: {
                baseDataType: "text",
                valueParser: (params)=>params.newValue === "" ? null : $437b23f6a393c3bf$export$2a74c29220d5c88e(params.newValue),
                dataTypeMatcher: (value)=>typeof value === "string"
            },
            boolean: {
                baseDataType: "boolean",
                valueParser: (params)=>{
                    if (params.newValue == null) return params.newValue;
                    return params.newValue?.trim?.() === "" ? null : String(params.newValue).toLowerCase() === "true";
                },
                valueFormatter: (params)=>params.value == null ? "" : String(params.value),
                dataTypeMatcher: (value)=>typeof value === "boolean"
            },
            date: this.getDateObjectTypeDef("date"),
            dateString: this.getDateStringTypeDef("dateString"),
            dateTime: this.getDateObjectTypeDef("dateTime"),
            dateTimeString: {
                ...this.getDateStringTypeDef("dateTimeString"),
                dataTypeMatcher: (value)=>typeof value === "string" && $437b23f6a393c3bf$var$_isValidDateTime(value)
            },
            object: {
                baseDataType: "object",
                valueParser: ()=>null,
                valueFormatter: (params)=>$437b23f6a393c3bf$export$2a74c29220d5c88e(params.value) ?? ""
            }
        };
    }
    destroyColumnStateUpdateListeners() {
        for (const destroyFunc of this.columnStateUpdateListenerDestroyFuncs)destroyFunc();
        this.columnStateUpdateListenerDestroyFuncs = [];
    }
    destroy() {
        this.dataTypeDefinitions = {};
        this.dataTypeMatchers = {};
        this.formatValueFuncs = {};
        this.columnStateUpdatesPendingInference = {};
        this.destroyColumnStateUpdateListeners();
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$mergeDataTypeDefinitions(parentDataTypeDefinition, childDataTypeDefinition) {
    const mergedDataTypeDefinition = {
        ...parentDataTypeDefinition,
        ...childDataTypeDefinition
    };
    if (parentDataTypeDefinition.columnTypes && childDataTypeDefinition.columnTypes && childDataTypeDefinition.appendColumnTypes) mergedDataTypeDefinition.columnTypes = [
        ...$437b23f6a393c3bf$var$convertColumnTypes(parentDataTypeDefinition.columnTypes),
        ...$437b23f6a393c3bf$var$convertColumnTypes(childDataTypeDefinition.columnTypes)
    ];
    return mergedDataTypeDefinition;
}
function $437b23f6a393c3bf$var$validateDataTypeDefinition(dataTypeDefinition, parentDataTypeDefinition, parentCellDataType) {
    if (!parentDataTypeDefinition) {
        $437b23f6a393c3bf$export$545083624300f13d(45, {
            parentCellDataType: parentCellDataType
        });
        return false;
    }
    if (parentDataTypeDefinition.baseDataType !== dataTypeDefinition.baseDataType) {
        $437b23f6a393c3bf$export$545083624300f13d(46);
        return false;
    }
    return true;
}
function $437b23f6a393c3bf$var$createGroupSafeValueFormatter(dataTypeDefinition, gos) {
    if (!dataTypeDefinition.valueFormatter) return void 0;
    return (params)=>{
        if (params.node?.group) {
            const aggFunc = (params.colDef.pivotValueColumn ?? params.column).getAggFunc();
            if (aggFunc) {
                if (aggFunc === "first" || aggFunc === "last") return dataTypeDefinition.valueFormatter(params);
                if (dataTypeDefinition.baseDataType === "number" && aggFunc !== "count") {
                    if (typeof params.value === "number") return dataTypeDefinition.valueFormatter(params);
                    if (typeof params.value === "object") {
                        if (!params.value) return void 0;
                        if ("toNumber" in params.value) return dataTypeDefinition.valueFormatter({
                            ...params,
                            value: params.value.toNumber()
                        });
                        if ("value" in params.value) return dataTypeDefinition.valueFormatter({
                            ...params,
                            value: params.value.value
                        });
                    }
                }
                return void 0;
            }
        } else if (gos.get("groupHideOpenParents") && params.column.isRowGroupActive()) {
            if (typeof params.value === "string" && !dataTypeDefinition.dataTypeMatcher?.(params.value)) return void 0;
        }
        return dataTypeDefinition.valueFormatter(params);
    };
}
function $437b23f6a393c3bf$var$doesColDefPropPreventInference(colDef, checkProps, prop, comparisonValue) {
    if (!checkProps[prop]) return false;
    const value = colDef[prop];
    if (value === null) {
        checkProps[prop] = false;
        return false;
    } else return comparisonValue === void 0 ? !!value : value === comparisonValue;
}
function $437b23f6a393c3bf$var$doColDefPropsPreventInference(colDef, propsToCheckForInference) {
    return [
        [
            "cellRenderer",
            "agSparklineCellRenderer"
        ],
        [
            "valueGetter",
            void 0
        ],
        [
            "valueParser",
            void 0
        ],
        [
            "refData",
            void 0
        ]
    ].some(([prop, comparisonValue])=>$437b23f6a393c3bf$var$doesColDefPropPreventInference(colDef, propsToCheckForInference, prop, comparisonValue));
}
function $437b23f6a393c3bf$var$getUpdatedColumnState(column, columnStateUpdates) {
    const columnState = $437b23f6a393c3bf$var$getColumnStateFromColDef(column);
    for (const key of columnStateUpdates){
        delete columnState[key];
        if (key === "rowGroup") delete columnState.rowGroupIndex;
        else if (key === "pivot") delete columnState.pivotIndex;
    }
    return columnState;
}
// packages/ag-grid-community/src/columns/columnModule.ts
var $437b23f6a393c3bf$var$DataTypeModule = {
    moduleName: "DataType",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DataTypeService
    ],
    dependsOn: [
        $437b23f6a393c3bf$var$CheckboxCellRendererModule
    ]
};
var $437b23f6a393c3bf$var$ColumnFlexModule = {
    moduleName: "ColumnFlex",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnFlexService
    ]
};
var $437b23f6a393c3bf$export$5c4abee658e86c68 = {
    moduleName: "ColumnApi",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnDefFactory
    ],
    apiFunctions: {
        getColumnDef: $437b23f6a393c3bf$var$getColumnDef,
        getDisplayNameForColumn: $437b23f6a393c3bf$var$getDisplayNameForColumn,
        getColumn: $437b23f6a393c3bf$var$getColumn,
        getColumns: $437b23f6a393c3bf$var$getColumns,
        applyColumnState: $437b23f6a393c3bf$var$applyColumnState,
        getColumnState: $437b23f6a393c3bf$var$getColumnState,
        resetColumnState: $437b23f6a393c3bf$var$resetColumnState,
        isPinning: $437b23f6a393c3bf$var$isPinning,
        isPinningLeft: $437b23f6a393c3bf$var$isPinningLeft,
        isPinningRight: $437b23f6a393c3bf$var$isPinningRight,
        getDisplayedColAfter: $437b23f6a393c3bf$var$getDisplayedColAfter,
        getDisplayedColBefore: $437b23f6a393c3bf$var$getDisplayedColBefore,
        setColumnsVisible: $437b23f6a393c3bf$var$setColumnsVisible,
        setColumnsPinned: $437b23f6a393c3bf$var$setColumnsPinned,
        getAllGridColumns: $437b23f6a393c3bf$var$getAllGridColumns,
        getDisplayedLeftColumns: $437b23f6a393c3bf$var$getDisplayedLeftColumns,
        getDisplayedCenterColumns: $437b23f6a393c3bf$var$getDisplayedCenterColumns,
        getDisplayedRightColumns: $437b23f6a393c3bf$var$getDisplayedRightColumns,
        getAllDisplayedColumns: $437b23f6a393c3bf$var$getAllDisplayedColumns,
        getAllDisplayedVirtualColumns: $437b23f6a393c3bf$var$getAllDisplayedVirtualColumns,
        getColumnDefs: $437b23f6a393c3bf$var$getColumnDefs
    }
};
// packages/ag-grid-community/src/columns/columnNameService.ts
function $437b23f6a393c3bf$var$_camelCaseToHumanText(camelCase) {
    if (!camelCase || camelCase == null) return null;
    const rex = /([a-z])([A-Z])/g;
    const rexCaps = /([A-Z]+)([A-Z])([a-z])/g;
    const words = camelCase.replace(rex, "$1 $2").replace(rexCaps, "$1 $2$3").replace(/\./g, " ").split(" ");
    return words.map((word)=>word.substring(0, 1).toUpperCase() + (word.length > 1 ? word.substring(1, word.length) : "")).join(" ");
}
var $437b23f6a393c3bf$var$ColumnNameService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colNames";
    }
    getDisplayNameForColumn(column, location, includeAggFunc = false) {
        if (!column) return null;
        const headerName = this.getHeaderName(column.getColDef(), column, null, null, location);
        const { aggColNameSvc: aggColNameSvc } = this.beans;
        if (includeAggFunc && aggColNameSvc) return aggColNameSvc.getHeaderName(column, headerName);
        return headerName;
    }
    getDisplayNameForProvidedColumnGroup(columnGroup, providedColumnGroup, location) {
        const colGroupDef = providedColumnGroup?.getColGroupDef();
        if (colGroupDef) return this.getHeaderName(colGroupDef, null, columnGroup, providedColumnGroup, location);
        return null;
    }
    getDisplayNameForColumnGroup(columnGroup, location) {
        return this.getDisplayNameForProvidedColumnGroup(columnGroup, columnGroup.getProvidedColumnGroup(), location);
    }
    // location is where the column is going to appear, ie who is calling us
    getHeaderName(colDef, column, columnGroup, providedColumnGroup, location) {
        const headerValueGetter = colDef.headerValueGetter;
        if (headerValueGetter) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                colDef: colDef,
                column: column,
                columnGroup: columnGroup,
                providedColumnGroup: providedColumnGroup,
                location: location
            });
            if (typeof headerValueGetter === "function") return headerValueGetter(params);
            else if (typeof headerValueGetter === "string") return this.beans.expressionSvc?.evaluate(headerValueGetter, params) ?? null;
            return "";
        } else if (colDef.headerName != null) return colDef.headerName;
        else if (colDef.field) return $437b23f6a393c3bf$var$_camelCaseToHumanText(colDef.field);
        return "";
    }
};
// packages/ag-grid-community/src/columns/columnViewportService.ts
var $437b23f6a393c3bf$var$ColumnViewportService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colViewport";
        // cols in center that are in the viewport
        this.colsWithinViewport = [];
        // same as colsWithinViewport, except we always include columns with headerAutoHeight
        this.headerColsWithinViewport = [];
        // A hash key to keep track of changes in viewport columns
        this.colsWithinViewportHash = "";
        // all columns & groups to be rendered, index by row.
        // used by header rows to get all items to render for that row.
        this.rowsOfHeadersToRenderLeft = {};
        this.rowsOfHeadersToRenderRight = {};
        this.rowsOfHeadersToRenderCenter = {};
        this.columnsToRenderLeft = [];
        this.columnsToRenderRight = [];
        this.columnsToRenderCenter = [];
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.colModel = beans.colModel;
    }
    postConstruct() {
        this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
    }
    setScrollPosition(scrollWidth, scrollPosition, afterScroll = false) {
        const { visibleCols: visibleCols } = this;
        const bodyWidthDirty = visibleCols.isBodyWidthDirty;
        const noChange = scrollWidth === this.scrollWidth && scrollPosition === this.scrollPosition && !bodyWidthDirty;
        if (noChange) return;
        this.scrollWidth = scrollWidth;
        this.scrollPosition = scrollPosition;
        visibleCols.isBodyWidthDirty = true;
        if (this.gos.get("enableRtl")) {
            const bodyWidth = visibleCols.bodyWidth;
            this.viewportLeft = bodyWidth - scrollPosition - scrollWidth;
            this.viewportRight = bodyWidth - scrollPosition;
        } else {
            this.viewportLeft = scrollPosition;
            this.viewportRight = scrollWidth + scrollPosition;
        }
        if (this.colModel.ready) this.checkViewportColumns(afterScroll);
    }
    /**
   * Returns the columns that are currently rendered in the viewport.
   */ getColumnHeadersToRender(type) {
        switch(type){
            case "left":
                return this.columnsToRenderLeft;
            case "right":
                return this.columnsToRenderRight;
            default:
                return this.columnsToRenderCenter;
        }
    }
    /**
   * Returns the column groups that are currently rendered in the viewport at a specific header row index.
   */ getHeadersToRender(type, depth) {
        let result;
        switch(type){
            case "left":
                result = this.rowsOfHeadersToRenderLeft[depth];
                break;
            case "right":
                result = this.rowsOfHeadersToRenderRight[depth];
                break;
            default:
                result = this.rowsOfHeadersToRenderCenter[depth];
                break;
        }
        return result ?? [];
    }
    extractViewportColumns() {
        const displayedColumnsCenter = this.visibleCols.centerCols;
        if (this.isColumnVirtualisationSuppressed()) {
            this.colsWithinViewport = displayedColumnsCenter;
            this.headerColsWithinViewport = displayedColumnsCenter;
        } else {
            this.colsWithinViewport = displayedColumnsCenter.filter(this.isColumnInRowViewport.bind(this));
            this.headerColsWithinViewport = displayedColumnsCenter.filter(this.isColumnInHeaderViewport.bind(this));
        }
    }
    isColumnVirtualisationSuppressed() {
        return this.suppressColumnVirtualisation || this.viewportRight === 0;
    }
    clear() {
        this.rowsOfHeadersToRenderLeft = {};
        this.rowsOfHeadersToRenderRight = {};
        this.rowsOfHeadersToRenderCenter = {};
        this.colsWithinViewportHash = "";
    }
    isColumnInHeaderViewport(col) {
        if (col.isAutoHeaderHeight() || $437b23f6a393c3bf$var$isAnyParentAutoHeaderHeight(col)) return true;
        return this.isColumnInRowViewport(col);
    }
    isColumnInRowViewport(col) {
        if (col.isAutoHeight()) return true;
        const columnLeft = col.getLeft() || 0;
        const columnRight = columnLeft + col.getActualWidth();
        const leftBounds = this.viewportLeft - 200;
        const rightBounds = this.viewportRight + 200;
        const columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
        const columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
        return !columnToMuchLeft && !columnToMuchRight;
    }
    // used by Grid API only
    getViewportColumns() {
        const { leftCols: leftCols, rightCols: rightCols } = this.visibleCols;
        const res = this.colsWithinViewport.concat(leftCols).concat(rightCols);
        return res;
    }
    // + rowRenderer
    // if we are not column spanning, this just returns back the virtual centre columns,
    // however if we are column spanning, then different rows can have different virtual
    // columns, so we have to work out the list for each individual row.
    getColsWithinViewport(rowNode) {
        if (!this.colModel.colSpanActive) return this.colsWithinViewport;
        const emptySpaceBeforeColumn = (col)=>{
            const left = col.getLeft();
            return $437b23f6a393c3bf$export$25d27f17d3af40f7(left) && left > this.viewportLeft;
        };
        const inViewportCallback = this.isColumnVirtualisationSuppressed() ? void 0 : this.isColumnInRowViewport.bind(this);
        const { visibleCols: visibleCols } = this;
        const displayedColumnsCenter = visibleCols.centerCols;
        return visibleCols.getColsForRow(rowNode, displayedColumnsCenter, inViewportCallback, emptySpaceBeforeColumn);
    }
    // checks what columns are currently displayed due to column virtualisation. dispatches an event
    // if the list of columns has changed.
    // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
    checkViewportColumns(afterScroll = false) {
        const viewportColumnsChanged = this.extractViewport();
        if (viewportColumnsChanged) this.eventSvc.dispatchEvent({
            type: "virtualColumnsChanged",
            afterScroll: afterScroll
        });
    }
    calculateHeaderRows() {
        const { leftCols: leftCols, rightCols: rightCols } = this.visibleCols;
        this.columnsToRenderLeft = leftCols;
        this.columnsToRenderRight = rightCols;
        this.columnsToRenderCenter = this.colsWithinViewport;
        const workOutGroupsToRender = (cols)=>{
            const groupsToRenderSet = /* @__PURE__ */ new Set();
            const groupsToRender = {};
            for (const col of cols){
                let group = col.getParent();
                const skipFillers = col.isSpanHeaderHeight();
                while(group){
                    if (groupsToRenderSet.has(group)) break;
                    const skipFillerGroup = skipFillers && group.isPadding();
                    if (skipFillerGroup) {
                        group = group.getParent();
                        continue;
                    }
                    const level = group.getProvidedColumnGroup().getLevel();
                    groupsToRender[level] ?? (groupsToRender[level] = []);
                    groupsToRender[level].push(group);
                    groupsToRenderSet.add(group);
                    group = group.getParent();
                }
            }
            return groupsToRender;
        };
        this.rowsOfHeadersToRenderLeft = workOutGroupsToRender(leftCols);
        this.rowsOfHeadersToRenderRight = workOutGroupsToRender(rightCols);
        this.rowsOfHeadersToRenderCenter = workOutGroupsToRender(this.headerColsWithinViewport);
    }
    extractViewport() {
        const hashColumn = (c)=>`${c.getId()}-${c.getPinned() || "normal"}`;
        this.extractViewportColumns();
        const newHash = this.getViewportColumns().map(hashColumn).join("#");
        const changed = this.colsWithinViewportHash !== newHash;
        if (changed) {
            this.colsWithinViewportHash = newHash;
            this.calculateHeaderRows();
        }
        return changed;
    }
};
function $437b23f6a393c3bf$var$isAnyParentAutoHeaderHeight(col) {
    while(col){
        if (col.isAutoHeaderHeight()) return true;
        col = col.getParent();
    }
    return false;
}
// packages/ag-grid-community/src/components/framework/agComponentUtils.ts
var $437b23f6a393c3bf$var$AgComponentUtils = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "agCompUtils";
    }
    adaptFunction(type, jsCompFunc) {
        if (!type.cellRenderer) return null;
        class Adapter {
            refresh() {
                return false;
            }
            getGui() {
                return this.eGui;
            }
            init(params) {
                const callbackResult = jsCompFunc(params);
                const type2 = typeof callbackResult;
                if (type2 === "string" || type2 === "number" || type2 === "boolean") {
                    this.eGui = $437b23f6a393c3bf$export$b1f57d075ca6d5fb("<span>" + callbackResult + "</span>");
                    return;
                }
                if (callbackResult == null) {
                    this.eGui = $437b23f6a393c3bf$export$a232bb0480ae674a({
                        tag: "span"
                    });
                    return;
                }
                this.eGui = callbackResult;
            }
        }
        return Adapter;
    }
};
// packages/ag-grid-community/src/components/framework/cellRendererFunctionModule.ts
var $437b23f6a393c3bf$var$CellRendererFunctionModule = {
    moduleName: "CellRendererFunction",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AgComponentUtils
    ]
};
// packages/ag-grid-community/src/components/framework/registry.ts
var $437b23f6a393c3bf$var$Registry = class extends $437b23f6a393c3bf$export$95e025d9098f4893 {
    constructor(){
        super(...arguments);
        this.agGridDefaults = {};
        this.agGridDefaultOverrides = {};
        this.jsComps = {};
        this.selectors = {};
        this.icons = {};
    }
    postConstruct() {
        const comps = this.gos.get("components");
        if (comps != null) for (const key of Object.keys(comps))this.jsComps[key] = comps[key];
    }
    registerModule(module) {
        const { icons: icons, userComponents: userComponents, dynamicBeans: dynamicBeans, selectors: selectors } = module;
        if (userComponents) {
            const registerUserComponent = (name, component, params, processParams)=>{
                this.agGridDefaults[name] = component;
                if (params || processParams) this.agGridDefaultOverrides[name] = {
                    params: params,
                    processParams: processParams
                };
            };
            for (const name of Object.keys(userComponents)){
                let comp = userComponents[name];
                if ($437b23f6a393c3bf$var$isComponentMetaFunc(comp)) comp = comp.getComp(this.beans);
                if (typeof comp === "object") {
                    const { classImp: classImp, params: params, processParams: processParams } = comp;
                    registerUserComponent(name, classImp, params, processParams);
                } else registerUserComponent(name, comp);
            }
        }
        this.registerDynamicBeans(dynamicBeans);
        for (const selector of selectors ?? [])this.selectors[selector.selector] = selector;
        if (icons) for (const name of Object.keys(icons))this.icons[name] = icons[name];
    }
    getUserComponent(propertyName, name) {
        const createResult = (component, componentFromFramework, params, processParams)=>({
                componentFromFramework: componentFromFramework,
                component: component,
                params: params,
                processParams: processParams
            });
        const { frameworkOverrides: frameworkOverrides } = this.beans;
        const registeredViaFrameworkComp = frameworkOverrides.frameworkComponent(name, this.gos.get("components"));
        if (registeredViaFrameworkComp != null) return createResult(registeredViaFrameworkComp, true);
        const jsComponent = this.jsComps[name];
        if (jsComponent) {
            const isFwkComp = frameworkOverrides.isFrameworkComponent(jsComponent);
            return createResult(jsComponent, isFwkComp);
        }
        const defaultComponent = this.agGridDefaults[name];
        if (defaultComponent) {
            const overrides = this.agGridDefaultOverrides[name];
            return createResult(defaultComponent, false, overrides?.params, overrides?.processParams);
        }
        this.beans.validation?.missingUserComponent(propertyName, name, this.agGridDefaults, this.jsComps);
        return null;
    }
    getSelector(name) {
        return this.selectors[name];
    }
    getIcon(name) {
        return this.icons[name];
    }
    getDynamicError(name, init) {
        if (init) return $437b23f6a393c3bf$export$680bb5102fca525e(279, {
            name: name
        });
        return this.beans.validation?.missingDynamicBean(name) ?? $437b23f6a393c3bf$export$680bb5102fca525e(256);
    }
};
// packages/ag-grid-community/src/ctrlsService.ts
var $437b23f6a393c3bf$var$NUM_CTRLS = 23;
var $437b23f6a393c3bf$var$CtrlsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "ctrlsSvc";
        this.params = {};
        this.ready = false;
        this.readyCallbacks = [];
    }
    postConstruct() {
        this.addEventListener("ready", ()=>{
            this.updateReady();
            if (this.ready) {
                for (const callback of this.readyCallbacks)callback(this.params);
                this.readyCallbacks.length = 0;
            }
        }, this.beans.frameworkOverrides.runWhenReadyAsync?.() ?? false);
    }
    updateReady() {
        const values = Object.values(this.params);
        this.ready = values.length === $437b23f6a393c3bf$var$NUM_CTRLS && values.every((ctrl)=>{
            return ctrl?.isAlive() ?? false;
        });
    }
    whenReady(caller, callback) {
        if (this.ready) callback(this.params);
        else this.readyCallbacks.push(callback);
        caller.addDestroyFunc(()=>{
            const index = this.readyCallbacks.indexOf(callback);
            if (index >= 0) this.readyCallbacks.splice(index, 1);
        });
    }
    register(ctrlType, ctrl) {
        this.params[ctrlType] = ctrl;
        this.updateReady();
        if (this.ready) this.dispatchLocalEvent({
            type: "ready"
        });
        ctrl.addDestroyFunc(()=>{
            this.updateReady();
        });
    }
    get(ctrlType) {
        return this.params[ctrlType];
    }
    getGridBodyCtrl() {
        return this.params.gridBodyCtrl;
    }
    getHeaderRowContainerCtrls() {
        const { leftHeader: leftHeader, centerHeader: centerHeader, rightHeader: rightHeader } = this.params;
        return [
            leftHeader,
            rightHeader,
            centerHeader
        ];
    }
    getHeaderRowContainerCtrl(pinned) {
        const params = this.params;
        switch(pinned){
            case "left":
                return params.leftHeader;
            case "right":
                return params.rightHeader;
            default:
                return params.centerHeader;
        }
    }
    getScrollFeature() {
        return this.getGridBodyCtrl().scrollFeature;
    }
};
// packages/ag-grid-community/src/theming/core/core.css-GENERATED.ts
var $437b23f6a393c3bf$var$coreCSS = /*css*/ `.ag-aria-description-container{border:0;z-index:9999;clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.ag-unselectable{-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-selectable{-webkit-user-select:text;-moz-user-select:text;user-select:text}.ag-tab-guard{display:block;height:0;position:absolute;width:0}:where(.ag-virtual-list-viewport) .ag-tab-guard{position:sticky}.ag-tab-guard-top{top:1px}.ag-tab-guard-bottom{bottom:1px}.ag-shake-left-to-right{animation-direction:alternate;animation-duration:.2s;animation-iteration-count:infinite;animation-name:ag-shake-left-to-right}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-body-horizontal-scroll-viewport,.ag-body-vertical-scroll-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport,.ag-virtual-list-viewport{flex:1 1 auto;height:100%;min-width:0;overflow:hidden;position:relative}.ag-viewport{position:relative}.ag-spanning-container{position:absolute;top:0;z-index:1}.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport{overflow-x:auto;-ms-overflow-style:none!important;scrollbar-width:none!important;&::-webkit-scrollbar{display:none!important}}.ag-body-viewport{display:flex;overflow-x:hidden;&:where(.ag-layout-normal){overflow-y:auto;-webkit-overflow-scrolling:touch}}.ag-floating-bottom-container,.ag-floating-top-container,.ag-sticky-bottom-container,.ag-sticky-top-container{min-height:1px}.ag-center-cols-viewport{min-height:100%;width:100%}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-body-vertical-scroll-viewport{overflow-y:scroll}.ag-virtual-list-viewport{overflow:auto;width:100%}.ag-body-container,.ag-body-horizontal-scroll-container,.ag-body-vertical-scroll-container,.ag-center-cols-container,.ag-floating-bottom-container,.ag-floating-bottom-full-width-container,.ag-floating-top-container,.ag-full-width-container,.ag-header-container,.ag-pinned-left-cols-container,.ag-pinned-right-cols-container,.ag-sticky-bottom-container,.ag-sticky-top-container,.ag-virtual-list-container{position:relative}.ag-floating-bottom-container,.ag-floating-top-container,.ag-header-container,.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top,.ag-sticky-bottom-container,.ag-sticky-top-container{height:100%;white-space:nowrap}.ag-center-cols-container,.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-body-vertical-scroll-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container,.ag-full-width-container,.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{pointer-events:none;position:absolute;top:0}:where(.ag-ltr) .ag-floating-bottom-full-width-container,:where(.ag-ltr) .ag-floating-top-full-width-container,:where(.ag-ltr) .ag-full-width-container,:where(.ag-ltr) .ag-sticky-bottom-full-width-container,:where(.ag-ltr) .ag-sticky-top-full-width-container{left:0}:where(.ag-rtl) .ag-floating-bottom-full-width-container,:where(.ag-rtl) .ag-floating-top-full-width-container,:where(.ag-rtl) .ag-full-width-container,:where(.ag-rtl) .ag-sticky-bottom-full-width-container,:where(.ag-rtl) .ag-sticky-top-full-width-container{right:0}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;height:100%;overflow:hidden;width:100%}.ag-virtual-list-container{overflow:hidden}.ag-body{display:flex;flex:1 1 auto;flex-direction:row!important;min-height:0;position:relative}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:flex;min-height:0;min-width:0;position:relative;&:where(.ag-scrollbar-invisible){bottom:0;position:absolute;&:where(.ag-apple-scrollbar){opacity:0;transition:opacity .4s;visibility:hidden;&:where(.ag-scrollbar-scrolling,.ag-scrollbar-active){opacity:1;visibility:visible}}}}.ag-body-horizontal-scroll{width:100%;&:where(.ag-scrollbar-invisible){left:0;right:0}}.ag-body-vertical-scroll{height:100%;&:where(.ag-scrollbar-invisible){top:0;z-index:10}}:where(.ag-ltr) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){right:0}}:where(.ag-rtl) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){left:0}}.ag-force-vertical-scroll{overflow-y:scroll!important}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll;&:where(.ag-scroller-corner){overflow-x:hidden}}:where(.ag-row-animation) .ag-row{transition:transform .4s,top .4s,opacity .2s;&:where(.ag-after-created){transition:transform .4s,top .4s,height .4s,opacity .2s}}:where(.ag-row-animation.ag-prevent-animation) .ag-row{transition:none!important;&:where(.ag-row.ag-after-created){transition:none!important}}:where(.ag-row-no-animation) .ag-row{transition:none}.ag-row-loading{align-items:center;display:flex}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{align-items:center;display:flex}.ag-cell{display:inline-block;height:100%;position:absolute;white-space:nowrap;&:focus-visible{box-shadow:none}}.ag-cell-value{flex:1 1 auto}.ag-cell-value:not(.ag-allow-overflow),.ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-cell-wrap-text{white-space:normal;word-break:break-word}:where(.ag-cell) .ag-icon{display:inline-block;vertical-align:middle}.ag-floating-top{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-top:not(.ag-invisible)){border-bottom:var(--ag-pinned-row-border)}.ag-floating-bottom{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-bottom:not(.ag-invisible)){border-top:var(--ag-pinned-row-border)}.ag-sticky-bottom,.ag-sticky-top{background-color:var(--ag-data-background-color);display:flex;height:0;overflow:hidden;position:absolute;width:100%;z-index:1}.ag-opacity-zero{opacity:0!important}.ag-cell-label-container{align-items:center;display:flex;flex-direction:row-reverse;height:100%;justify-content:space-between;width:100%}:where(.ag-right-aligned-header){.ag-cell-label-container{flex-direction:row}.ag-header-cell-text{text-align:end}}.ag-column-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr){direction:ltr;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row}}:where(.ag-rtl){direction:rtl;text-align:right;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row-reverse}.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{display:block}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(180deg)}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(-180deg)}}.ag-measurement-container{height:0;overflow:hidden;visibility:hidden;width:0}.ag-measurement-element-border{display:inline-block;&:before{border-left:var(--ag-internal-measurement-border);content:"";display:block}}.ag-group{position:relative;width:100%}.ag-group-title-bar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-title{display:inline;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-group-title-bar) .ag-group-title{cursor:default}.ag-group-toolbar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-container{display:flex}.ag-disabled .ag-group-container{pointer-events:none}.ag-disabled-group-container,.ag-disabled-group-title-bar{opacity:.5}.ag-group-container-horizontal{flex-flow:row wrap}.ag-group-container-vertical{flex-direction:column}.ag-group-title-bar-icon{cursor:pointer;flex:none}:where(.ag-ltr) .ag-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-group-title-bar-icon{margin-left:var(--ag-spacing)}:where(.ag-group-item-alignment-stretch) .ag-group-item{align-items:stretch}:where(.ag-group-item-alignment-start) .ag-group-item{align-items:flex-start}:where(.ag-group-item-alignment-end) .ag-group-item{align-items:flex-end}:where(.ag-ltr) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}:where(.ag-rtl) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}:where(.ag-ltr) .ag-row-group-leaf-indent{margin-left:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}:where(.ag-rtl) .ag-row-group-leaf-indent{margin-right:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}.ag-value-change-delta{padding:0 2px}.ag-value-change-delta-up{color:var(--ag-value-change-delta-up-color)}.ag-value-change-delta-down{color:var(--ag-value-change-delta-down-color)}.ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-value-change-value-highlight{background-color:var(--ag-value-change-value-highlight-background-color);transition:background-color .1s}.ag-cell-data-changed{background-color:var(--ag-value-change-value-highlight-background-color)!important}.ag-cell-data-changed-animation{background-color:transparent}.ag-cell-highlight{background-color:var(--ag-range-selection-highlight-color)!important}.ag-row,.ag-spanned-row{color:var(--ag-cell-text-color);font-family:var(--ag-cell-font-family);font-size:var(--ag-data-font-size);white-space:nowrap;--ag-internal-content-line-height:calc(min(var(--ag-row-height), var(--ag-line-height, 1000px)) - var(--ag-internal-row-border-width, 1px) - 2px)}.ag-row{background-color:var(--ag-data-background-color);border-bottom:var(--ag-row-border);height:var(--ag-row-height);width:100%;&.ag-row-editing-invalid{background-color:var(--ag-full-row-edit-invalid-background-color)}}:where(.ag-body-vertical-content-no-gap>div>div>div,.ag-body-vertical-content-no-gap>div>div>div>div)>.ag-row-last{border-bottom-color:transparent}.ag-sticky-bottom{border-top:var(--ag-row-border);box-sizing:content-box!important}.ag-group-contracted,.ag-group-expanded{cursor:pointer}.ag-cell,.ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;line-height:var(--ag-internal-content-line-height);-webkit-font-smoothing:subpixel-antialiased}:where(.ag-ltr) .ag-cell{border-right:var(--ag-column-border)}:where(.ag-rtl) .ag-cell{border-left:var(--ag-column-border)}.ag-spanned-cell-wrapper{background-color:var(--ag-data-background-color);position:absolute}.ag-spanned-cell-wrapper>.ag-spanned-cell{display:block;position:relative}:where(.ag-ltr) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-right-color:transparent}:where(.ag-rtl) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-left-color:transparent}.ag-cell-wrapper{align-items:center;display:flex;>:where(:not(.ag-cell-value,.ag-group-value)){align-items:center;display:flex;height:var(--ag-internal-content-line-height)}&:where(.ag-row-group){align-items:flex-start}:where(.ag-full-width-row) &:where(.ag-row-group){align-items:center;height:100%}}:where(.ag-ltr) .ag-cell-wrapper{padding-left:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-rtl) .ag-cell-wrapper{padding-right:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-cell-wrap-text:not(.ag-cell-auto-height)) .ag-cell-wrapper{align-items:normal;height:100%;:where(.ag-cell-value){height:100%}}:where(.ag-ltr) .ag-row>.ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-row>.ag-cell-wrapper.ag-row-group{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-cell-range-single-cell,.ag-cell-range-single-cell.ag-cell-range-handle,.ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-context-menu-open .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group{border:1px solid;border-color:var(--ag-range-selection-border-color);border-style:var(--ag-range-selection-border-style);outline:initial}.ag-full-width-row.ag-row-focus:focus{box-shadow:none}:where(.ag-ltr) .ag-group-contracted,:where(.ag-ltr) .ag-group-expanded,:where(.ag-ltr) .ag-row-drag,:where(.ag-ltr) .ag-selection-checkbox{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-contracted,:where(.ag-rtl) .ag-group-expanded,:where(.ag-rtl) .ag-row-drag,:where(.ag-rtl) .ag-selection-checkbox{margin-left:var(--ag-cell-widget-spacing)}:where(.ag-ltr) .ag-group-child-count{margin-left:3px}:where(.ag-rtl) .ag-group-child-count{margin-right:3px}.ag-row-highlight-above:after,.ag-row-highlight-below:after,.ag-row-highlight-inside:after{background-color:var(--ag-range-selection-border-color);content:"";height:1px;pointer-events:none;position:absolute;width:calc(100% - 1px)}:where(.ag-ltr) .ag-row-highlight-above:after,:where(.ag-ltr) .ag-row-highlight-below:after,:where(.ag-ltr) .ag-row-highlight-inside:after{left:1px}:where(.ag-rtl) .ag-row-highlight-above:after,:where(.ag-rtl) .ag-row-highlight-below:after,:where(.ag-rtl) .ag-row-highlight-inside:after{right:1px}.ag-row-highlight-above:after{top:0}.ag-row-highlight-below:after{bottom:0}.ag-row-highlight-indent:after{display:block;width:auto}:where(.ag-ltr) .ag-row-highlight-indent:after{left:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size));right:1px}:where(.ag-rtl) .ag-row-highlight-indent:after{left:1px;right:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size))}.ag-row-highlight-inside:after{background-color:var(--ag-selected-row-background-color);border:1px solid var(--ag-range-selection-border-color);display:block;height:auto;inset:0;width:auto}.ag-body,.ag-floating-bottom,.ag-floating-top{background-color:var(--ag-data-background-color)}.ag-row-odd{background-color:var(--ag-odd-row-background-color)}.ag-row-selected:before{background-color:var(--ag-selected-row-background-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-full-width-row.ag-row-group:before,.ag-row-hover:not(.ag-full-width-row):before{background-color:var(--ag-row-hover-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-row-selected:before{background-color:var(--ag-row-hover-color);background-image:linear-gradient(var(--ag-selected-row-background-color),var(--ag-selected-row-background-color))}.ag-row.ag-full-width-row.ag-row-group>*{position:relative}.ag-column-hover{background-color:var(--ag-column-hover-color)}.ag-header-range-highlight{background-color:var(--ag-range-header-highlight-color)}.ag-right-aligned-cell{font-variant-numeric:tabular-nums}:where(.ag-ltr) .ag-right-aligned-cell{text-align:right}:where(.ag-rtl) .ag-right-aligned-cell{text-align:left}.ag-right-aligned-cell .ag-cell-value,.ag-right-aligned-cell .ag-group-value{margin-left:auto}:where(.ag-ltr) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-ltr) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level));padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}:where(.ag-rtl) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-rtl) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-row>.ag-cell-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}.ag-row-dragging{cursor:move;opacity:.5}.ag-details-row{background-color:var(--ag-data-background-color);padding:calc(var(--ag-spacing)*3.75)}.ag-layout-auto-height,.ag-layout-print{.ag-center-cols-container,.ag-center-cols-viewport{min-height:150px}}.ag-overlay-loading-wrapper{background-color:var(--ag-modal-overlay-background-color)}.ag-skeleton-container{align-content:center;height:100%;width:100%}.ag-skeleton-effect{animation:ag-skeleton-loading 1.5s ease-in-out .5s infinite;background-color:var(--ag-row-loading-skeleton-effect-color);border-radius:.25rem;height:1em;width:100%}:where(.ag-ltr) .ag-right-aligned-cell .ag-skeleton-effect{margin-left:auto}:where(.ag-rtl) .ag-right-aligned-cell .ag-skeleton-effect{margin-right:auto}@keyframes ag-skeleton-loading{0%{background-color:var(--ag-row-loading-skeleton-effect-color)}50%{background-color:color-mix(in srgb,transparent,var(--ag-row-loading-skeleton-effect-color) 40%)}to{background-color:var(--ag-row-loading-skeleton-effect-color)}}.ag-loading{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-loading{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-loading{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-ltr) .ag-loading-icon{padding-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-loading-icon{padding-left:var(--ag-cell-widget-spacing)}.ag-icon-loading{animation-duration:1s;animation-iteration-count:infinite;animation-name:spin;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.ag-header{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);color:var(--ag-header-text-color);display:flex;font-family:var(--ag-header-font-family);font-size:var(--ag-header-font-size);font-weight:var(--ag-header-font-weight);overflow:hidden;white-space:nowrap;width:100%}.ag-header-row{height:var(--ag-header-height);position:absolute}.ag-floating-filter-button-button,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,:where(.ag-header-cell-sortable) .ag-header-cell-label{cursor:pointer}:where(.ag-ltr) .ag-header-expand-icon{margin-left:4px}:where(.ag-rtl) .ag-header-expand-icon{margin-right:4px}.ag-header-row:where(:not(:first-child)){:where(.ag-header-cell:not(.ag-header-span-height.ag-header-span-total,.ag-header-parent-hidden),.ag-header-group-cell.ag-header-group-cell-with-group){border-top:var(--ag-header-row-border)}}.ag-header-row:where(:not(.ag-header-row-column-group)){overflow:hidden}:where(.ag-header.ag-header-allow-overflow) .ag-header-row{overflow:visible}.ag-header-cell{display:inline-flex;overflow:hidden}.ag-header-group-cell{contain:paint;display:flex}.ag-header-cell,.ag-header-group-cell{align-items:center;gap:var(--ag-cell-widget-spacing);height:100%;padding:0 var(--ag-cell-horizontal-padding);position:absolute}@property --ag-internal-moving-color{syntax:"<color>";inherits:false;initial-value:transparent}@property --ag-internal-hover-color{syntax:"<color>";inherits:false;initial-value:transparent}.ag-header-cell:where(:not(.ag-floating-filter)),.ag-header-group-cell{&:before{background-image:linear-gradient(var(--ag-internal-hover-color),var(--ag-internal-hover-color)),linear-gradient(var(--ag-internal-moving-color),var(--ag-internal-moving-color));content:"";inset:0;position:absolute;--ag-internal-moving-color:transparent;--ag-internal-hover-color:transparent;transition:--ag-internal-moving-color var(--ag-header-cell-background-transition-duration),--ag-internal-hover-color var(--ag-header-cell-background-transition-duration)}&:where(:hover):before{--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}&:where(.ag-header-cell-moving):before{--ag-internal-moving-color:var(--ag-header-cell-moving-background-color);--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}}:where(.ag-header-cell:not(.ag-floating-filter) *,.ag-header-group-cell *){position:relative;z-index:1}.ag-header-cell-menu-button:where(:not(.ag-header-menu-always-show)){opacity:0;transition:opacity .2s}.ag-header-cell-filter-button,:where(.ag-header-cell.ag-header-active) .ag-header-cell-menu-button{opacity:1}.ag-header-cell-label,.ag-header-group-cell-label{align-items:center;align-self:stretch;display:flex;flex:1 1 auto;overflow:hidden;padding:5px 0}:where(.ag-ltr) .ag-sort-indicator-icon{padding-left:var(--ag-spacing)}:where(.ag-rtl) .ag-sort-indicator-icon{padding-right:var(--ag-spacing)}.ag-header-cell-label{text-overflow:ellipsis}.ag-header-group-cell-label.ag-sticky-label{flex:none;max-width:100%;overflow:visible;position:sticky}:where(.ag-ltr) .ag-header-group-cell-label.ag-sticky-label{left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-header-group-cell-label.ag-sticky-label{right:var(--ag-cell-horizontal-padding)}.ag-header-cell-text,.ag-header-group-text{overflow:hidden;text-overflow:ellipsis}.ag-header-cell-text{word-break:break-word}.ag-header-cell-comp-wrapper{width:100%}:where(.ag-header-group-cell) .ag-header-cell-comp-wrapper{display:flex}:where(.ag-header-cell:not(.ag-header-cell-auto-height)) .ag-header-cell-comp-wrapper{align-items:center;display:flex;height:100%}.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper{white-space:normal}.ag-header-cell-comp-wrapper-limited-height>*{overflow:hidden}:where(.ag-right-aligned-header) .ag-header-cell-label{flex-direction:row-reverse}:where(.ag-ltr) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-ltr) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}.ag-header-cell:after,.ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{content:"";height:var(--ag-header-column-border-height);position:absolute;top:calc(50% - var(--ag-header-column-border-height)*.5);z-index:1}:where(.ag-ltr) .ag-header-cell:after,:where(.ag-ltr) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-right:var(--ag-header-column-border);right:0}:where(.ag-rtl) .ag-header-cell:after,:where(.ag-rtl) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-left:var(--ag-header-column-border);left:0}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-accent-color);content:"";height:100%;position:absolute;width:1px}:where(.ag-ltr) .ag-header-highlight-before:after{left:0}:where(.ag-rtl) .ag-header-highlight-before:after{right:0}:where(.ag-ltr) .ag-header-highlight-after:after{right:0;:where(.ag-pinned-left-header) &{right:1px}}:where(.ag-rtl) .ag-header-highlight-after:after{left:0;:where(.ag-pinned-left-header) &{left:1px}}.ag-header-cell-resize{align-items:center;cursor:ew-resize;display:flex;height:100%;position:absolute;top:0;width:8px;z-index:2;&:after{background-color:var(--ag-header-column-resize-handle-color);content:"";height:var(--ag-header-column-resize-handle-height);position:absolute;top:calc(50% - var(--ag-header-column-resize-handle-height)*.5);width:var(--ag-header-column-resize-handle-width);z-index:1}}:where(.ag-ltr) .ag-header-cell-resize{right:-3px;&:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-rtl) .ag-header-cell-resize{left:-3px;&:after{right:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-header-cell.ag-header-span-height) .ag-header-cell-resize:after{height:calc(100% - var(--ag-spacing)*4);top:calc(var(--ag-spacing)*2)}.ag-header-group-cell-no-group:where(.ag-header-span-height){display:none}.ag-sort-indicator-container{display:flex;gap:var(--ag-spacing)}.ag-layout-print{&.ag-body{display:block;height:unset}&.ag-root-wrapper{display:inline-block}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:none}&.ag-force-vertical-scroll{overflow-y:visible!important}}@media print{.ag-root-wrapper.ag-layout-print{display:table;.ag-body-horizontal-scroll-viewport,.ag-body-viewport,.ag-center-cols-container,.ag-center-cols-viewport,.ag-root,.ag-root-wrapper-body,.ag-virtual-list-viewport{display:block!important;height:auto!important;overflow:hidden!important}.ag-cell,.ag-row{-moz-column-break-inside:avoid;break-inside:avoid}}}ag-grid,ag-grid-angular{display:block}.ag-root-wrapper{border:var(--ag-wrapper-border);border-radius:var(--ag-wrapper-border-radius);display:flex;flex-direction:column;overflow:hidden;position:relative;&.ag-layout-normal{height:100%}}.ag-root-wrapper-body{display:flex;flex-direction:row;&.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}}.ag-root{display:flex;flex-direction:column;position:relative;&.ag-layout-auto-height,&.ag-layout-normal{flex:1 1 auto;overflow:hidden;width:0}&.ag-layout-normal{height:100%}}.ag-virtual-list-item{height:var(--ag-list-item-height);position:absolute;width:100%}.ag-list-item-hovered:after{background-color:var(--ag-accent-color);content:"";height:1px;left:0;position:absolute;right:0}.ag-item-highlight-top:after{top:0}.ag-item-highlight-bottom:after{bottom:0}.ag-drag-handle{color:var(--ag-drag-handle-color);cursor:grab;:where(.ag-icon){color:var(--ag-drag-handle-color)}}.ag-chart-menu-icon,.ag-chart-settings-next,.ag-chart-settings-prev,.ag-column-group-icons,.ag-column-select-header-icon,.ag-filter-toolpanel-expand,.ag-floating-filter-button-button,.ag-group-title-bar-icon,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,.ag-panel-title-bar-button-icon,.ag-set-filter-group-icons,:where(.ag-group-contracted) .ag-icon,:where(.ag-group-expanded) .ag-icon{background-color:var(--ag-icon-button-background-color);border-radius:var(--ag-icon-button-border-radius);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-background-color);color:var(--ag-icon-button-color);&:hover{background-color:var(--ag-icon-button-hover-background-color);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-hover-background-color);color:var(--ag-icon-button-hover-color)}}.ag-filter-active{background-image:linear-gradient(var(--ag-icon-button-active-background-color),var(--ag-icon-button-active-background-color));border-radius:1px;outline:solid var(--ag-icon-button-background-spread) var(--ag-icon-button-active-background-color);position:relative;&:after{background-color:var(--ag-icon-button-active-indicator-color);border-radius:50%;content:"";height:6px;position:absolute;top:-1px;width:6px}:where(.ag-icon-filter){clip-path:path("M8,0C8,4.415 11.585,8 16,8L16,16L0,16L0,0L8,0Z");color:var(--ag-icon-button-active-color)}}:where(.ag-ltr) .ag-filter-active{&:after{right:-1px}}:where(.ag-rtl) .ag-filter-active{&:after{left:-1px}}.ag-menu{background-color:var(--ag-menu-background-color);border:var(--ag-menu-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-menu-shadow);color:var(--ag-menu-text-color);max-height:100%;overflow-y:auto;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}`;
// packages/ag-grid-community/src/theming/core/core-css.ts
var $437b23f6a393c3bf$var$coreDefaults = {
    wrapperBorder: true,
    rowBorder: true,
    headerRowBorder: true,
    footerRowBorder: {
        ref: "rowBorder"
    },
    columnBorder: {
        style: "solid",
        width: 1,
        color: "transparent"
    },
    headerColumnBorder: false,
    headerColumnBorderHeight: "100%",
    pinnedColumnBorder: true,
    pinnedRowBorder: true,
    sidePanelBorder: true,
    sideBarPanelWidth: 250,
    sideBarBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    sideButtonBarBackgroundColor: {
        ref: "sideBarBackgroundColor"
    },
    sideButtonBarTopPadding: 0,
    sideButtonSelectedUnderlineWidth: 2,
    sideButtonSelectedUnderlineColor: "transparent",
    sideButtonSelectedUnderlineTransitionDuration: 0,
    sideButtonBackgroundColor: "transparent",
    sideButtonTextColor: {
        ref: "textColor"
    },
    sideButtonHoverBackgroundColor: {
        ref: "sideButtonBackgroundColor"
    },
    sideButtonHoverTextColor: {
        ref: "sideButtonTextColor"
    },
    sideButtonSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    sideButtonSelectedTextColor: {
        ref: "sideButtonTextColor"
    },
    sideButtonBorder: "solid 1px transparent",
    sideButtonSelectedBorder: true,
    sideButtonLeftPadding: {
        ref: "spacing"
    },
    sideButtonRightPadding: {
        ref: "spacing"
    },
    sideButtonVerticalPadding: {
        calc: "spacing * 3"
    },
    headerBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    headerFontFamily: {
        ref: "fontFamily"
    },
    cellFontFamily: {
        ref: "fontFamily"
    },
    headerFontWeight: 500,
    headerFontSize: {
        ref: "fontSize"
    },
    dataFontSize: {
        ref: "fontSize"
    },
    headerTextColor: {
        ref: "textColor"
    },
    headerCellHoverBackgroundColor: "transparent",
    headerCellMovingBackgroundColor: {
        ref: "headerCellHoverBackgroundColor"
    },
    headerCellBackgroundTransitionDuration: "0.2s",
    cellTextColor: {
        ref: "textColor"
    },
    rangeSelectionBorderStyle: "solid",
    rangeSelectionBorderColor: $437b23f6a393c3bf$var$accentColor,
    rangeSelectionBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.2),
    rangeSelectionChartBackgroundColor: "#0058FF1A",
    rangeSelectionChartCategoryBackgroundColor: "#00FF841A",
    rangeSelectionHighlightColor: $437b23f6a393c3bf$var$accentMix(0.5),
    rangeHeaderHighlightColor: $437b23f6a393c3bf$var$foregroundHeaderBackgroundMix(0.08),
    rowNumbersSelectedColor: $437b23f6a393c3bf$var$accentMix(0.5),
    rowHoverColor: $437b23f6a393c3bf$var$accentMix(0.08),
    columnHoverColor: $437b23f6a393c3bf$var$accentMix(0.05),
    selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.12),
    modalOverlayBackgroundColor: {
        ref: "backgroundColor",
        mix: 0.66
    },
    dataBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    oddRowBackgroundColor: {
        ref: "dataBackgroundColor"
    },
    wrapperBorderRadius: 8,
    cellHorizontalPadding: {
        calc: "spacing * 2 * cellHorizontalPaddingScale"
    },
    cellWidgetSpacing: {
        calc: "spacing * 1.5"
    },
    cellHorizontalPaddingScale: 1,
    rowGroupIndentSize: {
        calc: "cellWidgetSpacing + iconSize"
    },
    valueChangeDeltaUpColor: "#43a047",
    valueChangeDeltaDownColor: "#e53935",
    valueChangeValueHighlightBackgroundColor: "#16a08580",
    rowHeight: {
        calc: "max(iconSize, dataFontSize) + spacing * 3.25 * rowVerticalPaddingScale"
    },
    rowVerticalPaddingScale: 1,
    headerHeight: {
        calc: "max(iconSize, dataFontSize) + spacing * 4 * headerVerticalPaddingScale"
    },
    headerVerticalPaddingScale: 1,
    paginationPanelHeight: {
        ref: "rowHeight",
        calc: "max(rowHeight, 22px)"
    },
    dragHandleColor: $437b23f6a393c3bf$var$foregroundMix(0.7),
    headerColumnResizeHandleHeight: "30%",
    headerColumnResizeHandleWidth: 2,
    headerColumnResizeHandleColor: {
        ref: "borderColor"
    },
    widgetContainerHorizontalPadding: {
        calc: "spacing * 1.5"
    },
    widgetContainerVerticalPadding: {
        calc: "spacing * 1.5"
    },
    widgetHorizontalSpacing: {
        calc: "spacing * 1.5"
    },
    widgetVerticalSpacing: {
        ref: "spacing"
    },
    iconButtonColor: {
        ref: "iconColor"
    },
    iconButtonBackgroundColor: "transparent",
    iconButtonBackgroundSpread: 4,
    iconButtonBorderRadius: 1,
    iconButtonHoverColor: {
        ref: "iconButtonColor"
    },
    iconButtonHoverBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.1),
    iconButtonActiveColor: $437b23f6a393c3bf$var$accentColor,
    iconButtonActiveBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.28),
    iconButtonActiveIndicatorColor: $437b23f6a393c3bf$var$accentColor,
    menuBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.2)
    },
    menuBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.03),
    menuTextColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.95),
    menuShadow: {
        ref: "popupShadow"
    },
    menuSeparatorColor: {
        ref: "borderColor"
    },
    setFilterIndentSize: {
        ref: "iconSize"
    },
    chartMenuPanelWidth: 260,
    chartMenuLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.8),
    dialogShadow: {
        ref: "popupShadow"
    },
    cellEditingBorder: {
        color: $437b23f6a393c3bf$var$accentColor
    },
    cellEditingShadow: {
        ref: "cardShadow"
    },
    fullRowEditInvalidBackgroundColor: {
        ref: "invalidColor",
        onto: "backgroundColor",
        mix: 0.25
    },
    dialogBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.2)
    },
    panelBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    panelTitleBarHeight: {
        ref: "headerHeight"
    },
    panelTitleBarBackgroundColor: {
        ref: "headerBackgroundColor"
    },
    panelTitleBarIconColor: {
        ref: "headerTextColor"
    },
    panelTitleBarTextColor: {
        ref: "headerTextColor"
    },
    panelTitleBarFontWeight: {
        ref: "headerFontWeight"
    },
    panelTitleBarBorder: true,
    columnSelectIndentSize: {
        ref: "iconSize"
    },
    toolPanelSeparatorBorder: true,
    columnDropCellBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.07),
    columnDropCellTextColor: {
        ref: "textColor"
    },
    columnDropCellDragHandleColor: {
        ref: "textColor"
    },
    columnDropCellBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.13)
    },
    selectCellBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.07),
    selectCellBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.13)
    },
    advancedFilterBuilderButtonBarBorder: true,
    advancedFilterBuilderIndentSize: {
        calc: "spacing * 2 + iconSize"
    },
    advancedFilterBuilderJoinPillColor: "#f08e8d",
    advancedFilterBuilderColumnPillColor: "#a6e194",
    advancedFilterBuilderOptionPillColor: "#f3c08b",
    advancedFilterBuilderValuePillColor: "#85c0e4",
    filterPanelApplyButtonColor: $437b23f6a393c3bf$var$backgroundColor,
    filterPanelApplyButtonBackgroundColor: $437b23f6a393c3bf$var$accentColor,
    filterPanelCardSubtleColor: {
        ref: "textColor",
        mix: 0.7
    },
    filterPanelCardSubtleHoverColor: {
        ref: "textColor"
    },
    findMatchColor: $437b23f6a393c3bf$var$foregroundColor,
    findMatchBackgroundColor: "#ffff00",
    findActiveMatchColor: $437b23f6a393c3bf$var$foregroundColor,
    findActiveMatchBackgroundColor: "#ffa500",
    filterToolPanelGroupIndent: {
        ref: "spacing"
    },
    rowLoadingSkeletonEffectColor: $437b23f6a393c3bf$var$foregroundMix(0.15),
    statusBarLabelColor: $437b23f6a393c3bf$var$foregroundColor,
    statusBarLabelFontWeight: 500,
    statusBarValueColor: $437b23f6a393c3bf$var$foregroundColor,
    statusBarValueFontWeight: 500,
    pinnedSourceRowTextColor: {
        ref: "textColor"
    },
    pinnedSourceRowBackgroundColor: {
        ref: "dataBackgroundColor"
    },
    pinnedSourceRowFontWeight: 600,
    pinnedRowFontWeight: 600,
    pinnedRowBackgroundColor: {
        ref: "dataBackgroundColor"
    },
    pinnedRowTextColor: {
        ref: "textColor"
    }
};
// packages/ag-grid-community/src/theming/parts/batch-edit/batch-edit-style-default.css-GENERATED.ts
var $437b23f6a393c3bf$var$batchEditStyleDefaultCSS = /*css*/ `.ag-cell-batch-edit{background-color:var(--ag-cell-batch-edit-background-color);color:var(--ag-cell-batch-edit-text-color);display:inherit}.ag-row-batch-edit{background-color:var(--ag-row-batch-edit-background-color);color:var(--ag-row-batch-edit-text-color)}`;
// packages/ag-grid-community/src/theming/parts/batch-edit/batch-edit-styles.ts
var $437b23f6a393c3bf$var$baseParams = {
    cellBatchEditBackgroundColor: "rgba(220 181 139 / 16%)",
    cellBatchEditTextColor: "#422f00",
    rowBatchEditBackgroundColor: {
        ref: "cellBatchEditBackgroundColor"
    },
    rowBatchEditTextColor: {
        ref: "cellBatchEditTextColor"
    }
};
var $437b23f6a393c3bf$var$baseDarkBatchEditParams = {
    ...$437b23f6a393c3bf$var$baseParams,
    cellBatchEditTextColor: "#f3d0b3"
};
var $437b23f6a393c3bf$var$makeBatchEditStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "batchEditStyle",
        params: $437b23f6a393c3bf$var$baseParams,
        css: $437b23f6a393c3bf$var$batchEditStyleDefaultCSS
    });
var $437b23f6a393c3bf$var$batchEditStyleBase = /* @__PURE__ */ $437b23f6a393c3bf$var$makeBatchEditStyleBaseTreeShakeable();
// packages/ag-grid-community/src/theming/parts/button-style/button-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$buttonStyleBaseCSS = /*css*/ `:where(.ag-button){background:none;border:none;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0;text-indent:inherit;text-shadow:inherit;text-transform:inherit;word-spacing:inherit;&:disabled{cursor:default}&:focus-visible{box-shadow:var(--ag-focus-shadow);outline:none}}.ag-standard-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--ag-button-background-color);border:var(--ag-button-border);border-radius:var(--ag-button-border-radius);color:var(--ag-button-text-color);cursor:pointer;font-weight:var(--ag-button-font-weight);padding:var(--ag-button-vertical-padding) var(--ag-button-horizontal-padding);&:hover{background-color:var(--ag-button-hover-background-color);border:var(--ag-button-hover-border);color:var(--ag-button-hover-text-color)}&:active{background-color:var(--ag-button-active-background-color);border:var(--ag-button-active-border);color:var(--ag-button-active-text-color)}&:disabled{background-color:var(--ag-button-disabled-background-color);border:var(--ag-button-disabled-border);color:var(--ag-button-disabled-text-color)}}`;
// packages/ag-grid-community/src/theming/parts/button-style/button-styles.ts
var $437b23f6a393c3bf$var$baseParams2 = {
    buttonTextColor: "inherit",
    buttonFontWeight: "normal",
    buttonBackgroundColor: "transparent",
    buttonBorder: false,
    buttonBorderRadius: {
        ref: "borderRadius"
    },
    buttonHorizontalPadding: {
        calc: "spacing * 2"
    },
    buttonVerticalPadding: {
        ref: "spacing"
    },
    buttonHoverTextColor: {
        ref: "buttonTextColor"
    },
    buttonHoverBackgroundColor: {
        ref: "buttonBackgroundColor"
    },
    buttonHoverBorder: {
        ref: "buttonBorder"
    },
    buttonActiveTextColor: {
        ref: "buttonHoverTextColor"
    },
    buttonActiveBackgroundColor: {
        ref: "buttonHoverBackgroundColor"
    },
    buttonActiveBorder: {
        ref: "buttonHoverBorder"
    },
    buttonDisabledTextColor: {
        ref: "inputDisabledTextColor"
    },
    buttonDisabledBackgroundColor: {
        ref: "inputDisabledBackgroundColor"
    },
    buttonDisabledBorder: {
        ref: "inputDisabledBorder"
    }
};
var $437b23f6a393c3bf$var$makeButtonStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: $437b23f6a393c3bf$var$baseParams2,
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$ac3227978dde8e12 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            buttonBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonBorder: true,
            buttonHoverBackgroundColor: {
                ref: "rowHoverColor"
            },
            buttonActiveBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            }
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$a70529c52057ad6a = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            buttonBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            },
            buttonFontWeight: 600,
            buttonTextColor: $437b23f6a393c3bf$var$accentColor,
            buttonHoverBackgroundColor: {
                ref: "rowHoverColor"
            },
            buttonActiveBackgroundColor: $437b23f6a393c3bf$var$accentColor,
            buttonActiveTextColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$c5a38eb31ae86567 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleBalhamTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            buttonBorder: {
                color: $437b23f6a393c3bf$var$foregroundColor,
                width: 2,
                style: "outset"
            },
            buttonActiveBorder: {
                color: $437b23f6a393c3bf$var$foregroundColor,
                width: 2,
                style: "inset"
            },
            buttonBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.07),
            buttonHoverBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonVerticalPadding: {
                calc: "spacing * 0.5"
            }
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$effe67f8e12191d5 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleBalhamTreeShakeable();
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-style-bordered.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnDropStyleBorderedCSS = /*css*/ `.ag-column-drop-vertical-empty-message{align-items:center;border:dashed var(--ag-border-width);border-color:var(--ag-border-color);display:flex;inset:0;justify-content:center;margin:calc(var(--ag-spacing)*1.5) calc(var(--ag-spacing)*2);overflow:hidden;padding:calc(var(--ag-spacing)*2);position:absolute}`;
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-style-plain.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnDropStylePlainCSS = /*css*/ `.ag-column-drop-vertical-empty-message{color:var(--ag-subtle-text-color);font-size:calc(var(--ag-font-size) - 1px);font-weight:600;padding-top:var(--ag-spacing)}:where(.ag-ltr) .ag-column-drop-vertical-empty-message{padding-left:calc(var(--ag-icon-size) + var(--ag-spacing) + var(--ag-widget-horizontal-spacing));padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-column-drop-vertical-empty-message{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-icon-size) + var(--ag-spacing) + var(--ag-widget-horizontal-spacing))}`;
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-styles.ts
var $437b23f6a393c3bf$var$makeColumnDropStyleBorderedTreeShakeable = ()=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "columnDropStyle",
        css: $437b23f6a393c3bf$var$columnDropStyleBorderedCSS
    });
};
var $437b23f6a393c3bf$export$9dd26d60e574ec0 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColumnDropStyleBorderedTreeShakeable();
var $437b23f6a393c3bf$var$makeColumnDropStylePlainTreeShakeable = ()=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "columnDropStyle",
        css: $437b23f6a393c3bf$var$columnDropStylePlainCSS
    });
};
var $437b23f6a393c3bf$export$9eadc93b54e4a807 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColumnDropStylePlainTreeShakeable();
// packages/ag-grid-community/src/theming/createTheme.ts
var $437b23f6a393c3bf$var$gridThemeLogger = {
    warn: (...args)=>{
        $437b23f6a393c3bf$export$545083624300f13d(args[0], args[1]);
    },
    error: (...args)=>{
        $437b23f6a393c3bf$export$a20c7248650823a9(args[0], args[1]);
    },
    preInitErr: (...args)=>{
        $437b23f6a393c3bf$var$_logPreInitErr(args[0], args[2], args[1]);
    }
};
var $437b23f6a393c3bf$export$25d302a5b900a763 = ()=>$437b23f6a393c3bf$var$createSharedTheme($437b23f6a393c3bf$var$gridThemeLogger).withParams($437b23f6a393c3bf$var$coreDefaults).withPart($437b23f6a393c3bf$export$a70529c52057ad6a).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withPart($437b23f6a393c3bf$var$batchEditStyleBase);
// packages/ag-grid-community/src/theming/parts/checkbox-style/checkbox-style-default.css-GENERATED.ts
var $437b23f6a393c3bf$var$checkboxStyleDefaultCSS = /*css*/ `.ag-checkbox-input-wrapper,.ag-radio-button-input-wrapper{background-color:var(--ag-checkbox-unchecked-background-color);border:solid var(--ag-checkbox-border-width) var(--ag-checkbox-unchecked-border-color);flex:none;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);:where(input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-icon-size);margin:0;opacity:0;width:var(--ag-icon-size)}&:after{content:"";display:block;inset:0;-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;pointer-events:none;position:absolute}&:where(.ag-checked){background-color:var(--ag-checkbox-checked-background-color);border-color:var(--ag-checkbox-checked-border-color);&:after{background-color:var(--ag-checkbox-checked-shape-color)}}&:where(:focus-within,:active){box-shadow:var(--ag-focus-shadow)}&:where(.ag-disabled){filter:grayscale();opacity:.5}}.ag-checkbox-input-wrapper{border-radius:var(--ag-checkbox-border-radius);&:where(.ag-checked):after{-webkit-mask-image:var(--ag-checkbox-checked-shape-image);mask-image:var(--ag-checkbox-checked-shape-image)}&:where(.ag-indeterminate){background-color:var(--ag-checkbox-indeterminate-background-color);border-color:var(--ag-checkbox-indeterminate-border-color);&:after{background-color:var(--ag-checkbox-indeterminate-shape-color);-webkit-mask-image:var(--ag-checkbox-indeterminate-shape-image);mask-image:var(--ag-checkbox-indeterminate-shape-image)}}}.ag-cell-editing-error .ag-checkbox-input-wrapper:focus-within{box-shadow:var(--ag-focus-error-shadow)}.ag-radio-button-input-wrapper{border-radius:100%;&:where(.ag-checked):after{-webkit-mask-image:var(--ag-radio-checked-shape-image);mask-image:var(--ag-radio-checked-shape-image)}}`;
// packages/ag-grid-community/src/theming/parts/checkbox-style/checkbox-styles.ts
var $437b23f6a393c3bf$var$makeCheckboxStyleDefaultTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "checkboxStyle",
        params: {
            checkboxBorderWidth: 1,
            checkboxBorderRadius: {
                ref: "borderRadius"
            },
            checkboxUncheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
            checkboxCheckedBackgroundColor: $437b23f6a393c3bf$var$accentColor,
            checkboxCheckedBorderColor: {
                ref: "checkboxCheckedBackgroundColor"
            },
            checkboxCheckedShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M1 3.5 3.5 6l5-5"/></svg>'
            },
            checkboxCheckedShapeColor: $437b23f6a393c3bf$var$backgroundColor,
            checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
            checkboxIndeterminateBorderColor: {
                ref: "checkboxIndeterminateBackgroundColor"
            },
            checkboxIndeterminateShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" fill="none"><rect width="10" height="2" fill="#000" rx="1"/></svg>'
            },
            checkboxIndeterminateShapeColor: $437b23f6a393c3bf$var$backgroundColor,
            radioCheckedShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" fill="none"><circle cx="3" cy="3" r="3" fill="#000"/></svg>'
            }
        },
        css: $437b23f6a393c3bf$var$checkboxStyleDefaultCSS
    });
var $437b23f6a393c3bf$export$cb8a4bb75f2f86bb = /* @__PURE__ */ $437b23f6a393c3bf$var$makeCheckboxStyleDefaultTreeShakeable();
// packages/ag-grid-community/src/theming/parts/color-scheme/color-schemes.ts
var $437b23f6a393c3bf$var$makeColorSchemeLightTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$defaultLightColorSchemeParams
    });
var $437b23f6a393c3bf$export$a116df924b17ca5b = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeLightWarmTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            foregroundColor: "#000000de",
            borderColor: "#60300026",
            chromeBackgroundColor: "#60300005"
        }
    });
var $437b23f6a393c3bf$export$57dc871710981584 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightWarmTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeLightColdTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            foregroundColor: "#000",
            chromeBackgroundColor: "#f3f8f8"
        }
    });
var $437b23f6a393c3bf$export$4cac94f49a02889d = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightColdTreeShakeable();
var $437b23f6a393c3bf$var$darkParams = ()=>({
        ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
        ...$437b23f6a393c3bf$var$baseDarkBatchEditParams,
        backgroundColor: "hsl(217, 0%, 17%)",
        foregroundColor: "#FFF",
        chromeBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.05),
        rowHoverColor: $437b23f6a393c3bf$var$accentMix(0.15),
        selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.2),
        menuBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.1),
        browserColorScheme: "dark",
        popupShadow: "0 0px 20px #000A",
        cardShadow: "0 1px 4px 1px #000A",
        advancedFilterBuilderJoinPillColor: "#7a3a37",
        advancedFilterBuilderColumnPillColor: "#355f2d",
        advancedFilterBuilderOptionPillColor: "#5a3168",
        advancedFilterBuilderValuePillColor: "#374c86",
        filterPanelApplyButtonColor: $437b23f6a393c3bf$var$foregroundColor,
        findMatchColor: $437b23f6a393c3bf$var$backgroundColor,
        findActiveMatchColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.4),
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.4),
        rowBatchEditBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.1)
    });
var $437b23f6a393c3bf$var$makeColorSchemeDarkTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$darkParams()
    });
var $437b23f6a393c3bf$export$cd586495722a2c01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeDarkWarmTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            backgroundColor: "hsl(29, 10%, 17%)",
            foregroundColor: "#FFF",
            browserColorScheme: "dark"
        }
    });
var $437b23f6a393c3bf$var$darkBlueParams = ()=>({
        ...$437b23f6a393c3bf$var$darkParams(),
        backgroundColor: "#1f2836"
    });
var $437b23f6a393c3bf$export$cd0e0dbae95c289b = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkWarmTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeDarkBlueTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$darkBlueParams()
    });
var $437b23f6a393c3bf$export$55741f191f921eee = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkBlueTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeVariableTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$defaultLightColorSchemeParams,
        modeParams: {
            light: $437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            dark: $437b23f6a393c3bf$var$darkParams(),
            "dark-blue": $437b23f6a393c3bf$var$darkBlueParams()
        }
    });
var $437b23f6a393c3bf$export$e4400993032942f7 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeVariableTreeShakeable();
// packages/ag-grid-community/src/theming/parts/icon-set/balham/icon-set-balham.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetBalhamCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eaggregation%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0M7.006 4c-1.57.02-2.946 1.348-3.004 2.922-.078 6.078-.23 12.16.002 18.234.094 1.484 1.354 2.746 2.84 2.84 6.1.232 12.212.232 18.312 0 1.48-.094 2.746-1.35 2.84-2.84.232-6.1.232-12.212 0-18.312-.094-1.48-1.35-2.746-2.84-2.84C19.11 3.774 13.056 4 7.006 4M22 12h-2v-2h-8v.092c.056 1.352 3.426 2.598 4.472 4.404.682 1.174.438 2.754-.572 3.72C14.29 19.618 12 20.924 12 22h8v-2h2v4H10c0-1.586-.098-3.304 1.016-4.314 1.904-1.632 4.89-3.108 3.54-4.42-1.918-1.68-4.464-2.936-4.554-5.12L10 8h12z'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Earrows%3C/title%3E%3Cpath d='m6.414 17 2.294 2.292-1.416 1.416L2.586 16l4.706-4.708 1.416 1.416L6.414 15H15V6.414l-2.292 2.294-1.416-1.416L16 2.586l4.708 4.706-1.416 1.416L17 6.414V15h8.586l-2.294-2.292 1.416-1.416L29.414 16l-4.706 4.708-1.416-1.416L25.586 17H17v8.586l2.292-2.294 1.416 1.416L16 29.414l-4.708-4.706 1.416-1.416L15 25.586V17z'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m15 10.621-4.292 4.294-1.416-1.416L16 6.793l6.708 6.706-1.416 1.416L17 10.621v14.586h-2z'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecancel%3C/title%3E%3Cpath d='M16 4C9.378 4 4 9.378 4 16s5.378 12 12 12 12-5.378 12-12S22.622 4 16 4m0 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S6 21.52 6 16 10.48 6 16 6m0 8.586 5.292-5.294 1.416 1.416L17.414 16l5.294 5.292-1.416 1.416L16 17.414l-5.292 5.294-1.416-1.416L14.586 16l-5.294-5.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cpath d='M6.667 12.267h4v13.067h-4zm7.466-5.6h3.733v18.667h-3.733zM21.6 17.333h3.733v8H21.6z'/%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolor-picker%3C/title%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387H7.361zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolumns%3C/title%3E%3Cpath d='M14 25h-2V7h2zm6 0h-2V7h2zm6 0h-2V7h2zM8 25H6V7h2z'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Econtracted%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecopy%3C/title%3E%3Cpath d='M21.929 27.999h-7.828a5.09 5.09 0 0 1-5.086-5.086v-9.812a5.087 5.087 0 0 1 5.086-5.086h7.828a5.09 5.09 0 0 1 5.086 5.086v9.812a5.087 5.087 0 0 1-5.086 5.086m.16-17.984h-8.088a2.94 2.94 0 0 0-2.938 2.938v10.132a2.94 2.94 0 0 0 2.938 2.938h8.088a2.94 2.94 0 0 0 2.936-2.938V12.953a2.94 2.94 0 0 0-2.936-2.938M7.041 26.013h-2.05a4 4 0 0 1-.006-.228V9.065a5.07 5.07 0 0 1 5.064-5.064h12.812q.069 0 .134.002v2.012H9.915a2.876 2.876 0 0 0-2.874 2.874z'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='4 4 24 24'%3E%3Ctitle%3Ecross%3C/title%3E%3Cpath d='m16 14.586 5.292-5.294 1.416 1.416L17.414 16l5.294 5.292-1.416 1.416L16 17.414l-5.292 5.294-1.416-1.416L14.586 16l-5.294-5.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14.703 15.096 6.215 4.719a1 1 0 1 1 1.548-1.267l13.058 15.965A5.001 5.001 0 0 1 28 23.916a5 5 0 0 1-4.999 4.999 5 5 0 0 1-4.999-4.999 4.98 4.98 0 0 1 1.23-3.283l-3.238-3.958-3.272 4.001a4.98 4.98 0 0 1 1.265 3.323 5 5 0 0 1-4.999 4.999 5 5 0 0 1-4.999-4.999 5 5 0 0 1 7.13-4.522zM8.991 20.8a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M23 20.8a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1m-5.723-8.852 1.292 1.579 7.205-8.808a1 1 0 0 0-1.548-1.267z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Edesc%3C/title%3E%3Cpath d='m17 21.379 4.292-4.294 1.416 1.416L16 25.207l-6.708-6.706 1.416-1.416L15 21.379V6.793h2z'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eexpanded%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath d='M9.304 7.89a15.2 15.2 0 0 1 6.404-1.638c.294-.002.292-.002.584 0 5.956.174 11.328 4.088 13.62 9.748 0 0-1.318 3.178-3.224 5.174a13.6 13.6 0 0 1-2.226 1.874L26.414 25 25 26.414l-2.336-2.336C17.866 26.396 11.776 26.15 7.36 22.96a14.9 14.9 0 0 1-4.168-4.612c-.41-.71-.694-1.336-1.104-2.348 0 0 .898-2.218 2.002-3.718a14.6 14.6 0 0 1 3.442-3.334L5.586 7 7 5.586zm-.3 2.528c-2.038 1.344-3.708 3.246-4.724 5.508L4.248 16c2.46 5.762 9.622 9.064 15.63 7.15q.688-.219 1.342-.516l-.912-.912a6.96 6.96 0 0 1-4.19 1.394c-3.862 0-7-3.136-7-7 0-1.57.52-3.022 1.394-4.19zm14.032 11.204a13.25 13.25 0 0 0 4.684-5.548l.032-.074c-1.984-4.646-6.834-7.798-12.006-7.748-1.712.05-3.386.458-4.922 1.158l1.102 1.102a6.97 6.97 0 0 1 4.192-1.396 7.003 7.003 0 0 1 5.606 11.192zm-11.09-8.262a5.003 5.003 0 0 0 6.928 6.928zm8.342 5.514a5.002 5.002 0 0 0-6.928-6.928z'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye%3C/title%3E%3Cpath d='M16.292 6.32c5.956.174 11.328 4.086 13.62 9.746 0 0-1.318 3.18-3.224 5.176-4.862 5.088-13.534 5.97-19.328 1.784a14.9 14.9 0 0 1-4.168-4.612c-.41-.71-.694-1.336-1.104-2.348 0 0 .898-2.216 2.002-3.716 2.678-3.64 7.03-5.896 11.618-6.03.294-.004.292-.004.584 0m-.546 2c-4.896.142-9.458 3.202-11.466 7.672l-.032.074c2.46 5.762 9.622 9.066 15.63 7.152 3.458-1.102 6.342-3.738 7.842-7.076l.032-.076C25.768 11.42 20.918 8.27 15.746 8.32m.254.946c3.754 0 6.8 3.048 6.8 6.8 0 3.754-3.046 6.8-6.8 6.8s-6.8-3.046-6.8-6.8c0-3.752 3.046-6.8 6.8-6.8m5 6.768V16c0-2.76-2.24-5-5-5s-5 2.24-5 5v.066c0 2.76 2.24 5 5 5s5-2.24 5-5z'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efilter%3C/title%3E%3Cpath d='M26 8.184c-.066 2.658-4.058 5.154-6.742 7.974a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h20zM8 8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.066-2.658 4.058-5.154 6.742-7.974.198-.23.258-.538.258-.842z'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efirst%3C/title%3E%3Cpath d='M24.354 8.708 17.06 16l7.294 7.292-1.416 1.416L14.232 16l8.706-8.708zM9.646 8v16h-2V8z'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egroup%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0M7.006 4c-1.57.02-2.946 1.348-3.004 2.922-.078 6.078-.23 12.16.002 18.234.094 1.484 1.354 2.746 2.84 2.84 6.1.232 12.212.232 18.312 0 1.48-.094 2.746-1.35 2.84-2.84.232-6.1.232-12.212 0-18.312-.094-1.48-1.35-2.746-2.84-2.84C19.11 3.774 13.056 4 7.006 4M14 21h-4v-2h4zm12 0H16v-2h10zm-12-4h-4v-2h4zm12 0H16v-2h10zm-16-4H6v-2h4zm16 0H12v-2h14z'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elast%3C/title%3E%3Cpath d='m17.768 16-8.706 8.708-1.416-1.416L14.94 16 7.646 8.708l1.416-1.416zm6.586 8h-2V8h2z'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eleft%3C/title%3E%3Cpath d='m17.621 11-2 2h12.586v6H15.621l2 2-4.414 4.414L3.793 16l9.414-9.414zm-11 5 6.586 6.586L14.793 21l-4-4h15.414v-2H10.793l4-4-1.586-1.586z'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elinked%3C/title%3E%3Cpath d='M17.138 13.418a1.03 1.03 0 0 0-.298.658s.125.096.226.178c1.372 1.114 2.033 3.039 1.582 4.796a4.7 4.7 0 0 1-1.205 2.123c-1.145 1.151-2.296 2.294-3.445 3.441-1.241 1.232-3.185 1.691-4.864 1.105-1.546-.54-2.756-1.938-3.048-3.572-.267-1.496.246-3.108 1.319-4.186l.578-.578-.03-.092a10.5 10.5 0 0 1-.452-2.3v-.005c-.776.775-1.621 1.489-2.275 2.396-1.817 2.522-1.643 6.323.706 8.669 1.813 1.811 4.708 2.462 7.171 1.517a6.75 6.75 0 0 0 2.336-1.518l3.427-3.424c1.939-1.954 2.533-5.126 1.294-7.674a6.8 6.8 0 0 0-2.071-2.481l-.003-.002zM21.265 4a6.8 6.8 0 0 0-4.734 1.964l-3.427 3.424c-1.961 1.977-2.52 5.092-1.32 7.619a6.8 6.8 0 0 0 2.098 2.537l.003.002c.32-.32.643-.637.96-.96.167-.172.27-.401.286-.64l-.204-.167c-1.603-1.287-2.215-3.68-1.316-5.616a4.7 4.7 0 0 1 .918-1.32c1.145-1.151 2.296-2.294 3.445-3.441 1.239-1.23 3.178-1.694 4.864-1.105 1.83.639 3.16 2.498 3.12 4.493a4.8 4.8 0 0 1-1.391 3.265l-.578.578.03.092c.235.743.387 1.519.452 2.3v.005c.732-.731 1.521-1.406 2.162-2.244 1.192-1.559 1.643-3.651 1.204-5.575a6.8 6.8 0 0 0-3.98-4.703 6.8 6.8 0 0 0-2.529-.506h-.061z'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eloading%3C/title%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='3 3 26 26'%3E%3Ctitle%3Emaximize%3C/title%3E%3Cpath d='m7.54 17.4.1 6.98 6.96.1-2.24-2.24L16 18.6 13.4 16l-3.64 3.64zm16.92-2.8-.1-6.98-6.96-.1 2.24 2.24L16 13.4l2.6 2.6 3.64-3.64z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emenu%3C/title%3E%3Cpath d='M26 23H6v-2h20zm0-6H6v-2h20zm0-6H6V9h20z'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none'%3E%3Cpath fill='%23000' d='M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='3 3 26 26'%3E%3Ctitle%3Eminimize%3C/title%3E%3Cpath d='m14.8 24.26-.1-6.96-6.96-.1 2.24 2.24-3.64 3.64 2.6 2.6 3.64-3.64zm2.4-16.52.1 6.96 6.96.1-2.24-2.24 3.64-3.64-2.6-2.6-3.64 3.64z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 7.515c-4.683 4.682-4.683 12.288 0 16.97 4.682 4.683 12.288 4.683 16.97 0 4.683-4.682 4.683-12.288 0-16.97-4.682-4.683-12.288-4.683-16.97 0m1.414 1.414c3.903-3.903 10.239-3.903 14.142 0s3.903 10.239 0 14.142-10.239 3.903-14.142 0-3.903-10.239 0-14.142m-1.414 6.07h16.97v2.002H7.515z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enext%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cpath d='m10.044 21.258 4.478-4.198L16 18.444 9 25l-7-6.556 1.478-1.384 4.478 4.198V7h2.088zm14 3.742h-2.088V10.742l-4.478 4.198L16 13.556 23 7q3.5 3.28 7 6.556l-1.478 1.384-4.478-4.198z'/%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enot-allowed%3C/title%3E%3Cpath d='M16.186 3.646c8.188.154 14.898 9.796 11.17 17.78-3.298 7.066-13.932 9.374-19.848 3.87-3.9-3.632-5.076-9.896-2.684-14.708 2.082-4.19 6.588-6.974 11.362-6.942m-.298 1.998c-6.922.132-12.578 8.308-9.33 15.052 3.342 6.934 15.246 7.646 18.932 0 3.076-6.386-1.988-15.1-9.602-15.052m7.596 6.422c2.864 5.33-1.744 13.186-8.306 12.536a8.6 8.6 0 0 1-3.232-.998l-1.266-.706L22.778 10.8q.351.633.706 1.266m-9.422 10.276c3.296 1.028 7.246-1.006 8.216-4.418a6.6 6.6 0 0 0-.056-3.742zm2.104-14.696a8.8 8.8 0 0 1 3.936 1.038l1.266.706L9.27 21.488c-3.018-5.41-.99-13.37 6.318-13.834q.289-.01.578-.008m-.31 2c-4.06.154-7.23 4.614-6.03 8.46l8.16-8.16a6.8 6.8 0 0 0-2.13-.3'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epaste%3C/title%3E%3Cpath d='M20 6.5c0-1-1-3-4-3s-4 2-4 3H8c-2.21 0-4 1.79-4 4v14c0 2.21 1.79 4 4 4h16c2.21 0 4-1.79 4-4v-14c0-2.21-1.79-4-4-4zm-4 .546c.734 0 1.334.572 1.334 1.272S16.734 9.59 16 9.59s-1.334-.572-1.334-1.272.6-1.272 1.334-1.272M24 26.5H8a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h2v4h12v-4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epin%3C/title%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epivot%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008c-1.358-.022-2.714-.026-4.07-.022v4.034h4.07z'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 7.515c-4.683 4.682-4.683 12.288 0 16.97 4.682 4.683 12.288 4.683 16.97 0 4.683-4.682 4.683-12.288 0-16.97-4.682-4.683-12.288-4.683-16.97 0m1.414 1.414c3.903-3.903 10.239-3.903 14.142 0s3.903 10.239 0 14.142-10.239 3.903-14.142 0-3.903-10.239 0-14.142M15 15l-.001-7.485h2.002L17 15l7.485-.001v2.002L17 17l.001 7.485h-2.002L15 17l-7.485.001v-2.002z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eprevious%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eright%3C/title%3E%3Cpath d='m28.207 16-9.414 9.414L14.379 21l2-2H3.793v-6h12.586l-2-2 4.414-4.414zm-11-5 4 4H5.793v2h15.414l-4 4 1.586 1.586L25.379 16l-6.586-6.586z'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esave%3C/title%3E%3Cpath d='M25.333 16v9.333H6.666V16H3.999v9.333C3.999 26.8 5.199 28 6.666 28h18.667C26.8 28 28 26.8 28 25.333V16zm-8 .893 3.453-3.44 1.88 1.88L15.999 22l-6.667-6.667 1.88-1.88 3.453 3.44V4h2.667v12.893z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-down%3C/title%3E%3Cpath d='M24.708 12.355 16 21.061l-8.708-8.706 1.416-1.416L16 18.233l7.292-7.294z'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-left%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-right%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-up%3C/title%3E%3Cpath d='m24.708 19.645-1.416 1.416L16 13.767l-7.292 7.294-1.416-1.416L16 10.939z'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etick%3C/title%3E%3Cpath d='M24.708 10.855 13 22.561l-5.708-5.706 1.416-1.416L13 19.733 23.292 9.439z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-closed%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-indeterminate%3C/title%3E%3Cpath d='M6 15h20v2H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-open%3C/title%3E%3Cpath d='M24.708 12.355 16 21.061l-8.708-8.706 1.416-1.416L16 18.233l7.292-7.294z'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eunlinked%3C/title%3E%3Cpath d='M5.35 3.999a.2.2 0 0 0-.14.058c-.388.38-.768.768-1.152 1.152a.21.21 0 0 0-.002.288c7.459 7.506 14.965 14.965 22.447 22.447a.21.21 0 0 0 .288.002q.576-.574 1.151-1.151a.21.21 0 0 0 .002-.288C20.484 19.002 12.979 11.542 5.497 4.06a.2.2 0 0 0-.146-.061zm.611 12.548c-1.933 1.939-2.538 5.119-1.289 7.688a6.79 6.79 0 0 0 4.891 3.672 6.82 6.82 0 0 0 5.893-1.866l1.984-1.984-1.438-1.438-1.986 1.986c-1.486 1.476-3.993 1.81-5.834.629a4.73 4.73 0 0 1-2.024-2.853 4.76 4.76 0 0 1 1.241-4.393l1.986-1.986-1.438-1.438-1.984 1.984zM21.273 3.999a6.78 6.78 0 0 0-4.727 1.963l-1.984 1.984L16 9.384l1.985-1.985a4.74 4.74 0 0 1 2.776-1.338c1.974-.224 4.045.926 4.845 2.834.712 1.699.329 3.778-1.004 5.12L22.616 16l1.439 1.438q1-1 2-2c2.012-2.031 2.557-5.368 1.112-7.982-1.144-2.07-3.432-3.441-5.834-3.459h-.061z'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m15 10.621-4.292 4.294-1.416-1.416L16 6.793l6.708 6.706-1.416 1.416L17 10.621v14.586h-2z'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egrip%3C/title%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M19.834 8H8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.056-2.267 2.968-4.417 5.49-6.75v3.087c-1.081.974-2.245 1.968-3.232 3.005a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h13.834z'/%3E%3Cpath fill='currentColor' d='M26 6h2.946v2.002H26v3.313h-2.002V8.002h-2.946V6h2.946V3.04H26z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M23.182 5a3.82 3.82 0 0 1 2.83 6.383l-.131.137-2.09 2.088a1 1 0 0 1-.084.099 1 1 0 0 1-.098.084L12.533 24.869a3 3 0 0 1-1.245.746l-4.353 1.32-.003.002a1.5 1.5 0 0 1-1.87-1.867l.003-.004 1.32-4.352v-.003l.06-.174c.13-.344.321-.661.565-.936l.126-.135L18.209 8.39a1 1 0 0 1 .18-.181l2.092-2.09.137-.132A3.82 3.82 0 0 1 23.182 5M8.548 20.883a1 1 0 0 0-.25.415l-1.049 3.451 3.457-1.048.114-.042q.17-.076.301-.206l10.458-10.46-2.572-2.572zM23.182 7c-.482 0-.946.19-1.287.531v.001l-1.474 1.475 2.572 2.572 1.474-1.474.121-.133A1.82 1.82 0 0 0 23.182 7'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/balham/icon-set-balham.ts
var $437b23f6a393c3bf$var$iconSetBalham = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetBalhamCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/alpine/icon-set-alpine.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetAlpineCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24 6H8v2l8 8-8 8v2h16v-2H11l8-8-8-8h13z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 11.171 2.687 16l4.828 4.829-1.414 1.414L-.142 16l6.243-6.243zm16.97 0 1.414-1.414L32.142 16l-6.243 6.243-1.414-1.414L29.313 16zM16.028 13.2l2.829 2.828-2.829 2.829-2.828-2.829zm-4.857 11.285L16 29.313l4.829-4.828 1.414 1.414L16 32.142l-6.243-6.243zm0-16.97L9.757 6.101 16-.142l6.243 6.243-1.414 1.414L16 2.687z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667A13.32 13.32 0 0 0 2.667 16c0 7.373 5.96 13.333 13.333 13.333S29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M14 7h4v18h-4zM8 17h4v8H8zM20 13h4v12h-4z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26 25H6V7h20zM12 11H8v12h4zm6 0h-4v12h4zm6 12V11h-4v12z' style='fill-rule:nonzero' transform='translate(0 -1)'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m12 6 10 10-10 10-2-2 8-8-8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.984 13.894 27.05 2.828l2.122 2.122-11.066 11.066 11.066 11.066-2.122 2.12-11.066-11.066L4.918 29.202l-2.12-2.12 11.066-11.066L2.798 4.95l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M13.775 15.198 3.835 2.945a1.501 1.501 0 0 1 2.33-1.89l14.997 18.488A6.003 6.003 0 0 1 29.657 25c0 3.311-2.688 6-6 6s-6-2.689-6-6c0-1.335.437-2.569 1.176-3.566l-3.127-3.855-3.001 3.7A5.97 5.97 0 0 1 14 25c0 3.311-2.689 6-6 6s-6-2.689-6-6a6.003 6.003 0 0 1 8.315-5.536zm9.882 6.702a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M8 21.95a3.05 3.05 0 1 0 .001 6.101A3.05 3.05 0 0 0 8 21.95m9.63-11.505 1.932 2.381 8.015-9.881a1.5 1.5 0 0 0-2.329-1.89z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 26 10 16 20 6l2 2-8 8 8 8z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath fill='%23000' fill-rule='nonzero' d='M8.95 10.364 7 8.414 8.414 7l2.32 2.32A13.2 13.2 0 0 1 16.5 8c5.608 0 10.542 3.515 12.381 8.667L29 17l-.119.333a13 13 0 0 1-4.255 5.879l1.466 1.466-1.414 1.414-1.754-1.753A13.2 13.2 0 0 1 16.5 26c-5.608 0-10.542-3.515-12.381-8.667L4 17l.119-.333a13 13 0 0 1 4.83-6.303m1.445 1.445A11.02 11.02 0 0 0 6.148 17c1.646 4.177 5.728 7 10.352 7 1.76 0 3.441-.409 4.94-1.146l-1.878-1.878A5.06 5.06 0 0 1 16.5 22c-2.789 0-5.05-2.239-5.05-5 0-1.158.398-2.223 1.065-3.07zm1.855-.974 1.794 1.795A5.07 5.07 0 0 1 16.5 12c2.789 0 5.05 2.239 5.05 5 0 .9-.24 1.745-.661 2.474l2.305 2.306A11 11 0 0 0 26.852 17c-1.646-4.177-5.728-7-10.352-7-1.495 0-2.933.295-4.25.835'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16.5 23c4.624 0 8.706-2.823 10.352-7-1.646-4.177-5.728-7-10.352-7s-8.706 2.823-10.352 7c1.646 4.177 5.728 7 10.352 7M4.119 15.667C5.958 10.515 10.892 7 16.5 7s10.542 3.515 12.381 8.667L29 16l-.119.333C27.042 21.485 22.108 25 16.5 25S5.958 21.485 4.119 16.333L4 16zM16.5 21c2.789 0 5.049-2.239 5.049-5s-2.26-5-5.049-5-5.049 2.239-5.049 5 2.26 5 5.049 5' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m28 8-8 8v5l-6 6V16L6 8V6h22zM9 8l7 7v7l2-2v-5l7-7z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 7v1H9V7zm0-3v1H5.001V4zm-7 7H5v-1h2zm0-3H5V7h2zM3 5H1V4h2zm11 5v1H9v-1zm-7 4H5v-1h2zm7-1v1H9v-1z' style='fill-rule:nonzero' transform='matrix(2 0 0 2 0 -2)'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333a6.67 6.67 0 0 0-6.667 6.667 6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133 4.136 4.136 0 0 1-4.133 4.133h-5.333v2.533h5.333a6.67 6.67 0 0 0 6.667-6.667 6.67 6.67 0 0 0-6.667-6.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z' style='fill-rule:nonzero' transform='translate(-3.692 -3.692)scale(1.23077)'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 30H2V18h2.828v7.05l8.254-8.252 2.12 2.12-8.252 8.254H14zm4-28h12v12h-2.828V6.95l-8.254 8.252-2.12-2.12 8.252-8.254H18z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 13H0v-2h20zm0-6H0V5h20zm0-6H0v-2h20z' style='fill-rule:nonzero' transform='translate(6 9)'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 27a3 3 0 1 0 0-6 3 3 0 0 0 0 6'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M2 18h12v12h-2.828v-7.05l-8.254 8.252-2.12-2.12 8.252-8.254H2zm28-4H18V2h2.828v7.05L29.082.798l2.12 2.12-8.252 8.254H30z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.94 6 9.06 7.88 17.167 16 9.06 24.12 10.94 26l10-10z' style='fill-rule:nonzero' transform='translate(1)'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M23.708 14.645 16 6.939l-7.708 7.706 1.416 1.416L16 9.767l6.292 6.294zM23.708 20.355 16 28.061l-7.708-7.706 1.416-1.416L16 25.233l6.292-6.294z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.334 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4M16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008a213 213 0 0 0-4.07-.022v4.034h4.07z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.94 7.88 20.06 6l-10 10 10 10 1.88-1.88L13.833 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.708 2.355 8 10.061.292 2.355 1.708.939 8 7.233 14.292.939z' style='fill-rule:nonzero' transform='translate(8 14)'/%3E%3Cpath d='M5 26h22v2H5zM15 4h2v18h-2z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 10.667 16 21.334l8.667-10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.333 7.334 10.666 16l10.667 8.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.667 24.666 21.334 16 10.667 7.333z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 21.333 16 10.666l8.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M11.586 22.96 27.718 6.828 29.84 8.95 11.586 27.202 2.4 18.016l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m11.94 6-1.88 1.88L18.167 16l-8.107 8.12L11.94 26l10-10z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6 13.5h20v3H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.12 9.06 16 17.167 7.88 9.06 6 10.94l10 10 10-10z' style='fill-rule:nonzero' transform='translate(0 1)'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M19.834 8H8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.056-2.267 2.968-4.417 5.49-6.75v3.087c-1.081.974-2.245 1.968-3.232 3.005a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h13.834z'/%3E%3Cpath fill='currentColor' d='M26 6h2.946v2.002H26v3.313h-2.002V8.002h-2.946V6h2.946V3.04H26z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M6.222 25.778h1.611l14.834-14.811-1.611-1.611-14.834 14.81zM4 28v-4.733L22.644 4.656a2.26 2.26 0 0 1 1.567-.634q.423 0 .833.167.412.166.734.478l1.589 1.6q.333.322.483.733t.15.822q0 .423-.161.839-.162.416-.472.728L8.733 28zm17.856-17.833-.8-.811 1.61 1.61z'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/alpine/icon-set-alpine.ts
var $437b23f6a393c3bf$export$9bb4a1bee1653083 = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetAlpineCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/material/icon-set-material.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetMaterialCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eaggregation%3C/title%3E%3Cpath d='M24 5.333H8V8l8.667 8L8 24v2.667h16v-4h-9.333L21.334 16l-6.667-6.667H24z'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Earrows%3C/title%3E%3Cpath d='M13.333 11.556h5.333V8h3.556L16 1.778 9.778 8h3.556zm-1.777 1.777H8V9.777l-6.222 6.222L8 22.221v-3.556h3.556zM30.222 16 24 9.778v3.556h-3.556v5.333H24v3.556l6.222-6.222zm-11.555 4.444h-5.333V24H9.778L16 30.222 22.222 24h-3.556z'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333z'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecancel%3C/title%3E%3Cpath d='M16 2.667C8.627 2.667 2.667 8.627 2.667 16S8.627 29.333 16 29.333 29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cpath d='M6.667 12.267h4v13.067h-4zm7.466-5.6h3.733v18.667h-3.733zM21.6 17.333h3.733v8H21.6z'/%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolor-picker%3C/title%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387H7.361zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolumns%3C/title%3E%3Cpath d='M5.333 10.667h5.333V5.334H5.333zm8 16h5.333v-5.333h-5.333zm-8 0h5.333v-5.333H5.333zm0-8h5.333v-5.333H5.333zm8 0h5.333v-5.333h-5.333zm8-13.334v5.333h5.333V5.333zm-8 5.334h5.333V5.334h-5.333zm8 8h5.333v-5.333h-5.333zm0 8h5.333v-5.333h-5.333z'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Econtracted%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecopy%3C/title%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecross%3C/title%3E%3Cpath d='m25.333 8.547-1.88-1.88L16 14.12 8.547 6.667l-1.88 1.88L14.12 16l-7.453 7.453 1.88 1.88L16 17.88l7.453 7.453 1.88-1.88L17.88 16z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m19 3-6 6 2 2 7-7V3m-10 9.5a.503.503 0 0 1-.5-.5c0-.274.226-.5.5-.5s.5.226.5.5-.226.5-.5.5M6 20c-1.097 0-2-.903-2-2a2 2 0 0 1 2-2c1.097 0 2 .903 2 2a2 2 0 0 1-2 2M6 8c-1.097 0-2-.903-2-2a2 2 0 0 1 2-2c1.097 0 2 .903 2 2a2 2 0 0 1-2 2m3.64-.36c.23-.5.36-1.05.36-1.64 0-2.194-1.806-4-4-4S2 3.806 2 6s1.806 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.194 0-4 1.806-4 4s1.806 4 4 4 4-1.806 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1z' style='fill-rule:nonzero' transform='translate(4 4)'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Edesc%3C/title%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667L26.668 16z'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eexpanded%3C/title%3E%3Cpath d='M20.94 9.88 19.06 8l-8 8 8 8 1.88-1.88L14.833 16z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath d='M21.106 15.088A5.19 5.19 0 0 0 16 10.814a5.17 5.17 0 0 0-3.668 1.522L9.866 9.868a12.2 12.2 0 0 1 6.133-1.646c5.186 0 9.614 3.225 11.408 7.778a12.34 12.34 0 0 1-5.276 6.133l-2.468-2.466a5.17 5.17 0 0 0 1.449-2.802h-2.123c-.148.508-.42.964-.782 1.33l-1.33-1.33h-2.514l2.196 2.196q-.272.049-.56.05a3.11 3.11 0 0 1-2.99-2.245h-2.123a5.19 5.19 0 0 0 7.3 3.836l2.247 2.247a12.2 12.2 0 0 1-4.434.828c-5.186 0-9.614-3.225-11.408-7.778a12.3 12.3 0 0 1 3.781-5.111l2.924 2.924a5.1 5.1 0 0 0-.404 1.275h4.206l-1.296-1.296a3.1 3.1 0 0 1 2.196-.903c1.404 0 2.587.924 2.976 2.199h2.13z'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye%3C/title%3E%3Cpath d='M16 8.222c-5.186 0-9.614 3.225-11.408 7.778 1.794 4.553 6.222 7.778 11.408 7.778S25.614 20.553 27.408 16C25.614 11.447 21.186 8.222 16 8.222m0 12.964c-2.862 0-5.186-2.324-5.186-5.186s2.324-5.186 5.186-5.186 5.186 2.324 5.186 5.186-2.324 5.186-5.186 5.186m0-8.297c-1.721 0-3.111 1.39-3.111 3.111s1.39 3.111 3.111 3.111 3.111-1.39 3.111-3.111-1.39-3.111-3.111-3.111'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efilter%3C/title%3E%3Cpath d='M13.333 24h5.333v-2.667h-5.333zM4 8v2.667h24V8zm4 9.333h16v-2.667H8z'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efirst%3C/title%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egroup%3C/title%3E%3Cpath d='M18.667 21.333h8.889A3.555 3.555 0 0 1 24 24.889h-5.333zm8.888-7.111v3.556h-8.889v-3.556zM24 7.111a3.555 3.555 0 0 1 3.556 3.556h-16V7.111zm-8.889 17.778h-3.556v-3.556h3.556zm0-7.111h-3.556v-3.556h3.556zM8 10.667H4.444A3.555 3.555 0 0 1 8 7.111z'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elast%3C/title%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eleft%3C/title%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227v-2.667z'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elinked%3C/title%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333c-3.68 0-6.667 2.987-6.667 6.667s2.987 6.667 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333c2.28 0 4.133 1.853 4.133 4.133s-1.853 4.133-4.133 4.133h-5.333v2.533h5.333c3.68 0 6.667-2.987 6.667-6.667s-2.987-6.667-6.667-6.667z'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eloading%3C/title%3E%3Cpath d='m17.778 11.708 3.25-3.251 2.516 2.516-3.251 3.25h4.597v3.556h-4.597l3.251 3.25-2.516 2.516-3.25-3.251v4.597h-3.556v-4.597l-3.25 3.251-2.516-2.516 3.251-3.25H7.11v-3.556h4.597l-3.251-3.25 2.516-2.516 3.25 3.251V7.111h3.556zm-3.251 7.847h2.944l2.084-2.084v-2.944l-2.084-2.084h-2.944l-2.084 2.084v2.944z'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emaximize%3C/title%3E%3Cpath d='M4 4h24v2.667H4z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emenu%3C/title%3E%3Cpath d='M4 24h24v-2.667H4zm0-6.667h24v-2.667H4zM4 8v2.667h24V8z'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 26.667a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 24q0-1.1.784-1.883A2.57 2.57 0 0 1 16 21.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784m0-8a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 16q0-1.1.784-1.883A2.57 2.57 0 0 1 16 13.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784m0-8a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 8q0-1.1.784-1.883A2.57 2.57 0 0 1 16 5.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eminimize%3C/title%3E%3Cpath d='M8 25.333h16V28H8z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enext%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cpath d='M4 24h16v-2.667H4zM4 8v2.667h24V8zm0 9.333h24v-2.667H4z'/%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enot-allowed%3C/title%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epaste%3C/title%3E%3Cpath d='M25.333 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4zM16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epin%3C/title%3E%3Cpath d='m11.106 22.093-4.444 4.444-1.259-1.259 4.444-4.444zm5.872-16.63 9.618 9.62-.962.962-.962-.962-7.694 3.847 1.924 1.924-2.74 2.74-7.696-7.696 2.741-2.74 1.924 1.925 3.847-7.696-.962-.962z'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epivot%3C/title%3E%3Cpath d='M26.667 30.223H5.334a3.556 3.556 0 0 1-3.556-3.556V5.334a3.556 3.556 0 0 1 3.556-3.556h21.333a3.556 3.556 0 0 1 3.556 3.556v21.333a3.556 3.556 0 0 1-3.556 3.556m-16-8.89H5.334v5.333h5.333zm16-7.11H12.444v12.444h14.223zm-9.15 6.85-2.039 2.037 2.039 2.039-1.257 1.257-3.295-3.296 3.295-3.295q.63.628 1.257 1.257zm-6.85-6.85H5.334v5.333h5.333zm15.74 3.816-1.257 1.256-2.039-2.037-2.037 2.037-1.257-1.256 3.295-3.296zM10.667 5.333H5.334v5.333h5.333zm8.889 0h-7.112v5.333h7.112zm7.111 0h-5.333v5.333h5.333z'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eprevious%3C/title%3E%3Cpath d='M20.94 9.88 19.06 8l-8 8 8 8 1.88-1.88L14.833 16z'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eright%3C/title%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esave%3C/title%3E%3Cpath d='M25.333 16v9.333H6.666V16H3.999v9.333C3.999 26.8 5.199 28 6.666 28h18.667C26.8 28 28 26.8 28 25.333V16zm-8 .893 3.453-3.44 1.88 1.88L15.999 22l-6.667-6.667 1.88-1.88 3.453 3.44V4h2.667v12.893z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-down%3C/title%3E%3Cpath d='M9.333 12.667 16 19.334l6.667-6.667H9.334z'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-left%3C/title%3E%3Cpath d='M19.333 9.333 12.666 16l6.667 6.667V9.334z'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-right%3C/title%3E%3Cpath d='M12.667 22.667 19.334 16l-6.667-6.667v13.333z'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-up%3C/title%3E%3Cpath d='M9.333 19.333 16 12.666l6.667 6.667H9.334z'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etick%3C/title%3E%3Cpath d='m11.727 21.167-5.56-5.56-1.893 1.88 7.453 7.453 16-16-1.88-1.88z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-closed%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-indeterminate%3C/title%3E%3Cpath d='M6.667 14.667h18.667v2.667H6.667z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-open%3C/title%3E%3Cpath d='M22.12 11.06 16 17.167 9.88 11.06 8 12.94l8 8 8-8z'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eunlinked%3C/title%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333z'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egrip%3C/title%3E%3Cpath d='M26.667 12H5.334v2.667h21.333zM5.333 20h21.333v-2.667H5.333z'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11'/%3E%3Cpath fill='currentColor' d='M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28zM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972z'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22M3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22M12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M18.666 24h-5.333v-2.667h5.333zM24 17.333H8v-2.667h16zm3.59-9.344h3.221v2.657h-3.22v3.22h-2.656v-3.22h-3.221V7.989h3.22V4.77h2.657zm-8.582 2.678H4V8h15.008z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M6.222 25.778h1.611l14.834-14.811-1.611-1.611-14.834 14.81zM4 28v-4.733L22.644 4.656a2.26 2.26 0 0 1 1.567-.634q.423 0 .833.167.412.166.734.478l1.589 1.6q.333.322.483.733t.15.822q0 .423-.161.839-.162.416-.472.728L8.733 28zm17.856-17.833-.8-.811 1.61 1.61z'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/material/icon-set-material.ts
var $437b23f6a393c3bf$export$e9404e008fead04f = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetMaterialCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/overrides/icon-overrides.ts
var $437b23f6a393c3bf$export$32f04c7493939075 = (args)=>{
    const cssParts = [];
    if (args.type === "image") {
        const { icons: icons, mask: mask } = args;
        for (const key of Object.keys(icons)){
            const imageCssValue = $437b23f6a393c3bf$var$imageValueToCss(icons[key]);
            if (mask) cssParts.push(`.ag-icon-${key}::before { mask-image: ${imageCssValue}; }`);
            else cssParts.push(`.ag-icon-${key}::before { background-image: ${imageCssValue}; ${$437b23f6a393c3bf$var$unsetMaskIcon} }`);
        }
    }
    if (args.type === "font") {
        const { family: family, weight: weight, color: color, icons: icons } = args;
        let properties = $437b23f6a393c3bf$var$unsetMaskIcon;
        if (family) properties += ` font-family: ${$437b23f6a393c3bf$var$fontFamilyValueToCss(family)};`;
        if (weight) properties += ` font-weight: ${$437b23f6a393c3bf$var$fontWeightValueToCss(weight)};`;
        if (color) properties += ` color: ${$437b23f6a393c3bf$var$colorValueToCss(color)};`;
        for (const key of Object.keys(icons))cssParts.push(`.ag-icon-${key}::before { content: ${JSON.stringify(icons[key])}; ${properties} }`);
    }
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        css: cssParts.join(";\n"),
        cssImports: args.cssImports
    });
};
var $437b23f6a393c3bf$var$unsetMaskIcon = `background-color: unset; mask-image: unset; -webkit-mask-image: unset;`;
// packages/ag-grid-community/src/theming/parts/icon-set/quartz/quartz-icon-data.ts
var $437b23f6a393c3bf$var$iconNameToSvgFragment = {
    aggregation: '<path d="M18 7V4H6l6 8-6 8h12v-3"/>',
    arrows: '<polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/>',
    asc: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
    cancel: '<path d="m18 6-12 12"/><path d="m6 6 12 12"/>',
    chart: '<line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="14"/>',
    "color-picker": '<path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"/><path d="m5 2 5 5"/><path d="M2 13h15"/><path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"/>',
    columns: '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>',
    contracted: '<path d="m9 18 6-6-6-6"/>',
    copy: '<rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>',
    cross: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    csv: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
    cut: '<circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/>',
    desc: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
    down: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
    excel: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
    expanded: '<path d="m15 18-6-6 6-6"/>',
    "eye-slash": '<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/>',
    eye: '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
    filter: '<path d="M3 6h18"/><path d="M7 12h10"/><path d="M10 18h4"/>',
    first: '<path d="m17 18-6-6 6-6"/><path d="M7 6v12"/>',
    group: '<path d="M16 12H3"/><path d="M16 18H3"/><path d="M10 6H3"/><path d="M21 18V8a2 2 0 0 0-2-2h-5"/><path d="m16 8-2-2 2-2"/>',
    last: '<path d="m7 18 6-6-6-6"/><path d="M17 6v12"/>',
    left: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
    linked: '<path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" x2="16" y1="12" y2="12"/>',
    loading: '<line x1="12" x2="12" y1="2" y2="6"/><line x1="12" x2="12" y1="18" y2="22"/><line x1="4.93" x2="7.76" y1="4.93" y2="7.76"/><line x1="16.24" x2="19.07" y1="16.24" y2="19.07"/><line x1="2" x2="6" y1="12" y2="12"/><line x1="18" x2="22" y1="12" y2="12"/><line x1="4.93" x2="7.76" y1="19.07" y2="16.24"/><line x1="16.24" x2="19.07" y1="7.76" y2="4.93"/>',
    maximize: '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" x2="14" y1="3" y2="10"/><line x1="3" x2="10" y1="21" y2="14"/>',
    menu: '<line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/>',
    "menu-alt": '<circle cx="12" cy="5" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="12" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="19" r="0.75" fill="#D9D9D9"/>',
    minimize: '<polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" x2="21" y1="10" y2="3"/><line x1="3" x2="10" y1="21" y2="14"/>',
    minus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/>',
    next: '<path d="m9 18 6-6-6-6"/>',
    none: '<path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/>',
    "not-allowed": '<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>',
    paste: '<path d="M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"/><path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"/><path d="m17 10 4 4-4 4"/>',
    pin: '<line x1="12" x2="12" y1="17" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>',
    pivot: '<path d="M15 3v18"/><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M21 9H3"/><path d="M21 15H3"/>',
    plus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/>',
    previous: '<path d="m15 18-6-6 6-6"/>',
    right: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    save: '<path d="M12 17V3"/><path d="m6 11 6 6 6-6"/><path d="M19 21H5"/>',
    "small-left": '<path d="m15 18-6-6 6-6"/>',
    "small-right": '<path d="m9 18 6-6-6-6"/>',
    tick: '<path d="M20 6 9 17l-5-5"/>',
    "tree-closed": '<path d="m9 18 6-6-6-6"/>',
    "tree-indeterminate": '<path d="M5 12h14"/>',
    "tree-open": '<path d="m6 9 6 6 6-6"/>',
    unlinked: '<path d="M9 17H7A5 5 0 0 1 7 7"/><path d="M15 7h2a5 5 0 0 1 4 8"/><line x1="8" x2="12" y1="12" y2="12"/><line x1="2" x2="22" y1="2" y2="22"/>',
    up: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
    grip: '<circle cx="5" cy="8" r="0.5"/><circle cx="12" cy="8" r="0.5"/><circle cx="19" cy="8" r="0.5"/><circle cx="5" cy="16" r="0.5"/><circle cx="12" cy="16" r="0.5"/><circle cx="19" cy="16" r="0.5"/><g stroke="none" fill="currentColor"><circle cx="5" cy="8" r="1"/><circle cx="12" cy="8" r="1"/><circle cx="19" cy="8" r="1"/><circle cx="5" cy="16" r="1"/><circle cx="12" cy="16" r="1"/><circle cx="19" cy="16" r="1"/></g>',
    settings: '<path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/>'
};
var $437b23f6a393c3bf$var$iconNameToFullSvg = {
    "column-arrow": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 26C0 28.2092 1.79086 30 4 30H14C16.2091 30 18 28.2092 18 26V15H25.8786L24.4394 16.4393C23.8536 17.0251 23.8536 17.9749 24.4394 18.5607C25.0252 19.1464 25.9748 19.1464 26.5606 18.5607L30.5606 14.5607C31.1464 13.9749 31.1464 13.0251 30.5606 12.4393L26.5606 8.43934C25.9748 7.85356 25.0252 7.85356 24.4394 8.43934C23.8536 9.02512 23.8536 9.97488 24.4394 10.5607L25.8786 12H18V6C18 3.79086 16.2091 2 14 2H4C1.79086 2 0 3.79086 0 6V26ZM14 5H10.5V12H15V6C15 5.44772 14.5523 5 14 5ZM4 5H7.5V12H3V6C3 5.44772 3.44772 5 4 5ZM10.5 15H15V26C15 26.5522 14.5523 27 14 27H10.5V15ZM4 27H7.5V15H3V26C3 26.5522 3.44772 27 4 27Z" fill="currentColor"/></svg>',
    "small-down": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 10.667 16 21.334l8.667-10.667H7.334Z"/></svg>',
    "small-up": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 21.333 16 10.666l8.667 10.667H7.334Z"/></svg>',
    "pinned-top": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22ZM3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536Z"/></svg>',
    "pinned-bottom": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22ZM12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536Z"/></svg>',
    "un-pin": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11Z"/><path fill="currentColor" d="M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904l.589-.825Zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28l2.887-4.044ZM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972L9.277 1Z"/></svg>',
    "chevron-down": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6L8 10L4 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "chevron-up": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 10L8 6L12 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "chevron-left": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "chevron-right": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "filter-add": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.12126 7.75L10.8517 7.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M6.65934 11.748L9.32778 11.748" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M12.2943 1.04872V6.19184M14.9886 3.74341H9.68478" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M8.25488 3C8.04799 3.18323 7.91706 3.45099 7.91699 3.74902C7.91713 4.04868 8.04988 4.31681 8.25879 4.5H2C1.58579 4.5 1.25 4.16421 1.25 3.75C1.25 3.33579 1.58579 3 2 3H8.25488Z" fill="currentColor"/></svg>',
    edit: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 10.6262V12.5012H5.375L10.905 6.97122L9.03 5.09622L3.5 10.6262ZM12.355 5.52122C12.4014 5.47497 12.4381 5.42002 12.4632 5.35953C12.4883 5.29905 12.5012 5.23421 12.5012 5.16872C12.5012 5.10324 12.4883 5.0384 12.4632 4.97791C12.4381 4.91742 12.4014 4.86248 12.355 4.81622L11.185 3.64622C11.1387 3.59987 11.0838 3.5631 11.0233 3.53801C10.9628 3.51291 10.898 3.5 10.8325 3.5C10.767 3.5 10.7022 3.51291 10.6417 3.53801C10.5812 3.5631 10.5263 3.59987 10.48 3.64622L9.565 4.56122L11.44 6.43622L12.355 5.52122Z" fill="currentColor"/></svg>'
};
var $437b23f6a393c3bf$var$getQuartzIconsCss = (args = {})=>{
    let result = "";
    for (const iconName of [
        ...Object.keys($437b23f6a393c3bf$var$iconNameToSvgFragment),
        ...Object.keys($437b23f6a393c3bf$var$iconNameToFullSvg)
    ]){
        const iconSvg = $437b23f6a393c3bf$var$quartzIconSvg(iconName, args.strokeWidth);
        result += `.ag-icon-${iconName}::before { mask-image: url('data:image/svg+xml,${encodeURIComponent(iconSvg)}'); }
`;
    }
    return result;
};
var $437b23f6a393c3bf$var$quartzIconSvg = (name, strokeWidth = 1.5)=>{
    const fullSVG = $437b23f6a393c3bf$var$iconNameToFullSvg[name];
    if (fullSVG) return fullSVG;
    const svgFragment = $437b23f6a393c3bf$var$iconNameToSvgFragment[name];
    if (!svgFragment) throw new Error(`Missing icon data for ${name}`);
    return `<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="black" stroke-width="${strokeWidth}" viewBox="0 0 24 24"><style>* { vector-effect: non-scaling-stroke; }</style>` + svgFragment + "</svg>";
};
// packages/ag-grid-community/src/theming/parts/icon-set/quartz/icon-set-quartz.ts
var $437b23f6a393c3bf$export$d2d85e4420173ddb = (args = {})=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "iconSet",
        css: ()=>$437b23f6a393c3bf$var$getQuartzIconsCss(args)
    });
};
var $437b23f6a393c3bf$export$3147a7744202f5a7 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb({
    strokeWidth: 1
});
var $437b23f6a393c3bf$export$b60dff12ba08ba55 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb();
var $437b23f6a393c3bf$export$3a4c15e55a998025 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb({
    strokeWidth: 2
});
// packages/ag-grid-community/src/theming/parts/input-style/input-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleBaseCSS = /*css*/ `:where(.ag-input-field-input[type=number]:not(.ag-number-field-input-stepper)){-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}}.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){background-color:var(--ag-input-background-color);border:var(--ag-input-border);border-radius:var(--ag-input-border-radius);color:var(--ag-input-text-color);font-family:inherit;font-size:inherit;line-height:inherit;margin:0;min-height:var(--ag-input-height);padding:0;&:where(:disabled){background-color:var(--ag-input-disabled-background-color);border:var(--ag-input-disabled-border);color:var(--ag-input-disabled-text-color)}&:where(:focus){background-color:var(--ag-input-focus-background-color);border:var(--ag-input-focus-border);box-shadow:var(--ag-input-focus-shadow);color:var(--ag-input-focus-text-color);outline:none}&:where(:invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&::-moz-placeholder{color:var(--ag-input-placeholder-text-color)}&::placeholder{color:var(--ag-input-placeholder-text-color)}}:where(.ag-ltr) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-left:var(--ag-input-padding-start)}:where(.ag-rtl) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-right:var(--ag-input-padding-start)}:where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{background-color:currentcolor;color:var(--ag-input-icon-color);content:"";display:block;height:12px;-webkit-mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;opacity:.5;position:absolute;width:12px}}:where(.ag-ltr) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{margin-left:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-left:calc(var(--ag-spacing)*1.5 + 12px)}}:where(.ag-rtl) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{margin-right:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-right:calc(var(--ag-spacing)*1.5 + 12px)}}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-style-bordered.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleBorderedCSS = /*css*/ `.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){&:focus{box-shadow:var(--ag-focus-shadow);&:where(.invalid),&:where(:invalid){box-shadow:var(--ag-focus-error-shadow)}}}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-style-underlined.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleUnderlinedCSS = /*css*/ `.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){border-left:none;border-right:none;border-top:none}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-styles.ts
var $437b23f6a393c3bf$var$baseParams3 = {
    inputBackgroundColor: "transparent",
    inputBorder: false,
    inputBorderRadius: 0,
    inputTextColor: {
        ref: "textColor"
    },
    inputPlaceholderTextColor: {
        ref: "inputTextColor",
        mix: 0.5
    },
    inputPaddingStart: 0,
    inputHeight: {
        calc: "max(iconSize, fontSize) + spacing * 2"
    },
    inputFocusBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputFocusBorder: {
        ref: "inputBorder"
    },
    inputFocusShadow: "none",
    inputFocusTextColor: {
        ref: "inputTextColor"
    },
    inputDisabledBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputDisabledBorder: {
        ref: "inputBorder"
    },
    inputDisabledTextColor: {
        ref: "inputTextColor"
    },
    inputInvalidBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputInvalidBorder: {
        ref: "inputBorder"
    },
    inputInvalidTextColor: {
        ref: "inputTextColor"
    },
    inputIconColor: {
        ref: "inputTextColor"
    },
    pickerButtonBorder: false,
    pickerButtonFocusBorder: {
        ref: "inputFocusBorder"
    },
    pickerButtonBackgroundColor: {
        ref: "backgroundColor"
    },
    pickerButtonFocusBackgroundColor: {
        ref: "backgroundColor"
    },
    pickerListBorder: false,
    pickerListBackgroundColor: {
        ref: "backgroundColor"
    },
    colorPickerThumbSize: 18,
    colorPickerTrackSize: 12,
    colorPickerThumbBorderWidth: 3,
    colorPickerTrackBorderRadius: 12,
    colorPickerColorBorderRadius: 4
};
var $437b23f6a393c3bf$var$makeInputStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: $437b23f6a393c3bf$var$baseParams3,
        css: $437b23f6a393c3bf$var$inputStyleBaseCSS
    });
var $437b23f6a393c3bf$export$2c8ad0489069516 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeInputStyleBorderedTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams3,
            inputBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            inputBorder: true,
            inputBorderRadius: {
                ref: "borderRadius"
            },
            inputPaddingStart: {
                ref: "spacing"
            },
            inputFocusBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            },
            inputFocusShadow: {
                ref: "focusShadow"
            },
            inputDisabledBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.06),
            inputDisabledTextColor: {
                ref: "textColor",
                mix: 0.5
            },
            inputInvalidBorder: {
                color: {
                    ref: "invalidColor"
                }
            },
            pickerButtonBorder: true,
            pickerListBorder: true
        },
        css: ()=>$437b23f6a393c3bf$var$inputStyleBaseCSS + $437b23f6a393c3bf$var$inputStyleBorderedCSS
    });
var $437b23f6a393c3bf$export$df11db3e1948ad10 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleBorderedTreeShakeable();
var $437b23f6a393c3bf$var$makeInputStyleUnderlinedTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams3,
            inputBackgroundColor: "transparent",
            inputBorder: {
                width: 2,
                color: $437b23f6a393c3bf$var$foregroundMix(0.3)
            },
            inputPaddingStart: {
                ref: "spacing"
            },
            inputFocusBorder: "solid 2px var(--ag-accent-color)",
            inputDisabledTextColor: {
                ref: "textColor",
                mix: 0.5
            },
            inputDisabledBorder: "solid 1px var(--ag-border-color)",
            inputInvalidBorder: {
                width: 2,
                color: {
                    ref: "invalidColor",
                    mix: 0.3
                }
            }
        },
        css: ()=>$437b23f6a393c3bf$var$inputStyleBaseCSS + $437b23f6a393c3bf$var$inputStyleUnderlinedCSS
    });
var $437b23f6a393c3bf$export$c9667c02da45fcf0 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleUnderlinedTreeShakeable();
// packages/ag-grid-community/src/theming/parts/tab-style/tab-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$tabStyleBaseCSS = /*css*/ `.ag-tabs-header{background-color:var(--ag-tab-bar-background-color);border-bottom:var(--ag-tab-bar-border);display:flex;flex:1;gap:var(--ag-tab-spacing);padding:var(--ag-tab-bar-top-padding) var(--ag-tab-bar-horizontal-padding) 0}.ag-tabs-header-wrapper{display:flex}.ag-tabs-close-button-wrapper{align-items:center;border:0;display:flex;padding:var(--ag-spacing)}:where(.ag-ltr) .ag-tabs-close-button-wrapper{border-right:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-tabs-close-button-wrapper{border-left:solid var(--ag-border-width) var(--ag-border-color)}.ag-tabs-close-button{background-color:unset;border:0;cursor:pointer;padding:0}.ag-tab{align-items:center;background-color:var(--ag-tab-background-color);border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;color:var(--ag-tab-text-color);cursor:pointer;display:flex;flex:1;justify-content:center;padding:var(--ag-tab-top-padding) var(--ag-tab-horizontal-padding) var(--ag-tab-bottom-padding);position:relative;&:hover{background-color:var(--ag-tab-hover-background-color);color:var(--ag-tab-hover-text-color)}&.ag-tab-selected{background-color:var(--ag-tab-selected-background-color);color:var(--ag-tab-selected-text-color)}&:after{background-color:var(--ag-tab-selected-underline-color);bottom:0;content:"";display:block;height:var(--ag-tab-selected-underline-width);left:0;opacity:0;position:absolute;right:0;transition:opacity var(--ag-tab-selected-underline-transition-duration)}&.ag-tab-selected:after{opacity:1}}:where(.ag-ltr) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-left-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-right-color:var(--ag-tab-selected-border-color)}}}:where(.ag-rtl) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-right-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-left-color:var(--ag-tab-selected-border-color)}}}`;
// packages/ag-grid-community/src/theming/parts/tab-style/tab-style-rolodex.css-GENERATED.ts
var $437b23f6a393c3bf$var$tabStyleRolodexCSS = /*css*/ `.ag-tab{border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;border-top:var(--ag-tab-selected-border-width) solid transparent;flex:none;&.ag-tab-selected{border-left-color:var(--ag-tab-selected-border-color);border-right-color:var(--ag-tab-selected-border-color);border-top-color:var(--ag-tab-selected-border-color);margin-bottom:-1px;padding-bottom:calc(var(--ag-tab-bottom-padding) + 1px)}}`;
// packages/ag-grid-community/src/theming/parts/tab-style/tab-styles.ts
var $437b23f6a393c3bf$var$baseParams4 = {
    tabBarBackgroundColor: "transparent",
    tabBarHorizontalPadding: 0,
    tabBarTopPadding: 0,
    tabBackgroundColor: "transparent",
    tabTextColor: {
        ref: "textColor"
    },
    tabHorizontalPadding: {
        ref: "spacing"
    },
    tabTopPadding: {
        ref: "spacing"
    },
    tabBottomPadding: {
        ref: "spacing"
    },
    tabSpacing: "0",
    tabHoverBackgroundColor: {
        ref: "tabBackgroundColor"
    },
    tabHoverTextColor: {
        ref: "tabTextColor"
    },
    tabSelectedBackgroundColor: {
        ref: "tabBackgroundColor"
    },
    tabSelectedTextColor: {
        ref: "tabTextColor"
    },
    tabSelectedBorderWidth: {
        ref: "borderWidth"
    },
    tabSelectedBorderColor: "transparent",
    tabSelectedUnderlineColor: "transparent",
    tabSelectedUnderlineWidth: 0,
    tabSelectedUnderlineTransitionDuration: 0,
    tabBarBorder: false
};
var $437b23f6a393c3bf$var$makeTabStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: $437b23f6a393c3bf$var$baseParams4,
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$7e3279c3902732ba = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBorder: true,
            tabBarBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.05),
            tabTextColor: {
                ref: "textColor",
                mix: 0.7
            },
            tabSelectedTextColor: {
                ref: "textColor"
            },
            tabHoverTextColor: {
                ref: "textColor"
            },
            tabSelectedBorderColor: {
                ref: "borderColor"
            },
            tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$7ad22b51edfdfcfe = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleMaterialTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabSelectedUnderlineColor: {
                ref: "primaryColor"
            },
            tabSelectedUnderlineWidth: 2,
            tabSelectedUnderlineTransitionDuration: 0
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$4c07fbd6ebedeb01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleMaterialTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBorder: true,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabHoverTextColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedTextColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedUnderlineWidth: 2,
            tabSelectedUnderlineTransitionDuration: "0.3s"
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$e3b539837601fcda = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleRolodexTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabBarHorizontalPadding: {
                ref: "spacing"
            },
            tabBarTopPadding: {
                ref: "spacing"
            },
            tabBarBorder: true,
            tabHorizontalPadding: {
                calc: "spacing * 2"
            },
            tabTopPadding: {
                ref: "spacing"
            },
            tabBottomPadding: {
                ref: "spacing"
            },
            tabSpacing: {
                ref: "spacing"
            },
            tabSelectedBorderColor: {
                ref: "borderColor"
            },
            tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: ()=>$437b23f6a393c3bf$var$tabStyleBaseCSS + $437b23f6a393c3bf$var$tabStyleRolodexCSS
    });
var $437b23f6a393c3bf$export$5c4a9ec5ca09df01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleRolodexTreeShakeable();
// packages/ag-grid-community/src/theming/parts/theme/material-adjustments.css-GENERATED.ts
var $437b23f6a393c3bf$var$materialAdjustmentsCSS = /*css*/ `.ag-dnd-ghost,.ag-filter-toolpanel-header,.ag-filter-toolpanel-search,.ag-multi-filter-group-title-bar,.ag-panel-title-bar-title,.ag-status-bar{color:var(--ag-header-text-color);font-size:calc(var(--ag-font-size) - 1px);font-weight:600}.ag-column-drop-horizontal{background-color:color-mix(in srgb,var(--ag-background-color),var(--ag-foreground-color) 8%)}.ag-cell.ag-cell-inline-editing{background-color:var(--ag-background-color);background-image:linear-gradient(0deg,var(--ag-input-background-color),var(--ag-input-background-color));border:var(--ag-input-border)!important;border-width:1px!important;height:calc(var(--ag-row-height) + var(--ag-spacing)*3);padding:var(--ag-spacing);:where(.ag-row-last:not(.ag-row-first)) &{bottom:0}:where(.ag-has-focus) &{border:var(--ag-input-focus-border)!important;border-width:1px!important}}.ag-advanced-filter-builder-button,.ag-standard-button{text-transform:uppercase}.ag-status-bar{border:solid var(--ag-border-width) var(--ag-border-color)}.ag-list-item-hovered:after{background-color:var(--ag-primary-color)}.ag-pill-button:hover{color:var(--ag-primary-color)}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-primary-color)}.ag-filter-add-button,.ag-filter-add-button:hover{border-bottom:2px solid var(--ag-primary-color)}`;
// packages/ag-grid-community/src/theming/parts/theme/themes.ts
var $437b23f6a393c3bf$var$makeThemeQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$b60dff12ba08ba55).withPart($437b23f6a393c3bf$export$7ad22b51edfdfcfe).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withParams({
        fontFamily: [
            {
                googleFont: "IBM Plex Sans"
            },
            "-apple-system",
            "BlinkMacSystemFont",
            "Segoe UI",
            "Roboto",
            "Oxygen-Sans",
            "Ubuntu"
        ]
    });
var $437b23f6a393c3bf$export$495b90cf446940a1 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$c5a38eb31ae86567).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$9bb4a1bee1653083).withPart($437b23f6a393c3bf$export$e3b539837601fcda).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withParams({
        accentColor: "#2196f3",
        selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.3),
        inputFocusBorder: {
            color: $437b23f6a393c3bf$var$accentMix(0.4)
        },
        focusShadow: {
            radius: 2,
            spread: 1.6,
            color: $437b23f6a393c3bf$var$accentMix(0.4)
        },
        iconButtonHoverBackgroundColor: "transparent",
        iconButtonActiveBackgroundColor: "transparent",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxIndeterminateBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxBorderWidth: 2,
        checkboxBorderRadius: 2,
        fontSize: 13,
        dataFontSize: 14,
        headerFontWeight: 700,
        borderRadius: 3,
        wrapperBorderRadius: 3,
        tabSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
        tabSelectedBorderWidth: 0,
        tabSelectedUnderlineTransitionDuration: 0.3,
        sideButtonSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
        sideButtonSelectedUnderlineWidth: 2,
        sideButtonSelectedUnderlineTransitionDuration: 0.3,
        sideButtonBorder: false,
        sideButtonSelectedBorder: false,
        sideButtonBarTopPadding: {
            calc: "spacing * 3"
        },
        sideButtonSelectedBackgroundColor: "transparent",
        sideButtonHoverTextColor: $437b23f6a393c3bf$var$accentColor,
        iconButtonHoverColor: $437b23f6a393c3bf$var$accentColor,
        toggleButtonWidth: 28,
        toggleButtonHeight: 18,
        toggleButtonSwitchInset: 1,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        colorPickerThumbSize: 13,
        colorPickerTrackSize: 11,
        colorPickerThumbBorderWidth: 2,
        colorPickerTrackBorderRadius: 2,
        colorPickerColorBorderRadius: 2
    });
var $437b23f6a393c3bf$export$dfd7728c5c3233e9 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeBalhamTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$effe67f8e12191d5).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$var$iconSetBalham).withPart($437b23f6a393c3bf$export$5c4a9ec5ca09df01).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9eadc93b54e4a807).withParams({
        accentColor: "#0091ea",
        borderColor: $437b23f6a393c3bf$var$foregroundMix(0.2),
        spacing: 4,
        widgetVerticalSpacing: {
            calc: "max(8px, spacing)"
        },
        borderRadius: 2,
        wrapperBorderRadius: 2,
        headerColumnResizeHandleColor: "transparent",
        headerColumnBorder: true,
        headerColumnBorderHeight: "50%",
        oddRowBackgroundColor: {
            ref: "chromeBackgroundColor",
            mix: 0.5
        },
        checkboxBorderRadius: 2,
        checkboxBorderWidth: 1,
        checkboxUncheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxCheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxCheckedBorderColor: $437b23f6a393c3bf$var$accentColor,
        checkboxCheckedShapeColor: $437b23f6a393c3bf$var$accentColor,
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxIndeterminateBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxIndeterminateShapeColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        focusShadow: {
            radius: 2,
            spread: 1,
            color: $437b23f6a393c3bf$var$accentColor
        },
        headerTextColor: $437b23f6a393c3bf$var$foregroundMix(0.6),
        iconButtonHoverBackgroundColor: "transparent",
        iconButtonActiveBackgroundColor: "transparent",
        fontSize: 12,
        tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        headerFontWeight: "bold",
        toggleButtonWidth: 32,
        toggleButtonHeight: 16,
        toggleButtonSwitchInset: 1,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        sideButtonBorder: true,
        sideButtonBarTopPadding: {
            calc: "spacing * 4"
        },
        popupShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)",
        statusBarLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.54),
        statusBarLabelFontWeight: 600,
        statusBarValueFontWeight: 600,
        panelTitleBarIconColor: $437b23f6a393c3bf$var$foregroundColor,
        colorPickerThumbSize: 13,
        colorPickerTrackSize: 11,
        colorPickerThumbBorderWidth: 2,
        colorPickerTrackBorderRadius: 2,
        colorPickerColorBorderRadius: 2
    });
var $437b23f6a393c3bf$export$679a577f1afc49d7 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeBalhamTreeShakeable();
var $437b23f6a393c3bf$var$makeStyleMaterialTreeShakeable = ()=>{
    const sharedParams = {
        tabSelectedUnderlineColor: {
            ref: "primaryColor"
        },
        sideButtonSelectedUnderlineColor: {
            ref: "primaryColor"
        },
        buttonTextColor: {
            ref: "primaryColor"
        },
        rangeSelectionBackgroundColor: {
            ref: "primaryColor",
            mix: 0.2
        },
        rangeSelectionBorderColor: {
            ref: "primaryColor"
        },
        rangeSelectionHighlightColor: {
            ref: "primaryColor",
            mix: 0.5
        },
        rangeHeaderHighlightColor: {
            ref: "foregroundColor",
            mix: 0.08
        },
        rowNumbersSelectedColor: {
            ref: "primaryColor",
            mix: 0.5
        },
        inputFocusBorder: {
            width: 2,
            color: {
                ref: "primaryColor"
            }
        },
        pickerButtonFocusBorder: {
            width: 1,
            color: {
                ref: "primaryColor"
            }
        },
        cellEditingBorder: {
            color: {
                ref: "primaryColor"
            }
        },
        menuBackgroundColor: {
            ref: "backgroundColor"
        },
        sideButtonBarBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        sideButtonSelectedBackgroundColor: "transparent",
        sideButtonBarTopPadding: {
            calc: "spacing * 4"
        },
        headerColumnResizeHandleColor: "none",
        headerBackgroundColor: {
            ref: "backgroundColor"
        },
        rowHoverColor: $437b23f6a393c3bf$var$foregroundMix(0.08),
        columnHoverColor: $437b23f6a393c3bf$var$foregroundMix(0.08),
        headerCellHoverBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.05),
        statusBarLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.63),
        statusBarLabelFontWeight: 600,
        statusBarValueFontWeight: 600,
        valueChangeValueHighlightBackgroundColor: "#00acc1",
        panelTitleBarIconColor: $437b23f6a393c3bf$var$foregroundColor,
        advancedFilterBuilderButtonBarBorder: false,
        filterPanelApplyButtonColor: {
            ref: "buttonTextColor"
        },
        filterPanelApplyButtonBackgroundColor: {
            ref: "buttonBackgroundColor"
        },
        colorPickerThumbSize: 13,
        colorPickerTrackSize: 11,
        colorPickerThumbBorderWidth: 2,
        colorPickerTrackBorderRadius: 2,
        colorPickerColorBorderRadius: 2
    };
    const lightParams = {
        ...sharedParams,
        primaryColor: "#3f51b5",
        foregroundColor: "#000D",
        headerTextColor: "#0008",
        accentColor: "#ff4081",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundColor,
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundColor,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundColor,
        selectedRowBackgroundColor: "rgba(33, 150, 243, 0.3)"
    };
    const darkParams2 = {
        ...sharedParams,
        primaryColor: "#3f51b5",
        foregroundColor: "#fffD",
        headerTextColor: "#fff8",
        accentColor: "#bb86fc",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        selectedRowBackgroundColor: "#bb86fc33"
    };
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "styleMaterial",
        css: $437b23f6a393c3bf$var$materialAdjustmentsCSS,
        params: lightParams,
        modeParams: {
            light: lightParams,
            dark: darkParams2,
            "dark-blue": darkParams2
        }
    });
};
var $437b23f6a393c3bf$export$5fe7e1ddfe58a67 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeStyleMaterialTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeMaterialTreeShakeable = ()=>/* @__PURE__ */ $437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$ac3227978dde8e12).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$e9404e008fead04f).withPart($437b23f6a393c3bf$export$4c07fbd6ebedeb01).withPart($437b23f6a393c3bf$export$c9667c02da45fcf0).withPart($437b23f6a393c3bf$export$9eadc93b54e4a807).withPart($437b23f6a393c3bf$export$5fe7e1ddfe58a67).withParams({
        rowHeight: {
            calc: "max(iconSize, dataFontSize) + spacing * 3.75 * rowVerticalPaddingScale"
        },
        headerHeight: {
            calc: "max(iconSize, dataFontSize) + spacing * 4.75 * headerVerticalPaddingScale"
        },
        widgetVerticalSpacing: {
            calc: "spacing * 1.75"
        },
        cellHorizontalPadding: {
            calc: "spacing * 3"
        },
        buttonHorizontalPadding: {
            ref: "spacing"
        },
        widgetContainerHorizontalPadding: {
            calc: "spacing * 1.5"
        },
        widgetContainerVerticalPadding: {
            calc: "spacing * 2"
        },
        fontSize: 13,
        iconSize: 18,
        borderRadius: 0,
        wrapperBorderRadius: 0,
        wrapperBorder: false,
        menuBorder: false,
        dialogBorder: false,
        panelTitleBarBorder: false,
        tabSelectedBorderWidth: 0,
        tabSelectedUnderlineTransitionDuration: 0.3,
        sidePanelBorder: false,
        sideButtonSelectedBorder: false,
        sideButtonSelectedUnderlineWidth: 2,
        sideButtonSelectedUnderlineTransitionDuration: 0.3,
        sideButtonBorder: false,
        buttonBorder: false,
        buttonDisabledBorder: false,
        focusShadow: {
            spread: 4,
            color: $437b23f6a393c3bf$var$foregroundMix(0.16)
        },
        fontFamily: [
            {
                googleFont: "Roboto"
            },
            "-apple-system",
            "BlinkMacSystemFont",
            "Segoe UI",
            "Oxygen-Sans",
            "Ubuntu",
            "Cantarell",
            "Helvetica Neue",
            "sans-serif"
        ],
        inputHeight: {
            calc: "max(iconSize, fontSize) + spacing * 3"
        },
        pickerButtonBorder: {
            width: 1,
            color: "transparent"
        },
        headerFontWeight: 600,
        headerFontSize: {
            calc: "fontSize - 1px"
        },
        checkboxBorderWidth: 2,
        checkboxBorderRadius: 2,
        toggleButtonWidth: 34,
        toggleButtonSwitchInset: 1,
        cardShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
        popupShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)"
    });
var $437b23f6a393c3bf$export$55ff169dc6a8025a = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeMaterialTreeShakeable();
// packages/ag-grid-community/src/environment.ts
var $437b23f6a393c3bf$var$CELL_HORIZONTAL_PADDING = {
    cssName: "--ag-cell-horizontal-padding",
    changeKey: "cellHorizontalPaddingChanged",
    defaultValue: 16
};
var $437b23f6a393c3bf$var$INDENTATION_LEVEL = {
    cssName: "--ag-indentation-level",
    changeKey: "indentationLevelChanged",
    defaultValue: 0,
    noWarn: true,
    cacheDefault: true
};
var $437b23f6a393c3bf$var$ROW_GROUP_INDENT_SIZE = {
    cssName: "--ag-row-group-indent-size",
    changeKey: "rowGroupIndentSizeChanged",
    defaultValue: 0
};
var $437b23f6a393c3bf$var$ROW_HEIGHT = {
    cssName: "--ag-row-height",
    changeKey: "rowHeightChanged",
    defaultValue: 42
};
var $437b23f6a393c3bf$var$HEADER_HEIGHT = {
    cssName: "--ag-header-height",
    changeKey: "headerHeightChanged",
    defaultValue: 48
};
var $437b23f6a393c3bf$var$LIST_ITEM_HEIGHT = {
    cssName: "--ag-list-item-height",
    changeKey: "listItemHeightChanged",
    defaultValue: 24
};
var $437b23f6a393c3bf$var$ROW_BORDER_WIDTH = {
    cssName: "--ag-row-border",
    changeKey: "rowBorderWidthChanged",
    defaultValue: 1,
    border: true
};
var $437b23f6a393c3bf$var$PINNED_BORDER_WIDTH = {
    cssName: "--ag-pinned-row-border",
    changeKey: "pinnedRowBorderWidthChanged",
    defaultValue: 1,
    border: true
};
function $437b23f6a393c3bf$export$950282e49bfaca2e(cssMap, modules) {
    for (const module of modules.sort((a, b)=>a.moduleName.localeCompare(b.moduleName))){
        const moduleCss = module.css;
        if (moduleCss) cssMap.set(`module-${module.moduleName}`, moduleCss);
    }
}
var $437b23f6a393c3bf$var$Environment = class extends $437b23f6a393c3bf$export$13d30f6a265c57c6 {
    constructor(){
        super(...arguments);
        this.sizeEls = /* @__PURE__ */ new Map();
        this.lastKnownValues = /* @__PURE__ */ new Map();
        this.sizesMeasured = false;
    }
    initVariables() {
        this.addManagedPropertyListener("rowHeight", ()=>this.refreshRowHeightVariable());
        this.getSizeEl($437b23f6a393c3bf$var$ROW_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$HEADER_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$LIST_ITEM_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
        this.getSizeEl($437b23f6a393c3bf$var$PINNED_BORDER_WIDTH);
        this.refreshRowBorderWidthVariable();
    }
    getPinnedRowBorderWidth() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$PINNED_BORDER_WIDTH);
    }
    getRowBorderWidth() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
    }
    getDefaultRowHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_HEIGHT);
    }
    getDefaultHeaderHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$HEADER_HEIGHT);
    }
    getDefaultCellHorizontalPadding() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$CELL_HORIZONTAL_PADDING);
    }
    getCellPaddingLeft() {
        const cellHorizontalPadding = this.getDefaultCellHorizontalPadding();
        const indentationLevel = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$INDENTATION_LEVEL);
        const rowGroupIndentSize = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_GROUP_INDENT_SIZE);
        return cellHorizontalPadding - 1 + rowGroupIndentSize * indentationLevel;
    }
    getCellPadding() {
        const cellPaddingRight = this.getDefaultCellHorizontalPadding() - 1;
        return this.getCellPaddingLeft() + cellPaddingRight;
    }
    getDefaultColumnMinWidth() {
        return Math.min(36, this.getDefaultRowHeight());
    }
    getDefaultListItemHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$LIST_ITEM_HEIGHT);
    }
    refreshRowHeightVariable() {
        const { eRootDiv: eRootDiv } = this;
        const oldRowHeight = eRootDiv.style.getPropertyValue("--ag-line-height").trim();
        const height = this.gos.get("rowHeight");
        if (height == null || isNaN(height) || !isFinite(height)) {
            if (oldRowHeight !== null) eRootDiv.style.setProperty("--ag-line-height", null);
            return -1;
        }
        const newRowHeight = `${height}px`;
        if (oldRowHeight != newRowHeight) {
            eRootDiv.style.setProperty("--ag-line-height", newRowHeight);
            return height;
        }
        return oldRowHeight != "" ? Number.parseFloat(oldRowHeight) : -1;
    }
    getCSSVariablePixelValue(variable) {
        const cached = this.lastKnownValues.get(variable);
        if (cached != null) return cached;
        const measurement = this.measureSizeEl(variable);
        if (measurement === "detached" || measurement === "no-styles") {
            if (variable.cacheDefault) this.lastKnownValues.set(variable, variable.defaultValue);
            return variable.defaultValue;
        }
        this.lastKnownValues.set(variable, measurement);
        return measurement;
    }
    measureSizeEl(variable) {
        const sizeEl = this.getSizeEl(variable);
        if (sizeEl.offsetParent == null) return "detached";
        const newSize = sizeEl.offsetWidth;
        if (newSize === $437b23f6a393c3bf$var$NO_VALUE_SENTINEL) return "no-styles";
        this.sizesMeasured = true;
        return newSize;
    }
    getMeasurementContainer() {
        let container = this.eMeasurementContainer;
        if (!container) {
            container = this.eMeasurementContainer = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-measurement-container"
            });
            this.eRootDiv.appendChild(container);
        }
        return container;
    }
    getSizeEl(variable) {
        let sizeEl = this.sizeEls.get(variable);
        if (sizeEl) return sizeEl;
        const container = this.getMeasurementContainer();
        sizeEl = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div"
        });
        const { border: border, noWarn: noWarn } = variable;
        if (border) {
            sizeEl.className = "ag-measurement-element-border";
            sizeEl.style.setProperty("--ag-internal-measurement-border", `var(${variable.cssName}, solid ${$437b23f6a393c3bf$var$NO_VALUE_SENTINEL}px)`);
        } else sizeEl.style.width = `var(${variable.cssName}, ${$437b23f6a393c3bf$var$NO_VALUE_SENTINEL}px)`;
        container.appendChild(sizeEl);
        this.sizeEls.set(variable, sizeEl);
        let lastMeasurement = this.measureSizeEl(variable);
        if (lastMeasurement === "no-styles" && !noWarn) $437b23f6a393c3bf$export$545083624300f13d(9, {
            variable: variable
        });
        const unsubscribe = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, sizeEl, ()=>{
            const newMeasurement = this.measureSizeEl(variable);
            if (newMeasurement === "detached" || newMeasurement === "no-styles") return;
            this.lastKnownValues.set(variable, newMeasurement);
            if (newMeasurement !== lastMeasurement) {
                lastMeasurement = newMeasurement;
                this.fireStylesChangedEvent(variable.changeKey);
            }
        });
        this.addDestroyFunc(()=>unsubscribe());
        return sizeEl;
    }
    fireStylesChangedEvent(change) {
        if (change === "rowBorderWidthChanged") this.refreshRowBorderWidthVariable();
        this.eventSvc.dispatchEvent({
            type: "gridStylesChanged",
            [change]: true
        });
    }
    refreshRowBorderWidthVariable() {
        const width = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
        this.eRootDiv.style.setProperty("--ag-internal-row-border-width", `${width}px`);
    }
    postProcessThemeChange(newGridTheme, themeGridOption) {
        if (newGridTheme && getComputedStyle(this.getMeasurementContainer()).getPropertyValue("--ag-legacy-styles-loaded")) {
            if (themeGridOption) $437b23f6a393c3bf$export$a20c7248650823a9(106);
            else $437b23f6a393c3bf$export$a20c7248650823a9(239);
        }
    }
    getAdditionalCss() {
        const additionalCss = /* @__PURE__ */ new Map();
        additionalCss.set("core", [
            $437b23f6a393c3bf$var$coreCSS
        ]);
        $437b23f6a393c3bf$export$950282e49bfaca2e(additionalCss, Array.from($437b23f6a393c3bf$var$_getAllRegisteredModules()));
        return additionalCss;
    }
    getDefaultTheme() {
        return $437b23f6a393c3bf$export$495b90cf446940a1;
    }
    themeError(theme) {
        $437b23f6a393c3bf$export$a20c7248650823a9(240, {
            theme: theme
        });
    }
};
var $437b23f6a393c3bf$var$NO_VALUE_SENTINEL = 15538;
// packages/ag-grid-community/src/eventService.ts
var $437b23f6a393c3bf$var$EventService = class extends $437b23f6a393c3bf$export$495c88faa5a4d068 {
    postConstruct() {
        const { globalListener: globalListener, globalSyncListener: globalSyncListener } = this.beans;
        if (globalListener) this.addGlobalListener(globalListener, true);
        if (globalSyncListener) this.addGlobalListener(globalSyncListener, false);
    }
};
// packages/ag-grid-community/src/navigation/headerNavigationService.ts
function $437b23f6a393c3bf$var$getHeaderIndexToFocus(beans, column, level) {
    const columnRowIndex = beans.visibleCols.headerGroupRowCount;
    if (level >= columnRowIndex) return {
        column: column,
        headerRowIndex: level
    };
    let parent = column.getParent();
    while(parent && parent.getProvidedColumnGroup().getLevel() > level)parent = parent.getParent();
    const isColSpanning = column.isSpanHeaderHeight();
    if (!parent || isColSpanning && parent.isPadding()) return {
        column: column,
        headerRowIndex: columnRowIndex
    };
    return {
        column: parent,
        headerRowIndex: parent.getProvidedColumnGroup().getLevel()
    };
}
var $437b23f6a393c3bf$var$HeaderNavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "headerNavigation";
        this.currentHeaderRowWithoutSpan = -1;
    }
    postConstruct() {
        const beans = this.beans;
        beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        this.addManagedElementListeners(eDocument, {
            mousedown: ()=>{
                this.currentHeaderRowWithoutSpan = -1;
            }
        });
    }
    getHeaderPositionForColumn(colKey, floatingFilter) {
        let column;
        const { colModel: colModel, colGroupSvc: colGroupSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        if (typeof colKey === "string") {
            column = colModel.getCol(colKey);
            if (!column) column = colGroupSvc?.getColumnGroup(colKey) ?? null;
        } else column = colKey;
        if (!column) return null;
        const centerHeaderContainer = ctrlsSvc.getHeaderRowContainerCtrl();
        const allCtrls = centerHeaderContainer?.getAllCtrls();
        const isFloatingFilterVisible = $437b23f6a393c3bf$export$236389741107357f(allCtrls || []).type === "filter";
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1;
        let row = -1;
        let col = column;
        while(col){
            row++;
            col = col.getParent();
        }
        let headerRowIndex = row;
        if (floatingFilter && isFloatingFilterVisible && headerRowIndex === headerRowCount - 1) headerRowIndex++;
        return headerRowIndex === -1 ? null : {
            headerRowIndex: headerRowIndex,
            column: column
        };
    }
    /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateVertically(direction, event) {
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const { focusedHeader: focusedHeader } = focusSvc;
        if (!focusedHeader) return false;
        const { headerRowIndex: headerRowIndex } = focusedHeader;
        const column = focusedHeader.column;
        const rowLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
        const currentRowType = this.getHeaderRowType(headerRowIndex);
        const columnHeaderRowIndex = visibleCols.headerGroupRowCount;
        let { headerRowIndex: nextRow, column: nextFocusColumn, headerRowIndexWithoutSpan: headerRowIndexWithoutSpan } = direction === "UP" ? $437b23f6a393c3bf$var$getColumnVisibleParent(currentRowType, column, headerRowIndex) : $437b23f6a393c3bf$var$getColumnVisibleChild(column, headerRowIndex, columnHeaderRowIndex);
        let skipColumn = false;
        if (nextRow < 0) {
            nextRow = 0;
            nextFocusColumn = column;
            skipColumn = true;
        }
        if (nextRow >= rowLen) {
            nextRow = -1;
            this.currentHeaderRowWithoutSpan = -1;
        } else if (headerRowIndexWithoutSpan !== void 0) this.currentHeaderRowWithoutSpan = headerRowIndexWithoutSpan;
        if (!skipColumn && !nextFocusColumn) return false;
        return focusSvc.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: nextRow,
                column: nextFocusColumn
            },
            allowUserOverride: true,
            event: event
        });
    }
    /*
   * This method navigates grid header horizontally
   * @returns {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateHorizontally(direction, fromTab = false, event) {
        const { focusSvc: focusSvc, gos: gos } = this.beans;
        const focusedHeader = {
            ...focusSvc.focusedHeader
        };
        let nextHeader;
        let normalisedDirection;
        if (this.currentHeaderRowWithoutSpan !== -1) focusedHeader.headerRowIndex = this.currentHeaderRowWithoutSpan;
        else this.currentHeaderRowWithoutSpan = focusedHeader.headerRowIndex;
        if (direction === "LEFT" !== gos.get("enableRtl")) {
            normalisedDirection = "Before";
            nextHeader = this.findHeader(focusedHeader, normalisedDirection);
        } else {
            normalisedDirection = "After";
            nextHeader = this.findHeader(focusedHeader, normalisedDirection);
        }
        const userFunc = gos.getCallback("tabToNextHeader");
        if (fromTab && userFunc) {
            const wasFocusedFromUserFunc = focusSvc.focusHeaderPositionFromUserFunc({
                userFunc: userFunc,
                headerPosition: nextHeader,
                direction: normalisedDirection
            });
            if (wasFocusedFromUserFunc) {
                const { headerRowIndex: headerRowIndex } = focusSvc.focusedHeader || {};
                if (headerRowIndex != null && headerRowIndex != focusedHeader.headerRowIndex) this.currentHeaderRowWithoutSpan = headerRowIndex;
            }
            return wasFocusedFromUserFunc;
        }
        if (nextHeader || !fromTab) return focusSvc.focusHeaderPosition({
            headerPosition: nextHeader,
            direction: normalisedDirection,
            fromTab: fromTab,
            allowUserOverride: true,
            event: event
        });
        return this.focusNextHeaderRow(focusedHeader, normalisedDirection, event);
    }
    focusNextHeaderRow(focusedHeader, direction, event) {
        const beans = this.beans;
        const currentIndex = focusedHeader.headerRowIndex;
        let nextFocusedCol = null;
        let nextRowIndex;
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
        const allVisibleCols = this.beans.visibleCols.allCols;
        if (direction === "Before") {
            if (currentIndex <= 0) return false;
            nextFocusedCol = $437b23f6a393c3bf$export$236389741107357f(allVisibleCols);
            nextRowIndex = currentIndex - 1;
            this.currentHeaderRowWithoutSpan -= 1;
        } else {
            nextFocusedCol = allVisibleCols[0];
            nextRowIndex = currentIndex + 1;
            if (this.currentHeaderRowWithoutSpan < headerRowCount) this.currentHeaderRowWithoutSpan += 1;
            else this.currentHeaderRowWithoutSpan = -1;
        }
        let { column: column, headerRowIndex: headerRowIndex } = $437b23f6a393c3bf$var$getHeaderIndexToFocus(this.beans, nextFocusedCol, nextRowIndex);
        if (headerRowIndex >= headerRowCount) headerRowIndex = -1;
        return beans.focusSvc.focusHeaderPosition({
            headerPosition: {
                column: column,
                headerRowIndex: headerRowIndex
            },
            direction: direction,
            fromTab: true,
            allowUserOverride: true,
            event: event
        });
    }
    scrollToColumn(column, direction = "After") {
        if (column.getPinned()) return;
        let columnToScrollTo;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(column)) {
            const columns = column.getDisplayedLeafColumns();
            columnToScrollTo = direction === "Before" ? $437b23f6a393c3bf$export$236389741107357f(columns) : columns[0];
        } else columnToScrollTo = column;
        this.gridBodyCon.scrollFeature.ensureColumnVisible(columnToScrollTo);
    }
    findHeader(focusedHeader, direction) {
        const { colGroupSvc: colGroupSvc, visibleCols: visibleCols } = this.beans;
        let currentFocusedColumn = focusedHeader.column;
        if (currentFocusedColumn instanceof $437b23f6a393c3bf$export$273c80940a54c770) {
            const leafChildren = currentFocusedColumn.getDisplayedLeafColumns();
            currentFocusedColumn = direction === "Before" ? leafChildren[0] : leafChildren[leafChildren.length - 1];
        }
        const nextFocusedCol = direction === "Before" ? visibleCols.getColBefore(currentFocusedColumn) : visibleCols.getColAfter(currentFocusedColumn);
        if (!nextFocusedCol) return void 0;
        const headerGroupRowIndex = visibleCols.headerGroupRowCount;
        if (focusedHeader.headerRowIndex >= headerGroupRowIndex) return {
            headerRowIndex: focusedHeader.headerRowIndex,
            column: nextFocusedCol
        };
        const groupAtLevel = colGroupSvc?.getColGroupAtLevel(nextFocusedCol, focusedHeader.headerRowIndex);
        if (!groupAtLevel) {
            const isSpanningCol = nextFocusedCol instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 && nextFocusedCol.isSpanHeaderHeight();
            return {
                headerRowIndex: isSpanningCol ? visibleCols.headerGroupRowCount : focusedHeader.headerRowIndex,
                column: nextFocusedCol
            };
        }
        if (groupAtLevel.isPadding() && nextFocusedCol.isSpanHeaderHeight()) return {
            headerRowIndex: visibleCols.headerGroupRowCount,
            column: nextFocusedCol
        };
        return {
            headerRowIndex: focusedHeader.headerRowIndex,
            column: groupAtLevel ?? nextFocusedCol
        };
    }
    getHeaderRowType(rowIndex) {
        const centerHeaderContainer = this.beans.ctrlsSvc.getHeaderRowContainerCtrl();
        if (centerHeaderContainer) return centerHeaderContainer.getRowType(rowIndex);
    }
};
function $437b23f6a393c3bf$var$getColumnVisibleParent(currentRowType, currentColumn, currentIndex) {
    const optimisticNextIndex = currentIndex - 1;
    if (currentRowType !== "filter") {
        const isSpanningCol = currentColumn instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 && currentColumn.isSpanHeaderHeight();
        let nextVisibleParent = currentColumn.getParent();
        while(nextVisibleParent && // skip if row isn't visible or col is padding and spanned
        (nextVisibleParent.getProvidedColumnGroup().getLevel() > optimisticNextIndex || isSpanningCol && nextVisibleParent.isPadding()))nextVisibleParent = nextVisibleParent.getParent();
        if (nextVisibleParent) {
            if (isSpanningCol) return {
                column: nextVisibleParent,
                headerRowIndex: nextVisibleParent.getProvidedColumnGroup().getLevel(),
                headerRowIndexWithoutSpan: optimisticNextIndex
            };
            else return {
                column: nextVisibleParent,
                headerRowIndex: optimisticNextIndex,
                headerRowIndexWithoutSpan: optimisticNextIndex
            };
        }
    }
    return {
        column: currentColumn,
        headerRowIndex: optimisticNextIndex,
        headerRowIndexWithoutSpan: optimisticNextIndex
    };
}
function $437b23f6a393c3bf$var$getColumnVisibleChild(column, currentIndex, columnHeaderRowIndex) {
    const optimisticNextIndex = currentIndex + 1;
    const result = {
        column: column,
        headerRowIndex: optimisticNextIndex,
        headerRowIndexWithoutSpan: optimisticNextIndex
    };
    if (column instanceof $437b23f6a393c3bf$export$273c80940a54c770) {
        if (optimisticNextIndex >= columnHeaderRowIndex) return {
            column: column.getDisplayedLeafColumns()[0],
            headerRowIndex: columnHeaderRowIndex,
            headerRowIndexWithoutSpan: optimisticNextIndex
        };
        const children = column.getDisplayedChildren();
        let firstChild = children[0];
        if (firstChild instanceof $437b23f6a393c3bf$export$273c80940a54c770 && firstChild.isPadding()) {
            const firstCol = firstChild.getDisplayedLeafColumns()[0];
            if (firstCol.isSpanHeaderHeight()) firstChild = firstCol;
        }
        result.column = firstChild;
        const isSpanningCol = firstChild instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 && firstChild.isSpanHeaderHeight();
        if (isSpanningCol) {
            result.headerRowIndex = columnHeaderRowIndex;
            result.headerRowIndexWithoutSpan = optimisticNextIndex;
        }
    }
    return result;
}
// packages/ag-grid-community/src/focusService.ts
var $437b23f6a393c3bf$var$FocusService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "focusSvc";
        /** If a cell was destroyed that previously had focus, focus needs restored when the cell reappears */ this.focusFallbackTimeout = null;
        this.needsFocusRestored = false;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.visibleCols = beans.visibleCols;
        this.rowRenderer = beans.rowRenderer;
        this.navigation = beans.navigation;
        this.filterManager = beans.filterManager;
        this.overlays = beans.overlays;
    }
    postConstruct() {
        const clearFocusedCellListener = this.clearFocusedCell.bind(this);
        this.addManagedEventListeners({
            columnPivotModeChanged: clearFocusedCellListener,
            newColumnsLoaded: this.onColumnEverythingChanged.bind(this),
            columnGroupOpened: clearFocusedCellListener,
            columnRowGroupChanged: clearFocusedCellListener
        });
        this.addDestroyFunc($437b23f6a393c3bf$var$_registerKeyboardFocusEvents(this.beans));
    }
    attemptToRecoverFocus() {
        this.needsFocusRestored = true;
        if (this.focusFallbackTimeout != null) clearTimeout(this.focusFallbackTimeout);
        this.focusFallbackTimeout = window.setTimeout(this.setFocusRecovered.bind(this), 100);
    }
    setFocusRecovered() {
        this.needsFocusRestored = false;
        if (this.focusFallbackTimeout != null) {
            clearTimeout(this.focusFallbackTimeout);
            this.focusFallbackTimeout = null;
        }
    }
    /**
   * Specifies whether to take focus, as grid either already has focus, or lost it due
   * to a destroyed cell
   * @returns true if the grid should re-take focus, otherwise false
   */ shouldTakeFocus() {
        if (this.gos.get("suppressFocusAfterRefresh")) {
            this.setFocusRecovered();
            return false;
        }
        if (this.needsFocusRestored) {
            this.setFocusRecovered();
            return true;
        }
        return this.doesRowOrCellHaveBrowserFocus();
    }
    onColumnEverythingChanged() {
        if (!this.focusedCell) return;
        const col = this.focusedCell.column;
        const colFromColumnModel = this.colModel.getCol(col.getId());
        if (col !== colFromColumnModel) this.clearFocusedCell();
    }
    // we check if the browser is focusing something, and if it is, and
    // it's the cell we think is focused, then return the cell. so this
    // methods returns the cell if a) we think it has focus and b) the
    // browser thinks it has focus. this then returns nothing if we
    // first focus a cell, then second click outside the grid, as then the
    // grid cell will still be focused as far as the grid is concerned,
    // however the browser focus will have moved somewhere else.
    getFocusCellToUseAfterRefresh() {
        const { gos: gos, focusedCell: focusedCell } = this;
        if (gos.get("suppressFocusAfterRefresh") || gos.get("suppressCellFocus") || !focusedCell) return null;
        if (!this.doesRowOrCellHaveBrowserFocus()) return null;
        return focusedCell;
    }
    getFocusHeaderToUseAfterRefresh() {
        if (this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeader) return null;
        if (!this.isDomDataPresentInHierarchy($437b23f6a393c3bf$export$16bc98d422315038(this.beans), $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL)) return null;
        return this.focusedHeader;
    }
    /**
   * Check for both cells and rows, as a row might be destroyed and the dom data removed before the cell if the
   * row is animating out.
   */ doesRowOrCellHaveBrowserFocus() {
        const activeElement = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        if (this.isDomDataPresentInHierarchy(activeElement, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL)) return true;
        return this.isDomDataPresentInHierarchy(activeElement, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL);
    }
    isDomDataPresentInHierarchy(eBrowserCell, key) {
        let ePointer = eBrowserCell;
        while(ePointer){
            const data = $437b23f6a393c3bf$var$_getDomData(this.gos, ePointer, key);
            if (data) return true;
            ePointer = ePointer.parentNode;
        }
        return false;
    }
    getFocusedCell() {
        return this.focusedCell;
    }
    getFocusEventParams(focusedCellPosition) {
        const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = focusedCellPosition;
        const params = {
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column,
            isFullWidthCell: false
        };
        const rowCtrl = this.rowRenderer.getRowByPosition({
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        if (rowCtrl) params.isFullWidthCell = rowCtrl.isFullWidth();
        return params;
    }
    clearFocusedCell() {
        if (this.focusedCell == null) return;
        const focusEventParams = this.getFocusEventParams(this.focusedCell);
        this.focusedCell = null;
        this.eventSvc.dispatchEvent({
            type: "cellFocusCleared",
            ...focusEventParams
        });
    }
    setFocusedCell(params) {
        this.setFocusRecovered();
        const { column: column, rowIndex: rowIndex, rowPinned: rowPinned, forceBrowserFocus: forceBrowserFocus = false, preventScrollOnBrowserFocus: preventScrollOnBrowserFocus = false, sourceEvent: sourceEvent } = params;
        const gridColumn = this.colModel.getCol(column);
        if (!gridColumn) {
            this.focusedCell = null;
            return;
        }
        this.focusedCell = {
            rowIndex: rowIndex,
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
            column: gridColumn
        };
        const focusEventParams = this.getFocusEventParams(this.focusedCell);
        this.eventSvc.dispatchEvent({
            type: "cellFocused",
            ...focusEventParams,
            ...this.previousCellFocusParams && {
                previousParams: this.previousCellFocusParams
            },
            forceBrowserFocus: forceBrowserFocus,
            preventScrollOnBrowserFocus: preventScrollOnBrowserFocus,
            sourceEvent: sourceEvent
        });
        this.previousCellFocusParams = focusEventParams;
    }
    isCellFocused(cellPosition) {
        if (this.focusedCell == null) return false;
        return $437b23f6a393c3bf$export$be3973033c2c5267(cellPosition, this.focusedCell);
    }
    isHeaderWrapperFocused(headerCtrl) {
        if (this.focusedHeader == null) return false;
        const { column: column, rowCtrl: { rowIndex: headerRowIndex, pinned: pinned } } = headerCtrl;
        const { column: focusedColumn, headerRowIndex: focusedHeaderRowIndex } = this.focusedHeader;
        return column === focusedColumn && headerRowIndex === focusedHeaderRowIndex && pinned == focusedColumn.getPinned();
    }
    focusHeaderPosition(params) {
        this.setFocusRecovered();
        if ($437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return false;
        const { direction: direction, fromTab: fromTab, allowUserOverride: allowUserOverride, event: event, fromCell: fromCell, rowWithoutSpanValue: rowWithoutSpanValue, scroll: scroll = true } = params;
        let { headerPosition: headerPosition } = params;
        if (fromCell && this.filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
        if (allowUserOverride) {
            const currentPosition = this.focusedHeader;
            const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
            if (fromTab) {
                const userFunc = this.gos.getCallback("tabToNextHeader");
                if (userFunc) headerPosition = this.getHeaderPositionFromUserFunc({
                    userFunc: userFunc,
                    direction: direction,
                    currentPosition: currentPosition,
                    headerPosition: headerPosition,
                    headerRowCount: headerRowCount
                });
            } else {
                const userFunc = this.gos.getCallback("navigateToNextHeader");
                if (userFunc && event) {
                    const params2 = {
                        key: event.key,
                        previousHeaderPosition: currentPosition,
                        nextHeaderPosition: headerPosition,
                        headerRowCount: headerRowCount,
                        event: event
                    };
                    headerPosition = userFunc(params2);
                }
            }
        }
        if (!headerPosition) return false;
        return this.focusProvidedHeaderPosition({
            headerPosition: headerPosition,
            direction: direction,
            event: event,
            fromCell: fromCell,
            rowWithoutSpanValue: rowWithoutSpanValue,
            scroll: scroll
        });
    }
    focusHeaderPositionFromUserFunc(params) {
        if ($437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return false;
        const { userFunc: userFunc, headerPosition: headerPosition, direction: direction, event: event } = params;
        const currentPosition = this.focusedHeader;
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
        const newHeaderPosition = this.getHeaderPositionFromUserFunc({
            userFunc: userFunc,
            direction: direction,
            currentPosition: currentPosition,
            headerPosition: headerPosition,
            headerRowCount: headerRowCount
        });
        return !!newHeaderPosition && this.focusProvidedHeaderPosition({
            headerPosition: newHeaderPosition,
            direction: direction,
            event: event
        });
    }
    getHeaderPositionFromUserFunc(params) {
        const { userFunc: userFunc, direction: direction, currentPosition: currentPosition, headerPosition: headerPosition, headerRowCount: headerRowCount } = params;
        const userFuncParams = {
            backwards: direction === "Before",
            previousHeaderPosition: currentPosition,
            nextHeaderPosition: headerPosition,
            headerRowCount: headerRowCount
        };
        const userResult = userFunc(userFuncParams);
        if (userResult === true) return currentPosition;
        if (userResult === false) return null;
        return userResult;
    }
    focusProvidedHeaderPosition(params) {
        const { headerPosition: headerPosition, direction: direction, fromCell: fromCell, rowWithoutSpanValue: rowWithoutSpanValue, event: event, scroll: scroll = true } = params;
        const { column: column, headerRowIndex: headerRowIndex } = headerPosition;
        const { filterManager: filterManager, ctrlsSvc: ctrlsSvc, headerNavigation: headerNavigation } = this.beans;
        if (this.focusedHeader && $437b23f6a393c3bf$var$isHeaderPositionEqual(params.headerPosition, this.focusedHeader)) return false;
        if (headerRowIndex === -1) {
            if (filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
            return this.focusGridView({
                column: column,
                event: event
            });
        }
        if (scroll) headerNavigation?.scrollToColumn(column, direction);
        const headerRowContainerCtrl = ctrlsSvc.getHeaderRowContainerCtrl(column.getPinned());
        const focusSuccess = headerRowContainerCtrl?.focusHeader(headerPosition.headerRowIndex, column, event) || false;
        if (headerNavigation && focusSuccess && (rowWithoutSpanValue != null || fromCell)) headerNavigation.currentHeaderRowWithoutSpan = rowWithoutSpanValue ?? -1;
        return focusSuccess;
    }
    focusFirstHeader() {
        if (this.overlays?.isExclusive() && this.focusOverlay()) return true;
        const firstColumn = this.visibleCols.allCols[0];
        if (!firstColumn) return false;
        const headerPosition = $437b23f6a393c3bf$var$getHeaderIndexToFocus(this.beans, firstColumn, 0);
        return this.focusHeaderPosition({
            headerPosition: headerPosition,
            rowWithoutSpanValue: 0
        });
    }
    focusLastHeader(event) {
        if (this.overlays?.isExclusive() && this.focusOverlay(true)) return true;
        const headerRowIndex = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1;
        const column = $437b23f6a393c3bf$export$236389741107357f(this.visibleCols.allCols);
        return this.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: headerRowIndex,
                column: column
            },
            rowWithoutSpanValue: -1,
            event: event
        });
    }
    focusPreviousFromFirstCell(event) {
        if (this.filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(null);
        return this.focusLastHeader(event);
    }
    isAnyCellFocused() {
        return !!this.focusedCell;
    }
    isRowFocused(rowIndex, rowPinnedType) {
        if (this.focusedCell == null) return false;
        return this.focusedCell.rowIndex === rowIndex && this.focusedCell.rowPinned === $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinnedType);
    }
    focusOverlay(backwards) {
        const overlayGui = this.overlays?.isVisible() && this.overlays.eWrapper?.getGui();
        return !!overlayGui && $437b23f6a393c3bf$export$8598088d375f416f(overlayGui, backwards);
    }
    focusGridView(params) {
        const { backwards: backwards = false, canFocusOverlay: canFocusOverlay = true, event: event } = params;
        if (this.overlays?.isExclusive()) return canFocusOverlay && this.focusOverlay(backwards);
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(this.beans)) {
            if (backwards) {
                if (!$437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return this.focusLastHeader();
            }
            if (canFocusOverlay && this.focusOverlay(backwards)) return true;
            if (backwards) return false;
            return $437b23f6a393c3bf$export$987f3c95dc941f0c(this.beans, backwards);
        }
        const nextRow = backwards ? $437b23f6a393c3bf$export$a1449222017e428(this.beans) : $437b23f6a393c3bf$export$124b4386b662b699(this.beans);
        if (nextRow) {
            const column = params.column ?? this.focusedHeader?.column;
            const { rowIndex: rowIndex, rowPinned: rowPinned } = nextRow;
            const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, nextRow);
            if (!column || !rowNode || rowIndex == null) return false;
            if (column.isSuppressNavigable(rowNode)) {
                const isRtl = this.gos.get("enableRtl");
                let key;
                if (!event || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) key = isRtl ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT : $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
                else key = event.key;
                this.beans.navigation?.navigateToNextCell(null, key, {
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned || null
                }, true);
                return true;
            }
            this.navigation?.ensureCellVisible({
                rowIndex: rowIndex,
                column: column,
                rowPinned: rowPinned
            });
            if (backwards) {
                const rowCtrl = this.rowRenderer.getRowByPosition(nextRow);
                if (rowCtrl?.isFullWidth() && this.navigation?.tryToFocusFullWidthRow(nextRow, backwards)) return true;
            }
            this.setFocusedCell({
                rowIndex: rowIndex,
                column: column,
                rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
                forceBrowserFocus: true
            });
            this.beans.rangeSvc?.setRangeToCell({
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                column: column
            });
            return true;
        }
        if (canFocusOverlay && this.focusOverlay(backwards)) return true;
        if (backwards && this.focusLastHeader()) return true;
        return false;
    }
    focusAdvancedFilter(position) {
        this.advFilterFocusColumn = position?.column;
        return this.beans.advancedFilter?.getCtrl().focusHeaderComp() ?? false;
    }
    focusNextFromAdvancedFilter(backwards, forceFirstColumn) {
        const column = (forceFirstColumn ? void 0 : this.advFilterFocusColumn) ?? this.visibleCols.allCols?.[0];
        if (backwards) return this.focusHeaderPosition({
            headerPosition: {
                column: column,
                headerRowIndex: $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1
            }
        });
        else return this.focusGridView({
            column: column
        });
    }
    clearAdvancedFilterColumn() {
        this.advFilterFocusColumn = void 0;
    }
};
// packages/ag-grid-community/src/gridBodyComp/scrollVisibleService.ts
var $437b23f6a393c3bf$var$ScrollVisibleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "scrollVisibleSvc";
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.colAnimation = beans.colAnimation;
    }
    postConstruct() {
        this.horizontalScrollShowing = this.gos.get("alwaysShowHorizontalScroll") === true;
        this.verticalScrollShowing = this.gos.get("alwaysShowVerticalScroll") === true;
        this.getScrollbarWidth();
        this.addManagedEventListeners({
            displayedColumnsChanged: this.updateScrollVisible.bind(this),
            displayedColumnsWidthChanged: this.updateScrollVisible.bind(this)
        });
    }
    updateScrollVisible() {
        const { colAnimation: colAnimation } = this;
        if (colAnimation?.isActive()) colAnimation.executeLaterVMTurn(()=>{
            colAnimation.executeLaterVMTurn(()=>this.updateScrollVisibleImpl());
        });
        else this.updateScrollVisibleImpl();
    }
    updateScrollVisibleImpl() {
        const centerRowCtrl = this.ctrlsSvc.get("center");
        if (!centerRowCtrl || this.colAnimation?.isActive()) return;
        const params = {
            horizontalScrollShowing: centerRowCtrl.isHorizontalScrollShowing(),
            verticalScrollShowing: this.verticalScrollShowing
        };
        this.setScrollsVisible(params);
        this.updateScrollGap();
    }
    updateScrollGap() {
        const centerRowCtrl = this.ctrlsSvc.get("center");
        const horizontalGap = centerRowCtrl.hasHorizontalScrollGap();
        const verticalGap = centerRowCtrl.hasVerticalScrollGap();
        const atLeastOneDifferent = this.horizontalScrollGap !== horizontalGap || this.verticalScrollGap !== verticalGap;
        if (atLeastOneDifferent) {
            this.horizontalScrollGap = horizontalGap;
            this.verticalScrollGap = verticalGap;
            this.eventSvc.dispatchEvent({
                type: "scrollGapChanged"
            });
        }
    }
    setScrollsVisible(params) {
        const atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing || this.verticalScrollShowing !== params.verticalScrollShowing;
        if (atLeastOneDifferent) {
            this.horizontalScrollShowing = params.horizontalScrollShowing;
            this.verticalScrollShowing = params.verticalScrollShowing;
            this.eventSvc.dispatchEvent({
                type: "scrollVisibilityChanged"
            });
        }
    }
    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
    // allow the user to provide the scroll width before we work it out.
    getScrollbarWidth() {
        if (this.scrollbarWidth == null) {
            const gridOptionsScrollbarWidth = this.gos.get("scrollbarWidth");
            const useGridOptions = typeof gridOptionsScrollbarWidth === "number" && gridOptionsScrollbarWidth >= 0;
            const scrollbarWidth = useGridOptions ? gridOptionsScrollbarWidth : $437b23f6a393c3bf$var$_getScrollbarWidth();
            if (scrollbarWidth != null) {
                this.scrollbarWidth = scrollbarWidth;
                this.eventSvc.dispatchEvent({
                    type: "scrollbarWidthChanged"
                });
            }
        }
        return this.scrollbarWidth;
    }
};
// packages/ag-grid-community/src/gridDestroyService.ts
var $437b23f6a393c3bf$var$GridDestroyService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gridDestroySvc";
        this.destroyCalled = false;
    }
    destroy() {
        if (this.destroyCalled) return;
        const { stateSvc: stateSvc, ctrlsSvc: ctrlsSvc, context: context } = this.beans;
        this.eventSvc.dispatchEvent({
            type: "gridPreDestroyed",
            state: stateSvc?.getState() ?? {}
        });
        this.destroyCalled = true;
        ctrlsSvc.get("gridCtrl")?.destroyGridUi();
        context.destroy();
        super.destroy();
    }
};
// packages/ag-grid-community/src/events.ts
var $437b23f6a393c3bf$export$12e4e9a3cbd0ec07 = /* @__PURE__ */ new Set([
    "gridPreDestroyed",
    "fillStart",
    "pasteStart"
]);
// packages/ag-grid-community/src/eventTypes.ts
var $437b23f6a393c3bf$export$e9c8ffb796317123 = [
    "columnEverythingChanged",
    "newColumnsLoaded",
    "columnPivotModeChanged",
    "pivotMaxColumnsExceeded",
    "columnRowGroupChanged",
    "expandOrCollapseAll",
    "columnPivotChanged",
    "gridColumnsChanged",
    "columnValueChanged",
    "columnMoved",
    "columnVisible",
    "columnPinned",
    "columnGroupOpened",
    "columnResized",
    "displayedColumnsChanged",
    "virtualColumnsChanged",
    "columnHeaderMouseOver",
    "columnHeaderMouseLeave",
    "columnHeaderClicked",
    "columnHeaderContextMenu",
    "asyncTransactionsFlushed",
    "rowGroupOpened",
    "rowDataUpdated",
    "pinnedRowDataChanged",
    "pinnedRowsChanged",
    "rangeSelectionChanged",
    "cellSelectionChanged",
    "chartCreated",
    "chartRangeSelectionChanged",
    "chartOptionsChanged",
    "chartDestroyed",
    "toolPanelVisibleChanged",
    "toolPanelSizeChanged",
    "modelUpdated",
    "cutStart",
    "cutEnd",
    "pasteStart",
    "pasteEnd",
    "fillStart",
    "fillEnd",
    "cellSelectionDeleteStart",
    "cellSelectionDeleteEnd",
    "rangeDeleteStart",
    "rangeDeleteEnd",
    "undoStarted",
    "undoEnded",
    "redoStarted",
    "redoEnded",
    "cellClicked",
    "cellDoubleClicked",
    "cellMouseDown",
    "cellContextMenu",
    "cellValueChanged",
    "cellEditRequest",
    "rowValueChanged",
    "headerFocused",
    "cellFocused",
    "rowSelected",
    "selectionChanged",
    "tooltipShow",
    "tooltipHide",
    "cellKeyDown",
    "cellMouseOver",
    "cellMouseOut",
    "filterChanged",
    "filterModified",
    "filterUiChanged",
    "filterOpened",
    "floatingFilterUiChanged",
    "advancedFilterBuilderVisibleChanged",
    "sortChanged",
    "virtualRowRemoved",
    "rowClicked",
    "rowDoubleClicked",
    "gridReady",
    "gridPreDestroyed",
    "gridSizeChanged",
    "viewportChanged",
    "firstDataRendered",
    "dragStarted",
    "dragStopped",
    "dragCancelled",
    "rowEditingStarted",
    "rowEditingStopped",
    "cellEditingStarted",
    "cellEditingStopped",
    "bodyScroll",
    "bodyScrollEnd",
    "paginationChanged",
    "componentStateChanged",
    "storeRefreshed",
    "stateUpdated",
    "columnMenuVisibleChanged",
    "contextMenuVisibleChanged",
    "rowDragEnter",
    "rowDragMove",
    "rowDragLeave",
    "rowDragEnd",
    "rowDragCancel",
    "findChanged",
    "rowResizeStarted",
    "rowResizeEnded",
    "columnsReset",
    "bulkEditingStarted",
    "bulkEditingStopped",
    "batchEditingStarted",
    "batchEditingStopped"
];
var $437b23f6a393c3bf$var$_INTERNAL_EVENTS = [
    "scrollbarWidthChanged",
    "keyShortcutChangedCellStart",
    "keyShortcutChangedCellEnd",
    "pinnedHeightChanged",
    "cellFocusCleared",
    "fullWidthRowFocused",
    "checkboxChanged",
    "heightScaleChanged",
    "suppressMovableColumns",
    "suppressMenuHide",
    "suppressFieldDotNotation",
    "columnPanelItemDragStart",
    "columnPanelItemDragEnd",
    "bodyHeightChanged",
    "columnContainerWidthChanged",
    "displayedColumnsWidthChanged",
    "scrollVisibilityChanged",
    "scrollGapChanged",
    "columnHoverChanged",
    "flashCells",
    "paginationPixelOffsetChanged",
    "displayedRowsChanged",
    "leftPinnedWidthChanged",
    "rightPinnedWidthChanged",
    "rowContainerHeightChanged",
    "headerHeightChanged",
    "columnGroupHeaderHeightChanged",
    "columnHeaderHeightChanged",
    "gridStylesChanged",
    "storeUpdated",
    "filterDestroyed",
    "filterHandlerDestroyed",
    "rowDataUpdateStarted",
    "rowCountReady",
    "advancedFilterEnabledChanged",
    "dataTypesInferred",
    "fieldValueChanged",
    "fieldPickerValueSelected",
    "richSelectListRowSelected",
    "sideBarUpdated",
    "alignedGridScroll",
    "alignedGridColumn",
    "gridOptionsChanged",
    "chartTitleEdit",
    "recalculateRowBounds",
    "stickyTopOffsetChanged",
    "overlayExclusiveChanged",
    "rowNodeDataChanged",
    "cellEditValuesChanged",
    "filterSwitched",
    "filterClosed",
    "headerRowsChanged",
    "rowExpansionStateChanged"
];
var $437b23f6a393c3bf$export$a4bee1102f884a4d = ()=>[
        ...$437b23f6a393c3bf$export$e9c8ffb796317123,
        ...$437b23f6a393c3bf$var$_INTERNAL_EVENTS
    ];
// packages/ag-grid-community/src/publicEventHandlersMap.ts
var $437b23f6a393c3bf$export$85716710781d6a6b = $437b23f6a393c3bf$export$e9c8ffb796317123.reduce((mem, ev)=>{
    mem[ev] = $437b23f6a393c3bf$export$2badf35af69344c1(ev);
    return mem;
}, {});
// packages/ag-grid-community/src/sort/sortIndicatorComp.ts
var $437b23f6a393c3bf$var$makeIconParams = (dataRefSuffix, classSuffix)=>({
        tag: "span",
        ref: `eSort${dataRefSuffix}`,
        cls: `ag-sort-indicator-icon ag-sort-${classSuffix} ag-hidden`,
        attrs: {
            "aria-hidden": "true"
        }
    });
var $437b23f6a393c3bf$var$SortIndicatorElement = {
    tag: "span",
    cls: "ag-sort-indicator-container",
    children: [
        $437b23f6a393c3bf$var$makeIconParams("Order", "order"),
        $437b23f6a393c3bf$var$makeIconParams("Asc", "ascending-icon"),
        $437b23f6a393c3bf$var$makeIconParams("Desc", "descending-icon"),
        $437b23f6a393c3bf$var$makeIconParams("Mixed", "mixed-icon"),
        $437b23f6a393c3bf$var$makeIconParams("None", "none-icon")
    ]
};
var $437b23f6a393c3bf$var$SortIndicatorComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(skipTemplate){
        super();
        // Elements might by undefined when the user provides a custom template
        this.eSortOrder = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAsc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortDesc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortMixed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortNone = $437b23f6a393c3bf$export$6c811454646ed8be;
        if (!skipTemplate) this.setTemplate($437b23f6a393c3bf$var$SortIndicatorElement);
    }
    attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone) {
        this.eSortOrder = eSortOrder;
        this.eSortAsc = eSortAsc;
        this.eSortDesc = eSortDesc;
        this.eSortMixed = eSortMixed;
        this.eSortNone = eSortNone;
    }
    setupSort(column, suppressOrder = false) {
        this.column = column;
        this.suppressOrder = suppressOrder;
        this.setupMultiSortIndicator();
        if (!column.isSortable() && !column.getColDef().showRowGroup) return;
        this.addInIcon("sortAscending", this.eSortAsc, column);
        this.addInIcon("sortDescending", this.eSortDesc, column);
        this.addInIcon("sortUnSort", this.eSortNone, column);
        const updateIcons = this.updateIcons.bind(this);
        const sortUpdated = this.onSortChanged.bind(this);
        this.addManagedPropertyListener("unSortIcon", updateIcons);
        this.addManagedEventListeners({
            newColumnsLoaded: updateIcons,
            // Watch global events, as row group columns can effect their display column.
            sortChanged: sortUpdated,
            // when grouping changes so can sort indexes and icons
            columnRowGroupChanged: sortUpdated
        });
        this.onSortChanged();
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    onSortChanged() {
        this.updateIcons();
        if (!this.suppressOrder) this.updateSortOrder();
    }
    updateIcons() {
        const { eSortAsc: eSortAsc, eSortDesc: eSortDesc, eSortNone: eSortNone, column: column, gos: gos, beans: beans } = this;
        const sortDirection = beans.sortSvc.getDisplaySortForColumn(column);
        if (eSortAsc) {
            const isAscending = sortDirection === "asc";
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortAsc, isAscending, {
                skipAriaHidden: true
            });
        }
        if (eSortDesc) {
            const isDescending = sortDirection === "desc";
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortDesc, isDescending, {
                skipAriaHidden: true
            });
        }
        if (eSortNone) {
            const alwaysHideNoSort = !column.getColDef().unSortIcon && !gos.get("unSortIcon");
            const isNone = sortDirection === null || sortDirection === void 0;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortNone, !alwaysHideNoSort && isNone, {
                skipAriaHidden: true
            });
        }
    }
    setupMultiSortIndicator() {
        const { eSortMixed: eSortMixed, column: column, gos: gos } = this;
        this.addInIcon("sortUnSort", eSortMixed, column);
        const isColumnShowingRowGroup = column.getColDef().showRowGroup;
        const areGroupsCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        if (areGroupsCoupled && isColumnShowingRowGroup) {
            this.addManagedEventListeners({
                // Watch global events, as row group columns can effect their display column.
                sortChanged: this.updateMultiSortIndicator.bind(this),
                // when grouping changes so can sort indexes and icons
                columnRowGroupChanged: this.updateMultiSortIndicator.bind(this)
            });
            this.updateMultiSortIndicator();
        }
    }
    updateMultiSortIndicator() {
        const { eSortMixed: eSortMixed, beans: beans, column: column } = this;
        if (eSortMixed) {
            const isMixedSort = beans.sortSvc.getDisplaySortForColumn(column) === "mixed";
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortMixed, isMixedSort, {
                skipAriaHidden: true
            });
        }
    }
    // we listen here for global sort events, NOT column sort events, as we want to do this
    // when sorting has been set on all column (if we listened just for our col (where we
    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
    updateSortOrder() {
        const { eSortOrder: eSortOrder, column: column, beans: { sortSvc: sortSvc } } = this;
        if (!eSortOrder) return;
        const allColumnsWithSorting = sortSvc.getColumnsWithSortingOrdered();
        const indexThisCol = sortSvc.getDisplaySortIndexForColumn(column) ?? -1;
        const moreThanOneColSorting = allColumnsWithSorting.some((col)=>sortSvc.getDisplaySortIndexForColumn(col) ?? false);
        const showIndex = indexThisCol >= 0 && moreThanOneColSorting;
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortOrder, showIndex, {
            skipAriaHidden: true
        });
        if (indexThisCol >= 0) eSortOrder.textContent = (indexThisCol + 1).toString();
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eSortOrder);
    }
};
var $437b23f6a393c3bf$var$SortIndicatorSelector = {
    selector: "AG-SORT-INDICATOR",
    component: $437b23f6a393c3bf$var$SortIndicatorComp
};
// packages/ag-grid-community/src/sort/sortService.ts
var $437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER = [
    "asc",
    "desc",
    null
];
var $437b23f6a393c3bf$var$SortService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "sortSvc";
    }
    progressSort(column, multiSort, source) {
        const nextDirection = this.getNextSortDirection(column);
        this.setSortForColumn(column, nextDirection, multiSort, source);
    }
    progressSortFromEvent(column, event) {
        const sortUsingCtrl = this.gos.get("multiSortKey") === "ctrl";
        const multiSort = sortUsingCtrl ? event.ctrlKey || event.metaKey : event.shiftKey;
        this.progressSort(column, multiSort, "uiColumnSorted");
    }
    setSortForColumn(column, sort, multiSort, source) {
        if (sort !== "asc" && sort !== "desc") sort = null;
        const { gos: gos, showRowGroupCols: showRowGroupCols } = this.beans;
        const isColumnsSortingCoupledToGroup = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        let columnsToUpdate = [
            column
        ];
        if (isColumnsSortingCoupledToGroup) {
            if (column.getColDef().showRowGroup) {
                const rowGroupColumns = showRowGroupCols?.getSourceColumnsForGroupColumn?.(column);
                const sortableRowGroupColumns = rowGroupColumns?.filter((col)=>col.isSortable());
                if (sortableRowGroupColumns) columnsToUpdate = [
                    column,
                    ...sortableRowGroupColumns
                ];
            }
        }
        for (const col of columnsToUpdate)this.setColSort(col, sort, source);
        const doingMultiSort = (multiSort || gos.get("alwaysMultiSort")) && !gos.get("suppressMultiSort");
        const updatedColumns = [];
        if (!doingMultiSort) {
            const clearedColumns = this.clearSortBarTheseColumns(columnsToUpdate, source);
            updatedColumns.push(...clearedColumns);
        }
        this.updateSortIndex(column);
        updatedColumns.push(...columnsToUpdate);
        this.dispatchSortChangedEvents(source, updatedColumns);
    }
    updateSortIndex(lastColToChange) {
        const { gos: gos, colModel: colModel, showRowGroupCols: showRowGroupCols } = this.beans;
        const isCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        const groupParent = showRowGroupCols?.getShowRowGroupCol(lastColToChange.getId());
        const lastSortIndexCol = isCoupled ? groupParent || lastColToChange : lastColToChange;
        const allSortedCols = this.getColumnsWithSortingOrdered();
        colModel.forAllCols((col)=>this.setColSortIndex(col, null));
        const allSortedColsWithoutChangesOrGroups = allSortedCols.filter((col)=>{
            if (isCoupled && col.getColDef().showRowGroup) return false;
            return col !== lastSortIndexCol;
        });
        const sortedColsWithIndices = lastSortIndexCol.getSort() ? [
            ...allSortedColsWithoutChangesOrGroups,
            lastSortIndexCol
        ] : allSortedColsWithoutChangesOrGroups;
        sortedColsWithIndices.forEach((col, idx)=>this.setColSortIndex(col, idx));
    }
    // gets called by API, so if data changes, use can call this, which will end up
    // working out the sort order again of the rows.
    onSortChanged(source, columns) {
        this.dispatchSortChangedEvents(source, columns);
    }
    isSortActive() {
        let isSorting = false;
        this.beans.colModel.forAllCols((col)=>{
            if (col.getSort()) isSorting = true;
        });
        return isSorting;
    }
    dispatchSortChangedEvents(source, columns) {
        const event = {
            type: "sortChanged",
            source: source
        };
        if (columns) event.columns = columns;
        this.eventSvc.dispatchEvent(event);
    }
    clearSortBarTheseColumns(columnsToSkip, source) {
        const clearedColumns = [];
        this.beans.colModel.forAllCols((columnToClear)=>{
            if (!columnsToSkip.includes(columnToClear)) {
                if (columnToClear.getSort()) clearedColumns.push(columnToClear);
                this.setColSort(columnToClear, void 0, source);
            }
        });
        return clearedColumns;
    }
    getNextSortDirection(column) {
        const sortingOrder = column.getColDef().sortingOrder ?? this.gos.get("sortingOrder") ?? $437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER;
        const currentIndex = sortingOrder.indexOf(column.getSort());
        const notInArray = currentIndex < 0;
        const lastItemInArray = currentIndex == sortingOrder.length - 1;
        return notInArray || lastItemInArray ? sortingOrder[0] : sortingOrder[currentIndex + 1];
    }
    /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */ getIndexedSortMap() {
        const { gos: gos, colModel: colModel, showRowGroupCols: showRowGroupCols, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        let allSortedCols = [];
        colModel.forAllCols((col)=>{
            if (col.getSort()) allSortedCols.push(col);
        });
        if (colModel.isPivotMode()) {
            const isSortingLinked = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
            allSortedCols = allSortedCols.filter((col)=>{
                const isAggregated = !!col.getAggFunc();
                const isSecondary = !col.isPrimary();
                const isGroup = isSortingLinked ? showRowGroupCols?.getShowRowGroupCol(col.getId()) : col.getColDef().showRowGroup;
                return isAggregated || isSecondary || isGroup;
            });
        }
        const sortedRowGroupCols = rowGroupColsSvc?.columns.filter((col)=>!!col.getSort()) ?? [];
        const allColsIndexes = {};
        allSortedCols.forEach((col, index)=>allColsIndexes[col.getId()] = index);
        allSortedCols.sort((a, b)=>{
            const iA = a.getSortIndex();
            const iB = b.getSortIndex();
            if (iA != null && iB != null) return iA - iB;
            else if (iA == null && iB == null) {
                const posA = allColsIndexes[a.getId()];
                const posB = allColsIndexes[b.getId()];
                return posA > posB ? 1 : -1;
            } else if (iB == null) return -1;
            else return 1;
        });
        const isSortLinked = $437b23f6a393c3bf$export$96c51c2547b81aed(gos) && !!sortedRowGroupCols.length;
        if (isSortLinked) allSortedCols = [
            ...new Set(// if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
            allSortedCols.map((col)=>showRowGroupCols?.getShowRowGroupCol(col.getId()) ?? col))
        ];
        const indexMap = /* @__PURE__ */ new Map();
        allSortedCols.forEach((col, idx)=>indexMap.set(col, idx));
        if (isSortLinked) for (const col of sortedRowGroupCols){
            const groupDisplayCol = showRowGroupCols.getShowRowGroupCol(col.getId());
            indexMap.set(col, indexMap.get(groupDisplayCol));
        }
        return indexMap;
    }
    getColumnsWithSortingOrdered() {
        return [
            ...this.getIndexedSortMap().entries()
        ].sort(([, idx1], [, idx2])=>idx1 - idx2).map(([col])=>col);
    }
    // used by server side row models, to sent sort to server
    getSortModel() {
        return this.getColumnsWithSortingOrdered().filter((column)=>column.getSort()).map((column)=>({
                sort: column.getSort(),
                colId: column.getId()
            }));
    }
    getSortOptions() {
        return this.getColumnsWithSortingOrdered().filter((column)=>column.getSort()).map((column)=>({
                sort: column.getSort(),
                column: column
            }));
    }
    canColumnDisplayMixedSort(column) {
        const isColumnSortCouplingActive = $437b23f6a393c3bf$export$96c51c2547b81aed(this.gos);
        const isGroupDisplayColumn = !!column.getColDef().showRowGroup;
        return isColumnSortCouplingActive && isGroupDisplayColumn;
    }
    getDisplaySortForColumn(column) {
        const linkedColumns = this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(column);
        if (!this.canColumnDisplayMixedSort(column) || !linkedColumns?.length) return column.getSort();
        const columnHasUniqueData = column.getColDef().field != null || !!column.getColDef().valueGetter;
        const sortableColumns = columnHasUniqueData ? [
            column,
            ...linkedColumns
        ] : linkedColumns;
        const firstSort = sortableColumns[0].getSort();
        const allMatch = sortableColumns.every((col)=>col.getSort() == firstSort);
        if (!allMatch) return "mixed";
        return firstSort;
    }
    getDisplaySortIndexForColumn(column) {
        return this.getIndexedSortMap().get(column);
    }
    setupHeader(comp, column, clickElement) {
        let lastMovingChanged = 0;
        comp.addManagedListeners(column, {
            movingChanged: ()=>{
                lastMovingChanged = Date.now();
            }
        });
        if (clickElement) comp.addManagedElementListeners(clickElement, {
            click: (event)=>{
                const moving = column.isMoving();
                const nowTime = Date.now();
                const movedRecently = nowTime - lastMovingChanged < 50;
                const columnMoving = moving || movedRecently;
                if (!columnMoving) this.progressSortFromEvent(column, event);
            }
        });
        const onSortingChanged = ()=>{
            const sort = column.getSort();
            comp.toggleCss("ag-header-cell-sorted-asc", sort === "asc");
            comp.toggleCss("ag-header-cell-sorted-desc", sort === "desc");
            comp.toggleCss("ag-header-cell-sorted-none", !sort);
            if (column.getColDef().showRowGroup) {
                const sourceColumns = this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(column);
                const sortDirectionsMatch = sourceColumns?.every((sourceCol)=>column.getSort() == sourceCol.getSort());
                const isMultiSorting = !sortDirectionsMatch;
                comp.toggleCss("ag-header-cell-sorted-mixed", isMultiSorting);
            }
        };
        comp.addManagedEventListeners({
            sortChanged: onSortingChanged,
            columnRowGroupChanged: onSortingChanged
        });
    }
    initCol(column) {
        const { sort: sort, initialSort: initialSort, sortIndex: sortIndex, initialSortIndex: initialSortIndex } = column.colDef;
        if (sort !== void 0) {
            if (sort === "asc" || sort === "desc") column.sort = sort;
        } else if (initialSort === "asc" || initialSort === "desc") column.sort = initialSort;
        if (sortIndex !== void 0) {
            if (sortIndex !== null) column.sortIndex = sortIndex;
        } else if (initialSortIndex !== null) column.sortIndex = initialSortIndex;
    }
    updateColSort(column, sort, source) {
        if (sort !== void 0) {
            if (sort === "desc" || sort === "asc") this.setColSort(column, sort, source);
            else this.setColSort(column, void 0, source);
        }
    }
    setColSort(column, sort, source) {
        if (column.sort !== sort) {
            column.sort = sort;
            column.dispatchColEvent("sortChanged", source);
        }
        column.dispatchStateUpdatedEvent("sort");
    }
    setColSortIndex(column, sortOrder) {
        column.sortIndex = sortOrder;
        column.dispatchStateUpdatedEvent("sortIndex");
    }
    createSortIndicator(skipTemplate) {
        return new $437b23f6a393c3bf$var$SortIndicatorComp(skipTemplate);
    }
    getSortIndicatorSelector() {
        return $437b23f6a393c3bf$var$SortIndicatorSelector;
    }
};
// packages/ag-grid-community/src/validation/rules/userCompValidations.ts
var $437b23f6a393c3bf$var$USER_COMP_MODULES = {
    agSetColumnFilter: "SetFilter",
    agSetColumnFloatingFilter: "SetFilter",
    agMultiColumnFilter: "MultiFilter",
    agMultiColumnFloatingFilter: "MultiFilter",
    agGroupColumnFilter: "GroupFilter",
    agGroupColumnFloatingFilter: "GroupFilter",
    agGroupCellRenderer: "GroupCellRenderer",
    agGroupRowRenderer: "GroupCellRenderer",
    agRichSelect: "RichSelect",
    agRichSelectCellEditor: "RichSelect",
    agDetailCellRenderer: "SharedMasterDetail",
    agSparklineCellRenderer: "Sparklines",
    agDragAndDropImage: "SharedDragAndDrop",
    agColumnHeader: "ColumnHeaderComp",
    agColumnGroupHeader: "ColumnGroupHeaderComp",
    agSortIndicator: "Sort",
    agAnimateShowChangeCellRenderer: "HighlightChanges",
    agAnimateSlideCellRenderer: "HighlightChanges",
    agLoadingCellRenderer: "LoadingCellRenderer",
    agSkeletonCellRenderer: "SkeletonCellRenderer",
    agCheckboxCellRenderer: "CheckboxCellRenderer",
    agLoadingOverlay: "Overlay",
    agNoRowsOverlay: "Overlay",
    agTooltipComponent: "Tooltip",
    agReadOnlyFloatingFilter: "CustomFilter",
    agTextColumnFilter: "TextFilter",
    agNumberColumnFilter: "NumberFilter",
    agDateColumnFilter: "DateFilter",
    agDateInput: "DateFilter",
    agTextColumnFloatingFilter: "TextFilter",
    agNumberColumnFloatingFilter: "NumberFilter",
    agDateColumnFloatingFilter: "DateFilter",
    agCellEditor: "TextEditor",
    agSelectCellEditor: "SelectEditor",
    agTextCellEditor: "TextEditor",
    agNumberCellEditor: "NumberEditor",
    agDateCellEditor: "DateEditor",
    agDateStringCellEditor: "DateEditor",
    agCheckboxCellEditor: "CheckboxEditor",
    agLargeTextCellEditor: "LargeTextEditor",
    agMenuItem: "MenuItem",
    agColumnsToolPanel: "ColumnsToolPanel",
    agFiltersToolPanel: "FiltersToolPanel",
    agNewFiltersToolPanel: "NewFiltersToolPanel",
    agAggregationComponent: "StatusBar",
    agSelectedRowCountComponent: "StatusBar",
    agTotalRowCountComponent: "StatusBar",
    agFilteredRowCountComponent: "StatusBar",
    agTotalAndFilteredRowCountComponent: "StatusBar",
    agFindCellRenderer: "Find"
};
// packages/ag-grid-community/src/validation/rules/colDefValidations.ts
function $437b23f6a393c3bf$var$quote(s) {
    return `"${s}"`;
}
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_DEPRECATIONS = ()=>({
        checkboxSelection: {
            version: "32.2",
            message: "Use `rowSelection.checkboxes` in `GridOptions` instead."
        },
        headerCheckboxSelection: {
            version: "32.2",
            message: "Use `rowSelection.headerCheckbox = true` in `GridOptions` instead."
        },
        headerCheckboxSelectionFilteredOnly: {
            version: "32.2",
            message: 'Use `rowSelection.selectAll = "filtered"` in `GridOptions` instead.'
        },
        headerCheckboxSelectionCurrentPageOnly: {
            version: "32.2",
            message: 'Use `rowSelection.selectAll = "currentPage"` in `GridOptions` instead.'
        },
        showDisabledCheckboxes: {
            version: "32.2",
            message: "Use `rowSelection.hideDisabledCheckboxes = true` in `GridOptions` instead."
        },
        rowGroupingHierarchy: {
            version: "34.3",
            message: "Use `colDef.groupHierarchy` instead."
        }
    });
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_MOD_VALIDATIONS = {
    aggFunc: "SharedAggregation",
    autoHeight: "RowAutoHeight",
    cellClass: "CellStyle",
    cellClassRules: "CellStyle",
    cellEditor: ({ cellEditor: cellEditor, editable: editable })=>{
        if (!editable) return null;
        if (typeof cellEditor === "string") return $437b23f6a393c3bf$var$USER_COMP_MODULES[cellEditor] ?? "CustomEditor";
        return "CustomEditor";
    },
    cellRenderer: ({ cellRenderer: cellRenderer })=>{
        if (typeof cellRenderer !== "string") return null;
        return $437b23f6a393c3bf$var$USER_COMP_MODULES[cellRenderer];
    },
    cellStyle: "CellStyle",
    columnChooserParams: "ColumnMenu",
    contextMenuItems: "ContextMenu",
    dndSource: "DragAndDrop",
    dndSourceOnRowDrag: "DragAndDrop",
    editable: ({ editable: editable, cellEditor: cellEditor })=>{
        if (editable && !cellEditor) return "TextEditor";
        return null;
    },
    enableCellChangeFlash: "HighlightChanges",
    enablePivot: "SharedPivot",
    enableRowGroup: "SharedRowGrouping",
    enableValue: "SharedAggregation",
    filter: ({ filter: filter })=>{
        if (filter && typeof filter !== "string" && typeof filter !== "boolean") return "CustomFilter";
        if (typeof filter === "string") return $437b23f6a393c3bf$var$USER_COMP_MODULES[filter] ?? "ColumnFilter";
        return "ColumnFilter";
    },
    floatingFilter: "ColumnFilter",
    getQuickFilterText: "QuickFilter",
    headerTooltip: "Tooltip",
    headerTooltipValueGetter: "Tooltip",
    mainMenuItems: "ColumnMenu",
    menuTabs: (options)=>{
        const enterpriseMenuTabs = [
            "columnsMenuTab",
            "generalMenuTab"
        ];
        if (options.menuTabs?.some((tab)=>enterpriseMenuTabs.includes(tab))) return "ColumnMenu";
        return null;
    },
    pivot: "SharedPivot",
    pivotIndex: "SharedPivot",
    rowDrag: "RowDrag",
    rowGroup: "SharedRowGrouping",
    rowGroupIndex: "SharedRowGrouping",
    tooltipField: "Tooltip",
    tooltipValueGetter: "Tooltip",
    tooltipComponentSelector: "Tooltip",
    spanRows: "CellSpan",
    groupHierarchy: "SharedRowGrouping"
};
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_VALIDATIONS = ()=>{
    const validations = {
        autoHeight: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (_colDef, { paginationAutoPageSize: paginationAutoPageSize })=>{
                if (paginationAutoPageSize) return "colDef.autoHeight is not supported with paginationAutoPageSize.";
                return null;
            }
        },
        cellRendererParams: {
            validate: (colDef)=>{
                const groupColumn = colDef.rowGroup != null || colDef.rowGroupIndex != null || colDef.cellRenderer === "agGroupCellRenderer";
                if (groupColumn && "checkbox" in colDef.cellRendererParams) return 'Since v33.0, `cellRendererParams.checkbox` has been deprecated. Use `rowSelection.checkboxLocation = "autoGroupColumn"` instead.';
                return null;
            }
        },
        flex: {
            validate: (_options, gridOptions)=>{
                if (gridOptions.autoSizeStrategy) return "colDef.flex is not supported with gridOptions.autoSizeStrategy";
                return null;
            }
        },
        headerCheckboxSelection: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
        },
        headerCheckboxSelectionCurrentPageOnly: {
            supportedRowModels: [
                "clientSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
        },
        headerCheckboxSelectionFilteredOnly: {
            supportedRowModels: [
                "clientSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
        },
        headerValueGetter: {
            validate: (_options)=>{
                const headerValueGetter = _options.headerValueGetter;
                if (typeof headerValueGetter === "function" || typeof headerValueGetter === "string") return null;
                return "headerValueGetter must be a function or a valid string expression";
            }
        },
        icons: {
            validate: ({ icons: icons })=>{
                if (icons) {
                    if (icons["smallDown"]) return $437b23f6a393c3bf$export$680bb5102fca525e(262);
                    if (icons["smallLeft"]) return $437b23f6a393c3bf$export$680bb5102fca525e(263);
                    if (icons["smallRight"]) return $437b23f6a393c3bf$export$680bb5102fca525e(264);
                }
                return null;
            }
        },
        sortingOrder: {
            validate: (_options)=>{
                const sortingOrder = _options.sortingOrder;
                if (Array.isArray(sortingOrder) && sortingOrder.length > 0) {
                    const invalidItems = sortingOrder.filter((a)=>!$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.includes(a));
                    if (invalidItems.length > 0) return `sortingOrder must be an array with elements from [${$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}], currently it includes [${invalidItems.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}]`;
                } else if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) return `sortingOrder must be an array with at least one element, currently it's ${sortingOrder}`;
                return null;
            }
        },
        type: {
            validate: (_options)=>{
                const type = _options.type;
                if (type instanceof Array) {
                    const invalidArray = type.some((a)=>typeof a !== "string");
                    if (invalidArray) return "if colDef.type is supplied an array it should be of type 'string[]'";
                    return null;
                }
                if (typeof type === "string") return null;
                return "colDef.type should be of type 'string' | 'string[]'";
            }
        },
        rowSpan: {
            validate: (_options, { suppressRowTransform: suppressRowTransform })=>{
                if (!suppressRowTransform) return "colDef.rowSpan requires suppressRowTransform to be enabled.";
                return null;
            }
        },
        spanRows: {
            dependencies: {
                editable: {
                    required: [
                        false,
                        void 0
                    ]
                },
                rowDrag: {
                    required: [
                        false,
                        void 0
                    ]
                },
                colSpan: {
                    required: [
                        void 0
                    ]
                },
                rowSpan: {
                    required: [
                        void 0
                    ]
                }
            },
            validate: (_options, { rowSelection: rowSelection, cellSelection: cellSelection, suppressRowTransform: suppressRowTransform, enableCellSpan: enableCellSpan, rowDragEntireRow: rowDragEntireRow, enableCellTextSelection: enableCellTextSelection })=>{
                if (typeof rowSelection === "object") {
                    if (rowSelection?.mode === "singleRow" && rowSelection?.enableClickSelection) return "colDef.spanRows is not supported with rowSelection.clickSelection";
                }
                if (cellSelection) return "colDef.spanRows is not supported with cellSelection.";
                if (suppressRowTransform) return "colDef.spanRows is not supported with suppressRowTransform.";
                if (!enableCellSpan) return "colDef.spanRows requires enableCellSpan to be enabled.";
                if (rowDragEntireRow) return "colDef.spanRows is not supported with rowDragEntireRow.";
                if (enableCellTextSelection) return "colDef.spanRows is not supported with enableCellTextSelection.";
                return null;
            }
        },
        groupHierarchy: {
            validate (options, { groupHierarchyConfig: groupHierarchyConfig = {} }, beans) {
                const GROUP_HIERARCHY_PARTS = /* @__PURE__ */ new Set([
                    "year",
                    "quarter",
                    "month",
                    "formattedMonth",
                    "day",
                    "hour",
                    "minute",
                    "second"
                ]);
                const unrecognisedParts = [];
                for (const part of options.groupHierarchy ?? []){
                    if (typeof part === "object") {
                        beans.validation?.validateColDef(part);
                        continue;
                    }
                    if (!GROUP_HIERARCHY_PARTS.has(part) && !(part in groupHierarchyConfig)) unrecognisedParts.push($437b23f6a393c3bf$var$quote(part));
                }
                if (unrecognisedParts.length > 0) {
                    const warning = `The following parts of colDef.groupHierarchy are not recognised: ${unrecognisedParts.join(", ")}.`;
                    const suggestions = `Choose one of ${[
                        ...GROUP_HIERARCHY_PARTS
                    ].map($437b23f6a393c3bf$var$quote).join(", ")}, or define your own parts in gridOptions.groupHierarchyConfig.`;
                    return `${warning}
${suggestions}`;
                }
                return null;
            }
        }
    };
    return validations;
};
var $437b23f6a393c3bf$var$colDefPropertyMap = {
    headerName: void 0,
    columnGroupShow: void 0,
    headerStyle: void 0,
    headerClass: void 0,
    toolPanelClass: void 0,
    headerValueGetter: void 0,
    pivotKeys: void 0,
    groupId: void 0,
    colId: void 0,
    sort: void 0,
    initialSort: void 0,
    field: void 0,
    type: void 0,
    cellDataType: void 0,
    tooltipComponent: void 0,
    tooltipField: void 0,
    headerTooltip: void 0,
    headerTooltipValueGetter: void 0,
    cellClass: void 0,
    showRowGroup: void 0,
    filter: void 0,
    initialAggFunc: void 0,
    defaultAggFunc: void 0,
    aggFunc: void 0,
    pinned: void 0,
    initialPinned: void 0,
    chartDataType: void 0,
    cellAriaRole: void 0,
    cellEditorPopupPosition: void 0,
    headerGroupComponent: void 0,
    headerGroupComponentParams: void 0,
    cellStyle: void 0,
    cellRenderer: void 0,
    cellRendererParams: void 0,
    cellEditor: void 0,
    cellEditorParams: void 0,
    filterParams: void 0,
    pivotValueColumn: void 0,
    headerComponent: void 0,
    headerComponentParams: void 0,
    floatingFilterComponent: void 0,
    floatingFilterComponentParams: void 0,
    tooltipComponentParams: void 0,
    refData: void 0,
    columnChooserParams: void 0,
    children: void 0,
    sortingOrder: void 0,
    allowedAggFuncs: void 0,
    menuTabs: void 0,
    pivotTotalColumnIds: void 0,
    cellClassRules: void 0,
    icons: void 0,
    sortIndex: void 0,
    initialSortIndex: void 0,
    flex: void 0,
    initialFlex: void 0,
    width: void 0,
    initialWidth: void 0,
    minWidth: void 0,
    maxWidth: void 0,
    rowGroupIndex: void 0,
    initialRowGroupIndex: void 0,
    pivotIndex: void 0,
    initialPivotIndex: void 0,
    suppressColumnsToolPanel: void 0,
    suppressFiltersToolPanel: void 0,
    openByDefault: void 0,
    marryChildren: void 0,
    suppressStickyLabel: void 0,
    hide: void 0,
    initialHide: void 0,
    rowGroup: void 0,
    initialRowGroup: void 0,
    pivot: void 0,
    initialPivot: void 0,
    checkboxSelection: void 0,
    showDisabledCheckboxes: void 0,
    headerCheckboxSelection: void 0,
    headerCheckboxSelectionFilteredOnly: void 0,
    headerCheckboxSelectionCurrentPageOnly: void 0,
    suppressHeaderMenuButton: void 0,
    suppressMovable: void 0,
    lockPosition: void 0,
    lockVisible: void 0,
    lockPinned: void 0,
    unSortIcon: void 0,
    suppressSizeToFit: void 0,
    suppressAutoSize: void 0,
    enableRowGroup: void 0,
    enablePivot: void 0,
    enableValue: void 0,
    editable: void 0,
    suppressPaste: void 0,
    suppressNavigable: void 0,
    enableCellChangeFlash: void 0,
    rowDrag: void 0,
    dndSource: void 0,
    autoHeight: void 0,
    wrapText: void 0,
    sortable: void 0,
    resizable: void 0,
    singleClickEdit: void 0,
    floatingFilter: void 0,
    cellEditorPopup: void 0,
    suppressFillHandle: void 0,
    wrapHeaderText: void 0,
    autoHeaderHeight: void 0,
    dndSourceOnRowDrag: void 0,
    valueGetter: void 0,
    valueSetter: void 0,
    filterValueGetter: void 0,
    keyCreator: void 0,
    valueFormatter: void 0,
    valueParser: void 0,
    comparator: void 0,
    equals: void 0,
    pivotComparator: void 0,
    suppressKeyboardEvent: void 0,
    suppressHeaderKeyboardEvent: void 0,
    colSpan: void 0,
    rowSpan: void 0,
    spanRows: void 0,
    getQuickFilterText: void 0,
    onCellValueChanged: void 0,
    onCellClicked: void 0,
    onCellDoubleClicked: void 0,
    onCellContextMenu: void 0,
    rowDragText: void 0,
    tooltipValueGetter: void 0,
    tooltipComponentSelector: void 0,
    cellRendererSelector: void 0,
    cellEditorSelector: void 0,
    suppressSpanHeaderHeight: void 0,
    useValueFormatterForExport: void 0,
    useValueParserForImport: void 0,
    mainMenuItems: void 0,
    contextMenuItems: void 0,
    suppressFloatingFilterButton: void 0,
    suppressHeaderFilterButton: void 0,
    suppressHeaderContextMenu: void 0,
    loadingCellRenderer: void 0,
    loadingCellRendererParams: void 0,
    loadingCellRendererSelector: void 0,
    context: void 0,
    dateComponent: void 0,
    dateComponentParams: void 0,
    getFindText: void 0,
    rowGroupingHierarchy: void 0,
    groupHierarchy: void 0
};
var $437b23f6a393c3bf$var$ALL_PROPERTIES = ()=>Object.keys($437b23f6a393c3bf$var$colDefPropertyMap);
var $437b23f6a393c3bf$var$COL_DEF_VALIDATORS = ()=>({
        objectName: "colDef",
        allProperties: $437b23f6a393c3bf$var$ALL_PROPERTIES(),
        docsUrl: "column-properties/",
        deprecations: $437b23f6a393c3bf$var$COLUMN_DEFINITION_DEPRECATIONS(),
        validations: $437b23f6a393c3bf$var$COLUMN_DEFINITION_VALIDATIONS()
    });
// packages/ag-grid-community/src/propertyKeys.ts
var $437b23f6a393c3bf$var$STRING_GRID_OPTIONS = [
    "overlayLoadingTemplate",
    "overlayNoRowsTemplate",
    "gridId",
    "quickFilterText",
    "rowModelType",
    "editType",
    "domLayout",
    "clipboardDelimiter",
    "rowGroupPanelShow",
    "multiSortKey",
    "pivotColumnGroupTotals",
    "pivotRowTotals",
    "pivotPanelShow",
    "fillHandleDirection",
    "groupDisplayType",
    "treeDataDisplayType",
    "treeDataChildrenField",
    "treeDataParentIdField",
    "colResizeDefault",
    "tooltipTrigger",
    "serverSidePivotResultFieldSeparator",
    "columnMenu",
    "tooltipShowMode",
    "invalidEditValueMode",
    "grandTotalRow",
    "themeCssLayer",
    "findSearchValue",
    "styleNonce",
    "renderingMode"
];
var $437b23f6a393c3bf$var$OBJECT_GRID_OPTIONS = [
    "components",
    "rowStyle",
    "context",
    "autoGroupColumnDef",
    "localeText",
    "icons",
    "datasource",
    "dragAndDropImageComponentParams",
    "serverSideDatasource",
    "viewportDatasource",
    "groupRowRendererParams",
    "aggFuncs",
    "fullWidthCellRendererParams",
    "defaultColGroupDef",
    "defaultColDef",
    "defaultCsvExportParams",
    "defaultExcelExportParams",
    "columnTypes",
    "rowClassRules",
    "detailCellRendererParams",
    "loadingCellRendererParams",
    "loadingOverlayComponentParams",
    "noRowsOverlayComponentParams",
    "popupParent",
    "themeStyleContainer",
    "statusBar",
    "chartThemeOverrides",
    "customChartThemes",
    "chartToolPanelsDef",
    "dataTypeDefinitions",
    "advancedFilterParent",
    "advancedFilterBuilderParams",
    "advancedFilterParams",
    "initialState",
    "autoSizeStrategy",
    "selectionColumnDef",
    "findOptions",
    "filterHandlers",
    "groupHierarchyConfig"
];
var $437b23f6a393c3bf$var$ARRAY_GRID_OPTIONS = [
    "sortingOrder",
    "alignedGrids",
    "rowData",
    "columnDefs",
    "excelStyles",
    "pinnedTopRowData",
    "pinnedBottomRowData",
    "chartThemes",
    "rowClass",
    "paginationPageSizeSelector"
];
var $437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS = [
    "rowHeight",
    "detailRowHeight",
    "rowBuffer",
    "headerHeight",
    "groupHeaderHeight",
    "groupLockGroupColumns",
    "floatingFiltersHeight",
    "pivotHeaderHeight",
    "pivotGroupHeaderHeight",
    "groupDefaultExpanded",
    "pivotDefaultExpanded",
    "viewportRowModelPageSize",
    "viewportRowModelBufferSize",
    "autoSizePadding",
    "maxBlocksInCache",
    "maxConcurrentDatasourceRequests",
    "tooltipShowDelay",
    "tooltipHideDelay",
    "cacheOverflowSize",
    "paginationPageSize",
    "cacheBlockSize",
    "infiniteInitialRowCount",
    "serverSideInitialRowCount",
    "scrollbarWidth",
    "asyncTransactionWaitMillis",
    "blockLoadDebounceMillis",
    "keepDetailRowsCount",
    "undoRedoCellEditingLimit",
    "cellFlashDuration",
    "cellFadeDuration",
    "tabIndex",
    "pivotMaxGeneratedColumns",
    "rowDragInsertDelay"
];
var $437b23f6a393c3bf$var$OTHER_GRID_OPTIONS = [
    "theme",
    "rowSelection"
];
var $437b23f6a393c3bf$export$fb22311288c545c2 = [
    "cellSelection",
    "sideBar",
    "rowNumbers",
    "suppressGroupChangesColumnVisibility",
    "groupAggFiltering",
    "suppressStickyTotalRow",
    "groupHideParentOfSingleChild",
    "enableRowPinning"
];
var $437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS = [
    "loadThemeGoogleFonts",
    "suppressMakeColumnVisibleAfterUnGroup",
    "suppressRowClickSelection",
    "suppressCellFocus",
    "suppressHeaderFocus",
    "suppressHorizontalScroll",
    "groupSelectsChildren",
    "alwaysShowHorizontalScroll",
    "alwaysShowVerticalScroll",
    "debug",
    "enableBrowserTooltips",
    "enableCellExpressions",
    "groupSuppressBlankHeader",
    "suppressMenuHide",
    "suppressRowDeselection",
    "unSortIcon",
    "suppressMultiSort",
    "alwaysMultiSort",
    "singleClickEdit",
    "suppressLoadingOverlay",
    "suppressNoRowsOverlay",
    "suppressAutoSize",
    "skipHeaderOnAutoSize",
    "suppressColumnMoveAnimation",
    "suppressMoveWhenColumnDragging",
    "suppressMovableColumns",
    "suppressFieldDotNotation",
    "enableRangeSelection",
    "enableRangeHandle",
    "enableFillHandle",
    "suppressClearOnFillReduction",
    "deltaSort",
    "suppressTouch",
    "allowContextMenuWithControlKey",
    "suppressContextMenu",
    "suppressDragLeaveHidesColumns",
    "suppressRowGroupHidesColumns",
    "suppressMiddleClickScrolls",
    "suppressPreventDefaultOnMouseWheel",
    "suppressCopyRowsToClipboard",
    "copyHeadersToClipboard",
    "copyGroupHeadersToClipboard",
    "pivotMode",
    "suppressAggFuncInHeader",
    "suppressColumnVirtualisation",
    "alwaysAggregateAtRootLevel",
    "suppressFocusAfterRefresh",
    "functionsReadOnly",
    "animateRows",
    "groupSelectsFiltered",
    "groupRemoveSingleChildren",
    "groupRemoveLowestSingleChildren",
    "enableRtl",
    "enableCellSpan",
    "suppressClickEdit",
    "rowDragEntireRow",
    "rowDragManaged",
    "suppressRowDrag",
    "suppressMoveWhenRowDragging",
    "rowDragMultiRow",
    "enableGroupEdit",
    "embedFullWidthRows",
    "suppressPaginationPanel",
    "groupHideOpenParents",
    "groupAllowUnbalanced",
    "pagination",
    "paginationAutoPageSize",
    "suppressScrollOnNewData",
    "suppressScrollWhenPopupsAreOpen",
    "purgeClosedRowNodes",
    "cacheQuickFilter",
    "includeHiddenColumnsInQuickFilter",
    "ensureDomOrder",
    "accentedSort",
    "suppressChangeDetection",
    "valueCache",
    "valueCacheNeverExpires",
    "aggregateOnlyChangedColumns",
    "suppressAnimationFrame",
    "suppressExcelExport",
    "suppressCsvExport",
    "includeHiddenColumnsInAdvancedFilter",
    "suppressMultiRangeSelection",
    "enterNavigatesVerticallyAfterEdit",
    "enterNavigatesVertically",
    "suppressPropertyNamesCheck",
    "rowMultiSelectWithClick",
    "suppressRowHoverHighlight",
    "suppressRowTransform",
    "suppressClipboardPaste",
    "suppressLastEmptyLineOnPaste",
    "enableCharts",
    "suppressMaintainUnsortedOrder",
    "enableCellTextSelection",
    "suppressBrowserResizeObserver",
    "suppressMaxRenderedRowRestriction",
    "excludeChildrenWhenTreeDataFiltering",
    "tooltipMouseTrack",
    "tooltipInteraction",
    "keepDetailRows",
    "paginateChildRows",
    "preventDefaultOnContextMenu",
    "undoRedoCellEditing",
    "allowDragFromColumnsToolPanel",
    "pivotSuppressAutoColumn",
    "suppressExpandablePivotGroups",
    "debounceVerticalScrollbar",
    "detailRowAutoHeight",
    "serverSideSortAllLevels",
    "serverSideEnableClientSideSort",
    "serverSideOnlyRefreshFilteredGroups",
    "suppressAggFilteredOnly",
    "showOpenedGroup",
    "suppressClipboardApi",
    "suppressModelUpdateAfterUpdateTransaction",
    "stopEditingWhenCellsLoseFocus",
    "groupMaintainOrder",
    "columnHoverHighlight",
    "readOnlyEdit",
    "suppressRowVirtualisation",
    "enableCellEditingOnBackspace",
    "resetRowDataOnUpdate",
    "removePivotHeaderRowWhenSingleValueColumn",
    "suppressCopySingleCellRanges",
    "suppressGroupRowsSticky",
    "suppressCutToClipboard",
    "rowGroupPanelSuppressSort",
    "allowShowChangeAfterFilter",
    "enableAdvancedFilter",
    "masterDetail",
    "treeData",
    "reactiveCustomComponents",
    "applyQuickFilterBeforePivotOrAgg",
    "suppressServerSideFullWidthLoadingRow",
    "suppressAdvancedFilterEval",
    "loading",
    "maintainColumnOrder",
    "enableStrictPivotColumnOrder",
    "suppressSetFilterByDefault",
    "enableFilterHandlers",
    "suppressStartEditOnTab",
    "hidePaddedHeaderRows",
    "ssrmExpandAllAffectsAllRows"
];
var $437b23f6a393c3bf$var$_FUNCTION_GRID_OPTIONS = [
    "doesExternalFilterPass",
    "processPivotResultColDef",
    "processPivotResultColGroupDef",
    "getBusinessKeyForNode",
    "isRowSelectable",
    "rowDragText",
    "groupRowRenderer",
    "dragAndDropImageComponent",
    "fullWidthCellRenderer",
    "loadingCellRenderer",
    "loadingOverlayComponent",
    "noRowsOverlayComponent",
    "detailCellRenderer",
    "quickFilterParser",
    "quickFilterMatcher",
    "getLocaleText",
    "isExternalFilterPresent",
    "getRowHeight",
    "getRowClass",
    "getRowStyle",
    "getFullRowEditValidationErrors",
    "getContextMenuItems",
    "getMainMenuItems",
    "processRowPostCreate",
    "processCellForClipboard",
    "getGroupRowAgg",
    "isFullWidthRow",
    "sendToClipboard",
    "focusGridInnerElement",
    "navigateToNextHeader",
    "tabToNextHeader",
    "navigateToNextCell",
    "tabToNextCell",
    "processCellFromClipboard",
    "getDocument",
    "postProcessPopup",
    "getChildCount",
    "getDataPath",
    "isRowMaster",
    "postSortRows",
    "processHeaderForClipboard",
    "processUnpinnedColumns",
    "processGroupHeaderForClipboard",
    "paginationNumberFormatter",
    "processDataFromClipboard",
    "getServerSideGroupKey",
    "isServerSideGroup",
    "createChartContainer",
    "getChartToolbarItems",
    "fillOperation",
    "isApplyServerSideTransaction",
    "getServerSideGroupLevelParams",
    "isServerSideGroupOpenByDefault",
    "isGroupOpenByDefault",
    "initialGroupOrderComparator",
    "loadingCellRendererSelector",
    "getRowId",
    "chartMenuItems",
    "groupTotalRow",
    "alwaysPassFilter",
    "isRowPinnable",
    "isRowPinned",
    "isRowValidDropPosition"
];
var $437b23f6a393c3bf$export$a827a39ae0574df3 = ()=>[
        ...$437b23f6a393c3bf$var$ARRAY_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$OBJECT_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$STRING_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_FUNCTION_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS,
        ...$437b23f6a393c3bf$export$fb22311288c545c2,
        ...$437b23f6a393c3bf$var$OTHER_GRID_OPTIONS
    ];
// packages/ag-grid-community/src/validation/rules/gridOptionsValidations.ts
var $437b23f6a393c3bf$var$GRID_OPTION_DEPRECATIONS = ()=>({
        suppressLoadingOverlay: {
            version: "32",
            message: "Use `loading`=false instead."
        },
        enableFillHandle: {
            version: "32.2",
            message: "Use `cellSelection.handle` instead."
        },
        enableRangeHandle: {
            version: "32.2",
            message: "Use `cellSelection.handle` instead."
        },
        enableRangeSelection: {
            version: "32.2",
            message: "Use `cellSelection = true` instead."
        },
        suppressMultiRangeSelection: {
            version: "32.2",
            message: "Use `cellSelection.suppressMultiRanges` instead."
        },
        suppressClearOnFillReduction: {
            version: "32.2",
            message: "Use `cellSelection.handle.suppressClearOnFillReduction` instead."
        },
        fillHandleDirection: {
            version: "32.2",
            message: "Use `cellSelection.handle.direction` instead."
        },
        fillOperation: {
            version: "32.2",
            message: "Use `cellSelection.handle.setFillValue` instead."
        },
        suppressRowClickSelection: {
            version: "32.2",
            message: "Use `rowSelection.enableClickSelection` instead."
        },
        suppressRowDeselection: {
            version: "32.2",
            message: "Use `rowSelection.enableClickSelection` instead."
        },
        rowMultiSelectWithClick: {
            version: "32.2",
            message: "Use `rowSelection.enableSelectionWithoutKeys` instead."
        },
        groupSelectsChildren: {
            version: "32.2",
            message: 'Use `rowSelection.groupSelects = "descendants"` instead.'
        },
        groupSelectsFiltered: {
            version: "32.2",
            message: 'Use `rowSelection.groupSelects = "filteredDescendants"` instead.'
        },
        isRowSelectable: {
            version: "32.2",
            message: "Use `selectionOptions.isRowSelectable` instead."
        },
        suppressCopySingleCellRanges: {
            version: "32.2",
            message: "Use `rowSelection.copySelectedRows` instead."
        },
        suppressCopyRowsToClipboard: {
            version: "32.2",
            message: "Use `rowSelection.copySelectedRows` instead."
        },
        onRangeSelectionChanged: {
            version: "32.2",
            message: "Use `onCellSelectionChanged` instead."
        },
        onRangeDeleteStart: {
            version: "32.2",
            message: "Use `onCellSelectionDeleteStart` instead."
        },
        onRangeDeleteEnd: {
            version: "32.2",
            message: "Use `onCellSelectionDeleteEnd` instead."
        },
        suppressBrowserResizeObserver: {
            version: "32.2",
            message: "The grid always uses the browser's ResizeObserver, this grid option has no effect."
        },
        onColumnEverythingChanged: {
            version: "32.2",
            message: "Either use `onDisplayedColumnsChanged` which is fired at the same time, or use one of the more specific column events."
        },
        groupRemoveSingleChildren: {
            version: "33",
            message: "Use `groupHideParentOfSingleChild` instead."
        },
        groupRemoveLowestSingleChildren: {
            version: "33",
            message: 'Use `groupHideParentOfSingleChild: "leafGroupsOnly"` instead.'
        },
        suppressRowGroupHidesColumns: {
            version: "33",
            message: 'Use `suppressGroupChangesColumnVisibility: "suppressHideOnGroup"` instead.'
        },
        suppressMakeColumnVisibleAfterUnGroup: {
            version: "33",
            message: 'Use `suppressGroupChangesColumnVisibility: "suppressShowOnUngroup"` instead.'
        },
        unSortIcon: {
            version: "33",
            message: "Use `defaultColDef.unSortIcon` instead."
        },
        sortingOrder: {
            version: "33",
            message: "Use `defaultColDef.sortingOrder` instead."
        },
        suppressPropertyNamesCheck: {
            version: "33",
            message: "`gridOptions` and `columnDefs` both have a `context` property that should be used for arbitrary user data. This means that column definitions and gridOptions should only contain valid properties making this property redundant."
        },
        suppressAdvancedFilterEval: {
            version: "34",
            message: "Advanced filter no longer uses function evaluation, so this option has no effect."
        }
    });
function $437b23f6a393c3bf$var$toConstrainedNum(key, value, min) {
    if (typeof value === "number" || value == null) {
        if (value == null) return null;
        return value >= min ? null : `${key}: value should be greater than or equal to ${min}`;
    }
    return `${key}: value should be a number`;
}
var $437b23f6a393c3bf$var$GRID_OPTIONS_MODULES = {
    alignedGrids: "AlignedGrids",
    allowContextMenuWithControlKey: "ContextMenu",
    autoSizeStrategy: "ColumnAutoSize",
    cellSelection: "CellSelection",
    columnHoverHighlight: "ColumnHover",
    datasource: "InfiniteRowModel",
    doesExternalFilterPass: "ExternalFilter",
    editType: "EditCore",
    invalidEditValueMode: "EditCore",
    enableAdvancedFilter: "AdvancedFilter",
    enableCellSpan: "CellSpan",
    enableCharts: "IntegratedCharts",
    enableRangeSelection: "CellSelection",
    enableRowPinning: "PinnedRow",
    findSearchValue: "Find",
    getFullRowEditValidationErrors: "EditCore",
    getContextMenuItems: "ContextMenu",
    getLocaleText: "Locale",
    getMainMenuItems: "ColumnMenu",
    getRowClass: "RowStyle",
    getRowStyle: "RowStyle",
    groupTotalRow: "SharedRowGrouping",
    grandTotalRow: "ClientSideRowModelHierarchy",
    initialState: "GridState",
    isExternalFilterPresent: "ExternalFilter",
    isRowPinnable: "PinnedRow",
    isRowPinned: "PinnedRow",
    localeText: "Locale",
    masterDetail: "SharedMasterDetail",
    pagination: "Pagination",
    pinnedBottomRowData: "PinnedRow",
    pinnedTopRowData: "PinnedRow",
    pivotMode: "SharedPivot",
    pivotPanelShow: "RowGroupingPanel",
    quickFilterText: "QuickFilter",
    rowClass: "RowStyle",
    rowClassRules: "RowStyle",
    rowData: "ClientSideRowModel",
    rowDragManaged: "RowDrag",
    rowGroupPanelShow: "RowGroupingPanel",
    rowNumbers: "RowNumbers",
    rowSelection: "SharedRowSelection",
    rowStyle: "RowStyle",
    serverSideDatasource: "ServerSideRowModel",
    sideBar: "SideBar",
    statusBar: "StatusBar",
    treeData: "SharedTreeData",
    undoRedoCellEditing: "UndoRedoEdit",
    valueCache: "ValueCache",
    viewportDatasource: "ViewportRowModel"
};
var $437b23f6a393c3bf$var$GRID_OPTION_VALIDATIONS = ()=>{
    const definedValidations = {
        autoSizePadding: {
            validate ({ autoSizePadding: autoSizePadding }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("autoSizePadding", autoSizePadding, 0);
            }
        },
        cacheBlockSize: {
            supportedRowModels: [
                "serverSide",
                "infinite"
            ],
            validate ({ cacheBlockSize: cacheBlockSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("cacheBlockSize", cacheBlockSize, 1);
            }
        },
        cacheOverflowSize: {
            validate ({ cacheOverflowSize: cacheOverflowSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("cacheOverflowSize", cacheOverflowSize, 1);
            }
        },
        datasource: {
            supportedRowModels: [
                "infinite"
            ]
        },
        domLayout: {
            validate: (options)=>{
                const domLayout = options.domLayout;
                const validLayouts = [
                    "autoHeight",
                    "normal",
                    "print"
                ];
                if (domLayout && !validLayouts.includes(domLayout)) return `domLayout must be one of [${validLayouts.join()}], currently it's ${domLayout}`;
                return null;
            }
        },
        enableFillHandle: {
            dependencies: {
                enableRangeSelection: {
                    required: [
                        true
                    ]
                }
            }
        },
        enableRangeHandle: {
            dependencies: {
                enableRangeSelection: {
                    required: [
                        true
                    ]
                }
            }
        },
        enableRangeSelection: {
            dependencies: {
                rowDragEntireRow: {
                    required: [
                        false,
                        void 0
                    ]
                }
            }
        },
        enableRowPinning: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ enableRowPinning: enableRowPinning, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (enableRowPinning && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either set `enableRowPinning` to `false`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                return null;
            }
        },
        isRowPinnable: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ enableRowPinning: enableRowPinning, isRowPinnable: isRowPinnable, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (isRowPinnable && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinnable`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                if (!enableRowPinning && isRowPinnable) return "`isRowPinnable` requires `enableRowPinning` to be set.";
                return null;
            }
        },
        isRowPinned: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ enableRowPinning: enableRowPinning, isRowPinned: isRowPinned, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (isRowPinned && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinned`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                if (!enableRowPinning && isRowPinned) return "`isRowPinned` requires `enableRowPinning` to be set.";
                return null;
            }
        },
        groupDefaultExpanded: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        groupHideOpenParents: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            dependencies: {
                groupTotalRow: {
                    required: [
                        void 0,
                        "bottom"
                    ]
                },
                treeData: {
                    required: [
                        void 0,
                        false
                    ],
                    reason: "Tree Data has values at the group level so it doesn't make sense to hide them."
                }
            }
        },
        groupHideParentOfSingleChild: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupRemoveLowestSingleChildren: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                },
                groupRemoveSingleChildren: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupRemoveSingleChildren: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                },
                groupRemoveLowestSingleChildren: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupSelectsChildren: {
            dependencies: {
                rowSelection: {
                    required: [
                        "multiple"
                    ]
                }
            }
        },
        groupHierarchyConfig: {
            validate ({ groupHierarchyConfig: groupHierarchyConfig = {} }, gridOptions, beans) {
                for (const k of Object.keys(groupHierarchyConfig))beans.validation?.validateColDef(groupHierarchyConfig[k]);
                return null;
            }
        },
        icons: {
            validate: ({ icons: icons })=>{
                if (icons) {
                    if (icons["smallDown"]) return $437b23f6a393c3bf$export$680bb5102fca525e(262);
                    if (icons["smallLeft"]) return $437b23f6a393c3bf$export$680bb5102fca525e(263);
                    if (icons["smallRight"]) return $437b23f6a393c3bf$export$680bb5102fca525e(264);
                }
                return null;
            }
        },
        infiniteInitialRowCount: {
            validate ({ infiniteInitialRowCount: infiniteInitialRowCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("infiniteInitialRowCount", infiniteInitialRowCount, 1);
            }
        },
        initialGroupOrderComparator: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        ssrmExpandAllAffectsAllRows: {
            validate: (options)=>{
                if (typeof options.ssrmExpandAllAffectsAllRows === "boolean") {
                    if (options.rowModelType !== "serverSide") return "'ssrmExpandAllAffectsAllRows' is only supported with the Server Side Row Model.";
                    if (options.ssrmExpandAllAffectsAllRows && typeof options.getRowId !== "function") return `'getRowId' callback must be provided for Server Side Row Model grouping to work correctly.`;
                }
                return null;
            }
        },
        keepDetailRowsCount: {
            validate ({ keepDetailRowsCount: keepDetailRowsCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("keepDetailRowsCount", keepDetailRowsCount, 1);
            }
        },
        paginationPageSize: {
            validate ({ paginationPageSize: paginationPageSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("paginationPageSize", paginationPageSize, 1);
            }
        },
        paginationPageSizeSelector: {
            validate: (options)=>{
                const values = options.paginationPageSizeSelector;
                if (typeof values === "boolean" || values == null) return null;
                if (!values.length) return `'paginationPageSizeSelector' cannot be an empty array.
                    If you want to hide the page size selector, set paginationPageSizeSelector to false.`;
                return null;
            }
        },
        pivotMode: {
            dependencies: {
                treeData: {
                    required: [
                        false,
                        void 0
                    ],
                    reason: "Pivot Mode is not supported with Tree Data."
                }
            }
        },
        quickFilterText: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        rowBuffer: {
            validate ({ rowBuffer: rowBuffer }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("rowBuffer", rowBuffer, 0);
            }
        },
        rowClass: {
            validate: (options)=>{
                const rowClass = options.rowClass;
                if (typeof rowClass === "function") return "rowClass should not be a function, please use getRowClass instead";
                return null;
            }
        },
        rowData: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        rowDragManaged: {
            supportedRowModels: [
                "clientSide"
            ],
            dependencies: {
                pagination: {
                    required: [
                        false,
                        void 0
                    ]
                }
            }
        },
        rowSelection: {
            validate ({ rowSelection: rowSelection }) {
                if (rowSelection && typeof rowSelection === "string") return 'As of version 32.2.1, using `rowSelection` with the values "single" or "multiple" has been deprecated. Use the object value instead.';
                if (rowSelection && typeof rowSelection !== "object") return "Expected `RowSelectionOptions` object for the `rowSelection` property.";
                if (rowSelection && rowSelection.mode !== "multiRow" && rowSelection.mode !== "singleRow") return `Selection mode "${rowSelection.mode}" is invalid. Use one of 'singleRow' or 'multiRow'.`;
                return null;
            }
        },
        rowStyle: {
            validate: (options)=>{
                const rowStyle = options.rowStyle;
                if (rowStyle && typeof rowStyle === "function") return "rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead";
                return null;
            }
        },
        serverSideDatasource: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        serverSideInitialRowCount: {
            supportedRowModels: [
                "serverSide"
            ],
            validate ({ serverSideInitialRowCount: serverSideInitialRowCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("serverSideInitialRowCount", serverSideInitialRowCount, 1);
            }
        },
        serverSideOnlyRefreshFilteredGroups: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        serverSideSortAllLevels: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        sortingOrder: {
            validate: (_options)=>{
                const sortingOrder = _options.sortingOrder;
                if (Array.isArray(sortingOrder) && sortingOrder.length > 0) {
                    const invalidItems = sortingOrder.filter((a)=>!$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.includes(a));
                    if (invalidItems.length > 0) return `sortingOrder must be an array with elements from [${$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}], currently it includes [${invalidItems.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}]`;
                } else if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) return `sortingOrder must be an array with at least one element, currently it's ${sortingOrder}`;
                return null;
            }
        },
        tooltipHideDelay: {
            validate: (options)=>{
                if (options.tooltipHideDelay && options.tooltipHideDelay < 0) return "tooltipHideDelay should not be lower than 0";
                return null;
            }
        },
        tooltipShowDelay: {
            validate: (options)=>{
                if (options.tooltipShowDelay && options.tooltipShowDelay < 0) return "tooltipShowDelay should not be lower than 0";
                return null;
            }
        },
        treeData: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (options)=>{
                const rowModel = options.rowModelType ?? "clientSide";
                switch(rowModel){
                    case "clientSide":
                        {
                            const { treeDataChildrenField: treeDataChildrenField, treeDataParentIdField: treeDataParentIdField, getDataPath: getDataPath, getRowId: getRowId } = options;
                            if (!treeDataChildrenField && !treeDataParentIdField && !getDataPath) return "treeData requires either 'treeDataChildrenField' or 'treeDataParentIdField' or 'getDataPath' in the clientSide row model.";
                            if (treeDataChildrenField) {
                                if (getDataPath) return "Cannot use both 'treeDataChildrenField' and 'getDataPath' at the same time.";
                                if (treeDataParentIdField) return "Cannot use both 'treeDataChildrenField' and 'treeDataParentIdField' at the same time.";
                            }
                            if (treeDataParentIdField) {
                                if (!getRowId) return "getRowId callback not provided, tree data with parent id cannot be built.";
                                if (getDataPath) return "Cannot use both 'treeDataParentIdField' and 'getDataPath' at the same time.";
                            }
                            return null;
                        }
                    case "serverSide":
                        {
                            const ssrmWarning = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${rowModel} row model.`;
                            return options.isServerSideGroup && options.getServerSideGroupKey ? null : ssrmWarning;
                        }
                }
                return null;
            }
        },
        viewportDatasource: {
            supportedRowModels: [
                "viewport"
            ]
        },
        viewportRowModelBufferSize: {
            validate ({ viewportRowModelBufferSize: viewportRowModelBufferSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("viewportRowModelBufferSize", viewportRowModelBufferSize, 0);
            }
        },
        viewportRowModelPageSize: {
            validate ({ viewportRowModelPageSize: viewportRowModelPageSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("viewportRowModelPageSize", viewportRowModelPageSize, 1);
            }
        },
        rowDragEntireRow: {
            dependencies: {
                cellSelection: {
                    required: [
                        void 0
                    ]
                }
            }
        },
        autoGroupColumnDef: {
            validate ({ autoGroupColumnDef: autoGroupColumnDef, showOpenedGroup: showOpenedGroup }) {
                if (autoGroupColumnDef?.field && showOpenedGroup) return "autoGroupColumnDef.field and showOpenedGroup are not supported when used together.";
                if (autoGroupColumnDef?.valueGetter && showOpenedGroup) return "autoGroupColumnDef.valueGetter and showOpenedGroup are not supported when used together.";
                return null;
            }
        },
        renderingMode: {
            validate: (options)=>{
                const renderingMode = options.renderingMode;
                const validModes = [
                    "default",
                    "legacy"
                ];
                if (renderingMode && !validModes.includes(renderingMode)) return `renderingMode must be one of [${validModes.join()}], currently it's ${renderingMode}`;
                return null;
            }
        },
        autoSizeStrategy: {
            validate: ({ autoSizeStrategy: autoSizeStrategy })=>{
                if (!autoSizeStrategy) return null;
                const validModes = [
                    "fitCellContents",
                    "fitGridWidth",
                    "fitProvidedWidth"
                ];
                const type = autoSizeStrategy.type;
                if (type !== "fitCellContents" && type !== "fitGridWidth" && type !== "fitProvidedWidth") return `Invalid Auto-size strategy. \`autoSizeStrategy\` must be one of ${validModes.map((m)=>'"' + m + '"').join(", ")}, currently it's ${type}`;
                if (type === "fitProvidedWidth" && typeof autoSizeStrategy.width != "number") return `When using the 'fitProvidedWidth' auto-size strategy, must provide a numeric \`width\`. You provided ${autoSizeStrategy.width}`;
                return null;
            }
        }
    };
    const validations = {};
    for (const key of $437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS)validations[key] = {
        expectedType: "boolean"
    };
    for (const key of $437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS)validations[key] = {
        expectedType: "number"
    };
    $437b23f6a393c3bf$export$8ade6bd474fcde42(validations, definedValidations);
    return validations;
};
var $437b23f6a393c3bf$var$GRID_OPTIONS_VALIDATORS = ()=>({
        objectName: "gridOptions",
        allProperties: [
            ...$437b23f6a393c3bf$export$a827a39ae0574df3(),
            ...Object.values($437b23f6a393c3bf$export$85716710781d6a6b)
        ],
        propertyExceptions: [
            "api"
        ],
        docsUrl: "grid-options/",
        deprecations: $437b23f6a393c3bf$var$GRID_OPTION_DEPRECATIONS(),
        validations: $437b23f6a393c3bf$var$GRID_OPTION_VALIDATIONS()
    });
// packages/ag-grid-community/src/gridOptionsService.ts
var $437b23f6a393c3bf$var$changeSetId = 0;
var $437b23f6a393c3bf$var$gridInstanceSequence = 0;
var $437b23f6a393c3bf$var$GRID_DOM_KEY = "__ag_grid_instance";
var $437b23f6a393c3bf$var$GridOptionsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gos";
        this.domDataKey = "__AG_" + Math.random().toString();
        /** This is only used for the main DOM element */ this.instanceId = $437b23f6a393c3bf$var$gridInstanceSequence++;
        // Used to hold user events until the grid is ready
        // Required to support React 19 StrictMode. See IFrameworkOverrides.runWhenReadyAsync but also is likely a good idea that onGridReady is the first event fired.
        this.gridReadyFired = false;
        this.queueEvents = [];
        this.propEventSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
        // responsible for calling the onXXX functions on gridOptions
        // It forces events defined in GridOptionsService.alwaysSyncGlobalEvents to be fired synchronously.
        // This is required for events such as GridPreDestroyed.
        // Other events can be fired asynchronously or synchronously depending on config.
        this.globalEventHandlerFactory = (restrictToSyncOnly)=>{
            return (eventName, event)=>{
                if (!this.isAlive()) return;
                const alwaysSync = $437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventName);
                if (alwaysSync && !restrictToSyncOnly || !alwaysSync && restrictToSyncOnly) return;
                if (!$437b23f6a393c3bf$var$isPublicEventHandler(eventName)) return;
                const fireEvent = (name, e)=>{
                    const eventHandlerName = $437b23f6a393c3bf$export$85716710781d6a6b[name];
                    const eventHandler = this.gridOptions[eventHandlerName];
                    if (typeof eventHandler === "function") this.beans.frameworkOverrides.wrapOutgoing(()=>eventHandler(e));
                };
                if (this.gridReadyFired) fireEvent(eventName, event);
                else if (eventName === "gridReady") {
                    fireEvent(eventName, event);
                    this.gridReadyFired = true;
                    for (const q of this.queueEvents)fireEvent(q.eventName, q.event);
                    this.queueEvents = [];
                } else this.queueEvents.push({
                    eventName: eventName,
                    event: event
                });
            };
        };
    }
    wireBeans(beans) {
        this.gridOptions = beans.gridOptions;
        this.validation = beans.validation;
        this.api = beans.gridApi;
        this.gridId = beans.context.getId();
    }
    // This is quicker then having code call gridOptionsService.get('context')
    get gridOptionsContext() {
        return this.gridOptions["context"];
    }
    postConstruct() {
        this.validateGridOptions(this.gridOptions);
        this.eventSvc.addGlobalListener(this.globalEventHandlerFactory().bind(this), true);
        this.eventSvc.addGlobalListener(this.globalEventHandlerFactory(true).bind(this), false);
        this.propEventSvc.setFrameworkOverrides(this.beans.frameworkOverrides);
        this.addManagedEventListeners({
            gridOptionsChanged: ({ options: options })=>{
                this.updateGridOptions({
                    options: options,
                    force: true,
                    source: "optionsUpdated"
                });
            }
        });
    }
    destroy() {
        super.destroy();
        this.queueEvents = [];
    }
    /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */ get(property) {
        return this.gridOptions[property] ?? $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS[property];
    }
    /**
   * Get the GridOption callback but wrapped so that the common params of api and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */ getCallback(property) {
        return this.mergeGridCommonParams(this.gridOptions[property]);
    }
    /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */ exists(property) {
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(this.gridOptions[property]);
    }
    /**
   * Wrap the user callback and attach the api and context to the params object on the way through.
   * @param callback User provided callback
   * @returns Wrapped callback where the params object not require api and context
   */ mergeGridCommonParams(callback) {
        if (callback) {
            const wrapped = (callbackParams)=>{
                return callback(this.addCommon(callbackParams));
            };
            return wrapped;
        }
        return callback;
    }
    updateGridOptions({ options: options, force: force, source: source = "api" }) {
        const changeSet = {
            id: $437b23f6a393c3bf$var$changeSetId++,
            properties: []
        };
        const events = [];
        const { gridOptions: gridOptions, validation: validation } = this;
        for (const key of Object.keys(options)){
            const value = $437b23f6a393c3bf$var$GlobalGridOptions.applyGlobalGridOption(key, options[key]);
            validation?.warnOnInitialPropertyUpdate(source, key);
            const shouldForce = force || typeof value === "object" && source === "api";
            const previousValue = gridOptions[key];
            if (shouldForce || previousValue !== value) {
                gridOptions[key] = value;
                const event = {
                    type: key,
                    currentValue: value,
                    previousValue: previousValue,
                    changeSet: changeSet,
                    source: source
                };
                events.push(event);
            }
        }
        this.validateGridOptions(this.gridOptions);
        changeSet.properties = events.map((event)=>event.type);
        for (const event of events){
            $437b23f6a393c3bf$var$_logIfDebug(this, `Updated property ${event.type} from`, event.previousValue, ` to `, event.currentValue);
            this.propEventSvc.dispatchEvent(event);
        }
    }
    addPropertyEventListener(key, listener) {
        this.propEventSvc.addEventListener(key, listener);
    }
    removePropertyEventListener(key, listener) {
        this.propEventSvc.removeEventListener(key, listener);
    }
    getDomDataKey() {
        return this.domDataKey;
    }
    /** Prefer _addGridCommonParams from gridOptionsUtils for bundle size savings */ addCommon(params) {
        params.api = this.api;
        params.context = this.gridOptionsContext;
        return params;
    }
    validateOptions(options, modValidations) {
        for (const key of Object.keys(options)){
            const value = options[key];
            if (value == null || value === false) continue;
            let moduleToCheck = modValidations[key];
            if (typeof moduleToCheck === "function") moduleToCheck = moduleToCheck(options, this.gridOptions, this.beans);
            if (moduleToCheck) this.assertModuleRegistered(moduleToCheck, key);
        }
    }
    validateGridOptions(gridOptions) {
        this.validateOptions(gridOptions, $437b23f6a393c3bf$var$GRID_OPTIONS_MODULES);
        this.validation?.processGridOptions(gridOptions);
    }
    validateColDef(colDef, colId, skipInferenceCheck) {
        if (skipInferenceCheck || !this.beans.dataTypeSvc?.isColPendingInference(colId)) {
            this.validateOptions(colDef, $437b23f6a393c3bf$var$COLUMN_DEFINITION_MOD_VALIDATIONS);
            this.validation?.validateColDef(colDef);
        }
    }
    assertModuleRegistered(moduleName, reasonOrId) {
        const registered = Array.isArray(moduleName) ? moduleName.some((modName)=>this.isModuleRegistered(modName)) : this.isModuleRegistered(moduleName);
        if (!registered) $437b23f6a393c3bf$export$a20c7248650823a9(200, {
            ...this.getModuleErrorParams(),
            moduleName: moduleName,
            reasonOrId: reasonOrId
        });
        return registered;
    }
    getModuleErrorParams() {
        return {
            gridId: this.gridId,
            gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
            rowModelType: this.get("rowModelType"),
            isUmd: $437b23f6a393c3bf$var$_isUmd()
        };
    }
    isModuleRegistered(moduleName) {
        return $437b23f6a393c3bf$var$_isModuleRegistered(moduleName, this.gridId, this.get("rowModelType"));
    }
    setInstanceDomData(element) {
        element[$437b23f6a393c3bf$var$GRID_DOM_KEY] = this.instanceId;
    }
    isElementInThisInstance(element) {
        let pointer = element;
        while(pointer){
            const instanceId = pointer[$437b23f6a393c3bf$var$GRID_DOM_KEY];
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(instanceId)) {
                const eventFromThisGrid = instanceId === this.instanceId;
                return eventFromThisGrid;
            }
            pointer = pointer.parentElement;
        }
        return false;
    }
};
function $437b23f6a393c3bf$var$isPublicEventHandler(eventName) {
    return !!$437b23f6a393c3bf$export$85716710781d6a6b[eventName];
}
// packages/ag-grid-community/src/headerRendering/cells/column/headerComp.ts
function $437b23f6a393c3bf$var$getHeaderCompElementParams(includeSortIndicator) {
    const hiddenAttrs = {
        "aria-hidden": "true"
    };
    return {
        tag: "div",
        cls: "ag-cell-label-container",
        role: "presentation",
        children: [
            {
                tag: "span",
                ref: "eMenu",
                cls: "ag-header-icon ag-header-cell-menu-button",
                attrs: hiddenAttrs
            },
            {
                tag: "span",
                ref: "eFilterButton",
                cls: "ag-header-icon ag-header-cell-filter-button",
                attrs: hiddenAttrs
            },
            {
                tag: "div",
                ref: "eLabel",
                cls: "ag-header-cell-label",
                role: "presentation",
                children: [
                    {
                        tag: "span",
                        ref: "eText",
                        cls: "ag-header-cell-text"
                    },
                    {
                        tag: "span",
                        ref: "eFilter",
                        cls: "ag-header-icon ag-header-label-icon ag-filter-icon",
                        attrs: hiddenAttrs
                    },
                    includeSortIndicator ? {
                        tag: "ag-sort-indicator",
                        ref: "eSortIndicator"
                    } : null
                ]
            }
        ]
    };
}
var $437b23f6a393c3bf$var$HeaderCompElement = $437b23f6a393c3bf$var$getHeaderCompElementParams(true);
var $437b23f6a393c3bf$var$HeaderCompElementNoSort = $437b23f6a393c3bf$var$getHeaderCompElementParams(false);
var $437b23f6a393c3bf$export$266cd3930df0b35d = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        // All the elements are optional, as they are not guaranteed to be present if the user provides a custom template
        this.eFilter = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eFilterButton = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortIndicator = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eMenu = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eText = $437b23f6a393c3bf$export$6c811454646ed8be;
        /**
     * Selectors for custom headers templates, i.e when the ag-sort-indicator is not present.
     */ this.eSortOrder = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAsc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortDesc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortMixed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortNone = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isLoadingInnerComponent = false;
    }
    refresh(params) {
        const oldParams = this.params;
        this.params = params;
        if (this.workOutTemplate(params, !!this.beans?.sortSvc) != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || params.enableSorting != this.currentSort || this.currentSuppressMenuHide != null && this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || oldParams.enableFilterButton != params.enableFilterButton || oldParams.enableFilterIcon != params.enableFilterIcon) return false;
        if (this.innerHeaderComponent) {
            const mergedParams = {
                ...params
            };
            $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedParams, params.innerHeaderComponentParams);
            this.innerHeaderComponent.refresh?.(mergedParams);
        } else this.setDisplayName(params);
        return true;
    }
    workOutTemplate(params, isSorting) {
        const paramsTemplate = params.template;
        if (paramsTemplate) return paramsTemplate?.trim ? paramsTemplate.trim() : paramsTemplate;
        else return isSorting ? $437b23f6a393c3bf$var$HeaderCompElement : $437b23f6a393c3bf$var$HeaderCompElementNoSort;
    }
    init(params) {
        this.params = params;
        const { sortSvc: sortSvc, touchSvc: touchSvc, rowNumbersSvc: rowNumbersSvc, userCompFactory: userCompFactory } = this.beans;
        const sortComp = sortSvc?.getSortIndicatorSelector();
        this.currentTemplate = this.workOutTemplate(params, !!sortComp);
        this.setTemplate(this.currentTemplate, sortComp ? [
            sortComp
        ] : void 0);
        touchSvc?.setupForHeader(this);
        this.setMenu();
        this.setupSort();
        rowNumbersSvc?.setupForHeader(this);
        this.setupFilterIcon();
        this.setupFilterButton();
        this.workOutInnerHeaderComponent(userCompFactory, params);
        this.setDisplayName(params);
    }
    workOutInnerHeaderComponent(userCompFactory, params) {
        const userCompDetails = $437b23f6a393c3bf$var$_getInnerHeaderCompDetails(userCompFactory, params, params);
        if (!userCompDetails) return;
        this.isLoadingInnerComponent = true;
        userCompDetails.newAgStackInstance().then((comp)=>{
            this.isLoadingInnerComponent = false;
            if (!comp) return;
            if (this.isAlive()) {
                this.innerHeaderComponent = comp;
                if (this.eText) this.eText.appendChild(comp.getGui());
            } else this.destroyBean(comp);
        });
    }
    setDisplayName(params) {
        const { displayName: displayName } = params;
        const oldDisplayName = this.currentDisplayName;
        this.currentDisplayName = displayName;
        if (!this.eText || oldDisplayName === displayName || this.innerHeaderComponent || this.isLoadingInnerComponent) return;
        this.eText.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(displayName);
    }
    addInIcon(iconName, eParent, column) {
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    workOutShowMenu() {
        return this.params.enableMenu && !!this.beans.menuSvc?.isHeaderMenuButtonEnabled();
    }
    shouldSuppressMenuHide() {
        return !!this.beans.menuSvc?.isHeaderMenuButtonAlwaysShowEnabled();
    }
    setMenu() {
        if (!this.eMenu) return;
        this.currentShowMenu = this.workOutShowMenu();
        if (!this.currentShowMenu) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eMenu);
            this.eMenu = void 0;
            return;
        }
        const { gos: gos, eMenu: eMenu, params: params } = this;
        const isLegacyMenu = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
        this.addInIcon(isLegacyMenu ? "menu" : "menuAlt", eMenu, params.column);
        eMenu.classList.toggle("ag-header-menu-icon", !isLegacyMenu);
        const currentSuppressMenuHide = this.shouldSuppressMenuHide();
        this.currentSuppressMenuHide = currentSuppressMenuHide;
        this.addManagedElementListeners(eMenu, {
            click: ()=>this.showColumnMenu(this.eMenu)
        });
        this.toggleMenuAlwaysShow(currentSuppressMenuHide);
    }
    toggleMenuAlwaysShow(alwaysShow) {
        this.eMenu?.classList.toggle("ag-header-menu-always-show", alwaysShow);
    }
    showColumnMenu(element) {
        const { currentSuppressMenuHide: currentSuppressMenuHide, params: params } = this;
        if (!currentSuppressMenuHide) this.toggleMenuAlwaysShow(true);
        params.showColumnMenu(element, ()=>{
            if (!currentSuppressMenuHide) this.toggleMenuAlwaysShow(false);
        });
    }
    onMenuKeyboardShortcut(isFilterShortcut) {
        const { params: params, gos: gos, beans: beans, eMenu: eMenu, eFilterButton: eFilterButton } = this;
        const column = params.column;
        const isLegacyMenuEnabled = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
        if (isFilterShortcut && !isLegacyMenuEnabled) {
            if (beans.menuSvc?.isFilterMenuInHeaderEnabled(column)) {
                params.showFilter(eFilterButton ?? eMenu ?? this.getGui());
                return true;
            }
        } else if (params.enableMenu) {
            this.showColumnMenu(eMenu ?? eFilterButton ?? this.getGui());
            return true;
        }
        return false;
    }
    setupSort() {
        const { sortSvc: sortSvc } = this.beans;
        if (!sortSvc) return;
        const { enableSorting: enableSorting, column: column } = this.params;
        this.currentSort = enableSorting;
        if (!this.eSortIndicator) {
            this.eSortIndicator = this.createBean(sortSvc.createSortIndicator(true));
            const { eSortIndicator: eSortIndicator, eSortOrder: eSortOrder, eSortAsc: eSortAsc, eSortDesc: eSortDesc, eSortMixed: eSortMixed, eSortNone: eSortNone } = this;
            eSortIndicator.attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone);
        }
        this.eSortIndicator.setupSort(column);
        if (!this.currentSort) return;
        sortSvc.setupHeader(this, column, this.eLabel);
    }
    setupFilterIcon() {
        const { eFilter: eFilter, params: params } = this;
        if (!eFilter) return;
        const onFilterChangedIcon = ()=>{
            const filterPresent = params.column.isFilterActive();
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eFilter, filterPresent, {
                skipAriaHidden: true
            });
        };
        this.configureFilter(params.enableFilterIcon, eFilter, onFilterChangedIcon, "filterActive");
    }
    setupFilterButton() {
        const { eFilterButton: eFilterButton, params: params } = this;
        if (!eFilterButton) return;
        const configured = this.configureFilter(params.enableFilterButton, eFilterButton, this.onFilterChangedButton.bind(this), "filter");
        if (configured) this.addManagedElementListeners(eFilterButton, {
            click: ()=>params.showFilter(eFilterButton)
        });
        else this.eFilterButton = void 0;
    }
    configureFilter(enabled, element, filterChangedCallback, icon) {
        if (!enabled) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(element);
            return false;
        }
        const column = this.params.column;
        this.addInIcon(icon, element, column);
        this.addManagedListeners(column, {
            filterChanged: filterChangedCallback
        });
        filterChangedCallback();
        return true;
    }
    onFilterChangedButton() {
        const filterPresent = this.params.column.isFilterActive();
        this.eFilterButton.classList.toggle("ag-filter-active", filterPresent);
    }
    getAnchorElementForMenu(isFilter) {
        const { eFilterButton: eFilterButton, eMenu: eMenu } = this;
        if (isFilter) return eFilterButton ?? eMenu ?? this.getGui();
        return eMenu ?? eFilterButton ?? this.getGui();
    }
    destroy() {
        super.destroy();
        if (this.innerHeaderComponent) {
            this.destroyBean(this.innerHeaderComponent);
            this.innerHeaderComponent = void 0;
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupComp.ts
var $437b23f6a393c3bf$var$HeaderGroupCompElement = {
    tag: "div",
    cls: "ag-header-group-cell-label",
    role: "presentation",
    children: [
        {
            tag: "span",
            ref: "agLabel",
            cls: "ag-header-group-text",
            role: "presentation"
        },
        {
            tag: "span",
            ref: "agOpened",
            cls: `ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded`
        },
        {
            tag: "span",
            ref: "agClosed",
            cls: `ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed`
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderGroupComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$HeaderGroupCompElement);
        this.agOpened = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.agClosed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.agLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isLoadingInnerComponent = false;
    }
    init(params) {
        const { userCompFactory: userCompFactory, touchSvc: touchSvc } = this.beans;
        this.params = params;
        this.checkWarnings();
        this.workOutInnerHeaderGroupComponent(userCompFactory, params);
        this.setupLabel(params);
        this.addGroupExpandIcon(params);
        this.setupExpandIcons();
        touchSvc?.setupForHeaderGroup(this);
    }
    checkWarnings() {
        const paramsAny = this.params;
        if (paramsAny.template) $437b23f6a393c3bf$export$545083624300f13d(89);
    }
    workOutInnerHeaderGroupComponent(userCompFactory, params) {
        const userCompDetails = $437b23f6a393c3bf$var$_getInnerHeaderGroupCompDetails(userCompFactory, params, params);
        if (!userCompDetails) return;
        this.isLoadingInnerComponent = true;
        userCompDetails.newAgStackInstance().then((comp)=>{
            this.isLoadingInnerComponent = false;
            if (!comp) return;
            if (this.isAlive()) {
                this.innerHeaderGroupComponent = comp;
                this.agLabel.appendChild(comp.getGui());
            } else this.destroyBean(comp);
        });
    }
    setupExpandIcons() {
        const { agOpened: agOpened, agClosed: agClosed, params: { columnGroup: columnGroup }, beans: beans } = this;
        this.addInIcon("columnGroupOpened", agOpened);
        this.addInIcon("columnGroupClosed", agClosed);
        const expandAction = (event)=>{
            if ($437b23f6a393c3bf$export$9a48e23524c6d58(event)) return;
            const newExpandedValue = !columnGroup.isExpanded();
            beans.colGroupSvc.setColumnGroupOpened(columnGroup.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        };
        this.addTouchAndClickListeners(beans, agClosed, expandAction);
        this.addTouchAndClickListeners(beans, agOpened, expandAction);
        const stopPropagationAction = (event)=>{
            $437b23f6a393c3bf$export$456c40e80134d72a(event);
        };
        this.addManagedElementListeners(agClosed, {
            dblclick: stopPropagationAction
        });
        this.addManagedElementListeners(agOpened, {
            dblclick: stopPropagationAction
        });
        this.addManagedElementListeners(this.getGui(), {
            dblclick: expandAction
        });
        this.updateIconVisibility();
        const providedColumnGroup = columnGroup.getProvidedColumnGroup();
        const updateIcon = this.updateIconVisibility.bind(this);
        this.addManagedListeners(providedColumnGroup, {
            expandedChanged: updateIcon,
            expandableChanged: updateIcon
        });
    }
    addTouchAndClickListeners(beans, eElement, action) {
        beans.touchSvc?.setupForHeaderGroupElement(this, eElement, action);
        this.addManagedElementListeners(eElement, {
            click: action
        });
    }
    updateIconVisibility() {
        const { agOpened: agOpened, agClosed: agClosed, params: { columnGroup: columnGroup } } = this;
        if (columnGroup.isExpandable()) {
            const expanded = columnGroup.isExpanded();
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, expanded);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, !expanded);
        } else {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, false);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, false);
        }
    }
    addInIcon(iconName, element) {
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, null);
        if (eIcon) element.appendChild(eIcon);
    }
    addGroupExpandIcon(params) {
        if (!params.columnGroup.isExpandable()) {
            const { agOpened: agOpened, agClosed: agClosed } = this;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, false);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, false);
        }
    }
    setupLabel(params) {
        const { displayName: displayName, columnGroup: columnGroup } = params;
        const hasInnerComponent = this.innerHeaderGroupComponent || this.isLoadingInnerComponent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(displayName) && !hasInnerComponent) this.agLabel.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(displayName);
        this.toggleCss("ag-sticky-label", !columnGroup.getColGroupDef()?.suppressStickyLabel);
    }
    destroy() {
        super.destroy();
        if (this.innerHeaderGroupComponent) {
            this.destroyBean(this.innerHeaderGroupComponent);
            this.innerHeaderGroupComponent = void 0;
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/headerModule.ts
var $437b23f6a393c3bf$var$ColumnHeaderCompModule = {
    moduleName: "ColumnHeaderComp",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agColumnHeader: $437b23f6a393c3bf$export$266cd3930df0b35d
    },
    icons: {
        // button to launch legacy column menu
        menu: "menu",
        // button to launch new enterprise column menu
        menuAlt: "menu-alt"
    }
};
var $437b23f6a393c3bf$var$ColumnGroupHeaderCompModule = {
    moduleName: "ColumnGroupHeaderComp",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agColumnGroupHeader: $437b23f6a393c3bf$var$HeaderGroupComp
    },
    icons: {
        // header column group shown when expanded (click to contract)
        columnGroupOpened: "expanded",
        // header column group shown when contracted (click to expand)
        columnGroupClosed: "contracted"
    }
};
// packages/ag-grid-community/src/misc/animationFrameService.ts
var $437b23f6a393c3bf$var$AnimationFrameService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "animationFrameSvc";
        // p1 and p2 are create tasks are to do with row and cell creation.
        // for them we want to execute according to row order, so we use
        // TaskItem so we know what index the item is for.
        this.p1 = {
            list: [],
            sorted: false
        };
        // eg drawing back-ground of rows
        this.p2 = {
            list: [],
            sorted: false
        };
        // eg cell renderers, adding hover functionality
        this.f1 = {
            list: [],
            sorted: false
        };
        // eg framework cell renderers
        // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
        // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
        // important.
        this.destroyTasks = [];
        this.ticking = false;
        // we need to know direction of scroll, to build up rows in the direction of
        // the scroll. eg if user scrolls down, we extend the rows by building down.
        this.scrollGoingDown = true;
        this.lastScrollTop = 0;
        this.taskCount = 0;
    }
    setScrollTop(scrollTop) {
        this.scrollGoingDown = scrollTop >= this.lastScrollTop;
        if (scrollTop === 0) this.scrollGoingDown = true;
        this.lastScrollTop = scrollTop;
    }
    postConstruct() {
        this.active = !this.gos.get("suppressAnimationFrame");
        this.batchFrameworkComps = this.beans.frameworkOverrides.batchFrameworkComps;
    }
    // this method is for our AG Grid sanity only - if animation frames are turned off,
    // then no place in the code should be looking to add any work to be done in animation
    // frames. this stops bugs - where some code is asking for a frame to be executed
    // when it should not.
    verify() {
        if (this.active === false) $437b23f6a393c3bf$export$545083624300f13d(92);
    }
    createTask(task, index, list, isFramework, isDeferred = false) {
        this.verify();
        let taskList = list;
        if (isFramework && this.batchFrameworkComps) taskList = "f1";
        const taskItem = {
            task: task,
            index: index,
            createOrder: ++this.taskCount,
            deferred: isDeferred
        };
        this.addTaskToList(this[taskList], taskItem);
        this.schedule();
    }
    addTaskToList(taskList, task) {
        taskList.list.push(task);
        taskList.sorted = false;
    }
    sortTaskList(taskList) {
        if (taskList.sorted) return;
        const sortDirection = this.scrollGoingDown ? 1 : -1;
        taskList.list.sort((a, b)=>{
            if (a.deferred !== b.deferred) return a.deferred ? -1 : 1;
            if (a.index !== b.index) return sortDirection * (b.index - a.index);
            return b.createOrder - a.createOrder;
        });
        taskList.sorted = true;
    }
    addDestroyTask(task) {
        this.verify();
        this.destroyTasks.push(task);
        this.schedule();
    }
    executeFrame(millis) {
        const { p1: p1, p2: p2, f1: f1, destroyTasks: destroyTasks, beans: beans } = this;
        const { ctrlsSvc: ctrlsSvc, frameworkOverrides: frameworkOverrides } = beans;
        const p1Tasks = p1.list;
        const p2Tasks = p2.list;
        const f1Tasks = f1.list;
        const frameStart = Date.now();
        let duration = 0;
        const noMaxMillis = millis <= 0;
        const scrollFeature = ctrlsSvc.getScrollFeature();
        while(noMaxMillis || duration < millis){
            const gridBodyDidSomething = scrollFeature.scrollGridIfNeeded();
            if (!gridBodyDidSomething) {
                let task;
                if (p1Tasks.length) {
                    this.sortTaskList(p1);
                    task = p1Tasks.pop().task;
                } else if (p2Tasks.length) {
                    this.sortTaskList(p2);
                    task = p2Tasks.pop().task;
                } else if (f1Tasks.length) {
                    frameworkOverrides.wrapOutgoing(()=>{
                        while(noMaxMillis || duration < millis){
                            const gridBodyDidSomething2 = scrollFeature.scrollGridIfNeeded();
                            if (!gridBodyDidSomething2) {
                                if (f1Tasks.length) {
                                    this.sortTaskList(f1);
                                    task = f1Tasks.pop().task;
                                    task();
                                } else break;
                            } else break;
                            duration = Date.now() - frameStart;
                        }
                    });
                    task = ()=>{};
                } else if (destroyTasks.length) task = destroyTasks.pop();
                else break;
                task();
            }
            duration = Date.now() - frameStart;
        }
        if (p1Tasks.length || p2Tasks.length || f1Tasks.length || destroyTasks.length) this.requestFrame();
        else this.ticking = false;
    }
    flushAllFrames() {
        if (!this.active) return;
        this.executeFrame(-1);
    }
    schedule() {
        if (!this.active) return;
        if (!this.ticking) {
            this.ticking = true;
            this.requestFrame();
        }
    }
    requestFrame() {
        const callback = this.executeFrame.bind(this, 60);
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, callback);
    }
    isQueueEmpty() {
        return !this.ticking;
    }
};
// packages/ag-grid-community/src/misc/animationFrameModule.ts
var $437b23f6a393c3bf$var$AnimationFrameModule = {
    moduleName: "AnimationFrame",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AnimationFrameService
    ]
};
// packages/ag-grid-community/src/misc/iconService.ts
var $437b23f6a393c3bf$var$IconService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "iconSvc";
    }
    createIconNoSpan(iconName, params) {
        return $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, params?.column);
    }
};
// packages/ag-grid-community/src/misc/touchService.ts
var $437b23f6a393c3bf$var$TouchService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "touchSvc";
    }
    mockBodyContextMenu(ctrl, listener) {
        this.mockContextMenu(ctrl, ctrl.eBodyViewport, listener);
    }
    mockHeaderContextMenu(ctrl, listener) {
        this.mockContextMenu(ctrl, ctrl.eGui, listener);
    }
    mockRowContextMenu(ctrl) {
        if (!$437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        const listener = (mouseListener, touch, touchEvent)=>{
            const { rowCtrl: rowCtrl, cellCtrl: cellCtrl } = ctrl.getControlsForEventTarget(touchEvent?.target ?? null);
            if (cellCtrl?.column) cellCtrl.dispatchCellContextMenuEvent(touchEvent ?? null);
            this.beans.contextMenuSvc?.handleContextMenuMouseEvent(void 0, touchEvent, rowCtrl, cellCtrl);
        };
        this.mockContextMenu(ctrl, ctrl.element, listener);
    }
    handleCellDoubleClick(ctrl, mouseEvent) {
        const isDoubleClickOnIPad = ()=>{
            if (!$437b23f6a393c3bf$export$6b6034a68325bd8a() || $437b23f6a393c3bf$var$_isEventSupported("dblclick")) return false;
            const nowMillis = Date.now();
            const res = nowMillis - ctrl.lastIPadMouseClickEvent < 200;
            ctrl.lastIPadMouseClickEvent = nowMillis;
            return res;
        };
        if (isDoubleClickOnIPad()) {
            ctrl.onCellDoubleClicked(mouseEvent);
            mouseEvent.preventDefault();
            return true;
        }
        return false;
    }
    setupForHeader(comp) {
        const { gos: gos, sortSvc: sortSvc, menuSvc: menuSvc } = this.beans;
        if (gos.get("suppressTouch")) return;
        const { params: params, eMenu: eMenu, eFilterButton: eFilterButton } = comp;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(comp.getGui(), true);
        comp.addDestroyFunc(()=>touchListener.destroy());
        const suppressMenuHide = comp.shouldSuppressMenuHide();
        const tapMenuButton = suppressMenuHide && $437b23f6a393c3bf$export$25d27f17d3af40f7(eMenu) && params.enableMenu;
        let menuTouchListener = touchListener;
        if (tapMenuButton) {
            menuTouchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eMenu, true);
            comp.addDestroyFunc(()=>menuTouchListener.destroy());
        }
        if (params.enableMenu || menuSvc?.isHeaderContextMenuEnabled(params.column)) {
            const eventType = tapMenuButton ? "tap" : "longTap";
            const showMenuFn = (event)=>params.showColumnMenuAfterMouseClick(event.touchStart);
            comp.addManagedListeners(menuTouchListener, {
                [eventType]: showMenuFn
            });
            comp.addManagedListeners(touchListener, {
                longTap: showMenuFn
            });
        }
        if (params.enableSorting) {
            const tapListener = (event)=>{
                const target = event.touchStart.target;
                if (suppressMenuHide && (eMenu?.contains(target) || eFilterButton?.contains(target))) return;
                sortSvc?.progressSort(params.column, false, "uiColumnSorted");
            };
            comp.addManagedListeners(touchListener, {
                tap: tapListener
            });
        }
        if (params.enableFilterButton && eFilterButton) {
            const filterButtonTouchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eFilterButton, true);
            comp.addManagedListeners(filterButtonTouchListener, {
                tap: ()=>params.showFilter(eFilterButton)
            });
            comp.addDestroyFunc(()=>filterButtonTouchListener.destroy());
        }
    }
    setupForHeaderGroup(comp) {
        const params = comp.params;
        if (this.beans.menuSvc?.isHeaderContextMenuEnabled(params.columnGroup.getProvidedColumnGroup())) {
            const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(params.eGridHeader, true);
            const showMenuFn = (event)=>params.showColumnMenuAfterMouseClick(event.touchStart);
            comp.addManagedListeners(touchListener, {
                longTap: showMenuFn
            });
            comp.addDestroyFunc(()=>touchListener.destroy());
        }
    }
    setupForHeaderGroupElement(comp, eElement, action) {
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eElement, true);
        comp.addManagedListeners(touchListener, {
            tap: action
        });
        comp.addDestroyFunc(()=>touchListener.destroy());
    }
    mockContextMenu(ctrl, element, listener) {
        if (!$437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(element);
        const longTapListener = (event)=>{
            if (!$437b23f6a393c3bf$var$_isEventFromThisInstance(this.beans, event.touchEvent)) return;
            listener(void 0, event.touchStart, event.touchEvent);
        };
        ctrl.addManagedListeners(touchListener, {
            longTap: longTapListener
        });
        ctrl.addDestroyFunc(()=>touchListener.destroy());
    }
};
// packages/ag-grid-community/src/misc/touchModule.ts
var $437b23f6a393c3bf$var$TouchModule = {
    moduleName: "Touch",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TouchService
    ]
};
// packages/ag-grid-community/src/navigation/cellNavigationService.ts
var $437b23f6a393c3bf$var$CellNavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellNavigation";
    }
    wireBeans(beans) {
        this.rowSpanSvc = beans.rowSpanSvc;
    }
    // returns null if no cell to focus on, ie at the end of the grid
    getNextCellToFocus(key, focusedCell, ctrlPressed = false) {
        if (ctrlPressed) return this.getNextCellToFocusWithCtrlPressed(key, focusedCell);
        return this.getNextCellToFocusWithoutCtrlPressed(key, focusedCell);
    }
    getNextCellToFocusWithCtrlPressed(key, focusedCell) {
        const upKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP;
        const downKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        const leftKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT;
        let column;
        let rowIndex;
        const { pageBounds: pageBounds, gos: gos, visibleCols: visibleCols, pinnedRowModel: pinnedRowModel } = this.beans;
        const { rowPinned: rowPinned } = focusedCell;
        if (upKey || downKey) {
            if (rowPinned && pinnedRowModel) {
                if (upKey) rowIndex = 0;
                else rowIndex = rowPinned === "top" ? pinnedRowModel.getPinnedTopRowCount() - 1 : pinnedRowModel.getPinnedBottomRowCount() - 1;
            } else rowIndex = upKey ? pageBounds.getFirstRow() : pageBounds.getLastRow();
            column = focusedCell.column;
        } else {
            const isRtl = gos.get("enableRtl");
            rowIndex = focusedCell.rowIndex;
            const allColumns = leftKey !== isRtl ? visibleCols.allCols : [
                ...visibleCols.allCols
            ].reverse();
            column = allColumns.find((col)=>this.isCellGoodToFocusOn({
                    rowIndex: rowIndex,
                    rowPinned: null,
                    column: col
                }));
        }
        return column ? {
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column
        } : null;
    }
    getNextCellToFocusWithoutCtrlPressed(key, focusedCell) {
        let pointer = focusedCell;
        let finished = false;
        while(!finished){
            switch(key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                    pointer = this.getCellAbove(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                    pointer = this.getCellBelow(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                    pointer = this.gos.get("enableRtl") ? this.getCellToLeft(pointer) : this.getCellToRight(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                    pointer = this.gos.get("enableRtl") ? this.getCellToRight(pointer) : this.getCellToLeft(pointer);
                    break;
                default:
                    pointer = null;
                    $437b23f6a393c3bf$export$545083624300f13d(8, {
                        key: key
                    });
                    break;
            }
            if (pointer) finished = this.isCellGoodToFocusOn(pointer);
            else finished = true;
        }
        return pointer;
    }
    isCellGoodToFocusOn(gridCell) {
        const column = gridCell.column;
        let rowNode;
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        switch(gridCell.rowPinned){
            case "top":
                rowNode = pinnedRowModel?.getPinnedTopRow(gridCell.rowIndex);
                break;
            case "bottom":
                rowNode = pinnedRowModel?.getPinnedBottomRow(gridCell.rowIndex);
                break;
            default:
                rowNode = rowModel.getRow(gridCell.rowIndex);
                break;
        }
        if (!rowNode) return false;
        const suppressNavigable = this.isSuppressNavigable(column, rowNode);
        return !suppressNavigable;
    }
    getCellToLeft(lastCell) {
        if (!lastCell) return null;
        const colToLeft = this.beans.visibleCols.getColBefore(lastCell.column);
        if (!colToLeft) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToLeft,
            rowPinned: lastCell.rowPinned
        };
    }
    getCellToRight(lastCell) {
        if (!lastCell) return null;
        const colToRight = this.beans.visibleCols.getColAfter(lastCell.column);
        if (!colToRight) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToRight,
            rowPinned: lastCell.rowPinned
        };
    }
    getCellBelow(lastCell) {
        if (!lastCell) return null;
        const adjustedLastCell = this.rowSpanSvc?.getCellEnd(lastCell) ?? lastCell;
        const rowBelow = $437b23f6a393c3bf$export$3077f3bcabdc5ad1(this.beans, adjustedLastCell, true);
        if (rowBelow) return {
            rowIndex: rowBelow.rowIndex,
            column: lastCell.column,
            rowPinned: rowBelow.rowPinned
        };
        return null;
    }
    getCellAbove(lastCell) {
        if (!lastCell) return null;
        const adjustedLastCell = this.rowSpanSvc?.getCellStart(lastCell) ?? lastCell;
        const rowAbove = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, {
            rowIndex: adjustedLastCell.rowIndex,
            rowPinned: adjustedLastCell.rowPinned
        }, true);
        if (rowAbove) return {
            rowIndex: rowAbove.rowIndex,
            column: lastCell.column,
            rowPinned: rowAbove.rowPinned
        };
        return null;
    }
    getNextTabbedCell(gridCell, backwards) {
        if (backwards) return this.getNextTabbedCellBackwards(gridCell);
        return this.getNextTabbedCellForwards(gridCell);
    }
    getNextTabbedCellForwards(gridCell) {
        const { visibleCols: visibleCols, pagination: pagination } = this.beans;
        const displayedColumns = visibleCols.allCols;
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = visibleCols.getColAfter(gridCell.column);
        if (!newColumn) {
            newColumn = displayedColumns[0];
            const rowBelow = $437b23f6a393c3bf$export$3077f3bcabdc5ad1(this.beans, gridCell, true);
            if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowBelow)) return null;
            if (!rowBelow.rowPinned && !(pagination?.isRowInPage(rowBelow.rowIndex) ?? true)) return null;
            newRowIndex = rowBelow ? rowBelow.rowIndex : null;
            newFloating = rowBelow ? rowBelow.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
    getNextTabbedCellBackwards(gridCell) {
        const { beans: beans } = this;
        const { visibleCols: visibleCols, pagination: pagination } = beans;
        const displayedColumns = visibleCols.allCols;
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = visibleCols.getColBefore(gridCell.column);
        if (!newColumn) {
            newColumn = $437b23f6a393c3bf$export$236389741107357f(displayedColumns);
            const rowAbove = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(beans, {
                rowIndex: gridCell.rowIndex,
                rowPinned: gridCell.rowPinned
            }, true);
            if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowAbove)) return null;
            if (!rowAbove.rowPinned && !(pagination?.isRowInPage(rowAbove.rowIndex) ?? true)) return null;
            newRowIndex = rowAbove ? rowAbove.rowIndex : null;
            newFloating = rowAbove ? rowAbove.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
    isSuppressNavigable(column, rowNode) {
        const { suppressNavigable: suppressNavigable } = column.colDef;
        if (typeof suppressNavigable === "boolean") return suppressNavigable;
        if (typeof suppressNavigable === "function") {
            const params = column.createColumnFunctionCallbackParams(rowNode);
            const userFunc = suppressNavigable;
            return userFunc(params);
        }
        return false;
    }
};
// packages/ag-grid-community/src/navigation/navigationApi.ts
function $437b23f6a393c3bf$var$getFocusedCell(beans) {
    return beans.focusSvc.getFocusedCell();
}
function $437b23f6a393c3bf$var$clearFocusedCell(beans) {
    return beans.focusSvc.clearFocusedCell();
}
function $437b23f6a393c3bf$var$setFocusedCell(beans, rowIndex, colKey, rowPinned) {
    beans.focusSvc.setFocusedCell({
        rowIndex: rowIndex,
        column: colKey,
        rowPinned: rowPinned,
        forceBrowserFocus: true
    });
}
function $437b23f6a393c3bf$var$tabToNextCell(beans, event) {
    return beans.navigation?.tabToNextCell(false, event) ?? false;
}
function $437b23f6a393c3bf$var$tabToPreviousCell(beans, event) {
    return beans.navigation?.tabToNextCell(true, event) ?? false;
}
function $437b23f6a393c3bf$var$setFocusedHeader(beans, colKey, floatingFilter = false) {
    const headerPosition = beans.headerNavigation?.getHeaderPositionForColumn(colKey, floatingFilter);
    if (!headerPosition) return;
    beans.focusSvc.focusHeaderPosition({
        headerPosition: headerPosition
    });
}
// packages/ag-grid-community/src/edit/editModelService.ts
var $437b23f6a393c3bf$var$EditModelService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "editModelSvc";
        this.edits = /* @__PURE__ */ new Map();
        this.cellValidations = new $437b23f6a393c3bf$var$EditCellValidationModel();
        this.rowValidations = new $437b23f6a393c3bf$var$EditRowValidationModel();
        // during some operations, we want to always return false from `hasEdits`
        this.suspendEdits = false;
    }
    suspend(suspend) {
        this.suspendEdits = suspend;
    }
    removeEdits({ rowNode: rowNode, column: column }) {
        if (!this.hasEdits({
            rowNode: rowNode
        }) || !rowNode) return;
        const editRow = this.getEditRow(rowNode);
        if (column) editRow.delete(column);
        else editRow.clear();
        if (editRow.size === 0) this.edits.delete(rowNode);
    }
    getEditRow(rowNode, params = {}) {
        if (this.suspendEdits) return void 0;
        if (this.edits.size === 0) return void 0;
        const edits = rowNode && this.edits.get(rowNode);
        if (edits) return edits;
        if (params.checkSiblings) {
            const pinnedSibling = rowNode.pinnedSibling;
            if (pinnedSibling) return this.getEditRow(pinnedSibling);
        }
        return void 0;
    }
    getEditRowDataValue(rowNode, { checkSiblings: checkSiblings } = {}) {
        if (!rowNode || this.edits.size === 0) return void 0;
        const editRow = this.getEditRow(rowNode);
        const pinnedSibling = rowNode.pinnedSibling;
        const siblingRow = checkSiblings && pinnedSibling && this.getEditRow(pinnedSibling);
        if (!editRow && !siblingRow) return void 0;
        const data = Object.assign({}, rowNode.data);
        const applyEdits = (edits, data2)=>edits.forEach(({ pendingValue: pendingValue }, column)=>{
                if (pendingValue !== $437b23f6a393c3bf$var$UNEDITED) data2[column.getColId()] = pendingValue;
            });
        if (editRow) applyEdits(editRow, data);
        if (siblingRow) applyEdits(siblingRow, data);
        return data;
    }
    getEdit(position, copy) {
        const edit = this._getEdit(position);
        return copy && edit ? {
            ...edit
        } : edit;
    }
    _getEdit(position) {
        if (this.suspendEdits) return void 0;
        if (this.edits.size === 0) return void 0;
        return position.rowNode && position.column && this.getEditRow(position.rowNode)?.get(position.column);
    }
    getEditMap(copy = true) {
        if (this.suspendEdits || this.edits.size === 0) return /* @__PURE__ */ new Map();
        if (!copy) return this.edits;
        const map = /* @__PURE__ */ new Map();
        this.edits.forEach((editRow, rowNode)=>{
            const newEditRow = /* @__PURE__ */ new Map();
            editRow.forEach(({ editorState: _, ...cellData }, column)=>// Ensure we copy the cell data to avoid reference issues
                newEditRow.set(column, {
                    ...cellData
                }));
            map.set(rowNode, newEditRow);
        });
        return map;
    }
    setEditMap(newEdits) {
        this.edits.clear();
        newEdits.forEach((editRow, rowNode)=>{
            const newRow = /* @__PURE__ */ new Map();
            editRow.forEach((cellData, column)=>// Ensure we copy the cell data to avoid reference issues
                newRow.set(column, {
                    ...cellData
                }));
            this.edits.set(rowNode, newRow);
        });
    }
    setEdit(position, edit) {
        (this.edits.size === 0 || !this.edits.has(position.rowNode)) && this.edits.set(position.rowNode, /* @__PURE__ */ new Map());
        const currentEdit = this._getEdit(position);
        const updatedEdit = Object.assign({
            editorState: {
                isCancelAfterEnd: void 0,
                isCancelBeforeStart: void 0
            },
            ...currentEdit,
            ...edit
        });
        this.getEditRow(position.rowNode).set(position.column, updatedEdit);
        return updatedEdit;
    }
    clearEditValue(position) {
        const { rowNode: rowNode, column: column } = position;
        if (rowNode) {
            if (column) {
                const edit = this._getEdit(position);
                if (edit) {
                    edit.editorValue = void 0;
                    edit.pendingValue = edit.sourceValue;
                    edit.state = "changed";
                }
            } else this.getEditRow(rowNode)?.forEach((cellData)=>{
                cellData.editorValue = void 0;
                cellData.pendingValue = cellData.sourceValue;
                cellData.state = "changed";
            });
        }
    }
    getState(position) {
        if (this.suspendEdits) return void 0;
        return this.getEdit(position)?.state;
    }
    getEditPositions(editMap) {
        if (this.suspendEdits || (editMap ?? this.edits).size === 0) return [];
        const positions = [];
        (editMap ?? this.edits).forEach((editRow, rowNode)=>{
            for (const column of editRow.keys()){
                const { editorState: _, ...rest } = editRow.get(column);
                positions.push({
                    rowNode: rowNode,
                    column: column,
                    ...rest
                });
            }
        });
        return positions;
    }
    hasRowEdits(rowNode, params) {
        if (this.suspendEdits) return false;
        if (this.edits.size === 0) return false;
        const rowEdits = this.getEditRow(rowNode, params);
        return !!rowEdits;
    }
    hasEdits(position = {}, params = {}) {
        if (this.suspendEdits) return false;
        if (this.edits.size === 0) return false;
        const { rowNode: rowNode, column: column } = position;
        const { withOpenEditor: withOpenEditor } = params;
        if (rowNode) {
            const rowEdits = this.getEditRow(rowNode, params);
            if (!rowEdits) return false;
            if (column) {
                if (withOpenEditor) return this.getEdit(position)?.state === "editing";
                return rowEdits.has(column) ?? false;
            }
            if (rowEdits.size !== 0) {
                if (withOpenEditor) return Array.from(rowEdits.values()).some(({ state: state })=>state === "editing");
                return true;
            }
            return false;
        }
        if (withOpenEditor) return this.getEditPositions().some(({ state: state })=>state === "editing");
        return this.edits.size > 0;
    }
    start(position) {
        const map = this.getEditRow(position.rowNode) ?? /* @__PURE__ */ new Map();
        const { rowNode: rowNode, column: column } = position;
        if (column && !map.has(column)) map.set(column, {
            editorValue: void 0,
            pendingValue: $437b23f6a393c3bf$var$UNEDITED,
            sourceValue: this.beans.valueSvc.getValue(column, rowNode, false, "api"),
            state: "editing",
            editorState: {
                isCancelAfterEnd: void 0,
                isCancelBeforeStart: void 0
            }
        });
        this.edits.set(rowNode, map);
    }
    stop(position) {
        if (!this.hasEdits(position)) return;
        if (position) this.removeEdits(position);
        else this.clear();
    }
    clear() {
        for (const pendingRowEdits of this.edits.values())pendingRowEdits.clear();
        this.edits.clear();
    }
    getCellValidationModel() {
        return this.cellValidations;
    }
    getRowValidationModel() {
        return this.rowValidations;
    }
    setCellValidationModel(model) {
        this.cellValidations = model;
    }
    setRowValidationModel(model) {
        this.rowValidations = model;
    }
    destroy() {
        super.destroy();
        this.clear();
    }
};
var $437b23f6a393c3bf$var$EditCellValidationModel = class {
    constructor(){
        this.cellValidations = /* @__PURE__ */ new Map();
    }
    getCellValidation(position) {
        const { rowNode: rowNode, column: column } = position || {};
        return this.cellValidations?.get(rowNode)?.get(column);
    }
    hasCellValidation(position) {
        if (!position?.rowNode || !position.column) return this.cellValidations.size > 0;
        return !!this.getCellValidation(position);
    }
    setCellValidation(position, validation) {
        const { rowNode: rowNode, column: column } = position;
        if (!this.cellValidations.has(rowNode)) this.cellValidations.set(rowNode, /* @__PURE__ */ new Map());
        this.cellValidations.get(rowNode).set(column, validation);
    }
    clearCellValidation(position) {
        const { rowNode: rowNode, column: column } = position;
        this.cellValidations.get(rowNode)?.delete(column);
    }
    setCellValidationMap(validationMap) {
        this.cellValidations = validationMap;
    }
    getCellValidationMap() {
        return this.cellValidations;
    }
    clearCellValidationMap() {
        this.cellValidations.clear();
    }
};
var $437b23f6a393c3bf$var$EditRowValidationModel = class {
    constructor(){
        this.rowValidations = /* @__PURE__ */ new Map();
    }
    getRowValidation(position) {
        const { rowNode: rowNode } = position || {};
        return this.rowValidations.get(rowNode);
    }
    hasRowValidation(position) {
        if (!position?.rowNode) return this.rowValidations.size > 0;
        return !!this.getRowValidation(position);
    }
    setRowValidation({ rowNode: rowNode }, rowValidation) {
        this.rowValidations.set(rowNode, rowValidation);
    }
    clearRowValidation({ rowNode: rowNode }) {
        this.rowValidations.delete(rowNode);
    }
    setRowValidationMap(validationMap) {
        this.rowValidations = validationMap;
    }
    getRowValidationMap() {
        return this.rowValidations;
    }
    clearRowValidationMap() {
        this.rowValidations.clear();
    }
};
// packages/ag-grid-community/src/edit/utils/controllers.ts
function $437b23f6a393c3bf$var$_getRowCtrl(beans, inputs = {}) {
    const { rowIndex: rowIndex, rowId: rowId, rowCtrl: rowCtrl, rowPinned: rowPinned } = inputs;
    if (rowCtrl) return rowCtrl;
    const { rowModel: rowModel, rowRenderer: rowRenderer } = beans;
    let { rowNode: rowNode } = inputs;
    if (!rowNode) {
        if (rowId) rowNode = $437b23f6a393c3bf$var$_getRowById(beans, rowId, rowPinned);
        else if (rowIndex != null) rowNode = rowModel.getRow(rowIndex);
    }
    return rowRenderer.getRowCtrls(rowNode ? [
        rowNode
    ] : [])?.[0];
}
function $437b23f6a393c3bf$var$_getCellCtrl(beans, inputs = {}) {
    const { cellCtrl: cellCtrl, colId: colId, columnId: columnId, column: column } = inputs;
    if (cellCtrl) return cellCtrl;
    const actualColumn = beans.colModel.getCol(colId ?? columnId ?? $437b23f6a393c3bf$var$_getColId(column));
    const rowCtrl = inputs.rowCtrl ?? $437b23f6a393c3bf$var$_getRowCtrl(beans, inputs);
    const result = rowCtrl?.getCellCtrl(actualColumn) ?? void 0;
    if (result) return result;
    const rowNode = inputs.rowNode ?? rowCtrl?.rowNode;
    if (rowNode) return beans.rowRenderer.getCellCtrls([
        rowNode
    ], [
        actualColumn
    ])?.[0];
    return void 0;
}
function $437b23f6a393c3bf$var$_stopEditing(beans) {
    const { editSvc: editSvc } = beans;
    if (editSvc?.isBatchEditing()) $437b23f6a393c3bf$var$_destroyEditors(beans);
    else editSvc?.stopEditing(void 0, {
        source: "api"
    });
}
function $437b23f6a393c3bf$var$_addStopEditingWhenGridLosesFocus(bean, beans, viewports) {
    const { gos: gos, popupSvc: popupSvc } = beans;
    if (!gos.get("stopEditingWhenCellsLoseFocus")) return;
    const focusOutListener = (event)=>{
        const elementWithFocus = event.relatedTarget;
        if ($437b23f6a393c3bf$var$_getTabIndex(elementWithFocus) === null) {
            $437b23f6a393c3bf$var$_stopEditing(beans);
            return;
        }
        let clickInsideGrid = // see if click came from inside the viewports
        viewports.some((viewport)=>viewport.contains(elementWithFocus)) && // and also that it's not from a detail grid
        gos.isElementInThisInstance(elementWithFocus);
        if (!clickInsideGrid) clickInsideGrid = !!popupSvc && (popupSvc.getActivePopups().some((popup)=>popup.contains(elementWithFocus)) || popupSvc.isElementWithinCustomPopup(elementWithFocus));
        if (!clickInsideGrid) $437b23f6a393c3bf$var$_stopEditing(beans);
    };
    for (const viewport of viewports)bean.addManagedElementListeners(viewport, {
        focusout: focusOutListener
    });
}
function $437b23f6a393c3bf$var$_getColId(column) {
    if (!column) return void 0;
    if (typeof column === "string") return column;
    return column.getColId();
}
// packages/ag-grid-community/src/edit/utils/editors.ts
var $437b23f6a393c3bf$var$UNEDITED = Symbol("unedited");
function $437b23f6a393c3bf$var$getCellEditorInstanceMap(beans, params = {}) {
    const res = [];
    const ctrls = beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns);
    for (const ctrl of ctrls){
        const cellEditor = ctrl.comp?.getCellEditor();
        if (cellEditor) res.push({
            ctrl: ctrl,
            editor: $437b23f6a393c3bf$export$213d4c63c3df47e4(cellEditor)
        });
    }
    return res;
}
var $437b23f6a393c3bf$var$getCellEditorInstances = (beans, params = {})=>$437b23f6a393c3bf$var$getCellEditorInstanceMap(beans, params).map((res)=>res.editor);
function $437b23f6a393c3bf$var$_setupEditors(beans, editingCells, position, key, event, cellStartedEdit) {
    if (editingCells.length === 0 && position?.rowNode && position?.column) $437b23f6a393c3bf$var$_setupEditor(beans, position, {
        key: key,
        event: event,
        cellStartedEdit: cellStartedEdit
    });
    const { valueSvc: valueSvc, editSvc: editSvc, editModelSvc: editModelSvc } = beans;
    const { rowNode: rowNode, column: column } = position ?? {};
    for (const cellPosition of editingCells){
        const { rowNode: cellRowNode, column: cellColumn } = cellPosition;
        const curCellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, cellPosition);
        if (!curCellCtrl) {
            if (cellRowNode && cellColumn) {
                const oldValue = valueSvc.getValue(cellColumn, cellRowNode, void 0, "api");
                const isNewValueCell = position?.rowNode === cellRowNode && position?.column === cellColumn;
                const cellStartValue = isNewValueCell && key || void 0;
                const newValue = cellStartValue ?? editSvc?.getCellDataValue(cellPosition, false) ?? valueSvc.getValueForDisplay(cellColumn, cellRowNode)?.value ?? oldValue ?? $437b23f6a393c3bf$var$UNEDITED;
                editModelSvc?.setEdit(cellPosition, {
                    pendingValue: newValue,
                    sourceValue: oldValue,
                    state: "editing"
                });
            }
            continue;
        }
        const shouldStartEditing2 = cellStartedEdit && rowNode === curCellCtrl.rowNode && curCellCtrl.column === column;
        $437b23f6a393c3bf$var$_setupEditor(beans, {
            rowNode: rowNode,
            column: curCellCtrl.column
        }, {
            key: shouldStartEditing2 ? key : null,
            event: shouldStartEditing2 ? event : null,
            cellStartedEdit: shouldStartEditing2 && cellStartedEdit
        });
    }
}
function $437b23f6a393c3bf$var$_sourceAndPendingDiffer({ pendingValue: pendingValue, sourceValue: sourceValue }) {
    if (pendingValue === $437b23f6a393c3bf$var$UNEDITED) pendingValue = sourceValue;
    return pendingValue !== sourceValue;
}
function $437b23f6a393c3bf$var$_setupEditor(beans, position, params) {
    const enableGroupEditing = beans.gos.get("enableGroupEdit");
    const { key: key, event: event, cellStartedEdit: cellStartedEdit, silent: silent } = params ?? {};
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
    const editorComp = cellCtrl?.comp?.getCellEditor();
    const editorParams = $437b23f6a393c3bf$var$_createEditorParams(beans, position, key, cellStartedEdit && !silent);
    const previousEdit = beans.editModelSvc?.getEdit(position);
    let newValue = editorParams.value;
    if (newValue === void 0) newValue = previousEdit?.sourceValue;
    beans.editModelSvc?.setEdit(position, {
        editorValue: newValue,
        state: "editing"
    });
    if (editorComp) {
        editorComp.refresh?.(editorParams);
        return;
    }
    const colDef = position.column.getColDef();
    const compDetails = $437b23f6a393c3bf$var$_getCellEditorDetails(beans.userCompFactory, colDef, editorParams);
    const popup = compDetails?.popupFromSelector != null ? compDetails.popupFromSelector : !!colDef.cellEditorPopup;
    const popupLocation = compDetails?.popupPositionFromSelector != null ? compDetails.popupPositionFromSelector : colDef.cellEditorPopupPosition;
    $437b23f6a393c3bf$var$checkAndPreventDefault(compDetails.params, event);
    if (cellCtrl) {
        cellCtrl.editCompDetails = compDetails;
        cellCtrl.onEditorAttachedFuncs.push(()=>cellCtrl.rangeFeature?.unsetComp());
        cellCtrl.comp?.setEditDetails(compDetails, popup, popupLocation, beans.gos.get("reactiveCustomComponents"));
        cellCtrl?.rowCtrl?.refreshRow({
            suppressFlash: true
        });
        const edit = beans.editModelSvc?.getEdit(position, true);
        if (!silent && !edit?.editorState?.cellStartedEditing) {
            beans.editSvc?.dispatchCellEvent(position, event, "cellEditingStarted", enableGroupEditing ? {
                value: newValue
            } : {});
            beans.editModelSvc?.setEdit(position, {
                editorState: {
                    cellStartedEditing: true
                }
            });
        }
    }
}
function $437b23f6a393c3bf$var$_valueFromEditor(beans, cellEditor, params) {
    const noValueResult = {
        editorValueExists: false
    };
    if ($437b23f6a393c3bf$var$_hasValidationRules(beans)) {
        const validationErrors = cellEditor.getValidationErrors?.();
        if ((validationErrors?.length ?? 0) > 0) return noValueResult;
    }
    if (params?.isCancelling) return noValueResult;
    if (params?.isStopping) {
        const isCancelAfterEnd = cellEditor?.isCancelAfterEnd?.();
        if (isCancelAfterEnd) return {
            ...noValueResult,
            isCancelAfterEnd: isCancelAfterEnd
        };
    }
    const editorValue = cellEditor.getValue();
    return {
        editorValue: editorValue,
        editorValueExists: true
    };
}
function $437b23f6a393c3bf$var$_createEditorParams(beans, position, key, cellStartedEdit) {
    const { valueSvc: valueSvc, gos: gos, editSvc: editSvc } = beans;
    const enableGroupEditing = beans.gos.get("enableGroupEdit");
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
    const rowIndex = position.rowNode?.rowIndex ?? void 0;
    const batchEdit = editSvc?.isBatchEditing();
    const agColumn = beans.colModel.getCol(position.column.getId());
    const { rowNode: rowNode, column: column } = position;
    const editor = cellCtrl.comp?.getCellEditor();
    const cellDataValue = editSvc?.getCellDataValue(position, false);
    const initialNewValue = cellDataValue === void 0 ? editor ? $437b23f6a393c3bf$var$_valueFromEditor(beans, editor)?.editorValue : void 0 : cellDataValue;
    const value = initialNewValue === $437b23f6a393c3bf$var$UNEDITED ? valueSvc.getValueForDisplay(agColumn, rowNode)?.value : initialNewValue;
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        value: enableGroupEditing ? initialNewValue : value,
        eventKey: key ?? null,
        column: column,
        colDef: column.getColDef(),
        rowIndex: rowIndex,
        node: rowNode,
        data: rowNode.data,
        cellStartedEdit: cellStartedEdit ?? false,
        onKeyDown: cellCtrl?.onKeyDown.bind(cellCtrl),
        stopEditing: (suppressNavigateAfterEdit)=>{
            editSvc.stopEditing(position, {
                source: batchEdit ? "ui" : "api",
                suppressNavigateAfterEdit: suppressNavigateAfterEdit
            });
            $437b23f6a393c3bf$var$_destroyEditor(beans, position);
        },
        eGridCell: cellCtrl?.eGui,
        parseValue: (newValue)=>valueSvc.parseValue(agColumn, rowNode, newValue, cellCtrl?.value),
        formatValue: cellCtrl?.formatValue.bind(cellCtrl),
        validate: ()=>{
            editSvc?.validateEdit();
        }
    });
}
function $437b23f6a393c3bf$var$_purgeUnchangedEdits(beans, includeEditing) {
    const { editModelSvc: editModelSvc } = beans;
    editModelSvc?.getEditMap().forEach((editRow, rowNode)=>{
        editRow.forEach((edit, column)=>{
            if (!includeEditing && (edit.state === "editing" || edit.pendingValue === $437b23f6a393c3bf$var$UNEDITED)) return;
            if (!$437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit) && (edit.state !== "editing" || includeEditing)) editModelSvc?.removeEdits({
                rowNode: rowNode,
                column: column
            });
        });
    });
}
function $437b23f6a393c3bf$var$_refreshEditorOnColDefChanged(beans, cellCtrl) {
    const editor = cellCtrl.comp?.getCellEditor();
    if (!editor?.refresh) return;
    const { eventKey: eventKey, cellStartedEdit: cellStartedEdit } = cellCtrl.editCompDetails.params;
    const { column: column } = cellCtrl;
    const editorParams = $437b23f6a393c3bf$var$_createEditorParams(beans, cellCtrl, eventKey, cellStartedEdit);
    const colDef = column.getColDef();
    const compDetails = $437b23f6a393c3bf$var$_getCellEditorDetails(beans.userCompFactory, colDef, editorParams);
    editor.refresh($437b23f6a393c3bf$var$checkAndPreventDefault(compDetails.params, eventKey));
}
function $437b23f6a393c3bf$var$checkAndPreventDefault(params, event) {
    if (event instanceof KeyboardEvent && params.column.getColDef().cellEditor === "agNumberCellEditor") params.suppressPreventDefault = [
        "-",
        "+",
        ".",
        "e"
    ].includes(event?.key ?? "") || params.suppressPreventDefault;
    else event?.preventDefault?.();
    return params;
}
function $437b23f6a393c3bf$var$_syncFromEditors(beans, params) {
    for (const cellId of beans.editModelSvc?.getEditPositions() ?? []){
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, cellId);
        if (!cellCtrl) continue;
        const editor = cellCtrl.comp?.getCellEditor();
        if (!editor) continue;
        const { editorValue: editorValue, editorValueExists: editorValueExists, isCancelAfterEnd: isCancelAfterEnd } = $437b23f6a393c3bf$var$_valueFromEditor(beans, editor, params);
        if (isCancelAfterEnd) beans.editModelSvc?.setEdit(cellId, {
            editorState: {
                isCancelAfterEnd: isCancelAfterEnd
            }
        });
        $437b23f6a393c3bf$var$_syncFromEditor(beans, cellId, editorValue, void 0, !editorValueExists, params);
    }
}
function $437b23f6a393c3bf$var$_syncFromEditor(beans, position, editorValue, _source, valueSameAsSource, params) {
    const { editModelSvc: editModelSvc, valueSvc: valueSvc } = beans;
    if (!editModelSvc) return;
    const { rowNode: rowNode, column: column } = position;
    if (!(rowNode && column)) return;
    let edit = editModelSvc.getEdit(position, true);
    if (!edit?.sourceValue) edit = editModelSvc.setEdit(position, {
        sourceValue: valueSvc.getValue(column, rowNode, void 0, "api"),
        pendingValue: edit ? edit.editorValue : $437b23f6a393c3bf$var$UNEDITED
    });
    editModelSvc.setEdit(position, {
        editorValue: valueSameAsSource ? edit.sourceValue : editorValue
    });
    if (params?.persist) $437b23f6a393c3bf$var$_persistEditorValue(beans, position);
}
function $437b23f6a393c3bf$var$_persistEditorValue(beans, position) {
    const { editModelSvc: editModelSvc } = beans;
    const edit = editModelSvc?.getEdit(position, true);
    editModelSvc?.setEdit(position, {
        pendingValue: edit?.editorValue
    });
}
function $437b23f6a393c3bf$var$_destroyEditors(beans, edits, params) {
    if (!edits) edits = beans.editModelSvc?.getEditPositions();
    for (const cellPosition of edits ?? [])$437b23f6a393c3bf$var$_destroyEditor(beans, cellPosition, params);
}
function $437b23f6a393c3bf$var$_destroyEditor(beans, position, params) {
    const enableGroupEditing = beans.gos.get("enableGroupEdit");
    const { editModelSvc: editModelSvc } = beans;
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
    const edit = editModelSvc?.getEdit(position, true);
    if (!cellCtrl) {
        if (edit) editModelSvc?.setEdit(position, {
            state: "changed"
        });
        return;
    }
    const { comp: comp } = cellCtrl;
    if (comp && !comp.getCellEditor()) {
        cellCtrl?.refreshCell();
        if (edit) {
            editModelSvc?.setEdit(position, {
                state: "changed"
            });
            const args = enableGroupEditing ? $437b23f6a393c3bf$var$groupEditOverrides(params, edit) : {
                valueChanged: false,
                newValue: void 0,
                oldValue: edit.sourceValue
            };
            $437b23f6a393c3bf$var$dispatchEditingStopped(beans, position, args, params);
        }
        return;
    }
    if ($437b23f6a393c3bf$var$_hasValidationRules(beans)) {
        const errorMessages = comp?.getCellEditor()?.getValidationErrors?.();
        const cellValidationModel = editModelSvc?.getCellValidationModel();
        if (errorMessages?.length) cellValidationModel?.setCellValidation(position, {
            errorMessages: errorMessages
        });
        else cellValidationModel?.clearCellValidation(position);
    }
    editModelSvc?.setEdit(position, {
        state: "changed"
    });
    comp?.setEditDetails();
    comp?.refreshEditStyles(false, false);
    cellCtrl?.refreshCell({
        force: true,
        suppressFlash: true
    });
    const latest = editModelSvc?.getEdit(position);
    if (latest && latest.state === "changed") {
        const args = enableGroupEditing ? $437b23f6a393c3bf$var$groupEditOverrides(params, latest) : {
            valueChanged: $437b23f6a393c3bf$var$_sourceAndPendingDiffer(latest) && !params?.cancel,
            newValue: params?.cancel || latest.editorState.isCancelAfterEnd ? void 0 : latest?.editorValue ?? edit?.pendingValue,
            oldValue: latest?.sourceValue
        };
        $437b23f6a393c3bf$var$dispatchEditingStopped(beans, position, args, params);
    }
}
function $437b23f6a393c3bf$var$groupEditOverrides(params, latest) {
    return params?.cancel ? {
        valueChanged: false,
        oldValue: latest.sourceValue,
        newValue: void 0,
        value: latest.sourceValue
    } : {
        valueChanged: false,
        oldValue: latest.sourceValue,
        newValue: latest.pendingValue,
        value: latest.sourceValue
    };
}
function $437b23f6a393c3bf$var$dispatchEditingStopped(beans, position, args, { silent: silent, event: event } = {}) {
    const { editSvc: editSvc, editModelSvc: editModelSvc } = beans;
    const latest = editModelSvc?.getEdit(position);
    const { editorState: editorState } = latest || {};
    const { isCancelBeforeStart: isCancelBeforeStart } = editorState || {};
    if (!silent && !isCancelBeforeStart) {
        editSvc?.dispatchCellEvent(position, event, "cellEditingStopped", args);
        editModelSvc?.setEdit(position, {
            editorState: {
                cellStoppedEditing: true
            }
        });
    }
}
function $437b23f6a393c3bf$var$_hasValidationRules(beans) {
    const { gos: gos, colModel: colModel } = beans;
    const getFullRowEditValidationErrors = !!gos.get("getFullRowEditValidationErrors");
    const columnsHaveRules = colModel.getColumnDefs()?.filter((c)=>c.editable).some(({ cellEditorParams: cellEditorParams })=>{
        const { minLength: minLength, maxLength: maxLength, getValidationErrors: getValidationErrors, min: min, max: max } = cellEditorParams || {};
        return minLength !== void 0 || maxLength !== void 0 || getValidationErrors !== void 0 || min !== void 0 || max !== void 0;
    });
    const editorsHaveRules = beans.gridApi.getCellEditorInstances().some((editor)=>editor.getValidationElement || editor.getValidationErrors);
    return columnsHaveRules || getFullRowEditValidationErrors || editorsHaveRules;
}
function $437b23f6a393c3bf$var$_populateModelValidationErrors(beans, force) {
    if (!(force || $437b23f6a393c3bf$var$_hasValidationRules(beans))) return;
    const mappedEditors = $437b23f6a393c3bf$var$getCellEditorInstanceMap(beans);
    const cellValidationModel = new $437b23f6a393c3bf$var$EditCellValidationModel();
    const { ariaAnnounce: ariaAnnounce, localeSvc: localeSvc, editModelSvc: editModelSvc, gos: gos } = beans;
    const includeRows = gos.get("editType") === "fullRow";
    const translate = $437b23f6a393c3bf$export$cc0bf4adff5b95e7(localeSvc);
    const ariaValidationErrorPrefix = translate("ariaValidationErrorPrefix", "Cell Editor Validation");
    for (const mappedEditor of mappedEditors){
        const { ctrl: ctrl, editor: editor } = mappedEditor;
        const { rowNode: rowNode, column: column } = ctrl;
        const errorMessages = editor.getValidationErrors?.() ?? [];
        const el = editor.getValidationElement?.(false) || !editor.isPopup?.() && ctrl.eGui;
        if (el) {
            const isInvalid = errorMessages != null && errorMessages.length > 0;
            const invalidMessage = isInvalid ? errorMessages.join(". ") : "";
            $437b23f6a393c3bf$export$fd1450327e6900f2(el, isInvalid);
            if (isInvalid) ariaAnnounce.announceValue(`${ariaValidationErrorPrefix} ${errorMessages}`, "editorValidation");
            if (el instanceof HTMLInputElement) el.setCustomValidity(invalidMessage);
            else el.classList.toggle("invalid", isInvalid);
        }
        if (errorMessages?.length > 0) cellValidationModel.setCellValidation({
            rowNode: rowNode,
            column: column
        }, {
            errorMessages: errorMessages
        });
    }
    $437b23f6a393c3bf$var$_syncFromEditors(beans, {
        persist: false
    });
    editModelSvc?.setCellValidationModel(cellValidationModel);
    const rowCtrlSet = /* @__PURE__ */ new Set();
    for (const { ctrl: ctrl } of mappedEditors)rowCtrlSet.add(ctrl.rowCtrl);
    if (includeRows) {
        const rowValidations = $437b23f6a393c3bf$var$_generateRowValidationErrors(beans);
        editModelSvc?.setRowValidationModel(rowValidations);
    }
    for (const rowCtrl of rowCtrlSet.values()){
        rowCtrl.rowEditStyleFeature?.applyRowStyles();
        for (const cellCtrl of rowCtrl.getAllCellCtrls()){
            cellCtrl.tooltipFeature?.refreshTooltip(true);
            cellCtrl.editorTooltipFeature?.refreshTooltip(true);
            cellCtrl.editStyleFeature?.applyCellStyles?.();
        }
    }
}
var $437b23f6a393c3bf$var$_generateRowValidationErrors = (beans)=>{
    const rowValidationModel = new $437b23f6a393c3bf$var$EditRowValidationModel();
    const getFullRowEditValidationErrors = beans.gos.get("getFullRowEditValidationErrors");
    const editMap = beans.editModelSvc?.getEditMap();
    if (!editMap) return rowValidationModel;
    for (const rowNode of editMap.keys()){
        const rowEditMap = editMap.get(rowNode);
        if (!rowEditMap) continue;
        const editorsState = [];
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode;
        for (const column of rowEditMap.keys()){
            const editValue = rowEditMap.get(column);
            if (!editValue) continue;
            const { editorValue: editorValue, pendingValue: pendingValue, sourceValue: sourceValue } = editValue;
            const newValue = editorValue ?? (pendingValue === $437b23f6a393c3bf$var$UNEDITED ? void 0 : pendingValue) ?? sourceValue;
            editorsState.push({
                column: column,
                colId: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                oldValue: sourceValue,
                newValue: newValue
            });
        }
        const errorMessages = getFullRowEditValidationErrors?.({
            editorsState: editorsState
        }) ?? [];
        if (errorMessages.length > 0) rowValidationModel.setRowValidation({
            rowNode: rowNode
        }, {
            errorMessages: errorMessages
        });
    }
    return rowValidationModel;
};
function $437b23f6a393c3bf$var$_validateEdit(beans) {
    $437b23f6a393c3bf$var$_populateModelValidationErrors(beans, true);
    const map = beans.editModelSvc?.getCellValidationModel().getCellValidationMap();
    if (!map) return null;
    const validations = [];
    map.forEach((rowValidations, rowNode)=>{
        rowValidations.forEach(({ errorMessages: errorMessages }, column)=>{
            validations.push({
                column: column,
                rowIndex: rowNode.rowIndex,
                rowPinned: rowNode.rowPinned,
                messages: errorMessages ?? null
            });
        });
    });
    return validations;
}
// packages/ag-grid-community/src/rendering/cell/cellEvent.ts
function $437b23f6a393c3bf$var$_createCellEvent(beans, domEvent, eventType, { rowNode: rowNode, column: column }, value) {
    const event = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
        type: eventType,
        node: rowNode,
        data: rowNode.data,
        value: value,
        column: column,
        colDef: column.getColDef(),
        rowPinned: rowNode.rowPinned,
        event: domEvent,
        rowIndex: rowNode.rowIndex
    });
    return event;
}
// packages/ag-grid-community/src/rendering/cell/cellKeyboardListenerFeature.ts
function $437b23f6a393c3bf$var$_isDeleteKey(key, alwaysReturnFalseOnBackspace = false) {
    if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) return true;
    if (!alwaysReturnFalseOnBackspace && key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE) return $437b23f6a393c3bf$var$_isMacOsUserAgent();
    return false;
}
var $437b23f6a393c3bf$var$CellKeyboardListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans, rowNode, rowCtrl){
        super();
        this.cellCtrl = cellCtrl;
        this.rowNode = rowNode;
        this.rowCtrl = rowCtrl;
        this.beans = beans;
    }
    init() {
        this.eGui = this.cellCtrl.eGui;
    }
    onKeyDown(event) {
        const key = event.key;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                this.onEnterKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2:
                this.onF2KeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                this.onEscapeKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                this.onTabKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE:
                this.onBackspaceOrDeleteKeyDown(key, event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                this.onNavigationKeyDown(event, key);
                break;
        }
    }
    onNavigationKeyDown(event, key) {
        const { cellCtrl: cellCtrl, beans: beans } = this;
        if (beans.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        if (event.shiftKey && cellCtrl.isRangeSelectionEnabled()) this.onShiftRangeSelect(event);
        else {
            const currentCellPosition = cellCtrl.getFocusedCellPosition();
            beans.navigation?.navigateToNextCell(event, key, currentCellPosition, true);
        }
        event.preventDefault();
    }
    onShiftRangeSelect(event) {
        const { rangeSvc: rangeSvc, navigation: navigation } = this.beans;
        if (!rangeSvc) return;
        const endCell = rangeSvc.extendLatestRangeInDirection(event);
        if (!endCell) return;
        if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT) navigation?.ensureColumnVisible(endCell.column);
        else navigation?.ensureRowVisible(endCell.rowIndex);
    }
    onTabKeyDown(event) {
        this.beans.navigation?.onTabKeyDown(this.cellCtrl, event);
    }
    onBackspaceOrDeleteKeyDown(key, event) {
        const { cellCtrl: cellCtrl, beans: beans, rowNode: rowNode } = this;
        const { gos: gos, rangeSvc: rangeSvc, eventSvc: eventSvc, editSvc: editSvc } = beans;
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellStart"
        });
        if ($437b23f6a393c3bf$var$_isDeleteKey(key, gos.get("enableCellEditingOnBackspace")) && !editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) {
            if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos)) rangeSvc.clearCellRangeCellValues({
                dispatchWrapperEvents: true,
                wrapperEventSource: "deleteKey"
            });
            else if (cellCtrl.isCellEditable()) {
                const { column: column } = cellCtrl;
                const emptyValue = this.beans.valueSvc.getDeleteValue(column, rowNode);
                rowNode.setDataValue(column, emptyValue, "cellClear");
            }
        } else if (!editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) beans.editSvc?.startEditing(cellCtrl, {
            startedEdit: true,
            event: event
        });
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellEnd"
        });
    }
    onEnterKeyDown(event) {
        const { cellCtrl: cellCtrl, beans: beans } = this;
        const { editSvc: editSvc, navigation: navigation } = beans;
        const cellEditing = editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        });
        const rowNode = cellCtrl.rowNode;
        const rowEditing = editSvc?.isRowEditing(rowNode, {
            withOpenEditor: true
        });
        const startEditingAction = (cellCtrl2)=>{
            const started = editSvc?.startEditing(cellCtrl2, {
                startedEdit: true,
                event: event,
                source: "edit"
            });
            if (started) event.preventDefault();
        };
        if (cellEditing || rowEditing) {
            if (this.isCtrlEnter(event)) {
                editSvc?.applyBulkEdit(cellCtrl, beans?.rangeSvc?.getCellRanges() || []);
                return;
            }
            $437b23f6a393c3bf$var$_populateModelValidationErrors(beans);
            if (editSvc?.checkNavWithValidation(void 0, event) === "block-stop") return;
            if (editSvc?.isEditing(cellCtrl, {
                withOpenEditor: true
            })) editSvc?.stopEditing(cellCtrl, {
                event: event,
                source: "edit"
            });
            else if (rowEditing && !cellCtrl.isCellEditable()) editSvc?.stopEditing({
                rowNode: rowNode
            }, {
                event: event,
                source: "edit"
            });
            else startEditingAction(cellCtrl);
        } else if (beans.gos.get("enterNavigatesVertically")) {
            const key = event.shiftKey ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP : $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
            navigation?.navigateToNextCell(null, key, cellCtrl.cellPosition, false);
        } else {
            if (editSvc?.hasValidationErrors()) return;
            if (editSvc?.hasValidationErrors(cellCtrl)) editSvc.revertSingleCellEdit(cellCtrl, true);
            startEditingAction(cellCtrl);
        }
    }
    isCtrlEnter(e) {
        return (e.ctrlKey || e.metaKey) && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
    }
    onF2KeyDown(event) {
        const { cellCtrl: cellCtrl, beans: { editSvc: editSvc } } = this;
        const editing = editSvc?.isEditing();
        if (editing) {
            $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
            if (editSvc?.checkNavWithValidation(void 0, event) === "block-stop") return;
        }
        editSvc?.startEditing(cellCtrl, {
            startedEdit: true,
            event: event
        });
    }
    onEscapeKeyDown(event) {
        const { cellCtrl: cellCtrl, beans: { editSvc: editSvc } } = this;
        if (editSvc?.checkNavWithValidation(cellCtrl, event) === "block-stop") editSvc.revertSingleCellEdit(cellCtrl);
        editSvc?.stopEditing(cellCtrl, {
            event: event,
            cancel: true
        });
    }
    processCharacter(event) {
        const eventTarget = event.target;
        const eventOnChildComponent = eventTarget !== this.eGui;
        const { beans: { editSvc: editSvc }, cellCtrl: cellCtrl } = this;
        if (eventOnChildComponent) return;
        if (editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        const key = event.key;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) this.onSpaceKeyDown(event);
        else if (editSvc?.isCellEditable(cellCtrl, "ui")) {
            if (editSvc?.hasValidationErrors() && !editSvc?.hasValidationErrors(cellCtrl)) return;
            editSvc?.startEditing(cellCtrl, {
                startedEdit: true,
                event: event,
                source: "api"
            });
            const compDetails = cellCtrl.editCompDetails;
            const shouldPreventDefault = !compDetails?.params?.suppressPreventDefault;
            if (shouldPreventDefault) event.preventDefault();
        }
    }
    onSpaceKeyDown(event) {
        const { gos: gos, editSvc: editSvc } = this.beans;
        const { rowNode: rowNode } = this.cellCtrl;
        if (!editSvc?.isEditing(this.cellCtrl, {
            withOpenEditor: true
        }) && $437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) this.beans.selectionSvc?.handleSelectionEvent(event, rowNode, "spaceKey");
        event.preventDefault();
    }
};
// packages/ag-grid-community/src/rendering/cell/cellMouseListenerFeature.ts
var $437b23f6a393c3bf$var$CellMouseListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans, column){
        super();
        this.cellCtrl = cellCtrl;
        this.column = column;
        this.beans = beans;
    }
    onMouseEvent(eventName, mouseEvent) {
        if ($437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        switch(eventName){
            case "click":
                this.onCellClicked(mouseEvent);
                break;
            case "mousedown":
            case "touchstart":
                this.onMouseDown(mouseEvent);
                break;
            case "dblclick":
                this.onCellDoubleClicked(mouseEvent);
                break;
            case "mouseout":
                this.onMouseOut(mouseEvent);
                break;
            case "mouseover":
                this.onMouseOver(mouseEvent);
                break;
        }
    }
    onCellClicked(event) {
        if (this.beans.touchSvc?.handleCellDoubleClick(this, event)) return;
        const { eventSvc: eventSvc, rangeSvc: rangeSvc, editSvc: editSvc, editModelSvc: editModelSvc, frameworkOverrides: frameworkOverrides, gos: gos } = this.beans;
        const isMultiKey = event.ctrlKey || event.metaKey;
        const { cellCtrl: cellCtrl } = this;
        const { column: column, cellPosition: cellPosition, rowNode: rowNode } = cellCtrl;
        const suppressMouseEvent2 = $437b23f6a393c3bf$export$d7866551eadae1d3(gos, column, rowNode, event);
        if (rangeSvc && isMultiKey && !suppressMouseEvent2) {
            if (rangeSvc.getCellRangeCount(cellPosition) > 1) rangeSvc.intersectLastRange(true);
        }
        const cellClickedEvent = cellCtrl.createEvent(event, "cellClicked");
        cellClickedEvent.isEventHandlingSuppressed = suppressMouseEvent2;
        eventSvc.dispatchEvent(cellClickedEvent);
        const colDef = column.getColDef();
        if (colDef.onCellClicked) window.setTimeout(()=>{
            frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellClicked(cellClickedEvent);
            });
        }, 0);
        if (suppressMouseEvent2) return;
        if (editModelSvc?.getState(cellCtrl) !== "editing") {
            const editing = editSvc?.isEditing();
            const cellValidations = editModelSvc?.getCellValidationModel().getCellValidationMap().size ?? 0;
            const rowValidations = editModelSvc?.getRowValidationModel().getRowValidationMap().size ?? 0;
            if (editing && (cellValidations > 0 || rowValidations > 0)) return;
            if (editSvc?.shouldStartEditing(cellCtrl, event)) editSvc?.startEditing(cellCtrl, {
                event: event
            });
            else if (editSvc?.shouldStopEditing(cellCtrl, event)) {
                if (this.beans.gos.get("editType") === "fullRow") editSvc?.stopEditing(cellCtrl, {
                    event: event,
                    source: "edit"
                });
                else editSvc?.stopEditing(void 0, {
                    event: event,
                    source: "edit"
                });
            }
        }
    }
    onCellDoubleClicked(event) {
        const { column: column, beans: beans, cellCtrl: cellCtrl } = this;
        const { eventSvc: eventSvc, frameworkOverrides: frameworkOverrides, editSvc: editSvc, editModelSvc: editModelSvc, gos: gos } = beans;
        const suppressMouseEvent2 = $437b23f6a393c3bf$export$d7866551eadae1d3(gos, cellCtrl.column, cellCtrl.rowNode, event);
        const colDef = column.getColDef();
        const cellDoubleClickedEvent = cellCtrl.createEvent(event, "cellDoubleClicked");
        cellDoubleClickedEvent.isEventHandlingSuppressed = suppressMouseEvent2;
        eventSvc.dispatchEvent(cellDoubleClickedEvent);
        if (typeof colDef.onCellDoubleClicked === "function") window.setTimeout(()=>{
            frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellDoubleClicked(cellDoubleClickedEvent);
            });
        }, 0);
        if (suppressMouseEvent2) return;
        if (editSvc?.shouldStartEditing(cellCtrl, event) && editModelSvc?.getState(cellCtrl) !== "editing") {
            const editing = editSvc?.isEditing();
            const cellValidations = editModelSvc?.getCellValidationModel().getCellValidationMap().size ?? 0;
            const rowValidations = editModelSvc?.getRowValidationModel().getRowValidationMap().size ?? 0;
            if (editing && (cellValidations > 0 || rowValidations > 0)) return;
            editSvc?.startEditing(cellCtrl, {
                event: event
            });
        }
    }
    onMouseDown(mouseEvent) {
        const { ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = mouseEvent;
        const target = mouseEvent.target;
        const { cellCtrl: cellCtrl, beans: beans } = this;
        const { eventSvc: eventSvc, rangeSvc: rangeSvc, rowNumbersSvc: rowNumbersSvc, focusSvc: focusSvc, gos: gos, editSvc: editSvc } = beans;
        const { column: column, rowNode: rowNode, cellPosition: cellPosition } = cellCtrl;
        const suppressMouseEvent2 = $437b23f6a393c3bf$export$d7866551eadae1d3(gos, column, rowNode, mouseEvent);
        const fireMouseDownEvent = ()=>{
            const cellMouseDownEvent = cellCtrl.createEvent(mouseEvent, "cellMouseDown");
            cellMouseDownEvent.isEventHandlingSuppressed = suppressMouseEvent2;
            eventSvc.dispatchEvent(cellMouseDownEvent);
        };
        if (suppressMouseEvent2) {
            fireMouseDownEvent();
            return;
        }
        if (this.isRightClickInExistingRange(mouseEvent)) return;
        const hasRanges = rangeSvc && !rangeSvc.isEmpty();
        const containsWidget = this.containsWidget(target);
        const isRowNumberColumn = $437b23f6a393c3bf$export$3d3e7d751f0445eb(column);
        if (rowNumbersSvc && isRowNumberColumn && !rowNumbersSvc.handleMouseDownOnCell(cellPosition, mouseEvent)) {
            if (rangeSvc) mouseEvent.preventDefault();
            mouseEvent.stopImmediatePropagation();
            return;
        }
        if (!shiftKey || !hasRanges) {
            const editing = editSvc?.isEditing(cellCtrl);
            const isEnableCellTextSelection = gos.get("enableCellTextSelection");
            const shouldFocus = isEnableCellTextSelection && mouseEvent.defaultPrevented;
            const forceBrowserFocus = ($437b23f6a393c3bf$export$8caf403dacd36a68() || shouldFocus) && !editing && !$437b23f6a393c3bf$var$_isFocusableFormField(target) && !containsWidget;
            cellCtrl.focusCell(forceBrowserFocus, mouseEvent);
        }
        if (shiftKey && hasRanges && !focusSvc.isCellFocused(cellPosition)) {
            mouseEvent.preventDefault();
            const focusedCell = focusSvc.getFocusedCell();
            if (focusedCell) {
                const { column: column2, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCell;
                if (editSvc?.isEditing(focusedCell)) editSvc?.stopEditing(focusedCell);
                focusSvc.setFocusedCell({
                    column: column2,
                    rowIndex: rowIndex,
                    rowPinned: rowPinned,
                    forceBrowserFocus: true,
                    preventScrollOnBrowserFocus: true,
                    sourceEvent: mouseEvent
                });
            }
        }
        if (containsWidget) return;
        if (rangeSvc) {
            if (isRowNumberColumn) mouseEvent.preventDefault();
            const hasRightClickedOnRowNumber = $437b23f6a393c3bf$export$f8093014f10b296a(beans, mouseEvent) && isRowNumberColumn;
            if (shiftKey) rangeSvc.extendLatestRangeToCell(cellPosition);
            else if (!hasRightClickedOnRowNumber) {
                const isMultiKey = ctrlKey || metaKey;
                rangeSvc.setRangeToCell(cellPosition, isMultiKey);
            }
        }
        fireMouseDownEvent();
    }
    isRightClickInExistingRange(mouseEvent) {
        const { rangeSvc: rangeSvc } = this.beans;
        if (rangeSvc) {
            const cellInRange = rangeSvc.isCellInAnyRange(this.cellCtrl.cellPosition);
            const isRightClick = $437b23f6a393c3bf$export$f8093014f10b296a(this.beans, mouseEvent);
            if (cellInRange && isRightClick) return true;
        }
        return false;
    }
    containsWidget(target) {
        return $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-selection-checkbox", 3) || $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-drag-handle", 3);
    }
    onMouseOut(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const { eventSvc: eventSvc, colHover: colHover } = this.beans;
        eventSvc.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, "cellMouseOut"));
        colHover?.clearMouseOver();
    }
    onMouseOver(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const { eventSvc: eventSvc, colHover: colHover } = this.beans;
        eventSvc.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, "cellMouseOver"));
        colHover?.setMouseOver([
            this.column
        ]);
    }
    mouseStayingInsideCell(e) {
        if (!e.target || !e.relatedTarget) return false;
        const eCell = this.cellCtrl.eGui;
        const cellContainsTarget = eCell.contains(e.target);
        const cellContainsRelatedTarget = eCell.contains(e.relatedTarget);
        return cellContainsTarget && cellContainsRelatedTarget;
    }
};
// packages/ag-grid-community/src/rendering/cell/cellPositionFeature.ts
var $437b23f6a393c3bf$var$CellPositionFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.beans = beans;
        this.column = cellCtrl.column;
        this.rowNode = cellCtrl.rowNode;
    }
    setupRowSpan() {
        this.rowSpan = this.column.getRowSpan(this.rowNode);
        this.addManagedListeners(this.beans.eventSvc, {
            newColumnsLoaded: ()=>this.onNewColumnsLoaded()
        });
    }
    init() {
        this.eSetLeft = this.cellCtrl.getRootElement();
        this.eContent = this.cellCtrl.eGui;
        const cellSpan = this.cellCtrl.getCellSpan();
        if (!cellSpan) {
            this.setupColSpan();
            this.setupRowSpan();
        }
        this.onLeftChanged();
        this.onWidthChanged();
        if (!cellSpan) this._legacyApplyRowSpan();
        if (cellSpan) {
            const refreshSpanHeight = this.refreshSpanHeight.bind(this, cellSpan);
            refreshSpanHeight();
            this.addManagedListeners(this.beans.eventSvc, {
                paginationChanged: refreshSpanHeight,
                recalculateRowBounds: refreshSpanHeight,
                pinnedHeightChanged: refreshSpanHeight
            });
        }
    }
    refreshSpanHeight(cellSpan) {
        const spanHeight = cellSpan.getCellHeight();
        if (spanHeight != null) this.eContent.style.height = `${spanHeight}px`;
    }
    onNewColumnsLoaded() {
        const rowSpan = this.column.getRowSpan(this.rowNode);
        if (this.rowSpan === rowSpan) return;
        this.rowSpan = rowSpan;
        this._legacyApplyRowSpan(true);
    }
    onDisplayColumnsChanged() {
        const colsSpanning = this.getColSpanningList();
        if (!$437b23f6a393c3bf$export$893967cdb9833fdd(this.colsSpanning, colsSpanning)) {
            this.colsSpanning = colsSpanning;
            this.onWidthChanged();
            this.onLeftChanged();
        }
    }
    setupColSpan() {
        if (this.column.getColDef().colSpan == null) return;
        this.colsSpanning = this.getColSpanningList();
        this.addManagedListeners(this.beans.eventSvc, {
            // because we are col spanning, a reorder of the cols can change what cols we are spanning over
            displayedColumnsChanged: this.onDisplayColumnsChanged.bind(this),
            // because we are spanning over multiple cols, we check for width any time any cols width changes.
            // this is expensive - really we should be explicitly checking only the cols we are spanning over
            // instead of every col, however it would be tricky code to track the cols we are spanning over, so
            // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
            displayedColumnsWidthChanged: this.onWidthChanged.bind(this)
        });
    }
    onWidthChanged() {
        if (!this.eContent) return;
        const width = this.getCellWidth();
        this.eContent.style.width = `${width}px`;
    }
    getCellWidth() {
        if (!this.colsSpanning) return this.column.getActualWidth();
        return this.colsSpanning.reduce((width, col)=>width + col.getActualWidth(), 0);
    }
    getColSpanningList() {
        const { column: column, rowNode: rowNode } = this;
        const colSpan = column.getColSpan(rowNode);
        const colsSpanning = [];
        if (colSpan === 1) colsSpanning.push(column);
        else {
            let pointer = column;
            const pinned = column.getPinned();
            for(let i = 0; pointer && i < colSpan; i++){
                colsSpanning.push(pointer);
                pointer = this.beans.visibleCols.getColAfter(pointer);
                if (!pointer || $437b23f6a393c3bf$export$672d9e47bc342bac(pointer)) break;
                if (pinned !== pointer.getPinned()) break;
            }
        }
        return colsSpanning;
    }
    onLeftChanged() {
        if (!this.eSetLeft) return;
        const left = this.modifyLeftForPrintLayout(this.getCellLeft());
        this.eSetLeft.style.left = left + "px";
    }
    getCellLeft() {
        let mostLeftCol;
        if (this.beans.gos.get("enableRtl") && this.colsSpanning) mostLeftCol = $437b23f6a393c3bf$export$236389741107357f(this.colsSpanning);
        else mostLeftCol = this.column;
        return mostLeftCol.getLeft();
    }
    modifyLeftForPrintLayout(leftPosition) {
        if (!this.cellCtrl.printLayout || this.column.getPinned() === "left") return leftPosition;
        const { visibleCols: visibleCols } = this.beans;
        const leftWidth = visibleCols.getColsLeftWidth();
        if (this.column.getPinned() === "right") {
            const bodyWidth = visibleCols.bodyWidth;
            return leftWidth + bodyWidth + (leftPosition || 0);
        }
        return leftWidth + (leftPosition || 0);
    }
    _legacyApplyRowSpan(force) {
        if (this.rowSpan === 1 && !force) return;
        const singleRowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
        const totalRowHeight = singleRowHeight * this.rowSpan;
        this.eContent.style.height = `${totalRowHeight}px`;
        this.eContent.style.zIndex = "1";
    }
    // overriding to make public, as we don't dispose this bean via context
    destroy() {
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/cell/cellCtrl.ts
var $437b23f6a393c3bf$var$CSS_CELL = "ag-cell";
var $437b23f6a393c3bf$var$CSS_AUTO_HEIGHT = "ag-cell-auto-height";
var $437b23f6a393c3bf$var$CSS_NORMAL_HEIGHT = "ag-cell-normal-height";
var $437b23f6a393c3bf$var$CSS_CELL_FOCUS = "ag-cell-focus";
var $437b23f6a393c3bf$var$CSS_CELL_FIRST_RIGHT_PINNED = "ag-cell-first-right-pinned";
var $437b23f6a393c3bf$var$CSS_CELL_LAST_LEFT_PINNED = "ag-cell-last-left-pinned";
var $437b23f6a393c3bf$var$CSS_CELL_NOT_INLINE_EDITING = "ag-cell-not-inline-editing";
var $437b23f6a393c3bf$var$CSS_CELL_WRAP_TEXT = "ag-cell-wrap-text";
var $437b23f6a393c3bf$var$instanceIdSequence4 = 0;
var $437b23f6a393c3bf$var$CellCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column, rowNode, beans, rowCtrl){
        super();
        this.column = column;
        this.rowNode = rowNode;
        this.rowCtrl = rowCtrl;
        this.rangeFeature = void 0;
        this.rowResizeFeature = void 0;
        this.positionFeature = void 0;
        this.customStyleFeature = void 0;
        this.editStyleFeature = void 0;
        this.mouseListener = void 0;
        this.keyboardListener = void 0;
        this.suppressRefreshCell = false;
        this.onCompAttachedFuncs = [];
        this.onEditorAttachedFuncs = [];
        this.focusEventWhileNotReady = null;
        // if cell has been focused, check if it's focused when destroyed
        this.hasBeenFocused = false;
        this.hasEdit = false;
        this.tooltipFeature = void 0;
        this.editorTooltipFeature = void 0;
        this.beans = beans;
        this.gos = beans.gos;
        this.editSvc = beans.editSvc;
        this.hasEdit = !!beans.editSvc;
        const { colId: colId } = column;
        this.instanceId = colId + "-" + $437b23f6a393c3bf$var$instanceIdSequence4++;
        this.createCellPosition();
        this.updateAndFormatValue(false);
    }
    addFeatures() {
        const { beans: beans } = this;
        this.positionFeature = new $437b23f6a393c3bf$var$CellPositionFeature(this, beans);
        this.customStyleFeature = beans.cellStyles?.createCellCustomStyleFeature(this, beans);
        this.editStyleFeature = beans.editSvc?.createCellStyleFeature(this, beans);
        this.mouseListener = new $437b23f6a393c3bf$var$CellMouseListenerFeature(this, beans, this.column);
        this.keyboardListener = new $437b23f6a393c3bf$var$CellKeyboardListenerFeature(this, beans, this.rowNode, this.rowCtrl);
        this.enableTooltipFeature();
        const { rangeSvc: rangeSvc } = beans;
        const cellSelectionEnabled = rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(beans.gos);
        if (cellSelectionEnabled) this.rangeFeature = rangeSvc.createCellRangeFeature(beans, this);
        if ($437b23f6a393c3bf$export$3d3e7d751f0445eb(this.column)) this.rowResizeFeature = this.beans.rowNumbersSvc.createRowNumbersRowResizerFeature(beans, this);
    }
    isCellSpanning() {
        return false;
    }
    getCellSpan() {
        return void 0;
    }
    removeFeatures() {
        const context = this.beans.context;
        this.positionFeature = context.destroyBean(this.positionFeature);
        this.editorTooltipFeature = context.destroyBean(this.editorTooltipFeature);
        this.customStyleFeature = context.destroyBean(this.customStyleFeature);
        this.editStyleFeature = context.destroyBean(this.editStyleFeature);
        this.mouseListener = context.destroyBean(this.mouseListener);
        this.keyboardListener = context.destroyBean(this.keyboardListener);
        this.rangeFeature = context.destroyBean(this.rangeFeature);
        this.rowResizeFeature = context.destroyBean(this.rowResizeFeature);
        this.disableTooltipFeature();
    }
    enableTooltipFeature(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.enableCellTooltipFeature(this, value, shouldDisplayTooltip);
    }
    disableTooltipFeature() {
        this.tooltipFeature = this.beans.context.destroyBean(this.tooltipFeature);
    }
    enableEditorTooltipFeature(editor) {
        if (this.editorTooltipFeature) this.disableEditorTooltipFeature();
        this.editorTooltipFeature = this.beans.tooltipSvc?.setupCellEditorTooltip(this, editor);
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
    }
    disableEditorTooltipFeature() {
        this.editorTooltipFeature = this.beans.context.destroyBean(this.editorTooltipFeature);
    }
    setComp(comp, eCell, _eWrapper, eCellWrapper, printLayout, startEditing, compBean) {
        this.comp = comp;
        this.eGui = eCell;
        this.printLayout = printLayout;
        compBean ?? (compBean = this);
        this.addDomData(compBean);
        this.addFeatures();
        compBean.addDestroyFunc(()=>this.removeFeatures());
        this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus"));
        this.setupFocus();
        this.applyStaticCssClasses();
        this.setWrapText();
        this.onFirstRightPinnedChanged();
        this.onLastLeftPinnedChanged();
        this.onColumnHover();
        this.setupControlComps();
        this.setupAutoHeight(eCellWrapper, compBean);
        this.refreshFirstAndLastStyles();
        this.refreshAriaColIndex();
        this.positionFeature?.init();
        this.customStyleFeature?.setComp(comp);
        this.editStyleFeature?.setComp(comp);
        this.tooltipFeature?.refreshTooltip();
        this.keyboardListener?.init();
        this.rangeFeature?.setComp(comp);
        this.rowResizeFeature?.refreshRowResizer();
        if (startEditing && this.isCellEditable() || this.hasEdit && this.editSvc?.isEditing(this, {
            withOpenEditor: true
        })) this.editSvc?.startEditing(this, {
            startedEdit: false,
            source: "api",
            silent: true,
            continueEditing: true
        });
        else this.showValue(false, true);
        if (this.onCompAttachedFuncs.length) {
            for (const func of this.onCompAttachedFuncs)func();
            this.onCompAttachedFuncs = [];
        }
    }
    setupAutoHeight(eCellWrapper, compBean) {
        this.isAutoHeight = this.beans.rowAutoHeight?.setupCellAutoHeight(this, eCellWrapper, compBean) ?? false;
    }
    getCellAriaRole() {
        return this.column.getColDef().cellAriaRole ?? "gridcell";
    }
    isCellRenderer() {
        const colDef = this.column.getColDef();
        return colDef.cellRenderer != null || colDef.cellRendererSelector != null;
    }
    getValueToDisplay() {
        return this.valueFormatted ?? this.value;
    }
    getDeferLoadingCellRenderer() {
        const { beans: beans, column: column } = this;
        const { userCompFactory: userCompFactory, ctrlsSvc: ctrlsSvc, eventSvc: eventSvc } = beans;
        const colDef = column.getColDef();
        const params = this.createCellRendererParams();
        params.deferRender = true;
        const loadingDetails = $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, colDef, params);
        if (ctrlsSvc.getGridBodyCtrl()?.scrollFeature?.isScrolling()) {
            let resolver;
            const onReady = new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
                resolver = resolve;
            });
            const [removeBodyScrollEnd] = this.addManagedListeners(eventSvc, {
                bodyScrollEnd: ()=>{
                    resolver();
                    removeBodyScrollEnd();
                }
            });
            return {
                loadingComp: loadingDetails,
                onReady: onReady
            };
        }
        return {
            loadingComp: loadingDetails,
            onReady: $437b23f6a393c3bf$export$30ec7836a4847721.resolve()
        };
    }
    showValue(forceNewCellRendererInstance, skipRangeHandleRefresh) {
        const { beans: beans, column: column, rowNode: rowNode, rangeFeature: rangeFeature } = this;
        const { userCompFactory: userCompFactory } = beans;
        let valueToDisplay = this.getValueToDisplay();
        let compDetails;
        const isSsrmLoading = rowNode.stub && rowNode.groupData?.[column.getId()] == null;
        const colDef = column.getColDef();
        if (isSsrmLoading || this.isCellRenderer()) {
            const params = this.createCellRendererParams();
            if (!isSsrmLoading || $437b23f6a393c3bf$export$3d3e7d751f0445eb(column)) compDetails = $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, colDef, params);
            else compDetails = $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, colDef, params);
        }
        if (!compDetails && !isSsrmLoading && beans.findSvc?.isMatch(rowNode, column)) {
            const params = this.createCellRendererParams();
            compDetails = $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, {
                ...column.getColDef(),
                cellRenderer: "agFindCellRenderer"
            }, params);
        }
        if (this.hasEdit && this.editSvc.isBatchEditing() && this.editSvc.isRowEditing(rowNode, {
            checkSiblings: true
        })) {
            const result = this.editSvc.prepDetailsDuringBatch(this, {
                compDetails: compDetails,
                valueToDisplay: valueToDisplay
            });
            if (result) {
                if (result.compDetails) compDetails = result.compDetails;
                else if (result.valueToDisplay) valueToDisplay = result.valueToDisplay;
            }
        }
        this.comp.setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance);
        this.customRowDragComp?.refreshVisibility();
        if (!skipRangeHandleRefresh && rangeFeature) $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>rangeFeature?.refreshHandle());
        this.rowResizeFeature?.refreshRowResizer();
    }
    setupControlComps() {
        const colDef = this.column.getColDef();
        this.includeSelection = this.isIncludeControl(this.isCheckboxSelection(colDef), true);
        this.includeRowDrag = this.isIncludeControl(colDef.rowDrag);
        this.includeDndSource = this.isIncludeControl(colDef.dndSource);
        this.comp.setIncludeSelection(this.includeSelection);
        this.comp.setIncludeDndSource(this.includeDndSource);
        this.comp.setIncludeRowDrag(this.includeRowDrag);
    }
    isForceWrapper() {
        return this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
    }
    getCellValueClass() {
        const prefix = "ag-cell-value";
        const isCheckboxRenderer = this.column.getColDef().cellRenderer === "agCheckboxCellRenderer";
        let suffix = "";
        if (isCheckboxRenderer) suffix = " ag-allow-overflow";
        return `${prefix}${suffix}`;
    }
    /**
   * Wrapper providing general conditions under which control elements (e.g. checkboxes and drag handles)
   * are rendered for a particular cell.
   * @param value Whether to render the control in the specific context of the caller
   * @param allowManuallyPinned Whether manually pinned rows are permitted this form of control element
   */ // eslint-disable-next-line @typescript-eslint/ban-types
    isIncludeControl(value, allowManuallyPinned = false) {
        const rowUnpinned = this.rowNode.rowPinned == null;
        return (rowUnpinned || allowManuallyPinned && $437b23f6a393c3bf$var$_isManualPinnedRow(this.rowNode)) && !!value;
    }
    isCheckboxSelection(colDef) {
        const { rowSelection: rowSelection, groupDisplayType: groupDisplayType } = this.beans.gridOptions;
        const checkboxLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection);
        const isSelectionColumn = $437b23f6a393c3bf$export$f6074a9792015c5d(this.column);
        if (groupDisplayType === "custom" && checkboxLocation !== "selectionColumn" && isSelectionColumn) return false;
        return colDef.checkboxSelection || isSelectionColumn && typeof rowSelection === "object" && $437b23f6a393c3bf$export$6df3a55606bca6ae(rowSelection);
    }
    refreshShouldDestroy() {
        const colDef = this.column.getColDef();
        const selectionChanged = this.includeSelection != this.isIncludeControl(this.isCheckboxSelection(colDef), true);
        const rowDragChanged = this.includeRowDrag != this.isIncludeControl(colDef.rowDrag);
        const dndSourceChanged = this.includeDndSource != this.isIncludeControl(colDef.dndSource);
        const autoHeightChanged = this.isAutoHeight != this.column.isAutoHeight();
        return selectionChanged || rowDragChanged || dndSourceChanged || autoHeightChanged;
    }
    onPopupEditorClosed() {
        const { editSvc: editSvc } = this.beans;
        if (!editSvc?.isEditing(this, {
            withOpenEditor: true
        })) return;
        editSvc?.stopEditing(this, {
            source: editSvc?.isBatchEditing() ? "ui" : "api"
        });
    }
    /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */ stopEditing(cancel = false) {
        const { editSvc: editSvc } = this.beans;
        return editSvc?.stopEditing(this, {
            cancel: cancel,
            source: editSvc?.isBatchEditing() ? "ui" : "api"
        }) ?? false;
    }
    createCellRendererParams() {
        const { value: value, valueFormatted: valueFormatted, column: column, rowNode: rowNode, comp: comp, eGui: eGui, beans: { valueSvc: valueSvc, gos: gos, editSvc: editSvc } } = this;
        const res = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            value: value,
            valueFormatted: valueFormatted,
            getValue: ()=>valueSvc.getValueForDisplay(column, rowNode).value,
            setValue: (value2)=>editSvc?.setDataValue({
                    rowNode: rowNode,
                    column: column
                }, value2) || rowNode.setDataValue(column, value2),
            formatValue: this.formatValue.bind(this),
            data: rowNode.data,
            node: rowNode,
            pinned: column.getPinned(),
            colDef: column.getColDef(),
            column: column,
            refreshCell: this.refreshCell.bind(this),
            eGridCell: eGui,
            eParentOfValue: comp.getParentOfValue(),
            registerRowDragger: (rowDraggerElement, dragStartPixels, value2, suppressVisibilityChange)=>this.registerRowDragger(rowDraggerElement, dragStartPixels, suppressVisibilityChange),
            setTooltip: (value2, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                if (this.tooltipFeature) this.disableTooltipFeature();
                this.enableTooltipFeature(value2, shouldDisplayTooltip);
                this.tooltipFeature?.refreshTooltip();
            }
        });
        return res;
    }
    onCellChanged(event) {
        const eventImpactsThisCell = event.column === this.column;
        if (eventImpactsThisCell) this.refreshCell({});
    }
    refreshOrDestroyCell(params) {
        if (this.refreshShouldDestroy()) this.rowCtrl?.recreateCell(this);
        else this.refreshCell(params);
        if (this.hasEdit && this.editCompDetails) {
            const { editSvc: editSvc, comp: comp } = this;
            if (!comp?.getCellEditor() && editSvc.isEditing(this, {
                withOpenEditor: true
            })) editSvc.startEditing(this, {
                startedEdit: false,
                source: "api",
                silent: true
            });
        }
    }
    // + stop editing {force: true, suppressFlash: true}
    // + event cellChanged {}
    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
    // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
    // + rowCtrl: api refreshCells() {animate: true/false}
    // + rowRenderer: api softRefreshView() {}
    refreshCell({ force: force, suppressFlash: suppressFlash, newData: newData } = {}) {
        const { editStyleFeature: editStyleFeature, customStyleFeature: customStyleFeature, rowCtrl: { rowEditStyleFeature: rowEditStyleFeature }, beans: { cellFlashSvc: cellFlashSvc, filterManager: filterManager }, column: column, comp: comp, suppressRefreshCell: suppressRefreshCell, tooltipFeature: tooltipFeature } = this;
        if (suppressRefreshCell) return;
        const { field: field, valueGetter: valueGetter, showRowGroup: showRowGroup, enableCellChangeFlash: enableCellChangeFlash } = column.getColDef();
        const noValueProvided = field == null && valueGetter == null && showRowGroup == null;
        const forceRefresh = force || noValueProvided || newData;
        const isCellCompReady = !!comp;
        const valuesDifferent = this.updateAndFormatValue(isCellCompReady);
        const dataNeedsUpdating = forceRefresh || valuesDifferent;
        if (!isCellCompReady) return;
        if (dataNeedsUpdating) {
            this.showValue(!!newData, false);
            const processingFilterChange = filterManager?.isSuppressFlashingCellsBecauseFiltering();
            const flashCell = !suppressFlash && !processingFilterChange && enableCellChangeFlash;
            if (flashCell) cellFlashSvc?.flashCell(this);
            editStyleFeature?.applyCellStyles?.();
            customStyleFeature?.applyUserStyles();
            customStyleFeature?.applyClassesFromColDef();
            rowEditStyleFeature?.applyRowStyles();
        }
        tooltipFeature?.refreshTooltip();
        customStyleFeature?.applyCellClassRules();
    }
    isCellEditable() {
        return this.column.isCellEditable(this.rowNode);
    }
    formatValue(value) {
        return this.callValueFormatter(value) ?? value;
    }
    callValueFormatter(value) {
        return this.beans.valueSvc.formatValue(this.column, this.rowNode, value);
    }
    updateAndFormatValue(compareValues) {
        const oldValue = this.value;
        const oldValueFormatted = this.valueFormatted;
        const { value: value, valueFormatted: valueFormatted } = this.beans.valueSvc.getValueForDisplay(this.column, this.rowNode, true);
        this.value = value;
        this.valueFormatted = valueFormatted;
        if (compareValues) return !this.valuesAreEqual(oldValue, this.value) || this.valueFormatted != oldValueFormatted;
        return true;
    }
    valuesAreEqual(val1, val2) {
        const colDef = this.column.getColDef();
        return colDef.equals ? colDef.equals(val1, val2) : val1 === val2;
    }
    addDomData(compBean) {
        const element = this.eGui;
        $437b23f6a393c3bf$var$_setDomData(this.beans.gos, element, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL, this);
        compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(this.beans.gos, element, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL, null));
    }
    createEvent(domEvent, eventType) {
        const { rowNode: rowNode, column: column, value: value, beans: beans } = this;
        return $437b23f6a393c3bf$var$_createCellEvent(beans, domEvent, eventType, {
            rowNode: rowNode,
            column: column
        }, value);
    }
    processCharacter(event) {
        this.keyboardListener?.processCharacter(event);
    }
    onKeyDown(event) {
        this.keyboardListener?.onKeyDown(event);
    }
    onMouseEvent(eventName, mouseEvent) {
        this.mouseListener?.onMouseEvent(eventName, mouseEvent);
    }
    getColSpanningList() {
        return this.positionFeature?.getColSpanningList() ?? [];
    }
    onLeftChanged() {
        if (!this.comp) return;
        this.positionFeature?.onLeftChanged();
    }
    onDisplayedColumnsChanged() {
        if (!this.eGui) return;
        this.refreshAriaColIndex();
        this.refreshFirstAndLastStyles();
    }
    refreshFirstAndLastStyles() {
        const { comp: comp, column: column, beans: beans } = this;
        $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, beans.visibleCols);
    }
    refreshAriaColIndex() {
        const colIdx = this.beans.visibleCols.getAriaColIndex(this.column);
        $437b23f6a393c3bf$export$84b73ecd0b234e89(this.eGui, colIdx);
    }
    onWidthChanged() {
        return this.positionFeature?.onWidthChanged();
    }
    getRowPosition() {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = this.cellPosition;
        return {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
    }
    updateRangeBordersIfRangeCount() {
        if (!this.comp) return;
        this.rangeFeature?.updateRangeBordersIfRangeCount();
    }
    onCellSelectionChanged() {
        if (!this.comp) return;
        this.rangeFeature?.onCellSelectionChanged();
    }
    isRangeSelectionEnabled() {
        return this.rangeFeature != null;
    }
    focusCell(forceBrowserFocus = false, sourceEvent) {
        const allowedTarget = this.editSvc?.allowedFocusTargetOnValidation(this);
        if (allowedTarget && allowedTarget !== this) return;
        this.beans.focusSvc.setFocusedCell({
            ...this.getFocusedCellPosition(),
            forceBrowserFocus: forceBrowserFocus,
            sourceEvent: sourceEvent
        });
    }
    /**
   * Restores focus to the cell, if it should have it
   * @param waitForRender if the cell has just setComp, it may not be rendered yet, so we wait for the next render
   */ restoreFocus(waitForRender = false) {
        const { beans: { editSvc: editSvc, focusSvc: focusSvc }, comp: comp } = this;
        if (!comp || editSvc?.isEditing(this) || !this.isCellFocused() || !focusSvc.shouldTakeFocus()) return;
        const focus = ()=>{
            if (!this.isAlive()) return;
            const focusableElement = comp.getFocusableElement();
            if (this.isCellFocused()) focusableElement.focus({
                preventScroll: true
            });
        };
        if (waitForRender) {
            setTimeout(focus, 0);
            return;
        }
        focus();
    }
    onRowIndexChanged() {
        this.createCellPosition();
        this.onCellFocused();
        this.restoreFocus();
        this.rangeFeature?.onCellSelectionChanged();
        this.rowResizeFeature?.refreshRowResizer();
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        const element = this.eGui;
        if (!element) return;
        if ($437b23f6a393c3bf$export$3d3e7d751f0445eb(this.column)) suppressCellFocus = true;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(element, "tabindex", suppressCellFocus ? void 0 : -1);
    }
    onFirstRightPinnedChanged() {
        if (!this.comp) return;
        const firstRightPinned = this.column.isFirstRightPinned();
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_FIRST_RIGHT_PINNED, firstRightPinned);
    }
    onLastLeftPinnedChanged() {
        if (!this.comp) return;
        const lastLeftPinned = this.column.isLastLeftPinned();
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_LAST_LEFT_PINNED, lastLeftPinned);
    }
    /**
   * Returns whether cell is focused by the focusSvc, overridden by spannedCellCtrl
   */ checkCellFocused() {
        return this.beans.focusSvc.isCellFocused(this.cellPosition);
    }
    isCellFocused() {
        const isFocused = this.checkCellFocused();
        this.hasBeenFocused || (this.hasBeenFocused = isFocused);
        return isFocused;
    }
    setupFocus() {
        this.restoreFocus(true);
        this.onCellFocused(this.focusEventWhileNotReady ?? void 0);
    }
    onCellFocused(event) {
        const { beans: beans } = this;
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(beans)) return;
        if (!this.comp) {
            if (event) this.focusEventWhileNotReady = event;
            return;
        }
        const cellFocused = this.isCellFocused();
        const editing = beans.editSvc?.isEditing(this) ?? false;
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_FOCUS, cellFocused);
        if (cellFocused && event?.forceBrowserFocus) {
            let focusEl = this.comp.getFocusableElement();
            if (editing) {
                const focusableEls = $437b23f6a393c3bf$export$7acf44f59625b1f6(focusEl, null, true);
                if (focusableEls.length) focusEl = focusableEls[0];
            }
            focusEl.focus({
                preventScroll: !!event.preventScrollOnBrowserFocus
            });
        }
        if (cellFocused && event) this.rowCtrl.announceDescription();
    }
    createCellPosition() {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = this.rowNode;
        this.cellPosition = {
            rowIndex: rowIndex,
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
            column: this.column
        };
    }
    // CSS Classes that only get applied once, they never change
    applyStaticCssClasses() {
        const { comp: comp } = this;
        comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL, true);
        comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_NOT_INLINE_EDITING, true);
        const autoHeight = this.column.isAutoHeight() == true;
        comp.toggleCss($437b23f6a393c3bf$var$CSS_AUTO_HEIGHT, autoHeight);
        comp.toggleCss($437b23f6a393c3bf$var$CSS_NORMAL_HEIGHT, !autoHeight);
    }
    onColumnHover() {
        this.beans.colHover?.onCellColumnHover(this.column, this.comp);
    }
    onColDefChanged() {
        if (!this.comp) return;
        if (this.column.isTooltipEnabled()) {
            this.disableTooltipFeature();
            this.enableTooltipFeature();
        } else this.disableTooltipFeature();
        this.setWrapText();
        if (this.editSvc?.isEditing(this)) this.editSvc?.handleColDefChanged(this);
        else this.refreshOrDestroyCell({
            force: true,
            suppressFlash: true
        });
    }
    setWrapText() {
        const value = this.column.getColDef().wrapText == true;
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_WRAP_TEXT, value);
    }
    dispatchCellContextMenuEvent(event) {
        const colDef = this.column.getColDef();
        const cellContextMenuEvent = this.createEvent(event, "cellContextMenu");
        const { beans: beans } = this;
        beans.eventSvc.dispatchEvent(cellContextMenuEvent);
        if (colDef.onCellContextMenu) window.setTimeout(()=>{
            beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellContextMenu(cellContextMenuEvent);
            });
        }, 0);
    }
    getCellRenderer() {
        return this.comp?.getCellRenderer() ?? null;
    }
    destroy() {
        this.onCompAttachedFuncs = [];
        this.onEditorAttachedFuncs = [];
        if (this.isCellFocused() && this.hasBrowserFocus()) this.beans.focusSvc.attemptToRecoverFocus();
        super.destroy();
    }
    hasBrowserFocus() {
        return this.eGui?.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans)) ?? false;
    }
    createSelectionCheckbox() {
        const cbSelectionComponent = this.beans.selectionSvc?.createCheckboxSelectionComponent();
        if (!cbSelectionComponent) return void 0;
        this.beans.context.createBean(cbSelectionComponent);
        cbSelectionComponent.init({
            rowNode: this.rowNode,
            column: this.column
        });
        return cbSelectionComponent;
    }
    createDndSource() {
        const dndSourceComp = this.beans.registry.createDynamicBean("dndSourceComp", false, this.rowNode, this.column, this.eGui);
        if (dndSourceComp) this.beans.context.createBean(dndSourceComp);
        return dndSourceComp;
    }
    registerRowDragger(customElement, dragStartPixels, alwaysVisible) {
        if (this.customRowDragComp) {
            this.customRowDragComp.setDragElement(customElement, dragStartPixels);
            return;
        }
        const newComp = this.createRowDragComp(customElement, dragStartPixels, alwaysVisible);
        if (newComp) {
            this.customRowDragComp = newComp;
            this.addDestroyFunc(()=>{
                this.beans.context.destroyBean(newComp);
                this.customRowDragComp = null;
            });
            newComp.refreshVisibility();
        }
    }
    createRowDragComp(customElement, dragStartPixels, alwaysVisible) {
        const rowDragComp = this.beans.rowDragSvc?.createRowDragCompForCell(this.rowNode, this.column, ()=>this.value, customElement, dragStartPixels, alwaysVisible);
        if (!rowDragComp) return void 0;
        this.beans.context.createBean(rowDragComp);
        return rowDragComp;
    }
    cellEditorAttached() {
        for (const func of this.onEditorAttachedFuncs)func();
        this.onEditorAttachedFuncs = [];
    }
    setFocusedCellPosition(_cellPosition) {}
    getFocusedCellPosition() {
        return this.cellPosition;
    }
    // used by spannedCellCtrl
    refreshAriaRowIndex() {}
    /**
   * Returns the root element of the cell, could be a span container rather than the cell element.
   * @returns The root element of the cell.
   */ getRootElement() {
        return this.eGui;
    }
};
// packages/ag-grid-community/src/styling/stylingUtils.ts
function $437b23f6a393c3bf$var$processClassRules(expressionSvc, previousClassRules, classRules, params, onApplicableClass, onNotApplicableClass) {
    if (classRules == null && previousClassRules == null) return;
    const classesToApply = {};
    const classesToRemove = {};
    const forEachSingleClass = (className, callback)=>{
        for (const singleClass of className.split(" ")){
            if (singleClass.trim() == "") continue;
            callback(singleClass);
        }
    };
    if (classRules) {
        const classNames = Object.keys(classRules);
        for(let i = 0; i < classNames.length; i++){
            const className = classNames[i];
            const rule = classRules[className];
            let resultOfRule;
            if (typeof rule === "string") resultOfRule = expressionSvc ? expressionSvc.evaluate(rule, params) : true;
            else if (typeof rule === "function") resultOfRule = rule(params);
            forEachSingleClass(className, (singleClass)=>{
                resultOfRule ? classesToApply[singleClass] = true : classesToRemove[singleClass] = true;
            });
        }
    }
    if (previousClassRules && onNotApplicableClass) for (const className of Object.keys(previousClassRules))forEachSingleClass(className, (singleClass)=>{
        if (!classesToApply[singleClass]) classesToRemove[singleClass] = true;
    });
    if (onNotApplicableClass) Object.keys(classesToRemove).forEach(onNotApplicableClass);
    Object.keys(classesToApply).forEach(onApplicableClass);
}
// packages/ag-grid-community/src/styling/rowStyleService.ts
function $437b23f6a393c3bf$var$calculateRowLevel(rowNode) {
    if (rowNode.group) return rowNode.level;
    const parent = rowNode.parent;
    return parent ? parent.level + 1 : 0;
}
var $437b23f6a393c3bf$var$RowStyleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowStyleSvc";
    }
    processClassesFromGridOptions(classes, rowNode) {
        const gos = this.gos;
        const process = (rowCls)=>{
            if (typeof rowCls === "string") classes.push(rowCls);
            else if (Array.isArray(rowCls)) for (const e of rowCls)classes.push(e);
        };
        const rowClass = gos.get("rowClass");
        if (rowClass) process(rowClass);
        const rowClassFunc = gos.getCallback("getRowClass");
        if (rowClassFunc) {
            const params = {
                data: rowNode.data,
                node: rowNode,
                rowIndex: rowNode.rowIndex
            };
            const rowClassFuncResult = rowClassFunc(params);
            process(rowClassFuncResult);
        }
    }
    preProcessRowClassRules(classes, rowNode) {
        this.processRowClassRules(rowNode, (className)=>{
            classes.push(className);
        }, ()=>{});
    }
    processRowClassRules(rowNode, onApplicableClass, onNotApplicableClass) {
        const { gos: gos, expressionSvc: expressionSvc } = this.beans;
        const rowClassParams = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            data: rowNode.data,
            node: rowNode,
            rowIndex: rowNode.rowIndex
        });
        $437b23f6a393c3bf$var$processClassRules(expressionSvc, void 0, gos.get("rowClassRules"), rowClassParams, onApplicableClass, onNotApplicableClass);
    }
    processStylesFromGridOptions(rowNode) {
        const gos = this.gos;
        const rowStyle = gos.get("rowStyle");
        const rowStyleFunc = gos.getCallback("getRowStyle");
        let rowStyleFuncResult;
        if (rowStyleFunc) {
            const params = {
                data: rowNode.data,
                node: rowNode,
                rowIndex: rowNode.rowIndex
            };
            rowStyleFuncResult = rowStyleFunc(params);
        }
        if (rowStyleFuncResult || rowStyle) return Object.assign({}, rowStyle, rowStyleFuncResult);
        return void 0;
    }
};
// packages/ag-grid-community/src/rendering/row/rowCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence5 = 0;
var $437b23f6a393c3bf$var$RowCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout){
        super();
        this.rowNode = rowNode;
        this.useAnimationFrameForCreate = useAnimationFrameForCreate;
        this.printLayout = printLayout;
        this.allRowGuis = [];
        this.active = true;
        this.centerCellCtrls = {
            list: [],
            map: {}
        };
        this.leftCellCtrls = {
            list: [],
            map: {}
        };
        this.rightCellCtrls = {
            list: [],
            map: {}
        };
        this.slideInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.fadeInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.rowDragComps = [];
        this.lastMouseDownOnDragger = false;
        this.emptyStyle = {};
        this.updateColumnListsPending = false;
        this.rowId = null;
        /** sanitised */ this.businessKey = null;
        this.beans = beans;
        this.gos = beans.gos;
        this.paginationPage = beans.pagination?.getCurrentPage() ?? 0;
        this.suppressRowTransform = this.gos.get("suppressRowTransform");
        this.instanceId = rowNode.id + "-" + $437b23f6a393c3bf$var$instanceIdSequence5++;
        this.rowId = $437b23f6a393c3bf$export$3df06b741968da82(rowNode.id);
        this.initRowBusinessKey();
        this.rowFocused = beans.focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        this.rowLevel = $437b23f6a393c3bf$var$calculateRowLevel(this.rowNode);
        this.setRowType();
        this.setAnimateFlags(animateIn);
        this.rowStyles = this.processStylesFromGridOptions();
        this.rowEditStyleFeature = beans.editSvc?.createRowStyleFeature(this, beans);
        this.addListeners();
    }
    initRowBusinessKey() {
        this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode");
        this.updateRowBusinessKey();
    }
    updateRowBusinessKey() {
        if (typeof this.businessKeyForNodeFunc !== "function") return;
        const businessKey = this.businessKeyForNodeFunc(this.rowNode);
        this.businessKey = $437b23f6a393c3bf$export$3df06b741968da82(businessKey);
    }
    updateGui(containerType, gui) {
        if (containerType === "left") this.leftGui = gui;
        else if (containerType === "right") this.rightGui = gui;
        else if (containerType === "fullWidth") this.fullWidthGui = gui;
        else this.centerGui = gui;
    }
    setComp(rowComp, element, containerType, compBean) {
        const { context: context, focusSvc: focusSvc } = this.beans;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBean);
        const gui = {
            rowComp: rowComp,
            element: element,
            containerType: containerType,
            compBean: compBean
        };
        this.allRowGuis.push(gui);
        this.updateGui(containerType, gui);
        this.initialiseRowComp(gui);
        const rowNode = this.rowNode;
        const isSsrmLoadingRow = this.rowType === "FullWidthLoading" || rowNode.stub;
        const isIrmLoadingRow = !rowNode.data && this.beans.rowModel.getType() === "infinite";
        if (!isSsrmLoadingRow && !isIrmLoadingRow && !rowNode.rowPinned) this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
        const focusableElement = this.fullWidthGui?.element;
        if (focusableElement) {
            const editing = this.beans.editSvc?.isEditing(this);
            if (!editing && focusSvc.isRowFocused(rowNode.rowIndex, rowNode.rowPinned) && focusSvc.shouldTakeFocus()) setTimeout(()=>focusableElement.focus({
                    preventScroll: true
                }), 0);
        }
    }
    unsetComp(containerType) {
        this.allRowGuis = this.allRowGuis.filter((rowGui)=>rowGui.containerType !== containerType);
        this.updateGui(containerType, void 0);
    }
    isCacheable() {
        return this.rowType === "FullWidthDetail" && this.gos.get("keepDetailRows");
    }
    setCached(cached) {
        const displayValue = cached ? "none" : "";
        for (const rg of this.allRowGuis)rg.element.style.display = displayValue;
    }
    initialiseRowComp(gui) {
        const gos = this.gos;
        this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus"));
        this.listenOnDomOrder(gui);
        this.onRowHeightChanged(gui);
        this.updateRowIndexes(gui);
        this.setFocusedClasses(gui);
        this.setStylesFromGridOptions(false, gui);
        if ($437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos) && this.rowNode.selectable) this.onRowSelected(gui);
        this.updateColumnLists(!this.useAnimationFrameForCreate);
        const comp = gui.rowComp;
        const initialRowClasses = this.getInitialRowClasses(gui.containerType);
        for (const name of initialRowClasses)comp.toggleCss(name, true);
        this.executeSlideAndFadeAnimations(gui);
        if (this.rowNode.group) $437b23f6a393c3bf$export$3ad3518dddf15485(gui.element, this.rowNode.expanded == true);
        this.setRowCompRowId(comp);
        this.setRowCompRowBusinessKey(comp);
        $437b23f6a393c3bf$var$_setDomData(gos, gui.element, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL, this);
        gui.compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(gos, gui.element, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL, null));
        if (this.useAnimationFrameForCreate) this.beans.animationFrameSvc.createTask(this.addHoverFunctionality.bind(this, gui), this.rowNode.rowIndex, "p2", false);
        else this.addHoverFunctionality(gui);
        if (this.isFullWidth()) this.setupFullWidth(gui);
        if (gos.get("rowDragEntireRow")) this.addRowDraggerToRow(gui);
        if (this.useAnimationFrameForCreate) this.beans.animationFrameSvc.addDestroyTask(()=>{
            if (!this.isAlive()) return;
            gui.rowComp.toggleCss("ag-after-created", true);
        });
        this.executeProcessRowPostCreateFunc();
    }
    setRowCompRowBusinessKey(comp) {
        if (this.businessKey == null) return;
        comp.setRowBusinessKey(this.businessKey);
    }
    setRowCompRowId(comp) {
        const rowId = $437b23f6a393c3bf$export$3df06b741968da82(this.rowNode.id);
        this.rowId = rowId;
        if (rowId == null) return;
        comp.setRowId(rowId);
    }
    executeSlideAndFadeAnimations(gui) {
        const { containerType: containerType } = gui;
        const shouldSlide = this.slideInAnimation[containerType];
        if (shouldSlide) {
            $437b23f6a393c3bf$export$8ea55376d0d59592(()=>{
                this.onTopChanged();
            });
            this.slideInAnimation[containerType] = false;
        }
        const shouldFade = this.fadeInAnimation[containerType];
        if (shouldFade) {
            $437b23f6a393c3bf$export$8ea55376d0d59592(()=>{
                gui.rowComp.toggleCss("ag-opacity-zero", false);
            });
            this.fadeInAnimation[containerType] = false;
        }
    }
    addRowDraggerToRow(gui) {
        const rowDragComp = this.beans.rowDragSvc?.createRowDragCompForRow(this.rowNode, gui.element);
        if (!rowDragComp) return;
        const rowDragBean = this.createBean(rowDragComp, this.beans.context);
        this.rowDragComps.push(rowDragBean);
        gui.compBean.addDestroyFunc(()=>{
            this.rowDragComps = this.rowDragComps.filter((r)=>r !== rowDragBean);
            this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, this.beans.context);
            this.destroyBean(rowDragBean, this.beans.context);
        });
    }
    setupFullWidth(gui) {
        const pinned = this.getPinnedForContainer(gui.containerType);
        const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
        gui.rowComp.showFullWidth(compDetails);
    }
    getFullWidthCellRenderers() {
        if (this.gos.get("embedFullWidthRows")) return this.allRowGuis.map((gui)=>gui?.rowComp?.getFullWidthCellRenderer());
        return [
            this.fullWidthGui?.rowComp?.getFullWidthCellRenderer()
        ];
    }
    executeProcessRowPostCreateFunc() {
        const func = this.gos.getCallback("processRowPostCreate");
        if (!func || !this.areAllContainersReady()) return;
        const params = {
            // areAllContainersReady asserts that centerGui is not null
            eRow: this.centerGui.element,
            ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
            ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
            node: this.rowNode,
            rowIndex: this.rowNode.rowIndex,
            addRenderedRowListener: this.addEventListener.bind(this)
        };
        func(params);
    }
    areAllContainersReady() {
        const { leftGui: leftGui, centerGui: centerGui, rightGui: rightGui, beans: { visibleCols: visibleCols } } = this;
        const isLeftReady = !!leftGui || !visibleCols.isPinningLeft();
        const isCenterReady = !!centerGui;
        const isRightReady = !!rightGui || !visibleCols.isPinningRight();
        return isLeftReady && isCenterReady && isRightReady;
    }
    isNodeFullWidthCell() {
        if (this.rowNode.detail) return true;
        const isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
        return isFullWidthCellFunc ? isFullWidthCellFunc({
            rowNode: this.rowNode
        }) : false;
    }
    setRowType() {
        const isStub = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow") && !this.gos.get("groupHideOpenParents");
        const isFullWidthCell = this.isNodeFullWidthCell();
        const isDetailCell = this.gos.get("masterDetail") && this.rowNode.detail;
        const pivotMode = this.beans.colModel.isPivotMode();
        const isFullWidthGroup = $437b23f6a393c3bf$export$410912a9c501b8cc(this.gos, this.rowNode, pivotMode);
        if (isStub) this.rowType = "FullWidthLoading";
        else if (isDetailCell) this.rowType = "FullWidthDetail";
        else if (isFullWidthCell) this.rowType = "FullWidth";
        else if (isFullWidthGroup) this.rowType = "FullWidthGroup";
        else this.rowType = "Normal";
    }
    updateColumnLists(suppressAnimationFrame = false, useFlushSync = false) {
        if (this.isFullWidth()) return;
        const { animationFrameSvc: animationFrameSvc } = this.beans;
        const noAnimation = !animationFrameSvc?.active || suppressAnimationFrame || this.printLayout;
        if (noAnimation) {
            this.updateColumnListsImpl(useFlushSync);
            return;
        }
        if (this.updateColumnListsPending) return;
        animationFrameSvc.createTask(()=>{
            if (!this.active) return;
            this.updateColumnListsImpl(true);
        }, this.rowNode.rowIndex, "p1", false);
        this.updateColumnListsPending = true;
    }
    /**
   * Overridden by SpannedRowCtrl
   */ getNewCellCtrl(col) {
        const isCellSpan = this.beans.rowSpanSvc?.isCellSpanning(col, this.rowNode);
        if (isCellSpan) return void 0;
        return new $437b23f6a393c3bf$var$CellCtrl(col, this.rowNode, this.beans, this);
    }
    /**
   * Overridden by SpannedRowCtrl, if span context changes cell needs rebuilt
   */ isCorrectCtrlForSpan(cell) {
        return !this.beans.rowSpanSvc?.isCellSpanning(cell.column, this.rowNode);
    }
    createCellCtrls(prev, cols, pinned = null) {
        const res = {
            list: [],
            map: {}
        };
        const addCell = (colInstanceId, cellCtrl, index)=>{
            if (index != null) res.list.splice(index, 0, cellCtrl);
            else res.list.push(cellCtrl);
            res.map[colInstanceId] = cellCtrl;
        };
        const colsFromPrev = [];
        for (const col of cols){
            const colInstanceId = col.getInstanceId();
            let cellCtrl = prev.map[colInstanceId];
            if (cellCtrl && !this.isCorrectCtrlForSpan(cellCtrl)) {
                cellCtrl.destroy();
                cellCtrl = void 0;
            }
            if (!cellCtrl) cellCtrl = this.getNewCellCtrl(col);
            if (!cellCtrl) continue;
            addCell(colInstanceId, cellCtrl);
        }
        for (const prevCellCtrl of prev.list){
            const colInstanceId = prevCellCtrl.column.getInstanceId();
            const cellInResult = res.map[colInstanceId] != null;
            if (cellInResult) continue;
            const keepCell = !this.isCellEligibleToBeRemoved(prevCellCtrl, pinned);
            if (keepCell) colsFromPrev.push([
                colInstanceId,
                prevCellCtrl
            ]);
            else prevCellCtrl.destroy();
        }
        if (colsFromPrev.length) for (const [colInstanceId, cellCtrl] of colsFromPrev){
            const index = res.list.findIndex((ctrl)=>ctrl.column.getLeft() > cellCtrl.column.getLeft());
            const normalisedIndex = index === -1 ? void 0 : Math.max(index - 1, 0);
            addCell(colInstanceId, cellCtrl, normalisedIndex);
        }
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (focusedCell && focusedCell.column.getPinned() == pinned) {
            const focusedColInstanceId = focusedCell.column.getInstanceId();
            const focusedCellCtrl = res.map[focusedColInstanceId];
            if (!focusedCellCtrl && visibleCols.allCols.includes(focusedCell.column)) {
                const cellCtrl = this.createFocusedCellCtrl();
                if (cellCtrl) {
                    const index = res.list.findIndex((ctrl)=>ctrl.column.getLeft() > cellCtrl.column.getLeft());
                    const normalisedIndex = index === -1 ? void 0 : Math.max(index - 1, 0);
                    addCell(focusedColInstanceId, cellCtrl, normalisedIndex);
                }
            }
        }
        return res;
    }
    /**
   * Creates a new cell ctrl for the focused cell, if this is the correct row ctrl.
   * @returns a CellCtrl for the focused cell, if required.
   */ createFocusedCellCtrl() {
        const { focusSvc: focusSvc, rowSpanSvc: rowSpanSvc } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (!focusedCell) return void 0;
        const focusedSpan = rowSpanSvc?.getCellSpan(focusedCell.column, this.rowNode);
        if (focusedSpan) {
            if (focusedSpan.firstNode !== this.rowNode || !focusedSpan.doesSpanContain(focusedCell)) return void 0;
        } else if (!focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned)) return void 0;
        return this.getNewCellCtrl(focusedCell.column);
    }
    updateColumnListsImpl(useFlushSync) {
        this.updateColumnListsPending = false;
        this.createAllCellCtrls();
        this.setCellCtrls(useFlushSync);
    }
    setCellCtrls(useFlushSync) {
        for (const item of this.allRowGuis){
            const cellControls = this.getCellCtrlsForContainer(item.containerType);
            item.rowComp.setCellCtrls(cellControls, useFlushSync);
        }
    }
    getCellCtrlsForContainer(containerType) {
        switch(containerType){
            case "left":
                return this.leftCellCtrls.list;
            case "right":
                return this.rightCellCtrls.list;
            case "fullWidth":
                return [];
            case "center":
                return this.centerCellCtrls.list;
        }
    }
    createAllCellCtrls() {
        const colViewport = this.beans.colViewport;
        const presentedColsService = this.beans.visibleCols;
        if (this.printLayout) {
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, presentedColsService.allCols);
            this.leftCellCtrls = {
                list: [],
                map: {}
            };
            this.rightCellCtrls = {
                list: [],
                map: {}
            };
        } else {
            const centerCols = colViewport.getColsWithinViewport(this.rowNode);
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, centerCols);
            const leftCols = presentedColsService.getLeftColsForRow(this.rowNode);
            this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, leftCols, "left");
            const rightCols = presentedColsService.getRightColsForRow(this.rowNode);
            this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, rightCols, "right");
        }
    }
    isCellEligibleToBeRemoved(cellCtrl, nextContainerPinned) {
        const REMOVE_CELL = true;
        const KEEP_CELL = false;
        const { column: column } = cellCtrl;
        if (column.getPinned() != nextContainerPinned) return REMOVE_CELL;
        if (!this.isCorrectCtrlForSpan(cellCtrl)) return REMOVE_CELL;
        const { visibleCols: visibleCols, editSvc: editSvc } = this.beans;
        const editing = editSvc?.isEditing(cellCtrl);
        const focused = cellCtrl.isCellFocused();
        const mightWantToKeepCell = editing || focused;
        if (mightWantToKeepCell) {
            const displayedColumns = visibleCols.allCols;
            const cellStillDisplayed = displayedColumns.indexOf(column) >= 0;
            return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
        }
        return REMOVE_CELL;
    }
    getDomOrder() {
        const isEnsureDomOrder = this.gos.get("ensureDomOrder");
        return isEnsureDomOrder || $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
    }
    listenOnDomOrder(gui) {
        const listener = ()=>{
            gui.rowComp.setDomOrder(this.getDomOrder());
        };
        gui.compBean.addManagedPropertyListeners([
            "domLayout",
            "ensureDomOrder"
        ], listener);
    }
    setAnimateFlags(animateIn) {
        if (this.rowNode.sticky || !animateIn) return;
        const oldRowTopExists = $437b23f6a393c3bf$export$25d27f17d3af40f7(this.rowNode.oldRowTop);
        const { visibleCols: visibleCols } = this.beans;
        const pinningLeft = visibleCols.isPinningLeft();
        const pinningRight = visibleCols.isPinningRight();
        if (oldRowTopExists) {
            const { slideInAnimation: slideInAnimation } = this;
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                slideInAnimation.fullWidth = true;
                return;
            }
            slideInAnimation.center = true;
            slideInAnimation.left = pinningLeft;
            slideInAnimation.right = pinningRight;
        } else {
            const { fadeInAnimation: fadeInAnimation } = this;
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                fadeInAnimation.fullWidth = true;
                return;
            }
            fadeInAnimation.center = true;
            fadeInAnimation.left = pinningLeft;
            fadeInAnimation.right = pinningRight;
        }
    }
    isFullWidth() {
        return this.rowType !== "Normal";
    }
    refreshFullWidth() {
        const tryRefresh = (gui, pinned)=>{
            if (!gui) return true;
            return gui.rowComp.refreshFullWidth(()=>{
                const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
                return compDetails.params;
            });
        };
        const fullWidthSuccess = tryRefresh(this.fullWidthGui, null);
        const centerSuccess = tryRefresh(this.centerGui, null);
        const leftSuccess = tryRefresh(this.leftGui, "left");
        const rightSuccess = tryRefresh(this.rightGui, "right");
        const allFullWidthRowsRefreshed = fullWidthSuccess && centerSuccess && leftSuccess && rightSuccess;
        return allFullWidthRowsRefreshed;
    }
    addListeners() {
        const { beans: beans, gos: gos, rowNode: rowNode } = this;
        const { expansionSvc: expansionSvc, eventSvc: eventSvc, context: context, rowSpanSvc: rowSpanSvc } = beans;
        this.addManagedListeners(this.rowNode, {
            heightChanged: ()=>this.onRowHeightChanged(),
            rowSelected: ()=>this.onRowSelected(),
            rowIndexChanged: this.onRowIndexChanged.bind(this),
            topChanged: this.onTopChanged.bind(this),
            ...expansionSvc?.getRowExpandedListeners(this) ?? {}
        });
        if (rowNode.detail) this.addManagedListeners(rowNode.parent, {
            dataChanged: this.onRowNodeDataChanged.bind(this)
        });
        this.addManagedListeners(rowNode, {
            dataChanged: this.onRowNodeDataChanged.bind(this),
            cellChanged: this.postProcessCss.bind(this),
            rowHighlightChanged: this.onRowNodeHighlightChanged.bind(this),
            draggingChanged: this.postProcessRowDragging.bind(this),
            uiLevelChanged: this.onUiLevelChanged.bind(this),
            rowPinned: this.onRowPinned.bind(this)
        });
        this.addManagedListeners(eventSvc, {
            paginationPixelOffsetChanged: this.onPaginationPixelOffsetChanged.bind(this),
            heightScaleChanged: this.onTopChanged.bind(this),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            virtualColumnsChanged: this.onVirtualColumnsChanged.bind(this),
            cellFocused: this.onCellFocusChanged.bind(this),
            cellFocusCleared: this.onCellFocusChanged.bind(this),
            paginationChanged: this.onPaginationChanged.bind(this),
            modelUpdated: this.refreshFirstAndLastRowStyles.bind(this),
            columnMoved: ()=>this.updateColumnLists()
        });
        if (rowSpanSvc) this.addManagedListeners(rowSpanSvc, {
            spannedCellsUpdated: ({ pinned: pinned })=>{
                if (pinned && !rowNode.rowPinned) return;
                this.updateColumnLists();
            }
        });
        this.addDestroyFunc(()=>{
            this.rowDragComps = this.destroyBeans(this.rowDragComps, context);
            this.tooltipFeature = this.destroyBean(this.tooltipFeature, context);
            this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, context);
        });
        this.addManagedPropertyListeners([
            "rowStyle",
            "getRowStyle",
            "rowClass",
            "getRowClass",
            "rowClassRules"
        ], this.postProcessCss.bind(this));
        this.addManagedPropertyListener("rowDragEntireRow", ()=>{
            const useRowDragEntireRow = gos.get("rowDragEntireRow");
            if (useRowDragEntireRow) {
                for (const gui of this.allRowGuis)this.addRowDraggerToRow(gui);
                return;
            }
            this.rowDragComps = this.destroyBeans(this.rowDragComps, context);
        });
        this.addListenersForCellComps();
    }
    addListenersForCellComps() {
        this.addManagedListeners(this.rowNode, {
            rowIndexChanged: ()=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onRowIndexChanged();
            },
            cellChanged: (event)=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onCellChanged(event);
            }
        });
    }
    /** Should only ever be triggered on source rows (i.e. not on pinned siblings) */ onRowPinned() {
        for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-row-pinned-source", !!this.rowNode.pinnedSibling);
    }
    onRowNodeDataChanged(event) {
        this.refreshRow({
            suppressFlash: !event.update,
            newData: !event.update
        });
    }
    refreshRow(params) {
        const fullWidthChanged = this.isFullWidth() !== !!this.isNodeFullWidthCell();
        if (fullWidthChanged) {
            this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        if (this.isFullWidth()) {
            const refresh = this.refreshFullWidth();
            if (!refresh) this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        for (const cellCtrl of this.getAllCellCtrls())cellCtrl.refreshCell(params);
        for (const gui of this.allRowGuis){
            this.setRowCompRowId(gui.rowComp);
            this.updateRowBusinessKey();
            this.setRowCompRowBusinessKey(gui.rowComp);
        }
        this.onRowSelected();
        this.postProcessCss();
    }
    postProcessCss() {
        this.setStylesFromGridOptions(true);
        this.postProcessClassesFromGridOptions();
        this.postProcessRowClassRules();
        this.rowEditStyleFeature?.applyRowStyles();
        this.postProcessRowDragging();
    }
    onRowNodeHighlightChanged() {
        const rowDropHighlightSvc = this.beans.rowDropHighlightSvc;
        const highlighted = rowDropHighlightSvc?.row === this.rowNode ? rowDropHighlightSvc.position : "none";
        const aboveOn = highlighted === "above";
        const insideOn = highlighted === "inside";
        const belowOn = highlighted === "below";
        const treeData = this.gos.get("treeData");
        const indented = treeData && (belowOn || aboveOn);
        const uiLevel = this.rowNode.uiLevel.toString();
        for (const gui of this.allRowGuis){
            const rowComp = gui.rowComp;
            rowComp.toggleCss("ag-row-highlight-above", aboveOn);
            rowComp.toggleCss("ag-row-highlight-inside", insideOn);
            rowComp.toggleCss("ag-row-highlight-below", belowOn);
            rowComp.toggleCss("ag-row-highlight-indent", indented);
            if (indented) gui.element.style.setProperty("--ag-row-highlight-level", uiLevel);
            else gui.element.style.removeProperty("--ag-row-highlight-level");
        }
    }
    postProcessRowDragging() {
        const dragging = this.rowNode.dragging;
        for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-row-dragging", dragging);
    }
    onDisplayedColumnsChanged() {
        this.updateColumnLists(true);
        this.beans.rowAutoHeight?.requestCheckAutoHeight();
    }
    onVirtualColumnsChanged() {
        this.updateColumnLists(false, true);
    }
    getRowPosition() {
        return {
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(this.rowNode.rowPinned),
            rowIndex: this.rowNode.rowIndex
        };
    }
    onKeyboardNavigate(keyboardEvent) {
        const groupInfo = this.findFullWidthInfoForEvent(keyboardEvent);
        if (!groupInfo) return;
        const { rowGui: rowGui, column: column } = groupInfo;
        const currentFullWidthContainer = rowGui.element;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        if (!isFullWidthContainerFocused) return;
        const node = this.rowNode;
        const { focusSvc: focusSvc, navigation: navigation } = this.beans;
        const lastFocusedCell = focusSvc.getFocusedCell();
        const cellPosition = {
            rowIndex: node.rowIndex,
            rowPinned: node.rowPinned,
            column: lastFocusedCell?.column ?? column
        };
        navigation?.navigateToNextCell(keyboardEvent, keyboardEvent.key, cellPosition, true);
        keyboardEvent.preventDefault();
    }
    onTabKeyDown(keyboardEvent) {
        if (keyboardEvent.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(keyboardEvent)) return;
        const currentFullWidthComp = this.allRowGuis.find((c)=>c.element.contains(keyboardEvent.target));
        const currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        let isDetailGridCellFocused = false;
        if (currentFullWidthContainer && activeEl) isDetailGridCellFocused = currentFullWidthContainer.contains(activeEl) && activeEl.classList.contains("ag-cell");
        let nextEl = null;
        if (!isFullWidthContainerFocused && !isDetailGridCellFocused) nextEl = $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, currentFullWidthContainer, false, keyboardEvent.shiftKey);
        if (this.isFullWidth() && isFullWidthContainerFocused || !nextEl) this.beans.navigation?.onTabKeyDown(this, keyboardEvent);
    }
    getFullWidthElement() {
        if (this.fullWidthGui) return this.fullWidthGui.element;
        return null;
    }
    getRowYPosition() {
        const displayedEl = this.allRowGuis.find((el)=>$437b23f6a393c3bf$export$2badf4aa566524cb(el.element))?.element;
        if (displayedEl) return displayedEl.getBoundingClientRect().top;
        return 0;
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        const tabIndex = this.isFullWidth() && suppressCellFocus ? void 0 : this.gos.get("tabIndex");
        for (const gui of this.allRowGuis)$437b23f6a393c3bf$var$_addOrRemoveAttribute(gui.element, "tabindex", tabIndex);
    }
    onFullWidthRowFocused(event) {
        const node = this.rowNode;
        const isFocused = !event ? false : this.isFullWidth() && event.rowIndex === node.rowIndex && event.rowPinned == node.rowPinned;
        let element;
        if (this.fullWidthGui) element = this.fullWidthGui.element;
        else {
            const column = this.beans.colModel.getCol(event?.column);
            const pinned = column?.pinned;
            if (pinned) element = pinned === "right" ? this.rightGui?.element : this.leftGui?.element;
            else element = this.centerGui?.element;
        }
        if (!element) return;
        element.classList.toggle("ag-full-width-focus", isFocused);
        if (isFocused && event?.forceBrowserFocus) element.focus({
            preventScroll: true
        });
    }
    recreateCell(cellCtrl) {
        this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, cellCtrl);
        this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, cellCtrl);
        this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, cellCtrl);
        cellCtrl.destroy();
        this.updateColumnLists();
    }
    removeCellCtrl(prev, cellCtrlToRemove) {
        const res = {
            list: [],
            map: {}
        };
        for (const cellCtrl of prev.list){
            if (cellCtrl === cellCtrlToRemove) continue;
            res.list.push(cellCtrl);
            res.map[cellCtrl.column.getInstanceId()] = cellCtrl;
        }
        return res;
    }
    onMouseEvent(eventName, mouseEvent) {
        switch(eventName){
            case "dblclick":
                this.onRowDblClick(mouseEvent);
                break;
            case "click":
                this.onRowClick(mouseEvent);
                break;
            case "touchstart":
            case "mousedown":
                this.onRowMouseDown(mouseEvent);
                break;
        }
    }
    createRowEvent(type, domEvent) {
        const { rowNode: rowNode } = this;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            node: rowNode,
            data: rowNode.data,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            event: domEvent
        });
    }
    createRowEventWithSource(type, domEvent) {
        const event = this.createRowEvent(type, domEvent);
        event.source = this;
        return event;
    }
    onRowDblClick(mouseEvent) {
        if ($437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        const rowEvent = this.createRowEventWithSource("rowDoubleClicked", mouseEvent);
        rowEvent.isEventHandlingSuppressed = this.isSuppressMouseEvent(mouseEvent);
        this.beans.eventSvc.dispatchEvent(rowEvent);
    }
    findFullWidthInfoForEvent(event) {
        if (!event) return;
        const rowGui = this.findFullWidthRowGui(event.target);
        const column = this.getColumnForFullWidth(rowGui);
        if (!rowGui || !column) return;
        return {
            rowGui: rowGui,
            column: column
        };
    }
    findFullWidthRowGui(target) {
        return this.allRowGuis.find((c)=>c.element.contains(target));
    }
    getColumnForFullWidth(fullWidthRowGui) {
        const { visibleCols: visibleCols } = this.beans;
        switch(fullWidthRowGui?.containerType){
            case "center":
                return visibleCols.centerCols[0];
            case "left":
                return visibleCols.leftCols[0];
            case "right":
                return visibleCols.rightCols[0];
            default:
                return visibleCols.allCols[0];
        }
    }
    onRowMouseDown(mouseEvent) {
        this.lastMouseDownOnDragger = $437b23f6a393c3bf$var$_isElementChildOfClass(mouseEvent.target, "ag-row-drag", 3);
        if (!this.isFullWidth() || this.isSuppressMouseEvent(mouseEvent)) return;
        const { rangeSvc: rangeSvc, focusSvc: focusSvc } = this.beans;
        rangeSvc?.removeAllCellRanges();
        const groupInfo = this.findFullWidthInfoForEvent(mouseEvent);
        if (!groupInfo) return;
        const { rowGui: rowGui, column: column } = groupInfo;
        const element = rowGui.element;
        const target = mouseEvent.target;
        const node = this.rowNode;
        let forceBrowserFocus = mouseEvent.defaultPrevented || $437b23f6a393c3bf$export$8caf403dacd36a68();
        if (element && element.contains(target) && $437b23f6a393c3bf$var$_isFocusableFormField(target)) forceBrowserFocus = false;
        focusSvc.setFocusedCell({
            rowIndex: node.rowIndex,
            column: column,
            rowPinned: node.rowPinned,
            forceBrowserFocus: forceBrowserFocus
        });
    }
    isSuppressMouseEvent(mouseEvent) {
        const { gos: gos, rowNode: rowNode } = this;
        if (this.isFullWidth()) {
            const fullWidthRowGui = this.findFullWidthRowGui(mouseEvent.target);
            return $437b23f6a393c3bf$var$_suppressFullWidthMouseEvent(gos, fullWidthRowGui?.rowComp.getFullWidthCellRendererParams(), rowNode, mouseEvent);
        }
        const cellCtrl = $437b23f6a393c3bf$export$b5bf61dcea514250(gos, mouseEvent.target);
        return cellCtrl != null && $437b23f6a393c3bf$export$d7866551eadae1d3(gos, cellCtrl.column, rowNode, mouseEvent);
    }
    onRowClick(mouseEvent) {
        const stop = $437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent) || this.lastMouseDownOnDragger;
        if (stop) return;
        const isSuppressMouseEvent = this.isSuppressMouseEvent(mouseEvent);
        const { eventSvc: eventSvc, selectionSvc: selectionSvc } = this.beans;
        const rowEvent = this.createRowEventWithSource("rowClicked", mouseEvent);
        rowEvent.isEventHandlingSuppressed = isSuppressMouseEvent;
        eventSvc.dispatchEvent(rowEvent);
        if (isSuppressMouseEvent) return;
        selectionSvc?.handleSelectionEvent(mouseEvent, this.rowNode, "rowClicked");
    }
    setupDetailRowAutoHeight(eDetailGui) {
        if (this.rowType !== "FullWidthDetail") return;
        this.beans.masterDetailSvc?.setupDetailRowAutoHeight(this, eDetailGui);
    }
    createFullWidthCompDetails(eRow, pinned) {
        const { gos: gos, rowNode: rowNode } = this;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            fullWidth: true,
            data: rowNode.data,
            node: rowNode,
            value: rowNode.key,
            valueFormatted: rowNode.key,
            // these need to be taken out, as part of 'afterAttached' now
            eGridCell: eRow,
            eParentOfValue: eRow,
            pinned: pinned,
            addRenderedRowListener: this.addEventListener.bind(this),
            // This is not on the type of ICellRendererParams
            registerRowDragger: (rowDraggerElement, dragStartPixels, value, rowDragEntireRow)=>this.addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value, rowDragEntireRow),
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupFullWidthRowTooltip(value, shouldDisplayTooltip);
            }
        });
        const compFactory = this.beans.userCompFactory;
        switch(this.rowType){
            case "FullWidthDetail":
                return $437b23f6a393c3bf$var$_getFullWidthDetailCellRendererDetails(compFactory, params);
            case "FullWidthGroup":
                {
                    const { value: value, valueFormatted: valueFormatted } = this.beans.valueSvc.getValueForDisplay(void 0, this.rowNode, true);
                    params.value = value;
                    params.valueFormatted = valueFormatted;
                    return $437b23f6a393c3bf$var$_getFullWidthGroupCellRendererDetails(compFactory, params);
                }
            case "FullWidthLoading":
                return $437b23f6a393c3bf$var$_getFullWidthLoadingCellRendererDetails(compFactory, params);
            default:
                return $437b23f6a393c3bf$var$_getFullWidthCellRendererDetails(compFactory, params);
        }
    }
    setupFullWidthRowTooltip(value, shouldDisplayTooltip) {
        if (!this.fullWidthGui) return;
        this.tooltipFeature = this.beans.tooltipSvc?.setupFullWidthRowTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value = "", alwaysVisible) {
        const { rowDragSvc: rowDragSvc, context: context } = this.beans;
        if (!rowDragSvc || !this.isFullWidth()) return;
        const rowDragComp = rowDragSvc.createRowDragComp(()=>value, this.rowNode, void 0, rowDraggerElement, dragStartPixels, alwaysVisible);
        this.createBean(rowDragComp, context);
        this.addDestroyFunc(()=>{
            this.destroyBean(rowDragComp, context);
        });
    }
    onUiLevelChanged() {
        const newLevel = $437b23f6a393c3bf$var$calculateRowLevel(this.rowNode);
        if (this.rowLevel != newLevel) {
            const classToAdd = "ag-row-level-" + newLevel;
            const classToRemove = "ag-row-level-" + this.rowLevel;
            for (const gui of this.allRowGuis){
                gui.rowComp.toggleCss(classToAdd, true);
                gui.rowComp.toggleCss(classToRemove, false);
            }
        }
        this.rowLevel = newLevel;
    }
    isFirstRowOnPage() {
        return this.rowNode.rowIndex === this.beans.pageBounds.getFirstRow();
    }
    isLastRowOnPage() {
        return this.rowNode.rowIndex === this.beans.pageBounds.getLastRow();
    }
    refreshFirstAndLastRowStyles() {
        const newFirst = this.isFirstRowOnPage();
        const newLast = this.isLastRowOnPage();
        if (this.firstRowOnPage !== newFirst) {
            this.firstRowOnPage = newFirst;
            for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-row-first", newFirst);
        }
        if (this.lastRowOnPage !== newLast) {
            this.lastRowOnPage = newLast;
            for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-row-last", newLast);
        }
    }
    getAllCellCtrls() {
        if (this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0) return this.centerCellCtrls.list;
        const res = [
            ...this.centerCellCtrls.list,
            ...this.leftCellCtrls.list,
            ...this.rightCellCtrls.list
        ];
        return res;
    }
    postProcessClassesFromGridOptions() {
        const cssClasses = [];
        this.beans.rowStyleSvc?.processClassesFromGridOptions(cssClasses, this.rowNode);
        if (!cssClasses.length) return;
        for (const classStr of cssClasses)for (const c of this.allRowGuis)c.rowComp.toggleCss(classStr, true);
    }
    postProcessRowClassRules() {
        this.beans.rowStyleSvc?.processRowClassRules(this.rowNode, (className)=>{
            for (const gui of this.allRowGuis)gui.rowComp.toggleCss(className, true);
        }, (className)=>{
            for (const gui of this.allRowGuis)gui.rowComp.toggleCss(className, false);
        });
    }
    setStylesFromGridOptions(updateStyles, gui) {
        if (updateStyles) this.rowStyles = this.processStylesFromGridOptions();
        this.forEachGui(gui, (gui2)=>gui2.rowComp.setUserStyles(this.rowStyles));
    }
    getPinnedForContainer(rowContainerType) {
        if (rowContainerType === "left" || rowContainerType === "right") return rowContainerType;
        return null;
    }
    getInitialRowClasses(rowContainerType) {
        const pinned = this.getPinnedForContainer(rowContainerType);
        const fullWidthRow = this.isFullWidth();
        const { rowNode: rowNode, beans: beans } = this;
        const classes = [];
        classes.push("ag-row");
        classes.push(this.rowFocused ? "ag-row-focus" : "ag-row-no-focus");
        if (this.fadeInAnimation[rowContainerType]) classes.push("ag-opacity-zero");
        classes.push(rowNode.rowIndex % 2 === 0 ? "ag-row-even" : "ag-row-odd");
        if (rowNode.isRowPinned()) {
            classes.push("ag-row-pinned");
            if (beans.pinnedRowModel?.isManual()) classes.push("ag-row-pinned-manual");
        }
        if (!rowNode.isRowPinned() && rowNode.pinnedSibling) classes.push("ag-row-pinned-source");
        if (rowNode.isSelected()) classes.push("ag-row-selected");
        if (rowNode.footer) classes.push("ag-row-footer");
        classes.push("ag-row-level-" + this.rowLevel);
        if (rowNode.stub) classes.push("ag-row-loading");
        if (fullWidthRow) classes.push("ag-full-width-row");
        beans.expansionSvc?.addExpandedCss(classes, rowNode);
        if (rowNode.dragging) classes.push("ag-row-dragging");
        const { rowStyleSvc: rowStyleSvc } = beans;
        if (rowStyleSvc) {
            rowStyleSvc.processClassesFromGridOptions(classes, rowNode);
            rowStyleSvc.preProcessRowClassRules(classes, rowNode);
        }
        classes.push(this.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute");
        if (this.isFirstRowOnPage()) classes.push("ag-row-first");
        if (this.isLastRowOnPage()) classes.push("ag-row-last");
        if (fullWidthRow) {
            if (pinned === "left") classes.push("ag-cell-last-left-pinned");
            if (pinned === "right") classes.push("ag-cell-first-right-pinned");
        }
        return classes;
    }
    processStylesFromGridOptions() {
        return this.beans.rowStyleSvc?.processStylesFromGridOptions(this.rowNode) ?? this.emptyStyle;
    }
    onRowSelected(gui) {
        this.beans.selectionSvc?.onRowCtrlSelected(this, (gui2)=>{
            if (gui2 === this.centerGui || gui2 === this.fullWidthGui) this.announceDescription();
        }, gui);
    }
    announceDescription() {
        this.beans.selectionSvc?.announceAriaRowSelection(this.rowNode);
    }
    addHoverFunctionality(eGui) {
        if (!this.active) return;
        const { element: element, compBean: compBean } = eGui;
        const { rowNode: rowNode, beans: beans, gos: gos } = this;
        compBean.addManagedListeners(element, {
            // We use pointer events here instead of mouse events, as pointer events
            // are more reliable for hover detection, especially with touch devices
            // or hybrid touch + mouse devices.
            pointerenter: (e)=>{
                if (e.pointerType === "mouse") rowNode.dispatchRowEvent("mouseEnter");
            },
            pointerleave: (e)=>{
                if (e.pointerType === "mouse") rowNode.dispatchRowEvent("mouseLeave");
            }
        });
        compBean.addManagedListeners(rowNode, {
            mouseEnter: ()=>{
                if (!beans.dragSvc?.dragging && !gos.get("suppressRowHoverHighlight")) {
                    element.classList.add("ag-row-hover");
                    rowNode.setHovered(true);
                }
            },
            mouseLeave: ()=>{
                this.resetHoveredStatus(element);
            }
        });
    }
    resetHoveredStatus(el) {
        const elements = el ? [
            el
        ] : this.allRowGuis.map((gui)=>gui.element);
        for (const element of elements)element.classList.remove("ag-row-hover");
        this.rowNode.setHovered(false);
    }
    // for animation, we don't want to animate entry or exit to a very far away pixel,
    // otherwise the row would move so fast, it would appear to disappear. so this method
    // moves the row closer to the viewport if it is far away, so the row slide in / out
    // at a speed the user can see.
    roundRowTopToBounds(rowTop) {
        const range = this.beans.ctrlsSvc.getScrollFeature().getApproximateVScollPosition();
        const minPixel = this.applyPaginationOffset(range.top, true) - 100;
        const maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
        return Math.min(Math.max(minPixel, rowTop), maxPixel);
    }
    forEachGui(gui, callback) {
        if (gui) callback(gui);
        else for (const gui2 of this.allRowGuis)callback(gui2);
    }
    isRowRendered() {
        return this.allRowGuis.length > 0;
    }
    onRowHeightChanged(gui) {
        if (this.rowNode.rowHeight == null) return;
        const rowHeight = this.rowNode.rowHeight;
        const defaultRowHeight = this.beans.environment.getDefaultRowHeight();
        const isHeightFromFunc = $437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(this.gos);
        const heightFromFunc = isHeightFromFunc ? $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, this.rowNode).height : void 0;
        const lineHeight = heightFromFunc ? `${Math.min(defaultRowHeight, heightFromFunc) - 2}px` : void 0;
        this.forEachGui(gui, (gui2)=>{
            gui2.element.style.height = `${rowHeight}px`;
            if (lineHeight) gui2.element.style.setProperty("--ag-line-height", lineHeight);
        });
    }
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroyFirstPass(suppressAnimation = false) {
        this.active = false;
        const { rowNode: rowNode } = this;
        if (!suppressAnimation && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos) && !rowNode.sticky) {
            const rowStillVisibleJustNotInViewport = rowNode.rowTop != null;
            if (rowStillVisibleJustNotInViewport) {
                const rowTop = this.roundRowTopToBounds(rowNode.rowTop);
                this.setRowTop(rowTop);
            } else for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-opacity-zero", true);
        }
        if (this.fullWidthGui?.element.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) this.beans.focusSvc.attemptToRecoverFocus();
        rowNode.setHovered(false);
        const event = this.createRowEvent("virtualRowRemoved");
        this.dispatchLocalEvent(event);
        this.beans.eventSvc.dispatchEvent(event);
        super.destroy();
    }
    destroySecondPass() {
        this.allRowGuis.length = 0;
        const destroyCellCtrls = (ctrls)=>{
            for (const c of ctrls.list)c.destroy();
            return {
                list: [],
                map: {}
            };
        };
        this.centerCellCtrls = destroyCellCtrls(this.centerCellCtrls);
        this.leftCellCtrls = destroyCellCtrls(this.leftCellCtrls);
        this.rightCellCtrls = destroyCellCtrls(this.rightCellCtrls);
    }
    setFocusedClasses(gui) {
        this.forEachGui(gui, (gui2)=>{
            gui2.rowComp.toggleCss("ag-row-focus", this.rowFocused);
            gui2.rowComp.toggleCss("ag-row-no-focus", !this.rowFocused);
        });
    }
    onCellFocusChanged() {
        const { focusSvc: focusSvc } = this.beans;
        const rowFocused = focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        if (rowFocused !== this.rowFocused) {
            this.rowFocused = rowFocused;
            this.setFocusedClasses();
        }
    }
    onPaginationChanged() {
        const currentPage = this.beans.pagination?.getCurrentPage() ?? 0;
        if (this.paginationPage !== currentPage) {
            this.paginationPage = currentPage;
            this.onTopChanged();
        }
        this.refreshFirstAndLastRowStyles();
    }
    onTopChanged() {
        this.setRowTop(this.rowNode.rowTop);
    }
    onPaginationPixelOffsetChanged() {
        this.onTopChanged();
    }
    // applies pagination offset, eg if on second page, and page height is 500px, then removes
    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
    // reverse will take the offset away rather than add.
    applyPaginationOffset(topPx, reverse = false) {
        if (this.rowNode.isRowPinned() || this.rowNode.sticky) return topPx;
        const pixelOffset = this.beans.pageBounds.getPixelOffset();
        const multiplier = reverse ? 1 : -1;
        return topPx + pixelOffset * multiplier;
    }
    setRowTop(pixels) {
        if (this.printLayout) return;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(pixels)) {
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            const skipScaling = this.rowNode.isRowPinned() || this.rowNode.sticky;
            const afterScalingPixels = skipScaling ? afterPaginationPixels : this.beans.rowContainerHeight.getRealPixelPosition(afterPaginationPixels);
            const topPx = `${afterScalingPixels}px`;
            this.setRowTopStyle(topPx);
        }
    }
    // the top needs to be set into the DOM element when the element is created, not updated afterwards.
    // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
    // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
    // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
    // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
    // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
    // time, the row would animate down (ie from position zero).
    getInitialRowTop(rowContainerType) {
        return this.suppressRowTransform ? this.getInitialRowTopShared(rowContainerType) : void 0;
    }
    getInitialTransform(rowContainerType) {
        return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(rowContainerType)})`;
    }
    getInitialRowTopShared(rowContainerType) {
        if (this.printLayout) return "";
        const rowNode = this.rowNode;
        let rowTop;
        if (rowNode.sticky) rowTop = rowNode.stickyRowTop;
        else {
            const pixels = this.slideInAnimation[rowContainerType] ? this.roundRowTopToBounds(rowNode.oldRowTop) : rowNode.rowTop;
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            rowTop = rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeight.getRealPixelPosition(afterPaginationPixels);
        }
        return rowTop + "px";
    }
    setRowTopStyle(topPx) {
        for (const gui of this.allRowGuis)this.suppressRowTransform ? gui.rowComp.setTop(topPx) : gui.rowComp.setTransform(`translateY(${topPx})`);
    }
    getCellCtrl(column, skipColSpanSearch = false) {
        let res = null;
        for (const cellCtrl of this.getAllCellCtrls())if (cellCtrl.column == column) res = cellCtrl;
        if (res != null || skipColSpanSearch) return res;
        for (const cellCtrl of this.getAllCellCtrls())if (cellCtrl?.getColSpanningList().indexOf(column) >= 0) res = cellCtrl;
        return res;
    }
    onRowIndexChanged() {
        if (this.rowNode.rowIndex != null) {
            this.onCellFocusChanged();
            this.updateRowIndexes();
            this.postProcessCss();
        }
    }
    updateRowIndexes(gui) {
        const rowIndexStr = this.rowNode.getRowIndexString();
        if (rowIndexStr === null) return;
        const headerRowCount = (this.beans.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0) + (this.beans.filterManager?.getHeaderRowCount() ?? 0);
        const rowIsEven = this.rowNode.rowIndex % 2 === 0;
        const ariaRowIndex = headerRowCount + this.rowNode.rowIndex + 1;
        this.forEachGui(gui, (c)=>{
            c.rowComp.setRowIndex(rowIndexStr);
            c.rowComp.toggleCss("ag-row-even", rowIsEven);
            c.rowComp.toggleCss("ag-row-odd", !rowIsEven);
            $437b23f6a393c3bf$export$ba731dedf9d88615(c.element, ariaRowIndex);
        });
    }
};
// packages/ag-grid-community/src/navigation/navigationService.ts
var $437b23f6a393c3bf$var$NavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "navigation";
        this.onPageDown = $437b23f6a393c3bf$var$_throttle(this.onPageDown, 100);
        this.onPageUp = $437b23f6a393c3bf$var$_throttle(this.onPageUp, 100);
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    handlePageScrollingKey(event, fromFullWidth = false) {
        const key = event.key;
        const alt = event.altKey;
        const ctrl = event.ctrlKey || event.metaKey;
        const rangeServiceShouldHandleShift = !!this.beans.rangeSvc && event.shiftKey;
        const currentCell = $437b23f6a393c3bf$export$d85fcb0e6e51242(this.gos, event);
        let processed = false;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (!ctrl && !alt) {
                    this.onHomeOrEndKey(key);
                    processed = true;
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!currentCell) return false;
                if (ctrl && !alt && !rangeServiceShouldHandleShift) {
                    this.onCtrlUpDownLeftRight(key, currentCell);
                    processed = true;
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
                if (!ctrl && !alt) processed = this.handlePageUpDown(key, currentCell, fromFullWidth);
                break;
        }
        if (processed) event.preventDefault();
        return processed;
    }
    handlePageUpDown(key, currentCell, fromFullWidth) {
        if (fromFullWidth) currentCell = this.beans.focusSvc.getFocusedCell();
        if (!currentCell) return false;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) this.onPageUp(currentCell);
        else this.onPageDown(currentCell);
        return true;
    }
    navigateTo({ scrollIndex: scrollIndex, scrollType: scrollType, scrollColumn: scrollColumn, focusIndex: focusIndex, focusColumn: focusColumn, isAsync: isAsync, rowPinned: rowPinned }) {
        const { scrollFeature: scrollFeature } = this.gridBodyCon;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(scrollColumn) && !scrollColumn.isPinned()) scrollFeature.ensureColumnVisible(scrollColumn);
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(scrollIndex)) scrollFeature.ensureIndexVisible(scrollIndex, scrollType);
        if (!isAsync) scrollFeature.ensureIndexVisible(focusIndex);
        const { focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        focusSvc.setFocusedCell({
            rowIndex: focusIndex,
            column: focusColumn,
            rowPinned: rowPinned,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell({
            rowIndex: focusIndex,
            rowPinned: rowPinned,
            column: focusColumn
        });
    }
    // this method is throttled, see the `constructor`
    onPageDown(gridCell) {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const pixelsInOnePage = this.getViewportHeight();
        const { pageBounds: pageBounds, rowModel: rowModel, rowAutoHeight: rowAutoHeight } = beans;
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
        const currentPageBottomRow = rowModel.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
        if (rowAutoHeight?.active) this.navigateToNextPageWithAutoHeight(gridCell, currentPageBottomRow);
        else this.navigateToNextPage(gridCell, currentPageBottomRow);
    }
    // this method is throttled, see the `constructor`
    onPageUp(gridCell) {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const { pageBounds: pageBounds, rowModel: rowModel, rowAutoHeight: rowAutoHeight } = beans;
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentPageTopPixel = scrollPosition.top;
        const currentPageTopRow = rowModel.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
        if (rowAutoHeight?.active) this.navigateToNextPageWithAutoHeight(gridCell, currentPageTopRow, true);
        else this.navigateToNextPage(gridCell, currentPageTopRow, true);
    }
    navigateToNextPage(gridCell, scrollIndex, up = false) {
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const pixelsInOnePage = this.getViewportHeight();
        const firstRow = pageBounds.getFirstRow();
        const lastRow = pageBounds.getLastRow();
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentRowNode = rowModel.getRow(gridCell.rowIndex);
        const rowPixelDiff = up ? // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
        currentRowNode?.rowHeight - pixelsInOnePage - pagingPixelOffset : pixelsInOnePage - pagingPixelOffset;
        const nextCellPixel = currentRowNode?.rowTop + rowPixelDiff;
        let focusIndex = rowModel.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
        if (focusIndex === gridCell.rowIndex) {
            const diff = up ? -1 : 1;
            scrollIndex = focusIndex = gridCell.rowIndex + diff;
        }
        let scrollType;
        if (up) {
            scrollType = "bottom";
            if (focusIndex < firstRow) focusIndex = firstRow;
            if (scrollIndex < firstRow) scrollIndex = firstRow;
        } else {
            scrollType = "top";
            if (focusIndex > lastRow) focusIndex = lastRow;
            if (scrollIndex > lastRow) scrollIndex = lastRow;
        }
        if (this.isRowTallerThanView(rowModel.getRow(focusIndex))) {
            scrollIndex = focusIndex;
            scrollType = "top";
        }
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: scrollType,
            scrollColumn: null,
            focusIndex: focusIndex,
            focusColumn: gridCell.column
        });
    }
    navigateToNextPageWithAutoHeight(gridCell, scrollIndex, up = false) {
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: up ? "bottom" : "top",
            scrollColumn: null,
            focusIndex: scrollIndex,
            focusColumn: gridCell.column
        });
        setTimeout(()=>{
            const focusIndex = this.getNextFocusIndexForAutoHeight(gridCell, up);
            this.navigateTo({
                scrollIndex: scrollIndex,
                scrollType: up ? "bottom" : "top",
                scrollColumn: null,
                focusIndex: focusIndex,
                focusColumn: gridCell.column,
                isAsync: true
            });
        }, 50);
    }
    getNextFocusIndexForAutoHeight(gridCell, up = false) {
        const step = up ? -1 : 1;
        const pixelsInOnePage = this.getViewportHeight();
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const lastRowIndex = pageBounds.getLastRow();
        let pixelSum = 0;
        let currentIndex = gridCell.rowIndex;
        while(currentIndex >= 0 && currentIndex <= lastRowIndex){
            const currentCell = rowModel.getRow(currentIndex);
            if (currentCell) {
                const currentCellHeight = currentCell.rowHeight ?? 0;
                if (pixelSum + currentCellHeight > pixelsInOnePage) break;
                pixelSum += currentCellHeight;
            }
            currentIndex += step;
        }
        return Math.max(0, Math.min(currentIndex, lastRowIndex));
    }
    getViewportHeight() {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const scrollbarWidth = this.beans.scrollVisibleSvc.getScrollbarWidth();
        let pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
        if (beans.ctrlsSvc.get("center").isHorizontalScrollShowing()) pixelsInOnePage -= scrollbarWidth;
        return pixelsInOnePage;
    }
    isRowTallerThanView(rowNode) {
        if (!rowNode) return false;
        const rowHeight = rowNode.rowHeight;
        if (typeof rowHeight !== "number") return false;
        return rowHeight > this.getViewportHeight();
    }
    onCtrlUpDownLeftRight(key, gridCell) {
        const cellToFocus = this.beans.cellNavigation.getNextCellToFocus(key, gridCell, true);
        const normalisedPosition = this.getNormalisedPosition(cellToFocus);
        const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = normalisedPosition ?? cellToFocus;
        const col = column;
        this.navigateTo({
            scrollIndex: rowIndex,
            scrollType: null,
            scrollColumn: col,
            focusIndex: rowIndex,
            focusColumn: col,
            rowPinned: rowPinned
        });
    }
    // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
    // same cell into view (which means either scroll all the way up, or all the way down).
    onHomeOrEndKey(key) {
        const homeKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME;
        const { visibleCols: visibleCols, pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const allColumns = visibleCols.allCols;
        const scrollIndex = homeKey ? pageBounds.getFirstRow() : pageBounds.getLastRow();
        const rowNode = rowModel.getRow(scrollIndex);
        if (!rowNode) return;
        const columnToSelect = (homeKey ? allColumns : [
            ...allColumns
        ].reverse()).find((col)=>!col.isSuppressNavigable(rowNode));
        if (!columnToSelect) return;
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: null,
            scrollColumn: columnToSelect,
            focusIndex: scrollIndex,
            focusColumn: columnToSelect
        });
    }
    // result of keyboard event
    onTabKeyDown(previous, keyboardEvent) {
        const backwards = keyboardEvent.shiftKey;
        const movedToNextCell = this.tabToNextCellCommon(previous, backwards, keyboardEvent);
        const beans = this.beans;
        const { ctrlsSvc: ctrlsSvc, pageBounds: pageBounds, focusSvc: focusSvc, gos: gos } = beans;
        if (movedToNextCell !== false) {
            if (movedToNextCell) keyboardEvent.preventDefault();
            else if (movedToNextCell === null) ctrlsSvc.get("gridCtrl").allowFocusForNextCoreContainer(backwards);
            return;
        }
        if (backwards) {
            const { rowIndex: rowIndex, rowPinned: rowPinned } = previous.getRowPosition();
            const firstRow = rowPinned ? rowIndex === 0 : rowIndex === pageBounds.getFirstRow();
            if (firstRow) {
                if (gos.get("headerHeight") === 0 || $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans)) $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, true, true);
                else {
                    keyboardEvent.preventDefault();
                    focusSvc.focusPreviousFromFirstCell(keyboardEvent);
                }
            }
        } else {
            if (previous instanceof $437b23f6a393c3bf$var$CellCtrl) previous.focusCell(true);
            if (focusSvc.focusOverlay(false) || $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards)) keyboardEvent.preventDefault();
        }
    }
    // comes from API
    tabToNextCell(backwards, event) {
        const beans = this.beans;
        const { focusSvc: focusSvc, rowRenderer: rowRenderer } = beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (!focusedCell) return false;
        let cellOrRow = $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, focusedCell);
        if (!cellOrRow) {
            cellOrRow = rowRenderer.getRowByPosition(focusedCell);
            if (!cellOrRow?.isFullWidth()) return false;
        }
        return !!this.tabToNextCellCommon(cellOrRow, backwards, event, "api");
    }
    tabToNextCellCommon(previous, backwards, event, source = "ui") {
        const { editSvc: editSvc, focusSvc: focusSvc } = this.beans;
        let res = void 0;
        const cellCtrl = previous instanceof $437b23f6a393c3bf$var$CellCtrl ? previous : previous.getAllCellCtrls()?.[0];
        if (editSvc?.isEditing()) res = editSvc?.moveToNextCell(cellCtrl, backwards, event, source);
        else res = this.moveToNextCellNotEditing(previous, backwards, event);
        if (res === null) return res;
        return res || !!focusSvc.focusedHeader;
    }
    // returns null if no navigation should be performed
    moveToNextCellNotEditing(previousCell, backwards, event) {
        const displayedColumns = this.beans.visibleCols.allCols;
        let cellPos;
        if (previousCell instanceof $437b23f6a393c3bf$var$RowCtrl) {
            cellPos = {
                ...previousCell.getRowPosition(),
                column: backwards ? displayedColumns[0] : $437b23f6a393c3bf$export$236389741107357f(displayedColumns)
            };
            if (this.gos.get("embedFullWidthRows") && event) {
                const focusedContainer = previousCell.findFullWidthInfoForEvent(event);
                if (focusedContainer) cellPos.column = focusedContainer.column;
            }
        } else cellPos = previousCell.getFocusedCellPosition();
        const nextCell = this.findNextCellToFocusOn(cellPos, {
            backwards: backwards,
            startEditing: false
        });
        if (nextCell === false) return null;
        if (nextCell instanceof $437b23f6a393c3bf$var$CellCtrl) nextCell.focusCell(true);
        else if (nextCell) return this.tryToFocusFullWidthRow(nextCell, backwards);
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(nextCell);
    }
    /**
   * called by the cell, when tab is pressed while editing.
   * @returns RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */ findNextCellToFocusOn(previousPosition, { backwards: backwards, startEditing: startEditing, skipToNextEditableCell: skipToNextEditableCell }) {
        let nextPosition = previousPosition;
        const beans = this.beans;
        const { cellNavigation: cellNavigation, gos: gos, focusSvc: focusSvc, rowRenderer: rowRenderer, rangeSvc: rangeSvc } = beans;
        while(true){
            if (previousPosition !== nextPosition) previousPosition = nextPosition;
            if (!backwards) nextPosition = this.getLastCellOfColSpan(nextPosition);
            nextPosition = cellNavigation.getNextTabbedCell(nextPosition, backwards);
            const userFunc = gos.getCallback("tabToNextCell");
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userFunc)) {
                const params = {
                    backwards: backwards,
                    editing: startEditing,
                    previousCellPosition: previousPosition,
                    nextCellPosition: nextPosition ? nextPosition : null
                };
                const userResult = userFunc(params);
                if (userResult === true) nextPosition = previousPosition;
                else if (userResult === false) return false;
                else nextPosition = {
                    rowIndex: userResult.rowIndex,
                    column: userResult.column,
                    rowPinned: userResult.rowPinned
                };
            }
            if (!nextPosition) return null;
            if (nextPosition.rowIndex < 0) {
                const headerLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
                focusSvc.focusHeaderPosition({
                    headerPosition: {
                        headerRowIndex: headerLen + nextPosition.rowIndex,
                        column: nextPosition.column
                    },
                    fromCell: true
                });
                return null;
            }
            const fullRowEdit = gos.get("editType") === "fullRow";
            if (startEditing && (!fullRowEdit || skipToNextEditableCell)) {
                const cellIsEditable = this.isCellEditable(nextPosition);
                if (!cellIsEditable) continue;
            }
            this.ensureCellVisible(nextPosition);
            const nextCell = $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, nextPosition);
            if (!nextCell) {
                const row = rowRenderer.getRowByPosition(nextPosition);
                if (!row || !row.isFullWidth() || startEditing) continue;
                return {
                    ...row.getRowPosition(),
                    column: nextPosition?.column
                };
            }
            if (cellNavigation.isSuppressNavigable(nextCell.column, nextCell.rowNode)) continue;
            nextCell.setFocusedCellPosition(nextPosition);
            rangeSvc?.setRangeToCell(nextPosition);
            return nextCell;
        }
    }
    isCellEditable(cell) {
        const rowNode = this.lookupRowNodeForCell(cell);
        if (rowNode) return cell.column.isCellEditable(rowNode);
        return false;
    }
    lookupRowNodeForCell({ rowIndex: rowIndex, rowPinned: rowPinned }) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        if (rowPinned === "top") return pinnedRowModel?.getPinnedTopRow(rowIndex);
        if (rowPinned === "bottom") return pinnedRowModel?.getPinnedBottomRow(rowIndex);
        return rowModel.getRow(rowIndex);
    }
    // we use index for rows, but column object for columns, as the next column (by index) might not
    // be visible (header grouping) so it's not reliable, so using the column object instead.
    navigateToNextCell(event, key, currentCell, allowUserOverride) {
        let nextCell = currentCell;
        let hitEdgeOfGrid = false;
        const beans = this.beans;
        const { cellNavigation: cellNavigation, focusSvc: focusSvc, gos: gos } = beans;
        while(nextCell && (nextCell === currentCell || !this.isValidNavigateCell(nextCell))){
            if (gos.get("enableRtl")) {
                if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT) nextCell = this.getLastCellOfColSpan(nextCell);
            } else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT) nextCell = this.getLastCellOfColSpan(nextCell);
            nextCell = cellNavigation.getNextCellToFocus(key, nextCell);
            hitEdgeOfGrid = $437b23f6a393c3bf$export$672d9e47bc342bac(nextCell);
        }
        if (hitEdgeOfGrid && event && event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP) nextCell = {
            rowIndex: -1,
            rowPinned: null,
            column: currentCell.column
        };
        if (allowUserOverride) {
            const userFunc = gos.getCallback("navigateToNextCell");
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userFunc)) {
                const params = {
                    key: key,
                    previousCellPosition: currentCell,
                    nextCellPosition: nextCell ? nextCell : null,
                    event: event
                };
                const userCell = userFunc(params);
                if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userCell)) nextCell = {
                    rowPinned: userCell.rowPinned,
                    rowIndex: userCell.rowIndex,
                    column: userCell.column
                };
                else nextCell = null;
            }
        }
        if (!nextCell) return;
        if (nextCell.rowIndex < 0) {
            const headerLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
            focusSvc.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: headerLen + nextCell.rowIndex,
                    column: currentCell.column
                },
                event: event || void 0,
                fromCell: true
            });
            return;
        }
        const normalisedPosition = this.getNormalisedPosition(nextCell);
        if (normalisedPosition) this.focusPosition(normalisedPosition);
        else this.tryToFocusFullWidthRow(nextCell);
    }
    getNormalisedPosition(cellPosition) {
        const isSpannedCell = !!this.beans.spannedRowRenderer?.getCellByPosition(cellPosition);
        if (isSpannedCell) return cellPosition;
        this.ensureCellVisible(cellPosition);
        const cellCtrl = $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cellPosition);
        if (!cellCtrl) return null;
        cellPosition = cellCtrl.getFocusedCellPosition();
        this.ensureCellVisible(cellPosition);
        return cellPosition;
    }
    tryToFocusFullWidthRow(position, backwards) {
        const { visibleCols: visibleCols, rowRenderer: rowRenderer, focusSvc: focusSvc, eventSvc: eventSvc } = this.beans;
        const displayedColumns = visibleCols.allCols;
        const rowComp = rowRenderer.getRowByPosition(position);
        if (!rowComp?.isFullWidth()) return false;
        const currentCellFocused = focusSvc.getFocusedCell();
        const cellPosition = {
            rowIndex: position.rowIndex,
            rowPinned: position.rowPinned,
            column: position.column || (backwards ? $437b23f6a393c3bf$export$236389741107357f(displayedColumns) : displayedColumns[0])
        };
        this.focusPosition(cellPosition);
        const fromBelow = backwards == null ? currentCellFocused != null && $437b23f6a393c3bf$export$6cce97428a227a31(cellPosition, currentCellFocused) : backwards;
        eventSvc.dispatchEvent({
            type: "fullWidthRowFocused",
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned,
            column: cellPosition.column,
            isFullWidthCell: true,
            fromBelow: fromBelow
        });
        return true;
    }
    focusPosition(cellPosition) {
        const { focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        focusSvc.setFocusedCell({
            rowIndex: cellPosition.rowIndex,
            column: cellPosition.column,
            rowPinned: cellPosition.rowPinned,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell(cellPosition);
    }
    isValidNavigateCell(cell) {
        const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, cell);
        return !!rowNode;
    }
    getLastCellOfColSpan(cell) {
        const cellCtrl = $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cell);
        if (!cellCtrl) return cell;
        const colSpanningList = cellCtrl.getColSpanningList();
        if (colSpanningList.length === 1) return cell;
        return {
            rowIndex: cell.rowIndex,
            column: $437b23f6a393c3bf$export$236389741107357f(colSpanningList),
            rowPinned: cell.rowPinned
        };
    }
    ensureCellVisible(gridCell) {
        const isGroupStickyEnabled = $437b23f6a393c3bf$export$d5f33aacea6a0849(this.gos);
        const rowNode = this.beans.rowModel.getRow(gridCell.rowIndex);
        const skipScrollToRow = isGroupStickyEnabled && rowNode?.sticky;
        const { scrollFeature: scrollFeature } = this.gridBodyCon;
        if (!skipScrollToRow && $437b23f6a393c3bf$export$672d9e47bc342bac(gridCell.rowPinned)) scrollFeature.ensureIndexVisible(gridCell.rowIndex);
        if (!gridCell.column.isPinned()) scrollFeature.ensureColumnVisible(gridCell.column);
    }
    ensureColumnVisible(column) {
        const scrollFeature = this.gridBodyCon.scrollFeature;
        if (!column.isPinned()) scrollFeature.ensureColumnVisible(column);
    }
    ensureRowVisible(rowIndex) {
        const scrollFeature = this.gridBodyCon.scrollFeature;
        scrollFeature.ensureIndexVisible(rowIndex);
    }
};
function $437b23f6a393c3bf$var$getVScroll(beans) {
    return beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
// packages/ag-grid-community/src/navigation/navigationModule.ts
var $437b23f6a393c3bf$export$44f04c51d8088336 = {
    moduleName: "KeyboardNavigation",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$NavigationService,
        $437b23f6a393c3bf$var$CellNavigationService,
        $437b23f6a393c3bf$var$HeaderNavigationService
    ],
    apiFunctions: {
        getFocusedCell: $437b23f6a393c3bf$var$getFocusedCell,
        clearFocusedCell: $437b23f6a393c3bf$var$clearFocusedCell,
        setFocusedCell: $437b23f6a393c3bf$var$setFocusedCell,
        setFocusedHeader: $437b23f6a393c3bf$var$setFocusedHeader,
        tabToNextCell: $437b23f6a393c3bf$var$tabToNextCell,
        tabToPreviousCell: $437b23f6a393c3bf$var$tabToPreviousCell
    }
};
// packages/ag-grid-community/src/pagination/pageBoundsListener.ts
var $437b23f6a393c3bf$var$PageBoundsListener = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pageBoundsListener";
    }
    postConstruct() {
        this.addManagedEventListeners({
            modelUpdated: this.onModelUpdated.bind(this),
            recalculateRowBounds: this.calculatePages.bind(this)
        });
        this.onModelUpdated();
    }
    onModelUpdated(modelUpdatedEvent) {
        this.calculatePages();
        this.eventSvc.dispatchEvent({
            type: "paginationChanged",
            animate: modelUpdatedEvent?.animate ?? false,
            newData: modelUpdatedEvent?.newData ?? false,
            newPage: modelUpdatedEvent?.newPage ?? false,
            newPageSize: modelUpdatedEvent?.newPageSize ?? false,
            keepRenderedRows: modelUpdatedEvent?.keepRenderedRows ?? false
        });
    }
    calculatePages() {
        const { pageBounds: pageBounds, pagination: pagination, rowModel: rowModel } = this.beans;
        if (pagination) pagination.calculatePages();
        else pageBounds.calculateBounds(0, rowModel.getRowCount() - 1);
    }
};
// packages/ag-grid-community/src/pagination/pageBoundsService.ts
var $437b23f6a393c3bf$var$PageBoundsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pageBounds";
        this.pixelOffset = 0;
    }
    getFirstRow() {
        return this.topRowBounds?.rowIndex ?? -1;
    }
    getLastRow() {
        return this.bottomRowBounds?.rowIndex ?? -1;
    }
    getCurrentPageHeight() {
        const { topRowBounds: topRowBounds, bottomRowBounds: bottomRowBounds } = this;
        if (!topRowBounds || !bottomRowBounds) return 0;
        return Math.max(bottomRowBounds.rowTop + bottomRowBounds.rowHeight - topRowBounds.rowTop, 0);
    }
    getCurrentPagePixelRange() {
        const { topRowBounds: topRowBounds, bottomRowBounds: bottomRowBounds } = this;
        const pageFirstPixel = topRowBounds?.rowTop ?? 0;
        const pageLastPixel = bottomRowBounds ? bottomRowBounds.rowTop + bottomRowBounds.rowHeight : 0;
        return {
            pageFirstPixel: pageFirstPixel,
            pageLastPixel: pageLastPixel
        };
    }
    calculateBounds(topDisplayedRowIndex, bottomDisplayedRowIndex) {
        const { rowModel: rowModel } = this.beans;
        const topRowBounds = rowModel.getRowBounds(topDisplayedRowIndex);
        if (topRowBounds) topRowBounds.rowIndex = topDisplayedRowIndex;
        this.topRowBounds = topRowBounds;
        const bottomRowBounds = rowModel.getRowBounds(bottomDisplayedRowIndex);
        if (bottomRowBounds) bottomRowBounds.rowIndex = bottomDisplayedRowIndex;
        this.bottomRowBounds = bottomRowBounds;
        this.calculatePixelOffset();
    }
    getPixelOffset() {
        return this.pixelOffset;
    }
    calculatePixelOffset() {
        const value = this.topRowBounds?.rowTop ?? 0;
        if (this.pixelOffset === value) return;
        this.pixelOffset = value;
        this.eventSvc.dispatchEvent({
            type: "paginationPixelOffsetChanged"
        });
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnModule.css-GENERATED.ts
var $437b23f6a393c3bf$var$pinnedColumnModuleCSS = /*css*/ `.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top{min-width:0;overflow:hidden;position:relative}.ag-pinned-left-sticky-top,.ag-pinned-right-sticky-top{height:100%;overflow:hidden;position:relative}.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{height:100%;overflow:hidden;width:100%}.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;height:100%;overflow:hidden;position:relative}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible){.ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:var(--ag-pinned-column-border)}.ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:var(--ag-pinned-column-border)}}.ag-pinned-right-header{border-left:var(--ag-pinned-column-border)}.ag-pinned-left-header{border-right:var(--ag-pinned-column-border)}.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-left:var(--ag-pinned-column-border)}.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-right:var(--ag-pinned-column-border)}.ag-pinned-left-header .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-right-header .ag-header-cell-resize:after{left:50%}.ag-pinned-left-header .ag-header-cell-resize{right:-3px}.ag-pinned-right-header .ag-header-cell-resize{left:-3px}`;
// packages/ag-grid-community/src/gridBodyComp/rowContainer/setPinnedWidthFeature.ts
var $437b23f6a393c3bf$var$SetPinnedWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(isLeft, elements){
        super();
        this.isLeft = isLeft;
        this.elements = elements;
        this.getWidth = isLeft ? ()=>this.beans.pinnedCols.leftWidth : ()=>this.beans.pinnedCols.rightWidth;
    }
    postConstruct() {
        this.addManagedEventListeners({
            [`${this.isLeft ? "left" : "right"}PinnedWidthChanged`]: this.onPinnedWidthChanged.bind(this)
        });
    }
    onPinnedWidthChanged() {
        const width = this.getWidth();
        const displayed = width > 0;
        for (const element of this.elements)if (element) {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, displayed);
            $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width);
        }
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnService.ts
var $437b23f6a393c3bf$var$PinnedColumnService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pinnedCols";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
        const listener = this.checkContainerWidths.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: listener,
            displayedColumnsWidthChanged: listener
        });
        this.addManagedPropertyListener("domLayout", listener);
    }
    checkContainerWidths() {
        const { gos: gos, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        const newLeftWidth = printLayout ? 0 : visibleCols.getColsLeftWidth();
        const newRightWidth = printLayout ? 0 : visibleCols.getDisplayedColumnsRightWidth();
        if (newLeftWidth != this.leftWidth) {
            this.leftWidth = newLeftWidth;
            eventSvc.dispatchEvent({
                type: "leftPinnedWidthChanged"
            });
        }
        if (newRightWidth != this.rightWidth) {
            this.rightWidth = newRightWidth;
            eventSvc.dispatchEvent({
                type: "rightPinnedWidthChanged"
            });
        }
    }
    keepPinnedColumnsNarrowerThanViewport() {
        const eBodyViewport = this.gridBodyCtrl.eBodyViewport;
        const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(eBodyViewport);
        if (bodyWidth <= 50) return;
        const processedColumnsToRemove = this.getPinnedColumnsOverflowingViewport(bodyWidth - 50);
        const processUnpinnedColumns = this.gos.getCallback("processUnpinnedColumns");
        const { columns: columns, hasLockedPinned: hasLockedPinned } = processedColumnsToRemove;
        let columnsToRemove = columns;
        if (!columnsToRemove.length && !hasLockedPinned) return;
        if (processUnpinnedColumns) {
            const params = {
                columns: columnsToRemove,
                viewportWidth: bodyWidth
            };
            columnsToRemove = processUnpinnedColumns(params);
        }
        if (!columnsToRemove?.length) return;
        columnsToRemove = columnsToRemove.filter((col)=>!$437b23f6a393c3bf$export$3d3e7d751f0445eb(col));
        this.setColsPinned(columnsToRemove, null, "viewportSizeFeature");
    }
    createPinnedWidthFeature(isLeft, ...elements) {
        return new $437b23f6a393c3bf$var$SetPinnedWidthFeature(isLeft, elements);
    }
    setColsPinned(keys, pinned, source) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, gos: gos } = this.beans;
        if (!colModel.cols) return;
        if (!keys?.length) return;
        if ($437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print")) {
            $437b23f6a393c3bf$export$545083624300f13d(37);
            return;
        }
        colAnimation?.start();
        let actualPinned;
        if (pinned === true || pinned === "left") actualPinned = "left";
        else if (pinned === "right") actualPinned = "right";
        else actualPinned = null;
        const updatedCols = [];
        for (const key of keys){
            if (!key) continue;
            const column = colModel.getCol(key);
            if (!column) continue;
            if (column.getPinned() !== actualPinned) {
                this.setColPinned(column, actualPinned);
                updatedCols.push(column);
            }
        }
        if (updatedCols.length) {
            visibleCols.refresh(source);
            $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(this.eventSvc, updatedCols, source);
        }
        colAnimation?.finish();
    }
    initCol(column) {
        const { pinned: pinned, initialPinned: initialPinned } = column.colDef;
        if (pinned !== void 0) this.setColPinned(column, pinned);
        else this.setColPinned(column, initialPinned);
    }
    setColPinned(column, pinned) {
        if (pinned === true || pinned === "left") column.pinned = "left";
        else if (pinned === "right") column.pinned = "right";
        else column.pinned = null;
        column.dispatchStateUpdatedEvent("pinned");
    }
    setupHeaderPinnedWidth(ctrl) {
        const { scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        if (ctrl.pinned == null) return;
        const pinningLeft = ctrl.pinned === "left";
        const pinningRight = ctrl.pinned === "right";
        ctrl.hidden = true;
        const listener = ()=>{
            const width = pinningLeft ? this.leftWidth : this.rightWidth;
            if (width == null) return;
            const hidden = width == 0;
            const hiddenChanged = ctrl.hidden !== hidden;
            const isRtl = this.gos.get("enableRtl");
            const scrollbarWidth = scrollVisibleSvc.getScrollbarWidth();
            const addPaddingForScrollbar = scrollVisibleSvc.verticalScrollShowing && (isRtl && pinningLeft || !isRtl && pinningRight);
            const widthWithPadding = addPaddingForScrollbar ? width + scrollbarWidth : width;
            ctrl.comp.setPinnedContainerWidth(`${widthWithPadding}px`);
            ctrl.comp.setDisplayed(!hidden);
            if (hiddenChanged) {
                ctrl.hidden = hidden;
                ctrl.refresh();
            }
        };
        ctrl.addManagedEventListeners({
            leftPinnedWidthChanged: listener,
            rightPinnedWidthChanged: listener,
            scrollVisibilityChanged: listener,
            scrollbarWidthChanged: listener
        });
    }
    getHeaderResizeDiff(diff, column) {
        const pinned = column.getPinned();
        if (pinned) {
            const { leftWidth: leftWidth, rightWidth: rightWidth } = this;
            const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(this.beans.ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
            if (leftWidth + rightWidth + diff > bodyWidth) {
                if (bodyWidth > leftWidth + rightWidth) diff = bodyWidth - leftWidth - rightWidth;
                else return 0;
            }
        }
        return diff;
    }
    getPinnedColumnsOverflowingViewport(viewportWidth) {
        const pinnedRightWidth = this.rightWidth ?? 0;
        const pinnedLeftWidth = this.leftWidth ?? 0;
        const totalPinnedWidth = pinnedRightWidth + pinnedLeftWidth;
        let hasLockedPinned = false;
        if (totalPinnedWidth < viewportWidth) return {
            columns: [],
            hasLockedPinned: hasLockedPinned
        };
        const { visibleCols: visibleCols } = this.beans;
        const pinnedLeftColumns = [
            ...visibleCols.leftCols
        ];
        const pinnedRightColumns = [
            ...visibleCols.rightCols
        ];
        let indexRight = 0;
        let indexLeft = 0;
        const totalWidthRemoved = 0;
        const columnsToRemove = [];
        let spaceNecessary = totalPinnedWidth - totalWidthRemoved - viewportWidth;
        while((indexLeft < pinnedLeftColumns.length || indexRight < pinnedRightColumns.length) && spaceNecessary > 0){
            if (indexRight < pinnedRightColumns.length) {
                const currentColumn = pinnedRightColumns[indexRight++];
                if (currentColumn.colDef.lockPinned) {
                    hasLockedPinned = true;
                    continue;
                }
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
            if (indexLeft < pinnedLeftColumns.length && spaceNecessary > 0) {
                const currentColumn = pinnedLeftColumns[indexLeft++];
                if (currentColumn.colDef.lockPinned) {
                    hasLockedPinned = true;
                    continue;
                }
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
        }
        return {
            columns: columnsToRemove,
            hasLockedPinned: hasLockedPinned
        };
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnModule.ts
var $437b23f6a393c3bf$var$PinnedColumnModule = {
    moduleName: "PinnedColumn",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PinnedColumnService
    ],
    css: [
        $437b23f6a393c3bf$var$pinnedColumnModuleCSS
    ]
};
// packages/ag-grid-community/src/rendering/ariaAnnouncementService.ts
var $437b23f6a393c3bf$var$AriaAnnouncementService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "ariaAnnounce";
        this.descriptionContainer = null;
        this.pendingAnnouncements = /* @__PURE__ */ new Map();
        this.lastAnnouncement = "";
        this.updateAnnouncement = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.updateAnnouncement.bind(this), 200);
    }
    postConstruct() {
        const beans = this.beans;
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        const div = this.descriptionContainer = eDocument.createElement("div");
        div.classList.add("ag-aria-description-container");
        $437b23f6a393c3bf$var$_setAriaLive(div, "polite");
        $437b23f6a393c3bf$var$_setAriaRelevant(div, "additions text");
        $437b23f6a393c3bf$var$_setAriaAtomic(div, true);
        beans.eGridDiv.appendChild(div);
    }
    /**
   * @param key used for debouncing calls
   */ announceValue(value, key) {
        this.pendingAnnouncements.set(key, value);
        this.updateAnnouncement();
    }
    updateAnnouncement() {
        if (!this.descriptionContainer) return;
        const value = Array.from(this.pendingAnnouncements.values()).join(". ");
        this.pendingAnnouncements.clear();
        this.descriptionContainer.textContent = "";
        setTimeout(()=>{
            this.handleAnnouncementUpdate(value);
        }, 50);
    }
    handleAnnouncementUpdate(value) {
        if (!this.isAlive() || !this.descriptionContainer) return;
        let valueToAnnounce = value;
        if (valueToAnnounce == null || valueToAnnounce.replace(/[ .]/g, "") == "") {
            this.lastAnnouncement = "";
            return;
        }
        if (this.lastAnnouncement === valueToAnnounce) valueToAnnounce = `${valueToAnnounce}\u200B`;
        this.lastAnnouncement = valueToAnnounce;
        this.descriptionContainer.textContent = valueToAnnounce;
    }
    destroy() {
        super.destroy();
        const { descriptionContainer: descriptionContainer } = this;
        if (descriptionContainer) {
            $437b23f6a393c3bf$export$69e6e10709eabd91(descriptionContainer);
            descriptionContainer.remove();
        }
        this.descriptionContainer = null;
        this.pendingAnnouncements.clear();
    }
};
// packages/ag-grid-community/src/rendering/ariaModule.ts
var $437b23f6a393c3bf$var$AriaModule = {
    moduleName: "Aria",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AriaAnnouncementService
    ]
};
// packages/ag-grid-community/src/rendering/column-delay-render.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnDelayRenderCSS = /*css*/ `:where(.ag-delay-render){.ag-cell,.ag-header-cell,.ag-header-group-cell,.ag-row,.ag-spanned-cell-wrapper{visibility:hidden}}`;
// packages/ag-grid-community/src/rendering/columnDelayRenderService.ts
var $437b23f6a393c3bf$var$HideClass = "ag-delay-render";
var $437b23f6a393c3bf$var$ColumnDelayRenderService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colDelayRenderSvc";
        this.hideRequested = false;
        this.alreadyRevealed = false;
        this.timesRetried = 0;
        this.requesters = /* @__PURE__ */ new Set();
    }
    hideColumns(key) {
        if (this.alreadyRevealed || this.requesters.has(key)) return;
        this.requesters.add(key);
        if (!this.hideRequested) {
            this.beans.ctrlsSvc.whenReady(this, (p)=>{
                p.gridBodyCtrl.eGridBody.classList.add($437b23f6a393c3bf$var$HideClass);
            });
            this.hideRequested = true;
        }
    }
    revealColumns(key) {
        if (this.alreadyRevealed || !this.isAlive()) return;
        this.requesters.delete(key);
        if (this.requesters.size > 0) return;
        const { renderStatus: renderStatus, ctrlsSvc: ctrlsSvc } = this.beans;
        if (renderStatus) {
            if (!renderStatus.areHeaderCellsRendered() && this.timesRetried < 5) {
                this.timesRetried++;
                setTimeout(()=>this.revealColumns(key));
                return;
            }
            this.timesRetried = 0;
        }
        ctrlsSvc.getGridBodyCtrl().eGridBody.classList.remove($437b23f6a393c3bf$var$HideClass);
        this.alreadyRevealed = true;
    }
};
var $437b23f6a393c3bf$var$ColumnDelayRenderModule = {
    moduleName: "ColumnDelayRender",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnDelayRenderService
    ],
    css: [
        $437b23f6a393c3bf$var$columnDelayRenderCSS
    ]
};
// packages/ag-grid-community/src/rendering/overlays/overlayApi.ts
function $437b23f6a393c3bf$var$showLoadingOverlay(beans) {
    beans.overlays?.showLoadingOverlay();
}
function $437b23f6a393c3bf$var$showNoRowsOverlay(beans) {
    beans.overlays?.showNoRowsOverlay();
}
function $437b23f6a393c3bf$var$hideOverlay(beans) {
    beans.overlays?.hideOverlay();
}
// packages/ag-grid-community/src/rendering/overlays/overlayWrapperComponent.css-GENERATED.ts
var $437b23f6a393c3bf$var$overlayWrapperComponentCSS = /*css*/ `.ag-overlay{inset:0;pointer-events:none;position:absolute;z-index:2}.ag-overlay-panel,.ag-overlay-wrapper{display:flex;height:100%;width:100%}.ag-overlay-wrapper{align-items:center;flex:none;justify-content:center;text-align:center}.ag-overlay-loading-wrapper{pointer-events:all}.ag-overlay-loading-center{background:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-popup-shadow);padding:var(--ag-spacing)}`;
// packages/ag-grid-community/src/rendering/overlays/overlayWrapperComponent.ts
var $437b23f6a393c3bf$var$OverlayWrapperElement = {
    tag: "div",
    cls: "ag-overlay",
    role: "presentation",
    children: [
        {
            tag: "div",
            cls: "ag-overlay-panel",
            role: "presentation",
            children: [
                {
                    tag: "div",
                    ref: "eOverlayWrapper",
                    cls: "ag-overlay-wrapper",
                    role: "presentation"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$OverlayWrapperComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$OverlayWrapperElement);
        this.eOverlayWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.activePromise = null;
        this.activeOverlay = null;
        this.updateListenerDestroyFunc = null;
        this.activeCssClass = null;
        this.elToFocusAfter = null;
        this.registerCSS($437b23f6a393c3bf$var$overlayWrapperComponentCSS);
    }
    handleKeyDown(e) {
        if (e.key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || e.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(e)) return;
        const beans = this.beans;
        const nextEl = $437b23f6a393c3bf$export$83fc12531358bd28(beans, this.eOverlayWrapper, false, e.shiftKey);
        if (nextEl) return;
        let isFocused = false;
        if (e.shiftKey) isFocused = beans.focusSvc.focusGridView({
            column: $437b23f6a393c3bf$export$236389741107357f(beans.visibleCols.allCols),
            backwards: true,
            canFocusOverlay: false
        });
        else isFocused = $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, false);
        if (isFocused) e.preventDefault();
    }
    updateLayoutClasses(cssClass, params) {
        const overlayWrapperClassList = this.eOverlayWrapper.classList;
        const { AUTO_HEIGHT: AUTO_HEIGHT, NORMAL: NORMAL, PRINT: PRINT } = $437b23f6a393c3bf$var$LayoutCssClasses;
        overlayWrapperClassList.toggle(AUTO_HEIGHT, params.autoHeight);
        overlayWrapperClassList.toggle(NORMAL, params.normal);
        overlayWrapperClassList.toggle(PRINT, params.print);
    }
    postConstruct() {
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this));
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
        this.beans.overlays.setOverlayWrapperComp(this);
        this.addManagedElementListeners(this.getFocusableElement(), {
            keydown: this.handleKeyDown.bind(this)
        });
    }
    setWrapperTypeClass(overlayWrapperCssClass) {
        const overlayWrapperClassList = this.eOverlayWrapper.classList;
        if (this.activeCssClass) overlayWrapperClassList.toggle(this.activeCssClass, false);
        this.activeCssClass = overlayWrapperCssClass;
        overlayWrapperClassList.toggle(overlayWrapperCssClass, true);
    }
    showOverlay(overlayComponentPromise, overlayWrapperCssClass, exclusive, gridOption) {
        this.setWrapperTypeClass(overlayWrapperCssClass);
        this.destroyActiveOverlay();
        this.elToFocusAfter = null;
        this.activePromise = overlayComponentPromise;
        if (!overlayComponentPromise) return;
        this.setDisplayed(true, {
            skipAriaHidden: true
        });
        if (exclusive && this.isGridFocused()) {
            const activeElement = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
            if (activeElement && !$437b23f6a393c3bf$export$8ff9eef09a45371f(this.beans)) this.elToFocusAfter = activeElement;
        }
        overlayComponentPromise.then((comp)=>{
            if (this.activePromise !== overlayComponentPromise) {
                if (this.activeOverlay !== comp) {
                    this.destroyBean(comp);
                    comp = null;
                }
                return;
            }
            this.activePromise = null;
            if (!comp) return;
            if (this.activeOverlay !== comp) {
                this.eOverlayWrapper.appendChild(comp.getGui());
                this.activeOverlay = comp;
                if (gridOption) {
                    const component = comp;
                    this.updateListenerDestroyFunc = this.addManagedPropertyListener(gridOption, ({ currentValue: currentValue })=>{
                        component.refresh?.($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                            ...currentValue ?? {}
                        }));
                    });
                }
            }
            if (exclusive && this.isGridFocused()) $437b23f6a393c3bf$export$8598088d375f416f(this.eOverlayWrapper);
        });
    }
    updateOverlayWrapperPaddingTop(padding) {
        this.eOverlayWrapper.style.setProperty("padding-top", `${padding}px`);
    }
    destroyActiveOverlay() {
        this.activePromise = null;
        const activeOverlay = this.activeOverlay;
        if (!activeOverlay) return;
        let elementToFocus = this.elToFocusAfter;
        this.activeOverlay = null;
        this.elToFocusAfter = null;
        if (elementToFocus && !this.isGridFocused()) elementToFocus = null;
        const updateListenerDestroyFunc = this.updateListenerDestroyFunc;
        if (updateListenerDestroyFunc) {
            updateListenerDestroyFunc();
            this.updateListenerDestroyFunc = null;
        }
        this.destroyBean(activeOverlay);
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eOverlayWrapper);
        elementToFocus?.focus?.({
            preventScroll: true
        });
    }
    hideOverlay() {
        this.destroyActiveOverlay();
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
    }
    isGridFocused() {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return !!activeEl && this.beans.eGridDiv.contains(activeEl);
    }
    destroy() {
        this.elToFocusAfter = null;
        this.destroyActiveOverlay();
        this.beans.overlays.setOverlayWrapperComp(void 0);
        super.destroy();
    }
};
var $437b23f6a393c3bf$var$OverlayWrapperSelector = {
    selector: "AG-OVERLAY-WRAPPER",
    component: $437b23f6a393c3bf$var$OverlayWrapperComponent
};
// packages/ag-grid-community/src/rendering/overlays/overlayService.ts
var $437b23f6a393c3bf$var$OverlayService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "overlays";
        this.state = 0 /* Hidden */ ;
        this.showInitialOverlay = true;
        this.wrapperPadding = 0;
    }
    postConstruct() {
        this.isClientSide = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos);
        this.isServerSide = !this.isClientSide && $437b23f6a393c3bf$export$cf1bac0013650216(this.gos);
        const updateOverlayVisibility = ()=>this.updateOverlayVisibility();
        this.addManagedEventListeners({
            newColumnsLoaded: updateOverlayVisibility,
            rowDataUpdated: updateOverlayVisibility,
            gridSizeChanged: this.refreshWrapperPadding.bind(this),
            rowCountReady: ()=>{
                this.showInitialOverlay = false;
                this.updateOverlayVisibility();
            }
        });
        this.addManagedPropertyListener("loading", updateOverlayVisibility);
    }
    setOverlayWrapperComp(overlayWrapperComp) {
        this.eWrapper = overlayWrapperComp;
        this.updateOverlayVisibility();
    }
    /** Returns true if the overlay is visible. */ isVisible() {
        return this.state !== 0 /* Hidden */  && !!this.eWrapper;
    }
    /** Returns true if the overlay is visible and is exclusive (popup over the grid) */ isExclusive() {
        return this.state === 1 /* Loading */  && !!this.eWrapper;
    }
    showLoadingOverlay() {
        this.showInitialOverlay = false;
        const gos = this.gos;
        const loading = gos.get("loading");
        if (!loading && (loading !== void 0 || gos.get("suppressLoadingOverlay"))) return;
        this.doShowLoadingOverlay();
    }
    showNoRowsOverlay() {
        this.showInitialOverlay = false;
        const gos = this.gos;
        if (gos.get("loading") || gos.get("suppressNoRowsOverlay")) return;
        this.doShowNoRowsOverlay();
    }
    hideOverlay() {
        this.showInitialOverlay = false;
        if (this.gos.get("loading")) {
            $437b23f6a393c3bf$export$545083624300f13d(99);
            return;
        }
        this.doHideOverlay();
    }
    getOverlayWrapperSelector() {
        return $437b23f6a393c3bf$var$OverlayWrapperSelector;
    }
    getOverlayWrapperCompClass() {
        return $437b23f6a393c3bf$var$OverlayWrapperComponent;
    }
    updateOverlayVisibility() {
        if (!this.eWrapper) {
            this.state = 0 /* Hidden */ ;
            return;
        }
        const { state: state, isClientSide: isClientSide, isServerSide: isServerSide, beans: { gos: gos, colModel: colModel, rowModel: rowModel } } = this;
        let loading = this.gos.get("loading");
        if (loading !== void 0) this.showInitialOverlay = false;
        if (this.showInitialOverlay && loading === void 0 && !gos.get("suppressLoadingOverlay")) loading = !gos.get("columnDefs") || !colModel.ready || !gos.get("rowData") && isClientSide;
        if (loading) {
            if (state !== 1 /* Loading */ ) this.doShowLoadingOverlay();
        } else {
            this.showInitialOverlay = false;
            if (isClientSide && rowModel.isEmpty() && !gos.get("suppressNoRowsOverlay")) {
                if (state !== 2 /* NoRows */ ) this.doShowNoRowsOverlay();
            } else if (state === 1 /* Loading */  || !isServerSide && state !== 0 /* Hidden */ ) this.doHideOverlay();
        }
    }
    doShowLoadingOverlay() {
        if (!this.eWrapper) return;
        this.state = 1 /* Loading */ ;
        this.showOverlay($437b23f6a393c3bf$var$_getLoadingOverlayCompDetails(this.beans.userCompFactory, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {})), "ag-overlay-loading-wrapper", "loadingOverlayComponentParams");
        this.updateExclusive();
    }
    doShowNoRowsOverlay() {
        if (!this.eWrapper) return;
        this.state = 2 /* NoRows */ ;
        this.showOverlay($437b23f6a393c3bf$var$_getNoRowsOverlayCompDetails(this.beans.userCompFactory, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {})), "ag-overlay-no-rows-wrapper", "noRowsOverlayComponentParams");
        this.updateExclusive();
    }
    doHideOverlay() {
        if (!this.eWrapper) return;
        this.state = 0 /* Hidden */ ;
        this.eWrapper.hideOverlay();
        this.updateExclusive();
    }
    showOverlay(compDetails, wrapperCssClass, gridOption) {
        const promise = compDetails?.newAgStackInstance() ?? null;
        this.eWrapper?.showOverlay(promise, wrapperCssClass, this.isExclusive(), gridOption);
        this.refreshWrapperPadding();
    }
    updateExclusive() {
        const wasExclusive = this.exclusive;
        this.exclusive = this.isExclusive();
        if (this.exclusive !== wasExclusive) this.eventSvc.dispatchEvent({
            type: "overlayExclusiveChanged"
        });
    }
    refreshWrapperPadding() {
        const eWrapper = this.eWrapper;
        if (!eWrapper) return;
        let newPadding = 0;
        if (this.state === 2 /* NoRows */ ) {
            const headerCtrl = this.beans.ctrlsSvc.get("gridHeaderCtrl");
            const headerHeight = headerCtrl?.headerHeight || 0;
            newPadding = headerHeight;
        }
        if (this.wrapperPadding === newPadding) return;
        this.wrapperPadding = newPadding;
        eWrapper.updateOverlayWrapperPaddingTop(newPadding);
    }
};
// packages/ag-grid-community/src/rendering/overlays/overlayModule.ts
var $437b23f6a393c3bf$var$OverlayModule = {
    moduleName: "Overlay",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agLoadingOverlay: $437b23f6a393c3bf$var$LoadingOverlayComponent2,
        agNoRowsOverlay: $437b23f6a393c3bf$var$NoRowsOverlayComponent2
    },
    apiFunctions: {
        showLoadingOverlay: $437b23f6a393c3bf$var$showLoadingOverlay,
        showNoRowsOverlay: $437b23f6a393c3bf$var$showNoRowsOverlay,
        hideOverlay: $437b23f6a393c3bf$var$hideOverlay
    },
    beans: [
        $437b23f6a393c3bf$var$OverlayService
    ]
};
// packages/ag-grid-community/src/rendering/rowContainerHeightService.ts
var $437b23f6a393c3bf$var$RowContainerHeightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowContainerHeight";
        // the scrollY position
        this.scrollY = 0;
        // how tall the body is
        this.uiBodyHeight = 0;
    }
    postConstruct() {
        this.addManagedEventListeners({
            bodyHeightChanged: this.updateOffset.bind(this)
        });
        this.maxDivHeight = $437b23f6a393c3bf$var$_getMaxDivHeight();
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, "RowContainerHeightService - maxDivHeight = " + this.maxDivHeight);
    }
    updateOffset() {
        if (!this.stretching) return;
        const newScrollY = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition().top;
        const newBodyHeight = this.getUiBodyHeight();
        const atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;
        if (atLeastOneChanged) {
            this.scrollY = newScrollY;
            this.uiBodyHeight = newBodyHeight;
            this.calculateOffset();
        }
    }
    calculateOffset() {
        this.setUiContainerHeight(this.maxDivHeight);
        this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
        this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
        const scrollPercent = this.scrollY / this.maxScrollY;
        const divStretchOffset = scrollPercent * this.pixelsToShave;
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowContainerHeightService - Div Stretch Offset = ${divStretchOffset} (${this.pixelsToShave} * ${scrollPercent})`);
        this.setDivStretchOffset(divStretchOffset);
    }
    setUiContainerHeight(height) {
        if (height !== this.uiContainerHeight) {
            this.uiContainerHeight = height;
            this.eventSvc.dispatchEvent({
                type: "rowContainerHeightChanged"
            });
        }
    }
    clearOffset() {
        this.setUiContainerHeight(this.modelHeight);
        this.pixelsToShave = 0;
        this.setDivStretchOffset(0);
    }
    setDivStretchOffset(newOffset) {
        const newOffsetFloor = typeof newOffset === "number" ? Math.floor(newOffset) : null;
        if (this.divStretchOffset === newOffsetFloor) return;
        this.divStretchOffset = newOffsetFloor;
        this.eventSvc.dispatchEvent({
            type: "heightScaleChanged"
        });
    }
    setModelHeight(modelHeight) {
        this.modelHeight = modelHeight;
        this.stretching = modelHeight != null && // null happens when in print layout
        this.maxDivHeight > 0 && modelHeight > this.maxDivHeight;
        if (this.stretching) this.calculateOffset();
        else this.clearOffset();
    }
    getRealPixelPosition(modelPixel) {
        return modelPixel - this.divStretchOffset;
    }
    getUiBodyHeight() {
        const pos = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
        return pos.bottom - pos.top;
    }
    getScrollPositionForPixel(rowTop) {
        if (this.pixelsToShave <= 0) return rowTop;
        const modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
        const scrollPercent = rowTop / modelMaxScroll;
        const scrollPixel = this.maxScrollY * scrollPercent;
        return scrollPixel;
    }
};
// packages/ag-grid-community/src/rendering/rowRenderer.ts
var $437b23f6a393c3bf$var$ROW_ANIMATION_TIMEOUT = 400;
var $437b23f6a393c3bf$var$RowRenderer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowRenderer";
        this.destroyFuncsForColumnListeners = [];
        // map of row ids to row objects. keeps track of which elements
        // are rendered for which rows in the dom.
        this.rowCtrlsByRowIndex = {};
        this.zombieRowCtrls = {};
        this.allRowCtrls = [];
        this.topRowCtrls = [];
        this.bottomRowCtrls = [];
        // we only allow one refresh at a time, otherwise the internal memory structure here
        // will get messed up. this can happen if the user has a cellRenderer, and inside the
        // renderer they call an API method that results in another pass of the refresh,
        // then it will be trying to draw rows in the middle of a refresh.
        this.refreshInProgress = false;
        this.dataFirstRenderedFired = false;
        this.setupRangeSelectionListeners = ()=>{
            const onCellSelectionChanged = ()=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onCellSelectionChanged();
            };
            const onColumnMovedPinnedVisible = ()=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.updateRangeBordersIfRangeCount();
            };
            const addCellSelectionListeners = ()=>{
                this.eventSvc.addListener("cellSelectionChanged", onCellSelectionChanged);
                this.eventSvc.addListener("columnMoved", onColumnMovedPinnedVisible);
                this.eventSvc.addListener("columnPinned", onColumnMovedPinnedVisible);
                this.eventSvc.addListener("columnVisible", onColumnMovedPinnedVisible);
            };
            const removeCellSelectionListeners = ()=>{
                this.eventSvc.removeListener("cellSelectionChanged", onCellSelectionChanged);
                this.eventSvc.removeListener("columnMoved", onColumnMovedPinnedVisible);
                this.eventSvc.removeListener("columnPinned", onColumnMovedPinnedVisible);
                this.eventSvc.removeListener("columnVisible", onColumnMovedPinnedVisible);
            };
            this.addDestroyFunc(()=>removeCellSelectionListeners());
            this.addManagedPropertyListeners([
                "enableRangeSelection",
                "cellSelection"
            ], ()=>{
                const isEnabled = $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos);
                if (isEnabled) addCellSelectionListeners();
                else removeCellSelectionListeners();
            });
            const cellSelectionEnabled = $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos);
            if (cellSelectionEnabled) addCellSelectionListeners();
        };
    }
    wireBeans(beans) {
        this.pageBounds = beans.pageBounds;
        this.colModel = beans.colModel;
        this.pinnedRowModel = beans.pinnedRowModel;
        this.rowModel = beans.rowModel;
        this.focusSvc = beans.focusSvc;
        this.rowContainerHeight = beans.rowContainerHeight;
        this.ctrlsSvc = beans.ctrlsSvc;
        this.editSvc = beans.editSvc;
    }
    postConstruct() {
        this.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.initialise();
        });
    }
    initialise() {
        this.addManagedEventListeners({
            paginationChanged: this.onPageLoaded.bind(this),
            pinnedRowDataChanged: this.onPinnedRowDataChanged.bind(this),
            pinnedRowsChanged: this.onPinnedRowsChanged.bind(this),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            bodyScroll: this.onBodyScroll.bind(this),
            bodyHeightChanged: this.redraw.bind(this, {})
        });
        this.addManagedPropertyListeners([
            "domLayout",
            "embedFullWidthRows"
        ], ()=>this.onDomLayoutChanged());
        this.addManagedPropertyListeners([
            "suppressMaxRenderedRowRestriction",
            "rowBuffer"
        ], ()=>this.redraw());
        this.addManagedPropertyListener("suppressCellFocus", (e)=>this.onSuppressCellFocusChanged(e.currentValue));
        this.addManagedPropertyListeners([
            "groupSuppressBlankHeader",
            "getBusinessKeyForNode",
            "fullWidthCellRenderer",
            "fullWidthCellRendererParams",
            "suppressStickyTotalRow",
            "groupRowRenderer",
            "groupRowRendererParams",
            // maybe only needs to refresh FW rows...
            "loadingCellRenderer",
            "loadingCellRendererParams",
            "detailCellRenderer",
            "detailCellRendererParams",
            "enableRangeSelection",
            "enableCellTextSelection"
        ], ()=>this.redrawRows());
        this.addManagedPropertyListener("cellSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            if (!previousValue && currentValue || previousValue && !currentValue) this.redrawRows();
        });
        const { stickyRowSvc: stickyRowSvc, gos: gos, showRowGroupCols: showRowGroupCols } = this.beans;
        if (showRowGroupCols) this.addManagedPropertyListener("showOpenedGroup", ()=>{
            const columns = showRowGroupCols.getShowRowGroupCols();
            if (columns.length) this.refreshCells({
                columns: columns,
                force: true
            });
        });
        if (stickyRowSvc) this.stickyRowFeature = stickyRowSvc.createStickyRowFeature(this, this.createRowCon.bind(this), this.destroyRowCtrls.bind(this));
        else {
            const gridBodyCtrl = this.gridBodyCtrl;
            gridBodyCtrl.setStickyTopHeight(0);
            gridBodyCtrl.setStickyBottomHeight(0);
        }
        this.registerCellEventListeners();
        this.initialiseCache();
        this.printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        this.embedFullWidthRows = this.printLayout || gos.get("embedFullWidthRows");
        this.redrawAfterModelUpdate();
    }
    initialiseCache() {
        if (this.gos.get("keepDetailRows")) {
            const countProp = this.getKeepDetailRowsCount();
            const count = countProp != null ? countProp : 3;
            this.cachedRowCtrls = new $437b23f6a393c3bf$var$RowCtrlCache(count);
        }
    }
    getKeepDetailRowsCount() {
        return this.gos.get("keepDetailRowsCount");
    }
    getStickyTopRowCtrls() {
        return this.stickyRowFeature?.stickyTopRowCtrls ?? [];
    }
    getStickyBottomRowCtrls() {
        return this.stickyRowFeature?.stickyBottomRowCtrls ?? [];
    }
    updateAllRowCtrls() {
        const liveList = Object.values(this.rowCtrlsByRowIndex);
        const zombieList = Object.values(this.zombieRowCtrls);
        const cachedList = this.cachedRowCtrls?.getEntries() ?? [];
        if (zombieList.length > 0 || cachedList.length > 0) this.allRowCtrls = [
            ...liveList,
            ...zombieList,
            ...cachedList
        ];
        else this.allRowCtrls = liveList;
    }
    /**
   * Checks if the cell is rendered or not. Also returns true if row ctrl is present but has not rendered
   * cells yet.
   * @returns true if cellCtrl is present, or if the row is present but has not rendered rows yet
   */ isCellBeingRendered(rowIndex, column) {
        const rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
        if (!column || !rowCtrl) return !!rowCtrl;
        if (rowCtrl.isFullWidth()) return true;
        const spannedCell = this.beans.spannedRowRenderer?.getCellByPosition({
            rowIndex: rowIndex,
            column: column,
            rowPinned: null
        });
        return !!spannedCell || !!rowCtrl.getCellCtrl(column) || !rowCtrl.isRowRendered();
    }
    /**
   * Notifies all row and cell controls of any change in focused cell.
   * @param event cell focused event
   */ updateCellFocus(event) {
        for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onCellFocused(event);
        for (const rowCtrl of this.getFullWidthRowCtrls())rowCtrl.onFullWidthRowFocused(event);
    }
    /**
   * Called when a new cell is focused in the grid
   * - if the focused cell isn't rendered; re-draw rows to dry to render it
   * - subsequently updates all cell and row controls with the new focused cell
   * @param event cell focused event
   */ onCellFocusChanged(event) {
        if (event?.rowIndex != null && !event.rowPinned) {
            const col = this.beans.colModel.getCol(event.column) ?? void 0;
            if (!this.isCellBeingRendered(event.rowIndex, col)) this.redraw();
        }
        this.updateCellFocus(event);
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onSuppressCellFocusChanged(suppressCellFocus);
        for (const rowCtrl of this.getFullWidthRowCtrls())rowCtrl.onSuppressCellFocusChanged(suppressCellFocus);
    }
    // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
    // registering and de-registering for events is a performance bottleneck. so we register here once and inform
    // all active cells.
    registerCellEventListeners() {
        this.addManagedEventListeners({
            cellFocused: (event)=>this.onCellFocusChanged(event),
            cellFocusCleared: ()=>this.updateCellFocus(),
            flashCells: (event)=>{
                const { cellFlashSvc: cellFlashSvc } = this.beans;
                if (cellFlashSvc) for (const cellCtrl of this.getAllCellCtrls())cellFlashSvc.onFlashCells(cellCtrl, event);
            },
            columnHoverChanged: ()=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onColumnHover();
            },
            displayedColumnsChanged: ()=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onDisplayedColumnsChanged();
            },
            displayedColumnsWidthChanged: ()=>{
                if (this.printLayout) for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onLeftChanged();
            }
        });
        this.setupRangeSelectionListeners();
        this.refreshListenersToColumnsForCellComps();
        this.addManagedEventListeners({
            gridColumnsChanged: this.refreshListenersToColumnsForCellComps.bind(this)
        });
        this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
    }
    // executes all functions in destroyFuncsForColumnListeners and then clears the list
    removeGridColumnListeners() {
        for (const func of this.destroyFuncsForColumnListeners)func();
        this.destroyFuncsForColumnListeners.length = 0;
    }
    // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
    // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
    // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
    // once instead.
    refreshListenersToColumnsForCellComps() {
        this.removeGridColumnListeners();
        const cols = this.colModel.getCols();
        for (const col of cols){
            const forEachCellWithThisCol = (callback)=>{
                for (const cellCtrl of this.getAllCellCtrls())if (cellCtrl.column === col) callback(cellCtrl);
            };
            const leftChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLeftChanged());
            };
            const widthChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onWidthChanged());
            };
            const firstRightPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onFirstRightPinnedChanged());
            };
            const lastLeftPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLastLeftPinnedChanged());
            };
            const colDefChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onColDefChanged());
            };
            col.__addEventListener("leftChanged", leftChangedListener);
            col.__addEventListener("widthChanged", widthChangedListener);
            col.__addEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
            col.__addEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
            col.__addEventListener("colDefChanged", colDefChangedListener);
            this.destroyFuncsForColumnListeners.push(()=>{
                col.__removeEventListener("leftChanged", leftChangedListener);
                col.__removeEventListener("widthChanged", widthChangedListener);
                col.__removeEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
                col.__removeEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
                col.__removeEventListener("colDefChanged", colDefChangedListener);
            });
        }
    }
    onDomLayoutChanged() {
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const embedFullWidthRows = printLayout || this.gos.get("embedFullWidthRows");
        const destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
        this.printLayout = printLayout;
        this.embedFullWidthRows = embedFullWidthRows;
        if (destroyRows) this.redrawAfterModelUpdate({
            domLayoutChanged: true
        });
    }
    // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
    // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
    datasourceChanged() {
        this.firstRenderedRow = 0;
        this.lastRenderedRow = -1;
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove);
    }
    onPageLoaded(event) {
        const params = {
            recycleRows: event.keepRenderedRows,
            animate: event.animate,
            newData: event.newData,
            newPage: event.newPage,
            // because this is a model updated event (not pinned rows), we
            // can skip updating the pinned rows. this is needed so that if user
            // is doing transaction updates, the pinned rows are not getting constantly
            // trashed - or editing cells in pinned rows are not refreshed and put into read mode
            onlyBody: true
        };
        this.redrawAfterModelUpdate(params);
    }
    /**
   * @param column AgColumn
   * @returns An array with HTMLElement for every cell of the column passed as param.
   * If the cell is spanning across multiple columns, it only returns the html element
   * if the column passed is the first column of the span (used for auto width calculation).
   */ getAllCellsNotSpanningForColumn(column) {
        const res = [];
        for (const rowCtrl of this.getAllRowCtrls()){
            const eCell = rowCtrl.getCellCtrl(column, true)?.eGui;
            if (eCell) res.push(eCell);
        }
        return res;
    }
    refreshFloatingRowComps(recycleRows = true) {
        this.refreshFloatingRows(this.topRowCtrls, "top", recycleRows);
        this.refreshFloatingRows(this.bottomRowCtrls, "bottom", recycleRows);
    }
    /**
   * Determines which row controllers need to be destroyed and re-created vs which ones can
   * be re-used.
   *
   * This is operation is to pinned/floating rows as `this.recycleRows` is to normal/body rows.
   *
   * All `RowCtrl` instances in `rowCtrls` that don't correspond to `RowNode` instances in `rowNodes` are destroyed.
   * All `RowNode` instances in `rowNodes` that don't correspond to `RowCtrl` instances in `rowCtrls` are created.
   * All instances in `rowCtrls` must be in the same order as their corresponding nodes in `rowNodes`.
   *
   * @param rowCtrls The list of existing row controllers
   * @param rowNodes The canonical list of row nodes that should have associated controllers
   */ refreshFloatingRows(rowCtrls, floating, recycleRows) {
        const { pinnedRowModel: pinnedRowModel, beans: beans, printLayout: printLayout } = this;
        const rowCtrlMap = Object.fromEntries(rowCtrls.map((ctrl)=>[
                ctrl.rowNode.id,
                ctrl
            ]));
        pinnedRowModel?.forEachPinnedRow(floating, (node, i)=>{
            const rowCtrl = rowCtrls[i];
            const rowCtrlDoesNotExist = rowCtrl && pinnedRowModel.getPinnedRowById(rowCtrl.rowNode.id, floating) === void 0;
            if (rowCtrlDoesNotExist) {
                rowCtrl.destroyFirstPass();
                rowCtrl.destroySecondPass();
            }
            if (node.id in rowCtrlMap && recycleRows) {
                rowCtrls[i] = rowCtrlMap[node.id];
                delete rowCtrlMap[node.id];
            } else rowCtrls[i] = new $437b23f6a393c3bf$var$RowCtrl(node, beans, false, false, printLayout);
        });
        const rowNodeCount = (floating === "top" ? pinnedRowModel?.getPinnedTopRowCount() : pinnedRowModel?.getPinnedBottomRowCount()) ?? 0;
        rowCtrls.length = rowNodeCount;
    }
    onPinnedRowDataChanged() {
        const params = {
            recycleRows: true
        };
        this.redrawAfterModelUpdate(params);
    }
    onPinnedRowsChanged() {
        this.redrawAfterModelUpdate({
            recycleRows: true
        });
    }
    redrawRow(rowNode, suppressEvent = false) {
        if (rowNode.sticky) this.stickyRowFeature?.refreshStickyNode(rowNode);
        else if (this.cachedRowCtrls?.has(rowNode)) {
            this.cachedRowCtrls.removeRow(rowNode);
            return;
        } else {
            const destroyAndRecreateCtrl = (dataStruct)=>{
                const ctrl = dataStruct[rowNode.rowIndex];
                if (!ctrl) return;
                if (ctrl.rowNode !== rowNode) return;
                ctrl.destroyFirstPass();
                ctrl.destroySecondPass();
                dataStruct[rowNode.rowIndex] = this.createRowCon(rowNode, false, false);
            };
            switch(rowNode.rowPinned){
                case "top":
                    destroyAndRecreateCtrl(this.topRowCtrls);
                    break;
                case "bottom":
                    destroyAndRecreateCtrl(this.bottomRowCtrls);
                    break;
                default:
                    destroyAndRecreateCtrl(this.rowCtrlsByRowIndex);
                    this.updateAllRowCtrls();
            }
        }
        if (!suppressEvent) this.dispatchDisplayedRowsChanged(false);
    }
    redrawRows(rowNodes) {
        const { editSvc: editSvc } = this.beans;
        if (editSvc?.isEditing()) {
            if (editSvc.isBatchEditing()) editSvc.cleanupEditors();
            else editSvc.stopEditing(void 0, {
                source: "api"
            });
        }
        const partialRefresh = rowNodes != null;
        if (partialRefresh) {
            for (const node of rowNodes ?? [])this.redrawRow(node, true);
            this.dispatchDisplayedRowsChanged(false);
            return;
        }
        this.redrawAfterModelUpdate();
    }
    // gets called from:
    // +) initialisation (in registerGridComp) params = null
    // +) onDomLayoutChanged, params = null
    // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
    // +) onPinnedRowDataChanged, recycleRows = true
    // +) redrawRows (from Grid API), recycleRows = true/false
    redrawAfterModelUpdate(params = {}) {
        this.getLockOnRefresh();
        const focusedCell = this.beans.focusSvc?.getFocusCellToUseAfterRefresh();
        this.updateContainerHeights();
        this.scrollToTopIfNewData(params);
        const recycleRows = !params.domLayoutChanged && !!params.recycleRows;
        const animate = params.animate && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos);
        const rowsToRecycle = recycleRows ? this.getRowsToRecycle() : null;
        if (!recycleRows) this.removeAllRowComps();
        this.workOutFirstAndLastRowsToRender();
        const { stickyRowFeature: stickyRowFeature, gos: gos } = this;
        if (stickyRowFeature) {
            stickyRowFeature.checkStickyRows();
            const extraHeight = stickyRowFeature.extraTopHeight + stickyRowFeature.extraBottomHeight;
            if (extraHeight) this.updateContainerHeights(extraHeight);
        }
        this.recycleRows(rowsToRecycle, animate);
        this.gridBodyCtrl.updateRowCount();
        if (!params.onlyBody) this.refreshFloatingRowComps(gos.get("enableRowPinning") ? recycleRows : void 0);
        this.dispatchDisplayedRowsChanged();
        if (focusedCell != null) this.restoreFocusedCell(focusedCell);
        this.releaseLockOnRefresh();
    }
    scrollToTopIfNewData(params) {
        const scrollToTop = params.newData || params.newPage;
        const suppressScrollToTop = this.gos.get("suppressScrollOnNewData");
        if (scrollToTop && !suppressScrollToTop) {
            this.gridBodyCtrl.scrollFeature.scrollToTop();
            this.stickyRowFeature?.resetOffsets();
        }
    }
    updateContainerHeights(additionalHeight = 0) {
        const { rowContainerHeight: rowContainerHeight } = this;
        if (this.printLayout) {
            rowContainerHeight.setModelHeight(null);
            return;
        }
        let containerHeight = this.pageBounds.getCurrentPageHeight();
        if (containerHeight === 0) containerHeight = 1;
        rowContainerHeight.setModelHeight(containerHeight + additionalHeight);
    }
    getLockOnRefresh() {
        if (this.refreshInProgress) throw new Error($437b23f6a393c3bf$export$680bb5102fca525e(252));
        this.refreshInProgress = true;
        this.beans.frameworkOverrides.getLockOnRefresh?.();
    }
    releaseLockOnRefresh() {
        this.refreshInProgress = false;
        this.beans.frameworkOverrides.releaseLockOnRefresh?.();
    }
    isRefreshInProgress() {
        return this.refreshInProgress;
    }
    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
    // edited cell).
    restoreFocusedCell(cellPosition) {
        if (!cellPosition) return;
        const focusSvc = this.beans.focusSvc;
        const cellToFocus = this.findPositionToFocus(cellPosition);
        if (!cellToFocus) {
            focusSvc.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1,
                    column: cellPosition.column
                }
            });
            return;
        }
        if (cellPosition.rowIndex !== cellToFocus.rowIndex || cellPosition.rowPinned != cellToFocus.rowPinned) {
            focusSvc.setFocusedCell({
                ...cellToFocus,
                preventScrollOnBrowserFocus: true,
                forceBrowserFocus: true
            });
            return;
        }
        if (!focusSvc.doesRowOrCellHaveBrowserFocus()) this.updateCellFocus($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            ...cellToFocus,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true,
            type: "cellFocused"
        }));
    }
    findPositionToFocus(cellPosition) {
        const { pagination: pagination, pageBounds: pageBounds } = this.beans;
        let rowPosition = cellPosition;
        if (rowPosition.rowPinned == null && pagination && pageBounds && !pagination.isRowInPage(rowPosition.rowIndex)) rowPosition = {
            rowPinned: null,
            rowIndex: pageBounds.getFirstRow()
        };
        while(rowPosition){
            if (rowPosition.rowPinned == null && pageBounds) {
                if (rowPosition.rowIndex < pageBounds.getFirstRow()) {
                    rowPosition = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, {
                        rowPinned: null,
                        rowIndex: 0
                    });
                    if (!rowPosition) return null;
                } else if (rowPosition.rowIndex > pageBounds.getLastRow()) rowPosition = {
                    rowPinned: null,
                    rowIndex: pageBounds.getLastRow()
                };
            }
            const row = this.getRowByPosition(rowPosition);
            if (row?.isAlive()) return {
                ...row.getRowPosition(),
                column: cellPosition.column
            };
            rowPosition = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, rowPosition);
        }
        return null;
    }
    getAllCellCtrls() {
        const res = [];
        const rowCtrls = this.getAllRowCtrls();
        const rowCtrlsLength = rowCtrls.length;
        for(let i = 0; i < rowCtrlsLength; i++){
            const cellCtrls = rowCtrls[i].getAllCellCtrls();
            const cellCtrlsLength = cellCtrls.length;
            for(let j = 0; j < cellCtrlsLength; j++)res.push(cellCtrls[j]);
        }
        return res;
    }
    getAllRowCtrls() {
        const { spannedRowRenderer: spannedRowRenderer } = this.beans;
        const stickyTopRowCtrls = this.getStickyTopRowCtrls();
        const stickyBottomRowCtrls = this.getStickyBottomRowCtrls();
        const res = [
            ...this.topRowCtrls,
            ...this.bottomRowCtrls,
            ...stickyTopRowCtrls,
            ...stickyBottomRowCtrls,
            ...spannedRowRenderer?.getCtrls("top") ?? [],
            ...spannedRowRenderer?.getCtrls("bottom") ?? [],
            ...spannedRowRenderer?.getCtrls("center") ?? [],
            ...Object.values(this.rowCtrlsByRowIndex)
        ];
        return res;
    }
    addRenderedRowListener(eventName, rowIndex, callback) {
        const rowComp = this.rowCtrlsByRowIndex[rowIndex];
        if (rowComp) rowComp.addEventListener(eventName, callback);
    }
    refreshCells({ rowNodes: rowNodes, columns: columns, force: force, suppressFlash: suppressFlash } = {}) {
        const refreshCellParams = {
            force: force,
            newData: false,
            suppressFlash: suppressFlash
        };
        for (const cellCtrl of this.getCellCtrls(rowNodes, columns))cellCtrl.refreshOrDestroyCell(refreshCellParams);
        this.refreshFullWidth(rowNodes);
    }
    refreshRows(params = {}) {
        for (const rowCtrl of this.getRowCtrls(params.rowNodes))rowCtrl.refreshRow(params);
        this.refreshFullWidth(params.rowNodes);
    }
    refreshFullWidth(rowNodes) {
        if (!rowNodes) return;
        let rowRedrawn = false;
        for (const rowCtrl of this.getRowCtrls(rowNodes)){
            if (!rowCtrl.isFullWidth()) continue;
            const refreshed = rowCtrl.refreshFullWidth();
            if (!refreshed) {
                rowRedrawn = true;
                this.redrawRow(rowCtrl.rowNode, true);
            }
        }
        if (rowRedrawn) this.dispatchDisplayedRowsChanged(false);
    }
    /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */ getRowCtrls(rowNodes) {
        const rowIdsMap = $437b23f6a393c3bf$var$mapRowNodes(rowNodes);
        const allRowCtrls = this.getAllRowCtrls();
        if (!rowNodes || !rowIdsMap) return allRowCtrls;
        return allRowCtrls.filter((rowCtrl)=>{
            const rowNode = rowCtrl.rowNode;
            return $437b23f6a393c3bf$var$isRowInMap(rowNode, rowIdsMap);
        });
    }
    // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
    // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
    getCellCtrls(rowNodes, columns) {
        let colIdsMap;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(columns)) {
            colIdsMap = {};
            columns.forEach((colKey)=>{
                const column = this.colModel.getCol(colKey);
                if ($437b23f6a393c3bf$export$25d27f17d3af40f7(column)) colIdsMap[column.getId()] = true;
            });
        }
        const res = [];
        for (const rowCtrl of this.getRowCtrls(rowNodes))for (const cellCtrl of rowCtrl.getAllCellCtrls()){
            const colId = cellCtrl.column.getId();
            const excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
            if (excludeColFromRefresh) continue;
            res.push(cellCtrl);
        }
        return res;
    }
    destroy() {
        this.removeAllRowComps(true);
        super.destroy();
    }
    removeAllRowComps(suppressAnimation = false) {
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove, suppressAnimation);
        this.stickyRowFeature?.destroyStickyCtrls();
    }
    getRowsToRecycle() {
        const stubNodeIndexes = [];
        for (const index of Object.keys(this.rowCtrlsByRowIndex)){
            const rowCtrl = this.rowCtrlsByRowIndex[index];
            const stubNode = rowCtrl.rowNode.id == null;
            if (stubNode) stubNodeIndexes.push(index);
        }
        this.removeRowCtrls(stubNodeIndexes);
        const ctrlsByIdMap = {};
        for (const rowCtrl of Object.values(this.rowCtrlsByRowIndex)){
            const rowNode = rowCtrl.rowNode;
            ctrlsByIdMap[rowNode.id] = rowCtrl;
        }
        this.rowCtrlsByRowIndex = {};
        return ctrlsByIdMap;
    }
    // takes array of row indexes
    removeRowCtrls(rowsToRemove, suppressAnimation = false) {
        for (const indexToRemove of rowsToRemove){
            const rowCtrl = this.rowCtrlsByRowIndex[indexToRemove];
            if (rowCtrl) {
                rowCtrl.destroyFirstPass(suppressAnimation);
                rowCtrl.destroySecondPass();
            }
            delete this.rowCtrlsByRowIndex[indexToRemove];
        }
    }
    onBodyScroll(e) {
        if (e.direction !== "vertical") return;
        this.redraw({
            afterScroll: true
        });
    }
    // gets called when rows don't change, but viewport does, so after:
    // 1) height of grid body changes, ie number of displayed rows has changed
    // 2) grid scrolled to new position
    // 3) ensure index visible (which is a scroll)
    redraw(params = {}) {
        const { focusSvc: focusSvc, animationFrameSvc: animationFrameSvc } = this.beans;
        const { afterScroll: afterScroll } = params;
        let cellFocused;
        const stickyRowFeature = this.stickyRowFeature;
        if (stickyRowFeature) cellFocused = focusSvc?.getFocusCellToUseAfterRefresh() || void 0;
        const oldFirstRow = this.firstRenderedRow;
        const oldLastRow = this.lastRenderedRow;
        this.workOutFirstAndLastRowsToRender();
        let hasStickyRowChanges = false;
        if (stickyRowFeature) {
            hasStickyRowChanges = stickyRowFeature.checkStickyRows();
            const extraHeight = stickyRowFeature.extraTopHeight + stickyRowFeature.extraBottomHeight;
            if (extraHeight) this.updateContainerHeights(extraHeight);
        }
        const rangeChanged = this.firstRenderedRow !== oldFirstRow || this.lastRenderedRow !== oldLastRow;
        if (afterScroll && !hasStickyRowChanges && !rangeChanged) return;
        this.getLockOnRefresh();
        this.recycleRows(null, false, afterScroll);
        this.releaseLockOnRefresh();
        this.dispatchDisplayedRowsChanged(afterScroll && !hasStickyRowChanges);
        if (cellFocused != null) {
            const newFocusedCell = focusSvc?.getFocusCellToUseAfterRefresh();
            if (cellFocused != null && newFocusedCell == null) {
                animationFrameSvc?.flushAllFrames();
                this.restoreFocusedCell(cellFocused);
            }
        }
    }
    removeRowCompsNotToDraw(indexesToDraw, suppressAnimation) {
        const indexesToDrawMap = {};
        for (const index of indexesToDraw)indexesToDrawMap[index] = true;
        const existingIndexes = Object.keys(this.rowCtrlsByRowIndex);
        const indexesNotToDraw = existingIndexes.filter((index)=>!indexesToDrawMap[index]);
        this.removeRowCtrls(indexesNotToDraw, suppressAnimation);
    }
    calculateIndexesToDraw(rowsToRecycle) {
        const indexesToDraw = [];
        for(let i = this.firstRenderedRow; i <= this.lastRenderedRow; i++)indexesToDraw.push(i);
        const pagination = this.beans.pagination;
        const focusedRowIndex = this.beans.focusSvc?.getFocusedCell()?.rowIndex;
        if (focusedRowIndex != null && (focusedRowIndex < this.firstRenderedRow || focusedRowIndex > this.lastRenderedRow) && (!pagination || pagination.isRowInPage(focusedRowIndex)) && focusedRowIndex < this.rowModel.getRowCount()) indexesToDraw.push(focusedRowIndex);
        const checkRowToDraw = (rowComp)=>{
            const index = rowComp.rowNode.rowIndex;
            if (index == null || index === focusedRowIndex) return;
            if (index < this.firstRenderedRow || index > this.lastRenderedRow) {
                if (this.doNotUnVirtualiseRow(rowComp)) indexesToDraw.push(index);
            }
        };
        for (const rowCtrl of Object.values(this.rowCtrlsByRowIndex))checkRowToDraw(rowCtrl);
        if (rowsToRecycle) for (const rowCtrl of Object.values(rowsToRecycle))checkRowToDraw(rowCtrl);
        indexesToDraw.sort((a, b)=>a - b);
        const ret = [];
        for(let i = 0; i < indexesToDraw.length; i++){
            const currRow = indexesToDraw[i];
            const rowNode = this.rowModel.getRow(currRow);
            if (rowNode && !rowNode.sticky) ret.push(currRow);
        }
        return ret;
    }
    recycleRows(rowsToRecycle, animate = false, afterScroll = false) {
        const indexesToDraw = this.calculateIndexesToDraw(rowsToRecycle);
        if (this.printLayout || afterScroll) animate = false;
        this.removeRowCompsNotToDraw(indexesToDraw, !animate);
        for (const rowIndex of indexesToDraw)this.createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll);
        if (rowsToRecycle) {
            const { animationFrameSvc: animationFrameSvc } = this.beans;
            const useAnimationFrame = animationFrameSvc?.active && afterScroll && !this.printLayout;
            if (useAnimationFrame) animationFrameSvc.addDestroyTask(()=>{
                this.destroyRowCtrls(rowsToRecycle, animate);
                this.updateAllRowCtrls();
                this.dispatchDisplayedRowsChanged();
            });
            else this.destroyRowCtrls(rowsToRecycle, animate);
        }
        this.updateAllRowCtrls();
    }
    dispatchDisplayedRowsChanged(afterScroll = false) {
        this.eventSvc.dispatchEvent({
            type: "displayedRowsChanged",
            afterScroll: afterScroll
        });
    }
    onDisplayedColumnsChanged() {
        const { visibleCols: visibleCols } = this.beans;
        const pinningLeft = visibleCols.isPinningLeft();
        const pinningRight = visibleCols.isPinningRight();
        const atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
        if (atLeastOneChanged) {
            this.pinningLeft = pinningLeft;
            this.pinningRight = pinningRight;
            if (this.embedFullWidthRows) this.redrawFullWidthEmbeddedRows();
        }
    }
    // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
    // then it should go into the pinned left area if pinning left, or the center area if not pinning.
    redrawFullWidthEmbeddedRows() {
        const rowsToRemove = [];
        for (const fullWidthCtrl of this.getFullWidthRowCtrls()){
            const rowIndex = fullWidthCtrl.rowNode.rowIndex;
            rowsToRemove.push(rowIndex.toString());
        }
        this.refreshFloatingRowComps();
        this.removeRowCtrls(rowsToRemove);
        this.redraw({
            afterScroll: true
        });
    }
    getFullWidthRowCtrls(rowNodes) {
        const rowNodesMap = $437b23f6a393c3bf$var$mapRowNodes(rowNodes);
        return this.getAllRowCtrls().filter((rowCtrl)=>{
            if (!rowCtrl.isFullWidth()) return false;
            const rowNode = rowCtrl.rowNode;
            if (rowNodesMap != null && !$437b23f6a393c3bf$var$isRowInMap(rowNode, rowNodesMap)) return false;
            return true;
        });
    }
    createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll) {
        let rowNode;
        let rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
        if (!rowCtrl) {
            rowNode = this.rowModel.getRow(rowIndex);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowNode) && $437b23f6a393c3bf$export$25d27f17d3af40f7(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
                rowCtrl = rowsToRecycle[rowNode.id];
                rowsToRecycle[rowNode.id] = null;
            }
        }
        const creatingNewRowCtrl = !rowCtrl;
        if (creatingNewRowCtrl) {
            if (!rowNode) rowNode = this.rowModel.getRow(rowIndex);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowNode)) rowCtrl = this.createRowCon(rowNode, animate, afterScroll);
            else return;
        }
        if (rowNode) rowNode.alreadyRendered = true;
        this.rowCtrlsByRowIndex[rowIndex] = rowCtrl;
    }
    destroyRowCtrls(rowCtrlsMap, animate) {
        const executeInAWhileFuncs = [];
        if (rowCtrlsMap) for (const rowCtrl of Object.values(rowCtrlsMap)){
            if (!rowCtrl) continue;
            if (this.cachedRowCtrls && rowCtrl.isCacheable()) {
                this.cachedRowCtrls.addRow(rowCtrl);
                continue;
            }
            rowCtrl.destroyFirstPass(!animate);
            if (animate) {
                const instanceId = rowCtrl.instanceId;
                this.zombieRowCtrls[instanceId] = rowCtrl;
                executeInAWhileFuncs.push(()=>{
                    rowCtrl.destroySecondPass();
                    delete this.zombieRowCtrls[instanceId];
                });
            } else rowCtrl.destroySecondPass();
        }
        if (animate) {
            executeInAWhileFuncs.push(()=>{
                if (this.isAlive()) {
                    this.updateAllRowCtrls();
                    this.dispatchDisplayedRowsChanged();
                }
            });
            window.setTimeout(()=>{
                for (const func of executeInAWhileFuncs)func();
            }, $437b23f6a393c3bf$var$ROW_ANIMATION_TIMEOUT);
        }
    }
    getRowBuffer() {
        return this.gos.get("rowBuffer");
    }
    getRowBufferInPixels() {
        const rowsToBuffer = this.getRowBuffer();
        const defaultRowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
        return rowsToBuffer * defaultRowHeight;
    }
    workOutFirstAndLastRowsToRender() {
        const { rowContainerHeight: rowContainerHeight, pageBounds: pageBounds, rowModel: rowModel } = this;
        rowContainerHeight.updateOffset();
        let newFirst;
        let newLast;
        if (!rowModel.isRowsToRender()) {
            newFirst = 0;
            newLast = -1;
        } else if (this.printLayout) {
            this.beans.environment.refreshRowHeightVariable();
            newFirst = pageBounds.getFirstRow();
            newLast = pageBounds.getLastRow();
        } else {
            const bufferPixels = this.getRowBufferInPixels();
            const scrollFeature = this.ctrlsSvc.getScrollFeature();
            const suppressRowVirtualisation = this.gos.get("suppressRowVirtualisation");
            let rowHeightsChanged = false;
            let firstPixel;
            let lastPixel;
            do {
                const paginationOffset = pageBounds.getPixelOffset();
                const { pageFirstPixel: pageFirstPixel, pageLastPixel: pageLastPixel } = pageBounds.getCurrentPagePixelRange();
                const divStretchOffset = rowContainerHeight.divStretchOffset;
                const bodyVRange = scrollFeature.getVScrollPosition();
                const bodyTopPixel = bodyVRange.top;
                const bodyBottomPixel = bodyVRange.bottom;
                if (suppressRowVirtualisation) {
                    firstPixel = pageFirstPixel + divStretchOffset;
                    lastPixel = pageLastPixel + divStretchOffset;
                } else {
                    firstPixel = Math.max(bodyTopPixel + paginationOffset - bufferPixels, pageFirstPixel) + divStretchOffset;
                    lastPixel = Math.min(bodyBottomPixel + paginationOffset + bufferPixels, pageLastPixel) + divStretchOffset;
                }
                this.firstVisibleVPixel = Math.max(bodyTopPixel + paginationOffset, pageFirstPixel) + divStretchOffset;
                this.lastVisibleVPixel = Math.min(bodyBottomPixel + paginationOffset, pageLastPixel) + divStretchOffset;
                rowHeightsChanged = this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
            }while (rowHeightsChanged);
            let firstRowIndex = rowModel.getRowIndexAtPixel(firstPixel);
            let lastRowIndex = rowModel.getRowIndexAtPixel(lastPixel);
            const pageFirstRow = pageBounds.getFirstRow();
            const pageLastRow = pageBounds.getLastRow();
            if (firstRowIndex < pageFirstRow) firstRowIndex = pageFirstRow;
            if (lastRowIndex > pageLastRow) lastRowIndex = pageLastRow;
            newFirst = firstRowIndex;
            newLast = lastRowIndex;
        }
        const rowLayoutNormal = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        const suppressRowCountRestriction = this.gos.get("suppressMaxRenderedRowRestriction");
        const rowBufferMaxSize = Math.max(this.getRowBuffer(), 500);
        if (rowLayoutNormal && !suppressRowCountRestriction) {
            if (newLast - newFirst > rowBufferMaxSize) newLast = newFirst + rowBufferMaxSize;
        }
        const firstDiffers = newFirst !== this.firstRenderedRow;
        const lastDiffers = newLast !== this.lastRenderedRow;
        if (firstDiffers || lastDiffers) {
            this.firstRenderedRow = newFirst;
            this.lastRenderedRow = newLast;
            this.eventSvc.dispatchEvent({
                type: "viewportChanged",
                firstRow: newFirst,
                lastRow: newLast
            });
        }
    }
    /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */ dispatchFirstDataRenderedEvent() {
        if (this.dataFirstRenderedFired) return;
        this.dataFirstRenderedFired = true;
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>{
            this.beans.eventSvc.dispatchEvent({
                type: "firstDataRendered",
                firstRow: this.firstRenderedRow,
                lastRow: this.lastRenderedRow
            });
        });
    }
    ensureAllRowsInRangeHaveHeightsCalculated(topPixel, bottomPixel) {
        const pinnedRowHeightsChanged = this.pinnedRowModel?.ensureRowHeightsValid();
        const stickyHeightsChanged = this.stickyRowFeature?.ensureRowHeightsValid();
        const { pageBounds: pageBounds, rowModel: rowModel } = this;
        const rowModelHeightsChanged = rowModel.ensureRowHeightsValid(topPixel, bottomPixel, pageBounds.getFirstRow(), pageBounds.getLastRow());
        if (rowModelHeightsChanged || stickyHeightsChanged) this.eventSvc.dispatchEvent({
            type: "recalculateRowBounds"
        });
        if (stickyHeightsChanged || rowModelHeightsChanged || pinnedRowHeightsChanged) {
            this.updateContainerHeights();
            return true;
        }
        return false;
    }
    // check that none of the rows to remove are editing or focused as:
    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
    //    the edit is reset - so we want to keep it rendered.
    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
    //    and then ctrl+c, nothing will happen if cell is removed from dom.
    // c) if detail record of master detail, as users complained that the context of detail rows
    //    was getting lost when detail row out of view. eg user expands to show detail row,
    //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
    //    after detail panel is scrolled out of / into view.
    doNotUnVirtualiseRow(rowCtrl) {
        const REMOVE_ROW = false;
        const KEEP_ROW = true;
        const rowNode = rowCtrl.rowNode;
        const rowHasFocus = this.focusSvc.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
        const rowIsEditing = this.editSvc?.isEditing(rowCtrl);
        const rowIsDetail = rowNode.detail;
        const mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;
        if (!mightWantToKeepRow) return REMOVE_ROW;
        const rowNodePresent = this.isRowPresent(rowNode);
        return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
    }
    isRowPresent(rowNode) {
        if (!this.rowModel.isRowPresent(rowNode)) return false;
        return this.beans.pagination?.isRowInPage(rowNode.rowIndex) ?? true;
    }
    createRowCon(rowNode, animate, afterScroll) {
        const rowCtrlFromCache = this.cachedRowCtrls?.getRow(rowNode) ?? null;
        if (rowCtrlFromCache) return rowCtrlFromCache;
        const useAnimationFrameForCreate = afterScroll && !this.printLayout && !!this.beans.animationFrameSvc?.active;
        const res = new $437b23f6a393c3bf$var$RowCtrl(rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout);
        return res;
    }
    getRenderedNodes() {
        const viewportRows = Object.values(this.rowCtrlsByRowIndex).map((rowCtrl)=>rowCtrl.rowNode);
        const stickyTopRows = this.getStickyTopRowCtrls().map((rowCtrl)=>rowCtrl.rowNode);
        const stickyBottomRows = this.getStickyBottomRowCtrls().map((rowCtrl)=>rowCtrl.rowNode);
        return [
            ...stickyTopRows,
            ...viewportRows,
            ...stickyBottomRows
        ];
    }
    getRowByPosition(rowPosition) {
        let rowCtrl;
        const { rowIndex: rowIndex } = rowPosition;
        switch(rowPosition.rowPinned){
            case "top":
                rowCtrl = this.topRowCtrls[rowIndex];
                break;
            case "bottom":
                rowCtrl = this.bottomRowCtrls[rowIndex];
                break;
            default:
                rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
                if (!rowCtrl) {
                    rowCtrl = this.getStickyTopRowCtrls().find((ctrl)=>ctrl.rowNode.rowIndex === rowIndex) || null;
                    if (!rowCtrl) rowCtrl = this.getStickyBottomRowCtrls().find((ctrl)=>ctrl.rowNode.rowIndex === rowIndex) || null;
                }
                break;
        }
        return rowCtrl;
    }
    // returns true if any row between startIndex and endIndex is rendered. used by
    // SSRM or IRM, as they don't want to purge visible blocks from cache.
    isRangeInRenderedViewport(startIndex, endIndex) {
        const parentClosed = startIndex == null || endIndex == null;
        if (parentClosed) return false;
        const blockAfterViewport = startIndex > this.lastRenderedRow;
        const blockBeforeViewport = endIndex < this.firstRenderedRow;
        const blockInsideViewport = !blockBeforeViewport && !blockAfterViewport;
        return blockInsideViewport;
    }
};
var $437b23f6a393c3bf$var$RowCtrlCache = class {
    constructor(maxCount){
        // map for fast access
        this.entriesMap = {};
        // list for keeping order
        this.entriesList = [];
        this.maxCount = maxCount;
    }
    addRow(rowCtrl) {
        this.entriesMap[rowCtrl.rowNode.id] = rowCtrl;
        this.entriesList.push(rowCtrl);
        rowCtrl.setCached(true);
        if (this.entriesList.length > this.maxCount) {
            const rowCtrlToDestroy = this.entriesList[0];
            rowCtrlToDestroy.destroyFirstPass();
            rowCtrlToDestroy.destroySecondPass();
            this.removeFromCache(rowCtrlToDestroy);
        }
    }
    getRow(rowNode) {
        if (rowNode?.id == null) return null;
        const res = this.entriesMap[rowNode.id];
        if (!res) return null;
        this.removeFromCache(res);
        res.setCached(false);
        const rowNodeMismatch = res.rowNode != rowNode;
        return rowNodeMismatch ? null : res;
    }
    has(rowNode) {
        return this.entriesMap[rowNode.id] != null;
    }
    removeRow(rowNode) {
        const rowNodeId = rowNode.id;
        const ctrl = this.entriesMap[rowNodeId];
        delete this.entriesMap[rowNodeId];
        $437b23f6a393c3bf$export$83a881c8b5120679(this.entriesList, ctrl);
    }
    removeFromCache(rowCtrl) {
        const rowNodeId = rowCtrl.rowNode.id;
        delete this.entriesMap[rowNodeId];
        $437b23f6a393c3bf$export$83a881c8b5120679(this.entriesList, rowCtrl);
    }
    getEntries() {
        return this.entriesList;
    }
};
function $437b23f6a393c3bf$var$mapRowNodes(rowNodes) {
    if (!rowNodes) return;
    const res = {
        top: {},
        bottom: {},
        normal: {}
    };
    for (const rowNode of rowNodes){
        const id = rowNode.id;
        switch(rowNode.rowPinned){
            case "top":
                res.top[id] = rowNode;
                break;
            case "bottom":
                res.bottom[id] = rowNode;
                break;
            default:
                res.normal[id] = rowNode;
                break;
        }
    }
    return res;
}
function $437b23f6a393c3bf$var$isRowInMap(rowNode, rowIdsMap) {
    const id = rowNode.id;
    const floating = rowNode.rowPinned;
    switch(floating){
        case "top":
            return rowIdsMap.top[id] != null;
        case "bottom":
            return rowIdsMap.bottom[id] != null;
        default:
            return rowIdsMap.normal[id] != null;
    }
}
// packages/ag-grid-community/src/sort/rowNodeSorter.ts
var $437b23f6a393c3bf$var$RowNodeSorter = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowNodeSorter";
    }
    postConstruct() {
        const { gos: gos } = this;
        this.isAccentedSort = gos.get("accentedSort");
        this.primaryColumnsSortGroups = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        this.addManagedPropertyListener("accentedSort", (propChange)=>this.isAccentedSort = propChange.currentValue);
        this.addManagedPropertyListener("autoGroupColumnDef", ()=>this.primaryColumnsSortGroups = $437b23f6a393c3bf$export$96c51c2547b81aed(gos));
    }
    doFullSort(rowNodes, sortOptions) {
        const sortedRowNodes = rowNodes.map((rowNode, currentPos)=>({
                currentPos: currentPos,
                rowNode: rowNode
            }));
        sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
        return sortedRowNodes.map((item)=>item.rowNode);
    }
    compareRowNodes(sortOptions, sortedNodeA, sortedNodeB) {
        const nodeA = sortedNodeA.rowNode;
        const nodeB = sortedNodeB.rowNode;
        for(let i = 0, len = sortOptions.length; i < len; i++){
            const sortOption = sortOptions[i];
            const isDescending = sortOption.sort === "desc";
            const valueA = this.getValue(nodeA, sortOption.column);
            const valueB = this.getValue(nodeB, sortOption.column);
            let comparatorResult;
            const providedComparator = this.getComparator(sortOption, nodeA);
            if (providedComparator) comparatorResult = providedComparator(valueA, valueB, nodeA, nodeB, isDescending);
            else comparatorResult = $437b23f6a393c3bf$export$b0cca9f3c87c8df8(valueA, valueB, this.isAccentedSort);
            const validResult = !isNaN(comparatorResult);
            if (validResult && comparatorResult !== 0) return sortOption.sort === "asc" ? comparatorResult : comparatorResult * -1;
        }
        return sortedNodeA.currentPos - sortedNodeB.currentPos;
    }
    getComparator(sortOption, rowNode) {
        const column = sortOption.column;
        const comparatorOnCol = column.getColDef().comparator;
        if (comparatorOnCol != null) return comparatorOnCol;
        if (!column.getColDef().showRowGroup) return;
        const groupLeafField = !rowNode.group && column.getColDef().field;
        if (!groupLeafField) return;
        const primaryColumn = this.beans.colModel.getColDefCol(groupLeafField);
        if (!primaryColumn) return;
        return primaryColumn.getColDef().comparator;
    }
    getValue(node, column) {
        const { valueSvc: valueSvc, colModel: colModel, showRowGroupCols: showRowGroupCols, gos: gos } = this.beans;
        if (!this.primaryColumnsSortGroups) return valueSvc.getValue(column, node, false);
        const isNodeGroupedAtLevel = node.rowGroupColumn === column;
        if (isNodeGroupedAtLevel) {
            const isGroupRows = $437b23f6a393c3bf$export$b911c5b172d227b4(gos, colModel.isPivotActive());
            if (isGroupRows) {
                const leafChild = node.data ? node : $437b23f6a393c3bf$export$d3815c2420e77efc(node.childrenAfterGroup);
                return leafChild && valueSvc.getValue(column, leafChild, false);
            }
            const displayCol = showRowGroupCols?.getShowRowGroupCol(column.getId());
            if (!displayCol) return void 0;
            return node.groupData?.[displayCol.getId()];
        }
        if (node.group && column.getColDef().showRowGroup) return void 0;
        return valueSvc.getValue(column, node, false);
    }
};
// packages/ag-grid-community/src/sort/sortApi.ts
function $437b23f6a393c3bf$var$onSortChanged(beans) {
    beans.sortSvc?.onSortChanged("api");
}
// packages/ag-grid-community/src/sort/sortModule.ts
var $437b23f6a393c3bf$export$1a6625c5691649e8 = {
    moduleName: "Sort",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$SortService,
        $437b23f6a393c3bf$var$RowNodeSorter
    ],
    apiFunctions: {
        onSortChanged: $437b23f6a393c3bf$var$onSortChanged
    },
    userComponents: {
        agSortIndicator: $437b23f6a393c3bf$var$SortIndicatorComp
    },
    icons: {
        // show on column header when column is sorted ascending
        sortAscending: "asc",
        // show on column header when column is sorted descending
        sortDescending: "desc",
        // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
        sortUnSort: "none"
    }
};
// packages/ag-grid-community/src/syncService.ts
var $437b23f6a393c3bf$var$SyncService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "syncSvc";
        this.waitingForColumns = false;
    }
    postConstruct() {
        this.addManagedPropertyListener("columnDefs", (event)=>this.setColumnDefs(event));
    }
    start() {
        this.beans.ctrlsSvc.whenReady(this, ()=>{
            const columnDefs = this.gos.get("columnDefs");
            if (columnDefs) this.setColumnsAndData(columnDefs);
            else this.waitingForColumns = true;
            this.gridReady();
        });
    }
    setColumnsAndData(columnDefs) {
        const { colModel: colModel, rowModel: rowModel } = this.beans;
        colModel.setColumnDefs(columnDefs ?? [], "gridInitializing");
        rowModel.start();
    }
    gridReady() {
        const { eventSvc: eventSvc, gos: gos } = this;
        eventSvc.dispatchEvent({
            type: "gridReady"
        });
        $437b23f6a393c3bf$var$_logIfDebug(gos, `initialised successfully, enterprise = ${gos.isModuleRegistered("EnterpriseCore")}`);
    }
    setColumnDefs(event) {
        const columnDefs = this.gos.get("columnDefs");
        if (!columnDefs) return;
        if (this.waitingForColumns) {
            this.waitingForColumns = false;
            this.setColumnsAndData(columnDefs);
            return;
        }
        this.beans.colModel.setColumnDefs(columnDefs, $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source));
    }
};
// packages/ag-grid-community/src/valueService/cellApi.ts
function $437b23f6a393c3bf$var$expireValueCache(beans) {
    beans.valueCache?.expire();
}
function $437b23f6a393c3bf$var$getCellValue(beans, params) {
    const { colKey: colKey, rowNode: rowNode, useFormatter: useFormatter } = params;
    const column = beans.colModel.getColDefCol(colKey) ?? beans.colModel.getCol(colKey);
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(column)) return null;
    const result = beans.valueSvc.getValueForDisplay(column, rowNode, useFormatter);
    if (useFormatter) return result.valueFormatted ?? $437b23f6a393c3bf$export$a16cfb6652fe466f(result.value);
    return result.value;
}
// packages/ag-grid-community/src/valueService/changeDetectionService.ts
var $437b23f6a393c3bf$var$SOURCE_PASTE = "paste";
var $437b23f6a393c3bf$var$ChangeDetectionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "changeDetectionSvc";
        this.clientSideRowModel = null;
    }
    postConstruct() {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) this.clientSideRowModel = rowModel;
        this.addManagedEventListeners({
            cellValueChanged: this.onCellValueChanged.bind(this)
        });
    }
    onCellValueChanged(event) {
        const { gos: gos, rowRenderer: rowRenderer } = this.beans;
        if (event.source === $437b23f6a393c3bf$var$SOURCE_PASTE || gos.get("suppressChangeDetection")) return;
        const rowNode = event.node;
        const nodesToRefresh = [
            rowNode
        ];
        const clientSideRowModel = this.clientSideRowModel;
        const rootNode = clientSideRowModel?.rootNode;
        if (rootNode && !rowNode.isRowPinned()) {
            const onlyChangedColumns = gos.get("aggregateOnlyChangedColumns");
            const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(onlyChangedColumns, rootNode);
            changedPath.addParentNode(rowNode.parent, [
                event.column
            ]);
            clientSideRowModel.doAggregate(changedPath);
            changedPath.forEachChangedNodeDepthFirst((rowNode2)=>{
                nodesToRefresh.push(rowNode2);
                if (rowNode2.sibling) nodesToRefresh.push(rowNode2.sibling);
            });
        }
        rowRenderer.refreshCells({
            rowNodes: nodesToRefresh
        });
    }
};
// packages/ag-grid-community/src/valueService/expressionService.ts
var $437b23f6a393c3bf$var$ExpressionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "expressionSvc";
        this.cache = {};
    }
    evaluate(expression, params) {
        if (typeof expression === "string") return this.evaluateExpression(expression, params);
        else $437b23f6a393c3bf$export$a20c7248650823a9(15, {
            expression: expression
        });
    }
    evaluateExpression(expression, params) {
        try {
            const javaScriptFunction = this.createExpressionFunction(expression);
            const result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.getValue, params.column, params.columnGroup);
            return result;
        } catch (e) {
            $437b23f6a393c3bf$export$a20c7248650823a9(16, {
                expression: expression,
                params: params,
                e: e
            });
            return null;
        }
    }
    createExpressionFunction(expression) {
        const expressionToFunctionCache = this.cache;
        if (expressionToFunctionCache[expression]) return expressionToFunctionCache[expression];
        const functionBody = this.createFunctionBody(expression);
        const theFunction = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, getValue, column, columnGroup", functionBody);
        expressionToFunctionCache[expression] = theFunction;
        return theFunction;
    }
    createFunctionBody(expression) {
        if (expression.includes("return")) return expression;
        else return "return " + expression + ";";
    }
};
// packages/ag-grid-community/src/valueService/valueCache.ts
var $437b23f6a393c3bf$var$ValueCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "valueCache";
        this.cacheVersion = 0;
    }
    postConstruct() {
        const gos = this.gos;
        this.active = gos.get("valueCache");
        this.neverExpires = gos.get("valueCacheNeverExpires");
    }
    onDataChanged() {
        if (this.neverExpires) return;
        this.expire();
    }
    expire() {
        this.cacheVersion++;
    }
    setValue(rowNode, colId, value) {
        if (this.active) {
            const cacheVersion = this.cacheVersion;
            if (rowNode.__cacheVersion !== cacheVersion) {
                rowNode.__cacheVersion = cacheVersion;
                rowNode.__cacheData = {};
            }
            rowNode.__cacheData[colId] = value;
        }
    }
    getValue(rowNode, colId) {
        if (!this.active || rowNode.__cacheVersion !== this.cacheVersion) return void 0;
        return rowNode.__cacheData[colId];
    }
};
// packages/ag-grid-community/src/valueService/valueModule.ts
var $437b23f6a393c3bf$export$3110fedd6be63d8e = {
    moduleName: "ValueCache",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ValueCache
    ],
    apiFunctions: {
        expireValueCache: $437b23f6a393c3bf$var$expireValueCache
    }
};
var $437b23f6a393c3bf$var$ExpressionModule = {
    moduleName: "Expression",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ExpressionService
    ]
};
var $437b23f6a393c3bf$var$ChangeDetectionModule = {
    moduleName: "ChangeDetection",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ChangeDetectionService
    ]
};
var $437b23f6a393c3bf$export$d7a9d7f5c41fb970 = {
    moduleName: "CellApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        getCellValue: $437b23f6a393c3bf$var$getCellValue
    }
};
// packages/ag-grid-community/src/valueService/valueService.ts
var $437b23f6a393c3bf$var$ValueService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "valueSvc";
        this.hasEditSvc = false;
        this.initialised = false;
        this.isSsrm = false;
    }
    wireBeans(beans) {
        this.expressionSvc = beans.expressionSvc;
        this.colModel = beans.colModel;
        this.valueCache = beans.valueCache;
        this.dataTypeSvc = beans.dataTypeSvc;
        this.editSvc = beans.editSvc;
        this.hasEditSvc = !!beans.editSvc;
    }
    postConstruct() {
        if (!this.initialised) this.init();
    }
    init() {
        this.executeValueGetter = this.valueCache ? this.executeValueGetterWithValueCache.bind(this) : this.executeValueGetterWithoutValueCache.bind(this);
        this.isSsrm = $437b23f6a393c3bf$export$cf1bac0013650216(this.gos);
        this.cellExpressions = this.gos.get("enableCellExpressions");
        this.isTreeData = this.gos.get("treeData");
        this.initialised = true;
        const listener = (event)=>this.callColumnCellValueChangedHandler(event);
        this.eventSvc.addListener("cellValueChanged", listener, true);
        this.addDestroyFunc(()=>this.eventSvc.removeListener("cellValueChanged", listener, true));
        this.addManagedPropertyListener("treeData", (propChange)=>this.isTreeData = propChange.currentValue);
    }
    /**
   * Use this function to get a displayable cell value.
   * The values from this function are not used for sorting, filtering, or aggregation purposes.
   * Handles: groupHideOpenParents, showOpenedGroup and groupSuppressBlankHeader behaviours
   */ getValueForDisplay(column, node, includeValueFormatted = false, exporting = false, source = "ui") {
        const { showRowGroupColValueSvc: showRowGroupColValueSvc } = this.beans;
        const isFullWidthGroup = !column && node.group;
        const isGroupCol = column?.colDef.showRowGroup;
        const processTreeDataAsGroup = !this.isTreeData || node.footer;
        if (showRowGroupColValueSvc && processTreeDataAsGroup && (isFullWidthGroup || isGroupCol)) {
            const groupValue = showRowGroupColValueSvc.getGroupValue(node, column);
            if (groupValue == null) return {
                value: null,
                valueFormatted: null
            };
            if (!includeValueFormatted) return {
                value: groupValue.value,
                valueFormatted: null
            };
            const valueFormatted = showRowGroupColValueSvc.formatAndPrefixGroupColValue(groupValue, column, exporting);
            return {
                value: groupValue.value,
                valueFormatted: valueFormatted
            };
        }
        if (!column) return {
            value: node.key,
            valueFormatted: null
        };
        const isPivotLeaf = node.leafGroup && this.colModel.isPivotMode();
        const isOpenedGroup = node.group && node.expanded && !node.footer && !isPivotLeaf;
        const groupShowsAggData = this.gos.get("groupSuppressBlankHeader") || !node.sibling;
        const ignoreAggData = isOpenedGroup && !groupShowsAggData;
        const value = this.getValue(column, node, ignoreAggData, source);
        const format = includeValueFormatted && !(exporting && column.colDef.useValueFormatterForExport === false);
        return {
            value: value,
            valueFormatted: format ? this.formatValue(column, node, value) : null
        };
    }
    getValue(column, rowNode, ignoreAggData = false, source = "ui") {
        if (!this.initialised) this.init();
        if (!rowNode) return;
        const colDef = column.getColDef();
        const field = colDef.field;
        const colId = column.getColId();
        const data = rowNode.data;
        if (this.hasEditSvc && source === "ui") {
            const editSvc = this.editSvc;
            if (editSvc.isEditing()) {
                const newValue = editSvc.getCellDataValue({
                    rowNode: rowNode,
                    column: column
                }, true);
                if (newValue !== void 0) return newValue;
            }
        }
        let result;
        const rowGroupColId = colDef.showRowGroup;
        if (typeof rowGroupColId === "string") {
            const colRowGroupIndex = this.beans.rowGroupColsSvc?.getColumnIndex(rowGroupColId) ?? -1;
            if (colRowGroupIndex > rowNode.level) return null;
        }
        const allowUserValuesForCell = typeof rowGroupColId !== "string" || !rowNode.group;
        const groupDataExists = rowNode.groupData && colId in rowNode.groupData;
        const aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== void 0;
        const ignoreSsrmAggData = this.isSsrm && ignoreAggData && !!colDef.aggFunc;
        const ssrmFooterGroupCol = this.isSsrm && rowNode.footer && rowNode.field && (colDef.showRowGroup === true || colDef.showRowGroup === rowNode.field);
        if (this.isTreeData && aggDataExists) result = rowNode.aggData[colId];
        else if (this.isTreeData && colDef.valueGetter) result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        else if (this.isTreeData && field && data) result = $437b23f6a393c3bf$var$_getValueUsingField(data, field, column.isFieldContainsDots());
        else if (groupDataExists) result = rowNode.groupData[colId];
        else if (aggDataExists) result = rowNode.aggData[colId];
        else if (colDef.valueGetter && !ignoreSsrmAggData) {
            if (!allowUserValuesForCell) return result;
            result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        } else if (ssrmFooterGroupCol) result = $437b23f6a393c3bf$var$_getValueUsingField(data, rowNode.field, column.isFieldContainsDots());
        else if (field && data && !ignoreSsrmAggData) {
            if (!allowUserValuesForCell) return result;
            result = $437b23f6a393c3bf$var$_getValueUsingField(data, field, column.isFieldContainsDots());
        }
        if (this.cellExpressions && typeof result === "string" && result.indexOf("=") === 0) {
            const cellValueGetter = result.substring(1);
            result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
        }
        return result;
    }
    parseValue(column, rowNode, newValue, oldValue) {
        const colDef = column.getColDef();
        const valueParser = colDef.valueParser;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueParser)) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                node: rowNode,
                data: rowNode?.data,
                oldValue: oldValue,
                newValue: newValue,
                colDef: colDef,
                column: column
            });
            if (typeof valueParser === "function") return valueParser(params);
            return this.expressionSvc?.evaluate(valueParser, params);
        }
        return newValue;
    }
    getDeleteValue(column, rowNode) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(column.getColDef().valueParser)) return this.parseValue(column, rowNode, "", this.getValueForDisplay(column, rowNode).value) ?? null;
        return null;
    }
    formatValue(column, node, value, suppliedFormatter, useFormatterFromColumn = true) {
        const { expressionSvc: expressionSvc } = this.beans;
        let result = null;
        let formatter;
        const colDef = column.getColDef();
        if (suppliedFormatter) formatter = suppliedFormatter;
        else if (useFormatterFromColumn) formatter = colDef.valueFormatter;
        if (formatter) {
            const data = node ? node.data : null;
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                node: node,
                data: data,
                colDef: colDef,
                column: column
            });
            if (typeof formatter === "function") result = formatter(params);
            else result = expressionSvc ? expressionSvc.evaluate(formatter, params) : null;
        } else if (colDef.refData) return colDef.refData[value] || "";
        if (result == null && Array.isArray(value)) result = value.join(", ");
        return result;
    }
    /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */ setValue(rowNode, colKey, newValue, eventSource) {
        const column = this.colModel.getColDefCol(colKey);
        if (!rowNode || !column) return false;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowNode.data)) rowNode.data = {};
        const { field: field, valueSetter: valueSetter } = column.getColDef();
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(field) && $437b23f6a393c3bf$export$672d9e47bc342bac(valueSetter)) {
            $437b23f6a393c3bf$export$545083624300f13d(17);
            return false;
        }
        if (this.dataTypeSvc && !this.dataTypeSvc.checkType(column, newValue)) {
            $437b23f6a393c3bf$export$545083624300f13d(135);
            return false;
        }
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            oldValue: this.getValue(column, rowNode, void 0, eventSource),
            newValue: newValue,
            colDef: column.getColDef(),
            column: column
        });
        params.newValue = newValue;
        let valueWasDifferent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueSetter)) {
            if (typeof valueSetter === "function") valueWasDifferent = valueSetter(params);
            else valueWasDifferent = this.expressionSvc?.evaluate(valueSetter, params);
        } else valueWasDifferent = this.setValueUsingField(rowNode.data, field, newValue, column.isFieldContainsDots());
        if (valueWasDifferent === void 0) valueWasDifferent = true;
        if (!valueWasDifferent) return false;
        rowNode.resetQuickFilterAggregateText();
        this.valueCache?.onDataChanged();
        const savedValue = this.getValue(column, rowNode);
        this.dispatchCellValueChangedEvent(rowNode, params, savedValue, eventSource);
        if (rowNode.pinnedSibling) this.dispatchCellValueChangedEvent(rowNode.pinnedSibling, params, savedValue, eventSource);
        return true;
    }
    dispatchCellValueChangedEvent(rowNode, params, value, source) {
        this.eventSvc.dispatchEvent({
            type: "cellValueChanged",
            event: null,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            column: params.column,
            colDef: params.colDef,
            data: rowNode.data,
            node: rowNode,
            oldValue: params.oldValue,
            newValue: value,
            value: value,
            source: source
        });
    }
    callColumnCellValueChangedHandler(event) {
        const onCellValueChanged = event.colDef.onCellValueChanged;
        if (typeof onCellValueChanged === "function") this.beans.frameworkOverrides.wrapOutgoing(()=>{
            onCellValueChanged({
                node: event.node,
                data: event.data,
                oldValue: event.oldValue,
                newValue: event.newValue,
                colDef: event.colDef,
                column: event.column,
                api: event.api,
                context: event.context
            });
        });
    }
    setValueUsingField(data, field, newValue, isFieldContainsDots) {
        if (!field) return false;
        let valuesAreSame = false;
        if (!isFieldContainsDots) {
            valuesAreSame = data[field] === newValue;
            if (!valuesAreSame) data[field] = newValue;
        } else {
            const fieldPieces = field.split(".");
            let currentObject = data;
            while(fieldPieces.length > 0 && currentObject){
                const fieldPiece = fieldPieces.shift();
                if (fieldPieces.length === 0) {
                    valuesAreSame = currentObject[fieldPiece] === newValue;
                    if (!valuesAreSame) currentObject[fieldPiece] = newValue;
                } else currentObject = currentObject[fieldPiece];
            }
        }
        return !valuesAreSame;
    }
    executeValueGetterWithValueCache(valueGetter, data, column, rowNode) {
        const colId = column.getColId();
        const valueFromCache = this.valueCache.getValue(rowNode, colId);
        if (valueFromCache !== void 0) return valueFromCache;
        const result = this.executeValueGetterWithoutValueCache(valueGetter, data, column, rowNode);
        this.valueCache.setValue(rowNode, colId, result);
        return result;
    }
    executeValueGetterWithoutValueCache(valueGetter, data, column, rowNode) {
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            data: data,
            node: rowNode,
            column: column,
            colDef: column.getColDef(),
            getValue: this.getValueCallback.bind(this, rowNode)
        });
        let result;
        if (typeof valueGetter === "function") result = valueGetter(params);
        else result = this.expressionSvc?.evaluate(valueGetter, params);
        return result;
    }
    getValueCallback(node, field) {
        const otherColumn = this.colModel.getColDefCol(field);
        if (otherColumn) return this.getValue(otherColumn, node);
        return null;
    }
    // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
    getKeyForNode(col, rowNode) {
        const value = this.getValue(col, rowNode);
        const keyCreator = col.getColDef().keyCreator;
        let result = value;
        if (keyCreator) {
            const keyParams = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                colDef: col.getColDef(),
                column: col,
                node: rowNode,
                data: rowNode.data
            });
            result = keyCreator(keyParams);
        }
        if (typeof result === "string" || result == null) return result;
        result = String(result);
        if (result === "[object Object]") $437b23f6a393c3bf$export$545083624300f13d(121);
        return result;
    }
};
// packages/ag-grid-community/src/gridCoreModule.ts
var $437b23f6a393c3bf$var$CommunityCoreModule = {
    moduleName: "CommunityCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$GridDestroyService,
        $437b23f6a393c3bf$var$ApiFunctionService,
        $437b23f6a393c3bf$var$Registry,
        $437b23f6a393c3bf$var$UserComponentFactory,
        $437b23f6a393c3bf$var$RowContainerHeightService,
        $437b23f6a393c3bf$var$VisibleColsService,
        $437b23f6a393c3bf$var$EventService,
        $437b23f6a393c3bf$var$GridOptionsService,
        $437b23f6a393c3bf$var$ColumnModel,
        $437b23f6a393c3bf$var$PageBoundsService,
        $437b23f6a393c3bf$var$PageBoundsListener,
        $437b23f6a393c3bf$var$RowRenderer,
        $437b23f6a393c3bf$var$ValueService,
        $437b23f6a393c3bf$var$FocusService,
        $437b23f6a393c3bf$var$Environment,
        $437b23f6a393c3bf$var$ScrollVisibleService,
        $437b23f6a393c3bf$var$CtrlsService,
        $437b23f6a393c3bf$var$SyncService,
        $437b23f6a393c3bf$var$ColumnNameService,
        $437b23f6a393c3bf$var$ColumnViewportService,
        $437b23f6a393c3bf$var$IconService
    ],
    icons: {
        // icon on select dropdowns (select cell editor, charts tool panels)
        selectOpen: "small-down",
        /** @deprecated v33 */ smallDown: "small-down",
        /** @deprecated v33 */ colorPicker: "color-picker",
        /** @deprecated v33 */ smallUp: "small-up",
        /** @deprecated v33 */ checkboxChecked: "small-up",
        /** @deprecated v33 */ checkboxIndeterminate: "checkbox-indeterminate",
        /** @deprecated v33 */ checkboxUnchecked: "checkbox-unchecked",
        /** @deprecated v33 */ radioButtonOn: "radio-button-on",
        /** @deprecated v33 */ radioButtonOff: "radio-button-off",
        /** @deprecated v33 */ smallLeft: "small-left",
        /** @deprecated v33 */ smallRight: "small-right"
    },
    apiFunctions: {
        getGridId: $437b23f6a393c3bf$var$getGridId,
        destroy: $437b23f6a393c3bf$var$destroy,
        isDestroyed: $437b23f6a393c3bf$var$isDestroyed,
        getGridOption: $437b23f6a393c3bf$var$getGridOption,
        setGridOption: $437b23f6a393c3bf$var$setGridOption,
        updateGridOptions: $437b23f6a393c3bf$var$updateGridOptions,
        isModuleRegistered: $437b23f6a393c3bf$var$isModuleRegistered
    },
    dependsOn: [
        $437b23f6a393c3bf$var$DataTypeModule,
        $437b23f6a393c3bf$export$1458fbffed29c925,
        $437b23f6a393c3bf$var$ColumnResizeModule,
        $437b23f6a393c3bf$export$1a6625c5691649e8,
        $437b23f6a393c3bf$var$ColumnHeaderCompModule,
        $437b23f6a393c3bf$export$922da35340a6d14e,
        $437b23f6a393c3bf$var$ColumnGroupHeaderCompModule,
        $437b23f6a393c3bf$var$OverlayModule,
        $437b23f6a393c3bf$var$ChangeDetectionModule,
        $437b23f6a393c3bf$var$AnimationFrameModule,
        $437b23f6a393c3bf$export$44f04c51d8088336,
        $437b23f6a393c3bf$var$PinnedColumnModule,
        $437b23f6a393c3bf$var$AriaModule,
        $437b23f6a393c3bf$var$TouchModule,
        $437b23f6a393c3bf$var$CellRendererFunctionModule,
        $437b23f6a393c3bf$var$ColumnFlexModule,
        $437b23f6a393c3bf$var$ExpressionModule,
        $437b23f6a393c3bf$var$SkeletonCellRendererModule,
        $437b23f6a393c3bf$var$ColumnDelayRenderModule
    ]
};
// packages/ag-grid-community/src/validation/enterpriseModuleNames.ts
var $437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES = {
    AdvancedFilter: 1,
    AiToolkit: 1,
    AllEnterprise: 1,
    BatchEdit: 1,
    CellSelection: 1,
    Clipboard: 1,
    ColumnMenu: 1,
    ColumnsToolPanel: 1,
    ContextMenu: 1,
    ExcelExport: 1,
    FiltersToolPanel: 1,
    Find: 1,
    GridCharts: 1,
    IntegratedCharts: 1,
    GroupFilter: 1,
    MasterDetail: 1,
    Menu: 1,
    MultiFilter: 1,
    NewFiltersToolPanel: 1,
    Pivot: 1,
    RangeSelection: 1,
    RichSelect: 1,
    RowNumbers: 1,
    RowGrouping: 1,
    RowGroupingPanel: 1,
    ServerSideRowModelApi: 1,
    ServerSideRowModel: 1,
    SetFilter: 1,
    SideBar: 1,
    Sparklines: 1,
    StatusBar: 1,
    TreeData: 1,
    ViewportRowModel: 1
};
// packages/ag-grid-community/src/validation/resolvableModuleNames.ts
var $437b23f6a393c3bf$var$ALL_COLUMN_FILTERS = [
    "TextFilter",
    "NumberFilter",
    "DateFilter",
    "SetFilter",
    "MultiFilter",
    "GroupFilter",
    "CustomFilter"
];
var $437b23f6a393c3bf$var$RESOLVABLE_MODULE_NAMES = {
    EditCore: [
        "TextEditor",
        "NumberEditor",
        "DateEditor",
        "CheckboxEditor",
        "LargeTextEditor",
        "SelectEditor",
        "RichSelect",
        "CustomEditor"
    ],
    CheckboxCellRenderer: [
        "AllCommunity"
    ],
    ClientSideRowModelHierarchy: [
        "RowGrouping",
        "Pivot",
        "TreeData"
    ],
    ColumnFilter: $437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
    ColumnGroupHeaderComp: [
        "AllCommunity"
    ],
    ColumnGroup: [
        "AllCommunity"
    ],
    ColumnHeaderComp: [
        "AllCommunity"
    ],
    ColumnMove: [
        "AllCommunity"
    ],
    ColumnResize: [
        "AllCommunity"
    ],
    CommunityCore: [
        "AllCommunity"
    ],
    CsrmSsrmSharedApi: [
        "ClientSideRowModelApi",
        "ServerSideRowModelApi"
    ],
    RowModelSharedApi: [
        "ClientSideRowModelApi",
        "ServerSideRowModelApi"
    ],
    EnterpriseCore: [
        "AllEnterprise"
    ],
    FilterCore: [
        ...$437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
        "QuickFilter",
        "ExternalFilter",
        "AdvancedFilter"
    ],
    GroupCellRenderer: [
        "RowGrouping",
        "Pivot",
        "TreeData",
        "MasterDetail",
        "ServerSideRowModel"
    ],
    KeyboardNavigation: [
        "AllCommunity"
    ],
    LoadingCellRenderer: [
        "ServerSideRowModel"
    ],
    MenuCore: [
        "ColumnMenu",
        "ContextMenu"
    ],
    MenuItem: [
        "ColumnMenu",
        "ContextMenu",
        "MultiFilter",
        "IntegratedCharts",
        "ColumnsToolPanel"
    ],
    Overlay: [
        "AllCommunity"
    ],
    PinnedColumn: [
        "AllCommunity"
    ],
    SharedAggregation: [
        "RowGrouping",
        "Pivot",
        "TreeData",
        "ServerSideRowModel"
    ],
    SharedDragAndDrop: [
        "AllCommunity"
    ],
    SharedMasterDetail: [
        "MasterDetail",
        "ServerSideRowModel"
    ],
    SharedMenu: [
        ...$437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
        "ColumnMenu",
        "ContextMenu"
    ],
    SharedPivot: [
        "Pivot",
        "ServerSideRowModel"
    ],
    SharedRowGrouping: [
        "RowGrouping",
        "ServerSideRowModel"
    ],
    SharedRowSelection: [
        "RowSelection",
        "ServerSideRowModel"
    ],
    SkeletonCellRenderer: [
        "ServerSideRowModel"
    ],
    Sort: [
        "AllCommunity"
    ],
    SsrmInfiniteSharedApi: [
        "InfiniteRowModel",
        "ServerSideRowModelApi"
    ],
    SharedTreeData: [
        "TreeData",
        "ServerSideRowModel"
    ]
};
var $437b23f6a393c3bf$var$MODULES_FOR_ROW_MODELS = {
    InfiniteRowModel: "infinite",
    ClientSideRowModelApi: "clientSide",
    ClientSideRowModel: "clientSide",
    ServerSideRowModelApi: "serverSide",
    ServerSideRowModel: "serverSide",
    ViewportRowModel: "viewport"
};
function $437b23f6a393c3bf$var$resolveModuleNames(moduleName, rowModelType) {
    const resolvedModuleNames = [];
    for (const modName of Array.isArray(moduleName) ? moduleName : [
        moduleName
    ]){
        const resolved = $437b23f6a393c3bf$var$RESOLVABLE_MODULE_NAMES[modName];
        if (resolved) for (const resolvedModName of resolved){
            const rowModelForModule = $437b23f6a393c3bf$var$MODULES_FOR_ROW_MODELS[resolvedModName];
            if (!rowModelForModule || rowModelForModule === rowModelType) resolvedModuleNames.push(resolvedModName);
        }
        else resolvedModuleNames.push(modName);
    }
    return resolvedModuleNames;
}
// packages/ag-grid-community/src/validation/errorMessages/errorText.ts
var $437b23f6a393c3bf$var$NoModulesRegisteredError = ()=>`No AG Grid modules are registered! It is recommended to start with all Community features via the AllCommunityModule:
                    
    import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
    
    ModuleRegistry.registerModules([ AllCommunityModule ]);
    `;
var $437b23f6a393c3bf$var$moduleImportMsg = (moduleNames)=>{
    const imports = moduleNames.map((moduleName)=>`import { ${$437b23f6a393c3bf$var$convertToUserModuleName(moduleName)} } from '${$437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES[moduleName] ? "ag-grid-enterprise" : "ag-grid-community"}';`);
    const includeCharts = moduleNames.some((m)=>m === "IntegratedCharts" || m === "Sparklines");
    if (includeCharts) {
        const chartImport = `import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';`;
        imports.push(chartImport);
    }
    return `import { ModuleRegistry } from 'ag-grid-community'; 
${imports.join(" \n")} 

ModuleRegistry.registerModules([ ${moduleNames.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m, true)).join(", ")} ]); 

For more info see: ${$437b23f6a393c3bf$var$baseDocLink}/modules/`;
};
function $437b23f6a393c3bf$var$convertToUserModuleName(moduleName, inModuleRegistration = false) {
    if (inModuleRegistration && (moduleName === "IntegratedCharts" || moduleName === "Sparklines")) return `${moduleName}Module.with(AgChartsEnterpriseModule)`;
    return `${moduleName}Module`;
}
function $437b23f6a393c3bf$var$umdMissingModule(reasonOrId, moduleNames) {
    const chartModules = moduleNames.filter((m)=>m === "IntegratedCharts" || m === "Sparklines");
    let message = "";
    const agChartsDynamic = globalThis?.agCharts;
    if (!agChartsDynamic && chartModules.length > 0) message = `Unable to use ${reasonOrId} as either the ag-charts-community or ag-charts-enterprise script needs to be included alongside ag-grid-enterprise.
`;
    else if (moduleNames.some((m)=>$437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES[m])) message = message + `Unable to use ${reasonOrId} as that requires the ag-grid-enterprise script to be included.
`;
    return message;
}
function $437b23f6a393c3bf$var$missingRowModelTypeError({ moduleName: moduleName, rowModelType: rowModelType }) {
    return `To use the ${moduleName}Module you must set the gridOption "rowModelType='${rowModelType}'"`;
}
var $437b23f6a393c3bf$var$missingModule = ({ reasonOrId: reasonOrId, moduleName: moduleName, gridScoped: gridScoped, gridId: gridId, rowModelType: rowModelType, additionalText: additionalText, isUmd: isUmd2 })=>{
    const resolvedModuleNames = $437b23f6a393c3bf$var$resolveModuleNames(moduleName, rowModelType);
    const reason = typeof reasonOrId === "string" ? reasonOrId : $437b23f6a393c3bf$var$MISSING_MODULE_REASONS[reasonOrId];
    if (isUmd2) return $437b23f6a393c3bf$var$umdMissingModule(reason, resolvedModuleNames);
    const chartModules = resolvedModuleNames.filter((m)=>m === "IntegratedCharts" || m === "Sparklines");
    const chartImportRequired = chartModules.length > 0 ? `${chartModules.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m)).join()} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.` : "";
    const explanation = `Unable to use ${reason} as ${resolvedModuleNames.length > 1 ? "one of " + resolvedModuleNames.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m)).join(", ") : $437b23f6a393c3bf$var$convertToUserModuleName(resolvedModuleNames[0])} is not registered${gridScoped ? " for gridId: " + gridId : ""}. ${chartImportRequired} Check if you have registered the module:
`;
    return `${explanation}
${$437b23f6a393c3bf$var$moduleImportMsg(resolvedModuleNames)}` + (additionalText ? ` 

${additionalText}` : "");
};
var $437b23f6a393c3bf$var$missingChartsWithModule = (gridModule)=>{
    return `${gridModule} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.

import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { ${gridModule} } from 'ag-grid-enterprise';
    
ModuleRegistry.registerModules([${gridModule}.with(AgChartsEnterpriseModule)]);
    `;
};
var $437b23f6a393c3bf$var$clipboardApiError = (method)=>`AG Grid: Unable to use the Clipboard API (navigator.clipboard.${method}()). The reason why it could not be used has been logged in the previous line. For this reason the grid has defaulted to using a workaround which doesn't perform as well. Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.`;
var $437b23f6a393c3bf$var$AG_GRID_ERRORS = {
    1: ()=>"`rowData` must be an array",
    2: ({ nodeId: nodeId })=>`Duplicate node id '${nodeId}' detected from getRowId callback, this could cause issues in your grid.`,
    3: ()=>"Calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.",
    4: ({ id: id })=>`Could not find row id=${id}, data item was not found for this id`,
    5: ({ data: data })=>[
            `Could not find data item as object was not found.`,
            data,
            " Consider using getRowId to help the Grid find matching row data"
        ],
    6: ()=>`'groupHideOpenParents' only works when specifying specific columns for 'colDef.showRowGroup'`,
    7: ()=>"Pivoting is not supported with aligned grids as it may produce different columns in each grid.",
    8: ({ key: key })=>`Unknown key for navigation ${key}`,
    9: ({ variable: variable })=>`No value for ${variable?.cssName}. This usually means that the grid has been initialised before styles have been loaded. The default value of ${variable?.defaultValue} will be used and updated when styles load.`,
    10: ({ eventType: eventType })=>`As of v33, the '${eventType}' event is deprecated. Use the global 'modelUpdated' event to determine when row children have changed.`,
    11: ()=>"No gridOptions provided to createGrid",
    12: ({ colKey: colKey })=>[
            "column ",
            colKey,
            " not found"
        ],
    13: ()=>"Could not find rowIndex, this means tasks are being executed on a rowNode that has been removed from the grid.",
    14: ({ groupPrefix: groupPrefix })=>`Row IDs cannot start with ${groupPrefix}, this is a reserved prefix for AG Grid's row grouping feature.`,
    15: ({ expression: expression })=>[
            "value should be either a string or a function",
            expression
        ],
    16: ({ expression: expression, params: params, e: e })=>[
            "Processing of the expression failed",
            "Expression = ",
            expression,
            "Params = ",
            params,
            "Exception = ",
            e
        ],
    17: ()=>"you need either field or valueSetter set on colDef for editing to work",
    18: ()=>`alignedGrids contains an undefined option.`,
    19: ()=>`alignedGrids - No api found on the linked grid.`,
    20: ()=>`You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`,
    21: ()=>"pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.",
    22: ({ key: key })=>`${key} is an initial property and cannot be updated.`,
    23: ()=>"The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.",
    24: ()=>"row height must be a number if not using standard row model",
    25: ({ id: id })=>[
            `The getRowId callback must return a string. The ID `,
            id,
            ` is being cast to a string.`
        ],
    26: ({ fnName: fnName, preDestroyLink: preDestroyLink })=>{
        return `Grid API function ${fnName}() cannot be called as the grid has been destroyed.
 Either clear local references to the grid api, when it is destroyed, or check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
 To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${preDestroyLink}`;
    },
    27: ({ fnName: fnName, module: module })=>`API function '${fnName}' not registered to module '${module}'`,
    28: ()=>"setRowCount cannot be used while using row grouping.",
    29: ()=>"tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?",
    30: ({ toIndex: toIndex })=>[
            "tried to insert columns in invalid location, toIndex = ",
            toIndex,
            "remember that you should not count the moving columns when calculating the new index"
        ],
    31: ()=>"infinite loop in resizeColumnSets",
    32: ()=>"applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.",
    33: ()=>"stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.",
    34: ({ key: key })=>`the column type '${key}' is a default column type and cannot be overridden.`,
    35: ()=>`Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.`,
    36: ({ t: t })=>"colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes",
    37: ()=>`Changing the column pinning status is not allowed with domLayout='print'`,
    38: ({ iconName: iconName })=>`provided icon '${iconName}' needs to be a string or a function`,
    39: ()=>"Applying column order broke a group where columns should be married together. Applying new order has been discarded.",
    40: ({ e: e, method: method })=>`${e}
${$437b23f6a393c3bf$var$clipboardApiError(method)}`,
    41: ()=>"Browser did not allow document.execCommand('copy'). Ensure 'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise the browser will prevent it for security reasons.",
    42: ()=>"Browser does not support document.execCommand('copy') for clipboard operations",
    43: ({ iconName: iconName })=>`As of v33, icon '${iconName}' is deprecated. Use the icon CSS name instead.`,
    44: ()=>'Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.',
    45: ({ parentCellDataType: parentCellDataType })=>`The data type definition ${parentCellDataType} does not exist.`,
    46: ()=>'The "baseDataType" property of a data type definition must match that of its parent.',
    47: ({ cellDataType: cellDataType })=>`Missing data type definition - "${cellDataType}"`,
    48: ({ property: property })=>`Cell data type is "object" but no Value ${property} has been provided. Please either provide an object data type definition with a Value ${property}, or set "colDef.value${property}"`,
    49: ({ methodName: methodName })=>`Framework component is missing the method ${methodName}()`,
    50: ({ compName: compName })=>`Could not find component ${compName}, did you forget to configure this component?`,
    51: ()=>`Export cancelled. Export is not allowed as per your configuration.`,
    52: ()=>"There is no `window` associated with the current `document`",
    53: ()=>`unknown value type during csv conversion`,
    54: ()=>"Could not find document body, it is needed for drag and drop and context menu.",
    55: ()=>"addRowDropZone - A container target needs to be provided",
    56: ()=>"addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.",
    57: ()=>"unable to show popup filter, filter instantiation failed",
    58: ()=>"no values found for select cellEditor",
    59: ()=>"cannot select pinned rows",
    60: ()=>"cannot select node until it has finished loading",
    61: ()=>"since version v32.2.0, rowNode.isFullWidthCell() has been deprecated. Instead check `rowNode.detail` followed by the user provided `isFullWidthRow` grid option.",
    62: ({ colId: colId })=>`setFilterModel() - no column found for colId: ${colId}`,
    63: ({ colId: colId })=>`setFilterModel() - unable to fully apply model, filtering disabled for colId: ${colId}`,
    64: ({ colId: colId })=>`setFilterModel() - unable to fully apply model, unable to create filter for colId: ${colId}`,
    65: ()=>"filter missing setModel method, which is needed for setFilterModel",
    66: ()=>"filter API missing getModel method, which is needed for getFilterModel",
    67: ()=>"Filter is missing isFilterActive() method",
    68: ()=>"Column Filter API methods have been disabled as Advanced Filters are enabled.",
    69: ({ guiFromFilter: guiFromFilter })=>`getGui method from filter returned ${guiFromFilter}; it should be a DOM element.`,
    70: ({ newFilter: newFilter })=>`Grid option quickFilterText only supports string inputs, received: ${typeof newFilter}`,
    71: ()=>"debounceMs is ignored when apply button is present",
    72: ({ keys: keys })=>[
            `ignoring FilterOptionDef as it doesn't contain one of `,
            keys
        ],
    73: ()=>`invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'`,
    74: ()=>"no filter options for filter",
    75: ()=>"Unknown button type specified",
    76: ({ filterModelType: filterModelType })=>[
            'Unexpected type of filter "',
            filterModelType,
            '", it looks like the filter was configured with incorrect Filter Options'
        ],
    77: ()=>`Filter model is missing 'conditions'`,
    78: ()=>'Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.',
    79: ()=>'"filterParams.maxNumConditions" must be greater than or equal to zero.',
    80: ()=>'"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.',
    81: ()=>'"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".',
    82: ({ param: param })=>`DateFilter ${param} is not a number`,
    83: ()=>`DateFilter minValidYear should be <= maxValidYear`,
    84: ()=>`DateFilter minValidDate should be <= maxValidDate`,
    85: ()=>"DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.",
    86: ()=>"DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.",
    87: ()=>"DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.",
    88: ({ index: index })=>`Invalid row index for ensureIndexVisible: ${index}`,
    89: ()=>`A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)`,
    90: ()=>`datasource is missing getRows method`,
    91: ()=>"Filter is missing method doesFilterPass",
    92: ()=>`AnimationFrameService called but animation frames are off`,
    93: ()=>"cannot add multiple ranges when `cellSelection.suppressMultiRanges = true`",
    94: ({ paginationPageSizeOption: paginationPageSizeOption, pageSizeSet: pageSizeSet, pageSizesSet: pageSizesSet, pageSizeOptions: pageSizeOptions })=>`'paginationPageSize=${paginationPageSizeOption}'${pageSizeSet ? "" : " (default value)"}, but ${paginationPageSizeOption} is not included in${pageSizesSet ? "" : " the default"} paginationPageSizeSelector=[${pageSizeOptions?.join(", ")}].`,
    95: ({ paginationPageSizeOption: paginationPageSizeOption, paginationPageSizeSelector: paginationPageSizeSelector2 })=>`Either set '${paginationPageSizeSelector2}' to an array that includes ${paginationPageSizeOption} or to 'false' to disable the page size selector.`,
    96: ({ id: id, data: data })=>[
            "Duplicate ID",
            id,
            "found for pinned row with data",
            data,
            "When `getRowId` is defined, it must return unique IDs for all pinned rows. Use the `rowPinned` parameter."
        ],
    97: ({ colId: colId })=>`cellEditor for column ${colId} is missing getGui() method`,
    98: ()=>"popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.",
    99: ()=>"Since v32, `api.hideOverlay()` does not hide the loading overlay when `loading=true`. Set `loading=false` instead.",
    // 100: ({ rowModelType }: { rowModelType: RowModelType }) =>
    //     `selectAll only available when rowModelType='clientSide', ie not ${rowModelType}` as const,
    101: ({ propertyName: propertyName, componentName: componentName, agGridDefaults: agGridDefaults, jsComps: jsComps })=>{
        const textOutput = [];
        const validComponents = [
            // Don't include the old names / internals in potential suggestions
            ...Object.keys(agGridDefaults ?? []).filter((k)=>![
                    "agCellEditor",
                    "agGroupRowRenderer",
                    "agSortIndicator"
                ].includes(k)),
            ...Object.keys(jsComps ?? []).filter((k)=>!!jsComps[k])
        ];
        const suggestions = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
            inputValue: componentName,
            allSuggestions: validComponents,
            hideIrrelevant: true,
            filterByPercentageOfBestMatch: 0.8
        }).values;
        textOutput.push(`Could not find '${componentName}' component. It was configured as "${propertyName}: '${componentName}'" but it wasn't found in the list of registered components.
`);
        if (suggestions.length > 0) textOutput.push(`         Did you mean: [${suggestions.slice(0, 3)}]?
`);
        textOutput.push(`If using a custom component check it has been registered correctly.`);
        return textOutput;
    },
    102: ()=>"selectAll: 'filtered' only works when gridOptions.rowModelType='clientSide'",
    103: ()=>"Invalid selection state. When using client-side row model, the state must conform to `string[]`.",
    104: ({ value: value, param: param })=>`Numeric value ${value} passed to ${param} param will be interpreted as ${value} seconds. If this is intentional use "${value}s" to silence this warning.`,
    105: ({ e: e })=>[
            `chart rendering failed`,
            e
        ],
    106: ()=>`Theming API and Legacy Themes are both used in the same page. A Theming API theme has been provided to the 'theme' grid option, but the file (ag-grid.css) is also included and will cause styling issues. Remove ag-grid.css from the page. See the migration guide: ${$437b23f6a393c3bf$var$baseDocLink}/theming-migration/`,
    107: ({ key: key, value: value })=>`Invalid value for theme param ${key} - ${value}`,
    108: ({ e: e })=>[
            "chart update failed",
            e
        ],
    109: ({ inputValue: inputValue, allSuggestions: allSuggestions })=>{
        const suggestions = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
            inputValue: inputValue,
            allSuggestions: allSuggestions,
            hideIrrelevant: true,
            filterByPercentageOfBestMatch: 0.8
        }).values;
        return [
            `Could not find '${inputValue}' aggregate function. It was configured as "aggFunc: '${inputValue}'" but it wasn't found in the list of registered aggregations.`,
            suggestions.length > 0 ? `         Did you mean: [${suggestions.slice(0, 3)}]?` : "",
            `If using a custom aggregation function check it has been registered correctly.`
        ].join("\n");
    },
    110: ()=>"groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup",
    111: ()=>"Invalid selection state. When `groupSelects` is enabled, the state must conform to `IServerSideGroupSelectionState`.",
    113: ()=>"Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values",
    114: ({ component: component })=>`Could not find component with name of ${component}. Is it in Vue.components?`,
    // 115: () => 'The provided selection state should be an object.' as const,
    116: ()=>"Invalid selection state. The state must conform to `IServerSideSelectionState`.",
    117: ()=>"selectAll must be of boolean type.",
    118: ()=>"Infinite scrolling must be enabled in order to set the row count.",
    119: ()=>"Unable to instantiate filter",
    120: ()=>"MultiFloatingFilterComp expects MultiFilter as its parent",
    121: ()=>"a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (see AG Grid docs) or b) to toString() on the object to return a key",
    122: ()=>"could not find the document, document is empty",
    123: ()=>"Advanced Filter is only supported with the Client-Side Row Model or Server-Side Row Model.",
    124: ()=>"No active charts to update.",
    125: ({ chartId: chartId })=>`Unable to update chart. No active chart found with ID: ${chartId}.`,
    126: ()=>"unable to restore chart as no chart model is provided",
    127: ({ allRange: allRange })=>`unable to create chart as ${allRange ? "there are no columns in the grid" : "no range is selected"}.`,
    128: ({ feature: feature })=>`${feature} is only available if using 'multiRow' selection mode.`,
    129: ({ feature: feature, rowModel: rowModel })=>`${feature} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${rowModel}.`,
    130: ()=>'cannot multi select unless selection mode is "multiRow"',
    // 131: () => 'cannot range select while selecting multiple rows' as const,
    132: ()=>"Row selection features are not available unless `rowSelection` is enabled.",
    133: ({ iconName: iconName })=>`icon '${iconName}' function should return back a string or a dom object`,
    134: ({ iconName: iconName })=>`Did not find icon '${iconName}'`,
    135: ()=>`Data type of the new value does not match the cell data type of the column`,
    136: ()=>`Unable to update chart as the 'type' is missing. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.`,
    137: ({ type: type, currentChartType: currentChartType })=>`Unable to update chart as a '${type}' update type is not permitted on a ${currentChartType}.`,
    138: ({ chartType: chartType })=>`invalid chart type supplied: ${chartType}`,
    139: ({ customThemeName: customThemeName })=>`a custom chart theme with the name ${customThemeName} has been supplied but not added to the 'chartThemes' list`,
    140: ({ name: name })=>`no stock theme exists with the name '${name}' and no custom chart theme with that name was supplied to 'customChartThemes'`,
    141: ()=>"cross filtering with row grouping is not supported.",
    142: ()=>"cross filtering is only supported in the client side row model.",
    143: ({ panel: panel })=>`'${panel}' is not a valid Chart Tool Panel name`,
    144: ({ type: type })=>`Invalid charts data panel group name supplied: '${type}'`,
    145: ({ group: group })=>`As of v32, only one charts customize panel group can be expanded at a time. '${group}' will not be expanded.`,
    146: ({ comp: comp })=>`Unable to instantiate component '${comp}' as its module hasn't been loaded. Add 'ValidationModule' to see which module is required.`,
    147: ({ group: group })=>`Invalid charts customize panel group name supplied: '${group}'`,
    148: ({ group: group })=>`invalid chartGroupsDef config '${group}'`,
    149: ({ group: group, chartType: chartType })=>`invalid chartGroupsDef config '${group}.${chartType}'`,
    150: ()=>`'seriesChartTypes' are required when the 'customCombo' chart type is specified.`,
    151: ({ chartType: chartType })=>`invalid chartType '${chartType}' supplied in 'seriesChartTypes', converting to 'line' instead.`,
    152: ({ colId: colId })=>`no 'seriesChartType' found for colId = '${colId}', defaulting to 'line'.`,
    153: ({ chartDataType: chartDataType })=>`unexpected chartDataType value '${chartDataType}' supplied, instead use 'category', 'series' or 'excluded'`,
    154: ({ colId: colId })=>`cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' to be defined on the column with id: ${colId}`,
    155: ({ option: option })=>`'${option}' is not a valid Chart Toolbar Option`,
    156: ({ panel: panel })=>`Invalid panel in chartToolPanelsDef.panels: '${panel}'`,
    157: ({ unrecognisedGroupIds: unrecognisedGroupIds })=>[
            "unable to find group(s) for supplied groupIds:",
            unrecognisedGroupIds
        ],
    158: ()=>"can not expand a column item that does not represent a column group header",
    159: ()=>"Invalid params supplied to createExcelFileForExcel() - `ExcelExportParams.data` is empty.",
    160: ()=>`Export cancelled. Export is not allowed as per your configuration.`,
    161: ()=>"The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'",
    162: ({ id: id, dataType: dataType })=>`Unrecognized data type for excel export [${id}.dataType=${dataType}]`,
    163: ({ featureName: featureName })=>`Excel table export does not work with ${featureName}. The exported Excel file will not contain any Excel tables.
 Please turn off ${featureName} to enable Excel table exports.`,
    164: ()=>"Unable to add data table to Excel sheet: A table already exists.",
    165: ()=>"Unable to add data table to Excel sheet: Missing required parameters.",
    166: ({ unrecognisedGroupIds: unrecognisedGroupIds })=>[
            "unable to find groups for these supplied groupIds:",
            unrecognisedGroupIds
        ],
    167: ({ unrecognisedColIds: unrecognisedColIds })=>[
            "unable to find columns for these supplied colIds:",
            unrecognisedColIds
        ],
    168: ()=>"detailCellRendererParams.template should be function or string",
    169: ()=>'Reference to eDetailGrid was missing from the details template. Please add data-ref="eDetailGrid" to the template.',
    170: ({ providedStrategy: providedStrategy })=>`invalid cellRendererParams.refreshStrategy = ${providedStrategy} supplied, defaulting to refreshStrategy = 'rows'.`,
    171: ()=>"could not find detail grid options for master detail, please set gridOptions.detailCellRendererParams.detailGridOptions",
    172: ()=>"could not find getDetailRowData for master / detail, please set gridOptions.detailCellRendererParams.getDetailRowData",
    173: ({ group: group })=>`invalid chartGroupsDef config '${group}'`,
    174: ({ group: group, chartType: chartType })=>`invalid chartGroupsDef config '${group}.${chartType}'`,
    175: ({ menuTabName: menuTabName, itemsToConsider: itemsToConsider })=>[
            `Trying to render an invalid menu item '${menuTabName}'. Check that your 'menuTabs' contains one of `,
            itemsToConsider
        ],
    176: ({ key: key })=>`unknown menu item type ${key}`,
    177: ()=>`valid values for cellSelection.handle.direction are 'x', 'y' and 'xy'. Default to 'xy'.`,
    178: ({ colId: colId })=>`column ${colId} is not visible`,
    179: ()=>"totalValueGetter should be either a function or a string (expression)",
    180: ()=>"agRichSelectCellEditor requires cellEditorParams.values to be set",
    181: ()=>"agRichSelectCellEditor cannot have `multiSelect` and `allowTyping` set to `true`. AllowTyping has been turned off.",
    182: ()=>'you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data',
    183: ()=>"Group Column Filter only works on group columns. Please use a different filter.",
    184: ({ parentGroupData: parentGroupData, childNodeData: childNodeData })=>[
            `duplicate group keys for row data, keys should be unique`,
            [
                parentGroupData,
                childNodeData
            ]
        ],
    185: ({ data: data })=>[
            `getDataPath() should not return an empty path`,
            [
                data
            ]
        ],
    186: ({ rowId: rowId, rowData: rowData, duplicateRowsData: duplicateRowsData })=>[
            `duplicate group keys for row data, keys should be unique`,
            rowId,
            rowData,
            ...duplicateRowsData ?? []
        ],
    187: ({ rowId: rowId, firstData: firstData, secondData: secondData })=>[
            `Duplicate node id ${rowId}. Row IDs are provided via the getRowId() callback. Please modify the getRowId() callback code to provide unique row id values.`,
            "first instance",
            firstData,
            "second instance",
            secondData
        ],
    188: (props)=>`getRowId callback must be provided for Server Side Row Model ${props?.feature || "selection"} to work correctly.`,
    189: ({ startRow: startRow })=>`invalid value ${startRow} for startRow, the value should be >= 0`,
    190: ({ rowGroupId: rowGroupId, data: data })=>[
            `null and undefined values are not allowed for server side row model keys`,
            rowGroupId ? `column = ${rowGroupId}` : ``,
            `data is `,
            data
        ],
    // 191: () => `cannot multi select unless selection mode is 'multiRow'` as const,
    // 192: () => `cannot use range selection when multi selecting rows` as const,
    // 193: () => "cannot multi select unless selection mode is 'multiRow'" as const,
    194: ({ method: method })=>`calling gridApi.${method}() is only possible when using rowModelType=\`clientSide\`.`,
    195: ({ justCurrentPage: justCurrentPage })=>`selecting just ${justCurrentPage ? "current page" : "filtered"} only works when gridOptions.rowModelType='clientSide'`,
    196: ({ key: key })=>`Provided ids must be of string type. Invalid id provided: ${key}`,
    197: ()=>"`toggledNodes` must be an array of string ids.",
    // 198: () => `cannot multi select unless selection mode is 'multiRow'` as const,
    199: ()=>`getSelectedNodes and getSelectedRows functions cannot be used with select all functionality with the server-side row model. Use \`api.getServerSideSelectionState()\` instead.`,
    200: $437b23f6a393c3bf$var$missingModule,
    201: ({ rowModelType: rowModelType })=>`Could not find row model for rowModelType = ${rowModelType}`,
    202: ()=>`\`getSelectedNodes\` and \`getSelectedRows\` functions cannot be used with \`groupSelectsChildren\` and the server-side row model. Use \`api.getServerSideSelectionState()\` instead.`,
    203: ()=>"Server Side Row Model does not support Dynamic Row Height and Cache Purging. Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.",
    204: ()=>"Server Side Row Model does not support Auto Row Height and Cache Purging. Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.",
    205: ({ duplicateIdText: duplicateIdText })=>`Unable to display rows as duplicate row ids (${duplicateIdText}) were returned by the getRowId callback. Please modify the getRowId callback to provide unique ids.`,
    206: ()=>"getRowId callback must be implemented for transactions to work. Transaction was ignored.",
    207: ()=>'The Set Filter Parameter "defaultToNothingSelected" value was ignored because it does not work when "excelMode" is used.',
    208: ()=>`Set Filter Value Formatter must return string values. Please ensure the Set Filter Value Formatter returns string values for complex objects.`,
    209: ()=>`Set Filter Key Creator is returning null for provided values and provided values are primitives. Please provide complex objects. See ${$437b23f6a393c3bf$var$baseDocLink}/filter-set-filter-list/#filter-value-types`,
    210: ()=>"Set Filter has a Key Creator, but provided values are primitives. Did you mean to provide complex objects?",
    211: ()=>"property treeList=true for Set Filter params, but you did not provide a treeListPathGetter or values of type Date.",
    212: ()=>`please review all your toolPanel components, it seems like at least one of them doesn't have an id`,
    213: ()=>"Advanced Filter does not work with Filters Tool Panel. Filters Tool Panel has been disabled.",
    214: ({ key: key })=>`unable to lookup Tool Panel as invalid key supplied: ${key}`,
    215: ({ key: key, defaultByKey: defaultByKey })=>`the key ${key} is not a valid key for specifying a tool panel, valid keys are: ${Object.keys(defaultByKey ?? {}).join(",")}`,
    216: ({ name: name })=>`Missing component for '${name}'`,
    217: ({ invalidColIds: invalidColIds })=>[
            "unable to find grid columns for the supplied colDef(s):",
            invalidColIds
        ],
    218: ({ property: property, defaultOffset: defaultOffset })=>`${property} must be a number, the value you provided is not a valid number. Using the default of ${defaultOffset}px.`,
    219: ({ property: property })=>`Property ${property} does not exist on the target object.`,
    220: ({ lineDash: lineDash })=>`'${lineDash}' is not a valid 'lineDash' option.`,
    221: ()=>`agAggregationComponent should only be used with the client and server side row model.`,
    222: ()=>`agFilteredRowCountComponent should only be used with the client side row model.`,
    223: ()=>`agSelectedRowCountComponent should only be used with the client and server side row model.`,
    224: ()=>`agTotalAndFilteredRowCountComponent should only be used with the client side row model.`,
    225: ()=>"agTotalRowCountComponent should only be used with the client side row model.",
    226: ()=>"viewport is missing init method.",
    227: ()=>"menu item icon must be DOM node or string",
    228: ({ menuItemOrString: menuItemOrString })=>`unrecognised menu item ${menuItemOrString}`,
    229: ({ index: index })=>[
            "invalid row index for ensureIndexVisible: ",
            index
        ],
    230: ()=>"detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://www.ag-grid.com/react-data-grid/master-detail-custom-detail/",
    // @deprecated v32 mark for removal as part of v32 deprecated features
    231: ()=>"As of v32, using custom components with `reactiveCustomComponents = false` is deprecated.",
    232: ()=>"Using both rowData and v-model. rowData will be ignored.",
    233: ({ methodName: methodName })=>`Framework component is missing the method ${methodName}()`,
    234: ()=>'Group Column Filter does not work with the colDef property "field". This property will be ignored.',
    235: ()=>'Group Column Filter does not work with the colDef property "filterValueGetter". This property will be ignored.',
    236: ()=>'Group Column Filter does not work with the colDef property "filterParams". This property will be ignored.',
    237: ()=>"Group Column Filter does not work with Tree Data enabled. Please disable Tree Data, or use a different filter.",
    238: ()=>"setRowCount can only accept a positive row count.",
    239: ()=>'Theming API and CSS File Themes are both used in the same page. In v33 we released the Theming API as the new default method of styling the grid. See the migration docs https://www.ag-grid.com/react-data-grid/theming-migration/. Because no value was provided to the `theme` grid option it defaulted to themeQuartz. But the file (ag-grid.css) is also included and will cause styling issues. Either pass the string "legacy" to the theme grid option to use v32 style themes, or remove ag-grid.css from the page to use Theming API.',
    240: ({ theme: theme })=>`theme grid option must be a Theming API theme object or the string "legacy", received: ${theme}`,
    // 241: () => `cannot select multiple rows when rowSelection.mode is set to 'singleRow'` as const,
    // 242: () => 'cannot select multiple rows when using rangeSelect' as const,
    243: ()=>"Failed to deserialize state - each provided state object must be an object.",
    244: ()=>"Failed to deserialize state - `selectAllChildren` must be a boolean value or undefined.",
    245: ()=>"Failed to deserialize state - `toggledNodes` must be an array.",
    246: ()=>"Failed to deserialize state - Every `toggledNode` requires an associated string id.",
    247: ()=>`Row selection state could not be parsed due to invalid data. Ensure all child state has toggledNodes or does not conform with the parent rule. 
Please rebuild the selection state and reapply it.`,
    248: ()=>"SetFloatingFilter expects SetFilter as its parent",
    249: ()=>"Must supply a Value Formatter in Set Filter params when using a Key Creator",
    250: ()=>"Must supply a Key Creator in Set Filter params when `treeList = true` on a group column, and Tree Data or Row Grouping is enabled.",
    251: ({ chartType: chartType })=>`AG Grid: Unable to create chart as an invalid chartType = '${chartType}' was supplied.`,
    252: ()=>"cannot get grid to draw rows when it is in the middle of drawing rows. \nYour code probably called a grid API method while the grid was in the render stage. \nTo overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). \nTo see what part of your code that caused the refresh check this stacktrace.",
    253: ({ version: version })=>[
            "Illegal version string: ",
            version
        ],
    254: ()=>"Cannot create chart: no chart themes available.",
    255: ({ point: point })=>`Lone surrogate U+${point?.toString(16).toUpperCase()} is not a scalar value`,
    256: ()=>"Unable to initialise. See validation error, or load ValidationModule if missing.",
    257: ()=>$437b23f6a393c3bf$var$missingChartsWithModule("IntegratedChartsModule"),
    258: ()=>$437b23f6a393c3bf$var$missingChartsWithModule("SparklinesModule"),
    259: ({ part: part })=>`the argument to theme.withPart must be a Theming API part object, received: ${part}`,
    260: ({ propName: propName, compName: compName, gridScoped: gridScoped, gridId: gridId, rowModelType: rowModelType })=>$437b23f6a393c3bf$var$missingModule({
            reasonOrId: `AG Grid '${propName}' component: ${compName}`,
            moduleName: $437b23f6a393c3bf$var$USER_COMP_MODULES[compName],
            gridId: gridId,
            gridScoped: gridScoped,
            rowModelType: rowModelType
        }),
    261: ()=>"As of v33, `column.isHovered()` is deprecated. Use `api.isColumnHovered(column)` instead.",
    262: ()=>'As of v33, icon key "smallDown" is deprecated. Use "advancedFilterBuilderSelect" for Advanced Filter Builder dropdown, "selectOpen" for Select cell editor and dropdowns (e.g. Integrated Charts menu), "richSelectOpen" for Rich Select cell editor.',
    263: ()=>'As of v33, icon key "smallLeft" is deprecated. Use "panelDelimiterRtl" for Row Group Panel / Pivot Panel, "subMenuOpenRtl" for sub-menus.',
    264: ()=>'As of v33, icon key "smallRight" is deprecated. Use "panelDelimiter" for Row Group Panel / Pivot Panel, "subMenuOpen" for sub-menus.',
    265: ({ colId: colId })=>`Unable to infer chart data type for column '${colId}' if first data entry is null. Please specify "chartDataType", or a "cellDataType" in the column definition. For more information, see ${$437b23f6a393c3bf$var$baseDocLink}/integrated-charts-range-chart#coldefchartdatatype .`,
    266: ()=>'As of v33.1, using "keyCreator" with the Rich Select Editor has been deprecated. It now requires the "formatValue" callback to convert complex data to strings.',
    267: ()=>"Detail grids can not use a different theme to the master grid, the `theme` detail grid option will be ignored.",
    268: ()=>"Transactions aren't supported with tree data when using treeDataChildrenField",
    269: ()=>"When `masterSelects: 'detail'`, detail grids must be configured with multi-row selection",
    270: ({ id: id, parentId: parentId })=>`Cycle detected for row with id='${id}' and parent id='${parentId}'. Resetting the parent for row with id='${id}' and showing it as a root-level node.`,
    271: ({ id: id, parentId: parentId })=>`Parent row not found for row with id='${id}' and parent id='${parentId}'. Showing row with id='${id}' as a root-level node.`,
    272: ()=>$437b23f6a393c3bf$var$NoModulesRegisteredError(),
    273: ({ providedId: providedId, usedId: usedId })=>`Provided column id '${providedId}' was already in use, ensure all column and group ids are unique. Using '${usedId}' instead.`,
    274: ({ prop: prop })=>{
        let msg = `Since v33, ${prop} has been deprecated.`;
        switch(prop){
            case "maxComponentCreationTimeMs":
                msg += " This property is no longer required and so will be removed in a future version.";
                break;
            case "setGridApi":
                msg += ` This method is not called by AG Grid. To access the GridApi see: https://ag-grid.com/react-data-grid/grid-interface/#grid-api `;
                break;
            case "children":
                msg += ` For multiple versions AgGridReact does not support children.`;
                break;
        }
        return msg;
    },
    275: $437b23f6a393c3bf$var$missingRowModelTypeError,
    276: ()=>"Row Numbers Row Resizer cannot be used when Grid Columns have `autoHeight` enabled.",
    277: ({ colId: colId })=>`'enableFilterHandlers' is set to true, but column '${colId}' does not have 'filter.doesFilterPass' or 'filter.handler' set.`,
    278: ({ colId: colId })=>`Unable to create filter handler for column '${colId}'`,
    279: (_)=>{},
    // `Unable to create dynamic bean '${name}' during module init lifecycle, dynamic beans must be initialised on first use.` as const,
    280: ({ colId: colId })=>`'name' must be provided for custom filter components for column '${colId}`,
    281: ({ colId: colId })=>`Filter for column '${colId}' does not have 'filterParams.buttons', but the new Filters Tool Panel has buttons configured. Either configure buttons for the filter, or disable buttons on the Filters Tool Panel.`,
    282: ()=>"New filter tool panel requires `enableFilterHandlers: true`.",
    283: ()=>"As of v34, use the same method on the filter handler (`api.getColumnFilterHandler(colKey)`) instead.",
    284: ()=>"As of v34, filters are active when they have a model. Use `api.getColumnFilterModel()` instead.",
    285: ()=>"As of v34, use (`api.getColumnFilterModel()`) instead.",
    286: ()=>"As of v34, use (`api.setColumnFilterModel()`) instead.",
    287: ()=>"`api.doFilterAction()` requires `enableFilterHandlers = true",
    288: ()=>"`api.getColumnFilterModel(key, true)` requires `enableFilterHandlers = true",
    289: ({ rowModelType: rowModelType })=>`Row Model '${rowModelType}' is not supported with Batch Editing`,
    290: ({ rowIndex: rowIndex, rowPinned: rowPinned })=>`Row with index '${rowIndex}' and pinned state '${rowPinned}' not found`,
    291: ()=>"License Key being set multiple times with different values. This can result in an incorrect license key being used,",
    292: ({ colId: colId })=>`The Multi Filter for column '${colId}' has buttons configured against the child filters. When 'enableFilterHandlers=true', buttons must instead be provided against the parent Multi Filter params. The child filter buttons will be ignored.`
};
function $437b23f6a393c3bf$var$getError(errorId, args) {
    const msgOrFunc = $437b23f6a393c3bf$var$AG_GRID_ERRORS[errorId];
    if (!msgOrFunc) return [
        `Missing error text for error id ${errorId}!`
    ];
    const errorBody = msgOrFunc(args);
    const errorLink = $437b23f6a393c3bf$var$getErrorLink(errorId, args);
    const errorSuffix = `
See ${errorLink}`;
    return Array.isArray(errorBody) ? errorBody.concat(errorSuffix) : [
        errorBody,
        errorSuffix
    ];
}
var $437b23f6a393c3bf$var$MISSING_MODULE_REASONS = {
    1: "Charting Aggregation",
    2: "pivotResultFields",
    3: "setTooltip"
};
// packages/ag-grid-community/src/grid.ts
var $437b23f6a393c3bf$var$_gridApiCache = /* @__PURE__ */ new WeakMap();
var $437b23f6a393c3bf$var$_gridElementCache = /* @__PURE__ */ new WeakMap();
function $437b23f6a393c3bf$export$fce123c48a7b4eae(eGridDiv, gridOptions, params) {
    if (!gridOptions) {
        $437b23f6a393c3bf$export$a20c7248650823a9(11);
        return {};
    }
    const gridParams = params;
    let destroyCallback;
    if (!gridParams?.setThemeOnGridDiv) {
        const newGridDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div"
        });
        newGridDiv.style.height = "100%";
        eGridDiv.appendChild(newGridDiv);
        eGridDiv = newGridDiv;
        destroyCallback = ()=>eGridDiv.remove();
    }
    const api = new $437b23f6a393c3bf$export$7759b93c6200a2f9().create(eGridDiv, gridOptions, (context)=>{
        const gridComp = new $437b23f6a393c3bf$var$GridComp(eGridDiv);
        context.createBean(gridComp);
    }, void 0, params, destroyCallback);
    return api;
}
var $437b23f6a393c3bf$var$nextGridId = 1;
var $437b23f6a393c3bf$export$7759b93c6200a2f9 = class {
    create(eGridDiv, providedOptions, createUi, acceptChanges, params, _destroyCallback) {
        const gridOptions = $437b23f6a393c3bf$var$GlobalGridOptions.applyGlobalGridOptions(providedOptions);
        const gridId = gridOptions.gridId ?? String($437b23f6a393c3bf$var$nextGridId++);
        const registeredModules = this.getRegisteredModules(params, gridId, gridOptions.rowModelType);
        const beanClasses = this.createBeansList(gridOptions.rowModelType, registeredModules, gridId);
        const providedBeanInstances = this.createProvidedBeans(eGridDiv, gridOptions, params);
        if (!beanClasses) return void 0;
        const destroyCallback = ()=>{
            $437b23f6a393c3bf$var$_gridElementCache.delete(api);
            $437b23f6a393c3bf$var$_gridApiCache.delete(eGridDiv);
            $437b23f6a393c3bf$var$_unRegisterGridModules(gridId);
            _destroyCallback?.();
        };
        const contextParams = {
            providedBeanInstances: providedBeanInstances,
            beanClasses: beanClasses,
            id: gridId,
            beanInitComparator: $437b23f6a393c3bf$var$gridBeanInitComparator,
            beanDestroyComparator: $437b23f6a393c3bf$var$gridBeanDestroyComparator,
            derivedBeans: [
                $437b23f6a393c3bf$var$createGridApi
            ],
            destroyCallback: destroyCallback
        };
        const context = new $437b23f6a393c3bf$export$1e4aca051de0f84c(contextParams);
        this.registerModuleFeatures(context, registeredModules);
        createUi(context);
        context.getBean("syncSvc").start();
        acceptChanges?.(context);
        const api = context.getBean("gridApi");
        $437b23f6a393c3bf$var$_gridApiCache.set(eGridDiv, api);
        $437b23f6a393c3bf$var$_gridElementCache.set(api, eGridDiv);
        return api;
    }
    getRegisteredModules(params, gridId, rowModelType) {
        $437b23f6a393c3bf$export$d0b008fbcc09e577($437b23f6a393c3bf$var$CommunityCoreModule, void 0, true);
        params?.modules?.forEach((m)=>$437b23f6a393c3bf$export$d0b008fbcc09e577(m, gridId));
        return $437b23f6a393c3bf$var$_getRegisteredModules(gridId, $437b23f6a393c3bf$var$getDefaultRowModelType(rowModelType));
    }
    registerModuleFeatures(context, registeredModules) {
        const registry = context.getBean("registry");
        const apiFunctionSvc = context.getBean("apiFunctionSvc");
        for (const module of registeredModules){
            registry.registerModule(module);
            const apiFunctions = module.apiFunctions;
            if (apiFunctions) {
                const names = Object.keys(apiFunctions);
                for (const name of names)apiFunctionSvc?.addFunction(name, apiFunctions[name]);
            }
        }
    }
    createProvidedBeans(eGridDiv, gridOptions, params) {
        let frameworkOverrides = params ? params.frameworkOverrides : null;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(frameworkOverrides)) frameworkOverrides = new $437b23f6a393c3bf$export$8174ad74937c6482();
        const seed = {
            gridOptions: gridOptions,
            eGridDiv: eGridDiv,
            eRootDiv: eGridDiv,
            globalListener: params ? params.globalListener : null,
            globalSyncListener: params ? params.globalSyncListener : null,
            frameworkOverrides: frameworkOverrides
        };
        if (params?.providedBeanInstances) Object.assign(seed, params.providedBeanInstances);
        return seed;
    }
    createBeansList(userProvidedRowModelType, registeredModules, gridId) {
        const rowModelModuleNames = {
            clientSide: "ClientSideRowModel",
            infinite: "InfiniteRowModel",
            serverSide: "ServerSideRowModel",
            viewport: "ViewportRowModel"
        };
        const rowModelType = $437b23f6a393c3bf$var$getDefaultRowModelType(userProvidedRowModelType);
        const rowModuleModelName = rowModelModuleNames[rowModelType];
        if (!rowModuleModelName) {
            $437b23f6a393c3bf$var$_logPreInitErr(201, {
                rowModelType: rowModelType
            }, `Unknown rowModelType ${rowModelType}.`);
            return;
        }
        if (!$437b23f6a393c3bf$var$_hasUserRegistered()) {
            $437b23f6a393c3bf$var$_logPreInitErr(272, void 0, $437b23f6a393c3bf$var$NoModulesRegisteredError());
            return;
        }
        if (!userProvidedRowModelType) {
            const registeredRowModelModules = Object.entries(rowModelModuleNames).filter(([rowModelType2, module])=>$437b23f6a393c3bf$var$_isModuleRegistered(module, gridId, rowModelType2));
            if (registeredRowModelModules.length == 1) {
                const [userRowModelType, moduleName] = registeredRowModelModules[0];
                if (userRowModelType !== rowModelType) {
                    const params = {
                        moduleName: moduleName,
                        rowModelType: userRowModelType
                    };
                    $437b23f6a393c3bf$var$_logPreInitErr(275, params, $437b23f6a393c3bf$var$missingRowModelTypeError(params));
                    return;
                }
            }
        }
        if (!$437b23f6a393c3bf$var$_isModuleRegistered(rowModuleModelName, gridId, rowModelType)) {
            $437b23f6a393c3bf$var$_logPreInitErr(200, {
                reasonOrId: `rowModelType = '${rowModelType}'`,
                moduleName: rowModuleModelName,
                gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
                gridId: gridId,
                rowModelType: rowModelType
            }, `Missing module ${rowModuleModelName}Module for rowModelType ${rowModelType}.`);
            return;
        }
        const beans = /* @__PURE__ */ new Set();
        for (const module of registeredModules)for (const bean of module.beans ?? [])beans.add(bean);
        return Array.from(beans);
    }
};
function $437b23f6a393c3bf$var$getDefaultRowModelType(passedRowModelType) {
    return passedRowModelType ?? "clientSide";
}
function $437b23f6a393c3bf$export$23a926ae0d6d33d3(gridElement) {
    if (typeof gridElement === "string") try {
        gridElement = document.querySelector(`[grid-id="${gridElement}"]`)?.parentElement ?? document.querySelector(gridElement)?.firstElementChild ?? document.getElementById(gridElement)?.firstElementChild;
    } catch  {
        gridElement = null;
    }
    return gridElement ? $437b23f6a393c3bf$var$_gridApiCache.get(gridElement) : void 0;
}
function $437b23f6a393c3bf$export$dbd289bae768c48d(api) {
    return $437b23f6a393c3bf$var$_gridElementCache.get(api);
}
// packages/ag-grid-community/src/api/rowModelApiUtils.ts
function $437b23f6a393c3bf$export$f5285e6f27a03f95(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "clientSide" ? rowModel : void 0;
}
function $437b23f6a393c3bf$var$_getInfiniteRowModel(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "infinite" ? rowModel : void 0;
}
function $437b23f6a393c3bf$export$aada92189a74e985(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "serverSide" ? rowModel : void 0;
}
function $437b23f6a393c3bf$export$78d50ab577b1d84b(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "viewport" ? rowModel : void 0;
}
// packages/ag-grid-community/src/misc/locale/localeService.ts
var $437b23f6a393c3bf$export$f325e19d05d9c36d = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "localeSvc";
    }
    getLocaleTextFunc() {
        const gos = this.gos;
        const getLocaleText = gos.getCallback("getLocaleText");
        if (getLocaleText) return $437b23f6a393c3bf$export$b2a251dd30f2791(getLocaleText);
        return $437b23f6a393c3bf$export$5a79576e712817ac(gos.get("localeText"));
    }
};
// packages/ag-grid-community/src/misc/state/stateUtils.ts
function $437b23f6a393c3bf$export$9453e80be74134db(columnState, enablePivotMode = false) {
    const sortColumns = [];
    const groupColIds = [];
    const aggregationColumns = [];
    const pivotColIds = [];
    const leftColIds = [];
    const rightColIds = [];
    const hiddenColIds = [];
    const columnSizes = [];
    const columns = [];
    let defaultSortIndex = 0;
    for(let i = 0; i < columnState.length; i++){
        const { colId: colId, sort: sort, sortIndex: sortIndex, rowGroup: rowGroup, rowGroupIndex: rowGroupIndex, aggFunc: aggFunc, pivot: pivot, pivotIndex: pivotIndex, pinned: pinned, hide: hide, width: width, flex: flex } = columnState[i];
        columns.push(colId);
        if (sort) sortColumns[sortIndex ?? defaultSortIndex++] = {
            colId: colId,
            sort: sort
        };
        if (rowGroup) groupColIds[rowGroupIndex ?? 0] = colId;
        if (typeof aggFunc === "string") aggregationColumns.push({
            colId: colId,
            aggFunc: aggFunc
        });
        if (pivot) pivotColIds[pivotIndex ?? 0] = colId;
        if (pinned) (pinned === "right" ? rightColIds : leftColIds).push(colId);
        if (hide) hiddenColIds.push(colId);
        if (flex != null || width) columnSizes.push({
            colId: colId,
            flex: flex ?? void 0,
            width: width
        });
    }
    return {
        sort: sortColumns.length ? {
            sortModel: $437b23f6a393c3bf$var$_removeEmptyValues(sortColumns)
        } : void 0,
        rowGroup: groupColIds.length ? {
            groupColIds: $437b23f6a393c3bf$var$_removeEmptyValues(groupColIds)
        } : void 0,
        aggregation: aggregationColumns.length ? {
            aggregationModel: aggregationColumns
        } : void 0,
        pivot: pivotColIds.length || enablePivotMode ? {
            pivotMode: enablePivotMode,
            pivotColIds: $437b23f6a393c3bf$var$_removeEmptyValues(pivotColIds)
        } : void 0,
        columnPinning: leftColIds.length || rightColIds.length ? {
            leftColIds: leftColIds,
            rightColIds: rightColIds
        } : void 0,
        columnVisibility: hiddenColIds.length ? {
            hiddenColIds: hiddenColIds
        } : void 0,
        columnSizing: columnSizes.length ? {
            columnSizingModel: columnSizes
        } : void 0,
        columnOrder: columns.length ? {
            orderedColIds: columns
        } : void 0
    };
}
function $437b23f6a393c3bf$var$_removeEmptyValues(array) {
    return array.filter((a)=>a != void 0);
}
function $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState) {
    const openColumnGroups = [];
    for (const { groupId: groupId, open: open } of columnGroupState)if (open) openColumnGroups.push(groupId);
    return openColumnGroups.length ? {
        openColumnGroupIds: openColumnGroups
    } : void 0;
}
function $437b23f6a393c3bf$export$e5b0fd7258628d55(columnGroupState) {
    return {
        columnGroup: $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState)
    };
}
// packages/ag-grid-community/src/components/framework/frameworkComponentWrapper.ts
var $437b23f6a393c3bf$export$157f014d661b6f19 = class {
    wrap(OriginalConstructor, mandatoryMethods, optionalMethods, componentType) {
        const wrapper = this.createWrapper(OriginalConstructor, componentType);
        for (const methodName of mandatoryMethods ?? [])this.createMethod(wrapper, methodName, true);
        for (const methodName of optionalMethods ?? [])this.createMethod(wrapper, methodName, false);
        return wrapper;
    }
    createMethod(wrapper, methodName, mandatory) {
        wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
    }
    createMethodProxy(wrapper, methodName, mandatory) {
        return function() {
            if (wrapper.hasMethod(methodName)) return wrapper.callMethod(methodName, arguments);
            if (mandatory) $437b23f6a393c3bf$export$545083624300f13d(49, {
                methodName: methodName
            });
            return null;
        };
    }
};
// packages/ag-grid-community/src/tooltip/tooltipFeature.ts
function $437b23f6a393c3bf$export$58660753196c7cdf(gos) {
    return gos.get("tooltipShowMode") === "whenTruncated";
}
function $437b23f6a393c3bf$export$75f51ed61a5271e6(gos, getElement2) {
    return $437b23f6a393c3bf$export$58660753196c7cdf(gos) ? $437b23f6a393c3bf$export$8980540b0a37a11d(getElement2) : void 0;
}
// packages/ag-grid-community/src/utils/number.ts
function $437b23f6a393c3bf$export$c8980add4a69422e(value, getLocaleTextFunc) {
    if (typeof value !== "number") return "";
    const localeTextFunc = getLocaleTextFunc();
    const thousandSeparator = localeTextFunc("thousandSeparator", ",");
    const decimalSeparator = localeTextFunc("decimalSeparator", ".");
    return value.toString().replace(".", decimalSeparator).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`);
}
// packages/ag-grid-community/src/export/baseCreator.ts
var $437b23f6a393c3bf$export$b335f23c5aead909 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    getFileName(fileName) {
        const extension = this.getDefaultFileExtension();
        if (!fileName?.length) fileName = this.getDefaultFileName();
        return fileName.includes(".") ? fileName : `${fileName}.${extension}`;
    }
    getData(params) {
        const serializingSession = this.createSerializingSession(params);
        return this.beans.gridSerializer.serialize(serializingSession, params);
    }
    getDefaultFileName() {
        return `export.${this.getDefaultFileExtension()}`;
    }
};
// packages/ag-grid-community/src/export/baseGridSerializingSession.ts
var $437b23f6a393c3bf$export$5018ab277b833b61 = class {
    constructor(config){
        const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, colNames: colNames, valueSvc: valueSvc, gos: gos, processCellCallback: processCellCallback, processHeaderCallback: processHeaderCallback, processGroupHeaderCallback: processGroupHeaderCallback, processRowGroupCallback: processRowGroupCallback } = config;
        this.colModel = colModel;
        this.rowGroupColsSvc = rowGroupColsSvc;
        this.colNames = colNames;
        this.valueSvc = valueSvc;
        this.gos = gos;
        this.processCellCallback = processCellCallback;
        this.processHeaderCallback = processHeaderCallback;
        this.processGroupHeaderCallback = processGroupHeaderCallback;
        this.processRowGroupCallback = processRowGroupCallback;
    }
    prepare(_columnsToExport) {}
    extractHeaderValue(column) {
        const value = this.getHeaderName(this.processHeaderCallback, column);
        return value ?? "";
    }
    extractRowCellValue(column, currentColumnIndex, accumulatedRowIndex, type, node) {
        const isFullWidthGroup = currentColumnIndex === 0 && $437b23f6a393c3bf$export$410912a9c501b8cc(this.gos, node, this.colModel.isPivotMode());
        if (this.processRowGroupCallback && (this.gos.get("treeData") || node.group) && (column.isRowGroupDisplayed(node.rowGroupColumn?.getColId() ?? "") || isFullWidthGroup)) return {
            value: this.processRowGroupCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                column: column,
                node: node
            })) ?? ""
        };
        if (this.processCellCallback) return {
            value: this.processCellCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                accumulatedRowIndex: accumulatedRowIndex,
                column: column,
                node: node,
                value: this.valueSvc.getValueForDisplay(column, node, void 0, void 0).value,
                type: type,
                parseValue: (valueToParse)=>this.valueSvc.parseValue(column, node, valueToParse, this.valueSvc.getValue(column, node, void 0)),
                formatValue: (valueToFormat)=>this.valueSvc.formatValue(column, node, valueToFormat) ?? valueToFormat
            })) ?? ""
        };
        const isTreeData = this.gos.get("treeData");
        const valueService = this.valueSvc;
        const isGrandTotalRow = node.level === -1 && node.footer;
        const isMultiAutoCol = column.colDef.showRowGroup === true && (node.group || isTreeData);
        if (!isGrandTotalRow && (isFullWidthGroup || isMultiAutoCol)) {
            let concatenatedGroupValue = "";
            let pointer = node;
            while(pointer && pointer.level !== -1){
                const { value: value2, valueFormatted: valueFormatted2 } = valueService.getValueForDisplay(isFullWidthGroup ? void 0 : column, // full width group doesn't have a column
                pointer, true, true);
                concatenatedGroupValue = ` -> ${valueFormatted2 ?? value2 ?? ""}${concatenatedGroupValue}`;
                pointer = pointer.parent;
            }
            return {
                value: concatenatedGroupValue,
                // don't return the unformatted value; as if the grid detects number it'll not use the concatenated string
                valueFormatted: concatenatedGroupValue
            };
        }
        const { value: value, valueFormatted: valueFormatted } = valueService.getValueForDisplay(column, node, true, true);
        return {
            value: value ?? "",
            valueFormatted: valueFormatted
        };
    }
    getHeaderName(callback, column) {
        if (callback) return callback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column
        }));
        return this.colNames.getDisplayNameForColumn(column, "csv", true);
    }
};
// packages/ag-grid-community/src/export/downloader.ts
function $437b23f6a393c3bf$export$97aef6bcdc3f7ef5(fileName, content) {
    const win = document.defaultView || window;
    if (!win) {
        $437b23f6a393c3bf$export$545083624300f13d(52);
        return;
    }
    const element = document.createElement("a");
    const url = win.URL.createObjectURL(content);
    element.setAttribute("href", url);
    element.setAttribute("download", fileName);
    element.style.display = "none";
    document.body.appendChild(element);
    element.dispatchEvent(new MouseEvent("click", {
        bubbles: false,
        cancelable: true,
        view: win
    }));
    element.remove();
    win.setTimeout(()=>{
        win.URL.revokeObjectURL(url);
    }, 0);
}
// packages/ag-grid-community/src/gridOptionsInitial.ts
var $437b23f6a393c3bf$var$INITIAL_GRID_OPTION_KEYS = {
    enableBrowserTooltips: true,
    tooltipTrigger: true,
    tooltipMouseTrack: true,
    tooltipShowMode: true,
    tooltipInteraction: true,
    defaultColGroupDef: true,
    suppressAutoSize: true,
    skipHeaderOnAutoSize: true,
    autoSizeStrategy: true,
    components: true,
    stopEditingWhenCellsLoseFocus: true,
    undoRedoCellEditing: true,
    undoRedoCellEditingLimit: true,
    excelStyles: true,
    cacheQuickFilter: true,
    customChartThemes: true,
    chartThemeOverrides: true,
    chartToolPanelsDef: true,
    loadingCellRendererSelector: true,
    localeText: true,
    keepDetailRows: true,
    keepDetailRowsCount: true,
    detailRowHeight: true,
    detailRowAutoHeight: true,
    tabIndex: true,
    valueCache: true,
    valueCacheNeverExpires: true,
    enableCellExpressions: true,
    suppressTouch: true,
    suppressBrowserResizeObserver: true,
    suppressPropertyNamesCheck: true,
    debug: true,
    dragAndDropImageComponent: true,
    loadingOverlayComponent: true,
    suppressLoadingOverlay: true,
    noRowsOverlayComponent: true,
    paginationPageSizeSelector: true,
    paginateChildRows: true,
    pivotPanelShow: true,
    pivotSuppressAutoColumn: true,
    suppressExpandablePivotGroups: true,
    aggFuncs: true,
    allowShowChangeAfterFilter: true,
    ensureDomOrder: true,
    enableRtl: true,
    suppressColumnVirtualisation: true,
    suppressMaxRenderedRowRestriction: true,
    suppressRowVirtualisation: true,
    rowDragText: true,
    groupLockGroupColumns: true,
    suppressGroupRowsSticky: true,
    rowModelType: true,
    cacheOverflowSize: true,
    infiniteInitialRowCount: true,
    serverSideInitialRowCount: true,
    maxBlocksInCache: true,
    maxConcurrentDatasourceRequests: true,
    blockLoadDebounceMillis: true,
    serverSideOnlyRefreshFilteredGroups: true,
    serverSidePivotResultFieldSeparator: true,
    viewportRowModelPageSize: true,
    viewportRowModelBufferSize: true,
    debounceVerticalScrollbar: true,
    suppressAnimationFrame: true,
    suppressPreventDefaultOnMouseWheel: true,
    scrollbarWidth: true,
    icons: true,
    suppressRowTransform: true,
    gridId: true,
    enableGroupEdit: true,
    initialState: true,
    processUnpinnedColumns: true,
    createChartContainer: true,
    getLocaleText: true,
    getRowId: true,
    reactiveCustomComponents: true,
    renderingMode: true,
    columnMenu: true,
    suppressSetFilterByDefault: true,
    getDataPath: true,
    enableCellSpan: true,
    enableFilterHandlers: true,
    filterHandlers: true
};
// packages/ag-grid-community/src/validation/apiFunctionValidator.ts
var $437b23f6a393c3bf$var$clientSide = "clientSide";
var $437b23f6a393c3bf$var$serverSide = "serverSide";
var $437b23f6a393c3bf$var$infinite = "infinite";
var $437b23f6a393c3bf$var$functionRowModels = {
    onGroupExpandedOrCollapsed: [
        $437b23f6a393c3bf$var$clientSide
    ],
    refreshClientSideRowModel: [
        $437b23f6a393c3bf$var$clientSide
    ],
    isRowDataEmpty: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachLeafNode: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachNodeAfterFilter: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachNodeAfterFilterAndSort: [
        $437b23f6a393c3bf$var$clientSide
    ],
    resetRowHeights: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    applyTransaction: [
        $437b23f6a393c3bf$var$clientSide
    ],
    applyTransactionAsync: [
        $437b23f6a393c3bf$var$clientSide
    ],
    flushAsyncTransactions: [
        $437b23f6a393c3bf$var$clientSide
    ],
    getBestCostNodeSelection: [
        $437b23f6a393c3bf$var$clientSide
    ],
    getServerSideSelectionState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    setServerSideSelectionState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideTransaction: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideTransactionAsync: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideRowData: [
        $437b23f6a393c3bf$var$serverSide
    ],
    retryServerSideLoads: [
        $437b23f6a393c3bf$var$serverSide
    ],
    flushServerSideAsyncTransactions: [
        $437b23f6a393c3bf$var$serverSide
    ],
    refreshServerSide: [
        $437b23f6a393c3bf$var$serverSide
    ],
    getServerSideGroupLevelState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    refreshInfiniteCache: [
        $437b23f6a393c3bf$var$infinite
    ],
    purgeInfiniteCache: [
        $437b23f6a393c3bf$var$infinite
    ],
    getInfiniteRowCount: [
        $437b23f6a393c3bf$var$infinite
    ],
    isLastRowIndexKnown: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ],
    expandAll: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    collapseAll: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    onRowHeightChanged: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    setRowCount: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ],
    getCacheBlockState: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ]
};
var $437b23f6a393c3bf$var$deprecatedFunctions = {
    showLoadingOverlay: {
        version: "v32",
        message: '`showLoadingOverlay` is deprecated. Use the grid option "loading"=true instead or setGridOption("loading", true).'
    },
    clearRangeSelection: {
        version: "v32.2",
        message: "Use `clearCellSelection` instead."
    },
    getInfiniteRowCount: {
        version: "v32.2",
        old: "getInfiniteRowCount()",
        new: "getDisplayedRowCount()"
    },
    selectAllFiltered: {
        version: "v33",
        old: "selectAllFiltered()",
        new: 'selectAll("filtered")'
    },
    deselectAllFiltered: {
        version: "v33",
        old: "deselectAllFiltered()",
        new: 'deselectAll("filtered")'
    },
    selectAllOnCurrentPage: {
        version: "v33",
        old: "selectAllOnCurrentPage()",
        new: 'selectAll("currentPage")'
    },
    deselectAllOnCurrentPage: {
        version: "v33",
        old: "deselectAllOnCurrentPage()",
        new: 'deselectAll("currentPage")'
    }
};
function $437b23f6a393c3bf$var$validateApiFunction(functionName, apiFunction, beans) {
    const deprecation = $437b23f6a393c3bf$var$deprecatedFunctions[functionName];
    if (deprecation) {
        const { version: version, new: replacement, old: old, message: message } = deprecation;
        const apiMethod = old ?? functionName;
        return (...args)=>{
            const replacementMessage = replacement ? `Please use ${replacement} instead. ` : "";
            $437b23f6a393c3bf$export$2cf41453020eef66(`Since ${version} api.${apiMethod} is deprecated. ${replacementMessage}${message ?? ""}`);
            return apiFunction.apply(apiFunction, args);
        };
    }
    const rowModels = $437b23f6a393c3bf$var$functionRowModels[functionName];
    if (rowModels) return (...args)=>{
        const rowModel = beans.rowModel.getType();
        if (!rowModels.includes(rowModel)) {
            $437b23f6a393c3bf$var$_errorOnce(`api.${functionName} can only be called when gridOptions.rowModelType is ${rowModels.join(" or ")}`);
            return void 0;
        }
        return apiFunction.apply(apiFunction, args);
    };
    return apiFunction;
}
// packages/ag-grid-community/src/validation/rules/dynamicBeanValidations.ts
var $437b23f6a393c3bf$var$DYNAMIC_BEAN_MODULES = {
    detailCellRendererCtrl: "SharedMasterDetail",
    dndSourceComp: "DragAndDrop",
    fillHandle: "CellSelection",
    groupCellRendererCtrl: "GroupCellRenderer",
    headerFilterCellCtrl: "ColumnFilter",
    headerGroupCellCtrl: "ColumnGroup",
    rangeHandle: "CellSelection",
    tooltipFeature: "Tooltip",
    highlightTooltipFeature: "Tooltip",
    tooltipStateManager: "Tooltip",
    groupStrategy: "RowGrouping",
    treeGroupStrategy: "TreeData",
    rowNumberRowResizer: "RowNumbers",
    singleCell: "EditCore",
    fullRow: "EditCore",
    agSetColumnFilterHandler: "SetFilter",
    agMultiColumnFilterHandler: "MultiFilter",
    agGroupColumnFilterHandler: "GroupFilter",
    agNumberColumnFilterHandler: "NumberFilter",
    agDateColumnFilterHandler: "DateFilter",
    agTextColumnFilterHandler: "TextFilter"
};
// packages/ag-grid-community/src/validation/rules/iconValidations.ts
var $437b23f6a393c3bf$var$ICON_VALUES = {
    expanded: 1,
    contracted: 1,
    "tree-closed": 1,
    "tree-open": 1,
    "tree-indeterminate": 1,
    pin: 1,
    "eye-slash": 1,
    arrows: 1,
    left: 1,
    right: 1,
    group: 1,
    aggregation: 1,
    pivot: 1,
    "not-allowed": 1,
    chart: 1,
    cross: 1,
    cancel: 1,
    tick: 1,
    first: 1,
    previous: 1,
    next: 1,
    last: 1,
    linked: 1,
    unlinked: 1,
    "color-picker": 1,
    loading: 1,
    menu: 1,
    "menu-alt": 1,
    filter: 1,
    "filter-add": 1,
    columns: 1,
    maximize: 1,
    minimize: 1,
    copy: 1,
    cut: 1,
    paste: 1,
    grip: 1,
    save: 1,
    csv: 1,
    excel: 1,
    "small-down": 1,
    "small-left": 1,
    "small-right": 1,
    "small-up": 1,
    asc: 1,
    desc: 1,
    none: 1,
    up: 1,
    down: 1,
    plus: 1,
    minus: 1,
    settings: 1,
    "checkbox-checked": 1,
    "checkbox-indeterminate": 1,
    "checkbox-unchecked": 1,
    "radio-button-on": 1,
    "radio-button-off": 1,
    eye: 1,
    "column-arrow": 1,
    "un-pin": 1,
    "pinned-top": 1,
    "pinned-bottom": 1,
    "chevron-up": 1,
    "chevron-down": 1,
    "chevron-left": 1,
    "chevron-right": 1,
    edit: 1
};
var $437b23f6a393c3bf$var$ICON_MODULES = {
    chart: "MenuCore",
    cancel: "EnterpriseCore",
    first: "Pagination",
    previous: "Pagination",
    next: "Pagination",
    last: "Pagination",
    linked: "IntegratedCharts",
    loadingMenuItems: "MenuCore",
    unlinked: "IntegratedCharts",
    menu: "ColumnHeaderComp",
    legacyMenu: "ColumnMenu",
    filter: "ColumnFilter",
    filterActive: "ColumnFilter",
    filterAdd: "NewFiltersToolPanel",
    filterCardCollapse: "NewFiltersToolPanel",
    filterCardExpand: "NewFiltersToolPanel",
    filterCardEditing: "NewFiltersToolPanel",
    filterTab: "ColumnMenu",
    filtersToolPanel: "FiltersToolPanel",
    columns: [
        "MenuCore"
    ],
    columnsToolPanel: [
        "ColumnsToolPanel"
    ],
    maximize: "EnterpriseCore",
    minimize: "EnterpriseCore",
    save: "MenuCore",
    columnGroupOpened: "ColumnGroupHeaderComp",
    columnGroupClosed: "ColumnGroupHeaderComp",
    accordionOpen: "EnterpriseCore",
    accordionClosed: "EnterpriseCore",
    accordionIndeterminate: "EnterpriseCore",
    columnSelectClosed: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnSelectOpen: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnSelectIndeterminate: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnMovePin: "SharedDragAndDrop",
    columnMoveHide: "SharedDragAndDrop",
    columnMoveMove: "SharedDragAndDrop",
    columnMoveLeft: "SharedDragAndDrop",
    columnMoveRight: "SharedDragAndDrop",
    columnMoveGroup: "SharedDragAndDrop",
    columnMoveValue: "SharedDragAndDrop",
    columnMovePivot: "SharedDragAndDrop",
    dropNotAllowed: "SharedDragAndDrop",
    ensureColumnVisible: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    groupContracted: "GroupCellRenderer",
    groupExpanded: "GroupCellRenderer",
    setFilterGroupClosed: "SetFilter",
    setFilterGroupOpen: "SetFilter",
    setFilterGroupIndeterminate: "SetFilter",
    setFilterLoading: "SetFilter",
    close: "EnterpriseCore",
    check: "MenuItem",
    colorPicker: "CommunityCore",
    groupLoading: "LoadingCellRenderer",
    menuAlt: "ColumnHeaderComp",
    menuPin: "MenuCore",
    menuValue: "MenuCore",
    menuAddRowGroup: [
        "MenuCore",
        "ColumnsToolPanel"
    ],
    menuRemoveRowGroup: [
        "MenuCore",
        "ColumnsToolPanel"
    ],
    clipboardCopy: "MenuCore",
    clipboardCut: "MenuCore",
    clipboardPaste: "MenuCore",
    pivotPanel: [
        "ColumnsToolPanel",
        "RowGroupingPanel"
    ],
    rowGroupPanel: [
        "ColumnsToolPanel",
        "RowGroupingPanel"
    ],
    valuePanel: "ColumnsToolPanel",
    columnDrag: "EnterpriseCore",
    rowDrag: [
        "RowDrag",
        "DragAndDrop"
    ],
    csvExport: "MenuCore",
    excelExport: "MenuCore",
    smallDown: "CommunityCore",
    selectOpen: "CommunityCore",
    richSelectOpen: "RichSelect",
    richSelectRemove: "RichSelect",
    smallLeft: "CommunityCore",
    smallRight: "CommunityCore",
    subMenuOpen: "MenuItem",
    subMenuOpenRtl: "MenuItem",
    panelDelimiter: "RowGroupingPanel",
    panelDelimiterRtl: "RowGroupingPanel",
    smallUp: "CommunityCore",
    sortAscending: [
        "MenuCore",
        "Sort"
    ],
    sortDescending: [
        "MenuCore",
        "Sort"
    ],
    sortUnSort: [
        "MenuCore",
        "Sort"
    ],
    advancedFilterBuilder: "AdvancedFilter",
    advancedFilterBuilderDrag: "AdvancedFilter",
    advancedFilterBuilderInvalid: "AdvancedFilter",
    advancedFilterBuilderMoveUp: "AdvancedFilter",
    advancedFilterBuilderMoveDown: "AdvancedFilter",
    advancedFilterBuilderAdd: "AdvancedFilter",
    advancedFilterBuilderRemove: "AdvancedFilter",
    advancedFilterBuilderSelectOpen: "AdvancedFilter",
    chartsMenu: "IntegratedCharts",
    chartsMenuEdit: "IntegratedCharts",
    chartsMenuAdvancedSettings: "IntegratedCharts",
    chartsMenuAdd: "IntegratedCharts",
    chartsColorPicker: "IntegratedCharts",
    chartsThemePrevious: "IntegratedCharts",
    chartsThemeNext: "IntegratedCharts",
    chartsDownload: "IntegratedCharts",
    checkboxChecked: "CommunityCore",
    checkboxIndeterminate: "CommunityCore",
    checkboxUnchecked: "CommunityCore",
    radioButtonOn: "CommunityCore",
    radioButtonOff: "CommunityCore",
    rowPin: "PinnedRow",
    rowUnpin: "PinnedRow",
    rowPinBottom: "PinnedRow",
    rowPinTop: "PinnedRow"
};
var $437b23f6a393c3bf$var$DEPRECATED_ICONS_V33 = /* @__PURE__ */ new Set([
    "colorPicker",
    "smallUp",
    "checkboxChecked",
    "checkboxIndeterminate",
    "checkboxUnchecked",
    "radioButtonOn",
    "radioButtonOff",
    "smallDown",
    "smallLeft",
    "smallRight"
]);
// packages/ag-grid-community/src/validation/validationService.ts
var $437b23f6a393c3bf$var$ValidationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "validation";
    }
    wireBeans(beans) {
        this.gridOptions = beans.gridOptions;
        $437b23f6a393c3bf$var$provideValidationServiceLogger($437b23f6a393c3bf$var$getError);
    }
    warnOnInitialPropertyUpdate(source, key) {
        if (source === "api" && $437b23f6a393c3bf$var$INITIAL_GRID_OPTION_KEYS[key]) $437b23f6a393c3bf$export$545083624300f13d(22, {
            key: key
        });
    }
    processGridOptions(options) {
        this.processOptions(options, $437b23f6a393c3bf$var$GRID_OPTIONS_VALIDATORS());
    }
    validateApiFunction(functionName, apiFunction) {
        return $437b23f6a393c3bf$var$validateApiFunction(functionName, apiFunction, this.beans);
    }
    missingUserComponent(propertyName, componentName, agGridDefaults, jsComps) {
        const moduleForComponent = $437b23f6a393c3bf$var$USER_COMP_MODULES[componentName];
        if (moduleForComponent) this.gos.assertModuleRegistered(moduleForComponent, `AG Grid '${propertyName}' component: ${componentName}`);
        else $437b23f6a393c3bf$export$545083624300f13d(101, {
            propertyName: propertyName,
            componentName: componentName,
            agGridDefaults: agGridDefaults,
            jsComps: jsComps
        });
    }
    missingDynamicBean(beanName) {
        const moduleName = $437b23f6a393c3bf$var$DYNAMIC_BEAN_MODULES[beanName];
        return moduleName ? $437b23f6a393c3bf$export$680bb5102fca525e(200, {
            ...this.gos.getModuleErrorParams(),
            moduleName: moduleName,
            reasonOrId: beanName
        }) : void 0;
    }
    checkRowEvents(eventType) {
        if ($437b23f6a393c3bf$var$DEPRECATED_ROW_NODE_EVENTS.has(eventType)) $437b23f6a393c3bf$export$545083624300f13d(10, {
            eventType: eventType
        });
    }
    validateIcon(iconName) {
        if ($437b23f6a393c3bf$var$DEPRECATED_ICONS_V33.has(iconName)) $437b23f6a393c3bf$export$545083624300f13d(43, {
            iconName: iconName
        });
        if ($437b23f6a393c3bf$var$ICON_VALUES[iconName]) return;
        const moduleName = $437b23f6a393c3bf$var$ICON_MODULES[iconName];
        if (moduleName) {
            $437b23f6a393c3bf$export$a20c7248650823a9(200, {
                reasonOrId: `icon '${iconName}'`,
                moduleName: moduleName,
                gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
                gridId: this.beans.context.getId(),
                rowModelType: this.gos.get("rowModelType"),
                additionalText: "Alternatively, use the CSS icon name directly."
            });
            return;
        }
        $437b23f6a393c3bf$export$545083624300f13d(134, {
            iconName: iconName
        });
    }
    isProvidedUserComp(compName) {
        return !!$437b23f6a393c3bf$var$USER_COMP_MODULES[compName];
    }
    /** Should only be called via the GridOptionsService */ validateColDef(colDef) {
        this.processOptions(colDef, $437b23f6a393c3bf$var$COL_DEF_VALIDATORS());
    }
    processOptions(options, validator) {
        const { validations: validations, deprecations: deprecations, allProperties: allProperties, propertyExceptions: propertyExceptions, objectName: objectName, docsUrl: docsUrl } = validator;
        if (allProperties && this.gridOptions.suppressPropertyNamesCheck !== true) this.checkProperties(options, [
            ...propertyExceptions ?? [],
            ...Object.keys(deprecations)
        ], allProperties, objectName, docsUrl);
        const warnings = /* @__PURE__ */ new Set();
        const optionKeys = Object.keys(options);
        optionKeys.forEach((key)=>{
            const deprecation = deprecations[key];
            if (deprecation) {
                const { message: message, version: version } = deprecation;
                warnings.add(`As of v${version}, ${String(key)} is deprecated. ${message ?? ""}`);
            }
            const value = options[key];
            if (value == null || value === false) return;
            const rules = validations[key];
            if (!rules) return;
            const { dependencies: dependencies, validate: validate, supportedRowModels: supportedRowModels, expectedType: expectedType } = rules;
            if (expectedType) {
                const actualType = typeof value;
                if (actualType !== expectedType) {
                    warnings.add(`${String(key)} should be of type '${expectedType}' but received '${actualType}' (${value}).`);
                    return;
                }
            }
            if (supportedRowModels) {
                const rowModel = this.gridOptions.rowModelType ?? "clientSide";
                if (!supportedRowModels.includes(rowModel)) {
                    warnings.add(`${String(key)} is not supported with the '${rowModel}' row model. It is only valid with: ${supportedRowModels.join(", ")}.`);
                    return;
                }
            }
            if (dependencies) {
                const warning = this.checkForRequiredDependencies(key, dependencies, options);
                if (warning) {
                    warnings.add(warning);
                    return;
                }
            }
            if (validate) {
                const warning = validate(options, this.gridOptions, this.beans);
                if (warning) {
                    warnings.add(warning);
                    return;
                }
            }
        });
        if (warnings.size > 0) for (const warning of warnings)$437b23f6a393c3bf$export$2cf41453020eef66(warning);
    }
    checkForRequiredDependencies(key, validator, options) {
        const optionEntries = Object.entries(validator);
        const failedOptions = optionEntries.filter(([key2, value])=>{
            const gridOptionValue = options[key2];
            return !value.required.includes(gridOptionValue);
        });
        if (failedOptions.length === 0) return null;
        return failedOptions.map(([failedKey, possibleOptions])=>`'${String(key)}' requires '${failedKey}' to be one of [${possibleOptions.required.map((o)=>{
                if (o === null) return "null";
                else if (o === void 0) return "undefined";
                return o;
            }).join(", ")}]. ${possibleOptions.reason ?? ""}`).join("\n           ");
    }
    checkProperties(object, exceptions, validProperties, containerName, docsUrl) {
        const VUE_FRAMEWORK_PROPS = [
            "__ob__",
            "__v_skip",
            "__metadata__"
        ];
        const invalidProperties = $437b23f6a393c3bf$var$_fuzzyCheckStrings(Object.getOwnPropertyNames(object), [
            ...VUE_FRAMEWORK_PROPS,
            ...exceptions,
            ...validProperties
        ], validProperties);
        const invalidPropertiesKeys = Object.keys(invalidProperties);
        for (const key of invalidPropertiesKeys){
            const value = invalidProperties[key];
            let message = `invalid ${containerName} property '${key}' did you mean any of these: ${value.slice(0, 8).join(", ")}.`;
            if (validProperties.includes("context")) message += `
If you are trying to annotate ${containerName} with application data, use the '${containerName}.context' property instead.`;
            $437b23f6a393c3bf$export$2cf41453020eef66(message);
        }
        if (invalidPropertiesKeys.length > 0 && docsUrl) {
            const url = this.beans.frameworkOverrides.getDocLink(docsUrl);
            $437b23f6a393c3bf$export$2cf41453020eef66(`to see all the valid ${containerName} properties please check: ${url}`);
        }
    }
};
function $437b23f6a393c3bf$var$_fuzzyCheckStrings(inputValues, validValues, allSuggestions) {
    const fuzzyMatches = {};
    const invalidInputs = inputValues.filter((inputValue)=>!validValues.some((validValue)=>validValue === inputValue));
    if (invalidInputs.length > 0) for (const invalidInput of invalidInputs)fuzzyMatches[invalidInput] = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
        inputValue: invalidInput,
        allSuggestions: allSuggestions
    }).values;
    return fuzzyMatches;
}
var $437b23f6a393c3bf$var$DEPRECATED_ROW_NODE_EVENTS = /* @__PURE__ */ new Set([
    "firstChildChanged",
    "lastChildChanged",
    "childIndexChanged"
]);
// packages/ag-grid-community/src/validation/validationModule.ts
var $437b23f6a393c3bf$export$798770a8f68ba4e7 = {
    moduleName: "Validation",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ValidationService
    ]
};
// packages/ag-grid-community/src/clientSideRowModel/filterStage.ts
function $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode) {
    const sibling = rowNode.sibling;
    if (sibling) sibling.childrenAfterFilter = rowNode.childrenAfterFilter;
}
var $437b23f6a393c3bf$var$FilterStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterStage";
        this.step = "filter";
        this.refreshProps = [
            "excludeChildrenWhenTreeDataFiltering"
        ];
    }
    wireBeans(beans) {
        this.filterManager = beans.filterManager;
    }
    execute(params) {
        const { changedPath: changedPath } = params;
        this.filter(changedPath);
    }
    filter(changedPath) {
        const filterActive = !!this.filterManager?.isChildFilterPresent();
        this.filterNodes(filterActive, changedPath);
    }
    filterNodes(filterActive, changedPath) {
        const filterCallback = (rowNode, includeChildNodes)=>{
            if (rowNode.hasChildren()) {
                if (filterActive && !includeChildNodes) rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter((childNode)=>{
                    const passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
                    const passBecauseDataPasses = childNode.data && this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    return passBecauseChildren || passBecauseDataPasses;
                });
                else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            } else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode);
        };
        if (this.doingTreeDataFiltering()) {
            const treeDataDepthFirstFilter = (rowNode, alreadyFoundInParent)=>{
                if (rowNode.childrenAfterGroup) for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
                    const childNode = rowNode.childrenAfterGroup[i];
                    const foundInParent = alreadyFoundInParent || this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    if (childNode.childrenAfterGroup) treeDataDepthFirstFilter(rowNode.childrenAfterGroup[i], foundInParent);
                    else filterCallback(childNode, foundInParent);
                }
                filterCallback(rowNode, alreadyFoundInParent);
            };
            const treeDataFilterCallback = (rowNode)=>treeDataDepthFirstFilter(rowNode, false);
            changedPath.executeFromRootNode(treeDataFilterCallback);
        } else {
            const defaultFilterCallback = (rowNode)=>filterCallback(rowNode, false);
            changedPath.forEachChangedNodeDepthFirst(defaultFilterCallback, true);
        }
    }
    doingTreeDataFiltering() {
        return this.gos.get("treeData") && !this.gos.get("excludeChildrenWhenTreeDataFiltering");
    }
};
// packages/ag-grid-community/src/headerRendering/cells/floatingFilter/headerFilterCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderFilterCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.iconCreated = false;
    }
    wireComp(comp, eGui, eButtonShowMainFilter, eFloatingFilterBody, compBeanInput) {
        this.comp = comp;
        const compBean = $437b23f6a393c3bf$var$setupCompBean(this, this.beans.context, compBeanInput);
        this.eButtonShowMainFilter = eButtonShowMainFilter;
        this.eFloatingFilterBody = eFloatingFilterBody;
        this.setGui(eGui, compBean);
        this.setupActive();
        this.refreshHeaderStyles();
        this.setupWidth(compBean);
        this.setupLeft(compBean);
        this.setupHover(compBean);
        this.setupFocus(compBean);
        this.setupAria();
        this.setupFilterButton();
        this.setupUserComp();
        this.setupSyncWithFilter(compBean);
        this.setupUi();
        compBean.addManagedElementListeners(this.eButtonShowMainFilter, {
            click: this.showParentFilter.bind(this)
        });
        this.setupFilterChangedListener(compBean);
        const colDefChanged = ()=>this.onColDefChanged(compBean);
        compBean.addManagedListeners(this.column, {
            colDefChanged: colDefChanged
        });
        compBean.addManagedEventListeners({
            filterSwitched: ({ column: column })=>{
                if (column === this.column) colDefChanged();
            }
        });
        compBean.addDestroyFunc(()=>{
            this.eButtonShowMainFilter = null;
            this.eFloatingFilterBody = null;
            this.userCompDetails = null;
            this.clearComponent();
        });
    }
    // empty abstract method
    resizeHeader() {}
    moveHeader() {}
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.colDef;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            column: column,
            floatingFilter: true
        });
    }
    setupActive() {
        const colDef = this.column.getColDef();
        const filterExists = !!colDef.filter;
        const floatingFilterExists = !!colDef.floatingFilter;
        this.active = filterExists && floatingFilterExists;
    }
    setupUi() {
        this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton);
        if (!this.active || this.iconCreated) return;
        const eMenuIcon = $437b23f6a393c3bf$export$d8feba07bf373edb("filter", this.beans, this.column);
        if (eMenuIcon) {
            this.iconCreated = true;
            this.eButtonShowMainFilter.appendChild(eMenuIcon);
        }
    }
    setupFocus(compBean) {
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
    }
    setupAria() {
        const localeTextFunc = this.getLocaleTextFunc();
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.eButtonShowMainFilter, localeTextFunc("ariaFilterMenuOpen", "Open Filter Menu"));
    }
    onTabKeyDown(e) {
        const { beans: beans } = this;
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
        const wrapperHasFocus = activeEl === this.eGui;
        if (wrapperHasFocus) return;
        const nextFocusableEl = $437b23f6a393c3bf$export$83fc12531358bd28(beans, this.eGui, null, e.shiftKey);
        if (nextFocusableEl) {
            beans.headerNavigation?.scrollToColumn(this.column);
            e.preventDefault();
            nextFocusableEl.focus();
            return;
        }
        const nextFocusableColumn = this.findNextColumnWithFloatingFilter(e.shiftKey);
        if (!nextFocusableColumn) return;
        if (beans.focusSvc.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: this.rowCtrl.rowIndex,
                column: nextFocusableColumn
            },
            event: e
        })) e.preventDefault();
    }
    findNextColumnWithFloatingFilter(backwards) {
        const presentedColsService = this.beans.visibleCols;
        let nextCol = this.column;
        do {
            nextCol = backwards ? presentedColsService.getColBefore(nextCol) : presentedColsService.getColAfter(nextCol);
            if (!nextCol) break;
        }while (!nextCol.getColDef().filter || !nextCol.getColDef().floatingFilter);
        return nextCol;
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (wrapperHasFocus) return;
                $437b23f6a393c3bf$export$456c40e80134d72a(e);
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                if (wrapperHasFocus) {
                    if ($437b23f6a393c3bf$export$8598088d375f416f(this.eGui)) e.preventDefault();
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (!wrapperHasFocus) this.eGui.focus();
        }
    }
    onFocusIn(e) {
        const isRelatedWithin = this.eGui.contains(e.relatedTarget);
        if (isRelatedWithin) return;
        const notFromHeaderWrapper = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter");
        const fromWithinHeader = !!e.relatedTarget && $437b23f6a393c3bf$var$_isElementChildOfClass(e.relatedTarget, "ag-floating-filter");
        if (notFromHeaderWrapper && fromWithinHeader && e.target === this.eGui) {
            const lastFocusEvent = this.lastFocusEvent;
            const fromTab = !!(lastFocusEvent && lastFocusEvent.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB);
            if (lastFocusEvent && fromTab) {
                const shouldFocusLast = lastFocusEvent.shiftKey;
                $437b23f6a393c3bf$export$8598088d375f416f(this.eGui, shouldFocusLast);
            }
        }
        this.focusThis();
    }
    setupHover(compBean) {
        this.beans.colHover?.addHeaderFilterColumnHoverListener(compBean, this.comp, this.column, this.eGui);
    }
    setupLeft(compBean) {
        const setLeftFeature = new $437b23f6a393c3bf$var$SetLeftFeature(this.column, this.eGui, this.beans);
        compBean.createManagedBean(setLeftFeature);
    }
    setupFilterButton() {
        this.suppressFilterButton = !this.beans.menuSvc?.isFloatingFilterButtonEnabled(this.column);
        this.highlightFilterButtonWhenActive = !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos);
    }
    setupUserComp() {
        if (!this.active) return;
        const compDetails = this.beans.colFilter?.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter());
        if (compDetails) this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setCompDetails(compDetails);
    }
    showParentFilter() {
        const eventSource = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
        this.beans.menuSvc?.showFilterMenu({
            column: this.column,
            buttonElement: eventSource,
            containerType: "floatingFilter",
            positionBy: "button"
        });
    }
    setupSyncWithFilter(compBean) {
        if (!this.active) return;
        const { beans: { colFilter: colFilter }, column: column, gos: gos } = this;
        const syncWithFilter = (event)=>{
            if (event?.source === "filterDestroyed" && (!this.isAlive() || !colFilter?.isAlive())) return;
            const compPromise = this.comp.getFloatingFilterComp();
            if (!compPromise) return;
            compPromise.then((comp)=>{
                if (comp) {
                    if (gos.get("enableFilterHandlers")) {
                        const eventWithParams = event;
                        let source = "filter";
                        if (eventWithParams?.afterFloatingFilter) source = "ui";
                        else if (eventWithParams?.afterDataChange) source = "dataChanged";
                        else if (event?.source === "api") source = "api";
                        this.updateFloatingFilterParams(this.userCompDetails, source);
                        return;
                    }
                    const parentModel = colFilter?.getCurrentFloatingFilterParentModel(column);
                    const filterChangedEvent = event ? {
                        // event can have additional params like `afterDataChange` which need to be passed through
                        ...event,
                        columns: event.columns ?? [],
                        source: event.source === "api" ? "api" : "columnFilter"
                    } : null;
                    comp.onParentModelChanged(parentModel, filterChangedEvent);
                }
            });
        };
        [this.destroySyncListener] = compBean.addManagedListeners(column, {
            filterChanged: syncWithFilter
        });
        if (colFilter?.isFilterActive(column)) syncWithFilter(null);
    }
    setupWidth(compBean) {
        const listener = ()=>{
            const width = `${this.column.getActualWidth()}px`;
            this.comp.setWidth(width);
        };
        compBean.addManagedListeners(this.column, {
            widthChanged: listener
        });
        listener();
    }
    setupFilterChangedListener(compBean) {
        if (this.active) {
            [this.destroyFilterChangedListener] = compBean.addManagedListeners(this.column, {
                filterChanged: this.updateFilterButton.bind(this)
            });
            this.updateFilterButton();
        }
    }
    updateFilterButton() {
        if (!this.suppressFilterButton && this.comp) {
            const isFilterAllowed = !!this.beans.filterManager?.isFilterAllowed(this.column);
            this.comp.setButtonWrapperDisplayed(isFilterAllowed);
            if (this.highlightFilterButtonWhenActive && isFilterAllowed) this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
        }
    }
    onColDefChanged(compBean) {
        const wasActive = this.active;
        this.setupActive();
        const becomeActive = !wasActive && this.active;
        if (wasActive && !this.active) {
            this.destroySyncListener();
            this.destroyFilterChangedListener();
        }
        const colFilter = this.beans.colFilter;
        const newCompDetails = this.active ? colFilter?.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter()) : null;
        const compPromise = this.comp.getFloatingFilterComp();
        if (!compPromise || !newCompDetails) this.updateCompDetails(compBean, newCompDetails, becomeActive);
        else compPromise.then((compInstance)=>{
            if (!compInstance || colFilter?.areFilterCompsDifferent(this.userCompDetails ?? null, newCompDetails)) this.updateCompDetails(compBean, newCompDetails, becomeActive);
            else this.updateFloatingFilterParams(newCompDetails, "colDef");
        });
    }
    updateCompDetails(compBean, compDetails, becomeActive) {
        if (!this.isAlive()) return;
        this.setCompDetails(compDetails);
        this.setupFilterButton();
        this.setupUi();
        if (becomeActive) {
            this.setupSyncWithFilter(compBean);
            this.setupFilterChangedListener(compBean);
        }
    }
    updateFloatingFilterParams(userCompDetails, source) {
        if (!userCompDetails) return;
        let params = userCompDetails.params;
        this.comp.getFloatingFilterComp()?.then((floatingFilter)=>{
            if (typeof floatingFilter?.refresh === "function") {
                if (this.gos.get("enableFilterHandlers")) params = {
                    ...params,
                    model: $437b23f6a393c3bf$export$8981db65da4532f2(this.beans.colFilter?.model ?? {}, this.column.getColId()),
                    source: source
                };
                floatingFilter.refresh(params);
            }
        });
    }
    addResizeAndMoveKeyboardListeners() {}
    destroy() {
        super.destroy();
        this.destroySyncListener = null;
        this.destroyFilterChangedListener = null;
    }
};
// packages/ag-grid-community/src/misc/menu/menuApi.ts
function $437b23f6a393c3bf$var$showColumnMenu(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return;
    }
    beans.menuSvc?.showColumnMenu({
        column: column,
        positionBy: "auto"
    });
}
function $437b23f6a393c3bf$var$hidePopupMenu(beans) {
    beans.menuSvc?.hidePopupMenu();
}
// packages/ag-grid-community/src/misc/menu/sharedMenuModule.ts
var $437b23f6a393c3bf$export$b0ea578339daf1f7 = {
    moduleName: "SharedMenu",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$MenuService
    ],
    apiFunctions: {
        showColumnMenu: $437b23f6a393c3bf$var$showColumnMenu,
        hidePopupMenu: $437b23f6a393c3bf$var$hidePopupMenu
    }
};
// packages/ag-grid-community/src/widgets/popupService.ts
var $437b23f6a393c3bf$var$PopupService = class extends $437b23f6a393c3bf$export$a5869429525f9944 {
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridCtrl = p.gridCtrl;
        });
        this.addManagedEventListeners({
            gridStylesChanged: this.handleThemeChange.bind(this)
        });
    }
    getDefaultPopupParent() {
        return this.gridCtrl.getGui();
    }
    positionPopupForMenu(params) {
        const { eventSource: eventSource, ePopup: ePopup, event: event } = params;
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        this.setAlignedTo(eventSource, ePopup);
        let minWidthSet = false;
        const updatePosition = ()=>{
            const y = this.keepXYWithinBounds(ePopup, sourceRect.top - parentRect.top, 0 /* Vertical */ );
            const minWidth = ePopup.clientWidth > 0 ? ePopup.clientWidth : 200;
            if (!minWidthSet) {
                ePopup.style.minWidth = `${minWidth}px`;
                minWidthSet = true;
            }
            const widthOfParent = parentRect.right - parentRect.left;
            const maxX = widthOfParent - minWidth;
            let x;
            if (this.gos.get("enableRtl")) {
                x = xLeftPosition();
                if (x < 0) {
                    x = xRightPosition();
                    this.setAlignedStyles(ePopup, "left");
                }
                if (x > maxX) {
                    x = 0;
                    this.setAlignedStyles(ePopup, "right");
                }
            } else {
                x = xRightPosition();
                if (x > maxX) {
                    x = xLeftPosition();
                    this.setAlignedStyles(ePopup, "right");
                }
                if (x < 0) {
                    x = 0;
                    this.setAlignedStyles(ePopup, "left");
                }
            }
            return {
                x: x,
                y: y
            };
            function xRightPosition() {
                return sourceRect.right - parentRect.left - 2;
            }
            function xLeftPosition() {
                return sourceRect.left - parentRect.left - minWidth;
            }
        };
        this.positionPopup({
            ePopup: ePopup,
            keepWithinBounds: true,
            updatePosition: updatePosition,
            postProcessCallback: ()=>this.callPostProcessPopup(params, "subMenu", ePopup, eventSource, event instanceof MouseEvent ? event : void 0)
        });
    }
    callPostProcessPopup(params, type, ePopup, eventSource, mouseEvent) {
        const callback = this.gos.getCallback("postProcessPopup");
        if (callback) {
            const { column: column, rowNode: rowNode } = params;
            const postProcessParams = {
                column: column,
                rowNode: rowNode,
                ePopup: ePopup,
                type: type,
                eventSource: eventSource,
                mouseEvent: mouseEvent
            };
            callback(postProcessParams);
        }
    }
    getActivePopups() {
        return this.popupList.map((popup)=>popup.element);
    }
    handleThemeChange(e) {
        if (e.themeChanged) {
            const environment = this.beans.environment;
            for (const popup of this.popupList)environment.applyThemeClasses(popup.wrapper);
        }
    }
    hasAnchoredPopup() {
        return this.popupList.some((popup)=>popup.isAnchored);
    }
    isStopPropagation(event) {
        return $437b23f6a393c3bf$export$9a48e23524c6d58(event);
    }
};
// packages/ag-grid-community/src/widgets/popupModule.ts
var $437b23f6a393c3bf$export$da5c9bb998e6c24d = {
    moduleName: "Popup",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PopupService
    ]
};
// packages/ag-grid-community/src/filter/column-filters.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnFiltersCSS = /*css*/ `.ag-set-filter{--ag-indentation-level:0}.ag-set-filter-item{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-set-filter-item{padding-left:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}:where(.ag-rtl) .ag-set-filter-item{padding-right:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}.ag-set-filter-item-checkbox{display:flex;height:100%;width:100%}.ag-set-filter-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr) .ag-set-filter-group-icons{margin-right:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-set-filter-group-icons{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-filter-body-wrapper{display:flex;flex-direction:column}:where(.ag-menu:not(.ag-tabs) .ag-filter) .ag-filter-body-wrapper,:where(.ag-menu:not(.ag-tabs) .ag-filter)>:not(.ag-filter-wrapper){min-width:180px}.ag-filter-filter{flex:1 1 0px}.ag-filter-condition{display:flex;justify-content:center}.ag-floating-filter-body{display:flex;flex:1 1 auto;height:100%;position:relative}.ag-floating-filter-full-body{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;width:100%}:where(.ag-floating-filter-full-body)>div{flex:1 1 auto}.ag-floating-filter-input{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}:where(.ag-input-field-input[type=date]),:where(.ag-input-field-input[type=datetime-local]){width:1px}}.ag-floating-filter-button{display:flex;flex:none}.ag-date-floating-filter-wrapper{display:flex}.ag-set-floating-filter-input :where(input)[disabled]{pointer-events:none}.ag-floating-filter-button-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;height:var(--ag-icon-size);width:var(--ag-icon-size)}.ag-filter-loading{align-items:unset;background-color:var(--ag-chrome-background-color);height:100%;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;width:100%;z-index:1;:where(.ag-menu) &{background-color:var(--ag-menu-background-color)}}.ag-filter-separator{border-top:solid var(--ag-border-width) var(--menu-separator-color)}:where(.ag-filter-select) .ag-picker-field-wrapper{width:0}.ag-filter-condition-operator{height:17px}:where(.ag-ltr) .ag-filter-condition-operator-or{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-condition-operator-or{margin-right:calc(var(--ag-spacing)*2)}.ag-set-filter-select-all{padding-top:var(--ag-widget-container-vertical-padding)}.ag-filter-no-matches,.ag-set-filter-list{height:calc(var(--ag-list-item-height)*6)}.ag-filter-no-matches{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-set-filter-tree-list{height:calc(var(--ag-list-item-height)*10)}.ag-set-filter-filter{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding);margin-top:var(--ag-widget-container-vertical-padding)}.ag-filter-to{margin-top:var(--ag-widget-vertical-spacing)}.ag-mini-filter{margin:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-set-filter-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-rtl) .ag-set-filter-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-filter-menu) .ag-set-filter-list{min-width:200px}.ag-filter-virtual-list-item:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-filter-apply-panel{display:flex;justify-content:flex-end;overflow:hidden;padding:var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) var(--ag-widget-container-vertical-padding)}.ag-filter-apply-panel-button{line-height:1.5}:where(.ag-ltr) .ag-filter-apply-panel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-apply-panel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-simple-filter-body-wrapper{display:flex;flex-direction:column;min-height:calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing));overflow-y:auto;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));&>*{margin-bottom:var(--ag-widget-vertical-spacing)}:where(.ag-resizer-wrapper){margin:0}}.ag-multi-filter-menu-item{margin:var(--ag-spacing) 0}.ag-multi-filter-group-title-bar{background-color:transparent;color:var(--ag-header-text-color);font-weight:500;padding:calc(var(--ag-spacing)*1.5) var(--ag-spacing)}.ag-group-filter-field-select-wrapper{display:flex;flex-direction:column;gap:var(--ag-widget-vertical-spacing);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}`;
// packages/ag-grid-community/src/filter/columnFilterApi.ts
function $437b23f6a393c3bf$var$isColumnFilterPresent(beans) {
    const filterManager = beans.filterManager;
    return !!filterManager?.isColumnFilterPresent() || !!filterManager?.isAggregateFilterPresent();
}
function $437b23f6a393c3bf$var$getColumnFilterInstance(beans, key) {
    return beans.filterManager?.getColumnFilterInstance(key) ?? Promise.resolve(void 0);
}
function $437b23f6a393c3bf$var$destroyFilter(beans, key) {
    const column = beans.colModel.getColDefCol(key);
    if (column) return beans.colFilter?.destroyFilter(column, "api");
}
function $437b23f6a393c3bf$var$setFilterModel(beans, model) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.filterManager?.setFilterModel(model));
}
function $437b23f6a393c3bf$var$getFilterModel(beans) {
    return beans.filterManager?.getFilterModel() ?? {};
}
function $437b23f6a393c3bf$var$getColumnFilterModel(beans, key, useUnapplied) {
    const { gos: gos, colModel: colModel, colFilter: colFilter } = beans;
    if (useUnapplied && !gos.get("enableFilterHandlers")) {
        $437b23f6a393c3bf$export$545083624300f13d(288);
        useUnapplied = false;
    }
    const column = colModel.getColDefCol(key);
    return column ? colFilter?.getModelForColumn(column, useUnapplied) ?? null : null;
}
function $437b23f6a393c3bf$var$setColumnFilterModel(beans, column, model) {
    return beans.filterManager?.setColumnFilterModel(column, model) ?? Promise.resolve();
}
function $437b23f6a393c3bf$var$showColumnFilter(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return;
    }
    beans.menuSvc?.showFilterMenu({
        column: column,
        containerType: "columnFilter",
        positionBy: "auto"
    });
}
function $437b23f6a393c3bf$var$hideColumnFilter(beans) {
    beans.menuSvc?.hideFilterMenu();
}
function $437b23f6a393c3bf$var$getColumnFilterHandler(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return void 0;
    }
    return beans.colFilter?.getHandler(column, true);
}
function $437b23f6a393c3bf$var$doFilterAction(beans, params) {
    const { colModel: colModel, colFilter: colFilter, gos: gos } = beans;
    if (!gos.get("enableFilterHandlers")) {
        $437b23f6a393c3bf$export$545083624300f13d(287);
        return;
    }
    const { colId: colId, action: action } = params;
    if (colId) {
        const column = colModel.getColById(colId);
        if (column) colFilter?.updateModel(column, action);
    } else colFilter?.updateAllModels(action);
}
// packages/ag-grid-community/src/filter/columnFilterService.ts
var $437b23f6a393c3bf$var$DUMMY_HANDLER = {
    filterHandler: ()=>({
            doesFilterPass: ()=>true
        })
};
var $437b23f6a393c3bf$var$ColumnFilterService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colFilter";
        this.allColumnFilters = /* @__PURE__ */ new Map();
        this.allColumnListeners = /* @__PURE__ */ new Map();
        this.activeAggregateFilters = [];
        this.activeColumnFilters = [];
        // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
        // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
        // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
        // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
        // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.
        this.processingFilterChange = false;
        // when we're waiting for cell data types to be inferred, we need to defer filter model updates
        this.modelUpdates = [];
        this.columnModelUpdates = [];
        /** This contains the UI state for handler columns */ this.state = /* @__PURE__ */ new Map();
        this.handlerMap = {
            ...$437b23f6a393c3bf$var$FILTER_HANDLER_MAP
        };
        this.isGlobalButtons = false;
        this.activeFilterComps = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        this.addManagedEventListeners({
            gridColumnsChanged: this.onColumnsChanged.bind(this),
            dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
        });
        const gos = this.gos;
        const initialFilterModel = {
            ...gos.get("initialState")?.filter?.filterModel ?? {}
        };
        this.initialModel = initialFilterModel;
        this.model = {
            ...initialFilterModel
        };
        if (!gos.get("enableFilterHandlers")) delete this.handlerMap["agMultiColumnFilter"];
    }
    refreshModel() {
        this.onNewRowsLoaded("rowDataUpdated");
    }
    setModel(model, source = "api", forceUpdateActive) {
        const { colModel: colModel, dataTypeSvc: dataTypeSvc, filterManager: filterManager } = this.beans;
        if (dataTypeSvc?.isPendingInference) {
            this.modelUpdates.push({
                model: model,
                source: source
            });
            return;
        }
        const allPromises = [];
        const previousModel = this.getModel(true);
        if (model) {
            const modelKeys = new Set(Object.keys(model));
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const newModel = model[colId];
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper, newModel));
                modelKeys.delete(colId);
            });
            modelKeys.forEach((colId)=>{
                const column = colModel.getColDefCol(colId) || colModel.getCol(colId);
                if (!column) {
                    $437b23f6a393c3bf$export$545083624300f13d(62, {
                        colId: colId
                    });
                    return;
                }
                if (!column.isFilterAllowed()) {
                    $437b23f6a393c3bf$export$545083624300f13d(63, {
                        colId: colId
                    });
                    return;
                }
                const filterWrapper = this.getOrCreateFilterWrapper(column, true);
                if (!filterWrapper) {
                    $437b23f6a393c3bf$export$545083624300f13d(64, {
                        colId: colId
                    });
                    return;
                }
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper, model[colId], true));
            });
        } else {
            this.model = {};
            this.allColumnFilters.forEach((filterWrapper)=>{
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper, null));
            });
        }
        $437b23f6a393c3bf$export$30ec7836a4847721.all(allPromises).then(()=>{
            const currentModel = this.getModel(true);
            const columns = [];
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const before = previousModel ? previousModel[colId] : null;
                const after = currentModel ? currentModel[colId] : null;
                if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(before, after)) columns.push(filterWrapper.column);
            });
            if (columns.length > 0) filterManager?.onFilterChanged({
                columns: columns,
                source: source
            });
            else if (forceUpdateActive) this.updateActive("filterChanged");
        });
    }
    getModel(excludeInitialState) {
        const result = {};
        const { allColumnFilters: allColumnFilters, initialModel: initialModel, beans: { colModel: colModel } } = this;
        allColumnFilters.forEach((filterWrapper, key)=>{
            const model = this.getModelFromFilterWrapper(filterWrapper);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model)) result[key] = model;
        });
        if (!excludeInitialState) for (const colId of Object.keys(initialModel)){
            const model = initialModel[colId];
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model) && !allColumnFilters.has(colId) && colModel.getCol(colId)?.isFilterAllowed()) result[colId] = model;
        }
        return result;
    }
    setState(model, state, source = "api") {
        this.state.clear();
        if (state) for (const colId of Object.keys(state)){
            const newState = state[colId];
            this.state.set(colId, {
                model: $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId),
                state: newState
            });
        }
        this.setModel(model, source, true);
    }
    getState() {
        const state = this.state;
        if (!state.size) return void 0;
        const newState = {};
        let hasNewState = false;
        state.forEach((colState, colId)=>{
            const actualState = colState.state;
            if (actualState != null) {
                hasNewState = true;
                newState[colId] = actualState;
            }
        });
        return hasNewState ? newState : void 0;
    }
    getModelFromFilterWrapper(filterWrapper) {
        const column = filterWrapper.column;
        const colId = column.getColId();
        if (filterWrapper.isHandler) return $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
        const filter = filterWrapper.filter;
        if (filter) {
            if (typeof filter.getModel !== "function") {
                $437b23f6a393c3bf$export$545083624300f13d(66);
                return null;
            }
            return filter.getModel();
        }
        return $437b23f6a393c3bf$export$8981db65da4532f2(this.initialModel, colId);
    }
    isFilterPresent() {
        return this.activeColumnFilters.length > 0;
    }
    isAggFilterPresent() {
        return !!this.activeAggregateFilters.length;
    }
    disableFilters() {
        this.initialModel = {};
        const { allColumnFilters: allColumnFilters } = this;
        if (allColumnFilters.size) {
            allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "advancedFilterEnabled"));
            return true;
        }
        return false;
    }
    updateActiveFilters() {
        const isFilterActive = (filter)=>{
            if (!filter) return false;
            if (!filter.isFilterActive) {
                $437b23f6a393c3bf$export$545083624300f13d(67);
                return false;
            }
            return filter.isFilterActive();
        };
        const { colModel: colModel, gos: gos } = this.beans;
        const groupFilterEnabled = !!$437b23f6a393c3bf$export$3708afee0330994(gos);
        const isAggFilter = (column)=>{
            const isSecondary = !column.isPrimary();
            if (isSecondary) return true;
            const isShowingPrimaryColumns = !colModel.isPivotActive();
            const isValueActive = column.isValueActive();
            if (!isValueActive || !isShowingPrimaryColumns) return false;
            if (colModel.isPivotMode()) return true;
            return groupFilterEnabled;
        };
        const activeAggregateFilters = [];
        const activeColumnFilters = [];
        const addFilter = (column, filterActive, doesFilterPassWrapper)=>{
            if (filterActive) {
                if (isAggFilter(column)) activeAggregateFilters.push(doesFilterPassWrapper);
                else activeColumnFilters.push(doesFilterPassWrapper);
            }
        };
        const promises = [];
        this.allColumnFilters.forEach((filterWrapper)=>{
            const column = filterWrapper.column;
            const colId = column.getColId();
            if (filterWrapper.isHandler) promises.push($437b23f6a393c3bf$export$30ec7836a4847721.resolve().then(()=>{
                addFilter(column, this.isHandlerActive(column), {
                    colId: colId,
                    isHandler: true,
                    handler: filterWrapper.handler,
                    handlerParams: filterWrapper.handlerParams
                });
            }));
            else {
                const promise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
                if (promise) promises.push(promise.then((filter)=>{
                    addFilter(column, isFilterActive(filter), {
                        colId: colId,
                        isHandler: false,
                        comp: filter
                    });
                }));
            }
        });
        return $437b23f6a393c3bf$export$30ec7836a4847721.all(promises).then(()=>{
            this.activeAggregateFilters = activeAggregateFilters;
            this.activeColumnFilters = activeColumnFilters;
        });
    }
    updateFilterFlagInColumns(source, additionalEventAttributes) {
        const promises = [];
        this.allColumnFilters.forEach((filterWrapper)=>{
            const column = filterWrapper.column;
            if (filterWrapper.isHandler) promises.push($437b23f6a393c3bf$export$30ec7836a4847721.resolve().then(()=>{
                this.setColFilterActive(column, this.isHandlerActive(column), source, additionalEventAttributes);
            }));
            else {
                const promise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
                if (promise) promises.push(promise.then((filter)=>{
                    this.setColFilterActive(column, filter.isFilterActive(), source, additionalEventAttributes);
                }));
            }
        });
        this.beans.groupFilter?.updateFilterFlags(source, additionalEventAttributes);
        return $437b23f6a393c3bf$export$30ec7836a4847721.all(promises);
    }
    doFiltersPass(node, colIdToSkip, targetAggregates) {
        const { data: data, aggData: aggData } = node;
        const targetedFilters = targetAggregates ? this.activeAggregateFilters : this.activeColumnFilters;
        const targetedData = targetAggregates ? aggData : data;
        const model = this.model;
        for(let i = 0; i < targetedFilters.length; i++){
            const filter = targetedFilters[i];
            const { colId: colId, isHandler: isHandler } = filter;
            if (colId === colIdToSkip) continue;
            if (isHandler) {
                const { handler: handler, handlerParams: handlerParams } = filter;
                if (!handler.doesFilterPass({
                    node: node,
                    data: targetedData,
                    model: $437b23f6a393c3bf$export$8981db65da4532f2(model, colId),
                    handlerParams: handlerParams
                })) return false;
            } else {
                const comp = filter.comp;
                if (typeof comp.doesFilterPass !== "function") {
                    $437b23f6a393c3bf$export$a20c7248650823a9(91);
                    continue;
                }
                if (!comp.doesFilterPass({
                    node: node,
                    data: targetedData
                })) return false;
            }
        }
        return true;
    }
    getHandlerParams(column) {
        const wrapper = this.allColumnFilters.get(column.getColId());
        return wrapper?.isHandler ? wrapper.handlerParams : void 0;
    }
    // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
    // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
    // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
    // which results in React State getting applied in the main application, triggering a useEffect() to
    // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
    // getting it's useEffect() triggered in this way.
    callOnFilterChangedOutsideRenderCycle(params) {
        const { rowRenderer: rowRenderer, filterManager: filterManager } = this.beans;
        const action = ()=>{
            if (this.isAlive()) filterManager?.onFilterChanged(params);
        };
        if (rowRenderer.isRefreshInProgress()) setTimeout(action, 0);
        else action();
    }
    updateBeforeFilterChanged(params = {}) {
        const { column: column, additionalEventAttributes: additionalEventAttributes } = params;
        const colId = column?.getColId();
        return this.updateActiveFilters().then(()=>this.updateFilterFlagInColumns("filterChanged", additionalEventAttributes).then(()=>{
                this.allColumnFilters.forEach((filterWrapper)=>{
                    const { column: filterColumn, isHandler: isHandler } = filterWrapper;
                    if (colId === filterColumn.getColId()) return;
                    if (isHandler) filterWrapper.handler.onAnyFilterChanged?.();
                    $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, isHandler)?.then((filter)=>{
                        if (typeof filter?.onAnyFilterChanged === "function") filter.onAnyFilterChanged();
                    });
                });
                this.processingFilterChange = true;
            }));
    }
    updateAfterFilterChanged() {
        this.processingFilterChange = false;
    }
    isSuppressFlashingCellsBecauseFiltering() {
        const allowShowChangeAfterFilter = this.gos.get("allowShowChangeAfterFilter") ?? false;
        return !allowShowChangeAfterFilter && this.processingFilterChange;
    }
    onNewRowsLoaded(source) {
        const promises = [];
        this.allColumnFilters.forEach((filterWrapper)=>{
            const isHandler = filterWrapper.isHandler;
            if (isHandler) filterWrapper.handler.onNewRowsLoaded?.();
            const promise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, isHandler);
            if (promise) promises.push(promise.then((filter)=>{
                filter.onNewRowsLoaded?.();
            }));
        });
        $437b23f6a393c3bf$export$30ec7836a4847721.all(promises).then(()=>this.updateActive(source, {
                afterDataChange: true
            }));
    }
    updateActive(source, additionalEventAttributes) {
        this.updateFilterFlagInColumns(source, additionalEventAttributes).then(()=>this.updateActiveFilters());
    }
    createGetValue(filterColumn, filterValueGetterOverride) {
        const { filterValueSvc: filterValueSvc, colModel: colModel } = this.beans;
        return (rowNode, column)=>{
            const columnToUse = column ? colModel.getCol(column) : filterColumn;
            return columnToUse ? filterValueSvc.getValue(columnToUse, rowNode, filterValueGetterOverride) : void 0;
        };
    }
    isFilterActive(column) {
        const filterWrapper = this.cachedFilter(column);
        if (filterWrapper?.isHandler) return this.isHandlerActive(column);
        const filter = filterWrapper?.filter;
        if (filter) return filter.isFilterActive();
        return $437b23f6a393c3bf$export$8981db65da4532f2(this.initialModel, column.getColId()) != null;
    }
    isHandlerActive(column) {
        const active = $437b23f6a393c3bf$export$25d27f17d3af40f7($437b23f6a393c3bf$export$8981db65da4532f2(this.model, column.getColId()));
        if (active) return active;
        const groupFilter = this.beans.groupFilter;
        return groupFilter?.isGroupFilter(column) ? groupFilter.isFilterActive(column) : false;
    }
    getOrCreateFilterUi(column) {
        const filterWrapper = this.getOrCreateFilterWrapper(column, true);
        return filterWrapper ? $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper) : null;
    }
    getFilterUiForDisplay(column) {
        const filterWrapper = this.getOrCreateFilterWrapper(column, true);
        if (!filterWrapper) return null;
        const compPromise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
        if (!compPromise) return null;
        return compPromise.then((comp)=>({
                comp: comp,
                params: filterWrapper.filterUi.filterParams,
                isHandler: filterWrapper.isHandler
            }));
    }
    getHandler(column, createIfMissing) {
        const filterWrapper = this.getOrCreateFilterWrapper(column, createIfMissing);
        return filterWrapper?.isHandler ? filterWrapper.handler : void 0;
    }
    getOrCreateFilterWrapper(column, createIfMissing) {
        if (!column.isFilterAllowed()) return void 0;
        let filterWrapper = this.cachedFilter(column);
        if (!filterWrapper && createIfMissing) {
            filterWrapper = this.createFilterWrapper(column);
            this.setColumnFilterWrapper(column, filterWrapper);
        }
        return filterWrapper;
    }
    cachedFilter(column) {
        return this.allColumnFilters.get(column.getColId());
    }
    getDefaultFilter(column, isFloating = false) {
        return this.getDefaultFilterFromDataType(()=>this.beans.dataTypeSvc?.getBaseDataType(column), isFloating);
    }
    getDefaultFilterFromDataType(getCellDataType, isFloating = false) {
        if ($437b23f6a393c3bf$export$b68e6345dc6b83fa(this.gos)) return isFloating ? "agSetColumnFloatingFilter" : "agSetColumnFilter";
        return $437b23f6a393c3bf$export$4a4e3cf6acc7e93(getCellDataType(), isFloating);
    }
    getDefaultFloatingFilter(column) {
        return this.getDefaultFilter(column, true);
    }
    createFilterComp(column, filterDef, defaultFilter, getFilterParams, isHandler, source) {
        const createFilterCompDetails = ()=>{
            const params = this.createFilterCompParams(column, isHandler, source);
            const updatedParams = getFilterParams(params, isHandler);
            return $437b23f6a393c3bf$export$e6db9a2d59456da0(this.beans.userCompFactory, filterDef, updatedParams, defaultFilter);
        };
        const compDetails = createFilterCompDetails();
        if (!compDetails) return null;
        const createFilterUi = (update)=>{
            return (update ? createFilterCompDetails() : compDetails).newAgStackInstance();
        };
        return {
            compDetails: compDetails,
            createFilterUi: createFilterUi
        };
    }
    createFilterInstance(column, filterDef, defaultFilter, getFilterParams) {
        const selectableFilter = this.beans.selectableFilter;
        if (selectableFilter?.isSelectable(filterDef)) filterDef = selectableFilter.getFilterDef(column, filterDef);
        const { handler: handler, handlerParams: handlerParams, handlerGenerator: handlerGenerator } = this.createHandler(column, filterDef, defaultFilter) ?? {};
        const filterCompDetails = this.createFilterComp(column, filterDef, defaultFilter, getFilterParams, !!handler, "init");
        if (!filterCompDetails) return {
            compDetails: null,
            createFilterUi: null,
            handler: handler,
            handlerGenerator: handlerGenerator,
            handlerParams: handlerParams
        };
        const { compDetails: compDetails, createFilterUi: createFilterUi } = filterCompDetails;
        if (this.isGlobalButtons) {
            const hasLocalButtons = !!compDetails.params?.buttons?.length;
            if (!hasLocalButtons) $437b23f6a393c3bf$export$545083624300f13d(281, {
                colId: column.getColId()
            });
        }
        return {
            compDetails: compDetails,
            handler: handler,
            handlerGenerator: handlerGenerator,
            handlerParams: handlerParams,
            createFilterUi: createFilterUi
        };
    }
    createBaseFilterParams(column, forFloatingFilter) {
        const { filterManager: filterManager, rowModel: rowModel } = this.beans;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column,
            colDef: column.getColDef(),
            getValue: this.createGetValue(column),
            doesRowPassOtherFilter: forFloatingFilter ? ()=>true : (node)=>filterManager?.doesRowPassOtherFilters(column.getColId(), node) ?? true,
            rowModel: // to avoid breaking changes to `filterParams` defined as functions
            // we need to provide the below options even though they are not valid for handlers
            rowModel
        });
    }
    createFilterCompParams(column, useHandler, source, forFloatingFilter) {
        const filterChangedCallback = this.filterChangedCallbackFactory(column);
        const params = this.createBaseFilterParams(column, forFloatingFilter);
        params.filterChangedCallback = filterChangedCallback;
        params.filterModifiedCallback = forFloatingFilter ? ()=>{} : (additionalEventAttributes)=>this.filterModified(column, additionalEventAttributes);
        if (useHandler) {
            const displayParams = params;
            const colId = column.getColId();
            const model = $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
            displayParams.model = model;
            displayParams.state = this.state.get(colId) ?? {
                model: model
            };
            displayParams.onModelChange = (model2, additionalEventAttributes)=>{
                this.updateStoredModel(colId, model2);
                this.refreshHandlerAndUi(column, model2, "ui", false, additionalEventAttributes).then(()=>{
                    filterChangedCallback({
                        ...additionalEventAttributes,
                        source: "columnFilter"
                    });
                });
            };
            displayParams.onStateChange = (state)=>{
                this.updateState(column, state);
                this.updateOrRefreshFilterUi(column);
            };
            displayParams.onAction = (action, additionalEventAttributes, event)=>{
                this.updateModel(column, action, additionalEventAttributes);
                this.dispatchLocalEvent({
                    type: "filterAction",
                    column: column,
                    action: action,
                    event: event
                });
            };
            displayParams.getHandler = ()=>this.getHandler(column, true);
            displayParams.onUiChange = (additionalEventAttributes)=>this.filterUiChanged(column, additionalEventAttributes);
            displayParams.source = source;
        }
        return params;
    }
    createFilterUiForHandler(compDetails, createFilterUi) {
        return createFilterUi ? {
            created: false,
            create: createFilterUi,
            filterParams: compDetails.params,
            compDetails: compDetails
        } : null;
    }
    createFilterUiLegacy(compDetails, createFilterUi, updateInstanceCallback) {
        const promise = createFilterUi();
        const filterUi = {
            created: true,
            create: createFilterUi,
            filterParams: compDetails.params,
            compDetails: compDetails,
            promise: promise
        };
        promise.then(updateInstanceCallback);
        return filterUi;
    }
    createFilterWrapper(column) {
        const { compDetails: compDetails, handler: handler, handlerGenerator: handlerGenerator, handlerParams: handlerParams, createFilterUi: createFilterUi } = this.createFilterInstance(column, column.getColDef(), this.getDefaultFilter(column), (params)=>params);
        const colId = column.getColId();
        if (handler) {
            delete this.initialModel[colId];
            handler.init?.({
                ...handlerParams,
                source: "init",
                model: $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId)
            });
            return {
                column: column,
                isHandler: true,
                handler: handler,
                handlerGenerator: handlerGenerator,
                handlerParams: handlerParams,
                filterUi: this.createFilterUiForHandler(compDetails, createFilterUi)
            };
        }
        if (createFilterUi) {
            const filterWrapper = {
                column: column,
                filterUi: null,
                isHandler: false
            };
            filterWrapper.filterUi = this.createFilterUiLegacy(compDetails, createFilterUi, (filterComp)=>{
                filterWrapper.filter = filterComp ?? void 0;
            });
            return filterWrapper;
        }
        return {
            column: column,
            filterUi: null,
            isHandler: false
        };
    }
    createHandlerFunc(column, filterDef, defaultFilter) {
        const { gos: gos, frameworkOverrides: frameworkOverrides, registry: registry } = this.beans;
        let doesFilterPass;
        const getFilterHandlerFromDef = (filterDef2)=>{
            const filter = filterDef2.filter;
            if ($437b23f6a393c3bf$var$isColumnFilterComp(filter)) {
                const handler = filter.handler;
                if (handler) return handler;
                doesFilterPass = filter.doesFilterPass;
                if (doesFilterPass) return ()=>({
                        doesFilterPass: doesFilterPass
                    });
                return void 0;
            }
            return typeof filter === "string" ? filter : void 0;
        };
        const enableFilterHandlers = gos.get("enableFilterHandlers");
        const providedFilterHandler = enableFilterHandlers ? getFilterHandlerFromDef(filterDef) : void 0;
        const resolveProvidedFilterHandler = (handlerName2)=>()=>this.createBean(registry.createDynamicBean(handlerName2, true));
        let filterHandler;
        let handlerName;
        if (typeof providedFilterHandler === "string") {
            const userFilterHandler = gos.get("filterHandlers")?.[providedFilterHandler];
            if (userFilterHandler != null) filterHandler = userFilterHandler;
            else if ($437b23f6a393c3bf$var$FILTER_HANDLERS.has(providedFilterHandler)) {
                filterHandler = resolveProvidedFilterHandler(providedFilterHandler);
                handlerName = providedFilterHandler;
            }
        } else filterHandler = providedFilterHandler;
        if (!filterHandler) {
            let filterName;
            const { compName: compName, jsComp: jsComp, fwComp: fwComp } = $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, filterDef);
            if (compName) filterName = compName;
            else {
                const usingDefaultFilter = jsComp == null && fwComp == null && filterDef.filter === true;
                if (usingDefaultFilter) filterName = defaultFilter;
            }
            handlerName = this.handlerMap[filterName];
            if (handlerName) filterHandler = resolveProvidedFilterHandler(handlerName);
        }
        if (!filterHandler) {
            if (!enableFilterHandlers) return void 0;
            if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos)) $437b23f6a393c3bf$export$545083624300f13d(277, {
                colId: column.getColId()
            });
            return $437b23f6a393c3bf$var$DUMMY_HANDLER;
        }
        return {
            filterHandler: filterHandler,
            handlerNameOrCallback: doesFilterPass ?? handlerName
        };
    }
    createHandler(column, filterDef, defaultFilter) {
        const handlerFunc = this.createHandlerFunc(column, filterDef, defaultFilter);
        if (!handlerFunc) return void 0;
        const filterParams = $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(this.beans.userCompFactory, filterDef, this.createFilterCompParams(column, true, "init"));
        const { handlerNameOrCallback: handlerNameOrCallback, filterHandler: filterHandler } = handlerFunc;
        const { handler: handler, handlerParams: handlerParams } = this.createHandlerFromFunc(column, filterHandler, filterParams);
        return {
            handler: handler,
            handlerParams: handlerParams,
            handlerGenerator: handlerNameOrCallback ?? filterHandler
        };
    }
    createHandlerFromFunc(column, filterHandler, filterParams) {
        const colDef = column.getColDef();
        const handler = filterHandler($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column,
            colDef: colDef
        }));
        const handlerParams = this.createHandlerParams(column, filterParams);
        return {
            handler: handler,
            handlerParams: handlerParams
        };
    }
    createHandlerParams(column, filterParams) {
        const colDef = column.getColDef();
        const colId = column.getColId();
        const filterChangedCallback = this.filterChangedCallbackFactory(column);
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            colDef: colDef,
            column: column,
            getValue: this.createGetValue(column),
            doesRowPassOtherFilter: (node)=>this.beans.filterManager?.doesRowPassOtherFilters(colId, node) ?? true,
            onModelChange: (newModel, additionalEventAttributes)=>{
                this.updateStoredModel(colId, newModel);
                this.refreshHandlerAndUi(column, newModel, "handler", false, additionalEventAttributes).then(()=>{
                    filterChangedCallback({
                        ...additionalEventAttributes,
                        source: "columnFilter"
                    });
                });
            },
            filterParams: filterParams
        });
    }
    onColumnsChanged() {
        const columns = [];
        const { colModel: colModel, filterManager: filterManager, groupFilter: groupFilter } = this.beans;
        this.allColumnFilters.forEach((wrapper, colId)=>{
            let currentColumn;
            if (wrapper.column.isPrimary()) currentColumn = colModel.getColDefCol(colId);
            else currentColumn = colModel.getCol(colId);
            if (currentColumn && currentColumn === wrapper.column) return;
            columns.push(wrapper.column);
            this.disposeFilterWrapper(wrapper, "columnChanged");
            this.disposeColumnListener(colId);
        });
        const allFiltersAreGroupFilters = groupFilter && columns.every((col)=>groupFilter.isGroupFilter(col));
        if (columns.length > 0 && !allFiltersAreGroupFilters) filterManager?.onFilterChanged({
            columns: columns,
            source: "api"
        });
    }
    isFilterAllowed(column) {
        const isFilterAllowed = column.isFilterAllowed();
        if (!isFilterAllowed) return false;
        const groupFilter = this.beans.groupFilter;
        if (groupFilter?.isGroupFilter(column)) return groupFilter.isFilterAllowed(column);
        return true;
    }
    getFloatingFilterCompDetails(column, showParentFilter) {
        const { userCompFactory: userCompFactory, frameworkOverrides: frameworkOverrides, selectableFilter: selectableFilter } = this.beans;
        const parentFilterInstance = (callback)=>{
            const filterComponent = this.getOrCreateFilterUi(column);
            if (filterComponent == null) return;
            filterComponent.then((instance)=>{
                callback($437b23f6a393c3bf$export$213d4c63c3df47e4(instance));
            });
        };
        const colDef = column.getColDef();
        const filterDef = selectableFilter?.isSelectable(colDef) ? selectableFilter.getFilterDef(column, colDef) : colDef;
        const defaultFloatingFilterType = $437b23f6a393c3bf$export$47072b32bdaf5d61(frameworkOverrides, filterDef, ()=>this.getDefaultFloatingFilter(column)) ?? "agReadOnlyFloatingFilter";
        const isReactive = this.gos.get("enableFilterHandlers");
        const filterParams = $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(userCompFactory, filterDef, this.createFilterCompParams(column, isReactive, "init", true));
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column,
            filterParams: filterParams,
            currentParentModel: ()=>this.getCurrentFloatingFilterParentModel(column),
            parentFilterInstance: parentFilterInstance,
            showParentFilter: showParentFilter
        });
        if (isReactive) {
            const displayParams = params;
            const colId = column.getColId();
            const filterChangedCallback = this.filterChangedCallbackFactory(column);
            displayParams.onUiChange = (additionalEventAttributes)=>this.floatingFilterUiChanged(column, additionalEventAttributes);
            displayParams.model = $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
            displayParams.onModelChange = (model, additionalEventAttributes)=>{
                this.updateStoredModel(colId, model);
                this.refreshHandlerAndUi(column, model, "floating", true, additionalEventAttributes).then(()=>{
                    filterChangedCallback({
                        ...additionalEventAttributes,
                        source: "columnFilter"
                    });
                });
            };
            displayParams.getHandler = ()=>this.getHandler(column, true);
            displayParams.source = "init";
        }
        return $437b23f6a393c3bf$export$14d0998f093f007e(userCompFactory, colDef, params, defaultFloatingFilterType);
    }
    getCurrentFloatingFilterParentModel(column) {
        return this.getModelFromFilterWrapper(this.cachedFilter(column) ?? {
            column: column
        });
    }
    destroyFilterUi(filterWrapper, column, compDetails, createFilterUi) {
        const source = "paramsUpdated";
        if (filterWrapper.isHandler) {
            const colId = column.getColId();
            delete this.initialModel[colId];
            this.state.delete(colId);
            const filterUi = filterWrapper.filterUi;
            const newFilterUi = this.createFilterUiForHandler(compDetails, createFilterUi);
            filterWrapper.filterUi = newFilterUi;
            const eventSvc = this.eventSvc;
            if (filterUi?.created) filterUi.promise.then((filter)=>{
                this.destroyBean(filter);
                eventSvc.dispatchEvent({
                    type: "filterDestroyed",
                    source: source,
                    column: column
                });
            });
            else eventSvc.dispatchEvent({
                type: "filterHandlerDestroyed",
                source: source,
                column: column
            });
        } else this.destroyFilter(column, source);
    }
    // destroys the filter, so it no longer takes part
    destroyFilter(column, source = "api") {
        const colId = column.getColId();
        const filterWrapper = this.allColumnFilters.get(colId);
        this.disposeColumnListener(colId);
        delete this.initialModel[colId];
        if (filterWrapper) this.disposeFilterWrapper(filterWrapper, source).then((wasActive)=>{
            if (wasActive && this.isAlive()) this.beans.filterManager?.onFilterChanged({
                columns: [
                    column
                ],
                source: "api"
            });
        });
    }
    disposeColumnListener(colId) {
        const columnListener = this.allColumnListeners.get(colId);
        if (columnListener) {
            this.allColumnListeners.delete(colId);
            columnListener();
        }
    }
    disposeFilterWrapper(filterWrapper, source) {
        let isActive = false;
        const { column: column, isHandler: isHandler, filterUi: filterUi } = filterWrapper;
        const colId = column.getColId();
        if (isHandler) {
            isActive = this.isHandlerActive(column);
            this.destroyBean(filterWrapper.handler);
            delete this.model[colId];
            this.state.delete(colId);
        }
        const removeFilter = ()=>{
            this.setColFilterActive(column, false, "filterDestroyed");
            this.allColumnFilters.delete(colId);
            this.eventSvc.dispatchEvent({
                type: "filterDestroyed",
                source: source,
                column: column
            });
        };
        if (filterUi) {
            if (filterUi.created) return filterUi.promise.then((filter)=>{
                isActive = isHandler ? isActive : !!filter?.isFilterActive();
                this.destroyBean(filter);
                removeFilter();
                return isActive;
            });
            else removeFilter();
        }
        return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(isActive);
    }
    filterChangedCallbackFactory(column) {
        return (additionalEventAttributes)=>{
            this.callOnFilterChangedOutsideRenderCycle({
                additionalEventAttributes: additionalEventAttributes,
                columns: [
                    column
                ],
                column: column,
                source: additionalEventAttributes?.source ?? "columnFilter"
            });
        };
    }
    filterParamsChanged(colId, source = "api") {
        const filterWrapper = this.allColumnFilters.get(colId);
        if (!filterWrapper) return;
        const beans = this.beans;
        const column = filterWrapper.column;
        const colDef = column.getColDef();
        const isFilterAllowed = column.isFilterAllowed();
        const defaultFilter = this.getDefaultFilter(column);
        const selectableFilter = beans.selectableFilter;
        const filterDef = selectableFilter?.isSelectable(colDef) ? selectableFilter.getFilterDef(column, colDef) : colDef;
        const handlerFunc = isFilterAllowed ? this.createHandlerFunc(column, filterDef, this.getDefaultFilter(column)) : void 0;
        const isHandler = !!handlerFunc;
        const wasHandler = filterWrapper.isHandler;
        if (wasHandler != isHandler) {
            this.destroyFilter(column, "paramsUpdated");
            return;
        }
        const { compDetails: compDetails, createFilterUi: createFilterUi } = (isFilterAllowed ? this.createFilterComp(column, filterDef, defaultFilter, (params)=>params, isHandler, "colDef") : null) ?? {
            compDetails: null,
            createFilterUi: null
        };
        const newFilterParams = compDetails?.params ?? $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(beans.userCompFactory, filterDef, this.createFilterCompParams(column, isHandler, "colDef"));
        if (wasHandler) {
            const handlerGenerator = handlerFunc?.handlerNameOrCallback ?? handlerFunc?.filterHandler;
            const existingModel = $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
            if (filterWrapper.handlerGenerator != handlerGenerator) {
                const oldHandler = filterWrapper.handler;
                const { handler: handler, handlerParams: handlerParams } = this.createHandlerFromFunc(column, handlerFunc.filterHandler, newFilterParams);
                filterWrapper.handler = handler;
                filterWrapper.handlerParams = handlerParams;
                filterWrapper.handlerGenerator = handlerGenerator;
                delete this.model[colId];
                handler.init?.({
                    ...handlerParams,
                    source: "init",
                    model: null
                });
                this.destroyBean(oldHandler);
                if (existingModel != null) this.beans.filterManager?.onFilterChanged({
                    columns: [
                        column
                    ],
                    source: source
                });
            } else {
                const handlerParams = this.createHandlerParams(column, compDetails?.params);
                filterWrapper.handlerParams = handlerParams;
                filterWrapper.handler.refresh?.({
                    ...handlerParams,
                    source: "colDef",
                    model: existingModel
                });
            }
        }
        if (this.areFilterCompsDifferent(filterWrapper.filterUi?.compDetails ?? null, compDetails) || !filterWrapper.filterUi || !compDetails) {
            this.destroyFilterUi(filterWrapper, column, compDetails, createFilterUi);
            return;
        }
        filterWrapper.filterUi.filterParams = newFilterParams;
        $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, wasHandler)?.then((filter)=>{
            const shouldRefreshFilter = filter?.refresh ? filter.refresh(newFilterParams) : true;
            if (shouldRefreshFilter === false) this.destroyFilterUi(filterWrapper, column, compDetails, createFilterUi);
            else this.dispatchLocalEvent({
                type: "filterParamsChanged",
                column: column,
                params: newFilterParams
            });
        });
    }
    refreshHandlerAndUi(column, model, source, createIfMissing, additionalEventAttributes) {
        const filterWrapper = this.cachedFilter(column);
        if (!filterWrapper) {
            if (createIfMissing) this.getOrCreateFilterWrapper(column, true);
            return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        }
        if (!filterWrapper.isHandler) return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        const { filterUi: filterUi, handler: handler, handlerParams: handlerParams } = filterWrapper;
        return $437b23f6a393c3bf$export$1fc9ad198b29415d(()=>{
            if (filterUi) {
                const { created: created, filterParams: filterParams } = filterUi;
                if (created) return filterUi.promise.then((filter)=>{
                    return filter ? {
                        filter: filter,
                        filterParams: filterParams
                    } : void 0;
                });
                else filterUi.refreshed = true;
            }
            return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(void 0);
        }, handler, handlerParams, model, this.state.get(column.getColId()) ?? {
            model: model
        }, source, additionalEventAttributes);
    }
    setColumnFilterWrapper(column, filterWrapper) {
        const colId = column.getColId();
        this.allColumnFilters.set(colId, filterWrapper);
        this.allColumnListeners.set(colId, this.addManagedListeners(column, {
            colDefChanged: ()=>this.filterParamsChanged(colId)
        })[0]);
    }
    areFilterCompsDifferent(oldCompDetails, newCompDetails) {
        if (!newCompDetails || !oldCompDetails) return true;
        const { componentClass: oldComponentClass } = oldCompDetails;
        const { componentClass: newComponentClass } = newCompDetails;
        const isSameComponentClass = oldComponentClass === newComponentClass || // react hooks returns new wrappers, so check nested render method
        oldComponentClass?.render && newComponentClass?.render && oldComponentClass.render === newComponentClass.render;
        return !isSameComponentClass;
    }
    hasFloatingFilters() {
        const gridColumns = this.beans.colModel.getCols();
        return gridColumns.some((col)=>col.getColDef().floatingFilter);
    }
    getFilterInstance(key) {
        const column = this.beans.colModel.getColDefCol(key);
        if (!column) return Promise.resolve(void 0);
        const filterPromise = this.getOrCreateFilterUi(column);
        if (!filterPromise) return Promise.resolve(null);
        return new Promise((resolve)=>{
            filterPromise.then((filter)=>{
                resolve($437b23f6a393c3bf$export$213d4c63c3df47e4(filter));
            });
        });
    }
    processFilterModelUpdateQueue() {
        this.modelUpdates.forEach(({ model: model, source: source })=>this.setModel(model, source));
        this.modelUpdates = [];
        this.columnModelUpdates.forEach(({ key: key, model: model, resolve: resolve })=>{
            this.setModelForColumn(key, model).then(()=>resolve());
        });
        this.columnModelUpdates = [];
    }
    getModelForColumn(column, useUnapplied) {
        if (useUnapplied) {
            const { state: state, model: model } = this;
            const colId = column.getColId();
            const colState = state.get(colId);
            if (colState) return colState.model ?? null;
            return $437b23f6a393c3bf$export$8981db65da4532f2(model, colId);
        }
        const filterWrapper = this.cachedFilter(column);
        return filterWrapper ? this.getModelFromFilterWrapper(filterWrapper) : null;
    }
    setModelForColumn(key, model) {
        if (this.beans.dataTypeSvc?.isPendingInference) {
            let resolve = ()=>{};
            const promise = new Promise((res)=>{
                resolve = res;
            });
            this.columnModelUpdates.push({
                key: key,
                model: model,
                resolve: resolve
            });
            return promise;
        }
        return new Promise((resolve)=>{
            this.setModelForColumnLegacy(key, model).then((result)=>resolve(result));
        });
    }
    getStateForColumn(colId) {
        return this.state.get(colId) ?? {
            model: $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId)
        };
    }
    setModelForColumnLegacy(key, model) {
        const column = this.beans.colModel.getColDefCol(key);
        const filterWrapper = column ? this.getOrCreateFilterWrapper(column, true) : null;
        return filterWrapper ? this.setModelOnFilterWrapper(filterWrapper, model) : $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    setColDefPropsForDataType(colDef, dataTypeDefinition, formatValue) {
        const providedFilter = colDef.filter;
        const filter = providedFilter === true ? this.getDefaultFilterFromDataType(()=>dataTypeDefinition.baseDataType) : providedFilter;
        if (typeof filter !== "string") return;
        let filterParams;
        let filterValueGetter;
        const beans = this.beans;
        const { filterParams: colDefFilterParams, filterValueGetter: colDefFilterValueGetter } = colDef;
        if (filter === "agMultiColumnFilter") ({ filterParams: filterParams, filterValueGetter: filterValueGetter } = beans.multiFilter?.getParamsForDataType(colDefFilterParams, colDefFilterValueGetter, dataTypeDefinition, formatValue) ?? {});
        else ({ filterParams: filterParams, filterValueGetter: filterValueGetter } = $437b23f6a393c3bf$export$4a99b58ce484acc(filter, colDefFilterParams, colDefFilterValueGetter, dataTypeDefinition, formatValue, beans, this.getLocaleTextFunc()));
        colDef.filterParams = filterParams;
        if (filterValueGetter) colDef.filterValueGetter = filterValueGetter;
    }
    // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
    setColFilterActive(column, active, source, additionalEventAttributes) {
        if (column.filterActive !== active) {
            column.filterActive = active;
            column.dispatchColEvent("filterActiveChanged", source);
        }
        column.dispatchColEvent("filterChanged", source, additionalEventAttributes);
    }
    setModelOnFilterWrapper(filterWrapper, newModel, justCreated) {
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            if (filterWrapper.isHandler) {
                const column = filterWrapper.column;
                const colId = column.getColId();
                const existingModel = this.model[colId];
                this.updateStoredModel(colId, newModel);
                if (justCreated && newModel === existingModel) {
                    resolve();
                    return;
                }
                this.refreshHandlerAndUi(column, newModel, "api").then(()=>resolve());
                return;
            }
            const uiPromise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
            if (uiPromise) {
                uiPromise.then((filter)=>{
                    if (typeof filter?.setModel !== "function") {
                        $437b23f6a393c3bf$export$545083624300f13d(65);
                        resolve();
                        return;
                    }
                    (filter.setModel(newModel) || $437b23f6a393c3bf$export$30ec7836a4847721.resolve()).then(()=>resolve());
                });
                return;
            }
            resolve();
        });
    }
    /** for handlers only */ updateStoredModel(colId, model) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model)) this.model[colId] = model;
        else delete this.model[colId];
        const oldState = this.state.get(colId);
        const newState = {
            model: model,
            state: oldState?.state
        };
        this.state.set(colId, newState);
    }
    filterModified(column, additionalEventAttributes) {
        this.getOrCreateFilterUi(column)?.then((filterInstance)=>{
            this.eventSvc.dispatchEvent({
                type: "filterModified",
                column: column,
                filterInstance: filterInstance,
                ...additionalEventAttributes
            });
        });
    }
    filterUiChanged(column, additionalEventAttributes) {
        if (this.gos.get("enableFilterHandlers")) this.eventSvc.dispatchEvent({
            type: "filterUiChanged",
            column: column,
            ...additionalEventAttributes
        });
    }
    floatingFilterUiChanged(column, additionalEventAttributes) {
        if (this.gos.get("enableFilterHandlers")) this.eventSvc.dispatchEvent({
            type: "floatingFilterUiChanged",
            column: column,
            ...additionalEventAttributes
        });
    }
    updateModel(column, action, additionalEventAttributes) {
        const colId = column.getColId();
        const filterWrapper = this.cachedFilter(column);
        const getFilterUi = ()=>filterWrapper?.filterUi;
        $437b23f6a393c3bf$export$3305e8c6f4c8572a(action, getFilterUi, ()=>$437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId), ()=>this.state.get(colId), (state)=>this.updateState(column, state), (model)=>getFilterUi()?.filterParams?.onModelChange(model, additionalEventAttributes), filterWrapper?.isHandler ? filterWrapper.handler.processModelToApply?.bind(filterWrapper.handler) : void 0);
    }
    updateAllModels(action, additionalEventAttributes) {
        const promises = [];
        this.allColumnFilters.forEach((filter, colId)=>{
            const column = this.beans.colModel.getColDefCol(colId);
            if (column) $437b23f6a393c3bf$export$3305e8c6f4c8572a(action, ()=>filter.filterUi, ()=>$437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId), ()=>this.state.get(colId), (state)=>this.updateState(column, state), (model)=>{
                this.updateStoredModel(colId, model);
                this.dispatchLocalEvent({
                    type: "filterAction",
                    column: column,
                    action: action
                });
                promises.push(this.refreshHandlerAndUi(column, model, "ui"));
            }, filter?.isHandler ? filter.handler.processModelToApply?.bind(filter.handler) : void 0);
        });
        if (promises.length) $437b23f6a393c3bf$export$30ec7836a4847721.all(promises).then(()=>{
            this.callOnFilterChangedOutsideRenderCycle({
                source: "columnFilter",
                additionalEventAttributes: additionalEventAttributes,
                columns: []
            });
        });
    }
    updateOrRefreshFilterUi(column) {
        const colId = column.getColId();
        $437b23f6a393c3bf$var$getAndRefreshFilterUi(()=>this.cachedFilter(column)?.filterUi, ()=>$437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId), ()=>this.state.get(colId));
    }
    updateState(column, state) {
        this.state.set(column.getColId(), state);
        this.dispatchLocalEvent({
            type: "filterStateChanged",
            column: column,
            state: state
        });
    }
    // for tool panel only
    canApplyAll() {
        const { state: state, model: model, activeFilterComps: activeFilterComps } = this;
        for (const comp of activeFilterComps){
            if (comp.source === "COLUMN_MENU") return false;
        }
        let hasChanges = false;
        for (const colId of state.keys()){
            const colState = state.get(colId);
            if (colState.valid === false) return false;
            if ((colState.model ?? null) !== $437b23f6a393c3bf$export$8981db65da4532f2(model, colId)) hasChanges = true;
        }
        return hasChanges;
    }
    hasUnappliedModel(colId) {
        const { model: model, state: state } = this;
        return (state.get(colId)?.model ?? null) !== $437b23f6a393c3bf$export$8981db65da4532f2(model, colId);
    }
    setGlobalButtons(isGlobal) {
        this.isGlobalButtons = isGlobal;
        this.dispatchLocalEvent({
            type: "filterGlobalButtons",
            isGlobal: isGlobal
        });
    }
    shouldKeepStateOnDetach(column, lastContainerType) {
        if (lastContainerType === "newFiltersToolPanel") return true;
        const filterPanelSvc = this.beans.filterPanelSvc;
        if (filterPanelSvc?.isActive) return !!filterPanelSvc.getState(column.getColId());
        return false;
    }
    destroy() {
        super.destroy();
        this.allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "gridDestroyed"));
        this.allColumnListeners.clear();
        this.state.clear();
        this.activeFilterComps.clear();
    }
};
// packages/ag-grid-community/src/filter/filterApi.ts
function $437b23f6a393c3bf$var$isAnyFilterPresent(beans) {
    return !!beans.filterManager?.isAnyFilterPresent();
}
function $437b23f6a393c3bf$var$onFilterChanged(beans, source = "api") {
    beans.filterManager?.onFilterChanged({
        source: source
    });
}
// packages/ag-grid-community/src/filter/filterManager.ts
var $437b23f6a393c3bf$var$FilterManager = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterManager";
        // when we're waiting for cell data types to be inferred, we need to defer filter model updates
        this.advFilterModelUpdateQueue = [];
    }
    wireBeans(beans) {
        this.quickFilter = beans.quickFilter;
        this.advancedFilter = beans.advancedFilter;
        this.colFilter = beans.colFilter;
    }
    postConstruct() {
        const refreshFiltersForAggregations = this.refreshFiltersForAggregations.bind(this);
        const updateAdvFilterColumns = this.updateAdvFilterColumns.bind(this);
        this.addManagedEventListeners({
            columnValueChanged: refreshFiltersForAggregations,
            columnPivotChanged: refreshFiltersForAggregations,
            columnPivotModeChanged: refreshFiltersForAggregations,
            newColumnsLoaded: updateAdvFilterColumns,
            columnVisible: updateAdvFilterColumns,
            advancedFilterEnabledChanged: ({ enabled: enabled })=>this.onAdvFilterEnabledChanged(enabled),
            dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
        });
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        this.addManagedPropertyListeners([
            "isExternalFilterPresent",
            "doesExternalFilterPass"
        ], ()=>{
            this.onFilterChanged({
                source: "api"
            });
        });
        this.updateAggFiltering();
        this.addManagedPropertyListener("groupAggFiltering", ()=>{
            this.updateAggFiltering();
            this.onFilterChanged();
        });
        if (this.quickFilter) this.addManagedListeners(this.quickFilter, {
            quickFilterChanged: ()=>this.onFilterChanged({
                    source: "quickFilter"
                })
        });
        const { gos: gos } = this;
        this.alwaysPassFilter = gos.get("alwaysPassFilter");
        this.addManagedPropertyListener("alwaysPassFilter", ()=>{
            this.alwaysPassFilter = gos.get("alwaysPassFilter");
            this.onFilterChanged({
                source: "api"
            });
        });
    }
    isExternalFilterPresentCallback() {
        const isFilterPresent = this.gos.getCallback("isExternalFilterPresent");
        return typeof isFilterPresent === "function" && isFilterPresent({});
    }
    doesExternalFilterPass(node) {
        const doesFilterPass = this.gos.get("doesExternalFilterPass");
        return typeof doesFilterPass === "function" && doesFilterPass(node);
    }
    setFilterState(model, state, source = "api") {
        if (this.isAdvFilterEnabled()) return;
        this.colFilter?.setState(model, state, source);
    }
    setFilterModel(model, source = "api", skipWarning) {
        if (this.isAdvFilterEnabled()) {
            if (!skipWarning) this.warnAdvFilters();
            return;
        }
        this.colFilter?.setModel(model, source);
    }
    getFilterModel() {
        return this.colFilter?.getModel() ?? {};
    }
    getFilterState() {
        return this.colFilter?.getState();
    }
    isColumnFilterPresent() {
        return !!this.colFilter?.isFilterPresent();
    }
    isAggregateFilterPresent() {
        return !!this.colFilter?.isAggFilterPresent();
    }
    isChildFilterPresent() {
        return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.externalFilterPresent || this.isAdvFilterPresent();
    }
    isAnyFilterPresent() {
        return this.isChildFilterPresent() || this.isAggregateFilterPresent();
    }
    isAdvFilterPresent() {
        return this.isAdvFilterEnabled() && this.advancedFilter.isFilterPresent();
    }
    onAdvFilterEnabledChanged(enabled) {
        if (enabled) {
            if (this.colFilter?.disableFilters()) this.onFilterChanged({
                source: "advancedFilter"
            });
        } else if (this.advancedFilter?.isFilterPresent()) {
            this.advancedFilter.setModel(null);
            this.onFilterChanged({
                source: "advancedFilter"
            });
        }
    }
    isAdvFilterEnabled() {
        return !!this.advancedFilter?.isEnabled();
    }
    isAdvFilterHeaderActive() {
        return this.isAdvFilterEnabled() && this.advancedFilter.isHeaderActive();
    }
    refreshFiltersForAggregations() {
        if ($437b23f6a393c3bf$export$3708afee0330994(this.gos) && this.isAnyFilterPresent()) this.onFilterChanged();
    }
    onFilterChanged(params = {}) {
        const { source: source, additionalEventAttributes: additionalEventAttributes, columns: columns = [] } = params;
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        (this.colFilter ? this.colFilter.updateBeforeFilterChanged(params) : $437b23f6a393c3bf$export$30ec7836a4847721.resolve()).then(()=>{
            const filterChangedEvent = {
                source: source,
                type: "filterChanged",
                columns: columns
            };
            if (additionalEventAttributes) $437b23f6a393c3bf$export$8ade6bd474fcde42(filterChangedEvent, additionalEventAttributes);
            this.eventSvc.dispatchEvent(filterChangedEvent);
            this.colFilter?.updateAfterFilterChanged();
        });
    }
    isSuppressFlashingCellsBecauseFiltering() {
        return !!this.colFilter?.isSuppressFlashingCellsBecauseFiltering();
    }
    isQuickFilterPresent() {
        return !!this.quickFilter?.isFilterPresent();
    }
    updateAggFiltering() {
        this.aggFiltering = !!$437b23f6a393c3bf$export$3708afee0330994(this.gos);
    }
    isAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
    }
    isNonAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
    }
    shouldApplyQuickFilterAfterAgg() {
        return (this.aggFiltering || this.beans.colModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
    }
    doesRowPassOtherFilters(colIdToSkip, rowNode) {
        return this.doesRowPassFilter({
            rowNode: rowNode,
            colIdToSkip: colIdToSkip
        });
    }
    doesRowPassAggregateFilters(params) {
        const { rowNode: rowNode } = params;
        if (this.alwaysPassFilter?.(rowNode)) return true;
        if (this.isAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(rowNode)) return false;
        if (this.isAggregateFilterPresent() && !this.colFilter.doFiltersPass(rowNode, params.colIdToSkip, true)) return false;
        return true;
    }
    doesRowPassFilter(params) {
        const { rowNode: rowNode } = params;
        if (this.alwaysPassFilter?.(rowNode)) return true;
        if (this.isNonAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(rowNode)) return false;
        if (this.externalFilterPresent && !this.doesExternalFilterPass(rowNode)) return false;
        if (this.isColumnFilterPresent() && !this.colFilter.doFiltersPass(rowNode, params.colIdToSkip)) return false;
        if (this.isAdvFilterPresent() && !this.advancedFilter.doesFilterPass(rowNode)) return false;
        return true;
    }
    // for group filters, can change dynamically whether they are allowed or not
    isFilterAllowed(column) {
        if (this.isAdvFilterEnabled()) return false;
        return !!this.colFilter?.isFilterAllowed(column);
    }
    getAdvFilterModel() {
        return this.isAdvFilterEnabled() ? this.advancedFilter.getModel() : null;
    }
    setAdvFilterModel(expression, source = "api") {
        if (!this.isAdvFilterEnabled()) return;
        if (this.beans.dataTypeSvc?.isPendingInference) {
            this.advFilterModelUpdateQueue.push(expression);
            return;
        }
        this.advancedFilter.setModel(expression ?? null);
        this.onFilterChanged({
            source: source
        });
    }
    toggleAdvFilterBuilder(show, source) {
        if (!this.isAdvFilterEnabled()) return;
        this.advancedFilter.getCtrl().toggleFilterBuilder({
            source: source,
            force: show
        });
    }
    updateAdvFilterColumns() {
        if (!this.isAdvFilterEnabled()) return;
        if (this.advancedFilter.updateValidity()) this.onFilterChanged({
            source: "advancedFilter"
        });
    }
    hasFloatingFilters() {
        if (this.isAdvFilterEnabled()) return false;
        return !!this.colFilter?.hasFloatingFilters();
    }
    getColumnFilterInstance(key) {
        if (this.isAdvFilterEnabled()) {
            this.warnAdvFilters();
            return Promise.resolve(void 0);
        }
        return this.colFilter?.getFilterInstance(key) ?? Promise.resolve(void 0);
    }
    warnAdvFilters() {
        $437b23f6a393c3bf$export$545083624300f13d(68);
    }
    setupAdvFilterHeaderComp(eCompToInsertBefore) {
        this.advancedFilter?.getCtrl().setupHeaderComp(eCompToInsertBefore);
    }
    getHeaderRowCount() {
        return this.isAdvFilterHeaderActive() ? 1 : 0;
    }
    getHeaderHeight() {
        return this.isAdvFilterHeaderActive() ? this.advancedFilter.getCtrl().getHeaderHeight() : 0;
    }
    processFilterModelUpdateQueue() {
        for (const model of this.advFilterModelUpdateQueue)this.setAdvFilterModel(model);
        this.advFilterModelUpdateQueue = [];
    }
    setColumnFilterModel(key, model) {
        if (this.isAdvFilterEnabled()) {
            this.warnAdvFilters();
            return Promise.resolve();
        }
        return this.colFilter?.setModelForColumn(key, model) ?? Promise.resolve();
    }
};
// packages/ag-grid-community/src/filter/filterMenuFactory.ts
var $437b23f6a393c3bf$var$FilterMenuFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterMenuFactory";
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
    }
    hideActiveMenu() {
        this.hidePopup?.();
    }
    showMenuAfterMouseEvent(column, mouseEvent, containerType, onClosedCallback) {
        if (column && !column.isColumn) return;
        this.showPopup(column, (eMenu)=>{
            this.popupSvc?.positionPopupUnderMouseEvent({
                column: column,
                type: containerType,
                mouseEvent: mouseEvent,
                ePopup: eMenu
            });
        }, containerType, mouseEvent.target, $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos), onClosedCallback);
    }
    showMenuAfterButtonClick(column, eventSource, containerType, onClosedCallback) {
        if (column && !column.isColumn) return;
        let multiplier = -1;
        let alignSide = "left";
        const isLegacyMenuEnabled = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos);
        if (!isLegacyMenuEnabled && this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        const nudgeX = isLegacyMenuEnabled ? void 0 : 4 * multiplier;
        const nudgeY = isLegacyMenuEnabled ? void 0 : 4;
        this.showPopup(column, (eMenu)=>{
            this.popupSvc?.positionPopupByComponent({
                type: containerType,
                eventSource: eventSource,
                ePopup: eMenu,
                nudgeX: nudgeX,
                nudgeY: nudgeY,
                alignSide: alignSide,
                keepWithinBounds: true,
                position: "under",
                column: column
            });
        }, containerType, eventSource, isLegacyMenuEnabled, onClosedCallback);
    }
    showPopup(column, positionCallback, containerType, eventSource, isLegacyMenuEnabled, onClosedCallback) {
        const comp = column ? this.createBean(new $437b23f6a393c3bf$export$7db6d402989d8b90(column, "COLUMN_MENU")) : void 0;
        this.activeMenu = comp;
        if (!comp?.hasFilter() || !column) {
            $437b23f6a393c3bf$export$a20c7248650823a9(57);
            return;
        }
        const eMenu = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: `ag-menu${!isLegacyMenuEnabled ? " ag-filter-menu" : ""}`,
            role: "presentation"
        });
        [this.tabListener] = this.addManagedElementListeners(eMenu, {
            keydown: (e)=>this.trapFocusWithin(e, eMenu)
        });
        eMenu.appendChild(comp?.getGui());
        let hidePopup;
        const afterGuiDetached = ()=>comp?.afterGuiDetached();
        const anchorToElement = $437b23f6a393c3bf$export$cfe4cf52f3717a7b(this.gos) ? eventSource ?? this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody : void 0;
        const closedCallback = (e)=>{
            $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, false, "contextMenu");
            const isKeyboardEvent = e instanceof KeyboardEvent;
            if (this.tabListener) this.tabListener = this.tabListener();
            if (isKeyboardEvent && eventSource && $437b23f6a393c3bf$export$2badf4aa566524cb(eventSource)) {
                const focusableEl = $437b23f6a393c3bf$export$c4c49c776025d475(eventSource);
                focusableEl?.focus({
                    preventScroll: true
                });
            }
            afterGuiDetached();
            this.destroyBean(this.activeMenu);
            this.dispatchVisibleChangedEvent(false, containerType, column);
            onClosedCallback?.();
        };
        const translate = this.getLocaleTextFunc();
        const ariaLabel = isLegacyMenuEnabled && containerType !== "columnFilter" ? translate("ariaLabelColumnMenu", "Column Menu") : translate("ariaLabelColumnFilter", "Column Filter");
        const addPopupRes = this.popupSvc?.addPopup({
            modal: true,
            eChild: eMenu,
            closeOnEsc: true,
            closedCallback: closedCallback,
            positionCallback: ()=>positionCallback(eMenu),
            anchorToElement: anchorToElement,
            ariaLabel: ariaLabel
        });
        if (addPopupRes) this.hidePopup = hidePopup = addPopupRes.hideFunc;
        comp.afterInit().then(()=>{
            positionCallback(eMenu);
            comp.afterGuiAttached({
                container: containerType,
                hidePopup: hidePopup
            });
        });
        $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, true, "contextMenu");
        this.dispatchVisibleChangedEvent(true, containerType, column);
    }
    trapFocusWithin(e, menu) {
        if (e.key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || e.defaultPrevented || $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, menu, false, e.shiftKey)) return;
        e.preventDefault();
        $437b23f6a393c3bf$export$8598088d375f416f(menu, e.shiftKey);
    }
    dispatchVisibleChangedEvent(visible, containerType, column) {
        this.eventSvc.dispatchEvent({
            type: "columnMenuVisibleChanged",
            visible: visible,
            switchingTab: false,
            key: containerType,
            column: column ?? null,
            columnGroup: null
        });
    }
    isMenuEnabled(column) {
        return column.isFilterAllowed() && (column.getColDef().menuTabs ?? [
            "filterMenuTab"
        ]).includes("filterMenuTab");
    }
    showMenuAfterContextMenuEvent() {}
    destroy() {
        this.destroyBean(this.activeMenu);
        super.destroy();
    }
};
// packages/ag-grid-community/src/filter/filterValueService.ts
var $437b23f6a393c3bf$var$FilterValueService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterValueSvc";
    }
    getValue(column, rowNode, filterValueGetterOverride) {
        if (!rowNode) return;
        const colDef = column.getColDef();
        const { selectableFilter: selectableFilter, valueSvc: valueSvc } = this.beans;
        const filterValueGetter = filterValueGetterOverride ?? selectableFilter?.getFilterValueGetter(column.getColId()) ?? colDef.filterValueGetter;
        if (filterValueGetter) return this.executeFilterValueGetter(filterValueGetter, rowNode.data, column, rowNode, colDef);
        return valueSvc.getValue(column, rowNode);
    }
    executeFilterValueGetter(valueGetter, data, column, node, colDef) {
        const { expressionSvc: expressionSvc, valueSvc: valueSvc } = this.beans;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            data: data,
            node: node,
            column: column,
            colDef: colDef,
            getValue: valueSvc.getValueCallback.bind(valueSvc, node)
        });
        if (typeof valueGetter === "function") return valueGetter(params);
        return expressionSvc?.evaluate(valueGetter, params);
    }
};
// packages/ag-grid-community/src/filter/floating/provided/readOnlyFloatingFilter.ts
var $437b23f6a393c3bf$var$ReadOnlyFloatingFilterElement = {
    tag: "div",
    cls: "ag-floating-filter-input",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eFloatingFilterText"
        }
    ]
};
var $437b23f6a393c3bf$var$ReadOnlyFloatingFilter = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$ReadOnlyFloatingFilterElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eFloatingFilterText = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    init(params) {
        this.params = params;
        const displayName = this.beans.colNames.getDisplayNameForColumn(params.column, "header", true);
        this.eFloatingFilterText.setDisabled(true).setInputAriaLabel(`${displayName} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`);
        if (this.gos.get("enableFilterHandlers")) {
            const reactiveParams = params;
            const handler = reactiveParams.getHandler();
            if (handler.getModelAsString) {
                const modelAsString = handler.getModelAsString(reactiveParams.model);
                this.eFloatingFilterText.setValue(modelAsString);
            }
        }
    }
    onParentModelChanged(parentModel) {
        if (parentModel == null) {
            this.eFloatingFilterText.setValue("");
            return;
        }
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance.getModelAsString) {
                const modelAsString = filterInstance.getModelAsString(parentModel);
                this.eFloatingFilterText.setValue(modelAsString);
            }
        });
    }
    refresh(params) {
        this.init(params);
    }
};
// packages/ag-grid-community/src/filter/provided/optionsFactory.ts
var $437b23f6a393c3bf$var$OptionsFactory = class {
    constructor(){
        this.customFilterOptions = {};
    }
    init(params, defaultOptions) {
        this.filterOptions = params.filterOptions ?? defaultOptions;
        this.mapCustomOptions();
        this.defaultOption = this.getDefaultItem(params.defaultOption);
    }
    refresh(params, defaultOptions) {
        const filterOptions = params.filterOptions ?? defaultOptions;
        if (this.filterOptions !== filterOptions) {
            this.filterOptions = filterOptions;
            this.customFilterOptions = {};
            this.mapCustomOptions();
        }
        this.defaultOption = this.getDefaultItem(params.defaultOption);
    }
    mapCustomOptions() {
        const { filterOptions: filterOptions } = this;
        if (!filterOptions) return;
        for (const filterOption of filterOptions){
            if (typeof filterOption === "string") continue;
            const requiredProperties = [
                [
                    "displayKey"
                ],
                [
                    "displayName"
                ],
                [
                    "predicate",
                    "test"
                ]
            ];
            const propertyCheck = (keys)=>{
                if (!keys.some((key)=>filterOption[key] != null)) {
                    $437b23f6a393c3bf$export$545083624300f13d(72, {
                        keys: keys
                    });
                    return false;
                }
                return true;
            };
            if (!requiredProperties.every(propertyCheck)) {
                this.filterOptions = filterOptions.filter((v)=>v === filterOption) || [];
                continue;
            }
            this.customFilterOptions[filterOption.displayKey] = filterOption;
        }
    }
    getDefaultItem(defaultOption) {
        const { filterOptions: filterOptions } = this;
        if (defaultOption) return defaultOption;
        else if (filterOptions.length >= 1) {
            const firstFilterOption = filterOptions[0];
            if (typeof firstFilterOption === "string") return firstFilterOption;
            else if (firstFilterOption.displayKey) return firstFilterOption.displayKey;
            else $437b23f6a393c3bf$export$545083624300f13d(73);
        } else $437b23f6a393c3bf$export$545083624300f13d(74);
        return void 0;
    }
    getCustomOption(name) {
        return this.customFilterOptions[name];
    }
};
// packages/ag-grid-community/src/filter/provided/simpleFilterUtils.ts
function $437b23f6a393c3bf$var$removeItems(items, startPosition, deleteCount) {
    return deleteCount == null ? items.splice(startPosition) : items.splice(startPosition, deleteCount);
}
function $437b23f6a393c3bf$var$isBlank(cellValue) {
    return cellValue == null || typeof cellValue === "string" && cellValue.trim().length === 0;
}
function $437b23f6a393c3bf$var$getDefaultJoinOperator(defaultJoinOperator) {
    return defaultJoinOperator === "AND" || defaultJoinOperator === "OR" ? defaultJoinOperator : "AND";
}
function $437b23f6a393c3bf$var$evaluateCustomFilter(customFilterOption, values, cellValue) {
    if (customFilterOption == null) return;
    const { predicate: predicate } = customFilterOption;
    if (predicate != null && !values.some((v)=>v == null)) return predicate(values, cellValue);
}
function $437b23f6a393c3bf$var$validateAndUpdateConditions(conditions, maxNumConditions) {
    let numConditions = conditions.length;
    if (numConditions > maxNumConditions) {
        conditions.splice(maxNumConditions);
        $437b23f6a393c3bf$export$545083624300f13d(78);
        numConditions = maxNumConditions;
    }
    return numConditions;
}
function $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory) {
    const customOpts = optionsFactory.getCustomOption(type);
    if (customOpts) {
        const { numberOfInputs: numberOfInputs } = customOpts;
        return numberOfInputs != null ? numberOfInputs : 1;
    }
    const zeroInputTypes = [
        "empty",
        "notBlank",
        "blank"
    ];
    if (type && zeroInputTypes.indexOf(type) >= 0) return 0;
    else if (type === "inRange") return 2;
    return 1;
}
// packages/ag-grid-community/src/filter/provided/simpleFilter.ts
var $437b23f6a393c3bf$var$SimpleFilter = class extends $437b23f6a393c3bf$export$a927a1327c2cc7f0 {
    constructor(filterNameKey, mapValuesFromModel, defaultOptions){
        super(filterNameKey, "simple-filter");
        this.mapValuesFromModel = mapValuesFromModel;
        this.defaultOptions = defaultOptions;
        this.eTypes = [];
        this.eJoinPanels = [];
        this.eJoinAnds = [];
        this.eJoinOrs = [];
        this.eConditionBodies = [];
        this.listener = ()=>this.onUiChanged();
        this.lastUiCompletePosition = null;
        this.joinOperatorId = 0;
    }
    setParams(params) {
        super.setParams(params);
        const optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory = optionsFactory;
        optionsFactory.init(params, this.defaultOptions);
        this.commonUpdateSimpleParams(params);
        this.createOption();
        this.createMissingConditionsAndOperators();
    }
    updateParams(newParams, oldParams) {
        this.optionsFactory.refresh(newParams, this.defaultOptions);
        super.updateParams(newParams, oldParams);
        this.commonUpdateSimpleParams(newParams);
    }
    commonUpdateSimpleParams(params) {
        this.setNumConditions(params);
        this.defaultJoinOperator = $437b23f6a393c3bf$var$getDefaultJoinOperator(params.defaultJoinOperator);
        this.filterPlaceholder = params.filterPlaceholder;
        this.createFilterListOptions();
        const eGui = this.getGui();
        if (this.isReadOnly()) eGui.setAttribute("tabindex", "-1");
        else eGui.removeAttribute("tabindex");
    }
    // floating filter calls this when user applies filter from floating filter
    onFloatingFilterChanged(type, value) {
        this.setTypeFromFloatingFilter(type);
        this.setValueFromFloatingFilter(value);
        this.onUiChanged("immediately", true);
    }
    setTypeFromFloatingFilter(type) {
        this.eTypes.forEach((eType, position)=>{
            const value = position === 0 ? type : this.optionsFactory.defaultOption;
            eType.setValue(value, true);
        });
    }
    getModelFromUi() {
        const conditions = this.getUiCompleteConditions();
        if (conditions.length === 0) return null;
        if (this.maxNumConditions > 1 && conditions.length > 1) return {
            filterType: this.filterType,
            operator: this.getJoinOperator(),
            conditions: conditions
        };
        return conditions[0];
    }
    getConditionTypes() {
        return this.eTypes.map((eType)=>eType.getValue());
    }
    getConditionType(position) {
        return this.eTypes[position].getValue();
    }
    getJoinOperator() {
        const { eJoinOrs: eJoinOperatorsOr, defaultJoinOperator: defaultJoinOperator } = this;
        return eJoinOperatorsOr.length === 0 ? defaultJoinOperator : eJoinOperatorsOr[0].getValue() === true ? "OR" : "AND";
    }
    areNonNullModelsEqual(a, b) {
        const aIsSimple = !a.operator;
        const bIsSimple = !b.operator;
        const oneSimpleOneCombined = !aIsSimple && bIsSimple || aIsSimple && !bIsSimple;
        if (oneSimpleOneCombined) return false;
        let res;
        if (aIsSimple) {
            const aSimple = a;
            const bSimple = b;
            res = this.areSimpleModelsEqual(aSimple, bSimple);
        } else {
            const aCombined = a;
            const bCombined = b;
            res = aCombined.operator === bCombined.operator && $437b23f6a393c3bf$export$893967cdb9833fdd(aCombined.conditions, bCombined.conditions, (aModel, bModel)=>this.areSimpleModelsEqual(aModel, bModel));
        }
        return res;
    }
    setModelIntoUi(model, isInitialLoad) {
        if (model == null) {
            this.resetUiToDefaults(isInitialLoad);
            return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        }
        const isCombined = model.operator;
        if (isCombined) {
            const combinedModel = model;
            let conditions = combinedModel.conditions;
            if (conditions == null) {
                conditions = [];
                $437b23f6a393c3bf$export$545083624300f13d(77);
            }
            const numConditions = $437b23f6a393c3bf$var$validateAndUpdateConditions(conditions, this.maxNumConditions);
            const numPrevConditions = this.getNumConditions();
            if (numConditions < numPrevConditions) this.removeConditionsAndOperators(numConditions);
            else if (numConditions > numPrevConditions) for(let i = numPrevConditions; i < numConditions; i++){
                this.createJoinOperatorPanel();
                this.createOption();
            }
            const orChecked = combinedModel.operator === "OR";
            this.eJoinAnds.forEach((eJoinOperatorAnd)=>eJoinOperatorAnd.setValue(!orChecked, true));
            this.eJoinOrs.forEach((eJoinOperatorOr)=>eJoinOperatorOr.setValue(orChecked, true));
            conditions.forEach((condition, position)=>{
                this.eTypes[position].setValue(condition.type, true);
                this.setConditionIntoUi(condition, position);
            });
        } else {
            const simpleModel = model;
            if (this.getNumConditions() > 1) this.removeConditionsAndOperators(1);
            this.eTypes[0].setValue(simpleModel.type, true);
            this.setConditionIntoUi(simpleModel, 0);
        }
        this.lastUiCompletePosition = this.getNumConditions() - 1;
        this.createMissingConditionsAndOperators();
        this.updateUiVisibility();
        if (!isInitialLoad) this.params.onUiChange(this.getUiChangeEventParams());
        return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    setNumConditions(params) {
        let maxNumConditions = params.maxNumConditions ?? 2;
        if (maxNumConditions < 1) {
            $437b23f6a393c3bf$export$545083624300f13d(79);
            maxNumConditions = 1;
        }
        this.maxNumConditions = maxNumConditions;
        let numAlwaysVisibleConditions = params.numAlwaysVisibleConditions ?? 1;
        if (numAlwaysVisibleConditions < 1) {
            $437b23f6a393c3bf$export$545083624300f13d(80);
            numAlwaysVisibleConditions = 1;
        }
        if (numAlwaysVisibleConditions > maxNumConditions) {
            $437b23f6a393c3bf$export$545083624300f13d(81);
            numAlwaysVisibleConditions = maxNumConditions;
        }
        this.numAlwaysVisibleConditions = numAlwaysVisibleConditions;
    }
    createOption() {
        const eGui = this.getGui();
        const eType = this.createManagedBean(new $437b23f6a393c3bf$export$6f9c460854d56032());
        this.eTypes.push(eType);
        eType.addCss("ag-filter-select");
        eGui.appendChild(eType.getGui());
        const eConditionBody = this.createEValue();
        this.eConditionBodies.push(eConditionBody);
        eGui.appendChild(eConditionBody);
        this.putOptionsIntoDropdown(eType);
        this.resetType(eType);
        const position = this.getNumConditions() - 1;
        this.forEachPositionInput(position, (element)=>this.resetInput(element));
        this.addChangedListeners(eType, position);
    }
    createJoinOperatorPanel() {
        const eJoinOperatorPanel = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-condition"
        });
        this.eJoinPanels.push(eJoinOperatorPanel);
        const eJoinOperatorAnd = this.createJoinOperator(this.eJoinAnds, eJoinOperatorPanel, "and");
        const eJoinOperatorOr = this.createJoinOperator(this.eJoinOrs, eJoinOperatorPanel, "or");
        this.getGui().appendChild(eJoinOperatorPanel);
        const index = this.eJoinPanels.length - 1;
        const uniqueGroupId = this.joinOperatorId++;
        this.resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId);
        this.resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId);
        if (!this.isReadOnly()) {
            eJoinOperatorAnd.onValueChange(this.listener);
            eJoinOperatorOr.onValueChange(this.listener);
        }
    }
    createJoinOperator(eJoinOperators, eJoinOperatorPanel, andOr) {
        const eJoinOperator = this.createManagedBean(new $437b23f6a393c3bf$export$5caa9ea96bbb722());
        eJoinOperators.push(eJoinOperator);
        const baseClass = "ag-filter-condition-operator";
        eJoinOperator.addCss(baseClass);
        eJoinOperator.addCss(`${baseClass}-${andOr}`);
        eJoinOperatorPanel.appendChild(eJoinOperator.getGui());
        return eJoinOperator;
    }
    createFilterListOptions() {
        this.filterListOptions = this.optionsFactory.filterOptions.map((option)=>typeof option === "string" ? this.createBoilerplateListOption(option) : this.createCustomListOption(option));
    }
    putOptionsIntoDropdown(eType) {
        const { filterListOptions: filterListOptions } = this;
        for (const listOption of filterListOptions)eType.addOption(listOption);
        eType.setDisabled(filterListOptions.length <= 1);
    }
    createBoilerplateListOption(option) {
        return {
            value: option,
            text: this.translate(option)
        };
    }
    createCustomListOption(option) {
        const { displayKey: displayKey } = option;
        const customOption = this.optionsFactory.getCustomOption(option.displayKey);
        return {
            value: displayKey,
            text: customOption ? this.getLocaleTextFunc()(customOption.displayKey, customOption.displayName) : this.translate(displayKey)
        };
    }
    createBodyTemplate() {
        return null;
    }
    getAgComponents() {
        return [];
    }
    updateUiVisibility() {
        const joinOperator = this.getJoinOperator();
        this.updateNumConditions();
        this.updateConditionStatusesAndValues(this.lastUiCompletePosition, joinOperator);
    }
    updateNumConditions() {
        let lastUiCompletePosition = -1;
        let areAllConditionsUiComplete = true;
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) lastUiCompletePosition = position;
        else areAllConditionsUiComplete = false;
        if (this.shouldAddNewConditionAtEnd(areAllConditionsUiComplete)) {
            this.createJoinOperatorPanel();
            this.createOption();
        } else {
            const activePosition = this.lastUiCompletePosition ?? this.getNumConditions() - 2;
            if (lastUiCompletePosition < activePosition) {
                this.removeConditionsAndOperators(activePosition + 1);
                const removeStartPosition = lastUiCompletePosition + 1;
                const numConditionsToRemove = activePosition - removeStartPosition;
                if (numConditionsToRemove > 0) this.removeConditionsAndOperators(removeStartPosition, numConditionsToRemove);
                this.createMissingConditionsAndOperators();
            }
        }
        this.lastUiCompletePosition = lastUiCompletePosition;
    }
    updateConditionStatusesAndValues(lastUiCompletePosition, joinOperator) {
        this.eTypes.forEach((eType, position)=>{
            const disabled = this.isConditionDisabled(position, lastUiCompletePosition);
            eType.setDisabled(disabled || this.filterListOptions.length <= 1);
            if (position === 1) {
                $437b23f6a393c3bf$export$b6b4f08392e9bfaf(this.eJoinPanels[0], disabled);
                this.eJoinAnds[0].setDisabled(disabled);
                this.eJoinOrs[0].setDisabled(disabled);
            }
        });
        this.eConditionBodies.forEach((element, index)=>{
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, this.isConditionBodyVisible(index));
        });
        const orChecked = (joinOperator ?? this.getJoinOperator()) === "OR";
        for (const eJoinOperatorAnd of this.eJoinAnds)eJoinOperatorAnd.setValue(!orChecked, true);
        for (const eJoinOperatorOr of this.eJoinOrs)eJoinOperatorOr.setValue(orChecked, true);
        this.forEachInput((element, index, position, numberOfInputs)=>{
            this.setElementDisplayed(element, index < numberOfInputs);
            this.setElementDisabled(element, this.isConditionDisabled(position, lastUiCompletePosition));
        });
        this.resetPlaceholder();
    }
    shouldAddNewConditionAtEnd(areAllConditionsUiComplete) {
        return areAllConditionsUiComplete && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
    }
    removeConditionsAndOperators(startPosition, deleteCount) {
        if (startPosition >= this.getNumConditions()) return;
        const { eTypes: eTypes, eConditionBodies: eConditionBodies, eJoinPanels: eJoinOperatorPanels, eJoinAnds: eJoinOperatorsAnd, eJoinOrs: eJoinOperatorsOr } = this;
        this.removeComponents(eTypes, startPosition, deleteCount);
        this.removeElements(eConditionBodies, startPosition, deleteCount);
        this.removeEValues(startPosition, deleteCount);
        const joinOperatorIndex = Math.max(startPosition - 1, 0);
        this.removeElements(eJoinOperatorPanels, joinOperatorIndex, deleteCount);
        this.removeComponents(eJoinOperatorsAnd, joinOperatorIndex, deleteCount);
        this.removeComponents(eJoinOperatorsOr, joinOperatorIndex, deleteCount);
    }
    removeElements(elements, startPosition, deleteCount) {
        const removedElements = $437b23f6a393c3bf$var$removeItems(elements, startPosition, deleteCount);
        for (const element of removedElements)$437b23f6a393c3bf$export$dd4d52e41fb4cef5(element);
    }
    removeComponents(components, startPosition, deleteCount) {
        const removedComponents = $437b23f6a393c3bf$var$removeItems(components, startPosition, deleteCount);
        for (const comp of removedComponents){
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(comp.getGui());
            this.destroyBean(comp);
        }
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.resetPlaceholder();
        if (!params?.suppressFocus) {
            let elementToFocus;
            if (!this.isReadOnly()) {
                const firstInput = this.getInputs(0)[0];
                if (firstInput instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3 && this.isConditionBodyVisible(0)) elementToFocus = firstInput.getInputElement();
                else elementToFocus = this.eTypes[0]?.getFocusableElement();
            }
            (elementToFocus ?? this.getGui()).focus({
                preventScroll: true
            });
        }
    }
    afterGuiDetached() {
        super.afterGuiDetached();
        const params = this.params;
        if (this.beans.colFilter?.shouldKeepStateOnDetach(params.column)) return;
        params.onStateChange({
            model: params.model
        });
        let lastUiCompletePosition = -1;
        let updatedLastUiCompletePosition = -1;
        let conditionsRemoved = false;
        const joinOperator = this.getJoinOperator();
        for(let position = this.getNumConditions() - 1; position >= 0; position--){
            if (this.isConditionUiComplete(position)) {
                if (lastUiCompletePosition === -1) {
                    lastUiCompletePosition = position;
                    updatedLastUiCompletePosition = position;
                }
            } else {
                const shouldRemovePositionAtEnd = position >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(position - 1);
                const positionBeforeLastUiCompletePosition = position < lastUiCompletePosition;
                if (shouldRemovePositionAtEnd || positionBeforeLastUiCompletePosition) {
                    this.removeConditionsAndOperators(position, 1);
                    conditionsRemoved = true;
                    if (positionBeforeLastUiCompletePosition) updatedLastUiCompletePosition--;
                }
            }
        }
        let shouldUpdateConditionStatusesAndValues = false;
        if (this.getNumConditions() < this.numAlwaysVisibleConditions) {
            this.createMissingConditionsAndOperators();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (this.shouldAddNewConditionAtEnd(updatedLastUiCompletePosition === this.getNumConditions() - 1)) {
            this.createJoinOperatorPanel();
            this.createOption();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (shouldUpdateConditionStatusesAndValues) this.updateConditionStatusesAndValues(updatedLastUiCompletePosition, joinOperator);
        if (conditionsRemoved) this.updateJoinOperatorsDisabled();
        this.lastUiCompletePosition = updatedLastUiCompletePosition;
    }
    getModelAsString(model) {
        return this.params.getHandler()?.getModelAsString?.(model) ?? "";
    }
    getPlaceholderText(defaultPlaceholder, position) {
        let placeholder = this.translate(defaultPlaceholder);
        if (typeof this.filterPlaceholder === "function") {
            const filterOptionKey = this.eTypes[position].getValue();
            const filterOption = this.translate(filterOptionKey);
            placeholder = this.filterPlaceholder({
                filterOptionKey: filterOptionKey,
                filterOption: filterOption,
                placeholder: placeholder
            });
        } else if (typeof this.filterPlaceholder === "string") placeholder = this.filterPlaceholder;
        return placeholder;
    }
    // allow sub-classes to reset HTML placeholders after UI update.
    resetPlaceholder() {
        const globalTranslate = this.getLocaleTextFunc();
        this.forEachInput((element, index, position, numberOfInputs)=>{
            if (!(element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3)) return;
            const placeholder = index === 0 && numberOfInputs > 1 ? "inRangeStart" : index === 0 ? "filterOoo" : "inRangeEnd";
            const ariaLabel = index === 0 && numberOfInputs > 1 ? globalTranslate("ariaFilterFromValue", "Filter from value") : index === 0 ? globalTranslate("ariaFilterValue", "Filter Value") : globalTranslate("ariaFilterToValue", "Filter to Value");
            element.setInputPlaceholder(this.getPlaceholderText(placeholder, position));
            element.setInputAriaLabel(ariaLabel);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setElementValue(element, value, fromFloatingFilter) {
        if (element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3) element.setValue(value != null ? String(value) : null, true);
    }
    setElementDisplayed(element, displayed) {
        if ($437b23f6a393c3bf$export$e9be47ed2688240e(element)) $437b23f6a393c3bf$export$9405f1cbb4e2383f(element.getGui(), displayed);
    }
    setElementDisabled(element, disabled) {
        if ($437b23f6a393c3bf$export$e9be47ed2688240e(element)) $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element.getGui(), disabled);
    }
    attachElementOnChange(element, listener) {
        if (element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3) element.onValueChange(listener);
    }
    forEachInput(cb) {
        this.getConditionTypes().forEach((type, position)=>{
            this.forEachPositionTypeInput(position, type, cb);
        });
    }
    forEachPositionInput(position, cb) {
        const type = this.getConditionType(position);
        this.forEachPositionTypeInput(position, type, cb);
    }
    forEachPositionTypeInput(position, type, cb) {
        const numberOfInputs = $437b23f6a393c3bf$var$getNumberOfInputs(type, this.optionsFactory);
        const inputs = this.getInputs(position);
        for(let index = 0; index < inputs.length; index++){
            const input = inputs[index];
            if (input != null) cb(input, index, position, numberOfInputs);
        }
    }
    isConditionDisabled(position, lastUiCompletePosition) {
        if (this.isReadOnly()) return true;
        if (position === 0) return false;
        return position > lastUiCompletePosition + 1;
    }
    isConditionBodyVisible(position) {
        const type = this.getConditionType(position);
        const numberOfInputs = $437b23f6a393c3bf$var$getNumberOfInputs(type, this.optionsFactory);
        return numberOfInputs > 0;
    }
    // returns true if the UI represents a working filter, eg all parts are filled out.
    // eg if text filter and textfield blank then returns false.
    isConditionUiComplete(position) {
        if (position >= this.getNumConditions()) return false;
        const type = this.getConditionType(position);
        if (type === "empty") return false;
        if (this.getValues(position).some((v)=>v == null)) return false;
        return true;
    }
    getNumConditions() {
        return this.eTypes.length;
    }
    getUiCompleteConditions() {
        const conditions = [];
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) conditions.push(this.createCondition(position));
        return conditions;
    }
    createMissingConditionsAndOperators() {
        if (this.isReadOnly()) return;
        for(let i = this.getNumConditions(); i < this.numAlwaysVisibleConditions; i++){
            this.createJoinOperatorPanel();
            this.createOption();
        }
    }
    resetUiToDefaults(silent) {
        this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions);
        this.eTypes.forEach((eType)=>this.resetType(eType));
        this.eJoinAnds.forEach((eJoinOperatorAnd, index)=>this.resetJoinOperatorAnd(eJoinOperatorAnd, index, this.joinOperatorId + index));
        this.eJoinOrs.forEach((eJoinOperatorOr, index)=>this.resetJoinOperatorOr(eJoinOperatorOr, index, this.joinOperatorId + index));
        this.joinOperatorId++;
        this.forEachInput((element)=>this.resetInput(element));
        this.resetPlaceholder();
        this.createMissingConditionsAndOperators();
        this.lastUiCompletePosition = null;
        this.updateUiVisibility();
        if (!silent) this.params.onUiChange(this.getUiChangeEventParams());
    }
    resetType(eType) {
        const translate = this.getLocaleTextFunc();
        const filteringLabel = translate("ariaFilteringOperator", "Filtering operator");
        eType.setValue(this.optionsFactory.defaultOption, true).setAriaLabel(filteringLabel).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
    }
    resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorAnd, index, this.defaultJoinOperator === "AND", this.translate("andCondition"), uniqueGroupId);
    }
    resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorOr, index, this.defaultJoinOperator === "OR", this.translate("orCondition"), uniqueGroupId);
    }
    resetJoinOperator(eJoinOperator, index, value, label, uniqueGroupId) {
        this.updateJoinOperatorDisabled(eJoinOperator.setValue(value, true).setName(`ag-simple-filter-and-or-${this.getCompId()}-${uniqueGroupId}`).setLabel(label), index);
    }
    updateJoinOperatorsDisabled() {
        const updater = (eJoinOperator, index)=>this.updateJoinOperatorDisabled(eJoinOperator, index);
        this.eJoinAnds.forEach(updater);
        this.eJoinOrs.forEach(updater);
    }
    updateJoinOperatorDisabled(eJoinOperator, index) {
        eJoinOperator.setDisabled(this.isReadOnly() || index > 0);
    }
    resetInput(element) {
        this.setElementValue(element, null);
        this.setElementDisabled(element, this.isReadOnly());
    }
    // puts model values into the UI
    setConditionIntoUi(model, position) {
        const values = this.mapValuesFromModel(model, this.optionsFactory);
        this.forEachInput((element, index, elPosition)=>{
            if (elPosition !== position) return;
            this.setElementValue(element, values[index] != null ? values[index] : null);
        });
    }
    // after floating filter changes, this sets the 'value' section. this is implemented by the base class
    // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
    setValueFromFloatingFilter(value) {
        this.forEachInput((element, index, position)=>{
            this.setElementValue(element, index === 0 && position === 0 ? value : null, true);
        });
    }
    addChangedListeners(eType, position) {
        if (this.isReadOnly()) return;
        eType.onValueChange(this.listener);
        this.forEachPositionInput(position, (element)=>{
            this.attachElementOnChange(element, this.listener);
        });
    }
    hasInvalidInputs() {
        return false;
    }
    isReadOnly() {
        return !!this.params.readOnly;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateCompWrapper.ts
var $437b23f6a393c3bf$var$DateCompWrapper = class {
    constructor(context, userCompFactory, colDef, dateComponentParams, eParent, onReady){
        this.alive = true;
        this.context = context;
        this.eParent = eParent;
        const compDetails = $437b23f6a393c3bf$var$_getDateCompDetails(userCompFactory, colDef, dateComponentParams);
        if (!compDetails) return;
        compDetails.newAgStackInstance().then((dateComp)=>{
            if (!this.alive) {
                context.destroyBean(dateComp);
                return;
            }
            this.dateComp = dateComp;
            if (!dateComp) return;
            eParent.appendChild(dateComp.getGui());
            dateComp?.afterGuiAttached?.();
            const { tempValue: tempValue, disabled: disabled } = this;
            if (tempValue) dateComp.setDate(tempValue);
            if (disabled != null) dateComp.setDisabled?.(disabled);
            onReady?.(this);
        });
    }
    destroy() {
        this.alive = false;
        this.dateComp = this.context.destroyBean(this.dateComp);
    }
    getDate() {
        return this.dateComp ? this.dateComp.getDate() : this.tempValue;
    }
    setDate(value) {
        const dateComp = this.dateComp;
        if (dateComp) dateComp.setDate(value);
        else this.tempValue = value;
    }
    setDisabled(disabled) {
        const dateComp = this.dateComp;
        if (dateComp) dateComp.setDisabled?.(disabled);
        else this.disabled = disabled;
    }
    setDisplayed(displayed) {
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eParent, displayed);
    }
    setInputPlaceholder(placeholder) {
        this.dateComp?.setInputPlaceholder?.(placeholder);
    }
    setInputAriaLabel(label) {
        this.dateComp?.setInputAriaLabel?.(label);
    }
    afterGuiAttached(params) {
        this.dateComp?.afterGuiAttached?.(params);
    }
    updateParams(params) {
        this.dateComp?.refresh?.(params);
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS = [
    "equals",
    "notEqual",
    "lessThan",
    "greaterThan",
    "inRange",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/date/dateFilterUtils.ts
function $437b23f6a393c3bf$var$mapValuesFromDateFilterModel(filterModel, optionsFactory) {
    const { dateFrom: dateFrom, dateTo: dateTo, type: type } = filterModel || {};
    return [
        dateFrom && $437b23f6a393c3bf$export$26ded2d88c01b527(dateFrom, void 0, true) || null,
        dateTo && $437b23f6a393c3bf$export$26ded2d88c01b527(dateTo, void 0, true) || null
    ].slice(0, $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory));
}
// packages/ag-grid-community/src/filter/provided/date/dateFilter.ts
var $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR = 1e3;
var $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR = Infinity;
var $437b23f6a393c3bf$var$DateFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    constructor(){
        super("dateFilter", $437b23f6a393c3bf$var$mapValuesFromDateFilterModel, $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS);
        this.eConditionPanelsFrom = [];
        this.eConditionPanelsTo = [];
        this.dateConditionFromComps = [];
        this.dateConditionToComps = [];
        this.minValidYear = $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR;
        this.maxValidYear = $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR;
        this.minValidDate = null;
        this.maxValidDate = null;
        this.filterType = "date";
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.dateConditionFromComps[0].afterGuiAttached(params);
    }
    commonUpdateSimpleParams(params) {
        super.commonUpdateSimpleParams(params);
        const yearParser = (param, fallback)=>{
            const value = params[param];
            if (value != null) {
                if (!isNaN(value)) return value == null ? fallback : Number(value);
                else $437b23f6a393c3bf$export$545083624300f13d(82, {
                    param: param
                });
            }
            return fallback;
        };
        const minValidYear = yearParser("minValidYear", $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR);
        const maxValidYear = yearParser("maxValidYear", $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR);
        this.minValidYear = minValidYear;
        this.maxValidYear = maxValidYear;
        if (minValidYear > maxValidYear) $437b23f6a393c3bf$export$545083624300f13d(83);
        const { minValidDate: minValidDate, maxValidDate: maxValidDate } = params;
        const parsedMinValidDate = minValidDate instanceof Date ? minValidDate : $437b23f6a393c3bf$export$26ded2d88c01b527(minValidDate);
        this.minValidDate = parsedMinValidDate;
        const parsedMaxValidDate = maxValidDate instanceof Date ? maxValidDate : $437b23f6a393c3bf$export$26ded2d88c01b527(maxValidDate);
        this.maxValidDate = parsedMaxValidDate;
        if (parsedMinValidDate && parsedMaxValidDate && parsedMinValidDate > parsedMaxValidDate) $437b23f6a393c3bf$export$545083624300f13d(84);
    }
    createDateCompWrapper(element) {
        const { beans: { userCompFactory: userCompFactory, context: context, gos: gos }, params: params } = this;
        const dateCompWrapper = new $437b23f6a393c3bf$var$DateCompWrapper(context, userCompFactory, params.colDef, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            onDateChanged: ()=>this.onUiChanged(),
            filterParams: params,
            location: "filter"
        }), element);
        this.addDestroyFunc(()=>dateCompWrapper.destroy());
        return dateCompWrapper;
    }
    setElementValue(element, value) {
        element.setDate(value);
    }
    setElementDisplayed(element, displayed) {
        element.setDisplayed(displayed);
    }
    setElementDisabled(element, disabled) {
        element.setDisabled(disabled);
    }
    createEValue() {
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body"
        });
        this.createFromToElement(eCondition, this.eConditionPanelsFrom, this.dateConditionFromComps, "from");
        this.createFromToElement(eCondition, this.eConditionPanelsTo, this.dateConditionToComps, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eConditionPanels, dateConditionComps, fromTo) {
        const eConditionPanel = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: `ag-filter-${fromTo} ag-filter-date-${fromTo}`
        });
        eConditionPanels.push(eConditionPanel);
        eCondition.appendChild(eConditionPanel);
        dateConditionComps.push(this.createDateCompWrapper(eConditionPanel));
    }
    removeEValues(startPosition, deleteCount) {
        this.removeDateComps(this.dateConditionFromComps, startPosition, deleteCount);
        this.removeDateComps(this.dateConditionToComps, startPosition, deleteCount);
        $437b23f6a393c3bf$var$removeItems(this.eConditionPanelsFrom, startPosition, deleteCount);
        $437b23f6a393c3bf$var$removeItems(this.eConditionPanelsTo, startPosition, deleteCount);
    }
    removeDateComps(components, startPosition, deleteCount) {
        const removedComponents = $437b23f6a393c3bf$var$removeItems(components, startPosition, deleteCount);
        for (const comp of removedComponents)comp.destroy();
    }
    isValidDateValue(value) {
        if (value === null) return false;
        const { minValidDate: minValidDate, maxValidDate: maxValidDate, minValidYear: minValidYear, maxValidYear: maxValidYear } = this;
        if (minValidDate) {
            if (value < minValidDate) return false;
        } else if (value.getUTCFullYear() < minValidYear) return false;
        if (maxValidDate) {
            if (value > maxValidDate) return false;
        } else if (value.getUTCFullYear() > maxValidYear) return false;
        return true;
    }
    isConditionUiComplete(position) {
        if (!super.isConditionUiComplete(position)) return false;
        let valid = true;
        this.forEachInput((element, index, elPosition, numberOfInputs)=>{
            if (elPosition !== position || !valid || index >= numberOfInputs) return;
            valid = valid && this.isValidDateValue(element.getDate());
        });
        return valid;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.dateFrom === bSimple.dateFrom && aSimple.dateTo === bSimple.dateTo && aSimple.type === bSimple.type;
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {};
        const values = this.getValues(position);
        const separator = this.params.useIsoSeparator ? "T" : " ";
        if (values.length > 0) model.dateFrom = $437b23f6a393c3bf$export$3d7fedfb21962874(values[0], true, separator);
        if (values.length > 1) model.dateTo = $437b23f6a393c3bf$export$3d7fedfb21962874(values[1], true, separator);
        return {
            dateFrom: null,
            dateTo: null,
            filterType: this.filterType,
            type: type,
            ...model
        };
    }
    resetPlaceholder() {
        const globalTranslate = this.getLocaleTextFunc();
        const placeholder = this.translate("dateFormatOoo");
        const ariaLabel = globalTranslate("ariaFilterValue", "Filter Value");
        this.forEachInput((element)=>{
            element.setInputPlaceholder(placeholder);
            element.setInputAriaLabel(ariaLabel);
        });
    }
    getInputs(position) {
        const { dateConditionFromComps: dateConditionFromComps, dateConditionToComps: dateConditionToComps } = this;
        if (position >= dateConditionFromComps.length) return [
            null,
            null
        ];
        return [
            dateConditionFromComps[position],
            dateConditionToComps[position]
        ];
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push(element.getDate());
        });
        return result;
    }
    translate(key) {
        if (key === "lessThan") return super.translate("before");
        if (key === "greaterThan") return super.translate("after");
        return super.translate(key);
    }
};
// packages/ag-grid-community/src/filter/provided/simpleFilterHandler.ts
var $437b23f6a393c3bf$var$SimpleFilterHandler = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(mapValuesFromModel, defaultOptions){
        super();
        this.mapValuesFromModel = mapValuesFromModel;
        this.defaultOptions = defaultOptions;
    }
    init(params) {
        const filterParams = params.filterParams;
        const optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory = optionsFactory;
        optionsFactory.init(filterParams, this.defaultOptions);
        this.filterModelFormatter = this.createManagedBean(new this.FilterModelFormatterClass(optionsFactory, filterParams));
        this.updateParams(params);
        this.validateModel(params);
    }
    refresh(params) {
        if (params.source === "colDef") {
            const filterParams = params.filterParams;
            const optionsFactory = this.optionsFactory;
            optionsFactory.refresh(filterParams, this.defaultOptions);
            this.filterModelFormatter.updateParams({
                optionsFactory: optionsFactory,
                filterParams: filterParams
            });
            this.updateParams(params);
        }
        this.validateModel(params);
    }
    updateParams(params) {
        this.params = params;
    }
    doesFilterPass(params) {
        const model = params.model;
        if (model == null) return true;
        const { operator: operator } = model;
        const models = [];
        if (operator) {
            const combinedModel = model;
            models.push(...combinedModel.conditions ?? []);
        } else models.push(model);
        const combineFunction = operator && operator === "OR" ? "some" : "every";
        const cellValue = this.params.getValue(params.node);
        return models[combineFunction]((m)=>this.individualConditionPasses(params, m, cellValue));
    }
    getModelAsString(model, source) {
        return this.filterModelFormatter.getModelAsString(model, source) ?? "";
    }
    validateModel(params) {
        const { model: model, filterParams: { filterOptions: filterOptions, maxNumConditions: maxNumConditions } } = params;
        if (model == null) return;
        const isCombined = $437b23f6a393c3bf$export$a3f343af66a0c1bd(model);
        let conditions = isCombined ? model.conditions : [
            model
        ];
        const newOptionsList = filterOptions?.map((option)=>typeof option === "string" ? option : option.displayKey) ?? this.defaultOptions;
        const allConditionsExistInNewOptionsList = !conditions || conditions.every((condition)=>newOptionsList.find((option)=>option === condition.type) !== void 0);
        if (!allConditionsExistInNewOptionsList) {
            this.params = {
                ...params,
                model: null
            };
            params.onModelChange(null);
            return;
        }
        let needsUpdate = false;
        const filterType = this.filterType;
        if (conditions && !conditions.every((condition)=>condition.filterType === filterType) || model.filterType !== filterType) {
            conditions = conditions.map((condition)=>({
                    ...condition,
                    filterType: filterType
                }));
            needsUpdate = true;
        }
        if (typeof maxNumConditions === "number" && conditions && conditions.length > maxNumConditions) {
            conditions = conditions.slice(0, maxNumConditions);
            needsUpdate = true;
        }
        if (needsUpdate) {
            const updatedModel = conditions.length > 1 ? {
                ...model,
                filterType: filterType,
                conditions: conditions
            } : {
                ...conditions[0],
                filterType: filterType
            };
            this.params = {
                ...params,
                model: updatedModel
            };
            params.onModelChange(updatedModel);
        }
    }
    /** returns true if the row passes the said condition */ individualConditionPasses(params, filterModel, cellValue) {
        const optionsFactory = this.optionsFactory;
        const values = this.mapValuesFromModel(filterModel, optionsFactory);
        const customFilterOption = optionsFactory.getCustomOption(filterModel.type);
        const customFilterResult = $437b23f6a393c3bf$var$evaluateCustomFilter(customFilterOption, values, cellValue);
        if (customFilterResult != null) return customFilterResult;
        if (cellValue == null) return this.evaluateNullValue(filterModel.type);
        return this.evaluateNonNullValue(values, cellValue, filterModel, params);
    }
};
// packages/ag-grid-community/src/filter/provided/scalarFilterHandler.ts
var $437b23f6a393c3bf$var$ScalarFilterHandler = class extends $437b23f6a393c3bf$var$SimpleFilterHandler {
    evaluateNullValue(filterType) {
        const { includeBlanksInEquals: includeBlanksInEquals, includeBlanksInNotEqual: includeBlanksInNotEqual, includeBlanksInGreaterThan: includeBlanksInGreaterThan, includeBlanksInLessThan: includeBlanksInLessThan, includeBlanksInRange: includeBlanksInRange } = this.params.filterParams;
        switch(filterType){
            case "equals":
                if (includeBlanksInEquals) return true;
                break;
            case "notEqual":
                if (includeBlanksInNotEqual) return true;
                break;
            case "greaterThan":
            case "greaterThanOrEqual":
                if (includeBlanksInGreaterThan) return true;
                break;
            case "lessThan":
            case "lessThanOrEqual":
                if (includeBlanksInLessThan) return true;
                break;
            case "inRange":
                if (includeBlanksInRange) return true;
                break;
            case "blank":
                return true;
            case "notBlank":
                return false;
        }
        return false;
    }
    evaluateNonNullValue(values, cellValue, filterModel) {
        const type = filterModel.type;
        if (!this.isValid(cellValue)) return type === "notEqual" || type === "notBlank";
        const comparator = this.comparator();
        const compareResult = values[0] != null ? comparator(values[0], cellValue) : 0;
        switch(type){
            case "equals":
                return compareResult === 0;
            case "notEqual":
                return compareResult !== 0;
            case "greaterThan":
                return compareResult > 0;
            case "greaterThanOrEqual":
                return compareResult >= 0;
            case "lessThan":
                return compareResult < 0;
            case "lessThanOrEqual":
                return compareResult <= 0;
            case "inRange":
                {
                    const compareToResult = comparator(values[1], cellValue);
                    return this.params.filterParams.inRangeInclusive ? compareResult >= 0 && compareToResult <= 0 : compareResult > 0 && compareToResult < 0;
                }
            case "blank":
                return $437b23f6a393c3bf$var$isBlank(cellValue);
            case "notBlank":
                return !$437b23f6a393c3bf$var$isBlank(cellValue);
            default:
                $437b23f6a393c3bf$export$545083624300f13d(76, {
                    filterModelType: type
                });
                return true;
        }
    }
};
// packages/ag-grid-community/src/filter/provided/simpleFilterModelFormatter.ts
var $437b23f6a393c3bf$var$SCALAR_FILTER_TYPE_KEYS = {
    equals: "Equals",
    notEqual: "NotEqual",
    greaterThan: "GreaterThan",
    greaterThanOrEqual: "GreaterThanOrEqual",
    lessThan: "LessThan",
    lessThanOrEqual: "LessThanOrEqual",
    inRange: "InRange"
};
var $437b23f6a393c3bf$var$TEXT_FILTER_TYPE_KEYS = {
    contains: "Contains",
    notContains: "NotContains",
    equals: "TextEquals",
    notEqual: "TextNotEqual",
    startsWith: "StartsWith",
    endsWith: "EndsWith",
    inRange: "InRange"
};
var $437b23f6a393c3bf$var$SimpleFilterModelFormatter = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(optionsFactory, filterParams, valueFormatter){
        super();
        this.optionsFactory = optionsFactory;
        this.filterParams = filterParams;
        this.valueFormatter = valueFormatter;
    }
    // used by:
    // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
    // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
    getModelAsString(model, source) {
        const translate = this.getLocaleTextFunc();
        const forToolPanel = source === "filterToolPanel";
        if (!model) return forToolPanel ? $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, "filterSummaryInactive") : null;
        const isCombined = model.operator != null;
        if (isCombined) {
            const combinedModel = model;
            const conditions = combinedModel.conditions ?? [];
            const customOptions = conditions.map((condition)=>this.getModelAsString(condition, source));
            const joinOperatorTranslateKey = combinedModel.operator === "AND" ? "andCondition" : "orCondition";
            return customOptions.join(` ${$437b23f6a393c3bf$export$e2a0ae4af921fff8(this, joinOperatorTranslateKey)} `);
        } else if (model.type === "blank" || model.type === "notBlank") return forToolPanel ? $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, model.type === "blank" ? "filterSummaryBlank" : "filterSummaryNotBlank") : translate(model.type, model.type);
        else {
            const condition = model;
            const customOption = this.optionsFactory.getCustomOption(condition.type);
            const { displayKey: displayKey, displayName: displayName, numberOfInputs: numberOfInputs } = customOption || {};
            if (displayKey && displayName && numberOfInputs === 0) return translate(displayKey, displayName);
            return this.conditionToString(condition, forToolPanel, condition.type === "inRange" || numberOfInputs === 2, displayKey, displayName);
        }
    }
    updateParams(params) {
        const { optionsFactory: optionsFactory, filterParams: filterParams } = params;
        this.optionsFactory = optionsFactory;
        this.filterParams = filterParams;
    }
    conditionForToolPanel(type, isRange, getFilter, getFilterTo, customDisplayKey, customDisplayName) {
        let typeValue;
        const typeKey = this.getTypeKey(type);
        if (typeKey) typeValue = $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, typeKey);
        if (customDisplayKey && customDisplayName) typeValue = this.getLocaleTextFunc()(customDisplayKey, customDisplayName);
        if (typeValue != null) {
            if (isRange) return `${typeValue} ${$437b23f6a393c3bf$export$e2a0ae4af921fff8(this, "filterSummaryInRangeValues", [
                getFilter(),
                getFilterTo()
            ])}`;
            else return `${typeValue} ${getFilter()}`;
        }
        return null;
    }
    getTypeKey(type) {
        const suffix = this.filterTypeKeys[type];
        return suffix ? `filterSummary${suffix}` : null;
    }
    formatValue(value) {
        const valueFormatter = this.valueFormatter;
        return valueFormatter ? valueFormatter(value ?? null) ?? "" : String(value);
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilterModelFormatter.ts
var $437b23f6a393c3bf$var$DateFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(optionsFactory, filterParams){
        super(optionsFactory, filterParams, (value)=>{
            const { dataTypeSvc: dataTypeSvc, valueSvc: valueSvc } = this.beans;
            const column = filterParams.column;
            const dateFormatFn = dataTypeSvc?.getDateFormatterFunction(column);
            const valueToFormat = dateFormatFn ? dateFormatFn(value ?? void 0) : value;
            return valueSvc.formatValue(column, null, valueToFormat);
        });
        this.filterTypeKeys = $437b23f6a393c3bf$var$SCALAR_FILTER_TYPE_KEYS;
    }
    conditionToString(condition, forToolPanel, isRange, customDisplayKey, customDisplayName) {
        const { type: type } = condition;
        const dateFrom = $437b23f6a393c3bf$export$26ded2d88c01b527(condition.dateFrom);
        const dateTo = $437b23f6a393c3bf$export$26ded2d88c01b527(condition.dateTo);
        const format = this.filterParams.inRangeFloatingFilterDateFormat;
        const formatDate = forToolPanel ? this.formatValue.bind(this) : (value)=>$437b23f6a393c3bf$var$_dateToFormattedString(value, format);
        const formattedFrom = ()=>dateFrom !== null ? formatDate(dateFrom) : "null";
        const formattedTo = ()=>dateTo !== null ? formatDate(dateTo) : "null";
        if (forToolPanel) {
            const valueForToolPanel = this.conditionForToolPanel(type, isRange, formattedFrom, formattedTo, customDisplayKey, customDisplayName);
            if (valueForToolPanel != null) return valueForToolPanel;
        }
        if (isRange) return `${formattedFrom()}-${formattedTo()}`;
        if (dateFrom != null) return formatDate(dateFrom);
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilterHandler.ts
function $437b23f6a393c3bf$var$defaultDateComparator(filterDate, cellValue) {
    const cellAsDate = cellValue;
    if (cellAsDate < filterDate) return -1;
    if (cellAsDate > filterDate) return 1;
    return 0;
}
var $437b23f6a393c3bf$var$DateFilterHandler = class extends $437b23f6a393c3bf$var$ScalarFilterHandler {
    constructor(){
        super($437b23f6a393c3bf$var$mapValuesFromDateFilterModel, $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS);
        this.filterType = "date";
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$DateFilterModelFormatter;
    }
    comparator() {
        return this.params.filterParams.comparator ?? $437b23f6a393c3bf$var$defaultDateComparator;
    }
    isValid(value) {
        const isValidDate2 = this.params.filterParams.isValidDate;
        return !isValidDate2 || isValidDate2(value);
    }
};
// packages/ag-grid-community/src/filter/floating/provided/simpleFloatingFilter.ts
var $437b23f6a393c3bf$var$SimpleFloatingFilter = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        this.defaultDebounceMs = 0;
    }
    setLastTypeFromModel(model) {
        if (!model) {
            this.lastType = this.optionsFactory.defaultOption;
            return;
        }
        const isCombined = model.operator;
        let condition;
        if (isCombined) {
            const combinedModel = model;
            condition = combinedModel.conditions[0];
        } else condition = model;
        this.lastType = condition.type;
    }
    canWeEditAfterModelFromParentFilter(model) {
        if (!model) return this.isTypeEditable(this.lastType);
        const isCombined = model.operator;
        if (isCombined) return false;
        const simpleModel = model;
        return this.isTypeEditable(simpleModel.type);
    }
    init(params) {
        this.params = params;
        const reactive = this.gos.get("enableFilterHandlers");
        this.reactive = reactive;
        this.setParams(params);
        if (reactive) {
            const reactiveParams = params;
            this.onModelUpdated(reactiveParams.model);
        }
    }
    setParams(params) {
        const optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory = optionsFactory;
        optionsFactory.init(params.filterParams, this.defaultOptions);
        this.filterModelFormatter = this.createManagedBean(new this.FilterModelFormatterClass(optionsFactory, params.filterParams));
        this.setSimpleParams(params, false);
    }
    setSimpleParams(params, update = true) {
        const defaultOption = this.optionsFactory.defaultOption;
        if (!update) this.lastType = defaultOption;
        this.readOnly = !!params.filterParams.readOnly;
        const editable = this.isTypeEditable(defaultOption);
        this.setEditable(editable);
    }
    refresh(params) {
        this.params = params;
        const reactiveParams = params;
        const reactive = this.reactive;
        if (!reactive || reactiveParams.source === "colDef") this.updateParams(params);
        if (reactive) {
            const { source: source, model: model } = reactiveParams;
            if (source === "dataChanged" || source === "ui") return;
            this.onModelUpdated(model);
        }
    }
    updateParams(params) {
        const optionsFactory = this.optionsFactory;
        optionsFactory.refresh(params.filterParams, this.defaultOptions);
        this.setSimpleParams(params);
        this.filterModelFormatter.updateParams({
            optionsFactory: optionsFactory,
            filterParams: params.filterParams
        });
    }
    onParentModelChanged(model, event) {
        if (event?.afterFloatingFilter || event?.afterDataChange) return;
        this.onModelUpdated(model);
    }
    hasSingleInput(filterType) {
        const numberOfInputs = this.optionsFactory.getCustomOption(filterType)?.numberOfInputs;
        return numberOfInputs == null || numberOfInputs == 1;
    }
    isTypeEditable(type) {
        const uneditableTypes = [
            "inRange",
            "empty",
            "blank",
            "notBlank"
        ];
        return !!type && !this.readOnly && this.hasSingleInput(type) && uneditableTypes.indexOf(type) < 0;
    }
    getAriaLabel(params) {
        const displayName = this.beans.colNames.getDisplayNameForColumn(params.column, "header", true);
        return `${displayName} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFloatingFilter.ts
var $437b23f6a393c3bf$var$DateFloatingFilterElement = {
    tag: "div",
    cls: "ag-floating-filter-input",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eReadOnlyText"
        },
        {
            tag: "div",
            ref: "eDateWrapper",
            cls: "ag-date-floating-filter-wrapper"
        }
    ]
};
var $437b23f6a393c3bf$var$DateFloatingFilter = class extends $437b23f6a393c3bf$var$SimpleFloatingFilter {
    constructor(){
        super($437b23f6a393c3bf$var$DateFloatingFilterElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eReadOnlyText = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDateWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$DateFilterModelFormatter;
        this.filterType = "date";
        this.defaultOptions = $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS;
    }
    setParams(params) {
        super.setParams(params);
        this.createDateComponent();
        const translate = this.getLocaleTextFunc();
        this.eReadOnlyText.setDisabled(true).setInputAriaLabel(translate("ariaDateFilterInput", "Date Filter Input"));
    }
    updateParams(params) {
        super.updateParams(params);
        this.dateComp.updateParams(this.getDateComponentParams());
        this.updateCompOnModelChange(params.currentParentModel());
    }
    updateCompOnModelChange(model) {
        const allowEditing = !this.readOnly && this.canWeEditAfterModelFromParentFilter(model);
        this.setEditable(allowEditing);
        if (allowEditing) {
            const dateModel = model ? $437b23f6a393c3bf$export$26ded2d88c01b527(model.dateFrom) : null;
            this.dateComp.setDate(dateModel);
            this.eReadOnlyText.setValue("");
        } else {
            this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(model));
            this.dateComp.setDate(null);
        }
    }
    setEditable(editable) {
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eDateWrapper, editable);
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eReadOnlyText.getGui(), !editable);
    }
    onModelUpdated(model) {
        super.setLastTypeFromModel(model);
        this.updateCompOnModelChange(model);
    }
    onDateChanged() {
        const filterValueDate = this.dateComp.getDate();
        if (this.reactive) {
            const reactiveParams = this.params;
            reactiveParams.onUiChange();
            const model = reactiveParams.model;
            const filterValueText = $437b23f6a393c3bf$export$3d7fedfb21962874(filterValueDate);
            const newModel = filterValueText == null ? null : {
                ...model ?? {
                    filterType: this.filterType,
                    type: this.lastType ?? this.optionsFactory.defaultOption
                },
                dateFrom: filterValueText
            };
            reactiveParams.onModelChange(newModel, {
                afterFloatingFilter: true
            });
        } else this.params.parentFilterInstance((filterInstance)=>{
            filterInstance?.onFloatingFilterChanged(this.lastType || null, filterValueDate);
        });
    }
    getDateComponentParams() {
        const { filterParams: filterParams } = this.params;
        const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(filterParams, this.defaultDebounceMs);
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            onDateChanged: $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onDateChanged.bind(this), debounceMs),
            filterParams: filterParams,
            location: "floatingFilter"
        });
    }
    createDateComponent() {
        const { beans: { context: context, userCompFactory: userCompFactory }, eDateWrapper: eDateWrapper, params: params } = this;
        this.dateComp = new $437b23f6a393c3bf$var$DateCompWrapper(context, userCompFactory, params.column.getColDef(), this.getDateComponentParams(), eDateWrapper, (dateComp)=>{
            dateComp.setInputAriaLabel(this.getAriaLabel(params));
        });
        this.addDestroyFunc(()=>this.dateComp.destroy());
    }
};
// packages/ag-grid-community/src/filter/provided/date/defaultDateComponent.ts
var $437b23f6a393c3bf$var$DefaultDateElement = {
    tag: "div",
    cls: "ag-filter-filter",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eDateInput",
            cls: "ag-date-filter"
        }
    ]
};
var $437b23f6a393c3bf$var$DefaultDateComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$DefaultDateElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eDateInput = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isApply = false;
        this.applyOnFocusOut = false;
    }
    init(params) {
        this.params = params;
        this.setParams(params);
        const inputElement = this.eDateInput.getInputElement();
        this.addManagedListeners(inputElement, {
            // ensures that the input element is focussed when a clear button is clicked,
            // unless using safari as there is no clear button and focus does not work properly
            mouseDown: ()=>{
                if (this.eDateInput.isDisabled() || this.usingSafariDatePicker) return;
                inputElement.focus({
                    preventScroll: true
                });
            },
            input: this.handleInput.bind(this, false),
            change: this.handleInput.bind(this, true),
            focusout: this.handleFocusOut.bind(this)
        });
    }
    handleInput(isChange) {
        if (this.eDateInput.isDisabled()) return;
        if (this.isApply) {
            this.applyOnFocusOut = !isChange;
            if (isChange) this.params.onDateChanged();
            return;
        }
        if (!isChange) this.params.onDateChanged();
    }
    handleFocusOut() {
        if (this.applyOnFocusOut) {
            this.applyOnFocusOut = false;
            this.params.onDateChanged();
        }
    }
    setParams(params) {
        const inputElement = this.eDateInput.getInputElement();
        const shouldUseBrowserDatePicker = this.shouldUseBrowserDatePicker(params);
        this.usingSafariDatePicker = shouldUseBrowserDatePicker && $437b23f6a393c3bf$export$8caf403dacd36a68();
        const { minValidYear: minValidYear, maxValidYear: maxValidYear, minValidDate: minValidDate, maxValidDate: maxValidDate, buttons: buttons, includeTime: includeTime, colDef: colDef } = params.filterParams || {};
        const dataTypeSvc = this.beans.dataTypeSvc;
        const shouldUseDateTimeLocal = includeTime ?? dataTypeSvc?.getDateIncludesTimeFlag?.(colDef.cellDataType) ?? false;
        if (shouldUseBrowserDatePicker) {
            if (shouldUseDateTimeLocal) {
                inputElement.type = "datetime-local";
                inputElement.step = "1";
            } else inputElement.type = "date";
        } else inputElement.type = "text";
        if (minValidDate && minValidYear) $437b23f6a393c3bf$export$545083624300f13d(85);
        if (maxValidDate && maxValidYear) $437b23f6a393c3bf$export$545083624300f13d(86);
        if (minValidDate && maxValidDate) {
            const [parsedMinValidDate, parsedMaxValidDate] = [
                minValidDate,
                maxValidDate
            ].map((v)=>v instanceof Date ? v : $437b23f6a393c3bf$export$26ded2d88c01b527(v));
            if (parsedMinValidDate && parsedMaxValidDate && parsedMinValidDate.getTime() > parsedMaxValidDate.getTime()) $437b23f6a393c3bf$export$545083624300f13d(87);
        }
        if (minValidDate) {
            if (minValidDate instanceof Date) inputElement.min = $437b23f6a393c3bf$var$_dateToFormattedString(minValidDate);
            else inputElement.min = minValidDate;
        } else if (minValidYear) inputElement.min = `${minValidYear}-01-01`;
        if (maxValidDate) {
            if (maxValidDate instanceof Date) inputElement.max = $437b23f6a393c3bf$var$_dateToFormattedString(maxValidDate);
            else inputElement.max = maxValidDate;
        } else if (maxValidYear) inputElement.max = `${maxValidYear}-12-31`;
        this.isApply = params.location === "floatingFilter" && !!buttons?.includes("apply");
    }
    refresh(params) {
        this.params = params;
        this.setParams(params);
    }
    getDate() {
        return $437b23f6a393c3bf$export$26ded2d88c01b527(this.eDateInput.getValue());
    }
    setDate(date) {
        const colType = this.params.filterParams.colDef.cellDataType;
        const includeTime = this.beans.dataTypeSvc?.getDateIncludesTimeFlag(colType) ?? false;
        this.eDateInput.setValue($437b23f6a393c3bf$export$3d7fedfb21962874(date, includeTime));
    }
    setInputPlaceholder(placeholder) {
        this.eDateInput.setInputPlaceholder(placeholder);
    }
    setInputAriaLabel(ariaLabel) {
        this.eDateInput.setAriaLabel(ariaLabel);
    }
    setDisabled(disabled) {
        this.eDateInput.setDisabled(disabled);
    }
    afterGuiAttached(params) {
        if (!params?.suppressFocus) this.eDateInput.getInputElement().focus({
            preventScroll: true
        });
    }
    shouldUseBrowserDatePicker(params) {
        return params?.filterParams?.browserDatePicker ?? true;
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS = [
    "equals",
    "notEqual",
    "greaterThan",
    "greaterThanOrEqual",
    "lessThan",
    "lessThanOrEqual",
    "inRange",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/number/numberFilterUtils.ts
function $437b23f6a393c3bf$var$getAllowedCharPattern(filterParams) {
    const { allowedCharPattern: allowedCharPattern } = filterParams ?? {};
    return allowedCharPattern ?? null;
}
function $437b23f6a393c3bf$var$processNumberFilterValue(value) {
    if (value == null) return null;
    return isNaN(value) ? null : value;
}
function $437b23f6a393c3bf$var$mapValuesFromNumberFilterModel(filterModel, optionsFactory) {
    const { filter: filter, filterTo: filterTo, type: type } = filterModel || {};
    return [
        $437b23f6a393c3bf$var$processNumberFilterValue(filter),
        $437b23f6a393c3bf$var$processNumberFilterValue(filterTo)
    ].slice(0, $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory));
}
// packages/ag-grid-community/src/filter/provided/number/numberFilter.ts
var $437b23f6a393c3bf$var$NumberFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    constructor(){
        super("numberFilter", $437b23f6a393c3bf$var$mapValuesFromNumberFilterModel, $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS);
        this.eValuesFrom = [];
        this.eValuesTo = [];
        this.filterType = "number";
        this.defaultDebounceMs = 500;
    }
    setElementValue(element, value, fromFloatingFilter) {
        const { numberFormatter: numberFormatter } = this.params;
        const valueToSet = !fromFloatingFilter && numberFormatter ? numberFormatter(value ?? null) : value;
        super.setElementValue(element, valueToSet);
    }
    createEValue() {
        const allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(this.params);
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body",
            role: "presentation"
        });
        this.createFromToElement(eCondition, this.eValuesFrom, "from", allowedCharPattern);
        this.createFromToElement(eCondition, this.eValuesTo, "to", allowedCharPattern);
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo, allowedCharPattern) {
        const eValue = this.createManagedBean(allowedCharPattern ? new $437b23f6a393c3bf$export$8c027679838afd47({
            allowedCharPattern: allowedCharPattern
        }) : new $437b23f6a393c3bf$export$c8aa0be99738aee());
        eValue.addCss(`ag-filter-${fromTo}`);
        eValue.addCss("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeEValues(startPosition, deleteCount) {
        const removeComps = (eGui)=>this.removeComponents(eGui, startPosition, deleteCount);
        removeComps(this.eValuesFrom);
        removeComps(this.eValuesTo);
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push($437b23f6a393c3bf$var$processNumberFilterValue(this.stringToFloat(element.getValue())));
        });
        return result;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    stringToFloat(value) {
        if (typeof value === "number") return value;
        let filterText = $437b23f6a393c3bf$export$4978424c4f7b5fc0(value);
        if (filterText != null && filterText.trim() === "") filterText = null;
        const numberParser = this.params.numberParser;
        if (numberParser) return numberParser(filterText);
        return filterText == null || filterText.trim() === "-" ? null : Number.parseFloat(filterText);
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.filterType,
            type: type
        };
        const values = this.getValues(position);
        if (values.length > 0) model.filter = values[0];
        if (values.length > 1) model.filterTo = values[1];
        return model;
    }
    getInputs(position) {
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        if (position >= eValuesFrom.length) return [
            null,
            null
        ];
        return [
            eValuesFrom[position],
            eValuesTo[position]
        ];
    }
    hasInvalidInputs() {
        let invalidInputs = false;
        this.forEachInput((element)=>{
            if (!element.getInputElement().validity.valid) invalidInputs = true;
        });
        return invalidInputs;
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFilterModelFormatter.ts
var $437b23f6a393c3bf$var$NumberFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(optionsFactory, filterParams){
        super(optionsFactory, filterParams, filterParams.numberFormatter);
        this.filterTypeKeys = $437b23f6a393c3bf$var$SCALAR_FILTER_TYPE_KEYS;
    }
    conditionToString(condition, forToolPanel, isRange, customDisplayKey, customDisplayName) {
        const { filter: filter, filterTo: filterTo, type: type } = condition;
        const formatValue = this.formatValue.bind(this);
        if (forToolPanel) {
            const valueForToolPanel = this.conditionForToolPanel(type, isRange, ()=>formatValue(filter), ()=>formatValue(filterTo), customDisplayKey, customDisplayName);
            if (valueForToolPanel != null) return valueForToolPanel;
        }
        if (isRange) return `${formatValue(filter)}-${formatValue(filterTo)}`;
        if (filter != null) return formatValue(filter);
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFilterHandler.ts
var $437b23f6a393c3bf$var$NumberFilterHandler = class extends $437b23f6a393c3bf$var$ScalarFilterHandler {
    constructor(){
        super($437b23f6a393c3bf$var$mapValuesFromNumberFilterModel, $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS);
        this.filterType = "number";
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$NumberFilterModelFormatter;
    }
    comparator() {
        return (left, right)=>{
            if (left === right) return 0;
            return left < right ? 1 : -1;
        };
    }
    isValid(value) {
        return !isNaN(value);
    }
};
// packages/ag-grid-community/src/filter/floating/provided/floatingFilterTextInputService.ts
var $437b23f6a393c3bf$var$FloatingFilterTextInputService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.params = params;
        this.eInput = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.onValueChanged = ()=>{};
    }
    setupGui(parentElement) {
        this.eInput = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47(this.params?.config));
        const eInput = this.eInput.getGui();
        parentElement.appendChild(eInput);
        const listener = (e)=>this.onValueChanged(e);
        this.addManagedListeners(eInput, {
            input: listener,
            keydown: listener
        });
    }
    setEditable(editable) {
        this.eInput.setDisabled(!editable);
    }
    getValue() {
        return this.eInput.getValue();
    }
    setValue(value, silent) {
        this.eInput.setValue(value, silent);
    }
    setValueChangedListener(listener) {
        this.onValueChanged = listener;
    }
    setParams({ ariaLabel: ariaLabel, autoComplete: autoComplete }) {
        const { eInput: eInput } = this;
        eInput.setInputAriaLabel(ariaLabel);
        if (autoComplete !== void 0) eInput.setAutoComplete(autoComplete);
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterUtils.ts
function $437b23f6a393c3bf$var$trimInputForFilter(value) {
    const trimmedInput = value?.trim();
    return trimmedInput === "" ? value : trimmedInput;
}
function $437b23f6a393c3bf$var$mapValuesFromTextFilterModel(filterModel, optionsFactory) {
    const { filter: filter, filterTo: filterTo, type: type } = filterModel || {};
    return [
        filter || null,
        filterTo || null
    ].slice(0, $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory));
}
// packages/ag-grid-community/src/filter/floating/provided/textInputFloatingFilter.ts
var $437b23f6a393c3bf$var$TextInputFloatingFilterElement = {
    tag: "div",
    ref: "eFloatingFilterInputContainer",
    cls: "ag-floating-filter-input",
    role: "presentation"
};
var $437b23f6a393c3bf$var$TextInputFloatingFilter = class extends $437b23f6a393c3bf$var$SimpleFloatingFilter {
    constructor(){
        super(...arguments);
        this.eFloatingFilterInputContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.defaultDebounceMs = 500;
    }
    postConstruct() {
        this.setTemplate($437b23f6a393c3bf$var$TextInputFloatingFilterElement);
    }
    onModelUpdated(model) {
        this.setLastTypeFromModel(model);
        this.setEditable(this.canWeEditAfterModelFromParentFilter(model));
        this.inputSvc.setValue(this.filterModelFormatter.getModelAsString(model));
    }
    setParams(params) {
        this.setupFloatingFilterInputService(params);
        super.setParams(params);
        this.setTextInputParams(params);
    }
    setupFloatingFilterInputService(params) {
        this.inputSvc = this.createFloatingFilterInputService(params);
        this.inputSvc.setupGui(this.eFloatingFilterInputContainer);
    }
    setTextInputParams(params) {
        const autoComplete = params.browserAutoComplete ?? false;
        const { inputSvc: inputSvc, defaultDebounceMs: defaultDebounceMs, readOnly: readOnly } = this;
        inputSvc.setParams({
            ariaLabel: this.getAriaLabel(params),
            autoComplete: autoComplete
        });
        this.applyActive = $437b23f6a393c3bf$export$527c1b777ebd9069(params.filterParams);
        if (!readOnly) {
            const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(params.filterParams, defaultDebounceMs);
            const toDebounce = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.syncUpWithParentFilter.bind(this), debounceMs);
            inputSvc.setValueChangedListener(toDebounce);
        }
    }
    updateParams(params) {
        super.updateParams(params);
        this.setTextInputParams(params);
    }
    recreateFloatingFilterInputService(params) {
        const { inputSvc: inputSvc } = this;
        const value = inputSvc.getValue();
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eFloatingFilterInputContainer);
        this.destroyBean(inputSvc);
        this.setupFloatingFilterInputService(params);
        inputSvc.setValue(value, true);
    }
    syncUpWithParentFilter(e) {
        const isEnterKey = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
        const reactive = this.reactive;
        if (reactive) {
            const reactiveParams = this.params;
            reactiveParams.onUiChange();
        }
        if (this.applyActive && !isEnterKey) return;
        const { inputSvc: inputSvc, params: params, lastType: lastType } = this;
        let value = inputSvc.getValue();
        if (params.filterParams.trimInput) {
            value = $437b23f6a393c3bf$var$trimInputForFilter(value);
            inputSvc.setValue(value, true);
        }
        if (reactive) {
            const reactiveParams = params;
            const model = reactiveParams.model;
            const parsedValue = this.convertValue(value);
            const newModel = parsedValue == null ? null : {
                ...model ?? {
                    filterType: this.filterType,
                    type: lastType ?? this.optionsFactory.defaultOption
                },
                filter: parsedValue
            };
            reactiveParams.onModelChange(newModel, {
                afterFloatingFilter: true
            });
        } else params.parentFilterInstance((filterInstance)=>{
            filterInstance?.onFloatingFilterChanged(lastType || null, value || null);
        });
    }
    convertValue(value) {
        return value || null;
    }
    setEditable(editable) {
        this.inputSvc.setEditable(editable);
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFloatingFilter.ts
var $437b23f6a393c3bf$var$FloatingFilterNumberInputService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.onValueChanged = ()=>{};
        this.numberInputActive = true;
    }
    setupGui(parentElement) {
        this.eNumberInput = this.createManagedBean(new $437b23f6a393c3bf$export$c8aa0be99738aee());
        this.eTextInput = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47());
        this.eTextInput.setDisabled(true);
        const eNumberInput = this.eNumberInput.getGui();
        const eTextInput = this.eTextInput.getGui();
        parentElement.appendChild(eNumberInput);
        parentElement.appendChild(eTextInput);
        this.setupListeners(eNumberInput, (e)=>this.onValueChanged(e));
        this.setupListeners(eTextInput, (e)=>this.onValueChanged(e));
    }
    setEditable(editable) {
        this.numberInputActive = editable;
        this.eNumberInput.setDisplayed(this.numberInputActive);
        this.eTextInput.setDisplayed(!this.numberInputActive);
    }
    setAutoComplete(autoComplete) {
        this.eNumberInput.setAutoComplete(autoComplete);
        this.eTextInput.setAutoComplete(autoComplete);
    }
    getValue() {
        return this.getActiveInputElement().getValue();
    }
    setValue(value, silent) {
        this.getActiveInputElement().setValue(value, silent);
    }
    getActiveInputElement() {
        return this.numberInputActive ? this.eNumberInput : this.eTextInput;
    }
    setValueChangedListener(listener) {
        this.onValueChanged = listener;
    }
    setupListeners(element, listener) {
        this.addManagedListeners(element, {
            input: listener,
            keydown: listener
        });
    }
    setParams(params) {
        this.setAriaLabel(params.ariaLabel);
        if (params.autoComplete !== void 0) this.setAutoComplete(params.autoComplete);
    }
    setAriaLabel(ariaLabel) {
        this.eNumberInput.setInputAriaLabel(ariaLabel);
        this.eTextInput.setInputAriaLabel(ariaLabel);
    }
};
var $437b23f6a393c3bf$var$NumberFloatingFilter = class extends $437b23f6a393c3bf$var$TextInputFloatingFilter {
    constructor(){
        super(...arguments);
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$NumberFilterModelFormatter;
        this.filterType = "number";
        this.defaultOptions = $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS;
    }
    updateParams(params) {
        const allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params.filterParams);
        if (allowedCharPattern !== this.allowedCharPattern) this.recreateFloatingFilterInputService(params);
        super.updateParams(params);
    }
    createFloatingFilterInputService(params) {
        this.allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params.filterParams);
        if (this.allowedCharPattern) return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterTextInputService({
            config: {
                allowedCharPattern: this.allowedCharPattern
            }
        }));
        return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterNumberInputService());
    }
    convertValue(value) {
        return value ? Number(value) : null;
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS = [
    "contains",
    "notContains",
    "equals",
    "notEqual",
    "startsWith",
    "endsWith",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/text/textFilter.ts
var $437b23f6a393c3bf$var$TextFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    constructor(){
        super("textFilter", $437b23f6a393c3bf$var$mapValuesFromTextFilterModel, $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS);
        this.filterType = "text";
        this.eValuesFrom = [];
        this.eValuesTo = [];
        this.defaultDebounceMs = 500;
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.filterType,
            type: type
        };
        const values = this.getValues(position);
        if (values.length > 0) model.filter = values[0];
        if (values.length > 1) model.filterTo = values[1];
        return model;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    getInputs(position) {
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        if (position >= eValuesFrom.length) return [
            null,
            null
        ];
        return [
            eValuesFrom[position],
            eValuesTo[position]
        ];
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push($437b23f6a393c3bf$export$4978424c4f7b5fc0(element.getValue()));
        });
        return result;
    }
    createEValue() {
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body",
            role: "presentation"
        });
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        this.createFromToElement(eCondition, eValuesFrom, "from");
        this.createFromToElement(eCondition, eValuesTo, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo) {
        const eValue = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47());
        eValue.addCss(`ag-filter-${fromTo}`);
        eValue.addCss("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeEValues(startPosition, deleteCount) {
        const removeComps = (eGui)=>this.removeComponents(eGui, startPosition, deleteCount);
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        removeComps(eValuesFrom);
        removeComps(eValuesTo);
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterModelFormatter.ts
var $437b23f6a393c3bf$var$TextFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(){
        super(...arguments);
        this.filterTypeKeys = $437b23f6a393c3bf$var$TEXT_FILTER_TYPE_KEYS;
    }
    conditionToString(condition, forToolPanel, isRange, customDisplayKey, customDisplayName) {
        const { filter: filter, filterTo: filterTo, type: type } = condition;
        if (forToolPanel) {
            const getValueFunc = (value)=>()=>$437b23f6a393c3bf$export$e2a0ae4af921fff8(this, "filterSummaryTextQuote", [
                        value
                    ]);
            const valueForToolPanel = this.conditionForToolPanel(type, isRange, getValueFunc(filter), getValueFunc(filterTo), customDisplayKey, customDisplayName);
            if (valueForToolPanel != null) return valueForToolPanel;
        }
        if (isRange) return `${filter}-${filterTo}`;
        if (filter != null) return `${filter}`;
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterHandler.ts
var $437b23f6a393c3bf$var$defaultMatcher = ({ filterOption: filterOption, value: value, filterText: filterText })=>{
    if (filterText == null) return false;
    switch(filterOption){
        case "contains":
            return value.includes(filterText);
        case "notContains":
            return !value.includes(filterText);
        case "equals":
            return value === filterText;
        case "notEqual":
            return value != filterText;
        case "startsWith":
            return value.indexOf(filterText) === 0;
        case "endsWith":
            {
                const index = value.lastIndexOf(filterText);
                return index >= 0 && index === value.length - filterText.length;
            }
        default:
            return false;
    }
};
var $437b23f6a393c3bf$var$defaultFormatter = (from)=>from;
var $437b23f6a393c3bf$var$defaultLowercaseFormatter = (from)=>from == null ? null : from.toString().toLowerCase();
var $437b23f6a393c3bf$var$TextFilterHandler = class extends $437b23f6a393c3bf$var$SimpleFilterHandler {
    constructor(){
        super($437b23f6a393c3bf$var$mapValuesFromTextFilterModel, $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS);
        this.filterType = "text";
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$TextFilterModelFormatter;
    }
    updateParams(params) {
        super.updateParams(params);
        const filterParams = params.filterParams;
        this.matcher = filterParams.textMatcher ?? $437b23f6a393c3bf$var$defaultMatcher;
        this.formatter = filterParams.textFormatter ?? (filterParams.caseSensitive ? $437b23f6a393c3bf$var$defaultFormatter : $437b23f6a393c3bf$var$defaultLowercaseFormatter);
    }
    evaluateNullValue(filterType) {
        const filterTypesAllowNulls = [
            "notEqual",
            "notContains",
            "blank"
        ];
        return filterType ? filterTypesAllowNulls.indexOf(filterType) >= 0 : false;
    }
    evaluateNonNullValue(values, cellValue, filterModel, params) {
        const formattedValues = values.map((v)=>this.formatter(v)) || [];
        const cellValueFormatted = this.formatter(cellValue);
        const { api: api, colDef: colDef, column: column, context: context, filterParams: { textFormatter: textFormatter } } = this.params;
        if (filterModel.type === "blank") return $437b23f6a393c3bf$var$isBlank(cellValue);
        else if (filterModel.type === "notBlank") return !$437b23f6a393c3bf$var$isBlank(cellValue);
        const matcherParams = {
            api: api,
            colDef: colDef,
            column: column,
            context: context,
            node: params.node,
            data: params.data,
            filterOption: filterModel.type,
            value: cellValueFormatted,
            textFormatter: textFormatter
        };
        return formattedValues.some((v)=>this.matcher({
                ...matcherParams,
                filterText: v
            }));
    }
    processModelToApply(model) {
        if (model && this.params.filterParams.trimInput) {
            const processCondition = (condition)=>{
                const newCondition = {
                    ...condition
                };
                const { filter: filter, filterTo: filterTo } = condition;
                if (filter) newCondition.filter = $437b23f6a393c3bf$var$trimInputForFilter(filter) ?? null;
                if (filterTo) newCondition.filterTo = $437b23f6a393c3bf$var$trimInputForFilter(filterTo) ?? null;
                return newCondition;
            };
            if ($437b23f6a393c3bf$export$a3f343af66a0c1bd(model)) return {
                ...model,
                conditions: model.conditions.map(processCondition)
            };
            return processCondition(model);
        }
        return model;
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFloatingFilter.ts
var $437b23f6a393c3bf$var$TextFloatingFilter = class extends $437b23f6a393c3bf$var$TextInputFloatingFilter {
    constructor(){
        super(...arguments);
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$TextFilterModelFormatter;
        this.filterType = "text";
        this.defaultOptions = $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS;
    }
    createFloatingFilterInputService() {
        return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterTextInputService());
    }
};
// packages/ag-grid-community/src/filter/quickFilterApi.ts
function $437b23f6a393c3bf$var$isQuickFilterPresent(beans) {
    return !!beans.quickFilter?.isFilterPresent();
}
function $437b23f6a393c3bf$var$getQuickFilter(beans) {
    return beans.quickFilter?.getText();
}
function $437b23f6a393c3bf$var$resetQuickFilter(beans) {
    beans.quickFilter?.resetCache();
}
// packages/ag-grid-community/src/filter/quickFilterService.ts
var $437b23f6a393c3bf$var$QuickFilterService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "quickFilter";
        this.quickFilter = null;
        this.quickFilterParts = null;
    }
    postConstruct() {
        const resetListener = this.resetCache.bind(this);
        const gos = this.gos;
        this.addManagedEventListeners({
            columnPivotModeChanged: resetListener,
            newColumnsLoaded: resetListener,
            columnRowGroupChanged: resetListener,
            columnVisible: ()=>{
                if (!gos.get("includeHiddenColumnsInQuickFilter")) this.resetCache();
            }
        });
        this.addManagedPropertyListener("quickFilterText", (e)=>this.setFilter(e.currentValue));
        this.addManagedPropertyListeners([
            "includeHiddenColumnsInQuickFilter",
            "applyQuickFilterBeforePivotOrAgg"
        ], ()=>this.onColumnConfigChanged());
        this.quickFilter = this.parseFilter(gos.get("quickFilterText"));
        this.parser = gos.get("quickFilterParser");
        this.matcher = gos.get("quickFilterMatcher");
        this.setFilterParts();
        this.addManagedPropertyListeners([
            "quickFilterMatcher",
            "quickFilterParser"
        ], ()=>this.setParserAndMatcher());
    }
    // if we are using autoGroupCols, then they should be included for quick filter. this covers the
    // following scenarios:
    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
    refreshCols() {
        const { autoColSvc: autoColSvc, colModel: colModel, gos: gos, pivotResultCols: pivotResultCols } = this.beans;
        const pivotMode = colModel.isPivotMode();
        const groupAutoCols = autoColSvc?.getColumns();
        const providedCols = colModel.getColDefCols();
        let columnsForQuickFilter = (pivotMode && !gos.get("applyQuickFilterBeforePivotOrAgg") ? pivotResultCols?.getPivotResultCols()?.list : providedCols) ?? [];
        if (groupAutoCols) columnsForQuickFilter = columnsForQuickFilter.concat(groupAutoCols);
        this.colsToUse = gos.get("includeHiddenColumnsInQuickFilter") ? columnsForQuickFilter : columnsForQuickFilter.filter((col)=>col.isVisible() || col.isRowGroupActive());
    }
    isFilterPresent() {
        return this.quickFilter !== null;
    }
    doesRowPass(node) {
        const usingCache = this.gos.get("cacheQuickFilter");
        if (this.matcher) return this.doesRowPassMatcher(usingCache, node);
        return this.quickFilterParts.every((part)=>usingCache ? this.doesRowPassCache(node, part) : this.doesRowPassNoCache(node, part));
    }
    resetCache() {
        this.beans.rowModel.forEachNode((node)=>node.quickFilterAggregateText = null);
    }
    getText() {
        return this.gos.get("quickFilterText");
    }
    setFilterParts() {
        const { quickFilter: quickFilter, parser: parser } = this;
        if (quickFilter) this.quickFilterParts = parser ? parser(quickFilter) : quickFilter.split(" ");
        else this.quickFilterParts = null;
    }
    parseFilter(newFilter) {
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(newFilter)) return null;
        return newFilter.toUpperCase();
    }
    setFilter(newFilter) {
        if (newFilter != null && typeof newFilter !== "string") {
            $437b23f6a393c3bf$export$545083624300f13d(70, {
                newFilter: newFilter
            });
            return;
        }
        const parsedFilter = this.parseFilter(newFilter);
        if (this.quickFilter !== parsedFilter) {
            this.quickFilter = parsedFilter;
            this.setFilterParts();
            this.dispatchLocalEvent({
                type: "quickFilterChanged"
            });
        }
    }
    setParserAndMatcher() {
        const parser = this.gos.get("quickFilterParser");
        const matcher = this.gos.get("quickFilterMatcher");
        const hasChanged = parser !== this.parser || matcher !== this.matcher;
        this.parser = parser;
        this.matcher = matcher;
        if (hasChanged) {
            this.setFilterParts();
            this.dispatchLocalEvent({
                type: "quickFilterChanged"
            });
        }
    }
    onColumnConfigChanged() {
        this.refreshCols();
        this.resetCache();
        if (this.isFilterPresent()) this.dispatchLocalEvent({
            type: "quickFilterChanged"
        });
    }
    doesRowPassNoCache(node, filterPart) {
        return this.colsToUse.some((column)=>{
            const part = this.getTextForColumn(column, node);
            return $437b23f6a393c3bf$export$25d27f17d3af40f7(part) && part.includes(filterPart);
        });
    }
    doesRowPassCache(node, filterPart) {
        this.checkGenerateAggText(node);
        return node.quickFilterAggregateText.includes(filterPart);
    }
    doesRowPassMatcher(usingCache, node) {
        let quickFilterAggregateText;
        if (usingCache) {
            this.checkGenerateAggText(node);
            quickFilterAggregateText = node.quickFilterAggregateText;
        } else quickFilterAggregateText = this.getAggText(node);
        const { quickFilterParts: quickFilterParts, matcher: matcher } = this;
        return matcher(quickFilterParts, quickFilterAggregateText);
    }
    checkGenerateAggText(node) {
        if (!node.quickFilterAggregateText) node.quickFilterAggregateText = this.getAggText(node);
    }
    getTextForColumn(column, node) {
        let value = this.beans.filterValueSvc.getValue(column, node);
        const colDef = column.getColDef();
        if (colDef.getQuickFilterText) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                node: node,
                data: node.data,
                column: column,
                colDef: colDef
            });
            value = colDef.getQuickFilterText(params);
        }
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(value) ? value.toString().toUpperCase() : null;
    }
    getAggText(node) {
        const stringParts = [];
        for (const column of this.colsToUse){
            const part = this.getTextForColumn(column, node);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(part)) stringParts.push(part);
        }
        return stringParts.join("\n");
    }
};
// packages/ag-grid-community/src/filter/filterModule.ts
var $437b23f6a393c3bf$var$ClientSideRowModelFilterModule = {
    moduleName: "ClientSideRowModelFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$FilterStage
    ]
};
var $437b23f6a393c3bf$export$b8779358eaaabc87 = {
    moduleName: "FilterCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$FilterManager
    ],
    apiFunctions: {
        isAnyFilterPresent: $437b23f6a393c3bf$var$isAnyFilterPresent,
        onFilterChanged: $437b23f6a393c3bf$var$onFilterChanged
    },
    css: [
        $437b23f6a393c3bf$var$columnFiltersCSS
    ],
    dependsOn: [
        $437b23f6a393c3bf$var$ClientSideRowModelFilterModule
    ]
};
var $437b23f6a393c3bf$export$55e846ac25ec4cc0 = {
    moduleName: "FilterValue",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$FilterValueService
    ]
};
var $437b23f6a393c3bf$export$bee7a6b8183a1c61 = {
    moduleName: "ColumnFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnFilterService,
        $437b23f6a393c3bf$var$FilterMenuFactory
    ],
    dynamicBeans: {
        headerFilterCellCtrl: $437b23f6a393c3bf$var$HeaderFilterCellCtrl
    },
    icons: {
        // open filter button - header, floating filter, menu
        filter: "filter",
        // filter is applied - header (legacy column menu), filter tool panel
        filterActive: "filter"
    },
    apiFunctions: {
        isColumnFilterPresent: $437b23f6a393c3bf$var$isColumnFilterPresent,
        getColumnFilterInstance: $437b23f6a393c3bf$var$getColumnFilterInstance,
        destroyFilter: $437b23f6a393c3bf$var$destroyFilter,
        setFilterModel: $437b23f6a393c3bf$var$setFilterModel,
        getFilterModel: $437b23f6a393c3bf$var$getFilterModel,
        getColumnFilterModel: $437b23f6a393c3bf$var$getColumnFilterModel,
        setColumnFilterModel: $437b23f6a393c3bf$var$setColumnFilterModel,
        showColumnFilter: $437b23f6a393c3bf$var$showColumnFilter,
        hideColumnFilter: $437b23f6a393c3bf$var$hideColumnFilter,
        getColumnFilterHandler: $437b23f6a393c3bf$var$getColumnFilterHandler,
        doFilterAction: $437b23f6a393c3bf$var$doFilterAction
    },
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87,
        $437b23f6a393c3bf$export$da5c9bb998e6c24d,
        $437b23f6a393c3bf$export$55e846ac25ec4cc0,
        $437b23f6a393c3bf$export$b0ea578339daf1f7
    ]
};
var $437b23f6a393c3bf$export$c992812899d813d0 = {
    moduleName: "CustomFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agReadOnlyFloatingFilter: $437b23f6a393c3bf$var$ReadOnlyFloatingFilter
    },
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ]
};
var $437b23f6a393c3bf$export$5ce3e57cec1fecc9 = {
    moduleName: "TextFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agTextColumnFilter: {
            classImp: $437b23f6a393c3bf$var$TextFilter,
            params: {
                useForm: true
            }
        },
        agTextColumnFloatingFilter: $437b23f6a393c3bf$var$TextFloatingFilter
    },
    dynamicBeans: {
        agTextColumnFilterHandler: $437b23f6a393c3bf$var$TextFilterHandler
    }
};
var $437b23f6a393c3bf$export$aabcd4399b0469bb = {
    moduleName: "NumberFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agNumberColumnFilter: {
            classImp: $437b23f6a393c3bf$var$NumberFilter,
            params: {
                useForm: true
            }
        },
        agNumberColumnFloatingFilter: $437b23f6a393c3bf$var$NumberFloatingFilter
    },
    dynamicBeans: {
        agNumberColumnFilterHandler: $437b23f6a393c3bf$var$NumberFilterHandler
    }
};
var $437b23f6a393c3bf$export$2a2721fe06c4c013 = {
    moduleName: "DateFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agDateColumnFilter: {
            classImp: $437b23f6a393c3bf$var$DateFilter,
            params: {
                useForm: true
            }
        },
        agDateInput: $437b23f6a393c3bf$var$DefaultDateComponent,
        agDateColumnFloatingFilter: $437b23f6a393c3bf$var$DateFloatingFilter
    },
    dynamicBeans: {
        agDateColumnFilterHandler: $437b23f6a393c3bf$var$DateFilterHandler
    }
};
var $437b23f6a393c3bf$var$QuickFilterCoreModule = {
    moduleName: "QuickFilterCore",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$QuickFilterService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87,
        $437b23f6a393c3bf$export$55e846ac25ec4cc0
    ]
};
var $437b23f6a393c3bf$export$7e8079ed742f8307 = {
    moduleName: "QuickFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        isQuickFilterPresent: $437b23f6a393c3bf$var$isQuickFilterPresent,
        getQuickFilter: $437b23f6a393c3bf$var$getQuickFilter,
        resetQuickFilter: $437b23f6a393c3bf$var$resetQuickFilter
    },
    dependsOn: [
        $437b23f6a393c3bf$var$QuickFilterCoreModule
    ]
};
var $437b23f6a393c3bf$export$fc403e59f6fc67b = {
    moduleName: "ExternalFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87
    ]
};
// packages/ag-grid-community/src/agStack/tooltip/tooltip.css-GENERATED.ts
var $437b23f6a393c3bf$var$tooltipCSS = /*css*/ `.ag-tooltip{background-color:var(--ag-tooltip-background-color);border:var(--ag-tooltip-border);border-radius:var(--ag-border-radius);color:var(--ag-tooltip-text-color);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;white-space:normal;z-index:99999;&:where(.ag-cell-editor-tooltip){background-color:var(--ag-tooltip-error-background-color);border:var(--ag-tooltip-error-border);color:var(--ag-tooltip-error-text-color);font-weight:500}}.ag-tooltip-custom{position:absolute;z-index:99999}.ag-tooltip-custom:where(:not(.ag-tooltip-interactive)),.ag-tooltip:where(:not(.ag-tooltip-interactive)){pointer-events:none}.ag-tooltip-animate{transition:opacity 1s;&:where(.ag-tooltip-hiding){opacity:0}}`;
// packages/ag-grid-community/src/tooltip/tooltipService.ts
var $437b23f6a393c3bf$var$getEditErrorsForPosition = (beans, cellCtrl, translate)=>{
    const { editModelSvc: editModelSvc } = beans;
    const cellValidationErrors = editModelSvc?.getCellValidationModel()?.getCellValidation(cellCtrl)?.errorMessages;
    const rowValidationErrors = editModelSvc?.getRowValidationModel().getRowValidation(cellCtrl)?.errorMessages;
    const errors = cellValidationErrors || rowValidationErrors;
    return errors?.length ? errors.join(translate("tooltipValidationErrorSeparator", ". ")) : void 0;
};
var $437b23f6a393c3bf$var$TooltipService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "tooltipSvc";
    }
    setupHeaderTooltip(existingTooltipFeature, ctrl, passedValue, shouldDisplayTooltip) {
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature);
        const gos = this.gos;
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(gos);
        const { column: column, eGui: eGui } = ctrl;
        const colDef = column.getColDef();
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colDef.headerComponent) shouldDisplayTooltip = $437b23f6a393c3bf$export$8980540b0a37a11d(()=>eGui.querySelector(".ag-header-cell-text"));
        const location = "header";
        const headerLocation = "header";
        const valueFormatted = this.beans.colNames.getDisplayNameForColumn(column, headerLocation, true);
        const value = passedValue ?? valueFormatted;
        const tooltipCtrl = {
            getGui: ()=>eGui,
            getLocation: ()=>location,
            getTooltipValue: ()=>passedValue ?? colDef?.headerTooltipValueGetter?.($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                    location: location,
                    colDef: colDef,
                    column: column,
                    value: value,
                    valueFormatted: valueFormatted
                })) ?? colDef?.headerTooltip,
            shouldDisplayTooltip: shouldDisplayTooltip,
            getAdditionalParams: ()=>({
                    column: column,
                    colDef: column.getColDef()
                })
        };
        let tooltipFeature = this.createTooltipFeature(tooltipCtrl);
        if (tooltipFeature) {
            tooltipFeature = ctrl.createBean(tooltipFeature);
            ctrl.setRefreshFunction("tooltip", ()=>tooltipFeature.refreshTooltip());
        }
        return tooltipFeature;
    }
    setupHeaderGroupTooltip(existingTooltipFeature, ctrl, passedValue, shouldDisplayTooltip) {
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature);
        const gos = this.gos;
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(gos);
        const { column: column, eGui: eGui } = ctrl;
        const colDef = column.getColGroupDef();
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colDef?.headerGroupComponent) shouldDisplayTooltip = $437b23f6a393c3bf$export$8980540b0a37a11d(()=>eGui.querySelector(".ag-header-group-text"));
        const location = "headerGroup";
        const headerLocation = "header";
        const valueFormatted = this.beans.colNames.getDisplayNameForColumnGroup(column, headerLocation);
        const value = passedValue ?? valueFormatted;
        const tooltipCtrl = {
            getGui: ()=>eGui,
            getLocation: ()=>location,
            getTooltipValue: ()=>passedValue ?? colDef?.headerTooltipValueGetter?.($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                    location: location,
                    colDef: colDef,
                    column: column,
                    value: value,
                    valueFormatted: valueFormatted
                })) ?? colDef?.headerTooltip,
            shouldDisplayTooltip: shouldDisplayTooltip,
            getAdditionalParams: ()=>{
                const additionalParams = {
                    column: column
                };
                if (colDef) additionalParams.colDef = colDef;
                return additionalParams;
            }
        };
        const tooltipFeature = this.createTooltipFeature(tooltipCtrl);
        return tooltipFeature ? ctrl.createBean(tooltipFeature) : tooltipFeature;
    }
    enableCellTooltipFeature(ctrl, value, shouldDisplayTooltip) {
        const { beans: beans } = this;
        const { gos: gos, editSvc: editSvc } = beans;
        const { column: column, rowNode: rowNode } = ctrl;
        let location = "cell";
        const getTooltipValue = ()=>{
            const isEditing2 = !!editSvc?.isEditing(ctrl);
            const errorMessages = !isEditing2 && $437b23f6a393c3bf$var$getEditErrorsForPosition(beans, ctrl, this.getLocaleTextFunc());
            if (errorMessages) {
                location = "cellEditor";
                return errorMessages;
            }
            location = "cell";
            const colDef = column.getColDef();
            const data = rowNode.data;
            if (colDef.tooltipField && $437b23f6a393c3bf$export$25d27f17d3af40f7(data)) return $437b23f6a393c3bf$var$_getValueUsingField(data, colDef.tooltipField, column.isTooltipFieldContainsDots());
            const valueGetter = colDef.tooltipValueGetter;
            if (valueGetter) return valueGetter($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                location: "cell",
                colDef: column.getColDef(),
                column: column,
                rowIndex: ctrl.cellPosition.rowIndex,
                node: rowNode,
                data: rowNode.data,
                value: ctrl.value,
                valueFormatted: ctrl.valueFormatted
            }));
            return null;
        };
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(gos);
        if (!shouldDisplayTooltip) {
            if (isTooltipWhenTruncated && !ctrl.isCellRenderer()) shouldDisplayTooltip = ()=>{
                const isEditing2 = !!editSvc?.isEditing(ctrl);
                const errorMessages = !isEditing2 && $437b23f6a393c3bf$var$getEditErrorsForPosition(beans, ctrl, this.getLocaleTextFunc());
                if (errorMessages) return true;
                const isTooltipEnabled = column.isTooltipEnabled();
                if (!isTooltipEnabled) return false;
                const isElementOverflowing = $437b23f6a393c3bf$export$8980540b0a37a11d(()=>{
                    const eCell = ctrl.eGui;
                    return eCell.children.length === 0 ? eCell : eCell.querySelector(".ag-cell-value");
                });
                return !isEditing2 && isElementOverflowing();
            };
            else shouldDisplayTooltip = ()=>!editSvc?.isEditing(ctrl);
        }
        const tooltipCtrl = {
            getGui: ()=>ctrl.eGui,
            getLocation: ()=>location,
            getTooltipValue: value != null ? ()=>value : getTooltipValue,
            shouldDisplayTooltip: shouldDisplayTooltip,
            getAdditionalParams: ()=>({
                    column: column,
                    colDef: column.getColDef(),
                    rowIndex: ctrl.cellPosition.rowIndex,
                    node: rowNode,
                    data: rowNode.data,
                    valueFormatted: ctrl.valueFormatted
                })
        };
        return this.createTooltipFeature(tooltipCtrl, beans);
    }
    setupFullWidthRowTooltip(existingTooltipFeature, ctrl, value, shouldDisplayTooltip) {
        const tooltipParams = {
            getGui: ()=>ctrl.getFullWidthElement(),
            getTooltipValue: ()=>value,
            getLocation: ()=>"fullWidthRow",
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        const beans = this.beans;
        const context = beans.context;
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature, context);
        const tooltipFeature = this.createTooltipFeature(tooltipParams, beans);
        if (!tooltipFeature) return;
        return ctrl.createBean(tooltipFeature, context);
    }
    setupCellEditorTooltip(cellCtrl, editor) {
        const { beans: beans } = this;
        const { context: context } = beans;
        const el = editor.getValidationElement?.(true) || !editor.isPopup?.() && cellCtrl.eGui;
        if (!el) return;
        const tooltipParams = {
            getGui: ()=>el,
            getTooltipValue: ()=>$437b23f6a393c3bf$var$getEditErrorsForPosition(beans, cellCtrl, this.getLocaleTextFunc()),
            getLocation: ()=>"cellEditor",
            shouldDisplayTooltip: ()=>{
                const { editModelSvc: editModelSvc } = beans;
                const rowValidationMap = editModelSvc?.getRowValidationModel()?.getRowValidationMap();
                const cellValidationMap = editModelSvc?.getCellValidationModel()?.getCellValidationMap();
                const hasRowValidationErrors = !!rowValidationMap && rowValidationMap.size > 0;
                const hasCellValidationErrors = !!cellValidationMap && cellValidationMap.size > 0;
                return hasRowValidationErrors || hasCellValidationErrors;
            }
        };
        const tooltipFeature = this.createTooltipFeature(tooltipParams, beans);
        if (!tooltipFeature) return;
        return cellCtrl.createBean(tooltipFeature, context);
    }
    initCol(column) {
        const { colDef: colDef } = column;
        column.tooltipEnabled = $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipField) || $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipValueGetter) || $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipComponent);
    }
    createTooltipFeature(tooltipCtrl, beans) {
        return this.beans.registry.createDynamicBean("tooltipFeature", false, tooltipCtrl, beans);
    }
};
// packages/ag-grid-community/src/tooltip/tooltipStateManager.ts
var $437b23f6a393c3bf$var$TooltipStateManager = class extends $437b23f6a393c3bf$export$96f12f5ea073bed1 {
    createTooltipComp(params, callback) {
        const userDetails = $437b23f6a393c3bf$var$_getTooltipCompDetails(this.beans.userCompFactory, params);
        userDetails?.newAgStackInstance().then(callback);
    }
    setEventHandlers(listener) {
        [this.onColumnMovedEventCallback] = this.addManagedEventListeners({
            columnMoved: listener
        });
    }
    clearEventHandlers() {
        this.onColumnMovedEventCallback?.();
        this.onColumnMovedEventCallback = void 0;
    }
};
// packages/ag-grid-community/src/tooltip/tooltipModule.ts
var $437b23f6a393c3bf$export$d0c662c133b8814e = {
    moduleName: "Tooltip",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TooltipService
    ],
    dynamicBeans: {
        tooltipFeature: $437b23f6a393c3bf$export$e72bd8c9b85d3e72,
        highlightTooltipFeature: $437b23f6a393c3bf$var$AgHighlightTooltipFeature,
        tooltipStateManager: $437b23f6a393c3bf$var$TooltipStateManager
    },
    userComponents: {
        agTooltipComponent: $437b23f6a393c3bf$export$7347ac91f8ec5988
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d
    ],
    css: [
        $437b23f6a393c3bf$var$tooltipCSS
    ]
};
// packages/ag-grid-community/src/undoRedo/undoRedoStack.ts
var $437b23f6a393c3bf$var$UndoRedoAction = class {
    constructor(cellValueChanges){
        this.cellValueChanges = cellValueChanges;
    }
};
var $437b23f6a393c3bf$var$RangeUndoRedoAction = class extends $437b23f6a393c3bf$var$UndoRedoAction {
    constructor(cellValueChanges, initialRange, finalRange, ranges){
        super(cellValueChanges);
        this.initialRange = initialRange;
        this.finalRange = finalRange;
        this.ranges = ranges;
    }
};
var $437b23f6a393c3bf$var$DEFAULT_STACK_SIZE = 10;
var $437b23f6a393c3bf$var$UndoRedoStack = class {
    constructor(maxStackSize){
        this.actionStack = [];
        this.maxStackSize = maxStackSize ? maxStackSize : $437b23f6a393c3bf$var$DEFAULT_STACK_SIZE;
        this.actionStack = new Array(this.maxStackSize);
    }
    pop() {
        return this.actionStack.pop();
    }
    push(item) {
        const shouldAddActions = item.cellValueChanges && item.cellValueChanges.length > 0;
        if (!shouldAddActions) return;
        if (this.actionStack.length === this.maxStackSize) this.actionStack.shift();
        this.actionStack.push(item);
    }
    clear() {
        this.actionStack = [];
    }
    getCurrentStackSize() {
        return this.actionStack.length;
    }
};
// packages/ag-grid-community/src/undoRedo/undoRedoService.ts
var $437b23f6a393c3bf$var$UndoRedoService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "undoRedo";
        this.cellValueChanges = [];
        this.activeCellEdit = null;
        this.activeRowEdit = null;
        this.isPasting = false;
        this.isRangeInAction = false;
        this.batchEditing = false;
        this.bulkEditing = false;
        this.onCellValueChanged = (event)=>{
            const eventCell = {
                column: event.column,
                rowIndex: event.rowIndex,
                rowPinned: event.rowPinned
            };
            const isCellEditing = this.activeCellEdit !== null && $437b23f6a393c3bf$export$be3973033c2c5267(this.activeCellEdit, eventCell);
            const isRowEditing = this.activeRowEdit !== null && $437b23f6a393c3bf$export$de6f9fa10e9f4188(this.activeRowEdit, eventCell);
            const shouldCaptureAction = isCellEditing || isRowEditing || this.isPasting || this.isRangeInAction;
            if (!shouldCaptureAction) return;
            const { rowPinned: rowPinned, rowIndex: rowIndex, column: column, oldValue: oldValue, value: value } = event;
            const cellValueChange = {
                rowPinned: rowPinned,
                rowIndex: rowIndex,
                columnId: column.getColId(),
                newValue: value,
                oldValue: oldValue
            };
            this.cellValueChanges.push(cellValueChange);
        };
        this.clearStacks = ()=>{
            this.undoStack.clear();
            this.redoStack.clear();
        };
    }
    postConstruct() {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        if (!gos.get("undoRedoCellEditing")) return;
        const undoRedoLimit = gos.get("undoRedoCellEditingLimit");
        if (undoRedoLimit <= 0) return;
        this.undoStack = new $437b23f6a393c3bf$var$UndoRedoStack(undoRedoLimit);
        this.redoStack = new $437b23f6a393c3bf$var$UndoRedoStack(undoRedoLimit);
        this.addListeners();
        const listener = this.clearStacks.bind(this);
        this.addManagedEventListeners({
            cellValueChanged: this.onCellValueChanged.bind(this),
            // undo / redo is restricted to actual editing so we clear the stacks when other operations are
            // performed that change the order of the row / cols.
            modelUpdated: (e)=>{
                if (!e.keepUndoRedoStack) this.clearStacks();
            },
            columnPivotModeChanged: listener,
            newColumnsLoaded: listener,
            columnGroupOpened: listener,
            columnRowGroupChanged: listener,
            columnMoved: listener,
            columnPinned: listener,
            columnVisible: listener,
            rowDragEnd: listener
        });
        ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
    }
    getCurrentUndoStackSize() {
        return this.undoStack?.getCurrentStackSize() ?? 0;
    }
    getCurrentRedoStackSize() {
        return this.redoStack?.getCurrentStackSize() ?? 0;
    }
    undo(source) {
        const { eventSvc: eventSvc, undoStack: undoStack, redoStack: redoStack } = this;
        eventSvc.dispatchEvent({
            type: "undoStarted",
            source: source
        });
        const operationPerformed = this.undoRedo(undoStack, redoStack, "initialRange", "oldValue", "undo");
        eventSvc.dispatchEvent({
            type: "undoEnded",
            source: source,
            operationPerformed: operationPerformed
        });
    }
    redo(source) {
        const { eventSvc: eventSvc, undoStack: undoStack, redoStack: redoStack } = this;
        eventSvc.dispatchEvent({
            type: "redoStarted",
            source: source
        });
        const operationPerformed = this.undoRedo(redoStack, undoStack, "finalRange", "newValue", "redo");
        eventSvc.dispatchEvent({
            type: "redoEnded",
            source: source,
            operationPerformed: operationPerformed
        });
    }
    undoRedo(undoRedoStack, opposingUndoRedoStack, rangeProperty, cellValueChangeProperty, source) {
        if (!undoRedoStack) return false;
        const undoRedoAction = undoRedoStack.pop();
        if (!undoRedoAction?.cellValueChanges) return false;
        this.processAction(undoRedoAction, (cellValueChange)=>cellValueChange[cellValueChangeProperty], source);
        if (undoRedoAction instanceof $437b23f6a393c3bf$var$RangeUndoRedoAction) this.processRange(undoRedoAction.ranges || [
            undoRedoAction[rangeProperty]
        ]);
        else this.processCell(undoRedoAction.cellValueChanges);
        opposingUndoRedoStack.push(undoRedoAction);
        return true;
    }
    processAction(action, valueExtractor, source) {
        for (const cellValueChange of action.cellValueChanges){
            const { rowIndex: rowIndex, rowPinned: rowPinned, columnId: columnId } = cellValueChange;
            const rowPosition = {
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
            const currentRow = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, rowPosition);
            if (!currentRow.displayed) continue;
            currentRow.setDataValue(columnId, valueExtractor(cellValueChange), source);
        }
    }
    processRange(ranges) {
        let lastFocusedCell;
        const rangeSvc = this.beans.rangeSvc;
        rangeSvc.removeAllCellRanges(true);
        ranges.forEach((range, idx)=>{
            if (!range) return;
            const startRow = range.startRow;
            const endRow = range.endRow;
            if (idx === ranges.length - 1) {
                lastFocusedCell = {
                    rowPinned: startRow.rowPinned,
                    rowIndex: startRow.rowIndex,
                    columnId: range.startColumn.getColId()
                };
                this.setLastFocusedCell(lastFocusedCell);
            }
            const cellRangeParams = {
                rowStartIndex: startRow.rowIndex,
                rowStartPinned: startRow.rowPinned,
                rowEndIndex: endRow.rowIndex,
                rowEndPinned: endRow.rowPinned,
                columnStart: range.startColumn,
                columns: range.columns
            };
            rangeSvc.addCellRange(cellRangeParams);
        });
    }
    processCell(cellValueChanges) {
        const cellValueChange = cellValueChanges[0];
        const { rowIndex: rowIndex, rowPinned: rowPinned } = cellValueChange;
        const rowPosition = {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
        const row = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, rowPosition);
        const lastFocusedCell = {
            rowPinned: cellValueChange.rowPinned,
            rowIndex: row.rowIndex,
            columnId: cellValueChange.columnId
        };
        this.setLastFocusedCell(lastFocusedCell);
    }
    setLastFocusedCell(lastFocusedCell) {
        const { rowIndex: rowIndex, columnId: columnId, rowPinned: rowPinned } = lastFocusedCell;
        const { colModel: colModel, focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        const column = colModel.getCol(columnId);
        if (!column) return;
        const { scrollFeature: scrollFeature } = this.gridBodyCtrl;
        scrollFeature.ensureIndexVisible(rowIndex);
        scrollFeature.ensureColumnVisible(column);
        const cellPosition = {
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned
        };
        focusSvc.setFocusedCell({
            ...cellPosition,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell(cellPosition);
    }
    addListeners() {
        this.addManagedEventListeners({
            rowEditingStarted: (e)=>{
                this.activeRowEdit = {
                    rowIndex: e.rowIndex,
                    rowPinned: e.rowPinned
                };
            },
            rowEditingStopped: ()=>{
                const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.activeRowEdit = null;
            },
            cellEditingStarted: (e)=>{
                this.activeCellEdit = {
                    column: e.column,
                    rowIndex: e.rowIndex,
                    rowPinned: e.rowPinned
                };
            },
            cellEditingStopped: (e)=>{
                this.activeCellEdit = null;
                const shouldPushAction = e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction;
                if (shouldPushAction) {
                    const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                    this.pushActionsToUndoStack(action);
                }
            },
            pasteStart: ()=>{
                this.isPasting = true;
            },
            pasteEnd: ()=>{
                const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.isPasting = false;
            },
            fillStart: ()=>{
                this.isRangeInAction = true;
            },
            fillEnd: (event)=>{
                const action = new $437b23f6a393c3bf$var$RangeUndoRedoAction(this.cellValueChanges, event.initialRange, event.finalRange);
                this.pushActionsToUndoStack(action);
                this.isRangeInAction = false;
            },
            keyShortcutChangedCellStart: ()=>{
                this.isRangeInAction = true;
            },
            keyShortcutChangedCellEnd: ()=>{
                let action;
                const { rangeSvc: rangeSvc, gos: gos } = this.beans;
                if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos)) action = new $437b23f6a393c3bf$var$RangeUndoRedoAction(this.cellValueChanges, void 0, void 0, [
                    ...rangeSvc.getCellRanges()
                ]);
                else action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.isRangeInAction = false;
            },
            batchEditingStarted: ()=>this.startBigChange("batchEditing"),
            batchEditingStopped: ({ changes: changes })=>this.stopBigChange("batchEditing", changes),
            bulkEditingStarted: ()=>this.startBigChange("bulkEditing"),
            bulkEditingStopped: ({ changes: changes })=>this.stopBigChange("bulkEditing", changes)
        });
    }
    startBigChange(key) {
        this.updateBigChange(key, true);
    }
    updateBigChange(key, value) {
        if (key === "bulkEditing") this.bulkEditing = value;
        else this.batchEditing = value;
    }
    stopBigChange(key, changes) {
        if (key === "bulkEditing" && !this.bulkEditing || key === "batchEditing" && !this.batchEditing) return;
        this.updateBigChange(key, false);
        if (changes?.length === 0) return;
        const action = new $437b23f6a393c3bf$var$UndoRedoAction(changes ?? []);
        this.pushActionsToUndoStack(action);
        this.cellValueChanges = [];
    }
    pushActionsToUndoStack(action) {
        this.undoStack.push(action);
        this.cellValueChanges = [];
        this.redoStack.clear();
    }
};
// packages/ag-grid-community/src/edit/cell-editing.css-GENERATED.ts
var $437b23f6a393c3bf$var$cellEditingCSS = /*css*/ `.ag-cell-inline-editing{border:var(--ag-cell-editing-border)!important;border-radius:var(--ag-border-radius);box-shadow:var(--ag-cell-editing-shadow);padding:0;z-index:1;.ag-cell-edit-wrapper,.ag-cell-editor,.ag-cell-wrapper,:where(.ag-cell-editor) .ag-input-field-input,:where(.ag-cell-editor) .ag-wrapper{height:100%;line-height:normal;min-height:100%;width:100%}&.ag-cell-editing-error{border-color:var(--ag-invalid-color)!important}}:where(.ag-popup-editor) .ag-large-text{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0}.ag-large-text-input{display:block;height:auto;padding:var(--ag-cell-horizontal-padding)}:where(.ag-rtl .ag-large-text-input) textarea{resize:none}:where(.ag-ltr) .ag-checkbox-edit{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-checkbox-edit{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-row.ag-row-editing-invalid .ag-cell-inline-editing){opacity:.8}.ag-popup-editor{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}`;
// packages/ag-grid-community/src/edit/cellEditors/checkboxCellEditor.ts
var $437b23f6a393c3bf$var$CheckboxCellEditorElement = {
    tag: "div",
    cls: "ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eEditor",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxCellEditorElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    initialiseEditor(params) {
        const isSelected = params.value ?? void 0;
        const eEditor = this.eEditor;
        eEditor.setValue(isSelected);
        const inputEl = eEditor.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        this.setAriaLabel(isSelected);
        this.addManagedListeners(eEditor, {
            fieldValueChanged: (event)=>this.setAriaLabel(event.selected)
        });
    }
    getValue() {
        return this.eEditor.getValue();
    }
    focusIn() {
        this.eEditor.getFocusableElement().focus();
    }
    afterGuiAttached() {
        if (this.params.cellStartedEdit) this.focusIn();
    }
    isPopup() {
        return false;
    }
    setAriaLabel(isSelected) {
        const translate = this.getLocaleTextFunc();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = translate("ariaToggleCellValue", "Press SPACE to toggle cell value");
        this.eEditor.setInputAriaLabel(`${ariaLabel} (${stateName})`);
    }
    getValidationElement(tooltip) {
        return tooltip ? this.params.eGridCell : this.eEditor.getInputElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { getValidationErrors: getValidationErrors } = params;
        const value = this.getValue();
        if (!getValidationErrors) return null;
        return getValidationErrors({
            value: value,
            internalErrors: null,
            cellEditorParams: params
        });
    }
};
// packages/ag-grid-community/src/edit/cellEditors/simpleCellEditor.ts
var $437b23f6a393c3bf$var$SimpleCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(cellEditorInput){
        super();
        this.cellEditorInput = cellEditorInput;
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    initialiseEditor(params) {
        const { cellEditorInput: cellEditorInput } = this;
        this.setTemplate({
            tag: "div",
            cls: "ag-cell-edit-wrapper",
            children: [
                cellEditorInput.getTemplate()
            ]
        }, cellEditorInput.getAgComponents());
        const { eEditor: eEditor } = this;
        const { cellStartedEdit: cellStartedEdit, eventKey: eventKey, suppressPreventDefault: suppressPreventDefault } = params;
        eEditor.getInputElement().setAttribute("title", "");
        cellEditorInput.init(eEditor, params);
        let startValue;
        let shouldSetStartValue = true;
        if (cellStartedEdit) {
            this.focusAfterAttached = true;
            if (eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE || eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) startValue = "";
            else if (eventKey && eventKey.length === 1) {
                if (suppressPreventDefault) shouldSetStartValue = false;
                else startValue = eventKey;
            } else {
                startValue = cellEditorInput.getStartValue();
                if (eventKey !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2) this.highlightAllOnFocus = true;
            }
        } else {
            this.focusAfterAttached = false;
            startValue = cellEditorInput.getStartValue();
        }
        if (shouldSetStartValue && startValue != null) eEditor.setStartValue(startValue);
        this.addGuiEventListener("keydown", (event)=>{
            const { key: key } = event;
            if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) event.preventDefault();
        });
    }
    afterGuiAttached() {
        const translate = this.getLocaleTextFunc();
        const eInput = this.eEditor;
        eInput.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (!this.focusAfterAttached) return;
        if (!$437b23f6a393c3bf$export$8caf403dacd36a68()) eInput.getFocusableElement().focus();
        const inputEl = eInput.getInputElement();
        if (this.highlightAllOnFocus) inputEl.select();
        else this.cellEditorInput.setCaret?.();
    }
    // gets called when tabbing through cells and in full row edit mode
    focusIn() {
        const { eEditor: eEditor } = this;
        const focusEl = eEditor.getFocusableElement();
        const inputEl = eEditor.getInputElement();
        focusEl.focus();
        inputEl.select();
    }
    getValue() {
        return this.cellEditorInput.getValue();
    }
    isPopup() {
        return false;
    }
    getValidationElement() {
        return this.eEditor.getInputElement();
    }
    getValidationErrors() {
        return this.cellEditorInput.getValidationErrors();
    }
};
// packages/ag-grid-community/src/edit/cellEditors/dateCellEditor.ts
var $437b23f6a393c3bf$var$DateCellElement = {
    tag: "ag-input-date-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$DateCellEditorInput = class {
    constructor(getDataTypeService, getLocaleTextFunc){
        this.getDataTypeService = getDataTypeService;
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$DateCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$var$AgInputDateFieldSelector
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const { min: min, max: max, step: step, colDef: colDef } = params;
        if (min != null) eEditor.setMin(min);
        if (max != null) eEditor.setMax(max);
        if (step != null) eEditor.setStep(step);
        this.includeTime = params.includeTime ?? this.getDataTypeService()?.getDateIncludesTimeFlag?.(colDef.cellDataType);
        if (this.includeTime != null) eEditor.setIncludeTime(this.includeTime);
    }
    getValidationErrors() {
        const eInput = this.eEditor.getInputElement();
        const value = eInput.valueAsDate;
        const { params: params } = this;
        const { min: min, max: max, getValidationErrors: getValidationErrors } = params;
        let internalErrors = [];
        const translate = this.getLocaleTextFunc();
        if (value instanceof Date && !isNaN(value.getTime())) {
            if (min) {
                const minValue = min instanceof Date ? min : new Date(min);
                if (value < minValue) {
                    const minDateString = minValue.toLocaleDateString();
                    internalErrors.push(translate("minDateValidation", `Date must be after ${minDateString}`, [
                        minDateString
                    ]));
                }
            }
            if (max) {
                const maxValue = max instanceof Date ? max : new Date(max);
                if (value > maxValue) {
                    const maxDateString = maxValue.toLocaleDateString();
                    internalErrors.push(translate("maxDateValidation", `Date must be before ${maxDateString}`, [
                        maxDateString
                    ]));
                }
            }
        }
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const value = eEditor.getDate();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return value ?? null;
    }
    getStartValue() {
        const { value: value } = this.params;
        if (!(value instanceof Date)) return void 0;
        return $437b23f6a393c3bf$export$3d7fedfb21962874(value, this.includeTime ?? false);
    }
};
var $437b23f6a393c3bf$var$DateCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$DateCellEditorInput(()=>this.beans.dataTypeSvc, ()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/edit/cellEditors/dateStringCellEditor.ts
var $437b23f6a393c3bf$var$DateStringCellElement = {
    tag: "ag-input-date-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$DateStringCellEditorInput = class {
    constructor(getDataTypeService, getLocaleTextFunc){
        this.getDataTypeService = getDataTypeService;
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$DateStringCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$var$AgInputDateFieldSelector
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const { min: min, max: max, step: step, colDef: colDef } = params;
        if (min != null) eEditor.setMin(min);
        if (max != null) eEditor.setMax(max);
        if (step != null) eEditor.setStep(step);
        this.includeTime = params.includeTime ?? this.getDataTypeService()?.getDateIncludesTimeFlag?.(colDef.cellDataType);
        if (this.includeTime != null) eEditor.setIncludeTime(this.includeTime);
    }
    getValidationErrors() {
        const { eEditor: eEditor, params: params } = this;
        const raw = eEditor.getInputElement().value;
        const value = this.formatDate(this.parseDate(raw ?? void 0));
        const { min: min, max: max, getValidationErrors: getValidationErrors } = params;
        let internalErrors = [];
        if (value) {
            const date = new Date(value);
            const translate = this.getLocaleTextFunc();
            if (min) {
                const minDate = new Date(min);
                if (date < minDate) {
                    const minDateString = minDate.toLocaleDateString();
                    internalErrors.push(translate("minDateValidation", `Date must be after ${minDateString}`, [
                        minDateString
                    ]));
                }
            }
            if (max) {
                const maxDate = new Date(max);
                if (date > maxDate) {
                    const maxDateString = maxDate.toLocaleDateString();
                    internalErrors.push(translate("maxDateValidation", `Date must be before ${maxDateString}`, [
                        maxDateString
                    ]));
                }
            }
        }
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: this.getValue(),
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    getValue() {
        const { params: params, eEditor: eEditor } = this;
        const value = this.formatDate(eEditor.getDate());
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return params.parseValue(value ?? "");
    }
    getStartValue() {
        return $437b23f6a393c3bf$export$3d7fedfb21962874(this.parseDate(this.params.value ?? void 0) ?? null, this.includeTime ?? false);
    }
    parseDate(value) {
        const dataTypeSvc = this.getDataTypeService();
        return dataTypeSvc ? dataTypeSvc.getDateParserFunction(this.params.column)(value) : $437b23f6a393c3bf$export$26ded2d88c01b527(value) ?? void 0;
    }
    formatDate(value) {
        const dataTypeSvc = this.getDataTypeService();
        return dataTypeSvc ? dataTypeSvc.getDateFormatterFunction(this.params.column)(value) : $437b23f6a393c3bf$export$3d7fedfb21962874(value ?? null, this.includeTime ?? false) ?? void 0;
    }
};
var $437b23f6a393c3bf$var$DateStringCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$DateStringCellEditorInput(()=>this.beans.dataTypeSvc, ()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/edit/cellEditors/largeTextCellEditor.ts
var $437b23f6a393c3bf$var$LargeTextCellElement = {
    tag: "div",
    cls: "ag-large-text",
    children: [
        {
            tag: "ag-input-text-area",
            ref: "eEditor",
            cls: "ag-large-text-input"
        }
    ]
};
var $437b23f6a393c3bf$var$LargeTextCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(){
        super($437b23f6a393c3bf$var$LargeTextCellElement, [
            $437b23f6a393c3bf$var$AgInputTextAreaSelector
        ]);
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    initialiseEditor(params) {
        const { eEditor: eEditor } = this;
        const { cellStartedEdit: cellStartedEdit, eventKey: eventKey, maxLength: maxLength, cols: cols, rows: rows } = params;
        this.focusAfterAttached = cellStartedEdit;
        eEditor.getInputElement().setAttribute("title", "");
        eEditor.setMaxLength(maxLength || 200).setCols(cols || 60).setRows(rows || 10);
        let startValue;
        if (cellStartedEdit) {
            this.focusAfterAttached = true;
            if (eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE || eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) startValue = "";
            else if (eventKey && eventKey.length === 1) startValue = eventKey;
            else {
                startValue = this.getStartValue(params);
                if (eventKey !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2) this.highlightAllOnFocus = true;
            }
        } else {
            this.focusAfterAttached = false;
            startValue = this.getStartValue(params);
        }
        if (startValue != null) eEditor.setValue(startValue, true);
        this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
        this.activateTabIndex();
    }
    getStartValue(params) {
        const { value: value } = params;
        return value?.toString() ?? value;
    }
    onKeyDown(event) {
        const key = event.key;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN || event.shiftKey && key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) event.stopPropagation();
    }
    afterGuiAttached() {
        const { eEditor: eEditor, focusAfterAttached: focusAfterAttached, highlightAllOnFocus: highlightAllOnFocus } = this;
        const translate = this.getLocaleTextFunc();
        eEditor.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (focusAfterAttached) {
            eEditor.getFocusableElement().focus();
            if (highlightAllOnFocus) eEditor.getInputElement().select();
        }
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const { value: value } = params;
        const editorValue = eEditor.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(editorValue) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(value)) return value;
        return params.parseValue(editorValue);
    }
    getValidationElement() {
        return this.eEditor.getInputElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { maxLength: maxLength, getValidationErrors: getValidationErrors } = params;
        const translate = this.getLocaleTextFunc();
        const value = this.getValue();
        let internalErrors = [];
        if (typeof value === "string" && maxLength != null && value.length > maxLength) internalErrors.push(translate("maxLengthValidation", `Must be ${maxLength} characters or fewer.`, [
            String(maxLength)
        ]));
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            internalErrors: internalErrors,
            cellEditorParams: params
        });
        return internalErrors;
    }
};
// packages/ag-grid-community/src/edit/cellEditors/numberCellEditor.ts
var $437b23f6a393c3bf$var$NumberCellElement = {
    tag: "ag-input-number-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$NumberCellEditorInput = class {
    constructor(getLocaleTextFunc){
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$NumberCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$export$c18153c9c909b7d7
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const { max: max, min: min, precision: precision, step: step } = params;
        if (max != null) eEditor.setMax(max);
        if (min != null) eEditor.setMin(min);
        if (precision != null) eEditor.setPrecision(precision);
        if (step != null) eEditor.setStep(step);
        const editorEl = eEditor.getInputElement();
        if (params.preventStepping) eEditor.addManagedElementListeners(editorEl, {
            keydown: this.preventStepping
        });
        else if (params.showStepperButtons) editorEl.classList.add("ag-number-field-input-stepper");
    }
    getValidationErrors() {
        const { params: params } = this;
        const { min: min, max: max, getValidationErrors: getValidationErrors } = params;
        const eInput = this.eEditor.getInputElement();
        const value = eInput.valueAsNumber;
        const translate = this.getLocaleTextFunc();
        let internalErrors = [];
        if (typeof value === "number") {
            if (min != null && value < min) internalErrors.push(translate("minValueValidation", `Must be greater than or equal to ${min}.`, [
                String(min)
            ]));
            if (max != null && value > max) internalErrors.push(translate("maxValueValidation", `Must be less than or equal to ${max}.`, [
                String(max)
            ]));
        }
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    preventStepping(e) {
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN) e.preventDefault();
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const value = eEditor.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        let parsedValue = params.parseValue(value);
        if (parsedValue == null) return parsedValue;
        if (typeof parsedValue === "string") {
            if (parsedValue === "") return null;
            parsedValue = Number(parsedValue);
        }
        return isNaN(parsedValue) ? null : parsedValue;
    }
    getStartValue() {
        return this.params.value;
    }
    setCaret() {
        if ($437b23f6a393c3bf$export$8caf403dacd36a68()) this.eEditor.getInputElement().focus({
            preventScroll: true
        });
    }
};
var $437b23f6a393c3bf$var$NumberCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$NumberCellEditorInput(()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/edit/cellEditors/selectCellEditor.ts
var $437b23f6a393c3bf$var$SelectCellElement = {
    tag: "div",
    cls: "ag-cell-edit-wrapper",
    children: [
        {
            tag: "ag-select",
            ref: "eEditor",
            cls: "ag-cell-editor"
        }
    ]
};
var $437b23f6a393c3bf$var$SelectCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(){
        super($437b23f6a393c3bf$var$SelectCellElement, [
            $437b23f6a393c3bf$export$e32612175ad118ef
        ]);
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.startedByEnter = false;
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
    }
    initialiseEditor(params) {
        this.focusAfterAttached = params.cellStartedEdit;
        const { eEditor: eEditor, valueSvc: valueSvc, gos: gos } = this;
        const { values: values, value: value, eventKey: eventKey } = params;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(values)) {
            $437b23f6a393c3bf$export$545083624300f13d(58);
            return;
        }
        this.startedByEnter = eventKey != null ? eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER : false;
        let hasValue = false;
        values.forEach((currentValue)=>{
            const option = {
                value: currentValue
            };
            const valueFormatted = valueSvc.formatValue(params.column, null, currentValue);
            const valueFormattedExits = valueFormatted !== null && valueFormatted !== void 0;
            option.text = valueFormattedExits ? valueFormatted : currentValue;
            eEditor.addOption(option);
            hasValue = hasValue || value === currentValue;
        });
        if (hasValue) eEditor.setValue(params.value, true);
        else if (params.values.length) eEditor.setValue(params.values[0], true);
        const { valueListGap: valueListGap, valueListMaxWidth: valueListMaxWidth, valueListMaxHeight: valueListMaxHeight } = params;
        if (valueListGap != null) eEditor.setPickerGap(valueListGap);
        if (valueListMaxHeight != null) eEditor.setPickerMaxHeight(valueListMaxHeight);
        if (valueListMaxWidth != null) eEditor.setPickerMaxWidth(valueListMaxWidth);
        if (gos.get("editType") !== "fullRow") this.addManagedListeners(this.eEditor, {
            selectedItem: ()=>params.stopEditing()
        });
    }
    afterGuiAttached() {
        if (this.focusAfterAttached) this.eEditor.getFocusableElement().focus();
        if (this.startedByEnter) setTimeout(()=>{
            if (this.isAlive()) this.eEditor.showPicker();
        });
    }
    focusIn() {
        this.eEditor.getFocusableElement().focus();
    }
    getValue() {
        return this.eEditor.getValue();
    }
    isPopup() {
        return false;
    }
    getValidationElement() {
        return this.eEditor.getAriaElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { values: values, getValidationErrors: getValidationErrors } = params;
        const value = this.getValue();
        let internalErrors = [];
        if (values && !values.includes(value)) {
            const translate = this.getLocaleTextFunc();
            internalErrors.push(translate("invalidSelectionValidation", "Invalid selection."));
        } else internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            internalErrors: internalErrors,
            cellEditorParams: params
        });
        return internalErrors;
    }
};
// packages/ag-grid-community/src/edit/cellEditors/textCellEditor.ts
var $437b23f6a393c3bf$var$TextCellEditorElement = {
    tag: "ag-input-text-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$TextCellEditorInput = class {
    constructor(getLocaleTextFunc){
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$TextCellEditorElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const maxLength = params.maxLength;
        if (maxLength != null) eEditor.setMaxLength(maxLength);
    }
    getValidationErrors() {
        const { params: params } = this;
        const { maxLength: maxLength, getValidationErrors: getValidationErrors } = params;
        const value = this.getValue();
        const translate = this.getLocaleTextFunc();
        let internalErrors = [];
        if (maxLength != null && typeof value === "string" && value.length > maxLength) internalErrors.push(translate("maxLengthValidation", `Must be ${maxLength} characters or fewer.`, [
            String(maxLength)
        ]));
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const value = eEditor.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return params.parseValue(value);
    }
    getStartValue() {
        const params = this.params;
        const formatValue = params.useFormatter || params.column.getColDef().refData;
        return formatValue ? params.formatValue(params.value) : params.value;
    }
    setCaret() {
        if ($437b23f6a393c3bf$export$8caf403dacd36a68()) this.eEditor.getInputElement().focus({
            preventScroll: true
        });
        const eInput = this.eEditor;
        const value = eInput.getValue();
        const len = $437b23f6a393c3bf$export$25d27f17d3af40f7(value) && value.length || 0;
        if (len) eInput.getInputElement().setSelectionRange(len, len);
    }
};
var $437b23f6a393c3bf$var$TextCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$TextCellEditorInput(()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/api/scrollApi.ts
function $437b23f6a393c3bf$var$getVerticalPixelRange(beans) {
    return beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
function $437b23f6a393c3bf$var$getHorizontalPixelRange(beans) {
    return beans.ctrlsSvc.getScrollFeature().getHScrollPosition();
}
function $437b23f6a393c3bf$var$ensureColumnVisible(beans, key, position = "auto") {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureColumnVisible(key, position), "ensureVisible");
}
function $437b23f6a393c3bf$var$ensureIndexVisible(beans, index, position) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureIndexVisible(index, position), "ensureVisible");
}
function $437b23f6a393c3bf$var$ensureNodeVisible(beans, nodeSelector, position = null) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureNodeVisible(nodeSelector, position), "ensureVisible");
}
// packages/ag-grid-community/src/edit/editApi.ts
function $437b23f6a393c3bf$var$undoCellEditing(beans) {
    beans.undoRedo?.undo("api");
}
function $437b23f6a393c3bf$var$redoCellEditing(beans) {
    beans.undoRedo?.redo("api");
}
function $437b23f6a393c3bf$var$getEditRowValues(beans, rowNode) {
    return beans.editModelSvc?.getEditRowDataValue(rowNode, {
        checkSiblings: true
    });
}
function $437b23f6a393c3bf$var$getEditingCells(beans) {
    const edits = beans.editModelSvc?.getEditMap();
    const positions = [];
    edits?.forEach((editRow, rowNode)=>{
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode;
        editRow.forEach((editValue, column)=>{
            const { editorValue: editorValue, pendingValue: pendingValue, sourceValue: oldValue, state: state } = editValue;
            const diff = $437b23f6a393c3bf$var$_sourceAndPendingDiffer(editValue);
            let newValue = editorValue ?? pendingValue;
            if (newValue === $437b23f6a393c3bf$var$UNEDITED) newValue = void 0;
            const edit = {
                newValue: newValue,
                oldValue: oldValue,
                state: state,
                column: column,
                colId: column.getColId(),
                colKey: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
            const changed = state === "changed" && diff;
            const editing = state === "editing";
            if (editing || changed) positions.push(edit);
        });
    });
    return positions;
}
function $437b23f6a393c3bf$var$stopEditing(beans, cancel = false) {
    const { editSvc: editSvc } = beans;
    if (editSvc?.isBatchEditing()) {
        if (cancel) {
            for (const cellPosition of beans.editModelSvc?.getEditPositions() ?? [])if (cellPosition.state === "editing") editSvc.revertSingleCellEdit(cellPosition);
        } else $437b23f6a393c3bf$var$_syncFromEditors(beans, {
            persist: true
        });
        $437b23f6a393c3bf$var$_destroyEditors(beans, void 0, {
            cancel: cancel
        });
    } else editSvc?.stopEditing(void 0, {
        cancel: cancel,
        source: "edit",
        forceStop: !cancel,
        forceCancel: cancel
    });
}
function $437b23f6a393c3bf$var$isEditing(beans, cellPosition) {
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, cellPosition);
    return beans.editSvc?.isEditing(cellCtrl) ?? false;
}
function $437b23f6a393c3bf$var$startEditingCell(beans, params) {
    const { key: key, colKey: colKey, rowIndex: rowIndex, rowPinned: rowPinned } = params;
    const { editSvc: editSvc, colModel: colModel } = beans;
    const column = colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$545083624300f13d(12, {
            colKey: colKey
        });
        return;
    }
    const cellPosition = {
        rowIndex: rowIndex,
        rowPinned: rowPinned || null,
        column: column
    };
    const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(beans, cellPosition);
    if (!rowNode) {
        $437b23f6a393c3bf$export$545083624300f13d(290, {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        return;
    }
    if (!column.isCellEditable(rowNode)) return;
    const notPinned = rowPinned == null;
    if (notPinned) $437b23f6a393c3bf$var$ensureIndexVisible(beans, rowIndex);
    $437b23f6a393c3bf$var$ensureColumnVisible(beans, colKey);
    editSvc?.startEditing({
        rowNode: rowNode,
        column: column
    }, {
        event: key ? new KeyboardEvent("keydown", {
            key: key
        }) : void 0,
        source: "api"
    });
}
function $437b23f6a393c3bf$var$validateEdit(beans) {
    return beans.editSvc?.validateEdit() || null;
}
function $437b23f6a393c3bf$var$getCurrentUndoSize(beans) {
    return beans.undoRedo?.getCurrentUndoStackSize() ?? 0;
}
function $437b23f6a393c3bf$var$getCurrentRedoSize(beans) {
    return beans.undoRedo?.getCurrentRedoStackSize() ?? 0;
}
// packages/ag-grid-community/src/edit/cellEditors/popupEditorWrapper.ts
var $437b23f6a393c3bf$var$PopupEditorElement = {
    tag: "div",
    cls: "ag-popup-editor",
    attrs: {
        tabindex: "-1"
    }
};
var $437b23f6a393c3bf$var$PopupEditorWrapper = class extends $437b23f6a393c3bf$export$acd471c9223f27ae {
    constructor(params){
        super($437b23f6a393c3bf$var$PopupEditorElement);
        this.params = params;
    }
    postConstruct() {
        $437b23f6a393c3bf$var$_setDomData(this.gos, this.getGui(), "popupEditorWrapper", true);
        this.addKeyDownListener();
    }
    addKeyDownListener() {
        const eGui = this.getGui();
        const params = this.params;
        const listener = (event)=>{
            if (!$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, event, params.node, params.column, true)) params.onKeyDown(event);
        };
        this.addManagedElementListeners(eGui, {
            keydown: listener
        });
    }
};
// packages/ag-grid-community/src/edit/strategy/strategyUtils.ts
function $437b23f6a393c3bf$var$shouldStartEditing(beans, { column: column }, event, cellStartedEdit, source = "ui") {
    if (event instanceof KeyboardEvent && (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2 || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE && cellStartedEdit)) return true;
    const extendingRange = event?.shiftKey && beans.rangeSvc?.getCellRanges().length != 0;
    if (extendingRange) return false;
    const colDef = column?.getColDef();
    const clickCount = $437b23f6a393c3bf$var$deriveClickCount(beans.gos, colDef);
    const type = event?.type;
    if (type === "click" && event?.detail === 1 && clickCount === 1) return true;
    if (type === "dblclick" && event?.detail === 2 && clickCount === 2) return true;
    if (source === "api") return cellStartedEdit ?? false;
    return false;
}
function $437b23f6a393c3bf$var$deriveClickCount(gos, colDef) {
    if (gos.get("suppressClickEdit") === true) return 0;
    if (gos.get("singleClickEdit") === true) return 1;
    if (colDef?.singleClickEdit) return 1;
    return 2;
}
function $437b23f6a393c3bf$var$isCellEditable(beans, { rowNode: rowNode, column: column }, _source = "ui") {
    const editable = column.getColDef().editable;
    const editModelSvc = beans.editModelSvc;
    return column.isColumnFunc(rowNode, editable) || !!editModelSvc && editModelSvc.hasEdits({
        rowNode: rowNode,
        column: column
    }, {
        withOpenEditor: true
    });
}
function $437b23f6a393c3bf$var$isFullRowCellEditable(beans, position, source = "ui") {
    const editable = $437b23f6a393c3bf$var$isCellEditable(beans, position, source);
    if (editable === true || source === "ui") return editable;
    const columns = beans.colModel.getCols();
    return columns.some((col)=>$437b23f6a393c3bf$var$isCellEditable(beans, {
            rowNode: position.rowNode,
            column: col
        }, source));
}
// packages/ag-grid-community/src/edit/styles/style-utils.ts
var $437b23f6a393c3bf$var$editHighlightFn = (edit, includeEditing = false)=>{
    if (edit !== void 0) return $437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit) || includeEditing && edit.state === "editing";
};
function $437b23f6a393c3bf$var$_hasEdits(beans, position, includeEditing = false) {
    return $437b23f6a393c3bf$var$editHighlightFn(beans.editModelSvc?.getEdit(position), includeEditing);
}
var $437b23f6a393c3bf$var$nodeHasLeafEdit = (children, editModelSvc, column)=>{
    if (!children) return;
    for(let i = 0, len = children.length; i < len; ++i){
        const child = children[i];
        if (child.data) {
            const highlight = $437b23f6a393c3bf$var$editHighlightFn(editModelSvc?.getEdit({
                rowNode: child,
                column: column
            })) || $437b23f6a393c3bf$var$editHighlightFn(editModelSvc?.getEdit({
                rowNode: child.pinnedSibling,
                column: column
            }));
            if (highlight) return true;
        }
        if ($437b23f6a393c3bf$var$nodeHasLeafEdit(child.childrenAfterGroup, editModelSvc, column)) return true;
    }
};
function $437b23f6a393c3bf$var$_hasLeafEdits(beans, position) {
    const { column: column, rowNode: rowNode } = position;
    if (beans.gos.get("groupTotalRow") && !rowNode?.footer) return false;
    return $437b23f6a393c3bf$var$nodeHasLeafEdit(rowNode?.childrenAfterGroup, beans.editModelSvc, column);
}
function $437b23f6a393c3bf$var$_hasPinnedEdits(beans, { rowNode: rowNode, column: column }) {
    rowNode = rowNode.pinnedSibling;
    if (!rowNode) return;
    return $437b23f6a393c3bf$var$editHighlightFn(beans.editModelSvc?.getEdit({
        rowNode: rowNode,
        column: column
    }));
}
// packages/ag-grid-community/src/edit/styles/cellEditStyleFeature.ts
var $437b23f6a393c3bf$var$CellEditStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.beans = beans;
        this.editSvc = beans.editSvc;
        this.editModelSvc = beans.editModelSvc;
    }
    setComp(comp) {
        this.cellComp = comp;
        this.applyCellStyles();
    }
    applyCellStyles() {
        const { cellCtrl: cellCtrl, editSvc: editSvc, beans: beans } = this;
        if (editSvc?.isBatchEditing() && editSvc.isEditing()) {
            const state = $437b23f6a393c3bf$var$_hasEdits(beans, cellCtrl) || $437b23f6a393c3bf$var$_hasLeafEdits(beans, cellCtrl) || $437b23f6a393c3bf$var$_hasPinnedEdits(beans, cellCtrl);
            this.applyBatchingStyle(state);
        } else this.applyBatchingStyle(false);
        const hasErrors = !!this.editModelSvc?.getCellValidationModel().hasCellValidation(this.cellCtrl);
        this.cellComp.toggleCss("ag-cell-editing-error", hasErrors);
    }
    applyBatchingStyle(newState) {
        this.cellComp.toggleCss("ag-cell-editing", newState ?? false);
        this.cellComp.toggleCss("ag-cell-batch-edit", (newState && this.editSvc?.isBatchEditing()) ?? false);
    }
};
// packages/ag-grid-community/src/edit/styles/rowEditStyleFeature.ts
var $437b23f6a393c3bf$var$RowEditStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowCtrl, beans){
        super();
        this.rowCtrl = rowCtrl;
        this.beans = beans;
        this.gos = beans.gos;
        this.editSvc = beans.editSvc;
        this.editModelSvc = beans.editModelSvc;
    }
    applyRowStyles() {
        const { rowCtrl: rowCtrl, editModelSvc: editModelSvc, beans: beans } = this;
        let rowNode = rowCtrl.rowNode;
        let edits = editModelSvc?.getEditRow(rowNode);
        const hasErrors = this.editModelSvc?.getRowValidationModel().hasRowValidation({
            rowNode: rowNode
        });
        if (!edits && rowNode.pinnedSibling) {
            rowNode = rowNode.pinnedSibling;
            edits = editModelSvc?.getEditRow(rowNode);
        }
        if (edits) {
            const editing = Array.from(edits.keys()).some((column)=>{
                const position = {
                    rowNode: rowNode,
                    column: column
                };
                return $437b23f6a393c3bf$var$_hasEdits(beans, position, true) || $437b23f6a393c3bf$var$_hasLeafEdits(beans, position) || $437b23f6a393c3bf$var$_hasPinnedEdits(beans, position);
            });
            this.applyStyle(hasErrors, editing);
            return;
        }
        this.applyStyle(hasErrors);
    }
    applyStyle(hasErrors = false, editing = false) {
        const batchEdit = this.editSvc?.isBatchEditing() ?? false;
        const fullRow = this.gos.get("editType") === "fullRow";
        this.rowCtrl?.forEachGui(void 0, ({ rowComp: rowComp })=>{
            rowComp.toggleCss("ag-row-editing", fullRow && editing);
            rowComp.toggleCss("ag-row-batch-edit", fullRow && editing && batchEdit);
            rowComp.toggleCss("ag-row-inline-editing", editing);
            rowComp.toggleCss("ag-row-not-inline-editing", !editing);
            rowComp.toggleCss("ag-row-editing-invalid", fullRow && editing && hasErrors);
        });
    }
};
// packages/ag-grid-community/src/edit/utils/refresh.ts
var $437b23f6a393c3bf$var$purgeRows = ({ rowModel: rowModel, pinnedRowModel: pinnedRowModel, editModelSvc: editModelSvc }, rowNodes)=>{
    const found = /* @__PURE__ */ new Set();
    rowModel.forEachNode((node)=>rowNodes.has(node) && found.add(node));
    pinnedRowModel?.forEachPinnedRow("top", (node)=>rowNodes.has(node) && found.add(node));
    pinnedRowModel?.forEachPinnedRow("bottom", (node)=>rowNodes.has(node) && found.add(node));
    for (const rowNode of rowNodes)if (!found.has(rowNode)) editModelSvc.removeEdits({
        rowNode: rowNode
    });
    return found;
};
var $437b23f6a393c3bf$var$purgeCells = ({ editModelSvc: editModelSvc }, rowNodes, columns)=>{
    for (const rowNode of rowNodes)editModelSvc?.getEditRow(rowNode)?.forEach((_, column)=>!columns.has(column) && editModelSvc.removeEdits({
            rowNode: rowNode,
            column: column
        }));
};
var $437b23f6a393c3bf$var$_refreshEditCells = (beans)=>()=>{
        const columns = new Set(beans.colModel.getCols());
        const updates = beans.editModelSvc.getEditMap(true);
        const rowNodes = new Set(updates.keys());
        $437b23f6a393c3bf$var$purgeCells(beans, $437b23f6a393c3bf$var$purgeRows(beans, rowNodes), columns);
    };
// packages/ag-grid-community/src/edit/editService.ts
var $437b23f6a393c3bf$var$KEEP_EDITOR_SOURCES = /* @__PURE__ */ new Set([
    "undo",
    "redo",
    "paste",
    "bulk",
    "rangeSvc"
]);
var $437b23f6a393c3bf$var$INTERNAL_EDITOR_SOURCES = /* @__PURE__ */ new Set([
    "ui",
    "api"
]);
var $437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM = {
    paste: "api",
    rangeSvc: "api",
    fillHandle: "api",
    cellClear: "api",
    bulk: "api"
};
var $437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM_KEYS = new Set(Object.keys($437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM));
var $437b23f6a393c3bf$var$SET_DATA_SOURCE_AS_API = /* @__PURE__ */ new Set([
    "paste",
    "rangeSvc",
    "renderer",
    "cellClear",
    "redo",
    "undo"
]);
var $437b23f6a393c3bf$var$CANCEL_PARAMS = {
    cancel: true,
    source: "api"
};
var $437b23f6a393c3bf$var$COMMIT_PARAMS = {
    cancel: false,
    source: "api"
};
var $437b23f6a393c3bf$var$CHECK_SIBLING = {
    checkSiblings: true
};
var $437b23f6a393c3bf$var$FORCE_REFRESH = {
    force: true,
    suppressFlash: true
};
var $437b23f6a393c3bf$var$EditService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "editSvc";
        this.batch = false;
        this.stopping = false;
        this.committing = false;
    }
    postConstruct() {
        const { beans: beans } = this;
        this.model = beans.editModelSvc;
        this.valueSvc = beans.valueSvc;
        this.rangeSvc = beans.rangeSvc;
        this.addManagedPropertyListener("editType", ({ currentValue: currentValue })=>{
            this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
            this.createStrategy(currentValue);
        });
        const handler = $437b23f6a393c3bf$var$_refreshEditCells(beans);
        const stopInvalidEdits = ()=>{
            const hasCellValidation = this.model.getCellValidationModel().getCellValidationMap().size > 0;
            const hasRowValidation = this.model.getRowValidationModel().getRowValidationMap().size > 0;
            if (hasCellValidation || hasRowValidation) this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
            else if (this.isEditing()) {
                if (this.isBatchEditing()) $437b23f6a393c3bf$var$_destroyEditors(beans, this.model.getEditPositions());
                else this.stopEditing(void 0, $437b23f6a393c3bf$var$COMMIT_PARAMS);
            }
            return false;
        };
        this.addManagedEventListeners({
            columnPinned: handler,
            columnVisible: handler,
            columnRowGroupChanged: handler,
            rowExpansionStateChanged: handler,
            pinnedRowsChanged: handler,
            displayedRowsChanged: handler,
            sortChanged: stopInvalidEdits,
            filterChanged: stopInvalidEdits,
            cellFocused: this.onCellFocused.bind(this)
        });
    }
    isBatchEditing() {
        return this.batch;
    }
    setBatchEditing(enabled) {
        if (enabled) {
            this.batch = true;
            this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
        } else {
            this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
            this.batch = false;
        }
    }
    createStrategy(editType) {
        const { beans: beans, gos: gos, strategy: strategy } = this;
        const name = $437b23f6a393c3bf$var$getEditType(gos, editType);
        if (strategy) {
            if (strategy.beanName === name) return strategy;
            this.destroyStrategy();
        }
        return this.strategy = this.createOptionalManagedBean(beans.registry.createDynamicBean(name, true));
    }
    destroyStrategy() {
        if (!this.strategy) return;
        this.strategy.destroy();
        this.strategy = this.destroyBean(this.strategy);
    }
    shouldStartEditing(position, event, cellStartedEdit, source = "ui") {
        const shouldStart = $437b23f6a393c3bf$var$shouldStartEditing(this.beans, position, event, cellStartedEdit, source);
        if (shouldStart) this.strategy ?? (this.strategy = this.createStrategy());
        return shouldStart;
    }
    shouldStopEditing(position, event, source = "ui") {
        return this.strategy?.shouldStop(position, event, source) ?? null;
    }
    shouldCancelEditing(position, event, source = "ui") {
        return this.strategy?.shouldCancel(position, event, source) ?? null;
    }
    validateEdit() {
        return $437b23f6a393c3bf$var$_validateEdit(this.beans);
    }
    isEditing(position, params) {
        return this.model.hasEdits(position, params ?? $437b23f6a393c3bf$var$CHECK_SIBLING);
    }
    isRowEditing(rowNode, params) {
        return (rowNode && this.model.hasRowEdits(rowNode, params)) ?? false;
    }
    /** @returns whether to prevent default on event */ startEditing(position, params) {
        const { startedEdit: startedEdit = true, event: event = null, source: source = "ui", ignoreEventKey: ignoreEventKey = false, silent: silent } = params;
        this.strategy ?? (this.strategy = this.createStrategy());
        if (!this.isCellEditable(position, "api")) return;
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
        if (cellCtrl && !cellCtrl.comp) {
            cellCtrl.onCompAttachedFuncs.push(()=>this.startEditing(position, params));
            return;
        }
        const res = this.shouldStartEditing(position, event, startedEdit, source);
        if (res === false && source !== "api") {
            this.isEditing(position) && this.stopEditing();
            return;
        }
        if (!this.batch && this.shouldStopEditing(position, void 0, source) && !params.continueEditing) this.stopEditing(void 0, {
            source: source
        });
        if (res && this.isBatchEditing()) this.dispatchBatchEvent("batchEditingStarted", /* @__PURE__ */ new Map());
        this.strategy.start({
            position: position,
            event: event,
            source: source,
            ignoreEventKey: ignoreEventKey,
            startedEdit: startedEdit,
            silent: silent
        });
    }
    stopEditing(position, params) {
        const { event: event, cancel: cancel, source: source = "ui", forceCancel: forceCancel, forceStop: forceStop } = params || {};
        const { beans: beans, model: model } = this;
        if ($437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM_KEYS.has(source)) {
            if (this.isBatchEditing()) {
                this.bulkRefresh(position);
                return false;
            }
        }
        const treatAsSource = this.committing ? $437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM[source] : source;
        const isEditingOrBatchWithEdits = this.committing || this.isEditing(position) || this.isBatchEditing() && model.hasEdits(position, $437b23f6a393c3bf$var$CHECK_SIBLING);
        if (!isEditingOrBatchWithEdits || !this.strategy || this.stopping) return false;
        this.stopping = true;
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
        if (cellCtrl) cellCtrl.onEditorAttachedFuncs = [];
        let edits = model.getEditMap(true);
        let res = false;
        const willStop = !cancel && (!!this.shouldStopEditing(position, event, treatAsSource) || this.committing && !this.batch) || (forceStop ?? false);
        const willCancel = cancel && !!this.shouldCancelEditing(position, event, treatAsSource) || (forceCancel ?? false);
        if (willStop || willCancel) {
            $437b23f6a393c3bf$var$_syncFromEditors(beans, {
                persist: true,
                isCancelling: willCancel || cancel,
                isStopping: willStop
            });
            const freshEdits = model.getEditMap();
            const editsToDelete = this.processEdits(freshEdits, cancel, source);
            this.strategy?.stop(cancel, event);
            for (const position2 of editsToDelete)model.clearEditValue(position2);
            this.bulkRefresh(void 0, edits);
            for (const pos of model.getEditPositions(freshEdits)){
                const cellCtrl2 = $437b23f6a393c3bf$var$_getCellCtrl(beans, pos);
                const valueChanged = $437b23f6a393c3bf$var$_sourceAndPendingDiffer(pos);
                cellCtrl2?.refreshCell({
                    force: true,
                    suppressFlash: !valueChanged
                });
            }
            edits = freshEdits;
            res || (res = willStop);
        } else if (event instanceof KeyboardEvent && this.batch && this.strategy?.midBatchInputsAllowed(position) && this.isEditing(position, {
            withOpenEditor: true
        })) {
            const { key: key } = event;
            const isEnter = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
            const isEscape = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE;
            const isTab = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB;
            if (isEnter || isTab || isEscape) {
                if (isEnter || isTab) $437b23f6a393c3bf$var$_syncFromEditors(beans, {
                    persist: true
                });
                else if (isEscape) this.revertSingleCellEdit(cellCtrl);
                if (this.isBatchEditing()) this.strategy?.cleanupEditors();
                else $437b23f6a393c3bf$var$_destroyEditors(beans, model.getEditPositions(), {
                    event: event,
                    cancel: isEscape
                });
                event.preventDefault();
                this.bulkRefresh(position, edits, {
                    suppressFlash: true
                });
                edits = model.getEditMap();
            }
        } else {
            $437b23f6a393c3bf$var$_syncFromEditors(beans, {
                persist: true
            });
            edits = model.getEditMap();
        }
        if (res && position) this.model.removeEdits(position);
        this.navigateAfterEdit(params, cellCtrl?.cellPosition);
        $437b23f6a393c3bf$var$_purgeUnchangedEdits(beans);
        if (!this.model.hasEdits()) {
            this.model.getCellValidationModel().clearCellValidationMap();
            this.model.getRowValidationModel().clearRowValidationMap();
        }
        this.bulkRefresh();
        if (willCancel) this.beans.rowRenderer.refreshRows({
            rowNodes: Array.from(edits.keys())
        });
        if (this.isBatchEditing()) {
            this.beans.rowRenderer.refreshRows({
                suppressFlash: true,
                force: true
            });
            if (res && willStop) this.dispatchBatchEvent("batchEditingStopped", edits);
        }
        this.stopping = false;
        return res;
    }
    navigateAfterEdit(params, cellPosition) {
        if (!params || !cellPosition) return;
        const { event: event, suppressNavigateAfterEdit: suppressNavigateAfterEdit } = params;
        const isKeyBoardEvent = event instanceof KeyboardEvent;
        if (!isKeyBoardEvent || suppressNavigateAfterEdit) return;
        const { key: key, shiftKey: shiftKey } = event;
        const navAfterEdit = this.gos.get("enterNavigatesVerticallyAfterEdit");
        if (key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || !navAfterEdit) return;
        const direction = shiftKey ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP : $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        this.beans.navigation?.navigateToNextCell(null, direction, cellPosition, false);
    }
    processEdits(edits, cancel = false, source) {
        const rowNodes = Array.from(edits.keys());
        const hasValidationErrors = this.model.getCellValidationModel().getCellValidationMap().size > 0 || this.model.getRowValidationModel().getRowValidationMap().size > 0;
        const editsToDelete = [];
        for (const rowNode of rowNodes){
            const editRow = edits.get(rowNode);
            for (const column of editRow.keys()){
                const editValue = editRow.get(column);
                const position = {
                    rowNode: rowNode,
                    column: column
                };
                const valueChanged = $437b23f6a393c3bf$var$_sourceAndPendingDiffer(editValue);
                if (!cancel && valueChanged && !hasValidationErrors) {
                    const success = this.setNodeDataValue(rowNode, column, editValue.pendingValue, void 0, source);
                    if (!success) editsToDelete.push(position);
                }
            }
        }
        return editsToDelete;
    }
    setNodeDataValue(rowNode, column, newValue, refreshCell, originalSource = "edit") {
        const { beans: beans } = this;
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, {
            rowNode: rowNode,
            column: column
        });
        const translatedSource = $437b23f6a393c3bf$var$INTERNAL_EDITOR_SOURCES.has(originalSource) ? "edit" : originalSource;
        if (cellCtrl) cellCtrl.suppressRefreshCell = true;
        this.commitNextEdit();
        const success = rowNode.setDataValue(column, newValue, translatedSource);
        if (cellCtrl) cellCtrl.suppressRefreshCell = false;
        if (refreshCell) cellCtrl?.refreshCell($437b23f6a393c3bf$var$FORCE_REFRESH);
        return success;
    }
    setEditMap(edits, params) {
        this.strategy ?? (this.strategy = this.createStrategy());
        this.strategy?.setEditMap(edits, params);
        this.bulkRefresh();
        let refreshParams = $437b23f6a393c3bf$var$FORCE_REFRESH;
        if (params?.forceRefreshOfEditCellsOnly) refreshParams = {
            ...$437b23f6a393c3bf$var$getRowColumnsFromMap(edits),
            ...$437b23f6a393c3bf$var$FORCE_REFRESH
        };
        this.beans.rowRenderer.refreshCells(refreshParams);
    }
    dispatchEditValuesChanged({ rowNode: rowNode, column: column }, edit = {}) {
        if (!rowNode || !column || !edit) return;
        const { pendingValue: pendingValue, sourceValue: sourceValue } = edit;
        const { rowIndex: rowIndex, rowPinned: rowPinned, data: data } = rowNode;
        this.beans.eventSvc.dispatchEvent({
            type: "cellEditValuesChanged",
            node: rowNode,
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column,
            source: "api",
            data: data,
            newValue: pendingValue,
            oldValue: sourceValue,
            value: pendingValue,
            colDef: column.getColDef()
        });
    }
    bulkRefresh(position = {}, editMap, params = {}) {
        const { beans: beans, gos: gos } = this;
        const { editModelSvc: editModelSvc, rowModel: rowModel } = beans;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) {
            if (position.rowNode && position.column) this.refCell(position, this.model.getEdit(position), params);
            else if (editMap) editModelSvc?.getEditMap(false)?.forEach((editRow, rowNode)=>{
                for (const column of editRow.keys())this.refCell({
                    rowNode: rowNode,
                    column: column
                }, editRow.get(column), params);
            });
        }
    }
    refCell({ rowNode: rowNode, column: column }, edit, params = {}) {
        const { beans: beans, gos: gos } = this;
        const updatedNodes = /* @__PURE__ */ new Set([
            rowNode
        ]);
        const refreshNodes = /* @__PURE__ */ new Set();
        const pinnedSibling = rowNode.pinnedSibling;
        if (pinnedSibling) updatedNodes.add(pinnedSibling);
        const sibling = rowNode.sibling;
        if (sibling) refreshNodes.add(sibling);
        let parent = rowNode.parent;
        while(parent){
            if (parent.sibling?.footer && gos.get("groupTotalRow")) refreshNodes.add(parent.sibling);
            else if (!parent.parent && parent.sibling && gos.get("grandTotalRow")) refreshNodes.add(parent.sibling);
            else refreshNodes.add(parent);
            parent = parent.parent;
        }
        for (const node of updatedNodes)this.dispatchEditValuesChanged({
            rowNode: node,
            column: column
        }, edit);
        for (const node of updatedNodes)$437b23f6a393c3bf$var$_getCellCtrl(beans, {
            rowNode: node,
            column: column
        })?.refreshCell(params);
        for (const node of refreshNodes)$437b23f6a393c3bf$var$_getCellCtrl(beans, {
            rowNode: node,
            column: column
        })?.refreshCell(params);
    }
    stopAllEditing(cancel = false, source = "ui") {
        if (this.isEditing()) this.stopEditing(void 0, {
            cancel: cancel,
            source: source
        });
    }
    isCellEditable(position, source = "ui") {
        const { rowNode: rowNode } = position;
        const { gos: gos, beans: beans } = this;
        if (rowNode.group) {
            if (gos.get("treeData")) {
                if (!rowNode.data && !gos.get("enableGroupEdit")) return false;
            } else if (!gos.get("enableGroupEdit")) return false;
        }
        const isEditable = $437b23f6a393c3bf$var$getEditType(gos) === "fullRow" ? $437b23f6a393c3bf$var$isFullRowCellEditable(beans, position, source) : $437b23f6a393c3bf$var$isCellEditable(beans, position, source);
        if (isEditable) this.strategy ?? (this.strategy = this.createStrategy());
        return isEditable;
    }
    cellEditingInvalidCommitBlocks() {
        return this.gos.get("invalidEditValueMode") === "block";
    }
    checkNavWithValidation(position, event, focus = true) {
        if (this.hasValidationErrors(position)) {
            const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
            if (this.cellEditingInvalidCommitBlocks()) {
                event?.preventDefault?.();
                if (focus) {
                    !cellCtrl?.hasBrowserFocus() && cellCtrl?.focusCell();
                    cellCtrl?.comp?.getCellEditor()?.focusIn?.();
                }
                return "block-stop";
            }
            cellCtrl && this.revertSingleCellEdit(cellCtrl);
            return "revert-continue";
        }
        return "continue";
    }
    revertSingleCellEdit(cellPosition, focus = false) {
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, cellPosition);
        if (!cellCtrl?.comp?.getCellEditor()) return;
        $437b23f6a393c3bf$var$_destroyEditors(this.beans, [
            cellPosition
        ], {
            silent: true
        });
        this.model.clearEditValue(cellPosition);
        $437b23f6a393c3bf$var$_setupEditor(this.beans, cellPosition, {
            silent: true
        });
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
        cellCtrl?.refreshCell($437b23f6a393c3bf$var$FORCE_REFRESH);
        if (!focus) return;
        cellCtrl?.focusCell();
        cellCtrl?.comp?.getCellEditor()?.focusIn?.();
    }
    hasValidationErrors(position) {
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
        if (cellCtrl) {
            cellCtrl.refreshCell($437b23f6a393c3bf$var$FORCE_REFRESH);
            cellCtrl.rowCtrl.rowEditStyleFeature?.applyRowStyles();
        }
        let invalid = false;
        if (position?.rowNode) {
            invalid || (invalid = this.model.getRowValidationModel().hasRowValidation({
                rowNode: position.rowNode
            }));
            if (position.column) invalid || (invalid = this.model.getCellValidationModel().hasCellValidation({
                rowNode: position.rowNode,
                column: position.column
            }));
        } else {
            invalid || (invalid = this.model.getCellValidationModel().getCellValidationMap().size > 0);
            invalid || (invalid = this.model.getRowValidationModel().getRowValidationMap().size > 0);
        }
        return invalid;
    }
    moveToNextCell(prev, backwards, event, source = "ui") {
        let res;
        const editing = this.isEditing();
        const preventNavigation = editing && this.checkNavWithValidation(void 0, event) === "block-stop";
        if (prev instanceof $437b23f6a393c3bf$var$CellCtrl && editing) res = this.strategy?.moveToNextEditingCell(prev, backwards, event, source, preventNavigation);
        if (res === null) return res;
        res = res || !!this.beans.focusSvc.focusedHeader;
        if (res === false && !preventNavigation) this.stopEditing();
        return res;
    }
    getCellDataValue({ rowNode: rowNode, column: column }, preferEditor = true) {
        if (!rowNode || !column) return void 0;
        let edit = this.model.getEdit({
            rowNode: rowNode,
            column: column
        });
        const pinnedSibling = rowNode.pinnedSibling;
        if (pinnedSibling) {
            const siblingEdit = this.model.getEdit({
                rowNode: pinnedSibling,
                column: column
            });
            if (siblingEdit) edit = siblingEdit;
        }
        const newValue = preferEditor ? edit?.editorValue ?? edit?.pendingValue : edit?.pendingValue;
        return newValue === $437b23f6a393c3bf$var$UNEDITED || !edit ? edit?.sourceValue ?? this.valueSvc.getValue(column, rowNode, false, "api") : newValue;
    }
    addStopEditingWhenGridLosesFocus(viewports) {
        $437b23f6a393c3bf$var$_addStopEditingWhenGridLosesFocus(this, this.beans, viewports);
    }
    createPopupEditorWrapper(params) {
        return new $437b23f6a393c3bf$var$PopupEditorWrapper(params);
    }
    commitNextEdit() {
        this.committing = true;
    }
    setDataValue(position, newValue, eventSource) {
        try {
            if ((!this.isEditing() || this.committing) && !$437b23f6a393c3bf$var$SET_DATA_SOURCE_AS_API.has(eventSource)) return;
            const { beans: beans } = this;
            this.strategy ?? (this.strategy = this.createStrategy());
            const source = this.isBatchEditing() ? "ui" : this.committing ? eventSource ?? "api" : "api";
            if (!eventSource || $437b23f6a393c3bf$var$KEEP_EDITOR_SOURCES.has(eventSource)) {
                $437b23f6a393c3bf$var$_syncFromEditor(beans, position, newValue, eventSource, void 0, {
                    persist: true
                });
                return this.setNodeDataValue(position.rowNode, position.column, newValue, true, eventSource);
            }
            const existing = this.model.getEdit(position);
            if (existing) {
                if (existing.pendingValue === newValue) return false;
                if (existing.sourceValue !== newValue) {
                    $437b23f6a393c3bf$var$_syncFromEditor(beans, position, newValue, eventSource, void 0, {
                        persist: true
                    });
                    this.stopEditing(position, {
                        source: source,
                        suppressNavigateAfterEdit: true
                    });
                    return true;
                }
                if (existing.sourceValue === newValue) {
                    beans.editModelSvc?.removeEdits(position);
                    this.dispatchEditValuesChanged(position, {
                        ...existing,
                        pendingValue: newValue
                    });
                    return true;
                }
            }
            $437b23f6a393c3bf$var$_syncFromEditor(beans, position, newValue, eventSource, void 0, {
                persist: true
            });
            this.stopEditing(position, {
                source: source,
                suppressNavigateAfterEdit: true
            });
            return true;
        } finally{
            this.committing = false;
        }
    }
    handleColDefChanged(cellCtrl) {
        $437b23f6a393c3bf$var$_refreshEditorOnColDefChanged(this.beans, cellCtrl);
    }
    destroy() {
        this.model.clear();
        this.destroyStrategy();
        super.destroy();
    }
    prepDetailsDuringBatch(position, params) {
        if (!this.batch) return;
        const hasEdits = this.model.hasRowEdits(position.rowNode, $437b23f6a393c3bf$var$CHECK_SIBLING);
        if (!hasEdits) return;
        const { rowNode: rowNode, column: column } = position;
        const { compDetails: compDetails, valueToDisplay: valueToDisplay } = params;
        if (compDetails) {
            const { params: params2 } = compDetails;
            params2.data = this.model.getEditRowDataValue(rowNode, $437b23f6a393c3bf$var$CHECK_SIBLING);
            return {
                compDetails: compDetails
            };
        }
        const editRow = this.model.getEditRow(position.rowNode, $437b23f6a393c3bf$var$CHECK_SIBLING);
        if (valueToDisplay !== void 0 && editRow?.has(column)) return {
            valueToDisplay: this.valueSvc.getValue(column, rowNode)
        };
    }
    cleanupEditors() {
        this.strategy?.cleanupEditors();
    }
    dispatchCellEvent(position, event, type, payload) {
        this.strategy?.dispatchCellEvent(position, event, type, payload);
    }
    dispatchBatchEvent(type, edits) {
        this.eventSvc.dispatchEvent(this.createBatchEditEvent(type, edits));
    }
    createBatchEditEvent(type, edits) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            ...type === "batchEditingStopped" ? {
                changes: this.toEventChangeList(edits)
            } : {}
        });
    }
    toEventChangeList(edits) {
        return this.model.getEditPositions(edits).map((edit)=>({
                rowIndex: edit.rowNode.rowIndex,
                rowPinned: edit.rowNode.rowPinned,
                columnId: edit.column.getColId(),
                newValue: edit.pendingValue,
                oldValue: edit.sourceValue
            }));
    }
    applyBulkEdit({ rowNode: rowNode, column: column }, ranges) {
        if (!ranges || ranges.length === 0) return;
        const { beans: beans, rangeSvc: rangeSvc, valueSvc: valueSvc } = this;
        $437b23f6a393c3bf$var$_syncFromEditors(beans, {
            persist: true
        });
        const edits = this.model.getEditMap(true);
        const editValue = edits.get(rowNode)?.get(column)?.pendingValue;
        if (!this.batch) this.eventSvc.dispatchEvent({
            type: "bulkEditingStarted"
        });
        ranges.forEach((range)=>{
            rangeSvc?.forEachRowInRange(range, (position)=>{
                const rowNode2 = $437b23f6a393c3bf$export$d4675a60917db7b0(beans, position);
                if (rowNode2 === void 0) return;
                const editRow = edits.get(rowNode2) ?? /* @__PURE__ */ new Map();
                for (const column2 of range.columns){
                    if (!column2) continue;
                    if (this.isCellEditable({
                        rowNode: rowNode2,
                        column: column2
                    }, "api")) {
                        const sourceValue = valueSvc.getValue(column2, rowNode2, true, "api");
                        let pendingValue = valueSvc.parseValue(column2, rowNode2 ?? null, editValue, sourceValue);
                        if (Number.isNaN(pendingValue)) pendingValue = null;
                        editRow.set(column2, {
                            editorValue: void 0,
                            pendingValue: pendingValue,
                            sourceValue: sourceValue,
                            state: "changed",
                            editorState: {
                                isCancelAfterEnd: void 0,
                                isCancelBeforeStart: void 0
                            }
                        });
                    }
                }
                if (editRow.size > 0) edits.set(rowNode2, editRow);
            });
            this.setEditMap(edits);
            if (this.batch) {
                this.cleanupEditors();
                $437b23f6a393c3bf$var$_purgeUnchangedEdits(beans);
                this.bulkRefresh();
                return;
            }
            this.commitNextEdit();
            this.stopEditing(void 0, {
                source: "bulk"
            });
            this.eventSvc.dispatchEvent({
                type: "bulkEditingStopped",
                changes: this.toEventChangeList(edits)
            });
        });
        this.bulkRefresh();
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, {
            rowNode: rowNode,
            column: column
        });
        if (cellCtrl) cellCtrl.focusCell(true);
    }
    createCellStyleFeature(cellCtrl, beans) {
        return new $437b23f6a393c3bf$var$CellEditStyleFeature(cellCtrl, beans);
    }
    createRowStyleFeature(rowCtrl, beans) {
        return new $437b23f6a393c3bf$var$RowEditStyleFeature(rowCtrl, beans);
    }
    setEditingCells(cells, params) {
        const { beans: beans } = this;
        const { colModel: colModel, valueSvc: valueSvc } = beans;
        const edits = /* @__PURE__ */ new Map();
        for (let { colId: colId, column: column, colKey: colKey, rowIndex: rowIndex, rowPinned: rowPinned, newValue: pendingValue, state: state } of cells){
            const col = colId ? colModel.getCol(colId) : colKey ? colModel.getCol(colKey) : column;
            if (!col) continue;
            const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(beans, {
                rowIndex: rowIndex,
                rowPinned: rowPinned
            });
            if (!rowNode) continue;
            const sourceValue = valueSvc.getValue(col, rowNode, true, "api");
            if (!params?.forceRefreshOfEditCellsOnly && !$437b23f6a393c3bf$var$_sourceAndPendingDiffer({
                pendingValue: pendingValue,
                sourceValue: sourceValue
            }) && state !== "editing") continue;
            let editRow = edits.get(rowNode);
            if (!editRow) {
                editRow = /* @__PURE__ */ new Map();
                edits.set(rowNode, editRow);
            }
            if (pendingValue === void 0) pendingValue = $437b23f6a393c3bf$var$UNEDITED;
            editRow.set(col, {
                editorValue: void 0,
                pendingValue: pendingValue,
                sourceValue: sourceValue,
                state: state ?? "changed",
                editorState: {
                    isCancelAfterEnd: void 0,
                    isCancelBeforeStart: void 0
                }
            });
        }
        this.setEditMap(edits, params);
    }
    onCellFocused(event) {
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, event);
        if (!cellCtrl || !this.isEditing(cellCtrl, $437b23f6a393c3bf$var$CHECK_SIBLING)) return;
        const edit = this.model.getEdit(cellCtrl);
        if (!edit || !$437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit)) return;
        const translate = this.getLocaleTextFunc();
        const label = translate("ariaPendingChange", "Pending Change");
        this.beans.ariaAnnounce?.announceValue(label, "pendingChange");
    }
    allowedFocusTargetOnValidation(cellPosition) {
        return $437b23f6a393c3bf$var$_getCellCtrl(this.beans, cellPosition);
    }
};
function $437b23f6a393c3bf$var$getRowColumnsFromMap(edits) {
    return {
        rowNodes: edits ? Array.from(edits.keys()) : void 0,
        columns: edits ? [
            ...new Set(Array.from(edits.values()).flatMap((er)=>Array.from(er.keys())))
        ] : void 0
    };
}
function $437b23f6a393c3bf$var$getEditType(gos, editType) {
    return editType ?? gos.get("editType") ?? "singleCell";
}
// packages/ag-grid-community/src/edit/strategy/baseEditStrategy.ts
var $437b23f6a393c3bf$var$BaseEditStrategy = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        this.model = this.beans.editModelSvc;
        this.editSvc = this.beans.editSvc;
        this.addManagedEventListeners({
            cellFocused: this.onCellFocusChanged?.bind(this),
            cellFocusCleared: this.onCellFocusChanged?.bind(this)
        });
    }
    clearEdits(position) {
        this.model.clearEditValue(position);
    }
    onCellFocusChanged(event) {
        let cellCtrl;
        const previous = event["previousParams"];
        const { editSvc: editSvc, beans: beans } = this;
        const sourceEvent = event.type === "cellFocused" ? event.sourceEvent : null;
        if (previous) cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, previous);
        const { gos: gos, editModelSvc: editModelSvc } = beans;
        const isFocusCleared = event.type === "cellFocusCleared";
        if (editSvc.isEditing(void 0, {
            withOpenEditor: true
        })) {
            const { column: column, rowIndex: rowIndex, rowPinned: rowPinned } = event;
            const cellPositionFromEvent = {
                column: column,
                rowNode: $437b23f6a393c3bf$export$d4675a60917db7b0(beans, {
                    rowIndex: rowIndex,
                    rowPinned: rowPinned
                })
            };
            const isBlock = gos.get("invalidEditValueMode") === "block";
            if (isBlock) return;
            const shouldRevert = !isBlock;
            const hasError = !!editModelSvc?.getCellValidationModel().hasCellValidation(cellPositionFromEvent);
            const shouldCancel = shouldRevert && hasError;
            const result = previous || isFocusCleared ? editSvc.stopEditing(void 0, {
                cancel: shouldCancel,
                source: isFocusCleared && shouldRevert ? "api" : void 0,
                event: sourceEvent
            }) : true;
            if (!result) {
                if (editSvc.isBatchEditing()) editSvc.cleanupEditors();
                else editSvc.stopEditing(void 0, {
                    source: "api"
                });
            }
        }
        cellCtrl?.refreshCell({
            suppressFlash: true,
            force: true
        });
    }
    stop(cancel, event) {
        const editingCells = this.model.getEditPositions();
        const results = {
            all: [],
            pass: [],
            fail: []
        };
        for (const cell of editingCells){
            results.all.push(cell);
            const validation = this.model.getCellValidationModel().getCellValidation(cell);
            if ((validation?.errorMessages?.length ?? 0) > 0) {
                results.fail.push(cell);
                continue;
            }
            results.pass.push(cell);
        }
        if (cancel) for (const cell of editingCells){
            $437b23f6a393c3bf$var$_destroyEditor(this.beans, cell, {
                cancel: cancel
            });
            this.model.stop(cell);
        }
        else {
            const actions = this.processValidationResults(results);
            if (actions.destroy.length > 0) for (const cell of actions.destroy){
                $437b23f6a393c3bf$var$_destroyEditor(this.beans, cell, {
                    event: event,
                    cancel: cancel
                });
                this.model.stop(cell);
            }
            if (actions.keep.length > 0) for (const cell of actions.keep){
                const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, cell);
                if (!this.editSvc?.cellEditingInvalidCommitBlocks()) cellCtrl && this.editSvc.revertSingleCellEdit(cellCtrl);
            }
        }
        return true;
    }
    cleanupEditors({ rowNode: rowNode } = {}, includeEditing) {
        $437b23f6a393c3bf$var$_syncFromEditors(this.beans, {
            persist: false
        });
        const positions = this.model.getEditPositions();
        const discard = [];
        if (rowNode) {
            for (const pos of positions)if (pos.rowNode !== rowNode) discard.push(pos);
        } else for (const pos of positions)discard.push(pos);
        $437b23f6a393c3bf$var$_destroyEditors(this.beans, discard);
        $437b23f6a393c3bf$var$_purgeUnchangedEdits(this.beans, includeEditing);
    }
    setFocusOutOnEditor(cellCtrl) {
        cellCtrl.comp?.getCellEditor()?.focusOut?.();
    }
    setFocusInOnEditor(cellCtrl) {
        const comp = cellCtrl.comp;
        const editor = comp?.getCellEditor();
        if (editor?.focusIn) editor.focusIn();
        else {
            const isFullRow = this.beans.gos.get("editType") === "fullRow";
            cellCtrl.focusCell(isFullRow);
            cellCtrl.onEditorAttachedFuncs.push(()=>comp?.getCellEditor()?.focusIn?.());
        }
    }
    setupEditors(params) {
        const { event: event, ignoreEventKey: ignoreEventKey = false, startedEdit: startedEdit, position: position, cells: cells = this.model.getEditPositions() } = params;
        const key = event instanceof KeyboardEvent && !ignoreEventKey && event.key || void 0;
        $437b23f6a393c3bf$var$_setupEditors(this.beans, cells, position, key, event, startedEdit);
    }
    dispatchCellEvent(position, event, type, payload) {
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
        if (cellCtrl) this.eventSvc.dispatchEvent({
            ...cellCtrl.createEvent(event ?? null, type),
            ...payload
        });
    }
    dispatchRowEvent(position, type, silent) {
        if (silent) return;
        const rowCtrl = $437b23f6a393c3bf$var$_getRowCtrl(this.beans, position);
        if (rowCtrl) this.eventSvc.dispatchEvent(rowCtrl.createRowEvent(type));
    }
    shouldStop(_position, event, source = "ui") {
        const batch = this.editSvc.isBatchEditing();
        if (batch && source === "api") return true;
        if (batch && (source === "ui" || source === "edit")) return false;
        if (source === "api") return true;
        if (event instanceof KeyboardEvent && !batch) return event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
        return null;
    }
    shouldCancel(_position, event, source = "ui") {
        const batch = this.editSvc.isBatchEditing();
        if (event instanceof KeyboardEvent && !batch) {
            const result = event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE;
            if (result) return true;
        }
        if (batch && source === "api") return true;
        if (source === "api") return true;
        return false;
    }
    setEditMap(edits, params) {
        if (!params?.update) this.editSvc.stopEditing(void 0, {
            cancel: true,
            source: "api"
        });
        const cells = [];
        edits.forEach((editRow, rowNode)=>{
            editRow.forEach((cellData, column)=>{
                if (cellData.state === "editing") cells.push({
                    ...cellData,
                    rowNode: rowNode,
                    column: column
                });
            });
        });
        if (params?.update) edits = new Map([
            ...this.model.getEditMap(),
            ...edits
        ]);
        this.model?.setEditMap(edits);
        if (cells.length > 0) {
            const position = cells.at(-1);
            const key = position.pendingValue === $437b23f6a393c3bf$var$UNEDITED ? void 0 : position.pendingValue;
            this.start({
                position: position,
                event: new KeyboardEvent("keydown", {
                    key: key
                }),
                source: "api"
            });
            const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
            if (cellCtrl) this.setFocusInOnEditor(cellCtrl);
        }
    }
    destroy() {
        this.cleanupEditors();
        super.destroy();
    }
};
// packages/ag-grid-community/src/edit/strategy/fullRowEditStrategy.ts
var $437b23f6a393c3bf$var$FullRowEditStrategy = class extends $437b23f6a393c3bf$var$BaseEditStrategy {
    constructor(){
        super(...arguments);
        this.beanName = "fullRow";
        this.startedRows = [];
    }
    shouldStop(position, event, _source = "ui") {
        const { rowNode: rowNode } = position || {};
        const oldRowCtrl = $437b23f6a393c3bf$var$_getRowCtrl(this.beans, {
            rowNode: this.rowNode
        });
        if (!oldRowCtrl) return true;
        const res = super.shouldStop({
            rowNode: this.rowNode
        }, event, _source);
        if (res !== null) return res;
        if (!this.rowNode) return false;
        return rowNode !== this.rowNode;
    }
    midBatchInputsAllowed({ rowNode: rowNode }) {
        if (!rowNode) return false;
        return this.model.hasEdits({
            rowNode: rowNode
        });
    }
    clearEdits(position) {
        this.model.clearEditValue(position);
    }
    start(params) {
        const { position: position, silent: silent, startedEdit: startedEdit, event: event, ignoreEventKey: ignoreEventKey } = params;
        const { rowNode: rowNode } = position;
        if (this.rowNode !== rowNode) super.cleanupEditors(position);
        const columns = this.beans.visibleCols.allCols;
        const cells = [];
        const editableColumns = [];
        for (const column of columns)if (column.isCellEditable(rowNode)) editableColumns.push(column);
        if (editableColumns.length == 0) return;
        this.dispatchRowEvent({
            rowNode: rowNode
        }, "rowEditingStarted", silent);
        this.startedRows.push(rowNode);
        for (const column of editableColumns){
            const position2 = {
                rowNode: rowNode,
                column: column
            };
            cells.push(position2);
            if (!this.model.hasEdits(position2)) this.model.start(position2);
        }
        this.rowNode = rowNode;
        this.setupEditors({
            cells: cells,
            position: position,
            startedEdit: startedEdit,
            event: event,
            ignoreEventKey: ignoreEventKey
        });
    }
    processValidationResults(results) {
        const anyFailed = results.fail.length > 0;
        if (anyFailed && this.editSvc.cellEditingInvalidCommitBlocks()) return {
            destroy: [],
            keep: results.all
        };
        return {
            destroy: results.all,
            keep: []
        };
    }
    stop(cancel, event) {
        const { rowNode: rowNode } = this;
        if (rowNode && !this.model.hasRowEdits(rowNode)) return false;
        const changedRows = [];
        if (!cancel) this.model.getEditMap().forEach((rowEdits, rowNode2)=>{
            if (!rowEdits || rowEdits.size === 0) return;
            for (const edit of rowEdits.values())if ($437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit)) {
                changedRows.push(rowNode2);
                break;
            }
        });
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
        if (!cancel && this.editSvc?.checkNavWithValidation({
            rowNode: rowNode
        }) === "block-stop") return false;
        super.stop(cancel, event);
        for (const rowNode2 of changedRows)this.dispatchRowEvent({
            rowNode: rowNode2
        }, "rowValueChanged");
        this.cleanupEditors({
            rowNode: rowNode
        }, true);
        this.rowNode = void 0;
        return true;
    }
    onCellFocusChanged(event) {
        const { rowIndex: rowIndex } = event;
        const prev = event["previousParams"];
        if (prev?.rowIndex === rowIndex || event.sourceEvent instanceof KeyboardEvent) return;
        const prevCell = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, prev);
        const isBlock = this.gos.get("invalidEditValueMode") === "block";
        if (isBlock && prevCell && (this.model.getCellValidationModel().getCellValidation(prevCell) || this.model.getRowValidationModel().getRowValidation(prevCell))) return;
        super.onCellFocusChanged(event);
    }
    cleanupEditors(position = {}, includeEditing) {
        super.cleanupEditors(position, includeEditing);
        for (const rowNode of this.startedRows)this.dispatchRowEvent({
            rowNode: rowNode
        }, "rowEditingStopped");
        this.startedRows.length = 0;
    }
    // returns null if no navigation should be performed
    moveToNextEditingCell(prevCell, backwards, event, source = "ui", preventNavigation = false) {
        const prevPos = prevCell.cellPosition;
        let nextCell;
        this.model.suspend(true);
        try {
            nextCell = this.beans.navigation?.findNextCellToFocusOn(prevPos, {
                backwards: backwards,
                startEditing: true,
                // Default behaviour for fullRow is skip to the next cell,
                // editable or not. FullRow editing might have some editable
                // and some not editable cells in the row.
                // More complex logic needed to skip to the
                // next FullRow editable cell,
                skipToNextEditableCell: false
            });
        } finally{
            this.model.suspend(false);
        }
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        const nextPos = nextCell.cellPosition;
        const prevEditable = prevCell.isCellEditable();
        const nextEditable = nextCell.isCellEditable();
        const rowsMatch = nextPos && prevPos.rowIndex === nextPos.rowIndex && prevPos.rowPinned === nextPos.rowPinned;
        if (prevEditable) this.setFocusOutOnEditor(prevCell);
        this.restoreEditors();
        const suppressStartEditOnTab = this.gos.get("suppressStartEditOnTab");
        if (nextEditable && !preventNavigation) {
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else {
                if (!nextCell.comp?.getCellEditor()) $437b23f6a393c3bf$var$_setupEditor(this.beans, nextCell, {
                    event: event,
                    cellStartedEdit: true
                });
                this.setFocusInOnEditor(nextCell);
                nextCell.focusCell(false, event);
            }
        } else {
            if (nextEditable && preventNavigation) this.setFocusInOnEditor(nextCell);
            nextCell.focusCell(true, event);
        }
        if (!rowsMatch && !preventNavigation) {
            this.editSvc?.stopEditing({
                rowNode: prevCell.rowNode
            }, {
                event: event
            });
            this.cleanupEditors(nextCell, true);
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else this.editSvc.startEditing(nextCell, {
                startedEdit: true,
                event: event,
                source: source,
                ignoreEventKey: true
            });
        }
        prevCell.rowCtrl?.refreshRow({
            suppressFlash: true,
            force: true
        });
        return true;
    }
    restoreEditors() {
        this.model.getEditMap().forEach((rowEdits, rowNode)=>rowEdits.forEach(({ state: state }, column)=>{
                if (state !== "editing") return;
                const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, {
                    rowNode: rowNode,
                    column: column
                });
                if (cellCtrl && !cellCtrl.comp?.getCellEditor()) $437b23f6a393c3bf$var$_setupEditor(this.beans, cellCtrl, {
                    silent: true
                });
            }));
    }
    destroy() {
        super.destroy();
        this.rowNode = void 0;
        this.startedRows.length = 0;
    }
};
// packages/ag-grid-community/src/edit/strategy/singleCellEditStrategy.ts
var $437b23f6a393c3bf$var$SingleCellEditStrategy = class extends $437b23f6a393c3bf$var$BaseEditStrategy {
    constructor(){
        super(...arguments);
        this.beanName = "singleCell";
    }
    shouldStop(position, event, source = "ui") {
        const res = super.shouldStop(position, event, source);
        if (res !== null) return res;
        const { rowNode: rowNode, column: column } = position || {};
        if ((!this.rowNode || !this.column) && rowNode && column) return null;
        return this.rowNode !== rowNode || this.column !== column;
    }
    midBatchInputsAllowed(position) {
        return this.model.hasEdits(position);
    }
    start(params) {
        const { position: position, startedEdit: startedEdit, event: event, ignoreEventKey: ignoreEventKey } = params;
        if (this.rowNode !== position.rowNode || this.column !== position.column) super.cleanupEditors();
        this.rowNode = position.rowNode;
        this.column = position.column;
        this.model.start(position);
        this.setupEditors({
            cells: [
                position
            ],
            position: position,
            startedEdit: startedEdit,
            event: event,
            ignoreEventKey: ignoreEventKey
        });
    }
    dispatchRowEvent(_position, _type, _silent) {}
    processValidationResults(results) {
        const anyFailed = results.fail.length > 0;
        if (anyFailed && this.editSvc.cellEditingInvalidCommitBlocks()) return {
            destroy: [],
            keep: results.all
        };
        return {
            destroy: results.all,
            keep: []
        };
    }
    stop(cancel, event) {
        super.stop(cancel, event);
        this.rowNode = void 0;
        this.column = void 0;
        return true;
    }
    onCellFocusChanged(event) {
        const { colModel: colModel, editSvc: editSvc } = this.beans;
        const { rowIndex: rowIndex, column: column, rowPinned: rowPinned } = event;
        const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        const curColId = $437b23f6a393c3bf$var$_getColId(column);
        const curCol = colModel.getCol(curColId);
        const previous = event["previousParams"];
        if (previous) {
            const prevColId = $437b23f6a393c3bf$var$_getColId(previous.column);
            if (previous?.rowIndex === rowIndex && prevColId === curColId && previous?.rowPinned === rowPinned) return;
        }
        if (editSvc?.isEditing({
            rowNode: rowNode,
            column: curCol
        }, {
            withOpenEditor: true
        }) && event.type === "cellFocused") return;
        super.onCellFocusChanged(event);
    }
    // returns null if no navigation should be performed
    moveToNextEditingCell(prevCell, backwards, event, source = "ui", preventNavigation = false) {
        const focusedCell = this.beans.focusSvc.getFocusedCell();
        if (focusedCell) prevCell = $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, focusedCell) ?? prevCell;
        const prevPos = prevCell.cellPosition;
        let nextCell;
        const shouldSuspend = this.beans.gos.get("editType") === "fullRow";
        if (shouldSuspend) this.model.suspend(true);
        if (!preventNavigation) {
            prevCell.eGui.focus();
            this.editSvc?.stopEditing(prevCell, {
                source: this.editSvc?.isBatchEditing() ? "ui" : "api",
                event: event
            });
        }
        try {
            nextCell = this.beans.navigation?.findNextCellToFocusOn(prevPos, {
                backwards: backwards,
                startEditing: true
            });
        } finally{
            if (shouldSuspend) this.model.suspend(false);
        }
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        const nextPos = nextCell.cellPosition;
        const prevEditable = prevCell.isCellEditable();
        const nextEditable = nextCell.isCellEditable();
        const rowsMatch = nextPos && prevPos.rowIndex === nextPos.rowIndex && prevPos.rowPinned === nextPos.rowPinned;
        if (prevEditable && !preventNavigation) this.setFocusOutOnEditor(prevCell);
        const suppressStartEditOnTab = this.gos.get("suppressStartEditOnTab");
        if (!rowsMatch && !preventNavigation) {
            super.cleanupEditors(nextCell, true);
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else this.editSvc.startEditing(nextCell, {
                startedEdit: true,
                event: event,
                source: source,
                ignoreEventKey: true
            });
        }
        if (nextEditable && !preventNavigation) {
            nextCell.focusCell(false, event);
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else if (!nextCell.comp?.getCellEditor()) {
                const alreadyEditing = this.editSvc?.isEditing(nextCell, {
                    withOpenEditor: true
                });
                $437b23f6a393c3bf$var$_setupEditor(this.beans, nextCell, {
                    event: event,
                    cellStartedEdit: true,
                    silent: alreadyEditing
                });
                this.setFocusInOnEditor(nextCell);
                this.cleanupEditors(nextCell);
            }
        } else {
            if (nextEditable && preventNavigation) this.setFocusInOnEditor(nextCell);
            nextCell.focusCell(true, event);
        }
        prevCell.rowCtrl?.refreshRow({
            suppressFlash: true,
            force: true
        });
        return true;
    }
    destroy() {
        super.destroy();
        this.rowNode = void 0;
        this.column = void 0;
    }
};
// packages/ag-grid-community/src/edit/editModule.ts
var $437b23f6a393c3bf$export$12c61a50add34259 = {
    moduleName: "EditCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$EditModelService,
        $437b23f6a393c3bf$var$EditService
    ],
    apiFunctions: {
        getEditingCells: $437b23f6a393c3bf$var$getEditingCells,
        getEditRowValues: $437b23f6a393c3bf$var$getEditRowValues,
        getCellEditorInstances: $437b23f6a393c3bf$var$getCellEditorInstances,
        startEditingCell: $437b23f6a393c3bf$var$startEditingCell,
        stopEditing: $437b23f6a393c3bf$var$stopEditing,
        isEditing: $437b23f6a393c3bf$var$isEditing,
        validateEdit: $437b23f6a393c3bf$var$validateEdit
    },
    dynamicBeans: {
        singleCell: $437b23f6a393c3bf$var$SingleCellEditStrategy,
        fullRow: $437b23f6a393c3bf$var$FullRowEditStrategy
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d,
        $437b23f6a393c3bf$export$d0c662c133b8814e
    ],
    css: [
        $437b23f6a393c3bf$var$cellEditingCSS
    ]
};
var $437b23f6a393c3bf$export$2bb59c6ee8834731 = {
    moduleName: "UndoRedoEdit",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$UndoRedoService
    ],
    apiFunctions: {
        undoCellEditing: $437b23f6a393c3bf$var$undoCellEditing,
        redoCellEditing: $437b23f6a393c3bf$var$redoCellEditing,
        getCurrentUndoSize: $437b23f6a393c3bf$var$getCurrentUndoSize,
        getCurrentRedoSize: $437b23f6a393c3bf$var$getCurrentRedoSize
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$5e6636bea954ad4e = {
    moduleName: "TextEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCellEditor: $437b23f6a393c3bf$var$TextCellEditor,
        agTextCellEditor: $437b23f6a393c3bf$var$TextCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$9bc83f811986c4f2 = {
    moduleName: "NumberEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agNumberCellEditor: {
            classImp: $437b23f6a393c3bf$var$NumberCellEditor
        }
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$d1dd3475f4d98a27 = {
    moduleName: "DateEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agDateCellEditor: $437b23f6a393c3bf$var$DateCellEditor,
        agDateStringCellEditor: $437b23f6a393c3bf$var$DateStringCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$b6d3a45586965934 = {
    moduleName: "CheckboxEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCheckboxCellEditor: $437b23f6a393c3bf$var$CheckboxCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$ccaa44b10c75f1d = {
    moduleName: "SelectEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agSelectCellEditor: $437b23f6a393c3bf$var$SelectCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$e1b6b5aa47694f20 = {
    moduleName: "LargeTextEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agLargeTextCellEditor: $437b23f6a393c3bf$var$LargeTextCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$e1d2707568ed81f6 = {
    moduleName: "CustomEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
// packages/ag-grid-community/src/columns/selectionColService.ts
var $437b23f6a393c3bf$var$SelectionColService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "selectionColSvc";
    }
    postConstruct() {
        this.addManagedPropertyListener("rowSelection", (event)=>{
            this.onSelectionOptionsChanged(event.currentValue, event.previousValue, $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source));
        });
        this.addManagedPropertyListener("selectionColumnDef", this.updateColumns.bind(this));
    }
    addColumns(cols) {
        const selectionCols = this.columns;
        if (selectionCols == null) return;
        cols.list = selectionCols.list.concat(cols.list);
        cols.tree = selectionCols.tree.concat(cols.tree);
        $437b23f6a393c3bf$export$c82fd63ff1738bed(cols);
    }
    createColumns(cols, updateOrders) {
        const destroyCollection = ()=>{
            $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.columns?.tree);
            this.columns = null;
        };
        const newTreeDepth = cols.treeDepth;
        const oldTreeDepth = this.columns?.treeDepth ?? -1;
        const treeDepthSame = oldTreeDepth == newTreeDepth;
        const list = this.generateSelectionCols();
        const areSame = $437b23f6a393c3bf$export$f56e341a1fe35ed4(list, this.columns?.list ?? []);
        if (areSame && treeDepthSame) return;
        destroyCollection();
        const { colGroupSvc: colGroupSvc } = this.beans;
        const treeDepth = colGroupSvc?.findDepth(cols.tree) ?? 0;
        const tree = colGroupSvc?.balanceTreeForAutoCols(list, treeDepth) ?? [];
        this.columns = {
            list: list,
            tree: tree,
            treeDepth: treeDepth,
            map: {}
        };
        const putSelectionColsFirstInList = (cols2)=>{
            if (!cols2) return null;
            const colsFiltered = cols2.filter((col)=>!$437b23f6a393c3bf$export$f6074a9792015c5d(col));
            return [
                ...list,
                ...colsFiltered
            ];
        };
        updateOrders(putSelectionColsFirstInList);
    }
    updateColumns(event) {
        const source = $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source);
        for (const col of this.columns?.list ?? []){
            const newColDef = this.createSelectionColDef(event.currentValue);
            col.setColDef(newColDef, null, source);
            $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
                state: [
                    {
                        ...newColDef,
                        colId: col.getColId()
                    }
                ]
            }, source);
        }
    }
    getColumn(key) {
        return this.columns?.list.find((col)=>$437b23f6a393c3bf$export$f5687d41c39fa1b3(col, key)) ?? null;
    }
    getColumns() {
        return this.columns?.list ?? null;
    }
    isSelectionColumnEnabled() {
        const { gos: gos, beans: beans } = this;
        const rowSelection = gos.get("rowSelection");
        if (typeof rowSelection !== "object" || !$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) return false;
        const hasAutoCols = (beans.autoColSvc?.getColumns()?.length ?? 0) > 0;
        if (rowSelection.checkboxLocation === "autoGroupColumn" && hasAutoCols) return false;
        const checkboxes = !!$437b23f6a393c3bf$export$6df3a55606bca6ae(rowSelection);
        const headerCheckbox = $437b23f6a393c3bf$export$e92e75627785d7a4(rowSelection);
        return checkboxes || headerCheckbox;
    }
    createSelectionColDef(def) {
        const { gos: gos } = this;
        const selectionColumnDef = def ?? gos.get("selectionColumnDef");
        const enableRTL = gos.get("enableRtl");
        const { rowSpan: _, spanRows: __, ...filteredSelColDef } = selectionColumnDef ?? {};
        return {
            // overridable properties
            width: 50,
            resizable: false,
            suppressHeaderMenuButton: true,
            sortable: false,
            suppressMovable: true,
            lockPosition: enableRTL ? "right" : "left",
            comparator (valueA, valueB, nodeA, nodeB) {
                const aSelected = nodeA.isSelected();
                const bSelected = nodeB.isSelected();
                return aSelected === bSelected ? 0 : aSelected ? 1 : -1;
            },
            editable: false,
            suppressFillHandle: true,
            pinned: null,
            // overrides
            ...filteredSelColDef,
            // non-overridable properties
            colId: $437b23f6a393c3bf$export$dd05e5f089eb2421,
            chartDataType: "excluded"
        };
    }
    generateSelectionCols() {
        if (!this.isSelectionColumnEnabled()) return [];
        const colDef = this.createSelectionColDef();
        const colId = colDef.colId;
        this.gos.validateColDef(colDef, colId, true);
        const col = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDef, null, colId, false);
        this.createBean(col);
        return [
            col
        ];
    }
    onSelectionOptionsChanged(current, prev, source) {
        const prevCheckbox = prev && typeof prev !== "string" ? $437b23f6a393c3bf$export$6df3a55606bca6ae(prev) : void 0;
        const currCheckbox = current && typeof current !== "string" ? $437b23f6a393c3bf$export$6df3a55606bca6ae(current) : void 0;
        const checkboxHasChanged = prevCheckbox !== currCheckbox;
        const prevHeaderCheckbox = prev && typeof prev !== "string" ? $437b23f6a393c3bf$export$e92e75627785d7a4(prev) : void 0;
        const currHeaderCheckbox = current && typeof current !== "string" ? $437b23f6a393c3bf$export$e92e75627785d7a4(current) : void 0;
        const headerCheckboxHasChanged = prevHeaderCheckbox !== currHeaderCheckbox;
        const currLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(current);
        const prevLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(prev);
        const locationChanged = currLocation !== prevLocation;
        if (checkboxHasChanged || headerCheckboxHasChanged || locationChanged) this.beans.colModel.refreshAll(source);
    }
    destroy() {
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.columns?.tree);
        super.destroy();
    }
    /**
   * Refreshes visibility of the selection column based on which columns are currently visible.
   * Called by the VisibleColsService with the columns that are currently visible in left/center/right
   * containers. This method *MUTATES* those arrays directly.
   *
   * The selection column should be visible if all of the following are true
   * - The selection column is not disabled
   * - The number of visible columns excluding the selection column and row numbers column is greater than 0
   * @param leftCols Visible columns in the left-pinned container
   * @param centerCols Visible columns in the center viewport
   * @param rightCols Visible columns in the right-pinned container
   */ refreshVisibility(leftCols, centerCols, rightCols) {
        if (!this.columns?.list.length) return;
        const numVisibleCols = leftCols.length + centerCols.length + rightCols.length;
        if (numVisibleCols === 0) return;
        const column = this.columns.list[0];
        if (!column.isVisible()) return;
        const hideSelectionCol = ()=>{
            let cols;
            switch(column.pinned){
                case "left":
                case true:
                    cols = leftCols;
                    break;
                case "right":
                    cols = rightCols;
                    break;
                default:
                    cols = centerCols;
            }
            cols && $437b23f6a393c3bf$export$83a881c8b5120679(cols, column);
        };
        const rowNumbersCol = this.beans.rowNumbersSvc?.getColumn($437b23f6a393c3bf$export$f55c01dfb205b029);
        const expectedNumCols = rowNumbersCol ? 2 : 1;
        if (expectedNumCols === numVisibleCols) hideSelectionCol();
    }
};
// packages/ag-grid-community/src/selection/rowSelectionApi.ts
function $437b23f6a393c3bf$var$setNodesSelected(beans, params) {
    const allNodesValid = params.nodes.every((node)=>{
        if (node.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(node)) {
            $437b23f6a393c3bf$export$545083624300f13d(59);
            return false;
        }
        if (node.id === void 0) {
            $437b23f6a393c3bf$export$545083624300f13d(60);
            return false;
        }
        return true;
    });
    if (!allNodesValid) return;
    const { nodes: nodes, source: source, newValue: newValue } = params;
    beans.selectionSvc?.setNodesSelected({
        nodes: nodes,
        source: source ?? "api",
        newValue: newValue
    });
}
function $437b23f6a393c3bf$var$selectAll(beans, selectAll2, source = "apiSelectAll") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: selectAll2
    });
}
function $437b23f6a393c3bf$var$deselectAll(beans, selectAll2, source = "apiSelectAll") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: selectAll2
    });
}
function $437b23f6a393c3bf$var$selectAllFiltered(beans, source = "apiSelectAllFiltered") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: "filtered"
    });
}
function $437b23f6a393c3bf$var$deselectAllFiltered(beans, source = "apiSelectAllFiltered") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: "filtered"
    });
}
function $437b23f6a393c3bf$var$selectAllOnCurrentPage(beans, source = "apiSelectAllCurrentPage") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: "currentPage"
    });
}
function $437b23f6a393c3bf$var$deselectAllOnCurrentPage(beans, source = "apiSelectAllCurrentPage") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: "currentPage"
    });
}
function $437b23f6a393c3bf$var$getSelectedNodes(beans) {
    return beans.selectionSvc?.getSelectedNodes() ?? [];
}
function $437b23f6a393c3bf$var$getSelectedRows(beans) {
    return beans.selectionSvc?.getSelectedRows() ?? [];
}
// packages/ag-grid-community/src/selection/selectionService.ts
var $437b23f6a393c3bf$var$SelectionService = class extends $437b23f6a393c3bf$export$3d7b168c0c9c2a78 {
    constructor(){
        super(...arguments);
        this.beanName = "selectionSvc";
        this.selectedNodes = /* @__PURE__ */ new Map();
        /** Only used to track detail grid selection state when master/detail is enabled */ this.detailSelection = /* @__PURE__ */ new Map();
        this.masterSelectsDetail = false;
    }
    postConstruct() {
        super.postConstruct();
        const { gos: gos } = this;
        this.mode = $437b23f6a393c3bf$export$80b6607444b3274f(gos);
        this.groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
        this.groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
        this.masterSelectsDetail = $437b23f6a393c3bf$var$_getMasterSelects(gos) === "detail";
        this.addManagedPropertyListeners([
            "groupSelectsChildren",
            "groupSelectsFiltered",
            "rowSelection"
        ], ()=>{
            const groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
            const selectionMode = $437b23f6a393c3bf$export$80b6607444b3274f(gos);
            const groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
            this.masterSelectsDetail = $437b23f6a393c3bf$var$_getMasterSelects(gos) === "detail";
            if (groupSelectsDescendants !== this.groupSelectsDescendants || groupSelectsFiltered !== this.groupSelectsFiltered || selectionMode !== this.mode) {
                this.deselectAllRowNodes({
                    source: "api"
                });
                this.groupSelectsDescendants = groupSelectsDescendants;
                this.groupSelectsFiltered = groupSelectsFiltered;
                this.mode = selectionMode;
            }
        });
        this.addManagedEventListeners({
            rowSelected: this.onRowSelected.bind(this)
        });
    }
    destroy() {
        super.destroy();
        this.resetNodes();
    }
    handleSelectionEvent(event, rowNode, source) {
        if (this.isRowSelectionBlocked(rowNode)) return 0;
        const selection = this.inferNodeSelections(rowNode, event.shiftKey, event.metaKey || event.ctrlKey, source);
        if (selection == null) return 0;
        this.selectionCtx.selectAll = false;
        if ("select" in selection) {
            if (selection.reset) this.resetNodes();
            else this.selectRange(selection.deselect, false, source);
            return this.selectRange(selection.select, true, source);
        } else {
            const newValue = selection.checkFilteredNodes ? $437b23f6a393c3bf$var$recursiveCanNodesBeSelected(selection.node) : selection.newValue;
            return this.setNodesSelected({
                nodes: [
                    selection.node
                ],
                newValue: newValue,
                clearSelection: selection.clearSelection,
                keepDescendants: selection.keepDescendants,
                event: event,
                source: source
            });
        }
    }
    setNodesSelected({ newValue: newValue, clearSelection: clearSelection, suppressFinishActions: suppressFinishActions, nodes: nodes, event: event, source: source, keepDescendants: keepDescendants = false }) {
        if (nodes.length === 0) return 0;
        const { gos: gos } = this;
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos) && newValue) {
            $437b23f6a393c3bf$export$545083624300f13d(132);
            return 0;
        }
        if (nodes.length > 1 && !this.isMultiSelect()) {
            $437b23f6a393c3bf$export$545083624300f13d(130);
            return 0;
        }
        let updatedCount = 0;
        for(let i = 0; i < nodes.length; i++){
            const rowNode = nodes[i];
            const node = $437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode);
            if (node.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(node)) {
                $437b23f6a393c3bf$export$545083624300f13d(59);
                continue;
            }
            if (node.id === void 0) {
                $437b23f6a393c3bf$export$545083624300f13d(60);
                continue;
            }
            const skipThisNode = this.groupSelectsFiltered && node.group && !gos.get("treeData");
            if (!skipThisNode) {
                const thisNodeWasSelected = this.selectRowNode(node, newValue, event, source);
                if (thisNodeWasSelected) {
                    this.detailSelection.delete(node.id);
                    updatedCount++;
                }
            }
            if (this.groupSelectsDescendants && node.childrenAfterGroup?.length) updatedCount += this.selectChildren(node, newValue, source);
        }
        if (!suppressFinishActions) {
            if (nodes.length === 1 && source === "api") this.selectionCtx.setRoot($437b23f6a393c3bf$var$_normaliseSiblingRef(nodes[0]));
            const clearOtherNodes = newValue && (clearSelection || !this.isMultiSelect());
            if (clearOtherNodes) updatedCount += this.clearOtherNodes($437b23f6a393c3bf$var$_normaliseSiblingRef(nodes[0]), keepDescendants, source);
            if (updatedCount > 0) {
                this.updateGroupsFromChildrenSelections(source);
                this.dispatchSelectionChanged(source);
            }
        }
        return updatedCount;
    }
    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
    // holding down 'shift'.
    selectRange(nodesToSelect, value, source) {
        let updatedCount = 0;
        nodesToSelect.forEach((node)=>{
            const rowNode = $437b23f6a393c3bf$var$_normaliseSiblingRef(node);
            if (rowNode.group && this.groupSelectsDescendants) return;
            const nodeWasSelected = this.selectRowNode(rowNode, value, void 0, source);
            if (nodeWasSelected) updatedCount++;
        });
        if (updatedCount > 0) {
            this.updateGroupsFromChildrenSelections(source);
            this.dispatchSelectionChanged(source);
        }
        return updatedCount;
    }
    selectChildren(node, newValue, source) {
        const children = this.groupSelectsFiltered ? node.childrenAfterAggFilter : node.childrenAfterGroup;
        if (!children) return 0;
        return this.setNodesSelected({
            newValue: newValue,
            clearSelection: false,
            suppressFinishActions: true,
            source: source,
            nodes: children
        });
    }
    getSelectedNodes() {
        return Array.from(this.selectedNodes.values());
    }
    getSelectedRows() {
        const selectedRows = [];
        this.selectedNodes.forEach((rowNode)=>rowNode.data && selectedRows.push(rowNode.data));
        return selectedRows;
    }
    getSelectionCount() {
        return this.selectedNodes.size;
    }
    /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */ filterFromSelection(predicate) {
        const newSelectedNodes = /* @__PURE__ */ new Map();
        this.selectedNodes.forEach((rowNode, key)=>{
            if (predicate(rowNode)) newSelectedNodes.set(key, rowNode);
        });
        this.selectedNodes = newSelectedNodes;
    }
    updateGroupsFromChildrenSelections(source, changedPath) {
        if (!this.groupSelectsDescendants) return false;
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return false;
        const rootNode = rowModel.rootNode;
        if (!rootNode) return false;
        if (!changedPath) {
            changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(true, rootNode);
            changedPath.active = false;
        }
        let selectionChanged = false;
        changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            if (rowNode !== rootNode) {
                const selected = this.calculateSelectedFromChildren(rowNode);
                selectionChanged = this.selectRowNode(rowNode, selected === null ? false : selected, void 0, source) || selectionChanged;
            }
        });
        return selectionChanged;
    }
    clearOtherNodes(rowNodeToKeepSelected, keepDescendants, source) {
        const groupsToRefresh = /* @__PURE__ */ new Map();
        let updatedCount = 0;
        this.selectedNodes.forEach((otherRowNode)=>{
            const isNodeToKeep = otherRowNode.id == rowNodeToKeepSelected.id;
            const shouldClearDescendant = keepDescendants ? !$437b23f6a393c3bf$var$isDescendantOf(rowNodeToKeepSelected, otherRowNode) : true;
            if (shouldClearDescendant && !isNodeToKeep) {
                const rowNode = this.selectedNodes.get(otherRowNode.id);
                updatedCount += this.setNodesSelected({
                    nodes: [
                        rowNode
                    ],
                    newValue: false,
                    clearSelection: false,
                    suppressFinishActions: true,
                    source: source
                });
                if (this.groupSelectsDescendants && otherRowNode.parent) groupsToRefresh.set(otherRowNode.parent.id, otherRowNode.parent);
            }
        });
        groupsToRefresh.forEach((group)=>{
            const selected = this.calculateSelectedFromChildren(group);
            this.selectRowNode(group, selected === null ? false : selected, void 0, source);
        });
        return updatedCount;
    }
    onRowSelected(event) {
        const rowNode = event.node;
        if (this.groupSelectsDescendants && rowNode.group) return;
        if (rowNode.isSelected()) this.selectedNodes.set(rowNode.id, rowNode);
        else this.selectedNodes.delete(rowNode.id);
    }
    syncInRowNode(rowNode, oldNode) {
        this.syncInOldRowNode(rowNode, oldNode);
        this.syncInNewRowNode(rowNode);
    }
    createDaemonNode(rowNode) {
        if (!rowNode.id) return void 0;
        const oldNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        oldNode.id = rowNode.id;
        oldNode.data = rowNode.data;
        oldNode.__selected = rowNode.__selected;
        oldNode.level = rowNode.level;
        return oldNode;
    }
    // if the id has changed for the node, then this means the rowNode
    // is getting used for a different data item, which breaks
    // our selectedNodes, as the node now is mapped by the old id
    // which is inconsistent. so to keep the old node as selected,
    // we swap in the clone (with the old id and old data). this means
    // the oldNode is effectively a daemon we keep a reference to,
    // so if client calls api.getSelectedNodes(), it gets the daemon
    // in the result. when the client un-selects, the reference to the
    // daemon is removed. the daemon, because it's an oldNode, is not
    // used by the grid for rendering, it's a copy of what the node used
    // to be like before the id was changed.
    syncInOldRowNode(rowNode, oldNode) {
        if (oldNode && rowNode.id !== oldNode.id) {
            const oldNodeSelected = this.selectedNodes.get(oldNode.id) == rowNode;
            if (oldNodeSelected) this.selectedNodes.set(oldNode.id, oldNode);
        }
    }
    syncInNewRowNode(rowNode) {
        if (this.selectedNodes.has(rowNode.id)) {
            rowNode.__selected = true;
            this.selectedNodes.set(rowNode.id, rowNode);
        } else rowNode.__selected = false;
    }
    reset(source) {
        const selectionCount = this.getSelectionCount();
        this.resetNodes();
        if (selectionCount) this.dispatchSelectionChanged(source);
    }
    resetNodes() {
        this.selectedNodes.forEach((node)=>{
            this.selectRowNode(node, false);
        });
        this.selectedNodes.clear();
    }
    // returns a list of all nodes at 'best cost' - a feature to be used
    // with groups / trees. if a group has all it's children selected,
    // then the group appears in the result, but not the children.
    // Designed for use with 'children' as the group selection type,
    // where groups don't actually appear in the selection normally.
    getBestCostNodeSelection() {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return;
        const topLevelNodes = rowModel.getTopLevelNodes();
        if (topLevelNodes === null) return;
        const result = [];
        function traverse(nodes) {
            for(let i = 0, l = nodes.length; i < l; i++){
                const node = nodes[i];
                if (node.isSelected()) result.push(node);
                else if (node.group && node.childrenAfterGroup) traverse(node.childrenAfterGroup);
            }
        }
        traverse(topLevelNodes);
        return result;
    }
    isEmpty() {
        return this.getSelectionCount() === 0;
    }
    deselectAllRowNodes({ source: source, selectAll: selectAll2 }) {
        const rowModelClientSide = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos);
        let updatedNodes = false;
        const callback = (rowNode)=>{
            const updated = this.selectRowNode($437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode), false, void 0, source);
            updatedNodes || (updatedNodes = updated);
        };
        if (selectAll2 === "currentPage" || selectAll2 === "filtered") {
            if (!rowModelClientSide) {
                $437b23f6a393c3bf$export$a20c7248650823a9(102);
                return;
            }
            this.getNodesToSelect(selectAll2).forEach(callback);
        } else {
            this.selectedNodes.forEach(callback);
            this.reset(source);
        }
        this.selectionCtx.selectAll = false;
        if (rowModelClientSide && this.groupSelectsDescendants) {
            const updated = this.updateGroupsFromChildrenSelections(source);
            updatedNodes || (updatedNodes = updated);
        }
        if (updatedNodes) this.dispatchSelectionChanged(source);
    }
    getSelectedCounts(selectAll2) {
        let selectedCount = 0;
        let notSelectedCount = 0;
        this.getNodesToSelect(selectAll2).forEach((node)=>{
            if (this.groupSelectsDescendants && node.group) return;
            if (node.isSelected()) selectedCount++;
            else if (node.selectable) notSelectedCount++;
        });
        return {
            selectedCount: selectedCount,
            notSelectedCount: notSelectedCount
        };
    }
    getSelectAllState(selectAll2) {
        const { selectedCount: selectedCount, notSelectedCount: notSelectedCount } = this.getSelectedCounts(selectAll2);
        return $437b23f6a393c3bf$var$_calculateSelectAllState(selectedCount, notSelectedCount) ?? null;
    }
    hasNodesToSelect(selectAll2) {
        return this.getNodesToSelect(selectAll2).filter((node)=>node.selectable).length > 0;
    }
    /**
   * @param selectAll See `MultiRowSelectionOptions.selectAll`
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */ getNodesToSelect(selectAll2) {
        if (!this.canSelectAll()) return [];
        const nodes = [];
        const addToResult = (node)=>nodes.push(node);
        if (selectAll2 === "currentPage") {
            this.forEachNodeOnPage((node)=>{
                if (!node.group) {
                    addToResult(node);
                    return;
                }
                if (!node.expanded && !node.footer) {
                    const recursivelyAddChildren = (child)=>{
                        addToResult(child);
                        child.childrenAfterFilter?.forEach(recursivelyAddChildren);
                    };
                    recursivelyAddChildren(node);
                    return;
                }
                if (!this.groupSelectsDescendants) addToResult(node);
            });
            return nodes;
        }
        const clientSideRowModel = this.beans.rowModel;
        if (selectAll2 === "filtered") {
            clientSideRowModel.forEachNodeAfterFilter(addToResult);
            return nodes;
        }
        clientSideRowModel.forEachNode(addToResult);
        return nodes;
    }
    forEachNodeOnPage(callback) {
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const firstRow = pageBounds.getFirstRow();
        const lastRow = pageBounds.getLastRow();
        for(let i = firstRow; i <= lastRow; i++){
            const node = rowModel.getRow(i);
            if (node) callback(node);
        }
    }
    selectAllRowNodes(params) {
        const { gos: gos, selectionCtx: selectionCtx } = this;
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) {
            $437b23f6a393c3bf$export$545083624300f13d(132);
            return;
        }
        if ($437b23f6a393c3bf$export$d3c80fcacb2e2d55(gos) && !$437b23f6a393c3bf$export$7bd8c52ebc4117d6(gos)) {
            $437b23f6a393c3bf$export$545083624300f13d(130);
            return;
        }
        if (!this.canSelectAll()) return;
        const { source: source, selectAll: selectAll2 } = params;
        let updatedNodes = false;
        this.getNodesToSelect(selectAll2).forEach((rowNode)=>{
            const updated = this.selectRowNode($437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode), true, void 0, source);
            updatedNodes || (updatedNodes = updated);
        });
        selectionCtx.selectAll = true;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos) && this.groupSelectsDescendants) {
            const updated = this.updateGroupsFromChildrenSelections(source);
            updatedNodes || (updatedNodes = updated);
        }
        if (updatedNodes) this.dispatchSelectionChanged(source);
    }
    getSelectionState() {
        return this.isEmpty() ? null : Array.from(this.selectedNodes.keys());
    }
    setSelectionState(state, source, clearSelection) {
        if (!state) state = [];
        if (!Array.isArray(state)) {
            $437b23f6a393c3bf$export$a20c7248650823a9(103);
            return;
        }
        const rowIds = new Set(state);
        const nodes = [];
        this.beans.rowModel.forEachNode((node)=>{
            if (rowIds.has(node.id)) nodes.push(node);
        });
        if (clearSelection) this.resetNodes();
        this.setNodesSelected({
            newValue: true,
            nodes: nodes,
            source: source
        });
    }
    canSelectAll() {
        return $437b23f6a393c3bf$export$9f182d9ca737e15(this.beans.gos);
    }
    /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData via `updateSelectableAfterGrouping`
   */ updateSelectable(changedPath) {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) return;
        const source = "selectableChanged";
        const skipLeafNodes = changedPath !== void 0;
        const isCSRMGroupSelectsDescendants = $437b23f6a393c3bf$export$9f182d9ca737e15(gos) && this.groupSelectsDescendants;
        const nodesToDeselect = [];
        const nodeCallback = (node)=>{
            if (skipLeafNodes && !node.group) return;
            if (isCSRMGroupSelectsDescendants && node.group) {
                const hasSelectableChild = node.childrenAfterGroup?.some((rowNode)=>rowNode.selectable) ?? false;
                this.setRowSelectable(node, hasSelectableChild, true);
                return;
            }
            const rowSelectable = this.updateRowSelectable(node, true);
            if (!rowSelectable && node.isSelected()) nodesToDeselect.push(node);
        };
        if (isCSRMGroupSelectsDescendants) {
            if (changedPath === void 0) {
                const rootNode = rowModel.rootNode;
                changedPath = rootNode ? new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, rootNode) : void 0;
            }
            changedPath?.forEachChangedNodeDepthFirst(nodeCallback, !skipLeafNodes, !skipLeafNodes);
        } else rowModel.forEachNode(nodeCallback);
        if (nodesToDeselect.length) this.setNodesSelected({
            nodes: nodesToDeselect,
            newValue: false,
            source: source
        });
        if (!skipLeafNodes && isCSRMGroupSelectsDescendants) this.updateGroupsFromChildrenSelections?.(source);
    }
    // only called by CSRM
    updateSelectableAfterGrouping(changedPath) {
        this.updateSelectable(changedPath);
        if (this.groupSelectsDescendants) {
            const selectionChanged = this.updateGroupsFromChildrenSelections?.("rowGroupChanged", changedPath);
            if (selectionChanged) this.dispatchSelectionChanged("rowGroupChanged");
        }
    }
    refreshMasterNodeState(node, e) {
        if (!this.masterSelectsDetail) return;
        const detailApi = node.detailNode?.detailGridInfo?.api;
        if (!detailApi) return;
        const isSelectAll = $437b23f6a393c3bf$var$_isAllSelected(detailApi);
        const current = node.isSelected();
        if (current !== isSelectAll) {
            const selectionChanged = this.selectRowNode(node, isSelectAll, e, "masterDetail");
            if (selectionChanged) this.dispatchSelectionChanged("masterDetail");
        }
        if (!isSelectAll) {
            const detailSelected = this.detailSelection.get(node.id) ?? /* @__PURE__ */ new Set();
            for (const n of detailApi.getSelectedNodes())detailSelected.add(n.id);
            this.detailSelection.set(node.id, detailSelected);
        }
    }
    setDetailSelectionState(masterNode, detailGridOptions, detailApi) {
        if (!this.masterSelectsDetail) return;
        if (!$437b23f6a393c3bf$export$7bd8c52ebc4117d6(detailGridOptions)) {
            $437b23f6a393c3bf$export$545083624300f13d(269);
            return;
        }
        switch(masterNode.isSelected()){
            case true:
                detailApi.selectAll();
                break;
            case false:
                detailApi.deselectAll();
                break;
            case void 0:
                {
                    const selectedIds = this.detailSelection.get(masterNode.id);
                    if (selectedIds) {
                        const nodes = [];
                        for (const id of selectedIds){
                            const n = detailApi.getRowNode(id);
                            if (n) nodes.push(n);
                        }
                        detailApi.setNodesSelected({
                            nodes: nodes,
                            newValue: true,
                            source: "masterDetail"
                        });
                    }
                    break;
                }
            default:
                break;
        }
    }
    dispatchSelectionChanged(source) {
        this.eventSvc.dispatchEvent({
            type: "selectionChanged",
            source: source,
            selectedNodes: this.getSelectedNodes(),
            serverSideState: null
        });
    }
};
function $437b23f6a393c3bf$var$_normaliseSiblingRef(node) {
    return $437b23f6a393c3bf$var$_isManualPinnedRow(node) ? node.pinnedSibling : node.footer ? node.sibling : node;
}
function $437b23f6a393c3bf$var$_isAllSelected(api) {
    let selectedCount = 0;
    let notSelectedCount = 0;
    api.forEachNode((node)=>{
        if (node.isSelected()) selectedCount++;
        else if (node.selectable) notSelectedCount++;
    });
    return $437b23f6a393c3bf$var$_calculateSelectAllState(selectedCount, notSelectedCount);
}
function $437b23f6a393c3bf$var$_calculateSelectAllState(selected, notSelected) {
    if (selected === 0 && notSelected === 0) return false;
    if (selected > 0 && notSelected > 0) return;
    return selected > 0;
}
function $437b23f6a393c3bf$var$isDescendantOf(root, child) {
    let parent = child.parent;
    while(parent){
        if (parent === root) return true;
        parent = parent.parent;
    }
    return false;
}
function $437b23f6a393c3bf$var$recursiveCanNodesBeSelected(root) {
    const rootCanBeSelected = root.isSelected() === false;
    const childrenCanBeSelected = root.childrenAfterFilter?.some($437b23f6a393c3bf$var$recursiveCanNodesBeSelected) ?? false;
    return rootCanBeSelected || childrenCanBeSelected;
}
// packages/ag-grid-community/src/selection/rowSelectionModule.ts
var $437b23f6a393c3bf$export$16cbd1164b82410d = {
    moduleName: "SharedRowSelection",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$SelectionColService
    ],
    apiFunctions: {
        setNodesSelected: $437b23f6a393c3bf$var$setNodesSelected,
        selectAll: $437b23f6a393c3bf$var$selectAll,
        deselectAll: $437b23f6a393c3bf$var$deselectAll,
        selectAllFiltered: $437b23f6a393c3bf$var$selectAllFiltered,
        deselectAllFiltered: $437b23f6a393c3bf$var$deselectAllFiltered,
        selectAllOnCurrentPage: $437b23f6a393c3bf$var$selectAllOnCurrentPage,
        deselectAllOnCurrentPage: $437b23f6a393c3bf$var$deselectAllOnCurrentPage,
        getSelectedNodes: $437b23f6a393c3bf$var$getSelectedNodes,
        getSelectedRows: $437b23f6a393c3bf$var$getSelectedRows
    }
};
var $437b23f6a393c3bf$export$dae0b5c1ba15d66f = {
    moduleName: "RowSelection",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide",
        "infinite",
        "viewport"
    ],
    beans: [
        $437b23f6a393c3bf$var$SelectionService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$16cbd1164b82410d
    ]
};
// packages/ag-grid-community/src/api/rowModelSharedApi.ts
function $437b23f6a393c3bf$var$expandAll(beans) {
    beans.expansionSvc?.expandAll(true);
}
function $437b23f6a393c3bf$var$collapseAll(beans) {
    beans.expansionSvc?.expandAll(false);
}
function $437b23f6a393c3bf$export$39ff1118beb20c8b(beans) {
    beans.rowModel?.onRowHeightChanged();
}
function $437b23f6a393c3bf$export$80ac5296eda53df5(beans) {
    if (beans.rowAutoHeight?.active) {
        $437b23f6a393c3bf$export$545083624300f13d(3);
        return;
    }
    beans.rowModel?.resetRowHeights();
}
// packages/ag-grid-community/src/api/ssrmInfiniteSharedApi.ts
function $437b23f6a393c3bf$var$setRowCount(beans, rowCount, maxRowFound) {
    const serverSideRowModel = $437b23f6a393c3bf$export$aada92189a74e985(beans);
    if (serverSideRowModel) {
        if (beans.rowGroupColsSvc?.columns.length === 0) {
            if (rowCount < 0) {
                $437b23f6a393c3bf$export$a20c7248650823a9(238);
                return;
            }
            serverSideRowModel.setRowCount(rowCount, maxRowFound);
            return;
        }
        $437b23f6a393c3bf$export$a20c7248650823a9(28);
        return;
    }
    $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.setRowCount(rowCount, maxRowFound);
}
function $437b23f6a393c3bf$var$getCacheBlockState(beans) {
    if ($437b23f6a393c3bf$export$cf1bac0013650216(beans.gos)) {
        const ssrm = beans.rowModel;
        return ssrm.getBlockStates();
    }
    return beans.rowNodeBlockLoader?.getBlockState() ?? {};
}
function $437b23f6a393c3bf$var$isLastRowIndexKnown(beans) {
    return beans.rowModel.isLastRowIndexKnown();
}
// packages/ag-grid-community/src/api/sharedApiModule.ts
var $437b23f6a393c3bf$export$76fb120d9e251426 = {
    moduleName: "CsrmSsrmSharedApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        expandAll: $437b23f6a393c3bf$var$expandAll,
        collapseAll: $437b23f6a393c3bf$var$collapseAll
    }
};
var $437b23f6a393c3bf$export$b36e8e3b22fa08ce = {
    moduleName: "RowModelSharedApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        onRowHeightChanged: $437b23f6a393c3bf$export$39ff1118beb20c8b,
        resetRowHeights: $437b23f6a393c3bf$export$80ac5296eda53df5
    }
};
var $437b23f6a393c3bf$export$2f6740e35dedc261 = {
    moduleName: "SsrmInfiniteSharedApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        setRowCount: $437b23f6a393c3bf$var$setRowCount,
        getCacheBlockState: $437b23f6a393c3bf$var$getCacheBlockState,
        isLastRowIndexKnown: $437b23f6a393c3bf$var$isLastRowIndexKnown
    }
};
// packages/ag-grid-community/src/alignedGrids/alignedGridsService.ts
var $437b23f6a393c3bf$var$AlignedGridsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "alignedGridsSvc";
        // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
        // while processing a master event) we mark this if consuming an event, and if we are, then
        // we don't fire back any events.
        this.consuming = false;
    }
    getAlignedGridApis() {
        let alignedGrids = this.gos.get("alignedGrids") ?? [];
        const isCallbackConfig = typeof alignedGrids === "function";
        if (typeof alignedGrids === "function") alignedGrids = alignedGrids();
        const apis = alignedGrids.map((alignedGrid)=>{
            if (!alignedGrid) {
                $437b23f6a393c3bf$export$a20c7248650823a9(18);
                if (!isCallbackConfig) $437b23f6a393c3bf$export$a20c7248650823a9(20);
                return;
            }
            if (this.isGridApi(alignedGrid)) return alignedGrid;
            const refOrComp = alignedGrid;
            if ("current" in refOrComp) return refOrComp.current?.api;
            if (!refOrComp.api) $437b23f6a393c3bf$export$a20c7248650823a9(19);
            return refOrComp.api;
        }).filter((api)=>!!api && !api.isDestroyed());
        return apis;
    }
    isGridApi(ref) {
        return !!ref && !!ref.dispatchEvent;
    }
    postConstruct() {
        const fireColumnEvent = this.fireColumnEvent.bind(this);
        this.addManagedEventListeners({
            columnMoved: fireColumnEvent,
            columnVisible: fireColumnEvent,
            columnPinned: fireColumnEvent,
            columnGroupOpened: fireColumnEvent,
            columnResized: fireColumnEvent,
            bodyScroll: this.fireScrollEvent.bind(this),
            alignedGridColumn: ({ event: event })=>this.onColumnEvent(event),
            alignedGridScroll: ({ event: event })=>this.onScrollEvent(event)
        });
    }
    // common logic across all the fire methods
    fireEvent(event) {
        if (this.consuming) return;
        for (const api of this.getAlignedGridApis()){
            if (api.isDestroyed()) continue;
            api.dispatchEvent(event);
        }
    }
    // common logic across all consume methods. very little common logic, however extracting
    // guarantees consistency across the methods.
    onEvent(callback) {
        this.consuming = true;
        callback();
        this.consuming = false;
    }
    fireColumnEvent(columnEvent) {
        this.fireEvent({
            type: "alignedGridColumn",
            event: columnEvent
        });
    }
    fireScrollEvent(scrollEvent) {
        if (scrollEvent.direction !== "horizontal") return;
        this.fireEvent({
            type: "alignedGridScroll",
            event: scrollEvent
        });
    }
    onScrollEvent(event) {
        this.onEvent(()=>{
            this.beans.ctrlsSvc.getScrollFeature().setHorizontalScrollPosition(event.left, true);
        });
    }
    extractDataFromEvent(event, func) {
        const result = [];
        if (event.columns) event.columns.forEach((column)=>{
            result.push(func(column));
        });
        else if (event.column) result.push(func(event.column));
        return result;
    }
    getMasterColumns(event) {
        return this.extractDataFromEvent(event, (col)=>col);
    }
    getColumnIds(event) {
        return this.extractDataFromEvent(event, (col)=>col.getColId());
    }
    onColumnEvent(event) {
        this.onEvent(()=>{
            switch(event.type){
                case "columnMoved":
                case "columnVisible":
                case "columnPinned":
                case "columnResized":
                    this.processColumnEvent(event);
                    break;
                case "columnGroupOpened":
                    this.processGroupOpenedEvent(event);
                    break;
                case "columnPivotChanged":
                    $437b23f6a393c3bf$export$545083624300f13d(21);
                    break;
            }
        });
    }
    processGroupOpenedEvent(groupOpenedEvent) {
        const { colGroupSvc: colGroupSvc } = this.beans;
        if (!colGroupSvc) return;
        for (const masterGroup of groupOpenedEvent.columnGroups){
            let otherColumnGroup = null;
            if (masterGroup) otherColumnGroup = colGroupSvc.getProvidedColGroup(masterGroup.getGroupId());
            if (masterGroup && !otherColumnGroup) continue;
            colGroupSvc.setColumnGroupOpened(otherColumnGroup, masterGroup.isExpanded(), "alignedGridChanged");
        }
    }
    processColumnEvent(colEvent) {
        const masterColumn = colEvent.column;
        let otherColumn = null;
        const beans = this.beans;
        const { colResize: colResize, ctrlsSvc: ctrlsSvc, colModel: colModel } = beans;
        if (masterColumn) otherColumn = colModel.getColDefCol(masterColumn.getColId());
        if (masterColumn && !otherColumn) return;
        const masterColumns = this.getMasterColumns(colEvent);
        switch(colEvent.type){
            case "columnMoved":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState,
                        applyOrder: true
                    }, "alignedGridChanged");
                }
                break;
            case "columnVisible":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            hide: s.hide
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState
                    }, "alignedGridChanged");
                }
                break;
            case "columnPinned":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            pinned: s.pinned
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState
                    }, "alignedGridChanged");
                }
                break;
            case "columnResized":
                {
                    const resizedEvent = colEvent;
                    const columnWidths = {};
                    for (const column of masterColumns)columnWidths[column.getId()] = {
                        key: column.getColId(),
                        newWidth: column.getActualWidth()
                    };
                    for (const col of resizedEvent.flexColumns ?? [])if (columnWidths[col.getId()]) delete columnWidths[col.getId()];
                    colResize?.setColumnWidths(Object.values(columnWidths), false, resizedEvent.finished, "alignedGridChanged");
                    break;
                }
        }
        const gridBodyCon = ctrlsSvc.getGridBodyCtrl();
        const isVerticalScrollShowing = gridBodyCon.isVerticalScrollShowing();
        for (const api of this.getAlignedGridApis())api.setGridOption("alwaysShowVerticalScroll", isVerticalScrollShowing);
    }
};
// packages/ag-grid-community/src/alignedGrids/alignedGridsModule.ts
var $437b23f6a393c3bf$export$a8c763073927f695 = {
    moduleName: "AlignedGrids",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AlignedGridsService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$5c4abee658e86c68
    ]
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideNodeManager.ts
var $437b23f6a393c3bf$var$ClientSideNodeManager = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rootNode){
        super();
        this.rootNode = rootNode;
        this.nextId = 0;
        this.allNodesMap = {};
        $437b23f6a393c3bf$var$initRootNode(rootNode);
    }
    getRowNode(id) {
        return this.allNodesMap[id];
    }
    setNewRowData(rowData) {
        const { selectionSvc: selectionSvc, pinnedRowModel: pinnedRowModel, groupStage: groupStage } = this.beans;
        selectionSvc?.reset("rowDataChanged");
        if (pinnedRowModel?.isManual()) pinnedRowModel.reset();
        this.dispatchRowDataUpdateStarted(rowData);
        this.allNodesMap = /* @__PURE__ */ Object.create(null);
        this.nextId = 0;
        const rootNode = $437b23f6a393c3bf$var$initRootNode(this.rootNode);
        const allLeafs = new Array(rowData.length);
        rootNode._leafs = allLeafs;
        let writeIdx = 0;
        const nestedDataGetter = groupStage?.getNestedDataGetter();
        const processedNested = nestedDataGetter ? /* @__PURE__ */ new Set() : null;
        const processChildren = (parent, childrenData)=>{
            const level = parent.level + 1;
            for(let i = 0, len = childrenData.length; i < len; ++i){
                const data = childrenData[i];
                if (!data) continue;
                const node = this.createRowNode(data, level);
                node.sourceRowIndex = writeIdx;
                allLeafs[writeIdx++] = node;
                if (processedNested && !processedNested.has(data)) {
                    processedNested.add(data);
                    node.treeParent = parent;
                    const children = nestedDataGetter(data);
                    if (children) processChildren(node, children);
                }
            }
        };
        processChildren(rootNode, rowData);
        allLeafs.length = writeIdx;
    }
    setImmutableRowData(params, rowData) {
        const { rootNode: rootNode, gos: gos } = this;
        this.dispatchRowDataUpdateStarted(rowData);
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(gos);
        const changedRowNodes = params.changedRowNodes;
        const { adds: adds, updates: updates } = changedRowNodes;
        const processedNodes = /* @__PURE__ */ new Set();
        const nodesToUnselect = [];
        const nestedDataGetter = this.beans.groupStage?.getNestedDataGetter();
        let reorder = gos.get("suppressMaintainUnsortedOrder") ? void 0 : false;
        let prevIndex = -1;
        let treeUpdated = false;
        const updateNode = (node, data)=>{
            if (!reorder && reorder !== void 0) {
                const oldIndex = node.sourceRowIndex;
                reorder = oldIndex <= prevIndex;
                prevIndex = oldIndex;
            }
            if (node.data !== data) {
                node.updateData(data);
                if (!adds.has(node)) updates.add(node);
                if (!node.selectable && node.isSelected()) nodesToUnselect.push(node);
            }
        };
        const processChildren = (parent, childrenData, level)=>{
            for(let i = 0, len = childrenData.length; i < len; ++i){
                const data = childrenData[i];
                if (!data) continue;
                let node = this.getRowNode(getRowIdFunc({
                    data: data,
                    level: level
                }));
                if (node) {
                    updateNode(node, data);
                    treeUpdated || (treeUpdated = !!nestedDataGetter && node.treeParent !== parent);
                } else {
                    node = this.createRowNode(data, level);
                    adds.add(node);
                }
                if (!nestedDataGetter || processedNodes.has(node)) {
                    processedNodes.add(node);
                    continue;
                }
                processedNodes.add(node);
                node.treeParent = parent;
                const children = nestedDataGetter(data);
                if (children) processChildren(node, children, level + 1);
            }
        };
        processChildren(rootNode, rowData, 0);
        const changed = this.deleteUnusedNodes(processedNodes, changedRowNodes, nodesToUnselect) || reorder || adds.size > 0;
        if (changed) {
            const allLeafs = rootNode._leafs ?? (rootNode._leafs = []);
            if (reorder === void 0) $437b23f6a393c3bf$var$updateRootLeafsKeepOrder(allLeafs, processedNodes, changedRowNodes);
            else if ($437b23f6a393c3bf$var$updateRootLeafsOrdered(allLeafs, processedNodes)) changedRowNodes.reordered = true;
        }
        if (changed || treeUpdated || updates.size) {
            params.rowDataUpdated = true;
            this.deselect(nodesToUnselect);
        }
    }
    deleteUnusedNodes(processedNodes, { removals: removals }, nodesToUnselect) {
        const allLeafs = this.rootNode._leafs;
        for(let i = 0, len = allLeafs.length; i < len; i++){
            const node = allLeafs[i];
            if (!processedNodes.has(node)) {
                removals.add(node);
                if (node.isSelected()) nodesToUnselect.push(node);
                this.deleteNode(node);
            }
        }
        return removals.size > 0;
    }
    updateRowData(rowDataTran, changedRowNodes) {
        this.dispatchRowDataUpdateStarted(rowDataTran.add);
        if (this.beans.groupStage?.getNestedDataGetter()) {
            $437b23f6a393c3bf$export$545083624300f13d(268);
            return {
                remove: [],
                update: [],
                add: []
            };
        }
        const nodesToUnselect = [];
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const remove = this.executeRemove(getRowIdFunc, rowDataTran, changedRowNodes, nodesToUnselect);
        const update = this.executeUpdate(getRowIdFunc, rowDataTran, changedRowNodes, nodesToUnselect);
        const add = this.executeAdd(rowDataTran, changedRowNodes);
        this.deselect(nodesToUnselect);
        return {
            remove: remove,
            update: update,
            add: add
        };
    }
    executeRemove(getRowIdFunc, { remove: remove }, { adds: adds, updates: updates, removals: removals }, nodesToUnselect) {
        const allLeafs = this.rootNode._leafs;
        const allLeafsLen = allLeafs?.length;
        const removeLen = remove?.length;
        if (!removeLen || !allLeafsLen) return [];
        let removeCount = 0;
        let filterIdx = allLeafsLen;
        let filterEndIdx = 0;
        let nodesNeverAdded;
        const removedResult = new Array(removeLen);
        for(let i = 0; i < removeLen; ++i){
            const rowNode = this.lookupNode(getRowIdFunc, remove[i]);
            if (!rowNode) continue;
            const sourceRowIndex = rowNode.sourceRowIndex;
            if (sourceRowIndex < filterIdx) filterIdx = sourceRowIndex;
            if (sourceRowIndex > filterEndIdx) filterEndIdx = sourceRowIndex;
            if (rowNode.isSelected()) nodesToUnselect.push(rowNode);
            this.deleteNode(rowNode);
            if (adds.delete(rowNode)) {
                nodesNeverAdded ?? (nodesNeverAdded = /* @__PURE__ */ new Set());
                nodesNeverAdded.add(rowNode);
            } else {
                updates.delete(rowNode);
                removals.add(rowNode);
            }
            removedResult[removeCount++] = rowNode;
        }
        removedResult.length = removeCount;
        if (removeCount) $437b23f6a393c3bf$var$filterRemovedRowNodes(allLeafs, filterIdx, filterEndIdx, removals, nodesNeverAdded);
        return removedResult;
    }
    executeUpdate(getRowIdFunc, { update: update }, { adds: adds, updates: updates }, nodesToUnselect) {
        const updateLen = update?.length;
        if (!updateLen) return [];
        const updateResult = new Array(updateLen);
        let writeIdx = 0;
        for(let i = 0; i < updateLen; i++){
            const item = update[i];
            const rowNode = this.lookupNode(getRowIdFunc, item);
            if (rowNode) {
                rowNode.updateData(item);
                if (!rowNode.selectable && rowNode.isSelected()) nodesToUnselect.push(rowNode);
                updateResult[writeIdx++] = rowNode;
                if (!adds.has(rowNode)) updates.add(rowNode);
            }
        }
        updateResult.length = writeIdx;
        return updateResult;
    }
    executeAdd(rowDataTran, changedRowNodes) {
        var _a2;
        const allLeafs = (_a2 = this.rootNode)._leafs ?? (_a2._leafs = []);
        const allLeafsLen = allLeafs.length;
        const add = rowDataTran.add;
        const addLength = add?.length;
        if (!addLength) return [];
        const newLen = allLeafsLen + addLength;
        let addIndex = this.sanitizeAddIndex(allLeafs, rowDataTran.addIndex);
        if (addIndex < allLeafsLen) {
            for(let readIdx = allLeafsLen - 1, writeIdx = newLen - 1; readIdx >= addIndex; --readIdx){
                const node = allLeafs[readIdx];
                node.sourceRowIndex = writeIdx;
                allLeafs[writeIdx--] = node;
            }
            changedRowNodes.reordered = true;
        }
        allLeafs.length = newLen;
        const addedNodes = new Array(addLength);
        const adds = changedRowNodes.adds;
        for(let i = 0; i < addLength; i++){
            const node = this.createRowNode(add[i], 0);
            adds.add(node);
            node.sourceRowIndex = addIndex;
            allLeafs[addIndex] = node;
            addedNodes[i] = node;
            addIndex++;
        }
        return addedNodes;
    }
    dispatchRowDataUpdateStarted(data) {
        this.eventSvc.dispatchEvent({
            type: "rowDataUpdateStarted",
            firstRowData: data?.length ? data[0] : null
        });
    }
    deselect(nodes) {
        const source = "rowDataChanged";
        const selectionSvc = this.beans.selectionSvc;
        if (nodes.length) selectionSvc?.setNodesSelected({
            newValue: false,
            nodes: nodes,
            suppressFinishActions: true,
            source: source
        });
        selectionSvc?.updateGroupsFromChildrenSelections?.(source);
        if (nodes.length) this.eventSvc.dispatchEvent({
            type: "selectionChanged",
            source: source,
            selectedNodes: selectionSvc?.getSelectedNodes() ?? null,
            serverSideState: null
        });
    }
    createRowNode(data, level) {
        const node = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        node.parent = this.rootNode;
        node.level = level;
        node.group = false;
        node.expanded = false;
        node.setDataAndId(data, String(this.nextId++));
        const id = node.id;
        const allNodesMap = this.allNodesMap;
        if (allNodesMap[id]) $437b23f6a393c3bf$export$545083624300f13d(2, {
            nodeId: id
        });
        allNodesMap[id] = node;
        return node;
    }
    /** Called when a node needs to be deleted */ deleteNode(node) {
        node.clearRowTopAndRowIndex();
        const id = node.id;
        const allNodesMap = this.allNodesMap;
        if (allNodesMap[id] === node) delete allNodesMap[id];
        const pinnedSibling = node.pinnedSibling;
        if (pinnedSibling) this.beans.pinnedRowModel?.pinRow(pinnedSibling, null);
    }
    lookupNode(getRowIdFunc, data) {
        if (!getRowIdFunc) return $437b23f6a393c3bf$var$lookupNodeByData(this.rootNode._leafs, data);
        const id = getRowIdFunc({
            data: data,
            level: 0
        });
        const rowNode = this.allNodesMap[id];
        if (!rowNode) {
            $437b23f6a393c3bf$export$a20c7248650823a9(4, {
                id: id
            });
            return null;
        }
        return rowNode;
    }
    sanitizeAddIndex(allLeafs, addIndex) {
        const allLeafsLen = allLeafs.length;
        if (typeof addIndex !== "number") return allLeafsLen;
        if (addIndex < 0 || addIndex >= allLeafsLen || Number.isNaN(addIndex)) return allLeafsLen;
        addIndex = Math.ceil(addIndex);
        const gos = this.gos;
        if (addIndex > 0 && gos.get("treeData") && gos.get("getDataPath")) addIndex = $437b23f6a393c3bf$var$adjustAddIndexForDataPath(allLeafs, addIndex);
        return addIndex;
    }
};
var $437b23f6a393c3bf$var$adjustAddIndexForDataPath = (allLeafs, addIndex)=>{
    for(let i = 0, len = allLeafs.length; i < len; i++){
        const node = allLeafs[i];
        if (node?.rowIndex == addIndex - 1) return i + 1;
    }
    return addIndex;
};
var $437b23f6a393c3bf$var$initRootNode = (rootNode)=>{
    rootNode.group = true;
    rootNode.level = -1;
    rootNode.id = "ROOT_NODE_ID";
    if (rootNode._leafs?.length !== 0) rootNode._leafs = [];
    const childrenAfterGroup = [];
    const childrenAfterSort = [];
    const childrenAfterAggFilter = [];
    const childrenAfterFilter = [];
    rootNode.childrenAfterGroup = childrenAfterGroup;
    rootNode.childrenAfterSort = childrenAfterSort;
    rootNode.childrenAfterAggFilter = childrenAfterAggFilter;
    rootNode.childrenAfterFilter = childrenAfterFilter;
    const sibling = rootNode.sibling;
    if (sibling) {
        sibling.childrenAfterGroup = childrenAfterGroup;
        sibling.childrenAfterSort = childrenAfterSort;
        sibling.childrenAfterAggFilter = childrenAfterAggFilter;
        sibling.childrenAfterFilter = childrenAfterFilter;
        sibling.childrenMapped = rootNode.childrenMapped;
    }
    rootNode.updateHasChildren();
    return rootNode;
};
var $437b23f6a393c3bf$var$lookupNodeByData = (nodes, data)=>{
    if (nodes) for(let i = 0, len = nodes.length; i < len; i++){
        const node = nodes[i];
        if (node.data === data) return node;
    }
    $437b23f6a393c3bf$export$a20c7248650823a9(5, {
        data: data
    });
    return null;
};
var $437b23f6a393c3bf$var$filterRemovedRowNodes = (allLeafs, filterIdx, filterEndIdx, removals, nodesNeverAdded)=>{
    filterIdx = Math.max(0, filterIdx);
    for(let readIdx = filterIdx, len = allLeafs.length; readIdx < len; ++readIdx){
        const node = allLeafs[readIdx];
        if (readIdx <= filterEndIdx && (removals.has(node) || nodesNeverAdded?.has(node))) continue;
        node.sourceRowIndex = filterIdx;
        allLeafs[filterIdx++] = node;
    }
    allLeafs.length = filterIdx;
};
var $437b23f6a393c3bf$var$updateRootLeafsOrdered = (allLeafs, processedNodes)=>{
    const newSize = processedNodes.size;
    allLeafs.length = newSize;
    let writeIdx = 0;
    let added = false;
    let reordered = false;
    for (const node of processedNodes){
        const sourceRowIndex = node.sourceRowIndex;
        if (sourceRowIndex === writeIdx) reordered || (reordered = added);
        else {
            if (sourceRowIndex >= 0) reordered = true;
            else added = true;
            node.sourceRowIndex = writeIdx;
            allLeafs[writeIdx] = node;
        }
        ++writeIdx;
    }
    return reordered;
};
var $437b23f6a393c3bf$var$updateRootLeafsKeepOrder = (allLeafs, processedNodes, { removals: removals, adds: adds })=>{
    const allLeafsLen = allLeafs.length;
    allLeafs.length = processedNodes.size;
    let writeIdx = 0;
    for(let readIdx = 0; readIdx < allLeafsLen; ++readIdx){
        const node = allLeafs[readIdx];
        if (!removals.has(node)) {
            if (writeIdx !== readIdx) {
                node.sourceRowIndex = writeIdx;
                allLeafs[writeIdx] = node;
            }
            ++writeIdx;
        }
    }
    for (const node of adds)if (node.sourceRowIndex < 0) {
        node.sourceRowIndex = writeIdx;
        allLeafs[writeIdx++] = node;
    }
    allLeafs.length = writeIdx;
};
// packages/ag-grid-community/src/clientSideRowModel/sortStage.ts
var $437b23f6a393c3bf$var$updateRowNodeAfterSort = (rowNode)=>{
    const childrenAfterSort = rowNode.childrenAfterSort;
    const sibling = rowNode.sibling;
    if (sibling) sibling.childrenAfterSort = childrenAfterSort;
    if (!childrenAfterSort) return;
    for(let i = 0, lastIdx = childrenAfterSort.length - 1; i <= lastIdx; i++){
        const child = childrenAfterSort[i];
        const first = i === 0;
        const last = i === lastIdx;
        if (child.firstChild !== first) {
            child.firstChild = first;
            child.dispatchRowEvent("firstChildChanged");
        }
        if (child.lastChild !== last) {
            child.lastChild = last;
            child.dispatchRowEvent("lastChildChanged");
        }
        if (child.childIndex !== i) {
            child.childIndex = i;
            child.dispatchRowEvent("childIndexChanged");
        }
    }
};
var $437b23f6a393c3bf$var$SortStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "sortStage";
        this.step = "sort";
        this.refreshProps = [
            "postSortRows",
            "groupDisplayType",
            "accentedSort"
        ];
    }
    execute(params) {
        const sortOptions = this.beans.sortSvc.getSortOptions();
        const deltaSort = sortOptions.length > 0 && !!params.changedRowNodes && // in time we can remove this check, so that delta sort is always
        // on if transactions are present. it's off for now so that we can
        // selectively turn it on and test it with some select users before
        // rolling out to everyone.
        this.gos.get("deltaSort");
        this.sort(sortOptions, deltaSort, params.changedRowNodes, params.changedPath);
    }
    sort(sortOptions, useDeltaSort, changedRowNodes, changedPath) {
        const { gos: gos, colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, rowNodeSorter: rowNodeSorter, rowRenderer: rowRenderer, showRowGroupCols: showRowGroupCols } = this.beans;
        const groupMaintainOrder = gos.get("groupMaintainOrder");
        const groupColumnsPresent = colModel.getCols().some((c)=>c.isRowGroupActive());
        const groupCols = rowGroupColsSvc?.columns;
        const isPivotMode = colModel.isPivotMode();
        const postSortFunc = gos.getCallback("postSortRows");
        let hasAnyFirstChildChanged = false;
        let sortContainsGroupColumns;
        const callback = (rowNode)=>{
            const skipSortingPivotLeafs = isPivotMode && rowNode.leafGroup;
            let skipSortingGroups = groupMaintainOrder && groupColumnsPresent && !rowNode.leafGroup;
            if (skipSortingGroups) {
                sortContainsGroupColumns ?? (sortContainsGroupColumns = this.shouldSortContainsGroupCols(sortOptions));
                skipSortingGroups && (skipSortingGroups = !sortContainsGroupColumns);
            }
            let newChildrenAfterSort = null;
            if (skipSortingGroups) {
                let wasSortExplicitlyRemoved = false;
                if (groupCols) {
                    const nextGroupIndex = rowNode.level + 1;
                    if (nextGroupIndex < groupCols.length) wasSortExplicitlyRemoved = groupCols[nextGroupIndex].getSort() === null;
                }
                if (!wasSortExplicitlyRemoved) newChildrenAfterSort = $437b23f6a393c3bf$var$preserveGroupOrder(rowNode);
            } else if (!sortOptions.length || skipSortingPivotLeafs) ;
            else if (useDeltaSort && changedRowNodes) newChildrenAfterSort = $437b23f6a393c3bf$var$doDeltaSort(rowNodeSorter, rowNode, changedRowNodes, changedPath, sortOptions);
            else newChildrenAfterSort = rowNodeSorter.doFullSort(rowNode.childrenAfterAggFilter, sortOptions);
            newChildrenAfterSort || (newChildrenAfterSort = rowNode.childrenAfterAggFilter?.slice(0) ?? []);
            hasAnyFirstChildChanged || (hasAnyFirstChildChanged = rowNode.childrenAfterSort?.[0] !== newChildrenAfterSort[0]);
            rowNode.childrenAfterSort = newChildrenAfterSort;
            $437b23f6a393c3bf$var$updateRowNodeAfterSort(rowNode);
            if (postSortFunc) {
                const params = {
                    nodes: rowNode.childrenAfterSort
                };
                postSortFunc(params);
            }
        };
        changedPath?.forEachChangedNodeDepthFirst(callback);
        if (hasAnyFirstChildChanged && gos.get("groupHideOpenParents")) {
            const columns = showRowGroupCols?.getShowRowGroupCols();
            if (columns?.length) rowRenderer.refreshCells({
                columns: columns,
                force: true
            });
        }
    }
    shouldSortContainsGroupCols(sortOptions) {
        const sortOptionsLen = sortOptions.length;
        if (!sortOptionsLen) return false;
        if ($437b23f6a393c3bf$export$96c51c2547b81aed(this.gos)) {
            for(let i = 0; i < sortOptionsLen; ++i){
                const column = sortOptions[i].column;
                if (column.isPrimary() && column.isRowGroupActive()) return true;
            }
            return false;
        }
        for(let i = 0; i < sortOptionsLen; ++i){
            if (sortOptions[i].column.getColDef().showRowGroup) return true;
        }
        return false;
    }
};
var $437b23f6a393c3bf$var$doDeltaSort = (rowNodeSorter, rowNode, changedRowNodes, changedPath, sortOptions)=>{
    const unsortedRows = rowNode.childrenAfterAggFilter;
    const oldSortedRows = rowNode.childrenAfterSort;
    if (!oldSortedRows) return rowNodeSorter.doFullSort(unsortedRows, sortOptions);
    const untouchedRows = /* @__PURE__ */ new Set();
    const touchedRows = [];
    const { updates: updates, adds: adds } = changedRowNodes;
    for(let i = 0, len = unsortedRows.length; i < len; ++i){
        const row = unsortedRows[i];
        if (updates.has(row) || adds.has(row) || changedPath && !changedPath.canSkip(row)) touchedRows.push({
            currentPos: touchedRows.length,
            rowNode: row
        });
        else untouchedRows.add(row);
    }
    const sortedUntouchedRows = oldSortedRows.filter((child)=>untouchedRows.has(child)).map((rowNode2, currentPos)=>({
            currentPos: currentPos,
            rowNode: rowNode2
        }));
    touchedRows.sort((a, b)=>rowNodeSorter.compareRowNodes(sortOptions, a, b));
    return $437b23f6a393c3bf$var$mergeSortedArrays(rowNodeSorter, sortOptions, touchedRows, sortedUntouchedRows);
};
var $437b23f6a393c3bf$var$mergeSortedArrays = (rowNodeSorter, sortOptions, arr1, arr2)=>{
    let i = 0;
    let j = 0;
    const arr1Length = arr1.length;
    const arr2Length = arr2.length;
    const res = new Array(arr1Length + arr2Length);
    let k = 0;
    while(i < arr1Length && j < arr2Length){
        const a = arr1[i];
        const b = arr2[j];
        if (rowNodeSorter.compareRowNodes(sortOptions, a, b) < 0) {
            res[k++] = a.rowNode;
            ++i;
        } else {
            res[k++] = b.rowNode;
            ++j;
        }
    }
    while(i < arr1Length)res[k++] = arr1[i++].rowNode;
    while(j < arr2Length)res[k++] = arr2[j++].rowNode;
    return res;
};
var $437b23f6a393c3bf$var$preserveGroupOrder = (node)=>{
    const childrenAfterSort = node.childrenAfterSort;
    const childrenAfterAggFilter = node.childrenAfterAggFilter;
    const childrenAfterSortLen = childrenAfterSort?.length;
    const childrenAfterAggFilterLen = childrenAfterAggFilter?.length;
    if (!childrenAfterSortLen || !childrenAfterAggFilterLen) return null;
    const result = new Array(childrenAfterAggFilterLen);
    const processed = /* @__PURE__ */ new Set();
    for(let i = 0; i < childrenAfterAggFilterLen; ++i)processed.add(childrenAfterAggFilter[i]);
    let writeIdx = 0;
    for(let i = 0; i < childrenAfterSortLen; ++i){
        const node2 = childrenAfterSort[i];
        if (processed.delete(node2)) result[writeIdx++] = node2;
    }
    if (processed.size === 0 && writeIdx === childrenAfterSortLen) return childrenAfterSort;
    for (const newNode of processed)result[writeIdx++] = newNode;
    result.length = writeIdx;
    return result;
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModel.ts
var $437b23f6a393c3bf$var$ClientSideRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
        // top most node of the tree. the children are the user provided data.
        this.rootNode = null;
        this.rowCountReady = false;
        this.nodeManager = void 0;
        this.rowsToDisplay = [];
        // the rows mapped to rows to display
        /** Keep track if row data was updated. Important with suppressModelUpdateAfterUpdateTransaction and refreshModel api is called  */ this.rowDataUpdatedPending = false;
        this.asyncTransactions = null;
        this.asyncTransactionsTimer = 0;
        /** Has the start method been called */ this.started = false;
        /**
     * This is to prevent refresh model being called when it's already being called.
     * E.g. the group stage can trigger initial state filter model to be applied. This fires onFilterChanged,
     * which then triggers the listener here that calls refresh model again but at the filter stage
     * (which is about to be run by the original call).
     */ this.refreshingModel = false;
        this.rowNodesCountReady = false;
        /** The stages that process row nodes, in order of execution */ this.stages = [];
        /** Maps a property name to the index in this.stages array */ this.stagesRefreshProps = /* @__PURE__ */ new Map();
        this.onRowHeightChanged_debounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onRowHeightChanged.bind(this), 100);
    }
    postConstruct() {
        const beans = this.beans;
        const rootNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
        this.rootNode = rootNode;
        this.nodeManager = this.createBean(new $437b23f6a393c3bf$var$ClientSideNodeManager(rootNode));
        const refreshEverythingFunc = this.refreshModel.bind(this, {
            step: "group"
        });
        const refreshEverythingAfterColsChangedFunc = this.refreshModel.bind(this, {
            step: "group",
            // after cols change, row grouping (the first stage) could of changed
            afterColumnsChanged: true,
            keepRenderedRows: true,
            // we want animations cos sorting or filtering could be applied
            animate: !this.gos.get("suppressAnimationFrame")
        });
        this.addManagedEventListeners({
            newColumnsLoaded: refreshEverythingAfterColsChangedFunc,
            columnRowGroupChanged: refreshEverythingFunc,
            columnValueChanged: this.onValueChanged.bind(this),
            columnPivotChanged: this.refreshModel.bind(this, {
                step: "pivot"
            }),
            filterChanged: this.onFilterChanged.bind(this),
            sortChanged: this.onSortChanged.bind(this),
            columnPivotModeChanged: refreshEverythingFunc,
            gridStylesChanged: this.onGridStylesChanges.bind(this),
            gridReady: this.onGridReady.bind(this),
            rowExpansionStateChanged: this.onRowGroupOpened.bind(this)
        });
        this.addPropertyListeners();
    }
    addPropertyListeners() {
        const { beans: beans, stagesRefreshProps: stagesRefreshProps } = this;
        const orderedStages = [
            beans.groupStage,
            beans.filterStage,
            beans.pivotStage,
            beans.aggStage,
            beans.sortStage,
            beans.filterAggStage,
            beans.flattenStage
        ].filter((stage)=>!!stage);
        this.stages = orderedStages;
        for(let i = orderedStages.length - 1; i >= 0; --i)for (const prop of orderedStages[i].refreshProps)stagesRefreshProps.set(prop, i);
        this.addManagedPropertyListeners([
            ...stagesRefreshProps.keys()
        ], (params)=>{
            const properties = params.changeSet?.properties;
            if (properties) this.onPropChange(properties);
        });
        this.addManagedPropertyListener("rowData", ()=>this.onPropChange([
                "rowData"
            ]));
        this.addManagedPropertyListener("rowHeight", ()=>this.resetRowHeights());
    }
    start() {
        this.started = true;
        if (this.rowNodesCountReady) this.refreshModel({
            step: "group",
            rowDataUpdated: true,
            newData: true
        });
        else this.setInitialData();
    }
    setInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData) this.onPropChange([
            "rowData"
        ]);
    }
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        let atLeastOneChange;
        let res = false;
        do {
            atLeastOneChange = false;
            const rowAtStartPixel = this.getRowIndexAtPixel(startPixel);
            const rowAtEndPixel = this.getRowIndexAtPixel(endPixel);
            const firstRow = Math.max(rowAtStartPixel, startLimitIndex);
            const lastRow = Math.min(rowAtEndPixel, endLimitIndex);
            for(let rowIndex = firstRow; rowIndex <= lastRow; rowIndex++){
                const rowNode = this.getRow(rowIndex);
                if (rowNode.rowHeightEstimated) {
                    const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                    rowNode.setRowHeight(rowHeight.height);
                    atLeastOneChange = true;
                    res = true;
                }
            }
            if (atLeastOneChange) this.setRowTopAndRowIndex();
        }while (atLeastOneChange);
        return res;
    }
    onPropChange(properties) {
        const { nodeManager: nodeManager, gos: gos, beans: beans } = this;
        const groupStage = beans.groupStage;
        if (!nodeManager) return;
        const changedProps = new Set(properties);
        const extractData = groupStage?.onPropChange(changedProps);
        let newRowData;
        if (changedProps.has("rowData")) newRowData = gos.get("rowData");
        else if (extractData) newRowData = groupStage?.extractData();
        if (newRowData && !Array.isArray(newRowData)) {
            newRowData = null;
            $437b23f6a393c3bf$export$545083624300f13d(1);
        }
        const params = {
            step: "nothing",
            changedProps: changedProps
        };
        if (newRowData) {
            const immutable = !extractData && !this.isEmpty() && newRowData.length > 0 && gos.exists("getRowId") && // backward compatibility - for who want old behaviour of Row IDs but NOT Immutable Data.
            !gos.get("resetRowDataOnUpdate");
            if (immutable) {
                params.keepRenderedRows = true;
                params.animate = !gos.get("suppressAnimationFrame");
                params.changedRowNodes = new $437b23f6a393c3bf$var$ChangedRowNodes();
                nodeManager.setImmutableRowData(params, newRowData);
            } else {
                params.rowDataUpdated = true;
                params.newData = true;
                nodeManager.setNewRowData(newRowData);
                this.rowNodesCountReady = true;
            }
        }
        const step = params.rowDataUpdated ? "group" : this.getRefreshedStage(properties);
        if (step) {
            params.step = step;
            this.refreshModel(params);
        }
    }
    getRefreshedStage(properties) {
        const { stages: stages, stagesRefreshProps: stagesRefreshProps } = this;
        const stagesLen = stages.length;
        let minIndex = stagesLen;
        for(let i = 0, len = properties.length; i < len && minIndex; ++i)minIndex = Math.min(minIndex, stagesRefreshProps.get(properties[i]) ?? minIndex);
        return minIndex < stagesLen ? stages[minIndex].step : null;
    }
    setRowTopAndRowIndex(outputDisplayedRowsMapped) {
        const { beans: beans, rowsToDisplay: rowsToDisplay } = this;
        const defaultRowHeight = beans.environment.getDefaultRowHeight();
        let nextRowTop = 0;
        const allowEstimate = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        for(let i = 0, len = rowsToDisplay.length; i < len; ++i){
            const rowNode = rowsToDisplay[i];
            const id = rowNode.id;
            if (id != null) outputDisplayedRowsMapped?.add(id);
            if (rowNode.rowHeight == null) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, rowNode, allowEstimate, defaultRowHeight);
                rowNode.setRowHeight(rowHeight.height, rowHeight.estimated);
            }
            rowNode.setRowTop(nextRowTop);
            rowNode.setRowIndex(i);
            nextRowTop += rowNode.rowHeight;
        }
    }
    clearRowTopAndRowIndex(changedPath, displayedRowsMapped) {
        const changedPathActive = changedPath.active;
        const clearIfNotDisplayed = (rowNode)=>{
            if (rowNode?.id != null && !displayedRowsMapped.has(rowNode.id)) rowNode.clearRowTopAndRowIndex();
        };
        const recurse = (rowNode)=>{
            clearIfNotDisplayed(rowNode);
            clearIfNotDisplayed(rowNode.detailNode);
            clearIfNotDisplayed(rowNode.sibling);
            const childrenAfterGroup = rowNode.childrenAfterGroup;
            if (!rowNode.hasChildren() || !childrenAfterGroup) return;
            const isRootNode = rowNode.level == -1;
            const skipChildren = changedPathActive && !isRootNode && !rowNode.expanded;
            if (skipChildren) return;
            for(let i = 0, len = childrenAfterGroup.length; i < len; ++i)recurse(childrenAfterGroup[i]);
        };
        const rootNode = this.rootNode;
        if (rootNode) recurse(rootNode);
    }
    isLastRowIndexKnown() {
        return true;
    }
    getRowCount() {
        return this.rowsToDisplay.length;
    }
    /**
   * Returns the number of rows with level === 1
   */ getTopLevelRowCount() {
        const { rootNode: rootNode, rowsToDisplay: rowsToDisplay } = this;
        if (!rootNode || !rowsToDisplay.length) return 0;
        const showingRootNode = rowsToDisplay[0] === rootNode;
        if (showingRootNode) return 1;
        const totalFooterInc = rootNode.sibling?.displayed ? 1 : 0;
        return (rootNode.childrenAfterSort?.length ?? 0) + totalFooterInc;
    }
    /**
   * Get the row display index by the top level index
   * top level index is the index of rows with level === 1
   */ getTopLevelRowDisplayedIndex(topLevelIndex) {
        const { beans: beans, rootNode: rootNode, rowsToDisplay: rowsToDisplay } = this;
        const showingRootNode = !rootNode || !rowsToDisplay.length || rowsToDisplay[0] === rootNode;
        if (showingRootNode) return topLevelIndex;
        const childrenAfterSort = rootNode.childrenAfterSort;
        const getDefaultIndex = (adjustedIndex)=>{
            let rowNode = childrenAfterSort[adjustedIndex];
            if (this.gos.get("groupHideOpenParents")) while(rowNode.expanded && rowNode.childrenAfterSort && rowNode.childrenAfterSort.length > 0)rowNode = rowNode.childrenAfterSort[0];
            return rowNode.rowIndex;
        };
        const footerSvc = beans.footerSvc;
        if (footerSvc) return footerSvc?.getTopDisplayIndex(rowsToDisplay, topLevelIndex, childrenAfterSort, getDefaultIndex);
        return getDefaultIndex(topLevelIndex);
    }
    /**
   * The opposite of `getTopLevelRowDisplayedIndex`
   */ getTopLevelIndexFromDisplayedIndex(displayedIndex) {
        const { rootNode: rootNode, rowsToDisplay: rowsToDisplay } = this;
        const showingRootNode = !rootNode || !rowsToDisplay.length || rowsToDisplay[0] === rootNode;
        if (showingRootNode) return displayedIndex;
        let node = this.getRow(displayedIndex);
        if (node.footer) node = node.sibling;
        let parent = node.parent;
        while(parent && parent !== rootNode){
            node = parent;
            parent = node.parent;
        }
        const topLevelIndex = rootNode.childrenAfterSort?.indexOf(node) ?? -1;
        return topLevelIndex >= 0 ? topLevelIndex : displayedIndex;
    }
    getRowBounds(index) {
        const rowNode = this.rowsToDisplay[index];
        return rowNode ? {
            rowTop: rowNode.rowTop,
            rowHeight: rowNode.rowHeight
        } : null;
    }
    onRowGroupOpened() {
        this.refreshModel({
            step: "map",
            keepRenderedRows: true,
            animate: $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos)
        });
    }
    onFilterChanged({ afterDataChange: afterDataChange, columns: columns }) {
        if (!afterDataChange) {
            const primaryOrQuickFilterChanged = columns.length === 0 || columns.some((col)=>col.isPrimary());
            const step = primaryOrQuickFilterChanged ? "filter" : "filter_aggregates";
            this.refreshModel({
                step: step,
                keepRenderedRows: true,
                animate: $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos)
            });
        }
    }
    onSortChanged() {
        this.refreshModel({
            step: "sort",
            keepRenderedRows: true,
            animate: $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos)
        });
    }
    getType() {
        return "clientSide";
    }
    onValueChanged() {
        this.refreshModel({
            step: this.beans.colModel.isPivotActive() ? "pivot" : "aggregate"
        });
    }
    createChangePath(enabled) {
        const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, this.rootNode);
        changedPath.active = enabled;
        return changedPath;
    }
    isSuppressModelUpdateAfterUpdateTransaction(params) {
        if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction")) return false;
        const { changedRowNodes: changedRowNodes, newData: newData, rowDataUpdated: rowDataUpdated } = params;
        if (!changedRowNodes || newData || !rowDataUpdated) return false;
        if (changedRowNodes.removals.size || changedRowNodes.adds.size) return false;
        return true;
    }
    refreshModel(params) {
        const { nodeManager: nodeManager, beans: beans, eventSvc: eventSvc, started: started, refreshingModel: refreshingModel } = this;
        if (!nodeManager) return;
        const rowDataUpdated = !!params.rowDataUpdated;
        const changedPath = params.changedPath ?? (params.changedPath = this.createChangePath(!params.newData && rowDataUpdated));
        if (started && rowDataUpdated) eventSvc.dispatchEvent({
            type: "rowDataUpdated"
        });
        if (!started || refreshingModel || beans.colModel.changeEventsDispatching || this.isSuppressModelUpdateAfterUpdateTransaction(params)) {
            this.rowDataUpdatedPending || (this.rowDataUpdatedPending = rowDataUpdated);
            return;
        }
        if (this.rowDataUpdatedPending) {
            this.rowDataUpdatedPending = false;
            params.step = "group";
        }
        this.refreshingModel = true;
        beans.masterDetailSvc?.refreshModel(params);
        if (rowDataUpdated && params.step !== "group") beans.colFilter?.refreshModel();
        switch(params.step){
            case "group":
                this.doGrouping(params);
            case "filter":
                this.doFilter(changedPath);
            case "pivot":
                this.doPivot(changedPath);
            case "aggregate":
                this.doAggregate(changedPath);
            case "filter_aggregates":
                this.doFilterAggregates(changedPath);
            case "sort":
                this.doSort(params.changedRowNodes, changedPath);
            case "map":
                this.doRowsToDisplay();
        }
        const displayedNodesMapped = /* @__PURE__ */ new Set();
        this.setRowTopAndRowIndex(displayedNodesMapped);
        this.clearRowTopAndRowIndex(changedPath, displayedNodesMapped);
        this.refreshingModel = false;
        eventSvc.dispatchEvent({
            type: "modelUpdated",
            animate: params.animate,
            keepRenderedRows: params.keepRenderedRows,
            newData: params.newData,
            newPage: false,
            keepUndoRedoStack: params.keepUndoRedoStack
        });
    }
    isEmpty() {
        return !this.rootNode?._leafs?.length || !this.beans.colModel?.ready;
    }
    isRowsToRender() {
        return this.rowsToDisplay.length > 0;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        let started = false;
        let finished = false;
        const result = [];
        const groupsSelectChildren = $437b23f6a393c3bf$export$460e5745f0e6a40d(this.gos);
        this.forEachNodeAfterFilterAndSort((rowNode)=>{
            if (finished) return;
            if (started) {
                if (rowNode === lastInRange || rowNode === firstInRange) {
                    finished = true;
                    if (groupsSelectChildren && rowNode.group) {
                        $437b23f6a393c3bf$var$addAllLeafs(result, rowNode);
                        return;
                    }
                }
            }
            if (!started) {
                if (rowNode !== lastInRange && rowNode !== firstInRange) return;
                started = true;
                if (lastInRange === firstInRange) finished = true;
            }
            const includeThisNode = !rowNode.group || !groupsSelectChildren;
            if (includeThisNode) result.push(rowNode);
        });
        return result;
    }
    getTopLevelNodes() {
        return this.rootNode?.childrenAfterGroup ?? null;
    }
    getRow(index) {
        return this.rowsToDisplay[index];
    }
    isRowPresent(rowNode) {
        return this.rowsToDisplay.indexOf(rowNode) >= 0;
    }
    getRowIndexAtPixel(pixelToMatch) {
        const rowsToDisplay = this.rowsToDisplay;
        const rowsToDisplayLen = rowsToDisplay.length;
        if (this.isEmpty() || rowsToDisplayLen === 0) return -1;
        let bottomPointer = 0;
        let topPointer = rowsToDisplayLen - 1;
        if (pixelToMatch <= 0) return 0;
        const lastNode = rowsToDisplay[topPointer];
        if (lastNode.rowTop <= pixelToMatch) return topPointer;
        let oldBottomPointer = -1;
        let oldTopPointer = -1;
        while(true){
            const midPointer = Math.floor((bottomPointer + topPointer) / 2);
            const currentRowNode = rowsToDisplay[midPointer];
            if (this.isRowInPixel(currentRowNode, pixelToMatch)) return midPointer;
            if (currentRowNode.rowTop < pixelToMatch) bottomPointer = midPointer + 1;
            else if (currentRowNode.rowTop > pixelToMatch) topPointer = midPointer - 1;
            const caughtInInfiniteLoop = oldBottomPointer === bottomPointer && oldTopPointer === topPointer;
            if (caughtInInfiniteLoop) return midPointer;
            oldBottomPointer = bottomPointer;
            oldTopPointer = topPointer;
        }
    }
    isRowInPixel(rowNode, pixelToMatch) {
        const topPixel = rowNode.rowTop;
        const bottomPixel = topPixel + rowNode.rowHeight;
        return topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
    }
    forEachLeafNode(callback) {
        const allLeafs = this.rootNode?._leafs;
        if (allLeafs) for(let i = 0, len = allLeafs.length; i < len; ++i)callback(allLeafs[i], i);
    }
    forEachNode(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes);
    }
    forEachDisplayedNode(callback) {
        const rowsToDisplay = this.rowsToDisplay;
        for(let i = 0, len = rowsToDisplay.length; i < len; ++i)callback(rowsToDisplay[i], i);
    }
    forEachNodeAfterFilter(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>node.childrenAfterAggFilter);
    }
    forEachNodeAfterFilterAndSort(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>node.childrenAfterSort);
    }
    forEachPivotNode(callback, includeFooterNodes, afterSort) {
        const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        if (!colModel.isPivotMode()) return;
        if (!rowGroupColsSvc?.columns.length) {
            callback(this.rootNode, 0);
            return;
        }
        const childrenField = afterSort ? "childrenAfterSort" : "childrenAfterGroup";
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>!node.leafGroup ? node[childrenField] : null);
    }
    /**
   * Iterate through each node and all of its children
   * @param callback the function to execute for each node
   * @param includeFooterNodes whether to also iterate over footer nodes
   * @param nodes the nodes to start iterating over
   * @param getChildren a function to determine the recursion strategy
   * @param startIndex the index to start from
   * @returns the index ended at
   */ depthFirstSearchRowNodes(callback, includeFooterNodes = false, getChildren = (node2)=>node2.childrenAfterGroup, node = this.rootNode, startIndex = 0) {
        let index = startIndex;
        if (!node) return index;
        const isRootNode = node === this.rootNode;
        if (!isRootNode) callback(node, index++);
        if (node.hasChildren() && !node.footer) {
            const children = getChildren(node);
            if (children) {
                const footerSvc = this.beans.footerSvc;
                index = footerSvc?.addTotalRows(index, node, callback, includeFooterNodes, isRootNode, "top") ?? index;
                for (const node2 of children)index = this.depthFirstSearchRowNodes(callback, includeFooterNodes, getChildren, node2, index);
                return footerSvc?.addTotalRows(index, node, callback, includeFooterNodes, isRootNode, "bottom") ?? index;
            }
        }
        return index;
    }
    // it's possible to recompute the aggregate without doing the other parts + api.refreshClientSideRowModel('aggregate')
    doAggregate(changedPath) {
        const rootNode = this.rootNode;
        if (rootNode) this.beans.aggStage?.execute({
            rowNode: rootNode,
            changedPath: changedPath
        });
    }
    doFilterAggregates(changedPath) {
        const rootNode = this.rootNode;
        const filterAggStage = this.beans.filterAggStage;
        if (filterAggStage) {
            filterAggStage.execute({
                rowNode: rootNode,
                changedPath: changedPath
            });
            return;
        }
        rootNode.childrenAfterAggFilter = rootNode.childrenAfterFilter;
    }
    doSort(changedRowNodes, changedPath) {
        const sortStage = this.beans.sortStage;
        if (sortStage) {
            sortStage.execute({
                rowNode: this.rootNode,
                changedRowNodes: changedRowNodes,
                changedPath: changedPath
            });
            return;
        }
        changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            rowNode.childrenAfterSort = rowNode.childrenAfterAggFilter.slice(0);
            $437b23f6a393c3bf$var$updateRowNodeAfterSort(rowNode);
        });
    }
    doGrouping(params) {
        const rootNode = this.rootNode;
        const groupStage = this.beans.groupStage;
        const groupingChanged = groupStage?.execute({
            rowNode: rootNode,
            changedRowNodes: params.changedRowNodes,
            changedPath: params.changedPath,
            afterColumnsChanged: !!params.afterColumnsChanged
        });
        if (groupingChanged === void 0) {
            const allLeafs = rootNode._leafs;
            rootNode.childrenAfterGroup = allLeafs;
            rootNode.updateHasChildren();
            const sibling = rootNode.sibling;
            if (sibling) sibling.childrenAfterGroup = allLeafs;
        }
        if (groupingChanged || params.rowDataUpdated) this.beans.colFilter?.refreshModel();
        if (!this.rowCountReady && this.rowNodesCountReady) {
            this.rowCountReady = true;
            this.eventSvc.dispatchEventOnce({
                type: "rowCountReady"
            });
        }
    }
    doFilter(changedPath) {
        const filterStage = this.beans.filterStage;
        if (filterStage) {
            filterStage.execute({
                rowNode: this.rootNode,
                changedPath: changedPath
            });
            return;
        }
        changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode);
        }, true);
    }
    doPivot(changedPath) {
        this.beans.pivotStage?.execute({
            rowNode: this.rootNode,
            changedPath: changedPath
        });
    }
    getRowNode(id) {
        const found = this.nodeManager?.getRowNode(id);
        if (typeof found === "object") return found;
        const idIsGroup = typeof id == "string" && id.indexOf($437b23f6a393c3bf$export$cb038fdaa8338d9f) === 0;
        return idIsGroup ? this.beans.groupStage?.getNode(id) : void 0;
    }
    batchUpdateRowData(rowDataTransaction, callback) {
        if (!this.asyncTransactionsTimer) {
            this.asyncTransactions = [];
            const waitMilliseconds = this.gos.get("asyncTransactionWaitMillis");
            this.asyncTransactionsTimer = setTimeout(()=>this.executeBatchUpdateRowData(), waitMilliseconds);
        }
        this.asyncTransactions.push({
            rowDataTransaction: rowDataTransaction,
            callback: callback
        });
    }
    flushAsyncTransactions() {
        const asyncTransactionsTimer = this.asyncTransactionsTimer;
        if (asyncTransactionsTimer) {
            clearTimeout(asyncTransactionsTimer);
            this.executeBatchUpdateRowData();
        }
    }
    executeBatchUpdateRowData() {
        const { nodeManager: nodeManager, beans: beans, eventSvc: eventSvc, asyncTransactions: asyncTransactions } = this;
        if (!nodeManager) return;
        beans.valueCache?.onDataChanged();
        const rowNodeTrans = [];
        const callbackFuncsBound = [];
        const changedRowNodes = new $437b23f6a393c3bf$var$ChangedRowNodes();
        for (const { rowDataTransaction: rowDataTransaction, callback: callback } of asyncTransactions ?? []){
            this.rowNodesCountReady = true;
            const rowNodeTransaction = nodeManager.updateRowData(rowDataTransaction, changedRowNodes);
            rowNodeTrans.push(rowNodeTransaction);
            if (callback) callbackFuncsBound.push(callback.bind(null, rowNodeTransaction));
        }
        this.commitTransactions(changedRowNodes);
        if (callbackFuncsBound.length > 0) setTimeout(()=>{
            for(let i = 0, len = callbackFuncsBound.length; i < len; i++)callbackFuncsBound[i]();
        }, 0);
        if (rowNodeTrans.length > 0) eventSvc.dispatchEvent({
            type: "asyncTransactionsFlushed",
            results: rowNodeTrans
        });
        this.asyncTransactionsTimer = 0;
        this.asyncTransactions = null;
    }
    /**
   * Used to apply transaction changes.
   * Called by gridApi & rowDragFeature
   */ updateRowData(rowDataTran) {
        const nodeManager = this.nodeManager;
        if (!nodeManager) return null;
        this.beans.valueCache?.onDataChanged();
        this.rowNodesCountReady = true;
        const changedRowNodes = new $437b23f6a393c3bf$var$ChangedRowNodes();
        const rowNodeTransaction = nodeManager.updateRowData(rowDataTran, changedRowNodes);
        this.commitTransactions(changedRowNodes);
        return rowNodeTransaction;
    }
    /**
   * Common to:
   * - executeBatchUpdateRowData (batch transactions)
   * - updateRowData (single transaction)
   * - setImmutableRowData (generated transaction)
   *
   * @param rowNodeTrans - the transactions to apply
   * @param orderChanged - whether the order of the rows has changed, either via generated transaction or user provided addIndex
   */ commitTransactions(changedRowNodes) {
        this.refreshModel({
            step: "group",
            rowDataUpdated: true,
            keepRenderedRows: true,
            animate: !this.gos.get("suppressAnimationFrame"),
            changedRowNodes: changedRowNodes,
            changedPath: this.createChangePath(true)
        });
    }
    doRowsToDisplay() {
        const { beans: beans, rootNode: rootNode } = this;
        const flattenStage = beans.flattenStage;
        if (flattenStage) {
            this.rowsToDisplay = flattenStage.execute({
                rowNode: rootNode
            });
            return;
        }
        const rowsToDisplay = this.rootNode.childrenAfterSort ?? [];
        for (const row of rowsToDisplay)row.setUiLevel(0);
        this.rowsToDisplay = rowsToDisplay;
    }
    onRowHeightChanged() {
        this.refreshModel({
            step: "map",
            keepRenderedRows: true,
            keepUndoRedoStack: true
        });
    }
    resetRowHeights() {
        const rootNode = this.rootNode;
        if (!rootNode) return;
        const atLeastOne = this.resetRowHeightsForAllRowNodes();
        rootNode.setRowHeight(rootNode.rowHeight, true);
        const sibling = rootNode.sibling;
        sibling?.setRowHeight(sibling.rowHeight, true);
        if (atLeastOne) this.onRowHeightChanged();
    }
    resetRowHeightsForAllRowNodes() {
        let atLeastOne = false;
        this.forEachNode((rowNode)=>{
            rowNode.setRowHeight(rowNode.rowHeight, true);
            const detailNode = rowNode.detailNode;
            detailNode?.setRowHeight(detailNode.rowHeight, true);
            const sibling = rowNode.sibling;
            sibling?.setRowHeight(sibling.rowHeight, true);
            atLeastOne = true;
        });
        return atLeastOne;
    }
    onGridStylesChanges(e) {
        if (e.rowHeightChanged && !this.beans.rowAutoHeight?.active) this.resetRowHeights();
    }
    onGridReady() {
        if (!this.started) this.setInitialData();
    }
    destroy() {
        super.destroy();
        this.nodeManager = this.destroyBean(this.nodeManager);
        this.started = false;
        this.rootNode = null;
        this.rowsToDisplay = [];
        this.asyncTransactions = null;
        clearTimeout(this.asyncTransactionsTimer);
    }
    /**
   * @deprecated v33.1
   */ onRowHeightChangedDebounced() {
        this.onRowHeightChanged_debounced();
    }
};
var $437b23f6a393c3bf$var$addAllLeafs = (result, node)=>{
    const childrenAfterGroup = node.childrenAfterGroup;
    if (childrenAfterGroup) for(let i = 0, len = childrenAfterGroup.length; i < len; ++i){
        const child = childrenAfterGroup[i];
        if (child.data) result.push(child);
        if (child.group) $437b23f6a393c3bf$var$addAllLeafs(result, child);
    }
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModelApi.ts
function $437b23f6a393c3bf$var$onGroupExpandedOrCollapsed(beans) {
    beans.expansionSvc?.onGroupExpandedOrCollapsed();
}
function $437b23f6a393c3bf$var$refreshClientSideRowModel(beans, step) {
    const clientSideRowModel = $437b23f6a393c3bf$export$f5285e6f27a03f95(beans);
    if (clientSideRowModel) {
        if (!step || step === "everything") step = "group";
        clientSideRowModel.refreshModel({
            step: step,
            keepRenderedRows: true,
            animate: !beans.gos.get("suppressAnimationFrame")
        });
    }
}
function $437b23f6a393c3bf$var$isRowDataEmpty(beans) {
    return $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.isEmpty() ?? true;
}
function $437b23f6a393c3bf$var$forEachLeafNode(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachLeafNode(callback);
}
function $437b23f6a393c3bf$var$forEachNodeAfterFilter(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachNodeAfterFilter(callback);
}
function $437b23f6a393c3bf$var$forEachNodeAfterFilterAndSort(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachNodeAfterFilterAndSort(callback);
}
function $437b23f6a393c3bf$var$applyTransaction(beans, rowDataTransaction) {
    return beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.updateRowData(rowDataTransaction));
}
function $437b23f6a393c3bf$var$applyTransactionAsync(beans, rowDataTransaction, callback) {
    beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.batchUpdateRowData(rowDataTransaction, callback));
}
function $437b23f6a393c3bf$var$flushAsyncTransactions(beans) {
    beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.flushAsyncTransactions());
}
function $437b23f6a393c3bf$var$getBestCostNodeSelection(beans) {
    return beans.selectionSvc?.getBestCostNodeSelection();
}
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModelModule.ts
var $437b23f6a393c3bf$export$4c74201d5a94c8e5 = {
    moduleName: "ClientSideRowModel",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$ClientSideRowModel,
        $437b23f6a393c3bf$var$SortStage
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$1a6625c5691649e8
    ]
};
var $437b23f6a393c3bf$export$15323dcce1401b05 = {
    moduleName: "ClientSideRowModelApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        onGroupExpandedOrCollapsed: $437b23f6a393c3bf$var$onGroupExpandedOrCollapsed,
        refreshClientSideRowModel: $437b23f6a393c3bf$var$refreshClientSideRowModel,
        isRowDataEmpty: $437b23f6a393c3bf$var$isRowDataEmpty,
        forEachLeafNode: $437b23f6a393c3bf$var$forEachLeafNode,
        forEachNodeAfterFilter: $437b23f6a393c3bf$var$forEachNodeAfterFilter,
        forEachNodeAfterFilterAndSort: $437b23f6a393c3bf$var$forEachNodeAfterFilterAndSort,
        applyTransaction: $437b23f6a393c3bf$var$applyTransaction,
        applyTransactionAsync: $437b23f6a393c3bf$var$applyTransactionAsync,
        flushAsyncTransactions: $437b23f6a393c3bf$var$flushAsyncTransactions,
        getBestCostNodeSelection: $437b23f6a393c3bf$var$getBestCostNodeSelection,
        resetRowHeights: $437b23f6a393c3bf$export$80ac5296eda53df5,
        onRowHeightChanged: $437b23f6a393c3bf$export$39ff1118beb20c8b
    },
    dependsOn: [
        $437b23f6a393c3bf$export$76fb120d9e251426,
        $437b23f6a393c3bf$export$b36e8e3b22fa08ce
    ]
};
// packages/ag-grid-community/src/export/gridSerializer.ts
var $437b23f6a393c3bf$var$GridSerializer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gridSerializer";
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.colModel = beans.colModel;
        this.rowModel = beans.rowModel;
        this.pinnedRowModel = beans.pinnedRowModel;
    }
    serialize(gridSerializingSession, params = {}) {
        const { allColumns: allColumns, columnKeys: columnKeys, skipRowGroups: skipRowGroups, exportRowNumbers: exportRowNumbers } = params;
        const columnsToExport = this.getColumnsToExport({
            allColumns: allColumns,
            skipRowGroups: skipRowGroups,
            columnKeys: columnKeys,
            exportRowNumbers: exportRowNumbers
        });
        return [
            // first pass, put in the header names of the cols
            this.prepareSession(columnsToExport),
            this.prependContent(params),
            this.exportColumnGroups(params, columnsToExport),
            this.exportHeaders(params, columnsToExport),
            this.processPinnedTopRows(params, columnsToExport),
            this.processRows(params, columnsToExport),
            this.processPinnedBottomRows(params, columnsToExport),
            this.appendContent(params)
        ].reduce((composed, f)=>f(composed), gridSerializingSession).parse();
    }
    processRow(gridSerializingSession, params, columnsToExport, node) {
        const rowSkipper = params.shouldRowBeSkipped || (()=>false);
        const isClipboardExport = params.rowPositions != null;
        const isExplicitExportSelection = isClipboardExport || !!params.onlySelected;
        const hideOpenParents = this.gos.get("groupHideOpenParents") && !isExplicitExportSelection;
        const isLeafNode = this.colModel.isPivotMode() ? node.leafGroup : !node.group;
        const isFooter = !!node.footer;
        const shouldSkipCurrentGroup = node.allChildrenCount === 1 && node.childrenAfterGroup?.length === 1 && $437b23f6a393c3bf$export$2f5892ff24cc879d(this.gos, node);
        if (!isLeafNode && !isFooter && (params.skipRowGroups || shouldSkipCurrentGroup || hideOpenParents) || params.onlySelected && !node.isSelected() || params.skipPinnedTop && node.rowPinned === "top" || params.skipPinnedBottom && node.rowPinned === "bottom" || node.stub) return;
        const nodeIsRootNode = node.level === -1;
        if (nodeIsRootNode && !isLeafNode && !isFooter) return;
        const shouldRowBeSkipped = rowSkipper($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: node
        }));
        if (shouldRowBeSkipped) return;
        const rowAccumulator = gridSerializingSession.onNewBodyRow(node);
        columnsToExport.forEach((column, index)=>{
            rowAccumulator.onColumn(column, index, node);
        });
        if (params.getCustomContentBelowRow) {
            const content = params.getCustomContentBelowRow($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                node: node
            }));
            if (content) gridSerializingSession.addCustomContent(content);
        }
    }
    appendContent(params) {
        return (gridSerializingSession)=>{
            const appendContent = params.appendContent;
            if (appendContent) gridSerializingSession.addCustomContent(appendContent);
            return gridSerializingSession;
        };
    }
    prependContent(params) {
        return (gridSerializingSession)=>{
            const prependContent = params.prependContent;
            if (prependContent) gridSerializingSession.addCustomContent(prependContent);
            return gridSerializingSession;
        };
    }
    prepareSession(columnsToExport) {
        return (gridSerializingSession)=>{
            gridSerializingSession.prepare(columnsToExport);
            return gridSerializingSession;
        };
    }
    exportColumnGroups(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnGroupHeaders) {
                const idCreator = new $437b23f6a393c3bf$export$b3b24737a74261fb();
                const { colGroupSvc: colGroupSvc } = this.beans;
                const displayedGroups = colGroupSvc ? colGroupSvc.createColumnGroups({
                    columns: columnsToExport,
                    idCreator: idCreator,
                    pinned: null,
                    isStandaloneStructure: true
                }) : columnsToExport;
                this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, params.processGroupHeaderCallback);
            }
            return gridSerializingSession;
        };
    }
    exportHeaders(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnHeaders) {
                const gridRowIterator = gridSerializingSession.onNewHeaderRow();
                columnsToExport.forEach((column, index)=>{
                    gridRowIterator.onColumn(column, index, void 0);
                });
            }
            return gridSerializingSession;
        };
    }
    processPinnedTopRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "top").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel?.getPinnedTopRow(position.rowIndex)).forEach(processRow);
            else if (!this.pinnedRowModel?.isManual()) this.pinnedRowModel?.forEachPinnedRow("top", processRow);
            return gridSerializingSession;
        };
    }
    processRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const rowModel = this.rowModel;
            const usingCsrm = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos, rowModel);
            const usingSsrm = $437b23f6a393c3bf$export$cf1bac0013650216(this.gos, rowModel);
            const onlySelectedNonStandardModel = !usingCsrm && params.onlySelected;
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            const { exportedRows: exportedRows = "filteredAndSorted" } = params;
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned == null).sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>rowModel.getRow(position.rowIndex)).forEach(processRow);
            else if (this.colModel.isPivotMode()) {
                if (usingCsrm) rowModel.forEachPivotNode(processRow, true, exportedRows === "filteredAndSorted");
                else if (usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else rowModel.forEachNode(processRow);
            } else if (params.onlySelectedAllPages || onlySelectedNonStandardModel) {
                const selectedNodes = this.beans.selectionSvc?.getSelectedNodes() ?? [];
                this.replicateSortedOrder(selectedNodes);
                selectedNodes.forEach(processRow);
            } else if (exportedRows === "all") rowModel.forEachNode(processRow);
            else if (usingCsrm || usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
            else rowModel.forEachNode(processRow);
            return gridSerializingSession;
        };
    }
    replicateSortedOrder(rows) {
        const { sortSvc: sortSvc, rowNodeSorter: rowNodeSorter } = this.beans;
        if (!sortSvc || !rowNodeSorter) return;
        const sortOptions = sortSvc.getSortOptions();
        const compareNodes = (rowA, rowB)=>{
            if (rowA.rowIndex != null && rowB.rowIndex != null) return rowA.rowIndex - rowB.rowIndex;
            if (rowA.level === rowB.level) {
                if (rowA.parent?.id === rowB.parent?.id) return rowNodeSorter.compareRowNodes(sortOptions, {
                    rowNode: rowA,
                    currentPos: rowA.rowIndex ?? -1
                }, {
                    rowNode: rowB,
                    currentPos: rowB.rowIndex ?? -1
                });
                return compareNodes(rowA.parent, rowB.parent);
            }
            if (rowA.level > rowB.level) return compareNodes(rowA.parent, rowB);
            return compareNodes(rowA, rowB.parent);
        };
        rows.sort(compareNodes);
    }
    processPinnedBottomRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "bottom").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel?.getPinnedBottomRow(position.rowIndex)).forEach(processRow);
            else if (!this.pinnedRowModel?.isManual()) this.pinnedRowModel?.forEachPinnedRow("bottom", processRow);
            return gridSerializingSession;
        };
    }
    getColumnsToExport(params) {
        const { allColumns: allColumns = false, skipRowGroups: skipRowGroups = false, exportRowNumbers: exportRowNumbers = false, columnKeys: columnKeys } = params;
        const { colModel: colModel, gos: gos, visibleCols: visibleCols } = this;
        const isPivotMode = colModel.isPivotMode();
        const filterSpecialColumns = (col)=>{
            if ($437b23f6a393c3bf$export$f6074a9792015c5d(col)) return false;
            return !$437b23f6a393c3bf$export$3d3e7d751f0445eb(col) || exportRowNumbers;
        };
        if (columnKeys?.length) return colModel.getColsForKeys(columnKeys).filter(filterSpecialColumns);
        const isTreeData = gos.get("treeData");
        let columnsToExport = [];
        if (allColumns && !isPivotMode) columnsToExport = colModel.getCols();
        else columnsToExport = visibleCols.allCols;
        columnsToExport = columnsToExport.filter((column)=>filterSpecialColumns(column) && (skipRowGroups && !isTreeData ? !$437b23f6a393c3bf$export$61b34611dc010a97(column) : true));
        return columnsToExport;
    }
    recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, processGroupHeaderCallback) {
        const directChildrenHeaderGroups = [];
        for (const columnGroupChild of displayedGroups){
            const columnGroup = columnGroupChild;
            if (!columnGroup.getChildren) continue;
            for (const it of columnGroup.getChildren() ?? [])directChildrenHeaderGroups.push(it);
        }
        if (displayedGroups.length > 0 && $437b23f6a393c3bf$export$1f44a60fc23f9028(displayedGroups[0])) this.doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback);
        if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession, processGroupHeaderCallback);
    }
    doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback) {
        const gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
        let columnIndex = 0;
        for (const columnGroupChild of displayedGroups){
            const columnGroup = columnGroupChild;
            let name;
            if (processGroupHeaderCallback) name = processGroupHeaderCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                columnGroup: columnGroup
            }));
            else name = this.beans.colNames.getDisplayNameForColumnGroup(columnGroup, "header");
            const columnsToCalculateRange = columnGroup.isExpandable() ? columnGroup.getLeafColumns() : [];
            const collapsibleGroupRanges = columnsToCalculateRange.reduce((collapsibleGroups, currentColumn, currentIdx, arr)=>{
                let lastGroup = $437b23f6a393c3bf$export$236389741107357f(collapsibleGroups);
                const groupShow = currentColumn.getColumnGroupShow() === "open";
                if (!groupShow) {
                    if (lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx - 1;
                } else if (!lastGroup || lastGroup[1] != null) {
                    lastGroup = [
                        currentIdx
                    ];
                    collapsibleGroups.push(lastGroup);
                }
                if (currentIdx === arr.length - 1 && lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx;
                return collapsibleGroups;
            }, []);
            gridRowIterator.onColumn(columnGroup, name || "", columnIndex++, columnGroup.getLeafColumns().length - 1, collapsibleGroupRanges);
        }
    }
};
// packages/ag-grid-community/src/export/exportModule.ts
var $437b23f6a393c3bf$export$e6030935e93fda2b = {
    moduleName: "SharedExport",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$GridSerializer
    ]
};
// packages/ag-grid-community/src/csvExport/csvSerializingSession.ts
var $437b23f6a393c3bf$var$LINE_SEPARATOR = "\r\n";
var $437b23f6a393c3bf$var$CsvSerializingSession = class extends $437b23f6a393c3bf$export$5018ab277b833b61 {
    constructor(config){
        super(config);
        this.config = config;
        this.isFirstLine = true;
        this.result = "";
        const { suppressQuotes: suppressQuotes, columnSeparator: columnSeparator } = config;
        this.suppressQuotes = suppressQuotes;
        this.columnSeparator = columnSeparator;
    }
    addCustomContent(content) {
        if (!content) return;
        if (typeof content === "string") {
            if (!/^\s*\n/.test(content)) this.beginNewLine();
            content = content.replace(/\r?\n/g, $437b23f6a393c3bf$var$LINE_SEPARATOR);
            this.result += content;
        } else content.forEach((row)=>{
            this.beginNewLine();
            row.forEach((cell, index)=>{
                if (index !== 0) this.result += this.columnSeparator;
                this.result += this.putInQuotes(cell.data.value || "");
                if (cell.mergeAcross) this.appendEmptyCells(cell.mergeAcross);
            });
        });
    }
    onNewHeaderGroupingRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
        };
    }
    onNewHeaderGroupingRowColumn(columnGroup, header, index, span) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(header);
        this.appendEmptyCells(span);
    }
    appendEmptyCells(count) {
        for(let i = 1; i <= count; i++)this.result += this.columnSeparator + this.putInQuotes("");
    }
    onNewHeaderRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderRowColumn.bind(this)
        };
    }
    onNewHeaderRowColumn(column, index) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(this.extractHeaderValue(column));
    }
    onNewBodyRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewBodyRowColumn.bind(this)
        };
    }
    onNewBodyRowColumn(column, index, node) {
        if (index != 0) this.result += this.columnSeparator;
        const rowCellValue = this.extractRowCellValue(column, index, index, "csv", node);
        this.result += this.putInQuotes(rowCellValue.valueFormatted ?? rowCellValue.value);
    }
    putInQuotes(value) {
        if (this.suppressQuotes) return value;
        if (value === null || value === void 0) return '""';
        let stringValue;
        if (typeof value === "string") stringValue = value;
        else if (typeof value.toString === "function") stringValue = value.toString();
        else {
            $437b23f6a393c3bf$export$545083624300f13d(53);
            stringValue = "";
        }
        const valueEscaped = stringValue.replace(/"/g, '""');
        return '"' + valueEscaped + '"';
    }
    parse() {
        return this.result;
    }
    beginNewLine() {
        if (!this.isFirstLine) this.result += $437b23f6a393c3bf$var$LINE_SEPARATOR;
        this.isFirstLine = false;
    }
};
// packages/ag-grid-community/src/csvExport/csvCreator.ts
var $437b23f6a393c3bf$var$CsvCreator = class extends $437b23f6a393c3bf$export$b335f23c5aead909 {
    constructor(){
        super(...arguments);
        this.beanName = "csvCreator";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.colNames = beans.colNames;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.valueSvc = beans.valueSvc;
    }
    getMergedParams(params) {
        const baseParams5 = this.gos.get("defaultCsvExportParams");
        return Object.assign({}, baseParams5, params);
    }
    export(userParams) {
        if (this.isExportSuppressed()) {
            $437b23f6a393c3bf$export$545083624300f13d(51);
            return;
        }
        const mergedParams = this.getMergedParams(userParams);
        const data = this.getData(mergedParams);
        const packagedFile = new Blob([
            "\uFEFF",
            data
        ], {
            type: "text/plain"
        });
        const fileName = typeof mergedParams.fileName === "function" ? mergedParams.fileName($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {})) : mergedParams.fileName;
        $437b23f6a393c3bf$export$97aef6bcdc3f7ef5(this.getFileName(fileName), packagedFile);
    }
    exportDataAsCsv(params) {
        this.export(params);
    }
    getDataAsCsv(params, skipDefaultParams = false) {
        const mergedParams = skipDefaultParams ? Object.assign({}, params) : this.getMergedParams(params);
        return this.getData(mergedParams);
    }
    getDefaultFileExtension() {
        return "csv";
    }
    createSerializingSession(params) {
        const { colModel: colModel, colNames: colNames, rowGroupColsSvc: rowGroupColsSvc, valueSvc: valueSvc, gos: gos } = this;
        const { processCellCallback: processCellCallback, processHeaderCallback: processHeaderCallback, processGroupHeaderCallback: processGroupHeaderCallback, processRowGroupCallback: processRowGroupCallback, suppressQuotes: suppressQuotes, columnSeparator: columnSeparator } = params;
        return new $437b23f6a393c3bf$var$CsvSerializingSession({
            colModel: colModel,
            colNames: colNames,
            valueSvc: valueSvc,
            gos: gos,
            processCellCallback: processCellCallback || void 0,
            processHeaderCallback: processHeaderCallback || void 0,
            processGroupHeaderCallback: processGroupHeaderCallback || void 0,
            processRowGroupCallback: processRowGroupCallback || void 0,
            suppressQuotes: suppressQuotes || false,
            columnSeparator: columnSeparator || ",",
            rowGroupColsSvc: rowGroupColsSvc
        });
    }
    isExportSuppressed() {
        return this.gos.get("suppressCsvExport");
    }
};
// packages/ag-grid-community/src/csvExport/csvExportApi.ts
function $437b23f6a393c3bf$var$getDataAsCsv(beans, params) {
    return beans.csvCreator?.getDataAsCsv(params);
}
function $437b23f6a393c3bf$var$exportDataAsCsv(beans, params) {
    beans.csvCreator?.exportDataAsCsv(params);
}
// packages/ag-grid-community/src/csvExport/csvExportModule.ts
var $437b23f6a393c3bf$export$f744275d8b795fc2 = {
    moduleName: "CsvExport",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CsvCreator
    ],
    apiFunctions: {
        getDataAsCsv: $437b23f6a393c3bf$var$getDataAsCsv,
        exportDataAsCsv: $437b23f6a393c3bf$var$exportDataAsCsv
    },
    dependsOn: [
        $437b23f6a393c3bf$export$e6030935e93fda2b
    ]
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteBlock.ts
var $437b23f6a393c3bf$var$InfiniteBlock = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(id, parentCache, params){
        super();
        this.id = id;
        this.parentCache = parentCache;
        this.params = params;
        this.state = "needsLoading";
        this.version = 0;
        this.startRow = id * params.blockSize;
        this.endRow = this.startRow + params.blockSize;
    }
    load() {
        this.state = "loading";
        this.loadFromDatasource();
    }
    setStateWaitingToLoad() {
        this.version++;
        this.state = "needsLoading";
    }
    pageLoadFailed(version) {
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) this.state = "failed";
        this.dispatchLocalEvent({
            type: "loadComplete"
        });
    }
    pageLoaded(version, rows, lastRow) {
        this.successCommon(version, {
            rowData: rows,
            rowCount: lastRow
        });
    }
    isRequestMostRecentAndLive(version) {
        const thisIsMostRecentRequest = version === this.version;
        const weAreNotDestroyed = this.isAlive();
        return thisIsMostRecentRequest && weAreNotDestroyed;
    }
    successCommon(version, params) {
        this.dispatchLocalEvent({
            type: "loadComplete"
        });
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) {
            this.state = "loaded";
            this.processServerResult(params);
        }
    }
    postConstruct() {
        this.rowNodes = [];
        const { params: { blockSize: blockSize, rowHeight: rowHeight }, startRow: startRow, beans: beans, rowNodes: rowNodes } = this;
        for(let i = 0; i < blockSize; i++){
            const rowIndex = startRow + i;
            const rowNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
            rowNode.setRowHeight(rowHeight);
            rowNode.uiLevel = 0;
            rowNode.setRowIndex(rowIndex);
            rowNode.setRowTop(rowHeight * rowIndex);
            rowNodes.push(rowNode);
        }
    }
    getBlockStateJson() {
        const { id: id, startRow: startRow, endRow: endRow, state: pageStatus } = this;
        return {
            id: "" + id,
            state: {
                blockNumber: id,
                startRow: startRow,
                endRow: endRow,
                pageStatus: pageStatus
            }
        };
    }
    setDataAndId(rowNode, data, index) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(data)) rowNode.setDataAndId(data, index.toString());
        else rowNode.setDataAndId(void 0, void 0);
    }
    loadFromDatasource() {
        const params = this.createLoadParams();
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.params.datasource.getRows)) {
            $437b23f6a393c3bf$export$545083624300f13d(90);
            return;
        }
        window.setTimeout(()=>{
            this.params.datasource.getRows(params);
        }, 0);
    }
    createLoadParams() {
        const { startRow: startRow, endRow: endRow, version: version, params: { sortModel: sortModel, filterModel: filterModel }, gos: gos } = this;
        const params = {
            startRow: startRow,
            endRow: endRow,
            successCallback: this.pageLoaded.bind(this, version),
            failCallback: this.pageLoadFailed.bind(this, version),
            sortModel: sortModel,
            filterModel: filterModel,
            context: $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {}).context
        };
        return params;
    }
    forEachNode(callback, sequence, rowCount) {
        this.rowNodes.forEach((rowNode, index)=>{
            const rowIndex = this.startRow + index;
            if (rowIndex < rowCount) callback(rowNode, sequence.value++);
        });
    }
    getRow(rowIndex, dontTouchLastAccessed = false) {
        if (!dontTouchLastAccessed) this.lastAccessed = this.params.lastAccessedSequence.value++;
        const localIndex = rowIndex - this.startRow;
        return this.rowNodes[localIndex];
    }
    processServerResult(params) {
        const { rowNodes: rowNodes, beans: beans } = this;
        rowNodes.forEach((rowNode, index)=>{
            const data = params.rowData ? params.rowData[index] : void 0;
            if (!rowNode.id && rowNode.alreadyRendered && data) {
                rowNodes[index] = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
                rowNodes[index].setRowIndex(rowNode.rowIndex);
                rowNodes[index].setRowTop(rowNode.rowTop);
                rowNodes[index].setRowHeight(rowNode.rowHeight);
                rowNode.clearRowTopAndRowIndex();
            }
            this.setDataAndId(rowNodes[index], data, this.startRow + index);
        });
        const finalRowCount = params.rowCount != null && params.rowCount >= 0 ? params.rowCount : void 0;
        this.parentCache.pageLoaded(this, finalRowCount);
    }
    destroy() {
        for (const rowNode of this.rowNodes)rowNode.clearRowTopAndRowIndex();
        super.destroy();
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteCache.ts
var $437b23f6a393c3bf$var$MAX_EMPTY_BLOCKS_TO_KEEP = 2;
var $437b23f6a393c3bf$var$InfiniteCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.params = params;
        this.lastRowIndexKnown = false;
        this.blocks = {};
        this.blockCount = 0;
        this.rowCount = params.initialRowCount;
    }
    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
    // it will want new pages in the cache as it asks for rows. only when we are inserting /
    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
    getRow(rowIndex, dontCreatePage = false) {
        const blockId = Math.floor(rowIndex / this.params.blockSize);
        let block = this.blocks[blockId];
        if (!block) {
            if (dontCreatePage) return void 0;
            block = this.createBlock(blockId);
        }
        return block.getRow(rowIndex);
    }
    createBlock(blockNumber) {
        const params = this.params;
        const newBlock = this.createBean(new $437b23f6a393c3bf$var$InfiniteBlock(blockNumber, this, params));
        this.blocks[newBlock.id] = newBlock;
        this.blockCount++;
        this.purgeBlocksIfNeeded(newBlock);
        params.rowNodeBlockLoader.addBlock(newBlock);
        return newBlock;
    }
    // we have this on infinite row model only, not server side row model,
    // because for server side, it would leave the children in inconsistent
    // state - eg if a node had children, but after the refresh it had data
    // for a different row, then the children would be with the wrong row node.
    refreshCache() {
        const nothingToRefresh = this.blockCount == 0;
        if (nothingToRefresh) {
            this.purgeCache();
            return;
        }
        for (const block of this.getBlocksInOrder())block.setStateWaitingToLoad();
        this.params.rowNodeBlockLoader.checkBlockToLoad();
    }
    destroy() {
        for (const block of this.getBlocksInOrder())this.destroyBlock(block);
        super.destroy();
    }
    getRowCount() {
        return this.rowCount;
    }
    isLastRowIndexKnown() {
        return this.lastRowIndexKnown;
    }
    // block calls this, when page loaded
    pageLoaded(block, lastRow) {
        if (!this.isAlive()) return;
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `InfiniteCache - onPageLoaded: page = ${block.id}, lastRow = ${lastRow}`);
        this.checkRowCount(block, lastRow);
        this.onCacheUpdated();
    }
    purgeBlocksIfNeeded(blockToExclude) {
        const blocksForPurging = this.getBlocksInOrder().filter((b)=>b != blockToExclude);
        const lastAccessedComparator = (a, b)=>b.lastAccessed - a.lastAccessed;
        blocksForPurging.sort(lastAccessedComparator);
        const maxBlocksProvided = this.params.maxBlocksInCache > 0;
        const blocksToKeep = maxBlocksProvided ? this.params.maxBlocksInCache - 1 : null;
        const emptyBlocksToKeep = $437b23f6a393c3bf$var$MAX_EMPTY_BLOCKS_TO_KEEP - 1;
        blocksForPurging.forEach((block, index)=>{
            const purgeBecauseBlockEmpty = block.state === "needsLoading" && index >= emptyBlocksToKeep;
            const purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
            if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
                if (this.isBlockCurrentlyDisplayed(block)) return;
                if (this.isBlockFocused(block)) return;
                this.removeBlockFromCache(block);
            }
        });
    }
    isBlockFocused(block) {
        const focusedCell = this.beans.focusSvc.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const { startRow: startRow, endRow: endRow } = block;
        const hasFocus = focusedCell.rowIndex >= startRow && focusedCell.rowIndex < endRow;
        return hasFocus;
    }
    isBlockCurrentlyDisplayed(block) {
        const { startRow: startRow, endRow: endRow } = block;
        return this.beans.rowRenderer.isRangeInRenderedViewport(startRow, endRow - 1);
    }
    removeBlockFromCache(blockToRemove) {
        if (!blockToRemove) return;
        this.destroyBlock(blockToRemove);
    }
    checkRowCount(block, lastRow) {
        if (typeof lastRow === "number" && lastRow >= 0) {
            this.rowCount = lastRow;
            this.lastRowIndexKnown = true;
        } else if (!this.lastRowIndexKnown) {
            const { blockSize: blockSize, overflowSize: overflowSize } = this.params;
            const lastRowIndex = (block.id + 1) * blockSize;
            const lastRowIndexPlusOverflow = lastRowIndex + overflowSize;
            if (this.rowCount < lastRowIndexPlusOverflow) this.rowCount = lastRowIndexPlusOverflow;
        }
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        this.rowCount = rowCount;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(lastRowIndexKnown)) this.lastRowIndexKnown = lastRowIndexKnown;
        if (!this.lastRowIndexKnown) {
            if (this.rowCount % this.params.blockSize === 0) this.rowCount++;
        }
        this.onCacheUpdated();
    }
    forEachNodeDeep(callback) {
        const sequence = {
            value: 0
        };
        for (const block of this.getBlocksInOrder())block.forEachNode(callback, sequence, this.rowCount);
    }
    getBlocksInOrder() {
        const blockComparator = (a, b)=>a.id - b.id;
        const blocks = Object.values(this.blocks).sort(blockComparator);
        return blocks;
    }
    destroyBlock(block) {
        delete this.blocks[block.id];
        this.destroyBean(block);
        this.blockCount--;
        this.params.rowNodeBlockLoader.removeBlock(block);
    }
    // gets called 1) row count changed 2) cache purged 3) items inserted
    onCacheUpdated() {
        if (this.isAlive()) {
            this.destroyAllBlocksPastVirtualRowCount();
            this.eventSvc.dispatchEvent({
                type: "storeUpdated"
            });
        }
    }
    destroyAllBlocksPastVirtualRowCount() {
        const blocksToDestroy = [];
        for (const block of this.getBlocksInOrder()){
            const startRow = block.id * this.params.blockSize;
            if (startRow >= this.rowCount) blocksToDestroy.push(block);
        }
        if (blocksToDestroy.length > 0) for (const block of blocksToDestroy)this.destroyBlock(block);
    }
    purgeCache() {
        for (const block of this.getBlocksInOrder())this.removeBlockFromCache(block);
        this.lastRowIndexKnown = false;
        if (this.rowCount === 0) this.rowCount = this.params.initialRowCount;
        this.onCacheUpdated();
    }
    getRowNodesInRange(firstInRange, lastInRange) {
        const result = [];
        let lastBlockId = -1;
        let inActiveRange = false;
        const numberSequence = {
            value: 0
        };
        let foundGapInSelection = false;
        for (const block of this.getBlocksInOrder()){
            if (foundGapInSelection) continue;
            if (inActiveRange && lastBlockId + 1 !== block.id) {
                foundGapInSelection = true;
                continue;
            }
            lastBlockId = block.id;
            block.forEachNode((rowNode)=>{
                const hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
                if (inActiveRange || hitFirstOrLast) result.push(rowNode);
                if (hitFirstOrLast) inActiveRange = !inActiveRange;
            }, numberSequence, this.rowCount);
        }
        const invalidRange = foundGapInSelection || inActiveRange;
        return invalidRange ? [] : result;
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModel.ts
var $437b23f6a393c3bf$var$InfiniteRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
        /** Dummy root node */ this.rootNode = null;
    }
    getRowBounds(index) {
        return {
            rowHeight: this.rowHeight,
            rowTop: this.rowHeight * index
        };
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid() {
        return false;
    }
    postConstruct() {
        if (this.gos.get("rowModelType") !== "infinite") return;
        const beans = this.beans;
        const rootNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
        this.rootNode = rootNode;
        rootNode.level = -1;
        this.rowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(beans);
        this.addEventListeners();
        this.addDestroyFunc(()=>this.destroyCache());
    }
    start() {
        this.setDatasource(this.gos.get("datasource"));
    }
    destroy() {
        this.destroyDatasource();
        super.destroy();
        this.rootNode = null;
    }
    destroyDatasource() {
        if (this.datasource) {
            this.destroyBean(this.datasource);
            this.beans.rowRenderer.datasourceChanged();
            this.datasource = null;
        }
    }
    addEventListeners() {
        this.addManagedEventListeners({
            filterChanged: this.reset.bind(this),
            sortChanged: this.reset.bind(this),
            newColumnsLoaded: this.onColumnEverything.bind(this),
            storeUpdated: this.dispatchModelUpdatedEvent.bind(this)
        });
        this.addManagedPropertyListener("datasource", ()=>this.setDatasource(this.gos.get("datasource")));
        this.addManagedPropertyListener("cacheBlockSize", ()=>this.resetCache());
        this.addManagedPropertyListener("rowHeight", ()=>{
            this.rowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
            this.cacheParams.rowHeight = this.rowHeight;
            this.updateRowHeights();
        });
    }
    onColumnEverything() {
        let resetRequired;
        if (this.cacheParams) resetRequired = !$437b23f6a393c3bf$export$dbc2068cc90f5875(this.cacheParams.sortModel, this.beans.sortSvc?.getSortModel() ?? []);
        else resetRequired = true;
        if (resetRequired) this.reset();
    }
    getType() {
        return "infinite";
    }
    setDatasource(datasource) {
        this.destroyDatasource();
        this.datasource = datasource;
        if (datasource) this.reset();
    }
    isEmpty() {
        return !this.infiniteCache;
    }
    isRowsToRender() {
        return !!this.infiniteCache;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        return this.infiniteCache?.getRowNodesInRange(firstInRange, lastInRange) ?? [];
    }
    reset() {
        if (!this.datasource) return;
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const userGeneratingIds = getRowIdFunc != null;
        if (!userGeneratingIds) this.beans.selectionSvc?.reset("rowDataChanged");
        this.resetCache();
    }
    dispatchModelUpdatedEvent() {
        this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            // not sure if these should all be false - noticed if after implementing,
            // maybe they should be true?
            newPage: false,
            newPageSize: false,
            newData: false,
            keepRenderedRows: true,
            animate: false
        });
    }
    resetCache() {
        this.destroyCache();
        const beans = this.beans;
        const { filterManager: filterManager, sortSvc: sortSvc, rowNodeBlockLoader: rowNodeBlockLoader, eventSvc: eventSvc, gos: gos } = beans;
        this.cacheParams = {
            // the user provided datasource
            datasource: this.datasource,
            // sort and filter model
            filterModel: filterManager?.getFilterModel() ?? {},
            sortModel: sortSvc?.getSortModel() ?? [],
            rowNodeBlockLoader: rowNodeBlockLoader,
            // properties - this way we take a snapshot of them, so if user changes any, they will be
            // used next time we create a new cache, which is generally after a filter or sort change,
            // or a new datasource is set
            initialRowCount: gos.get("infiniteInitialRowCount"),
            maxBlocksInCache: gos.get("maxBlocksInCache"),
            rowHeight: $437b23f6a393c3bf$export$8966875adec41e5b(beans),
            // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
            // the current page and request first row of next page
            overflowSize: gos.get("cacheOverflowSize"),
            // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
            // server for one page at a time. so the default if not specified is 100.
            blockSize: gos.get("cacheBlockSize"),
            // the cache could create this, however it is also used by the pages, so handy to create it
            // here as the settings are also passed to the pages
            lastAccessedSequence: {
                value: 0
            }
        };
        this.infiniteCache = this.createBean(new $437b23f6a393c3bf$var$InfiniteCache(this.cacheParams));
        eventSvc.dispatchEventOnce({
            type: "rowCountReady"
        });
        this.dispatchModelUpdatedEvent();
    }
    updateRowHeights() {
        this.forEachNode((node)=>{
            node.setRowHeight(this.rowHeight);
            node.setRowTop(this.rowHeight * node.rowIndex);
        });
        this.dispatchModelUpdatedEvent();
    }
    destroyCache() {
        this.infiniteCache = this.destroyBean(this.infiniteCache);
    }
    getRow(rowIndex) {
        const infiniteCache = this.infiniteCache;
        if (!infiniteCache) return void 0;
        if (rowIndex >= infiniteCache.getRowCount()) return void 0;
        return infiniteCache.getRow(rowIndex);
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
        });
        return result;
    }
    forEachNode(callback) {
        this.infiniteCache?.forEachNodeDeep(callback);
    }
    getTopLevelRowCount() {
        return this.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        return topLevelIndex;
    }
    getRowIndexAtPixel(pixel) {
        if (this.rowHeight !== 0) {
            const rowIndexForPixel = Math.floor(pixel / this.rowHeight);
            const lastRowIndex = this.getRowCount() - 1;
            if (rowIndexForPixel > lastRowIndex) return lastRowIndex;
            return rowIndexForPixel;
        }
        return 0;
    }
    getRowCount() {
        return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
    }
    isRowPresent(rowNode) {
        return !!this.getRowNode(rowNode.id);
    }
    refreshCache() {
        this.infiniteCache?.refreshCache();
    }
    purgeCache() {
        this.infiniteCache?.purgeCache();
    }
    // for iRowModel
    isLastRowIndexKnown() {
        return this.infiniteCache?.isLastRowIndexKnown() ?? false;
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        this.infiniteCache?.setRowCount(rowCount, lastRowIndexKnown);
    }
    resetRowHeights() {}
    onRowHeightChanged() {}
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModelApi.ts
function $437b23f6a393c3bf$var$refreshInfiniteCache(beans) {
    $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.refreshCache();
}
function $437b23f6a393c3bf$var$purgeInfiniteCache(beans) {
    $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.purgeCache();
}
function $437b23f6a393c3bf$var$getInfiniteRowCount(beans) {
    return $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.getRowCount();
}
// packages/ag-grid-community/src/infiniteRowModel/rowNodeBlockLoader.ts
var $437b23f6a393c3bf$var$RowNodeBlockLoader = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowNodeBlockLoader";
        this.activeBlockLoadsCount = 0;
        this.blocks = [];
        this.active = true;
    }
    postConstruct() {
        this.maxConcurrentRequests = $437b23f6a393c3bf$export$efae4c751fa7cc4d(this.gos);
        const blockLoadDebounceMillis = this.gos.get("blockLoadDebounceMillis");
        if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) this.checkBlockToLoadDebounce = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
    }
    addBlock(block) {
        this.blocks.push(block);
        block.addEventListener("loadComplete", this.loadComplete.bind(this));
        this.checkBlockToLoad();
    }
    removeBlock(block) {
        $437b23f6a393c3bf$export$83a881c8b5120679(this.blocks, block);
    }
    destroy() {
        super.destroy();
        this.active = false;
    }
    loadComplete() {
        this.activeBlockLoadsCount--;
        this.checkBlockToLoad();
    }
    checkBlockToLoad() {
        if (this.checkBlockToLoadDebounce) this.checkBlockToLoadDebounce();
        else this.performCheckBlocksToLoad();
    }
    performCheckBlocksToLoad() {
        if (!this.active) return;
        this.printCacheStatus();
        if (this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
            $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowNodeBlockLoader - checkBlockToLoad: max loads exceeded`);
            return;
        }
        const loadAvailability = this.maxConcurrentRequests != null ? this.maxConcurrentRequests - this.activeBlockLoadsCount : 1;
        const blocksToLoad = this.blocks.filter((block)=>block.state === "needsLoading").slice(0, loadAvailability);
        this.activeBlockLoadsCount += blocksToLoad.length;
        for (const block of blocksToLoad)block.load();
        this.printCacheStatus();
    }
    getBlockState() {
        const result = {};
        this.blocks.forEach((block)=>{
            const { id: id, state: state } = block.getBlockStateJson();
            result[id] = state;
        });
        return result;
    }
    printCacheStatus() {
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowNodeBlockLoader - printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`);
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModelModule.ts
var $437b23f6a393c3bf$var$InfiniteRowModelCoreModule = {
    moduleName: "InfiniteRowModelCore",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "infinite"
    ],
    beans: [
        $437b23f6a393c3bf$var$InfiniteRowModel,
        $437b23f6a393c3bf$var$RowNodeBlockLoader
    ]
};
var $437b23f6a393c3bf$export$ca8341149bdd39bc = {
    moduleName: "InfiniteRowModel",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        refreshInfiniteCache: $437b23f6a393c3bf$var$refreshInfiniteCache,
        purgeInfiniteCache: $437b23f6a393c3bf$var$purgeInfiniteCache,
        getInfiniteRowCount: $437b23f6a393c3bf$var$getInfiniteRowCount
    },
    dependsOn: [
        $437b23f6a393c3bf$var$InfiniteRowModelCoreModule,
        $437b23f6a393c3bf$export$2f6740e35dedc261
    ]
};
// packages/ag-grid-community/src/rendering/cellRenderers/animateShowChangeCellRenderer.ts
var $437b23f6a393c3bf$var$ARROW_UP = "\u2191";
var $437b23f6a393c3bf$var$ARROW_DOWN = "\u2193";
var $437b23f6a393c3bf$var$AnimateShowChangeCellRendererElement = {
    tag: "span",
    children: [
        {
            tag: "span",
            ref: "eDelta",
            cls: "ag-value-change-delta"
        },
        {
            tag: "span",
            ref: "eValue",
            cls: "ag-value-change-value"
        }
    ]
};
var $437b23f6a393c3bf$var$AnimateShowChangeCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$AnimateShowChangeCellRendererElement);
        this.eValue = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDelta = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.refreshCount = 0;
    }
    init(params) {
        this.refresh(params, true);
    }
    showDelta(params, delta) {
        const absDelta = Math.abs(delta);
        const valueFormatted = params.formatValue(absDelta);
        const valueToUse = $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : absDelta;
        const deltaUp = delta >= 0;
        const eDelta = this.eDelta;
        if (deltaUp) eDelta.textContent = $437b23f6a393c3bf$var$ARROW_UP + valueToUse;
        else eDelta.textContent = $437b23f6a393c3bf$var$ARROW_DOWN + valueToUse;
        eDelta.classList.toggle("ag-value-change-delta-up", deltaUp);
        eDelta.classList.toggle("ag-value-change-delta-down", !deltaUp);
    }
    setTimerToRemoveDelta() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        this.beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy === this.refreshCount) this.hideDeltaValue();
            }, 2e3);
        });
    }
    hideDeltaValue() {
        this.eValue.classList.remove("ag-value-change-value-highlight");
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eDelta);
    }
    refresh(params, isInitialRender = false) {
        const { value: value, valueFormatted: valueFormatted } = params;
        const { eValue: eValue, lastValue: lastValue, beans: beans } = this;
        if (value === lastValue) return false;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted)) eValue.textContent = valueFormatted;
        else if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) eValue.textContent = value;
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eValue);
        if (beans.filterManager?.isSuppressFlashingCellsBecauseFiltering()) return false;
        const numericValue = value && typeof value === "object" && "toNumber" in value ? value.toNumber() : value;
        const numericLastValue = lastValue && typeof lastValue === "object" && "toNumber" in lastValue ? lastValue.toNumber() : lastValue;
        if (numericValue === numericLastValue) return false;
        if (typeof numericValue === "number" && typeof numericLastValue === "number") {
            const delta = numericValue - numericLastValue;
            this.showDelta(params, delta);
        }
        if (lastValue) eValue.classList.add("ag-value-change-value-highlight");
        if (!isInitialRender) this.setTimerToRemoveDelta();
        this.lastValue = value;
        return true;
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/animateSlideCellRenderer.css-GENERATED.ts
var $437b23f6a393c3bf$var$animateSlideCellRendererCSS = /*css*/ `.ag-value-slide-out{opacity:1}:where(.ag-ltr) .ag-value-slide-out{margin-right:5px;transition:opacity 3s,margin-right 3s}:where(.ag-rtl) .ag-value-slide-out{margin-left:5px;transition:opacity 3s,margin-left 3s}:where(.ag-ltr,.ag-rtl) .ag-value-slide-out{transition-timing-function:linear}.ag-value-slide-out-end{opacity:0}:where(.ag-ltr) .ag-value-slide-out-end{margin-right:10px}:where(.ag-rtl) .ag-value-slide-out-end{margin-left:10px}`;
// packages/ag-grid-community/src/rendering/cellRenderers/animateSlideCellRenderer.ts
var $437b23f6a393c3bf$var$AnimateSlideCellRendererElement = {
    tag: "span",
    children: [
        {
            tag: "span",
            ref: "eCurrent",
            cls: "ag-value-slide-current"
        }
    ]
};
var $437b23f6a393c3bf$var$AnimateSlideCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$AnimateSlideCellRendererElement);
        this.eCurrent = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.refreshCount = 0;
        this.registerCSS($437b23f6a393c3bf$var$animateSlideCellRendererCSS);
    }
    init(params) {
        this.refresh(params, true);
    }
    addSlideAnimation() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        this.ePrevious?.remove();
        const { beans: beans, eCurrent: eCurrent } = this;
        const prevElement = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "span",
            cls: "ag-value-slide-previous ag-value-slide-out"
        });
        this.ePrevious = prevElement;
        prevElement.textContent = eCurrent.textContent;
        this.getGui().insertBefore(prevElement, eCurrent);
        beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.ePrevious.classList.add("ag-value-slide-out-end");
            }, 50);
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.ePrevious?.remove();
                this.ePrevious = null;
            }, 3e3);
        });
    }
    refresh(params, isInitialRender = false) {
        let value = params.value;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(value)) value = "";
        if (value === this.lastValue) return false;
        if (this.beans.filterManager?.isSuppressFlashingCellsBecauseFiltering()) return false;
        if (!isInitialRender) this.addSlideAnimation();
        this.lastValue = value;
        const eCurrent = this.eCurrent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(params.valueFormatted)) eCurrent.textContent = params.valueFormatted;
        else if ($437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) eCurrent.textContent = value;
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eCurrent);
        return true;
    }
};
// packages/ag-grid-community/src/rendering/cell/cellFlashService.ts
var $437b23f6a393c3bf$var$CellFlashService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellFlashSvc";
        this.nextAnimationTime = null;
        this.nextAnimationCycle = null;
        this.animations = {
            highlight: /* @__PURE__ */ new Map(),
            "data-changed": /* @__PURE__ */ new Map()
        };
    }
    animateCell(cellCtrl, cssName, flashDuration = this.beans.gos.get("cellFlashDuration"), fadeDuration = this.beans.gos.get("cellFadeDuration")) {
        const animations = this.animations[cssName];
        animations.delete(cellCtrl);
        const time = Date.now();
        const flashEndTime = time + flashDuration;
        const fadeEndTime = time + flashDuration + fadeDuration;
        const animState = {
            phase: "flash",
            flashEndTime: flashEndTime,
            fadeEndTime: fadeEndTime
        };
        animations.set(cellCtrl, animState);
        const cssBase = `ag-cell-${cssName}`;
        const cssAnimation = `${cssBase}-animation`;
        const { comp: comp, eGui: { style: style } } = cellCtrl;
        comp.toggleCss(cssBase, true);
        comp.toggleCss(cssAnimation, false);
        style.removeProperty("transition");
        style.removeProperty("transition-delay");
        if (this.nextAnimationTime && flashEndTime + 15 < this.nextAnimationTime) {
            clearTimeout(this.nextAnimationCycle);
            this.nextAnimationCycle = null;
            this.nextAnimationTime = null;
        }
        if (!this.nextAnimationCycle) {
            this.beans.frameworkOverrides.wrapIncoming(()=>{
                this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), flashDuration);
            });
            this.nextAnimationTime = flashEndTime;
        }
    }
    advanceAnimations() {
        const time = Date.now();
        let nextAnimationTime = null;
        for (const cssName of Object.keys(this.animations)){
            const animations = this.animations[cssName];
            const cssBase = `ag-cell-${cssName}`;
            const cssAnimation = `${cssBase}-animation`;
            for (const [cell, animState] of animations){
                if (!cell.isAlive() || !cell.comp) {
                    animations.delete(cell);
                    continue;
                }
                const { phase: phase, flashEndTime: flashEndTime, fadeEndTime: fadeEndTime } = animState;
                const nextActionableTime = phase === "flash" ? flashEndTime : fadeEndTime;
                const requiresAction = time + 15 >= nextActionableTime;
                if (!requiresAction) {
                    nextAnimationTime = Math.min(nextActionableTime, nextAnimationTime ?? Infinity);
                    continue;
                }
                const { comp: comp, eGui: { style: style } } = cell;
                switch(phase){
                    case "flash":
                        comp.toggleCss(cssBase, false);
                        comp.toggleCss(cssAnimation, true);
                        style.transition = `background-color ${fadeEndTime - flashEndTime}ms`;
                        style.transitionDelay = `${flashEndTime - time}ms`;
                        nextAnimationTime = Math.min(fadeEndTime, nextAnimationTime ?? Infinity);
                        animState.phase = "fade";
                        break;
                    case "fade":
                        comp.toggleCss(cssBase, false);
                        comp.toggleCss(cssAnimation, false);
                        style.removeProperty("transition");
                        style.removeProperty("transition-delay");
                        animations.delete(cell);
                        break;
                }
            }
        }
        if (nextAnimationTime == null) {
            this.nextAnimationTime = null;
            this.nextAnimationCycle = null;
        } else if (nextAnimationTime) {
            this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), nextAnimationTime - time);
            this.nextAnimationTime = nextAnimationTime;
        }
    }
    onFlashCells(cellCtrl, event) {
        if (!cellCtrl.comp) return;
        const cellId = $437b23f6a393c3bf$export$c0c5a5ba9327269f(cellCtrl.cellPosition);
        const shouldFlash = event.cells[cellId];
        if (shouldFlash) this.animateCell(cellCtrl, "highlight");
    }
    flashCell(cellCtrl, delays) {
        this.animateCell(cellCtrl, "data-changed", delays?.flashDuration, delays?.fadeDuration);
    }
    destroy() {
        for (const cssName of Object.keys(this.animations)){
            const animations = this.animations[cssName];
            animations.clear();
        }
    }
};
// packages/ag-grid-community/src/rendering/cell/highlightChangesApi.ts
function $437b23f6a393c3bf$var$flashCells(beans, params = {}) {
    const { cellFlashSvc: cellFlashSvc } = beans;
    if (!cellFlashSvc) return;
    beans.frameworkOverrides.wrapIncoming(()=>{
        for (const cellCtrl of beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns))cellFlashSvc.flashCell(cellCtrl, params);
    });
}
// packages/ag-grid-community/src/rendering/cell/highlightChangesModule.ts
var $437b23f6a393c3bf$export$98e8472b11750a07 = {
    moduleName: "HighlightChanges",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CellFlashService
    ],
    userComponents: {
        agAnimateShowChangeCellRenderer: $437b23f6a393c3bf$var$AnimateShowChangeCellRenderer,
        agAnimateSlideCellRenderer: $437b23f6a393c3bf$var$AnimateSlideCellRenderer
    },
    apiFunctions: {
        flashCells: $437b23f6a393c3bf$var$flashCells
    }
};
// packages/ag-grid-community/src/misc/state/stateApi.ts
function $437b23f6a393c3bf$var$getState(beans) {
    return beans.stateSvc?.getState() ?? {};
}
function $437b23f6a393c3bf$var$setState(beans, state, propertiesToIgnore) {
    return beans.stateSvc?.setState(state, propertiesToIgnore);
}
// packages/ag-grid-community/src/misc/state/stateModelMigration.ts
function $437b23f6a393c3bf$var$migrateGridStateModel(state) {
    state = {
        ...state
    };
    if (!state.version) state.version = "32.1.0";
    if (state.version === "32.1.0") state = $437b23f6a393c3bf$var$migrateV32_1(state);
    state.version = $437b23f6a393c3bf$var$VERSION;
    return state;
}
function $437b23f6a393c3bf$var$migrateV32_1(state) {
    state.cellSelection = $437b23f6a393c3bf$var$jsonGet(state, "rangeSelection");
    return state;
}
function $437b23f6a393c3bf$var$jsonGet(json, key) {
    if (json && typeof json === "object") return json[key];
}
// packages/ag-grid-community/src/misc/state/stateService.ts
var $437b23f6a393c3bf$var$StateService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "stateSvc";
        this.updateRowGroupExpansionStateTimer = 0;
        this.suppressEvents = true;
        this.queuedUpdateSources = /* @__PURE__ */ new Set();
        this.dispatchStateUpdateEventDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.dispatchQueuedStateUpdateEvents(), 0);
        // If user is doing a manual expand all node by node, we don't want to process one at a time.
        // EVENT_ROW_GROUP_OPENED is already async, so no impact of making the state async here.
        this.onRowGroupOpenedDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>{
            if (this.beans.gos.get("ssrmExpandAllAffectsAllRows")) {
                this.updateCachedState("ssrmRowGroupExpansion", this.getRowGroupExpansionState());
                this.updateCachedState("rowGroupExpansion", void 0);
            } else {
                this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
                this.updateCachedState("ssrmRowGroupExpansion", void 0);
            }
        }, 0);
        // similar to row expansion, want to debounce. However, selection is synchronous, so need to mark as stale in case `getState` is called.
        this.onRowSelectedDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>{
            this.staleStateKeys.delete("rowSelection");
            this.updateCachedState("rowSelection", this.getRowSelectionState());
        }, 0);
        this.staleStateKeys = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        const { gos: gos, ctrlsSvc: ctrlsSvc, colDelayRenderSvc: colDelayRenderSvc } = this.beans;
        this.isClientSideRowModel = $437b23f6a393c3bf$export$9f182d9ca737e15(gos);
        const initialState = $437b23f6a393c3bf$var$migrateGridStateModel(gos.get("initialState") ?? {});
        const partialColumnState = initialState.partialColumnState;
        delete initialState.partialColumnState;
        this.cachedState = initialState;
        const suppressEventsAndDispatchInitEvent = this.suppressEventsAndDispatchInitEvent.bind(this);
        ctrlsSvc.whenReady(this, ()=>suppressEventsAndDispatchInitEvent(()=>this.setupStateOnGridReady(initialState)));
        if (initialState.columnOrder || initialState.columnVisibility || initialState.columnSizing || initialState.columnPinning || initialState.columnGroup) colDelayRenderSvc?.hideColumns("columnState");
        const [newColumnsLoadedDestroyFunc, rowCountReadyDestroyFunc, firstDataRenderedDestroyFunc] = this.addManagedEventListeners({
            newColumnsLoaded: ({ source: source })=>{
                if (source === "gridInitializing") {
                    newColumnsLoadedDestroyFunc();
                    suppressEventsAndDispatchInitEvent(()=>{
                        this.setupStateOnColumnsInitialised(initialState, !!partialColumnState);
                        colDelayRenderSvc?.revealColumns("columnState");
                    });
                }
            },
            rowCountReady: ()=>{
                rowCountReadyDestroyFunc?.();
                suppressEventsAndDispatchInitEvent(()=>this.setupStateOnRowCountReady(initialState));
            },
            firstDataRendered: ()=>{
                firstDataRenderedDestroyFunc?.();
                suppressEventsAndDispatchInitEvent(()=>this.setupStateOnFirstDataRendered(initialState));
            }
        });
    }
    destroy() {
        super.destroy();
        clearTimeout(this.updateRowGroupExpansionStateTimer);
        this.queuedUpdateSources.clear();
    }
    getState() {
        if (this.staleStateKeys.size) this.refreshStaleState();
        return this.cachedState;
    }
    setState(providedState, propertiesToIgnore) {
        const state = $437b23f6a393c3bf$var$migrateGridStateModel(providedState);
        delete state.partialColumnState;
        this.cachedState = state;
        this.startSuppressEvents();
        const source = "api";
        const ignoreSet = propertiesToIgnore ? new Set(propertiesToIgnore) : void 0;
        this.setGridReadyState(state, source, ignoreSet);
        this.setColumnsInitialisedState(state, source, !!ignoreSet, ignoreSet);
        this.setRowCountState(state, source, ignoreSet);
        setTimeout(()=>{
            if (this.isAlive()) this.setFirstDataRenderedState(state, source, ignoreSet);
            this.stopSuppressEvents(source);
        });
    }
    setGridReadyState(state, source, ignoreSet) {
        if (source === "api" && !ignoreSet?.has("sideBar")) this.beans.sideBar?.comp?.setState(state.sideBar);
        this.updateCachedState("sideBar", this.getSideBarState());
    }
    setupStateOnGridReady(initialState) {
        this.setGridReadyState(initialState, "gridInitializing");
        const stateUpdater = ()=>this.updateCachedState("sideBar", this.getSideBarState());
        this.addManagedEventListeners({
            toolPanelVisibleChanged: stateUpdater,
            sideBarUpdated: stateUpdater
        });
    }
    updateColumnAndGroupState() {
        this.updateColumnState([
            "aggregation",
            "columnOrder",
            "columnPinning",
            "columnSizing",
            "columnVisibility",
            "pivot",
            "rowGroup",
            "sort"
        ]);
        this.updateCachedState("columnGroup", this.getColumnGroupState());
    }
    setColumnsInitialisedState(state, source, partialColumnState, ignoreSet) {
        this.setColumnState(state, source, partialColumnState, ignoreSet);
        this.setColumnGroupState(state, source, ignoreSet);
        this.updateColumnAndGroupState();
    }
    setupStateOnColumnsInitialised(initialState, partialColumnState) {
        this.setColumnsInitialisedState(initialState, "gridInitializing", partialColumnState);
        const onUpdate = (state)=>()=>this.updateColumnState([
                    state
                ]);
        this.addManagedEventListeners({
            columnValueChanged: onUpdate("aggregation"),
            columnMoved: onUpdate("columnOrder"),
            columnPinned: onUpdate("columnPinning"),
            columnResized: onUpdate("columnSizing"),
            columnVisible: onUpdate("columnVisibility"),
            columnPivotChanged: onUpdate("pivot"),
            columnPivotModeChanged: onUpdate("pivot"),
            columnRowGroupChanged: onUpdate("rowGroup"),
            sortChanged: onUpdate("sort"),
            newColumnsLoaded: this.updateColumnAndGroupState.bind(this),
            columnGroupOpened: ()=>this.updateCachedState("columnGroup", this.getColumnGroupState())
        });
    }
    setRowCountState(state, source, ignoreSet) {
        const { filter: filterState, rowGroupExpansion: rowGroupExpansionState, ssrmRowGroupExpansion: ssrmRowGroupExpansion, rowSelection: rowSelectionState, pagination: paginationState } = state;
        const shouldSetState = (prop, propState)=>!ignoreSet?.has(prop) && (propState || source === "api");
        if (shouldSetState("filter", filterState)) this.setFilterState(filterState);
        if (shouldSetState("rowGroupExpansion", rowGroupExpansionState)) this.setRowGroupExpansionState(ssrmRowGroupExpansion, rowGroupExpansionState, source);
        if (shouldSetState("rowSelection", rowSelectionState)) this.setRowSelectionState(rowSelectionState, source);
        if (shouldSetState("pagination", paginationState)) this.setPaginationState(paginationState, source);
        const updateCachedState = this.updateCachedState.bind(this);
        updateCachedState("filter", this.getFilterState());
        if (this.beans.gos.get("ssrmExpandAllAffectsAllRows")) {
            updateCachedState("ssrmRowGroupExpansion", this.getRowGroupExpansionState());
            updateCachedState("rowGroupExpansion", void 0);
        } else {
            updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
            updateCachedState("ssrmRowGroupExpansion", void 0);
        }
        updateCachedState("rowSelection", this.getRowSelectionState());
        updateCachedState("pagination", this.getPaginationState());
    }
    setupStateOnRowCountReady(initialState) {
        this.setRowCountState(initialState, "gridInitializing");
        const updateCachedState = this.updateCachedState.bind(this);
        const updateRowGroupExpansionState = ()=>{
            this.updateRowGroupExpansionStateTimer = 0;
            if (this.beans.gos.get("ssrmExpandAllAffectsAllRows")) {
                updateCachedState("ssrmRowGroupExpansion", this.getRowGroupExpansionState());
                updateCachedState("rowGroupExpansion", void 0);
            } else {
                updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
                updateCachedState("ssrmRowGroupExpansion", void 0);
            }
        };
        const updateFilterState = ()=>updateCachedState("filter", this.getFilterState());
        const { gos: gos, colFilter: colFilter } = this.beans;
        this.addManagedEventListeners({
            filterChanged: updateFilterState,
            rowExpansionStateChanged: this.onRowGroupOpenedDebounced,
            expandOrCollapseAll: updateRowGroupExpansionState,
            // `groupDefaultExpanded`/`isGroupOpenByDefault` updates expansion state without an expansion event
            columnRowGroupChanged: updateRowGroupExpansionState,
            rowDataUpdated: ()=>{
                if (gos.get("groupDefaultExpanded") !== 0 || gos.get("isGroupOpenByDefault")) this.updateRowGroupExpansionStateTimer || (this.updateRowGroupExpansionStateTimer = setTimeout(updateRowGroupExpansionState));
            },
            selectionChanged: ()=>{
                this.staleStateKeys.add("rowSelection");
                this.onRowSelectedDebounced();
            },
            paginationChanged: (event)=>{
                if (event.newPage || event.newPageSize) updateCachedState("pagination", this.getPaginationState());
            }
        });
        if (colFilter) this.addManagedListeners(colFilter, {
            filterStateChanged: updateFilterState
        });
    }
    setFirstDataRenderedState(state, source, ignoreSet) {
        const { scroll: scrollState, cellSelection: cellSelectionState, focusedCell: focusedCellState, columnOrder: columnOrderState, rowPinning: rowPinning } = state;
        const shouldSetState = (prop, propState)=>!ignoreSet?.has(prop) && (propState || source === "api");
        if (shouldSetState("focusedCell", focusedCellState)) this.setFocusedCellState(focusedCellState);
        if (shouldSetState("cellSelection", cellSelectionState)) this.setCellSelectionState(cellSelectionState);
        if (shouldSetState("scroll", scrollState)) this.setScrollState(scrollState);
        if (shouldSetState("rowPinning", rowPinning)) this.setRowPinningState(rowPinning);
        this.setColumnPivotState(!!columnOrderState?.orderedColIds, source);
        const updateCachedState = this.updateCachedState.bind(this);
        updateCachedState("sideBar", this.getSideBarState());
        updateCachedState("focusedCell", this.getFocusedCellState());
        const cellSelection = this.getRangeSelectionState();
        updateCachedState("rangeSelection", cellSelection);
        updateCachedState("cellSelection", cellSelection);
        updateCachedState("scroll", this.getScrollState());
    }
    setupStateOnFirstDataRendered(initialState) {
        this.setFirstDataRenderedState(initialState, "gridInitializing");
        const updateCachedState = this.updateCachedState.bind(this);
        const updateFocusState = ()=>updateCachedState("focusedCell", this.getFocusedCellState());
        this.addManagedEventListeners({
            cellFocused: updateFocusState,
            cellFocusCleared: updateFocusState,
            cellSelectionChanged: (event)=>{
                if (event.finished) {
                    const cellSelection = this.getRangeSelectionState();
                    updateCachedState("rangeSelection", cellSelection);
                    updateCachedState("cellSelection", cellSelection);
                }
            },
            bodyScrollEnd: ()=>updateCachedState("scroll", this.getScrollState()),
            pinnedRowsChanged: ()=>updateCachedState("rowPinning", this.getRowPinningState())
        });
    }
    getColumnState() {
        const beans = this.beans;
        return $437b23f6a393c3bf$export$9453e80be74134db($437b23f6a393c3bf$export$e7d9af1fb362df7b(beans), beans.colModel.isPivotMode());
    }
    setColumnState(state, source, partialColumnState, ignoreSet) {
        const { sort: sortState, rowGroup: groupState, aggregation: aggregationState, pivot: pivotState, columnPinning: columnPinningState, columnVisibility: columnVisibilityState, columnSizing: columnSizingState, columnOrder: columnOrderState } = state;
        let forceSetState = false;
        const shouldSetState = (prop, propState)=>{
            const shouldSet = !ignoreSet?.has(prop) && !!(propState || source === "api");
            forceSetState || (forceSetState = shouldSet);
            return shouldSet;
        };
        const columnStateMap = {};
        const getColumnState2 = (colId)=>{
            let columnState = columnStateMap[colId];
            if (columnState) return columnState;
            columnState = {
                colId: colId
            };
            columnStateMap[colId] = columnState;
            return columnState;
        };
        const defaultState = {};
        const shouldSetSortState = shouldSetState("sort", sortState);
        if (shouldSetSortState) sortState?.sortModel.forEach(({ colId: colId, sort: sort }, sortIndex)=>{
            const columnState = getColumnState2(colId);
            columnState.sort = sort;
            columnState.sortIndex = sortIndex;
        });
        if (shouldSetSortState || !partialColumnState) {
            defaultState.sort = null;
            defaultState.sortIndex = null;
        }
        const shouldSetGroupState = shouldSetState("rowGroup", groupState);
        if (shouldSetGroupState) groupState?.groupColIds.forEach((colId, rowGroupIndex)=>{
            const columnState = getColumnState2(colId);
            columnState.rowGroup = true;
            columnState.rowGroupIndex = rowGroupIndex;
        });
        if (shouldSetGroupState || !partialColumnState) {
            defaultState.rowGroup = null;
            defaultState.rowGroupIndex = null;
        }
        const shouldSetAggregationState = shouldSetState("aggregation", aggregationState);
        if (shouldSetAggregationState) aggregationState?.aggregationModel.forEach(({ colId: colId, aggFunc: aggFunc })=>{
            getColumnState2(colId).aggFunc = aggFunc;
        });
        if (shouldSetAggregationState || !partialColumnState) defaultState.aggFunc = null;
        const shouldSetPivotState = shouldSetState("pivot", pivotState);
        if (shouldSetPivotState) {
            pivotState?.pivotColIds.forEach((colId, pivotIndex)=>{
                const columnState = getColumnState2(colId);
                columnState.pivot = true;
                columnState.pivotIndex = pivotIndex;
            });
            this.gos.updateGridOptions({
                options: {
                    pivotMode: !!pivotState?.pivotMode
                },
                source: source
            });
        }
        if (shouldSetPivotState || !partialColumnState) {
            defaultState.pivot = null;
            defaultState.pivotIndex = null;
        }
        const shouldSetColumnPinningState = shouldSetState("columnPinning", columnPinningState);
        if (shouldSetColumnPinningState) {
            for (const colId of columnPinningState?.leftColIds ?? [])getColumnState2(colId).pinned = "left";
            for (const colId of columnPinningState?.rightColIds ?? [])getColumnState2(colId).pinned = "right";
        }
        if (shouldSetColumnPinningState || !partialColumnState) defaultState.pinned = null;
        const shouldSetColumnVisibilityState = shouldSetState("columnVisibility", columnVisibilityState);
        if (shouldSetColumnVisibilityState) for (const colId of columnVisibilityState?.hiddenColIds ?? [])getColumnState2(colId).hide = true;
        if (shouldSetColumnVisibilityState || !partialColumnState) defaultState.hide = null;
        const shouldSetColumnSizingState = shouldSetState("columnSizing", columnSizingState);
        if (shouldSetColumnSizingState) for (const { colId: colId, flex: flex, width: width } of columnSizingState?.columnSizingModel ?? []){
            const columnState = getColumnState2(colId);
            columnState.flex = flex ?? null;
            columnState.width = width;
        }
        if (shouldSetColumnSizingState || !partialColumnState) defaultState.flex = null;
        const columns = columnOrderState?.orderedColIds;
        const applyOrder = !!columns?.length && !ignoreSet?.has("columnOrder");
        const columnStates = applyOrder ? columns.map((colId)=>getColumnState2(colId)) : Object.values(columnStateMap);
        if (columnStates.length || forceSetState) {
            this.columnStates = columnStates;
            $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
                state: columnStates,
                applyOrder: applyOrder,
                defaultState: defaultState
            }, source);
        }
    }
    setColumnPivotState(applyOrder, source) {
        const columnStates = this.columnStates;
        this.columnStates = void 0;
        const columnGroupStates = this.columnGroupStates;
        this.columnGroupStates = void 0;
        const beans = this.beans;
        const { pivotResultCols: pivotResultCols, colGroupSvc: colGroupSvc } = beans;
        if (!pivotResultCols?.isPivotResultColsPresent()) return;
        if (columnStates) {
            const secondaryColumnStates = [];
            for (const columnState of columnStates)if (pivotResultCols.getPivotResultCol(columnState.colId)) secondaryColumnStates.push(columnState);
            $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                state: secondaryColumnStates,
                applyOrder: applyOrder
            }, source);
        }
        if (columnGroupStates) colGroupSvc?.setColumnGroupState(columnGroupStates, source);
    }
    getColumnGroupState() {
        const colGroupSvc = this.beans.colGroupSvc;
        if (!colGroupSvc) return void 0;
        const columnGroupState = colGroupSvc.getColumnGroupState();
        return $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState);
    }
    setColumnGroupState(state, source, ignoreSet) {
        const colGroupSvc = this.beans.colGroupSvc;
        if (!colGroupSvc || ignoreSet?.has("columnGroup") || source !== "api" && !Object.prototype.hasOwnProperty.call(state, "columnGroup")) return;
        const openColumnGroups = new Set(state.columnGroup?.openColumnGroupIds);
        const existingColumnGroupState = colGroupSvc.getColumnGroupState();
        const stateItems = existingColumnGroupState.map(({ groupId: groupId })=>{
            const open = openColumnGroups.has(groupId);
            if (open) openColumnGroups.delete(groupId);
            return {
                groupId: groupId,
                open: open
            };
        });
        for (const groupId of openColumnGroups)stateItems.push({
            groupId: groupId,
            open: true
        });
        if (stateItems.length) this.columnGroupStates = stateItems;
        colGroupSvc.setColumnGroupState(stateItems, source);
    }
    getFilterState() {
        const filterManager = this.beans.filterManager;
        let filterModel = filterManager?.getFilterModel();
        if (filterModel && Object.keys(filterModel).length === 0) filterModel = void 0;
        const columnFilterState = filterManager?.getFilterState();
        const advancedFilterModel = filterManager?.getAdvFilterModel() ?? void 0;
        return filterModel || advancedFilterModel || columnFilterState ? {
            filterModel: filterModel,
            columnFilterState: columnFilterState,
            advancedFilterModel: advancedFilterModel
        } : void 0;
    }
    setFilterState(filterState) {
        const filterManager = this.beans.filterManager;
        const { filterModel: filterModel, columnFilterState: columnFilterState, advancedFilterModel: advancedFilterModel } = filterState ?? {
            filterModel: null,
            columnFilterState: null,
            advancedFilterModel: null
        };
        if (filterModel !== void 0 || columnFilterState !== void 0) filterManager?.setFilterState(filterModel ?? null, columnFilterState ?? null, "columnFilter");
        if (advancedFilterModel !== void 0) filterManager?.setAdvFilterModel(advancedFilterModel ?? null, "advancedFilter");
    }
    getRangeSelectionState() {
        const cellRanges = this.beans.rangeSvc?.getCellRanges().map((cellRange)=>{
            const { id: id, type: type, startRow: startRow, endRow: endRow, columns: columns, startColumn: startColumn } = cellRange;
            return {
                id: id,
                type: type,
                startRow: startRow,
                endRow: endRow,
                colIds: columns.map((column)=>column.getColId()),
                startColId: startColumn.getColId()
            };
        });
        return cellRanges?.length ? {
            cellRanges: cellRanges
        } : void 0;
    }
    setCellSelectionState(cellSelectionState) {
        const { gos: gos, rangeSvc: rangeSvc, colModel: colModel, visibleCols: visibleCols } = this.beans;
        if (!$437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) || !rangeSvc) return;
        const cellRanges = [];
        for (const cellRange of cellSelectionState?.cellRanges ?? []){
            const columns = [];
            for (const colId of cellRange.colIds){
                const column = colModel.getCol(colId);
                if (column) columns.push(column);
            }
            if (!columns.length) continue;
            let startColumn = colModel.getCol(cellRange.startColId);
            if (!startColumn) {
                const allColumns = visibleCols.allCols;
                const columnSet = new Set(columns);
                startColumn = allColumns.find((column)=>columnSet.has(column));
            }
            cellRanges.push({
                ...cellRange,
                columns: columns,
                startColumn: startColumn
            });
        }
        rangeSvc.setCellRanges(cellRanges);
    }
    getScrollState() {
        if (!this.isClientSideRowModel) return void 0;
        const scrollFeature = this.beans.ctrlsSvc.getScrollFeature();
        const { left: left } = scrollFeature?.getHScrollPosition() ?? {
            left: 0
        };
        const { top: top } = scrollFeature?.getVScrollPosition() ?? {
            top: 0
        };
        return top || left ? {
            top: top,
            left: left
        } : void 0;
    }
    setScrollState(scrollState) {
        if (!this.isClientSideRowModel) return;
        const { top: top, left: left } = scrollState ?? {
            top: 0,
            left: 0
        };
        const { frameworkOverrides: frameworkOverrides, rowRenderer: rowRenderer, animationFrameSvc: animationFrameSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        frameworkOverrides.wrapIncoming(()=>{
            ctrlsSvc.get("center").setCenterViewportScrollLeft(left);
            ctrlsSvc.getScrollFeature()?.setVerticalScrollPosition(top);
            rowRenderer.redraw({
                afterScroll: true
            });
            animationFrameSvc?.flushAllFrames();
        });
    }
    getSideBarState() {
        return this.beans.sideBar?.comp?.getState();
    }
    getFocusedCellState() {
        if (!this.isClientSideRowModel) return void 0;
        const focusedCell = this.beans.focusSvc.getFocusedCell();
        if (focusedCell) {
            const { column: column, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCell;
            return {
                colId: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
        }
        return void 0;
    }
    setFocusedCellState(focusedCellState) {
        if (!this.isClientSideRowModel) return;
        const { focusSvc: focusSvc, colModel: colModel } = this.beans;
        if (!focusedCellState) {
            focusSvc.clearFocusedCell();
            return;
        }
        const { colId: colId, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCellState;
        focusSvc.setFocusedCell({
            column: colModel.getCol(colId),
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true
        });
    }
    getPaginationState() {
        const { pagination: pagination, gos: gos } = this.beans;
        if (!pagination) return void 0;
        const page = pagination.getCurrentPage();
        const pageSize = !gos.get("paginationAutoPageSize") ? pagination.getPageSize() : void 0;
        if (!page && !pageSize) return;
        return {
            page: page,
            pageSize: pageSize
        };
    }
    setPaginationState(paginationState, source) {
        const { pagination: pagination, gos: gos } = this.beans;
        if (!pagination) return;
        const { pageSize: pageSize, page: page } = paginationState ?? {
            page: 0,
            pageSize: gos.get("paginationPageSize")
        };
        const isInit = source === "gridInitializing";
        if (pageSize && !gos.get("paginationAutoPageSize")) pagination.setPageSize(pageSize, isInit ? "initialState" : "pageSizeSelector");
        if (typeof page === "number") {
            if (isInit) pagination.setPage(page);
            else pagination.goToPage(page);
        }
    }
    getRowSelectionState() {
        const selectionSvc = this.beans.selectionSvc;
        if (!selectionSvc) return void 0;
        const selectionState = selectionSvc.getSelectionState();
        const noSelections = !selectionState || !Array.isArray(selectionState) && (selectionState.selectAll === false || selectionState.selectAllChildren === false) && !selectionState?.toggledNodes?.length;
        return noSelections ? void 0 : selectionState;
    }
    setRowSelectionState(rowSelectionState, source) {
        this.beans.selectionSvc?.setSelectionState(rowSelectionState, source, source === "api");
    }
    getRowGroupExpansionState() {
        const { expansionSvc: expansionSvc } = this.beans;
        if (!expansionSvc) return void 0;
        return expansionSvc.getExpansionState();
    }
    getRowPinningState() {
        return this.beans.pinnedRowModel?.getPinnedState();
    }
    setRowPinningState(state) {
        const pinnedRowModel = this.beans.pinnedRowModel;
        if (state) pinnedRowModel?.setPinnedState(state);
        else pinnedRowModel?.reset();
    }
    setRowGroupExpansionState(ssrmRowGroupExpansionState, rowGroupExpansionState, source) {
        const expansionSvc = this.beans.expansionSvc;
        if (!expansionSvc) return;
        const newExpansionState = rowGroupExpansionState ?? {
            expandedRowGroupIds: [],
            collapsedRowGroupIds: []
        };
        expansionSvc.setExpansionState(newExpansionState, source);
    }
    updateColumnState(features) {
        const newColumnState = this.getColumnState();
        let hasChanged = false;
        const cachedState = this.cachedState;
        for (const key of Object.keys(newColumnState)){
            const value = newColumnState[key];
            if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(value, cachedState[key])) hasChanged = true;
        }
        this.cachedState = {
            ...cachedState,
            ...newColumnState
        };
        if (hasChanged) this.dispatchStateUpdateEvent(features);
    }
    updateCachedState(key, value) {
        const existingValue = this.cachedState[key];
        this.setCachedStateValue(key, value);
        if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(value, existingValue)) this.dispatchStateUpdateEvent([
            key
        ]);
    }
    setCachedStateValue(key, value) {
        this.cachedState = {
            ...this.cachedState,
            [key]: value
        };
    }
    refreshStaleState() {
        const staleStateKeys = this.staleStateKeys;
        for (const key of staleStateKeys)if (key === "rowSelection") this.setCachedStateValue(key, this.getRowSelectionState());
        staleStateKeys.clear();
    }
    dispatchStateUpdateEvent(sources) {
        if (this.suppressEvents) return;
        for (const source of sources)this.queuedUpdateSources.add(source);
        this.dispatchStateUpdateEventDebounced();
    }
    dispatchQueuedStateUpdateEvents() {
        const queuedUpdateSources = this.queuedUpdateSources;
        const sources = Array.from(queuedUpdateSources);
        queuedUpdateSources.clear();
        this.eventSvc.dispatchEvent({
            type: "stateUpdated",
            sources: sources,
            state: this.cachedState
        });
    }
    startSuppressEvents() {
        this.suppressEvents = true;
        this.beans.colAnimation?.setSuppressAnimation(true);
    }
    stopSuppressEvents(source) {
        setTimeout(()=>{
            this.suppressEvents = false;
            this.queuedUpdateSources.clear();
            if (!this.isAlive()) return;
            this.beans.colAnimation?.setSuppressAnimation(false);
            this.dispatchStateUpdateEvent([
                source
            ]);
        });
    }
    suppressEventsAndDispatchInitEvent(updateFunc) {
        this.startSuppressEvents();
        updateFunc();
        this.stopSuppressEvents("gridInitializing");
    }
};
// packages/ag-grid-community/src/misc/state/stateModule.ts
var $437b23f6a393c3bf$export$3402149dbbda9537 = {
    moduleName: "GridState",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$StateService
    ],
    apiFunctions: {
        getState: $437b23f6a393c3bf$var$getState,
        setState: $437b23f6a393c3bf$var$setState
    }
};
// packages/ag-grid-community/src/pagination/paginationApi.ts
function $437b23f6a393c3bf$var$paginationIsLastPageFound(beans) {
    return beans.rowModel.isLastRowIndexKnown();
}
function $437b23f6a393c3bf$var$paginationGetPageSize(beans) {
    return beans.pagination?.getPageSize() ?? 100;
}
function $437b23f6a393c3bf$var$paginationGetCurrentPage(beans) {
    return beans.pagination?.getCurrentPage() ?? 0;
}
function $437b23f6a393c3bf$var$paginationGetTotalPages(beans) {
    return beans.pagination?.getTotalPages() ?? 1;
}
function $437b23f6a393c3bf$var$paginationGetRowCount(beans) {
    return beans.pagination ? beans.pagination.getMasterRowCount() : beans.rowModel.getRowCount();
}
function $437b23f6a393c3bf$var$paginationGoToNextPage(beans) {
    beans.pagination?.goToNextPage();
}
function $437b23f6a393c3bf$var$paginationGoToPreviousPage(beans) {
    beans.pagination?.goToPreviousPage();
}
function $437b23f6a393c3bf$var$paginationGoToFirstPage(beans) {
    beans.pagination?.goToFirstPage();
}
function $437b23f6a393c3bf$var$paginationGoToLastPage(beans) {
    beans.pagination?.goToLastPage();
}
function $437b23f6a393c3bf$var$paginationGoToPage(beans, page) {
    beans.pagination?.goToPage(page);
}
// packages/ag-grid-community/src/pagination/paginationAutoPageSizeService.ts
var $437b23f6a393c3bf$var$PaginationAutoPageSizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "paginationAutoPageSizeSvc";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowsCtrl = p.center;
            const listener = this.checkPageSize.bind(this);
            this.addManagedEventListeners({
                bodyHeightChanged: listener,
                scrollVisibilityChanged: listener
            });
            this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this));
            this.checkPageSize();
        });
    }
    notActive() {
        return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
    }
    onPaginationAutoSizeChanged() {
        if (this.notActive()) this.beans.pagination.unsetAutoCalculatedPageSize();
        else this.checkPageSize();
    }
    checkPageSize() {
        if (this.notActive()) return;
        const bodyHeight = this.centerRowsCtrl.viewportSizeFeature.getBodyHeight();
        if (bodyHeight > 0) {
            const beans = this.beans;
            const update = ()=>{
                const rowHeight = Math.max($437b23f6a393c3bf$export$8966875adec41e5b(beans), 1);
                const newPageSize = Math.floor(bodyHeight / rowHeight);
                beans.pagination.setPageSize(newPageSize, "autoCalculated");
            };
            if (!this.isBodyRendered) {
                update();
                this.isBodyRendered = true;
            } else $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, update, 50)();
        } else this.isBodyRendered = false;
    }
};
// packages/ag-grid-community/src/pagination/pageSizeSelector/pageSizeSelectorComp.ts
var $437b23f6a393c3bf$var$paginationPageSizeSelector = "paginationPageSizeSelector";
var $437b23f6a393c3bf$var$PageSizeSelectorCompElement = {
    tag: "span",
    cls: "ag-paging-page-size"
};
var $437b23f6a393c3bf$var$PageSizeSelectorComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$PageSizeSelectorCompElement);
        this.hasEmptyOption = false;
        this.handlePageSizeItemSelected = ()=>{
            if (!this.selectPageSizeComp) return;
            const newValue = this.selectPageSizeComp.getValue();
            if (!newValue) return;
            const paginationPageSize = Number(newValue);
            if (isNaN(paginationPageSize) || paginationPageSize < 1 || paginationPageSize === this.pagination.getPageSize()) return;
            this.pagination.setPageSize(paginationPageSize, "pageSizeSelector");
            if (this.hasEmptyOption) this.toggleSelectDisplay(true);
            this.selectPageSizeComp.getFocusableElement().focus();
        };
    }
    wireBeans(beans) {
        this.pagination = beans.pagination;
    }
    postConstruct() {
        this.addManagedPropertyListener($437b23f6a393c3bf$var$paginationPageSizeSelector, ()=>{
            this.onPageSizeSelectorValuesChange();
        });
        this.addManagedEventListeners({
            paginationChanged: (event)=>this.handlePaginationChanged(event)
        });
    }
    handlePaginationChanged(paginationChangedEvent) {
        if (!this.selectPageSizeComp || !paginationChangedEvent?.newPageSize) return;
        const paginationPageSize = this.pagination.getPageSize();
        if (this.getPageSizeSelectorValues().includes(paginationPageSize)) this.selectPageSizeComp.setValue(paginationPageSize.toString());
        else if (this.hasEmptyOption) this.selectPageSizeComp.setValue("");
        else this.toggleSelectDisplay(true);
    }
    toggleSelectDisplay(show) {
        if (this.selectPageSizeComp && !show) this.reset();
        if (!show) return;
        this.reloadPageSizesSelector();
        if (!this.selectPageSizeComp) return;
    }
    reset() {
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.getGui());
        if (!this.selectPageSizeComp) return;
        this.selectPageSizeComp = this.destroyBean(this.selectPageSizeComp);
    }
    onPageSizeSelectorValuesChange() {
        if (!this.selectPageSizeComp) return;
        if (this.shouldShowPageSizeSelector()) this.reloadPageSizesSelector();
    }
    shouldShowPageSizeSelector() {
        return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector) !== false;
    }
    reloadPageSizesSelector() {
        const pageSizeOptions = this.getPageSizeSelectorValues();
        const paginationPageSizeOption = this.pagination.getPageSize();
        const shouldAddAndSelectEmptyOption = !paginationPageSizeOption || !pageSizeOptions.includes(paginationPageSizeOption);
        if (shouldAddAndSelectEmptyOption) {
            const pageSizeSet = this.gos.exists("paginationPageSize");
            const pageSizesSet = this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector) !== true;
            $437b23f6a393c3bf$export$545083624300f13d(94, {
                pageSizeSet: pageSizeSet,
                pageSizesSet: pageSizesSet,
                pageSizeOptions: pageSizeOptions,
                paginationPageSizeOption: paginationPageSizeOption
            });
            if (!pageSizesSet) $437b23f6a393c3bf$export$545083624300f13d(95, {
                paginationPageSizeOption: paginationPageSizeOption,
                paginationPageSizeSelector: $437b23f6a393c3bf$var$paginationPageSizeSelector
            });
            pageSizeOptions.unshift("");
        }
        const value = String(shouldAddAndSelectEmptyOption ? "" : paginationPageSizeOption);
        if (this.selectPageSizeComp) {
            if (!$437b23f6a393c3bf$export$893967cdb9833fdd(this.pageSizeOptions, pageSizeOptions)) {
                this.selectPageSizeComp.clearOptions().addOptions(this.createPageSizeSelectOptions(pageSizeOptions));
                this.pageSizeOptions = pageSizeOptions;
            }
            this.selectPageSizeComp.setValue(value, true);
        } else this.createPageSizeSelectorComp(pageSizeOptions, value);
        this.hasEmptyOption = shouldAddAndSelectEmptyOption;
    }
    createPageSizeSelectOptions(pageSizeOptions) {
        return pageSizeOptions.map((value)=>({
                value: String(value)
            }));
    }
    createPageSizeSelectorComp(pageSizeOptions, value) {
        const localeTextFunc = this.getLocaleTextFunc();
        const localisedLabel = localeTextFunc("pageSizeSelectorLabel", "Page Size:");
        const localisedAriaLabel = localeTextFunc("ariaPageSizeSelectorLabel", "Page Size");
        this.selectPageSizeComp = this.createManagedBean(new $437b23f6a393c3bf$export$6f9c460854d56032()).addOptions(this.createPageSizeSelectOptions(pageSizeOptions)).setValue(value).setAriaLabel(localisedAriaLabel).setLabel(localisedLabel).onValueChange(()=>this.handlePageSizeItemSelected());
        this.appendChild(this.selectPageSizeComp);
    }
    getPageSizeSelectorValues() {
        const defaultValues = [
            20,
            50,
            100
        ];
        const paginationPageSizeSelectorValues = this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector);
        if (!Array.isArray(paginationPageSizeSelectorValues) || !paginationPageSizeSelectorValues?.length) return defaultValues;
        return [
            ...paginationPageSizeSelectorValues
        ].sort((a, b)=>a - b);
    }
    destroy() {
        this.toggleSelectDisplay(false);
        super.destroy();
    }
};
var $437b23f6a393c3bf$var$PageSizeSelectorSelector = {
    selector: "AG-PAGE-SIZE-SELECTOR",
    component: $437b23f6a393c3bf$var$PageSizeSelectorComp
};
// packages/ag-grid-community/src/pagination/paginationComp.css-GENERATED.ts
var $437b23f6a393c3bf$var$paginationCompCSS = /*css*/ `.ag-paging-panel{align-items:center;border-top:var(--ag-footer-row-border);display:flex;gap:calc(var(--ag-spacing)*4);height:var(--ag-pagination-panel-height);justify-content:flex-end;padding:0 var(--ag-cell-horizontal-padding)}:where(.ag-paging-page-size) .ag-wrapper{min-width:50px}.ag-paging-page-summary-panel{align-items:center;display:flex;gap:var(--ag-cell-widget-spacing);.ag-disabled &{pointer-events:none}}.ag-paging-button{cursor:pointer;position:relative;&.ag-disabled{cursor:default;opacity:.5}}.ag-paging-number,.ag-paging-row-summary-panel-number{font-weight:500}`;
// packages/ag-grid-community/src/pagination/paginationComp.ts
var $437b23f6a393c3bf$var$PaginationComp = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(){
        super();
        this.btFirst = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btPrevious = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btNext = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btLast = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbRecordCount = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbFirstRowOnPage = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbLastRowOnPage = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbCurrent = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbTotal = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.pageSizeComp = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.previousAndFirstButtonsDisabled = false;
        this.nextButtonDisabled = false;
        this.lastButtonDisabled = false;
        this.areListenersSetup = false;
        this.allowFocusInnerElement = false;
        this.registerCSS($437b23f6a393c3bf$var$paginationCompCSS);
    }
    wireBeans(beans) {
        this.rowModel = beans.rowModel;
        this.pagination = beans.pagination;
        this.ariaAnnounce = beans.ariaAnnounce;
    }
    postConstruct() {
        const isRtl = this.gos.get("enableRtl");
        this.setTemplate(this.getTemplate(), [
            $437b23f6a393c3bf$var$PageSizeSelectorSelector
        ]);
        const { btFirst: btFirst, btPrevious: btPrevious, btNext: btNext, btLast: btLast } = this;
        this.activateTabIndex([
            btFirst,
            btPrevious,
            btNext,
            btLast
        ]);
        btFirst.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "last" : "first", this.beans));
        btPrevious.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "next" : "previous", this.beans));
        btNext.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "previous" : "next", this.beans));
        btLast.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "first" : "last", this.beans));
        this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListeners([
            "paginationPageSizeSelector",
            "paginationAutoPageSize",
            "suppressPaginationPanel"
        ], ()=>this.onPageSizeRelatedOptionsChange());
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
        this.initialiseTabGuard({
            // prevent tab guard default logic
            onTabKeyDown: ()=>{},
            focusInnerElement: (fromBottom)=>{
                if (this.allowFocusInnerElement) return this.tabGuardFeature.getTabGuardCtrl().focusInnerElement(fromBottom);
                else return $437b23f6a393c3bf$export$b3beea4db79d8bb3(this.beans, fromBottom);
            },
            forceFocusOutWhenTabGuardsAreEmpty: true
        });
        this.onPaginationChanged();
    }
    setAllowFocus(allowFocus) {
        this.allowFocusInnerElement = allowFocus;
    }
    onPaginationChanged() {
        const isPaging = this.gos.get("pagination");
        const paginationPanelEnabled = isPaging && !this.gos.get("suppressPaginationPanel");
        this.setDisplayed(paginationPanelEnabled);
        if (!paginationPanelEnabled) return;
        this.setupListeners();
        this.enableOrDisableButtons();
        this.updateLabels();
        this.onPageSizeRelatedOptionsChange();
    }
    onPageSizeRelatedOptionsChange() {
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
    }
    setupListeners() {
        if (!this.areListenersSetup) {
            this.addManagedEventListeners({
                paginationChanged: this.onPaginationChanged.bind(this)
            });
            for (const item of [
                {
                    el: this.btFirst,
                    fn: this.onBtFirst.bind(this)
                },
                {
                    el: this.btPrevious,
                    fn: this.onBtPrevious.bind(this)
                },
                {
                    el: this.btNext,
                    fn: this.onBtNext.bind(this)
                },
                {
                    el: this.btLast,
                    fn: this.onBtLast.bind(this)
                }
            ]){
                const { el: el, fn: fn } = item;
                this.addManagedListeners(el, {
                    click: fn,
                    keydown: (e)=>{
                        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) {
                            e.preventDefault();
                            fn();
                        }
                    }
                });
            }
            $437b23f6a393c3bf$export$8865b8c867776648(this.beans, this, this.getGui());
            this.areListenersSetup = true;
        }
    }
    onBtFirst() {
        if (!this.previousAndFirstButtonsDisabled) this.pagination.goToFirstPage();
    }
    formatNumber(value) {
        const userFunc = this.gos.getCallback("paginationNumberFormatter");
        if (userFunc) {
            const params = {
                value: value
            };
            return userFunc(params);
        }
        return $437b23f6a393c3bf$export$c8980add4a69422e(value, this.getLocaleTextFunc.bind(this));
    }
    getTemplate() {
        const localeTextFunc = this.getLocaleTextFunc();
        const idPrefix = `ag-${this.getCompId()}`;
        return {
            tag: "div",
            cls: "ag-paging-panel ag-unselectable",
            attrs: {
                id: `${idPrefix}`
            },
            children: [
                {
                    tag: "ag-page-size-selector",
                    ref: "pageSizeComp"
                },
                {
                    tag: "span",
                    cls: "ag-paging-row-summary-panel",
                    children: [
                        {
                            tag: "span",
                            ref: "lbFirstRowOnPage",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-first-row`
                            }
                        },
                        {
                            tag: "span",
                            attrs: {
                                id: `${idPrefix}-to`
                            },
                            children: localeTextFunc("to", "to")
                        },
                        {
                            tag: "span",
                            ref: "lbLastRowOnPage",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-last-row`
                            }
                        },
                        {
                            tag: "span",
                            attrs: {
                                id: `${idPrefix}-of`
                            },
                            children: localeTextFunc("of", "of")
                        },
                        {
                            tag: "span",
                            ref: "lbRecordCount",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-row-count`
                            }
                        }
                    ]
                },
                {
                    tag: "span",
                    cls: "ag-paging-page-summary-panel",
                    role: "presentation",
                    children: [
                        {
                            tag: "div",
                            ref: "btFirst",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("firstPage", "First Page")
                            }
                        },
                        {
                            tag: "div",
                            ref: "btPrevious",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("previousPage", "Previous Page")
                            }
                        },
                        {
                            tag: "span",
                            cls: "ag-paging-description",
                            children: [
                                {
                                    tag: "span",
                                    attrs: {
                                        id: `${idPrefix}-start-page`
                                    },
                                    children: localeTextFunc("page", "Page")
                                },
                                {
                                    tag: "span",
                                    ref: "lbCurrent",
                                    cls: "ag-paging-number",
                                    attrs: {
                                        id: `${idPrefix}-start-page-number`
                                    }
                                },
                                {
                                    tag: "span",
                                    attrs: {
                                        id: `${idPrefix}-of-page`
                                    },
                                    children: localeTextFunc("of", "of")
                                },
                                {
                                    tag: "span",
                                    ref: "lbTotal",
                                    cls: "ag-paging-number",
                                    attrs: {
                                        id: `${idPrefix}-of-page-number`
                                    }
                                }
                            ]
                        },
                        {
                            tag: "div",
                            ref: "btNext",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("nextPage", "Next Page")
                            }
                        },
                        {
                            tag: "div",
                            ref: "btLast",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("lastPage", "Last Page")
                            }
                        }
                    ]
                }
            ]
        };
    }
    onBtNext() {
        if (!this.nextButtonDisabled) this.pagination.goToNextPage();
    }
    onBtPrevious() {
        if (!this.previousAndFirstButtonsDisabled) this.pagination.goToPreviousPage();
    }
    onBtLast() {
        if (!this.lastButtonDisabled) this.pagination.goToLastPage();
    }
    enableOrDisableButtons() {
        const currentPage = this.pagination.getCurrentPage();
        const maxRowFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        this.previousAndFirstButtonsDisabled = currentPage === 0;
        this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled);
        this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
        const zeroPagesToDisplay = this.isZeroPagesToDisplay();
        const onLastPage = currentPage === totalPages - 1;
        this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
        this.lastButtonDisabled = !maxRowFound || zeroPagesToDisplay || currentPage === totalPages - 1;
        this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled);
        this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
    }
    toggleButtonDisabled(button, disabled) {
        $437b23f6a393c3bf$export$7ed376f43c6f2bbd(button, disabled);
        button.classList.toggle("ag-disabled", disabled);
    }
    isZeroPagesToDisplay() {
        const maxRowFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        return maxRowFound && totalPages === 0;
    }
    updateLabels() {
        const lastPageFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        const masterRowCount = this.pagination.getMasterRowCount();
        const rowCount = lastPageFound ? masterRowCount : null;
        const currentPage = this.pagination.getCurrentPage();
        const pageSize = this.pagination.getPageSize();
        let startRow;
        let endRow;
        if (this.isZeroPagesToDisplay()) startRow = endRow = 0;
        else {
            startRow = pageSize * currentPage + 1;
            endRow = startRow + pageSize - 1;
            if (lastPageFound && endRow > rowCount) endRow = rowCount;
        }
        const theoreticalEndRow = startRow + pageSize - 1;
        const isLoadingPageSize = !lastPageFound && masterRowCount < theoreticalEndRow;
        const lbFirstRowOnPage = this.formatNumber(startRow);
        this.lbFirstRowOnPage.textContent = lbFirstRowOnPage;
        let lbLastRowOnPage;
        const localeTextFunc = this.getLocaleTextFunc();
        if (isLoadingPageSize) lbLastRowOnPage = localeTextFunc("pageLastRowUnknown", "?");
        else lbLastRowOnPage = this.formatNumber(endRow);
        this.lbLastRowOnPage.textContent = lbLastRowOnPage;
        const pagesExist = totalPages > 0;
        const toDisplay = pagesExist ? currentPage + 1 : 0;
        const lbCurrent = this.formatNumber(toDisplay);
        this.lbCurrent.textContent = lbCurrent;
        let lbTotal;
        let lbRecordCount;
        if (lastPageFound) {
            lbTotal = this.formatNumber(totalPages);
            lbRecordCount = this.formatNumber(rowCount);
        } else {
            const moreText = localeTextFunc("more", "more");
            lbTotal = moreText;
            lbRecordCount = moreText;
        }
        this.lbTotal.textContent = lbTotal;
        this.lbRecordCount.textContent = lbRecordCount;
        this.announceAriaStatus(lbFirstRowOnPage, lbLastRowOnPage, lbRecordCount, lbCurrent, lbTotal);
    }
    announceAriaStatus(lbFirstRowOnPage, lbLastRowOnPage, lbRecordCount, lbCurrent, lbTotal) {
        const localeTextFunc = this.getLocaleTextFunc();
        const strPage = localeTextFunc("page", "Page");
        const strTo = localeTextFunc("to", "to");
        const strOf = localeTextFunc("of", "of");
        const ariaRowStatus = `${lbFirstRowOnPage} ${strTo} ${lbLastRowOnPage} ${strOf} ${lbRecordCount}`;
        const ariaPageStatus = `${strPage} ${lbCurrent} ${strOf} ${lbTotal}`;
        if (ariaRowStatus !== this.ariaRowStatus) {
            this.ariaRowStatus = ariaRowStatus;
            this.ariaAnnounce?.announceValue(ariaRowStatus, "paginationRow");
        }
        if (ariaPageStatus !== this.ariaPageStatus) {
            this.ariaPageStatus = ariaPageStatus;
            this.ariaAnnounce?.announceValue(ariaPageStatus, "paginationPage");
        }
    }
};
var $437b23f6a393c3bf$var$PaginationSelector = {
    selector: "AG-PAGINATION",
    component: $437b23f6a393c3bf$var$PaginationComp
};
// packages/ag-grid-community/src/pagination/paginationService.ts
var $437b23f6a393c3bf$var$PaginationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pagination";
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = 0;
        this.masterRowCount = 0;
    }
    postConstruct() {
        const gos = this.gos;
        this.active = gos.get("pagination");
        this.pageSizeFromGridOptions = gos.get("paginationPageSize");
        this.paginateChildRows = this.isPaginateChildRows();
        this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this));
        this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
    }
    getPaginationSelector() {
        return $437b23f6a393c3bf$var$PaginationSelector;
    }
    isPaginateChildRows() {
        const gos = this.gos;
        const shouldPaginate = gos.get("groupHideParentOfSingleChild") || // following two properties deprecated v32.3.0
        gos.get("groupRemoveSingleChildren") || gos.get("groupRemoveLowestSingleChildren");
        if (shouldPaginate) return true;
        return gos.get("paginateChildRows");
    }
    onPaginationGridOptionChanged() {
        this.active = this.gos.get("pagination");
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            keepRenderedRows: true
        });
    }
    onPageSizeGridOptionChanged() {
        this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
    }
    goToPage(page) {
        const currentPage = this.currentPage;
        if (!this.active || currentPage === page || typeof currentPage !== "number") return;
        const { editSvc: editSvc } = this.beans;
        if (editSvc?.isEditing()) {
            if (editSvc.isBatchEditing()) editSvc.cleanupEditors();
            else editSvc.stopEditing(void 0, {
                source: "api"
            });
        }
        this.currentPage = page;
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            newPage: true
        });
    }
    goToPageWithIndex(index) {
        if (!this.active) return;
        let adjustedIndex = index;
        if (!this.paginateChildRows) adjustedIndex = this.beans.rowModel.getTopLevelIndexFromDisplayedIndex?.(index) ?? index;
        this.goToPage(Math.floor(adjustedIndex / this.pageSize));
    }
    isRowInPage(rowIndex) {
        if (!this.active) return true;
        return rowIndex >= this.topDisplayedRowIndex && rowIndex <= this.bottomDisplayedRowIndex;
    }
    getCurrentPage() {
        return this.currentPage;
    }
    goToNextPage() {
        this.goToPage(this.currentPage + 1);
    }
    goToPreviousPage() {
        this.goToPage(this.currentPage - 1);
    }
    goToFirstPage() {
        this.goToPage(0);
    }
    goToLastPage() {
        const rowCount = this.beans.rowModel.getRowCount();
        const lastPage = Math.floor(rowCount / this.pageSize);
        this.goToPage(lastPage);
    }
    getPageSize() {
        return this.pageSize;
    }
    getTotalPages() {
        return this.totalPages;
    }
    /** This is only for state setting before data has been loaded */ setPage(page) {
        this.currentPage = page;
    }
    get pageSize() {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeAutoCalculated) && this.gos.get("paginationAutoPageSize")) return this.pageSizeAutoCalculated;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromPageSizeSelector)) return this.pageSizeFromPageSizeSelector;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromInitialState)) return this.pageSizeFromInitialState;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromGridOptions)) return this.pageSizeFromGridOptions;
        return this.defaultPageSize;
    }
    calculatePages() {
        if (this.active) {
            if (this.paginateChildRows) this.calculatePagesAllRows();
            else this.calculatePagesMasterRowsOnly();
        } else this.calculatedPagesNotActive();
        this.beans.pageBounds.calculateBounds(this.topDisplayedRowIndex, this.bottomDisplayedRowIndex);
    }
    unsetAutoCalculatedPageSize() {
        if (this.pageSizeAutoCalculated === void 0) return;
        const oldPageSize = this.pageSizeAutoCalculated;
        this.pageSizeAutoCalculated = void 0;
        if (this.pageSize === oldPageSize) return;
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            newPageSize: true
        });
    }
    setPageSize(size, source) {
        const currentSize = this.pageSize;
        switch(source){
            case "autoCalculated":
                this.pageSizeAutoCalculated = size;
                break;
            case "pageSizeSelector":
                this.pageSizeFromPageSizeSelector = size;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
            case "initialState":
                this.pageSizeFromInitialState = size;
                break;
            case "gridOptions":
                this.pageSizeFromGridOptions = size;
                this.pageSizeFromInitialState = void 0;
                this.pageSizeFromPageSizeSelector = void 0;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
        }
        if (currentSize !== this.pageSize) {
            this.calculatePages();
            this.dispatchPaginationChangedEvent({
                newPageSize: true,
                keepRenderedRows: true
            });
        }
    }
    setZeroRows() {
        this.masterRowCount = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = -1;
        this.currentPage = 0;
        this.totalPages = 0;
    }
    adjustCurrentPageIfInvalid() {
        const totalPages = this.totalPages;
        if (this.currentPage >= totalPages) this.currentPage = totalPages - 1;
        const currentPage = this.currentPage;
        if (!isFinite(currentPage) || isNaN(currentPage) || currentPage < 0) this.currentPage = 0;
    }
    calculatePagesMasterRowsOnly() {
        const rowModel = this.beans.rowModel;
        const masterRowCount = rowModel.getTopLevelRowCount();
        this.masterRowCount = masterRowCount;
        if (masterRowCount <= 0) {
            this.setZeroRows();
            return;
        }
        const pageSize = this.pageSize;
        const masterLastRowIndex = masterRowCount - 1;
        this.totalPages = Math.floor(masterLastRowIndex / pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        const currentPage = this.currentPage;
        const masterPageStartIndex = pageSize * currentPage;
        let masterPageEndIndex = pageSize * (currentPage + 1) - 1;
        if (masterPageEndIndex > masterLastRowIndex) masterPageEndIndex = masterLastRowIndex;
        this.topDisplayedRowIndex = rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);
        if (masterPageEndIndex === masterLastRowIndex) this.bottomDisplayedRowIndex = rowModel.getRowCount() - 1;
        else {
            const firstIndexNotToShow = rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
            this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
        }
    }
    getMasterRowCount() {
        return this.masterRowCount;
    }
    calculatePagesAllRows() {
        const masterRowCount = this.beans.rowModel.getRowCount();
        this.masterRowCount = masterRowCount;
        if (masterRowCount === 0) {
            this.setZeroRows();
            return;
        }
        const { pageSize: pageSize, currentPage: currentPage } = this;
        const maxRowIndex = masterRowCount - 1;
        this.totalPages = Math.floor(maxRowIndex / pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        this.topDisplayedRowIndex = pageSize * currentPage;
        this.bottomDisplayedRowIndex = pageSize * (currentPage + 1) - 1;
        if (this.bottomDisplayedRowIndex > maxRowIndex) this.bottomDisplayedRowIndex = maxRowIndex;
    }
    calculatedPagesNotActive() {
        this.setPageSize(void 0, "autoCalculated");
        this.totalPages = 1;
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = this.beans.rowModel.getRowCount() - 1;
    }
    dispatchPaginationChangedEvent(params) {
        const { keepRenderedRows: keepRenderedRows = false, newPage: newPage = false, newPageSize: newPageSize = false } = params;
        this.eventSvc.dispatchEvent({
            type: "paginationChanged",
            animate: false,
            newData: false,
            newPage: newPage,
            newPageSize: newPageSize,
            keepRenderedRows: keepRenderedRows
        });
    }
};
// packages/ag-grid-community/src/pagination/paginationModule.ts
var $437b23f6a393c3bf$export$a57c5ed18afb0c4 = {
    moduleName: "Pagination",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PaginationService,
        $437b23f6a393c3bf$var$PaginationAutoPageSizeService
    ],
    icons: {
        // "go to first" button in pagination controls
        first: "first",
        // "go to previous" button in pagination controls
        previous: "previous",
        // "go to next" button in pagination controls
        next: "next",
        // "go to last" button in pagination controls
        last: "last"
    },
    apiFunctions: {
        paginationIsLastPageFound: $437b23f6a393c3bf$var$paginationIsLastPageFound,
        paginationGetPageSize: $437b23f6a393c3bf$var$paginationGetPageSize,
        paginationGetCurrentPage: $437b23f6a393c3bf$var$paginationGetCurrentPage,
        paginationGetTotalPages: $437b23f6a393c3bf$var$paginationGetTotalPages,
        paginationGetRowCount: $437b23f6a393c3bf$var$paginationGetRowCount,
        paginationGoToNextPage: $437b23f6a393c3bf$var$paginationGoToNextPage,
        paginationGoToPreviousPage: $437b23f6a393c3bf$var$paginationGoToPreviousPage,
        paginationGoToFirstPage: $437b23f6a393c3bf$var$paginationGoToFirstPage,
        paginationGoToLastPage: $437b23f6a393c3bf$var$paginationGoToLastPage,
        paginationGoToPage: $437b23f6a393c3bf$var$paginationGoToPage
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d
    ]
};
// packages/ag-grid-community/src/api/rowApi.ts
function $437b23f6a393c3bf$var$redrawRows(beans, params = {}) {
    const rowNodes = params ? params.rowNodes : void 0;
    beans.frameworkOverrides.wrapIncoming(()=>beans.rowRenderer.redrawRows(rowNodes));
}
function $437b23f6a393c3bf$var$setRowNodeExpanded(beans, rowNode, expanded, expandParents, forceSync) {
    if (rowNode) {
        if (expandParents && rowNode.parent && rowNode.parent.level !== -1) $437b23f6a393c3bf$var$setRowNodeExpanded(beans, rowNode.parent, expanded, expandParents, forceSync);
        rowNode.setExpanded(expanded, void 0, forceSync);
    }
}
function $437b23f6a393c3bf$var$getRowNode(beans, id) {
    return beans.rowModel.getRowNode(id);
}
function $437b23f6a393c3bf$var$addRenderedRowListener(beans, eventName, rowIndex, callback) {
    beans.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
}
function $437b23f6a393c3bf$var$getRenderedNodes(beans) {
    return beans.rowRenderer.getRenderedNodes();
}
function $437b23f6a393c3bf$var$forEachNode(beans, callback, includeFooterNodes) {
    beans.rowModel.forEachNode(callback, includeFooterNodes);
}
function $437b23f6a393c3bf$var$getFirstDisplayedRowIndex(beans) {
    return beans.rowRenderer.firstRenderedRow;
}
function $437b23f6a393c3bf$var$getLastDisplayedRowIndex(beans) {
    return beans.rowRenderer.lastRenderedRow;
}
function $437b23f6a393c3bf$var$getDisplayedRowAtIndex(beans, index) {
    return beans.rowModel.getRow(index);
}
function $437b23f6a393c3bf$var$getDisplayedRowCount(beans) {
    return beans.rowModel.getRowCount();
}
// packages/ag-grid-community/src/api/apiModule.ts
var $437b23f6a393c3bf$export$12e9d7df2a270583 = {
    moduleName: "RowApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        redrawRows: $437b23f6a393c3bf$var$redrawRows,
        setRowNodeExpanded: $437b23f6a393c3bf$var$setRowNodeExpanded,
        getRowNode: $437b23f6a393c3bf$var$getRowNode,
        addRenderedRowListener: $437b23f6a393c3bf$var$addRenderedRowListener,
        getRenderedNodes: $437b23f6a393c3bf$var$getRenderedNodes,
        forEachNode: $437b23f6a393c3bf$var$forEachNode,
        getFirstDisplayedRowIndex: $437b23f6a393c3bf$var$getFirstDisplayedRowIndex,
        getLastDisplayedRowIndex: $437b23f6a393c3bf$var$getLastDisplayedRowIndex,
        getDisplayedRowAtIndex: $437b23f6a393c3bf$var$getDisplayedRowAtIndex,
        getDisplayedRowCount: $437b23f6a393c3bf$var$getDisplayedRowCount
    }
};
var $437b23f6a393c3bf$export$351f260d7f887abc = {
    moduleName: "ScrollApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        getVerticalPixelRange: $437b23f6a393c3bf$var$getVerticalPixelRange,
        getHorizontalPixelRange: $437b23f6a393c3bf$var$getHorizontalPixelRange,
        ensureColumnVisible: $437b23f6a393c3bf$var$ensureColumnVisible,
        ensureIndexVisible: $437b23f6a393c3bf$var$ensureIndexVisible,
        ensureNodeVisible: $437b23f6a393c3bf$var$ensureNodeVisible
    }
};
// packages/ag-grid-community/src/rendering/renderApi.ts
function $437b23f6a393c3bf$var$setGridAriaProperty(beans, property, value) {
    if (!property) return;
    const eGrid = beans.ctrlsSvc.getGridBodyCtrl().eGridBody;
    const ariaProperty = `aria-${property}`;
    if (value === null) eGrid.removeAttribute(ariaProperty);
    else eGrid.setAttribute(ariaProperty, value);
}
function $437b23f6a393c3bf$var$refreshCells(beans, params = {}) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.rowRenderer.refreshCells(params));
}
function $437b23f6a393c3bf$var$refreshHeader(beans) {
    beans.frameworkOverrides.wrapIncoming(()=>{
        for (const c of beans.ctrlsSvc.getHeaderRowContainerCtrls())c.refresh();
    });
}
function $437b23f6a393c3bf$var$isAnimationFrameQueueEmpty(beans) {
    return beans.animationFrameSvc?.isQueueEmpty() ?? true;
}
function $437b23f6a393c3bf$var$flushAllAnimationFrames(beans) {
    beans.animationFrameSvc?.flushAllFrames();
}
function $437b23f6a393c3bf$var$getSizesForCurrentTheme(beans) {
    return {
        rowHeight: $437b23f6a393c3bf$export$8966875adec41e5b(beans),
        headerHeight: $437b23f6a393c3bf$var$getHeaderHeight(beans)
    };
}
function $437b23f6a393c3bf$var$getCellRendererInstances(beans, params = {}) {
    const cellRenderers = [];
    for (const cellCtrl of beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns)){
        const cellRenderer = cellCtrl.getCellRenderer();
        if (cellRenderer != null) cellRenderers.push($437b23f6a393c3bf$export$213d4c63c3df47e4(cellRenderer));
    }
    if (params.columns?.length) return cellRenderers;
    const fullWidthRenderers = [];
    const rowIdMap = $437b23f6a393c3bf$var$mapRowNodes(params.rowNodes);
    for (const rowCtrl of beans.rowRenderer.getAllRowCtrls()){
        if (rowIdMap && !$437b23f6a393c3bf$var$isRowInMap(rowCtrl.rowNode, rowIdMap)) continue;
        if (!rowCtrl.isFullWidth()) continue;
        const renderers = rowCtrl.getFullWidthCellRenderers();
        for(let i = 0; i < renderers.length; i++){
            const renderer = renderers[i];
            if (renderer != null) fullWidthRenderers.push($437b23f6a393c3bf$export$213d4c63c3df47e4(renderer));
        }
    }
    return [
        ...fullWidthRenderers,
        ...cellRenderers
    ];
}
// packages/ag-grid-community/src/rendering/renderModule.ts
var $437b23f6a393c3bf$export$b67b27f72da743ce = {
    moduleName: "RenderApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        setGridAriaProperty: $437b23f6a393c3bf$var$setGridAriaProperty,
        refreshCells: $437b23f6a393c3bf$var$refreshCells,
        refreshHeader: $437b23f6a393c3bf$var$refreshHeader,
        isAnimationFrameQueueEmpty: $437b23f6a393c3bf$var$isAnimationFrameQueueEmpty,
        flushAllAnimationFrames: $437b23f6a393c3bf$var$flushAllAnimationFrames,
        getSizesForCurrentTheme: $437b23f6a393c3bf$var$getSizesForCurrentTheme,
        getCellRendererInstances: $437b23f6a393c3bf$var$getCellRendererInstances
    }
};
// packages/ag-grid-community/src/columnAutosize/columnAutosizeApi.ts
function $437b23f6a393c3bf$var$sizeColumnsToFit(beans, paramsOrGridWidth) {
    if (typeof paramsOrGridWidth === "number") beans.colAutosize?.sizeColumnsToFit(paramsOrGridWidth, "api");
    else beans.colAutosize?.sizeColumnsToFitGridBody(paramsOrGridWidth);
}
function $437b23f6a393c3bf$var$autoSizeColumns({ colAutosize: colAutosize, visibleCols: visibleCols }, keysOrParams, skipHeader) {
    if (Array.isArray(keysOrParams)) colAutosize?.autoSizeCols({
        colKeys: keysOrParams,
        skipHeader: skipHeader,
        source: "api"
    });
    else colAutosize?.autoSizeCols({
        ...keysOrParams,
        colKeys: keysOrParams.colIds ?? visibleCols.allCols,
        source: "api"
    });
}
function $437b23f6a393c3bf$var$autoSizeAllColumns(beans, paramsOrSkipHeader) {
    if (paramsOrSkipHeader && typeof paramsOrSkipHeader === "object") $437b23f6a393c3bf$var$autoSizeColumns(beans, paramsOrSkipHeader);
    else beans.colAutosize?.autoSizeAllColumns({
        source: "api",
        skipHeader: paramsOrSkipHeader
    });
}
// packages/ag-grid-community/src/columnAutosize/columnAutosizeService.ts
var $437b23f6a393c3bf$var$ColumnAutosizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colAutosize";
        this.timesDelayed = 0;
        /** when we're waiting for cell data types to be inferred, we need to defer column resizing */ this.shouldQueueResizeOperations = false;
        this.resizeOperationQueue = [];
    }
    postConstruct() {
        const { gos: gos } = this;
        const autoSizeStrategy = gos.get("autoSizeStrategy");
        if (autoSizeStrategy) {
            let shouldHideColumns = false;
            const type = autoSizeStrategy.type;
            if (type === "fitGridWidth" || type === "fitProvidedWidth") shouldHideColumns = true;
            else if (type === "fitCellContents") {
                this.addManagedEventListeners({
                    firstDataRendered: ()=>this.onFirstDataRendered(autoSizeStrategy)
                });
                const rowData = gos.get("rowData");
                shouldHideColumns = rowData != null && rowData.length > 0 && $437b23f6a393c3bf$export$9f182d9ca737e15(gos);
            }
            if (shouldHideColumns) this.beans.colDelayRenderSvc?.hideColumns(type);
        }
    }
    autoSizeCols(params) {
        const { eventSvc: eventSvc, visibleCols: visibleCols } = this.beans;
        this.innerAutoSizeCols(params).then((columnsAutoSized)=>{
            const dispatch = (cols)=>$437b23f6a393c3bf$var$dispatchColumnResizedEvent(eventSvc, Array.from(cols), true, "autosizeColumns");
            if (!params.scaleUpToFitGridWidth) return dispatch(columnsAutoSized);
            const availableGridWidth = $437b23f6a393c3bf$var$getAvailableWidth(this.beans);
            const isLeftCol = (col)=>visibleCols.leftCols.some((leftCol)=>$437b23f6a393c3bf$export$f5687d41c39fa1b3(leftCol, col));
            const isRightCol = (col)=>visibleCols.rightCols.some((rightCol)=>$437b23f6a393c3bf$export$f5687d41c39fa1b3(rightCol, col));
            const colKeys = params.colKeys.filter((col)=>!$437b23f6a393c3bf$export$f6074a9792015c5d(col) && !$437b23f6a393c3bf$export$3d3e7d751f0445eb(col) && !isLeftCol(col) && !isRightCol(col));
            this.sizeColumnsToFit(availableGridWidth, params.source, true, {
                defaultMaxWidth: params.defaultMaxWidth,
                defaultMinWidth: params.defaultMinWidth,
                columnLimits: params.columnLimits?.map((limit)=>({
                        ...limit,
                        key: limit.colId
                    })),
                colKeys: colKeys,
                onlyScaleUp: true
            });
            dispatch(columnsAutoSized);
        });
    }
    innerAutoSizeCols(params) {
        return new Promise((resolve, reject)=>{
            if (this.shouldQueueResizeOperations) return this.pushResizeOperation(()=>this.innerAutoSizeCols(params).then(resolve, reject));
            const { colKeys: colKeys, skipHeader: skipHeader, skipHeaderGroups: skipHeaderGroups, stopAtGroup: stopAtGroup, defaultMaxWidth: defaultMaxWidth, defaultMinWidth: defaultMinWidth, columnLimits: columnLimits = [], source: source = "api" } = params;
            const { animationFrameSvc: animationFrameSvc, renderStatus: renderStatus, colModel: colModel, autoWidthCalc: autoWidthCalc, visibleCols: visibleCols } = this.beans;
            animationFrameSvc?.flushAllFrames();
            if (this.timesDelayed < 5 && renderStatus && (!renderStatus.areHeaderCellsRendered() || !renderStatus.areCellsRendered())) {
                this.timesDelayed++;
                setTimeout(()=>{
                    if (this.isAlive()) this.innerAutoSizeCols(params).then(resolve, reject);
                });
                return;
            }
            this.timesDelayed = 0;
            const columnsAutoSized = /* @__PURE__ */ new Set();
            let changesThisTimeAround = -1;
            const columnLimitsIndex = Object.fromEntries(columnLimits.map(({ colId: colId, ...dimensions })=>[
                    colId,
                    dimensions
                ]));
            const shouldSkipHeader = skipHeader ?? this.gos.get("skipHeaderOnAutoSize");
            const shouldSkipHeaderGroups = skipHeaderGroups ?? shouldSkipHeader;
            while(changesThisTimeAround !== 0){
                changesThisTimeAround = 0;
                const updatedColumns = [];
                for (const key of colKeys){
                    if (!key || $437b23f6a393c3bf$export$ee97d5717f8d44ec(key)) continue;
                    const column = colModel.getCol(key);
                    if (!column || columnsAutoSized.has(column)) continue;
                    const preferredWidth = autoWidthCalc.getPreferredWidthForColumn(column, shouldSkipHeader);
                    if (preferredWidth > 0) {
                        const columnLimit = columnLimitsIndex[column.colId] ?? {};
                        columnLimit.minWidth ?? (columnLimit.minWidth = defaultMinWidth);
                        columnLimit.maxWidth ?? (columnLimit.maxWidth = defaultMaxWidth);
                        const newWidth = $437b23f6a393c3bf$var$normaliseColumnWidth(column, preferredWidth, columnLimit);
                        column.setActualWidth(newWidth, source);
                        columnsAutoSized.add(column);
                        changesThisTimeAround++;
                    }
                    updatedColumns.push(column);
                }
                if (updatedColumns.length) visibleCols.refresh(source);
            }
            if (!shouldSkipHeaderGroups) this.autoSizeColumnGroupsByColumns(colKeys, source, stopAtGroup);
            resolve(columnsAutoSized);
        });
    }
    autoSizeColumn(key, source, skipHeader) {
        this.autoSizeCols({
            colKeys: [
                key
            ],
            skipHeader: skipHeader,
            skipHeaderGroups: true,
            source: source
        });
    }
    autoSizeColumnGroupsByColumns(keys, source, stopAtGroup) {
        const { colModel: colModel, ctrlsSvc: ctrlsSvc } = this.beans;
        const columnGroups = /* @__PURE__ */ new Set();
        const columns = colModel.getColsForKeys(keys);
        for (const col of columns){
            let parent = col.getParent();
            while(parent && parent != stopAtGroup){
                if (!parent.isPadding()) columnGroups.add(parent);
                parent = parent.getParent();
            }
        }
        let headerGroupCtrl;
        for (const columnGroup of columnGroups){
            for (const headerContainerCtrl of ctrlsSvc.getHeaderRowContainerCtrls()){
                headerGroupCtrl = headerContainerCtrl.getHeaderCtrlForColumn(columnGroup);
                if (headerGroupCtrl) break;
            }
            headerGroupCtrl?.resizeLeafColumnsToFit(source);
        }
    }
    autoSizeAllColumns(params) {
        if (this.shouldQueueResizeOperations) {
            this.pushResizeOperation(()=>this.autoSizeAllColumns(params));
            return;
        }
        this.autoSizeCols({
            colKeys: this.beans.visibleCols.allCols,
            ...params
        });
    }
    addColumnAutosizeListeners(element, column) {
        const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
        const autoSizeColListener = ()=>{
            this.autoSizeColumn(column, "uiColumnResized", skipHeaderOnAutoSize);
        };
        element.addEventListener("dblclick", autoSizeColListener);
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(element);
        touchListener.addEventListener("doubleTap", autoSizeColListener);
        return ()=>{
            element.removeEventListener("dblclick", autoSizeColListener);
            touchListener.destroy();
        };
    }
    addColumnGroupResize(element, columnGroup, callback) {
        const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
        const listener = ()=>{
            const keys = [];
            const leafCols = columnGroup.getDisplayedLeafColumns();
            for (const column of leafCols)if (!column.getColDef().suppressAutoSize) keys.push(column.getColId());
            if (keys.length > 0) this.autoSizeCols({
                colKeys: keys,
                skipHeader: skipHeaderOnAutoSize,
                stopAtGroup: columnGroup,
                source: "uiColumnResized"
            });
            callback();
        };
        element.addEventListener("dblclick", listener);
        return ()=>element.removeEventListener("dblclick", listener);
    }
    // method will call itself if no available width. this covers if the grid
    // isn't visible, but is just about to be visible.
    sizeColumnsToFitGridBody(params, nextTimeout) {
        if (!this.isAlive()) return;
        const availableWidth = $437b23f6a393c3bf$var$getAvailableWidth(this.beans);
        if (availableWidth > 0) {
            this.sizeColumnsToFit(availableWidth, "sizeColumnsToFit", false, params);
            return;
        }
        if (nextTimeout === void 0) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, 100);
        }, 0);
        else if (nextTimeout === 100) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, 500);
        }, 100);
        else if (nextTimeout === 500) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, -1);
        }, 500);
        else $437b23f6a393c3bf$export$545083624300f13d(29);
    }
    // called from api
    sizeColumnsToFit(gridWidth, source = "sizeColumnsToFit", silent, params) {
        if (this.shouldQueueResizeOperations) {
            this.pushResizeOperation(()=>this.sizeColumnsToFit(gridWidth, source, silent, params));
            return;
        }
        const limitsMap = {};
        for (const { key: key, ...dimensions } of params?.columnLimits ?? [])limitsMap[typeof key === "string" ? key : key.getColId()] = dimensions;
        const allDisplayedColumns = this.beans.visibleCols.allCols;
        if (gridWidth <= 0 || !allDisplayedColumns.length) return;
        const currentTotalColumnWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(allDisplayedColumns);
        if (params?.onlyScaleUp && currentTotalColumnWidth > gridWidth) return;
        const doColumnsAlreadyFit = gridWidth === currentTotalColumnWidth;
        if (doColumnsAlreadyFit) {
            const doAllColumnsSatisfyConstraints = allDisplayedColumns.every((column)=>{
                if (column.colDef.suppressSizeToFit) return true;
                const widthOverride = limitsMap?.[column.getId()];
                const minWidth = widthOverride?.minWidth ?? params?.defaultMinWidth;
                const maxWidth = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
                const colWidth = column.getActualWidth();
                return (minWidth == null || colWidth >= minWidth) && (maxWidth == null || colWidth <= maxWidth);
            });
            if (doAllColumnsSatisfyConstraints) return;
        }
        const colsToSpread = [];
        const colsToNotSpread = [];
        for (const column of allDisplayedColumns){
            const isIncluded = params?.colKeys?.some((key)=>$437b23f6a393c3bf$export$f5687d41c39fa1b3(column, key)) ?? true;
            if (column.getColDef().suppressSizeToFit || !isIncluded) colsToNotSpread.push(column);
            else colsToSpread.push(column);
        }
        const colsToDispatchEventFor = colsToSpread.slice(0);
        let finishedResizing = false;
        const moveToNotSpread = (column)=>{
            $437b23f6a393c3bf$export$83a881c8b5120679(colsToSpread, column);
            colsToNotSpread.push(column);
        };
        for (const column of colsToSpread){
            column.resetActualWidth(source);
            const widthOverride = limitsMap?.[column.getId()];
            const minOverride = widthOverride?.minWidth ?? params?.defaultMinWidth;
            const maxOverride = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
            const colWidth = column.getActualWidth();
            if (typeof minOverride === "number" && colWidth < minOverride) column.setActualWidth(minOverride, source, true);
            else if (typeof maxOverride === "number" && colWidth > maxOverride) column.setActualWidth(maxOverride, source, true);
        }
        while(!finishedResizing){
            finishedResizing = true;
            const availablePixels = gridWidth - $437b23f6a393c3bf$var$getWidthOfColsInList(colsToNotSpread);
            if (availablePixels <= 0) for (const column of colsToSpread){
                const newWidth = limitsMap?.[column.getId()]?.minWidth ?? params?.defaultMinWidth ?? column.minWidth;
                column.setActualWidth(newWidth, source, true);
            }
            else {
                const scale = availablePixels / $437b23f6a393c3bf$var$getWidthOfColsInList(colsToSpread);
                let pixelsForLastCol = availablePixels;
                for(let i = colsToSpread.length - 1; i >= 0; i--){
                    const column = colsToSpread[i];
                    const widthOverride = limitsMap?.[column.getId()];
                    const minOverride = widthOverride?.minWidth ?? params?.defaultMinWidth;
                    const maxOverride = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
                    const colMinWidth = column.getMinWidth();
                    const colMaxWidth = column.getMaxWidth();
                    const minWidth = typeof minOverride === "number" && minOverride > colMinWidth ? minOverride : colMinWidth;
                    const maxWidth = typeof maxOverride === "number" && maxOverride < colMaxWidth ? maxOverride : colMaxWidth;
                    let newWidth = Math.round(column.getActualWidth() * scale);
                    if (newWidth < minWidth) {
                        newWidth = minWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (newWidth > maxWidth) {
                        newWidth = maxWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (i === 0) newWidth = pixelsForLastCol;
                    column.setActualWidth(newWidth, source, true);
                    pixelsForLastCol -= newWidth;
                }
            }
        }
        for (const col of colsToDispatchEventFor)col.fireColumnWidthChangedEvent(source);
        const visibleCols = this.beans.visibleCols;
        visibleCols.setLeftValues(source);
        visibleCols.updateBodyWidths();
        if (silent) return;
        $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, colsToDispatchEventFor, true, source);
    }
    applyAutosizeStrategy() {
        const { gos: gos, colDelayRenderSvc: colDelayRenderSvc } = this.beans;
        const autoSizeStrategy = gos.get("autoSizeStrategy");
        if (autoSizeStrategy?.type !== "fitGridWidth" && autoSizeStrategy?.type !== "fitProvidedWidth") return;
        setTimeout(()=>{
            if (!this.isAlive()) return;
            const type = autoSizeStrategy.type;
            if (type === "fitGridWidth") {
                const { columnLimits: propColumnLimits, defaultMinWidth: defaultMinWidth, defaultMaxWidth: defaultMaxWidth } = autoSizeStrategy;
                const columnLimits = propColumnLimits?.map(({ colId: key, minWidth: minWidth, maxWidth: maxWidth })=>({
                        key: key,
                        minWidth: minWidth,
                        maxWidth: maxWidth
                    }));
                this.sizeColumnsToFitGridBody({
                    defaultMinWidth: defaultMinWidth,
                    defaultMaxWidth: defaultMaxWidth,
                    columnLimits: columnLimits
                });
            } else if (type === "fitProvidedWidth") this.sizeColumnsToFit(autoSizeStrategy.width, "sizeColumnsToFit");
            colDelayRenderSvc?.revealColumns(type);
        });
    }
    onFirstDataRendered({ colIds: colKeys, ...params }) {
        setTimeout(()=>{
            if (!this.isAlive()) return;
            const source = "autosizeColumns";
            if (colKeys) this.autoSizeCols({
                ...params,
                source: source,
                colKeys: colKeys
            });
            else this.autoSizeAllColumns({
                ...params,
                source: source
            });
            this.beans.colDelayRenderSvc?.revealColumns(params.type);
        });
    }
    processResizeOperations() {
        this.shouldQueueResizeOperations = false;
        for (const resizeOperation of this.resizeOperationQueue)resizeOperation();
        this.resizeOperationQueue = [];
    }
    pushResizeOperation(func) {
        this.resizeOperationQueue.push(func);
    }
    destroy() {
        this.resizeOperationQueue.length = 0;
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$normaliseColumnWidth(column, newWidth, limits = {}) {
    const minWidth = limits.minWidth ?? column.getMinWidth();
    if (newWidth < minWidth) newWidth = minWidth;
    const maxWidth = limits.maxWidth ?? column.getMaxWidth();
    if (newWidth > maxWidth) newWidth = maxWidth;
    return newWidth;
}
function $437b23f6a393c3bf$var$getAvailableWidth({ ctrlsSvc: ctrlsSvc, scrollVisibleSvc: scrollVisibleSvc }) {
    const gridBodyCtrl = ctrlsSvc.getGridBodyCtrl();
    const removeScrollWidth = gridBodyCtrl.isVerticalScrollShowing();
    const scrollWidthToRemove = removeScrollWidth ? scrollVisibleSvc.getScrollbarWidth() : 0;
    const bodyViewportWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(gridBodyCtrl.eGridBody);
    return bodyViewportWidth - scrollWidthToRemove;
}
// packages/ag-grid-community/src/columnAutosize/columnAutosizeModule.ts
var $437b23f6a393c3bf$export$baf19ca56ec781d2 = {
    moduleName: "ColumnAutoSize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnAutosizeService
    ],
    apiFunctions: {
        sizeColumnsToFit: $437b23f6a393c3bf$var$sizeColumnsToFit,
        autoSizeColumns: $437b23f6a393c3bf$var$autoSizeColumns,
        autoSizeAllColumns: $437b23f6a393c3bf$var$autoSizeAllColumns
    },
    dependsOn: [
        $437b23f6a393c3bf$var$AutoWidthModule
    ]
};
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRow.css-GENERATED.ts
var $437b23f6a393c3bf$var$manualPinnedRowCSS = /*css*/ `.ag-row-pinned-source{background-color:var(--ag-pinned-source-row-background-color);color:var(--ag-pinned-source-row-text-color);font-weight:var(--ag-pinned-source-row-font-weight)}.ag-row-pinned-manual{background-color:var(--ag-pinned-row-background-color);color:var(--ag-pinned-row-text-color);font-weight:var(--ag-pinned-row-font-weight)}`;
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowApi.ts
function $437b23f6a393c3bf$var$getPinnedTopRowCount(beans) {
    return beans.pinnedRowModel?.getPinnedTopRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getPinnedBottomRowCount(beans) {
    return beans.pinnedRowModel?.getPinnedBottomRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getPinnedTopRow(beans, index) {
    return beans.pinnedRowModel?.getPinnedTopRow(index);
}
function $437b23f6a393c3bf$var$getPinnedBottomRow(beans, index) {
    return beans.pinnedRowModel?.getPinnedBottomRow(index);
}
function $437b23f6a393c3bf$var$forEachPinnedRow(beans, floating, callback) {
    return beans.pinnedRowModel?.forEachPinnedRow(floating, callback);
}
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowModule.ts
var $437b23f6a393c3bf$export$b6e84cdeabbb116a = {
    moduleName: "PinnedRow",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$export$d44126a5f53c99d9
    ],
    css: [
        $437b23f6a393c3bf$var$manualPinnedRowCSS
    ],
    apiFunctions: {
        getPinnedTopRowCount: $437b23f6a393c3bf$var$getPinnedTopRowCount,
        getPinnedBottomRowCount: $437b23f6a393c3bf$var$getPinnedBottomRowCount,
        getPinnedTopRow: $437b23f6a393c3bf$var$getPinnedTopRow,
        getPinnedBottomRow: $437b23f6a393c3bf$var$getPinnedBottomRow,
        forEachPinnedRow: $437b23f6a393c3bf$var$forEachPinnedRow
    },
    icons: {
        rowPin: "pin",
        rowPinTop: "pinned-top",
        rowPinBottom: "pinned-bottom",
        rowUnpin: "un-pin"
    }
};
// packages/ag-grid-community/src/rendering/spanning/rowSpanCache.ts
var $437b23f6a393c3bf$var$CellSpan = class {
    constructor(col, firstNode){
        this.col = col;
        this.firstNode = firstNode;
        // used for distinguishing between types
        this.cellSpan = true;
        this.spannedNodes = /* @__PURE__ */ new Set();
        this.addSpannedNode(firstNode);
    }
    /**
   * Reset the span leaving only the head.
   * Head is used as a comparison as this is the row used to render this cell
   * Even if the row data changes, the cell will properly reflect the correct value.
   */ reset() {
        this.spannedNodes.clear();
        this.addSpannedNode(this.firstNode);
    }
    addSpannedNode(node) {
        this.spannedNodes.add(node);
        this.lastNode = node;
    }
    getLastNode() {
        return this.lastNode;
    }
    getCellHeight() {
        return this.lastNode.rowTop + this.lastNode.rowHeight - this.firstNode.rowTop - 1;
    }
    doesSpanContain(cellPosition) {
        if (cellPosition.column !== this.col) return false;
        if (cellPosition.rowPinned != this.firstNode.rowPinned) return false;
        return this.firstNode.rowIndex <= cellPosition.rowIndex && cellPosition.rowIndex <= this.lastNode.rowIndex;
    }
    /**
   * Gets the auto height value for last node in the spanned cell.
   * The first node is used to store the auto height for the cell, but the additional height for this cell
   * needs applied to the last row in the span.
   */ getLastNodeAutoHeight() {
        const autoHeight = this.firstNode.__autoHeights?.[this.col.getColId()];
        if (autoHeight == null) return void 0;
        let allButLastHeights = 0;
        for (const node of this.spannedNodes){
            if (node === this.lastNode) continue;
            allButLastHeights += node.rowHeight;
        }
        return autoHeight - allButLastHeights;
    }
};
var $437b23f6a393c3bf$var$RowSpanCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column){
        super();
        this.column = column;
    }
    buildCache(pinned) {
        const { column: column, beans: { gos: gos, pinnedRowModel: pinnedRowModel, rowModel: rowModel, valueSvc: valueSvc, pagination: pagination } } = this;
        const { colDef: colDef } = column;
        const oldMap = this.getNodeMap(pinned);
        const newMap = /* @__PURE__ */ new Map();
        const isFullWidthCellFunc = gos.getCallback("isFullWidthRow");
        const equalsFnc = colDef.equals;
        const customCompare = colDef.spanRows;
        const isCustomCompare = typeof customCompare === "function";
        let lastNode = null;
        let spanData = null;
        let lastValue;
        const setNewHead = (node, value)=>{
            lastNode = node;
            spanData = null;
            lastValue = value;
        };
        const checkNodeForCache = (node)=>{
            const doesNodeSupportSpanning = !node.isExpandable() && !node.group && !node.detail && (isFullWidthCellFunc ? !isFullWidthCellFunc({
                rowNode: node
            }) : true);
            if (node.rowIndex == null || !doesNodeSupportSpanning) {
                setNewHead(null, null);
                return;
            }
            if (lastNode == null || node.level !== lastNode.level || // no span across groups
            node.footer || spanData && node.rowIndex - 1 !== spanData?.getLastNode().rowIndex) {
                setNewHead(node, valueSvc.getValue(column, node));
                return;
            }
            const value = valueSvc.getValue(column, node);
            if (isCustomCompare) {
                const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                    valueA: lastValue,
                    nodeA: lastNode,
                    valueB: value,
                    nodeB: node,
                    column: column,
                    colDef: colDef
                });
                if (!customCompare(params)) {
                    setNewHead(node, value);
                    return;
                }
            } else if (equalsFnc ? !equalsFnc(lastValue, value) : lastValue !== value) {
                setNewHead(node, value);
                return;
            }
            if (!spanData) {
                const oldSpan = oldMap?.get(lastNode);
                if (oldSpan?.firstNode === lastNode) {
                    oldSpan.reset();
                    spanData = oldSpan;
                } else spanData = new $437b23f6a393c3bf$var$CellSpan(column, lastNode);
                newMap.set(lastNode, spanData);
            }
            spanData.addSpannedNode(node);
            newMap.set(node, spanData);
        };
        switch(pinned){
            case "center":
                rowModel.forEachDisplayedNode?.((node)=>{
                    const isNodeInPage = !pagination || pagination.isRowInPage(node.rowIndex);
                    if (!isNodeInPage) return;
                    checkNodeForCache(node);
                });
                this.centerValueNodeMap = newMap;
                break;
            case "top":
                pinnedRowModel?.forEachPinnedRow("top", checkNodeForCache);
                this.topValueNodeMap = newMap;
                break;
            case "bottom":
                pinnedRowModel?.forEachPinnedRow("bottom", checkNodeForCache);
                this.bottomValueNodeMap = newMap;
                break;
        }
    }
    isCellSpanning(node) {
        return !!this.getCellSpan(node);
    }
    getCellSpan(node) {
        return this.getNodeMap(node.rowPinned).get(node);
    }
    getNodeMap(container) {
        switch(container){
            case "top":
                return this.topValueNodeMap;
            case "bottom":
                return this.bottomValueNodeMap;
            default:
                return this.centerValueNodeMap;
        }
    }
};
// packages/ag-grid-community/src/rendering/spanning/rowSpanService.ts
var $437b23f6a393c3bf$var$RowSpanService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowSpanSvc";
        this.spanningColumns = /* @__PURE__ */ new Map();
        // debounced to allow spannedRowRenderer to run first, removing any old spanned rows
        this.debouncePinnedEvent = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.dispatchCellsUpdatedEvent.bind(this, true), 0);
        this.debounceModelEvent = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.dispatchCellsUpdatedEvent.bind(this, false), 0);
        this.pinnedTimeout = null;
        this.modelTimeout = null;
    }
    postConstruct() {
        const onRowDataUpdated = this.onRowDataUpdated.bind(this);
        const buildPinnedCaches = this.buildPinnedCaches.bind(this);
        this.addManagedEventListeners({
            paginationChanged: this.buildModelCaches.bind(this),
            pinnedRowDataChanged: buildPinnedCaches,
            pinnedRowsChanged: buildPinnedCaches,
            rowNodeDataChanged: onRowDataUpdated,
            cellValueChanged: onRowDataUpdated
        });
    }
    /**
   * When a new column is created with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */ register(column) {
        const { gos: gos } = this.beans;
        if (!gos.get("enableCellSpan")) return;
        if (this.spanningColumns.has(column)) return;
        const cache = this.createManagedBean(new $437b23f6a393c3bf$var$RowSpanCache(column));
        this.spanningColumns.set(column, cache);
        cache.buildCache("top");
        cache.buildCache("bottom");
        cache.buildCache("center");
        this.debouncePinnedEvent();
        this.debounceModelEvent();
    }
    dispatchCellsUpdatedEvent(pinned) {
        this.dispatchLocalEvent({
            type: "spannedCellsUpdated",
            pinned: pinned
        });
    }
    /**
   * When a new column is destroyed with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */ deregister(column) {
        this.spanningColumns.delete(column);
    }
    // called when data changes, as this could be a hot path it's debounced
    // it uses timeouts instead of debounce so that it can be cancelled by `modelUpdated`
    // which is expected to run immediately (to exec before the rowRenderer)
    onRowDataUpdated({ node: node }) {
        const { spannedRowRenderer: spannedRowRenderer } = this.beans;
        if (node.rowPinned) {
            if (this.pinnedTimeout != null) return;
            this.pinnedTimeout = window.setTimeout(()=>{
                this.pinnedTimeout = null;
                this.buildPinnedCaches();
                spannedRowRenderer?.createCtrls("top");
                spannedRowRenderer?.createCtrls("bottom");
            }, 0);
            return;
        }
        if (this.modelTimeout != null) return;
        this.modelTimeout = window.setTimeout(()=>{
            this.modelTimeout = null;
            this.buildModelCaches();
            spannedRowRenderer?.createCtrls("center");
        }, 0);
    }
    buildModelCaches() {
        if (this.modelTimeout != null) clearTimeout(this.modelTimeout);
        this.spanningColumns.forEach((cache)=>cache.buildCache("center"));
        this.debounceModelEvent();
    }
    buildPinnedCaches() {
        if (this.pinnedTimeout != null) clearTimeout(this.pinnedTimeout);
        this.spanningColumns.forEach((cache)=>{
            cache.buildCache("top");
            cache.buildCache("bottom");
        });
        this.debouncePinnedEvent();
    }
    isCellSpanning(col, rowNode) {
        const cache = this.spanningColumns.get(col);
        if (!cache) return false;
        return cache.isCellSpanning(rowNode);
    }
    getCellSpanByPosition(position) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        const col = position.column;
        const index = position.rowIndex;
        const cache = this.spanningColumns.get(col);
        if (!cache) return void 0;
        let node;
        switch(position.rowPinned){
            case "top":
                node = pinnedRowModel?.getPinnedTopRow(index);
                break;
            case "bottom":
                node = pinnedRowModel?.getPinnedBottomRow(index);
                break;
            default:
                node = rowModel.getRow(index);
        }
        if (!node) return void 0;
        return cache.getCellSpan(node);
    }
    getCellStart(position) {
        const span = this.getCellSpanByPosition(position);
        if (!span) return position;
        return {
            ...position,
            rowIndex: span.firstNode.rowIndex
        };
    }
    getCellEnd(position) {
        const span = this.getCellSpanByPosition(position);
        if (!span) return position;
        return {
            ...position,
            rowIndex: span.getLastNode().rowIndex
        };
    }
    /**
   * Look-up a spanned cell given a col and node as position indicators
   *
   * @param col a column to lookup a span at this position
   * @param rowNode a node that may be spanned at this position
   * @returns the CellSpan object if one exists
   */ getCellSpan(col, rowNode) {
        const cache = this.spanningColumns.get(col);
        if (!cache) return void 0;
        return cache.getCellSpan(rowNode);
    }
    forEachSpannedColumn(rowNode, callback) {
        for (const [col, cache] of this.spanningColumns)if (cache.isCellSpanning(rowNode)) {
            const spanningNode = cache.getCellSpan(rowNode);
            callback(col, spanningNode);
        }
    }
    destroy() {
        super.destroy();
        this.spanningColumns.clear();
    }
};
// packages/ag-grid-community/src/rendering/spanning/spannedCellCtrl.ts
var $437b23f6a393c3bf$var$SpannedCellCtrl = class extends $437b23f6a393c3bf$var$CellCtrl {
    constructor(cellSpan, rowCtrl, beans){
        super(cellSpan.col, cellSpan.firstNode, beans, rowCtrl);
        this.cellSpan = cellSpan;
        this.SPANNED_CELL_CSS_CLASS = "ag-spanned-cell";
    }
    setComp(comp, eCell, eWrapper, eCellWrapper, printLayout, startEditing, compBean) {
        this.eWrapper = eWrapper;
        super.setComp(comp, eCell, eWrapper, eCellWrapper, printLayout, startEditing, compBean);
        this.setAriaRowSpan();
        this.refreshAriaRowIndex();
    }
    isCellSpanning() {
        return true;
    }
    getCellSpan() {
        return this.cellSpan;
    }
    /**
   * When cell is spanning, ensure row index is also available on the cell
   */ refreshAriaRowIndex() {
        const { eGui: eGui, rowNode: rowNode } = this;
        if (!eGui || rowNode.rowIndex == null) return;
        $437b23f6a393c3bf$export$ba731dedf9d88615(eGui, rowNode.rowIndex);
    }
    /**
   * When cell is spanning, ensure row index is also available on the cell
   */ setAriaRowSpan() {
        $437b23f6a393c3bf$var$_setAriaRowSpan(this.eGui, this.cellSpan.spannedNodes.size);
    }
    // not ideal, for tabbing need to force the focused position
    setFocusedCellPosition(cellPos) {
        this.focusedCellPosition = cellPos;
    }
    getFocusedCellPosition() {
        return this.focusedCellPosition ?? this.cellPosition;
    }
    checkCellFocused() {
        const focusedCell = this.beans.focusSvc.getFocusedCell();
        return !!focusedCell && this.cellSpan.doesSpanContain(focusedCell);
    }
    applyStaticCssClasses() {
        super.applyStaticCssClasses();
        this.comp.toggleCss(this.SPANNED_CELL_CSS_CLASS, true);
    }
    onCellFocused(event) {
        const { beans: beans } = this;
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(beans)) {
            this.focusedCellPosition = void 0;
            return;
        }
        const cellFocused = this.isCellFocused();
        if (!cellFocused) this.focusedCellPosition = void 0;
        if (event && cellFocused) this.focusedCellPosition = {
            rowIndex: event.rowIndex,
            rowPinned: event.rowPinned,
            column: event.column
        };
        super.onCellFocused(event);
    }
    getRootElement() {
        return this.eWrapper;
    }
};
// packages/ag-grid-community/src/rendering/spanning/spannedRowCtrl.ts
var $437b23f6a393c3bf$var$SpannedRowCtrl = class extends $437b23f6a393c3bf$var$RowCtrl {
    onRowIndexChanged() {
        super.onRowIndexChanged();
        for (const c of this.getAllCellCtrls())c.refreshAriaRowIndex();
    }
    getInitialRowClasses(_rowContainerType) {
        return [
            "ag-spanned-row"
        ];
    }
    getNewCellCtrl(col) {
        const cellSpan = this.beans.rowSpanSvc?.getCellSpan(col, this.rowNode);
        if (!cellSpan) return;
        const firstRowOfSpan = cellSpan.firstNode !== this.rowNode;
        if (firstRowOfSpan) return;
        return new $437b23f6a393c3bf$var$SpannedCellCtrl(cellSpan, this, this.beans);
    }
    isCorrectCtrlForSpan(cell) {
        const cellSpan = this.beans.rowSpanSvc?.getCellSpan(cell.column, this.rowNode);
        if (!cellSpan) return false;
        const firstRowOfSpan = cellSpan.firstNode !== this.rowNode;
        if (firstRowOfSpan) return false;
        return cell.getCellSpan() === cellSpan;
    }
    /**
   * Below overrides are explicitly disabling styling and other unwanted behaviours for spannedRowCtrl
   */ // row height should be 0 in spanned row - they're only included for purpose of aria
    onRowHeightChanged() {}
    // no styling spanned rows
    refreshFirstAndLastRowStyles() {}
    // no hover functionality for spanned rows
    addHoverFunctionality() {}
    resetHoveredStatus() {}
};
// packages/ag-grid-community/src/rendering/spanning/spannedRowRenderer.ts
var $437b23f6a393c3bf$var$SpannedRowRenderer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "spannedRowRenderer";
        this.topCtrls = /* @__PURE__ */ new Map();
        this.bottomCtrls = /* @__PURE__ */ new Map();
        this.centerCtrls = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        this.addManagedEventListeners({
            displayedRowsChanged: this.createAllCtrls.bind(this)
        });
    }
    createAllCtrls() {
        this.createCtrls("top");
        this.createCtrls("bottom");
        this.createCtrls("center");
    }
    /**
   * When displayed rows or cols change, the spanned cell ctrls need to update
   */ createCtrls(ctrlsKey) {
        const { rowSpanSvc: rowSpanSvc } = this.beans;
        const previousCtrls = this.getCtrlsMap(ctrlsKey);
        const previousCtrlsSize = previousCtrls.size;
        const rowCtrls = this.getAllRelevantRowControls(ctrlsKey);
        const newRowCtrls = /* @__PURE__ */ new Map();
        let hasNewSpans = false;
        for (const ctrl of rowCtrls){
            if (!ctrl.isAlive()) continue;
            rowSpanSvc?.forEachSpannedColumn(ctrl.rowNode, (col, cellSpan)=>{
                if (newRowCtrls.has(cellSpan.firstNode)) return;
                const existingCtrl = previousCtrls.get(cellSpan.firstNode);
                if (existingCtrl) {
                    newRowCtrls.set(cellSpan.firstNode, existingCtrl);
                    previousCtrls.delete(cellSpan.firstNode);
                    return;
                }
                hasNewSpans = true;
                const newCtrl = new $437b23f6a393c3bf$var$SpannedRowCtrl(cellSpan.firstNode, this.beans, false, false, false);
                newRowCtrls.set(cellSpan.firstNode, newCtrl);
            });
        }
        this.setCtrlsMap(ctrlsKey, newRowCtrls);
        const sameCount = newRowCtrls.size === previousCtrlsSize;
        if (!hasNewSpans && sameCount) return;
        for (const oldCtrl of previousCtrls.values()){
            oldCtrl.destroyFirstPass(true);
            oldCtrl.destroySecondPass();
        }
        this.dispatchLocalEvent({
            type: `spannedRowsUpdated`,
            ctrlsKey: ctrlsKey
        });
    }
    // cannot use getAllRowCtrls as it returns this services row ctrls.
    getAllRelevantRowControls(ctrlsKey) {
        const { rowRenderer: rowRenderer } = this.beans;
        switch(ctrlsKey){
            case "top":
                return rowRenderer.topRowCtrls;
            case "bottom":
                return rowRenderer.bottomRowCtrls;
            case "center":
                return rowRenderer.allRowCtrls;
        }
    }
    getCellByPosition(cellPosition) {
        const { rowSpanSvc: rowSpanSvc } = this.beans;
        const cellSpan = rowSpanSvc?.getCellSpanByPosition(cellPosition);
        if (!cellSpan) return void 0;
        const ctrl = this.getCtrlsMap(cellPosition.rowPinned).get(cellSpan.firstNode);
        if (!ctrl) return void 0;
        return ctrl.getAllCellCtrls().find((cellCtrl)=>cellCtrl.column === cellPosition.column);
    }
    getCtrls(container) {
        return [
            ...this.getCtrlsMap(container).values()
        ];
    }
    destroyRowCtrls(container) {
        for (const ctrl of this.getCtrlsMap(container).values()){
            ctrl.destroyFirstPass(true);
            ctrl.destroySecondPass();
        }
        this.setCtrlsMap(container, /* @__PURE__ */ new Map());
    }
    getCtrlsMap(container) {
        switch(container){
            case "top":
                return this.topCtrls;
            case "bottom":
                return this.bottomCtrls;
            default:
                return this.centerCtrls;
        }
    }
    setCtrlsMap(container, map) {
        switch(container){
            case "top":
                this.topCtrls = map;
                break;
            case "bottom":
                this.bottomCtrls = map;
                break;
            default:
                this.centerCtrls = map;
                break;
        }
    }
    destroy() {
        super.destroy();
        this.destroyRowCtrls("top");
        this.destroyRowCtrls("bottom");
        this.destroyRowCtrls("center");
    }
};
// packages/ag-grid-community/src/rendering/spanning/cellSpanModule.ts
var $437b23f6a393c3bf$export$b7ca1fc11bfe19c3 = {
    moduleName: "CellSpan",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowSpanService,
        $437b23f6a393c3bf$var$SpannedRowRenderer
    ]
};
// packages/ag-grid-community/src/styling/cellCustomStyleFeature.ts
var $437b23f6a393c3bf$var$CellCustomStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.staticClasses = [];
        this.beans = beans;
        this.column = cellCtrl.column;
    }
    setComp(comp) {
        this.cellComp = comp;
        this.applyUserStyles();
        this.applyCellClassRules();
        this.applyClassesFromColDef();
    }
    applyCellClassRules() {
        const { column: column, cellComp: cellComp } = this;
        const colDef = column.colDef;
        const cellClassRules = colDef.cellClassRules;
        const cellClassParams = this.getCellClassParams(column, colDef);
        $437b23f6a393c3bf$var$processClassRules(this.beans.expressionSvc, // if current was previous, skip
        cellClassRules === this.cellClassRules ? void 0 : this.cellClassRules, cellClassRules, cellClassParams, (className)=>cellComp.toggleCss(className, true), (className)=>cellComp.toggleCss(className, false));
        this.cellClassRules = cellClassRules;
    }
    applyUserStyles() {
        const column = this.column;
        const colDef = column.colDef;
        const cellStyle = colDef.cellStyle;
        if (!cellStyle) return;
        let styles;
        if (typeof cellStyle === "function") {
            const cellStyleParams = this.getCellClassParams(column, colDef);
            styles = cellStyle(cellStyleParams);
        } else styles = cellStyle;
        if (styles) this.cellComp.setUserStyles(styles);
    }
    applyClassesFromColDef() {
        const { column: column, cellComp: cellComp } = this;
        const colDef = column.colDef;
        const cellClassParams = this.getCellClassParams(column, colDef);
        for (const className of this.staticClasses)cellComp.toggleCss(className, false);
        const newStaticClasses = this.beans.cellStyles.getStaticCellClasses(colDef, cellClassParams);
        this.staticClasses = newStaticClasses;
        for (const className of newStaticClasses)cellComp.toggleCss(className, true);
    }
    getCellClassParams(column, colDef) {
        const { value: value, rowNode: rowNode } = this.cellCtrl;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.beans.gos, {
            value: value,
            data: rowNode.data,
            node: rowNode,
            colDef: colDef,
            column: column,
            rowIndex: rowNode.rowIndex
        });
    }
};
// packages/ag-grid-community/src/styling/cellStyleService.ts
var $437b23f6a393c3bf$var$CellStyleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellStyles";
    }
    processAllCellClasses(colDef, params, onApplicableClass, onNotApplicableClass) {
        $437b23f6a393c3bf$var$processClassRules(this.beans.expressionSvc, void 0, colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
        this.processStaticCellClasses(colDef, params, onApplicableClass);
    }
    getStaticCellClasses(colDef, params) {
        const { cellClass: cellClass } = colDef;
        if (!cellClass) return [];
        let classOrClasses;
        if (typeof cellClass === "function") {
            const cellClassFunc = cellClass;
            classOrClasses = cellClassFunc(params);
        } else classOrClasses = cellClass;
        if (typeof classOrClasses === "string") classOrClasses = [
            classOrClasses
        ];
        return classOrClasses || [];
    }
    createCellCustomStyleFeature(ctrl, beans) {
        return new $437b23f6a393c3bf$var$CellCustomStyleFeature(ctrl, beans);
    }
    processStaticCellClasses(colDef, params, onApplicableClass) {
        const classOrClasses = this.getStaticCellClasses(colDef, params);
        classOrClasses.forEach((cssClassItem)=>{
            onApplicableClass(cssClassItem);
        });
    }
};
// packages/ag-grid-community/src/styling/stylingModule.ts
var $437b23f6a393c3bf$export$be75c2ed74fb2144 = {
    moduleName: "CellStyle",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CellStyleService
    ]
};
var $437b23f6a393c3bf$export$dbb09c7a8266fd30 = {
    moduleName: "RowStyle",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowStyleService
    ]
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverApi.ts
function $437b23f6a393c3bf$var$isColumnHovered(beans, column) {
    return !!beans.colHover?.isHovered(column);
}
// packages/ag-grid-community/src/columns/columnHover/hoverFeature.ts
var $437b23f6a393c3bf$var$HoverFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columns, element){
        super();
        this.columns = columns;
        this.element = element;
        this.destroyManagedListeners = [];
        this.enableFeature = (enabled)=>{
            const { beans: beans, gos: gos, element: element, columns: columns } = this;
            const colHover = beans.colHover;
            const active = enabled ?? !!gos.get("columnHoverHighlight");
            if (active) this.destroyManagedListeners = this.addManagedElementListeners(element, {
                mouseover: colHover.setMouseOver.bind(colHover, columns),
                mouseout: colHover.clearMouseOver.bind(colHover)
            });
            else {
                for (const fn of this.destroyManagedListeners)fn();
                this.destroyManagedListeners = [];
            }
        };
    }
    postConstruct() {
        this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: currentValue })=>{
            this.enableFeature(currentValue);
        });
        this.enableFeature();
    }
    destroy() {
        super.destroy();
        this.destroyManagedListeners = null;
    }
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverService.ts
var $437b23f6a393c3bf$var$CSS_COLUMN_HOVER = "ag-column-hover";
var $437b23f6a393c3bf$var$ColumnHoverService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colHover";
    }
    postConstruct() {
        this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: currentValue })=>{
            if (!currentValue) this.clearMouseOver();
        });
    }
    setMouseOver(columns) {
        this.updateState(columns);
    }
    clearMouseOver() {
        this.updateState(null);
    }
    isHovered(column) {
        if (!this.gos.get("columnHoverHighlight")) return false;
        const selectedColumns = this.selectedColumns;
        return !!selectedColumns && selectedColumns.indexOf(column) >= 0;
    }
    addHeaderColumnHoverListener(compBean, comp, column) {
        const listener = ()=>{
            const isHovered = this.isHovered(column);
            comp.toggleCss("ag-column-hover", isHovered);
        };
        compBean.addManagedEventListeners({
            columnHoverChanged: listener
        });
        listener();
    }
    onCellColumnHover(column, cellComp) {
        if (!cellComp) return;
        const isHovered = this.isHovered(column);
        cellComp.toggleCss($437b23f6a393c3bf$var$CSS_COLUMN_HOVER, isHovered);
    }
    addHeaderFilterColumnHoverListener(compBean, comp, column, eGui) {
        this.createHoverFeature(compBean, [
            column
        ], eGui);
        const listener = ()=>{
            const hovered = this.isHovered(column);
            comp.toggleCss("ag-column-hover", hovered);
        };
        compBean.addManagedEventListeners({
            columnHoverChanged: listener
        });
        listener();
    }
    createHoverFeature(compBean, columns, eGui) {
        compBean.createManagedBean(new $437b23f6a393c3bf$var$HoverFeature(columns, eGui));
    }
    updateState(columns) {
        this.selectedColumns = columns;
        this.eventSvc.dispatchEvent({
            type: "columnHoverChanged"
        });
    }
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverModule.ts
var $437b23f6a393c3bf$export$ca683b579c0df457 = {
    moduleName: "ColumnHover",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnHoverService
    ],
    apiFunctions: {
        isColumnHovered: $437b23f6a393c3bf$var$isColumnHovered
    }
};
// packages/ag-grid-community/src/misc/apiEvents/apiEventService.ts
var $437b23f6a393c3bf$var$ApiEventService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "apiEventSvc";
        this.syncListeners = /* @__PURE__ */ new Map();
        this.asyncListeners = /* @__PURE__ */ new Map();
        this.syncGlobalListeners = /* @__PURE__ */ new Set();
        this.globalListenerPairs = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        this.wrapSvc = this.beans.frameworkOverrides.createGlobalEventListenerWrapper?.();
    }
    addListener(eventType, userListener) {
        const listener = this.wrapSvc?.wrap(eventType, userListener) ?? userListener;
        const async = !$437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType);
        const listeners = async ? this.asyncListeners : this.syncListeners;
        if (!listeners.has(eventType)) listeners.set(eventType, /* @__PURE__ */ new Set());
        listeners.get(eventType).add(listener);
        this.eventSvc.addListener(eventType, listener, async);
    }
    removeListener(eventType, userListener) {
        const listener = this.wrapSvc?.unwrap(eventType, userListener) ?? userListener;
        const asyncListeners = this.asyncListeners.get(eventType);
        const hasAsync = !!asyncListeners?.delete(listener);
        if (!hasAsync) this.syncListeners.get(eventType)?.delete(listener);
        this.eventSvc.removeListener(eventType, listener, hasAsync);
    }
    addGlobalListener(userListener) {
        const listener = this.wrapSvc?.wrapGlobal(userListener) ?? userListener;
        const syncListener = (eventType, event)=>{
            if ($437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType)) listener(eventType, event);
        };
        const asyncListener = (eventType, event)=>{
            if (!$437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType)) listener(eventType, event);
        };
        this.globalListenerPairs.set(userListener, {
            syncListener: syncListener,
            asyncListener: asyncListener
        });
        const eventSvc = this.eventSvc;
        eventSvc.addGlobalListener(syncListener, false);
        eventSvc.addGlobalListener(asyncListener, true);
    }
    removeGlobalListener(userListener) {
        const { eventSvc: eventSvc, wrapSvc: wrapSvc, globalListenerPairs: globalListenerPairs } = this;
        const listener = wrapSvc?.unwrapGlobal(userListener) ?? userListener;
        const hasAsync = globalListenerPairs.has(listener);
        if (hasAsync) {
            const { syncListener: syncListener, asyncListener: asyncListener } = globalListenerPairs.get(listener);
            eventSvc.removeGlobalListener(syncListener, false);
            eventSvc.removeGlobalListener(asyncListener, true);
            globalListenerPairs.delete(userListener);
        } else {
            this.syncGlobalListeners.delete(listener);
            eventSvc.removeGlobalListener(listener, false);
        }
    }
    destroyEventListeners(map, async) {
        map.forEach((listeners, eventType)=>{
            listeners.forEach((listener)=>this.eventSvc.removeListener(eventType, listener, async));
            listeners.clear();
        });
        map.clear();
    }
    destroyGlobalListeners(set, async) {
        for (const listener of set)this.eventSvc.removeGlobalListener(listener, async);
        set.clear();
    }
    destroy() {
        super.destroy();
        this.destroyEventListeners(this.syncListeners, false);
        this.destroyEventListeners(this.asyncListeners, true);
        this.destroyGlobalListeners(this.syncGlobalListeners, false);
        const { globalListenerPairs: globalListenerPairs, eventSvc: eventSvc } = this;
        globalListenerPairs.forEach(({ syncListener: syncListener, asyncListener: asyncListener })=>{
            eventSvc.removeGlobalListener(syncListener, false);
            eventSvc.removeGlobalListener(asyncListener, true);
        });
        globalListenerPairs.clear();
    }
};
// packages/ag-grid-community/src/misc/apiEvents/eventApi.ts
function $437b23f6a393c3bf$var$addEventListener(beans, eventType, listener) {
    beans.apiEventSvc?.addListener(eventType, listener);
}
function $437b23f6a393c3bf$var$removeEventListener(beans, eventType, listener) {
    beans.apiEventSvc?.removeListener(eventType, listener);
}
function $437b23f6a393c3bf$var$addGlobalListener(beans, listener) {
    beans.apiEventSvc?.addGlobalListener(listener);
}
function $437b23f6a393c3bf$var$removeGlobalListener(beans, listener) {
    beans.apiEventSvc?.removeGlobalListener(listener);
}
// packages/ag-grid-community/src/misc/apiEvents/apiEventModule.ts
var $437b23f6a393c3bf$export$d20c5df25778eac8 = {
    moduleName: "EventApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        addEventListener: $437b23f6a393c3bf$var$addEventListener,
        addGlobalListener: $437b23f6a393c3bf$var$addGlobalListener,
        removeEventListener: $437b23f6a393c3bf$var$removeEventListener,
        removeGlobalListener: $437b23f6a393c3bf$var$removeGlobalListener
    },
    beans: [
        $437b23f6a393c3bf$var$ApiEventService
    ]
};
// packages/ag-grid-community/src/misc/locale/localeModule.ts
var $437b23f6a393c3bf$export$77471a542fe056d = {
    moduleName: "Locale",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$export$f325e19d05d9c36d
    ]
};
// packages/ag-grid-community/src/rendering/row/rowAutoHeightService.ts
var $437b23f6a393c3bf$var$RowAutoHeightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowAutoHeight";
        this.wasEverActive = false;
        this._debouncedCalculateRowHeights = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.calculateRowHeights.bind(this), 1);
    }
    /**
   * If row height has been active, request a refresh of the row heights.
   */ requestCheckAutoHeight() {
        if (!this.wasEverActive) return;
        this._debouncedCalculateRowHeights();
    }
    calculateRowHeights() {
        const { visibleCols: visibleCols, rowModel: rowModel, rowSpanSvc: rowSpanSvc, pinnedRowModel: pinnedRowModel } = this.beans;
        const displayedAutoHeightCols = visibleCols.autoHeightCols;
        let anyNodeChanged = false;
        const updateDisplayedRowHeights = (row)=>{
            const autoHeights = row.__autoHeights;
            let newRowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, row).height;
            for (const col of displayedAutoHeightCols){
                let cellHeight = autoHeights?.[col.getColId()];
                const spannedCell = rowSpanSvc?.getCellSpan(col, row);
                if (spannedCell) {
                    if (spannedCell.getLastNode() !== row) continue;
                    cellHeight = rowSpanSvc?.getCellSpan(col, row)?.getLastNodeAutoHeight();
                    if (!cellHeight) return;
                }
                if (cellHeight == null) {
                    if (this.colSpanSkipCell(col, row)) continue;
                    return;
                }
                newRowHeight = Math.max(cellHeight, newRowHeight);
            }
            if (newRowHeight !== row.rowHeight) {
                row.setRowHeight(newRowHeight);
                anyNodeChanged = true;
            }
        };
        pinnedRowModel?.forEachPinnedRow?.("top", updateDisplayedRowHeights);
        pinnedRowModel?.forEachPinnedRow?.("bottom", updateDisplayedRowHeights);
        rowModel.forEachDisplayedNode?.(updateDisplayedRowHeights);
        if (anyNodeChanged) rowModel.onRowHeightChanged?.();
    }
    /**
   * Set the cell height into the row node, and request a refresh of the row heights if there's been a change.
   * @param rowNode the node to set the auto height on
   * @param cellHeight the height to set, undefined if the cell has just been destroyed
   * @param column the column of the cell
   */ setRowAutoHeight(rowNode, cellHeight, column) {
        rowNode.__autoHeights ?? (rowNode.__autoHeights = {});
        if (cellHeight == void 0) {
            delete rowNode.__autoHeights[column.getId()];
            return;
        }
        const previousCellHeight = rowNode.__autoHeights[column.getId()];
        rowNode.__autoHeights[column.getId()] = cellHeight;
        if (previousCellHeight !== cellHeight) this.requestCheckAutoHeight();
    }
    /**
   * If using col span, then cells which have been spanned over do not need an auto height value
   * @param col the column of the cell
   * @param node the node of the cell
   * @returns whether the row needs auto height value for that column
   */ colSpanSkipCell(col, node) {
        const { colModel: colModel, colViewport: colViewport, visibleCols: visibleCols } = this.beans;
        if (!colModel.colSpanActive) return false;
        let activeColsForRow = [];
        switch(col.getPinned()){
            case "left":
                activeColsForRow = visibleCols.getLeftColsForRow(node);
                break;
            case "right":
                activeColsForRow = visibleCols.getRightColsForRow(node);
                break;
            case null:
                activeColsForRow = colViewport.getColsWithinViewport(node);
                break;
        }
        return !activeColsForRow.includes(col);
    }
    /**
   * If required, sets up observers to continuously measure changes in the cell height.
   * @param cellCtrl the cellCtrl of the cell
   * @param eCellWrapper the HTMLElement to track the height of
   * @param compBean the component bean to add the destroy/cleanup function to
   * @returns whether or not auto height has been set up on this cell
   */ setupCellAutoHeight(cellCtrl, eCellWrapper, compBean) {
        if (!cellCtrl.column.isAutoHeight() || !eCellWrapper) return false;
        this.wasEverActive = true;
        const eParentCell = eCellWrapper.parentElement;
        const { rowNode: rowNode, column: column } = cellCtrl;
        const beans = this.beans;
        const measureHeight = (timesCalled)=>{
            if (this.beans.editSvc?.isEditing(cellCtrl)) return;
            if (!cellCtrl.isAlive() || !compBean.isAlive()) return;
            const { paddingTop: paddingTop, paddingBottom: paddingBottom, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth } = $437b23f6a393c3bf$var$_getElementSize(eParentCell);
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = eCellWrapper.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
                const notYetInDom = !doc?.contains(eCellWrapper);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    window.setTimeout(()=>measureHeight(timesCalled + 1), 0);
                    return;
                }
            }
            this.setRowAutoHeight(rowNode, autoHeight, column);
        };
        const listener = ()=>measureHeight(0);
        listener();
        const destroyResizeObserver = $437b23f6a393c3bf$export$9aef8476630687be(beans, eCellWrapper, listener);
        compBean.addDestroyFunc(()=>{
            destroyResizeObserver();
            this.setRowAutoHeight(rowNode, void 0, column);
        });
        return true;
    }
    setAutoHeightActive(cols) {
        this.active = cols.list.some((col)=>col.isVisible() && col.isAutoHeight());
    }
    /**
   * Determines if the row auto height service has cells to grow.
   * @returns true if all of the rendered rows are at least as tall as their rendered cells.
   */ areRowsMeasured() {
        if (!this.active) return true;
        const rowCtrls = this.beans.rowRenderer.getAllRowCtrls();
        let renderedAutoHeightCols = null;
        for (const { rowNode: rowNode } of rowCtrls){
            if (!renderedAutoHeightCols || this.beans.colModel.colSpanActive) {
                const renderedCols = this.beans.colViewport.getColsWithinViewport(rowNode);
                renderedAutoHeightCols = renderedCols.filter((col)=>col.isAutoHeight());
            }
            if (renderedAutoHeightCols.length === 0) continue;
            if (!rowNode.__autoHeights) return false;
            for (const col of renderedAutoHeightCols){
                const cellHeight = rowNode.__autoHeights[col.getColId()];
                if (!cellHeight || rowNode.rowHeight < cellHeight) return false;
            }
        }
        return true;
    }
};
// packages/ag-grid-community/src/rendering/row/rowAutoHeightModule.ts
var $437b23f6a393c3bf$export$dd3171a7609a981f = {
    moduleName: "RowAutoHeight",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowAutoHeightService
    ]
};
// packages/ag-grid-community/src/allCommunityModule.ts
var $437b23f6a393c3bf$export$526323caf9d1af13 = {
    moduleName: "AllCommunity",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$4c74201d5a94c8e5,
        $437b23f6a393c3bf$export$f744275d8b795fc2,
        $437b23f6a393c3bf$export$ca8341149bdd39bc,
        $437b23f6a393c3bf$export$798770a8f68ba4e7,
        $437b23f6a393c3bf$export$5e6636bea954ad4e,
        $437b23f6a393c3bf$export$9bc83f811986c4f2,
        $437b23f6a393c3bf$export$d1dd3475f4d98a27,
        $437b23f6a393c3bf$export$b6d3a45586965934,
        $437b23f6a393c3bf$export$ccaa44b10c75f1d,
        $437b23f6a393c3bf$export$e1b6b5aa47694f20,
        $437b23f6a393c3bf$export$e1d2707568ed81f6,
        $437b23f6a393c3bf$export$2bb59c6ee8834731,
        $437b23f6a393c3bf$export$5ce3e57cec1fecc9,
        $437b23f6a393c3bf$export$aabcd4399b0469bb,
        $437b23f6a393c3bf$export$2a2721fe06c4c013,
        $437b23f6a393c3bf$export$c992812899d813d0,
        $437b23f6a393c3bf$export$7e8079ed742f8307,
        $437b23f6a393c3bf$export$fc403e59f6fc67b,
        $437b23f6a393c3bf$export$3402149dbbda9537,
        $437b23f6a393c3bf$export$a8c763073927f695,
        $437b23f6a393c3bf$export$a57c5ed18afb0c4,
        $437b23f6a393c3bf$export$5c4abee658e86c68,
        $437b23f6a393c3bf$export$12e9d7df2a270583,
        $437b23f6a393c3bf$export$351f260d7f887abc,
        $437b23f6a393c3bf$export$b67b27f72da743ce,
        $437b23f6a393c3bf$export$baf19ca56ec781d2,
        $437b23f6a393c3bf$export$49c914873cdbe391,
        $437b23f6a393c3bf$export$b6e84cdeabbb116a,
        $437b23f6a393c3bf$export$dae0b5c1ba15d66f,
        $437b23f6a393c3bf$export$3110fedd6be63d8e,
        $437b23f6a393c3bf$export$be75c2ed74fb2144,
        $437b23f6a393c3bf$export$ca683b579c0df457,
        $437b23f6a393c3bf$export$dbb09c7a8266fd30,
        $437b23f6a393c3bf$export$d20c5df25778eac8,
        $437b23f6a393c3bf$export$d7a9d7f5c41fb970,
        $437b23f6a393c3bf$export$98e8472b11750a07,
        $437b23f6a393c3bf$export$d0c662c133b8814e,
        $437b23f6a393c3bf$export$77471a542fe056d,
        $437b23f6a393c3bf$export$dd3171a7609a981f,
        $437b23f6a393c3bf$export$b9bac28848e60126,
        $437b23f6a393c3bf$export$15323dcce1401b05,
        $437b23f6a393c3bf$export$b7ca1fc11bfe19c3
    ]
};
// packages/ag-grid-community/src/testing/testIdUtils.ts
function $437b23f6a393c3bf$var$formatTestId(name, attributes = {}) {
    const params = Object.keys(attributes).map((k)=>{
        const v = attributes[k];
        return v != null ? `${k}=${v}` : null;
    }).filter(Boolean).join(";");
    return [
        name,
        params
    ].filter((s)=>s.length > 0).join(":");
}
var $437b23f6a393c3bf$export$11b44e0a72aa6bc3 = {
    grid (gridId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-grid-root", {
            gridId: gridId
        });
    },
    /** Headers */ headerGroupCell (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-group-cell", {
            colId: colId
        });
    },
    headerCell (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell", {
            colId: colId
        });
    },
    headerCheckbox (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-selection-checkbox", {
            colId: colId
        });
    },
    headerFilterButton (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell-filter-button", {
            colId: colId
        });
    },
    floatingFilter (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-floating-filter", {
            colId: colId
        });
    },
    floatingFilterButton (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-floating-filter-button", {
            colId: colId
        });
    },
    headerCellMenuButton (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell-menu-button", {
            colId: colId
        });
    },
    headerResizeHandle (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell-resize", {
            colId: colId
        });
    },
    /** Column Filters */ filterInstancePickerDisplay (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-picker-display`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    numberFilterInstanceInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-number-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    textFilterInstanceInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-text-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    dateFilterInstanceInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-date-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    setFilterInstanceMiniFilterInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-set-filter-mini-filter-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    setFilterInstanceItem (spec, itemLabel) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-set-filter-item`, spec.source === "filter-toolpanel" ? {
            colLabel: spec.colLabel,
            itemLabel: itemLabel
        } : {
            colId: spec.colId,
            itemLabel: itemLabel
        });
    },
    setFilterApplyPanelButton (spec, buttonLabel) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-set-filter-apply-panel-button`, spec.source === "filter-toolpanel" ? {
            colLabel: spec.colLabel,
            buttonLabel: buttonLabel
        } : {
            colId: spec.colId,
            buttonLabel: buttonLabel
        });
    },
    filterConditionRadioButton (spec, buttonLabel) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-filter-condition-radio-button`, spec.source === "filter-toolpanel" ? {
            colLabel: spec.colLabel,
            buttonLabel: buttonLabel
        } : {
            colId: spec.colId,
            buttonLabel: buttonLabel
        });
    },
    /** Advanced Filter */ advancedFilterInput () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-input");
    },
    advancedFilterButton (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-button", {
            label: label
        });
    },
    advancedFilterBuilderButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-button");
    },
    advancedFilterPanelMaximiseButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-panel-maximise");
    },
    advancedFilterPanelCloseButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-panel-close");
    },
    advancedFilterPill (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-pill", {
            label: label
        });
    },
    advancedFilterBuilderAddItemButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-add-item-button");
    },
    /** Rows */ rowNode (rowId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-row", {
            ["row-id"]: rowId
        });
    },
    /** Cells */ cell (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-cell", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    autoGroupCell (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.cell(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    checkbox (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-selection-checkbox", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    selectionColumnCheckbox (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.checkbox(rowId, $437b23f6a393c3bf$export$dd05e5f089eb2421);
    },
    autoGroupColumnCheckbox (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.checkbox(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    dragHandle (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-drag-handle", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    groupContracted (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-group-contracted", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    groupExpanded (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-group-expanded", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    autoGroupContracted (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupContracted(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    autoGroupExpanded (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupExpanded(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    rowNumber (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.cell(rowId, $437b23f6a393c3bf$export$f55c01dfb205b029);
    },
    /** Menu */ menu () {
        return $437b23f6a393c3bf$var$formatTestId("ag-menu");
    },
    menuOption (option) {
        return $437b23f6a393c3bf$var$formatTestId("ag-menu-option", {
            ["option"]: option
        });
    },
    /** SideBar */ sideBar () {
        return $437b23f6a393c3bf$var$formatTestId("ag-side-bar");
    },
    sideBarButton (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-side-button", {
            label: label
        });
    },
    /** Column Tool Panel */ columnToolPanel () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-panel");
    },
    pivotModeSelect () {
        return $437b23f6a393c3bf$var$formatTestId("ag-pivot-mode-select");
    },
    columnPanelSelectHeaderCheckbox () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-panel-select-header-checkbox");
    },
    columnPanelSelectHeaderFilter () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-panel-select-header-filter");
    },
    columnSelectListItemGroupClosedIcon (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-select-list-item-group-closed-icon", {
            label: label
        });
    },
    columnSelectListItemCheckbox (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-select-list-item-checkbox", {
            label: label
        });
    },
    columnSelectListItemDragHandle (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-select-list-item-drag-handle", {
            label: label
        });
    },
    columnDropCellDragHandle (source, area, label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-drop-cell-drag-handle", {
            source: source,
            area: area,
            label: label
        });
    },
    columnDropCellCancelButton (source, area, label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-drop-cell-cancel", {
            source: source,
            area: area,
            label: label
        });
    },
    columnDropArea (source, name) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-drop-area", {
            source: source,
            name: name
        });
    },
    /** Filter Tool Panel (New) */ filterToolPanel () {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-panel");
    },
    filterToolPanelAddFilterButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-panel-add-filter-button");
    },
    filterToolPanelFilterTypeSelector (colLabel) {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-panel-filter-type-selector", {
            colLabel: colLabel
        });
    },
    /** Filter Tool Panel (Old) */ filterToolPanelSearchInput () {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-toolpanel-search-input");
    },
    filterToolPanelGroup (title) {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-toolpanel-group", {
            title: title
        });
    },
    filterToolPanelGroupCollapsedIcon (title) {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-toolpanel-group-collapsed-icon", {
            title: title
        });
    },
    /** Status Bar */ statusBarTotalAndFilteredRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-total-and-filtered-row-count");
    },
    statusBarTotalRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-total-row-count");
    },
    statusBarFilteredRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-filtered-row-count");
    },
    statusBarSelectedRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-selected-row-count");
    },
    statusBarAggregations () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-aggregations");
    },
    /** Pagination */ paginationPanelSizePickerDisplay (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-pagination-page-size-picker-field-display", {
            value: value
        });
    },
    paginationPanelFirstRowOnPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-row-summary-panel-first-row-on-page", {
            value: value
        });
    },
    paginationPanelLastRowOnPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-row-summary-panel-last-row-on-page", {
            value: value
        });
    },
    paginationPanelRecordCount (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-row-summary-panel-record-count", {
            value: value
        });
    },
    paginationSummaryPanelButton (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-page-summary-panel-btn", {
            label: label
        });
    },
    paginationSummaryPanelCurrentPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-page-summary-panel-current-page", {
            value: value
        });
    },
    paginationSummaryPanelTotalPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-page-summary-panel-total-page", {
            value: value
        });
    },
    /** Fill Handle */ fillHandle () {
        return $437b23f6a393c3bf$var$formatTestId("ag-fill-handle");
    },
    /** Column Chooser */ columnChooserCloseButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-close-button");
    },
    columnChooserSearchBarCheckbox () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-header-checkbox");
    },
    columnChooserSearchBarFilter () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-searchbar-filter");
    },
    columnChooserListItemGroupClosedIcon (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-list-item-group-closed-icon", {
            label: label
        });
    },
    columnChooserListItemCheckbox (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-list-item-checkbox", {
            label: label
        });
    },
    columnChooserListItemDragHandle (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-list-item-drag-handle", {
            label: label
        });
    },
    /** Overlay */ overlay () {
        return $437b23f6a393c3bf$var$formatTestId("ag-overlay");
    }
};
var $437b23f6a393c3bf$export$387ead18f69f83ca = (fn)=>{
    const locators = {};
    const keys = Object.keys($437b23f6a393c3bf$export$11b44e0a72aa6bc3);
    for (const k of keys)locators[k] = (...args)=>{
        return fn($437b23f6a393c3bf$export$11b44e0a72aa6bc3[k](...args));
    };
    return locators;
};
// packages/ag-grid-community/src/testing/testIdService.ts
var $437b23f6a393c3bf$var$TEST_ID_ATTR = "data-testid";
function $437b23f6a393c3bf$var$setTestId(element, testId) {
    element?.setAttribute($437b23f6a393c3bf$var$TEST_ID_ATTR, testId);
}
function $437b23f6a393c3bf$var$setTestIdAttribute(attr) {
    $437b23f6a393c3bf$var$TEST_ID_ATTR = attr;
}
var $437b23f6a393c3bf$var$TestIdService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "testIdSvc";
    }
    postConstruct() {
        const delayedDebounce = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.setupAllTestIds(), 500);
        const setup = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>{
            this.setupAllTestIds();
            delayedDebounce();
        }, 0);
        this.addManagedEventListeners({
            firstDataRendered: setup,
            displayedRowsChanged: setup,
            displayedColumnsChanged: setup,
            displayedColumnsWidthChanged: setup,
            virtualColumnsChanged: setup,
            columnMenuVisibleChanged: setup,
            contextMenuVisibleChanged: setup,
            advancedFilterBuilderVisibleChanged: setup,
            fieldPickerValueSelected: setup,
            modelUpdated: setup,
            sideBarUpdated: setup,
            pinnedHeightChanged: setup,
            gridReady: setup,
            overlayExclusiveChanged: setup,
            rowGroupOpened: setup,
            scrollVisibilityChanged: setup,
            gridSizeChanged: setup,
            filterOpened: setup,
            filterChanged: setup,
            cellSelectionChanged: setup
        });
    }
    setupAllTestIds() {
        const root = $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans);
        const gridId = $437b23f6a393c3bf$var$getGridId(this.beans);
        const gridWrapper = root.querySelector(`[grid-id="${gridId}"]`);
        $437b23f6a393c3bf$var$setTestId(gridWrapper, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.grid(gridId));
        root.querySelectorAll(".ag-header-group-cell").forEach((groupCell)=>{
            $437b23f6a393c3bf$var$setTestId(groupCell, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerGroupCell(groupCell.getAttribute("col-id")));
        });
        root.querySelectorAll(".ag-header-cell").forEach((cell)=>{
            const colId = cell.getAttribute("col-id");
            const isFloatingFilter = cell.classList.contains("ag-floating-filter");
            const headerCellId = isFloatingFilter ? $437b23f6a393c3bf$export$11b44e0a72aa6bc3.floatingFilter(colId) : $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerCell(colId);
            $437b23f6a393c3bf$var$setTestId(cell, headerCellId);
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-header-cell-filter-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerFilterButton(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-header-cell-menu-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerCellMenuButton(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-header-cell-resize"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerResizeHandle(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerCheckbox(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-floating-filter-button button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.floatingFilterButton(colId));
            this.setupFilterInstance(cell.querySelector(".ag-floating-filter-body"), {
                source: "floating-filter",
                colId: colId
            });
        });
        const filterMenu = root.querySelector(".ag-filter-menu");
        this.setupFilterInstance(filterMenu, {
            source: "column-filter"
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-advanced-filter input[type=text]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterInput());
        root.querySelectorAll(".ag-advanced-filter-buttons button").forEach((button)=>{
            $437b23f6a393c3bf$var$setTestId(button, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterButton(button.textContent));
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector("button.ag-advanced-filter-builder-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterBuilderButton());
        root.querySelectorAll('.ag-panel[aria-label="Advanced Filter"] .ag-panel-title-bar-button').forEach((button, i)=>{
            $437b23f6a393c3bf$var$setTestId(button, i === 0 ? $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterPanelMaximiseButton() : $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterPanelCloseButton());
        });
        root.querySelectorAll('.ag-panel[aria-lable="Advanced Filter"] .ag-advanced-filter-builder-pill').forEach((pill)=>{
            $437b23f6a393c3bf$var$setTestId(pill, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterPill(pill.querySelector(".ag-picker-field-display")?.textContent));
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector('.ag-panel[aria-label="Advanced Filter"] .ag-advanced-filter-builder-item-button'), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterBuilderAddItemButton());
        root.querySelectorAll(".ag-row").forEach((row)=>{
            const rowId = row.getAttribute("row-id");
            $437b23f6a393c3bf$var$setTestId(row, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.rowNode(rowId));
            row.querySelectorAll(".ag-cell").forEach((cell)=>{
                const colId = cell.getAttribute("col-id");
                $437b23f6a393c3bf$var$setTestId(cell, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.cell(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-selection-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.checkbox(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.dragHandle(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-group-contracted"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupContracted(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-group-expanded"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupExpanded(rowId, colId));
            });
        });
        root.querySelectorAll(".ag-menu-list").forEach((menu)=>{
            $437b23f6a393c3bf$var$setTestId(menu, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.menu());
            menu.querySelectorAll(".ag-menu-option").forEach((option)=>{
                $437b23f6a393c3bf$var$setTestId(option, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.menuOption(option.querySelector(".ag-menu-option-text")?.textContent));
            });
        });
        root.querySelectorAll(".ag-side-bar").forEach((sideBar)=>{
            $437b23f6a393c3bf$var$setTestId(sideBar, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.sideBar());
            sideBar.querySelectorAll(".ag-side-button button").forEach((button)=>{
                $437b23f6a393c3bf$var$setTestId(button, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.sideBarButton(button.querySelector(".ag-side-button-label")?.textContent));
            });
            sideBar.querySelectorAll(".ag-column-panel").forEach((panel)=>{
                $437b23f6a393c3bf$var$setTestId(panel, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnToolPanel());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-pivot-mode-select input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.pivotModeSelect());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-column-select-header-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnPanelSelectHeaderCheckbox());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-column-select-header-filter-wrapper input[type=text]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnPanelSelectHeaderFilter());
                panel.querySelectorAll(".ag-column-select-list").forEach((list)=>{
                    list.querySelectorAll(".ag-column-select-virtual-list-item").forEach((item)=>{
                        const label = item.getAttribute("aria-label");
                        $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-group-closed-icon"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnSelectListItemGroupClosedIcon(label));
                        $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-select-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnSelectListItemCheckbox(label));
                        $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnSelectListItemDragHandle(label));
                    });
                });
                this.setupColumnDropArea(panel, "toolbar");
            });
            sideBar.querySelectorAll(".ag-filter-panel").forEach((panel)=>{
                $437b23f6a393c3bf$var$setTestId(panel, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanel());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector("button.ag-filter-add-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelAddFilterButton());
                panel.querySelectorAll(".ag-filter-card").forEach((filterCard)=>{
                    const colLabel = filterCard.querySelector(".ag-filter-card-title")?.textContent;
                    const typeSelector = filterCard.querySelector(".ag-filter-type-select");
                    $437b23f6a393c3bf$var$setTestId(typeSelector, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelFilterTypeSelector(colLabel));
                    filterCard.querySelectorAll(".ag-filter").forEach((filter)=>this.setupFilterInstance(filter, {
                            source: "filter-toolpanel",
                            colLabel: colLabel
                        }));
                });
            });
            sideBar.querySelectorAll(".ag-filter-toolpanel").forEach((panel)=>{
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-filter-toolpanel-search-input input[type=text]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelSearchInput());
                panel.querySelectorAll(".ag-filter-toolpanel-group").forEach((group)=>{
                    const title = group.querySelector(".ag-filter-toolpanel-group-title")?.textContent;
                    $437b23f6a393c3bf$var$setTestId(group, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelGroup(title));
                    $437b23f6a393c3bf$var$setTestId(group.querySelector(".ag-filter-toolpanel-group-title-bar-icon .ag-icon-tree-closed"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelGroupCollapsedIcon(title));
                    const filterRoot = group.querySelector(".ag-filter-toolpanel-instance-filter");
                    if (filterRoot) this.setupFilterInstance(filterRoot, {
                        source: "filter-toolpanel",
                        colLabel: title
                    });
                });
            });
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-total-and-filtered-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarTotalAndFilteredRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-total-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarTotalRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-filtered-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarFilteredRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-selected-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarSelectedRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-filtered-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarAggregations());
        root.querySelectorAll(".ag-paging-panel").forEach((pagingPanel)=>{
            $437b23f6a393c3bf$var$setTestId(pagingPanel.querySelector(".ag-paging-page-size .ag-picker-field-display"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelSizePickerDisplay(pagingPanel.querySelector(".ag-paging-page-size .ag-picker-field-display")?.textContent));
            pagingPanel.querySelectorAll(".ag-paging-row-summary-panel-number").forEach((panelNumber)=>{
                const dataRef = panelNumber.getAttribute("data-ref");
                switch(dataRef){
                    case "lbFirstRowOnPage":
                        $437b23f6a393c3bf$var$setTestId(panelNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelFirstRowOnPage(panelNumber.textContent));
                        break;
                    case "lbLastRowOnPage":
                        $437b23f6a393c3bf$var$setTestId(panelNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelLastRowOnPage(panelNumber.textContent));
                        break;
                    case "lbRecordCount":
                        $437b23f6a393c3bf$var$setTestId(panelNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelRecordCount(panelNumber.textContent));
                        break;
                }
            });
            pagingPanel.querySelectorAll(".ag-paging-page-summary-panel .ag-button").forEach((pagingButton)=>{
                $437b23f6a393c3bf$var$setTestId(pagingButton, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationSummaryPanelButton(pagingButton.getAttribute("aria-label")?.toLowerCase()));
            });
            pagingPanel.querySelectorAll(".ag-paging-page-summary-panel .ag-paging-number").forEach((pagingNumber)=>{
                const dataRef = pagingNumber.getAttribute("data-ref");
                switch(dataRef){
                    case "lbCurrent":
                        $437b23f6a393c3bf$var$setTestId(pagingNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationSummaryPanelCurrentPage(pagingNumber.textContent));
                        break;
                    case "lbTotal":
                        $437b23f6a393c3bf$var$setTestId(pagingNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationSummaryPanelTotalPage(pagingNumber.textContent));
                        break;
                }
            });
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-fill-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.fillHandle());
        root.querySelectorAll('.ag-panel[aria-label="Choose Columns"]').forEach((panel)=>{
            $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-panel-title-bar-button-icon"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserCloseButton());
            $437b23f6a393c3bf$var$setTestId(panel.querySelector('.ag-column-select-header-checkbox input[type="checkbox"]'), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserSearchBarCheckbox());
            $437b23f6a393c3bf$var$setTestId(panel.querySelector('.ag-column-select-header-filter-wrapper input[type="text"]'), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserSearchBarFilter());
            panel.querySelectorAll(".ag-column-select-list").forEach((list)=>{
                list.querySelectorAll(".ag-column-select-virtual-list-item").forEach((item)=>{
                    const label = item.getAttribute("aria-label");
                    $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-group-closed-icon"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserListItemGroupClosedIcon(label));
                    $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-select-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserListItemCheckbox(label));
                    $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserListItemDragHandle(label));
                });
            });
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-overlay-wrapper"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.overlay());
        const rowGroupPanelWrapper = root.querySelector(".ag-column-drop-wrapper");
        if (rowGroupPanelWrapper) this.setupColumnDropArea(rowGroupPanelWrapper, "panel");
    }
    setupFilterInstance(filterRoot, spec) {
        if (!filterRoot) return;
        filterRoot.querySelectorAll(".ag-filter-select .ag-picker-field-display").forEach((fieldDisplay)=>{
            $437b23f6a393c3bf$var$setTestId(fieldDisplay, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterInstancePickerDisplay(spec));
        });
        const numberInput = filterRoot.querySelector('.ag-filter-body input[type="number"]');
        $437b23f6a393c3bf$var$setTestId(numberInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.numberFilterInstanceInput(spec));
        const textInput = filterRoot.querySelector('.ag-filter-body input[type="text"]');
        $437b23f6a393c3bf$var$setTestId(textInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.textFilterInstanceInput(spec));
        const dateInput = filterRoot.querySelector('.ag-filter-body input[type="date"]');
        $437b23f6a393c3bf$var$setTestId(dateInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.dateFilterInstanceInput(spec));
        const setMiniFilterInput = filterRoot.querySelector('.ag-mini-filter input[type="text"]');
        $437b23f6a393c3bf$var$setTestId(setMiniFilterInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.setFilterInstanceMiniFilterInput(spec));
        filterRoot.querySelectorAll(".ag-set-filter-list .ag-set-filter-item").forEach((item)=>{
            const label = item.querySelector(".ag-checkbox-label")?.textContent;
            const checkbox = item.querySelector('input[type="checkbox"]');
            $437b23f6a393c3bf$var$setTestId(checkbox, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.setFilterInstanceItem(spec, label));
        });
        filterRoot.querySelectorAll(".ag-filter-apply-panel button").forEach((button)=>{
            $437b23f6a393c3bf$var$setTestId(button, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.setFilterApplyPanelButton(spec, button.textContent));
        });
        filterRoot.querySelectorAll(".ag-filter-condition .ag-radio-button").forEach((radioButton)=>{
            const label = radioButton.querySelector(".ag-radio-button-label")?.textContent;
            $437b23f6a393c3bf$var$setTestId(radioButton.querySelector("input[type=radio]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterConditionRadioButton(spec, label));
        });
    }
    setupColumnDropArea(root, source) {
        root.querySelectorAll(".ag-column-drop").forEach((columnDrop)=>{
            const dropAreaName = columnDrop.querySelector(".ag-column-drop-list")?.getAttribute("aria-label");
            $437b23f6a393c3bf$var$setTestId(columnDrop, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnDropArea(source, dropAreaName));
            columnDrop.querySelectorAll(".ag-column-drop-cell").forEach((columnDropCell)=>{
                const label = columnDropCell.querySelector(".ag-column-drop-cell-text")?.textContent;
                $437b23f6a393c3bf$var$setTestId(columnDropCell.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnDropCellDragHandle(source, dropAreaName, label));
                $437b23f6a393c3bf$var$setTestId(columnDropCell.querySelector(".ag-column-drop-cell-button .ag-icon-cancel"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnDropCellCancelButton(source, dropAreaName, label));
            });
        });
    }
};
// packages/ag-grid-community/src/testing/testingModule.ts
var $437b23f6a393c3bf$var$TestingModule = {
    moduleName: "Testing",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TestIdService
    ]
};
function $437b23f6a393c3bf$export$a2068793f28bf00e({ testIdAttribute: testIdAttribute } = {}) {
    if (testIdAttribute) $437b23f6a393c3bf$var$setTestIdAttribute(testIdAttribute);
    $437b23f6a393c3bf$export$dc053975cc7f6c11.registerModules([
        $437b23f6a393c3bf$var$TestingModule
    ]);
}


// packages/ag-grid-react/src/agGridReact.tsx

var $acw62 = parcelRequire("acw62");


var $0e439ae7301dd858$var$BeansContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
var $0e439ae7301dd858$var$RenderModeContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext("default");
// packages/ag-grid-react/src/reactUi/jsComp.tsx
var $0e439ae7301dd858$var$showJsComp = (compDetails, context, eParent, ref)=>{
    const doNothing = !compDetails || compDetails.componentFromFramework || context.isDestroyed();
    if (doNothing) return;
    const promise = compDetails.newAgStackInstance();
    let comp;
    let compGui;
    let destroyed = false;
    promise.then((c)=>{
        if (destroyed) {
            context.destroyBean(c);
            return;
        }
        comp = c;
        compGui = comp.getGui();
        eParent.appendChild(compGui);
        $0e439ae7301dd858$var$setRef(ref, comp);
    });
    return ()=>{
        destroyed = true;
        if (!comp) return;
        compGui?.remove();
        context.destroyBean(comp);
        if (ref) $0e439ae7301dd858$var$setRef(ref, void 0);
    };
};
var $0e439ae7301dd858$var$setRef = (ref, value)=>{
    if (!ref) return;
    if (ref instanceof Function) {
        const refCallback = ref;
        refCallback(value);
    } else {
        const refObj = ref;
        refObj.current = value;
    }
};
var $0e439ae7301dd858$var$classesList = (...list)=>{
    const filtered = list.filter((s)=>s != null && s !== "");
    return filtered.join(" ");
};
var $0e439ae7301dd858$var$CssClasses = class _CssClasses {
    constructor(...initialClasses){
        this.classesMap = {};
        for (const className of initialClasses)this.classesMap[className] = true;
    }
    setClass(className, on) {
        const nothingHasChanged = !!this.classesMap[className] == on;
        if (nothingHasChanged) return this;
        const res = new _CssClasses();
        res.classesMap = {
            ...this.classesMap
        };
        res.classesMap[className] = on;
        return res;
    }
    toString() {
        const res = Object.keys(this.classesMap).filter((key)=>this.classesMap[key]).join(" ");
        return res;
    }
};
var $0e439ae7301dd858$var$isComponentStateless = (Component2)=>{
    const hasSymbol = ()=>typeof Symbol === "function" && Symbol.for;
    const getMemoType = ()=>hasSymbol() ? Symbol.for("react.memo") : 60115;
    return typeof Component2 === "function" && !(Component2.prototype && Component2.prototype.isReactComponent) || typeof Component2 === "object" && Component2.$$typeof === getMemoType();
};
var $0e439ae7301dd858$var$reactVersion = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version?.split(".")[0];
var $0e439ae7301dd858$var$isReactVersion17Minus = $0e439ae7301dd858$var$reactVersion === "16" || $0e439ae7301dd858$var$reactVersion === "17";
function $0e439ae7301dd858$var$isReact19() {
    return $0e439ae7301dd858$var$reactVersion === "19";
}
var $0e439ae7301dd858$var$disableFlushSync = false;
function $0e439ae7301dd858$var$runWithoutFlushSync(func) {
    if (!$0e439ae7301dd858$var$disableFlushSync) setTimeout(()=>$0e439ae7301dd858$var$disableFlushSync = false, 0);
    $0e439ae7301dd858$var$disableFlushSync = true;
    return func();
}
var $0e439ae7301dd858$var$agFlushSync = (useFlushSync, fn)=>{
    if (!$0e439ae7301dd858$var$isReactVersion17Minus && useFlushSync && !$0e439ae7301dd858$var$disableFlushSync) (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).flushSync(fn);
    else fn();
};
var $0e439ae7301dd858$var$agStartTransition = (fn)=>{
    if (!$0e439ae7301dd858$var$isReactVersion17Minus) (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).startTransition(fn);
    else fn();
};
function $0e439ae7301dd858$var$agUseSyncExternalStore(subscribe, getSnapshot, defaultSnapshot) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore(subscribe, getSnapshot);
    else return defaultSnapshot;
}
function $0e439ae7301dd858$var$getNextValueIfDifferent(prev, next, maintainOrder) {
    if (next == null || prev == null) return next;
    if (prev === next || next.length === 0 && prev.length === 0) return prev;
    if (maintainOrder || prev.length === 0 && next.length > 0 || prev.length > 0 && next.length === 0) return next;
    const oldValues = [];
    const newValues = [];
    const prevMap = /* @__PURE__ */ new Map();
    const nextMap = /* @__PURE__ */ new Map();
    for(let i = 0; i < next.length; i++){
        const c = next[i];
        nextMap.set(c.instanceId, c);
    }
    for(let i = 0; i < prev.length; i++){
        const c = prev[i];
        prevMap.set(c.instanceId, c);
        if (nextMap.has(c.instanceId)) oldValues.push(c);
    }
    for(let i = 0; i < next.length; i++){
        const c = next[i];
        const instanceId = c.instanceId;
        if (!prevMap.has(instanceId)) newValues.push(c);
    }
    if (oldValues.length === prev.length && newValues.length === 0) return prev;
    if (oldValues.length === 0 && newValues.length === next.length) return next;
    if (oldValues.length === 0) return newValues;
    if (newValues.length === 0) return oldValues;
    return [
        ...oldValues,
        ...newValues
    ];
}
// packages/ag-grid-react/src/reactUi/cellRenderer/groupCellRenderer.tsx
var $0e439ae7301dd858$var$GroupCellRenderer = (0, $acw62.forwardRef)((props, ref)=>{
    const { registry: registry, context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const eGui = (0, $acw62.useRef)(null);
    const eValueRef = (0, $acw62.useRef)(null);
    const eCheckboxRef = (0, $acw62.useRef)(null);
    const eExpandedRef = (0, $acw62.useRef)(null);
    const eContractedRef = (0, $acw62.useRef)(null);
    const ctrlRef = (0, $acw62.useRef)();
    const [innerCompDetails, setInnerCompDetails] = (0, $acw62.useState)();
    const [childCount, setChildCount] = (0, $acw62.useState)();
    const [value, setValue] = (0, $acw62.useState)();
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [expandedCssClasses, setExpandedCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-hidden"));
    const [contractedCssClasses, setContractedCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-hidden"));
    const [checkboxCssClasses, setCheckboxCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-invisible"));
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return {
            // force new instance when grid tries to refresh
            refresh () {
                return false;
            }
        };
    });
    (0, $acw62.useLayoutEffect)(()=>{
        return $0e439ae7301dd858$var$showJsComp(innerCompDetails, context, eValueRef.current);
    }, [
        innerCompDetails
    ]);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        if (!eRef || context.isDestroyed()) {
            ctrlRef.current = context.destroyBean(ctrlRef.current);
            return;
        }
        const compProxy = {
            setInnerRenderer: (details, valueToDisplay)=>{
                setInnerCompDetails(details);
                setValue(valueToDisplay);
            },
            setChildCount: (count)=>setChildCount(count),
            toggleCss: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setContractedDisplayed: (displayed)=>setContractedCssClasses((prev)=>prev.setClass("ag-hidden", !displayed)),
            setExpandedDisplayed: (displayed)=>setExpandedCssClasses((prev)=>prev.setClass("ag-hidden", !displayed)),
            setCheckboxVisible: (visible)=>setCheckboxCssClasses((prev)=>prev.setClass("ag-invisible", !visible)),
            setCheckboxSpacing: (add)=>setCheckboxCssClasses((prev)=>prev.setClass("ag-group-checkbox-spacing", add))
        };
        const groupCellRendererCtrl = registry.createDynamicBean("groupCellRendererCtrl", true);
        if (groupCellRendererCtrl) {
            ctrlRef.current = context.createBean(groupCellRendererCtrl);
            ctrlRef.current.init(compProxy, eRef, eCheckboxRef.current, eExpandedRef.current, eContractedRef.current, $0e439ae7301dd858$var$GroupCellRenderer, props);
        }
    }, []);
    const className = (0, $acw62.useMemo)(()=>`ag-cell-wrapper ${cssClasses.toString()}`, [
        cssClasses
    ]);
    const expandedClassName = (0, $acw62.useMemo)(()=>`ag-group-expanded ${expandedCssClasses.toString()}`, [
        expandedCssClasses
    ]);
    const contractedClassName = (0, $acw62.useMemo)(()=>`ag-group-contracted ${contractedCssClasses.toString()}`, [
        contractedCssClasses
    ]);
    const checkboxClassName = (0, $acw62.useMemo)(()=>`ag-group-checkbox ${checkboxCssClasses.toString()}`, [
        checkboxCssClasses
    ]);
    const useFwRenderer = innerCompDetails?.componentFromFramework;
    const FwRenderer = useFwRenderer ? innerCompDetails.componentClass : void 0;
    const useValue = innerCompDetails == null && value != null;
    const escapedValue = (0, $437b23f6a393c3bf$export$a16cfb6652fe466f)(value);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: className,
        ref: setRef2,
        ...!props.colDef ? {
            role: ctrlRef.current?.getCellAriaRole()
        } : {}
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: expandedClassName,
        ref: eExpandedRef
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: contractedClassName,
        ref: eContractedRef
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: checkboxClassName,
        ref: eCheckboxRef
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ag-group-value",
        ref: eValueRef
    }, useValue ? escapedValue : useFwRenderer ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FwRenderer, {
        ...innerCompDetails.params
    }) : null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ag-group-child-count"
    }, childCount));
});
var $0e439ae7301dd858$var$groupCellRenderer_default = $0e439ae7301dd858$var$GroupCellRenderer;
var $0e439ae7301dd858$export$9f6317c67b47ac67 = (0, $acw62.createContext)({
    setMethods: ()=>{}
});
// packages/ag-grid-react/src/reactUi/customComp/customWrapperComp.tsx
var $0e439ae7301dd858$var$CustomWrapperComp = (params)=>{
    const { initialProps: initialProps, addUpdateCallback: addUpdateCallback, CustomComponentClass: CustomComponentClass, setMethods: setMethods } = params;
    const [{ key: key, ...props }, setProps] = (0, $acw62.useState)(initialProps);
    (0, $acw62.useEffect)(()=>{
        addUpdateCallback((newProps)=>setProps(newProps));
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$export$9f6317c67b47ac67.Provider, {
        value: {
            setMethods: setMethods
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CustomComponentClass, {
        key: key,
        ...props
    }));
};
var $0e439ae7301dd858$var$customWrapperComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$CustomWrapperComp);
// packages/ag-grid-react/src/shared/keyGenerator.ts
var $0e439ae7301dd858$var$counter = 0;
function $0e439ae7301dd858$var$generateNewKey() {
    return `agPortalKey_${++$0e439ae7301dd858$var$counter}`;
}
// packages/ag-grid-react/src/shared/reactComponent.ts
var $0e439ae7301dd858$var$ReactComponent = class {
    constructor(reactComponent, portalManager, componentType, suppressFallbackMethods){
        this.portal = null;
        this.oldPortal = null;
        this.reactComponent = reactComponent;
        this.portalManager = portalManager;
        this.componentType = componentType;
        this.suppressFallbackMethods = !!suppressFallbackMethods;
        this.statelessComponent = this.isStateless(this.reactComponent);
        this.key = $0e439ae7301dd858$var$generateNewKey();
        this.portalKey = $0e439ae7301dd858$var$generateNewKey();
        this.instanceCreated = this.isStatelessComponent() ? (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(false) : new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            this.resolveInstanceCreated = resolve;
        });
    }
    getGui() {
        return this.eParentElement;
    }
    /** `getGui()` returns the parent element. This returns the actual root element. */ getRootElement() {
        const firstChild = this.eParentElement.firstChild;
        return firstChild;
    }
    destroy() {
        if (this.componentInstance && typeof this.componentInstance.destroy == "function") this.componentInstance.destroy();
        const portal = this.portal;
        if (portal) this.portalManager.destroyPortal(portal);
    }
    createParentElement(params) {
        const componentWrappingElement = this.portalManager.getComponentWrappingElement();
        const eParentElement = document.createElement(componentWrappingElement || "div");
        eParentElement.classList.add("ag-react-container");
        params.reactContainer = eParentElement;
        return eParentElement;
    }
    statelessComponentRendered() {
        return this.eParentElement.childElementCount > 0 || this.eParentElement.childNodes.length > 0;
    }
    getFrameworkComponentInstance() {
        return this.componentInstance;
    }
    isStatelessComponent() {
        return this.statelessComponent;
    }
    getReactComponentName() {
        return this.reactComponent.name;
    }
    getMemoType() {
        return this.hasSymbol() ? Symbol.for("react.memo") : 60115;
    }
    hasSymbol() {
        return typeof Symbol === "function" && Symbol.for;
    }
    isStateless(Component2) {
        return typeof Component2 === "function" && !(Component2.prototype && Component2.prototype.isReactComponent) || typeof Component2 === "object" && Component2.$$typeof === this.getMemoType();
    }
    hasMethod(name) {
        const frameworkComponentInstance = this.getFrameworkComponentInstance();
        return !!frameworkComponentInstance && frameworkComponentInstance[name] != null || this.fallbackMethodAvailable(name);
    }
    callMethod(name, args) {
        const frameworkComponentInstance = this.getFrameworkComponentInstance();
        if (this.isStatelessComponent()) return this.fallbackMethod(name, !!args && args[0] ? args[0] : {});
        else if (!frameworkComponentInstance) {
            setTimeout(()=>this.callMethod(name, args));
            return;
        }
        const method = frameworkComponentInstance[name];
        if (method) return method.apply(frameworkComponentInstance, args);
        if (this.fallbackMethodAvailable(name)) return this.fallbackMethod(name, !!args && args[0] ? args[0] : {});
    }
    addMethod(name, callback) {
        this[name] = callback;
    }
    init(params) {
        this.eParentElement = this.createParentElement(params);
        this.createOrUpdatePortal(params);
        return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>this.createReactComponent(resolve));
    }
    createOrUpdatePortal(params) {
        if (!this.isStatelessComponent()) {
            this.ref = (element)=>{
                this.componentInstance = element;
                this.resolveInstanceCreated?.(true);
                this.resolveInstanceCreated = void 0;
            };
            params.ref = this.ref;
        }
        this.reactElement = this.createElement(this.reactComponent, {
            ...params,
            key: this.key
        });
        this.portal = (0, $11492dca620dcaa5$exports.createPortal)(this.reactElement, this.eParentElement, this.portalKey);
    }
    createElement(reactComponent, props) {
        return (0, $acw62.createElement)(reactComponent, props);
    }
    createReactComponent(resolve) {
        this.portalManager.mountReactPortal(this.portal, this, resolve);
    }
    rendered() {
        return this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
    }
    /*
   * fallback methods - these will be invoked if a corresponding instance method is not present
   * for example if refresh is called and is not available on the component instance, then refreshComponent on this
   * class will be invoked instead
   *
   * Currently only refresh is supported
   */ refreshComponent(args) {
        this.oldPortal = this.portal;
        this.createOrUpdatePortal(args);
        this.portalManager.updateReactPortal(this.oldPortal, this.portal);
    }
    fallbackMethod(name, params) {
        const method = this[`${name}Component`];
        if (!this.suppressFallbackMethods && !!method) return method.bind(this)(params);
    }
    fallbackMethodAvailable(name) {
        if (this.suppressFallbackMethods) return false;
        const method = this[`${name}Component`];
        return !!method;
    }
};
// packages/ag-grid-react/src/shared/customComp/customComponentWrapper.ts
function $0e439ae7301dd858$var$addOptionalMethods(optionalMethodNames, providedMethods, component) {
    for (const methodName of optionalMethodNames){
        const providedMethod = providedMethods[methodName];
        if (providedMethod) component[methodName] = providedMethod;
    }
}
var $0e439ae7301dd858$var$CustomComponentWrapper = class extends $0e439ae7301dd858$var$ReactComponent {
    constructor(){
        super(...arguments);
        this.awaitUpdateCallback = new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            this.resolveUpdateCallback = resolve;
        });
        this.wrapperComponent = $0e439ae7301dd858$var$customWrapperComp_default;
    }
    init(params) {
        this.sourceParams = params;
        return super.init(this.getProps());
    }
    addMethod() {}
    getInstance() {
        return this.instanceCreated.then(()=>this.componentInstance);
    }
    getFrameworkComponentInstance() {
        return this;
    }
    createElement(reactComponent, props) {
        return super.createElement(this.wrapperComponent, {
            initialProps: props,
            CustomComponentClass: reactComponent,
            setMethods: (methods)=>this.setMethods(methods),
            addUpdateCallback: (callback)=>{
                this.updateCallback = ()=>{
                    callback(this.getProps());
                    return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
                        setTimeout(()=>{
                            resolve();
                        });
                    });
                };
                this.resolveUpdateCallback();
            }
        });
    }
    setMethods(methods) {
        this.providedMethods = methods;
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), this.providedMethods, this);
    }
    getOptionalMethods() {
        return [];
    }
    getProps() {
        return {
            ...this.sourceParams,
            key: this.key,
            ref: this.ref
        };
    }
    refreshProps() {
        if (this.updateCallback) return this.updateCallback();
        return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>this.awaitUpdateCallback.then(()=>{
                this.updateCallback().then(()=>resolve());
            }));
    }
};
// packages/ag-grid-react/src/shared/customComp/cellRendererComponentWrapper.ts
var $0e439ae7301dd858$var$CellRendererComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
};
// packages/ag-grid-react/src/shared/customComp/dateComponentWrapper.ts
var $0e439ae7301dd858$var$DateComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.date = null;
        this.onDateChange = (date)=>this.updateDate(date);
    }
    getDate() {
        return this.date;
    }
    setDate(date) {
        this.date = date;
        this.refreshProps();
    }
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached",
            "setInputPlaceholder",
            "setInputAriaLabel",
            "setDisabled"
        ];
    }
    updateDate(date) {
        this.setDate(date);
        this.sourceParams.onDateChanged();
    }
    getProps() {
        const props = super.getProps();
        props.date = this.date;
        props.onDateChange = this.onDateChange;
        delete props.onDateChanged;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/dragAndDropImageComponentWrapper.ts
var $0e439ae7301dd858$var$DragAndDropImageComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.label = "";
        this.icon = null;
        this.shake = false;
    }
    setIcon(iconName, shake) {
        this.icon = iconName;
        this.shake = shake;
        this.refreshProps();
    }
    setLabel(label) {
        this.label = label;
        this.refreshProps();
    }
    getProps() {
        const props = super.getProps();
        const { label: label, icon: icon, shake: shake } = this;
        props.label = label;
        props.icon = icon;
        props.shake = shake;
        return props;
    }
};
var $0e439ae7301dd858$var$FilterComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
        this.onUiChange = ()=>this.sourceParams.filterModifiedCallback();
        this.expectingNewMethods = true;
        this.hasBeenActive = false;
        this.awaitSetMethodsCallback = new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            this.resolveSetMethodsCallback = resolve;
        });
    }
    isFilterActive() {
        return this.model != null;
    }
    doesFilterPass(params) {
        return this.providedMethods.doesFilterPass(params);
    }
    getModel() {
        return this.model;
    }
    setModel(model) {
        this.expectingNewMethods = true;
        this.model = model;
        this.hasBeenActive || (this.hasBeenActive = this.isFilterActive());
        return this.refreshProps();
    }
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
        return true;
    }
    afterGuiAttached(params) {
        const providedMethods = this.providedMethods;
        if (!providedMethods) this.awaitSetMethodsCallback.then(()=>this.providedMethods?.afterGuiAttached?.(params));
        else providedMethods.afterGuiAttached?.(params);
    }
    getOptionalMethods() {
        return [
            "afterGuiDetached",
            "onNewRowsLoaded",
            "getModelAsString",
            "onAnyFilterChanged"
        ];
    }
    setMethods(methods) {
        if (this.expectingNewMethods === false && this.hasBeenActive && this.providedMethods?.doesFilterPass !== methods?.doesFilterPass) setTimeout(()=>{
            this.sourceParams.filterChangedCallback();
        });
        this.expectingNewMethods = false;
        super.setMethods(methods);
        this.resolveSetMethodsCallback();
        this.resolveFilterPassCallback?.();
        this.resolveFilterPassCallback = void 0;
    }
    updateModel(model) {
        this.resolveFilterPassCallback?.();
        const awaitFilterPassCallback = new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            this.resolveFilterPassCallback = resolve;
        });
        this.setModel(model).then(()=>{
            awaitFilterPassCallback.then(()=>{
                this.sourceParams.filterChangedCallback();
            });
        });
    }
    getProps() {
        const props = super.getProps();
        props.model = this.model;
        props.onModelChange = this.onModelChange;
        props.onUiChange = this.onUiChange;
        delete props.filterChangedCallback;
        return props;
    }
};
var $0e439ae7301dd858$var$FilterDisplayComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.awaitSetMethodsCallback = new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            this.resolveSetMethodsCallback = resolve;
        });
    }
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
        return true;
    }
    afterGuiAttached(params) {
        const providedMethods = this.providedMethods;
        if (!providedMethods) this.awaitSetMethodsCallback.then(()=>this.providedMethods?.afterGuiAttached?.(params));
        else providedMethods.afterGuiAttached?.(params);
    }
    getOptionalMethods() {
        return [
            "afterGuiDetached",
            "onNewRowsLoaded",
            "onAnyFilterChanged"
        ];
    }
    setMethods(methods) {
        super.setMethods(methods);
        this.resolveSetMethodsCallback();
    }
};
function $0e439ae7301dd858$var$updateFloatingFilterParent(params, model) {
    params.parentFilterInstance((instance)=>{
        (instance.setModel(model) || (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve()).then(()=>{
            params.filterParams.filterChangedCallback();
        });
    });
}
var $0e439ae7301dd858$var$FloatingFilterComponentProxy = class {
    constructor(floatingFilterParams, refreshProps){
        this.floatingFilterParams = floatingFilterParams;
        this.refreshProps = refreshProps;
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
    }
    getProps() {
        return {
            ...this.floatingFilterParams,
            model: this.model,
            onModelChange: this.onModelChange
        };
    }
    onParentModelChanged(parentModel) {
        this.model = parentModel;
        this.refreshProps();
    }
    refresh(params) {
        this.floatingFilterParams = params;
        this.refreshProps();
    }
    setMethods(methods) {
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), methods, this);
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
    updateModel(model) {
        this.model = model;
        this.refreshProps();
        $0e439ae7301dd858$var$updateFloatingFilterParent(this.floatingFilterParams, model);
    }
};
// packages/ag-grid-react/src/shared/customComp/floatingFilterComponentWrapper.ts
var $0e439ae7301dd858$var$FloatingFilterComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
    }
    onParentModelChanged(parentModel) {
        this.model = parentModel;
        this.refreshProps();
    }
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
    updateModel(model) {
        this.model = model;
        this.refreshProps();
        $0e439ae7301dd858$var$updateFloatingFilterParent(this.sourceParams, model);
    }
    getProps() {
        const props = super.getProps();
        props.model = this.model;
        props.onModelChange = this.onModelChange;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/floatingFilterDisplayComponentWrapper.ts
var $0e439ae7301dd858$var$FloatingFilterDisplayComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
};
// packages/ag-grid-react/src/shared/customComp/innerHeaderComponentWrapper.ts
var $0e439ae7301dd858$var$InnerHeaderComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
};
// packages/ag-grid-react/src/shared/customComp/loadingOverlayComponentWrapper.ts
var $0e439ae7301dd858$var$LoadingOverlayComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
};
// packages/ag-grid-react/src/shared/customComp/menuItemComponentWrapper.ts
var $0e439ae7301dd858$var$MenuItemComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.active = false;
        this.expanded = false;
        this.onActiveChange = (active)=>this.updateActive(active);
    }
    setActive(active) {
        this.awaitSetActive(active);
    }
    setExpanded(expanded) {
        this.expanded = expanded;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "select",
            "configureDefaults"
        ];
    }
    awaitSetActive(active) {
        this.active = active;
        return this.refreshProps();
    }
    updateActive(active) {
        const result = this.awaitSetActive(active);
        if (active) result.then(()=>this.sourceParams.onItemActivated());
    }
    getProps() {
        const props = super.getProps();
        props.active = this.active;
        props.expanded = this.expanded;
        props.onActiveChange = this.onActiveChange;
        delete props.onItemActivated;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/noRowsOverlayComponentWrapper.ts
var $0e439ae7301dd858$var$NoRowsOverlayComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
};
// packages/ag-grid-react/src/shared/customComp/statusPanelComponentWrapper.ts
var $0e439ae7301dd858$var$StatusPanelComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
};
// packages/ag-grid-react/src/shared/customComp/toolPanelComponentWrapper.ts
var $0e439ae7301dd858$var$ToolPanelComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.onStateChange = (state)=>this.updateState(state);
    }
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
    getState() {
        return this.state;
    }
    updateState(state) {
        this.state = state;
        this.refreshProps();
        this.sourceParams.onStateUpdated();
    }
    getProps() {
        const props = super.getProps();
        props.state = this.state;
        props.onStateChange = this.onStateChange;
        return props;
    }
};
function $0e439ae7301dd858$export$8bedcca5bbd73999(wrapperComponent, callback) {
    const promise = wrapperComponent?.getInstance?.() ?? (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(void 0);
    promise.then((comp)=>callback(comp));
}
function $0e439ae7301dd858$export$e83e01bcf62967be() {
    (0, $437b23f6a393c3bf$export$545083624300f13d)(231);
}
// packages/ag-grid-react/src/shared/portalManager.ts
var $0e439ae7301dd858$var$MAX_COMPONENT_CREATION_TIME_IN_MS = 1e3;
var $0e439ae7301dd858$var$PortalManager = class {
    constructor(refresher, wrappingElement, maxComponentCreationTimeMs){
        this.destroyed = false;
        this.portals = [];
        this.hasPendingPortalUpdate = false;
        this.wrappingElement = wrappingElement ? wrappingElement : "div";
        this.refresher = refresher;
        this.maxComponentCreationTimeMs = maxComponentCreationTimeMs ? maxComponentCreationTimeMs : $0e439ae7301dd858$var$MAX_COMPONENT_CREATION_TIME_IN_MS;
    }
    getPortals() {
        return this.portals;
    }
    destroy() {
        this.destroyed = true;
    }
    destroyPortal(portal) {
        this.portals = this.portals.filter((curPortal)=>curPortal !== portal);
        this.batchUpdate();
    }
    getComponentWrappingElement() {
        return this.wrappingElement;
    }
    mountReactPortal(portal, reactComponent, resolve) {
        this.portals = [
            ...this.portals,
            portal
        ];
        this.waitForInstance(reactComponent, resolve);
        this.batchUpdate();
    }
    updateReactPortal(oldPortal, newPortal) {
        this.portals[this.portals.indexOf(oldPortal)] = newPortal;
        this.batchUpdate();
    }
    batchUpdate() {
        if (this.hasPendingPortalUpdate) return;
        setTimeout(()=>{
            if (!this.destroyed) {
                this.refresher();
                this.hasPendingPortalUpdate = false;
            }
        });
        this.hasPendingPortalUpdate = true;
    }
    waitForInstance(reactComponent, resolve, startTime = Date.now()) {
        if (this.destroyed) {
            resolve(null);
            return;
        }
        if (reactComponent.rendered()) resolve(reactComponent);
        else {
            if (Date.now() - startTime >= this.maxComponentCreationTimeMs && !this.hasPendingPortalUpdate) {
                $0e439ae7301dd858$var$agFlushSync(true, ()=>this.refresher());
                if (reactComponent.rendered()) resolve(reactComponent);
                return;
            }
            window.setTimeout(()=>{
                this.waitForInstance(reactComponent, resolve, startTime);
            });
        }
    }
};
var $0e439ae7301dd858$var$HeaderCellComp = ({ ctrl: ctrl })=>{
    const isAlive = ctrl.isAlive();
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const [userCompDetails, setUserCompDetails] = (0, $acw62.useState)();
    const [userStyles, setUserStyles] = (0, $acw62.useState)();
    const compBean = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const eResize = (0, $acw62.useRef)(null);
    const eHeaderCompWrapper = (0, $acw62.useRef)(null);
    const userCompRef = (0, $acw62.useRef)();
    const cssManager = (0, $acw62.useRef)();
    if (isAlive && !cssManager.current) cssManager.current = new (0, $437b23f6a393c3bf$export$a7053cb7eb605bd2)(()=>eGui.current);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        if (!eRef || !ctrl.isAlive() || context.isDestroyed()) {
            compBean.current = context.destroyBean(compBean.current);
            return;
        }
        compBean.current = context.createBean(new (0, $437b23f6a393c3bf$export$4f8bbae47c6ad8d2)());
        const refreshSelectAllGui = ()=>{
            const selectAllGui = ctrl.getSelectAllGui();
            if (selectAllGui) {
                eResize.current?.insertAdjacentElement("afterend", selectAllGui);
                compBean.current.addDestroyFunc(()=>selectAllGui.remove());
            }
        };
        const compProxy = {
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            toggleCss: (name, on)=>cssManager.current.toggleCss(name, on),
            setUserStyles: (styles)=>setUserStyles(styles),
            setAriaSort: (sort)=>{
                if (eGui.current) sort ? (0, $437b23f6a393c3bf$export$c8dd030b968c6fd2)(eGui.current, sort) : (0, $437b23f6a393c3bf$export$26c7aa61eda05134)(eGui.current);
            },
            setUserCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            getUserCompInstance: ()=>userCompRef.current || void 0,
            refreshSelectAllGui: refreshSelectAllGui,
            removeSelectAllGui: ()=>ctrl.getSelectAllGui()?.remove()
        };
        ctrl.setComp(compProxy, eRef, eResize.current, eHeaderCompWrapper.current, compBean.current);
        refreshSelectAllGui();
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(userCompDetails, context, eHeaderCompWrapper.current, userCompRef), [
        userCompDetails
    ]);
    (0, $acw62.useEffect)(()=>{
        ctrl.setDragSource(eGui.current);
    }, [
        userCompDetails
    ]);
    const userCompStateless = (0, $acw62.useMemo)(()=>{
        const res = userCompDetails?.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const reactUserComp = userCompDetails?.componentFromFramework;
    const UserCompClass = userCompDetails?.componentClass;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        style: userStyles,
        className: "ag-header-cell",
        role: "columnheader"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eResize,
        className: "ag-header-cell-resize",
        role: "presentation"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eHeaderCompWrapper,
        className: "ag-header-cell-comp-wrapper",
        role: "presentation"
    }, reactUserComp ? userCompStateless ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...userCompDetails.params
    }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...userCompDetails.params,
        ref: userCompRef
    }) : null));
};
var $0e439ae7301dd858$var$headerCellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderCellComp);
// packages/ag-grid-react/src/shared/customComp/floatingFilterDisplayComponentProxy.ts
var $0e439ae7301dd858$var$FloatingFilterDisplayComponentProxy = class {
    constructor(floatingFilterParams, refreshProps){
        this.floatingFilterParams = floatingFilterParams;
        this.refreshProps = refreshProps;
    }
    getProps() {
        return this.floatingFilterParams;
    }
    refresh(params) {
        this.floatingFilterParams = params;
        this.refreshProps();
    }
    setMethods(methods) {
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), methods, this);
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
};
// packages/ag-grid-react/src/reactUi/header/headerFilterCellComp.tsx
var $0e439ae7301dd858$var$HeaderFilterCellComp = ({ ctrl: ctrl })=>{
    const { context: context, gos: gos } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const [userStyles, setUserStyles] = (0, $acw62.useState)();
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-header-cell", "ag-floating-filter"));
    const [cssBodyClasses, setBodyCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [cssButtonWrapperClasses, setButtonWrapperCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-floating-filter-button", "ag-hidden"));
    const [buttonWrapperAriaHidden, setButtonWrapperAriaHidden] = (0, $acw62.useState)("false");
    const [userCompDetails, setUserCompDetails] = (0, $acw62.useState)();
    const [, setRenderKey] = (0, $acw62.useState)(1);
    const compBean = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const eFloatingFilterBody = (0, $acw62.useRef)(null);
    const eButtonWrapper = (0, $acw62.useRef)(null);
    const eButtonShowMainFilter = (0, $acw62.useRef)(null);
    const userCompResolve = (0, $acw62.useRef)();
    const userCompPromise = (0, $acw62.useRef)();
    const userCompRef = (value)=>{
        if (value == null) return;
        userCompResolve.current && userCompResolve.current(value);
    };
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        if (!eRef || !ctrl.isAlive() || context.isDestroyed()) {
            compBean.current = context.destroyBean(compBean.current);
            return;
        }
        compBean.current = context.createBean(new (0, $437b23f6a393c3bf$export$4f8bbae47c6ad8d2)());
        userCompPromise.current = new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            userCompResolve.current = resolve;
        });
        const compProxy = {
            toggleCss: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setUserStyles: (styles)=>setUserStyles(styles),
            addOrRemoveBodyCssClass: (name, on)=>setBodyCssClasses((prev)=>prev.setClass(name, on)),
            setButtonWrapperDisplayed: (displayed)=>{
                setButtonWrapperCssClasses((prev)=>prev.setClass("ag-hidden", !displayed));
                setButtonWrapperAriaHidden(!displayed ? "true" : "false");
            },
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            setCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            getFloatingFilterComp: ()=>userCompPromise.current ? userCompPromise.current : null,
            setMenuIcon: (eIcon)=>eButtonShowMainFilter.current?.appendChild(eIcon)
        };
        ctrl.setComp(compProxy, eRef, eButtonShowMainFilter.current, eFloatingFilterBody.current, compBean.current);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(userCompDetails, context, eFloatingFilterBody.current, userCompRef), [
        userCompDetails
    ]);
    const className = (0, $acw62.useMemo)(()=>cssClasses.toString(), [
        cssClasses
    ]);
    const bodyClassName = (0, $acw62.useMemo)(()=>cssBodyClasses.toString(), [
        cssBodyClasses
    ]);
    const buttonWrapperClassName = (0, $acw62.useMemo)(()=>cssButtonWrapperClasses.toString(), [
        cssButtonWrapperClasses
    ]);
    const userCompStateless = (0, $acw62.useMemo)(()=>{
        const res = userCompDetails && userCompDetails.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const reactiveCustomComponents = (0, $acw62.useMemo)(()=>gos.get("reactiveCustomComponents"), []);
    const enableFilterHandlers = (0, $acw62.useMemo)(()=>gos.get("enableFilterHandlers"), []);
    const [floatingFilterCompProxy, setFloatingFilterCompProxy] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (userCompDetails?.componentFromFramework) {
            if (reactiveCustomComponents) {
                const ProxyClass = enableFilterHandlers ? $0e439ae7301dd858$var$FloatingFilterDisplayComponentProxy : $0e439ae7301dd858$var$FloatingFilterComponentProxy;
                const compProxy = new ProxyClass(userCompDetails.params, ()=>setRenderKey((prev)=>prev + 1));
                userCompRef(compProxy);
                setFloatingFilterCompProxy(compProxy);
            } else $0e439ae7301dd858$export$e83e01bcf62967be();
        }
    }, [
        userCompDetails
    ]);
    const floatingFilterProps = floatingFilterCompProxy?.getProps();
    const reactUserComp = userCompDetails?.componentFromFramework;
    const UserCompClass = userCompDetails?.componentClass;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        style: userStyles,
        className: className,
        role: "gridcell"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eFloatingFilterBody,
        className: bodyClassName,
        role: "presentation"
    }, reactUserComp ? reactiveCustomComponents ? floatingFilterProps && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$export$9f6317c67b47ac67.Provider, {
        value: {
            setMethods: (methods)=>floatingFilterCompProxy.setMethods(methods)
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...floatingFilterProps
    })) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...userCompDetails.params,
        ref: userCompStateless ? ()=>{} : userCompRef
    }) : null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eButtonWrapper,
        "aria-hidden": buttonWrapperAriaHidden,
        className: buttonWrapperClassName,
        role: "presentation"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: eButtonShowMainFilter,
        type: "button",
        className: "ag-button ag-floating-filter-button-button",
        tabIndex: -1
    })));
};
var $0e439ae7301dd858$var$headerFilterCellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderFilterCellComp);
var $0e439ae7301dd858$var$HeaderGroupCellComp = ({ ctrl: ctrl })=>{
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const [userStyles, setUserStyles] = (0, $acw62.useState)();
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [cssResizableClasses, setResizableCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [resizableAriaHidden, setResizableAriaHidden] = (0, $acw62.useState)("false");
    const [ariaExpanded, setAriaExpanded] = (0, $acw62.useState)();
    const [userCompDetails, setUserCompDetails] = (0, $acw62.useState)();
    const compBean = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const eResize = (0, $acw62.useRef)(null);
    const eHeaderCompWrapper = (0, $acw62.useRef)(null);
    const userCompRef = (0, $acw62.useRef)();
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        if (!eRef || !ctrl.isAlive() || context.isDestroyed()) {
            compBean.current = context.destroyBean(compBean.current);
            return;
        }
        compBean.current = context.createBean(new (0, $437b23f6a393c3bf$export$4f8bbae47c6ad8d2)());
        const compProxy = {
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            toggleCss: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setUserStyles: (styles)=>setUserStyles(styles),
            setHeaderWrapperHidden: (hidden)=>{
                const headerCompWrapper = eHeaderCompWrapper.current;
                if (!headerCompWrapper) return;
                if (hidden) headerCompWrapper.style.setProperty("display", "none");
                else headerCompWrapper.style.removeProperty("display");
            },
            setHeaderWrapperMaxHeight: (value)=>{
                const headerCompWrapper = eHeaderCompWrapper.current;
                if (!headerCompWrapper) return;
                if (value != null) headerCompWrapper.style.setProperty("max-height", `${value}px`);
                else headerCompWrapper.style.removeProperty("max-height");
                headerCompWrapper.classList.toggle("ag-header-cell-comp-wrapper-limited-height", value != null);
            },
            setUserCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            setResizableDisplayed: (displayed)=>{
                setResizableCssClasses((prev)=>prev.setClass("ag-hidden", !displayed));
                setResizableAriaHidden(!displayed ? "true" : "false");
            },
            setAriaExpanded: (expanded)=>setAriaExpanded(expanded),
            getUserCompInstance: ()=>userCompRef.current || void 0
        };
        ctrl.setComp(compProxy, eRef, eResize.current, eHeaderCompWrapper.current, compBean.current);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(userCompDetails, context, eHeaderCompWrapper.current), [
        userCompDetails
    ]);
    (0, $acw62.useEffect)(()=>{
        if (eGui.current) ctrl.setDragSource(eGui.current);
    }, [
        userCompDetails
    ]);
    const userCompStateless = (0, $acw62.useMemo)(()=>{
        const res = userCompDetails?.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const className = (0, $acw62.useMemo)(()=>"ag-header-group-cell " + cssClasses.toString(), [
        cssClasses
    ]);
    const resizableClassName = (0, $acw62.useMemo)(()=>"ag-header-cell-resize " + cssResizableClasses.toString(), [
        cssResizableClasses
    ]);
    const reactUserComp = userCompDetails?.componentFromFramework;
    const UserCompClass = userCompDetails?.componentClass;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        style: userStyles,
        className: className,
        role: "columnheader",
        "aria-expanded": ariaExpanded
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eHeaderCompWrapper,
        className: "ag-header-cell-comp-wrapper",
        role: "presentation"
    }, reactUserComp ? userCompStateless ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...userCompDetails.params
    }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...userCompDetails.params,
        ref: userCompRef
    }) : null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eResize,
        "aria-hidden": resizableAriaHidden,
        className: resizableClassName
    }));
};
var $0e439ae7301dd858$var$headerGroupCellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderGroupCellComp);
// packages/ag-grid-react/src/reactUi/header/headerRowComp.tsx
var $0e439ae7301dd858$var$HeaderRowComp = ({ ctrl: ctrl })=>{
    const { gos: gos, context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { topOffset: topOffset, rowHeight: rowHeight } = (0, $acw62.useMemo)(()=>ctrl.getTopAndHeight(), []);
    const tabIndex = (0, $acw62.useMemo)(()=>gos.get("tabIndex"), []);
    const [ariaRowIndex, setAriaRowIndex] = (0, $acw62.useState)(()=>ctrl.getAriaRowIndex());
    const className = ctrl.headerRowClass;
    const [height, setHeight] = (0, $acw62.useState)(()=>rowHeight + "px");
    const [top, setTop] = (0, $acw62.useState)(()=>topOffset + "px");
    const cellCtrlsRef = (0, $acw62.useRef)(null);
    const [cellCtrls, setCellCtrls] = (0, $acw62.useState)(()=>ctrl.getUpdatedHeaderCtrls());
    const compBean = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        if (!eRef || !ctrl.isAlive() || context.isDestroyed()) {
            compBean.current = context.destroyBean(compBean.current);
            return;
        }
        compBean.current = context.createBean(new (0, $437b23f6a393c3bf$export$4f8bbae47c6ad8d2)());
        const compProxy = {
            setHeight: (height2)=>setHeight(height2),
            setTop: (top2)=>setTop(top2),
            setHeaderCtrls: (ctrls, forceOrder, afterScroll)=>{
                const prevCellCtrls = cellCtrlsRef.current;
                const nextCells = $0e439ae7301dd858$var$getNextValueIfDifferent(prevCellCtrls, ctrls, forceOrder);
                if (nextCells !== prevCellCtrls) {
                    cellCtrlsRef.current = nextCells;
                    $0e439ae7301dd858$var$agFlushSync(afterScroll, ()=>setCellCtrls(nextCells));
                }
            },
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            setRowIndex: (rowIndex)=>{
                setAriaRowIndex(rowIndex);
            }
        };
        ctrl.setComp(compProxy, compBean.current, false);
    }, []);
    const style = (0, $acw62.useMemo)(()=>({
            height: height,
            top: top
        }), [
        height,
        top
    ]);
    const createCellJsx = (0, $acw62.useCallback)((cellCtrl)=>{
        switch(ctrl.type){
            case "group":
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerGroupCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.instanceId
                });
            case "filter":
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerFilterCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.instanceId
                });
            default:
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.instanceId
                });
        }
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: className,
        role: "row",
        style: style,
        tabIndex: tabIndex,
        "aria-rowindex": ariaRowIndex
    }, cellCtrls.map(createCellJsx));
};
var $0e439ae7301dd858$var$headerRowComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderRowComp);
// packages/ag-grid-react/src/reactUi/header/headerRowContainerComp.tsx
var $0e439ae7301dd858$var$HeaderRowContainerComp = ({ pinned: pinned })=>{
    const [displayed, setDisplayed] = (0, $acw62.useState)(true);
    const [headerRowCtrls, setHeaderRowCtrls] = (0, $acw62.useState)([]);
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const eGui = (0, $acw62.useRef)(null);
    const eCenterContainer = (0, $acw62.useRef)(null);
    const headerRowCtrlRef = (0, $acw62.useRef)();
    const pinnedLeft = pinned === "left";
    const pinnedRight = pinned === "right";
    const centre = !pinnedLeft && !pinnedRight;
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        if (!eRef || context.isDestroyed()) {
            headerRowCtrlRef.current = context.destroyBean(headerRowCtrlRef.current);
            return;
        }
        headerRowCtrlRef.current = context.createBean(new (0, $437b23f6a393c3bf$export$1e864ee88f54e7b)(pinned));
        const compProxy = {
            setDisplayed: setDisplayed,
            setCtrls: (ctrls)=>setHeaderRowCtrls(ctrls),
            // centre only
            setCenterWidth: (width)=>{
                if (eCenterContainer.current) eCenterContainer.current.style.width = width;
            },
            setViewportScrollLeft: (left)=>{
                if (eGui.current) eGui.current.scrollLeft = left;
            },
            // pinned only
            setPinnedContainerWidth: (width)=>{
                if (eGui.current) {
                    eGui.current.style.width = width;
                    eGui.current.style.minWidth = width;
                    eGui.current.style.maxWidth = width;
                }
            }
        };
        headerRowCtrlRef.current.setComp(compProxy, eGui.current);
    }, []);
    const className = !displayed ? "ag-hidden" : "";
    const insertRowsJsx = ()=>headerRowCtrls.map((ctrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowComp_default, {
                ctrl: ctrl,
                key: ctrl.instanceId
            }));
    return pinnedLeft ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: "ag-pinned-left-header " + className,
        "aria-hidden": !displayed,
        role: "rowgroup"
    }, insertRowsJsx()) : pinnedRight ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: "ag-pinned-right-header " + className,
        "aria-hidden": !displayed,
        role: "rowgroup"
    }, insertRowsJsx()) : centre ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: "ag-header-viewport " + className,
        role: "rowgroup",
        tabIndex: -1
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eCenterContainer,
        className: "ag-header-container",
        role: "presentation"
    }, insertRowsJsx())) : null;
};
var $0e439ae7301dd858$var$headerRowContainerComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderRowContainerComp);
// packages/ag-grid-react/src/reactUi/header/gridHeaderComp.tsx
var $0e439ae7301dd858$var$GridHeaderComp = ()=>{
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [height, setHeight] = (0, $acw62.useState)();
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const eGui = (0, $acw62.useRef)(null);
    const gridCtrlRef = (0, $acw62.useRef)();
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        if (!eRef || context.isDestroyed()) {
            gridCtrlRef.current = context.destroyBean(gridCtrlRef.current);
            return;
        }
        gridCtrlRef.current = context.createBean(new (0, $437b23f6a393c3bf$export$20b300eb69ca4d09)());
        const compProxy = {
            toggleCss: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setHeightAndMinHeight: (height2)=>setHeight(height2)
        };
        gridCtrlRef.current.setComp(compProxy, eRef, eRef);
    }, []);
    const className = (0, $acw62.useMemo)(()=>{
        const res = cssClasses.toString();
        return "ag-header " + res;
    }, [
        cssClasses
    ]);
    const style = (0, $acw62.useMemo)(()=>({
            height: height,
            minHeight: height
        }), [
        height
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: className,
        style: style,
        role: "presentation"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowContainerComp_default, {
        pinned: "left"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowContainerComp_default, {
        pinned: null
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowContainerComp_default, {
        pinned: "right"
    }));
};
var $0e439ae7301dd858$var$gridHeaderComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$GridHeaderComp);
var $0e439ae7301dd858$var$useReactCommentEffect = (comment, eForCommentRef)=>{
    (0, $acw62.useEffect)(()=>{
        const eForComment = eForCommentRef.current;
        if (eForComment) {
            const eParent = eForComment.parentElement;
            if (eParent) {
                const eComment = document.createComment(comment);
                eParent.insertBefore(eComment, eForComment);
                return ()=>{
                    eComment.remove();
                };
            }
        }
    }, [
        comment
    ]);
};
var $0e439ae7301dd858$var$reactComment_default = $0e439ae7301dd858$var$useReactCommentEffect;
var $0e439ae7301dd858$var$CellEditorComponentProxy = class {
    constructor(cellEditorParams, refreshProps){
        this.cellEditorParams = cellEditorParams;
        this.refreshProps = refreshProps;
        this.instanceCreated = new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            this.resolveInstanceCreated = resolve;
        });
        this.onValueChange = (value)=>this.updateValue(value);
        this.value = cellEditorParams.value;
    }
    getProps() {
        return {
            ...this.cellEditorParams,
            initialValue: this.cellEditorParams.value,
            value: this.value,
            onValueChange: this.onValueChange
        };
    }
    getValue() {
        return this.value;
    }
    refresh(params) {
        this.cellEditorParams = params;
        this.refreshProps();
    }
    setMethods(methods) {
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), methods, this);
    }
    getInstance() {
        return this.instanceCreated.then(()=>this.componentInstance);
    }
    setRef(componentInstance) {
        this.componentInstance = componentInstance;
        this.resolveInstanceCreated?.();
        this.resolveInstanceCreated = void 0;
    }
    getOptionalMethods() {
        return [
            "isCancelBeforeStart",
            "isCancelAfterEnd",
            "focusIn",
            "focusOut",
            "afterGuiAttached",
            "getValidationErrors",
            "getValidationElement"
        ];
    }
    updateValue(value) {
        this.value = value;
        this.refreshProps();
    }
};
var $0e439ae7301dd858$var$useEffectOnce = (effect)=>{
    const effectFn = (0, $acw62.useRef)(effect);
    const destroyFn = (0, $acw62.useRef)();
    const effectCalled = (0, $acw62.useRef)(false);
    const rendered = (0, $acw62.useRef)(false);
    const [, setVal] = (0, $acw62.useState)(0);
    if (effectCalled.current) rendered.current = true;
    (0, $acw62.useEffect)(()=>{
        if (!effectCalled.current) {
            destroyFn.current = effectFn.current();
            effectCalled.current = true;
        }
        setVal((val)=>val + 1);
        return ()=>{
            if (!rendered.current) return;
            destroyFn.current?.();
        };
    }, []);
};
// packages/ag-grid-react/src/reactUi/cells/popupEditorComp.tsx
var $0e439ae7301dd858$var$PopupEditorComp = (props)=>{
    const [popupEditorWrapper, setPopupEditorWrapper] = (0, $acw62.useState)();
    const beans = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { context: context, popupSvc: popupSvc, gos: gos, editSvc: editSvc } = beans;
    const { editDetails: editDetails, cellCtrl: cellCtrl, eParentCell: eParentCell } = props;
    $0e439ae7301dd858$var$useEffectOnce(()=>{
        const { compDetails: compDetails } = editDetails;
        const useModelPopup = gos.get("stopEditingWhenCellsLoseFocus");
        let hideEditorPopup = void 0;
        let wrapper;
        if (!context.isDestroyed()) {
            wrapper = context.createBean(editSvc.createPopupEditorWrapper(compDetails.params));
            const ePopupGui = wrapper.getGui();
            if (props.jsChildComp) {
                const eChildGui = props.jsChildComp.getGui();
                if (eChildGui) ePopupGui.appendChild(eChildGui);
            }
            const { column: column, rowNode: rowNode } = cellCtrl;
            const positionParams = {
                column: column,
                rowNode: rowNode,
                type: "popupCellEditor",
                eventSource: eParentCell,
                ePopup: ePopupGui,
                position: editDetails.popupPosition,
                keepWithinBounds: true
            };
            const positionCallback = popupSvc?.positionPopupByComponent.bind(popupSvc, positionParams);
            const addPopupRes = popupSvc?.addPopup({
                modal: useModelPopup,
                eChild: ePopupGui,
                closeOnEsc: true,
                closedCallback: ()=>{
                    cellCtrl.onPopupEditorClosed();
                },
                anchorToElement: eParentCell,
                positionCallback: positionCallback,
                ariaOwns: eParentCell
            });
            hideEditorPopup = addPopupRes ? addPopupRes.hideFunc : void 0;
            setPopupEditorWrapper(wrapper);
            props.jsChildComp?.afterGuiAttached?.();
        }
        return ()=>{
            hideEditorPopup?.();
            context.destroyBean(wrapper);
        };
    });
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (cellCtrl.isCellFocused() && popupEditorWrapper?.getGui().contains((0, $437b23f6a393c3bf$export$16bc98d422315038)(beans))) eParentCell.focus({
                preventScroll: true
            });
        };
    }, [
        popupEditorWrapper
    ]);
    return popupEditorWrapper && props.wrappedContent ? (0, $11492dca620dcaa5$exports.createPortal)(props.wrappedContent, popupEditorWrapper.getGui()) : null;
};
var $0e439ae7301dd858$var$popupEditorComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$PopupEditorComp);
// packages/ag-grid-react/src/reactUi/cells/cellEditorComp.tsx
var $0e439ae7301dd858$var$jsxEditorProxy = (editDetails, CellEditorClass, setRef2)=>{
    const { compProxy: compProxy } = editDetails;
    setRef2(compProxy);
    const props = compProxy.getProps();
    const isStateless = $0e439ae7301dd858$var$isComponentStateless(CellEditorClass);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$export$9f6317c67b47ac67.Provider, {
        value: {
            setMethods: (methods)=>compProxy.setMethods(methods)
        }
    }, isStateless ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellEditorClass, {
        ...props
    }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellEditorClass, {
        ...props,
        ref: (ref)=>compProxy.setRef(ref)
    }));
};
var $0e439ae7301dd858$var$jsxEditor = (editDetails, CellEditorClass, setRef2)=>{
    const newFormat = editDetails.compProxy;
    return newFormat ? $0e439ae7301dd858$var$jsxEditorProxy(editDetails, CellEditorClass, setRef2) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellEditorClass, {
        ...editDetails.compDetails.params,
        ref: setRef2
    });
};
var $0e439ae7301dd858$var$jsxEditValue = (editDetails, setCellEditorRef, eGui, cellCtrl, jsEditorComp)=>{
    const compDetails = editDetails.compDetails;
    const CellEditorClass = compDetails.componentClass;
    const reactInlineEditor = compDetails.componentFromFramework && !editDetails.popup;
    const reactPopupEditor = compDetails.componentFromFramework && editDetails.popup;
    const jsPopupEditor = !compDetails.componentFromFramework && editDetails.popup;
    return reactInlineEditor ? $0e439ae7301dd858$var$jsxEditor(editDetails, CellEditorClass, setCellEditorRef) : reactPopupEditor ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$popupEditorComp_default, {
        editDetails: editDetails,
        cellCtrl: cellCtrl,
        eParentCell: eGui,
        wrappedContent: $0e439ae7301dd858$var$jsxEditor(editDetails, CellEditorClass, setCellEditorRef)
    }) : jsPopupEditor && jsEditorComp ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$popupEditorComp_default, {
        editDetails: editDetails,
        cellCtrl: cellCtrl,
        eParentCell: eGui,
        jsChildComp: jsEditorComp
    }) : null;
};
var $0e439ae7301dd858$var$useJsCellRenderer = (showDetails, showTools, eCellValue, cellValueVersion, jsCellRendererRef, eGui)=>{
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const destroyCellRenderer = (0, $acw62.useCallback)(()=>{
        const comp = jsCellRendererRef.current;
        if (!comp) return;
        const compGui = comp.getGui();
        if (compGui && compGui.parentElement) compGui.remove();
        context.destroyBean(comp);
        jsCellRendererRef.current = void 0;
    }, []);
    (0, $acw62.useEffect)(()=>{
        const showValue = showDetails != null;
        const jsCompDetails = showDetails?.compDetails && !showDetails.compDetails.componentFromFramework;
        const waitingForToolsSetup = showTools && eCellValue == null;
        const showComp = showValue && jsCompDetails && !waitingForToolsSetup;
        if (!showComp) {
            destroyCellRenderer();
            return;
        }
        const compDetails = showDetails.compDetails;
        if (jsCellRendererRef.current) {
            const comp = jsCellRendererRef.current;
            const attemptRefresh = comp.refresh != null && showDetails.force == false;
            const refreshResult = attemptRefresh ? comp.refresh(compDetails.params) : false;
            const refreshWorked = refreshResult === true || refreshResult === void 0;
            if (refreshWorked) return;
            destroyCellRenderer();
        }
        const promise = compDetails.newAgStackInstance();
        promise.then((comp)=>{
            if (!comp) return;
            const compGui = comp.getGui();
            if (!compGui) return;
            const parent = showTools ? eCellValue : eGui.current;
            parent.appendChild(compGui);
            jsCellRendererRef.current = comp;
        });
    }, [
        showDetails,
        showTools,
        cellValueVersion
    ]);
    (0, $acw62.useEffect)(()=>{
        return destroyCellRenderer;
    }, []);
};
var $0e439ae7301dd858$var$showJsRenderer_default = $0e439ae7301dd858$var$useJsCellRenderer;
var $0e439ae7301dd858$var$SkeletonCellRenderer = ({ cellCtrl: cellCtrl, parent: parent })=>{
    const jsCellRendererRef = (0, $acw62.useRef)();
    const renderDetails = (0, $acw62.useMemo)(()=>{
        const { loadingComp: loadingComp } = cellCtrl.getDeferLoadingCellRenderer();
        return loadingComp ? {
            value: void 0,
            compDetails: loadingComp,
            force: false
        } : void 0;
    }, [
        cellCtrl
    ]);
    $0e439ae7301dd858$var$showJsRenderer_default(renderDetails, false, void 0, 1, jsCellRendererRef, parent);
    if (renderDetails?.compDetails?.componentFromFramework) {
        const CellRendererClass = renderDetails.compDetails.componentClass;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellRendererClass, {
            ...renderDetails.compDetails.params
        });
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};
// packages/ag-grid-react/src/reactUi/cells/cellComp.tsx
var $0e439ae7301dd858$var$CellComp = ({ cellCtrl: cellCtrl, printLayout: printLayout, editingCell: editingCell })=>{
    const beans = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { context: context } = beans;
    const { column: { colIdSanitised: colIdSanitised }, instanceId: instanceId } = cellCtrl;
    const compBean = (0, $acw62.useRef)();
    const [renderDetails, setRenderDetails] = (0, $acw62.useState)(()=>cellCtrl.isCellRenderer() ? void 0 : {
            compDetails: void 0,
            value: cellCtrl.getValueToDisplay(),
            force: false
        });
    const [editDetails, setEditDetails] = (0, $acw62.useState)();
    const [renderKey, setRenderKey] = (0, $acw62.useState)(1);
    const [userStyles, setUserStyles] = (0, $acw62.useState)();
    const [includeSelection, setIncludeSelection] = (0, $acw62.useState)(false);
    const [includeRowDrag, setIncludeRowDrag] = (0, $acw62.useState)(false);
    const [includeDndSource, setIncludeDndSource] = (0, $acw62.useState)(false);
    const [jsEditorComp, setJsEditorComp] = (0, $acw62.useState)();
    const forceWrapper = (0, $acw62.useMemo)(()=>cellCtrl.isForceWrapper(), [
        cellCtrl
    ]);
    const cellAriaRole = (0, $acw62.useMemo)(()=>cellCtrl.getCellAriaRole(), [
        cellCtrl
    ]);
    const eGui = (0, $acw62.useRef)(null);
    const eWrapper = (0, $acw62.useRef)(null);
    const cellRendererRef = (0, $acw62.useRef)(null);
    const jsCellRendererRef = (0, $acw62.useRef)();
    const cellEditorRef = (0, $acw62.useRef)();
    const eCellWrapper = (0, $acw62.useRef)();
    const cellWrapperDestroyFuncs = (0, $acw62.useRef)([]);
    const rowDragCompRef = (0, $acw62.useRef)();
    const eCellValue = (0, $acw62.useRef)();
    const [cellValueVersion, setCellValueVersion] = (0, $acw62.useState)(0);
    const setCellValueRef = (0, $acw62.useCallback)((ref)=>{
        eCellValue.current = ref;
        setCellValueVersion((v)=>v + 1);
    }, []);
    const showTools = renderDetails != null && (includeSelection || includeDndSource || includeRowDrag) && (editDetails == null || !!editDetails.popup);
    const showCellWrapper = forceWrapper || showTools;
    const cellValueClass = (0, $acw62.useMemo)(()=>{
        return cellCtrl.getCellValueClass();
    }, [
        cellCtrl
    ]);
    const setCellEditorRef = (0, $acw62.useCallback)((cellEditor)=>{
        cellEditorRef.current = cellEditor;
        if (cellEditor) {
            const editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
            setTimeout(()=>{
                if (editingCancelledByUserComp) {
                    cellCtrl.stopEditing(true);
                    cellCtrl.focusCell(true);
                } else {
                    cellCtrl.cellEditorAttached();
                    cellCtrl.enableEditorTooltipFeature(cellEditor);
                }
            });
        }
    }, [
        cellCtrl
    ]);
    const cssManager = (0, $acw62.useRef)();
    if (!cssManager.current) cssManager.current = new (0, $437b23f6a393c3bf$export$a7053cb7eb605bd2)(()=>eGui.current);
    $0e439ae7301dd858$var$showJsRenderer_default(renderDetails, showCellWrapper, eCellValue.current, cellValueVersion, jsCellRendererRef, eGui);
    const lastRenderDetails = (0, $acw62.useRef)();
    (0, $acw62.useLayoutEffect)(()=>{
        const oldDetails = lastRenderDetails.current;
        const newDetails = renderDetails;
        lastRenderDetails.current = renderDetails;
        if (oldDetails == null || oldDetails.compDetails == null || newDetails == null || newDetails.compDetails == null) return;
        rowDragCompRef.current?.refreshVisibility();
        const oldCompDetails = oldDetails.compDetails;
        const newCompDetails = newDetails.compDetails;
        if (oldCompDetails.componentClass != newCompDetails.componentClass) return;
        if (cellRendererRef.current?.refresh == null) return;
        const result = cellRendererRef.current.refresh(newCompDetails.params);
        if (result != true) setRenderKey((prev)=>prev + 1);
    }, [
        renderDetails
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        const doingJsEditor = editDetails && !editDetails.compDetails.componentFromFramework;
        if (!doingJsEditor || context.isDestroyed()) return;
        const compDetails = editDetails.compDetails;
        const isPopup = editDetails.popup === true;
        const cellEditorPromise = compDetails.newAgStackInstance();
        cellEditorPromise.then((cellEditor)=>{
            if (!cellEditor) return;
            const compGui = cellEditor.getGui();
            setCellEditorRef(cellEditor);
            if (!isPopup) {
                const parentEl = (forceWrapper ? eCellWrapper : eGui).current;
                parentEl?.appendChild(compGui);
                cellEditor.afterGuiAttached?.();
            }
            setJsEditorComp(cellEditor);
        });
        return ()=>{
            cellEditorPromise.then((cellEditor)=>{
                const compGui = cellEditor.getGui();
                cellCtrl.disableEditorTooltipFeature();
                context.destroyBean(cellEditor);
                setCellEditorRef(void 0);
                setJsEditorComp(void 0);
                compGui?.remove();
            });
        };
    }, [
        editDetails
    ]);
    const setCellWrapperRef = (0, $acw62.useCallback)((eRef)=>{
        eCellWrapper.current = eRef;
        if (!eRef || context.isDestroyed() || !cellCtrl.isAlive()) {
            const callbacks = cellWrapperDestroyFuncs.current;
            cellWrapperDestroyFuncs.current = [];
            for (const cb of callbacks)cb();
            return;
        }
        let rowDragComp;
        const addComp = (comp)=>{
            if (comp) {
                eRef.insertAdjacentElement("afterbegin", comp.getGui());
                cellWrapperDestroyFuncs.current.push(()=>{
                    (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(comp.getGui());
                    context.destroyBean(comp);
                    if (rowDragCompRef.current === rowDragComp) rowDragCompRef.current = void 0;
                });
            }
        };
        if (includeSelection) addComp(cellCtrl.createSelectionCheckbox());
        if (includeDndSource) addComp(cellCtrl.createDndSource());
        if (includeRowDrag) {
            rowDragComp = cellCtrl.createRowDragComp();
            rowDragCompRef.current = rowDragComp;
            if (rowDragComp) {
                addComp(rowDragComp);
                rowDragComp.refreshVisibility();
            }
        }
    }, [
        cellCtrl,
        context,
        includeDndSource,
        includeRowDrag,
        includeSelection
    ]);
    const init = (0, $acw62.useCallback)(()=>{
        const spanReady = !cellCtrl.isCellSpanning() || eWrapper.current;
        const eRef = eGui.current;
        if (!eRef || !spanReady || !cellCtrl || !cellCtrl.isAlive() || context.isDestroyed()) {
            compBean.current = context.destroyBean(compBean.current);
            return;
        }
        compBean.current = context.createBean(new (0, $437b23f6a393c3bf$export$4f8bbae47c6ad8d2)());
        const compProxy = {
            toggleCss: (name, on)=>cssManager.current.toggleCss(name, on),
            setUserStyles: (styles)=>setUserStyles(styles),
            getFocusableElement: ()=>eGui.current,
            setIncludeSelection: (include)=>setIncludeSelection(include),
            setIncludeRowDrag: (include)=>setIncludeRowDrag(include),
            setIncludeDndSource: (include)=>setIncludeDndSource(include),
            getCellEditor: ()=>cellEditorRef.current ?? null,
            getCellRenderer: ()=>cellRendererRef.current ?? jsCellRendererRef.current,
            getParentOfValue: ()=>eCellValue.current ?? eCellWrapper.current ?? eGui.current,
            setRenderDetails: (compDetails, value, force)=>{
                const setDetails = ()=>{
                    setRenderDetails((prev)=>{
                        if (prev?.compDetails !== compDetails || prev?.value !== value || prev?.force !== force) return {
                            value: value,
                            compDetails: compDetails,
                            force: force
                        };
                        else return prev;
                    });
                };
                if (compDetails?.params?.deferRender && !cellCtrl.rowNode.group) {
                    const { loadingComp: loadingComp, onReady: onReady } = cellCtrl.getDeferLoadingCellRenderer();
                    if (loadingComp) {
                        setRenderDetails({
                            value: void 0,
                            compDetails: loadingComp,
                            force: false
                        });
                        onReady.then(()=>$0e439ae7301dd858$var$agStartTransition(setDetails));
                        return;
                    }
                }
                setDetails();
            },
            setEditDetails: (compDetails, popup, popupPosition, reactiveCustomComponents)=>{
                if (compDetails) {
                    let compProxy2 = void 0;
                    if (compDetails.componentFromFramework) {
                        if (reactiveCustomComponents) compProxy2 = new $0e439ae7301dd858$var$CellEditorComponentProxy(compDetails.params, ()=>setRenderKey((prev)=>prev + 1));
                        else $0e439ae7301dd858$export$e83e01bcf62967be();
                    }
                    setEditDetails({
                        compDetails: compDetails,
                        popup: popup,
                        popupPosition: popupPosition,
                        compProxy: compProxy2
                    });
                    if (!popup) setRenderDetails(void 0);
                } else {
                    const recoverFocus = cellCtrl.hasBrowserFocus();
                    if (recoverFocus) compProxy.getFocusableElement().focus({
                        preventScroll: true
                    });
                    cellEditorRef.current = void 0;
                    setEditDetails(void 0);
                }
            },
            refreshEditStyles: (editing, isPopup)=>{
                if (!eGui.current) return;
                const { current: current } = cssManager;
                current.toggleCss("ag-cell-value", !showCellWrapper);
                current.toggleCss("ag-cell-inline-editing", !!editing && !isPopup);
                current.toggleCss("ag-cell-popup-editing", !!editing && !!isPopup);
                current.toggleCss("ag-cell-not-inline-editing", !editing || !!isPopup);
            }
        };
        const cellWrapperOrUndefined = eCellWrapper.current || void 0;
        cellCtrl.setComp(compProxy, eRef, eWrapper.current ?? void 0, cellWrapperOrUndefined, printLayout, editingCell, compBean.current);
    }, []);
    const setGuiRef = (0, $acw62.useCallback)((ref)=>{
        eGui.current = ref;
        init();
    }, []);
    const setWrapperRef = (0, $acw62.useCallback)((ref)=>{
        eWrapper.current = ref;
        init();
    }, []);
    const reactCellRendererStateless = (0, $acw62.useMemo)(()=>{
        const res = renderDetails?.compDetails?.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(renderDetails.compDetails.componentClass);
        return !!res;
    }, [
        renderDetails
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (!eGui.current) return;
        const { current: current } = cssManager;
        current.toggleCss("ag-cell-value", !showCellWrapper);
        current.toggleCss("ag-cell-inline-editing", !!editDetails && !editDetails.popup);
        current.toggleCss("ag-cell-popup-editing", !!editDetails && !!editDetails.popup);
        current.toggleCss("ag-cell-not-inline-editing", !editDetails || !!editDetails.popup);
    });
    const valueOrCellComp = ()=>{
        const { compDetails: compDetails, value: value } = renderDetails;
        if (!compDetails) return value?.toString?.() ?? value;
        if (compDetails.componentFromFramework) {
            const CellRendererClass = compDetails.componentClass;
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
                fallback: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$SkeletonCellRenderer, {
                    cellCtrl: cellCtrl,
                    parent: eGui
                })
            }, reactCellRendererStateless ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellRendererClass, {
                ...compDetails.params,
                key: renderKey
            }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellRendererClass, {
                ...compDetails.params,
                key: renderKey,
                ref: cellRendererRef
            }));
        }
    };
    const showCellOrEditor = ()=>{
        const showCellValue = ()=>{
            if (renderDetails == null) return null;
            return showCellWrapper ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                role: "presentation",
                id: `cell-${instanceId}`,
                className: cellValueClass,
                ref: setCellValueRef
            }, valueOrCellComp()) : valueOrCellComp();
        };
        const showEditValue = (details)=>$0e439ae7301dd858$var$jsxEditValue(details, setCellEditorRef, eGui.current, cellCtrl, jsEditorComp);
        if (editDetails != null) {
            if (editDetails.popup) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, showCellValue(), showEditValue(editDetails));
            return showEditValue(editDetails);
        }
        return showCellValue();
    };
    const renderCell = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: setGuiRef,
            style: userStyles,
            role: cellAriaRole,
            "col-id": colIdSanitised
        }, showCellWrapper ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ag-cell-wrapper",
            role: "presentation",
            ref: setCellWrapperRef
        }, showCellOrEditor()) : showCellOrEditor());
    if (cellCtrl.isCellSpanning()) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setWrapperRef,
        className: "ag-spanned-cell-wrapper",
        role: "presentation"
    }, renderCell());
    return renderCell();
};
var $0e439ae7301dd858$var$cellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$CellComp);
// packages/ag-grid-react/src/reactUi/rows/rowComp.tsx
var $0e439ae7301dd858$var$RowComp = ({ rowCtrl: rowCtrl, containerType: containerType })=>{
    const { context: context, gos: gos, editSvc: editSvc } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const enableUses = (0, $acw62.useContext)($0e439ae7301dd858$var$RenderModeContext) === "default";
    const compBean = (0, $acw62.useRef)();
    const domOrderRef = (0, $acw62.useRef)(rowCtrl.getDomOrder());
    const isFullWidth = rowCtrl.isFullWidth();
    const isDisplayed = rowCtrl.rowNode.displayed;
    const [rowIndex, setRowIndex] = (0, $acw62.useState)(()=>isDisplayed ? rowCtrl.rowNode.getRowIndexString() : null);
    const [rowId, setRowId] = (0, $acw62.useState)(()=>rowCtrl.rowId);
    const [rowBusinessKey, setRowBusinessKey] = (0, $acw62.useState)(()=>rowCtrl.businessKey);
    const [userStyles, setUserStyles] = (0, $acw62.useState)(()=>rowCtrl.rowStyles);
    const cellCtrlsRef = (0, $acw62.useRef)(null);
    const [cellCtrlsFlushSync, setCellCtrlsFlushSync] = (0, $acw62.useState)(()=>null);
    const [fullWidthCompDetails, setFullWidthCompDetails] = (0, $acw62.useState)();
    const [top, setTop] = (0, $acw62.useState)(()=>isDisplayed ? rowCtrl.getInitialRowTop(containerType) : void 0);
    const [transform, setTransform] = (0, $acw62.useState)(()=>isDisplayed ? rowCtrl.getInitialTransform(containerType) : void 0);
    const eGui = (0, $acw62.useRef)(null);
    const fullWidthCompRef = (0, $acw62.useRef)();
    const fullWidthParamsRef = (0, $acw62.useRef)();
    const autoHeightSetup = (0, $acw62.useRef)(false);
    const [autoHeightSetupAttempt, setAutoHeightSetupAttempt] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (autoHeightSetup.current || !fullWidthCompDetails || autoHeightSetupAttempt > 10) return;
        const eChild = eGui.current?.firstChild;
        if (eChild) {
            rowCtrl.setupDetailRowAutoHeight(eChild);
            autoHeightSetup.current = true;
        } else setAutoHeightSetupAttempt((prev)=>prev + 1);
    }, [
        fullWidthCompDetails,
        autoHeightSetupAttempt
    ]);
    const cssManager = (0, $acw62.useRef)();
    if (!cssManager.current) cssManager.current = new (0, $437b23f6a393c3bf$export$a7053cb7eb605bd2)(()=>eGui.current);
    const cellsChanged = (0, $acw62.useRef)(()=>{});
    const sub = (0, $acw62.useCallback)((onStoreChange)=>{
        cellsChanged.current = onStoreChange;
        return ()=>{
            cellsChanged.current = ()=>{};
        };
    }, []);
    const cellCtrlsUses = $0e439ae7301dd858$var$agUseSyncExternalStore(sub, ()=>{
        return cellCtrlsRef.current;
    }, []);
    const cellCtrlsMerged = enableUses ? cellCtrlsUses : cellCtrlsFlushSync;
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        compBean.current = eRef ? context.createBean(new (0, $437b23f6a393c3bf$export$4f8bbae47c6ad8d2)()) : context.destroyBean(compBean.current);
        if (!eRef) {
            rowCtrl.unsetComp(containerType);
            return;
        }
        if (!rowCtrl.isAlive() || context.isDestroyed()) return;
        const compProxy = {
            setTop: // the rowTop is managed by state, instead of direct style manipulation by rowCtrl (like all the other styles)
            // as we need to have an initial value when it's placed into he DOM for the first time, for animation to work.
            setTop,
            setTransform: setTransform,
            // i found using React for managing classes at the row level was to slow, as modifying classes caused a lot of
            // React code to execute, so avoiding React for managing CSS Classes made the grid go much faster.
            toggleCss: (name, on)=>cssManager.current.toggleCss(name, on),
            setDomOrder: (domOrder)=>domOrderRef.current = domOrder,
            setRowIndex: setRowIndex,
            setRowId: setRowId,
            setRowBusinessKey: setRowBusinessKey,
            setUserStyles: setUserStyles,
            // if we don't maintain the order, then cols will be ripped out and into the dom
            // when cols reordered, which would stop the CSS transitions from working
            setCellCtrls: (next, useFlushSync)=>{
                const prevCellCtrls = cellCtrlsRef.current;
                const nextCells = $0e439ae7301dd858$var$getNextValueIfDifferent(prevCellCtrls, next, domOrderRef.current);
                if (nextCells !== prevCellCtrls) {
                    cellCtrlsRef.current = nextCells;
                    if (enableUses) cellsChanged.current();
                    else $0e439ae7301dd858$var$agFlushSync(useFlushSync, ()=>setCellCtrlsFlushSync(nextCells));
                }
            },
            showFullWidth: (compDetails)=>{
                fullWidthParamsRef.current = compDetails.params;
                setFullWidthCompDetails(compDetails);
            },
            getFullWidthCellRenderer: ()=>fullWidthCompRef.current,
            getFullWidthCellRendererParams: ()=>fullWidthParamsRef.current,
            refreshFullWidth: (getUpdatedParams)=>{
                const fullWidthParams = getUpdatedParams();
                fullWidthParamsRef.current = fullWidthParams;
                if (canRefreshFullWidthRef.current) {
                    setFullWidthCompDetails((prevFullWidthCompDetails)=>({
                            ...prevFullWidthCompDetails,
                            params: fullWidthParams
                        }));
                    return true;
                } else {
                    if (!fullWidthCompRef.current || !fullWidthCompRef.current.refresh) return false;
                    return fullWidthCompRef.current.refresh(fullWidthParams);
                }
            }
        };
        rowCtrl.setComp(compProxy, eRef, containerType, compBean.current);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(fullWidthCompDetails, context, eGui.current, fullWidthCompRef), [
        fullWidthCompDetails
    ]);
    const rowStyles = (0, $acw62.useMemo)(()=>{
        const res = {
            top: top,
            transform: transform
        };
        Object.assign(res, userStyles);
        return res;
    }, [
        top,
        transform,
        userStyles
    ]);
    const showFullWidthFramework = isFullWidth && fullWidthCompDetails?.componentFromFramework;
    const showCells = !isFullWidth && cellCtrlsMerged != null;
    const reactFullWidthCellRendererStateless = (0, $acw62.useMemo)(()=>{
        const res = fullWidthCompDetails?.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(fullWidthCompDetails.componentClass);
        return !!res;
    }, [
        fullWidthCompDetails
    ]);
    const canRefreshFullWidthRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        canRefreshFullWidthRef.current = reactFullWidthCellRendererStateless && !!fullWidthCompDetails && !!gos.get("reactiveCustomComponents");
    }, [
        reactFullWidthCellRendererStateless,
        fullWidthCompDetails
    ]);
    const showCellsJsx = ()=>cellCtrlsMerged?.map((cellCtrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$cellComp_default, {
                cellCtrl: cellCtrl,
                editingCell: editSvc?.isEditing(cellCtrl, {
                    withOpenEditor: true
                }) ?? false,
                printLayout: rowCtrl.printLayout,
                key: cellCtrl.instanceId
            }));
    const showFullWidthFrameworkJsx = ()=>{
        const FullWidthComp = fullWidthCompDetails.componentClass;
        return reactFullWidthCellRendererStateless ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FullWidthComp, {
            ...fullWidthCompDetails.params
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FullWidthComp, {
            ...fullWidthCompDetails.params,
            ref: fullWidthCompRef
        });
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        role: "row",
        style: rowStyles,
        "row-index": rowIndex,
        "row-id": rowId,
        "row-business-key": rowBusinessKey
    }, showCells ? showCellsJsx() : showFullWidthFramework ? showFullWidthFrameworkJsx() : null);
};
var $0e439ae7301dd858$var$rowComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$RowComp);
// packages/ag-grid-react/src/reactUi/rows/rowContainerComp.tsx
var $0e439ae7301dd858$var$RowContainerComp = ({ name: name })=>{
    const { context: context, gos: gos } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const containerOptions = (0, $acw62.useMemo)(()=>(0, $437b23f6a393c3bf$export$a46aad9f8c79261f)(name), [
        name
    ]);
    const eViewport = (0, $acw62.useRef)(null);
    const eContainer = (0, $acw62.useRef)(null);
    const eSpanContainer = (0, $acw62.useRef)(null);
    const rowCtrlsRef = (0, $acw62.useRef)([]);
    const prevRowCtrlsRef = (0, $acw62.useRef)([]);
    const [rowCtrlsOrdered, setRowCtrlsOrdered] = (0, $acw62.useState)(()=>[]);
    const isSpanning = !!gos.get("enableCellSpan") && !!containerOptions.getSpannedRowCtrls;
    const spannedRowCtrlsRef = (0, $acw62.useRef)([]);
    const prevSpannedRowCtrlsRef = (0, $acw62.useRef)([]);
    const [spannedRowCtrlsOrdered, setSpannedRowCtrlsOrdered] = (0, $acw62.useState)(()=>[]);
    const domOrderRef = (0, $acw62.useRef)(false);
    const rowContainerCtrlRef = (0, $acw62.useRef)();
    const viewportClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-viewport", (0, $437b23f6a393c3bf$export$65619730ec980d6a)(name)), [
        name
    ]);
    const containerClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList((0, $437b23f6a393c3bf$export$35e1b2dddf7fc6e9)(name)), [
        name
    ]);
    const spanClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-spanning-container", (0, $437b23f6a393c3bf$export$cd6b90bdf6c4fcfd)(name)), [
        name
    ]);
    const shouldRenderViewport = containerOptions.type === "center" || isSpanning;
    const topLevelRef = shouldRenderViewport ? eViewport : eContainer;
    $0e439ae7301dd858$var$reactComment_default(" AG Row Container " + name + " ", topLevelRef);
    const areElementsReady = (0, $acw62.useCallback)(()=>{
        const viewportReady = !shouldRenderViewport || eViewport.current != null;
        const containerReady = eContainer.current != null;
        const spanContainerReady = !isSpanning || eSpanContainer.current != null;
        return viewportReady && containerReady && spanContainerReady;
    }, []);
    const areElementsRemoved = (0, $acw62.useCallback)(()=>{
        return eViewport.current == null && eContainer.current == null && eSpanContainer.current == null;
    }, []);
    const setRef2 = (0, $acw62.useCallback)(()=>{
        if (areElementsRemoved()) rowContainerCtrlRef.current = context.destroyBean(rowContainerCtrlRef.current);
        if (context.isDestroyed()) return;
        if (areElementsReady()) {
            const updateRowCtrlsOrdered = (useFlushSync)=>{
                const next = $0e439ae7301dd858$var$getNextValueIfDifferent(prevRowCtrlsRef.current, rowCtrlsRef.current, domOrderRef.current);
                if (next !== prevRowCtrlsRef.current) {
                    prevRowCtrlsRef.current = next;
                    $0e439ae7301dd858$var$agFlushSync(useFlushSync, ()=>setRowCtrlsOrdered(next));
                }
            };
            const updateSpannedRowCtrlsOrdered = (useFlushSync)=>{
                const next = $0e439ae7301dd858$var$getNextValueIfDifferent(prevSpannedRowCtrlsRef.current, spannedRowCtrlsRef.current, domOrderRef.current);
                if (next !== prevSpannedRowCtrlsRef.current) {
                    prevSpannedRowCtrlsRef.current = next;
                    $0e439ae7301dd858$var$agFlushSync(useFlushSync, ()=>setSpannedRowCtrlsOrdered(next));
                }
            };
            const compProxy = {
                setHorizontalScroll: (offset)=>{
                    if (eViewport.current) eViewport.current.scrollLeft = offset;
                },
                setViewportHeight: (height)=>{
                    if (eViewport.current) eViewport.current.style.height = height;
                },
                setRowCtrls: ({ rowCtrls: rowCtrls, useFlushSync: useFlushSync })=>{
                    const useFlush = !!useFlushSync && rowCtrlsRef.current.length > 0 && rowCtrls.length > 0;
                    rowCtrlsRef.current = rowCtrls;
                    updateRowCtrlsOrdered(useFlush);
                },
                setSpannedRowCtrls: (rowCtrls, useFlushSync)=>{
                    const useFlush = !!useFlushSync && spannedRowCtrlsRef.current.length > 0 && rowCtrls.length > 0;
                    spannedRowCtrlsRef.current = rowCtrls;
                    updateSpannedRowCtrlsOrdered(useFlush);
                },
                setDomOrder: (domOrder)=>{
                    if (domOrderRef.current != domOrder) {
                        domOrderRef.current = domOrder;
                        updateRowCtrlsOrdered(false);
                    }
                },
                setContainerWidth: (width)=>{
                    if (eContainer.current) eContainer.current.style.width = width;
                },
                setOffsetTop: (offset)=>{
                    if (eContainer.current) eContainer.current.style.transform = `translateY(${offset})`;
                }
            };
            rowContainerCtrlRef.current = context.createBean(new (0, $437b23f6a393c3bf$export$2d4385f6f566fe5e)(name));
            rowContainerCtrlRef.current.setComp(compProxy, eContainer.current, eSpanContainer.current ?? void 0, eViewport.current);
        }
    }, [
        areElementsReady,
        areElementsRemoved
    ]);
    const setContainerRef = (0, $acw62.useCallback)((e)=>{
        eContainer.current = e;
        setRef2();
    }, [
        setRef2
    ]);
    const setSpanContainerRef = (0, $acw62.useCallback)((e)=>{
        eSpanContainer.current = e;
        setRef2();
    }, [
        setRef2
    ]);
    const setViewportRef = (0, $acw62.useCallback)((e)=>{
        eViewport.current = e;
        setRef2();
    }, [
        setRef2
    ]);
    const buildContainer = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: containerClasses,
            ref: setContainerRef,
            role: shouldRenderViewport ? "presentation" : "rowgroup"
        }, rowCtrlsOrdered.map((rowCtrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$rowComp_default, {
                rowCtrl: rowCtrl,
                containerType: containerOptions.type,
                key: rowCtrl.instanceId
            })));
    if (!shouldRenderViewport) return buildContainer();
    const buildSpanContainer = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: spanClasses,
            ref: setSpanContainerRef,
            role: "presentation"
        }, spannedRowCtrlsOrdered.map((rowCtrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$rowComp_default, {
                rowCtrl: rowCtrl,
                containerType: containerOptions.type,
                key: rowCtrl.instanceId
            })));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: viewportClasses,
        ref: setViewportRef,
        role: "rowgroup"
    }, buildContainer(), isSpanning ? buildSpanContainer() : null);
};
var $0e439ae7301dd858$var$rowContainerComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$RowContainerComp);
// packages/ag-grid-react/src/reactUi/gridBodyComp.tsx
var $0e439ae7301dd858$var$GridBodyComp = ()=>{
    const beans = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { context: context, overlays: overlays } = beans;
    const [rowAnimationClass, setRowAnimationClass] = (0, $acw62.useState)("");
    const [topHeight, setTopHeight] = (0, $acw62.useState)(0);
    const [bottomHeight, setBottomHeight] = (0, $acw62.useState)(0);
    const [stickyTopHeight, setStickyTopHeight] = (0, $acw62.useState)("0px");
    const [stickyTopTop, setStickyTopTop] = (0, $acw62.useState)("0px");
    const [stickyTopWidth, setStickyTopWidth] = (0, $acw62.useState)("100%");
    const [stickyBottomHeight, setStickyBottomHeight] = (0, $acw62.useState)("0px");
    const [stickyBottomBottom, setStickyBottomBottom] = (0, $acw62.useState)("0px");
    const [stickyBottomWidth, setStickyBottomWidth] = (0, $acw62.useState)("100%");
    const [topInvisible, setTopInvisible] = (0, $acw62.useState)(true);
    const [bottomInvisible, setBottomInvisible] = (0, $acw62.useState)(true);
    const [forceVerticalScrollClass, setForceVerticalScrollClass] = (0, $acw62.useState)(null);
    const [topAndBottomOverflowY, setTopAndBottomOverflowY] = (0, $acw62.useState)("");
    const [cellSelectableCss, setCellSelectableCss] = (0, $acw62.useState)(null);
    const [layoutClass, setLayoutClass] = (0, $acw62.useState)("ag-layout-normal");
    const cssManager = (0, $acw62.useRef)();
    if (!cssManager.current) cssManager.current = new (0, $437b23f6a393c3bf$export$a7053cb7eb605bd2)(()=>eRoot.current);
    const eRoot = (0, $acw62.useRef)(null);
    const eTop = (0, $acw62.useRef)(null);
    const eStickyTop = (0, $acw62.useRef)(null);
    const eStickyBottom = (0, $acw62.useRef)(null);
    const eBody = (0, $acw62.useRef)(null);
    const eBodyViewport = (0, $acw62.useRef)(null);
    const eBottom = (0, $acw62.useRef)(null);
    const beansToDestroy = (0, $acw62.useRef)([]);
    const destroyFuncs = (0, $acw62.useRef)([]);
    $0e439ae7301dd858$var$reactComment_default(" AG Grid Body ", eRoot);
    $0e439ae7301dd858$var$reactComment_default(" AG Pinned Top ", eTop);
    $0e439ae7301dd858$var$reactComment_default(" AG Sticky Top ", eStickyTop);
    $0e439ae7301dd858$var$reactComment_default(" AG Middle ", eBodyViewport);
    $0e439ae7301dd858$var$reactComment_default(" AG Pinned Bottom ", eBottom);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eRoot.current = eRef;
        if (!eRef || context.isDestroyed()) {
            beansToDestroy.current = context.destroyBeans(beansToDestroy.current);
            for (const f of destroyFuncs.current)f();
            destroyFuncs.current = [];
            return;
        }
        const attachToDom = (eParent, eChild)=>{
            eParent.appendChild(eChild);
            destroyFuncs.current.push(()=>eChild.remove());
        };
        const newComp = (compClass)=>{
            const comp = context.createBean(new compClass());
            beansToDestroy.current.push(comp);
            return comp;
        };
        const addComp = (eParent, compClass, comment)=>{
            attachToDom(eParent, document.createComment(comment));
            attachToDom(eParent, newComp(compClass).getGui());
        };
        addComp(eRef, (0, $437b23f6a393c3bf$export$8f252e09ef6be2d3), " AG Fake Horizontal Scroll ");
        const overlayComp = overlays?.getOverlayWrapperCompClass();
        if (overlayComp) addComp(eRef, overlayComp, " AG Overlay Wrapper ");
        if (eBody.current) addComp(eBody.current, (0, $437b23f6a393c3bf$export$f496fc30dbebdfa3), " AG Fake Vertical Scroll ");
        const compProxy = {
            setRowAnimationCssOnBodyViewport: setRowAnimationClass,
            setColumnCount: (count)=>{
                if (eRoot.current) (0, $437b23f6a393c3bf$export$56744a26086b5898)(eRoot.current, count);
            },
            setRowCount: (count)=>{
                if (eRoot.current) (0, $437b23f6a393c3bf$export$1ad8496b26b660f8)(eRoot.current, count);
            },
            setTopHeight: setTopHeight,
            setBottomHeight: setBottomHeight,
            setStickyTopHeight: setStickyTopHeight,
            setStickyTopTop: setStickyTopTop,
            setStickyTopWidth: setStickyTopWidth,
            setTopInvisible: setTopInvisible,
            setBottomInvisible: setBottomInvisible,
            setColumnMovingCss: (cssClass, flag)=>cssManager.current.toggleCss(cssClass, flag),
            updateLayoutClasses: setLayoutClass,
            setAlwaysVerticalScrollClass: setForceVerticalScrollClass,
            setPinnedTopBottomOverflowY: setTopAndBottomOverflowY,
            setCellSelectableCss: (cssClass, flag)=>setCellSelectableCss(flag ? cssClass : null),
            setBodyViewportWidth: (width)=>{
                if (eBodyViewport.current) eBodyViewport.current.style.width = width;
            },
            registerBodyViewportResizeListener: (listener)=>{
                if (eBodyViewport.current) {
                    const unsubscribeFromResize = (0, $437b23f6a393c3bf$export$9aef8476630687be)(beans, eBodyViewport.current, listener);
                    destroyFuncs.current.push(()=>unsubscribeFromResize());
                }
            },
            setStickyBottomHeight: setStickyBottomHeight,
            setStickyBottomBottom: setStickyBottomBottom,
            setStickyBottomWidth: setStickyBottomWidth,
            setGridRootRole: (role)=>eRef.setAttribute("role", role)
        };
        const ctrl = context.createBean(new (0, $437b23f6a393c3bf$export$8bebc3145b40d221)());
        beansToDestroy.current.push(ctrl);
        ctrl.setComp(compProxy, eRef, eBodyViewport.current, eTop.current, eBottom.current, eStickyTop.current, eStickyBottom.current);
    }, []);
    const rootClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-root", "ag-unselectable", layoutClass), [
        layoutClass
    ]);
    const bodyViewportClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-body-viewport", rowAnimationClass, layoutClass, forceVerticalScrollClass, cellSelectableCss), [
        rowAnimationClass,
        layoutClass,
        forceVerticalScrollClass,
        cellSelectableCss
    ]);
    const bodyClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-body", layoutClass), [
        layoutClass
    ]);
    const topClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-floating-top", topInvisible ? "ag-invisible" : null, cellSelectableCss), [
        cellSelectableCss,
        topInvisible
    ]);
    const stickyTopClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-sticky-top", cellSelectableCss), [
        cellSelectableCss
    ]);
    const stickyBottomClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-sticky-bottom", stickyBottomHeight === "0px" ? "ag-invisible" : null, cellSelectableCss), [
        cellSelectableCss,
        stickyBottomHeight
    ]);
    const bottomClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-floating-bottom", bottomInvisible ? "ag-invisible" : null, cellSelectableCss), [
        cellSelectableCss,
        bottomInvisible
    ]);
    const topStyle = (0, $acw62.useMemo)(()=>({
            height: topHeight,
            minHeight: topHeight,
            overflowY: topAndBottomOverflowY
        }), [
        topHeight,
        topAndBottomOverflowY
    ]);
    const stickyTopStyle = (0, $acw62.useMemo)(()=>({
            height: stickyTopHeight,
            top: stickyTopTop,
            width: stickyTopWidth
        }), [
        stickyTopHeight,
        stickyTopTop,
        stickyTopWidth
    ]);
    const stickyBottomStyle = (0, $acw62.useMemo)(()=>({
            height: stickyBottomHeight,
            bottom: stickyBottomBottom,
            width: stickyBottomWidth
        }), [
        stickyBottomHeight,
        stickyBottomBottom,
        stickyBottomWidth
    ]);
    const bottomStyle = (0, $acw62.useMemo)(()=>({
            height: bottomHeight,
            minHeight: bottomHeight,
            overflowY: topAndBottomOverflowY
        }), [
        bottomHeight,
        topAndBottomOverflowY
    ]);
    const createRowContainer = (container)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$rowContainerComp_default, {
            name: container,
            key: `${container}-container`
        });
    const createSection = ({ section: section, children: children, className: className, style: style })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: section,
            className: className,
            role: "presentation",
            style: style
        }, children.map(createRowContainer));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: rootClasses
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$gridHeaderComp_default, null), createSection({
        section: eTop,
        className: topClasses,
        style: topStyle,
        children: [
            "topLeft",
            "topCenter",
            "topRight",
            "topFullWidth"
        ]
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: bodyClasses,
        ref: eBody,
        role: "presentation"
    }, createSection({
        section: eBodyViewport,
        className: bodyViewportClasses,
        children: [
            "left",
            "center",
            "right",
            "fullWidth"
        ]
    })), createSection({
        section: eStickyTop,
        className: stickyTopClasses,
        style: stickyTopStyle,
        children: [
            "stickyTopLeft",
            "stickyTopCenter",
            "stickyTopRight",
            "stickyTopFullWidth"
        ]
    }), createSection({
        section: eStickyBottom,
        className: stickyBottomClasses,
        style: stickyBottomStyle,
        children: [
            "stickyBottomLeft",
            "stickyBottomCenter",
            "stickyBottomRight",
            "stickyBottomFullWidth"
        ]
    }), createSection({
        section: eBottom,
        className: bottomClasses,
        style: bottomStyle,
        children: [
            "bottomLeft",
            "bottomCenter",
            "bottomRight",
            "bottomFullWidth"
        ]
    }));
};
var $0e439ae7301dd858$var$gridBodyComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$GridBodyComp);
var $0e439ae7301dd858$var$TabGuardCompRef = (props, forwardRef4)=>{
    const { children: children, eFocusableElement: eFocusableElement, onTabKeyDown: onTabKeyDown, gridCtrl: gridCtrl, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, isEmpty: isEmpty } = props;
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const topTabGuardRef = (0, $acw62.useRef)(null);
    const bottomTabGuardRef = (0, $acw62.useRef)(null);
    const tabGuardCtrlRef = (0, $acw62.useRef)();
    const setTabIndex = (value)=>{
        const processedValue = value == null ? void 0 : parseInt(value, 10).toString();
        for (const tabGuard of [
            topTabGuardRef,
            bottomTabGuardRef
        ])if (processedValue === void 0) tabGuard.current?.removeAttribute("tabindex");
        else tabGuard.current?.setAttribute("tabindex", processedValue);
    };
    (0, $acw62.useImperativeHandle)(forwardRef4, ()=>({
            forceFocusOutOfContainer (up) {
                tabGuardCtrlRef.current?.forceFocusOutOfContainer(up);
            }
        }));
    const setupCtrl = (0, $acw62.useCallback)(()=>{
        const topTabGuard = topTabGuardRef.current;
        const bottomTabGuard = bottomTabGuardRef.current;
        if (!topTabGuard && !bottomTabGuard || context.isDestroyed()) {
            tabGuardCtrlRef.current = context.destroyBean(tabGuardCtrlRef.current);
            return;
        }
        if (topTabGuard && bottomTabGuard) {
            const compProxy = {
                setTabIndex: setTabIndex
            };
            tabGuardCtrlRef.current = context.createBean(new (0, $437b23f6a393c3bf$export$3074753638c3772c)({
                comp: compProxy,
                eTopGuard: topTabGuard,
                eBottomGuard: bottomTabGuard,
                eFocusableElement: eFocusableElement,
                onTabKeyDown: onTabKeyDown,
                forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty,
                focusInnerElement: (fromBottom)=>gridCtrl.focusInnerElement(fromBottom),
                isEmpty: isEmpty
            }));
        }
    }, []);
    const setTopRef = (0, $acw62.useCallback)((e)=>{
        topTabGuardRef.current = e;
        setupCtrl();
    }, [
        setupCtrl
    ]);
    const setBottomRef = (0, $acw62.useCallback)((e)=>{
        bottomTabGuardRef.current = e;
        setupCtrl();
    }, [
        setupCtrl
    ]);
    const createTabGuard = (side)=>{
        const className = side === "top" ? (0, $437b23f6a393c3bf$export$3be5727576441c72).TAB_GUARD_TOP : (0, $437b23f6a393c3bf$export$3be5727576441c72).TAB_GUARD_BOTTOM;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: `${(0, $437b23f6a393c3bf$export$3be5727576441c72).TAB_GUARD} ${className}`,
            role: "presentation",
            ref: side === "top" ? setTopRef : setBottomRef
        });
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, createTabGuard("top"), children, createTabGuard("bottom"));
};
var $0e439ae7301dd858$var$TabGuardComp = (0, $acw62.forwardRef)($0e439ae7301dd858$var$TabGuardCompRef);
var $0e439ae7301dd858$var$tabGuardComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$TabGuardComp);
// packages/ag-grid-react/src/reactUi/gridComp.tsx
var $0e439ae7301dd858$var$GridComp = ({ context: context })=>{
    const [rtlClass, setRtlClass] = (0, $acw62.useState)("");
    const [layoutClass, setLayoutClass] = (0, $acw62.useState)("");
    const [cursor, setCursor] = (0, $acw62.useState)(null);
    const [userSelect, setUserSelect] = (0, $acw62.useState)(null);
    const [initialised, setInitialised] = (0, $acw62.useState)(false);
    const [tabGuardReady, setTabGuardReady] = (0, $acw62.useState)();
    const gridCtrlRef = (0, $acw62.useRef)();
    const eRootWrapperRef = (0, $acw62.useRef)(null);
    const tabGuardRef = (0, $acw62.useRef)();
    const [eGridBodyParent, setGridBodyParent] = (0, $acw62.useState)(null);
    const focusInnerElementRef = (0, $acw62.useRef)(()=>void 0);
    const paginationCompRef = (0, $acw62.useRef)();
    const focusableContainersRef = (0, $acw62.useRef)([]);
    const onTabKeyDown = (0, $acw62.useCallback)(()=>void 0, []);
    $0e439ae7301dd858$var$reactComment_default(" AG Grid ", eRootWrapperRef);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eRootWrapperRef.current = eRef;
        gridCtrlRef.current = eRef ? context.createBean(new (0, $437b23f6a393c3bf$export$f3c741dac0be9745)()) : context.destroyBean(gridCtrlRef.current);
        if (!eRef || context.isDestroyed()) return;
        const gridCtrl = gridCtrlRef.current;
        focusInnerElementRef.current = gridCtrl.focusInnerElement.bind(gridCtrl);
        const compProxy = {
            destroyGridUi: ()=>{},
            setRtlClass: // do nothing, as framework users destroy grid by removing the comp
            setRtlClass,
            forceFocusOutOfContainer: (up)=>{
                if (!up && paginationCompRef.current?.isDisplayed()) {
                    paginationCompRef.current.forceFocusOutOfContainer(up);
                    return;
                }
                tabGuardRef.current?.forceFocusOutOfContainer(up);
            },
            updateLayoutClasses: setLayoutClass,
            getFocusableContainers: ()=>{
                const comps = [];
                const gridBodyCompEl = eRootWrapperRef.current?.querySelector(".ag-root");
                if (gridBodyCompEl) comps.push({
                    getGui: ()=>gridBodyCompEl
                });
                for (const comp of focusableContainersRef.current)if (comp.isDisplayed()) comps.push(comp);
                return comps;
            },
            setCursor: setCursor,
            setUserSelect: setUserSelect
        };
        gridCtrl.setComp(compProxy, eRef, eRef);
        setInitialised(true);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const gridCtrl = gridCtrlRef.current;
        const eRootWrapper = eRootWrapperRef.current;
        if (!tabGuardReady || !gridCtrl || !eGridBodyParent || !eRootWrapper || context.isDestroyed()) return;
        const beansToDestroy = [];
        const { watermarkSelector: watermarkSelector, paginationSelector: paginationSelector, sideBarSelector: sideBarSelector, statusBarSelector: statusBarSelector, gridHeaderDropZonesSelector: gridHeaderDropZonesSelector } = gridCtrl.getOptionalSelectors();
        const additionalEls = [];
        if (gridHeaderDropZonesSelector) {
            const headerDropZonesComp = context.createBean(new gridHeaderDropZonesSelector.component());
            const eGui = headerDropZonesComp.getGui();
            eRootWrapper.insertAdjacentElement("afterbegin", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(headerDropZonesComp);
        }
        if (sideBarSelector) {
            const sideBarComp = context.createBean(new sideBarSelector.component());
            const eGui = sideBarComp.getGui();
            const bottomTabGuard = eGridBodyParent.querySelector(".ag-tab-guard-bottom");
            if (bottomTabGuard) {
                bottomTabGuard.insertAdjacentElement("beforebegin", eGui);
                additionalEls.push(eGui);
            }
            beansToDestroy.push(sideBarComp);
            focusableContainersRef.current.push(sideBarComp);
        }
        const addComponentToDom = (component)=>{
            const comp = context.createBean(new component());
            const eGui = comp.getGui();
            eRootWrapper.insertAdjacentElement("beforeend", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(comp);
            return comp;
        };
        if (statusBarSelector) addComponentToDom(statusBarSelector.component);
        if (paginationSelector) {
            const paginationComp = addComponentToDom(paginationSelector.component);
            paginationCompRef.current = paginationComp;
            focusableContainersRef.current.push(paginationComp);
        }
        if (watermarkSelector) addComponentToDom(watermarkSelector.component);
        return ()=>{
            context.destroyBeans(beansToDestroy);
            for (const el of additionalEls)el.remove();
        };
    }, [
        tabGuardReady,
        eGridBodyParent,
        context
    ]);
    const rootWrapperClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-root-wrapper", rtlClass, layoutClass), [
        rtlClass,
        layoutClass
    ]);
    const rootWrapperBodyClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-root-wrapper-body", "ag-focus-managed", layoutClass), [
        layoutClass
    ]);
    const topStyle = (0, $acw62.useMemo)(()=>({
            userSelect: userSelect != null ? userSelect : "",
            WebkitUserSelect: userSelect != null ? userSelect : "",
            cursor: cursor != null ? cursor : ""
        }), [
        userSelect,
        cursor
    ]);
    const setTabGuardCompRef = (0, $acw62.useCallback)((ref)=>{
        tabGuardRef.current = ref;
        setTabGuardReady(ref !== null);
    }, []);
    const isFocusable = (0, $acw62.useCallback)(()=>!gridCtrlRef.current?.isFocusable(), []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: rootWrapperClasses,
        style: topStyle,
        role: "presentation"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: rootWrapperBodyClasses,
        ref: setGridBodyParent,
        role: "presentation"
    }, initialised && eGridBodyParent && !context.isDestroyed() && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$BeansContext.Provider, {
        value: context.getBeans()
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$tabGuardComp_default, {
        ref: setTabGuardCompRef,
        eFocusableElement: eGridBodyParent,
        onTabKeyDown: onTabKeyDown,
        gridCtrl: gridCtrlRef.current,
        forceFocusOutWhenTabGuardsAreEmpty: true,
        isEmpty: isFocusable
    }, // we wait for initialised before rending the children, so GridComp has created and registered with it's
    // GridCtrl before we create the child GridBodyComp. Otherwise the GridBodyComp would initialise first,
    // before we have set the the Layout CSS classes, causing the GridBodyComp to render rows to a grid that
    // doesn't have it's height specified, which would result if all the rows getting rendered (and if many rows,
    // hangs the UI)
    /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$gridBodyComp_default, null)))));
};
var $0e439ae7301dd858$var$gridComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$GridComp);
var $0e439ae7301dd858$var$RenderStatusService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    postConstruct() {
        if (this.beans.colAutosize) {
            const queueResizeOperationsForTick = this.queueResizeOperationsForTick.bind(this);
            this.addManagedEventListeners({
                rowExpansionStateChanged: queueResizeOperationsForTick,
                expandOrCollapseAll: queueResizeOperationsForTick,
                // Enable devs to resize after they updated via the API
                cellValueChanged: queueResizeOperationsForTick,
                rowNodeDataChanged: queueResizeOperationsForTick,
                rowDataUpdated: queueResizeOperationsForTick
            });
        }
    }
    queueResizeOperationsForTick() {
        const colAutosize = this.beans.colAutosize;
        colAutosize.shouldQueueResizeOperations = true;
        setTimeout(()=>{
            colAutosize.processResizeOperations();
        }, 0);
    }
    areHeaderCellsRendered() {
        return this.beans.ctrlsSvc.getHeaderRowContainerCtrls().every((container)=>container.getAllCtrls().every((ctrl)=>ctrl.areCellsRendered()));
    }
    areCellsRendered() {
        return this.beans.rowRenderer.getAllRowCtrls().every((row)=>row.isRowRendered() && row.getAllCellCtrls().every((cellCtrl)=>!!cellCtrl.eGui));
    }
};
// packages/ag-grid-react/src/reactUi/agGridReactUi.tsx
var $0e439ae7301dd858$var$deprecatedProps = {
    setGridApi: void 0,
    maxComponentCreationTimeMs: void 0,
    children: void 0
};
var $0e439ae7301dd858$var$reactPropsNotGridOptions = {
    gridOptions: void 0,
    modules: void 0,
    containerStyle: void 0,
    className: void 0,
    passGridApi: void 0,
    componentWrappingElement: void 0,
    ...$0e439ae7301dd858$var$deprecatedProps
};
var $0e439ae7301dd858$var$excludeReactCompProps = new Set(Object.keys($0e439ae7301dd858$var$reactPropsNotGridOptions));
var $0e439ae7301dd858$var$deprecatedReactCompProps = new Set(Object.keys($0e439ae7301dd858$var$deprecatedProps));
var $0e439ae7301dd858$var$AgGridReactUi = (props)=>{
    const apiRef = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const portalManager = (0, $acw62.useRef)(null);
    const destroyFuncs = (0, $acw62.useRef)([]);
    const whenReadyFuncs = (0, $acw62.useRef)([]);
    const prevProps = (0, $acw62.useRef)(props);
    const frameworkOverridesRef = (0, $acw62.useRef)();
    const gridIdRef = (0, $acw62.useRef)();
    const ready = (0, $acw62.useRef)(false);
    const [context, setContext] = (0, $acw62.useState)(void 0);
    const [, setPortalRefresher] = (0, $acw62.useState)(0);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        if (!eRef) {
            for (const f of destroyFuncs.current)f();
            destroyFuncs.current.length = 0;
            return;
        }
        const modules = props.modules || [];
        if (!portalManager.current) {
            portalManager.current = new $0e439ae7301dd858$var$PortalManager(()=>setPortalRefresher((prev)=>prev + 1), props.componentWrappingElement, props.maxComponentCreationTimeMs);
            destroyFuncs.current.push(()=>{
                portalManager.current?.destroy();
                portalManager.current = null;
            });
        }
        const mergedGridOps = (0, $437b23f6a393c3bf$export$bfe37fc2d3c03134)(props.gridOptions, props, Object.keys(props).filter((key)=>!$0e439ae7301dd858$var$excludeReactCompProps.has(key)));
        const processQueuedUpdates = ()=>{
            if (ready.current) {
                const getFn = ()=>frameworkOverridesRef.current?.shouldQueueUpdates() ? void 0 : whenReadyFuncs.current.shift();
                let fn = getFn();
                while(fn){
                    fn();
                    fn = getFn();
                }
            }
        };
        const frameworkOverrides = new $0e439ae7301dd858$var$ReactFrameworkOverrides(processQueuedUpdates);
        frameworkOverridesRef.current = frameworkOverrides;
        const renderStatus = new $0e439ae7301dd858$var$RenderStatusService();
        const gridParams = {
            providedBeanInstances: {
                frameworkCompWrapper: new $0e439ae7301dd858$var$ReactFrameworkComponentWrapper(portalManager.current, mergedGridOps),
                renderStatus: renderStatus
            },
            modules: modules,
            frameworkOverrides: frameworkOverrides,
            setThemeOnGridDiv: true
        };
        const createUiCallback = (ctx)=>{
            setContext(ctx);
            ctx.createBean(renderStatus);
            destroyFuncs.current.push(()=>{
                ctx.destroy();
            });
            ctx.getBean("ctrlsSvc").whenReady({
                addDestroyFunc: (func)=>{
                    destroyFuncs.current.push(func);
                }
            }, ()=>{
                if (ctx.isDestroyed()) return;
                const api = apiRef.current;
                if (api) props.passGridApi?.(api);
            });
        };
        const acceptChangesCallback = (context2)=>{
            context2.getBean("ctrlsSvc").whenReady({
                addDestroyFunc: (func)=>{
                    destroyFuncs.current.push(func);
                }
            }, ()=>{
                for (const f of whenReadyFuncs.current)f();
                whenReadyFuncs.current.length = 0;
                ready.current = true;
            });
        };
        const gridCoreCreator = new (0, $437b23f6a393c3bf$export$7759b93c6200a2f9)();
        mergedGridOps.gridId ?? (mergedGridOps.gridId = gridIdRef.current);
        apiRef.current = gridCoreCreator.create(eRef, mergedGridOps, createUiCallback, acceptChangesCallback, gridParams);
        destroyFuncs.current.push(()=>{
            apiRef.current = void 0;
        });
        if (apiRef.current) gridIdRef.current = apiRef.current.getGridId();
    }, []);
    const style = (0, $acw62.useMemo)(()=>{
        return {
            height: "100%",
            ...props.containerStyle || {}
        };
    }, [
        props.containerStyle
    ]);
    const processWhenReady = (0, $acw62.useCallback)((func)=>{
        if (ready.current && !frameworkOverridesRef.current?.shouldQueueUpdates()) func();
        else whenReadyFuncs.current.push(func);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const changes = $0e439ae7301dd858$var$extractGridPropertyChanges(prevProps.current, props);
        prevProps.current = props;
        processWhenReady(()=>{
            if (apiRef.current) (0, $437b23f6a393c3bf$export$52208033bd24c2b2)(changes, apiRef.current);
        });
    }, [
        props
    ]);
    const renderMode = !(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore || (0, $437b23f6a393c3bf$export$aa5750e97994dd3)(props, "renderingMode") === "legacy" ? "legacy" : "default";
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: style,
        className: props.className,
        ref: setRef2
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$RenderModeContext.Provider, {
        value: renderMode
    }, context && !context.isDestroyed() ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$gridComp_default, {
        key: context.instanceId,
        context: context
    }) : null, portalManager.current?.getPortals() ?? null));
};
function $0e439ae7301dd858$var$extractGridPropertyChanges(prevProps, nextProps) {
    const changes = {};
    for (const propKey of Object.keys(nextProps)){
        if ($0e439ae7301dd858$var$excludeReactCompProps.has(propKey)) {
            if ($0e439ae7301dd858$var$deprecatedReactCompProps.has(propKey)) (0, $437b23f6a393c3bf$export$545083624300f13d)(274, {
                prop: propKey
            });
            continue;
        }
        const propValue = nextProps[propKey];
        if (prevProps[propKey] !== propValue) changes[propKey] = propValue;
    }
    return changes;
}
var $0e439ae7301dd858$var$ReactFrameworkComponentWrapper = class extends (0, $437b23f6a393c3bf$export$157f014d661b6f19) {
    constructor(parent, gridOptions){
        super();
        this.parent = parent;
        this.gridOptions = gridOptions;
    }
    createWrapper(UserReactComponent, componentType) {
        const gridOptions = this.gridOptions;
        const reactiveCustomComponents = (0, $437b23f6a393c3bf$export$aa5750e97994dd3)(gridOptions, "reactiveCustomComponents");
        if (reactiveCustomComponents) {
            const getComponentClass = (propertyName)=>{
                switch(propertyName){
                    case "filter":
                        return (0, $437b23f6a393c3bf$export$aa5750e97994dd3)(gridOptions, "enableFilterHandlers") ? $0e439ae7301dd858$var$FilterDisplayComponentWrapper : $0e439ae7301dd858$var$FilterComponentWrapper;
                    case "floatingFilterComponent":
                        return (0, $437b23f6a393c3bf$export$aa5750e97994dd3)(gridOptions, "enableFilterHandlers") ? $0e439ae7301dd858$var$FloatingFilterDisplayComponentWrapper : $0e439ae7301dd858$var$FloatingFilterComponentWrapper;
                    case "dateComponent":
                        return $0e439ae7301dd858$var$DateComponentWrapper;
                    case "dragAndDropImageComponent":
                        return $0e439ae7301dd858$var$DragAndDropImageComponentWrapper;
                    case "loadingOverlayComponent":
                        return $0e439ae7301dd858$var$LoadingOverlayComponentWrapper;
                    case "noRowsOverlayComponent":
                        return $0e439ae7301dd858$var$NoRowsOverlayComponentWrapper;
                    case "statusPanel":
                        return $0e439ae7301dd858$var$StatusPanelComponentWrapper;
                    case "toolPanel":
                        return $0e439ae7301dd858$var$ToolPanelComponentWrapper;
                    case "menuItem":
                        return $0e439ae7301dd858$var$MenuItemComponentWrapper;
                    case "cellRenderer":
                        return $0e439ae7301dd858$var$CellRendererComponentWrapper;
                    case "innerHeaderComponent":
                        return $0e439ae7301dd858$var$InnerHeaderComponentWrapper;
                }
            };
            const ComponentClass = getComponentClass(componentType.name);
            if (ComponentClass) return new ComponentClass(UserReactComponent, this.parent, componentType);
        } else switch(componentType.name){
            case "filter":
            case "floatingFilterComponent":
            case "dateComponent":
            case "dragAndDropImageComponent":
            case "loadingOverlayComponent":
            case "noRowsOverlayComponent":
            case "statusPanel":
            case "toolPanel":
            case "menuItem":
            case "cellRenderer":
                $0e439ae7301dd858$export$e83e01bcf62967be();
                break;
        }
        const suppressFallbackMethods = !componentType.cellRenderer && componentType.name !== "toolPanel";
        return new $0e439ae7301dd858$var$ReactComponent(UserReactComponent, this.parent, componentType, suppressFallbackMethods);
    }
};
var $0e439ae7301dd858$var$DetailCellRenderer = (0, $acw62.forwardRef)((props, ref)=>{
    const beans = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { registry: registry, context: context, gos: gos, rowModel: rowModel } = beans;
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [gridCssClasses, setGridCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [detailGridOptions, setDetailGridOptions] = (0, $acw62.useState)();
    const [detailRowData, setDetailRowData] = (0, $acw62.useState)();
    const ctrlRef = (0, $acw62.useRef)();
    const eGuiRef = (0, $acw62.useRef)(null);
    const resizeObserverDestroyFunc = (0, $acw62.useRef)();
    const parentModules = (0, $acw62.useMemo)(()=>(0, $437b23f6a393c3bf$export$7c244c452cd4b417)(props.api.getGridId(), detailGridOptions?.rowModelType ?? "clientSide"), [
        props
    ]);
    const topClassName = (0, $acw62.useMemo)(()=>cssClasses.toString() + " ag-details-row", [
        cssClasses
    ]);
    const gridClassName = (0, $acw62.useMemo)(()=>gridCssClasses.toString() + " ag-details-grid", [
        gridCssClasses
    ]);
    if (ref) (0, $acw62.useImperativeHandle)(ref, ()=>({
            refresh () {
                return ctrlRef.current?.refresh() ?? false;
            }
        }));
    if (props.template) (0, $437b23f6a393c3bf$export$545083624300f13d)(230);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGuiRef.current = eRef;
        if (!eRef || context.isDestroyed()) {
            ctrlRef.current = context.destroyBean(ctrlRef.current);
            resizeObserverDestroyFunc.current?.();
            return;
        }
        const compProxy = {
            toggleCss: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            toggleDetailGridCss: (name, on)=>setGridCssClasses((prev)=>prev.setClass(name, on)),
            setDetailGrid: (gridOptions)=>setDetailGridOptions(gridOptions),
            setRowData: (rowData)=>setDetailRowData(rowData),
            getGui: ()=>eGuiRef.current
        };
        const ctrl = registry.createDynamicBean("detailCellRendererCtrl", true);
        if (!ctrl) return;
        context.createBean(ctrl);
        ctrl.init(compProxy, props);
        ctrlRef.current = ctrl;
        if (gos.get("detailRowAutoHeight")) {
            const checkRowSizeFunc = ()=>{
                if (eGuiRef.current == null) return;
                const clientHeight = eGuiRef.current.clientHeight;
                if (clientHeight != null && clientHeight > 0) {
                    const updateRowHeightFunc = ()=>{
                        props.node.setRowHeight(clientHeight);
                        if ((0, $437b23f6a393c3bf$export$9f182d9ca737e15)(gos, rowModel) || (0, $437b23f6a393c3bf$export$cf1bac0013650216)(gos, rowModel)) rowModel.onRowHeightChanged();
                    };
                    setTimeout(updateRowHeightFunc, 0);
                }
            };
            resizeObserverDestroyFunc.current = (0, $437b23f6a393c3bf$export$9aef8476630687be)(beans, eRef, checkRowSizeFunc);
            checkRowSizeFunc();
        }
    }, []);
    const registerGridApi = (0, $acw62.useCallback)((api)=>{
        ctrlRef.current?.registerDetailWithMaster(api);
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: topClassName,
        ref: setRef2
    }, detailGridOptions && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$AgGridReactUi, {
        className: gridClassName,
        ...detailGridOptions,
        modules: parentModules,
        rowData: detailRowData,
        passGridApi: registerGridApi
    }));
});
var $0e439ae7301dd858$var$ReactFrameworkOverrides = class extends (0, $437b23f6a393c3bf$export$8174ad74937c6482) {
    constructor(processQueuedUpdates){
        super("react");
        this.processQueuedUpdates = processQueuedUpdates;
        this.queueUpdates = false;
        this.renderingEngine = "react";
        this.frameworkComponents = {
            agGroupCellRenderer: $0e439ae7301dd858$var$groupCellRenderer_default,
            agGroupRowRenderer: $0e439ae7301dd858$var$groupCellRenderer_default,
            agDetailCellRenderer: $0e439ae7301dd858$var$DetailCellRenderer
        };
        this.wrapIncoming = (callback, source)=>{
            if (source === "ensureVisible") return $0e439ae7301dd858$var$runWithoutFlushSync(callback);
            return callback();
        };
    }
    frameworkComponent(name) {
        return this.frameworkComponents[name];
    }
    isFrameworkComponent(comp) {
        if (!comp) return false;
        const prototype = comp.prototype;
        const isJsComp = prototype && "getGui" in prototype;
        return !isJsComp;
    }
    getLockOnRefresh() {
        this.queueUpdates = true;
    }
    releaseLockOnRefresh() {
        this.queueUpdates = false;
        this.processQueuedUpdates();
    }
    shouldQueueUpdates() {
        return this.queueUpdates;
    }
    runWhenReadyAsync() {
        return $0e439ae7301dd858$var$isReact19();
    }
};
// packages/ag-grid-react/src/agGridReact.tsx
var $0e439ae7301dd858$export$4074462c5969a5d8 = class extends (0, $acw62.Component) {
    constructor(){
        super(...arguments);
        this.apiListeners = [];
        this.setGridApi = (api)=>{
            this.api = api;
            for (const listener of this.apiListeners)listener(api);
        };
    }
    registerApiListener(listener) {
        this.apiListeners.push(listener);
    }
    componentWillUnmount() {
        this.apiListeners.length = 0;
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$AgGridReactUi, {
            ...this.props,
            passGridApi: this.setGridApi
        });
    }
};
function $0e439ae7301dd858$var$useGridCustomComponent(methods) {
    const { setMethods: setMethods } = (0, $acw62.useContext)($0e439ae7301dd858$export$9f6317c67b47ac67);
    setMethods(methods);
}
function $0e439ae7301dd858$export$70780aa16b46d041(callbacks) {
    $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$ae0fe569b475a61(callbacks) {
    return $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$42838275cbf666c4(callbacks) {
    return $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$1960c6fcb2ef5be2(callbacks) {
    return $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$a2cd2617441b4952(callbacks) {
    $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$bfb597f578b2979b(callbacks) {
    $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}



parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b698d1771218a1ca$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "12",
            r: "1",
            key: "1wjl8i"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "12",
            r: "1",
            key: "1pcz8c"
        }
    ]
];
const $b698d1771218a1ca$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ellipsis", $b698d1771218a1ca$export$3efd853dbb351e94);



// Simple button variants for pagination
const $c814d8d13fd9d633$var$buttonVariants = ({ variant: variant = "ghost", size: size = "icon" })=>{
    const baseStyles = "tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-text-sm tw-font-medium tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring disabled:tw-pointer-events-none disabled:tw-opacity-50";
    const variantStyles = {
        outline: "tw-border tw-border-[#535D66] tw-bg-transparent tw-text-white hover:tw-bg-[#1c1f23] hover:tw-border-[#4a5056]",
        ghost: "tw-text-white hover:tw-bg-[#1c1f23] hover:tw-text-white"
    };
    const sizeStyles = {
        default: "tw-h-9 tw-px-4 tw-py-2",
        icon: "tw-h-9 tw-w-9"
    };
    return (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseStyles, variantStyles[variant], sizeStyles[size]);
};
function $c814d8d13fd9d633$export$68f5e1453c188a82({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
        role: "navigation",
        "aria-label": "pagination",
        "data-slot": "pagination",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-mx-auto tw-flex tw-w-full tw-justify-center", className),
        ...props
    });
}
function $c814d8d13fd9d633$export$e3c2252a821bad58({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
        "data-slot": "pagination-content",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-flex-row tw-items-center tw-gap-1", className),
        ...props
    });
}
function $c814d8d13fd9d633$export$c82a077939f0464b({ ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
        "data-slot": "pagination-item",
        ...props
    });
}
function $c814d8d13fd9d633$export$389c2523d2fb7ac8({ className: className, isActive: isActive, size: size = "icon", ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        "aria-current": isActive ? "page" : undefined,
        "data-slot": "pagination-link",
        "data-active": isActive,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($c814d8d13fd9d633$var$buttonVariants({
            variant: isActive ? "outline" : "ghost",
            size: size
        }), className),
        ...props
    });
}
function $c814d8d13fd9d633$export$c38bddd65ea050e7({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c814d8d13fd9d633$export$389c2523d2fb7ac8, {
        "aria-label": "Go to previous page",
        size: "default",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-gap-1 tw-px-2.5 sm:tw-pl-2.5", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                className: "tw-h-4 tw-w-4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "tw-hidden sm:tw-inline-block",
                children: "Previous"
            })
        ]
    });
}
function $c814d8d13fd9d633$export$ef9c8bfc54489a24({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c814d8d13fd9d633$export$389c2523d2fb7ac8, {
        "aria-label": "Go to next page",
        size: "default",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-gap-1 tw-px-2.5 sm:tw-pr-2.5", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "tw-hidden sm:tw-inline-block",
                children: "Next"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                className: "tw-h-4 tw-w-4"
            })
        ]
    });
}
function $c814d8d13fd9d633$export$bf296fe40f0f4032({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        "aria-hidden": true,
        "data-slot": "pagination-ellipsis",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-size-9 tw-items-center tw-justify-center", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b698d1771218a1ca$export$2e2bcd8739ae039), {
                className: "tw-size-4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "tw-sr-only",
                children: "More pages"
            })
        ]
    });
}




var $f1q41 = parcelRequire("f1q41");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $7da2b291db98759b$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $7da2b291db98759b$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $7da2b291db98759b$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$7da2b291db98759b$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $7da2b291db98759b$var$MAX_DELAY_MS);
}
function $7da2b291db98759b$export$2e2bcd8739ae039() {
    const isMounted = (0, $ed7e9ace1ce49d9f$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $acw62.useRef)();
    (0, $63805df80cf3ca43$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $acw62.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $7da2b291db98759b$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $7da2b291db98759b$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear
        };
    }, []);
}



function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}




var $acw62 = parcelRequire("acw62");
var $768901fea8dbe440$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (format === undefined) throw new Error("invariant requires an error message argument");
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$768901fea8dbe440$exports = $768901fea8dbe440$var$invariant;


var $b7f5460541b42e0f$var$noop = function noop() {};
function $b7f5460541b42e0f$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $b7f5460541b42e0f$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$b7f5460541b42e0f$export$26cbf8c37e721e67(prop)] = $b7f5460541b42e0f$var$noop;
        var handler = controlledValues[prop];
        !(typeof handler === "string" && handler.trim().length) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false, "Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable", displayName, prop);
        propTypes[prop] = $b7f5460541b42e0f$var$readOnlyPropType(handler, displayName);
    });
    return propTypes;
}
function $b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $b7f5460541b42e0f$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $b7f5460541b42e0f$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== "function" || component.prototype && component.prototype.isReactComponent);
}


function $5809a50e160ad91a$var$_toPropertyKey(arg) {
    var key = $5809a50e160ad91a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5809a50e160ad91a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5809a50e160ad91a$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    var _useState = (0, $acw62.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $5809a50e160ad91a$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, [
            $b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($5809a50e160ad91a$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $5809a50e160ad91a$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}






var $acw62 = parcelRequire("acw62");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $a2318047db3e7b05$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $a2318047db3e7b05$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || "Component";
    var canAcceptRef = $b7f5460541b42e0f$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($b7f5460541b42e0f$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false, "[uncontrollable] stateless function components cannot pass through methods because they have no associated instances. Check component: " + displayName + ", " + "attempting to pass through methods: " + methods.join(", "));
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, key) && $b7f5460541b42e0f$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    (0, $c8a186e1757974bb$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UncontrolledComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $a2318047db3e7b05$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $a2318047db3e7b05$export$2e2bcd8739ae039(newComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $371d31aa64efa655$var$has = Object.prototype.hasOwnProperty;
function $371d31aa64efa655$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($371d31aa64efa655$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $371d31aa64efa655$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $371d31aa64efa655$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === "object") {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === "object") {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$371d31aa64efa655$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($371d31aa64efa655$var$has.call(foo, ctor) && ++len && !$371d31aa64efa655$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$371d31aa64efa655$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $acw62 = parcelRequire("acw62");

/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $736213cceee2e4cc$var$useSafeState(state) {
    const isMounted = (0, $ed7e9ace1ce49d9f$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $acw62.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $736213cceee2e4cc$export$2e2bcd8739ae039 = $736213cceee2e4cc$var$useSafeState;



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}



function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};







function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $aa2830a619d3769f$export$8f7491d57c8f97a9 = (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $69d8d7bda7717b01$export$2e2bcd8739ae039),
        (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
        (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
        (0, $e7d7845625089588$export$2e2bcd8739ae039),
        (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
        (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
        (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
        (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039)
    ]
});


const $3e96790ca7bcc44e$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $3e96790ca7bcc44e$var$disabledApplyStylesModifier = {
    name: "applyStyles",
    enabled: false,
    phase: "afterWrite",
    fn: ()=>undefined
};
// until docjs supports type exports...
const $3e96790ca7bcc44e$var$ariaDescribedByModifier = {
    name: "ariaDescribedBy",
    enabled: true,
    phase: "afterWrite",
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ("removeAttribute" in reference) {
                const ids = (reference.getAttribute("aria-describedby") || "").split(",").filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute("aria-describedby");
                else reference.setAttribute("aria-describedby", ids.join(","));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute("role")) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === "tooltip" && "setAttribute" in reference) {
            const ids = reference.getAttribute("aria-describedby");
            if (ids && ids.split(",").indexOf(popper.id) !== -1) return;
            reference.setAttribute("aria-describedby", ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $3e96790ca7bcc44e$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $3e96790ca7bcc44e$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = "bottom", strategy: strategy = "absolute", modifiers: modifiers = $3e96790ca7bcc44e$var$EMPTY_MODIFIERS } = _ref, config = $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(_ref, $3e96790ca7bcc44e$var$_excluded);
    const prevModifiers = (0, $acw62.useRef)(modifiers);
    const popperInstanceRef = (0, $acw62.useRef)();
    const update = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $736213cceee2e4cc$export$2e2bcd8739ae039)((0, $acw62.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $acw62.useMemo)(()=>({
            name: "updateStateModifier",
            enabled: true,
            phase: "write",
            requires: [
                "computeStyles"
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $acw62.useMemo)(()=>{
        if (!(0, $371d31aa64efa655$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $3e96790ca7bcc44e$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $aa2830a619d3769f$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $3e96790ca7bcc44e$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $3e96790ca7bcc44e$export$2e2bcd8739ae039 = $3e96790ca7bcc44e$var$usePopper;





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


const $bfacdc492f374f5e$var$noop = ()=>{};
function $bfacdc492f374f5e$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $bfacdc492f374f5e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $bfacdc492f374f5e$export$347601c75fcd4732 = (ref)=>ref && ("current" in ref ? ref.current : ref);
const $bfacdc492f374f5e$var$InitialTriggerEvents = {
    click: "mousedown",
    mouseup: "mousedown",
    pointerup: "pointerdown"
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $bfacdc492f374f5e$var$useClickOutside(ref, onClickOutside = $bfacdc492f374f5e$var$noop, { disabled: disabled, clickTrigger: clickTrigger = "click" } = {}) {
    const preventMouseClickOutsideRef = (0, $acw62.useRef)(false);
    const waitingForTrigger = (0, $acw62.useRef)(false);
    const handleMouseCapture = (0, $acw62.useCallback)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $bfacdc492f374f5e$var$isModifiedEvent(e) || !$bfacdc492f374f5e$var$isLeftClickEvent(e) || !!(0, $967999a1a8cec832$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $967999a1a8cec832$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
    });
    const handleMouse = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $acw62.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)($bfacdc492f374f5e$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, $bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ("ontouchstart" in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(el, "mousemove", $bfacdc492f374f5e$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $bfacdc492f374f5e$export$2e2bcd8739ae039 = $bfacdc492f374f5e$var$useClickOutside;



const $e8106b249b7a3807$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $e8106b249b7a3807$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $e8106b249b7a3807$var$noop;
    (0, $bfacdc492f374f5e$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if ((0, $a36e95ee292bed8b$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $acw62.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)((0, $bfacdc492f374f5e$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, "keyup", (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $e8106b249b7a3807$export$2e2bcd8739ae039 = $e8106b249b7a3807$var$useRootClose;



function $d29a438d14321507$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $d29a438d14321507$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $d29a438d14321507$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $d29a438d14321507$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? "fixed" : popperConfig.strategy,
        modifiers: $d29a438d14321507$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $93d1afca8879b95a$var$Overlay = /*#__PURE__*/ $acw62.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $6ee4f2c1aea3527b$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $6ee4f2c1aea3527b$export$2e2bcd8739ae039)();
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(props.container);
    const target = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $acw62.useState)(!props.show);
    const popper = (0, $3e96790ca7bcc44e$export$2e2bcd8739ae039)(target, rootElement, (0, $d29a438d14321507$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $e8106b249b7a3807$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(child, container) : null;
});
$93d1afca8879b95a$var$Overlay.displayName = "Overlay";
var $93d1afca8879b95a$export$2e2bcd8739ae039 = $93d1afca8879b95a$var$Overlay;






var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $a6e5f9750149a1a0$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("popover-header");



var $322d82ade70b4ad6$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("popover-body");



var $acw62 = parcelRequire("acw62");
class $5be11e4096c49daa$export$34582a676b91ff07 extends $acw62.Component {
}
function $5be11e4096c49daa$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === "left") bsDirection = isRTL ? "end" : "start";
    else if (placement === "right") bsDirection = isRTL ? "start" : "end";
    return bsDirection;
}


function $2773df40e83847cd$export$2e2bcd8739ae039(position = "absolute") {
    return {
        position: position,
        top: "0",
        left: "0",
        opacity: "0",
        pointerEvents: "none"
    };
}



const $d0df75e22d728968$var$Popover = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "popover");
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $5be11e4096c49daa$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $2773df40e83847cd$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $322d82ade70b4ad6$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
var $d0df75e22d728968$export$2e2bcd8739ae039 = Object.assign($d0df75e22d728968$var$Popover, {
    Header: (0, $a6e5f9750149a1a0$export$2e2bcd8739ae039),
    Body: (0, $322d82ade70b4ad6$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $acw62 = parcelRequire("acw62");




const $0937b8ed541186d0$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "tooltip");
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $5be11e4096c49daa$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $2773df40e83847cd$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$0937b8ed541186d0$var$Tooltip.displayName = "Tooltip";
var $0937b8ed541186d0$export$2e2bcd8739ae039 = Object.assign($0937b8ed541186d0$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


function $5444443f433675a7$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $acw62.useRef)(null);
    const popoverClass = (0, $626bd95fa485b758$export$7f387860ebffb32c)(undefined, "popover");
    const tooltipClass = (0, $626bd95fa485b758$export$7f387860ebffb32c)(undefined, "tooltip");
    const offset = (0, $acw62.useMemo)(()=>({
            name: "offset",
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $d0df75e22d728968$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $0937b8ed541186d0$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}





function $fa76858134013112$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $75718871ab216e51$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r)));
}
const $fa76858134013112$var$Overlay = /*#__PURE__*/ $acw62.forwardRef(({ children: overlay, transition: transition = (0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = "top", show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $acw62.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $acw62.useState)(null);
    const [ref, modifiers] = (0, $5444443f433675a7$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $588ffbaaa8a325aa$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState) popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93d1afca8879b95a$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state, _popperObj$state$modi;
            $fa76858134013112$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null ? void 0 : (_popperObj$state = popperObj.state) == null ? void 0 : (_popperObj$state$modi = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state$modi.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === "function") return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: "show"
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $acw62.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlay.props.className, !transition && show && "show"),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$fa76858134013112$var$Overlay.displayName = "Overlay";
var $fa76858134013112$export$2e2bcd8739ae039 = $fa76858134013112$var$Overlay;




function $3ec0f3191f4dead1$var$normalizeDelay(delay) {
    return delay && typeof delay === "object" ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $3ec0f3191f4dead1$var$handleMouseOverOut(// eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
function $3ec0f3191f4dead1$var$OverlayTrigger({ trigger: trigger = [
    "hover",
    "focus"
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf("auto") !== -1, ...props }) {
    const triggerNodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(triggerNodeRef, children.ref);
    const timeout = (0, $7da2b291db98759b$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $acw62.useRef)("");
    const [show, setShow] = (0, $5809a50e160ad91a$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $3ec0f3191f4dead1$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== "function" ? $acw62.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $acw62.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "show";
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "show") setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $acw62.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "hide";
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "hide") setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $acw62.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $acw62.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $acw62.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $acw62.useCallback)((...args)=>{
        $3ec0f3191f4dead1$var$handleMouseOverOut(handleShow, args, "fromElement");
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $acw62.useCallback)((...args)=>{
        $3ec0f3191f4dead1$var$handleMouseOverOut(handleHide, args, "toElement");
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf("click") !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf("focus") !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf("hover") !== -1) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(triggers.length > 1, '[react-bootstrap] Specifying only the `"hover"` trigger limits the visibility of the overlay to just mouse users. Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.');
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            typeof children === "function" ? children(triggerProps) : /*#__PURE__*/ (0, $acw62.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa76858134013112$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
}
var $3ec0f3191f4dead1$export$2e2bcd8739ae039 = $3ec0f3191f4dead1$var$OverlayTrigger;



const $ca4bfbde716b69b9$var$getMappedConfidencePattern = (confidencePattern)=>{
    const confidencePatternMap = {
        track_level_contribution: "Track-Level Contribution",
        inferred_contribution: "Inferred Contribution",
        released_by_artist: "Released by Artist (Solo)",
        release_level_contribution: "Release-Level Contribution",
        associated_with_ppl: "Associated with PPL",
        released_by_band_artist: "Released by Artist (Band)",
        non_identifying_sources: "Non-Identifying Sources (Spotify, Deezer)",
        version_of_recording: "Version of Recording (non-derivative)",
        ppl_only_source: "PPL as Only Source",
        unresolved_position: "Unresolved position for explicit payable roles",
        manual_update: "Manually Updated",
        unknown: "Unknown"
    };
    return confidencePatternMap[confidencePattern] ?? confidencePattern;
};
function $ca4bfbde716b69b9$var$getPillClassName(confidenceCategory) {
    return [
        "tw-inline-flex tw-rounded-xs tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-uppercase tw-h-6",
        confidenceCategory === "5" ? "tw-bg-[#AAB2B9] tw-text-black" : "",
        confidenceCategory === "4" ? "tw-bg-[#FF2600]" : "",
        confidenceCategory === "3" ? "tw-bg-[#FF8A00]" : "",
        confidenceCategory === "2" ? "tw-bg-[#F6FF00] tw-text-black" : "",
        confidenceCategory === "1" ? "tw-bg-[#6EE038] tw-text-black" : ""
    ].filter(Boolean).join(" ");
}
function $ca4bfbde716b69b9$export$733e49a0308b4cd({ contribution: contribution }) {
    const pillClassName = $ca4bfbde716b69b9$var$getPillClassName(contribution.confidenceCategory);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec0f3191f4dead1$export$2e2bcd8739ae039), {
        delay: {
            hide: 50,
            show: 50
        },
        placement: "top",
        flip: true,
        popperConfig: {
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: "viewport"
                    }
                }
            ]
        },
        overlay: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0937b8ed541186d0$export$2e2bcd8739ae039), {
                ...props,
                className: "black-bg tw-max-w-xs !tw-z-[9999]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-justify-start tw-items-start tw-flex-col tw-gap-2 tw-p-2 tw-px-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-font-semibold",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: pillClassName,
                                children: (0, $f1q41.capitalize)(contribution.contribution)
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-text-sm tw-text-gray-300 tw-break-words tw-text-left",
                            children: $ca4bfbde716b69b9$var$getMappedConfidencePattern(contribution.confidencePattern)
                        })
                    ]
                })
            }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: pillClassName,
            children: (0, $f1q41.capitalize)(contribution.contribution)
        })
    });
}


/**
 * Contribution roles taxonomy.
 *
 * Source: westbury-functions-mono/model_deployment/role_standardisation/
 *         dedup_role_instrument_list.csv (deduplicated upstream).
 *
 * Regenerate: node admin_portal/src/data/generate-contributions-taxonomy.js
 */ /** All unique contribution roles, sorted alphabetically (deduplicated upstream). */ const $f50146991650bb90$export$a0305d43acfa6742 = [
    "12-string acoustic guitar",
    "12-string bass",
    "12-string guitar",
    "17-string bass koto",
    "4-string banjo",
    "5-string banjo",
    "6-string banjo",
    "6-string bass",
    "8-string bass guitar",
    "accompanist",
    "accordina",
    "accordion",
    "achere",
    "acoustic bass",
    "acoustic bass guitar",
    "acoustic fretless guitar",
    "acoustic guitar",
    "acoustic piano",
    "acoustic piccolo bass",
    "actor",
    "adufe",
    "adungu",
    "aeolian harp",
    "afoxe",
    "african congo drums",
    "afuche",
    "agogo",
    "ajaeng",
    "akete",
    "akkordolia",
    "alfaia",
    "algaita",
    "algerian mandole",
    "alghoza",
    "alphorn",
    "alto",
    "alto clarinet",
    "alto crumhorn",
    "alto flute",
    "alto horn",
    "alto recorder",
    "alto saxophone",
    "alto trombone",
    "alto valve trombone",
    "alto viol",
    "alto violin",
    "alto vocals",
    "amadinda",
    "aman khuur",
    "ambtara",
    "analog synthesizer",
    "anandalahari",
    "anatara",
    "andean flute",
    "andean harp",
    "angklung",
    "anglo-concertina",
    "animal sounds",
    "animal sounds impersonator",
    "ankle rattlers",
    "announcer",
    "antara",
    "anvil",
    "apentemma",
    "apito",
    "apongalahy",
    "appalachian dulcimer",
    "archlute",
    "archtop guitar",
    "arco bass",
    "arghul",
    "arpa",
    "arpeggione",
    "arrabel",
    "artistic narrator",
    "artistic producer",
    "ashiko",
    "associate producer",
    "atabal",
    "atabaque",
    "atarigane",
    "atchere",
    "audio generator",
    "autoharp",
    "automatic orchestra",
    "baandu",
    "baby grand piano",
    "background studio singer",
    "backing band",
    "backing vocals",
    "baglama",
    "baglama (saz) family",
    "bagpipes",
    "bahian guitar",
    "bajo",
    "bajo quinto",
    "bajo sexto",
    "balafon",
    "balalaika",
    "baltic psalteries",
    "bambaro",
    "bamboo flute",
    "band",
    "bandola",
    "bandolin",
    "bandoneon",
    "bandora",
    "bandura",
    "bandurria",
    "bangu",
    "banhu",
    "banjitar",
    "banjo",
    "banjo guitar",
    "banjo-dulcimer",
    "banjo-mandolin",
    "banjo-ukulele",
    "banjolin",
    "banjulele",
    "bankia",
    "bansuri",
    "bapang",
    "bara",
    "barbat",
    "baritone",
    "baritone clarinet",
    "baritone guitar",
    "baritone horn",
    "baritone saxhorn",
    "baritone saxophone",
    "baritone violin",
    "baritone vocals",
    "baroque guitar",
    "baroque trumpet",
    "barrel drum",
    "barrel organ",
    "barrel piano",
    "baryton",
    "bass",
    "bass accordion",
    "bass clarinet",
    "bass concertina",
    "bass crumhorn",
    "bass drum",
    "bass dulcian",
    "bass fado viola",
    "bass flute",
    "bass guitar",
    "bass harmonica",
    "bass lute",
    "bass marimba",
    "bass oboe",
    "bass pedals",
    "bass rackett",
    "bass recorder",
    "bass saxophone",
    "bass synthesizer",
    "bass tambura",
    "bass trombone",
    "bass trumpet",
    "bass tuba",
    "bass viol",
    "bass violin",
    "bass vocals",
    "bass-baritone",
    "bass-baritone vocals",
    "basset clarinet",
    "basset horn",
    "basso continuo",
    "bassoon",
    "basy",
    "bata",
    "bata drum",
    "bawu",
    "bayan",
    "bazooka",
    "beatbox",
    "beats",
    "bedug",
    "bell plate",
    "bell tree",
    "bell-piano",
    "bellow-blown bagpipes",
    "bellowed reed",
    "bellowphone",
    "bells",
    "bembe",
    "bendir",
    "berda",
    "berimbau",
    "bhapang",
    "bicycle bell",
    "big drum",
    "bin",
    "bin-sasara",
    "bin-sitar",
    "biniou",
    "birbyne",
    "birch lur",
    "bisernica",
    "biwa",
    "blaster beam",
    "blues harp",
    "bo (bell)",
    "bo (cymbals)",
    "bo (flute)",
    "boatswain's pipe",
    "bodhran",
    "body percussion",
    "bolivian flute",
    "bolon",
    "bombarde",
    "bombardon",
    "bombo",
    "bombo (bass drum)",
    "bombo (frame drum)",
    "bombo (mouth bom)",
    "bombo leguero",
    "bonang",
    "bonang barung",
    "bonang panembung",
    "bonang panerus",
    "bones",
    "bongos",
    "boobam",
    "boomwhacker",
    "border pipes",
    "bordonua",
    "bottle",
    "bouzar",
    "bouzouki",
    "bowed lute",
    "bowed lyre",
    "bowed piano",
    "bowed psaltery",
    "bowed string instruments",
    "box zither",
    "brac",
    "braguinha",
    "brass",
    "brass band",
    "brass bass",
    "bronze lur",
    "broom",
    "brushes",
    "bucium",
    "bugarija",
    "bugle",
    "buhay",
    "buisine",
    "buk",
    "bukkehorn",
    "bulbul tarang",
    "bull fiddle",
    "bullroarer",
    "button accordion",
    "buzuq",
    "byzaanchi",
    "c-bass recorder",
    "c-melody saxophone",
    "cabasa",
    "caixa",
    "caja",
    "caja vallenata",
    "cajas rumberas",
    "cajon",
    "cajon peruano",
    "calabash",
    "caller",
    "calliope",
    "calung",
    "campana",
    "cantor",
    "caramusa",
    "carillon",
    "carnyx",
    "castanets",
    "castrato",
    "cavaco",
    "cavaquinho",
    "caxixi",
    "celesta",
    "cello",
    "cello banjo",
    "cembalet",
    "ceng ceng",
    "cetara",
    "cevgen",
    "chacaras",
    "chacha",
    "chak'chas",
    "chakhe",
    "chalumeau",
    "chamber organ",
    "chamber pipes",
    "chamberlin",
    "chande",
    "changgo",
    "changi",
    "chansonnier",
    "chanter",
    "chanting",
    "chanzy",
    "chap",
    "chap lek",
    "chapman stick",
    "charamel",
    "charango",
    "chasquidos",
    "chau gong",
    "chekere",
    "cheng",
    "chikuzen biwa",
    "chime bar",
    "chimes",
    "chinchin",
    "chinese drum",
    "chinese flute",
    "chinese harp",
    "ching",
    "chirimia",
    "chirimia and drum",
    "chitarra battente",
    "chitarrone",
    "chitra veena",
    "chiwata",
    "chocalho",
    "choir",
    "choir member",
    "choir singing",
    "choir stand-in",
    "chonguri",
    "choral conductor",
    "chorus",
    "chromatic button accordion",
    "chromatic harmonica",
    "chuniri",
    "church organ",
    "chuurqin",
    "cifteli",
    "cigar box guitar",
    "cimbalom",
    "cimbasso",
    "cimpoi",
    "cinema organ",
    "cither",
    "citole",
    "cittern",
    "cizhonghu",
    "clapping",
    "clapstick",
    "clarin cajamarquino",
    "clarinet",
    "clarinet (c)",
    "clarinet (e flat)",
    "clarion",
    "clarsach",
    "classical guitar",
    "classical kemence",
    "claves",
    "clavichord",
    "clavier",
    "clavinet",
    "claviola",
    "clavioline",
    "claviorganum",
    "clog",
    "clog dancer",
    "co ke",
    "co-producer",
    "cobza",
    "colascione",
    "comb",
    "combolin",
    "comedian",
    "commentator",
    "computer",
    "concert band",
    "concert flute",
    "concert grand piano",
    "concert harp",
    "concertina",
    "concertmaster",
    "concertmistress",
    "conch shell",
    "concussion idiophone",
    "conductor",
    "conductor (instruments)",
    "conductor (strings)",
    "conductor (vocals)",
    "conga",
    "continuum",
    "contra-alto clarinet",
    "contrabass",
    "contrabass clarinet",
    "contrabass flute",
    "contrabass recorder",
    "contrabass saxophone",
    "contrabass trombone",
    "contrabass violin",
    "contrabassoon",
    "contralto",
    "contralto vocals",
    "contributor",
    "cornamuse",
    "cornet",
    "cornett",
    "corno da caccia",
    "coro",
    "counter tenor",
    "cowbells",
    "crash cymbals",
    "craviola",
    "cretan lyra",
    "cristal baschet",
    "cromorne",
    "crotales",
    "crumhorn",
    "crwth",
    "cuatro",
    "cuica",
    "cultrun",
    "cumbus",
    "cura",
    "curtal",
    "cyla-diare",
    "cylindrical drum",
    "cymbals",
    "daegeum",
    "daf",
    "daire",
    "daluo",
    "damaru",
    "dan bau",
    "dan nguyet",
    "dan nhi",
    "dan tam",
    "dan tam thap luc",
    "dan tranh",
    "dan tu",
    "dan tu day",
    "dan ty ba",
    "danburo",
    "dancer",
    "dancer saw",
    "danso",
    "darbuka",
    "daruan",
    "davul",
    "daw",
    "daxaphone",
    "deaejeng",
    "denis d'or",
    "dhol",
    "dholak",
    "di (flute)",
    "di (slit drum)",
    "diaff",
    "diatonic button accordion",
    "diddley bow",
    "didgeridoo",
    "digital audio workstation",
    "dikanza",
    "dilli tuiduk",
    "dilruba",
    "ding buot",
    "ding nam",
    "ding tac ta",
    "diple",
    "disk drive",
    "diyingehu",
    "dizi",
    "dj",
    "dj (scratcher)",
    "dj (spoken word)",
    "dj (toaster)",
    "djembe",
    "djoza",
    "djura",
    "dobro",
    "dobro-bass",
    "dohol",
    "doira",
    "dojo",
    "dolceola",
    "doli",
    "dombra",
    "domra",
    "doneli",
    "donno",
    "donso ngoni",
    "doorbell",
    "doshpuluur",
    "dotara",
    "double bass",
    "double bassoon",
    "double clarinet",
    "double flute",
    "double reed",
    "doumbaki",
    "doumbi",
    "doyra",
    "dramyin",
    "dril-bu",
    "droma",
    "drone",
    "drum",
    "drum kit",
    "drum machine",
    "drum major",
    "drum programming",
    "drum sergeant",
    "drumkit",
    "drums",
    "drums (drum set)",
    "duck call",
    "duduk",
    "duet with",
    "duff",
    "duggi",
    "dulce melos",
    "dulcian",
    "dulcimer",
    "dulcitone",
    "dulzaina",
    "dumbak",
    "dumbelek",
    "dumbuks",
    "dung-chen",
    "dunun",
    "dutar",
    "duxianqin",
    "dvojacka",
    "dvojnice",
    "e-bow",
    "e-flat clarinet",
    "ektara",
    "electric accordion",
    "electric appalachian dulcimer",
    "electric baritone guitar",
    "electric bass",
    "electric bass guitar",
    "electric cello",
    "electric drums",
    "electric fiddle",
    "electric fretless guitar",
    "electric grand piano",
    "electric guitar",
    "electric harmonium",
    "electric harp",
    "electric harpsichord",
    "electric keyboards",
    "electric lap steel guitar",
    "electric mandolin",
    "electric organ",
    "electric piano",
    "electric sitar",
    "electric upright bass",
    "electric viola",
    "electric violin",
    "electronic drum kit",
    "electronic drum set",
    "electronic instrument",
    "electronic music",
    "electronic percussion",
    "electronic valve instrument",
    "electronic vibraphone",
    "electronic wind instrument",
    "electronics",
    "electronium",
    "eligible studio producer",
    "emulator",
    "end-blown flute",
    "english bagpipes",
    "english concertina",
    "english flageolet",
    "english guitar",
    "english horn",
    "ensemble",
    "entertainer",
    "epinette des vosges",
    "erhu",
    "esraj",
    "euphonium",
    "ewi",
    "fado viola",
    "fairground organ",
    "falsetto",
    "falsetto vocals",
    "fanfare trumpet",
    "farfisa",
    "featuring",
    "feedback",
    "fiddle",
    "fife",
    "finger clicks",
    "finger cymbals",
    "finger snaps",
    "fipple flute",
    "flabiol",
    "flageolet",
    "flamenco guitar",
    "flauta",
    "flexatone",
    "floppy disk drive",
    "floyera",
    "flugabone",
    "flugelhorn",
    "fluier",
    "flumpet",
    "flute",
    "flute d'amour",
    "flute organ",
    "flutina",
    "folk guitar",
    "folk harp",
    "folklorist",
    "foot stamping",
    "foot stomps",
    "foot tapping",
    "footbass",
    "fortepiano",
    "fotdella",
    "frame drum",
    "free reed",
    "free-reed flute",
    "french bagpipes",
    "french horn",
    "fretless bass",
    "fretless bass guitar",
    "fretless guitar",
    "friction drum",
    "friction idiophone",
    "frigideira",
    "friscaletto",
    "frottoir",
    "frying-pan",
    "fujara",
    "fundeh",
    "fyell",
    "gadulka",
    "gaita",
    "gajde",
    "galician gaita",
    "gallichon",
    "galo",
    "galoubet",
    "gambang",
    "game console sound chip",
    "gamelan",
    "ganga",
    "gangsa",
    "gankogui",
    "ganza",
    "gaohu",
    "gardon",
    "garifuna drum",
    "garklein recorder",
    "garmon",
    "gayageum",
    "gbedu",
    "gehu",
    "gemshorn",
    "gender",
    "gender barung",
    "gender panerus",
    "gender wayang",
    "genggong",
    "geomungo",
    "german concertina",
    "german harp",
    "ghara",
    "ghatam",
    "ghati",
    "ghayta",
    "ghijak",
    "ghungroo",
    "giga",
    "gini",
    "gittern",
    "glass",
    "glass harmonica",
    "glass harp",
    "glockenspiel",
    "goblet drum",
    "goje",
    "gong",
    "gong bass drum",
    "gong chime",
    "gong-chime",
    "gorodao",
    "gottuvadyam",
    "gourd",
    "gourd rattle",
    "gralla",
    "gramorimba",
    "grand piano",
    "grantang",
    "gravikord",
    "great bass recorder",
    "great highland bagpipe",
    "griot",
    "grneta",
    "groovebox",
    "gu",
    "guacharaca",
    "guan",
    "guayo",
    "guban",
    "gubgubi",
    "gudastviri",
    "gudok",
    "gudugudu",
    "guest",
    "guimbri",
    "guira",
    "guiro",
    "guitalele",
    "guitar",
    "guitar banjo",
    "guitar synthesizer",
    "guitaret",
    "guitarra",
    "guitarron",
    "guitarron chileno",
    "guitarron mexicano",
    "guitarviol",
    "guitolao",
    "guitorgan",
    "guitsteel",
    "gung",
    "guntang",
    "guqin",
    "gusli",
    "guzheng",
    "haegeum",
    "halldorophone",
    "halszither",
    "hammer",
    "hammered dulcimer",
    "hammond organ",
    "hand bells",
    "hand clapping",
    "handpan",
    "hang drum",
    "hard disk drive",
    "hardanger fiddle",
    "hardingfele",
    "harjedalspipa",
    "harmet",
    "harmonica",
    "harmonium",
    "harmony vocals",
    "harp",
    "harp guitar",
    "harpejji",
    "harpsichord",
    "harpsipiano",
    "haute-contre",
    "haute-contre vocals",
    "hawaiian guitar",
    "heckelphone",
    "heike biwa",
    "helicon",
    "hi-hat",
    "hichiriki",
    "high violin",
    "highland bagpipes",
    "hmong flute",
    "hoddu",
    "homus",
    "horagai",
    "horns",
    "hosho",
    "hot fountain pen",
    "hotchiku",
    "hourglass drum",
    "huapanguera",
    "hudukka",
    "hue puruhau",
    "hue puruwai",
    "hulusi",
    "hummel",
    "humming",
    "hunting horn",
    "hunting horn (valved)",
    "huqin",
    "hurdy-gurdy",
    "hyoshigi",
    "ichigenkin",
    "idiophone",
    "igil",
    "imitation bass",
    "impersonator",
    "indian harp",
    "indonesian rebab",
    "instructor",
    "instrument",
    "instruments",
    "interview",
    "interviewee",
    "interviewer",
    "irish bouzouki",
    "irish flute",
    "irish harp",
    "irish whistle",
    "jagd horn",
    "jaggo",
    "jal tarang",
    "janggu",
    "jantar",
    "japanese wooden flute",
    "jarana",
    "jazz horn",
    "jegogan",
    "jejo",
    "jejo voatavo",
    "jeli ngoni",
    "jew's harp",
    "jing",
    "jing'erhu",
    "jinghu",
    "jingle bells",
    "joik",
    "jouhikko",
    "jublag",
    "jug",
    "jugkalimba",
    "jumbush",
    "junjung",
    "jushichigen-kin (bass koto)",
    "ka (drum)",
    "kaba gaida",
    "kabosy",
    "kacapi",
    "kacapi indung",
    "kacapi rincik",
    "kacapi siter",
    "kachva sitar",
    "kagura suzu",
    "kagurabue",
    "kaiamba rambo",
    "kakegoe",
    "kalimba",
    "kamac",
    "kamaica",
    "kamale ngoni",
    "kamancheh",
    "kanjira",
    "kankles",
    "kannel",
    "kantele",
    "kantilan",
    "kanun",
    "karamouza",
    "karigo",
    "karkabas",
    "karna",
    "kaval",
    "kayagum",
    "kazoo",
    "kecer",
    "kemanak",
    "kemence",
    "kemence of the black sea",
    "kempli",
    "kempul",
    "kempyang",
    "ken bau",
    "ken la",
    "kena",
    "kendang",
    "kendang lanang",
    "kendang wadon",
    "kendhang batangan",
    "kendhang gendhing",
    "kendhang indung",
    "kendhang ketipung",
    "kendhang kulanter",
    "kendhang wayangan",
    "kenong",
    "kepyak",
    "kethuk",
    "kettledrum",
    "ketuk",
    "keyboard bass",
    "keyboards",
    "keyed box zither",
    "keyed brass instruments",
    "keytar",
    "khaen",
    "khalam",
    "khartal",
    "khen meo",
    "khene",
    "khim",
    "khlui",
    "khol",
    "khong wong",
    "khong wong lek",
    "khong wong yai",
    "khulsan khuur",
    "khurdak",
    "khuur",
    "ki pah",
    "kinnor",
    "kirar",
    "kithara",
    "kkwaenggwari",
    "klong",
    "klong khaek",
    "klong song na",
    "klong that",
    "klong yao",
    "koauau",
    "koauau ponga ihu",
    "kobyz",
    "kokle",
    "kokyu",
    "komun'go",
    "komuz",
    "kora",
    "kortholt",
    "kos",
    "koto",
    "kotsuzumi",
    "krakebs",
    "krap",
    "krap khu",
    "krap phuang",
    "krap sepha",
    "krar",
    "kudum",
    "kulintang",
    "kusle",
    "kynggari",
    "lagerphone",
    "lakota flute",
    "lamba",
    "lamellophone",
    "langeleik",
    "laouto",
    "lap harp",
    "lap steel guitar",
    "laser harp",
    "laud",
    "launeddas",
    "lautenwerck",
    "lavta",
    "lead guitar",
    "lead vocals",
    "leader",
    "likembe",
    "lilting",
    "limbe",
    "lion's roar",
    "lira",
    "lira da braccio",
    "lira organizzatai",
    "lirica",
    "lirone",
    "liru",
    "lithophone",
    "liuqin",
    "llaute",
    "log drum",
    "lokanga bara",
    "lokole",
    "low whistle",
    "lowland pipes",
    "lukeme",
    "lur",
    "lute",
    "lute guitar",
    "lute-harpsichord",
    "lutheal",
    "lyra",
    "lyra viol",
    "lyre",
    "lyricon",
    "lysarden",
    "madal",
    "maddalam",
    "maddale",
    "magruna",
    "mallets",
    "mandobass",
    "mandocello",
    "mandoguitar",
    "mandola",
    "mandolin",
    "mandolin banjo",
    "mandolin family",
    "mandolincello",
    "mandolute",
    "mandore",
    "manjira",
    "mankeri",
    "manzello",
    "maracas",
    "marimba",
    "marimba lumina",
    "marimbula",
    "marine trumpet",
    "mark tree",
    "marovany",
    "marxophone",
    "masenqo",
    "master of ceremonies (mc)",
    "mbira",
    "mechanical general",
    "mejoranera",
    "mellophone",
    "mellophonium",
    "mellotron",
    "melodeon",
    "melodica",
    "membranophone",
    "mendoza",
    "metallophone",
    "mexican vihuela",
    "mey",
    "mezzo violin",
    "mezzo-contralto",
    "mezzo-soprano",
    "midi",
    "midi controller",
    "midistick",
    "mijwiz",
    "minimoog",
    "minipiano",
    "minister",
    "mirliton",
    "mirwas",
    "miscellaneous",
    "mizmar",
    "mizwad",
    "moceno",
    "mong",
    "monkey stick",
    "monochord",
    "moog",
    "morchang",
    "morin khuur",
    "morrisette",
    "morsing",
    "mountain dulcimer",
    "mouth bow",
    "mouth harp",
    "mouth music",
    "mouth organ",
    "mrdanga",
    "mukkuri",
    "munnharpe",
    "murali",
    "murcang",
    "murli",
    "muselar",
    "musette",
    "musette de cour",
    "music box",
    "music director",
    "music sequencer",
    "music video clip director",
    "musical bow",
    "musical saw",
    "musician",
    "n'vike",
    "nabal",
    "nadaswaram",
    "nagadou-daiko",
    "nagak",
    "nai",
    "nakers",
    "nal",
    "nanga",
    "naobo",
    "naqqara",
    "narrator",
    "nattuva talam",
    "natural brass instruments",
    "natural horn",
    "natural trumpet",
    "ney",
    "ngoma",
    "ngoni",
    "nguru",
    "nigenkin",
    "njarka",
    "nkoni",
    "nohkan",
    "noises",
    "northumbrian pipes",
    "northumbrian small pipes",
    "nose flute",
    "nose whistle",
    "novachord",
    "nyatiti",
    "nyckelharpa",
    "oboe",
    "oboe d'amore",
    "oboe da caccia",
    "ocarina",
    "ocean drum",
    "octapad",
    "octave mandolin",
    "octavilla",
    "octavina",
    "octoban",
    "octobass",
    "okonkole",
    "oktawka",
    "olifant",
    "omnichord",
    "ondes martenot",
    "ondioline",
    "one-man band",
    "onoben",
    "open-back banjo",
    "ophicleide",
    "optigan",
    "organ",
    "organistrum",
    "orpharion",
    "orphica",
    "otamatone",
    "other",
    "other brass instruments",
    "other instruments",
    "other plucking instruments",
    "other woodwind instruments",
    "otsuzumi",
    "oud",
    "outi",
    "oval spinet",
    "overtone flute",
    "overtone voice",
    "p'iri",
    "pahu",
    "pahu pounamu",
    "paiban",
    "paila",
    "pakhavaj",
    "pakuru",
    "palmas",
    "pan flute",
    "pandeiro",
    "pandereta",
    "panduri",
    "pang gu ly hu hmong",
    "pano",
    "panpipes",
    "paraguayan harp",
    "pardessus de viole",
    "parlour grand piano",
    "pate",
    "pedabro",
    "pedal accordion",
    "pedal piano",
    "pedal steel guitar",
    "pedalboard",
    "pemade",
    "percussion",
    "percussion idiophone",
    "performer",
    "phach",
    "pi",
    "pi chawa",
    "pi nai",
    "pi thiu",
    "pianet",
    "piano",
    "piano accordion",
    "piano duo",
    "piano four hands",
    "piano quartet",
    "piano spinet",
    "piano trio",
    "pianoforte",
    "piccolo",
    "piccolo banjo",
    "piccolo bass",
    "piccolo bass guitar",
    "piccolo flute",
    "piccolo oboe",
    "piccolo trumpet",
    "pierrot ensemble",
    "pifana",
    "piffaro",
    "pipa",
    "pipe and tabor",
    "pipe major",
    "pipe organ",
    "pipe sergeant",
    "pipes",
    "pirula",
    "pito",
    "pito herreno",
    "pixiephone",
    "pkhachich",
    "platillos",
    "player piano",
    "plectrum banjo",
    "plucked idiophone",
    "plucked string instruments",
    "pluriarc",
    "pocket trumpet",
    "poetry reader",
    "poi",
    "poi awhiowhio",
    "polyphon",
    "porotiti",
    "portative",
    "portuguese guitar",
    "porutu",
    "positive organ",
    "post horn",
    "practice chanter",
    "preacher",
    "prempensua",
    "prepared piano",
    "presenter",
    "primero",
    "producer",
    "producer (rhythm track)",
    "producer (vocal)",
    "producer remixer",
    "producer vocal",
    "programming",
    "psalmodicon",
    "psaltery",
    "pujador",
    "pukaea",
    "pullankulal",
    "pumotomoto",
    "pump organ",
    "pupakapaka",
    "purerehua",
    "putatara",
    "putorino",
    "qanun",
    "qasaba",
    "qilaut",
    "qirba",
    "quadruple reed",
    "quart-bassoon",
    "quena",
    "quenacho",
    "quijada",
    "quills",
    "quint-bassoon",
    "quinto",
    "quinton",
    "quray",
    "rababa",
    "rabeca",
    "rabel",
    "rackett",
    "raconteur",
    "rag dung",
    "rainstick",
    "rammana",
    "ranat ek",
    "ranat kaeo",
    "ranat thum",
    "rap",
    "ratchet",
    "rattle",
    "rauschpfeife",
    "ravanahatha",
    "reactable",
    "read by",
    "rebab",
    "rebec",
    "reciter",
    "reco-reco",
    "recorder",
    "reed organ",
    "reeds",
    "regal",
    "rehu",
    "reikin",
    "remaster producer",
    "remix engineer",
    "renaissance rackett",
    "repeater",
    "repinique",
    "repique",
    "reporter",
    "requinto",
    "requinto guitar",
    "resonator",
    "resonator banjo",
    "resonator guitar",
    "reyong",
    "rgya-gling",
    "rhaita",
    "rhodes piano",
    "rhythm guitar",
    "rhythm section",
    "rhythm sticks",
    "rhythms box",
    "riqq",
    "rkang-gling",
    "rnga",
    "rol-mo",
    "rondador",
    "ronroco",
    "roria",
    "rototoms",
    "rozhok",
    "ruan",
    "rubab",
    "rubboard",
    "rudra veena",
    "ryuteki",
    "sabar",
    "sackbut",
    "sackpipa",
    "saduk",
    "saenghwang",
    "salamuri",
    "salterio",
    "saluang",
    "samba whistle",
    "samica",
    "sampler",
    "sampona",
    "samvadini",
    "sanfona",
    "sanger-in",
    "sanshin",
    "santoor",
    "sanxian",
    "sanza",
    "sao meo",
    "sao truc",
    "sapeh",
    "sarangi",
    "saraswati veena",
    "sargija",
    "sarod",
    "saron",
    "saron barung",
    "saron demung",
    "saron family",
    "saron panerus",
    "saron peking",
    "saron wayang",
    "saroz",
    "sarrusophone",
    "satara",
    "satsuma",
    "satsuma biwa",
    "saw",
    "saw duang",
    "saw sam sai",
    "saw u",
    "saxello",
    "saxhorn",
    "saxophone",
    "saxophone quartet",
    "saxor",
    "saz",
    "scat",
    "schlagzeug drums",
    "schwyzerorgeli",
    "scottish small pipes",
    "scottish smallpipes",
    "scraped idiophone",
    "scraper",
    "scratcher",
    "scratches",
    "segunda",
    "selmer-maccaferri guitar",
    "semi-acoustic guitar",
    "senh tien",
    "seni rebab",
    "seperewa",
    "sequencer",
    "serpent",
    "setar",
    "shahi baaja",
    "shakers",
    "shakubyoshi",
    "shakuhachi",
    "shamisen",
    "shawm",
    "shehnai",
    "shekere",
    "sheng",
    "shichepshin",
    "shime-daiko",
    "shinobue",
    "sho",
    "shofar",
    "shouting",
    "shruti box",
    "shudraga",
    "shuitar",
    "shuttle pipes",
    "siku",
    "sil-snyan",
    "sindhi sarangi",
    "singer",
    "singing bowls",
    "single reed",
    "sintir",
    "siren",
    "sistrum",
    "sitar",
    "skratjie",
    "slagbordun",
    "slapstick",
    "sleigh bells",
    "slenthem",
    "slide brass instruments",
    "slide guitar",
    "slide trumpet",
    "slide whistle",
    "slit drums",
    "small bass violin",
    "small guitar",
    "smallpipes",
    "snare",
    "snare drums",
    "sodina",
    "software instrument",
    "solo vocal",
    "soloist",
    "song loan",
    "sopilka",
    "sopranino",
    "sopranino clarinet",
    "sopranino recorder",
    "sopranino saxophone",
    "soprano",
    "soprano clarinet",
    "soprano cornet",
    "soprano crumhorn",
    "soprano flute",
    "soprano recorder",
    "soprano saxophone",
    "soprano trombone",
    "soprano violin",
    "soprano vocals",
    "sordone",
    "sorna",
    "souna",
    "sound effects",
    "sounds",
    "sousaphone",
    "souvliari",
    "spanish guitar",
    "speech",
    "spike-fiddle",
    "spilapipa",
    "spinet",
    "spinettone",
    "spoken word",
    "spoons",
    "square pianoforte",
    "steam locomotive sounds",
    "steel drums",
    "steel guitar",
    "steel-string acoustic guitar",
    "steelpan",
    "steirische harmonika",
    "step dancer",
    "stick sal",
    "stick zither",
    "stomp box",
    "storyteller",
    "street organ",
    "string drum",
    "string quartet",
    "string quintet",
    "string synthesizer",
    "string trio",
    "strings",
    "stritch",
    "stroh violin",
    "strohfidel",
    "struck idiophone",
    "struck string instruments",
    "strumstick",
    "studio conductor",
    "studio personnel (performing)",
    "stylophone",
    "subcontrabass recorder",
    "subcontrabass saxophone",
    "suka",
    "suling",
    "suona",
    "surbahar",
    "surdo",
    "surigane",
    "surmandal",
    "surnai (kashmir)",
    "sursingar",
    "svara mandala",
    "svirala",
    "swanee whistle",
    "swarmandal",
    "symphony",
    "sympitar",
    "synclavier",
    "synthaxe",
    "synthesizer",
    "syrinx",
    "t'rung",
    "taal",
    "tabal",
    "tabla",
    "table steel guitar",
    "tabor",
    "tack piano",
    "taegum",
    "taepyeongso",
    "taiko",
    "taishogoto",
    "talharpa",
    "talkbox",
    "talking drum",
    "tam-tam",
    "tama",
    "tambin",
    "tambora",
    "tamboril",
    "tamborim",
    "tambourine",
    "tambur (drum)",
    "tambur (gong)",
    "tambur (lute)",
    "tambura",
    "tamburica",
    "tan-tan",
    "tanbou ka",
    "tanbur",
    "tangent piano",
    "tannerin",
    "tanpura",
    "taonga puoro",
    "tap dancer",
    "tapan",
    "tapboard",
    "taphon",
    "tar",
    "tar (drum)",
    "tar (flute)",
    "tar (frame drum)",
    "tar (lute)",
    "tar shenai",
    "taragot",
    "taragoto",
    "tarawangsa",
    "tarka",
    "tarogato",
    "tarol",
    "tarota",
    "tavil",
    "te ku",
    "tea chest bass",
    "tef",
    "telharmonium",
    "temple bells",
    "temple blocks",
    "temur khuur",
    "tenor",
    "tenor banjo",
    "tenor bassoon",
    "tenor flute",
    "tenor guitar",
    "tenor horn",
    "tenor recorder",
    "tenor sarrusophone",
    "tenor saxophone",
    "tenor sordun",
    "tenor trombone",
    "tenor viol",
    "tenor violin",
    "tenor vocals",
    "tenora",
    "tenoroon",
    "tepsija",
    "thavil",
    "the great stalacpipe organ",
    "theatre organ",
    "theorbo",
    "theremin",
    "thon",
    "three-hole pipe",
    "throat singing",
    "thumb piano",
    "ti bwa",
    "ti-tse",
    "tibetan singing bowl",
    "tibetan water drum",
    "tible",
    "tieu",
    "tifa",
    "timbal",
    "timbrel",
    "timpani",
    "timple",
    "tin whistle",
    "tinya",
    "tiompan",
    "tiple",
    "toasting",
    "tokere",
    "tololoche",
    "tom-tom",
    "tombak",
    "tonette",
    "tongatong",
    "tonkori",
    "topshuur",
    "torader",
    "totobuang",
    "toumbas",
    "tovshuur",
    "toy (instruments)",
    "toy piano",
    "traditional basque ensemble",
    "tram ple",
    "trang jau",
    "trang lu",
    "transverse flute",
    "traps",
    "trautonium",
    "treble",
    "treble flute",
    "treble recorder",
    "treble shawm",
    "treble tambura",
    "treble viol",
    "treble violin",
    "treble vocals",
    "tres",
    "tres cubano",
    "triangle",
    "trikitixa",
    "triple harp",
    "tritantri veena",
    "tromba marina",
    "trombone",
    "trompeta",
    "trompetica china",
    "trong bong",
    "trumpet",
    "trumpet (eflat)",
    "trumpet marine",
    "trutruka",
    "tsuur",
    "tuba",
    "tubaphone",
    "tubax",
    "tube zither",
    "tubon",
    "tubular bells",
    "tubulum",
    "tulum",
    "tumba",
    "tumba (goblet drum)",
    "tumbadora",
    "tumbi",
    "tumutumu",
    "tun",
    "tuned percussion",
    "tungso",
    "tungur",
    "tusseflute",
    "txalaparta",
    "txirula",
    "txistu",
    "tymps",
    "typewriter",
    "tzouras",
    "udu",
    "ugal",
    "uilleann pipes",
    "ukeke",
    "ukulele",
    "ukulele banjo",
    "untuned percussion",
    "upright piano",
    "utogardon",
    "valiha",
    "valve trombone",
    "valve trumpet",
    "valved brass instruments",
    "variophon",
    "veena",
    "venu",
    "vessel flute",
    "vibes",
    "vibra-slap",
    "vibrandoneon",
    "vibraphone",
    "vichitra veena",
    "vielle",
    "vietnamese guitar",
    "vihuela",
    "viol",
    "viol consort",
    "viol family",
    "viola",
    "viola (guitar)",
    "viola bastarda",
    "viola beiroa",
    "viola braguesa",
    "viola caipira",
    "viola campanica",
    "viola d'amore",
    "viola da gamba",
    "viola de cocho",
    "viola kontra",
    "viola nordestina",
    "viola organista",
    "viola pomposa",
    "violarina",
    "violin",
    "violin octet",
    "violino piccolo",
    "viololyra",
    "violoncello",
    "violoncello piccolo",
    "violone",
    "violotta",
    "virginals",
    "vocal effects",
    "vocal percussion",
    "vocalese",
    "vocalizer",
    "vocals",
    "vocoder",
    "voice",
    "voice actor",
    "voice synthesizer",
    "vuvuzela",
    "wagner tuba",
    "walaycho",
    "waldhorn",
    "warr guitar",
    "washboard",
    "washint",
    "washtub bass",
    "waterphone",
    "wavedrum",
    "weisenborn",
    "whip",
    "whistle",
    "whistling",
    "whistling water jar",
    "wiener horn",
    "willow flute",
    "wind",
    "wind chime",
    "wind machine",
    "wind piano",
    "wind synthesizer",
    "wire-strung harp",
    "wobble board",
    "wood block",
    "wood chimes",
    "woodblock",
    "wooden fish",
    "wooden flute",
    "woodwind",
    "word director",
    "worship leader",
    "wot",
    "wurlitzer electric piano",
    "wurlitzer organ",
    "xalam",
    "xaphoon",
    "xiao",
    "xiaoluo",
    "xun",
    "xylophone",
    "xylophone (strohfidel)",
    "xylorimba",
    "yaktaro",
    "yamaha wx-7",
    "yanggeum",
    "yangqin",
    "yatga",
    "yayli tanbur",
    "yehu",
    "yenjing",
    "yodelling",
    "yonggo",
    "yoochin",
    "yorgaphone",
    "yueqin",
    "yunluo",
    "zabumba",
    "zafzafa",
    "zampogna",
    "zamr",
    "zapateado",
    "zaqq",
    "zarb",
    "zeze",
    "zhaleika",
    "zhonghu",
    "zhongruan",
    "zhuihu",
    "zill",
    "zirbaghali",
    "zither",
    "zongora",
    "zukra",
    "zummara",
    "zurna"
];
const $f50146991650bb90$export$8a37bc9941276912 = [
    "12-string guitar",
    "accompanist",
    "accordion",
    "achere",
    "acoustic bass",
    "acoustic guitar",
    "akete",
    "alghoza",
    "alphorn",
    "alto saxophone",
    "aman khuur",
    "analog synthesizer",
    "angklung",
    "appalachian dulcimer",
    "archlute",
    "arrabel",
    "artistic narrator",
    "ashiko",
    "autoharp",
    "backing vocals",
    "baglama (saz) family",
    "bagpipes",
    "baltic psalteries",
    "band",
    "bandoneon",
    "bandora",
    "banjo",
    "banjo guitar",
    "banjo-ukulele",
    "bansuri",
    "barbat",
    "baritone",
    "baritone guitar",
    "baritone saxophone",
    "baroque guitar",
    "barrel drum",
    "barrel organ",
    "bass",
    "bass drum",
    "bass recorder",
    "bass viol",
    "bass violin",
    "bass-baritone",
    "bassoon",
    "bata drum",
    "bell-piano",
    "bellow-blown bagpipes",
    "bellowed reed",
    "bells",
    "bin",
    "bin-sitar",
    "biwa",
    "body percussion",
    "bombo",
    "bonang",
    "bonang barung",
    "bonang panembung",
    "bongos",
    "boobam",
    "border pipes",
    "bouzouki",
    "bowed lute",
    "bowed lyre",
    "bowed psaltery",
    "bowed string instruments",
    "box zither",
    "brass",
    "bronze lur",
    "bugle",
    "button accordion",
    "c-melody saxophone",
    "cabasa",
    "caixa",
    "caja",
    "cajon",
    "castanets",
    "castrato",
    "cavaquinho",
    "celesta",
    "cello",
    "chakhe",
    "chamber organ",
    "chamberlin",
    "chanting",
    "chap",
    "chapman stick",
    "chimes",
    "chirimia",
    "chorus",
    "chromatic button accordion",
    "chuurqin",
    "cither",
    "cittern",
    "clapstick",
    "clarinet",
    "classical guitar",
    "clavichord",
    "claviorganum",
    "clog",
    "concert flute",
    "concert harp",
    "concertina",
    "concussion idiophone",
    "conductor",
    "contrabass saxophone",
    "contralto",
    "cornet",
    "cornett",
    "crumhorn",
    "cumbus",
    "cylindrical drum",
    "cymbals",
    "daf",
    "dan bau",
    "dan nhi",
    "dancer",
    "darbuka",
    "davul",
    "diatonic button accordion",
    "didgeridoo",
    "digital audio workstation",
    "dilli tuiduk",
    "dilruba",
    "disk drive",
    "dobro",
    "dohol",
    "dolceola",
    "double bass",
    "double flute",
    "double reed",
    "drum machine",
    "drum programming",
    "drums",
    "drums (drum set)",
    "dulce melos",
    "dulcian",
    "dulcimer",
    "dunun",
    "e-flat clarinet",
    "ektara",
    "electric bass guitar",
    "electric cello",
    "electric fretless guitar",
    "electric guitar",
    "electric keyboards",
    "electric piano",
    "electric viola",
    "electric violin",
    "electronic drum set",
    "electronic instrument",
    "electronic wind instrument",
    "eligible studio producer",
    "end-blown flute",
    "euphonium",
    "falsetto",
    "fiddle",
    "fife",
    "finger cymbals",
    "finger snaps",
    "fipple flute",
    "flabiol",
    "flageolet",
    "flamenco guitar",
    "flugelhorn",
    "flumpet",
    "flute",
    "folk harp",
    "foot stomps",
    "frame drum",
    "free reed",
    "fretless bass",
    "friction drum",
    "friction idiophone",
    "frottoir",
    "frying-pan",
    "galo",
    "gamelan",
    "garifuna drum",
    "gayageum",
    "gender",
    "german concertina",
    "ghara",
    "glass",
    "glass harp",
    "goblet drum",
    "gong",
    "gong-chime",
    "gourd",
    "gralla",
    "grand piano",
    "great highland bagpipe",
    "guan",
    "guban",
    "gudok",
    "guitar",
    "guitaret",
    "guitarron chileno",
    "guqin",
    "gusli",
    "guzheng",
    "haegeum",
    "hammered dulcimer",
    "hammond organ",
    "hand clapping",
    "harmonica",
    "harmonium",
    "harp",
    "harpsichord",
    "haute-contre",
    "hawaiian guitar",
    "helicon",
    "hi-hat",
    "hmong flute",
    "hourglass drum",
    "hunting horn (valved)",
    "huqin",
    "hurdy-gurdy",
    "idiophone",
    "interview",
    "jing",
    "jug",
    "kaba gaida",
    "kacapi",
    "kachva sitar",
    "kamancheh",
    "kannel",
    "karamouza",
    "kaval",
    "kempul",
    "kendang",
    "keyboards",
    "keyed box zither",
    "khol",
    "khong wong",
    "khong wong yai",
    "kkwaenggwari",
    "klong that",
    "kora",
    "koto",
    "krap",
    "lamellophone",
    "lap steel guitar",
    "lira da braccio",
    "lirone",
    "lithophone",
    "lukeme",
    "lute",
    "lute-harpsichord",
    "lyra viol",
    "lyre",
    "madal",
    "mandola",
    "mandolin",
    "mandolin family",
    "maracas",
    "marimba",
    "mbira",
    "melodica",
    "membranophone",
    "mendoza",
    "metallophone",
    "mezzo-contralto",
    "mirliton",
    "miscellaneous",
    "monkey stick",
    "monochord",
    "morin khuur",
    "morsing",
    "mouth harp",
    "mouth organ",
    "murali",
    "musette de cour",
    "musical bow",
    "nanga",
    "naqqara",
    "narrator",
    "natural brass instruments",
    "natural horn",
    "natural trumpet",
    "ngoni",
    "northumbrian pipes",
    "nose flute",
    "nyatiti",
    "nyckelharpa",
    "oboe",
    "oboe da caccia",
    "octavilla",
    "octoban",
    "organ",
    "other instruments",
    "other woodwind instruments",
    "pahu",
    "pan flute",
    "pardessus de viole",
    "pedal steel guitar",
    "percussion",
    "percussion idiophone",
    "performer",
    "pi",
    "pianet",
    "piano",
    "piano accordion",
    "pianoforte",
    "piccolo",
    "piccolo oboe",
    "pipa",
    "pipe and tabor",
    "pipe organ",
    "plucked idiophone",
    "plucked string instruments",
    "pluriarc",
    "portuguese guitar",
    "post horn",
    "producer",
    "producer (vocal)",
    "programming",
    "psaltery",
    "pump organ",
    "putatara",
    "qilaut",
    "quadruple reed",
    "quena",
    "quinto",
    "rababa",
    "rackett",
    "rainstick",
    "ranat ek",
    "rattle",
    "ravanahatha",
    "rebab",
    "reco-reco",
    "recorder",
    "reeds",
    "regal",
    "repinique",
    "resonator guitar",
    "rhythm sticks",
    "rondador",
    "ruan",
    "rudra veena",
    "sabar",
    "saduk",
    "samica",
    "sanshin",
    "sanxian",
    "sarangi",
    "sargija",
    "saron",
    "saron family",
    "sarrusophone",
    "satsuma biwa",
    "saw duang",
    "saw u",
    "saxophone",
    "saz",
    "scottish smallpipes",
    "scraped idiophone",
    "scratcher",
    "shakers",
    "shakuhachi",
    "shawm",
    "shekere",
    "siku",
    "singer",
    "single reed",
    "sitar",
    "slenthem",
    "slide brass instruments",
    "sopilka",
    "sopranino recorder",
    "sopranino saxophone",
    "soprano",
    "soprano saxophone",
    "sorna",
    "sound effects",
    "sounds",
    "souvliari",
    "spike-fiddle",
    "spilapipa",
    "spinet",
    "steel drums",
    "steel guitar",
    "steel-string acoustic guitar",
    "stick zither",
    "storyteller",
    "string drum",
    "string quartet",
    "string quintet",
    "strings",
    "struck idiophone",
    "struck string instruments",
    "surdo",
    "sursingar",
    "swarmandal",
    "synthesizer",
    "tack piano",
    "taepyeongso",
    "taiko",
    "taishogoto",
    "talharpa",
    "tamborim",
    "tambourine",
    "tambura",
    "tamburica",
    "tanbur",
    "taonga puoro",
    "tar",
    "tar (frame drum)",
    "tarota",
    "tef",
    "temple blocks",
    "tenor",
    "tenora",
    "tenoroon",
    "thavil",
    "theatre organ",
    "three-hole pipe",
    "tibetan water drum",
    "tifa",
    "timple",
    "tin whistle",
    "tiple",
    "tom-tom",
    "topshuur",
    "toumbas",
    "toy piano",
    "trang lu",
    "treble",
    "tres",
    "tromba marina",
    "trombone",
    "trumpet",
    "tuba",
    "tube zither",
    "tumba (goblet drum)",
    "tuned percussion",
    "tungso",
    "uilleann pipes",
    "ukulele",
    "utogardon",
    "valve trombone",
    "valved brass instruments",
    "veena",
    "vessel flute",
    "vibraphone",
    "vichitra veena",
    "vielle",
    "viol",
    "viol family",
    "viola",
    "viola da gamba",
    "violin",
    "violin octet",
    "viololyra",
    "vocals",
    "voice",
    "walaycho",
    "washboard",
    "whistle",
    "wind",
    "wind chime",
    "wind synthesizer",
    "wood block",
    "woodwind",
    "worship leader",
    "xalam",
    "xiao",
    "xiaoluo",
    "xylophone",
    "xylophone (strohfidel)",
    "yangqin",
    "yatga",
    "zarb",
    "zhuihu",
    "zirbaghali",
    "zither",
    "zummara"
];


/**
 * Release Format taxonomy — combined from Discogs + MusicBrainz format names.
 * Maps to the "mediaType" field in the OpenSearch ParentRelease schema.
 *
 * To regenerate: node admin_portal/src/data/generate-release-taxonomies.js
 */ /** All valid release format values, sorted alphabetically. */ const $0b4e1af42faad25c$export$6a2892aa4af64e1e = [
    '10" Acetate',
    '10" Shellac',
    '10" Vinyl',
    '12" Acetate',
    '12" LaserDisc',
    '12" Shellac',
    '12" Vinyl',
    '3" Vinyl',
    '3.5" Floppy Disk',
    "4-Track Cartridge",
    '5.25" Floppy Disk',
    '7" Acetate',
    '7" Flexi-disc',
    '7" Shellac',
    '7" Vinyl',
    '8" LaserDisc',
    "8-Track Cartridge",
    "8cm CD",
    "8cm CD+G",
    "8cm CD-R",
    "Acetate",
    "All Media",
    "Beta ED",
    "Betacam",
    "Betacam SP",
    "Betamax",
    "Blu-ray",
    "Blu-ray-R",
    "Blu-spec CD",
    "Box Set",
    "CD",
    "CD+G",
    "CD-R",
    "CD-i",
    "CDV",
    "CDr",
    "CED",
    "Cartridge",
    "Cartrivision",
    "Cassette",
    "Copy Control CD",
    "Cylinder",
    "DAT",
    "DC-International",
    "DCC",
    "DTS CD",
    "DVD",
    "DVD-Audio",
    "DVD-R Video",
    "DVD-Video",
    "DVDplus",
    "DVDplus (CD side)",
    "DVDplus (DVD-Audio side)",
    "DVDplus (DVD-Video side)",
    "DVDr",
    "Data CD",
    "Data DVD",
    "Data DVD-R",
    "DataPlay",
    "Digital Media",
    "Download Card",
    "DualDisc",
    "DualDisc (CD side)",
    "DualDisc (DVD side)",
    "DualDisc (DVD-Audio side)",
    "DualDisc (DVD-Video side)",
    "Edison Diamond Disc",
    "Edison Disc",
    "Elcaset",
    "Enhanced CD",
    "File",
    "Film Reel",
    "Flexi-disc",
    "Floppy Disk",
    "HD DVD",
    "HD DVD-R",
    "HD-DVD",
    "HDCD",
    "HQCD",
    "HiPac",
    "HitClips",
    "Hybrid",
    "Hybrid SACD",
    "Hybrid SACD (CD layer)",
    "Hybrid SACD (SACD layer)",
    "Hybrid SACD (SACD layer, 2 channels)",
    "Hybrid SACD (SACD layer, multichannel)",
    "KiT Album",
    "LaserDisc",
    "Laserdisc",
    "Lathe Cut",
    "MVD",
    "Memory Stick",
    "Microcassette",
    "Mighty Tiny",
    "MiniDV",
    "MiniDVD",
    "MiniDVD-Audio",
    "MiniDVD-Video",
    "MiniDisc",
    "Minidisc",
    "Minimax CD",
    "Minimax DV",
    "Minimax DVD",
    "Minimax DVD-Audio",
    "Minimax DVD-Video",
    "Mixed Mode CD",
    "NT Cassette",
    "Other",
    "Path\xe9 Disc",
    "Path\xe9 disc",
    "Phonograph record",
    "Piano Roll",
    "PlayTape",
    "Playbutton",
    "Pocket Rocker",
    "RCA Tape Cartridge",
    "ROM cartridge",
    "Reel-To-Reel",
    "Reel-to-reel",
    "Revere Magnetic Stereo Tape Ca",
    "SACD",
    "SACD (2 channels)",
    "SACD (multichannel)",
    "SD Card",
    "SHM-CD",
    "SHM-SACD",
    "SHM-SACD (2 channels)",
    "SHM-SACD (multichannel)",
    "SVCD",
    "Sabamobil",
    "SelectaVision",
    "Shellac",
    "Sopic",
    "Super Beta",
    "Super VHS",
    "TeD",
    "Tefifon",
    "U-matic",
    "UMD",
    "USB Flash Drive",
    "Ultra HD Blu-ray",
    "Unknown format",
    "VCD",
    "VHD",
    "VHS",
    "Video 2000",
    "Video8",
    "Vinyl",
    "VinylDisc",
    "VinylDisc (CD side)",
    "VinylDisc (DVD side)",
    "VinylDisc (Vinyl side)",
    "Wax Cylinder",
    "Wire Recording",
    "Zip Disk",
    "microSD",
    "slotMusic"
];


/**
 * Release Type taxonomy — combined from MusicBrainz primary/secondary types + Discogs descriptions.
 * Maps to the "format" field in the OpenSearch ParentRelease schema.
 *
 * To regenerate: node admin_portal/src/data/generate-release-taxonomies.js
 */ /** All valid release type values, sorted alphabetically. */ const $491894d32f9e82de$export$8993785e14ab2dfb = [
    "Advance",
    "Album",
    "Audio drama",
    "Audiobook",
    "Bioplastic",
    "Broadcast",
    "Card Backed",
    "Club Edition",
    "Compilation",
    "DJ-mix",
    "Deluxe Edition",
    "Demo",
    "EP",
    "Enhanced",
    "Etched",
    "Field recording",
    "Interview",
    "Jukebox",
    "Limited Edition",
    "Live",
    "Maxi-Single",
    "Mini-Album",
    "Mispress",
    "Misprint",
    "Mixed",
    "Mixtape",
    "Mixtape/Street",
    "Numbered",
    "Other",
    "Partially Mixed",
    "Partially Unofficial",
    "Picture Disc",
    "Promo",
    "Record Store Day",
    "Reissue",
    "Remastered",
    "Remix",
    "Repress",
    "Sampler",
    "Single",
    "Soundtrack",
    "Special Cut",
    "Special Edition",
    "Spokenword",
    "Styrene",
    "Test Pressing",
    "Transcription",
    "Unofficial Release",
    "White Label"
];



// Register all Community features
(0, $437b23f6a393c3bf$export$dc053975cc7f6c11).registerModules([
    (0, $437b23f6a393c3bf$export$526323caf9d1af13)
]);
/** Bulk edit (one plan applied across many recordings) was hidden while it had
 *  no backend behind it. It now posts to the bulk-edit endpoint, so the entry
 *  point is back. Kept as a flag so it can be pulled again without unpicking the
 *  mode itself. */ const $ee5d817149f79816$var$BULK_EDIT_ENABLED = true;
// to use myTheme in an application, pass it to the theme grid option
const $ee5d817149f79816$var$myTheme = (0, $437b23f6a393c3bf$export$495b90cf446940a1).withParams({
    backgroundColor: "#151719",
    browserColorScheme: "dark",
    chromeBackgroundColor: "#151719",
    foregroundColor: "#FFFFFF",
    headerFontSize: 14,
    headerFontWeight: "bold",
    headerRowBorder: false,
    wrapperBorder: false
});
// Map ag-grid column IDs to API sort fields
const $ee5d817149f79816$var$GRID_SORT_TO_API_FIELD = {
    artist: "parentRecording.bandArtistName.raw",
    title: "parentRecording.recordingTitle.raw",
    release: "earliestParentRelease.releaseTitle.raw",
    year: "earliestParentRelease.dateReleased",
    format: "earliestParentRelease.format",
    type: "earliestParentRelease.mediaType",
    stageName: "persona.stageName",
    // `live` is now the free-text descriptor string, sorted alphanumerically
    // (was the boolean `parentRecording.isLive`).
    live: "parentRecording.live",
    contributions: "westburyContributions.contribution",
    isrcs: "parentRecording.isrcs",
    duration: "parentRecording.duration",
    featured: "performance.featuredStatus",
    collaborators: "parentRecording.bandArtistName.raw",
    version: "parentRecording.recordingVersion",
    label: "earliestParentRelease.releaseLabels",
    catNumbers: "earliestParentRelease.catNumbers",
    yearRecorded: "parentRecording.yearRecorded"
};
// Map ag-grid column IDs to API filter field names.
//
// `location` (countryOfRecording) and `pNames` are deliberately absent. The
// parent-recordings index is `"dynamic": "false"` and neither field appears in
// its mapping (westbury-functions-mono/opensearch/opensearch/index_definitions.py),
// so both ride in `_source` — which is why they read fine — but are not
// indexed. A filter on either would return zero rows *without erroring*, so
// their columns declare `sortable: false` and no `filter` rather than offering
// an affordance that silently finds nothing. Making them sortable/filterable
// means a mapping change plus a reindex, not an entry in this map.
const $ee5d817149f79816$var$GRID_COL_TO_API_FILTER_FIELD = {
    artist: "parentRecording.bandArtistName.raw",
    version: "parentRecording.recordingVersion",
    contributions: "westburyContributions.contribution",
    release: "earliestParentRelease.releaseTitle.raw",
    year: "earliestParentRelease.dateReleased",
    live: "parentRecording.live",
    title: "parentRecording.recordingTitle.raw",
    isrcs: "parentRecording.isrcs",
    stageName: "persona.stageName",
    type: "earliestParentRelease.mediaType",
    format: "earliestParentRelease.format",
    catNumbers: "earliestParentRelease.catNumbers",
    label: "earliestParentRelease.releaseLabels",
    featured: "performance.featuredStatus",
    yearRecorded: "parentRecording.yearRecorded"
};
// Default sort order: Format, Year of Release, Live, Release, Version, Recording Title, Artist
const $ee5d817149f79816$var$DEFAULT_SORT_MODEL = [
    // { colId: 'format', sort: 'asc' },
    {
        colId: "year",
        sort: "asc"
    },
    {
        colId: "live",
        sort: "asc"
    },
    {
        colId: "release",
        sort: "asc"
    },
    {
        colId: "version",
        sort: "asc"
    },
    {
        colId: "title",
        sort: "asc"
    },
    {
        colId: "artist",
        sort: "asc"
    }
];
// --- Mass-edit cell rendering (PROTOTYPE) ---------------------------------
// A pulsating purple dot in the top-right corner marks a cell with a pending
// mass edit (mirrors the recording edit form's "unsaved change" indicator).
const $ee5d817149f79816$var$MASS_DOT_CLASS = "tw-absolute tw-top-1 tw-right-1 tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-surfacePurple tw-border tw-border-gray-900 tw-animate-pulse-slow tw-z-10 tw-pointer-events-none";
/** Edit affordance shown on cell hover — hidden by default, revealed via the
 *  parent's `tw-group` hover. Clicking it starts editing (inline input or a
 *  quick-edit modal) without triggering the cell's other click behaviour.
 *
 *  A locked field still shows the pencil so the affordance doesn't silently
 *  disappear, but greyed out and non-interactive. The `title` and the
 *  not-allowed cursor sit on the wrapper because a `disabled` button receives
 *  no mouse events, so neither would ever show on the button itself. */ const $ee5d817149f79816$var$MassEditPencil = ({ onEdit: onEdit, disabled: disabled = false, disabledReason: disabledReason })=>disabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        title: disabledReason,
        className: "tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-flex-shrink-0 tw-ml-1 tw-inline-flex tw-cursor-not-allowed",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            "aria-label": "Edit (locked)",
            "aria-disabled": "true",
            role: "button",
            className: "tw-p-1 tw-rounded tw-text-textSeal tw-opacity-50 tw-pointer-events-none",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                className: "tw-w-3.5 tw-h-3.5"
            })
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        "aria-label": "Edit",
        title: "Edit",
        className: "tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-flex-shrink-0 tw-ml-1 tw-p-1 tw-rounded hover:tw-bg-gray-700 tw-text-textDove hover:tw-text-white",
        onClick: (e)=>{
            e.stopPropagation();
            onEdit();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
            className: "tw-w-3.5 tw-h-3.5"
        })
    });
/** Read-only cell content with a pending-change dot (used for cells that can't
 *  be edited, e.g. an empty Version or a write-once Duration already set). */ const $ee5d817149f79816$var$MassCellShell = ({ changed: changed, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-relative tw-flex tw-items-center tw-w-full tw-h-full",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "tw-truncate",
                children: children
            }),
            changed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "aria-hidden": true,
                title: "Pending change",
                className: $ee5d817149f79816$var$MASS_DOT_CLASS
            })
        ]
    });
/** Wrapper for a complex field (Artist, Version, Contributions, Live, ISRCs).
 *  The edit pencil appears on hover and opens the quick-edit modal; the rest of
 *  the cell keeps its normal click behaviour (e.g. copy). */ const $ee5d817149f79816$var$MassComplexCellShell = ({ changed: changed, onOpen: onOpen, disabled: disabled = false, disabledReason: disabledReason, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-relative tw-flex tw-items-center tw-w-full tw-h-full tw-group",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-items-center tw-gap-2 tw-min-w-0 tw-flex-1",
                children: children
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee5d817149f79816$var$MassEditPencil, {
                onEdit: onOpen,
                disabled: disabled,
                disabledReason: disabledReason
            }),
            changed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "aria-hidden": true,
                title: "Pending change",
                className: $ee5d817149f79816$var$MASS_DOT_CLASS
            })
        ]
    });
/** Render the display content of a complex mass-edit cell — the pending value
 *  if one exists, otherwise the recording's current value. */ function $ee5d817149f79816$var$renderMassComplexContent(field, row, pending) {
    switch(field){
        case "live":
            {
                // Matches the read-only Live column: the free-text descriptor itself
                // (e.g. "Live in London, 1989"), or '-' when the recording isn't live.
                const descriptor = pending !== undefined ? pending.trim() : row.live ?? "";
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-truncate",
                    children: descriptor || "-"
                });
            }
        case "version":
            {
                const versions = pending !== undefined ? pending : row.versionsArray ?? [];
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-truncate",
                    children: versions.join(", ") || "-"
                });
            }
        case "isrcs":
            {
                const isrcs = pending !== undefined ? pending : row.isrcsArray ?? [];
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-truncate",
                    children: isrcs.join(", ") || "-"
                });
            }
        case "contributions":
            {
                const contributions = pending !== undefined ? pending : row.contributions ?? [];
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-gap-2 tw-overflow-hidden",
                    children: contributions.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca4bfbde716b69b9$export$733e49a0308b4cd), {
                            contribution: c
                        }, c.contribution))
                });
            }
        case "artist":
            {
                // Demoted artists are tombstones carried for the save layer — the cell,
                // like the editor, only lists featured / other-featured artists.
                const names = pending !== undefined ? pending.filter((a)=>!a.demoted).map((a)=>a.name).join(", ") : row.artist ?? "";
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-truncate",
                    children: names || "-"
                });
            }
        default:
            return null;
    }
}
// Map DetailGrid field names to main grid column IDs
const $ee5d817149f79816$var$DETAIL_FIELD_TO_MAIN_COL_ID = {
    collaborators: "artist",
    format: "format",
    type: "type",
    stageName: "stageName"
};
// Combined Column Visibility Dropdown Component
const $ee5d817149f79816$var$CombinedColumnVisibilityDropdown = ({ gridApi: gridApi, columnDefs: columnDefs, detailColumnDefs: detailColumnDefs, onDetailColumnVisibilityChange: onDetailColumnVisibilityChange, detailVisibleColumns: detailVisibleColumns })=>{
    const [visibleColumns, setVisibleColumns] = (0, $acw62.useState)(()=>{
        // Initialize with all non-hidden columns
        const visible = new Set();
        columnDefs.forEach((col)=>{
            if (col.colId && !col.hide) visible.add(col.colId);
        });
        return visible;
    });
    // Update visible columns when columnDefs change
    (0, $acw62.useEffect)(()=>{
        if (!gridApi) return;
        const columnState = gridApi.getColumnState();
        const newVisible = new Set();
        columnState.forEach((col)=>{
            if (col.colId && !col.hide) newVisible.add(col.colId);
        });
        setVisibleColumns(newVisible);
    }, [
        gridApi,
        columnDefs
    ]);
    const toggleMainColumnVisibility = (colId)=>{
        if (!gridApi || !colId) return;
        const isVisible = visibleColumns.has(colId);
        const newVisible = new Set(visibleColumns);
        if (isVisible) newVisible.delete(colId);
        else newVisible.add(colId);
        setVisibleColumns(newVisible);
        gridApi.setColumnsVisible([
            colId
        ], !isVisible);
    };
    const toggleDetailColumnVisibility = (field)=>{
        const isVisible = detailVisibleColumns.has(field);
        onDetailColumnVisibilityChange(field, !isVisible);
    };
    // Filter out expand column and get displayable columns
    const displayableMainColumns = columnDefs.filter((col)=>col.colId && col.colId !== "expand");
    const displayableDetailColumns = detailColumnDefs.filter((col)=>col.field);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f48ae8c4ad4b8a8$export$2e2bcd8739ae039), {
        trigger: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            variant: "secondary",
            label: "Show/Hide Data"
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-min-w-[200px] tw-max-h-[500px] tw-overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-px-2 tw-py-2 tw-text-xs tw-font-semibold tw-text-neutral-400 tw-uppercase tw-tracking-wide",
                    children: "Top-Level"
                }),
                displayableMainColumns.map((col)=>{
                    const colId = col.colId;
                    const isVisible = visibleColumns.has(colId);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "button",
                        tabIndex: 0,
                        className: "tw-px-2 tw-py-2 tw-cursor-pointer hover:tw-bg-neutral-800 tw-flex tw-items-center tw-gap-2",
                        onClick: ()=>toggleMainColumnVisibility(colId),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                toggleMainColumnVisibility(colId);
                            }
                        },
                        children: [
                            isVisible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                className: "tw-w-4 tw-h-4 tw-text-white"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                className: "tw-w-4 tw-h-4 tw-text-neutral-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: isVisible ? "tw-text-white" : "tw-text-neutral-500",
                                children: col.headerName || colId
                            })
                        ]
                    }, `main-${colId}`);
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-px-2 tw-py-1 tw-border-t tw-border-neutral-700 tw-my-1"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-px-2 tw-py-2 tw-text-xs tw-font-semibold tw-text-neutral-400 tw-uppercase tw-tracking-wide",
                    children: "Sub-Level"
                }),
                displayableDetailColumns.map((col)=>{
                    const field = col.field;
                    const isVisible = detailVisibleColumns.has(field);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "button",
                        tabIndex: 0,
                        className: "tw-px-2 tw-py-2 tw-cursor-pointer hover:tw-bg-neutral-800 tw-flex tw-items-center tw-gap-2",
                        onClick: ()=>toggleDetailColumnVisibility(field),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                toggleDetailColumnVisibility(field);
                            }
                        },
                        children: [
                            isVisible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                className: "tw-w-4 tw-h-4 tw-text-white"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                className: "tw-w-4 tw-h-4 tw-text-neutral-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: isVisible ? "tw-text-white" : "tw-text-neutral-500",
                                children: col.headerName || field
                            })
                        ]
                    }, `detail-${field}`);
                })
            ]
        })
    });
};
// Detail grid component
const $ee5d817149f79816$var$DetailGrid = ({ row: row, onSortChange: onSortChange, rowId: rowId, onGridReady: onGridReady, visibleColumns: visibleColumns, onCellClickedForCopy: onCellClickedForCopy })=>{
    const detailGridApiRef = (0, $acw62.useRef)(null);
    const detailColumnDefs = (0, $acw62.useMemo)(()=>[
            {
                headerName: "Artist",
                hide: true,
                field: "artist",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Recording Title",
                hide: true,
                field: "title",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Version",
                hide: true,
                field: "version",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Contributions",
                hide: true,
                field: "contributions",
                minWidth: 150,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                cellRenderer: (params)=>{
                    if (!params.data) return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-gap-2",
                        children: params.data.contributions.map((contribution)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca4bfbde716b69b9$export$733e49a0308b4cd), {
                                contribution: contribution
                            }, contribution.contribution))
                    });
                }
            },
            {
                headerName: "ISRCs",
                hide: true,
                field: "isrcs",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Release",
                hide: true,
                field: "release",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Year",
                hide: true,
                field: "year",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Duration",
                hide: true,
                field: "duration",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Live",
                hide: true,
                field: "isLive",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Collaborators",
                field: "collaborators",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Label",
                field: "label",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Catalogue Number",
                field: "catNumbers",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Format",
                field: "format",
                minWidth: 100,
                sortable: true,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Type",
                field: "type",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Stage Name",
                field: "stageName",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Featured",
                field: "isFeatured",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                cellRenderer: (params)=>{
                    if (!params.data) return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi wi-xs", {
                                "wi-check": params.data.isFeatured,
                                "wi-close": !params.data.isFeatured
                            })
                        })
                    });
                }
            }
        ], []);
    const detailRowData = (0, $acw62.useMemo)(()=>[
            {
                artist: row.artist || "\u2014",
                title: row.title || "\u2014",
                version: row.version || "\u2014",
                contributions: row.contributions || "\u2014",
                isrcs: row.isrcs || "\u2014",
                release: row.release || "\u2014",
                year: row.year || "\u2014",
                duration: row.duration || "\u2014",
                type: row.mediaType || "\u2014",
                stageName: row.stageName || "\u2014",
                isLive: row.isLive || false,
                isFeatured: row.isFeatured || false,
                collaborators: row.collaborators || "\u2014",
                label: row.label || "\u2014",
                catNumbers: row.catNumbers || "\u2014",
                format: row.format || "\u2014"
            }
        ], [
        row
    ]);
    const detailDefaultColDef = (0, $acw62.useMemo)(()=>({
            sortable: true,
            resizable: true,
            suppressMenu: true,
            suppressMovable: false,
            sortingOrder: [
                "asc",
                "desc",
                null
            ]
        }), []);
    const handleDetailSortChanged = (0, $acw62.useCallback)((event)=>{
        if (!event.api || !onSortChange) return;
        const sortedColumns = event.api.getColumnState().filter((col)=>col.sort && col.sortIndex !== null && col.sortIndex !== undefined).sort((a, b)=>(a.sortIndex ?? 0) - (b.sortIndex ?? 0));
        // Get the primary sorted column (first one)
        const primaryColumn = sortedColumns[0];
        if (primaryColumn && primaryColumn.colId) {
            const mainColId = $ee5d817149f79816$var$DETAIL_FIELD_TO_MAIN_COL_ID[primaryColumn.colId];
            if (mainColId && primaryColumn.sort) // Trigger sort in main grid
            onSortChange(mainColId, primaryColumn.sort);
        } else sortedColumns.length;
    }, [
        onSortChange
    ]);
    const handleDetailGridReady = (0, $acw62.useCallback)((params)=>{
        detailGridApiRef.current = params.api;
        if (onGridReady) onGridReady(rowId, params.api);
        // Apply initial column visibility
        detailColumnDefs.forEach((colDef)=>{
            if (colDef.field) {
                const shouldBeVisible = visibleColumns.has(colDef.field);
                params.api.setColumnsVisible([
                    colDef.field
                ], shouldBeVisible);
            }
        });
    }, [
        onGridReady,
        rowId,
        detailColumnDefs,
        visibleColumns
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "detail-grid-wrapper tw-w-full tw-h-full tw-rounded-b tw-p-3",
        style: {
            width: "100%",
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                height: "60px",
                width: "100%",
                overflow: "hidden"
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e439ae7301dd858$export$4074462c5969a5d8), {
                rowData: detailRowData,
                columnDefs: detailColumnDefs,
                defaultColDef: detailDefaultColDef,
                headerHeight: 30,
                rowHeight: 30,
                domLayout: "normal",
                suppressHorizontalScroll: false,
                onSortChanged: handleDetailSortChanged,
                onGridReady: handleDetailGridReady,
                onCellClicked: (event)=>{
                    if (event.rowIndex != null && onCellClickedForCopy) onCellClickedForCopy(event.api, event.rowIndex, event.column.getColId());
                },
                alwaysMultiSort: false,
                suppressRowHoverHighlight: true
            })
        })
    });
};
function $ee5d817149f79816$var$MasterDiscography() {
    const { userId: userId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [clientPersonalInfo, setClientPersonalInfo] = (0, $acw62.useState)();
    const [isPendingExportGeneration, setIsPendingExportGeneration] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [loadingError, setLoadingError] = (0, $acw62.useState)(false);
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [images, setImages] = (0, $acw62.useState)({});
    const [confidenceStats, setConfidenceStats] = (0, $acw62.useState)(null);
    const [selectedConfidenceCategory, setSelectedConfidenceCategory] = (0, $acw62.useState)(null);
    const [availableFilters, setAvailableFilters] = (0, $acw62.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = (0, $acw62.useState)("");
    const [page, setPage] = (0, $acw62.useState)(1);
    const [rowsPerPage, setRowsPerPage] = (0, $acw62.useState)(50);
    const [recordingsCount, setRecordingsCount] = (0, $acw62.useState)(0);
    const [isOpenExportConfirmationModal, setIsOpenExportConfirmationModal] = (0, $acw62.useState)(false);
    const [showEditModal, setShowEditModal] = (0, $acw62.useState)(false);
    const [showEditPanel, setShowEditPanel] = (0, $acw62.useState)(false);
    const [selectedRowForModal, setSelectedRowForModal] = (0, $acw62.useState)(null);
    // Row the user wants to switch to while the currently-open recording has
    // unsaved changes — pending a discard/continue confirmation.
    const [pendingSwitchRow, setPendingSwitchRow] = (0, $acw62.useState)(null);
    const mainContentColumnRef = (0, $acw62.useRef)(null);
    const editFormRef = (0, $acw62.useRef)(null);
    // Mirror of the currently-open row id so handleOpenEditModal can detect a
    // switch without taking selectedRowForModal as a useCallback dependency
    // (which would rebuild the grid column defs on every selection change).
    const selectedRowIdRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        selectedRowIdRef.current = selectedRowForModal?.id ?? null;
    }, [
        selectedRowForModal
    ]);
    const [panelBounds, setPanelBounds] = (0, $acw62.useState)(null);
    const sortFieldsRef = (0, $acw62.useRef)([]);
    const [sortFields, setSortFields] = (0, $acw62.useState)(()=>{
        // Build default sortFields from DEFAULT_SORT_MODEL
        const defaultSortFields = $ee5d817149f79816$var$DEFAULT_SORT_MODEL.map((item)=>{
            const apiField = $ee5d817149f79816$var$GRID_SORT_TO_API_FIELD[item.colId];
            if (apiField && item.sort) return {
                field: apiField,
                order: item.sort === "desc" ? "desc" : "asc"
            };
            return null;
        }).filter((item)=>item !== null);
        sortFieldsRef.current = defaultSortFields;
        return defaultSortFields;
    });
    const [fieldFilters, setFieldFilters] = (0, $acw62.useState)([]);
    const [expandedRowIds, setExpandedRowIds] = (0, $acw62.useState)(()=>new Set());
    const gridApiRef = (0, $acw62.useRef)(null);
    // --- Bulk / mass editing (PROTOTYPE) -------------------------------------
    // Toggles the whole table into bulk-edit mode: filtering & pagination are
    // disabled, all rows load on a single page, the Actions column is swapped
    // for a selection checkbox column, and the toolbar shows bulk actions only.
    const [bulkEditMode, setBulkEditMode] = (0, $acw62.useState)(false);
    const [selectedRowIds, setSelectedRowIds] = (0, $acw62.useState)(()=>new Set());
    const [showBulkEditModal, setShowBulkEditModal] = (0, $acw62.useState)(false);
    // Client aliases (personas) for the contribution editor in the bulk modal.
    const [bulkClientAliases, setBulkClientAliases] = (0, $acw62.useState)([]);
    // Remember the page size used before entering bulk mode so we can restore it
    // on exit (bulk mode forces a single page containing every record).
    const preBulkRowsPerPageRef = (0, $acw62.useRef)(rowsPerPage);
    // Mirror selection + rows into refs so cell/header renderers can read the
    // latest value without rebuilding columnDefs on every change.
    const selectedRowIdsRef = (0, $acw62.useRef)(selectedRowIds);
    const prevSelectedRowIdsRef = (0, $acw62.useRef)(selectedRowIds);
    (0, $acw62.useEffect)(()=>{
        const prev = prevSelectedRowIdsRef.current;
        const curr = selectedRowIds;
        selectedRowIdsRef.current = curr;
        prevSelectedRowIdsRef.current = curr;
        const api = gridApiRef.current;
        if (!api) return;
        // Redraw the rows whose selection state flipped so both the checkbox cell
        // and the row-level "selected" background (getRowStyle) are re-applied —
        // refreshCells alone doesn't re-run getRowStyle.
        const changedIds = new Set();
        prev.forEach((id)=>{
            if (!curr.has(id)) changedIds.add(id);
        });
        curr.forEach((id)=>{
            if (!prev.has(id)) changedIds.add(id);
        });
        const changedNodes = Array.from(changedIds).map((id)=>api.getRowNode(id)).filter((node)=>node != null);
        if (changedNodes.length > 0) api.redrawRows({
            rowNodes: changedNodes
        });
        // Keep the select-all header checkbox in sync.
        api.refreshHeader();
    }, [
        selectedRowIds
    ]);
    const rowsRef = (0, $acw62.useRef)(rows);
    (0, $acw62.useEffect)(()=>{
        rowsRef.current = rows;
    }, [
        rows
    ]);
    // --- Mass editing (PROTOTYPE) --------------------------------------------
    // Recording-level cells are edited individually — inline for simple fields
    // (title, duration) and via reused modals for complex ones (artist, version,
    // contributions, live, isrcs). The edit affordance is revealed on cell hover;
    // there is no top-level toggle. The moment the first cell is edited the table
    // "enters" mass-edit mode (mass edit mode is derived from having any pending
    // edit) which locks the toolbar to Save/Cancel and freezes the current page.
    // Mass edit always works with the current page only — we never fetch all.
    const [massEdits, setMassEdits] = (0, $acw62.useState)({});
    const massEditsRef = (0, $acw62.useRef)(massEdits);
    // Which complex field/recording is currently open in a quick-edit modal.
    const [massFieldTarget, setMassFieldTarget] = (0, $acw62.useState)(null);
    // Which single-value field (Title/Duration) is open in its own modal editor.
    // Both are modal-only rather than inline: their rules need more room than a
    // grid cell can give.
    const [massTextTarget, setMassTextTarget] = (0, $acw62.useState)(null);
    const [showMassSummary, setShowMassSummary] = (0, $acw62.useState)(false);
    // ISRCs reassigned onto a recording during this mass edit, keyed by the
    // recording gaining them. Carried into the `add isrcs` edit as `dup_isrcs`
    // so the backend detaches each ISRC from its source recording.
    const [massIsrcReassignments, setMassIsrcReassignments] = (0, $acw62.useState)({});
    // In-flight state + outcome of the batch apply, surfaced by the summary modal.
    const [massSaving, setMassSaving] = (0, $acw62.useState)(false);
    const [massApplyResult, setMassApplyResult] = (0, $acw62.useState)(null);
    // Keep the ref in sync and re-render the visible cells (so the purple
    // "pending change" dot appears/disappears) whenever pending edits change.
    (0, $acw62.useEffect)(()=>{
        massEditsRef.current = massEdits;
        gridApiRef.current?.refreshCells({
            force: true
        });
    }, [
        massEdits
    ]);
    // Total number of pending field changes across all recordings.
    const massEditFieldCount = (0, $acw62.useMemo)(()=>Object.values(massEdits).reduce((sum, rowEdits)=>sum + Object.keys(rowEdits).length, 0), [
        massEdits
    ]);
    // Mass-edit mode is derived: the table is "in" mass edit as soon as there is
    // at least one pending edit, and reverts to normal browsing when the user
    // saves or cancels (which clears the pending edits).
    const massEditMode = massEditFieldCount > 0;
    // Record (or clear, when reverted to the original) a pending edit for one
    // field of one recording. `changed` decides whether it's stored or dropped.
    const setMassCellEdit = (0, $acw62.useCallback)((rowId, field, value, changed)=>{
        setMassEdits((prev)=>{
            const rowEdits = {
                ...prev[rowId] ?? {}
            };
            if (changed) rowEdits[field] = value;
            else delete rowEdits[field];
            const next = {
                ...prev
            };
            if (Object.keys(rowEdits).length > 0) next[rowId] = rowEdits;
            else delete next[rowId];
            massEditsRef.current = next;
            return next;
        });
    }, []);
    const openMassFieldModal = (0, $acw62.useCallback)((rowId, field)=>{
        setMassFieldTarget({
            rowId: rowId,
            field: field
        });
    }, []);
    // Save the value returned by a complex-field quick-edit modal, storing it as
    // a pending edit only when it actually differs from the recording's current
    // value.
    const handleMassFieldSave = (0, $acw62.useCallback)((row, field, value)=>{
        let original;
        switch(field){
            case "live":
                original = typeof row.live === "string" ? row.live.trim() : "";
                break;
            case "version":
                original = row.versionsArray ?? [];
                break;
            case "isrcs":
                original = row.isrcsArray ?? [];
                break;
            case "contributions":
                original = (row.contributions ?? []).map((c)=>({
                        contribution: c.contribution,
                        confidenceCategory: c.confidenceCategory ?? "1",
                        confidencePattern: c.confidencePattern ?? ""
                    }));
                break;
            case "artist":
                original = (row.mainArtistsRaw ?? []).map((item)=>typeof item === "string" ? item : item.stageName);
                break;
            default:
                original = undefined;
        }
        const changed = field === "artist" ? // list, so a name-only comparison would treat the demotion as a
        // no-op and silently drop it.
        JSON.stringify(value.map((a)=>[
                a.name,
                !!a.demoted
            ])) !== JSON.stringify(original.map((n)=>[
                n,
                false
            ])) : JSON.stringify(value) !== JSON.stringify(original);
        setMassCellEdit(row.id, field, value, changed);
        setMassFieldTarget(null);
    }, [
        setMassCellEdit
    ]);
    // When an ISRC is reassigned to the recording being edited we do two things:
    // remember the source recordings so the `add isrcs` edit can carry
    // `dup_isrcs` when the mass edit is applied, and optimistically strip the
    // ISRC from those source rows — but only the ones currently loaded on the
    // page, so the user sees the ISRC move rather than appear twice.
    const handleReassignIsrcs = (0, $acw62.useCallback)((targetRowId, reassignments)=>{
        setMassIsrcReassignments((prev)=>({
                ...prev,
                [targetRowId]: {
                    ...prev[targetRowId] ?? {},
                    ...Object.fromEntries(Object.entries(reassignments).map(([isrc, matches])=>[
                            isrc,
                            matches.map((m)=>({
                                    recordingId: m.recordingId,
                                    documentId: m.documentId
                                }))
                        ]))
                }
            }));
        Object.entries(reassignments).forEach(([isrc, matches])=>{
            matches.forEach(({ recordingId: srcId })=>{
                const srcRow = rowsRef.current.find((r)=>r.id === srcId);
                if (!srcRow) return; // source recording isn't on the current page
                const currentList = massEditsRef.current[srcId]?.isrcs ?? srcRow.isrcsArray ?? [];
                const nextList = currentList.filter((x)=>x.toLowerCase() !== isrc.toLowerCase());
                if (nextList.length === currentList.length) return; // not present
                const original = srcRow.isrcsArray ?? [];
                const changed = JSON.stringify(nextList) !== JSON.stringify(original);
                setMassCellEdit(srcId, "isrcs", nextList, changed);
            });
        });
    }, [
        setMassCellEdit
    ]);
    // Discard a single pending edit (used by the review summary's "Remove").
    const removeMassCellEdit = (0, $acw62.useCallback)((rowId, field)=>{
        setMassEdits((prev)=>{
            if (!prev[rowId] || prev[rowId][field] === undefined) return prev;
            const rowEdits = {
                ...prev[rowId]
            };
            delete rowEdits[field];
            const next = {
                ...prev
            };
            if (Object.keys(rowEdits).length > 0) next[rowId] = rowEdits;
            else delete next[rowId];
            massEditsRef.current = next;
            return next;
        });
    }, []);
    // Persist a Title/Duration edit, dropping it if it reverts to the
    // recording's original value.
    const handleMassTextSave = (0, $acw62.useCallback)((row, field, value)=>{
        const nv = value.trim();
        if (field === "title") setMassCellEdit(row.id, "title", nv, nv !== row.title);
        else setMassCellEdit(row.id, "duration", nv, nv !== (row.duration ?? ""));
    }, [
        setMassCellEdit
    ]);
    // Route the summary's "Edit" to the right editor: complex fields reuse the
    // grid's quick-edit modal; Title/Duration use their own.
    const handleSummaryEditChange = (0, $acw62.useCallback)((rowId, field)=>{
        if (field === "title" || field === "duration") setMassTextTarget({
            rowId: rowId,
            field: field
        });
        else setMassFieldTarget({
            rowId: rowId,
            field: field
        });
    }, []);
    // -------------------------------------------------------------------------
    const prevDebouncedSearchTermRef = (0, $acw62.useRef)("");
    const isInitialMountRef = (0, $acw62.useRef)(true);
    const isApplyingInitialSortRef = (0, $acw62.useRef)(false);
    // Transient "copied to clipboard" popup state.
    const [copyFeedback, setCopyFeedback] = (0, $acw62.useState)(null);
    const copyFeedbackTimeoutRef = (0, $acw62.useRef)(null);
    // The last cell the user clicked in either the main grid or an expanded
    // detail grid. Used to resolve the copy target (with its owning grid api).
    const copySourceRef = (0, $acw62.useRef)(null);
    // Serialize arrays for stable dependency comparison
    const sortFieldsKey = (0, $acw62.useMemo)(()=>JSON.stringify(sortFields), [
        sortFields
    ]);
    const fieldFiltersKey = (0, $acw62.useMemo)(()=>JSON.stringify(fieldFilters), [
        fieldFilters
    ]);
    // Track detail grid APIs for column visibility control
    const detailGridApiRefs = (0, $acw62.useRef)(new Map());
    // Measure main content column so the side panel height matches the table area
    (0, $acw62.useEffect)(()=>{
        if (!showEditPanel || !selectedRowForModal || !mainContentColumnRef.current) {
            setPanelBounds(null);
            return;
        }
        const el = mainContentColumnRef.current;
        const updateBounds = ()=>{
            const rect = el.getBoundingClientRect();
            setPanelBounds({
                top: rect.top,
                height: rect.height
            });
        };
        updateBounds();
        const ro = new ResizeObserver(updateBounds);
        ro.observe(el);
        return ()=>ro.disconnect();
    }, [
        showEditPanel,
        selectedRowForModal
    ]);
    // Detail grid column visibility state - initialized from detailColumnDefs
    const detailColumnDefsForVisibility = (0, $acw62.useMemo)(()=>[
            {
                headerName: "Artist",
                hide: true,
                field: "artist"
            },
            {
                headerName: "Recording Title",
                hide: true,
                field: "title"
            },
            {
                headerName: "Version",
                hide: true,
                field: "version"
            },
            {
                headerName: "Contributions",
                hide: true,
                field: "contributions"
            },
            {
                headerName: "ISRCs",
                hide: true,
                field: "isrcs"
            },
            {
                headerName: "Release",
                hide: true,
                field: "release"
            },
            {
                headerName: "Year",
                hide: true,
                field: "year"
            },
            {
                headerName: "Duration",
                hide: true,
                field: "duration"
            },
            {
                headerName: "Type",
                hide: true,
                colId: "type"
            },
            {
                headerName: "Stage Name",
                hide: true,
                field: "stageName"
            },
            {
                headerName: "Live",
                hide: true,
                field: "isLive"
            },
            {
                headerName: "Featured",
                field: "isFeatured"
            },
            {
                headerName: "Collaborators",
                field: "collaborators"
            },
            {
                headerName: "Label",
                field: "label"
            },
            {
                headerName: "Catalogue Number",
                field: "catNumbers"
            },
            {
                headerName: "Format",
                field: "format"
            },
            {
                headerName: "Type",
                field: "type"
            }
        ], []);
    const [detailVisibleColumns, setDetailVisibleColumns] = (0, $acw62.useState)(()=>{
        const visible = new Set();
        // Initialize with all non-hidden detail columns
        detailColumnDefsForVisibility.forEach((col)=>{
            if (col.field && !col.hide) visible.add(col.field);
        });
        return visible;
    });
    const initialColumnState = (0, $acw62.useMemo)(()=>$ee5d817149f79816$var$DEFAULT_SORT_MODEL.filter((item)=>Boolean(item.colId && item.sort)).map((item, index)=>({
                colId: item.colId,
                sort: item.sort,
                sortIndex: index
            })), []);
    const defaultSortStateByColId = (0, $acw62.useMemo)(()=>new Map(initialColumnState.filter((col)=>col.sort !== null && col.sortIndex !== null && col.sort !== undefined && col.sortIndex !== undefined).map(({ colId: colId, sort: sort, sortIndex: sortIndex })=>[
                colId,
                {
                    sort: sort,
                    sortIndex: sortIndex
                }
            ])), [
        initialColumnState
    ]);
    const skipToLastPage = ()=>{
        const totalPages = Math.ceil(recordingsCount / rowsPerPage);
        if (totalPages > 0) setPage(totalPages);
    };
    const handleSortChanged = (0, $acw62.useCallback)((event)=>{
        if (!event.api) return;
        // Ignore sort changes during initial sort application
        if (isApplyingInitialSortRef.current) return;
        // Get the current sort state from the grid
        const sortedColumns = event.api.getColumnState().filter((col)=>col.sort && col.sortIndex !== null && col.sortIndex !== undefined).sort((a, b)=>(a.sortIndex ?? 0) - (b.sortIndex ?? 0));
        // Build sortFields array from sorted columns
        const newSortFields = sortedColumns.map((col)=>{
            if (!col.colId) return null;
            const apiField = $ee5d817149f79816$var$GRID_SORT_TO_API_FIELD[col.colId];
            if (!apiField || !col.sort) return null;
            return {
                field: apiField,
                order: col.sort === "desc" ? "desc" : "asc"
            };
        }).filter((item)=>item !== null);
        // Compare sort fields (order matters for multi-sort)
        const sortChanged = JSON.stringify(sortFieldsRef.current) !== JSON.stringify(newSortFields);
        // Only update if sort actually changed
        if (!sortChanged) return;
        // Update sortFields with new sort (can be empty array if user removed all sorts)
        sortFieldsRef.current = newSortFields;
        setSortFields(newSortFields);
        setPage(1);
    }, []);
    const handleFilterChanged = (0, $acw62.useCallback)((event)=>{
        if (!event.api) return;
        const filterModel = event.api.getFilterModel();
        const newFieldFilters = [];
        // Convert AG Grid filter model to API fieldFilters format
        // Note: filterModel only contains active filters, so if a filter is cleared, it won't be in the model
        Object.keys(filterModel).forEach((colId)=>{
            const apiField = $ee5d817149f79816$var$GRID_COL_TO_API_FILTER_FIELD[colId];
            if (!apiField) return; // Skip columns that don't have filter mapping
            const filter = filterModel[colId];
            if (!filter) return; // Skip if filter is null/undefined
            // Handle checkbox filter (AgCheckboxFilter returns { values: string[] })
            if (filter && filter.values && Array.isArray(filter.values)) // Only add filter if at least one value is selected (filter is active)
            // When no values are selected, the filter is inactive and we don't filter
            {
                if (filter.values.length > 0) {
                    // Filter out the BLANK_KEY if present, as it's not a real value
                    const realValues = filter.values.filter((v)=>v !== "__AG_CHECKBOX_FILTER_BLANK__");
                    if (realValues.length > 0) {
                        // Special handling for featured column: expand "Yes" to ["featured", "otherFeatured"]
                        let expandedValues = realValues;
                        if (colId === "featured") expandedValues = realValues.flatMap((v)=>{
                            if (v === "Yes") return [
                                "featured",
                                "otherFeatured"
                            ];
                            return [
                                v
                            ];
                        });
                        const filterConfig = {
                            field: apiField,
                            value: expandedValues
                        };
                        if (colId === "featured") filterConfig.caseSensitive = true;
                        newFieldFilters.push(filterConfig);
                    }
                }
            } else if (filter && filter.filter !== undefined) {
                // AG Grid text filter stores the filter value in the 'filter' property
                const filterValue = String(filter.filter).trim();
                // Only add filter if there's a non-empty value
                if (filterValue) newFieldFilters.push({
                    field: apiField,
                    value: [
                        filterValue
                    ]
                });
            // If filterValue is empty, don't add to fieldFilters (filter is cleared)
            }
        });
        // Compare with existing filters to prevent unnecessary updates
        const newFieldFiltersKey = JSON.stringify(newFieldFilters);
        const currentFieldFiltersKey = JSON.stringify(fieldFilters);
        // Only update if filters actually changed
        if (newFieldFiltersKey !== currentFieldFiltersKey) {
            setFieldFilters(newFieldFilters);
            setPage(1);
        }
    }, [
        fieldFilters
    ]);
    // Helper function to get available values for a column from API filters
    const getAvailableValuesForColumn = (0, $acw62.useCallback)((colId)=>{
        if (!availableFilters) return null;
        const apiField = $ee5d817149f79816$var$GRID_COL_TO_API_FILTER_FIELD[colId];
        if (!apiField) return null;
        const filterData = availableFilters.availableFilters.find((f)=>f.field === apiField);
        return filterData?.values ?? null;
    }, [
        availableFilters
    ]);
    const handleGridReady = (0, $acw62.useCallback)((params)=>{
        gridApiRef.current = params.api;
        // Only apply initial sort state on first mount
        if (isInitialMountRef.current) {
            isApplyingInitialSortRef.current = true;
            params.api.applyColumnState({
                defaultState: {
                    sort: null,
                    sortIndex: null
                },
                state: initialColumnState
            });
            isApplyingInitialSortRef.current = false;
            isInitialMountRef.current = false;
        }
    }, [
        initialColumnState
    ]);
    // Show a transient "copied" popup, auto-dismissing after a short delay.
    const showCopyFeedback = (0, $acw62.useCallback)((message)=>{
        setCopyFeedback(message);
        if (copyFeedbackTimeoutRef.current) clearTimeout(copyFeedbackTimeoutRef.current);
        copyFeedbackTimeoutRef.current = setTimeout(()=>{
            setCopyFeedback(null);
            copyFeedbackTimeoutRef.current = null;
        }, 1800);
    }, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (copyFeedbackTimeoutRef.current) clearTimeout(copyFeedbackTimeoutRef.current);
        };
    }, []);
    // Remember the last cell the user clicked (in the main grid) so we know what
    // to copy. Tracking clicks is more reliable than AG Grid's focus reporting
    // with the interactive cell renderers in this grid.
    const handleCellClicked = (0, $acw62.useCallback)((event)=>{
        if (event.rowIndex != null) copySourceRef.current = {
            api: event.api,
            rowIndex: event.rowIndex,
            colId: event.column.getColId()
        };
    }, []);
    // Same, but for a cell clicked inside an expanded detail grid (the detail
    // grid is a separate AG Grid instance with its own api).
    const handleDetailCellClicked = (0, $acw62.useCallback)((api, rowIndex, colId)=>{
        copySourceRef.current = {
            api: api,
            rowIndex: rowIndex,
            colId: colId
        };
    }, []);
    // Clipboard copy for ag-grid-community (the built-in clipboard is an
    // Enterprise feature). We listen for Ctrl/Cmd+C on the document in the
    // capture phase — more reliable than AG Grid's onCellKeyDown, which doesn't
    // fire dependably when cells contain interactive renderers. The copy targets
    // the last clicked cell (main grid or expanded detail grid), preferring that
    // grid's focused cell. Ctrl/Cmd+C copies the cell; adding Shift copies the row.
    (0, $acw62.useEffect)(()=>{
        const onKeyDown = (event)=>{
            const isCopyKey = (event.ctrlKey || event.metaKey) && (event.key === "c" || event.key === "C");
            if (!isCopyKey) return;
            // Let the browser handle a normal text selection copy.
            if (window.getSelection()?.toString()) return;
            // Don't hijack copy while the user is typing in an input.
            const active = document.activeElement;
            if (active && (active.tagName === "INPUT" || active.tagName === "TEXTAREA" || active.isContentEditable)) return;
            const source = copySourceRef.current;
            if (!source) return;
            try {
                const api = source.api;
                // Prefer the grid's own focused cell, fall back to the recorded click.
                let rowIndex = source.rowIndex;
                let column = api.getColumn(source.colId);
                const focusedCell = api.getFocusedCell();
                if (focusedCell) {
                    rowIndex = focusedCell.rowIndex;
                    column = focusedCell.column;
                }
                if (!column) return;
                const rowNode = api.getDisplayedRowAtIndex(rowIndex);
                if (!rowNode) return;
                const payload = (0, $3afce4b0784d8abb$export$452a843c2126e4cf)(api, rowNode, column, event.shiftKey);
                if (!payload) return;
                event.preventDefault();
                (0, $3afce4b0784d8abb$export$f980440e1ab4537d)(payload.text).then((copied)=>{
                    if (copied) {
                        // Brief highlight + popup so the user sees what was copied.
                        api.flashCells({
                            rowNodes: [
                                rowNode
                            ],
                            columns: payload.flashColumns
                        });
                        showCopyFeedback(payload.feedback);
                    } else console.error("Failed to copy to clipboard");
                });
            } catch  {
            // The source grid may have been unmounted (e.g. the row was
            // collapsed) — ignore and let the next click re-establish a target.
            }
        };
        document.addEventListener("keydown", onKeyDown, true);
        return ()=>document.removeEventListener("keydown", onKeyDown, true);
    }, [
        showCopyFeedback
    ]);
    const handleDetailGridSortChange = (0, $acw62.useCallback)((colId, sort)=>{
        if (!gridApiRef.current) return;
        // Apply the sort to this column as primary sort
        // First, clear all sorts
        gridApiRef.current.applyColumnState({
            defaultState: {
                sort: null,
                sortIndex: null
            }
        });
        // Then apply the new sort
        if (sort) gridApiRef.current.applyColumnState({
            state: [
                {
                    colId: colId,
                    sort: sort,
                    sortIndex: 0
                }
            ]
        });
    // handleSortChanged will be triggered automatically and update sortFields
    }, []);
    const handleDetailColumnVisibilityChange = (0, $acw62.useCallback)((field, visible)=>{
        setDetailVisibleColumns((prev)=>{
            const newSet = new Set(prev);
            if (visible) newSet.add(field);
            else newSet.delete(field);
            return newSet;
        });
        // Apply to all detail grids
        detailGridApiRefs.current.forEach((api)=>{
            api.setColumnsVisible([
                field
            ], visible);
        });
    }, []);
    const resetSortOrder = (0, $acw62.useCallback)(()=>{
        if (!gridApiRef.current) return;
        gridApiRef.current.applyColumnState({
            defaultState: {
                sort: null,
                sortIndex: null
            },
            state: initialColumnState
        });
        // handleSortChanged will be triggered automatically and update sortFields
        // But we also need to update sortFields immediately for consistency
        const defaultSortFields = $ee5d817149f79816$var$DEFAULT_SORT_MODEL.map((item)=>{
            const apiField = $ee5d817149f79816$var$GRID_SORT_TO_API_FIELD[item.colId];
            if (apiField && item.sort) return {
                field: apiField,
                order: item.sort === "desc" ? "desc" : "asc"
            };
            return null;
        }).filter((item)=>item !== null);
        sortFieldsRef.current = defaultSortFields;
        setSortFields(defaultSortFields);
        setPage(1);
    }, [
        initialColumnState
    ]);
    const resetFilters = (0, $acw62.useCallback)(()=>{
        if (!gridApiRef.current) return;
        // Clear all filters from the grid
        gridApiRef.current.setFilterModel(null);
        // Reset field filters state
        setFieldFilters([]);
        setPage(1);
    }, []);
    const toggleRowExpansion = (0, $acw62.useCallback)((rowId)=>{
        setExpandedRowIds((prev)=>{
            const next = new Set(prev);
            if (next.has(rowId)) next.delete(rowId);
            else next.add(rowId);
            return next;
        });
    }, []);
    const expandAllRows = (0, $acw62.useCallback)(()=>{
        setExpandedRowIds(new Set(rows.map((row)=>row.id)));
    }, [
        rows
    ]);
    const collapseAllRows = (0, $acw62.useCallback)(()=>{
        setExpandedRowIds(new Set());
    }, []);
    const hasAnyExpandedRows = (0, $acw62.useMemo)(()=>{
        return expandedRowIds.size > 0;
    }, [
        expandedRowIds.size
    ]);
    // --- Bulk / mass editing handlers (PROTOTYPE) ----------------------------
    const toggleRowSelection = (0, $acw62.useCallback)((rowId)=>{
        setSelectedRowIds((prev)=>{
            const next = new Set(prev);
            if (next.has(rowId)) next.delete(rowId);
            else next.add(rowId);
            return next;
        });
    }, []);
    // Select-all toggles between "every current row" and "none".
    const toggleSelectAll = (0, $acw62.useCallback)(()=>{
        setSelectedRowIds((prev)=>{
            const allIds = rowsRef.current.map((row)=>row.id);
            const allSelected = allIds.length > 0 && allIds.every((id)=>prev.has(id));
            return allSelected ? new Set() : new Set(allIds);
        });
    }, []);
    const enterBulkEditMode = (0, $acw62.useCallback)(()=>{
        preBulkRowsPerPageRef.current = rowsPerPage;
        setSelectedRowIds(new Set());
        collapseAllRows();
        // Filtering is disabled in bulk mode — clear any active filters/search so
        // "all results" really means every record.
        setSearchTerm("");
        setDebouncedSearchTerm("");
        setFieldFilters([]);
        setSelectedConfidenceCategory(null);
        gridApiRef.current?.setFilterModel(null);
        // Collapse pagination into a single page holding every record.
        setPage(1);
        // If we don't already hold every record, we're about to fetch all of them.
        // Show the loading indicator *immediately* and drop the current partial
        // page so the stale "current page" rows aren't shown while the full fetch
        // is in flight (avoids the "current page, then all rows" flash).
        const alreadyHaveAll = recordingsCount > 0 && rowsRef.current.length >= recordingsCount;
        if (!alreadyHaveAll) {
            setIsLoading(true);
            setRows([]);
        }
        setRowsPerPage(recordingsCount > 0 ? recordingsCount : rowsPerPage);
        setBulkEditMode(true);
    }, [
        rowsPerPage,
        recordingsCount,
        collapseAllRows
    ]);
    // `enterBulkEditMode` sizes the single page from the count it holds at that
    // moment — which is the *filtered* count, while entering also clears the
    // filters. The wider count only arrives with the next fetch, so widen the
    // page to match it once it does. Without this the table keeps one stale
    // page-worth of records with pagination hidden, leaving the rest unreachable
    // and unselectable while the footer claimed to be showing everything.
    (0, $acw62.useEffect)(()=>{
        if (!bulkEditMode) return;
        if (recordingsCount > rowsPerPage) setRowsPerPage(recordingsCount);
    }, [
        bulkEditMode,
        recordingsCount,
        rowsPerPage
    ]);
    const exitBulkEditMode = (0, $acw62.useCallback)(()=>{
        setBulkEditMode(false);
        setSelectedRowIds(new Set());
        setShowBulkEditModal(false);
        setRowsPerPage(preBulkRowsPerPageRef.current);
        setPage(1);
    }, []);
    // Cancel mass editing: discard all pending edits (which drops the mode back to
    // normal, since mass edit mode is derived from having pending edits). We stay
    // on the current page and keep the current filters — mass edit never changed
    // them, so there's nothing to restore.
    const exitMassEditMode = (0, $acw62.useCallback)(()=>{
        setMassEdits({});
        massEditsRef.current = {};
        setMassFieldTarget(null);
        setShowMassSummary(false);
        setMassIsrcReassignments({});
        setMassApplyResult(null);
    }, []);
    // Apply every pending mass edit through the batch endpoints (contract §3.1):
    // one call per endpoint rather than one per recording. Recordings that saved
    // cleanly are updated optimistically and their pending edits dropped; ones
    // that failed keep their edits so the user can fix and retry, with the
    // per-recording reasons shown in the summary.
    const handleApplyMassEdits = (0, $acw62.useCallback)(async ()=>{
        if (!userId) return;
        setMassSaving(true);
        setMassApplyResult(null);
        try {
            const editsSnapshot = massEditsRef.current;
            const result = await (0, $1ca226bb7c080c09$export$87145ec5ef7f5cf1)(api, userId, editsSnapshot, rowsRef.current, massIsrcReassignments);
            setMassApplyResult(result);
            if (result.appliedRecordingIds.length > 0) {
                const applied = new Set(result.appliedRecordingIds);
                setRows((prev)=>prev.map((r)=>applied.has(r.id) && editsSnapshot[r.id] ? (0, $1ca226bb7c080c09$export$5f6de07de0e6ae14)(r, editsSnapshot[r.id]) : r));
                // Drop the edits that landed; anything still pending failed and stays
                // on screen so the user can correct it.
                setMassEdits((prev)=>{
                    const next = Object.fromEntries(Object.entries(prev).filter(([id])=>!applied.has(id)));
                    massEditsRef.current = next;
                    return next;
                });
            }
            if (result.ok) exitMassEditMode();
        } finally{
            setMassSaving(false);
        }
    }, [
        api,
        userId,
        massIsrcReassignments,
        exitMassEditMode
    ]);
    // The first mass edit closes any open single-recording edit panel/modal so the
    // two editing surfaces don't overlap.
    const prevMassEditModeRef = (0, $acw62.useRef)(massEditMode);
    (0, $acw62.useEffect)(()=>{
        if (massEditMode && !prevMassEditModeRef.current) {
            setShowEditModal(false);
            setShowEditPanel(false);
            setSelectedRowForModal(null);
        }
        prevMassEditModeRef.current = massEditMode;
    }, [
        massEditMode
    ]);
    // Populate the contribution alias dropdown when a mass contributions modal
    // opens (personas are client-level, so any parent recording id works). Reuses
    // the same alias state as the bulk editor.
    (0, $acw62.useEffect)(()=>{
        if (massFieldTarget?.field !== "contributions" || !userId || bulkClientAliases.length > 0) return;
        let cancelled = false;
        (async ()=>{
            try {
                const response = await api.lookupClientAliasesLookupClientAliasesResponse({
                    userId: userId,
                    parentRecordingId: massFieldTarget.rowId
                });
                if (!cancelled) setBulkClientAliases(response.personas.map((p)=>({
                        stageName: p.stageName,
                        personaId: p.personaId
                    })));
            } catch  {
            // Silently ignore — the alias dropdown will just be empty.
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        massFieldTarget,
        userId,
        bulkClientAliases.length,
        api
    ]);
    // Fetch client aliases (personas) when the bulk edit modal opens so the
    // contribution editor's Alias dropdown is populated. Personas are
    // client-level; the lookup just needs any parent recording id, so we use the
    // first selected row.
    (0, $acw62.useEffect)(()=>{
        if (!showBulkEditModal || !userId || bulkClientAliases.length > 0) return;
        const firstSelectedId = Array.from(selectedRowIds)[0];
        if (!firstSelectedId) return;
        let cancelled = false;
        (async ()=>{
            try {
                const response = await api.lookupClientAliasesLookupClientAliasesResponse({
                    userId: userId,
                    parentRecordingId: firstSelectedId
                });
                if (!cancelled) setBulkClientAliases(response.personas.map((p)=>({
                        stageName: p.stageName,
                        personaId: p.personaId
                    })));
            } catch  {
            // Silently ignore — the alias dropdown will just be empty.
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showBulkEditModal,
        userId,
        selectedRowIds,
        bulkClientAliases.length,
        api
    ]);
    // -------------------------------------------------------------------------
    const handleOpenEditModal = (0, $acw62.useCallback)((row)=>{
        // If a different recording is already open with unsaved changes, confirm
        // before switching so the user doesn't silently lose their edits.
        if (selectedRowIdRef.current && selectedRowIdRef.current !== row.id && editFormRef.current?.isDirty()) {
            setPendingSwitchRow(row);
            return;
        }
        setSelectedRowForModal(row);
        setShowEditPanel(true);
    }, []);
    const handleSaveModalEdit = (0, $acw62.useCallback)((updatedRow, reassignedIsrcs)=>{
        // Build a map of recordingId → ISRCs to remove (from duplicate ISRC reassignment)
        const isrcsToRemove = new Map();
        if (reassignedIsrcs) {
            for (const { isrc: isrc, fromRecordingIds: fromRecordingIds } of reassignedIsrcs)for (const rid of fromRecordingIds){
                if (!isrcsToRemove.has(rid)) isrcsToRemove.set(rid, new Set());
                isrcsToRemove.get(rid).add(isrc);
            }
        }
        setRows((prevRows)=>{
            return prevRows.map((row)=>{
                if (row.id === updatedRow.id) return {
                    ...row,
                    ...updatedRow,
                    isModified: true
                };
                // Strip reassigned ISRCs from source recordings
                const toRemove = isrcsToRemove.get(row.id);
                if (toRemove) {
                    const newIsrcsArray = (row.isrcsArray ?? []).filter((v)=>!toRemove.has(v));
                    return {
                        ...row,
                        isrcs: newIsrcsArray.join(", "),
                        isrcsArray: newIsrcsArray
                    };
                }
                return row;
            });
        });
        // Keep the modal/panel open after save so users can continue reviewing
        // their changes; the form drops back into read-only mode on its own and
        // also re-fetches the manual-changes overlay so indicators update.
        setSelectedRowForModal((prev)=>prev && prev.id === updatedRow.id ? {
                ...prev,
                ...updatedRow,
                isModified: true
            } : prev);
    }, []);
    const gridRows = (0, $acw62.useMemo)(()=>{
        const expanded = new Set(expandedRowIds);
        const result = [];
        rows.forEach((row)=>{
            result.push({
                ...row,
                kind: "data"
            });
            if (expanded.has(row.id)) result.push({
                kind: "detail",
                id: `${row.id}__detail`,
                parentId: row.id,
                base: row
            });
        });
        return result;
    }, [
        expandedRowIds,
        rows
    ]);
    const getRowId = (0, $acw62.useCallback)((params)=>{
        if (!params.data) return "";
        if (params.data.kind === "detail") return params.data.id;
        return params.data.id;
    }, []);
    const getRowHeight = (0, $acw62.useCallback)((params)=>{
        if (!params.data) return 48;
        if (params.data.kind === "detail") // Header height (30) + row height (70) + padding (24) = 124
        return 94;
        return 48;
    }, []);
    const handlePostSortRows = (0, $acw62.useCallback)(({ nodes: nodes })=>{
        const detailNodes = [];
        for(let i = nodes.length - 1; i >= 0; i--){
            const node = nodes[i];
            if (node.data?.kind === "detail") {
                detailNodes.push(node);
                nodes.splice(i, 1);
            }
        }
        detailNodes.reverse().forEach((detailNode)=>{
            const data = detailNode.data;
            if (!data || data.kind !== "detail") {
                nodes.push(detailNode);
                return;
            }
            const parentId = data.parentId;
            if (!parentId) {
                nodes.push(detailNode);
                return;
            }
            const parentIndex = nodes.findIndex((node)=>node.data?.kind === "data" && node.data.id === parentId);
            if (parentIndex === -1) {
                nodes.push(detailNode);
                return;
            }
            nodes.splice(parentIndex + 1, 0, detailNode);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        setExpandedRowIds((prev)=>{
            const available = new Set(rows.map((row)=>row.id));
            const retained = new Set();
            prev.forEach((id)=>{
                if (available.has(id)) retained.add(id);
            });
            return retained.size === prev.size ? prev : retained;
        });
    }, [
        rows
    ]);
    // Reset row heights when confidence filter changes and new data arrives
    // This fixes the visual bug where rows render with wrong heights after filter change
    const prevConfidenceCategoryRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        // Check if confidence category changed
        const confidenceChanged = prevConfidenceCategoryRef.current !== selectedConfidenceCategory;
        if (confidenceChanged && gridApiRef.current && rows.length > 0) // Reset row heights after confidence filter change to fix visual bug
        // Use requestAnimationFrame to ensure this happens after React render
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (gridApiRef.current) gridApiRef.current.resetRowHeights();
            });
        });
        prevConfidenceCategoryRef.current = selectedConfidenceCategory;
    }, [
        selectedConfidenceCategory,
        rows.length
    ]);
    const fetchData = async ()=>{
        if (userId === undefined) return;
        setIsLoading(true);
        try {
            const discographyData = await api.searchPrimaryDiscography({
                userId: userId,
                primaryDiscographyRequest: {
                    size: rowsPerPage,
                    fromOffset: (page - 1) * rowsPerPage,
                    sortFields: sortFields,
                    ...sortFields.length > 0 && {
                        sortField: sortFields[0].field,
                        sortOrder: sortFields[0].order
                    },
                    confidenceCategory: selectedConfidenceCategory ?? undefined,
                    searchTerm: debouncedSearchTerm || undefined,
                    fieldFilters: fieldFilters.length > 0 ? fieldFilters : undefined
                }
            });
            const rows = discographyData.recordings.map((recording)=>{
                const { parentRecording: parentRecording, earliestParentRelease: earliestParentRelease, evidenceReleases: evidenceReleases, westburyContributions: westburyContributions, performance: performance, persona: persona } = recording;
                return {
                    id: parentRecording.id,
                    artist: parentRecording.bandArtistName,
                    title: parentRecording.recordingTitle,
                    version: (parentRecording.recordingVersion ?? []).join(",\u2000"),
                    release: earliestParentRelease?.releaseTitle ?? "",
                    year: earliestParentRelease?.dateReleased,
                    isrcs: (parentRecording.isrcs ?? []).join(",\u2000"),
                    contributions: westburyContributions.sort((a, b)=>b.confidenceCategory.localeCompare(a.confidenceCategory)),
                    duration: parentRecording.duration ?? null,
                    isFeatured: [
                        "featured",
                        "otherFeatured"
                    ].includes(performance.featuredStatus ?? ""),
                    isLive: !!parentRecording.live,
                    live: parentRecording.live ?? null,
                    // Subheadings data
                    collaborators: "",
                    catNumbers: (earliestParentRelease?.catNumbers ?? []).join(",\u2000"),
                    label: (earliestParentRelease?.releaseLabels ?? []).join(",\u2000"),
                    format: earliestParentRelease?.format ?? "",
                    mediaType: earliestParentRelease?.mediaType ?? "",
                    stageName: persona.stageName,
                    location: parentRecording.countryOfRecording ?? "",
                    yearRecorded: parentRecording.yearRecorded ?? null,
                    pNames: (parentRecording.pNames ?? []).join(", "),
                    source: recording.parentRecording.source.toString(),
                    labelsArray: earliestParentRelease?.releaseLabels ?? [],
                    catNumbersArray: earliestParentRelease?.catNumbers ?? [],
                    versionsArray: parentRecording.recordingVersion ?? [],
                    isrcsArray: parentRecording.isrcs ?? [],
                    mainArtistsRaw: parentRecording.mainArtists ?? [],
                    documentId: recording.documentId ?? undefined,
                    earliestParentReleaseId: earliestParentRelease?.id,
                    sourceReleaseId: earliestParentRelease?.sourceReleaseId ?? [],
                    // notes: '',
                    earliestReleaseImageKey: (evidenceReleases?.at(0)?.evidenceImages ?? []).map((image)=>image.objectKey).at(0),
                    releaseImageKeys: (evidenceReleases ?? []).flatMap((release)=>(release.evidenceImages ?? []).map((image)=>image.objectKey)),
                    hasManualChanges: false
                };
            });
            // Fetch the manual-changes overlay for the visible rows. Contract 4.5.1.
            // We use document_ids (canonical OS identifier) when available; fall
            // back to recording_ids otherwise. Failures are non-fatal — the table
            // just renders without the purple-line indicator.
            const documentIds = rows.map((r)=>r.documentId).filter((d)=>!!d);
            const recordingIds = rows.map((r)=>r.id);
            const changedRecordingIds = new Set();
            try {
                if (userId) {
                    const bulk = await api.bulkManualChangesBulkManualChangesResponse({
                        userId: userId,
                        bulkManualChangesRequest: documentIds.length === rows.length ? {
                            documentIds: documentIds
                        } : {
                            recordingIds: recordingIds
                        }
                    });
                    for (const entry of bulk?.recordings ?? [])if (entry?.hasManualChanges && entry?.recordingId) changedRecordingIds.add(entry.recordingId);
                }
            } catch (err) {
                console.warn("bulk manual-changes lookup failed", err);
            }
            for (const row of rows)row.hasManualChanges = changedRecordingIds.has(row.id);
            // For rows that have *some* manual change, resolve which specific fields
            // were manually edited (live, duration). This drives the write-once
            // editability gate in mass/bulk edit — a value that is already set and
            // has never been manually edited is locked (mirrors the edit form's
            // isFieldEdited). Only the changed subset needs the per-recording detail
            // call, so this stays bounded and off the happy path.
            if (userId) {
                const changedRows = rows.filter((r)=>r.hasManualChanges);
                await Promise.all(changedRows.map(async (row)=>{
                    try {
                        const detail = await api.recordingManualChangesRecordingManualChangesResponse({
                            userId: userId,
                            parentRecordingId: row.id,
                            documentId: row.documentId
                        });
                        const fields = detail?.fields ?? {};
                        row.liveEditedManually = fields.live != null;
                        row.durationEditedManually = fields.duration != null;
                        // Artists added by a manual change, so the mass-edit chips can
                        // show the same purple line the edit form does (4.5.2).
                        const artistItems = fields.artists?.items ?? [];
                        const added = artistItems.filter((it)=>it.op === "add");
                        row.manuallyAddedArtistIds = added.map((it)=>it.artistId).filter((id)=>!!id);
                        row.manuallyAddedArtistNames = added.map((it)=>it.stageName).filter((n)=>!!n);
                        // Contribution roles touched by a manual change — mirrors the
                        // edit form's editedContributionRoles (add or edit ops).
                        const contributionItems = fields.contributions?.items ?? [];
                        row.manuallyChangedContributionRoles = contributionItems.filter((it)=>it.op === "add" || it.op === "edit").map((it)=>it.role).filter((r)=>!!r);
                        // ISRCs added by a manual change — matched by value, mirroring
                        // the edit form's addedValuesFor('isrcs').
                        const isrcItems = fields.isrcs?.items ?? [];
                        row.manuallyAddedIsrcs = isrcItems.filter((it)=>it.op === "add" && typeof it.value === "string").map((it)=>it.value);
                    } catch (err) {
                        console.warn("per-field manual-changes lookup failed", err);
                    }
                }));
            }
            // Merge with existing rows to preserve editing state
            setRows((prevRows)=>{
                return rows.map((newRow)=>{
                    const existingRow = prevRows.find((r)=>r.id === newRow.id);
                    if (existingRow && existingRow.isModified) return {
                        ...newRow,
                        ...existingRow,
                        // Keep modified values but update other fields
                        artist: existingRow.artist,
                        title: existingRow.title,
                        release: existingRow.release,
                        year: existingRow.year,
                        isrcs: existingRow.isrcs
                    };
                    return {
                        ...newRow,
                        isModified: false,
                        originalValues: {}
                    };
                });
            });
            setRecordingsCount(discographyData.count);
        } catch (e) {
            console.error(e);
            setLoadingError(true);
        }
        setIsLoading(false);
    };
    const transformConfidenceStatsToChartData = (stats)=>{
        const getCategoryIcon = (categoryId)=>{
            switch(categoryId){
                case "1":
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                        className: "tw-w-5 tw-h-5"
                    });
                case "2":
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                        className: "tw-w-5 tw-h-5"
                    });
                case "3":
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-p-1 tw-rounded-full tw-border-[#f97316] tw-border-[2px] tw-w-5 tw-h-5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $604e08b57548a73d$export$2e2bcd8739ae039), {
                            className: "tw-w-2.5 tw-h-2.5 -tw-mt-[1px] -tw-ml-[1px]"
                        })
                    });
                case "4":
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                        className: "tw-w-5 tw-h-5"
                    });
                case "5":
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                        className: "tw-w-5 tw-h-5"
                    });
                default:
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                        className: "tw-w-5 tw-h-5"
                    });
            }
        };
        const getCategoryInfo = (categoryId)=>{
            switch(categoryId){
                case "1":
                    return {
                        label: "Verified (No Effort)",
                        text: "black",
                        color: "#6EE038",
                        description: "Contributions that have been verified and require no additional effort"
                    };
                case "2":
                    return {
                        label: "Inferred (Low Effort)",
                        text: "black",
                        color: "#F6FF00",
                        description: "Contributions that can be inferred with low verification effort"
                    };
                case "3":
                    return {
                        label: "Credited (Mid Effort)",
                        text: "white",
                        color: "#FF8A00",
                        description: "Contributions that are credited and require moderate verification effort"
                    };
                case "4":
                    return {
                        label: "Unverified (High Effort)",
                        text: "white",
                        color: "#FF2600",
                        description: "Contributions that are unverified and require high verification effort"
                    };
                case "5":
                    return {
                        label: "Unknown (Max Effort)",
                        text: "black",
                        color: "#AAB2B9",
                        description: "Contributions with unknown status requiring maximum verification effort"
                    };
                default:
                    return {
                        label: `Category ${categoryId}`,
                        text: "white",
                        color: "#AAB2B9",
                        description: "Unknown confidence category"
                    };
            }
        };
        stats.confidenceCategories.sort((a, b)=>Number(a.confidenceCategory) - Number(b.confidenceCategory));
        return stats.confidenceCategories.map((category)=>{
            const categoryInfo = getCategoryInfo(category.confidenceCategory);
            return {
                id: category.confidenceCategory,
                label: categoryInfo.label,
                value: category.count,
                text: categoryInfo.text,
                color: categoryInfo.color,
                icon: getCategoryIcon(category.confidenceCategory),
                description: categoryInfo.description
            };
        });
    };
    const fetchConfidenceStats = async ()=>{
        if (userId === undefined) return;
        try {
            const stats = await api.confidenceStatsConfidenceStats({
                userId: userId
            });
            setConfidenceStats(stats);
        } catch (e) {
            console.error("Failed to fetch confidence stats:", e);
            // Set to null on error so we can show default data or handle gracefully
            setConfidenceStats(null);
        }
    };
    const fetchAvailableFilters = async ()=>{
        if (userId === undefined) return;
        try {
            const filters = await api.availableFiltersAvailableFiltersResponse({
                userId: userId
            });
            setAvailableFilters(filters);
        } catch (e) {
            console.error("Failed to fetch available filters:", e);
            setAvailableFilters(null);
        }
    };
    const handleConfidenceFilterChange = (categoryId)=>{
        // Filtering is disabled in bulk-edit mode — ignore chart clicks so the
        // single-page "all records" view isn't re-filtered.
        if (bulkEditMode) return;
        setSelectedConfidenceCategory(categoryId);
        setPage(1); // Reset to first page when filter changes
        // Don't clear rows immediately - let fetchData handle it naturally
        // This prevents AG Grid from having stale row nodes with cached heights
        setIsLoading(true); // Set loading state
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId,
        page,
        rowsPerPage,
        sortFieldsKey,
        selectedConfidenceCategory,
        debouncedSearchTerm,
        fieldFiltersKey
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchConfidenceStats();
        fetchAvailableFilters();
    }, [
        userId
    ]);
    // Client personal info (used only for the header name) doesn't change with
    // pagination/sort/filter, so fetch it once per user. Keeping it inside
    // fetchData meant it re-fired on every page change and, being unhandled,
    // a transient network failure surfaced as an unhandled rejection that
    // crashed the whole view.
    (0, $acw62.useEffect)(()=>{
        if (userId === undefined) return;
        api.retrieveAdminPersonalInformation({
            userId: userId
        }).then((personalInfo)=>{
            setClientPersonalInfo(personalInfo);
        }).catch((err)=>{
            console.warn("failed to load client personal information", err);
        });
    }, [
        userId
    ]);
    // Debounce search term with 300ms delay
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebouncedSearchTerm(searchTerm);
        }, 300);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        searchTerm
    ]);
    // Reset to page 1 when debounced search term changes (but not on initial mount)
    (0, $acw62.useEffect)(()=>{
        if (prevDebouncedSearchTermRef.current !== debouncedSearchTerm) {
            if (!isInitialMountRef.current) setPage(1);
            prevDebouncedSearchTermRef.current = debouncedSearchTerm;
            isInitialMountRef.current = false;
        }
    }, [
        debouncedSearchTerm
    ]);
    // Update filter available values when availableFilters changes
    (0, $acw62.useEffect)(()=>{
        if (!gridApiRef.current || !availableFilters) return;
        // Update each filterable column's filter with new available values
        const filterableColumns = [
            "artist",
            "version",
            "contributions",
            "release",
            "year",
            "live",
            "stageName",
            "type",
            "format",
            "label",
            "catNumbers",
            "featured"
        ];
        filterableColumns.forEach((colId)=>{
            const column = gridApiRef.current?.getColumn(colId);
            if (!column) return;
            // Use getColumnApi or direct access to get filter instance
            const filterInstance = gridApiRef.current.getFilterInstance?.(colId);
            if (filterInstance && typeof filterInstance.setAvailableValues === "function") {
                const availableValues = getAvailableValuesForColumn(colId);
                if (availableValues) filterInstance.setAvailableValues(availableValues);
            }
        });
    }, [
        availableFilters,
        getAvailableValuesForColumn
    ]);
    const fetchSignedEvidenceImageUrls = ()=>{
        if (userId === undefined) return;
        for (const row of rows){
            if (row.earliestReleaseImageKey === undefined) continue;
            api.evidenceImageSignedUrlEvidenceImageSignedUrl({
                userId: userId,
                evidenceImageSignedUrlRequest: {
                    objectKey: row.earliestReleaseImageKey
                }
            }).then(({ signedUrl: signedUrl })=>{
                setImages((prev)=>{
                    return {
                        ...prev,
                        [row.id]: signedUrl
                    };
                });
            }).catch((e)=>{
                console.error(e);
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchSignedEvidenceImageUrls();
    }, [
        rows
    ]);
    const fetchLatestExportStatus = async ()=>{
        if (userId === undefined) return;
        api.retrieveLatestPrimaryDiscographyExport({
            userId: userId
        }).then((primaryDiscographyExport)=>{
            setIsPendingExportGeneration(!primaryDiscographyExport.ready);
        }).catch(()=>{});
    };
    (0, $acw62.useEffect)(()=>{
        fetchLatestExportStatus();
    }, [
        userId
    ]);
    const handleGenerateExport = ()=>{
        if (userId === undefined) return;
        api.createGeneratePrimaryDiscographyExport({
            userId: userId
        }).then(()=>{
            setIsOpenExportConfirmationModal(true);
            fetchLatestExportStatus();
        }).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Discography export generation request failed"));
        });
    };
    const defaultColDef = (0, $acw62.useMemo)(()=>({
            sortable: true,
            resizable: true,
            suppressMenu: true,
            suppressMovable: false,
            sortingOrder: [
                "asc",
                "desc",
                null
            ],
            flex: 1,
            minWidth: 80
        }), []);
    // Store images in a ref so cell renderers can access it without causing columnDefs to recreate
    const imagesRef = (0, $acw62.useRef)(images);
    const prevImagesKeysRef = (0, $acw62.useRef)(JSON.stringify(Object.keys(images)));
    (0, $acw62.useEffect)(()=>{
        const currentImagesKeys = JSON.stringify(Object.keys(images));
        imagesRef.current = images;
        // Refresh cells when images change (including initial load)
        // Check if images actually changed to avoid unnecessary refreshes
        if (gridApiRef.current && currentImagesKeys !== prevImagesKeysRef.current) {
            prevImagesKeysRef.current = currentImagesKeys;
            // Use setTimeout to ensure this happens after render
            setTimeout(()=>{
                if (gridApiRef.current) gridApiRef.current.refreshCells({
                    columns: [
                        "evidence"
                    ],
                    force: true
                });
            }, 0);
        }
    }, [
        images
    ]);
    // Store expandedRowIds in a ref so cell renderers can access it without causing columnDefs to recreate
    const expandedRowIdsRef = (0, $acw62.useRef)(expandedRowIds);
    (0, $acw62.useEffect)(()=>{
        expandedRowIdsRef.current = expandedRowIds;
    }, [
        expandedRowIds
    ]);
    // Custom header component that shows sort index next to sort icon
    // Uses AG Grid's native sort handling via setSort method
    // Defined outside useMemo to prevent recreation
    const CustomHeaderWithSortIndex = (params)=>{
        // Use state to force re-render when sort changes
        const [sortState, setSortState] = (0, $acw62.useState)(()=>({
                sort: params.column?.getSort() ?? null,
                sortIndex: params.column?.getSortIndex() ?? null
            }));
        // Track filter state
        const [isFiltered, setIsFiltered] = (0, $acw62.useState)(()=>{
            if (!params.column) return false;
            const filterModel = params.api.getFilterModel();
            const colId = params.column.getColId();
            const filter = filterModel[colId];
            // Check for text filter
            if (filter && filter.filter) return true;
            // Check for checkbox filter (AgCheckboxFilter returns { values: string[] })
            if (filter && filter.values && Array.isArray(filter.values) && filter.values.length > 0) return true;
            return false;
        });
        // Track menu open state to properly toggle (use ref to avoid re-renders in event handler)
        const menuOpenRef = (0, $acw62.useRef)(false);
        const [isMenuOpen, setIsMenuOpen] = (0, $acw62.useState)(false);
        // Listen to sort changes and update state to force re-render
        (0, $acw62.useEffect)(()=>{
            const updateSortState = ()=>{
                setSortState({
                    sort: params.column?.getSort() ?? null,
                    sortIndex: params.column?.getSortIndex() ?? null
                });
            };
            const updateFilterState = ()=>{
                if (!params.column) return;
                const filterModel = params.api.getFilterModel();
                const colId = params.column.getColId();
                const filter = filterModel[colId];
                // Check for text filter
                let hasFilter = false;
                if (filter && filter.filter) hasFilter = true;
                else if (filter && filter.values && Array.isArray(filter.values) && filter.values.length > 0) // Check for checkbox filter with selected values
                hasFilter = true;
                setIsFiltered(hasFilter);
            };
            // Update filter state when filter changes (don't update menu state here to avoid loops)
            // AG Grid automatically closes the menu when filters are applied
            const handleFilterChanged = ()=>{
                updateFilterState();
                // Update ref without causing re-render
                menuOpenRef.current = false;
            };
            // Update immediately
            updateSortState();
            updateFilterState();
            // Listen to sort changed events
            params.api.addEventListener("sortChanged", updateSortState);
            // Listen to filter changed events (only update filter state, not menu state)
            params.api.addEventListener("filterChanged", handleFilterChanged);
            return ()=>{
                params.api.removeEventListener("sortChanged", updateSortState);
                params.api.removeEventListener("filterChanged", handleFilterChanged);
            };
        }, [
            params.api,
            params.column
        ]);
        const sortIndex = sortState.sortIndex;
        const sort = sortState.sort;
        const displayName = params.displayName;
        // Handle sort click - use AG Grid's native setSort method
        const onSortRequested = (event)=>{
            if (!params.enableSorting || !params.column) return;
            // Check for Ctrl (Windows/Linux) or Cmd (Mac) for multi-sort
            // The grid is configured with multiSortKey="ctrl"
            const mouseEvent = event;
            const multiSortKey = mouseEvent.ctrlKey || mouseEvent.metaKey;
            // Use AG Grid's native setSort method which handles multi-sort automatically
            // The multiSortKey="ctrl" setting will be respected
            params.setSort(sort === "asc" ? "desc" : sort === "desc" ? null : "asc", multiSortKey);
        };
        // Handle filter icon click - toggle filter menu
        const onFilterClick = (event)=>{
            event.stopPropagation();
            event.preventDefault();
            if (!params.column) return;
            // If menu is open, close it; otherwise open it
            // Use ref to check state to avoid stale closures
            if (menuOpenRef.current) {
                // Close the menu
                params.api.hidePopupMenu();
                menuOpenRef.current = false;
                setIsMenuOpen(false);
            } else {
                // Open the column menu which contains the filter
                params.showColumnMenu(event.currentTarget);
                menuOpenRef.current = true;
                setIsMenuOpen(true);
            }
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `ag-header-cell-label tw-flex tw-items-center tw-gap-1 tw-w-full ${params.enableSorting ? "tw-cursor-pointer" : ""}`,
            onClick: params.enableSorting ? onSortRequested : undefined,
            onTouchEnd: params.enableSorting ? onSortRequested : undefined,
            role: params.enableSorting ? "button" : undefined,
            tabIndex: params.enableSorting ? 0 : undefined,
            onKeyDown: params.enableSorting ? (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onSortRequested(e);
                }
            } : undefined,
            "aria-label": params.enableSorting ? `Sort by ${displayName}` : undefined,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-flex-1",
                    children: displayName
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-1",
                    children: [
                        params.column?.getColDef().filter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onFilterClick,
                            className: `tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-rounded tw-transition-colors ${isFiltered ? "tw-bg-blue-600 tw-text-white tw-p-1" : "tw-bg-transparent tw-text-neutral-500 tw-p-1 hover:tw-bg-neutral-800"}`,
                            "aria-label": `Filter ${displayName}`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                className: `tw-w-3 tw-h-3 ${isFiltered ? "tw-text-white" : "tw-text-neutral-500"}`
                            })
                        }),
                        params.enableSorting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                sort && sortIndex !== null && sortIndex !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tw-text-xs tw-text-neutral-400 tw-font-medium tw-h-[14px]",
                                    children: sortIndex + 1
                                }),
                                sort ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-flex tw-items-center",
                                    children: sort === "asc" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f05f6a77fc593bc$export$2e2bcd8739ae039), {
                                        className: "tw-w-3 tw-h-3"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $008e11cf932a0927$export$2e2bcd8739ae039), {
                                        className: "tw-w-3 tw-h-3"
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const ExpandAllHeaderComponent = ()=>{
        return null;
    };
    // Header checkbox for the bulk-edit selection column: select all / none.
    // Reads current selection from the ref; the selection effect calls
    // refreshHeader() so this stays in sync.
    const SelectAllHeaderComponent = ()=>{
        const allIds = rowsRef.current.map((row)=>row.id);
        const selected = selectedRowIdsRef.current;
        const allSelected = allIds.length > 0 && allIds.every((id)=>selected.has(id));
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-h-full tw-items-center tw-justify-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95d3bd05f0e5a60a$export$fab3ce5a4cf652db), {
                checkboxSize: "sm",
                checked: allSelected,
                onChange: toggleSelectAll
            })
        });
    };
    const columnDefs = (0, $acw62.useMemo)(()=>{
        return [
            {
                headerName: "",
                colId: "expand",
                width: 20,
                maxWidth: 20,
                cellStyle: (params)=>{
                    const baseStyle = {
                        padding: 0,
                        display: "flex"
                    };
                    if (params.data?.kind === "detail") return {
                        ...baseStyle,
                        alignItems: "stretch",
                        justifyContent: "stretch",
                        width: "100%"
                    };
                    return {
                        ...baseStyle,
                        alignItems: "center",
                        justifyContent: "center"
                    };
                },
                headerClass: "tw-flex tw-items-center tw-justify-center",
                flex: 0,
                sortable: false,
                resizable: false,
                suppressMovable: true,
                headerComponent: ExpandAllHeaderComponent,
                cellRenderer: (params)=>{
                    if (!params.data) return null;
                    if (params.data.kind === "detail") {
                        const row = params.data.base;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee5d817149f79816$var$DetailGrid, {
                            row: row,
                            onSortChange: handleDetailGridSortChange,
                            rowId: params.data.parentId,
                            onGridReady: (rowId, api)=>{
                                detailGridApiRefs.current.set(rowId, api);
                            },
                            visibleColumns: detailVisibleColumns,
                            onCellClickedForCopy: handleDetailCellClicked
                        });
                    }
                    const isExpanded = expandedRowIdsRef.current.has(params.data.id);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: (event)=>{
                            event.stopPropagation();
                            toggleRowExpansion(params.data.id);
                        },
                        // translateX nudges the chevron right so it clears the
                        // "manually changed" left line with a small gap. A transform is
                        // used (rather than margin/padding/width) so it doesn't reflow
                        // the column or shift the rest of the row layout.
                        className: "tw-flex tw-h-7 tw-w-7 tw-translate-x-[8px] tw-items-center tw-justify-center tw-rounded tw-border tw-border-[#30353b] tw-bg-transparent tw-text-white hover:tw-border-[#4a5056]",
                        "aria-label": isExpanded ? "Collapse row" : "Expand row",
                        children: isExpanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                            className: "tw-h-4 tw-w-4"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                            className: "tw-h-4 tw-w-4"
                        })
                    });
                },
                colSpan: (params)=>{
                    if (params.data?.kind === "detail") return Math.max(params.api.getAllDisplayedColumns().length, 1);
                    return 1;
                }
            },
            {
                headerName: "Evidence",
                colId: "evidence",
                width: 80,
                minWidth: 100,
                flex: 0,
                sortable: false,
                cellRenderer: (params)=>{
                    if (!params.data || params.data.kind !== "data") return null;
                    const row = params.data;
                    const imageUrl = imagesRef.current[row.id];
                    const hasImageKey = !!row.earliestReleaseImageKey;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-[45px] tw-h-[45px]",
                        children: hasImageKey ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/discography/${userId}/ai-evidence/${row.id}`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-cursor-pointer",
                                children: imageUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: imageUrl,
                                    alt: "Evidence",
                                    className: "tw-w-full tw-h-full"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-flex tw-justify-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "tw-my-auto tw-animate-ping",
                                        children: "\u26AA"
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi wi-shut-eye wi-20px"
                            })
                        })
                    });
                },
                colSpan: (params)=>{
                    if (params.data?.kind === "detail") return 0;
                    return 1;
                }
            },
            {
                headerName: "Artist",
                colId: "artist",
                field: "artist",
                width: 160,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.artist : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.artist : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("artist") ?? undefined,
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Recording Title",
                colId: "title",
                field: "title",
                width: 128,
                minWidth: 200,
                sortable: true,
                filter: (0, $36bcfc8b5b2b059b$export$1952167e72fdddd1),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.title : "",
                filterParams: {
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Version",
                hide: false,
                colId: "version",
                field: "version",
                width: 50,
                minWidth: 150,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.version || "-" : "",
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return params.data.versionsArray?.length ? params.data.versionsArray : null;
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("version") ?? undefined,
                    serverSideFiltering: true
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: params.data.version || "-"
                    });
                }
            },
            {
                headerName: "Contributions",
                colId: "contributions",
                field: "contributions",
                minWidth: 150,
                width: 150,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.contributions : [],
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    // Return as array for better filtering - split comma-separated values
                    const contributions = params.data.contributions;
                    if (!contributions) return null;
                    // Split by comma and trim each value
                    return contributions.map((contribution)=>contribution.contribution);
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("contributions") ?? undefined,
                    serverSideFiltering: true
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-gap-2",
                        children: params.data.contributions.map((contribution)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca4bfbde716b69b9$export$733e49a0308b4cd), {
                                contribution: contribution
                            }, contribution.contribution))
                    });
                }
            },
            {
                headerName: "ISRCs",
                colId: "isrcs",
                field: "isrcs",
                width: 50,
                sortable: true,
                filter: (0, $36bcfc8b5b2b059b$export$1952167e72fdddd1),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.isrcs : "",
                filterParams: {
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Release",
                colId: "release",
                field: "release",
                width: 50,
                minWidth: 160,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.release : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.release : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("release") ?? undefined,
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Year",
                colId: "year",
                field: "year",
                width: 80,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>{
                    if (params.data?.kind !== "data" || !params.data.year) return "";
                    return new Date(params.data.year).getFullYear().toString();
                },
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data" || !params.data.year) return null;
                    return new Date(params.data.year).getFullYear().toString();
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("year") ?? undefined,
                    serverSideFiltering: true,
                    // Extract year from date strings like "1999-01-23"
                    valueExtractor: (apiValue)=>{
                        try {
                            const date = new Date(apiValue);
                            if (!isNaN(date.getTime())) return date.getFullYear().toString();
                        } catch  {
                        // If parsing fails, return as-is
                        }
                        return apiValue;
                    }
                }
            },
            // --- (P)-line trio -------------------------------------------------
            // Country / year of recording / (P) names. All hidden by default and
            // opt-in via "Show/Hide Data". Read-only: they are absent from the
            // recording edit form and, by construction, from mass and bulk edit —
            // those key their affordances off specific colIds (COMPLEX_FIELDS,
            // `title`, `duration`) and off BulkEditField, so a new colId cannot
            // leak in.
            {
                headerName: "Year of Recording",
                hide: true,
                colId: "yearRecorded",
                field: "yearRecorded",
                width: 140,
                // The only one of the three that is indexed, so the only one that can
                // sort or filter — see GRID_COL_TO_API_FILTER_FIELD.
                sortable: true,
                filter: (0, $36bcfc8b5b2b059b$export$1952167e72fdddd1),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.yearRecorded ?? "" : "",
                filterParams: {
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Country of Recording",
                hide: true,
                colId: "location",
                field: "location",
                width: 160,
                // Unindexed — see GRID_COL_TO_API_FILTER_FIELD. `defaultColDef` turns
                // sorting on for every column, so this has to opt out explicitly:
                // handleSortChanged silently drops colIds with no sort mapping, which
                // would leave the header showing an arrow that does nothing.
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.location : ""
            },
            {
                headerName: "(P) Name",
                hide: true,
                colId: "pNames",
                field: "pNames",
                width: 180,
                // Unindexed — see the Country of Recording column above.
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.pNames ?? "" : ""
            },
            {
                headerName: "Duration",
                colId: "duration",
                field: "duration",
                width: 100,
                sortable: true,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.duration || "-" : "",
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: params.data.duration || "-"
                    });
                }
            },
            {
                headerName: "Type",
                hide: true,
                colId: "type",
                field: "mediaType",
                width: 120,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.mediaType : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.mediaType : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("type") ?? undefined,
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Stage Name",
                hide: true,
                colId: "stageName",
                field: "stageName",
                width: 150,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.stageName : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.stageName : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("stageName") ?? undefined,
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Live",
                colId: "live",
                field: "live",
                width: 150,
                minWidth: 120,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                // `live` is a free-text descriptor string (e.g. "Live in London, 1989").
                // Empty/null means the recording is not live. Sorted/filtered
                // alphanumerically on the string, not the former boolean flag.
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.live || "-" : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.live || null : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("live") ?? undefined,
                    serverSideFiltering: true
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: params.data.live || "-"
                    });
                }
            },
            {
                headerName: "Featured",
                hide: true,
                colId: "featured",
                field: "isFeatured",
                width: 140,
                maxWidth: 140,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.isFeatured : "",
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    // Map boolean to display value
                    return params.data.isFeatured ? "Yes" : "No";
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("featured") ?? undefined,
                    serverSideFiltering: true,
                    caseSensitive: true,
                    // Map API values to display values
                    valueMapper: (apiValue)=>{
                        if (apiValue === "featured" || apiValue === "otherFeatured") return "Yes";
                        if (apiValue === "nonFeatured") return "No";
                        return apiValue;
                    },
                    // Map display values back to API values (will be expanded in handleFilterChanged)
                    reverseMapper: (displayValue)=>{
                        // Keep "Yes" as-is, it will be expanded to ["featured", "otherFeatured"] in handleFilterChanged
                        if (displayValue === "Yes") return "Yes";
                        if (displayValue === "No") return "nonFeatured";
                        return displayValue;
                    }
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi wi-xs", {
                                "wi-check": params.data.isFeatured,
                                "wi-close": !params.data.isFeatured
                            })
                        })
                    });
                }
            },
            {
                headerName: "Format",
                hide: true,
                colId: "format",
                field: "format",
                width: 120,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.format : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.format : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("format") ?? undefined,
                    serverSideFiltering: true,
                    caseInsensitiveDeduplication: true
                }
            },
            {
                headerName: "Collaborators",
                colId: "collaborators",
                field: "collaborators",
                hide: true,
                minWidth: 100,
                sortable: true,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Label",
                colId: "label",
                field: "label",
                hide: true,
                minWidth: 100,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.label : "",
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return params.data.labelsArray?.length ? params.data.labelsArray : null;
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("label") ?? undefined,
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Catalogue Number",
                colId: "catNumbers",
                field: "catNumbers",
                hide: true,
                minWidth: 100,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.catNumbers : "",
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return params.data.catNumbersArray?.length ? params.data.catNumbersArray : null;
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("catNumbers") ?? undefined,
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Actions",
                colId: "actions",
                width: 120,
                minWidth: 120,
                maxWidth: 120,
                flex: 0,
                sortable: false,
                resizable: false,
                cellClass: "tw-flex tw-items-center tw-justify-center",
                cellRenderer: (params)=>{
                    if (!params.data || params.data.kind !== "data") return null;
                    const row = params.data;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-items-center tw-justify-center tw-gap-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            icon: "edit",
                            variant: "secondary",
                            label: "Edit",
                            onClick: ()=>handleOpenEditModal(row)
                        })
                    });
                }
            }
        ];
    }, [
        userId,
        toggleRowExpansion,
        handleDetailGridSortChange,
        getAvailableValuesForColumn,
        handleOpenEditModal
    ]);
    // Column defs actually handed to the grid.
    //  • Bulk-edit mode prepends a selection checkbox column, drops Actions, and
    //    disables filtering.
    //  • Otherwise every recording-level cell is hover-editable at all times (the
    //    edit pencil is revealed on hover). The moment the first edit lands, mass
    //    edit mode is active, and we additionally drop the Actions column and
    //    freeze filtering — matching the toolbar lockdown.
    const effectiveColumnDefs = (0, $acw62.useMemo)(()=>{
        if (bulkEditMode) {
            const selectColumn = {
                headerName: "",
                colId: "select",
                width: 48,
                minWidth: 48,
                maxWidth: 48,
                flex: 0,
                sortable: false,
                resizable: false,
                suppressMovable: true,
                // Intentionally NOT pinned: pinning splits the row into separate
                // pinned/centre viewports, which makes the manual-change inset
                // box-shadow (drawn per row element in `getRowStyle`) appear on both
                // sides of the checkbox. Keeping the column unpinned draws the
                // indicator once, on the left of the checkbox.
                headerComponent: SelectAllHeaderComponent,
                cellClass: "tw-flex tw-items-center tw-justify-center",
                cellRenderer: (params)=>{
                    if (!params.data || params.data.kind !== "data") return null;
                    const rowId = params.data.id;
                    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-h-full tw-items-center tw-justify-center",
                        onClick: (e)=>e.stopPropagation(),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95d3bd05f0e5a60a$export$fab3ce5a4cf652db), {
                            checkboxSize: "sm",
                            checked: selectedRowIdsRef.current.has(rowId),
                            onChange: ()=>toggleRowSelection(rowId)
                        })
                    }));
                }
            };
            const bulkColumns = columnDefs.filter((col)=>col.colId !== "actions");
            return [
                selectColumn,
                ...bulkColumns
            ].map((col)=>col.colId === "select" ? col : {
                    ...col,
                    filter: false,
                    floatingFilter: false
                });
        }
        // Default (browsing + mass editing).
        const COMPLEX_FIELDS = {
            artist: "artist",
            version: "version",
            isrcs: "isrcs",
            contributions: "contributions",
            live: "live"
        };
        // The Actions (full edit form) column and filtering are only removed once
        // mass edit mode is active; before that, normal browsing is untouched.
        const dataColumns = massEditMode ? columnDefs.filter((col)=>col.colId !== "actions") : columnDefs;
        return dataColumns.map((col)=>{
            const base = massEditMode ? {
                ...col,
                filter: false,
                floatingFilter: false
            } : {
                ...col
            };
            // Recording Title — always editable, through its own modal rather than
            // an inline input. A title is required, and a cell that silently refuses
            // to commit an empty value can't say why; the modal states the rule and
            // disables Save instead.
            if (col.colId === "title") return {
                ...base,
                cellRenderer: (p)=>{
                    if (p.data?.kind !== "data") return null;
                    const dataRow = p.data;
                    const pend = massEditsRef.current[dataRow.id]?.title;
                    const orig = dataRow.title ?? "";
                    const value = pend !== undefined ? pend : orig;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee5d817149f79816$var$MassComplexCellShell, {
                        changed: pend !== undefined && pend !== orig,
                        onOpen: ()=>setMassTextTarget({
                                rowId: dataRow.id,
                                field: "title"
                            }),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-truncate",
                            children: value || "-"
                        })
                    });
                }
            };
            // Duration — write-once (HH:MM:SS). Edited through its own modal rather
            // than an inline input: the format is easy to get wrong and the cell has
            // no room to explain the mistake. Editable when unset, or once it has
            // been manually changed before; a system-populated duration that was
            // never manually edited shows a disabled pencil, mirroring Live.
            if (col.colId === "duration") return {
                ...base,
                cellRenderer: (p)=>{
                    if (p.data?.kind !== "data") return null;
                    const dataRow = p.data;
                    const pend = massEditsRef.current[dataRow.id]?.duration;
                    const orig = dataRow.duration ?? "";
                    const value = pend !== undefined ? pend : orig;
                    const locked = pend === undefined && !(0, $e353c670efa3bb12$export$a58c1d5525adff3f)(dataRow.duration, !!dataRow.durationEditedManually);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee5d817149f79816$var$MassComplexCellShell, {
                        changed: pend !== undefined && pend !== orig,
                        onOpen: ()=>setMassTextTarget({
                                rowId: dataRow.id,
                                field: "duration"
                            }),
                        disabled: locked,
                        disabledReason: (0, $7ba18110fd51242f$export$a67f5c23c74e5e60),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-truncate",
                            children: value || "-"
                        })
                    });
                }
            };
            const complexField = COMPLEX_FIELDS[col.colId ?? ""];
            if (complexField) return {
                ...base,
                cellRenderer: (p)=>{
                    if (p.data?.kind !== "data") return null;
                    const row = p.data;
                    const pend = massEditsRef.current[row.id]?.[complexField];
                    // Versions can only be edited, not added — a recording with no
                    // versions has nothing to edit, so it renders read-only (no edit
                    // affordance).
                    if (complexField === "version") {
                        const hasVersions = pend !== undefined ? pend.length > 0 : (row.versionsArray?.length ?? 0) > 0;
                        if (!hasVersions) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee5d817149f79816$var$MassCellShell, {
                            changed: false,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-textDove",
                                children: "-"
                            })
                        });
                    }
                    // Live is write-once: a descriptor that is already set can only be
                    // changed if it was manually changed before. A pending in-session
                    // edit keeps it open so the user can revise their own change.
                    const liveLocked = complexField === "live" && typeof pend !== "string" && !(0, $e353c670efa3bb12$export$a58c1d5525adff3f)((0, $e353c670efa3bb12$export$6a8f182e25b88c10)(row.live), !!row.liveEditedManually);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee5d817149f79816$var$MassComplexCellShell, {
                        changed: pend !== undefined,
                        onOpen: ()=>openMassFieldModal(row.id, complexField),
                        disabled: liveLocked,
                        disabledReason: (0, $7ba18110fd51242f$export$7e62e461b48ebca8),
                        children: $ee5d817149f79816$var$renderMassComplexContent(complexField, row, pend)
                    });
                }
            };
            // Release-level / non-editable columns: unchanged (aside from the
            // mass-mode filter strip applied in `base`).
            return base;
        });
    }, [
        bulkEditMode,
        massEditMode,
        columnDefs,
        toggleRowSelection,
        setMassCellEdit,
        openMassFieldModal
    ]);
    // Highlight row currently being edited, and visually indicate modified rows
    const getRowStyle = (0, $acw62.useCallback)((params)=>{
        if (params.data?.kind !== "data") return undefined;
        const row = params.data;
        const isBeingEdited = selectedRowForModal != null && row.id === selectedRowForModal.id;
        const isBulkSelected = bulkEditMode && selectedRowIdsRef.current.has(row.id);
        const hasManualEdits = row.hasManualChanges || row.isModified;
        const style = {};
        if (isBeingEdited) style.backgroundColor = "#262626";
        else if (isBulkSelected) // Slightly lighter background across the whole row when it is selected
        // for bulk editing.
        style.backgroundColor = "#2f2f2f";
        // Purple left line when the recording has any tracked manual edits
        // (sourced from the bulk manual-changes endpoint, contract 4.5.1).
        // We treat `isModified` (just-saved in this session) the same way so
        // optimistic edits get the same indicator as edits returned by the BE.
        // The indicator must persist while the row is being edited, otherwise
        // selecting a manually-changed recording would drop its purple line.
        if (hasManualEdits) style.boxShadow = (0, $0fd6d64054ffdc01$export$4a73c783bc3de3b9);
        return isBeingEdited || isBulkSelected || hasManualEdits ? style : undefined;
    }, [
        selectedRowForModal,
        bulkEditMode
    ]);
    // Everything the bulk-edit modal needs about the current selection: the
    // recordings the plan will target, the contributions & artists actually
    // present across them (so "Delete" and "Demote" can only offer real values),
    // and each artist's graph id — the pickers are name-based, but the contract
    // links artists by id.
    const bulkSelection = (0, $acw62.useMemo)(()=>{
        const contributions = new Set();
        const artists = new Set();
        const artistIdByName = {};
        const targets = [];
        let firstRow = null;
        rows.forEach((row)=>{
            if (!selectedRowIds.has(row.id)) return;
            if (!firstRow) firstRow = row;
            targets.push({
                recordingId: row.id,
                documentId: row.documentId
            });
            row.contributions?.forEach((c)=>{
                if (c.contribution) contributions.add(c.contribution);
            });
            // Prefer the structured artists — `row.artist` is a display string, so
            // splitting it is only a fallback for rows the API returned without ids.
            if (row.mainArtistsRaw && row.mainArtistsRaw.length > 0) row.mainArtistsRaw.forEach((item)=>{
                if (typeof item === "string") {
                    if (item.trim()) artists.add(item.trim());
                    return;
                }
                const artist = item;
                if (!artist.stageName) return;
                artists.add(artist.stageName);
                if (artist.id) artistIdByName[artist.stageName] = artist.id;
            });
            else if (row.artist) row.artist.split(",").map((name)=>name.trim()).filter(Boolean).forEach((name)=>artists.add(name));
        });
        return {
            contributions: Array.from(contributions).sort(),
            artists: Array.from(artists).sort(),
            artistIdByName: artistIdByName,
            targets: targets,
            firstRow: firstRow
        };
    }, [
        rows,
        selectedRowIds
    ]);
    /**
   * A bulk edit finished with at least one action applied.
   *
   * There is nothing to project optimistically the way mass edit does: the plan
   * is applied by set-based queries whose per-recording effect we don't model,
   * so the grid is refetched instead. The apply is synchronous and strongly
   * consistent (contract §6), so the refetch sees the change. A partial success
   * still lands here — data changed, so the grid must catch up — but the modal
   * stays open with the failed actions listed.
   */ const handleBulkEditApplied = (result)=>{
        fetchData();
        if (result.ok) exitBulkEditMode();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee5d817149f79816$var$EditRecordingModal, {
                isOpen: showEditModal,
                onClose: ()=>{
                    setShowEditModal(false);
                    setSelectedRowForModal(null);
                },
                row: selectedRowForModal,
                onSave: handleSaveModalEdit,
                userId: userId,
                availableFormats: (0, $491894d32f9e82de$export$8993785e14ab2dfb),
                availableTypes: (0, $0b4e1af42faad25c$export$6a2892aa4af64e1e),
                availableContributions: (0, $f50146991650bb90$export$a0305d43acfa6742),
                availableArtists: getAvailableValuesForColumn("artist") ?? []
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee5d817149f79816$var$ExportConfirmationModal, {
                isOpen: isOpenExportConfirmationModal,
                onClose: ()=>setIsOpenExportConfirmationModal(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b481426d4df6dccf$export$2e2bcd8739ae039), {
                isOpen: showBulkEditModal,
                onClose: ()=>setShowBulkEditModal(false),
                targets: bulkSelection.targets,
                availableArtists: getAvailableValuesForColumn("artist") ?? [],
                availableContributions: (0, $f50146991650bb90$export$a0305d43acfa6742),
                availableAliases: bulkClientAliases,
                assignedContributions: bulkSelection.contributions,
                assignedArtists: bulkSelection.artists,
                artistIdByName: bulkSelection.artistIdByName,
                userId: userId,
                releaseContextRow: bulkSelection.firstRow,
                availableFormats: (0, $491894d32f9e82de$export$8993785e14ab2dfb),
                availableTypes: (0, $0b4e1af42faad25c$export$6a2892aa4af64e1e),
                onApplied: handleBulkEditApplied
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02ae4f076c1d4517$export$2803f1e68ef5d8b6), {
                isOpen: showMassSummary,
                onClose: ()=>{
                    if (massSaving) return;
                    setShowMassSummary(false);
                    setMassApplyResult(null);
                },
                onConfirm: handleApplyMassEdits,
                edits: massEdits,
                rows: rows,
                onEditChange: handleSummaryEditChange,
                onRemoveChange: removeMassCellEdit,
                isSaving: massSaving,
                errorsByRecording: massApplyResult?.errorsByRecording,
                fatalError: massApplyResult?.fatalError
            }),
            massFieldTarget && (()=>{
                const targetRow = rows.find((r)=>r.id === massFieldTarget.rowId);
                if (!targetRow) return null;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ba18110fd51242f$export$d2f5a4651416d26c), {
                    field: massFieldTarget.field,
                    row: targetRow,
                    pending: massEdits[targetRow.id]?.[massFieldTarget.field],
                    availableContributions: (0, $f50146991650bb90$export$a0305d43acfa6742),
                    availableAliases: bulkClientAliases,
                    userId: userId,
                    onClose: ()=>setMassFieldTarget(null),
                    onSave: (field, value)=>handleMassFieldSave(targetRow, field, value),
                    onReassignIsrc: (reassignments)=>handleReassignIsrcs(targetRow.id, reassignments)
                });
            })(),
            massTextTarget && (()=>{
                const targetRow = rows.find((r)=>r.id === massTextTarget.rowId);
                if (!targetRow) return null;
                const field = massTextTarget.field;
                const pend = massEdits[targetRow.id]?.[field];
                if (field === "duration") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ba18110fd51242f$export$c8763191f5c97710), {
                    recordingTitle: targetRow.title || "(untitled)",
                    initial: pend !== undefined ? pend : targetRow.duration ?? "",
                    locked: pend === undefined && !(0, $e353c670efa3bb12$export$a58c1d5525adff3f)(targetRow.duration, !!targetRow.durationEditedManually),
                    onClose: ()=>setMassTextTarget(null),
                    onSave: (value)=>{
                        handleMassTextSave(targetRow, field, value);
                        setMassTextTarget(null);
                    }
                });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ba18110fd51242f$export$b6661608da11c63b), {
                    recordingTitle: targetRow.title || "(untitled)",
                    initial: pend !== undefined ? pend : targetRow.title ?? "",
                    onClose: ()=>setMassTextTarget(null),
                    onSave: (value)=>{
                        handleMassTextSave(targetRow, field, value);
                        setMassTextTarget(null);
                    }
                });
            })(),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `tw-flex tw-w-full tw-gap-4 ${showEditPanel && selectedRowForModal ? "tw-mr-[calc(min(520px,95vw)+1rem)]" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        ref: mainContentColumnRef,
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex-1 tw-min-w-0 tw-flex tw-flex-col tw-gap-6", showEditPanel && selectedRowForModal && "tw-pr-[calc(min(520px,95vw)+1rem)]"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-mb-6",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "link-secondary",
                                    icon: "chevron-left",
                                    onClick: ()=>{
                                        window.history.back();
                                    },
                                    label: "Back"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-flex-col tw-gap-2 tw-w-full",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-flex-col tw-justify-between tw-w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    children: `${clientPersonalInfo?.firstName} ${clientPersonalInfo?.lastName}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex-grow tw-flex tw-items-end tw-gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $814c1923bdb44d7d$export$3695c2f14e8c6908), {
                                                        data: confidenceStats ? transformConfidenceStatsToChartData(confidenceStats) : [],
                                                        onFilterChange: handleConfidenceFilterChange
                                                    }),
                                                    !bulkEditMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "tw-justify-self-end tw-mb-[18px]",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                            variant: "secondary",
                                                            label: "Export Discography",
                                                            icon: "export",
                                                            disabled: isPendingExportGeneration,
                                                            onClick: handleGenerateExport
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-bg-surfaceBlack90 tw-p-6 tw-text-white tw-rounded-2xl tw-max-w-full IS_W_CONTAINER",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-flex tw-justify-between tw-items-center tw-min-h-[48px]",
                                                children: bulkEditMode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-items-center tw-gap-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "tw-text-white tw-text-base tw-font-semibold",
                                                                    children: "Bulk edit"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "tw-text-sm tw-text-textDove",
                                                                    children: [
                                                                        selectedRowIds.size,
                                                                        " selected"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "primary",
                                                                    label: "Edit",
                                                                    icon: "edit",
                                                                    disabled: selectedRowIds.size === 0,
                                                                    onClick: ()=>setShowBulkEditModal(true)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "secondary",
                                                                    label: "Cancel",
                                                                    onClick: exitBulkEditMode
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : massEditMode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-items-center tw-gap-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "tw-text-white tw-text-base tw-font-semibold",
                                                                    children: "Mass edit"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "tw-text-sm tw-text-textDove",
                                                                    children: [
                                                                        massEditFieldCount,
                                                                        " pending change",
                                                                        massEditFieldCount === 1 ? "" : "s"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "primary",
                                                                    label: "Save",
                                                                    disabled: massEditFieldCount === 0,
                                                                    onClick: ()=>setShowMassSummary(true)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "secondary",
                                                                    label: "Cancel",
                                                                    onClick: exitMassEditMode
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-flex-col tw-gap-2 tw-w-1/2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "tw-relative",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "tw-relative",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                                className: `wi wi-20px wi-search tw-absolute tw-left-3 tw-top-[14px]`
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-12", "tw-placeholder-textSeal", "tw-text-sm", "tw-leading-5", "tw-p-3", "tw-pl-9", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none"),
                                                                                id: "discography-search",
                                                                                type: "text",
                                                                                value: searchTerm,
                                                                                onChange: (e)=>setSearchTerm(e.target.value),
                                                                                placeholder: "Search discography...",
                                                                                autoComplete: "off"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    searchTerm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: ()=>setSearchTerm(""),
                                                                        className: "tw-absolute tw-right-2 tw-top-1/2 -tw-translate-y-1/2 tw-text-neutral-400 hover:tw-text-white tw-transition-colors",
                                                                        "aria-label": "Clear search",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                            className: "tw-w-4 tw-h-4"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-gap-2",
                                                            children: [
                                                                $ee5d817149f79816$var$BULK_EDIT_ENABLED && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "primary",
                                                                    label: "Bulk Edit",
                                                                    icon: "edit",
                                                                    onClick: enterBulkEditMode
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "secondary",
                                                                    label: "Expand/Collapse All",
                                                                    onClick: ()=>{
                                                                        if (hasAnyExpandedRows) collapseAllRows();
                                                                        else expandAllRows();
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee5d817149f79816$var$CombinedColumnVisibilityDropdown, {
                                                                    gridApi: gridApiRef.current,
                                                                    columnDefs: columnDefs,
                                                                    detailColumnDefs: detailColumnDefsForVisibility,
                                                                    onDetailColumnVisibilityChange: handleDetailColumnVisibilityChange,
                                                                    detailVisibleColumns: detailVisibleColumns
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "secondary",
                                                                    label: "Reset Sort",
                                                                    onClick: resetSortOrder
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                    variant: "secondary",
                                                                    label: "Reset Filters",
                                                                    onClick: resetFilters
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-h-[500px] tw-relative",
                                                        children: [
                                                            copyFeedback && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                role: "status",
                                                                "aria-live": "polite",
                                                                className: "tw-absolute tw-bottom-4 tw-left-1/2 -tw-translate-x-1/2 tw-z-50 tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-bg-neutral-800 tw-px-4 tw-py-2 tw-text-sm tw-text-white tw-shadow-lg tw-pointer-events-none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                                        className: "tw-w-4 tw-h-4 tw-text-green-400"
                                                                    }),
                                                                    copyFeedback
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e439ae7301dd858$export$4074462c5969a5d8), {
                                                                theme: $ee5d817149f79816$var$myTheme,
                                                                rowData: gridRows,
                                                                columnDefs: effectiveColumnDefs,
                                                                defaultColDef: defaultColDef,
                                                                pagination: false,
                                                                onSortChanged: handleSortChanged,
                                                                onFilterChanged: handleFilterChanged,
                                                                onGridReady: handleGridReady,
                                                                onCellClicked: handleCellClicked,
                                                                postSortRows: handlePostSortRows,
                                                                getRowId: getRowId,
                                                                getRowHeight: getRowHeight,
                                                                getRowStyle: getRowStyle,
                                                                masterDetail: true,
                                                                animateRows: true,
                                                                domLayout: "normal",
                                                                multiSortKey: "ctrl",
                                                                loading: isLoading && rows.length === 0,
                                                                isExternalFilterPresent: ()=>{
                                                                    // Tell AG Grid that filtering is handled server-side
                                                                    // Check if any filters are active (fieldFilters, searchTerm, or confidenceCategory)
                                                                    return fieldFilters.length > 0 || debouncedSearchTerm.length > 0 || selectedConfidenceCategory !== null;
                                                                },
                                                                doesExternalFilterPass: ()=>{
                                                                    // Since filtering is handled server-side, always return true
                                                                    // The backend has already filtered the data, so we show all rows returned
                                                                    return true;
                                                                },
                                                                overlayNoRowsTemplate: loadingError ? '<div class="ag-overlay-no-rows-center" style="color: white;"><h5>Error loading data</h5></div>' : debouncedSearchTerm || selectedConfidenceCategory ? '<div class="ag-overlay-no-rows-center" style="color: white;"><h5>The filters did not match any data</h5></div>' : '<div class="ag-overlay-no-rows-center" style="color: white;"><h5>No data available currently</h5></div>'
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618f8aff4a5696a2$export$2e2bcd8739ae039), {
                                                                active: isLoading && rows.length > 0
                                                            })
                                                        ]
                                                    }),
                                                    recordingsCount > 0 && !bulkEditMode && !massEditMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee5d817149f79816$var$DataTablePagination, {
                                                        currentPage: page,
                                                        totalRows: recordingsCount,
                                                        rowsPerPage: rowsPerPage,
                                                        onPageChange: (newPage)=>{
                                                            setPage(newPage);
                                                        },
                                                        onRowsPerPageChange: (newRowsPerPage)=>{
                                                            setRowsPerPage(newRowsPerPage);
                                                            setPage(1);
                                                        },
                                                        onGoToLastPage: skipToLastPage
                                                    }),
                                                    bulkEditMode && rows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-mt-3 tw-text-sm tw-text-textDove",
                                                        children: [
                                                            "Showing all ",
                                                            rows.length,
                                                            " recording",
                                                            rows.length === 1 ? "" : "s",
                                                            " on a single page."
                                                        ]
                                                    }),
                                                    massEditMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-mt-3 tw-text-sm tw-text-textDove",
                                                        children: [
                                                            "Mass editing ",
                                                            rows.length,
                                                            " recording",
                                                            rows.length === 1 ? "" : "s",
                                                            " on this page. Save or cancel to continue browsing."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    showEditPanel && selectedRowForModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
                        className: "tw-fixed tw-right-0 tw-w-[min(520px,95vw)] tw-border-l tw-border-gray-600 tw-bg-surfaceBlack90 tw-flex tw-flex-col tw-overflow-hidden tw-rounded-l-2xl tw-z-10",
                        style: {
                            boxShadow: "-4px 0 12px rgba(0,0,0,0.15)",
                            ...panelBounds ? {
                                top: panelBounds.top,
                                height: panelBounds.height
                            } : {
                                top: 64,
                                height: "calc(100vh - 124px)"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-items-center tw-justify-between tw-p-3 tw-border-b tw-border-gray-600 tw-flex-shrink-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "tw-text-white tw-text-base tw-font-semibold",
                                        children: "Edit Recording"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                variant: "secondary",
                                                label: "Full screen",
                                                onClick: ()=>setShowEditModal(true)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                variant: "secondary",
                                                label: "Close",
                                                onClick: ()=>{
                                                    setShowEditPanel(false);
                                                    setSelectedRowForModal(null);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex-1 tw-overflow-y-auto tw-min-h-0",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c320e41e081b01e$export$92bd65961bd57ee8), {
                                    ref: editFormRef,
                                    row: selectedRowForModal,
                                    onSave: (r, reassignedIsrcs)=>{
                                        handleSaveModalEdit(r, reassignedIsrcs);
                                    // Keep the panel open after save (form drops back to
                                    // read-only on its own).
                                    },
                                    onCancel: ()=>{
                                        setShowEditPanel(false);
                                        setSelectedRowForModal(null);
                                    },
                                    stacked: true,
                                    hideFooter: true,
                                    userId: userId,
                                    availableFormats: (0, $491894d32f9e82de$export$8993785e14ab2dfb),
                                    availableTypes: (0, $0b4e1af42faad25c$export$6a2892aa4af64e1e),
                                    availableContributions: (0, $f50146991650bb90$export$a0305d43acfa6742),
                                    availableArtists: getAvailableValuesForColumn("artist") ?? []
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                        isOpen: pendingSwitchRow !== null,
                        onClose: ()=>setPendingSwitchRow(null),
                        title: "Discard unsaved changes?",
                        modalClasses: "tw-max-w-md tw-w-full tw-mx-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-mt-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-white tw-text-sm tw-mb-6",
                                    children: "You have unsaved changes on this recording. Switching to another recording will discard them."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-justify-end tw-gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                            variant: "secondary",
                                            label: "Continue editing",
                                            onClick: ()=>setPendingSwitchRow(null)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                            variant: "primary",
                                            label: "Discard changes",
                                            onClick: ()=>{
                                                const next = pendingSwitchRow;
                                                setPendingSwitchRow(null);
                                                if (next) {
                                                    setSelectedRowForModal(next);
                                                    setShowEditPanel(true);
                                                }
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
const $ee5d817149f79816$var$EditRecordingModal = ({ isOpen: isOpen, onClose: onClose, row: row, onSave: onSave, userId: userId, availableFormats: availableFormats = [], availableTypes: availableTypes = [], availableContributions: availableContributions = [], availableArtists: availableArtists = [] })=>{
    if (!isOpen || !row) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: onClose,
        title: "Edit Recording Details",
        modalClasses: "tw-max-w-5xl tw-w-full tw-max-h-[90vh] tw-flex tw-flex-col tw-bg-gray-900 tw-overflow-hidden tw-mx-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex-1 tw-overflow-hidden tw-flex tw-flex-col tw-min-h-0",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c320e41e081b01e$export$92bd65961bd57ee8), {
                row: row,
                onSave: (r, reassignedIsrcs)=>{
                    // Keep the modal open after save — the form drops back to
                    // read-only mode on its own. The user closes it explicitly.
                    onSave(r, reassignedIsrcs);
                },
                onCancel: onClose,
                userId: userId,
                availableFormats: availableFormats,
                availableTypes: availableTypes,
                availableContributions: availableContributions,
                availableArtists: availableArtists
            })
        })
    });
};
const $ee5d817149f79816$var$ExportConfirmationModal = ({ isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: onClose,
        title: "",
        hasCloseButton: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-pb-8",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
                title: "Discography Export In Progress",
                description: "Once complete, a download link will appear as a task on your dashboard."
            })
        })
    });
};
const $ee5d817149f79816$var$DataTablePagination = ({ currentPage: currentPage, totalRows: totalRows, rowsPerPage: rowsPerPage, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, onGoToLastPage: onGoToLastPage })=>{
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const startRow = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
    const endRow = Math.min(currentPage * rowsPerPage, totalRows);
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage >= totalPages;
    // Calculate which page numbers to show
    const getPageNumbers = ()=>{
        const pages = [];
        const maxVisiblePages = 7;
        if (totalPages <= maxVisiblePages) // Show all pages if total is less than max
        for(let i = 1; i <= totalPages; i++)pages.push(i);
        else {
            // Always show first page
            pages.push(1);
            if (currentPage <= 3) {
                // Show first few pages
                for(let i = 2; i <= 4; i++)pages.push(i);
                pages.push("ellipsis");
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                // Show last few pages
                pages.push("ellipsis");
                for(let i = totalPages - 3; i <= totalPages; i++)pages.push(i);
            } else {
                // Show pages around current
                pages.push("ellipsis");
                for(let i = currentPage - 1; i <= currentPage + 1; i++)pages.push(i);
                pages.push("ellipsis");
                pages.push(totalPages);
            }
        }
        return pages;
    };
    const pageNumbers = getPageNumbers();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-items-center tw-justify-between tw-mt-4 tw-text-white tw-text-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-items-center tw-gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-neutral-400",
                        children: "Rows per page:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        value: rowsPerPage,
                        onChange: (e)=>onRowsPerPageChange(Number(e.target.value)),
                        className: "tw-bg-[#151719] tw-border tw-border-[#535D66] tw-rounded tw-px-2 tw-py-1 tw-text-white focus:tw-outline-none focus:tw-border-[#4a5056]",
                        children: [
                            25,
                            50,
                            100,
                            500
                        ].map((size)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: size,
                                children: size
                            }, size))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-items-center tw-gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "tw-text-neutral-400 tw-text-sm",
                        children: [
                            startRow,
                            "-",
                            endRow,
                            " of ",
                            totalRows
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$68f5e1453c188a82), {
                        className: "[&&]:tw-w-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c814d8d13fd9d633$export$e3c2252a821bad58), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c814d8d13fd9d633$export$389c2523d2fb7ac8), {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            if (!isFirstPage) onPageChange(1);
                                        },
                                        className: isFirstPage ? "tw-pointer-events-none tw-opacity-50" : "tw-cursor-pointer tw-gap-1 tw-px-2.5",
                                        size: "default",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4551b311634241de$export$2e2bcd8739ae039), {
                                                className: "tw-h-4 tw-w-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-hidden sm:tw-inline-block",
                                                children: "First"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c38bddd65ea050e7), {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            if (!isFirstPage) onPageChange(currentPage - 1);
                                        },
                                        className: isFirstPage ? "tw-pointer-events-none tw-opacity-50" : "tw-cursor-pointer"
                                    })
                                }),
                                pageNumbers.map((pageNum, index)=>{
                                    if (pageNum === "ellipsis") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-px-2 tw-text-neutral-400",
                                            children: "..."
                                        })
                                    }, `ellipsis-${index}`);
                                    const pageNumber = pageNum;
                                    const isActive = pageNumber === currentPage;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$389c2523d2fb7ac8), {
                                            href: "#",
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                if (!isActive) onPageChange(pageNumber);
                                            },
                                            style: {
                                                color: isActive ? "black" : "white"
                                            },
                                            className: isActive ? "tw-bg-white tw-text-black tw-pointer-events-none" : "tw-cursor-pointer",
                                            size: "default",
                                            children: pageNumber
                                        })
                                    }, pageNumber);
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$ef9c8bfc54489a24), {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            if (!isLastPage) onPageChange(currentPage + 1);
                                        },
                                        className: isLastPage ? "tw-pointer-events-none tw-opacity-50" : "tw-cursor-pointer"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c814d8d13fd9d633$export$389c2523d2fb7ac8), {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            if (!isLastPage) onGoToLastPage();
                                        },
                                        className: isLastPage ? "tw-pointer-events-none tw-opacity-50" : "tw-cursor-pointer tw-gap-1 tw-px-2.5",
                                        size: "default",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-hidden sm:tw-inline-block",
                                                children: "Last"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f09bbb993f3fef38$export$2e2bcd8739ae039), {
                                                className: "tw-h-4 tw-w-4"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $ee5d817149f79816$export$2e2bcd8739ae039 = $ee5d817149f79816$var$MasterDiscography;




var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");






function $6d28b75b57ba2a0c$var$Sidebar({ isCollapsed: isCollapsed, onToggle: onToggle }) {
    const selectedDashboardPath = (0, $edd541b4e0018444$export$aa84995bf48f6cf0)();
    const currentPath = location.pathname;
    const isDashboardPage = new RegExp(`^${selectedDashboardPath}$`).test(currentPath);
    const classes = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
        "tw-text-textLime": isDashboardPage
    }, {
        "tw-text-textWhite": !isDashboardPage
    }, "tw-cursor-pointer", "tw-hover:text-textLime", isCollapsed && "tw-sr-only");
    const discographyAdditionalPaths = [
        "registrations",
        "discography"
    ];
    const settingsAdditionalPaths = [
        "society-config"
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-h-full tw-flex tw-flex-col tw-text-white tw-border-r-outlineGraphite",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-p-4", isCollapsed && "tw-px-3 tw-py-4"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-pb-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-justify-between", isCollapsed && "tw-justify-center"),
                            children: [
                                !isCollapsed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($99b5763031ccc1a7$exports))),
                                    alt: "Westbury Music Logo",
                                    width: "151"
                                }),
                                isCollapsed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($99b5763031ccc1a7$exports))),
                                    alt: "Westbury Music",
                                    className: "tw-h-8 tw-w-8 tw-object-contain"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `${selectedDashboardPath}`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-space-x-2", isCollapsed && "tw-justify-center tw-space-x-0"),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi", "wi-sm", "wi-home", {
                                                "tw-text-textLime": isDashboardPage
                                            }, {
                                                "tw-text-textWhite": !isDashboardPage
                                            }, "tw-cursor-pointer")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: classes,
                                            children: "Dashboard"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                label: "Clients",
                                to: "/clients",
                                icon: "users",
                                compact: isCollapsed
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                label: "Discography",
                                to: "/discography",
                                icon: "speakers",
                                additionalPaths: discographyAdditionalPaths,
                                compact: isCollapsed
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                label: "Distribution",
                                to: "/distribution",
                                icon: "gbp",
                                variant: "disabled",
                                compact: isCollapsed
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-border-t tw-border-textGraphite tw-pt-8 tw-space-x-8",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                        label: "Settings",
                                        to: "/settings",
                                        icon: "settings",
                                        additionalPaths: settingsAdditionalPaths,
                                        compact: isCollapsed
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                        label: "Messages",
                                        to: "/messages",
                                        icon: "email",
                                        variant: "disabled",
                                        compact: isCollapsed
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-mt-auto tw-border-t tw-border-textGraphite tw-p-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onToggle,
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-justify-center tw-w-full tw-py-2 tw-rounded tw-text-white tw-bg-transparent hover:tw-bg-white/10 tw-transition-colors", isCollapsed && "tw-justify-center"),
                    title: isCollapsed ? "Expand sidebar" : "Collapse sidebar",
                    "aria-label": isCollapsed ? "Expand sidebar" : "Collapse sidebar",
                    children: isCollapsed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                        className: "tw-h-5 tw-w-5"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                className: "tw-h-5 tw-w-5 tw-mr-1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-sm",
                                children: "Collapse"
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var $6d28b75b57ba2a0c$export$2e2bcd8739ae039 = $6d28b75b57ba2a0c$var$Sidebar;



function $3960585a5a16564f$var$PageLayout({ children: children }) {
    const [sidebarSmall, setSidebarSmall] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-h-screen tw-flex tw-flex-col tw-bg-surfaceBlack80",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ab845b8dc308a3a$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-grow tw-pb-[60px] tw-bg-surfaceBlack80",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
                        className: `tw-shrink-0 tw-bg-surfaceBlack80 tw-transition-[width] tw-duration-200 tw-ease-out tw-overflow-hidden ${sidebarSmall ? "tw-w-16" : "tw-w-[218px]"}`,
                        style: {
                            borderRight: "1px solid #535D66"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d28b75b57ba2a0c$export$2e2bcd8739ae039), {
                            isCollapsed: sidebarSmall,
                            onToggle: ()=>setSidebarSmall((prev)=>!prev)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                        className: "tw-flex-1 tw-min-w-0 tw-bg-surfaceBlack80 tw-pl-6",
                        style: {
                            maxWidth: sidebarSmall ? "none" : "1580px"
                        },
                        children: [
                            " ",
                            children
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-bg-surfaceBlack90",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f92545aa51ff06d8$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $3960585a5a16564f$export$2e2bcd8739ae039 = $3960585a5a16564f$var$PageLayout;














// Register all Community features
(0, $437b23f6a393c3bf$export$dc053975cc7f6c11).registerModules([
    (0, $437b23f6a393c3bf$export$526323caf9d1af13)
]);
// to use myTheme in an application, pass it to the theme grid option
const $6a458b07a6d42853$var$myTheme = (0, $437b23f6a393c3bf$export$495b90cf446940a1).withParams({
    backgroundColor: "#151719",
    browserColorScheme: "dark",
    chromeBackgroundColor: "#151719",
    foregroundColor: "#FFFFFF",
    headerFontSize: 14,
    headerFontWeight: "bold",
    headerRowBorder: false,
    wrapperBorder: false
});
// Map ag-grid column IDs to API sort fields
const $6a458b07a6d42853$var$GRID_SORT_TO_API_FIELD = {
    artist: "parentRecording.bandArtistName.raw",
    title: "parentRecording.recordingTitle.raw",
    release: "earliestParentRelease.releaseTitle.raw",
    year: "earliestParentRelease.dateReleased",
    format: "earliestParentRelease.format",
    type: "earliestParentRelease.mediaType",
    stageName: "persona.stageName",
    live: "parentRecording.live",
    contributions: "westburyContributions.contribution",
    isrcs: "parentRecording.isrcs",
    duration: "parentRecording.duration",
    featured: "performance.featuredStatus",
    collaborators: "parentRecording.bandArtistName.raw",
    version: "parentRecording.recordingVersion"
};
// Map ag-grid column IDs to API filter field names
const $6a458b07a6d42853$var$GRID_COL_TO_API_FILTER_FIELD = {
    artist: "parentRecording.bandArtistName.raw",
    version: "parentRecording.recordingVersion",
    contributions: "westburyContributions.contribution",
    release: "earliestParentRelease.releaseTitle.raw",
    year: "earliestParentRelease.dateReleased",
    live: "parentRecording.live",
    title: "parentRecording.recordingTitle.raw",
    isrcs: "parentRecording.isrcs",
    stageName: "persona.stageName",
    type: "earliestParentRelease.mediaType",
    format: "earliestParentRelease.format",
    catNumbers: "earliestParentRelease.catNumbers",
    label: "earliestParentRelease.releaseLabels",
    featured: "performance.featuredStatus"
};
// Default sort order: Format, Year of Release, Live, Release, Version, Recording Title, Artist
const $6a458b07a6d42853$var$DEFAULT_SORT_MODEL = [
    // { colId: 'format', sort: 'asc' },
    {
        colId: "year",
        sort: "asc"
    },
    {
        colId: "live",
        sort: "asc"
    },
    {
        colId: "release",
        sort: "asc"
    },
    {
        colId: "version",
        sort: "asc"
    },
    {
        colId: "title",
        sort: "asc"
    },
    {
        colId: "artist",
        sort: "asc"
    }
];
// Map DetailGrid field names to main grid column IDs
const $6a458b07a6d42853$var$DETAIL_FIELD_TO_MAIN_COL_ID = {
    collaborators: "artist",
    format: "format",
    type: "type",
    stageName: "stageName"
};
// Combined Column Visibility Dropdown Component
const $6a458b07a6d42853$var$CombinedColumnVisibilityDropdown = ({ gridApi: gridApi, columnDefs: columnDefs, detailColumnDefs: detailColumnDefs, onDetailColumnVisibilityChange: onDetailColumnVisibilityChange, detailVisibleColumns: detailVisibleColumns })=>{
    const [visibleColumns, setVisibleColumns] = (0, $acw62.useState)(()=>{
        // Initialize with all non-hidden columns
        const visible = new Set();
        columnDefs.forEach((col)=>{
            if (col.colId && !col.hide) visible.add(col.colId);
        });
        return visible;
    });
    // Update visible columns when columnDefs change
    (0, $acw62.useEffect)(()=>{
        if (!gridApi) return;
        const columnState = gridApi.getColumnState();
        const newVisible = new Set();
        columnState.forEach((col)=>{
            if (col.colId && !col.hide) newVisible.add(col.colId);
        });
        setVisibleColumns(newVisible);
    }, [
        gridApi,
        columnDefs
    ]);
    const toggleMainColumnVisibility = (colId)=>{
        if (!gridApi || !colId) return;
        const isVisible = visibleColumns.has(colId);
        const newVisible = new Set(visibleColumns);
        if (isVisible) newVisible.delete(colId);
        else newVisible.add(colId);
        setVisibleColumns(newVisible);
        gridApi.setColumnsVisible([
            colId
        ], !isVisible);
    };
    const toggleDetailColumnVisibility = (field)=>{
        const isVisible = detailVisibleColumns.has(field);
        onDetailColumnVisibilityChange(field, !isVisible);
    };
    // Filter out expand column and get displayable columns
    const displayableMainColumns = columnDefs.filter((col)=>col.colId && col.colId !== "expand");
    const displayableDetailColumns = detailColumnDefs.filter((col)=>col.field);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f48ae8c4ad4b8a8$export$2e2bcd8739ae039), {
        trigger: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            variant: "secondary",
            label: "Show/Hide Data"
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-min-w-[200px] tw-max-h-[500px] tw-overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-px-2 tw-py-2 tw-text-xs tw-font-semibold tw-text-neutral-400 tw-uppercase tw-tracking-wide",
                    children: "Top-Level"
                }),
                displayableMainColumns.map((col)=>{
                    const colId = col.colId;
                    const isVisible = visibleColumns.has(colId);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "button",
                        tabIndex: 0,
                        className: "tw-px-2 tw-py-2 tw-cursor-pointer hover:tw-bg-neutral-800 tw-flex tw-items-center tw-gap-2",
                        onClick: ()=>toggleMainColumnVisibility(colId),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                toggleMainColumnVisibility(colId);
                            }
                        },
                        children: [
                            isVisible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                className: "tw-w-4 tw-h-4 tw-text-white"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                className: "tw-w-4 tw-h-4 tw-text-neutral-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: isVisible ? "tw-text-white" : "tw-text-neutral-500",
                                children: col.headerName || colId
                            })
                        ]
                    }, `main-${colId}`);
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-px-2 tw-py-1 tw-border-t tw-border-neutral-700 tw-my-1"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-px-2 tw-py-2 tw-text-xs tw-font-semibold tw-text-neutral-400 tw-uppercase tw-tracking-wide",
                    children: "Sub-Level"
                }),
                displayableDetailColumns.map((col)=>{
                    const field = col.field;
                    const isVisible = detailVisibleColumns.has(field);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "button",
                        tabIndex: 0,
                        className: "tw-px-2 tw-py-2 tw-cursor-pointer hover:tw-bg-neutral-800 tw-flex tw-items-center tw-gap-2",
                        onClick: ()=>toggleDetailColumnVisibility(field),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                toggleDetailColumnVisibility(field);
                            }
                        },
                        children: [
                            isVisible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                className: "tw-w-4 tw-h-4 tw-text-white"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                className: "tw-w-4 tw-h-4 tw-text-neutral-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: isVisible ? "tw-text-white" : "tw-text-neutral-500",
                                children: col.headerName || field
                            })
                        ]
                    }, `detail-${field}`);
                })
            ]
        })
    });
};
// Detail grid component
const $6a458b07a6d42853$var$DetailGrid = ({ row: row, onSortChange: onSortChange, rowId: rowId, onGridReady: onGridReady, visibleColumns: visibleColumns })=>{
    const detailGridApiRef = (0, $acw62.useRef)(null);
    const detailColumnDefs = (0, $acw62.useMemo)(()=>[
            {
                headerName: "Artist",
                hide: true,
                field: "artist",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Recording Title",
                hide: true,
                field: "title",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Version",
                hide: true,
                field: "version",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Contributions",
                hide: true,
                field: "contributions",
                minWidth: 150,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                cellRenderer: (params)=>{
                    if (!params.data) return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-gap-2",
                        children: params.data.contributions.map((contribution)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca4bfbde716b69b9$export$733e49a0308b4cd), {
                                contribution: contribution
                            }, contribution.contribution))
                    });
                }
            },
            {
                headerName: "ISRCs",
                hide: true,
                field: "isrcs",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Release",
                hide: true,
                field: "release",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Year",
                hide: true,
                field: "year",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Duration",
                hide: true,
                field: "duration",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Live",
                hide: true,
                field: "isLive",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Collaborators",
                field: "collaborators",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Label",
                field: "label",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Catalogue Number",
                field: "catNumbers",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Format",
                field: "format",
                minWidth: 100,
                sortable: true,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Type",
                field: "type",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Stage Name",
                field: "stageName",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Featured",
                field: "isFeatured",
                minWidth: 100,
                sortable: false,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                cellRenderer: (params)=>{
                    if (!params.data) return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi wi-xs", {
                                "wi-check": params.data.isFeatured,
                                "wi-close": !params.data.isFeatured
                            })
                        })
                    });
                }
            }
        ], []);
    const detailRowData = (0, $acw62.useMemo)(()=>[
            {
                artist: row.artist || "\u2014",
                title: row.title || "\u2014",
                version: row.version || "\u2014",
                contributions: row.contributions || "\u2014",
                isrcs: row.isrcs || "\u2014",
                release: row.release || "\u2014",
                year: row.year || "\u2014",
                duration: row.duration || "\u2014",
                type: row.mediaType || "\u2014",
                stageName: row.stageName || "\u2014",
                isLive: row.isLive || false,
                isFeatured: row.isFeatured || false,
                collaborators: row.collaborators || "\u2014",
                label: row.label || "\u2014",
                catNumbers: row.catNumbers || "\u2014",
                format: row.format || "\u2014"
            }
        ], [
        row
    ]);
    const detailDefaultColDef = (0, $acw62.useMemo)(()=>({
            sortable: true,
            resizable: true,
            suppressMenu: true,
            suppressMovable: false,
            sortingOrder: [
                "asc",
                "desc",
                null
            ]
        }), []);
    const handleDetailSortChanged = (0, $acw62.useCallback)((event)=>{
        if (!event.api || !onSortChange) return;
        const sortedColumns = event.api.getColumnState().filter((col)=>col.sort && col.sortIndex !== null && col.sortIndex !== undefined).sort((a, b)=>(a.sortIndex ?? 0) - (b.sortIndex ?? 0));
        // Get the primary sorted column (first one)
        const primaryColumn = sortedColumns[0];
        if (primaryColumn && primaryColumn.colId) {
            const mainColId = $6a458b07a6d42853$var$DETAIL_FIELD_TO_MAIN_COL_ID[primaryColumn.colId];
            if (mainColId && primaryColumn.sort) // Trigger sort in main grid
            onSortChange(mainColId, primaryColumn.sort);
        } else sortedColumns.length;
    }, [
        onSortChange
    ]);
    const handleDetailGridReady = (0, $acw62.useCallback)((params)=>{
        detailGridApiRef.current = params.api;
        if (onGridReady) onGridReady(rowId, params.api);
        // Apply initial column visibility
        detailColumnDefs.forEach((colDef)=>{
            if (colDef.field) {
                const shouldBeVisible = visibleColumns.has(colDef.field);
                params.api.setColumnsVisible([
                    colDef.field
                ], shouldBeVisible);
            }
        });
    }, [
        onGridReady,
        rowId,
        detailColumnDefs,
        visibleColumns
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "detail-grid-wrapper tw-w-full tw-h-full tw-rounded-b tw-p-3",
        style: {
            width: "100%",
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                height: "60px",
                width: "100%",
                overflow: "hidden"
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e439ae7301dd858$export$4074462c5969a5d8), {
                rowData: detailRowData,
                columnDefs: detailColumnDefs,
                defaultColDef: detailDefaultColDef,
                headerHeight: 30,
                rowHeight: 30,
                domLayout: "normal",
                suppressHorizontalScroll: false,
                onSortChanged: handleDetailSortChanged,
                onGridReady: handleDetailGridReady,
                alwaysMultiSort: false,
                suppressRowHoverHighlight: true
            })
        })
    });
};
function $6a458b07a6d42853$var$MasterDiscography() {
    const { userId: userId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [clientPersonalInfo, setClientPersonalInfo] = (0, $acw62.useState)();
    const [isPendingExportGeneration, setIsPendingExportGeneration] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [loadingError, setLoadingError] = (0, $acw62.useState)(false);
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [images, setImages] = (0, $acw62.useState)({});
    const [confidenceStats, setConfidenceStats] = (0, $acw62.useState)(null);
    const [selectedConfidenceCategory, setSelectedConfidenceCategory] = (0, $acw62.useState)(null);
    const [availableFilters, setAvailableFilters] = (0, $acw62.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = (0, $acw62.useState)("");
    const [page, setPage] = (0, $acw62.useState)(1);
    const [rowsPerPage, setRowsPerPage] = (0, $acw62.useState)(50);
    const [recordingsCount, setRecordingsCount] = (0, $acw62.useState)(0);
    const [isOpenExportConfirmationModal, setIsOpenExportConfirmationModal] = (0, $acw62.useState)(false);
    const [showEditModal, setShowEditModal] = (0, $acw62.useState)(false);
    const [showEditPanel, setShowEditPanel] = (0, $acw62.useState)(false);
    const [selectedRowForModal, setSelectedRowForModal] = (0, $acw62.useState)(null);
    const mainContentColumnRef = (0, $acw62.useRef)(null);
    const editFormRef = (0, $acw62.useRef)(null);
    const [panelBounds, setPanelBounds] = (0, $acw62.useState)(null);
    const sortFieldsRef = (0, $acw62.useRef)([]);
    const [sortFields, setSortFields] = (0, $acw62.useState)(()=>{
        // Build default sortFields from DEFAULT_SORT_MODEL
        const defaultSortFields = $6a458b07a6d42853$var$DEFAULT_SORT_MODEL.map((item)=>{
            const apiField = $6a458b07a6d42853$var$GRID_SORT_TO_API_FIELD[item.colId];
            if (apiField && item.sort) return {
                field: apiField,
                order: item.sort === "desc" ? "desc" : "asc"
            };
            return null;
        }).filter((item)=>item !== null);
        sortFieldsRef.current = defaultSortFields;
        return defaultSortFields;
    });
    const [fieldFilters, setFieldFilters] = (0, $acw62.useState)([]);
    const [expandedRowIds, setExpandedRowIds] = (0, $acw62.useState)(()=>new Set());
    const gridApiRef = (0, $acw62.useRef)(null);
    const prevDebouncedSearchTermRef = (0, $acw62.useRef)("");
    const isInitialMountRef = (0, $acw62.useRef)(true);
    const isApplyingInitialSortRef = (0, $acw62.useRef)(false);
    // Serialize arrays for stable dependency comparison
    const sortFieldsKey = (0, $acw62.useMemo)(()=>JSON.stringify(sortFields), [
        sortFields
    ]);
    const fieldFiltersKey = (0, $acw62.useMemo)(()=>JSON.stringify(fieldFilters), [
        fieldFilters
    ]);
    // Track detail grid APIs for column visibility control
    const detailGridApiRefs = (0, $acw62.useRef)(new Map());
    // Measure main content column so the side panel height matches the table area
    (0, $acw62.useEffect)(()=>{
        if (!showEditPanel || !selectedRowForModal || !mainContentColumnRef.current) {
            setPanelBounds(null);
            return;
        }
        const el = mainContentColumnRef.current;
        const updateBounds = ()=>{
            const rect = el.getBoundingClientRect();
            setPanelBounds({
                top: rect.top,
                height: rect.height
            });
        };
        updateBounds();
        const ro = new ResizeObserver(updateBounds);
        ro.observe(el);
        return ()=>ro.disconnect();
    }, [
        showEditPanel,
        selectedRowForModal
    ]);
    // Detail grid column visibility state - initialized from detailColumnDefs
    const detailColumnDefsForVisibility = (0, $acw62.useMemo)(()=>[
            {
                headerName: "Artist",
                hide: true,
                field: "artist"
            },
            {
                headerName: "Recording Title",
                hide: true,
                field: "title"
            },
            {
                headerName: "Version",
                hide: true,
                field: "version"
            },
            {
                headerName: "Contributions",
                hide: true,
                field: "contributions"
            },
            {
                headerName: "ISRCs",
                hide: true,
                field: "isrcs"
            },
            {
                headerName: "Release",
                hide: true,
                field: "release"
            },
            {
                headerName: "Year",
                hide: true,
                field: "year"
            },
            {
                headerName: "Duration",
                hide: true,
                field: "duration"
            },
            {
                headerName: "Type",
                hide: true,
                colId: "type"
            },
            {
                headerName: "Stage Name",
                hide: true,
                field: "stageName"
            },
            {
                headerName: "Live",
                hide: true,
                field: "isLive"
            },
            {
                headerName: "Featured",
                field: "isFeatured"
            },
            {
                headerName: "Collaborators",
                field: "collaborators"
            },
            {
                headerName: "Label",
                field: "label"
            },
            {
                headerName: "Catalogue Number",
                field: "catNumbers"
            },
            {
                headerName: "Format",
                field: "format"
            },
            {
                headerName: "Type",
                field: "type"
            }
        ], []);
    const [detailVisibleColumns, setDetailVisibleColumns] = (0, $acw62.useState)(()=>{
        const visible = new Set();
        // Initialize with all non-hidden detail columns
        detailColumnDefsForVisibility.forEach((col)=>{
            if (col.field && !col.hide) visible.add(col.field);
        });
        return visible;
    });
    const initialColumnState = (0, $acw62.useMemo)(()=>$6a458b07a6d42853$var$DEFAULT_SORT_MODEL.filter((item)=>Boolean(item.colId && item.sort)).map((item, index)=>({
                colId: item.colId,
                sort: item.sort,
                sortIndex: index
            })), []);
    const defaultSortStateByColId = (0, $acw62.useMemo)(()=>new Map(initialColumnState.filter((col)=>col.sort !== null && col.sortIndex !== null && col.sort !== undefined && col.sortIndex !== undefined).map(({ colId: colId, sort: sort, sortIndex: sortIndex })=>[
                colId,
                {
                    sort: sort,
                    sortIndex: sortIndex
                }
            ])), [
        initialColumnState
    ]);
    const skipToLastPage = ()=>{
        const totalPages = Math.ceil(recordingsCount / rowsPerPage);
        if (totalPages > 0) setPage(totalPages);
    };
    const handleSortChanged = (0, $acw62.useCallback)((event)=>{
        if (!event.api) return;
        // Ignore sort changes during initial sort application
        if (isApplyingInitialSortRef.current) return;
        // Get the current sort state from the grid
        const sortedColumns = event.api.getColumnState().filter((col)=>col.sort && col.sortIndex !== null && col.sortIndex !== undefined).sort((a, b)=>(a.sortIndex ?? 0) - (b.sortIndex ?? 0));
        // Build sortFields array from sorted columns
        const newSortFields = sortedColumns.map((col)=>{
            if (!col.colId) return null;
            const apiField = $6a458b07a6d42853$var$GRID_SORT_TO_API_FIELD[col.colId];
            if (!apiField || !col.sort) return null;
            return {
                field: apiField,
                order: col.sort === "desc" ? "desc" : "asc"
            };
        }).filter((item)=>item !== null);
        // Compare sort fields (order matters for multi-sort)
        const sortChanged = JSON.stringify(sortFieldsRef.current) !== JSON.stringify(newSortFields);
        // Only update if sort actually changed
        if (!sortChanged) return;
        // Update sortFields with new sort (can be empty array if user removed all sorts)
        sortFieldsRef.current = newSortFields;
        setSortFields(newSortFields);
        setPage(1);
    }, []);
    const handleFilterChanged = (0, $acw62.useCallback)((event)=>{
        if (!event.api) return;
        const filterModel = event.api.getFilterModel();
        const newFieldFilters = [];
        // Convert AG Grid filter model to API fieldFilters format
        // Note: filterModel only contains active filters, so if a filter is cleared, it won't be in the model
        Object.keys(filterModel).forEach((colId)=>{
            const apiField = $6a458b07a6d42853$var$GRID_COL_TO_API_FILTER_FIELD[colId];
            if (!apiField) return; // Skip columns that don't have filter mapping
            const filter = filterModel[colId];
            if (!filter) return; // Skip if filter is null/undefined
            // Handle checkbox filter (AgCheckboxFilter returns { values: string[] })
            if (filter && filter.values && Array.isArray(filter.values)) // Only add filter if at least one value is selected (filter is active)
            // When no values are selected, the filter is inactive and we don't filter
            {
                if (filter.values.length > 0) {
                    // Filter out the BLANK_KEY if present, as it's not a real value
                    const realValues = filter.values.filter((v)=>v !== "__AG_CHECKBOX_FILTER_BLANK__");
                    if (realValues.length > 0) {
                        // Special handling for featured column: expand "Yes" to ["featured", "otherFeatured"]
                        let expandedValues = realValues;
                        if (colId === "featured") expandedValues = realValues.flatMap((v)=>{
                            if (v === "Yes") return [
                                "featured",
                                "otherFeatured"
                            ];
                            return [
                                v
                            ];
                        });
                        const filterConfig = {
                            field: apiField,
                            value: expandedValues
                        };
                        if (colId === "featured") filterConfig.caseSensitive = true;
                        newFieldFilters.push(filterConfig);
                    }
                }
            } else if (filter && filter.filter !== undefined) {
                // AG Grid text filter stores the filter value in the 'filter' property
                const filterValue = String(filter.filter).trim();
                // Only add filter if there's a non-empty value
                if (filterValue) newFieldFilters.push({
                    field: apiField,
                    value: [
                        filterValue
                    ]
                });
            // If filterValue is empty, don't add to fieldFilters (filter is cleared)
            }
        });
        // Compare with existing filters to prevent unnecessary updates
        const newFieldFiltersKey = JSON.stringify(newFieldFilters);
        const currentFieldFiltersKey = JSON.stringify(fieldFilters);
        // Only update if filters actually changed
        if (newFieldFiltersKey !== currentFieldFiltersKey) {
            setFieldFilters(newFieldFilters);
            setPage(1);
        }
    }, [
        fieldFilters
    ]);
    // Helper function to get available values for a column from API filters
    const getAvailableValuesForColumn = (0, $acw62.useCallback)((colId)=>{
        if (!availableFilters) return null;
        const apiField = $6a458b07a6d42853$var$GRID_COL_TO_API_FILTER_FIELD[colId];
        if (!apiField) return null;
        const filterData = availableFilters.availableFilters.find((f)=>f.field === apiField);
        return filterData?.values ?? null;
    }, [
        availableFilters
    ]);
    const handleGridReady = (0, $acw62.useCallback)((params)=>{
        gridApiRef.current = params.api;
        // Only apply initial sort state on first mount
        if (isInitialMountRef.current) {
            isApplyingInitialSortRef.current = true;
            params.api.applyColumnState({
                defaultState: {
                    sort: null,
                    sortIndex: null
                },
                state: initialColumnState
            });
            isApplyingInitialSortRef.current = false;
            isInitialMountRef.current = false;
        }
    }, [
        initialColumnState
    ]);
    const handleDetailGridSortChange = (0, $acw62.useCallback)((colId, sort)=>{
        if (!gridApiRef.current) return;
        // Apply the sort to this column as primary sort
        // First, clear all sorts
        gridApiRef.current.applyColumnState({
            defaultState: {
                sort: null,
                sortIndex: null
            }
        });
        // Then apply the new sort
        if (sort) gridApiRef.current.applyColumnState({
            state: [
                {
                    colId: colId,
                    sort: sort,
                    sortIndex: 0
                }
            ]
        });
    // handleSortChanged will be triggered automatically and update sortFields
    }, []);
    const handleDetailColumnVisibilityChange = (0, $acw62.useCallback)((field, visible)=>{
        setDetailVisibleColumns((prev)=>{
            const newSet = new Set(prev);
            if (visible) newSet.add(field);
            else newSet.delete(field);
            return newSet;
        });
        // Apply to all detail grids
        detailGridApiRefs.current.forEach((api)=>{
            api.setColumnsVisible([
                field
            ], visible);
        });
    }, []);
    const resetSortOrder = (0, $acw62.useCallback)(()=>{
        if (!gridApiRef.current) return;
        gridApiRef.current.applyColumnState({
            defaultState: {
                sort: null,
                sortIndex: null
            },
            state: initialColumnState
        });
        // handleSortChanged will be triggered automatically and update sortFields
        // But we also need to update sortFields immediately for consistency
        const defaultSortFields = $6a458b07a6d42853$var$DEFAULT_SORT_MODEL.map((item)=>{
            const apiField = $6a458b07a6d42853$var$GRID_SORT_TO_API_FIELD[item.colId];
            if (apiField && item.sort) return {
                field: apiField,
                order: item.sort === "desc" ? "desc" : "asc"
            };
            return null;
        }).filter((item)=>item !== null);
        sortFieldsRef.current = defaultSortFields;
        setSortFields(defaultSortFields);
        setPage(1);
    }, [
        initialColumnState
    ]);
    const resetFilters = (0, $acw62.useCallback)(()=>{
        if (!gridApiRef.current) return;
        // Clear all filters from the grid
        gridApiRef.current.setFilterModel(null);
        // Reset field filters state
        setFieldFilters([]);
        setPage(1);
    }, []);
    const handleOpenEditModal = (0, $acw62.useCallback)((row)=>{
        setSelectedRowForModal({
            ...row
        });
        setShowEditPanel(true);
    }, []);
    const handleSaveModalEdit = (0, $acw62.useCallback)((updatedRow)=>{
        setRows((prevRows)=>{
            return prevRows.map((row)=>{
                if (row.id === updatedRow.id) return {
                    ...row,
                    ...updatedRow,
                    isModified: true
                };
                return row;
            });
        });
        setShowEditModal(false);
        setSelectedRowForModal(null);
    }, []);
    const toggleRowExpansion = (0, $acw62.useCallback)((rowId)=>{
        setExpandedRowIds((prev)=>{
            const next = new Set(prev);
            if (next.has(rowId)) next.delete(rowId);
            else next.add(rowId);
            return next;
        });
    }, []);
    const expandAllRows = (0, $acw62.useCallback)(()=>{
        setExpandedRowIds(new Set(rows.map((row)=>row.id)));
    }, [
        rows
    ]);
    const collapseAllRows = (0, $acw62.useCallback)(()=>{
        setExpandedRowIds(new Set());
    }, []);
    const hasAnyExpandedRows = (0, $acw62.useMemo)(()=>{
        return expandedRowIds.size > 0;
    }, [
        expandedRowIds.size
    ]);
    const gridRows = (0, $acw62.useMemo)(()=>{
        const expanded = new Set(expandedRowIds);
        const result = [];
        rows.forEach((row)=>{
            result.push({
                ...row,
                kind: "data"
            });
            if (expanded.has(row.id)) result.push({
                kind: "detail",
                id: `${row.id}__detail`,
                parentId: row.id,
                base: row
            });
        });
        return result;
    }, [
        expandedRowIds,
        rows
    ]);
    const getRowId = (0, $acw62.useCallback)((params)=>{
        if (!params.data) return "";
        if (params.data.kind === "detail") return params.data.id;
        return params.data.id;
    }, []);
    const getRowHeight = (0, $acw62.useCallback)((params)=>{
        if (!params.data) return 48;
        if (params.data.kind === "detail") // Header height (30) + row height (70) + padding (24) = 124
        return 94;
        return 48;
    }, []);
    const handlePostSortRows = (0, $acw62.useCallback)(({ nodes: nodes })=>{
        const detailNodes = [];
        for(let i = nodes.length - 1; i >= 0; i--){
            const node = nodes[i];
            if (node.data?.kind === "detail") {
                detailNodes.push(node);
                nodes.splice(i, 1);
            }
        }
        detailNodes.reverse().forEach((detailNode)=>{
            const data = detailNode.data;
            if (!data || data.kind !== "detail") {
                nodes.push(detailNode);
                return;
            }
            const parentId = data.parentId;
            if (!parentId) {
                nodes.push(detailNode);
                return;
            }
            const parentIndex = nodes.findIndex((node)=>node.data?.kind === "data" && node.data.id === parentId);
            if (parentIndex === -1) {
                nodes.push(detailNode);
                return;
            }
            nodes.splice(parentIndex + 1, 0, detailNode);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        setExpandedRowIds((prev)=>{
            const available = new Set(rows.map((row)=>row.id));
            const retained = new Set();
            prev.forEach((id)=>{
                if (available.has(id)) retained.add(id);
            });
            return retained.size === prev.size ? prev : retained;
        });
    }, [
        rows
    ]);
    // Reset row heights when confidence filter changes and new data arrives
    // This fixes the visual bug where rows render with wrong heights after filter change
    const prevConfidenceCategoryRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        // Check if confidence category changed
        const confidenceChanged = prevConfidenceCategoryRef.current !== selectedConfidenceCategory;
        if (confidenceChanged && gridApiRef.current && rows.length > 0) // Reset row heights after confidence filter change to fix visual bug
        // Use requestAnimationFrame to ensure this happens after React render
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (gridApiRef.current) gridApiRef.current.resetRowHeights();
            });
        });
        prevConfidenceCategoryRef.current = selectedConfidenceCategory;
    }, [
        selectedConfidenceCategory,
        rows.length
    ]);
    const fetchData = async ()=>{
        if (userId === undefined) return;
        setIsLoading(true);
        api.retrieveAdminPersonalInformation({
            userId: userId
        }).then((personalInfo)=>{
            setClientPersonalInfo(personalInfo);
        });
        try {
            const discographyData = await api.searchPrimaryDiscography({
                userId: userId,
                primaryDiscographyRequest: {
                    size: rowsPerPage,
                    fromOffset: (page - 1) * rowsPerPage,
                    sortFields: sortFields,
                    ...sortFields.length > 0 && {
                        sortField: sortFields[0].field,
                        sortOrder: sortFields[0].order
                    },
                    confidenceCategory: selectedConfidenceCategory ?? undefined,
                    searchTerm: debouncedSearchTerm || undefined,
                    fieldFilters: fieldFilters.length > 0 ? fieldFilters : undefined
                }
            });
            const rows = discographyData.recordings.map((recording)=>{
                const { parentRecording: parentRecording, earliestParentRelease: earliestParentRelease, evidenceReleases: evidenceReleases, westburyContributions: westburyContributions, performance: performance, persona: persona } = recording;
                return {
                    id: parentRecording.id,
                    artist: parentRecording.bandArtistName,
                    title: parentRecording.recordingTitle,
                    version: (parentRecording.recordingVersion ?? []).join(",\u2000"),
                    release: earliestParentRelease?.releaseTitle ?? "",
                    year: earliestParentRelease?.dateReleased,
                    isrcs: (parentRecording.isrcs ?? []).join(",\u2000"),
                    contributions: westburyContributions.sort((a, b)=>b.confidenceCategory.localeCompare(a.confidenceCategory)),
                    duration: parentRecording.duration ?? null,
                    isFeatured: [
                        "featured",
                        "otherFeatured"
                    ].includes(performance.featuredStatus ?? ""),
                    isLive: !!parentRecording.live,
                    live: parentRecording.live ?? null,
                    // Subheadings data
                    collaborators: "",
                    catNumbers: (earliestParentRelease?.catNumbers ?? []).join(",\u2000"),
                    label: (earliestParentRelease?.releaseLabels ?? []).join(",\u2000"),
                    labelsArray: earliestParentRelease?.releaseLabels ?? [],
                    catNumbersArray: earliestParentRelease?.catNumbers ?? [],
                    versionsArray: parentRecording.recordingVersion ?? [],
                    isrcsArray: parentRecording.isrcs ?? [],
                    mainArtistsRaw: parentRecording.mainArtists ?? [],
                    format: earliestParentRelease?.format ?? "",
                    mediaType: earliestParentRelease?.mediaType ?? "",
                    stageName: persona.stageName,
                    location: parentRecording.countryOfRecording ?? "",
                    source: recording.parentRecording.source.toString(),
                    // notes: '',
                    earliestReleaseImageKey: (evidenceReleases?.at(0)?.evidenceImages ?? []).map((image)=>image.objectKey).at(0),
                    releaseImageKeys: (evidenceReleases ?? []).flatMap((release)=>(release.evidenceImages ?? []).map((image)=>image.objectKey))
                };
            });
            // Merge with existing rows to preserve editing state
            setRows((prevRows)=>{
                return rows.map((newRow)=>{
                    const existingRow = prevRows.find((r)=>r.id === newRow.id);
                    if (existingRow && existingRow.isModified) return {
                        ...newRow,
                        ...existingRow,
                        // Keep modified values but update other fields
                        artist: existingRow.artist,
                        title: existingRow.title,
                        release: existingRow.release,
                        year: existingRow.year,
                        isrcs: existingRow.isrcs
                    };
                    return {
                        ...newRow,
                        isModified: false,
                        originalValues: {}
                    };
                });
            });
            setRecordingsCount(discographyData.count);
        } catch (e) {
            console.error(e);
            setLoadingError(true);
        }
        setIsLoading(false);
    };
    const transformConfidenceStatsToChartData = (stats)=>{
        const getCategoryIcon = (categoryId)=>{
            switch(categoryId){
                case "1":
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                        className: "tw-w-5 tw-h-5"
                    });
                case "2":
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                        className: "tw-w-5 tw-h-5"
                    });
                case "3":
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-p-1 tw-rounded-full tw-border-[#f97316] tw-border-[2px] tw-w-5 tw-h-5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $604e08b57548a73d$export$2e2bcd8739ae039), {
                            className: "tw-w-2.5 tw-h-2.5 -tw-mt-[1px] -tw-ml-[1px]"
                        })
                    });
                case "4":
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                        className: "tw-w-5 tw-h-5"
                    });
                case "5":
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                        className: "tw-w-5 tw-h-5"
                    });
                default:
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                        className: "tw-w-5 tw-h-5"
                    });
            }
        };
        const getCategoryInfo = (categoryId)=>{
            switch(categoryId){
                case "1":
                    return {
                        label: "Verified (No Effort)",
                        text: "black",
                        color: "#6EE038",
                        description: "Contributions that have been verified and require no additional effort"
                    };
                case "2":
                    return {
                        label: "Inferred (Low Effort)",
                        text: "black",
                        color: "#F6FF00",
                        description: "Contributions that can be inferred with low verification effort"
                    };
                case "3":
                    return {
                        label: "Credited (Mid Effort)",
                        text: "white",
                        color: "#FF8A00",
                        description: "Contributions that are credited and require moderate verification effort"
                    };
                case "4":
                    return {
                        label: "Unverified (High Effort)",
                        text: "white",
                        color: "#FF2600",
                        description: "Contributions that are unverified and require high verification effort"
                    };
                case "5":
                    return {
                        label: "Unknown (Max Effort)",
                        text: "black",
                        color: "#AAB2B9",
                        description: "Contributions with unknown status requiring maximum verification effort"
                    };
                default:
                    return {
                        label: `Category ${categoryId}`,
                        text: "white",
                        color: "#AAB2B9",
                        description: "Unknown confidence category"
                    };
            }
        };
        stats.confidenceCategories.sort((a, b)=>Number(a.confidenceCategory) - Number(b.confidenceCategory));
        return stats.confidenceCategories.map((category)=>{
            const categoryInfo = getCategoryInfo(category.confidenceCategory);
            return {
                id: category.confidenceCategory,
                label: categoryInfo.label,
                value: category.count,
                text: categoryInfo.text,
                color: categoryInfo.color,
                icon: getCategoryIcon(category.confidenceCategory),
                description: categoryInfo.description
            };
        });
    };
    const fetchConfidenceStats = async ()=>{
        if (userId === undefined) return;
        try {
            const stats = await api.confidenceStatsConfidenceStats({
                userId: userId
            });
            setConfidenceStats(stats);
        } catch (e) {
            console.error("Failed to fetch confidence stats:", e);
            // Set to null on error so we can show default data or handle gracefully
            setConfidenceStats(null);
        }
    };
    const fetchAvailableFilters = async ()=>{
        if (userId === undefined) return;
        try {
            const filters = await api.availableFiltersAvailableFiltersResponse({
                userId: userId
            });
            setAvailableFilters(filters);
        } catch (e) {
            console.error("Failed to fetch available filters:", e);
            setAvailableFilters(null);
        }
    };
    const handleConfidenceFilterChange = (categoryId)=>{
        setSelectedConfidenceCategory(categoryId);
        setPage(1); // Reset to first page when filter changes
        // Don't clear rows immediately - let fetchData handle it naturally
        // This prevents AG Grid from having stale row nodes with cached heights
        setIsLoading(true); // Set loading state
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId,
        page,
        rowsPerPage,
        sortFieldsKey,
        selectedConfidenceCategory,
        debouncedSearchTerm,
        fieldFiltersKey
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchConfidenceStats();
        fetchAvailableFilters();
    }, [
        userId
    ]);
    // Debounce search term with 300ms delay
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebouncedSearchTerm(searchTerm);
        }, 300);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        searchTerm
    ]);
    // Reset to page 1 when debounced search term changes (but not on initial mount)
    (0, $acw62.useEffect)(()=>{
        if (prevDebouncedSearchTermRef.current !== debouncedSearchTerm) {
            if (!isInitialMountRef.current) setPage(1);
            prevDebouncedSearchTermRef.current = debouncedSearchTerm;
            isInitialMountRef.current = false;
        }
    }, [
        debouncedSearchTerm
    ]);
    // Update filter available values when availableFilters changes
    (0, $acw62.useEffect)(()=>{
        if (!gridApiRef.current || !availableFilters) return;
        // Update each filterable column's filter with new available values
        const filterableColumns = [
            "artist",
            "version",
            "contributions",
            "release",
            "year",
            "live",
            "stageName",
            "type",
            "format",
            "label",
            "catNumbers",
            "featured"
        ];
        filterableColumns.forEach((colId)=>{
            const column = gridApiRef.current?.getColumn(colId);
            if (!column) return;
            // Use getColumnApi or direct access to get filter instance
            const filterInstance = gridApiRef.current.getFilterInstance?.(colId);
            if (filterInstance && typeof filterInstance.setAvailableValues === "function") {
                const availableValues = getAvailableValuesForColumn(colId);
                if (availableValues) filterInstance.setAvailableValues(availableValues);
            }
        });
    }, [
        availableFilters,
        getAvailableValuesForColumn
    ]);
    const fetchSignedEvidenceImageUrls = ()=>{
        if (userId === undefined) return;
        for (const row of rows){
            if (row.earliestReleaseImageKey === undefined) continue;
            api.evidenceImageSignedUrlEvidenceImageSignedUrl({
                userId: userId,
                evidenceImageSignedUrlRequest: {
                    objectKey: row.earliestReleaseImageKey
                }
            }).then(({ signedUrl: signedUrl })=>{
                setImages((prev)=>{
                    return {
                        ...prev,
                        [row.id]: signedUrl
                    };
                });
            }).catch((e)=>{
                console.error(e);
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchSignedEvidenceImageUrls();
    }, [
        rows
    ]);
    const fetchLatestExportStatus = async ()=>{
        if (userId === undefined) return;
        api.retrieveLatestPrimaryDiscographyExport({
            userId: userId
        }).then((primaryDiscographyExport)=>{
            setIsPendingExportGeneration(!primaryDiscographyExport.ready);
        }).catch(()=>{});
    };
    (0, $acw62.useEffect)(()=>{
        fetchLatestExportStatus();
    }, [
        userId
    ]);
    const handleGenerateExport = ()=>{
        if (userId === undefined) return;
        api.createGeneratePrimaryDiscographyExport({
            userId: userId
        }).then(()=>{
            setIsOpenExportConfirmationModal(true);
            fetchLatestExportStatus();
        }).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Discography export generation request failed"));
        });
    };
    const defaultColDef = (0, $acw62.useMemo)(()=>({
            sortable: true,
            resizable: true,
            suppressMenu: true,
            suppressMovable: false,
            sortingOrder: [
                "asc",
                "desc",
                null
            ],
            flex: 1,
            minWidth: 80
        }), []);
    // Store images in a ref so cell renderers can access it without causing columnDefs to recreate
    const imagesRef = (0, $acw62.useRef)(images);
    const prevImagesKeysRef = (0, $acw62.useRef)(JSON.stringify(Object.keys(images)));
    (0, $acw62.useEffect)(()=>{
        const currentImagesKeys = JSON.stringify(Object.keys(images));
        imagesRef.current = images;
        // Refresh cells when images change (including initial load)
        // Check if images actually changed to avoid unnecessary refreshes
        if (gridApiRef.current && currentImagesKeys !== prevImagesKeysRef.current) {
            prevImagesKeysRef.current = currentImagesKeys;
            // Use setTimeout to ensure this happens after render
            setTimeout(()=>{
                if (gridApiRef.current) gridApiRef.current.refreshCells({
                    columns: [
                        "evidence"
                    ],
                    force: true
                });
            }, 0);
        }
    }, [
        images
    ]);
    // Store expandedRowIds in a ref so cell renderers can access it without causing columnDefs to recreate
    const expandedRowIdsRef = (0, $acw62.useRef)(expandedRowIds);
    (0, $acw62.useEffect)(()=>{
        expandedRowIdsRef.current = expandedRowIds;
    }, [
        expandedRowIds
    ]);
    // Custom header component that shows sort index next to sort icon
    // Uses AG Grid's native sort handling via setSort method
    // Defined outside useMemo to prevent recreation
    const CustomHeaderWithSortIndex = (params)=>{
        // Use state to force re-render when sort changes
        const [sortState, setSortState] = (0, $acw62.useState)(()=>({
                sort: params.column?.getSort() ?? null,
                sortIndex: params.column?.getSortIndex() ?? null
            }));
        // Track filter state
        const [isFiltered, setIsFiltered] = (0, $acw62.useState)(()=>{
            if (!params.column) return false;
            const filterModel = params.api.getFilterModel();
            const colId = params.column.getColId();
            const filter = filterModel[colId];
            // Check for text filter
            if (filter && filter.filter) return true;
            // Check for checkbox filter (AgCheckboxFilter returns { values: string[] })
            if (filter && filter.values && Array.isArray(filter.values) && filter.values.length > 0) return true;
            return false;
        });
        // Track menu open state to properly toggle (use ref to avoid re-renders in event handler)
        const menuOpenRef = (0, $acw62.useRef)(false);
        const [isMenuOpen, setIsMenuOpen] = (0, $acw62.useState)(false);
        // Listen to sort changes and update state to force re-render
        (0, $acw62.useEffect)(()=>{
            const updateSortState = ()=>{
                setSortState({
                    sort: params.column?.getSort() ?? null,
                    sortIndex: params.column?.getSortIndex() ?? null
                });
            };
            const updateFilterState = ()=>{
                if (!params.column) return;
                const filterModel = params.api.getFilterModel();
                const colId = params.column.getColId();
                const filter = filterModel[colId];
                // Check for text filter
                let hasFilter = false;
                if (filter && filter.filter) hasFilter = true;
                else if (filter && filter.values && Array.isArray(filter.values) && filter.values.length > 0) // Check for checkbox filter with selected values
                hasFilter = true;
                setIsFiltered(hasFilter);
            };
            // Update filter state when filter changes (don't update menu state here to avoid loops)
            // AG Grid automatically closes the menu when filters are applied
            const handleFilterChanged = ()=>{
                updateFilterState();
                // Update ref without causing re-render
                menuOpenRef.current = false;
            };
            // Update immediately
            updateSortState();
            updateFilterState();
            // Listen to sort changed events
            params.api.addEventListener("sortChanged", updateSortState);
            // Listen to filter changed events (only update filter state, not menu state)
            params.api.addEventListener("filterChanged", handleFilterChanged);
            return ()=>{
                params.api.removeEventListener("sortChanged", updateSortState);
                params.api.removeEventListener("filterChanged", handleFilterChanged);
            };
        }, [
            params.api,
            params.column
        ]);
        const sortIndex = sortState.sortIndex;
        const sort = sortState.sort;
        const displayName = params.displayName;
        // Handle sort click - use AG Grid's native setSort method
        const onSortRequested = (event)=>{
            if (!params.enableSorting || !params.column) return;
            // Check for Ctrl (Windows/Linux) or Cmd (Mac) for multi-sort
            // The grid is configured with multiSortKey="ctrl"
            const mouseEvent = event;
            const multiSortKey = mouseEvent.ctrlKey || mouseEvent.metaKey;
            // Use AG Grid's native setSort method which handles multi-sort automatically
            // The multiSortKey="ctrl" setting will be respected
            params.setSort(sort === "asc" ? "desc" : sort === "desc" ? null : "asc", multiSortKey);
        };
        // Handle filter icon click - toggle filter menu
        const onFilterClick = (event)=>{
            event.stopPropagation();
            event.preventDefault();
            if (!params.column) return;
            // If menu is open, close it; otherwise open it
            // Use ref to check state to avoid stale closures
            if (menuOpenRef.current) {
                // Close the menu
                params.api.hidePopupMenu();
                menuOpenRef.current = false;
                setIsMenuOpen(false);
            } else {
                // Open the column menu which contains the filter
                params.showColumnMenu(event.currentTarget);
                menuOpenRef.current = true;
                setIsMenuOpen(true);
            }
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `ag-header-cell-label tw-flex tw-items-center tw-gap-1 tw-w-full ${params.enableSorting ? "tw-cursor-pointer" : ""}`,
            onClick: params.enableSorting ? onSortRequested : undefined,
            onTouchEnd: params.enableSorting ? onSortRequested : undefined,
            role: params.enableSorting ? "button" : undefined,
            tabIndex: params.enableSorting ? 0 : undefined,
            onKeyDown: params.enableSorting ? (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onSortRequested(e);
                }
            } : undefined,
            "aria-label": params.enableSorting ? `Sort by ${displayName}` : undefined,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-flex-1",
                    children: displayName
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-1",
                    children: [
                        params.column?.getColDef().filter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onFilterClick,
                            className: `tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-rounded tw-transition-colors ${isFiltered ? "tw-bg-blue-600 tw-text-white tw-p-1" : "tw-bg-transparent tw-text-neutral-500 tw-p-1 hover:tw-bg-neutral-800"}`,
                            "aria-label": `Filter ${displayName}`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                className: `tw-w-3 tw-h-3 ${isFiltered ? "tw-text-white" : "tw-text-neutral-500"}`
                            })
                        }),
                        params.enableSorting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                sort && sortIndex !== null && sortIndex !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tw-text-xs tw-text-neutral-400 tw-font-medium tw-h-[14px]",
                                    children: sortIndex + 1
                                }),
                                sort ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-flex tw-items-center",
                                    children: sort === "asc" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f05f6a77fc593bc$export$2e2bcd8739ae039), {
                                        className: "tw-w-3 tw-h-3"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $008e11cf932a0927$export$2e2bcd8739ae039), {
                                        className: "tw-w-3 tw-h-3"
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const ExpandAllHeaderComponent = ()=>{
        return null;
    };
    const columnDefs = (0, $acw62.useMemo)(()=>{
        return [
            {
                headerName: "",
                colId: "expand",
                width: 20,
                maxWidth: 20,
                cellStyle: (params)=>{
                    const baseStyle = {
                        padding: 0,
                        display: "flex"
                    };
                    if (params.data?.kind === "detail") return {
                        ...baseStyle,
                        alignItems: "stretch",
                        justifyContent: "stretch",
                        width: "100%"
                    };
                    return {
                        ...baseStyle,
                        alignItems: "center",
                        justifyContent: "center"
                    };
                },
                headerClass: "tw-flex tw-items-center tw-justify-center",
                flex: 0,
                sortable: false,
                resizable: false,
                suppressMovable: true,
                headerComponent: ExpandAllHeaderComponent,
                cellRenderer: (params)=>{
                    if (!params.data) return null;
                    if (params.data.kind === "detail") {
                        const row = params.data.base;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a458b07a6d42853$var$DetailGrid, {
                            row: row,
                            onSortChange: handleDetailGridSortChange,
                            rowId: params.data.parentId,
                            onGridReady: (rowId, api)=>{
                                detailGridApiRefs.current.set(rowId, api);
                            },
                            visibleColumns: detailVisibleColumns
                        });
                    }
                    const isExpanded = expandedRowIdsRef.current.has(params.data.id);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: (event)=>{
                            event.stopPropagation();
                            toggleRowExpansion(params.data.id);
                        },
                        className: "tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded tw-border tw-border-[#30353b] tw-bg-transparent tw-text-white hover:tw-border-[#4a5056]",
                        "aria-label": isExpanded ? "Collapse row" : "Expand row",
                        children: isExpanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                            className: "tw-h-4 tw-w-4"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                            className: "tw-h-4 tw-w-4"
                        })
                    });
                },
                colSpan: (params)=>{
                    if (params.data?.kind === "detail") return Math.max(params.api.getAllDisplayedColumns().length, 1);
                    return 1;
                }
            },
            {
                headerName: "Evidence",
                colId: "evidence",
                width: 80,
                minWidth: 100,
                flex: 0,
                sortable: false,
                cellRenderer: (params)=>{
                    if (!params.data || params.data.kind !== "data") return null;
                    const row = params.data;
                    const imageUrl = imagesRef.current[row.id];
                    const hasImageKey = !!row.earliestReleaseImageKey;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-[45px] tw-h-[45px]",
                        children: hasImageKey ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/discography/${userId}/ai-evidence/${row.id}`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-cursor-pointer",
                                children: imageUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: imageUrl,
                                    alt: "Evidence",
                                    className: "tw-w-full tw-h-full"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-flex tw-justify-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "tw-my-auto tw-animate-ping",
                                        children: "\u26AA"
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi wi-shut-eye wi-20px"
                            })
                        })
                    });
                },
                colSpan: (params)=>{
                    if (params.data?.kind === "detail") return 0;
                    return 1;
                }
            },
            {
                headerName: "Artist",
                colId: "artist",
                field: "artist",
                width: 160,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.artist : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.artist : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("artist") ?? undefined,
                    serverSideFiltering: true
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: params.data.artist || "-"
                    });
                }
            },
            {
                headerName: "Recording Title",
                colId: "title",
                field: "title",
                width: 128,
                minWidth: 200,
                sortable: true,
                filter: (0, $36bcfc8b5b2b059b$export$1952167e72fdddd1),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.title : "",
                filterParams: {
                    serverSideFiltering: true
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: params.data.title || "-"
                    });
                }
            },
            {
                headerName: "Version",
                hide: false,
                colId: "version",
                field: "version",
                width: 50,
                minWidth: 150,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.version || "-" : "",
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return params.data.versionsArray?.length ? params.data.versionsArray : null;
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("version") ?? undefined,
                    serverSideFiltering: true
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: params.data.version || "-"
                    });
                }
            },
            {
                headerName: "Contributions",
                colId: "contributions",
                field: "contributions",
                minWidth: 150,
                width: 150,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.contributions : [],
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    // Return as array for better filtering - split comma-separated values
                    const contributions = params.data.contributions;
                    if (!contributions) return null;
                    // Split by comma and trim each value
                    return contributions.map((contribution)=>contribution.contribution);
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("contributions") ?? undefined,
                    serverSideFiltering: true
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-gap-2",
                        children: params.data.contributions.map((contribution)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca4bfbde716b69b9$export$733e49a0308b4cd), {
                                contribution: contribution
                            }, contribution.contribution))
                    });
                }
            },
            {
                headerName: "ISRCs",
                colId: "isrcs",
                field: "isrcs",
                width: 50,
                sortable: true,
                filter: (0, $36bcfc8b5b2b059b$export$1952167e72fdddd1),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.isrcs : "",
                filterParams: {
                    serverSideFiltering: true
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: params.data.isrcs || "-"
                    });
                }
            },
            {
                headerName: "Release",
                colId: "release",
                field: "release",
                width: 50,
                minWidth: 160,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.release : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.release : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("release") ?? undefined,
                    serverSideFiltering: true
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: params.data.release || "-"
                    });
                }
            },
            {
                headerName: "Year",
                colId: "year",
                field: "year",
                width: 80,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>{
                    if (params.data?.kind !== "data" || !params.data.year) return "";
                    return new Date(params.data.year).getFullYear().toString();
                },
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data" || !params.data.year) return null;
                    return new Date(params.data.year).getFullYear().toString();
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("year") ?? undefined,
                    serverSideFiltering: true,
                    // Extract year from date strings like "1999-01-23"
                    valueExtractor: (apiValue)=>{
                        try {
                            const date = new Date(apiValue);
                            if (!isNaN(date.getTime())) return date.getFullYear().toString();
                        } catch  {
                        // If parsing fails, return as-is
                        }
                        return apiValue;
                    }
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    const year = params.data.year;
                    const displayYear = year ? new Date(year).getFullYear().toString() : "-";
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: displayYear
                    });
                }
            },
            {
                headerName: "Duration",
                colId: "duration",
                field: "duration",
                width: 100,
                sortable: true,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.duration || "-" : "",
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: params.data.duration || "-"
                    });
                }
            },
            {
                headerName: "Type",
                hide: true,
                colId: "type",
                field: "mediaType",
                width: 120,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.mediaType : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.mediaType : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("type") ?? undefined,
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Stage Name",
                hide: true,
                colId: "stageName",
                field: "stageName",
                width: 150,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.stageName : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.stageName : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("stageName") ?? undefined,
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Live",
                colId: "live",
                field: "live",
                width: 150,
                minWidth: 120,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                // `live` is a free-text descriptor string, sorted/filtered
                // alphanumerically (was the boolean `isLive` checkbox).
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.live || "-" : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.live || null : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("live") ?? undefined,
                    serverSideFiltering: true
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: params.data.live || "-"
                    });
                }
            },
            {
                headerName: "Featured",
                hide: true,
                colId: "featured",
                field: "isFeatured",
                width: 140,
                maxWidth: 140,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.isFeatured : "",
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    // Map boolean to display value
                    return params.data.isFeatured ? "Yes" : "No";
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("featured") ?? undefined,
                    serverSideFiltering: true,
                    caseSensitive: true,
                    // Map API values to display values
                    valueMapper: (apiValue)=>{
                        if (apiValue === "featured" || apiValue === "otherFeatured") return "Yes";
                        if (apiValue === "nonFeatured") return "No";
                        return apiValue;
                    },
                    // Map display values back to API values (will be expanded in handleFilterChanged)
                    reverseMapper: (displayValue)=>{
                        // Keep "Yes" as-is, it will be expanded to ["featured", "otherFeatured"] in handleFilterChanged
                        if (displayValue === "Yes") return "Yes";
                        if (displayValue === "No") return "nonFeatured";
                        return displayValue;
                    }
                },
                cellRenderer: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi wi-xs", {
                                "wi-check": params.data.isFeatured,
                                "wi-close": !params.data.isFeatured
                            })
                        })
                    });
                }
            },
            {
                headerName: "Format",
                hide: true,
                colId: "format",
                field: "format",
                width: 120,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.format : "",
                filterValueGetter: (params)=>params.data?.kind === "data" ? params.data.format : null,
                filterParams: {
                    availableValues: getAvailableValuesForColumn("format") ?? undefined,
                    serverSideFiltering: true,
                    caseInsensitiveDeduplication: true
                }
            },
            {
                headerName: "Collaborators",
                colId: "collaborators",
                field: "collaborators",
                hide: true,
                minWidth: 100,
                sortable: true,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light"
            },
            {
                headerName: "Label",
                colId: "label",
                field: "label",
                hide: true,
                minWidth: 100,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.label : "",
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return params.data.labelsArray?.length ? params.data.labelsArray : null;
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("label") ?? undefined,
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Catalogue Number",
                colId: "catNumbers",
                field: "catNumbers",
                hide: true,
                minWidth: 100,
                sortable: true,
                filter: (0, $5e7458979ad0d817$export$1e84ed9684f7d7df),
                suppressMenu: false,
                headerComponent: CustomHeaderWithSortIndex,
                cellClass: "tw-text-textDove tw-flex tw-items-center tw-text-white tw-font-light",
                valueGetter: (params)=>params.data?.kind === "data" ? params.data.catNumbers : "",
                filterValueGetter: (params)=>{
                    if (params.data?.kind !== "data") return null;
                    return params.data.catNumbersArray?.length ? params.data.catNumbersArray : null;
                },
                filterParams: {
                    availableValues: getAvailableValuesForColumn("catNumbers") ?? undefined,
                    serverSideFiltering: true
                }
            },
            {
                headerName: "Actions",
                colId: "actions",
                width: 120,
                minWidth: 120,
                maxWidth: 120,
                flex: 0,
                sortable: false,
                resizable: false,
                cellClass: "tw-flex tw-items-center tw-justify-center",
                cellRenderer: (params)=>{
                    if (!params.data || params.data.kind !== "data") return null;
                    const row = params.data;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-items-center tw-justify-center tw-gap-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            label: "Edit",
                            onClick: ()=>handleOpenEditModal(row)
                        })
                    });
                }
            }
        ];
    }, [
        userId,
        toggleRowExpansion,
        handleDetailGridSortChange,
        getAvailableValuesForColumn,
        handleOpenEditModal
    ]);
    // Row styling: manual-edits indicator (purple left bar); use inset box-shadow so it doesn't displace the row
    // Highlight row currently being edited (same as row hover: neutral-800)
    const getRowStyle = (0, $acw62.useCallback)((params)=>{
        if (params.data?.kind !== "data") return undefined;
        const row = params.data;
        const isBeingEdited = selectedRowForModal != null && row.id === selectedRowForModal.id;
        if (isBeingEdited) return {
            backgroundColor: "#262626"
        }; // same as hover (tw-bg-neutral-800)
        const rowIndex = params.node?.rowIndex ?? 0;
        // TODO: when we have manual-edits info per row, use it instead of every other row
        const hasManualEdits = rowIndex % 2 === 0;
        if (hasManualEdits) return {
            boxShadow: "inset 3px 0 0 0 #7C3AED"
        };
        if (params.data.isModified) return {
            backgroundColor: "rgba(255, 165, 0, 0.1)",
            boxShadow: "inset 3px 0 0 0 #FFA500"
        };
        return undefined;
    }, [
        selectedRowForModal
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3960585a5a16564f$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a458b07a6d42853$var$EditRecordingModal, {
                isOpen: showEditModal,
                onClose: ()=>{
                    setShowEditModal(false);
                    setSelectedRowForModal(null);
                },
                row: selectedRowForModal,
                onSave: handleSaveModalEdit,
                availableFormats: (0, $491894d32f9e82de$export$8993785e14ab2dfb),
                availableTypes: (0, $0b4e1af42faad25c$export$6a2892aa4af64e1e),
                availableContributions: (0, $f50146991650bb90$export$a0305d43acfa6742),
                availableArtists: getAvailableValuesForColumn("artist") ?? []
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a458b07a6d42853$var$ExportConfirmationModal, {
                isOpen: isOpenExportConfirmationModal,
                onClose: ()=>setIsOpenExportConfirmationModal(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `tw-flex tw-w-full tw-gap-4 ${showEditPanel && selectedRowForModal ? "tw-mr-[calc(min(520px,95vw)+1rem)]" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        ref: mainContentColumnRef,
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex-1 tw-min-w-0 tw-flex tw-flex-col tw-gap-6", showEditPanel && selectedRowForModal && "tw-pr-[calc(min(520px,95vw)+1rem)]"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-mb-6",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "link-secondary",
                                    icon: "chevron-left",
                                    onClick: ()=>{
                                        window.history.back();
                                    },
                                    label: "Back"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-flex-col tw-gap-2 tw-w-full",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-flex-col tw-justify-between tw-w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    children: `${clientPersonalInfo?.firstName} ${clientPersonalInfo?.lastName}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex-grow tw-flex tw-items-end tw-gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $814c1923bdb44d7d$export$3695c2f14e8c6908), {
                                                        data: confidenceStats ? transformConfidenceStatsToChartData(confidenceStats) : [],
                                                        onFilterChange: handleConfidenceFilterChange
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "tw-justify-self-end tw-mb-[18px]",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                            variant: "secondary",
                                                            label: "Export Discography",
                                                            icon: "export",
                                                            disabled: isPendingExportGeneration,
                                                            onClick: handleGenerateExport
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-bg-surfaceBlack90 tw-p-6 tw-text-white tw-rounded-2xl tw-max-w-full IS_W_CONTAINER",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex tw-justify-between tw-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "tw-flex tw-flex-col tw-gap-2 tw-w-1/2",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-relative",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "tw-relative",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                            className: `wi wi-20px wi-search tw-absolute tw-left-3 tw-top-[14px]`
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-12", "tw-placeholder-textSeal", "tw-text-sm", "tw-leading-5", "tw-p-3", "tw-pl-9", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none"),
                                                                            id: "discography-search",
                                                                            type: "text",
                                                                            value: searchTerm,
                                                                            onChange: (e)=>setSearchTerm(e.target.value),
                                                                            placeholder: "Search discography...",
                                                                            autoComplete: "off"
                                                                        })
                                                                    ]
                                                                }),
                                                                searchTerm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>setSearchTerm(""),
                                                                    className: "tw-absolute tw-right-2 tw-top-1/2 -tw-translate-y-1/2 tw-text-neutral-400 hover:tw-text-white tw-transition-colors",
                                                                    "aria-label": "Clear search",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                        className: "tw-w-4 tw-h-4"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-flex tw-gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                variant: "secondary",
                                                                label: "Expand/Collapse All",
                                                                onClick: ()=>{
                                                                    if (hasAnyExpandedRows) collapseAllRows();
                                                                    else expandAllRows();
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a458b07a6d42853$var$CombinedColumnVisibilityDropdown, {
                                                                gridApi: gridApiRef.current,
                                                                columnDefs: columnDefs,
                                                                detailColumnDefs: detailColumnDefsForVisibility,
                                                                onDetailColumnVisibilityChange: handleDetailColumnVisibilityChange,
                                                                detailVisibleColumns: detailVisibleColumns
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                variant: "secondary",
                                                                label: "Reset Sort",
                                                                onClick: resetSortOrder
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                variant: "secondary",
                                                                label: "Reset Filters",
                                                                onClick: resetFilters
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "tw-h-[500px]",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e439ae7301dd858$export$4074462c5969a5d8), {
                                                            theme: $6a458b07a6d42853$var$myTheme,
                                                            rowData: gridRows,
                                                            columnDefs: columnDefs,
                                                            defaultColDef: defaultColDef,
                                                            pagination: false,
                                                            onSortChanged: handleSortChanged,
                                                            onFilterChanged: handleFilterChanged,
                                                            onGridReady: handleGridReady,
                                                            postSortRows: handlePostSortRows,
                                                            getRowId: getRowId,
                                                            getRowHeight: getRowHeight,
                                                            getRowStyle: getRowStyle,
                                                            masterDetail: true,
                                                            animateRows: true,
                                                            domLayout: "normal",
                                                            multiSortKey: "ctrl",
                                                            loading: isLoading && rows.length === 0,
                                                            isExternalFilterPresent: ()=>{
                                                                // Tell AG Grid that filtering is handled server-side
                                                                // Check if any filters are active (fieldFilters, searchTerm, or confidenceCategory)
                                                                return fieldFilters.length > 0 || debouncedSearchTerm.length > 0 || selectedConfidenceCategory !== null;
                                                            },
                                                            doesExternalFilterPass: ()=>{
                                                                // Since filtering is handled server-side, always return true
                                                                // The backend has already filtered the data, so we show all rows returned
                                                                return true;
                                                            },
                                                            overlayNoRowsTemplate: loadingError ? '<div class="ag-overlay-no-rows-center" style="color: white;"><h5>Error loading data</h5></div>' : debouncedSearchTerm || selectedConfidenceCategory ? '<div class="ag-overlay-no-rows-center" style="color: white;"><h5>The filters did not match any data</h5></div>' : '<div class="ag-overlay-no-rows-center" style="color: white;"><h5>No data available currently</h5></div>'
                                                        })
                                                    }),
                                                    recordingsCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a458b07a6d42853$var$DataTablePagination, {
                                                        currentPage: page,
                                                        totalRows: recordingsCount,
                                                        rowsPerPage: rowsPerPage,
                                                        onPageChange: (newPage)=>{
                                                            setPage(newPage);
                                                        },
                                                        onRowsPerPageChange: (newRowsPerPage)=>{
                                                            setRowsPerPage(newRowsPerPage);
                                                            setPage(1);
                                                        },
                                                        onGoToLastPage: skipToLastPage
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    showEditPanel && selectedRowForModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
                        className: "tw-fixed tw-right-0 tw-w-[min(520px,95vw)] tw-border-l tw-border-gray-600 tw-bg-surfaceBlack90 tw-flex tw-flex-col tw-overflow-hidden tw-rounded-l-2xl tw-z-10",
                        style: {
                            boxShadow: "-4px 0 12px rgba(0,0,0,0.15)",
                            ...panelBounds ? {
                                top: panelBounds.top,
                                height: panelBounds.height
                            } : {
                                top: 64,
                                height: "calc(100vh - 124px)"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-items-center tw-justify-between tw-p-3 tw-border-b tw-border-gray-600 tw-flex-shrink-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "tw-text-white tw-text-base tw-font-semibold",
                                        children: "Edit Recording"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                variant: "secondary",
                                                label: "Full screen",
                                                onClick: ()=>setShowEditModal(true)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                variant: "secondary",
                                                label: "Close",
                                                onClick: ()=>{
                                                    setShowEditPanel(false);
                                                    setSelectedRowForModal(null);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex-1 tw-overflow-y-auto tw-min-h-0",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c320e41e081b01e$export$92bd65961bd57ee8), {
                                    ref: editFormRef,
                                    row: selectedRowForModal,
                                    onSave: (r)=>{
                                        handleSaveModalEdit(r);
                                        setShowEditPanel(false);
                                        setSelectedRowForModal(null);
                                    },
                                    onCancel: ()=>{
                                        setShowEditPanel(false);
                                        setSelectedRowForModal(null);
                                    },
                                    stacked: true,
                                    hideFooter: true,
                                    availableFormats: (0, $491894d32f9e82de$export$8993785e14ab2dfb),
                                    availableTypes: (0, $0b4e1af42faad25c$export$6a2892aa4af64e1e),
                                    availableContributions: getAvailableValuesForColumn("contributions") ?? [],
                                    availableArtists: getAvailableValuesForColumn("artist") ?? []
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-justify-end tw-gap-2 tw-p-3 tw-pt-3 tw-px-3 tw-pb-3 tw-border-t tw-border-gray-600 tw-flex-shrink-0 tw-bg-surfaceBlack90",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        label: "Cancel",
                                        onClick: ()=>editFormRef.current?.cancel()
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        label: "Save Changes",
                                        onClick: ()=>editFormRef.current?.save()
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $6a458b07a6d42853$var$ExportConfirmationModal = ({ isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: onClose,
        title: "",
        hasCloseButton: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-pb-8",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
                title: "Discography Export In Progress",
                description: "Once complete, a download link will appear as a task on your dashboard."
            })
        })
    });
};
const $6a458b07a6d42853$var$EditRecordingModal = ({ isOpen: isOpen, onClose: onClose, row: row, onSave: onSave, availableFormats: availableFormats = [], availableTypes: availableTypes = [], availableContributions: availableContributions = [], availableArtists: availableArtists = [] })=>{
    if (!isOpen || !row) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: onClose,
        title: "Edit Recording Details",
        modalClasses: "tw-max-w-5xl tw-w-full tw-max-h-[90vh] tw-flex tw-flex-col tw-bg-gray-900 tw-overflow-hidden tw-mx-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex-1 tw-overflow-hidden tw-flex tw-flex-col tw-min-h-0",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c320e41e081b01e$export$92bd65961bd57ee8), {
                row: row,
                onSave: (r)=>{
                    onSave(r);
                    onClose();
                },
                onCancel: onClose,
                availableFormats: availableFormats,
                availableTypes: availableTypes,
                availableContributions: availableContributions,
                availableArtists: availableArtists
            })
        })
    });
};
const $6a458b07a6d42853$var$DataTablePagination = ({ currentPage: currentPage, totalRows: totalRows, rowsPerPage: rowsPerPage, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, onGoToLastPage: onGoToLastPage })=>{
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const startRow = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
    const endRow = Math.min(currentPage * rowsPerPage, totalRows);
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage >= totalPages;
    // Calculate which page numbers to show
    const getPageNumbers = ()=>{
        const pages = [];
        const maxVisiblePages = 7;
        if (totalPages <= maxVisiblePages) // Show all pages if total is less than max
        for(let i = 1; i <= totalPages; i++)pages.push(i);
        else {
            // Always show first page
            pages.push(1);
            if (currentPage <= 3) {
                // Show first few pages
                for(let i = 2; i <= 4; i++)pages.push(i);
                pages.push("ellipsis");
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                // Show last few pages
                pages.push("ellipsis");
                for(let i = totalPages - 3; i <= totalPages; i++)pages.push(i);
            } else {
                // Show pages around current
                pages.push("ellipsis");
                for(let i = currentPage - 1; i <= currentPage + 1; i++)pages.push(i);
                pages.push("ellipsis");
                pages.push(totalPages);
            }
        }
        return pages;
    };
    const pageNumbers = getPageNumbers();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-items-center tw-justify-between tw-mt-4 tw-text-white tw-text-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-items-center tw-gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-neutral-400",
                        children: "Rows per page:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        value: rowsPerPage,
                        onChange: (e)=>onRowsPerPageChange(Number(e.target.value)),
                        className: "tw-bg-[#151719] tw-border tw-border-[#535D66] tw-rounded tw-px-2 tw-py-1 tw-text-white focus:tw-outline-none focus:tw-border-[#4a5056]",
                        children: [
                            25,
                            50,
                            100,
                            500
                        ].map((size)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: size,
                                children: size
                            }, size))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-items-center tw-gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "tw-text-neutral-400 tw-text-sm",
                        children: [
                            startRow,
                            "-",
                            endRow,
                            " of ",
                            totalRows
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$68f5e1453c188a82), {
                        className: "[&&]:tw-w-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c814d8d13fd9d633$export$e3c2252a821bad58), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c814d8d13fd9d633$export$389c2523d2fb7ac8), {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            if (!isFirstPage) onPageChange(1);
                                        },
                                        className: isFirstPage ? "tw-pointer-events-none tw-opacity-50" : "tw-cursor-pointer tw-gap-1 tw-px-2.5",
                                        size: "default",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4551b311634241de$export$2e2bcd8739ae039), {
                                                className: "tw-h-4 tw-w-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-hidden sm:tw-inline-block",
                                                children: "First"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c38bddd65ea050e7), {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            if (!isFirstPage) onPageChange(currentPage - 1);
                                        },
                                        className: isFirstPage ? "tw-pointer-events-none tw-opacity-50" : "tw-cursor-pointer"
                                    })
                                }),
                                pageNumbers.map((pageNum, index)=>{
                                    if (pageNum === "ellipsis") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-px-2 tw-text-neutral-400",
                                            children: "..."
                                        })
                                    }, `ellipsis-${index}`);
                                    const pageNumber = pageNum;
                                    const isActive = pageNumber === currentPage;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$389c2523d2fb7ac8), {
                                            href: "#",
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                if (!isActive) onPageChange(pageNumber);
                                            },
                                            style: {
                                                color: isActive ? "black" : "white"
                                            },
                                            className: isActive ? "tw-bg-white tw-text-black tw-pointer-events-none" : "tw-cursor-pointer",
                                            size: "default",
                                            children: pageNumber
                                        })
                                    }, pageNumber);
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$ef9c8bfc54489a24), {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            if (!isLastPage) onPageChange(currentPage + 1);
                                        },
                                        className: isLastPage ? "tw-pointer-events-none tw-opacity-50" : "tw-cursor-pointer"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c814d8d13fd9d633$export$c82a077939f0464b), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c814d8d13fd9d633$export$389c2523d2fb7ac8), {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            if (!isLastPage) onGoToLastPage();
                                        },
                                        className: isLastPage ? "tw-pointer-events-none tw-opacity-50" : "tw-cursor-pointer tw-gap-1 tw-px-2.5",
                                        size: "default",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-hidden sm:tw-inline-block",
                                                children: "Last"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f09bbb993f3fef38$export$2e2bcd8739ae039), {
                                                className: "tw-h-4 tw-w-4"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $6a458b07a6d42853$export$2e2bcd8739ae039 = $6a458b07a6d42853$var$MasterDiscography;




var $acw62 = parcelRequire("acw62");




var $d9d62761516cb445$exports = {};
"use strict";
Object.defineProperty($d9d62761516cb445$exports, "__esModule", {
    value: !0
});

var $acw62 = parcelRequire("acw62");
var $f8dbcd8598db1f0b$exports = {};

$parcel$defineInteropFlag($f8dbcd8598db1f0b$exports);

$parcel$export($f8dbcd8598db1f0b$exports, "isStyledComponent", () => $f8dbcd8598db1f0b$export$7ba318d8d2f06c76);
$parcel$export($f8dbcd8598db1f0b$exports, "version", () => $f8dbcd8598db1f0b$export$83d89fbfd8236492);
$parcel$export($f8dbcd8598db1f0b$exports, "StyleSheetContext", () => $f8dbcd8598db1f0b$export$8c190ef828af4c86);
$parcel$export($f8dbcd8598db1f0b$exports, "StyleSheetConsumer", () => $f8dbcd8598db1f0b$export$91317688fc694efa);
$parcel$export($f8dbcd8598db1f0b$exports, "StyleSheetManager", () => $f8dbcd8598db1f0b$export$a473771da2f0ff7c);
$parcel$export($f8dbcd8598db1f0b$exports, "css", () => $f8dbcd8598db1f0b$export$dbf350e5966cf602);
$parcel$export($f8dbcd8598db1f0b$exports, "ThemeContext", () => $f8dbcd8598db1f0b$export$2c657da244d00bd6);
$parcel$export($f8dbcd8598db1f0b$exports, "ThemeConsumer", () => $f8dbcd8598db1f0b$export$b631efc24e9d5e2f);
$parcel$export($f8dbcd8598db1f0b$exports, "ThemeProvider", () => $f8dbcd8598db1f0b$export$d8964aec282183a3);
$parcel$export($f8dbcd8598db1f0b$exports, "createGlobalStyle", () => $f8dbcd8598db1f0b$export$f0f03736edb61697);
$parcel$export($f8dbcd8598db1f0b$exports, "keyframes", () => $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e);
$parcel$export($f8dbcd8598db1f0b$exports, "ServerStyleSheet", () => $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20);
$parcel$export($f8dbcd8598db1f0b$exports, "withTheme", () => $f8dbcd8598db1f0b$export$e8748c6a27b910dc);
$parcel$export($f8dbcd8598db1f0b$exports, "useTheme", () => $f8dbcd8598db1f0b$export$93d4e7f90805808f);
$parcel$export($f8dbcd8598db1f0b$exports, "__PRIVATE__", () => $f8dbcd8598db1f0b$export$5c87cfe6c475f500);
$parcel$export($f8dbcd8598db1f0b$exports, "default", () => $f8dbcd8598db1f0b$export$2e2bcd8739ae039);
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("hkVY4"));



var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $9a1e650477d9d52e$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9a1e650477d9d52e$export$2e2bcd8739ae039 = $9a1e650477d9d52e$var$stylis_min;


var $2d512083a27c8269$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $2d512083a27c8269$export$2e2bcd8739ae039 = $2d512083a27c8269$var$unitlessKeys;


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $72623ab6bcb0a33b$exports = {};
"use strict";
var $1c4952809f3474ad$exports = {};
"use strict";

$1c4952809f3474ad$exports = (parcelRequire("8Hm9c"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$1c4952809f3474ad$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$1c4952809f3474ad$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($1c4952809f3474ad$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;



var $hPtJY = parcelRequire("hPtJY");
function $f8dbcd8598db1f0b$var$y() {
    return ($f8dbcd8598db1f0b$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $f8dbcd8598db1f0b$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $f8dbcd8598db1f0b$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $3251146683c5d714$exports.typeOf)(t);
}, $f8dbcd8598db1f0b$var$S = Object.freeze([]), $f8dbcd8598db1f0b$var$w = Object.freeze({});
function $f8dbcd8598db1f0b$var$E(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$var$b(e) {
    return "string" == typeof e && e || e.displayName || e.name || "Component";
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $f8dbcd8598db1f0b$var$N = ("undefined" != typeof $hPtJY && void 0 !== $hPtJY.env && undefined, "data-styled"), $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "5.3.11", $f8dbcd8598db1f0b$var$C = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $hPtJY && void 0 !== $hPtJY.env && true), $f8dbcd8598db1f0b$var$P = {}, $f8dbcd8598db1f0b$var$O = {
    1: "Cannot create styled-component for component: %s.\n\n",
    2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
    9: "Missing document `<head>`\n\n",
    10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    14: 'ThemeProvider: "theme" prop is required.\n\n',
    15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
};
function $f8dbcd8598db1f0b$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $f8dbcd8598db1f0b$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error($f8dbcd8598db1f0b$var$R.apply(void 0, [
        $f8dbcd8598db1f0b$var$O[e]
    ].concat(n)).trim());
}
var $f8dbcd8598db1f0b$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $f8dbcd8598db1f0b$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$T = new Map, $f8dbcd8598db1f0b$var$x = new Map, $f8dbcd8598db1f0b$var$k = 1, $f8dbcd8598db1f0b$var$V = function(e) {
    if ($f8dbcd8598db1f0b$var$T.has(e)) return $f8dbcd8598db1f0b$var$T.get(e);
    for(; $f8dbcd8598db1f0b$var$x.has($f8dbcd8598db1f0b$var$k);)$f8dbcd8598db1f0b$var$k++;
    var t = $f8dbcd8598db1f0b$var$k++;
    return ((0 | t) < 0 || t > 1073741824) && $f8dbcd8598db1f0b$var$D(16, "" + t), $f8dbcd8598db1f0b$var$T.set(e, t), $f8dbcd8598db1f0b$var$x.set(t, e), t;
}, $f8dbcd8598db1f0b$var$B = function(e) {
    return $f8dbcd8598db1f0b$var$x.get(e);
}, $f8dbcd8598db1f0b$var$z = function(e, t) {
    t >= $f8dbcd8598db1f0b$var$k && ($f8dbcd8598db1f0b$var$k = t + 1), $f8dbcd8598db1f0b$var$T.set(e, t), $f8dbcd8598db1f0b$var$x.set(t, e);
}, $f8dbcd8598db1f0b$var$M = "style[" + $f8dbcd8598db1f0b$var$N + '][data-styled-version="5.3.11"]', $f8dbcd8598db1f0b$var$G = new RegExp("^" + $f8dbcd8598db1f0b$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $f8dbcd8598db1f0b$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $f8dbcd8598db1f0b$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($f8dbcd8598db1f0b$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($f8dbcd8598db1f0b$var$z(u, c), $f8dbcd8598db1f0b$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $f8dbcd8598db1f0b$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $f8dbcd8598db1f0b$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($f8dbcd8598db1f0b$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($f8dbcd8598db1f0b$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $f8dbcd8598db1f0b$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $f8dbcd8598db1f0b$var$H = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $f8dbcd8598db1f0b$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$$ = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$U = $f8dbcd8598db1f0b$var$C, $f8dbcd8598db1f0b$var$J = {
    isServer: !$f8dbcd8598db1f0b$var$C,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$I
}, $f8dbcd8598db1f0b$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$w), void 0 === t && (t = {}), this.options = $f8dbcd8598db1f0b$var$y({}, $f8dbcd8598db1f0b$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$C && $f8dbcd8598db1f0b$var$U && ($f8dbcd8598db1f0b$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($f8dbcd8598db1f0b$var$N) && ($f8dbcd8598db1f0b$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($f8dbcd8598db1f0b$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $f8dbcd8598db1f0b$var$W(o) : r ? new $f8dbcd8598db1f0b$var$H(o) : new $f8dbcd8598db1f0b$var$$(o), new $f8dbcd8598db1f0b$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $f8dbcd8598db1f0b$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $f8dbcd8598db1f0b$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $f8dbcd8598db1f0b$var$Z = /(a)(d)/gi, $f8dbcd8598db1f0b$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$K(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$K(t % 52) + n).replace($f8dbcd8598db1f0b$var$Z, "$1-$2");
}
var $f8dbcd8598db1f0b$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$te = function(e) {
    return $f8dbcd8598db1f0b$var$ee(5381, e);
};
function $f8dbcd8598db1f0b$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$E(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$re = $f8dbcd8598db1f0b$var$te("5.3.11"), $f8dbcd8598db1f0b$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = false, this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$re, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $f8dbcd8598db1f0b$var$_e(this.rules, e, t, n).join(""), i = $f8dbcd8598db1f0b$var$Q($f8dbcd8598db1f0b$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $f8dbcd8598db1f0b$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h, u = $f8dbcd8598db1f0b$var$ee(u, h + d);
                else if (h) {
                    var p = $f8dbcd8598db1f0b$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $f8dbcd8598db1f0b$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $f8dbcd8598db1f0b$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $f8dbcd8598db1f0b$var$se = /^\s*\/\/.*$/gm, $f8dbcd8598db1f0b$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $f8dbcd8598db1f0b$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $f8dbcd8598db1f0b$var$w : e, i = s.options, a = void 0 === i ? $f8dbcd8598db1f0b$var$w : i, c = s.plugins, u = void 0 === c ? $f8dbcd8598db1f0b$var$S : c, l = new (0, $9a1e650477d9d52e$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $f8dbcd8598db1f0b$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($f8dbcd8598db1f0b$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$D(15), $f8dbcd8598db1f0b$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$var$de = ($f8dbcd8598db1f0b$var$le.Consumer, new $f8dbcd8598db1f0b$var$X), $f8dbcd8598db1f0b$var$he = $f8dbcd8598db1f0b$var$ae();
function $f8dbcd8598db1f0b$var$pe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86) || $f8dbcd8598db1f0b$var$de;
}
function $f8dbcd8598db1f0b$var$fe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$var$le) || $f8dbcd8598db1f0b$var$he;
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $f8dbcd8598db1f0b$var$pe(), u = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$le.Provider, {
        value: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(e.children)));
}
var $f8dbcd8598db1f0b$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $f8dbcd8598db1f0b$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$he), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$ve = /([A-Z])/, $f8dbcd8598db1f0b$var$ge = /([A-Z])/g, $f8dbcd8598db1f0b$var$Se = /^ms-/, $f8dbcd8598db1f0b$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $f8dbcd8598db1f0b$var$Ee(e) {
    return $f8dbcd8598db1f0b$var$ve.test(e) ? e.replace($f8dbcd8598db1f0b$var$ge, $f8dbcd8598db1f0b$var$we).replace($f8dbcd8598db1f0b$var$Se, "-ms-") : e;
}
var $f8dbcd8598db1f0b$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $f8dbcd8598db1f0b$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $f8dbcd8598db1f0b$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($f8dbcd8598db1f0b$var$be(e)) return "";
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($f8dbcd8598db1f0b$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return (0, $3251146683c5d714$exports.isElement)(u) && console.warn($f8dbcd8598db1f0b$var$b(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), $f8dbcd8598db1f0b$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $f8dbcd8598db1f0b$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $f8dbcd8598db1f0b$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$f8dbcd8598db1f0b$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $f8dbcd8598db1f0b$var$E(t[i]) ? s.push($f8dbcd8598db1f0b$var$Ee(i) + ":", t[i], ";") : $f8dbcd8598db1f0b$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($f8dbcd8598db1f0b$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $2d512083a27c8269$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $f8dbcd8598db1f0b$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $f8dbcd8598db1f0b$var$E(e) || $f8dbcd8598db1f0b$var$g(e) ? $f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$_e($f8dbcd8598db1f0b$var$v($f8dbcd8598db1f0b$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$_e($f8dbcd8598db1f0b$var$v(e, n)));
}
var $f8dbcd8598db1f0b$var$Ce = /invalid hook call/i, $f8dbcd8598db1f0b$var$Ie = new Set, $f8dbcd8598db1f0b$var$Pe = function(e, t) {
    var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.", r = console.error;
    try {
        var o = !0;
        console.error = function(e) {
            if ($f8dbcd8598db1f0b$var$Ce.test(e)) o = !1, $f8dbcd8598db1f0b$var$Ie.delete(n);
            else {
                for(var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)s[i - 1] = arguments[i];
                r.apply(void 0, [
                    e
                ].concat(s));
            }
        }, (0, $acw62.useRef)(), o && !$f8dbcd8598db1f0b$var$Ie.has(n) && (console.warn(n), $f8dbcd8598db1f0b$var$Ie.add(n));
    } catch (e) {
        $f8dbcd8598db1f0b$var$Ce.test(e.message) && $f8dbcd8598db1f0b$var$Ie.delete(n);
    } finally{
        console.error = r;
    }
}, $f8dbcd8598db1f0b$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $f8dbcd8598db1f0b$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$De = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$je(e) {
    return e.replace($f8dbcd8598db1f0b$var$Re, "-").replace($f8dbcd8598db1f0b$var$De, "");
}
var $f8dbcd8598db1f0b$var$Te = function(e) {
    return $f8dbcd8598db1f0b$var$Q($f8dbcd8598db1f0b$var$te(e) >>> 0);
};
function $f8dbcd8598db1f0b$var$xe(e) {
    return "string" == typeof e && e.charAt(0) === e.charAt(0).toLowerCase();
}
var $f8dbcd8598db1f0b$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $f8dbcd8598db1f0b$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $f8dbcd8598db1f0b$var$Be(e, t, n) {
    var r = e[n];
    $f8dbcd8598db1f0b$var$ke(t) && $f8dbcd8598db1f0b$var$ke(r) ? $f8dbcd8598db1f0b$var$ze(r, t) : e[n] = t;
}
function $f8dbcd8598db1f0b$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($f8dbcd8598db1f0b$var$ke(i)) for(var a in i)$f8dbcd8598db1f0b$var$Ve(a) && $f8dbcd8598db1f0b$var$Be(e, i[a], a);
    }
    return e;
}
var $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var t = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), n = (0, $acw62.useMemo)(function() {
        return function(e, t) {
            if (!e) return $f8dbcd8598db1f0b$var$D(14);
            if ($f8dbcd8598db1f0b$var$E(e)) {
                var n = e(t);
                return null !== n && !Array.isArray(n) && "object" == typeof n ? n : $f8dbcd8598db1f0b$var$D(7);
            }
            return Array.isArray(e) || "object" != typeof e ? $f8dbcd8598db1f0b$var$D(8) : t ? $f8dbcd8598db1f0b$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Fe = {};
function $f8dbcd8598db1f0b$var$Ye(e, t, n) {
    var o = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), i = !$f8dbcd8598db1f0b$var$xe(e), a = t.attrs, c = void 0 === a ? $f8dbcd8598db1f0b$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$je(e);
        $f8dbcd8598db1f0b$var$Fe[n] = ($f8dbcd8598db1f0b$var$Fe[n] || 0) + 1;
        var r = n + "-" + $f8dbcd8598db1f0b$var$Te("5.3.11" + n + $f8dbcd8598db1f0b$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $f8dbcd8598db1f0b$var$xe(e) ? "styled." + e : "Styled(" + $f8dbcd8598db1f0b$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $f8dbcd8598db1f0b$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $f8dbcd8598db1f0b$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $f8dbcd8598db1f0b$var$w);
                var r = $f8dbcd8598db1f0b$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $f8dbcd8598db1f0b$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($f8dbcd8598db1f0b$var$Oe(t, (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), a) || $f8dbcd8598db1f0b$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $f8dbcd8598db1f0b$var$pe(), s = $f8dbcd8598db1f0b$var$fe(), i = t ? e.generateAndInjectStyles($f8dbcd8598db1f0b$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return !t && r && r(i), i;
            }(i, r, m, (0, e.warnTooManyClasses)), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $f8dbcd8598db1f0b$var$xe(b), N = v !== t ? $f8dbcd8598db1f0b$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $bcd4e42ca4163639$export$2e2bcd8739ae039), b) : !_ || (0, $bcd4e42ca4163639$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $f8dbcd8598db1f0b$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $acw62.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $f8dbcd8598db1f0b$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($f8dbcd8598db1f0b$var$xe(e) ? e : $f8dbcd8598db1f0b$var$je($f8dbcd8598db1f0b$var$b(e)));
        return $f8dbcd8598db1f0b$var$Ye(e, $f8dbcd8598db1f0b$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $f8dbcd8598db1f0b$var$ze({}, e.defaultProps, t) : t;
        }
    }), $f8dbcd8598db1f0b$var$Pe(p, v), A.warnTooManyClasses = function(e, t) {
        var n = {}, r = !1;
        return function(o) {
            if (!r && (n[o] = !0, Object.keys(n).length >= 200)) {
                var s = t ? ' with the id of "' + t + '"' : "";
                console.warn("Over 200 classes were generated for component " + e + s + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r = !0, n = {};
            }
        };
    }(p, v), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $f8dbcd8598db1f0b$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $f8dbcd8598db1f0b$var$w), !(0, $3251146683c5d714$exports.isValidElementType)(r)) return $f8dbcd8598db1f0b$var$D(1, String(r));
        var s = function() {
            return t(r, o, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($f8dbcd8598db1f0b$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $f8dbcd8598db1f0b$var$qe[e] = $f8dbcd8598db1f0b$var$qe(e);
});
var $f8dbcd8598db1f0b$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$ne(e), $f8dbcd8598db1f0b$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($f8dbcd8598db1f0b$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $f8dbcd8598db1f0b$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $f8dbcd8598db1f0b$var$Te(JSON.stringify(i)), u = new $f8dbcd8598db1f0b$var$He(i, a);
    function d(e) {
        var t = $f8dbcd8598db1f0b$var$pe(), n = $f8dbcd8598db1f0b$var$fe(), o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), d = (0, $acw62.useRef)(t.allocateGSInstance(a)).current;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(e.children) && console.warn("The global style component " + a + " was given child JSX. createGlobalStyle does not render children."), i.some(function(e) {
            return "string" == typeof e && -1 !== e.indexOf("@import");
        }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), t.server && h(d, e, t, o, n), (0, $acw62.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $f8dbcd8598db1f0b$var$P, n, o);
        else {
            var s = $f8dbcd8598db1f0b$var$y({}, t, {
                theme: $f8dbcd8598db1f0b$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return $f8dbcd8598db1f0b$var$Pe(a), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(d);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(e) {
    "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $f8dbcd8598db1f0b$var$Te(o);
    return new $f8dbcd8598db1f0b$var$ye(s, o);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $f8dbcd8598db1f0b$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $f8dbcd8598db1f0b$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $f8dbcd8598db1f0b$var$D(2);
            var n = ((t = {})[$f8dbcd8598db1f0b$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $f8dbcd8598db1f0b$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", $f8dbcd8598db1f0b$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $f8dbcd8598db1f0b$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $f8dbcd8598db1f0b$var$D(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, n) {
        var o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), i = e.defaultProps, a = $f8dbcd8598db1f0b$var$Oe(t, o, i);
        return void 0 === a && console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + $f8dbcd8598db1f0b$var$b(e) + '"'), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, $f8dbcd8598db1f0b$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(t, e), t.displayName = "WithTheme(" + $f8dbcd8598db1f0b$var$b(e) + ")", t;
}, $f8dbcd8598db1f0b$export$93d4e7f90805808f = function() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
}, $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$X,
    masterSheet: $f8dbcd8598db1f0b$var$de
};
"undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, 1 === window["__styled-components-init__"] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
var $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$qe;


function $d9d62761516cb445$var$n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
        default: e
    };
}
function $d9d62761516cb445$var$o(e) {
    if (e && e.__esModule) return e;
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var o = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, o.get ? o : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var $d9d62761516cb445$var$a, $d9d62761516cb445$var$l = $d9d62761516cb445$var$o($acw62), $d9d62761516cb445$var$r = $d9d62761516cb445$var$n($acw62), $d9d62761516cb445$var$i = $d9d62761516cb445$var$n($f8dbcd8598db1f0b$exports);
function $d9d62761516cb445$var$s(e, t) {
    return e[t];
}
function $d9d62761516cb445$var$d(e, t) {
    return t.split(".").reduce((e, t)=>{
        const n = t.match(/[^\]\\[.]+/g);
        if (n && n.length > 1) for(let t = 0; t < n.length; t++)return e[n[t]][n[t + 1]];
        return e[t];
    }, e);
}
function $d9d62761516cb445$var$c(e = [], t, n = 0) {
    return [
        ...e.slice(0, n),
        t,
        ...e.slice(n)
    ];
}
function $d9d62761516cb445$var$g(e = [], t, n = "id") {
    const o = e.slice(), a = $d9d62761516cb445$var$s(t, n);
    return a ? o.splice(o.findIndex((e)=>$d9d62761516cb445$var$s(e, n) === a), 1) : o.splice(o.findIndex((e)=>e === t), 1), o;
}
function $d9d62761516cb445$var$u(e) {
    return e.map((e, t)=>{
        const n = Object.assign(Object.assign({}, e), {
            sortable: e.sortable || !!e.sortFunction || void 0
        });
        return e.id || (n.id = t + 1), n;
    });
}
function $d9d62761516cb445$var$p(e, t) {
    return Math.ceil(e / t);
}
function $d9d62761516cb445$var$b(e, t) {
    return Math.min(e, t);
}
!function(e) {
    e.ASC = "asc", e.DESC = "desc";
}($d9d62761516cb445$var$a || ($d9d62761516cb445$var$a = {}));
const $d9d62761516cb445$var$m = ()=>null;
function $d9d62761516cb445$var$f(e, t = [], n = []) {
    let o = {}, a = [
        ...n
    ];
    return t.length && t.forEach((t)=>{
        if (!t.when || "function" != typeof t.when) throw new Error('"when" must be defined in the conditional style object and must be function');
        t.when(e) && (o = t.style || {}, t.classNames && (a = [
            ...a,
            ...t.classNames
        ]), "function" == typeof t.style && (o = t.style(e) || {}));
    }), {
        style: o,
        classNames: a.join(" ")
    };
}
function $d9d62761516cb445$var$h(e, t = [], n = "id") {
    const o = $d9d62761516cb445$var$s(e, n);
    return o ? t.some((e)=>$d9d62761516cb445$var$s(e, n) === o) : t.some((t)=>t === e);
}
function $d9d62761516cb445$var$w(e, t) {
    return t ? e.findIndex((e)=>$d9d62761516cb445$var$x(e.id, t)) : -1;
}
function $d9d62761516cb445$var$x(e, t) {
    return e == t;
}
function $d9d62761516cb445$var$C(e, t) {
    const n = !e.toggleOnSelectedRowsChange;
    switch(t.type){
        case "SELECT_ALL_ROWS":
            {
                const { keyField: n, rows: o, rowCount: a, mergeSelections: l } = t, r = !e.allSelected, i = !e.toggleOnSelectedRowsChange;
                if (l) {
                    const t = r ? [
                        ...e.selectedRows,
                        ...o.filter((t)=>!$d9d62761516cb445$var$h(t, e.selectedRows, n))
                    ] : e.selectedRows.filter((e)=>!$d9d62761516cb445$var$h(e, o, n));
                    return Object.assign(Object.assign({}, e), {
                        allSelected: r,
                        selectedCount: t.length,
                        selectedRows: t,
                        toggleOnSelectedRowsChange: i
                    });
                }
                return Object.assign(Object.assign({}, e), {
                    allSelected: r,
                    selectedCount: r ? a : 0,
                    selectedRows: r ? o : [],
                    toggleOnSelectedRowsChange: i
                });
            }
        case "SELECT_SINGLE_ROW":
            {
                const { keyField: o, row: a, isSelected: l, rowCount: r, singleSelect: i } = t;
                return i ? l ? Object.assign(Object.assign({}, e), {
                    selectedCount: 0,
                    allSelected: !1,
                    selectedRows: [],
                    toggleOnSelectedRowsChange: n
                }) : Object.assign(Object.assign({}, e), {
                    selectedCount: 1,
                    allSelected: !1,
                    selectedRows: [
                        a
                    ],
                    toggleOnSelectedRowsChange: n
                }) : l ? Object.assign(Object.assign({}, e), {
                    selectedCount: e.selectedRows.length > 0 ? e.selectedRows.length - 1 : 0,
                    allSelected: !1,
                    selectedRows: $d9d62761516cb445$var$g(e.selectedRows, a, o),
                    toggleOnSelectedRowsChange: n
                }) : Object.assign(Object.assign({}, e), {
                    selectedCount: e.selectedRows.length + 1,
                    allSelected: e.selectedRows.length + 1 === r,
                    selectedRows: $d9d62761516cb445$var$c(e.selectedRows, a),
                    toggleOnSelectedRowsChange: n
                });
            }
        case "SELECT_MULTIPLE_ROWS":
            {
                const { keyField: o, selectedRows: a, totalRows: l, mergeSelections: r } = t;
                if (r) {
                    const t = [
                        ...e.selectedRows,
                        ...a.filter((t)=>!$d9d62761516cb445$var$h(t, e.selectedRows, o))
                    ];
                    return Object.assign(Object.assign({}, e), {
                        selectedCount: t.length,
                        allSelected: !1,
                        selectedRows: t,
                        toggleOnSelectedRowsChange: n
                    });
                }
                return Object.assign(Object.assign({}, e), {
                    selectedCount: a.length,
                    allSelected: a.length === l,
                    selectedRows: a,
                    toggleOnSelectedRowsChange: n
                });
            }
        case "CLEAR_SELECTED_ROWS":
            {
                const { selectedRowsFlag: n } = t;
                return Object.assign(Object.assign({}, e), {
                    allSelected: !1,
                    selectedCount: 0,
                    selectedRows: [],
                    selectedRowsFlag: n
                });
            }
        case "SORT_CHANGE":
            {
                const { sortDirection: o, selectedColumn: a, clearSelectedOnSort: l } = t;
                return Object.assign(Object.assign(Object.assign({}, e), {
                    selectedColumn: a,
                    sortDirection: o,
                    currentPage: 1
                }), l && {
                    allSelected: !1,
                    selectedCount: 0,
                    selectedRows: [],
                    toggleOnSelectedRowsChange: n
                });
            }
        case "CHANGE_PAGE":
            {
                const { page: o, paginationServer: a, visibleOnly: l, persistSelectedOnPageChange: r } = t, i = a && r, s = a && !r || l;
                return Object.assign(Object.assign(Object.assign(Object.assign({}, e), {
                    currentPage: o
                }), i && {
                    allSelected: !1
                }), s && {
                    allSelected: !1,
                    selectedCount: 0,
                    selectedRows: [],
                    toggleOnSelectedRowsChange: n
                });
            }
        case "CHANGE_ROWS_PER_PAGE":
            {
                const { rowsPerPage: n, page: o } = t;
                return Object.assign(Object.assign({}, e), {
                    currentPage: o,
                    rowsPerPage: n
                });
            }
    }
}
const $d9d62761516cb445$var$y = $f8dbcd8598db1f0b$exports.css`
	pointer-events: none;
	opacity: 0.4;
`, $d9d62761516cb445$var$v = $d9d62761516cb445$var$i.default.div`
	position: relative;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	max-width: 100%;
	${({ disabled: e })=>e && $d9d62761516cb445$var$y};
	${({ theme: e })=>e.table.style};
`, $d9d62761516cb445$var$R = $f8dbcd8598db1f0b$exports.css`
	position: sticky;
	position: -webkit-sticky; /* Safari */
	top: 0;
	z-index: 1;
`, $d9d62761516cb445$var$S = $d9d62761516cb445$var$i.default.div`
	display: flex;
	width: 100%;
	${({ $fixedHeader: e })=>e && $d9d62761516cb445$var$R};
	${({ theme: e })=>e.head.style};
`, $d9d62761516cb445$var$E = $d9d62761516cb445$var$i.default.div`
	display: flex;
	align-items: stretch;
	width: 100%;
	${({ theme: e })=>e.headRow.style};
	${({ $dense: e, theme: t })=>e && t.headRow.denseStyle};
`, $d9d62761516cb445$var$O = (e, ...n)=>$f8dbcd8598db1f0b$exports.css`
		@media screen and (max-width: ${599}px) {
			${$f8dbcd8598db1f0b$exports.css(e, ...n)}
		}
	`, $d9d62761516cb445$var$$ = (e, ...n)=>$f8dbcd8598db1f0b$exports.css`
		@media screen and (max-width: ${959}px) {
			${$f8dbcd8598db1f0b$exports.css(e, ...n)}
		}
	`, $d9d62761516cb445$var$P = (e, ...n)=>$f8dbcd8598db1f0b$exports.css`
		@media screen and (max-width: ${1280}px) {
			${$f8dbcd8598db1f0b$exports.css(e, ...n)}
		}
	`, $d9d62761516cb445$var$k = (e)=>(n, ...o)=>$f8dbcd8598db1f0b$exports.css`
				@media screen and (max-width: ${e}px) {
					${$f8dbcd8598db1f0b$exports.css(n, ...o)}
				}
			`, $d9d62761516cb445$var$D = $d9d62761516cb445$var$i.default.div`
	position: relative;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	line-height: normal;
	${({ theme: e, $headCell: t })=>e[t ? "headCells" : "cells"].style};
	${({ $noPadding: e })=>e && "padding: 0"};
`, $d9d62761516cb445$var$H = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$D)`
	flex-grow: ${({ button: e, grow: t })=>0 === t || e ? 0 : t || 1};
	flex-shrink: 0;
	flex-basis: 0;
	max-width: ${({ maxWidth: e })=>e || "100%"};
	min-width: ${({ minWidth: e })=>e || "100px"};
	${({ width: e })=>e && $f8dbcd8598db1f0b$exports.css`
			min-width: ${e};
			max-width: ${e};
		`};
	${({ right: e })=>e && "justify-content: flex-end"};
	${({ button: e, center: t })=>(t || e) && "justify-content: center"};
	${({ compact: e, button: t })=>(e || t) && "padding: 0"};

	/* handle hiding cells */
	${({ hide: e })=>e && "sm" === e && $d9d62761516cb445$var$O`
    display: none;
  `};
	${({ hide: e })=>e && "md" === e && $d9d62761516cb445$var$$`
    display: none;
  `};
	${({ hide: e })=>e && "lg" === e && $d9d62761516cb445$var$P`
    display: none;
  `};
	${({ hide: e })=>e && Number.isInteger(e) && $d9d62761516cb445$var$k(e)`
    display: none;
  `};
`, $d9d62761516cb445$var$j = $f8dbcd8598db1f0b$exports.css`
	div:first-child {
		white-space: ${({ $wrapCell: e })=>e ? "normal" : "nowrap"};
		overflow: ${({ $allowOverflow: e })=>e ? "visible" : "hidden"};
		text-overflow: ellipsis;
	}
`, $d9d62761516cb445$var$F = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$H).attrs((e)=>({
        style: e.style
    }))`
	${({ $renderAsCell: e })=>!e && $d9d62761516cb445$var$j};
	${({ theme: e, $isDragging: t })=>t && e.cells.draggingStyle};
	${({ $cellStyle: e })=>e};
`;
var $d9d62761516cb445$var$T = $d9d62761516cb445$var$l.memo(function({ id: e, column: t, row: n, rowIndex: o, dataTag: a, isDragging: r, onDragStart: i, onDragOver: s, onDragEnd: c, onDragEnter: g, onDragLeave: u }) {
    const { style: p, classNames: b } = $d9d62761516cb445$var$f(n, t.conditionalCellStyles, [
        "rdt_TableCell"
    ]);
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$F, {
        id: e,
        "data-column-id": t.id,
        role: "cell",
        className: b,
        "data-tag": a,
        $cellStyle: t.style,
        $renderAsCell: !!t.cell,
        $allowOverflow: t.allowOverflow,
        button: t.button,
        center: t.center,
        compact: t.compact,
        grow: t.grow,
        hide: t.hide,
        maxWidth: t.maxWidth,
        minWidth: t.minWidth,
        right: t.right,
        width: t.width,
        $wrapCell: t.wrap,
        style: p,
        $isDragging: r,
        onDragStart: i,
        onDragOver: s,
        onDragEnd: c,
        onDragEnter: g,
        onDragLeave: u
    }, !t.cell && $d9d62761516cb445$var$l.createElement("div", {
        "data-tag": a
    }, function(e, t, n, o) {
        if (!t) return null;
        if ("string" != typeof t && "function" != typeof t) throw new Error("selector must be a . delimited string eg (my.property) or function (e.g. row => row.field");
        return n && "function" == typeof n ? n(e, o) : t && "function" == typeof t ? t(e, o) : $d9d62761516cb445$var$d(e, t);
    }(n, t.selector, t.format, o)), t.cell && t.cell(n, o, t, e));
});
var $d9d62761516cb445$var$I = $d9d62761516cb445$var$l.memo(function({ name: e, component: t = "input", componentOptions: n = {
    style: {}
}, indeterminate: o = !1, checked: a = !1, disabled: r = !1, onClick: i = $d9d62761516cb445$var$m }) {
    const s = t, d = "input" !== s ? n.style : ((e)=>Object.assign(Object.assign({
            fontSize: "18px"
        }, !e && {
            cursor: "pointer"
        }), {
            padding: 0,
            marginTop: "1px",
            verticalAlign: "middle",
            position: "relative"
        }))(r), c = $d9d62761516cb445$var$l.useMemo(()=>(function(e, ...t) {
            let n;
            return Object.keys(e).map((t)=>e[t]).forEach((o, a)=>{
                const l = e;
                "function" == typeof o && (n = Object.assign(Object.assign({}, l), {
                    [Object.keys(e)[a]]: o(...t)
                }));
            }), n || e;
        })(n, o), [
        n,
        o
    ]);
    return $d9d62761516cb445$var$l.createElement(s, Object.assign({
        type: "checkbox",
        ref: (e)=>{
            e && (e.indeterminate = o);
        },
        style: d,
        onClick: r ? $d9d62761516cb445$var$m : i,
        name: e,
        "aria-label": e,
        checked: a,
        disabled: r
    }, c, {
        onChange: $d9d62761516cb445$var$m
    }));
});
const $d9d62761516cb445$var$M = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$D)`
	flex: 0 0 48px;
	min-width: 48px;
	justify-content: center;
	align-items: center;
	user-select: none;
	white-space: nowrap;
`;
function $d9d62761516cb445$var$A({ name: e, keyField: t, row: n, rowCount: o, selected: a, selectableRowsComponent: r, selectableRowsComponentProps: i, selectableRowsSingle: s, selectableRowDisabled: d, onSelectedRow: c }) {
    const g = !(!d || !d(n));
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$M, {
        onClick: (e)=>e.stopPropagation(),
        className: "rdt_TableCell",
        $noPadding: !0
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$I, {
        name: e,
        component: r,
        componentOptions: i,
        checked: a,
        "aria-checked": a,
        onClick: ()=>{
            c({
                type: "SELECT_SINGLE_ROW",
                row: n,
                isSelected: a,
                keyField: t,
                rowCount: o,
                singleSelect: s
            });
        },
        disabled: g
    }));
}
const $d9d62761516cb445$var$L = $d9d62761516cb445$var$i.default.button`
	display: inline-flex;
	align-items: center;
	user-select: none;
	white-space: nowrap;
	border: none;
	background-color: transparent;
	${({ theme: e })=>e.expanderButton.style};
`;
function $d9d62761516cb445$var$_({ disabled: e = !1, expanded: t = !1, expandableIcon: n, id: o, row: a, onToggled: r }) {
    const i = t ? n.expanded : n.collapsed;
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$L, {
        "aria-disabled": e,
        onClick: ()=>r && r(a),
        "data-testid": `expander-button-${o}`,
        disabled: e,
        "aria-label": t ? "Collapse Row" : "Expand Row",
        role: "button",
        type: "button"
    }, i);
}
const $d9d62761516cb445$var$z = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$D)`
	white-space: nowrap;
	font-weight: 400;
	min-width: 48px;
	${({ theme: e })=>e.expanderCell.style};
`;
function $d9d62761516cb445$var$N({ row: e, expanded: t = !1, expandableIcon: n, id: o, onToggled: a, disabled: r = !1 }) {
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$z, {
        onClick: (e)=>e.stopPropagation(),
        $noPadding: !0
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$_, {
        id: o,
        row: e,
        expanded: t,
        expandableIcon: n,
        disabled: r,
        onToggled: a
    }));
}
const $d9d62761516cb445$var$W = $d9d62761516cb445$var$i.default.div`
	width: 100%;
	box-sizing: border-box;
	${({ theme: e })=>e.expanderRow.style};
	${({ $extendedRowStyle: e })=>e};
`;
var $d9d62761516cb445$var$B = $d9d62761516cb445$var$l.memo(function({ data: e, ExpanderComponent: t, expanderComponentProps: n, extendedRowStyle: o, extendedClassNames: a }) {
    const r = [
        "rdt_ExpanderRow",
        ...a.split(" ").filter((e)=>"rdt_TableRow" !== e)
    ].join(" ");
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$W, {
        className: r,
        $extendedRowStyle: o
    }, $d9d62761516cb445$var$l.createElement(t, Object.assign({
        data: e
    }, n)));
});
var $d9d62761516cb445$var$G, $d9d62761516cb445$var$V, $d9d62761516cb445$var$U;
$d9d62761516cb445$exports.Direction = void 0, ($d9d62761516cb445$var$G = $d9d62761516cb445$exports.Direction || ($d9d62761516cb445$exports.Direction = {})).LTR = "ltr", $d9d62761516cb445$var$G.RTL = "rtl", $d9d62761516cb445$var$G.AUTO = "auto", $d9d62761516cb445$exports.Alignment = void 0, ($d9d62761516cb445$var$V = $d9d62761516cb445$exports.Alignment || ($d9d62761516cb445$exports.Alignment = {})).LEFT = "left", $d9d62761516cb445$var$V.RIGHT = "right", $d9d62761516cb445$var$V.CENTER = "center", $d9d62761516cb445$exports.Media = void 0, ($d9d62761516cb445$var$U = $d9d62761516cb445$exports.Media || ($d9d62761516cb445$exports.Media = {})).SM = "sm", $d9d62761516cb445$var$U.MD = "md", $d9d62761516cb445$var$U.LG = "lg";
const $d9d62761516cb445$var$q = $f8dbcd8598db1f0b$exports.css`
	&:hover {
		${({ $highlightOnHover: e, theme: t })=>e && t.rows.highlightOnHoverStyle};
	}
`, $d9d62761516cb445$var$Y = $f8dbcd8598db1f0b$exports.css`
	&:hover {
		cursor: pointer;
	}
`, $d9d62761516cb445$var$K = $d9d62761516cb445$var$i.default.div.attrs((e)=>({
        style: e.style
    }))`
	display: flex;
	align-items: stretch;
	align-content: stretch;
	width: 100%;
	box-sizing: border-box;
	${({ theme: e })=>e.rows.style};
	${({ $dense: e, theme: t })=>e && t.rows.denseStyle};
	${({ $striped: e, theme: t })=>e && t.rows.stripedStyle};
	${({ $highlightOnHover: e })=>e && $d9d62761516cb445$var$q};
	${({ $pointerOnHover: e })=>e && $d9d62761516cb445$var$Y};
	${({ $selected: e, theme: t })=>e && t.rows.selectedHighlightStyle};
`;
function $d9d62761516cb445$var$J({ columns: e = [], conditionalRowStyles: t = [], defaultExpanded: n = !1, defaultExpanderDisabled: o = !1, dense: a = !1, expandableIcon: r, expandableRows: i = !1, expandableRowsComponent: d, expandableRowsComponentProps: c, expandableRowsHideExpander: g, expandOnRowClicked: u = !1, expandOnRowDoubleClicked: p = !1, highlightOnHover: b = !1, id: h, expandableInheritConditionalStyles: w, keyField: C, onRowClicked: y = $d9d62761516cb445$var$m, onRowDoubleClicked: v = $d9d62761516cb445$var$m, onRowMouseEnter: R = $d9d62761516cb445$var$m, onRowMouseLeave: S = $d9d62761516cb445$var$m, onRowExpandToggled: E = $d9d62761516cb445$var$m, onSelectedRow: O = $d9d62761516cb445$var$m, pointerOnHover: $ = !1, row: P, rowCount: k, rowIndex: D, selectableRowDisabled: H = null, selectableRows: j = !1, selectableRowsComponent: F, selectableRowsComponentProps: I, selectableRowsHighlight: M = !1, selectableRowsSingle: L = !1, selected: _, striped: z = !1, draggingColumnId: W, onDragStart: G, onDragOver: V, onDragEnd: U, onDragEnter: q, onDragLeave: Y }) {
    const [J, Q] = $d9d62761516cb445$var$l.useState(n);
    $d9d62761516cb445$var$l.useEffect(()=>{
        Q(n);
    }, [
        n
    ]);
    const X = $d9d62761516cb445$var$l.useCallback(()=>{
        Q(!J), E(!J, P);
    }, [
        J,
        E,
        P
    ]), Z = $ || i && (u || p), ee = $d9d62761516cb445$var$l.useCallback((e)=>{
        e.target && "allowRowEvents" === e.target.getAttribute("data-tag") && (y(P, e), !o && i && u && X());
    }, [
        o,
        u,
        i,
        X,
        y,
        P
    ]), te = $d9d62761516cb445$var$l.useCallback((e)=>{
        e.target && "allowRowEvents" === e.target.getAttribute("data-tag") && (v(P, e), !o && i && p && X());
    }, [
        o,
        p,
        i,
        X,
        v,
        P
    ]), ne = $d9d62761516cb445$var$l.useCallback((e)=>{
        R(P, e);
    }, [
        R,
        P
    ]), oe = $d9d62761516cb445$var$l.useCallback((e)=>{
        S(P, e);
    }, [
        S,
        P
    ]), ae = $d9d62761516cb445$var$s(P, C), { style: le, classNames: re } = $d9d62761516cb445$var$f(P, t, [
        "rdt_TableRow"
    ]), ie = M && _, se = w ? le : {}, de = z && D % 2 == 0;
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$l.Fragment, null, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$K, {
        id: `row-${h}`,
        role: "row",
        $striped: de,
        $highlightOnHover: b,
        $pointerOnHover: !o && Z,
        $dense: a,
        onClick: ee,
        onDoubleClick: te,
        onMouseEnter: ne,
        onMouseLeave: oe,
        className: re,
        $selected: ie,
        style: le
    }, j && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$A, {
        name: `select-row-${ae}`,
        keyField: C,
        row: P,
        rowCount: k,
        selected: _,
        selectableRowsComponent: F,
        selectableRowsComponentProps: I,
        selectableRowDisabled: H,
        selectableRowsSingle: L,
        onSelectedRow: O
    }), i && !g && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$N, {
        id: ae,
        expandableIcon: r,
        expanded: J,
        row: P,
        onToggled: X,
        disabled: o
    }), e.map((e)=>e.omit ? null : $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$T, {
            id: `cell-${e.id}-${ae}`,
            key: `cell-${e.id}-${ae}`,
            dataTag: e.ignoreRowClick || e.button ? null : "allowRowEvents",
            column: e,
            row: P,
            rowIndex: D,
            isDragging: $d9d62761516cb445$var$x(W, e.id),
            onDragStart: G,
            onDragOver: V,
            onDragEnd: U,
            onDragEnter: q,
            onDragLeave: Y
        }))), i && J && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$B, {
        key: `expander-${ae}`,
        data: P,
        extendedRowStyle: se,
        extendedClassNames: re,
        ExpanderComponent: d,
        expanderComponentProps: c
    }));
}
const $d9d62761516cb445$var$Q = $d9d62761516cb445$var$i.default.span`
	padding: 2px;
	color: inherit;
	flex-grow: 0;
	flex-shrink: 0;
	${({ $sortActive: e })=>e ? "opacity: 1" : "opacity: 0"};
	${({ $sortDirection: e })=>"desc" === e && "transform: rotate(180deg)"};
`, $d9d62761516cb445$var$X = ({ sortActive: e, sortDirection: t })=>$d9d62761516cb445$var$r.default.createElement($d9d62761516cb445$var$Q, {
        $sortActive: e,
        $sortDirection: t
    }, "\u25B2"), $d9d62761516cb445$var$Z = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$H)`
	${({ button: e })=>e && "text-align: center"};
	${({ theme: e, $isDragging: t })=>t && e.headCells.draggingStyle};
`, $d9d62761516cb445$var$ee = $f8dbcd8598db1f0b$exports.css`
	cursor: pointer;
	span.__rdt_custom_sort_icon__ {
		i,
		svg {
			transform: 'translate3d(0, 0, 0)';
			${({ sortActive: e })=>e ? "opacity: 1" : "opacity: 0"};
			color: inherit;
			font-size: 18px;
			height: 18px;
			width: 18px;
			backface-visibility: hidden;
			transform-style: preserve-3d;
			transition-duration: 95ms;
			transition-property: transform;
		}

		&.asc i,
		&.asc svg {
			transform: rotate(180deg);
		}
	}

	${({ sortActive: e })=>!e && $f8dbcd8598db1f0b$exports.css`
			&:hover,
			&:focus {
				opacity: 0.7;

				span,
				span.__rdt_custom_sort_icon__ * {
					opacity: 0.7;
				}
			}
		`};
`, $d9d62761516cb445$var$te = $d9d62761516cb445$var$i.default.div`
	display: inline-flex;
	align-items: center;
	justify-content: inherit;
	height: 100%;
	width: 100%;
	outline: none;
	user-select: none;
	overflow: hidden;
	${({ disabled: e })=>!e && $d9d62761516cb445$var$ee};
`, $d9d62761516cb445$var$ne = $d9d62761516cb445$var$i.default.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
var $d9d62761516cb445$var$oe = $d9d62761516cb445$var$l.memo(function({ column: e, disabled: t, draggingColumnId: n, selectedColumn: o = {}, sortDirection: r, sortIcon: i, sortServer: s, pagination: d, paginationServer: c, persistSelectedOnSort: g, selectableRowsVisibleOnly: u, onSort: p, onDragStart: b, onDragOver: m, onDragEnd: f, onDragEnter: h, onDragLeave: w }) {
    $d9d62761516cb445$var$l.useEffect(()=>{
        "string" == typeof e.selector && console.error(`Warning: ${e.selector} is a string based column selector which has been deprecated as of v7 and will be removed in v8. Instead, use a selector function e.g. row => row[field]...`);
    }, []);
    const [C, y] = $d9d62761516cb445$var$l.useState(!1), v = $d9d62761516cb445$var$l.useRef(null);
    if ($d9d62761516cb445$var$l.useEffect(()=>{
        v.current && y(v.current.scrollWidth > v.current.clientWidth);
    }, [
        C
    ]), e.omit) return null;
    const R = ()=>{
        if (!e.sortable && !e.selector) return;
        let t = r;
        $d9d62761516cb445$var$x(o.id, e.id) && (t = r === $d9d62761516cb445$var$a.ASC ? $d9d62761516cb445$var$a.DESC : $d9d62761516cb445$var$a.ASC), p({
            type: "SORT_CHANGE",
            sortDirection: t,
            selectedColumn: e,
            clearSelectedOnSort: d && c && !g || s || u
        });
    }, S = (e)=>$d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$X, {
            sortActive: e,
            sortDirection: r
        }), E = ()=>$d9d62761516cb445$var$l.createElement("span", {
            className: [
                r,
                "__rdt_custom_sort_icon__"
            ].join(" ")
        }, i), O = !(!e.sortable || !$d9d62761516cb445$var$x(o.id, e.id)), $ = !e.sortable || t, P = e.sortable && !i && !e.right, k = e.sortable && !i && e.right, D = e.sortable && i && !e.right, H = e.sortable && i && e.right;
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Z, {
        "data-column-id": e.id,
        className: "rdt_TableCol",
        $headCell: !0,
        allowOverflow: e.allowOverflow,
        button: e.button,
        compact: e.compact,
        grow: e.grow,
        hide: e.hide,
        maxWidth: e.maxWidth,
        minWidth: e.minWidth,
        right: e.right,
        center: e.center,
        width: e.width,
        draggable: e.reorder,
        $isDragging: $d9d62761516cb445$var$x(e.id, n),
        onDragStart: b,
        onDragOver: m,
        onDragEnd: f,
        onDragEnter: h,
        onDragLeave: w
    }, e.name && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$te, {
        "data-column-id": e.id,
        "data-sort-id": e.id,
        role: "columnheader",
        tabIndex: 0,
        className: "rdt_TableCol_Sortable",
        onClick: $ ? void 0 : R,
        onKeyPress: $ ? void 0 : (e)=>{
            "Enter" === e.key && R();
        },
        sortActive: !$ && O,
        disabled: $
    }, !$ && H && E(), !$ && k && S(O), "string" == typeof e.name ? $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ne, {
        title: C ? e.name : void 0,
        ref: v,
        "data-column-id": e.id
    }, e.name) : e.name, !$ && D && E(), !$ && P && S(O)));
});
const $d9d62761516cb445$var$ae = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$D)`
	flex: 0 0 48px;
	justify-content: center;
	align-items: center;
	user-select: none;
	white-space: nowrap;
	font-size: unset;
`;
function $d9d62761516cb445$var$le({ headCell: e = !0, rowData: t, keyField: n, allSelected: o, mergeSelections: a, selectedRows: r, selectableRowsComponent: i, selectableRowsComponentProps: s, selectableRowDisabled: d, onSelectAllRows: c }) {
    const g = r.length > 0 && !o, u = d ? t.filter((e)=>!d(e)) : t, p = 0 === u.length, b = Math.min(t.length, u.length);
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ae, {
        className: "rdt_TableCol",
        $headCell: e,
        $noPadding: !0
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$I, {
        name: "select-all-rows",
        component: i,
        componentOptions: s,
        onClick: ()=>{
            c({
                type: "SELECT_ALL_ROWS",
                rows: u,
                rowCount: b,
                mergeSelections: a,
                keyField: n
            });
        },
        checked: o,
        indeterminate: g,
        disabled: p
    }));
}
function $d9d62761516cb445$var$re(e = $d9d62761516cb445$exports.Direction.AUTO) {
    const t = "object" == typeof window, [n, o] = $d9d62761516cb445$var$l.useState(!1);
    return $d9d62761516cb445$var$l.useEffect(()=>{
        if (t) {
            if ("auto" !== e) o("rtl" === e);
            else {
                const e = !(!window.document || !window.document.createElement), t = document.getElementsByTagName("BODY")[0], n = document.getElementsByTagName("HTML")[0], a = "rtl" === t.dir || "rtl" === n.dir;
                o(e && a);
            }
        }
    }, [
        e,
        t
    ]), n;
}
const $d9d62761516cb445$var$ie = $d9d62761516cb445$var$i.default.div`
	display: flex;
	align-items: center;
	flex: 1 0 auto;
	height: 100%;
	color: ${({ theme: e })=>e.contextMenu.fontColor};
	font-size: ${({ theme: e })=>e.contextMenu.fontSize};
	font-weight: 400;
`, $d9d62761516cb445$var$se = $d9d62761516cb445$var$i.default.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-wrap: wrap;
`, $d9d62761516cb445$var$de = $d9d62761516cb445$var$i.default.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	box-sizing: inherit;
	z-index: 1;
	align-items: center;
	justify-content: space-between;
	display: flex;
	${({ $rtl: e })=>e && "direction: rtl"};
	${({ theme: e })=>e.contextMenu.style};
	${({ theme: e, $visible: t })=>t && e.contextMenu.activeStyle};
`;
function $d9d62761516cb445$var$ce({ contextMessage: e, contextActions: t, contextComponent: n, selectedCount: o, direction: a }) {
    const r = $d9d62761516cb445$var$re(a), i = o > 0;
    return n ? $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$de, {
        $visible: i
    }, $d9d62761516cb445$var$l.cloneElement(n, {
        selectedCount: o
    })) : $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$de, {
        $visible: i,
        $rtl: r
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ie, null, ((e, t, n)=>{
        if (0 === t) return null;
        const o = 1 === t ? e.singular : e.plural;
        return n ? `${t} ${e.message || ""} ${o}` : `${t} ${o} ${e.message || ""}`;
    })(e, o, r)), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$se, null, t));
}
const $d9d62761516cb445$var$ge = $d9d62761516cb445$var$i.default.div`
	position: relative;
	box-sizing: border-box;
	overflow: hidden;
	display: flex;
	flex: 1 1 auto;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	flex-wrap: wrap;
	${({ theme: e })=>e.header.style}
`, $d9d62761516cb445$var$ue = $d9d62761516cb445$var$i.default.div`
	flex: 1 0 auto;
	color: ${({ theme: e })=>e.header.fontColor};
	font-size: ${({ theme: e })=>e.header.fontSize};
	font-weight: 400;
`, $d9d62761516cb445$var$pe = $d9d62761516cb445$var$i.default.div`
	flex: 1 0 auto;
	display: flex;
	align-items: center;
	justify-content: flex-end;

	> * {
		margin-left: 5px;
	}
`, $d9d62761516cb445$var$be = ({ title: e, actions: t = null, contextMessage: n, contextActions: o, contextComponent: a, selectedCount: r, direction: i, showMenu: s = !0 })=>$d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ge, {
        className: "rdt_TableHeader",
        role: "heading",
        "aria-level": 1
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ue, null, e), t && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$pe, null, t), s && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ce, {
        contextMessage: n,
        contextActions: o,
        contextComponent: a,
        direction: i,
        selectedCount: r
    })) /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ ;
function $d9d62761516cb445$var$me(e, t) {
    var n = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for(o = Object.getOwnPropertySymbols(e); a < o.length; a++)t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (n[o[a]] = e[o[a]]);
    }
    return n;
}
const $d9d62761516cb445$var$fe = {
    left: "flex-start",
    right: "flex-end",
    center: "center"
}, $d9d62761516cb445$var$he = $d9d62761516cb445$var$i.default.header`
	position: relative;
	display: flex;
	flex: 1 1 auto;
	box-sizing: border-box;
	align-items: center;
	padding: 4px 16px 4px 24px;
	width: 100%;
	justify-content: ${({ align: e })=>$d9d62761516cb445$var$fe[e]};
	flex-wrap: ${({ $wrapContent: e })=>e ? "wrap" : "nowrap"};
	${({ theme: e })=>e.subHeader.style}
`, $d9d62761516cb445$var$we = (e)=>{
    var { align: t = "right", wrapContent: n = !0 } = e, o = $d9d62761516cb445$var$me(e, [
        "align",
        "wrapContent"
    ]);
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$he, Object.assign({
        align: t,
        $wrapContent: n
    }, o));
}, $d9d62761516cb445$var$xe = $d9d62761516cb445$var$i.default.div`
	display: flex;
	flex-direction: column;
`, $d9d62761516cb445$var$Ce = $d9d62761516cb445$var$i.default.div`
	position: relative;
	width: 100%;
	border-radius: inherit;
	${({ $responsive: e, $fixedHeader: n })=>e && $f8dbcd8598db1f0b$exports.css`
			overflow-x: auto;

			// hidden prevents vertical scrolling in firefox when fixedHeader is disabled
			overflow-y: ${n ? "auto" : "hidden"};
			min-height: 0;
		`};

	${({ $fixedHeader: e = !1, $fixedHeaderScrollHeight: n = "100vh" })=>e && $f8dbcd8598db1f0b$exports.css`
			max-height: ${n};
			-webkit-overflow-scrolling: touch;
		`};

	${({ theme: e })=>e.responsiveWrapper.style};
`, $d9d62761516cb445$var$ye = $d9d62761516cb445$var$i.default.div`
	position: relative;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	${(e)=>e.theme.progress.style};
`, $d9d62761516cb445$var$ve = $d9d62761516cb445$var$i.default.div`
	position: relative;
	width: 100%;
	${({ theme: e })=>e.tableWrapper.style};
`, $d9d62761516cb445$var$Re = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$D)`
	white-space: nowrap;
	${({ theme: e })=>e.expanderCell.style};
`, $d9d62761516cb445$var$Se = $d9d62761516cb445$var$i.default.div`
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	${({ theme: e })=>e.noData.style};
`, $d9d62761516cb445$var$Ee = ()=>$d9d62761516cb445$var$r.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, $d9d62761516cb445$var$r.default.createElement("path", {
        d: "M7 10l5 5 5-5z"
    }), $d9d62761516cb445$var$r.default.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    })), $d9d62761516cb445$var$Oe = $d9d62761516cb445$var$i.default.select`
	cursor: pointer;
	height: 24px;
	max-width: 100%;
	user-select: none;
	padding-left: 8px;
	padding-right: 24px;
	box-sizing: content-box;
	font-size: inherit;
	color: inherit;
	border: none;
	background-color: transparent;
	appearance: none;
	direction: ltr;
	flex-shrink: 0;

	&::-ms-expand {
		display: none;
	}

	&:disabled::-ms-expand {
		background: #f60;
	}

	option {
		color: initial;
	}
`, $d9d62761516cb445$var$$e = $d9d62761516cb445$var$i.default.div`
	position: relative;
	flex-shrink: 0;
	font-size: inherit;
	color: inherit;
	margin-top: 1px;

	svg {
		top: 0;
		right: 0;
		color: inherit;
		position: absolute;
		fill: currentColor;
		width: 24px;
		height: 24px;
		display: inline-block;
		user-select: none;
		pointer-events: none;
	}
`, $d9d62761516cb445$var$Pe = (e)=>{
    var { defaultValue: t, onChange: n } = e, o = $d9d62761516cb445$var$me(e, [
        "defaultValue",
        "onChange"
    ]);
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$$e, null, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Oe, Object.assign({
        onChange: n,
        defaultValue: t
    }, o)), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Ee, null));
}, $d9d62761516cb445$var$ke = {
    columns: [],
    data: [],
    title: "",
    keyField: "id",
    selectableRows: !1,
    selectableRowsHighlight: !1,
    selectableRowsNoSelectAll: !1,
    selectableRowSelected: null,
    selectableRowDisabled: null,
    selectableRowsComponent: "input",
    selectableRowsComponentProps: {},
    selectableRowsVisibleOnly: !1,
    selectableRowsSingle: !1,
    clearSelectedRows: !1,
    expandableRows: !1,
    expandableRowDisabled: null,
    expandableRowExpanded: null,
    expandOnRowClicked: !1,
    expandableRowsHideExpander: !1,
    expandOnRowDoubleClicked: !1,
    expandableInheritConditionalStyles: !1,
    expandableRowsComponent: function() {
        return $d9d62761516cb445$var$r.default.createElement("div", null, "To add an expander pass in a component instance via ", $d9d62761516cb445$var$r.default.createElement("strong", null, "expandableRowsComponent"), ". You can then access props.data from this component.");
    },
    expandableIcon: {
        collapsed: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
                fill: "currentColor",
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg"
            }, $d9d62761516cb445$var$r.default.createElement("path", {
                d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
            }), $d9d62761516cb445$var$r.default.createElement("path", {
                d: "M0-.25h24v24H0z",
                fill: "none"
            })), null),
        expanded: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
                fill: "currentColor",
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg"
            }, $d9d62761516cb445$var$r.default.createElement("path", {
                d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
            }), $d9d62761516cb445$var$r.default.createElement("path", {
                d: "M0-.75h24v24H0z",
                fill: "none"
            })), null)
    },
    expandableRowsComponentProps: {},
    progressPending: !1,
    progressComponent: $d9d62761516cb445$var$r.default.createElement("div", {
        style: {
            fontSize: "24px",
            fontWeight: 700,
            padding: "24px"
        }
    }, "Loading..."),
    persistTableHead: !1,
    sortIcon: null,
    sortFunction: null,
    sortServer: !1,
    striped: !1,
    highlightOnHover: !1,
    pointerOnHover: !1,
    noContextMenu: !1,
    contextMessage: {
        singular: "item",
        plural: "items",
        message: "selected"
    },
    actions: null,
    contextActions: null,
    contextComponent: null,
    defaultSortFieldId: null,
    defaultSortAsc: !0,
    responsive: !0,
    noDataComponent: $d9d62761516cb445$var$r.default.createElement("div", {
        style: {
            padding: "24px"
        }
    }, "There are no records to display"),
    disabled: !1,
    noTableHead: !1,
    noHeader: !1,
    subHeader: !1,
    subHeaderAlign: $d9d62761516cb445$exports.Alignment.RIGHT,
    subHeaderWrap: !0,
    subHeaderComponent: null,
    fixedHeader: !1,
    fixedHeaderScrollHeight: "100vh",
    pagination: !1,
    paginationServer: !1,
    paginationServerOptions: {
        persistSelectedOnSort: !1,
        persistSelectedOnPageChange: !1
    },
    paginationDefaultPage: 1,
    paginationResetDefaultPage: !1,
    paginationTotalRows: 0,
    paginationPerPage: 10,
    paginationRowsPerPageOptions: [
        10,
        15,
        20,
        25,
        30
    ],
    paginationComponent: null,
    paginationComponentOptions: {},
    paginationIconFirstPage: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
        }), $d9d62761516cb445$var$r.default.createElement("path", {
            fill: "none",
            d: "M24 24H0V0h24v24z"
        })), null),
    paginationIconLastPage: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
        }), $d9d62761516cb445$var$r.default.createElement("path", {
            fill: "none",
            d: "M0 0h24v24H0V0z"
        })), null),
    paginationIconNext: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
        }), $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
        })), null),
    paginationIconPrevious: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
        }), $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
        })), null),
    dense: !1,
    conditionalRowStyles: [],
    theme: "default",
    customStyles: {},
    direction: $d9d62761516cb445$exports.Direction.AUTO,
    onChangePage: $d9d62761516cb445$var$m,
    onChangeRowsPerPage: $d9d62761516cb445$var$m,
    onRowClicked: $d9d62761516cb445$var$m,
    onRowDoubleClicked: $d9d62761516cb445$var$m,
    onRowMouseEnter: $d9d62761516cb445$var$m,
    onRowMouseLeave: $d9d62761516cb445$var$m,
    onRowExpandToggled: $d9d62761516cb445$var$m,
    onSelectedRowsChange: $d9d62761516cb445$var$m,
    onSort: $d9d62761516cb445$var$m,
    onColumnOrderChange: $d9d62761516cb445$var$m
}, $d9d62761516cb445$var$De = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: !1,
    selectAllRowsItem: !1,
    selectAllRowsItemText: "All"
}, $d9d62761516cb445$var$He = $d9d62761516cb445$var$i.default.nav`
	display: flex;
	flex: 1 1 auto;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	padding-right: 8px;
	padding-left: 8px;
	width: 100%;
	${({ theme: e })=>e.pagination.style};
`, $d9d62761516cb445$var$je = $d9d62761516cb445$var$i.default.button`
	position: relative;
	display: block;
	user-select: none;
	border: none;
	${({ theme: e })=>e.pagination.pageButtonsStyle};
	${({ $isRTL: e })=>e && "transform: scale(-1, -1)"};
`, $d9d62761516cb445$var$Fe = $d9d62761516cb445$var$i.default.div`
	display: flex;
	align-items: center;
	border-radius: 4px;
	white-space: nowrap;
	${$d9d62761516cb445$var$O`
    width: 100%;
    justify-content: space-around;
  `};
`, $d9d62761516cb445$var$Te = $d9d62761516cb445$var$i.default.span`
	flex-shrink: 1;
	user-select: none;
`, $d9d62761516cb445$var$Ie = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$Te)`
	margin: 0 24px;
`, $d9d62761516cb445$var$Me = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$Te)`
	margin: 0 4px;
`;
var $d9d62761516cb445$var$Ae = $d9d62761516cb445$var$l.memo(function({ rowsPerPage: e, rowCount: t, currentPage: n, direction: o = $d9d62761516cb445$var$ke.direction, paginationRowsPerPageOptions: a = $d9d62761516cb445$var$ke.paginationRowsPerPageOptions, paginationIconLastPage: r = $d9d62761516cb445$var$ke.paginationIconLastPage, paginationIconFirstPage: i = $d9d62761516cb445$var$ke.paginationIconFirstPage, paginationIconNext: s = $d9d62761516cb445$var$ke.paginationIconNext, paginationIconPrevious: d = $d9d62761516cb445$var$ke.paginationIconPrevious, paginationComponentOptions: c = $d9d62761516cb445$var$ke.paginationComponentOptions, onChangeRowsPerPage: g = $d9d62761516cb445$var$ke.onChangeRowsPerPage, onChangePage: u = $d9d62761516cb445$var$ke.onChangePage }) {
    const b = (()=>{
        const e = "object" == typeof window;
        function t() {
            return {
                width: e ? window.innerWidth : void 0,
                height: e ? window.innerHeight : void 0
            };
        }
        const [n, o] = $d9d62761516cb445$var$l.useState(t);
        return $d9d62761516cb445$var$l.useEffect(()=>{
            if (!e) return ()=>null;
            function n() {
                o(t());
            }
            return window.addEventListener("resize", n), ()=>window.removeEventListener("resize", n);
        }, []), n;
    })(), m = $d9d62761516cb445$var$re(o), f = b.width && b.width > 599, h = $d9d62761516cb445$var$p(t, e), w = n * e, x = w - e + 1, C = 1 === n, y = n === h, v = Object.assign(Object.assign({}, $d9d62761516cb445$var$De), c), R = n === h ? `${x}-${t} ${v.rangeSeparatorText} ${t}` : `${x}-${w} ${v.rangeSeparatorText} ${t}`, S = $d9d62761516cb445$var$l.useCallback(()=>u(n - 1), [
        n,
        u
    ]), E = $d9d62761516cb445$var$l.useCallback(()=>u(n + 1), [
        n,
        u
    ]), O = $d9d62761516cb445$var$l.useCallback(()=>u(1), [
        u
    ]), $ = $d9d62761516cb445$var$l.useCallback(()=>u($d9d62761516cb445$var$p(t, e)), [
        u,
        t,
        e
    ]), P = $d9d62761516cb445$var$l.useCallback((e)=>g(Number(e.target.value), n), [
        n,
        g
    ]), k = a.map((e)=>$d9d62761516cb445$var$l.createElement("option", {
            key: e,
            value: e
        }, e));
    v.selectAllRowsItem && k.push($d9d62761516cb445$var$l.createElement("option", {
        key: -1,
        value: t
    }, v.selectAllRowsItemText));
    const D = $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Pe, {
        onChange: P,
        defaultValue: e,
        "aria-label": v.rowsPerPageText
    }, k);
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$He, {
        className: "rdt_Pagination"
    }, !v.noRowsPerPage && f && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$l.Fragment, null, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Me, null, v.rowsPerPageText), D), f && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Ie, null, R), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Fe, null, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$je, {
        id: "pagination-first-page",
        type: "button",
        "aria-label": "First Page",
        "aria-disabled": C,
        onClick: O,
        disabled: C,
        $isRTL: m
    }, i), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$je, {
        id: "pagination-previous-page",
        type: "button",
        "aria-label": "Previous Page",
        "aria-disabled": C,
        onClick: S,
        disabled: C,
        $isRTL: m
    }, d), !v.noRowsPerPage && !f && D, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$je, {
        id: "pagination-next-page",
        type: "button",
        "aria-label": "Next Page",
        "aria-disabled": y,
        onClick: E,
        disabled: y,
        $isRTL: m
    }, s), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$je, {
        id: "pagination-last-page",
        type: "button",
        "aria-label": "Last Page",
        "aria-disabled": y,
        onClick: $,
        disabled: y,
        $isRTL: m
    }, r)));
});
const $d9d62761516cb445$var$Le = (e, t)=>{
    const n = $d9d62761516cb445$var$l.useRef(!0);
    $d9d62761516cb445$var$l.useEffect(()=>{
        n.current ? n.current = !1 : e();
    }, t);
};
var $d9d62761516cb445$var$_e = function(e) {
    return function(e) {
        return !!e && "object" == typeof e;
    }(e) && !function(e) {
        var t = Object.prototype.toString.call(e);
        return "[object RegExp]" === t || "[object Date]" === t || function(e) {
            return e.$$typeof === $d9d62761516cb445$var$ze;
        }(e);
    }(e);
};
var $d9d62761516cb445$var$ze = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;
function $d9d62761516cb445$var$Ne(e, t) {
    var n;
    return !1 !== t.clone && t.isMergeableObject(e) ? $d9d62761516cb445$var$Ue((n = e, Array.isArray(n) ? [] : {}), e, t) : e;
}
function $d9d62761516cb445$var$We(e, t, n) {
    return e.concat(t).map(function(e) {
        return $d9d62761516cb445$var$Ne(e, n);
    });
}
function $d9d62761516cb445$var$Be(e) {
    return Object.keys(e).concat(function(e) {
        return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
            return e.propertyIsEnumerable(t);
        }) : [];
    }(e));
}
function $d9d62761516cb445$var$Ge(e, t) {
    try {
        return t in e;
    } catch (e) {
        return !1;
    }
}
function $d9d62761516cb445$var$Ve(e, t, n) {
    var o = {};
    return n.isMergeableObject(e) && $d9d62761516cb445$var$Be(e).forEach(function(t) {
        o[t] = $d9d62761516cb445$var$Ne(e[t], n);
    }), $d9d62761516cb445$var$Be(t).forEach(function(a) {
        (function(e, t) {
            return $d9d62761516cb445$var$Ge(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
        })(e, a) || ($d9d62761516cb445$var$Ge(e, a) && n.isMergeableObject(t[a]) ? o[a] = (function(e, t) {
            if (!t.customMerge) return $d9d62761516cb445$var$Ue;
            var n = t.customMerge(e);
            return "function" == typeof n ? n : $d9d62761516cb445$var$Ue;
        })(a, n)(e[a], t[a], n) : o[a] = $d9d62761516cb445$var$Ne(t[a], n));
    }), o;
}
function $d9d62761516cb445$var$Ue(e, t, n) {
    (n = n || {}).arrayMerge = n.arrayMerge || $d9d62761516cb445$var$We, n.isMergeableObject = n.isMergeableObject || $d9d62761516cb445$var$_e, n.cloneUnlessOtherwiseSpecified = $d9d62761516cb445$var$Ne;
    var o = Array.isArray(t);
    return o === Array.isArray(e) ? o ? n.arrayMerge(e, t, n) : $d9d62761516cb445$var$Ve(e, t, n) : $d9d62761516cb445$var$Ne(t, n);
}
$d9d62761516cb445$var$Ue.all = function(e, t) {
    if (!Array.isArray(e)) throw new Error("first argument should be an array");
    return e.reduce(function(e, n) {
        return $d9d62761516cb445$var$Ue(e, n, t);
    }, {});
};
var $d9d62761516cb445$var$qe = $d9d62761516cb445$var$Ue;
const $d9d62761516cb445$var$Ye = {
    text: {
        primary: "rgba(0, 0, 0, 0.87)",
        secondary: "rgba(0, 0, 0, 0.54)",
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    background: {
        default: "#FFFFFF"
    },
    context: {
        background: "#e3f2fd",
        text: "rgba(0, 0, 0, 0.87)"
    },
    divider: {
        default: "rgba(0,0,0,.12)"
    },
    button: {
        default: "rgba(0,0,0,.54)",
        focus: "rgba(0,0,0,.12)",
        hover: "rgba(0,0,0,.12)",
        disabled: "rgba(0, 0, 0, .18)"
    },
    selected: {
        default: "#e3f2fd",
        text: "rgba(0, 0, 0, 0.87)"
    },
    highlightOnHover: {
        default: "#EEEEEE",
        text: "rgba(0, 0, 0, 0.87)"
    },
    striped: {
        default: "#FAFAFA",
        text: "rgba(0, 0, 0, 0.87)"
    }
}, $d9d62761516cb445$var$Ke = {
    default: $d9d62761516cb445$var$Ye,
    light: $d9d62761516cb445$var$Ye,
    dark: {
        text: {
            primary: "#FFFFFF",
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(0,0,0,.12)"
        },
        background: {
            default: "#424242"
        },
        context: {
            background: "#E91E63",
            text: "#FFFFFF"
        },
        divider: {
            default: "rgba(81, 81, 81, 1)"
        },
        button: {
            default: "#FFFFFF",
            focus: "rgba(255, 255, 255, .54)",
            hover: "rgba(255, 255, 255, .12)",
            disabled: "rgba(255, 255, 255, .18)"
        },
        selected: {
            default: "rgba(0, 0, 0, .7)",
            text: "#FFFFFF"
        },
        highlightOnHover: {
            default: "rgba(0, 0, 0, .7)",
            text: "#FFFFFF"
        },
        striped: {
            default: "rgba(0, 0, 0, .87)",
            text: "#FFFFFF"
        }
    }
};
function $d9d62761516cb445$var$Je(e, t, n, o) {
    const [r, i] = $d9d62761516cb445$var$l.useState(()=>$d9d62761516cb445$var$u(e)), [s, d] = $d9d62761516cb445$var$l.useState(""), c = $d9d62761516cb445$var$l.useRef("");
    $d9d62761516cb445$var$Le(()=>{
        i($d9d62761516cb445$var$u(e));
    }, [
        e
    ]);
    const g = $d9d62761516cb445$var$l.useCallback((e)=>{
        var t, n, o;
        const { attributes: a } = e.target, l = null === (t = a.getNamedItem("data-column-id")) || void 0 === t ? void 0 : t.value;
        l && (c.current = (null === (o = null === (n = r[$d9d62761516cb445$var$w(r, l)]) || void 0 === n ? void 0 : n.id) || void 0 === o ? void 0 : o.toString()) || "", d(c.current));
    }, [
        r
    ]), p = $d9d62761516cb445$var$l.useCallback((e)=>{
        var n;
        const { attributes: o } = e.target, a = null === (n = o.getNamedItem("data-column-id")) || void 0 === n ? void 0 : n.value;
        if (a && c.current && a !== c.current) {
            const e = $d9d62761516cb445$var$w(r, c.current), n = $d9d62761516cb445$var$w(r, a), o = [
                ...r
            ];
            o[e] = r[n], o[n] = r[e], i(o), t(o);
        }
    }, [
        t,
        r
    ]), b = $d9d62761516cb445$var$l.useCallback((e)=>{
        e.preventDefault();
    }, []), m = $d9d62761516cb445$var$l.useCallback((e)=>{
        e.preventDefault();
    }, []), f = $d9d62761516cb445$var$l.useCallback((e)=>{
        e.preventDefault(), c.current = "", d("");
    }, []), h = function(e = !1) {
        return e ? $d9d62761516cb445$var$a.ASC : $d9d62761516cb445$var$a.DESC;
    }(o), x = $d9d62761516cb445$var$l.useMemo(()=>r[$d9d62761516cb445$var$w(r, null == n ? void 0 : n.toString())] || {}, [
        n,
        r
    ]);
    return {
        tableColumns: r,
        draggingColumnId: s,
        handleDragStart: g,
        handleDragEnter: p,
        handleDragOver: b,
        handleDragLeave: m,
        handleDragEnd: f,
        defaultSortDirection: h,
        defaultSortColumn: x
    };
}
var $d9d62761516cb445$var$Qe = $d9d62761516cb445$var$l.memo(function(e) {
    const { data: n = $d9d62761516cb445$var$ke.data, columns: o = $d9d62761516cb445$var$ke.columns, title: r = $d9d62761516cb445$var$ke.title, actions: i = $d9d62761516cb445$var$ke.actions, keyField: c = $d9d62761516cb445$var$ke.keyField, striped: g = $d9d62761516cb445$var$ke.striped, highlightOnHover: u = $d9d62761516cb445$var$ke.highlightOnHover, pointerOnHover: m = $d9d62761516cb445$var$ke.pointerOnHover, dense: f = $d9d62761516cb445$var$ke.dense, selectableRows: w = $d9d62761516cb445$var$ke.selectableRows, selectableRowsSingle: x = $d9d62761516cb445$var$ke.selectableRowsSingle, selectableRowsHighlight: y = $d9d62761516cb445$var$ke.selectableRowsHighlight, selectableRowsNoSelectAll: R = $d9d62761516cb445$var$ke.selectableRowsNoSelectAll, selectableRowsVisibleOnly: O = $d9d62761516cb445$var$ke.selectableRowsVisibleOnly, selectableRowSelected: $ = $d9d62761516cb445$var$ke.selectableRowSelected, selectableRowDisabled: P = $d9d62761516cb445$var$ke.selectableRowDisabled, selectableRowsComponent: k = $d9d62761516cb445$var$ke.selectableRowsComponent, selectableRowsComponentProps: H = $d9d62761516cb445$var$ke.selectableRowsComponentProps, onRowExpandToggled: j = $d9d62761516cb445$var$ke.onRowExpandToggled, onSelectedRowsChange: F = $d9d62761516cb445$var$ke.onSelectedRowsChange, expandableIcon: T = $d9d62761516cb445$var$ke.expandableIcon, onChangeRowsPerPage: I = $d9d62761516cb445$var$ke.onChangeRowsPerPage, onChangePage: M = $d9d62761516cb445$var$ke.onChangePage, paginationServer: A = $d9d62761516cb445$var$ke.paginationServer, paginationServerOptions: L = $d9d62761516cb445$var$ke.paginationServerOptions, paginationTotalRows: _ = $d9d62761516cb445$var$ke.paginationTotalRows, paginationDefaultPage: z = $d9d62761516cb445$var$ke.paginationDefaultPage, paginationResetDefaultPage: N = $d9d62761516cb445$var$ke.paginationResetDefaultPage, paginationPerPage: W = $d9d62761516cb445$var$ke.paginationPerPage, paginationRowsPerPageOptions: B = $d9d62761516cb445$var$ke.paginationRowsPerPageOptions, paginationIconLastPage: G = $d9d62761516cb445$var$ke.paginationIconLastPage, paginationIconFirstPage: V = $d9d62761516cb445$var$ke.paginationIconFirstPage, paginationIconNext: U = $d9d62761516cb445$var$ke.paginationIconNext, paginationIconPrevious: q = $d9d62761516cb445$var$ke.paginationIconPrevious, paginationComponent: Y = $d9d62761516cb445$var$ke.paginationComponent, paginationComponentOptions: K = $d9d62761516cb445$var$ke.paginationComponentOptions, responsive: Q = $d9d62761516cb445$var$ke.responsive, progressPending: X = $d9d62761516cb445$var$ke.progressPending, progressComponent: Z = $d9d62761516cb445$var$ke.progressComponent, persistTableHead: ee = $d9d62761516cb445$var$ke.persistTableHead, noDataComponent: te = $d9d62761516cb445$var$ke.noDataComponent, disabled: ne = $d9d62761516cb445$var$ke.disabled, noTableHead: ae = $d9d62761516cb445$var$ke.noTableHead, noHeader: re = $d9d62761516cb445$var$ke.noHeader, fixedHeader: ie = $d9d62761516cb445$var$ke.fixedHeader, fixedHeaderScrollHeight: se = $d9d62761516cb445$var$ke.fixedHeaderScrollHeight, pagination: de = $d9d62761516cb445$var$ke.pagination, subHeader: ce = $d9d62761516cb445$var$ke.subHeader, subHeaderAlign: ge = $d9d62761516cb445$var$ke.subHeaderAlign, subHeaderWrap: ue = $d9d62761516cb445$var$ke.subHeaderWrap, subHeaderComponent: pe = $d9d62761516cb445$var$ke.subHeaderComponent, noContextMenu: me = $d9d62761516cb445$var$ke.noContextMenu, contextMessage: fe = $d9d62761516cb445$var$ke.contextMessage, contextActions: he = $d9d62761516cb445$var$ke.contextActions, contextComponent: Ee = $d9d62761516cb445$var$ke.contextComponent, expandableRows: Oe = $d9d62761516cb445$var$ke.expandableRows, onRowClicked: $e = $d9d62761516cb445$var$ke.onRowClicked, onRowDoubleClicked: Pe = $d9d62761516cb445$var$ke.onRowDoubleClicked, onRowMouseEnter: De = $d9d62761516cb445$var$ke.onRowMouseEnter, onRowMouseLeave: He = $d9d62761516cb445$var$ke.onRowMouseLeave, sortIcon: je = $d9d62761516cb445$var$ke.sortIcon, onSort: Fe = $d9d62761516cb445$var$ke.onSort, sortFunction: Te = $d9d62761516cb445$var$ke.sortFunction, sortServer: Ie = $d9d62761516cb445$var$ke.sortServer, expandableRowsComponent: Me = $d9d62761516cb445$var$ke.expandableRowsComponent, expandableRowsComponentProps: _e = $d9d62761516cb445$var$ke.expandableRowsComponentProps, expandableRowDisabled: ze = $d9d62761516cb445$var$ke.expandableRowDisabled, expandableRowsHideExpander: Ne = $d9d62761516cb445$var$ke.expandableRowsHideExpander, expandOnRowClicked: We = $d9d62761516cb445$var$ke.expandOnRowClicked, expandOnRowDoubleClicked: Be = $d9d62761516cb445$var$ke.expandOnRowDoubleClicked, expandableRowExpanded: Ge = $d9d62761516cb445$var$ke.expandableRowExpanded, expandableInheritConditionalStyles: Ve = $d9d62761516cb445$var$ke.expandableInheritConditionalStyles, defaultSortFieldId: Ue = $d9d62761516cb445$var$ke.defaultSortFieldId, defaultSortAsc: Ye = $d9d62761516cb445$var$ke.defaultSortAsc, clearSelectedRows: Qe = $d9d62761516cb445$var$ke.clearSelectedRows, conditionalRowStyles: Xe = $d9d62761516cb445$var$ke.conditionalRowStyles, theme: Ze = $d9d62761516cb445$var$ke.theme, customStyles: et = $d9d62761516cb445$var$ke.customStyles, direction: tt = $d9d62761516cb445$var$ke.direction, onColumnOrderChange: nt = $d9d62761516cb445$var$ke.onColumnOrderChange, className: ot } = e, { tableColumns: at, draggingColumnId: lt, handleDragStart: rt, handleDragEnter: it, handleDragOver: st, handleDragLeave: dt, handleDragEnd: ct, defaultSortDirection: gt, defaultSortColumn: ut } = $d9d62761516cb445$var$Je(o, nt, Ue, Ye), [{ rowsPerPage: pt, currentPage: bt, selectedRows: mt, allSelected: ft, selectedCount: ht, selectedColumn: wt, sortDirection: xt, toggleOnSelectedRowsChange: Ct }, yt] = $d9d62761516cb445$var$l.useReducer($d9d62761516cb445$var$C, {
        allSelected: !1,
        selectedCount: 0,
        selectedRows: [],
        selectedColumn: ut,
        toggleOnSelectedRowsChange: !1,
        sortDirection: gt,
        currentPage: z,
        rowsPerPage: W,
        selectedRowsFlag: !1,
        contextMessage: $d9d62761516cb445$var$ke.contextMessage
    }), { persistSelectedOnSort: vt = !1, persistSelectedOnPageChange: Rt = !1 } = L, St = !(!A || !Rt && !vt), Et = de && !X && n.length > 0, Ot = Y || $d9d62761516cb445$var$Ae, $t = $d9d62761516cb445$var$l.useMemo(()=>((e = {}, t = "default", n = "default")=>{
            const o = $d9d62761516cb445$var$Ke[t] ? t : n;
            var a;
            return $d9d62761516cb445$var$qe({
                table: {
                    style: {
                        color: (a = $d9d62761516cb445$var$Ke[o]).text.primary,
                        backgroundColor: a.background.default
                    }
                },
                tableWrapper: {
                    style: {
                        display: "table"
                    }
                },
                responsiveWrapper: {
                    style: {}
                },
                header: {
                    style: {
                        fontSize: "22px",
                        color: a.text.primary,
                        backgroundColor: a.background.default,
                        minHeight: "56px",
                        paddingLeft: "16px",
                        paddingRight: "8px"
                    }
                },
                subHeader: {
                    style: {
                        backgroundColor: a.background.default,
                        minHeight: "52px"
                    }
                },
                head: {
                    style: {
                        color: a.text.primary,
                        fontSize: "12px",
                        fontWeight: 500
                    }
                },
                headRow: {
                    style: {
                        backgroundColor: a.background.default,
                        minHeight: "52px",
                        borderBottomWidth: "1px",
                        borderBottomColor: a.divider.default,
                        borderBottomStyle: "solid"
                    },
                    denseStyle: {
                        minHeight: "32px"
                    }
                },
                headCells: {
                    style: {
                        paddingLeft: "16px",
                        paddingRight: "16px"
                    },
                    draggingStyle: {
                        cursor: "move"
                    }
                },
                contextMenu: {
                    style: {
                        backgroundColor: a.context.background,
                        fontSize: "18px",
                        fontWeight: 400,
                        color: a.context.text,
                        paddingLeft: "16px",
                        paddingRight: "8px",
                        transform: "translate3d(0, -100%, 0)",
                        transitionDuration: "125ms",
                        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
                        willChange: "transform"
                    },
                    activeStyle: {
                        transform: "translate3d(0, 0, 0)"
                    }
                },
                cells: {
                    style: {
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        wordBreak: "break-word"
                    },
                    draggingStyle: {}
                },
                rows: {
                    style: {
                        fontSize: "13px",
                        fontWeight: 400,
                        color: a.text.primary,
                        backgroundColor: a.background.default,
                        minHeight: "48px",
                        "&:not(:last-of-type)": {
                            borderBottomStyle: "solid",
                            borderBottomWidth: "1px",
                            borderBottomColor: a.divider.default
                        }
                    },
                    denseStyle: {
                        minHeight: "32px"
                    },
                    selectedHighlightStyle: {
                        "&:nth-of-type(n)": {
                            color: a.selected.text,
                            backgroundColor: a.selected.default,
                            borderBottomColor: a.background.default
                        }
                    },
                    highlightOnHoverStyle: {
                        color: a.highlightOnHover.text,
                        backgroundColor: a.highlightOnHover.default,
                        transitionDuration: "0.15s",
                        transitionProperty: "background-color",
                        borderBottomColor: a.background.default,
                        outlineStyle: "solid",
                        outlineWidth: "1px",
                        outlineColor: a.background.default
                    },
                    stripedStyle: {
                        color: a.striped.text,
                        backgroundColor: a.striped.default
                    }
                },
                expanderRow: {
                    style: {
                        color: a.text.primary,
                        backgroundColor: a.background.default
                    }
                },
                expanderCell: {
                    style: {
                        flex: "0 0 48px"
                    }
                },
                expanderButton: {
                    style: {
                        color: a.button.default,
                        fill: a.button.default,
                        backgroundColor: "transparent",
                        borderRadius: "2px",
                        transition: "0.25s",
                        height: "100%",
                        width: "100%",
                        "&:hover:enabled": {
                            cursor: "pointer"
                        },
                        "&:disabled": {
                            color: a.button.disabled
                        },
                        "&:hover:not(:disabled)": {
                            cursor: "pointer",
                            backgroundColor: a.button.hover
                        },
                        "&:focus": {
                            outline: "none",
                            backgroundColor: a.button.focus
                        },
                        svg: {
                            margin: "auto"
                        }
                    }
                },
                pagination: {
                    style: {
                        color: a.text.secondary,
                        fontSize: "13px",
                        minHeight: "56px",
                        backgroundColor: a.background.default,
                        borderTopStyle: "solid",
                        borderTopWidth: "1px",
                        borderTopColor: a.divider.default
                    },
                    pageButtonsStyle: {
                        borderRadius: "50%",
                        height: "40px",
                        width: "40px",
                        padding: "8px",
                        margin: "px",
                        cursor: "pointer",
                        transition: "0.4s",
                        color: a.button.default,
                        fill: a.button.default,
                        backgroundColor: "transparent",
                        "&:disabled": {
                            cursor: "unset",
                            color: a.button.disabled,
                            fill: a.button.disabled
                        },
                        "&:hover:not(:disabled)": {
                            backgroundColor: a.button.hover
                        },
                        "&:focus": {
                            outline: "none",
                            backgroundColor: a.button.focus
                        }
                    }
                },
                noData: {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: a.text.primary,
                        backgroundColor: a.background.default
                    }
                },
                progress: {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: a.text.primary,
                        backgroundColor: a.background.default
                    }
                }
            }, e);
        })(et, Ze), [
        et,
        Ze
    ]), Pt = $d9d62761516cb445$var$l.useMemo(()=>Object.assign({}, "auto" !== tt && {
            dir: tt
        }), [
        tt
    ]), kt = $d9d62761516cb445$var$l.useMemo(()=>{
        if (Ie) return n;
        if ((null == wt ? void 0 : wt.sortFunction) && "function" == typeof wt.sortFunction) {
            const e = wt.sortFunction, t = xt === $d9d62761516cb445$var$a.ASC ? e : (t, n)=>-1 * e(t, n);
            return [
                ...n
            ].sort(t);
        }
        return function(e, t, n, o) {
            return t ? o && "function" == typeof o ? o(e.slice(0), t, n) : e.slice(0).sort((e, o)=>{
                let a, l;
                if ("string" == typeof t ? (a = $d9d62761516cb445$var$d(e, t), l = $d9d62761516cb445$var$d(o, t)) : (a = t(e), l = t(o)), "asc" === n) {
                    if (a < l) return -1;
                    if (a > l) return 1;
                }
                if ("desc" === n) {
                    if (a > l) return -1;
                    if (a < l) return 1;
                }
                return 0;
            }) : e;
        }(n, null == wt ? void 0 : wt.selector, xt, Te);
    }, [
        Ie,
        wt,
        xt,
        n,
        Te
    ]), Dt = $d9d62761516cb445$var$l.useMemo(()=>{
        if (de && !A) {
            const e = bt * pt, t = e - pt;
            return kt.slice(t, e);
        }
        return kt;
    }, [
        bt,
        de,
        A,
        pt,
        kt
    ]), Ht = $d9d62761516cb445$var$l.useCallback((e)=>{
        yt(e);
    }, []), jt = $d9d62761516cb445$var$l.useCallback((e)=>{
        yt(e);
    }, []), Ft = $d9d62761516cb445$var$l.useCallback((e)=>{
        yt(e);
    }, []), Tt = $d9d62761516cb445$var$l.useCallback((e, t)=>$e(e, t), [
        $e
    ]), It = $d9d62761516cb445$var$l.useCallback((e, t)=>Pe(e, t), [
        Pe
    ]), Mt = $d9d62761516cb445$var$l.useCallback((e, t)=>De(e, t), [
        De
    ]), At = $d9d62761516cb445$var$l.useCallback((e, t)=>He(e, t), [
        He
    ]), Lt = $d9d62761516cb445$var$l.useCallback((e)=>yt({
            type: "CHANGE_PAGE",
            page: e,
            paginationServer: A,
            visibleOnly: O,
            persistSelectedOnPageChange: Rt
        }), [
        A,
        Rt,
        O
    ]), _t = $d9d62761516cb445$var$l.useCallback((e)=>{
        const t = $d9d62761516cb445$var$p(_ || Dt.length, e), n = $d9d62761516cb445$var$b(bt, t);
        A || Lt(n), yt({
            type: "CHANGE_ROWS_PER_PAGE",
            page: n,
            rowsPerPage: e
        });
    }, [
        bt,
        Lt,
        A,
        _,
        Dt.length
    ]);
    if (de && !A && kt.length > 0 && 0 === Dt.length) {
        const e = $d9d62761516cb445$var$p(kt.length, pt), t = $d9d62761516cb445$var$b(bt, e);
        Lt(t);
    }
    $d9d62761516cb445$var$Le(()=>{
        F({
            allSelected: ft,
            selectedCount: ht,
            selectedRows: mt.slice(0)
        });
    }, [
        Ct
    ]), $d9d62761516cb445$var$Le(()=>{
        Fe(wt, xt, kt.slice(0));
    }, [
        wt,
        xt
    ]), $d9d62761516cb445$var$Le(()=>{
        M(bt, _ || kt.length);
    }, [
        bt
    ]), $d9d62761516cb445$var$Le(()=>{
        I(pt, bt);
    }, [
        pt
    ]), $d9d62761516cb445$var$Le(()=>{
        Lt(z);
    }, [
        z,
        N
    ]), $d9d62761516cb445$var$Le(()=>{
        if (de && A && _ > 0) {
            const e = $d9d62761516cb445$var$p(_, pt), t = $d9d62761516cb445$var$b(bt, e);
            bt !== t && Lt(t);
        }
    }, [
        _
    ]), $d9d62761516cb445$var$l.useEffect(()=>{
        yt({
            type: "CLEAR_SELECTED_ROWS",
            selectedRowsFlag: Qe
        });
    }, [
        x,
        Qe
    ]), $d9d62761516cb445$var$l.useEffect(()=>{
        if (!$) return;
        const e = kt.filter((e)=>$(e)), t = x ? e.slice(0, 1) : e;
        yt({
            type: "SELECT_MULTIPLE_ROWS",
            keyField: c,
            selectedRows: t,
            totalRows: kt.length,
            mergeSelections: St
        });
    }, [
        n,
        $
    ]);
    const zt = O ? Dt : kt, Nt = Rt || x || R;
    return $d9d62761516cb445$var$l.createElement($f8dbcd8598db1f0b$exports.ThemeProvider, {
        theme: $t
    }, !re && (!!r || !!i) && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$be, {
        title: r,
        actions: i,
        showMenu: !me,
        selectedCount: ht,
        direction: tt,
        contextActions: he,
        contextComponent: Ee,
        contextMessage: fe
    }), ce && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$we, {
        align: ge,
        wrapContent: ue
    }, pe), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Ce, Object.assign({
        $responsive: Q,
        $fixedHeader: ie,
        $fixedHeaderScrollHeight: se,
        className: ot
    }, Pt), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ve, null, X && !ee && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ye, null, Z), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$v, {
        disabled: ne,
        className: "rdt_Table",
        role: "table"
    }, !ae && (!!ee || kt.length > 0 && !X) && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$S, {
        className: "rdt_TableHead",
        role: "rowgroup",
        $fixedHeader: ie
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$E, {
        className: "rdt_TableHeadRow",
        role: "row",
        $dense: f
    }, w && (Nt ? $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$D, {
        style: {
            flex: "0 0 48px"
        }
    }) : $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$le, {
        allSelected: ft,
        selectedRows: mt,
        selectableRowsComponent: k,
        selectableRowsComponentProps: H,
        selectableRowDisabled: P,
        rowData: zt,
        keyField: c,
        mergeSelections: St,
        onSelectAllRows: jt
    })), Oe && !Ne && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Re, null), at.map((e)=>$d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$oe, {
            key: e.id,
            column: e,
            selectedColumn: wt,
            disabled: X || 0 === kt.length,
            pagination: de,
            paginationServer: A,
            persistSelectedOnSort: vt,
            selectableRowsVisibleOnly: O,
            sortDirection: xt,
            sortIcon: je,
            sortServer: Ie,
            onSort: Ht,
            onDragStart: rt,
            onDragOver: st,
            onDragEnd: ct,
            onDragEnter: it,
            onDragLeave: dt,
            draggingColumnId: lt
        })))), !kt.length && !X && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Se, null, te), X && ee && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ye, null, Z), !X && kt.length > 0 && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$xe, {
        className: "rdt_TableBody",
        role: "rowgroup"
    }, Dt.map((e, t)=>{
        const n = $d9d62761516cb445$var$s(e, c), o = function(e = "") {
            return "number" != typeof e && (!e || 0 === e.length);
        }(n) ? t : n, a = $d9d62761516cb445$var$h(e, mt, c), r = !!(Oe && Ge && Ge(e)), i = !!(Oe && ze && ze(e));
        return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$J, {
            id: o,
            key: o,
            keyField: c,
            "data-row-id": o,
            columns: at,
            row: e,
            rowCount: kt.length,
            rowIndex: t,
            selectableRows: w,
            expandableRows: Oe,
            expandableIcon: T,
            highlightOnHover: u,
            pointerOnHover: m,
            dense: f,
            expandOnRowClicked: We,
            expandOnRowDoubleClicked: Be,
            expandableRowsComponent: Me,
            expandableRowsComponentProps: _e,
            expandableRowsHideExpander: Ne,
            defaultExpanderDisabled: i,
            defaultExpanded: r,
            expandableInheritConditionalStyles: Ve,
            conditionalRowStyles: Xe,
            selected: a,
            selectableRowsHighlight: y,
            selectableRowsComponent: k,
            selectableRowsComponentProps: H,
            selectableRowDisabled: P,
            selectableRowsSingle: x,
            striped: g,
            onRowExpandToggled: j,
            onRowClicked: Tt,
            onRowDoubleClicked: It,
            onRowMouseEnter: Mt,
            onRowMouseLeave: At,
            onSelectedRow: Ft,
            draggingColumnId: lt,
            onDragStart: rt,
            onDragOver: st,
            onDragEnd: ct,
            onDragEnter: it,
            onDragLeave: dt
        });
    }))))), Et && $d9d62761516cb445$var$l.createElement("div", null, $d9d62761516cb445$var$l.createElement(Ot, {
        onChangePage: Lt,
        onChangeRowsPerPage: _t,
        rowCount: _ || kt.length,
        currentPage: bt,
        rowsPerPage: pt,
        direction: tt,
        paginationRowsPerPageOptions: B,
        paginationIconLastPage: G,
        paginationIconFirstPage: V,
        paginationIconNext: U,
        paginationIconPrevious: q,
        paginationComponentOptions: K
    })));
});
$d9d62761516cb445$exports.STOP_PROP_TAG = "allowRowEvents", $d9d62761516cb445$exports.createTheme = function(e = "default", t, n = "default") {
    return $d9d62761516cb445$var$Ke[e] || ($d9d62761516cb445$var$Ke[e] = $d9d62761516cb445$var$qe($d9d62761516cb445$var$Ke[n], t || {})), $d9d62761516cb445$var$Ke[e] = $d9d62761516cb445$var$qe($d9d62761516cb445$var$Ke[e], t || {}), $d9d62761516cb445$var$Ke[e];
}, $d9d62761516cb445$exports.default = $d9d62761516cb445$var$Qe, $d9d62761516cb445$exports.defaultThemes = $d9d62761516cb445$var$Ke;









var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");


const $e8e01c44718aa32b$var$DiscographyCheckboxList = ({ selectAllOnChange: selectAllOnChange, onCheckboxChange: onCheckboxChange, societyList: societyList })=>{
    const [checkedValues, setCheckedValues] = (0, $acw62.useState)([]);
    const [isCheckedAll, setIsCheckedAll] = (0, $acw62.useState)(false);
    const societyCheckBoxList = societyList.map((society)=>{
        return {
            value: society.id,
            label: society.label
        };
    });
    const { setIsEditing: setIsEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    setIsEditing(true);
    (0, $acw62.useEffect)(()=>{
        // list of society ID's if society.isChecked is true
        const checkedSocieties = societyList.filter((society)=>society.isChecked).map((society)=>society.id);
        setCheckedValues(checkedSocieties);
    }, [
        societyList
    ]);
    (0, $acw62.useEffect)(()=>{
        // iterate through societies, if all are checked set isCheckedAll to true
        const checkedSocieties = societyList.filter((society)=>!society.isChecked);
        if (checkedSocieties.length !== 0) setIsCheckedAll(false);
        else setIsCheckedAll(true);
    }, [
        societyList
    ]);
    const grid = "tw-grid-cols-2 tw-gap-2";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7248374da9a479ee$export$796f1daee04ec730), {
                    name: "selectAll",
                    label: "",
                    options: [
                        {
                            value: "select all",
                            label: "Select All"
                        }
                    ],
                    defaultCheckedValues: isCheckedAll ? [
                        "select all"
                    ] : [],
                    onChange: ({ newValues: newValues })=>{
                        selectAllOnChange(!isCheckedAll);
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7248374da9a479ee$export$796f1daee04ec730), {
                    name: "society",
                    label: "",
                    checkboxSize: "xs",
                    options: societyCheckBoxList,
                    defaultCheckedValues: checkedValues,
                    onChange: ({ oldValues: oldValues, newValues: newValues })=>{
                        selectAllOnChange(false);
                        // Find the changed checkbox
                        const diff = oldValues.filter((x)=>!newValues.includes(x));
                        const diff2 = newValues.filter((x)=>!oldValues.includes(x));
                        // check if it was checked or unchecked
                        if (diff.length > 0) onCheckboxChange(diff[0]);
                        else onCheckboxChange(diff2[0]);
                    },
                    grid: "tw-grid-cols-2 tw-gap-2"
                })
            ]
        })
    });
};
var $e8e01c44718aa32b$export$2e2bcd8739ae039 = $e8e01c44718aa32b$var$DiscographyCheckboxList;





const $7c6052a69acf71cc$export$828397361e60d675 = ({ isOpen: isOpen, onClose: onClose, userId: userId })=>{
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [societyOptions, setSocietyOptions] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [successful, setSuccessful] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    const fetchData = async ()=>{
        if (!userId) throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("User ID is required"));
        setIsLoading(true);
        let termsOfAgreementData = undefined;
        try {
            termsOfAgreementData = await api.retrieveTermsOfAgreement({
                userId: userId
            });
        } catch (error) {
        // don't throw error if terms of agreement is not found - user may not have created one yet
        }
        try {
            let societiesData = await api.listAdminSocieties();
            if (termsOfAgreementData && !termsOfAgreementData.universalMandate) societiesData = societiesData.filter((society)=>{
                return termsOfAgreementData?.mandatedSocieties?.includes(society.id ?? "");
            });
            setSocietyOptions(societiesData.map((society)=>({
                    id: society.id,
                    label: society.readableName,
                    isChecked: false
                })));
        } catch (error) {
            console.log(error);
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Society Discography Generation Failed. Please try again later"));
            onClose();
        } finally{
            setIsLoading(false);
        }
    };
    const handleSelectAllChange = (checked)=>{
        const updatedSocietyList = societyOptions.map((society)=>({
                ...society,
                isChecked: checked
            }));
        setSocietyOptions(updatedSocietyList);
    };
    const handleIndividualCheckboxChange = (societyId)=>{
        const updatedSocietyList = societyOptions.map((society)=>society.id === societyId ? {
                ...society,
                isChecked: !society.isChecked
            } : society);
        setSocietyOptions(updatedSocietyList);
    };
    const handleSubmit = async ()=>{
        setIsLoading(true);
        let societyIds = societyOptions.filter((society)=>society.isChecked).map((society)=>society.id);
        if (societyIds.length === 0) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Please select at least one society"));
            setIsLoading(false);
            onClose();
            return;
        }
        return api.generateSecondaryDiscography({
            userId: userId,
            secondaryDiscography: {
                societyIds: societyIds
            }
        }).then(()=>{
            setSuccessful(true);
        }).catch(async (error)=>{
            const title = "Society Discography Generation Failed";
            let message = "Something went wrong";
            if (error.response.status === 400) {
                const data = await error.response.json();
                const childMessages = data.society_ids ?? [];
                if (childMessages.length) message = childMessages[0];
            }
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)(message, undefined, title));
            return Promise.reject();
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    const onSuccess = ()=>{
        setSuccessful(true);
    };
    if (successful) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        title: "",
        isOpen: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
            title: "Society Discography Generation In Progress",
            description: "You can view progress of society discography generation on the artist\u2019s Discography tab",
            cta: {
                ctaText: "Go To Discography Page ",
                onClick: ()=>{
                    navigate("/discography");
                }
            }
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        title: "Society Discography Submission",
        isOpen: isOpen,
        onClose: onClose,
        modalClasses: "tw-max-h-[95vh] tw-overflow-y-scroll",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            handleSubmit: handleSubmit,
            schema: undefined,
            onSuccess: onSuccess,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-row tw-justify-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-pr-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-font-light tw-pb-4",
                                children: "Choose the societies to receive the discography"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            label: "Generate Society Discographies",
                            onClick: handleSubmit,
                            variant: "primary"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-w-full tw-flex tw-flex-col",
                    children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-my-auto tw-animate-ping",
                            children: "\u26AA"
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e8e01c44718aa32b$export$2e2bcd8739ae039), {
                        selectAllOnChange: handleSelectAllChange,
                        societyList: societyOptions,
                        onCheckboxChange: handleIndividualCheckboxChange
                    })
                })
            ]
        })
    });
};






var $0cb68ff8dfba6508$exports = {};
$0cb68ff8dfba6508$exports = JSON.parse('{"12 string guitar":"guitar","12-string bass":"bass-guitar","12-string guitar":"guitar","17-string bass koto":"koto","5-string banjo":"banjo","6-string banjo":"banjo","6-string bass":"bass-guitar","8-string bass guitar":"bass-guitar","accompanist":"general","accordina":"accordion","accordion":"accordion","acoustic bass":"acoustic-bass","acoustic piano":"keyboards","achere":"","acoustic bass guitar":"acoustic-bass","acoustic fretless guitar":"acoustic-guitar","acoustic guitar":"acoustic-guitar","acoustic piccolo bass":"acoustic-bass","actor":"general","adufe":"","aeolian harp":"harp","afoxe":"","african congo drums":"percussion","afuche":"","agogo":"","ajaeng":"strings","akete":"","aketse":"","akkordolia":"zither","alfaia":"","algaita":"","alghoza":"","alphorn":"alphorn","alto vocals":"vocals","alto clarinet":"clarinet","alto crumhorn":"woodwind","alto flute":"flute","alto horn":"horn","alto recorder":"recorder","alto saxophone":"saxophone","alto trombone":"trombone","alto valve trombone":"trombone","alto viol":"strings","alto violin":"violin","amadinda":"","aman khuur":"","ambtara":"","analog synthesizer":"synthesizer","anandalahari":"","anatara":"","andean flute":"flute","andean harp":"harp","angklung":"","anglo concertina":"","vocals":"vocals","ankle rattlers":"percussion","announcer":"general","antara":"","anvil":"percussion","apentemma":"","apito":"","apongalahy":"","appalachian dulcimer":"general","archlute":"strings","archtop guitar":"guitar","arco bass":"double-bass","arghul":"","arpa":"","arpeggione":"","arrabel":"","artist":"contributor","artistic narrative narrator":"general","artistic producer":"producer","ashiko":"","asiko":"","associate producer":"producer","atabal":"","atabaque":"","atarigane":"","atchere":"","audio generator":"synthesizer","autoharp":"autoharp","baandu":"","babasa":"","baby grand piano":"grand-piano","background studio singer":"vocals","backing band":"general","backing vocals":"vocals","baglama":"","bagpipes":"bagpipes","bajo":"","bajo quinto":"","bajo sexto":"strings","balafon":"","balalaika":"strings","baltic psalteries":"","bambaro":"","bamboo flute":"flute","band":"general","band/ensemble member":"general","bandola":"strings","bandolin":"strings","bandoneon":"strings","bandora":"strings","bandura":"strings","bandurria":"strings","bangu":"","banhu":"strings","banjitar":"strings","banjo":"banjo","banjo-dulcimer":"banjo","banjo-mandolin":"mandolin","banjo-ukulele":"banjo","banjolin":"banjo","banjulele":"banjo","bankia":"","bansuri":"","bapang":"","bara":"","barbat":"","baritone saxhorn":"brass","baritone vocals":"vocals","baritone clarinet":"clarinet","baritone guitar":"guitar","baritone horn":"horn","baritone saxophone":"saxophone","baroque guitar":"guitar","baroque trumpet":"trumpet","barrel drum":"percussion","barrel organ":"keyboards","barrel piano":"keyboards","baryton":"","bass":"bass-guitar","bass vocals":"vocals","bass accordion":"accordion","bass clarinet":"bass-clarinet","bass concertina":"","bass crumhorn":"woodwind","bass drum":"bsss-drum","bass dulcian":"","bass fado viola":"strings","bass flute":"flute","bass guitar":"bass-guitar","bass harmonica":"mouth-organ","bass lute":"strings","bass marimba":"","bass oboe":"oboe","bass pedals":"","bass racket":"","bass recorder":"recorder","bass saxophone":"saxophone","bass synthesizer":"synthesizer","bass tambura":"","bass trombone":"trombone","bass trumpet":"trumpet","bass tuba":"tuba","bass viol":"strings","bass violin":"strings","bass-baritone vocals":"vocals","basset clarinet":"woodwind","basset horn":"","basso continuo":"","bassoon":"bassoon","basy":"","bata drum":"percussion","bawu":"","bayan":"","bazooka":"","beatbox":"general","programming":"programming","bedug":"","bell":"bell","bell plate":"bells","bell tree":"bells","bell-piano":"bells","bellow-blown bagpipes":"bagpipes","bellowed reed":"","bellowphone":"","bells":"bells","bembe":"","bendir":"","berda":"","berimbau":"","bhapang":"","bicycle bell":"bells","big drum":"percussion","bin":"","bin-sasara":"","bin-sitar":"","biniou":"","birbyne":"","birch lur":"","bisernica":"","biwa":"","blaster beam":"","blues harp":"mouth-organ","bo (bell)":"bells","bo (cymbals)":"percussion","flute":"flute","boatswain\'s pipe":"","bodhran":"percussion","body percussion":"percussion","bolivian flute":"flute","bolon":"","bombarde":"","bombardon":"","bombo":"bombo","bombo (bass drum)":"bombo","bombo (frame drum)":"bombo","bombo (mouth bom)":"","bombo leguero":"","bonang":"","bonang barung":"","bonang panembung":"","bonang panerus":"","bones":"","bongo":"bongos","bongos":"bongos","boobam":"","boobams":"","boomwhacker":"","border pipes":"bagpipes","bordonua":"","bottle":"","bouzar":"","bouzar / gouzouki":"","bouzouki":"strings","bowed lute":"strings","bowed lyre":"strings","bowed piano":"","bowed psaltery":"","bowed string instruments":"strings","box zither":"zither","brac":"","braguinha":"","brass":"brass","brass band":"brass","brass bass":"brass","bronze lur":"","broom":"","brushes":"","bucium":"","bugarija":"","bugle":"brass","buhay":"","buisine":"","buk":"","bukkehorn":"","bulbul tarang":"","bull fiddle":"strings","bullroarer":"","button accordion":"accordion","buzuq":"","byzaanchi":"","c melody saxophone":"saxophone","c-bass recorder":"recorder","c-melody saxophone":"saxophone","cabasa":"cabasa","cadenza":"","caixa":"","caja":"","caja vallenata":"","cajas rumberas":"","cajon":"","cajon peruano":"","calabash":"","caller":"","calliope":"","calung":"","campana":"","cantor":"","caramusa":"","carillon":"","carnyx":"","castanets":"castanets","cavaco":"","cavaquinho":"","caxixi":"","celesta":"","cello":"cello","cello banjo":"banjo","cembalet":"","ceng ceng":"","cetara":"","cevgen":"","chacaras":"","chacha":"","chak\'chas":"","chakhe":"","chalumeau":"","chamber organ":"keyboards","chamber pipes":"","chamberlin":"","chande":"","changgo":"","changi":"","chansonnier":"","chanter":"","chanzy":"","chap":"","chap lek":"","chapman stick":"","charamel":"","charango":"","chasquidos":"","chau gong":"","chekere":"","cheng":"","chikuzen biwa":"","chime bar":"","chimes":"chimes","chimes/carillion":"chimes","chinchin":"","chinese drum":"percussion","chinese flute":"flute","chinese harp":"harp","ching":"","ching (cymbals)":"percussion","chirimia":"","chitarra battente":"","chitarrone":"","chitra veena":"","chiwata":"","chocalho":"","choir":"vocals","choir member":"vocals","choir singer":"vocals","choir singing":"vocals","choir stand-in":"vocals","chonguri":"","conductor":"conductor","chromatic button accordion":"accordion","chromatic harmonica":"mouth-organ","chuniri":"","church organ":"organ","chuurqin":"","cifteli":"","cigar box guitar":"guitar","cimbalom":"","cimbasso":"","cimpoi":"","cinema organ":"organ","cither":"","citole":"","cittern":"","cizhonghu":"","handclaps":"hand-claps","clap sticks":"percussion","clapper":"percussion","clapstick":"percussion","clarin cajamarquino":"","clarinet":"clarinet","clarinet (c)":"clarinet","clarinet (e flat)":"clarinet","clarion":"","clarsach":"harp","classical guitar":"guitar","classical kemence":"","claves":"claves","clavichord":"","clavier":"","clavinet":"","claviola":"","clavioline":"","claviorgan":"","claviorganum":"","clog":"","clog dancer":"","co ke":"","producer":"producer","cobza":"","colascione":"","comb":"","commentator":"general","computer":"general","concert band":"general","concert flute":"flute","concert grand piano":"grand-piano","concert harp":"harp","concertina":"","violin":"violin","conch":"","concussion idiophone":"","conga":"congas","continuum":"","contra-alto clarinet":"clarinet","contrabass":"","contrabass clarinet":"bass-clarinet","contrabass flute":"flute","contrabass recorder":"recorder","contrabass saxophone":"saxophone","contrabass trombone":"trombone","contrabassoon":"contrabassoon","contralto vocals":"vocals","contributor":"contributor","cor anglais":"english-horn","cornamuse":"","cornet":"cornet","cornett":"","corno da caccia":"","coro":"","countertenor vocals":"","cowbell":"cow-bell","crash cymbals":"cymbal","craviola":"","cretan lyra":"","cristal baschet":"","cromorne":"","crotales":"","crumhorn":"woodwind","crwth":"","cuatro":"","cuica":"","cultrun":"","cumbus":"","cura":"","curtal":"","cyla-diare":"","cylindrical drum":"percussion","cymbal":"cymbal","daegeum":"","daf":"","daire":"","daluo":"","damaru":"","dan bau":"","dan nguyet":"","dan nhi":"","dan tam":"","dan tam thap luc":"","dan tranh":"","dan tu":"","dan tu day":"","dan ty ba":"","danburo":"","danso":"","darabuka":"","daruan":"","davul":"","daxaphone":"","deaejeng":"","denis d\'or":"","dhol":"","dholak":"","di (slit drum)":"","di (flute)":"","diaff":"","diatonic button accordion":"accordion","diddley bow":"","didgeridoo":"didgeridoo","dikanza":"","dili tuiduk":"","dilruba":"","ding buot":"","ding nam":"","ding tac ta":"","diple":"","disk drive":"","diyingehu":"","dizi":"","scratches":"","djembe":"djembe","djoza":"","djura":"","dobro":"","dobro-bass":"","dohol":"","doira":"","dojo":"","dolceola":"","doli":"","dombra":"","doneli":"","donno":"","donso ngoni":"","doorbell":"","doshpuluur":"","dotara":"","double bass":"double-bass","double bassoon":"bassoon","double clarinet":"clarinet","double flute":"flute","double reed":"wodwind","doumbaki":"","doumbi":"","doyra":"","dramyin":"","dril-bu":"","droma":"","drone":"","drum":"percussion","drums":"drumkit","drum machine":"drum-machine","drum programming":"programming","stylophone":"stylophone","duck call":"","duduk":"","duff":"","duggi":"","dulce melos":"","dulceola":"","dulcian":"","dulcimer":"","dulcitone":"","dulzaina":"","dumbak":"","dumbelek":"","dumbuks":"","dundun":"","dung-chen":"","dunun":"","dutar":"","duxianqin":"","dvojacka":"","dvojnice":"","e-bow":"","e-flat clarinet":"clarinet","guitar":"guitar","e-organ":"","ebow":"","effects":"general","ektara":"","electric accordion":"accordion","electric appalachian dulcimer":"","electric baritone guitar":"electric-guitar","electric cello":"cello","electronic drums":"","electric fiddle":"violin","electric fretless guitar":"electric-guitar","electric grand piano":"grand-piano","electric harmonium":"harmonium","electric harp":"harp","electric harpsichord":"harpsichord","keyboards":"keyboards","electric lap steel guitar":"steel-guitar","electric organ":"organ","electric piano":"keyboards","electric sitar":"sitar","electric upright bass":"double-bass","electric viola":"viola","electric violin":"violin","electronic cello":"cello","synthesizer":"synthesizer","electronic organ":"organ","electronic percussion":"","electronic valve instrument":"","electronic vibraphone":"","electronic wind instrument":"","electronics":"","electronium":"","elektronium":"","eligible studio producer":"producer","end-blown flute":"flute","english bagpipes":"bagpipes","english concertina":"","english flageolet":"","english guitar":"guitar","english horn":"english-horn","ensemble":"","entertainer":"general","epinette des vosges":"","erhu":"erhu","esraj":"","euphonium":"brass","ewi":"","ezzo-soprano":"","fado viola":"","fairground organ":"organ","falsetto vocals":"vocals","fanfare trumpet":"trumpet","fanfaretrumpet":"trumpet","farfisa":"","featuring":"","sound effects":"sound-effects","fiddel":"","fiddle":"violin","fife":"woodwind","finger clicks":"finger-snaps","finger cymbals":"","fipple flute":"woodwind","five-string banjo":"banjo","flabiol":"","flageolet":"","flamenco guitar":"guitar","flexatone":"","floppy disk drive":"","floyera":"","flugabone":"","flugelhorn":"brass","fluier":"","flumpet":"","flute d\'amour":"flute","flute organ":"flute","flutina":"","folk guitar":"guitar","folk harp":"harp","folklorist":"","foot stamping":"foot-stomps","foot stomps":"foot-stomps","foot tapping":"","footbass":"","fortepiano":"keyboards","fotdella":"","four-string banjo":"banjo","frame drum":"percussion","free reed":"","free-reed flute":"flute","french bagpipes":"bagpipes","french horn":"french-horn","fretless bass guitar":"bass-guitar","fretless guitar":"guitar","friction drum":"percussion","friction idiophone":"","friscaletto":"","frottoir":"","frigideira":"","fujara":"","fundeh":"","fyell":"","gadulka":"","gaita":"","gajde":"","galician gaita":"","gallichon":"","galo":"","galoubet":"","gambang":"","gamelan":"","ganga":"","gangsa":"","gankogui":"","ganza":"","gaohu":"","gardon":"","garifuna drum":"","garklein recorder":"","garmon":"","gayageum":"","gbedu":"","gehu":"","gemshorn":"","gender":"","gender barung":"","gender panerus":"","gender wayang":"","genggong":"","geomungo":"","german concertina":"","german harp":"harp","ghara":"","ghatam":"","ghati":"","ghayta":"","ghijak":"","ghungroo":"","giga":"","gimbri":"","gini":"","gittern":"","glass":"","glass harmonica":"mouth-organ","glass harp":"","glockenspiel":"glockenspiel","goblet drum":"","goge":"","gong":"gong","gong bass drum":"","gong chime":"","gorodao":"","gottuvadyam":"","gourd":"","gourd rattle":"","gouzouki":"","gralla":"","gramorimba":"","grand piano":"grand-piano","grantang":"","gravikord":"","great bass recorder":"recorder","great highland bagpipe":"bagpipes","griot":"","grneta":"","groovebox":"","gu":"","gua\'chara":"","guacharaca":"","guan":"","guayo":"","guban":"","gubgubi":"","gudastviri":"","gudok":"","gudugudu":"","guimbri":"","guira":"","guiro":"guiro","guitalele":"","guitar banjo":"bango","guitar synthesizer":"","guitaret":"","guitarron":"","guitarron chileno":"","guitarron mexicano":"","guitarviol":"","guitorgan":"","guitsteel":"","gumbri":"","gung":"","gunje":"","guntang":"","guqin":"","gusli":"","guzheng":"","haegeum":"","hair":"","halldorophone":"","hammer":"","hammered dulcimer":"","hammond organ":"","handbell":"hand-bell","handpan":"","hang drum":"percussion","hard disk drive":"","hardanger fiddle":"","hardingfele":"","harjedalspipa":"","harmet":"","harmonica":"mouth-organ","harmonium":"harmonium","harmony vocals":"vocals","harp":"harp","harp guitar":"guitar","harpejji":"","harpsichord":"harpsichord","harpsipiano":"keyboards","haute-contre vocals":"","hawaiian guitar":"guitar","heckelphone":"","heike biwa":"","helicon":"","hi-hat":"","hichiriki":"","high violin":"violin","highland bagpipes":"bagpipes","hmong flute":"flute","hoddu":"","homus":"","horagai":"","horn":"horn","horns":"","hosho":"","hoshu":"","hot fountain pen":"","hotchiku":"","hourglass drum":"","huapanguera":"","hudukka":"","hue puruhau":"","hue puruwai":"","hulusi":"","hummel":"","humming":"","hunting horn":"","hunting horn (valved)":"","huqin":"","hurdy-gurdy":"","hyoshigi":"","ichigenkin":"","idiophone":"","igil":"","imitation bass":"","indian harp":"harp","indonesian rebab":"","instruments":"","interviewee":"","interviewer":"","irish bouzouki":"strings","irish flute":"flute","irish harp":"harp","irish whistle":"whistle","jagd horn":"","jaggo":"","jal tarang":"","janggu":"","jantar":"","japanese wooden flute":"flute","jarana":"","jawan":"","jazz horn":"","jegogan":"","jejo":"","jejo voatavo":"","jeli ngoni":"","jew\'s harp":"","jing":"","jing\'erhu":"","jinghu":"","jingle bells":"bells","joik":"","jouhikko":"","joze":"","jublag":"","jug":"jug","jugkalimba":"","jumbush":"","junjung":"","jushichigen-kin (bass koto)":"koto","k\'kwaengwari":"","ka (drum)":"","kaba gaida":"","kabosa":"","kabosy":"","kacapi":"","kacapi indung":"","kacapi rincik":"","kacapi siter":"","kachva sitar":"","kagura suzu":"","kagurabue":"","kaiamba rambo":"","kakegoe":"","kalimba":"kalimba","kamac":"","kamaica":"","kamale ngoni":"","kamancheh":"","kanjira":"","kankles":"","kannel":"","kantele":"","kantilan":"","kanun":"","karamouza":"","karigo":"","karkabas":"","karna":"","kartal":"","kaval":"","kayagum":"","kazoo":"kazoo","kecer":"","kelenang":"","kemanak":"","kemenche":"","kemence of the black sea":"","kemene":"","kempli":"","kempul":"","kempur":"","kempyang":"","ken bau":"","ken la":"","kena":"","kendang":"","kendang lanang":"","kendang wadon":"","kendhang batangan":"","kendhang gendhing":"","kendhang indung":"","kendhang ketipung":"","kendhang kulanter":"","kendhang wayangan":"","kenong":"","kenyir":"","kepyak":"","kethuk":"","kettledrum":"kettle-drum","ketuk":"","keyboard bass":"","keyed box zither":"zither","keyed brass instruments":"brass","keytar":"keytar","khaen":"","khalam":"","khartal":"","khen meo":"","khene":"","khim":"","khlui":"","khol":"","khong wong":"","khong wong lek":"","khong wong yai":"","khulsan khuur":"","khurdak":"","khuur":"","ki pah":"","kinnor":"","kirar":"","kithara":"","kkwaenggwari":"","klong":"","klong khaek":"","klong song na":"","klong that":"","klong yao":"","koauau":"","koauau ponga ihu":"","kobyz":"","kokle":"","kokyu":"","komun\'go":"","komuz":"","kong wong yai":"","kora":"","korintsana":"","kortholt":"","kos":"","koto":"koto","kotsuzumi":"","krakebs":"","krap":"","krap khu":"","krap phuang":"","krap sepha":"","krar":"","kudum":"","kusle":"","kynggari":"","lagerphone":"","lakota flute":"flute","lakoto flute":"flute","lamba":"","lamellaphone":"","lamellophone":"","langeleik":"","laouto":"","lap harp":"harp","lap steel guitar":"steel-guitar","laser harp":"harp","laud":"","launeddas":"","lautenwerck":"","lavta":"","lead guitar":"guitar","lead vocal":"vocals","likembe":"","limbe":"","lion\'s roar":"","lira":"","lira da braccio":"","lira organizzatai":"","lirica":"","lirone":"","liru":"","lithophone":"","liuqin":"","llaute":"","log drum":"percussion","lokanga bara":"","lokole":"","low whistle":"whistle","lowland pipes":"bagpipes","lukeme":"","lur":"","lute":"","lute guitar":"guitar","lute harpsichord":"","lutheal":"","lyra":"","lyra viol":"","lyre":"","lyricon":"","lysarden":"","madal":"","maddalam":"","maddale":"","magruna":"","mallets":"","mandobass":"","mandocello":"","mandoguitar":"","mandola":"","mandolin":"mandolin","mandolin banjo":"banjo","mandolincello":"","mandolute":"","mandora":"","mandore":"","manjira":"","manjur":"","mankeri":"","manzello":"","maracas":"maracas","marimba":"","marimba lumina":"","marimbula":"","mark tree":"","marovany":"","marxophone":"","masenqo":"","masinko":"","mc":"","mbira":"","mejoranera":"","mellophone":"","mellophonium":"","mellotron":"","melodeon":"","melodica":"melodica","melophone":"","membranophone":"","mendoza":"","metallophone":"","mexican vihuela":"","mey":"","mezzo-contralto vocals":"vocals","mezzo-soprano vocals":"vocals","midi controller":"","midi instrument":"","midistick":"","mijwiz":"","minimoog":"","minipiano":"keyboards","minister":"","mirliton":"","mirwas":"","mizmar":"","mizwad":"","moceno":"","mong":"","monkey stick":"","monochord":"monochord","moog":"","morchang":"","morin khuur":"","morrisette":"","morsing":"","mountain dulcimer":"","mouth bow":"","mouth harp":"","mouth organ":"mouth-organ","mrdanga":"","mridangam":"","mukkuri":"","munnharpe":"","murali":"","murcang":"","murli":"","muselar":"","musette":"","musette de cour":"","music box":"","music sequencer":"","music video clip director":"","musical bow":"","musical box":"","musical saw":"","n\'vike":"","nabal":"","nadaswaram":"","nagadou-daiko":"","nagak":"","nagasvaram":"","nai":"","nakers":"","nal":"","nanga":"","naobo":"","naqareh":"","naqqara":"","narrator":"","nattuva talam":"","natural horn":"","natural trumpet":"","ney":"","ngoma":"","ngomi":"","ngoni":"","nguru":"","nigenkin":"","njarka":"","nohkan":"","noises":"","northumbrian pipes":"bagpipes","northumbrian small pipes":"bagpipes","nose flute":"","nose whistle":"whistle","novachord":"","nyatiti":"","nyckelharpa":"","oboe":"oboe","oboe d\'amore":"oboe","oboe da caccia":"oboe","oboe damore":"oboe","ocarina":"","ocean drum":"","octapad":"","octave mandolin":"mandolin","octavilla":"","octavina":"","octoban":"","octobass":"","okonkole":"","oktawka":"","olifant":"","omnichord":"","ondes martenot":"","ondioline":"","onoben":"","open-back banjo":"","ophicleide":"","optigan":"","organ":"","organistrum":"","orpharion":"","orphica":"","otamatone":"","other":"","other brass instruments":"brass","other instruments":"general","other keyboard instruments":"keyboards","other music video clip creator":"general","other percussion instruments":"percussion","other plucking instruments":"","other string instruments":"strings","other woodwind instruments":"woodwind","otsuzumi":"","oud":"","outi":"","oval spinet":"","overtone flute":"","overtone voice":"","p\'iri":"","pahu":"","paiban":"","paila":"","pakhavaj":"","pakhawaj":"","palmas":"","pan flute":"panpipes","panpipes":"panpipes","pandeiro":"","pandereta":"","panduri":"","pang gu ly hu hmong":"","pano":"","paraguayan harp":"","pardessus de viole":"","parlour grand piano":"grand-piano","pate":"","pedabro":"","pedal accordion":"","pedal piano":"keyboards","pedal steel guitar":"steel-guitar","pedalboard":"","pemade":"","percussion":"percussion","performer":"contributor","phach":"","pi":"","pi chawa":"","pi nai":"","pi thiu":"","pianet":"","piano":"keyboards","piano accordion":"accordion","piano duo":"keyboards","piano four hands":"keyboards","piano quartet":"keyboards","piano spinet":"keyboards","piano trio":"keyboards","pianoforte":"keyboards","piccolo":"piccolo","piccolo banjo":"banjo","piccolo bass":"bass","piccolo bass guitar":"bass-guitar","piccolo flute":"piccolo","piccolo oboe":"oboe","piccolo trumpet":"trumpet","pierrot ensemble":"","pifana":"","piffaro":"","pipa":"","pipe":"pipe","pipe and tabor":"pipe","pipe major":"bagpipes","pipe organ":"organ","pipes":"bagpipes","piri":"","pito":"","pito herreno":"","pixiephone":"","pkhachich":"","platillos":"","player piano":"keyboards","plectrum banjo":"banjo","plucked idiophone":"","plucked string instruments":"","pluriarc":"","pocket trumpet":"trumpet","poetry reader":"general","poi awhiowhio":"","polyphon":"","porotiti":"","portative":"","portuguese guitar":"guitar","porutu":"","positive organ":"","post horn":"","practice chanter":"","preacher":"","prempensua":"","prepared piano":"keyboards","presenter":"general","primero":"","psalmodicon":"","psaltery":"","pujador":"","pullankulal":"","pumotomoto":"","pump organ":"organ","pupakapaka":"","purerehua":"","putatara":"","putorino":"","qanun":"","qasaba":"","qilaut":"","qirba":"","quadruple reed":"","quena":"","quenacho":"","quijada":"","quills":"","quintfagott":"","quinto":"","quinton":"","quitls":"","quray":"","rabab":"","rabeca":"","rabel":"","rackett":"","raconteur":"","rag dung":"","rain stick":"","rainstick":"rainstick","rammana":"","ranat ek":"","ranat kaeo":"","ranat thum":"","rap":"","rapper":"vocals","ratchet":"","rattle":"","rauschpfeife":"","ravanahatha":"","reactable":"","read by":"","rebab":"","rebec":"","reco-reco":"","recorder":"recorder","reed":"","reed organ":"","reeds":"","regal":"","reikin":"","remix":"","remixer":"","repeater":"","repicador":"","repinique":"","reporter":"","requinto":"","requinto guitar":"guitar","resonator guitar":"guitar","resonator banjo":"banjo","reyong":"","rgya-gling":"","rhaita":"","rhodes piano":"keyboards","rhythm guitar":"guitar","rhythm sticks":"","rhythms box":"","riqq":"","rkang-gling":"","rnga":"","rol-mo":"","rondador":"","ronroco":"","roria":"","rototom":"","rozhok":"","ruan":"","rubab":"","rubboard":"","rudra veena":"","rudravina":"","ryuteki":"","sabar":"","sabaro":"","sackbut":"","sackpipa":"","saduk":"","saenghwang":"","sahnai":"","salterio":"","saluang":"","samba whistle":"","samica":"","sampled performer":"","sampler":"sampler","sampona":"","samvadini":"","sanfona":"","sansa":"","sanshin":"","santoor":"","santur":"","sanxian":"","sanza":"","sao meo":"","sao truc":"","sapeh":"","sarangi":"","saraswati veena":"","sargija":"","sarod":"","saron":"","saron barung":"","saron demung":"","saron panerus":"","saron peking":"","saron wayang":"","saroz":"","sarrusophone":"","satara":"","satsuma biwa":"","saw duang":"","saw sam sai":"","saw u":"","saxello":"","saxhorn":"","saxophone":"saxophone","saxor":"","saz":"","scat":"vocals","schwyzerorgeli":"","scottish smallpipes":"bagpipes","scraped idiophone":"","scraper":"","scratcher":"","segunda":"","sekere":"","seljeflyte":"","selmer-maccaferri guitar":"","semi-acoustic guitar":"","senh tien":"","seni rebab":"","seperewa":"","sequencer":"","serbo-croatian tamburica orchestra":"","serpent":"","setar":"","shahi baaja":"","shaker":"shaker","shakubyoshi":"","shakuhachi":"","shamisen":"","shanai":"","shawm":"","shehnai":"","shekere":"","sheng":"","shichepshin":"","shime-daiko":"","shinobue":"","sho":"","shofar":"","shouting":"vocals","shruti box":"","shudraga":"","shuitar":"","shuttle pipes":"","sihu":"","siku":"","sil-snyan":"","sindhi sarangi":"","singing bowl":"","single reed":"","sintir":"","siren":"","sistrum":"","sitar":"sitar","skratjie":"","slagbordun":"","slapstick":"","slenthem":"","slentho":"","slide brass instruments":"brass","slide guitar":"guitar","slide trumpet":"trumpet","slide whistle":"whistle","slit drums":"percussion","small guitar":"guitar","smallpipes":"bagpipes","snare drum":"snare-drum","sodina":"","sodinar":"","soloist":"","song loan":"","sopilka":"","sopranino":"","sopranino clarinet":"clarinet","sopranino recorder":"recorder","sopranino saxophone":"saxophone","soprano vocals":"vocals","soprano clarinet":"clarinet","soprano cornet":"cornet","soprano crumhorn":"woodwind","soprano flute":"flute","soprano recorder":"recorder","soprano saxophone":"saxophone","soprano trombone":"trombone","soprano violin":"violin","sordone":"","sorna":"","souna":"","sound director":"general","sounds":"","sousaphone":"","souvliari":"","spanish guitar":"acoustic-guitar","speech":"vocals","spike-fiddle":"","spilapipa":"","spinet":"","spinettone":"","spoken word":"vocals","spoons":"spoons","square pianoforte":"keyboards","steel drums":"steel-drum","steel guitar":"steel-guitar","steelpan":"","steel-string acoustic guitar":"acoustic-guitar","steirische harmonika":"mouth-organ","stick zither":"zither","stomp box":"","story teller":"","street organ":"organ","string drum":"percussion","string instrument":"strings","string synthesizer":"","strings":"strings","stritch":"","stroh violin":"","struck idiophone":"","struck string instruments":"","strumstick":"","subcontrabass recorder":"recorder","subcontrabass saxophone":"saxophone","suka":"","suling":"","suona":"","surbahar":"","surdo":"","surdu":"","surigane":"","surmandal":"","surnai (kashmir)":"","sursingar":"","svara mandala":"","svirala":"","swarmandal":"","symphony":"","sympitar":"","synclavier":"","synthaxe":"","t\'rung":"","taal":"","tabal":"","tabla":"","table steel guitar":"steel-guitar","tabor":"","tack piano":"keyboards","taegum":"","taepyeongso":"","taiko":"","taishogoto":"","talharpa":"","talkbox":"","talking drum":"talking-drum","tam-tam":"","tama":"","tambin":"","tambora":"","tamboril":"","tamborim":"","tambourine":"tambourine","tambur (drum)":"percussion","tambur (gong)":"gong","tambur (lute)":"","tanpura":"","tamburitza":"","tan-tan":"","tanbou ka":"","tanbur":"","tanbura":"","tangent piano":"","tannerin":"","taonga puoro":"","tapan":"","tapboard":"","taphon":"","tar":"","tar (drum)":"percussion","tar (flute)":"flute","tar (frame drum)":"percussion","tar (lute)":"","tar shenai":"","taragot":"","tarawangsa":"","tarka":"","tarogato":"","tarol":"","tarota":"","tavil":"","te ku":"","tea chest bass":"","tef":"","telharmonium":"","temple blocks":"","temur khuur":"","tenor vocals":"vocals","tenor banjo":"banjo","tenor flute":"flute","tenor guitar":"guitar","tenor horn":"horn","tenor recorder":"recorder","tenor sarrusophone":"","tenor saxophone":"saxophone","tenor sordun":"","tenor trombone":"trombone","tenor viol":"strings","tenor violin":"violin","tenora":"","tepsija":"","thavil":"","the great stalacpipe organ":"organ","theatre organ":"organ","theorbo":"","theremin":"theremin","thon":"","three-hole pipe":"pipe","throat singing":"","thumb piano":"","ti bwa":"","ti-tse":"","tibetan singing bowl":"","tibetan water drum":"","tible":"","tieu":"","tifa":"","totobuang":"","timbales":"percussion","timbrel":"","timpani":"percussion","timple":"","tin whistle":"whistle","tinya":"","tiompan":"","tiple":"","tipple":"","toasting":"","tokere":"","tololoche":"","tom-tom":"","tombak":"","tonette":"","tongtong":"","tonkori":"","topshuur":"","torader":"","toumbas":"","tovshuur":"","toy (instruments)":"general","toy piano":"keyboards","tram ple":"","trang jau":"","trang lu":"","transverse flute":"flute","traps":"","trautonium":"","treble vocals":"vocals","treble flute":"flute","treble recorder":"recorder","treble shawm":"","treble tambura":"","treble viol":"strings","treble violin":"violin","tres":"","tres cubano":"","triangle":"triangle","trikiti":"","trikitixa":"","triple harp":"","tritantri veena":"","tromba marina":"","trombone":"trombone","trumpet":"trumpet","trompetica china":"","trong bong":"","trumpet marine":"trumpet","trutruka":"","tsuur":"","tuba":"tuba","tubaphone":"","tubax":"","tube zither":"zither","tubon":"","tubular bells":"tubular-bells","tubulum":"","tulum":"","tumba":"","tumbadora":"","tumbi":"","tumutumu":"","tun":"","tuner":"","tungur":"","tusseflute":"","txalaparta":"","txirula":"","txistu":"","typewriter":"","tzouras":"","udu":"","ugal":"","uilleann pipes":"bagpipes","ukelele":"ukelele","ukulele banjo":"banjo","unidentified instruments":"general","upright piano":"keyboards","utogardon":"","valiha":"","valve trombone":"trombone","valve trumpet":"trumpet","valved brass instruments":"brass","valvetrombone":"trombone","variophon":"","veena":"","vena":"","venu":"","vessel flute":"","vibes":"","vibra-slap":"vibraslap","vibrandoneon":"","vibraphone":"vibraphone","vibraslap":"vibraslap","vichitra veena":"","vielle":"","vietnamese guitar":"","vihuela":"","vina":"","viol":"","viola":"viola","viola caipira":"viola","viola bastarda":"viola","viola beiroa":"viola","viola braguesa":"viola","viola campanica":"viola","viola d\'amore":"viola","viola da gamba":"viola","viola de cocho":"viola","viola kontra":"viola","viola nordestina":"viola","viola organista":"viola","viola pomposa":"viola","violarina":"strings","violino piccolo":"strings","viololyra":"strings","violoncello piccolo":"strings","violone":"strings","violotta":"strings","virginals":"","vocal":"vocals","vocal effects":"vocals","vocalese":"vocals","vocalizer":"","vocoder":"vocoder","voice actor":"general","voice synthesizer":"","vuvuzela":"vuvuzela","wagner tuba":"brass","walaycho":"","waldhorn":"","warr guitar":"guitar","washboard":"washboard","washint":"","washtub bass":"","waterphone":"","wavedrum":"","weisenborn":"","whip":"","whistle":"whistle","whistling":"","whistling water jar":"","wiener horn":"horn","willow flute":"flute","wind":"woodwind","wind chimes":"chimes","wind instrument":"woodwind","wind machine":"","wind piano":"","wind synthesizer":"","wire-strung harp":"harp","wobble board":"","wood block":"wood-block","wood chimes":"chimes","woodblock":"wood-block","wooden fish":"","wooden flute":"flute","woodwind":"woodwind","word director":"general","worship leader":"general","wot":"","wurlitzer electric piano":"keyboards","wurlitzer organ":"organ","xalam":"","xaphoon":"","xiao":"","xiaoluo":"","xilophono":"","xun":"","xylophone":"xylophone","strohfidel":"","xylorimba":"","yaktaro":"","yamaha wx7":"","yang t\'chin":"","yanggeum":"","yangqin":"","yatga":"","yayli tanbur":"","yehu":"","yenjing":"","yodel":"","yodelling":"","yonggo":"","yoochin":"","yorgaphone":"","yueqin":"","yunluo":"","zabumba":"","zafzafa":"","zampogna":"","zampona":"","zapateado":"","zaqq":"","zarb":"","zeze":"","zhaleika":"","zhonghu":"","zhongruan":"","zhuihu":"","zill":"","zirbaghali":"","zither":"","zongora":"","zukra":"","zumare":"","zummara":"","zurla":"","zurna":"","beresta":"","pakuru":"","pirula":"","pukaea":"","rehu":"","salamuri":"","zamr":""}');


/**
 * Dual-type support for mainArtists field.
 *
 * OpenSearch records contain mainArtists as either:
 * - list of strings (legacy format)
 * - list of MainArtistItem objects (new format with id, stageName, type)
 *
 * This module lives outside generated/ so it survives schema regeneration.
 */ function $b65015e99ebdc48e$export$cb2381f3844a33e9(item) {
    return typeof item === "string" ? item : item.stageName;
}


const $983d43ed167c8171$var$statusColorMap = {
    SUBMITTED_TO_SOCIETY: "tw-text-[#00B3FF]",
    EVIDENCE_NEEDED: "tw-text-[#FF2600]",
    REGISTERED_WITH_SOCIETY: "tw-text-[#6EE038]",
    TO_BE_REGISTERED: "tw-text-textDove",
    OTHER: "tw-text-textDove"
};
function $983d43ed167c8171$var$DiscographyRegistrations() {
    const { userId: userId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [loadingError, setLoadingError] = (0, $acw62.useState)(false);
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [images, setImages] = (0, $acw62.useState)({});
    const [isPendingExportGeneration, setIsPendingExportGeneration] = (0, $acw62.useState)(false);
    const [isSocietyDiscographySubmissionModalOpen, setIsSocietyDiscographySubmissionModalOpen] = (0, $acw62.useState)(false);
    const [isOpenExportConfirmationModal, setIsOpenExportConfirmationModal] = (0, $acw62.useState)(false);
    const [page, setPage] = (0, $acw62.useState)(1);
    const [rowsPerPage, setRowsPerPage] = (0, $acw62.useState)(50);
    const [recordingsCount, setRecordingsCount] = (0, $acw62.useState)(0);
    const [resetPaginationToggle, setResetPaginationToggle] = (0, $acw62.useState)(false);
    const handleChangePage = (newPage)=>{
        setPage(newPage);
    };
    const skipToLastPage = ()=>{
        const totalPages = Math.ceil(recordingsCount / rowsPerPage);
        if (totalPages > 0) setPage(totalPages);
    };
    const handleChangeRowsPerPage = (newRowsPerPage)=>{
        setRowsPerPage(newRowsPerPage);
        setResetPaginationToggle(true);
    };
    // Map old field names to new field names
    const mapSortField = (field)=>{
        const fieldMap = {
            "parentRecording.mainArtists": "parentRecording.bandArtistName.raw",
            "parentRecording.recordingTitle": "parentRecording.recordingTitle.raw",
            "earliestParentRelease.releaseTitle": "earliestParentRelease.releaseTitle.raw",
            "earliestParentRelease.dateReleased": "earliestParentRelease.dateReleased",
            "earliestParentRelease.mediaType": "earliestParentRelease.mediaType",
            "earliestParentRelease.format": "earliestParentRelease.format",
            "persona.stageName": "persona.stageName"
        };
        return fieldMap[field] || field;
    };
    const [sortFields, setSortFields] = (0, $acw62.useState)([
        {
            field: "parentRecording.recordingTitle.raw",
            order: "asc"
        }
    ]);
    const [sortFieldSortOrderMap, setSortFieldSortOrderMap] = (0, $acw62.useState)({
        "parentRecording.bandArtistName.raw": null,
        "parentRecording.recordingTitle.raw": "asc",
        "earliestParentRelease.releaseTitle.raw": null,
        "earliestParentRelease.dateReleased": null,
        "earliestParentRelease.mediaType": null,
        "earliestParentRelease.format": null,
        "persona.stageName": null
    });
    const handleSort = (newSortField)=>{
        const mappedField = mapSortField(newSortField);
        const currentSortField = sortFields[0]?.field;
        let newSortOrder;
        if (mappedField === currentSortField) newSortOrder = sortFieldSortOrderMap[mappedField] === "asc" ? "desc" : "asc";
        else newSortOrder = "asc";
        setSortFieldSortOrderMap({
            ...sortFieldSortOrderMap,
            ...currentSortField && {
                [currentSortField]: null
            },
            [mappedField]: newSortOrder
        });
        setSortFields([
            {
                field: mappedField,
                order: newSortOrder
            }
        ]);
        setPage(1);
    };
    const ColumnHeading = ({ sortField: sortField, children: children })=>{
        const mappedField = mapSortField(sortField);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            onClick: ()=>handleSort(sortField),
            className: "tw-flex tw-items-center tw-gap-0.5 hover:tw-text-neutral-200",
            children: [
                children,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($983d43ed167c8171$var$SortIcon, {
                    sortOrder: sortFieldSortOrderMap[mappedField] ?? null
                })
            ]
        });
    };
    const fetchData = async ()=>{
        if (userId === undefined) return;
        setLoading(true);
        try {
            const discographyData = await api.searchPrimaryDiscography({
                userId: userId,
                primaryDiscographyRequest: {
                    size: rowsPerPage,
                    fromOffset: (page - 1) * rowsPerPage,
                    sortFields: sortFields,
                    ...sortFields.length > 0 && {
                        sortField: sortFields[0].field,
                        sortOrder: sortFields[0].order
                    }
                }
            });
            const rows = discographyData.recordings.map((recording)=>{
                const { parentRecording: parentRecording, earliestParentRelease: earliestParentRelease, evidenceReleases: evidenceReleases, thumbnailEvidenceImage: thumbnailEvidenceImage, westburyContributions: westburyContributions, pplContributions: pplContributions } = recording;
                return {
                    id: parentRecording.id,
                    artist: (parentRecording.mainArtists ?? []).map((0, $b65015e99ebdc48e$export$cb2381f3844a33e9)).join(", "),
                    title: parentRecording.recordingTitle,
                    release: earliestParentRelease?.releaseTitle ?? "",
                    year: earliestParentRelease?.dateReleased,
                    isrcs: parentRecording.isrcs?.toString() ?? "",
                    contributions: westburyContributions.map((westburyContribution)=>westburyContribution.contribution),
                    pplContributions: pplContributions ?? [],
                    thumbnailEvidenceImageKey: thumbnailEvidenceImage?.objectKey,
                    releaseImageKeys: (evidenceReleases ?? []).flatMap((release)=>(release.evidenceImages ?? []).map((image)=>image.objectKey))
                };
            });
            setRows(rows);
            setRecordingsCount(discographyData.count);
        } catch (e) {
            console.error(e);
            setLoadingError(true);
        }
        setLoading(false);
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
        setResetPaginationToggle(false);
    }, [
        userId,
        page,
        rowsPerPage,
        JSON.stringify(sortFields)
    ]);
    const fetchSignedEvidenceImageUrls = ()=>{
        if (userId === undefined) return;
        for (const row of rows){
            if (row.thumbnailEvidenceImageKey === undefined) continue;
            api.evidenceImageSignedUrlEvidenceImageSignedUrl({
                userId: userId,
                evidenceImageSignedUrlRequest: {
                    objectKey: row.thumbnailEvidenceImageKey
                }
            }).then(({ signedUrl: signedUrl })=>{
                setImages((prev)=>{
                    return {
                        ...prev,
                        [row.id]: signedUrl
                    };
                });
            }).catch((e)=>{
                console.error(e);
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchSignedEvidenceImageUrls();
    }, [
        rows
    ]);
    const handleGenerateExport = ()=>{
        if (userId === undefined) return;
        api.createGeneratePPLReviewExport({
            userId: userId
        }).then(()=>{
            setIsOpenExportConfirmationModal(true);
            fetchLatestExportStatus();
        }).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("PPL review export generation request failed"));
        });
    };
    const fetchLatestExportStatus = async ()=>{
        if (userId === undefined) return;
        api.retrieveLatestPPLReviewExport({
            userId: userId
        }).then((pplReviewExport)=>{
            setIsPendingExportGeneration(!pplReviewExport.ready);
        }).catch(()=>{});
    };
    const columns = [
        {
            cell: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-w-[45px] tw-h-[45px]",
                    children: row.thumbnailEvidenceImageKey ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: `/discography/${userId}/ai-evidence/${row.id}`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-cursor-pointer",
                            children: images[row.id] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: images[row.id],
                                alt: "Evidence",
                                className: "tw-w-full tw-h-full"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-my-auto tw-animate-ping",
                                    children: "\u26AA"
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "wi wi-shut-eye wi-20px"
                        })
                    })
                }),
            minWidth: "80px",
            maxWidth: "80px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ColumnHeading, {
                    sortField: "parentRecording.mainArtists",
                    children: "Artist"
                })
            }),
            selector: (row)=>row.artist,
            minWidth: "200px",
            maxWidth: "200px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ColumnHeading, {
                    sortField: "parentRecording.recordingTitle",
                    children: "Title"
                })
            }),
            selector: (row)=>row.title,
            minWidth: "200px",
            maxWidth: "200px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ColumnHeading, {
                    sortField: "earliestParentRelease.releaseTitle",
                    children: "Release"
                })
            }),
            selector: (row)=>row.release,
            minWidth: "210px",
            maxWidth: "210px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ColumnHeading, {
                    sortField: "earliestParentRelease.dateReleased",
                    children: "Year"
                })
            }),
            selector: (row)=>row.year ? new Date(row.year).getFullYear() : "",
            minWidth: "110px",
            maxWidth: "110px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: "ISRC(s)"
            }),
            selector: (row)=>row.isrcs,
            minWidth: "170px",
            maxWidth: "170px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: "Contributions"
            }),
            cell: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex gap-2",
                    children: row.contributions.map((westburyContribution, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec0f3191f4dead1$export$2e2bcd8739ae039), {
                            delay: {
                                hide: 350,
                                show: 300
                            },
                            overlay: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0937b8ed541186d0$export$2e2bcd8739ae039), {
                                    className: "black-bg datatable-tip tw-capitalize",
                                    ...props,
                                    children: westburyContribution
                                }),
                            placement: "top",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-rounded-sm tw-bg-surfaceBlack80",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi wi-xs", `wi-role-${(0, (/*@__PURE__*/$parcel$interopDefault($0cb68ff8dfba6508$exports)))[westburyContribution] || "general"}`)
                                })
                            })
                        }, i))
                }),
            minWidth: "295px",
            maxWidth: "295px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-uppercase tw-mb-6 tw-text-xs",
                        children: "PPL Discography"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Contributions"
                    })
                ]
            }),
            cell: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex gap-2",
                    children: row.pplContributions.map(({ westburyContribution: westburyContribution, westburyStatus: westburyStatus }, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec0f3191f4dead1$export$2e2bcd8739ae039), {
                            delay: {
                                hide: 350,
                                show: 300
                            },
                            overlay: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0937b8ed541186d0$export$2e2bcd8739ae039), {
                                    className: "black-bg datatable-tip tw-capitalize",
                                    ...props,
                                    children: westburyContribution
                                }),
                            placement: "top",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-rounded-sm tw-bg-surfaceBlack80",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi wi-xs", `wi-role-${(0, (/*@__PURE__*/$parcel$interopDefault($0cb68ff8dfba6508$exports)))[westburyContribution] || "general"}`, $983d43ed167c8171$var$statusColorMap[westburyStatus ?? "OTHER"])
                                })
                            })
                        }, i))
                })
        }
    ];
    const customStyles = {
        headRow: {
            style: {
                borderBottom: "none !important",
                borderBottomColor: "none !important",
                fontSize: "14px",
                background: "#151719"
            }
        },
        headCells: {
            style: {
                background: "transparent",
                color: "#fff",
                paddingBottom: "12px",
                "&:last-of-type": {
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1px",
                    borderLeftColor: "#535D66"
                },
                ".rdt_TableCol_Sortable span": {
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end"
                },
                ".rdt_TableCol_Sortable": {
                    overflow: "visible"
                }
            }
        },
        cells: {
            style: {
                background: "#151719",
                color: "#fff",
                fontWeight: "300",
                overflowX: "auto",
                "&:last-of-type": {
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1px",
                    borderLeftColor: "#535D66"
                }
            }
        },
        rows: {
            style: {
                fontSize: "14px",
                minHeight: "60px",
                borderBottom: "1px solid #535D66 !important"
            }
        },
        pagination: {
            style: {
                color: "#fff",
                fontSize: "13px",
                backgroundColor: "#151719"
            },
            pageButtonsStyle: {
                color: "#fff",
                fill: "#fff",
                backgroundColor: "transparent",
                "&:hover:not(:disabled)": {
                    color: "#fff",
                    fill: "#fff",
                    backgroundColor: "#151719"
                },
                "&:active": {
                    color: "#fff",
                    fill: "#fff",
                    backgroundColor: "#151719"
                },
                "&:disabled": {
                    cursor: "unset",
                    color: "#535D66",
                    fill: "#535D66"
                }
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c6052a69acf71cc$export$828397361e60d675), {
                isOpen: isSocietyDiscographySubmissionModalOpen,
                onClose: ()=>setIsSocietyDiscographySubmissionModalOpen(false),
                userId: userId
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($983d43ed167c8171$var$ExportConfirmationModal, {
                isOpen: isOpenExportConfirmationModal,
                onClose: ()=>setIsOpenExportConfirmationModal(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Registrations"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-mt-6 tw-mb-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "link-secondary",
                    icon: "chevron-left",
                    onClick: ()=>{
                        window.history.back();
                    },
                    label: "Back"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pageDetailsWrapper",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($983d43ed167c8171$var$Keys, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-flex-col tw-justify-start tw-h-full tw-w-full tw-pl-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-w-full tw-uppercase tw-text-xs tw-border-l tw-border-l-[#FF00A6] tw-pl-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: "WMC Discography"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-pt-4 tw-pb-8",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex tw-justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                            label: "Submit to Societies",
                                                            variant: "primary",
                                                            onClick: ()=>{
                                                                setIsSocietyDiscographySubmissionModalOpen(true);
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                            label: "Export PPL Review",
                                                            variant: "secondary",
                                                            icon: "export",
                                                            disabled: isPendingExportGeneration,
                                                            onClick: handleGenerateExport
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: rows.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d9d62761516cb445$exports))), {
                                            columns: columns,
                                            data: rows,
                                            customStyles: customStyles,
                                            fixedHeader: true,
                                            fixedHeaderScrollHeight: "7000px" // around 100 rows
                                            ,
                                            pagination: true,
                                            paginationServer: true,
                                            paginationTotalRows: recordingsCount,
                                            paginationPerPage: rowsPerPage,
                                            paginationRowsPerPageOptions: [
                                                25,
                                                50,
                                                100,
                                                500
                                            ],
                                            paginationResetDefaultPage: resetPaginationToggle,
                                            onChangePage: handleChangePage,
                                            onChangeRowsPerPage: handleChangeRowsPerPage
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618f8aff4a5696a2$export$2e2bcd8739ae039), {
                                            active: loading
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-flex tw-justify-center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "tw-my-auto tw-animate-ping",
                                            children: "\u26AA"
                                        })
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "loadingError",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                            children: loadingError ? "Error loading data" : "No data available currently"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $983d43ed167c8171$export$2e2bcd8739ae039 = $983d43ed167c8171$var$DiscographyRegistrations;
const $983d43ed167c8171$var$SortIcon = ({ sortOrder: sortOrder })=>{
    if (!sortOrder) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "tw-text-xs",
        children: "\u21F5"
    });
    return sortOrder === "asc" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: "\u21E1"
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: "\u21E3"
    });
};
const $983d43ed167c8171$var$Keys = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-end tw-space-x-4 tw-items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($983d43ed167c8171$var$Key, {
                color: "tw-bg-[#6EE038]",
                label: "Registered with society",
                tooltip: "This contribution has been registered with the society"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($983d43ed167c8171$var$Key, {
                color: "tw-bg-[#FF2600]",
                label: "Evidence needed",
                tooltip: "The society has requested evidence for this contribution"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($983d43ed167c8171$var$Key, {
                color: "tw-bg-[#00B3FF]",
                label: "Submitted to society",
                tooltip: "We have submitted this contribution to the society."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($983d43ed167c8171$var$Key, {
                color: "tw-bg-textDove",
                label: "To be registered",
                tooltip: "This contribution is pending submission to the society."
            })
        ]
    });
};
const $983d43ed167c8171$var$Key = ({ color: color, label: label, tooltip: tooltip })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec0f3191f4dead1$export$2e2bcd8739ae039), {
            delay: {
                hide: 150,
                show: 100
            },
            overlay: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0937b8ed541186d0$export$2e2bcd8739ae039), {
                    className: "black-bg",
                    ...props,
                    children: tooltip
                }),
            placement: "left",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "pointer-cursor tw-flex tw-text-white tw-leading-1 tw-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `tw-rounded-full ${color} tw-mr-2`,
                        style: {
                            width: "10px",
                            height: "10px",
                            display: "block"
                        }
                    }),
                    label
                ]
            })
        })
    });
};
const $983d43ed167c8171$var$ExportConfirmationModal = ({ isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: onClose,
        title: "",
        hasCloseButton: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-pb-8",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
                title: "PPL Review Export In Progress",
                description: "Once complete, a download link will appear as a task on your dashboard."
            })
        })
    });
};




var $acw62 = parcelRequire("acw62");


var $8c269053df9a3dc8$exports = {};
$8c269053df9a3dc8$exports = new URL("star.c42070a9.svg", import.meta.url).toString();







var $acw62 = parcelRequire("acw62");
const $75407d21e3df7fb8$var$Spinner = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-w-16 tw-h-16 tw-border-4 tw-border-t-transparent tw-border-white tw-rounded-full tw-animate-spin"
        })
    });
};
const $75407d21e3df7fb8$export$21495182eeff761c = ()=>{
    const [isVisible, setIsVisible] = (0, $acw62.useState)(false);
    const showSpinner = ()=>setIsVisible(true);
    const hideSpinner = ()=>setIsVisible(false);
    const WSpinner = ()=>isVisible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($75407d21e3df7fb8$var$Spinner, {}) : null;
    return {
        showSpinner: showSpinner,
        hideSpinner: hideSpinner,
        WSpinner: WSpinner
    };
};







var $ff323866fb43afa6$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ff323866fb43afa6$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");
!function(e) {
    $ff323866fb43afa6$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\x00\x00",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\x00", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\x00", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\x00\x00\x00\x00" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\x00\x00\x00\x00" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $ff323866fb43afa6$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($ff323866fb43afa6$require$Buffer.from && $ff323866fb43afa6$require$Buffer.from !== Uint8Array.from) return $ff323866fb43afa6$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $ff323866fb43afa6$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($ff323866fb43afa6$require$Buffer.alloc) return $ff323866fb43afa6$require$Buffer.alloc(e);
                        var t = new $ff323866fb43afa6$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $ff323866fb43afa6$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $ff323866fb43afa6$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $ff323866fb43afa6$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $hPtJY.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});



function $b725876768576cee$export$2e2bcd8739ae039() {
    const { userId: userId, parentRecordingId: parentRecordingId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { showSpinner: showSpinner, hideSpinner: hideSpinner, WSpinner: WSpinner } = (0, $75407d21e3df7fb8$export$21495182eeff761c)();
    const [urlIsCheckedMap, setUrlIsCheckedMap] = (0, $acw62.useState)({});
    const [isSelectAll, setIsSelectAll] = (0, $acw62.useState)(true);
    (0, $acw62.useLayoutEffect)(()=>{
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        location.pathname
    ]);
    const [images, setImages] = (0, $acw62.useState)([]);
    const [selectedImage, setSelectedImage] = (0, $acw62.useState)(null);
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const handleImageClick = (image)=>{
        setSelectedImage(image);
        setIsModalOpen(true);
    };
    const closeModal = ()=>{
        setIsModalOpen(false);
        setSelectedImage(null);
    };
    const [imageUrls, setImageUrls] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)({});
    const [carouselIndex, setCarouselIndex] = (0, $acw62.useState)(0);
    const [visibleRows, setVisibleRows] = (0, $acw62.useState)(2);
    const [recordingData, setRecordingData] = (0, $acw62.useState)({
        artist: "",
        recording: "",
        contributor: "",
        roles: []
    });
    const ROW_SIZE = 6; // Number of images per row
    // const imagesSorted = useMemo<
    //   RecordingEarliestParentReleaseEvidenceImagesInner[]
    // >(() => {
    //   return images.toSorted(
    //     (a, b) => Number(b.isPreferred) - Number(a.isPreferred)
    //   );
    // }, [images]);
    const imagesSorted = images;
    const carouselImages = (0, $acw62.useMemo)(()=>{
        if (imagesSorted.length <= 2) // If there are 2 or fewer images, display all
        return imagesSorted;
        const firstIndex = carouselIndex % imagesSorted.length;
        const secondIndex = (carouselIndex + 1) % imagesSorted.length;
        return [
            imagesSorted[firstIndex],
            imagesSorted[secondIndex]
        ];
    }, [
        carouselIndex,
        imagesSorted
    ]);
    const fetchData = async ()=>{
        if (userId === undefined || parentRecordingId === undefined) return;
        try {
            showSpinner();
            const { parentRecording: parentRecording, earliestParentRelease: earliestParentRelease, persona: persona, person: person, evidenceReleases: evidenceReleases, westburyContributions: westburyContributions } = await api.retrieveRecording({
                userId: userId,
                parentRecordingId: parentRecordingId
            });
            const roles = [];
            westburyContributions.forEach((westburyContribution)=>{
                const role = westburyContribution.contribution.charAt(0).toUpperCase() + westburyContribution.contribution.slice(1);
                roles.push(role);
            });
            // artist is bandArtistName if it exists, otherwise it's built using mainArtists
            const artist = parentRecording.bandArtistName ?? persona.stageName;
            setRecordingData({
                artist: artist,
                recording: parentRecording.recordingTitle,
                contributor: person?.realName?.[0] ?? persona.stageName,
                roles: roles
            });
            if (!evidenceReleases) return;
            const newImages = [];
            const newLoadingState = {};
            for (const evidenceRelease of evidenceReleases)for (const image of evidenceRelease.evidenceImages ?? []){
                newImages.push(image);
                newLoadingState[image.objectKey] = true;
                // Fetch signed URL for each image
                api.evidenceImageSignedUrlEvidenceImageSignedUrl({
                    userId: userId,
                    evidenceImageSignedUrlRequest: {
                        objectKey: image.objectKey
                    }
                }).then(({ signedUrl: signedUrl })=>{
                    setImageUrls((prev)=>({
                            ...prev,
                            [image.objectKey]: signedUrl
                        }));
                }).catch((error)=>{
                    console.error(`Error fetching signed URL for ${image.objectKey}: `, error);
                }).finally(()=>{
                    setLoading((prev)=>({
                            ...prev,
                            [image.objectKey]: false
                        }));
                });
            }
            setImages(newImages);
            setLoading(newLoadingState);
        } catch (error) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong"));
        } finally{
            hideSpinner();
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        parentRecordingId
    ]);
    // compute that at least one urlIsChecked everytime urlIsCheckedMap changes
    const isAtLeastOneChecked = (0, $acw62.useMemo)(()=>{
        const res = Object.values(urlIsCheckedMap).some((isChecked)=>isChecked);
        return res;
    }, [
        urlIsCheckedMap
    ]);
    const handleChecked = (url)=>{
        setUrlIsCheckedMap({
            ...urlIsCheckedMap,
            [url]: !urlIsCheckedMap[url]
        });
    };
    (0, $acw62.useEffect)(()=>{
        setIsSelectAll(Object.values(urlIsCheckedMap).every((isChecked)=>isChecked));
    }, [
        urlIsCheckedMap
    ]);
    const handleSelectAll = (event)=>{
        setUrlIsCheckedMap(Object.fromEntries(Object.entries(urlIsCheckedMap).map(([url])=>[
                url,
                event.target.checked
            ])));
    };
    const handleDownload = async ()=>{
        if (Object.keys(urlIsCheckedMap).length === 0) return;
        const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($ff323866fb43afa6$exports)))();
        const urlsForDownload = Object.entries(urlIsCheckedMap).flatMap(([url, isChecked])=>isChecked ? [
                url
            ] : []);
        for await (const [index, url] of Object.entries(urlsForDownload))try {
            const imageBlob = await fetch(url).then((response)=>response.blob());
            const pathComponents = new URL(url).pathname.split("/");
            const fileName = pathComponents.pop() ?? `evidence${index}.jpg`;
            const imageFile = new File([
                imageBlob
            ], fileName);
            zip.file(fileName, imageFile);
        } catch (error) {
            console.error(error);
        }
        zip.generateAsync({
            type: "blob"
        }).then((content)=>// @ts-expect-error -- UMD global
            saveAs(content, "annotated-evidence"));
    };
    const handleCopyToClipboard = ()=>{
        if (Object.keys(urlIsCheckedMap).length === 0) return;
        const text = Object.entries(urlIsCheckedMap).flatMap(([url, isChecked])=>isChecked ? [
                url
            ] : []).join("\n");
        navigator.clipboard.writeText(text);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(WSpinner, {}),
            isModalOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: isModalOpen,
                onClose: closeModal,
                title: "Image",
                modalClasses: "tw-max-w-xl tw-max-h-screen tw-overflow-y-auto",
                children: selectedImage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: imageUrls[selectedImage.objectKey],
                    alt: selectedImage.alt,
                    className: "tw-w-full tw-h-auto tw-rounded-lg"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "AI Evidence"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "link-secondary",
                    icon: "chevron-left",
                    onClick: ()=>{
                        window.history.back();
                    },
                    label: "Back"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                className: "tw-font-sans tw-text-xl tw-mb-4 tw-text-white",
                children: [
                    'Evidence Results For "',
                    recordingData.recording,
                    '"'
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-grid tw-gap-5 tw-grid-cols-[1fr_minmax(0,2fr)_1fr] tw-rounded-lg tw-text-white tw-w-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-h-[35rem] tw-bg-surfaceBlack90 tw-rounded-lg tw-p-4 tw-text-white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-grid tw-gap-5 tw-bg-surfaceBlack90 tw-rounded-lg tw-p-4 tw-pt-8 tw-text-white ",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-items-end tw-justify-end tw-gap-2 ",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: isAtLeastOneChecked ? "secondary" : "disabled",
                                        onClick: handleDownload,
                                        label: "Download Selected"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: isAtLeastOneChecked ? "primary" : "disabled",
                                        onClick: handleCopyToClipboard,
                                        label: "Copy to Clipboard"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-grid tw-grid-cols-[min-content_1fr_1fr_min-content] tw-gap-1.5 tw-items-center tw-align-top",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-flex tw-items-center",
                                        children: imagesSorted.length > 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                            onClick: ()=>{
                                                setCarouselIndex((carouselIndex - 1 + imagesSorted.length) % imagesSorted.length); // Move left circularly
                                            },
                                            variant: "link-secondary",
                                            icon: "chevron-left",
                                            label: ""
                                        })
                                    }),
                                    carouselImages.map((image, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-relative tw-aspect-square tw-h-full tw-flex tw-items-start tw-justify-start tw-max-h-[300px] tw-cursor-pointer"),
                                            children: [
                                                loading[image.objectKey] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tw-flex tw-justify-center tw-items-center tw-h-full",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "tw-my-auto tw-animate-ping",
                                                        children: "\u26AA"
                                                    })
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "tw-m-0 tw-p-0 tw-border-none tw-outline-none",
                                                    onClick: ()=>{
                                                        handleImageClick(image);
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        alt: "Preview carousel",
                                                        src: imageUrls[image.objectKey],
                                                        className: "tw-max-h-[300px]"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-flex-row tw-gap-2 tw-absolute tw-top-2 tw-left-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-bg-black/70 tw-rounded-[4px] tw-flex tw-h-[20px]",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95d3bd05f0e5a60a$export$fab3ce5a4cf652db), {
                                                                name: `checkbox-${image.objectKey}`,
                                                                checked: urlIsCheckedMap[imageUrls[image.objectKey]] || false,
                                                                onChange: ()=>handleChecked(imageUrls[image.objectKey]),
                                                                checkboxSize: "sm" // Customize size if needed
                                                                ,
                                                                extraClasses: ""
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                            alt: "",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8c269053df9a3dc8$exports))),
                                                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-6", {
                                                                "tw-hidden": !image.isPreferred
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, image.objectKey)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-flex tw-items-center tw-align-middle",
                                        children: imagesSorted.length > 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                            onClick: ()=>{
                                                setCarouselIndex((carouselIndex + 1) % imagesSorted.length); // Move right circularly
                                            },
                                            variant: "link-secondary",
                                            icon: "chevron-right",
                                            label: ""
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-grid tw-gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "tw-font-sans",
                                        children: "Evidence Images"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-grid tw-grid-cols-6 tw-gap-3",
                                        children: imagesSorted.slice(0, visibleRows * ROW_SIZE) // Dynamically limit the number of images
                                        .map((image)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-aspect-square tw-relative",
                                                children: [
                                                    loading[image.objectKey] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "tw-flex tw-justify-center tw-items-center tw-h-full",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "tw-my-auto tw-animate-ping",
                                                            children: "\u26AA"
                                                        })
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "tw-m-0 tw-p-0 tw-border-none tw-outline-none",
                                                        onClick: ()=>{
                                                            handleImageClick(image);
                                                        },
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                            src: imageUrls[image.objectKey],
                                                            className: "tw-cursor-pointer",
                                                            alt: "Preview grid"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        alt: "",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8c269053df9a3dc8$exports))),
                                                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-absolute tw-top-0 tw-left-0 tw-m-0.5 tw-w-4", {
                                                            "tw-hidden": !image.isPreferred
                                                        })
                                                    })
                                                ]
                                            }, image.objectKey))
                                    })
                                ]
                            }),
                            visibleRows * ROW_SIZE < imagesSorted.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-ml-auto tw-flex tw-space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "outline-light",
                                        onClick: ()=>setVisibleRows(Math.ceil(imagesSorted.length / ROW_SIZE)),
                                        label: "View All"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        onClick: ()=>setVisibleRows((prev)=>prev + 2),
                                        label: "View More"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-overflow-hidden",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-h-[35rem]",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-h-full tw-flex tw-flex-col tw-gap-5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex-1 tw-bg-surfaceBlack90 tw-rounded-lg tw-p-4 tw-text-white",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "tw-font-sans tw-text-lg tw-text-white tw-mb-4",
                                                children: "Recording Data"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex tw-flex-col tw-gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-p-1 tw-pt-2 tw-min-h-[50px] tw-border-l-4 tw-border-x-westburyBlue",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                className: "tw-font-sans",
                                                                children: "Artist/Group"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "tw-font-light tw-text-sm",
                                                                children: recordingData.artist
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-p-1 tw-pt-2 tw-min-h-[50px] tw-border-l-4 tw-border-x-westburyRed",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                className: "tw-font-sans",
                                                                children: "Recording"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "tw-font-light tw-text-sm",
                                                                children: [
                                                                    " ",
                                                                    recordingData.recording
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-p-1 tw-pt-2 tw-min-h-[50px] tw-border-l-4 tw-border-x-surfaceYellow",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                className: "tw-font-sans",
                                                                children: "Contributor"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "tw-font-light tw-text-sm",
                                                                children: recordingData.contributor
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tw-p-1 tw-pt-2 tw-min-h-[50px] tw-border-l-4 tw-border-x-westburyGreen",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                className: "tw-font-sans",
                                                                children: "Role(s)"
                                                            }),
                                                            recordingData.roles.map((role)=>{
                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "tw-font-light tw-text-sm",
                                                                    children: role
                                                                }, role);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-h-[30%] tw-bg-surfaceBlack90 tw-rounded-lg tw-p-4 tw-text-white",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "tw-font-sans tw-text-lg tw-text-white"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $8980c8a5d2c3be96$exports = {};
$8980c8a5d2c3be96$exports = new URL("SquarePlaceholder185.0e56c7d7.svg", import.meta.url).toString();










var $acw62 = parcelRequire("acw62");




const $92bfaa0dd900734b$export$f81dc54dab7d6a = ({ type: type, name: name, value: value, label: label, hideOnView: hideOnView = false, onBlur: onBlur, onChange: onChange })=>{
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const [innerError, setInnerError] = (0, $acw62.useState)(null); // Local state for errors
    const fileInputRef = (0, $acw62.useRef)(null);
    const handleFileChange = (event)=>{
        if (!event.target.files) return;
        setInnerError(null);
        const fileSchema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
            avatar: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any()
        }).refine((data)=>{
            if (data.avatar !== undefined) return data.avatar.size <= (0, $2a27e1541d4c5148$export$2e2bcd8739ae039).MAX_FILE_SIZE && (0, $2a27e1541d4c5148$export$2e2bcd8739ae039).IMAGE_FILE_TYPES.includes(data.avatar.type);
        }, {
            path: [
                "avatar"
            ],
            message: "Profile picture should be a valid jpg, jpeg or png and less than 5MB"
        });
        const parsedFile = fileSchema.safeParse({
            avatar: event.target.files[0]
        });
        if (parsedFile.success === false) {
            const error = parsedFile.error;
            // get the first error message
            const errorMessage = error.issues[0].message;
            // set the error message in the local state
            setInnerError(errorMessage);
            return;
        }
        onChange(event);
        setInnerValue(URL.createObjectURL(event.target.files[0]));
    };
    const [innerValue, setInnerValue] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setInnerValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-flex-col ",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    width: "185px",
                    height: "185px"
                },
                className: ``,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: `tw-rounded-full tw-h-[185px] `,
                            src: isEditing ? innerValue ?? (0, (/*@__PURE__*/$parcel$interopDefault($8980c8a5d2c3be96$exports))) : value ?? (0, (/*@__PURE__*/$parcel$interopDefault($8980c8a5d2c3be96$exports))),
                            alt: "Avatar"
                        }),
                        isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            onClick: ()=>{
                                fileInputRef.current?.click(); // The optional chaining is used to ensure that the current is not null
                            },
                            className: "tw-cursor-pointer tw-w-11 tw-h-11 tw-p-2.5 tw-bg-surfaceLime tw-rounded-[360px] tw-justify-center tw-items-center tw-inline-flex tw-absolute tw-bottom-0 tw-right-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-edit",
                                    style: {
                                        backgroundColor: "black"
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    ref: fileInputRef,
                                    type: "file",
                                    name: name,
                                    className: "tw-hidden",
                                    onChange: (e)=>{
                                        handleFileChange(e);
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-mt-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `tw-text-sm`,
                        children: label
                    }),
                    innerError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `tw-text-westburyRed tw-text-sm`,
                        children: innerError
                    })
                ]
            })
        ]
    });
};









function $1d97bc66d35eccc6$var$FormEditSection() {
    const { isEditing: isEditing, setIsEditing: setIsEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            label: "Edit",
            icon: "edit",
            variant: "secondary",
            onClick: ()=>setIsEditing(!isEditing)
        })
    });
}
const $1d97bc66d35eccc6$export$adccb981c6e2576d = ()=>{
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const user = (0, $bb19b832faf6099b$export$23bbbc4533528f03)();
    const [isOldPasswordError, setIsOldPasswordError] = (0, $acw62.useState)(false);
    const [departmentOptions, setDepartmentOptions] = (0, $acw62.useState)([]);
    const [userPhotoUrl, setUserPhotoUrl] = (0, $acw62.useState)("");
    const [formData, setFormData] = (0, $acw62.useState)({});
    const [userPhoto, setUserPhoto] = (0, $acw62.useState)(null);
    const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    // if old password is set, then password and confirm password must be set
    const AccountSettingsSchema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        firstName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        lastName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        emailAddress: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().regex(emailRegex),
        department: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        oldPassword: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().optional(),
        password: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().optional(),
        confirmPassword: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().optional()
    }).refine((data)=>data.password === data.confirmPassword, {
        message: "Password and confirm password don't match",
        path: [
            "confirmPassword"
        ]
    });
    const fetchData = ()=>{
        api.retrieveAdminPersonalInformation({
            userId: userId
        }).then((personalInfo)=>{
            setFormData({
                firstName: personalInfo.firstName,
                lastName: personalInfo.lastName,
                emailAddress: personalInfo.emailAddress,
                ...personalInfo,
                oldPassword: "",
                password: "",
                confirmPassword: "",
                department: personalInfo.department
            });
            setDepartmentOptions(personalInfo.departmentChoices);
            setUserPhotoUrl(personalInfo.userPhotoUrl ?? (0, (/*@__PURE__*/$parcel$interopDefault($8980c8a5d2c3be96$exports))));
        }).catch((error)=>{
            // parse error
            const data = error.response.json();
            console.log(data);
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong when fetching data"));
        });
    };
    const handleSubmit = (isValid, data, errors)=>{
        if (!isValid) return;
        let payload = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            // emailAddress: formData.emailAddress,
            department: formData.department
        };
        if (formData.oldPassword) payload = {
            ...payload,
            oldPassword: formData.oldPassword,
            password: formData.password
        };
        if (userPhoto && userId) api.updatePhotoAdminPersonalInformation({
            userId: userId,
            userPhoto: userPhoto
        }).then((response)=>{
            setUserPhotoUrl(response.userPhotoUrl);
            user.setImageUrl(response.userPhotoUrl);
        }).catch(()=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong when updating photo"));
        });
        return api.partialUpdateAdminPersonalInformation({
            userId: userId,
            adminPersonalInformation: payload
        }).then(()=>{
            user.setFirstName(formData.firstName);
            user.setLastName(formData.lastName);
            user.setDepartment(formData.department);
            return Promise.resolve(user);
        }).catch((error)=>{
            error.response.json().then((json)=>{
                if (json && json.old_password && json.old_password.includes("Incorrect password")) setIsOldPasswordError(true);
            });
            return Promise.reject(error);
        });
    };
    // TODO: Handle Async file validation in WAvatar
    // TODO: Handle error messages in WAvatar
    const handlePhotoSubmit = (e)=>{
        const image = e.target.files[0];
        if (userId === undefined) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("User not found"));
            return false;
        }
        if (!image) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Image not found"));
            return false;
        }
        setUserPhoto(image);
        return true;
    };
    const handleChange = (event)=>{
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (userId) fetchData();
    }, [
        userId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
        schema: AccountSettingsSchema,
        handleSubmit: handleSubmit,
        onSuccess: ()=>{
            setFormData({
                ...formData,
                oldPassword: "",
                password: "",
                confirmPassword: ""
            });
        },
        formData: formData,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                extraClasses: "tw-w-3/7 tw-min-w-[600px]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-flex-row tw-justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `tw-text-2xl tw-mb-6`,
                                children: "My Account"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1d97bc66d35eccc6$var$FormEditSection, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                        isOpen: isOldPasswordError,
                        onClose: ()=>{
                            setIsOldPasswordError(false);
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31555d64cac64856$export$2e2bcd8739ae039), {
                            title: "Incorrect password",
                            description: "Your current password is incorrect"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-flex-col tw-mb-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92bfaa0dd900734b$export$f81dc54dab7d6a), {
                            onBlur: ()=>{},
                            label: ``,
                            onChange: (e)=>{
                                if (e.target.files === null) return false;
                                return handlePhotoSubmit(e);
                            },
                            type: `avatar`,
                            value: userPhotoUrl,
                            name: `avatar`
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "firstName",
                        label: "First name",
                        // take input validation out of AccountSettings and put it in WInput
                        onBlur: ()=>{},
                        onChange: handleChange,
                        value: formData.firstName
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: `lastName`,
                        label: "Last name",
                        onBlur: ()=>{},
                        onChange: handleChange,
                        value: formData.lastName
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "email",
                        name: `emailAddress`,
                        label: "Email",
                        onBlur: ()=>{},
                        onChange: ()=>{},
                        value: formData.emailAddress,
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                        name: "oldPassword",
                        label: "Current password",
                        icon: "\uD83D\uDC40",
                        onChange: handleChange,
                        onBlur: ()=>{},
                        value: formData.oldPassword
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                        name: "password",
                        label: "New password",
                        onChange: handleChange,
                        onBlur: ()=>{},
                        icon: "\uD83D\uDC40",
                        hideOnView: true,
                        value: formData.password
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                        name: "confirmPassword",
                        label: "Confirm password",
                        icon: "\uD83D\uDC40",
                        onChange: handleChange,
                        onBlur: ()=>{},
                        hideOnView: true,
                        value: formData.confirmPassword
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                        name: `department`,
                        label: "Department",
                        onChange: handleChange,
                        options: departmentOptions.filter((option)=>option == "Membership").map((department)=>({
                                value: department,
                                label: department
                            })),
                        defaultValue: formData.department,
                        onBlur: ()=>{}
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa72595174cf6cb$export$d51e1baf57edf249), {})
        ]
    });
};






var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");


var $bca6762c33b6a61d$exports = {};
$bca6762c33b6a61d$exports = JSON.parse('["United Kingdom","United States of America","Afghanistan","\xc5land Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia (Plurinational State of)","Bonaire, Sint Eustatius and Saba","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon","Canada","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo (the Democratic Republic of the)","Congo","Cook Islands","Costa Rica","Croatia","Cuba","Cura\xe7ao","Cyprus","Czechia","C\xf4te d\'Ivoire","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Falkland Islands   [Malvinas]","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island and McDonald Islands","Holy See","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran (Islamic Republic of)","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea (the Democratic People\'s Republic of)","Korea (the Republic of)","Kuwait","Kyrgyzstan","Lao People\'s Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macao","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia (Federated States of)","Moldova (the Republic of)","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestine, State of","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Republic of North Macedonia","Romania","Russian Federation","Rwanda","R\xe9union","Saint Barth\xe9lemy","Saint Helena, Ascension and Tristan da Cunha","Saint Kitts and Nevis","Saint Lucia","Saint Martin (French part)","Saint Pierre and Miquelon","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten (Dutch part)","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Svalbard and Jan Mayen","Sweden","Switzerland","Syrian Arab Republic","Taiwan (Province of China)","Tajikistan","Tanzania, United Republic of","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","Uruguay","Uzbekistan","Vanuatu","Venezuela (Bolivarian Republic of)","Viet Nam","Virgin Islands (British)","Virgin Islands (U.S.)","Wallis and Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"]');





const $70676ef9534bf4c0$export$6cb73e75575f7e55 = ({ formData: formData, handleChange: handleChange, handleLogoSubmit: handleLogoSubmit })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const containerClasses = isEditing ? `tw-bg-surfaceBlack90
  tw-p-6
  tw-mt-6
  tw-text-white
  tw-rounded-2xl
  tw-max-w-full` : ``;
    const selectCountries = (0, (/*@__PURE__*/$parcel$interopDefault($bca6762c33b6a61d$exports))).map((country)=>{
        return {
            value: country,
            label: country
        };
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: containerClasses,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `tw-text-2xl tw-mb-6`,
                        children: "Company Info"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($70676ef9534bf4c0$var$FormEditSection, {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-justify-between tw-align-top tw-mb-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92bfaa0dd900734b$export$f81dc54dab7d6a), {
                    label: ``,
                    onChange: (e)=>{
                        if (e.target.files === null) return;
                        handleLogoSubmit(e);
                    },
                    type: `avatar`,
                    value: formData.logoImageUrl,
                    name: `avatar`
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Company name",
                name: "name",
                value: formData.name,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Email address",
                name: "emailAddress",
                value: formData.emailAddress,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Address Line 1",
                name: "streetAddress1",
                value: formData.streetAddress1,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Address Line 2",
                name: "streetAddress2",
                value: formData.streetAddress2,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "County",
                name: "county",
                value: formData.county,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Postcode",
                name: "postcode",
                value: formData.postcode,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                label: "Country",
                name: "country",
                defaultValue: formData.country,
                onChange: handleChange,
                options: selectCountries,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Phone number",
                name: "phoneNumber",
                value: formData.phoneNumber,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Website",
                name: "marketingUrl",
                value: formData.marketingUrl,
                onChange: handleChange,
                onBlur: ()=>{}
            })
        ]
    });
};
const $70676ef9534bf4c0$var$FormEditSection = ()=>{
    const { isEditing: isEditing, setIsEditing: setIsEditing, setFormSubmitted: setFormSubmitted } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            label: "Edit",
            variant: "secondary",
            icon: "edit",
            onClick: ()=>{
                setIsEditing(true);
                setFormSubmitted(false);
            }
        })
    });
};




var $acw62 = parcelRequire("acw62");


const $11218644d5359328$export$760afa1517a5896f = ({ formData: formData, handleChange: handleChange })=>{
    const prefix = (0, $acw62.useId)();
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const containerClasses = isEditing ? `tw-bg-surfaceBlack90
  tw-p-6
  tw-mt-6
  tw-text-white
  tw-rounded-2xl
  tw-max-w-full` : ``;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: containerClasses,
        children: [
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: `tw-text-2xl tw-mb-6`,
                children: "Bank Details"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Account name",
                name: "bankAccountName",
                value: formData.bankAccountName,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Sort code",
                name: "bankSortCode",
                value: formData.bankSortCode,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Account number",
                name: "bankAccountNumber",
                value: formData.bankAccountNumber,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Bank Name",
                name: "bankName",
                value: formData.bankName,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Bank Address",
                name: "bankAddress",
                value: formData.bankAddress,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "Bank Postcode",
                name: "bankPostcode",
                value: formData.bankPostcode,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "IBAN Number",
                name: "bankIban",
                value: formData.bankIban,
                onChange: handleChange,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                type: "text",
                label: "BIC/SWIFT code",
                name: "bankBicSwiftCode",
                value: formData.bankBicSwiftCode,
                onChange: handleChange,
                onBlur: ()=>{}
            })
        ]
    });
};



parcelRequire("acw62");




const $3eb79ec02390e132$export$e52caa9ae560afd8 = {
    role: undefined,
    forms: [
        {
            form: undefined
        }
    ]
};
const $3eb79ec02390e132$var$roleSelectOptions = Object.values((0, $acabe406dbdcaf5a$export$a57988bf603f230f)).map((role)=>{
    return {
        value: role,
        label: role
    };
});
const $3eb79ec02390e132$export$619c2b22333b03ca = ({ companyFormRoles: companyFormRoles, setCompanyFormRoles: setCompanyFormRoles, societyForms: societyForms })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const getSocietyFormOptions = (roleIndex, currentFormId)=>{
        const selectedFormsForRole = new Set(companyFormRoles[roleIndex].forms?.map((form)=>form?.form));
        return societyForms.filter((societyForm)=>{
            return societyForm.id === currentFormId || !selectedFormsForRole.has(societyForm.id);
        }).map((societyForm)=>{
            return {
                value: societyForm.readableName,
                label: societyForm.readableName
            };
        });
    };
    const societyIdToName = (id)=>{
        const societyForm = societyForms.find((societyForm)=>societyForm.id == id);
        return societyForm ? societyForm.readableName : "";
    };
    const societyNameToId = (readableName)=>{
        const societyForm = societyForms.find((societyForm)=>societyForm.readableName == readableName);
        return societyForm && societyForm.id ? societyForm.id : "";
    };
    const addForm = ()=>{
        // debugger;
        const newFormRoles = [
            ...companyFormRoles
        ];
        newFormRoles.push($3eb79ec02390e132$export$e52caa9ae560afd8);
        setCompanyFormRoles(newFormRoles);
    };
    const deleteForm = (index)=>{
        const newFormRoles = [
            ...companyFormRoles
        ];
        newFormRoles.splice(index, 1);
        setCompanyFormRoles(newFormRoles);
    };
    const addSubForm = (index)=>{
        // debugger;
        const newFormRoles = [
            ...companyFormRoles
        ];
        newFormRoles[index].forms?.push({
            form: undefined
        });
        setCompanyFormRoles(newFormRoles);
    };
    const deleteSubForm = (index, fIndex)=>{
        const newFormRoles = [
            ...companyFormRoles
        ];
        newFormRoles[index].forms?.splice(fIndex, 1);
        setCompanyFormRoles(newFormRoles);
    };
    const updateRole = (index, newRole)=>{
        const newFormRoles = companyFormRoles.map((role, roleIndex)=>{
            if (roleIndex === index) return {
                ...role,
                role: newRole
            };
            return role;
        });
        setCompanyFormRoles(newFormRoles);
    };
    const updateSubForm = (index, fIndex, newForms)=>{
        const newFormRoles = companyFormRoles.map((role, roleIndex)=>{
            if (roleIndex === index) {
                const newFormsArray = role.forms?.map((form, formIndex)=>{
                    if (formIndex === fIndex) return {
                        ...form,
                        ...newForms
                    };
                    return form;
                });
                return {
                    ...role,
                    forms: newFormsArray
                };
            }
            return role;
        });
        setCompanyFormRoles(newFormRoles);
    };
    const containerClasses = isEditing ? `tw-bg-surfaceBlack90
      tw-p-6
      tw-mt-6
      tw-text-white
      tw-rounded-2xl
      tw-max-w-full` : ``;
    if (!isEditing) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3eb79ec02390e132$var$CompanyFormRolesSummary, {
        containerClasses: containerClasses,
        companyFormRoles: companyFormRoles,
        societyIdToName: societyIdToName
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: containerClasses,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-2xl tw-mb-6 tw-capitalize",
                children: "configure company documents"
            }),
            companyFormRoles.map((companyFormRole, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "role",
                            label: "Role",
                            options: $3eb79ec02390e132$var$roleSelectOptions.filter((role)=>!companyFormRoles.map((companyFormRole)=>companyFormRole.role).includes(role.value) || role.value === companyFormRole.role),
                            defaultValue: companyFormRole.role ? companyFormRole.role : undefined,
                            onChange: (e)=>{
                                updateRole(index, e.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-xs tw-uppercase tw-text-textDove",
                            children: "Add The Forms That Are Required For This Role"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-flex-col tw-mt-4",
                            children: companyFormRole.forms?.map((form, fIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                                            name: "form",
                                            label: "Form",
                                            options: getSocietyFormOptions(index, form.form),
                                            defaultValue: form.form ? societyIdToName(form.form) : undefined,
                                            onChange: (e)=>{
                                                updateSubForm(index, fIndex, {
                                                    ...form,
                                                    form: societyNameToId(e.target.value)
                                                });
                                            }
                                        }),
                                        fIndex == 0 ? "" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                            label: "Remove form",
                                            icon: "trash",
                                            variant: "link-secondary",
                                            onClick: ()=>deleteSubForm(index, fIndex),
                                            extraClasses: companyFormRole.forms?.length && fIndex === companyFormRole.forms?.length - 1 ? "!tw-justify-end tw-text-formOutlineErrorRed tw-mb-4" : "!tw-justify-end tw-text-formOutlineErrorRed"
                                        })
                                    ]
                                }))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: index == 0 ? "tw-flex tw-justify-end" : "tw-flex tw-justify-between",
                            children: [
                                index == 0 ? "" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    label: "Remove role",
                                    icon: "trash",
                                    variant: "link-secondary",
                                    onClick: ()=>deleteForm(index),
                                    extraClasses: "tw-text-formOutlineErrorRed"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    label: "Add another form",
                                    icon: "plus",
                                    variant: "link-secondary",
                                    onClick: ()=>addSubForm(index)
                                })
                            ]
                        }),
                        index != companyFormRoles.length - 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3eb79ec02390e132$var$Ruler, {}) : ""
                    ]
                }, index)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-gap-4 tw-mt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-text-left",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        label: "Add another role",
                        icon: "plus",
                        variant: "link",
                        onClick: addForm
                    })
                })
            })
        ]
    });
};
const $3eb79ec02390e132$var$Ruler = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
        className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
    });
};
const $3eb79ec02390e132$var$CompanyFormRolesSummary = ({ containerClasses: containerClasses, companyFormRoles: companyFormRoles, societyIdToName: societyIdToName })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: containerClasses,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3eb79ec02390e132$var$Ruler, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-2xl tw-mb-6 tw-capitalize",
                children: "configure company documents"
            }),
            companyFormRoles.map((companyFormRole, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Role"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-textDove my-2",
                            children: companyFormRole.role
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: companyFormRole.forms?.length === 1 ? "Form" : "Forms"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            className: "tw-text-textDove my-2",
                            children: companyFormRole.forms?.map((form, fIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: societyIdToName(form.form ?? "")
                                    })
                                }, fIndex))
                        }),
                        index !== companyFormRoles.length - 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3eb79ec02390e132$var$Ruler, {}) : ""
                    ]
                }, index))
        ]
    });
};








const $6c80dc26ec93a8d9$export$1d4614f6bf3dcc20 = ()=>{
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [formData, setFormData] = (0, $acw62.useState)({
        name: "",
        emailAddress: "",
        streetAddress1: "",
        streetAddress2: "",
        county: "",
        country: "",
        postcode: "",
        phoneNumber: "",
        logoImageUrl: "",
        bankAccountName: "",
        bankSortCode: "",
        bankAccountNumber: "",
        bankName: "",
        bankAddress: "",
        bankPostcode: "",
        bankBicSwiftCode: "",
        bankIban: "",
        marketingUrl: ""
    });
    const [companyFormRoles, setCompanyFormRoles] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([
        (0, $3eb79ec02390e132$export$e52caa9ae560afd8)
    ]);
    const [societyForms, setSocietyForms] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [companyLogo, setCompanyLogo] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const handleChange = (event)=>{
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        });
    };
    const schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        name: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        emailAddress: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email(),
        streetAddress1: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        streetAddress2: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        county: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        country: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        postcode: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        phoneNumber: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        bankAccountName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        bankSortCode: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        bankAccountNumber: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        bankName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        bankAddress: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        bankPostcode: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        bankBicSwiftCode: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        bankIban: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1),
        marketingUrl: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(1)
    });
    const fetchData = ()=>{
        api.retrieveCompany().then(({ companyInformation: companyInformation, roleForms: roleForms, societyForms: societyForms })=>{
            setCompanyFormRoles(roleForms ?? [
                defaultCompanyFormRole()
            ]);
            setSocietyForms(societyForms ?? []);
            const formData = {
                name: companyInformation.name ?? "",
                emailAddress: companyInformation.emailAddress ?? "",
                streetAddress1: companyInformation.streetAddress1 ?? "",
                streetAddress2: companyInformation.streetAddress2 ?? "",
                county: companyInformation.county ?? "",
                country: companyInformation.country ?? "",
                postcode: companyInformation.postcode ?? "",
                phoneNumber: companyInformation.phoneNumber ?? "",
                logoImageUrl: companyInformation.logoImageUrl,
                bankAccountName: companyInformation.bankDetails?.bankAccountName ?? "",
                bankSortCode: companyInformation.bankDetails?.bankSortCode ?? "",
                bankAccountNumber: companyInformation.bankDetails?.bankAccountNumber ?? "",
                bankName: companyInformation.bankDetails?.bankName ?? "",
                bankAddress: companyInformation.bankDetails?.bankAddress ?? "",
                bankPostcode: companyInformation.bankDetails?.bankPostcode ?? "",
                bankBicSwiftCode: companyInformation.bankDetails?.bankBicSwiftCode ?? "",
                bankIban: companyInformation.bankDetails?.bankIban ?? "",
                marketingUrl: companyInformation.marketingUrl ?? ""
            };
            setFormData(formData);
        }).catch(()=>{});
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    const handleSubmit = ()=>{
        if (companyLogo != null) api.updateLogoImageCompanyInformationLogoImage({
            logoImage: companyLogo
        }).then(()=>{
            setFormData({
                ...formData,
                logoImageUrl: URL.createObjectURL(companyLogo)
            });
        }).catch(()=>{});
        return api.updateCompany({
            company: {
                roleForms: companyFormRoles,
                companyInformation: {
                    name: formData.name,
                    emailAddress: formData.emailAddress,
                    streetAddress1: formData.streetAddress1,
                    streetAddress2: formData.streetAddress2,
                    county: formData.county,
                    country: formData.country,
                    postcode: formData.postcode,
                    phoneNumber: formData.phoneNumber,
                    marketingUrl: formData.marketingUrl,
                    bankDetails: {
                        bankAccountName: formData.bankAccountName,
                        bankSortCode: formData.bankSortCode,
                        bankAccountNumber: formData.bankAccountNumber,
                        bankName: formData.bankName,
                        bankAddress: formData.bankAddress,
                        bankPostcode: formData.bankPostcode,
                        bankBicSwiftCode: formData.bankBicSwiftCode,
                        bankIban: formData.bankIban
                    }
                }
            }
        });
    };
    const handleLogoSubmit = (e)=>{
        if (e.target.files === null) return;
        const companyLogo = e.target.files[0];
        if (companyLogo === undefined) return;
        setCompanyLogo(companyLogo);
    };
    // Create a props object
    const companyInfoProps = {
        formData: formData,
        handleChange: handleChange,
        handleLogoSubmit: handleLogoSubmit
    };
    const companyFormRolesProps = {
        companyFormRoles: companyFormRoles,
        setCompanyFormRoles: setCompanyFormRoles,
        societyForms: societyForms
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-flex-col",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            schema: schema,
            handleSubmit: handleSubmit,
            onSuccessMessage: null,
            onSuccess: ()=>{
                (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                    text: "Company information saved.",
                    variant: "success",
                    duration: 10000
                });
            },
            formData: formData,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6c80dc26ec93a8d9$var$CompanyInfoContent, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70676ef9534bf4c0$export$6cb73e75575f7e55), {
                            ...companyInfoProps
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11218644d5359328$export$760afa1517a5896f), {
                            ...companyInfoProps
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3eb79ec02390e132$export$619c2b22333b03ca), {
                            ...companyFormRolesProps
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa72595174cf6cb$export$d51e1baf57edf249), {})
            ]
        })
    });
};
const $6c80dc26ec93a8d9$var$CompanyInfoContent = ({ children: children })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const containerClasses = isEditing ? `tw-w-3/7 tw-min-w-[600px]` : `tw-bg-surfaceBlack90
    tw-p-6
    tw-mt-6
    tw-text-white
    tw-rounded-2xl
    tw-max-w-full tw-w-3/7 tw-min-w-[600px]`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: containerClasses,
        children: children
    });
};








function $7c666735050c0648$var$Settings() {
    const [type, setType] = (0, $acw62.useState)("my-account");
    let SelectedComponent = (0, $1d97bc66d35eccc6$export$adccb981c6e2576d);
    if (type === "company-information") SelectedComponent = (0, $6c80dc26ec93a8d9$export$1d4614f6bf3dcc20);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Settings"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-space-x-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                        extraClasses: "tw-w-[240px] tw-self-start tw-text-[16px] tw-line-height-20px tw-font-light",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-mb-4", "tw-cursor-pointer", {
                                    "tw-text-surfaceLime tw-font-medium": type === "my-account",
                                    "tw-font-normal": type !== "my-account"
                                }),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    onClick: ()=>setType("my-account"),
                                    children: "My Account"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-mb-4 tw-cursor-pointer", {
                                    "tw-text-surfaceLime tw-font-medium": type === "company-information",
                                    "tw-font-normal": type !== "company-information"
                                }),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    onClick: ()=>setType("company-information"),
                                    children: "Company Information"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-cursor-pointer tw-font-normal"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    onClick: ()=>navigate("/society-config"),
                                    children: "Society Configuration"
                                })
                            })
                        ]
                    }),
                    type === "my-account" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d97bc66d35eccc6$export$adccb981c6e2576d), {})
                    }),
                    type === "company-information" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c80dc26ec93a8d9$export$1d4614f6bf3dcc20), {}),
                    type === "notification-settings" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                        extraClasses: "tw-w-3/7 tw-min-w-[600px]",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-bg-surfaceBlack90 tw-rounded-lg tw-p-2 tw-w-full",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-bg-surfaceBlack90 tw-rounded-lg tw-text-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: "tw-text-white tw-text-2xl tw-font-bold tw-mb-4",
                                    children: "Notification settings"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var $7c666735050c0648$export$2e2bcd8739ae039 = $7c666735050c0648$var$Settings;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");


// Handle checkbox change
const $f00d91f1f390d4f2$var$WSelectBoxWithCheckboxes = ({ label: label, options: options, onChange: onChange })=>{
    const handleCheckboxChange = (id)=>{
        const prevOptions = [
            ...innerOptions
        ];
        const newOptions = prevOptions.map((option)=>option.id === id ? {
                ...option,
                checked: !option.checked
            } : option);
        setInnerOptions(newOptions);
        // tell the parent component that the options have changed
        onChange(newOptions);
    };
    // store inner options and propagate the whole array when onChange is called
    const [innerOptions, setInnerOptions] = (0, $acw62.useState)(options);
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const [territoriesSearch, setTerritoriesSearch] = (0, $acw62.useState)(""); // Fetch errors from context
    const searchRegex = new RegExp(territoriesSearch, "i");
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [isInputFocused, setInputFocus] = (0, $acw62.useState)(false);
    const wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $acw62.useEffect)(()=>{
        // set the inner options to the parent options
        setInnerOptions(options);
    }, [
        options
    ]);
    // close the dropdown when clicking outside
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            // Cleanup the event listener on component unmount
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // debugger;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-relative tw-mb-4",
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: " ",
                className: "tw-block tw-leading-4 tw-font-medium tw-text-white tw-mb-2",
                children: label
            }),
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                onClick: ()=>setIsOpen(!isOpen),
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-block tw-w-full tw-border-2  tw-bg-surfaceBlack80 tw-text-textWhite tw-p-1 tw-pl-2 tw-rounded-lg tw-cursor-pointer", isInputFocused ? "tw-border-white" : "tw-border-surfaceBlack80"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            autoComplete: "off",
                            placeholder: "Select territories",
                            className: "tw-bg-transparent tw-text-textWhite tw-w-full tw-py-2 tw-rounded-lg tw-border-0 tw-outline-none",
                            name: "search_key",
                            id: "search_key",
                            value: territoriesSearch,
                            onChange: (event)=>setTerritoriesSearch(event.target.value),
                            onFocus: ()=>setInputFocus(true),
                            onBlur: ()=>setInputFocus(false)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-absolute tw-right-0 tw-top-0 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-pointer-events-none",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi wi-sm wi-chevron-down"
                            })
                        })
                    ]
                })
            }),
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-wrap",
                children: innerOptions.filter((option)=>option.checked).map((option, index, filteredOptions)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-text-sm tw-text-textDove",
                        children: [
                            option.label,
                            index < filteredOptions.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: ","
                            }),
                            "\xa0"
                        ]
                    }, index))
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-absolute tw-w-full tw-bg-surfaceBlack80 tw-rounded-lg tw-rounded tw-max-w-[345px] tw-mt-2 tw-p-4 tw-shadow-lg tw-z-50 tw-max-h-[300px] tw-overflow-y-scroll",
                children: innerOptions.filter((option)=>searchRegex.test(option.label)).map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-mb-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-relative tw-inline-block tw-w-6 tw-h-6 tw-mr-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: option.id,
                                        checked: option.checked,
                                        onChange: ()=>handleCheckboxChange(option.id),
                                        className: "tw-absolute tw-w-full tw-h-full tw-opacity-0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `tw-w-full tw-h-full tw-border-2 tw-rounded ${option.checked ? "tw-bg-surfaceBlack90" : "tw-bg-surfaceBlack80"} tw-flex tw-items-center tw-justify-center tw-text-textWhite`,
                                        children: option.checked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                                id: "check",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    id: "Vector",
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M20.6187 6.38128C20.9604 6.72299 20.9604 7.27701 20.6187 7.61872L10.6187 17.6187C10.277 17.9604 9.72299 17.9604 9.38128 17.6187L4.38128 12.6187C4.03957 12.277 4.03957 11.723 4.38128 11.3813C4.72299 11.0396 5.27701 11.0396 5.61872 11.3813L10 15.7626L19.3813 6.38128C19.723 6.03957 20.277 6.03957 20.6187 6.38128Z",
                                                    fill: "white"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: option.id,
                                className: "tw-text-textWhite",
                                children: option.label
                            })
                        ]
                    }, option.id))
            })
        ]
    });
};
var $f00d91f1f390d4f2$export$2e2bcd8739ae039 = $f00d91f1f390d4f2$var$WSelectBoxWithCheckboxes;




var $acw62 = parcelRequire("acw62");




const $8ccbf19395abc1b2$var$WImageUpload = ({ label: label, subTitle: subTitle, onFileChange: onFileChange, value: value, name: name })=>{
    const fileInputRef = (0, $acw62.useRef)(null);
    const handleFileChange = (event)=>{
        setInnerError(null);
        if (!event.target.files) return;
        const file = event.target.files[0];
        const data = {
            image: file
        };
        // In order to not display the previewed image, we need to prevent the default behavior of the input if the file is not valid
        const imageUploadSchema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
            image: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any()
        }).refine((data)=>{
            if (data.image !== undefined) return data.image.size <= (0, $2a27e1541d4c5148$export$2e2bcd8739ae039).MAX_FILE_SIZE && (0, $2a27e1541d4c5148$export$2e2bcd8739ae039).IMAGE_FILE_TYPES.includes(data.image.type);
        }, {
            path: [
                "image"
            ],
            message: "Image should be a valid jpg, jpeg or png and less than 5MB."
        });
        const result = imageUploadSchema.safeParse(data);
        if (result.success === false) {
            const error = result.error;
            // get the first error message
            const errorMessage = error.issues[0].message;
            // set the error message in the local state
            setInnerError(errorMessage);
            return;
        }
        setInnerValue(file);
        onFileChange(event);
    };
    const handleClick = ()=>{
        fileInputRef.current?.click();
    };
    const [innerValue, setInnerValue] = (0, $acw62.useState)(null);
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors, validateForm: validateForm } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const [innerError, setInnerError] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setInnerError(errors[name]);
    }, [
        errors,
        name
    ]);
    // whenever the value changes, reset the inner value and error
    // otherwise component state is kept between different values
    (0, $acw62.useEffect)(()=>{
        setInnerValue(null);
        setInnerError(null);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "tw-w-[120px] tw-h-[120px] tw-mb-6 tw-bg-textGraphite tw-rounded-full",
                src: value ? value : "/images/default-avatar.png",
                alt: "Profile image"
            }),
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                    "tw-relative tw-border-dashed tw-border-2 tw-border-textGraphite tw-rounded tw-p-6 tw-cursor-pointer tw-mb-4": !innerValue
                }),
                onClick: handleClick,
                children: [
                    innerValue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-relative tw-w-[185px] tw-h-[185px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                onClick: ()=>{
                                    fileInputRef.current?.click(); // The optional chaining is used to ensure that the current is not null
                                },
                                className: "tw-cursor-pointer tw-w-11 tw-h-11 tw-p-2.5 tw-bg-surfaceLime tw-rounded-[360px] tw-justify-center tw-items-center tw-inline-flex tw-absolute tw-bottom-0 tw-right-0",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-edit",
                                    style: {
                                        backgroundColor: "black"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "tw-w-[185px] tw-h-[185px] tw-mb-4 tw-bg-textGraphite tw-rounded-full",
                                src: URL.createObjectURL(innerValue),
                                alt: "Profile image"
                            })
                        ]
                    }),
                    !innerValue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-text-center tw-font-light",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "",
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: subTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-mb-4 tw-flex tw-justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-lg wi-export"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        name: name,
                        ref: fileInputRef,
                        type: "file",
                        className: "tw-hidden",
                        onChange: handleFileChange
                    }),
                    innerError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-p-2 tw-bg-westburyRed tw-text-white tw-text-center",
                        children: innerError
                    })
                ]
            })
        ]
    });
};
var $8ccbf19395abc1b2$export$2e2bcd8739ae039 = $8ccbf19395abc1b2$var$WImageUpload;




const $cc76d270f8cab3fa$export$ad2f3b3b8fde444f = ({ societySelected: societySelected, setSocietyInfoDetails: setSocietyInfoDetails, setIsEditingSociety: setIsEditingSociety })=>{
    const [id, setId] = (0, $acw62.useState)("");
    const [internalIdentifier, setInternalIdentifier] = (0, $acw62.useState)("");
    const [readableName, setReadableName] = (0, $acw62.useState)("");
    const [address, setAddress] = (0, $acw62.useState)("");
    const [country, setCountry] = (0, $acw62.useState)("");
    const [website, setWebsite] = (0, $acw62.useState)("");
    const [additionalTerritoriesChecked, setAdditionalTerritoriesChecked] = (0, $acw62.useState)("");
    const [additionalTerritories, setAdditionalTerritories] = (0, $acw62.useState)([]);
    const [phone, setPhone] = (0, $acw62.useState)("");
    const [portal, setPortal] = (0, $acw62.useState)("");
    const [societyLogo, setSocietyLogo] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setId(societySelected?.id ? societySelected.id : "");
        setInternalIdentifier(societySelected?.internalIdentifier ? societySelected.internalIdentifier : "");
        setReadableName(societySelected?.readableName ? societySelected.readableName : "");
        setAddress(societySelected?.address ? societySelected.address : "");
        setCountry(societySelected?.country ? societySelected.country : "");
        setWebsite(societySelected?.website ? societySelected.website : "");
        const additionalTerritoriesCondition = societySelected?.additionalTerritories && societySelected.additionalTerritories != undefined && societySelected.additionalTerritories.length > 0;
        setAdditionalTerritoriesChecked(additionalTerritoriesCondition ? "Yes" : "No");
        setAdditionalTerritories(additionalTerritoriesCondition ? societySelected.additionalTerritories : []);
        setPhone(societySelected?.phone ? societySelected.phone : "");
        setPortal(societySelected?.portal ? societySelected.portal : "");
        setSocietyLogo(undefined);
    }, [
        societySelected
    ]);
    (0, $acw62.useEffect)(()=>{
        const societyInfoDetailsForm = {
            id: societySelected?.id,
            internalIdentifier: internalIdentifier,
            readableName: readableName,
            address: address,
            country: country,
            website: website,
            additionalTerritories: [],
            phone: phone,
            portal: portal
        };
        if (societyLogo && societyLogo !== undefined) societyInfoDetailsForm.logo = societyLogo;
        if (additionalTerritoriesChecked && additionalTerritoriesChecked === "Yes") {
            if (additionalTerritories && additionalTerritories.length > 0) societyInfoDetailsForm.additionalTerritories = additionalTerritories;
        }
        setSocietyInfoDetails(societyInfoDetailsForm);
    }, [
        id,
        internalIdentifier,
        readableName,
        address,
        country,
        website,
        additionalTerritoriesChecked,
        additionalTerritories,
        phone,
        portal,
        societyLogo
    ]);
    const handleSocietyLogoChange = (event)=>{
        if (!event.target.files) return;
        setSocietyLogo(event.target.files[0]);
    };
    // debugger returns 0 when inspecting Countries
    const countries = (0, (/*@__PURE__*/$parcel$interopDefault($bca6762c33b6a61d$exports)));
    const baseSelectCountries = countries.map((country)=>({
            id: country,
            label: country,
            checked: additionalTerritories.includes(country)
        }));
    const [selectCountries, setSelectCountries] = (0, $acw62.useState)(baseSelectCountries);
    // If a country is selected, remove it from the list of territories
    (0, $acw62.useEffect)(()=>{
        if (country === "") return;
        const territories = [
            ...baseSelectCountries
        ];
        // remove the selected country from the selectCountries list
        const index = territories.findIndex((territory)=>territory.id === country);
        territories.splice(index, 1);
        setSelectCountries(territories);
    }, [
        country
    ]);
    const countriesSelectList = (0, (/*@__PURE__*/$parcel$interopDefault($bca6762c33b6a61d$exports))).map((country)=>({
            value: country,
            label: country
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        extraClasses: "tw-max-w-[650px]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ccbf19395abc1b2$export$2e2bcd8739ae039), {
                        value: societySelected?.logoUrl ? societySelected?.logoUrl : "",
                        label: "Upload society logo",
                        subTitle: "Drag and drop or click to upload",
                        onFileChange: (e)=>{
                            handleSocietyLogoChange(e);
                        },
                        name: "logo"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cc76d270f8cab3fa$var$FormEditSection, {
                        setIsEditingSocietyGlobal: setIsEditingSociety
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Name",
                type: "text",
                onBlur: ()=>{},
                value: readableName ? readableName : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, setReadableName),
                name: "readableName"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Address",
                type: "text",
                onBlur: ()=>{},
                value: address ? address : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, setAddress),
                name: "address"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                label: "Country",
                name: "country",
                defaultValue: country ? country : undefined,
                onChange: (e)=>{
                    setCountry(e.target.value);
                    const territories = [
                        ...baseSelectCountries
                    ];
                    // remove the selected country from the selectCountries list
                    const index = territories.findIndex((territory)=>territory.id === e.target.value);
                    territories.splice(index, 1);
                    setSelectCountries(territories);
                },
                options: countriesSelectList,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                label: "Covers Additional Territories",
                name: "additionalTerritoriesChecked",
                selectedValue: additionalTerritoriesChecked,
                items: [
                    {
                        value: "Yes",
                        label: "Yes"
                    },
                    {
                        value: "No",
                        label: "No"
                    }
                ],
                onChange: (e)=>{
                    setAdditionalTerritoriesChecked(e.target.value);
                }
            }),
            additionalTerritoriesChecked === "Yes" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f00d91f1f390d4f2$export$2e2bcd8739ae039), {
                    label: `Additional Territories`,
                    options: selectCountries,
                    onBlur: ()=>{},
                    onChange: (selectedTerritories)=>setAdditionalTerritories(selectedTerritories)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Website",
                type: "text",
                onBlur: ()=>{},
                value: website ? website : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, setWebsite),
                name: "website"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Phone",
                type: "text",
                onBlur: ()=>{},
                value: phone ? phone : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, setPhone),
                name: "phone"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Portal",
                type: "text",
                onBlur: ()=>{},
                value: portal ? portal : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, setPortal),
                name: "portal"
            })
        ]
    });
};
function $cc76d270f8cab3fa$var$FormEditSection({ setIsEditingSocietyGlobal: setIsEditingSocietyGlobal }) {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                variant: "secondary",
                icon: "edit",
                onClick: ()=>{
                    setIsEditingSocietyGlobal(true);
                    setIsEditing(true);
                },
                label: "Edit"
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");


const $e1871ac2e6b6f47b$export$83ea3b89da471b36 = ({ notifyByEmailCheck: notifyByEmailCheck, notifyByPostCheck: notifyByPostCheck, notifyByPortalCheck: notifyByPortalCheck, notifyEmail: notifyEmail, notifyPost: notifyPost, notifyPortal: notifyPortal, setNotifyByEmailCheck: setNotifyByEmailCheck, setNotifyByPostCheck: setNotifyByPostCheck, setNotifyByPortalCheck: setNotifyByPortalCheck, setNotifyEmail: setNotifyEmail, setNotifyPost: setNotifyPost, setNotifyPortal: setNotifyPortal })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-mb-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: " ",
                className: "tw-text-white tw-mb-4",
                children: "How Are Forms Sent To This Society?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1871ac2e6b6f47b$var$CustomInput, {
                label: `Email`,
                placeholder: `Email address`,
                checked: notifyByEmailCheck,
                inputValue: notifyEmail,
                isEnabled: isEditing,
                onCheckboxChange: setNotifyByEmailCheck,
                onInputChange: setNotifyEmail
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1871ac2e6b6f47b$var$CustomInput, {
                label: `Post`,
                placeholder: `Address`,
                checked: notifyByPostCheck,
                inputValue: notifyPost,
                isEnabled: isEditing,
                onCheckboxChange: setNotifyByPostCheck,
                onInputChange: setNotifyPost
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1871ac2e6b6f47b$var$CustomInput, {
                label: `Portal`,
                placeholder: `Portal`,
                checked: notifyByPortalCheck,
                inputValue: notifyPortal,
                isEnabled: isEditing,
                onCheckboxChange: setNotifyByPortalCheck,
                onInputChange: setNotifyPortal
            })
        ]
    });
};
const $e1871ac2e6b6f47b$var$CustomInput = ({ label: label, placeholder: placeholder, checked: checked, inputValue: inputValue, isEnabled: isEnabled, onCheckboxChange: onCheckboxChange, onInputChange: onInputChange })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `tw-flex tw-items-center tw-w-full ${isEnabled ? "" : "tw-opacity-50"}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "tw-flex tw-items-center tw-cursor-pointer tw-w-1/4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-relative tw-inline-block tw-w-6 tw-h-6 tw-mr-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "checkbox",
                                // id={option.id}
                                disabled: !isEnabled,
                                checked: checked,
                                onClick: (e)=>{
                                    if (!isEnabled) e.preventDefault();
                                },
                                onChange: (e)=>onCheckboxChange(e.target.checked),
                                className: "tw-absolute tw-w-full tw-h-full tw-opacity-0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `tw-w-full tw-h-full tw-border-2 tw-rounded ${checked ? "tw-bg-surfaceBlack90" : "tw-bg-surfaceBlack80"} tw-flex tw-items-center tw-justify-center tw-text-textWhite`,
                                children: checked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                        id: "check",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            id: "Vector",
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M20.6187 6.38128C20.9604 6.72299 20.9604 7.27701 20.6187 7.61872L10.6187 17.6187C10.277 17.9604 9.72299 17.9604 9.38128 17.6187L4.38128 12.6187C4.03957 12.277 4.03957 11.723 4.38128 11.3813C4.72299 11.0396 5.27701 11.0396 5.61872 11.3813L10 15.7626L19.3813 6.38128C19.723 6.03957 20.277 6.03957 20.6187 6.38128Z",
                                            fill: "white"
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: label
                    })
                ]
            }),
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `tw-w-3/4`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "text",
                    value: inputValue,
                    onChange: (e)=>onInputChange(e.target.value),
                    disabled: !checked || !isEnabled,
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-12", "tw-placeholder-textSeal", "tw-text-sm", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none"),
                    placeholder: placeholder
                })
            })
        ]
    });
};
var $e1871ac2e6b6f47b$export$2e2bcd8739ae039 = $e1871ac2e6b6f47b$var$CustomInput;



parcelRequire("acw62");



const $972c6ff5333ed3f2$var$frequencyOptions = Object.values((0, $3fcbd4bdbdf09193$export$2e487ae93f0349b8));
const $972c6ff5333ed3f2$export$f3f31e5b4af87478 = ({ reminderSociety: reminderSociety, reminderEmail: reminderEmail, reminderFrequency: reminderFrequency, stopReminder: stopReminder, setReminderFrequency: setReminderFrequency, setReminderEmail: setReminderEmail, setStopReminder: setStopReminder })=>{
    // transform options
    let reminderOptions = $972c6ff5333ed3f2$var$frequencyOptions.map((option)=>{
        return {
            value: option,
            label: option
        };
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: reminderSociety === "reminder_society_Yes" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-space-x-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-w-1/2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Reminder frequency",
                            name: "reminder_frequency",
                            defaultValue: reminderFrequency,
                            options: reminderOptions,
                            onBlur: ()=>{},
                            onChange: (e)=>setReminderFrequency(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Stop reminders after",
                            name: "stop_reminder",
                            defaultValue: stopReminder,
                            options: reminderOptions,
                            onBlur: ()=>{},
                            onChange: (e)=>setStopReminder(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-w-1/2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        label: "Send to",
                        type: "email",
                        name: "reminder_email",
                        onBlur: ()=>{},
                        onChange: (e)=>setReminderEmail(e.target.value),
                        value: reminderEmail
                    })
                })
            ]
        })
    });
};



parcelRequire("acw62");

const $6489b6a11b46f9e4$export$f205b16615c63b8f = ({ isEditingSociety: isEditingSociety, differentTaxForm: differentTaxForm, setDifferentTaxForm: setDifferentTaxForm, formRoles: formRoles, setFormRoles: setFormRoles })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
            label: "Are Different Tax Forms Needed?",
            name: "different_tax_form",
            selectedValue: differentTaxForm,
            items: [
                {
                    value: "different_tax_form_Yes",
                    label: "Yes"
                },
                {
                    value: "different_tax_form_No",
                    label: "No"
                }
            ],
            onChange: (e)=>{
                setDifferentTaxForm(e.target.value);
            }
        })
    });
};



parcelRequire("acw62");

var $4d6712f60e31b0c6$exports = {};
$4d6712f60e31b0c6$exports = JSON.parse('["British","American","Afghan","Albanian","Algerian","Andorran","Angolan","Antiguans","Argentinean","Armenian","Australian","Austrian","Azerbaijani","Bahamian","Bahraini","Bangladeshi","Barbadian","Barbudans","Batswana","Belarusian","Belgian","Belizean","Beninese","Bhutanese","Bolivian","Bosnian","Brazilian","Bruneian","Bulgarian","Burkinabe","Burmese","Burundian","Cambodian","Cameroonian","Canadian","Cape Verdean","Central African","Chadian","Chilean","Chinese","Colombian","Comoran","Congolese","Congolese","Costa Rican","Croatian","Cuban","Cypriot","Czech","Danish","Djibouti","Dominican","Dutch","Dutchman","Dutchwoman","East Timorese","Ecuadorean","Egyptian","Emirian","Equatorial Guinean","Eritrean","Estonian","Ethiopian","Fijian","Filipino","Finnish","French","Gabonese","Gambian","Georgian","German","Ghanaian","Greek","Grenadian","Guatemalan","Guinea-Bissauan","Guinean","Guyanese","Haitian","Herzegovinian","Honduran","Hungarian","I-Kiribati","Icelander","Indian","Indonesian","Iranian","Iraqi","Irish","Israeli","Italian","Ivorian","Jamaican","Japanese","Jordanian","Kazakhstani","Kenyan","Kittian and Nevisian","Kuwaiti","Kyrgyz","Laotian","Latvian","Lebanese","Liberian","Libyan","Liechtensteiner","Lithuanian","Luxembourger","Macedonian","Malagasy","Malawian","Malaysian","Maldivan","Malian","Maltese","Marshallese","Mauritanian","Mauritian","Mexican","Micronesian","Moldovan","Monacan","Mongolian","Moroccan","Mosotho","Motswana","Mozambican","Namibian","Nauruan","Nepalese","Netherlander","New Zealander","Ni-Vanuatu","Nicaraguan","Nigerian","Nigerien","North Korean","Northern Irish","Norwegian","Omani","Pakistani","Palauan","Panamanian","Papua New Guinean","Paraguayan","Peruvian","Polish","Portuguese","Qatari","Romanian","Russian","Rwandan","Saint Lucian","Salvadoran","Samoan","San Marinese","Sao Tomean","Saudi","Scottish","Senegalese","Serbian","Seychellois","Sierra Leonean","Singaporean","Slovakian","Slovenian","Solomon Islander","Somali","South African","South Korean","Spanish","Sri Lankan","Sudanese","Surinamer","Swazi","Swedish","Swiss","Syrian","Taiwanese","Tajik","Tanzanian","Thai","Togolese","Tongan","Trinidadian","Tobagonian","Tunisian","Turkish","Tuvaluan","Ugandan","Ukrainian","Uruguayan","Uzbekistani","Venezuelan","Vietnamese","Welsh","Yemenite","Zambian","Zimbabwean"]');






const $4139f894e5c9b6e7$var$determinedByOptions = Object.values((0, $98a0cfd0de059254$export$7863502ca02bbd4a)).map((option)=>({
        value: option,
        label: option
    }));
const $4139f894e5c9b6e7$var$signatureOptions = Object.values((0, $efe484b832d95e72$export$bebbe8f42e79a1f0)).map((role)=>({
        label: role,
        value: role
    }));
const $4139f894e5c9b6e7$var$sendViaOptions = Object.values((0, $efe484b832d95e72$export$2ff726ead5d5b9cc)).map((role)=>({
        label: role,
        value: role
    }));
const $4139f894e5c9b6e7$var$signedByOptions = Object.values((0, $efe484b832d95e72$export$b2ac61b2aa882589)).map((role)=>({
        label: role,
        value: role
    }));
const $4139f894e5c9b6e7$var$countryOptions = [
    {
        label: "Any other",
        value: "Any other"
    },
    ...(0, (/*@__PURE__*/$parcel$interopDefault($bca6762c33b6a61d$exports))).map((country)=>({
            label: country,
            value: country
        }))
];
const $4139f894e5c9b6e7$var$nationalityOptions = [
    {
        label: "Any other",
        value: "Any other"
    },
    ...(0, (/*@__PURE__*/$parcel$interopDefault($4d6712f60e31b0c6$exports))).map((nationality)=>({
            label: nationality,
            value: nationality
        }))
];
const $4139f894e5c9b6e7$export$a1efad21f1afa8ad = ({ isEditingSociety: isEditingSociety, differentTaxForm: differentTaxForm, taxForms: taxForms, setTaxForms: setTaxForms, societyForms: societyForms })=>{
    const addForm = ()=>{
        setTaxForms([
            ...taxForms,
            {
                determined_by: "",
                country: "",
                form: "",
                signed_by: "",
                signature: "",
                send_via: ""
            }
        ]);
    };
    const updateForm = (index, newForm)=>{
        const newTaxforms = [
            ...taxForms
        ];
        newTaxforms[index] = newForm;
        setTaxForms(newTaxforms);
    };
    const deleteForm = (index)=>{
        const newTaxforms = [
            ...taxForms
        ];
        newTaxforms.splice(index, 1);
        setTaxForms(newTaxforms);
    };
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: differentTaxForm == "different_tax_form_Yes" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-w-full tw-flex-col",
                    children: taxForms.map(({ determined_by: determined_by, country: country, form: form, signature: signature, send_via: send_via, signed_by: signed_by }, index)=>$4139f894e5c9b6e7$var$taxFormDetail({
                            isEditingSociety: isEditingSociety,
                            index: index,
                            determined_by: determined_by,
                            country: country,
                            form: form,
                            send_via: send_via,
                            signature: signature,
                            signed_by: signed_by,
                            updateForm: updateForm,
                            deleteForm: deleteForm,
                            societyForms: societyForms
                        }))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-justify-end",
                    children: isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        label: "Add another form",
                        icon: "plus",
                        variant: "link",
                        onClick: ()=>{
                            console.log("called");
                            addForm();
                        }
                    })
                })
            ]
        }) : ""
    });
};
const $4139f894e5c9b6e7$var$taxFormDetail = ({ isEditingSociety: isEditingSociety, index: index, determined_by: determined_by, country: country, form: form, send_via: send_via, signature: signature, signed_by: signed_by, updateForm: updateForm, deleteForm: deleteForm, societyForms: societyForms })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const taxFormOptions = societyForms.map((societyForm)=>({
            label: societyForm.readableName,
            value: societyForm.readableName
        }));
    const updateDeterminedBy = (selectedDeterminedBy)=>{
        updateForm(index, {
            determined_by: selectedDeterminedBy,
            country: country,
            form: form,
            send_via: send_via,
            signature: signature,
            signed_by: signed_by
        });
    };
    const updateCountry = (selectedCountry)=>{
        updateForm(index, {
            determined_by: determined_by,
            country: selectedCountry,
            form: form,
            send_via: send_via,
            signature: signature,
            signed_by: signed_by
        });
    };
    const updateSignedBy = (selectedSignedBy)=>{
        updateForm(index, {
            determined_by: determined_by,
            country: country,
            form: form,
            send_via: send_via,
            signature: signature,
            signed_by: selectedSignedBy
        });
    };
    const updateSignature = (selectedSignature)=>{
        updateForm(index, {
            determined_by: determined_by,
            country: country,
            form: form,
            send_via: send_via,
            signature: selectedSignature,
            signed_by: signed_by
        });
    };
    const updateSendVia = (selectedSendVia)=>{
        updateForm(index, {
            determined_by: determined_by,
            country: country,
            form: form,
            send_via: selectedSendVia,
            signature: signature,
            signed_by: signed_by
        });
    };
    const updateTaxForm = (selectedTaxForm)=>{
        updateForm(index, {
            determined_by: determined_by,
            country: country,
            form: selectedTaxForm,
            send_via: send_via,
            signature: signature,
            signed_by: signed_by
        });
    };
    const societyNameToId = (readableName)=>{
        const societyForm = societyForms.find((societyForm)=>societyForm.readableName === readableName);
        return societyForm?.id ?? "";
    };
    const societyIdToName = (id)=>{
        const societyForm = societyForms.find((societyForm)=>societyForm.id === id);
        return societyForm?.readableName ?? "";
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-space-x-2 tw-mt-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Determined by",
                            name: "determined_by",
                            defaultValue: determined_by && determined_by != "" ? determined_by : undefined,
                            options: $4139f894e5c9b6e7$var$determinedByOptions,
                            onBlur: ()=>{},
                            onChange: (e)=>updateDeterminedBy(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: determined_by == "Nationality" ? "Nationality" : "Country",
                            name: "country",
                            defaultValue: country && country != "" ? country : undefined,
                            options: determined_by == "Nationality" ? $4139f894e5c9b6e7$var$nationalityOptions : $4139f894e5c9b6e7$var$countryOptions,
                            onBlur: ()=>{},
                            onChange: (e)=>updateCountry(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Form",
                            name: "form",
                            defaultValue: form && form != "" ? societyIdToName(form) : undefined,
                            options: taxFormOptions,
                            onBlur: ()=>{},
                            onChange: (e)=>updateTaxForm(societyNameToId(e.target.value))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-space-x-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "signedBy",
                            defaultValue: signed_by && signed_by !== "" ? signed_by : undefined,
                            label: "Signed by",
                            options: $4139f894e5c9b6e7$var$signedByOptions,
                            onChange: (e)=>updateSignedBy(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "signature",
                            defaultValue: signature && signature !== "" ? signature : undefined,
                            label: "Signature",
                            options: $4139f894e5c9b6e7$var$signatureOptions,
                            onChange: (e)=>updateSignature(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "sendVia",
                            defaultValue: send_via && send_via !== "" ? send_via : undefined,
                            label: "Send via",
                            options: $4139f894e5c9b6e7$var$sendViaOptions,
                            onChange: (e)=>updateSendVia(e.target.value)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-space-x-1",
                    children: isEditing && index != 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        onClick: ()=>deleteForm(index),
                        label: "Remove",
                        variant: "link-secondary",
                        icon: "trash"
                    }) : ""
                })
            })
        ]
    }, index);
};




var $acw62 = parcelRequire("acw62");




const $17301cb79d6da8bd$var$roleSelectOptions = Object.values((0, $50e4c7544de1252c$export$17dd5a46c1eb75e2)).map((role)=>({
        label: role,
        value: role
    }));
const $17301cb79d6da8bd$var$signatureOptions = Object.values((0, $efe484b832d95e72$export$bebbe8f42e79a1f0)).map((role)=>({
        label: role,
        value: role
    }));
const $17301cb79d6da8bd$var$sendViaOptions = Object.values((0, $efe484b832d95e72$export$2ff726ead5d5b9cc)).map((role)=>({
        label: role,
        value: role
    }));
const $17301cb79d6da8bd$var$signedByOptions = Object.values((0, $efe484b832d95e72$export$b2ac61b2aa882589)).map((role)=>({
        label: role,
        value: role
    }));
const $17301cb79d6da8bd$export$c5886a1ce6e8575a = ({ isEditingSociety: isEditingSociety, formRoles: formRoles, setFormRoles: setFormRoles, societyForms: societyForms })=>{
    const [roleFormToggle, setRoleFormToggle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(-1);
    const societyIdToName = (id)=>{
        const societyForm = societyForms.find((societyForm)=>societyForm.id == id);
        return societyForm ? societyForm.readableName : "";
    };
    const societyNameToId = (readableName)=>{
        const societyForm = societyForms.find((societyForm)=>societyForm.readableName == readableName);
        return societyForm ? societyForm.id : "";
    };
    const addForm = ()=>{
        const newFormRoles = [
            ...formRoles
        ];
        newFormRoles.push({
            role: "",
            forms: [
                {
                    form: "",
                    signature: "",
                    send_via: "",
                    signed_by: ""
                }
            ]
        });
        setFormRoles(newFormRoles);
    };
    const deleteForm = (index)=>{
        const newFormRoles = [
            ...formRoles
        ];
        newFormRoles.splice(index, 1);
        setFormRoles(newFormRoles);
    };
    const addSubForm = (index)=>{
        const newFormRoles = [
            ...formRoles
        ];
        newFormRoles[index].forms.push({
            form: "",
            signature: "",
            send_via: "",
            signed_by: ""
        });
        setFormRoles(newFormRoles);
    };
    const deleteSubForm = (index, fIndex)=>{
        const newFormRoles = [
            ...formRoles
        ];
        newFormRoles[index].forms.splice(fIndex, 1);
        setFormRoles(newFormRoles);
    };
    const updateRole = (index, newRole)=>{
        const newFormRoles = [
            ...formRoles
        ];
        newFormRoles[index].role = newRole;
        setFormRoles(newFormRoles);
        // auto-open the accordion
        setRoleFormToggle(index);
    };
    const updateSubForm = (index, fIndex, newForms)=>{
        const newFormRoles = [
            ...formRoles
        ];
        const oldForm = newFormRoles[index].forms[fIndex];
        newFormRoles[index].forms[fIndex] = {
            ...oldForm,
            ...newForms
        };
        setFormRoles(newFormRoles);
    };
    (0, $acw62.useEffect)(()=>{
        // accordion should be closed when you've just opened the page
        // when editing a society, it should be allowed to open
        if (!isEditingSociety) setRoleFormToggle(-1);
    }, [
        formRoles
    ]);
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const getSocietyFormOptions = (roleIndex, currentFormId)=>{
        const selectedFormsForRole = new Set(formRoles[roleIndex].forms?.map((form)=>form?.form));
        return societyForms.filter((societyForm)=>{
            return societyForm.id === currentFormId || !selectedFormsForRole.has(societyForm.id);
        }).map((societyForm)=>{
            return {
                value: societyForm.readableName,
                label: societyForm.readableName
            };
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-text-2xl tw-mt-6 tw-mb-6",
                        children: "Membership Form Configuration"
                    }),
                    formRoles.map(({ role: role, forms: forms }, index)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-w-full tw-flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-w-full",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                                                name: "roleSelect",
                                                defaultValue: role != "" ? role : undefined,
                                                label: "What Is This Role?",
                                                options: $17301cb79d6da8bd$var$roleSelectOptions.filter((role)=>!formRoles.map((societyFormRole)=>societyFormRole.role).includes(role.value) || role.value === formRoles[index].role),
                                                onChange: (e)=>updateRole(index, e.target.value)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: `tw-text-textDove tw-uppercase tw-mt-6 tw-mb-6 tw-text-xs`,
                                                    children: "Add The Forms That Are Required For This Role"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-flex-col",
                                                    children: [
                                                        forms && forms.length > 0 ? forms.map(({ form: form, signature: signature, send_via: send_via, signed_by: signedBy }, fIndex)=>$17301cb79d6da8bd$var$RoleFormDetail({
                                                                isEditingSociety: isEditingSociety,
                                                                societyFormOptions: getSocietyFormOptions(index, form),
                                                                index: index,
                                                                fIndex: fIndex,
                                                                form: form,
                                                                signature: signature,
                                                                send_via: send_via,
                                                                signed_by: signedBy,
                                                                addSubForm: addSubForm,
                                                                updateSubForm: updateSubForm,
                                                                deleteSubForm: deleteSubForm,
                                                                societyIdToName: societyIdToName,
                                                                societyNameToId: societyNameToId
                                                            })) : "",
                                                        isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-justify-end",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                label: "Add form",
                                                                variant: "link-secondary",
                                                                icon: "plus",
                                                                onClick: ()=>addSubForm(index)
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-flex tw-justify-start",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                variant: "link-secondary",
                                                onClick: ()=>deleteForm(index),
                                                label: "Remove role",
                                                icon: "trash"
                                            })
                                        })
                                    ]
                                }, index),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
                                })
                            ]
                        }, index);
                    }),
                    isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-end",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            onClick: ()=>addForm(),
                            variant: "link-secondary",
                            icon: "plus",
                            label: "Add another role"
                        })
                    })
                ]
            })
        ]
    });
};
const $17301cb79d6da8bd$var$RoleFormDetail = ({ isEditingSociety: isEditingSociety, societyFormOptions: societyFormOptions, index: index, fIndex: fIndex, form: form, signature: signature, send_via: send_via, signed_by: signed_by, addSubForm: addSubForm, updateSubForm: updateSubForm, deleteSubForm: deleteSubForm, societyIdToName: societyIdToName, societyNameToId: societyNameToId })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const updateForm = (newValue)=>{
        updateSubForm(index, fIndex, {
            form: newValue,
            signature: signature,
            send_via: send_via,
            signed_by: signed_by
        });
    };
    const updateSignature = (newValue)=>{
        updateSubForm(index, fIndex, {
            form: form,
            signature: newValue,
            send_via: send_via,
            signed_by: signed_by
        });
    };
    const updateSendVia = (newValue)=>{
        updateSubForm(index, fIndex, {
            form: form,
            signature: signature,
            send_via: newValue,
            signed_by: signed_by
        });
    };
    const updateSignedBy = (newValue)=>{
        updateSubForm(index, fIndex, {
            form: form,
            signature: signature,
            send_via: send_via,
            signed_by: newValue
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-w-full tw-flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                    name: "formName",
                    defaultValue: form && form !== "" ? societyIdToName(form) : undefined,
                    label: "Form",
                    options: societyFormOptions,
                    onChange: (e)=>updateForm(societyNameToId(e.target.value))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-w-full tw-space-x-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "signedBy",
                            defaultValue: signed_by && signed_by !== "" ? signed_by : undefined,
                            label: "Signed by",
                            options: $17301cb79d6da8bd$var$signedByOptions,
                            onChange: (e)=>updateSignedBy(e.target.value),
                            disabled: form === ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "signature",
                            defaultValue: signature && signature !== "" ? signature : undefined,
                            label: "Signature",
                            options: $17301cb79d6da8bd$var$signatureOptions,
                            onChange: (e)=>updateSignature(e.target.value),
                            disabled: form === ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "sendVia",
                            defaultValue: send_via && send_via !== "" ? send_via : undefined,
                            label: "Send via",
                            options: $17301cb79d6da8bd$var$sendViaOptions,
                            onChange: (e)=>updateSendVia(e.target.value),
                            disabled: form === ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-justify-between",
                children: isEditing && fIndex != 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "link-secondary",
                    icon: "trash",
                    label: "Remove form",
                    onClick: ()=>deleteSubForm(index, fIndex)
                })
            })
        ]
    }, fIndex);
};




const $bc451199f44ef806$var$defaultTaxForm = [
    {
        determined_by: "",
        country: "",
        form: ""
    }
];
const $bc451199f44ef806$var$defaultFormRoles = [
    {
        role: "",
        forms: [
            {
                form: "",
                signature: "",
                send_via: ""
            }
        ]
    }
];
const $bc451199f44ef806$export$7a68edaca24ab739 = ({ societySelected: societySelected, isEditingSociety: isEditingSociety, setOnboardingMembershipDetails: setOnboardingMembershipDetails })=>{
    const [notifyByEmailCheck, setNotifyByEmailCheck] = (0, $acw62.useState)(false);
    const [notifyEmail, setNotifyEmail] = (0, $acw62.useState)("");
    const [notifyByPostCheck, setNotifyByPostCheck] = (0, $acw62.useState)(false);
    const [notifyPost, setNotifyPost] = (0, $acw62.useState)("");
    const [notifyByPortalCheck, setNotifyByPortalCheck] = (0, $acw62.useState)(false);
    const [notifyPortal, setNotifyPortal] = (0, $acw62.useState)("");
    const [reminderSociety, setReminderSociety] = (0, $acw62.useState)("");
    const [reminderEmail, setReminderEmail] = (0, $acw62.useState)("");
    const [reminderFrequency, setReminderFrequency] = (0, $acw62.useState)("");
    const [stopReminder, setStopReminder] = (0, $acw62.useState)("");
    const [differentTaxForm, setDifferentTaxForm] = (0, $acw62.useState)("");
    const [taxForms, setTaxForms] = (0, $acw62.useState)($bc451199f44ef806$var$defaultTaxForm);
    const [formRoles, setFormRoles] = (0, $acw62.useState)($bc451199f44ef806$var$defaultFormRoles);
    const [societyForms, setSocietyForms] = (0, $acw62.useState)([
        {}
    ]);
    (0, $acw62.useEffect)(()=>{
        setNotifyByEmailCheck(societySelected && societySelected.formEmail && societySelected.formEmail !== "" ? true : false);
        setNotifyEmail(societySelected && societySelected.formEmail && societySelected.formEmail != "" ? societySelected.formEmail : "");
        setNotifyByPostCheck(societySelected && societySelected.formPostalAddress && societySelected.formPostalAddress !== "" ? true : false);
        setNotifyPost(societySelected && societySelected.formPostalAddress && societySelected.formPostalAddress != "" ? societySelected.formPostalAddress : "");
        setNotifyByPortalCheck(societySelected && societySelected.formPortal && societySelected.formPortal !== "" ? true : false);
        setNotifyPortal(societySelected && societySelected.formPortal && societySelected.formPortal != "" ? societySelected.formPortal : "");
        setReminderSociety(societySelected && societySelected.formReminderSendTo && societySelected.formReminderFrequency && societySelected.formStopReminderFrequency ? "reminder_society_Yes" : "reminder_society_No");
        setReminderEmail(societySelected && societySelected.formReminderSendTo && societySelected.formReminderSendTo != "" ? societySelected.formReminderSendTo : "");
        setReminderFrequency(societySelected && societySelected.formReminderFrequency ? societySelected.formReminderFrequency : "");
        setStopReminder(societySelected && societySelected.formStopReminderFrequency ? societySelected.formStopReminderFrequency : "");
        setDifferentTaxForm(societySelected && societySelected.taxForms && societySelected.taxForms.length > 0 ? "different_tax_form_Yes" : "different_tax_form_No");
        setTaxForms(// @ts-ignore - CLI tool thinks .formTaxForms is a string, not an Array<string>
        societySelected && societySelected.taxForms && societySelected.taxForms.length > 0 ? societySelected.taxForms : $bc451199f44ef806$var$defaultTaxForm);
        setFormRoles(// @ts-ignore - CLI tool thinks .formRoleForms is a string, not an Array<string>
        societySelected && societySelected.roleForms && societySelected.roleForms.length > 0 ? societySelected.roleForms : $bc451199f44ef806$var$defaultFormRoles);
        setSocietyForms(// @ts-ignore - CLI tool thinks .societyForms is a string, not an Array<string>
        societySelected && societySelected.societyForms && societySelected.societyForms.length > 0 ? societySelected.societyForms : []);
    }, [
        societySelected
    ]);
    (0, $acw62.useEffect)(()=>{
        setOnboardingMembershipDetails({
            formEmail: notifyEmail && notifyByEmailCheck ? notifyEmail : "",
            formPostalAddress: notifyPost && notifyByPostCheck ? notifyPost : "",
            formPortal: notifyPortal && notifyByPortalCheck ? notifyPortal : "",
            formReminderFrequency: reminderSociety == "reminder_society_Yes" && reminderFrequency ? reminderFrequency : "",
            formStopReminderFrequency: reminderSociety == "reminder_society_Yes" && stopReminder ? stopReminder : "",
            formReminderSendTo: reminderSociety == "reminder_society_Yes" && reminderEmail ? reminderEmail : "",
            taxForms: differentTaxForm == "different_tax_form_Yes" ? JSON.stringify(taxForms) : JSON.stringify([]),
            roleForms: JSON.stringify(formRoles)
        });
    }, [
        notifyByEmailCheck,
        notifyEmail,
        notifyByPostCheck,
        notifyPost,
        notifyByPortalCheck,
        notifyPortal,
        reminderSociety,
        reminderEmail,
        reminderFrequency,
        stopReminder,
        differentTaxForm,
        taxForms,
        formRoles
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1871ac2e6b6f47b$export$83ea3b89da471b36), {
                notifyByEmailCheck: notifyByEmailCheck,
                notifyByPostCheck: notifyByPostCheck,
                notifyByPortalCheck: notifyByPortalCheck,
                notifyEmail: notifyEmail,
                notifyPost: notifyPost,
                notifyPortal: notifyPortal,
                setNotifyByEmailCheck: setNotifyByEmailCheck,
                setNotifyByPostCheck: setNotifyByPostCheck,
                setNotifyByPortalCheck: setNotifyByPortalCheck,
                setNotifyEmail: setNotifyEmail,
                setNotifyPost: setNotifyPost,
                setNotifyPortal: setNotifyPortal
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6489b6a11b46f9e4$export$f205b16615c63b8f), {
                isEditingSociety: isEditingSociety,
                differentTaxForm: differentTaxForm,
                setDifferentTaxForm: setDifferentTaxForm,
                formRoles: formRoles,
                setFormRoles: setFormRoles
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4139f894e5c9b6e7$export$a1efad21f1afa8ad), {
                isEditingSociety: isEditingSociety,
                differentTaxForm: differentTaxForm,
                taxForms: taxForms,
                setTaxForms: setTaxForms,
                societyForms: societyForms
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17301cb79d6da8bd$export$c5886a1ce6e8575a), {
                societySelected: societySelected,
                isEditingSociety: isEditingSociety,
                formRoles: formRoles,
                setFormRoles: setFormRoles,
                societyForms: societyForms
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");






const $9ae3182f2ea947ac$var$contactRolesOptions = [
    ...Object.keys((0, $ec1fec872195ff2d$export$4648418e7dd54936)).map((key)=>{
        return {
            label: key,
            value: key
        };
    })
];
const $9ae3182f2ea947ac$var$defaultContactDetails = [
    {
        name: "",
        email: "",
        phone: "",
        role: ""
    }
];
const $9ae3182f2ea947ac$export$b9d767bd38ad68e1 = ({ societySelected: societySelected, setContactDetails: setContactDetails })=>{
    const [contactInformation, setContactInformation] = (0, $acw62.useState)($9ae3182f2ea947ac$var$defaultContactDetails);
    const addNewContactDetails = ()=>{
        const newContactDetails = [
            ...contactInformation
        ];
        newContactDetails.push($9ae3182f2ea947ac$var$defaultContactDetails[0]);
        setContactInformation(newContactDetails);
    };
    const deleteContactDetails = (index)=>{
        const newContactDetails = [
            ...contactInformation
        ];
        newContactDetails.splice(index, 1);
        setContactInformation(newContactDetails);
    };
    const updateContactDetails = (index, newContactDetail)=>{
        const newContactDetails = [
            ...contactInformation
        ];
        const oldContactDetail = newContactDetails[index];
        newContactDetails[index] = {
            ...oldContactDetail,
            ...newContactDetail
        };
        setContactInformation(newContactDetails);
    };
    (0, $acw62.useEffect)(()=>{
        setContactInformation(// @ts-ignore - CLI tool thinks .contactInformation is a string, not an Array<string>
        societySelected && societySelected.contactInformation && societySelected.contactInformation.length > 0 ? societySelected.contactInformation : $9ae3182f2ea947ac$var$defaultContactDetails);
    }, [
        societySelected
    ]);
    (0, $acw62.useEffect)(()=>{
        setContactDetails({
            contactInformation: JSON.stringify(contactInformation)
        });
    }, [
        contactInformation
    ]);
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-grid tw-grid-cols-2 tw-gap-2",
                children: contactInformation.map(({ name: name, email: email, phone: phone, role: role }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9ae3182f2ea947ac$var$ContactDetailsRow, {
                        index: index,
                        name: name,
                        email: email,
                        phone: phone,
                        role: role,
                        addNewContactDetails: addNewContactDetails,
                        updateContactDetails: updateContactDetails,
                        deleteContactDetails: deleteContactDetails
                    }, index))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "link-secondary",
                    icon: "plus",
                    label: "Add a new contact",
                    onClick: ()=>{
                        addNewContactDetails();
                    }
                })
            })
        ]
    });
};
const $9ae3182f2ea947ac$var$ContactDetailsRow = ({ index: index, name: name, email: email, phone: phone, role: role, addNewContactDetails: addNewContactDetails, updateContactDetails: updateContactDetails, deleteContactDetails: deleteContactDetails })=>{
    const updateName = (name)=>{
        updateContactDetails(index, {
            name: name,
            email: email,
            phone: phone,
            role: role
        });
    };
    const updateEmail = (email)=>{
        updateContactDetails(index, {
            name: name,
            email: email,
            phone: phone,
            role: role
        });
    };
    const updatePhone = (phone)=>{
        updateContactDetails(index, {
            name: name,
            email: email,
            phone: phone,
            role: role
        });
    };
    const updateRole = (role)=>{
        updateContactDetails(index, {
            name: name,
            email: email,
            phone: phone,
            role: role
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Name",
                type: "text",
                onBlur: ()=>{},
                value: name ? name : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, updateName),
                name: "contact_name"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Email",
                type: "text",
                onBlur: ()=>{},
                value: email ? email : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, updateEmail),
                name: "contact_email"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Phone",
                type: "text",
                onBlur: ()=>{},
                value: phone ? phone : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, updatePhone),
                name: "contact_phone"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                name: "role",
                label: "Contact Role",
                options: $9ae3182f2ea947ac$var$contactRolesOptions,
                onBlur: ()=>{},
                defaultValue: role ? role : undefined,
                onChange: (e)=>updateRole(e.target.value)
            })
        ]
    });
};














const $550631537f4bfb7e$export$f283555e39d271d7 = ({ societySelected: societySelected, setSocietySelected: setSocietySelected, addNewSocietyCallback: addNewSocietyCallback, isEditingSociety: isEditingSociety, setIsEditingSociety: setIsEditingSociety })=>{
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [societyInfoDetails, setSocietyInfoDetails] = (0, $acw62.useState)();
    const [onboardingMembershipDetails, setOnboardingMembershipDetails] = (0, $acw62.useState)();
    const [distributionDetails, setDistributionDetails] = (0, $acw62.useState)();
    const [discographyDetails, setDiscographyDetails] = (0, $acw62.useState)();
    const [contactDetails, setContactDetails] = (0, $acw62.useState)();
    const [societyDetails, setSocietyDetails] = (0, $acw62.useState)();
    const [showSuccessModal, setShowSuccessModal] = (0, $acw62.useState)(false);
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const saveData = async ()=>{
        let req; // determine whether to create or update
        const isSocietyCreate = societyInfoDetails && societyInfoDetails.id === undefined;
        // debugger;
        // filter out empty additional territories and keep just the ids if is checked
        const additionalTerritoriesChecked = societyDetails?.additionalTerritories?.filter((territory)=>territory.checked === true).map((territory)=>territory.id);
        if (additionalTerritoriesChecked) societyDetails.additionalTerritories = additionalTerritoriesChecked;
        if (isSocietyCreate) req = api.createAdminCreateSociety({
            ...societyDetails
        });
        else req = api.updateAdminUpdateSociety({
            ...societyDetails,
            societyId: societyInfoDetails.id
        });
        return req.then((response)=>{
            setIsEditingSociety(false);
            addNewSocietyCallback(response.id);
            setShowSuccessModal(true);
        }).catch((error)=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Error saving society details"));
            return Promise.reject(error);
        });
    };
    const addNewSociety = ()=>{
        setSocietySelected(undefined);
        setSocietyInfoDetails(undefined);
        setOnboardingMembershipDetails(undefined);
        setDistributionDetails(undefined);
        setDiscographyDetails(undefined);
        setContactDetails(undefined);
    };
    (0, $acw62.useEffect)(()=>{
        setSocietyDetails({
            ...societyInfoDetails,
            ...onboardingMembershipDetails,
            // ...distributionDetails,
            // ...discographyDetails,
            ...contactDetails
        });
    }, [
        societyInfoDetails,
        onboardingMembershipDetails,
        // distributionDetails,
        // discographyDetails,
        contactDetails
    ]);
    const formSchema = undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            handleSubmit: saveData,
            schema: formSchema,
            formData: societyDetails,
            onSuccessMessage: null,
            submitOnEnter: false,
            onSuccess: ()=>{
                (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                    text: "Society details saved.",
                    variant: "success",
                    duration: 10000
                });
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-justify-end tw-text-white tw-space-x-4",
                    style: {
                        marginTop: "-32px",
                        height: "32px"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550631537f4bfb7e$var$AddNewSocietyButton, {
                        addNewSociety: addNewSociety,
                        setIsEditingSociety: setIsEditingSociety
                    })
                }),
                (isEditingSociety || societySelected) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc76d270f8cab3fa$export$ad2f3b3b8fde444f), {
                            societySelected: societySelected,
                            setSocietyInfoDetails: setSocietyInfoDetails,
                            setIsEditingSociety: setIsEditingSociety
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                            title: `Onboarding and Memberships`,
                            extraClasses: `tw-max-w-[650px]`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc451199f44ef806$export$7a68edaca24ab739), {
                                societySelected: societySelected,
                                isEditingSociety: isEditingSociety,
                                setOnboardingMembershipDetails: setOnboardingMembershipDetails
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                            title: `Discography`,
                            disabled: true,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                            title: `Distribution`,
                            disabled: true,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                            extraClasses: "tw-max-w-[650px]",
                            title: `Contact information`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ae3182f2ea947ac$export$b9d767bd38ad68e1), {
                                societySelected: societySelected,
                                isEditingSociety: isEditingSociety,
                                setContactDetails: setContactDetails
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa72595174cf6cb$export$d51e1baf57edf249), {
                            setIsEditingGlobal: setIsEditingSociety
                        })
                    ]
                })
            ]
        })
    });
};
const $550631537f4bfb7e$export$2096bae78ecda911 = (event, setterCallback)=>{
    const eventValue = event.target.value;
    setterCallback(eventValue);
};
const $550631537f4bfb7e$export$899efff2d0433d49 = (text)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0df75e22d728968$export$2e2bcd8739ae039), {
        id: "popover-basic",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0df75e22d728968$export$2e2bcd8739ae039).Body, {
            children: text
        })
    });
};
function $550631537f4bfb7e$var$FormEditSection({ setIsEditingSociety: setIsEditingSociety }) {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>{
                    setIsEditing(true);
                    setIsEditingSociety(true);
                },
                children: "Edit"
            })
        ]
    });
}
function $550631537f4bfb7e$var$AddNewSocietyButton({ addNewSociety: addNewSociety, setIsEditingSociety: setIsEditingSociety }) {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            variant: "secondary-lg",
            onClick: ()=>{
                addNewSociety();
                setIsEditingSociety(true);
                setIsEditing(true);
            },
            icon: "plus",
            label: "Add New Society"
        })
    });
}









const $1a4973640320fd67$export$50df2ad4baaf49a6 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
        extraClasses: "tw-w-1/4 tw-max-h-[1100px]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `tw-flex tw-justify-between tw-mb-4`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: `tw-text-2xl`,
                    children: "Societies"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fc63188fe3db22$export$dd467e6bea57703c), {
                ...props
            })
        ]
    });
};


function $bf374ce87df7918c$var$SocietyConfig() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [societyList, setSocietyList] = (0, $acw62.useState)([]);
    const [societySelected, setSocietySelected] = (0, $acw62.useState)();
    const [isEditingSociety, setIsEditingSociety] = (0, $acw62.useState)(false);
    const societiesFetch = async (retries = 0, societyId)=>{
        api.listAdminSocieties().then((response)=>{
            if (response.length === 0) return;
            setSocietyList(response);
            if (societyId !== undefined) {
                const society = response.find((society)=>society.id === societyId);
                if (society === undefined) return;
                setSocietySelected(society);
            }
            if (societySelected !== undefined) return;
        }).catch((err)=>{
            retries++;
            setTimeout(()=>{
                societiesFetch(retries);
            }, 500);
            return;
        });
    };
    const societyClickHandler = (society)=>{
        if (isEditingSociety) return;
        if (society === societySelected) return;
        setSocietySelected(society);
    };
    const addNewSocietyCallback = (id)=>{
        societiesFetch(0, id);
    };
    (0, $acw62.useEffect)(()=>{
        societiesFetch();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-space-x-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a4973640320fd67$export$50df2ad4baaf49a6), {
                        societies: societyList,
                        societySelected: societySelected,
                        societyClickHandler: societyClickHandler,
                        isEditingSociety: isEditingSociety
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-pt-0 tw-w-3/4 tw-max-w-[650px]",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $550631537f4bfb7e$export$f283555e39d271d7), {
                            societySelected: societySelected,
                            setSocietySelected: setSocietySelected,
                            addNewSocietyCallback: addNewSocietyCallback,
                            isEditingSociety: isEditingSociety,
                            setIsEditingSociety: setIsEditingSociety
                        })
                    })
                ]
            })
        ]
    });
}
var $bf374ce87df7918c$export$2e2bcd8739ae039 = $bf374ce87df7918c$var$SocietyConfig;












var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");












function $cdee3e2a095adc71$var$DiscographyDetails() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [registerUsers, setRegisterUsers] = (0, $acw62.useState)(75);
    const [verifyPassport, setVerifyPassport] = (0, $acw62.useState)(false);
    const [showDeclineMessage, setShowDeclineMessage] = (0, $acw62.useState)(false);
    const [passportId, setPassportId] = (0, $acw62.useState)("");
    const [passportDateOfBirth, setPassportDateOfBirth] = (0, $acw62.useState)("");
    const [passportNumber, setPassportNumber] = (0, $acw62.useState)("");
    const [passportExpiryDate, setPassportExpiryDate] = (0, $acw62.useState)("");
    const [passportFileLocation, setPassportFileLocation] = (0, $acw62.useState)("");
    const [clientTasks, setClientTasks] = (0, $acw62.useState)([]);
    const [clientList, setClientList] = (0, $acw62.useState)([]);
    const [taskId, setTaskId] = (0, $acw62.useState)("");
    const [continueButtonDisabled, setContinueButtonDisabled] = (0, $acw62.useState)(true);
    const [eoiReviewID, setEoiReviewID] = (0, $acw62.useState)("");
    const [DiscographyID, setDiscographyID] = (0, $acw62.useState)();
    const [showEOIcard, setShowEOIcard] = (0, $acw62.useState)(false);
    const [showDiscographyIDcard, setShowDiscographyIDcard] = (0, $acw62.useState)(false);
    const things_to_do_status = new Map([
        [
            "verify_passport_and_send_forms",
            "Curate discography"
        ],
        [
            "expression_of_interest_review",
            "Society rip uploaded"
        ],
        [
            "submit_discography_id",
            "Run discography"
        ]
    ]);
    const { clientId: clientId, setClientId: setClientId, setClientEmail: setClientEmail } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const fetchData = ()=>{
        api.listUsers().then((clients)=>{
            console.log("clients", clients);
            setClientList(// set image to empty string pending backend implementation
            clients.map((client)=>{
                return {
                    ...client,
                    image: ""
                };
            }));
            api.listAdminTaskClients().then((adminClientTasks)=>{
                setClientTasks(adminClientTasks);
            }).catch(()=>{});
        }).catch((error)=>{});
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    const acceptPassport = ()=>{
        if (clientId === undefined) return;
        api.approveAdminApproveIdentityDocument({
            userId: clientId,
            documentId: passportId,
            dateOfBirth: passportDateOfBirth,
            documentNumber: passportNumber,
            documentExpiryDate: passportExpiryDate
        }).then((response)=>{
            setPassportDateOfBirth("");
            setPassportNumber("");
            setPassportExpiryDate("");
        }).catch((error)=>{
            setPassportDateOfBirth("");
            setPassportNumber("");
            setPassportExpiryDate("");
        });
    };
    const declineMessage = ()=>{
        if (clientId === undefined) return;
        setVerifyPassport(false);
        setPassportDateOfBirth("");
        setPassportNumber("");
        setPassportExpiryDate("");
        setShowDeclineMessage(true);
        api.declineAdminDeclineIdentityDocument({
            userId: clientId,
            documentId: passportId
        }).then(()=>{
            api.destroyAdminTaskClient({
                taskId: taskId
            });
        }).catch(()=>{});
    };
    const handleThingsToDoStatusClick = (clientTask)=>{
        const client_task_status = clientTask.clientAdminTasks[0].status;
        if (client_task_status == "verify_passport_and_send_forms") {
            setClientId(clientTask.id.toString());
            api.listAdminIdentityDocumentSubmissions({
                userId: clientTask.id.toString()
            }).then((response)=>{
                response.forEach((document1)=>{
                    if (document1.documentType === "Passport") {
                        setPassportId(document1.id);
                        setPassportFileLocation(document1.fileUrl);
                        setTaskId(clientTask.clientAdminTasks[0].id);
                    }
                });
            });
            setVerifyPassport(true);
            setVerifyPassport(true);
        } else if (client_task_status == "expression_of_interest_review") {
            setClientEmail(clientTask.username);
            setClientId(clientTask.id.toString());
            showCard();
            setEoiReviewID(clientTask.id.toString());
            setTaskId(clientTask.clientAdminTasks[0].id);
            setShowEOIcard(true);
        } else if (client_task_status == "submit_discography_id") {
            setClientEmail(clientTask.username);
            setClientId(clientTask.id.toString());
            showCard();
            setDiscographyID(clientTask.id.toString());
            setTaskId(clientTask.clientAdminTasks[0].id);
            setShowDiscographyIDcard(true);
        }
    };
    const showCard = ()=>{
        document.body.classList.add("hide-scroll");
    };
    const hideCard = ()=>{
        document.body.classList.remove("hide-scroll");
        setShowEOIcard(false);
        setShowDiscographyIDcard(false);
    };
    (0, $acw62.useEffect)(()=>{
        const continueButtonDisabled = passportDateOfBirth != "" && passportExpiryDate != "" && passportNumber != "";
        setContinueButtonDisabled(continueButtonDisabled);
    }, [
        passportDateOfBirth,
        passportExpiryDate,
        passportNumber
    ]);
    let tableData = clientTasks.filter((clientTask)=>!clientList.some((client)=>Number(client.userId ?? 0) === Number(clientTask.id ?? 0) && client.nonClient === true)).map((clientTask)=>{
        const [firstThingToDo] = clientTask?.clientAdminTasks ?? [];
        let dateCreated = firstThingToDo?.dateCreated;
        return {
            artist: clientTask.fullName,
            action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pointer-cursor",
                onClick: ()=>handleThingsToDoStatusClick(clientTask),
                onKeyDown: (e)=>{
                    if (e.key === "Enter") handleThingsToDoStatusClick(clientTask);
                },
                role: "button",
                tabIndex: 0,
                children: things_to_do_status.get(firstThingToDo?.status ?? "")
            }),
            status: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c962736a82687da2$export$c71c3a205c92eaf4), {
                percentage: 75,
                label: "75% complete"
            }),
            dateCreated: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: dateCreated?.toLocaleDateString().toString() || "-"
                })
            })
        };
    });
    let rawData = clientTasks.filter((clientTask)=>!clientList.some((client)=>Number(client.userId ?? 0) === Number(clientTask.id ?? 0) && client.nonClient === true)).map((clientTask)=>{
        const [firstThingToDo] = clientTask?.clientAdminTasks ?? [];
        let dateCreated = firstThingToDo?.dateCreated;
        return {
            artist: clientTask.fullName,
            action: things_to_do_status.get(firstThingToDo?.status ?? ""),
            status: "75% complete",
            dateCreated: dateCreated
        };
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41b3017e16d4d38e$export$2e2bcd8739ae039), {
                cardEvent: hideCard,
                eoiReviewID: eoiReviewID,
                taskId: taskId,
                clientTasks: clientTasks,
                setClientTasks: setClientTasks,
                isOpen: showEOIcard
            }),
            showDiscographyIDcard ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d3075243f034f38$export$2e2bcd8739ae039), {
                isOpen: showDiscographyIDcard,
                onClose: hideCard
            }) : null,
            verifyPassport ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8027e0c1918401fd$export$2e2bcd8739ae039), {
                setPassportDateOfBirth: setPassportDateOfBirth,
                setPassportNumber: setPassportNumber,
                setPassportExpiryDate: setPassportExpiryDate,
                hideVerification: setVerifyPassport,
                declineMessage: declineMessage,
                acceptPassport: acceptPassport,
                passportFileLocation: passportFileLocation,
                clientTasks: clientTasks,
                taskId: taskId,
                continueButtonDisabled: continueButtonDisabled,
                passportDateOfBirth: passportDateOfBirth,
                passportNumber: passportNumber,
                passportExpiryDate: passportExpiryDate
            }) : showDeclineMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa8b665f3163a5b2$export$2e2bcd8739ae039), {
                declineMessage: declineMessage
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-w-full tw-space-x-6 tw-max-w-[1500px]",
                        style: {
                            maxWidth: "1584px",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                                extraClasses: "tw-min-w-[302px]",
                                disabled: true,
                                title: "Discographies submitted",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "tw-uppercase tw-text-sm",
                                        children: "Discographies submitted"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a6180f04a3e64cf$export$553fd01770b02e7e), {
                                        value: registerUsers,
                                        text: "discographies submitted"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-text-right",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            className: "viewLink",
                                            children: "View"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                                extraClasses: "tw-flex-grow tw-overflow-scroll tw-scrollbar-none",
                                disabled: true,
                                title: "Society Overview",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-uppercase tw-text-sm tw-pb-2",
                                            children: "Society overview"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-overflow-x-scroll tw-flex-grow tw-w-full tw-overflow-scroll tw-scrollbar-none",
                                        style: {},
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $662f9e853a36449a$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-uppercase tw-text-2xl tw-text-white tw-mt-6",
                        children: "Tasks"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$e2595d8541f6e8ef), {
                            columnStyle: {
                                borderBottom: "none",
                                padding: "0px"
                            },
                            columns: [
                                {
                                    title: "Artist",
                                    dataKey: "artist",
                                    sort: true
                                },
                                {
                                    title: "Action",
                                    dataKey: "action",
                                    sort: true
                                },
                                {
                                    title: "Date Added",
                                    dataKey: "dateCreated",
                                    sort: true
                                }
                            ],
                            data: tableData,
                            rawData: rawData
                        })
                    })
                ]
            })
        ]
    });
}
var $cdee3e2a095adc71$export$2e2bcd8739ae039 = $cdee3e2a095adc71$var$DiscographyDetails;



function $cc1c20adb5e80bc9$var$DiscographyNew() {
    const [sidebarSmall, setSidebarSmall] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Discography Dashboard"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cdee3e2a095adc71$export$2e2bcd8739ae039), {})
        ]
    });
}
var $cc1c20adb5e80bc9$export$2e2bcd8739ae039 = $cc1c20adb5e80bc9$var$DiscographyNew;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(arr, i) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(arr) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(arr, i) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr, i) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}



function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $acw62 = parcelRequire("acw62");


function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(self);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}



function $95003165623aa54c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(arr);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(arr) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? false : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
        if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.");
        this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {
                if (!/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) console.error('There was a problem inserting the following rule: "' + rule + '"', e);
            }
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
        this._alreadyInsertedOrderInsensitiveRule = false;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};



var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (!key) throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key + '" was passed');
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    omnipresentPlugins.push($fc182b1f84212d3f$var$createUnsafeSelectorsAlarm({
        get compat () {
            return cache.compat;
        }
    }), $fc182b1f84212d3f$var$incorrectImportAlarm);
    var currentSheet;
    var finalizingPlugins = [
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
        function(element) {
            if (!element.root) {
                if (element["return"]) currentSheet.insert(element["return"]);
                else if (element.value && element.type !== (0, $298fb931ed4fbf8b$export$a29989082612d0d9)) // insert empty rule in non-production environments
                // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
                currentSheet.insert(element.value + "{}");
            }
        }
    ];
    var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        if (serialized.map !== undefined) currentSheet = {
            insert: function insert(rule) {
                sheet.insert(rule + serialized.map);
            }
        };
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e18645ac1956fbe6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};





// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
var $90ba2da1f62e5f1b$var$contentValues = [
    "normal",
    "none",
    "initial",
    "inherit",
    "unset"
];
var $90ba2da1f62e5f1b$var$oldProcessStyleValue = $90ba2da1f62e5f1b$var$processStyleValue;
var $90ba2da1f62e5f1b$var$msPattern = /^-ms-/;
var $90ba2da1f62e5f1b$var$hyphenPattern = /-(.)/g;
var $90ba2da1f62e5f1b$var$hyphenatedCache = {};
$90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    if (key === "content") {
        if (typeof value !== "string" || $90ba2da1f62e5f1b$var$contentValues.indexOf(value) === -1 && !$90ba2da1f62e5f1b$var$contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
    }
    var processed = $90ba2da1f62e5f1b$var$oldProcessStyleValue(key, value);
    if (processed !== "" && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && key.indexOf("-") !== -1 && $90ba2da1f62e5f1b$var$hyphenatedCache[key] === undefined) {
        $90ba2da1f62e5f1b$var$hyphenatedCache[key] = true;
        console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace($90ba2da1f62e5f1b$var$msPattern, "ms-").replace($90ba2da1f62e5f1b$var$hyphenPattern, function(str, _char) {
            return _char.toUpperCase();
        }) + "?");
    }
    return processed;
};
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) {
        if (interpolation.toString() === "NO_COMPONENT_SELECTOR") throw new Error($90ba2da1f62e5f1b$var$noComponentSelectorMessage);
        return interpolation;
    }
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                if (interpolation.map !== undefined) styles += interpolation.map;
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            } else console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
            break;
        case "string":
            var matched = [];
            var replaced = interpolation.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                var fakeVarName = "animation" + matched.length;
                matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`");
                return "${" + fakeVarName + "}";
            });
            if (matched.length) console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, [
                "`" + replaced + "`"
            ]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + replaced + "`"));
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else {
            if (_key === "NO_COMPONENT_SELECTOR" && true) throw new Error($90ba2da1f62e5f1b$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case "animation":
                    case "animationName":
                        string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        if (_key === "undefined") console.error($90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR);
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
$90ba2da1f62e5f1b$var$sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        if (strings[0] === undefined) console.error($90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        styles += strings[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            if (strings[i] === undefined) console.error($90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR);
            styles += strings[i];
        }
    }
    var sourceMap;
    styles = styles.replace($90ba2da1f62e5f1b$var$sourceMapPattern, function(match) {
        sourceMap = match;
        return "";
    });
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
        name: name,
        styles: styles,
        map: sourceMap,
        next: $90ba2da1f62e5f1b$var$cursor,
        toString: function toString() {
            return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
        }
    };
};



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;


var $0fe24a6591b39473$export$23f2a1d2818174ef = true;
var $0fe24a6591b39473$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $0fe24a6591b39473$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
$0fe24a6591b39473$var$EmotionCacheContext.displayName = "EmotionCacheContext";
var $0fe24a6591b39473$export$e7094788287c5e9b = $0fe24a6591b39473$var$EmotionCacheContext.Provider;
var $0fe24a6591b39473$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
};
var $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$0fe24a6591b39473$export$23f2a1d2818174ef) $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $0fe24a6591b39473$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
$0fe24a6591b39473$export$971d5caa766a69d7.displayName = "EmotionThemeContext";
var $0fe24a6591b39473$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
};
var $0fe24a6591b39473$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        if (mergedTheme == null || typeof mergedTheme !== "object" || Array.isArray(mergedTheme)) throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");
        return mergedTheme;
    }
    if (theme == null || typeof theme !== "object" || Array.isArray(theme)) throw new Error("[ThemeProvider] Please make your theme prop a plain object");
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $0fe24a6591b39473$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $0fe24a6591b39473$var$getTheme(outerTheme, theme);
    });
});
var $0fe24a6591b39473$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $0fe24a6591b39473$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $0fe24a6591b39473$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $0fe24a6591b39473$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]);
    return undefined;
};
var $0fe24a6591b39473$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $0fe24a6591b39473$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $0fe24a6591b39473$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($0fe24a6591b39473$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $0fe24a6591b39473$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $0fe24a6591b39473$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    if (typeof props.css === "string" && // check if there is a css declaration
    props.css.indexOf(":") !== -1) throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$0fe24a6591b39473$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    // the label hasn't already been computed
    if (!!props.css && (typeof props.css !== "object" || typeof props.css.name !== "string" || props.css.name.indexOf("-") === -1)) {
        var label = $0fe24a6591b39473$var$getLabelFromStackTrace(new Error().stack);
        if (label) newProps[$0fe24a6591b39473$var$labelPropName] = label;
    }
    return newProps;
};
var $0fe24a6591b39473$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $0fe24a6591b39473$var$Emotion = /* #__PURE__ */ $0fe24a6591b39473$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$0fe24a6591b39473$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7));
    if (serialized.name.indexOf("-") === -1) {
        var labelFromStack = props[$0fe24a6591b39473$var$labelPropName];
        if (labelFromStack) serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)([
            serialized,
            "label:" + labelFromStack + ";"
        ]);
    }
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $0fe24a6591b39473$var$typePropName && key !== $0fe24a6591b39473$var$labelPropName) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
$0fe24a6591b39473$var$Emotion.displayName = "EmotionCssPropInternal";
var $0fe24a6591b39473$export$a9c23c6ac3fc3eca = $0fe24a6591b39473$var$Emotion;



var $acw62 = parcelRequire("acw62");




var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;





var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $0fe24a6591b39473$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $0fe24a6591b39473$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $0fe24a6591b39473$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $acw62.createElement.apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache) {
    if (!$63d46a01db878c10$var$warnedAboutCssPropForGlobal && // probably using the custom createElement which
    // means it will be turned into a className prop
    // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
    (props.className || props.css)) {
        console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
        $63d46a01db878c10$var$warnedAboutCssPropForGlobal = true;
    }
    var styles = props.styles;
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7)));
    if (!(0, $0fe24a6591b39473$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
$63d46a01db878c10$export$98f03c5d19621d70.displayName = "EmotionGlobal";
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    if (arg.styles !== undefined && arg.name !== undefined) console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.");
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && true) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && true) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
$63d46a01db878c10$export$9b9c0f9d9f3552b8.displayName = "EmotionClassNames";
var $63d46a01db878c10$var$isBrowser = true; // #1727, #2905 for some reason Jest and Vitest evaluate modules twice if some consuming module gets mocked
var $63d46a01db878c10$var$isTestEnv = typeof jest !== "undefined" || typeof vi !== "undefined";
if ($63d46a01db878c10$var$isBrowser && !$63d46a01db878c10$var$isTestEnv) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var $63d46a01db878c10$var$globalContext = typeof globalThis !== "undefined" ? globalThis // eslint-disable-line no-undef
     : $63d46a01db878c10$var$isBrowser ? window : $parcel$global;
    var $63d46a01db878c10$var$globalKey = "__EMOTION_REACT_" + $63d46a01db878c10$var$pkg.version.split(".")[0] + "__";
    if ($63d46a01db878c10$var$globalContext[$63d46a01db878c10$var$globalKey]) console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used.");
    $63d46a01db878c10$var$globalContext[$63d46a01db878c10$var$globalKey] = true;
}





function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $acw62 = parcelRequire("acw62");

const $10310cf078d13212$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $10310cf078d13212$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $10310cf078d13212$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $071542918b64c1f1$export$651544f548703224(node) {
    if ($071542918b64c1f1$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $071542918b64c1f1$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $071542918b64c1f1$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($071542918b64c1f1$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $071542918b64c1f1$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $071542918b64c1f1$export$38b2d434cce3ea22(value).Node;
}
function $071542918b64c1f1$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $071542918b64c1f1$export$38b2d434cce3ea22(value).Element;
}
function $071542918b64c1f1$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $071542918b64c1f1$export$38b2d434cce3ea22(value).HTMLElement;
}
function $071542918b64c1f1$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $071542918b64c1f1$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $071542918b64c1f1$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $071542918b64c1f1$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $071542918b64c1f1$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($071542918b64c1f1$export$651544f548703224(element));
}
function $071542918b64c1f1$export$d6c4e8150c35fed1(element) {
    const webkit = $071542918b64c1f1$export$78551043582a6a98();
    const css = $071542918b64c1f1$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $071542918b64c1f1$export$940d8225183e1404(element) {
    let currentNode = $071542918b64c1f1$export$4e12058fc4d51d56(element);
    while($071542918b64c1f1$export$1b3bfaa9684536aa(currentNode) && !$071542918b64c1f1$export$d1162fb0b6d4cd51(currentNode)){
        if ($071542918b64c1f1$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $071542918b64c1f1$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $071542918b64c1f1$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $071542918b64c1f1$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($071542918b64c1f1$export$651544f548703224(node));
}
function $071542918b64c1f1$export$3735103072e4a80(element) {
    return $071542918b64c1f1$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $071542918b64c1f1$export$dc8fc79fa2800137(element) {
    if ($071542918b64c1f1$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $071542918b64c1f1$export$4e12058fc4d51d56(node) {
    if ($071542918b64c1f1$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $071542918b64c1f1$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $071542918b64c1f1$export$e495491855dc5418(node);
    return $071542918b64c1f1$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $071542918b64c1f1$export$7cd01a57c8ca906c(node) {
    const parentNode = $071542918b64c1f1$export$4e12058fc4d51d56(node);
    if ($071542918b64c1f1$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($071542918b64c1f1$export$1b3bfaa9684536aa(parentNode) && $071542918b64c1f1$export$989e911fa9af580a(parentNode)) return parentNode;
    return $071542918b64c1f1$export$7cd01a57c8ca906c(parentNode);
}
function $071542918b64c1f1$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $071542918b64c1f1$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $071542918b64c1f1$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $071542918b64c1f1$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $071542918b64c1f1$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $071542918b64c1f1$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $071542918b64c1f1$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $071542918b64c1f1$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $071542918b64c1f1$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $071542918b64c1f1$export$38b2d434cce3ea22)(element);
    if (!(0, $071542918b64c1f1$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $071542918b64c1f1$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $071542918b64c1f1$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $071542918b64c1f1$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $071542918b64c1f1$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $071542918b64c1f1$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $071542918b64c1f1$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $071542918b64c1f1$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $071542918b64c1f1$export$651544f548703224)(offsetParent) !== "body" || (0, $071542918b64c1f1$export$989e911fa9af580a)(documentElement)) scroll = (0, $071542918b64c1f1$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $071542918b64c1f1$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $461947879dcdbcd4$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $461947879dcdbcd4$var$getBoundingClientRect((0, $071542918b64c1f1$export$e495491855dc5418)(element)).left + (0, $071542918b64c1f1$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $071542918b64c1f1$export$e495491855dc5418)(element);
    const scroll = (0, $071542918b64c1f1$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $071542918b64c1f1$export$3735103072e4a80)(body).direction === "rtl") x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $071542918b64c1f1$export$38b2d434cce3ea22)(element);
    const html = (0, $071542918b64c1f1$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $071542918b64c1f1$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $071542918b64c1f1$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect((0, $071542918b64c1f1$export$e495491855dc5418)(element));
    else if ((0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $071542918b64c1f1$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(parentNode) || (0, $071542918b64c1f1$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $071542918b64c1f1$export$3735103072e4a80)(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $071542918b64c1f1$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(el) && (0, $071542918b64c1f1$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $071542918b64c1f1$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $071542918b64c1f1$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(currentNode) && !(0, $071542918b64c1f1$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $071542918b64c1f1$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $071542918b64c1f1$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $071542918b64c1f1$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $071542918b64c1f1$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    return $461947879dcdbcd4$var$getCssDimensions(element);
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $071542918b64c1f1$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $071542918b64c1f1$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $071542918b64c1f1$export$651544f548703224)(offsetParent) !== "body" || (0, $071542918b64c1f1$export$989e911fa9af580a)(documentElement)) scroll = (0, $071542918b64c1f1$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $071542918b64c1f1$export$1b3bfaa9684536aa)(element) || (0, $071542918b64c1f1$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const window = (0, $071542918b64c1f1$export$38b2d434cce3ea22)(element);
    if (!(0, $071542918b64c1f1$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $071542918b64c1f1$export$71535ffaa902797f)(offsetParent) && (0, $071542918b64c1f1$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $071542918b64c1f1$export$651544f548703224)(offsetParent) === "html" || (0, $071542918b64c1f1$export$651544f548703224)(offsetParent) === "body" && (0, $071542918b64c1f1$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $071542918b64c1f1$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $071542918b64c1f1$export$940d8225183e1404)(element) || window;
}
const $461947879dcdbcd4$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $071542918b64c1f1$export$3735103072e4a80)(element).direction === "rtl";
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $071542918b64c1f1$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $071542918b64c1f1$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $071542918b64c1f1$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $071542918b64c1f1$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $071542918b64c1f1$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$var$index = (0, $acw62.useLayoutEffect);
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = $e62b4578a0a2b358$var$index;


var $95aa1968e67d2b10$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $95aa1968e67d2b10$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $95aa1968e67d2b10$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $95aa1968e67d2b10$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($95aa1968e67d2b10$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $95aa1968e67d2b10$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($95aa1968e67d2b10$var$isArray(value)) return value.filter(Boolean);
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $95aa1968e67d2b10$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $95aa1968e67d2b10$var$_excluded$4);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $95aa1968e67d2b10$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $95aa1968e67d2b10$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $95aa1968e67d2b10$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $95aa1968e67d2b10$var$normalizedHeight(el) {
    if ($95aa1968e67d2b10$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $95aa1968e67d2b10$var$getScrollTop(el) {
    if ($95aa1968e67d2b10$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $95aa1968e67d2b10$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($95aa1968e67d2b10$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $95aa1968e67d2b10$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $95aa1968e67d2b10$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $95aa1968e67d2b10$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $95aa1968e67d2b10$export$b4171a6734a65d42;
    var start = $95aa1968e67d2b10$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $95aa1968e67d2b10$var$easeOutCubic(currentTime, start, change, duration);
        $95aa1968e67d2b10$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $95aa1968e67d2b10$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $95aa1968e67d2b10$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $95aa1968e67d2b10$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $95aa1968e67d2b10$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $95aa1968e67d2b10$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $95aa1968e67d2b10$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $95aa1968e67d2b10$var$passiveOptionAccessed = false;
var $95aa1968e67d2b10$var$options = {
    get passive () {
        return $95aa1968e67d2b10$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $95aa1968e67d2b10$var$w = typeof window !== "undefined" ? window : {};
if ($95aa1968e67d2b10$var$w.addEventListener && $95aa1968e67d2b10$var$w.removeEventListener) {
    $95aa1968e67d2b10$var$w.addEventListener("p", $95aa1968e67d2b10$export$b4171a6734a65d42, $95aa1968e67d2b10$var$options);
    $95aa1968e67d2b10$var$w.removeEventListener("p", $95aa1968e67d2b10$export$b4171a6734a65d42, false);
}
var $95aa1968e67d2b10$export$2408f22a0fab9ae5 = $95aa1968e67d2b10$var$passiveOptionAccessed;
function $95aa1968e67d2b10$export$3466f893ebf79586(item) {
    return item != null;
}
function $95aa1968e67d2b10$var$isArray(arg) {
    return Array.isArray(arg);
}
function $95aa1968e67d2b10$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $95aa1968e67d2b10$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $95aa1968e67d2b10$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $95aa1968e67d2b10$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $95aa1968e67d2b10$var$_excluded$3 = [
    "children",
    "innerProps"
], $95aa1968e67d2b10$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $95aa1968e67d2b10$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $95aa1968e67d2b10$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $95aa1968e67d2b10$var$normalizedHeight(scrollParent);
    var scrollTop = $95aa1968e67d2b10$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $95aa1968e67d2b10$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $95aa1968e67d2b10$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $95aa1968e67d2b10$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $95aa1968e67d2b10$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $95aa1968e67d2b10$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $95aa1968e67d2b10$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $95aa1968e67d2b10$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $95aa1968e67d2b10$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: "menu"
    }, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, $95aa1968e67d2b10$var$alignToControl(placement), "100%"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "width", "100%"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $95aa1968e67d2b10$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $95aa1968e67d2b10$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($95aa1968e67d2b10$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $95aa1968e67d2b10$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $95aa1968e67d2b10$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $95aa1968e67d2b10$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $95aa1968e67d2b10$var$Menu$1 = $95aa1968e67d2b10$var$Menu;
// ==============================
// Menu List
// ==============================
var $95aa1968e67d2b10$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $95aa1968e67d2b10$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $95aa1968e67d2b10$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $95aa1968e67d2b10$export$3b14a55fb2447963 = $95aa1968e67d2b10$var$noticeCSS;
var $95aa1968e67d2b10$export$342063e11d6c3cad = $95aa1968e67d2b10$var$noticeCSS;
var $95aa1968e67d2b10$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref6, $95aa1968e67d2b10$var$_excluded$3);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $95aa1968e67d2b10$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $95aa1968e67d2b10$var$_excluded2$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $95aa1968e67d2b10$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $95aa1968e67d2b10$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($95aa1968e67d2b10$var$coercePlacement(menuPlacement)), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $95aa1968e67d2b10$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $461947879dcdbcd4$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $95aa1968e67d2b10$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($95aa1968e67d2b10$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $95aa1968e67d2b10$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $95aa1968e67d2b10$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $95aa1968e67d2b10$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $95aa1968e67d2b10$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $95aa1968e67d2b10$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $95aa1968e67d2b10$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $95aa1968e67d2b10$var$_templateObject;
var $95aa1968e67d2b10$var$_excluded$2 = [
    "size"
], $95aa1968e67d2b10$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $95aa1968e67d2b10$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $95aa1968e67d2b10$var$_ref2 = {
    name: "tj5bde-Svg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: $95aa1968e67d2b10$var$_EMOTION_STRINGIFIED_CSS_ERROR__
};
var $95aa1968e67d2b10$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $95aa1968e67d2b10$var$_excluded$2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $95aa1968e67d2b10$var$_ref2
    }, props));
};
var $95aa1968e67d2b10$var$CrossIcon = function CrossIcon(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($95aa1968e67d2b10$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $95aa1968e67d2b10$var$DownChevron = function DownChevron(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($95aa1968e67d2b10$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $95aa1968e67d2b10$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $95aa1968e67d2b10$export$f1e1789686576879 = $95aa1968e67d2b10$var$baseCSS;
var $95aa1968e67d2b10$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($95aa1968e67d2b10$var$DownChevron, null));
};
var $95aa1968e67d2b10$export$407448d2b89b1813 = $95aa1968e67d2b10$var$baseCSS;
var $95aa1968e67d2b10$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($95aa1968e67d2b10$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $95aa1968e67d2b10$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $95aa1968e67d2b10$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerProps, $95aa1968e67d2b10$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $95aa1968e67d2b10$var$loadingDotAnimations = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)($95aa1968e67d2b10$var$_templateObject || ($95aa1968e67d2b10$var$_templateObject = (0, $cbe7edbf3ccb8828$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $95aa1968e67d2b10$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $95aa1968e67d2b10$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            animation: "".concat($95aa1968e67d2b10$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, ";label:LoadingDot;", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    });
};
var $95aa1968e67d2b10$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $95aa1968e67d2b10$var$_excluded2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($95aa1968e67d2b10$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($95aa1968e67d2b10$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($95aa1968e67d2b10$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $95aa1968e67d2b10$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $95aa1968e67d2b10$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $95aa1968e67d2b10$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps), children);
};
var $95aa1968e67d2b10$var$Control$1 = $95aa1968e67d2b10$var$Control;
var $95aa1968e67d2b10$var$_excluded$1 = [
    "data"
];
var $95aa1968e67d2b10$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $95aa1968e67d2b10$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Heading, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", null, children));
};
var $95aa1968e67d2b10$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $95aa1968e67d2b10$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $95aa1968e67d2b10$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $95aa1968e67d2b10$var$_excluded$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $95aa1968e67d2b10$var$Group$1 = $95aa1968e67d2b10$var$Group;
var $95aa1968e67d2b10$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $95aa1968e67d2b10$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $95aa1968e67d2b10$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $95aa1968e67d2b10$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $95aa1968e67d2b10$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $95aa1968e67d2b10$var$spacingStyle)
};
var $95aa1968e67d2b10$var$inputStyle = function inputStyle(isHidden) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $95aa1968e67d2b10$var$spacingStyle);
};
var $95aa1968e67d2b10$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $95aa1968e67d2b10$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $95aa1968e67d2b10$var$_excluded);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $95aa1968e67d2b10$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $95aa1968e67d2b10$var$Input$1 = $95aa1968e67d2b10$var$Input;
var $95aa1968e67d2b10$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $95aa1968e67d2b10$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $95aa1968e67d2b10$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $95aa1968e67d2b10$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $95aa1968e67d2b10$var$MultiValueContainer = $95aa1968e67d2b10$var$MultiValueGeneric;
var $95aa1968e67d2b10$var$MultiValueLabel = $95aa1968e67d2b10$var$MultiValueGeneric;
function $95aa1968e67d2b10$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($95aa1968e67d2b10$var$CrossIcon, {
        size: 14
    }));
}
var $95aa1968e67d2b10$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $95aa1968e67d2b10$var$MultiValue$1 = $95aa1968e67d2b10$var$MultiValue;
var $95aa1968e67d2b10$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $95aa1968e67d2b10$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $95aa1968e67d2b10$var$Option$1 = $95aa1968e67d2b10$var$Option;
var $95aa1968e67d2b10$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $95aa1968e67d2b10$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $95aa1968e67d2b10$var$Placeholder$1 = $95aa1968e67d2b10$var$Placeholder;
var $95aa1968e67d2b10$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $95aa1968e67d2b10$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $95aa1968e67d2b10$var$SingleValue$1 = $95aa1968e67d2b10$var$SingleValue;
var $95aa1968e67d2b10$export$db3b6bfb95261072 = {
    ClearIndicator: $95aa1968e67d2b10$var$ClearIndicator,
    Control: $95aa1968e67d2b10$var$Control$1,
    DropdownIndicator: $95aa1968e67d2b10$var$DropdownIndicator,
    DownChevron: $95aa1968e67d2b10$var$DownChevron,
    CrossIcon: $95aa1968e67d2b10$var$CrossIcon,
    Group: $95aa1968e67d2b10$var$Group$1,
    GroupHeading: $95aa1968e67d2b10$var$GroupHeading,
    IndicatorsContainer: $95aa1968e67d2b10$var$IndicatorsContainer,
    IndicatorSeparator: $95aa1968e67d2b10$var$IndicatorSeparator,
    Input: $95aa1968e67d2b10$var$Input$1,
    LoadingIndicator: $95aa1968e67d2b10$var$LoadingIndicator,
    Menu: $95aa1968e67d2b10$var$Menu$1,
    MenuList: $95aa1968e67d2b10$var$MenuList,
    MenuPortal: $95aa1968e67d2b10$var$MenuPortal,
    LoadingMessage: $95aa1968e67d2b10$var$LoadingMessage,
    NoOptionsMessage: $95aa1968e67d2b10$var$NoOptionsMessage,
    MultiValue: $95aa1968e67d2b10$var$MultiValue$1,
    MultiValueContainer: $95aa1968e67d2b10$var$MultiValueContainer,
    MultiValueLabel: $95aa1968e67d2b10$var$MultiValueLabel,
    MultiValueRemove: $95aa1968e67d2b10$var$MultiValueRemove,
    Option: $95aa1968e67d2b10$var$Option$1,
    Placeholder: $95aa1968e67d2b10$var$Placeholder$1,
    SelectContainer: $95aa1968e67d2b10$var$SelectContainer,
    SingleValue: $95aa1968e67d2b10$var$SingleValue$1,
    ValueContainer: $95aa1968e67d2b10$var$ValueContainer
};
var $95aa1968e67d2b10$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $95aa1968e67d2b10$export$db3b6bfb95261072), props.components);
};



var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $c6e34b1f19b3d869$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $c6e34b1f19b3d869$var$_ref = {
    name: "1f43avz-a11yText-A11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
    toString: $c6e34b1f19b3d869$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2
};
var $c6e34b1f19b3d869$var$A11yText = function A11yText(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        css: $c6e34b1f19b3d869$var$_ref
    }, props));
};
var $c6e34b1f19b3d869$var$A11yText$1 = $c6e34b1f19b3d869$var$A11yText;
var $c6e34b1f19b3d869$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu") {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $c6e34b1f19b3d869$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $c6e34b1f19b3d869$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($c6e34b1f19b3d869$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($c6e34b1f19b3d869$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $c6e34b1f19b3d869$var$LiveRegion$1 = $c6e34b1f19b3d869$var$LiveRegion;
var $c6e34b1f19b3d869$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $c6e34b1f19b3d869$var$anyDiacritic = new RegExp("[" + $c6e34b1f19b3d869$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $c6e34b1f19b3d869$var$diacriticToBase = {};
for(var $c6e34b1f19b3d869$var$i = 0; $c6e34b1f19b3d869$var$i < $c6e34b1f19b3d869$var$diacritics.length; $c6e34b1f19b3d869$var$i++){
    var $c6e34b1f19b3d869$var$diacritic = $c6e34b1f19b3d869$var$diacritics[$c6e34b1f19b3d869$var$i];
    for(var $c6e34b1f19b3d869$var$j = 0; $c6e34b1f19b3d869$var$j < $c6e34b1f19b3d869$var$diacritic.letters.length; $c6e34b1f19b3d869$var$j++)$c6e34b1f19b3d869$var$diacriticToBase[$c6e34b1f19b3d869$var$diacritic.letters[$c6e34b1f19b3d869$var$j]] = $c6e34b1f19b3d869$var$diacritic.base;
}
var $c6e34b1f19b3d869$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($c6e34b1f19b3d869$var$anyDiacritic, function(match) {
        return $c6e34b1f19b3d869$var$diacriticToBase[match];
    });
};
var $c6e34b1f19b3d869$var$memoizedStripDiacriticsForInput = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)($c6e34b1f19b3d869$var$stripDiacritics);
var $c6e34b1f19b3d869$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $c6e34b1f19b3d869$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $c6e34b1f19b3d869$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $c6e34b1f19b3d869$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $c6e34b1f19b3d869$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $c6e34b1f19b3d869$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $c6e34b1f19b3d869$var$memoizedStripDiacriticsForInput(input);
            candidate = $c6e34b1f19b3d869$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $c6e34b1f19b3d869$var$_excluded = [
    "innerRef"
];
function $c6e34b1f19b3d869$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $c6e34b1f19b3d869$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $95aa1968e67d2b10$export$43caf9889c228507)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, ";label:DummyInput;", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
    }));
}
var $c6e34b1f19b3d869$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $c6e34b1f19b3d869$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $c6e34b1f19b3d869$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $95aa1968e67d2b10$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $c6e34b1f19b3d869$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $c6e34b1f19b3d869$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $c6e34b1f19b3d869$var$preventTouchMove(e) {
    e.preventDefault();
}
function $c6e34b1f19b3d869$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $c6e34b1f19b3d869$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $c6e34b1f19b3d869$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $c6e34b1f19b3d869$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $c6e34b1f19b3d869$var$activeScrollLocks = 0;
var $c6e34b1f19b3d869$var$listenerOptions = {
    capture: false,
    passive: false
};
function $c6e34b1f19b3d869$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$c6e34b1f19b3d869$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $c6e34b1f19b3d869$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $c6e34b1f19b3d869$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($c6e34b1f19b3d869$var$LOCK_STYLES).forEach(function(key) {
                var val = $c6e34b1f19b3d869$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $c6e34b1f19b3d869$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $c6e34b1f19b3d869$var$preventTouchMove, $c6e34b1f19b3d869$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $c6e34b1f19b3d869$var$preventInertiaScroll, $c6e34b1f19b3d869$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $c6e34b1f19b3d869$var$allowTouchMove, $c6e34b1f19b3d869$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $c6e34b1f19b3d869$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$c6e34b1f19b3d869$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $c6e34b1f19b3d869$var$activeScrollLocks = Math.max($c6e34b1f19b3d869$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $c6e34b1f19b3d869$var$activeScrollLocks < 1) $c6e34b1f19b3d869$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $c6e34b1f19b3d869$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $c6e34b1f19b3d869$var$preventTouchMove, $c6e34b1f19b3d869$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $c6e34b1f19b3d869$var$preventInertiaScroll, $c6e34b1f19b3d869$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $c6e34b1f19b3d869$var$allowTouchMove, $c6e34b1f19b3d869$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $c6e34b1f19b3d869$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c6e34b1f19b3d869$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $c6e34b1f19b3d869$var$_ref2$1 = {
    name: "bp8cua-ScrollManager",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: $c6e34b1f19b3d869$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function $c6e34b1f19b3d869$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $c6e34b1f19b3d869$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $c6e34b1f19b3d869$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, lockEnabled && (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", {
        onClick: $c6e34b1f19b3d869$var$blurSelectInput,
        css: $c6e34b1f19b3d869$var$_ref2$1
    }), children(targetRef));
}
function $c6e34b1f19b3d869$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c6e34b1f19b3d869$var$_ref2 = {
    name: "5kkxb2-requiredInput-RequiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
    toString: $c6e34b1f19b3d869$var$_EMOTION_STRINGIFIED_CSS_ERROR__
};
var $c6e34b1f19b3d869$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $c6e34b1f19b3d869$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $c6e34b1f19b3d869$var$RequiredInput$1 = $c6e34b1f19b3d869$var$RequiredInput;
var $c6e34b1f19b3d869$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $c6e34b1f19b3d869$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $c6e34b1f19b3d869$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $c6e34b1f19b3d869$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $c6e34b1f19b3d869$var$defaultStyles = {
    clearIndicator: (0, $95aa1968e67d2b10$export$407448d2b89b1813),
    container: (0, $95aa1968e67d2b10$export$8b22cf2602fb60ce),
    control: (0, $95aa1968e67d2b10$export$4368d992c4eafac0),
    dropdownIndicator: (0, $95aa1968e67d2b10$export$f1e1789686576879),
    group: (0, $95aa1968e67d2b10$export$39b482c5e57630a8),
    groupHeading: (0, $95aa1968e67d2b10$export$2d1720544b23b823),
    indicatorsContainer: (0, $95aa1968e67d2b10$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $95aa1968e67d2b10$export$dda1d9f60106f0e9),
    input: (0, $95aa1968e67d2b10$export$35e795649ee09318),
    loadingIndicator: (0, $95aa1968e67d2b10$export$882b5998b3b9117c),
    loadingMessage: (0, $95aa1968e67d2b10$export$342063e11d6c3cad),
    menu: (0, $95aa1968e67d2b10$export$953cecd6e717a553),
    menuList: (0, $95aa1968e67d2b10$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $95aa1968e67d2b10$export$ae1af26003f05816),
    multiValue: (0, $95aa1968e67d2b10$export$ffb5f4729a158638),
    multiValueLabel: (0, $95aa1968e67d2b10$export$9e5f44173e64f162),
    multiValueRemove: (0, $95aa1968e67d2b10$export$625550452a3fa3ec),
    noOptionsMessage: (0, $95aa1968e67d2b10$export$3b14a55fb2447963),
    option: (0, $95aa1968e67d2b10$export$90a7f3efeed30595),
    placeholder: (0, $95aa1968e67d2b10$export$efccba1c4a2ef57b),
    singleValue: (0, $95aa1968e67d2b10$export$d141bba7fdc215a3),
    valueContainer: (0, $95aa1968e67d2b10$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $c6e34b1f19b3d869$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $c6e34b1f19b3d869$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $c6e34b1f19b3d869$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $c6e34b1f19b3d869$var$baseUnit = 4;
// The minimum height of the control
var $c6e34b1f19b3d869$var$controlHeight = 38;
// The amount of space between the control and menu */
var $c6e34b1f19b3d869$var$menuGutter = $c6e34b1f19b3d869$var$baseUnit * 2;
var $c6e34b1f19b3d869$var$spacing = {
    baseUnit: $c6e34b1f19b3d869$var$baseUnit,
    controlHeight: $c6e34b1f19b3d869$var$controlHeight,
    menuGutter: $c6e34b1f19b3d869$var$menuGutter
};
var $c6e34b1f19b3d869$export$4368d992c4eafac0 = {
    borderRadius: $c6e34b1f19b3d869$var$borderRadius,
    colors: $c6e34b1f19b3d869$var$colors,
    spacing: $c6e34b1f19b3d869$var$spacing
};
var $c6e34b1f19b3d869$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $95aa1968e67d2b10$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $95aa1968e67d2b10$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $c6e34b1f19b3d869$export$db3b6bfb95261072(),
    formatGroupLabel: $c6e34b1f19b3d869$var$formatGroupLabel,
    getOptionLabel: $c6e34b1f19b3d869$export$8b22cf2602fb60ce,
    getOptionValue: $c6e34b1f19b3d869$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $c6e34b1f19b3d869$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $95aa1968e67d2b10$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $c6e34b1f19b3d869$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $c6e34b1f19b3d869$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $c6e34b1f19b3d869$var$_isOptionSelected(props, option, selectValue);
    var label = $c6e34b1f19b3d869$var$getOptionLabel(props, option);
    var value = $c6e34b1f19b3d869$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $c6e34b1f19b3d869$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $c6e34b1f19b3d869$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $c6e34b1f19b3d869$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $c6e34b1f19b3d869$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $c6e34b1f19b3d869$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $95aa1968e67d2b10$export$3466f893ebf79586));
}
function $c6e34b1f19b3d869$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $c6e34b1f19b3d869$var$buildFocusableOptions(props, selectValue) {
    return $c6e34b1f19b3d869$var$buildFocusableOptionsFromCategorizedOptions($c6e34b1f19b3d869$var$buildCategorizedOptions(props, selectValue));
}
function $c6e34b1f19b3d869$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$c6e34b1f19b3d869$var$shouldHideSelectedOptions(props) || !isSelected) && $c6e34b1f19b3d869$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $c6e34b1f19b3d869$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $c6e34b1f19b3d869$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $c6e34b1f19b3d869$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $c6e34b1f19b3d869$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $c6e34b1f19b3d869$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $c6e34b1f19b3d869$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $c6e34b1f19b3d869$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $c6e34b1f19b3d869$var$getOptionValue(props, i) === candidate;
    });
}
function $c6e34b1f19b3d869$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $c6e34b1f19b3d869$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $c6e34b1f19b3d869$var$instanceId = 1;
var $c6e34b1f19b3d869$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $95aa1968e67d2b10$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $95aa1968e67d2b10$export$ef35774e6d314e91)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $95aa1968e67d2b10$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $95aa1968e67d2b10$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $95aa1968e67d2b10$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $95aa1968e67d2b10$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $95aa1968e67d2b10$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $95aa1968e67d2b10$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $c6e34b1f19b3d869$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $c6e34b1f19b3d869$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $c6e34b1f19b3d869$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $95aa1968e67d2b10$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $c6e34b1f19b3d869$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $c6e34b1f19b3d869$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $95aa1968e67d2b10$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $c6e34b1f19b3d869$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$c6e34b1f19b3d869$var$instanceId);
        _this.state.selectValue = (0, $95aa1968e67d2b10$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $95aa1968e67d2b10$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $95aa1968e67d2b10$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $c6e34b1f19b3d869$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($c6e34b1f19b3d869$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $c6e34b1f19b3d869$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $c6e34b1f19b3d869$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $c6e34b1f19b3d869$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $c6e34b1f19b3d869$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox"
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox"),
                    "aria-owns": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($c6e34b1f19b3d869$var$DummyInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $95aa1968e67d2b10$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $95aa1968e67d2b10$export$3a1a48c8f6ef640e), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId("listbox")
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($c6e34b1f19b3d869$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($c6e34b1f19b3d869$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($c6e34b1f19b3d869$var$LiveRegion$1, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $95aa1968e67d2b10$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $c6e34b1f19b3d869$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $c6e34b1f19b3d869$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $c6e34b1f19b3d869$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $95aa1968e67d2b10$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$c6e34b1f19b3d869$export$25ce5a424b770e84.defaultProps = $c6e34b1f19b3d869$export$407448d2b89b1813;





var $8de12fa6a893dcd1$exports = {};
var $bb7ca61ce45563c4$exports = {};
var $010f4e0e13c82e16$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$_toPrimitive(input, hint) {
    if ($b77c8068776c2a21$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b77c8068776c2a21$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$_toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$_toPropertyKey(arg) {
    var key = $b77c8068776c2a21$exports(arg, "string");
    return $010f4e0e13c82e16$var$_typeof(key) === "symbol" ? key : String(key);
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$_toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $010f4e0e13c82e16$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;


function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bb7ca61ce45563c4$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$8de12fa6a893dcd1$exports = $8de12fa6a893dcd1$var$_objectSpread2, $8de12fa6a893dcd1$exports.__esModule = true, $8de12fa6a893dcd1$exports["default"] = $8de12fa6a893dcd1$exports;


var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;


var $51f08ebed50a2438$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $51f08ebed50a2438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e0ecff44bad0ea1$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e0ecff44bad0ea1$exports(o, minLen);
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(arr, i) {
    return $bf2dbd940d8d1ee7$exports(arr) || $efa3fde0b6100532$exports(arr, i) || $51f08ebed50a2438$exports(arr, i) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;


var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8bc9a7bbcf9a2a3b$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;


var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};

function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $010f4e0e13c82e16$exports(descriptor.key), descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;


var $b050fc8434f4a0e1$exports = {};
var $7b4ac2338b8e8f97$exports = {};
function $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p) {
    $7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports;
    return $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p);
}
$7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports;


function $b050fc8434f4a0e1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7b4ac2338b8e8f97$exports(subClass, superClass);
}
$b050fc8434f4a0e1$exports = $b050fc8434f4a0e1$var$_inherits, $b050fc8434f4a0e1$exports.__esModule = true, $b050fc8434f4a0e1$exports["default"] = $b050fc8434f4a0e1$exports;


var $6c89cb228f797fa5$exports = {};
var $93d4339c80153a6a$exports = {};
function $93d4339c80153a6a$var$_getPrototypeOf(o) {
    $93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports;
    return $93d4339c80153a6a$var$_getPrototypeOf(o);
}
$93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports;


var $426f299ee58329c3$exports = {};
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
$426f299ee58329c3$exports = $426f299ee58329c3$var$_isNativeReflectConstruct, $426f299ee58329c3$exports.__esModule = true, $426f299ee58329c3$exports["default"] = $426f299ee58329c3$exports;


var $ac4cd79166dac6e4$exports = {};

var $ac4cd79166dac6e4$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $4c93951af9bb8a88$exports = {};
function $4c93951af9bb8a88$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$4c93951af9bb8a88$exports = $4c93951af9bb8a88$var$_assertThisInitialized, $4c93951af9bb8a88$exports.__esModule = true, $4c93951af9bb8a88$exports["default"] = $4c93951af9bb8a88$exports;


function $ac4cd79166dac6e4$var$_possibleConstructorReturn(self, call) {
    if (call && ($ac4cd79166dac6e4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4c93951af9bb8a88$exports(self);
}
$ac4cd79166dac6e4$exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, $ac4cd79166dac6e4$exports.__esModule = true, $ac4cd79166dac6e4$exports["default"] = $ac4cd79166dac6e4$exports;


function $6c89cb228f797fa5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $426f299ee58329c3$exports();
    return function _createSuperInternal() {
        var Super = $93d4339c80153a6a$exports(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $93d4339c80153a6a$exports(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ac4cd79166dac6e4$exports(this, result);
    };
}
$6c89cb228f797fa5$exports = $6c89cb228f797fa5$var$_createSuper, $6c89cb228f797fa5$exports.__esModule = true, $6c89cb228f797fa5$exports["default"] = $6c89cb228f797fa5$exports;


var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};

function $41f5c206613f56c9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1e0ecff44bad0ea1$exports(arr);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;



var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(arr) {
    return $41f5c206613f56c9$exports(arr) || $cce79e023a3a67e7$exports(arr) || $51f08ebed50a2438$exports(arr) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;




var $c4870074adc2be76$exports = {};
function $c4870074adc2be76$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$c4870074adc2be76$exports = $c4870074adc2be76$var$_taggedTemplateLiteral, $c4870074adc2be76$exports.__esModule = true, $c4870074adc2be76$exports["default"] = $c4870074adc2be76$exports;






var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $9d88f0746ba78f85$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $c6e34b1f19b3d869$export$25ce5a424b770e84), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $0fe24a6591b39473$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};


var $969aac8aeafba2a4$exports = {};
$969aac8aeafba2a4$exports = new URL("uploadedFile.25f7089c.png", import.meta.url).toString();





function $a75de2e6cc2a08af$var$uploadDistribution(props) {
    const [creditOrEditDis, setcreditOrEditDis] = (0, $acw62.useState)(null);
    const [fileDataUpload, setFileDataUpload] = (0, $acw62.useState)(null);
    const [formSubmitted, setFormSubmitted] = (0, $acw62.useState)(false);
    const [formError, setFormError] = (0, $acw62.useState)("");
    const handlecreateOrEditChange = (event)=>{
        setcreditOrEditDis(event.target.value);
        console.log(creditOrEditDis);
    };
    const handleSubmitDistribution = (e)=>{
        e.preventDefault();
    };
    const societyDropList = [
        "AARC",
        "ACTRA",
        "ABRAMUS",
        "ADAMI",
        "GVL",
        "ITSRIGHT",
        "LaIPA",
        "LSG",
        "NORMA",
        "PlayRight",
        "PPL",
        "AARC",
        "ACTRA",
        "ABRAMUS",
        "ADAMI"
    ].map((societyDrop)=>({
            value: societyDrop,
            label: societyDrop
        }));
    const distributionDate = [
        "dd/mm/yy",
        "dd/mm/yy",
        "dd/mm/yy",
        "dd/mm/yy"
    ].map((societyDrop)=>({
            value: societyDrop,
            label: societyDrop
        }));
    const [uploadedDistributionFile, setuploadedDistributionFile] = (0, $acw62.useState)(null);
    const handleFileUpload = (event)=>{
        const file = event.target.files[0];
        setuploadedDistributionFile(file);
    };
    const deleteUploaded = ()=>{
        setuploadedDistributionFile(null);
    };
    const handleUploadDistri = (e)=>{
        e.preventDefault();
        setFormSubmitted(true);
    };
    const distributionData = [
        {
            name: "Victoria Adams",
            wa_name: "Victoria Beckham",
            amount: "892.77"
        },
        {
            name: "Emma Bunton",
            wa_name: "Emma Bunton",
            amount: "285.50"
        },
        {
            name: "David Robert Jones",
            wa_name: "David Robert Jones",
            amount: "2,657.12"
        },
        {
            name: "Alicia Keys",
            wa_name: "Alicia Keys",
            amount: "439.21"
        },
        {
            name: "Melanie C",
            wa_name: "Melanie Chisholm",
            amount: "750.00"
        },
        {
            name: "Melanie Brown",
            wa_name: "Melanie Brown",
            amount: "39.00"
        }
    ];
    const waArtist = [
        "Victoria Beckham",
        "Emma Bunton",
        "Alicia Keys",
        "Melanie Chisholm",
        "Melanie Brown"
    ].map((artist)=>({
            value: artist,
            label: artist
        }));
    const [formValue, setFormValue] = (0, $acw62.useState)({
        edit_create_distribuition: "",
        society: "",
        distribution_date: ""
    });
    const handleInputChange = (event)=>{
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: formSubmitted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
            isOpen: props.show && formSubmitted,
            onClose: ()=>{
                props.onCloseBtn();
                setFormSubmitted(false);
            },
            children: formError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "thankyouBlock",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "thImage",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($87f827128963ff43$exports))),
                            alt: "Thumbs Down",
                            width: "180",
                            className: "d-block m-auto"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                        className: "mt-4 pt-1 mb-3 text-center",
                        children: [
                            "Unable to extract the data.",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            " Please manually enter the details"
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "thankyouBlock",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "thImage",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ef80980ea56e490c$exports))),
                            alt: "Thumbs Up",
                            width: "180",
                            className: "d-block m-auto"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                        className: "mt-4 pt-1 mb-3 text-center",
                        children: [
                            "ABRAMUS",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "distribution uploaded"
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
            isOpen: props.show && !formSubmitted,
            onClose: props.onCloseBtn,
            title: "",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    className: "ModalClose btn btn-primary",
                    onClick: props.onCloseBtn,
                    children: "close"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: "Upload new distribution file"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039), {
                    onSubmit: handleSubmitDistribution,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "scInputFields scCheckFields fonmGroupControl align-items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "Edit_create_distribuition",
                                    children: "Create or edit a distribution"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "FormRadioGroup",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-0 styledRadioButtons styledCheckboxButtons radioButtonsRound d-flex flex-nowrap",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Check, {
                                                inline: true,
                                                label: "Create distribuition",
                                                type: "radio",
                                                value: "create_distribuition",
                                                name: "edit_create_distribuition",
                                                id: "create_distribuition",
                                                onChange: handleInputChange,
                                                className: "mb-0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Check, {
                                                inline: true,
                                                label: "Edit distribuition",
                                                type: "radio",
                                                value: "edit_distribuition",
                                                name: "edit_create_distribuition",
                                                id: "edit_distribuition",
                                                onChange: handleInputChange,
                                                className: "mb-0"
                                            })
                                        ]
                                    }, "inline-radio-distribution")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "scInputFields fonmGroupControl SocietySelect mb-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "Society_select",
                                    children: "Society"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                    options: societyDropList,
                                    className: "customSelect",
                                    placeholder: "Select Society",
                                    name: "society",
                                    styles: {
                                        control: (provided)=>({
                                                ...provided,
                                                width: "222px",
                                                borderColor: "#000!important",
                                                height: "30px",
                                                minHeight: "30px",
                                                color: "#000"
                                            }),
                                        placeholder: (provided)=>({
                                                ...provided,
                                                color: "#000"
                                            }),
                                        option: (provided)=>({
                                                ...provided,
                                                borderBottom: "1px solid #000",
                                                color: "var(--color-black)",
                                                fontSize: "1rem",
                                                padding: ".51rem 10px",
                                                backgroundColor: "white!important",
                                                cursor: "pointer",
                                                width: "222px"
                                            }),
                                        menu: (provided)=>({
                                                ...provided,
                                                maxHeight: "256px",
                                                overflowY: "hidden",
                                                width: "222px"
                                            })
                                    }
                                })
                            ]
                        }),
                        creditOrEditDis === "edit_distribuition" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "scInputFields fonmGroupControl SocietySelect",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "Society_select",
                                    children: "Distribution Date"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                    options: distributionDate,
                                    className: "customSelect",
                                    placeholder: "Please select",
                                    // defaultValue={selectedCountry}
                                    styles: {
                                        control: (provided)=>({
                                                ...provided,
                                                width: "222px",
                                                borderColor: "#000!important",
                                                height: "30px",
                                                minHeight: "30px",
                                                color: "#000"
                                            }),
                                        placeholder: (provided)=>({
                                                ...provided,
                                                color: "#000"
                                            }),
                                        option: (provided)=>({
                                                ...provided,
                                                borderBottom: "1px solid #000",
                                                color: "var(--color-black)",
                                                fontSize: "1rem",
                                                padding: ".51rem 10px",
                                                backgroundColor: "white!important",
                                                cursor: "pointer",
                                                width: "222px"
                                            }),
                                        menu: (provided)=>({
                                                ...provided,
                                                maxHeight: "256px",
                                                overflowY: "hidden",
                                                width: "222px"
                                            })
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: " w-100 my-3 scLogoUpload d-block fonmGroupControl",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "distributionFileUpload",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            children: "Upload the distribution file"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "fileTypeNote mb-0",
                                            children: "(.xls, .csv and .pdf are supported)"
                                        }),
                                        uploadedDistributionFile === null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "DistributionFile",
                                                    className: "distributionfileUploadLabel",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Drag and drop or click to upload"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                                                    type: "file",
                                                    name: "DistributionFile",
                                                    className: "formFileUpload",
                                                    id: "DistributionFile",
                                                    accept: ".xlsx, .xls, .pdf, .docx" // Specify the file types you want to allow
                                                    ,
                                                    onDragOver: (e)=>{
                                                        e.preventDefault();
                                                    // Add any visual indications for drag and drop here
                                                    },
                                                    onDrop: (e)=>{
                                                        e.preventDefault();
                                                        const file = e.dataTransfer.files[0];
                                                    },
                                                    onChange: handleFileUpload
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                uploadedDistributionFile != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "uploadedFile my-4 py-2",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "d-flex align-items-end",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($969aac8aeafba2a4$exports))),
                                                alt: "uploaded file icon",
                                                style: {
                                                    "height": "70px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "m-0 uploadedFileTilte ps-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mb-0",
                                                        children: uploadedDistributionFile["name"]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "uploadprcnt",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn-primary",
                                                            onClick: deleteUploaded,
                                                            children: "close"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                uploadedDistributionFile != null && fileDataUpload && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "uploadedFileDataColumns pt-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "d-flex fileColumnsheader",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "saNameBox",
                                                    children: "Society artist name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "waNameBox",
                                                    children: "Westbury artist name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "amountBox",
                                                    children: "Amount (USD $)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "fileColumnsDataFieldsWrap",
                                            children: distributionData && distributionData.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "d-flex fileColumnsDataFields mt-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "saNameBox",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                placeholder: "",
                                                                type: "text",
                                                                value: item.name ? item.name : "",
                                                                name: `society_name_${index}`,
                                                                className: "m-0"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "waNameBox",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                                                options: waArtist,
                                                                className: "customSelect waSelect",
                                                                placeholder: "Please select",
                                                                defaultValue: item.wa_name,
                                                                name: `wa_name_${index}`,
                                                                styles: {
                                                                    control: (provided)=>({
                                                                            ...provided,
                                                                            width: "200px",
                                                                            borderColor: "#000!important",
                                                                            height: "30px",
                                                                            minHeight: "30px",
                                                                            color: "#000"
                                                                        }),
                                                                    placeholder: (provided)=>({
                                                                            ...provided,
                                                                            color: "#000"
                                                                        }),
                                                                    option: (provided)=>({
                                                                            ...provided,
                                                                            borderBottom: "1px solid #000",
                                                                            color: "var(--color-black)",
                                                                            fontSize: "1rem",
                                                                            padding: ".51rem 10px",
                                                                            backgroundColor: "white!important",
                                                                            cursor: "pointer",
                                                                            width: "200px"
                                                                        }),
                                                                    menu: (provided)=>({
                                                                            ...provided,
                                                                            maxHeight: "256px",
                                                                            overflowY: "hidden",
                                                                            width: "200px"
                                                                        })
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "amountBox",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                placeholder: "",
                                                                type: "text",
                                                                value: item.amount ? item.amount : "",
                                                                name: `amount_${index}`,
                                                                className: "m-0"
                                                            })
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                })
                            ]
                        }),
                        fileDataUpload ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "x-button bg-grad w-100 d-block ms-auto justify-content-center mt-1",
                            onClick: handleUploadDistri,
                            children: "Upload"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "x-button bg-grad w-100 d-block ms-auto justify-content-center mt-1",
                            onClick: (e)=>setFileDataUpload(true),
                            children: "Upload"
                        })
                    ]
                })
            ]
        })
    });
}
var $a75de2e6cc2a08af$export$2e2bcd8739ae039 = $a75de2e6cc2a08af$var$uploadDistribution;




var $acw62 = parcelRequire("acw62");



var $ff8b9995e7c48792$exports = {};
$ff8b9995e7c48792$exports = new URL("plus-button.d7e06136.svg", import.meta.url).toString();


var $c8c33637d7b4ed5c$exports = {};
$c8c33637d7b4ed5c$exports = new URL("minus-button.efb5815f.svg", import.meta.url).toString();



function $dd5144e694c88f5a$var$uploadCredit(props) {
    const handleUploadDistri = (e)=>{
        e.preventDefault();
    };
    const [creditOrEditDis, setcreditOrEditDis] = (0, $acw62.useState)(null);
    const [enterManually, setEnterManually] = (0, $acw62.useState)(false);
    const handlecreateOrEditChange = (event)=>{
        setcreditOrEditDis(event.target.value);
    };
    const handleSubmitDistribution = (e)=>{
        e.preventDefault();
    };
    const societyDropList = [
        "One",
        "Two",
        "Three",
        "Four"
    ].map((societyDrop)=>({
            value: societyDrop,
            label: societyDrop
        }));
    const distributionDate = [
        "dd/mm/yy",
        "dd/mm/yy",
        "dd/mm/yy",
        "dd/mm/yy"
    ].map((societyDrop)=>({
            value: societyDrop,
            label: societyDrop
        }));
    const currencies = [
        "EUR",
        "USD",
        "GBP"
    ].map((currenciesDrop)=>({
            value: currenciesDrop,
            label: currenciesDrop
        }));
    const [selectedValue, setSelectedValue] = (0, $acw62.useState)("combined_payment");
    const handleSwitchChange = (event)=>{
        const checkedValue = event.target.value;
        if (checkedValue == "combined_payment") setSelectedValue("individual_payment");
        else setSelectedValue("combined_payment");
    };
    const [uploadedDistributionFile, setuploadedDistributionFile] = (0, $acw62.useState)(null);
    const handleFileUpload = (event)=>{
        const file = event.target.files[0];
        setuploadedDistributionFile(file);
        console.log(file);
    };
    const deleteUploaded = ()=>{
        setuploadedDistributionFile(null);
    };
    // Simulating upload progress (replace with your actual upload logic)
    const [uploadPercentage, setUploadPercentage] = (0, $acw62.useState)(0);
    const [uploadedInputForm, setuploadedInputForm] = (0, $acw62.useState)([
        {
            currency: "",
            conversinRate: "",
            bankCharges: "",
            transactionAmount: "",
            dateReceived: "",
            amountReceived: ""
        }
    ]);
    const handletaxFormInfoReplicate = ()=>{
        const noOfForms = uploadedInputForm.length;
        console.log(uploadedInputForm);
        const newRole = {
            currency: "",
            conversinRate: "",
            bankCharges: "",
            transactionAmount: "",
            dateReceived: "",
            amountReceived: ""
        };
        const updatedFormsFields = [
            ...uploadedInputForm,
            newRole
        ];
        setuploadedInputForm(updatedFormsFields);
    };
    // deleteing newly created form
    const deleteCurentForm = (e)=>{
        const formToDeleteId = e.target.getAttribute("data-delete");
        const idParts = formToDeleteId.split("-");
        const idNumber = parseInt(idParts[1]);
        const updatedArray = [
            ...uploadedInputForm
        ]; // make a copy of the array
        updatedArray.splice(idNumber, 1); // remove 1 element at index 1
        setuploadedInputForm(updatedArray);
    };
    console.log(uploadedInputForm);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
            onClose: props.onCloseBtn,
            isOpen: props.show,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: "Upload new credit advice"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039), {
                    onSubmit: handleSubmitDistribution,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "scInputFields scCheckFields fonmGroupControl align-items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "Edit_create_distribuition_credit",
                                    children: "Create or edit a distribution"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "FormRadioGroup",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-0 styledRadioButtons styledCheckboxButtons radioButtonsRound d-flex flex-nowrap",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Check, {
                                                inline: true,
                                                label: "Create distribuition",
                                                type: "radio",
                                                value: "create_distribuition_credit",
                                                name: "Edit_create_distribuition_credit",
                                                id: "create_distribuition_credit",
                                                onChange: handlecreateOrEditChange,
                                                className: "mb-0 mt-2"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Check, {
                                                inline: true,
                                                label: "Edit distribuition",
                                                type: "radio",
                                                value: "edit_distribuition_credit",
                                                name: "Edit_create_distribuition_credit",
                                                id: "edit_distribuition_credit",
                                                onChange: handlecreateOrEditChange,
                                                className: "mb-0 mt-2"
                                            })
                                        ]
                                    }, "inline-radio-distribution")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "scInputFields fonmGroupControl SocietySelect mb-4 pb-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "Society_select",
                                    children: "Society"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                    options: societyDropList,
                                    className: "customSelect",
                                    placeholder: "Select society",
                                    // defaultValue={selectedCountry}
                                    styles: {
                                        control: (provided)=>({
                                                ...provided,
                                                width: "222px",
                                                borderColor: "#000!important",
                                                height: "30px",
                                                minHeight: "30px",
                                                color: "#000"
                                            }),
                                        placeholder: (provided)=>({
                                                ...provided,
                                                color: "#000"
                                            }),
                                        option: (provided)=>({
                                                ...provided,
                                                borderBottom: "1px solid #000",
                                                color: "var(--color-black)",
                                                fontSize: "1rem",
                                                padding: ".51rem 10px",
                                                backgroundColor: "white!important",
                                                cursor: "pointer",
                                                width: "222px"
                                            }),
                                        menu: (provided)=>({
                                                ...provided,
                                                maxHeight: "256px",
                                                overflowY: "hidden",
                                                width: "222px"
                                            })
                                    }
                                })
                            ]
                        }),
                        creditOrEditDis === "edit_distribuition_credit" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "scInputFields fonmGroupControl SocietySelect mb-4 pb-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "Society_select",
                                    children: "Distribution Date"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                    options: distributionDate,
                                    className: "customSelect",
                                    placeholder: "Please select",
                                    // defaultValue={selectedCountry}
                                    styles: {
                                        control: (provided)=>({
                                                ...provided,
                                                width: "222px",
                                                borderColor: "#000!important",
                                                height: "30px",
                                                minHeight: "30px",
                                                color: "#000"
                                            }),
                                        placeholder: (provided)=>({
                                                ...provided,
                                                color: "#000"
                                            }),
                                        option: (provided)=>({
                                                ...provided,
                                                borderBottom: "1px solid #000",
                                                color: "var(--color-black)",
                                                fontSize: "1rem",
                                                padding: ".51rem 10px",
                                                backgroundColor: "white!important",
                                                cursor: "pointer",
                                                width: "222px"
                                            }),
                                        menu: (provided)=>({
                                                ...provided,
                                                maxHeight: "256px",
                                                overflowY: "hidden",
                                                width: "222px"
                                            })
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "scInputFields  scSwitch fonmGroupControl align-items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    children: "Enter the credit advice details"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "FormRadioGroup",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-0 d-flex flex-nowrap",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "switch-label",
                                                children: "Combined Payment"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Check, {
                                                inline: true,
                                                type: "switch",
                                                value: selectedValue,
                                                name: "paymentMode",
                                                id: "paymentMode",
                                                onChange: handleSwitchChange
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "switch-label",
                                                children: "Individual Payment"
                                            })
                                        ]
                                    }, "inline-radio-distribution")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: " w-100 my-3 scLogoUpload d-block fonmGroupControl",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "distributionFileUpload position-relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        children: "Upload the distribution file"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "d-flex justify-content-between",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "fileTypeNote mb-0 pr-4",
                                                children: "(.xls, .csv and .pdf are supported)"
                                            }),
                                            uploadedDistributionFile === null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "manualLinkWrap",
                                                children: enterManually ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#",
                                                    className: "enterDetailsManually m-0 position-absolute end-0",
                                                    onClick: ()=>setEnterManually(false),
                                                    children: "Automatically enter the details"
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#",
                                                    className: "enterDetailsManually m-0 position-absolute end-0",
                                                    onClick: ()=>setEnterManually(true),
                                                    children: "Manually enter the details"
                                                })
                                            })
                                        ]
                                    }),
                                    uploadedDistributionFile === null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "DistributionFile_credit",
                                                className: "distributionfileUploadLabel",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Drag and drop or click to upload"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                                                type: "file",
                                                name: "DistributionFile_credit",
                                                className: "formFileUpload",
                                                id: "DistributionFile_credit",
                                                accept: ".txt, .pdf, .docx" // Specify the file types you want to allow
                                                ,
                                                onDragOver: (e)=>{
                                                    e.preventDefault();
                                                // Add any visual indications for drag and drop here
                                                },
                                                onDrop: (e)=>{
                                                    e.preventDefault();
                                                    const file = e.dataTransfer.files[0];
                                                },
                                                onChange: handleFileUpload
                                            })
                                        ]
                                    }),
                                    uploadedDistributionFile != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "uploadedFile my-3",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "d-flex align-items-end",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($969aac8aeafba2a4$exports))),
                                                    alt: "uploaded file icon",
                                                    style: {
                                                        "height": "70px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "m-0 uploadedFileTilte ps-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "mb-0",
                                                            children: uploadedDistributionFile["name"]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "uploadprcnt",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "btn btn-primary",
                                                                onClick: deleteUploaded,
                                                                children: "close"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        (uploadedDistributionFile != null || enterManually) && uploadedInputForm.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "d-flex fileUploadedInputs justify-content-between flex-wrap position-relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-3 scInputFields fonmGroupControl",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: `currency_${index}`,
                                                children: "Currency"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                                options: currencies,
                                                className: "customSelect",
                                                placeholder: "Please select",
                                                styles: {
                                                    control: (provided)=>({
                                                            ...provided,
                                                            width: "222px",
                                                            borderColor: "#000!important",
                                                            height: "30px",
                                                            minHeight: "30px",
                                                            color: "#000"
                                                        }),
                                                    placeholder: (provided)=>({
                                                            ...provided,
                                                            color: "#000"
                                                        }),
                                                    option: (provided)=>({
                                                            ...provided,
                                                            borderBottom: "1px solid #000",
                                                            color: "var(--color-black)",
                                                            fontSize: "1rem",
                                                            padding: ".51rem 10px",
                                                            backgroundColor: "white!important",
                                                            cursor: "pointer",
                                                            width: "222px"
                                                        }),
                                                    menu: (provided)=>({
                                                            ...provided,
                                                            maxHeight: "256px",
                                                            overflowY: "hidden",
                                                            width: "222px"
                                                        })
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-3 scInputFields fonmGroupControl defaultInput",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: `convrsion_rate_${index}`,
                                                children: "Conversion Rate"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                placeholder: "",
                                                type: "text",
                                                // value=""
                                                // onChange={handleInputChange}
                                                name: `convrsion_rate_${index}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-3 scInputFields fonmGroupControl defaultInput",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: `bank_charges_${index}`,
                                                children: "Bank charges (GBP)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                placeholder: "",
                                                type: "text",
                                                // value=""
                                                // onChange={handleInputChange}
                                                name: `bank_charges_${index}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-3 scInputFields fonmGroupControl defaultInput",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: `transaction_amount_${index}`,
                                                children: "Transaction amount (USD$)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                placeholder: "",
                                                type: "text",
                                                // value=""
                                                // onChange={handleInputChange}
                                                name: `transaction_amount_${index}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-3 scInputFields fonmGroupControl defaultInput",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: `date_received_${index}`,
                                                children: "Date received"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                placeholder: "",
                                                type: "text",
                                                // value=""
                                                // onChange={handleInputChange}
                                                name: `date_received_${index}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-3 scInputFields fonmGroupControl defaultInput",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: `amount_received_${index}`,
                                                children: "Amount received"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                placeholder: "",
                                                type: "text",
                                                // value=""
                                                // onChange={handleInputChange}
                                                name: `amount_received_${index}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "addformNew addformNew d-flex justify-content-between align-self-end",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                onClick: handletaxFormInfoReplicate,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ff8b9995e7c48792$exports))),
                                                    className: "pointer-none",
                                                    title: "Add New Form"
                                                })
                                            }),
                                            index !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                onClick: deleteCurentForm,
                                                "data-delete": `formId-${index}`,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c8c33637d7b4ed5c$exports))),
                                                    className: "pointer-none",
                                                    title: "Remove Form",
                                                    className: "removeNewForm",
                                                    "data-delete": `formId-${index}`
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, index))
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "x-button bg-grad w-100 d-block ms-auto justify-content-center mt-1",
                    onClick: handleUploadDistri,
                    children: "Upload"
                })
            ]
        })
    });
}
var $dd5144e694c88f5a$export$2e2bcd8739ae039 = $dd5144e694c88f5a$var$uploadCredit;




var $acw62 = parcelRequire("acw62");




function $ec0c794bd7811e61$var$CashChequeCard({ cashChequeId: cashChequeId, onComplete: onComplete, cardEvent: cardEvent, isOpen: isOpen }) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [showDetails, setShowDetails] = (0, $acw62.useState)(false);
    const [isSelected, setIsSelected] = (0, $acw62.useState)(false);
    const [isArtistToggle, setArtistToggle] = (0, $acw62.useState)(false);
    const [isAmountToggle, setAmountToggle] = (0, $acw62.useState)(false);
    const [isPercentageToggle, setPercentageToggle] = (0, $acw62.useState)(false);
    const [formStatus, setFormStatus] = (0, $acw62.useState)(false);
    const [formSubmitted, setFormSubmitted] = (0, $acw62.useState)(false);
    const [formError, setFormError] = (0, $acw62.useState)(false);
    const { clientId: clientId, clientEmail: clientEmail } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const statusDropList = [
        "Cash Cheque 08/06/22",
        "Waiting to receive money",
        "Credit advice received",
        "Xero money in",
        "Internal Transfer"
    ].map((statusDrop)=>({
            value: statusDrop,
            label: statusDrop
        }));
    const associationDetails = [
        {
            name: "David Bowie",
            amount: "10,844",
            percentage: "57%"
        },
        {
            name: "Emma Bowie",
            amount: "2,844",
            percentage: "17%"
        },
        {
            name: "Geri Bowie",
            amount: "3,844",
            percentage: "37%"
        }
    ];
    (0, $acw62.useEffect)(()=>{
        setFormSubmitted(false);
        setFormError(false);
        fetchData();
    }, [
        clientEmail
    ]);
    const fetchData = ()=>{
        if (clientId === undefined) return;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cc827972f01625b6$export$8ba061c9afd04389), {
        isOpen: isOpen,
        cardEvent: cardEvent,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "artistDetailsCard tw-bg-surfaceBlack80",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "detailsBoxWrap",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                            className: "d-flex align-items-center mb-3",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "pr-14",
                                children: "Distribution details"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "d-flex mb-2 fonmGroupControl edt-form-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "dstcard-label",
                                    children: "Society: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dstcard-fieldValue ",
                                    children: "SoundExchange"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "d-flex mb-2 fonmGroupControl edt-form-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "dstcard-label",
                                    children: "Amount: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dstcard-fieldValue ",
                                    children: "$18,475"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "d-flex mb-2 fonmGroupControl edt-form-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "dstcard-label",
                                    children: "Date: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dstcard-fieldValue "
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "d-flex mb-2 fonmGroupControl edt-form-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "dstcard-label",
                                    children: "Email: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dstcard-fieldValue ",
                                    children: "distribution@soundexchange.com"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "d-flex mb-2 fonmGroupControl edt-form-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "dstcard-label",
                                    children: "Phone: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dstcard-fieldValue ",
                                    children: "+1 202-604-5858"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "d-flex mb-2 fonmGroupControl edt-form-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "dstcard-label",
                                    children: "Status: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dstcard-fieldValue ",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                        options: statusDropList,
                                        className: "statusSelect",
                                        // defaultValue={selectedCountry}
                                        styles: {
                                            control: (provided)=>({
                                                    ...provided,
                                                    width: "222px",
                                                    borderColor: "#000!important",
                                                    height: "30px",
                                                    minHeight: "30px",
                                                    color: "#191C1F"
                                                }),
                                            placeholder: (provided)=>({
                                                    ...provided,
                                                    color: "#000"
                                                }),
                                            option: (provided)=>({
                                                    ...provided,
                                                    borderBottom: "1px solid #000",
                                                    color: "var(--color-black)",
                                                    fontSize: "1rem",
                                                    padding: ".51rem 10px",
                                                    backgroundColor: "white!important",
                                                    cursor: "pointer",
                                                    width: "222px"
                                                }),
                                            menu: (provided)=>({
                                                    ...provided,
                                                    maxHeight: "256px",
                                                    overflowY: "hidden",
                                                    width: "222px"
                                                })
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "d-flex justify-content-end my-4 py-2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "x-button px-3 py-2 gradient-bg",
                    onClick: (e)=>setFormSubmitted(true),
                    children: "Complete"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "artistDetailsCard tw-bg-surfaceBlack80",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "detailsBoxWrap",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "associationDetails",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "listingTableWrap",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "d-flex ardHeadingsRow ardRow justify-content-between",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "ard-name ardHeading",
                                            children: [
                                                "Artist",
                                                isArtistToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "dropArrowButton arrowSort arrowSortUp",
                                                    onClick: ()=>setArtistToggle(false),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "close"
                                                    })
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "dropArrowButton arrowSort arrowSortDown",
                                                    onClick: ()=>setArtistToggle(true),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: `ard-inner ${isArtistToggle ? "" : "d-none"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                            href: "javascript:void(0);",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "arrow-asc"
                                                                }),
                                                                "A to Z"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                            href: "javascript:void(0);",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "arrow-dsc"
                                                                }),
                                                                "Z to A"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "amounts ardHeading d-flex",
                                            children: [
                                                "Amount (USD $)",
                                                isAmountToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "dropArrowButton arrowSort arrowSortUp",
                                                    onClick: ()=>setAmountToggle(!isAmountToggle),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "close"
                                                    })
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "dropArrowButton arrowSort arrowSortDown",
                                                    onClick: ()=>setAmountToggle(!isAmountToggle),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: `ard-inner ${isAmountToggle ? "" : "d-none"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                            href: "javascript:void(0);",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "arrow-asc"
                                                                }),
                                                                "A to Z"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                            href: "javascript:void(0);",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "arrow-dsc"
                                                                }),
                                                                "Z to A"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "percentage ardHeading d-flex",
                                            children: [
                                                "% of distribution",
                                                isPercentageToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "dropArrowButton arrowSort arrowSortUp",
                                                    onClick: ()=>setPercentageToggle(!isPercentageToggle),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "close"
                                                    })
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "dropArrowButton arrowSort arrowSortDown",
                                                    onClick: ()=>setPercentageToggle(!isPercentageToggle),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: `ard-inner ${isPercentageToggle ? "" : "d-none"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                            href: "javascript:void(0);",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "arrow-asc"
                                                                }),
                                                                "A to Z"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                            href: "javascript:void(0);",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "arrow-dsc"
                                                                }),
                                                                "Z to A"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "viewRecords d-flex"
                                        })
                                    ]
                                }),
                                associationDetails.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "ardRowWrap",
                                    children: associationDetails.map((artist, playIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "ardRowInner",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "ardRow b-0 d-flex justify-content-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "ard-name",
                                                        children: artist.name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "amounts",
                                                        children: artist.amount
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "percentage",
                                                        children: artist.percentage
                                                    })
                                                ]
                                            })
                                        }, playIndex.toString()))
                                }) : ""
                            ]
                        })
                    })
                })
            })
        ]
    });
}
var $ec0c794bd7811e61$export$2e2bcd8739ae039 = $ec0c794bd7811e61$var$CashChequeCard;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $c770a015764ac03c$var$Row = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const decoratedBsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "row");
    const breakpoints = (0, $626bd95fa485b758$export$8970c8db816a5863)();
    const minBreakpoint = (0, $626bd95fa485b758$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === "object") ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$c770a015764ac03c$var$Row.displayName = "Row";
var $c770a015764ac03c$export$2e2bcd8739ae039 = $c770a015764ac03c$var$Row;



function $a1dbcb5edfc74bab$var$XeroFileReady({ show: show, modalClose: modalClose, statementPdf: statementPdf }) {
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const numToString = (num)=>{
        const parseNumber = num / 100;
        const toLocale = parseNumber.toLocaleString(navigator.language, {
            minimumFractionDigits: 2
        });
        return toLocale;
    };
    const [isArtistToggle, setArtistToggle] = (0, $acw62.useState)(false);
    const [isAmountToggle, setAmountToggle] = (0, $acw62.useState)(false);
    const [isAmountAltToggle, setAmountAltToggle] = (0, $acw62.useState)(false);
    const [isStatusToggle, setStatusToggle] = (0, $acw62.useState)(false);
    const [isPercentageToggle, setPercentageToggle] = (0, $acw62.useState)(false);
    const [formValue, setFormValue] = (0, $acw62.useState)({
        society_name: "LSG",
        distribution_date: "12/07/22",
        distribution_status: "Status",
        currency: "Euro",
        exchange_rate: "0.8865193",
        native_charges: "0.00",
        bank_charges: "10.00"
    });
    const inputChange = (event)=>{
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    const associationDetails = [
        {
            name: "David Bowie",
            amount: "10,844",
            amount_alt: "90.20",
            status: "held",
            percentage: "57%"
        },
        {
            name: "Emma Bowie",
            amount: "2,844",
            amount_alt: "90.20",
            status: "cleared",
            percentage: "17%"
        },
        {
            name: "Geri Bowie",
            amount: "3,844",
            amount_alt: "90.20",
            status: "held",
            percentage: "37%"
        },
        {
            name: "David Bowie",
            amount: "10,844",
            amount_alt: "90.20",
            status: "held",
            percentage: "57%"
        },
        {
            name: "Emma Bowie",
            amount: "2,844",
            amount_alt: "90.20",
            status: "cleared",
            percentage: "17%"
        },
        {
            name: "Geri Bowie",
            amount: "3,844",
            amount_alt: "90.20",
            status: "held",
            percentage: "37%"
        },
        {
            name: "David Bowie",
            amount: "10,844",
            amount_alt: "90.20",
            status: "held",
            percentage: "57%"
        },
        {
            name: "Emma Bowie",
            amount: "2,844",
            amount_alt: "90.20",
            status: "cleared",
            percentage: "17%"
        },
        {
            name: "Geri Bowie",
            amount: "3,844",
            amount_alt: "90.20",
            status: "held",
            percentage: "37%"
        },
        {
            name: "David Bowie",
            amount: "10,844",
            amount_alt: "90.20",
            status: "held",
            percentage: "57%"
        },
        {
            name: "Emma Bowie",
            amount: "2,844",
            amount_alt: "90.20",
            status: "cleared",
            percentage: "17%"
        },
        {
            name: "Geri Bowie",
            amount: "3,844",
            amount_alt: "90.20",
            status: "held",
            percentage: "37%"
        }
    ];
    const statusMap = {
        cleared: "Cleared",
        to_be_transferred: "Awaiting transfer",
        waiting_cheque_clear: "Awaiting cheque clearance",
        held: "Held"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: show,
        onClose: ()=>modalClose(),
        title: "Xero File Ready",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "AgreementModalData",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "agreementHeader",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "d-flex justify-content-end modalTopButtons",
                        children: [
                            isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                variant: "primary",
                                className: "x-button px-3 py-2 buttonIconSave",
                                onClick: (e)=>{
                                    setIsEditing(false);
                                },
                                children: "Save"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                className: "x-button sign-btn px-3 py-2",
                                onClick: (e)=>setIsEditing(true),
                                children: "Edit"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "#",
                                className: "btn download-btn button-border ml-2",
                                download: true,
                                children: "Download"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "modalDocument",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "statementDoc",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                    lg: 6,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039), {
                                        className: "XeroFileForm pb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "d-flex filedListing align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "xerofieldLabel",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Society Name"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "fieldValue",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                            name: "society_name",
                                                            className: ` mt-0 fieldSmaller ${isEditing ? "fieldWithBorder" : "readonlyField"}`,
                                                            readOnly: isEditing ? false : true,
                                                            onChange: (e)=>inputChange(e),
                                                            value: formValue.society_name ? formValue.society_name : ""
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "d-flex filedListing align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "xerofieldLabel",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Distribution date"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "fieldValue",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                            name: "distribution_date",
                                                            type: "date",
                                                            className: ` mt-0 fieldSmaller ${isEditing ? "fieldWithBorder" : "readonlyField"}`,
                                                            readOnly: isEditing ? false : true,
                                                            onChange: (e)=>inputChange(e),
                                                            value: formValue.distribution_date ? formValue.distribution_date : ""
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "d-flex filedListing align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "xerofieldLabel",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Distribution status"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "fieldValue",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                            name: "distribution_status",
                                                            className: ` mt-0 fieldSmaller ${isEditing ? "fieldWithBorder" : "readonlyField"}`,
                                                            readOnly: isEditing ? false : true,
                                                            onChange: (e)=>inputChange(e),
                                                            value: formValue.distribution_status ? formValue.distribution_status : ""
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "d-flex filedListing align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "xerofieldLabel",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Currency"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "fieldValue",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                            name: "currency",
                                                            className: ` mt-0 fieldSmaller ${isEditing ? "fieldWithBorder" : "readonlyField"}`,
                                                            readOnly: isEditing ? false : true,
                                                            onChange: (e)=>inputChange(e),
                                                            value: formValue.currency ? formValue.currency : ""
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "d-flex filedListing align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "xerofieldLabel",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Exchange rate"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "fieldValue",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                            name: "exchange_rate",
                                                            className: ` mt-0 fieldSmaller ${isEditing ? "fieldWithBorder" : "readonlyField"}`,
                                                            readOnly: isEditing ? false : true,
                                                            onChange: (e)=>inputChange(e),
                                                            value: formValue.exchange_rate ? formValue.exchange_rate : ""
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "d-flex filedListing align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "xerofieldLabel",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Native charges "
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "fieldValue",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                            name: "native_charges",
                                                            className: ` mt-0 fieldSmaller ${isEditing ? "fieldWithBorder" : "readonlyField"}`,
                                                            readOnly: isEditing ? false : true,
                                                            onChange: (e)=>inputChange(e),
                                                            value: formValue.native_charges ? formValue.native_charges : ""
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "d-flex filedListing align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "xerofieldLabel",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Bank charges"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "fieldValue",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                            name: "bank_charges",
                                                            className: ` mt-0 fieldSmaller ${isEditing ? "fieldWithBorder" : "readonlyField"}`,
                                                            readOnly: isEditing ? false : true,
                                                            onChange: (e)=>inputChange(e),
                                                            value: formValue.bank_charges ? formValue.bank_charges : ""
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "XeroFileTable statementDetailTable",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "ArtistDistibutionAmountTable",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "listingTableWrap",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "d-flex ardHeadingsRow ardRow justify-content-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "ard-name ardHeading",
                                                                    children: [
                                                                        "Artist",
                                                                        isArtistToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: "dropArrowButton arrowSort arrowSortUp",
                                                                            onClick: ()=>setArtistToggle(false),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "close"
                                                                            })
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: "dropArrowButton arrowSort arrowSortDown",
                                                                            onClick: ()=>setArtistToggle(true),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "Open"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: `ard-inner ${isArtistToggle ? "" : "d-none"}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                                    href: "javascript:void(0);",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "arrow-asc"
                                                                                        }),
                                                                                        "A to Z"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                                    href: "javascript:void(0);",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "arrow-dsc"
                                                                                        }),
                                                                                        "Z to A"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "percentage ardHeading d-flex",
                                                                    children: [
                                                                        "% of distribution",
                                                                        isPercentageToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: "dropArrowButton arrowSort arrowSortUp",
                                                                            onClick: ()=>setPercentageToggle(!isPercentageToggle),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "close"
                                                                            })
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: "dropArrowButton arrowSort arrowSortDown",
                                                                            onClick: ()=>setPercentageToggle(!isPercentageToggle),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "Open"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: `ard-inner ${isPercentageToggle ? "" : "d-none"}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                                    href: "javascript:void(0);",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "arrow-asc"
                                                                                        }),
                                                                                        "A to Z"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                                    href: "javascript:void(0);",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "arrow-dsc"
                                                                                        }),
                                                                                        "Z to A"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "amounts ardHeading d-flex",
                                                                    children: [
                                                                        "Amount in \u20AC",
                                                                        isAmountToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: "dropArrowButton arrowSort arrowSortUp",
                                                                            onClick: ()=>setAmountToggle(!isAmountToggle),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "close"
                                                                            })
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: "dropArrowButton arrowSort arrowSortDown",
                                                                            onClick: ()=>setAmountToggle(!isAmountToggle),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "Open"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: `ard-inner ${isAmountToggle ? "" : "d-none"}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                                    href: "javascript:void(0);",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "arrow-asc"
                                                                                        }),
                                                                                        "A to Z"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                                    href: "javascript:void(0);",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "arrow-dsc"
                                                                                        }),
                                                                                        "Z to A"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "amounts ardHeading d-flex",
                                                                    children: [
                                                                        "Amount in \xa3",
                                                                        isAmountToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: "dropArrowButton arrowSort arrowSortUp",
                                                                            onClick: ()=>setAmountToggle(!isAmountToggle),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "close"
                                                                            })
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: "dropArrowButton arrowSort arrowSortDown",
                                                                            onClick: ()=>setAmountToggle(!isAmountToggle),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "Open"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: `ard-inner ${isAmountToggle ? "" : "d-none"}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                                    href: "javascript:void(0);",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "arrow-asc"
                                                                                        }),
                                                                                        "A to Z"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                                    href: "javascript:void(0);",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "arrow-dsc"
                                                                                        }),
                                                                                        "Z to A"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "status ardHeading d-flex",
                                                                    children: [
                                                                        "Status",
                                                                        isAmountToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: "dropArrowButton arrowSort arrowSortUp",
                                                                            onClick: ()=>setAmountToggle(!isAmountToggle),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "close"
                                                                            })
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: "dropArrowButton arrowSort arrowSortDown",
                                                                            onClick: ()=>setAmountToggle(!isAmountToggle),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "Open"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: `ard-inner ${isAmountToggle ? "" : "d-none"}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                                    href: "javascript:void(0);",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "arrow-asc"
                                                                                        }),
                                                                                        "A to Z"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                                    href: "javascript:void(0);",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "arrow-dsc"
                                                                                        }),
                                                                                        "Z to A"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        associationDetails.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "ardRowWrap",
                                                            children: associationDetails.map((artist, playIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "ardRowInner",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "ardRow b-0 d-flex justify-content-between",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "ard-name",
                                                                                children: artist.name
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "percentage",
                                                                                children: artist.percentage
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "amounts",
                                                                                children: artist.amount
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "amounts",
                                                                                children: artist.amount
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: `${artist.status} status`,
                                                                                children: statusMap[artist.status]
                                                                            })
                                                                        ]
                                                                    })
                                                                }, playIndex.toString()))
                                                        }) : ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "XeroListingSummary",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "ardRow b-0 d-flex justify-content-between",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "ard-name ardHeading"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "percentage ardHeading"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "amounts amountTotal d-flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "totalLabel",
                                                                        children: "Total: "
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "",
                                                                        children: "10,087"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "amounts amountTotal d-flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "totalLabel",
                                                                        children: "Total: "
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "",
                                                                        children: "8,943 "
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "statusTotal",
                                                                children: "63.63% cleared"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
var $a1dbcb5edfc74bab$export$2e2bcd8739ae039 = $a1dbcb5edfc74bab$var$XeroFileReady;









function $20f6fe0e2d8be51b$var$DistributionDetails() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [registerUsers, setRegisterUsers] = (0, $acw62.useState)(75);
    const [clientTasks, setClientTasks] = (0, $acw62.useState)([]);
    const [clientList, setClientList] = (0, $acw62.useState)([]);
    const [taskId, setTaskId] = (0, $acw62.useState)("");
    const [continueButtonDisabled, setContinueButtonDisabled] = (0, $acw62.useState)(true);
    const [eoiReviewID, setEoiReviewID] = (0, $acw62.useState)("");
    const [DiscographyID, setDiscographyID] = (0, $acw62.useState)();
    const [showEOIcard, setShowEOIcard] = (0, $acw62.useState)(false);
    const [showCashChequeCard, setShowCashChequeCard] = (0, $acw62.useState)(false);
    const [showUploadDistribution, setshowUploadDistribution] = (0, $acw62.useState)(false);
    const [showUploadCredit, setShowUploadCredit] = (0, $acw62.useState)(false);
    const [statementView, setStatementView] = (0, $acw62.useState)(false);
    const things_to_do_status = new Map([
        [
            "verify_passport_and_send_forms",
            "Cash cheque"
        ],
        [
            "expression_of_interest_review",
            "Upload credit advice"
        ],
        [
            "submit_discography_id",
            "Post cheque to client"
        ]
    ]);
    const { clientId: clientId, setClientId: setClientId, setClientEmail: setClientEmail } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const fetchData = ()=>{
        api.listUsers().then((clients)=>{
            console.log("clients", clients);
            setClientList(// set image to empty string pending backend implementation
            clients.map((client)=>{
                return {
                    ...client,
                    image: ""
                };
            }));
            api.listAdminTaskClients().then((adminClientTasks)=>{
                setClientTasks(adminClientTasks);
            }).catch(()=>{});
        }).catch((error)=>{});
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    const handleThingsToDoStatusClick = (clientTask)=>{
        const client_task_status = clientTask.clientAdminTasks[0].status;
        if (client_task_status == "verify_passport_and_send_forms") setShowCashChequeCard(true);
        else if (client_task_status == "expression_of_interest_review") setShowCashChequeCard(true);
        else if (client_task_status == "submit_discography_id") setShowCashChequeCard(true);
    };
    const showCard = ()=>{
        document.body.classList.add("hide-scroll");
    };
    const hideCard = ()=>{
        document.body.classList.remove("hide-scroll");
        setShowEOIcard(false);
        setShowCashChequeCard(false);
    };
    const showDistributionUpload = ()=>{
        setshowUploadDistribution(true);
        if (showUploadDistribution == true) setshowUploadDistribution(false);
    };
    const showDistributionCredit = ()=>{
        setShowUploadCredit(true);
        if (showUploadCredit == true) setShowUploadCredit(false);
    };
    const handleShow = ()=>setStatementView(!statementView);
    let tableData = clientTasks.filter((clientTask)=>!clientList.some((client)=>Number(client.userId ?? 0) === Number(clientTask.id ?? 0) && client.nonClient === true)).map((clientTask, i)=>{
        const [firstThingToDo] = clientTask?.clientAdminTasks ?? [];
        let dateCreated = firstThingToDo?.dateCreated;
        return {
            artist: clientTask.fullName ?? clientTask.username,
            action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "button",
                tabIndex: 0,
                onClick: ()=>handleThingsToDoStatusClick(clientTask),
                onKeyPress: (e)=>{
                    if (e.key === "Enter") handleThingsToDoStatusClick(clientTask);
                },
                children: things_to_do_status.get(firstThingToDo?.status ?? "")
            }),
            dateCreated: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: dateCreated?.toLocaleDateString().toString() || "-"
            }),
            status: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c962736a82687da2$export$c71c3a205c92eaf4), {
                percentage: 75,
                label: "75% complete"
            })
        };
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec0c794bd7811e61$export$2e2bcd8739ae039), {
                isOpen: showCashChequeCard,
                cardEvent: hideCard
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a75de2e6cc2a08af$export$2e2bcd8739ae039), {
                show: showUploadDistribution,
                onCloseBtn: showDistributionUpload
            }),
            statementView ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1dbcb5edfc74bab$export$2e2bcd8739ae039), {
                show: statementView,
                modalClose: handleShow,
                statementPdf: "test"
            }) : "",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `EOICardWrap ${showUploadCredit ? "active" : "hide-card"}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd5144e694c88f5a$export$2e2bcd8739ae039), {
                    show: showUploadCredit,
                    onCloseBtn: showDistributionCredit
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "tw-mb-6",
                children: "Distribution dashboard"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-w-full tw-space-x-6 tw-max-w-[1500px]",
                style: {
                    maxWidth: "1584px",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                        extraClasses: "tw-flex tw-w-[340px] tw-flex-col tw-bg-surfaceBlack90 tw-text-white tw-p-6 tw-rounded-3 tw-rounded-xl tw-mt-0",
                        // style={{ minWidth: '302px' }}
                        disabled: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-uppercase tw-text-sm",
                                children: "Income paid out"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a6180f04a3e64cf$export$553fd01770b02e7e), {
                                value: registerUsers,
                                text: "of income cleared"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-text-right",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    className: "viewLink",
                                    children: "View"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                        disabled: true,
                        extraClasses: "tw-flex tw-flex-col tw-align-bottom tw-bg-surfaceBlack90 tw-text-white tw-p-4 tw-rounded-xl tw-flex-grow tw-overflow-scroll tw-mt-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-uppercase tw-text-sm tw-pb-2",
                                children: "WMC Income"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-overflow-x-scroll tw-flex-grow tw-w-full",
                                style: {},
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $662f9e853a36449a$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-uppercase tw-text-2xl tw-text-white tw-mt-8 tw-mb-8 tw-uppercase",
                children: "Tasks"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
                disabled: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$e2595d8541f6e8ef), {
                    columns: [
                        {
                            title: "Artist",
                            dataKey: "artist"
                        },
                        {
                            title: "Action",
                            dataKey: "action"
                        },
                        {
                            title: "Date Added",
                            dataKey: "dateCreated"
                        },
                        {
                            title: "Status",
                            dataKey: "status"
                        }
                    ],
                    data: tableData
                })
            })
        ]
    });
}
var $20f6fe0e2d8be51b$export$2e2bcd8739ae039 = $20f6fe0e2d8be51b$var$DistributionDetails;




function $5de1eb2efd64c48e$var$Distribution() {
    const [sidebarSmall, setSidebarSmall] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7950a72521dfb882$export$5d91bb6ce8e0f47), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f6fe0e2d8be51b$export$2e2bcd8739ae039), {})
        })
    });
}
var $5de1eb2efd64c48e$export$2e2bcd8739ae039 = $5de1eb2efd64c48e$var$Distribution;




var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");


function $333ea6f8c882b24a$var$SocietyFormModal({ isOpen: isOpen, onClose: onClose, isLoading: isLoading, setIsLoading: setIsLoading, title: title, sessionId: sessionId, onComplete: onComplete }) {
    const [isCompleted, setIsCompleted] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setIsCompleted(false);
    }, [
        isOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleMessage = (event)=>{
            const payload = event.data && event.data.payload;
            const type = event.data && event.data.type;
            switch(type){
                case "session_view.document.loaded":
                    if (isLoading) setIsLoading(false);
                    break;
                case "session_view.document.completed":
                    if (payload && payload.uuid) {
                        if (onComplete && !isCompleted) {
                            setIsCompleted(true);
                            onComplete();
                        }
                    }
                    break;
            }
        };
        // pandadocs iframe event message listeners
        // https://developers.pandadoc.com/reference/embed-a-document#embedded-document-javascript-events
        window.addEventListener("message", handleMessage);
        // Cleanup the event listener on component unmount
        return ()=>{
            window.removeEventListener("message", handleMessage);
        };
    }, [
        isLoading,
        isCompleted,
        onComplete
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: onClose,
        title: title,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-w-[70vw] tw-h-[75vh]",
            children: [
                isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-center tw-min-h-[75vh]",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-my-auto tw-animate-ping",
                            children: "\u26AA"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: isLoading ? "tw-hidden" : "",
                    children: sessionId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccc269c1cbba2785$export$2e2bcd8739ae039), {
                            title: title,
                            documentId: sessionId
                        })
                    })
                })
            ]
        })
    });
}
var $333ea6f8c882b24a$export$2e2bcd8739ae039 = $333ea6f8c882b24a$var$SocietyFormModal;




parcelRequire("acw62");


const $7c5e3bb6e84fbc57$var$ClientDetailsCard = ({ photo: photo, name: name, address: address, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: " tw-flex tw-flex-row tw-items-end tw-bg-surfaceBlack90 tw-text-sm tw-text-textWhite tw-rounded-lg tw-p-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: photo || (0, (/*@__PURE__*/$parcel$interopDefault($c0b087292c3026cb$exports))),
                alt: "Client",
                className: "tw-w-12 tw-h-12 tw-rounded-full"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-pr-2 tw-pl-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-font-medium tw-text-xs tw-pb-1",
                        children: "DETAILS"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "tw-text-textDove tw-text-normal tw-pb-1",
                        children: [
                            name,
                            ", ",
                            address
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                variant: "link-secondary",
                label: "View more",
                onClick: onClick,
                extraClasses: "tw-text-xs tw-pt-0.5"
            })
        ]
    });
};
var $7c5e3bb6e84fbc57$export$2e2bcd8739ae039 = $7c5e3bb6e84fbc57$var$ClientDetailsCard;





parcelRequire("acw62");

parcelRequire("acw62");

const $f7b3250b317787cf$var$ClientDetailsRow = ({ label: label, data: data, copy: copy = true, link: link = "" })=>{
    const handleCopyToClipboard = (data)=>{
        navigator.clipboard.writeText(data).catch((err)=>{
            console.error("Failed to copy text: ", err);
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-text-base tw-pt-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-pb-1 tw-text-textWhite",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-items-center tw-justify-between tw-text-textDove tw-border-b tw-border-outlineGraphite tw-pb-2",
                children: [
                    link ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: "tw-underline",
                        href: link,
                        target: "_blank",
                        rel: "noreferrer",
                        children: data ? data : `Filename for ${label} missing`
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: data ? data : "\xa0"
                    }),
                    copy && data && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        variant: "link-secondary",
                        label: "Copy",
                        onClick: ()=>handleCopyToClipboard(data),
                        extraClasses: "tw-text-sm"
                    })
                ]
            })
        ]
    });
};
var $f7b3250b317787cf$export$2e2bcd8739ae039 = $f7b3250b317787cf$var$ClientDetailsRow;



const $e66de57366146505$var$ClientDetails = ({ photo: photo, data: data })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-items-center tw-flex-row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-text-2xl tw-pr-4",
                        children: "Artist Details"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: photo || (0, (/*@__PURE__*/$parcel$interopDefault($c0b087292c3026cb$exports))),
                        alt: "Client",
                        className: "tw-rounded-full tw-w-12 tw-h-12"
                    })
                ]
            }),
            data.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7b3250b317787cf$export$2e2bcd8739ae039), {
                    label: item.label,
                    data: item.data,
                    copy: item.copy,
                    link: item.link
                }, index))
        ]
    });
};
var $e66de57366146505$export$2e2bcd8739ae039 = $e66de57366146505$var$ClientDetails;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $da8c825c5c7a5854$var$WFileUpload = ({ name: name, label: label, subTitle: subTitle = "Drag & drop or click to upload", onFileChange: onFileChange, value: value })=>{
    const fileInputRef = (0, $acw62.useRef)(null);
    const handleFileChange = (event)=>{
        if (event.target.files === null) return;
        const fileName = event.target.files[0].name;
        const fileUrl = URL.createObjectURL(event.target.files?.[0]);
        const file = event.target.files?.[0];
        setInnerValue({
            file: file,
            fileName: fileName,
            fileUrl: fileUrl
        });
        onFileChange(event);
    };
    const handleClick = ()=>{
        fileInputRef.current?.click();
    };
    (0, $acw62.useEffect)(()=>{
        if (value != undefined && innerValue == undefined) {
            if (typeof value === "object" && typeof value?.name === "string" && typeof value?.size === "number") {
                const file = value;
                const fileName = value.name;
                const fileUrl = URL.createObjectURL(file);
                setInnerValue({
                    file: file,
                    fileName: fileName,
                    fileUrl: fileUrl
                });
            } else if (value.hasOwnProperty("fileName") && value.hasOwnProperty("fileUrl")) setInnerValue({
                fileName: value.fileName,
                fileUrl: value.fileUrl,
                file: undefined
            });
        }
    }, [
        value
    ]);
    const [innerValue, setInnerValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const { isEditing: isEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-mb-4 tw-flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-block tw-leading-4 tw-mb-2", {
                    "tw-text-[14px]": !isEditing,
                    "tw-text-white": !errors[name],
                    "tw-text-formOutlineErrorRed": errors[name]
                }),
                htmlFor: "",
                children: label
            }),
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-text-textDove tw-text-sm",
                children: [
                    innerValue != undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        target: "_blank",
                        href: innerValue?.fileUrl,
                        children: innerValue?.fileName || "-"
                    }),
                    innerValue == undefined && "-"
                ]
            }),
            isEditing && innerValue != undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "tw-underline tw-flex tw-space-x-2 tw-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        target: "_blank",
                        href: innerValue.fileUrl,
                        children: innerValue.fileName
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "wi wi-xs wi-close tw-cursor-pointer",
                        onClick: ()=>{
                            setInnerValue(undefined);
                        }
                    })
                ]
            }),
            isEditing && innerValue == undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-relative tw-border-dashed tw-border-2  tw-rounded tw-p-6 tw-cursor-pointer tw-mb-2", {
                        "tw-border-textGraphite": !errors[name]
                    }, {
                        "tw-border-formOutlineErrorRed": errors[name]
                    }),
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-text-center tw-font-light",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "",
                                children: subTitle
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-mb-4 tw-flex tw-justify-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi wi-lg wi-export"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            ref: fileInputRef,
                            type: "file",
                            name: name,
                            className: "tw-hidden",
                            onChange: (e)=>{
                                handleFileChange(e);
                            }
                        })
                    ]
                })
            }),
            isEditing && errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-text-formOutlineErrorRed tw-text-xs",
                children: errors[name]
            })
        ]
    });
};
var $da8c825c5c7a5854$export$2e2bcd8739ae039 = $da8c825c5c7a5854$var$WFileUpload;




const $a299b74cbba0d268$var$FormUpload = ({ upload: upload, initialFormData: initialFormData, onSuccess: onSuccess })=>{
    const [formData, setFormData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initialFormData);
    const onFileChange = (event)=>{
        if (event === null) return;
        if (!event.target.value) return;
        if (event.target.files === null) return;
        if (event.target.value) setFormData({
            ...formData,
            file: event.target.files[0]
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-flex-col tw-text-sm tw-text-textWhite tw-w-[500px]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            schema: undefined,
            handleSubmit: upload,
            editByDefault: true,
            formData: formData,
            onSuccess: onSuccess,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                    label: "Upload Physically Signed Form",
                    name: "uploadForm",
                    subTitle: "Drag & drop or click to upload",
                    onFileChange: (event)=>{
                        onFileChange(event);
                    },
                    value: undefined
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a299b74cbba0d268$var$FormUploadFooter, {})
            ]
        })
    });
};
var $a299b74cbba0d268$export$2e2bcd8739ae039 = $a299b74cbba0d268$var$FormUpload;
function $a299b74cbba0d268$var$FormUploadFooter() {
    const { handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const [isSubmitting, setIsSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            label: "Upload",
            variant: "primary",
            onClick: ()=>{
                setIsSubmitting(true);
                handleFormSubmit(formData);
                // set isSubmitting to false again in case of error
                setIsSubmitting(false);
            },
            disabled: isSubmitting
        })
    });
}



parcelRequire("acw62");


const $86dce93aea4012b4$var$modalTitle = "Is the Society Webform Complete?";
const $86dce93aea4012b4$var$modalDescription = "Did you successfully complete all the forms required through this society portal?";
const $86dce93aea4012b4$export$fbb9f58feb1a9096 = ({ onClose: onClose, onComplete: onComplete, title: title = $86dce93aea4012b4$var$modalTitle, description: description = $86dce93aea4012b4$var$modalDescription })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-w-[450px] tw-flex tw-flex-col tw-pb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-text-2xl tw-pb-4 stw-font-medium",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-pt-2 tw-text-base tw-font-normal",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        onClick: onComplete,
                        label: "Complete",
                        variant: "primary",
                        extraClasses: "tw-mr-4"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        label: "Not yet",
                        variant: "link-secondary"
                    })
                ]
            })
        ]
    });
};
var $86dce93aea4012b4$export$2e2bcd8739ae039 = $86dce93aea4012b4$export$fbb9f58feb1a9096;



function $44c8b82f2381591f$var$SocietyForms() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const data = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const taskId = data.state?.taskId ? data.state.taskId : undefined;
    const [societyList, setSocietyList] = (0, $acw62.useState)([]);
    const { userId: userId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [digitalTableData, setDigitalTableData] = (0, $acw62.useState)([]);
    const [physicalTableData, setPhysicalTableData] = (0, $acw62.useState)([]);
    const [portalTableData, setPortalTableData] = (0, $acw62.useState)([]);
    const [digitalTaxFormsData, setDigitalTaxFormsData] = (0, $acw62.useState)([]);
    const [physicalTaxFormsData, setPhysicalTaxFormsData] = (0, $acw62.useState)([]);
    const [membershipForms, setMembershipForms] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [societyFormsModalIsOpen, setSocietyFormsModalIsOpen] = (0, $acw62.useState)(false);
    const [sessionId, setSessionId] = (0, $acw62.useState)(undefined);
    const [modalTitle, setModalTitle] = (0, $acw62.useState)("");
    const [successModalIsOpen, setSuccessModalIsOpen] = (0, $acw62.useState)(false);
    const [onComplete, setOnComplete] = (0, $acw62.useState)(undefined);
    const [userSettings, setUserSettings] = (0, $acw62.useState)(undefined);
    const [SuccessfulBlockTitle, setSuccessfulBlockTitle] = (0, $acw62.useState)("");
    const [SuccessfulBlockDescription, setSuccessfulBlockDescription] = (0, $acw62.useState)("");
    const [artistDetailsSidebarIsOpen, setArtistDetailsSidebarIsOpen] = (0, $acw62.useState)(false);
    const [clientDetailsData, setClientDetailsData] = (0, $acw62.useState)([]);
    const [userIdUrl, setUserIdUrl] = (0, $acw62.useState)({
        fileName: "",
        fileUrl: ""
    });
    const [userPoaUrl, setUserPoaUrl] = (0, $acw62.useState)({
        fileName: "",
        fileUrl: ""
    });
    const [formUploadIsOpen, setFormUploadIsOpen] = (0, $acw62.useState)(false);
    const [openWebformCompleteModal, setOpenWebformCompleteModal] = (0, $acw62.useState)(false);
    const [webformCompleteModalIsOpen, setWebformCompleteModalIsOpen] = (0, $acw62.useState)(false);
    const [societyPortalTasks, setSocietyPortalTasks] = (0, $acw62.useState)([]);
    const [allFormsComplete, setAllFormsComplete] = (0, $acw62.useState)(false);
    const rowStyle = {
        borderBottom: "1px solid #505050"
    };
    const columns = [
        {
            title: "Form name",
            dataKey: "formName",
            width: "2fr"
        },
        {
            title: "Society",
            dataKey: "society",
            width: "2fr"
        },
        {
            title: "Territory",
            dataKey: "territory",
            width: "2fr"
        },
        {
            title: "Signed by",
            dataKey: "signedBy",
            width: "2fr"
        },
        {
            title: "",
            dataKey: "withClient",
            width: "1fr"
        },
        {
            title: "",
            dataKey: "cta",
            width: "1fr"
        }
    ];
    const portalColumns = [
        {
            title: "Society",
            dataKey: "society",
            width: "2fr"
        },
        {
            title: "Territory",
            dataKey: "territory",
            width: "2fr"
        },
        {
            title: "",
            dataKey: "cta",
            width: "1fr"
        }
    ];
    const [completePortalTaskFunc, setCompletePortalTaskFunc] = (0, $acw62.useState)(()=>{});
    const fetchData = async ()=>{
        if (userId === undefined) return;
        try {
            let membershipForms = await api.listMembershipForms({
                userId: userId
            });
            let societiesData = await api.listAdminSocieties();
            let termsOfAgreementData = await api.retrieveTermsOfAgreement({
                userId: userId
            });
            if (!termsOfAgreementData.universalMandate) societiesData = societiesData.filter((society)=>{
                return termsOfAgreementData?.mandatedSocieties?.includes(society.id ?? "");
            });
            setMembershipForms(membershipForms);
            setSocietyList(societiesData);
            let userSettingsData = await api.retrieveUserSettings({
                userId: userId
            });
            setUserSettings(userSettingsData);
            let passportResult = await api.retrieveLatestAdminIdentityDocumentSubmission({
                userId: userId,
                documentType: "Passport"
            });
            setUserIdUrl({
                fileName: passportResult.filename ?? "",
                fileUrl: passportResult.fileUrl ?? ""
            });
            let poaResult = await api.retrieveLatestAdminIdentityDocumentSubmission({
                userId: userId,
                documentType: "Power_Of_Attorney"
            });
            setUserPoaUrl({
                fileName: poaResult.filename ?? "",
                fileUrl: poaResult.fileUrl ?? ""
            });
            let portalTasks = await api.listSocietyPortalTasks({
                userId: userId
            });
            setSocietyPortalTasks(portalTasks);
        } catch (err) {
            console.log("Error retrieving data", err);
            return;
        }
    };
    const renderPandadocDocument = async (societyFormSubroleId, adminSocietyFormTaskId, sessionId, complete = false, signedBy, signature)=>{
        setSocietyFormsModalIsOpen(true);
        setIsLoading(true);
        let sessionIdInner = sessionId;
        if (sessionIdInner === undefined || sessionIdInner === null) {
            sessionIdInner = await createPandadocDocument(societyFormSubroleId, adminSocietyFormTaskId);
            if (sessionIdInner === undefined) return;
        }
        if (!complete) {
            setOnComplete(()=>()=>{
                    completePandadocDocument(societyFormSubroleId, adminSocietyFormTaskId, signature);
                });
            switch(signedBy){
                case (0, $efe484b832d95e72$export$b2ac61b2aa882589).Admin:
                    setSuccessfulBlockTitle("Form Signed");
                    setSuccessfulBlockDescription("Thank you for signing this form. Don\u2019t forget to sign all forms for this client to process their registration for each society.");
                    break;
                default:
                    setSuccessfulBlockTitle("Sent to Client");
                    setSuccessfulBlockDescription("The form has been successfully forwarded to the client\u2019s portal. They will be able to log in and sign this form digitally.");
                    break;
            }
        } else setOnComplete(undefined);
        setSessionId(sessionIdInner);
    };
    const createPandadocDocument = async (societyFormSubroleId, adminSocietyFormTaskId)=>{
        try {
            let pandadocDocumentIdsData = await api.createPandadocDocumentIds({
                pandadocDocumentIds: {
                    userId: userId,
                    email: userSettings?.emailAddress ?? "missing",
                    adminSocietyFormTaskId: adminSocietyFormTaskId,
                    societyFormSubroleId: societyFormSubroleId
                }
            });
            if (pandadocDocumentIdsData === undefined || pandadocDocumentIdsData.documents === undefined || // check if any sessionId is undefined for sessionId in pandadocDocumentIdsData.documents
            pandadocDocumentIdsData.documents?.some((document)=>document.sessionId === null)) {
                console.log("Error retrieving pandadoc document ids");
                closeSocietyFormsModal();
                return;
            }
            return pandadocDocumentIdsData.documents[0].sessionId;
        } catch (err) {
            console.log("Error retrieving pandadoc document ids", err);
            closeSocietyFormsModal();
        }
    };
    const completePandadocDocument = async (societyFormSubroleId, adminSocietyFormTaskId, signature)=>{
        try {
            setIsLoading(true);
            let responseData = await api.adminSignSignMembershipForms({
                formId: adminSocietyFormTaskId,
                signMembershipForms: {
                    societyFormSubRoleId: societyFormSubroleId,
                    user: userId,
                    societyForm: ""
                }
            });
            let membershipFormsInner = membershipForms;
            setMembershipForms(membershipFormsInner.map((membershipForm)=>{
                return membershipForm.id === adminSocietyFormTaskId ? responseData : membershipForm;
            }));
            if (signature === (0, $efe484b832d95e72$export$bebbe8f42e79a1f0).Physical) {
                setIsLoading(false);
                return;
            }
            closeSocietyFormsModal();
            setSuccessModalIsOpen(true);
        } catch (err) {
            console.log("error completing form", err);
        }
    };
    const closeSocietyFormsModal = ()=>{
        setSocietyFormsModalIsOpen(false);
        setIsLoading(false);
        setSessionId(undefined);
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    const checkAllFormsComplete = ()=>{
        if (membershipForms.length === 0) return;
        let allFormsComplete = true;
        membershipForms.forEach((membershipForm)=>{
            if (membershipForm.complete === false || membershipForm.status === (0, $33ff94992968ec35$export$966c6b48709962b0).ClientToSign || membershipForm.status === (0, $33ff94992968ec35$export$966c6b48709962b0).WithClient) allFormsComplete = false;
        });
        societyPortalTasks.forEach((task)=>{
            if (task.complete === false) allFormsComplete = false;
        });
        setAllFormsComplete(allFormsComplete);
    };
    (0, $acw62.useEffect)(()=>{
        if (societyList.length === 0) return;
        checkAllFormsComplete();
        const digitalFormData = [];
        const physicalFormData = [];
        const portalFormData = [];
        const digitalTaxFormData = [];
        const physicalTaxFormData = [];
        societyList.forEach((society)=>{
            // @ts-ignore - CLI tool thinks that roleForms is a string, not SocietyFormRole[]
            society.roleForms?.forEach((role)=>{
                role.forms?.forEach((form)=>{
                    const formName = society.societyForms.find((societyForm)=>societyForm.id === form.form)?.readableName || "";
                    const membershipForm = membershipForms.find((membershipForm)=>membershipForm.societyForm === form.form);
                    // only add to table if there's a corresponding membership form
                    if (membershipForm) {
                        let data = {
                            formName: formName,
                            society: society.readableName ?? "",
                            territory: society.country ?? "",
                            withClient: membershipForm?.status === (0, $33ff94992968ec35$export$966c6b48709962b0).ClientToSign || membershipForm?.status === (0, $33ff94992968ec35$export$966c6b48709962b0).WithClient ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    color: "black",
                                    whiteSpace: "nowrap"
                                },
                                className: "tw-bg-surfaceBlue",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "WITH CLIENT"
                                })
                            }) : "",
                            // @ts-ignore - signed_by isn't correctly converted to expected camelCase attribute
                            signedBy: form.signed_by ?? "",
                            cta: buildCta(form, membershipForm, formName)
                        };
                        if (form.signature === (0, $efe484b832d95e72$export$bebbe8f42e79a1f0).Digital) digitalFormData.push(data);
                        else if (form.signature === (0, $efe484b832d95e72$export$bebbe8f42e79a1f0).Physical) physicalFormData.push(data);
                    }
                });
            });
            if (society.formPortal && society.formPortal !== "") {
                // find societyportaltask with society id matching society.id
                let societyPortalTask = societyPortalTasks.find((task)=>task.society === society.id);
                // if task, push to portalFormData
                if (societyPortalTask !== undefined) {
                    const complete = societyPortalTask.status === "complete";
                    let portalData = {
                        formName: "",
                        society: society.readableName ?? "",
                        territory: society.country ?? "",
                        signedBy: "",
                        withClient: "",
                        cta: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-w-full",
                            children: [
                                complete && completedTick(),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    label: "Go to portal",
                                    onClick: ()=>{
                                        society.formPortal && openPortal(society.formPortal, societyPortalTask?.id ?? "", society.id ?? "");
                                    }
                                })
                            ]
                        })
                    };
                    portalFormData.push(portalData);
                }
            }
            // @ts-ignore - CLI tool thinks that taxForms is a string, not TaxFormRole[]
            society.taxForms?.forEach((taxForm)=>{
                // find membership form with societyForm matching taxForm.form
                let membershipForm = membershipForms.find((membershipForm)=>membershipForm.societyForm === taxForm.form);
                const formName = society.societyForms.find((societyForm)=>societyForm.id === taxForm.form)?.readableName || "";
                if (membershipForm) {
                    let data = {
                        formName: formName,
                        society: society.readableName ?? "",
                        territory: society.country ?? "",
                        withClient: membershipForm?.status === "client_to_sign" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                color: "black",
                                whiteSpace: "nowrap"
                            },
                            className: "tw-bg-surfaceBlue",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "WITH CLIENT"
                            })
                        }) : "",
                        // @ts-ignore - signed_by isn't correctly converted to expected camelCase attribute
                        signedBy: taxForm.signed_by ?? "",
                        cta: buildCta(taxForm, membershipForm, formName)
                    };
                    if (taxForm.signature === (0, $efe484b832d95e72$export$bebbe8f42e79a1f0).Digital) digitalTaxFormData.push(data);
                    else if (taxForm.signature === (0, $efe484b832d95e72$export$bebbe8f42e79a1f0).Physical) physicalTaxFormData.push(data);
                }
            });
        });
        setDigitalTableData(digitalFormData);
        setPhysicalTableData(physicalFormData);
        setPortalTableData(portalFormData);
        setDigitalTaxFormsData(digitalTaxFormData);
        setPhysicalTaxFormsData(physicalTaxFormData);
    }, [
        societyList,
        membershipForms,
        userSettings,
        societyPortalTasks
    ]);
    const completedTick = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
            style: {
                backgroundColor: "#6EE038"
            },
            className: `wi-sm wi-circle-check tw-mr-2 tw-mt-1`
        });
    };
    const buildCta = (form, membershipForm, formName)=>{
        const membershipFormId = membershipForm?.id;
        const sessionId = membershipForm?.pandadocsSessionId;
        const adminCompleted = membershipForm?.complete || membershipForm?.status !== (0, $33ff94992968ec35$export$966c6b48709962b0).AdminToSign;
        const withClient = membershipForm?.status === (0, $33ff94992968ec35$export$966c6b48709962b0).ClientToSign || membershipForm?.status === (0, $33ff94992968ec35$export$966c6b48709962b0).WithClient;
        const classNames = `tw-justify-end ${adminCompleted ? " tw-mr-8" : ""}`;
        const uploaded = membershipForm?.status !== "awaiting_upload";
        switch(form.signature){
            case (0, $efe484b832d95e72$export$bebbe8f42e79a1f0).Digital:
                const signText = // @ts-ignore - signed_by isn't correctly converted to expected camelCase attribute
                form.signed_by === (0, $efe484b832d95e72$export$b2ac61b2aa882589).Client ? "View & Send" : "View & Sign";
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `tw-flex tw-w-full ${classNames}`,
                    children: [
                        adminCompleted && !withClient && completedTick(),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: adminCompleted ? "link-secondary" : "secondary",
                            label: adminCompleted ? "View" : signText,
                            onClick: ()=>{
                                setModalTitle(formName);
                                renderPandadocDocument(form.id, membershipFormId, sessionId, adminCompleted, // @ts-ignore - signed_by isn't correctly converted to expected camelCase attribute
                                form.signed_by, form.signature);
                            }
                        })
                    ]
                });
            case (0, $efe484b832d95e72$export$bebbe8f42e79a1f0).Physical:
                let awaitingUpload = membershipForm?.status === (0, $33ff94992968ec35$export$966c6b48709962b0).AwaitingUpload;
                const onClick = adminCompleted && !awaitingUpload ? ()=>{
                    // download membership form from presigned url
                    window.open(membershipForm?.url, "_blank");
                } : ()=>{
                    setModalTitle(formName);
                    renderPandadocDocument(form.id, membershipFormId, sessionId, adminCompleted, // @ts-ignore - signed_by isn't correctly converted to expected camelCase attribute
                    form.signed_by, form.signature);
                };
                const viewButtonText = adminCompleted && !awaitingUpload ? "Download" : "View";
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `tw-flex tw-justify-end tw-w-full ${adminCompleted && !awaitingUpload ? "tw-mr-4" : "tw-mr-8"}`,
                    children: [
                        awaitingUpload && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "link-secondary",
                            label: "Upload",
                            onClick: ()=>{
                                setFormData({
                                    formId: membershipForm?.id ?? "",
                                    societyFormSubRoleId: form.id ?? "",
                                    user: userId,
                                    societyForm: form.form ?? "",
                                    file: undefined
                                });
                                setFormUploadIsOpen(true);
                            },
                            extraClasses: "tw-mr-4"
                        }),
                        adminCompleted && uploaded && completedTick(),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "link-secondary",
                            label: viewButtonText,
                            onClick: onClick
                        })
                    ]
                });
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (userSettings === undefined) return;
        let userSettingsData = [
            {
                label: "Title",
                data: userSettings?.title ?? "",
                copy: false
            },
            {
                label: "First Name",
                data: userSettings?.firstName ?? ""
            },
            {
                label: "Middle Name",
                data: userSettings?.middleName ?? ""
            },
            {
                label: "Last Name",
                data: userSettings?.lastName ?? ""
            },
            {
                label: "Aliases",
                data: userSettings?.aliases?.join(", ") ?? ""
            },
            {
                label: "Date of Birth",
                data: userSettings?.dateOfBirth?.toLocaleDateString() ?? "",
                copy: false
            },
            {
                label: "Gender",
                data: userSettings?.gender ?? "",
                copy: false
            },
            {
                label: "Nationality",
                data: userSettings?.nationality ?? "",
                copy: false
            },
            {
                label: "City of Birth",
                data: userSettings?.cityOfBirth ?? ""
            },
            {
                label: "Country of Birth",
                data: userSettings?.countryOfBirth ?? ""
            },
            {
                label: "Email",
                data: userSettings?.emailAddress ?? ""
            },
            {
                label: "Phone Number",
                data: userSettings?.phoneNumber ?? ""
            },
            {
                label: "Street Address of Residence",
                data: userSettings?.streetAddress ?? ""
            },
            {
                label: "County/State of Residence",
                data: userSettings?.county ?? ""
            },
            {
                label: "Zip/Postcode of Residence",
                data: userSettings?.postcode ?? ""
            },
            {
                label: "Country of Residence",
                data: userSettings?.country ?? ""
            },
            {
                label: "Country of Taxation",
                data: userSettings?.taxationCountry ?? ""
            },
            {
                label: "VAT Number",
                data: userSettings?.vatNumber ?? ""
            },
            {
                label: "Tax ID Type",
                data: userSettings?.taxIdType ?? ""
            },
            {
                label: "Tax ID Number",
                data: userSettings?.taxIdNumber ?? ""
            },
            {
                label: "ID",
                data: userIdUrl.fileName ?? "",
                copy: false,
                link: userIdUrl.fileUrl ?? ""
            },
            {
                label: "Power of Attorney",
                data: userPoaUrl.fileName ?? "",
                copy: false,
                link: userPoaUrl.fileUrl ?? ""
            }
        ];
        setClientDetailsData(userSettingsData);
    }, [
        userSettings,
        userIdUrl,
        userPoaUrl
    ]);
    const emptyFormState = {
        formId: "",
        societyFormSubRoleId: "",
        user: userId,
        societyForm: "",
        file: undefined
    };
    const [formData, setFormData] = (0, $acw62.useState)(emptyFormState);
    const uploadForm = async (isValid, data)=>{
        if (data === undefined || data.file === undefined || data.user === undefined) return Promise.reject("data, file or user is undefined");
        const response = api.adminUploadUploadMembershipForms({
            formId: data.formId ?? "",
            societyFormSubRoleId: data.societyFormSubRoleId ?? "",
            user: data.user,
            societyForm: data.societyForm ?? "",
            file: data.file
        }).then((responseData)=>{
            setMembershipForms(membershipForms.map((membershipForm)=>{
                return membershipForm.id === responseData.id ? responseData : membershipForm;
            }));
            return Promise.resolve(responseData);
        }).catch((error)=>{
            return Promise.reject(error);
        });
        return response;
    };
    const onSuccess = ()=>{
        setFormUploadIsOpen(false);
        setSuccessModalIsOpen(true);
        setSuccessfulBlockTitle("Form Uploaded");
        setSuccessfulBlockDescription("The form has been successfully uploaded to the portal and will be available to view under each the \u2018Documents\u2019 tab in the \u2018Single Artist Page\u2019.");
    };
    const openPortal = (url, taskId, societyId)=>{
        if (url === "" || url === undefined) {
            console.error("url is empty");
            return;
        }
        setArtistDetailsSidebarIsOpen(true);
        setOpenWebformCompleteModal(true);
        setCompletePortalTaskFunc(()=>()=>{
                completePortalTask(taskId, societyId);
            });
        window.open(url, "_blank");
    };
    const closeWebformCompleteModal = ()=>{
        setOpenWebformCompleteModal(false);
        setWebformCompleteModalIsOpen(false);
    };
    const closeClientDetailsSidebar = ()=>{
        setArtistDetailsSidebarIsOpen(false);
        if (openWebformCompleteModal) setWebformCompleteModalIsOpen(true);
    };
    const completePortalTask = async (taskId, societyId)=>{
        try {
            let response = await api.adminCompleteSocietyPortalTasks({
                taskId: taskId,
                societyPortalTasks: {
                    user: userId,
                    society: societyId
                }
            });
            setSocietyPortalTasks(societyPortalTasks.map((task)=>{
                return task.id === taskId ? response : task;
            }));
            closeWebformCompleteModal();
        } catch (err) {
            console.log("error completing portal task", err);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d96ba216e256194$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-col  tw-justify-between text-white",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "tw-pb-4",
                        children: "Forms"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-pb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "link-secondary",
                            icon: "chevron-left",
                            label: "Back",
                            onClick: ()=>navigate("/dashboard")
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-items-end tw-justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-pt-2 tw-text-xl",
                                children: "Society Forms"
                            }),
                            userSettings && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c5e3bb6e84fbc57$export$2e2bcd8739ae039), {
                                photo: userSettings?.userPhotoUrl ?? "",
                                name: `${userSettings?.firstName ?? ""} ${userSettings?.lastName ?? ""}`,
                                address: `${userSettings?.streetAddress ?? ""}, ${userSettings?.county ?? ""}, ${userSettings?.postcode ?? ""}`,
                                onClick: ()=>setArtistDetailsSidebarIsOpen(true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                        title: "Digital",
                        isOpen: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
                            rowStyle: digitalTableData.map(()=>rowStyle),
                            columns: columns,
                            data: digitalTableData
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                        title: "Physical",
                        isOpen: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
                            rowStyle: physicalTableData.map(()=>rowStyle),
                            columns: columns,
                            data: physicalTableData
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                        title: "Society Portal",
                        isOpen: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
                            rowStyle: portalTableData.map(()=>rowStyle),
                            columns: portalColumns,
                            data: portalTableData
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-pt-2 tw-text-xl",
                        children: "Tax Forms"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                        title: "Digital",
                        isOpen: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
                            rowStyle: digitalTaxFormsData.map(()=>rowStyle),
                            columns: columns,
                            data: digitalTaxFormsData
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                        title: "Physical",
                        isOpen: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
                            rowStyle: physicalTaxFormsData.map(()=>rowStyle),
                            columns: columns,
                            data: physicalTaxFormsData
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $333ea6f8c882b24a$export$2e2bcd8739ae039), {
                isOpen: societyFormsModalIsOpen,
                onClose: closeSocietyFormsModal,
                isLoading: isLoading,
                setIsLoading: setIsLoading,
                title: modalTitle,
                sessionId: sessionId,
                onComplete: onComplete
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: successModalIsOpen,
                onClose: ()=>{
                    setSuccessModalIsOpen(false);
                },
                title: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
                    title: "Form Signed",
                    description: "Thank you for signing this form. Don\u2019t forget to sign all forms for this client to process their registration for each society."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cc827972f01625b6$export$8ba061c9afd04389), {
                isOpen: artistDetailsSidebarIsOpen,
                cardEvent: ()=>{
                    closeClientDetailsSidebar();
                },
                title: "",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e66de57366146505$export$2e2bcd8739ae039), {
                            photo: userSettings?.userPhotoUrl ?? "",
                            data: clientDetailsData
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc827972f01625b6$export$3d28cc639c274ad6), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            variant: "primary",
                            label: "Close",
                            onClick: ()=>{
                                closeClientDetailsSidebar();
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: formUploadIsOpen,
                onClose: ()=>{
                    setFormUploadIsOpen(false);
                },
                title: "Upload Document",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a299b74cbba0d268$export$2e2bcd8739ae039), {
                    upload: uploadForm,
                    initialFormData: formData,
                    onSuccess: onSuccess
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: webformCompleteModalIsOpen,
                onClose: ()=>{
                    closeWebformCompleteModal();
                },
                title: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86dce93aea4012b4$export$2e2bcd8739ae039), {
                    onClose: ()=>{
                        closeWebformCompleteModal();
                    },
                    onComplete: completePortalTaskFunc
                })
            }),
            allFormsComplete && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-mt-6 tw-flex tw-justify-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "primary",
                    label: "All Forms Complete",
                    onClick: async ()=>{
                        if (taskId !== undefined) await api.destroyAdminTaskClient({
                            taskId: taskId
                        });
                        navigate("/dashboard");
                    }
                })
            })
        ]
    });
}
var $44c8b82f2381591f$export$2e2bcd8739ae039 = $44c8b82f2381591f$var$SocietyForms;


/* eslint-disable jsx-a11y/label-has-associated-control */ 

var $acw62 = parcelRequire("acw62");


// ── Shared Components ──
function $6101b280ed6ed360$var$StatusBadge({ method: method, path: path }) {
    const color = method === "GET" ? "tw-bg-blue-500/20 tw-text-blue-400 tw-border-blue-500/30" : "tw-bg-green-500/20 tw-text-green-400 tw-border-green-500/30";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-items-center tw-gap-2 tw-mb-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `tw-text-[11px] tw-font-bold tw-uppercase tw-px-2 tw-py-0.5 tw-rounded tw-border ${color}`,
                children: method
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                className: "tw-text-gray-400 tw-text-xs tw-font-mono",
                children: path
            })
        ]
    });
}
function $6101b280ed6ed360$var$ResponseBlock({ response: response, error: error, loading: loading }) {
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-mt-3 tw-p-3 tw-rounded tw-bg-gray-800 tw-border tw-border-gray-700 tw-text-gray-400 tw-text-xs tw-font-mono tw-animate-pulse",
        children: "Sending request..."
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-mt-3 tw-p-3 tw-rounded tw-bg-red-900/30 tw-border tw-border-red-700/50 tw-text-red-300 tw-text-xs tw-font-mono tw-whitespace-pre-wrap tw-max-h-48 tw-overflow-y-auto",
        children: error
    });
    if (response !== null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-mt-3 tw-p-3 tw-rounded tw-bg-gray-800 tw-border tw-border-gray-700 tw-text-green-300 tw-text-xs tw-font-mono tw-whitespace-pre-wrap tw-max-h-64 tw-overflow-y-auto",
        children: JSON.stringify(response, null, 2)
    });
    return null;
}
function $6101b280ed6ed360$var$FieldRow({ label: label, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: "tw-text-gray-400 tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-wider",
                children: label
            }),
            children
        ]
    });
}
function $6101b280ed6ed360$var$Input({ value: value, onChange: onChange, placeholder: placeholder, className: className = "" }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        type: "text",
        value: value,
        onChange: (e)=>onChange(e.target.value),
        placeholder: placeholder,
        className: `tw-bg-gray-800 tw-border tw-border-gray-600 tw-rounded tw-px-2.5 tw-py-1.5 tw-text-white tw-text-sm tw-font-mono tw-outline-none focus:tw-border-blue-500 tw-transition-colors ${className}`
    });
}
function $6101b280ed6ed360$var$Select({ value: value, onChange: onChange, options: options }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
        value: value,
        onChange: (e)=>onChange(e.target.value),
        className: "tw-bg-gray-800 tw-border tw-border-gray-600 tw-rounded tw-px-2.5 tw-py-1.5 tw-text-white tw-text-sm tw-font-mono tw-outline-none focus:tw-border-blue-500 tw-transition-colors",
        children: options.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                value: o.value,
                children: o.label
            }, o.value))
    });
}
function $6101b280ed6ed360$var$ExecuteButton({ onClick: onClick, loading: loading }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: onClick,
        disabled: loading,
        className: "tw-bg-blue-600 hover:tw-bg-blue-500 disabled:tw-bg-gray-600 disabled:tw-cursor-not-allowed tw-text-white tw-text-sm tw-font-medium tw-px-4 tw-py-1.5 tw-rounded tw-transition-colors tw-self-end",
        children: loading ? "Executing..." : "Execute"
    });
}
function $6101b280ed6ed360$var$EndpointCard({ title: title, description: description, children: children }) {
    const [expanded, setExpanded] = (0, $acw62.useState)(true);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-border tw-border-gray-700 tw-rounded-lg tw-bg-gray-900/50 tw-overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setExpanded(!expanded),
                className: "tw-w-full tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-3 tw-bg-gray-800/50 hover:tw-bg-gray-800 tw-transition-colors tw-border-b tw-border-gray-700",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-text-left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "tw-text-white tw-font-semibold tw-text-sm",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-text-gray-400 tw-text-xs tw-mt-0.5",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-gray-500 tw-text-lg",
                        children: expanded ? "\u25B2" : "\u25BC"
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-p-5",
                children: children
            })
        ]
    });
}
// ── Global user selector ──
function $6101b280ed6ed360$var$GlobalUserSelector({ users: users, usersLoading: usersLoading, usersError: usersError, selectedUserId: selectedUserId, setSelectedUserId: setSelectedUserId, recordingId: recordingId, setRecordingId: setRecordingId }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-border tw-border-gray-700 tw-rounded-lg tw-bg-gray-900/80 tw-p-5 tw-mb-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "tw-text-white tw-font-semibold tw-text-sm tw-mb-3",
                children: "Request Context"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-gray-500 tw-text-xs tw-mb-4",
                children: "Select a user and recording ID to use across all endpoints below. Only onboarded users with UserSettings will work."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-grid tw-grid-cols-2 tw-gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                        label: "User",
                        children: usersLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-bg-gray-800 tw-border tw-border-gray-600 tw-rounded tw-px-2.5 tw-py-1.5 tw-text-gray-500 tw-text-sm tw-animate-pulse",
                            children: "Loading users..."
                        }) : usersError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-text-red-400 tw-text-xs",
                                    children: usersError
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                    value: selectedUserId,
                                    onChange: setSelectedUserId,
                                    placeholder: "Enter user ID manually"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: selectedUserId,
                            onChange: (e)=>setSelectedUserId(e.target.value),
                            className: "tw-bg-gray-800 tw-border tw-border-gray-600 tw-rounded tw-px-2.5 tw-py-1.5 tw-text-white tw-text-sm tw-font-mono tw-outline-none focus:tw-border-blue-500 tw-transition-colors",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "-- Select a user --"
                                }),
                                users.map((u)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                        value: u.userId ?? "",
                                        children: [
                                            u.fullName || "Unnamed",
                                            " (ID: ",
                                            u.userId,
                                            ")",
                                            u.nonClient ? " [non-client]" : ""
                                        ]
                                    }, u.userId))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                        label: "Parent Recording ID",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                            value: recordingId,
                            onChange: setRecordingId,
                            placeholder: "e.g. rec-abc-123"
                        })
                    })
                ]
            }),
            selectedUserId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-mt-3 tw-flex tw-items-center tw-gap-2 tw-text-xs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-green-500"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "tw-text-gray-400",
                        children: [
                            "Using user",
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white tw-font-mono",
                                children: selectedUserId
                            }),
                            " ",
                            "and recording",
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white tw-font-mono",
                                children: recordingId || "(empty)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $6101b280ed6ed360$var$ContextDisplay({ userId: userId, recordingId: recordingId }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-items-center tw-gap-3 tw-text-[11px] tw-text-gray-500 tw-mb-3 tw-font-mono",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    "user_id= ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-gray-300",
                        children: userId || "?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    "parent_recording_id=",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-gray-300",
                        children: recordingId || "?"
                    })
                ]
            })
        ]
    });
}
// ── 1. Correct Recording Data (4.1.1) ──
function $6101b280ed6ed360$var$CorrectRecordingForm({ userId: userId, recordingId: recordingId }) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [edits, setEdits] = (0, $acw62.useState)([
        {
            op: "edit",
            field: "title",
            value: "Updated Song Title"
        },
        {
            op: "edit",
            field: "duration",
            value: "00:04:32"
        },
        {
            op: "edit",
            field: "is_live",
            value: "false"
        }
    ]);
    const [response, setResponse] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const updateEdit = (idx, key, val)=>{
        setEdits((prev)=>prev.map((e, i)=>i === idx ? {
                    ...e,
                    [key]: val
                } : e));
    };
    const execute = async ()=>{
        setLoading(true);
        setError(null);
        setResponse(null);
        try {
            const result = await api.correctRecordingServiceResponse({
                userId: userId,
                parentRecordingId: recordingId,
                correctRecordingRequest: {
                    edits: edits.map((e)=>({
                            op: e.op,
                            field: e.field,
                            value: e.value === "true" ? true : e.value === "false" ? false : e.value
                        }))
                }
            });
            setResponse(result);
        } catch (err) {
            setError(err?.message || JSON.stringify(err));
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6101b280ed6ed360$var$EndpointCard, {
        title: "4.1.1 Correct Recording Data",
        description: "Update/correct values on an existing recording (title, duration, ISRCs, live flag, version)",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$StatusBadge, {
                method: "POST",
                path: "/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/correct/"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ContextDisplay, {
                        userId: userId,
                        recordingId: recordingId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-border tw-border-gray-700 tw-rounded tw-p-3 tw-space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-items-center tw-justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "tw-text-gray-400 tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-wider",
                                        children: "Edits"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setEdits((prev)=>[
                                                    ...prev,
                                                    {
                                                        op: "edit",
                                                        field: "",
                                                        value: ""
                                                    }
                                                ]),
                                        className: "tw-text-blue-400 tw-text-xs hover:tw-text-blue-300",
                                        children: "+ Add edit"
                                    })
                                ]
                            }),
                            edits.map((edit, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-grid tw-grid-cols-[100px_1fr_1fr_32px] tw-gap-2 tw-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Select, {
                                            value: edit.op,
                                            onChange: (v)=>updateEdit(idx, "op", v),
                                            options: [
                                                {
                                                    value: "edit",
                                                    label: "edit"
                                                },
                                                {
                                                    value: "add",
                                                    label: "add"
                                                },
                                                {
                                                    value: "delete",
                                                    label: "delete"
                                                }
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                            value: edit.field,
                                            onChange: (v)=>updateEdit(idx, "field", v),
                                            placeholder: "field name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                            value: edit.value,
                                            onChange: (v)=>updateEdit(idx, "value", v),
                                            placeholder: "value"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setEdits((prev)=>prev.filter((_, i)=>i !== idx)),
                                            className: "tw-text-gray-500 hover:tw-text-red-400 tw-text-sm tw-transition-colors",
                                            children: "x"
                                        })
                                    ]
                                }, idx))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ExecuteButton, {
                        onClick: execute,
                        loading: loading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ResponseBlock, {
                response: response,
                error: error,
                loading: loading
            })
        ]
    });
}
// ── 2. Change Associated Artists (4.1.3) ──
function $6101b280ed6ed360$var$ChangeArtistsForm({ userId: userId, recordingId: recordingId }) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [edits, setEdits] = (0, $acw62.useState)([
        {
            artistId: "artist-001",
            op: "add",
            featuredStatus: "ofa"
        },
        {
            artistId: "artist-002",
            op: "delete",
            featuredStatus: "nfa"
        }
    ]);
    const [response, setResponse] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const updateEdit = (idx, key, val)=>{
        setEdits((prev)=>prev.map((e, i)=>i === idx ? {
                    ...e,
                    [key]: val
                } : e));
    };
    const execute = async ()=>{
        setLoading(true);
        setError(null);
        setResponse(null);
        try {
            const result = await api.changeArtistsServiceResponse({
                userId: userId,
                parentRecordingId: recordingId,
                changeAssociatedArtistsRequest: {
                    edits: edits.map((e)=>({
                            artistId: e.artistId,
                            op: e.op,
                            featuredStatus: e.featuredStatus
                        }))
                }
            });
            setResponse(result);
        } catch (err) {
            setError(err?.message || JSON.stringify(err));
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6101b280ed6ed360$var$EndpointCard, {
        title: "4.1.3 Change Associated Artists",
        description: "Add/remove existing artists (alias/group) as main artists on a recording",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$StatusBadge, {
                method: "POST",
                path: "/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ContextDisplay, {
                        userId: userId,
                        recordingId: recordingId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-border tw-border-gray-700 tw-rounded tw-p-3 tw-space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-items-center tw-justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "tw-text-gray-400 tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-wider",
                                        children: "Edits"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setEdits((prev)=>[
                                                    ...prev,
                                                    {
                                                        artistId: "",
                                                        op: "add",
                                                        featuredStatus: "ofa"
                                                    }
                                                ]),
                                        className: "tw-text-blue-400 tw-text-xs hover:tw-text-blue-300",
                                        children: "+ Add edit"
                                    })
                                ]
                            }),
                            edits.map((edit, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-grid tw-grid-cols-[1fr_100px_100px_32px] tw-gap-2 tw-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                            value: edit.artistId,
                                            onChange: (v)=>updateEdit(idx, "artistId", v),
                                            placeholder: "artist_id"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Select, {
                                            value: edit.op,
                                            onChange: (v)=>updateEdit(idx, "op", v),
                                            options: [
                                                {
                                                    value: "add",
                                                    label: "add"
                                                },
                                                {
                                                    value: "delete",
                                                    label: "delete"
                                                }
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Select, {
                                            value: edit.featuredStatus,
                                            onChange: (v)=>updateEdit(idx, "featuredStatus", v),
                                            options: [
                                                {
                                                    value: "fa",
                                                    label: "fa"
                                                },
                                                {
                                                    value: "ofa",
                                                    label: "ofa"
                                                },
                                                {
                                                    value: "nfa",
                                                    label: "nfa"
                                                }
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setEdits((prev)=>prev.filter((_, i)=>i !== idx)),
                                            className: "tw-text-gray-500 hover:tw-text-red-400 tw-text-sm tw-transition-colors",
                                            children: "x"
                                        })
                                    ]
                                }, idx))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ExecuteButton, {
                        onClick: execute,
                        loading: loading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ResponseBlock, {
                response: response,
                error: error,
                loading: loading
            })
        ]
    });
}
// ── 3. Manage Contributions (4.2.1) ──
function $6101b280ed6ed360$var$ManageContributionsForm({ userId: userId, recordingId: recordingId }) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [edits, setEdits] = (0, $acw62.useState)([
        {
            op: "add",
            role: "writer",
            personaId: "persona-001",
            dataCategory: "1",
            sourceUrl: "https://example.com/evidence",
            notes: "Confirmed via liner notes"
        },
        {
            op: "edit",
            role: "producer",
            personaId: "",
            dataCategory: "3",
            sourceUrl: "",
            notes: "Category updated"
        }
    ]);
    const [response, setResponse] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const updateEdit = (idx, key, val)=>{
        setEdits((prev)=>prev.map((e, i)=>i === idx ? {
                    ...e,
                    [key]: val
                } : e));
    };
    const execute = async ()=>{
        setLoading(true);
        setError(null);
        setResponse(null);
        try {
            const result = await api.manageContributionsServiceResponse({
                userId: userId,
                parentRecordingId: recordingId,
                manageContributionsRequest: {
                    edits: edits.map((e)=>({
                            op: e.op,
                            role: e.role,
                            personaId: e.personaId || undefined,
                            dataCategory: e.dataCategory || undefined,
                            sourceUrl: e.sourceUrl || undefined,
                            notes: e.notes || undefined
                        }))
                }
            });
            setResponse(result);
        } catch (err) {
            setError(err?.message || JSON.stringify(err));
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6101b280ed6ed360$var$EndpointCard, {
        title: "4.2.1 Manage Contributions",
        description: "Add/delete/edit contributions (role/type) for an alias on a recording",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$StatusBadge, {
                method: "POST",
                path: "/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/contributions/"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ContextDisplay, {
                        userId: userId,
                        recordingId: recordingId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-border tw-border-gray-700 tw-rounded tw-p-3 tw-space-y-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-items-center tw-justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "tw-text-gray-400 tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-wider",
                                        children: "Edits"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setEdits((prev)=>[
                                                    ...prev,
                                                    {
                                                        op: "add",
                                                        role: "",
                                                        personaId: "",
                                                        dataCategory: "5",
                                                        sourceUrl: "",
                                                        notes: ""
                                                    }
                                                ]),
                                        className: "tw-text-blue-400 tw-text-xs hover:tw-text-blue-300",
                                        children: "+ Add edit"
                                    })
                                ]
                            }),
                            edits.map((edit, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-border tw-border-gray-700/50 tw-rounded tw-p-2.5 tw-space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex tw-items-center tw-justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "tw-text-gray-500 tw-text-[10px] tw-font-mono",
                                                    children: [
                                                        "edit[",
                                                        idx,
                                                        "]"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setEdits((prev)=>prev.filter((_, i)=>i !== idx)),
                                                    className: "tw-text-gray-500 hover:tw-text-red-400 tw-text-xs tw-transition-colors",
                                                    children: "remove"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-grid tw-grid-cols-3 tw-gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                                    label: "op",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Select, {
                                                        value: edit.op,
                                                        onChange: (v)=>updateEdit(idx, "op", v),
                                                        options: [
                                                            {
                                                                value: "add",
                                                                label: "add"
                                                            },
                                                            {
                                                                value: "delete",
                                                                label: "delete"
                                                            },
                                                            {
                                                                value: "edit",
                                                                label: "edit"
                                                            }
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                                    label: "role",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                                        value: edit.role,
                                                        onChange: (v)=>updateEdit(idx, "role", v),
                                                        placeholder: "e.g. writer"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                                    label: "persona_id",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                                        value: edit.personaId,
                                                        onChange: (v)=>updateEdit(idx, "personaId", v),
                                                        placeholder: "optional"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-grid tw-grid-cols-3 tw-gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                                    label: "data_category",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Select, {
                                                        value: edit.dataCategory,
                                                        onChange: (v)=>updateEdit(idx, "dataCategory", v),
                                                        options: [
                                                            {
                                                                value: "1",
                                                                label: "1 - Verified"
                                                            },
                                                            {
                                                                value: "2",
                                                                label: "2 - Inferred"
                                                            },
                                                            {
                                                                value: "3",
                                                                label: "3 - Credited"
                                                            },
                                                            {
                                                                value: "4",
                                                                label: "4 - Unverified"
                                                            },
                                                            {
                                                                value: "5",
                                                                label: "5 - Unknown"
                                                            }
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                                    label: "source_url",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                                        value: edit.sourceUrl,
                                                        onChange: (v)=>updateEdit(idx, "sourceUrl", v),
                                                        placeholder: "https://..."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                                    label: "notes",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                                        value: edit.notes,
                                                        onChange: (v)=>updateEdit(idx, "notes", v),
                                                        placeholder: "optional"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, idx))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ExecuteButton, {
                        onClick: execute,
                        loading: loading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ResponseBlock, {
                response: response,
                error: error,
                loading: loading
            })
        ]
    });
}
// ── 4. Lookup Client Aliases (4.2.2) ──
function $6101b280ed6ed360$var$LookupClientAliasesForm({ userId: userId, recordingId: recordingId }) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [response, setResponse] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const execute = async ()=>{
        setLoading(true);
        setError(null);
        setResponse(null);
        try {
            const result = await api.lookupClientAliasesLookupClientAliasesResponse({
                userId: userId,
                parentRecordingId: recordingId
            });
            setResponse(result);
        } catch (err) {
            setError(err?.message || JSON.stringify(err));
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6101b280ed6ed360$var$EndpointCard, {
        title: "4.2.2 Lookup Client Aliases",
        description: "Retrieve client aliases (personas) for a westbury client",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$StatusBadge, {
                method: "GET",
                path: "/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/client-aliases/"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ContextDisplay, {
                        userId: userId,
                        recordingId: recordingId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ExecuteButton, {
                        onClick: execute,
                        loading: loading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ResponseBlock, {
                response: response,
                error: error,
                loading: loading
            })
        ]
    });
}
// ── 5. Lookup Artists (4.4.1) ──
function $6101b280ed6ed360$var$LookupArtistsForm({ userId: userId, recordingId: recordingId }) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("Beatles");
    const [response, setResponse] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const execute = async ()=>{
        setLoading(true);
        setError(null);
        setResponse(null);
        try {
            const result = await api.lookupArtistsLookupArtistsResponse({
                userId: userId,
                parentRecordingId: recordingId,
                searchTerm: searchTerm
            });
            setResponse(result);
        } catch (err) {
            setError(err?.message || JSON.stringify(err));
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6101b280ed6ed360$var$EndpointCard, {
        title: "4.4.1 Lookup Artists",
        description: "Retrieve artists from WMC database by search term (GraphDB)",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$StatusBadge, {
                method: "GET",
                path: "/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/lookup/"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ContextDisplay, {
                        userId: userId,
                        recordingId: recordingId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                        label: "Search Term",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                            value: searchTerm,
                            onChange: setSearchTerm,
                            placeholder: "e.g. Beatles"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ExecuteButton, {
                        onClick: execute,
                        loading: loading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ResponseBlock, {
                response: response,
                error: error,
                loading: loading
            })
        ]
    });
}
// ── 5b. Artist Lookup Live Search (integration test) ──
function $6101b280ed6ed360$var$ArtistLookupLiveSearchForm({ userId: userId, recordingId: recordingId }) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)("");
    const [results, setResults] = (0, $acw62.useState)([]);
    const [selectedArtists, setSelectedArtists] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [lastPayload, setLastPayload] = (0, $acw62.useState)(null);
    // Debounced search
    (0, $acw62.useEffect)(()=>{
        if (!userId || !recordingId) return;
        setLoading(true);
        setError(null);
        const timer = setTimeout(async ()=>{
            try {
                const result = await api.lookupArtistsLookupArtistsResponse({
                    userId: userId,
                    parentRecordingId: recordingId,
                    searchTerm: searchQuery.trim() || "*"
                });
                setResults((result.artists ?? []).map((a)=>({
                        id: a.id ?? "",
                        stageName: a.stageName ?? ""
                    })));
            } catch (err) {
                setError(err?.message || "Lookup failed");
                setResults([]);
            } finally{
                setLoading(false);
            }
        }, 300);
        return ()=>clearTimeout(timer);
    }, [
        searchQuery,
        userId,
        recordingId,
        api
    ]);
    const addArtist = (artist)=>{
        if (selectedArtists.some((a)=>a.id === artist.id)) return;
        setSelectedArtists((prev)=>[
                ...prev,
                {
                    ...artist,
                    featuredStatus: "fa"
                }
            ]);
    };
    const removeArtist = (id)=>{
        setSelectedArtists((prev)=>prev.filter((a)=>a.id !== id));
    };
    const toggleFeatured = (id)=>{
        setSelectedArtists((prev)=>prev.map((a)=>a.id === id ? {
                    ...a,
                    featuredStatus: a.featuredStatus === "fa" ? "ofa" : "fa"
                } : a));
    };
    const buildPayload = ()=>{
        const payload = {
            edits: selectedArtists.map((a)=>({
                    artist_id: a.id,
                    op: "add",
                    featuredStatus: a.featuredStatus
                }))
        };
        setLastPayload(payload);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6101b280ed6ed360$var$EndpointCard, {
        title: "Artist Lookup \u2014 Live Search Integration Test",
        description: "Simulates the RecordingEditForm artist search: type to search, select artists, see the change_artists payload that would be sent",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$StatusBadge, {
                method: "GET",
                path: "/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/lookup/"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ContextDisplay, {
                        userId: userId,
                        recordingId: recordingId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                        label: "Search Artists (debounced, 300ms)",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                            value: searchQuery,
                            onChange: setSearchQuery,
                            placeholder: "Type to search... (empty = all)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-border tw-border-gray-700 tw-rounded tw-p-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "tw-text-gray-400 tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-wider",
                                children: [
                                    "Lookup Results",
                                    " ",
                                    loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "tw-text-blue-400 tw-normal-case",
                                        children: "(searching...)"
                                    })
                                ]
                            }),
                            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-text-red-400 tw-text-xs tw-mt-1",
                                children: error
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-mt-2 tw-space-y-1 tw-max-h-48 tw-overflow-y-auto",
                                children: [
                                    results.length === 0 && !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "tw-text-gray-500 tw-text-xs",
                                        children: "No results"
                                    }),
                                    results.map((artist)=>{
                                        const alreadyAdded = selectedArtists.some((a)=>a.id === artist.id);
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "tw-flex tw-items-center tw-justify-between tw-px-2 tw-py-1.5 tw-rounded tw-bg-gray-800/50",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "tw-text-white tw-text-sm",
                                                            children: artist.stageName
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "tw-text-gray-500 tw-text-xs tw-ml-2 tw-font-mono",
                                                            children: artist.id
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    disabled: alreadyAdded,
                                                    onClick: ()=>addArtist(artist),
                                                    className: `tw-text-xs tw-px-2 tw-py-0.5 tw-rounded tw-transition-colors ${alreadyAdded ? "tw-bg-gray-700 tw-text-gray-500 tw-cursor-not-allowed" : "tw-bg-blue-600 tw-text-white hover:tw-bg-blue-500"}`,
                                                    children: alreadyAdded ? "Added" : "Add"
                                                })
                                            ]
                                        }, artist.id);
                                    })
                                ]
                            })
                        ]
                    }),
                    selectedArtists.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-border tw-border-gray-700 tw-rounded tw-p-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-gray-400 tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-wider",
                                children: "Selected Artists"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-mt-2 tw-space-y-1",
                                children: selectedArtists.map((artist)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-justify-between tw-px-2 tw-py-1.5 tw-rounded tw-bg-gray-800/50",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "tw-flex tw-items-center tw-gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "tw-text-white tw-text-sm",
                                                        children: artist.stageName
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>toggleFeatured(artist.id),
                                                        className: `tw-text-[10px] tw-px-1.5 tw-py-0.5 tw-rounded tw-font-mono tw-transition-colors ${artist.featuredStatus === "fa" ? "tw-bg-green-600/20 tw-text-green-400 tw-border tw-border-green-600/30" : "tw-bg-gray-700 tw-text-gray-400 tw-border tw-border-gray-600"}`,
                                                        children: artist.featuredStatus === "fa" ? "Featuring" : "Other Featured"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "tw-text-gray-600 tw-text-xs tw-font-mono",
                                                        children: artist.id
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>removeArtist(artist.id),
                                                className: "tw-text-gray-500 hover:tw-text-red-400 tw-text-xs tw-transition-colors",
                                                children: "remove"
                                            })
                                        ]
                                    }, artist.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: buildPayload,
                        disabled: selectedArtists.length === 0,
                        className: "tw-bg-blue-600 hover:tw-bg-blue-500 disabled:tw-bg-gray-600 disabled:tw-cursor-not-allowed tw-text-white tw-text-sm tw-font-medium tw-px-4 tw-py-1.5 tw-rounded tw-transition-colors",
                        children: "Build change_artists Payload"
                    })
                ]
            }),
            lastPayload && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-mt-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-gray-400 tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-wider",
                        children: "Payload that would be sent to POST .../artists/"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mt-1 tw-p-3 tw-rounded tw-bg-gray-800 tw-border tw-border-gray-700 tw-text-green-300 tw-text-xs tw-font-mono tw-whitespace-pre-wrap tw-max-h-48 tw-overflow-y-auto",
                        children: JSON.stringify(lastPayload, null, 2)
                    })
                ]
            })
        ]
    });
}
// ── 6. Create Artist and Link (4.4.2) ──
function $6101b280ed6ed360$var$CreateArtistForm({ userId: userId, recordingId: recordingId }) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [stageName, setStageName] = (0, $acw62.useState)("New Artist Name");
    const [source, setSource] = (0, $acw62.useState)("discogs");
    const [sourceId, setSourceId] = (0, $acw62.useState)("");
    const [featuredStatus, setFeaturedStatus] = (0, $acw62.useState)("fa");
    const [isGroup, setIsGroup] = (0, $acw62.useState)(false);
    const [members, setMembers] = (0, $acw62.useState)([]);
    const [memberSearch, setMemberSearch] = (0, $acw62.useState)("");
    const [memberResults, setMemberResults] = (0, $acw62.useState)([]);
    const [memberSearchLoading, setMemberSearchLoading] = (0, $acw62.useState)(false);
    const [response, setResponse] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    // Debounced member lookup
    (0, $acw62.useEffect)(()=>{
        if (!isGroup || !userId || !recordingId) return;
        const q = memberSearch.trim();
        if (!q) {
            setMemberResults([]);
            return;
        }
        setMemberSearchLoading(true);
        const timer = setTimeout(async ()=>{
            try {
                const result = await api.lookupArtistsLookupArtistsResponse({
                    userId: userId,
                    parentRecordingId: recordingId,
                    searchTerm: q
                });
                setMemberResults((result.artists ?? []).map((a)=>({
                        id: a.id ?? "",
                        stageName: a.stageName ?? ""
                    })));
            } catch  {
                setMemberResults([]);
            } finally{
                setMemberSearchLoading(false);
            }
        }, 300);
        return ()=>clearTimeout(timer);
    }, [
        memberSearch,
        isGroup,
        userId,
        recordingId,
        api
    ]);
    const execute = async ()=>{
        setLoading(true);
        setError(null);
        setResponse(null);
        try {
            const result = await api.createArtistAndLinkServiceResponse({
                userId: userId,
                parentRecordingId: recordingId,
                createArtistAndLinkRequest: {
                    stageName: stageName,
                    source: source,
                    sourceId: sourceId || undefined,
                    featuredStatus: featuredStatus,
                    members: isGroup && members.length > 0 ? members : undefined
                }
            });
            setResponse(result);
        } catch (err) {
            setError(err?.message || JSON.stringify(err));
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6101b280ed6ed360$var$EndpointCard, {
        title: "4.4.2 Create Artist + Link",
        description: "Create a new artist (alias/group) as main artist and link to recording. Includes members for groups.",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$StatusBadge, {
                method: "POST",
                path: "/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/create/"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ContextDisplay, {
                        userId: userId,
                        recordingId: recordingId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-grid tw-grid-cols-2 tw-gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                label: "Stage Name",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                    value: stageName,
                                    onChange: setStageName,
                                    placeholder: "Artist or group name"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                label: "Source",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Select, {
                                    value: source,
                                    onChange: setSource,
                                    options: [
                                        {
                                            value: "discogs",
                                            label: "Discogs"
                                        },
                                        {
                                            value: "MB",
                                            label: "MusicBrainz"
                                        },
                                        {
                                            value: "spotify",
                                            label: "Spotify"
                                        },
                                        {
                                            value: "deezer",
                                            label: "Deezer"
                                        }
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-grid tw-grid-cols-2 tw-gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                label: "Source ID (optional)",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                    value: sourceId,
                                    onChange: setSourceId,
                                    placeholder: "e.g. 12345"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                label: "Featured Status",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Select, {
                                    value: featuredStatus,
                                    onChange: setFeaturedStatus,
                                    options: [
                                        {
                                            value: "fa",
                                            label: "fa (Featuring Artist)"
                                        },
                                        {
                                            value: "ofa",
                                            label: "ofa (Other Featured Artist)"
                                        }
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "checkbox",
                                id: "test-is-group",
                                checked: isGroup,
                                onChange: (e)=>{
                                    setIsGroup(e.target.checked);
                                    if (!e.target.checked) {
                                        setMembers([]);
                                        setMemberSearch("");
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: "test-is-group",
                                className: "tw-text-white tw-text-sm tw-cursor-pointer",
                                children: "This is a group / band"
                            })
                        ]
                    }),
                    isGroup && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-border tw-border-gray-700 tw-rounded tw-p-3 tw-space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-gray-400 tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-wider",
                                children: "Members (search to add from artist lookup)"
                            }),
                            members.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-flex-wrap tw-gap-1.5",
                                children: members.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded tw-px-2 tw-py-1 tw-text-xs tw-bg-gray-800 tw-text-white tw-border tw-border-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: m.stageName
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-text-gray-500 tw-font-mono",
                                                children: m.id
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setMembers((prev)=>prev.filter((p)=>p.id !== m.id)),
                                                className: "tw-text-gray-500 hover:tw-text-red-400 tw-transition-colors",
                                                children: "x"
                                            })
                                        ]
                                    }, m.id))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                value: memberSearch,
                                onChange: setMemberSearch,
                                placeholder: "Search for member..."
                            }),
                            memberSearch.trim() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-max-h-36 tw-overflow-y-auto tw-space-y-1",
                                children: memberSearchLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-gray-400 tw-text-xs",
                                    children: "Searching..."
                                }) : memberResults.filter((a)=>!members.some((m)=>m.id === a.id)).length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-gray-500 tw-text-xs",
                                    children: "No results"
                                }) : memberResults.filter((a)=>!members.some((m)=>m.id === a.id)).map((artist)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            setMembers((prev)=>[
                                                    ...prev,
                                                    artist
                                                ]);
                                            setMemberSearch("");
                                        },
                                        className: "tw-w-full tw-text-left tw-px-2 tw-py-1 tw-text-sm tw-text-white hover:tw-bg-gray-700 tw-rounded tw-transition-colors",
                                        children: [
                                            artist.stageName,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-text-gray-500 tw-text-xs tw-ml-2 tw-font-mono",
                                                children: artist.id
                                            })
                                        ]
                                    }, artist.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ExecuteButton, {
                        onClick: execute,
                        loading: loading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ResponseBlock, {
                response: response,
                error: error,
                loading: loading
            })
        ]
    });
}
// ── Lookup Source Artist ──
function $6101b280ed6ed360$var$LookupSourceArtistForm({ userId: userId, recordingId: recordingId }) {
    const [source, setSource] = (0, $acw62.useState)("discogs");
    const [sourceId, setSourceId] = (0, $acw62.useState)("");
    const [response, setResponse] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const execute = async ()=>{
        if (!sourceId.trim()) {
            setError("Source ID is required");
            return;
        }
        setLoading(true);
        setError(null);
        setResponse(null);
        try {
            const url = `${"https://web.dev.westburymusic.com"}/portal/users/${userId}/primary-discography/recording/${encodeURIComponent(recordingId)}/artists/lookup-source/?source=${source}&source_id=${encodeURIComponent(sourceId.trim())}`;
            const resp = await (0, $4c86c2ba3eebb152$export$2e2bcd8739ae039)(url);
            const data = await resp.json();
            if (!resp.ok) setError(`${resp.status}: ${JSON.stringify(data)}`);
            else setResponse(data);
        } catch (err) {
            setError(err?.message || JSON.stringify(err));
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6101b280ed6ed360$var$EndpointCard, {
        title: "Lookup Source Artist",
        description: "Lookup artist from external source (Discogs/MusicBrainz) by source ID. Returns stage name and group members.",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$StatusBadge, {
                method: "GET",
                path: "/portal/users/{user_id}/primary-discography/recording/{recording_id}/artists/lookup-source/"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ContextDisplay, {
                        userId: userId,
                        recordingId: recordingId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-grid tw-grid-cols-2 tw-gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                label: "Source",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Select, {
                                    value: source,
                                    onChange: setSource,
                                    options: [
                                        {
                                            value: "discogs",
                                            label: "Discogs"
                                        },
                                        {
                                            value: "musicbrainz",
                                            label: "MusicBrainz"
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                                label: "Source ID",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                                    value: sourceId,
                                    onChange: setSourceId,
                                    placeholder: "e.g. 31456"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ExecuteButton, {
                        onClick: execute,
                        loading: loading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ResponseBlock, {
                response: response,
                error: error,
                loading: loading
            })
        ]
    });
}
function $6101b280ed6ed360$var$DagsterRunConcurrencyForm({ userId: userId }) {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [count, setCount] = (0, $acw62.useState)("5");
    const [running, setRunning] = (0, $acw62.useState)(false);
    const [outcomes, setOutcomes] = (0, $acw62.useState)(null);
    const [finalStatus, setFinalStatus] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    // Editable so the test can target a different artist — e.g. when the selected
    // one has a stuck/corrupted run. Defaults to (and follows) the global selection.
    const [targetUserId, setTargetUserId] = (0, $acw62.useState)(userId);
    (0, $acw62.useEffect)(()=>{
        setTargetUserId(userId);
    }, [
        userId
    ]);
    const fireOnce = async (index)=>{
        try {
            // 2xx (202) — this request claimed the run and a launch was started.
            const body = await api.createPipelineRunStatus({
                pipelineRunRequest: {
                    userId: targetUserId
                }
            });
            return {
                index: index,
                outcome: "started",
                httpStatus: 202,
                runId: body.runId ?? null,
                phase: body.phase ?? null
            };
        } catch (e) {
            const httpStatus = e && typeof e === "object" && "response" in e ? e.response?.status : undefined;
            // 409 — the backend rejected this concurrent trigger (a run is already active).
            if (httpStatus === 409) return {
                index: index,
                outcome: "rejected",
                httpStatus: httpStatus
            };
            return {
                index: index,
                outcome: "error",
                httpStatus: httpStatus,
                message: e?.message ?? String(e)
            };
        }
    };
    const run = async ()=>{
        if (!targetUserId) return;
        const n = Math.max(2, Math.min(50, Number(count) || 0));
        setRunning(true);
        setError(null);
        setOutcomes(null);
        setFinalStatus(null);
        try {
            // Fire all requests at once so they race against the backend's row lock.
            const results = await Promise.all(Array.from({
                length: n
            }, (_, i)=>fireOnce(i + 1)));
            setOutcomes(results);
            // Fetch the resulting run so it's clear exactly one exists.
            try {
                setFinalStatus(await api.retrievePipelineRunStatus({
                    userId: targetUserId
                }));
            } catch  {
            // The summary above already demonstrates the guarantee.
            }
        } catch (e) {
            setError(e?.message ?? String(e));
        } finally{
            setRunning(false);
        }
    };
    const started = outcomes?.filter((o)=>o.outcome === "started").length ?? 0;
    const rejected = outcomes?.filter((o)=>o.outcome === "rejected").length ?? 0;
    const errored = outcomes?.filter((o)=>o.outcome === "error").length ?? 0;
    let verdict = null;
    if (outcomes) {
        if (started > 1) verdict = {
            kind: "fail",
            text: `FAIL \u{2014} ${started} runs started. The single-run guard did not hold.`
        };
        else if (started === 1) verdict = {
            kind: "pass",
            text: `PASS \u{2014} exactly 1 run started; ${rejected} concurrent request(s) correctly rejected (409).`
        };
        else verdict = {
            kind: "warn",
            text: `No run started \u{2014} the artist already had an active run, so all ${rejected} request(s) were rejected (409). No duplicate was created (guard held). Cancel/finish the current run and retry to see a fresh launch.`
        };
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6101b280ed6ed360$var$EndpointCard, {
        title: "Dagster Run \u2014 Concurrency Guard",
        description: "Fire N concurrent run-trigger requests and verify only one Dagster run starts",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$StatusBadge, {
                method: "POST",
                path: "/portal/dagster/primary-discography/pipeline-runs/ \xd7N"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ContextDisplay, {
                userId: targetUserId,
                recordingId: "(n/a)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-items-end tw-gap-3 tw-flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                        label: "User ID to test",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                            value: targetUserId,
                            onChange: setTargetUserId,
                            placeholder: "user id",
                            className: "tw-w-64"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$FieldRow, {
                        label: "Concurrent requests",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$Input, {
                            value: count,
                            onChange: setCount,
                            placeholder: "5",
                            className: "tw-w-24"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        disabled: running || !targetUserId,
                        onClick: run,
                        className: "tw-bg-green-600 hover:tw-bg-green-500 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-text-white tw-text-sm tw-font-medium tw-px-4 tw-py-1.5 tw-rounded tw-transition-colors",
                        children: running ? "Firing\u2026" : "Fire concurrent requests"
                    })
                ]
            }),
            verdict && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: [
                    "tw-mt-4 tw-p-3 tw-rounded tw-border tw-text-sm",
                    verdict.kind === "pass" ? "tw-bg-green-900/30 tw-border-green-700/50 tw-text-green-300" : verdict.kind === "fail" ? "tw-bg-red-900/30 tw-border-red-700/50 tw-text-red-300" : "tw-bg-yellow-900/30 tw-border-yellow-700/50 tw-text-yellow-300"
                ].join(" "),
                children: verdict.text
            }),
            outcomes && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-mt-3 tw-grid tw-grid-cols-3 tw-gap-2 tw-text-center tw-text-xs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-p-2 tw-rounded tw-bg-gray-800 tw-border tw-border-gray-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-text-green-400 tw-text-lg tw-font-bold",
                                children: started
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-text-gray-400",
                                children: "started (202)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-p-2 tw-rounded tw-bg-gray-800 tw-border tw-border-gray-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-text-yellow-400 tw-text-lg tw-font-bold",
                                children: rejected
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-text-gray-400",
                                children: "rejected (409)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-p-2 tw-rounded tw-bg-gray-800 tw-border tw-border-gray-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-text-red-400 tw-text-lg tw-font-bold",
                                children: errored
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-text-gray-400",
                                children: "errors"
                            })
                        ]
                    })
                ]
            }),
            outcomes && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-mt-3 tw-p-3 tw-rounded tw-bg-gray-800 tw-border tw-border-gray-700 tw-text-xs tw-font-mono tw-max-h-48 tw-overflow-y-auto tw-space-y-1",
                children: outcomes.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "tw-text-gray-500",
                                children: [
                                    "#",
                                    o.index
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: o.outcome === "started" ? "tw-text-green-300" : o.outcome === "rejected" ? "tw-text-yellow-300" : "tw-text-red-300",
                                children: [
                                    o.outcome,
                                    o.httpStatus ? ` (${o.httpStatus})` : ""
                                ]
                            }),
                            o.phase && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "tw-text-gray-400",
                                children: [
                                    "phase=",
                                    o.phase
                                ]
                            }),
                            o.message && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-gray-400",
                                children: o.message
                            })
                        ]
                    }, o.index))
            }),
            finalStatus !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-mt-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-text-gray-400 tw-text-[11px] tw-uppercase tw-tracking-wider tw-mb-1",
                        children: "Resulting run (GET status)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ResponseBlock, {
                        response: finalStatus,
                        error: null,
                        loading: false
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ResponseBlock, {
                response: null,
                error: error,
                loading: false
            })
        ]
    });
}
function $6101b280ed6ed360$export$2e2bcd8739ae039() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [usersLoading, setUsersLoading] = (0, $acw62.useState)(true);
    const [usersError, setUsersError] = (0, $acw62.useState)(null);
    const [selectedUserId, setSelectedUserId] = (0, $acw62.useState)("");
    const [recordingId, setRecordingId] = (0, $acw62.useState)("test-recording-001");
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            try {
                const result = await api.listUsers();
                if (cancelled) return;
                setUsers(result);
                // Auto-select first user that has a userId
                const first = result.find((u)=>u.userId);
                if (first?.userId) setSelectedUserId(first.userId);
            } catch (err) {
                if (!cancelled) setUsersError(err?.message || "Failed to load users");
            } finally{
                if (!cancelled) setUsersLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-min-h-screen tw-bg-gray-950 tw-text-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-max-w-4xl tw-mx-auto tw-py-8 tw-px-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mb-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "tw-text-2xl tw-font-bold tw-text-white",
                            children: "Recording Management API Testing"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-gray-400 tw-text-sm tw-mt-1",
                            children: "BE-DS Service Contract endpoints (v0.1) \u2014 mock responses until DS implements"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-items-center tw-gap-4 tw-mt-3 tw-text-xs tw-text-gray-500",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "tw-flex tw-items-center tw-gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-green-500"
                                        }),
                                        "Success response"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "tw-flex tw-items-center tw-gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-red-500"
                                        }),
                                        "Error response"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "tw-flex tw-items-center tw-gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-blue-500"
                                        }),
                                        "GET endpoints return data"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$GlobalUserSelector, {
                    users: users,
                    usersLoading: usersLoading,
                    usersError: usersError,
                    selectedUserId: selectedUserId,
                    setSelectedUserId: setSelectedUserId,
                    recordingId: recordingId,
                    setRecordingId: setRecordingId
                }),
                !selectedUserId && !usersLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-text-center tw-py-12 tw-text-gray-500 tw-text-sm",
                    children: "Select a user above to start testing endpoints."
                }),
                selectedUserId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$CorrectRecordingForm, {
                            userId: selectedUserId,
                            recordingId: recordingId
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ChangeArtistsForm, {
                            userId: selectedUserId,
                            recordingId: recordingId
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ManageContributionsForm, {
                            userId: selectedUserId,
                            recordingId: recordingId
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$LookupClientAliasesForm, {
                            userId: selectedUserId,
                            recordingId: recordingId
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$LookupArtistsForm, {
                            userId: selectedUserId,
                            recordingId: recordingId
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$ArtistLookupLiveSearchForm, {
                            userId: selectedUserId,
                            recordingId: recordingId
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$CreateArtistForm, {
                            userId: selectedUserId,
                            recordingId: recordingId
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$LookupSourceArtistForm, {
                            userId: selectedUserId,
                            recordingId: recordingId
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-pt-4 tw-mt-2 tw-border-t tw-border-gray-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "tw-text-white tw-font-semibold tw-text-sm",
                                    children: "Dagster pipeline runs"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-gray-500 tw-text-xs tw-mt-0.5 tw-mb-3",
                                    children: "Validate the single-run guarantee on the run-trigger endpoint."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6101b280ed6ed360$var$DagsterRunConcurrencyForm, {
                            userId: selectedUserId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-mt-8 tw-text-center tw-text-gray-600 tw-text-xs",
                    children: [
                        "Endpoints hit the local backend at ",
                        "{",
                        "WB_API_URL",
                        "}",
                        "/portal/..."
                    ]
                })
            ]
        })
    });
}



// Sentry.init({
//   dsn: 'https://1516507424c330427f150253597b0248@o4506376806465536.ingest.sentry.io/4506376953659392',
//   integrations: [
//     new Sentry.BrowserTracing({
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       tracePropagationTargets: [
//         'https://admin.prod.westburymusic.com/',
//         'https://admin.dev.westburymusic.com/',
//       ],
//     }),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });
(0, $9481eb156b453e62$export$2e2bcd8739ae039).init("phc_PUGeiiTXxm2q7fPp5n8d77UgtXu59IZgUdbRVEVrixF", {
    api_host: "https://eu.posthog.com"
});
function $49c5b8f31e37366b$var$App() {
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace6711bea63eb39$export$f536685410d85835), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b5fd5559e42de25$export$f4e57f6132f56752), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb19b832faf6099b$export$88f24fd8fcfab6ca), {
                api: api,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7950a72521dfb882$export$5d91bb6ce8e0f47), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4330379de499a7df$export$c654193b8661f133), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $edd541b4e0018444$export$d91daf425539f32f), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56dc2e9e4d88bc0c$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/signin",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56dc2e9e4d88bc0c$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/clients",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18e6c9218ed081af$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/dashboard",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25b0364cb2516bb0$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/discography-dashboard",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc1c20adb5e80bc9$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/distribution-dashboard",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5de1eb2efd64c48e$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/discography",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d152945f8a08a4a$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/distribution",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b882307f2535c6a$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/terms-of-agreement/:userId",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b698fe643cd3ade$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/discography/:userId",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee5d817149f79816$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/discography-edit-mock/:userId",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a458b07a6d42853$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/discography-registrations/:userId",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $983d43ed167c8171$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/discography/:userId/ai-evidence/:parentRecordingId",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b725876768576cee$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/settings",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c666735050c0648$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/society-config",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf374ce87df7918c$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/society-forms/:userId",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44c8b82f2381591f$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                            path: "/testing/recording-endpoints",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6101b280ed6ed360$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}
var $49c5b8f31e37366b$export$2e2bcd8739ae039 = $49c5b8f31e37366b$var$App;


const $db6f6048144eedba$var$container = document.getElementById("app");
const $db6f6048144eedba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($db6f6048144eedba$var$container);
$db6f6048144eedba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49c5b8f31e37366b$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.e5b26ecb.js.map
